/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A Coursera language code used for translation.
   * Examples: "en", "es", "fr", "pt-BR", "zh-CN", "zh-TW".
   *
   * Must be a valid code from CourseraLanguageCode:
   * https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  ContentfulTranslation_CourseraLanguageCode: any;
  /** An RFC-3339 compliant Full Date Scalar */
  Date: string;
  /** A slightly refined version of RFC-3339 compliant DateTime Scalar */
  DateTime: string;
  /**
   * A string representing a duration conforming to the
   * [ISO-8601 format](https://en.wikipedia.org/wiki/ISO_8601#Durations) PnDTnHnMn.nS, with days
   * considered to be exactly 24 hours. eg: P1DT13H23M34.5S
   * P is the duration designator (for period) placed at the start of the duration representation.
   * D is the day designator that follows the value for the number of days.
   * T is the time designator that precedes the time components of the representation.
   * H is the hour designator that follows the value for the number of hours.
   * M is the minute designator that follows the value for the number of minutes.
   * S is the second designator that follows the value for the number of seconds.
   * Milliseconds may be represented using decimals, eg. PT0.5S for 500ms.
   *
   * Note: year, month, and week designators are not supported.
   */
  Duration: string;
  /** A JSON scalar */
  JSON: any;
  /** 24-hour clock time value string in the format `hh:mm:ss` or `hh:mm:ss.sss`. */
  LocalTime: string;
  /** A IETF BCP 47 language tag */
  Locale: string;
  ObjMap: any;
  /** An RFC-3339 compliant Full Time Scalar */
  Time: string;
  /** A url scalar that accepts string values like https://www.w3.org/Addressing/URL/url-spec.txt */
  URL: string;
};

/** TODO: Complete this description */
export type AcademicDisciplineQueries = {
  __typename?: 'AcademicDisciplineQueries';
  /** TODO: Complete this description */
  queryAcademicDisciplineById?: Maybe<AcademicDiscipline_AcademicDisciplinePayload>;
  /** TODO: Complete this description */
  queryAcademicDisciplineSummariesByOrgId: AcademicDiscipline_AcademicDisciplineSummariesPayload;
  /** TODO: Complete this description */
  queryCustomizedSkillSets: AcademicDiscipline_SkillSetsSummariesPayload;
};


/** TODO: Complete this description */
export type AcademicDisciplineQueriesQueryAcademicDisciplineByIdArgs = {
  id: Scalars['String'];
};


/** TODO: Complete this description */
export type AcademicDisciplineQueriesQueryAcademicDisciplineSummariesByOrgIdArgs = {
  orgId: Scalars['String'];
};


/** TODO: Complete this description */
export type AcademicDisciplineQueriesQueryCustomizedSkillSetsArgs = {
  input?: InputMaybe<AcademicDiscipline_QueryCustomizedSkillSetsInput>;
};

/** TODO: Complete this description */
export type AcademicDisciplineSummary = {
  __typename?: 'AcademicDisciplineSummary';
  /** TODO: Complete this description */
  domainName: Scalars['String'];
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  name: Scalars['String'];
  /** TODO: Complete this description */
  skillSetCount?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  subjectCount?: Maybe<Scalars['Int']>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_AcademicDisciplinePayload = {
  __typename?: 'AcademicDiscipline_academicDisciplinePayload';
  /** TODO: Complete this description */
  domainName: Scalars['String'];
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  name: Scalars['String'];
  /** TODO: Complete this description */
  skillSetIds?: Maybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  subjects?: Maybe<Array<Subject>>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_AcademicDisciplineSummariesPayload = {
  __typename?: 'AcademicDiscipline_academicDisciplineSummariesPayload';
  /** TODO: Complete this description */
  academicDisciplineSummaries?: Maybe<Array<AcademicDisciplineSummary>>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_QueryCustomizedSkillSetsInput = {
  /** TODO: Complete this description */
  orgId: Scalars['String'];
  /** TODO: Complete this description */
  templateSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_SetupAcademicDisciplineBasedProgramInput = {
  /** TODO: Complete this description */
  orgId: Scalars['String'];
  /** TODO: Complete this description */
  programId: Scalars['String'];
  /** TODO: Complete this description */
  selectedAcademicDisciplineId: Scalars['String'];
  /** TODO: Complete this description */
  selectedSubjectIds?: InputMaybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  selectedTargetSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  selectedTemplateSkillProfileIds?: InputMaybe<Array<Scalars['String']>>;
};

/** TODO: Complete this description */
export type AcademicDiscipline_SetupAcademicDisciplineBasedProgramPayload = {
  __typename?: 'AcademicDiscipline_setupAcademicDisciplineBasedProgramPayload';
  /** TODO: Complete this description */
  id: Scalars['ID'];
};

/** TODO: Complete this description */
export type AcademicDiscipline_SkillSetsSummariesPayload = {
  __typename?: 'AcademicDiscipline_skillSetsSummariesPayload';
  /** TODO: Complete this description */
  skillSetSummaries?: Maybe<Array<SkillSetSummary>>;
};

/** Enum defining the possible actions for contract tag product operations */
export const AdHocProducts_ContractTagProductAction = {
  /** Product IDs are allowed for the contract tag (allowlist operation) */
  Allowed: 'ALLOWED',
  /** Product IDs are denied for the contract tag (denylist operation) */
  Denied: 'DENIED'
} as const;

export type AdHocProducts_ContractTagProductAction = typeof AdHocProducts_ContractTagProductAction[keyof typeof AdHocProducts_ContractTagProductAction];
/** HardRemoveContractTagProductId Mutation Failure response. */
export type AdHocProducts_HardRemoveContractTagProductIdFailure = {
  __typename?: 'AdHocProducts_HardRemoveContractTagProductIdFailure';
  /** List of errors resulting from an attempted mutation. */
  errors: Array<AdHocProducts_MutationError>;
};

/** Input for hard removing product IDs from a contract tag */
export type AdHocProducts_HardRemoveContractTagProductIdInput = {
  /** The contract tag name */
  contractTagName: Scalars['String'];
  /** List of product IDs to hard remove */
  productIds: Array<Scalars['ID']>;
};

/** HardRemoveContractTagProductId Mutation result, can either be a success or failure. */
export type AdHocProducts_HardRemoveContractTagProductIdResult = AdHocProducts_HardRemoveContractTagProductIdFailure | AdHocProducts_HardRemoveContractTagProductIdSuccess;

/** HardRemoveContractTagProductId Mutation Success response. */
export type AdHocProducts_HardRemoveContractTagProductIdSuccess = {
  __typename?: 'AdHocProducts_HardRemoveContractTagProductIdSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Base error interface. */
export type AdHocProducts_MutationError = {
  /** Error message. */
  message: Scalars['String'];
};

/** UpdateContractTagProductId Mutation Failure response. */
export type AdHocProducts_UpdateContractTagProductIdFailure = {
  __typename?: 'AdHocProducts_UpdateContractTagProductIdFailure';
  /** List of errors resulting from an attempted mutation. */
  errors: Array<AdHocProducts_MutationError>;
};

/** Input for allowing or denying product IDs from a contract tag */
export type AdHocProducts_UpdateContractTagProductIdInput = {
  /** Action to perform: ALLOWED or DENIED */
  action: AdHocProducts_ContractTagProductAction;
  /** The contract tag name */
  contractTagName: Scalars['String'];
  /** List of product IDs to allow or deny */
  productIds: Array<Scalars['ID']>;
};

/** UpdateContractTagProductId Mutation result, can either be a success or failure. */
export type AdHocProducts_UpdateContractTagProductIdResult = AdHocProducts_UpdateContractTagProductIdFailure | AdHocProducts_UpdateContractTagProductIdSuccess;

/** UpdateContractTagProductId Mutation Success response. */
export type AdHocProducts_UpdateContractTagProductIdSuccess = {
  __typename?: 'AdHocProducts_UpdateContractTagProductIdSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Adaptive Learning Queries */
export type AdaptiveLearningQueries = {
  __typename?: 'AdaptiveLearningQueries';
  /** Get a course item, optionally with a cached transformation */
  getItem?: Maybe<AdaptiveLearning_ItemResponse>;
  /** Get the current learning plan for a course branch */
  getLearningPlan?: Maybe<AdaptiveLearning_OnboardResult>;
  /**
   * Returns the items in the calling user's adaptive activity learning plan for a
   * course branch, each annotated with whether it is required and the user's
   * completion status.
   *
   * Only items present in the learner's plan are returned — authored course items
   * the plan includes plus items the plan generated (AI summary items and
   * AI-generated practice). One-pagers are excluded (overview content with no
   * completion concept). Authored branch items the plan dropped (e.g. optional
   * items the learner self-assessed as experienced in) or merged into an AI
   * summary are NOT included. Returns null when the learner has no plan for the
   * branch (i.e. has not onboarded).
   *
   * This is a point-in-time snapshot, not kept live. Two things change it with no
   * mutation firing: (1) completion status for authored items is sourced from
   * course-progress and changes out-of-band (the course player, or async grading
   * for programming/peer-review items); (2) the plan itself is regenerated
   * server-side on its own — lazily on the next read once a session-boundary timer
   * elapses, or when the skill hierarchy or session-duration preference changes —
   * which alters which items appear. Clients should therefore refetch on
   * mount/focus (cache-and-network), not only after their own mutations. Reading
   * this field reflects the regenerated, progress-synced plan.
   */
  getMyLearningPlanItemProgress?: Maybe<AdaptiveLearning_MyLearningPlanItemProgressResponse>;
  /**
   * Returns the user's recorded pre-assessment proficiency for a course branch.
   * Skills with no assessed sub-skill are excluded.
   */
  getPreAssessmentProficiency?: Maybe<AdaptiveLearning_PreAssessmentProficiencyResponse>;
  /** Get pre-assessment questions for a learning block */
  getPreAssessmentQuestionsByLearningBlock?: Maybe<AdaptiveLearning_PreAssessmentQuestionsResponse>;
  /**
   * Re-entry refresher: returns the learner's recent mistaken AI-generated practices
   * (newest-wrong first) plus authored flashcards for their recently-completed
   * course items. Summary-aware: completing an AI summary item counts as
   * completing the WHAT/WHY/HOW course items it replaced (for flashcards fetching
   * only course progress is not changed)
   *
   * Returns a response with empty lists when the learner hasn't onboarded, has no
   * attempts, or the course has no flashcards for completed items.
   */
  getRecaps?: Maybe<AdaptiveLearning_RecapsResponse>;
  /**
   * Get the user's learning preferences for a course branch.
   * Returns the user's selected session duration and per-subSkill proficiency
   * (from pre-assessment answers). Returns null if the user has not onboarded.
   */
  getUserLearningPreferences?: Maybe<AdaptiveLearning_UserLearningPreferences>;
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetItemArgs = {
  format?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetLearningPlanArgs = {
  courseBranchId: Scalars['ID'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetMyLearningPlanItemProgressArgs = {
  courseBranchId: Scalars['ID'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetPreAssessmentProficiencyArgs = {
  courseBranchId: Scalars['ID'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetPreAssessmentQuestionsByLearningBlockArgs = {
  courseBranchId: Scalars['ID'];
  learningBlockNumber: Scalars['Int'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetRecapsArgs = {
  courseBranchId: Scalars['ID'];
};


/** Adaptive Learning Queries */
export type AdaptiveLearningQueriesGetUserLearningPreferencesArgs = {
  courseBranchId: Scalars['ID'];
};

/** Input for adding back an original course item to a learning block */
export type AdaptiveLearning_AddCourseItemToLearningBlockInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Original course item ID to add back to the learning block */
  itemId: Scalars['ID'];
  /** Learning block ID */
  learningBlockId: Scalars['ID'];
};

/** Result of adding a course item to a learning block */
export type AdaptiveLearning_AddCourseItemToLearningBlockResult = {
  __typename?: 'AdaptiveLearning_AddCourseItemToLearningBlockResult';
  /** Updated plan reflecting the added course item */
  updatedPlan: AdaptiveLearning_OnboardResult;
};

/** Input for deleting a learner's adaptive learning plan for a course branch. */
export type AdaptiveLearning_DeleteLearningPlanInput = {
  /** Course Branch ID whose plan should be deleted. */
  courseBranchId: Scalars['ID'];
  /** Coursera userId of the learner whose plan should be deleted. */
  userId: Scalars['ID'];
};

/**
 * Result of deleting a learner's adaptive learning plan. Counts reflect rows
 * deleted by this invocation — zeros are a valid (and idempotent) response for
 * a learner who had no state for the branch.
 */
export type AdaptiveLearning_DeleteLearningPlanResult = {
  __typename?: 'AdaptiveLearning_DeleteLearningPlanResult';
  /** Course Branch ID whose plan was deleted. Echoes the request. */
  courseBranchId: Scalars['ID'];
  /** Number of UserAiGeneratedContent rows deleted (both ONE_PAGER and AI_GENERATED_PRACTICE). */
  deletedAiContent: Scalars['Int'];
  /** Number of UserLearningBlock rows deleted via the plan's cascade. */
  deletedBlocks: Scalars['Int'];
  /** Number of UserLearningPlan rows deleted (0 if no plan existed, 1 otherwise). */
  deletedPlans: Scalars['Int'];
  /** Total Redis keys removed across preferences, practice attempts, and the attempt index. */
  redisKeysRemoved: Scalars['Int'];
  /** Coursera userId of the learner whose plan was deleted. Echoes the request. */
  userId: Scalars['ID'];
};

/**
 * The calling user's completion state for a single item, mirroring the source
 * CourseBranchItemCompletionStatus. AI-generated practice and summary items only
 * ever report NOT_STARTED or COMPLETED (they have no STARTED signal). One-pagers
 * are not returned by getMyLearningPlanItemProgress at all — they are overview
 * content with no completion concept. UNKNOWN is the default when no completion
 * record exists for the item.
 */
export const AdaptiveLearning_ItemCompletionStatus = {
  /** The user has completed the item. */
  Completed: 'COMPLETED',
  /** The user has a record for the item but has not completed it. */
  NotStarted: 'NOT_STARTED',
  /** The user has begun but not yet completed the item. */
  Started: 'STARTED',
  /** No completion record exists for this (user, item). */
  Unknown: 'UNKNOWN'
} as const;

export type AdaptiveLearning_ItemCompletionStatus = typeof AdaptiveLearning_ItemCompletionStatus[keyof typeof AdaptiveLearning_ItemCompletionStatus];
/** Item response with optional transformation */
export type AdaptiveLearning_ItemResponse = {
  __typename?: 'AdaptiveLearning_ItemResponse';
  /** Original content */
  content?: Maybe<Scalars['String']>;
  /** Duration in minutes */
  durationMinutes: Scalars['Float'];
  /** Item ID */
  id: Scalars['ID'];
  /** Item name */
  itemName: Scalars['String'];
  /** Item type */
  itemType: Scalars['String'];
  /** Learning objectives */
  learningObjectives?: Maybe<Array<Scalars['String']>>;
  /** Lesson name */
  lessonName?: Maybe<Scalars['String']>;
  /** Module name */
  moduleName?: Maybe<Scalars['String']>;
  /** Transcript */
  transcript?: Maybe<Scalars['String']>;
  /** Transformation status */
  transformationStatus?: Maybe<Scalars['String']>;
  /** Transformation type applied */
  transformationType?: Maybe<Scalars['String']>;
  /** Transformed content */
  transformedContent?: Maybe<Scalars['String']>;
  /** Video ID */
  videoId?: Maybe<Scalars['ID']>;
};

/**
 * A single item in the learner's adaptive learning plan, annotated with its
 * required status and the calling user's completion status.
 */
export type AdaptiveLearning_LearningPlanItemProgress = {
  __typename?: 'AdaptiveLearning_LearningPlanItemProgress';
  /**
   * Opaque entity identifier. Represents userId~courseBranchId~itemId — both the
   * required status and completion status are scoped to the calling user and the
   * branch, so the bare itemId is not a stable cache key on its own.
   */
  id: Scalars['ID'];
  /**
   * Whether the item was generated by the learner's adaptive activity learning
   * plan (AI summary item or AI-generated practice) rather than authored in the
   * course. Generated items are never required.
   */
  isGenerated: Scalars['Boolean'];
  /**
   * Whether the item is required. An item is required iff its course-material
   * definition carries a numeric `gradingWeight` (the weight may be zero or
   * non-zero). Items without a grading weight — lectures, supplements, pure
   * practice — and adaptive-plan-generated items are not required.
   */
  isRequired: Scalars['Boolean'];
  /**
   * Item ID. For authored course items this is the course-material item id; for
   * adaptive-plan-generated items it is the generated item's id.
   */
  itemId: Scalars['ID'];
  /** The calling user's completion status for this item. */
  status: AdaptiveLearning_ItemCompletionStatus;
};

/**
 * The items in the learner's adaptive learning plan for a course branch —
 * authored and plan-generated — each with its required status and the calling
 * user's completion status.
 */
export type AdaptiveLearning_MyLearningPlanItemProgressResponse = {
  __typename?: 'AdaptiveLearning_MyLearningPlanItemProgressResponse';
  /** Course Branch ID. Echoes the request. */
  courseBranchId: Scalars['ID'];
  /**
   * Opaque entity identifier. Represents userId~courseBranchId — the response is
   * scoped to the calling user and the requested branch.
   */
  id: Scalars['ID'];
  /**
   * The items in the learner's adaptive learning plan, in plan order (learning
   * block order, then item order within each block). Includes both authored
   * course items the plan contains and plan-generated items (AI summaries and
   * AI-generated practice). One-pagers are excluded (overview content with no
   * completion concept). Authored branch items the plan dropped or merged into an
   * AI summary are not included. (When the learner has no plan the whole response
   * is null, so this list is never empty for that reason.)
   */
  items: Array<AdaptiveLearning_LearningPlanItemProgress>;
};

/** Onboard input */
export type AdaptiveLearning_OnboardInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Learning goal */
  goal: Scalars['String'];
  /** Learning pace */
  learningPace?: InputMaybe<Scalars['String']>;
  /** Session duration in minutes */
  sessionDurationMinutes?: InputMaybe<Scalars['Int']>;
};

/** Onboarding response */
export type AdaptiveLearning_OnboardResult = {
  __typename?: 'AdaptiveLearning_OnboardResult';
  /** Course */
  course: Course_Course;
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** The current session plan the user should focus on, with the current item highlighted */
  currentLearningBlock?: Maybe<AdaptiveLearning_SessionPlan>;
  /** Unique ID of the user learning plan */
  id: Scalars['ID'];
  /** Whether the learning plan was regenerated (e.g. due to a new session or changed duration) */
  isRegenerated: Scalars['Boolean'];
  /** Session plan */
  sessionPlans: Array<AdaptiveLearning_SessionPlan>;
  /** Total estimated minutes */
  totalEstimatedMinutes: Scalars['Float'];
  /** Total items */
  totalItems: Scalars['Int'];
};

/** A single answer to a pre-assessment question */
export type AdaptiveLearning_PreAssessmentAnswer = {
  /** Question ID */
  questionId: Scalars['ID'];
  /** Learner's selected skill level */
  selectedOption: AdaptiveLearning_SkillLevel;
};

/** A single pre-assessment answer at either skill or subSkill granularity. */
export type AdaptiveLearning_PreAssessmentAnswerV2 = {
  /** Whether `name` refers to a skill or a subSkill in the course's hierarchy. */
  level: AdaptiveLearning_SkillHierarchyLevel;
  /** Skill or subSkill name (interpreted per the level field). */
  name: Scalars['String'];
  /** Selected skill level. */
  selectedOption: AdaptiveLearning_SkillLevel;
};

/** Snapshot of the user's pre-assessment state for a course branch. */
export type AdaptiveLearning_PreAssessmentProficiencyResponse = {
  __typename?: 'AdaptiveLearning_PreAssessmentProficiencyResponse';
  /** Course Branch ID. */
  courseBranchId: Scalars['ID'];
  /** Skills with at least one assessed sub-skill. */
  skills: Array<AdaptiveLearning_SkillProficiency>;
};

/** A single pre-assessment question */
export type AdaptiveLearning_PreAssessmentQuestion = {
  __typename?: 'AdaptiveLearning_PreAssessmentQuestion';
  /** Question ID */
  questionId: Scalars['ID'];
  /** Question text */
  questionText: Scalars['String'];
  /** Sub-skill being assessed */
  subSkill: AdaptiveLearning_SubSkill;
};

/** Pre-assessment questions for a learning block */
export type AdaptiveLearning_PreAssessmentQuestionsResponse = {
  __typename?: 'AdaptiveLearning_PreAssessmentQuestionsResponse';
  /** List of assessment questions */
  questions: Array<AdaptiveLearning_PreAssessmentQuestion>;
};

/**
 * A single proficiency entry — either a skill or a sub-skill — with its
 * recorded level. Used uniformly for the skill node and for each sub-skill in
 * the breakdown so clients render from one shape.
 */
export type AdaptiveLearning_Proficiency = {
  __typename?: 'AdaptiveLearning_Proficiency';
  /** Whether `name` refers to a skill or a sub-skill in the course's hierarchy. */
  level: AdaptiveLearning_SkillHierarchyLevel;
  /** Skill or sub-skill name (interpreted per the level field). */
  name: Scalars['String'];
  /** Recorded proficiency level. NEW/SEEN/KNOWN for SUBSKILL entries; SKILL entries may also be MIXED. */
  skillLevel: AdaptiveLearning_ProficiencyLevel;
};

/**
 * Proficiency level returned in pre-assessment responses. Mirrors
 * AdaptiveLearning_SkillLevel (NEW/SEEN/KNOWN) plus the MIXED marker that the
 * server uses for SKILL-level entries when the constituent assessed sub-skills
 * disagree. Distinct from AdaptiveLearning_SkillLevel because MIXED is not a
 * valid user-selectable answer (it is server-computed only).
 */
export const AdaptiveLearning_ProficiencyLevel = {
  /** Learner can do this independently */
  Known: 'KNOWN',
  /** Server-only: returned for SKILL entries when assessed sub-skills disagree. Never returned for SUBSKILL entries. */
  Mixed: 'MIXED',
  /** Learner hasn't done this before */
  New: 'NEW',
  /** Learner knows the basics but needs a refresh */
  Seen: 'SEEN'
} as const;

export type AdaptiveLearning_ProficiencyLevel = typeof AdaptiveLearning_ProficiencyLevel[keyof typeof AdaptiveLearning_ProficiencyLevel];
/**
 * Re-entry refresher payload. Both lists are in reverse-chronological order and
 * may be empty. The client is expected to render whichever sections have entries.
 */
export type AdaptiveLearning_RecapsResponse = {
  __typename?: 'AdaptiveLearning_RecapsResponse';
  /**
   * Distinct sub-skill names for the course items that produced reviewFlashcards,
   * newest-contributing-flashcard first. Deduplicated - each sub-skill appears once
   * even if multiple returned flashcards came from it. Empty when reviewFlashcards is empty
   * or when a contributing item's sub-skill could not be resolved from the learner's plan.
   */
  completedSubSkills: Array<Scalars['String']>;
  /**
   * The learner's most recent incorrect attempts on AI-generated practice questions,
   * newest first. Capped at 5 currently. Excludes attempts whose underlying practice has since
   * been archived.
   */
  mistakenPractices: Array<LowStakesLearningTools_AiGeneratedPractice>;
  /**
   * Up to 4 bullet points reminding the learner of key facts from recently-completed
   * material, extracted from existing sub-skill summary content. Sourced from the same
   * sub-skills as completedSubSkills, in the same recency order; a sub-skill contributes
   * 0+ bullets depending on how many exist in its summary and how much budget remains.
   * Empty when no contributing sub-skill has generated summary content.
   */
  quickReminder: Array<Scalars['String']>;
  /**
   * Flashcards from the learner's recently-completed course items, newest
   * first. Capped at 7 currently. Same source and shape
   * as LowStakesLearning.reviewFlashcardsDeck.
   */
  reviewFlashcards: Array<LowStakesLearning_ReviewFlashcard>;
};

/** Input for reporting progress on a session plan item */
export type AdaptiveLearning_ReportItemProgressInput = {
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID that was completed */
  itemId: Scalars['ID'];
  /** Learning block ID */
  learningBlockId: Scalars['ID'];
};

/** Result of reporting item progress, contains the updated plan state */
export type AdaptiveLearning_ReportItemProgressResult = {
  __typename?: 'AdaptiveLearning_ReportItemProgressResult';
  /** Updated onboarding result reflecting the latest progress */
  updatedPlan: AdaptiveLearning_OnboardResult;
};

/** Input for reporting a learner's attempt on a single AI-generated practice question */
export type AdaptiveLearning_ReportPracticeAttemptInput = {
  /** Stable UUID of the AI-generated practice (from AiGeneratedPractice.aiGeneratedPracticeId) */
  aiGeneratedPracticeId: Scalars['ID'];
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /**
   * Whether the learner answered correctly. Client-reported: for MCQ-style practices
   * the client compares the selected option to the known correct answer; for
   * flashcards the client passes the learner's self-grade.
   */
  isCorrect: Scalars['Boolean'];
  /** Type of the practice (disambiguates the practice alongside aiGeneratedPracticeId) */
  practiceType: LowStakesLearningTools_AiGeneratedPracticeType;
  /**
   * Optional free-form record of what the learner entered or selected. Not
   * interpreted by the server; kept for future analytics and debuggability.
   */
  userAnswer?: InputMaybe<Scalars['String']>;
};

/** Result of reporting a learner's attempt on a practice question */
export type AdaptiveLearning_ReportPracticeAttemptResult = {
  __typename?: 'AdaptiveLearning_ReportPracticeAttemptResult';
  /** Server-authoritative timestamp of when the attempt was recorded */
  attemptedAt: Scalars['DateTime'];
};

/** A session plan from onboarding */
export type AdaptiveLearning_SessionPlan = {
  __typename?: 'AdaptiveLearning_SessionPlan';
  /** Whether all items in this session plan have been completed by the user */
  completed?: Maybe<Scalars['Boolean']>;
  /** The item ID the UX should focus on within this session plan */
  currentItemId?: Maybe<Scalars['ID']>;
  /** Estimated minutes */
  estimatedMinutes: Scalars['Float'];
  /** Unique session plan identifier */
  id: Scalars['ID'];
  /**
   * Whether this learning block has been finalized and will no longer change.
   * Frozen blocks are immutable: items, ordering, and estimated minutes are
   * guaranteed stable across subsequent reads and across the
   * ReportItemProgress / AddCourseItemToLearningBlock /
   * SubmitPreAssessmentAnswers / Onboard mutations. The FE can safely cache
   * rendered output. Defaults to false for any block that has not been frozen.
   */
  isFrozen: Scalars['Boolean'];
  /** Items as JSON */
  items: Scalars['JSON'];
  /**
   * Items the learner explicitly added (e.g. original WHAT/WHY/HOW
   * course items that were replaced by an AI summary in ACCELERATED pace).
   */
  itemsAddedByUser: Scalars['JSON'];
  /**
   * The learningBlock duration (in minutes) used as the budget when this block was
   * packed — i.e., the user-selected session duration at the moment the block
   * was generated/repacked. Preserved across freeze, splits, and completions,
   * so it can diverge from the user's current preference if it has since
   * changed. Distinct from estimatedMinutes — this is the budget, not the
   * packed content's actual length.
   */
  learningBlockDurationMinutes: Scalars['Int'];
  /** Session number */
  sessionNumber: Scalars['Int'];
  /** Win description */
  winDescription: Scalars['String'];
};

/** Granularity at which a pre-assessment answer applies. */
export const AdaptiveLearning_SkillHierarchyLevel = {
  /** Answer fans out to all subSkills under the named skill. */
  Skill: 'SKILL',
  /** Answer applies to the named subSkill only. */
  Subskill: 'SUBSKILL'
} as const;

export type AdaptiveLearning_SkillHierarchyLevel = typeof AdaptiveLearning_SkillHierarchyLevel[keyof typeof AdaptiveLearning_SkillHierarchyLevel];
/** Learner's self-assessed skill level */
export const AdaptiveLearning_SkillLevel = {
  /** Learner can do this independently */
  Known: 'KNOWN',
  /** Learner hasn't done this before */
  New: 'NEW',
  /** Learner knows the basics but needs a refresh */
  Seen: 'SEEN'
} as const;

export type AdaptiveLearning_SkillLevel = typeof AdaptiveLearning_SkillLevel[keyof typeof AdaptiveLearning_SkillLevel];
/**
 * Proficiency for a single skill: the skill-level entry plus a breakdown of its
 * assessed sub-skills.
 */
export type AdaptiveLearning_SkillProficiency = {
  __typename?: 'AdaptiveLearning_SkillProficiency';
  /** Skill-level entry. level is always SKILL. skillLevel is MIXED iff the assessed sub-skills disagree. */
  skillProficiency: AdaptiveLearning_Proficiency;
  /** Per-sub-skill breakdown of every assessed sub-skill under this skill. Always populated. Each entry's level is SUBSKILL. */
  subSkillProficiencies: Array<AdaptiveLearning_Proficiency>;
};

/** A sub-skill associated with a pre-assessment question */
export type AdaptiveLearning_SubSkill = {
  __typename?: 'AdaptiveLearning_SubSkill';
  /** Sub-skill name */
  name: Scalars['String'];
};

/** A single subSkill's user-reported proficiency level */
export type AdaptiveLearning_SubSkillProficiency = {
  __typename?: 'AdaptiveLearning_SubSkillProficiency';
  /** The user's self-assessed skill level from pre-assessment (reverse-mapped from stored LearningPace) */
  skillLevel: AdaptiveLearning_SkillLevel;
  /** SubSkill name */
  subSkillName: Scalars['String'];
};

/** Input for submitting pre-assessment answers */
export type AdaptiveLearning_SubmitPreAssessmentAnswersInput = {
  /** List of responses to pre-assessment questions */
  responses: Array<AdaptiveLearning_PreAssessmentAnswer>;
};

/** Result of submitting pre-assessment answers */
export type AdaptiveLearning_SubmitPreAssessmentAnswersResult = {
  __typename?: 'AdaptiveLearning_SubmitPreAssessmentAnswersResult';
  /** Updated onboarding result reflecting the learning paces derived from pre-assessment answers */
  updatedPlan: AdaptiveLearning_OnboardResult;
};

/** Input for submitting pre-assessment answers at either granularity. */
export type AdaptiveLearning_SubmitPreAssessmentAnswersV2Input = {
  /**
   * Skill- and subSkill-level answers, in any order. May be null or empty —
   * in which case no writes are performed and the mutation simply returns the
   * current proficiency snapshot.
   */
  answers?: InputMaybe<Array<AdaptiveLearning_PreAssessmentAnswerV2>>;
  /** Course Branch ID. */
  courseBranchId: Scalars['ID'];
};

/** Result of submitting V2 pre-assessment answers. */
export type AdaptiveLearning_SubmitPreAssessmentAnswersV2Result = {
  __typename?: 'AdaptiveLearning_SubmitPreAssessmentAnswersV2Result';
  /** Post-write proficiency snapshot for the whole course branch. */
  proficiency: AdaptiveLearning_PreAssessmentProficiencyResponse;
};

/** Combined view of a user's learning preferences for a course branch */
export type AdaptiveLearning_UserLearningPreferences = {
  __typename?: 'AdaptiveLearning_UserLearningPreferences';
  /** The session duration in minutes the user selected (not the stretched estimatedMinutes) */
  sessionDurationMinutes: Scalars['Int'];
  /** Per-subSkill proficiency levels from pre-assessment answers */
  subSkillProficiencies: Array<AdaptiveLearning_SubSkillProficiency>;
};

/** The paginated list of courses */
export type AdminCourse_AdminCoursePaginatedResult = {
  __typename?: 'AdminCourse_AdminCoursePaginatedResult';
  /** The number of courses where the optimizations are completed */
  coursesOptimizedCount: Scalars['Int'];
  /** The number of courses where the optimizations are submitted for review but still pending */
  coursesPendingOptimizationCount: Scalars['Int'];
  /** List of elements in the page */
  elements: Array<AdminCourse_Course>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Admin course type */
export type AdminCourse_Course = {
  __typename?: 'AdminCourse_Course';
  /** The course */
  course: Course_Course;
  /** The id of the course */
  id: Scalars['ID'];
};

/** The optimization status for the course */
export const AdminCourse_OptimizationStatus = {
  /** Completed optimization */
  CompletedOptimization: 'COMPLETED_OPTIMIZATION',
  /** Pending optimization */
  PendingOptimization: 'PENDING_OPTIMIZATION'
} as const;

export type AdminCourse_OptimizationStatus = typeof AdminCourse_OptimizationStatus[keyof typeof AdminCourse_OptimizationStatus];
/** The page type */
export const AdminCourse_PageType = {
  /** The Courses page */
  Course: 'COURSE',
  /** The Projects page */
  Project: 'PROJECT'
} as const;

export type AdminCourse_PageType = typeof AdminCourse_PageType[keyof typeof AdminCourse_PageType];
/** Input for querying courses by search query and filters. */
export type AdminCourse_QueryBySearchQueryAndFiltersInput = {
  /** The optional list of course ids */
  courseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The optional instructor ids */
  instructorIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The optional list of optimization status to filter by */
  optimizationStatuses?: InputMaybe<Array<AdminCourse_OptimizationStatus>>;
  /** The page type */
  pageType: AdminCourse_PageType;
  /** The partner id */
  partnerId: Scalars['ID'];
  /** The optional list of program slugs to filter courses by */
  programSlugs?: InputMaybe<Array<Scalars['String']>>;
  /** The optional search query string */
  searchQuery?: InputMaybe<Scalars['String']>;
  /** The optional list of session statuses to filter course contexts by */
  sessionStatuses?: InputMaybe<Array<AdminCourse_SessionStatus>>;
  /** The optional user id, the course filter permissions are applied for the user if present */
  userId?: InputMaybe<Scalars['ID']>;
};

/** The session status of the course contexts */
export const AdminCourse_SessionStatus = {
  /** All course sessions for the course context are over */
  Archived: 'ARCHIVED',
  /** There are currently active course sessions for the course context */
  Live: 'LIVE',
  /** No course sessions for the course context */
  New: 'NEW',
  /** There are upcoming course sessions for the course context */
  Upcoming: 'UPCOMING'
} as const;

export type AdminCourse_SessionStatus = typeof AdminCourse_SessionStatus[keyof typeof AdminCourse_SessionStatus];
/** Queries for the courses list from the admin view */
export type AdminCoursesQueries = {
  __typename?: 'AdminCoursesQueries';
  /** Query courses by a search query and optional filters. */
  queryBySearchQueryAndFilters?: Maybe<AdminCourse_AdminCoursePaginatedResult>;
};


/** Queries for the courses list from the admin view */
export type AdminCoursesQueriesQueryBySearchQueryAndFiltersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: AdminCourse_QueryBySearchQueryAndFiltersInput;
  limit?: Scalars['Int'];
};

export type AdminPagePermissionsV1 = {
  __typename?: 'AdminPagePermissionsV1';
  canAccessPage: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type AdminPagePermissionsV1Connection = {
  __typename?: 'AdminPagePermissionsV1Connection';
  elements: Array<Maybe<AdminPagePermissionsV1>>;
  paging: ResponsePagination;
};

export type AdminPagePermissionsV1Resource = {
  __typename?: 'AdminPagePermissionsV1Resource';
  getAll?: Maybe<AdminPagePermissionsV1Connection>;
};


export type AdminPagePermissionsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/**
 * List of queries returning admin memberships in partners.
 * Kept for legacy purposes. New queries should request roles or permissions.
 */
export type AdminPartnerMembershipsQueries = {
  __typename?: 'AdminPartnerMembershipsQueries';
  /**
   * This query returns admin partner membership entries associated with a particular user.
   * Optionally filters by partner ID or role.
   */
  queryByUser: AdminPartnerMemberships_QueryByUserResponse;
};


/**
 * List of queries returning admin memberships in partners.
 * Kept for legacy purposes. New queries should request roles or permissions.
 */
export type AdminPartnerMembershipsQueriesQueryByUserArgs = {
  input: AdminPartnerMemberships_QueryByUserInput;
};

/** Representation of an admin membership. */
export type AdminPartnerMemberships_AdminPartnerMembership = {
  __typename?: 'AdminPartnerMemberships_AdminPartnerMembership';
  /** Date created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Membership ID */
  id: Scalars['ID'];
  /** Partner Id. */
  partnerId: Scalars['ID'];
  /** Role */
  role: AdminPartnerMemberships_AdminPartnerMembershipRole;
  /** User ID */
  userId: Scalars['ID'];
};

/** Role enum. */
export const AdminPartnerMemberships_AdminPartnerMembershipRole = {
  /** Course assistant role */
  CourseAssistant: 'COURSE_ASSISTANT',
  /** Data coordinator role */
  DataCoordinator: 'DATA_COORDINATOR',
  /** Instructor role */
  Instructor: 'INSTRUCTOR',
  /** Partner admin role */
  PartnerAdmin: 'PARTNER_ADMIN',
  /** Teaching staff role */
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type AdminPartnerMemberships_AdminPartnerMembershipRole = typeof AdminPartnerMemberships_AdminPartnerMembershipRole[keyof typeof AdminPartnerMemberships_AdminPartnerMembershipRole];
/** Instructor profile that is optionally fetched as part of admin partner memberships */
export type AdminPartnerMemberships_InstructorProfile = {
  __typename?: 'AdminPartnerMemberships_InstructorProfile';
  /** Instructor bio */
  bio?: Maybe<Scalars['String']>;
  /** Instructor's certificate title */
  certificateTitle?: Maybe<Scalars['String']>;
  /** Instructor department */
  department?: Maybe<Scalars['String']>;
  /** Instructor's email */
  email?: Maybe<Scalars['String']>;
  /** Instructor ethnicity */
  ethnicities?: Maybe<Array<Scalars['String']>>;
  /** Instructor full name */
  fullName?: Maybe<Scalars['String']>;
  /** Coursera ID of instructor */
  id: Scalars['Int'];
  /** Instructor photo link */
  photo?: Maybe<Scalars['String']>;
  /** Instructor shortname */
  shortName?: Maybe<Scalars['String']>;
  /** Boolean to indicate if instructor should be displayed on partner page */
  showOnPartnerPage?: Maybe<Scalars['Boolean']>;
  /** Instructor signature */
  signature?: Maybe<Scalars['String']>;
  /** Instructor's social media information */
  social?: Maybe<AdminPartnerMemberships_Social>;
  /** Instructor title */
  title?: Maybe<Scalars['String']>;
};

/** Input type for AdminPartnerMemberships_QueryByUserInput */
export type AdminPartnerMemberships_QueryByUserInput = {
  /** Optional fetch instructors */
  fetchInstructors?: Scalars['Boolean'];
  /** Optional filter by partner ID */
  partnerId?: InputMaybe<Scalars['ID']>;
  /** Optional filter by role */
  role?: InputMaybe<Scalars['String']>;
  /** User id */
  userId: Scalars['ID'];
};

/** Response object encompassing the admin memberships and instructor profiles */
export type AdminPartnerMemberships_QueryByUserResponse = {
  __typename?: 'AdminPartnerMemberships_QueryByUserResponse';
  /** Representation of an admin membership. */
  adminPartnerMemberships: Array<AdminPartnerMemberships_AdminPartnerMembership>;
  /** Instructor profiles */
  instructorProfiles?: Maybe<Array<AdminPartnerMemberships_InstructorProfile>>;
};

/** Instructor social media information */
export type AdminPartnerMemberships_Social = {
  __typename?: 'AdminPartnerMemberships_Social';
  /** Instrutor facebook link */
  facebook?: Maybe<Scalars['String']>;
  /** Instructor google plus */
  gplus?: Maybe<Scalars['String']>;
  /** Instructor linkedIn profile */
  linkedin?: Maybe<Scalars['String']>;
  /** Instructor twitter handle */
  twitter?: Maybe<Scalars['String']>;
  /** List of instructor websites */
  websites?: Maybe<Array<Scalars['String']>>;
  /** Instructor youtube channel */
  youtube?: Maybe<Scalars['String']>;
};

/** Queries for admin program impersonations. */
export type AdminProgramImpersonationsQueries = {
  __typename?: 'AdminProgramImpersonationsQueries';
  /**
   * Get impersonated program selections for a given organization.
   * User ID is inferred from request context.
   * Returns null if no active impersonation exists or if expired.
   */
  get?: Maybe<AdminProgramImpersonations_AdminProgramImpersonation>;
};


/** Queries for admin program impersonations. */
export type AdminProgramImpersonationsQueriesGetArgs = {
  thirdPartyOrganizationId: Scalars['ID'];
};

/** An admin's impersonated program selections for a specific organization. */
export type AdminProgramImpersonations_AdminProgramImpersonation = {
  __typename?: 'AdminProgramImpersonations_AdminProgramImpersonation';
  /** When the impersonation will expire. */
  expiresAt: Scalars['DateTime'];
  /** The organization being impersonated within. */
  organization: ThirdPartyOrganization_ThirdPartyOrganization;
  /** The program IDs the admin selected to impersonate. */
  programIds: Array<Scalars['ID']>;
};

/** Input for deleting impersonation selections. */
export type AdminProgramImpersonations_DeleteInput = {
  /** The organization ID. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of deleting impersonation selections. */
export type AdminProgramImpersonations_DeleteResult = AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_DeleteResultSuccess;

/** Error result for delete. */
export type AdminProgramImpersonations_DeleteResultError = Error & {
  __typename?: 'AdminProgramImpersonations_DeleteResultError';
  /** Error message. */
  message: Scalars['String'];
};

/** Success result for delete. */
export type AdminProgramImpersonations_DeleteResultSuccess = {
  __typename?: 'AdminProgramImpersonations_DeleteResultSuccess';
  /** The organization whose selections were deleted. */
  organization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Input for setting impersonation selections. */
export type AdminProgramImpersonations_SetInput = {
  /** Program IDs to impersonate. All must belong to the specified organization. */
  programIds: Array<Scalars['ID']>;
  /** The organization ID. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of setting impersonation selections. */
export type AdminProgramImpersonations_SetResult = AdminProgramImpersonations_SetResultError | AdminProgramImpersonations_SetResultSuccess;

/** Error result for set. */
export type AdminProgramImpersonations_SetResultError = Error & {
  __typename?: 'AdminProgramImpersonations_SetResultError';
  /** Error message. */
  message: Scalars['String'];
};

/** Success result for set. */
export type AdminProgramImpersonations_SetResultSuccess = {
  __typename?: 'AdminProgramImpersonations_SetResultSuccess';
  /** The saved impersonation. */
  impersonation: AdminProgramImpersonations_AdminProgramImpersonation;
};

/** List of queries returning staff memberships. */
export type AdminStaffMembershipsQueries = {
  __typename?: 'AdminStaffMembershipsQueries';
  /**
   * This query returns staff membership entries for all the session assistants associated with a
   * given session id.
   */
  querySessionAssistantsBySessionId: AdminStaffMemberships_SessionAssistantsBySessionIdResult;
  /** Given partner id, this query returns all staff with associated staff memberships. | Maximum page size: 2000 */
  queryStaffByPartner: AdminStaffMemberships_StaffByPartnerConnection;
};


/** List of queries returning staff memberships. */
export type AdminStaffMembershipsQueriesQuerySessionAssistantsBySessionIdArgs = {
  input: AdminStaffMemberships_SessionAssistantsBySessionIdInput;
};


/** List of queries returning staff memberships. */
export type AdminStaffMembershipsQueriesQueryStaffByPartnerArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  input: AdminStaffMemberships_StaffByPartnerInput;
};

/** Input type for AddSessionAssistantsByEmails */
export type AdminStaffMemberships_AddSessionAssistantsByEmailsInput = {
  /** list of emails to be added/invited to a session */
  emails: Array<Scalars['String']>;
  /** session id */
  sessionId: Scalars['ID'];
};

/** Error when the mutation partially succeeds */
export type AdminStaffMemberships_AddSessionAssistantsByEmailsPartialSuccess = {
  __typename?: 'AdminStaffMemberships_AddSessionAssistantsByEmailsPartialSuccess';
  /** Emails don't have Coursera account */
  invitesSent?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Error message */
  message: Scalars['String'];
  /** Emails of staff accounts added to a session as Session Assistant */
  staffAdded?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Result type for AddSessionAssistantsByEmails */
export type AdminStaffMemberships_AddSessionAssistantsByEmailsResult = AdminStaffMemberships_AddSessionAssistantsByEmailsPartialSuccess | AdminStaffMemberships_AddSessionAssistantsByEmailsSuccess;

/** This is returned if the mutation succeeds */
export type AdminStaffMemberships_AddSessionAssistantsByEmailsSuccess = {
  __typename?: 'AdminStaffMemberships_AddSessionAssistantsByEmailsSuccess';
  /** Emails don't have Coursera account */
  invitesSent?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Emails of staff accounts added to a session as Session Assistant */
  staffAdded?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** User IDs and session ID for role deletion. */
export type AdminStaffMemberships_DeleteSessionAssistantsInput = {
  /** Session ID */
  sessionId: Scalars['ID'];
  /** List of user IDs that should have their roles removed from the given session */
  userIds: Array<Scalars['ID']>;
};

/** Returned when all users were successfully removed */
export type AdminStaffMemberships_DeleteSessionAssistantsResult = {
  __typename?: 'AdminStaffMemberships_DeleteSessionAssistantsResult';
  /** List of users whose roles were successfully deleted from the given session */
  userIds: Array<Scalars['ID']>;
};

/** Staff Membership nested into Staff. */
export type AdminStaffMemberships_NestedStaffMembership = {
  __typename?: 'AdminStaffMemberships_NestedStaffMembership';
  /** Staff membership id in `userId~roleId~scopeType!~scopeId` format. */
  id: Scalars['ID'];
  /** Session Assistant role Id. */
  roleId: Scalars['ID'];
  /** Scope of staff memberships */
  scope: AdminStaffMemberships_Scope;
};

/** Role scope (Group, Course, Degree, Partner) object for staff memberships. */
export type AdminStaffMemberships_Scope = {
  __typename?: 'AdminStaffMemberships_Scope';
  /** Scope Id. */
  id: Scalars['ID'];
  /** Scope type name. */
  scopeTypeName: AdminStaffMemberships_ScopeType;
};

/** ScopeType enum. */
export const AdminStaffMemberships_ScopeType = {
  /** Type name for course scope */
  Course: 'COURSE',
  /** Type name for degree scope */
  Degree: 'DEGREE',
  /** Type name for group scope */
  Group: 'GROUP',
  /** Type name for partner scope */
  Partner: 'PARTNER'
} as const;

export type AdminStaffMemberships_ScopeType = typeof AdminStaffMemberships_ScopeType[keyof typeof AdminStaffMemberships_ScopeType];
/** Session ID to look up the session assistants associated with. */
export type AdminStaffMemberships_SessionAssistantsBySessionIdInput = {
  /** Session Id to look up. */
  sessionId: Scalars['ID'];
};

/** Returned when get session assistants by session id query ran successfully. */
export type AdminStaffMemberships_SessionAssistantsBySessionIdResult = {
  __typename?: 'AdminStaffMemberships_SessionAssistantsBySessionIdResult';
  /** List of session assistant staff memberships associated with a given session id. */
  staffMemberships?: Maybe<Array<Maybe<AdminStaffMemberships_StaffMembership>>>;
};

/** Staff node that includes user's full name, email and associated staff memberships. */
export type AdminStaffMemberships_Staff = Node & {
  __typename?: 'AdminStaffMemberships_Staff';
  /** User's email address. */
  email: Scalars['String'];
  /** User's full name. */
  fullName: Scalars['String'];
  /** User Id. */
  id: Scalars['ID'];
  /** Associated staff memberships. */
  staffMemberships: Array<AdminStaffMemberships_NestedStaffMembership>;
};

/** Paginated Staff */
export type AdminStaffMemberships_StaffByPartnerConnection = {
  __typename?: 'AdminStaffMemberships_StaffByPartnerConnection';
  /** Staff edges in the graph */
  edges?: Maybe<Array<AdminStaffMemberships_StaffEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of staff */
  totalCount: Scalars['Int'];
};

/** Partner ID to look up associated staff. */
export type AdminStaffMemberships_StaffByPartnerInput = {
  /** Partner id to look up. */
  partnerId: Scalars['ID'];
};

/** StaffEdge in graph. */
export type AdminStaffMemberships_StaffEdge = {
  __typename?: 'AdminStaffMemberships_StaffEdge';
  /** Offset for pagination */
  cursor: Scalars['String'];
  /** Staff */
  node: AdminStaffMemberships_Staff;
};

/** Staff Membership object. */
export type AdminStaffMemberships_StaffMembership = {
  __typename?: 'AdminStaffMemberships_StaffMembership';
  /** Staff membership id in `userId~roleId~scopeType!~scopeId` format. */
  id: Scalars['ID'];
  /** Session Assistant role Id. */
  roleId: Scalars['ID'];
  /** Scope of staff memberships */
  scope: AdminStaffMemberships_Scope;
  /** Staff user. */
  user: AdminStaffMemberships_User;
  /**
   * Staff user id.
   * @deprecated replaced with user field.
   */
  userId: Scalars['ID'];
};

/** User entity that includes user's full name and email. */
export type AdminStaffMemberships_User = {
  __typename?: 'AdminStaffMemberships_User';
  /** User's email address. */
  email: Scalars['String'];
  /** User's full name. */
  fullName: Scalars['String'];
  /** User Id. */
  id: Scalars['ID'];
};

export type AdminUserPermissionsV1 = {
  __typename?: 'AdminUserPermissionsV1';
  id: Scalars['String'];
  permissions: Scalars['JSON'];
};

export type AdminUserPermissionsV1ByUser = {
  __typename?: 'AdminUserPermissionsV1ByUser';
  connection?: Maybe<AdminUserPermissionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type AdminUserPermissionsV1Connection = {
  __typename?: 'AdminUserPermissionsV1Connection';
  elements: Array<Maybe<AdminUserPermissionsV1>>;
  paging: ResponsePagination;
};

export type AdminUserPermissionsV1My = {
  __typename?: 'AdminUserPermissionsV1My';
  connection?: Maybe<AdminUserPermissionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AdminUserPermissionsV1Resource = {
  __typename?: 'AdminUserPermissionsV1Resource';
  byUser?: Maybe<AdminUserPermissionsV1Connection>;
  my?: Maybe<AdminUserPermissionsV1Connection>;
};


export type AdminUserPermissionsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type AdminUserPermissionsV1ResourceMyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** List of queries returning admin user profiles */
export type AdminUserProfileQueries = {
  __typename?: 'AdminUserProfileQueries';
  /**
   * Returns profile information for an admin user. Only accessible to admin users in the same
   * institution.
   */
  queryByUser: AdminUserProfiles_AdminUserProfile;
};


/** List of queries returning admin user profiles */
export type AdminUserProfileQueriesQueryByUserArgs = {
  input: AdminUserProfiles_QueryByUserInput;
};

/**
 * Profile information for an admin user. Only accessible to admin users in the same
 * institution.
 */
export type AdminUserProfiles_AdminUserProfile = {
  __typename?: 'AdminUserProfiles_AdminUserProfile';
  /** User email */
  email?: Maybe<Scalars['String']>;
  /** User full name */
  fullName?: Maybe<Scalars['String']>;
  /** User ID */
  id: Scalars['ID'];
  /** URL to user profile picture if available */
  profilePicture?: Maybe<Scalars['URL']>;
  /** Timezone name, ex: America/Toronto */
  timezoneName?: Maybe<Scalars['String']>;
};

/** Input for queryByUser */
export type AdminUserProfiles_QueryByUserInput = {
  /** User ID for profile */
  userId: Scalars['ID'];
};

/** List of queries returning staff memberships. */
export type AdminUserRoleQueries = {
  __typename?: 'AdminUserRoleQueries';
  /** This query returns all user roles for a given user and partner ID. | Maximum page size: 100 */
  queryByUser: AdminUserRoles_RolesByUserConnection;
};


/** List of queries returning staff memberships. */
export type AdminUserRoleQueriesQueryByUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  input: AdminUserRoles_RolesByUserInput;
};

/** Paginated adminUserRoles */
export type AdminUserRoles_RolesByUserConnection = {
  __typename?: 'AdminUserRoles_RolesByUserConnection';
  /** Roles */
  edges: Array<AdminUserRoles_UserRoleEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of roles for this query */
  totalCount: Scalars['Int'];
};

/** Input for rolesByUser */
export type AdminUserRoles_RolesByUserInput = {
  /** Return only roles applying to content belonging to this partner */
  partnerId: Scalars['ID'];
  /** Text query searches role names and institution/program/course/group names */
  query?: InputMaybe<Scalars['String']>;
  /** Return only roles of this user */
  userId: Scalars['ID'];
};

/** Scope level for role */
export const AdminUserRoles_ScopeLevel = {
  /** Course scope level */
  Course: 'COURSE',
  /** Program (degree) scope level */
  Degree: 'DEGREE',
  /** Group (session) scope level */
  Group: 'GROUP',
  /** Institution (partner) scope level */
  Partner: 'PARTNER'
} as const;

export type AdminUserRoles_ScopeLevel = typeof AdminUserRoles_ScopeLevel[keyof typeof AdminUserRoles_ScopeLevel];
/** User role */
export type AdminUserRoles_UserRole = Node & {
  __typename?: 'AdminUserRoles_UserRole';
  /** ID in the format <userId>~<roleTemplateId>~<scopeLevel>!~<scopeId> */
  id: Scalars['ID'];
  /** ID of the element's parent scope. Populated with course ID for group-level roles */
  parentScopeId?: Maybe<Scalars['ID']>;
  /** Name of the element's parent scope. Populated with course name for group-level roles */
  parentScopeName?: Maybe<Scalars['String']>;
  /** Role name */
  roleName: Scalars['String'];
  /** Role template ID */
  roleTemplateId: Scalars['ID'];
  /** ID of the element to which the role applies (institution, program, course, or group ID) */
  scopeId: Scalars['ID'];
  /** Scope to which the role applies (institution, program, course, or group) */
  scopeLevel: AdminUserRoles_ScopeLevel;
  /** Name of the element to which the role applies (institution, program, course, or group name) */
  scopeName: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** A user role */
export type AdminUserRoles_UserRoleEdge = {
  __typename?: 'AdminUserRoles_UserRoleEdge';
  /** 1-indexed offset for pagination */
  cursor: Scalars['String'];
  /** Role */
  node: AdminUserRoles_UserRole;
};

/** Ai assignments dispute status */
export const AiAssignmments_DisputeStatus = {
  /** Status indicating dispute was processed and there are grade updtes */
  Accepted: 'ACCEPTED',
  /** Status indicating failure to process the dispute */
  Failed: 'FAILED',
  /** Status once dispute is requested but no decision has been made */
  InProgress: 'IN_PROGRESS',
  /** Status indicating dispute was processed but there won't be grade changes */
  Rejected: 'REJECTED'
} as const;

export type AiAssignmments_DisputeStatus = typeof AiAssignmments_DisputeStatus[keyof typeof AiAssignmments_DisputeStatus];
/** Ai assignments dispute issue categories */
export const AiAssignmments_IssueCategory = {
  /** Category indicates that The AI's evaluation of the answer doesn’t seem to align with the content of the course. */
  Accuracy: 'ACCURACY',
  /** Category indicates that AI has misunderstood the assignment requirements or objectives. */
  AssignmentUnderstanding: 'ASSIGNMENT_UNDERSTANDING',
  /** Category indicates the submission had extra materials that were not properly considered by AI. */
  ExtraMaterial: 'EXTRA_MATERIAL',
  /** Category indicates that the feedback provided by the AI does not align with the given grade. */
  GradeFeedbackMisalignment: 'GRADE_FEEDBACK_MISALIGNMENT',
  /** Category indicates any other issues not covered by the other categories. */
  Other: 'OTHER',
  /** Category indicates that AI has misinterpreted the grading rubric or criteria. */
  RubricMisinterpretation: 'RUBRIC_MISINTERPRETATION'
} as const;

export type AiAssignmments_IssueCategory = typeof AiAssignmments_IssueCategory[keyof typeof AiAssignmments_IssueCategory];
/** Input representing user feedback about a particular LLM response */
export type AiAuthoring_SubmitWritingAssistantFeedbackInput = {
  /** Optional user comment about the response */
  comment?: InputMaybe<Scalars['String']>;
  /** The ID of the response */
  id: Scalars['ID'];
  /** User's sentiment about the response */
  sentiment: AiAuthoring_WritingAssistantUserSentiment;
};

/**
 * AiAuthoring_SubmitWritingAssistantFeedback mutation result.
 * At the time of writing, there are no expected client errors to return, so the result union only contains a success
 * type. A union is used to allow for failure types to be returned in the future if product requirements evolve.
 */
export type AiAuthoring_SubmitWritingAssistantFeedbackResult = AiAuthoring_SubmitWritingAssistantFeedbackSuccess;

/** Represents a successful feedback submission */
export type AiAuthoring_SubmitWritingAssistantFeedbackSuccess = {
  __typename?: 'AiAuthoring_SubmitWritingAssistantFeedbackSuccess';
  /** The ID of the response the feedback was submitted for */
  id: Scalars['ID'];
};

/** Input to the AI Writing Assistant, containing various fields that can be set or unset depending on the use case */
export type AiAuthoring_WritingAssistantInput = {
  /** Optional input JSON that can be used for use cases requiring more complex, structured inputs */
  additionalInputs?: InputMaybe<Scalars['JSON']>;
  /** Optional input representing a selection of text that will be operated on for use cases like rewriting or critiquing */
  selectedText?: InputMaybe<AiAuthoring_WritingAssistantSelectedTextInput>;
  /** Input determining the system prompt that will be passed to the LLM */
  systemPrompt: AiAuthoring_WritingAssistantSystemPromptInput;
  /**
   * What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while
   * lower values like 0.2 will make it more focused and deterministic.
   */
  temperature?: Scalars['Float'];
  /** Optional user prompt which will be passed to the LLM for use cases requiring user input to guide generation */
  userPrompt?: InputMaybe<Scalars['String']>;
};

/** AI Writing Assistant response */
export type AiAuthoring_WritingAssistantResponse = {
  __typename?: 'AiAuthoring_WritingAssistantResponse';
  /**
   * The aggregate response of the LLM, formed by concatenating all deltas received so far. Intended to be used during
   * prompt development to easily view the full LLM response.
   */
  aggregateResponse: Scalars['String'];
  /** The next token of the response streamed from the LLM */
  delta: Scalars['String'];
  /** The ID of the response, which can be used to associate the response with user feedback */
  id: Scalars['ID'];
};

/** Represents a text selection */
export type AiAuthoring_WritingAssistantSelectedTextInput = {
  /** The complete text that the selection is a part of */
  completeText: Scalars['String'];
  /**
   * The index after the last character of the substring (exclusive). The length of the substring is expected to equal
   * selectionEndIndex - selectionStartIndex.
   */
  selectionEndIndex: Scalars['Int'];
  /** The index of the first character of the selection (inclusive) */
  selectionStartIndex: Scalars['Int'];
};

/**
 * Input determining the system prompt that will be passed to the LLM, expected to contain either a prompt template ID or
 * a prompt override string
 */
export type AiAuthoring_WritingAssistantSystemPromptInput = {
  /**
   * If set, the prompt override will be passed to the LLM, allowing different prompts to be tested without requiring code
   * changes or long-term persistence
   */
  promptOverride?: InputMaybe<Scalars['String']>;
  /**
   * If set, a system prompt corresponding to the template ID will be retrieved from a parameter store and passed to the
   * LLM
   */
  promptTemplateId?: InputMaybe<Scalars['ID']>;
};

/** Enum representing the user's sentiment about a particular LLM response */
export const AiAuthoring_WritingAssistantUserSentiment = {
  /** The user disliked the LLM response */
  Negative: 'NEGATIVE',
  /** The user liked the LLM response */
  Positive: 'POSITIVE'
} as const;

export type AiAuthoring_WritingAssistantUserSentiment = typeof AiAuthoring_WritingAssistantUserSentiment[keyof typeof AiAuthoring_WritingAssistantUserSentiment];
/** Queries related to AI cheating flagged events */
export type AiCheatingFlaggedEventQueries = {
  __typename?: 'AiCheatingFlaggedEventQueries';
  /** Returns all AI cheating flagged events for the given program. */
  queryByProgram: Array<AiCheatingFlaggedEvent_FlaggedEvent>;
};


/** Queries related to AI cheating flagged events */
export type AiCheatingFlaggedEventQueriesQueryByProgramArgs = {
  programId: Scalars['ID'];
};

/** An admin's manual review decision on an auto-flagged event. */
export const AiCheatingFlaggedEvent_AdminDecision = {
  /** The admin confirms the event is suspicious (upholds the flag). */
  Confirmed: 'CONFIRMED',
  /** The admin overrides the flag as a false positive (clears the learner). */
  Dismissed: 'DISMISSED'
} as const;

export type AiCheatingFlaggedEvent_AdminDecision = typeof AiCheatingFlaggedEvent_AdminDecision[keyof typeof AiCheatingFlaggedEvent_AdminDecision];
/** A single AI cheating flagged event for a learner on a course item. */
export type AiCheatingFlaggedEvent_FlaggedEvent = {
  __typename?: 'AiCheatingFlaggedEvent_FlaggedEvent';
  /** Free-text note left by the reviewing admin; null if not yet reviewed */
  adminComment?: Maybe<Scalars['String']>;
  /** Admin review decision overriding this auto-flagged event; null if not yet reviewed */
  adminDecision?: Maybe<AiCheatingFlaggedEvent_AdminDecision>;
  /** Time an admin last reviewed this event; null if not yet reviewed */
  adminReviewedAtTime?: Maybe<Scalars['DateTime']>;
  /** ID of the admin who reviewed this event; null if not yet reviewed */
  adminReviewedByUserId?: Maybe<Scalars['ID']>;
  /** Percentile rank of the anomaly score */
  anomalyPercentile: Scalars['Float'];
  /** Raw anomaly score assigned by the model */
  anomalyScore: Scalars['Float'];
  /** Count of blur (focus-loss) events observed during the assignment */
  blurAssignmentEvents: Scalars['Int'];
  /** Time taken to complete the item, in seconds */
  completionDurationSeconds: Scalars['Int'];
  /** ID of the course branch the event belongs to */
  courseBranchId: Scalars['ID'];
  /** ID of the course the event belongs to */
  courseId: Scalars['ID'];
  /** ID of the course item the event belongs to */
  courseItemId: Scalars['ID'];
  /** Calendar date the event occurred */
  eventDate: Scalars['Date'];
  /** Human-readable reason the event was flagged */
  flagReason: Scalars['String'];
  /** Time the event row was written to the store */
  insertedAtTime: Scalars['DateTime'];
  /** Ratio of delete keystrokes to total keystrokes */
  keystrokeDeleteRatio: Scalars['Float'];
  /** 50th percentile inter-keystroke interval, in milliseconds */
  keystrokeP50IkiMs: Scalars['Float'];
  /** 99th percentile inter-keystroke interval, in milliseconds */
  keystrokeP99IkiMs: Scalars['Float'];
  /** Standard deviation of inter-keystroke interval, in milliseconds */
  keystrokeStddevIkiMs: Scalars['Float'];
  /** Total number of keystrokes observed */
  keystrokeTotalKeystrokes: Scalars['Int'];
  /** Keystroke typing velocity, in keystrokes per second */
  keystrokeVelocityKps: Scalars['Float'];
  /** Name of the model that produced the flag */
  model: Scalars['String'];
  /** Version of the model that produced the flag */
  modelVersion: Scalars['String'];
  /** Count of paste events observed during the assignment */
  pasteAssignmentEvents: Scalars['Int'];
  /** ID of the enterprise program the learner is associated with */
  programId: Scalars['ID'];
  /** Time the event was scored by the model */
  scoredAtTime: Scalars['DateTime'];
  /** ID of the flagged learner */
  userId: Scalars['ID'];
};

/**
 * Input for an admin overriding a single auto-flagged AI cheating event, looked up by the
 * (userId, courseId, courseBranchId, courseItemId) tuple.
 */
export type AiCheatingFlaggedEvent_OverrideFlaggedEventInput = {
  /** Optional free-text note explaining the decision */
  adminComment?: InputMaybe<Scalars['String']>;
  /** The admin's review decision */
  adminDecision: AiCheatingFlaggedEvent_AdminDecision;
  /** ID of the course branch the event belongs to */
  courseBranchId: Scalars['ID'];
  /** ID of the course the event belongs to */
  courseId: Scalars['ID'];
  /** ID of the course item the event belongs to */
  courseItemId: Scalars['ID'];
  /** Name of the model that produced the flag; part of the key that uniquely identifies the event */
  model: Scalars['String'];
  /** ID of the flagged learner */
  userId: Scalars['ID'];
};

/** Result of overriding an auto-flagged AI cheating event. */
export type AiCheatingFlaggedEvent_OverrideFlaggedEventResult = {
  __typename?: 'AiCheatingFlaggedEvent_OverrideFlaggedEventResult';
  /** The flagged event with the admin override applied */
  flaggedEvent: AiCheatingFlaggedEvent_FlaggedEvent;
};

/** All AI coach queries */
export type AiCoachQueries = {
  __typename?: 'AiCoachQueries';
  /** This query returns the status and result of a Coach Async Task */
  queryAsyncTaskResult: AiCoach_AsyncTaskResult;
  /**
   * This query returns all the user messages and AI coach responses queried on a specific chat session ID. This is ordered
   * in decreasing order by the creation timestamp of the messages to help the FE UI with the ordering of the messages.
   */
  queryByChatSessionId: AiCoach_ChatMessagesPaginatedResult;
  /** This query returns all chat sessions queried on a specific user ID. */
  queryChatSessionsByUserId: AiCoach_ChatSessionPaginatedResult;
  /** This query returns the Coach settings for the current learner */
  queryCoachUserSettingsForUser: AiCoach_CoachUserSettings;
  /** POC query, convert speech to text */
  speechToText: AiCoach_SpeechToTextResult;
  /** POC query, convert text to speech */
  textToSpeech: AiCoach_TextToSpeechResult;
};


/** All AI coach queries */
export type AiCoachQueriesQueryAsyncTaskResultArgs = {
  taskId: Scalars['ID'];
};


/** All AI coach queries */
export type AiCoachQueriesQueryByChatSessionIdArgs = {
  chatSessionId: Scalars['ID'];
  cookieId?: InputMaybe<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
};


/** All AI coach queries */
export type AiCoachQueriesQueryChatSessionsByUserIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


/** All AI coach queries */
export type AiCoachQueriesSpeechToTextArgs = {
  audioBase64: Scalars['String'];
};


/** All AI coach queries */
export type AiCoachQueriesTextToSpeechArgs = {
  text: Scalars['String'];
};

/** This is used to track whether the learner's message was a direct action request or free-form. */
export const AiCoach_Action = {
  /** Direct action for the button 'Tell me what you can do' */
  AboutCoach: 'ABOUT_COACH',
  /** Direct action for the button 'Check my understanding' */
  CheckUnderstanding: 'CHECK_UNDERSTANDING',
  /** Action used in Coach Items (Roleplay) to initiate debrief session. */
  CoachItemGenerateFeedback: 'COACH_ITEM_GENERATE_FEEDBACK',
  /** Action used in Coach Items (Roleplay) to generate json representation of the scenario. Response is not shown to the learner. */
  CoachItemGenerateJson: 'COACH_ITEM_GENERATE_JSON',
  /** Action used in Coach Items (Roleplay) to initate scenario generation. Response of this is shown to the learner. */
  CoachItemGenerateScenario: 'COACH_ITEM_GENERATE_SCENARIO',
  /** Action used in Coach Items for learners to indicate that they are ready to start */
  CoachItemLetsGetStarted: 'COACH_ITEM_LETS_GET_STARTED',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_1: 'COACH_ITEM_PERSONALIZATION_OPTION_1',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_2: 'COACH_ITEM_PERSONALIZATION_OPTION_2',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_3: 'COACH_ITEM_PERSONALIZATION_OPTION_3',
  /**
   * Action used in Coach Items (Dialogue) for learners to indicate that they are ready to start with a personalized session.
   * Allows us to unique identify which option the user has selected without relying on the option's title (which may be translated).
   */
  CoachItemPersonalizationOption_4: 'COACH_ITEM_PERSONALIZATION_OPTION_4',
  /** Action used in the Coach Items to encourage learner to continue chat even when they feel stuck */
  CoachItemStuckContinue: 'COACH_ITEM_STUCK_CONTINUE',
  /** Action used in the Coach Items to indicate that chat should be ended as learner is stuck */
  CoachItemStuckEnd: 'COACH_ITEM_STUCK_END',
  /** Action used in the Coach Items completion flow to indicate to the FE and BE that the chat should be ended */
  CoachItemSummary: 'COACH_ITEM_SUMMARY',
  /** Action used in the Coach Items to indicate that chat should be ended as learner completed the tasks. */
  CoachItemTaskCompleted: 'COACH_ITEM_TASK_COMPLETED',
  /** Generic action buttons that does not require special handling in the BE */
  GenericAction: 'GENERIC_ACTION',
  /** Direct action for the button 'Help me get started' */
  HelpGetStartedWithCourse: 'HELP_GET_STARTED_WITH_COURSE',
  /** Action used in the Practice Moment to indicate that chat should be ended as user ended the activity. */
  PracticeMomentEndedActivity: 'PRACTICE_MOMENT_ENDED_ACTIVITY',
  /** Action used in the Practice Moment to indicate that it's a single turn activity. */
  PracticeMomentSingleTurn: 'PRACTICE_MOMENT_SINGLE_TURN',
  /** Direct action for the button 'Can you generate practice questions based on this video?' */
  PracticeQuestions: 'PRACTICE_QUESTIONS',
  /** Direct action for the button 'Give me a practice scenario' */
  PracticeScenario: 'PRACTICE_SCENARIO',
  /** Direct action for the button that asks coach to generate real-life examples */
  RealLifeExamples: 'REAL_LIFE_EXAMPLES',
  /** Direct action for the button 'Can you explain this topic in simple terms?' */
  SimpleExplanation: 'SIMPLE_EXPLANATION',
  /** Direct action for the button 'Put it in simple terms' */
  SimpleTerms: 'SIMPLE_TERMS',
  /** Direct action for the button 'Can you summarize this video for me?' */
  Summarize: 'SUMMARIZE',
  /** Direct action for the button 'Summarize this reading' */
  SummarizeReading: 'SUMMARIZE_READING',
  /** Free form message entered by the learner */
  TypedMessage: 'TYPED_MESSAGE',
  /** Direct action for generating a welcome message, prior to any user interaction */
  WelcomeMessage: 'WELCOME_MESSAGE',
  /** Direct action for the button 'Why should I take this course?' */
  WhyTakeCourse: 'WHY_TAKE_COURSE'
} as const;

export type AiCoach_Action = typeof AiCoach_Action[keyof typeof AiCoach_Action];
/** The additional context of a Coach chat as an input. */
export type AiCoach_AdditionalContextInput = {
  /** Context key for the additional context with a prefix of "additionalContext.". For example, "additionalContext.roleData" */
  contextKey: Scalars['String'];
  /** The value of the additional context. */
  contextValue: Scalars['String'];
};

/**
 * Analytics embedded content surfaced by the AI coach.
 * Contains the resulting metric data from the Analytics Control Plane.
 */
export type AiCoach_AnalyticsEmbeddedContent = AiCoach_EmbeddedContent & {
  __typename?: 'AiCoach_AnalyticsEmbeddedContent';
  /**
   * The analytics metric results returned from the Analytics Control Plane.
   * Null when the Control Plane returned no data.
   */
  analyticsData?: Maybe<Array<AiCoach_AnalyticsMetricResult>>;
  /**
   * Discriminator that identifies this as analytics embedded content.
   * Always returns ANALYTICS.
   */
  contentType: AiCoach_EmbeddedContentType;
};

/**
 * Embedded content surfaced when the NLQ-derived filters diverge from the overall applied filters.
 * Provides the client with enough information to display a confirmation or override prompt.
 */
export type AiCoach_AnalyticsFilterContent = AiCoach_EmbeddedContent & {
  __typename?: 'AiCoach_AnalyticsFilterContent';
  /**
   * Discriminator that identifies this as filter-override embedded content.
   * Always returns OVERRIDE_FILTERS.
   */
  contentType: AiCoach_EmbeddedContentType;
  /** True when the NLQ-derived filters conflict with the overall applied filters. */
  isConflict: Scalars['Boolean'];
  /**
   * The resolved filters the client should apply if the user accepts the override.
   * Null when there are no override filters to apply.
   */
  overrideFilters?: Maybe<AiCoach_AnalyticsFilters>;
};

/** Full set of filters applied to an analytics query. */
export type AiCoach_AnalyticsFilters = {
  __typename?: 'AiCoach_AnalyticsFilters';
  /** Contract IDs to scope the analytics query to. */
  contractIds?: Maybe<Array<Scalars['ID']>>;
  /** Date range to scope the analytics query to. Null when no date range filter is applied. */
  dateRange?: Maybe<AiCoach_DateRange>;
  /** Learner enrollment statuses to filter by. */
  learnerStatus?: Maybe<Array<AiCoach_LearnerStatus>>;
  /** Program IDs to scope the analytics query to. */
  programIds?: Maybe<Array<Scalars['ID']>>;
  /** Skill IDs to scope the analytics query to. */
  skillIds?: Maybe<Array<Scalars['ID']>>;
};

/**
 * Descriptive information about an analytics metric.
 * Maps directly to the MetricInfo message from the Analytics Control Plane proto.
 */
export type AiCoach_AnalyticsMetricInfo = {
  __typename?: 'AiCoach_AnalyticsMetricInfo';
  /** Dimensions that can be used to break down this metric. */
  availableDimensions?: Maybe<Array<Scalars['String']>>;
  /** Filter keys that can be applied when querying this metric. */
  availableFilters?: Maybe<Array<Scalars['String']>>;
  /** Time granularities supported for this metric (e.g. "day", "week", "month"). */
  availableGranularities?: Maybe<Array<Scalars['String']>>;
  /** Earliest date for which data is available for this metric. */
  dataAvailableFrom?: Maybe<Scalars['DateTime']>;
  /** Latest date for which data is available for this metric. */
  dataAvailableTo?: Maybe<Scalars['DateTime']>;
  /** Plain-language definition of what the metric measures. */
  definition: Scalars['String'];
  /** Human-readable display name of the metric. */
  displayName: Scalars['String'];
  /** Formula or expression used to compute the metric value. */
  formula?: Maybe<Scalars['String']>;
  /** Unique identifier of the metric. */
  metricId: Scalars['ID'];
  /** Number of decimal places to use when displaying the metric value. */
  precision?: Maybe<Scalars['Int']>;
  /** Unit of measurement for the metric (e.g. "count", "percent"). */
  unit?: Maybe<Scalars['String']>;
};

/** A single analytics metric result, including its metadata, KPIs, charts, and tables. */
export type AiCoach_AnalyticsMetricResult = {
  __typename?: 'AiCoach_AnalyticsMetricResult';
  /**
   * The filters that were actually applied when computing this metric result.
   * Null when the Analytics Control Plane did not echo back applied filters.
   */
  appliedFilters?: Maybe<AiCoach_AnalyticsFilters>;
  /** Visualization specifications describing charts to render for this metric. */
  chartSpecs?: Maybe<Array<AiCoach_VisualizationSpec>>;
  /** Key performance indicator values for this metric. */
  kpis?: Maybe<Array<AiCoach_MetricKpi>>;
  /**
   * Timestamp indicating when this metric's data was last refreshed.
   * Null when not provided by the Analytics Control Plane.
   */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Descriptive metadata about the metric, such as its display name, definition, and unit.
   * Null when the Control Plane did not return metric metadata.
   * @deprecated Use metricInfos instead. Retained for backward compatibility.
   */
  metricInfo?: Maybe<AiCoach_AnalyticsMetricInfo>;
  /**
   * Descriptive metadata about the metric, such as its display name, definition, and unit.
   * Null when the Control Plane did not return metric metadata.
   */
  metricInfos?: Maybe<Array<AiCoach_AnalyticsMetricInfo>>;
  /** Data tables associated with this metric result. */
  tables?: Maybe<Array<AiCoach_PresentationTable>>;
};

/** Metadata of the assignment item */
export type AiCoach_AssignmentItemMetadata = AiCoach_ItemMetadata & {
  __typename?: 'AiCoach_AssignmentItemMetadata';
  /** The course the item is in */
  course: Course_Course;
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
  /** Title of the assignment */
  itemTitle: Scalars['String'];
  /** Number of questions in the assignment */
  numQuestions: Scalars['Int'];
};

/**
 * Result of querying an async task status, including the result when completed.
 * This type provides both the current status of the async task and the actual
 * response data when the task has completed successfully.
 */
export type AiCoach_AsyncTaskResult = {
  __typename?: 'AiCoach_AsyncTaskResult';
  /**
   * The result data when the task is completed successfully.
   * This field is only populated when status is COMPLETED.
   */
  result?: Maybe<AiCoach_RespondToUserMessageResult>;
  /** The current status of the async task */
  status: AiCoach_AsyncTaskStatus;
};

/** The status of a Coach Async Task */
export const AiCoach_AsyncTaskStatus = {
  /** The async task has completed successfully */
  Completed: 'COMPLETED',
  /** The async task has failed */
  Failed: 'FAILED',
  /** The async task is picked up by a consumer and is in progress */
  InProgress: 'IN_PROGRESS',
  /** The async task is sent to the queue and waiting to be processed */
  Pending: 'PENDING'
} as const;

export type AiCoach_AsyncTaskStatus = typeof AiCoach_AsyncTaskStatus[keyof typeof AiCoach_AsyncTaskStatus];
/** Metadata describing a file attachment associated with a chat message, returned for display. */
export type AiCoach_Attachment = {
  __typename?: 'AiCoach_Attachment';
  /** The size of the file in bytes. */
  byteSize: Scalars['Int'];
  /** The MIME type of the file (e.g. "image/png", "application/pdf"). */
  mimeType: Scalars['String'];
  /** The original filename as provided by the user. */
  originalName: Scalars['String'];
  /** The S3 URL where the uploaded file is stored. */
  s3Url: Scalars['URL'];
};

/** Metadata describing a file attachment uploaded by the user and sent with a chat message. */
export type AiCoach_AttachmentInput = {
  /** The size of the file in bytes. */
  byteSize: Scalars['Int'];
  /** The MIME type of the file (e.g. "image/png", "application/pdf"). */
  mimeType: Scalars['String'];
  /** The original filename as provided by the user. */
  originalName: Scalars['String'];
  /** The S3 URL where the uploaded file is stored. */
  s3Url: Scalars['URL'];
};

/** This contains the chat message from the user or the AI coach. */
export type AiCoach_ChatMessage = Node & {
  __typename?: 'AiCoach_ChatMessage';
  /** File attachments associated with this message. Empty if none were attached. */
  attachments: Array<AiCoach_Attachment>;
  /**
   * A list of the clips that were recommended to the learner. It will be null in the case of a user message.
   * @deprecated Clip recommendations was rolled back.
   */
  clipRecommendations?: Maybe<Array<AiCoach_ClipRecommendation>>;
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Provides the Course ID context of the message if the context is available */
  courseId?: Maybe<Scalars['ID']>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: Maybe<AiCoach_CourseraContext>;
  /** The timestamp at which the message was created */
  createdAt: Scalars['DateTime'];
  /**
   * A list of embedded content items (e.g. analytics visualizations) surfaced by the AI coach.
   * It will be null in the case of a user message.
   */
  embeddedContents?: Maybe<Array<AiCoach_AnalyticsEmbeddedContent | AiCoach_AnalyticsFilterContent | AiCoach_McpToolCallEmbeddedContent>>;
  /** Message ID */
  id: Scalars['ID'];
  /** Provides the Item ID context of the message if the context is available */
  itemId?: Maybe<Scalars['ID']>;
  /** Message by the user or the AI coach */
  message: Scalars['String'];
  /**
   * A list of navigation buttons. It will be null in the case of a user message.
   * @deprecated Navigation Buttons was moved to Navigation Buttons V2.
   */
  navigationButtons?: Maybe<Array<AiCoach_GoToFirstItemNavigationButton>>;
  /** A list of V2 navigation buttons. It will be null in the case of a user message. */
  navigationButtonsV2?: Maybe<Array<AiCoach_ItemNavigationButton | AiCoach_RedirectLinkNavigationButton>>;
  /** A list of product cards recommended by the AI coach. It will be null in the case of a user message. */
  productCards?: Maybe<Array<AiCoach_ProductCard>>;
  /** A list of generated recommended actions. It will be null in the case of a user message. */
  recommendedActions?: Maybe<Array<AiCoach_RecommendedAction>>;
  /** A list of V2 generated recommended actions. It will be null in the case of a user message. */
  recommendedActionsV2?: Maybe<Array<AiCoach_CoachActionConfig>>;
  /** A list of generated recommendedEdit action. It will be null in the case of a user message. */
  recommendedEdits?: Maybe<Array<AiCoach_CoachEdit>>;
  /** Provides the Specialization ID context of the message if the context is available */
  s12nId?: Maybe<Scalars['ID']>;
  /** Specifies if the message sent is by the user or the AI coach */
  senderType: AiCoach_SenderType;
  /**
   * A JSON structured response from the LLM. Only available in actions configured with the responseSchema
   * field via CoachConfiguration.
   */
  structuredResponse?: Maybe<Scalars['JSON']>;
  /**
   * Task processing status, only populated for system replies to user messages sent with the TASK_BASED_PROCESSING processing type
   * @deprecated Please use the new async endpoint AiCoach_RespondToUserMessageAsync and queryAsyncTaskResult to check async task status.
   */
  taskStatus?: Maybe<AiCoach_TaskStatus>;
  /** Feedback from the user on the AI coach response via a comment */
  userComments?: Maybe<Scalars['String']>;
  /** Feedback from the user on the AI coach response via a like/dislike */
  userFeedback?: Maybe<AiCoach_UserFeedback>;
};

/** Chat messages with pagination */
export type AiCoach_ChatMessagesPaginatedResult = {
  __typename?: 'AiCoach_ChatMessagesPaginatedResult';
  /** Chat messages */
  elements: Array<AiCoach_ChatMessage>;
  /** Pagination */
  pagination: Pagination;
  /** The overall session of the chat */
  session: AiCoach_ChatSession;
};

/** Chat session type */
export type AiCoach_ChatSession = {
  __typename?: 'AiCoach_ChatSession';
  /** Chat Session Created At */
  createdAt: Scalars['DateTime'];
  /** Chat Session ID */
  id: Scalars['ID'];
  /** The state of the conversation as it pertains to whether messages can be sent */
  status: AiCoach_ChatSessionStatus;
  /** Chat Session Title */
  title: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Chat sessions with pagination */
export type AiCoach_ChatSessionPaginatedResult = {
  __typename?: 'AiCoach_ChatSessionPaginatedResult';
  /** Chat sessions */
  elements: Array<AiCoach_ChatSession>;
  /** Pagination */
  pagination: Pagination;
};

/** The state of the conversation as it pertains to whether messages can be sent */
export const AiCoach_ChatSessionStatus = {
  /** The conversation is open to new messages from the user */
  Active: 'ACTIVE',
  /** The conversation has concluded in error due to too many messages being sent */
  ChatLimitReached: 'CHAT_LIMIT_REACHED',
  /** The chat session data has been deleted */
  Deleted: 'DELETED',
  /** The chat session data is in the process of being deleted */
  Deleting: 'DELETING',
  /** The conversation has concluded intentionally either by the user or system */
  Ended: 'ENDED'
} as const;

export type AiCoach_ChatSessionStatus = typeof AiCoach_ChatSessionStatus[keyof typeof AiCoach_ChatSessionStatus];
/** Clip recommendation related to the message */
export type AiCoach_ClipRecommendation = {
  __typename?: 'AiCoach_ClipRecommendation';
  /** The course the clip is in */
  course: Course_Course;
  /** Duration of the clip */
  duration: Scalars['Duration'];
  /** ID of the item the clip is in */
  itemId: Scalars['ID'];
  /** Slug of the item the clip is in */
  itemSlug: Scalars['String'];
  /** Title of the item the clip is in */
  itemTitle: Scalars['String'];
  /** Partner names of the course the clip is in */
  partners: Array<Partner_Partner>;
  /** Preview image of the clip */
  previewImage: Scalars['URL'];
};

/** The configuration of a Coach Action. */
export type AiCoach_CoachActionConfig = {
  __typename?: 'AiCoach_CoachActionConfig';
  /** The label of the action showing the message associated with the action */
  actionLabel: Scalars['String'];
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /**
   * The progress loading messages used in the coach mode when waiting for Coach to generate response
   * @deprecated These will be managed on FE instead of passing from BE going forward.
   */
  progressLoadingMessages: Array<Scalars['String']>;
};

/** The configuration of Coach as an input. Contains a subset of fields from proto model coursera.proto.aicoach.v1beta1.CoachConfiguration. */
export type AiCoach_CoachConfigInput = {
  /** The max number of chat history messages included in prompt. */
  chatHistoryLimit?: InputMaybe<Scalars['Int']>;
  /** The max token of chat history messages included in prompt. */
  chatHistoryTokenLimit?: InputMaybe<Scalars['Int']>;
  /** The model used for config override, such as "gpt-5" */
  model?: InputMaybe<Scalars['String']>;
  /** System prompt template */
  systemPromptTemplate?: InputMaybe<Scalars['String']>;
  /** The max token of prompt, including system prompt template, context and chat history. */
  totalTokenLimit?: InputMaybe<Scalars['Int']>;
  /** The max user message length in characters. */
  userMessageLengthLimit?: InputMaybe<Scalars['Int']>;
};

/** Platform Feature: An edit to an object suggested by coach */
export type AiCoach_CoachEdit = {
  __typename?: 'AiCoach_CoachEdit';
  /** The child edit changes if the edit verb is GROUP */
  childChanges?: Maybe<Array<AiCoach_CoachEdit>>;
  /** The user response to the suggested edit */
  editUserResponse?: Maybe<AiCoach_CoachEditUserResponse>;
  /** The new value that coach is suggesting in the case of an ADD, UPDATE, or REORDER edit */
  editedValue?: Maybe<Scalars['String']>;
  /** The key for the edit */
  id: Scalars['ID'];
  /** Item type of proposed edit (null outside of content optimization edits) */
  itemType?: Maybe<AiCoach_OptimizationItemType>;
  /** The index at which the item should be added in the case of an ADD edit */
  newIndex?: Maybe<Scalars['Int']>;
  /** Coach's reasoning for the proposed edit */
  rationale?: Maybe<Scalars['String']>;
  /** A path pointing to the field that coach is suggesting be edited */
  subject: Scalars['String'];
  /** Coach's summary for the proposed edit */
  summary?: Maybe<Scalars['String']>;
  /** Coach's title for the proposed edit */
  title?: Maybe<Scalars['String']>;
  /** What type of edit coach is recommending (add, remove, update, reorder) */
  verb: AiCoach_CoachEditVerb;
};

/** The status of the edit user response */
export const AiCoach_CoachEditResponseStatus = {
  /** Approve */
  Approve: 'APPROVE',
  /** Reject */
  Reject: 'REJECT'
} as const;

export type AiCoach_CoachEditResponseStatus = typeof AiCoach_CoachEditResponseStatus[keyof typeof AiCoach_CoachEditResponseStatus];
/** The edit user response type */
export type AiCoach_CoachEditUserResponse = {
  __typename?: 'AiCoach_CoachEditUserResponse';
  /** Response type */
  responseStatus: AiCoach_CoachEditResponseStatus;
};

/** The type of edit being suggested by coach */
export const AiCoach_CoachEditVerb = {
  /** Denotes that coach would like to add an object */
  Add: 'ADD',
  /** Denotes that there are multiple suggested edits grouped together */
  Group: 'GROUP',
  /** Denotes that coach would like to remove an object */
  Remove: 'REMOVE',
  /** Denotes that coach would like to reorder the elements of a list field */
  Reorder: 'REORDER',
  /** Denotes that coach would like to update an field or object */
  Update: 'UPDATE'
} as const;

export type AiCoach_CoachEditVerb = typeof AiCoach_CoachEditVerb[keyof typeof AiCoach_CoachEditVerb];
/** Coach Memory */
export type AiCoach_CoachMemory = {
  __typename?: 'AiCoach_CoachMemory';
  /** createdAt */
  createdAt: Scalars['DateTime'];
  /** memoryId */
  memoryId: Scalars['ID'];
  /** text of memory */
  text: Scalars['String'];
};

/** The coach settings memory preference for the user */
export type AiCoach_CoachSettingsMemoryPreference = {
  __typename?: 'AiCoach_CoachSettingsMemoryPreference';
  /** Enable collection of memory and usage in user interactions */
  enableMemory: Scalars['Boolean'];
};

/** Input for setting the coach settings memory preference */
export type AiCoach_CoachSettingsMemoryPreferenceInput = {
  /** Enable collection of memory and usage in interactions */
  enableMemory: Scalars['Boolean'];
};

/** The coach settings profile preference for the user */
export type AiCoach_CoachSettingsProfilePreference = {
  __typename?: 'AiCoach_CoachSettingsProfilePreference';
  /** Enable additional info */
  enableAdditionalInfo: Scalars['Boolean'];
  /** Enable education history */
  enableEducationHistory: Scalars['Boolean'];
  /** Enable location */
  enableLocation: Scalars['Boolean'];
  /** Enable the usage of user profile or completely disable the usage of all user profile fields */
  enableProfile: Scalars['Boolean'];
  /** Enable work history */
  enableWorkHistory: Scalars['Boolean'];
};

/** Input for setting the coach settings profile preference */
export type AiCoach_CoachSettingsProfilePreferenceInput = {
  /** Enable additional info */
  enableAdditionalInfo: Scalars['Boolean'];
  /** Enable education history */
  enableEducationHistory: Scalars['Boolean'];
  /** Enable location */
  enableLocation: Scalars['Boolean'];
  /** Enable the usage of user profile or completely disable the usage of all user profile fields */
  enableProfile: Scalars['Boolean'];
  /** Enable work history */
  enableWorkHistory: Scalars['Boolean'];
};

/** The coach settings for the user */
export type AiCoach_CoachUserSettings = {
  __typename?: 'AiCoach_CoachUserSettings';
  /** Coach settings memory preference */
  memoryPreference: AiCoach_CoachSettingsMemoryPreference;
  /** Coach settings profile preference */
  profilePreference: AiCoach_CoachSettingsProfilePreference;
};

/** The configuration of a Coach chat message as an input. */
export type AiCoach_ConfigurationInput = {
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Optional parameter containing the coach config version. If not provided, the latest published config is used. */
  coachConfigVersion?: InputMaybe<Scalars['Int']>;
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Include structured output in chat history */
  includeStructuredOutputInChatHistory?: Scalars['Boolean'];
};

/** Context of where the dynamic prompts are to be shown to the learner */
export const AiCoach_ContextType = {
  /** Shows dynamic prompts in Coach Tutor Disclosure UI */
  Disclosure: 'DISCLOSURE'
} as const;

export type AiCoach_ContextType = typeof AiCoach_ContextType[keyof typeof AiCoach_ContextType];
/** Coursera info used to help the AI coach understand the context of the message in coursera. */
export type AiCoach_CourseraContext = {
  __typename?: 'AiCoach_CourseraContext';
  /** List of additional products the user need as supporting context */
  additionalProducts?: Maybe<Array<AiCoach_Product>>;
  /** Provides the AuthoringCourseBranch ID context of the message if the context is available. */
  authoringCourseBranchId?: Maybe<Scalars['ID']>;
  /** Course the user is currently on. */
  course?: Maybe<Course_Course>;
  /** Provides the CourseBranch ID context of the message if the context is available. */
  courseBranchId?: Maybe<Scalars['ID']>;
  /** Degree the user is currently on. */
  degree?: Maybe<Degree_Degree>;
  /** Provides the Item ID context of the message if the context is available. */
  itemId?: Maybe<Scalars['ID']>;
  /** Provides the Module ID context of the message if the context is available. */
  moduleId?: Maybe<Scalars['ID']>;
  /** Specialization the user is currently on. */
  specialization?: Maybe<Specialization_Specialization>;
};

/** Contextual information used to help the AI coach understand the context of the message in coursera. */
export type AiCoach_CourseraContextInput = {
  /** List of additional products the user need as supporting context */
  additionalProducts?: InputMaybe<Array<AiCoach_ProductInput>>;
  /** Provides the AuthoringCourseBranch ID context of the message if the context is available. */
  authoringCourseBranchId?: InputMaybe<Scalars['ID']>;
  /** Provides the CourseBranch ID context of the message if the context is available. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Degree ID the user is currently on */
  degreeId?: InputMaybe<Scalars['ID']>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Module ID the user is currently on */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Specialization ID the user is currently on */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** The enum indicating the type of the product for the AI coach to understand the additional context of the message in coursera. */
export const AiCoach_CourseraProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type AiCoach_CourseraProductType = typeof AiCoach_CourseraProductType[keyof typeof AiCoach_CourseraProductType];
/** Input for creating a new chat session */
export type AiCoach_CreateChatSessionInput = {
  /** Chat Session Title */
  title: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Response type for creating a new chat session */
export type AiCoach_CreateChatSessionResult = {
  __typename?: 'AiCoach_CreateChatSessionResult';
  /** Chat Session Created At */
  createdAt: Scalars['DateTime'];
  /** Chat Session ID */
  id: Scalars['ID'];
  /** Chat Session Title */
  title: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** The input to create a LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenDevInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * Agent type name to specify which agent should be dispatched to the room when
   * a user joins. Should match the one you are using in local testing.
   */
  agentTypeName: Scalars['String'];
  /** Existing Coach chat session id. */
  chatSessionId: Scalars['ID'];
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
};

/** LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenDevResult = {
  __typename?: 'AiCoach_CreateLiveKitTokenDevResult';
  /** LiveKit access token (JWT) */
  jwt: Scalars['String'];
  /** Participant identity used in LiveKit (not raw userId) */
  participantIdentity: Scalars['ID'];
  /** Room identifier used in LiveKit */
  roomName: Scalars['String'];
  /** LiveKit websocket URL (wss://...livekit.cloud) */
  serviceUri: Scalars['String'];
};

/** The input to create a LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /** Existing Coach chat session id. */
  chatSessionId: Scalars['ID'];
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
};

/** LiveKit access token + websocket URL for realtime audio room join. */
export type AiCoach_CreateLiveKitTokenResult = {
  __typename?: 'AiCoach_CreateLiveKitTokenResult';
  /** LiveKit access token (JWT) */
  jwt: Scalars['String'];
  /** Participant identity used in LiveKit (not raw userId) */
  participantIdentity: Scalars['ID'];
  /** Room identifier used in LiveKit */
  roomName: Scalars['String'];
  /** LiveKit websocket URL (wss://...livekit.cloud) */
  serviceUri: Scalars['String'];
};

/**
 * Input for creating and returning the message from the user and the subsequent response returned by the AI coach.
 * The input includes the optional fields of courseId and itemId, or s12nId to help link the chat
 * message to those fields, if the context allows.
 */
export type AiCoach_CreateUserMessageAndReturnResponseInput = {
  /** This signifies a direct action or a message typed out by the learner in the FE. */
  action?: AiCoach_Action;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** Optional parameter containing the coach config version. If not provided, the latest published config is used. */
  coachConfigVersion?: InputMaybe<Scalars['Int']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
  /** Coach mode. */
  mode?: AiCoach_Mode;
  /** Specialization ID the user is currently on */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** User ID */
  userId: Scalars['ID'];
};

/** The result with the message created by the user and the subsequent response returned by the AI coach. */
export type AiCoach_CreateUserMessageAndReturnResponseResult = {
  __typename?: 'AiCoach_CreateUserMessageAndReturnResponseResult';
  /**
   * The ID of the current chat session
   * @deprecated Instead, access via session.id
   */
  chatSessionId: Scalars['ID'];
  /**
   * A list of clip recommendation related to the message
   * @deprecated Clip recommendations was rolled back.
   */
  clipRecommendations: Array<AiCoach_ClipRecommendation>;
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Message response from the AI coach */
  messageByAiCoach: AiCoach_MessageByAiCoach;
  /** Message created by the user */
  messageByUser: AiCoach_MessageByUser;
  /**
   * A list of navigation buttons. Both clip recommendations and recommended actions will be empty if navigation buttons are present.
   * @deprecated Navigation Buttons was moved to Navigation Buttons V2.
   */
  navigationButtons?: Maybe<Array<AiCoach_GoToFirstItemNavigationButton>>;
  /** A list of generated recommended actions. It will be empty if no actions are generated or if clip recommendations present. */
  recommendedActions: Array<AiCoach_RecommendedAction>;
  /** The session to which this message belongs */
  session: AiCoach_ChatSession;
};

/** Date range used to scope an analytics query. */
export type AiCoach_DateRange = {
  __typename?: 'AiCoach_DateRange';
  /** End date timestamp. */
  end: Scalars['DateTime'];
  /** Start date timestamp */
  start: Scalars['DateTime'];
  /** Preset date range type that produced this range. Null when an explicit custom range was used. */
  type?: Maybe<AiCoach_DateRangeType>;
};

/** Preset date range selection used to scope an analytics query. */
export const AiCoach_DateRangeType = {
  /** All available historical data with no date restriction. */
  AllTime: 'ALL_TIME',
  /** A custom date range specified by the user. */
  Custom: 'CUSTOM',
  /** Last 30 days from the current date. */
  Last_30Days: 'LAST_30_DAYS',
  /** Last 60 days from the current date. */
  Last_60Days: 'LAST_60_DAYS',
  /** Last 90 days from the current date. */
  Last_90Days: 'LAST_90_DAYS'
} as const;

export type AiCoach_DateRangeType = typeof AiCoach_DateRangeType[keyof typeof AiCoach_DateRangeType];
/** Response type for deleting all chat sessions for the current learner */
export type AiCoach_DeleteAllChatSessionsForCurrentUserResult = {
  __typename?: 'AiCoach_DeleteAllChatSessionsForCurrentUserResult';
  /** The id of the async task created to delete all chat sessions */
  taskId: Scalars['ID'];
};

/** Response type for deleting all chat sessions for the current learner */
export type AiCoach_DeleteAllChatSessionsForUserResult = {
  __typename?: 'AiCoach_DeleteAllChatSessionsForUserResult';
  /** Chat Session IDs deleted */
  chatSessionIds: Array<Scalars['ID']>;
};

/** Response type for deleting all memories for the current learner */
export type AiCoach_DeleteAllMemoriesForCurrentUserResult = {
  __typename?: 'AiCoach_DeleteAllMemoriesForCurrentUserResult';
  /** The id of the async task created to delete all memories */
  taskId: Scalars['ID'];
};

/** Input for deleting chat sessions for the current learner */
export type AiCoach_DeleteChatSessionsForCurrentUserInput = {
  /** Chat Session IDs */
  chatSessionIds: Array<Scalars['ID']>;
};

/** Response type for deleting chat sessions for the current learner */
export type AiCoach_DeleteChatSessionsForCurrentUserResult = {
  __typename?: 'AiCoach_DeleteChatSessionsForCurrentUserResult';
  /** The id of the async task created to delete the chat sessions */
  taskId: Scalars['ID'];
};

/** Input for deleting memories for the current learner */
export type AiCoach_DeleteMemoriesForCurrentUserInput = {
  /** Memory IDs */
  memoryIds: Array<Scalars['ID']>;
};

/** Response type for deleting memories for the current learner */
export type AiCoach_DeleteMemoriesForCurrentUserResult = {
  __typename?: 'AiCoach_DeleteMemoriesForCurrentUserResult';
  /** The id of the async task created to delete the memories */
  taskId: Scalars['ID'];
};

/** Difficulty level of a Coursera product. */
export const AiCoach_DifficultyLevel = {
  /** Suitable for learners with substantial experience and deep knowledge of the subject. */
  Advanced: 'ADVANCED',
  /** Suitable for learners with little to no prior knowledge of the subject. */
  Beginner: 'BEGINNER',
  /** Suitable for learners with some foundational knowledge of the subject. */
  Intermediate: 'INTERMEDIATE',
  /** Contains content spanning multiple difficulty levels. */
  Mixed: 'MIXED'
} as const;

export type AiCoach_DifficultyLevel = typeof AiCoach_DifficultyLevel[keyof typeof AiCoach_DifficultyLevel];
/** A single dynamic prompt */
export type AiCoach_DynamicPrompt = {
  __typename?: 'AiCoach_DynamicPrompt';
  /** Label for the button with translation */
  buttonLabel: Scalars['String'];
  /** The associated coach action */
  coachAction: Scalars['String'];
  /** The associated coach mode */
  coachMode: Scalars['String'];
  /** ID of the dynamic prompt shown to the learner */
  id: Scalars['ID'];
};

/** Result for dynamic prompts query */
export type AiCoach_DynamicPromptsResult = {
  __typename?: 'AiCoach_DynamicPromptsResult';
  /** List of the dynamic prompts to be shown to the learner */
  dynamicPrompts: Array<AiCoach_DynamicPrompt>;
};

/**
 * Base interface for embedded content returned by the AI coach.
 * All embedded content types must implement this interface.
 * This is intentionally generic to support future content types from other teams.
 */
export type AiCoach_EmbeddedContent = {
  /** Discriminator that identifies the concrete subtype of this embedded content. */
  contentType: AiCoach_EmbeddedContentType;
};

/**
 * The type of embedded content returned by the AI coach.
 * Each value identifies a concrete implementation of AiCoach_EmbeddedContent.
 */
export const AiCoach_EmbeddedContentType = {
  /** Embedded content containing analytics data from the Analytics Control Plane. */
  Analytics: 'ANALYTICS',
  /**
   * Embedded content representing a tool call returned by an MCP server, optionally
   * carrying an interactive MCP App.
   */
  McpToolCall: 'MCP_TOOL_CALL',
  /**
   * Embedded content representing a filter override, surfaced when the NLQ-derived filters
   * conflict with or diverge from the overall applied filters.
   */
  OverrideFilters: 'OVERRIDE_FILTERS'
} as const;

export type AiCoach_EmbeddedContentType = typeof AiCoach_EmbeddedContentType[keyof typeof AiCoach_EmbeddedContentType];
/** Metadata of the generic item for currently unsupported item types */
export type AiCoach_GenericItemMetadata = AiCoach_ItemMetadata & {
  __typename?: 'AiCoach_GenericItemMetadata';
  /** The course the item is in */
  course: Course_Course;
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
  /** Title of the item */
  itemTitle: Scalars['String'];
};

/** Navigation button for going to the first item */
export type AiCoach_GoToFirstItemNavigationButton = AiCoach_NavigationButton & {
  __typename?: 'AiCoach_GoToFirstItemNavigationButton';
  /** Metadata of the item to navigate to */
  itemMetadata: AiCoach_AssignmentItemMetadata | AiCoach_GenericItemMetadata | AiCoach_LectureItemMetadata | AiCoach_QuizItemMetadata | AiCoach_ReadingItemMetadata;
  /** Navigation leading message, which will appear before the navigation button */
  navigationLeadingMessage: AiCoach_NavigationLeadingMessage;
};

/** Item metadata */
export type AiCoach_ItemMetadata = {
  /** The course the item is in */
  course: Course_Course;
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
};

/** Platform feature: Navigation button for going to an course item */
export type AiCoach_ItemNavigationButton = AiCoach_NavigationButtonV2 & {
  __typename?: 'AiCoach_ItemNavigationButton';
  /** The label on the inner clickable button. Optional in case a new design removes the button. */
  buttonLabel?: Maybe<Scalars['String']>;
  /** Metadata of the item to navigate to */
  itemMetadata: AiCoach_AssignmentItemMetadata | AiCoach_GenericItemMetadata | AiCoach_LectureItemMetadata | AiCoach_QuizItemMetadata | AiCoach_ReadingItemMetadata;
  /** Navigation leading message, which will appear before the navigation button */
  navigationLeadingMessage: Scalars['String'];
};

/**
 * Comparison block showing a KPI's change relative to a prior period.
 * Maps directly to the KpiComparisonBlock message from the Analytics Control Plane proto.
 */
export type AiCoach_KpiComparisonBlock = {
  __typename?: 'AiCoach_KpiComparisonBlock';
  /** Absolute change from the comparison period to the current period. */
  delta?: Maybe<Scalars['Float']>;
  /** Formatted string representation of the absolute delta. */
  deltaFormatted?: Maybe<Scalars['String']>;
  /** Percentage change from the comparison period to the current period. */
  deltaPercent?: Maybe<Scalars['Float']>;
  /** Formatted string representation of the percentage delta. */
  deltaPercentFormatted?: Maybe<Scalars['String']>;
  /** Direction of change: "up", "down", or "neutral". */
  direction?: Maybe<Scalars['String']>;
  /** Formatted string representation of the comparison value, ready for display. */
  formatted?: Maybe<Scalars['String']>;
  /** Human-readable label for the comparison (e.g. "Prior Period"). */
  label?: Maybe<Scalars['String']>;
  /** Human-readable label for the comparison time period. */
  periodLabel?: Maybe<Scalars['String']>;
  /** Unit of measurement for the comparison value (e.g. "count", "percent"). */
  unit?: Maybe<Scalars['String']>;
  /** Raw numeric value of the KPI in the comparison period. */
  value?: Maybe<Scalars['Float']>;
};

/**
 * The numeric and display representation of a KPI value.
 * Maps directly to the KpiValue message from the Analytics Control Plane proto.
 */
export type AiCoach_KpiValue = {
  __typename?: 'AiCoach_KpiValue';
  /** Aggregation method used to compute this KPI (e.g. "sum", "average"). */
  aggregation?: Maybe<Scalars['String']>;
  /** Formatted string representation of the value, ready for display. */
  formatted?: Maybe<Scalars['String']>;
  /**
   * Deprecated: use `title` instead.
   * @deprecated Use `title` instead.
   */
  label?: Maybe<Scalars['String']>;
  /** Human-readable label for the time period this value covers. */
  periodLabel?: Maybe<Scalars['String']>;
  /** Secondary display text providing additional context for this KPI (e.g. a date range or filter description). */
  subtitle?: Maybe<Scalars['String']>;
  /** Human-readable title for this KPI (e.g. "Total Enrollments"). Replaces the deprecated `label` field. */
  title?: Maybe<Scalars['String']>;
  /** Unit of measurement for the value (e.g. "count", "percent"). */
  unit?: Maybe<Scalars['String']>;
  /** Raw numeric value of the KPI. */
  value?: Maybe<Scalars['Float']>;
};

/** Learner enrollment status used in analytics filters. */
export const AiCoach_LearnerStatus = {
  /** Learner has been invited but has not yet joined. */
  Invited: 'INVITED',
  /** Learner has accepted the invitation and joined. */
  Joined: 'JOINED',
  /** Learner has been removed from the program or contract. */
  Removed: 'REMOVED'
} as const;

export type AiCoach_LearnerStatus = typeof AiCoach_LearnerStatus[keyof typeof AiCoach_LearnerStatus];
/** Metadata of the lecture item */
export type AiCoach_LectureItemMetadata = AiCoach_ItemMetadata & {
  __typename?: 'AiCoach_LectureItemMetadata';
  /** The course the item is in */
  course: Course_Course;
  /** Duration of the lecture */
  duration: Scalars['Duration'];
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
  /** Title of the lecture */
  itemTitle: Scalars['String'];
};

/**
 * Input for re-pointing a logged-out learner's chat history to the calling authenticated user at
 * first-time registration.
 */
export type AiCoach_LinkLoggedOutHistoryToCurrentUserInput = {
  /**
   * Optional single chat session to migrate. When omitted, all sessions owned by the logged-out
   * identity are migrated (the recommended client behavior).
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /**
   * The __204u cookie value identifying the logged-out session whose chat history should be linked.
   * Cross-checked server-side against the __204u request cookie; a mismatch is rejected.
   */
  cookieId: Scalars['ID'];
};

/** Result of linking a logged-out learner's chat history to the authenticated user. */
export type AiCoach_LinkLoggedOutHistoryToCurrentUserResult = {
  __typename?: 'AiCoach_LinkLoggedOutHistoryToCurrentUserResult';
  /** Number of chat messages whose ownership was migrated to the authenticated user. */
  migratedMessageCount: Scalars['Int'];
  /** Number of chat sessions whose ownership was migrated to the authenticated user. */
  migratedSessionCount: Scalars['Int'];
};

/**
 * Metadata for an interactive MCP App UI returned by an MCP tool call. Carried in
 * the appContent field of AiCoach_McpToolCallEmbeddedContent. Clients use these URLs
 * to render the App inside a sandboxed iframe per the MCP App protocol.
 */
export type AiCoach_McpAppContent = {
  __typename?: 'AiCoach_McpAppContent';
  /**
   * Allowed base URIs for the App document. Maps to the CSP base-uri directive.
   * Sourced from _meta.ui.csp.baseUriDomains. Null or empty when unspecified.
   */
  cspBaseUriDomains?: Maybe<Array<Scalars['String']>>;
  /**
   * Origins permitted for fetch, XHR, and WebSocket connections from the App.
   * Maps to the CSP connect-src directive. Sourced from _meta.ui.csp.connectDomains
   * on the MCP App resource. Null or empty when the App declares no external
   * network access (secure default). Wildcard subdomains are supported (e.g.
   * "https://*.example.com").
   */
  cspConnectDomains?: Maybe<Array<Scalars['String']>>;
  /**
   * Origins permitted for nested iframes within the App (e.g. YouTube embeds).
   * Maps to the CSP frame-src directive. Sourced from _meta.ui.csp.frameDomains.
   * Null or empty when the App embeds no third-party frames.
   */
  cspFrameDomains?: Maybe<Array<Scalars['String']>>;
  /**
   * Origins permitted for static resources (images, scripts, stylesheets, fonts,
   * media) loaded by the App. Maps to the CSP img-src, script-src, style-src,
   * font-src, and media-src directives. Sourced from _meta.ui.csp.resourceDomains.
   * Null or empty when the App declares no external resources.
   */
  cspResourceDomains?: Maybe<Array<Scalars['String']>>;
  /**
   * URL of the MCP Server that produced this app, so the host can load the resourceUri.
   * Always present.
   */
  mcpServerUrl: Scalars['URL'];
  /**
   * Opt-in sandbox permissions the App requests from the host iframe (e.g.
   * "camera", "microphone", "geolocation", "clipboardWrite"). Sourced from
   * _meta.ui.permissions on the MCP App resource. Null or empty when the App
   * requests no additional permissions.
   */
  permissions?: Maybe<Array<Scalars['String']>>;
  /**
   * Server-rendered HTML fallback for the App. Used as a backup to render the
   * content directly when the client is unable to fully connect to the MCP
   * server and load the App into a sandboxed iframe. Null when no fallback is
   * available and the client should rely on the live MCP App connection.
   */
  renderedHtml?: Maybe<Scalars['String']>;
  /**
   * Resource URI (typically a ui:// URI) that the host should load into a sandboxed
   * iframe and render via the MCP App UI runtime. Always present.
   */
  resourceUri: Scalars['String'];
  /**
   * URL to the hosted sandbox_proxy.html. Hosted on an origin distinct from the host
   * app to enforce cross-origin sandboxing per the MCP App protocol.
   */
  sandboxProxyUrl: Scalars['URL'];
};

/**
 * Embedded content representing an MCP tool call result. When the tool returns
 * an interactive MCP App, appContent is populated and the client should render it
 * in a sandboxed iframe. Otherwise the structuredResponse JSON is rendered by a
 * client-side handler keyed on toolName.
 */
export type AiCoach_McpToolCallEmbeddedContent = AiCoach_EmbeddedContent & {
  __typename?: 'AiCoach_McpToolCallEmbeddedContent';
  /**
   * Interactive App content for this tool call. Null when the tool did not return
   * an MCP App.
   */
  appContent?: Maybe<AiCoach_McpAppContent>;
  /**
   * Discriminator that identifies this as an MCP tool-call embedded content.
   * Always returns MCP_TOOL_CALL.
   */
  contentType: AiCoach_EmbeddedContentType;
  /**
   * Structured JSON response from the tool. Rendered by a client-side handler
   * keyed on toolName when no appContent is present.
   */
  structuredResponse?: Maybe<Scalars['JSON']>;
  /**
   * Function or tool name that was invoked (e.g. "search_catalog"). Mirrors
   * ToolCall.functionName on the backend. Always present.
   */
  toolName: Scalars['String'];
};

/** The response that is returned by the AI coach. */
export type AiCoach_MessageByAiCoach = {
  __typename?: 'AiCoach_MessageByAiCoach';
  /** Message response by the AI coach */
  message: Scalars['String'];
  /** Message ID */
  messageId: Scalars['ID'];
  /** The senderType should be the AI coach */
  senderType: AiCoach_SenderType;
  /**
   * A JSON structured response from the LLM. Only available in actions configured with the responseSchema
   * field via CoachConfiguration.
   */
  structuredResponse?: Maybe<Scalars['JSON']>;
};

/** The message that is created by the user. */
export type AiCoach_MessageByUser = {
  __typename?: 'AiCoach_MessageByUser';
  /** File attachments the user sent with this message. Empty if none were attached. */
  attachments: Array<AiCoach_Attachment>;
  /** Message by the user */
  message: Scalars['String'];
  /** Message ID */
  messageId: Scalars['ID'];
  /** The senderType should be the user */
  senderType: AiCoach_SenderType;
};

/** A key performance indicator value for an analytics metric. */
export type AiCoach_MetricKpi = {
  __typename?: 'AiCoach_MetricKpi';
  /**
   * Comparison block showing this KPI's change relative to a prior period.
   * Deprecated: use `comparisons` instead.
   */
  comparisonBlock?: Maybe<AiCoach_KpiComparisonBlock>;
  /** Comparison blocks showing this KPI's change relative to prior periods. */
  comparisons?: Maybe<Array<AiCoach_KpiComparisonBlock>>;
  /** Unique identifier of the KPI. */
  id: Scalars['ID'];
  /** The numeric and display representation of the KPI value. */
  value?: Maybe<AiCoach_KpiValue>;
};

/** This is used to define the mode of the AI coach. */
export const AiCoach_Mode = {
  /** This mode is used on pre- and post-assignment pages to help learners prepare assignments and review the results afterwards */
  Assignment: 'ASSIGNMENT',
  /** Basic mode where Coach only has some common context and is not aware of any additional page-specific stuff */
  Basic: 'BASIC',
  /** This mode is used in coach items. see https://coursera.atlassian.net/wiki/spaces/CP/pages/3655335963/Coach+Item+MVP for more details. eg) socratic dicussion */
  CoachItem: 'COACH_ITEM',
  /** This operates identically to the COACH_ITEM type, except that this lets authors access the draft version of the item rather than the live version */
  CoachItemAuthoringDraft: 'COACH_ITEM_AUTHORING_DRAFT',
  /** This operates identically to the COACH_ITEM_AUTHORING_DRAFT type, except that this lets authors access the published version of the item */
  CoachItemAuthoringPublished: 'COACH_ITEM_AUTHORING_PUBLISHED',
  /** This mode is used on course home page */
  CourseGuide: 'COURSE_GUIDE',
  /** This mode is used on lecture and reading pages */
  ItemLearning: 'ITEM_LEARNING',
  /** Experimental "injectable" "Proactive AI" item type */
  PracticeMoment: 'PRACTICE_MOMENT',
  /** This mode is used on pre- and post-quiz pages to help learners prepare quizzes and review the results afterwards */
  Quiz: 'QUIZ'
} as const;

export type AiCoach_Mode = typeof AiCoach_Mode[keyof typeof AiCoach_Mode];
/** Navigation buttons related to the message */
export type AiCoach_NavigationButton = {
  /** Navigation leading message, which will appear before the navigation button */
  navigationLeadingMessage: AiCoach_NavigationLeadingMessage;
};

/** Platform Feature: Navigation buttons related to the message */
export type AiCoach_NavigationButtonV2 = {
  /** The label on the inner clickable button. Optional in case a new design removes the button. */
  buttonLabel?: Maybe<Scalars['String']>;
  /** Navigation leading message, which will appear before the navigation button */
  navigationLeadingMessage: Scalars['String'];
};

/** This is used to define the type of the navigation leading message. */
export const AiCoach_NavigationLeadingMessage = {
  /** Leading message for the navigation button appending the response of Help me get started action */
  HelpGetStartedWithCourseNavigation: 'HELP_GET_STARTED_WITH_COURSE_NAVIGATION',
  /** Leading message for the navigation button appending the response of Why should I take this course action */
  WhyTakeCourseNavigation: 'WHY_TAKE_COURSE_NAVIGATION'
} as const;

export type AiCoach_NavigationLeadingMessage = typeof AiCoach_NavigationLeadingMessage[keyof typeof AiCoach_NavigationLeadingMessage];
/** Item types supported for new course optimizations */
export const AiCoach_OptimizationItemType = {
  /** Dialogue */
  Dialogue: 'DIALOGUE',
  /** Tool based practice */
  ToolBasedPractice: 'TOOL_BASED_PRACTICE'
} as const;

export type AiCoach_OptimizationItemType = typeof AiCoach_OptimizationItemType[keyof typeof AiCoach_OptimizationItemType];
/**
 * A data table returned from the Analytics Control Plane.
 * Rows and footer are free-form JSON objects to accommodate varying table shapes.
 */
export type AiCoach_PresentationTable = {
  __typename?: 'AiCoach_PresentationTable';
  /** Ordered list of column definitions for this table. */
  columns?: Maybe<Array<AiCoach_TableColumn>>;
  /** Optional footer row as a free-form JSON object (e.g. totals or summary row). */
  footer?: Maybe<Scalars['JSON']>;
  /** Unique identifier of the table. */
  id: Scalars['ID'];
  /** Pagination metadata for this table result. */
  pagination?: Maybe<AiCoach_TablePagination>;
  /** Row data as free-form JSON objects, one per row. Shape is determined by the column definitions. */
  rows?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  /** Default sort configuration applied to this table. */
  sort?: Maybe<AiCoach_TableSort>;
  /** Optional human-readable subtitle for the table. */
  subtitle?: Maybe<Scalars['String']>;
  /** Optional human-readable title for the table. */
  title?: Maybe<Scalars['String']>;
};

/** Product for the AI coach to understand the additional context of the message in coursera. */
export type AiCoach_Product = {
  __typename?: 'AiCoach_Product';
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: AiCoach_CourseraProductType;
};

/** A product card recommended by the AI coach. */
export type AiCoach_ProductCard = {
  __typename?: 'AiCoach_ProductCard';
  /** Average star rating of the product on a scale of 1 to 5. */
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  /** Estimated months to complete this product (specializations and professional certificates only). */
  avgLearningMonths?: Maybe<Scalars['Int']>;
  /** Short description of the product. */
  description?: Maybe<Scalars['String']>;
  /** Difficulty level of the product. */
  difficultyLevel?: Maybe<AiCoach_DifficultyLevel>;
  /** Unique identifier of the product. */
  id: Scalars['ID'];
  /** URL to the product's thumbnail or cover image. */
  imageUrl?: Maybe<Scalars['URL']>;
  /** Display name of the product. */
  name: Scalars['String'];
  /** List of URLs to partner logo images. */
  partnerLogos?: Maybe<Array<Scalars['String']>>;
  /** List of partner or institution names offering this product. */
  partners?: Maybe<Array<Scalars['String']>>;
  /** The type of product (e.g. course, specialization, professional certificate). */
  productType?: Maybe<Scalars['String']>;
  /** List of skills learners will gain from this product. */
  skills?: Maybe<Array<Scalars['String']>>;
  /** Estimated total hours of content in the product. */
  totalContentHours?: Maybe<Scalars['Int']>;
  /** URL to the product page on Coursera. */
  url: Scalars['URL'];
};

/** Product input for the AI coach to understand the additional context of the message in coursera. */
export type AiCoach_ProductInput = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: AiCoach_CourseraProductType;
};

/** Metadata of the quiz item */
export type AiCoach_QuizItemMetadata = AiCoach_ItemMetadata & {
  __typename?: 'AiCoach_QuizItemMetadata';
  /** The course the item is in */
  course: Course_Course;
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
  /** Title of the quiz */
  itemTitle: Scalars['String'];
  /** Number of questions in the quiz */
  numQuestions: Scalars['Int'];
};

/** Metadata of the reading item */
export type AiCoach_ReadingItemMetadata = AiCoach_ItemMetadata & {
  __typename?: 'AiCoach_ReadingItemMetadata';
  /** The course the item is in */
  course: Course_Course;
  /** Duration of the reading */
  duration?: Maybe<Scalars['Duration']>;
  /** Id of the item */
  itemId: Scalars['ID'];
  /** Slug of the item */
  itemSlug: Scalars['String'];
  /** Title of the reading */
  itemTitle: Scalars['String'];
};

/** Recommended Actions related to the message */
export type AiCoach_RecommendedAction = {
  __typename?: 'AiCoach_RecommendedAction';
  /** This signifies a direct action or a message typed out by the learner in the FE. */
  action: AiCoach_Action;
  /** Recommended action message */
  actionMessage: Scalars['String'];
};

/** Redirect Link metadata */
export type AiCoach_RedirectLinkMetadata = {
  __typename?: 'AiCoach_RedirectLinkMetadata';
  /** Title of the redirection */
  redirectTitle: Scalars['String'];
  /** Url for the redirection */
  redirectUrl: Scalars['URL'];
};

/** Platform feature: Navigation button for going to an course item */
export type AiCoach_RedirectLinkNavigationButton = AiCoach_NavigationButtonV2 & {
  __typename?: 'AiCoach_RedirectLinkNavigationButton';
  /** The label on the inner clickable button. Optional in case a new design removes the button. */
  buttonLabel?: Maybe<Scalars['String']>;
  /** Navigation leading message, which will appear before the navigation button */
  navigationLeadingMessage: Scalars['String'];
  /** Metadata of the link to redirect to */
  redirectLinkMetadata: AiCoach_RedirectLinkMetadata;
};

/** Use for PLATFORM: Input for creating and returning the message from the user and the subsequent response returned by the AI coach async. */
export type AiCoach_RespondToUserMessageAsyncInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
};

/** Result for async user message processing that returns a task ID for status tracking. */
export type AiCoach_RespondToUserMessageAsyncResult = {
  __typename?: 'AiCoach_RespondToUserMessageAsyncResult';
  /** The unique identifier for the async task that can be used to query its status. */
  taskId: Scalars['ID'];
};

/** Use for PLATFORM: Input for creating and returning the message from the user and the subsequent response returned by the AI coach. */
export type AiCoach_RespondToUserMessageInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * File attachments to send with this message. Defaults to an empty list so existing
   * callers are unaffected. At most one attachment is supported for MVP.
   */
  attachments?: Array<AiCoach_AttachmentInput>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** A field that can be only used by Courserians to preview config changes on the flight. */
  configOverride?: InputMaybe<AiCoach_CoachConfigInput>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
  /**
   * How the message should be processed by Coach.
   * @deprecated Please use the new async endpoint AiCoach_RespondToUserMessageAsync as task based processing will be deprecated.
   */
  responseProcessingType?: AiCoach_ResponseProcessingType;
};

/** Use for PLATFORM: The result with the message created by the user and the subsequent response returned by the AI coach. */
export type AiCoach_RespondToUserMessageResult = {
  __typename?: 'AiCoach_RespondToUserMessageResult';
  /**
   * The ID of the current chat session
   * @deprecated Instead, access via session.id
   */
  chatSessionId: Scalars['ID'];
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** A list of embedded content items (e.g. analytics dashboards) surfaced by the AI coach. */
  embeddedContents?: Maybe<Array<AiCoach_AnalyticsEmbeddedContent | AiCoach_AnalyticsFilterContent | AiCoach_McpToolCallEmbeddedContent>>;
  /** Message response from the AI coach */
  messageByAiCoach: AiCoach_MessageByAiCoach;
  /** Message created by the user */
  messageByUser: AiCoach_MessageByUser;
  /** A list of navigation buttons. */
  navigationButtons?: Maybe<Array<AiCoach_ItemNavigationButton | AiCoach_RedirectLinkNavigationButton>>;
  /** A list of product cards recommended by the AI coach. */
  productCards?: Maybe<Array<AiCoach_ProductCard>>;
  /** A list of generated recommended actions. It will be empty if no actions are generated */
  recommendedActions: Array<AiCoach_CoachActionConfig>;
  /** A list of generated recommended edits. */
  recommendedEdits?: Maybe<Array<AiCoach_CoachEdit>>;
  /** The session to which this message belongs */
  session: AiCoach_ChatSession;
};

/** Use for PLATFORM: How Coach should process the message */
export const AiCoach_ResponseProcessingType = {
  /** Default: Process the message synchronously and return the response */
  SynchronousResponse: 'SYNCHRONOUS_RESPONSE',
  /** Process the message with a task-based workflow based on the Coach action's task configuration */
  TaskBasedProcessing: 'TASK_BASED_PROCESSING'
} as const;

export type AiCoach_ResponseProcessingType = typeof AiCoach_ResponseProcessingType[keyof typeof AiCoach_ResponseProcessingType];
/** Input for saving coach settings for the user */
export type AiCoach_SaveCoachUserSettingsInput = {
  /**
   * The coach settings memory preference input, which includes the enable/disable settings for collection and retrieval
   * of memory in user interactions
   */
  memoryPreferenceInput?: InputMaybe<AiCoach_CoachSettingsMemoryPreferenceInput>;
  /** The coach settings profile preference input, which includes the enable/disable settings for user profile fields */
  profilePreferenceInput?: InputMaybe<AiCoach_CoachSettingsProfilePreferenceInput>;
};

/** Result for saving coach settings for the user */
export type AiCoach_SaveCoachUserSettingsResult = {
  __typename?: 'AiCoach_SaveCoachUserSettingsResult';
  /** Saved coach settings for the user */
  coachSettings: AiCoach_CoachUserSettings;
};

/** This helps depict if the message is by the user or the AI coach. */
export const AiCoach_SenderType = {
  /** Message is by the AI coach */
  System: 'SYSTEM',
  /** Message is by the user */
  User: 'USER'
} as const;

export type AiCoach_SenderType = typeof AiCoach_SenderType[keyof typeof AiCoach_SenderType];
/** The result of speech-to-text */
export type AiCoach_SpeechToTextResult = {
  __typename?: 'AiCoach_SpeechToTextResult';
  /** text converted from speech */
  text: Scalars['String'];
};

/**
 * Metadata for a column in an analytics table.
 * Maps directly to the TableColumn message from the Analytics Control Plane proto.
 */
export type AiCoach_TableColumn = {
  __typename?: 'AiCoach_TableColumn';
  /** Text alignment for the column (e.g. "left", "right", "center"). */
  alignment?: Maybe<Scalars['String']>;
  /** Optional conditional formatting rules as a free-form JSON object. */
  conditionalFormat?: Maybe<Scalars['JSON']>;
  /** Data type of the column values (e.g. "string", "number", "date"). */
  dataType?: Maybe<Scalars['String']>;
  /** Human-readable name shown as the column header. */
  displayName?: Maybe<Scalars['String']>;
  /** Key used to identify the column and look up its value in a row object. */
  key?: Maybe<Scalars['String']>;
  /** Whether this column can be used to sort the table. */
  sortable?: Maybe<Scalars['Boolean']>;
  /** Logical type of the column (e.g. "metric", "dimension"). */
  type?: Maybe<Scalars['String']>;
};

/**
 * Pagination metadata for a table result.
 * Maps directly to the TablePagination message from the Analytics Control Plane proto.
 */
export type AiCoach_TablePagination = {
  __typename?: 'AiCoach_TablePagination';
  /** Number of rows included in the current page. */
  rowCount?: Maybe<Scalars['Int']>;
  /** Total number of rows matching the query across all pages. */
  totalMatching?: Maybe<Scalars['Int']>;
  /** Whether the result set was truncated due to exceeding the maximum allowed rows. */
  truncated?: Maybe<Scalars['Boolean']>;
};

/**
 * Default sort configuration for a table.
 * Maps directly to the TableSort message from the Analytics Control Plane proto.
 */
export type AiCoach_TableSort = {
  __typename?: 'AiCoach_TableSort';
  /** Key of the column to sort by. */
  column?: Maybe<Scalars['String']>;
  /** Sort direction: "asc" for ascending or "desc" for descending. */
  direction?: Maybe<Scalars['String']>;
};

/** Optional external reference to tie task-based processing results to the original message */
export type AiCoach_TaskProcessingExternalReference = {
  __typename?: 'AiCoach_TaskProcessingExternalReference';
  /** External ID for task processing */
  taskProcessingExternalId: Scalars['ID'];
};

/** Failure result of task processing */
export type AiCoach_TaskProcessingFailure = {
  __typename?: 'AiCoach_TaskProcessingFailure';
  /** When the task processing failed. */
  taskProcessingFailedAt: Scalars['DateTime'];
  /** Reason for task processing failure */
  taskProcessingFailedReason: Scalars['String'];
};

/** Result of task-based message processing */
export type AiCoach_TaskProcessingResult = AiCoach_TaskProcessingFailure | AiCoach_TaskProcessingSuccess;

/** Success result of task processing */
export type AiCoach_TaskProcessingSuccess = {
  __typename?: 'AiCoach_TaskProcessingSuccess';
  /** When the task-based processing completed. */
  taskProcessingCompletedAt: Scalars['DateTime'];
};

/** Use for PLATFORM: Task processing status. These values can be populated by the provider, but are not required. */
export type AiCoach_TaskStatus = {
  __typename?: 'AiCoach_TaskStatus';
  /** Optional external reference to tie external task processing results to the original message */
  taskProcessingExternalReference?: Maybe<AiCoach_TaskProcessingExternalReference>;
  /** Results of the task processing */
  taskProcessingResult?: Maybe<AiCoach_TaskProcessingResult>;
  /** When the task provider started processing the message. */
  taskProviderProcessingStartedAt?: Maybe<Scalars['DateTime']>;
  /** When Coach received the request to process the message with a task-based workflow. */
  taskRequestedAt?: Maybe<Scalars['DateTime']>;
};

/** Platform text streaming: Input for creating and returning the message from the user and the subsequent STREAMED response returned by the AI coach. */
export type AiCoach_TextStreamingChatInput = {
  /** Additional context to append to the prompt if it's not available in existing context fetcher. */
  additionalContext?: InputMaybe<Array<AiCoach_AdditionalContextInput>>;
  /**
   * File attachments to send with this message. Defaults to an empty list so existing
   * callers are unaffected. At most one attachment is supported for MVP.
   */
  attachments?: Array<AiCoach_AttachmentInput>;
  /**
   * The ID of the current chat session. If the field is empty, that means that the user is starting a new chat. In that
   * case BE will generate a new chatSessionId and return it to the FE.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** This signifies the configuration input of the chat message including action and mode. */
  config: AiCoach_ConfigurationInput;
  /** A field that can be only used by Courserians to preview config changes on the flight. */
  configOverride?: InputMaybe<AiCoach_CoachConfigInput>;
  /**
   * The cookie ID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  cookieId?: InputMaybe<Scalars['ID']>;
  /** Coursera info used to help the AI coach understand the context of the message */
  courseraContext?: InputMaybe<AiCoach_CourseraContextInput>;
  /**
   * The UUID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Message input by the user to the AI coach */
  message: Scalars['String'];
};

/** Platform text streaming: The result with the message created by the user and the subsequent STREAMED response returned by the AI coach. */
export type AiCoach_TextStreamingChatResult = {
  __typename?: 'AiCoach_TextStreamingChatResult';
  /** The ID of the current chat session */
  chatSessionId: Scalars['ID'];
  /** A list of embedded content items (e.g. analytics dashboards) surfaced by the AI coach. */
  embeddedContents?: Maybe<Array<AiCoach_AnalyticsEmbeddedContent | AiCoach_AnalyticsFilterContent | AiCoach_McpToolCallEmbeddedContent>>;
  /** Indication of whether the current streamed chunk is the last chunk of the response. */
  isLastChunk: Scalars['Boolean'];
  /** Streamed message response from the AI coach */
  messageByAiCoach: AiCoach_MessageByAiCoach;
  /** Message created by the user */
  messageByUser: AiCoach_MessageByUser;
  /** A list of navigation buttons. */
  navigationButtons?: Maybe<Array<AiCoach_ItemNavigationButton | AiCoach_RedirectLinkNavigationButton>>;
  /** A list of product cards recommended by the AI coach. */
  productCards?: Maybe<Array<AiCoach_ProductCard>>;
  /** A list of generated recommended actions. It will be empty if no actions are generated */
  recommendedActions: Array<AiCoach_CoachActionConfig>;
  /** A list of generated recommended edits. */
  recommendedEdits?: Maybe<Array<AiCoach_CoachEdit>>;
};

/** The result of text-to-speech */
export type AiCoach_TextToSpeechResult = {
  __typename?: 'AiCoach_TextToSpeechResult';
  /** base64 encoded audio file of speech */
  audioBase64: Scalars['String'];
};

/** Input for updating a  chat session */
export type AiCoach_UpdateChatSessionInput = {
  /** Chat Session ID */
  id: Scalars['ID'];
  /** Chat Session Title */
  title: Scalars['String'];
};

/** Response type to update chat session */
export type AiCoach_UpdateChatSessionResult = {
  __typename?: 'AiCoach_UpdateChatSessionResult';
  /** Chat Session Created At */
  createdAt: Scalars['DateTime'];
  /** Chat Session ID */
  id: Scalars['ID'];
  /** Chat Session Title */
  title: Scalars['String'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Input to update the status of a dynamic prompt to completed status for a learner */
export type AiCoach_UpdateDynamicPromptStatusAsCompleteInput = {
  /** The ID of the dynamic prompt that needs to get updated with the completed status */
  id: Scalars['ID'];
};

/** Result for AiCoach_UpdateDynamicPromptStatusAsCompleteResult mutation */
export type AiCoach_UpdateDynamicPromptStatusAsCompleteResult = {
  __typename?: 'AiCoach_UpdateDynamicPromptStatusAsCompleteResult';
  /** Dummy variable */
  ok?: Maybe<Scalars['Boolean']>;
};

/** Inputs for updating the feedback of the user on a AI coach response. */
export type AiCoach_UpdateWithUserFeedbackInput = {
  /**
   * The cookie ID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  cookieId?: InputMaybe<Scalars['ID']>;
  /**
   * The UUID of the logged out user.
   * When the field is empty, the user is in the logged-in state and validation occurs using the CAUTH cookie as a priority.
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Message ID */
  messageId: Scalars['ID'];
  /** Feedback via comments from the user on the response received by the AI coach */
  userComments?: InputMaybe<Scalars['String']>;
  /** Feedback via a like/dislike from the user on the response received by the AI coach */
  userFeedback: AiCoach_UserFeedback;
};

/** Result for the user feedback on the response received by the AI coach. */
export type AiCoach_UpdateWithUserFeedbackResult = {
  __typename?: 'AiCoach_UpdateWithUserFeedbackResult';
  /** Message ID */
  messageId: Scalars['ID'];
};

/** User feedback via a like/dislike on the response received by the AI coach. */
export const AiCoach_UserFeedback = {
  /** AI coach response is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI coach response is liked by the user */
  Like: 'LIKE',
  /** User feedback i.e the like or dislike status is unset by the user */
  Unset: 'UNSET'
} as const;

export type AiCoach_UserFeedback = typeof AiCoach_UserFeedback[keyof typeof AiCoach_UserFeedback];
/**
 * Specification for a visualization chart.
 * The 'spec' field is a free-form JSON object whose shape is defined by the chart 'type'.
 */
export type AiCoach_VisualizationSpec = {
  __typename?: 'AiCoach_VisualizationSpec';
  /** Chart type identifier (e.g. "bar", "line", "pie"). */
  chartType?: Maybe<Scalars['String']>;
  /** Unique identifier of the visualization. */
  id: Scalars['ID'];
  /** Free-form JSON object describing the chart specification. Shape is defined by the chartType. */
  spec?: Maybe<Scalars['JSON']>;
};

/**
 * Input for creating / updating the index of the given asset.
 * The course item context indicates the item to which this asset was attached.
 */
export type AiEmbeddings_IndexDocumentAssetInput = {
  /** Asset ID to be indexed */
  assetId: Scalars['ID'];
  /** Course Branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Module ID */
  moduleId: Scalars['ID'];
};

/** The result with the status of the request. */
export type AiEmbeddings_IndexDocumentAssetResult = {
  __typename?: 'AiEmbeddings_IndexDocumentAssetResult';
  /** The error code of the operation. If operation is successful the value would be NONE */
  errorCode?: Maybe<AiEmbeddings_IndexDocumentErrorCode>;
  /**
   * Message with additional details
   * @deprecated use error code to determine error message to display
   */
  message?: Maybe<Scalars['String']>;
  /** The status of the operation */
  status: AiEmbeddings_IndexDocumentAssetStatus;
};

/** This is used to define the status of the request. */
export const AiEmbeddings_IndexDocumentAssetStatus = {
  /** Processing denied, due to some validation error */
  Denied: 'DENIED',
  /** Processing failed */
  Failure: 'FAILURE',
  /** Request successfully processed */
  Success: 'SUCCESS'
} as const;

export type AiEmbeddings_IndexDocumentAssetStatus = typeof AiEmbeddings_IndexDocumentAssetStatus[keyof typeof AiEmbeddings_IndexDocumentAssetStatus];
/** This is used to define the error code of the request. */
export const AiEmbeddings_IndexDocumentErrorCode = {
  /** No error */
  None: 'NONE',
  /** Indicates asset cannot be found */
  NotFoundError: 'NOT_FOUND_ERROR',
  /** Indicates general processing error */
  ProcessingError: 'PROCESSING_ERROR',
  /** Indicates asset file size exceeds maximum */
  SizeLimitExceededError: 'SIZE_LIMIT_EXCEEDED_ERROR',
  /** Indicates asset is of unsupported file type */
  UnsupportedFileTypeError: 'UNSUPPORTED_FILE_TYPE_ERROR'
} as const;

export type AiEmbeddings_IndexDocumentErrorCode = typeof AiEmbeddings_IndexDocumentErrorCode[keyof typeof AiEmbeddings_IndexDocumentErrorCode];
/** AiGradedChallenge Queries */
export type AiGradedChallengeQueries = {
  __typename?: 'AiGradedChallengeQueries';
  /** Attempt summary related to the item with challenge */
  queryAttemptSummary: AiGradedChallenge_AttemptSummary;
  /**
   * Attempt summary related to the item.
   * Will always query proctor configuration for the latest atom version
   */
  queryAttemptSummaryForItem: AiGradedChallenge_AttemptSummary;
  /** Return submissions for the provided assessment and learner in descending created order. */
  queryChallengeSubmissionsForAssessmentAndLearner: Array<AiGradedChallenge_ChallengeSubmission>;
  /**
   * Return challenges for the provided assessment ordered by creation timestamp descending.
   * Optionally filter by enablement status and challenge status.
   */
  queryChallenges: Array<AiGradedChallenge_Challenge>;
  /** Return caller's submissions for the provided challenge ordered by creation timestamp descending. */
  queryMyChallengeSubmissions: Array<AiGradedChallenge_ChallengeSubmission>;
  /**
   * Return caller's submissions for the challenge associated with a given
   * course item, ordered by creation timestamp descending.
   */
  queryMyChallengeSubmissionsForItem: AiGradedChallenge_ChallengeSubmissionPaginatedResult;
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryAttemptSummaryArgs = {
  atomId: Scalars['ID'];
  atomVersion?: InputMaybe<Scalars['Int']>;
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryAttemptSummaryForItemArgs = {
  branchId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryChallengeSubmissionsForAssessmentAndLearnerArgs = {
  assessmentId: Scalars['ID'];
  courseId: Scalars['ID'];
  learnerId: Scalars['ID'];
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryChallengesArgs = {
  assessmentId: Scalars['ID'];
  assessmentType: AiGradedChallenge_AssessmentType;
  assessmentVersion?: InputMaybe<Scalars['Int']>;
  challengeStatusFilter?: InputMaybe<AiGradedChallenge_ChallengeStatus>;
  enablementStatusFilter?: InputMaybe<Array<AiGradedChallenge_EnablementStatus>>;
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryMyChallengeSubmissionsArgs = {
  assessmentId?: InputMaybe<Scalars['ID']>;
  challengeId: Scalars['ID'];
};


/** AiGradedChallenge Queries */
export type AiGradedChallengeQueriesQueryMyChallengeSubmissionsForItemArgs = {
  branchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
};

/** The type of assessment for which a challenge is created. */
export const AiGradedChallenge_AssessmentType = {
  /** Lab assignment. */
  Lab: 'LAB',
  /** Roleplay assessment. */
  Roleplay: 'ROLEPLAY'
} as const;

export type AiGradedChallenge_AssessmentType = typeof AiGradedChallenge_AssessmentType[keyof typeof AiGradedChallenge_AssessmentType];
/** Summary of limitations on number of attempts */
export type AiGradedChallenge_AttemptLimitSummary = AiGradedChallenge_NoLimitSummary | AiGradedChallenge_RateLimitSummary;

/** AttemptStatus */
export const AiGradedChallenge_AttemptStatus = {
  /**
   * The attempt is completed or closed because either they ran out of submissions or time, and
   * at this time learner cannot make submissions.
   */
  Completed: 'COMPLETED',
  /** The attempt is in progress and learner is allowed to make submissions */
  InProgress: 'IN_PROGRESS',
  /** Learner has not started the attempt */
  NotStarted: 'NOT_STARTED'
} as const;

export type AiGradedChallenge_AttemptStatus = typeof AiGradedChallenge_AttemptStatus[keyof typeof AiGradedChallenge_AttemptStatus];
/** Attempt summary for item with challenge */
export type AiGradedChallenge_AttemptSummary = {
  __typename?: 'AiGradedChallenge_AttemptSummary';
  /** Summary of limitations on number of attempts */
  attemptLimitSummary: AiGradedChallenge_AttemptLimitSummary;
  /** Current ongoing attempt (if there is one) */
  ongoingAttempt?: Maybe<AiGradedChallenge_OngoingAttempt>;
  /** Optional time limit summary */
  timeLimitSummary?: Maybe<AiGradedChallenge_TimeLimitSummary>;
};

/** Represents a challenge that can be added to an item type. */
export type AiGradedChallenge_Challenge = {
  __typename?: 'AiGradedChallenge_Challenge';
  /** Draft or published status of the challenge. */
  challengeStatus: AiGradedChallenge_ChallengeStatus;
  /** Enablement status of the challenge. */
  enablementStatus: AiGradedChallenge_EnablementStatus;
  /** Grader-facing instructions for the challenge. */
  graderInstructions?: Maybe<Cml_Cml>;
  /** ID of the challenge. */
  id: Scalars['ID'];
  /** Instructions how to complete the challenge. */
  instructions: AiGradedChallenge_Instructions;
  /** Rubrics for the challenge. */
  rubrics: Array<AiGradedChallenge_Rubric>;
};

/** The draft/published status of a challenge. */
export const AiGradedChallenge_ChallengeStatus = {
  /** Challenge is a draft being edited by the author. */
  Draft: 'DRAFT',
  /** Challenge has been published and is visible to learners. */
  Published: 'PUBLISHED'
} as const;

export type AiGradedChallenge_ChallengeStatus = typeof AiGradedChallenge_ChallengeStatus[keyof typeof AiGradedChallenge_ChallengeStatus];
/** Represents a submission of a challenge by a user. */
export type AiGradedChallenge_ChallengeSubmission = {
  __typename?: 'AiGradedChallenge_ChallengeSubmission';
  /**
   * ID of the AI suggestion for this submission.
   * Null for legacy submissions that predate AI suggestion generation.
   */
  aiSuggestionId?: Maybe<Scalars['ID']>;
  /** ID of the challenge. */
  challengeId?: Maybe<Scalars['ID']>;
  /** The timestamp when the challenge submission was created. */
  createdAt: Scalars['DateTime'];
  /** The grades for the challenge submission based on the rubrics. Null if the challenge submission is not graded yet. */
  grades?: Maybe<Array<AiGradedChallenge_RubricGrade>>;
  /** ID of the challenge submission. */
  id: Scalars['ID'];
  /** The status of the skill verification process for this submission. */
  skillVerificationStatus: AiGradedChallenge_SkillVerificationStatus;
  /** The status of the challenge submission. */
  status: AiGradedChallenge_ChallengeSubmissionStatus;
  /** The content of the challenge submission. */
  submissionContent: AiGradedChallenge_SubmissionContent;
  /** The user's feedback for the grading result. */
  userFeedback?: Maybe<AiGradedChallenge_UserFeedback>;
};

/** Paginated list of challenge submissions. */
export type AiGradedChallenge_ChallengeSubmissionPaginatedResult = {
  __typename?: 'AiGradedChallenge_ChallengeSubmissionPaginatedResult';
  /** Challenge submission list. */
  elements: Array<AiGradedChallenge_ChallengeSubmission>;
  /** Pagination. */
  pagination: Pagination;
};

/** The status of the challenge submission. */
export const AiGradedChallenge_ChallengeSubmissionStatus = {
  /** The challenge submission grading failed. */
  GradingFailed: 'GRADING_FAILED',
  /** The challenge submission grading has started. */
  GradingStarted: 'GRADING_STARTED',
  /** The challenge submission grading succeeded. */
  GradingSucceeded: 'GRADING_SUCCEEDED'
} as const;

export type AiGradedChallenge_ChallengeSubmissionStatus = typeof AiGradedChallenge_ChallengeSubmissionStatus[keyof typeof AiGradedChallenge_ChallengeSubmissionStatus];
/** The criteria for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricCriteria = {
  __typename?: 'AiGradedChallenge_ChecklistRubricCriteria';
  /** Options for the checklist rubric. */
  options: Array<AiGradedChallenge_ChecklistRubricOption>;
  /** Prompt for the checklist rubric. */
  prompt: Scalars['String'];
};

/** The criteria for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricCriteriaInput = {
  /** Options for the checklist rubric. */
  options: Array<AiGradedChallenge_ChecklistRubricOptionInput>;
  /** Prompt for the checklist rubric. */
  prompt: Scalars['String'];
};

/** The grading result for a checklist-based rubric. */
export type AiGradedChallenge_ChecklistRubricGrade = {
  __typename?: 'AiGradedChallenge_ChecklistRubricGrade';
  /** Optional explanation for the overall checklist grade. */
  explanation?: Maybe<Scalars['String']>;
  /** The selected options for this checklist rubric grade. */
  selectedOptions: Array<AiGradedChallenge_ChecklistRubricOptionGrade>;
  /**
   * The unselected options for this checklist rubric grade. Nullable for backward
   * compatibility with existing persisted data that has no unselected options.
   */
  unselectedOptions?: Maybe<Array<AiGradedChallenge_ChecklistRubricOptionGrade>>;
};

/** An option for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricOption = {
  __typename?: 'AiGradedChallenge_ChecklistRubricOption';
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: Maybe<Scalars['Float']>;
};

/** The grading detail for an individual checklist rubric option. */
export type AiGradedChallenge_ChecklistRubricOptionGrade = {
  __typename?: 'AiGradedChallenge_ChecklistRubricOptionGrade';
  /** Optional additional support information for this option. */
  additionalSupport?: Maybe<Scalars['String']>;
  /** Optional explanation for this option. */
  explanation?: Maybe<Scalars['String']>;
  /** The ID of the option. */
  optionId: Scalars['ID'];
};

/** An option for a checklist rubric. */
export type AiGradedChallenge_ChecklistRubricOptionInput = {
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: InputMaybe<Scalars['Float']>;
};

/** Input for AiGradedChallenge_CreateChallenge mutation */
export type AiGradedChallenge_CreateChallengeInput = {
  /** ID of the assessment for which a challenge is created. */
  assessmentId: Scalars['ID'];
  /** Type of assessment for which a challenge is created. */
  assessmentType: AiGradedChallenge_AssessmentType;
  /** Version of the assessment for which a challenge is created. */
  assessmentVersion: Scalars['Int'];
  /** Draft or published status of the challenge. */
  challengeStatus: AiGradedChallenge_ChallengeStatus;
  /**
   * ID of the course the challenge belongs to. Optional for backward
   * compatibility with existing callers; will be tightened to required once all
   * callers are updated.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Enablement status of the challenge. */
  enablementStatus: AiGradedChallenge_EnablementStatus;
  /** Grader-facing instructions for the challenge. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** Instructions for the challenge. */
  instructions: AiGradedChallenge_InstructionsInput;
  /** Rubrics for the challenge. */
  rubrics: Array<AiGradedChallenge_RubricInput>;
};

/** The result of the create challenge mutation. */
export type AiGradedChallenge_CreateChallengeResult = {
  __typename?: 'AiGradedChallenge_CreateChallengeResult';
  /** ID of the challenge that was created. */
  challengeId: Scalars['ID'];
};

/** Input for AiGradedChallenge_DeleteDraftChallengeById mutation */
export type AiGradedChallenge_DeleteDraftChallengeByIdInput = {
  /** The composite challenge ID of the draft challenge to delete. */
  challengeId: Scalars['ID'];
};

/** The result of the delete draft challenge by ID mutation. */
export type AiGradedChallenge_DeleteDraftChallengeByIdResult = {
  __typename?: 'AiGradedChallenge_DeleteDraftChallengeByIdResult';
  /** ID of the challenge that was deleted. */
  challengeId: Scalars['ID'];
};

/** Input for AiGradedChallenge_DeleteDraftChallenge mutation */
export type AiGradedChallenge_DeleteDraftChallengeInput = {
  /** ID of the assessment for the draft challenge to delete. */
  assessmentId: Scalars['ID'];
  /** Type of assessment for the draft challenge to delete. */
  assessmentType: AiGradedChallenge_AssessmentType;
  /** Version of the assessment for the draft challenge to delete. */
  assessmentVersion: Scalars['Int'];
};

/** The result of the delete draft challenge mutation. */
export type AiGradedChallenge_DeleteDraftChallengeResult = {
  __typename?: 'AiGradedChallenge_DeleteDraftChallengeResult';
  /** ID of the challenge that was deleted. */
  challengeId: Scalars['ID'];
};

/** The enablement status of a challenge. */
export const AiGradedChallenge_EnablementStatus = {
  /** Challenge is disabled. */
  Disabled: 'DISABLED',
  /** Challenge is enabled. */
  Enabled: 'ENABLED'
} as const;

export type AiGradedChallenge_EnablementStatus = typeof AiGradedChallenge_EnablementStatus[keyof typeof AiGradedChallenge_EnablementStatus];
/** Represents a single part of challenge instructions. */
export type AiGradedChallenge_InstructionPart = {
  __typename?: 'AiGradedChallenge_InstructionPart';
  /** The content of this instruction part. */
  content: Cml_Cml;
  /** The title of this instruction part. */
  title: Scalars['String'];
};

/** The instructions part. */
export type AiGradedChallenge_InstructionPartInput = {
  /** The CML content of the part. */
  content: Cml_CmlInput;
  /** The title of the part. */
  title: Scalars['String'];
};

/** Represents the instructions for a challenge. */
export type AiGradedChallenge_Instructions = {
  __typename?: 'AiGradedChallenge_Instructions';
  /** List of instruction parts/steps that make up the complete challenge instructions. */
  parts: Array<AiGradedChallenge_InstructionPart>;
};

/** The instructions for a challenge. */
export type AiGradedChallenge_InstructionsInput = {
  /** The instructions parts. */
  parts: Array<AiGradedChallenge_InstructionPartInput>;
};

/** A lab capture submission content. */
export type AiGradedChallenge_LabCapture = {
  __typename?: 'AiGradedChallenge_LabCapture';
  /** The attempt ID associated with the lab capture. */
  attemptId: Scalars['ID'];
  /** Recording Id of the capture */
  recordingId?: Maybe<Scalars['ID']>;
};

/** Lab capture content input. */
export type AiGradedChallenge_LabCaptureContentInput = {
  /** Attempt ID */
  attemptId: Scalars['ID'];
};

/** NoLimitSummary indicates that there are no limits for the learner, meaning they can attempt unlimited number of times. */
export type AiGradedChallenge_NoLimitSummary = {
  __typename?: 'AiGradedChallenge_NoLimitSummary';
  /** Placeholder to circumvent no empty object rule */
  _?: Maybe<Scalars['String']>;
};

/** Information about the current ongoing attempt */
export type AiGradedChallenge_OngoingAttempt = {
  __typename?: 'AiGradedChallenge_OngoingAttempt';
  /** Attempt id */
  id: Scalars['ID'];
  /** Attempt started at */
  startedTime: Scalars['DateTime'];
};

/** The criteria for an options rubric. */
export type AiGradedChallenge_OptionsRubricCriteria = {
  __typename?: 'AiGradedChallenge_OptionsRubricCriteria';
  /** Options for the options rubric. */
  options: Array<AiGradedChallenge_OptionsRubricOption>;
  /** Prompt for the options rubric. */
  prompt: Scalars['String'];
};

/** The criteria for a options rubric. */
export type AiGradedChallenge_OptionsRubricCriteriaInput = {
  /** Options for the options rubric. */
  options: Array<AiGradedChallenge_OptionsRubricOptionInput>;
  /** Prompt for the options rubric. */
  prompt: Scalars['String'];
};

/** The grading result for an options-based rubric. */
export type AiGradedChallenge_OptionsRubricGrade = {
  __typename?: 'AiGradedChallenge_OptionsRubricGrade';
  /** Optional explanation for why this option was selected. */
  explanation?: Maybe<Scalars['String']>;
  /** The ID of the selected option. */
  optionId: Scalars['ID'];
};

/** The option for an options rubric. */
export type AiGradedChallenge_OptionsRubricOption = {
  __typename?: 'AiGradedChallenge_OptionsRubricOption';
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: Maybe<Scalars['Float']>;
};

/** The option for a options rubric. */
export type AiGradedChallenge_OptionsRubricOptionInput = {
  /** The option description. */
  description: Scalars['String'];
  /** The option ID. */
  optionId: Scalars['ID'];
  /** The option points. */
  points?: InputMaybe<Scalars['Float']>;
};

/** Input for AiGradedChallenge_PublishChallenge mutation */
export type AiGradedChallenge_PublishChallengeInput = {
  /** ID of the assessment for the draft challenge to publish. */
  assessmentId: Scalars['ID'];
  /** Type of assessment for the draft challenge to publish. */
  assessmentType: AiGradedChallenge_AssessmentType;
  /**
   * Version of the draft assessment to publish. The resulting PUBLISHED
   * challenge is created at the next assessment version.
   */
  assessmentVersion: Scalars['Int'];
};

/** The result of the publish challenge mutation. */
export type AiGradedChallenge_PublishChallengeResult = {
  __typename?: 'AiGradedChallenge_PublishChallengeResult';
  /** ID of the newly created PUBLISHED challenge. */
  challengeId: Scalars['ID'];
};

/** RateLimitSummary indicates that there are rate limits. Learners are limited to a certain number of attempts in a given period. */
export type AiGradedChallenge_RateLimitSummary = {
  __typename?: 'AiGradedChallenge_RateLimitSummary';
  /**
   * Next possible attempt time if learner has used up some attempts in this period.
   * This is when the remaining attempts will increase again to maxPerInterval
   */
  attemptsRemainingIncreasesAt?: Maybe<Scalars['DateTime']>;
  /** Number of attempts the learner can make in a given period. */
  maxPerInterval: Scalars['Int'];
  /** The remaining attempts that are available at this moment. If this is zero, learner cannot start a new attempt. */
  remainingAttempts: Scalars['Int'];
  /** Interval duration in which the learner can make limited attempts. */
  timeIntervalDuration: Scalars['Duration'];
};

/** The recording submission for the challenge. */
export type AiGradedChallenge_RecordingContentInput = {
  /** ID of the recording */
  recordingId: Scalars['ID'];
};

/** The rubric for a challenge. */
export type AiGradedChallenge_Rubric = {
  __typename?: 'AiGradedChallenge_Rubric';
  /** Criteria for the rubric. */
  criteria: AiGradedChallenge_RubricCriteria;
  /** Grader-facing instructions for this rubric. */
  graderInstructions?: Maybe<Cml_Cml>;
  /** ID of the rubric. */
  rubricId: Scalars['ID'];
  /** IDs of the skill expressions associated with this rubric. */
  skillExpressionIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * Sources indicating who created/contributed to this rubric.
   * e.g. [AI] = AI-generated, [AI, HUMAN] = AI-generated then human-edited, [HUMAN] = human-created.
   */
  sources?: Maybe<Array<AiGradedChallenge_RubricSource>>;
};

/** The criteria for a rubric. */
export type AiGradedChallenge_RubricCriteria = AiGradedChallenge_ChecklistRubricCriteria | AiGradedChallenge_OptionsRubricCriteria | AiGradedChallenge_TextRubricCriteria;

/** The criteria for a rubric. */
export type AiGradedChallenge_RubricCriteriaInput = {
  /** Rubric criteria for a checklist rubric. */
  checklistRubricCriteria?: InputMaybe<AiGradedChallenge_ChecklistRubricCriteriaInput>;
  /** Rubric criteria for an options rubric. */
  optionsRubricCriteria?: InputMaybe<AiGradedChallenge_OptionsRubricCriteriaInput>;
  /** Rubric criteria for a text rubric. */
  textRubricCriteria?: InputMaybe<AiGradedChallenge_TextRubricCriteriaInput>;
};

/** The grading result for a specific rubric in an AI graded challenge. */
export type AiGradedChallenge_RubricGrade = {
  __typename?: 'AiGradedChallenge_RubricGrade';
  /** The grading details for this rubric. */
  details: AiGradedChallenge_RubricGradeDetails;
  /** The rubric id that this grade is for. */
  rubricId: Scalars['ID'];
};

/** The grading details that can be either option-based or text-based rubric grading. */
export type AiGradedChallenge_RubricGradeDetails = AiGradedChallenge_ChecklistRubricGrade | AiGradedChallenge_OptionsRubricGrade | AiGradedChallenge_TextRubricGrade;

/** The rubric for a challenge. */
export type AiGradedChallenge_RubricInput = {
  /** Criteria for the rubric. */
  criteria: AiGradedChallenge_RubricCriteriaInput;
  /** Grader-facing instructions for this rubric. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** ID of the rubric. */
  rubricId: Scalars['ID'];
  /** IDs of the skill expressions associated with this rubric. */
  skillExpressionIds: Array<Scalars['ID']>;
  /**
   * Sources indicating who created/contributed to this rubric.
   * Defaults to an empty list if not provided.
   */
  sources?: Array<AiGradedChallenge_RubricSource>;
};

/** The source of a rubric (who created or contributed to it). */
export const AiGradedChallenge_RubricSource = {
  /** Rubric was generated by AI. */
  Ai: 'AI',
  /** Rubric was created or edited by a human. */
  Human: 'HUMAN'
} as const;

export type AiGradedChallenge_RubricSource = typeof AiGradedChallenge_RubricSource[keyof typeof AiGradedChallenge_RubricSource];
/** Input for AiGradedChallenge_SaveUserFeedback mutation */
export type AiGradedChallenge_SaveUserFeedbackInput = {
  /** ID of the challenge submission that should be saved. */
  challengeSubmissionId: Scalars['ID'];
  /** Optional user feedback comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Type of user feedback for a challenge submission. */
  feedbackType: AiGradedChallenge_UserFeedbackType;
};

/** The result of the save user feedback mutation. */
export type AiGradedChallenge_SaveUserFeedbackResult = {
  __typename?: 'AiGradedChallenge_SaveUserFeedbackResult';
  /** Dummy field. */
  _: Scalars['Boolean'];
};

/** The status of the skill verification process for a challenge submission. */
export const AiGradedChallenge_SkillVerificationStatus = {
  /** Skill verification has completed. */
  Complete: 'COMPLETE',
  /** Skill verification is in progress. */
  InProgress: 'IN_PROGRESS',
  /** Skill verification is not required for this submission. */
  NotRequired: 'NOT_REQUIRED'
} as const;

export type AiGradedChallenge_SkillVerificationStatus = typeof AiGradedChallenge_SkillVerificationStatus[keyof typeof AiGradedChallenge_SkillVerificationStatus];
/**
 * The content of the challenge submission. The concrete type identifies what kind of
 * content this submission carries:
 * - `Cml_Cml` for CML text submissions
 * - `ExamRecording_Recording` for lab recordings
 * - `AiCoach_ChatSession` for graded role play chat sessions
 */
export type AiGradedChallenge_SubmissionContent = AiCoach_ChatSession | AiGradedChallenge_LabCapture | Cml_Cml | ExamRecording_Recording;

/** The content of the challenge submission. */
export type AiGradedChallenge_SubmissionContentInput = {
  /** CML submission. */
  cmlContent?: InputMaybe<Cml_CmlInput>;
  /** Lab capture. */
  labCaptureContent?: InputMaybe<AiGradedChallenge_LabCaptureContentInput>;
  /** Recording submission. */
  recordingContent?: InputMaybe<AiGradedChallenge_RecordingContentInput>;
};

/** Input for AiGradedChallenge_SubmitChallenge mutation */
export type AiGradedChallenge_SubmitChallengeInput = {
  /** ID of the branch in which this submission is made. */
  branchId: Scalars['ID'];
  /** ID of the challenge that the submission is for. */
  challengeId: Scalars['ID'];
  /** ID of the course in which the submission is made. */
  courseId: Scalars['ID'];
  /** ID of the item for which this challenge submission is associated with. */
  itemId: Scalars['ID'];
  /** Content of the challenge submission. */
  submissionContent: AiGradedChallenge_SubmissionContentInput;
};

/** The result of the submit challenge mutation. */
export type AiGradedChallenge_SubmitChallengeResult = {
  __typename?: 'AiGradedChallenge_SubmitChallengeResult';
  /** ID of the challenge submission. */
  challengeSubmissionId: Scalars['ID'];
};

/** The criteria for a text rubric. */
export type AiGradedChallenge_TextRubricCriteria = {
  __typename?: 'AiGradedChallenge_TextRubricCriteria';
  /** Points for the text rubric. */
  points?: Maybe<Scalars['Float']>;
  /** Prompt for the text rubric. */
  prompt: Scalars['String'];
};

/** The criteria for a text rubric. */
export type AiGradedChallenge_TextRubricCriteriaInput = {
  /** Points for the text rubric. */
  points?: InputMaybe<Scalars['Float']>;
  /** Prompt for the text rubric. */
  prompt: Scalars['String'];
};

/** The grading result for a text-based rubric. */
export type AiGradedChallenge_TextRubricGrade = {
  __typename?: 'AiGradedChallenge_TextRubricGrade';
  /** The textual feedback for this rubric. */
  feedback: Scalars['String'];
  /** The score assigned for this text rubric. */
  score?: Maybe<Scalars['Float']>;
};

/** TimeLImitSummary indicates that learner has limited time between the start and end of each attempt. */
export type AiGradedChallenge_TimeLimitSummary = {
  __typename?: 'AiGradedChallenge_TimeLimitSummary';
  /** The total time allowed for an attempt. */
  allowedDuration: Scalars['Duration'];
  /**
   * The current attempt status indicating whether learner can submit or not. They can only submit
   * if the attempt is in progress.
   */
  attemptStatus: AiGradedChallenge_AttemptStatus;
  /** If present, the remaining time before their attempt gets closed/completed. */
  remainingDuration?: Maybe<Scalars['Duration']>;
  /** If present, the start time of the current attempt */
  startedTime?: Maybe<Scalars['DateTime']>;
};

/** Input for AiGradedChallenge_UpdateChallenge mutation */
export type AiGradedChallenge_UpdateChallengeInput = {
  /** ID of the challenge to update. */
  challengeId: Scalars['ID'];
  /**
   * ID of the course the challenge belongs to. Optional for backward
   * compatibility with existing callers; will be tightened to required once all
   * callers are updated.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Enablement status of the challenge. */
  enablementStatus: AiGradedChallenge_EnablementStatus;
  /** Grader-facing instructions for the challenge. */
  graderInstructions?: InputMaybe<Cml_CmlInput>;
  /** Instructions for the challenge. */
  instructions: AiGradedChallenge_InstructionsInput;
  /** Rubrics for the challenge. */
  rubrics: Array<AiGradedChallenge_RubricInput>;
};

/** The result of the update challenge mutation. */
export type AiGradedChallenge_UpdateChallengeResult = {
  __typename?: 'AiGradedChallenge_UpdateChallengeResult';
  /** ID of the challenge that was updated. */
  challengeId: Scalars['ID'];
};

/** The user's feedback for the grading result. */
export type AiGradedChallenge_UserFeedback = {
  __typename?: 'AiGradedChallenge_UserFeedback';
  /** The comment for the grading result. */
  comment?: Maybe<Scalars['String']>;
  /** The feedback type for the grading result. */
  feedbackType: AiGradedChallenge_UserFeedbackType;
};

/** The type of user feedback for a challenge submission. */
export const AiGradedChallenge_UserFeedbackType = {
  /** Downvote the challenge submission. */
  Downvote: 'DOWNVOTE',
  /** Upvote the challenge submission feedback. */
  Upvote: 'UPVOTE'
} as const;

export type AiGradedChallenge_UserFeedbackType = typeof AiGradedChallenge_UserFeedbackType[keyof typeof AiGradedChallenge_UserFeedbackType];
/** Queries that return AI grading information */
export type AiGradingQueries = {
  __typename?: 'AiGradingQueries';
  /** Finds AI grading dispute for a given submission */
  findDisputes: Array<AiGrading_Dispute>;
  /** Returns the ai grades preview with a specific preview id. */
  getAiGradesPreview: AiGrading_AiGradesPreview;
  /** Gets AI grading response from chatGpt */
  getAiGradingChatCompletionResponse: AiGrading_ChatCompletionResponse;
  /** Gets AI grading suggestion status */
  getAiGradingSuggestionStatus: AiGrading_SuggestionStatus;
  /** Returns the AI-generated assignment rubrics with a specific job ID (assignment-level result). */
  getAssignmentLevelRubricGenerationJob: AiGrading_AssignmentLevelRubricGenerationJobResult;
  /** Returns the AI-generated assignment rubrics with a specific job ID. */
  getAssignmentRubricGenerationJob: AiGrading_AssignmentRubricGenerationJobResult;
  /** Returns the timestamped AI grading for a combination of ReviewPart IDs and Suggestion IDs */
  getTimestampedAiGrading: Array<AiGrading_TimestampedReviewPartAiGrading>;
  /** Get Feedback previously given for AI generated grading suggestions */
  getUserFeedback: Array<AiGrading_UserReviewPartFeedback>;
  /** Returns the latest ai grades preview for one question with sample answer. */
  latestAiGradesPreview: AiGrading_AiGradesPreview;
  /** Returns the latest AI-generated assignment rubrics for an assignment (not scoped to a question). */
  latestAssignmentLevelRubricGenerationJob: AiGrading_AssignmentLevelRubricGenerationJobResult;
  /** Returns the latest AI-generated assignment rubrics for a specific question ID. */
  latestAssignmentRubricGenerationJobByQuestionId: AiGrading_AssignmentRubricGenerationJobResult;
};


/** Queries that return AI grading information */
export type AiGradingQueriesFindDisputesArgs = {
  submissionId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetAiGradesPreviewArgs = {
  courseId: Scalars['ID'];
  previewId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetAiGradingChatCompletionResponseArgs = {
  aiModel: AiGrading_AiModelEnum;
  assignmentId: Scalars['ID'];
  assignmentVersion: Scalars['Int'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  promptTemplate: Scalars['String'];
  submissionId: Scalars['ID'];
  submitterId: Scalars['ID'];
  temperature: Scalars['Float'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetAiGradingSuggestionStatusArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  submissionId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetAssignmentLevelRubricGenerationJobArgs = {
  courseId: Scalars['ID'];
  jobId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetAssignmentRubricGenerationJobArgs = {
  courseId: Scalars['ID'];
  jobId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetTimestampedAiGradingArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  scopedSubmitterId: Scalars['ID'];
  submissionId: Scalars['ID'];
  suggestionIds: Array<Scalars['ID']>;
};


/** Queries that return AI grading information */
export type AiGradingQueriesGetUserFeedbackArgs = {
  suggestionId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesLatestAiGradesPreviewArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  questionId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesLatestAssignmentLevelRubricGenerationJobArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** Queries that return AI grading information */
export type AiGradingQueriesLatestAssignmentRubricGenerationJobByQuestionIdArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  questionId: Scalars['ID'];
};

/** The preview ai grades result. */
export type AiGrading_AiGradesPreview = {
  __typename?: 'AiGrading_AiGradesPreview';
  /** The Course */
  course: Course_Course;
  /** The preview ai grades. Empty list if the preview job hasn't finished yet. */
  grades: Array<AiGrading_AiGradesPreviewGrades>;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The preview ID uniquely identifying ai grades preview job. */
  previewId: Scalars['ID'];
  /** The Question ID */
  questionId: Scalars['ID'];
  /** The status of the preview ai grades job */
  status: AiGrading_PreviewAiGradesJobStatus;
};

/** The generated ai grades with the sample answer. */
export type AiGrading_AiGradesPreviewGrades = {
  __typename?: 'AiGrading_AiGradesPreviewGrades';
  /** The preview grades details */
  details: AiGrading_PreviewAiGradesDetails;
  /** The rubric id is used for mapping the rubric to the grade. */
  rubricId: Scalars['ID'];
};

/** Enum type for AI Models */
export const AiGrading_AiModelEnum = {
  /** To use Gpt4 Client */
  Gpt_4: 'GPT_4',
  /** To use Gpt35Turbo16k Client */
  Gpt_35Turbo_16K: 'GPT_35_TURBO_16K'
} as const;

export type AiGrading_AiModelEnum = typeof AiGrading_AiModelEnum[keyof typeof AiGrading_AiModelEnum];
/** The type of assessment for rubric generation. */
export const AiGrading_AssessmentType = {
  /** Graded assignment. */
  Assignment: 'ASSIGNMENT',
  /** Lab. */
  Lab: 'LAB',
  /** ROLEPLAY */
  Roleplay: 'ROLEPLAY'
} as const;

export type AiGrading_AssessmentType = typeof AiGrading_AssessmentType[keyof typeof AiGrading_AssessmentType];
/** The assignment-level rubric generation result (not scoped to a question). */
export type AiGrading_AssignmentLevelRubricGenerationJobResult = {
  __typename?: 'AiGrading_AssignmentLevelRubricGenerationJobResult';
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course */
  course: Course_Course;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Job ID uniquely identifying a rubric generation job */
  jobId: Scalars['ID'];
  /** The generated rubrics. Null if the generation job hasn't finished yet. */
  rubrics?: Maybe<Array<AiGrading_AssignmentRubricSchema>>;
  /** The status of the rubric generation job */
  status: AiGrading_AssignmentRubricGenerationJobStatus;
};

/** The assignment rubric generation result. */
export type AiGrading_AssignmentRubricGenerationJobResult = {
  __typename?: 'AiGrading_AssignmentRubricGenerationJobResult';
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course */
  course: Course_Course;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Job ID uniquely identifying a rubric generation job */
  jobId: Scalars['ID'];
  /** The Question ID */
  questionId: Scalars['ID'];
  /** The generated rubrics. Null if the generation job hasn't finished yet. */
  rubrics?: Maybe<Array<AiGrading_AssignmentRubricSchema>>;
  /** The status of the rubric generation job */
  status: AiGrading_AssignmentRubricGenerationJobStatus;
};

/** The status of the rubrics generation job. */
export const AiGrading_AssignmentRubricGenerationJobStatus = {
  /** The job completed successfully */
  Completed: 'COMPLETED',
  /** The job failed */
  Failed: 'FAILED',
  /** The job is in progress */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiGrading_AssignmentRubricGenerationJobStatus = typeof AiGrading_AssignmentRubricGenerationJobStatus[keyof typeof AiGrading_AssignmentRubricGenerationJobStatus];
/** The assignment rubric with a rubric prompt and rubric details of different types. */
export type AiGrading_AssignmentRubricSchema = {
  __typename?: 'AiGrading_AssignmentRubricSchema';
  /** The rubric details */
  details: AiGrading_AssignmentRubricSchemaDetails;
  /** The rubric prompt */
  rubricPrompt: Scalars['String'];
};

/** The rubric details that can be option rubric details, text rubric details, or checklist rubric details. */
export type AiGrading_AssignmentRubricSchemaDetails = AiGrading_ChecklistRubricSchemaDetails | AiGrading_OptionsRubricSchemaDetails | AiGrading_TextRubricSchemaDetails;

/** Contains the Ai grading feedbacks for an assignment */
export type AiGrading_ChatCompletionResponse = {
  __typename?: 'AiGrading_ChatCompletionResponse';
  /** Ai grading feedbacks for all review parts */
  reviewResults: Scalars['String'];
  /** Token usage to generate Ai grading feedback for an assignment */
  usage: AiGrading_ChatCompletionUsage;
};

/** Contains token usage information */
export type AiGrading_ChatCompletionUsage = {
  __typename?: 'AiGrading_ChatCompletionUsage';
  /** Number of tokens used in feedback generation */
  completionTokens: Scalars['Int'];
  /** Number of tokens used in the prompt */
  promptTokens: Scalars['Int'];
  /** Total number of tokens used */
  totalTokens: Scalars['Int'];
};

/**
 * The checklist rubric details. Contains a list of options where the AI selects zero or more.
 * The score is the sum of each selected option's points.
 */
export type AiGrading_ChecklistRubricSchemaDetails = {
  __typename?: 'AiGrading_ChecklistRubricSchemaDetails';
  /** The list of checklist options */
  options: Array<AiGrading_ChecklistRubricSchemaOption>;
};

/**
 * One of the options in the checklist rubric. Contains a description and optional points.
 * IDs are not included in the generation schema; they are assigned downstream when the
 * rubric is persisted as a challenge.
 */
export type AiGrading_ChecklistRubricSchemaOption = {
  __typename?: 'AiGrading_ChecklistRubricSchemaOption';
  /** The option description */
  optionDescription: Scalars['String'];
  /** The points awarded when this option is selected. Nullable for unscored options. */
  points?: Maybe<Scalars['Float']>;
};

/** Input for CreateAssignmentLevelRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentLevelRubricGenerationJobInput = {
  /** The assessment type. */
  assessmentType?: AiGrading_AssessmentType;
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /**
   * A list of skill expression ids for which we should generate rubrics. If empty, the systems will
   * attempt to query for skill expressions that need rubrics.
   */
  skillExpressionIds?: Array<Scalars['ID']>;
};

/** Result of CreateAssignmentLevelRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentLevelRubricGenerationJobResult = {
  __typename?: 'AiGrading_CreateAssignmentLevelRubricGenerationJobResult';
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course */
  course: Course_Course;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Job ID uniquely identifying a rubric generation job */
  jobId: Scalars['ID'];
};

/** Input for CreateAssignmentRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentRubricGenerationJobInput = {
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Question ID */
  questionId: Scalars['ID'];
};

/** Result of CreateAssignmentRubricGenerationJob mutation */
export type AiGrading_CreateAssignmentRubricGenerationJobResult = {
  __typename?: 'AiGrading_CreateAssignmentRubricGenerationJobResult';
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course */
  course: Course_Course;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Job ID uniquely identifying a rubric generation job */
  jobId: Scalars['ID'];
  /** The Question ID */
  questionId: Scalars['ID'];
};

/** AiGrading_CreateDisputeFailure */
export type AiGrading_CreateDisputeFailure = {
  __typename?: 'AiGrading_CreateDisputeFailure';
  /** Error */
  error: AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError;
};

/** User Input for createDispute mutation */
export type AiGrading_CreateDisputeInput = {
  /** Id of the AI Suggestion this dispute is about */
  aiSuggestionId: Scalars['ID'];
  /** Id of the assignment this dispute is about */
  assignmentId: Scalars['ID'];
  /** version of the assignment this dispute is about */
  assignmentVersion: Scalars['Int'];
  /** Id of the course branch */
  courseBranchId: Scalars['ID'];
  /** Id of the course this dispute is about */
  courseId: Scalars['ID'];
  /** Id of the item this dispute is about */
  itemId: Scalars['ID'];
  /** Id of the submission this dispute is about */
  submissionId: Scalars['ID'];
  /** Dispute details entered by user */
  userInput: AiGrading_UserInputInput;
};

/** AiGrading_CreateDisputeResult */
export type AiGrading_CreateDisputeResult = AiGrading_CreateDisputeFailure | AiGrading_CreateDisputeSuccess;

/** In case of success the created dispute will be returned */
export type AiGrading_CreateDisputeSuccess = {
  __typename?: 'AiGrading_CreateDisputeSuccess';
  /** The created dispute */
  dispute: AiGrading_Dispute;
};

/** Contains the Ai grading dispute details */
export type AiGrading_Dispute = {
  __typename?: 'AiGrading_Dispute';
  /** timestamp of when the dispute was created */
  createdAt: Scalars['DateTime'];
  /** Unique id of the dispute */
  id: Scalars['ID'];
  /** Contains the status of the dispute */
  status: AiGrading_DisputeStatus;
  /** Contains the original user input submitted during dispute request */
  userInput: AiGrading_UserInput;
};

/** Ai Grading dispute status */
export const AiGrading_DisputeStatus = {
  /** Status indicating dispute was processed and there are grade updtes */
  Accepted: 'ACCEPTED',
  /** Status indicating failure to process the dispute */
  Failed: 'FAILED',
  /** Status once dispute is requested but no decision has been made */
  InProgress: 'IN_PROGRESS',
  /** Status indicating dispute was processed but there won't be grade changes */
  Rejected: 'REJECTED'
} as const;

export type AiGrading_DisputeStatus = typeof AiGrading_DisputeStatus[keyof typeof AiGrading_DisputeStatus];
/** Ai grading dispute issue categories */
export const AiGrading_IssueCategory = {
  /** Category indicates that The AI's evaluation of the answer doesn’t seem to align with the content of the course. */
  Accuracy: 'ACCURACY',
  /** Category indicates that AI has misunderstood the assignment requirements or objectives. */
  AssignmentUnderstanding: 'ASSIGNMENT_UNDERSTANDING',
  /** Category indicates the submission had extra materials that were not properly considered by AI. */
  ExtraMaterial: 'EXTRA_MATERIAL',
  /** Category indicates that the feedback provided by the AI does not align with the given grade. */
  GradeFeedbackMisalignment: 'GRADE_FEEDBACK_MISALIGNMENT',
  /** Category indicates any other issues not covered by the other categories. */
  Other: 'OTHER',
  /** Category indicates that AI has misinterpreted the grading rubric or criteria. */
  RubricMisinterpretation: 'RUBRIC_MISINTERPRETATION'
} as const;

export type AiGrading_IssueCategory = typeof AiGrading_IssueCategory[keyof typeof AiGrading_IssueCategory];
/** Enum type for ItemType */
export const AiGrading_ItemType = {
  /** assignment item */
  Assignment: 'ASSIGNMENT',
  /** peer review item */
  PeerReview: 'PEER_REVIEW'
} as const;

export type AiGrading_ItemType = typeof AiGrading_ItemType[keyof typeof AiGrading_ItemType];
/** The options rubric details. Contains a list of options with different scores and option descriptions. */
export type AiGrading_OptionsRubricSchemaDetails = {
  __typename?: 'AiGrading_OptionsRubricSchemaDetails';
  /** The list of options */
  options: Array<AiGrading_OptionsRubricSchemaOption>;
};

/** One of the options in the options rubric. Contains points and the option description. */
export type AiGrading_OptionsRubricSchemaOption = {
  __typename?: 'AiGrading_OptionsRubricSchemaOption';
  /** The option description */
  optionDescription: Scalars['String'];
  /** The option points */
  points: Scalars['Float'];
};

/** The ai grades that can be either option grade or text grade */
export type AiGrading_PreviewAiGradesDetails = AiGrading_PreviewAiGradesOptionsDetails | AiGrading_PreviewAiGradesTextDetails;

/** The status of the preview ai grades job. */
export const AiGrading_PreviewAiGradesJobStatus = {
  /** The job completed successfully */
  Completed: 'COMPLETED',
  /** The job failed */
  Failed: 'FAILED',
  /** The job is in progress */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiGrading_PreviewAiGradesJobStatus = typeof AiGrading_PreviewAiGradesJobStatus[keyof typeof AiGrading_PreviewAiGradesJobStatus];
/**
 * The choice details. Contains the selected optionId
 * and explanation to provide more context if necessary.
 */
export type AiGrading_PreviewAiGradesOptionsChoice = {
  __typename?: 'AiGrading_PreviewAiGradesOptionsChoice';
  /** Explanation about why this option was selected. */
  explanation?: Maybe<Scalars['String']>;
  /** The selected option. */
  optionId: Scalars['ID'];
};

/** The option grade details for AiGrading_OptionsRubricSchemaDetails */
export type AiGrading_PreviewAiGradesOptionsDetails = {
  __typename?: 'AiGrading_PreviewAiGradesOptionsDetails';
  /** The ai grade choice from AiGrading_OptionsRubricSchemaDetails */
  choice: AiGrading_PreviewAiGradesOptionsChoice;
};

/**
 * The text grade details for AiGrading_TextRubricSchemaDetails.
 * Contains the score field reflects the score assigned to the sample answer and text feedback.
 */
export type AiGrading_PreviewAiGradesTextDetails = {
  __typename?: 'AiGrading_PreviewAiGradesTextDetails';
  /** Text feedback associated with text based rubric schema. */
  feedback: Scalars['String'];
  /** The score field reflects the score assigned to the sample answer. */
  score?: Maybe<Scalars['Float']>;
};

/** Input for AiGrading_PreviewGradeForQuestionBankQuestion mutation */
export type AiGrading_PreviewGradeForQuestionBankQuestionInput = {
  /** The Course ID that owns the question bank being authored */
  courseId: Scalars['ID'];
  /** The question prompt/stem */
  questionPrompt: Cml_CmlInput;
  /** The AI grading rubric criteria for the question */
  rubrics: Array<AiGrading_QuestionBankRubricInput>;
  /** Sample answer to preview AI grading */
  sampleInput: AiGrading_PreviewGradeForQuestionSampleInputUnion;
};

/** Result of AiGrading_PreviewGradeForQuestionBankQuestion mutation */
export type AiGrading_PreviewGradeForQuestionBankQuestionResult = {
  __typename?: 'AiGrading_PreviewGradeForQuestionBankQuestionResult';
  /** The Preview ID uniquely identifying a preview ai grade job */
  previewId: Scalars['ID'];
};

/** Sample Content for AI grading when the question requires a file upload response input */
export type AiGrading_PreviewGradeForQuestionFileInput = {
  /** Caption to describe the file */
  caption: Scalars['String'];
  /** Generated file URL after upload */
  fileUrl: Scalars['String'];
  /** Title to describe the file */
  title: Scalars['String'];
};

/** Input for AiGrading_PreviewGradeForQuestion mutation */
export type AiGrading_PreviewGradeForQuestionInput = {
  /** The Branch ID */
  branchId: Scalars['ID'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The ItemType */
  itemType: AiGrading_ItemType;
  /** The Question ID */
  questionId: Scalars['ID'];
  /** sample answer to preview AI grading */
  sampleInput: AiGrading_PreviewGradeForQuestionSampleInputUnion;
};

/** Result of AiGrading_PreviewGradeForQuestion mutation */
export type AiGrading_PreviewGradeForQuestionResult = {
  __typename?: 'AiGrading_PreviewGradeForQuestionResult';
  /** The Preview ID uniquely identifying a preview ai grade job */
  previewId: Scalars['ID'];
};

/** The sample answer used for the AiGrading_PreviewGradeForQuestion mutation */
export type AiGrading_PreviewGradeForQuestionSampleInputUnion = {
  /** Cml content input. */
  cmlContentInput?: InputMaybe<CmlContentInput>;
  /** File Upload content. */
  fileUploadInput?: InputMaybe<AiGrading_PreviewGradeForQuestionFileInput>;
};

/** An options-based AI graded rubric criterion */
export type AiGrading_QuestionBankOptionsRubricInput = {
  /** Unique ID for the rubric criterion */
  id: Scalars['ID'];
  /** The possible options for this rubric criterion */
  options: Array<AiGrading_QuestionBankRubricOptionInput>;
  /** A description of the rubric criterion, provided to the AI grader */
  prompt: Scalars['String'];
};

/** An AI graded rubric criterion for a question bank question */
export type AiGrading_QuestionBankRubricInput = {
  /** An options-based (multiple choice style) rubric criterion */
  optionsRubric?: InputMaybe<AiGrading_QuestionBankOptionsRubricInput>;
  /** A free-text (multi-line) rubric criterion */
  textRubric?: InputMaybe<AiGrading_QuestionBankTextRubricInput>;
};

/** An option for an options-based AI graded rubric criterion */
export type AiGrading_QuestionBankRubricOptionInput = {
  /** Instructions for this option, provided to the AI grader */
  description: Scalars['String'];
  /** Unique ID for the option */
  id: Scalars['ID'];
  /** How much this option is worth. Omitted for feedback-only rubrics. */
  points?: InputMaybe<Scalars['Float']>;
};

/** A free-text AI graded rubric criterion */
export type AiGrading_QuestionBankTextRubricInput = {
  /** Unique ID for the rubric criterion */
  id: Scalars['ID'];
  /** How much this rubric criterion is worth. Omitted for feedback-only rubrics. */
  points?: InputMaybe<Scalars['Float']>;
  /** A description of the rubric criterion, provided to the AI grader */
  prompt: Scalars['String'];
};

/** Input for AiGrading_SaveUserFeedbackInput mutation */
export type AiGrading_SaveUserFeedbackInput = {
  /**
   * [Optional] The logged in user's feedback choice for the specified AI grading review part of a specific review
   * This field is optional, which is useful when the learner deselects feedback.
   */
  feedbackChoice?: InputMaybe<AiGrading_UserFeedbackChoice>;
  /** The Review Part ID of the AI review */
  reviewPartId: Scalars['ID'];
  /** AI Suggestion ID */
  suggestionId: Scalars['ID'];
};

/** Result for AiGrading_SaveUserFeedback mutation */
export type AiGrading_SaveUserFeedbackResult = {
  __typename?: 'AiGrading_SaveUserFeedbackResult';
  /** Just returning Suggestion ID, will error out if mutation not successful */
  suggestionId: Scalars['ID'];
};

/** Ai grading suggestion status */
export const AiGrading_SuggestionStatus = {
  /** The suggestion is marked as CANCELED when the submission is not found or has been deleted. */
  Canceled: 'CANCELED',
  /** The suggestion is marked as FAILED after the maximum number of retries. */
  Failed: 'FAILED',
  /** Initial status during suggestion generation process */
  Pending: 'PENDING',
  /**
   * The suggestion is marked as SUCCEEDED when all open-ended questions have been correctly graded.
   * If an assignment includes both manually graded questions and open-ended questions,
   * the suggestion may or may not contain grades for the manually graded questions.
   */
  Succeeded: 'SUCCEEDED'
} as const;

export type AiGrading_SuggestionStatus = typeof AiGrading_SuggestionStatus[keyof typeof AiGrading_SuggestionStatus];
/** The text rubric details. Contains points for the rubric. */
export type AiGrading_TextRubricSchemaDetails = {
  __typename?: 'AiGrading_TextRubricSchemaDetails';
  /** The rubric points. Nullable to support ungraded text rubrics. */
  points?: Maybe<Scalars['Float']>;
};

/** Timestamped AI feedback, used for audio/video questions. */
export type AiGrading_TimestampedAiFeedback = {
  __typename?: 'AiGrading_TimestampedAiFeedback';
  /** The AI's timestamped evaluation of the review part */
  feedback: Scalars['String'];
  /** Timestamp for the point relevant in the audio/video question */
  timestampSeconds: Scalars['Float'];
};

/** AI review for a specific review part with timestamp. Used for AI graded audio/video questions. */
export type AiGrading_TimestampedReviewPartAiGrading = {
  __typename?: 'AiGrading_TimestampedReviewPartAiGrading';
  /** ReviewPart ID */
  reviewPartId: Scalars['ID'];
  /** Suggestion ID */
  suggestionId: Scalars['ID'];
  /** List of timestamped AI feedback */
  timestampedAiFeedback: Array<AiGrading_TimestampedAiFeedback>;
};

/** Enum representing user feedback of AI grading */
export const AiGrading_UserFeedbackChoice = {
  /** AI review part is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI review part is liked by the user */
  Like: 'LIKE'
} as const;

export type AiGrading_UserFeedbackChoice = typeof AiGrading_UserFeedbackChoice[keyof typeof AiGrading_UserFeedbackChoice];
/** User Input */
export type AiGrading_UserInput = {
  __typename?: 'AiGrading_UserInput';
  /** Text justifying dispute entered by user */
  inputText: Scalars['String'];
  /** List of issue categories selected by user */
  issueCategory: Array<AiGrading_IssueCategory>;
};

/** User Input for mutation */
export type AiGrading_UserInputInput = {
  /** Text justifying dispute entered by user */
  inputText: Scalars['String'];
  /** List of issue categories selected by user */
  issueCategory: Array<AiGrading_IssueCategory>;
};

/** Feedback given to grade suggested by AI for the given rubric */
export type AiGrading_UserReviewPartFeedback = {
  __typename?: 'AiGrading_UserReviewPartFeedback';
  /** Feedback given to AI suggestion */
  feedbackChoice: AiGrading_UserFeedbackChoice;
  /** ReviewPart Id */
  reviewPartId: Scalars['ID'];
};

/** AI Item Generation Queries */
export type AiItemGenerationQueries = {
  __typename?: 'AiItemGenerationQueries';
  /**
   * Poll the status of an item generation job by its job ID. When status
   * is COMPLETED, the item has been fully populated with LLM-generated
   * content and a rubric.
   */
  queryStatusByJobId: AiItemGeneration_ItemGenerationStatus;
};


/** AI Item Generation Queries */
export type AiItemGenerationQueriesQueryStatusByJobIdArgs = {
  jobId: Scalars['ID'];
};

/**
 * A free-form library reference, identified by a package name and an
 * optional exact version.
 */
export type AiItemGeneration_CustomLibraryInput = {
  /** Package name as understood by the package manager (e.g. \"pandas\"). */
  name: Scalars['String'];
  /** Exact version to pin (e.g. \"2.2.0\"). Optional; omit to allow any version. */
  version?: InputMaybe<Scalars['String']>;
};

/**
 * A free-form virtual browser website, identified by a display name and
 * an optional URL to open when the lab launches.
 */
export type AiItemGeneration_CustomWebsiteInput = {
  /**
   * The URL to open in the virtual browser when the lab launches.
   * Optional; when omitted the launch URL is resolved downstream.
   */
  launchUrl?: InputMaybe<Scalars['URL']>;
  /** Human-readable name of the website or tool (e.g. \"Canva\"). */
  name: Scalars['String'];
};

/**
 * Defer materialization: generate content now and create the item later via
 * the AiItemGeneration_FinalizeGeneratedItem mutation.
 */
export type AiItemGeneration_DeferredMaterializationInput = {
  /**
   * The item after which the generated item should be inserted when it is
   * materialized. Captured at generate time and replayed at finalize to
   * position the item. If not provided, the item is appended as the last
   * item in the module.
   */
  previousItemId?: InputMaybe<Scalars['ID']>;
};

/**
 * Input for finalizing (materializing) a previously generated item. The
 * placement and configuration are taken from what was captured at generate
 * time, so only the job id is required.
 */
export type AiItemGeneration_FinalizeGeneratedItemInput = {
  /** The ID of the generation job to finalize. */
  jobId: Scalars['ID'];
};

/** Result of the FinalizeGeneratedItem mutation, returned synchronously. */
export type AiItemGeneration_FinalizeGeneratedItemResult = {
  __typename?: 'AiItemGeneration_FinalizeGeneratedItemResult';
  /** The atom ID of the materialized item. */
  atomId: Scalars['ID'];
  /** The generation job ID that was finalized. */
  jobId: Scalars['ID'];
};

/** Input for generating a new AI-powered item in a course module. */
export type AiItemGeneration_GenerateItemInput = {
  /** The authoring course branch. */
  branchId: Scalars['ID'];
  /** The course to create the item in. */
  courseId: Scalars['ID'];
  /**
   * The type-specific configuration for the item to generate. Exactly one
   * field must be set.
   */
  itemInput: AiItemGeneration_ItemInput;
  /**
   * How the generated item should be materialized. Exactly one field must
   * be set.
   */
  materialization: AiItemGeneration_MaterializationInput;
  /** The module to create the item in. */
  moduleId: Scalars['ID'];
  /**
   * How skill expressions for the generated rubrics should be sourced.
   * Defaults to NONE: generated rubrics carry no skill expressions and none
   * are derived. Set DERIVE_FROM_CONTEXT to opt into the legacy behavior of
   * deriving skill expressions from surrounding module items.
   */
  skillExpressionMode?: AiItemGeneration_SkillExpressionMode;
  /**
   * Skill expressions that scope the generated content. Interpreted according
   * to skillExpressionMode: under DERIVE_FROM_CONTEXT an empty or omitted list
   * triggers derivation from surrounding module items; under NONE the list is
   * ignored and no skill expressions are attached or queried.
   */
  skillExpressions?: InputMaybe<Array<Scalars['String']>>;
};

/** Result of the GenerateItem mutation, returned synchronously. */
export type AiItemGeneration_GenerateItemResult = {
  __typename?: 'AiItemGeneration_GenerateItemResult';
  /**
   * The ID of the generation job. Pass to
   * AiItemGeneration.queryStatusByJobId to poll for completion
   * and to retrieve the item ID once generation is done.
   */
  jobId: Scalars['ID'];
};

/**
 * A read-only preview of generated item content. Discriminated by item type
 * so future item types (e.g. quizzes) can be added without a breaking change.
 */
export type AiItemGeneration_GeneratedItem = AiItemGeneration_GeneratedLab;

/**
 * A generated lab preview: content and rubrics common to all lab types, plus
 * a per-lab-type settings union.
 */
export type AiItemGeneration_GeneratedLab = {
  __typename?: 'AiItemGeneration_GeneratedLab';
  /** The shared, type-independent content of the lab. */
  content: AiItemGeneration_GeneratedLabContent;
  /** The generated rubrics. Only options rubrics are surfaced today. */
  rubrics: Array<AiItemGeneration_GeneratedRubric>;
  /** Per-lab-type settings. A Jupyter notebook type may be added later. */
  settings: AiItemGeneration_GeneratedLabSettings;
};

/**
 * The shared, type-independent content of a generated lab. Rich-text fields
 * are CML, matching the materialized item (markdown is converted to CML at
 * materialization time).
 */
export type AiItemGeneration_GeneratedLabContent = {
  __typename?: 'AiItemGeneration_GeneratedLabContent';
  /** The cover page content, as CML. */
  coverPage: Cml_Cml;
  /** The ordered instruction steps. */
  instructions: Array<AiItemGeneration_GeneratedLabInstruction>;
  /** The lab title. */
  title: Scalars['String'];
};

/** A single instruction step in a generated lab. */
export type AiItemGeneration_GeneratedLabInstruction = {
  __typename?: 'AiItemGeneration_GeneratedLabInstruction';
  /** The step content, as CML. */
  content: Cml_Cml;
  /** The step title. */
  title: Scalars['String'];
};

/**
 * Per-lab-type settings for a generated lab. Discriminated by lab type so
 * additional types (e.g. Jupyter notebook) can be added without a breaking
 * change.
 */
export type AiItemGeneration_GeneratedLabSettings = AiItemGeneration_VirtualBrowserLabSettings;

/**
 * An options rubric: a prompt and the scorable options. Skill expression ids
 * are intentionally omitted; this is preview content, not for editing.
 */
export type AiItemGeneration_GeneratedOptionsRubric = {
  __typename?: 'AiItemGeneration_GeneratedOptionsRubric';
  /** The scorable options. */
  options: Array<AiItemGeneration_GeneratedRubricOption>;
  /** The rubric prompt. */
  rubricPrompt: Scalars['String'];
};

/**
 * A generated rubric preview. Discriminated by rubric type so text and
 * checklist rubrics can be added later without a breaking change. Only the
 * options rubric is surfaced today.
 */
export type AiItemGeneration_GeneratedRubric = AiItemGeneration_GeneratedOptionsRubric;

/** A single scorable option within an options rubric. */
export type AiItemGeneration_GeneratedRubricOption = {
  __typename?: 'AiItemGeneration_GeneratedRubricOption';
  /** The option description. */
  optionDescription: Scalars['String'];
  /** The points awarded for this option. */
  points: Scalars['Float'];
};

/** Whether an item is a graded assessment or ungraded practice. */
export const AiItemGeneration_GradingType = {
  /** Graded assessment with no time limit and unlimited attempts. */
  Graded: 'GRADED',
  /** Ungraded practice mode. */
  Practice: 'PRACTICE'
} as const;

export type AiItemGeneration_GradingType = typeof AiItemGeneration_GradingType[keyof typeof AiItemGeneration_GradingType];
/** Status of an item generation job. */
export const AiItemGeneration_ItemGenerationJobStatus = {
  /**
   * Content generation and materialization succeeded.
   * The item is fully populated and ready for human review.
   */
  Completed: 'COMPLETED',
  /** The job failed. The item shell exists but content is incomplete. */
  Failed: 'FAILED',
  /** The job is queued or the LLM is generating content. */
  InProgress: 'IN_PROGRESS'
} as const;

export type AiItemGeneration_ItemGenerationJobStatus = typeof AiItemGeneration_ItemGenerationJobStatus[keyof typeof AiItemGeneration_ItemGenerationJobStatus];
/** The current status of an item generation job. */
export type AiItemGeneration_ItemGenerationStatus = {
  __typename?: 'AiItemGeneration_ItemGenerationStatus';
  /**
   * A read-only preview of the generated content. Present when status is
   * COMPLETED; null otherwise. Intended to let a caller render a preview
   * before committing a deferred job. Carries no ids or working data.
   */
  generatedItem?: Maybe<AiItemGeneration_GeneratedItem>;
  /** The generation job ID. */
  jobId: Scalars['ID'];
  /** Current status of the generation pipeline. */
  status: AiItemGeneration_ItemGenerationJobStatus;
};

/**
 * Discriminated union of item-type-specific generation inputs. Exactly
 * one field must be provided.
 */
export type AiItemGeneration_ItemInput = {
  /** Configuration for generating a virtual browser lab. */
  lab?: InputMaybe<AiItemGeneration_LabInput>;
};

/** The publication status of a generated item. */
export const AiItemGeneration_ItemStatus = {
  /** Leave the item as a draft for human review before publishing. */
  Draft: 'DRAFT',
  /** Publish the item immediately. */
  Published: 'PUBLISHED'
} as const;

export type AiItemGeneration_ItemStatus = typeof AiItemGeneration_ItemStatus[keyof typeof AiItemGeneration_ItemStatus];
/**
 * A recommended Jupyter notebook lab. Carries the libraries the generated
 * notebook is expected to use.
 */
export type AiItemGeneration_JupyterNotebookToolInput = {
  /**
   * Libraries the lab is expected to use. Optional; may be empty, in which
   * case the generator still infers imports from the generated notebook.
   */
  expectedLibraries?: Array<AiItemGeneration_NotebookLibraryInput>;
};

/** Configuration specific to generating a lab item. */
export type AiItemGeneration_LabInput = {
  /**
   * Whether this is a graded assessment or ungraded practice.
   * Defaults to PRACTICE if not provided.
   */
  gradingType?: AiItemGeneration_GradingType;
  /**
   * A one-sentence direction from the pedagogy model describing what the
   * generated lab should focus on. When provided, the LLM uses this to
   * tailor the exercise scenario and requirements.
   */
  recommendedFocus?: InputMaybe<Scalars['String']>;
  /**
   * An optional recommended tool/website for the generated lab. When
   * provided, the LLM is encouraged to build the exercise around it.
   * Omitting it leaves the tool choice to the generator.
   */
  recommendedTool?: InputMaybe<AiItemGeneration_RecommendedToolInput>;
  /**
   * The number of rubrics the caller wants generated, decoupled from any
   * skill expression count. When omitted, the service default is used.
   */
  requestedRubricCount?: InputMaybe<Scalars['Int']>;
  /**
   * The caller's minimum confidence (0.0-1.0) required for a generated
   * rubric to be kept; rubrics whose confidence falls below it are dropped.
   * When omitted, the service default is used.
   */
  requiredRubricConfidence?: InputMaybe<Scalars['Float']>;
  /**
   * Estimated time for the learner to complete the lab, in minutes.
   * Defaults to 15 if not provided.
   */
  timeEstimateMinutes?: Scalars['Int'];
};

/**
 * Discriminated union of materialization strategies. Exactly one field
 * must be provided.
 */
export type AiItemGeneration_MaterializationInput = {
  /**
   * Generate content without materializing an item now. The item is created
   * later via the AiItemGeneration_FinalizeGeneratedItem mutation.
   */
  deferred?: InputMaybe<AiItemGeneration_DeferredMaterializationInput>;
  /** Insert the generated item into a module at a specific position. */
  moduleItemMaterialization?: InputMaybe<AiItemGeneration_ModuleItemMaterializationInput>;
};

/** Materialize the generated item as an item inserted into a module. */
export type AiItemGeneration_ModuleItemMaterializationInput = {
  /**
   * Whether the item should be left as a draft or published immediately.
   * Defaults to DRAFT if not provided.
   */
  itemStatus?: AiItemGeneration_ItemStatus;
  /**
   * The item ID after which the new item should be inserted. If not
   * provided, the item is appended as the last item in the module.
   */
  previousItemId?: InputMaybe<Scalars['ID']>;
};

/**
 * Discriminated union of notebook library kinds. Exactly one field must be
 * provided. Today only a free-form custom library is supported; a typed
 * \"known library\" arm may be added later without a breaking change.
 */
export type AiItemGeneration_NotebookLibraryInput = {
  /** A free-form library specified by name and optional version. */
  custom?: InputMaybe<AiItemGeneration_CustomLibraryInput>;
};

/**
 * Discriminated union of recommended tools. Exactly one field must be
 * provided. Modeled as a union so additional tool types can be added
 * later without a breaking change.
 */
export type AiItemGeneration_RecommendedToolInput = {
  /**
   * A Jupyter notebook tool, carrying the libraries the generated notebook
   * is expected to use.
   */
  jupyterNotebook?: InputMaybe<AiItemGeneration_JupyterNotebookToolInput>;
  /** A virtual browser tool, scoped to a specific website. */
  virtualBrowser?: InputMaybe<AiItemGeneration_VirtualBrowserToolInput>;
};

/**
 * How skill expressions for a generated item's rubrics should be sourced.
 * Additional arms (e.g. an EXPLICIT mode that uses exactly the provided
 * skillExpressions with no fallback) may be added later without a breaking
 * change.
 */
export const AiItemGeneration_SkillExpressionMode = {
  /**
   * Use the provided skillExpressions; if none are provided, derive them from
   * surrounding module items. This is the legacy behavior, retained as an
   * opt-in for callers mid-migration.
   */
  DeriveFromContext: 'DERIVE_FROM_CONTEXT',
  /**
   * Do not attach or query skill expressions for the generated rubrics. Any
   * provided skillExpressions are ignored and no derivation occurs. This is
   * the default.
   */
  None: 'NONE'
} as const;

export type AiItemGeneration_SkillExpressionMode = typeof AiItemGeneration_SkillExpressionMode[keyof typeof AiItemGeneration_SkillExpressionMode];
/** Virtual-browser-specific settings for a generated lab. */
export type AiItemGeneration_VirtualBrowserLabSettings = {
  __typename?: 'AiItemGeneration_VirtualBrowserLabSettings';
  /** The URL opened when the lab launches. */
  startUrl?: Maybe<Scalars['URL']>;
  /** The tool/image the lab launches (e.g. "vscode"). */
  tool: Scalars['String'];
};

/**
 * Discriminated union of virtual browser website kinds. Exactly one field
 * must be provided. Today only a free-form custom website is supported; a
 * typed \"known website\" arm may be added later without a breaking change.
 */
export type AiItemGeneration_VirtualBrowserToolInput = {
  /** A free-form website specified by name and launch URL. */
  custom?: InputMaybe<AiItemGeneration_CustomWebsiteInput>;
};

/** Queries for AI Grading */
export type AiSuggestionsQueries = {
  __typename?: 'AiSuggestionsQueries';
  /** Get AI generated grading suggestions */
  getAiSuggestions?: Maybe<Array<AiSuggestions_ReviewPartSuggestion>>;
  /** Get Feedback previously given for AI generated grading suggestions */
  getSuggestionFeedback?: Maybe<AiSuggestions_SuggestionFeedback>;
};


/** Queries for AI Grading */
export type AiSuggestionsQueriesGetAiSuggestionsArgs = {
  courseId: Scalars['ID'];
  groupId: Scalars['ID'];
  itemId: Scalars['ID'];
  submitterId: Scalars['ID'];
};


/** Queries for AI Grading */
export type AiSuggestionsQueriesGetSuggestionFeedbackArgs = {
  suggestionId: Scalars['ID'];
};

/** Details on the graded and feedback suggested by AI for the given rubric */
export type AiSuggestions_Details = AiSuggestions_GradedTextBoxDetails | AiSuggestions_OptionsDetails | AiSuggestions_UngradedTextBoxDetails;

/** ENUM for feedback types */
export const AiSuggestions_FeedbackChoice = {
  /** Grader gave dislike/thumbs down */
  Dislike: 'DISLIKE',
  /** Grader gave like/thumbs up */
  Like: 'LIKE'
} as const;

export type AiSuggestions_FeedbackChoice = typeof AiSuggestions_FeedbackChoice[keyof typeof AiSuggestions_FeedbackChoice];
/** Details on the grade and feedback suggested by AI for graded text box rubric */
export type AiSuggestions_GradedTextBoxDetails = {
  __typename?: 'AiSuggestions_GradedTextBoxDetails';
  /** Text feedback suggested by AI */
  input: Scalars['String'];
  /** Score suggested by AI */
  score: Scalars['Int'];
};

/** Details on the grade suggested by AI for options and yes/no rubrics */
export type AiSuggestions_OptionsDetails = {
  __typename?: 'AiSuggestions_OptionsDetails';
  /** [Optional] Text feedback suggested by AI */
  feedback?: Maybe<Scalars['String']>;
  /** The option suggested by AI */
  optionChoice: Scalars['ID'];
};

/** Feedback given to grade suggested by AI for the given rubric */
export type AiSuggestions_ReviewPartFeedback = {
  __typename?: 'AiSuggestions_ReviewPartFeedback';
  /** Feedback given to AI suggestion */
  feedbackChoice: AiSuggestions_FeedbackChoice;
  /** ReviewPart Id */
  reviewPartId: Scalars['ID'];
};

/** Grade suggested by AI */
export type AiSuggestions_ReviewPartSuggestion = {
  __typename?: 'AiSuggestions_ReviewPartSuggestion';
  /** Details on the graded and feedback suggested by AI for the given rubric */
  details: AiSuggestions_Details;
  /** Composite ID of suggestionId~reviewPartId */
  id: Scalars['ID'];
  /** Rubric Type */
  typeName?: Maybe<AssignmentPresentations_ReviewPartTypeName>;
};

/** Suggestion feedback input */
export type AiSuggestions_SaveSuggestionFeedbackInput = {
  /**
   * Feedback given to AI suggestion
   * This can be null as graders can unset their previously given feedback
   */
  feedbackChoice?: InputMaybe<AiSuggestions_FeedbackChoice>;
  /** Rubric Id */
  reviewPartId: Scalars['ID'];
  /** Suggestion Id */
  suggestionId: Scalars['ID'];
};

/** Suggestion feedback response */
export type AiSuggestions_SaveSuggestionFeedbackResult = {
  __typename?: 'AiSuggestions_SaveSuggestionFeedbackResult';
  /** Suggestion Id */
  suggestionId: Scalars['ID'];
};

/** Feedback given to grade suggested by AI */
export type AiSuggestions_SuggestionFeedback = {
  __typename?: 'AiSuggestions_SuggestionFeedback';
  /** Feedback given to grade suggested by AI for the given rubric */
  reviewParts?: Maybe<Array<AiSuggestions_ReviewPartFeedback>>;
  /** SuggestionId */
  suggestionId: Scalars['ID'];
};

/** Details on the feedback suggested by AI for ungraded text box rubrics */
export type AiSuggestions_UngradedTextBoxDetails = {
  __typename?: 'AiSuggestions_UngradedTextBoxDetails';
  /** Text feedback suggested by AI */
  input: Scalars['String'];
};

/** All DynamicPrompt queries */
export type AiTutorDynamicPromptQueries = {
  __typename?: 'AiTutorDynamicPromptQueries';
  /** Returns dynamic prompts for a given context based on user progress */
  queryForDynamicPrompts: AiTutor_DynamicPromptsResult;
};


/** All DynamicPrompt queries */
export type AiTutorDynamicPromptQueriesQueryForDynamicPromptsArgs = {
  contextType: AiTutor_ContextType;
  courseBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId?: InputMaybe<Scalars['ID']>;
};

/** Context of where the dynamic prompts are to be shown to the learner */
export const AiTutor_ContextType = {
  /** Shows dynamic prompts in Coach Tutor Disclosure UI */
  Disclosure: 'DISCLOSURE'
} as const;

export type AiTutor_ContextType = typeof AiTutor_ContextType[keyof typeof AiTutor_ContextType];
/** A single dynamic prompt */
export type AiTutor_DynamicPrompt = {
  __typename?: 'AiTutor_DynamicPrompt';
  /** Label for the button with translation */
  buttonLabel: Scalars['String'];
  /** The associated coach action */
  coachAction: Scalars['String'];
  /** The associated coach mode */
  coachMode: Scalars['String'];
  /** ID of the dynamic prompt shown to the learner */
  id: Scalars['ID'];
};

/** Result for dynamic prompts query */
export type AiTutor_DynamicPromptsResult = {
  __typename?: 'AiTutor_DynamicPromptsResult';
  /** List of the dynamic prompts to be shown to the learner */
  dynamicPrompts: Array<AiTutor_DynamicPrompt>;
};

/** Input to update the status of a dynamic prompt to completed status for a learner */
export type AiTutor_UpdateDynamicPromptStatusAsCompleteInput = {
  /** The ID of the dynamic prompt that needs to get updated with the completed status */
  id: Scalars['ID'];
};

/** Result for AiTutor_UpdateDynamicPromptStatusAsCompleteResult mutation */
export type AiTutor_UpdateDynamicPromptStatusAsCompleteResult = {
  __typename?: 'AiTutor_UpdateDynamicPromptStatusAsCompleteResult';
  /** Dummy variable */
  _?: Maybe<Scalars['Boolean']>;
};

/** Status of the AI grading of the submission */
export const Ai_Grading_Status = {
  /** Grading finished */
  Graded: 'GRADED',
  /** Grading started */
  Grading: 'GRADING',
  /** Grading is not required */
  NotRequired: 'NOT_REQUIRED',
  /** Grading didn't start yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Ai_Grading_Status = typeof Ai_Grading_Status[keyof typeof Ai_Grading_Status];
/** Queries for explaining flagged anomalous attempts. */
export type AnomalyExplainerQueries = {
  __typename?: 'AnomalyExplainerQueries';
  /**
   * Generate a plain-language explanation of why a flagged attempt is anomalous,
   * from its de-identified behavioral signals. Cacheable: the result is a pure function
   * of the (de-identified) input signals.
   */
  explainAnomalousAttempt: AnomalyExplainer_ExplainAnomalousAttemptResult;
};


/** Queries for explaining flagged anomalous attempts. */
export type AnomalyExplainerQueriesExplainAnomalousAttemptArgs = {
  input: AnomalyExplainer_ExplainAnomalousAttemptInput;
};

/**
 * Input for generating a plain-language explanation of a flagged anomalous attempt.
 *
 * Carries only de-identified behavioral signals (mirrors the behavioral columns of the
 * upstream flagged_user_events table) — no learner/course identifiers and no dates/timestamps.
 */
export type AnomalyExplainer_ExplainAnomalousAttemptInput = {
  /** Percentile of the anomaly score within the baseline cohort (0-1). */
  anomalyPercentile: Scalars['Float'];
  /** Anomaly score produced by the detection model. */
  anomalyScore: Scalars['Float'];
  /** Number of blur (focus-loss) events during the attempt; null if not captured. */
  blurAssignmentEvents?: InputMaybe<Scalars['Int']>;
  /** Time taken to complete the attempt, in seconds. */
  completionDurationSeconds: Scalars['Int'];
  /** Why the attempt was flagged (e.g. "completion_duration_seconds"). */
  flagReason: Scalars['String'];
  /** Ratio of delete keystrokes; null if not captured. */
  keystrokeDeleteRatio?: InputMaybe<Scalars['Float']>;
  /** p50 inter-key interval (ms); null if not captured. */
  keystrokeP50IkiMs?: InputMaybe<Scalars['Float']>;
  /** p99 inter-key interval (ms); null if not captured. */
  keystrokeP99IkiMs?: InputMaybe<Scalars['Float']>;
  /** Stddev of inter-key interval (ms); null if not captured. */
  keystrokeStddevIkiMs?: InputMaybe<Scalars['Float']>;
  /** Total keystrokes; null if not captured. */
  keystrokeTotalKeystrokes?: InputMaybe<Scalars['Float']>;
  /** Keystroke velocity (keys/sec); null if not captured. */
  keystrokeVelocityKps?: InputMaybe<Scalars['Float']>;
  /** Detection model that produced the score. */
  model: Scalars['String'];
  /** Version of the detection model. */
  modelVersion: Scalars['String'];
  /** Number of paste events during the attempt; null if not captured upstream. */
  pasteAssignmentEvents?: InputMaybe<Scalars['Int']>;
};

/** The generated explanation of why an attempt was flagged as anomalous. */
export type AnomalyExplainer_ExplainAnomalousAttemptResult = {
  __typename?: 'AnomalyExplainer_ExplainAnomalousAttemptResult';
  /** Human-readable explanation of why the attempt stands out statistically. */
  message: Scalars['String'];
};

/** TODO: Complete this description */
export const ApiStatusType = {
  /** ApiStatusType shows Turnitin webhook status is configured or not. */
  Configured: 'CONFIGURED',
  /** TODO: Complete this description */
  NotConfigured: 'NOT_CONFIGURED'
} as const;

export type ApiStatusType = typeof ApiStatusType[keyof typeof ApiStatusType];
/** Fetch data for app fee waiver */
export type AppFeeWaiverQueries = {
  __typename?: 'AppFeeWaiverQueries';
  /** Return if the user is qualified for an application fee waiver for this degree. */
  hasAppFeeWaiverQualification: Scalars['Boolean'];
};


/** Fetch data for app fee waiver */
export type AppFeeWaiverQueriesHasAppFeeWaiverQualificationArgs = {
  degreeSlug?: InputMaybe<Scalars['String']>;
};

/** Result for the query to get assessment generation parameters */
export type AssessmentGeneration_AssessmentGenerationParametersResult = {
  __typename?: 'AssessmentGeneration_AssessmentGenerationParametersResult';
  /** Generation parameters as structured json data */
  generationParameters: Scalars['JSON'];
};

/** Status of assessment generation process */
export const AssessmentGeneration_AssessmentGenerationStatus = {
  /** Generation has been cancelled */
  Cancelled: 'CANCELLED',
  /** Generation has completed successfully */
  Completed: 'COMPLETED',
  /** Generation has failed */
  Failed: 'FAILED',
  /** Generation is currently in progress */
  InProgress: 'IN_PROGRESS',
  /** Generation has not started yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type AssessmentGeneration_AssessmentGenerationStatus = typeof AssessmentGeneration_AssessmentGenerationStatus[keyof typeof AssessmentGeneration_AssessmentGenerationStatus];
/** Assessment generation status information */
export type AssessmentGeneration_AssessmentGenerationStatusResult = {
  __typename?: 'AssessmentGeneration_AssessmentGenerationStatusResult';
  /** The generated atom ID if generation is completed */
  generatedAtomId?: Maybe<Scalars['ID']>;
  /**
   * The generated item ID if generation is completed
   * @deprecated use generatedAtomId instead
   */
  generatedItemId?: Maybe<Scalars['ID']>;
  /** Current status of the assessment generation */
  status: AssessmentGeneration_AssessmentGenerationStatus;
};

/** Assessment generation input to trigger assessment generation */
export type AssessmentGeneration_GenerateAssessmentInput = {
  /** The branch ID for the assessment generation */
  branchId: Scalars['ID'];
  /** The course ID for the assessment generation */
  courseId: Scalars['ID'];
  /** Generation parameters as structured json data */
  generationParameters: Scalars['JSON'];
};

/** Result of assessment generation request */
export type AssessmentGeneration_GenerateAssessmentResult = {
  __typename?: 'AssessmentGeneration_GenerateAssessmentResult';
  /** The unique generation ID to track the assessment generation process */
  generationId: Scalars['ID'];
};

/** Input for getting assessment generation status */
export type AssessmentGeneration_GetAssessmentGenerationStatusInput = {
  /** The generation ID to check status for */
  generationId: Scalars['ID'];
};

/** Assessment generation input to cancel assessment generation */
export type AssessmentGeneration_StopAssessmentGenerationInput = {
  /** The unique generation ID to track the assessment generation process */
  generationId: Scalars['ID'];
};

/** Result of assessment generation cancellation request */
export type AssessmentGeneration_StopAssessmentGenerationResult = {
  __typename?: 'AssessmentGeneration_StopAssessmentGenerationResult';
  /** The unique generation ID to track the assessment generation process */
  generationId: Scalars['ID'];
};

/** State of an assignment generation request */
export type AssessmentGenerator_GenerationStateResult = {
  __typename?: 'AssessmentGenerator_GenerationStateResult';
  /** ID */
  assessmentGenerationRequestId?: Maybe<Scalars['ID']>;
  /** Stated of the linked question generation request */
  questionGenerationStateResult: QuestionGenerator_GenerationStateResult;
  /** Status of the assignment generation request */
  status: AssessmentGenerator_RequestStatus;
};

/** Assignment Generator Status */
export const AssessmentGenerator_RequestStatus = {
  /**
   * The assignment generation was cancelled by the user.
   * This can only happen during the GENERATING state.
   */
  Cancelled: 'CANCELLED',
  /** The assignment generation ended */
  Completed: 'COMPLETED',
  /** The assignment generation failed */
  Failed: 'FAILED',
  /** The question generation started */
  Generating: 'GENERATING',
  /** The question generation ended and the process started publishing the question bank */
  PublishingQuestionBank: 'PUBLISHING_QUESTION_BANK',
  /** The assignment generation request was created, but the question generation hasn't started yet */
  Started: 'STARTED',
  /** Finished publishing question bank and started updating assignment */
  UpdatingAssignment: 'UPDATING_ASSIGNMENT'
} as const;

export type AssessmentGenerator_RequestStatus = typeof AssessmentGenerator_RequestStatus[keyof typeof AssessmentGenerator_RequestStatus];
/** Input to start an assignment generation process */
export type AssessmentGenerator_StartGenerationInput = {
  /** Assignment to fill in the generation */
  assessmentId: Scalars['ID'];
  /** Parameters for the question generation request */
  questionGenerationInput: QuestionGenerator_StartGenerationInput;
  /** Number of questions learner will see in the in the assignment; default is 1 */
  questionsPerQuestionBlock?: Scalars['Int'];
};

/** Result of the assignment generation start request */
export type AssessmentGenerator_StartGenerationResult = {
  __typename?: 'AssessmentGenerator_StartGenerationResult';
  /** Assignment generation request unique identifier */
  assessmentGenerationRequestId: Scalars['ID'];
  /** Result from the question generation request */
  questionGenerationStartResult: QuestionGenerator_StartGenerationResult;
};

/** Add asset video error. */
export type AssetVideo_AddAssetVideoError = {
  __typename?: 'AssetVideo_AddAssetVideoError';
  /** TODO: Complete this description */
  message: Scalars['String'];
};

/** Add asset video failure. */
export type AssetVideo_AddAssetVideoFailure = {
  __typename?: 'AssetVideo_AddAssetVideoFailure';
  /** TODO: Complete this description */
  errors: Array<AssetVideo_AddAssetVideoError>;
};

/** Add asset video input. */
export type AssetVideo_AddAssetVideoInput = {
  /** Index (starts at 0) of image which is used as the poster image. Optional, uses first image if not present. */
  preferredPosterIndex?: InputMaybe<Scalars['Int']>;
  /**
   * Trimming ranges for this video asset across all branches it's used in. If a branch id
   * matches an existing one, the range will be replaced in the underlying map.
   */
  trimmingRangesForBranches?: InputMaybe<Array<AssetVideo_TrimmingRangesForBranchesInput>>;
  /** Video asset id. */
  videoAssetId: Scalars['ID'];
  /** Video id. */
  videoId: Scalars['ID'];
};

/** Add asset video result. */
export type AssetVideo_AddAssetVideoResult = AssetVideo_AddAssetVideoFailure | AssetVideo_Video;

/** failure result when trying to convert to an audioDescription video asset */
export type AssetVideo_ConvertExistingVideoToAudioDescriptionVideoFailure = {
  __typename?: 'AssetVideo_ConvertExistingVideoToAudioDescriptionVideoFailure';
  /** an error message describing why conversion failed */
  errorMessage?: Maybe<Scalars['String']>;
};

/** Inputs for converting an existing video into an audioDescription video asset */
export type AssetVideo_ConvertExistingVideoToAudioDescriptionVideoInput = {
  /** course that the video asset is associated with, used for permission check */
  courseId: Scalars['ID'];
  /** Language code for the audioDescription video */
  languageCode: Scalars['String'];
  /**
   * assetId of the original video asset that we would want to attach
   * the audio description video asset to
   */
  originalAssetId: Scalars['ID'];
  /** assetId of the video asset that we want to turn use as the audio description video */
  videoAssetId: Scalars['ID'];
};

/** Converting to AD Video attempt result */
export type AssetVideo_ConvertExistingVideoToAudioDescriptionVideoResult = AssetVideo_ConvertExistingVideoToAudioDescriptionVideoFailure | AssetVideo_ConvertExistingVideoToAudioDescriptionVideoSuccess;

/** success result when trying to convert to an audioDescription video asset */
export type AssetVideo_ConvertExistingVideoToAudioDescriptionVideoSuccess = {
  __typename?: 'AssetVideo_ConvertExistingVideoToAudioDescriptionVideoSuccess';
  /** Language code for the audioDescription video we converted */
  languageCode: Scalars['String'];
  /** assetId of the original video asset that we attached the audio description video asset to */
  originalAssetId: Scalars['ID'];
  /** assetId of the video asset that is now used as the audio description */
  videoAssetId: Scalars['ID'];
};

/** failure result when trying to delete an audioDescription video asset */
export type AssetVideo_DeleteAudioDescriptionVideoFailure = {
  __typename?: 'AssetVideo_DeleteAudioDescriptionVideoFailure';
  /** an error message describing why deletion failed */
  errorMessage?: Maybe<Scalars['String']>;
};

/** Inputs for deleting an audioDescription video asset */
export type AssetVideo_DeleteAudioDescriptionVideoInput = {
  /** course that the video asset is associated with, used for permission check */
  courseId: Scalars['ID'];
  /** Language code for the audioDescription video we want to delete from the original video asset */
  languageCode: Scalars['String'];
  /**
   * assetId of the original video asset that we would want to delete
   * the audio description video asset from
   */
  videoAssetId: Scalars['ID'];
};

/** Deletion attempt result */
export type AssetVideo_DeleteAudioDescriptionVideoResult = AssetVideo_DeleteAudioDescriptionVideoFailure | AssetVideo_DeleteAudioDescriptionVideoSuccess;

/** success result when trying to delete an audioDescription video asset */
export type AssetVideo_DeleteAudioDescriptionVideoSuccess = {
  __typename?: 'AssetVideo_DeleteAudioDescriptionVideoSuccess';
  /** Language code for the audioDescription video we deleted from the original video asset */
  languageCode: Scalars['String'];
  /** assetId of the original video asset that we deleted the audio description video asset from */
  videoAssetId: Scalars['ID'];
};

/** Asset video queries. */
export type AssetVideo_Queries = {
  __typename?: 'AssetVideo_Queries';
  /** Get asset video. */
  getAssetVideoByVideoId?: Maybe<AssetVideo_Video>;
};


/** Asset video queries. */
export type AssetVideo_QueriesGetAssetVideoByVideoIdArgs = {
  videoId: Scalars['String'];
};

/** Set trimming range error. */
export type AssetVideo_SetTrimmingRangeForBranchError = {
  __typename?: 'AssetVideo_SetTrimmingRangeForBranchError';
  /** TODO: Complete this description */
  message: Scalars['String'];
};

/** Set trimming range failure. */
export type AssetVideo_SetTrimmingRangeForBranchFailure = {
  __typename?: 'AssetVideo_SetTrimmingRangeForBranchFailure';
  /** TODO: Complete this description */
  errors: Array<AssetVideo_SetTrimmingRangeForBranchError>;
};

/** Set trimming range input. */
export type AssetVideo_SetTrimmingRangeForBranchInput = {
  /** The authoring course branch this trimming range applies to. */
  authoringCourseBranchId: Scalars['ID'];
  /** The ending point in ms for the trimmed video. */
  endMs: Scalars['Int'];
  /** The starting point in ms for the trimmed video. */
  startMs: Scalars['Int'];
  /** Video id. */
  videoId: Scalars['ID'];
};

/** Set trimming range result. */
export type AssetVideo_SetTrimmingRangeForBranchResult = AssetVideo_SetTrimmingRangeForBranchFailure | AssetVideo_Video;

/** A Trimming range associated with a given video asset and branch it is used in. */
export type AssetVideo_TrimmingRangesForBranches = {
  __typename?: 'AssetVideo_TrimmingRangesForBranches';
  /** The authoring course branch this trimming range applies to. */
  authoringCourseBranchId: Scalars['ID'];
  /** The ending point in ms for the trimmed video. */
  endMs: Scalars['Int'];
  /** unique identifier for the trimming range. It should be unique per assetId + branchId combination. */
  id?: Maybe<Scalars['ID']>;
  /** The starting point in ms for the trimmed video. */
  startMs: Scalars['Int'];
};

/** Video trimming ranges for branches. */
export type AssetVideo_TrimmingRangesForBranchesInput = {
  /** The authoring course branch this trimming range applies to. */
  authoringCourseBranchId: Scalars['ID'];
  /** The ending point in ms for the trimmed video. */
  endMs: Scalars['Int'];
  /** The starting point in ms for the trimmed video. */
  startMs: Scalars['Int'];
};

/** AssetVideo GraphQL schema */
export type AssetVideo_Video = {
  __typename?: 'AssetVideo_Video';
  /** Index (starts at 0) of image which is used as the poster image. Optional, uses first image if not present. */
  preferredPosterIndex?: Maybe<Scalars['Int']>;
  /**
   * Trimming ranges for this video asset across all branches it's used in. At most one trimming range can be
   * specified for an AssetVideo on a branch. The underlying storage is a map keyed on authoringCourseBranchId.
   */
  trimmingRangesForBranches?: Maybe<Array<AssetVideo_TrimmingRangesForBranches>>;
  /** Video asset id. */
  videoAssetId: Scalars['ID'];
  /** Video id. */
  videoId: Scalars['ID'];
};

/** Administrative tools for working with assignments. */
export type AssignmentAdminToolQueries = {
  __typename?: 'AssignmentAdminToolQueries';
  /**
   * For use with retool for fetching the assignment parts which is used to populate the veriifed
   * skills spreadsheet.
   *
   * This API takes the Assignment Id/Version.
   */
  verifiedSkillsAssignmentParts?: Maybe<AssignmentAdminTools_VerifiedSkillsAssignmentParts>;
  /**
   * For use with retool for fetching the assignment parts which is used to populate the veriifed
   * skills spreadsheet.
   *
   * This API takes the Atom Id/Version.
   */
  verifiedSkillsAssignmentPartsByAtomId?: Maybe<AssignmentAdminTools_VerifiedSkillsAssignmentParts>;
  /**
   * For use with retool for fetching the draft assignment parts which is used to populate the veriifed
   * skills spreadsheet.
   *
   * This API takes the Atom Id.
   */
  verifiedSkillsDraftAssignmentParts?: Maybe<AssignmentAdminTools_VerifiedSkillsAssignmentParts>;
};


/** Administrative tools for working with assignments. */
export type AssignmentAdminToolQueriesVerifiedSkillsAssignmentPartsArgs = {
  assignmentId: Scalars['ID'];
  assignmentVersion: Scalars['Int'];
};


/** Administrative tools for working with assignments. */
export type AssignmentAdminToolQueriesVerifiedSkillsAssignmentPartsByAtomIdArgs = {
  atomId: Scalars['ID'];
  atomVersion: Scalars['Int'];
};


/** Administrative tools for working with assignments. */
export type AssignmentAdminToolQueriesVerifiedSkillsDraftAssignmentPartsArgs = {
  atomId: Scalars['ID'];
};

/** An assignment part for use with verified skills */
export type AssignmentAdminTools_VerifiedSkillsAssignmentPart = {
  __typename?: 'AssignmentAdminTools_VerifiedSkillsAssignmentPart';
  /** A description of the part, typically this will be the question or rubric prompt. */
  description: Scalars['String'];
  /** Part ID. Typically a QuestionId or RubricId */
  id: Scalars['ID'];
  /** Type of part. Either Rubric or Question. */
  type: AssignmentAdminTools_VerifiedSkillsAssignmentPartType;
};

/** Type of part */
export const AssignmentAdminTools_VerifiedSkillsAssignmentPartType = {
  /** Autograded Question type */
  Question: 'Question',
  /** Rubric type */
  Rubric: 'Rubric'
} as const;

export type AssignmentAdminTools_VerifiedSkillsAssignmentPartType = typeof AssignmentAdminTools_VerifiedSkillsAssignmentPartType[keyof typeof AssignmentAdminTools_VerifiedSkillsAssignmentPartType];
/** A list of parts for the specified assignment */
export type AssignmentAdminTools_VerifiedSkillsAssignmentParts = {
  __typename?: 'AssignmentAdminTools_VerifiedSkillsAssignmentParts';
  /** Assignment ID */
  id: Scalars['ID'];
  /** List of parts */
  parts: Array<AssignmentAdminTools_VerifiedSkillsAssignmentPart>;
  /** Assignment Version */
  version: Scalars['Int'];
};

/** Apply AI grading input */
export type AssignmentAiGrading_ApplyAiGradingInput = {
  /** UserId of the AI grader */
  aiGraderId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Submission ID */
  submissionId: Scalars['ID'];
  /** Submitter ID */
  submitterId: Scalars['ID'];
  /**
   * User ID in submitter, we are using the first user in either the team or user submitter to fetch
   * the assignment presentation, so for internal use we can just pass in any UserId from the submitter
   */
  userIdInSubmitter: Scalars['ID'];
};

/** Apply AI grading response */
export type AssignmentAiGrading_ApplyAiGradingResult = {
  __typename?: 'AssignmentAiGrading_ApplyAiGradingResult';
  /** Error message if it exists */
  errorMessage?: Maybe<Scalars['String']>;
};

/** Error */
export type AssignmentAi_Error = {
  __typename?: 'AssignmentAi_Error';
  /** Error message */
  message: Scalars['String'];
};

/** OpenAI Message */
export type AssignmentAi_OpenAiMessage = {
  __typename?: 'AssignmentAi_OpenAIMessage';
  /** Content */
  content?: Maybe<Scalars['String']>;
  /** Role */
  role?: Maybe<AssignmentAi_OpenAiRole>;
};

/** OpenAI Message Input */
export type AssignmentAi_OpenAiMessage_Input = {
  /** Content */
  content?: InputMaybe<Scalars['String']>;
  /** Role */
  role?: InputMaybe<AssignmentAi_OpenAiRole>;
};

/** OpenAI Chat Roles */
export const AssignmentAi_OpenAiRole = {
  /** ASSISTANT */
  Assistant: 'ASSISTANT',
  /** SYSTEM */
  System: 'SYSTEM',
  /** USER */
  User: 'USER'
} as const;

export type AssignmentAi_OpenAiRole = typeof AssignmentAi_OpenAiRole[keyof typeof AssignmentAi_OpenAiRole];
/** Assignment AI Utility Queries */
export type AssignmentAi_Utilities_ChatV1Input = {
  /** MaxTokensForResponse */
  maxTokensForResponse?: InputMaybe<Scalars['Int']>;
  /** Messages */
  messages: Array<AssignmentAi_OpenAiMessage_Input>;
  /** The number of chat completion responses to generate */
  n?: InputMaybe<Scalars['Int']>;
  /** Temperature */
  temperature?: InputMaybe<Scalars['Float']>;
  /** TopP */
  topP?: InputMaybe<Scalars['Float']>;
};

/** Response */
export type AssignmentAi_Utilities_ChatV1Result = AssignmentAi_Utilities_ChatV1_Failure | AssignmentAi_Utilities_ChatV1_Success;

/** Failure Response */
export type AssignmentAi_Utilities_ChatV1_Failure = {
  __typename?: 'AssignmentAi_Utilities_ChatV1_Failure';
  /** Errors */
  errors: Array<AssignmentAi_Error>;
};

/** Success Response */
export type AssignmentAi_Utilities_ChatV1_Success = {
  __typename?: 'AssignmentAi_Utilities_ChatV1_Success';
  /** Message */
  message: AssignmentAi_OpenAiMessage;
};

/** Assignment Coach queries */
export type AssignmentCoachQueries = {
  __typename?: 'AssignmentCoachQueries';
  /**
   * Query to get the assignment coach inputs
   * For the initial feedback
   */
  additionalContextForInitialFeedback: AssignmentCoach_AdditionalContextForInitialFeedbackResult;
};


/** Assignment Coach queries */
export type AssignmentCoachQueriesAdditionalContextForInitialFeedbackArgs = {
  branchId: Scalars['ID'];
  itemId: Scalars['ID'];
};

/** Result when the query to fetch the additional context fails */
export type AssignmentCoach_AdditionalContextForInitialFeedbackFailure = {
  __typename?: 'AssignmentCoach_AdditionalContextForInitialFeedbackFailure';
  /** List of errors when fetching the additional context */
  errors: Array<AssignmentCoach_Error>;
};

/** Response for fetching the additional context */
export type AssignmentCoach_AdditionalContextForInitialFeedbackResult = AssignmentCoach_AdditionalContextForInitialFeedbackFailure | AssignmentCoach_AdditionalContextForInitialFeedbackSuccess;

/** Successful return type for fetching the additional context */
export type AssignmentCoach_AdditionalContextForInitialFeedbackSuccess = {
  __typename?: 'AssignmentCoach_AdditionalContextForInitialFeedbackSuccess';
  /** List of question submissions the user made to the assignment */
  questionSubmission: Array<AssignmentCoach_QuestionSubmission>;
  /** List of all the recommended items' learning objectives for the assignment */
  recommendedItems: Array<AssignmentCoach_RecommendedItemInformation>;
};

/** AssignmentCoach_Error */
export type AssignmentCoach_Error = {
  __typename?: 'AssignmentCoach_Error';
  /** Error message. */
  message: Scalars['String'];
};

/** Type of feedback */
export const AssignmentCoach_FeedbackRating = {
  /** Not Useful */
  ThumbsDown: 'THUMBS_DOWN',
  /** Useful */
  ThumbsUp: 'THUMBS_UP'
} as const;

export type AssignmentCoach_FeedbackRating = typeof AssignmentCoach_FeedbackRating[keyof typeof AssignmentCoach_FeedbackRating];
/** Question submissions the user made */
export type AssignmentCoach_QuestionSubmission = {
  __typename?: 'AssignmentCoach_QuestionSubmission';
  /** Whether it is a correct response or not */
  isCorrect: Scalars['Boolean'];
  /** Question prompt */
  questionPrompt: Scalars['String'];
  /** The response the user sent */
  response?: Maybe<Scalars['String']>;
};

/** Recommended information for a specific item */
export type AssignmentCoach_RecommendedItemInformation = {
  __typename?: 'AssignmentCoach_RecommendedItemInformation';
  /** Item id */
  itemId: Scalars['ID'];
  /** Item name */
  itemName: Scalars['String'];
  /** Generated learning objectives */
  learningObjectives: Array<Scalars['String']>;
};

/** Request for the submission of feedback */
export type AssignmentCoach_SubmitFeedbackOnSuggestionInput = {
  /** branch id */
  branchId: Scalars['ID'];
  /** Student's comment */
  comment?: InputMaybe<Scalars['String']>;
  /** feedback */
  feedbackRating: AssignmentCoach_FeedbackRating;
  /** Item id */
  itemId: Scalars['ID'];
};

/** Response for submitting feedback */
export type AssignmentCoach_SubmitFeedbackOnSuggestionResult = AssignmentCoach_Error | AssignmentCoach_SubmitFeedbackOnSuggestionSuccess;

/** Response after submitting feedback successfully */
export type AssignmentCoach_SubmitFeedbackOnSuggestionSuccess = {
  __typename?: 'AssignmentCoach_SubmitFeedbackOnSuggestionSuccess';
  /** Feedback id */
  feedbackId: Scalars['ID'];
};

/** This query returns assignment metadata tailored to course builder assignment preview */
export type AssignmentMetadataQueries = {
  __typename?: 'AssignmentMetadataQueries';
  /** This query returns assignment metadata tailored to course builder assignment preview */
  metadataByVersionedAtomId?: Maybe<AssignmentMetadata_AssignmentMetadataQueryResult>;
};


/** This query returns assignment metadata tailored to course builder assignment preview */
export type AssignmentMetadataQueriesMetadataByVersionedAtomIdArgs = {
  atomId: Scalars['ID'];
  courseId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Successful query result */
export type AssignmentMetadata_AssignmentMetadata = {
  __typename?: 'AssignmentMetadata_AssignmentMetadata';
  /** Number of questions in the assignment */
  assignmentQuestionCount: Scalars['Int'];
  /**
   * Number of attempts allowed, when this optional field is not defined, unlimited attempts are
   * allowed
   */
  attemptLimit?: Maybe<Scalars['Int']>;
  /** id of the requested assignment id, present for caching on the client */
  id: Scalars['ID'];
  /** When true: it is a Graded assignment; when false: it is a practice assignment */
  isGraded: Scalars['Boolean'];
  /**
   * Sum of questions in the question banks used in the assignment, it's undefined when no question
   * bank is used in the assignment
   */
  questionBankQuestionCount?: Maybe<Scalars['Int']>;
  /** Version number of the assignment to fetch metadata for specific assignment */
  version: Scalars['Int'];
};

/** Errors when querying for assignment metadata */
export type AssignmentMetadata_AssignmentMetadataQueryFailure = {
  __typename?: 'AssignmentMetadata_AssignmentMetadataQueryFailure';
  /** Errors encountered when determining the assignment metadata. */
  errors: Array<AssignmentMetadata_ErrorDetailsWithErrorCode>;
};

/** Query result can be a success or an error */
export type AssignmentMetadata_AssignmentMetadataQueryResult = AssignmentMetadata_AssignmentMetadata | AssignmentMetadata_AssignmentMetadataQueryFailure;

/** Types of errors */
export const AssignmentMetadata_ErrorDetailsWithErrorCode = {
  /** Thrown when querying by the downstream record ID returns error */
  AssignmentMetadataIdNotFoundError: 'AssignmentMetadata_IdNotFoundError'
} as const;

export type AssignmentMetadata_ErrorDetailsWithErrorCode = typeof AssignmentMetadata_ErrorDetailsWithErrorCode[keyof typeof AssignmentMetadata_ErrorDetailsWithErrorCode];
/** rubric-grading assignment presentations GraphQL schema */
export type AssignmentPresentationsQueries = {
  __typename?: 'AssignmentPresentationsQueries';
  /** TODO: Complete this description */
  queryForExecutionPresentation?: Maybe<AssignmentPresentations_Presentation>;
  /** TODO: Complete this description */
  queryGraderPresentation?: Maybe<AssignmentPresentations_Presentation>;
  /** TODO: Complete this description */
  queryLearnerPresentation?: Maybe<AssignmentPresentations_Presentation>;
};


/** rubric-grading assignment presentations GraphQL schema */
export type AssignmentPresentationsQueriesQueryForExecutionPresentationArgs = {
  courseId: Scalars['String'];
  executionId: Scalars['String'];
  itemId: Scalars['String'];
  userId: Scalars['String'];
};


/** rubric-grading assignment presentations GraphQL schema */
export type AssignmentPresentationsQueriesQueryGraderPresentationArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  userId: Scalars['String'];
};


/** rubric-grading assignment presentations GraphQL schema */
export type AssignmentPresentationsQueriesQueryLearnerPresentationArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  userId: Scalars['String'];
};

/** TODO: Complete this description */
export const AssignmentPresentations_AllowedUrlType = {
  /** TODO: Complete this description */
  All: 'All',
  /** TODO: Complete this description */
  StandardAudio: 'StandardAudio',
  /** TODO: Complete this description */
  StandardVideo: 'StandardVideo'
} as const;

export type AssignmentPresentations_AllowedUrlType = typeof AssignmentPresentations_AllowedUrlType[keyof typeof AssignmentPresentations_AllowedUrlType];
/**
 * Modeled after AwardFullCredit courier model.
 * Award full credit regardless the response.
 */
export type AssignmentPresentations_AwardFullCredit = {
  __typename?: 'AssignmentPresentations_AwardFullCredit';
  /** always set to awardFullCredit */
  courierTypeName: AssignmentPresentations_MachineEvaluationOverrideCourierTypeName;
};

/** TODO: Complete this description */
export const AssignmentPresentations_BaseTaskId = {
  /** TODO: Complete this description */
  AutoGradedEvaluation: 'AUTO_GRADED_EVALUATION',
  /** TODO: Complete this description */
  GitInitialization: 'GIT_INITIALIZATION',
  /** TODO: Complete this description */
  GitSubmission: 'GIT_SUBMISSION',
  /** TODO: Complete this description */
  GradeRelease: 'GRADE_RELEASE',
  /** TODO: Complete this description */
  MachineEvaluableVariantSelection: 'MACHINE_EVALUABLE_VARIANT_SELECTION',
  /** TODO: Complete this description */
  MachineEvaluationOverride: 'MACHINE_EVALUATION_OVERRIDE',
  /** TODO: Complete this description */
  PeerReview: 'PEER_REVIEW',
  /** TODO: Complete this description */
  PeerReviewAllocation: 'PEER_REVIEW_ALLOCATION',
  /** TODO: Complete this description */
  StaffEvaluation: 'STAFF_EVALUATION',
  /** TODO: Complete this description */
  SubmitterSubmission: 'SUBMITTER_SUBMISSION',
  /** TODO: Complete this description */
  SubmitterViewEvaluation: 'SUBMITTER_VIEW_EVALUATION'
} as const;

export type AssignmentPresentations_BaseTaskId = typeof AssignmentPresentations_BaseTaskId[keyof typeof AssignmentPresentations_BaseTaskId];
/** Modeled after org.coursera.assignment.assemblerfixes.Content courier model */
export type AssignmentPresentations_Content = AssignmentPresentations_ContentCmlContent | AssignmentPresentations_ContentHtmlContent;

/** TODO: Complete this description */
export type AssignmentPresentations_ContentCmlContent = {
  __typename?: 'AssignmentPresentations_ContentCmlContent';
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Always cmlContent */
  courierTypeName: AssignmentPresentations_ContentTypeName;
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['String'];
  /** directly renderable html with metadata payload */
  htmlWithMetadata: CmlHtmlWithMetadata;
};

/** TODO: Complete this description */
export type AssignmentPresentations_ContentHtmlContent = {
  __typename?: 'AssignmentPresentations_ContentHtmlContent';
  /** Always htmlContent */
  courierTypeName: AssignmentPresentations_ContentTypeName;
  /** representation of rich-text content in html format */
  html: Scalars['String'];
};

/** TODO: Complete this description */
export const AssignmentPresentations_ContentTypeName = {
  /** TODO: Complete this description */
  CmlContent: 'cmlContent',
  /** TODO: Complete this description */
  HtmlContent: 'htmlContent'
} as const;

export type AssignmentPresentations_ContentTypeName = typeof AssignmentPresentations_ContentTypeName[keyof typeof AssignmentPresentations_ContentTypeName];
/** Modeled after DetailLevel.courier */
export const AssignmentPresentations_DetailLevel = {
  /** All information about the question necessary for responding to it. */
  Full: 'Full',
  /** No information about the question. */
  NoDetails: 'NoDetails',
  /**
   * Enough information about the question to let the learner know what it is, but not enough
   * to respond to it. For example, `Partial` for multiple choice questions includes the prompt
   * but none of the options.
   */
  Partial: 'Partial'
} as const;

export type AssignmentPresentations_DetailLevel = typeof AssignmentPresentations_DetailLevel[keyof typeof AssignmentPresentations_DetailLevel];
/** Modeled after feedback courier model. */
export type AssignmentPresentations_Feedback = {
  __typename?: 'AssignmentPresentations_Feedback';
  /** definition field represents AnyData. */
  definition: Scalars['String'];
  /** FeedbackLevel field could be NoFeedback, Graded or Explained. */
  feedbackLevel: AssignmentPresentations_FeedbackLevel;
};

/** Modeled after FeedbackLevel.courier model. */
export const AssignmentPresentations_FeedbackLevel = {
  /** All relevant instructor-specified explanations. */
  Explained: 'Explained',
  /** Feedback about correctness but nothing else. */
  Graded: 'Graded',
  /** No feedback. */
  NoFeedback: 'NoFeedback'
} as const;

export type AssignmentPresentations_FeedbackLevel = typeof AssignmentPresentations_FeedbackLevel[keyof typeof AssignmentPresentations_FeedbackLevel];
/**
 * Modeled after FormElement.courier
 *
 * Union representing the different kinds of form elements
 */
export type AssignmentPresentations_FormElement = AssignmentPresentations_FormElementAutoGradedResponseElement | AssignmentPresentations_FormElementPromptRequiringResponseElement | AssignmentPresentations_FormElementPromptWithResponseElement;

/** Modeled after AutoGradedResponse courier model. */
export type AssignmentPresentations_FormElementAutoGradedResponseElement = {
  __typename?: 'AssignmentPresentations_FormElementAutoGradedResponseElement';
  /** always set to autoGradedResponseElement */
  courierTypeName: AssignmentPresentations_FormElementCourierTypeName;
  /** A score in which the points may not be awarded, will contain points and maxPoints. */
  score?: Maybe<AssignmentPresentations_Score>;
  /**
   * Machine evaluation will contain the following fields: question, feedback, effective response,
   * weighted scoring.
   */
  value: AssignmentPresentations_MachineEvaluation;
};

/** Modeled after the typedDefinition aliases in FormElement.courier */
export const AssignmentPresentations_FormElementCourierTypeName = {
  /** TODO: Complete this description */
  AutoGradedResponseElement: 'autoGradedResponseElement',
  /** TODO: Complete this description */
  GitRepositoryPromptElement: 'gitRepositoryPromptElement',
  /** TODO: Complete this description */
  InstructionsElement: 'instructionsElement',
  /** TODO: Complete this description */
  InstructionsWithReviewCriteriaElement: 'instructionsWithReviewCriteriaElement',
  /** TODO: Complete this description */
  PromptRequiringResponseElement: 'promptRequiringResponseElement',
  /** TODO: Complete this description */
  PromptWithMultipleResponsesElement: 'promptWithMultipleResponsesElement',
  /** TODO: Complete this description */
  PromptWithResponseElement: 'promptWithResponseElement',
  /** TODO: Complete this description */
  PromptWithoutResponseElement: 'promptWithoutResponseElement'
} as const;

export type AssignmentPresentations_FormElementCourierTypeName = typeof AssignmentPresentations_FormElementCourierTypeName[keyof typeof AssignmentPresentations_FormElementCourierTypeName];
/**
 * Modeled after FormElementNode.courier
 *
 * Primarily used to represent individual question prompts and responses or rubric
 * prompts and responses. Recursively defined, but typically the element is the prompt and the
 * children are the responses.
 *
 * Note: only the parts relevant to SGA grading our represented here.
 */
export type AssignmentPresentations_FormElementNode = {
  __typename?: 'AssignmentPresentations_FormElementNode';
  /** TODO: Complete this description */
  children: Array<AssignmentPresentations_FormElementNode>;
  /** TODO: Complete this description */
  element: AssignmentPresentations_FormElement;
};

/**
 * Modeled after PromptRequiringResponseElement courier model
 *
 * A prompt with the desired response ID. When this is provided as part of the step part
 * definition, this means that the actor should be providing the response.
 */
export type AssignmentPresentations_FormElementPromptRequiringResponseElement = {
  __typename?: 'AssignmentPresentations_FormElementPromptRequiringResponseElement';
  /** always set to promptRequiringResponseElement. */
  courierTypeName: AssignmentPresentations_FormElementCourierTypeName;
  /** represents the prompt for user input (typically a submission or rubric question) */
  prompt: AssignmentPresentations_Prompt;
  /** union type representing the response object specific to different types of prompts */
  response: AssignmentPresentations_Response;
  /** opaque value identifying the response. */
  responseId: Scalars['ID'];
  /** [optional] maximum and awarded score for form element */
  score?: Maybe<AssignmentPresentations_Score>;
};

/**
 * Modeled after PromptWithResponseElement.courier
 *
 * A prompt with the provided response. This means that this prompt has already been answered and
 * does not require a response.
 */
export type AssignmentPresentations_FormElementPromptWithResponseElement = {
  __typename?: 'AssignmentPresentations_FormElementPromptWithResponseElement';
  /** always set to promptWithResponseElement. */
  courierTypeName: AssignmentPresentations_FormElementCourierTypeName;
  /** represents the prompt for user input (typically a submission or rubric question) */
  prompt: AssignmentPresentations_Prompt;
  /** union type representing the response object specific to different types of prompts */
  response: AssignmentPresentations_Response;
  /** opaque value identifying the response. */
  responseId: Scalars['ID'];
  /** [optional] who created the response and when */
  responseMetadata?: Maybe<AssignmentPresentations_ResponseMetadata>;
  /** [optional] maximum and awarded score for form element */
  score?: Maybe<AssignmentPresentations_Score>;
};

/** TODO: Complete this description */
export type AssignmentPresentations_FormTask = {
  __typename?: 'AssignmentPresentations_FormTask';
  /** TODO: Complete this description */
  executionId?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  submittedAt?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  taskIdHash: Scalars['String'];
  /** TODO: Complete this description */
  updatedAt?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  updatedBy?: Maybe<Scalars['Int']>;
};

/** TODO: Complete this description */
export type AssignmentPresentations_GraderActionInstance = {
  __typename?: 'AssignmentPresentations_GraderActionInstance';
  /** TODO: Complete this description */
  actionTime: Timestamp;
  /** TODO: Complete this description */
  actorName?: Maybe<Scalars['String']>;
};

/**
 * Used to describe the question or review to indicate the type of grader.
 * When used in the prompt, signifies the default grader type that should be used to grade said prompt.
 */
export const AssignmentPresentations_GraderType = {
  /** AI Graded */
  Ai: 'AI',
  /** Auto graded questions */
  Auto: 'AUTO',
  /** Human Graded */
  Human: 'HUMAN'
} as const;

export type AssignmentPresentations_GraderType = typeof AssignmentPresentations_GraderType[keyof typeof AssignmentPresentations_GraderType];
/**
 * Modeled after MachineEvaluableQuestion.courier
 * Leaving only one field right now to be conform with quiz models, we can add more to this model
 * after we get rid of quiz session for assignment platform
 */
export type AssignmentPresentations_MachineEvaluableQuestion = {
  __typename?: 'AssignmentPresentations_MachineEvaluableQuestion';
  /** Question type field. */
  type: Scalars['String'];
};

/** Modeled after MachineEvaluation.courier */
export type AssignmentPresentations_MachineEvaluation = {
  __typename?: 'AssignmentPresentations_MachineEvaluation';
  /** ResponseContainer field. */
  effectiveResponse: AssignmentPresentations_ResponseContainer;
  /** [optional] MachineEvaluationOverride could be regrade or awardFullCredit. */
  evaluationOverride?: Maybe<AssignmentPresentations_MachineEvaluationOverride>;
  /** Feedback field. */
  feedback: AssignmentPresentations_Feedback;
  /** QuestionInternalId */
  id: Scalars['ID'];
  /** Represents whether submitted is allowed. */
  isSubmitAllowed: Scalars['Boolean'];
  /** MachineEvaluableQuestion field. */
  question: AssignmentPresentations_MachineEvaluableQuestion;
  /** MachineEvaluableQuestionKey */
  questionGroupId: Scalars['ID'];
  /**
   * StudentVariant field,
   * Assignment version of [[org.coursera.assess.framework.question.StudentVariant]]
   */
  variant: AssignmentPresentations_StudentVariant;
  /** WeightScoring field for a single question and response pair. */
  weightedScoring: AssignmentPresentations_WeightedScoring;
};

/** Modeled after MachineEvaluation.courier */
export type AssignmentPresentations_MachineEvaluationOverride = AssignmentPresentations_AwardFullCredit | AssignmentPresentations_Regrade;

/** Modeled after typedDefinition alias in MachineEvaluationOverride.courier */
export const AssignmentPresentations_MachineEvaluationOverrideCourierTypeName = {
  /** Award full credit regardless the response. */
  AwardFullCredit: 'AwardFullCredit',
  /**
   * Regrade response with a provided questionId. If questions are compatible, we will evaluate with
   * new question. We accept previously correct answer if `acceptPreviouslyCorrectAnswer` is set to
   * true. If questions are incompatible, we will always use original question of evaluate.
   */
  Regrade: 'Regrade'
} as const;

export type AssignmentPresentations_MachineEvaluationOverrideCourierTypeName = typeof AssignmentPresentations_MachineEvaluationOverrideCourierTypeName[keyof typeof AssignmentPresentations_MachineEvaluationOverrideCourierTypeName];
/**
 * Modeled after MaxScore.courier
 * A temporary data model to show maxScore in a nested fashion when jsonified to keep compatibility,
 * we should move it to MachineEvaluablePrompt after we change it on the FE.
 */
export type AssignmentPresentations_MaxScore = {
  __typename?: 'AssignmentPresentations_MaxScore';
  /** maxScore field. */
  maxScore: Scalars['Float'];
};

/** Modeled after OptionsOption.courier */
export type AssignmentPresentations_OptionsOption = {
  __typename?: 'AssignmentPresentations_OptionsOption';
  /** Display content */
  display: AssignmentPresentations_Content;
  /** Options option id */
  id: Scalars['ID'];
  /** [optional] point */
  points?: Maybe<Scalars['Float']>;
};

/** TODO: Complete this description */
export type AssignmentPresentations_Phase = AssignmentPresentations_ReviewPhaseMember | AssignmentPresentations_SingleFormPhaseMember;

/**
 * Modeled after PlagiarismConfig.courier
 *
 * Used to configure similarity check functionality on/off in UI.
 */
export type AssignmentPresentations_PlagiarismConfig = {
  __typename?: 'AssignmentPresentations_PlagiarismConfig';
  /** TODO: Complete this description */
  plagiarismCheckEnable: Scalars['Boolean'];
};

/** TODO: Complete this description */
export type AssignmentPresentations_Presentation = {
  __typename?: 'AssignmentPresentations_Presentation';
  /** TODO: Complete this description */
  grade?: Maybe<AssignmentPresentations_ProvisionalGrade>;
  /** TODO: Complete this description */
  latestGraderAction?: Maybe<AssignmentPresentations_GraderActionInstance>;
  /** TODO: Complete this description */
  phases: Array<AssignmentPresentations_Phase>;
  /** TODO: Complete this description */
  submissionStatus: AssignmentPresentations_SubmissionStatus;
};

/**
 * Modeled after Prompt.courier
 *
 * Union representing the different types of prompts represented in our presentation model. These
 * are generally manually-graded "submission" prompts, their associated staff "review" prompts, and
 * auto-graded "machine-evaluable" prompts.
 */
export type AssignmentPresentations_Prompt = AssignmentPresentations_PromptAutoGradablePrompt | AssignmentPresentations_PromptReviewPrompt | AssignmentPresentations_PromptSubmissionPrompt;

/**
 * Modeled after AutoGradablePrompt.courier model.
 * A quiz question as defined by the assess model.
 */
export type AssignmentPresentations_PromptAutoGradablePrompt = {
  __typename?: 'AssignmentPresentations_PromptAutoGradablePrompt';
  /** Always set to autoGradablePrompt */
  courierTypeName: AssignmentPresentations_PromptTypeName;
  /** MachineEvaluablePrompt field */
  value: AssignmentPresentations_PromptMachineEvaluablePrompt;
};

/** Modeled after MachineEvaluablePrompt.courier. */
export type AssignmentPresentations_PromptMachineEvaluablePrompt = {
  __typename?: 'AssignmentPresentations_PromptMachineEvaluablePrompt';
  /** Always set to machineEvaluablePrompt */
  courierTypeName: AssignmentPresentations_PromptTypeName;
  /** QuestionInternalId */
  id: Scalars['ID'];
  /** MachineEvaluableQuestion will contain type field. */
  question: AssignmentPresentations_MachineEvaluableQuestion;
  /** MachineEvaluableQuestionKey */
  questionGroupId: Scalars['String'];
  /** Student variant field. */
  variant: AssignmentPresentations_StudentVariant;
  /** WeightedScoring field will contain max score value. */
  weightedScoring: AssignmentPresentations_MaxScore;
};

/** Modeled after ReviewPrompt */
export type AssignmentPresentations_PromptReviewPrompt = {
  __typename?: 'AssignmentPresentations_PromptReviewPrompt';
  /** always set to reviewPrompt. */
  courierTypeName: AssignmentPresentations_PromptTypeName;
  /** Type of grader for this review prompt */
  graderType: AssignmentPresentations_GraderType;
  /** Review prompt identification. */
  id: Scalars['ID'];
  /** Prompt content. */
  promptContent: AssignmentPresentations_Content;
  /** Review part schema details. */
  reviewPartSchemaDetails: AssignmentPresentations_ReviewPartSchemaDetails;
  /** [optional] Submission part Id. */
  submissionPartId?: Maybe<Scalars['ID']>;
};

/**
 * Modeled after SubmissionPrompt.courier
 *
 * Used to represent the prompt learners see for for manually-graded questions. This also comes in
 * different types (see AssignmentPresentations_SubmissionPartSchemaDetails).
 */
export type AssignmentPresentations_PromptSubmissionPrompt = {
  __typename?: 'AssignmentPresentations_PromptSubmissionPrompt';
  /** always set to submissionPrompt. */
  courierTypeName: AssignmentPresentations_PromptTypeName;
  /** Type of grader for this submission prompt */
  graderType: AssignmentPresentations_GraderType;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  plagiarismConfig?: Maybe<AssignmentPresentations_PlagiarismConfig>;
  /** TODO: Complete this description */
  promptContent: AssignmentPresentations_Content;
  /** TODO: Complete this description */
  submissionPartSchemaDetails: AssignmentPresentations_SubmissionPartSchemaDetails;
};

/**
 * Modeled after @typedDefinition aliases Prompt.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_PromptTypeName = {
  /** TODO: Complete this description */
  AutoGradablePrompt: 'autoGradablePrompt',
  /** TODO: Complete this description */
  MachineEvaluablePrompt: 'machineEvaluablePrompt',
  /** TODO: Complete this description */
  ReviewPrompt: 'reviewPrompt',
  /** TODO: Complete this description */
  SubmissionPrompt: 'submissionPrompt',
  /** TODO: Complete this description */
  TitlePrompt: 'titlePrompt'
} as const;

export type AssignmentPresentations_PromptTypeName = typeof AssignmentPresentations_PromptTypeName[keyof typeof AssignmentPresentations_PromptTypeName];
/** TODO: Complete this description */
export type AssignmentPresentations_ProvisionalGrade = {
  __typename?: 'AssignmentPresentations_ProvisionalGrade';
  /** TODO: Complete this description */
  gradeReleasedAt?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  isPassed?: Maybe<Scalars['Boolean']>;
  /** TODO: Complete this description */
  maxScore?: Maybe<Scalars['Float']>;
  /** TODO: Complete this description */
  passingFraction: Scalars['Float'];
  /** TODO: Complete this description */
  rawScore?: Maybe<Scalars['Float']>;
};

/** Modeled after regard courier model. */
export type AssignmentPresentations_Regrade = {
  __typename?: 'AssignmentPresentations_Regrade';
  /** Whether the previously correct answer is accepted or not. */
  acceptPreviouslyCorrectAnswer: Scalars['Boolean'];
  /** always set to regard */
  courierTypeName: AssignmentPresentations_MachineEvaluationOverrideCourierTypeName;
  /** VersionedQuestionId */
  targetQuestionId: Scalars['ID'];
};

/**
 * Modeled after Response.courier
 *
 * Union representing the responses for different parts of assignment flow.
 */
export type AssignmentPresentations_Response = AssignmentPresentations_ResponseAutoGradableResponse | AssignmentPresentations_ResponseReviewResponse | AssignmentPresentations_ResponseSubmissionResponse;

/**
 * Modeled after AutoGradableResponse.courier.
 * A quiz question response as defined by the assess system.
 */
export type AssignmentPresentations_ResponseAutoGradableResponse = {
  __typename?: 'AssignmentPresentations_ResponseAutoGradableResponse';
  /** Always set to autoGradableResponse */
  courierTypeName: AssignmentPresentations_ResponseTypeName;
  /** AnyData */
  value: Scalars['String'];
};

/** Modeled after ResponseContainer */
export type AssignmentPresentations_ResponseContainer = {
  __typename?: 'AssignmentPresentations_ResponseContainer';
  /** QuestionInternalId */
  questionInstance: Scalars['ID'];
  /** Response field represents AnyData. */
  response: Scalars['String'];
};

/**
 * Modeled after ResponseMetadata.courier
 *
 * Represents maximum points possible and, if already graded, the points awarded.
 *
 * Note: There are optional submitterProfile and profile fields in the courier model. We may not need
 * these. We can add them later if we do.
 */
export type AssignmentPresentations_ResponseMetadata = {
  __typename?: 'AssignmentPresentations_ResponseMetadata';
  /** milliseconds from epoch when response was created */
  createdAt: Scalars['Int'];
  /** [optional] If present, user who created response. If absent, likely system generated. */
  createdBy?: Maybe<Scalars['ID']>;
};

/** Modeled after ReviewResponse.courier */
export type AssignmentPresentations_ResponseReviewResponse = {
  __typename?: 'AssignmentPresentations_ResponseReviewResponse';
  /** SuggestionId of the AI review if this part was graded by AI */
  aiSuggestionId?: Maybe<Scalars['ID']>;
  /** Always set to reviewResponse */
  courierTypeName: AssignmentPresentations_ResponseTypeName;
  /** Type of grader for this review response */
  graderType: AssignmentPresentations_GraderType;
  /** Review part response. */
  reviewPart: AssignmentPresentations_ReviewPart;
};

/**
 * Modeled after SubmissionResponse.courier
 *
 * A manually graded question response (as defined within the project model used by staff graded
 * assessments).
 */
export type AssignmentPresentations_ResponseSubmissionResponse = {
  __typename?: 'AssignmentPresentations_ResponseSubmissionResponse';
  /** Always set to submissionResponse */
  courierTypeName: AssignmentPresentations_ResponseTypeName;
  /** Union type representing submission data specific to different question formats. */
  submissionPartResponse: AssignmentPresentations_SubmissionPartResponse;
};

/**
 * Modeled after @typedDefinition aliases Response.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_ResponseTypeName = {
  /** TODO: Complete this description */
  AutoGradableResponse: 'autoGradableResponse',
  /** TODO: Complete this description */
  MachineEvaluableResponse: 'machineEvaluableResponse',
  /** TODO: Complete this description */
  ReviewResponse: 'reviewResponse',
  /** TODO: Complete this description */
  SubmissionResponse: 'submissionResponse',
  /** TODO: Complete this description */
  TitleResponse: 'titleResponse'
} as const;

export type AssignmentPresentations_ResponseTypeName = typeof AssignmentPresentations_ResponseTypeName[keyof typeof AssignmentPresentations_ResponseTypeName];
/** Modeled after ReviewPart.courier */
export type AssignmentPresentations_ReviewPart = AssignmentPresentations_ReviewPartBoxViewDocumentAnnotation | AssignmentPresentations_ReviewPartMultiLineInput | AssignmentPresentations_ReviewPartOptions | AssignmentPresentations_ReviewPartSingleLineInput | AssignmentPresentations_ReviewPartYesNo;

/**
 * Modeled after BoxViewDocumentAnnotation courier model
 * Used to represent the response for BoxViewDocumentAnnotation review part.
 */
export type AssignmentPresentations_ReviewPartBoxViewDocumentAnnotation = {
  __typename?: 'AssignmentPresentations_ReviewPartBoxViewDocumentAnnotation';
  /** If annotation is completed */
  annotationComplete: Scalars['Boolean'];
  /** Always set to boxViewDocumentAnnotation */
  courierTypeName: AssignmentPresentations_ReviewPartTypeName;
  /** File id */
  fileId: Scalars['ID'];
};

/**
 * Modeled after MultiLineInput courier model.
 * Used to represent the response for MultilineInput review part.
 */
export type AssignmentPresentations_ReviewPartMultiLineInput = {
  __typename?: 'AssignmentPresentations_ReviewPartMultiLineInput';
  /** Always set to multiLineInput */
  courierTypeName: AssignmentPresentations_ReviewPartTypeName;
  /** [optional] multiline input */
  input?: Maybe<Scalars['String']>;
  /**
   * [optional] rich text input
   * This field is replacing plain text input field.
   */
  richTextInput?: Maybe<AssignmentPresentations_ContentCmlContent>;
  /** [optional] score */
  score?: Maybe<Scalars['Float']>;
};

/**
 * Modeled after Options courier model.
 * Used to represent the response for Options review part.
 */
export type AssignmentPresentations_ReviewPartOptions = {
  __typename?: 'AssignmentPresentations_ReviewPartOptions';
  /** Always set to options */
  courierTypeName: AssignmentPresentations_ReviewPartTypeName;
  /** option id */
  optionChoice?: Maybe<Scalars['ID']>;
  /** [optional] rich text input */
  richTextInput?: Maybe<AssignmentPresentations_ContentCmlContent>;
};

/** Modeled after ReviewPartSchemaDetails.courier */
export type AssignmentPresentations_ReviewPartSchemaDetails = AssignmentPresentations_ReviewPartSchemaDetailsBoxViewDocumentAnnotationReviewSchema | AssignmentPresentations_ReviewPartSchemaDetailsMultiLineInputReviewSchema | AssignmentPresentations_ReviewPartSchemaDetailsOptionsReviewSchema | AssignmentPresentations_ReviewPartSchemaDetailsSingleLineInputReviewSchema | AssignmentPresentations_ReviewPartSchemaDetailsYesNoReviewSchema;

/** Modeled after boxViewDocumentAnnotationReviewSchema courier model */
export type AssignmentPresentations_ReviewPartSchemaDetailsBoxViewDocumentAnnotationReviewSchema = {
  __typename?: 'AssignmentPresentations_ReviewPartSchemaDetailsBoxViewDocumentAnnotationReviewSchema';
  /** always set to boxViewDocumentAnnotationReviewSchema. */
  courierTypeName: AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName;
};

/** Modeled after @typeDefinition aliases ReviewPartSchemaDetails.courier */
export const AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName = {
  /** Box view document annotation review schema */
  BoxViewDocumentAnnotationReviewSchema: 'boxViewDocumentAnnotationReviewSchema',
  /** Multiline input review schema */
  MultiLineInputReviewSchema: 'multiLineInputReviewSchema',
  /** Options review schema */
  OptionsReviewSchema: 'optionsReviewSchema',
  /** Single line input review schema */
  SingleLineInputReviewSchema: 'singleLineInputReviewSchema',
  /** YesNo review schema */
  YesNoReviewSchema: 'yesNoReviewSchema'
} as const;

export type AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName = typeof AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName[keyof typeof AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName];
/** Modeled after MultiLineReviewSchema courier model */
export type AssignmentPresentations_ReviewPartSchemaDetailsMultiLineInputReviewSchema = {
  __typename?: 'AssignmentPresentations_ReviewPartSchemaDetailsMultiLineInputReviewSchema';
  /** always set to multiLineInputReviewSchema. */
  courierTypeName: AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName;
  /** If present, review part is graded. */
  points?: Maybe<Scalars['Float']>;
};

/** Modeled after OptionsReviewSchema.courier */
export type AssignmentPresentations_ReviewPartSchemaDetailsOptionsReviewSchema = {
  __typename?: 'AssignmentPresentations_ReviewPartSchemaDetailsOptionsReviewSchema';
  /** always set to optionsReviewSchema. */
  courierTypeName: AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName;
  /** If it is scored. */
  isScored: Scalars['Boolean'];
  /** list of options. */
  options: Array<AssignmentPresentations_OptionsOption>;
};

/** Modeled after singleLineInputReviewSchema courier model */
export type AssignmentPresentations_ReviewPartSchemaDetailsSingleLineInputReviewSchema = {
  __typename?: 'AssignmentPresentations_ReviewPartSchemaDetailsSingleLineInputReviewSchema';
  /** always set to singleLineInputReviewSchema. */
  courierTypeName: AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName;
};

/** Modeled after yesNoReviewSchema courier model */
export type AssignmentPresentations_ReviewPartSchemaDetailsYesNoReviewSchema = {
  __typename?: 'AssignmentPresentations_ReviewPartSchemaDetailsYesNoReviewSchema';
  /** always set to yesNoReviewSchema. */
  courierTypeName: AssignmentPresentations_ReviewPartSchemaDetailsCourierTypeName;
  /** [optional]If present, review part is graded. */
  points?: Maybe<AssignmentPresentations_YesNoPoints>;
};

/**
 * Modeled after SingleLineInput courier model.
 * Used to represent the response for SingleLineInput review part.
 */
export type AssignmentPresentations_ReviewPartSingleLineInput = {
  __typename?: 'AssignmentPresentations_ReviewPartSingleLineInput';
  /** Always set to singleLineInput */
  courierTypeName: AssignmentPresentations_ReviewPartTypeName;
  /** [optional] single line input. */
  input?: Maybe<Scalars['String']>;
};

/** Modeled after @typedDefinition aliases ReviewPart.courier */
export const AssignmentPresentations_ReviewPartTypeName = {
  /** BoxViewDocumentAnnotation review part. */
  BoxViewDocumentAnnotation: 'boxViewDocumentAnnotation',
  /** Multiline input review part. */
  MultiLineInput: 'multiLineInput',
  /** Options review part. */
  Options: 'options',
  /** SingleLine input review part. */
  SingleLineInput: 'singleLineInput',
  /** YesNo review part. */
  YesNo: 'yesNo'
} as const;

export type AssignmentPresentations_ReviewPartTypeName = typeof AssignmentPresentations_ReviewPartTypeName[keyof typeof AssignmentPresentations_ReviewPartTypeName];
/**
 * Modeled after YesNo courier model
 * Used to represent the response for YesNo review part.
 */
export type AssignmentPresentations_ReviewPartYesNo = {
  __typename?: 'AssignmentPresentations_ReviewPartYesNo';
  /** Always set to yesNo */
  courierTypeName: AssignmentPresentations_ReviewPartTypeName;
  /** [optional] explanation field */
  explanation?: Maybe<Scalars['String']>;
  /** [optional] Yes or No choice */
  yesNoChoice?: Maybe<AssignmentPresentations_YesNoChoice>;
};

/** TODO: Complete this description */
export type AssignmentPresentations_ReviewPhase = {
  __typename?: 'AssignmentPresentations_ReviewPhase';
  /** TODO: Complete this description */
  baseTaskId: AssignmentPresentations_BaseTaskId;
  /** TODO: Complete this description */
  deadline?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  givenReviewCount: Scalars['Int'];
  /** TODO: Complete this description */
  receivedReviewCount: Scalars['Int'];
  /** TODO: Complete this description */
  requiredReviewsToGive: Scalars['Int'];
  /** TODO: Complete this description */
  requiredReviewsToReceive: Scalars['Int'];
};

/** TODO: Complete this description */
export type AssignmentPresentations_ReviewPhaseMember = {
  __typename?: 'AssignmentPresentations_ReviewPhaseMember';
  /** TODO: Complete this description */
  reviewPhase: AssignmentPresentations_ReviewPhase;
};

/**
 * Modeled after Score.courier
 *
 * Represents maximum points possible and, if already graded, the points awarded.
 */
export type AssignmentPresentations_Score = {
  __typename?: 'AssignmentPresentations_Score';
  /** maximum possible points. note this is a soft limit in light of extra credit. */
  maxPoints: Scalars['Float'];
  /** [optional] points awarded */
  points?: Maybe<Scalars['Float']>;
};

/** TODO: Complete this description */
export type AssignmentPresentations_SingleFormPhase = {
  __typename?: 'AssignmentPresentations_SingleFormPhase';
  /** TODO: Complete this description */
  baseTaskId: AssignmentPresentations_BaseTaskId;
  /** TODO: Complete this description */
  deadline?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  fulfilled: Scalars['Boolean'];
  /** TODO: Complete this description */
  isInteractive: Scalars['Boolean'];
  /** TODO: Complete this description */
  task: AssignmentPresentations_FormTask;
};

/** TODO: Complete this description */
export type AssignmentPresentations_SingleFormPhaseMember = {
  __typename?: 'AssignmentPresentations_SingleFormPhaseMember';
  /** TODO: Complete this description */
  singleFormPhase: AssignmentPresentations_SingleFormPhase;
};

/**
 * Modeled after StudentVariant.courier model
 * Assignment version of [[org.coursera.assess.framework.question.StudentVariant]]
 */
export type AssignmentPresentations_StudentVariant = {
  __typename?: 'AssignmentPresentations_StudentVariant';
  /** AnyData */
  definition: Scalars['String'];
  /** Represents the information level about the question. NoDetails, Partial or Full. */
  detailLevel: AssignmentPresentations_DetailLevel;
};

/**
 * Modeled after SubmissionPartResponse.courier
 *
 * Union representing the responses for different types of manually graded submission parts.
 */
export type AssignmentPresentations_SubmissionPartResponse = AssignmentPresentations_SubmissionPartResponseFileUploadResponse | AssignmentPresentations_SubmissionPartResponseOffPlatformResponse | AssignmentPresentations_SubmissionPartResponsePlainTextResponse | AssignmentPresentations_SubmissionPartResponseRichTextResponse | AssignmentPresentations_SubmissionPartResponseUrlResponse;

/**
 * Modeled after FileUploadSubmissionPartResponse.courier
 *
 * Used to represent the response for file upload submission parts.
 */
export type AssignmentPresentations_SubmissionPartResponseFileUploadResponse = {
  __typename?: 'AssignmentPresentations_SubmissionPartResponseFileUploadResponse';
  /** Mandatory caption for submission part. */
  caption: Scalars['String'];
  /** Always set to fileUploadResponse */
  courierTypeName: AssignmentPresentations_SubmissionPartResponseTypeName;
  /** URL of where uploaded file is hosted. */
  fileUrl: Scalars['String'];
  /** Mandatory title of submission part. May not match file name. */
  title: Scalars['String'];
};

/**
 * Modeled after OffPlatformPartResponse.courier
 *
 * Used to represent the response for off-platform submission parts. This doesn't carry any actual
 * information but it is a placeholder that is expected by the system.
 */
export type AssignmentPresentations_SubmissionPartResponseOffPlatformResponse = {
  __typename?: 'AssignmentPresentations_SubmissionPartResponseOffPlatformResponse';
  /** Always set to offPlatformResponse */
  courierTypeName: AssignmentPresentations_SubmissionPartResponseTypeName;
};

/**
 * Modeled after PlainTextSubmissionPartResponse.courier
 *
 * Used to represent the response for plain text submission parts.
 */
export type AssignmentPresentations_SubmissionPartResponsePlainTextResponse = {
  __typename?: 'AssignmentPresentations_SubmissionPartResponsePlainTextResponse';
  /** Always set to plainTextResponse */
  courierTypeName: AssignmentPresentations_SubmissionPartResponseTypeName;
  /** Response in plain text format. */
  plainText: Scalars['String'];
};

/**
 * Modeled after RichTextSubmissionPartResponse.courier
 *
 * Used to represent the response for rich text submission parts.
 */
export type AssignmentPresentations_SubmissionPartResponseRichTextResponse = {
  __typename?: 'AssignmentPresentations_SubmissionPartResponseRichTextResponse';
  /** Always set to richTextResponse */
  courierTypeName: AssignmentPresentations_SubmissionPartResponseTypeName;
  /** Response in CML format. */
  richText: AssignmentPresentations_Content;
};

/**
 * Modeled after @typedDefinition aliases SubmissionPartResponse.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_SubmissionPartResponseTypeName = {
  /** TODO: Complete this description */
  FileUploadResponse: 'fileUploadResponse',
  /** TODO: Complete this description */
  OffPlatformResponse: 'offPlatformResponse',
  /** TODO: Complete this description */
  PlainTextResponse: 'plainTextResponse',
  /** TODO: Complete this description */
  RichTextResponse: 'richTextResponse',
  /** TODO: Complete this description */
  UrlResponse: 'urlResponse'
} as const;

export type AssignmentPresentations_SubmissionPartResponseTypeName = typeof AssignmentPresentations_SubmissionPartResponseTypeName[keyof typeof AssignmentPresentations_SubmissionPartResponseTypeName];
/**
 * Modeled after UrlSubmissionPartResponse.courier
 *
 * Used to represent the response for url submission parts.
 */
export type AssignmentPresentations_SubmissionPartResponseUrlResponse = {
  __typename?: 'AssignmentPresentations_SubmissionPartResponseUrlResponse';
  /** Mandatory caption for submission part. */
  caption: Scalars['String'];
  /** Always set to urlResponse */
  courierTypeName: AssignmentPresentations_SubmissionPartResponseTypeName;
  /** Mandatory title of submission part. May not match file name. */
  title: Scalars['String'];
  /** URL representing learner submission. */
  url: Scalars['String'];
};

/**
 * Modeled after SubmissionPartSchemaDetails.courier
 *
 * Union representing the configuration options associated with different types of submission parts.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetails = AssignmentPresentations_SubmissionPartSchemaDetailsFileUploadSchema | AssignmentPresentations_SubmissionPartSchemaDetailsOffPlatformSchema | AssignmentPresentations_SubmissionPartSchemaDetailsPlainTextSchema | AssignmentPresentations_SubmissionPartSchemaDetailsRichTextSchema | AssignmentPresentations_SubmissionPartSchemaDetailsUrlSchema;

/**
 * Modeled after @typedDefinition aliases SubmissionPartSchemaDetails.courier
 *
 * The purpose of these is to allow for backward compatibility with the type names of the old courier
 * models. Once the FE is completely decoupled from the old naptime APIs, we deprecate these in
 * favor of the GraphQl `__typename` field.
 */
export const AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName = {
  /** TODO: Complete this description */
  FileUploadSchema: 'fileUploadSchema',
  /** TODO: Complete this description */
  OffPlatformSchema: 'offPlatformSchema',
  /** TODO: Complete this description */
  PlainTextSchema: 'plainTextSchema',
  /** TODO: Complete this description */
  RichTextSchema: 'richTextSchema',
  /** TODO: Complete this description */
  UrlSchema: 'urlSchema'
} as const;

export type AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName = typeof AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName[keyof typeof AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName];
/**
 * Modeled after FileUploadSchema.courier
 *
 * Represents SGA question where a file upload submission response is expected.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetailsFileUploadSchema = {
  __typename?: 'AssignmentPresentations_SubmissionPartSchemaDetailsFileUploadSchema';
  /** always set to fileUploadSchema. */
  courierTypeName: AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName;
  /** TODO: Complete this description */
  required: Scalars['Boolean'];
};

/**
 * Modeled after OffPlatformSchema.courier
 *
 * Represents SGA question where an off-platform submission response is expected.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetailsOffPlatformSchema = {
  __typename?: 'AssignmentPresentations_SubmissionPartSchemaDetailsOffPlatformSchema';
  /** always set to offPlatformSchema. */
  courierTypeName: AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName;
};

/**
 * Modeled after PlainTextSchema.courier
 *
 * Represents SGA question where a plain text submission response is expected.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetailsPlainTextSchema = {
  __typename?: 'AssignmentPresentations_SubmissionPartSchemaDetailsPlainTextSchema';
  /** always set to plainTextSchema. */
  courierTypeName: AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName;
};

/**
 * Modeled after RichTextSchema.courier
 *
 * Represents SGA question where a rich text submission response is expected.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetailsRichTextSchema = {
  __typename?: 'AssignmentPresentations_SubmissionPartSchemaDetailsRichTextSchema';
  /** always set to richTextSchema. */
  courierTypeName: AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName;
};

/**
 * Modeled after UrlSchema.courier
 *
 * Represents SGA question where a URL submission response is expected.
 */
export type AssignmentPresentations_SubmissionPartSchemaDetailsUrlSchema = {
  __typename?: 'AssignmentPresentations_SubmissionPartSchemaDetailsUrlSchema';
  /** TODO: Complete this description */
  allowedUrls: Array<AssignmentPresentations_AllowedUrlType>;
  /** always set to urlSchema. */
  courierTypeName: AssignmentPresentations_SubmissionPartSchemaDetailsCourierTypeName;
};

/** TODO: Complete this description */
export const AssignmentPresentations_SubmissionStatus = {
  /** TODO: Complete this description */
  AwaitingPeerReview: 'AWAITING_PEER_REVIEW',
  /** TODO: Complete this description */
  Deleted: 'DELETED',
  /** TODO: Complete this description */
  GradeReleased: 'GRADE_RELEASED',
  /** TODO: Complete this description */
  GradingFinished: 'GRADING_FINISHED',
  /** TODO: Complete this description */
  GradingStarted: 'GRADING_STARTED',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED',
  /** TODO: Complete this description */
  NotYetSubmitted: 'NOT_YET_SUBMITTED',
  /** TODO: Complete this description */
  ReadyForGrading: 'READY_FOR_GRADING'
} as const;

export type AssignmentPresentations_SubmissionStatus = typeof AssignmentPresentations_SubmissionStatus[keyof typeof AssignmentPresentations_SubmissionStatus];
/**
 * Modeled after WeightedScoring.courier
 *
 * Weighted scoring for a single question and response pair
 */
export type AssignmentPresentations_WeightedScoring = {
  __typename?: 'AssignmentPresentations_WeightedScoring';
  /** Max score for a question. */
  maxScore: Scalars['Float'];
  /** [optional] score for a question. */
  score?: Maybe<Scalars['Float']>;
};

/** Yes or No choice */
export const AssignmentPresentations_YesNoChoice = {
  /** No choice */
  No: 'No',
  /** Yes choice */
  Yes: 'Yes'
} as const;

export type AssignmentPresentations_YesNoChoice = typeof AssignmentPresentations_YesNoChoice[keyof typeof AssignmentPresentations_YesNoChoice];
/** Modeled after YesNoPoints courier model */
export type AssignmentPresentations_YesNoPoints = {
  __typename?: 'AssignmentPresentations_YesNoPoints';
  /** No point */
  no?: Maybe<Scalars['Float']>;
  /** Yes point */
  yes?: Maybe<Scalars['Float']>;
};

/** Assignment preview (e.g. question prompts) for course builder */
export type AssignmentPreviewQueries = {
  __typename?: 'AssignmentPreviewQueries';
  /** This query returns assignment preview */
  previewByVersionedAssignmentId?: Maybe<AssignmentPreview_AssignmentPreviewQueryResult>;
};


/** Assignment preview (e.g. question prompts) for course builder */
export type AssignmentPreviewQueriesPreviewByVersionedAssignmentIdArgs = {
  assignmentId: Scalars['ID'];
  courseId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
  version: Scalars['Int'];
};

/** Successful query result */
export type AssignmentPreview_AssignmentPreview = {
  __typename?: 'AssignmentPreview_AssignmentPreview';
  /** id of the requested assignment id, present for caching on the client */
  id: Scalars['ID'];
  /**
   * Sum of questions in the question banks used in the assignment, it's undefined when no question
   * bank is used in the assignment
   */
  questionPreviews?: Maybe<Array<AssignmentPreview_QuestionPreview>>;
  /** Version number of the assignment to fetch assignment content preview for specific assignment */
  version: Scalars['Int'];
};

/** Errors when querying for assignment metadata */
export type AssignmentPreview_AssignmentPreviewQueryFailure = {
  __typename?: 'AssignmentPreview_AssignmentPreviewQueryFailure';
  /** Errors encountered when determining the assignment metadata. */
  errors: Array<AssignmentPreview_ErrorDetailsWithErrorCode>;
};

/** Query result can be a success or an error */
export type AssignmentPreview_AssignmentPreviewQueryResult = AssignmentPreview_AssignmentPreview | AssignmentPreview_AssignmentPreviewQueryFailure;

/** Types of errors */
export const AssignmentPreview_ErrorDetailsWithErrorCode = {
  /** Thrown when querying by the downstream record ID returns error */
  AssignmentPreviewIdNotFoundError: 'AssignmentPreview_IdNotFoundError'
} as const;

export type AssignmentPreview_ErrorDetailsWithErrorCode = typeof AssignmentPreview_ErrorDetailsWithErrorCode[keyof typeof AssignmentPreview_ErrorDetailsWithErrorCode];
/** Question preview: question prompts, etc */
export type AssignmentPreview_QuestionPreview = {
  __typename?: 'AssignmentPreview_QuestionPreview';
  /** Question prompts as rich text */
  prompt: Cml_Cml;
};

/** Assignment regrade input to register regrade configurations per item */
export type Assignment_AssignmentRegradeInput = {
  /** The course branch Id to which the item belongs */
  courseBranchId: Scalars['ID'];
  /**
   * The assignment item id to be regraded, depending on the regrade item scope, this is might not
   * be the only item to be regraded
   */
  itemId: Scalars['ID'];
  /** The regrade configuration for the assignment item applied when doing machine evaluation */
  regradeConfig: Assignment_RegradeConfigInput;
};

/**
 * Assignment version scope to regrade, either only the latest version when registering the
 * regrade configuration, or specified versions
 */
export type Assignment_AssignmentRegradeResult = {
  __typename?: 'Assignment_AssignmentRegradeResult';
  /** The number of potentially impacted learners */
  potentiallyImpactedLearners: Scalars['Int'];
};

/**
 * Item instances of the assignment to regrade, either only the specified item instance, or all
 * linked items
 */
export const Assignment_ItemRegradeScope = {
  /** Regrade all linked items */
  ItemScopeAllLinkedItems: 'ITEM_SCOPE_ALL_LINKED_ITEMS',
  /** Regrade only the specified item instance */
  ItemScopeSingleItem: 'ITEM_SCOPE_SINGLE_ITEM'
} as const;

export type Assignment_ItemRegradeScope = typeof Assignment_ItemRegradeScope[keyof typeof Assignment_ItemRegradeScope];
/** The assignment regrade configurations */
export type Assignment_RegradeConfigInput = {
  /**
   * Assignment version scope to regrade, either only the latest version when registering the
   * regrade configuration, or specified versions
   */
  assignmentVersionScope?: InputMaybe<Array<Scalars['Int']>>;
  /** Specified group of learners to regrade, otherwise all groups/non-groups are regraded */
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Item instances of the assignment to regrade, either only the specified item instance, or all
   * linked items
   */
  itemRegradeScope: Assignment_ItemRegradeScope;
  /** Specified learnerIds to regrade, otherwise all learners are regraded */
  learnerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Specified questionIds to regrade, otherwise all questions in the assignment are regraded */
  questionIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Formula for question regrade: Either full credit to questions, or true credit based on the latest
   * question definition
   */
  regradeFormula: Assignment_RegradeFormula;
  /**
   * Submissions to regrade: either only in existing/past submissions, or for all submissions
   * including future submissions
   */
  submissionRegradeScope: Assignment_SubmissionRegradeScope;
};

/**
 * Formula for question regrade: Either full credit to questions, or true credit based on the latest
 * question definition
 */
export const Assignment_RegradeFormula = {
  /** Full credit to questions */
  FullCredit: 'FULL_CREDIT',
  /** True credit based on the latest question definition */
  RegradeByLatestAssignment: 'REGRADE_BY_LATEST_ASSIGNMENT'
} as const;

export type Assignment_RegradeFormula = typeof Assignment_RegradeFormula[keyof typeof Assignment_RegradeFormula];
/**
 * Submissions to regrade: either only in existing/past submissions, or for all submissions
 * including future submissions
 */
export const Assignment_SubmissionRegradeScope = {
  /** Regrade in all submissions including future submissions */
  RegradeSubmissionScopePastAndOngoingSubmissions: 'REGRADE_SUBMISSION_SCOPE_PAST_AND_ONGOING_SUBMISSIONS',
  /** Regrade only in existing/past submissions */
  RegradeSubmissionScopePastSubmissions: 'REGRADE_SUBMISSION_SCOPE_PAST_SUBMISSIONS'
} as const;

export type Assignment_SubmissionRegradeScope = typeof Assignment_SubmissionRegradeScope[keyof typeof Assignment_SubmissionRegradeScope];
/** Atom summative content queries */
export type AtomSummativeContentQueries = {
  __typename?: 'AtomSummativeContentQueries';
  /** Find atom summative contents by branch and item id. Return an empty result in case the generated contents are not ready yet for the new atom. */
  findAtomSummativeContentByBranchAndItemId?: Maybe<AtomSummativeContent_AtomSummativeContent>;
  /** Find atom summative contents by atom id. */
  findAtomSummativeContentsByAtomId: AtomSummativeContent_AtomSummativeContentsPaginatedResult;
  /**
   * Find atom summative contents by course branch id and atom type. Notice that we will not generate atom summative contents through AI in this endpoint since it will take a
   * significantly long time to do AI generation for multiple items all at once. The summative content will be generated next time when queried by GET instead.
   */
  findAtomSummativeContentsByCourseBranchIdAndAtomType: AtomSummativeContent_AtomSummativeContentsPaginatedResult;
  /** Get atom summative content. Return an empty result in case the generated contents are not ready yet for the new atom. */
  getAtomSummativeContent?: Maybe<AtomSummativeContent_AtomSummativeContent>;
  /** Get course outline summary as an export file by course and course branch id. */
  getCourseOutlineExportByCourseIdAndBranchId?: Maybe<AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdResult>;
  /** Multi-get atom summative contents. */
  multiGetAtomSummativeContents: Array<AtomSummativeContent_AtomSummativeContent>;
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesFindAtomSummativeContentByBranchAndItemIdArgs = {
  findAtomSummativeContentByBranchAndItemIdInput: AtomSummativeContent_FindAtomSummativeContentByBranchAndItemIdInput;
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesFindAtomSummativeContentsByAtomIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  findAtomSummativeContentsByAtomIdInput: AtomSummativeContent_FindAtomSummativeContentsByAtomIdInput;
  limit: Scalars['Int'];
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesFindAtomSummativeContentsByCourseBranchIdAndAtomTypeArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  findAtomSummativeContentsByCourseBranchIdAndAtomTypeInput: AtomSummativeContent_FindAtomSummativeContentsByCourseBranchIdAndAtomTypeInput;
  limit: Scalars['Int'];
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesGetAtomSummativeContentArgs = {
  getAtomSummativeContentInput: AtomSummativeContent_GetAtomSummativeContentInput;
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesGetCourseOutlineExportByCourseIdAndBranchIdArgs = {
  getCourseOutlineExportByCourseIdAndBranchIdInput: AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdInput;
};


/** Atom summative content queries */
export type AtomSummativeContentQueriesMultiGetAtomSummativeContentsArgs = {
  multiGetAtomSummativeContentsInput: AtomSummativeContent_MultiGetAtomSummativeContentsInput;
};

/** Atom summative content entity, which can be referenced by other subgraphs */
export type AtomSummativeContent_AtomSummativeContent = {
  __typename?: 'AtomSummativeContent_AtomSummativeContent';
  /** Atom type */
  atomType: AtomSummativeContent_AtomType;
  /** Central theme or topic of the learning material for course context summarization. */
  centralTheme?: Maybe<Scalars['String']>;
  /** Created at. */
  createdAt: Scalars['DateTime'];
  /** Important examples used to illustrate concepts for course context summarization. */
  importantExamples: Array<AtomSummativeContent_ImportantExample>;
  /** Are learning objectives manually overridden by the original author. */
  isLearningObjectiveManuallyOverridden: Scalars['Boolean'];
  /** Is summary manually overridden by the original author. */
  isSummaryManuallyOverridden: Scalars['Boolean'];
  /** Is title manually overridden by the original author. */
  isTitleManuallyOverridden: Scalars['Boolean'];
  /** Key concepts or ideas presented for course context summarization. */
  keyConceptsAndIdeas: Array<AtomSummativeContent_KeyConceptAndIdea>;
  /** Learning objectives. */
  learningObjectives: Array<Scalars['String']>;
  /** Summary */
  summary: Scalars['String'];
  /** Specific terminology with definitions for course context summarization. */
  terminologyAndDefinitions: Array<AtomSummativeContent_TerminologyDefinition>;
  /** Title. */
  title: Scalars['String'];
  /** Updated at. */
  updatedAt: Scalars['DateTime'];
  /** Only set if the atom summative content is changed by the original author */
  userId?: Maybe<Scalars['ID']>;
  /** Versioned atom id */
  versionedAtomId: AtomSummativeContent_VersionedAtomId;
};

/** Atom summative content error. */
export type AtomSummativeContent_AtomSummativeContentError = {
  __typename?: 'AtomSummativeContent_AtomSummativeContentError';
  /** Error message. */
  message: Scalars['String'];
};

/** Atom summative content failure. */
export type AtomSummativeContent_AtomSummativeContentFailure = {
  __typename?: 'AtomSummativeContent_AtomSummativeContentFailure';
  /** Errors. */
  errors: Array<AtomSummativeContent_AtomSummativeContentError>;
};

/** Atom summative content */
export type AtomSummativeContent_AtomSummativeContentInput = {
  /** atom type */
  atomType: AtomSummativeContent_AtomType;
  /** Are learning objectives manually overridden by the original author. */
  isLearningObjectiveManuallyOverridden: Scalars['Boolean'];
  /** Is summary manually overridden by the original author. */
  isSummaryManuallyOverridden: Scalars['Boolean'];
  /** Is title manually overridden by the original author. */
  isTitleManuallyOverridden: Scalars['Boolean'];
  /** Learning objectives. */
  learningObjectives: Array<Scalars['String']>;
  /** Summary */
  summary: Scalars['String'];
  /** Title. */
  title: Scalars['String'];
  /** Only set if the atom summative content is changed by the original author */
  userId?: InputMaybe<Scalars['ID']>;
  /** versioned atom id */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Atom summative content success. */
export type AtomSummativeContent_AtomSummativeContentSuccess = {
  __typename?: 'AtomSummativeContent_AtomSummativeContentSuccess';
  /** Atom summative content. */
  atomSummativeContent: AtomSummativeContent_AtomSummativeContent;
};

/** Atom summative contents paginated result (for pagination) */
export type AtomSummativeContent_AtomSummativeContentsPaginatedResult = {
  __typename?: 'AtomSummativeContent_AtomSummativeContentsPaginatedResult';
  /** Elements. */
  elements: Array<AtomSummativeContent_AtomSummativeContent>;
  /** Pagination. */
  pagination: Pagination;
};

/** Atom type. */
export const AtomSummativeContent_AtomType = {
  /** A discussion prompt is a custom experience built on top of discussion forums. */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** External tool */
  LtiTool: 'LTI_TOOL',
  /** Peer review */
  PeerReview: 'PEER_REVIEW',
  /** Programming assignment allows instructors to set up autograders to grade learner submissions. Learners complete programming assignments either on their local environment or inside Coursera Labs(aka Workspaces) and then make submissions to get grades on Coursera. */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /** Staff Graded Assignments (SGA) is one assessment type that was specifically designed for degrees to allow manual grading. */
  StaffGraded: 'STAFF_GRADED',
  /** Teammate Review (TMR) is an assessment type that allows for team members to review each other. The typical use case for this item type is to allow individuals to give feedback to each other for a project that was performed in a different item type (e.g., Staff Graded Assignments) or off of the platform. */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Coursera Labs enables you to build interactive in-browser learning experiences powered by Coursera-hosted cloud environments. */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget which can be plugged in to the course items */
  Widget: 'WIDGET',
  /** WISEflow is a third-party tool we use to enhance your learning experience. */
  WiseFlow: 'WISE_FLOW'
} as const;

export type AtomSummativeContent_AtomType = typeof AtomSummativeContent_AtomType[keyof typeof AtomSummativeContent_AtomType];
/** Create atom summative content input. */
export type AtomSummativeContent_CreateAtomSummativeContentInput = {
  /** Atom summative content. */
  atomSummativeContent?: InputMaybe<AtomSummativeContent_AtomSummativeContentInput>;
};

/** Create atom summative content result. */
export type AtomSummativeContent_CreateAtomSummativeContentResult = AtomSummativeContent_AtomSummativeContentFailure | AtomSummativeContent_AtomSummativeContentSuccess;

/** Delete atom summative content input. */
export type AtomSummativeContent_DeleteAtomSummativeContentInput = {
  /** Versioned atom id. */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Delete atom summative content result. */
export type AtomSummativeContent_DeleteAtomSummativeContentResult = AtomSummativeContent_AtomSummativeContentFailure | AtomSummativeContent_VersionedAtomId;

/** Find atom summative contents by branch item id. */
export type AtomSummativeContent_FindAtomSummativeContentByBranchAndItemIdInput = {
  /** Course branch id. */
  branchId: Scalars['ID'];
  /** Item id */
  itemId: Scalars['ID'];
};

/** Find atom summative contents by atom id. */
export type AtomSummativeContent_FindAtomSummativeContentsByAtomIdInput = {
  /** Atom id. */
  atomId: Scalars['ID'];
};

/** Find atom summative contents by course branch id and atom type. */
export type AtomSummativeContent_FindAtomSummativeContentsByCourseBranchIdAndAtomTypeInput = {
  /** Atom type. */
  atomType: AtomSummativeContent_AtomType;
  /** The learner side course branch id */
  courseBranchId: Scalars['ID'];
};

/** Errors relating to generating the course outline summary export */
export type AtomSummativeContent_GenerateCourseOutlineSummaryExportError = {
  __typename?: 'AtomSummativeContent_GenerateCourseOutlineSummaryExportError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Get atom summative content input. */
export type AtomSummativeContent_GetAtomSummativeContentInput = {
  /** Versioned atom id. */
  versionedAtomId: AtomSummativeContent_VersionedAtomIdInput;
};

/** Returned if AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdFailure ran into a client-actionable error and no download url provided */
export type AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdFailure = {
  __typename?: 'AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdFailure';
  /** List of errors */
  errors: Array<AtomSummativeContent_GenerateCourseOutlineSummaryExportError>;
};

/** Get course outline summary as an export file, using course id and course branch id */
export type AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdInput = {
  /** Course branch Id */
  courseBranchId: Scalars['ID'];
  /** Course Id */
  courseId: Scalars['ID'];
};

/** Possible results from querying to retrieve the course outline summary as an export file */
export type AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdResult = AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdFailure | AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdSuccess;

/** Returned if Course outline summary export is generated and returned successfully */
export type AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdSuccess = {
  __typename?: 'AtomSummativeContent_GetCourseOutlineExportByCourseIdAndBranchIdSuccess';
  /** download URL for generated course outline summary export */
  downloadUrl: Scalars['URL'];
  /** List of any partial errors or additional notes that occurred during the export generation */
  partialErrors?: Maybe<Array<AtomSummativeContent_GenerateCourseOutlineSummaryExportError>>;
};

/** Important example used to illustrate concepts in course context summarization. */
export type AtomSummativeContent_ImportantExample = {
  __typename?: 'AtomSummativeContent_ImportantExample';
  /** The example text. */
  example: Scalars['String'];
};

/** Key concept or idea presented in course context summarization. */
export type AtomSummativeContent_KeyConceptAndIdea = {
  __typename?: 'AtomSummativeContent_KeyConceptAndIdea';
  /** Description of the concept. */
  description: Scalars['String'];
  /** Title of the concept. */
  title: Scalars['String'];
};

/** Multi-get atom summative contents input. */
export type AtomSummativeContent_MultiGetAtomSummativeContentsInput = {
  /** Versioned atom ids. */
  versionedAtomIds: Array<AtomSummativeContent_VersionedAtomIdInput>;
};

/** Terminology definition for course context summarization. */
export type AtomSummativeContent_TerminologyDefinition = {
  __typename?: 'AtomSummativeContent_TerminologyDefinition';
  /** The definition of the term. */
  definition: Scalars['String'];
  /** The term. */
  term: Scalars['String'];
};

/** Update atom summative content input. */
export type AtomSummativeContent_UpdateAtomSummativeContentInput = {
  /** Atom summative content. */
  atomSummativeContent?: InputMaybe<AtomSummativeContent_AtomSummativeContentInput>;
};

/** Update atom summative content result. */
export type AtomSummativeContent_UpdateAtomSummativeContentResult = AtomSummativeContent_AtomSummativeContentFailure | AtomSummativeContent_AtomSummativeContentSuccess;

/** Versioned atom id. */
export type AtomSummativeContent_VersionedAtomId = {
  __typename?: 'AtomSummativeContent_VersionedAtomId';
  /** Atom id. */
  atomId: Scalars['ID'];
  /** Version. */
  version: Scalars['Int'];
};

/** Versioned atom id input */
export type AtomSummativeContent_VersionedAtomIdInput = {
  /** Atom id */
  atomId: Scalars['ID'];
  /** Atom version. The atom version can only be empty in the get/ multi-get atom summative contents input */
  version?: InputMaybe<Scalars['Int']>;
};

/**
 * AttemptStatus NOT_STARTED - indicates the learner has not started the attempt, IN_PROGRESS - the attempt is in progress and learner
 * is allowed to make submissions, COMPLETED - the attempt is completed or closed because either they ran out of submissions or time, and
 * at this time learner cannot make submissions.
 */
export const AttemptStatus = {
  /** TODO: Complete this description */
  Completed: 'COMPLETED',
  /** TODO: Complete this description */
  InProgress: 'IN_PROGRESS',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED'
} as const;

export type AttemptStatus = typeof AttemptStatus[keyof typeof AttemptStatus];
/** TODO: Complete this description */
export type AttemptSummary = NoLimitSummary | RateLimitSummary | SubmissionLimitSummary | TimeAndSubmissionLimitSummary | TimeLimitSummary;

/** TODO: Complete this description */
export type AttemptSummaryQueries = {
  __typename?: 'AttemptSummaryQueries';
  /**
   * query to get programming AttemptSummary which can be any of : NoLimitSummary, RateLimitSummary, TimeLimitSummary,
   * SubmissionLimitSummary, and TimeAndSubmissionLimitSummary. This query is used for all the cases independent of
   * whether an assignment is configured for Timed or Not.
   */
  queryAttemptSummary: AttemptSummary;
};


/** TODO: Complete this description */
export type AttemptSummaryQueriesQueryAttemptSummaryArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  userId: Scalars['String'];
};

/** Type Wrapper for academicDisciplines attribute. */
export type Attribute_AcademicDiscipline = {
  __typename?: 'Attribute_AcademicDiscipline';
  /** Value of academicDiscipline */
  value: Scalars['String'];
};

/** Type Wrapper for contractTagNames attribute (currently only used for academy). */
export type Attribute_ContractTagName = {
  __typename?: 'Attribute_ContractTagName';
  /** Value of contractTagName */
  value: Scalars['String'];
};

/** Type Wrapper for educationalGoals attribute. */
export type Attribute_EducationalGoal = {
  __typename?: 'Attribute_EducationalGoal';
  /** Value of educationalGoal */
  value: Scalars['String'];
};

/** Type Wrapper for learningObjectives attribute. */
export type Attribute_LearningObjective = {
  __typename?: 'Attribute_LearningObjective';
  /** Value of learningObjective */
  value: Scalars['String'];
};

/** Type Wrapper for optimization status attribute, it is either "NEED_REVIEW" or "OPTIMIZED" */
export type Attribute_OptimizationStatus = {
  __typename?: 'Attribute_OptimizationStatus';
  /** Indicate if the collection needs optimized */
  value: Scalars['String'];
};

/** Type Wrapper for organizationGoals attribute. */
export type Attribute_OrganizationGoal = {
  __typename?: 'Attribute_OrganizationGoal';
  /** Value of organizationGoal */
  value: Scalars['String'];
};

/** Type Wrapper for organisation ID attribute (one per collection; owning organisation). */
export type Attribute_OrganizationId = {
  __typename?: 'Attribute_OrganizationId';
  /** Organisation ID value */
  organizationId: Scalars['ID'];
};

/** Type Wrapper for program ID attribute (programs where the collection is added). */
export type Attribute_ProgramId = {
  __typename?: 'Attribute_ProgramId';
  /** Program ID value */
  programId: Scalars['ID'];
};

/** Represents whether the collection serves as a "CURATED_LIBRARY" or a "LEARNING_PATH" */
export type Attribute_Purpose = {
  __typename?: 'Attribute_Purpose';
  /** Value of collection purpose */
  value: Scalars['String'];
};

export type AuthoringActivitiesV1 = {
  __typename?: 'AuthoringActivitiesV1';
  authoringScopeMetadata?: Maybe<AuthoringScopeMetadataV1>;
  createdAt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  details: AuthoringActivitiesV1_Details;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type AuthoringActivitiesV1ByScope = {
  __typename?: 'AuthoringActivitiesV1ByScope';
  connection?: Maybe<AuthoringActivitiesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitiesV1ByScopeItem = {
  __typename?: 'AuthoringActivitiesV1ByScopeItem';
  connection?: Maybe<AuthoringActivitiesV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitiesV1ByScopeItemActivityType = {
  __typename?: 'AuthoringActivitiesV1ByScopeItemActivityType';
  activityType: Scalars['String'];
  connection?: Maybe<AuthoringActivitiesV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitiesV1Connection = {
  __typename?: 'AuthoringActivitiesV1Connection';
  elements: Array<Maybe<AuthoringActivitiesV1>>;
  paging: ResponsePagination;
};

export type AuthoringActivitiesV1Resource = {
  __typename?: 'AuthoringActivitiesV1Resource';
  byScope?: Maybe<AuthoringActivitiesV1Connection>;
  byScopeItem?: Maybe<AuthoringActivitiesV1Connection>;
  byScopeItemActivityType?: Maybe<AuthoringActivitiesV1Connection>;
  get?: Maybe<AuthoringActivitiesV1>;
  multiGet?: Maybe<AuthoringActivitiesV1Connection>;
};


export type AuthoringActivitiesV1ResourceByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitiesV1ResourceByScopeItemArgs = {
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitiesV1ResourceByScopeItemActivityTypeArgs = {
  activityType: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitiesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringActivitiesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringActivitiesV1ResourceMutations = {
  __typename?: 'AuthoringActivitiesV1ResourceMutations';
  create?: Maybe<AuthoringActivitiesV1Connection>;
  delete?: Maybe<AuthoringActivitiesV1Connection>;
  update?: Maybe<AuthoringActivitiesV1Connection>;
};


export type AuthoringActivitiesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type AuthoringActivitiesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type AuthoringActivitiesV1_Item_DiscussionMember = {
  __typename?: 'AuthoringActivitiesV1_ITEM_DISCUSSIONMember';
  ITEM_DISCUSSION: AuthoringActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails;
};

export type AuthoringActivitiesV1_Item_SubmissionMember = {
  __typename?: 'AuthoringActivitiesV1_ITEM_SUBMISSIONMember';
  ITEM_SUBMISSION: AuthoringActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails;
};

export type AuthoringActivitiesV1_Practice_Item_SubmissionMember = {
  __typename?: 'AuthoringActivitiesV1_PRACTICE_ITEM_SUBMISSIONMember';
  PRACTICE_ITEM_SUBMISSION: AuthoringActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails;
};

export type AuthoringActivitiesV1_Standalone_DiscussionMember = {
  __typename?: 'AuthoringActivitiesV1_STANDALONE_DISCUSSIONMember';
  STANDALONE_DISCUSSION: AuthoringActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails;
};

export type AuthoringActivitiesV1_Teammate_ReviewMember = {
  __typename?: 'AuthoringActivitiesV1_TEAMMATE_REVIEWMember';
  TEAMMATE_REVIEW: AuthoringActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails;
};

export type AuthoringActivitiesV1_Details = AuthoringActivitiesV1_Item_DiscussionMember | AuthoringActivitiesV1_Item_SubmissionMember | AuthoringActivitiesV1_Practice_Item_SubmissionMember | AuthoringActivitiesV1_Standalone_DiscussionMember | AuthoringActivitiesV1_Teammate_ReviewMember;

export type AuthoringActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails = {
  __typename?: 'AuthoringActivitiesV1_org_coursera_teamwork_ItemDiscussionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails = {
  __typename?: 'AuthoringActivitiesV1_org_coursera_teamwork_ItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails = {
  __typename?: 'AuthoringActivitiesV1_org_coursera_teamwork_PracticeItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails = {
  __typename?: 'AuthoringActivitiesV1_org_coursera_teamwork_StandaloneDiscussionActivityDetails';
  ArbitraryField: Scalars['String'];
};

export type AuthoringActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails = {
  __typename?: 'AuthoringActivitiesV1_org_coursera_teamwork_TeammateReviewActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitySetActivitiesV1 = {
  __typename?: 'AuthoringActivitySetActivitiesV1';
  createdAt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  details: AuthoringActivitySetActivitiesV1_Details;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type AuthoringActivitySetActivitiesV1Connection = {
  __typename?: 'AuthoringActivitySetActivitiesV1Connection';
  elements: Array<Maybe<AuthoringActivitySetActivitiesV1>>;
  paging: ResponsePagination;
};

export type AuthoringActivitySetActivitiesV1GetLockedActivities = {
  __typename?: 'AuthoringActivitySetActivitiesV1GetLockedActivities';
  connection?: Maybe<AuthoringActivitySetActivitiesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitySetActivitiesV1Resource = {
  __typename?: 'AuthoringActivitySetActivitiesV1Resource';
  getLockedActivities?: Maybe<AuthoringActivitySetActivitiesV1Connection>;
};


export type AuthoringActivitySetActivitiesV1ResourceGetLockedActivitiesArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringActivitySetActivitiesV1_Item_DiscussionMember = {
  __typename?: 'AuthoringActivitySetActivitiesV1_ITEM_DISCUSSIONMember';
  ITEM_DISCUSSION: AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails;
};

export type AuthoringActivitySetActivitiesV1_Item_SubmissionMember = {
  __typename?: 'AuthoringActivitySetActivitiesV1_ITEM_SUBMISSIONMember';
  ITEM_SUBMISSION: AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails;
};

export type AuthoringActivitySetActivitiesV1_Practice_Item_SubmissionMember = {
  __typename?: 'AuthoringActivitySetActivitiesV1_PRACTICE_ITEM_SUBMISSIONMember';
  PRACTICE_ITEM_SUBMISSION: AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails;
};

export type AuthoringActivitySetActivitiesV1_Standalone_DiscussionMember = {
  __typename?: 'AuthoringActivitySetActivitiesV1_STANDALONE_DISCUSSIONMember';
  STANDALONE_DISCUSSION: AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails;
};

export type AuthoringActivitySetActivitiesV1_Teammate_ReviewMember = {
  __typename?: 'AuthoringActivitySetActivitiesV1_TEAMMATE_REVIEWMember';
  TEAMMATE_REVIEW: AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails;
};

export type AuthoringActivitySetActivitiesV1_Details = AuthoringActivitySetActivitiesV1_Item_DiscussionMember | AuthoringActivitySetActivitiesV1_Item_SubmissionMember | AuthoringActivitySetActivitiesV1_Practice_Item_SubmissionMember | AuthoringActivitySetActivitiesV1_Standalone_DiscussionMember | AuthoringActivitySetActivitiesV1_Teammate_ReviewMember;

export type AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails = {
  __typename?: 'AuthoringActivitySetActivitiesV1_org_coursera_teamwork_ItemDiscussionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails = {
  __typename?: 'AuthoringActivitySetActivitiesV1_org_coursera_teamwork_ItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails = {
  __typename?: 'AuthoringActivitySetActivitiesV1_org_coursera_teamwork_PracticeItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails = {
  __typename?: 'AuthoringActivitySetActivitiesV1_org_coursera_teamwork_StandaloneDiscussionActivityDetails';
  ArbitraryField: Scalars['String'];
};

export type AuthoringActivitySetActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails = {
  __typename?: 'AuthoringActivitySetActivitiesV1_org_coursera_teamwork_TeammateReviewActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type AuthoringActivitySetTeamsV1 = {
  __typename?: 'AuthoringActivitySetTeamsV1';
  createdAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  members: Array<Maybe<Scalars['Int']>>;
  name: Scalars['String'];
  slackIntegrationMetadata?: Maybe<AuthoringActivitySetTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata>;
  updatedAt?: Maybe<Scalars['Float']>;
  versionedTeamId: Scalars['String'];
};

export type AuthoringActivitySetTeamsV1Connection = {
  __typename?: 'AuthoringActivitySetTeamsV1Connection';
  elements: Array<Maybe<AuthoringActivitySetTeamsV1>>;
  paging: ResponsePagination;
};

export type AuthoringActivitySetTeamsV1GetEligibleTeams = {
  __typename?: 'AuthoringActivitySetTeamsV1GetEligibleTeams';
  connection?: Maybe<AuthoringActivitySetTeamsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitySetTeamsV1GetLockedTeams = {
  __typename?: 'AuthoringActivitySetTeamsV1GetLockedTeams';
  connection?: Maybe<AuthoringActivitySetTeamsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitySetTeamsV1Resource = {
  __typename?: 'AuthoringActivitySetTeamsV1Resource';
  getEligibleTeams?: Maybe<AuthoringActivitySetTeamsV1Connection>;
  getLockedTeams?: Maybe<AuthoringActivitySetTeamsV1Connection>;
};


export type AuthoringActivitySetTeamsV1ResourceGetEligibleTeamsArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetTeamsV1ResourceGetLockedTeamsArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringActivitySetTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata = {
  __typename?: 'AuthoringActivitySetTeamsV1_org_coursera_teamwork_SlackIntegrationMetadata';
  slackGroupId: Scalars['String'];
  slackTeamDomain?: Maybe<Scalars['String']>;
  slackTeamId: Scalars['String'];
};

export type AuthoringActivitySetsV1 = {
  __typename?: 'AuthoringActivitySetsV1';
  activities?: Maybe<AuthoringActivitiesV1Connection>;
  activityIds: Array<Maybe<Scalars['String']>>;
  authoringScopeMetadata?: Maybe<AuthoringScopeMetadataV1>;
  candidateDiscussionItems?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  candidatePracticeSubmissionItems?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  candidateSubmissionItems?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  candidateTeammateReviewItems?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  createdAt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  eligibleTeams?: Maybe<AuthoringActivitySetTeamsV1Connection>;
  id: Scalars['String'];
  lockedActivities?: Maybe<AuthoringActivitySetActivitiesV1Connection>;
  lockedTeams?: Maybe<AuthoringActivitySetTeamsV1Connection>;
  name: Scalars['String'];
  teamIds: Array<Maybe<Scalars['String']>>;
  teams?: Maybe<AuthoringTeamsV1Connection>;
  updatedAt?: Maybe<Scalars['Float']>;
};


export type AuthoringActivitySetsV1ActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1CandidateDiscussionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1CandidatePracticeSubmissionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1CandidateSubmissionItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1CandidateTeammateReviewItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1EligibleTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1LockedActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1LockedTeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1TeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringActivitySetsV1ByScope = {
  __typename?: 'AuthoringActivitySetsV1ByScope';
  connection?: Maybe<AuthoringActivitySetsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringActivitySetsV1Connection = {
  __typename?: 'AuthoringActivitySetsV1Connection';
  elements: Array<Maybe<AuthoringActivitySetsV1>>;
  paging: ResponsePagination;
};

export type AuthoringActivitySetsV1Resource = {
  __typename?: 'AuthoringActivitySetsV1Resource';
  byScope?: Maybe<AuthoringActivitySetsV1Connection>;
  get?: Maybe<AuthoringActivitySetsV1>;
  multiGet?: Maybe<AuthoringActivitySetsV1Connection>;
};


export type AuthoringActivitySetsV1ResourceByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringActivitySetsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringActivitySetsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringActivitySetsV1ResourceMutations = {
  __typename?: 'AuthoringActivitySetsV1ResourceMutations';
  create?: Maybe<AuthoringActivitySetsV1Connection>;
  delete?: Maybe<AuthoringActivitySetsV1Connection>;
  update?: Maybe<AuthoringActivitySetsV1Connection>;
};


export type AuthoringActivitySetsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type AuthoringActivitySetsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

/** Asset Creation Atom Context Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationAtomContextInput = {
  /** The authoringAtomId of the attempt */
  authoringAtomId: Scalars['ID'];
};

/** Asset Creation Context Union Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationContextUnionInput = {
  /** Asset Creation Atom Context */
  assetCreationAtomContext?: InputMaybe<AuthoringAssetCreationAttempts_AssetCreationAtomContextInput>;
  /** Asset Creation Course Context */
  assetCreationCourseContext?: InputMaybe<AuthoringAssetCreationAttempts_AssetCreationCourseContextInput>;
};

/** Asset Creation Course Context Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetCreationCourseContextInput = {
  /** The courseId of the attempt */
  courseId: Scalars['ID'];
};

/** Asset Tag input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetTagInput = {
  /** Name of the asset tag */
  name: Scalars['String'];
  /** Value of the asset tag */
  value: Scalars['String'];
};

/** Asset Type enum GraphQL schema */
export const AuthoringAssetCreationAttempts_AssetType = {
  /** Asset of type: Audio */
  AssetTypeAudio: 'ASSET_TYPE_AUDIO',
  /** Asset of type: Generic */
  AssetTypeGeneric: 'ASSET_TYPE_GENERIC',
  /** Asset of type: Image */
  AssetTypeImage: 'ASSET_TYPE_IMAGE',
  /** Invalid asset type */
  AssetTypeInvalid: 'ASSET_TYPE_INVALID',
  /** Asset of type: Pdf */
  AssetTypePdf: 'ASSET_TYPE_PDF',
  /** Asset of type: Subtitle */
  AssetTypeSubtitle: 'ASSET_TYPE_SUBTITLE',
  /** Asset of type: Video */
  AssetTypeVideo: 'ASSET_TYPE_VIDEO'
} as const;

export type AuthoringAssetCreationAttempts_AssetType = typeof AuthoringAssetCreationAttempts_AssetType[keyof typeof AuthoringAssetCreationAttempts_AssetType];
/** Asset Type Audio With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeAudioWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_AUDIO
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Generic With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeGenericWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_GENERIC
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Image With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeImageWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_IMAGE
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Invalid With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeInvalidWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_INVALID
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
};

/** Asset Type Pdf With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypePdfWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_PDF
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** Pdf template of the asset to be created */
  pdfTemplate: AuthoringAssetCreationAttempts_PdfTemplate;
};

/** Asset Type Subtitle With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeSubtitleWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_SUBTITLE
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** language of the asset to be created */
  language: Scalars['String'];
};

/** Asset Type Video With Related Data */
export type AuthoringAssetCreationAttempts_AssetTypeVideoWithRelatedDataInput = {
  /**
   * Type of the asset to be created:
   * In this case, ASSET_TYPE_VIDEO
   */
  assetType?: InputMaybe<AuthoringAssetCreationAttempts_AssetType>;
  /** videoId of the asset to be created */
  videoId: Scalars['ID'];
  /** Video template of the asset to be created */
  videoTemplate: AuthoringAssetCreationAttempts_VideoTemplate;
};

/** Asset Type With Related Data Union Input GraphQL schema */
export type AuthoringAssetCreationAttempts_AssetTypeWithRelatedDataUnionInput = {
  /** Asset Type Audio With Related Data */
  assetTypeAudioWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeAudioWithRelatedDataInput>;
  /** Asset Type Generic With Related Data */
  assetTypeGenericWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeGenericWithRelatedDataInput>;
  /** Asset Type Image With Related Data */
  assetTypeImageWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeImageWithRelatedDataInput>;
  /** Asset Type Invalid With Related Data */
  assetTypeInvalidWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeInvalidWithRelatedDataInput>;
  /** Asset Type Pdf With Related Data */
  assetTypePdfWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypePdfWithRelatedDataInput>;
  /** Asset Type Subtitle With Related Data */
  assetTypeSubtitleWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeSubtitleWithRelatedDataInput>;
  /** Asset Type Video With Related Data */
  assetTypeVideoWithRelatedData?: InputMaybe<AuthoringAssetCreationAttempts_AssetTypeVideoWithRelatedDataInput>;
};

/** Create Input GraphQL schema */
export type AuthoringAssetCreationAttempts_CreateInput = {
  /** Creation context of the asset */
  assetCreationContext: AuthoringAssetCreationAttempts_AssetCreationContextUnionInput;
  /** Tags of the asset to be created */
  assetTags: Array<AuthoringAssetCreationAttempts_AssetTagInput>;
  /** Type of the asset to be created */
  assetTypeWithRelatedData: AuthoringAssetCreationAttempts_AssetTypeWithRelatedDataUnionInput;
  /** creatorId (userId) of the asset to be created */
  creatorId?: InputMaybe<Scalars['Int']>;
  /** Name of the asset to be created */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Pending Asset Creation Attempt Union Output GraphQL schema
 * This is done to allow additional possible results in the future without breaking changes
 */
export type AuthoringAssetCreationAttempts_CreateResult = AuthoringAssetCreationAttempts_CreateSuccess;

/** Pending Asset Creation Attempt Success GraphQL schema */
export type AuthoringAssetCreationAttempts_CreateSuccess = {
  __typename?: 'AuthoringAssetCreationAttempts_CreateSuccess';
  /** Time of creation of the creation attempt */
  created?: Maybe<Scalars['DateTime']>;
  /** Expiry date of the creation attempt */
  expiry?: Maybe<Scalars['DateTime']>;
  /** Id of the created attempt */
  id: Scalars['ID'];
};

/** Pdf Template enum GraphQL schema */
export const AuthoringAssetCreationAttempts_PdfTemplate = {
  /** Invalid pdf template */
  PdfTemplateInvalid: 'PDF_TEMPLATE_INVALID',
  /** Pdf template of type: Slides */
  PdfTemplateSlides: 'PDF_TEMPLATE_SLIDES'
} as const;

export type AuthoringAssetCreationAttempts_PdfTemplate = typeof AuthoringAssetCreationAttempts_PdfTemplate[keyof typeof AuthoringAssetCreationAttempts_PdfTemplate];
/** Video template GraphQL schema */
export const AuthoringAssetCreationAttempts_VideoTemplate = {
  /** Video template of type: Full Video */
  VideoTemplateFullVideo: 'VIDEO_TEMPLATE_FULL_VIDEO',
  /** Video template of type: Full Video Two */
  VideoTemplateFullVideoTwo: 'VIDEO_TEMPLATE_FULL_VIDEO_TWO',
  /** Invalid video template */
  VideoTemplateInvalid: 'VIDEO_TEMPLATE_INVALID',
  /** Video template of type: Lite Video */
  VideoTemplateLiteVideo: 'VIDEO_TEMPLATE_LITE_VIDEO'
} as const;

export type AuthoringAssetCreationAttempts_VideoTemplate = typeof AuthoringAssetCreationAttempts_VideoTemplate[keyof typeof AuthoringAssetCreationAttempts_VideoTemplate];
export type AuthoringCandidateItemActivitiesV1 = {
  __typename?: 'AuthoringCandidateItemActivitiesV1';
  authoringActivities?: Maybe<AuthoringActivitiesV1Connection>;
  contentSummary: AuthoringCandidateItemActivitiesV1_ContentSummary;
  id: Scalars['String'];
  itemId: Scalars['String'];
  name: Scalars['String'];
};


export type AuthoringCandidateItemActivitiesV1AuthoringActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1ByActivityType = {
  __typename?: 'AuthoringCandidateItemActivitiesV1ByActivityType';
  activityType: Scalars['String'];
  connection?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedActivitySetId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1Connection = {
  __typename?: 'AuthoringCandidateItemActivitiesV1Connection';
  elements: Array<Maybe<AuthoringCandidateItemActivitiesV1>>;
  paging: ResponsePagination;
};

export type AuthoringCandidateItemActivitiesV1Resource = {
  __typename?: 'AuthoringCandidateItemActivitiesV1Resource';
  byActivityType?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
  get?: Maybe<AuthoringCandidateItemActivitiesV1>;
  multiGet?: Maybe<AuthoringCandidateItemActivitiesV1Connection>;
};


export type AuthoringCandidateItemActivitiesV1ResourceByActivityTypeArgs = {
  activityType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopedActivitySetId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringCandidateItemActivitiesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringCandidateItemActivitiesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_AssessOpenSinglePageMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_assessOpenSinglePageMember';
  assessOpenSinglePage: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_ClosedPeerMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_closedPeerMember';
  closedPeer: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_CoachMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_coachMember';
  coach: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_CompoundLatePenaltyMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_compoundLatePenaltyMember';
  compoundLatePenalty: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type AuthoringCandidateItemActivitiesV1_ContentSummary = AuthoringCandidateItemActivitiesV1_AssessOpenSinglePageMember | AuthoringCandidateItemActivitiesV1_ClosedPeerMember | AuthoringCandidateItemActivitiesV1_CoachMember | AuthoringCandidateItemActivitiesV1_DiscussionPromptMember | AuthoringCandidateItemActivitiesV1_ExamMember | AuthoringCandidateItemActivitiesV1_GradedCoachMember | AuthoringCandidateItemActivitiesV1_GradedDiscussionPromptMember | AuthoringCandidateItemActivitiesV1_GradedLabMember | AuthoringCandidateItemActivitiesV1_GradedLtiMember | AuthoringCandidateItemActivitiesV1_GradedPeerMember | AuthoringCandidateItemActivitiesV1_GradedProgrammingMember | AuthoringCandidateItemActivitiesV1_GradedWidgetMember | AuthoringCandidateItemActivitiesV1_LectureMember | AuthoringCandidateItemActivitiesV1_NotebookMember | AuthoringCandidateItemActivitiesV1_PeerMember | AuthoringCandidateItemActivitiesV1_PhasedPeerMember | AuthoringCandidateItemActivitiesV1_PlaceholderMember | AuthoringCandidateItemActivitiesV1_ProgrammingMember | AuthoringCandidateItemActivitiesV1_QuizMember | AuthoringCandidateItemActivitiesV1_SingleQuestionSubmitMember | AuthoringCandidateItemActivitiesV1_SlideshowMember | AuthoringCandidateItemActivitiesV1_StaffGradedMember | AuthoringCandidateItemActivitiesV1_SupplementMember | AuthoringCandidateItemActivitiesV1_TeammateReviewMember | AuthoringCandidateItemActivitiesV1_UngradedAssignmentMember | AuthoringCandidateItemActivitiesV1_UngradedLabMember | AuthoringCandidateItemActivitiesV1_UngradedLtiMember | AuthoringCandidateItemActivitiesV1_UngradedProgrammingMember | AuthoringCandidateItemActivitiesV1_UngradedWidgetMember | AuthoringCandidateItemActivitiesV1_WiseFlowMember | AuthoringCandidateItemActivitiesV1_WorkspaceLauncherMember;

export type AuthoringCandidateItemActivitiesV1_DiscussionPromptMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_discussionPromptMember';
  discussionPrompt: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_ExamMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_examMember';
  exam: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_FixedGradingLatePenaltyMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type AuthoringCandidateItemActivitiesV1_GradedCoachMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedCoachMember';
  gradedCoach: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedCoachSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedDiscussionPromptMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedLabMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedLabMember';
  gradedLab: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedLabSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedLtiMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedLtiMember';
  gradedLti: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedPeerMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedPeerMember';
  gradedPeer: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedProgrammingMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedProgrammingMember';
  gradedProgramming: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradedWidgetMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_gradedWidgetMember';
  gradedWidget: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_GradingLatePenalty = AuthoringCandidateItemActivitiesV1_CompoundLatePenaltyMember | AuthoringCandidateItemActivitiesV1_FixedGradingLatePenaltyMember | AuthoringCandidateItemActivitiesV1_IncrementalGradingLatePenaltyMember;

export type AuthoringCandidateItemActivitiesV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type AuthoringCandidateItemActivitiesV1_LectureMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_lectureMember';
  lecture: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_NotebookMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_notebookMember';
  notebook: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_CoachSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedCoachSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedCoachSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedLabSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedLabSummaryDefinition';
  passingFraction: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  iframeTitle?: Maybe<Scalars['String']>;
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  assignmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<AuthoringCandidateItemActivitiesV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  assignmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  iframeTitle?: Maybe<Scalars['String']>;
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type AuthoringCandidateItemActivitiesV1_PeerMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_peerMember';
  peer: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_PhasedPeerMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_phasedPeerMember';
  phasedPeer: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_PlaceholderMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_placeholderMember';
  placeholder: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_ProgrammingMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_programmingMember';
  programming: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_QuizMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_quizMember';
  quiz: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_SingleQuestionSubmitMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_singleQuestionSubmitMember';
  singleQuestionSubmit: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_SlideshowMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_slideshowMember';
  slideshow: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_StaffGradedMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_staffGradedMember';
  staffGraded: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_SupplementMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_supplementMember';
  supplement: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_TeammateReviewMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_teammateReviewMember';
  teammateReview: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_UngradedAssignmentMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_ungradedAssignmentMember';
  ungradedAssignment: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_UngradedLabMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_ungradedLabMember';
  ungradedLab: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_UngradedLtiMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_ungradedLtiMember';
  ungradedLti: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_UngradedProgrammingMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_ungradedProgrammingMember';
  ungradedProgramming: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_UngradedWidgetMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_ungradedWidgetMember';
  ungradedWidget: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_WiseFlowMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_wiseFlowMember';
  wiseFlow: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type AuthoringCandidateItemActivitiesV1_WorkspaceLauncherMember = {
  __typename?: 'AuthoringCandidateItemActivitiesV1_workspaceLauncherMember';
  workspaceLauncher: AuthoringCandidateItemActivitiesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export type AuthoringCopyBranchesV2 = {
  __typename?: 'AuthoringCopyBranchesV2';
  branchId: Scalars['String'];
  courseId: Scalars['String'];
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  creatorId: Scalars['Int'];
  id: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  keepAtomsShared?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  plannedLaunchDateOption?: Maybe<Scalars['Float']>;
  result?: Maybe<AuthoringCopyBranchesV2_Result>;
  sourceBranchId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type AuthoringCopyBranchesV2Connection = {
  __typename?: 'AuthoringCopyBranchesV2Connection';
  elements: Array<Maybe<AuthoringCopyBranchesV2>>;
  paging: ResponsePagination;
};

export type AuthoringCopyBranchesV2FindByCourse = {
  __typename?: 'AuthoringCopyBranchesV2FindByCourse';
  connection?: Maybe<AuthoringCopyBranchesV2Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringCopyBranchesV2FindByDestinationBranch = {
  __typename?: 'AuthoringCopyBranchesV2FindByDestinationBranch';
  connection?: Maybe<AuthoringCopyBranchesV2Connection>;
  destinationBranchId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringCopyBranchesV2Resource = {
  __typename?: 'AuthoringCopyBranchesV2Resource';
  findByCourse?: Maybe<AuthoringCopyBranchesV2Connection>;
  findByDestinationBranch?: Maybe<AuthoringCopyBranchesV2Connection>;
  get?: Maybe<AuthoringCopyBranchesV2>;
};


export type AuthoringCopyBranchesV2ResourceFindByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringCopyBranchesV2ResourceFindByDestinationBranchArgs = {
  destinationBranchId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringCopyBranchesV2ResourceGetArgs = {
  id: Scalars['String'];
};

export type AuthoringCopyBranchesV2ResourceMutations = {
  __typename?: 'AuthoringCopyBranchesV2ResourceMutations';
  create?: Maybe<AuthoringCopyBranchesV2Connection>;
  delete?: Maybe<AuthoringCopyBranchesV2Connection>;
  patch?: Maybe<AuthoringCopyBranchesV2Connection>;
};


export type AuthoringCopyBranchesV2ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type AuthoringCopyBranchesV2ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};

export type AuthoringCopyBranchesV2_CreatingMember = {
  __typename?: 'AuthoringCopyBranchesV2_creatingMember';
  creating: AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreating;
};

export type AuthoringCopyBranchesV2_CreationFailureMember = {
  __typename?: 'AuthoringCopyBranchesV2_creationFailureMember';
  creationFailure: AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreationFailure;
};

export type AuthoringCopyBranchesV2_JobResultMember = {
  __typename?: 'AuthoringCopyBranchesV2_jobResultMember';
  jobResult: AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreationSuccess;
};

export type AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreating = {
  __typename?: 'AuthoringCopyBranchesV2_org_coursera_authoring_course_branch_AuthoringCopyBranchCreating';
  message: Scalars['String'];
};

export type AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreationFailure = {
  __typename?: 'AuthoringCopyBranchesV2_org_coursera_authoring_course_branch_AuthoringCopyBranchCreationFailure';
  message: Scalars['String'];
};

export type AuthoringCopyBranchesV2_Org_Coursera_Authoring_Course_Branch_AuthoringCopyBranchCreationSuccess = {
  __typename?: 'AuthoringCopyBranchesV2_org_coursera_authoring_course_branch_AuthoringCopyBranchCreationSuccess';
  message: Scalars['String'];
};

export type AuthoringCopyBranchesV2_Result = AuthoringCopyBranchesV2_CreatingMember | AuthoringCopyBranchesV2_CreationFailureMember | AuthoringCopyBranchesV2_JobResultMember;

export type AuthoringScopeDiffsV1 = {
  __typename?: 'AuthoringScopeDiffsV1';
  activitySets: Scalars['JSON'];
  diffStatus: Scalars['String'];
  id: Scalars['String'];
};

export type AuthoringScopeDiffsV1Connection = {
  __typename?: 'AuthoringScopeDiffsV1Connection';
  elements: Array<Maybe<AuthoringScopeDiffsV1>>;
  paging: ResponsePagination;
};

export type AuthoringScopeDiffsV1Resource = {
  __typename?: 'AuthoringScopeDiffsV1Resource';
  get?: Maybe<AuthoringScopeDiffsV1>;
  multiGet?: Maybe<AuthoringScopeDiffsV1Connection>;
};


export type AuthoringScopeDiffsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringScopeDiffsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringScopeMetadataV1 = {
  __typename?: 'AuthoringScopeMetadataV1';
  authoringScopeDiff?: Maybe<AuthoringScopeDiffsV1>;
  id: Scalars['String'];
  publishedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  publishedBy?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Float'];
  /** id for a Coursera user */
  updatedBy: Scalars['Int'];
  version: Scalars['Int'];
};

export type AuthoringScopeMetadataV1ByGroup = {
  __typename?: 'AuthoringScopeMetadataV1ByGroup';
  connection?: Maybe<AuthoringScopeMetadataV1Connection>;
  groupId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringScopeMetadataV1Connection = {
  __typename?: 'AuthoringScopeMetadataV1Connection';
  elements: Array<Maybe<AuthoringScopeMetadataV1>>;
  paging: ResponsePagination;
};

export type AuthoringScopeMetadataV1Resource = {
  __typename?: 'AuthoringScopeMetadataV1Resource';
  byGroup?: Maybe<AuthoringScopeMetadataV1Connection>;
  get?: Maybe<AuthoringScopeMetadataV1>;
  multiGet?: Maybe<AuthoringScopeMetadataV1Connection>;
};


export type AuthoringScopeMetadataV1ResourceByGroupArgs = {
  groupId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringScopeMetadataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringScopeMetadataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeamMetadataV1 = {
  __typename?: 'AuthoringTeamMetadataV1';
  id: Scalars['String'];
  membersAddedAt: Scalars['JSON'];
  numActivitySets: Scalars['Int'];
  versionedTeamId: Scalars['String'];
};

export type AuthoringTeamMetadataV1Connection = {
  __typename?: 'AuthoringTeamMetadataV1Connection';
  elements: Array<Maybe<AuthoringTeamMetadataV1>>;
  paging: ResponsePagination;
};

export type AuthoringTeamMetadataV1Resource = {
  __typename?: 'AuthoringTeamMetadataV1Resource';
  get?: Maybe<AuthoringTeamMetadataV1>;
  multiGet?: Maybe<AuthoringTeamMetadataV1Connection>;
};


export type AuthoringTeamMetadataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringTeamMetadataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeamUsersV1 = {
  __typename?: 'AuthoringTeamUsersV1';
  id: Scalars['String'];
  numTeams: Scalars['Int'];
  profile?: Maybe<TeamworkUserProfilesV1>;
  userId: Scalars['Int'];
};

export type AuthoringTeamUsersV1ByScope = {
  __typename?: 'AuthoringTeamUsersV1ByScope';
  connection?: Maybe<AuthoringTeamUsersV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamUsersV1Connection = {
  __typename?: 'AuthoringTeamUsersV1Connection';
  elements: Array<Maybe<AuthoringTeamUsersV1>>;
  paging: ResponsePagination;
};

export type AuthoringTeamUsersV1GetEligibleTeamMembers = {
  __typename?: 'AuthoringTeamUsersV1GetEligibleTeamMembers';
  connection?: Maybe<AuthoringTeamUsersV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  versionedTeamId: Scalars['String'];
};

export type AuthoringTeamUsersV1GetTeamMembers = {
  __typename?: 'AuthoringTeamUsersV1GetTeamMembers';
  connection?: Maybe<AuthoringTeamUsersV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  versionedTeamId: Scalars['String'];
};

export type AuthoringTeamUsersV1Resource = {
  __typename?: 'AuthoringTeamUsersV1Resource';
  byScope?: Maybe<AuthoringTeamUsersV1Connection>;
  getEligibleTeamMembers?: Maybe<AuthoringTeamUsersV1Connection>;
  getTeamMembers?: Maybe<AuthoringTeamUsersV1Connection>;
};


export type AuthoringTeamUsersV1ResourceByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamUsersV1ResourceGetEligibleTeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  versionedTeamId: Scalars['String'];
};


export type AuthoringTeamUsersV1ResourceGetTeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  versionedTeamId: Scalars['String'];
};

export type AuthoringTeammateReviewsV1 = {
  __typename?: 'AuthoringTeammateReviewsV1';
  draft?: Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_TeammateReviewDraftWithValidation>;
  id: Scalars['String'];
  published: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_TeammateReviewDraft;
  writeAccessState: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState;
  /** We used to have a lot of different models for conflict metadata accross the Authoring service. The FE doesn't need to know what fields are in conflict metadata because it is only useful for conflict detection. Therefore, to unify the behavior we encrypt all different types of conflict metadata into a string ((see [[WriteAccessTokenEncrypter]])), namely WriteAccessToken, and return it to the FE. If we don't want to grant write access to the FE, we would just not return the field. WriteAccessToken serves 2 purposes: write access control and conflict detection. */
  writeAccessToken?: Maybe<Scalars['String']>;
};

export type AuthoringTeammateReviewsV1Connection = {
  __typename?: 'AuthoringTeammateReviewsV1Connection';
  elements: Array<Maybe<AuthoringTeammateReviewsV1>>;
  paging: ResponsePagination;
};

export type AuthoringTeammateReviewsV1Resource = {
  __typename?: 'AuthoringTeammateReviewsV1Resource';
  get?: Maybe<AuthoringTeammateReviewsV1>;
  multiGet?: Maybe<AuthoringTeammateReviewsV1Connection>;
};


export type AuthoringTeammateReviewsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringTeammateReviewsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeammateReviewsV1ResourceMutations = {
  __typename?: 'AuthoringTeammateReviewsV1ResourceMutations';
  create?: Maybe<AuthoringTeammateReviewsV1Connection>;
  publish?: Maybe<Scalars['JSON']>;
  revert?: Maybe<Scalars['JSON']>;
  update?: Maybe<AuthoringTeammateReviewsV1Connection>;
};


export type AuthoringTeammateReviewsV1ResourceMutationsPublishArgs = {
  id: Scalars['String'];
};


export type AuthoringTeammateReviewsV1ResourceMutationsRevertArgs = {
  id: Scalars['String'];
};


export type AuthoringTeammateReviewsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_AiAuthorMember = {
  __typename?: 'AuthoringTeammateReviewsV1_aiAuthorMember';
  aiAuthor: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_AiAuthor;
};

export type AuthoringTeammateReviewsV1_AtLeastOneTeammateReviewQuestion = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_AtomicValidation = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_BoxViewDocumentAnnotationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_boxViewDocumentAnnotationMember';
  boxViewDocumentAnnotation: AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_BoxViewDocumentAnnotationSchema;
};

export type AuthoringTeammateReviewsV1_CmlMember = {
  __typename?: 'AuthoringTeammateReviewsV1_cmlMember';
  cml: AuthoringTeammateReviewsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type AuthoringTeammateReviewsV1_CreatedBy = AuthoringTeammateReviewsV1_AiAuthorMember | AuthoringTeammateReviewsV1_HumanAuthorMember;

export type AuthoringTeammateReviewsV1_Details = AuthoringTeammateReviewsV1_BoxViewDocumentAnnotationMember | AuthoringTeammateReviewsV1_MultiLineInputMember | AuthoringTeammateReviewsV1_OptionsMember | AuthoringTeammateReviewsV1_SingleLineInputMember | AuthoringTeammateReviewsV1_YesNoMember;

/** the pegasus schema for org.coursera.ondemand.content.Content. See https://phabricator.dkandu.me/D22517 */
export type AuthoringTeammateReviewsV1_Display = AuthoringTeammateReviewsV1_CmlMember | AuthoringTeammateReviewsV1_HtmlMember;

export type AuthoringTeammateReviewsV1_ExactOneStaffEvaluationQuestion = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_HtmlMember = {
  __typename?: 'AuthoringTeammateReviewsV1_htmlMember';
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  html: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_HumanAuthorMember = {
  __typename?: 'AuthoringTeammateReviewsV1_humanAuthorMember';
  humanAuthor: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_HumanAuthor;
};

export type AuthoringTeammateReviewsV1_Id = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_MultiLineInputMember = {
  __typename?: 'AuthoringTeammateReviewsV1_multiLineInputMember';
  multiLineInput: AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_MultiLineReviewSchema;
};

export type AuthoringTeammateReviewsV1_Name = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_OptionsMember = {
  __typename?: 'AuthoringTeammateReviewsV1_optionsMember';
  options: AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_OptionsReviewSchema;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_AiAuthor = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_assignment_AIAuthor';
  aiGenerationJobId: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_HumanAuthor = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_assignment_HumanAuthor';
  ArbitraryField: Scalars['String'];
};

export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = {
  Ai: 'AI',
  Auto: 'AUTO',
  Human: 'HUMAN'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType];
export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState = {
  AccessGranted: 'ACCESS_GRANTED',
  AtomVersionNotAtLatest: 'ATOM_VERSION_NOT_AT_LATEST',
  InsufficientPermissions: 'INSUFFICIENT_PERMISSIONS'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Conflict_WriteAccessState];
export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Project_Review_Validation_ReviewPartSchemaValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_project_review_validation_ReviewPartSchemaValidation';
  details: AuthoringTeammateReviewsV1_Details;
  id: AuthoringTeammateReviewsV1_Id;
  prompt: AuthoringTeammateReviewsV1_Prompt;
  submissionPartId: AuthoringTeammateReviewsV1_SubmissionPartId;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_TeammateReviewDraft = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_teammatereviewassessment_TeammateReviewDraft';
  assessmentSchema: AuthoringTeammateReviewsV1_Org_Coursera_Teammatereview_TeammateReviewAssessment;
  name: Scalars['String'];
  passingFraction?: Maybe<Scalars['Float']>;
  timeCommitment: Scalars['Float'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_TeammateReviewDraftWithValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_teammatereviewassessment_TeammateReviewDraftWithValidation';
  assessmentSchema: AuthoringTeammateReviewsV1_Org_Coursera_Teammatereview_TeammateReviewAssessment;
  name: Scalars['String'];
  passingFraction?: Maybe<Scalars['Float']>;
  timeCommitment: Scalars['Float'];
  validation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_Validation_TeammateReviewDraftValidation;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_Validation_TeammateReviewAssessmentValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_teammatereviewassessment_validation_TeammateReviewAssessmentValidation';
  atLeastOneTeammateReviewQuestion: AuthoringTeammateReviewsV1_AtLeastOneTeammateReviewQuestion;
  exactOneStaffEvaluationQuestion: AuthoringTeammateReviewsV1_ExactOneStaffEvaluationQuestion;
  staffEvaluationInstructions: AuthoringTeammateReviewsV1_StaffEvaluationInstructions;
  staffEvaluationQuestions: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Project_Review_Validation_ReviewPartSchemaValidation>>;
  teammateReviewInstructions: AuthoringTeammateReviewsV1_CmlMember;
  teammateReviewQuestions: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Project_Review_Validation_ReviewPartSchemaValidation>>;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_Validation_TeammateReviewDraftValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_teammatereviewassessment_validation_TeammateReviewDraftValidation';
  assessmentSchema: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Teammatereviewassessment_Validation_TeammateReviewAssessmentValidation;
  invalidMembers: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_AtomicValidationWithPath>>;
  name: AuthoringTeammateReviewsV1_Name;
  passingFraction: AuthoringTeammateReviewsV1_PassingFraction;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_AtomicValidationWithPath = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_AtomicValidationWithPath';
  atomicValidation: AuthoringTeammateReviewsV1_AtomicValidation;
  path: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_GenericValidation';
  message?: Maybe<Scalars['String']>;
  status: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_GenericValidationMember';
  org_coursera_authoring_validation_GenericValidation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidation;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_IntRangeValidation';
  actual: Scalars['Int'];
  includeMax?: Maybe<Scalars['Boolean']>;
  includeMin?: Maybe<Scalars['Boolean']>;
  max?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Int']>;
  status: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_IntRangeValidationMember';
  org_coursera_authoring_validation_IntRangeValidation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidation;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_NumericRangeValidation';
  actual: Scalars['Float'];
  includeMax?: Maybe<Scalars['Boolean']>;
  includeMin?: Maybe<Scalars['Boolean']>;
  max?: Maybe<Scalars['Float']>;
  message?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['Float']>;
  status: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_NumericRangeValidationMember';
  org_coursera_authoring_validation_NumericRangeValidation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidation;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_TextLengthValidation';
  actualLength: Scalars['Int'];
  maxLength?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  minLength?: Maybe<Scalars['Int']>;
  status: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_TextLengthValidationMember';
  org_coursera_authoring_validation_TextLengthValidation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidation;
};

export const AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus = {
  BadReference: 'BAD_REFERENCE',
  Dtd: 'DTD',
  Duplicate: 'DUPLICATE',
  Empty: 'EMPTY',
  Enum: 'ENUM',
  Format: 'FORMAT',
  Locked: 'LOCKED',
  NonEmpty: 'NON_EMPTY',
  Other: 'OTHER',
  Overlap: 'OVERLAP',
  TooLarge: 'TOO_LARGE',
  TooLong: 'TOO_LONG',
  TooShort: 'TOO_SHORT',
  TooSmall: 'TOO_SMALL',
  Valid: 'VALID'
} as const;

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus = typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus[keyof typeof AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus];
export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidation = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_WordCountValidation';
  actualCount: Scalars['Int'];
  maxCount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  minCount?: Maybe<Scalars['Int']>;
  status: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_ValidationStatus;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_authoring_validation_WordCountValidationMember';
  org_coursera_authoring_validation_WordCountValidation: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidation;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type AuthoringTeammateReviewsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: AuthoringTeammateReviewsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type AuthoringTeammateReviewsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type AuthoringTeammateReviewsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_BoxViewDocumentAnnotationSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_BoxViewDocumentAnnotationSchema';
  ArbitraryField: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_MultiLineReviewSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_MultiLineReviewSchema';
  points?: Maybe<Scalars['Float']>;
};

/** `points` are the points awarded for this option. If `isScored` is true in the schema, then `points` must be present. Otherwise, `points` must not be present. Notice that these are named `points` instead of `score` to distinguish them from scores which are the points that a particular user earns from a particular review. */
export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_OptionsOption = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_OptionsOption';
  display: AuthoringTeammateReviewsV1_Display;
  id: Scalars['String'];
  points?: Maybe<Scalars['Float']>;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_OptionsReviewSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_OptionsReviewSchema';
  isScored: Scalars['Boolean'];
  options: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_OptionsOption>>;
};

/** Note: This schema should remain in sync with org.coursera.assignment.assemblerfixes.ReviewPartSchema. */
export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_ReviewPartSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_ReviewPartSchema';
  createdBy?: Maybe<AuthoringTeammateReviewsV1_CreatedBy>;
  details: AuthoringTeammateReviewsV1_Details;
  graderType: AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType;
  id: Scalars['String'];
  prompt: AuthoringTeammateReviewsV1_Prompt;
  submissionPartId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<AuthoringTeammateReviewsV1_UpdatedBy>;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_SingleLineReviewSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_SingleLineReviewSchema';
  ArbitraryField: Scalars['String'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_YesNoPoints = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_YesNoPoints';
  no: Scalars['Float'];
  yes: Scalars['Float'];
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_YesNoReviewSchema = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_project_review_YesNoReviewSchema';
  points?: Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_YesNoPoints>;
};

export type AuthoringTeammateReviewsV1_Org_Coursera_Teammatereview_TeammateReviewAssessment = {
  __typename?: 'AuthoringTeammateReviewsV1_org_coursera_teammatereview_TeammateReviewAssessment';
  staffEvaluationInstructions?: Maybe<AuthoringTeammateReviewsV1_StaffEvaluationInstructions>;
  staffEvaluationQuestions: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_ReviewPartSchema>>;
  teammateReviewInstructions?: Maybe<AuthoringTeammateReviewsV1_CmlMember>;
  teammateReviewQuestions: Array<Maybe<AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_ReviewPartSchema>>;
};

export type AuthoringTeammateReviewsV1_PassingFraction = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_Prompt = AuthoringTeammateReviewsV1_CmlMember | AuthoringTeammateReviewsV1_HtmlMember;

export type AuthoringTeammateReviewsV1_SingleLineInputMember = {
  __typename?: 'AuthoringTeammateReviewsV1_singleLineInputMember';
  singleLineInput: AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_SingleLineReviewSchema;
};

export type AuthoringTeammateReviewsV1_StaffEvaluationInstructions = AuthoringTeammateReviewsV1_CmlMember | DummyType;

export type AuthoringTeammateReviewsV1_SubmissionPartId = AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_GenericValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_IntRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_NumericRangeValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_TextLengthValidationMember | AuthoringTeammateReviewsV1_Org_Coursera_Authoring_Validation_WordCountValidationMember;

export type AuthoringTeammateReviewsV1_UpdatedBy = AuthoringTeammateReviewsV1_AiAuthorMember | AuthoringTeammateReviewsV1_HumanAuthorMember;

export type AuthoringTeammateReviewsV1_YesNoMember = {
  __typename?: 'AuthoringTeammateReviewsV1_yesNoMember';
  yesNo: AuthoringTeammateReviewsV1_Org_Coursera_Project_Review_YesNoReviewSchema;
};

export type AuthoringTeamsV1 = {
  __typename?: 'AuthoringTeamsV1';
  authoringScopeMetadata?: Maybe<AuthoringScopeMetadataV1>;
  createdAt?: Maybe<Scalars['Float']>;
  eligibleTeamMembers?: Maybe<AuthoringTeamUsersV1Connection>;
  id: Scalars['String'];
  memberProfiles?: Maybe<TeamworkUserProfilesV1Connection>;
  members: Array<Maybe<Scalars['Int']>>;
  name: Scalars['String'];
  scopeId: Scalars['String'];
  slackIntegrationMetadata?: Maybe<AuthoringTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata>;
  teamMembers?: Maybe<AuthoringTeamUsersV1Connection>;
  teamMetaData?: Maybe<AuthoringTeamMetadataV1>;
  updatedAt?: Maybe<Scalars['Float']>;
  versionedTeamId: Scalars['String'];
};


export type AuthoringTeamsV1EligibleTeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamsV1MemberProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamsV1TeamMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeamsV1ByScope = {
  __typename?: 'AuthoringTeamsV1ByScope';
  connection?: Maybe<AuthoringTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamsV1Connection = {
  __typename?: 'AuthoringTeamsV1Connection';
  elements: Array<Maybe<AuthoringTeamsV1>>;
  paging: ResponsePagination;
};

export type AuthoringTeamsV1Latest = {
  __typename?: 'AuthoringTeamsV1Latest';
  connection?: Maybe<AuthoringTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedTeamId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamsV1MultiLatest = {
  __typename?: 'AuthoringTeamsV1MultiLatest';
  connection?: Maybe<AuthoringTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedTeamIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamsV1Resource = {
  __typename?: 'AuthoringTeamsV1Resource';
  byScope?: Maybe<AuthoringTeamsV1Connection>;
  get?: Maybe<AuthoringTeamsV1>;
  latest?: Maybe<AuthoringTeamsV1Connection>;
  multiGet?: Maybe<AuthoringTeamsV1Connection>;
  multiLatest?: Maybe<AuthoringTeamsV1Connection>;
};


export type AuthoringTeamsV1ResourceByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringTeamsV1ResourceLatestArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopedTeamId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamsV1ResourceMultiLatestArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopedTeamIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeamsV1ResourceMutations = {
  __typename?: 'AuthoringTeamsV1ResourceMutations';
  addSlackIntegrationMetadata?: Maybe<Scalars['JSON']>;
  autoCreate?: Maybe<Scalars['JSON']>;
  canReadTeamsForGroup?: Maybe<Scalars['JSON']>;
  create?: Maybe<AuthoringTeamsV1Connection>;
  delete?: Maybe<AuthoringTeamsV1Connection>;
  deleteTeams?: Maybe<Scalars['JSON']>;
  multiDelete?: Maybe<Scalars['JSON']>;
  update?: Maybe<AuthoringTeamsV1Connection>;
};


export type AuthoringTeamsV1ResourceMutationsAddSlackIntegrationMetadataArgs = {
  id: Scalars['String'];
};


export type AuthoringTeamsV1ResourceMutationsCanReadTeamsForGroupArgs = {
  groupId: Scalars['String'];
};


export type AuthoringTeamsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type AuthoringTeamsV1ResourceMutationsMultiDeleteArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  scopeId: Scalars['String'];
};


export type AuthoringTeamsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type AuthoringTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata = {
  __typename?: 'AuthoringTeamsV1_org_coursera_teamwork_SlackIntegrationMetadata';
  slackGroupId: Scalars['String'];
  slackTeamDomain?: Maybe<Scalars['String']>;
  slackTeamId: Scalars['String'];
};

export type AuthoringTeamworkScopesV1 = {
  __typename?: 'AuthoringTeamworkScopesV1';
  allMembers?: Maybe<AuthoringTeamUsersV1Connection>;
  id: Scalars['String'];
  metadata: AuthoringTeamworkScopesV1_Org_Coursera_Authoring_Teamwork_AuthoringScopeMetadata;
};


export type AuthoringTeamworkScopesV1AllMembersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringTeamworkScopesV1ByGroup = {
  __typename?: 'AuthoringTeamworkScopesV1ByGroup';
  connection?: Maybe<AuthoringTeamworkScopesV1Connection>;
  groupId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamworkScopesV1ByNonHighEngagementGroup = {
  __typename?: 'AuthoringTeamworkScopesV1ByNonHighEngagementGroup';
  connection?: Maybe<AuthoringTeamworkScopesV1Connection>;
  groupId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringTeamworkScopesV1Connection = {
  __typename?: 'AuthoringTeamworkScopesV1Connection';
  elements: Array<Maybe<AuthoringTeamworkScopesV1>>;
  paging: ResponsePagination;
};

export type AuthoringTeamworkScopesV1Resource = {
  __typename?: 'AuthoringTeamworkScopesV1Resource';
  byGroup?: Maybe<AuthoringTeamworkScopesV1Connection>;
  byNonHighEngagementGroup?: Maybe<AuthoringTeamworkScopesV1Connection>;
  get?: Maybe<AuthoringTeamworkScopesV1>;
};


export type AuthoringTeamworkScopesV1ResourceByGroupArgs = {
  groupId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamworkScopesV1ResourceByNonHighEngagementGroupArgs = {
  groupId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringTeamworkScopesV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type AuthoringTeamworkScopesV1ResourceMutations = {
  __typename?: 'AuthoringTeamworkScopesV1ResourceMutations';
  create?: Maybe<AuthoringTeamworkScopesV1Connection>;
  publish?: Maybe<Scalars['JSON']>;
  revert?: Maybe<Scalars['JSON']>;
};

export type AuthoringTeamworkScopesV1_Org_Coursera_Authoring_Teamwork_AuthoringScopeMetadata = {
  __typename?: 'AuthoringTeamworkScopesV1_org_coursera_authoring_teamwork_AuthoringScopeMetadata';
  publishedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  publishedBy?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Float'];
  /** id for a Coursera user */
  updatedBy: Scalars['Int'];
  version: Scalars['Int'];
};

export type AuthoringUserCoursePermissionsV1 = {
  __typename?: 'AuthoringUserCoursePermissionsV1';
  id: Scalars['String'];
  permissions: Scalars['JSON'];
};

export type AuthoringUserCoursePermissionsV1Connection = {
  __typename?: 'AuthoringUserCoursePermissionsV1Connection';
  elements: Array<Maybe<AuthoringUserCoursePermissionsV1>>;
  paging: ResponsePagination;
};

export type AuthoringUserCoursePermissionsV1My = {
  __typename?: 'AuthoringUserCoursePermissionsV1My';
  connection?: Maybe<AuthoringUserCoursePermissionsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringUserCoursePermissionsV1Resource = {
  __typename?: 'AuthoringUserCoursePermissionsV1Resource';
  get?: Maybe<AuthoringUserCoursePermissionsV1>;
  multiGet?: Maybe<AuthoringUserCoursePermissionsV1Connection>;
  my?: Maybe<AuthoringUserCoursePermissionsV1Connection>;
};


export type AuthoringUserCoursePermissionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringUserCoursePermissionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringUserCoursePermissionsV1ResourceMyArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringWorkspaceTemplatesV1 = {
  __typename?: 'AuthoringWorkspaceTemplatesV1';
  description?: Maybe<Scalars['String']>;
  entryPoints: Array<Maybe<AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_Authoring_WorkspaceEntryPoint>>;
  id: Scalars['String'];
  imageTag: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  publishStatus?: Maybe<WorkspacePublishStatesV1>;
  publishedTemplate?: Maybe<WorkspaceTemplatesV1Connection>;
  publishedTemplateId?: Maybe<Scalars['String']>;
  sharedWorkspace: AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_SharedWorkspace;
  updatedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  updatedBy?: Maybe<Scalars['Int']>;
  volumeMountPaths: Array<Maybe<AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_Authoring_VolumeMountPath>>;
  volumes: Scalars['JSON'];
};


export type AuthoringWorkspaceTemplatesV1PublishedTemplateArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringWorkspaceTemplatesV1ByCourseAndImage = {
  __typename?: 'AuthoringWorkspaceTemplatesV1ByCourseAndImage';
  connection?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  courseId: Scalars['String'];
  imageTag: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type AuthoringWorkspaceTemplatesV1Connection = {
  __typename?: 'AuthoringWorkspaceTemplatesV1Connection';
  elements: Array<Maybe<AuthoringWorkspaceTemplatesV1>>;
  paging: ResponsePagination;
};

export type AuthoringWorkspaceTemplatesV1Resource = {
  __typename?: 'AuthoringWorkspaceTemplatesV1Resource';
  byCourseAndImage?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  get?: Maybe<AuthoringWorkspaceTemplatesV1>;
  multiGet?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
};


export type AuthoringWorkspaceTemplatesV1ResourceByCourseAndImageArgs = {
  courseId: Scalars['String'];
  imageTag: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type AuthoringWorkspaceTemplatesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type AuthoringWorkspaceTemplatesV1ResourceMutations = {
  __typename?: 'AuthoringWorkspaceTemplatesV1ResourceMutations';
  asyncPublish?: Maybe<Scalars['JSON']>;
  create?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  delete?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  fork?: Maybe<Scalars['JSON']>;
  patch?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  publish?: Maybe<Scalars['JSON']>;
  removeFromCourse?: Maybe<Scalars['JSON']>;
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsAsyncPublishArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsForkArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsPublishArgs = {
  id: Scalars['String'];
};


export type AuthoringWorkspaceTemplatesV1ResourceMutationsRemoveFromCourseArgs = {
  courseId: Scalars['String'];
  id: Scalars['String'];
};

export type AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_SharedWorkspace = {
  __typename?: 'AuthoringWorkspaceTemplatesV1_org_coursera_workspace_SharedWorkspace';
  workspaceId: Scalars['String'];
};

/** Computed view of the volume definition. */
export type AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_Authoring_VolumeMountPath = {
  __typename?: 'AuthoringWorkspaceTemplatesV1_org_coursera_workspace_authoring_VolumeMountPath';
  isDeletable: Scalars['Boolean'];
  isPathRenamable: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  path: Scalars['String'];
};

export type AuthoringWorkspaceTemplatesV1_Org_Coursera_Workspace_Authoring_WorkspaceEntryPoint = {
  __typename?: 'AuthoringWorkspaceTemplatesV1_org_coursera_workspace_authoring_WorkspaceEntryPoint';
  authoringCourseBranchId: Scalars['String'];
  courseId: Scalars['String'];
  embeddedContentSourceCourseId?: Maybe<Scalars['String']>;
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

/** AuthorizationError is one of the standard errors, used for authorization errors. */
export type AuthorizationError = ErrorDetails & {
  __typename?: 'AuthorizationError';
  /**
   * Error code that can be used by our tooling for error metrics.
   *
   * When developer defines a new custom error using the ErrorDetails interface,
   * they should use the name of the custom error as the errorCode.
   */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/**
 * Input type @authorization directive.
 * Any @authorization directive usage must specify at least one AuthorizationKey.
 */
export type AuthorizationKey = {
  /**
   * The list of additional inputs required by the authorization implementation for the
   * corresponding authorization key.
   *
   * The elements of this list are JSON path styled strings that point to the input field(s)
   * of the decorated GraphQL field, or their nested field(s).
   *
   * The length of this list must match the expected number of additional inputs defined in the
   * graphql-configurations.yaml file for the corresponding authorization key.
   *
   * The order of the elements are important, please make sure they are provided in the exact
   * order that the authorizer implementation would expect.
   *
   * Examples:
   * - ["courseId"]
   * - ["courseId", "userId"]
   * - ["queryInput.userId"]
   */
  inputPaths?: InputMaybe<Array<Scalars['String']>>;
  /**
   * The key of the authorization in string format.
   * All authorization keys must be defined properly in the graphql-configurations.yaml file,
   * with a brief description and the expected number of additional inputs.
   *
   * The key follows a hierarchical structure, separated by dots.
   * Examples:
   * - 'core.loggedIn'
   * - 'core.courserian'
   */
  key: Scalars['String'];
};

/** Queries related to AutoProctor functionality. */
export type AutoProctorQueries = {
  __typename?: 'AutoProctorQueries';
  /** Get credentials to authenticate when calling AutoProctor API (private sessions). */
  queryAutoProctorCredentials?: Maybe<AutoProctor_AutoProctorCredentials>;
  /** Get credentials to authenticate when calling AutoProctor API (public sessions). */
  queryCourseScopedAutoProctorCredentials?: Maybe<AutoProctor_AutoProctorCredentials>;
};


/** Queries related to AutoProctor functionality. */
export type AutoProctorQueriesQueryAutoProctorCredentialsArgs = {
  assessmentId: Scalars['ID'];
  message: Scalars['String'];
  sessionId: Scalars['ID'];
};


/** Queries related to AutoProctor functionality. */
export type AutoProctorQueriesQueryCourseScopedAutoProctorCredentialsArgs = {
  assessmentId: Scalars['ID'];
  courseId: Scalars['ID'];
  message: Scalars['String'];
};

/** AutoProctor credentials used to authenticate when calling AutoProctor API. */
export type AutoProctor_AutoProctorCredentials = {
  __typename?: 'AutoProctor_AutoProctorCredentials';
  /** AutoProctor client ID which is a part of the key pair. */
  clientId: Scalars['ID'];
  /** The value that was signed. */
  message: Scalars['String'];
  /** The signature of the message signed using the secret key. */
  signature: Scalars['String'];
};

/** Autograder analytics queries. */
export type AutograderAnalyticsQueries = {
  __typename?: 'AutograderAnalyticsQueries';
  /** query to get analytics summary for a given learner/course/item. */
  queryGraderRunAnalyticsSummary: Autograder_RunAnalyticsSummary;
  /**
   * query to get score analytics for a given learner/course/item.
   * it will fetch the best score by that learner, and how they rank compared to others.
   */
  queryGraderRunScoreAnalytics?: Maybe<Autograder_RunAnalytics>;
};


/** Autograder analytics queries. */
export type AutograderAnalyticsQueriesQueryGraderRunAnalyticsSummaryArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  learnerId: Scalars['ID'];
};


/** Autograder analytics queries. */
export type AutograderAnalyticsQueriesQueryGraderRunScoreAnalyticsArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  learnerId: Scalars['ID'];
};

/** Generic type that contains all types of metrics for a grader. */
export type Autograder_GraderAnalytics = {
  __typename?: 'Autograder_GraderAnalytics';
  /** Average of all the numbers for given metric in the grader. */
  average: Scalars['Float'];
  /** Maximum of all the numbers for given metric in the grader. */
  max: Scalars['Float'];
  /** Median of all the numbers for given metric in the grader. */
  median: Scalars['Float'];
  /** Minimum of all the numbers for given metric in the grader. */
  min: Scalars['Float'];
};

/** Metric type. */
export const Autograder_MetricType = {
  /** Number of Attempts */
  Attempts: 'ATTEMPTS',
  /** Memory usage in MB. */
  MemoryUsage: 'MEMORY_USAGE',
  /** Performance/runtime in milliseconds. */
  Performance: 'PERFORMANCE',
  /** The score (aka grade) of the submission in percent (rounded to 2 decimal places). */
  Score: 'SCORE'
} as const;

export type Autograder_MetricType = typeof Autograder_MetricType[keyof typeof Autograder_MetricType];
/** Generic type that supports all types of metrics for grader run. */
export type Autograder_RunAnalytics = {
  __typename?: 'Autograder_RunAnalytics';
  /** metric type for each type of analytics. */
  metricType: Autograder_MetricType;
  /** Percentile corresponding to the actual value for the given run and metric. */
  percentile: Scalars['Float'];
  /** Analytics at the grader level for the corresponding item (which generally corresponds to a grader). */
  summary: Autograder_GraderAnalytics;
  /** Actual value for the given run and metric. */
  value: Scalars['Float'];
};

/** Contains summary of analytics for various metrics. */
export type Autograder_RunAnalyticsSummary = {
  __typename?: 'Autograder_RunAnalyticsSummary';
  /**
   * List of analytics for each metric type.
   * null is a possible case when analytics doesn't exist for a given learner/course/item or not supported.
   */
  analytics?: Maybe<Array<Autograder_RunAnalytics>>;
};

/** Generic type that contains analytics for a test case. */
export type Autograder_TestCaseAnalytics = {
  __typename?: 'Autograder_TestCaseAnalytics';
  /** Count of students that failed this test case. */
  failCount: Scalars['Int'];
  /** Count of students that passed this test case. */
  passCount: Scalars['Int'];
  /** Count of students that did not attempt this test case. */
  skipCount: Scalars['Int'];
  /** Id of the test case that these analytics correspond to. */
  testCaseId: Scalars['ID'];
  /** Numerical label for the test case within the assignment. */
  testCaseLabel: Scalars['String'];
  /** Count of all students who submitted the assignment. */
  totalCount: Scalars['Int'];
};

/** Contains summary of analytics for an assignment that has multiple test cases. */
export type Autograder_TestCaseAnalyticsPaginatedResult = {
  __typename?: 'Autograder_TestCaseAnalyticsPaginatedResult';
  /** List of analytics for each test case. */
  elements: Array<Autograder_TestCaseAnalytics>;
  /** Contains information for paginating the collection */
  pagination: Pagination;
};

/** Status of a test case evaluation will always either be PASS, FAIL, or SKIP */
export const Autograder_TestCaseEvaluationStatus = {
  /** Test case errored out */
  Error: 'ERROR',
  /** Test case failed */
  Fail: 'FAIL',
  /** Test case passed */
  Pass: 'PASS',
  /** Test case skipped */
  Skip: 'SKIP'
} as const;

export type Autograder_TestCaseEvaluationStatus = typeof Autograder_TestCaseEvaluationStatus[keyof typeof Autograder_TestCaseEvaluationStatus];
/** Contains a learner and their respective result for a single test case. */
export type Autograder_TestCaseLearnerResult = {
  __typename?: 'Autograder_TestCaseLearnerResult';
  /** URL of feedback. */
  feedbackUrl: Scalars['URL'];
  /** Id of learner. */
  learnerId: Scalars['ID'];
  /** Name of learner. */
  learnerName: Scalars['String'];
  /** Status of test case evaluation. */
  testResult: Autograder_TestCaseEvaluationStatus;
};

/** Contains a paginated collection of learner results for a given test case. */
export type Autograder_TestCaseLearnerResultsPaginatedResult = {
  __typename?: 'Autograder_TestCaseLearnerResultsPaginatedResult';
  /** List of results on an individual learner basis for a given test case. */
  elements: Array<Autograder_TestCaseLearnerResult>;
  /** Contains information for paginating the collection */
  pagination: Pagination;
};

/** Backfilled weekly streak for a learner before experiment launch. */
export type BackfilledLearnerStreaks_Streak = {
  __typename?: 'BackfilledLearnerStreaks_Streak';
  /** The number of weeks the learner has consistently learned before experiment launch. */
  streakCount: Scalars['Int'];
};

/** Badge Queries */
export type BadgeQueries = {
  __typename?: 'BadgeQueries';
  /**
   * This query returns an issued badge based on an issued badge id.
   * Note: This query is public and does not require authentication.
   */
  byIssuedBadgeId: Badge_IssuedBadgePublic;
  /**
   * Get Credly badge template mappings in pages. When cursor is omitted, results start from the
   * beginning of the collection.
   */
  getAllCredlyBadgeTemplateMappings: Badge_CredlyBadgeTemplateMappingPaginatedResult;
  /** Get a Credly badge template mapping by product ID. Returns null if no mapping exists. */
  getCredlyBadgeTemplateMapping?: Maybe<Badge_CredlyBadgeTemplateMapping>;
  /** This query returns a badge template based on a badge template id. */
  queryBadgeTemplateById: Badge_BadgeTemplate;
  /** Query a user's badges by course */
  queryByUserAndCourse: Badge_UserCourseBadges;
  /** This query returns all enterprise badge collections for a program with user states. */
  queryCountByBadgeTemplateAndStates: Badge_CountByBadgeTemplateAndStatesResult;
};


/** Badge Queries */
export type BadgeQueriesByIssuedBadgeIdArgs = {
  issuedBadgeId: Scalars['ID'];
};


/** Badge Queries */
export type BadgeQueriesGetAllCredlyBadgeTemplateMappingsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Badge Queries */
export type BadgeQueriesGetCredlyBadgeTemplateMappingArgs = {
  productId: Scalars['ID'];
};


/** Badge Queries */
export type BadgeQueriesQueryBadgeTemplateByIdArgs = {
  badgeTemplateId: Scalars['ID'];
};


/** Badge Queries */
export type BadgeQueriesQueryByUserAndCourseArgs = {
  courseId: Scalars['ID'];
};


/** Badge Queries */
export type BadgeQueriesQueryCountByBadgeTemplateAndStatesArgs = {
  badgeTemplateId: Scalars['ID'];
  programId: Scalars['ID'];
  userStates: Array<Badge_UserState>;
};

/** One of the possible badge activities */
export type Badge_BadgeActivity = Badge_CourseActivity;

/** Input for badge name style customization */
export type Badge_BadgeNameStyle = {
  /** Badge Name Font Color */
  fontColor?: InputMaybe<Scalars['String']>;
  /** Badge Name Font Size */
  fontSize?: Scalars['Int'];
  /** Badge Name Font Style */
  fontStyle?: InputMaybe<Badge_StringFontStyle>;
};

/** Enum that defines where the badge was initially created. */
export const Badge_BadgeSource = {
  /** COURSERA */
  Coursera: 'COURSERA',
  /** CREDLY */
  Credly: 'CREDLY'
} as const;

export type Badge_BadgeSource = typeof Badge_BadgeSource[keyof typeof Badge_BadgeSource];
/** Badge State Count */
export type Badge_BadgeStateCountRecord = {
  __typename?: 'Badge_BadgeStateCountRecord';
  /** Count */
  count: Scalars['Int'];
  /** User state */
  userState: Badge_UserState;
};

/** Badge template. */
export type Badge_BadgeTemplate = {
  __typename?: 'Badge_BadgeTemplate';
  /** Badge activities. */
  activities?: Maybe<Array<Badge_BadgeActivity>>;
  /** Badge source. */
  badgeSource: Badge_BadgeSource;
  /** The id of a badge template. */
  badgeTemplateId: Scalars['ID'];
  /** Badge template created time. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Badge description. */
  description: Scalars['String'];
  /**
   * URL of the badge image.
   * This image will be displayed on our badge surfaces,
   * such as the issued badge page, course home, and user profile.
   */
  imageUrl: Scalars['URL'];
  /** Badge issuer id. */
  issuerId: Scalars['ID'];
  /** Badge issuer type. */
  issuerType: Badge_IssuerType;
  /** Badge learning objectives. */
  learningObjectives?: Maybe<Array<Scalars['String']>>;
  /**
   * URL of the meta image url.
   * This image will be used for meta tags to support social sharing.
   */
  metaImageUrl: Scalars['URL'];
  /**
   * URL of the badge description page.
   * Depending on the type of badge, the badge description page can vary.
   * For example, the previewUrl of an ELP badge links to the XDP of the ELP badge.
   */
  previewUrl: Scalars['URL'];
  /** Skills of the badge. */
  skills?: Maybe<Array<Skill_Skill>>;
  /** Badge slug. */
  slug: Scalars['String'];
  /** Badge title. */
  title: Scalars['String'];
  /** Badge template updated time. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Count By Badge Template And States Result */
export type Badge_CountByBadgeTemplateAndStatesResult = {
  __typename?: 'Badge_CountByBadgeTemplateAndStatesResult';
  /** A list of badge user state and count mapping */
  result: Array<Badge_BadgeStateCountRecord>;
};

/** Badge course activity. */
export type Badge_CourseActivity = {
  __typename?: 'Badge_CourseActivity';
  /** Activity product. */
  course: Course_Course;
};

/** Input for creating or updating one or more Credly badge template mappings. */
export type Badge_CreateOrUpdateCredlyBadgeTemplateMappingInput = {
  /** One or more mappings to create or update. */
  mappings: Array<Badge_CredlyBadgeTemplateMappingInput>;
};

/** Result of creating or updating Credly badge template mappings. */
export type Badge_CreateOrUpdateCredlyBadgeTemplateMappingResult = {
  __typename?: 'Badge_CreateOrUpdateCredlyBadgeTemplateMappingResult';
  /** The created or updated Credly badge template mappings. */
  mappings: Array<Badge_CredlyBadgeTemplateMapping>;
};

/** A mapping between a Coursera product and a Credly badge template. */
export type Badge_CredlyBadgeTemplateMapping = {
  __typename?: 'Badge_CredlyBadgeTemplateMapping';
  /** The Credly badge template ID associated with this product. */
  badgeTemplateId: Scalars['ID'];
  /** The product ID (e.g., course ID or specialization ID) associated with this mapping. */
  productId: Scalars['ID'];
  /** Timestamp of the last update. */
  updatedAt: Scalars['DateTime'];
  /** The user who last updated this mapping. */
  updatedBy: Scalars['ID'];
};

/** A single product-to-badge-template mapping entry. */
export type Badge_CredlyBadgeTemplateMappingInput = {
  /** The Credly badge template ID to associate with this product. */
  badgeTemplateId: Scalars['ID'];
  /** The product ID (e.g., course ID or specialization ID). */
  productId: Scalars['ID'];
};

/** Paginated list of Credly badge template mappings. */
export type Badge_CredlyBadgeTemplateMappingPaginatedResult = {
  __typename?: 'Badge_CredlyBadgeTemplateMappingPaginatedResult';
  /** Mappings in the current page. */
  elements: Array<Badge_CredlyBadgeTemplateMapping>;
  /** Pagination metadata for fetching additional pages. */
  pagination: Pagination;
};

/** Input for deleting a Credly badge template mapping. */
export type Badge_DeleteCredlyBadgeTemplateMappingInput = {
  /** The product ID of the mapping to delete. */
  productId: Scalars['ID'];
};

/** Result of deleting a Credly badge template mapping. */
export type Badge_DeleteCredlyBadgeTemplateMappingResult = {
  __typename?: 'Badge_DeleteCredlyBadgeTemplateMappingResult';
  /** True if the mapping was deleted, false if no mapping existed. */
  success: Scalars['Boolean'];
};

/** Issued badge data. */
export type Badge_IssuedBadge = {
  __typename?: 'Badge_IssuedBadge';
  /** The badge template that the user enrolled or earned. */
  badgeTemplate: Badge_BadgeTemplate;
  /** Time when the badge is issued to the user. */
  issuedAt?: Maybe<Scalars['DateTime']>;
  /** UUID of the issued badge */
  issuedBadgeId: Scalars['ID'];
  /** Badge issuing platform, e.g. Coursera, Credly */
  issuedBadgeSource: Badge_BadgeSource;
};

/** User badge data for public access. */
export type Badge_IssuedBadgePublic = {
  __typename?: 'Badge_IssuedBadgePublic';
  /** The badge template that the user enrolled or earned. */
  badgeTemplate: Badge_BadgeTemplate;
  /** Indicates if the badge is owned by the current user. */
  isOwnedByMe: Scalars['Boolean'];
  /** Time when the badge is issued to the user. */
  issuedAt?: Maybe<Scalars['DateTime']>;
  /** UUID of the issued badge */
  issuedBadgeId: Scalars['ID'];
  /** Badge issuing platform, e.g. COURSERA, CREDLY */
  issuedBadgeSource: Badge_BadgeSource;
  /** The full name of the user that earned a badge. */
  userName: Scalars['String'];
};

/** Enum that defines all supported badge issuer type. */
export const Badge_IssuerType = {
  /** ENTERPRISE_ORG */
  EnterpriseOrg: 'ENTERPRISE_ORG'
} as const;

export type Badge_IssuerType = typeof Badge_IssuerType[keyof typeof Badge_IssuerType];
/** Input for Open Badge image creation */
export type Badge_OpenBadgeImageGenerationInput = {
  /** Issued Badge ID */
  issuedBadgeId: Scalars['ID'];
  /** Open Badge Version */
  openBadgeVersion: Badge_OpenBadgeVersion;
};

/** Response for Open badge generation mutation */
export type Badge_OpenBadgeImageGenerationResult = {
  __typename?: 'Badge_OpenBadgeImageGenerationResult';
  /** Stored Open Badge image location */
  openBadgeImageUrl: Scalars['URL'];
};

/** Enum that defines all supported Open Badges version. */
export const Badge_OpenBadgeVersion = {
  /** Open badge version 2.0 */
  V2_0: 'V2_0',
  /** Open badge version 3.0 */
  V3_0: 'V3_0'
} as const;

export type Badge_OpenBadgeVersion = typeof Badge_OpenBadgeVersion[keyof typeof Badge_OpenBadgeVersion];
/** Input for badge creation */
export type Badge_PreviewGeneratorInput = {
  /** Badge logo image URL */
  badgeImage?: InputMaybe<Scalars['URL']>;
  /** Badge logo height */
  badgeLogoHeight?: Scalars['Int'];
  /** Badge name */
  badgeName: Scalars['String'];
  /** Badge Name Style */
  badgeNameStyle?: InputMaybe<Badge_BadgeNameStyle>;
  /** Program ID */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Response for Badge preview generate mutation */
export type Badge_PreviewGeneratorResult = {
  __typename?: 'Badge_PreviewGeneratorResult';
  /** Stored preview image loction */
  previewLocation?: Maybe<Scalars['URL']>;
  /** Flag indicating if the preview generation was successful */
  success: Scalars['Boolean'];
};

/** Enum for badge sources */
export const Badge_Source = {
  /** A badge created internally on Coursera */
  Coursera: 'COURSERA',
  /** A badge created externally on Credly */
  Credly: 'CREDLY'
} as const;

export type Badge_Source = typeof Badge_Source[keyof typeof Badge_Source];
/** Badge font Enum */
export const Badge_StringFontStyle = {
  /** Italic */
  Italic: 'ITALIC',
  /** Normal */
  Normal: 'NORMAL'
} as const;

export type Badge_StringFontStyle = typeof Badge_StringFontStyle[keyof typeof Badge_StringFontStyle];
/** A federated Entity representing the list of badges issued to a user */
export type Badge_UserBadges = {
  __typename?: 'Badge_UserBadges';
  /** The requested badges for the user-id */
  badges?: Maybe<Array<Badge_IssuedBadge>>;
};

/** A federated entity representing the list of badges issued to a user within a course */
export type Badge_UserCourseBadges = {
  __typename?: 'Badge_UserCourseBadges';
  /** The requested badges for the user-id and course id */
  badges: Array<Badge_IssuedBadge>;
  /** Course for which badges were issued */
  course: Course_Course;
  /** User entity stub for a coursera user (only included as its needed to make the entity uniquely identifiable) */
  user: User_User;
};

/** Enum that defines all possible user states for a badge */
export const Badge_UserState = {
  /** ENROLLED */
  Enrolled: 'ENROLLED',
  /** ISSUED */
  Issued: 'ISSUED',
  /** NEVER ENROLLED */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** UNENROLLED */
  Unenrolled: 'UNENROLLED'
} as const;

export type Badge_UserState = typeof Badge_UserState[keyof typeof Badge_UserState];
/** banneradcampaigns GraphQL Schema */
export type BannerAdCampaignQueries = {
  __typename?: 'BannerAdCampaignQueries';
  /** Query the banner ad campaign by ID and placement. */
  queryByIdAndPlacement: BannerAdCampaign_BannerAdCampaign;
  /**
   * This query returns the banner ad campaigns that can be shown on the given placement. Besides the explicitly
   * requested placement, the banner server considers other criteria too (e.g. user targeting) before deciding which
   * banners to return.
   */
  queryByPlacement?: Maybe<Array<Maybe<BannerAdCampaign_BannerAdCampaign>>>;
};


/** banneradcampaigns GraphQL Schema */
export type BannerAdCampaignQueriesQueryByIdAndPlacementArgs = {
  id: Scalars['ID'];
  placement: BannerAdCampaign_Placement;
};


/** banneradcampaigns GraphQL Schema */
export type BannerAdCampaignQueriesQueryByPlacementArgs = {
  bannerCount: Scalars['Int'];
  debug?: InputMaybe<Scalars['Boolean']>;
  isBannerCountExact?: InputMaybe<Scalars['Boolean']>;
  placement: BannerAdCampaign_Placement;
};

/** A banner ad campaign that's intended to be used by clients trying to display the banner to learners. */
export type BannerAdCampaign_BannerAdCampaign = {
  __typename?: 'BannerAdCampaign_bannerAdCampaign';
  /** TODO: Complete this description */
  callToActionUrl: Scalars['String'];
  /** TODO: Complete this description */
  creative?: Maybe<BannerAdCampaign_Creative>;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** Human-readable name for internal identification; not needed for rendering banner ad. */
  internalName: Scalars['String'];
  /** The intended display placement as computed by the server. */
  placement?: Maybe<BannerAdCampaign_Placement>;
  /** For clients to pass along in eventing data. */
  promotedEntityId?: Maybe<Scalars['String']>;
};

/** The data for visually rendering the ad itself. */
export type BannerAdCampaign_Creative = {
  __typename?: 'BannerAdCampaign_creative';
  /** TODO: Complete this description */
  backgroundColor: Scalars['String'];
  /** TODO: Complete this description */
  bodyText: Scalars['String'];
  /** TODO: Complete this description */
  callToActionText: Scalars['String'];
  /** TODO: Complete this description */
  creativeSlug: Scalars['String'];
  /** TODO: Complete this description */
  imageUrl: Scalars['String'];
  /** TODO: Complete this description */
  partnerName?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  titleText: Scalars['String'];
};

/** The places where a banner ad can be displayed are called placements. */
export const BannerAdCampaign_Placement = {
  /** Articles */
  Article: 'ARTICLE',
  /** Browse domain pages */
  BrowseDomain: 'BROWSE_DOMAIN',
  /** TODO: Complete this description */
  BrowseHome: 'BROWSE_HOME',
  /** Browse subdomain pages */
  BrowseSubdomain: 'BROWSE_SUBDOMAIN',
  /** TODO: Complete this description */
  LoggedInDashboard: 'LOGGED_IN_DASHBOARD',
  /** Menu expandable from page header */
  Megamenu: 'MEGAMENU',
  /** Weekly recommendations email */
  WeeklyRecsEmail: 'WEEKLY_RECS_EMAIL'
} as const;

export type BannerAdCampaign_Placement = typeof BannerAdCampaign_Placement[keyof typeof BannerAdCampaign_Placement];
/** Beta testing schedule model. */
export type BetaTestingSchedule = Node & {
  __typename?: 'BetaTestingSchedule';
  /** Group Id of the beta testing. */
  groupId?: Maybe<Scalars['ID']>;
  /** Course id of the beta testing schedule. Each course can have only one beta testing schedule at a time. */
  id: Scalars['ID'];
  /** Date and time at which the beta test was started. */
  startedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Type to encapsulate all the queries for BetaTestingSchedule as per:
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Conventions
 */
export type BetaTestingScheduleQueries = {
  __typename?: 'BetaTestingScheduleQueries';
  /** Queries for a BetaTestingSchedule for a given course id. */
  queryBetaTestingScheduleByCourseId?: Maybe<BetaTestingSchedule_QueryBetaTestingScheduleByCourseIdResult>;
  /** Find beta testing schedules in an interval [start,end]. | Maximum page size: 10000 */
  queryBetaTestingSchedulesInInterval: BetaTestingSchedule_BetaTestingSchedulesConnection;
};


/**
 * Type to encapsulate all the queries for BetaTestingSchedule as per:
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Conventions
 */
export type BetaTestingScheduleQueriesQueryBetaTestingScheduleByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/**
 * Type to encapsulate all the queries for BetaTestingSchedule as per:
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Conventions
 */
export type BetaTestingScheduleQueriesQueryBetaTestingSchedulesInIntervalArgs = {
  after?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  first?: Scalars['Int'];
  start: Scalars['DateTime'];
};

/** Edge type for beta testing schedules pagination. */
export type BetaTestingSchedule_BetaTestingScheduleEdge = {
  __typename?: 'BetaTestingSchedule_BetaTestingScheduleEdge';
  /** Cursor for pagination. */
  cursor?: Maybe<Scalars['String']>;
  /** The beta testing schedule data. */
  node: BetaTestingSchedule;
};

/** Paginated result for BetaTestingSchedules. */
export type BetaTestingSchedule_BetaTestingSchedulesConnection = {
  __typename?: 'BetaTestingSchedule_BetaTestingSchedulesConnection';
  /** Beta testing schedules that were found, for the request. */
  edges: Array<BetaTestingSchedule_BetaTestingScheduleEdge>;
  /** page info */
  pageInfo: PageInfo;
};

/** Input for BetaTestingSchedule_Delete mutation. */
export type BetaTestingSchedule_DeleteInput = {
  /** Id of the course for which to delete its beta testing schedule. */
  courseId: Scalars['ID'];
};

/** Result type for the BetaTestingSchedule_Delete mutation. */
export type BetaTestingSchedule_DeleteResult = BetaTestingSchedule_DeleteSuccess;

/** Successful Result type for the BetaTestingSchedule_Delete mutation. */
export type BetaTestingSchedule_DeleteSuccess = {
  __typename?: 'BetaTestingSchedule_DeleteSuccess';
  /** Delete does not return anything yet, GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Result of the queryBetaTestingScheduleById. */
export type BetaTestingSchedule_QueryBetaTestingScheduleByCourseIdResult = BetaTestingSchedule_QueryBetaTestingScheduleByCourseIdSuccess | BetaTestingSchedule_QueryBetaTestingScheduleByCourseId_NotFoundError;

/** Success Result of the queryBetaTestingScheduleById. */
export type BetaTestingSchedule_QueryBetaTestingScheduleByCourseIdSuccess = {
  __typename?: 'BetaTestingSchedule_QueryBetaTestingScheduleByCourseIdSuccess';
  /** Beta testing schedule that was found. */
  betaTestingSchedule: BetaTestingSchedule;
};

/** Error indicating that a beta testing schedule was not found. */
export type BetaTestingSchedule_QueryBetaTestingScheduleByCourseId_NotFoundError = {
  __typename?: 'BetaTestingSchedule_QueryBetaTestingScheduleByCourseId_NotFoundError';
  /** Course for which beta testing schedule was not found. */
  courseId: Scalars['ID'];
  /** Error message. */
  message: Scalars['String'];
};

/** Input for BetaTestingSchedule_Update Mutation. */
export type BetaTestingSchedule_UpdateInput = {
  /** Id of the course to be updated \ added. */
  courseId: Scalars['ID'];
  /** Group Id of the beta testing. */
  groupId?: InputMaybe<Scalars['ID']>;
  /** The time of when the beta testing started. */
  startedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Result of the BetaTestingSchedule_Update mutation. */
export type BetaTestingSchedule_UpdateResult = BetaTestingSchedule_UpdateSuccess | BetaTestingSchedule_Update_InvalidArgumentsError;

/** Successful Result of the BetaTestingSchedule_Update mutation. */
export type BetaTestingSchedule_UpdateSuccess = {
  __typename?: 'BetaTestingSchedule_UpdateSuccess';
  /** Course id for which update was invoked. */
  betaTestingsSchedule?: Maybe<BetaTestingSchedule>;
};

/** Error indicating that a beta testing schedule was not found. */
export type BetaTestingSchedule_Update_InvalidArgumentsError = {
  __typename?: 'BetaTestingSchedule_Update_InvalidArgumentsError';
  /** Course for which invalid schedule argument were supplied. */
  courseId: Scalars['ID'];
  /** Error message. */
  message: Scalars['String'];
};

/** Enum of the supported Box widget RPC action types */
export const Box_WidgetRpcActionType = {
  /** Get scoped activity summary data for the user */
  GetActivitySummaries: 'GET_ACTIVITY_SUMMARIES',
  /** Get authorization data for specific APIs that the widget needs to communicate with */
  GetExternalApiAuthorizations: 'GET_EXTERNAL_API_AUTHORIZATIONS',
  /** Load current session's configuration data */
  GetSessionConfiguration: 'GET_SESSION_CONFIGURATION',
  /** Retrieve storedValues from our BE */
  GetStoredValues: 'GET_STORED_VALUES',
  /** Read specific, session-configured data keys from Nostos */
  ReadCustomQueryResults: 'READ_CUSTOM_QUERY_RESULTS',
  /** Set the answer for a graded widget */
  SetAnswer: 'SET_ANSWER',
  /** Set the containing item as complete */
  SetComplete: 'SET_COMPLETE',
  /** Set the height of the widget */
  SetHeight: 'SET_HEIGHT',
  /** Save storedValues to our BE for persistence */
  SetStoredValues: 'SET_STORED_VALUES'
} as const;

export type Box_WidgetRpcActionType = typeof Box_WidgetRpcActionType[keyof typeof Box_WidgetRpcActionType];
/** Box Widget Session */
export type Box_WidgetSession = {
  __typename?: 'Box_WidgetSession';
  /** The expiration of the widget session */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Box File ID */
  fileId: Scalars['ID'];
  /** Versioned id of the widget session */
  id: Scalars['ID'];
  /** The title supplied to the iframe that is presenting the widget contents */
  iframeTitle?: Maybe<Scalars['String']>;
  /** The list of rpc interactions that a widget is allowed to perform */
  rpcActionTypes: Array<Box_WidgetRpcActionType>;
  /**
   * Controls the restrictions applied to the content embedded in the <iframe>
   * Ex: 'allow-scripts allow-same-origin'
   */
  sandbox?: Maybe<Scalars['String']>;
  /** The source url for the iframe to display */
  source: Scalars['URL'];
};

/** Namespace wrapper for branch-level item queries. */
export type BranchItemQueries = {
  __typename?: 'BranchItemQueries';
  /**
   * Bulk fetch passing fractions for multiple items within a specific branch.
   *
   * Returns a list of records found. Items with no passing fraction are omitted.
   */
  queryPassingFractionsByBranchIdAndItemIds: Array<ItemPlatform_ItemPassingFraction>;
};


/** Namespace wrapper for branch-level item queries. */
export type BranchItemQueriesQueryPassingFractionsByBranchIdAndItemIdsArgs = {
  branchId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
};

/** Conflict metadata for a given branch used to determine if conflicting edits have been made */
export type BranchItem_AuthoringCourseBranchConflictMetadataInput = {
  /** Learner course branch version */
  courseBranchVersion: Scalars['Int'];
  /** Authoring course branch version */
  version: Scalars['Int'];
};

/** Represents the location of an item in a given branch's course material */
export type BranchItem_AuthoringCourseMaterialItemScopeInput = {
  /** Authoring branch id */
  authoringCourseBranchId: Scalars['ID'];
  /**
   * Optional item id. If provided, indicates the specific item to be operated on within the lesson, but can be left null
   * when creating a brand new item.
   */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson id */
  lessonId: Scalars['ID'];
  /** Module id */
  moduleId: Scalars['ID'];
};

/** Returned if BranchItem_CreateBranchItem ran into an error */
export type BranchItem_CreateBranchItemFailure = {
  __typename?: 'BranchItem_CreateBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for the BranchItem_CreateBranchItem mutation */
export type BranchItem_CreateBranchItemInput = {
  /** The location of the item to be created */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: InputMaybe<Scalars['String']>;
  /** Indicates whether the created atom was manually created by a user, or generated with AI assistance */
  generationSource?: ItemPlatform_AtomGenerationSource;
  /** Optional flag to determine if the created atom is graded */
  isGraded?: InputMaybe<Scalars['Boolean']>;
  /**
   * The item type for the atom to be created.
   *
   * We use a String instead of the ItemPlatform_ItemType enum to allow new item types to be added to the enum without
   * requiring coordinated deploys across all services that import graphql-shared-itemplatform.
   * By ensuring the enum is only used in return types and not in inputs, Federation will use the Union composition
   * strategy instead of requiring the enum definition to be exactly the same across all subgraphs where it is used:
   * https://www.apollographql.com/docs/federation/federated-types/composition/#enums.
   */
  itemType: Scalars['String'];
};

/** Result union for the BranchItem_CreateBranchItem mutation */
export type BranchItem_CreateBranchItemResult = BranchItem_CreateBranchItemFailure | BranchItem_CreateBranchItemSuccess;

/** Returned if BranchItem_CreateBranchItem completed successfully */
export type BranchItem_CreateBranchItemSuccess = {
  __typename?: 'BranchItem_CreateBranchItemSuccess';
  /** The newly created item */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if BranchItem_DuplicateBranchItem ran into an error */
export type BranchItem_DuplicateBranchItemFailure = {
  __typename?: 'BranchItem_DuplicateBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for BranchItem_DuplicateBranchItem mutation */
export type BranchItem_DuplicateBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
};

/** Result union for BranchItem_DuplicateBranchItem mutation */
export type BranchItem_DuplicateBranchItemResult = BranchItem_DuplicateBranchItemFailure | BranchItem_DuplicateBranchItemSuccess;

/** Returned if BranchItem_DuplicateBranchItem completed successfully */
export type BranchItem_DuplicateBranchItemSuccess = {
  __typename?: 'BranchItem_DuplicateBranchItemSuccess';
  /** The duplicated item */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if BranchItem_ForkBranchItem ran into an error */
export type BranchItem_ForkBranchItemFailure = {
  __typename?: 'BranchItem_ForkBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for BranchItem_ForkBranchItem mutation */
export type BranchItem_ForkBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
  /** The source authoring course branch id for change log reporting */
  sourceAuthoringCourseBranchId: Scalars['ID'];
};

/** Result union for BranchItem_ForkBranchItem mutation */
export type BranchItem_ForkBranchItemResult = BranchItem_ForkBranchItemFailure | BranchItem_ForkBranchItemSuccess;

/** Returned if BranchItem_ForkBranchItem completed successfully */
export type BranchItem_ForkBranchItemSuccess = {
  __typename?: 'BranchItem_ForkBranchItemSuccess';
  /** The newly forked item */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if BranchItem_PublishBranchItem ran into a client-actionable error */
export type BranchItem_PublishBranchItemFailure = {
  __typename?: 'BranchItem_PublishBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for the BranchItem_PublishBranchItem mutation */
export type BranchItem_PublishBranchItemInput = {
  /** Id of the atom to publish */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /**
   * Optional limit on which branches to publish to. If specified, only branches mapping to the
   * supplied branch ids will be published to and all other instances of the atom will be frozen.
   */
  publishLimit?: InputMaybe<Array<Scalars['ID']>>;
};

/** Result union for the BranchItem_PublishBranchItem mutation */
export type BranchItem_PublishBranchItemResult = BranchItem_PublishBranchItemFailure | BranchItem_PublishBranchItemSuccess;

/** Returned if BranchItem_PublishBranchItem completed successfully */
export type BranchItem_PublishBranchItemSuccess = {
  __typename?: 'BranchItem_PublishBranchItemSuccess';
  /** The updated item */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if BranchItem_ShareBranchItem ran into an error */
export type BranchItem_ShareBranchItemFailure = {
  __typename?: 'BranchItem_ShareBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for BranchItem_ShareBranchItem mutation */
export type BranchItem_ShareBranchItemInput = {
  /** The destination for the newly forked item */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Id of the atom to fork */
  sourceAtomId: Scalars['ID'];
  /** The source authoring course branch id for change log reporting */
  sourceAuthoringCourseBranchId: Scalars['ID'];
};

/** Result union for BranchItem_ShareBranchItem mutation */
export type BranchItem_ShareBranchItemResult = BranchItem_ShareBranchItemFailure | BranchItem_ShareBranchItemSuccess;

/** Returned if BranchItem_ShareBranchItem completed successfully */
export type BranchItem_ShareBranchItemSuccess = {
  __typename?: 'BranchItem_ShareBranchItemSuccess';
  /** The shared item */
  item: ItemPlatform_AuthoringItem;
};

/** The destination for an item to be unfrozen */
export type BranchItem_UnfreezeBranchItemDestination = {
  /** The authoring course branch id for the item to be unfrozen */
  authoringCourseBranchId: Scalars['ID'];
  /** The item id for item to be unfrozen */
  itemId: Scalars['ID'];
};

/** Returned if BranchItem_UnfreezeBranchItem ran into an error */
export type BranchItem_UnfreezeBranchItemFailure = {
  __typename?: 'BranchItem_UnfreezeBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for BranchItem_UnfreezeBranchItem mutation */
export type BranchItem_UnfreezeBranchItemInput = {
  /** Metadata to confirm modification to the branch */
  branchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** Destination of the item to be unfrozen */
  destination: BranchItem_UnfreezeBranchItemDestination;
};

/** Result union for BranchItem_UnfreezeBranchItem mutation */
export type BranchItem_UnfreezeBranchItemResult = BranchItem_UnfreezeBranchItemFailure | BranchItem_UnfreezeBranchItemSuccess;

/** Returned if BranchItem_UnfreezeBranchItem completed successfully */
export type BranchItem_UnfreezeBranchItemSuccess = {
  __typename?: 'BranchItem_UnfreezeBranchItemSuccess';
  /** The unfrozen item */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if BranchItem_UnlinkBranchItem ran into a client-actionable error */
export type BranchItem_UnlinkBranchItemFailure = {
  __typename?: 'BranchItem_UnlinkBranchItemFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for the BranchItem_UnlinkBranchItem mutation */
export type BranchItem_UnlinkBranchItemInput = {
  /** Id of the atom to unlink */
  atomId: Scalars['ID'];
  /** Conflict metadata for the target branch used to determine if conflicting edits have been made */
  authoringCourseBranchConflictMetadata: BranchItem_AuthoringCourseBranchConflictMetadataInput;
  /** The location of the item to unlink in the target branch's course material */
  authoringCourseMaterialItemScope: BranchItem_AuthoringCourseMaterialItemScopeInput;
};

/** Result union for the BranchItem_UnlinkBranchItem mutation */
export type BranchItem_UnlinkBranchItemResult = BranchItem_UnlinkBranchItemFailure | BranchItem_UnlinkBranchItemSuccess;

/** Returned if BranchItem_UnlinkBranchItem completed successfully */
export type BranchItem_UnlinkBranchItemSuccess = {
  __typename?: 'BranchItem_UnlinkBranchItemSuccess';
  /** The new atomId of the unlinked item */
  atomId: Scalars['ID'];
};

/** Namespaced queries through nesting to aid discoverability. */
export type BrazeIntegrationQueries = {
  __typename?: 'BrazeIntegrationQueries';
  /** To fetch the JWT token based on Coursera ID for braze user authentication */
  getBrazeJWT: Scalars['String'];
};

export type BrowseCollectionsV1 = {
  __typename?: 'BrowseCollectionsV1';
  courseId?: Maybe<Scalars['JSON']>;
  courses?: Maybe<CoursesV1Connection>;
  debug?: Maybe<Scalars['String']>;
  degrees?: Maybe<DegreesV1Connection>;
  domain?: Maybe<DomainsV1>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId?: Maybe<Scalars['String']>;
  entries: Array<Maybe<BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntry>>;
  eventingId?: Maybe<Scalars['String']>;
  facets: Scalars['JSON'];
  featuredListId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  label?: Maybe<Scalars['String']>;
  latestVersionS12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  linkedCollectionPageMetadata?: Maybe<BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget>;
  onDemandSpecializationId?: Maybe<Scalars['JSON']>;
  overrideRank?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  relatedDegrees?: Maybe<DegreesV1Connection>;
  relatedQueries?: Maybe<Array<Maybe<Scalars['String']>>>;
  relatedS12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  relatedUpsellsDegrees?: Maybe<DegreesV1Connection>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  specializationId?: Maybe<Scalars['JSON']>;
  subdomain?: Maybe<SubdomainsV1>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
  suggestions: Array<Maybe<BrowseCollectionsV1_Org_Coursera_Catalog_Suggestion>>;
};


export type BrowseCollectionsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type BrowseCollectionsV1DegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type BrowseCollectionsV1LatestVersionS12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type BrowseCollectionsV1RelatedDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type BrowseCollectionsV1RelatedS12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type BrowseCollectionsV1RelatedUpsellsDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type BrowseCollectionsV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type BrowseCollectionsV1ByCollections = {
  __typename?: 'BrowseCollectionsV1ByCollections';
  collectionSpecificVariables?: Maybe<Array<Maybe<Scalars['String']>>>;
  connection?: Maybe<BrowseCollectionsV1Connection>;
  contextId: Scalars['String'];
  contextType: Scalars['String'];
  debug?: Maybe<Scalars['Boolean']>;
  disableMMR?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nostosJobIdOverride?: Maybe<Scalars['String']>;
  numEntriesPerCollection?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userIdOverrideForSuperusers?: Maybe<Scalars['Int']>;
  userPreferredLanguage?: Maybe<Scalars['String']>;
};

export type BrowseCollectionsV1Connection = {
  __typename?: 'BrowseCollectionsV1Connection';
  elements: Array<Maybe<BrowseCollectionsV1>>;
  paging: ResponsePagination;
};

export type BrowseCollectionsV1Resource = {
  __typename?: 'BrowseCollectionsV1Resource';
  byCollections?: Maybe<BrowseCollectionsV1Connection>;
};


export type BrowseCollectionsV1ResourceByCollectionsArgs = {
  collectionSpecificVariables?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contextId: Scalars['String'];
  contextType: Scalars['String'];
  debug?: InputMaybe<Scalars['Boolean']>;
  disableMMR?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nostosJobIdOverride?: InputMaybe<Scalars['String']>;
  numEntriesPerCollection?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userIdOverrideForSuperusers?: InputMaybe<Scalars['Int']>;
  userPreferredLanguage?: InputMaybe<Scalars['String']>;
};

export type BrowseCollectionsV1ResourceMutations = {
  __typename?: 'BrowseCollectionsV1ResourceMutations';
  deleteCollectionMapping?: Maybe<Scalars['JSON']>;
  getTranslatableStrings?: Maybe<Scalars['JSON']>;
  readAllCollectionMappings?: Maybe<Scalars['JSON']>;
  readCollectionMapping?: Maybe<Scalars['JSON']>;
  updateCollectionMapping?: Maybe<Scalars['JSON']>;
};


export type BrowseCollectionsV1ResourceMutationsDeleteCollectionMappingArgs = {
  contextId: Scalars['String'];
  contextType: Scalars['String'];
};


export type BrowseCollectionsV1ResourceMutationsReadCollectionMappingArgs = {
  contextId: Scalars['String'];
  contextType: Scalars['String'];
};


export type BrowseCollectionsV1ResourceMutationsUpdateCollectionMappingArgs = {
  contextId: Scalars['String'];
  contextType: Scalars['String'];
};

export type BrowseCollectionsV1_Org_Coursera_Catalog_Suggestion = {
  __typename?: 'BrowseCollectionsV1_org_coursera_catalog_Suggestion';
  frequency: Scalars['Float'];
  term: Scalars['String'];
};

export type BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntry = {
  __typename?: 'BrowseCollectionsV1_org_coursera_catalogp_browse_CatalogEntry';
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  additionalSolrFieldValues?: Maybe<Scalars['JSON']>;
  courseId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isFreeCertificate?: Maybe<Scalars['Boolean']>;
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  latestVersionedS12nId?: Maybe<Scalars['String']>;
  onDemandSpecializationId?: Maybe<Scalars['String']>;
  relatedIds?: Maybe<BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds>;
  resourceName: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  specializationId?: Maybe<Scalars['String']>;
};

/** Record that contains ids relating to a specific CatalogEntry in some way. For example, if the CatalogEntry is a course, the `s12nId` field will be populated with the s12n that the course is a part of. "degreeId" will only be filled if a COURSE is a degree course "upsellsDegreeId" will be filled if a COURSE or S12N is a degree course, or is a stackable open degree enrollment item details: https://coursera.atlassian.net/wiki/spaces/GROW/pages/49512475/Degree+Upsells */
export type BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds = {
  __typename?: 'BrowseCollectionsV1_org_coursera_catalogp_browse_CatalogEntryRelatedIds';
  /** Identifier for a degree. */
  degreeId?: Maybe<Scalars['String']>;
  s12nId?: Maybe<Scalars['String']>;
  /** Identifier for a degree. */
  upsellsDegreeId?: Maybe<Scalars['String']>;
};

export type BrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget = {
  __typename?: 'BrowseCollectionsV1_org_coursera_catalogp_browse_CatalogResultTarget';
  /** Typeref for string that defines the isTranslatable property to true */
  label: Scalars['String'];
  url: Scalars['String'];
};

/** All queries related to bulk program invitation imports. */
export type BulkProgramInvitationsQueries = {
  __typename?: 'BulkProgramInvitationsQueries';
  /**
   * Scans an uploaded invitation CSV and returns attributes the frontend needs before
   * processing: whether the optional Group column has values, and whether the import
   * should be processed asynchronously. Runs no validation and makes no downstream
   * API calls.
   */
  previewImportAttributes: BulkProgramInvitations_PreviewImportAttributesResult;
};


/** All queries related to bulk program invitation imports. */
export type BulkProgramInvitationsQueriesPreviewImportAttributesArgs = {
  organizationId: Scalars['ID'];
  s3Bucket: Scalars['String'];
  s3Key: Scalars['String'];
};

/** Whether the optional Group column had values in the import CSV. */
export const BulkProgramInvitations_GroupColumnState = {
  /** Column missing, or no row specified a group */
  Absent: 'ABSENT',
  /** Every row specified a group */
  AllRows: 'ALL_ROWS',
  /** Some rows have a group, others don't */
  Partial: 'PARTIAL'
} as const;

export type BulkProgramInvitations_GroupColumnState = typeof BulkProgramInvitations_GroupColumnState[keyof typeof BulkProgramInvitations_GroupColumnState];
/** Attributes detected in a bulk invitation import CSV. */
export type BulkProgramInvitations_PreviewImportAttributesResult = {
  __typename?: 'BulkProgramInvitations_PreviewImportAttributesResult';
  /** Whether the optional Group column has values across the CSV rows. */
  groupColumnState: BulkProgramInvitations_GroupColumnState;
  /** True if the frontend should call the async process flow; false for sync. */
  shouldProcessAsync: Scalars['Boolean'];
};

/** Queries for the business-case proposal flow */
export type BusinessCaseProposalQueries = {
  __typename?: 'BusinessCaseProposalQueries';
  /** Polls for the current status of a previously-submitted download request. */
  getDownloadStatus: BusinessCaseProposal_DownloadStatus;
};


/** Queries for the business-case proposal flow */
export type BusinessCaseProposalQueriesGetDownloadStatusArgs = {
  requestId: Scalars['ID'];
};

/** Billing cycle options. */
export const BusinessCaseProposal_BillingCycle = {
  /** Single annual installment. */
  Annual: 'ANNUAL',
  /** Four quarterly installments. */
  Quarterly: 'QUARTERLY'
} as const;

export type BusinessCaseProposal_BillingCycle = typeof BusinessCaseProposal_BillingCycle[keyof typeof BusinessCaseProposal_BillingCycle];
/** Why an async download request reached the FAILED state. */
export const BusinessCaseProposal_DownloadErrorReason = {
  /** An unclassified failure occurred; service logs hold the cause. */
  InternalError: 'INTERNAL_ERROR',
  /** The render pipeline (Lambda invoke / S3 upload / presign) threw an exception. */
  RenderFailed: 'RENDER_FAILED'
} as const;

export type BusinessCaseProposal_DownloadErrorReason = typeof BusinessCaseProposal_DownloadErrorReason[keyof typeof BusinessCaseProposal_DownloadErrorReason];
/**
 * Current state of an async download request. Field nullability mirrors the lifecycle: URL
 * fields are populated only when `status == READY`; `errorReason` only when `status == FAILED`.
 */
export type BusinessCaseProposal_DownloadStatus = {
  __typename?: 'BusinessCaseProposal_DownloadStatus';
  /** Short-lived S3 presigned URL the client can navigate to. */
  downloadUrl?: Maybe<Scalars['URL']>;
  /** Why the render failed. Populated only when `status == FAILED`; null otherwise. */
  errorReason?: Maybe<BusinessCaseProposal_DownloadErrorReason>;
  /**
   * Wall-clock time at which the `downloadUrl` expires. Populated only when `status == READY`;
   * null otherwise.
   */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /**
   * Current lifecycle state. See `BusinessCaseProposal_DownloadStatusEnum` for what each value
   * implies for the other fields on this type.
   */
  status: BusinessCaseProposal_DownloadStatusEnum;
};

/** Lifecycle states of an async download request. */
export const BusinessCaseProposal_DownloadStatusEnum = {
  /**
   * Render or upload failed; `errorReason` is populated and the client must resubmit the
   * original `BusinessCaseProposal_RequestDownload` mutation.
   */
  Failed: 'FAILED',
  /** Render+upload is queued or executing; poll again shortly. */
  InProgress: 'IN_PROGRESS',
  /** The supplied `requestId` is unknown */
  NotFound: 'NOT_FOUND',
  /** Render succeeded; `downloadUrl` is populated and valid until `expiresAt`. */
  Ready: 'READY'
} as const;

export type BusinessCaseProposal_DownloadStatusEnum = typeof BusinessCaseProposal_DownloadStatusEnum[keyof typeof BusinessCaseProposal_DownloadStatusEnum];
/** The form state captured by the business-case builder on the business homepage. */
export type BusinessCaseProposal_Input = {
  /** Billing cycle for the contract. */
  billingCycle: BusinessCaseProposal_BillingCycle;
  /** Optional enterprise promotion ID to apply to the price. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional industry of the prospect's organization. When omitted, the "Organizations similar
   * to yours" section is hidden from the rendered PDF.
   */
  industry?: InputMaybe<Scalars['String']>;
  /** Number of learner licenses requested. */
  learnerCount: Scalars['Int'];
  /** Up to 3 learning priorities, used to seed catalog recommendations in the PDF. */
  learningPriorities: Array<Scalars['String']>;
  /** Optional BCP-47 locale tag for the rendered PDF and email body. Defaults to "en-US". */
  locale?: InputMaybe<Scalars['String']>;
  /**
   * Pricing model to apply for the contract. Defaults to STANDARD pricing where annual and
   * quarterly have the same effective annual rate.
   */
  pricingModel?: InputMaybe<EnterpriseContractPrice_PricingModel>;
  /**
   * Optional primary business goal driving the request. When omitted, the "Goal supported"
   * section is hidden from the rendered PDF.
   */
  primaryGoal?: InputMaybe<Scalars['String']>;
};

/** Input for `BusinessCaseProposal_RequestDownload`. */
export type BusinessCaseProposal_RequestDownloadInput = {
  /** Proposal configuration mirroring the business-case builder inputs */
  proposal: BusinessCaseProposal_Input;
};

/**
 * Result of `BusinessCaseProposal_RequestDownload`. On success, the `requestId` can be polled
 * via `BusinessCaseProposalQueries.getDownloadStatus(requestId)` until the rendered PDF is ready
 * to download. Rejection cases (rate-limit exceeded, learner count over supported max) surface
 * as GraphQL errors in the response `errors[]` array — clients should branch on
 * `errors[].extensions.applicationErrorType` (e.g., `rateLimitExceeded`, `VALIDATION_ERROR`).
 */
export type BusinessCaseProposal_RequestDownloadResult = {
  __typename?: 'BusinessCaseProposal_RequestDownloadResult';
  /**
   * Opaque ID for polling the render status. Always present on success. Treat as opaque —
   * unguessable per request.
   */
  requestId: Scalars['ID'];
  /** whether the request download was successful or not */
  success: Scalars['Boolean'];
};

/** Input for sending the business-case proposal PDF via email. */
export type BusinessCaseProposal_SendEmailInput = {
  /** Recipient business email address. */
  email: Scalars['String'];
  /** Proposal configuration mirroring the business-homepage builder inputs. */
  proposal: BusinessCaseProposal_Input;
};

/** Result of `BusinessCaseProposal_SendEmail` mutation. */
export type BusinessCaseProposal_SendEmailResult = {
  __typename?: 'BusinessCaseProposal_SendEmailResult';
  /** whether email send was successful */
  success: Scalars['Boolean'];
};

/** Paginated result type for Campaign data */
export type CampaignData_PaginatedResult = {
  __typename?: 'CampaignData_PaginatedResult';
  /** List of campaign data */
  elements: Array<CampaignManagement_CampaignData>;
  /** Pagination object for the result set */
  pagination: Pagination;
};

/** Groups CampaignManagement queries together */
export type CampaignManagementQueries = {
  __typename?: 'CampaignManagementQueries';
  /** Query to get all campaigns with optional arguments for limit and cursor */
  getAllCampaigns?: Maybe<CampaignData_PaginatedResult>;
  /** Query to get a specific campaign by id */
  getCampaignById?: Maybe<CampaignManagement_CampaignData>;
};


/** Groups CampaignManagement queries together */
export type CampaignManagementQueriesGetAllCampaignsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  showArchived?: Scalars['Boolean'];
};


/** Groups CampaignManagement queries together */
export type CampaignManagementQueriesGetCampaignByIdArgs = {
  id: Scalars['ID'];
};

/** Type representing a failed archive campaign operation, it returns the encountered errors */
export type CampaignManagement_ArchiveCampaignFailure = {
  __typename?: 'CampaignManagement_ArchiveCampaignFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input type for archiving a campaign */
export type CampaignManagement_ArchiveCampaignInput = {
  /** The ID of the campaign to be deleted */
  id: Scalars['ID'];
};

/** Union type representing the result of a ArchiveCampaign operation, it can either be a successful operation or a failure */
export type CampaignManagement_ArchiveCampaignResult = CampaignManagement_ArchiveCampaignFailure | CampaignManagement_ArchiveCampaignSuccess;

/** Type representing a successful archive campaign operation, it returns the archives campaign data */
export type CampaignManagement_ArchiveCampaignSuccess = {
  __typename?: 'CampaignManagement_ArchiveCampaignSuccess';
  /** The archived Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/**
 * BadRequestError type implementing CampaignManagement_Error
 * This type represents a bad request error with a message
 */
export type CampaignManagement_BadRequestError = CampaignManagement_Error & {
  __typename?: 'CampaignManagement_BadRequestError';
  /** Descriptive error message. */
  message: Scalars['String'];
};

/** Basic templating configuration for templating system. */
export type CampaignManagement_BasicTemplatingConfiguration = {
  __typename?: 'CampaignManagement_BasicTemplatingConfiguration';
  /** THe key value pairs of the data configuration. */
  keyValuePairs: Array<CampaignManagement_BasicTemplatingKeyValuePair>;
};

/** The baseline template variable configuration */
export type CampaignManagement_BasicTemplatingConfigurationInput = {
  /** THe key value pairs of the variable input. */
  keyValuePairs: Array<CampaignManagement_BasicTemplatingKeyValuePairInput>;
};

/** Key value pair for basic templating system. */
export type CampaignManagement_BasicTemplatingKeyValuePair = {
  __typename?: 'CampaignManagement_BasicTemplatingKeyValuePair';
  /** The value of the variable key value pair */
  value: Scalars['String'];
  /** THe key of the key value pair */
  variableName: Scalars['String'];
};

/** Key value pair input for baseling templating data. */
export type CampaignManagement_BasicTemplatingKeyValuePairInput = {
  /** The value of the variable key value pair */
  value: Scalars['String'];
  /** THe key of the key value pair */
  variableName: Scalars['String'];
};

/** Stores config for a specific campaign */
export type CampaignManagement_CampaignData = {
  __typename?: 'CampaignManagement_CampaignData';
  /** Shows whether the Campaign has been archived or not (soft delete) */
  archived: Scalars['Boolean'];
  /** Contentful Entry ID for the campaign */
  contentfulEntryId: Scalars['ID'];
  /** Creation time of the campaign */
  createdAt: Scalars['DateTime'];
  /** User that created campaign entry */
  createdBy: Scalars['ID'];
  /** Email for user that created campaign entry */
  creatorEmail: Scalars['String'];
  /** Only enabled campaigns are eligible to be shown via the Campaign Modules API */
  enabled: Scalars['Boolean'];
  /** Ending time of the campaign */
  endTime: Scalars['DateTime'];
  /**
   * Epic Experiment data for the campaign
   * @deprecated Use new experimentData field
   */
  epicExperimentData?: Maybe<CampaignManagement_EpicExperimentData>;
  /** Experiment data for the campaign */
  experimentData: CampaignManagement_ExperimentData;
  /** Unique identifier for the campaign */
  id: Scalars['ID'];
  /** Name of the campaign */
  name: Scalars['String'];
  /** Starting time of the campaign */
  startTime: Scalars['DateTime'];
  /** Status of the campaign */
  status: CampaignManagement_CampaignStatus;
  /** Targeting strategy configured for campaign */
  targetingStrategy: CampaignManagement_TargetingStrategy;
  /** Template variables of the campaign */
  templatingConfigurations: Array<CampaignManagement_TemplatingConfiguration>;
};

/** Supported Campaign Status Types */
export const CampaignManagement_CampaignStatus = {
  /** Archived */
  Archived: 'ARCHIVED',
  /** Completed */
  Completed: 'COMPLETED',
  /** Draft */
  Draft: 'DRAFT',
  /** Running */
  Running: 'RUNNING',
  /** Upcoming */
  Upcoming: 'UPCOMING'
} as const;

export type CampaignManagement_CampaignStatus = typeof CampaignManagement_CampaignStatus[keyof typeof CampaignManagement_CampaignStatus];
/** Countdown templating configuration. */
export type CampaignManagement_CountdownTemplatingConfiguration = {
  __typename?: 'CampaignManagement_CountdownTemplatingConfiguration';
  /** Days before end date to start countdown */
  countdownStart: Scalars['Int'];
};

/** Countdown configuration input for templating. */
export type CampaignManagement_CountdownTemplatingConfigurationInput = {
  /** Days before campaign end date to start countdown */
  countdownStart: Scalars['Int'];
};

/** Coursera Plus promotion configuration. */
export type CampaignManagement_CourseraPlusDynamicPricingTemplatingConfiguration = {
  __typename?: 'CampaignManagement_CourseraPlusDynamicPricingTemplatingConfiguration';
  /** Coursera plus type for this promotion. */
  courseraPlusType: CampaignManagement_CourseraPlusType;
  /** A list of promo codes associated with regions. */
  regionedPromos: Array<CampaignManagement_RegionedPromo>;
};

/** Coursera Plus promotion configuration input. */
export type CampaignManagement_CourseraPlusDynamicPricingTemplatingConfigurationInput = {
  /** Coursera plus type for this promotion. */
  courseraPlusType: CampaignManagement_CourseraPlusType;
  /** A list of promo codes associated with regions. */
  regionedPromos: Array<CampaignManagement_RegionedPromoInput>;
};

/** Enum for coursera plus type for the backend to translate into skus. */
export const CampaignManagement_CourseraPlusType = {
  /** Enum entry for annual coursera plus */
  Annual: 'ANNUAL',
  /** Enum entry for monthly coursera plus. */
  Monthly: 'MONTHLY'
} as const;

export type CampaignManagement_CourseraPlusType = typeof CampaignManagement_CourseraPlusType[keyof typeof CampaignManagement_CourseraPlusType];
/**
 * CreateCampaignFailure type
 * This type represents a failed campaign creation operation, with returning the encountered errors
 */
export type CampaignManagement_CreateCampaignFailure = {
  __typename?: 'CampaignManagement_CreateCampaignFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input type for creating a new campaign */
export type CampaignManagement_CreateCampaignInput = {
  /** New Campaign's Contentful Entry ID */
  contentfulEntryId: Scalars['ID'];
  /** New Campaign's ending time */
  endTime: Scalars['DateTime'];
  /**
   * New Campaign's epic experiment type
   * @deprecated Use new experimentType field.
   */
  epicExperimentType?: InputMaybe<CampaignManagement_EpicExperimentType>;
  /** New Campaign's experiment type (nullable while migrating off epicExperimentType) */
  experimentType?: InputMaybe<CampaignManagement_ExperimentType>;
  /** New Campaign's name */
  name: Scalars['String'];
  /** New Campaign's starting time */
  startTime: Scalars['DateTime'];
  /** New Campaign's targeting strategy configuration */
  targetingStrategy?: InputMaybe<CampaignManagement_TargetingStrategyInput>;
  /** New Campaign's templating details */
  templatingConfigurations?: Array<CampaignManagement_TemplatingConfigurationInput>;
};

/** Union type representing the result of a CreateCampaign operation, it can either be a successful operation or a failure */
export type CampaignManagement_CreateCampaignResult = CampaignManagement_CreateCampaignFailure | CampaignManagement_CreateCampaignSuccess;

/**
 * CreateCampaignSuccess type
 * This type represents a successful campaign creation operation, with returning the created campaign data
 */
export type CampaignManagement_CreateCampaignSuccess = {
  __typename?: 'CampaignManagement_CreateCampaignSuccess';
  /** The created Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/** Type representing a failed deletion campaign operation, it returns the encountered errors */
export type CampaignManagement_DeleteCampaignFailure = {
  __typename?: 'CampaignManagement_DeleteCampaignFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input type for deleting a campaign */
export type CampaignManagement_DeleteCampaignInput = {
  /** The ID of the campaign to be deleted */
  id: Scalars['ID'];
};

/** Union type representing the result of a DeleteCampaign operation, it can either be a successful operation or a failure */
export type CampaignManagement_DeleteCampaignResult = CampaignManagement_DeleteCampaignFailure | CampaignManagement_DeleteCampaignSuccess;

/** Type representing a successful deletion campaign operation, it returns the deleted campaign data */
export type CampaignManagement_DeleteCampaignSuccess = {
  __typename?: 'CampaignManagement_DeleteCampaignSuccess';
  /** The deleted Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/** Type representing a failed campaign end operation, it returns the encountered errors */
export type CampaignManagement_EndCampaignFailure = {
  __typename?: 'CampaignManagement_EndCampaignFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input for end campaign operation */
export type CampaignManagement_EndCampaignInput = {
  /** The ID of the campaign to be ended */
  id: Scalars['ID'];
};

/** Union type representing the result of a PatchCampaign operation, it can either be a successful operation or a failure */
export type CampaignManagement_EndCampaignResult = CampaignManagement_EndCampaignFailure | CampaignManagement_EndCampaignSuccess;

/** Type representing a successful campaign end operation, it returns the updated campaign data */
export type CampaignManagement_EndCampaignSuccess = {
  __typename?: 'CampaignManagement_EndCampaignSuccess';
  /** The ended Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/** Single Epic Experiment type */
export type CampaignManagement_EpicExperiment = {
  __typename?: 'CampaignManagement_EpicExperiment';
  /** Unique identifier for the experiment */
  id: Scalars['ID'];
  /** Region tied to the Campaign */
  region: Scalars['String'];
};

/** Epic Experiment type */
export type CampaignManagement_EpicExperimentData = {
  __typename?: 'CampaignManagement_EpicExperimentData';
  /** Type of the epic experiment, Rollout or A/B */
  epicExperimentType: CampaignManagement_EpicExperimentType;
  /** List of experiments match to this Campaign */
  experiments: Array<CampaignManagement_EpicExperiment>;
  /** Count of variants in the experiment */
  variantsCount: Scalars['Int'];
};

/** Supported epic experiment types */
export const CampaignManagement_EpicExperimentType = {
  /** A/B Epic Experiment Type */
  Ab: 'AB',
  /** Rollout Epic Experiment Type */
  Rollout: 'ROLLOUT'
} as const;

export type CampaignManagement_EpicExperimentType = typeof CampaignManagement_EpicExperimentType[keyof typeof CampaignManagement_EpicExperimentType];
/** Domain-specific error interface */
export type CampaignManagement_Error = {
  /** Error message */
  message: Scalars['String'];
};

/** Union type that maps to all experiment types */
export type CampaignManagement_ExperimentData = CampaignManagement_EpicExperimentData | CampaignManagement_StatsigExperimentData;

/** Supported experiment types */
export const CampaignManagement_ExperimentType = {
  /** A/B Epic Experiment Type */
  Ab: 'AB',
  /** Rollout Experiment Type */
  Rollout: 'ROLLOUT'
} as const;

export type CampaignManagement_ExperimentType = typeof CampaignManagement_ExperimentType[keyof typeof CampaignManagement_ExperimentType];
/** JustWords templating configuration for templating system. */
export type CampaignManagement_JustWordsTemplatingConfiguration = {
  __typename?: 'CampaignManagement_JustWordsTemplatingConfiguration';
  /** THe template id. */
  templateId: Scalars['ID'];
};

/** The JustWords template variable configuration */
export type CampaignManagement_JustWordsTemplatingConfigurationInput = {
  /** THe string representing the justwords template id. */
  templateId: Scalars['ID'];
};

/** Type representing a failed campaign mark ready for launch operation, it returns the encountered errors */
export type CampaignManagement_MarkCampaignReadyForLaunchFailure = {
  __typename?: 'CampaignManagement_MarkCampaignReadyForLaunchFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input for marking campaign ready for launch */
export type CampaignManagement_MarkCampaignReadyForLaunchInput = {
  /** The ID of the campaign to be marked ready for launch */
  id: Scalars['ID'];
};

/** Union type representing the result of a MarkReadyForLaunch operation, it can either be a successful operation or a failure */
export type CampaignManagement_MarkCampaignReadyForLaunchResult = CampaignManagement_MarkCampaignReadyForLaunchFailure | CampaignManagement_MarkCampaignReadyForLaunchSuccess;

/** Type representing a successful mark ready campaign operation, it returns the updated campaign data */
export type CampaignManagement_MarkCampaignReadyForLaunchSuccess = {
  __typename?: 'CampaignManagement_MarkCampaignReadyForLaunchSuccess';
  /** The marked for ready Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/** Type representing a failed campaign patch operation, it returns the encountered errors */
export type CampaignManagement_PatchCampaignFailure = {
  __typename?: 'CampaignManagement_PatchCampaignFailure';
  /** Array of Errors encountered during the operation */
  errors: Array<CampaignManagement_BadRequestError>;
};

/** Input type for patching a campaign. Use null as the field value when no update required for it. */
export type CampaignManagement_PatchCampaignInput = {
  /**
   * Enable or disable the campaign to toggle it from being eligible to be served via the Campaign Modules API
   * @deprecated This flag will be enabled/disabled via new queries that will be added soon.
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Campaign's new ending time. Use null for no update. Use null as the value when no update required. */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the campaign to be patched */
  id: Scalars['ID'];
  /** Campaign's new starting time. Use null as the value when no update required. */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** New Campaign's targeting strategy configuration */
  targetingStrategy?: InputMaybe<CampaignManagement_TargetingStrategyInput>;
  /** Campaign's new templating variables */
  templatingConfigurations?: InputMaybe<Array<CampaignManagement_TemplatingConfigurationInput>>;
};

/** Union type representing the result of a PatchCampaign operation, it can either be a successful operation or a failure */
export type CampaignManagement_PatchCampaignResult = CampaignManagement_PatchCampaignFailure | CampaignManagement_PatchCampaignSuccess;

/** Type representing a successful campaign patch operation, it returns the updated campaign data */
export type CampaignManagement_PatchCampaignSuccess = {
  __typename?: 'CampaignManagement_PatchCampaignSuccess';
  /** The patched Campaign's data */
  campaignData: CampaignManagement_CampaignData;
};

/** Object to match regions to promo ids. */
export type CampaignManagement_RegionedPromo = {
  __typename?: 'CampaignManagement_RegionedPromo';
  /** Contentful region code for matching promo to region. */
  contentfulRegionId: Scalars['ID'];
  /** Promotion id. */
  promoId: Scalars['ID'];
};

/** Input for promo ids with associated regions */
export type CampaignManagement_RegionedPromoInput = {
  /** Contentful region code for matching promo to region. */
  contentfulRegionId: Scalars['ID'];
  /** Promotion id. */
  promoId: Scalars['ID'];
};

/** Statsig Experiment type */
export type CampaignManagement_StatsigExperimentData = {
  __typename?: 'CampaignManagement_StatsigExperimentData';
  /** Experiment name */
  experimentName: Scalars['String'];
  /** Type of experiment, Rollout or A/B */
  experimentType: CampaignManagement_ExperimentType;
  /** Layer name */
  layerName: Scalars['String'];
  /** Count of variants in the experiment */
  variantsCount: Scalars['Int'];
};

/** Targeting strategy configuration for a Campaign */
export type CampaignManagement_TargetingStrategy = {
  __typename?: 'CampaignManagement_TargetingStrategy';
  /** Parameters used to configured targeting strategy */
  parameters: Scalars['JSON'];
  /** Targeting strategy type */
  type: CampaignManagement_TargetingStrategyType;
};

/** Targeting strategy input type */
export type CampaignManagement_TargetingStrategyInput = {
  /** Key/value pairs used to configure the targeting strategy */
  parameters?: InputMaybe<Scalars['JSON']>;
  /** Targeting Strategy Type */
  type: CampaignManagement_TargetingStrategyType;
};

/** Supported Targeting Strategy Types */
export const CampaignManagement_TargetingStrategyType = {
  /** All Learners */
  AllLearners: 'ALL_LEARNERS',
  /** Amplitude Cohort */
  AmplitudeCohort: 'AMPLITUDE_COHORT',
  /** Course Plus Eligible */
  CourseraPlusEligible: 'COURSERA_PLUS_ELIGIBLE',
  /** Logged In */
  LoggedIn: 'LOGGED_IN',
  /** Logged Out */
  LoggedOut: 'LOGGED_OUT'
} as const;

export type CampaignManagement_TargetingStrategyType = typeof CampaignManagement_TargetingStrategyType[keyof typeof CampaignManagement_TargetingStrategyType];
/** Union type of all template variable configurations. New templating variables should be unioned here to be added. */
export type CampaignManagement_TemplatingConfiguration = CampaignManagement_BasicTemplatingConfiguration | CampaignManagement_CountdownTemplatingConfiguration | CampaignManagement_CourseraPlusDynamicPricingTemplatingConfiguration | CampaignManagement_JustWordsTemplatingConfiguration;

/** Input for template variables */
export type CampaignManagement_TemplatingConfigurationInput = {
  /** Basic templating input. */
  basicTemplatingConfigurationInput?: InputMaybe<CampaignManagement_BasicTemplatingConfigurationInput>;
  /** Countdown templating input */
  countdownTemplatingInput?: InputMaybe<CampaignManagement_CountdownTemplatingConfigurationInput>;
  /** Coursera plus templating input */
  courseraPlusPromoTemplatingInput?: InputMaybe<CampaignManagement_CourseraPlusDynamicPricingTemplatingConfigurationInput>;
  /** JustWords templating input. */
  justWordsTemplatingConfigurationInput?: InputMaybe<CampaignManagement_JustWordsTemplatingConfigurationInput>;
};

/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueries = {
  __typename?: 'CampaignQueries';
  /** Fetches Campaign Modules for a 'Browse' campaign. */
  getCampaignModulesForArticles: Campaign_ArticlesCampaignModules;
  /** Fetches Campaign Modules for a 'Browse' campaign. */
  getCampaignModulesForBrowse: Campaign_BrowseCampaignModules;
  /** Fetches Campaign Modules for a 'CPlus Landing Page' campaign. */
  getCampaignModulesForCPlusLanding: Campaign_CPlusLandingCampaignModules;
  /** Fetches Campaign Modules for a 'Career Academy' campaign. */
  getCampaignModulesForCareerAcademy: Campaign_CareerAcademyCampaignModules;
  /** Fetches Campaign Modules for an 'EQP' campaign. */
  getCampaignModulesForEqp: Campaign_EqpCampaignModules;
  /** Fetches Campaign Modules for a 'Logged in Home Page' campaign. */
  getCampaignModulesForLihp: Campaign_LihpCampaignModules;
  /** Fetches Campaign Modules for a 'Logged out Home Page' campaign. */
  getCampaignModulesForLohp: Campaign_LohpCampaignModules;
  /** Fetches Campaign Modules for a 'Paid Ads on Xdp' campaign. */
  getCampaignModulesForPaidAdsXdp: Campaign_PaidAdsXdpCampaignModules;
  /** Fetches Campaign Modules for a 'RDP' campaign. */
  getCampaignModulesForRdp: Campaign_RdpCampaignModules;
  /** Fetches Campaign Modules for a 'Xdp' campaign. */
  getCampaignModulesForXdp: Campaign_XdpCampaignModules;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForArticlesArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForBrowseArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForCPlusLandingArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForCareerAcademyArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForEqpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForLihpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForLohpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForPaidAdsXdpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
  productType: Campaign_ProductType;
  slug: Scalars['String'];
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForRdpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
};


/** A type encapsulating methods to retrieve data for various campaign types. */
export type CampaignQueriesGetCampaignModulesForXdpArgs = {
  campaignModulesVariables?: InputMaybe<Campaign_CampaignModulesInputVariables>;
  overrides?: InputMaybe<Campaign_Overrides>;
  productType: Campaign_ProductType;
  slug: Scalars['String'];
};

/** Union type for additional data, future types of additional data will need to be added here. */
export type Campaign_AdditionalData = Campaign_BasicAdditionalData | Campaign_JustWordsAdditionalData;

/** The campaign modules for Article pages */
export type Campaign_ArticlesCampaignModules = {
  __typename?: 'Campaign_ArticlesCampaignModules';
  /** A Canned Collection module. */
  cannedCollection?: Maybe<Campaign_CannedCollectionModule>;
  /** A Promo Bar module. */
  promoBar?: Maybe<Campaign_PromoBarModule>;
};

/** Basic additional data to return to frontend */
export type Campaign_BasicAdditionalData = {
  __typename?: 'Campaign_BasicAdditionalData';
  /** The additional data from the templating system. */
  additionalData: Array<Campaign_BasicTemplateVariablesSource_KeyValuePair>;
};

/** Key value pair for baseline additional frontend data */
export type Campaign_BasicTemplateVariablesSource_KeyValuePair = {
  __typename?: 'Campaign_BasicTemplateVariablesSource_KeyValuePair';
  /** THe key of the key value pair */
  key: Scalars['String'];
  /** The value of the variable key value pair */
  value: Scalars['String'];
};

/** The campaign modules for Browse. */
export type Campaign_BrowseCampaignModules = {
  __typename?: 'Campaign_BrowseCampaignModules';
  /** A Canned Collection module. */
  cannedCollectionModule?: Maybe<Campaign_CannedCollectionModule>;
};

/** The campaign modules for C Plus Landing Page. */
export type Campaign_CPlusLandingCampaignModules = {
  __typename?: 'Campaign_CPlusLandingCampaignModules';
  /** A Promo Bar module. */
  promoBar?: Maybe<Campaign_PromoBarModule>;
};

/** An input type for variables related to Campaign Modules. */
export type Campaign_CampaignModulesInputVariables = {
  /** A specific campaign ID that should be used no matter what the default behavior would be. */
  forceUseCampaignId?: InputMaybe<Scalars['ID']>;
  /** A boolean flag to indicate whether Contentful is on preview mode. */
  useContentfulPreview?: InputMaybe<Scalars['Boolean']>;
};

/** A module representing a 'Canned Collection' promo unit module for a campaign, utilising common campaign module fields. */
export type Campaign_CannedCollectionModule = Campaign_Module & {
  __typename?: 'Campaign_CannedCollectionModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** A module representing a 'Card Takeover' campaign module, utilising common campaign module fields. */
export type Campaign_CardTakeoverModule = Campaign_Module & {
  __typename?: 'Campaign_CardTakeoverModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** The campaign modules for Career Academy. */
export type Campaign_CareerAcademyCampaignModules = {
  __typename?: 'Campaign_CareerAcademyCampaignModules';
  /** A Card Takeover module. */
  cardTakeover?: Maybe<Campaign_CardTakeoverModule>;
};

/** The campaign modules for EQP. */
export type Campaign_EqpCampaignModules = {
  __typename?: 'Campaign_EqpCampaignModules';
  /** A Card Takeover module. */
  cardTakeover?: Maybe<Campaign_CardTakeoverModule>;
};

/** Domain-specific error interface */
export type Campaign_Error = {
  /** Error message */
  message: Scalars['String'];
};

/** The variants of a campaign experiment. */
export const Campaign_ExperimentVariant = {
  /** The B variant. */
  B: 'B',
  /** The C variant. */
  C: 'C',
  /** The control variant. */
  Control: 'CONTROL'
} as const;

export type Campaign_ExperimentVariant = typeof Campaign_ExperimentVariant[keyof typeof Campaign_ExperimentVariant];
/** A module representing the 'Hero feature' of a campaign, utilising common campaign module fields. */
export type Campaign_HeroModule = Campaign_Module & {
  __typename?: 'Campaign_HeroModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** JustWords additional data to return to frontend */
export type Campaign_JustWordsAdditionalData = {
  __typename?: 'Campaign_JustWordsAdditionalData';
  /** The tracking id from the justwords api. */
  trackingId: Scalars['ID'];
};

/** An enum of all just words events that are supported. */
export const Campaign_JustWordsEventType = {
  /** A click event */
  Click: 'CLICK',
  /** An impression event */
  Impression: 'IMPRESSION'
} as const;

export type Campaign_JustWordsEventType = typeof Campaign_JustWordsEventType[keyof typeof Campaign_JustWordsEventType];
/** Input for a justwords templating event */
export type Campaign_JustWordsTemplatingEventInput = {
  /** The type of event to send */
  eventType?: InputMaybe<Campaign_JustWordsEventType>;
  /** The tracking id for the justwords template */
  trackingId: Scalars['ID'];
};

/** A module representing a 'Learner Stats' module for a campaign, utilising common campaign module fields. */
export type Campaign_LearnerStatsModule = Campaign_Module & {
  __typename?: 'Campaign_LearnerStatsModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** The campaign modules for LIHP. */
export type Campaign_LihpCampaignModules = {
  __typename?: 'Campaign_LihpCampaignModules';
  /** A Canned Collection module. */
  cannedCollection?: Maybe<Campaign_CannedCollectionModule>;
};

/** The campaign modules for LOHP. */
export type Campaign_LohpCampaignModules = {
  __typename?: 'Campaign_LohpCampaignModules';
  /** Additional data from the templating system. */
  additionalData: Array<Campaign_AdditionalData>;
  /** A Canned Collection module. */
  cannedCollection?: Maybe<Campaign_CannedCollectionModule>;
  /** A Hero module. */
  hero?: Maybe<Campaign_HeroModule>;
  /** A Spotlight Collections module. */
  spotlightCollections?: Maybe<Campaign_SpotlightCollectionsModule>;
};

/** Information on how a Module was matched to a Campaign */
export type Campaign_MatchedCampaign = {
  __typename?: 'Campaign_MatchedCampaign';
  /** Additional data from the templating system. */
  additionalData: Array<Campaign_AdditionalData>;
  /** An ID unique to each campaign. */
  campaignId: Scalars['ID'];
  /** Name of the matched campaign. */
  campaignName: Scalars['String'];
  /** Experiment ID associated with the campaign */
  experimentId: Scalars['ID'];
  /** Country code extracted that was used to match campaigns. */
  matchedCountryCode: Scalars['String'];
  /** Region name label from contentful campaign region entry */
  regionName: Scalars['String'];
};

/** An interface defining fields that all campaign modules return */
export type Campaign_Module = {
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** Parameters to override the default campaign matching and rendering behavior. */
export type Campaign_Overrides = {
  /** A specific campaign ID that should be used no matter what the default behavior would be. */
  campaignId?: InputMaybe<Scalars['ID']>;
  /** A boolean flag to indicate whether Contentful is on preview mode. */
  contentfulPreview?: InputMaybe<Scalars['Boolean']>;
  /** Country code to use when matching the campaign. Follows ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The time to use as the present when matching the campaign. */
  currentTime?: InputMaybe<Scalars['DateTime']>;
  /** Locale to use for fetching the contentful content. */
  locale?: InputMaybe<Scalars['String']>;
  /** The user ID to use when matching the campaign. */
  userId?: InputMaybe<Scalars['Int']>;
  /** The experiment variant to force for the campaign. */
  variant?: InputMaybe<Campaign_ExperimentVariant>;
};

/** The campaign modules for Paid Ads XDPs. */
export type Campaign_PaidAdsXdpCampaignModules = {
  __typename?: 'Campaign_PaidAdsXdpCampaignModules';
  /** A Promo Bar module. */
  promoBar?: Maybe<Campaign_PromoBarModule>;
};

/** Product type of the slug passed in. */
export const Campaign_ProductType = {
  /** Course */
  Course: 'COURSE',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type Campaign_ProductType = typeof Campaign_ProductType[keyof typeof Campaign_ProductType];
/** A module representing a feature advertisement 'Promo Bar' of a campaign, utilising common campaign module fields. */
export type Campaign_PromoBarModule = Campaign_Module & {
  __typename?: 'Campaign_PromoBarModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** The campaign modules for RDP. */
export type Campaign_RdpCampaignModules = {
  __typename?: 'Campaign_RdpCampaignModules';
  /** A Card Takeover module. */
  cardTakeover?: Maybe<Campaign_CardTakeoverModule>;
};

/** Campaign Event failure type */
export type Campaign_RecordEventError = {
  __typename?: 'Campaign_RecordEventError';
  /** Array of Errors encountered during the operation */
  errors: Array<Campaign_Error>;
};

/** Generic input type for events */
export type Campaign_RecordEventInput = {
  /** JustWords eventing input. */
  justWordsTemplatingEvent?: InputMaybe<Campaign_JustWordsTemplatingEventInput>;
};

/** Union type representing the result of a RecordEvent operation, it can either be a successful operation or a failure */
export type Campaign_RecordEventResult = Campaign_RecordEventError | Campaign_RecordEventSuccess;

/**
 * RecordEvent type
 * This type represents a successful campaign eventing operation, with returning the campaign event data
 */
export type Campaign_RecordEventSuccess = {
  __typename?: 'Campaign_RecordEventSuccess';
  /** The created Campaign's data */
  message?: Maybe<Scalars['String']>;
};

/** A module representing a highlight 'Spotlight Collections' of a campaign, utilising common campaign module fields. */
export type Campaign_SpotlightCollectionsModule = Campaign_Module & {
  __typename?: 'Campaign_SpotlightCollectionsModule';
  /** A JSON object containing content data for this specific type of campaign module. */
  contentDataJson?: Maybe<Scalars['JSON']>;
  /** Information on how this Module was matched to a Campaign */
  matchedCampaign: Campaign_MatchedCampaign;
};

/** The campaign modules for XDPs. */
export type Campaign_XdpCampaignModules = {
  __typename?: 'Campaign_XdpCampaignModules';
  /** A Canned Collection module. */
  cannedCollection?: Maybe<Campaign_CannedCollectionModule>;
  /** A Learner Stats module. */
  learnerStats?: Maybe<Campaign_LearnerStatsModule>;
  /** A Promo Bar module. */
  promoBar?: Maybe<Campaign_PromoBarModule>;
};

/** All Career Academy queries */
export type CareerAcademyQueries = {
  __typename?: 'CareerAcademyQueries';
  /** Get all the categories in Career Academy. */
  queryAllCategories: Array<CareerAcademy_Category>;
  /** Get all the roles in Career Academy. */
  queryAllRoles: Array<CareerAcademy_Role>;
  /** Get the list of all the variants of Career Academy. */
  queryAllVariants: Array<CareerAcademy_Variant>;
  /** Returns if program is eligible for Career Academy for selected variant or not */
  queryProgramEligibilityByIdAndVariant: CareerAcademy_ProgramEligibilityResult;
  /** Returns categories in context of Reference Curriculum for specified variant */
  queryReferenceCurriculumCategories: Array<CareerAcademy_ReferenceCurriculumCategory>;
  /** Return current status of refresh curriculum job */
  queryRefreshCurriculumsStatus: CareerAcademy_RefreshCurriculumsStatusResult;
  /** Get a role by ID in Career Academy. */
  queryRoleById: CareerAcademy_Role;
  /** Given the slug of an organization, return the career academy variant which is enabled for the program. */
  queryVariantByOrganizationSlug: CareerAcademy_Variant;
  /** Given an ID of a program, return the career academy variant which is enabled for the program. */
  queryVariantByProgramId: CareerAcademy_Variant;
};


/** All Career Academy queries */
export type CareerAcademyQueriesQueryProgramEligibilityByIdAndVariantArgs = {
  programId: Scalars['ID'];
  variant: CareerAcademy_Variant;
};


/** All Career Academy queries */
export type CareerAcademyQueriesQueryReferenceCurriculumCategoriesArgs = {
  variant: CareerAcademy_Variant;
};


/** All Career Academy queries */
export type CareerAcademyQueriesQueryRoleByIdArgs = {
  id: Scalars['ID'];
};


/** All Career Academy queries */
export type CareerAcademyQueriesQueryVariantByOrganizationSlugArgs = {
  orgSlug: Scalars['String'];
};


/** All Career Academy queries */
export type CareerAcademyQueriesQueryVariantByProgramIdArgs = {
  programId: Scalars['ID'];
};

/** Input for adding contents to an existing role. */
export type CareerAcademy_AddContentsToRoleInput = {
  /** IDs of the product to be added to the role. */
  id: Array<CareerAcademy_ProductId>;
  /** ID of the role */
  roleId: Scalars['ID'];
  /**
   * Variants of the role to which content is being added
   * Content can be added:
   * * To GROW_WITH_GOOGLE only, it's not allowed to add content to other variants in this case
   * * To all variants except GROW_WITH_GOOGLE
   */
  variants: Array<CareerAcademy_Variant>;
};

/** Result for adding a content to a role */
export type CareerAcademy_AddContentsToRoleResult = {
  __typename?: 'CareerAcademy_AddContentsToRoleResult';
  /** ID of the role */
  roleId: Scalars['ID'];
  /** Time role was updated with the content */
  updatedTime: Scalars['DateTime'];
};

/** Input for adding a role */
export type CareerAcademy_AddRoleInput = {
  /** Category ID of the role */
  categoryId: Scalars['ID'];
  /** Display name of role */
  name: Scalars['String'];
  /** Slug of role */
  slug: Scalars['String'];
};

/** Result for adding a role */
export type CareerAcademy_AddRoleResult = {
  __typename?: 'CareerAcademy_AddRoleResult';
  /** ID of the role */
  id: Scalars['ID'];
};

/** Entity representing a category of roles in Career Academy. */
export type CareerAcademy_Category = {
  __typename?: 'CareerAcademy_Category';
  /** ID of the category */
  id: Scalars['ID'];
  /** Display name of category */
  name: Scalars['String'];
  /** Career roles that belong to this category. */
  roles: Array<CareerAcademy_Role>;
};

/** Entity representing id of a content of a role in Career Academy. */
export type CareerAcademy_ContentId = {
  __typename?: 'CareerAcademy_ContentId';
  /** Type of the content */
  contentType: CareerAcademy_ContentType;
  /** ID of the content */
  id: Scalars['ID'];
  /** List of variants that this content belongs to. */
  variant: Array<CareerAcademy_Variant>;
};

/** Entity representing types of Content. */
export const CareerAcademy_ContentType = {
  /** Content is a Guided Project. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Content is a Portfolio Project */
  PortfolioProject: 'PORTFOLIO_PROJECT',
  /** Content is a Professional Certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE'
} as const;

export type CareerAcademy_ContentType = typeof CareerAcademy_ContentType[keyof typeof CareerAcademy_ContentType];
/** Input for deleting a role */
export type CareerAcademy_DeleteRoleInput = {
  /** Slug of the role */
  slug: Scalars['String'];
};

/** Result for deleting a role */
export type CareerAcademy_DeleteRoleResult = {
  __typename?: 'CareerAcademy_DeleteRoleResult';
  /** Time Role was removed. */
  updatedTime: Scalars['DateTime'];
};

/** Input representing id of the product */
export type CareerAcademy_ProductId = {
  /** ID of the product */
  id: Scalars['ID'];
  /** Type of the product */
  type: CareerAcademy_ProductType;
};

/** Entity representing types of Product. */
export const CareerAcademy_ProductType = {
  /** Course product. It can either be a normal course, guided project, or portfolio project. */
  Course: 'COURSE',
  /** Specialization product. It can be either a specialization or a professional certificate. */
  Specialization: 'SPECIALIZATION'
} as const;

export type CareerAcademy_ProductType = typeof CareerAcademy_ProductType[keyof typeof CareerAcademy_ProductType];
/** Represents a Professional Certificate */
export type CareerAcademy_ProfessionalCertificate = {
  __typename?: 'CareerAcademy_ProfessionalCertificate';
  /** ID of the professional certificate */
  id: Scalars['ID'];
  /** Professional Certificates, can be null when specialization isn't permitted to access. */
  professionalCertificate?: Maybe<Specialization_Specialization>;
};

/** Program eligibility for Career Academy result */
export type CareerAcademy_ProgramEligibilityResult = {
  __typename?: 'CareerAcademy_ProgramEligibilityResult';
  /** Indicate that Career Academy can be enabled for the Program. */
  eligible: Scalars['Boolean'];
};

/** Entity representing a category in context of Reference Curriculum of Career Academy */
export type CareerAcademy_ReferenceCurriculumCategory = {
  __typename?: 'CareerAcademy_ReferenceCurriculumCategory';
  /** Display name of category */
  name: Scalars['String'];
  /** Career roles that belong to this category. */
  roles: Array<CareerAcademy_ReferenceCurriculumRole>;
};

/**
 * Entity representing a role in a context of reference curriculum of Career Academy.
 * It differs from CareerAcademy_Role because it may contain unbound roles
 */
export type CareerAcademy_ReferenceCurriculumRole = {
  __typename?: 'CareerAcademy_ReferenceCurriculumRole';
  /** List of Guided Projects assigned to the Role. */
  guidedProjects: Array<Course_Course>;
  /** ID of the role */
  id: Scalars['ID'];
  /** Display name of role */
  name: Scalars['String'];
  /** List of Professional Certificates assigned to the Role. */
  professionalCertificates: Array<CareerAcademy_ProfessionalCertificate>;
};

/** input object of mutation CareerAcademy_RefreshCurriculums */
export type CareerAcademy_RefreshCurriculumsInput = {
  /**
   * Variants that needs to be updated by RefreshCurriculum job
   * Will update all variants when empty
   */
  variants: Array<CareerAcademy_Variant>;
};

/** Result for triggering curriculum refresh job */
export type CareerAcademy_RefreshCurriculumsResult = {
  __typename?: 'CareerAcademy_RefreshCurriculumsResult';
  /** Time curriculum refresh was triggered */
  refreshTime: Scalars['DateTime'];
  /** Status of the refresh job. */
  status: CareerAcademy_RefreshJobStatus;
};

/** RefreshCurriculums job status result */
export type CareerAcademy_RefreshCurriculumsStatusResult = {
  __typename?: 'CareerAcademy_RefreshCurriculumsStatusResult';
  /** Status of the refresh job. */
  status: CareerAcademy_RefreshJobStatus;
};

/** Enum representing status of the refresh job */
export const CareerAcademy_RefreshJobStatus = {
  /** Refresh job is idle */
  Idle: 'IDLE',
  /** Refresh job is currently running */
  Running: 'RUNNING',
  /** Refresh job has started */
  Started: 'STARTED'
} as const;

export type CareerAcademy_RefreshJobStatus = typeof CareerAcademy_RefreshJobStatus[keyof typeof CareerAcademy_RefreshJobStatus];
/** Input for removing content from a role. */
export type CareerAcademy_RemoveContentFromRoleInput = {
  /** IDs of the content. */
  id: Scalars['ID'];
  /** ID of the role */
  roleId: Scalars['ID'];
  /** Variants of the role to which content will be removed from */
  variant: CareerAcademy_Variant;
};

/** Result for removing content from a role */
export type CareerAcademy_RemoveContentFromRoleResult = {
  __typename?: 'CareerAcademy_RemoveContentFromRoleResult';
  /** Time content was removed from the role. */
  updatedTime: Scalars['DateTime'];
};

/** Entity representing a role in Career Academy. More fields will be added in next milestone. */
export type CareerAcademy_Role = {
  __typename?: 'CareerAcademy_Role';
  /**
   * List of content in the role. If variant is present, it will return content for that variant, else it will return
   * content for all the variants.
   */
  content: Array<CareerAcademy_ContentId>;
  /** ID of the role */
  id: Scalars['ID'];
  /** Display name of role */
  name: Scalars['String'];
};


/** Entity representing a role in Career Academy. More fields will be added in next milestone. */
export type CareerAcademy_RoleContentArgs = {
  variant?: InputMaybe<CareerAcademy_Variant>;
};

/** Input for update program curriculum */
export type CareerAcademy_UpdateProgramCurriculumInput = {
  /** Denotes program ID that will be updated */
  programId: Scalars['ID'];
  /**
   * Denotes to a list of role identifiers representing a subset CA reference curriculum roles.
   * Program admins may select only roles they want to be included in programs
   * instead of importing all roles from CA reference curriculum.
   * If empty the desired program will have all CA reference curriculum's role added to it's curriculum
   */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Variant of the program that will be updated */
  variant: CareerAcademy_Variant;
};

/** Update for update program curriculum */
export type CareerAcademy_UpdateProgramCurriculumResult = {
  __typename?: 'CareerAcademy_UpdateProgramCurriculumResult';
  /** Time program's curriculum was updated */
  updatedTime: Scalars['DateTime'];
};

/** The variant of Career Academy we're using (typically region/language based). */
export const CareerAcademy_Variant = {
  /** Variant containing arabic content in addition to default content. */
  Arabic: 'ARABIC',
  /** Default variant containing english content. */
  Default: 'DEFAULT',
  /** Grow with Google is an offering that contains just Google entry-level certs, and limited corresponding roles for it. */
  GrowWithGoogle: 'GROW_WITH_GOOGLE',
  /** Enum representing when no variant is present. */
  None: 'NONE',
  /** Variant containing spanish content in addition to default content. */
  Spanish: 'SPANISH'
} as const;

export type CareerAcademy_Variant = typeof CareerAcademy_Variant[keyof typeof CareerAcademy_Variant];
/** Career role completion status filter. */
export const CareerRole_CompletionStatusFilter = {
  /** All roles in the Role Taxonomy 2.0. */
  All: 'ALL',
  /** Completed roles, have completed merchandising data and pathways, can be ready for launching RDP. */
  Completed: 'COMPLETED',
  /** Roles with at least one pathway linked to it, merchandising data is not guaranteed. */
  PathwayLinked: 'PATHWAY_LINKED'
} as const;

export type CareerRole_CompletionStatusFilter = typeof CareerRole_CompletionStatusFilter[keyof typeof CareerRole_CompletionStatusFilter];
/** Image metadata */
export type CareerRole_Image = {
  __typename?: 'CareerRole_Image';
  /** Image description. */
  description?: Maybe<Scalars['String']>;
  /** Expected height of the image. */
  height: Scalars['Float'];
  /** Image link. */
  url: Scalars['URL'];
  /** Expected width of the image. */
  width: Scalars['Float'];
};

/** The job posting data based on the role and country. */
export type CareerRole_JobPostingData = {
  __typename?: 'CareerRole_JobPostingData';
  /** Country name. */
  countryName?: Maybe<Scalars['String']>;
  /** Currency code. */
  currencyCode?: Maybe<Scalars['String']>;
  /** The median annual salary advertised on job postings. */
  medianSalary?: Maybe<Scalars['Float']>;
  /** The number of unique active job postings that match this role. */
  numJobsAvailable?: Maybe<Scalars['Int']>;
};

/** The merchandising job categories that used for merchandising and filtering. */
export const CareerRole_MerchandisingJobCategory = {
  /** Business */
  Business: 'BUSINESS',
  /** Data & Analytics */
  DataAndAnalytics: 'DATA_AND_ANALYTICS',
  /** Healthcare */
  Healthcare: 'HEALTHCARE',
  /** Sales & Marketing */
  SalesAndMarketing: 'SALES_AND_MARKETING',
  /** Software & IT */
  SoftwareAndIt: 'SOFTWARE_AND_IT'
} as const;

export type CareerRole_MerchandisingJobCategory = typeof CareerRole_MerchandisingJobCategory[keyof typeof CareerRole_MerchandisingJobCategory];
/** The levels of the pathway specializations. */
export const CareerRole_PathwayLevel = {
  /** Advanced */
  Advanced: 'ADVANCED',
  /** Beginner */
  Beginner: 'BEGINNER',
  /** Intermediate */
  Intermediate: 'INTERMEDIATE'
} as const;

export type CareerRole_PathwayLevel = typeof CareerRole_PathwayLevel[keyof typeof CareerRole_PathwayLevel];
/** Career role product type. */
export const CareerRole_ProductType = {
  /** Course. */
  Course: 'COURSE',
  /** Degree. */
  Degree: 'DEGREE',
  /** Specialization (professional certificates included). */
  Specialization: 'SPECIALIZATION'
} as const;

export type CareerRole_ProductType = typeof CareerRole_ProductType[keyof typeof CareerRole_ProductType];
/** Cart */
export type Cart = {
  __typename?: 'Cart';
  /** Cart ID */
  id: Scalars['ID'];
};

export type CatalogCollectionPagesV1 = {
  __typename?: 'CatalogCollectionPagesV1';
  collection: CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogResult;
  courses?: Maybe<CoursesV1Connection>;
  curatorDescription?: Maybe<CatalogCollectionPagesV1_CuratorDescription>;
  curatorHeader?: Maybe<CatalogCollectionPagesV1_CuratorHeader>;
  degrees?: Maybe<DegreesV1Connection>;
  description?: Maybe<CatalogCollectionPagesV1_CmlMember>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  primaryLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  relatedCollectionPageIds: Array<Maybe<Scalars['String']>>;
  relatedCollectionPages?: Maybe<CatalogCollectionPagesV1Connection>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  secondaryDescription?: Maybe<CatalogCollectionPagesV1_SecondaryDescription>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  title: Scalars['String'];
};


export type CatalogCollectionPagesV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type CatalogCollectionPagesV1DegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogCollectionPagesV1RelatedCollectionPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogCollectionPagesV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CatalogCollectionPagesV1BySlug = {
  __typename?: 'CatalogCollectionPagesV1BySlug';
  connection?: Maybe<CatalogCollectionPagesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CatalogCollectionPagesV1Connection = {
  __typename?: 'CatalogCollectionPagesV1Connection';
  elements: Array<Maybe<CatalogCollectionPagesV1>>;
  paging: ResponsePagination;
};

export type CatalogCollectionPagesV1Resource = {
  __typename?: 'CatalogCollectionPagesV1Resource';
  bySlug?: Maybe<CatalogCollectionPagesV1Connection>;
  get?: Maybe<CatalogCollectionPagesV1>;
  multiGet?: Maybe<CatalogCollectionPagesV1Connection>;
  visibleToLearners?: Maybe<CatalogCollectionPagesV1Connection>;
};


export type CatalogCollectionPagesV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogCollectionPagesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type CatalogCollectionPagesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogCollectionPagesV1ResourceVisibleToLearnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CatalogCollectionPagesV1VisibleToLearners = {
  __typename?: 'CatalogCollectionPagesV1VisibleToLearners';
  connection?: Maybe<CatalogCollectionPagesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type CatalogCollectionPagesV1_CmlMember = {
  __typename?: 'CatalogCollectionPagesV1_cmlMember';
  cml: CatalogCollectionPagesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type CatalogCollectionPagesV1_CuratorDescription = CatalogCollectionPagesV1_CmlMember | DummyType;

export type CatalogCollectionPagesV1_CuratorHeader = CatalogCollectionPagesV1_CmlMember | DummyType;

export type CatalogCollectionPagesV1_Org_Coursera_Catalog_Suggestion = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_catalog_Suggestion';
  frequency: Scalars['Float'];
  term: Scalars['String'];
};

export type CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogEntry = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_catalogp_browse_CatalogEntry';
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  additionalSolrFieldValues?: Maybe<Scalars['JSON']>;
  courseId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isFreeCertificate?: Maybe<Scalars['Boolean']>;
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  latestVersionedS12nId?: Maybe<Scalars['String']>;
  onDemandSpecializationId?: Maybe<Scalars['String']>;
  relatedIds?: Maybe<CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds>;
  resourceName: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  specializationId?: Maybe<Scalars['String']>;
};

/** Record that contains ids relating to a specific CatalogEntry in some way. For example, if the CatalogEntry is a course, the `s12nId` field will be populated with the s12n that the course is a part of. "degreeId" will only be filled if a COURSE is a degree course "upsellsDegreeId" will be filled if a COURSE or S12N is a degree course, or is a stackable open degree enrollment item details: https://coursera.atlassian.net/wiki/spaces/GROW/pages/49512475/Degree+Upsells */
export type CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_catalogp_browse_CatalogEntryRelatedIds';
  /** Identifier for a degree. */
  degreeId?: Maybe<Scalars['String']>;
  s12nId?: Maybe<Scalars['String']>;
  /** Identifier for a degree. */
  upsellsDegreeId?: Maybe<Scalars['String']>;
};

export type CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogResult = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_catalogp_browse_CatalogResult';
  debug?: Maybe<Scalars['String']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId?: Maybe<Scalars['String']>;
  entries: Array<Maybe<CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogEntry>>;
  eventingId?: Maybe<Scalars['String']>;
  facets: Scalars['JSON'];
  featuredListId?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  label?: Maybe<Scalars['String']>;
  linkedCollectionPageMetadata?: Maybe<CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget>;
  overrideRank?: Maybe<Scalars['Int']>;
  query?: Maybe<Scalars['String']>;
  relatedQueries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
  suggestions: Array<Maybe<CatalogCollectionPagesV1_Org_Coursera_Catalog_Suggestion>>;
};

export type CatalogCollectionPagesV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_catalogp_browse_CatalogResultTarget';
  /** Typeref for string that defines the isTranslatable property to true */
  label: Scalars['String'];
  url: Scalars['String'];
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type CatalogCollectionPagesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<CatalogCollectionPagesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type CatalogCollectionPagesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<CatalogCollectionPagesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type CatalogCollectionPagesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: CatalogCollectionPagesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type CatalogCollectionPagesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type CatalogCollectionPagesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'CatalogCollectionPagesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<CatalogCollectionPagesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type CatalogCollectionPagesV1_SecondaryDescription = CatalogCollectionPagesV1_CmlMember | DummyType;

/** Catalog degree courses hold the marketing aspects of the private university courses. */
export type CatalogDegreeCourseQueries = {
  __typename?: 'CatalogDegreeCourseQueries';
  /** Returns the catalog degree course with the given course id */
  getCourseById?: Maybe<Course_Course>;
  /** Returns the catalog degree courses for the given course ids */
  getCoursesByIds?: Maybe<Array<Course_Course>>;
};


/** Catalog degree courses hold the marketing aspects of the private university courses. */
export type CatalogDegreeCourseQueriesGetCourseByIdArgs = {
  id: Scalars['ID'];
};


/** Catalog degree courses hold the marketing aspects of the private university courses. */
export type CatalogDegreeCourseQueriesGetCoursesByIdsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type CatalogMastertracksV1 = {
  __typename?: 'CatalogMastertracksV1';
  bannerImage?: Maybe<Scalars['String']>;
  catalogAvailabilityStatus: CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus;
  domainIds: Array<Maybe<Scalars['String']>>;
  domains?: Maybe<DomainsV1Connection>;
  id: Scalars['String'];
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  languageCode: Scalars['String'];
  launchDate?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  partners?: Maybe<PartnersV1Connection>;
  productVariant: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  shortName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  upsellCourseIds: Array<Maybe<Scalars['String']>>;
  upsellCourses?: Maybe<DomainsV1Connection>;
};


export type CatalogMastertracksV1DomainsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogMastertracksV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogMastertracksV1UpsellCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CatalogMastertracksV1ByPartnerId = {
  __typename?: 'CatalogMastertracksV1ByPartnerId';
  connection?: Maybe<CatalogMastertracksV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  liveOnly?: Maybe<Scalars['Boolean']>;
  partnerId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CatalogMastertracksV1BySlug = {
  __typename?: 'CatalogMastertracksV1BySlug';
  connection?: Maybe<CatalogMastertracksV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  liveOnly?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CatalogMastertracksV1Connection = {
  __typename?: 'CatalogMastertracksV1Connection';
  elements: Array<Maybe<CatalogMastertracksV1>>;
  paging: ResponsePagination;
};

export type CatalogMastertracksV1Resource = {
  __typename?: 'CatalogMastertracksV1Resource';
  byPartnerId?: Maybe<CatalogMastertracksV1Connection>;
  bySlug?: Maybe<CatalogMastertracksV1Connection>;
  get?: Maybe<CatalogMastertracksV1>;
  getAll?: Maybe<CatalogMastertracksV1Connection>;
  multiGet?: Maybe<CatalogMastertracksV1Connection>;
};


export type CatalogMastertracksV1ResourceByPartnerIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  liveOnly?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogMastertracksV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  liveOnly?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogMastertracksV1ResourceGetArgs = {
  id: Scalars['String'];
  liveOnly?: InputMaybe<Scalars['Boolean']>;
};


export type CatalogMastertracksV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  liveOnly?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CatalogMastertracksV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  liveOnly?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof CatalogMastertracksV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
/** TODO: Complete this description */
export type CertificateMetadata = {
  __typename?: 'CertificateMetadata';
  /** Granted at timestamp. */
  grantedAt?: Maybe<Timestamp>;
  /** Verify code of the certificate. */
  verifyCode?: Maybe<Scalars['String']>;
};

/** Represents the queries related to Certificate Print Settings */
export type CertificatePrintSettingsQueries = {
  __typename?: 'CertificatePrintSettingsQueries';
  /** Retrieves the print settings for a course certificate */
  queryCourseCertificatePrintSettingsById?: Maybe<Certificates_CourseCertificatePrintSettings>;
  /** Retrieves the print settings for a specialization certificate */
  queryS12nCertificatePrintSettingsById?: Maybe<Certificates_S12nCertificateOnDemandPrintSettings>;
};


/** Represents the queries related to Certificate Print Settings */
export type CertificatePrintSettingsQueriesQueryCourseCertificatePrintSettingsByIdArgs = {
  settingsId: Certificates_CourseCertificatePrintSettingsIdInput;
};


/** Represents the queries related to Certificate Print Settings */
export type CertificatePrintSettingsQueriesQueryS12nCertificatePrintSettingsByIdArgs = {
  settingsId: Certificates_S12nCertificatePrintSettingsIdInput;
};

/** All certificate-related queries */
export type CertificateQueries = {
  __typename?: 'CertificateQueries';
  /**
   * Internal API for power users to check certificates for any user.
   * Always returns validation results regardless of whether a certificate exists or not.
   * Returns either the certificate if it exists, or validation results if it doesn't.
   */
  getCertificateOrValidationByUserAndProduct: Certificates_CertificateOrValidation;
  /**
   * Returns a pre-signed URL for the authenticated user's certificate preview image,
   * or null if no preview is available. Requires the user to be logged in and to own
   * the certificate.
   *
   * High-latency, so callers should viewport-gate invocations or defer to CSR to avoid firing many in parallel on a single page.
   */
  getCertificatePreviewImage?: Maybe<Scalars['URL']>;
  /**
   * Get validation results for the currently logged in user and the given product.
   * Always returns validation results regardless of whether a certificate exists or not.
   * This is useful for checking certificate eligibility without needing to know if a certificate exists.
   */
  getCertificateValidationByProduct: Certificates_CertificateValidation;
  /**
   * Get certificate for the currently logged in user and the given product.
   * Returns either the certificate if it exists, or validation results if it doesn't.
   * If the certificate belongs to a different user than the logged in user, we throw an AccessDeniedException.
   */
  getMyCertificateByProduct: Certificates_CertificateOrValidation;
  /**
   * Fetch the certificate with complete details for the currently authenticated user.
   * This method will use the current user's ID from the authentication context.
   * If the certificate doesn't exist, this will return a NOT_FOUND error.
   * If the certificate belongs to a different user, this will return a PERMISSION_DENIED error.
   */
  getMyCertificateByVerifyCode?: Maybe<Certificates_Certificate>;
  /**
   * Fetch all certificates for the current user.
   * This method will use the current user's ID from the authentication context.
   * Only returns certificates belonging to the current user.
   * Returns an empty list if the user has no certificates.
   * @deprecated Use Recommendations { getMyCertificatesPaginated } instead.
   */
  getMyCertificates: Array<Certificates_Certificate>;
  /**
   * Fetch paginated certificates for the current user.
   * This method will use the current user's ID from the authentication context.
   * Only returns certificates belonging to the current user.
   * Returns an empty list if the user has no certificates. | Maximum page size: 100
   */
  getMyCertificatesPaginated: Certificates_PaginatedResult;
  /** Fetch a public certificate by verifyCode (available to anyone) */
  getPublicCertificateByVerifyCode?: Maybe<Certificates_PublicCertificate>;
};


/** All certificate-related queries */
export type CertificateQueriesGetCertificateOrValidationByUserAndProductArgs = {
  productItemId: Scalars['ID'];
  productType: Certificates_ProductType;
  userId: Scalars['ID'];
};


/** All certificate-related queries */
export type CertificateQueriesGetCertificatePreviewImageArgs = {
  verifyCode: Scalars['ID'];
};


/** All certificate-related queries */
export type CertificateQueriesGetCertificateValidationByProductArgs = {
  productItemId: Scalars['ID'];
  productType: Certificates_ProductType;
};


/** All certificate-related queries */
export type CertificateQueriesGetMyCertificateByProductArgs = {
  productItemId: Scalars['ID'];
  productType: Certificates_ProductType;
};


/** All certificate-related queries */
export type CertificateQueriesGetMyCertificateByVerifyCodeArgs = {
  verifyCode: Scalars['ID'];
};


/** All certificate-related queries */
export type CertificateQueriesGetMyCertificatesPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  productType?: InputMaybe<Certificates_ProductType>;
};


/** All certificate-related queries */
export type CertificateQueriesGetPublicCertificateByVerifyCodeArgs = {
  verifyCode: Scalars['ID'];
};

export type CertificateV1 = {
  __typename?: 'CertificateV1';
  certificateItemId: Scalars['String'];
  certificateType?: Maybe<CertificateV1_Org_Coursera_Certificate_CertificateType>;
  certificateTypeData: CertificateV1_CertificateTypeData;
  grantedAt: Scalars['Float'];
  id: Scalars['String'];
  lastModifiedAt: Scalars['Float'];
  platformOrigin: CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin;
  /** id for a Coursera user */
  userId: Scalars['Int'];
  verifyCode: Scalars['String'];
};

export type CertificateV1ByUser = {
  __typename?: 'CertificateV1ByUser';
  connection?: Maybe<CertificateV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CertificateV1ByUserAndCertificateType = {
  __typename?: 'CertificateV1ByUserAndCertificateType';
  certificateType: Scalars['String'];
  connection?: Maybe<CertificateV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CertificateV1ByVerifyCode = {
  __typename?: 'CertificateV1ByVerifyCode';
  connection?: Maybe<CertificateV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  verifyCode: Scalars['String'];
};

export type CertificateV1Connection = {
  __typename?: 'CertificateV1Connection';
  elements: Array<Maybe<CertificateV1>>;
  paging: ResponsePagination;
};

export type CertificateV1Resource = {
  __typename?: 'CertificateV1Resource';
  byUser?: Maybe<CertificateV1Connection>;
  byUserAndCertificateType?: Maybe<CertificateV1Connection>;
  byVerifyCode?: Maybe<CertificateV1Connection>;
  get?: Maybe<CertificateV1>;
  multiGet?: Maybe<CertificateV1Connection>;
};


export type CertificateV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type CertificateV1ResourceByUserAndCertificateTypeArgs = {
  certificateType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type CertificateV1ResourceByVerifyCodeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  verifyCode: Scalars['String'];
};


export type CertificateV1ResourceGetArgs = {
  id: Scalars['String'];
  useEventualConsistency?: InputMaybe<Scalars['Boolean']>;
};


export type CertificateV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  useEventualConsistency?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateV1ResourceMutations = {
  __typename?: 'CertificateV1ResourceMutations';
  create?: Maybe<CertificateV1Connection>;
  delete?: Maybe<CertificateV1Connection>;
  nukeByUser?: Maybe<Scalars['JSON']>;
  update?: Maybe<CertificateV1Connection>;
};


export type CertificateV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type CertificateV1ResourceMutationsNukeByUserArgs = {
  userId: Scalars['String'];
};


export type CertificateV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type CertificateV1_CourseCertificateMember = {
  __typename?: 'CertificateV1_CourseCertificateMember';
  CourseCertificate: CertificateV1_Org_Coursera_Certificate_CourseCertificate;
};

export type CertificateV1_SpecializationCertificateMember = {
  __typename?: 'CertificateV1_SpecializationCertificateMember';
  SpecializationCertificate: CertificateV1_Org_Coursera_Certificate_SpecializationCertificate;
};

export type CertificateV1_CertificateTypeData = CertificateV1_CourseCertificateMember | CertificateV1_SpecializationCertificateMember;

/** Distinction achieved by a learner getting a grade for a course */
export const CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** It is necessary to differentiate Spark and OnDemand courses because not all features can not treat these as the same thing. For example, we may have an upsell feature that prompts you to take a specialization if you took a course that is part of it. We wouldn't want this feature to treat all certs the same because Spark Courses/Specializations are no longer available. A SparkCourse Cert vs OnDemandCourse Cert shouldn't be considered as a different "type" of certificate though as they store the exact same fields. However a Course and a Specialization should be considered as different types as they are a completely different product */
export const CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin = {
  OnDemand: 'ON_DEMAND',
  Spark: 'SPARK'
} as const;

export type CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin = typeof CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin[keyof typeof CertificateV1_Org_Coursera_Certificate_CertificatePlatformOrigin];
/** Courier version of org.coursera.certificate.CertificateTypeV1 in org/coursera/certificate/package.scala. Number of certificate types have been reduced from CertificateTypeV1. Spark vs OnDemand is now represented in CertificatePlatformOrigin With/WithoutGrade is now represented using the CertificateSharingConfiguration. Honors course certs are defined through the Distinction level in CourseCertificate */
export const CertificateV1_Org_Coursera_Certificate_CertificateType = {
  Course: 'Course',
  Specialization: 'Specialization'
} as const;

export type CertificateV1_Org_Coursera_Certificate_CertificateType = typeof CertificateV1_Org_Coursera_Certificate_CertificateType[keyof typeof CertificateV1_Org_Coursera_Certificate_CertificateType];
/** We are not storing the passing state since earning a certificate implies you have passed the course. What about "passed" vs "verifiedPassed"?  In terms of Spark courses  -A user had to have a VerifiedPassed   to receive the certificate, regular passed doesn't count  -Verified Passed is only given for spark courses if a user  was part of SignatureTrack.  -Since we are only storing valid certificates, we only migrate  spark vc memberships that had a passing state of Verified Passed  In terms of OnDemand Courses  - As of Sept 2018, the grades system has deprecated  verifiedOutcome, we only use overallOutcome now.  We no longer have a notion of passed or verifiedPassed  so there is no logic that needs to depend on these states. */
export type CertificateV1_Org_Coursera_Certificate_CourseCertificate = {
  __typename?: 'CertificateV1_org_coursera_certificate_CourseCertificate';
  distinction: CertificateV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel;
  grade: Scalars['Float'];
  verifyCodeWithGrade?: Maybe<Scalars['String']>;
};

export type CertificateV1_Org_Coursera_Certificate_SpecializationCertificate = {
  __typename?: 'CertificateV1_org_coursera_certificate_SpecializationCertificate';
  ArbitraryField: Scalars['String'];
};

/** Union type representing either a course or specialization */
export type Certificate_Product = Course_Course | Specialization_Specialization;

/**
 * entity to return either the certificate, or a validation result for the requested learner,
 * product type and product id
 */
export type Certificate_UserProductCertificateOrValidation = {
  __typename?: 'Certificate_UserProductCertificateOrValidation';
  /** Certificate or validation result if user does not have a certificate for the course/specialization */
  certificate: Certificates_CertificateOrValidation;
  /** User entity stub for learner who's certificate is to be returned (only included as its needed to make the entity uniquely identifiable) */
  user: User_User;
};

/**
 * Private view of a certificate with complete information including grade.
 * Only available to the current logged-in user.
 */
export type Certificates_Certificate = Certificates_CertificateBase & {
  __typename?: 'Certificates_Certificate';
  /**
   * URL to a preview image of the certificate.
   *
   * High-latency to resolve, so when fetching more than a few certs in one query use
   * Certificate.getCertificatePreviewImage(verifyCode) with CSR or viewport loading to avoid fan-out and slow load times.
   */
  certificatePreviewImageUrl?: Maybe<Scalars['URL']>;
  /**
   * Grade earned for course certificates. Will be null for specialization certificates.
   * Only available in private certificate views.
   */
  grade?: Maybe<Scalars['Float']>;
  /** When the certificate was granted */
  grantedAt: Scalars['DateTime'];
  /** When the certificate was last modified */
  lastModifiedAt: Scalars['DateTime'];
  /** The course or specialization this certificate is for */
  product: Certificate_Product;
  /** Complete reference to the user who earned this certificate */
  user: User_User;
  /** Unique identifier for the certificate, also used for verification and sharing */
  verifyCode: Scalars['ID'];
};

/**
 * Base interface for certificates that includes common fields for both public and private certificate views.
 * Note: For client queries, prefer using product.__typename and product.id instead of certificateType and productItemId
 * which are marked as @inaccessible.
 */
export type Certificates_CertificateBase = {
  /** When the certificate was granted */
  grantedAt: Scalars['DateTime'];
  /** When the certificate was last modified */
  lastModifiedAt: Scalars['DateTime'];
  /** The course or specialization this certificate is for */
  product: Certificate_Product;
  /** Unique identifier for the certificate, also used for verification and sharing */
  verifyCode: Scalars['ID'];
};

/**
 * Union type for certificate check response.
 * Returns either:
 * - A certificate if it exists for the user
 * - Course validation results if the user hasn't earned a course certificate yet
 * - Specialization validation results if the user hasn't earned a specialization certificate yet
 */
export type Certificates_CertificateOrValidation = Certificates_Certificate | Certificates_CourseCertificateValidation | Certificates_SpecializationCertificateValidation;

/**
 * Union type for certificate validation response.
 * Returns either:
 * - Course validation results
 * - Specialization validation results
 */
export type Certificates_CertificateValidation = Certificates_CourseCertificateValidation | Certificates_SpecializationCertificateValidation;

/** Represents the print settings for a certificate with a disclaimer */
export type Certificates_CertificateWithDisclaimerPrintSettings = {
  __typename?: 'Certificates_CertificateWithDisclaimerPrintSettings';
  /** Disclaimer for the certificate */
  disclaimer: Scalars['String'];
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: Maybe<Scalars['URL']>;
  /** Signature image with text for the certificate */
  signatureImageWithText?: Maybe<Certificates_SignatureImageWithText>;
};

/** Represents the print settings for a certificate with disclaimer */
export type Certificates_CertificateWithDisclaimerPrintSettingsInput = {
  /** Disclaimer text for the certificate */
  disclaimer: Scalars['String'];
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText?: InputMaybe<Certificates_SignatureImageWithTextInput>;
};

/** Represents the print settings for a course certificate */
export type Certificates_CourseCertificatePrintSettings = Certificates_CertificateWithDisclaimerPrintSettings | Certificates_VerifiedCertificateOnDemandPrintSettings;

/** Represents the input for a course certificate print settings identifier */
export type Certificates_CourseCertificatePrintSettingsIdInput = {
  /** Type of the course certificate */
  certificateType: Certificates_CourseCertificateType;
  /** ID of the course */
  courseId: Scalars['ID'];
};

/** Represents the print settings for a course certificate */
export type Certificates_CourseCertificatePrintSettingsInput = {
  /** Print settings for a certificate with disclaimer */
  certificateWithDisclaimer?: InputMaybe<Certificates_CertificateWithDisclaimerPrintSettingsInput>;
  /** Print settings for a verified certificate on-demand */
  verifiedCertificateOnDemand?: InputMaybe<Certificates_VerifiedCertificateOnDemandPrintSettingsInput>;
};

/** Represents the certificate types for a course */
export const Certificates_CourseCertificateType = {
  /** Invalid certificate type */
  Invalid: 'INVALID',
  /** On-demand certificate type */
  OnDemand: 'ON_DEMAND',
  /** On-demand honors certificate type without grade */
  OnDemandHonorsWithoutGrade: 'ON_DEMAND_HONORS_WITHOUT_GRADE',
  /** On-demand certificate type without grade */
  OnDemandWithoutGrade: 'ON_DEMAND_WITHOUT_GRADE'
} as const;

export type Certificates_CourseCertificateType = typeof Certificates_CourseCertificateType[keyof typeof Certificates_CourseCertificateType];
/**
 * Detailed validation results for course certificate eligibility.
 * Provides comprehensive validation information when checking a single course.
 */
export type Certificates_CourseCertificateValidation = {
  __typename?: 'Certificates_CourseCertificateValidation';
  /** The course this validation is for */
  course: Course_Course;
  /** The learners grade if the learner passed the course, the grade is a fraction value that can range between 0.0 and 1.0, null if the user hasn't passed yet */
  grade?: Maybe<Scalars['Float']>;
  /** Whether ID verification requirements are satisfied (either the user has verified or they're not required to verify for the course) */
  hasUserFulfilledIdVerificationRequirement: Scalars['Boolean'];
  /** Whether name verification requirements are satisfied (either the user has verified or they're not required to verify for the course) */
  hasUserFulfilledNameVerificationRequirement: Scalars['Boolean'];
  /**
   * Whether the user has to complete any outstanding payments requirements, such as free trial learners who need to
   * convert their subscription to paid. Some users will not need to pay, such as enterprise learners or financial aid 100% off recipients.
   */
  hasUserFulfilledPaymentRequirements: Scalars['Boolean'];
  /** Whether the user has passed the course */
  isPassed: Scalars['Boolean'];
  /** Whether all validation requirements are met */
  isValid: Scalars['Boolean'];
  /** When the learners grade was last modified at, null if the user hasn't passed yet */
  lastModifiedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the user owns or has owned the product */
  ownsOrHasOwnedProduct: Scalars['Boolean'];
  /** Whether the user has an active profile */
  userHasActiveProfile: Scalars['Boolean'];
};

/**
 * Simplified validation status for a course within a specialization.
 * Used to report course validation status in specialization certificate checks.
 */
export type Certificates_CourseCertificateValidationStatus = {
  __typename?: 'Certificates_CourseCertificateValidationStatus';
  /** The course this validation is for */
  course: Course_Course;
  /** Whether the course validation requirements are met */
  isValid: Scalars['Boolean'];
};

/** Represents the input for deleting certificate print settings */
export type Certificates_DeleteCourseCertificatePrintSettingsInput = {
  /** Unique identifier for a course certificate print settings request */
  settingsId: Certificates_CourseCertificatePrintSettingsIdInput;
};

/** Represents the response for deleting a course certificate print settings */
export type Certificates_DeleteCourseCertificatePrintSettingsResult = {
  __typename?: 'Certificates_DeleteCourseCertificatePrintSettingsResult';
  /** It returns true in case settings was deleted successfuly */
  deleted: Scalars['Boolean'];
};

/** Represents the input for deleting certificate print settings */
export type Certificates_DeleteS12nCertificatePrintSettingsInput = {
  /** Unique identifier for a s12n certificate print settings request */
  settingsId: Certificates_S12nCertificatePrintSettingsIdInput;
};

/** Represents the response for deleting a s12n certificate print settings */
export type Certificates_DeleteS12nCertificatePrintSettingsResult = {
  __typename?: 'Certificates_DeleteS12nCertificatePrintSettingsResult';
  /** It returns true in case settings was deleted successfuly */
  deleted: Scalars['Boolean'];
};

/** Paginated result wrapper for Certificates_Certificate */
export type Certificates_PaginatedResult = {
  __typename?: 'Certificates_PaginatedResult';
  /** A list of skill expressions that match the provided query */
  elements: Array<Certificates_Certificate>;
  /** Pagination information */
  pagination: Pagination;
};

/** Type of certificate */
export const Certificates_ProductType = {
  /** Certificate for completing a course */
  Course: 'COURSE',
  /** Certificate for completing a specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type Certificates_ProductType = typeof Certificates_ProductType[keyof typeof Certificates_ProductType];
/**
 * Public view of a certificate which excludes private information like grade and private user information
 * Available to anyone
 */
export type Certificates_PublicCertificate = Certificates_CertificateBase & {
  __typename?: 'Certificates_PublicCertificate';
  /** When the certificate was granted */
  grantedAt: Scalars['DateTime'];
  /** When the certificate was last modified */
  lastModifiedAt: Scalars['DateTime'];
  /** The course or specialization this certificate is for */
  product: Certificate_Product;
  /** Public facing user data */
  user: User_PublicUser;
  /** Unique identifier for the certificate, also used for verification and sharing */
  verifyCode: Scalars['ID'];
};

/** Represents the print settings for a specialization certificate on-demand */
export type Certificates_S12nCertificateOnDemandPrintSettings = {
  __typename?: 'Certificates_S12nCertificateOnDemandPrintSettings';
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: Maybe<Scalars['URL']>;
  /** Signature image with text for the certificate */
  signatureImageWithText?: Maybe<Certificates_SignatureImageWithText>;
};

/** Represents the print settings for a specialization certificate on-demand */
export type Certificates_S12nCertificateOnDemandPrintSettingsInput = {
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText?: InputMaybe<Certificates_SignatureImageWithTextInput>;
};

/** Represents the input for an s12n certificate print settings identifier */
export type Certificates_S12nCertificatePrintSettingsIdInput = {
  /** Type of the s12n certificate */
  certificateType: Certificates_S12nCertificateType;
  /** ID of the s12n */
  s12nId: Scalars['ID'];
};

/** Represents the certificate types for a specialization */
export const Certificates_S12nCertificateType = {
  /** Invalid certificate type */
  Invalid: 'INVALID',
  /** Specialization certificate type */
  Specialization: 'SPECIALIZATION',
  /** Specialization on-demand certificate type */
  SpecializationOnDemand: 'SPECIALIZATION_ON_DEMAND'
} as const;

export type Certificates_S12nCertificateType = typeof Certificates_S12nCertificateType[keyof typeof Certificates_S12nCertificateType];
/** Represents the signature image with text for a certificate */
export type Certificates_SignatureImageWithText = {
  __typename?: 'Certificates_SignatureImageWithText';
  /** Signature text for the certificate */
  signatureText: Scalars['String'];
  /** Signature URL for the certificate. Null if not exists. */
  signatureUrl?: Maybe<Scalars['URL']>;
};

/** Represents input for the signature in a certificate */
export type Certificates_SignatureImageWithTextInput = {
  /** Text to display alongside the signature */
  signatureText: Scalars['String'];
  /** URL of the signature image. Null if not exists. */
  signatureUrl?: InputMaybe<Scalars['URL']>;
};

/**
 * Validation results for specialization certificate eligibility.
 * Returns a simplified validation status for each course in the specialization.
 */
export type Certificates_SpecializationCertificateValidation = {
  __typename?: 'Certificates_SpecializationCertificateValidation';
  /**
   * List of course validation statuses within the specialization.
   * Each entry contains the course reference and its validation status.
   */
  courseValidations: Array<Certificates_CourseCertificateValidationStatus>;
  /** Whether all validation requirements are met */
  isValid: Scalars['Boolean'];
  /** The specialization this validation is for */
  specialization: Specialization_Specialization;
};

/** Represents the input for updating course certificate print settings */
export type Certificates_UpdateCourseCertificatePrintSettingsInput = {
  /** The updated course certificate print settings */
  printSettings: Certificates_CourseCertificatePrintSettingsInput;
  /** Unique identifier for the course certificate print settings */
  settingsId: Certificates_CourseCertificatePrintSettingsIdInput;
};

/** Represents the result of updating course certificate print settings */
export type Certificates_UpdateCourseCertificatePrintSettingsResult = {
  __typename?: 'Certificates_UpdateCourseCertificatePrintSettingsResult';
  /** The updated course certificate print settings */
  printSettings?: Maybe<Certificates_CourseCertificatePrintSettings>;
};

/** Represents the input for updating s12n certificate print settings */
export type Certificates_UpdateS12nCertificatePrintSettingsInput = {
  /** The updated s12n certificate print settings */
  printSettings: Certificates_S12nCertificateOnDemandPrintSettingsInput;
  /** Unique identifier for the s12n certificate print settings */
  settingsId: Certificates_S12nCertificatePrintSettingsIdInput;
};

/** Represents the result of updating s12n certificate print settings */
export type Certificates_UpdateS12nCertificatePrintSettingsResult = {
  __typename?: 'Certificates_UpdateS12nCertificatePrintSettingsResult';
  /** The updated s12n certificate print settings */
  printSettings?: Maybe<Certificates_S12nCertificateOnDemandPrintSettings>;
};

/** Represents the print settings for a verified certificate on-demand */
export type Certificates_VerifiedCertificateOnDemandPrintSettings = {
  __typename?: 'Certificates_VerifiedCertificateOnDemandPrintSettings';
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: Maybe<Scalars['URL']>;
  /** Signature image with text for the certificate */
  signatureImageWithText?: Maybe<Certificates_SignatureImageWithText>;
};

/** Represents the print settings for a verified certificate on-demand */
export type Certificates_VerifiedCertificateOnDemandPrintSettingsInput = {
  /** Partner override logo URL for the certificate. Null if not exists. */
  partnerOverrideLogoUrl?: InputMaybe<Scalars['URL']>;
  /** Signature image and text for the certificate */
  signatureImageWithText: Certificates_SignatureImageWithTextInput;
};

/** TODO: Complete this description */
export type CheatingCaseQueries = {
  __typename?: 'CheatingCaseQueries';
  /** This query returns a copy of highlighed words from the flagged submission with words that appear in the matched submission. */
  queryHighlightedSubmission: CheatingCase_HighlightedSubmissionDetails;
  /** This query returns the activity details for the learner's cheating case. */
  queryLearnerActivityDetails: CheatingCase_ActivityDetails;
  /** This query returns the list of top similar submissions against learner's submission. */
  queryTopSimilarSubmissions: Array<CheatingCase_SimilarSubmissionDetail>;
};


/** TODO: Complete this description */
export type CheatingCaseQueriesQueryHighlightedSubmissionArgs = {
  flaggedSubmissionId: Scalars['String'];
  matchedSubmissionId: Scalars['String'];
};


/** TODO: Complete this description */
export type CheatingCaseQueriesQueryLearnerActivityDetailsArgs = {
  cheatingCaseId: Scalars['String'];
};


/** TODO: Complete this description */
export type CheatingCaseQueriesQueryTopSimilarSubmissionsArgs = {
  submissionId: Scalars['String'];
};

/** TODO: Complete this description */
export const CheatingCaseStatus = {
  /** the learner has requested an appeal for the case and was denied */
  AppealDenied: 'APPEAL_DENIED',
  /** the case has been granted an appeal with the false positive reason */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE',
  /** the case has been granted an appeal with an "other" reason */
  AppealOther: 'APPEAL_OTHER',
  /** the learner has requested an appeal for the case */
  AppealRequested: 'APPEAL_REQUESTED',
  /** cheating confirmed */
  CheatingConfirmed: 'CHEATING_CONFIRMED',
  /** cheating not confirmed */
  CheatingNotConfirmed: 'CHEATING_NOT_CONFIRMED',
  /** the case is still being resolved */
  InProgress: 'IN_PROGRESS',
  /** resolved no ruling */
  ResolvedNoRuling: 'RESOLVED_NO_RULING'
} as const;

export type CheatingCaseStatus = typeof CheatingCaseStatus[keyof typeof CheatingCaseStatus];
/** Queries related to cheating case tasks */
export type CheatingCaseTaskQueries = {
  __typename?: 'CheatingCaseTaskQueries';
  /** Returns a cheating case task */
  queryCheatingCaseTaskByStepId: CheatingCaseTask_EvidenceDevelopmentExecutorTask;
};


/** Queries related to cheating case tasks */
export type CheatingCaseTaskQueriesQueryCheatingCaseTaskByStepIdArgs = {
  cheatingCaseStepId: Scalars['String'];
};

/** Task to support multiple cases for same peer submission */
export type CheatingCaseTask_AdditionalPeerFlagEvidenceTask = {
  __typename?: 'CheatingCaseTask_AdditionalPeerFlagEvidenceTask';
  /** Dummy field since type cannot be empty in GraphQL */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** Placeholder task */
export type CheatingCaseTask_AdditionalSimilarityCheckEvidenceTask = {
  __typename?: 'CheatingCaseTask_AdditionalSimilarityCheckEvidenceTask';
  /** Dummy field since type cannot be empty in GraphQL */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** An option definition within the enumerated options schema */
export type CheatingCaseTask_EnumeratedInputSchemaOption = {
  __typename?: 'CheatingCaseTask_EnumeratedInputSchemaOption';
  display: Scalars['String'];
  key: Scalars['String'];
  score: Scalars['Float'];
};

/** Schema with enumerated options */
export type CheatingCaseTask_EnumeratedOptionsSchema = {
  __typename?: 'CheatingCaseTask_EnumeratedOptionsSchema';
  /** Options for response schema */
  options: Array<CheatingCaseTask_EnumeratedInputSchemaOption>;
};

/** Cheating case task can be one of different types. */
export type CheatingCaseTask_EvidenceDevelopmentExecutorTask = CheatingCaseTask_AdditionalPeerFlagEvidenceTask | CheatingCaseTask_AdditionalSimilarityCheckEvidenceTask | CheatingCaseTask_FlaggerCommentSubmissionIdentifierExecutorTask | CheatingCaseTask_OutsourcingAgentRubricTask | CheatingCaseTask_StaffCommentCollectionTask | CheatingCaseTask_StaffRulingCollectionTask | CheatingCaseTask_TestTask;

/** Cheating case task from flagger */
export type CheatingCaseTask_FlaggerCommentSubmissionIdentifierExecutorTask = {
  __typename?: 'CheatingCaseTask_FlaggerCommentSubmissionIdentifierExecutorTask';
  includeFlaggerOwnSubmission: Scalars['Boolean'];
  includeMyOwnMention: Scalars['Boolean'];
  includeNameMention: Scalars['Boolean'];
  includeSubmissionIdMention: Scalars['Boolean'];
  maxSubmissions?: Maybe<Scalars['Int']>;
};

/** Schema with number range */
export type CheatingCaseTask_NumericRangeSchema = {
  __typename?: 'CheatingCaseTask_NumericRangeSchema';
  maxScore: Scalars['Float'];
  minScore: Scalars['Float'];
};

/** Schema for rubric item within task for outsourcing agent */
export type CheatingCaseTask_OutsourcingAgentRubricItem = {
  __typename?: 'CheatingCaseTask_OutsourcingAgentRubricItem';
  /** Prompt shown to outsourcing agent. */
  prompt: Scalars['String'];
  /** Schema for agent response */
  responseSchema: CheatingCaseTask_ResponseSchema;
  /** Rubric item ID */
  rubricItemId: Scalars['String'];
  /** Item weight in scoring formula */
  weight: Scalars['Float'];
};

/** Cheating case task for outsourcing agent */
export type CheatingCaseTask_OutsourcingAgentRubricTask = {
  __typename?: 'CheatingCaseTask_OutsourcingAgentRubricTask';
  prompt: CmlContent;
  /** List of rubric items in outsourced cheating case task */
  rubricItems: Array<CheatingCaseTask_OutsourcingAgentRubricItem>;
  /** Outsourced ticketing system */
  ticketSystem?: Maybe<CheatingCaseTask_TicketSystem>;
};

/** Schema for agent response can be one of different types. */
export type CheatingCaseTask_ResponseSchema = CheatingCaseTask_EnumeratedOptionsSchema | CheatingCaseTask_NumericRangeSchema;

/** Salesforce environment status */
export const CheatingCaseTask_SalesforceEnvironment = {
  SalesForceEnvironmentInvalid: 'SALES_FORCE_ENVIRONMENT_INVALID',
  SalesForceEnvironmentSfExpDev: 'SALES_FORCE_ENVIRONMENT_SF_EXP_DEV',
  SalesForceEnvironmentSfProd: 'SALES_FORCE_ENVIRONMENT_SF_PROD',
  SalesForceEnvironmentSfQaBuild: 'SALES_FORCE_ENVIRONMENT_SF_QA_BUILD',
  SalesForceEnvironmentSfUat: 'SALES_FORCE_ENVIRONMENT_SF_UAT'
} as const;

export type CheatingCaseTask_SalesforceEnvironment = typeof CheatingCaseTask_SalesforceEnvironment[keyof typeof CheatingCaseTask_SalesforceEnvironment];
/** Salesforce case queue */
export type CheatingCaseTask_SalesforcePlagiarismCaseQueue = {
  __typename?: 'CheatingCaseTask_SalesforcePlagiarismCaseQueue';
  /** Salesforce environment status */
  salesforceEnv: CheatingCaseTask_SalesforceEnvironment;
};

/** Placeholder task */
export type CheatingCaseTask_StaffCommentCollectionTask = {
  __typename?: 'CheatingCaseTask_StaffCommentCollectionTask';
  /** Dummy field since type cannot be empty in GraphQL */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** Placeholder task */
export type CheatingCaseTask_StaffRulingCollectionTask = {
  __typename?: 'CheatingCaseTask_StaffRulingCollectionTask';
  /** Dummy field since type cannot be empty in GraphQL */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** Dummy task for testing */
export type CheatingCaseTask_TestTask = {
  __typename?: 'CheatingCaseTask_TestTask';
  /** Label for testing */
  label: Scalars['String'];
};

/** Outsourced ticketing systems */
export type CheatingCaseTask_TicketSystem = CheatingCaseTask_SalesforcePlagiarismCaseQueue | CheatingCaseTask_ZenDeskPlagiarismTicketQueue;

/** Dummy record for the current behaviour of creating tickets on zendesk */
export type CheatingCaseTask_ZenDeskPlagiarismTicketQueue = {
  __typename?: 'CheatingCaseTask_ZenDeskPlagiarismTicketQueue';
  /** Dummy field since type cannot be empty in GraphQL */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** TODO: Complete this description */
export type CheatingCase_ActivityDetails = {
  __typename?: 'CheatingCase_activityDetails';
  /** Course item id. */
  courseItemId: Scalars['ID'];
  /** Course slug. */
  courseSlug: Scalars['String'];
  /** The list of submission details for the learner's cheating case. */
  learnerSubmissionDetails: Array<CheatingCase_LearnerSubmissionDetail>;
};

/** TODO: Complete this description */
export type CheatingCase_Content = CheatingCase_HtmlContent | CmlContent;

/** TODO: Complete this description */
export type CheatingCase_HighlightedSubmissionDetails = {
  __typename?: 'CheatingCase_highlightedSubmissionDetails';
  /** TODO: Complete this description */
  parts: Array<CheatingCase_HighlightedSubmissionPart>;
  /** TODO: Complete this description */
  submissionId: Scalars['ID'];
};

/** TODO: Complete this description */
export type CheatingCase_HighlightedSubmissionPart = {
  __typename?: 'CheatingCase_highlightedSubmissionPart';
  /** The prompt response authored by the learner. Html. */
  highlightedResponse: Scalars['String'];
  /** Peer review submission part id. */
  partId: Scalars['String'];
  /** The prompt question authored by the course author. */
  question: CheatingCase_Content;
};

/** TODO: Complete this description */
export type CheatingCase_HtmlContent = {
  __typename?: 'CheatingCase_htmlContent';
  /** TODO: Complete this description */
  value: Scalars['String'];
};

/** TODO: Complete this description */
export type CheatingCase_LearnerSubmissionDetail = {
  __typename?: 'CheatingCase_learnerSubmissionDetail';
  /** The author ID. */
  authorID: Scalars['ID'];
  /** The length of the submission. */
  characterLength?: Maybe<Scalars['Int']>;
  /** Optional cheating case id if a cheating case is associated with a submission. */
  cheatingCaseId?: Maybe<Scalars['ID']>;
  /** Enum type mapping cheating case status to a submission. */
  cheatingCaseStatus?: Maybe<CheatingCaseStatus>;
  /** The type of evidence. */
  evidenceType: EvidenceType;
  /** The ID of the submission. */
  id: Scalars['ID'];
  /**
   * Whether the submission has been confirmed for plagiarism.
   * @deprecated Use cheatingCaseStatus and matchedCheatingCaseId instead.
   */
  isConfirmedForPlagiarism: Scalars['Boolean'];
  /** The similarity score result for the submission. */
  similarityScore?: Maybe<Scalars['Int']>;
  /** The time of submission. */
  submissionTime: Scalars['Float'];
};

/** TODO: Complete this description */
export type CheatingCase_SimilarSubmissionDetail = {
  __typename?: 'CheatingCase_similarSubmissionDetail';
  /** The ID of the assignment. */
  assignmentId: Scalars['ID'];
  /** The author ID. */
  authorID: Scalars['ID'];
  /** The length of the submission. */
  characterLength?: Maybe<Scalars['Int']>;
  /** Optional cheating case id if a cheating case is associated with a submission. */
  cheatingCaseId?: Maybe<Scalars['ID']>;
  /** Enum type mapping cheating case status to a submission. */
  cheatingCaseStatus?: Maybe<CheatingCaseStatus>;
  /** Course item id. */
  courseItemId: Scalars['String'];
  /** Course slug. */
  courseSlug: Scalars['String'];
  /**
   * Whether the submission has been confirmed for plagiarism.
   * @deprecated Use cheatingCaseStatus and matchedCheatingCaseId instead.
   */
  isConfirmedForPlagiarism: Scalars['Boolean'];
  /** The similarity score result for the submission. */
  similarityScore?: Maybe<Scalars['Int']>;
  /** The ID of the submission. */
  submissionId: Scalars['ID'];
  /** The time of submission. This value is the unix epoch in milliseconds */
  submissionTime: Scalars['Float'];
};

/** cheating incident related queries */
export type CheatingIncidentQueries = {
  __typename?: 'CheatingIncidentQueries';
  /** query cheating incident details, details include event history and contact logs */
  queryCheatingIncidentHistoryDetails?: Maybe<CheatingIncident_DetailsResponse>;
  /** query cheating incidents by user id and course ids | Maximum page size: 1000 */
  queryCheatingIncidentsByUserIdAndCourseIds?: Maybe<CheatingIncident_CheatingIncidentConnection>;
};


/** cheating incident related queries */
export type CheatingIncidentQueriesQueryCheatingIncidentHistoryDetailsArgs = {
  cheatingIncidentId: Scalars['String'];
};


/** cheating incident related queries */
export type CheatingIncidentQueriesQueryCheatingIncidentsByUserIdAndCourseIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  courseIds: Array<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  rulings?: InputMaybe<Array<CheatingIncident_CheatingIncidentRuling>>;
  userId: Scalars['Int'];
};

/** enums representing supported reasons in an appeal request */
export const CheatingIncident_AppealRequestReason = {
  /** one time exception for a given course */
  AppealException: 'APPEAL_EXCEPTION',
  /** learner does not agree with the ruling */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE'
} as const;

export type CheatingIncident_AppealRequestReason = typeof CheatingIncident_AppealRequestReason[keyof typeof CheatingIncident_AppealRequestReason];
/** contact log from an automated flag within our system */
export type CheatingIncident_AutomatedFlagContactLog = {
  __typename?: 'CheatingIncident_AutomatedFlagContactLog';
  /** comment from the flagger */
  similarityCheckId: Scalars['String'];
  /** similarity check score, 0-100 in percent */
  similarityScore: Scalars['Int'];
  /** timestamp on when the flag was created */
  timestamp: Scalars['DateTime'];
};

/** cheating incident model which provides an overview for a given cheating incident */
export type CheatingIncident_CheatingIncident = Node & {
  __typename?: 'CheatingIncident_CheatingIncident';
  /**
   * a list of cheating case id associated with same submission key.
   * a cheating incident may have one or more cheating case ids, depending on whether this incident is consolidated or not.
   */
  cheatingCaseIds: Array<Scalars['ID']>;
  /** course context for the cheating incident,  when it is null it means the course could not be found */
  courseContext?: Maybe<CheatingIncident_CourseContext>;
  /** course item context for the cheating incident, when it is null it means the course branch was could not be found(likely deleted) or the item in the course branch could not be found(likely deleted) */
  courseItemContext?: Maybe<CheatingIncident_CourseItemContext>;
  /** root cheating incident id with action plan result associated */
  id: Scalars['ID'];
  /** cheating incident ruling */
  ruling: CheatingIncident_CheatingIncidentRuling;
  /** user id the cheating incident is open against */
  userId: Scalars['Int'];
};

/** the connection object representing the cheating incident overview results */
export type CheatingIncident_CheatingIncidentConnection = {
  __typename?: 'CheatingIncident_CheatingIncidentConnection';
  /** cheating incident overview edges */
  edges?: Maybe<Array<Maybe<CheatingIncident_CheatingIncidentEdge>>>;
  /** page info */
  pageInfo: PageInfo;
};

/** cheating incident overview edge with cursor */
export type CheatingIncident_CheatingIncidentEdge = {
  __typename?: 'CheatingIncident_CheatingIncidentEdge';
  /** cursor used in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** the node in the edge */
  node?: Maybe<CheatingIncident_CheatingIncident>;
};

/** enum representing all possible cheating incident statuses */
export const CheatingIncident_CheatingIncidentRuling = {
  /** the learner has requested an appeal for the incident and was denied */
  AppealDenied: 'APPEAL_DENIED',
  /** the incident has been granted an appeal with the false positive reason */
  AppealFalsePositive: 'APPEAL_FALSE_POSITIVE',
  /** the incident has been granted an appeal with an "other" reason */
  AppealOther: 'APPEAL_OTHER',
  /** the learner has requested an appeal for the incident */
  AppealRequested: 'APPEAL_REQUESTED',
  /** cheating confirmed */
  CheatingConfirmed: 'CHEATING_CONFIRMED',
  /** cheating not confirmed */
  CheatingNotConfirmed: 'CHEATING_NOT_CONFIRMED',
  /** the incident is still being resolved */
  InProgress: 'IN_PROGRESS',
  /** resolved no ruling */
  ResolvedNoRuling: 'RESOLVED_NO_RULING'
} as const;

export type CheatingIncident_CheatingIncidentRuling = typeof CheatingIncident_CheatingIncidentRuling[keyof typeof CheatingIncident_CheatingIncidentRuling];
/** contact logs between our platform and learners */
export type CheatingIncident_ContactLog = CheatingIncident_AutomatedFlagContactLog | CheatingIncident_LearnerServiceContactLog | CheatingIncident_PeerFlagContactLog;

/** the course context for a given cheating incident */
export type CheatingIncident_CourseContext = {
  __typename?: 'CheatingIncident_CourseContext';
  /** course branch id */
  courseBranchId: Scalars['ID'];
  /** course id */
  courseId: Scalars['ID'];
  /** course name */
  courseName: Scalars['String'];
  /** course slug */
  courseSlug: Scalars['String'];
};

/** the course item context for a given cheating incident */
export type CheatingIncident_CourseItemContext = {
  __typename?: 'CheatingIncident_CourseItemContext';
  /** item id */
  itemId: Scalars['ID'];
  /** item name */
  itemName: Scalars['String'];
  /** item type */
  itemType: CheatingIncident_ItemType;
  /** the Id within the item type(assignment id for peer review for example) */
  itemTypeId: Scalars['ID'];
};

/** cheating incident detail */
export type CheatingIncident_DetailsResponse = {
  __typename?: 'CheatingIncident_DetailsResponse';
  /** An array of contact logs in chronological order reflecting the events related to a given cheating incident */
  contactLogs: Array<CheatingIncident_ContactLog>;
  /** course context for the cheating incident,  when it is null it means the course could not be found */
  courseContext?: Maybe<CheatingIncident_CourseContext>;
  /** course item context for the cheating incident, when it is null it means the course branch was could not be found(likely deleted) or the item in the course branch could not be found(likely deleted) */
  courseItemContext?: Maybe<CheatingIncident_CourseItemContext>;
  /** An array of events in chronological order reflecting the events related to a given cheating incident */
  eventHistory: Array<CheatingIncident_Event>;
  /** cheating incident ID */
  id: Scalars['ID'];
  /** boolean field describing if this given cheating incident is eligible for one time exception appeal within a course the incident was created in */
  isEligibleForOneTimeExceptionAppeal: Scalars['Boolean'];
  /** cheating incident ruling */
  ruling: CheatingIncident_CheatingIncidentRuling;
};

/** significant events related to the lifecycle of a given cheating incident */
export type CheatingIncident_Event = {
  __typename?: 'CheatingIncident_Event';
  /** timestamp for the event */
  timestamp: Scalars['DateTime'];
  /** event types related to possible significant events */
  type: CheatingIncident_EventType;
};

/** enums representing possible significant events related to the lifecycle of a given cheating incident */
export const CheatingIncident_EventType = {
  /** the learner submitted the assignment that was linked to the cheating incident */
  AssignmentSubmission: 'ASSIGNMENT_SUBMISSION',
  /** the requested appeal from the learner has been ruled by someone with incident ruling authority */
  CaseAppealRuled: 'CASE_APPEAL_RULED',
  /** the learner has requested an appeal for a given incident */
  CaseAppealSubmitted: 'CASE_APPEAL_SUBMITTED',
  /** the incident has been ruled by someone with incident ruling authority, for example, outsourcing agents */
  CaseRuled: 'CASE_RULED',
  /** the submission was flagged by our system either through peer flags or automated flags */
  SubmissionFlag: 'SUBMISSION_FLAG'
} as const;

export type CheatingIncident_EventType = typeof CheatingIncident_EventType[keyof typeof CheatingIncident_EventType];
/** all currently supported item types within the cheating incidents system */
export const CheatingIncident_ItemType = {
  /** peer review */
  Peer: 'PEER',
  /** programming assignments */
  Programming: 'PROGRAMMING',
  /** quizzes */
  Quiz: 'QUIZ',
  /** staff graded assignments */
  StaffGraded: 'STAFF_GRADED'
} as const;

export type CheatingIncident_ItemType = typeof CheatingIncident_ItemType[keyof typeof CheatingIncident_ItemType];
/** contact log between learner and learner services in a given cheating incident */
export type CheatingIncident_LearnerServiceContactLog = {
  __typename?: 'CheatingIncident_LearnerServiceContactLog';
  /** html representation of the contact email */
  content: Scalars['String'];
  /** enums representing possible contact log sources in LearnerServiceContactLog(learner or learner services) */
  from: CheatingIncident_LearnerServiceContactLogSource;
  /** timestamp on when the contact email was sent */
  timestamp: Scalars['DateTime'];
};

/** enums representing possible contact log sources in LearnerServiceContactLog */
export const CheatingIncident_LearnerServiceContactLogSource = {
  /** from the learner */
  Learner: 'LEARNER',
  /** from learner services */
  LearnerServices: 'LEARNER_SERVICES'
} as const;

export type CheatingIncident_LearnerServiceContactLogSource = typeof CheatingIncident_LearnerServiceContactLogSource[keyof typeof CheatingIncident_LearnerServiceContactLogSource];
/** contact log from a peer flagging the linked submission in this cheating incident */
export type CheatingIncident_PeerFlagContactLog = {
  __typename?: 'CheatingIncident_PeerFlagContactLog';
  /** comment from the flagger */
  flaggerComment: Scalars['String'];
  /** timestamp on when the flag was created */
  timestamp: Scalars['DateTime'];
};

/** input type for RequestAppealForCheatingIncident */
export type CheatingIncident_RequestAppealForCheatingIncidentInput = {
  /** when the appeal reason is FALSE_POSITIVE, it is a required field to allow learners to provide explanation on why they disagree with the ruling */
  explanation?: InputMaybe<Scalars['String']>;
  /** incident id */
  incidentId: Scalars['ID'];
  /** reason for appeal */
  reason: CheatingIncident_AppealRequestReason;
};

/** response type for RequestAppealForCheatingIncident mutation */
export type CheatingIncident_RequestAppealForCheatingIncidentResult = {
  __typename?: 'CheatingIncident_RequestAppealForCheatingIncidentResult';
  /** incident id */
  incidentId: Scalars['ID'];
};

/** Content id could refer to a verified certificate or to a specialization */
export type CheckoutGateway_ContentId = {
  /** A course (verified certificate) id */
  courseId?: InputMaybe<Scalars['ID']>;
  /** A specialization id */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** Side effects metadata for fulfillment of Coursera Lite ownable product */
export type CheckoutGateway_CourseraLitePostFulfillmentSideEffects = {
  /**
   * The course/s12n to grant membership for once checkout is complete
   * (e.g. the CDP/SDP they were exposed to Coursera Lite from)
   */
  contentIdToGrantMembershipTo?: InputMaybe<CheckoutGateway_ContentId>;
  /**
   * The course/s12n to grant membership to once checkout is complete
   * (e.g. the CDP they were exposed to s12n from)
   *
   * This is only relevant if the learner enrolled in Coursera Lite through a CDP in an s12n that
   * isn't the first course in the s12n. In this case, the learner should get the membership for that
   * course instead of going through normal s12n enrollment flow (which will grant the membership
   * of the first course in the s12n)
   */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
};

/** Side effects metadata for fulfillment of Coursera Plus ownable product */
export type CheckoutGateway_CourseraPlusPostFulfillmentSideEffects = {
  /**
   * The course/s12n to grant ownership for once checkout is complete
   * (e.g. the CDP/SDP they were exposed to Coursera Plus from)
   */
  contentIdToGrantOwnershipTo?: InputMaybe<CheckoutGateway_ContentId>;
  /**
   * The course/s12n to grant membership to once checkout is complete
   * (e.g. the CDP they were exposed to s12n from)
   *
   * This is only relevant if the learner enrolled in Coursera Plus through a CDP in an s12n that
   * isn't the first course in the s12n. In this case, the learner should get the membership for that
   * course instead of going through normal s12n enrollment flow (which will grant the membership
   * of the first course in the s12n)
   */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
};

/** Input for cart creation */
export type CheckoutGateway_CreateCart = {
  /** An identifier for an ownable product + fulfillment method pair */
  ownableProductFulfillmentConfigurationId: Scalars['ID'];
  /** Context to identify the fulfillment config, and side-effects of cart creation */
  productFulfillmentContext: CheckoutGateway_ProductFulfillmentContext;
  /** User id for the user that the cart should be created for */
  userId: Scalars['ID'];
};

/** Input options for cart create */
export type CheckoutGateway_CreateCartInput = {
  /** Input for production cart creation */
  prod?: InputMaybe<CheckoutGateway_CreateCart>;
  /** Input for test cart creation */
  test?: InputMaybe<CheckoutGateway_CreateCartTest>;
};

/** Mutation failure result containing an array of error details */
export type CheckoutGateway_CreateCartMutationFailure = {
  __typename?: 'CheckoutGateway_CreateCartMutationFailure';
  /** Error details */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Possible responses on cart creation */
export type CheckoutGateway_CreateCartResult = CheckoutGateway_CreateCartMutationFailure | CheckoutGateway_CreateCartSuccess;

/** Response after successful creation of the cart */
export type CheckoutGateway_CreateCartSuccess = {
  __typename?: 'CheckoutGateway_CreateCartSuccess';
  /** A cart that has been validated and prepared for checkout by our system */
  validatedCart: Payments_ValidatedCart;
};

/** Input for cart creation */
export type CheckoutGateway_CreateCartTest = {
  /** Country code */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Currency code */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** An identifier for an ownable product + fulfillment method pair */
  ownableProductFulfillmentConfigurationId: Scalars['ID'];
  /** Context to identify the fulfillment config, and side-effects of cart creation */
  productFulfillmentContext: CheckoutGateway_ProductFulfillmentContext;
  /** User id for the user that the cart should be created for */
  userId: Scalars['ID'];
};

/**
 * Side effects metadata for fulfillment of Credential Track ownable products (Mastertrack w/ 1 or 4
 * installments, Mastertrack one-time payment hack).
 */
export type CheckoutGateway_CredentialTrackPostFulfillmentSideEffects = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Generic error for checkout gateway queries */
export type CheckoutGateway_GenericError = Error & {
  __typename?: 'CheckoutGateway_GenericError';
  /** Readable message providing the error details */
  message: Scalars['String'];
};

/**
 * Side effects context for different products post fulfillment (scheme-agnostic)
 * Examples of side effects includes sending emails, product enrollment etc.
 * The long term vision of this model is to function as a well-defined side-effect container
 * for each product type that is obvious for engineers to extend/add to. Currently, the side-effects
 * container for VerifiedCertificate product type is empty because during phase 4 of
 * next gen product config, we learned that there wasn't a B2C use case for VerifiedCertificate
 * post fulfillment side effects, so we opted to remove the fields from this side effects container.
 * The credential track side-effects container is also empty because the FE does not use
 * CredentialTrackSubscriptionCartItemMetadata or auxiliaryCartInfo to encapsulate any side effects
 * for the "Mastertrack w/ 1 or 4 installments", or "Mastertrack one-time payment hack" case.
 */
export type CheckoutGateway_PostFulfillmentContext = {
  /** Metadata required for owning a Coursera Lite product */
  courseraLite?: InputMaybe<CheckoutGateway_CourseraLitePostFulfillmentSideEffects>;
  /** Metadata required for owning a Coursera Plus product */
  courseraPlus?: InputMaybe<CheckoutGateway_CourseraPlusPostFulfillmentSideEffects>;
  /** Metadata required for owning a credential track product */
  credentialTrack?: InputMaybe<CheckoutGateway_CredentialTrackPostFulfillmentSideEffects>;
  /** Metadata required for owning a specialization product */
  specialization?: InputMaybe<CheckoutGateway_SpecializationPostFulfillmentSideEffects>;
  /** Metadata required for owning a verified certificate product */
  verifiedCertificate?: InputMaybe<CheckoutGateway_VerifiedCertificatePostFulfillmentSideEffects>;
};

/**
 * Metadata context to capture any fulfillment-specific concerns
 * i.e. what you get access to and any side-effects around the context that you get access to it
 *
 * Distinct from scheme-specific concerns e.g. free trial length, prepaid vs subscription etc.
 *
 * This container is sparse to start but intended to be flexible for the future,
 * within the scope of product fulfillment
 */
export type CheckoutGateway_ProductFulfillmentContext = {
  /** Side effects context for different products post fulfillment (scheme-agnostic) */
  postFulfillmentContext?: InputMaybe<CheckoutGateway_PostFulfillmentContext>;
};

/** Side effects metadata for fulfillment of s12n ownable product */
export type CheckoutGateway_SpecializationPostFulfillmentSideEffects = {
  /** The course to enroll the learner in (e.g. the CDP they were exposed to s12n from) */
  courseIdToGrantMembershipTo?: InputMaybe<Scalars['ID']>;
  /** Flag to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/**
 * Side effects metadata for fulfillment of verified certificate ownable products
 * (courses, guided projects etc)
 */
export type CheckoutGateway_VerifiedCertificatePostFulfillmentSideEffects = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Queries related to CheckoutIntent. */
export type CheckoutIntentQueries = {
  __typename?: 'CheckoutIntentQueries';
  /** Fetches the latest CheckoutIntent details from a given CheckoutIntentId. */
  checkoutIntent?: Maybe<PaymentsCheckout_CheckoutIntent>;
  /** Checks if the CheckoutIntent is ready for payment. */
  validateCheckoutIntent: PaymentsCheckout_ValidateCheckoutIntentResult;
};


/** Queries related to CheckoutIntent. */
export type CheckoutIntentQueriesCheckoutIntentArgs = {
  checkoutIntentId: Scalars['ID'];
};


/** Queries related to CheckoutIntent. */
export type CheckoutIntentQueriesValidateCheckoutIntentArgs = {
  checkoutIntentId: Scalars['ID'];
};

/** Queries for the City entity */
export type CityQueries = {
  __typename?: 'CityQueries';
  /** Gets a list of cities that match the search term */
  searchCities: RecruitingCities_CityPaginatedResult;
};


/** Queries for the City entity */
export type CityQueriesSearchCitiesArgs = {
  countriesExclusive?: InputMaybe<Array<Scalars['String']>>;
  countriesInclusive?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  search: Scalars['String'];
};

/** clip GraphQL Schema queries */
export type ClipQueries = {
  __typename?: 'ClipQueries';
  /** Query for clip courseItems by courseItem ids */
  queryClipItemsByIds: Array<Clip_CourseItem>;
};


/** clip GraphQL Schema queries */
export type ClipQueriesQueryClipItemsByIdsArgs = {
  ids: Array<Clip_CourseItemId>;
};

/** A reference to the clips entity */
export type Clip_CourseItem = {
  __typename?: 'Clip_CourseItem';
  /** atomId of the clip */
  atomId: Scalars['ID'];
  /** course entity associated with the clip */
  course: Course_Course;
  /** duration of the clip */
  duration: Scalars['Duration'];
  /** Id with the format: CourseId~ItemId. */
  id: Scalars['ID'];
  /** course visibility */
  isPrivate: Scalars['Boolean'];
  /** name of the lesson (optional because we are introducing standalone clip) */
  lessonName?: Maybe<Scalars['String']>;
  /** name of the clip */
  name: Scalars['String'];
  /** partners information of the clip */
  partners?: Maybe<Array<Partner_Partner>>;
  /** thumbnail url of the clip */
  thumbnail?: Maybe<Scalars['URL']>;
  /** translated name of the clip */
  translatedName?: Maybe<Scalars['String']>;
  /** videoId of the clip */
  videoId?: Maybe<Scalars['ID']>;
  /** number of views of the clip */
  views?: Maybe<Scalars['Int']>;
};

/** CourseItem id Type */
export type Clip_CourseItemId = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** Item Id */
  itemId: Scalars['ID'];
};

/** cml GraphQL Schema */
export type CmlContent = {
  __typename?: 'CmlContent';
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['String'];
  /** directly renderable html with metadata payload */
  htmlWithMetadata: CmlHtmlWithMetadata;
};

/** TODO: Complete this description */
export type CmlContentInput = {
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['String'];
};

/** TODO: Complete this description */
export type CmlHtmlMetadata = {
  __typename?: 'CmlHtmlMetadata';
  /** True if the CML Content this was rendered from contains any <asset></asset> tags. */
  hasAssetBlock: Scalars['Boolean'];
  /**
   * True if there is a <code></code> Block present anywhere in the CML Content this was rendered
   * from. False otherwise.
   */
  hasCodeBlock: Scalars['Boolean'];
  /** True if any tag has the "hasMath" attribute in the CML this was rendered from. False otherwise. */
  hasMath: Scalars['Boolean'];
  /** True if the CML Content this was rendered from only contains <text></text> and no other tags. */
  isPlainText: Scalars['Boolean'];
};

/** TODO: Complete this description */
export type CmlHtmlWithMetadata = {
  __typename?: 'CmlHtmlWithMetadata';
  /** directly renderable html string */
  html: Scalars['String'];
  /** metadata about included html */
  metadata: CmlHtmlMetadata;
};

/** Additional data for assets in the CML Content this was rendered from. */
export type Cml_AssetData = {
  __typename?: 'Cml_AssetData';
  /** The id of the asset. */
  assetId: Scalars['ID'];
  /** The subtitle tracks for the asset. */
  subtitles?: Maybe<Array<Cml_SubtitleTrack>>;
};

/** Federated Cml type */
export type Cml_Cml = {
  __typename?: 'Cml_Cml';
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['ID'];
  /** directly renderable html with metadata payload */
  htmlWithMetadata: Cml_RenderableHtmlWithMetadata;
};

/** Federated Cml input type */
export type Cml_CmlInput = {
  /** representation of rich-text content in cml format */
  cmlValue: Scalars['String'];
  /** Id representing the expected structure/type of CML */
  dtdId: Scalars['ID'];
};

/** Metadata about renderable html */
export type Cml_RenderableHtmlMetadata = {
  __typename?: 'Cml_RenderableHtmlMetadata';
  /** Additional data for assets in the CML Content this was rendered from. */
  assetData?: Maybe<Array<Cml_AssetData>>;
  /** True if the CML Content this was rendered from contains any <asset></asset> tags. */
  hasAssetBlock: Scalars['Boolean'];
  /**
   * True if there is a <code></code> Block present anywhere in the CML Content this was rendered
   * from. False otherwise.
   */
  hasCodeBlock: Scalars['Boolean'];
  /** True if any tag has the "hasMath" attribute in the CML this was rendered from. False otherwise. */
  hasMath: Scalars['Boolean'];
  /** True if the CML Content this was rendered from only contains <text></text> and no other tags. */
  isPlainText: Scalars['Boolean'];
};

/** Renderable html with additional metadata */
export type Cml_RenderableHtmlWithMetadata = {
  __typename?: 'Cml_RenderableHtmlWithMetadata';
  /** directly renderable html string */
  html: Scalars['String'];
  /** metadata about included html */
  metadata: Cml_RenderableHtmlMetadata;
};

/** Subtitle track for an asset. */
export type Cml_SubtitleTrack = {
  __typename?: 'Cml_SubtitleTrack';
  /** The language code of the subtitle track. */
  languageCode: Scalars['String'];
  /** The url of the subtitle track. */
  url: Scalars['URL'];
};

/** All Coach Async Task queries */
export type CoachAsyncTaskQueries = {
  __typename?: 'CoachAsyncTaskQueries';
  /** This query returns the status of a Coach Async Task */
  queryAsyncTaskStatus: AiCoach_AsyncTaskStatus;
};


/** All Coach Async Task queries */
export type CoachAsyncTaskQueriesQueryAsyncTaskStatusArgs = {
  taskId: Scalars['ID'];
};

/** All Coach Chat Session queries */
export type CoachChatSessionQueries = {
  __typename?: 'CoachChatSessionQueries';
  /** This query returns all chat sessions queried on a specific user ID. */
  queryChatSessionsByUserId: AiCoach_ChatSessionPaginatedResult;
};


/** All Coach Chat Session queries */
export type CoachChatSessionQueriesQueryChatSessionsByUserIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};

/** Rate-limited submission: X attempts per Y time units */
export type CoachItemAuthoring_AttemptRateSubmission = {
  __typename?: 'CoachItemAuthoring_AttemptRateSubmission';
  /** Number of attempts allowed per time interval */
  maxAttemptsPerInterval: Scalars['Int'];
  /** Time interval value (unit specified by timeIntervalUnit) */
  timeInterval: Scalars['Int'];
  /** Unit for the time interval (hours or days) */
  timeIntervalUnit: CoachItemAuthoring_TimeIntervalUnit;
  /** Time limit for each attempt in minutes */
  timeLimitPerAttemptInMinutes: Scalars['Int'];
};

/** Input for attempt rate submission configuration */
export type CoachItemAuthoring_AttemptRateSubmissionInput = {
  /** Number of attempts allowed per time interval */
  maxAttemptsPerInterval: Scalars['Int'];
  /** Time interval value (unit specified by timeIntervalUnit) */
  timeInterval: Scalars['Int'];
  /** Unit for the time interval (hours or days) */
  timeIntervalUnit: CoachItemAuthoring_TimeIntervalUnit;
  /** Time limit for each attempt in minutes */
  timeLimitPerAttemptInMinutes: Scalars['Int'];
};

/** Coach activity type containing activity-specific details */
export type CoachItemAuthoring_CoachActivity = {
  __typename?: 'CoachItemAuthoring_CoachActivity';
  /** Allowed communication modes for the coach item. Empty or null means all modes are supported. */
  allowedCommunicationModes?: Maybe<Array<CoachItemAuthoring_CommunicationMode>>;
  /** Asset files to use as embeddings */
  assetIds: Array<Scalars['ID']>;
  /**
   * CoachActivitySchema that this particular coach activity is tied with.
   * This field was renamed from versionedCoachItemType eg) rolePlay@1, socraticDialogue@8
   */
  coachActivitySchemaId: Scalars['ID'];
  /** Type specific fields for different coach activities */
  coachActivityTypeSpecificFields: CoachItemAuthoring_CoachActivityTypeSpecificFields;
  /** Cover page instruction shown in the item cover page */
  coverPageInstruction: Scalars['String'];
  /**
   * Key-value pairs of prompt parameters used to customize the activity.
   *
   * Socratic Dialogue: authoringRubricAdvanced, authoringRubricIntermediate,
   * authoringRubricBeginner, purposeOfActivity.
   *
   * Role Play: authoringRubricAdvanced, authoringRubricIntermediate, authoringRubricBeginner,
   * scenarioDefinition.
   */
  promptParameters: Array<CoachItemAuthoring_PromptParameter>;
};

/** Input type for coach activity draft containing activity-specific details */
export type CoachItemAuthoring_CoachActivityDraftInput = {
  /** Allowed communication modes for the coach item. Empty or null means all modes are supported. */
  allowedCommunicationModes?: InputMaybe<Array<CoachItemAuthoring_CommunicationMode>>;
  /** Asset files to use as embeddings */
  assetIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * CoachActivityTemplate that this particular coach activity is tied with.
   * This field was renamed from versionedCoachItemType eg) rolePlay@1, socraticDialogue@8
   */
  coachActivitySchemaId?: InputMaybe<Scalars['ID']>;
  /** Type specific fields for different coach activities */
  coachActivityTypeSpecificFields?: InputMaybe<CoachItemAuthoring_CoachActivityTypeSpecificFieldsInput>;
  /** Cover page instruction shown in the item cover page */
  coverPageInstruction?: InputMaybe<Scalars['String']>;
  /**
   * Prompt parameters that eventually gets injected into different prompts.
   *
   * Socratic Dialogue: authoringRubricAdvanced, authoringRubricIntermediate,
   * authoringRubricBeginner, purposeOfActivity.
   *
   * Role Play: authoringRubricAdvanced, authoringRubricIntermediate, authoringRubricBeginner,
   * scenarioDefinition.
   */
  promptParameters?: InputMaybe<Array<CoachItemAuthoring_PromptParameterInput>>;
};

/** Union type for coach activity type-specific fields */
export type CoachItemAuthoring_CoachActivityTypeSpecificFields = CoachItemAuthoring_RolePlayFields | CoachItemAuthoring_SocraticDialogueFields;

/** Input type for different coach activity type specific fields */
export type CoachItemAuthoring_CoachActivityTypeSpecificFieldsInput = {
  /** Role play specific fields */
  rolePlay?: InputMaybe<CoachItemAuthoring_RolePlayFieldsInput>;
  /** Socratic dialogue specific fields */
  socraticDialogue?: InputMaybe<CoachItemAuthoring_SocraticDialogueFieldsInput>;
};

/** Communication mode for coach items */
export const CoachItemAuthoring_CommunicationMode = {
  /** Text-only communication */
  Text: 'TEXT',
  /** Voice-only communication */
  Voice: 'VOICE'
} as const;

export type CoachItemAuthoring_CommunicationMode = typeof CoachItemAuthoring_CommunicationMode[keyof typeof CoachItemAuthoring_CommunicationMode];
/** CoachItem draft content, represented as an input type */
export type CoachItemAuthoring_DraftContentInput = {
  /** Updated coach item content */
  coachActivity?: InputMaybe<CoachItemAuthoring_CoachActivityDraftInput>;
  /** Whether the coach item is graded */
  isGraded?: InputMaybe<Scalars['Boolean']>;
  /** Updated item name */
  name: Scalars['String'];
  /** Passing fraction threshold (0.0 to 1.0). Only applicable when isGraded is true. */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Submission limit configuration. Only applicable when isGraded is true. */
  submissionLimitConfig?: InputMaybe<CoachItemAuthoring_SubmissionLimitConfigInput>;
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
  /** versioned Id of the underlying coach activity */
  versionedCoachActivityId?: InputMaybe<Scalars['ID']>;
};

/** Key-value pair representing a prompt parameter */
export type CoachItemAuthoring_PromptParameter = {
  __typename?: 'CoachItemAuthoring_PromptParameter';
  /** The parameter key */
  key: Scalars['String'];
  /** The parameter value */
  value: Scalars['String'];
};

/** Input type for prompt parameter key-value pair */
export type CoachItemAuthoring_PromptParameterInput = {
  /** Key of the prompt parameter */
  key: Scalars['String'];
  /** Value of the prompt parameter */
  value: Scalars['String'];
};

/** Type-specific fields for Role Play coach activities */
export type CoachItemAuthoring_RolePlayFields = {
  __typename?: 'CoachItemAuthoring_RolePlayFields';
  /** Description of how the AI persona should behave during the role play */
  aiPersonaBehavior: Scalars['String'];
  /** First message for the AI persona to say */
  aiPersonaFirstMessage?: Maybe<Scalars['String']>;
  /** The role that the AI persona should adopt during the role play */
  aiPersonaRole: Scalars['String'];
  /** Author-defined scenario overview shown to the learner (not sent to the AI) */
  scenarioOverview?: Maybe<CoachItemAuthoring_ScenarioOverview>;
  /** List of tasks or objectives for the role play activity */
  tasks: Array<Scalars['String']>;
};

/** Input type for role play specific fields */
export type CoachItemAuthoring_RolePlayFieldsInput = {
  /** AI persona behavior */
  aiPersonaBehavior: Scalars['String'];
  /** AI persona first message */
  aiPersonaFirstMessage?: InputMaybe<Scalars['String']>;
  /** AI persona role */
  aiPersonaRole: Scalars['String'];
  /** Author-defined scenario overview shown to the learner (not sent to the AI) */
  scenarioOverview?: InputMaybe<CoachItemAuthoring_ScenarioOverviewInput>;
  /** List of tasks */
  tasks: Array<Scalars['String']>;
};

/** Author-defined overview of the role play scenario, displayed to the learner */
export type CoachItemAuthoring_ScenarioOverview = {
  __typename?: 'CoachItemAuthoring_ScenarioOverview';
  /** Description of the role play scenario */
  description?: Maybe<Scalars['String']>;
  /** Goal the learner should aim to achieve in the role play */
  goal?: Maybe<Scalars['String']>;
};

/** Input type for the author-defined role play scenario overview */
export type CoachItemAuthoring_ScenarioOverviewInput = {
  /** Description of the role play scenario */
  description?: InputMaybe<Scalars['String']>;
  /** Goal the learner should aim to achieve in the role play */
  goal?: InputMaybe<Scalars['String']>;
};

/** Type-specific fields for Socratic Dialogue coach activities */
export type CoachItemAuthoring_SocraticDialogueFields = {
  __typename?: 'CoachItemAuthoring_SocraticDialogueFields';
  /** Placeholder field for Socratic Dialogue (currently no specific fields defined) */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

/** Input type for socratic dialogue specific fields */
export type CoachItemAuthoring_SocraticDialogueFieldsInput = {
  /** Empty type for socratic dialogue fields */
  _placeholder?: Scalars['Boolean'];
};

/** Submission limit configuration for graded coach items */
export type CoachItemAuthoring_SubmissionLimitConfig = CoachItemAuthoring_AttemptRateSubmission | CoachItemAuthoring_UnlimitedSubmission;

/**
 * Submission limit configuration for graded coach items.
 * Exactly one field must be set.
 */
export type CoachItemAuthoring_SubmissionLimitConfigInput = {
  /** Rate-limited: X attempts per Y hours */
  attemptRate?: InputMaybe<CoachItemAuthoring_AttemptRateSubmissionInput>;
  /** Unlimited submissions allowed */
  unlimited?: InputMaybe<CoachItemAuthoring_UnlimitedSubmissionInput>;
};

/** Unit for the submission rate limit time interval */
export const CoachItemAuthoring_TimeIntervalUnit = {
  /** Time interval measured in days */
  Days: 'DAYS',
  /** Time interval measured in hours */
  Hours: 'HOURS'
} as const;

export type CoachItemAuthoring_TimeIntervalUnit = typeof CoachItemAuthoring_TimeIntervalUnit[keyof typeof CoachItemAuthoring_TimeIntervalUnit];
/** Unlimited submissions allowed */
export type CoachItemAuthoring_UnlimitedSubmission = {
  __typename?: 'CoachItemAuthoring_UnlimitedSubmission';
  /** Placeholder field */
  _placeholder?: Maybe<Scalars['Boolean']>;
};

/** Input for unlimited submission configuration */
export type CoachItemAuthoring_UnlimitedSubmissionInput = {
  /** Placeholder field */
  _placeholder?: Scalars['Boolean'];
};

/** Returned if CoachItemAuthoring_UpdateCoachItemDraft ran into a client-actionable error */
export type CoachItemAuthoring_UpdateCoachItemDraftFailure = {
  __typename?: 'CoachItemAuthoring_UpdateCoachItemDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Input for the CoachItemAuthoring_UpdateCoachItemDraft mutation */
export type CoachItemAuthoring_UpdateCoachItemDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: CoachItemAuthoring_DraftContentInput;
};

/** Result union for the CoachItemAuthoring_UpdateCoachItemDraft mutation */
export type CoachItemAuthoring_UpdateCoachItemDraftResult = CoachItemAuthoring_UpdateCoachItemDraftFailure | CoachItemAuthoring_UpdateCoachItemDraftSuccess;

/** Returned if CoachItemAuthoring_UpdateCoachItemDraft completed successfully */
export type CoachItemAuthoring_UpdateCoachItemDraftSuccess = {
  __typename?: 'CoachItemAuthoring_UpdateCoachItemDraftSuccess';
  /** The updated coach item */
  item: ItemPlatform_AuthoringItem;
};

/** Input for starting a grading attempt on a coach item. */
export type CoachItemGrading_StartGradingAttemptInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /**
   * The chat session ID for the role-play. Required so that the server can record
   * the session in the proctor attempt metadata and auto-submit it when the
   * deadline elapses.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
};

/** Result of starting a grading attempt. */
export type CoachItemGrading_StartGradingAttemptResult = {
  __typename?: 'CoachItemGrading_StartGradingAttemptResult';
  /** Whether the grading attempt was successfully started */
  accepted: Scalars['Boolean'];
  /** The proctor attempt ID, returned when accepted is true */
  attemptId?: Maybe<Scalars['ID']>;
  /**
   * The time at which the proctor attempt started. Used by the client to render
   * a deadline countdown. Returned when accepted is true.
   */
  attemptStartTime?: Maybe<Scalars['DateTime']>;
  /** Error message if the attempt could not be started */
  errorMessage?: Maybe<Scalars['String']>;
};

/** Input for submitting a coach item chat session for grading. */
export type CoachItemGrading_SubmitForGradingInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /** The chat session ID to submit for grading */
  chatSessionId: Scalars['ID'];
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
};

/** Result of submitting a coach item chat session for grading. */
export type CoachItemGrading_SubmitForGradingResult = {
  __typename?: 'CoachItemGrading_SubmitForGradingResult';
  /** Whether the grading submission was accepted */
  accepted: Scalars['Boolean'];
  /** Error message if the submission was not accepted */
  errorMessage?: Maybe<Scalars['String']>;
};

/** Input for updating coach item progress */
export type CoachItemProgress_UpdateCoachItemProgressInput = {
  /** The branch ID for the course content */
  branchId: Scalars['ID'];
  /** The course ID containing the coach item */
  courseId: Scalars['ID'];
  /** The specific item ID within the course */
  itemId: Scalars['ID'];
  /** The new progress state to set */
  progressState: CoachItem_ProgressState;
};

/** Result for updating coach item progress */
export type CoachItemProgress_UpdateCoachItemProgressResult = {
  __typename?: 'CoachItemProgress_UpdateCoachItemProgressResult';
  /** Placeholder for void function */
  _: Scalars['Boolean'];
};

/** Coach Item queries namespace */
export type CoachItemQueries = {
  __typename?: 'CoachItemQueries';
  /**
   * Retrieves coach item details for a specific user, course, and item combination.
   * Returns the coach activity data including instructions, parameters, and type-specific fields.
   */
  getCoachItemConfiguration: CoachItem_CoachItemConfiguration;
  /**
   * Fetches the role play task completion status for a given chat session.
   * Returns the same data as the CoachItem_RolePlayTaskStatus subscription.
   */
  queryRolePlayTaskStatus: CoachItem_RolePlayTaskStatusResponse;
};


/** Coach Item queries namespace */
export type CoachItemQueriesGetCoachItemConfigurationArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Coach Item queries namespace */
export type CoachItemQueriesQueryRolePlayTaskStatusArgs = {
  input: CoachItem_RolePlayTaskStatusInput;
};

/** The additional context of a Coach chat as an input. */
export type CoachItem_AdditionalContextInput = {
  /** Context key for the additional context with a prefix of "additionalContext.". For example, "additionalContext.roleData" */
  contextKey: Scalars['String'];
  /** The value of the additional context. */
  contextValue: Scalars['String'];
};

/**
 * Allowed coach action IDs for CoachItem_ResolveContent. Only actions listed here are
 * accepted; attempts to use any other value will be rejected at the schema level.
 */
export const CoachItem_CoachActionId = {
  /** Generate a JSON actor context for the role-play session */
  CoachItemGenerateJson: 'COACH_ITEM_GENERATE_JSON',
  /** Generate a scenario description for the role-play session */
  CoachItemGenerateScenarioV2: 'COACH_ITEM_GENERATE_SCENARIO_V2',
  /** Welcome message for dialogue */
  CoachItemWelcomeMessage: 'COACH_ITEM_WELCOME_MESSAGE',
  /** List all required dasks for the role-play session */
  TaskListing: 'TASK_LISTING'
} as const;

export type CoachItem_CoachActionId = typeof CoachItem_CoachActionId[keyof typeof CoachItem_CoachActionId];
/**
 * Represents a coach activity, a coach activity is an activity driven mainly through coach chat experience.
 * Today we have two types of coach activities powered via coach items. eg)socratic discussion and role play
 */
export type CoachItem_CoachActivity = {
  __typename?: 'CoachItem_CoachActivity';
  /** Allowed communication modes for the coach item. Empty or null means all modes are supported. */
  allowedCommunicationModes?: Maybe<Array<CoachItem_CommunicationMode>>;
  /** Asset files to use as embeddings */
  assetIds: Array<Scalars['ID']>;
  /** Unique identifier for the coach activity */
  coachActivityId: Scalars['ID'];
  /** CoachActivitySchema that this particular coach activity is tied with */
  coachActivitySchemaId?: Maybe<Scalars['ID']>;
  /** Type specific fields for different coach activities */
  coachActivityTypeSpecificFields: CoachItem_CoachActivityTypeSpecificFields;
  /** Cover page instruction shown in the item cover page */
  coverPageInstruction?: Maybe<Scalars['String']>;
  /** Key-value pairs of prompt parameters used to customize the activity */
  promptParameters: Array<CoachItem_PromptParameter>;
  /** Version number of the coach activity */
  version: Scalars['Int'];
};

/** Union type for coach activity type-specific fields */
export type CoachItem_CoachActivityTypeSpecificFields = CoachItem_RolePlayFields | CoachItem_SocraticDialogueFields;

/** Represents detailed information about a coach item configuration */
export type CoachItem_CoachItemConfiguration = {
  __typename?: 'CoachItem_CoachItemConfiguration';
  /** Unique identifier for the graded role play assessment associated with this coach activity */
  assessmentId?: Maybe<Scalars['ID']>;
  /** Version of the graded role play assessment associated with this coach activity */
  assessmentVersion?: Maybe<Scalars['Int']>;
  /** The coach activity content */
  coachActivity: CoachItem_CoachActivity;
  /** Passing fraction for the graded role play assessment associated with this coach activity */
  passingFraction?: Maybe<Scalars['Float']>;
};

/**
 * Allowed coach mode IDs for CoachItem_ResolveContent. Only modes listed here are
 * accepted; attempts to use any other value will be rejected at the schema level.
 */
export const CoachItem_CoachModeId = {
  /** Dialogue */
  CoachItemDialogue: 'COACH_ITEM_DIALOGUE',
  /** Role-play simulation mode */
  CoachItemRolePlay: 'COACH_ITEM_ROLE_PLAY'
} as const;

export type CoachItem_CoachModeId = typeof CoachItem_CoachModeId[keyof typeof CoachItem_CoachModeId];
/** Communication mode for coach items */
export const CoachItem_CommunicationMode = {
  /** Text-only communication */
  Text: 'TEXT',
  /** Voice-only communication */
  Voice: 'VOICE'
} as const;

export type CoachItem_CommunicationMode = typeof CoachItem_CommunicationMode[keyof typeof CoachItem_CommunicationMode];
/** The configuration of a Coach chat message as an input. */
export type CoachItem_ConfigurationInput = {
  /** Coach Action ID */
  coachActionId: Scalars['ID'];
  /** Coach Mode ID */
  coachModeId: Scalars['ID'];
  /** Include structured output in chat history */
  includeStructuredOutputInChatHistory?: Scalars['Boolean'];
};

/** Coursera context input for the AI coach to understand the context of the message. */
export type CoachItem_CourseraContextInput = {
  /** List of additional products the user need as supporting context */
  additionalProducts?: InputMaybe<Array<CoachItem_ProductInput>>;
  /** Provides the AuthoringCourseBranch ID context of the message if the context is available. */
  authoringCourseBranchId?: InputMaybe<Scalars['ID']>;
  /** Provides the CourseBranch ID context of the message if the context is available. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** Course ID the user is currently on */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Degree ID the user is currently on */
  degreeId?: InputMaybe<Scalars['ID']>;
  /** Item ID the user is currently on */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Module ID the user is currently on */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Specialization ID the user is currently on */
  specializationId?: InputMaybe<Scalars['ID']>;
};

/** The enum indicating the type of the product for the AI coach to understand the additional context of the message in coursera. */
export const CoachItem_CourseraProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type CoachItem_CourseraProductType = typeof CoachItem_CourseraProductType[keyof typeof CoachItem_CourseraProductType];
/** The response that is returned by the AI coach. */
export type CoachItem_MessageByAiCoach = {
  __typename?: 'CoachItem_MessageByAiCoach';
  /** Message response by the AI coach */
  message: Scalars['String'];
  /** Message ID */
  messageId: Scalars['ID'];
  /** The senderType should be the AI coach */
  senderType: CoachItem_SenderType;
  /** A JSON structured response from the LLM. Only available in actions configured with the responseSchema field. */
  structuredResponse?: Maybe<Scalars['JSON']>;
};

/** The message that is created by the user. */
export type CoachItem_MessageByUser = {
  __typename?: 'CoachItem_MessageByUser';
  /** Message by the user */
  message: Scalars['String'];
  /** Message ID */
  messageId: Scalars['ID'];
  /** The senderType should be the user */
  senderType: CoachItem_SenderType;
};

/** Product input for the AI coach to understand the additional context of the message in coursera. */
export type CoachItem_ProductInput = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: CoachItem_CourseraProductType;
};

/** Enum representing the progress state of a coach item */
export const CoachItem_ProgressState = {
  /** The coach item has been completed */
  Completed: 'COMPLETED',
  /** The coach item has not been started */
  NotStarted: 'NOT_STARTED',
  /** The coach item has been started but not completed */
  Started: 'STARTED',
  /** Unknown progress state (default) */
  Unknown: 'UNKNOWN'
} as const;

export type CoachItem_ProgressState = typeof CoachItem_ProgressState[keyof typeof CoachItem_ProgressState];
/** Key-value pair representing a prompt parameter */
export type CoachItem_PromptParameter = {
  __typename?: 'CoachItem_PromptParameter';
  /** The parameter key */
  key: Scalars['String'];
  /** The parameter value */
  value: Scalars['String'];
};

/**
 * Input for resolving coach item content. Mirrors the core fields of
 * AiCoach_RespondToUserMessageInput so that the frontend can swap mutation names with
 * minimal changes.
 */
export type CoachItem_ResolveContentInput = {
  /**
   * Additional context to append to the prompt when a cache miss triggers live LLM
   * generation.
   */
  additionalContext?: InputMaybe<Array<CoachItem_AdditionalContextInput>>;
  /**
   * The ID of the current chat session. If empty, the backend will create a new session
   * and return the generated ID in the result.
   */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /**
   * Configuration identifying the coach action (e.g. COACH_ITEM_GENERATE_SCENARIO or
   * COACH_ITEM_GENERATE_JSON) and mode. The coachActionId is used as the sort key in
   * the DynamoDB cache.
   */
  config: CoachItem_ConfigurationInput;
  /**
   * Coursera context used to derive the cache key (courseId, itemId, branchId) and to
   * help the AI coach understand the context of the message.
   */
  courseraContext?: InputMaybe<CoachItem_CourseraContextInput>;
  /** Message input by the user (or action trigger) to the AI coach */
  message: Scalars['String'];
};

/**
 * Result of resolving coach item content. Mirrors AiCoach_RespondToUserMessageResult
 * so that the frontend can treat cache hits and live generation responses identically.
 */
export type CoachItem_ResolveContentResult = {
  __typename?: 'CoachItem_ResolveContentResult';
  /** The ID of the chat session to which the messages were stored */
  chatSessionId: Scalars['ID'];
  /** Coach Action ID that was resolved */
  coachActionId: CoachItem_CoachActionId;
  /** Coach Mode ID that was used */
  coachModeId: CoachItem_CoachModeId;
  /** The coach response (from cache or freshly generated) stored in the chat history */
  messageByAiCoach: CoachItem_MessageByAiCoach;
  /** The user-side message stored in the chat history for this resolution request */
  messageByUser: CoachItem_MessageByUser;
};

/** Type-specific fields for Role Play coach activities */
export type CoachItem_RolePlayFields = {
  __typename?: 'CoachItem_RolePlayFields';
  /** Description of how the AI persona should behave during the role play */
  aiPersonaBehavior: Scalars['String'];
  /** First message for the AI persona to say */
  aiPersonaFirstMessage?: Maybe<Scalars['String']>;
  /** The role that the AI persona should adopt during the role play */
  aiPersonaRole: Scalars['String'];
  /** Author-defined scenario overview shown to the learner (not sent to the AI) */
  scenarioOverview?: Maybe<CoachItem_ScenarioOverview>;
  /** List of tasks or objectives for the role play activity */
  tasks: Array<Scalars['String']>;
};

/** Represents the completion status and reasoning for a single role play task. */
export type CoachItem_RolePlayTaskProgress = {
  __typename?: 'CoachItem_RolePlayTaskProgress';
  /** Whether the task has been completed by the learner. */
  completed: Scalars['Boolean'];
  /** The AI coach's reasoning for the task completion assessment. */
  reasoning: Scalars['String'];
  /** The unique identifier of the role play task. */
  taskId: Scalars['ID'];
  /** The title of the role play task. */
  title: Scalars['String'];
};

/** Input for subscribing to role play task status updates. */
export type CoachItem_RolePlayTaskStatusInput = {
  /** Additional context to append to the prompt if not available in existing context fetchers. */
  additionalContext?: InputMaybe<Array<CoachItem_AdditionalContextInput>>;
  /** The ID of the current chat session. If empty, the backend will generate a new session ID. */
  chatSessionId?: InputMaybe<Scalars['ID']>;
  /** The configuration input of the chat message including action and mode. */
  config: CoachItem_ConfigurationInput;
  /** Coursera info used to help the AI coach understand the context of the message. */
  courseraContext?: InputMaybe<CoachItem_CourseraContextInput>;
};

/** Response for the role play task status query and subscription containing the progress of each task. */
export type CoachItem_RolePlayTaskStatusResponse = {
  __typename?: 'CoachItem_RolePlayTaskStatusResponse';
  /** The progress status of each role play task. */
  taskProgress: Array<CoachItem_RolePlayTaskProgress>;
};

/** Author-defined overview of the role play scenario, displayed to the learner */
export type CoachItem_ScenarioOverview = {
  __typename?: 'CoachItem_ScenarioOverview';
  /** Description of the role play scenario */
  description?: Maybe<Scalars['String']>;
  /** Goal the learner should aim to achieve in the role play */
  goal?: Maybe<Scalars['String']>;
};

/** This helps depict if the message is by the user or the AI coach. */
export const CoachItem_SenderType = {
  /** Message is by the AI coach */
  System: 'SYSTEM',
  /** Message is by the user */
  User: 'USER'
} as const;

export type CoachItem_SenderType = typeof CoachItem_SenderType[keyof typeof CoachItem_SenderType];
/** Type-specific fields for Socratic Dialogue coach activities */
export type CoachItem_SocraticDialogueFields = {
  __typename?: 'CoachItem_SocraticDialogueFields';
  /** Placeholder field for Socratic Dialogue (currently no specific fields defined) */
  _?: Maybe<Scalars['Boolean']>;
};

/** All Coach Memory queries */
export type CoachMemoryQueries = {
  __typename?: 'CoachMemoryQueries';
  /**
   * This query returns a users memories.
   * For now we are not exposing the Memory Category to the user or any
   * filtering functionality.
   * Will be sorted by created_at in desc order
   */
  searchMemory: CoachMemory_SearchPaginatedResult;
};


/** All Coach Memory queries */
export type CoachMemoryQueriesSearchMemoryArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** CoachMemory_SearchResult */
export type CoachMemory_SearchPaginatedResult = {
  __typename?: 'CoachMemory_SearchPaginatedResult';
  /** Memories matching search criteria for user */
  elements: Array<AiCoach_CoachMemory>;
  /** Pagination */
  pagination: Pagination;
};

/** All Coach Speech queries */
export type CoachSpeechQueries = {
  __typename?: 'CoachSpeechQueries';
  /** POC query, convert speech to text */
  speechToText: AiCoach_SpeechToTextResult;
  /** POC query, convert text to speech */
  textToSpeech: AiCoach_TextToSpeechResult;
};


/** All Coach Speech queries */
export type CoachSpeechQueriesSpeechToTextArgs = {
  audioBase64: Scalars['String'];
};


/** All Coach Speech queries */
export type CoachSpeechQueriesTextToSpeechArgs = {
  text: Scalars['String'];
};

/** All Coach User Setting queries */
export type CoachUserSettingQueries = {
  __typename?: 'CoachUserSettingQueries';
  /** This query returns the Coach settings for the current learner */
  queryCoachUserSettingsForUser: AiCoach_CoachUserSettings;
};

/** Queries for Collection Attributes */
export type CollectionAttributesQueries = {
  __typename?: 'CollectionAttributesQueries';
  /** Retrieves all Collection Attributes by the supplied visibility scopes and purpose */
  getAllDistinctCollectionAttributes: Array<CollectionAttributes_CollectionAttributesGroupResult>;
};


/** Queries for Collection Attributes */
export type CollectionAttributesQueriesGetAllDistinctCollectionAttributesArgs = {
  attributeInputs?: InputMaybe<Array<Collection_CollectionAttributeInput>>;
  collectionType?: InputMaybe<Collection_CollectionType>;
  groupAttributesBy: Array<CollectionAttributes_GroupPaginationInput>;
  purpose?: Scalars['String'];
  visibilityScopes: Array<Collection_VisibilityScope>;
};

/** Entities that represent all the known collection attribute types. */
export type CollectionAttributes_AttributeEntity = Attribute_AcademicDiscipline | Attribute_ContractTagName | Attribute_EducationalGoal | Attribute_LearningObjective | Attribute_OptimizationStatus | Attribute_OrganizationGoal | Attribute_OrganizationId | Attribute_ProgramId | Attribute_Purpose | Domain_Domain | Skill_Skill;

/** Allowable options for collection Attribute Type */
export const CollectionAttributes_CollectionAttributeType = {
  /** Attribute Type that represents an academic discipline */
  AcademicDiscipline: 'ACADEMIC_DISCIPLINE',
  /** Attribute Type that represents the contract tag name (currently only support academy contract tag name) */
  ContractTagName: 'CONTRACT_TAG_NAME',
  /** Attribute Type that represents a domain */
  Domain: 'DOMAIN',
  /** Attribute Type that represents an educational goal */
  EducationalGoal: 'EDUCATIONAL_GOAL',
  /** Attribute Type that represents a learning objective */
  LearningObjective: 'LEARNING_OBJECTIVE',
  /** Attribute Type that represents the status of optimization */
  OptimizationStatus: 'OPTIMIZATION_STATUS',
  /** Attribute Type that represents a organization goal */
  OrganizationGoal: 'ORGANIZATION_GOAL',
  /** Attribute Type that represents the organisation ID (one per collection; owning org). */
  OrganizationId: 'ORGANIZATION_ID',
  /** Attribute Type that represents a program ID (multiple per collection; programs where the collection is added). */
  ProgramId: 'PROGRAM_ID',
  /** Attribute Type that represents the purpose of this collection */
  Purpose: 'PURPOSE',
  /** Attribute Type that represents a skill */
  Skill: 'SKILL'
} as const;

export type CollectionAttributes_CollectionAttributeType = typeof CollectionAttributes_CollectionAttributeType[keyof typeof CollectionAttributes_CollectionAttributeType];
/** Attributes of a Collection */
export type CollectionAttributes_CollectionAttributes = {
  __typename?: 'CollectionAttributes_CollectionAttributes';
  /** Collection attribute groups. */
  attributes: Array<CollectionAttributes_CollectionAttributesGroupResult>;
  /** The unique identifier for a collection. */
  collectionId: Scalars['ID'];
  /** Collection Type for a collection. */
  collectionType: Collection_CollectionType;
};


/** Attributes of a Collection */
export type CollectionAttributes_CollectionAttributesAttributesArgs = {
  groupAttributesBy: Array<CollectionAttributes_GroupPaginationInput>;
};

/** Pagination for collection attributes results. */
export type CollectionAttributes_CollectionAttributesGroupResult = {
  __typename?: 'CollectionAttributes_CollectionAttributesGroupResult';
  /** Attribute Type */
  attributeType: CollectionAttributes_CollectionAttributeType;
  /** Grouped attributes page. */
  attributes: CollectionAttributes_CollectionAttributesPagedResult;
};

/** Pagination for collection attributes results. */
export type CollectionAttributes_CollectionAttributesPagedResult = {
  __typename?: 'CollectionAttributes_CollectionAttributesPagedResult';
  /** A list of collection attribute entities. */
  elements: Array<CollectionAttributes_AttributeEntity>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Paginated input for collection attributes */
export type CollectionAttributes_GroupPaginationInput = {
  /** Collection attribute type */
  attributeType: CollectionAttributes_CollectionAttributeType;
  /** pagination cursor */
  cursor?: InputMaybe<Scalars['String']>;
  /** Max number of attributes to return */
  limit?: Scalars['Int'];
};

/** Collections queries */
export type CollectionQueries = {
  __typename?: 'CollectionQueries';
  /**
   * Fetch a collection
   * @deprecated Use Recommendations { queryCollection } instead.
   */
  queryCollection: Collection_Collection;
  /**
   * Fetch a curated collection
   * @deprecated Use Recommendations { queryCollection } instead.
   */
  queryCuratedCollection: Collection_CuratedCollection;
};


/** Collections queries */
export type CollectionQueriesQueryCollectionArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  fallbackCollectionIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
};


/** Collections queries */
export type CollectionQueriesQueryCuratedCollectionArgs = {
  id: Scalars['ID'];
};

/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueries = {
  __typename?: 'CollectionWithAttributesQueries';
  /**
   * Retrieves a Collection with its associated Attributes by ID and Type
   * @deprecated Use { getRecommendationCollectionWithAttributes } instead.
   */
  getCollectionWithAttributes?: Maybe<Collection_Collection>;
  /** Retrieves a Recommendation Collection with its associated Attributes by ID and Type */
  getRecommendationCollectionWithAttributes?: Maybe<Recommendation_Collection>;
  /**
   * Retrieves all Collection Attributes
   * @deprecated Use { queryRecommendationCollectionsByAttributes } instead.
   */
  queryCollectionsByAttributes: Collection_QueryCollectionWithAttributesPaginatedResult;
  /** Retrieves all Collection Attributes */
  queryRecommendationCollectionsByAttributes: Collection_QueryRecommendationCollectionWithAttributesPaginatedResult;
  /** Retrieves all Collection by IDs */
  queryRecommendationCollectionsByIds: Collection_QueryRecommendationCollectionWithAttributesPaginatedResult;
};


/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueriesGetCollectionWithAttributesArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  collectionId: Scalars['ID'];
  collectionType: Collection_CollectionType;
};


/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueriesGetRecommendationCollectionWithAttributesArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  collectionId: Scalars['ID'];
  collectionType: Collection_CollectionType;
};


/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueriesQueryCollectionsByAttributesArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  attributeInputs: Array<Collection_CollectionAttributeInput>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  visibilityScopes: Array<Collection_VisibilityScope>;
};


/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueriesQueryRecommendationCollectionsByAttributesArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  attributeInputs: Array<Collection_CollectionAttributeInput>;
  collectionType?: InputMaybe<Collection_CollectionType>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  visibilityScopes: Array<Collection_VisibilityScope>;
};


/** Defining the queries for Collection with attributes */
export type CollectionWithAttributesQueriesQueryRecommendationCollectionsByIdsArgs = {
  collectionIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Academic Discipline Attribute input type */
export type Collection_AcademicDisciplineInput = {
  /** Academic Discipline Attribute input value */
  value: Scalars['String'];
};

/** AddCollection mutation failure */
export type Collection_AddCollectionFailure = {
  __typename?: 'Collection_AddCollectionFailure';
  /** Errors */
  errors: Array<Collection_Error>;
};

/**
 * Input for AddCollection mutation. Currently only adds a reference of an existing collection into the collections table.
 * In the future, this API can be repurposed to add a new collection.
 */
export type Collection_AddCollectionInput = {
  /** Collection type */
  collectionType: Collection_CollectionType;
  /** ID of the collection */
  id: Scalars['ID'];
  /**
   * Visibility scope
   * @deprecated No longer used, use visibilityScopes instead
   */
  visibilityScope?: InputMaybe<Collection_VisibilityScope>;
  /** Visibility scopes */
  visibilityScopes?: InputMaybe<Array<Collection_VisibilityScope>>;
};

/** AddCollection mutation result */
export type Collection_AddCollectionResult = Collection_AddCollectionFailure | Collection_AddCollectionSuccess;

/** AddCollection mutation success result */
export type Collection_AddCollectionSuccess = {
  __typename?: 'Collection_AddCollectionSuccess';
  /** Dummy field since type cannot be empty */
  _?: Maybe<Scalars['String']>;
};

/** Federated Collection entity */
export type Collection_Collection = {
  __typename?: 'Collection_Collection';
  /** Reference Collection attributes */
  collectionAttributes: CollectionAttributes_CollectionAttributes;
  /** Optional field for curriculum track ID in the collection, only applicable to program curriculum collections. */
  collectionTrackingId?: Maybe<Scalars['ID']>;
  /** Non-sensitive and non-personal contextual metadata about how the recommendations were generated. */
  context?: Maybe<Scalars['JSON']>;
  /** The collection's description */
  description: Scalars['String'];
  /** The paginated response of entities in the collection */
  entities?: Maybe<Collection_CollectionEntitiesPaginatedResult>;
  /** The collection's recommender id, */
  id: Scalars['ID'];
  /**
   * The collection's unique identifier that hashes all the compound keys. Used for cache normalization.
   * NOTE: You MUST include this field in your query, otherwise Apollo will throw an error.
   */
  idHash: Scalars['ID'];
  /** The hash of the recommender configuration uniquely identifying a specific version of the configuration used to generate the recommendations. */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Optional field for collection subtitle cml content. */
  subtitle?: Maybe<Cml_Cml>;
};


/** Federated Collection entity */
export type Collection_CollectionEntitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Collection attribute input */
export type Collection_CollectionAttributeInput = {
  /** Academic discipline input */
  academicDiscipline?: InputMaybe<Collection_AcademicDisciplineInput>;
  /** Contract tag name input */
  contractTagName?: InputMaybe<Collection_ContractTagNameInput>;
  /** Domain ID input */
  domain?: InputMaybe<Collection_DomainAttributeInput>;
  /** Educational goal input */
  educationalGoal?: InputMaybe<Collection_EducationalGoalInput>;
  /** Learning objectives input */
  learningObjective?: InputMaybe<Collection_LearningObjectivesInput>;
  /** Optimization status */
  optimizationStatus?: InputMaybe<Collection_OptimizationStatusInput>;
  /** Organization goal input */
  organizationGoal?: InputMaybe<Collection_OrganizationGoalInput>;
  /** Organisation ID input (one per collection; owning organisation). */
  organizationId?: InputMaybe<Collection_OrganizationIdInput>;
  /** Program ID input (programs where the collection is added). */
  programId?: InputMaybe<Collection_ProgramIdInput>;
  /** Collection purpose input */
  purpose?: InputMaybe<Collection_CollectionPurposeInput>;
  /** Skill ID input */
  skill?: InputMaybe<Collection_SkillAttributeInput>;
};

/** Paginated result type for entities under a collection */
export type Collection_CollectionEntitiesPaginatedResult = {
  __typename?: 'Collection_CollectionEntitiesPaginatedResult';
  /**
   * List of collection entity elements in the page
   *
   * Note: the collection entity is marked as nullable because as of July 2024 some product cards cannot be resolved due
   * to specialization versioning issues. This is temporary and is being looked into by the lce-instructional-learning team.
   */
  elements: Array<Maybe<Collection_Entity>>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Collection Purpose Attribute input type */
export type Collection_CollectionPurposeInput = {
  /** Collection Purpose Attribute input value (i.e. CURATED_LIBRARY or LEARNING_PATH) */
  value: Scalars['String'];
};

/**
 * Collection types supposed by collection-mgmt-application.
 * Currently the only use case is enterprise curation library project.
 */
export const Collection_CollectionType = {
  /** Admin-curated (e.g. organisation-level) collection. */
  AdminCurated: 'ADMIN_CURATED',
  /** Preset */
  Preset: 'PRESET'
} as const;

export type Collection_CollectionType = typeof Collection_CollectionType[keyof typeof Collection_CollectionType];
/** Contract Tag Name Attribute input type (currently used for Academy) */
export type Collection_ContractTagNameInput = {
  /** Contract Tag Name Attribute input value */
  value: Scalars['String'];
};

/**
 * Enterprise Curated Collection schema.
 *
 * Curated Collection is a list of collections. It is manually curated so it does not go through the recommender system.
 * It is identified only through program IDs.
 */
export type Collection_CuratedCollection = {
  __typename?: 'Collection_CuratedCollection';
  /** The paginated response of collection entities in the curated collection */
  entities?: Maybe<Collection_CollectionEntitiesPaginatedResult>;
  /** Program ID for the curated collection */
  id: Scalars['ID'];
};


/**
 * Enterprise Curated Collection schema.
 *
 * Curated Collection is a list of collections. It is manually curated so it does not go through the recommender system.
 * It is identified only through program IDs.
 */
export type Collection_CuratedCollectionEntitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Domain Attribute input type */
export type Collection_DomainAttributeInput = {
  /** Domain ID input value */
  domainId: Scalars['ID'];
};

/** Educational Goal Attribute input type */
export type Collection_EducationalGoalInput = {
  /** Educational Goal Attribute input value */
  value: Scalars['String'];
};

/** Entities in the collection. Entities could be product cards, skill career roles, or nested collections. */
export type Collection_Entity = Collection_Collection | ProductCard_ProductCard | Skill_CareerRole;

/** Collection error */
export type Collection_Error = {
  __typename?: 'Collection_Error';
  /** Error message */
  message: Scalars['String'];
};

/** Learning Objectives Attribute input type */
export type Collection_LearningObjectivesInput = {
  /** Learning Objectives Attribute input value */
  value: Scalars['String'];
};

/** Collection Purpose Attribute input type */
export type Collection_OptimizationStatusInput = {
  /** Indicate if the collection needs optimized, the value of the enum is either "NEED_REVIEW" or "OPTIMIZED" */
  value: Scalars['String'];
};

/** Organization Goal Attribute input type */
export type Collection_OrganizationGoalInput = {
  /** Organization Goal Attribute input value */
  value: Scalars['String'];
};

/** Organisation ID attribute input type (one per collection; owning organisation). */
export type Collection_OrganizationIdInput = {
  /** Organisation ID value */
  organizationId: Scalars['ID'];
};

/** Program ID attribute input type (programs where the collection is added). */
export type Collection_ProgramIdInput = {
  /** Program ID value */
  programId: Scalars['ID'];
};

/** Paginated results for QueryCollections. */
export type Collection_QueryCollectionWithAttributesPaginatedResult = {
  __typename?: 'Collection_QueryCollectionWithAttributesPaginatedResult';
  /** A list of collections - enrich-able by federation. List items can be null if no collection item is accessible under the current context. */
  elements: Array<Maybe<Collection_Collection>>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Paginated results for QueryCollections. */
export type Collection_QueryRecommendationCollectionWithAttributesPaginatedResult = {
  __typename?: 'Collection_QueryRecommendationCollectionWithAttributesPaginatedResult';
  /** A list of collections - enrich-able by federation. List items can be null if no collection item is accessible under the current context. */
  elements: Array<Recommendation_Collection>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Skill Attribute input type */
export type Collection_SkillAttributeInput = {
  /** Skill ID input value */
  skillId: Scalars['ID'];
};

/** UpdateCollectionAttributes mutation failure */
export type Collection_UpdateCollectionAttributesFailure = {
  __typename?: 'Collection_UpdateCollectionAttributesFailure';
  /** Errors */
  errors: Array<Collection_Error>;
};

/** Input for UpdateCollectionAttributes mutation */
export type Collection_UpdateCollectionAttributesInput = {
  /** Attributes to add */
  attributesToAdd: Array<Collection_CollectionAttributeInput>;
  /** Attributes to delete */
  attributesToDelete: Array<Collection_CollectionAttributeInput>;
  /** Collection ID */
  collectionId: Scalars['ID'];
  /** Collection type */
  collectionType: Collection_CollectionType;
};

/** AddCollection mutation result */
export type Collection_UpdateCollectionAttributesResult = Collection_UpdateCollectionAttributesFailure | Collection_UpdateCollectionAttributesSuccess;

/** UpdateCollectionAttributes mutation success result */
export type Collection_UpdateCollectionAttributesSuccess = {
  __typename?: 'Collection_UpdateCollectionAttributesSuccess';
  /** Dummy field since type cannot be empty */
  _?: Maybe<Scalars['String']>;
};

/** UpdateCollectionAttributes mutation failure */
export type Collection_UpdateCollectionVisibilitiesFailure = {
  __typename?: 'Collection_UpdateCollectionVisibilitiesFailure';
  /** Errors */
  errors: Array<Collection_Error>;
};

/** Input for UpdateCollectionAttributes mutation */
export type Collection_UpdateCollectionVisibilitiesInput = {
  /** Collection ID */
  collectionId: Scalars['ID'];
  /** Collection type */
  collectionType: Collection_CollectionType;
  /** Visibility to add */
  visibilitiesToAdd: Array<Collection_VisibilityScope>;
  /** Visibility to delete */
  visibilitiesToDelete: Array<Collection_VisibilityScope>;
};

/** UpdateCollectionVisibilities mutation result */
export type Collection_UpdateCollectionVisibilitiesResult = Collection_UpdateCollectionVisibilitiesFailure | Collection_UpdateCollectionVisibilitiesSuccess;

/** UpdateCollectionAttributes mutation success result */
export type Collection_UpdateCollectionVisibilitiesSuccess = {
  __typename?: 'Collection_UpdateCollectionVisibilitiesSuccess';
  /** Dummy field since type cannot be empty */
  _?: Maybe<Scalars['String']>;
};

/** Collection visibility scope for Enterprise Curated Collection */
export const Collection_VisibilityScope = {
  /** Visible to Coursera for Business Audience */
  C4B: 'C4B',
  /** Visible to Coursera for Campus Audience */
  C4C: 'C4C',
  /** Visible to Coursera for Government Audience */
  C4G: 'C4G',
  /** Draft state, no visibility outside of internal tool */
  Draft: 'DRAFT',
  /** Visible to Enterprise Admins */
  EnterpriseAdmin: 'ENTERPRISE_ADMIN',
  /**
   * Visible to consumers
   * https://docs.google.com/document/d/1xpd3oMU7E3IX5FC046v4XQ0fpttSHTPZWMl4hinApNI/edit?tab=t.0
   */
  Marketing: 'MARKETING'
} as const;

export type Collection_VisibilityScope = typeof Collection_VisibilityScope[keyof typeof Collection_VisibilityScope];
/** Inferred roles confidence level */
export const Confidence_Level = {
  /** High confidence level */
  High: 'HIGH',
  /** Low confidence level */
  Low: 'LOW',
  /** Medium confidence level */
  Medium: 'MEDIUM'
} as const;

export type Confidence_Level = typeof Confidence_Level[keyof typeof Confidence_Level];
/** All content experiment queries */
export type ContentExperimentQueries = {
  __typename?: 'ContentExperimentQueries';
  /** Get a content experiment group by ID */
  getContentExperimentGroup?: Maybe<ContentExperiment_ContentExperimentGroup>;
  /** Get a single subject within a group by group ID and subject key */
  getSubject?: Maybe<ContentExperiment_ContentExperimentSubject>;
  /** Get all subjects belonging to a content experiment group */
  getSubjectsByGroupId: ContentExperiment_SubjectsPaginatedResult;
};


/** All content experiment queries */
export type ContentExperimentQueriesGetContentExperimentGroupArgs = {
  id: Scalars['ID'];
};


/** All content experiment queries */
export type ContentExperimentQueriesGetSubjectArgs = {
  groupId: Scalars['ID'];
  subjectKey: ContentExperiment_SubjectKeyInput;
};


/** All content experiment queries */
export type ContentExperimentQueriesGetSubjectsByGroupIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  groupId: Scalars['ID'];
  limit?: Scalars['Int'];
};

/** Allocation engine configuration for a content experiment group */
export type ContentExperiment_AllocationSettings = ContentExperiment_StatsigAllocationSettings;

/** Identifies a coach configuration by its mode and action */
export type ContentExperiment_CoachConfigurationKey = {
  __typename?: 'ContentExperiment_CoachConfigurationKey';
  /** Coach action identifier */
  action: Scalars['String'];
  /** Coach mode identifier */
  mode: Scalars['String'];
};

/** Input identifying a coach configuration by its mode and action */
export type ContentExperiment_CoachConfigurationKeyInput = {
  /** Coach action identifier */
  action: Scalars['String'];
  /** Coach mode identifier */
  mode: Scalars['String'];
};

/** Input to complete a content experiment group */
export type ContentExperiment_CompleteGroupInput = {
  /** Time at which to complete assignment for the experiment */
  completeTime: Scalars['DateTime'];
  /** ID of the content experiment group to complete */
  groupId: Scalars['ID'];
};

/** Result of completing a content experiment group */
export type ContentExperiment_CompleteGroupResult = {
  __typename?: 'ContentExperiment_CompleteGroupResult';
  /** The updated content experiment group */
  contentExperimentGroup: ContentExperiment_ContentExperimentGroup;
};

/** Union of the possible configuration keys (mirrors ContentExperiment_AllocationSettings). */
export type ContentExperiment_ConfigurationKey = ContentExperiment_CoachConfigurationKey;

/** Input "union" of the possible configuration keys (`@oneOf`: exactly one variant must be set). */
export type ContentExperiment_ConfigurationKeyInput = {
  /** Identifies a coach configuration by its mode and action */
  coachConfigurationKey?: InputMaybe<ContentExperiment_CoachConfigurationKeyInput>;
};

/** A group that defines the set of variants for content experiments */
export type ContentExperiment_ContentExperimentGroup = {
  __typename?: 'ContentExperiment_ContentExperimentGroup';
  /** Allocation engine configuration for this group */
  allocationSettings: ContentExperiment_AllocationSettings;
  /** Timestamp when the group experiment was completed, if applicable */
  completedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this group
   * @deprecated Use contentOptimizationConfiguration on ExperimentVariant instead
   */
  contentOptimizationConfiguration?: Maybe<ContentExperiment_ContentOptimizationConfiguration>;
  /** Timestamp when the group was created */
  createdAt: Scalars['DateTime'];
  /** Description of the group */
  description: Scalars['String'];
  /** Unique identifier for the group */
  id: Scalars['ID'];
  /** Name of the group */
  name: Scalars['String'];
  /** Timestamp when the group experiment was started, if applicable */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** Lifecycle state of the group */
  state: ContentExperiment_ExperimentGroupState;
  /** Timestamp when the group experiment was stopped, if applicable */
  stoppedAt?: Maybe<Scalars['DateTime']>;
  /** Subjects assigned to this group */
  subjects: ContentExperiment_SubjectsPaginatedResult;
  /** Timestamp when the group was last updated */
  updatedAt: Scalars['DateTime'];
  /** Variants defined in this group */
  variants: Array<ContentExperiment_ExperimentVariant>;
};


/** A group that defines the set of variants for content experiments */
export type ContentExperiment_ContentExperimentGroupSubjectsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** A subject assigned to a content experiment group */
export type ContentExperiment_ContentExperimentSubject = {
  __typename?: 'ContentExperiment_ContentExperimentSubject';
  /** Timestamp when the subject was created */
  createdAt: Scalars['DateTime'];
  /** ID of the content experiment group this subject belongs to */
  groupId: Scalars['ID'];
  /** Lifecycle state of the subject within the group */
  state: ContentExperiment_ExperimentSubjectState;
  /** Compound identifier for the subject */
  subjectKey: ContentExperiment_SubjectKey;
  /** Timestamp when the subject was last updated */
  updatedAt: Scalars['DateTime'];
};

/**
 * Content optimization configuration on a content experiment group. The record itself may be empty;
 * new top-level configuration fields can be added here over time.
 */
export type ContentExperiment_ContentOptimizationConfiguration = {
  __typename?: 'ContentExperiment_ContentOptimizationConfiguration';
  /**
   * Optional configuration key selecting which downstream resource (e.g. a coach configuration)
   * drives the pedagogy refresh event for this group
   */
  configurationKey?: Maybe<ContentExperiment_ConfigurationKey>;
};

/**
 * Input for the content optimization configuration on a content experiment group. The record itself
 * may be empty; new top-level configuration fields can be added here over time.
 */
export type ContentExperiment_ContentOptimizationConfigurationInput = {
  /**
   * Optional configuration key selecting which downstream resource (e.g. a coach configuration)
   * drives the pedagogy refresh event for this group
   */
  configurationKey?: InputMaybe<ContentExperiment_ConfigurationKeyInput>;
};

/** Input to create a content experiment group */
export type ContentExperiment_CreateContentExperimentGroupInput = {
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this group
   * @deprecated Use contentOptimizationConfiguration on ExperimentVariantInput instead
   */
  contentOptimizationConfiguration?: InputMaybe<ContentExperiment_ContentOptimizationConfigurationInput>;
  /** Description of the group */
  description: Scalars['String'];
  /** Optional unique identifier for the group */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the group */
  name: Scalars['String'];
  /** Variants to include in this group */
  variants: Array<ContentExperiment_ExperimentVariantInput>;
};

/** Result of creating a content experiment group */
export type ContentExperiment_CreateContentExperimentGroupResult = {
  __typename?: 'ContentExperiment_CreateContentExperimentGroupResult';
  /** The created content experiment group */
  contentExperimentGroup: ContentExperiment_ContentExperimentGroup;
};

/** Per-subject result for the CreateSubjectsForGroup mutation */
export type ContentExperiment_CreateSubjectResult = ContentExperiment_CreateSubjectResultError | ContentExperiment_CreateSubjectResultSuccess;

/** Error result for a single subject in CreateSubjectsForGroup mutation */
export type ContentExperiment_CreateSubjectResultError = Error & {
  __typename?: 'ContentExperiment_CreateSubjectResultError';
  /** Error message describing what went wrong */
  message: Scalars['String'];
  /** The subject key identifying which subject this result corresponds to */
  subjectKey: ContentExperiment_SubjectKey;
};

/** Successful result for a single subject in CreateSubjectsForGroup mutation */
export type ContentExperiment_CreateSubjectResultSuccess = {
  __typename?: 'ContentExperiment_CreateSubjectResultSuccess';
  /** The created subject */
  subject: ContentExperiment_ContentExperimentSubject;
  /** The subject key identifying which subject this result corresponds to */
  subjectKey: ContentExperiment_SubjectKey;
};

/** Input for createSubjectsForGroup mutation */
export type ContentExperiment_CreateSubjectsForGroupInput = {
  /** ID of the content experiment group */
  groupId: Scalars['ID'];
  /** List of subject keys to create for this group */
  subjectKeys: Array<ContentExperiment_SubjectKeyInput>;
};

/** Result of the CreateSubjectsForGroup mutation, containing one result per input subject key */
export type ContentExperiment_CreateSubjectsForGroupResult = {
  __typename?: 'ContentExperiment_CreateSubjectsForGroupResult';
  /** Per-subject results in the same order as the input subject keys */
  subjectResults: Array<ContentExperiment_CreateSubjectResult>;
};

/** Lifecycle state of a content experiment group */
export const ContentExperiment_ExperimentGroupState = {
  /** The group has been created but group-level resource setup has not started */
  New: 'NEW',
  /** All close calls have been issued; all subjects will be assigned back to default once the scheduled complete time is reached */
  ScheduledComplete: 'SCHEDULED_COMPLETE',
  /** All open calls have been issued; assignment will become active once the scheduled start time is reached */
  ScheduledStart: 'SCHEDULED_START',
  /** All stop calls have been issued; assignment will become inactive once the scheduled stop time is reached */
  ScheduledStop: 'SCHEDULED_STOP',
  /** Close calls are being issued to subjects */
  SchedulingComplete: 'SCHEDULING_COMPLETE',
  /** Open (start assignment) calls are being issued to subjects */
  SchedulingStart: 'SCHEDULING_START',
  /** Stop calls are being issued to subjects */
  SchedulingStop: 'SCHEDULING_STOP',
  /** Group-level resources are being configured */
  SettingUp: 'SETTING_UP',
  /** Group-level resources have been configured; the group is ready to accept subjects */
  SetupComplete: 'SETUP_COMPLETE',
  /** At least one subject is being set up in the downstream experiment pipeline */
  SubjectsSettingUp: 'SUBJECTS_SETTING_UP',
  /** All subjects have completed setup in the downstream experiment pipeline */
  SubjectsSetupComplete: 'SUBJECTS_SETUP_COMPLETE'
} as const;

export type ContentExperiment_ExperimentGroupState = typeof ContentExperiment_ExperimentGroupState[keyof typeof ContentExperiment_ExperimentGroupState];
/** Lifecycle state of a subject within a content experiment group */
export const ContentExperiment_ExperimentSubjectState = {
  /** The subject has been added but setup has not yet begun */
  New: 'NEW',
  /** An optimization task has been created for this subject; it is ready for experimentation */
  OptimizationStarted: 'OPTIMIZATION_STARTED',
  /** The close call has been issued; this subject will be assigned back to default once the scheduled complete time is reached */
  ScheduledComplete: 'SCHEDULED_COMPLETE',
  /** The open call has been issued; this subject's assignment will become active once the scheduled start time is reached */
  ScheduledStart: 'SCHEDULED_START',
  /** The stop call has been issued; this subject's assignment will become inactive once the scheduled stop time is reached */
  ScheduledStop: 'SCHEDULED_STOP',
  /** The close call is being issued to this subject */
  SchedulingComplete: 'SCHEDULING_COMPLETE',
  /** The open (start assignment) call is being issued to this subject */
  SchedulingStart: 'SCHEDULING_START',
  /** The stop call is being issued to this subject */
  SchedulingStop: 'SCHEDULING_STOP',
  /** Setup is in progress for this subject */
  SettingUp: 'SETTING_UP',
  /** Setup is complete and the subject is ready for experimentation */
  SetupComplete: 'SETUP_COMPLETE',
  /** Setup permanently failed (e.g. the branch copy job failed). The subject must be deleted and re-added to retry. */
  SetupFailed: 'SETUP_FAILED'
} as const;

export type ContentExperiment_ExperimentSubjectState = typeof ContentExperiment_ExperimentSubjectState[keyof typeof ContentExperiment_ExperimentSubjectState];
/** A variant within a content experiment group */
export type ContentExperiment_ExperimentVariant = {
  __typename?: 'ContentExperiment_ExperimentVariant';
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this variant
   */
  contentOptimizationConfiguration?: Maybe<ContentExperiment_ContentOptimizationConfiguration>;
  /** Unique identifier for the variant */
  id: Scalars['ID'];
  /** Whether this variant is the control (baseline) variant for the experiment */
  isControl: Scalars['Boolean'];
  /** Name of the variant */
  name: Scalars['String'];
};

/** Input for an experiment variant */
export type ContentExperiment_ExperimentVariantInput = {
  /**
   * Optional content optimization configuration that selects which prompt to use when producing
   * the downstream pedagogy refresh event for this variant
   */
  contentOptimizationConfiguration?: InputMaybe<ContentExperiment_ContentOptimizationConfigurationInput>;
  /** Unique identifier for the variant */
  id: Scalars['ID'];
  /**
   * Whether this variant is the control (baseline) variant for the experiment. Optional; treated as
   * false when omitted.
   */
  isControl?: InputMaybe<Scalars['Boolean']>;
  /** Name of the variant */
  name: Scalars['String'];
};

/** Per-subject result for the RemoveSubjectsFromGroup mutation */
export type ContentExperiment_RemoveSubjectResult = ContentExperiment_RemoveSubjectResultError | ContentExperiment_RemoveSubjectResultSuccess;

/** Error result for a single subject in RemoveSubjectsFromGroup mutation */
export type ContentExperiment_RemoveSubjectResultError = Error & {
  __typename?: 'ContentExperiment_RemoveSubjectResultError';
  /** Error message describing what went wrong */
  message: Scalars['String'];
  /** The subject key identifying which subject this result corresponds to */
  subjectKey: ContentExperiment_SubjectKey;
};

/** Successful result for a single subject in RemoveSubjectsFromGroup mutation */
export type ContentExperiment_RemoveSubjectResultSuccess = {
  __typename?: 'ContentExperiment_RemoveSubjectResultSuccess';
  /** The subject key identifying which subject this result corresponds to */
  subjectKey: ContentExperiment_SubjectKey;
};

/** Input for removeSubjectsFromGroup mutation */
export type ContentExperiment_RemoveSubjectsFromGroupInput = {
  /** ID of the content experiment group */
  groupId: Scalars['ID'];
  /** List of subject keys to remove from this group */
  subjectKeys: Array<ContentExperiment_SubjectKeyInput>;
};

/** Result of the RemoveSubjectsFromGroup mutation, containing one result per input subject key */
export type ContentExperiment_RemoveSubjectsFromGroupResult = {
  __typename?: 'ContentExperiment_RemoveSubjectsFromGroupResult';
  /** Per-subject results in the same order as the input subject keys */
  subjectResults: Array<ContentExperiment_RemoveSubjectResult>;
};

/** Input to start a content experiment group */
export type ContentExperiment_StartGroupInput = {
  /** ID of the content experiment group to start */
  groupId: Scalars['ID'];
  /** Time at which to start assignment for the experiment */
  startTime: Scalars['DateTime'];
};

/** Result of starting a content experiment group */
export type ContentExperiment_StartGroupResult = {
  __typename?: 'ContentExperiment_StartGroupResult';
  /** The updated content experiment group */
  contentExperimentGroup: ContentExperiment_ContentExperimentGroup;
};

/** Allocation settings for experiments backed by Statsig */
export type ContentExperiment_StatsigAllocationSettings = {
  __typename?: 'ContentExperiment_StatsigAllocationSettings';
  /** Statsig experiment ID */
  statsigExperimentId: Scalars['ID'];
  /** Statsig layer ID */
  statsigLayerId: Scalars['ID'];
};

/** Input to stop a content experiment group */
export type ContentExperiment_StopGroupInput = {
  /** ID of the content experiment group to stop */
  groupId: Scalars['ID'];
  /** Time at which to stop assignment for the experiment */
  stopTime: Scalars['DateTime'];
};

/** Result of stopping a content experiment group */
export type ContentExperiment_StopGroupResult = {
  __typename?: 'ContentExperiment_StopGroupResult';
  /** The updated content experiment group */
  contentExperimentGroup: ContentExperiment_ContentExperimentGroup;
};

/** Identifies a subject by its ID and type */
export type ContentExperiment_SubjectKey = {
  __typename?: 'ContentExperiment_SubjectKey';
  /** ID of the subject */
  subjectId: Scalars['ID'];
  /** Type of the subject */
  subjectType: Scalars['String'];
};

/** Identifies a subject by its ID and type */
export type ContentExperiment_SubjectKeyInput = {
  /** ID of the subject */
  subjectId: Scalars['ID'];
  /** Type of the subject */
  subjectType: Scalars['String'];
};

/** Paginated list of content experiment subjects */
export type ContentExperiment_SubjectsPaginatedResult = {
  __typename?: 'ContentExperiment_SubjectsPaginatedResult';
  /** The subjects in this page */
  elements: Array<ContentExperiment_ContentExperimentSubject>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Contentful request query and variables from the client. */
export type ContentfulRequestInput = {
  /** Contentful space to use for query. */
  contentfulSpace?: InputMaybe<Scalars['String']>;
  /** This is the contentful query coming from the client in order to support partial field selection. */
  query: Scalars['String'];
  /** Contentful request variables used in the query. */
  variables: ContentfulRequestInputVariables;
};

/** Contentful request variables used in the query. */
export type ContentfulRequestInputVariables = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** 2-letter ISO country code from the client, optional since it defaults to global. */
  countryCode: CountryCode;
  /** This flags enables querying Contentful entries that are not yet published. */
  isPreview: Scalars['Boolean'];
  /** 2-letter ISO Language code from the client, optional since it defaults to the country default language. */
  languageCode: LanguageCode;
  /**
   * This is the query parameter used in the query from the client, it is needed in order to be overridden by the localized parameter.
   * @deprecated The variant is determined by the localization-application through EPIC.
   */
  variant?: InputMaybe<Scalars['String']>;
};

/** Result for a single entry translation attempt. */
export type ContentfulTranslation_EntryResult = {
  __typename?: 'ContentfulTranslation_EntryResult';
  /** The Contentful entry ID. */
  contentfulEntryId: Scalars['ID'];
  /** Error code if translation failed. Only present when success is false. */
  errorCode?: Maybe<ContentfulTranslation_ErrorCode>;
  /** Success message or error description. */
  message?: Maybe<Scalars['String']>;
  /** Whether the translation succeeded. */
  success: Scalars['Boolean'];
};

/** Error codes for Contentful translation failures. */
export const ContentfulTranslation_ErrorCode = {
  /** Other Contentful API error. */
  ContentfulError: 'CONTENTFUL_ERROR',
  /** Contentful entry not found (HTTP 404). */
  EntryNotFound: 'ENTRY_NOT_FOUND',
  /** Invalid or unsupported language code. */
  InvalidLanguage: 'INVALID_LANGUAGE',
  /** No permission to access Contentful space (HTTP 401/403). */
  PermissionDenied: 'PERMISSION_DENIED',
  /** Contentful API rate limit exceeded (HTTP 429). */
  RateLimited: 'RATE_LIMITED',
  /** Unexpected translation failure. */
  TranslationFailed: 'TRANSLATION_FAILED'
} as const;

export type ContentfulTranslation_ErrorCode = typeof ContentfulTranslation_ErrorCode[keyof typeof ContentfulTranslation_ErrorCode];
/** Input for triggering translation of one or more Contentful entries. */
export type ContentfulTranslation_TranslateEntriesInput = {
  /**
   * Controls whether existing translations are overwritten.
   *
   * - false (default): Only translates fields that don't have existing translations
   *   in the target language. This preserves any human translations or previous
   *   machine translations. Recommended for most use cases.
   *
   * - true: Overwrites ALL existing translations with new machine translations.
   *   Use with caution: this will replace any human-edited translations and
   *   incurs additional translation costs for content that may already be translated.
   *
   * CAUTION: Setting allowOverwrite=true triggers retranslation of all fields,
   * which increases translation costs. Only use when source content has been
   * updated and you explicitly want to refresh all translations.
   */
  allowOverwrite?: InputMaybe<Scalars['Boolean']>;
  /** The Contentful entry IDs to translate. All entries must be in the same space/environment. */
  contentfulEntryIds: Array<Scalars['ID']>;
  /** The Contentful environment ID (e.g., "master"). */
  contentfulEnvironmentId: Scalars['ID'];
  /** The Contentful space ID where the entries reside. */
  contentfulSpaceId: Scalars['ID'];
  /** Source language code for translation (e.g., "en", "pt-BR"). */
  sourceLanguageCode: Scalars['ContentfulTranslation_CourseraLanguageCode'];
  /** Target language codes to translate into (e.g., ["es", "fr", "pt-BR"]). */
  targetLanguageCodes: Array<Scalars['ContentfulTranslation_CourseraLanguageCode']>;
};

/** Result of batch translation request containing per-entry results. */
export type ContentfulTranslation_TranslateEntriesResult = {
  __typename?: 'ContentfulTranslation_TranslateEntriesResult';
  /** Number of entries that failed to translate. */
  failureCount: Scalars['Int'];
  /** Per-entry results with success/failure details. */
  results: Array<ContentfulTranslation_EntryResult>;
  /** Number of entries that were successfully translated. */
  successCount: Scalars['Int'];
};

export type ContractMigrationsV2 = {
  __typename?: 'ContractMigrationsV2';
  createdAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  migrationRequest: ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationRequest;
  /** id for a Coursera user */
  requesterId: Scalars['Int'];
  status: ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus;
};

export type ContractMigrationsV2Connection = {
  __typename?: 'ContractMigrationsV2Connection';
  elements: Array<Maybe<ContractMigrationsV2>>;
  paging: ResponsePagination;
};

export type ContractMigrationsV2FindByNewContractId = {
  __typename?: 'ContractMigrationsV2FindByNewContractId';
  connection?: Maybe<ContractMigrationsV2Connection>;
  contractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type ContractMigrationsV2FindByOldContractId = {
  __typename?: 'ContractMigrationsV2FindByOldContractId';
  connection?: Maybe<ContractMigrationsV2Connection>;
  contractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type ContractMigrationsV2Resource = {
  __typename?: 'ContractMigrationsV2Resource';
  findByNewContractId?: Maybe<ContractMigrationsV2Connection>;
  findByOldContractId?: Maybe<ContractMigrationsV2Connection>;
  get?: Maybe<ContractMigrationsV2>;
};


export type ContractMigrationsV2ResourceFindByNewContractIdArgs = {
  contractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ContractMigrationsV2ResourceFindByOldContractIdArgs = {
  contractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ContractMigrationsV2ResourceGetArgs = {
  id: Scalars['String'];
};

export type ContractMigrationsV2ResourceMutations = {
  __typename?: 'ContractMigrationsV2ResourceMutations';
  create?: Maybe<ContractMigrationsV2Connection>;
  delete?: Maybe<ContractMigrationsV2Connection>;
  importContract?: Maybe<Scalars['JSON']>;
  runMigration?: Maybe<Scalars['JSON']>;
  updateMigrationRequest?: Maybe<Scalars['JSON']>;
  updateStatus?: Maybe<Scalars['JSON']>;
  validate?: Maybe<Scalars['JSON']>;
  validateContractMigrationAllocation?: Maybe<Scalars['JSON']>;
};


export type ContractMigrationsV2ResourceMutationsCreateArgs = {
  requestingUserId?: InputMaybe<Scalars['String']>;
};


export type ContractMigrationsV2ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type ContractMigrationsV2ResourceMutationsImportContractArgs = {
  requestingUserId?: InputMaybe<Scalars['String']>;
};


export type ContractMigrationsV2ResourceMutationsRunMigrationArgs = {
  id: Scalars['String'];
};


export type ContractMigrationsV2ResourceMutationsUpdateMigrationRequestArgs = {
  id: Scalars['String'];
};


export type ContractMigrationsV2ResourceMutationsUpdateStatusArgs = {
  id: Scalars['String'];
  newStatus: Scalars['String'];
};


export type ContractMigrationsV2ResourceMutationsValidateContractMigrationAllocationArgs = {
  id: Scalars['String'];
};

export type ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractEnrollmentMigrationRange = {
  __typename?: 'ContractMigrationsV2_org_coursera_enterprise_contract_migration_ContractEnrollmentMigrationRange';
  min: Scalars['Int'];
};

export type ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationRequest = {
  __typename?: 'ContractMigrationsV2_org_coursera_enterprise_contract_migration_ContractMigrationRequest';
  archiveContract: Scalars['Boolean'];
  bypassContractAllocationValidation: Scalars['Boolean'];
  bypassContractTagValidation: Scalars['Boolean'];
  contractEnrollmentMigrationRange?: Maybe<ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractEnrollmentMigrationRange>;
  migrateExistingContentRestrictions: Scalars['Boolean'];
  newContractId: Scalars['String'];
  oldContractId: Scalars['String'];
  programMigrationConfigurations: Array<Maybe<ContractMigrationsV2_Org_Coursera_Program_Migration_ProgramMigrationConfiguration>>;
  sendMembershipDeletionNotification: Scalars['Boolean'];
};

export const ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  Running: 'RUNNING',
  Successful: 'SUCCESSFUL'
} as const;

export type ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus = typeof ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus[keyof typeof ContractMigrationsV2_Org_Coursera_Enterprise_Contract_Migration_ContractMigrationStatus];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration = {
  Active: 'ACTIVE',
  AfterCutoffDate: 'AFTER_CUTOFF_DATE',
  All: 'ALL',
  None: 'NONE',
  OnlyFreeEnrollments: 'ONLY_FREE_ENROLLMENTS',
  Overage: 'OVERAGE',
  Selected: 'SELECTED'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration = {
  All: 'ALL',
  None: 'NONE'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration];
export const ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration = {
  Active: 'ACTIVE',
  All: 'ALL',
  None: 'NONE',
  Selected: 'SELECTED'
} as const;

export type ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration = typeof ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration[keyof typeof ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration];
export type ContractMigrationsV2_Org_Coursera_Program_Migration_ProgramMigrationConfiguration = {
  __typename?: 'ContractMigrationsV2_org_coursera_program_migration_ProgramMigrationConfiguration';
  enrollmentCutoffDate?: Maybe<Scalars['Float']>;
  enrollmentMigrationConfiguration: ContractMigrationsV2_Org_Coursera_Program_Migration_EnrollmentMigrationConfiguration;
  invitationMigrationConfiguration: ContractMigrationsV2_Org_Coursera_Program_Migration_InvitationMigrationConfiguration;
  membershipMigrationConfiguration: ContractMigrationsV2_Org_Coursera_Program_Migration_MembershipMigrationConfiguration;
  programId: Scalars['String'];
  refundCourseEnrollment: Scalars['Boolean'];
  restartEnrollmentTrigger: Scalars['Boolean'];
  restartInvitationReminders: Scalars['Boolean'];
  selectedUserCourseEnrollments?: Maybe<Array<Maybe<ContractMigrationsV2_Org_Coursera_Program_Migration_UserCourseEnrollment>>>;
  skipOldRosterCleanup: Scalars['Boolean'];
};

export type ContractMigrationsV2_Org_Coursera_Program_Migration_UserCourseEnrollment = {
  __typename?: 'ContractMigrationsV2_org_coursera_program_migration_UserCourseEnrollment';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  courseSlug?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
};

/** Core Skills taxonomy branch queries definition */
export type CoreSkillTaxonomyBranchQueries = {
  __typename?: 'CoreSkillTaxonomyBranchQueries';
  /** A query to retrieve a product with skills tags */
  queryCoreSkillTaxonomyBranchByNameAndStatus: CoreSkillTaxonomyBranch_PaginatedResult;
};


/** Core Skills taxonomy branch queries definition */
export type CoreSkillTaxonomyBranchQueriesQueryCoreSkillTaxonomyBranchByNameAndStatusArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  name: Scalars['String'];
  statuses: Array<CoreSkillTaxonomyBranch_Status>;
};

/** Input argument for create new branch. */
export type CoreSkillTaxonomyBranch_CreateNewBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for create new branch. */
export type CoreSkillTaxonomyBranch_CreateNewBranchResult = CoreSkillTaxonomyBranch_CreateNewBranchSuccess | CoreSkillTaxonomyBranch_GenericError;

/** Success result for create new branch. */
export type CoreSkillTaxonomyBranch_CreateNewBranchSuccess = {
  __typename?: 'CoreSkillTaxonomyBranch_CreateNewBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Input argument for deactivate branch. */
export type CoreSkillTaxonomyBranch_DeactivateBranchInput = {
  /** Flag to force deactivate freeze branch */
  includeFreezeBranch?: Scalars['Boolean'];
  /** The branch name */
  name: Scalars['String'];
};

/** Result for deactivate branch. */
export type CoreSkillTaxonomyBranch_DeactivateBranchResult = CoreSkillTaxonomyBranch_DeactivateBranchSuccess | CoreSkillTaxonomyBranch_GenericError;

/** Success result for deactivate branch. */
export type CoreSkillTaxonomyBranch_DeactivateBranchSuccess = {
  __typename?: 'CoreSkillTaxonomyBranch_DeactivateBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Input argument for freeze branch. */
export type CoreSkillTaxonomyBranch_FreezeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for freeze branch. */
export type CoreSkillTaxonomyBranch_FreezeBranchResult = CoreSkillTaxonomyBranch_FreezeBranchSuccess | CoreSkillTaxonomyBranch_GenericError;

/** Success result for freeze branch. */
export type CoreSkillTaxonomyBranch_FreezeBranchSuccess = {
  __typename?: 'CoreSkillTaxonomyBranch_FreezeBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Generic error for CoreSkillTaxonomyBranch */
export type CoreSkillTaxonomyBranch_GenericError = ErrorDetails & {
  __typename?: 'CoreSkillTaxonomyBranch_GenericError';
  /**
   * errorCode is a custom code when used with one of the predfined shared/standard errors.
   * When a developer defines a new custom error using the ErrorDetails interface, they should use the name of the custom error as the code.
   */
  errorCode: Scalars['String'];
  /** A readable message providing the error details. */
  message: Scalars['String'];
  /** The path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Input argument for merge branch. */
export type CoreSkillTaxonomyBranch_MergeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for merge branch. */
export type CoreSkillTaxonomyBranch_MergeBranchResult = CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyBranch_MergeBranchSuccess;

/** Success result for merge branch. */
export type CoreSkillTaxonomyBranch_MergeBranchSuccess = {
  __typename?: 'CoreSkillTaxonomyBranch_MergeBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Core Skill Taxonomy edge as one node within paginated results. */
export type CoreSkillTaxonomyBranch_PaginatedResult = {
  __typename?: 'CoreSkillTaxonomyBranch_PaginatedResult';
  /** Branch Content. */
  elements: Array<CoreSkillTaxonomyBranch_TaxonomyBranchContent>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Sorting direction for the SkillTag based on the TaxonomyBranchContent */
export const CoreSkillTaxonomyBranch_Status = {
  /** branch active for editing */
  Active: 'ACTIVE',
  /** branch deactivated for all operation other than deletion */
  Deactivate: 'DEACTIVATE',
  /** branch freezed for labelling and A/B testing */
  Freeze: 'FREEZE',
  /** branch has been merged into main */
  Merged: 'MERGED'
} as const;

export type CoreSkillTaxonomyBranch_Status = typeof CoreSkillTaxonomyBranch_Status[keyof typeof CoreSkillTaxonomyBranch_Status];
/** Core skill taxonomy branch content */
export type CoreSkillTaxonomyBranch_TaxonomyBranchContent = {
  __typename?: 'CoreSkillTaxonomyBranch_TaxonomyBranchContent';
  /** craeted timestamp */
  createdTime: Scalars['DateTime'];
  /**
   * Branch ID/Name
   * use id to instead of name to help the client side caching
   */
  id: Scalars['ID'];
  /** Last updated userId */
  lastUpdatedByUser: Scalars['ID'];
  /** Last updated timestamp */
  lastUpdatedTime: Scalars['DateTime'];
  /** Branch Status */
  status: CoreSkillTaxonomyBranch_Status;
};

/** Core Skills taxonomy nodes queries definition */
export type CoreSkillTaxonomyNodeQueries = {
  __typename?: 'CoreSkillTaxonomyNodeQueries';
  /** query all nodes by branch name */
  queryCoreSkillTaxonomyNodeByBranchName: CoreSkillTaxonomyNode_PaginatedResult;
};


/** Core Skills taxonomy nodes queries definition */
export type CoreSkillTaxonomyNodeQueriesQueryCoreSkillTaxonomyNodeByBranchNameArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  name: Scalars['String'];
};

/** Input argument for delete nodes by branch. */
export type CoreSkillTaxonomyNode_DeleteNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** Skill node ids to be deleted. */
  nodeIds: Array<Scalars['ID']>;
};

/** Result for delete nodes. */
export type CoreSkillTaxonomyNode_DeleteNodesByBranchNameResult = CoreSkillTaxonomyNode_DeleteNodesByBranchNameSuccess | CoreSkillTaxonomyNode_GenericError;

/** Success for delete nodes. */
export type CoreSkillTaxonomyNode_DeleteNodesByBranchNameSuccess = {
  __typename?: 'CoreSkillTaxonomyNode_DeleteNodesByBranchNameSuccess';
  /** deleted nodes */
  nodes: Array<CoreSkillTaxonomyNode_TaxonomyNode>;
};

/** Generic error for CoreSkillTaxonomyNode */
export type CoreSkillTaxonomyNode_GenericError = ErrorDetails & {
  __typename?: 'CoreSkillTaxonomyNode_GenericError';
  /** Inherited field from ErrorDetails interface */
  errorCode: Scalars['String'];
  /** A readable message providing the error details. */
  message: Scalars['String'];
  /** Inherited field from ErrorDetails interface */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Skill node for upsert */
export type CoreSkillTaxonomyNode_NodeInput = {
  /** Skill children nodes id. */
  childrenNodes: Array<Scalars['ID']>;
  /** mapped Coursera content domains that */
  courseraContentDomains: Array<Scalars['String']>;
  /** Skill description. */
  desc: Scalars['String'];
  /** Skill id. */
  id: Scalars['ID'];
  /**
   * Flag indicating whether a skill is part of our clean taxonomy, which has been
   * vetted for quality. Currently BTD only. Currently eligible for "precise" skill-content tags.
   */
  isHumanSkill: Scalars['Boolean'];
  /** if the skill is programming language */
  isProgrammingLanguage: Scalars['Boolean'];
  /** if the skill is tool or software */
  isToolSoftware: Scalars['Boolean'];
  /** Skill name. */
  name: Scalars['String'];
  /** Data source for the skill. */
  source: CoreSkillTaxonomyNode_Source;
};

/** Core Skill Taxonomy edge as one node within paginated results. */
export type CoreSkillTaxonomyNode_PaginatedResult = {
  __typename?: 'CoreSkillTaxonomyNode_PaginatedResult';
  /** Branch Content. */
  elements: Array<CoreSkillTaxonomyNode_TaxonomyNode>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Enum for skill source */
export const CoreSkillTaxonomyNode_Source = {
  /** From burning glass */
  BurningGlass: 'BURNING_GLASS',
  /** From Coursera */
  Coursera: 'COURSERA',
  /** From CSM */
  Csm: 'CSM',
  /** From Skill trans */
  SkillTrans: 'SKILL_TRANS',
  /** From Wikipedia */
  Wikipedia: 'WIKIPEDIA'
} as const;

export type CoreSkillTaxonomyNode_Source = typeof CoreSkillTaxonomyNode_Source[keyof typeof CoreSkillTaxonomyNode_Source];
/** Core skill taxonomy node */
export type CoreSkillTaxonomyNode_TaxonomyNode = {
  __typename?: 'CoreSkillTaxonomyNode_TaxonomyNode';
  /** Skill children nodes id. */
  childrenNodes: Array<Scalars['ID']>;
  /** mapped Coursera content domains that */
  courseraContentDomains: Array<Scalars['String']>;
  /** skill description */
  desc: Scalars['String'];
  /** skill id */
  id: Scalars['ID'];
  /**
   * Flag indicating whether a skill is part of our clean taxonomy, which has been
   * vetted for quality. Currently BTD only. Currently eligible for "precise" skill-content tags.
   */
  isHumanSkill: Scalars['Boolean'];
  /** if the skill is programming language */
  isProgrammingLanguage: Scalars['Boolean'];
  /** if the skill is tool or software */
  isToolSoftware: Scalars['Boolean'];
  /** Last updated userId */
  lastUpdatedByUser: Scalars['ID'];
  /** Last updated timestamp */
  lastUpdatedTime: Scalars['DateTime'];
  /** skill name */
  name: Scalars['String'];
  /** Data source for the skill. */
  source: CoreSkillTaxonomyNode_Source;
};

/** Input argument for upsert nodes by branch. */
export type CoreSkillTaxonomyNode_UpsertNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** Skill node to be upserted. */
  nodes: Array<CoreSkillTaxonomyNode_NodeInput>;
};

/** Result for upsert nodes. */
export type CoreSkillTaxonomyNode_UpsertNodesByBranchNameResult = CoreSkillTaxonomyNode_GenericError | CoreSkillTaxonomyNode_UpsertNodesByBranchNameSuccess;

/** Success for upsert nodes. */
export type CoreSkillTaxonomyNode_UpsertNodesByBranchNameSuccess = {
  __typename?: 'CoreSkillTaxonomyNode_UpsertNodesByBranchNameSuccess';
  /** upserted nodes. */
  nodes: Array<CoreSkillTaxonomyNode_TaxonomyNode>;
};

/** 2-letter ISO country codes. */
export const CountryCode = {
  /** Andorra */
  Ad: 'AD',
  /** United Arab Emirates */
  Ae: 'AE',
  /** Afghanistan */
  Af: 'AF',
  /** Antigua and Barbuda */
  Ag: 'AG',
  /** Anguilla */
  Ai: 'AI',
  /** Albania */
  Al: 'AL',
  /** Armenia */
  Am: 'AM',
  /** Netherland Antilles */
  An: 'AN',
  /** Angola */
  Ao: 'AO',
  /** Antarctica */
  Aq: 'AQ',
  /** Argentina */
  Ar: 'AR',
  /** American Samoa */
  As: 'AS',
  /** Austria */
  At: 'AT',
  /** Australia */
  Au: 'AU',
  /** Aruba */
  Aw: 'AW',
  /** Azerbaijan */
  Az: 'AZ',
  /** Bosnia- Herzegovina */
  Ba: 'BA',
  /** Barbados */
  Bb: 'BB',
  /** Bangladesh */
  Bd: 'BD',
  /** Belgium */
  Be: 'BE',
  /** Burkina Faso */
  Bf: 'BF',
  /** Bulgaria */
  Bg: 'BG',
  /** Bahrain */
  Bh: 'BH',
  /** Burundi */
  Bi: 'BI',
  /** Benin */
  Bj: 'BJ',
  /** Bermuda */
  Bm: 'BM',
  /** Brunei Darussalam */
  Bn: 'BN',
  /** Bolivia */
  Bo: 'BO',
  /** Brazil */
  Br: 'BR',
  /** Bahamas */
  Bs: 'BS',
  /** Bhutan */
  Bt: 'BT',
  /** Bouvet Island */
  Bv: 'BV',
  /** Botswana */
  Bw: 'BW',
  /** Belarus */
  By: 'BY',
  /** Belize */
  Bz: 'BZ',
  /** Canada */
  Ca: 'CA',
  /** Cocos (Keeling) Islands */
  Cc: 'CC',
  /** Central African Republic */
  Cf: 'CF',
  /** Congo */
  Cg: 'CG',
  /** Switzerland */
  Ch: 'CH',
  /** Ivory Coast */
  Ci: 'CI',
  /** Cook Islands */
  Ck: 'CK',
  /** Chile */
  Cl: 'CL',
  /** Cameroon */
  Cm: 'CM',
  /** China */
  Cn: 'CN',
  /** Colombia */
  Co: 'CO',
  /** Costa Rica */
  Cr: 'CR',
  /** Czechoslovakia (obsolete) */
  Cs: 'CS',
  /** Cuba */
  Cu: 'CU',
  /** Cape Verde */
  Cv: 'CV',
  /** Christmas Island */
  Cx: 'CX',
  /** Cyprus */
  Cy: 'CY',
  /** Czech Republic */
  Cz: 'CZ',
  /** Germany */
  De: 'DE',
  /** Djibouti */
  Dj: 'DJ',
  /** Denmark */
  Dk: 'DK',
  /** Dominica */
  Dm: 'DM',
  /** Dominican Republic */
  Do: 'DO',
  /** Algeria */
  Dz: 'DZ',
  /** Ecuador */
  Ec: 'EC',
  /** Estonia */
  Ee: 'EE',
  /** Egypt */
  Eg: 'EG',
  /** Western Sahara */
  Eh: 'EH',
  /** Eritrea */
  Er: 'ER',
  /** Spain */
  Es: 'ES',
  /** Ethiopia */
  Et: 'ET',
  /** Finland */
  Fi: 'FI',
  /** Fiji */
  Fj: 'FJ',
  /** Falkland Isl.( Malvinas) */
  Fk: 'FK',
  /** Micronesia */
  Fm: 'FM',
  /** Faroe Islands */
  Fo: 'FO',
  /** France */
  Fr: 'FR',
  /** France (Europe only) */
  Fx: 'FX',
  /** Gabon */
  Ga: 'GA',
  /** Great Britain (UK) */
  Gb: 'GB',
  /** Grenada */
  Gd: 'GD',
  /** Georgia */
  Ge: 'GE',
  /** Guyana (Fr.) */
  Gf: 'GF',
  /** Ghana */
  Gh: 'GH',
  /** Gibraltar */
  Gi: 'GI',
  /** Greenland */
  Gl: 'GL',
  /** Gambia */
  Gm: 'GM',
  /** Guinea */
  Gn: 'GN',
  /** Guadeloupe (Fr.) */
  Gp: 'GP',
  /** Equatorial Guinea */
  Gq: 'GQ',
  /** Greece */
  Gr: 'GR',
  /** South Georgia & South Sandwich Islands */
  Gs: 'GS',
  /** Guatemala */
  Gt: 'GT',
  /** Guam (US) */
  Gu: 'GU',
  /** Guinea Bissau */
  Gw: 'GW',
  /** Guyana */
  Gy: 'GY',
  /** Hong Kong */
  Hk: 'HK',
  /** Heard & McDonald Islands */
  Hm: 'HM',
  /** Honduras */
  Hn: 'HN',
  /** Croatia */
  Hr: 'HR',
  /** Haiti */
  Ht: 'HT',
  /** Hungary */
  Hu: 'HU',
  /** Indonesia */
  Id: 'ID',
  /** Ireland */
  Ie: 'IE',
  /** Israel */
  Il: 'IL',
  /** India */
  In: 'IN',
  /** British Indian Ocean Terr. */
  Io: 'IO',
  /** Iraq */
  Iq: 'IQ',
  /** Iran */
  Ir: 'IR',
  /** Iceland */
  Is: 'IS',
  /** Italy */
  It: 'IT',
  /** Jamaica */
  Jm: 'JM',
  /** Jordan */
  Jo: 'JO',
  /** Japan */
  Jp: 'JP',
  /** Kenya */
  Ke: 'KE',
  /** Kyrgyz Republic */
  Kg: 'KG',
  /** Cambodia */
  Kh: 'KH',
  /** Kiribati */
  Ki: 'KI',
  /** Comoros */
  Km: 'KM',
  /** St. Kitts Nevis Anguilla */
  Kn: 'KN',
  /** Korea (North) */
  Kp: 'KP',
  /** Korea (South) */
  Kr: 'KR',
  /** Kuwait */
  Kw: 'KW',
  /** Cayman Islands */
  Ky: 'KY',
  /** Kazachstan */
  Kz: 'KZ',
  /** Laos */
  La: 'LA',
  /** Lebanon */
  Lb: 'LB',
  /** Saint Lucia */
  Lc: 'LC',
  /** Liechtenstein */
  Li: 'LI',
  /** Sri Lanka */
  Lk: 'LK',
  /** Liberia */
  Lr: 'LR',
  /** Lesotho */
  Ls: 'LS',
  /** Lithuania */
  Lt: 'LT',
  /** Luxembourg */
  Lu: 'LU',
  /** Latvia */
  Lv: 'LV',
  /** Libya */
  Ly: 'LY',
  /** Morocco */
  Ma: 'MA',
  /** Monaco */
  Mc: 'MC',
  /** Moldova */
  Md: 'MD',
  /** Madagascar */
  Mg: 'MG',
  /** Marshall Islands */
  Mh: 'MH',
  /** Macedonia (prev. Yug.) */
  Mk: 'MK',
  /** Mali */
  Ml: 'ML',
  /** Myanmar */
  Mm: 'MM',
  /** Mongolia */
  Mn: 'MN',
  /** Macau */
  Mo: 'MO',
  /** Northern Mariana Islands */
  Mp: 'MP',
  /** Martinique (Fr.) */
  Mq: 'MQ',
  /** Mauritania */
  Mr: 'MR',
  /** Montserrat */
  Ms: 'MS',
  /** Malta */
  Mt: 'MT',
  /** Mauritius */
  Mu: 'MU',
  /** Maldives */
  Mv: 'MV',
  /** Malawi */
  Mw: 'MW',
  /** Mexico */
  Mx: 'MX',
  /** Malaysia */
  My: 'MY',
  /** Mozambique */
  Mz: 'MZ',
  /** Namibia */
  Na: 'NA',
  /** New Caledonia Fr. */
  Nc: 'NC',
  /** Niger */
  Ne: 'NE',
  /** Norfolk Island */
  Nf: 'NF',
  /** Nigeria */
  Ng: 'NG',
  /** Nicaragua */
  Ni: 'NI',
  /** Netherlands */
  Nl: 'NL',
  /** Norway */
  No: 'NO',
  /** Nepal */
  Np: 'NP',
  /** Nauru */
  Nr: 'NR',
  /** Niue */
  Nu: 'NU',
  /** New Zealand */
  Nz: 'NZ',
  /** Oman */
  Om: 'OM',
  /** Panama */
  Pa: 'PA',
  /** Peru */
  Pe: 'PE',
  /** Polynesia (Fr.) */
  Pf: 'PF',
  /** Papua New Guinea */
  Pg: 'PG',
  /** Philippines */
  Ph: 'PH',
  /** Pakistan */
  Pk: 'PK',
  /** Poland */
  Pl: 'PL',
  /** St. Pierre & Miquelon */
  Pm: 'PM',
  /** Pitcairn */
  Pn: 'PN',
  /** Puerto Rico (US) */
  Pr: 'PR',
  /** Portugal */
  Pt: 'PT',
  /** Palau */
  Pw: 'PW',
  /** Paraguay */
  Py: 'PY',
  /** Qatar */
  Qa: 'QA',
  /** Reunion (Fr.) */
  Re: 'RE',
  /** Romania */
  Ro: 'RO',
  /** Russian Federation */
  Ru: 'RU',
  /** Rwanda */
  Rw: 'RW',
  /** Saudi Arabia */
  Sa: 'SA',
  /** Solomon Islands */
  Sb: 'SB',
  /** Seychelles */
  Sc: 'SC',
  /** Sudan */
  Sd: 'SD',
  /** Sweden */
  Se: 'SE',
  /** Singapore */
  Sg: 'SG',
  /** St. Helena */
  Sh: 'SH',
  /** Slovenia */
  Si: 'SI',
  /** Svalbard& Jan Mayen Islands */
  Sj: 'SJ',
  /** Slovakia (Slovak Republic) */
  Sk: 'SK',
  /** Sierra Leone */
  Sl: 'SL',
  /** San Marino */
  Sm: 'SM',
  /** Senegal */
  Sn: 'SN',
  /** Somalia */
  So: 'SO',
  /** Suriname */
  Sr: 'SR',
  /** St. Tome and Principe */
  St: 'ST',
  /** Soviet Union (obsolete) */
  Su: 'SU',
  /** El Salvador */
  Sv: 'SV',
  /** Syria */
  Sy: 'SY',
  /** Swaziland */
  Sz: 'SZ',
  /** Turks& Caicos Islands */
  Tc: 'TC',
  /** Chad */
  Td: 'TD',
  /** French Southern Territory */
  Tf: 'TF',
  /** Togo */
  Tg: 'TG',
  /** Thailand */
  Th: 'TH',
  /** Tadjikistan */
  Tj: 'TJ',
  /** Tokelau */
  Tk: 'TK',
  /** Turkmenistan */
  Tm: 'TM',
  /** Tunisia */
  Tn: 'TN',
  /** Tonga */
  To: 'TO',
  /** East Timor */
  Tp: 'TP',
  /** Turkey */
  Tr: 'TR',
  /** Trinidad Tobago */
  Tt: 'TT',
  /** Tuvalu */
  Tv: 'TV',
  /** Taiwan */
  Tw: 'TW',
  /** Tanzania */
  Tz: 'TZ',
  /** Ukraine */
  Ua: 'UA',
  /** Uganda */
  Ug: 'UG',
  /** United Kingdom */
  Uk: 'UK',
  /** US Minor outlying Islands */
  Um: 'UM',
  /** United States */
  Us: 'US',
  /** Uruguay */
  Uy: 'UY',
  /** Uzbekistan */
  Uz: 'UZ',
  /** Vatican City State */
  Va: 'VA',
  /** St. Vincent& Grenadines */
  Vc: 'VC',
  /** Venezuela */
  Ve: 'VE',
  /** VirginIslands (GB) */
  Vg: 'VG',
  /** Virgin Islands (US) */
  Vi: 'VI',
  /** Vietnam */
  Vn: 'VN',
  /** Vanuatu */
  Vu: 'VU',
  /** Wallis & Futuna Islands */
  Wf: 'WF',
  /** Samoa */
  Ws: 'WS',
  /** Yemen */
  Ye: 'YE',
  /** Mayotte */
  Yt: 'YT',
  /** Yugoslavia (obsolete) */
  Yu: 'YU',
  /** South Africa */
  Za: 'ZA',
  /** Zambia */
  Zm: 'ZM',
  /** Zaire */
  Zr: 'ZR',
  /** Zimbabwe */
  Zw: 'ZW',
  /** Global country code is to be used as a default fallback */
  Global: 'global'
} as const;

export type CountryCode = typeof CountryCode[keyof typeof CountryCode];
export type CourseAccomplishmentsV1 = {
  __typename?: 'CourseAccomplishmentsV1';
  completionDate: Scalars['Float'];
  courseId: Scalars['String'];
  distinctionLevel: CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel;
  grade: Scalars['Float'];
  id: Scalars['Int'];
  instructors: Array<Maybe<CourseAccomplishmentsV1_Org_Coursera_Certificate_Accomplishments_Instructor>>;
  name: Scalars['String'];
  partners: Array<Maybe<CourseAccomplishmentsV1_Org_Coursera_Certificate_Accomplishments_Partner>>;
  platformOrigin: CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin;
  slug: Scalars['String'];
  verifyCode: Scalars['String'];
};

export type CourseAccomplishmentsV1ByUser = {
  __typename?: 'CourseAccomplishmentsV1ByUser';
  connection?: Maybe<CourseAccomplishmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CourseAccomplishmentsV1Connection = {
  __typename?: 'CourseAccomplishmentsV1Connection';
  elements: Array<Maybe<CourseAccomplishmentsV1>>;
  paging: ResponsePagination;
};

export type CourseAccomplishmentsV1Resource = {
  __typename?: 'CourseAccomplishmentsV1Resource';
  byUser?: Maybe<CourseAccomplishmentsV1Connection>;
};


export type CourseAccomplishmentsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** Distinction achieved by a learner getting a grade for a course */
export const CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof CourseAccomplishmentsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** It is necessary to differentiate Spark and OnDemand courses because not all features can not treat these as the same thing. For example, we may have an upsell feature that prompts you to take a specialization if you took a course that is part of it. We wouldn't want this feature to treat all certs the same because Spark Courses/Specializations are no longer available. A SparkCourse Cert vs OnDemandCourse Cert shouldn't be considered as a different "type" of certificate though as they store the exact same fields. However a Course and a Specialization should be considered as different types as they are a completely different product */
export const CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin = {
  OnDemand: 'ON_DEMAND',
  Spark: 'SPARK'
} as const;

export type CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin = typeof CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin[keyof typeof CourseAccomplishmentsV1_Org_Coursera_Certificate_CertificatePlatformOrigin];
export type CourseAccomplishmentsV1_Org_Coursera_Certificate_Accomplishments_Instructor = {
  __typename?: 'CourseAccomplishmentsV1_org_coursera_certificate_accomplishments_Instructor';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  photo: Scalars['String'];
  title: Scalars['String'];
};

export type CourseAccomplishmentsV1_Org_Coursera_Certificate_Accomplishments_Partner = {
  __typename?: 'CourseAccomplishmentsV1_org_coursera_certificate_accomplishments_Partner';
  logo: Scalars['String'];
  name: Scalars['String'];
};

/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderQueries = {
  __typename?: 'CourseBuilderQueries';
  /**
   * Find courses that were excluded from course builder
   * This will be based on either course level or s12n level restrictions
   */
  findCourseBuilderExcludedCourses?: Maybe<CourseBuilder_CourseRestrictions>;
  /** Find item types that were excluded by each partner */
  findCourseBuilderExcludedItemTypes?: Maybe<Array<CourseBuilder_PartnerExcludedItemTypes>>;
  /** Find item types that were excluded by the given course */
  findCourseBuilderExcludedItemTypesByCourseId?: Maybe<CourseBuilder_ItemTypeRestrictions>;
  /** Find item types that were excluded by the given partner */
  findCourseBuilderExcludedItemTypesByPartnerId?: Maybe<CourseBuilder_ItemTypeRestrictions>;
  /**
   * Find partners that have opted out from course builder
   * All content for these partners will be excluded from course builder
   * If partner id is provided, this will also include partner level restrictions
   */
  findCourseBuilderExcludedPartners: Array<Partner_Partner>;
  /** Get a course builder restrictions */
  getCourseBuilderRestrictions?: Maybe<Array<CourseBuilder_Restriction>>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderQueriesFindCourseBuilderExcludedItemTypesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderQueriesFindCourseBuilderExcludedItemTypesByPartnerIdArgs = {
  partnerId: Scalars['Int'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderQueriesFindCourseBuilderExcludedPartnersArgs = {
  partnerId?: InputMaybe<Scalars['Int']>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderQueriesGetCourseBuilderRestrictionsArgs = {
  partnerId: Scalars['Int'];
};

/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2Queries = {
  __typename?: 'CourseBuilderV2Queries';
  /**
   * Takes a user query and returns a list of alternative item curation results for replacing a given atom in an authoring
   * branch
   */
  getCurationRefinementPageForAtomInAuthoringCourseBranch?: Maybe<CourseBuilderV2_CurationRefinementOptionPaginatedResult>;
  /**
   * Takes a user query and returns a list of alternative item curation results for replacing an outline item during
   * the USER_CURATION_CHECKPOINT
   */
  getCurationRefinementPageForCurationCheckpoint?: Maybe<CourseBuilderV2_CuratedItemPaginatedResult>;
  /** Takes a user query and returns a list of item curation results for a given module in an authoring branch */
  getCurationRefinementPageForModuleInAuthoringCourseBranch?: Maybe<CourseBuilderV2_CurationRefinementOptionPaginatedResult>;
  /** Takes a user query and returns a list of module curation results for an authoring course branch */
  getModuleCurationPageForAuthoringCourseBranch?: Maybe<CourseBuilderV2_CuratedModulePaginatedResult>;
  /**
   * Takes a user query and returns a list of module curation results for a Course Builder workflow during
   * the USER_CURATION_CHECKPOINT
   */
  getModuleCurationPageForCurationCheckpoint?: Maybe<CourseBuilderV2_OutlineModulePaginatedResult>;
  /**
   * Query all course builder workflows associated with a given branch, with an optional status filter.
   * Entries are sorted by creation date, with the most recent first.
   */
  queryByAuthoringBranchIdAndStatuses?: Maybe<CourseBuilderV2_WorkflowPaginatedResult>;
  /** Query a course builder workflow by ID */
  queryById?: Maybe<CourseBuilderV2_Workflow>;
  /** Search modules that teach specific verified skills */
  searchModulesForVerifiedSkills?: Maybe<CourseBuilderV2_VerifiedSkillsModulePaginatedResult>;
  /** Search courses and other products to add to a Course Builder course */
  searchProducts?: Maybe<CourseBuilderV2_ProductSearchHitPaginatedResult>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesGetCurationRefinementPageForAtomInAuthoringCourseBranchArgs = {
  allowedCourseLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  allowedItemTypes?: InputMaybe<Array<CourseBuilderV2_CourseItemType>>;
  atomId?: InputMaybe<Scalars['ID']>;
  authoringCourseBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId?: InputMaybe<Scalars['ID']>;
  query: Scalars['String'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesGetCurationRefinementPageForCurationCheckpointArgs = {
  allowedCourseLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  allowedItemTypes?: InputMaybe<Array<CourseBuilderV2_CourseItemType>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  outlineModuleKey: Scalars['ID'];
  query: Scalars['String'];
  workflowId: Scalars['ID'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesGetCurationRefinementPageForModuleInAuthoringCourseBranchArgs = {
  allowedCourseLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  allowedItemTypes?: InputMaybe<Array<CourseBuilderV2_CourseItemType>>;
  authoringCourseBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  moduleId: Scalars['ID'];
  programId?: InputMaybe<Scalars['ID']>;
  query: Scalars['String'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesGetModuleCurationPageForAuthoringCourseBranchArgs = {
  allowedCourseLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  authoringCourseBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesGetModuleCurationPageForCurationCheckpointArgs = {
  allowedCourseLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  workflowId: Scalars['ID'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesQueryByAuthoringBranchIdAndStatusesArgs = {
  authoringBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  statuses?: InputMaybe<Array<CourseBuilderV2_WorkflowStatus>>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesSearchModulesForVerifiedSkillsArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  enterpriseProgramId: Scalars['ID'];
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  languages?: InputMaybe<Array<Scalars['String']>>;
  learningProductTypes?: InputMaybe<Array<Scalars['String']>>;
  learningProducts?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  programmingLanguages?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  skillExpressionIds?: InputMaybe<Array<Scalars['ID']>>;
  skillExpressions?: InputMaybe<Array<Scalars['String']>>;
  tools?: InputMaybe<Array<Scalars['String']>>;
};


/** Course builder queries. Extended in workflow_queries_v1.graphqls and refinement_v1.graphqls */
export type CourseBuilderV2QueriesSearchProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  enterpriseProgramId: Scalars['ID'];
  languages?: InputMaybe<Array<Scalars['String']>>;
  limit?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  productDifficultyLevels?: InputMaybe<Array<CourseBuilderV2_ProductDifficultyLevel>>;
  productDurations?: InputMaybe<Array<CourseBuilderV2_ProductDuration>>;
  productTypes?: InputMaybe<Array<CourseBuilderV2_ProductType>>;
  query?: InputMaybe<Scalars['String']>;
  syllabusAssetId?: InputMaybe<Scalars['ID']>;
};

/** Answer option with correctness */
export type CourseBuilderV2_AnswerOptionWithCorrectness = {
  __typename?: 'CourseBuilderV2_AnswerOptionWithCorrectness';
  /** Answer option */
  answer: Scalars['String'];
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
};

/** Input for an answer option with correctness */
export type CourseBuilderV2_AnswerOptionWithCorrectnessInput = {
  /** Answer option text */
  answer: Scalars['String'];
  /** Feedback for the answer option */
  feedback: Scalars['String'];
  /** Indicates if the answer option is correct */
  isCorrect: Scalars['Boolean'];
};

/** Answer option with ID */
export type CourseBuilderV2_AnswerOptionWithId = {
  __typename?: 'CourseBuilderV2_AnswerOptionWithId';
  /** Answer option */
  answer: Scalars['String'];
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** ID of the answer option */
  id: Scalars['ID'];
};

/** Input for an answer option with ID */
export type CourseBuilderV2_AnswerOptionWithIdInput = {
  /** Answer option text */
  answer: Scalars['String'];
  /** Feedback for the answer option */
  feedback: Scalars['String'];
  /** ID of the answer option */
  id: Scalars['ID'];
};

/** Assessment attempt configuration input */
export type CourseBuilderV2_AssessmentAttemptConfiguration = {
  __typename?: 'CourseBuilderV2_AssessmentAttemptConfiguration';
  /**
   * Number of attempts allowed
   * Can be null if unlimited attempts are allowed
   */
  attemptLimit?: Maybe<Scalars['Int']>;
  /**
   * Rate Limit Configuration
   * Can be null if no rate limit is set
   */
  rateLimitConfiguration?: Maybe<CourseBuilderV2_AssessmentRateLimitConfiguration>;
  /**
   * Submission limit for each attempt
   * Can be null if no submission limit is set
   */
  submissionLimitForEachAttempt?: Maybe<Scalars['Int']>;
  /**
   * Time limit for each attempt in milliseconds
   * Can be null if no time limit is set
   */
  timeLimitForEachAttempt?: Maybe<Scalars['Int']>;
};

/** Assessment attempt configuration input */
export type CourseBuilderV2_AssessmentAttemptConfigurationInput = {
  /**
   * Number of attempts allowed
   * Can be null if unlimited attempts are allowed
   */
  attemptLimit?: InputMaybe<Scalars['Int']>;
  /**
   * Rate Limit Configuration
   * Can be null if no rate limit is set
   */
  rateLimitConfiguration?: InputMaybe<CourseBuilderV2_AssessmentRateLimitConfigurationInput>;
  /**
   * Submission limit for each attempt
   * Can be null if no submission limit is set
   */
  submissionLimitForEachAttempt?: InputMaybe<Scalars['Int']>;
  /**
   * Time limit for each attempt in milliseconds
   * Can be null if no time limit is set
   */
  timeLimitForEachAttempt?: InputMaybe<Scalars['Int']>;
};

/** Assessment generation configuration input */
export type CourseBuilderV2_AssessmentGenerationConfigurationInput = {
  /** Question generation input */
  generationInput: CourseBuilderV2_StartAssessmentGenerationInput;
  /** Number of questions learners will see per module */
  questionsForLearnersPerModule: Scalars['Int'];
};

/** Assessment generation configuration inputs */
export type CourseBuilderV2_AssessmentGenerationConfigurationInputs = {
  __typename?: 'CourseBuilderV2_AssessmentGenerationConfigurationInputs';
  /** Question generation input */
  generationInput: CourseBuilderV2_StartAssessmentGenerationInputs;
  /** Number of questions learners will see per module */
  questionsForLearnersPerModule: Scalars['Int'];
};

/**
 * Enum representing the types of feedback level
 * QuestionGenerator_FeedbackType
 */
export const CourseBuilderV2_AssessmentGeneratorFeedbackType = {
  /** All relevant feedback provided */
  Full: 'FULL',
  /** Correct answer is not disclosed */
  Graded: 'GRADED',
  /** No feedback provided */
  None: 'NONE'
} as const;

export type CourseBuilderV2_AssessmentGeneratorFeedbackType = typeof CourseBuilderV2_AssessmentGeneratorFeedbackType[keyof typeof CourseBuilderV2_AssessmentGeneratorFeedbackType];
/**
 * Enum representing the types of questions the AI can generate
 * QuestionGenerator_QuestionType
 */
export const CourseBuilderV2_AssessmentGeneratorQuestionType = {
  /** Code expression question */
  AiGraded: 'AI_GRADED',
  /** Checkboxes question */
  Checkbox: 'CHECKBOX',
  /** Code expression question */
  CodeExpression: 'CODE_EXPRESSION',
  /** Multi-choice questions, or checkboxes */
  MultipleChoice: 'MULTIPLE_CHOICE',
  /** Number match questions */
  Number: 'NUMBER',
  /** Text match questions */
  TextExactMatch: 'TEXT_EXACT_MATCH'
} as const;

export type CourseBuilderV2_AssessmentGeneratorQuestionType = typeof CourseBuilderV2_AssessmentGeneratorQuestionType[keyof typeof CourseBuilderV2_AssessmentGeneratorQuestionType];
/** Generated assessment outline items */
export type CourseBuilderV2_AssessmentOutlineItem = {
  __typename?: 'CourseBuilderV2_AssessmentOutlineItem';
  /** Type of this assessment; either module quiz or final exam */
  assessmentOutlineType: CourseBuilderV2_AssessmentOutlineType;
  /** attempt configuration of the assessment */
  attemptConfiguration: CourseBuilderV2_AssessmentAttemptConfiguration;
  /** when true: it is a graded assignment; when false: it is a practice assignment */
  isGraded: Scalars['Boolean'];
  /** item type of the generated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** name of the assessment */
  name: Scalars['String'];
  /** question generation configuration of the assessment */
  questionGenerationConfiguration: CourseBuilderV2_AssessmentGenerationConfigurationInputs;
  /** specifies whether the assessment outline has been reviewed by the author */
  reviewed: Scalars['Boolean'];
};

/** Specify type of Assessment Outline */
export const CourseBuilderV2_AssessmentOutlineType = {
  /** Final exam */
  FinalExam: 'FINAL_EXAM',
  /** Module quiz */
  ModuleQuiz: 'MODULE_QUIZ'
} as const;

export type CourseBuilderV2_AssessmentOutlineType = typeof CourseBuilderV2_AssessmentOutlineType[keyof typeof CourseBuilderV2_AssessmentOutlineType];
/** Assessment Rate Limit Configuration */
export type CourseBuilderV2_AssessmentRateLimitConfiguration = {
  __typename?: 'CourseBuilderV2_AssessmentRateLimitConfiguration';
  /** Number of attempts allowed */
  numberOfAttempts: Scalars['Int'];
  /** Time interval for each attempt in milliseconds */
  timeInterval: Scalars['Int'];
};

/** Assessment Rate Limit Configuration */
export type CourseBuilderV2_AssessmentRateLimitConfigurationInput = {
  /** Number of attempts allowed */
  numberOfAttempts: Scalars['Int'];
  /** Time interval for each attempt in milliseconds */
  timeInterval: Scalars['Int'];
};

/** User inputs used to generate the course outline */
export type CourseBuilderV2_AssessmentsInputs = {
  __typename?: 'CourseBuilderV2_AssessmentsInputs';
  /**
   * assessment integrity configuration of the final exam
   * Can be null if final exam was not selected
   */
  finalExam?: Maybe<CourseBuilderV2_AssessmentAttemptConfiguration>;
  /**
   * assessment integrity configuration of the module quizzes
   * Can be null if module quiz was not selected
   */
  moduleQuiz?: Maybe<CourseBuilderV2_AssessmentAttemptConfiguration>;
};

/** Assignment segment */
export type CourseBuilderV2_AssignmentSegment = CourseBuilderV2_CheckBoxQuestion | CourseBuilderV2_CheckBoxReflectQuestion | CourseBuilderV2_ManualGradedQuestion | CourseBuilderV2_MathExpressionQuestion | CourseBuilderV2_MultipleChoiceQuestion | CourseBuilderV2_MultipleChoiceReflectQuestion | CourseBuilderV2_MultipleDropdownQuestion | CourseBuilderV2_NumericQuestion | CourseBuilderV2_RegexQuestion | CourseBuilderV2_TextBlockQuestion | CourseBuilderV2_TextExactMatchQuestion | CourseBuilderV2_TextReflectQuestion;

/** Input for an assignment segment */
export type CourseBuilderV2_AssignmentSegmentInput = {
  /** Check box question */
  checkBoxQuestion?: InputMaybe<CourseBuilderV2_CheckBoxQuestionInput>;
  /** Check box reflect question */
  checkBoxReflectQuestion?: InputMaybe<CourseBuilderV2_CheckBoxReflectQuestionInput>;
  /** Manual graded question */
  manualGradedQuestion?: InputMaybe<CourseBuilderV2_ManualGradedQuestionInput>;
  /** Math expression question */
  mathExpressionQuestion?: InputMaybe<CourseBuilderV2_MathExpressionQuestionInput>;
  /** Multiple choice question */
  multipleChoiceQuestion?: InputMaybe<CourseBuilderV2_MultipleChoiceQuestionInput>;
  /** Multiple choice reflect question */
  multipleChoiceReflectQuestion?: InputMaybe<CourseBuilderV2_MultipleChoiceReflectQuestionInput>;
  /** Multiple dropdown question */
  multipleDropdownQuestion?: InputMaybe<CourseBuilderV2_MultipleDropdownQuestionInput>;
  /** Numeric question */
  numericQuestion?: InputMaybe<CourseBuilderV2_NumericQuestionInput>;
  /** Regex question */
  regexQuestion?: InputMaybe<CourseBuilderV2_RegexQuestionInput>;
  /** Text block with learner instructions */
  textBlockQuestion?: InputMaybe<CourseBuilderV2_TextBlockQuestionInput>;
  /** Text exact match question */
  textExactMatchQuestion?: InputMaybe<CourseBuilderV2_TextExactMatchQuestionInput>;
  /** Text reflect question */
  textReflectQuestion?: InputMaybe<CourseBuilderV2_TextReflectQuestionInput>;
};

/** Generation source for generated atom underlying the course item */
export const CourseBuilderV2_AtomGenerationSource = {
  /** Atom was generated by AI */
  Ai: 'AI',
  /** Atom was generated by a user */
  User: 'USER'
} as const;

export type CourseBuilderV2_AtomGenerationSource = typeof CourseBuilderV2_AtomGenerationSource[keyof typeof CourseBuilderV2_AtomGenerationSource];
/** Check box question */
export type CourseBuilderV2_CheckBoxQuestion = {
  __typename?: 'CourseBuilderV2_CheckBoxQuestion';
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** A list of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectness>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox question */
export type CourseBuilderV2_CheckBoxQuestionInput = {
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** A list of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Check box reflect question */
export type CourseBuilderV2_CheckBoxReflectQuestion = {
  __typename?: 'CourseBuilderV2_CheckBoxReflectQuestion';
  /** A list of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithId>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** A list of answer options with correctness */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflect question */
export type CourseBuilderV2_CheckBoxReflectQuestionInput = {
  /** A list of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Range specifing a portion of split text and docx files converted to cml */
export type CourseBuilderV2_CmlRange = {
  __typename?: 'CourseBuilderV2_CmlRange';
  /** CML content */
  cml: Cml_Cml;
  /**
   * CML content
   * @deprecated Use properly typed `cml` field instead
   */
  cmlContent: Scalars['String'];
};

/** Range specifying a portion of split text and docx files converted to cml */
export type CourseBuilderV2_CmlRangeInput = {
  /** CML content */
  cml: Cml_CmlInput;
  /**
   * CML content
   * @deprecated Use properly typed `cml` field instead
   */
  cmlContent?: InputMaybe<Scalars['String']>;
};

/** Conflict error, thrown when the workflow version passed in as an input is out of date */
export type CourseBuilderV2_ConflictError = CourseBuilderV2_Error & Error & {
  __typename?: 'CourseBuilderV2_ConflictError';
  /** Error message */
  message: Scalars['String'];
};

/** Represents a domain and subdomain pair */
export type CourseBuilderV2_CourseDomainType = {
  __typename?: 'CourseBuilderV2_CourseDomainType';
  /** Domain ID */
  domainId: Scalars['ID'];
  /** Domain name */
  domainName: Scalars['String'];
  /** Subdomain ID */
  subdomainId: Scalars['ID'];
  /** Subdomain name */
  subdomainName: Scalars['String'];
};

/**
 * Union of all the different types of items to display in the course outline during the
 * USER_CURATION_CHECKPOINT step
 */
export type CourseBuilderV2_CourseItem = CourseBuilderV2_AssessmentOutlineItem | CourseBuilderV2_CuratedItem | CourseBuilderV2_GeneratedAssetItem | CourseBuilderV2_PlaceholderItem | CourseBuilderV2_UnmatchedSearchTerm;

/** Course item input */
export type CourseBuilderV2_CourseItemInput = {
  /** Assessment outline item */
  assessmentOutlineItem?: InputMaybe<CourseBuilderV2_GeneratedAssessmentOutlineItemInput>;
  /** Curated item */
  curatedItem?: InputMaybe<CourseBuilderV2_CuratedItemInput>;
  /** Generated asset item */
  generatedAssetItem?: InputMaybe<CourseBuilderV2_GeneratedAssetItemInput>;
  /** Placeholder item */
  placeholderItem?: InputMaybe<CourseBuilderV2_PlaceholderItemInput>;
  /** Unmatched search term */
  unmatchedSearchTerm?: InputMaybe<Scalars['String']>;
};

/** Course item type */
export const CourseBuilderV2_CourseItemType = {
  /** Assignment */
  Assignment: 'ASSIGNMENT',
  /** Dialogue */
  Dialogue: 'DIALOGUE',
  /** Discussion Prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** LTI or App Item */
  Lti: 'LTI',
  /** Peer Review Assignment */
  PeerReview: 'PEER_REVIEW',
  /** Programming Assignment */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /** Role Play */
  RolePlay: 'ROLE_PLAY',
  /** Teammate Review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** UNGRADED_LAB */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget (aka Plugin) */
  Widget: 'WIDGET'
} as const;

export type CourseBuilderV2_CourseItemType = typeof CourseBuilderV2_CourseItemType[keyof typeof CourseBuilderV2_CourseItemType];
/** Course length */
export type CourseBuilderV2_CourseLength = {
  __typename?: 'CourseBuilderV2_CourseLength';
  /** Desired length of the course in hours */
  numHours: Scalars['Int'];
  /** Desired number of modules to generate, inferred on the server if not originally provided */
  numModules: Scalars['Int'];
};

/** Course length */
export type CourseBuilderV2_CourseLengthInput = {
  /** Desired length of the course in hours */
  numHours: Scalars['Int'];
  /** Desired number of modules to generate, inferred on the server if not provided */
  numModules?: InputMaybe<Scalars['Int']>;
};

/** Course length specified using number of modules or a range of modules */
export type CourseBuilderV2_CourseLengthModuleBasedInput = {
  /** Specify a range of number of modules to generate */
  moduleRange?: InputMaybe<CourseBuilderV2_CourseLengthModuleRangeInput>;
  /** Specify a fixed number of modules to generate */
  numModules?: InputMaybe<Scalars['Int']>;
};

/** Course length specified using a fixed number of modules */
export type CourseBuilderV2_CourseLengthModuleOnly = {
  __typename?: 'CourseBuilderV2_CourseLengthModuleOnly';
  /** Desired number of modules to generate */
  numModules: Scalars['Int'];
};

/** Course length specified using a range of modules */
export type CourseBuilderV2_CourseLengthModuleRange = {
  __typename?: 'CourseBuilderV2_CourseLengthModuleRange';
  /** Maximum number of modules to generate */
  maxModules: Scalars['Int'];
  /** Minimum number of modules to generate */
  minModules: Scalars['Int'];
};

/** Course length specified using number of modules */
export type CourseBuilderV2_CourseLengthModuleRangeInput = {
  /** Maximum number of modules to generate */
  maxModules: Scalars['Int'];
  /** Minimum number of modules to generate */
  minModules: Scalars['Int'];
};

/** Course length specified using a combination of hours and modules, a range of modules, or a single number of modules */
export type CourseBuilderV2_CourseLengthOption = CourseBuilderV2_CourseLength | CourseBuilderV2_CourseLengthModuleOnly | CourseBuilderV2_CourseLengthModuleRange;

/** Fields required when creating a new workflow for the first time */
export type CourseBuilderV2_CreateWorkflowInput = {
  /** The authoring branch the workflow is associated with */
  authoringBranchId: Scalars['ID'];
  /** The course the workflow is associated with */
  courseId: Scalars['ID'];
  /**
   * Primary language code associated with the parent course.
   * This is its own field because the workflow stores a denormalized copy of the language code for use
   * in curation, generation, etc. The source of truth for inputting the language code is moving to the
   * StartGeneratingCourseOutlineWithModulesAndLearningObjectivesInput directly so that the code can be updated after
   * creation
   */
  languageCode: Scalars['String'];
};

/** Item curated from another course */
export type CourseBuilderV2_CuratedItem = {
  __typename?: 'CourseBuilderV2_CuratedItem';
  /** ID of the underlying atom */
  atomId: Scalars['ID'];
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: Maybe<Scalars['String']>;
  /** Range specifing the start and end of an asset, if this asset was trimmed by the user */
  itemRange?: Maybe<CourseBuilderV2_ItemRange>;
  /** Item type of the curated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** Learning objectives derived from atom-summative-application */
  learningObjectives: Array<Scalars['String']>;
  /** Item name */
  name: Scalars['String'];
  /**
   * If multiple items were curated from the same course, this will point at the next curated item
   * from the course to ensure that the order of items is maintained
   */
  nextAtomId?: Maybe<Scalars['ID']>;
  /**
   * If multiple items were curated from the same course, this will point at the previous curated item
   * from the course to ensure that the order of items is maintained
   */
  previousAtomId?: Maybe<Scalars['ID']>;
  /**
   * Generated rationale explaining why a curated item was placed in a particular location within a
   * course outline. Set during the GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS step.
   */
  rationale?: Maybe<Scalars['String']>;
  /**
   * Search terms from which this item was curated, either during the initial
   * CURATING_ITEMS_FOR_LEARNING_OBJECTIVES step or as a result of manual user refinement
   */
  searchTerms?: Maybe<Array<Scalars['String']>>;
  /** ID of the source branch the atom was curated from */
  sourceAuthoringBranchId: Scalars['ID'];
  /** The course from which the item originated */
  sourceCourse: Course_Course;
  /** ID of the item in its source authoring branch. Added on 3/5/24, earlier curated items will not have this field */
  sourceItemId?: Maybe<Scalars['ID']>;
  /** Item summary */
  summary: Scalars['String'];
  /**
   * AI-assigned search terms associated with this item. As we pull in surrounding items when items
   * are curated, it's possible for tagged search terms to differ from the original input search
   * terms, so we track these separately for forensic purposes.
   */
  taggedSearchTerms?: Maybe<Array<Scalars['String']>>;
  /** Item time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Curated item input */
export type CourseBuilderV2_CuratedItemInput = {
  /** ID of the underlying atom */
  atomId: Scalars['ID'];
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: InputMaybe<Scalars['String']>;
  /** Range specifing the start and end for of the trim, if the user chose to edit the trim manually */
  itemRange?: InputMaybe<CourseBuilderV2_ItemRangeInput>;
  /** Item type of the curated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** Generated learning objectives from atom-summative-application */
  learningObjectives?: InputMaybe<Array<Scalars['String']>>;
  /** Item name */
  name: Scalars['String'];
  /** If multiple items are curated from the same course, this will point at the next item */
  nextAtomId?: InputMaybe<Scalars['ID']>;
  /** If multiple items are curated from the same course, this will point at the previous item */
  previousAtomId?: InputMaybe<Scalars['ID']>;
  /**
   * Generated rationale explaining why a curated item was placed in a particular location within a
   * course outline.
   */
  rationale?: InputMaybe<Scalars['String']>;
  /**
   * Search terms from which this item was curated, either during the initial
   * CURATING_ITEMS_FOR_LEARNING_OBJECTIVES step or as a result of manual user refinement
   */
  searchTerms?: InputMaybe<Array<Scalars['String']>>;
  /** ID of the source branch the atom was curated from */
  sourceAuthoringBranchId: Scalars['ID'];
  /** ID of the course from which the item originated */
  sourceCourseId: Scalars['ID'];
  /** ID of the item in its source authoring branch. Added on 3/5/24, earlier curated items will not have this field */
  sourceItemId?: InputMaybe<Scalars['ID']>;
  /** Item summary */
  summary: Scalars['String'];
  /**
   * AI-assigned search terms associated with this item. As we pull in surrounding items when items
   * are curated, it's possible for tagged search terms to differ from the original input search
   * terms, so we track these separately for forensic purposes.
   */
  taggedSearchTerms?: InputMaybe<Array<Scalars['String']>>;
  /** Item time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Page of CourseBuilderV2_CuratedItem results */
export type CourseBuilderV2_CuratedItemPaginatedResult = {
  __typename?: 'CourseBuilderV2_CuratedItemPaginatedResult';
  /** List of curated items */
  elements: Array<CourseBuilderV2_CuratedItem>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Lesson in a module returned from a curation search */
export type CourseBuilderV2_CuratedLesson = {
  __typename?: 'CourseBuilderV2_CuratedLesson';
  /** List of items in the lesson */
  items: Array<CourseBuilderV2_CurationRefinementOption>;
  /** Lesson ID */
  lessonId: Scalars['ID'];
  /** Lesson name */
  name: Scalars['String'];
};

/** Module returned from a curation search */
export type CourseBuilderV2_CuratedModule = {
  __typename?: 'CourseBuilderV2_CuratedModule';
  /** Module description */
  description: Scalars['String'];
  /**
   * List of items in the module
   * @deprecated Use nested `items` in `lessons` instead
   */
  items: Array<CourseBuilderV2_CurationRefinementOption>;
  /** Module learning objectives */
  learningObjectives: Array<Scalars['String']>;
  /** List of lessons in the module */
  lessons: Array<CourseBuilderV2_CuratedLesson>;
  /** Module ID */
  moduleId: Scalars['ID'];
  /** Module name */
  name: Scalars['String'];
  /** Source authoring course branch the module was curated from */
  sourceAuthoringCourseBranchId: Scalars['ID'];
  /** Source course the branch was curated from */
  sourceCourse: Course_Course;
  /** Source course branch the module was curated from */
  sourceCourseBranchId: Scalars['ID'];
  /** Time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Page of CourseBuilderV2_CuratedModule results */
export type CourseBuilderV2_CuratedModulePaginatedResult = {
  __typename?: 'CourseBuilderV2_CuratedModulePaginatedResult';
  /** List of curated modules */
  elements: Array<CourseBuilderV2_CuratedModule>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** User inputs used to specify curation behaviour */
export type CourseBuilderV2_CurationInputs = {
  __typename?: 'CourseBuilderV2_CurationInputs';
  /** Optional during rollout list of language codes to use for filtering content available for curation */
  curationLanguageCodes?: Maybe<Array<Scalars['String']>>;
  /** Enterprise program used to filter content available for curation */
  enterpriseProgram?: Maybe<EnterpriseProgram>;
  /**
   * Optional list of courses whose items will be prioritized when generating curation results.
   * Set during the GENERATING_SUGGESTED_CURATION_FILTERS step.
   */
  prioritizedCourses?: Maybe<Array<Course_Course>>;
};

/** An option for refining a curated item */
export type CourseBuilderV2_CurationRefinementOption = {
  __typename?: 'CourseBuilderV2_CurationRefinementOption';
  /** Atom ID */
  atomId: Scalars['ID'];
  /**
   * Optional override for the item type display name, eg. to display "Dialogue" or "Role Play" instead of "Coach Item"
   * in the UI
   */
  customDisplayTypenameOverride?: Maybe<Scalars['String']>;
  /** Item type */
  itemType: CourseBuilderV2_CourseItemType;
  /** Learning objectives derived from atom-summative-application */
  learningObjectives: Array<Scalars['String']>;
  /** Name */
  name: Scalars['String'];
  /** Source authoring branch the item was curated from */
  sourceAuthoringBranchId: Scalars['ID'];
  /** Source course the branch was curated from */
  sourceCourse: Course_Course;
  /** ID of the item in its source authoring branch */
  sourceItemId: Scalars['ID'];
  /** Summary */
  summary: Scalars['String'];
  /** Time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Page of CourseBuilderV2_CurationRefinementOption results */
export type CourseBuilderV2_CurationRefinementOptionPaginatedResult = {
  __typename?: 'CourseBuilderV2_CurationRefinementOptionPaginatedResult';
  /** List of refinement options */
  elements: Array<CourseBuilderV2_CurationRefinementOption>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Enum representing the difficulty level of the course for learners */
export const CourseBuilderV2_DifficultyLevel = {
  /** Advanced */
  Advanced: 'ADVANCED',
  /** Beginner */
  Beginner: 'BEGINNER',
  /** Intermediate */
  Intermediate: 'INTERMEDIATE'
} as const;

export type CourseBuilderV2_DifficultyLevel = typeof CourseBuilderV2_DifficultyLevel[keyof typeof CourseBuilderV2_DifficultyLevel];
/**
 * Error thrown if the workflow failed to embed atoms to a destination module, usually caused by
 * out of date embedding DB. Users would need to manually delete/replace the item and then
 * attempt to regenerate the course material.
 */
export type CourseBuilderV2_EmbedAtomsError = CourseBuilderV2_WorkflowError & {
  __typename?: 'CourseBuilderV2_EmbedAtomsError';
  /** List of atoms that failed to be embedded. */
  embedFailedAtoms?: Maybe<Array<CourseBuilderV2_EmbedFailedAtom>>;
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/** Embed failed Atom with atom ID and module key, that will be used in CourseBuilderV2_EmbedAtomsError. */
export type CourseBuilderV2_EmbedFailedAtom = {
  __typename?: 'CourseBuilderV2_EmbedFailedAtom';
  /** The id of atom that failed to be embedded. */
  embedFailedAtomId: Scalars['ID'];
  /** The key of module that contains atom failed to be embedded. */
  embedFailedModuleKey: Scalars['ID'];
};

/** Namespaced error interface */
export type CourseBuilderV2_Error = {
  /** Error message */
  message: Scalars['String'];
};

/** Error thrown if a LLM call failed due to the message exceeding the token limit supported by the LLM. */
export type CourseBuilderV2_ExceededTokenLimit = CourseBuilderV2_WorkflowError & {
  __typename?: 'CourseBuilderV2_ExceededTokenLimit';
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/** Fillable blanks, used to populate placeholders in question prompts */
export type CourseBuilderV2_FillableBlank = CourseBuilderV2_MultipleChoiceFillableBlank;

/** Input for a fillable blank */
export type CourseBuilderV2_FillableBlankInput = {
  /** Fillable blank populated by multiple choice options */
  multipleChoiceFillableBlank?: InputMaybe<CourseBuilderV2_MultipleChoiceFillableBlankInput>;
};

/** Any data for Assignment items that isn't already present in GeneratedAssetItem */
export type CourseBuilderV2_FullItemAdditionalAssignmentData = {
  __typename?: 'CourseBuilderV2_FullItemAdditionalAssignmentData';
  /** Configuration for assessment attempts */
  assessmentAttemptConfiguration?: Maybe<CourseBuilderV2_AssessmentAttemptConfiguration>;
  /** Assignment level rubrics */
  assignmentLevelRubrics?: Maybe<Array<CourseBuilderV2_RubricPart>>;
  /** Assignment segments */
  assignmentSegments: Array<CourseBuilderV2_AssignmentSegment>;
  /** Instructions for graders */
  graderInstructions?: Maybe<Scalars['String']>;
  /** Indicates if it is a team assignment */
  isTeamAssignment?: Maybe<Scalars['Boolean']>;
  /** Visibility of learner feedback post grade release */
  learnerFeedbackVisibility?: Maybe<CourseBuilderV2_LearnerPostreleaseVisibility>;
  /** Visibility of learner submission post submission */
  learnerSubmissionVisibility?: Maybe<CourseBuilderV2_LearnerPostsubmitVisibility>;
  /** Passing fraction */
  passingFraction?: Maybe<Scalars['Float']>;
  /** Review criteria */
  reviewCriteria?: Maybe<Scalars['String']>;
  /** Indicates if the grade should be shown on grade release */
  showGradeOnGradeRelease?: Maybe<Scalars['Boolean']>;
};

/** Any data for Assignment items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalAssignmentDataInput = {
  /** Configuration for assessment attempts */
  assessmentAttemptConfiguration?: InputMaybe<CourseBuilderV2_AssessmentAttemptConfigurationInput>;
  /** Assignment level rubrics */
  assignmentLevelRubrics?: InputMaybe<Array<CourseBuilderV2_RubricPartInput>>;
  /** Assignment segments */
  assignmentSegments: Array<CourseBuilderV2_AssignmentSegmentInput>;
  /** Instructions for graders */
  graderInstructions?: InputMaybe<Scalars['String']>;
  /** Indicates if it is a team assignment */
  isTeamAssignment?: InputMaybe<Scalars['Boolean']>;
  /** Visibility of learner feedback post grade release */
  learnerFeedbackVisibility?: InputMaybe<CourseBuilderV2_LearnerPostreleaseVisibility>;
  /** Visibility of learner submission post submission */
  learnerSubmissionVisibility?: InputMaybe<CourseBuilderV2_LearnerPostsubmitVisibility>;
  /** Passing fraction */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Review criteria */
  reviewCriteria?: InputMaybe<Scalars['String']>;
  /** Indicates if the grade should be shown on grade release */
  showGradeOnGradeRelease?: InputMaybe<Scalars['Boolean']>;
};

/**
 * A container for all data that is specific to a particular item type; some item types such as Reading don't require any additional data, so there will be no
 * field for such item types in this message.
 */
export type CourseBuilderV2_FullItemAdditionalData = CourseBuilderV2_FullItemAdditionalAssignmentData | CourseBuilderV2_FullItemAdditionalDiscussionPromptData | CourseBuilderV2_FullItemAdditionalLectureData | CourseBuilderV2_FullItemAdditionalWidgetData;

/**
 * A container for all data that is specific to a particular item type; some item types such as Reading don't require any additional data, so there will be no
 * field for such item types in this message.
 */
export type CourseBuilderV2_FullItemAdditionalDataInput = {
  /** Container for any data for a fully fleshed Assignment item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalAssignmentData?: InputMaybe<CourseBuilderV2_FullItemAdditionalAssignmentDataInput>;
  /** Container for any data for a fully fleshed Discussion Prompt item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalDiscussionPromptData?: InputMaybe<CourseBuilderV2_FullItemAdditionalDiscussionPromptDataInput>;
  /** Container for any data for a fully fleshed Lecture item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalLectureData?: InputMaybe<CourseBuilderV2_FullItemAdditionalLectureDataInput>;
  /** Container for any data for a fully fleshed Widget item that isn't already present in GeneratedAssetItemInput */
  fullItemAdditionalWidgetData?: InputMaybe<CourseBuilderV2_FullItemAdditionalWidgetDataInput>;
};

/** Any data for Discussion Prompt items that isn't already present in GeneratedAssetItem */
export type CourseBuilderV2_FullItemAdditionalDiscussionPromptData = {
  __typename?: 'CourseBuilderV2_FullItemAdditionalDiscussionPromptData';
  /** The prompt for the discussion */
  prompt: Scalars['String'];
  /** The title for the discussion prompt */
  title: Scalars['String'];
};

/** Any data for Discussion Prompt items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalDiscussionPromptDataInput = {
  /** The prompt for the discussion */
  prompt: Scalars['String'];
  /** The title for the discussion prompt */
  title: Scalars['String'];
};

/** Any data for Lecture items that isn't already present in GeneratedAssetItem */
export type CourseBuilderV2_FullItemAdditionalLectureData = {
  __typename?: 'CourseBuilderV2_FullItemAdditionalLectureData';
  /** List of language codes and subtitle asset IDs for those languages */
  languageSubtitleAssetIds: Array<CourseBuilderV2_LanguageSubtitleAssetId>;
};

/** Any data for Lecture items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalLectureDataInput = {
  /** List of language codes and subtitle asset IDs for those languages */
  languageSubtitleAssetIds: Array<CourseBuilderV2_LanguageSubtitleAssetIdInput>;
};

/** Any data for Widget items that isn't already present in GeneratedAssetItem */
export type CourseBuilderV2_FullItemAdditionalWidgetData = {
  __typename?: 'CourseBuilderV2_FullItemAdditionalWidgetData';
  /** Configuration of the widget with fields which are tied to the used widget ID */
  configuration: Scalars['JSON'];
  /** Title of the iframe hosting the plugin in the UI */
  iframeTitle: Scalars['String'];
  /**
   * Do note use. Captures the broad categories of widgets that can be extracted from source content
   * @deprecated widget categories are internal to the backend distillation step and should not be relied upon by clients. Use the widgetid instead where needed.
   */
  widgetCategory: CourseBuilderV2_WidgetCategory;
  /** Coursera widget ID identifying the widget that is used for this item */
  widgetId: Scalars['ID'];
};

/** Any data for Widget items that isn't already present in GeneratedAssetItemInput */
export type CourseBuilderV2_FullItemAdditionalWidgetDataInput = {
  /** Configuration of the widget with fields which are tied to the used widget ID */
  configuration: Scalars['JSON'];
  /** Title of the iframe hosting the plugin in the UI */
  iframeTitle: Scalars['String'];
  /**
   * Captures the broad categories of widgets that can be extracted from source content
   * @deprecated widget categories are internal to the backend distillation step and should not be relied upon by clients. Use the widgetId instead where needed.
   */
  widgetCategory?: InputMaybe<CourseBuilderV2_WidgetCategory>;
  /** Coursera widget ID identifying the widget that is used for this item */
  widgetId: Scalars['ID'];
};

/** Generate assessment outline item input */
export type CourseBuilderV2_GenerateAssessmentOutlineItemInput = {
  /** attempt configuration of the assessment */
  attemptConfiguration: CourseBuilderV2_AssessmentAttemptConfigurationInput;
};

/** CourseBuilderV2_GenerateAssessmentsOutline mutation input */
export type CourseBuilderV2_GenerateAssessmentsOutlineItemsInput = {
  /**
   * Generate final exam assessments
   * Can be null if no final exam is needed
   */
  finalExam?: InputMaybe<CourseBuilderV2_GenerateAssessmentOutlineItemInput>;
  /**
   * Generate module quiz assessments
   * Can be null if no module quizzes are needed
   */
  moduleQuiz?: InputMaybe<CourseBuilderV2_GenerateAssessmentOutlineItemInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectives mutation result */
export type CourseBuilderV2_GenerateAssessmentsOutlineItemsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Generated assessment outline item input */
export type CourseBuilderV2_GeneratedAssessmentOutlineItemInput = {
  /** Type of this assessment; either module quiz or final exam */
  assessmentOutlineType: CourseBuilderV2_AssessmentOutlineType;
  /** attempt configuration of the assessment */
  attemptConfiguration: CourseBuilderV2_AssessmentAttemptConfigurationInput;
  /** when true: it is a graded assignment; when false: it is a practice assignment */
  isGraded: Scalars['Boolean'];
  /** Item type of the curated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** name of the assessment */
  name: Scalars['String'];
  /** question generation configuration of the assessment */
  questionGenerationConfiguration: CourseBuilderV2_AssessmentGenerationConfigurationInput;
  /** specifies whether the assessment outline has been reviewed by the author */
  reviewed: Scalars['Boolean'];
};

/** Generated items created from input files */
export type CourseBuilderV2_GeneratedAssetItem = {
  __typename?: 'CourseBuilderV2_GeneratedAssetItem';
  /**
   * ID for a generated asset item, if the item is unchanged this refers to the original uploaded
   * asset. For asset items that have been split corresponds to {originalAssetId}~{hashOfSplitRange}
   */
  assetId: Scalars['ID'];
  /**
   * With the introduction of Smart Ingestion, it is possible that some items will actually not be
   * generated by AI but ingested almost verbatim from user provided content; this field will help
   * track that on item level, allowing further manipulation by AI on ingested items to be tracked.
   */
  atomGenerationSource: CourseBuilderV2_AtomGenerationSource;
  /** S3 path of the extracted file content in textual form */
  contentPath: Scalars['String'];
  /**
   * If full item data is required by the current workflow type, this field will be populated with
   * it for the appropriate item type.
   */
  fullItemAdditionalData?: Maybe<CourseBuilderV2_FullItemAdditionalData>;
  /** Atom id that corresponds to the item that was created as a part of this generated asset. */
  generatedAtomId?: Maybe<Scalars['ID']>;
  /** Range specifing the start and end for the split, if this item was part of an auto-split asset */
  itemRange?: Maybe<CourseBuilderV2_ItemRange>;
  /** Item type of the generated item */
  itemType: CourseBuilderV2_CourseItemType;
  /** A key to uniquely identify this item; optional since not all flows use this field */
  key?: Maybe<Scalars['String']>;
  /** Generated item name */
  name: Scalars['String'];
  /** ID of the original input asset used to generate this item, present when an item has been split */
  originalAssetId?: Maybe<Scalars['ID']>;
  /** Time commitment of the original asset */
  originalTimeCommitment?: Maybe<Scalars['Duration']>;
  /**
   * Generated rationale explaining why a generated asset item was placed in a particular location
   * within a course outline. Set during the GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS step.
   */
  rationale?: Maybe<Scalars['String']>;
  /** Generated item summary */
  summary: Scalars['String'];
  /** Time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Generated asset item input */
export type CourseBuilderV2_GeneratedAssetItemInput = {
  /**
   * ID for a generated asset item, if the item is unchanged this refers to the original uploaded
   * asset. For asset items that have been split corresponds to {originalAssetId}~{hashOfSplitRange}
   */
  assetId: Scalars['ID'];
  /**
   * With the introduction of Smart Ingestion, it is possible that some items will actually not be
   * generated by AI but ingested almost verbatim from user provided content; this field will help
   * track that on item level, allowing further manipulation by AI on ingested items to be tracked.
   */
  atomGenerationSource?: InputMaybe<CourseBuilderV2_AtomGenerationSource>;
  /** S3 path of extracted file content in textual form */
  contentPath: Scalars['String'];
  /**
   * If full item data is required by the current workflow type, this field will be populated with
   * it for the appropriate item type.
   */
  fullItemAdditionalData?: InputMaybe<CourseBuilderV2_FullItemAdditionalDataInput>;
  /** Atom id that corresponds to the item that was created as a part of this generated asset. */
  generatedAtomId?: InputMaybe<Scalars['ID']>;
  /** Range specifying the start and end for the split, if the user chose to edit the split manually */
  itemRange?: InputMaybe<CourseBuilderV2_ItemRangeInput>;
  /** Assigned item type, based on the input file format. */
  itemType: CourseBuilderV2_CourseItemType;
  /** A key to uniquely identify this item; optional since not all flows use this field */
  key?: InputMaybe<Scalars['String']>;
  /** Generated item name */
  name: Scalars['String'];
  /** ID of the original input asset used to generate this item, present when an item has been split */
  originalAssetId?: InputMaybe<Scalars['ID']>;
  /** Time commitment of the original asset */
  originalTimeCommitment?: InputMaybe<Scalars['Duration']>;
  /**
   * Generated rationale explaining why a generated asset item was placed in a particular location
   * within a course outline.
   */
  rationale?: InputMaybe<Scalars['String']>;
  /** Generated item summary */
  summary: Scalars['String'];
  /** Time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Generated course metadata */
export type CourseBuilderV2_GeneratedCourseMetadata = {
  __typename?: 'CourseBuilderV2_GeneratedCourseMetadata';
  /** Generated course description */
  description: Scalars['String'];
  /** Generated course difficulty level */
  difficultyLevel?: Maybe<CourseBuilderV2_DifficultyLevel>;
  /**
   * Generated course domain and subdomain pairs. Note: it is possible for the same course to have
   * multiple domain types with the same domain as long as the subdomains are unique.
   */
  domainTypes: Array<CourseBuilderV2_CourseDomainType>;
  /** Generated course estimated workload */
  estimatedWorkload?: Maybe<Scalars['String']>;
  /** Generated course name */
  name: Scalars['String'];
  /** Recommended learner background for the generated course */
  recommendedBackground?: Maybe<Scalars['String']>;
  /** Generated course skill tags */
  skills: Array<Scalars['String']>;
  /** What you will learn section of the generated course */
  whatYouWillLearn?: Maybe<Array<Scalars['String']>>;
};

/** Graded text box rubric part */
export type CourseBuilderV2_GradedTextBoxRubricPart = {
  __typename?: 'CourseBuilderV2_GradedTextBoxRubricPart';
  /** Prompt for the rubric part which supports CML */
  partPrompt: Scalars['String'];
  /** Points for the rubric part */
  points: Scalars['Float'];
};

/** Input for a graded text box rubric part */
export type CourseBuilderV2_GradedTextBoxRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
  /** Points value for the rubric */
  points: Scalars['Float'];
};

/** Inline feedback rubric part */
export type CourseBuilderV2_InlineFeedbackRubricPart = {
  __typename?: 'CourseBuilderV2_InlineFeedbackRubricPart';
  /** Prompt for the rubric part which supports CML */
  partPrompt: Scalars['String'];
};

/** Input for an inline feedback rubric part */
export type CourseBuilderV2_InlineFeedbackRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** User file inputs used to generate course item contents, such as videos */
export type CourseBuilderV2_InputAsset = {
  __typename?: 'CourseBuilderV2_InputAsset';
  /** ID of the input file asset */
  assetId: Scalars['ID'];
  /** ID of the associated Airflow job used to process an asset, if any */
  inputProcessingTaskId?: Maybe<Scalars['ID']>;
  /** Item type of the generated item, so that FE can easily tell which assets are for which item type */
  itemType?: Maybe<CourseBuilderV2_CourseItemType>;
};

/** Union of all the different types of item ranges for auto-split items */
export type CourseBuilderV2_ItemRange = CourseBuilderV2_CmlRange | CourseBuilderV2_PageRange | CourseBuilderV2_TimestampRange;

/** Union of all the different types of item ranges for auto-split items */
export type CourseBuilderV2_ItemRangeInput = {
  /** Range specifing the start and end pages for split text and docx files */
  cmlRange?: InputMaybe<CourseBuilderV2_CmlRangeInput>;
  /** Range specifing the start and end pages for split PDFs */
  pageRange?: InputMaybe<CourseBuilderV2_PageRangeInput>;
  /** Range specifing the start and end timestamps for split/trimmed videos */
  timestampRange?: InputMaybe<CourseBuilderV2_TimestampRangeInput>;
};

/** The mapping between item and skills */
export type CourseBuilderV2_ItemSkillMapping = {
  __typename?: 'CourseBuilderV2_ItemSkillMapping';
  /** Item id */
  itemId: Scalars['ID'];
  /** Mapping value */
  value: CourseBuilderV2_ItemSkillMappingFields;
};

/** Mapping fields */
export type CourseBuilderV2_ItemSkillMappingFields = {
  __typename?: 'CourseBuilderV2_ItemSkillMappingFields';
  /** The programming language ids */
  programmingLanguageIds: Array<Scalars['ID']>;
  /** The skill expressions */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
  /** The tool ids */
  toolIds: Array<Scalars['ID']>;
  /** The skill content type */
  verifiedSkillsContentType: CourseBuilderV2_VerifiedSkillsContentType;
};

/** Mapping fields */
export type CourseBuilderV2_ItemSkillMappingFieldsInput = {
  /** The programming language ids */
  programmingLanguageIds: Array<Scalars['ID']>;
  /** The skill expressions IDs */
  skillExpressionIds: Array<Scalars['ID']>;
  /** The tool ids */
  toolIds: Array<Scalars['ID']>;
  /** The skill content type */
  verifiedSkillsContentType: CourseBuilderV2_VerifiedSkillsContentType;
};

/** The mapping between item and skills input */
export type CourseBuilderV2_ItemSkillMappingInput = {
  /** Item id */
  itemId: Scalars['ID'];
  /** Mapping value */
  value: CourseBuilderV2_ItemSkillMappingFieldsInput;
};

/** Language code and the subtitle asset ID for that language fields */
export type CourseBuilderV2_LanguageSubtitleAssetId = {
  __typename?: 'CourseBuilderV2_LanguageSubtitleAssetId';
  /** Asset ID for the subtitle asset in the designated language */
  assetId: Scalars['ID'];
  /** Language code (e.g., en, fr, es) */
  languageCode: Scalars['String'];
};

/** Language code and the subtitle asset ID for that language input fields */
export type CourseBuilderV2_LanguageSubtitleAssetIdInput = {
  /** Asset ID for the subtitle asset in the designated language */
  assetId: Scalars['ID'];
  /** Language code (e.g., en, fr, es) */
  languageCode: Scalars['String'];
};

/** Visibility of learner feedback post grade release */
export const CourseBuilderV2_LearnerPostreleaseVisibility = {
  /** Grade is fully visible post grade release */
  LearnerPostreleaseVisibilityFull: 'LEARNER_POSTRELEASE_VISIBILITY_FULL',
  /** Grade is not visible post grade release */
  LearnerPostreleaseVisibilityLimited: 'LEARNER_POSTRELEASE_VISIBILITY_LIMITED',
  /** Grade is partially visible post grade release */
  LearnerPostreleaseVisibilityPartial: 'LEARNER_POSTRELEASE_VISIBILITY_PARTIAL'
} as const;

export type CourseBuilderV2_LearnerPostreleaseVisibility = typeof CourseBuilderV2_LearnerPostreleaseVisibility[keyof typeof CourseBuilderV2_LearnerPostreleaseVisibility];
/** Visibility of learner submission post submission */
export const CourseBuilderV2_LearnerPostsubmitVisibility = {
  /** Submission is hidden post submission */
  LearnerPostsubmitVisibilityHidden: 'LEARNER_POSTSUBMIT_VISIBILITY_HIDDEN',
  /** Submission is visible post submission */
  LearnerPostsubmitVisibilityVisible: 'LEARNER_POSTSUBMIT_VISIBILITY_VISIBLE'
} as const;

export type CourseBuilderV2_LearnerPostsubmitVisibility = typeof CourseBuilderV2_LearnerPostsubmitVisibility[keyof typeof CourseBuilderV2_LearnerPostsubmitVisibility];
/** Manual graded question */
export type CourseBuilderV2_ManualGradedQuestion = {
  __typename?: 'CourseBuilderV2_ManualGradedQuestion';
  /** Whether the question is an ai-graded question or graded by a human. If none is present, it is human graded. */
  graderType?: Maybe<CourseBuilderV2_ManualGradedQuestionGraderType>;
  /** Whether plagiarism detection is enabled for the question */
  plagiarismDetection: Scalars['Boolean'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Response type for the question */
  responseType: CourseBuilderV2_ManualGradedQuestionResponseType;
  /** List of grading rubrics for the question */
  rubrics: Array<CourseBuilderV2_RubricPart>;
};

/** Indicates how this question should be graded */
export const CourseBuilderV2_ManualGradedQuestionGraderType = {
  /** graded by AI */
  Ai: 'AI',
  /** Graded by teaching staff (manually graded) */
  Human: 'HUMAN'
} as const;

export type CourseBuilderV2_ManualGradedQuestionGraderType = typeof CourseBuilderV2_ManualGradedQuestionGraderType[keyof typeof CourseBuilderV2_ManualGradedQuestionGraderType];
/** Input for a manually graded question */
export type CourseBuilderV2_ManualGradedQuestionInput = {
  /** Whether the question is an ai-graded question or graded by a human. If none is present, it is human graded. */
  graderType?: InputMaybe<CourseBuilderV2_ManualGradedQuestionGraderType>;
  /** Whether plagiarism detection is enabled for the question */
  plagiarismDetection: Scalars['Boolean'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Response type for the question */
  responseType: CourseBuilderV2_ManualGradedQuestionResponseType;
  /** List of grading rubrics for the question */
  rubrics: Array<CourseBuilderV2_RubricPartInput>;
};

/** Manual graded question response type */
export const CourseBuilderV2_ManualGradedQuestionResponseType = {
  /** File upload response type */
  FileUpload: 'FILE_UPLOAD',
  /** No submission response type */
  NoSubmission: 'NO_SUBMISSION',
  /** Rich text response type */
  RichText: 'RICH_TEXT',
  /** URL response type */
  Url: 'URL'
} as const;

export type CourseBuilderV2_ManualGradedQuestionResponseType = typeof CourseBuilderV2_ManualGradedQuestionResponseType[keyof typeof CourseBuilderV2_ManualGradedQuestionResponseType];
/** Math expression question */
export type CourseBuilderV2_MathExpressionQuestion = {
  __typename?: 'CourseBuilderV2_MathExpressionQuestion';
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectness>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a math expression question */
export type CourseBuilderV2_MathExpressionQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Module learning objective */
export type CourseBuilderV2_ModuleLearningObjective = {
  __typename?: 'CourseBuilderV2_ModuleLearningObjective';
  /** Flag denoting that a learning objective was AI-generated. */
  aiGenerated: Scalars['Boolean'];
  /** Unique key for this learning objective, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** The learning objective */
  learningObjective: Scalars['String'];
  /**
   * Optional list of curated items matching one of this learning objective's search terms, or one
   * of the items surrounding a search result. Set during the CURATING_ITEMS_FOR_LEARNING_OBJECTIVES
   * step.
   */
  matchingCuratedItems?: Maybe<Array<CourseBuilderV2_CuratedItem>>;
  /**
   * Optional list of generated asset items matching this learning objective. Set during the
   * TAGGING_GENERATED_ITEMS_WITH_LEARNING_OBJECTIVES step.
   */
  matchingGeneratedItems?: Maybe<Array<CourseBuilderV2_GeneratedAssetItem>>;
  /**
   * Optional list of curated items retained from a previous iteration matching this learning
   * objective. Set during the TAGGING_RETAINED_CURATED_ITEMS_WITH_LEARNING_OBJECTIVES step.
   */
  matchingRetainedCuratedItems?: Maybe<Array<CourseBuilderV2_CuratedItem>>;
  /**
   * Optional list of search terms that will be used to curate items for this learning objective.
   * Set during the GENERATING_SEARCH_TERMS step.
   */
  searchTerms?: Maybe<Array<Scalars['String']>>;
};

/** Module learning objective input */
export type CourseBuilderV2_ModuleLearningObjectiveInput = {
  /** Flag denoting that a learning objective was AI-generated. */
  aiGenerated?: Scalars['Boolean'];
  /** Unique key for this learning objective, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** The learning objective */
  learningObjective: Scalars['String'];
  /**
   * Optional list of curated items matching one of this learning objective's search terms, or one of
   * the items surrounding a search result.
   */
  matchingCuratedItems?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Optional list of generated asset items matching this learning objective */
  matchingGeneratedItems?: InputMaybe<Array<CourseBuilderV2_GeneratedAssetItemInput>>;
  /** Optional list of curated items retained from a previous iteration matching this learning objective */
  matchingRetainedCuratedItems?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Optional list of search terms that will be used to curate items for this learning objective */
  searchTerms?: InputMaybe<Array<Scalars['String']>>;
};

/** Skill, which is learned competencies */
export type CourseBuilderV2_ModuleSkillMetadata = {
  __typename?: 'CourseBuilderV2_ModuleSkillMetadata';
  /** The mapping between item and skills, this field will always be null for now since the item level module mapping is not supported yet. */
  itemMappings?: Maybe<Array<CourseBuilderV2_ItemSkillMapping>>;
  /** The programming language used in this skill. */
  programmingLanguages: Array<Scalars['String']>;
  /** A discrete, observable, and measurable capability that enables a person to perform a specific task or function. */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
  /** The tools envolved in the skill */
  tools: Array<Scalars['String']>;
};

/** Module skill metadata input */
export type CourseBuilderV2_ModuleSkillMetadataInput = {
  /** The mapping between item and skills, this field will always be null for now since the item level module mapping is not supported yet. */
  itemMappings?: InputMaybe<Array<CourseBuilderV2_ItemSkillMappingInput>>;
  /** The programming language used in this skill. */
  programmingLanguages?: InputMaybe<Array<Scalars['String']>>;
  /** A discrete, observable, and measurable capability that enables a person to perform a specific task or function. */
  skillExpressionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The tools envolved in the skill */
  tools?: InputMaybe<Array<Scalars['String']>>;
};

/** Fillable blank populated by multiple choice options */
export type CourseBuilderV2_MultipleChoiceFillableBlank = {
  __typename?: 'CourseBuilderV2_MultipleChoiceFillableBlank';
  /** List of answer options with IDs */
  answers: Array<CourseBuilderV2_AnswerOptionWithId>;
  /** The id of the correct answer option in the list of answers */
  correctAnswerOptionId: Scalars['ID'];
  /** ID of the fillable blank */
  id: Scalars['ID'];
};

/** Input for a fillable blank populated by multiple choice options */
export type CourseBuilderV2_MultipleChoiceFillableBlankInput = {
  /** List of answer options with IDs */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** The id of the correct answer option in the list of answers */
  correctAnswerOptionId: Scalars['ID'];
  /** ID of the fillable blank */
  id: Scalars['ID'];
};

/** Multiple choice question */
export type CourseBuilderV2_MultipleChoiceQuestion = {
  __typename?: 'CourseBuilderV2_MultipleChoiceQuestion';
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectness>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice question */
export type CourseBuilderV2_MultipleChoiceQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Multiple choice reflect question */
export type CourseBuilderV2_MultipleChoiceReflectQuestion = {
  __typename?: 'CourseBuilderV2_MultipleChoiceReflectQuestion';
  /** List of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithId>;
  /** Feedback for the question when none of the listed answers is chosen */
  noChosenFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflect question */
export type CourseBuilderV2_MultipleChoiceReflectQuestionInput = {
  /** List of answer options with IDs (IDs are ignored for this question because this is a reflection question) */
  answers: Array<CourseBuilderV2_AnswerOptionWithIdInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  noChosenFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Multiple dropdown question */
export type CourseBuilderV2_MultipleDropdownQuestion = {
  __typename?: 'CourseBuilderV2_MultipleDropdownQuestion';
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** placeholders for dropdown questions */
  fillableBlanks: Array<CourseBuilderV2_FillableBlank>;
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: Maybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML, and contains fillable blanks */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple dropdown question */
export type CourseBuilderV2_MultipleDropdownQuestionInput = {
  /** Award some points when some correct answers are selected */
  allowPartialScoring: Scalars['Boolean'];
  /** Placeholders for dropdown questions */
  fillableBlanks: Array<CourseBuilderV2_FillableBlankInput>;
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: InputMaybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML, and contains fillable blanks */
  prompt: Scalars['String'];
  /** Shuffle answer options for every attempt */
  shuffleOptions: Scalars['Boolean'];
};

/** Common failure type for Course Builder mutations */
export type CourseBuilderV2_MutationFailure = {
  __typename?: 'CourseBuilderV2_MutationFailure';
  /** List of errors */
  errors: Array<CourseBuilderV2_ConflictError>;
};

/** Common success type for Course Builder mutations */
export type CourseBuilderV2_MutationSuccess = {
  __typename?: 'CourseBuilderV2_MutationSuccess';
  /** The updated workflow */
  workflow: CourseBuilderV2_Workflow;
};

/**
 * Error encompassing various types of upstream network failures. Workflows can typically recover from such errors by
 * retrying the failed step.
 */
export type CourseBuilderV2_NetworkError = CourseBuilderV2_WorkflowError & {
  __typename?: 'CourseBuilderV2_NetworkError';
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/** Numeric answer */
export type CourseBuilderV2_NumericAnswer = CourseBuilderV2_RangeNumericAnswer | CourseBuilderV2_ValueNumericAnswer;

/** Input for a numeric answer */
export type CourseBuilderV2_NumericAnswerInput = {
  /** Range numeric answer */
  rangeAnswer?: InputMaybe<CourseBuilderV2_RangeNumericAnswerInput>;
  /** Value numeric answer */
  valueAnswer?: InputMaybe<CourseBuilderV2_ValueNumericAnswerInput>;
};

/** Numeric question */
export type CourseBuilderV2_NumericQuestion = {
  __typename?: 'CourseBuilderV2_NumericQuestion';
  /** List of numeric answer options */
  answers: Array<CourseBuilderV2_NumericAnswer>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a numeric question */
export type CourseBuilderV2_NumericQuestionInput = {
  /** List of numeric answer options */
  answers: Array<CourseBuilderV2_NumericAnswerInput>;
  /** Feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Options rubric part */
export type CourseBuilderV2_OptionsRubricPart = {
  __typename?: 'CourseBuilderV2_OptionsRubricPart';
  /** Options for the rubric part */
  options: Array<CourseBuilderV2_RubricOption>;
  /** Prompt for the rubric part which supports CML */
  partPrompt: Scalars['String'];
};

/** Input for an options rubric part */
export type CourseBuilderV2_OptionsRubricPartInput = {
  /** Rubric options */
  options: Array<CourseBuilderV2_RubricOptionInput>;
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** User inputs used to generate the course outline */
export type CourseBuilderV2_OutlineInputs = {
  __typename?: 'CourseBuilderV2_OutlineInputs';
  /** Description of the learners expected to take the course */
  audience: Scalars['String'];
  /**
   * Desired course length
   * @deprecated Use courseLengthOption instead
   */
  courseLength?: Maybe<CourseBuilderV2_CourseLength>;
  /** Desired course length that can be one of several possible definitions */
  courseLengthOption?: Maybe<CourseBuilderV2_CourseLengthOption>;
  /** Item types specified by the user that the outline generation from scratch job will create. */
  itemTypesToGenerate?: Maybe<Array<CourseBuilderV2_CourseItemType>>;
  /** Text describing outcomes or skills learners should get from taking the course */
  learningObjectives: Scalars['String'];
  /** Text describing topics to generate a course about */
  topics: Scalars['String'];
};

/** Course outline lesson */
export type CourseBuilderV2_OutlineLesson = {
  __typename?: 'CourseBuilderV2_OutlineLesson';
  /** List of items in the lesson. */
  items: Array<CourseBuilderV2_CourseItem>;
  /**
   * Unique key for this lesson, used by the FE to optimize list rendering.
   * Optional for backwards compatibility as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  key?: Maybe<Scalars['ID']>;
  /**
   * Lesson name.
   * Optional for backwards compatiblity as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  name?: Maybe<Scalars['String']>;
};

/** Lesson input */
export type CourseBuilderV2_OutlineLessonInput = {
  /** List of items in the lesson. */
  items: Array<CourseBuilderV2_CourseItemInput>;
  /**
   * Unique key for this lesson, used by the FE to optimize list rendering.
   * Optional for backwards compatibility as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  key?: InputMaybe<Scalars['ID']>;
  /**
   * Lesson name.
   * Optional for backwards compatiblity as lessons were not modeled in Course Builder until module reuse was introduced in Q2 2024.
   */
  name?: InputMaybe<Scalars['String']>;
};

/** Course outline module */
export type CourseBuilderV2_OutlineModule = {
  __typename?: 'CourseBuilderV2_OutlineModule';
  /** Approximate length in minutes */
  approximateLengthInMinutes: Scalars['Int'];
  /** Module description */
  description: Scalars['String'];
  /**
   * Optional list of course items that will be placed in this module. Set during the
   * GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS step.
   * @deprecated Use lessons instead
   */
  items?: Maybe<Array<CourseBuilderV2_CourseItem>>;
  /** Unique key for this module, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** Module learning objectives */
  learningObjectives: Array<CourseBuilderV2_ModuleLearningObjective>;
  /**
   * Optional list of lessons that will be placed in this module. Set during the
   * GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS step,
   * or included from the beginning for the syllabus upload and full course reuse flows.
   */
  lessons?: Maybe<Array<CourseBuilderV2_OutlineLesson>>;
  /** Module name */
  name: Scalars['String'];
  /** The skillmetadata tagged to the module */
  skillMetadata?: Maybe<CourseBuilderV2_ModuleSkillMetadata>;
  /**
   * [TODO - AUTHORING-7640] The following two fields can be removed once the FE no longer
   * relies on them during the workflow module recommendation process.
   *
   * The course from which the module originated if it was manually curated
   */
  sourceCourse?: Maybe<Course_Course>;
  /** ID of the source branch the module originated from if it was manually curated */
  sourceCourseBranchId?: Maybe<Scalars['ID']>;
  /** Computed field listing all the source courses from which items in the module originated */
  sourceCourses?: Maybe<Array<Course_Course>>;
};

/** Outline module input */
export type CourseBuilderV2_OutlineModuleInput = {
  /** Approximate length in minutes */
  approximateLengthInMinutes: Scalars['Int'];
  /** Module description */
  description: Scalars['String'];
  /**
   * Optional list of course items that will be placed in this module
   * @deprecated Use `lessons` instead
   */
  items?: InputMaybe<Array<CourseBuilderV2_CourseItemInput>>;
  /** Unique key for this module, used by the FE to optimize list rendering */
  key: Scalars['ID'];
  /** Module learning objectives */
  learningObjectives: Array<CourseBuilderV2_ModuleLearningObjectiveInput>;
  /** Optional list of lessons that will be placed in this module */
  lessons?: InputMaybe<Array<CourseBuilderV2_OutlineLessonInput>>;
  /** Module name */
  name: Scalars['String'];
  /** The skillmetadata tagged to the module */
  skillMetadata?: InputMaybe<CourseBuilderV2_ModuleSkillMetadataInput>;
};

/** Page of CourseBuilderV2_Module curation results */
export type CourseBuilderV2_OutlineModulePaginatedResult = {
  __typename?: 'CourseBuilderV2_OutlineModulePaginatedResult';
  /** List of curation options */
  elements: Array<CourseBuilderV2_OutlineModule>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Range specifing the start and end pages for split PDFs */
export type CourseBuilderV2_PageRange = {
  __typename?: 'CourseBuilderV2_PageRange';
  /** End page number */
  endPage: Scalars['Int'];
  /** Start page number */
  startPage: Scalars['Int'];
};

/** Range specifing the start and end pages for split PDFs */
export type CourseBuilderV2_PageRangeInput = {
  /** End page number */
  endPage: Scalars['Int'];
  /** Start page number */
  startPage: Scalars['Int'];
};

/**
 * Placeholder for an item that must either be manually authored by the user, or created with AI generation. In the AI
 * curation flow, placeholders can be created from search terms for which no matching items could be curated, while other
 * workflows may create placeholder items directly.
 */
export type CourseBuilderV2_PlaceholderItem = {
  __typename?: 'CourseBuilderV2_PlaceholderItem';
  /**
   * Content generated for the placeholder item based on the generationParameters. As of December 2025, required inputs for
   * various item types' generation APIs are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generatedContent?: Maybe<Scalars['JSON']>;
  /**
   * User-editable parameters that will be used as inputs to generate the item content, if present. As of December 2025,
   * the exact parameters for each item type are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generationParameters?: Maybe<Scalars['JSON']>;
  /** Item level learning objective for which this item is meant to fulfill */
  itemLevelLearningObjective?: Maybe<Scalars['String']>;
  /** Item type to generate */
  itemType: CourseBuilderV2_CourseItemType;
  /** Unique key for this placeholder item, used by FE to distinguish between placeholder items sharing the same name. */
  key?: Maybe<Scalars['ID']>;
  /** Name of item */
  name: Scalars['String'];
  /** Generated rationale explaining why a generated item was placed in a particular location within a course outline */
  rationale?: Maybe<Scalars['String']>;
  /**
   * Search term for which a curated item could not be found, resulting in this placeholder item
   * @deprecated Use `itemLevelLearningObjective` instead
   */
  searchTerm: Scalars['String'];
  /** Generated item summary */
  summary?: Maybe<Scalars['String']>;
};

/** Placeholder item input */
export type CourseBuilderV2_PlaceholderItemInput = {
  /**
   * Content generated for the placeholder item based on the generationParameters. As of December 2025, required inputs for
   * various item types' generation APIs are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generatedContent?: InputMaybe<Scalars['JSON']>;
  /**
   * User-editable parameters that will be used as inputs to generate the item content, if present. As of December 2025,
   * the exact parameters for each item type are not yet finalized, so we're using a generic JSON object for flexibility.
   * Long-term, we may migrate to a more strongly-typed representation.
   */
  generationParameters?: InputMaybe<Scalars['JSON']>;
  /** Item level learning objective for which this item is meant to fulfill */
  itemLevelLearningObjective?: InputMaybe<Scalars['String']>;
  /** Item type to generate */
  itemType: CourseBuilderV2_CourseItemType;
  /** Unique key for this placeholder item, used by FE to distinguish between placeholder items sharing the same name. */
  key?: InputMaybe<Scalars['ID']>;
  /** Name of item */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Search term for which a curated item could not be found, resulting in this placeholder item
   * @deprecated Use `itemLevelLearningObjective` instead
   */
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** A recommendation for where to insert a placeholder item in a course outline */
export type CourseBuilderV2_PlaceholderRecommendation = {
  __typename?: 'CourseBuilderV2_PlaceholderRecommendation';
  /** The type of item to generate */
  itemType: CourseBuilderV2_CourseItemType;
  /** The unique identifier of the module where the placeholder should be inserted */
  moduleKey: Scalars['String'];
  /**
   * The zero-based index position where the placeholder should be inserted in the module's item list.
   * This position is a snapshot at the time of gap analysis (before any placeholders are inserted).
   * When applying multiple recommendations for the same module, they must be applied in descending
   * position order to maintain validity.
   */
  positionWithoutPlaceholders: Scalars['Int'];
  /** Explanation of why this placeholder item is needed */
  reasoning: Scalars['String'];
};

/** Corresponds to the productDifficultyLevel facet in search_hit.proto */
export const CourseBuilderV2_ProductDifficultyLevel = {
  /** Corresponds to facet value "productDifficultyLevel:Advanced" */
  Advanced: 'ADVANCED',
  /** Corresponds to facet value "productDifficultyLevel:Beginner" */
  Beginner: 'BEGINNER',
  /** Corresponds to facet value "productDifficultyLevel:Intermediate" */
  Intermediate: 'INTERMEDIATE',
  /** Corresponds to facet value "productDifficultyLevel:Mixed" */
  Mixed: 'MIXED'
} as const;

export type CourseBuilderV2_ProductDifficultyLevel = typeof CourseBuilderV2_ProductDifficultyLevel[keyof typeof CourseBuilderV2_ProductDifficultyLevel];
/** Corresponds to the productDuration facet in search_hit.proto */
export const CourseBuilderV2_ProductDuration = {
  /** Corresponds to facet value "productDuration:Less Than 2 Hours" */
  LessThanTwoHours: 'LESS_THAN_TWO_HOURS',
  /** Corresponds to facet value "productDuration:1-4 Weeks" */
  OneToFourWeeks: 'ONE_TO_FOUR_WEEKS',
  /** Corresponds to facet value "productDuration:1-4 Years" */
  OneToFourYears: 'ONE_TO_FOUR_YEARS',
  /** Corresponds to facet value "productDuration:1-3 Months" */
  OneToThreeMonths: 'ONE_TO_THREE_MONTHS',
  /** Corresponds to facet value "productDuration:6-12 Months" */
  SixToTwelveMonths: 'SIX_TO_TWELVE_MONTHS',
  /** Corresponds to facet value "productDuration:3-6 Months" */
  ThreeToSixMonths: 'THREE_TO_SIX_MONTHS',
  /** Corresponds to facet value "productDuration:Under 60 Minutes" */
  UnderSixtyMinutes: 'UNDER_SIXTY_MINUTES'
} as const;

export type CourseBuilderV2_ProductDuration = typeof CourseBuilderV2_ProductDuration[keyof typeof CourseBuilderV2_ProductDuration];
/** Search facet */
export type CourseBuilderV2_ProductSearchFacet = {
  __typename?: 'CourseBuilderV2_ProductSearchFacet';
  /** Facet name */
  name: Scalars['String'];
  /** List of facet values and their counts */
  valuesAndCounts: Array<CourseBuilderV2_ProductSearchFacetValueAndCount>;
};

/** Mapping of search facet values and their counts */
export type CourseBuilderV2_ProductSearchFacetValueAndCount = {
  __typename?: 'CourseBuilderV2_ProductSearchFacetValueAndCount';
  /** Facet count */
  count: Scalars['Int'];
  /**
   * Facet label used for UI display; for example, if the facet value is a partner ID,
   * the label is the partner name.
   */
  label?: Maybe<Scalars['String']>;
  /** Facet value */
  value: Scalars['String'];
};

/** Search hit, corresponding to a single product */
export type CourseBuilderV2_ProductSearchHit = {
  __typename?: 'CourseBuilderV2_ProductSearchHit';
  /** Average product rating on a scale of 0-5 */
  averageProductRating?: Maybe<Scalars['Float']>;
  /** ID of the product */
  id: Scalars['ID'];
  /** Product name */
  name: Scalars['String'];
  /** Total number of ratings the product has received */
  numProductRatings?: Maybe<Scalars['Int']>;
  /** URLs of the partner logo images displayed in search cards */
  partnerLogoUrls: Array<Scalars['URL']>;
  /** Partner names */
  partnerNames: Array<Scalars['String']>;
  /**
   * The product card corresponding to the product, if available. Nullable to prevent the entire search hit from being
   * null if a federated lookup fails for some reason.
   */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Product difficulty level */
  productDifficultyLevel?: Maybe<CourseBuilderV2_ProductDifficultyLevel>;
  /** Product duration */
  productDuration?: Maybe<CourseBuilderV2_ProductDuration>;
  /** Product type */
  productType: CourseBuilderV2_ProductType;
};

/** Search results */
export type CourseBuilderV2_ProductSearchHitPaginatedResult = {
  __typename?: 'CourseBuilderV2_ProductSearchHitPaginatedResult';
  /** List of search hits */
  elements: Array<CourseBuilderV2_ProductSearchHit>;
  /** Facets */
  facets: Array<CourseBuilderV2_ProductSearchFacet>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Corresponds to the productTypeDescription facet in search_hit.proto */
export const CourseBuilderV2_ProductType = {
  /** Corresponds to facet value "productTypeDescription:Courses" */
  Course: 'COURSE',
  /** Corresponds to facet value "productTypeDescription:Professional Certificates" */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Corresponds to facet value "productTypeDescription:Specializations" */
  Specialization: 'SPECIALIZATION'
} as const;

export type CourseBuilderV2_ProductType = typeof CourseBuilderV2_ProductType[keyof typeof CourseBuilderV2_ProductType];
/** Error thrown if a LLM call failed due to the prompt exceeding the maximum token size supported by the LLM. */
export type CourseBuilderV2_PromptSizeTooLargeError = CourseBuilderV2_WorkflowError & {
  __typename?: 'CourseBuilderV2_PromptSizeTooLargeError';
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/** Range numeric answer */
export type CourseBuilderV2_RangeNumericAnswer = {
  __typename?: 'CourseBuilderV2_RangeNumericAnswer';
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Lower bound of the range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound is inclusive */
  lowerBoundInclusive: Scalars['Boolean'];
  /** Upper bound of the range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound is inclusive */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Input for a range numeric answer */
export type CourseBuilderV2_RangeNumericAnswerInput = {
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Lower bound of the range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound is inclusive */
  lowerBoundInclusive: Scalars['Boolean'];
  /** Upper bound of the range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound is inclusive */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Regex answer */
export type CourseBuilderV2_RegexAnswer = {
  __typename?: 'CourseBuilderV2_RegexAnswer';
  /** Whether the regex pattern is case insensitive */
  caseInsensitive: Scalars['Boolean'];
  /** Whether the the dot symbol in the regex pattern matches all characters, including newlines */
  dotAll: Scalars['Boolean'];
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Whether the regex pattern is multi-line */
  multiLine: Scalars['Boolean'];
  /** Regex pattern for the answer */
  regex: Scalars['String'];
};

/** Input for a regex answer */
export type CourseBuilderV2_RegexAnswerInput = {
  /** Whether the regex pattern is case insensitive */
  caseInsensitive: Scalars['Boolean'];
  /** Whether the dot symbol in the regex pattern matches all characters, including newlines */
  dotAll: Scalars['Boolean'];
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Whether the regex pattern is multi-line */
  multiLine: Scalars['Boolean'];
  /** Regex pattern for the answer */
  regex: Scalars['String'];
};

/** Regex question */
export type CourseBuilderV2_RegexQuestion = {
  __typename?: 'CourseBuilderV2_RegexQuestion';
  /** List of regex answer options */
  answers: Array<CourseBuilderV2_RegexAnswer>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a regex question */
export type CourseBuilderV2_RegexQuestionInput = {
  /** List of regex answer options */
  answers: Array<CourseBuilderV2_RegexAnswerInput>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** CourseBuilderV2_RewindToCheckpoint mutation input */
export type CourseBuilderV2_RewindToCheckpointInput = {
  /** Checkpoint to rewind to */
  checkpoint: CourseBuilderV2_WorkflowStatus;
  /** List of curated items to use in the next workflow iteration */
  curatedItemsToRetain?: InputMaybe<Array<CourseBuilderV2_CuratedItemInput>>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_RewindToCheckpoint mutation result */
export type CourseBuilderV2_RewindToCheckpointResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_RewindToStep mutation input */
export type CourseBuilderV2_RewindToStepInput = {
  /** Step to rewind to */
  step: CourseBuilderV2_WorkflowStatus;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_RewindToStep mutation result */
export type CourseBuilderV2_RewindToStepResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Rubric option */
export type CourseBuilderV2_RubricOption = {
  __typename?: 'CourseBuilderV2_RubricOption';
  /** Prompt for the option which supports CML */
  optionPrompt: Scalars['String'];
  /** Points for the option */
  points: Scalars['Float'];
};

/** Input for a rubric option */
export type CourseBuilderV2_RubricOptionInput = {
  /** Rubric option prompt */
  optionPrompt: Scalars['String'];
  /** Points value for the rubric option */
  points: Scalars['Float'];
};

/** Rubric part for an assignment */
export type CourseBuilderV2_RubricPart = CourseBuilderV2_GradedTextBoxRubricPart | CourseBuilderV2_InlineFeedbackRubricPart | CourseBuilderV2_OptionsRubricPart | CourseBuilderV2_UngradedTextBoxRubricPart | CourseBuilderV2_YesNoRubricPart;

/** Input for a rubric part for an assignment */
export type CourseBuilderV2_RubricPartInput = {
  /** Graded text box rubric part */
  gradedTextBoxRubricPart?: InputMaybe<CourseBuilderV2_GradedTextBoxRubricPartInput>;
  /** Inline feedback rubric part */
  inlineFeedbackRubricPart?: InputMaybe<CourseBuilderV2_InlineFeedbackRubricPartInput>;
  /** Options rubric part */
  optionsRubricPart?: InputMaybe<CourseBuilderV2_OptionsRubricPartInput>;
  /** Ungraded text box rubric part */
  ungradedTextBoxRubricPart?: InputMaybe<CourseBuilderV2_UngradedTextBoxRubricPartInput>;
  /** Yes no rubric part */
  yesNoRubricPart?: InputMaybe<CourseBuilderV2_YesNoRubricPartInput>;
};

/** CourseBuilderV2_SaveCoachChatSession input */
export type CourseBuilderV2_SaveCoachChatSessionInput = {
  /** Coach chat session ID to save */
  coachChatSessionId: Scalars['ID'];
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_SaveCoachChatSession mutation result */
export type CourseBuilderV2_SaveCoachChatSessionResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** The skill-related inputs */
export type CourseBuilderV2_SkillRelatedInputs = {
  __typename?: 'CourseBuilderV2_SkillRelatedInputs';
  /** Developmental progress within an occupational group. */
  careerBand: VerifiedSkills_CareerBand;
  /** Educators' partner ids */
  educators: Array<Scalars['ID']>;
  /** The program id the content is recommended from. */
  enterpriseProgramId: Scalars['ID'];
  /** Course language code ISO 639-1 language codes (e.g., 'en', 'es', 'fr', 'de'). We allow author to select multiple languages if non English is selected in Step 1. */
  languages: Array<Scalars['String']>;
  /** A cluster of occupations with a high degree of overlap in skills and competencies. */
  occupationalGroup: Scalars['String'];
  /**
   * [Deprecated] A Skill Area is learner-facing grouping of related skills that support a common phase of work or functional objective. The skills in a Skill Area are commonly taught, practiced, or applied together.
   * @deprecated skill areas are unmapped when referenced in guided flow in CB, use unmappedSkillArea instead
   */
  skillArea?: Maybe<VerifiedSkills_SkillArea>;
  /** A discrete, observable, and measurable capability that enables a person to perform a specific task or function. */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
  /**
   * SkillTrack is the Enterprise program's contract tag. There is currently no
   * contract tag type, so we're using a string instead
   */
  skillTrack: Scalars['String'];
  /** An unmapped Skill Area is learner-facing grouping of related skills that support a common phase of work or functional objective. The skills in a Skill Area are commonly taught, practiced, or applied together. */
  unmappedSkillArea: VerifiedSkills_UnmamppedSkillArea;
};

/** Data from Smart Ingestion content upload */
export type CourseBuilderV2_SmartIngestionCourseData = {
  __typename?: 'CourseBuilderV2_SmartIngestionCourseData';
  /** Original filename of the uploaded Common Cartridge or SCORM package */
  ingestedFileName?: Maybe<Scalars['String']>;
};

/** Input for analyzing a Smart Ingestion workflow for content gaps */
export type CourseBuilderV2_StartAnalyzingContentForGapsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** The ID of the Smart Ingestion workflow to analyze */
  workflowId: Scalars['ID'];
};

/** Result of analyzing a Smart Ingestion workflow for content gaps */
export type CourseBuilderV2_StartAnalyzingContentForGapsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Input to start a question generation request */
export type CourseBuilderV2_StartAssessmentGenerationInput = {
  /** The type of feedback the AI should generate. Feedback is displayed to learners alongside their answer. */
  feedbackType: CourseBuilderV2_AssessmentGeneratorFeedbackType;
  /** Number of questions to generate per module */
  numberOfQuestions: Scalars['Int'];
  /** The name of the question bank to be created */
  questionBankName: Scalars['String'];
  /** Question types to generate */
  questionTypes?: InputMaybe<Array<CourseBuilderV2_AssessmentGeneratorQuestionType>>;
};

/** Input to start a question generation request */
export type CourseBuilderV2_StartAssessmentGenerationInputs = {
  __typename?: 'CourseBuilderV2_StartAssessmentGenerationInputs';
  /** The type of feedback the AI should generate. Feedback is displayed to learners alongside their answer. */
  feedbackType: CourseBuilderV2_AssessmentGeneratorFeedbackType;
  /** Number of questions to generate per module */
  numberOfQuestions: Scalars['Int'];
  /** The name of the question bank to be created */
  questionBankName: Scalars['String'];
  /** Question types to generate */
  questionTypes?: Maybe<Array<CourseBuilderV2_AssessmentGeneratorQuestionType>>;
};

/** CourseBuilderV2_StartGeneratingCourseMaterials mutation input */
export type CourseBuilderV2_StartGeneratingCourseMaterialsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseMaterials mutation result */
export type CourseBuilderV2_StartGeneratingCourseMaterialsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineFromScratch mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromScratchInput = {
  /** Description of the learners expected to take the course */
  audience?: InputMaybe<Scalars['String']>;
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds?: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Desired course length, specified in number of modules */
  courseLength?: InputMaybe<CourseBuilderV2_CourseLengthModuleBasedInput>;
  /** language code to use for the primary language of the course */
  languageCode?: Scalars['String'];
  /** Text describing outcomes or skills learners should get from taking the course */
  learningObjectives?: InputMaybe<Scalars['String']>;
  /** Optional syllabus input asset ID */
  syllabusInputAssetId?: InputMaybe<Scalars['ID']>;
  /** Text describing topic to generate a course about */
  topic?: InputMaybe<Scalars['String']>;
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromScratch mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromScratchResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCourses mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesInput = {
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Enterprise program ID */
  enterpriseProgramId: Scalars['ID'];
  /** A list of source courses selected by the user as a starting point to generate the course */
  selectedSourceCourses: Array<Scalars['ID']>;
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCourses mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileInput mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileInput = {
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssetIds: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssetIds?: Array<Scalars['ID']>;
  /** Asset ID for user file inputs of the syllabus */
  syllabusInputAssetId: Scalars['ID'];
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFile mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItems mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsInput = {
  /** Optional list of course IDs whose items will be prioritized when generating curation results */
  prioritizedCourseIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItems mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectives mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesInput = {
  /** Description of the learners expected to take the course */
  audience: Scalars['String'];
  /**
   * Asset IDs for user file inputs used to directly generate course item contents, such as videos that will be included
   * directly in lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssets: Array<Scalars['ID']>;
  /** Asset IDs for user file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssets?: Array<Scalars['ID']>;
  /** Desired course length */
  courseLength: CourseBuilderV2_CourseLengthInput;
  /** language code to use for the primary language of the course */
  languageCode?: Scalars['String'];
  /** Text describing outcomes or skills learners should get from taking the course */
  learningObjectives: Scalars['String'];
  /** Text describing topics to generate a course about */
  topics: Scalars['String'];
  /**
   * Contains either a WorkflowIdAndVersion or a CreateInput. If a CreateInput is passed in, a new
   * workflow will be created. Otherwise, it is assumed that we're rerunning the
   * GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES step for an existing workflow.
   */
  workflowIdAndVersionOrCreateInput: CourseBuilderV2_WorkflowIdAndVersionOrCreateInput;
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectives mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTerms mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsInput = {
  /** Optional list of language codes to filter curated items */
  curationLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Enterprise program ID */
  enterpriseProgramId: Scalars['ID'];
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTerms mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSkills mutation input */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSkillsInput = {
  /** Authoring branch ID */
  authoringBranchId: Scalars['ID'];
  /** Developmental progress within an occupational group. */
  careerBand: Scalars['String'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Educators' partner ids */
  educators: Array<Scalars['ID']>;
  /** The program id the content is recommended from. */
  enterpriseProgramId: Scalars['ID'];
  /** Course language code ISO 639-1 language codes (e.g., 'en', 'es', 'fr', 'de'). We allow author to select multiple languages if non English is selected in Step 1. */
  languages: Array<Scalars['String']>;
  /** A cluster of occupations with a high degree of overlap in skills and competencies. */
  occupationalGroup: Scalars['String'];
  /** Skill area ID. A Skill Area is learner-facing grouping of related skills that support a common phase of work or functional objective. The skills in a Skill Area are commonly taught, practiced, or applied together. */
  skillArea: Scalars['ID'];
  /** Skill expressions' IDs */
  skillExpressions: Array<Scalars['String']>;
  /**
   * SkillTrack is the Enterprise program's contract tag.There is currently no
   * contract tag type, so we're using a string instead
   */
  skillTrack: Scalars['String'];
};

/** CourseBuilderV2_StartGeneratingCourseOutlineWithSkills mutation result */
export type CourseBuilderV2_StartGeneratingCourseOutlineWithSkillsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_StartGeneratingItemOutlineFromScratch mutation input */
export type CourseBuilderV2_StartGeneratingItemOutlineFromScratchInput = {
  /** List of item types that we can use to generate items */
  itemTypesToGenerate: Array<CourseBuilderV2_CourseItemType>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_StartGeneratingItemOutlineFromScratch mutation result */
export type CourseBuilderV2_StartGeneratingItemOutlineFromScratchResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Input for generating placeholder items in a workflow from placeholder recommendations */
export type CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsInput = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** The ID of the Smart Ingestion workflow to update. */
  workflowId: Scalars['ID'];
};

/** Result of generating placeholder items in a workflow from placeholder recommendations */
export type CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Text block with learner instructions */
export type CourseBuilderV2_TextBlockQuestion = {
  __typename?: 'CourseBuilderV2_TextBlockQuestion';
  /** Body of the text block which supports CML */
  body: Scalars['String'];
  /** Title of the text block */
  title: Scalars['String'];
};

/** Input for a text block question */
export type CourseBuilderV2_TextBlockQuestionInput = {
  /** Body of the text block which supports CML */
  body: Scalars['String'];
  /** Title of the text block */
  title: Scalars['String'];
};

/** Text exact match question */
export type CourseBuilderV2_TextExactMatchQuestion = {
  __typename?: 'CourseBuilderV2_TextExactMatchQuestion';
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectness>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a text exact match question */
export type CourseBuilderV2_TextExactMatchQuestionInput = {
  /** List of answer options with correctness */
  answers: Array<CourseBuilderV2_AnswerOptionWithCorrectnessInput>;
  /** Default feedback for the question when none of the listed answers is chosen */
  defaultFeedback: Scalars['String'];
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Text reflect question */
export type CourseBuilderV2_TextReflectQuestion = {
  __typename?: 'CourseBuilderV2_TextReflectQuestion';
  /** Feedback for when an answer is provided */
  feedback: Scalars['String'];
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: Maybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Input for a text reflect question */
export type CourseBuilderV2_TextReflectQuestionInput = {
  /** Feedback for when an answer is provided */
  feedback: Scalars['String'];
  /** Feedback for when no answer is provided */
  noAnswerFeedback?: InputMaybe<Scalars['String']>;
  /** Points for the question */
  points: Scalars['Int'];
  /** Prompt for the question which supports CML */
  prompt: Scalars['String'];
};

/** Range specifing the start and end timestamps for split/trimmed videos */
export type CourseBuilderV2_TimestampRange = {
  __typename?: 'CourseBuilderV2_TimestampRange';
  /** End timestamp in milliseconds */
  endMs: Scalars['Int'];
  /** Start timestamp in milliseconds */
  startMs: Scalars['Int'];
};

/** Range specifing the start and end timestamps for split/trimmed videos */
export type CourseBuilderV2_TimestampRangeInput = {
  /** End timestamp in milliseconds */
  endMs: Scalars['Int'];
  /** Start timestamp in milliseconds */
  startMs: Scalars['Int'];
};

/** Ungraded text box rubric part */
export type CourseBuilderV2_UngradedTextBoxRubricPart = {
  __typename?: 'CourseBuilderV2_UngradedTextBoxRubricPart';
  /** Prompt for the rubric part which supports CML */
  partPrompt: Scalars['String'];
};

/** Input for an ungraded text box rubric part */
export type CourseBuilderV2_UngradedTextBoxRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
};

/** Error encompassing any other type of failure that is not covered by the other error types. */
export type CourseBuilderV2_UnknownError = CourseBuilderV2_WorkflowError & {
  __typename?: 'CourseBuilderV2_UnknownError';
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/**
 * Represents a search term for which no matching items could be curated, and for which the user
 * has not yet opted to create a placeholder or manually curate an item.
 */
export type CourseBuilderV2_UnmatchedSearchTerm = {
  __typename?: 'CourseBuilderV2_UnmatchedSearchTerm';
  /** Search term */
  searchTerm: Scalars['String'];
};

/** CourseBuilderV2_UpdateCourseOutline mutation input */
export type CourseBuilderV2_UpdateCourseOutlineInput = {
  /** Updated course outline */
  courseOutline: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutline mutation result */
export type CourseBuilderV2_UpdateCourseOutlineResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_UpdateCourseOutlineWithCuratedItems mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithCuratedItemsInput = {
  /** Updated course outline */
  courseOutlineWithCuratedItems: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithCuratedItems mutation result */
export type CourseBuilderV2_UpdateCourseOutlineWithCuratedItemsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectives mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesInput = {
  /** Updated course outline */
  courseOutlineWithModulesAndLearningObjectives: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectives mutation result */
export type CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_UpdateCourseOutlineWithSearchTerms mutation input */
export type CourseBuilderV2_UpdateCourseOutlineWithSearchTermsInput = {
  /** Updated course outline */
  courseOutlineWithSearchTerms: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateCourseOutlineWithSearchTerms mutation result */
export type CourseBuilderV2_UpdateCourseOutlineWithSearchTermsResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** CourseBuilderV2_UpdateItemOutlineFromScratchInput mutation input */
export type CourseBuilderV2_UpdateItemOutlineFromScratchInput = {
  /** List of modules with updated items */
  courseOutlineWithItems: Array<CourseBuilderV2_OutlineModuleInput>;
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** CourseBuilderV2_UpdateItemOutlineFromScratchInput mutation result */
export type CourseBuilderV2_UpdateItemOutlineFromScratchResult = CourseBuilderV2_MutationFailure | CourseBuilderV2_MutationSuccess;

/** Maps Coach chat session ids to their respective user ids */
export type CourseBuilderV2_UserCoachChatSession = {
  __typename?: 'CourseBuilderV2_UserCoachChatSession';
  /** Coach chat session id */
  coachChatSessionId: Scalars['ID'];
  /**
   * Id of the user associated with the Coach chat session. Only the id is returned here since the same course could be
   * edited by multiple users.
   */
  userId: Scalars['ID'];
};

/** Value numeric answer */
export type CourseBuilderV2_ValueNumericAnswer = {
  __typename?: 'CourseBuilderV2_ValueNumericAnswer';
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Value of the answer */
  value: Scalars['Float'];
};

/** Input for a value numeric answer */
export type CourseBuilderV2_ValueNumericAnswerInput = {
  /** Feedback for the answer */
  feedback: Scalars['String'];
  /** Whether the answer is correct */
  isCorrect: Scalars['Boolean'];
  /** Value of the answer */
  value: Scalars['Float'];
};

/** The skill content type */
export const CourseBuilderV2_VerifiedSkillsContentType = {
  /** Practive quizzes, peer reviews etc. Items that are graded but do not contribute to skill expression attainment */
  Assessment: 'ASSESSMENT',
  /** Final Skill Assessment that counts toward skill expression attainment */
  Attainment: 'ATTAINMENT',
  /** Lectures, readings etc. Items that are not graded */
  Instructional: 'INSTRUCTIONAL'
} as const;

export type CourseBuilderV2_VerifiedSkillsContentType = typeof CourseBuilderV2_VerifiedSkillsContentType[keyof typeof CourseBuilderV2_VerifiedSkillsContentType];
/** Verified skills item */
export type CourseBuilderV2_VerifiedSkillsItem = {
  __typename?: 'CourseBuilderV2_VerifiedSkillsItem';
  /** The item ID */
  itemId: Scalars['ID'];
  /** The programming language used in this skill. */
  programmingLanguages: Array<Scalars['String']>;
  /** A discrete, observable, and measurable capability that enables a person to perform a specific task or function. */
  skillExpressionIds: Array<Scalars['String']>;
  /** The tools envolved in the skill */
  tools: Array<Scalars['String']>;
  /** The skill content type */
  verifiedSkillsContentType?: Maybe<CourseBuilderV2_VerifiedSkillsContentType>;
};

/** Verified skills module */
export type CourseBuilderV2_VerifiedSkillsModule = {
  __typename?: 'CourseBuilderV2_VerifiedSkillsModule';
  /** Verified skills item-skill mapping */
  itemSkillsMapping: Array<CourseBuilderV2_VerifiedSkillsItem>;
  /** The module corresponding to the verified skills */
  module: CourseBuilderV2_CuratedModule;
  /** The programming language used in this module. */
  programmingLanguages: Array<Scalars['String']>;
  /**
   * List of skill expressions included in the module
   * @deprecated Use verifiedSkillExpressions instead
   */
  skillExpressions: Array<Scalars['String']>;
  /** The tools involved in the module */
  tools: Array<Scalars['String']>;
  /** List of skill expressions included in the module */
  verifiedSkillExpressions?: Maybe<Array<VerifiedSkills_SkillExpression>>;
};

/** Verified skills module search results */
export type CourseBuilderV2_VerifiedSkillsModulePaginatedResult = {
  __typename?: 'CourseBuilderV2_VerifiedSkillsModulePaginatedResult';
  /** List of verified skills module search hits */
  elements: Array<CourseBuilderV2_VerifiedSkillsModule>;
  /** Facets */
  facets: Array<CourseBuilderV2_ProductSearchFacet>;
  /** Pagination metadata */
  pagination: Pagination;
};

/**
 * Widgets are a flexible item type and their configuration can take many shapes. To enable this
 * flexibility during Smart Ingestion Distillation and Augmentation steps, different models will be
 * used to extract information about different kinds of widgets. This enum captures the broad
 * categories of widgets that can be extracted from source content.
 */
export const CourseBuilderV2_WidgetCategory = {
  /** Widget with a single link such as IFrame or YouTube video */
  WidgetWithLink: 'WIDGET_WITH_LINK',
  /** Widget with a YouTube video ID */
  WidgetWithYoutubeVideoId: 'WIDGET_WITH_YOUTUBE_VIDEO_ID'
} as const;

export type CourseBuilderV2_WidgetCategory = typeof CourseBuilderV2_WidgetCategory[keyof typeof CourseBuilderV2_WidgetCategory];
/** Course Builder workflow schema */
export type CourseBuilderV2_Workflow = {
  __typename?: 'CourseBuilderV2_Workflow';
  /** A list of all Assessment Generation request IDs; required to poll for the status of their generation */
  assessmentGenerationRequestIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  /** User inputs used to generate the assessment items */
  assessmentsInputs?: Maybe<CourseBuilderV2_AssessmentsInputs>;
  /** The authoring branch the workflow is associated with */
  authoringBranchId: Scalars['ID'];
  /** A mapping of Coach chat sessions to their associated users. */
  coachChatSessions?: Maybe<Array<CourseBuilderV2_UserCoachChatSession>>;
  /**
   * User file inputs used to directly generate course item contents, such as videos that will be included directly in
   * lectures, or PDFs that will be embedded directly in readings.
   */
  contentInputAssets: Array<CourseBuilderV2_InputAsset>;
  /** User file inputs that will be used solely to provide context for AI generation. */
  contextOnlyInputAssets: Array<CourseBuilderV2_InputAsset>;
  /** The course the workflow is associated with */
  course: Course_Course;
  /** Course-level learning objectives, generated by refining the initial user inputs */
  courseLearningObjectives?: Maybe<Array<Scalars['String']>>;
  /**
   * The current working version of the course outline.
   *
   * Prior to the introduction of this field, we used separate fields tracking the state of the outline as the workflow
   * progressed through the various steps, but we decided to simplify the representation because it was a source of
   * confusion, required additional complexity on both the BE and FE to manage, and because we weren't actively using the
   * information about past outline states for any real purpose.
   *
   * If a pre-existing workflow does not yet have a value for this field saved, we will return the value of the
   * furthest-progressed outline field to maintain backwards-compatibility, based on the following priority order:
   * 1. courseOutlineWithCuratedItems
   * 2. initialCourseOutlineWithCuratedItems
   * 3. courseOutlineWithSearchTerms
   * 4. initialCourseOutlineWithSearchTerms
   * 5. courseOutlineWithModulesAndLearningObjectives
   * 6. initialCourseOutlineWithModulesAndLearningObjectives
   */
  courseOutline?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /**
   * Working version of the course outline with curated items, including user edits.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  courseOutlineWithCuratedItems?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /**
   * Working version of the course outline containing modules and learning objectives, including
   * user edits.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  courseOutlineWithModulesAndLearningObjectives?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /**
   * Working version of the course outline with search terms, including user edits.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  courseOutlineWithSearchTerms?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /** Time when the workflow was initially created */
  createdAt: Scalars['DateTime'];
  /** List of items an author has explicitly opted to retain when going back to a previous step */
  curatedItemsToRetain?: Maybe<Array<CourseBuilderV2_CuratedItem>>;
  /** Optional set of user inputs used to specify curation behaviour */
  curationInputs?: Maybe<CourseBuilderV2_CurationInputs>;
  /** Error that is set if the workflow fails for any reason */
  error?: Maybe<CourseBuilderV2_EmbedAtomsError | CourseBuilderV2_ExceededTokenLimit | CourseBuilderV2_NetworkError | CourseBuilderV2_PromptSizeTooLargeError | CourseBuilderV2_UnknownError>;
  /**
   * Error message that is set if the workflow fails for any reason
   * @deprecated Use error.rawErrorMessage instead
   */
  errorMessage?: Maybe<Scalars['String']>;
  /** Generated items created from input files */
  generatedAssetItems?: Maybe<Array<CourseBuilderV2_GeneratedAssetItem>>;
  /** Generated course metadata, such as the course name and domains */
  generatedCourseMetadata?: Maybe<CourseBuilderV2_GeneratedCourseMetadata>;
  /** Workflow ID */
  id: Scalars['ID'];
  /**
   * Initial generated course outline with curated items. This is intended to track the state of the
   * outline before authors have made any changes so we can compare this against the
   * courseOutlineWithCuratedItems field to see what edits authors are making.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  initialCourseOutlineWithCuratedItems?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /**
   * Initial generated course outline containing modules and learning objectives. This is intended
   * to track the state of the outline before authors have made any changes so we can compare this
   * against the courseOutlineWithModulesAndLearningObjectives field to see what edits authors are
   * making.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  initialCourseOutlineWithModulesAndLearningObjectives?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /**
   * Initial generated course outline after the first checkpoint that now contains search terms.
   * This is intended to track the state of the outline before authors have made any changes so we
   * can compare this against the courseOutlineWithSearchTerms field to see what edits authors are
   * making.
   *
   * Deprecated in favour of the unified `courseOutline` field.
   * @deprecated Migrated to a single unified `courseOutline` field
   */
  initialCourseOutlineWithSearchTerms?: Maybe<Array<CourseBuilderV2_OutlineModule>>;
  /** IDs of any associated Airflow jobs, listed in order of creation */
  jobInvocationIds: Array<Scalars['ID']>;
  /**
   * Primary language code associated with the parent course.
   * This is its own field because the workflow stores a denormalized copy of the language code for use
   * in curation, generation, etc.
   */
  languageCode: Scalars['String'];
  /** Time when the workflow was last updated */
  lastUpdatedAt: Scalars['DateTime'];
  /** User inputs used to generate the course outline */
  outlineInputs?: Maybe<CourseBuilderV2_OutlineInputs>;
  /**
   * Placeholder recommendations from Smart Ingestion gap analysis.
   * Populated during AnalyzeContentForGaps.
   */
  placeholderRecommendations?: Maybe<Array<CourseBuilderV2_PlaceholderRecommendation>>;
  /** ID of the user who triggered the workflow */
  requesterId: Scalars['ID'];
  /** A list of source courses selected by the user as a starting point to generate the course */
  selectedSourceCourses?: Maybe<Array<Course_Course>>;
  /** The skill-related inputs */
  skillRelatedInputs?: Maybe<CourseBuilderV2_SkillRelatedInputs>;
  /** Smart Ingestion course data populated when workflow type is SMART_INGESTION */
  smartIngestionCourseData?: Maybe<CourseBuilderV2_SmartIngestionCourseData>;
  /** Current status of the workflow */
  status: CourseBuilderV2_WorkflowStatus;
  /** An optional syllabus file that should be used to create the initial course outline */
  syllabusInputAsset?: Maybe<CourseBuilderV2_InputAsset>;
  /** Workflow type */
  type: CourseBuilderV2_WorkflowType;
  /** Auto-incremented version number used to prevent write conflicts */
  version: Scalars['Int'];
};

/**
 * Error interface for workflow failures, intended to be used as a fallback by clients in case new error cases are added
 * before they have a chance to update their code to handle the new error cases
 */
export type CourseBuilderV2_WorkflowError = {
  /**
   * Errors cause the workflow status to be set to FAILED. This field stores the previous workflow status before the error
   * occurred to allow the FE to determine what step to display if an error occurs.
   */
  previousWorkflowStatus?: Maybe<CourseBuilderV2_WorkflowStatus>;
  /** Raw error message that is set if the workflow fails for any reason */
  rawErrorMessage: Scalars['String'];
};

/** Course Builder workflow ID and version number */
export type CourseBuilderV2_WorkflowIdAndVersion = {
  /** Workflow version, used to prevent write conflicts */
  version: Scalars['Int'];
  /** Workflow ID */
  workflowId: Scalars['ID'];
};

/** oneOf field containing either a WorkflowIdAndVersion or a CreateInput */
export type CourseBuilderV2_WorkflowIdAndVersionOrCreateInput = {
  /** Set when creating a new workflow */
  createInput?: InputMaybe<CourseBuilderV2_CreateWorkflowInput>;
  /**
   * Set when rerunning the GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES step for an
   * existing workflow
   */
  workflowIdAndVersion?: InputMaybe<CourseBuilderV2_WorkflowIdAndVersion>;
};

/** Paginated workflow response */
export type CourseBuilderV2_WorkflowPaginatedResult = {
  __typename?: 'CourseBuilderV2_WorkflowPaginatedResult';
  /** List containing one page of workflow results */
  elements: Array<CourseBuilderV2_Workflow>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** The current status of the workflow */
export const CourseBuilderV2_WorkflowStatus = {
  /** The workflow polls Assessment Generator for status on generation requests triggered in GENERATING_COURSE_MATERIALS step */
  AwaitingAssessmentsGenerationCompletion: 'AWAITING_ASSESSMENTS_GENERATION_COMPLETION',
  /** The workflow is analyzing the course outline to identify gaps where placeholder items should be inserted */
  CbsiAnalyzingContentForGaps: 'CBSI_ANALYZING_CONTENT_FOR_GAPS',
  /** The workflow has completed assessment generation for Smart Ingestion and is waiting for the user to proceed to materials generation. */
  CbsiAssessmentsReviewCheckpoint: 'CBSI_ASSESSMENTS_REVIEW_CHECKPOINT',
  /** The workflow is augmenting the course content from the structure content field and based on the distilled course structure */
  CbsiAugmentCourseContentFromStructureContent: 'CBSI_AUGMENT_COURSE_CONTENT_FROM_STRUCTURE_CONTENT',
  /** The workflow is waiting for user to confirm or edit the placeholder recommendations before generating placeholder items */
  CbsiAwaitingPlaceholderConfirmation: 'CBSI_AWAITING_PLACEHOLDER_CONFIRMATION',
  /** The workflow is having coach generate suggestions for user to review */
  CbsiCoachReviewCheckpoint: 'CBSI_COACH_REVIEW_CHECKPOINT',
  /** The workflow is distilling the course structure from the structure content field */
  CbsiDistillCourseStructureFromStructureContent: 'CBSI_DISTILL_COURSE_STRUCTURE_FROM_STRUCTURE_CONTENT',
  /** The workflow is generating placeholder items based on the confirmed recommendations */
  CbsiGeneratingPlaceholderItems: 'CBSI_GENERATING_PLACEHOLDER_ITEMS',
  /** The workflow has completed placeholder generation and is waiting for the user to review the generated placeholder items before proceeding to the optional assessment step or materials generation. */
  CbsiPlaceholderReviewCheckpoint: 'CBSI_PLACEHOLDER_REVIEW_CHECKPOINT',
  /** The workflow starts asset loading based on asset bundles from structure content */
  CbsiStartAssetCreationFromStructureContent: 'CBSI_START_ASSET_CREATION_FROM_STRUCTURE_CONTENT',
  /** The workflow completed successfully */
  Completed: 'COMPLETED',
  /** The workflow is converting syllabus to course outline with modules and learning objectives */
  ConvertingSyllabusToCourseOutline: 'CONVERTING_SYLLABUS_TO_COURSE_OUTLINE',
  /** The workflow is searching for items matching each module learning objective's search terms */
  CuratingItemsForLearningObjectives: 'CURATING_ITEMS_FOR_LEARNING_OBJECTIVES',
  /** The workflow is fetching the modules by skills */
  CuratingModulesForSkills: 'CURATING_MODULES_FOR_SKILLS',
  /** The workflow is waiting for TextExtractJob invocations to extract text from input files */
  ExtractingTextFromInputFiles: 'EXTRACTING_TEXT_FROM_INPUT_FILES',
  /** The workflow ran into an error while executing */
  Failed: 'FAILED',
  /** The workflow is generating a course outline from scratch */
  FsGeneratingCourseOutline: 'FS_GENERATING_COURSE_OUTLINE',
  /** The workflow is generating course outline items from scratch */
  FsGeneratingCourseOutlineWithItems: 'FS_GENERATING_COURSE_OUTLINE_WITH_ITEMS',
  /** The workflow is generating Assessments items and adding them to course outline */
  GeneratingAssessmentsOutlineItems: 'GENERATING_ASSESSMENTS_OUTLINE_ITEMS',
  /** The workflow is populating the branch with course materials based on the outline */
  GeneratingCourseMaterials: 'GENERATING_COURSE_MATERIALS',
  /** The workflow is generating course metadata */
  GeneratingCourseMetadata: 'GENERATING_COURSE_METADATA',
  /**
   * The workflow is generating a course outline from selected source courses.
   * - course materials will be concatenated together
   * - learning objectives will be generated for modules that did not have learning objectives of their own
   * - items generated from uploaded files will be inserted into the course outline where the AI deems appropriate
   */
  GeneratingCourseOutlineFromSelectedCourses: 'GENERATING_COURSE_OUTLINE_FROM_SELECTED_COURSES',
  /** The workflow is selecting and reordering items from the previous step to form a complete course outline with curated items */
  GeneratingCourseOutlineWithCuratedItems: 'GENERATING_COURSE_OUTLINE_WITH_CURATED_ITEMS',
  /** The workflow is generating a course outline containing modules and their respective learning objectives */
  GeneratingCourseOutlineWithModulesAndLearningObjectives: 'GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES',
  /** The workflow is generating items based from input files and text extracted from them */
  GeneratingItemsFromInputFiles: 'GENERATING_ITEMS_FROM_INPUT_FILES',
  /**
   * The workflow is generating item contents, which will be converted into real course materials in the
   * GENERATING_COURSE_MATERIALS step
   */
  GeneratingItemContents: 'GENERATING_ITEM_CONTENTS',
  /**
   * The workflow is generating item-type specific parameters that will be reviewed by users and used as inputs for item
   * content generation
   */
  GeneratingItemParameters: 'GENERATING_ITEM_PARAMETERS',
  /** Coach is generating suggested edits for the course outline with items */
  GeneratingProactiveSuggestionsForOutlineWithItems: 'GENERATING_PROACTIVE_SUGGESTIONS_FOR_OUTLINE_WITH_ITEMS',
  /** Coach is generating suggested edits for the course outline with modules and learning objectives */
  GeneratingProactiveSuggestionsForOutlineWithModules: 'GENERATING_PROACTIVE_SUGGESTIONS_FOR_OUTLINE_WITH_MODULES',
  /** The workflow is generating search terms for each learning objective to be used for item curation */
  GeneratingSearchTerms: 'GENERATING_SEARCH_TERMS',
  /** The workflow is searching the catalog for relevant courses for more focused curation results */
  GeneratingSuggestedCurationFilters: 'GENERATING_SUGGESTED_CURATION_FILTERS',
  /** The workflow is converting syllabus uploads to usable format for later inputs to LLMs */
  HandlingSyllabusAssetUpload: 'HANDLING_SYLLABUS_ASSET_UPLOAD',
  /** The workflow was created, but the associated Airflow jobs have not yet run */
  NotStarted: 'NOT_STARTED',
  /** The workflow is refining course learning objectives from the original user-provided inputs */
  RefiningCourseLearningObjectives: 'REFINING_COURSE_LEARNING_OBJECTIVES',
  /** The workflow is started over */
  StartOver: 'START_OVER',
  /** The workflow is tagging generated items with learning objectives */
  TaggingGeneratedItemsWithLearningObjectives: 'TAGGING_GENERATED_ITEMS_WITH_LEARNING_OBJECTIVES',
  /** The workflow is tagging curated items retained from a previous iteration with learning objectives */
  TaggingRetainedCuratedItemsWithLearningObjectives: 'TAGGING_RETAINED_CURATED_ITEMS_WITH_LEARNING_OBJECTIVES',
  /** The workflow is updating the course with the metadata generated by the previous step */
  UpdatingCourseMetadata: 'UPDATING_COURSE_METADATA',
  /** The workflow is waiting for users to review and edit the generated assessment outline items */
  UserAssessmentsOutlineCheckpoint: 'USER_ASSESSMENTS_OUTLINE_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the outline generated by the previous step */
  UserCurationCheckpoint: 'USER_CURATION_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the item outline generated by the previous step */
  UserItemReviewCheckpoint: 'USER_ITEM_REVIEW_CHECKPOINT',
  /** The workflow is waiting for users to review and edit the outline generated by the previous step */
  UserOutlineCheckpoint: 'USER_OUTLINE_CHECKPOINT',
  /** The workflow is waiting for users to review and edit previously generated search terms and curation filters */
  UserSearchTermsCheckpoint: 'USER_SEARCH_TERMS_CHECKPOINT'
} as const;

export type CourseBuilderV2_WorkflowStatus = typeof CourseBuilderV2_WorkflowStatus[keyof typeof CourseBuilderV2_WorkflowStatus];
/** The type of the Course Builder workflow */
export const CourseBuilderV2_WorkflowType = {
  /** The workflow in which the generated course is built from existing content through AI-assisted curation */
  AiCuration: 'AI_CURATION',
  /**
   * Updated version of the workflow in which the generated course is built from existing content
   * through AI-assisted curation, now incorporating agentic outline and item content generation
   */
  AiCurationV2: 'AI_CURATION_V2',
  /** The workflow in which the generated course is built from scratch */
  FromScratch: 'FROM_SCRATCH',
  /**
   * Updated version of the workflow in which the generated course is built from scratch, now incorporating agentic outline
   * and item content generation
   */
  FromScratchV2: 'FROM_SCRATCH_V2',
  /** The workflow in which the generated course is built from a number of existing courses through reuse */
  FullCourseReuse: 'FULL_COURSE_REUSE',
  /** The workflow in which the generated course is built based on skills author required */
  SkillBased: 'SKILL_BASED',
  /** The workflow in which the generated course is built based on ingested content from some external source */
  SmartIngestion: 'SMART_INGESTION'
} as const;

export type CourseBuilderV2_WorkflowType = typeof CourseBuilderV2_WorkflowType[keyof typeof CourseBuilderV2_WorkflowType];
/** Points for Yes/No answers */
export type CourseBuilderV2_YesNoPoints = {
  __typename?: 'CourseBuilderV2_YesNoPoints';
  /** Points for No answer */
  noPoints: Scalars['Float'];
  /** Points for Yes answer */
  yesPoints: Scalars['Float'];
};

/** Input for Yes/No points */
export type CourseBuilderV2_YesNoPointsInput = {
  /** Points value for when the rubric part is not satisfied */
  noPoints: Scalars['Float'];
  /** Points value for when the rubric part is satisfied */
  yesPoints: Scalars['Float'];
};

/** Yes/No rubric part */
export type CourseBuilderV2_YesNoRubricPart = {
  __typename?: 'CourseBuilderV2_YesNoRubricPart';
  /** Prompt for the rubric part which supports CML */
  partPrompt: Scalars['String'];
  /** Points for Yes/No answers */
  yesNoPoints: CourseBuilderV2_YesNoPoints;
};

/** Input for a Yes/No rubric part */
export type CourseBuilderV2_YesNoRubricPartInput = {
  /** Rubric part prompt */
  partPrompt: Scalars['String'];
  /** Points for when the rubric part is and isn't satisfied */
  yesNoPoints: CourseBuilderV2_YesNoPointsInput;
};

/** Course courses being restricted. */
export type CourseBuilder_CourseRestrictions = {
  __typename?: 'CourseBuilder_CourseRestrictions';
  /** courseIds. */
  courseIds: Array<Course_Course>;
};

/** Course builder restriction creation input. */
export type CourseBuilder_CreateRestrictionInput = {
  /** The type of the access restriction: INCLUDE / EXCLUDE. */
  accessType: CourseBuilder_RestrictionAccessType;
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
  /**
   * The identifiers of entities being restricted. Actual values depend on the restrictionLevel.
   * For a Global restriction, this will be empty.
   */
  restrictions?: InputMaybe<Array<Scalars['String']>>;
};

/** Course builder restriction creation result. */
export type CourseBuilder_CreateRestrictionResult = {
  __typename?: 'CourseBuilder_CreateRestrictionResult';
  /** The created restriction. */
  restriction: CourseBuilder_Restriction;
};

/** Course builder restriction delete input. */
export type CourseBuilder_DeleteRestrictionInput = {
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
};

/** Course builder restriction delete result. */
export type CourseBuilder_DeleteRestrictionResult = {
  __typename?: 'CourseBuilder_DeleteRestrictionResult';
  /** The deleted restriction. */
  restriction: CourseBuilder_Restriction;
};

/** Item types being restricted. */
export type CourseBuilder_ItemTypeRestrictions = {
  __typename?: 'CourseBuilder_ItemTypeRestrictions';
  /** itemTypes. */
  excludedItemTypes: Array<Scalars['String']>;
};

/** Item types that are excluded by the given partner */
export type CourseBuilder_PartnerExcludedItemTypes = {
  __typename?: 'CourseBuilder_PartnerExcludedItemTypes';
  /** The item types that are excluded. */
  excludedItemTypes?: Maybe<CourseBuilder_ItemTypeRestrictions>;
  /** The partner id. */
  partner: Partner_Partner;
};

/** The partners being excluded by this restrictions. */
export type CourseBuilder_PartnerRestrictions = {
  __typename?: 'CourseBuilder_PartnerRestrictions';
  /** excludedPartnerIds. */
  excludedPartnerIds: Array<Partner_Partner>;
};

/** Course builder restriction schema */
export type CourseBuilder_Restriction = {
  __typename?: 'CourseBuilder_Restriction';
  /** The type of the access restriction: INCLUDE / EXCLUDE. */
  accessType: CourseBuilder_RestrictionAccessType;
  /** The timestamp when the restriction was created. */
  createdAt: Scalars['DateTime'];
  /** The user who created the restriction. */
  createdBy: Scalars['ID'];
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
  /**
   * The identifiers of entities being restricted. Actual type depends on the restrictionLevel.
   * For a Global restriction, this will be empty.
   */
  restrictions?: Maybe<CourseBuilder_Restrictions>;
  /** The timestamp when the restriction was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user who last updated the restriction. */
  updatedBy: Scalars['ID'];
};

/** The access type of the restriction. */
export const CourseBuilder_RestrictionAccessType = {
  /** EXCLUDE. */
  Exclude: 'EXCLUDE',
  /** INCLUDE. */
  Include: 'INCLUDE'
} as const;

export type CourseBuilder_RestrictionAccessType = typeof CourseBuilder_RestrictionAccessType[keyof typeof CourseBuilder_RestrictionAccessType];
/** The level of the restriction. */
export const CourseBuilder_RestrictionLevel = {
  /** COURSE. */
  Course: 'COURSE',
  /** GLOBAL. */
  Global: 'GLOBAL',
  /** ITEM_TYPE. */
  ItemType: 'ITEM_TYPE',
  /** PARTNER. */
  Partner: 'PARTNER',
  /** SPECIALIZATION. */
  Specialization: 'SPECIALIZATION'
} as const;

export type CourseBuilder_RestrictionLevel = typeof CourseBuilder_RestrictionLevel[keyof typeof CourseBuilder_RestrictionLevel];
/** The identifiers of entities being restricted. Actual type depends on the restrictionLevel. */
export type CourseBuilder_Restrictions = CourseBuilder_CourseRestrictions | CourseBuilder_ItemTypeRestrictions | CourseBuilder_PartnerRestrictions | CourseBuilder_S12nRestrictions;

/** Specializations being restricted. */
export type CourseBuilder_S12nRestrictions = {
  __typename?: 'CourseBuilder_S12nRestrictions';
  /** s12nIds. */
  s12nIds: Array<Specialization_Specialization>;
};

/** Course builder restriction update input. */
export type CourseBuilder_UpdateRestrictionInput = {
  /** The type of the access restriction: INCLUDE / EXCLUDE. */
  accessType: CourseBuilder_RestrictionAccessType;
  /** The id of the partner owning the resource. */
  partnerId: Scalars['Int'];
  /** The level of this restriction: course, s12n, item, etc. */
  restrictionLevel: CourseBuilder_RestrictionLevel;
  /**
   * The identifiers of entities being restricted. Actual values depend on the restrictionLevel.
   * For a Global restriction, this will be empty.
   */
  restrictions?: InputMaybe<Array<Scalars['String']>>;
};

/** Course builder restriction update result. */
export type CourseBuilder_UpdateRestrictionResult = {
  __typename?: 'CourseBuilder_UpdateRestrictionResult';
  /** The updated restriction. */
  restriction: CourseBuilder_Restriction;
};

/** Course change queries for authoring change log */
export type CourseChangeQueries = {
  __typename?: 'CourseChangeQueries';
  /**
   * This query returns course changes filtered by authoringCourseBranchId, courseItemChangeType,
   * dateRangeStart, dateRangeEnd, searchText (matching item name or name of updating user),
   * itemType, and itemIsGraded.
   *
   * It will group certain changes if groupChanges is true. start and limit are used to limit the results
   * returned.
   *
   * Filters that are absent or consist of empty lists will be ignored.
   */
  queryCourseChangesByBranch?: Maybe<CourseChange_CourseChangesPaginatedResult>;
};


/** Course change queries for authoring change log */
export type CourseChangeQueriesQueryCourseChangesByBranchArgs = {
  authoringCourseBranchId: Scalars['ID'];
  courseChangeType?: InputMaybe<Array<CourseChange_BranchChangeTypeInput>>;
  cursor?: InputMaybe<Scalars['String']>;
  dateRangeEnd?: InputMaybe<Scalars['DateTime']>;
  dateRangeStart?: InputMaybe<Scalars['DateTime']>;
  entityType?: InputMaybe<Array<Scalars['String']>>;
  groupChanges: Scalars['Boolean'];
  isGraded?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
};

/** Course change types (including item changes, learning objective changes, etc.) */
export type CourseChange_BranchChangeType = CourseChange_ItemChangeTypeWrapper | CourseChange_LearningObjectiveChangeTypeWrapper;

/** Course change input types */
export type CourseChange_BranchChangeTypeInput = {
  /** Item change type */
  itemChangeType?: InputMaybe<CourseItemChange_ChangeType>;
  /** Learning objective change type */
  learningObjectiveChangeType?: InputMaybe<CourseChange_LearningObjectiveChangeType>;
};

/** Course changes */
export type CourseChange_CourseChange = CourseChange_CourseLearningObjectiveChange | CourseItemChange;

/** Single page of course changes */
export type CourseChange_CourseChangesPaginatedResult = {
  __typename?: 'CourseChange_CourseChangesPaginatedResult';
  /** A list of course item changes matching criteria. */
  elements: Array<CourseChange_CourseChange>;
  /** Filter values for change type and item type. */
  filterValues?: Maybe<CourseChange_FilterValues>;
  /** Pagination */
  pagination: Pagination;
};

/** Learning objective change */
export type CourseChange_CourseLearningObjectiveChange = {
  __typename?: 'CourseChange_CourseLearningObjectiveChange';
  /** Authoring branch id of the entity being changed */
  authoringCourseBranchId?: Maybe<Scalars['ID']>;
  /** Whether the change was made by coursera or the partner */
  courseraOrPartnerChange?: Maybe<CourseChange_CourseraOrPartner>;
  /** Grouped items that are present if this change is of type GROUPED_CHANGES. */
  groupedChanges?: Maybe<Array<CourseChange_CourseLearningObjectiveChange>>;
  /** Change id (learning objective id + sequence) */
  learningObjectiveChangeId: Scalars['ID'];
  /** Learning objective change types: CREATE, UPDATE, MOVE, ASSOCIATED, DISASSOCIATE, etc. */
  learningObjectiveChangeType: CourseChange_LearningObjectiveChangeType;
  /** Learning objective description (to be used as name) */
  objectiveName?: Maybe<Scalars['String']>;
  /** When the learning objective was updated */
  objectiveUpdatedAt: Scalars['DateTime'];
  /** The previous order of the LO in the module */
  sourceIndex?: Maybe<Scalars['Int']>;
  /** Source module id (if LO is associated with a module) */
  sourceModuleId?: Maybe<Scalars['ID']>;
  /** The new order of the LO in the module */
  targetIndex?: Maybe<Scalars['Int']>;
  /** Target module id (if LO is associated with a module) */
  targetModuleId?: Maybe<Scalars['ID']>;
  /** Full name of user in updatedBy field. */
  updatedByUserName: Scalars['String'];
};

/** Type of user change was made by: Coursera or partner */
export const CourseChange_CourseraOrPartner = {
  /** Coursera */
  Coursera: 'COURSERA',
  /** Partner */
  Partner: 'PARTNER'
} as const;

export type CourseChange_CourseraOrPartner = typeof CourseChange_CourseraOrPartner[keyof typeof CourseChange_CourseraOrPartner];
/** Course change filter values */
export type CourseChange_FilterValues = {
  __typename?: 'CourseChange_FilterValues';
  /** Values that match course item change type in byBranch query. */
  changeTypes: Array<CourseChange_BranchChangeType>;
  /**
   * Values that match course entity type names in courseChangesByBranch query: for items, this will be
   *  the specific item type name (i.e., assignment, reading, etc.) as well as other entities like
   *  learning objective, module, etc.
   */
  entityTypes: Array<Scalars['String']>;
};

/** Course item change types wrapper */
export type CourseChange_ItemChangeTypeWrapper = {
  __typename?: 'CourseChange_ItemChangeTypeWrapper';
  /** Item change type */
  itemChangeType: CourseItemChange_ChangeType;
};

/** Learning objective change types */
export const CourseChange_LearningObjectiveChangeType = {
  /** The learning objective was associated */
  AssociateLo: 'ASSOCIATE_LO',
  /** The learning objective was created */
  CreateLo: 'CREATE_LO',
  /** The learning objective was deleted */
  DeleteLo: 'DELETE_LO',
  /** The learning objective was disassociated */
  DisassociateLo: 'DISASSOCIATE_LO',
  /** The learning objective change represents a group of changes */
  GroupedChanges: 'GROUPED_CHANGES',
  /** The learning objective was moved */
  MoveLo: 'MOVE_LO',
  /** The learning objective was reordered */
  ReorderLo: 'REORDER_LO',
  /** The learning objective was updated */
  UpdateLo: 'UPDATE_LO'
} as const;

export type CourseChange_LearningObjectiveChangeType = typeof CourseChange_LearningObjectiveChangeType[keyof typeof CourseChange_LearningObjectiveChangeType];
/** Course learning object change types wrapper */
export type CourseChange_LearningObjectiveChangeTypeWrapper = {
  __typename?: 'CourseChange_LearningObjectiveChangeTypeWrapper';
  /** Learning objective change type */
  objectiveChangeType: CourseChange_LearningObjectiveChangeType;
};

/** Recommended courses after course completion queries */
export type CourseCompletionRecommendationsQueries = {
  __typename?: 'CourseCompletionRecommendationsQueries';
  /** Query by user and course ids */
  queryByUserAndCourse: CourseCompletionRecommendations_QueryByUserAndCourseResponse;
};


/** Recommended courses after course completion queries */
export type CourseCompletionRecommendationsQueriesQueryByUserAndCourseArgs = {
  input: CourseCompletionRecommendations_QueryByUserAndCourseInput;
};

/** Recommended next course in the specialization if CourseID is part of a specialization */
export type CourseCompletionRecommendations_NextCourseInSpecialization = {
  __typename?: 'CourseCompletionRecommendations_NextCourseInSpecialization';
  /** A ProductCard_ProductCard to the next course in the specialization */
  course: ProductCard_ProductCard;
  /** A reference to the Specialization_Specialization */
  specialization: Specialization_Specialization;
};

/** Input parameters for CourseCompletionRecommendationsQueries */
export type CourseCompletionRecommendations_QueryByUserAndCourseInput = {
  /** The ID of the course for which a recommendation is being retrieved. */
  courseId?: InputMaybe<Scalars['ID']>;
};

/**
 * Returns a QueryByUserAndCourseResponse_CourseIsPartOfSpecialization of the next Course in the specialization if
 * CourseID is part of a specialization. Else, returns a Collection_Collection of recommended courses from the
 * course-completed recommender configuration.
 */
export type CourseCompletionRecommendations_QueryByUserAndCourseResponse = Collection_Collection | CourseCompletionRecommendations_NextCourseInSpecialization;

/** Course Content Deadlines Queries */
export type CourseContentDeadlinesQueries = {
  __typename?: 'CourseContentDeadlinesQueries';
  /** Query to get the logged in users course content deadlines by courseId */
  getUserCourseContentDeadlinesByCourse?: Maybe<CourseContentDeadlines_CourseContentDeadlines>;
};


/** Course Content Deadlines Queries */
export type CourseContentDeadlinesQueriesGetUserCourseContentDeadlinesByCourseArgs = {
  courseId: Scalars['ID'];
};

/** Course Content deadlines container object */
export type CourseContentDeadlines_CourseContentDeadlines = {
  __typename?: 'CourseContentDeadlines_CourseContentDeadlines';
  /** All the module deadlines for a user in a course */
  moduleDeadlines: Array<CourseContentDeadlines_ModuleDeadlines>;
};

/** Item deadline in a module */
export type CourseContentDeadlines_ItemDeadline = {
  __typename?: 'CourseContentDeadlines_ItemDeadline';
  /** deadline for the item */
  deadline: Scalars['DateTime'];
  /** The unique id for an item */
  itemId: Scalars['ID'];
};

/** Module deadlines for a user in a course */
export type CourseContentDeadlines_ModuleDeadlines = {
  __typename?: 'CourseContentDeadlines_ModuleDeadlines';
  /** deadline for the module */
  deadline: Scalars['DateTime'];
  /** A list of item deadlines in the module */
  itemDeadlines: Array<CourseContentDeadlines_ItemDeadline>;
  /** The unique index for a module */
  moduleIndex: Scalars['Int'];
};

/** Input for single course translation. */
export type CourseContentTranslation_SingleCourseTranslationInput = {
  /** The authoring branch id in the course for translation. */
  authoringBranchId: Scalars['ID'];
  /** The course id for translation. */
  courseId: Scalars['ID'];
  /** If this course is a previously translated course, we might need to retranslate the content by setting this to true. */
  retranslation: Scalars['Boolean'];
  /**
   * The target language codes to translate to. The language codes should follow the Coursera Language Code defined here
   * https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  targetLanguages: Array<Scalars['String']>;
};

/** Input for triggering proactive course translation. */
export type CourseContentTranslation_TriggerProactiveCourseTranslationInput = {
  /** A list of course translation config. */
  courses: Array<CourseContentTranslation_SingleCourseTranslationInput>;
};

/** Success response for triggering proactive course translation. */
export type CourseContentTranslation_TriggerProactiveCourseTranslationResult = {
  __typename?: 'CourseContentTranslation_TriggerProactiveCourseTranslationResult';
  /** Indicates the translation job was successfully triggered. */
  success: Scalars['Boolean'];
};

/** Represents a credit for a course that can be used by a user */
export type CourseCredit = {
  __typename?: 'CourseCredit';
  /** Timestamp when this credit was created */
  createdAt: Scalars['DateTime'];
  /** Optional timestamp when this credit expires */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the credit */
  id: Scalars['String'];
  /** Indicates if the credit has expired */
  isExpired: Scalars['Boolean'];
  /** Timestamp when this credit was redeemed, if it has been redeemed */
  redeemedAt?: Maybe<Scalars['DateTime']>;
  /** Cart item ID where this credit was redeemed, if it has been redeemed */
  redeemedCartItemId?: Maybe<Scalars['String']>;
  /** Timestamp when the product associated with this credit was refunded, if refunded */
  refundedAt?: Maybe<Scalars['DateTime']>;
  /** The user ID who owns this credit */
  userId: Scalars['Int'];
};

/** Paginated result for course credits */
export type CourseCredit_PaginatedResult = {
  __typename?: 'CourseCredit_PaginatedResult';
  /** List of course credits */
  elements: Array<CourseCredit>;
  /** Pagination information */
  pagination: Pagination;
};

/** CourseDefaultEnterpriseProgram related error */
export type CourseDefaultEnterpriseProgram_Error = Error & {
  __typename?: 'CourseDefaultEnterpriseProgram_Error';
  /** Error message */
  message: Scalars['String'];
};

/**
 * CourseDefaultEnterpriseProgram_IncompatibleAtomValidationWarning for any potentially faulty atoms
 * when changing enterprise program
 */
export type CourseDefaultEnterpriseProgram_IncompatibleAtomValidationWarning = {
  __typename?: 'CourseDefaultEnterpriseProgram_IncompatibleAtomValidationWarning';
  /** Atom id for the item that is invalid */
  atomId: Scalars['ID'];
  /** The course the incompatible atom comes from */
  incompatibleSourceCourse: Course_Course;
};

/** CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram failure result */
export type CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramFailure = {
  __typename?: 'CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramFailure';
  /** Any errors that occurred during the mutation */
  errors: Array<CourseDefaultEnterpriseProgram_Error>;
};

/** CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram mutation input */
export type CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramInput = {
  /** Course id to update the default enterprise program selection of */
  courseId: Scalars['ID'];
  /**
   * Default enterprise program id selection for a particular course id
   * This is used as a part of the Course Builder authoring flow, when embedding items author's select
   * from a list of enterprise program's to embed from.
   */
  defaultEnterpriseProgramId: Scalars['ID'];
};

/** CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram mutation result */
export type CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramResult = CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramFailure | CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramSuccess;

/** CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram successful result */
export type CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramSuccess = {
  __typename?: 'CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramSuccess';
  /** The updated course with the default enterprise program */
  course: Course_Course;
  /**
   * A list of incompatible atom validation warnings - atoms that are invalid in current course when
   * changing enterprise program
   */
  incompatibleAtomValidationWarnings?: Maybe<Array<CourseDefaultEnterpriseProgram_IncompatibleAtomValidationWarning>>;
};

export type CourseDerivativesV1 = {
  __typename?: 'CourseDerivativesV1';
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  avgLearningHoursAdjusted?: Maybe<Scalars['Float']>;
  catalogPrice?: Maybe<CourseDerivativesV1_Org_Coursera_Catalog_CatalogPrice>;
  commentCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isPrivateRatingCourse: Scalars['Boolean'];
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratingCount?: Maybe<Scalars['Float']>;
  skillTags?: Maybe<Array<Maybe<CourseDerivativesV1_Org_Coursera_Skill_Legacy_Api_SkillTag>>>;
  skillTagsForXDP?: Maybe<Array<Maybe<CourseDerivativesV1_Org_Coursera_Skill_Api_SkillTagForXdp>>>;
  truncatedDescription150Chars?: Maybe<Scalars['String']>;
};

export type CourseDerivativesV1Connection = {
  __typename?: 'CourseDerivativesV1Connection';
  elements: Array<Maybe<CourseDerivativesV1>>;
  paging: ResponsePagination;
};

export type CourseDerivativesV1Resource = {
  __typename?: 'CourseDerivativesV1Resource';
  get?: Maybe<CourseDerivativesV1>;
  multiGet?: Maybe<CourseDerivativesV1Connection>;
};


export type CourseDerivativesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type CourseDerivativesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CourseDerivativesV1_Org_Coursera_Catalog_CatalogPrice = {
  __typename?: 'CourseDerivativesV1_org_coursera_catalog_CatalogPrice';
  amount: Scalars['Float'];
  countryISOCode: Scalars['String'];
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  liableForTax: Scalars['Boolean'];
  productItemId: Scalars['String'];
  productPriceId: Scalars['String'];
  productType: Scalars['String'];
};

export type CourseDerivativesV1_Org_Coursera_Skill_Api_SkillTagForXdp = {
  __typename?: 'CourseDerivativesV1_org_coursera_skill_api_SkillTagForXDP';
  rnk?: Maybe<Scalars['Int']>;
  skillId?: Maybe<Scalars['String']>;
  skillName?: Maybe<Scalars['String']>;
};

export type CourseDerivativesV1_Org_Coursera_Skill_Legacy_Api_SkillTag = {
  __typename?: 'CourseDerivativesV1_org_coursera_skill_legacy_api_SkillTag';
  learnerChoiceScore?: Maybe<Scalars['Float']>;
  relevanceScore?: Maybe<Scalars['Float']>;
  skillName?: Maybe<Scalars['String']>;
};

export type CourseDerivativesV2 = {
  __typename?: 'CourseDerivativesV2';
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  avgLearningHoursAdjusted?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isPrivateRatingCourse: Scalars['Boolean'];
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratingCount?: Maybe<Scalars['Float']>;
  skillTags?: Maybe<Array<Maybe<CourseDerivativesV2_Org_Coursera_Skill_Legacy_Api_SkillTag>>>;
  skillTagsForXDP?: Maybe<Array<Maybe<CourseDerivativesV2_Org_Coursera_Skill_Api_SkillTagForXdp>>>;
};

export type CourseDerivativesV2Connection = {
  __typename?: 'CourseDerivativesV2Connection';
  elements: Array<Maybe<CourseDerivativesV2>>;
  paging: ResponsePagination;
};

export type CourseDerivativesV2Resource = {
  __typename?: 'CourseDerivativesV2Resource';
  get?: Maybe<CourseDerivativesV2>;
  multiGet?: Maybe<CourseDerivativesV2Connection>;
};


export type CourseDerivativesV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type CourseDerivativesV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CourseDerivativesV2_Org_Coursera_Skill_Api_SkillTagForXdp = {
  __typename?: 'CourseDerivativesV2_org_coursera_skill_api_SkillTagForXDP';
  rnk?: Maybe<Scalars['Int']>;
  skillId?: Maybe<Scalars['String']>;
  skillName?: Maybe<Scalars['String']>;
};

export type CourseDerivativesV2_Org_Coursera_Skill_Legacy_Api_SkillTag = {
  __typename?: 'CourseDerivativesV2_org_coursera_skill_legacy_api_SkillTag';
  learnerChoiceScore?: Maybe<Scalars['Float']>;
  relevanceScore?: Maybe<Scalars['Float']>;
  skillName?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type CourseItemChange = {
  __typename?: 'CourseItemChange';
  /** Atom id of change. */
  atomId: Scalars['String'];
  /**
   * The atom version associated with this change if available.
   * This can be used to link the authoring change log to published atoms.
   */
  atomVersion?: Maybe<Scalars['Int']>;
  /** Authoring-side id of branch the item being changed belongs to, if known. */
  branchId?: Maybe<Scalars['String']>;
  /** Type of the update */
  changeType: CourseItemChange_ChangeType;
  /** The id of this course item change (atom id and sequence number). */
  courseItemChangeId: Scalars['String'];
  /** Whether the change was made by coursera or the partner */
  courseraOrPartnerChange?: Maybe<CourseChange_CourseraOrPartner>;
  /** Custom display typename field that can be set to override how item typename is displayed. */
  customDisplayTypenameOverride?: Maybe<Scalars['String']>;
  /** Grouped items that are present if this change is of type GROUPED_CHANGES. */
  groupedChanges?: Maybe<Array<CourseItemChange>>;
  /** The item id on the branch being queried. This may be absent when querying by atom. */
  itemId?: Maybe<Scalars['String']>;
  /** Whether the item is graded or not, only saved for deleted item, and added to response for existing items */
  itemIsGraded: Scalars['Boolean'];
  /** Eligible for assignments, to determine whether the item is a team assignment or not. */
  itemIsTeamSubmissionEnabled?: Maybe<Scalars['Boolean']>;
  /** Most recent name of the item, including draft name if it exists. */
  itemName: Scalars['String'];
  /** Name of the item type. */
  itemTypeName: Scalars['String'];
  /** If the change is UNLINK_ITEM, the id of the atom that was unlinked. */
  sourceAtomId?: Maybe<Scalars['String']>;
  /**
   * Authoring-side id of branch the reference item originated from, if known.
   * For example: this field will be populated when copying an item from the ('sourceBranchId')
   * branch to the destination branch ('branchId').
   */
  sourceBranchId?: Maybe<Scalars['String']>;
  /** More information about the source branch when populated. */
  sourceBranchInfo?: Maybe<CourseItemChange_SourceBranchInfo>;
  /** The previous order of the item in the module */
  sourceIndex?: Maybe<Scalars['Int']>;
  /** Source lesson id (for item move) */
  sourceLessonId?: Maybe<Scalars['ID']>;
  /** Source module id (for item move) */
  sourceModuleId?: Maybe<Scalars['ID']>;
  /** The new order of the item in the module */
  targetIndex?: Maybe<Scalars['Int']>;
  /** Target lesson id (for item move) */
  targetLessonId?: Maybe<Scalars['ID']>;
  /** Target module id (for item move) */
  targetModuleId?: Maybe<Scalars['ID']>;
  /** Time of the update. */
  updatedAt: Timestamp;
  /** Id of User who made the update. */
  updatedBy: Scalars['Int'];
  /** Full name of user in updatedBy field. */
  updatedByUserName: Scalars['String'];
};

/** TODO: Complete this description */
export type CourseItemChangeQueries = {
  __typename?: 'CourseItemChangeQueries';
  /** This query returns the change with the most recent value of updatedAt for a given atom id. */
  getLatestChange?: Maybe<CourseItemChange>;
  /** This query returns the change with the most recent value of updatedAt for a given branch id. */
  latestByBranch?: Maybe<CourseItemChange>;
  /**
   * This query returns a URL to a CSV file of course item changes filtered by authoringCourseBranchId,
   * courseItemChangeType, dateRangeStart, dateRangeEnd, searchText (matching item name or name of
   * updating user), itemType, and itemIsGraded.
   *
   * Filters that are absent or consist of empty lists will be ignored.
   */
  prepareCsvFileByBranch?: Maybe<Scalars['String']>;
  /**
   * This query returns course item changes filtered by authoringCourseBranchId, courseItemChangeType,
   * dateRangeStart, dateRangeEnd, searchText (matching item name or name of updating user),
   * itemType, and itemIsGraded.
   *
   * It will group certain changes if groupChanges is true. start and limit are used to limit the results
   * returned.
   *
   * Filters that are absent or consist of empty lists will be ignored.
   */
  queryCourseItemChangeByBranch?: Maybe<CourseItemChange_Page>;
};


/** TODO: Complete this description */
export type CourseItemChangeQueriesGetLatestChangeArgs = {
  atomId: Scalars['String'];
  atomVersion?: InputMaybe<Scalars['Int']>;
  changeTypes?: InputMaybe<Array<CourseItemChange_ChangeType>>;
};


/** TODO: Complete this description */
export type CourseItemChangeQueriesLatestByBranchArgs = {
  authoringCourseBranchId: Scalars['String'];
};


/** TODO: Complete this description */
export type CourseItemChangeQueriesPrepareCsvFileByBranchArgs = {
  authoringCourseBranchId: Scalars['String'];
  courseItemChangeType?: InputMaybe<Array<CourseItemChange_ChangeType>>;
  dateRangeEnd?: InputMaybe<Scalars['Int']>;
  dateRangeStart?: InputMaybe<Scalars['Int']>;
  isGraded?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Array<Scalars['String']>>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** TODO: Complete this description */
export type CourseItemChangeQueriesQueryCourseItemChangeByBranchArgs = {
  authoringCourseBranchId: Scalars['String'];
  courseItemChangeType?: InputMaybe<Array<CourseItemChange_ChangeType>>;
  dateRangeEnd?: InputMaybe<Scalars['Int']>;
  dateRangeStart?: InputMaybe<Scalars['Int']>;
  groupChanges: Scalars['Boolean'];
  isGraded?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Array<Scalars['String']>>;
  limit: Scalars['Int'];
  searchText?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
};

/** TODO: Complete this description */
export const CourseItemChange_ChangeType = {
  /** The atom was forked. */
  CopyItem: 'COPY_ITEM',
  /** The atom was created. */
  CreateItem: 'CREATE_ITEM',
  /** The atom was deleted from this branch. */
  DeleteItem: 'DELETE_ITEM',
  /** The atom was duplicated in this branch. */
  DuplicateItem: 'DUPLICATE_ITEM',
  /** The atom draft was edited. */
  EditDraft: 'EDIT_DRAFT',
  /** The atom was frozen in this branch. */
  FreezeItem: 'FREEZE_ITEM',
  /** This course item change represents a group of changes. */
  GroupedChanges: 'GROUPED_CHANGES',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** The atom was linked to this branch. */
  LinkItem: 'LINK_ITEM',
  /** The atom was moved */
  MoveItem: 'MOVE_ITEM',
  /** The atom draft was published. */
  PublishItem: 'PUBLISH_ITEM',
  /** The atom was reordered */
  ReorderItem: 'REORDER_ITEM',
  /** The atom draft was reverted. */
  RevertDraft: 'REVERT_DRAFT',
  /** The atom was unfrozen in this branch. */
  UnfreezeItem: 'UNFREEZE_ITEM',
  /** The atom was unlinked and copied to this branch. */
  UnlinkItem: 'UNLINK_ITEM'
} as const;

export type CourseItemChange_ChangeType = typeof CourseItemChange_ChangeType[keyof typeof CourseItemChange_ChangeType];
/** TODO: Complete this description */
export type CourseItemChange_FilterValues = {
  __typename?: 'CourseItemChange_FilterValues';
  /** Values that match course item change type in byBranch query. */
  changeTypes: Array<CourseItemChange_ChangeType>;
  /** Values that match course item type names in byBranch query. */
  itemTypes: Array<Scalars['String']>;
};

/** TODO: Complete this description */
export type CourseItemChange_Page = {
  __typename?: 'CourseItemChange_Page';
  /** A list of course item changes matching criteria. */
  changes?: Maybe<Array<CourseItemChange>>;
  /** Filter values for change type and item type. */
  filterValues?: Maybe<CourseItemChange_FilterValues>;
  /** The next start value for which there are results, if present. Otherwise, this is the last page. */
  next?: Maybe<Scalars['Int']>;
  /** The total number of results available, ignoring grouping. */
  total: Scalars['Int'];
};

/** TODO: Complete this description */
export type CourseItemChange_SourceBranchInfo = {
  __typename?: 'CourseItemChange_SourceBranchInfo';
  /**
   * Custom label if sourceBranchId is known and course has custom label.
   * It is used when constructing a response to a byBranch query.
   */
  sourceBranchCourseCustomLabel?: Maybe<Scalars['String']>;
  /**
   * Indicates whether course for sourceBranchId is accessible to user.
   * It is used when constructing a response to a byBranch query and depends on userId.
   */
  sourceBranchCourseIsAccessible: Scalars['Boolean'];
  /**
   * Name of course of source branch if sourceBranchId is known.
   * It is used when constructing a response to a byBranch query.
   */
  sourceBranchCourseName: Scalars['String'];
  /**
   * Slug of source branch if sourceBranchId is known.
   * It is used when constructing a response to a byBranch query.
   */
  sourceBranchCourseSlug: Scalars['String'];
  /**
   * Name of source branch if sourceBranchId is known.
   * It is used when constructing a response to a byBranch query.
   */
  sourceBranchName: Scalars['String'];
};

/** Queries for course items. */
export type CourseItemsQueries = {
  __typename?: 'CourseItemsQueries';
  /** Get all the items of a specific type in the specific type given the course id. In case multiple items are found across the branches, only return one. */
  getItemsAcrossBranches: ItemPlatform_AuthoringItemsPaginatedResult;
};


/** Queries for course items. */
export type CourseItemsQueriesGetItemsAcrossBranchesArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemType: Scalars['String'];
  limit?: Scalars['Int'];
};

export type CourseMessagesV1 = {
  __typename?: 'CourseMessagesV1';
  id: Scalars['String'];
  messages: Array<Maybe<CourseMessagesV1_Org_Coursera_Coursemessages_CourseMessage>>;
  pageContext: Scalars['String'];
  userCourseSlug: CourseMessagesV1_Org_Coursera_Ondemand_Common_UserCourseIdentifier_UserCourseSlug;
};

export type CourseMessagesV1Connection = {
  __typename?: 'CourseMessagesV1Connection';
  elements: Array<Maybe<CourseMessagesV1>>;
  paging: ResponsePagination;
};

export type CourseMessagesV1FindCourseMessages = {
  __typename?: 'CourseMessagesV1FindCourseMessages';
  connection?: Maybe<CourseMessagesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type CourseMessagesV1Resource = {
  __typename?: 'CourseMessagesV1Resource';
  findCourseMessages?: Maybe<CourseMessagesV1Connection>;
  get?: Maybe<CourseMessagesV1>;
  multiGet?: Maybe<CourseMessagesV1Connection>;
};


export type CourseMessagesV1ResourceFindCourseMessagesArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CourseMessagesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type CourseMessagesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CourseMessagesV1_CalendarSyncMessageMember = {
  __typename?: 'CourseMessagesV1_calendarSyncMessageMember';
  calendarSyncMessage: CourseMessagesV1_Org_Coursera_Coursemessages_CalendarSyncMessage;
};

export type CourseMessagesV1_CmlMember = {
  __typename?: 'CourseMessagesV1_cmlMember';
  cml: CourseMessagesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type CourseMessagesV1_CourseScheduleAdjustmentMessageMember = {
  __typename?: 'CourseMessagesV1_courseScheduleAdjustmentMessageMember';
  courseScheduleAdjustmentMessage: CourseMessagesV1_Org_Coursera_Coursemessages_CourseScheduleAdjustmentMessage;
};

export type CourseMessagesV1_DeadlineOverdueMessageMember = {
  __typename?: 'CourseMessagesV1_deadlineOverdueMessageMember';
  deadlineOverdueMessage: CourseMessagesV1_Org_Coursera_Coursemessages_DeadlineOverdueMessage;
};

export type CourseMessagesV1_DegreeUpsellMessageMember = {
  __typename?: 'CourseMessagesV1_degreeUpsellMessageMember';
  degreeUpsellMessage: CourseMessagesV1_Org_Coursera_Coursemessages_DegreeUpsellMessage;
};

export type CourseMessagesV1_GradeDisclaimerMessageMember = {
  __typename?: 'CourseMessagesV1_gradeDisclaimerMessageMember';
  gradeDisclaimerMessage: CourseMessagesV1_Org_Coursera_Coursemessages_GradeDisclaimerMessage;
};

export type CourseMessagesV1_JoinNextSessionMessageMember = {
  __typename?: 'CourseMessagesV1_joinNextSessionMessageMember';
  joinNextSessionMessage: CourseMessagesV1_Org_Coursera_Coursemessages_JoinNextSessionMessage;
};

export type CourseMessagesV1_NewEnrollmentPersonalizedScheduleMessageMember = {
  __typename?: 'CourseMessagesV1_newEnrollmentPersonalizedScheduleMessageMember';
  newEnrollmentPersonalizedScheduleMessage: CourseMessagesV1_Org_Coursera_Coursemessages_NewEnrollmentPersonalizedScheduleMessage;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type CourseMessagesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'CourseMessagesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<CourseMessagesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type CourseMessagesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'CourseMessagesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<CourseMessagesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type CourseMessagesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'CourseMessagesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: CourseMessagesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type CourseMessagesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'CourseMessagesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_CalendarSyncMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_CalendarSyncMessage';
  ArbitraryField: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_CourseMessage = CourseMessagesV1_CalendarSyncMessageMember | CourseMessagesV1_CourseScheduleAdjustmentMessageMember | CourseMessagesV1_DeadlineOverdueMessageMember | CourseMessagesV1_DegreeUpsellMessageMember | CourseMessagesV1_GradeDisclaimerMessageMember | CourseMessagesV1_JoinNextSessionMessageMember | CourseMessagesV1_NewEnrollmentPersonalizedScheduleMessageMember | CourseMessagesV1_ReferralMessageMember | CourseMessagesV1_S12nUpgradeMessageMember | CourseMessagesV1_S12nUpsellMessageMember | CourseMessagesV1_UserVerificationRequiredMessageMember;

/** Used instead of [[JoinNextSessionMessage]] for learners in sessions v2 experiment. This essentially replaces all messages about session switching. */
export type CourseMessagesV1_Org_Coursera_Coursemessages_CourseScheduleAdjustmentMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_CourseScheduleAdjustmentMessage';
  courseId: Scalars['String'];
  isCoursePassed: Scalars['Boolean'];
  suggestion: CourseMessagesV1_Suggestion;
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_DeadlineOverdueMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_DeadlineOverdueMessage';
  courseId: Scalars['String'];
  deadline: Scalars['Float'];
  hasEnrollableSession: Scalars['Boolean'];
  hasUnsubmittedPeerReviews: Scalars['Boolean'];
  isPeerReviewOverdue: Scalars['Boolean'];
  isSessionPrivate: Scalars['Boolean'];
  sessionEndDateTime: Scalars['Float'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_DegreeUpsellMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_DegreeUpsellMessage';
  degreeName: Scalars['String'];
  degreeSlug: Scalars['String'];
  partnerName: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_GradeDisclaimerMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_GradeDisclaimerMessage';
  message?: Maybe<Scalars['String']>;
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_JoinNextSessionMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_JoinNextSessionMessage';
  courseId: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_NewEnrollmentPersonalizedScheduleMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_NewEnrollmentPersonalizedScheduleMessage';
  ArbitraryField: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_ReferralMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_ReferralMessage';
  ArbitraryField: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpdate = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_S12nUpdate';
  name: Scalars['String'];
  newS12nId: Scalars['String'];
  oldS12nId: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpgradeMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_S12nUpgradeMessage';
  s12nUpdates: Array<Maybe<CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpdate>>;
  upgradePreferences: Array<Maybe<CourseMessagesV1_Org_Coursera_User_Models_S12nUpgradeUserPreferenceEntry>>;
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpsellMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_S12nUpsellMessage';
  courseId: Scalars['String'];
  isEnrolledInCourse: Scalars['Boolean'];
  isEnrolledInS12n: Scalars['Boolean'];
  isHybridCourse: Scalars['Boolean'];
  s12nId: Scalars['String'];
  s12nIsCertificate: Scalars['Boolean'];
  s12nName: Scalars['String'];
  s12nSlug: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationRequiredMessage = {
  __typename?: 'CourseMessagesV1_org_coursera_coursemessages_UserVerificationRequiredMessage';
  verificationType: CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType;
};

export const CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType = {
  IdVerification: 'ID_VERIFICATION',
  NameAttestation: 'NAME_ATTESTATION'
} as const;

export type CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType = typeof CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType[keyof typeof CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationType];
export type CourseMessagesV1_Org_Coursera_Ondemand_Common_UserCourseIdentifier_UserCourseSlug = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_common_UserCourseIdentifier_UserCourseSlug';
  courseSlug: Scalars['String'];
  userId: Scalars['Int'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type CourseMessagesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<CourseMessagesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_BranchChange = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_BranchChange';
  changesDescription: CourseMessagesV1_CmlMember;
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_Extension';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason;
  sessionSwitch?: Maybe<CourseMessagesV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_ExtensionMember';
  org_coursera_ondemand_schedule_suggestion_Extension: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension;
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_NoSuggestion';
  reason: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason;
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_NoSuggestionMember';
  org_coursera_ondemand_schedule_suggestion_NoSuggestion: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion;
};

export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
/** Terminology: A "deadline" is a single point on a horizontal timeline. BeginningOfTime-----Deadline----EndofTime/Future "Moving forwards" is to move the deadline to the right                     Deadline-->>> Shift all deadlines forward by "days" Eg. Given Original Schedule: Let S = start Let E = end Let days = 4 1 2 3 4 5 6[S---------E] Becomes      [S--------E] If the shift in deadlines causes the user to be too far off from the relative schedule of other learners in the Cohort, they might not get enough time for Peer Review. Then we must recommend a new "Public Session/Cohort" Public Sessions act as "Cohorts/Groups" for learners in SessionsV2. Learners still receive their Peer Review Feedback from learners in the same Public Session, but have deadlines set to their own Personalized Schedule. */
export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlines';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason;
  sessionSwitch?: Maybe<CourseMessagesV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlinesMember';
  org_coursera_ondemand_schedule_suggestion_ShiftDeadlines: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines;
};

export const CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal';
  ArbitraryField: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoalMember';
  org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal: CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal;
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Session_SuggestedSwitch = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_session_SuggestedSwitch';
  branchChange?: Maybe<CourseMessagesV1_Org_Coursera_Ondemand_Schedule_BranchChange>;
  destinationSessionBranchId: Scalars['String'];
  destinationSessionId: Scalars['String'];
  sourceSessionBranchId: Scalars['String'];
  sourceSessionId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_session_SuggestedSwitchMember';
  org_coursera_ondemand_session_SuggestedSwitch: CourseMessagesV1_Org_Coursera_Ondemand_Session_SuggestedSwitch;
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_session_SwitchNotNeeded';
  ArbitraryField: Scalars['String'];
};

export type CourseMessagesV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember = {
  __typename?: 'CourseMessagesV1_org_coursera_ondemand_session_SwitchNotNeededMember';
  org_coursera_ondemand_session_SwitchNotNeeded: CourseMessagesV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded;
};

export type CourseMessagesV1_Org_Coursera_User_Models_S12nUpgradeUserPreferenceEntry = {
  __typename?: 'CourseMessagesV1_org_coursera_user_models_S12nUpgradeUserPreferenceEntry';
  dismissedTime?: Maybe<Scalars['Float']>;
  stayedTime?: Maybe<Scalars['Float']>;
  upgradeTime?: Maybe<Scalars['Float']>;
};

export type CourseMessagesV1_ReferralMessageMember = {
  __typename?: 'CourseMessagesV1_referralMessageMember';
  referralMessage: CourseMessagesV1_Org_Coursera_Coursemessages_ReferralMessage;
};

export type CourseMessagesV1_S12nUpgradeMessageMember = {
  __typename?: 'CourseMessagesV1_s12nUpgradeMessageMember';
  s12nUpgradeMessage: CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpgradeMessage;
};

export type CourseMessagesV1_S12nUpsellMessageMember = {
  __typename?: 'CourseMessagesV1_s12nUpsellMessageMember';
  s12nUpsellMessage: CourseMessagesV1_Org_Coursera_Coursemessages_S12nUpsellMessage;
};

export type CourseMessagesV1_SessionSwitch = CourseMessagesV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember | CourseMessagesV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember;

export type CourseMessagesV1_Suggestion = CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember | CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember | CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember | CourseMessagesV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember;

export type CourseMessagesV1_UserVerificationRequiredMessageMember = {
  __typename?: 'CourseMessagesV1_userVerificationRequiredMessageMember';
  userVerificationRequiredMessage: CourseMessagesV1_Org_Coursera_Coursemessages_UserVerificationRequiredMessage;
};

/** Queries definition */
export type CourseNavigationQueries = {
  __typename?: 'CourseNavigationQueries';
  /** Query to get navigation items on demand by courseId */
  getCourseNavigationByUserIdCourseId?: Maybe<CourseNavigation_NavigationItems>;
  /** Query the logged in learner's next item for each course */
  getMyNextCourseItemsByCourseIds: Array<CourseNavigation_LearnerNextItemDetails>;
  /**
   * Query the logged-in learner's time-bound learning block for a course: an ordered list of the
   * learner's next items that together fit within the given target duration, intended to power
   * "learn for the next N minutes" experiences. Items appear in the same priority order used to
   * compute the learner's single next item, and are accumulated until the following item would push
   * the total over the target duration (a strict upper bound). When a learning block exists it always
   * contains at least one item — the top-priority item is returned even if it alone exceeds the target.
   * Returns null when the learner has no eligible next item (e.g. the course has already been passed,
   * the learner is not a current session member, or the course does not have sessions enabled).
   */
  getMyTimeBoundLearningBlock?: Maybe<CourseNavigation_TimeBoundLearningBlock>;
  /** MultiGet learners' next item. Internal use only. */
  multiGetNextCourseItem: Array<CourseNavigation_LearnerNextItemDetails>;
};


/** Queries definition */
export type CourseNavigationQueriesGetCourseNavigationByUserIdCourseIdArgs = {
  courseId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Queries definition */
export type CourseNavigationQueriesGetMyNextCourseItemsByCourseIdsArgs = {
  courseIds: Array<Scalars['ID']>;
};


/** Queries definition */
export type CourseNavigationQueriesGetMyTimeBoundLearningBlockArgs = {
  courseId: Scalars['ID'];
  targetDuration: Scalars['Duration'];
};


/** Queries definition */
export type CourseNavigationQueriesMultiGetNextCourseItemArgs = {
  inputs: Array<CourseNavigation_MultiGetLearnerNextItemInput>;
};

/** Additional details for assignment types (i.e. STAFF_GRADED or UNGRADED_ASSIGNMENT item types) */
export type CourseNavigation_AssignmentTypeDetails = {
  __typename?: 'CourseNavigation_AssignmentTypeDetails';
  /** Indicates if an assignment has team submissions enabled */
  isTeamSubmissionEnabled: Scalars['Boolean'];
};

/** Result of getIsCoursePreview query */
export type CourseNavigation_CoursePreviewResult = {
  __typename?: 'CourseNavigation_CoursePreviewResult';
  /** is course preview is a flag that help to validate if user has access to see certain compononents */
  isCoursePreview: Scalars['Boolean'];
};

/** This is a enum that represents the weekly progress deadline status. */
export const CourseNavigation_DeadlineStatus = {
  /** TODO: Complete this description */
  Completed: 'COMPLETED',
  /** TODO: Complete this description */
  Failed: 'FAILED',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** TODO: Complete this description */
  Ontrack: 'ONTRACK',
  /** TODO: Complete this description */
  Overdue: 'OVERDUE'
} as const;

export type CourseNavigation_DeadlineStatus = typeof CourseNavigation_DeadlineStatus[keyof typeof CourseNavigation_DeadlineStatus];
/**
 * Item type
 * Should match UpcomingItems_ItemType
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 * Deprecate some item types based on https://docs.google.com/document/d/1xj9ffO56LgpH-QXUzLFWjUi966r7M_rteIW0e_d97GQ/edit#heading=h.hgy0mtjf8o5u
 */
export const CourseNavigation_ItemType = {
  /** Assessment open single page */
  AssesOpenSinglePage: 'ASSES_OPEN_SINGLE_PAGE',
  /** Closed peer */
  ClosedPeer: 'CLOSED_PEER',
  /** Coach */
  Coach: 'COACH',
  /** Discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Exam */
  Exam: 'EXAM',
  /** Graded coach */
  GradedCoach: 'GRADED_COACH',
  /** Graded discussion prompt */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** Graded lab */
  GradedLab: 'GRADED_LAB',
  /** Graded LTI */
  GradedLti: 'GRADED_LTI',
  /** Graded peer */
  GradedPeer: 'GRADED_PEER',
  /** Graded programming */
  GradedProgramming: 'GRADED_PROGRAMMING',
  /** Graded widget */
  GradedWidget: 'GRADED_WIDGET',
  /** Lecture */
  Lecture: 'LECTURE',
  /** Notebook */
  Notebook: 'NOTEBOOK',
  /** Peer */
  Peer: 'PEER',
  /** Phased peer */
  PhasedPeer: 'PHASED_PEER',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming */
  Programming: 'PROGRAMMING',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Single question submit */
  SingleQuestionSubmit: 'SINGLE_QUESTION_SUBMIT',
  /** Slideshow */
  Slideshow: 'SLIDESHOW',
  /** Staff graded */
  StaffGraded: 'STAFF_GRADED',
  /** Supplement */
  Supplement: 'SUPPLEMENT',
  /** Teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded assignment */
  UngradedAssignment: 'UNGRADED_ASSIGNMENT',
  /** Ungraded lab */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded LTI */
  UngradedLti: 'UNGRADED_LTI',
  /** Ungraded programming */
  UngradedProgramming: 'UNGRADED_PROGRAMMING',
  /** Ungraded widget */
  UngradedWidget: 'UNGRADED_WIDGET',
  /** Wise flow */
  WiseFlow: 'WISE_FLOW',
  /** Workspace launcher */
  WorkspaceLauncher: 'WORKSPACE_LAUNCHER'
} as const;

export type CourseNavigation_ItemType = typeof CourseNavigation_ItemType[keyof typeof CourseNavigation_ItemType];
/** Additional details for specific item types */
export type CourseNavigation_ItemTypeDetails = CourseNavigation_AssignmentTypeDetails;

/** Learners next item within a course */
export type CourseNavigation_LearnerCourseItem = {
  __typename?: 'CourseNavigation_LearnerCourseItem';
  /** Item deadline */
  deadline?: Maybe<Scalars['DateTime']>;
  /** Estimated time to complete item */
  estimatedTimeToComplete: Scalars['Duration'];
  /** Item id */
  id: Scalars['ID'];
  /** Type of item, kept consistent with learner course timeline UpcomingItems_ItemType! */
  itemType: CourseNavigation_ItemType;
  /** Additional details for certain items */
  itemTypeDetails?: Maybe<CourseNavigation_ItemTypeDetails>;
  /** Module the item belongs to */
  module: CourseNavigation_ModuleDetails;
  /** Item name */
  name: Scalars['String'];
  /** Resource path for the item, used for constructing url's to guide learners directly to the item */
  resourcePath: Scalars['String'];
};

/** Entity representing the next up course item for a learner */
export type CourseNavigation_LearnerNextItemDetails = {
  __typename?: 'CourseNavigation_LearnerNextItemDetails';
  /** Course of the item */
  course: Course_Course;
  /**
   * Whether the course is completed or not, the next item is nullable and will be null if this
   * value is set to true
   */
  isCourseCompleted: Scalars['Boolean'];
  /** Next item for user within the course */
  nextItem?: Maybe<CourseNavigation_LearnerCourseItem>;
};

/** Object representing the encompassing module for a users next course item */
export type CourseNavigation_ModuleDetails = {
  __typename?: 'CourseNavigation_ModuleDetails';
  /** Module ID */
  id: Scalars['ID'];
  /** Module number */
  moduleIndex: Scalars['Int'];
};

/** This is a enum that represents the module types. */
export const CourseNavigation_ModuleType = {
  /** TODO: Complete this description */
  FirstWeek: 'FIRST_WEEK',
  /** TODO: Complete this description */
  Full: 'FULL',
  /** TODO: Complete this description */
  Preview: 'PREVIEW'
} as const;

export type CourseNavigation_ModuleType = typeof CourseNavigation_ModuleType[keyof typeof CourseNavigation_ModuleType];
/** Navigation item for Modules. */
export type CourseNavigation_ModulesNavigationItem = CourseNavigation_NavigationItem & {
  __typename?: 'CourseNavigation_ModulesNavigationItem';
  /** Current module is the first module that the learner does not have a COMPLETED status. */
  currentModule?: Maybe<Scalars['Int']>;
  /** an array of statuses, the index should be the module number */
  moduleStatuses?: Maybe<Array<CourseNavigation_NavigationModule>>;
  /** Module type. */
  moduleType?: Maybe<CourseNavigation_ModuleType>;
  /** type */
  type: CourseNavigation_NavigationItemType;
};

/** Input for multiGet learner next item */
export type CourseNavigation_MultiGetLearnerNextItemInput = {
  /** Course id */
  courseId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

/** interface navigation items */
export type CourseNavigation_NavigationItem = {
  /** type */
  type: CourseNavigation_NavigationItemType;
};

/** navigation items types */
export const CourseNavigation_NavigationItemType = {
  /** TODO: Complete this description */
  Admin: 'ADMIN',
  /** TODO: Complete this description */
  Classmates: 'CLASSMATES',
  /** TODO: Complete this description */
  CourseInfo: 'COURSE_INFO',
  /** TODO: Complete this description */
  CourseManager: 'COURSE_MANAGER',
  /** TODO: Complete this description */
  DiscussionForums: 'DISCUSSION_FORUMS',
  /** TODO: Complete this description */
  Grades: 'GRADES',
  /** TODO: Complete this description */
  Inbox: 'INBOX',
  /** TODO: Complete this description */
  Modules: 'MODULES',
  /** TODO: Complete this description */
  Notes: 'NOTES',
  /** TODO: Complete this description */
  OfficeHours: 'OFFICE_HOURS',
  /** TODO: Complete this description */
  PreviewCourse: 'PREVIEW_COURSE',
  /** TODO: Complete this description */
  PreviewFirstWeek: 'PREVIEW_FIRST_WEEK',
  /** TODO: Complete this description */
  Resources: 'RESOURCES',
  /** TODO: Complete this description */
  Teamwork: 'TEAMWORK'
} as const;

export type CourseNavigation_NavigationItemType = typeof CourseNavigation_NavigationItemType[keyof typeof CourseNavigation_NavigationItemType];
/**
 * Result of queryNavigationItemsByUserCourseId, where you can request navigation items on demand
 * If a navigation item is returned, the UI should render the nav item that redirect to the component it represents
 * If navigation item doesn't meet certain rules, it could be null and the nav item shouldn't be showed in the UI
 * There are two special types of navigation items that carry more data to show in the UI, resources and modules
 */
export type CourseNavigation_NavigationItems = {
  __typename?: 'CourseNavigation_NavigationItems';
  /** admin */
  admin?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** classmates */
  classmates?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** course info */
  courseInfo?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** course manager */
  courseManager?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** discussion */
  discussionForums?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** grades */
  grades?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** id, it would be combination of user~courseId */
  id?: Maybe<Scalars['ID']>;
  /** inbox */
  inbox?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** modules */
  modules?: Maybe<CourseNavigation_ModulesNavigationItem>;
  /** notes */
  notes?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** office hours */
  officeHours?: Maybe<CourseNavigation_SimpleNavigationItem>;
  /** resources */
  resources?: Maybe<CourseNavigation_ResourcesNavigationItem>;
  /** team work */
  teamwork?: Maybe<CourseNavigation_SimpleNavigationItem>;
};

/** Type for Module Definition */
export type CourseNavigation_NavigationModule = {
  __typename?: 'CourseNavigation_NavigationModule';
  /** Deadline Status. */
  deadlineStatus: CourseNavigation_DeadlineStatus;
  /** Module number */
  moduleNumber?: Maybe<Scalars['Int']>;
};

/** Type for resource definition */
export type CourseNavigation_ResourceNavigationSubItem = {
  __typename?: 'CourseNavigation_ResourceNavigationSubItem';
  /** Resource name. */
  name: Scalars['String'];
  /** Resource identifier. */
  shortReferenceId: Scalars['ID'];
};

/** Navigation item for resources. */
export type CourseNavigation_ResourcesNavigationItem = CourseNavigation_NavigationItem & {
  __typename?: 'CourseNavigation_ResourcesNavigationItem';
  /** List of Resources */
  resources?: Maybe<Array<CourseNavigation_ResourceNavigationSubItem>>;
  /** type */
  type: CourseNavigation_NavigationItemType;
};

/** General Navigation item */
export type CourseNavigation_SimpleNavigationItem = CourseNavigation_NavigationItem & {
  __typename?: 'CourseNavigation_SimpleNavigationItem';
  /** type */
  type: CourseNavigation_NavigationItemType;
};

/**
 * A time-bound learning block: an ordered list of the learner's next items that together fit within a
 * requested target duration, intended to power "learn for the next N minutes" experiences. Items appear
 * in the same priority order used to compute the learner's single next item. The total estimated time
 * is at most the requested target duration, unless the single top item already exceeds it (in which case
 * that item is returned on its own).
 */
export type CourseNavigation_TimeBoundLearningBlock = {
  __typename?: 'CourseNavigation_TimeBoundLearningBlock';
  /**
   * The ordered next items that make up this learning block, in the order the learner should work
   * through them. Never empty when the block is present.
   */
  nextItems: Array<CourseNavigation_LearnerCourseItem>;
  /** The sum of the estimated time to complete every item in nextItems. */
  totalEstimatedTime: Scalars['Duration'];
};

/** Course offering error response */
export type CourseOfferingErrorResponse = {
  __typename?: 'CourseOfferingErrorResponse';
  /** The course offering response error code */
  courseOfferingError: CourseOffering_Error;
  /** Error message pertaining to the failed request */
  errorMsg: Scalars['String'];
};

/**
 * Course offering input class is needed as GraphQL must differentiate between input and types even
 * though similar structures are followed.
 *
 * Description of each field follows those in [courseoffering.graphqls].
 */
export type CourseOfferingInput = {
  /** The catalog availability setting of the offering. See [[CatalogAvailability]] for more details. */
  catalogAvailability: CourseOffering_CatalogAvailabilityUnionInput;
  /**
   * The courseId of the course the offering is part of. The relationship between an offering and a course
   * is 1:1.
   */
  courseId: Scalars['ID'];
  /** The default feature set of the offering. See [[DefaultFeatureSet]] for more details. */
  defaultFeatureSet: CourseOffering_DefaultFeatureSet;
  /**
   * Externally managed offerings are offerings created and managed outside of the educator
   * experience that should not be visible to admins in authoring flows.
   *
   * These offerings are currently used to support custom academic terms for MOOCs in C4C
   * enterprise programs. However, this flag is only intended to allow excluding these
   * offerings in authoring flows as a workaround for the lack of enterprise-admin / session-level
   * permissions. For additional details, see: http:go.dkandu.me/externallymanagedsession
   */
  isExternallyManaged: Scalars['Boolean'];
  /** The schedule availability of the offering. See [[ScheduleAvailability]] for more details. */
  scheduleAvailability: CourseOffering_ScheduleAvailabilityUnionInput;
  /** The schedule experience of the offering. See [[ScheduleExperience]] for more details. */
  scheduleExperience: CourseOffering_ScheduleExperienceUnionInput;
};

/** Course offering mutation queries */
export type CourseOfferingMutationQueries = {
  __typename?: 'CourseOfferingMutationQueries';
  /** Create a course offering */
  createCourseOffering: CreateCourseOfferingResponse;
  /** Delete a course offering */
  deleteCourseOffering: DeleteCourseOfferingResponse;
  /** Update a course offering */
  updateCourseOffering: UpdateCourseOfferingResponse;
};


/** Course offering mutation queries */
export type CourseOfferingMutationQueriesCreateCourseOfferingArgs = {
  input: CreateCourseOfferingRequest;
};


/** Course offering mutation queries */
export type CourseOfferingMutationQueriesDeleteCourseOfferingArgs = {
  input: DeleteCourseOfferingRequest;
};


/** Course offering mutation queries */
export type CourseOfferingMutationQueriesUpdateCourseOfferingArgs = {
  input: UpdateCourseOfferingRequest;
};

/** All course offering queries */
export type CourseOfferingQueries = {
  __typename?: 'CourseOfferingQueries';
  /** Get all offerings by courseID */
  getByCourseId: Array<CourseOfferingResponse>;
  /** Get by course offering ID */
  getByCourseOfferingId?: Maybe<CourseOfferingResponse>;
};


/** All course offering queries */
export type CourseOfferingQueriesGetByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/** All course offering queries */
export type CourseOfferingQueriesGetByCourseOfferingIdArgs = {
  courseOfferingId: Scalars['ID'];
};

/** Course offering response containing the offering itself and the offering's related sessions */
export type CourseOfferingResponse = {
  __typename?: 'CourseOfferingResponse';
  /** The course offering object */
  courseOffering: CourseOffering_Record;
  /** The course offering sessions that are linked to the course offering */
  courseOfferingSession: Array<CourseOffering_CourseSession>;
};

/** The course offering generates sessions on a recurring basis indefinitely. */
export type CourseOffering_AlwaysAvailability = {
  __typename?: 'CourseOffering_AlwaysAvailability';
  /**  eslint-disable-next-line custom-rules/related-id */
  branchId: Scalars['ID'];
  repeatFrequency: CourseOffering_RepeatFrequency;
};

/** The course offering generates sessions on a recurring basis indefinitely. */
export type CourseOffering_AlwaysAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  branchId: Scalars['ID'];
  /**  eslint-disable @graphql-eslint/require-description */
  repeatFrequency: CourseOffering_RepeatFrequencyUnionInput;
};

/**
 * The catalog availability of an offering. Note that the field denotes the INTENTION of publishing to
 * a catalog. It does NOT guarantee that the offering is actually published to a catalog.
 */
export type CourseOffering_CatalogAvailability = CourseOffering_EnterpriseAdminCatalogs | CourseOffering_NoCatalogs | CourseOffering_PublicCatalog;

/**
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type CourseOffering_CatalogAvailabilityUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  enterpriseAdminCatalogs?: InputMaybe<CourseOffering_EnterpriseAdminCatalogsInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  noCatalogs?: InputMaybe<CourseOffering_NoCatalogsInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  publicCatalog?: InputMaybe<CourseOffering_PublicCatalogInput>;
};

/**
 * A CohortBased learning experience means that learners enrolled in the offering will be bound by the session
 * start time, end time, item deadlines, etc. All learners in a same session will have the same experience with no
 * personalized treatment. The field selfSwitchOfferingSchedule controls whether learners should be able to self-serve
 * switch between sessions in the CohortBased offering.
 *
 * A CohortBased offering experience may use any type of availability format.
 */
export type CourseOffering_CohortBased = {
  __typename?: 'CourseOffering_CohortBased';
  /** If true, allows user to switch between sessions */
  selfSwitchOfferingSchedule: Scalars['Boolean'];
};

/**
 * A CohortBased learning experience means that learners enrolled in the offering will be bound by the session
 * start time, end time, item deadlines, etc. All learners in a same session will have the same experience with no
 * personalized treatment. The field selfSwitchOfferingSchedule controls whether learners should be able to self-serve
 * switch between sessions in the CohortBased offering.
 *
 * A CohortBased offering experience may use any type of availability format.
 */
export type CourseOffering_CohortBasedInput = {
  /** If true, allows user to switch between sessions */
  selfSwitchOfferingSchedule: Scalars['Boolean'];
};

/** A course session object used in session enrollment and course offering queries */
export type CourseOffering_CourseSession = {
  __typename?: 'CourseOffering_CourseSession';
  /** The course that the session belongs to */
  courseId: Scalars['ID'];
  /** Time when the session ends */
  endsAtTime: Timestamp;
  /** Time when enrollment into the session ends */
  enrollmentEndsAtTime: Timestamp;
  /** Unique ID of the session */
  id: Scalars['ID'];
  /** If the session is a preview session */
  isPreview: Scalars['Boolean'];
  /** List of module ID to it's deadline */
  moduleDeadlines: Array<CourseOffering_ModuleDeadlines>;
  /** Tune when the session beings */
  startsAtTime: Timestamp;
};

/**
 * The default feature set describes a default set of features that corresponds with the old MOOC/HE split,
 * which we have renamed to Basic/HighEngagement here.
 *
 * In the later phases, we will transition towards granular feature toggles powered by ProductFeatures,
 * and the default feature set will not be materialized anymore (but will stil be author facing). In the interim it is
 * still convenient to have something that corresponds to the MOOC/HE split before we have time to split out all of the
 * existing behavior into granular features.
 *
 * Please see the section titled "OfferingType and FeatureSet" in the proposal for more details:
 * https://docs.google.com/document/d/1N4cu3R-rjLwiZs9WAky53qirc7IlYsR2z9byWOCyAo8/edit?usp=sharing
 */
export const CourseOffering_DefaultFeatureSet = {
  /** Basic feature set akin to old MOOC features */
  DefaultFeatureSetBasic: 'DEFAULT_FEATURE_SET_BASIC',
  /** High engagement feature set such as timed quizzes */
  DefaultFeatureSetHighEngagement: 'DEFAULT_FEATURE_SET_HIGH_ENGAGEMENT'
} as const;

export type CourseOffering_DefaultFeatureSet = typeof CourseOffering_DefaultFeatureSet[keyof typeof CourseOffering_DefaultFeatureSet];
/**
 * An offering with an EnterpriseAdminCatalogs catalog setting appears in the admin catalog of
 * enterprise organizations, and potentially curated into an enterprise program.
 */
export type CourseOffering_EnterpriseAdminCatalogs = {
  __typename?: 'CourseOffering_EnterpriseAdminCatalogs';
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: Maybe<Scalars['String']>;
};

/**
 * An offering with an EnterpriseAdminCatalogs catalog setting appears in the admin catalog of
 * enterprise organizations, and potentially curated into an enterprise program.
 */
export type CourseOffering_EnterpriseAdminCatalogsInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/**
 * Generic error codes for failed GraphQL mutation requests.
 * TODO: Make more meaningful/specific errors as the Offerings app gets further developed.
 */
export const CourseOffering_Error = {
  /** A create offering mutation error. */
  CreateOfferingError: 'CREATE_OFFERING_ERROR',
  /** A delete offering mutation error. */
  DeleteOfferingError: 'DELETE_OFFERING_ERROR',
  /** An update offering mutation error. */
  UpdateOfferingError: 'UPDATE_OFFERING_ERROR'
} as const;

export type CourseOffering_Error = typeof CourseOffering_Error[keyof typeof CourseOffering_Error];
/** The generation window for creating limited available recurring sessions. */
export type CourseOffering_GenerationWindow = {
  __typename?: 'CourseOffering_GenerationWindow';
  /** The end time of the generation window */
  endsAtTime: Timestamp;
  /** The start time of the generation window */
  startsAtTime: Timestamp;
};

/** The generation window for creating limited available recurring sessions. */
export type CourseOffering_GenerationWindowInput = {
  /** The end time of the generation window */
  endsAtTime: TimestampInput;
  /** The start time of the generation window */
  startsAtTime: TimestampInput;
};

/** The course offering generates sessions on a recurring basis based on certain generation windows. */
export type CourseOffering_LimitedAvailability = {
  __typename?: 'CourseOffering_LimitedAvailability';
  /**  eslint-disable-next-line custom-rules/related-id */
  branchId: Scalars['ID'];
  /** eslint-disable-next-line @graphql-eslint/relay-edge-types */
  generationWindow: Array<CourseOffering_GenerationWindow>;
  postStartEnrollmentDuration: Scalars['Duration'];
  repeatFrequency: CourseOffering_RepeatFrequency;
};

/** The course offering generates sessions on a recurring basis based on certain generation windows. */
export type CourseOffering_LimitedAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  branchId: Scalars['ID'];
  /**  eslint-disable @graphql-eslint/require-description */
  generationWindow: Array<CourseOffering_GenerationWindowInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  postStartEnrollmentDuration: Scalars['Duration'];
  /**  eslint-disable @graphql-eslint/require-description */
  repeatFrequency: CourseOffering_RepeatFrequencyUnionInput;
};

/** The course offering does not generate sessions automatically. */
export type CourseOffering_ManualAvailability = {
  __typename?: 'CourseOffering_ManualAvailability';
  dummy?: Maybe<Scalars['String']>;
};

/** The course offering does not generate sessions automatically. */
export type CourseOffering_ManualAvailabilityInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** Module deadlines object */
export type CourseOffering_ModuleDeadlines = {
  __typename?: 'CourseOffering_ModuleDeadlines';
  /** Deadline of the module */
  deadline: Timestamp;
  /** Module ID */
  moduleId: Scalars['ID'];
};

/** A schedule availability that generates recurring sessions on a monthly timeline */
export type CourseOffering_Monthly = {
  __typename?: 'CourseOffering_Monthly';
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of the month this event should repeat on. Must be <= 28 to allow all months.
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfMonth <= 28, "Day of month should be <= 28")
   */
  dayOfMonth: Scalars['Int'];
};

/** A schedule availability that generates recurring sessions on a monthly timeline */
export type CourseOffering_MonthlyInput = {
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of the month this event should repeat on. Must be <= 28 to allow all months.
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfMonth <= 28, "Day of month should be <= 28")
   */
  dayOfMonth: Scalars['Int'];
};

/** An offering with a NoCatalogs catalog availability setting should not appear in any catalog. */
export type CourseOffering_NoCatalogs = {
  __typename?: 'CourseOffering_NoCatalogs';
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: Maybe<Scalars['String']>;
};

/** An offering with a NoCatalogs catalog availability setting should not appear in any catalog. */
export type CourseOffering_NoCatalogsInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/**
 * An offering with an PublicCatalog catalog setting can appear in any catalog.
 *
 * GraphQL does not allow types to have no fields- a dummy variable is placed here to prevent errors
 */
export type CourseOffering_PublicCatalog = {
  __typename?: 'CourseOffering_PublicCatalog';
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: Maybe<Scalars['String']>;
};

/** An offering with an PublicCatalog catalog setting can appear in any catalog. */
export type CourseOffering_PublicCatalogInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** A course offering object */
export type CourseOffering_Record = {
  __typename?: 'CourseOffering_Record';
  /** The catalog availability setting of the offering. See [[CatalogAvailability]] for more details. */
  catalogAvailability: CourseOffering_CatalogAvailability;
  /**
   * The courseId of the course the offering is part of. The relationship between an offering and a course
   * is 1:1.
   */
  courseId: Scalars['ID'];
  /** The course offering id. */
  courseOfferingId: Scalars['ID'];
  /** The default feature set of the offering. See [[DefaultFeatureSet]] for more details. */
  defaultFeatureSet: CourseOffering_DefaultFeatureSet;
  /**
   * Externally managed offerings are offerings created and managed outside of the educator
   * experience that should not be visible to admins in authoring flows.
   *
   * These offerings are currently used to support custom academic terms for MOOCs in C4C
   * enterprise programs. However, this flag is only intended to allow excluding these
   * offerings in authoring flows as a workaround for the lack of enterprise-admin / session-level
   * permissions. For additional details, see: http:go.dkandu.me/externallymanagedsession
   */
  isExternallyManaged: Scalars['Boolean'];
  /** The schedule availability of the offering. See [[ScheduleAvailability]] for more details. */
  scheduleAvailability: CourseOffering_ScheduleAvailability;
  /** The schedule experience of the offering. See [[ScheduleExperience]] for more details. */
  scheduleExperience: CourseOffering_ScheduleExperience;
};

/**  eslint-disable-next-line custom-rules/namespaced-types */
export type CourseOffering_RepeatFrequency = CourseOffering_Monthly | CourseOffering_Weekly;

export type CourseOffering_RepeatFrequencyUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  monthly?: InputMaybe<CourseOffering_MonthlyInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  weekly?: InputMaybe<CourseOffering_WeeklyInput>;
};

/** The schedule availability options for an offering. */
export type CourseOffering_ScheduleAvailability = CourseOffering_AlwaysAvailability | CourseOffering_LimitedAvailability | CourseOffering_ManualAvailability;

/** The schedule availability options for an offering. */
export type CourseOffering_ScheduleAvailabilityUnionInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  alwaysAvailability?: InputMaybe<CourseOffering_AlwaysAvailabilityInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  limitedAvailability?: InputMaybe<CourseOffering_LimitedAvailabilityInput>;
  /**  eslint-disable @graphql-eslint/require-description */
  manualAvailability?: InputMaybe<CourseOffering_ManualAvailabilityInput>;
};

/** The schedule experience of an offering */
export type CourseOffering_ScheduleExperience = CourseOffering_CohortBased | CourseOffering_SelfPaced;

/** The schedule experience of an offering */
export type CourseOffering_ScheduleExperienceUnionInput = {
  cohortBased?: InputMaybe<CourseOffering_CohortBasedInput>;
  selfPaced?: InputMaybe<CourseOffering_SelfPacedInput>;
};

/**
 * A SelfPaced learning experience means that learners enrolled in the offering will be able to learn
 * at a self-paced rate with personalized deadlines that are tailored for each learner. It is also implicit that
 * learners will be able to self-serve switch into a next session should the session end before they complete the
 * course.
 */
export type CourseOffering_SelfPaced = {
  __typename?: 'CourseOffering_SelfPaced';
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: Maybe<Scalars['String']>;
};

/**
 * A SelfPaced learning experience means that learners enrolled in the offering will be able to learn
 * at a self-paced rate with personalized deadlines that are tailored for each learner. It is also implicit that
 * learners will be able to self-serve switch into a next session should the session end before they complete the
 * course.
 */
export type CourseOffering_SelfPacedInput = {
  /**  eslint-disable @graphql-eslint/require-description */
  dummy?: InputMaybe<Scalars['String']>;
};

/** A schedule availability that generates recurring sessions on a weekly timeline */
export type CourseOffering_Weekly = {
  __typename?: 'CourseOffering_Weekly';
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of week that this event should repeat on. Follows [[org.joda.time.DateTimeConstants]]
   * conventions for converting day of week to number. (Monday = 1, Tuesday = 2.. Sunday = 7)
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfWeek >= 1 && dayOfWeek <= 7, "Day of week should be between 1 and 7 (inclusive)")
   */
  dayOfWeek: Scalars['Int'];
};

/** A schedule availability that generates recurring sessions on a weekly timeline */
export type CourseOffering_WeeklyInput = {
  /** Repeats every n weeks. */
  cadence: Scalars['Int'];
  /**
   * Day of week that this event should repeat on. Follows [[org.joda.time.DateTimeConstants]]
   * conventions for converting day of week to number. (Monday = 1, Tuesday = 2.. Sunday = 7)
   *
   * require(n >= 1, "Repeat frequency should be positive")
   * require(dayOfWeek >= 1 && dayOfWeek <= 7, "Day of week should be between 1 and 7 (inclusive)")
   */
  dayOfWeek: Scalars['Int'];
};

/** Queries definition */
export type CoursePreviewQueries = {
  __typename?: 'CoursePreviewQueries';
  /** Query to get the flag to check if course is in preview mode */
  getIsCoursePreview?: Maybe<CourseNavigation_CoursePreviewResult>;
};


/** Queries definition */
export type CoursePreviewQueriesGetIsCoursePreviewArgs = {
  courseId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Queries related to course profiles */
export type CourseProfilesQueries = {
  __typename?: 'CourseProfilesQueries';
  /** Query course profiles for institution */
  queryCourseProfilesForInstitution: Array<CourseProfiles_Profile>;
  /** Query course profiles for program */
  queryCourseProfilesForProgram?: Maybe<CourseProfiles_ProgramProfiles>;
};


/** Queries related to course profiles */
export type CourseProfilesQueriesQueryCourseProfilesForInstitutionArgs = {
  institutionId: Scalars['ID'];
};


/** Queries related to course profiles */
export type CourseProfilesQueriesQueryCourseProfilesForProgramArgs = {
  programId: Scalars['ID'];
};

/** Configurable academic integrity feature */
export type CourseProfiles_AcademicIntegrityFeatureConfiguration = {
  __typename?: 'CourseProfiles_AcademicIntegrityFeatureConfiguration';
  /** Enabled status for Coursera Proctoring */
  isCourseraProctoringEnabled: Scalars['Boolean'];
  /** Enabled status for graded item locking */
  isGradedItemLockingEnabled: Scalars['Boolean'];
  /** Enabled status for Locking Browser */
  isLockingBrowserEnabled: Scalars['Boolean'];
  /** Peer Review AI Grading disabled */
  isPeerReviewAiGradingDisabled: Scalars['Boolean'];
};

/** Feature configuration as input */
export type CourseProfiles_AcademicIntegrityFeatureConfigurationInput = {
  /** Enabled status for Coursera Proctoring */
  isCourseraProctoringEnabled?: Scalars['Boolean'];
  /** Enabled status for graded item locking */
  isGradedItemLockingEnabled: Scalars['Boolean'];
  /** Enabled status for Locking Browser */
  isLockingBrowserEnabled?: Scalars['Boolean'];
  /** Peer Review AI Grading disabled */
  isPeerReviewAiGradingDisabled?: Scalars['Boolean'];
};

/** Error for this domain */
export type CourseProfiles_Error = {
  /** Error message */
  message: Scalars['String'];
};

/** An associated profile for some scope */
export type CourseProfiles_Profile = {
  __typename?: 'CourseProfiles_Profile';
  /** Features configured under this profile */
  featureConfiguration: CourseProfiles_AcademicIntegrityFeatureConfiguration;
  /** A unique ID for the course profile */
  id: Scalars['ID'];
  /** Course profile type */
  type: CourseProfiles_ProfileType;
};

/** Types of course profiles */
export const CourseProfiles_ProfileType = {
  /** Credential courses, such as those offered for-credit */
  Credential: 'CREDENTIAL',
  /** Non-credential courses, such as those offered not for-credit */
  NonCredential: 'NON_CREDENTIAL'
} as const;

export type CourseProfiles_ProfileType = typeof CourseProfiles_ProfileType[keyof typeof CourseProfiles_ProfileType];
/** Response container for program-level course profiles */
export type CourseProfiles_ProgramProfiles = {
  __typename?: 'CourseProfiles_ProgramProfiles';
  /** Is the list inherited from institution-level */
  isInheritedFromInstitution: Scalars['Boolean'];
  /** List of profiles */
  profiles: Array<CourseProfiles_Profile>;
};

/** Error that can usually be resolved through retrying the request */
export type CourseProfiles_RetryableError = CourseProfiles_Error & {
  __typename?: 'CourseProfiles_RetryableError';
  /** Error message */
  message: Scalars['String'];
};

/** Possible scopes for course profiles */
export const CourseProfiles_Scope = {
  /** Institution scope */
  Institution: 'INSTITUTION',
  /** Program scope */
  Program: 'PROGRAM'
} as const;

export type CourseProfiles_Scope = typeof CourseProfiles_Scope[keyof typeof CourseProfiles_Scope];
/** Result schema when updating a course profile for program fails */
export type CourseProfiles_UpdateCourseProfileForInstitutionFailure = {
  __typename?: 'CourseProfiles_UpdateCourseProfileForInstitutionFailure';
  /** Errors */
  errors: Array<CourseProfiles_RetryableError>;
};

/** Input schema for updating a course profile for institution */
export type CourseProfiles_UpdateCourseProfileForInstitutionInput = {
  /** Feature configurations to be set for the course profile */
  featureConfiguration: CourseProfiles_AcademicIntegrityFeatureConfigurationInput;
  /** The institution ID for which the course profile is to be updated */
  institutionId: Scalars['ID'];
  /** The course profile type to be updated */
  profileType: CourseProfiles_ProfileType;
};

/** Mutation response for updating a course profile for institution */
export type CourseProfiles_UpdateCourseProfileForInstitutionResult = CourseProfiles_UpdateCourseProfileForInstitutionFailure | CourseProfiles_UpdateCourseProfileForInstitutionSuccess;

/** Result schema for updating a course profile for institution */
export type CourseProfiles_UpdateCourseProfileForInstitutionSuccess = {
  __typename?: 'CourseProfiles_UpdateCourseProfileForInstitutionSuccess';
  /** Course profile ID of the updated course profile */
  courseProfileId: Scalars['ID'];
};

/** Result schema when updating a course profile for program fails */
export type CourseProfiles_UpdateCourseProfileForProgramFailure = {
  __typename?: 'CourseProfiles_UpdateCourseProfileForProgramFailure';
  /** Errors */
  errors: Array<CourseProfiles_RetryableError>;
};

/** Input schema for updating a course profile for program */
export type CourseProfiles_UpdateCourseProfileForProgramInput = {
  /** Feature configurations to be set for the course profile */
  featureConfiguration: CourseProfiles_AcademicIntegrityFeatureConfigurationInput;
  /** The course profile type to be updated */
  profileType: CourseProfiles_ProfileType;
  /** The program ID for which the course profile is to be updated */
  programId: Scalars['ID'];
};

/** Mutation response for updating a course profile for program */
export type CourseProfiles_UpdateCourseProfileForProgramResult = CourseProfiles_UpdateCourseProfileForProgramFailure | CourseProfiles_UpdateCourseProfileForProgramSuccess;

/** Result schema for updating a course profile for program */
export type CourseProfiles_UpdateCourseProfileForProgramSuccess = {
  __typename?: 'CourseProfiles_UpdateCourseProfileForProgramSuccess';
  /** Course profile ID of the updated course profile */
  courseProfileId: Scalars['ID'];
};

/** courseprogress GraphQL Schema */
export type CourseProgressQueries = {
  __typename?: 'CourseProgressQueries';
  /** Fetches the atom progress for a given user by id. */
  getAtomProgress: CourseProgress_AtomProgress;
  /** Fetches the atom progress for a given user by item interaction id. */
  queryAtomProgressByUserIdAndAtomId: CourseProgress_AtomProgress;
  /** Query to retrieve all the module progress for the user making the request + course, on the user's current active course branch */
  queryCourseBranchModuleProgressByCourse: Array<CourseProgress_CourseBranchModuleProgress>;
  /** Query to retrieve all the module progress for the user making the request + course branch */
  queryCourseBranchModuleProgressByCourseBranch: Array<CourseProgress_CourseBranchModuleProgress>;
  /** Query to retrieve the Module progress for a the user making the request + course branch + specific module */
  queryCourseBranchModuleProgressByCourseBranchModuleId: CourseProgress_CourseBranchModuleProgress;
  /** Fetches the course progress for a given user and course. */
  queryCourseProgressByUserIdAndCourseId: CourseProgress_CourseProgress;
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesGetAtomProgressArgs = {
  id: Scalars['ID'];
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesQueryAtomProgressByUserIdAndAtomIdArgs = {
  atomId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesQueryCourseBranchModuleProgressByCourseArgs = {
  courseId: Scalars['ID'];
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesQueryCourseBranchModuleProgressByCourseBranchArgs = {
  courseBranchId: Scalars['ID'];
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesQueryCourseBranchModuleProgressByCourseBranchModuleIdArgs = {
  courseBranchId: Scalars['ID'];
  moduleId: Scalars['ID'];
};


/** courseprogress GraphQL Schema */
export type CourseProgressQueriesQueryCourseProgressByUserIdAndCourseIdArgs = {
  courseId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Represents an error result. */
export type CourseProgress_ApplyCourseProgressOverrideError = CourseProgress_Error & {
  __typename?: 'CourseProgress_ApplyCourseProgressOverrideError';
  /** Error message. */
  message: Scalars['String'];
};

/** Input schema for ApplyCourseProgressOverride mutation */
export type CourseProgress_ApplyCourseProgressOverrideInput = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The explanation for the override. */
  explanation: Scalars['String'];
  /** The overridden grade. */
  grade: Scalars['Float'];
  /**
   * [Optional] The overridden passing state for the honors track.
   * If the course does not have an honors track, exclude this field.
   * If the course does have an honors track but this field is omitted,
   * it will not override the honors passing state and will use whatever
   * the learner earned.
   */
  honorsPassingState?: InputMaybe<CourseProgress_PassingState>;
  /** The overridden passing state for the core track. */
  passingState: CourseProgress_PassingState;
  /** The user id. */
  userId: Scalars['ID'];
};

/** Result schema for ApplyCourseProgressOverride mutation */
export type CourseProgress_ApplyCourseProgressOverrideResult = CourseProgress_ApplyCourseProgressOverrideError | CourseProgress_ApplyCourseProgressOverrideSuccess;

/** Represents a successful result. */
export type CourseProgress_ApplyCourseProgressOverrideSuccess = {
  __typename?: 'CourseProgress_ApplyCourseProgressOverrideSuccess';
  /** The course progress after the mutation. */
  courseProgress: CourseProgress_CourseProgress;
};

/** The completion status of the atom */
export const CourseProgress_AtomCompletionStatus = {
  /** The atom is completed */
  Completed: 'COMPLETED',
  /** The atom has an invalid state. */
  Invalid: 'INVALID',
  /** The atom is not yet started */
  NotStarted: 'NOT_STARTED',
  /** The atom is in progress */
  Started: 'STARTED'
} as const;

export type CourseProgress_AtomCompletionStatus = typeof CourseProgress_AtomCompletionStatus[keyof typeof CourseProgress_AtomCompletionStatus];
/** The grade of the atom */
export type CourseProgress_AtomGrade = {
  __typename?: 'CourseProgress_AtomGrade';
  /** The grade of the atom. Typical Range = 0.0 to 1.0 (100%). Could be more if extra credit is allowed. */
  grade: Scalars['Float'];
  /** when the grade was last computed */
  gradedAt: Scalars['DateTime'];
  /** true if the grade is a passing one */
  isPassed: Scalars['Boolean'];
  /** details around a potential late penalty */
  latePenaltyRatio?: Maybe<CourseProgress_LatePenaltyRatio>;
  /**
   * The grade that the learner would have received if the late penalty was not applied.
   * Typical Range = 0.0 to 1.0 (100%). Could be more if extra credit is allowed.
   */
  preLatePenaltyGrade?: Maybe<Scalars['Float']>;
};

/** The hidden state of a grade. If present, it means the learner should not see the grade yet. */
export type CourseProgress_AtomGradeHide = {
  __typename?: 'CourseProgress_AtomGradeHide';
  /** when grade was hidden */
  hiddenAt: Scalars['DateTime'];
  /** The user that hid the grade */
  hiddenBy: User_User;
};

/** Represents progress made from interacting with an atom. */
export type CourseProgress_AtomProgress = {
  __typename?: 'CourseProgress_AtomProgress';
  /** The atom id. */
  atomId: Scalars['ID'];
  /** The progress that the learner actually earned. */
  earned?: Maybe<CourseProgress_AtomProgressDetails>;
  /** If present, it means the learner should not see the grade. */
  gradeHide?: Maybe<CourseProgress_AtomGradeHide>;
  /** represents userId~atomId */
  id: Scalars['ID'];
  /** If present, it should replace the progress the learner earned. */
  override?: Maybe<CourseProgress_AtomProgressOverride>;
  /** Place where progress was last made. May be empty if no progress has been made yet. */
  progressUpdateContext?: Maybe<CourseProgress_ProgressUpdateContext>;
  /** Time when progress was last made. May be empty if no progress has been made yet. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User who last updated the atom progress. May be empty if no progress has been made yet. */
  updatedBy?: Maybe<User_User>;
  /** The user id */
  user: User_User;
  /** The version of the atom progress record. */
  version?: Maybe<Scalars['Int']>;
};

/** Represents the progress a learner has actually earned. */
export type CourseProgress_AtomProgressDetails = {
  __typename?: 'CourseProgress_AtomProgressDetails';
  /** The completion status of the atom */
  completionStatus: CourseProgress_AtomCompletionStatus;
  /** The content id (item-specific. could be assignment id, lecture id, etc.) */
  contentId?: Maybe<Scalars['ID']>;
  /** Progress related to the specific item type */
  contentProgress?: Maybe<CourseProgress_ContentProgress>;
  /** The content version (see contentId) */
  contentVersion?: Maybe<Scalars['Int']>;
  /** The grade of the atom */
  grade?: Maybe<CourseProgress_AtomGrade>;
  /** The time when the atom was graded */
  updatedAt: Scalars['DateTime'];
  /** The user that last updated the atom progress */
  updatedBy?: Maybe<User_User>;
};

/** If present, it should replace the progress the learner earned. */
export type CourseProgress_AtomProgressOverride = {
  __typename?: 'CourseProgress_AtomProgressOverride';
  /** The completion status of the atom */
  completionStatus?: Maybe<CourseProgress_AtomCompletionStatus>;
  /** The reason for the override (shown to learners) */
  explanation?: Maybe<Scalars['String']>;
  /** The grade of the atom */
  grade?: Maybe<CourseProgress_AtomGrade>;
  /** when the atom progress was overridden */
  overriddenAt: Scalars['DateTime'];
  /** The user that overrode the atom progress */
  overriddenBy: User_User;
  /** The reason for the override (shown to partners) */
  partnerExplanation?: Maybe<Scalars['String']>;
};

/** Represents progress made from interacting with an atom. */
export type CourseProgress_AtomProgressUpdateContext = {
  __typename?: 'CourseProgress_AtomProgressUpdateContext';
  /** The atom id. */
  atomId: Scalars['ID'];
  /** The item interaction id. */
  itemInteractionId: Scalars['ID'];
};

/** Progress information for the ClosedPeerReviewProgress type. */
export type CourseProgress_ClosedPeerReviewProgress = {
  __typename?: 'CourseProgress_ClosedPeerReviewProgress';
  /** Whether the learner has submitted. */
  isSubmitted: Scalars['Boolean'];
  /** Number of reviews required. */
  requiredReviewCount?: Maybe<Scalars['Int']>;
  /** Number of reviews received. */
  reviewCount: Scalars['Int'];
  /** The submission grade. */
  submissionGrade?: Maybe<CourseProgress_SubmissionGrade>;
};

/** Policy of the applied compound late penalty. */
export type CourseProgress_CompoundLatePenalty = {
  __typename?: 'CourseProgress_CompoundLatePenalty';
  /** The late penalty increment for the compound late penalty policy. */
  increment?: Maybe<CourseProgress_LatePenaltyIncrement>;
  /** An optional max score you could set if there is a late penalty. */
  maxAllowedScore?: Maybe<CourseProgress_LatePenaltyScoreCap>;
  /** The minimum score that can be awarded based on a late penalty. */
  minScoreThreshold?: Maybe<CourseProgress_LatePenaltyMinScoreThreshold>;
};

/** There is a complex late penalty formula with caps, floors, and incremental penalties. */
export type CourseProgress_CompoundLatePenaltyRatio = {
  __typename?: 'CourseProgress_CompoundLatePenaltyRatio';
  /** Policy when late penalty was applied. */
  penalty: CourseProgress_CompoundLatePenalty;
  /** The late penalty ratio. 1 = 100% penalty, 0.5 = 50% penalty, 0 = no penalty */
  ratio: Scalars['Float'];
  /** When the submission is due. */
  submissionDeadline: Scalars['DateTime'];
  /** When the learner submitted. */
  submissionTime: Scalars['DateTime'];
};

/** Course progress information for a specific item type. */
export type CourseProgress_ContentProgress = CourseProgress_ClosedPeerReviewProgress | CourseProgress_GradedDiscussionPromptProgress | CourseProgress_GradedPeerReviewProgress | CourseProgress_LegacyProgrammingProgress | CourseProgress_LtiProgress | CourseProgress_PeerReviewProgress | CourseProgress_PhasedPeerReviewProgress | CourseProgress_QuizProgress | CourseProgress_StaffGradedProgress | CourseProgress_TeammateReviewProgress | CourseProgress_WiseFlowProgress;

/** The completion status of an item within a course branch. */
export const CourseProgress_CourseBranchItemCompletionStatus = {
  /** The learner has completed the item. */
  Completed: 'COMPLETED',
  /** The learner has not started the item. */
  NotStarted: 'NOT_STARTED',
  /** The learner has started but not completed the item. */
  Started: 'STARTED'
} as const;

export type CourseProgress_CourseBranchItemCompletionStatus = typeof CourseProgress_CourseBranchItemCompletionStatus[keyof typeof CourseProgress_CourseBranchItemCompletionStatus];
/** A grade earned on a course branch item. The grade reflects the final value after any late penalty. */
export type CourseProgress_CourseBranchItemGrade = {
  __typename?: 'CourseProgress_CourseBranchItemGrade';
  /** The grade, between 0.0 and 1.0. */
  grade: Scalars['Float'];
  /** When the item was graded. */
  gradedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the item was passed. */
  isPassed: Scalars['Boolean'];
};

/**
 * The learner's progress on a single item within a course branch (learner view, based on the
 * canonical v1 DetailedItemProgress). Resolved off CourseProgress_CourseBranchProgress.itemProgresses.
 *
 * Grade-hide takes precedence over everything: when the learner's grade is hidden, `earned`,
 * `overall`, and any `override` are all masked as NOT_STARTED with no grade, so a hidden grade is
 * never exposed — even when an override exists. When the grade is not hidden, `overall` resolves as
 * the override if one exists, otherwise the earned values. Admin-only grade-hide metadata is
 * intentionally not exposed here.
 */
export type CourseProgress_CourseBranchItemProgress = {
  __typename?: 'CourseProgress_CourseBranchItemProgress';
  /** The earned progress. Masked as NOT_STARTED with no grade when the grade is hidden. */
  earned: CourseProgress_CourseBranchItemProgressDetails;
  /** Opaque entity identifier. */
  id: Scalars['ID'];
  /** The item the progress represents. */
  itemId: Scalars['ID'];
  /**
   * The resolved progress. Masked as NOT_STARTED with no grade when the grade is hidden; otherwise the
   * override if one exists, else the earned values.
   */
  overall: CourseProgress_CourseBranchItemProgressDetails;
  /** The administrator override, if one has been applied. Masked when the grade is hidden. */
  override?: Maybe<CourseProgress_CourseBranchItemProgressOverride>;
};

/** Progress details for a course branch item (used for the overall and earned contexts). */
export type CourseProgress_CourseBranchItemProgressDetails = {
  __typename?: 'CourseProgress_CourseBranchItemProgressDetails';
  /** The item's completion status. */
  completionStatus: CourseProgress_CourseBranchItemCompletionStatus;
  /** The grade for the item, present only if it has been graded (and not hidden). */
  grade?: Maybe<CourseProgress_CourseBranchItemGrade>;
  /** When this progress was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * An override applied to a learner's progress on a course branch item by an administrator. When
 * present, the item's `overall` reflects these values rather than the earned values.
 */
export type CourseProgress_CourseBranchItemProgressOverride = {
  __typename?: 'CourseProgress_CourseBranchItemProgressOverride';
  /** The overridden completion status. */
  completionStatus: CourseProgress_CourseBranchItemCompletionStatus;
  /** A human-readable explanation for the override. */
  explanation?: Maybe<Scalars['String']>;
  /** The overridden grade. */
  grade?: Maybe<CourseProgress_CourseBranchItemGrade>;
  /** When the override was applied. */
  overriddenAt: Scalars['DateTime'];
  /**
   * The administrator who applied the override. Visible only to privileged viewers (courserians / power users); null otherwise.
   * TODO(CE-8175): also allow course teachers/staff of this course (requires course-scoped authz;
   * not expressible in-schema on this nested field today).
   */
  overriddenBy?: Maybe<User_User>;
};

/** Represents progress made by interacting with a course branch item. */
export type CourseProgress_CourseBranchItemProgressUpdateContext = {
  __typename?: 'CourseProgress_CourseBranchItemProgressUpdateContext';
  /** The course. */
  course: Course_Course;
  /** The course branch id. */
  courseBranchId: Scalars['ID'];
  /** The course item id. */
  itemId: Scalars['ID'];
  /** The item interaction id. */
  itemInteractionId: Scalars['ID'];
};

/** The completion status of a course branch module */
export const CourseProgress_CourseBranchModuleCompletionStatus = {
  /** The module is completed */
  Completed: 'COMPLETED',
  /** No progress has been made on the module */
  NotStarted: 'NOT_STARTED',
  /** The module is not yet complete, but progress has been made */
  Started: 'STARTED',
  /** The completion status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_CourseBranchModuleCompletionStatus = typeof CourseProgress_CourseBranchModuleCompletionStatus[keyof typeof CourseProgress_CourseBranchModuleCompletionStatus];
/** The module completion progress of the module's constituent Graded Assignment Groups (GAGs) */
export type CourseProgress_CourseBranchModuleGagCompletionProgress = {
  __typename?: 'CourseProgress_CourseBranchModuleGagCompletionProgress';
  /** The completion status of the GAG, as it contributes towards the overall module's completion status */
  completionStatus: CourseProgress_CourseBranchModuleCompletionStatus;
  /** The GAG ID */
  gagId: Scalars['ID'];
};

/** The module completion progress of the module's constituent items */
export type CourseProgress_CourseBranchModuleItemCompletionProgress = {
  __typename?: 'CourseProgress_CourseBranchModuleItemCompletionProgress';
  /** The completion status of the item, as it contributes towards the overall module's completion status */
  completionStatus: CourseProgress_CourseBranchModuleCompletionStatus;
  /** The item ID */
  itemId: Scalars['ID'];
};

/** The course branch module progress for a specific user + course + branch + module */
export type CourseProgress_CourseBranchModuleProgress = {
  __typename?: 'CourseProgress_CourseBranchModuleProgress';
  /** The course that the progress represents */
  course: Course_Course;
  /** The course branch that the progress represents */
  courseBranchId: Scalars['ID'];
  /** The representation of how the graded assignment groups (GAGs) contributed towards the overall completion status */
  gagModuleCompletionProgresses: Array<CourseProgress_CourseBranchModuleGagCompletionProgress>;
  /** The representation of how the items in the module contributed towards the overall completion status */
  itemModuleCompletionProgresses: Array<CourseProgress_CourseBranchModuleItemCompletionProgress>;
  /** The overall completion status of the module */
  moduleCompletionStatus: CourseProgress_CourseBranchModuleCompletionStatus;
  /** The module that the progress represents */
  moduleId: Scalars['ID'];
  /** The position of the module in the course */
  moduleIndex?: Maybe<Scalars['Int']>;
  /** The user that the progress represents */
  user: User_User;
};

/**
 * The learner's branch-level progress aggregate for a course branch (the branch analogue of
 * CourseProgress_CourseProgress). Accords with the canonical v1 BranchProgress model.
 */
export type CourseProgress_CourseBranchProgress = {
  __typename?: 'CourseProgress_CourseBranchProgress';
  /** The course this branch belongs to. */
  course: Course_Course;
  /** The course branch the progress represents. */
  courseBranchId: Scalars['ID'];
  /** Progress recomputed against the current course content. Null when not available. */
  current?: Maybe<CourseProgress_CourseBranchProgressDetails>;
  /** Progress based on what has been graded. Null when the learner has no progress yet. */
  earned?: Maybe<CourseProgress_CourseBranchProgressDetails>;
  /** Opaque entity identifier. */
  id: Scalars['ID'];
  /**
   * The learner's per-item progress within this branch (learner view; grade-hide applied). Resolved
   * on demand, so it is only fetched when requested.
   */
  itemProgresses: Array<CourseProgress_CourseBranchItemProgress>;
  /**
   * The resolved progress: the override if one exists, otherwise the earned values. Null when the
   * learner has no progress on the branch yet (initial state).
   */
  overall?: Maybe<CourseProgress_CourseBranchProgressDetails>;
  /** The admin override, if one has been applied. */
  override?: Maybe<CourseProgress_CourseBranchProgressOverride>;
};

/** The grade and passing state for a learner on a course branch. */
export type CourseProgress_CourseBranchProgressDetails = {
  __typename?: 'CourseProgress_CourseBranchProgressDetails';
  /** The number of core-track items the learner has completed. */
  coreTrackCompletedItemsCount?: Maybe<Scalars['Int']>;
  /** The number of core-track items the learner has passed. */
  coreTrackPassedItemsCount?: Maybe<Scalars['Int']>;
  /** The core-track passing state. */
  coreTrackPassingState: CourseProgress_PassingState;
  /** The aggregate branch grade, between 0.0 and 1.0. */
  grade: Scalars['Float'];
  /** The honors-track passing state, present only if the course has an honors track. */
  honorsTrackPassingState?: Maybe<CourseProgress_PassingState>;
  /** When the learner last had activity in this branch. */
  latestActivityAt?: Maybe<Scalars['DateTime']>;
};

/**
 * An override applied to a learner's branch-level progress by an administrator. When present, the
 * branch's `overall` reflects these values rather than the earned values.
 */
export type CourseProgress_CourseBranchProgressOverride = {
  __typename?: 'CourseProgress_CourseBranchProgressOverride';
  /** The overridden core-track passing state. */
  coreTrackPassingState: CourseProgress_PassingState;
  /** A human-readable explanation for the override. */
  explanation?: Maybe<Scalars['String']>;
  /** The overridden grade, between 0.0 and 1.0. */
  grade: Scalars['Float'];
  /** The overridden honors-track passing state, present only if the course has an honors track. */
  honorsTrackPassingState?: Maybe<CourseProgress_PassingState>;
  /** When the override was applied. */
  overriddenAt: Scalars['DateTime'];
  /**
   * The administrator who applied the override. Visible only to privileged viewers (courserians / power users); null otherwise.
   * TODO(CE-8175): also allow course teachers/staff of this course (requires course-scoped authz;
   * not expressible in-schema on this nested field today).
   */
  overriddenBy?: Maybe<User_User>;
};

/** Represents progress made by interacting with a course branch (but not a specific item). */
export type CourseProgress_CourseBranchProgressUpdateContext = {
  __typename?: 'CourseProgress_CourseBranchProgressUpdateContext';
  /** The course. */
  course: Course_Course;
  /** The course branch id. */
  courseBranchId: Scalars['ID'];
};

/** Course progress for a particular user and course. */
export type CourseProgress_CourseProgress = {
  __typename?: 'CourseProgress_CourseProgress';
  /** The course. */
  course: Course_Course;
  /** The course progress grade and passing state the learner actually earned. */
  earned: CourseProgress_CourseProgressDetails;
  /** Opaque entity identifier. */
  id: Scalars['ID'];
  /** The course progress grade and passing state (may reflect an override if present). */
  overall: CourseProgress_CourseProgressDetails;
  /** An optional override for the course progress grade and passing state. */
  override?: Maybe<CourseProgress_CourseProgressOverride>;
  /** The time the learner progress was last updated. If empty, the user has no progress. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The version of the course progress record. If empty, the user has no progress. */
  version?: Maybe<Scalars['Int']>;
};

/**
 * Represents the course progress and grade for a learner. The actual values here will either
 * represent the earned grade, the "current" grade, the grade override, or the overall grade depending on
 * the context.
 */
export type CourseProgress_CourseProgressDetails = {
  __typename?: 'CourseProgress_CourseProgressDetails';
  /** The overall progress percentage. */
  grade: Scalars['Float'];
  /** The course passing state (or projected passing state if "current" calculation is used). */
  passingState: CourseProgress_PassingState;
};

/** Represents an override for the course progress and grade for a learner. */
export type CourseProgress_CourseProgressOverride = {
  __typename?: 'CourseProgress_CourseProgressOverride';
  /** The explanation for the override. */
  explanation: Scalars['String'];
  /** The overridden grade. */
  grade: Scalars['Float'];
  /** [Optional] The overridden passing state for the honors track. */
  honorsPassingState?: Maybe<CourseProgress_PassingState>;
  /** The time the override was applied. */
  overriddenAt: Scalars['DateTime'];
  /** The user who applied the override. */
  overriddenBy: User_PublicUser;
  /** The overridden passing state for the core track. */
  passingState: CourseProgress_PassingState;
};

/** Represents progress made by interacting with a course (but not in a specific branch). */
export type CourseProgress_CourseProgressUpdateContext = {
  __typename?: 'CourseProgress_CourseProgressUpdateContext';
  /** The course. */
  course: Course_Course;
};

/** CourseProgress domain error interface */
export type CourseProgress_Error = {
  /** The error message. */
  message: Scalars['String'];
};

/** Simplest type. If the learner is at all late, they get a fixed penalty. */
export type CourseProgress_FixedLatePenaltyRatio = {
  __typename?: 'CourseProgress_FixedLatePenaltyRatio';
  /** The late penalty ratio. 1 = 100% penalty, 0.5 = 50% penalty, 0 = no penalty */
  ratio: Scalars['Float'];
};

/** Progress information for the GradedDiscussionPromptProgress type. */
export type CourseProgress_GradedDiscussionPromptProgress = {
  __typename?: 'CourseProgress_GradedDiscussionPromptProgress';
  /** Time when grading is supposed to start */
  gradingStartsAt?: Maybe<Scalars['DateTime']>;
};

/** Progress information for the GradedPeerReviewProgress type. */
export type CourseProgress_GradedPeerReviewProgress = {
  __typename?: 'CourseProgress_GradedPeerReviewProgress';
  /** Whether the learner has submitted. */
  isSubmitted: Scalars['Boolean'];
  /** Number of reviews required. */
  requiredReviewCount?: Maybe<Scalars['Int']>;
  /** Number of reviews received. */
  reviewCount: Scalars['Int'];
  /** The submission grade. */
  submissionGrade?: Maybe<CourseProgress_SubmissionGrade>;
};

/** There is an incremental penalty applied to the grade that depends on how late it is. */
export type CourseProgress_IncrementalLatePenaltyRatio = {
  __typename?: 'CourseProgress_IncrementalLatePenaltyRatio';
  /** The time between submission and hard deadline. */
  duration: Scalars['Duration'];
  /** The late penalty ratio. 1 = 100% penalty, 0.5 = 50% penalty, 0 = no penalty */
  ratio: Scalars['Float'];
};

/** Whether a late penalty is a fraction of the awarded score or a decrease in points of the awarded score. */
export const CourseProgress_LatePenaltyApplicationMode = {
  /** Apply the penalty as a fraction of the awarded score. */
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  /** Apply the penalty as a decrease in points of the awarded score. */
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE',
  /** An invalid late penalty application mode. */
  Invalid: 'INVALID'
} as const;

export type CourseProgress_LatePenaltyApplicationMode = typeof CourseProgress_LatePenaltyApplicationMode[keyof typeof CourseProgress_LatePenaltyApplicationMode];
/** The late penalty increment for the compound late penalty policy. */
export type CourseProgress_LatePenaltyIncrement = {
  __typename?: 'CourseProgress_LatePenaltyIncrement';
  /** The frequency at which the penalty should be applied. */
  applicationFrequency: CourseProgress_LatePenaltyPeriod;
  /** Whether the penalty should be interpreted as a fraction of the awarded score or as a decrease in the awarded score. */
  applicationMode: CourseProgress_LatePenaltyApplicationMode;
  /** The maximum number of times the penalty should be applied. */
  maxApplications?: Maybe<Scalars['Int']>;
  /** The penalty to apply per increment. */
  penalty: Scalars['Float'];
};

/** The minimum score that can be awarded based on a late penalty. */
export type CourseProgress_LatePenaltyMinScoreThreshold = {
  __typename?: 'CourseProgress_LatePenaltyMinScoreThreshold';
  /** The minimum score that can be awarded based on a late penalty. */
  minScore: Scalars['Float'];
};

/** The period of time over which a late penalty is applied. */
export type CourseProgress_LatePenaltyPeriod = {
  __typename?: 'CourseProgress_LatePenaltyPeriod';
  /** The period length. e.g. 3 (days), 2 (weeks), etc. */
  count: Scalars['Int'];
  /** The period type. e.g. (3) days, (2) weeks, etc. */
  periodType: CourseProgress_LatePenaltyPeriodType;
};

/** The period of time over which a late penalty is applied. */
export const CourseProgress_LatePenaltyPeriodType = {
  /** The period occurs every day. */
  Day: 'DAY',
  /** The period occurs every hour. */
  Hour: 'HOUR',
  /** The period is infinite. */
  Infinity: 'INFINITY',
  /** An invalid late penalty period type. */
  Invalid: 'INVALID',
  /** The period occurs every minute. */
  Minute: 'MINUTE',
  /** The period occurs every month. */
  Month: 'MONTH',
  /** The period occurs every week. */
  Week: 'WEEK',
  /** The period is zero (applies immediately). */
  Zero: 'ZERO'
} as const;

export type CourseProgress_LatePenaltyPeriodType = typeof CourseProgress_LatePenaltyPeriodType[keyof typeof CourseProgress_LatePenaltyPeriodType];
/** The late penalty applied to a grade. */
export type CourseProgress_LatePenaltyRatio = CourseProgress_CompoundLatePenaltyRatio | CourseProgress_FixedLatePenaltyRatio | CourseProgress_IncrementalLatePenaltyRatio;

/** An optional max score you could set if there is a late penalty. */
export type CourseProgress_LatePenaltyScoreCap = {
  __typename?: 'CourseProgress_LatePenaltyScoreCap';
  /** The score cap to apply the penalty to. */
  applyAfter: CourseProgress_LatePenaltyPeriod;
  /** The maximum score that can be awarded. */
  maxScore: Scalars['Float'];
};

/** Progress information for the LegacyProgrammingProgress type. */
export type CourseProgress_LegacyProgrammingProgress = {
  __typename?: 'CourseProgress_LegacyProgrammingProgress';
  /** Sentinel value to avoid empty model. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress information for a specific item type. */
export const CourseProgress_LtiActivityProgressStatus = {
  /** The activity has been completed. */
  Completed: 'COMPLETED',
  /** The activity has been initialized. */
  Initialized: 'INITIALIZED',
  /** The activity is in progress. */
  InProgress: 'IN_PROGRESS',
  /** The activity has been started. */
  Started: 'STARTED',
  /** The activity has been submitted. */
  Submitted: 'SUBMITTED',
  /** The activity progress status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_LtiActivityProgressStatus = typeof CourseProgress_LtiActivityProgressStatus[keyof typeof CourseProgress_LtiActivityProgressStatus];
/** Progress information for a specific item type. */
export const CourseProgress_LtiGradingProgressStatus = {
  /** The grading could not complete. */
  Failed: 'FAILED',
  /** The grading process is completed; the score value, if any represents the current Final Grade */
  FullyGraded: 'FULLY_GRADED',
  /** There is no grading process occurring(for example, the student has not yet made any submission) */
  NotReady: 'NOT_READY',
  /**
   * Final Grade is pending but does not require manual intervention; if a Score value is present,
   * it indicates the current value is partial and may be updated.
   */
  Pending: 'PENDING',
  /**
   * Final Grade is pending, and it does require human intervention; if a Score value is present, it
   * indicates the current value is partial and maybe updated during the manual grading.
   */
  PendingManual: 'PENDING_MANUAL',
  /** The grading progress status is unknown. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_LtiGradingProgressStatus = typeof CourseProgress_LtiGradingProgressStatus[keyof typeof CourseProgress_LtiGradingProgressStatus];
/** Progress information for the LtiProgress type. */
export type CourseProgress_LtiProgress = {
  __typename?: 'CourseProgress_LtiProgress';
  /** Progress status of the activity. */
  activityProgressStatus: CourseProgress_LtiActivityProgressStatus;
  /** Progress status of the grading. */
  gradingProgressStatus: CourseProgress_LtiGradingProgressStatus;
};

/** Passing state for courses and course branches. */
export const CourseProgress_PassingState = {
  /** No graded items. Can't be passed. */
  NotPassable: 'NOT_PASSABLE',
  /** Course is passable but learner has not passed. */
  NotPassed: 'NOT_PASSED',
  /** Course is passable and learner has passed. */
  Passed: 'PASSED',
  /** Not recognizable. */
  Unknown: 'UNKNOWN'
} as const;

export type CourseProgress_PassingState = typeof CourseProgress_PassingState[keyof typeof CourseProgress_PassingState];
/** Progress information for the PeerReviewProgress type. */
export type CourseProgress_PeerReviewProgress = {
  __typename?: 'CourseProgress_PeerReviewProgress';
  /** Whether the learner has submitted. */
  isSubmitted: Scalars['Boolean'];
  /** Number of reviews required. */
  requiredReviewCount?: Maybe<Scalars['Int']>;
  /** Number of reviews received. */
  reviewCount: Scalars['Int'];
};

/** Progress information for the PhasedPeerReviewProgress type. */
export type CourseProgress_PhasedPeerReviewProgress = {
  __typename?: 'CourseProgress_PhasedPeerReviewProgress';
  /** Whether the learner has submitted. */
  isSubmitted: Scalars['Boolean'];
  /** Number of reviews required. */
  requiredReviewCount: Scalars['Int'];
  /** Number of reviews received. */
  reviewCount: Scalars['Int'];
  /** The submission grade. */
  submissionGrade?: Maybe<CourseProgress_SubmissionGrade>;
};

/**
 * In a world where item-linking can link progress from one context to the next,
 * this shows where the progress was originally made.
 */
export type CourseProgress_ProgressUpdateContext = CourseProgress_AtomProgressUpdateContext | CourseProgress_CourseBranchItemProgressUpdateContext | CourseProgress_CourseBranchProgressUpdateContext | CourseProgress_CourseProgressUpdateContext | CourseProgress_UnknownUpdateContext;

/** Progress information for the QuizProgress type. */
export type CourseProgress_QuizProgress = {
  __typename?: 'CourseProgress_QuizProgress';
  /** Maximum score of quiz submission */
  maxScore: Scalars['Float'];
  /** Score of quiz submission */
  score: Scalars['Float'];
};

/** Represents an error result. */
export type CourseProgress_RemoveCourseProgressOverrideError = CourseProgress_Error & {
  __typename?: 'CourseProgress_RemoveCourseProgressOverrideError';
  /** Error message. */
  message: Scalars['String'];
};

/** Input schema for RemoveCourseProgressOverride mutation */
export type CourseProgress_RemoveCourseProgressOverrideInput = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** Result schema for RemoveCourseProgressOverride mutation */
export type CourseProgress_RemoveCourseProgressOverrideResult = CourseProgress_RemoveCourseProgressOverrideError | CourseProgress_RemoveCourseProgressOverrideSuccess;

/** Represents a successful result. */
export type CourseProgress_RemoveCourseProgressOverrideSuccess = {
  __typename?: 'CourseProgress_RemoveCourseProgressOverrideSuccess';
  /** The course progress after the mutation. */
  courseProgress: CourseProgress_CourseProgress;
};

/** Represents an error result. */
export type CourseProgress_ResyncCourseBranchProgressError = CourseProgress_Error & {
  __typename?: 'CourseProgress_ResyncCourseBranchProgressError';
  /** Error message. */
  message: Scalars['String'];
};

/** Input schema for resyncCourseBranchProgress mutation */
export type CourseProgress_ResyncCourseBranchProgressInput = {
  /** The courseBranchId. */
  courseBranchId: Scalars['ID'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** Result schema for resyncCourseBranchProgress mutation */
export type CourseProgress_ResyncCourseBranchProgressResult = CourseProgress_ResyncCourseBranchProgressError | CourseProgress_ResyncCourseBranchProgressSuccess;

/** Represents a successful result. */
export type CourseProgress_ResyncCourseBranchProgressSuccess = {
  __typename?: 'CourseProgress_ResyncCourseBranchProgressSuccess';
  /** just a placeholder fields to satisfy GraphQL requirement for at least one field */
  id?: Maybe<Scalars['ID']>;
};

/** Progress information for the StaffGradedProgress type. */
export type CourseProgress_StaffGradedProgress = {
  __typename?: 'CourseProgress_StaffGradedProgress';
  /** Whether the learner has submitted. */
  isSubmitted: Scalars['Boolean'];
};

/** Grade information for a submission. */
export type CourseProgress_SubmissionGrade = {
  __typename?: 'CourseProgress_SubmissionGrade';
  /** Maximum possible score. */
  maxScore: Scalars['Float'];
  /** Threshold for a passing score. */
  passingFraction: Scalars['Float'];
  /** Submission score. */
  score: Scalars['Float'];
};

/** Progress information for the TeammateReviewProgress type. */
export type CourseProgress_TeammateReviewProgress = {
  __typename?: 'CourseProgress_TeammateReviewProgress';
  /** Number of authored reviews. */
  authoredReviewCount: Scalars['Int'];
  /** Number of required reviews. */
  requiredReviewCount: Scalars['Int'];
};

/** Represents an error result. */
export type CourseProgress_ToggleAtomGradeHideError = CourseProgress_Error & {
  __typename?: 'CourseProgress_ToggleAtomGradeHideError';
  /** Error message. */
  message: Scalars['String'];
};

/** Input schema for toggleAtomGradeHide mutation */
export type CourseProgress_ToggleAtomGradeHideInput = {
  /** The atom id. */
  atomId: Scalars['ID'];
  /** If true, the grade should be hidden. If false, the grade should be shown. */
  hide: Scalars['Boolean'];
  /** The user id. */
  userId: Scalars['ID'];
};

/** Result schema for toggleAtomGradeHide mutation */
export type CourseProgress_ToggleAtomGradeHideResult = CourseProgress_ToggleAtomGradeHideError | CourseProgress_ToggleAtomGradeHideSuccess;

/** Represents a successful result. */
export type CourseProgress_ToggleAtomGradeHideSuccess = {
  __typename?: 'CourseProgress_ToggleAtomGradeHideSuccess';
  /** The atom progress after the mutation. */
  atomProgress: CourseProgress_AtomProgress;
};

/**
 * This is primarily for legacy data where the context of the progress update context was never recorded in our online
 * store. We have a rule that all progress moving forward needs an attribution but it's possible this context is missing
 * where we are copying legacy atom progress into our item progress store. This attribution allows us to set an attribution
 * so the progress doesn't get attributed again to that branch even if we don't necessary know where the progress was
 * originally made.
 */
export type CourseProgress_UnknownUpdateContext = {
  __typename?: 'CourseProgress_UnknownUpdateContext';
  /** Dummy field as you can't have an empty type. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress information for the WiseFlowProgress type. */
export type CourseProgress_WiseFlowProgress = {
  __typename?: 'CourseProgress_WiseFlowProgress';
  /** Time that the learner last submitted. */
  submittedAt?: Maybe<Scalars['DateTime']>;
};

/** All course metadata queries */
export type CourseQueries = {
  __typename?: 'CourseQueries';
  /**
   * Fetch a course basic information using a course id. The API could be accessed by all logged in
   * users. WARNING: this API will allow learners to access information for private courses, plesase
   * consult with #lms-cpm before using it.
   * TODO(#lms-authoring) - deprecate this API after the usage of calling it to fetch source
   * course info from a course builder course has been migrated to graphQl federation.
   */
  queryBasicInfoById?: Maybe<Course_BasicCourseInfo>;
  /** Fetch a course using a course id */
  queryById?: Maybe<Course_Course>;
  /** Fetch multiple courses using a list of course ids */
  queryByIds: Array<Course_Course>;
  /** Fetch a course using a course slug */
  queryBySlug?: Maybe<Course_Course>;
  /**
   * Given an array of slugs of Courses, return an array of the corresponding Courses. The array may contain
   * fewer results than the number of slugs passed in, if a Course with the corresponding slug does not exist.
   */
  queryBySlugs: Array<Course_Course>;
};


/** All course metadata queries */
export type CourseQueriesQueryBasicInfoByIdArgs = {
  id: Scalars['ID'];
};


/** All course metadata queries */
export type CourseQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** All course metadata queries */
export type CourseQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** All course metadata queries */
export type CourseQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};


/** All course metadata queries */
export type CourseQueriesQueryBySlugsArgs = {
  slugs: Array<Scalars['String']>;
};

/** Credential Track Session type */
export type CourseSession_CredentialTrackSession = {
  __typename?: 'CourseSession_CredentialTrackSession';
  /** Degree ID */
  degree: Degree_Degree;
};

/** Degree Session type */
export type CourseSession_DegreeSession = {
  __typename?: 'CourseSession_DegreeSession';
  /** Degree ID */
  degree: Degree_Degree;
};

/** Item Deadline type */
export type CourseSession_ItemDeadline = {
  __typename?: 'CourseSession_ItemDeadline';
  /** Deadline of the item */
  deadline: Scalars['DateTime'];
  /** Associated item Id */
  itemId: Scalars['ID'];
};

/** Module Deadline type */
export type CourseSession_ModuleDeadline = {
  __typename?: 'CourseSession_ModuleDeadline';
  /** Deadline of the module */
  deadline: Scalars['DateTime'];
  /** Associated module ID */
  moduleId: Scalars['ID'];
};

/** Schedule Override type */
export type CourseSession_ScheduleOverride = {
  __typename?: 'CourseSession_ScheduleOverride';
  /** Timed Item Locks */
  timedItemLocks: Array<CourseSession_TimedItemLock>;
};

/** Session Type Metadata type */
export type CourseSession_SessionTypeMetadata = CourseSession_CredentialTrackSession | CourseSession_DegreeSession;

/** Timed Item Lock type */
export type CourseSession_TimedItemLock = {
  __typename?: 'CourseSession_TimedItemLock';
  /** Relock Time */
  relockTime: Scalars['DateTime'];
  /** Timed Item Lock Custom Message, null if no message is present */
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  /** Unlock Time */
  unlockTime: Scalars['DateTime'];
};

export type CourseTypeMetadataV1 = {
  __typename?: 'CourseTypeMetadataV1';
  courseTypeMetadata: CourseTypeMetadataV1_CourseTypeMetadata;
  id: Scalars['String'];
  version: Scalars['Int'];
};

export type CourseTypeMetadataV1ByCourseType = {
  __typename?: 'CourseTypeMetadataV1ByCourseType';
  connection?: Maybe<CourseTypeMetadataV1Connection>;
  courseType: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type CourseTypeMetadataV1Connection = {
  __typename?: 'CourseTypeMetadataV1Connection';
  elements: Array<Maybe<CourseTypeMetadataV1>>;
  paging: ResponsePagination;
};

export type CourseTypeMetadataV1Resource = {
  __typename?: 'CourseTypeMetadataV1Resource';
  byCourseType?: Maybe<CourseTypeMetadataV1Connection>;
  get?: Maybe<CourseTypeMetadataV1>;
  getAll?: Maybe<CourseTypeMetadataV1Connection>;
  multiGet?: Maybe<CourseTypeMetadataV1Connection>;
};


export type CourseTypeMetadataV1ResourceByCourseTypeArgs = {
  courseType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CourseTypeMetadataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type CourseTypeMetadataV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CourseTypeMetadataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CourseTypeMetadataV1ResourceMutations = {
  __typename?: 'CourseTypeMetadataV1ResourceMutations';
  update?: Maybe<CourseTypeMetadataV1Connection>;
};


export type CourseTypeMetadataV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type CourseTypeMetadataV1_CmlMember = {
  __typename?: 'CourseTypeMetadataV1_cmlMember';
  cml: CourseTypeMetadataV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Marker for identifying what "type" of course a specific course shell is supposed to represent. Used for tailoring the learner and partner experience for each course type and for streamlined data reporting. This is modeled as a union rather than an enumeration to allow us to add course-type specific fields to these models, avoiding the possibility of invalid enumeration + field combinations. Type names should be kept in sync with the [[CourseType]] enum. */
export type CourseTypeMetadataV1_CourseTypeMetadata = CourseTypeMetadataV1_ProjectMember | CourseTypeMetadataV1_RhymeProjectMember | CourseTypeMetadataV1_ShortFormContentMember | CourseTypeMetadataV1_StandardCourseMember | CourseTypeMetadataV1_VerifiedSkillsCourseMember;

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type CourseTypeMetadataV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<CourseTypeMetadataV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type CourseTypeMetadataV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<CourseTypeMetadataV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type CourseTypeMetadataV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: CourseTypeMetadataV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type CourseTypeMetadataV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_ProjectMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_course_types_ProjectMetadata';
  screenshotUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  tasks?: Maybe<Array<Maybe<CourseTypeMetadataV1_CmlMember>>>;
  typeNameIndex: Scalars['String'];
};

export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_RhymeProjectMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_course_types_RhymeProjectMetadata';
  screenshotUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  tasks?: Maybe<Array<Maybe<CourseTypeMetadataV1_CmlMember>>>;
  typeNameIndex: Scalars['String'];
};

export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_ShortFormContentMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_course_types_ShortFormContentMetadata';
  typeNameIndex: Scalars['String'];
};

export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_StandardCourseMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_course_types_StandardCourseMetadata';
  typeNameIndex: Scalars['String'];
};

export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_VerifiedSkillsCourseMetadata = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_course_types_VerifiedSkillsCourseMetadata';
  typeNameIndex: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type CourseTypeMetadataV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'CourseTypeMetadataV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<CourseTypeMetadataV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type CourseTypeMetadataV1_ProjectMember = {
  __typename?: 'CourseTypeMetadataV1_projectMember';
  project: CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_ProjectMetadata;
};

export type CourseTypeMetadataV1_RhymeProjectMember = {
  __typename?: 'CourseTypeMetadataV1_rhymeProjectMember';
  rhymeProject: CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_RhymeProjectMetadata;
};

export type CourseTypeMetadataV1_ShortFormContentMember = {
  __typename?: 'CourseTypeMetadataV1_shortFormContentMember';
  shortFormContent: CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_ShortFormContentMetadata;
};

export type CourseTypeMetadataV1_StandardCourseMember = {
  __typename?: 'CourseTypeMetadataV1_standardCourseMember';
  standardCourse: CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_StandardCourseMetadata;
};

export type CourseTypeMetadataV1_VerifiedSkillsCourseMember = {
  __typename?: 'CourseTypeMetadataV1_verifiedSkillsCourseMember';
  verifiedSkillsCourse: CourseTypeMetadataV1_Org_Coursera_Ondemand_Course_Types_VerifiedSkillsCourseMetadata;
};

/** The a11y setting of the course's asset library */
export type Course_AuthoringCourseAssetLibraryAccessibilitySettings = {
  __typename?: 'Course_AuthoringCourseAssetLibraryAccessibilitySettings';
  /** Whether the auto-generation of image description is enabled */
  isImageDescriptionAutoGenerationOn: Scalars['Boolean'];
  /** The threshold of the minimum confidence level of the auto-generated description for the image */
  minAutoGeneratedImageDescriptionConfidenceLevel: Scalars['Float'];
};

/** Basic information of a course that could be accessed by all logged in users. */
export type Course_BasicCourseInfo = {
  __typename?: 'Course_BasicCourseInfo';
  /**
   * Marker for identifying what "type" of course a specific course shell is supposed to represent.
   * Used for tailoring the learner and partner experience for each course type and for streamlined data reporting.
   */
  courseTypeMetadata: Course_CourseTypeMetadataWithVersion;
  /** The id of the course, Apollo Client relies on id for cache management */
  id: Scalars['ID'];
  /** User-visible name of the course */
  name: Scalars['String'];
  /** Override partner logo for this course */
  overridePartnerLogos: Array<Course_OverridePartnerLogos>;
  /** Course Partners. Ordered so the primary university can be first */
  partners: Array<Partner_Partner>;
  /** Short name used in URLs, only return the slug if users have permissions to view the course */
  slug?: Maybe<Scalars['String']>;
};

/** Course entity */
export type Course_Course = {
  __typename?: 'Course_Course';
  /** The a11y setting of the course's asset library */
  assetLibraryAccessibilitySettings?: Maybe<Course_AuthoringCourseAssetLibraryAccessibilitySettings>;
  /** Hydrated URL of the additional photo for the course */
  brandingImageUrl?: Maybe<Scalars['URL']>;
  /** The completion rate (0-100) */
  completionRate?: Maybe<Scalars['Float']>;
  /**
   * Marker for identifying what "type" of course a specific course shell is supposed to represent.
   * Used for tailoring the learner and partner experience for each course type and for streamlined data reporting.
   */
  courseTypeMetadata: Course_CourseTypeMetadataWithVersion;
  /**
   * The default enterprise program for a specific course.
   * This is used as a part of the Course Builder authoring flow, when embedding items author's select
   * from a list of enterprise program's to embed from. This mutation sets the default program for
   * a given course.
   */
  defaultEnterpriseProgram?: Maybe<EnterpriseProgram>;
  /** List of degrees that include this course */
  degrees?: Maybe<Degree_DegreePaginatedResult>;
  /** The course's level */
  difficultyLevel?: Maybe<Course_DifficultyLevel>;
  /** List of domains and subdomains the course belongs to */
  domains: Array<Course_Domain>;
  /**
   * [2024 Q1] The consumer-Subscription team is launching the "Block Certs in Free Trial"
   * project. The purpose of this project is to prevent learners from earning a course certificate
   * during the free trial period of their Subscription (can be either a specialization Subscription
   * or a coursera plus Subscription). For this project, the FE needs data that informs them whether
   * or not a course was enrolled during the "active" free trial period of a Subscription. The
   * reason that we make the "active" distinction here is because if a learner cancels their
   * Subscription while in free trial status, we show a different certificate redemption CTA on the FE.
   * Since the FE needs to make this "active free trial" vs "cancelled free trial" distinction, this
   * "enrolledViaSubscriptionTrialMetadata" field captures Subscription trial metadata for all
   * course enrollments where the "endsAt" period for the learner's Subscription has not elapsed yet,
   * and the Subscription status is either in FREE_TRIAL or CANCELLED state.
   */
  enrolledViaSubscriptionTrialMetadata?: Maybe<Subscriptions_EnrolledViaSubscriptionTrialMetadata>;
  /** The enterprise custom sessions associated to the course */
  enterpriseCustomSessions?: Maybe<Course_SessionPaginatedResult>;
  /** Instructor-specified string describing course workload. Example: "5-7 hrs/week" */
  estimatedWorkload?: Maybe<Scalars['String']>;
  /** A list of FAQs */
  faqs: Array<Course_CourseQnA>;
  /** Hardware requirement of the course */
  hardwareRequirement?: Maybe<Scalars['String']>;
  /** Hydrated URL of the additional Banner photo for the course */
  headerImageUrl?: Maybe<Scalars['URL']>;
  /** CourseId */
  id: Scalars['ID'];
  /**
   * A list of incompatible atom validation warnings - atoms that are invalid in current course for
   * the enterprise program
   */
  incompatibleAtomValidationWarnings?: Maybe<Array<CourseDefaultEnterpriseProgram_IncompatibleAtomValidationWarning>>;
  /**
   * Tracks the initial branch that launched/will launch with the course as we will no longer
   * be able to assume that this was the Default branch as of PROD-343. AuthoringCourseBranchId
   * is used here instead of CourseBranchId as this is only required to prevent data loss when
   * automatically resolving conflicts between authoring and learner course versions
   */
  initialLaunchBranchId?: Maybe<Scalars['ID']>;
  /** Course instructors. Ordered so the primary instructor can be first */
  instructors: Array<Instructor_Instructor>;
  /** True if a course is a capstone project */
  isCapstoneProject: Scalars['Boolean'];
  /** For Credit Non Degree flag */
  isForCreditNonDegree?: Maybe<Scalars['Boolean']>;
  /**
   * Courses with this flag will only be available in the enterprise catalog of organizations
   * who have access
   */
  isLimitedToEnterprise: Scalars['Boolean'];
  /** True if a course is a portfolio project */
  isPortfolioProject: Scalars['Boolean'];
  /**
   * Whether this course is real (i.e. not for testing). If not real, the course is visible to
   * power users only.
   */
  isReal: Scalars['Boolean'];
  /** Whether this course restricts enrollment (not auto-enroll) */
  isRestrictedMembership: Scalars['Boolean'];
  /**
   * Whether primary-language subtitles should be translated into other languages via Smartling
   * (subtitles can still be manually uploaded by the instructor, so subtitleLanguageCodes is
   * not necessarily empty)
   */
  isSubtitleTranslationEnabled: Scalars['Boolean'];
  /** Students can enroll in verified certificate option */
  isVerificationEnabled: Scalars['Boolean'];
  /**
   * whether or not the course is enabled for the module experience which converts references to any
   * 'week' strings in course to 'module'
   */
  isWeekToModuleEnabledForCourse: Scalars['Boolean'];
  /** If the course is public, the time at which it was made public */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** Calculated learning hours required to complete the course */
  learningHours?: Maybe<Scalars['Float']>;
  /** Learning objectives of this course */
  learningObjectives: Array<CmlContent>;
  /** The program product metadata for the course and given programs. */
  multiProgramProductMetadata: Array<Course_ProgramProductMetadadata>;
  /**
   * Logged-in learner's branch-level progress aggregate on their current branch for this course.
   * Null when the learner has no current/active branch for the course. Per-item progress is available
   * via its `itemProgresses` field. Please check with #lce-course-experience before using.
   */
  myBranchProgress?: Maybe<CourseProgress_CourseBranchProgress>;
  /** Logged in user's progress on a particular course. Please check with #lce-course-experience before using. */
  myProgress: CourseProgress_CourseProgress;
  /** User-visible name of the course */
  name: Scalars['String'];
  /**
   * New public sessions created for this course should refer to this branch. If the field is null,
   * the base branch of the course (its id is the same as the course) will be used. When a new
   * public branch is launched, the newSessionBranchId will be updated to the id of that branch
   */
  newSessionBranchId?: Maybe<Scalars['ID']>;
  /** Override partner logo for this course */
  overridePartnerLogos: Array<Course_OverridePartnerLogos>;
  /**
   * This course data is stored in two different BE stores (authoring and learner), this field is
   * present in the authoring course and represents the corresponding version of the learner course.
   * A project of course store unification is in progress and this field can be deprecated later
   * when the system moves away completely from the learner store. It is kept in the schema for now
   * since it is still used in the FE.
   */
  parentCourseVersion: Scalars['Int'];
  /** Course Partners. Ordered so the primary university can be first */
  partners: Array<Partner_Partner>;
  /** Pathway parameters */
  pathwayProperties?: Maybe<Pathways_CourseProperties>;
  /** Expected launch date for pre-enrolling course. This field is only for display purpose */
  plannedLaunchDate?: Maybe<Scalars['String']>;
  /** Timestamp when course is set to be pre-launched */
  preEnrollmentEnabledAt?: Maybe<Scalars['DateTime']>;
  /** The list of premium experience variant and the enabled time */
  premiumExperiences: Array<Course_PremiumExperience>;
  /** Primary instructional languages of the course (frequently just English) */
  primaryLanguageCodes: Array<Scalars['String']>;
  /** The program product metadata for the course and given program. */
  programProductMetadata?: Maybe<Course_ProgramProductMetadadata>;
  /** Hydrated URL fo the promotional photo for the course */
  promoPhotoUrl?: Maybe<Scalars['URL']>;
  /** Recommended background to take this course */
  recommendedBackground?: Maybe<CmlContent>;
  /** S3 prefix path where the assets are stored. Default to courseId if not provided */
  s3Prefix?: Maybe<Scalars['String']>;
  /** Specification for auto-generating recurring sessions */
  sessionSchedule?: Maybe<Session_SessionSchedule>;
  /**
   * If the course has sessions, the time at which sessions were enabled. If this is after
   * course launch time, it means the course launched as on-demand first & was later converted
   * into sessions. Else, the course launched with sessions
   */
  sessionsEnabledAt?: Maybe<Scalars['DateTime']>;
  /** Sorted list of skills that the course is tagged with */
  skillTags: Array<SkillsTags_SkillTag>;
  /** Short name used in URLs */
  slug: Scalars['String'];
  /** List of specializations the course is used in */
  specializations: Array<Specialization_Specialization>;
  /** Non-primary languages in which subtitles are available */
  subtitleLanguageCodes: Array<Scalars['String']>;
  /** Who this class is for */
  targetAudience?: Maybe<Scalars['String']>;
  /** List of degrees that the course    stacks into */
  targetDegrees?: Maybe<Pathways_TargetDegreeResult>;
  /** Plain-text course description */
  textDescription: Scalars['String'];
  /** The translated name of the course. */
  translatedName?: Maybe<Scalars['String']>;
  /** The closest upcoming session for the course. There may not be one (for example, if the course hasn't launched yet). */
  upcomingCourseSession?: Maybe<Session_Session>;
  /** User verification requirements for the course. */
  userVerification?: Maybe<UserVerification_CourseUserVerification>;
  /** Verification timestamp */
  verificationEnabledAt?: Maybe<Scalars['DateTime']>;
};


/** Course entity */
export type Course_CourseDegreesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Course entity */
export type Course_CourseEnterpriseCustomSessionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};


/** Course entity */
export type Course_CourseMultiProgramProductMetadataArgs = {
  programIds: Array<Scalars['ID']>;
};


/** Course entity */
export type Course_CourseProgramProductMetadataArgs = {
  programId: Scalars['ID'];
};


/** Course entity */
export type Course_CourseTargetDegreesArgs = {
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** The type for question and answer */
export type Course_CourseQnA = {
  __typename?: 'Course_CourseQnA';
  /** The answer in CML (Coursera Markdown Language) */
  answer: CmlContent;
  /** The question in plaintext */
  question: Scalars['String'];
};

/**
 * Marker for identifying what "type" of course a specific course shell is supposed to represent.
 * Used for tailoring the learner and partner experience for each course type and for streamlined data reporting.
 */
export type Course_CourseTypeMetadata = Course_ProjectMetadata | Course_RhymeProjectMetadata | Course_ShortFormContentMetadata | Course_StandardCourseMetadata | Course_VerifiedSkillsCourseMetadata;

/**
 * Versioned marker for identifying what "type" of course a specific course shell is supposed to represent.
 * Used for tailoring the learner and partner experience for each course type and for streamlined data reporting.
 */
export type Course_CourseTypeMetadataWithVersion = {
  __typename?: 'Course_CourseTypeMetadataWithVersion';
  /**
   * Marker for identifying what "type" of course a specific course shell is supposed to represent.
   * Used for tailoring the learner and partner experience for each course type and for streamlined data reporting.
   */
  metadata: Course_CourseTypeMetadata;
  /**
   * Course type metadata is stored separately from the main course model and maintains its own version numbers, which
   * can be used for optimistic locking.
   */
  version: Scalars['Int'];
};

/** The difficulty level of the course */
export const Course_DifficultyLevel = {
  /** The advanced level */
  Advanced: 'ADVANCED',
  /** The beginner level */
  Beginner: 'BEGINNER',
  /** The intermediate level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type Course_DifficultyLevel = typeof Course_DifficultyLevel[keyof typeof Course_DifficultyLevel];
/** Defined domain/subdomain type for a course */
export type Course_Domain = {
  __typename?: 'Course_Domain';
  /** The slug of the primary domain, e.g., "computer-science" */
  domainSlug: Scalars['String'];
  /** Similar to domainSlug, the slug of the subdomain */
  subdomainSlug?: Maybe<Scalars['String']>;
};

/** The original type in the Scala case class is Map<partnerId, string> */
export type Course_OverridePartnerLogos = {
  __typename?: 'Course_OverridePartnerLogos';
  /** The logo */
  logoUrl: Scalars['URL'];
  /** The partner */
  partner: Partner_Partner;
};

/** The type of premium experience of the course */
export type Course_PremiumExperience = {
  __typename?: 'Course_PremiumExperience';
  /** The timestamp when the variant is enabled */
  enabledAt: Scalars['DateTime'];
  /** The type of the premium experience */
  variant: Course_PremiumExperienceVariant;
};

/** Different product variants that are currently supported */
export const Course_PremiumExperienceVariant = {
  /** Base variant where everything is free */
  BaseVariant: 'BASE_VARIANT',
  /** For closed course, all course materials are behind paywall */
  PremiumCourse: 'PREMIUM_COURSE',
  /** Gradable assessments are behind paywall */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type Course_PremiumExperienceVariant = typeof Course_PremiumExperienceVariant[keyof typeof Course_PremiumExperienceVariant];
/** Course program product metadata */
export type Course_ProgramProductMetadadata = {
  __typename?: 'Course_ProgramProductMetadadata';
  /** Is course auto enrollment enabled */
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  /** If the course is exclusive to the program */
  isExclusive: Scalars['Boolean'];
  /** If the course is selected for credit */
  isSelectedForCredit: Scalars['Boolean'];
  /** The program that the metadata are associated with */
  programId: Scalars['ID'];
};

/** Represents Project shells, such as Qwiklabs projects where LTI is configured by pointing to Qwiklabs resources. */
export type Course_ProjectMetadata = {
  __typename?: 'Course_ProjectMetadata';
  /** Screenshots of the Project experience. Displayed on the Project Description Page. */
  screenshotUrls: Array<Scalars['URL']>;
  /** Instructional tasks that an instructor defines for a Project. Displayed on the Project Description Page. */
  tasks: Array<Cml_Cml>;
};

/** Represents a Guided Project, which is tightly coupled to Rhyme. */
export type Course_RhymeProjectMetadata = {
  __typename?: 'Course_RhymeProjectMetadata';
  /** Screenshots of the Project experience. Displayed on the Project Description Page. */
  screenshotUrls: Array<Scalars['URL']>;
  /** Instructional tasks that an instructor defines for a Project. Displayed on the Project Description Page. */
  tasks: Array<Cml_Cml>;
};

/** Paginated result type for Session_Session in Course_Course entity */
export type Course_SessionPaginatedResult = {
  __typename?: 'Course_SessionPaginatedResult';
  /** List of elements in the page */
  elements: Array<Session_Session>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Represents a course shell that simply acts as a wrapper around short-form content. */
export type Course_ShortFormContentMetadata = {
  __typename?: 'Course_ShortFormContentMetadata';
  /** GraphQL types must include at least one field, so a no-op field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Represents MOOCs and high-engagement course offerings like degree courses */
export type Course_StandardCourseMetadata = {
  __typename?: 'Course_StandardCourseMetadata';
  /** GraphQL types must include at least one field, so a no-op field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Represents a course shell for a verified skills course */
export type Course_VerifiedSkillsCourseMetadata = {
  __typename?: 'Course_VerifiedSkillsCourseMetadata';
  /** GraphQL types must include at least one field, so a no-op field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Query definitions for fetching CourseraPlusCollections related data. */
export type CourseraPlusCollectionsQueries = {
  __typename?: 'CourseraPlusCollectionsQueries';
  /** Fetches the logged in user's Coursera Plus Collection state. */
  queryByLoggedInUser: CourseraPlusCollections_UserCourseraPlusCollectionState;
};

/** Wrapper for checkout cart ID (Coursera Plus cart checked out as part of Collection-save). */
export type CourseraPlusCollections_CartId = {
  /** Cart ID. */
  id: Scalars['ID'];
};

/** A record of a user saving a Coursera Plus Collection. */
export type CourseraPlusCollections_CollectionTransaction = {
  __typename?: 'CourseraPlusCollections_CollectionTransaction';
  /**
   * The federated Recommendation_Collection for this transaction, providing `id`, `additionalInput`, and `description`.
   * For the enriched `entities` (products) list (with `s12nIdToEnroll` on courses-in-S12n), use `enrichedEntities` instead.
   */
  collection: Recommendation_Collection;
  /**
   * The Collection's products enriched with `s12nIdToEnroll` when the product is a course-in-S12n and the learner is not
   * yet enrolled in the S12n. Each entry pairs a `ProductCard_ProductCard` (resolved via
   * federation) with a nullable `s12nIdToEnroll`, which is provided only when the product is a course that
   * must be enrolled through its parent Specialization.
   */
  enrichedEntities: CourseraPlusCollections_EnrichedEntityPaginatedResult;
  /** When the Coursera Plus Collection transaction occurred. */
  transactedAt: Scalars['DateTime'];
  /** The action for this transaction. */
  transactionAction: CourseraPlusCollections_TransactionAction;
  /**
   * The Coursera Plus subscription associated with this Collection transaction.
   * Should always be available, but not marked required because the database column is technically nullable.
   */
  transactionSubscription?: Maybe<Subscriptions_Subscription>;
};


/** A record of a user saving a Coursera Plus Collection. */
export type CourseraPlusCollections_CollectionTransactionEnrichedEntitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** A paginated list of Coursera Plus Collection transactions. */
export type CourseraPlusCollections_CollectionTransactionPaginatedResult = {
  __typename?: 'CourseraPlusCollections_CollectionTransactionPaginatedResult';
  /** The Collection transactions in this page. */
  elements: Array<CourseraPlusCollections_CollectionTransaction>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** A Collection entity enriched with Coursera Plus enrollment metadata. */
export type CourseraPlusCollections_EnrichedCollectionEntity = {
  __typename?: 'CourseraPlusCollections_EnrichedCollectionEntity';
  /**
   * The product card for display. Resolves to full card data via federation.
   * Use `canonicalType` to determine product type (COURSE, SPECIALIZATION, etc.).
   */
  productCard: ProductCard_ProductCard;
  /**
   * Only present when the product is a course that must be enrolled via its Specialization.
   * Null for standalone courses and Specializations.
   */
  s12nIdToEnroll?: Maybe<Scalars['ID']>;
};

/** A paginated list of Coursera Plus Collection entities enriched with enrollment metadata. */
export type CourseraPlusCollections_EnrichedEntityPaginatedResult = {
  __typename?: 'CourseraPlusCollections_EnrichedEntityPaginatedResult';
  /** The enriched entities in this page. */
  elements: Array<CourseraPlusCollections_EnrichedCollectionEntity>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Response returned if request failed. */
export type CourseraPlusCollections_Failure = {
  __typename?: 'CourseraPlusCollections_Failure';
  /** Details about the failure. */
  errors: Array<CourseraTierSubscriptions_Error>;
};

/** Input for CourseraPlusCollections_Save mutation. userId comes from request context. */
export type CourseraPlusCollections_SaveInput = {
  /** Additional input for that Collection: same shape as `Recommendations.queryCollection`'s `additionalInput` JSON (e.g. `preset_collection_id`, `ai_collection_id`, `query`, `facets`). */
  collectionAdditionalInput: Scalars['JSON'];
  /**
   * This ID is the same as `Recommendations.queryCollection`'s `id`. In coursera-plus-application, this is
   * the equivalent of the `collection_config_name` column, stored in the `collection_transactions` table.
   */
  collectionId: Scalars['ID'];
  /** Correlates this Collection-save with the learner's Plus subscription (`@oneOf`). See `CourseraPlusCollections_SubscriptionReference`. */
  subscriptionReference: CourseraPlusCollections_SubscriptionReference;
};

/** Result of the CourseraPlusCollections_Save mutation: success with saved Collection details, or failure with errors. */
export type CourseraPlusCollections_SaveResult = CourseraPlusCollections_Failure | CourseraPlusCollections_SaveSuccess;

/**
 * Saved Collection returned on successful save.
 * The Collection's human-readable name is omitted on Save; present in the `CourseraPlusCollectionsQueries#queryByLoggedInUser` response.
 */
export type CourseraPlusCollections_SaveSuccess = {
  __typename?: 'CourseraPlusCollections_SaveSuccess';
  /** Additional input persisted for this Collection-save (echo of input `collectionAdditionalInput`). */
  collectionAdditionalInput: Scalars['JSON'];
  /**
   * This ID is the same as `Recommendations.queryCollection`'s `id`. In coursera-plus-application, this is
   * the equivalent of the `collection_config_name` column, stored in the `collection_transactions`
   * table. Echoes the input `collectionId`.
   */
  collectionId: Scalars['ID'];
  /** When the Collection was saved for the user. */
  savedAt: Scalars['DateTime'];
};

/** Wrapper for Coursera Plus subscription ID. */
export type CourseraPlusCollections_SubscriptionId = {
  /** Subscription ID. */
  id: Scalars['ID'];
};

/** Allows us to link a learner's Plus subscription to a specific Collection-save. */
export type CourseraPlusCollections_SubscriptionReference = {
  /** Plus checkout cart for the Collection-save when the subscription ID is not available yet (checkout path). */
  checkoutCartId?: InputMaybe<CourseraPlusCollections_CartId>;
  /** Plus subscription ID when the learner is already subscribed (post-checkout path). */
  subscriptionId?: InputMaybe<CourseraPlusCollections_SubscriptionId>;
};

/** The action that triggered a Coursera Plus Collection transaction. Later, `UNSAVE` might be possible. */
export const CourseraPlusCollections_TransactionAction = {
  /** Indicates the Collection save drove the user into Coursera Plus checkout. */
  CheckoutSave: 'CHECKOUT_SAVE',
  /** Indicates the Collection was saved without driving a Coursera Plus checkout. */
  Save: 'SAVE'
} as const;

export type CourseraPlusCollections_TransactionAction = typeof CourseraPlusCollections_TransactionAction[keyof typeof CourseraPlusCollections_TransactionAction];
/** A user's Coursera Plus Collection state. */
export type CourseraPlusCollections_UserCourseraPlusCollectionState = {
  __typename?: 'CourseraPlusCollections_UserCourseraPlusCollectionState';
  /** The user's latest transaction per Collection, sorted by descending `transactedAt`. */
  collectionsTransactions: CourseraPlusCollections_CollectionTransactionPaginatedResult;
  /**
   * The number of product entities returned across `collectionsTransactions` elements.
   * Used by the frontend to determine how many pages are needed to show Collection products on the My Learning/Saved tab.
   */
  entityCount: Scalars['Int'];
};


/** A user's Coursera Plus Collection state. */
export type CourseraPlusCollections_UserCourseraPlusCollectionStateCollectionsTransactionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** Course related info when a user queries enrollment choice for a s12n via coursera plus. */
export type CourseraPlusCourseEnrollmentChoiceInfo = {
  __typename?: 'CourseraPlusCourseEnrollmentChoiceInfo';
  /** Course ID */
  courseId: Scalars['ID'];
};

export type CourseraPlusEnrollmentsV1 = {
  __typename?: 'CourseraPlusEnrollmentsV1';
  action: CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction;
  cartId?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  id: Scalars['String'];
  paymentReference?: Maybe<CourseraPlusEnrollmentsV1_PaymentReference>;
  paymentReferenceId?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  recurringPaymentId?: Maybe<Scalars['String']>;
};

export type CourseraPlusEnrollmentsV1Connection = {
  __typename?: 'CourseraPlusEnrollmentsV1Connection';
  elements: Array<Maybe<CourseraPlusEnrollmentsV1>>;
  paging: ResponsePagination;
};

export type CourseraPlusEnrollmentsV1GetEnrollmentByLatestRecurringPayment = {
  __typename?: 'CourseraPlusEnrollmentsV1GetEnrollmentByLatestRecurringPayment';
  connection?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1GetEnrollmentByUserIdAndProductId = {
  __typename?: 'CourseraPlusEnrollmentsV1GetEnrollmentByUserIdAndProductId';
  connection?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1GetEnrollmentsByRecurringPayment = {
  __typename?: 'CourseraPlusEnrollmentsV1GetEnrollmentsByRecurringPayment';
  connection?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  recurringPaymentId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CourseraPlusEnrollmentsV1GetMostRecentEnrollRecordsForLastBillingCycle = {
  __typename?: 'CourseraPlusEnrollmentsV1GetMostRecentEnrollRecordsForLastBillingCycle';
  connection?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1GetUpgradeEnrollment = {
  __typename?: 'CourseraPlusEnrollmentsV1GetUpgradeEnrollment';
  connection?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1Resource = {
  __typename?: 'CourseraPlusEnrollmentsV1Resource';
  getEnrollmentByLatestRecurringPayment?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  getEnrollmentByUserIdAndProductId?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  getEnrollmentsByRecurringPayment?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  getMostRecentEnrollRecordsForLastBillingCycle?: Maybe<CourseraPlusEnrollmentsV1Connection>;
  getUpgradeEnrollment?: Maybe<CourseraPlusEnrollmentsV1Connection>;
};


export type CourseraPlusEnrollmentsV1ResourceGetEnrollmentByLatestRecurringPaymentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceGetEnrollmentByUserIdAndProductIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceGetEnrollmentsByRecurringPaymentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  recurringPaymentId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type CourseraPlusEnrollmentsV1ResourceGetMostRecentEnrollRecordsForLastBillingCycleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceGetUpgradeEnrollmentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1ResourceMutations = {
  __typename?: 'CourseraPlusEnrollmentsV1ResourceMutations';
  enrollProduct?: Maybe<Scalars['JSON']>;
  revokeAllProductsByCourseraPlusPrepaidCartId?: Maybe<Scalars['JSON']>;
  revokeAllProductsByCourseraPlusPrepaidRefundCartId?: Maybe<Scalars['JSON']>;
  revokeAllProductsByRecurringPayment?: Maybe<Scalars['JSON']>;
  revokeProduct?: Maybe<Scalars['JSON']>;
  unenrollAllProductsByRecurringPayment?: Maybe<Scalars['JSON']>;
  unenrollAllProductsForUpgrade?: Maybe<Scalars['JSON']>;
  unenrollProduct?: Maybe<Scalars['JSON']>;
  unenrollProductByCourseraPlusPaymentReferenceId?: Maybe<Scalars['JSON']>;
  unenrollProductByOneTimePaymentReferenceCartId?: Maybe<Scalars['JSON']>;
  unenrollProductByRecurringPaymentId?: Maybe<Scalars['JSON']>;
};


export type CourseraPlusEnrollmentsV1ResourceMutationsEnrollProductArgs = {
  courseIdToGrantMembership?: InputMaybe<Scalars['String']>;
  isRenewal?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsRevokeAllProductsByCourseraPlusPrepaidCartIdArgs = {
  cartId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsRevokeAllProductsByCourseraPlusPrepaidRefundCartIdArgs = {
  refundCartId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsRevokeAllProductsByRecurringPaymentArgs = {
  recurringPaymentId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsRevokeProductArgs = {
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollAllProductsByRecurringPaymentArgs = {
  recurringPaymentId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollAllProductsForUpgradeArgs = {
  recurringPaymentId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollProductArgs = {
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollProductByCourseraPlusPaymentReferenceIdArgs = {
  courseraPlusPaymentReferenceId: Scalars['String'];
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollProductByOneTimePaymentReferenceCartIdArgs = {
  cartId: Scalars['String'];
  productId: Scalars['String'];
  userId: Scalars['String'];
};


export type CourseraPlusEnrollmentsV1ResourceMutationsUnenrollProductByRecurringPaymentIdArgs = {
  productId: Scalars['String'];
  recurringPaymentId: Scalars['String'];
  userId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1_CourseraPlusOneTimePaymentTypeMember = {
  __typename?: 'CourseraPlusEnrollmentsV1_courseraPlusOneTimePaymentTypeMember';
  courseraPlusOneTimePaymentType: CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusOneTimePayment;
};

export type CourseraPlusEnrollmentsV1_CourseraPlusSubscriptionPaymentTypeMember = {
  __typename?: 'CourseraPlusEnrollmentsV1_courseraPlusSubscriptionPaymentTypeMember';
  courseraPlusSubscriptionPaymentType: CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusSubscriptionPayment;
};

export const CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction = {
  Enroll: 'ENROLL',
  Revoke: 'REVOKE',
  Unenroll: 'UNENROLL',
  Upgrade: 'UPGRADE'
} as const;

export type CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction = typeof CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction[keyof typeof CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusEnrollmentAction];
export type CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusOneTimePayment = {
  __typename?: 'CourseraPlusEnrollmentsV1_org_coursera_product_courseraplus_CourseraPlusOneTimePayment';
  cartId: Scalars['Float'];
};

export type CourseraPlusEnrollmentsV1_Org_Coursera_Product_Courseraplus_CourseraPlusSubscriptionPayment = {
  __typename?: 'CourseraPlusEnrollmentsV1_org_coursera_product_courseraplus_CourseraPlusSubscriptionPayment';
  recurringPaymentId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type CourseraPlusEnrollmentsV1_PaymentReference = CourseraPlusEnrollmentsV1_CourseraPlusOneTimePaymentTypeMember | CourseraPlusEnrollmentsV1_CourseraPlusSubscriptionPaymentTypeMember;

/** Queries for Coursera Proctoring. */
export type CourseraProctoringQueries = {
  __typename?: 'CourseraProctoringQueries';
  /** Get proctoring session by id. Backend requires the user to be either a power user or staff for the associated course. */
  queryProctoringSession: CourseraProctoring_ProctoringSession;
  /** Get proctoring sessions for an assignment in a private course session. */
  queryProctoringSessionsForPrivateCourseSession: CourseraProctoring_ProctoringSessionPaginatedResult;
  /** Get proctoring sessions for an assignment in a YourOrg/public course session. Uses courseId because public sessions are always available and thus sessionIds are auto-generated. */
  queryProctoringSessionsForPublicCourseSession: CourseraProctoring_ProctoringSessionPaginatedResult;
};


/** Queries for Coursera Proctoring. */
export type CourseraProctoringQueriesQueryProctoringSessionArgs = {
  proctoringSessionId: Scalars['ID'];
};


/** Queries for Coursera Proctoring. */
export type CourseraProctoringQueriesQueryProctoringSessionsForPrivateCourseSessionArgs = {
  assessmentId: Scalars['ID'];
  assessmentType: ExamMonitor_AssessmentType;
  courseSessionId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};


/** Queries for Coursera Proctoring. */
export type CourseraProctoringQueriesQueryProctoringSessionsForPublicCourseSessionArgs = {
  assessmentId: Scalars['ID'];
  assessmentType: ExamMonitor_AssessmentType;
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};

/** Types of assets that can be uploaded for a proctoring session. */
export const CourseraProctoring_AssetType = {
  /** An image from the user's camera. */
  CameraImage: 'CAMERA_IMAGE',
  /** An image from the user's primary camera. */
  PrimaryCameraImage: 'PRIMARY_CAMERA_IMAGE',
  /** An image of the user's screen. */
  ScreenImage: 'SCREEN_IMAGE',
  /** An image from the user's secondary camera. */
  SecondaryCameraImage: 'SECONDARY_CAMERA_IMAGE'
} as const;

export type CourseraProctoring_AssetType = typeof CourseraProctoring_AssetType[keyof typeof CourseraProctoring_AssetType];
/** Configuration for a camera. */
export type CourseraProctoring_CameraConfig = {
  __typename?: 'CourseraProctoring_CameraConfig';
  /** Whether or not this camera is enabled. */
  cameraStatus: CourseraProctoring_EnablementStatus;
  /** Whether or not monitoring is enabled for this camera. */
  monitoringStatus: CourseraProctoring_EnablementStatus;
  /** Whether or not recording is enabled for this camera. */
  recordingStatus: CourseraProctoring_EnablementStatus;
};

/** Configuration for a camera in mutation input. */
export type CourseraProctoring_CameraConfigInput = {
  /** Whether camera is enabled or disabled. */
  cameraStatus: CourseraProctoring_EnablementStatus;
  /** Whether monitoring is enabled or disabled for this camera. */
  monitoringStatus: CourseraProctoring_EnablementStatus;
  /** Whether recording is enabled or disabled for this camera. */
  recordingStatus: CourseraProctoring_EnablementStatus;
};

/** Configuration for Coursera Proctoring features. */
export type CourseraProctoring_Configuration = {
  __typename?: 'CourseraProctoring_Configuration';
  /** Configuration for the primary camera. */
  primaryCameraConfig: CourseraProctoring_CameraConfig;
  /** Configuration for the secondary camera. */
  secondaryCameraConfig: CourseraProctoring_CameraConfig;
};

/** Configuration for Coursera Proctoring features. */
export type CourseraProctoring_ConfigurationInput = {
  /** Configuration for the primary camera. */
  primaryCameraConfig: CourseraProctoring_CameraConfigInput;
  /** Configuration for the secondary camera. */
  secondaryCameraConfig: CourseraProctoring_CameraConfigInput;
};

/** Content type of the asset. */
export const CourseraProctoring_ContentType = {
  /** Content type of the asset is image/jpeg. */
  ImageJpeg: 'IMAGE_JPEG'
} as const;

export type CourseraProctoring_ContentType = typeof CourseraProctoring_ContentType[keyof typeof CourseraProctoring_ContentType];
/** Enum representing the enablement status. */
export const CourseraProctoring_EnablementStatus = {
  /** The feature is disabled. */
  Disabled: 'DISABLED',
  /** The feature is enabled and required. */
  Enabled: 'ENABLED'
} as const;

export type CourseraProctoring_EnablementStatus = typeof CourseraProctoring_EnablementStatus[keyof typeof CourseraProctoring_EnablementStatus];
/** Input to finish the proctoring session. */
export type CourseraProctoring_EndProctoringInput = {
  /** The identifier of the proctoring session to end. */
  proctoringSessionId: Scalars['ID'];
};

/** The result of the end proctoring session mutation. */
export type CourseraProctoring_EndProctoringResult = {
  __typename?: 'CourseraProctoring_EndProctoringResult';
  /** The identifier of the proctoring session that ended. */
  proctoringSessionId: Scalars['ID'];
};

/** Feedback type for proctoring events. */
export const CourseraProctoring_FeedbackType = {
  /** Negative feedback */
  Downvote: 'DOWNVOTE',
  /** Positive feedback */
  Upvote: 'UPVOTE'
} as const;

export type CourseraProctoring_FeedbackType = typeof CourseraProctoring_FeedbackType[keyof typeof CourseraProctoring_FeedbackType];
/** The input to initialize a proctoring asset. */
export type CourseraProctoring_InitializeAssetInput = {
  /** The type of the asset being initialized. */
  assetType: CourseraProctoring_AssetType;
  /** The content type of the asset. */
  contentType: CourseraProctoring_ContentType;
  /** The identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/** The result of initializing a proctoring asset. */
export type CourseraProctoring_InitializeAssetResult = {
  __typename?: 'CourseraProctoring_InitializeAssetResult';
  /** The identifier of the asset. */
  assetId: Scalars['ID'];
  /** URL to upload the asset to. */
  uploadUrl: Scalars['URL'];
};

/** Learner information. Using a separate type since User_PublicUser doesn't contain email, and User_User is restricted. */
export type CourseraProctoring_Learner = {
  __typename?: 'CourseraProctoring_Learner';
  /** Email of the learner. */
  email: Scalars['String'];
  /** Full name of the learner. */
  fullName: Scalars['String'];
};

/** Key-value pair representing a metadata entry. */
export type CourseraProctoring_MetadataEntry = {
  /** Metadata key */
  key: Scalars['String'];
  /** Metadata value */
  value: Scalars['String'];
};

/** Key-value pair representing a metadata record. */
export type CourseraProctoring_MetadataRecord = {
  __typename?: 'CourseraProctoring_MetadataRecord';
  /** Metadata key. */
  key: Scalars['String'];
  /** Metadata value. */
  value: Scalars['String'];
};

/** The input to process an asset. */
export type CourseraProctoring_ProcessAssetInput = {
  /** The identifier of the asset. */
  assetId: Scalars['ID'];
  /** The identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/** The result of processing an asset. */
export type CourseraProctoring_ProcessAssetResult = {
  __typename?: 'CourseraProctoring_ProcessAssetResult';
  /** The result code of the analysis/processing. It can be used for providing feedback to the user. */
  resultCode: Scalars['String'];
};

/** Event that is generated by the proctoring system. */
export type CourseraProctoring_ProctoringEvent = {
  __typename?: 'CourseraProctoring_ProctoringEvent';
  /** Content type of the asset. */
  assetContentType: CourseraProctoring_ContentType;
  /** Unique ID of the asset. */
  assetId: Scalars['ID'];
  /** Type of the asset. */
  assetType: CourseraProctoring_AssetType;
  /** Presigned URL that can be used to view the asset. */
  assetUrl: Scalars['URL'];
  /** Time when the event was generated. */
  createdAt: Scalars['DateTime'];
  /** Explanation of the result code. */
  explanation: Scalars['String'];
  /** Detailed result code of the event. */
  resultCode: Scalars['String'];
  /** Severity of the event. */
  severity: CourseraProctoring_Severity;
};

/** Paginated result for proctoring events. */
export type CourseraProctoring_ProctoringEventPaginatedResult = {
  __typename?: 'CourseraProctoring_ProctoringEventPaginatedResult';
  /** List of elements in the page. */
  elements: Array<CourseraProctoring_ProctoringEvent>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Proctoring session for a user taking an assessment. */
export type CourseraProctoring_ProctoringSession = {
  __typename?: 'CourseraProctoring_ProctoringSession';
  /** Identifier of the assessment. */
  assessmentId: Scalars['ID'];
  /** Type of the assessment. */
  assessmentType: ExamMonitor_AssessmentType;
  /** End time of the proctoring session. */
  endedAt?: Maybe<Scalars['DateTime']>;
  /** Identifier of the proctoring session. */
  id: Scalars['ID'];
  /** Learner information. */
  learner: CourseraProctoring_Learner;
  /** Metadata about the proctoring session. Can store arbitrary key-value pairs. */
  metadata: Array<CourseraProctoring_MetadataRecord>;
  /** Proctoring events that occurred during the proctoring session. Events are ordered by createdAt descending. */
  proctoringEvents: CourseraProctoring_ProctoringEventPaginatedResult;
  /**
   * Recording associated with the proctoring session.
   * @deprecated Use recordings instead
   */
  recording: ExamRecording_Recording;
  /** Optional result from analyzing the session recording. */
  recordingProcessingResult?: Maybe<CourseraProctoring_RecordingProcessingResult>;
  /** Recordings associated with the proctoring session. */
  recordings: CourseraProctoring_Recordings;
  /** Number of events by severity. Available after the proctoring session ends. */
  severityCounts?: Maybe<Array<CourseraProctoring_SeverityCount>>;
  /** Start time of the proctoring session. */
  startedAt: Scalars['DateTime'];
};


/** Proctoring session for a user taking an assessment. */
export type CourseraProctoring_ProctoringSessionProctoringEventsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  severity?: InputMaybe<CourseraProctoring_Severity>;
};

/** Paginated result for proctoring sessions. */
export type CourseraProctoring_ProctoringSessionPaginatedResult = {
  __typename?: 'CourseraProctoring_ProctoringSessionPaginatedResult';
  /** List of elements in the page. */
  elements: Array<CourseraProctoring_ProctoringSession>;
  /** Pagination information. */
  pagination: Pagination;
};

/**
 * Input to reanalyze recordings that previously failed analysis.
 * INTERNAL USE ONLY: For manual intervention by engineers when recording analysis failures need to be fixed.
 */
export type CourseraProctoring_ReanalyzeRecordingsInput = {
  /** The identifiers of the recordings to reanalyze. */
  recordingIds: Array<Scalars['ID']>;
};

/** The result of reanalyzing recordings. */
export type CourseraProctoring_ReanalyzeRecordingsResult = {
  __typename?: 'CourseraProctoring_ReanalyzeRecordingsResult';
  /** The identifiers of the recordings that were submitted for reanalysis. */
  recordingIds: Array<Scalars['ID']>;
};

/** Recording event that occurred during the proctoring session. */
export type CourseraProctoring_RecordingEvent = {
  __typename?: 'CourseraProctoring_RecordingEvent';
  /** Seconds from the start of the video when the event ended. */
  endPlaybackSeconds: Scalars['Float'];
  /** Explanation of the event. */
  explanation: Scalars['String'];
  /** Severity of the event. */
  severity: CourseraProctoring_Severity;
  /** Seconds from the start of the video when the event occurred. */
  startPlaybackSeconds: Scalars['Float'];
};

/** Container for recording IDs associated with a proctoring session. */
export type CourseraProctoring_RecordingIds = {
  __typename?: 'CourseraProctoring_RecordingIds';
  /** The primary recording ID for the proctoring session. */
  primaryRecordingId: Scalars['ID'];
  /** The secondary recording ID for the proctoring session. Only present if secondary camera recording is enabled. */
  secondaryRecordingId?: Maybe<Scalars['ID']>;
};

/** Result from analyzing the session recording. */
export type CourseraProctoring_RecordingProcessingResult = {
  __typename?: 'CourseraProctoring_RecordingProcessingResult';
  /** Events that occurred during the recording. */
  recordingEvents: Array<CourseraProctoring_RecordingEvent>;
  /** Summary of the recording. */
  summary: Scalars['String'];
};

/** Recordings associated with the proctoring session. */
export type CourseraProctoring_Recordings = {
  __typename?: 'CourseraProctoring_Recordings';
  /** Primary recording. */
  primaryRecording: ExamRecording_Recording;
  /** Secondary recording if available. */
  secondaryRecording?: Maybe<ExamRecording_Recording>;
};

/** Input to set Coursera Proctoring enablement for an assessment. */
export type CourseraProctoring_SetEnablementInput = {
  /** The assessment ID. */
  assessmentId: Scalars['ID'];
  /** The type of the assessment. */
  assessmentType: ExamMonitor_AssessmentType;
  /** Configuration for proctoring. */
  configuration: CourseraProctoring_ConfigurationInput;
  /** The course ID. Required for public or YourOrg course sessions. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The course session ID. Required for private course sessions. */
  courseSessionId?: InputMaybe<Scalars['ID']>;
  /** Whether proctoring is enabled for the assessment. */
  enabled: Scalars['Boolean'];
};

/** The result of setting Coursera Proctoring enablement. */
export type CourseraProctoring_SetEnablementResult = {
  __typename?: 'CourseraProctoring_SetEnablementResult';
  /** Dummy field to satisfy the GraphQL schema. */
  _: Scalars['Boolean'];
};

/** Describes how severe misconduct is in a proctoring event. */
export const CourseraProctoring_Severity = {
  /** High severity event. */
  High: 'HIGH',
  /** Low severity event. */
  Low: 'LOW',
  /** Medium severity event. */
  Medium: 'MEDIUM',
  /** Normal event, no severity. */
  None: 'NONE'
} as const;

export type CourseraProctoring_Severity = typeof CourseraProctoring_Severity[keyof typeof CourseraProctoring_Severity];
/** Represents a number of proctoring events with a given severity. */
export type CourseraProctoring_SeverityCount = {
  __typename?: 'CourseraProctoring_SeverityCount';
  /** Count of proctoring events with the given severity. */
  count: Scalars['Int'];
  /** Severity of the proctoring event. */
  severity: CourseraProctoring_Severity;
};

/** Input to initialize a proctoring session. */
export type CourseraProctoring_StartProctoringInput = {
  /** The assessment being proctored. */
  assessmentId: Scalars['ID'];
  /** The type of the assessment being proctored. */
  assessmentType: ExamMonitor_AssessmentType;
  /** The assessment attempt being proctored. */
  attemptId: Scalars['ID'];
  /** The course session in which assessment is started. */
  courseSessionId: Scalars['ID'];
  /** Optional metadata about the proctoring session. Can store arbitrary key-value pairs. */
  metadata?: InputMaybe<Array<CourseraProctoring_MetadataEntry>>;
};

/** The result of the start proctoring session mutation. */
export type CourseraProctoring_StartProctoringResult = {
  __typename?: 'CourseraProctoring_StartProctoringResult';
  /** The identifier of the proctoring session created. */
  proctoringSessionId: Scalars['ID'];
  /** The recording associated with the proctoring session. */
  recordingId: Scalars['ID'];
  /** Recording IDs associated with the proctoring session. */
  recordingIds: CourseraProctoring_RecordingIds;
};

/** Event that is generated by the proctoring system. */
export type CourseraProctoring_SubmitProctoringEventFeedbackInput = {
  /** Asset ID. */
  assetId: Scalars['ID'];
  /** Feedback for the event. */
  feedback?: InputMaybe<Scalars['String']>;
  /** Feedback type. */
  feedbackType: CourseraProctoring_FeedbackType;
  /** Identifier of the proctoring session. */
  proctoringSessionId: Scalars['ID'];
};

/** Result of submitting proctoring event feedback. */
export type CourseraProctoring_SubmitProctoringEventFeedbackResult = {
  __typename?: 'CourseraProctoring_SubmitProctoringEventFeedbackResult';
  /** Dummy field to satisfy the GraphQL schema. */
  _: Scalars['Boolean'];
};

/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueries = {
  __typename?: 'CourseraTierSubscriptionsFetchQueries';
  /**
   * Fetches a list of all coursera tier product configurations that match the request filters.
   * The response can include product, price and fulfillment configuration details.
   */
  queryCourseraTierProductConfigurations: Array<OwnableProduct_OwnableProductTuple>;
  /**
   * Fetches all courses (paginated) the learner enrolled into via their Coursera Plus subscription.
   * This returns both standalone and course-in-s12n courses.
   */
  queryCoursesEnrolledViaCourseraPlusByUser?: Maybe<CourseraTierSubscriptions_CoursePaginatedResult>;
  /**
   * Fetches product ownerships for a particular user.
   * This query has different behavior from the entitlement application's getProductOwnershipByUser
   * query because it consolidates the current FE behavior: When we check for Coursera Plus, the FE
   * fetches all products by underlying product ID and then runs multi-get on product ownership.
   * This endpoint is essentially going to consolidate all that logic and add lite tier to it, so
   * the FE only needs one call to get all the information they want.
   */
  queryProductOwnershipsByUser: Array<Maybe<CourseraTierSubscriptions_ProductOwnership>>;
  /** Fetches all subscriptions eligible for upgrades (i.e. from a lower tier to upper tier subscription or from s12n subscription to tier subscription). */
  querySubscriptionsEligibleForUpgrade: Array<Subscriptions_Subscription>;
  /** Fetches # of subscribers in Coursera Plus/Lite */
  queryTierSubscriptionMetrics?: Maybe<CourseraTierSubscriptions_TierSubscriptionMetrics>;
};


/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueriesQueryCourseraTierProductConfigurationsArgs = {
  acquisitionType: CourseraTierSubscriptions_AcquisitionType;
  paymentCadence: CourseraTierSubscriptions_PaymentCadence;
  tier: CourseraTierSubscriptions_ProductType;
};


/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueriesQueryCoursesEnrolledViaCourseraPlusByUserArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueriesQueryProductOwnershipsByUserArgs = {
  userId: Scalars['ID'];
};


/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueriesQuerySubscriptionsEligibleForUpgradeArgs = {
  toBillingCycle: CourseraTierSubscriptions_BillingCycle;
  toProductType: CourseraTierSubscriptions_ProductType;
};


/** Query definitions for fetching CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsFetchQueriesQueryTierSubscriptionMetricsArgs = {
  tier: CourseraTierSubscriptions_ProductType;
};

/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueries = {
  __typename?: 'CourseraTierSubscriptionsMutationQueries';
  /** Checkout the coursera tier subscription and enroll the learner into the S12N they purchased this through. */
  checkout: CourseraTierSubscriptions_Subscription;
  /** Create a new cart for the user's Coursera tier subscription. */
  createCart: CourseraTierSubscriptions_CartWithComputed;
  /** Create the cart to be used in midCycleUpgrade from tier to tier. */
  createMidCycleUpgradeCart: CourseraTierSubscriptions_CreateMidCycleUpgradeCartOutput;
  /**
   * End the learners razorpay subscription created for a CourseraTier (CourseraPlus or
   * CourseraTierLite) product type. This is executed as part of midCycleUpgrade support for
   * Razorpay subscriptions only.
   *
   * All subscriptions are instantly cancelled and membership/ownership are revoked. The amount paid
   * by the learner is also refunded instantaneously where appropriate.
   */
  endRazorpaySubscriptionForCourseraTierProduct: CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductResult;
  /** Upgrade the learner from one tier to another, returning the new toTier Subscription */
  midCycleUpgrade: CourseraTierSubscriptions_Subscription;
  /**
   * This is a one-off API to support the "C+ Hero Modal Test in India" experiment, specifically for the
   * Lite-to-Plus upgrade flow. We are unable to implement a flow that has feature parity with the Braintree flow
   * because all Razorpay checkouts are human-in-the-loop for now. The experience will instead be to refund/invalidate
   * the Lite subscription at time of upgrade and then navigate to the checkout page where the learner can checkout Plus
   * themselves. We will then send an email to the learner with their Lite enrollments so they can re-enroll as needed.
   * This is the API for sending that email. The current plan is to trigger it from the FE for the sake of MVP. Triggering
   * it from the BE through CartItemMetadata is more standard, but involves changing the serialized data format which I
   * personally think is risky given how unproven this hacky upgrade feature is.
   *
   * For additional eng/product context, see this doc https://docs.google.com/document/d/1t14gVIJMaZjsc-Au-Tu9daCpqKTS_AjDTgzMma2Kyag/edit#heading=h.sd49fumfshcg. The solution we ultimately decided to go with is closest to "[NEW] Option 4 (Recommended)" but with some additional
   * complexity around making sure the learner gets a refund eventually and reflecting this in copy.
   */
  sendEmailWorkaroundForRazorpayLiteToPlusUpgrade: CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResult;
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesCheckoutArgs = {
  cartId: Scalars['ID'];
  paymentInformation: CourseraTierSubscriptions_SubscriptionPaymentInformationInputUnion;
  userId: Scalars['ID'];
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesCreateCartArgs = {
  input?: InputMaybe<CourseraTierSubscriptions_CartCreateInput>;
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesCreateMidCycleUpgradeCartArgs = {
  input: CourseraTierSubscriptions_CreateMidCycleUpgradeCartInput;
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesEndRazorpaySubscriptionForCourseraTierProductArgs = {
  input: CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductInput;
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesMidCycleUpgradeArgs = {
  input: CourseraTierSubscriptions_MidCycleUpgradeInput;
};


/** Query definitions for updating CourseraTierSubscriptions related data. */
export type CourseraTierSubscriptionsMutationQueriesSendEmailWorkaroundForRazorpayLiteToPlusUpgradeArgs = {
  input: CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeInput;
};

/** Denotes the different ways the learner can purchase a tier product (either through standard purchase or upgrade). */
export const CourseraTierSubscriptions_AcquisitionType = {
  /** Learner can purchase tier product through standard checkout */
  Standard: 'STANDARD',
  /** Learner can purchase tier product through upgrading/upsell */
  Upgrade: 'UPGRADE'
} as const;

export type CourseraTierSubscriptions_AcquisitionType = typeof CourseraTierSubscriptions_AcquisitionType[keyof typeof CourseraTierSubscriptions_AcquisitionType];
/** BillingCycles supported by existing subscriptions. */
export const CourseraTierSubscriptions_BillingCycle = {
  /** Billed annually */
  Annual: 'ANNUAL',
  /** Billed Monthly */
  Monthly: 'MONTHLY'
} as const;

export type CourseraTierSubscriptions_BillingCycle = typeof CourseraTierSubscriptions_BillingCycle[keyof typeof CourseraTierSubscriptions_BillingCycle];
/**
 * An instance of a Cart, used for checkout, refunds, renewals, etc. on Coursera's platform. Some
 * fields defined in Cart.scala in infra-services are omitted here because they're not relevant to intl-compliance.
 */
export type CourseraTierSubscriptions_Cart = {
  __typename?: 'CourseraTierSubscriptions_Cart';
  /** country in which the cart was checked out. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** The Timestamp of when the cart was created at. */
  createdAt: Scalars['DateTime'];
  /** id of the currency used to check out the cart */
  currencyId: Scalars['ID'];
  /** the fxRate used to convert to USD (should be empty if currency is USD) */
  fxRateId?: Maybe<Scalars['ID']>;
  /** Unique cart identifier */
  id: Scalars['ID'];
  /** The Timestamp of when the cart was last updated at. */
  lastUpdatedAt: Scalars['DateTime'];
  /** Id of the user for whom the cart was created */
  userId: Scalars['ID'];
};

/** Use to create a cart for checkout */
export type CourseraTierSubscriptions_CartCreateInput = {
  /** Country of the learner, to be used at checkout. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** Optional coupon id */
  couponId?: InputMaybe<Scalars['Int']>;
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /** List of products to be checked out by this cart. */
  productItems: Array<CourseraTierSubscriptions_CartItemCreateInput>;
  /** ID of the learner who owns this cart */
  userId: Scalars['ID'];
};

/** Components of the cart that a user is interested in checking out for. */
export type CourseraTierSubscriptions_CartItem = {
  __typename?: 'CourseraTierSubscriptions_CartItem';
  /** The amount of the cart item after discount, NOT including taxes if any. */
  amount: Scalars['String'];
  /** The parent cart's id */
  cartId: Scalars['ID'];
  /** The cart item that is being refunded by this cart item. If none, this is a purchase. */
  cartItemIdToRefund?: Maybe<Scalars['ID']>;
  /** Optional coupon id */
  couponId?: Maybe<Scalars['ID']>;
  /** Cart item id */
  id: Scalars['ID'];
  /** Mirrors the CartItemMetadata courier enum in infra-services. */
  metadata?: Maybe<CourseraTierSubscriptions_CartItemMetadata>;
  /** The amount of the cart item before discount. */
  originalAmount: Scalars['String'];
  /** The cart item container (e.g. specialization) */
  parentCartItemId?: Maybe<Scalars['ID']>;
  /** The ID to the product pricing table, which has the amount to charge/refund. */
  priceId?: Maybe<Scalars['ID']>;
  /** What action the user wants to take on the product, such as "buy". */
  productAction: CourseraTierSubscriptions_ProductAction;
  /** What the user wants to buy/refund. */
  productItemId: Scalars['ID'];
  /** product type that is being actioned upon. */
  productType: CourseraTierSubscriptions_ProductType;
};

/** Used to create a cart item. Stores the product to be purchased and the action to take with it */
export type CourseraTierSubscriptions_CartItemCreateInput = {
  /** Mirrors the CartItemMetadata courier enum in infra-services. */
  metadata: CourseraTierSubscriptions_CartItemMetadataInputUnion;
  /** The action to take with this product */
  productAction: CourseraTierSubscriptions_ProductAction;
  /** ID of the product being purchased */
  productItemId: Scalars['ID'];
  /** The type of product being purchased */
  productType: CourseraTierSubscriptions_ProductType;
};

/** Mirrors CartItemMetadata courier enum in infra-services. */
export type CourseraTierSubscriptions_CartItemMetadata = CourseraTierSubscriptions_CourseraPlusSubscriptionCartItemMetadata | CourseraTierSubscriptions_CourseraTierLiteCartItemMetadata;

/**
 * CartItemMetadata input used for request params. Mirrors CartItemMetadata courier enum in
 * infra-services.
 */
export type CourseraTierSubscriptions_CartItemMetadataInputUnion = {
  /** Metadata for a CourseraTierLite subscription. */
  courseraTierLiteCartItemMetadataInput?: InputMaybe<CourseraTierSubscriptions_CourseraTierLiteCartItemMetadataInput>;
};

/** Wrapper around CartItem with some additional information. */
export type CourseraTierSubscriptions_CartItemWithComputed = {
  __typename?: 'CourseraTierSubscriptions_CartItemWithComputed';
  /** CartItem that is being wrapped */
  cartItem: CourseraTierSubscriptions_CartItem;
  /** CartItem ID */
  id: Scalars['ID'];
  /** Promotion information for this cartItem if applicable */
  promotionInfo?: Maybe<CourseraTierSubscriptions_ProductPromotionInfo>;
};

/** A wrapper around cart with extra information. */
export type CourseraTierSubscriptions_CartWithComputed = {
  __typename?: 'CourseraTierSubscriptions_CartWithComputed';
  /** The underlying cart */
  cart: CourseraTierSubscriptions_Cart;
  /** Includes the computed fields that belong to the cart. */
  computedCartFields: CourseraTierSubscriptions_ComputedCartFields;
  /** The country iso code for the country in which the cart was checked out. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** The currency code in which the cart was checked out */
  currencyCode: Scalars['String'];
  /** Id of the Cart */
  id: Scalars['ID'];
};

/** Includes computed fields that belong to a cart such as amount, and cart items with computed amounts. */
export type CourseraTierSubscriptions_ComputedCartFields = {
  __typename?: 'CourseraTierSubscriptions_ComputedCartFields';
  /** The underlying cart items */
  cartItems: Array<Maybe<CourseraTierSubscriptions_CartItemWithComputed>>;
  /** Represents the total cart amount before discounts */
  originalTotalCartAmount: Scalars['String'];
  /** Represents the total amount of the cart including discounts */
  totalCartAmount: Scalars['String'];
};

/** Paginated list of courses. */
export type CourseraTierSubscriptions_CoursePaginatedResult = {
  __typename?: 'CourseraTierSubscriptions_CoursePaginatedResult';
  /** List of elements in the page */
  elements: Array<Course_Course>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Metadata for a CourseraPlusSubscription subscription */
export type CourseraTierSubscriptions_CourseraPlusSubscriptionCartItemMetadata = {
  __typename?: 'CourseraTierSubscriptions_CourseraPlusSubscriptionCartItemMetadata';
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: Maybe<CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout Coursera Plus */
  productEnrollmentInformation?: Maybe<CourseraTierSubscriptions_ProductEnrollmentInformation>;
  /** Upgrade variants for Coursera Plus subscriptions. */
  upgradeVariants?: Maybe<CourseraTierSubscriptions_CourseraPlusSubscriptionUpgradeVariants>;
};

/** Upgrade variants for Coursera Plus subscriptions. */
export type CourseraTierSubscriptions_CourseraPlusSubscriptionUpgradeVariants = {
  __typename?: 'CourseraTierSubscriptions_CourseraPlusSubscriptionUpgradeVariants';
  /** Metadata for an email regarding this variant */
  emailParameters?: Maybe<CourseraTierSubscriptions_UpgradeEmailParameters>;
  /** Overridden number of trial days */
  freeTrialInDaysOverride?: Maybe<Scalars['Int']>;
  /** Promo code id, a.k.a. promotion name */
  nextBillingPromotion?: Maybe<Scalars['String']>;
  /** Variant name */
  priceVariant?: Maybe<CourseraTierSubscriptions_PriceVariant>;
};

/** Metadata for a CourseraTierLite subscription */
export type CourseraTierSubscriptions_CourseraTierLiteCartItemMetadata = {
  __typename?: 'CourseraTierSubscriptions_CourseraTierLiteCartItemMetadata';
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: Maybe<CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout Coursera Lite */
  productEnrollmentInformation?: Maybe<CourseraTierSubscriptions_ProductEnrollmentInformation>;
};

/**
 * CourseraTierLiteCartItemMetadata input used for request params. Includes Metadata for
 * a CourseraTierLite subscription.
 */
export type CourseraTierSubscriptions_CourseraTierLiteCartItemMetadataInput = {
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: InputMaybe<CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout coursera lite */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
};

/** CreateMidCycleUpgradeCart request object */
export type CourseraTierSubscriptions_CreateMidCycleUpgradeCartInput = {
  /** Country of the learner, to be used at checkout. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /** The Coursera Tier that the learner owns at time of upgrade */
  fromTier: CourseraTierSubscriptions_ProductType;
  /**
   * productEnrollmentInformation contains the course ID and/or Specialization ID to enroll the user into
   * after the upgrade. if this input is provided, then the productIdToEnroll must be provided therein.
   * If there is no s12nId, the courseId will be used as the productIdToEnroll.
   */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
  /** The Coursera Tier to which the learner is trying to upgrade */
  toTier: CourseraTierSubscriptions_ProductType;
  /** The billing cycle to which the learner is trying to upgrade */
  toTierBillingCycle?: InputMaybe<CourseraTierSubscriptions_BillingCycle>;
  /** ID of the learner who owns this cart */
  userId: Scalars['ID'];
};

/** CreateMidCycleUpgradeCart return object */
export type CourseraTierSubscriptions_CreateMidCycleUpgradeCartOutput = {
  __typename?: 'CourseraTierSubscriptions_CreateMidCycleUpgradeCartOutput';
  /** Subscription for the fromTier in a midCycleUpgrade */
  fromTierSubscription: CourseraTierSubscriptions_Subscription;
  /** The toTier cart for a mid-cycle tier to tier upgrade */
  toTierCart: CourseraTierSubscriptions_CartWithComputed;
};

/** Razorpay subscription id whose subscription needs to be ended. */
export type CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductInput = {
  /** Subscription Id */
  subscriptionId: Scalars['ID'];
};

/** Result for when the razorpay subscription has been ended. */
export type CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductResult = CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductSuccess | CourseraTierSubscriptions_Failure;

/** Success response for when the razorpay subscription has been ended. */
export type CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductSuccess = {
  __typename?: 'CourseraTierSubscriptions_EndRazorpaySubscriptionForCourseraTierProductSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Domain specific error interface for coursera tier subscription. */
export type CourseraTierSubscriptions_Error = {
  /** Details about the error. */
  message: Scalars['String'];
};

/** Response returned if request failed */
export type CourseraTierSubscriptions_Failure = {
  __typename?: 'CourseraTierSubscriptions_Failure';
  /** Details about the failure. */
  errors: Array<CourseraTierSubscriptions_Error>;
};

/** The checkout information to be used for the toTier subscription */
export type CourseraTierSubscriptions_MidCycleUpgradeCheckoutInformation = {
  /** Subscription id for the fromTier in a midCycleUpgrade */
  fromTierSubscriptionId: Scalars['ID'];
  /** Payment information for the type of subscription that the learner is checking out */
  paymentInformation: CourseraTierSubscriptions_SubscriptionPaymentInformationInputUnion;
  /** Cart id for which to process coursera tier subscription checkout */
  toTierCartId: Scalars['ID'];
};

/** MidCycleUpgrade request object. */
export type CourseraTierSubscriptions_MidCycleUpgradeInput = {
  /**
   * [optional] The checkout information to be used for the toTier subscription instead of building
   * the toTier cart here and using the payment information linked to the "fromTier" subscription.
   */
  checkoutInformation?: InputMaybe<CourseraTierSubscriptions_MidCycleUpgradeCheckoutInformation>;
  /** Country of the learner, to be used at checkout. */
  countryIsoCode: Scalars['String'];
  /** Currency of the learner, to be used at checkout. */
  currencyCode: Scalars['String'];
  /**
   * Deprecated. Use fromTierSubscriptionId instead.
   * @deprecated Use fromTierSubscriptionId instead.
   */
  fromTier?: InputMaybe<CourseraTierSubscriptions_ProductType>;
  /** ID of the Subscription which is to be migrated to the new tier. */
  fromTierSubscriptionId: Scalars['ID'];
  /**
   * [optional] productEnrollmentInformation contains the course ID and/or Specialization ID to enroll the user into
   * after the upgrade. If this input is provided, then the productIdToEnroll must be provided therein.
   * If there is no s12nId, the courseId will be used as the productIdToEnroll.
   */
  productEnrollmentInformation?: InputMaybe<CourseraTierSubscriptions_ProductEnrollmentInformationInput>;
  /**
   * [optional] Promo code (eg: "SUBS_DISCOUNT_50") to include in the upgrade on the next billing.
   * Will be plugged into the UpgradeVariants.EmailParameters.additionalDiscountPromoCode.
   */
  promoCode?: InputMaybe<Scalars['String']>;
  /** The Coursera Tier to which the learner is trying to upgrade */
  toTier: CourseraTierSubscriptions_ProductType;
  /** [optional] The billing cycle to which the learner is trying to upgrade. Defaults to MONTHLY. */
  toTierBillingCycle?: InputMaybe<CourseraTierSubscriptions_BillingCycle>;
  /** User ID for which to process coursera tier subscription mid cycle upgrade. */
  userId: Scalars['ID'];
};

/**
 * Specifies the different payment cadence associated with the tier product configuration payment scheme
 * (Not to be confused with the actual PaymentSchemes of OneTimePaymentScheme and SubscriptionPaymentScheme
 * which contain actual paymentScheme details such as ownership, freeTrial and refund days)
 */
export const CourseraTierSubscriptions_PaymentCadence = {
  /** This is used to get tier product configuration details with annual subscription payment scheme */
  AnnualSubscription: 'ANNUAL_SUBSCRIPTION',
  /** This is used to get tier product configuration details with monthly subscription payment scheme */
  MonthlySubscription: 'MONTHLY_SUBSCRIPTION',
  /** This is used to get tier product configuration details with one-time payment scheme */
  OneTime: 'ONE_TIME'
} as const;

export type CourseraTierSubscriptions_PaymentCadence = typeof CourseraTierSubscriptions_PaymentCadence[keyof typeof CourseraTierSubscriptions_PaymentCadence];
/** Payment processor id in which this subscription billing is managed by. */
export const CourseraTierSubscriptions_PaymentProcessorId = {
  /** Payment processor id used for Braintree subscriptions. */
  Braintree: 'BRAINTREE',
  /** Payment processor id used for Braintree sandbox subscriptions. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Payment processor id used for Paypal subscriptions. */
  Paypal: 'PAYPAL',
  /** Payment processor id used Razorpay subscriptions. */
  Razorpay: 'RAZORPAY',
  /** Payment processor id used Razorpay subscriptions in sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Payment processor id used Stripe Europe subscriptions. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Payment processor id used Stripe Europe subscriptions in sandbox. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Payment processor id used Stripe subscriptions. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Payment processor id used Stripe subscriptions in sandbox. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX'
} as const;

export type CourseraTierSubscriptions_PaymentProcessorId = typeof CourseraTierSubscriptions_PaymentProcessorId[keyof typeof CourseraTierSubscriptions_PaymentProcessorId];
/** Variant name */
export type CourseraTierSubscriptions_PriceVariant = {
  __typename?: 'CourseraTierSubscriptions_PriceVariant';
  /** Variant name */
  variantName: Scalars['String'];
};

/** Product action of a transaction */
export const CourseraTierSubscriptions_ProductAction = {
  /**
   * Buy product action is the primary product action used by the FE.
   * Additional product actions are used to support our internal tool for Learner Services.
   * For the CourseraTierLite rollout, we are skipping internal tool support for the MVP.
   * We will rely on direct API calls if we need to do admin-level refunds.
   */
  Buy: 'BUY'
} as const;

export type CourseraTierSubscriptions_ProductAction = typeof CourseraTierSubscriptions_ProductAction[keyof typeof CourseraTierSubscriptions_ProductAction];
/**
 * Used when users purchase CourseraTierSubscription through an CDP or SDP. After users purchase
 * CourserTierSubscription, we also need to enroll them into the corresponding course or s12n.
 */
export type CourseraTierSubscriptions_ProductEnrollmentInformation = {
  __typename?: 'CourseraTierSubscriptions_ProductEnrollmentInformation';
  /**
   * Users can enroll in courseraTierSubscription through any CDP in an s12n. In this case, the user
   * should get the membership for that course instead of just going through normal s12n
   * enrollment flow which will
   * grant the membership of the first course in the s12n
   */
  courseIdToGrantMembership?: Maybe<Scalars['ID']>;
  /** The product to enroll with purchasing CourseraTierSubscription */
  productIdToEnroll: Scalars['ID'];
};

/**
 * ProductEnrollmentInformation input used for request params. Used when users
 * purchase CourseraTierSubscription through an CDP or SDP. After users purchase
 * CourserTierSubscription, we also need to enroll them into the corresponding course or s12n.
 */
export type CourseraTierSubscriptions_ProductEnrollmentInformationInput = {
  /**
   * Users can enroll in courseraTierSubscription through any CDP in an s12n. In this case, the user
   * should get the membership for that course instead of just going through normal s12n
   * enrollment flow which will
   * grant the membership of the first course in the s12n
   */
  courseIdToGrantMembership?: InputMaybe<Scalars['ID']>;
  /** The product to enroll with purchasing CourseraTierSubscription */
  productIdToEnroll: Scalars['ID'];
};

/** Sku of a particular tier product */
export type CourseraTierSubscriptions_ProductId = {
  __typename?: 'CourseraTierSubscriptions_ProductId';
  /** Id of the particular product */
  productItemId: Scalars['ID'];
  /** Type of the particular product */
  productType: CourseraTierSubscriptions_ProductType;
};

/** Represents the ownership status of a user wrt a product item. */
export type CourseraTierSubscriptions_ProductOwnership = {
  __typename?: 'CourseraTierSubscriptions_ProductOwnership';
  /**
   * Represents whether a learner used to own a product. It is mainly important for determining
   * whether a learner has earned a certificate based off their ownership history (current or past),
   * progress in the content, verification status, and whether they have an active profile.
   */
  expiredOwns: Scalars['Boolean'];
  /** Represents when your current ownership period for the given product ends, if applicable. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Represents the start of the first non-revoked (non-refunded) ownership period for a learner, either current or past. */
  firstOwnedAt?: Maybe<Scalars['DateTime']>;
  /** Product ownership ID */
  id: CourseraTierSubscriptions_UserProductOwnershipId;
  /** Timestamp of when the product ownership was last updated */
  lastUpdatedTime?: Maybe<Scalars['DateTime']>;
  /**
   * Represents whether a learner currently owns a product. Examples of its usage include checkout
   * to determine product action eligibility, upsells in learner logged in dashboard, and paid
   * access in the in-course experience.
   */
  owns: Scalars['Boolean'];
  /**
   * If a buy/refund transaction has been initiated, but not completed, the ownership is in an
   * uncertain state. Sometimes, client logic might want to take this into consideration, to decide
   * on the validity of an action (e.g. if a refund has been initiated, but not confirmed, we may
   * want to continue providing the user with the verification UI, but not issue a physical
   * certificate).
   */
  pendingConfirmation: Scalars['Boolean'];
};

/**
 * Information for the product promotion.
 * Note that when a coupon ID is present in the cart item, it will also require product promotion
 * information to be present as well.
 */
export type CourseraTierSubscriptions_ProductPromotionInfo = {
  __typename?: 'CourseraTierSubscriptions_ProductPromotionInfo';
  /** Calculated discount amount based on either the discountPercent or the flat amount used */
  discountAmount: Scalars['String'];
  /** Discount Percentage applied, if a discount percent was used (vs a flat discount amount) */
  discountPercent?: Maybe<Scalars['Int']>;
  /** ID of the promotion */
  promotionId: Scalars['ID'];
  /** Name of the promotion */
  promotionName: Scalars['String'];
};

/** Product type of the coursera tier subscription */
export const CourseraTierSubscriptions_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /** Use for Invalid or deprecated product types */
  Invalid: 'INVALID'
} as const;

export type CourseraTierSubscriptions_ProductType = typeof CourseraTierSubscriptions_ProductType[keyof typeof CourseraTierSubscriptions_ProductType];
/** Payment information used for a razorpay subscription checkout. */
export type CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformation = {
  __typename?: 'CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformation';
  /** Signifies if the payment is being made in the sandbox environment. Defaults to false when absent. */
  isSandbox?: Maybe<Scalars['Boolean']>;
  /** Payment Id returned by Razorpay */
  razorpayPaymentId?: Maybe<Scalars['ID']>;
  /** Signature returned by Razorpay */
  razorpaySignature?: Maybe<Scalars['ID']>;
  /** Subscription Id return by Razorpay */
  razorpaySubscriptionId: Scalars['ID'];
};

/** Payment information used for a razorpay subscription checkout used for request params. */
export type CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformationInput = {
  /** Signifies if the payment is being made in the sandbox environment. Defaults to false when absent. */
  isSandbox?: InputMaybe<Scalars['Boolean']>;
  /** Payment Id returned by Razorpay */
  razorpayPaymentId?: InputMaybe<Scalars['ID']>;
  /** Signature returned by Razorpay */
  razorpaySignature?: InputMaybe<Scalars['ID']>;
  /** Subscription Id return by Razorpay */
  razorpaySubscriptionId: Scalars['ID'];
};

/** SendEmailWorkaroundForRazorpayLiteToPlusUpgradeInput request object */
export type CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeInput = {
  /** Subscription ID for the Lite subscription that was just cancelled/invalidated/refunded so the learner could "upgrade to Plus. Primarily used to fetch the enrollments the learner previously engaged with so we could send them an email and they can reenroll as needed. */
  liteSubscriptionId: Scalars['ID'];
  /** Subscription ID for the Plus subscription that the learner checked out (e.g. "upgraded" to). Primarily used for receipt/fulfillment context */
  plusSubscriptionId: Scalars['ID'];
};

/** SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResult response for either success or failure */
export type CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResult = CourseraTierSubscriptions_Failure | CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResultSuccess;

/** Response returned if SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResult was successful */
export type CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResultSuccess = {
  __typename?: 'CourseraTierSubscriptions_SendEmailWorkaroundForRazorpayLiteToPlusUpgradeResultSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Status of the coursera tier subscription */
export const CourseraTierSubscriptions_Status = {
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  Active: 'ACTIVE',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE */
  Cancelled: 'CANCELLED',
  /**
   * Subscription has reached the specified number of billing cycles and has lapsed out of
   * the paid through period
   */
  Expired: 'EXPIRED',
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  FreeTrial: 'FREE_TRIAL',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE. */
  Inactive: 'INACTIVE',
  /** Learner maintains product ownership until the end of grace period after which status is INACTIVE */
  PastDue: 'PAST_DUE'
} as const;

export type CourseraTierSubscriptions_Status = typeof CourseraTierSubscriptions_Status[keyof typeof CourseraTierSubscriptions_Status];
/** Subscription payment related information returned for a Stripe subscription upgrade. */
export type CourseraTierSubscriptions_StripeSubscriptionPaymentInformation = {
  __typename?: 'CourseraTierSubscriptions_StripeSubscriptionPaymentInformation';
  /** Signifies if the payment is being made in the sandbox environment. Defaults to false when absent. */
  isSandbox: Scalars['Boolean'];
  /** Signifies if the payment is made using STRIPE_BV merchant account. */
  isStripeBv: Scalars['Boolean'];
  /** Subscription ID returned by Stripe */
  subscriptionId: Scalars['ID'];
};

/** Payment information used for a Stripe subscription upgrade. */
export type CourseraTierSubscriptions_StripeSubscriptionPaymentInformationInput = {
  /**
   * Optional new stripe payment method id which the learner wants the next transaction of the
   * subscription to be charged to.
   */
  updateSubscriptionToNewPaymentMethodId?: InputMaybe<Scalars['ID']>;
};

/** Encapsulates information about a subscription */
export type CourseraTierSubscriptions_Subscription = {
  __typename?: 'CourseraTierSubscriptions_Subscription';
  /** CartId of the original subscription checkout */
  cartId: Scalars['ID'];
  /** Subscription id */
  id: Scalars['ID'];
  /** Whether this subscription is still considered "active" (i.e. not "INACTIVE") */
  isActive: Scalars['Boolean'];
  /** Next billing date of this subscription if active */
  nextBillingAt?: Maybe<Scalars['DateTime']>;
  /** Payment information of this subscription. */
  paymentInformation: CourseraTierSubscriptions_SubscriptionPaymentInformation;
  /** Payment processor id in which this subscription billing is managed by */
  paymentProcessorId: CourseraTierSubscriptions_PaymentProcessorId;
  /** Underlying product item id */
  productItemId: Scalars['ID'];
  /** Sku of the product for this subscription */
  productSku: CourseraTierSubscriptions_ProductId;
  /** Underlying product type */
  productType: CourseraTierSubscriptions_ProductType;
  /** The start date of this subscription */
  startsAt: Scalars['DateTime'];
  /** Status of the CourseraTierSubscription */
  status: CourseraTierSubscriptions_Status;
  /** User id for which to process coursera tier subscription checkout for */
  userId: Scalars['ID'];
};

/** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
export const CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType = {
  /**
   * Used to trigger different side effects based off what type of payment a subscription checkout
   * Represents. Right now we only have the need to distinguish between INITIAL_CHECKOUT and
   * SUBSEQUENT_PAYMENT, but we may find a need for other actions like REFUND.
   */
  SubscriptionCartItemMetadataPaymentTypeInitialCheckout: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_INITIAL_CHECKOUT',
  /**
   * Any payment after the initial checkout payment. Deliberately chose not to call it
   * RECURRING_PAYMENT since that means both initial and subsequent payments in the context of our
   * store. Also didn't call it installment because generally we only use that to mean subsequent
   * payment for a terminal subscription.
   */
  SubscriptionCartItemMetadataPaymentTypeSubsequentPayment: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_SUBSEQUENT_PAYMENT'
} as const;

export type CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType = typeof CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType[keyof typeof CourseraTierSubscriptions_SubscriptionCartItemMetadataPaymentType];
/**
 * A model for subscription payment information that acts as a created subscription payment
 * information container.
 */
export type CourseraTierSubscriptions_SubscriptionPaymentInformation = CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformation | CourseraTierSubscriptions_StripeSubscriptionPaymentInformation | CourseraTierSubscriptions_WalletSubscriptionPaymentInformation;

/**
 * Input subscription payment information that acts as a created subscription payment
 * information container. Used for request params.
 */
export type CourseraTierSubscriptions_SubscriptionPaymentInformationInputUnion = {
  /** Used for razorpay checkout. */
  razorpayPaymentInformation?: InputMaybe<CourseraTierSubscriptions_RazorpaySubscriptionPaymentInformationInput>;
  /** Used for stripe checkout. */
  stripePaymentInformation?: InputMaybe<CourseraTierSubscriptions_StripeSubscriptionPaymentInformationInput>;
  /** Used for wallet based subscriptions such as Braintree */
  walletPaymentInformation?: InputMaybe<CourseraTierSubscriptions_WalletSubscriptionPaymentInformationInput>;
};

/** Subscription metrics related to Coursera tier */
export type CourseraTierSubscriptions_TierSubscriptionMetrics = {
  __typename?: 'CourseraTierSubscriptions_TierSubscriptionMetrics';
  /** # of subscribers in a Coursera tier */
  totalSubscriberCount: Scalars['Int'];
};

/** Metadata for an email regarding this variant */
export type CourseraTierSubscriptions_UpgradeEmailParameters = {
  __typename?: 'CourseraTierSubscriptions_UpgradeEmailParameters';
  /** Additional discount promotion code */
  additionalDiscountPromoCode?: Maybe<Scalars['String']>;
  /** CourseId to display */
  courseIdToDisplay?: Maybe<Scalars['ID']>;
  /** Upgraded productId */
  upgradedProductId: CourseraTierSubscriptions_ProductId;
};

/** Use to associate ownership of a product with a learner. */
export type CourseraTierSubscriptions_UserProductOwnershipId = {
  __typename?: 'CourseraTierSubscriptions_UserProductOwnershipId';
  /** Product item ID */
  productItemId: Scalars['ID'];
  /** Type of product */
  productType: CourseraTierSubscriptions_ProductType;
  /** ID of the learner who owns the product */
  userId: Scalars['ID'];
};

/** Payment wallet subscription information used in subscription response object. */
export type CourseraTierSubscriptions_WalletSubscriptionPaymentInformation = {
  __typename?: 'CourseraTierSubscriptions_WalletSubscriptionPaymentInformation';
  /** Payment wallet id for the payment wallet used at checkout. */
  paymentWalletId: Scalars['ID'];
  /**
   * PaymentWalletThreeDsNonce is passed when 3D Secure is enabled during the subscription creation.
   * This nonce is validated for a specific transaction amount and is valid for 45 days.
   */
  paymentWalletThreeDsNonce?: Maybe<Scalars['String']>;
  /**
   * For subscriptions, this is the id of the subscription. (e.g. braintree's SubscriptionId). For
   * transactions, this is the id of the transaction. (i.e. id used in ExternalTransaction)
   */
  transactionId: Scalars['ID'];
};

/** Input payment wallet subscription information used for request params. */
export type CourseraTierSubscriptions_WalletSubscriptionPaymentInformationInput = {
  /** Payment wallet id for the payment wallet used at checkout. */
  paymentWalletId: Scalars['ID'];
  /**
   * PaymentWalletThreeDsNonce is passed when 3D Secure is enabled during the subscription creation.
   * This nonce is validated for a specific transaction amount and is valid for 45 days.
   */
  paymentWalletThreeDsNonce?: InputMaybe<Scalars['String']>;
  /**
   * For subscriptions, this is the id of the subscription. (e.g. braintree's SubscriptionId). For
   * transactions, this is the id of the transaction. (i.e. id used in ExternalTransaction)
   */
  transactionId: Scalars['ID'];
};

/**
 * These are verification statuses that are useful from Coursera's perspective, and are
 * defined by Coursera. They are NOT the original callback parameter verificationStatus states
 * defined by Jumio
 *
 * For original verificationStatus states defined by Jumio, see JumioCallbackVerificationStatus.courier
 */
export const CourseraVerificationStatus = {
  /** Approved */
  Approved: 'APPROVED',
  /** Denied age */
  DeniedAge: 'DENIED_AGE',
  /** Denied by Jumio */
  DeniedByJumio: 'DENIED_BY_JUMIO',
  /** Denied by Persona */
  DeniedByPersona: 'DENIED_BY_PERSONA',
  /** Denied by expired id */
  DeniedExpiredId: 'DENIED_EXPIRED_ID',
  /** Denied restricted country */
  DeniedRestrictedCountry: 'DENIED_RESTRICTED_COUNTRY',
  /** Error not Jumio supported country */
  ErrorNotJumioSupportedCountry: 'ERROR_NOT_JUMIO_SUPPORTED_COUNTRY',
  /** Error not readable id */
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  /** No id uploaded */
  NoIdUploaded: 'NO_ID_UPLOADED',
  /** Pending */
  Pending: 'PENDING'
} as const;

export type CourseraVerificationStatus = typeof CourseraVerificationStatus[keyof typeof CourseraVerificationStatus];
/** Queries for Courserian roles. */
export type CourserianRolesQueries = {
  __typename?: 'CourserianRolesQueries';
  /** Get all Courserians' ids and their roles. */
  getAllCourserianRoles: CourserianRoles_PaginatedResult;
};


/** Queries for Courserian roles. */
export type CourserianRolesQueriesGetAllCourserianRolesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
};

/** Delete input */
export type CourserianRoles_DeleteRolesOfCourserianInput = {
  /** This id is the alias of a courserian. */
  courserianId: Scalars['ID'];
};

/** Delete results */
export type CourserianRoles_DeleteRolesOfCourserianResult = CourserianRoles_DeleteRolesOfCourserianSuccess | CourserianRoles_Error;

/** Successful delete result */
export type CourserianRoles_DeleteRolesOfCourserianSuccess = {
  __typename?: 'CourserianRoles_DeleteRolesOfCourserianSuccess';
  /** Dummy field since type cannot be empty in GraphQL */
  _?: Maybe<Scalars['String']>;
};

/** Generic error type for courserian roles */
export type CourserianRoles_Error = Error & {
  __typename?: 'CourserianRoles_Error';
  /** Error message */
  message: Scalars['String'];
};

/** This type represents a Courserian's id and roles. */
export type CourserianRoles_IdAndRoles = {
  __typename?: 'CourserianRoles_IdAndRoles';
  /** This id is the alias of a courserian. Each courserian's work email is [alias]@coursera.org. */
  courserianId: Scalars['ID'];
  /**
   * You can refer to
   * https://github.com/webedx-spark/user-roles-application/blob/cd0ceb60b56d29015993d98ca6b2957a502c1e96/src/main/java/org/coursera/userroles/models/CourserianRole.java#L5
   * for the list of permissible roles. They are mostly lower-case strings, like "dataAdmin", "engineer", etc.
   */
  roles: Array<Scalars['String']>;
};

/** Courserian roles results with pagination */
export type CourserianRoles_PaginatedResult = {
  __typename?: 'CourserianRoles_PaginatedResult';
  /** List of elements in the page */
  elements: Array<CourserianRoles_IdAndRoles>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Update input */
export type CourserianRoles_UpdateRolesOfCourserianInput = {
  /** This id is the alias of a courserian. Each courserian's work email is [alias]@coursera.org. */
  courserianId: Scalars['ID'];
  /**
   * You can refer to
   * https://github.com/webedx-spark/user-roles-application/blob/cd0ceb60b56d29015993d98ca6b2957a502c1e96/src/main/java/org/coursera/userroles/models/CourserianRole.java#L5
   * for the list of permissible roles. They are mostly lower-case strings, like "dataAdmin", "engineer", etc.
   */
  roles: Array<Scalars['String']>;
};

/** Update results */
export type CourserianRoles_UpdateRolesOfCourserianResult = CourserianRoles_Error | CourserianRoles_UpdateRolesOfCourserianSuccess;

/** Successful update result */
export type CourserianRoles_UpdateRolesOfCourserianSuccess = {
  __typename?: 'CourserianRoles_UpdateRolesOfCourserianSuccess';
  /** Result of updating roles of a Courserian. */
  result: CourserianRoles_IdAndRoles;
};

/** Fetch data for Course Stackability */
export type CoursesStackabilityQueries = {
  __typename?: 'CoursesStackabilityQueries';
  /** Returns the independent upsell courses that sorted by # of enrollments and # of credits offered. */
  queryUpsellCoursesByDegreeSlug?: Maybe<CoursesStackability_UpsellCourses>;
};


/** Fetch data for Course Stackability */
export type CoursesStackabilityQueriesQueryUpsellCoursesByDegreeSlugArgs = {
  degreeSlug?: InputMaybe<Scalars['String']>;
};

/** Independent upsell courses that sorted by # of enrollments and # of credits offered. */
export type CoursesStackability_UpsellCourses = {
  __typename?: 'CoursesStackability_UpsellCourses';
  /** List of courses with upsell relation type OFFERS_CREDIT, sorted by # of enrollments and # of credits offered */
  offersCreditCourses?: Maybe<Array<Course_Course>>;
  /** List of courses with upsell relation type PART_OF, sorted by # of enrollments */
  partOfCourses?: Maybe<Array<Course_Course>>;
  /** List of courses with upsell relation type RELATED_TO, sorted by # of enrollments */
  relatedToCourses?: Maybe<Array<Course_Course>>;
};

export type CoursesV1 = {
  __typename?: 'CoursesV1';
  activeAndUpcomingSessions?: Maybe<OnDemandLearnerSessionsV1Connection>;
  brandingImageUrl?: Maybe<Scalars['String']>;
  categories: Array<Maybe<Scalars['String']>>;
  certificatePartnerLogo?: Maybe<Scalars['String']>;
  certificates: Array<Maybe<CoursesV1_Org_Coursera_Course_CertificateType>>;
  courseDerivatives?: Maybe<CourseDerivativesV1>;
  courseDerivativesV2?: Maybe<CourseDerivativesV2>;
  courseMode: CoursesV1_Org_Coursera_Course_CourseMode;
  courseStatus?: Maybe<CoursesV1_Org_Coursera_Course_CourseStatus>;
  /** Course type. Valid values include v1.session, v1.capstone, v2.ondemand, and v2.capstone */
  courseType: Scalars['String'];
  courseTypeMetadata?: Maybe<CourseTypeMetadataV1>;
  degreeIds?: Maybe<Scalars['JSON']>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  display: Scalars['Boolean'];
  domainTypes: Array<Maybe<CoursesV1_Org_Coursera_Catalogp_Browse_DomainType>>;
  faqs: Array<Maybe<CoursesV1_Org_Coursera_Ondemand_Common_CourseQnA>>;
  guestLearnerMaterials?: Maybe<OnDemandLearnerMaterialsV1>;
  /** Typeref for string that defines the isTranslatable property to true */
  hardwareRequirement?: Maybe<Scalars['String']>;
  headerImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  instructors?: Maybe<InstructorsV1Connection>;
  learningObjectives: Array<Maybe<CoursesV1_CmlMember>>;
  level?: Maybe<CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel>;
  membership?: Maybe<MembershipsV1>;
  membershipIds?: Maybe<Scalars['JSON']>;
  myFeedback?: Maybe<MyFeedbackV1Connection>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  onDemandLearnerMaterials?: Maybe<OnDemandLearnerMaterialsV1>;
  organizationId: Scalars['Int'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  partnerLogo?: Maybe<Scalars['String']>;
  partnerLogos: Scalars['JSON'];
  partners?: Maybe<PartnersV1Connection>;
  photoUrl?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  plannedLaunchDate?: Maybe<Scalars['String']>;
  premiumExperienceVariant?: Maybe<CoursesV1_Org_Coursera_Course_PremiumExperienceVariant>;
  previewLink?: Maybe<Scalars['String']>;
  primaryLanguages: Array<Maybe<Scalars['String']>>;
  recommendedBackground?: Maybe<CoursesV1_RecommendedBackground>;
  s12nIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  s12nMembershipIds?: Maybe<Scalars['JSON']>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  slug: Scalars['String'];
  specializations: Array<Maybe<Scalars['String']>>;
  startDate?: Maybe<Scalars['Float']>;
  subtitleLanguages: Array<Maybe<Scalars['String']>>;
  /** Typeref for string that defines the isTranslatable property to true */
  targetAudience?: Maybe<Scalars['String']>;
  upcomingSessionStartDate?: Maybe<Scalars['Float']>;
  v1Details?: Maybe<Scalars['JSON']>;
  v2Details?: Maybe<Scalars['JSON']>;
  /** Typeref for string that defines the isTranslatable property to true */
  workload: Scalars['String'];
};


export type CoursesV1ActiveAndUpcomingSessionsArgs = {
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  learnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1InstructorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1MyFeedbackArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1OnDemandLearnerMaterialsArgs = {
  anonymousAccess?: InputMaybe<Scalars['Boolean']>;
};


export type CoursesV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type CoursesV1Connection = {
  __typename?: 'CoursesV1Connection';
  elements: Array<Maybe<CoursesV1>>;
  paging: ResponsePagination;
};

export type CoursesV1Recommendations = {
  __typename?: 'CoursesV1Recommendations';
  cdpViews?: Maybe<Array<Maybe<Scalars['String']>>>;
  connection?: Maybe<CoursesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  recommendationLanguage?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type CoursesV1RelatedCourses = {
  __typename?: 'CoursesV1RelatedCourses';
  connection?: Maybe<CoursesV1Connection>;
  courseId: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type CoursesV1Resource = {
  __typename?: 'CoursesV1Resource';
  get?: Maybe<CoursesV1>;
  getAll?: Maybe<CoursesV1Connection>;
  multiGet?: Maybe<CoursesV1Connection>;
  recommendations?: Maybe<CoursesV1Connection>;
  relatedCourses?: Maybe<CoursesV1Connection>;
  search?: Maybe<CoursesV1Connection>;
  sessionId?: Maybe<CoursesV1Connection>;
  slug?: Maybe<CoursesV1Connection>;
};


export type CoursesV1ResourceGetArgs = {
  id: Scalars['String'];
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type CoursesV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  sortedBy?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type CoursesV1ResourceRecommendationsArgs = {
  cdpViews?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  recommendationLanguage?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type CoursesV1ResourceRelatedCoursesArgs = {
  courseId: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type CoursesV1ResourceSearchArgs = {
  availability?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  debug?: InputMaybe<Scalars['Boolean']>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  primaryLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  query?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  subtitleLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userLanguage?: InputMaybe<Scalars['String']>;
};


export type CoursesV1ResourceSessionIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type CoursesV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type CoursesV1Search = {
  __typename?: 'CoursesV1Search';
  availability?: Maybe<Array<Maybe<Scalars['String']>>>;
  connection?: Maybe<CoursesV1Connection>;
  debug?: Maybe<Scalars['Boolean']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  languages?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  primaryLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  query?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  subtitleLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  userLanguage?: Maybe<Scalars['String']>;
};

export type CoursesV1SessionId = {
  __typename?: 'CoursesV1SessionId';
  connection?: Maybe<CoursesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CoursesV1Slug = {
  __typename?: 'CoursesV1Slug';
  connection?: Maybe<CoursesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  showHidden?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type CoursesV1_CmlMember = {
  __typename?: 'CoursesV1_cmlMember';
  cml: CoursesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Defined domain/subdomain type for a course */
export type CoursesV1_Org_Coursera_Catalogp_Browse_DomainType = {
  __typename?: 'CoursesV1_org_coursera_catalogp_browse_DomainType';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type CoursesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'CoursesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<CoursesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type CoursesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'CoursesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<CoursesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type CoursesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'CoursesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: CoursesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type CoursesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'CoursesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export const CoursesV1_Org_Coursera_Course_CertificateType = {
  Ace: 'ACE',
  SoA: 'SoA',
  Specialization: 'Specialization',
  VerifiedCert: 'VerifiedCert'
} as const;

export type CoursesV1_Org_Coursera_Course_CertificateType = typeof CoursesV1_Org_Coursera_Course_CertificateType[keyof typeof CoursesV1_Org_Coursera_Course_CertificateType];
export const CoursesV1_Org_Coursera_Course_CourseMode = {
  Ondemand: 'ONDEMAND',
  Session: 'SESSION'
} as const;

export type CoursesV1_Org_Coursera_Course_CourseMode = typeof CoursesV1_Org_Coursera_Course_CourseMode[keyof typeof CoursesV1_Org_Coursera_Course_CourseMode];
export const CoursesV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type CoursesV1_Org_Coursera_Course_CourseStatus = typeof CoursesV1_Org_Coursera_Course_CourseStatus[keyof typeof CoursesV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const CoursesV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type CoursesV1_Org_Coursera_Course_PremiumExperienceVariant = typeof CoursesV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof CoursesV1_Org_Coursera_Course_PremiumExperienceVariant];
export type CoursesV1_Org_Coursera_Ondemand_Common_CourseQnA = {
  __typename?: 'CoursesV1_org_coursera_ondemand_common_CourseQnA';
  answer: CoursesV1_CmlMember;
  /** Typeref for string that defines the isTranslatable property to true */
  question: Scalars['String'];
};

export const CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof CoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type CoursesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'CoursesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<CoursesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type CoursesV1_RecommendedBackground = CoursesV1_CmlMember | DummyType;

/** Create course offering request */
export type CreateCourseOfferingRequest = {
  /** The course offering to be created */
  courseOffering: CourseOfferingInput;
};

/**  eslint-disable-next-line custom-rules/namespaced-types, @graphql-eslint/require-description */
export type CreateCourseOfferingResponse = CourseOfferingErrorResponse | CreateCourseOfferingSuccessResponse;

/** Create course offering response */
export type CreateCourseOfferingSuccessResponse = {
  __typename?: 'CreateCourseOfferingSuccessResponse';
  /** The course offering that is saved */
  courseOffering: CourseOffering_Record;
};

/** Parameter for creating an upsell */
export type CreateUpsellRequest = {
  /** Additional parameters in JSON format */
  paramsJson?: InputMaybe<Scalars['String']>;
  /** The id of the product that upsells */
  sourceId: Scalars['ID'];
  /** The type of the product that upsells */
  sourceType: Scalars['String'];
  /** The id of the product to upsell to */
  targetId: Scalars['ID'];
  /** The type of the product to upsell to */
  targetType: Scalars['String'];
  /** Upsell type */
  upsellType: Scalars['String'];
};

/** Queries for credential configurations. */
export type CredentialConfigurationQueries = {
  __typename?: 'CredentialConfigurationQueries';
  /** Get the credential configuration status of a single configuration level */
  queryCredentialConfigurationStatus: CredentialConfiguration_Status;
  /** Get a list of course credential configurations based on institution id */
  queryCredentialConfigurationsForInstitution: CredentialConfiguration_PaginatedResult;
  /** Get a list of course credential configurations based on program id */
  queryCredentialConfigurationsForProgram: CredentialConfiguration_PaginatedResult;
};


/** Queries for credential configurations. */
export type CredentialConfigurationQueriesQueryCredentialConfigurationStatusArgs = {
  configurationId: Scalars['ID'];
  configurationLevel: CredentialConfiguration_Level;
};


/** Queries for credential configurations. */
export type CredentialConfigurationQueriesQueryCredentialConfigurationsForInstitutionArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  limit?: Scalars['Int'];
};


/** Queries for credential configurations. */
export type CredentialConfigurationQueriesQueryCredentialConfigurationsForProgramArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  limit?: Scalars['Int'];
};

/**
 * Represents the configuration for a credential at various levels.
 * This type defines how credentials are configured and managed across different educational entities.
 */
export type CredentialConfiguration_CredentialConfiguration = {
  __typename?: 'CredentialConfiguration_CredentialConfiguration';
  /**
   * Credential configuration for child level.
   * If query by institution id, the parent level is program and child level is collection/learning path.
   * If query by program id, the parent level is collection/learning path and child level is course/s12n.
   */
  childCredentialConfigurations: Array<CredentialConfiguration_CredentialConfiguration>;
  /**
   * Specifies at which hierarchical level this configuration applies
   * (e.g., institution-wide, program-specific, course-level, etc.)
   */
  configurationLevel: CredentialConfiguration_Level;
  /**
   * Current status of the configuration - can be CREDENTIAL, NON_CREDENTIAL, or MIXED
   * MIXED typically indicates different states in child configurations
   */
  configurationStatus: CredentialConfiguration_Status;
  /** Unique identifier for the credential configuration */
  id: Scalars['ID'];
  /** Name of the credential configuration */
  name: Scalars['String'];
};

/** Possible credential status values */
export const CredentialConfiguration_CredentialStatus = {
  /** Disabled credential status */
  Disabled: 'DISABLED',
  /** Enabled credential status */
  Enabled: 'ENABLED'
} as const;

export type CredentialConfiguration_CredentialStatus = typeof CredentialConfiguration_CredentialStatus[keyof typeof CredentialConfiguration_CredentialStatus];
/** Domain-specific error interface for credential configuration operations */
export type CredentialConfiguration_Error = {
  /** Error message describing what went wrong */
  message: Scalars['String'];
};

/** Error when invalid credential status is provided */
export type CredentialConfiguration_InvalidCredentialStatusError = CredentialConfiguration_Error & {
  __typename?: 'CredentialConfiguration_InvalidCredentialStatusError';
  /** Error message describing the invalid credential status issue */
  message: Scalars['String'];
  /** The invalid status that was provided */
  providedStatus: Scalars['String'];
};

/**
 * Defines the hierarchical levels at which a credential configuration can be applied.
 * Follows a top-down structure from institution to individual course/specialization level.
 */
export const CredentialConfiguration_Level = {
  /** Collection-level configuration */
  Collection: 'COLLECTION',
  /** Individual course-level configuration */
  Course: 'COURSE',
  /** Institution-wide configuration level */
  Institution: 'INSTITUTION',
  /** Learning path-specific configuration */
  LearningPath: 'LEARNING_PATH',
  /** Program-level configuration */
  Program: 'PROGRAM',
  /** Specialization-level configuration */
  Specialization: 'SPECIALIZATION'
} as const;

export type CredentialConfiguration_Level = typeof CredentialConfiguration_Level[keyof typeof CredentialConfiguration_Level];
/**
 * Paginated result type for credential configurations.
 * Enables efficient querying of large sets of credential configurations.
 */
export type CredentialConfiguration_PaginatedResult = {
  __typename?: 'CredentialConfiguration_PaginatedResult';
  /** List of credential configurations for the current page */
  elements: Array<CredentialConfiguration_CredentialConfiguration>;
  /** Pagination information for navigating through results */
  pagination: Pagination;
};

/** Error when user lacks permission to modify credential configuration */
export type CredentialConfiguration_PermissionDeniedError = CredentialConfiguration_Error & {
  __typename?: 'CredentialConfiguration_PermissionDeniedError';
  /** Error message describing the permission denied issue */
  message: Scalars['String'];
};

/** Error when program is not found */
export type CredentialConfiguration_ProgramNotFoundError = CredentialConfiguration_Error & {
  __typename?: 'CredentialConfiguration_ProgramNotFoundError';
  /** Error message describing the program not found issue */
  message: Scalars['String'];
  /** The program ID that was not found */
  programId: Scalars['ID'];
};

/** This is returned if setting credential configuration for a collection or learning path fails. */
export type CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathFailure = {
  __typename?: 'CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathFailure';
  /** List of errors that occurred during the operation */
  errors: Array<CredentialConfiguration_InvalidCredentialStatusError | CredentialConfiguration_PermissionDeniedError | CredentialConfiguration_ProgramNotFoundError | CredentialConfiguration_TrackNotFoundError | CredentialConfiguration_UnexpectedConfigurationInRequestError>;
};

/** Input for setting credential configuration for a collection or learning path */
export type CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathInput = {
  /** Credential status to set */
  credentialStatus: CredentialConfiguration_CredentialStatus;
  /** Program ID */
  programId: Scalars['ID'];
  /** Track ID (collection or learning path ID) */
  trackId: Scalars['ID'];
};

/** Response union for setting credential configuration for a collection or learning path */
export type CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathResult = CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathFailure | CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathSuccess;

/** This is returned if setting credential configuration for a collection or learning path succeeds. */
export type CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathSuccess = {
  __typename?: 'CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathSuccess';
  /** Indicates the operation was successful */
  success: Scalars['Boolean'];
};

/** This is returned if setting credential configuration for a program fails. */
export type CredentialConfiguration_SetCredentialConfigurationForProgramFailure = {
  __typename?: 'CredentialConfiguration_SetCredentialConfigurationForProgramFailure';
  /** List of errors that occurred during the operation */
  errors: Array<CredentialConfiguration_InvalidCredentialStatusError | CredentialConfiguration_PermissionDeniedError | CredentialConfiguration_ProgramNotFoundError | CredentialConfiguration_TrackNotFoundError | CredentialConfiguration_UnexpectedConfigurationInRequestError>;
};

/** Input for setting credential configuration for a program */
export type CredentialConfiguration_SetCredentialConfigurationForProgramInput = {
  /** Credential status to set */
  credentialStatus: CredentialConfiguration_CredentialStatus;
  /** Program ID */
  programId: Scalars['ID'];
};

/** Response union for setting credential configuration for a program */
export type CredentialConfiguration_SetCredentialConfigurationForProgramResult = CredentialConfiguration_SetCredentialConfigurationForProgramFailure | CredentialConfiguration_SetCredentialConfigurationForProgramSuccess;

/** This is returned if setting credential configuration for a program succeeds. */
export type CredentialConfiguration_SetCredentialConfigurationForProgramSuccess = {
  __typename?: 'CredentialConfiguration_SetCredentialConfigurationForProgramSuccess';
  /** Indicates the operation was successful */
  success: Scalars['Boolean'];
};

/**
 * Represents the possible states of a credential configuration.
 * MIXED state is particularly important for parent configurations that may have children
 * with different states.
 */
export const CredentialConfiguration_Status = {
  /** Configuration is active and fully enabled */
  Credential: 'CREDENTIAL',
  /** Indicates mixed states among child configurations */
  Mixed: 'MIXED',
  /** Configuration is inactive or disabled */
  NonCredential: 'NON_CREDENTIAL'
} as const;

export type CredentialConfiguration_Status = typeof CredentialConfiguration_Status[keyof typeof CredentialConfiguration_Status];
/** Error when track (collection or learning path) is not found */
export type CredentialConfiguration_TrackNotFoundError = CredentialConfiguration_Error & {
  __typename?: 'CredentialConfiguration_TrackNotFoundError';
  /** Error message describing the track not found issue */
  message: Scalars['String'];
  /** The track ID that was not found */
  trackId: Scalars['ID'];
};

/**
 * Error thrown when there is an unexpected configuration in the input
 * e.g configuration level is not valid for the request scope
 */
export type CredentialConfiguration_UnexpectedConfigurationInRequestError = CredentialConfiguration_Error & {
  __typename?: 'CredentialConfiguration_UnexpectedConfigurationInRequestError';
  /** Error message */
  message: Scalars['String'];
};

/** Generic input for updating credential configurations */
export type CredentialConfiguration_UpdateCredentialConfigurationInput = {
  /** Level of the credential configuration */
  configurationLevel: CredentialConfiguration_Level;
  /** New status for the credential configuration */
  configurationStatus: CredentialConfiguration_Status;
  /** Credential configuration ID */
  id: Scalars['ID'];
};

/** Failure when updating credential configurations inside institution */
export type CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionFailure = {
  __typename?: 'CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionFailure';
  /** Errors */
  errors: Array<CredentialConfiguration_InvalidCredentialStatusError | CredentialConfiguration_PermissionDeniedError | CredentialConfiguration_ProgramNotFoundError | CredentialConfiguration_TrackNotFoundError | CredentialConfiguration_UnexpectedConfigurationInRequestError>;
};

/** Mutation input for updating credential configurations inside institution */
export type CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionInput = {
  /**
   * Credential configurations to be updated.
   * For an institution, we expect a list of configs corresponding to the programs and collections under this program
   */
  credentialConfigurations: Array<CredentialConfiguration_UpdateCredentialConfigurationInput>;
  /** Institution for which credential configurations are to be updated in */
  institutionId: Scalars['ID'];
};

/** Mutation response for updating credential configurations inside institution */
export type CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionResult = CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionFailure | CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionSuccess;

/** Success when updating credential configurations inside institution */
export type CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionSuccess = {
  __typename?: 'CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionSuccess';
  /** Success message */
  message: Scalars['String'];
};

/** Failure when updating credential configurations inside program */
export type CredentialConfiguration_UpdateCredentialConfigurationsForProgramFailure = {
  __typename?: 'CredentialConfiguration_UpdateCredentialConfigurationsForProgramFailure';
  /** Errors */
  errors: Array<CredentialConfiguration_InvalidCredentialStatusError | CredentialConfiguration_PermissionDeniedError | CredentialConfiguration_ProgramNotFoundError | CredentialConfiguration_TrackNotFoundError | CredentialConfiguration_UnexpectedConfigurationInRequestError>;
};

/** Mutation input for updating credential configurations inside program */
export type CredentialConfiguration_UpdateCredentialConfigurationsForProgramInput = {
  /**
   * Credential configurations to be updated.
   * For a program, we expect a list of configs corresponding to the collections and products under this program
   */
  credentialConfigurations: Array<CredentialConfiguration_UpdateCredentialConfigurationInput>;
  /** Program for which credential configurations are to be updated in */
  programId: Scalars['ID'];
};

/** Mutation response for updating credential configurations inside program */
export type CredentialConfiguration_UpdateCredentialConfigurationsForProgramResult = CredentialConfiguration_UpdateCredentialConfigurationsForProgramFailure | CredentialConfiguration_UpdateCredentialConfigurationsForProgramSuccess;

/** Success when updating credential configurations inside program */
export type CredentialConfiguration_UpdateCredentialConfigurationsForProgramSuccess = {
  __typename?: 'CredentialConfiguration_UpdateCredentialConfigurationsForProgramSuccess';
  /** Success message */
  message: Scalars['String'];
};

/** Curriculum Management file processing workflow queries */
export type CsvDownloadQueries = {
  __typename?: 'CsvDownloadQueries';
  /** Query the csv download links by degree id and file processing type */
  queryByDegreeIdAndFileType: CsvDownload_Links;
};


/** Curriculum Management file processing workflow queries */
export type CsvDownloadQueriesQueryByDegreeIdAndFileTypeArgs = {
  degreeId: Scalars['ID'];
  processingType: CurriculumManagement_FileProcessingType;
};

/** CSV download links (curriculum) */
export type CsvDownload_CurriculumLinks = {
  __typename?: 'CsvDownload_CurriculumLinks';
  /** All files (zip) link */
  allFilesZipLink: Scalars['URL'];
  /** Categories file (or template) link */
  categoriesLink: Scalars['URL'];
  /** Curriculum metadata file (or template) link */
  curriculumLink: Scalars['URL'];
  /** Degree course pre-reqs file (or template) link */
  degreeCoursePrereqsLink: Scalars['URL'];
  /** Degree courses mapping file (or template) link */
  degreeCoursesMappingLink: Scalars['URL'];
  /** Degree courses properties file (or template) link */
  degreeCoursesPropertiesLink: Scalars['URL'];
  /** Segments file (or template) link */
  segmentsLink: Scalars['URL'];
};

/** CSV download links */
export type CsvDownload_Links = CsvDownload_CurriculumLinks | CsvDownload_TermLinks;

/** CSV download links (term) */
export type CsvDownload_TermLinks = {
  __typename?: 'CsvDownload_TermLinks';
  /** Academic calendar file (or template) link */
  academicCalendarLink: Scalars['URL'];
  /** All files (zip) link */
  allFilesZipLink: Scalars['URL'];
  /** Term course offerings file (or template) link */
  termCourseOfferingsLink: Scalars['URL'];
  /** Term structure file (or template) link */
  termStructureLink: Scalars['URL'];
  /** Umbrella term structure (or template) link */
  umbrellaTermStructureLink: Scalars['URL'];
};

/** Queries for Enterprise Program Curations */
export type CurationBuilderQueries = {
  __typename?: 'CurationBuilderQueries';
  /** Returns CurationOutline for the specified curationOutlineId */
  queryBulkCurationOutlines?: Maybe<CurationBuilder_BulkCurationOutlines>;
  /** Returns CurationOutline for the specified curationOutlineId */
  queryCurationOutline?: Maybe<CurationBuilder_CurationOutline>;
  /** Returns CurationOutlineContentSuggestions for the specified set of curationOutlineIds */
  queryCurationOutlineContentSuggestions?: Maybe<CurationBuilder_CurationOutlineContentSuggestions>;
  /** Returns ProgramOutline for the specified programOutlineId */
  queryProgramOutline?: Maybe<CurationBuilder_ProgramOutline>;
};


/** Queries for Enterprise Program Curations */
export type CurationBuilderQueriesQueryBulkCurationOutlinesArgs = {
  bulkSessionId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


/** Queries for Enterprise Program Curations */
export type CurationBuilderQueriesQueryCurationOutlineArgs = {
  curationOutlineId: Scalars['ID'];
  organizationId: Scalars['ID'];
};


/** Queries for Enterprise Program Curations */
export type CurationBuilderQueriesQueryCurationOutlineContentSuggestionsArgs = {
  curationOutlineIds: Array<Scalars['ID']>;
  organizationId: Scalars['ID'];
};


/** Queries for Enterprise Program Curations */
export type CurationBuilderQueriesQueryProgramOutlineArgs = {
  organizationId: Scalars['ID'];
  programOutlineId: Scalars['ID'];
};

/** Curation Builder Update Program failure response */
export type CurationBuilder_AddGroupCurationsToProgramsFailureResult = {
  __typename?: 'CurationBuilder_AddGroupCurationsToProgramsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating an enterprise program from a curation outline */
export type CurationBuilder_AddGroupCurationsToProgramsInput = {
  /** Suggested Curations with Matching Groups */
  SuggestedCurationsWithMatchingGroups: Array<CurationBuilder_SuggestedCurationWithMatchingGroups>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Curation Builder Add Group Curations To Programs result, can either be a success or failure */
export type CurationBuilder_AddGroupCurationsToProgramsResult = CurationBuilder_AddGroupCurationsToProgramsFailureResult | CurationBuilder_AddGroupCurationsToProgramsSuccessResult;

/** Curation Builder Update Program success response */
export type CurationBuilder_AddGroupCurationsToProgramsSuccessResult = {
  __typename?: 'CurationBuilder_AddGroupCurationsToProgramsSuccessResult';
  /** Updated enterprise programs */
  enterprisePrograms: Array<EnterpriseProgram_EnterpriseProgram>;
};

/** Group Curation Outlines */
export type CurationBuilder_BulkCurationOutlines = {
  __typename?: 'CurationBuilder_BulkCurationOutlines';
  /** Bulk Session ID */
  bulkSessionId: Scalars['ID'];
  /** Curation Outlines and contains matching groups. */
  curationOutlines: Array<CurationBuilder_CurationOutline>;
  /** Organization ID */
  organizationId: Scalars['ID'];
};

/** Program Builder Create Program failure response */
export type CurationBuilder_CreateProgramFromProgramOutlineFailureResult = {
  __typename?: 'CurationBuilder_CreateProgramFromProgramOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for creating an enterprise program from a program outline */
export type CurationBuilder_CreateProgramFromProgramOutlineInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program outline request */
  programOutlineRequest: CurationBuilder_ProgramOutlineUpdateRequest;
  /** Suggested curation requests */
  suggestedCurationRequests: Array<CurationBuilder_SuggestedCurationRequest>;
};

/** Program Builder Create Program result, can either be a success or failure */
export type CurationBuilder_CreateProgramFromProgramOutlineResult = CurationBuilder_CreateProgramFromProgramOutlineFailureResult | CurationBuilder_CreateProgramFromProgramOutlineSuccessResult;

/** Program Builder Create Program success response */
export type CurationBuilder_CreateProgramFromProgramOutlineSuccessResult = {
  __typename?: 'CurationBuilder_CreateProgramFromProgramOutlineSuccessResult';
  /** Created enterprise program */
  enterpriseProgram: EnterpriseProgram_EnterpriseProgram;
  /** Slug of the created enterprise program */
  enterpriseProgramSlug: Scalars['String'];
};

/** Single CurationOutline representation */
export type CurationBuilder_CurationOutline = {
  __typename?: 'CurationBuilder_CurationOutline';
  /** Status of the outline generation process */
  curationOutlineGenerationMetadata?: Maybe<CurationBuilder_CurationOutlineGenerationMetadata>;
  /** UUID for the curation outline */
  curationOutlineId: Scalars['ID'];
  /** Type of curation (COLLECTIONS or LEARNING_PATHS) */
  curationType: CurationBuilder_CurationType;
  /** Description of the curation outline */
  description: Scalars['String'];
  /** Expected learning completion hours (default 10) - applicable only for LearningPaths */
  expectedLearningCompletionHours?: Maybe<Scalars['Float']>;
  /** Learning objectives for the curation outline */
  learningObjectives: Array<CurationBuilder_LearningObjective>;
  /**
   * Optional matchingGroupIds
   * Will have a value only if saved groups has been linked to this curation outline
   */
  matchingGroupIds?: Maybe<Array<Scalars['ID']>>;
  /** Status of the outline generation process */
  outlineGenerationStatus: CurationBuilder_OutlineGenerationStatus;
  /**
   * DEPRECATED - Optional programId
   * Will have a value only if a saved program has been linked to this curation outline
   * @deprecated Use matchingGroupIds instead
   */
  programId?: Maybe<Scalars['ID']>;
  /** Title of the curation outline */
  title: Scalars['String'];
};

/** Content suggestions for curation outlines */
export type CurationBuilder_CurationOutlineContentSuggestions = {
  __typename?: 'CurationBuilder_CurationOutlineContentSuggestions';
  /** Array of suggested curations */
  suggestedCurations: Array<CurationBuilder_SuggestedCuration>;
  /** Status of the suggestion generation process */
  suggestionGenerationStatus: CurationBuilder_OutlineGenerationStatus;
};

/** Curation Outline Content Suggestions failure response */
export type CurationBuilder_CurationOutlineContentSuggestionsFailureResult = {
  __typename?: 'CurationBuilder_CurationOutlineContentSuggestionsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Curation Outline Content Suggestions success response */
export type CurationBuilder_CurationOutlineContentSuggestionsSuccessResult = {
  __typename?: 'CurationBuilder_CurationOutlineContentSuggestionsSuccessResult';
  /** Generated content suggestions */
  curationOutlineContentSuggestions: CurationBuilder_CurationOutlineContentSuggestions;
};

/** Input for Curation Outline Request */
export type CurationBuilder_CurationOutlineCreateOrUpdateRequest = {
  /** UUID for the curation outline (if no value is provided, will be auto-generated on the backend) */
  curationOutlineId?: InputMaybe<Scalars['ID']>;
  /** Parameters for curation outline request */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
};

/** Curation Outline Generation Metadata */
export type CurationBuilder_CurationOutlineGenerationMetadata = {
  __typename?: 'CurationBuilder_CurationOutlineGenerationMetadata';
  /**
   * Optional curationOutlineId
   * Will have a value only if the associated curation outline was re-generated
   * i.e an existing curation outline was updated
   */
  curationOutlineId?: Maybe<Scalars['ID']>;
  /** Types of curation */
  curationType: CurationBuilder_CurationType;
  /** Location of uploaded prompt file */
  fileLocation?: Maybe<CurationBuilder_PromptFileLocation>;
  /** Language for the program outline e.g. "en" */
  language: Scalars['String'];
  /** Program ID */
  programId: Scalars['ID'];
  /**
   * Optional programOutlineId
   * Will have a value only if the associated curation outline was created in the scope of a parent
   * program outline
   */
  programOutlineId?: Maybe<Scalars['ID']>;
  /** Text representing learner audience and learning goals */
  prompt: Scalars['String'];
};

/** Parameters of a Curation Outline */
export type CurationBuilder_CurationOutlineParams = {
  /** Type of curation (COLLECTIONS or LEARNING_PATHS) */
  curationType: CurationBuilder_CurationType;
  /** Description of the curation outline */
  description: Scalars['String'];
  /** Expected learning completion hours (default 10) - applicable only for LearningPaths */
  expectedLearningCompletionHours?: InputMaybe<Scalars['Float']>;
  /** Learning objectives */
  learningObjectives: Array<CurationBuilder_LearningObjectiveInput>;
  /** Title of the curation outline */
  title: Scalars['String'];
};

/** Curation type enum */
export const CurationBuilder_CurationType = {
  /** Collections curation type */
  Collections: 'COLLECTIONS',
  /** Learning paths curation type */
  LearningPaths: 'LEARNING_PATHS'
} as const;

export type CurationBuilder_CurationType = typeof CurationBuilder_CurationType[keyof typeof CurationBuilder_CurationType];
/** Learning Attributes deduced from uploaded file */
export type CurationBuilder_FileUploadPromptAttributes = {
  __typename?: 'CurationBuilder_FileUploadPromptAttributes';
  /** Language - deduced from the uploaded file e.g. "en" */
  language: Scalars['String'];
  /** Learner audience description - deduced from the uploaded file */
  learnerAudience: Scalars['String'];
  /** Learning goals description - deduced from the uploaded file */
  learningGoals: Scalars['String'];
  /** Matching Program IDs - deduced from the uploaded file */
  matchingProgramIds?: Maybe<Array<Scalars['ID']>>;
};

/** Generate Curation Outline failure response */
export type CurationBuilder_GenerateBulkCurationOutlinesFailureResult = {
  __typename?: 'CurationBuilder_GenerateBulkCurationOutlinesFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for generating group curation outlines */
export type CurationBuilder_GenerateBulkCurationOutlinesInput = {
  /**
   * Session UUID (optional)
   * if value not passed - BE will create a new session
   * if value is passed - BE will update an existing session
   */
  bulkSessionId?: InputMaybe<Scalars['ID']>;
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Types of curation to generate */
  curationTypes: Array<CurationBuilder_CurationType>;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the curation outline e.g. "en" */
  language: Scalars['String'];
  /** Program ID list, it can be empty. */
  learnerAudiences?: InputMaybe<Array<Scalars['ID']>>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Shared Prompt for group curation outlines creation */
  sharedPrompt: Scalars['String'];
};

/** Generate Curation Outline result, can either be a success or failure */
export type CurationBuilder_GenerateBulkCurationOutlinesResult = CurationBuilder_GenerateBulkCurationOutlinesFailureResult | CurationBuilder_GenerateBulkCurationOutlinesSuccessResult;

/** Generate Curation Outline success response */
export type CurationBuilder_GenerateBulkCurationOutlinesSuccessResult = {
  __typename?: 'CurationBuilder_GenerateBulkCurationOutlinesSuccessResult';
  /** Bulk Session Id */
  bulkSessionId: Scalars['ID'];
};

/** Input for generating curation outline content suggestions */
export type CurationBuilder_GenerateCurationOutlineContentSuggestionsInput = {
  /** Contents to retain from previous suggestions */
  contentsToRetain?: Array<CurationBuilder_SuggestedCurationRequest>;
  /** Curation content types to include */
  curationContentTypes: Array<CurationBuilder_ProductType>;
  /** Array of curation outline requests */
  curationOutlineRequests: Array<CurationBuilder_CurationOutlineCreateOrUpdateRequest>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Partner IDs to filter suggestions */
  partnerIds: Array<Scalars['ID']>;
};

/** Curation Outline Content Suggestions result, can either be a success or failure */
export type CurationBuilder_GenerateCurationOutlineContentSuggestionsResult = CurationBuilder_CurationOutlineContentSuggestionsFailureResult | CurationBuilder_CurationOutlineContentSuggestionsSuccessResult;

/** Generate Curation Outline failure response */
export type CurationBuilder_GenerateCurationOutlineFailureResult = {
  __typename?: 'CurationBuilder_GenerateCurationOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for generating a curation outline */
export type CurationBuilder_GenerateCurationOutlineInput = {
  /**
   * curation outline UUID (optional)
   * if value not passed - BE will create a new curationOutline
   * if value is passed - BE will update an existing curationOutline
   */
  curationOutlineId?: InputMaybe<Scalars['ID']>;
  /** Type of curation to generate */
  curationType: CurationBuilder_CurationType;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the curation outline e.g. "en" */
  language: Scalars['String'];
  /** Learner audience description */
  learnerAudience: Scalars['String'];
  /** Learning goals description */
  learningGoals: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program ID */
  programId: Scalars['ID'];
};

/** Generate Curation Outline result, can either be a success or failure */
export type CurationBuilder_GenerateCurationOutlineResult = CurationBuilder_GenerateCurationOutlineFailureResult | CurationBuilder_GenerateCurationOutlineSuccessResult;

/** Generate Curation Outline success response */
export type CurationBuilder_GenerateCurationOutlineSuccessResult = {
  __typename?: 'CurationBuilder_GenerateCurationOutlineSuccessResult';
  /** curationOutlineId (created or updated) */
  curationOutlineId: Scalars['ID'];
};

/** Generate File Upload Location failure response */
export type CurationBuilder_GenerateFileUploadLocationFailureResult = {
  __typename?: 'CurationBuilder_GenerateFileUploadLocationFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for requesting an s3 File upload location */
export type CurationBuilder_GenerateFileUploadLocationInput = {
  /** File name */
  fileName: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Generates a File Upload Location, can either be a success or failure */
export type CurationBuilder_GenerateFileUploadLocationResult = CurationBuilder_GenerateFileUploadLocationFailureResult | CurationBuilder_GenerateFileUploadLocationSuccessResult;

/** Generate File Upload Location success response */
export type CurationBuilder_GenerateFileUploadLocationSuccessResult = {
  __typename?: 'CurationBuilder_GenerateFileUploadLocationSuccessResult';
  /** s3 Location where prompt file should be uploaded to by the FE */
  fileLocation: CurationBuilder_PromptFileLocation;
};

/** Generate Program Outline failure response */
export type CurationBuilder_GenerateProgramOutlineFailureResult = {
  __typename?: 'CurationBuilder_GenerateProgramOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for generating a program outline */
export type CurationBuilder_GenerateProgramOutlineInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Types of curations to generate */
  curationTypes: Array<CurationBuilder_CurationType>;
  /** Location of prompt file in s3 */
  fileLocation?: InputMaybe<CurationBuilder_PromptFileLocationInput>;
  /** Language for the program outline e.g. "en" */
  language: Scalars['String'];
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /**
   * program outline UUID (optional)
   * if value not passed - BE will create a new programOutline
   * if value is passed - BE will update an existing programOutline
   */
  programOutlineId?: InputMaybe<Scalars['ID']>;
  /** Text representing learner audience and learning goals */
  prompt: Scalars['String'];
};

/** Generate Program Outline result, can either be a success or failure */
export type CurationBuilder_GenerateProgramOutlineResult = CurationBuilder_GenerateProgramOutlineFailureResult | CurationBuilder_GenerateProgramOutlineSuccessResult;

/** Generate Program Outline success response */
export type CurationBuilder_GenerateProgramOutlineSuccessResult = {
  __typename?: 'CurationBuilder_GenerateProgramOutlineSuccessResult';
  /** programOutlineId (created or updated) */
  programOutlineId: Scalars['ID'];
};

/** Generate Prompt Attributes failure response */
export type CurationBuilder_GeneratePromptAttributesFromFileFailureResult = {
  __typename?: 'CurationBuilder_GeneratePromptAttributesFromFileFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/**
 * Input for generating AI prompt from a file
 * Will initialize an outline of supplied outlineType
 */
export type CurationBuilder_GeneratePromptAttributesFromFileInput = {
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Location of prompt file that was uploaded to s3 */
  fileLocation: CurationBuilder_PromptFileLocationInput;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /**
   * Optional Unique ID identifier for the outlineType
   * if not provided, a new outline of outlineType will be created/initialized
   * if provided, the existing outline of outlineType will be updated/reinitialized
   */
  outlineId?: InputMaybe<Scalars['ID']>;
  /** Type of outline to generate prompt attributes for */
  outlineType: CurationBuilder_OutlineType;
  /** program ID required for curation builder flow */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Generate Prompt Attributes result, can either be a success or failure */
export type CurationBuilder_GeneratePromptAttributesFromFileResult = CurationBuilder_GeneratePromptAttributesFromFileFailureResult | CurationBuilder_GeneratePromptAttributesFromFileSuccessResult;

/** Generate Prompt Attributes success response */
export type CurationBuilder_GeneratePromptAttributesFromFileSuccessResult = {
  __typename?: 'CurationBuilder_GeneratePromptAttributesFromFileSuccessResult';
  /** Unique UUID identifier for the returned outline type */
  outlineId: Scalars['ID'];
  /** Type of outline returned */
  outlineType: CurationBuilder_OutlineType;
  /** Prompt attributes - attributes for building ai prompt deduced from the uploaded file */
  promptAttributes: CurationBuilder_FileUploadPromptAttributes;
};

/** Learning objectives including narration and skills */
export type CurationBuilder_LearningObjective = {
  __typename?: 'CurationBuilder_LearningObjective';
  /** Text summarizing the learning objective */
  narration: Scalars['String'];
  /** Skills associated with this learning objective */
  skills: Array<Skill_Skill>;
};

/** Input for Learning Objectives */
export type CurationBuilder_LearningObjectiveInput = {
  /** Text summarizing the learning objective */
  narration: Scalars['String'];
  /** Skills associated with this learning objective */
  skillIds: Array<Scalars['ID']>;
};

/** Input for learning path badge configuration */
export type CurationBuilder_LearningPathBadgeConfigurationInput = {
  /** Logo image height for the badge (px) */
  logoImageHeight?: Scalars['Int'];
  /** Logo image URL for the badge */
  logoImageUrl: Scalars['URL'];
};

/** Generic concrete implementation of base error interface */
export type CurationBuilder_MutationError = CurationBuilder_MutationFailure & Error & {
  __typename?: 'CurationBuilder_MutationError';
  /** Error message */
  message: Scalars['String'];
};

/** Base error interface */
export type CurationBuilder_MutationFailure = {
  /** Error message */
  message: Scalars['String'];
};

/** Outline generation status enum */
export const CurationBuilder_OutlineGenerationStatus = {
  /** Outline will go into this state when generation is completed */
  Generated: 'GENERATED',
  /**
   * Outline will toggle through this state when generation is in progress
   * i.e. when CurationBuilder_GenerateProgramOutline is called
   * Outline will also return to this state when Regeneration is triggered
   */
  Generating: 'GENERATING',
  /**
   * This is a terminal state, when the generation failure is permanent and shouldn't be retried.
   * Outline may also go into this state when generation fails after all retries have been exhausted.
   * Users will need to be notified whenever generation hits this state.
   */
  GenerationFailedNonRetryable: 'GENERATION_FAILED_NON_RETRYABLE',
  /**
   * Outline may go into this state when generation fails but is eligible to be auto-retried.
   * The async generation logic would retry 3x after which if it still fails then the state would go permanently into GENERATION_FAILED_NON_RETRYABLE.
   */
  GenerationFailedRetryable: 'GENERATION_FAILED_RETRYABLE',
  /**
   * Initial status when outline is first saved during
   * the CurationBuilder_GeneratePromptAttributesFromFile stage
   * Outline will also return to this state when file is re-uploaded
   * i.e. CurationBuilder_GeneratePromptAttributesFromFile is called
   */
  GenerationInitialized: 'GENERATION_INITIALIZED'
} as const;

export type CurationBuilder_OutlineGenerationStatus = typeof CurationBuilder_OutlineGenerationStatus[keyof typeof CurationBuilder_OutlineGenerationStatus];
/** Outline type enum */
export const CurationBuilder_OutlineType = {
  /** Curation outline type */
  CurationOutline: 'CURATION_OUTLINE',
  /** Group curation outline type */
  GroupCurationOutline: 'GROUP_CURATION_OUTLINE',
  /** Program outline type */
  ProgramOutline: 'PROGRAM_OUTLINE'
} as const;

export type CurationBuilder_OutlineType = typeof CurationBuilder_OutlineType[keyof typeof CurationBuilder_OutlineType];
/** Product type enum */
export const CurationBuilder_ProductType = {
  /** Course product type */
  Course: 'COURSE',
  /** Guided project product type */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional certificate product type */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type */
  Project: 'PROJECT',
  /** Specialization product type */
  Specialization: 'SPECIALIZATION',
  /** Video product type */
  Video: 'VIDEO'
} as const;

export type CurationBuilder_ProductType = typeof CurationBuilder_ProductType[keyof typeof CurationBuilder_ProductType];
/** Single ProgramOutline representation */
export type CurationBuilder_ProgramOutline = {
  __typename?: 'CurationBuilder_ProgramOutline';
  /** Array of CurationOutline objects associated with this programOutline */
  curationOutlines: Array<CurationBuilder_CurationOutline>;
  /** Status of the outline generation process */
  outlineGenerationStatus: CurationBuilder_OutlineGenerationStatus;
  /** Description about a program being built */
  programDescription: Scalars['String'];
  /**
   * Optional programId
   * Will have a value only if a saved program has been linked to this program outline
   */
  programId?: Maybe<Scalars['ID']>;
  /** Name to be applied to a program being built */
  programName: Scalars['String'];
  /** Status of the outline generation process */
  programOutlineGenerationMetadata?: Maybe<CurationBuilder_ProgramOutlineGenerationMetadata>;
  /** Unique identifier for a programOutline */
  programOutlineId: Scalars['ID'];
};

/** Program Outline Generation Metadata */
export type CurationBuilder_ProgramOutlineGenerationMetadata = {
  __typename?: 'CurationBuilder_ProgramOutlineGenerationMetadata';
  /** Contract ID */
  contractId: Scalars['ID'];
  /** Types of curations to generate */
  curationTypes: Array<CurationBuilder_CurationType>;
  /** Location of uploaded prompt file */
  fileLocation?: Maybe<CurationBuilder_PromptFileLocation>;
  /** Language for the program outline e.g. "en" */
  language: Scalars['String'];
  /**
   * Optional programOutlineId
   * Will have a value only if the associated program outline was re-generated
   * i.e an existing program outline was updated
   */
  programOutlineId?: Maybe<Scalars['ID']>;
  /** Text representing learner audience and learning goals */
  prompt: Scalars['String'];
};

/** Parameters of a Program Outline */
export type CurationBuilder_ProgramOutlineParams = {
  /** Array of CurationOutline objects associated with this programOutline */
  curationOutlineRequests: Array<CurationBuilder_CurationOutlineCreateOrUpdateRequest>;
  /** Description about a program being built */
  programDescription: Scalars['String'];
  /** Name to be applied to a program being built */
  programName: Scalars['String'];
};

/** Input for Program Outline Request */
export type CurationBuilder_ProgramOutlineUpdateRequest = {
  /** Unique UUID identifier for a programOutline */
  programOutlineId: Scalars['ID'];
  /** Parameters for program outline request */
  programOutlineParams: CurationBuilder_ProgramOutlineParams;
};

/** S3 file location */
export type CurationBuilder_PromptFileLocation = {
  __typename?: 'CurationBuilder_PromptFileLocation';
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
  /** signed upload url of file */
  signedUploadUrl: Scalars['URL'];
};

/** S3 file location */
export type CurationBuilder_PromptFileLocationInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
  /** signed s3 Upload File Url */
  signedUploadUrl: Scalars['URL'];
};

/** Suggested curation information */
export type CurationBuilder_SuggestedCuration = {
  __typename?: 'CurationBuilder_SuggestedCuration';
  /** Curation outline ID */
  curationOutlineId: Scalars['ID'];
  /** Products suggested for this curation */
  products: Array<CurationBuilder_SuggestedProduct>;
};

/** Input for suggested curation */
export type CurationBuilder_SuggestedCurationRequest = {
  /** Curation outline ID */
  curationOutlineId: Scalars['ID'];
  /** Products suggested for this curation */
  productIds: Array<Scalars['ID']>;
};

/** Input for suggested curation with matched groups */
export type CurationBuilder_SuggestedCurationWithMatchingGroups = {
  /** Group IDs */
  groupIds: Array<Scalars['ID']>;
  /** Suggested curation requests */
  suggestedCurationRequests: Array<CurationBuilder_SuggestedCurationRequest>;
};

/** Suggested product information */
export type CurationBuilder_SuggestedProduct = {
  __typename?: 'CurationBuilder_SuggestedProduct';
  /** Learning time in hours for this product */
  calculatedLearningTimeHours?: Maybe<Scalars['Float']>;
  /** Product ID */
  productId: Scalars['ID'];
  /** Product type */
  productType: CurationBuilder_ProductType;
};

/** Update Badge Configurations failure response */
export type CurationBuilder_UpdateBadgeConfigurationsFailureResult = {
  __typename?: 'CurationBuilder_UpdateBadgeConfigurationsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Update Badge Configurations failure response */
export type CurationBuilder_UpdateBadgeConfigurationsForProgramsFailureResult = {
  __typename?: 'CurationBuilder_UpdateBadgeConfigurationsForProgramsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating badge configurations */
export type CurationBuilder_UpdateBadgeConfigurationsForProgramsInput = {
  /** Learning path badge configuration */
  learningPathBadgeConfiguration: CurationBuilder_LearningPathBadgeConfigurationInput;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs */
  programIds: Array<Scalars['ID']>;
};

/** Update Badge Configurations result, can either be a success or failure */
export type CurationBuilder_UpdateBadgeConfigurationsForProgramsResult = CurationBuilder_UpdateBadgeConfigurationsForProgramsFailureResult | CurationBuilder_UpdateBadgeConfigurationsForProgramsSuccessResult;

/** Update Badge Configurations success response */
export type CurationBuilder_UpdateBadgeConfigurationsForProgramsSuccessResult = {
  __typename?: 'CurationBuilder_UpdateBadgeConfigurationsForProgramsSuccessResult';
  /** GraphQL types must include at least one field, so a dummy field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input for updating badge configurations */
export type CurationBuilder_UpdateBadgeConfigurationsInput = {
  /** Learning path badge configuration */
  learningPathBadgeConfiguration: CurationBuilder_LearningPathBadgeConfigurationInput;
  /**
   * DEPRECATED- Learning path badge configurations
   * @deprecated List not required - Use learningPathBadgeConfiguration instead
   */
  learningPathBadgeConfigurations?: InputMaybe<Array<CurationBuilder_LearningPathBadgeConfigurationInput>>;
  /** Program ID */
  programId: Scalars['ID'];
};

/** Update Badge Configurations result, can either be a success or failure */
export type CurationBuilder_UpdateBadgeConfigurationsResult = CurationBuilder_UpdateBadgeConfigurationsFailureResult | CurationBuilder_UpdateBadgeConfigurationsSuccessResult;

/** Update Badge Configurations success response */
export type CurationBuilder_UpdateBadgeConfigurationsSuccessResult = {
  __typename?: 'CurationBuilder_UpdateBadgeConfigurationsSuccessResult';
  /** GraphQL types must include at least one field, so a dummy field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Update Curation Outline failure response */
export type CurationBuilder_UpdateCurationOutlineFailureResult = {
  __typename?: 'CurationBuilder_UpdateCurationOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating a curation outline */
export type CurationBuilder_UpdateCurationOutlineInput = {
  /** UUID for the curation outline */
  curationOutlineId: Scalars['ID'];
  /** Curation outline parameters containing updated information */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Update Curation Outline result, can either be a success or failure */
export type CurationBuilder_UpdateCurationOutlineResult = CurationBuilder_UpdateCurationOutlineFailureResult | CurationBuilder_UpdateCurationOutlineSuccessResult;

/** Update Curation Outline success response */
export type CurationBuilder_UpdateCurationOutlineSuccessResult = {
  __typename?: 'CurationBuilder_UpdateCurationOutlineSuccessResult';
  /** Updated curation outline */
  curationOutline: CurationBuilder_CurationOutline;
};

/** Update Curation Outline failure response */
export type CurationBuilder_UpdateCurationOutlineWithGroupsFailureResult = {
  __typename?: 'CurationBuilder_UpdateCurationOutlineWithGroupsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating a curation outline */
export type CurationBuilder_UpdateCurationOutlineWithGroupsInput = {
  /** UUID for the curation outline */
  curationOutlineId: Scalars['ID'];
  /** Curation outline parameters containing updated information */
  curationOutlineParams: CurationBuilder_CurationOutlineParams;
  /** Updated matching group id */
  newMatchingGroupIds: Array<Scalars['ID']>;
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
};

/** Update Curation Outline result, can either be a success or failure */
export type CurationBuilder_UpdateCurationOutlineWithGroupsResult = CurationBuilder_UpdateCurationOutlineWithGroupsFailureResult | CurationBuilder_UpdateCurationOutlineWithGroupsSuccessResult;

/** Update Curation Outline success response */
export type CurationBuilder_UpdateCurationOutlineWithGroupsSuccessResult = {
  __typename?: 'CurationBuilder_UpdateCurationOutlineWithGroupsSuccessResult';
  /** Updated curation outline */
  curationOutline: CurationBuilder_CurationOutline;
  /** Matching Group IDs */
  groupIds: Array<Scalars['ID']>;
};

/** Curation Builder Update Program failure response */
export type CurationBuilder_UpdateProgramFromCurationOutlineFailureResult = {
  __typename?: 'CurationBuilder_UpdateProgramFromCurationOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating an enterprise program from a curation outline */
export type CurationBuilder_UpdateProgramFromCurationOutlineInput = {
  /** Program ID */
  programId: Scalars['ID'];
  /** Suggested curation request */
  suggestedCurationRequest: CurationBuilder_SuggestedCurationRequest;
};

/** Curation Builder Update Program result, can either be a success or failure */
export type CurationBuilder_UpdateProgramFromCurationOutlineResult = CurationBuilder_UpdateProgramFromCurationOutlineFailureResult | CurationBuilder_UpdateProgramFromCurationOutlineSuccessResult;

/** Curation Builder Update Program success response */
export type CurationBuilder_UpdateProgramFromCurationOutlineSuccessResult = {
  __typename?: 'CurationBuilder_UpdateProgramFromCurationOutlineSuccessResult';
  /** Updated enterprise program */
  enterpriseProgram: EnterpriseProgram_EnterpriseProgram;
};

/** Update Program Outline failure response */
export type CurationBuilder_UpdateProgramOutlineFailureResult = {
  __typename?: 'CurationBuilder_UpdateProgramOutlineFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<CurationBuilder_MutationError>;
};

/** Input for updating a program outline */
export type CurationBuilder_UpdateProgramOutlineInput = {
  /** Third Party Organization ID */
  organizationId: Scalars['ID'];
  /** Unique UUID identifier for a programOutline */
  programOutlineId: Scalars['ID'];
  /** Program outline parameters containing updated information */
  programOutlineParams: CurationBuilder_ProgramOutlineParams;
};

/** Update Program Outline result, can either be a success or failure */
export type CurationBuilder_UpdateProgramOutlineResult = CurationBuilder_UpdateProgramOutlineFailureResult | CurationBuilder_UpdateProgramOutlineSuccessResult;

/** Update Program Outline success response */
export type CurationBuilder_UpdateProgramOutlineSuccessResult = {
  __typename?: 'CurationBuilder_UpdateProgramOutlineSuccessResult';
  /** Updated program outline */
  programOutline: CurationBuilder_ProgramOutline;
};

/** Query operations for curation recommendations */
export type CurationRecommendationQueries = {
  __typename?: 'CurationRecommendationQueries';
  /**
   * Fetches curation recommendations for specific collection IDs that were created within the last 7 days.
   * This query is optimized to return recent recommendations to avoid stale data.
   */
  queryCurationRecommendationsByCollectionIds: CurationRecommendation_CurationRecommendationPaginatedResult;
};


/** Query operations for curation recommendations */
export type CurationRecommendationQueriesQueryCurationRecommendationsByCollectionIdsArgs = {
  collectionIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Collection item in the suggestions, union of Course or s12n will be set, also clips */
export type CurationRecommendation_CollectionContent = Clip_CourseItem | Course_Course | Specialization_Specialization;

/** Types of content that can be included in curation recommendations */
export const CurationRecommendation_CurationItemType = {
  /** Course content */
  Course: 'COURSE',
  /** Guided project content */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional certificate content */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project content */
  Project: 'PROJECT',
  /** Specialization content */
  Specialization: 'SPECIALIZATION',
  /** Video content */
  Video: 'VIDEO'
} as const;

export type CurationRecommendation_CurationItemType = typeof CurationRecommendation_CurationItemType[keyof typeof CurationRecommendation_CurationItemType];
/** A curation recommendation containing multiple suggestions for improving a collection */
export type CurationRecommendation_CurationRecommendation = {
  __typename?: 'CurationRecommendation_CurationRecommendation';
  /** The ID of the collection this recommendation applies to */
  collectionId: Scalars['ID'];
  /** Lastest Optimization time */
  latestOptimization?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the recommendation */
  recommendationId: Scalars['ID'];
  /** List of individual suggestions for this recommendation */
  suggestions: Array<CurationRecommendation_Suggestion>;
};

/** Paginated result type for curation recommendations */
export type CurationRecommendation_CurationRecommendationPaginatedResult = {
  __typename?: 'CurationRecommendation_CurationRecommendationPaginatedResult';
  /** List of curation recommendations in the current page */
  elements: Array<CurationRecommendation_CurationRecommendation>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Failure response for generating recommendations */
export type CurationRecommendation_GenerateRecommendationFailure = {
  __typename?: 'CurationRecommendation_GenerateRecommendationFailure';
  /** List of errors that occurred during the operation */
  errors: Array<CurationRecommendation_MutationError>;
};

/** Input for generating curation recommendations */
export type CurationRecommendation_GenerateRecommendationInput = {
  /** The ID of the collection to generate recommendations for */
  collectionId: Scalars['ID'];
  /** Language code for the recommendations (e.g., "en", "es", "fr") */
  language?: InputMaybe<Scalars['String']>;
};

/** Result of generating recommendations mutation */
export type CurationRecommendation_GenerateRecommendationResult = CurationRecommendation_GenerateRecommendationFailure | CurationRecommendation_GenerateRecommendationSuccess | CurationRecommendation_GenerateRecommendationSuccessNoRecommendation;

/** Success response for generating recommendations */
export type CurationRecommendation_GenerateRecommendationSuccess = {
  __typename?: 'CurationRecommendation_GenerateRecommendationSuccess';
  /** The generated curation recommendations */
  body: CurationRecommendation_CurationRecommendation;
};

/** Success response for generating recommendations when no recommendation was created */
export type CurationRecommendation_GenerateRecommendationSuccessNoRecommendation = {
  __typename?: 'CurationRecommendation_GenerateRecommendationSuccessNoRecommendation';
  /** GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Generic error type for curation recommendation mutations */
export type CurationRecommendation_MutationError = Error & {
  __typename?: 'CurationRecommendation_MutationError';
  /** Error message describing what went wrong */
  message: Scalars['String'];
};

/** An individual suggestion within a curation recommendation */
export type CurationRecommendation_Suggestion = {
  __typename?: 'CurationRecommendation_Suggestion';
  /** The action to be taken with this content item */
  action: CurationRecommendation_SuggestionActionType;
  /** Content item in the suggestions, union of Course or s12n will be set, also clips */
  content?: Maybe<CurationRecommendation_CollectionContent>;
  /**
   * The ID of the content item being suggested
   * @deprecated use content instead
   */
  contentId: Scalars['ID'];
  /**
   * The type of content being suggested
   * @deprecated use content instead
   */
  contentType: CurationRecommendation_CurationItemType;
  /** Reason of suggestion */
  reason?: Maybe<CurationRecommendation_SuggestionReason>;
  /** The content item being replaced (only populated when this is a replacement suggestion) */
  replacesContent?: Maybe<CurationRecommendation_CollectionContent>;
  /** The current status of this suggestion */
  status: CurationRecommendation_SuggestionStatusType;
  /** Unique identifier for the suggestion */
  suggestionId: Scalars['ID'];
};

/** Actions that can be taken on a content item in a curation suggestion */
export const CurationRecommendation_SuggestionActionType = {
  /** Add this content item to the collection */
  Add: 'ADD',
  /** Remove this content item from the collection */
  Delete: 'DELETE',
  /** Replace this content item from the collection */
  Replace: 'REPLACE'
} as const;

export type CurationRecommendation_SuggestionActionType = typeof CurationRecommendation_SuggestionActionType[keyof typeof CurationRecommendation_SuggestionActionType];
/** The reason for generating this curation recommendation. */
export const CurationRecommendation_SuggestionReason = {
  /** Replace content that is restricted or no longer available. */
  DeprecatedRestrictedContent: 'DEPRECATED_RESTRICTED_CONTENT',
  /** Add new content to collections that currently have fewer than 5 items. */
  ExpandCollection: 'EXPAND_COLLECTION',
  /** Replace content with a lower rating to enhance overall quality. */
  HigherRatingContent: 'HIGHER_RATING_CONTENT',
  /** Replace content that is older than one year with more current material. */
  NewerContent: 'NEWER_CONTENT',
  /** Remove content from collections that have more than 10 items. */
  ReduceCollection: 'REDUCE_COLLECTION',
  /** Remove content from collections that launched over 1 year. */
  StaleContent: 'STALE_CONTENT'
} as const;

export type CurationRecommendation_SuggestionReason = typeof CurationRecommendation_SuggestionReason[keyof typeof CurationRecommendation_SuggestionReason];
/** Status of a curation suggestion */
export const CurationRecommendation_SuggestionStatusType = {
  /** Suggestion has been accepted */
  Accepted: 'ACCEPTED',
  /** Suggestion is pending review */
  Pending: 'PENDING',
  /** Suggestion has been rejected */
  Rejected: 'REJECTED'
} as const;

export type CurationRecommendation_SuggestionStatusType = typeof CurationRecommendation_SuggestionStatusType[keyof typeof CurationRecommendation_SuggestionStatusType];
/** Failure response for updating suggestion status */
export type CurationRecommendation_UpdateSuggestionStatusFailure = {
  __typename?: 'CurationRecommendation_UpdateSuggestionStatusFailure';
  /** List of errors that occurred during the operation */
  errors: Array<CurationRecommendation_MutationError>;
};

/** Input for updating suggestion status */
export type CurationRecommendation_UpdateSuggestionStatusInput = {
  /** Status to update to */
  action: CurationRecommendation_SuggestionStatusType;
  /** Suggestion ID to update status */
  suggestionId: Scalars['ID'];
};

/** Result of Update Suggestion Status */
export type CurationRecommendation_UpdateSuggestionStatusResult = CurationRecommendation_UpdateSuggestionStatusFailure | CurationRecommendation_UpdateSuggestionStatusSuccess;

/** Success response for updating suggestion status */
export type CurationRecommendation_UpdateSuggestionStatusSuccess = {
  __typename?: 'CurationRecommendation_UpdateSuggestionStatusSuccess';
  /** Suggestion ID to accept */
  suggestionId: Scalars['ID'];
};

/** current List of ISO4217 codes. */
export const CurrencyCode = {
  /** TODO: Complete this description */
  Aed: 'AED',
  /** TODO: Complete this description */
  Afn: 'AFN',
  /** TODO: Complete this description */
  All: 'ALL',
  /** TODO: Complete this description */
  Amd: 'AMD',
  /** TODO: Complete this description */
  And: 'AND',
  /** TODO: Complete this description */
  Ang: 'ANG',
  /** TODO: Complete this description */
  Aoa: 'AOA',
  /** TODO: Complete this description */
  Ars: 'ARS',
  /** TODO: Complete this description */
  Aud: 'AUD',
  /** TODO: Complete this description */
  Awg: 'AWG',
  /** TODO: Complete this description */
  Azn: 'AZN',
  /** TODO: Complete this description */
  Bam: 'BAM',
  /** TODO: Complete this description */
  Bbd: 'BBD',
  /** TODO: Complete this description */
  Bdt: 'BDT',
  /** TODO: Complete this description */
  Bgn: 'BGN',
  /** TODO: Complete this description */
  Bhd: 'BHD',
  /** TODO: Complete this description */
  Bif: 'BIF',
  /** TODO: Complete this description */
  Bmd: 'BMD',
  /** TODO: Complete this description */
  Bnd: 'BND',
  /** TODO: Complete this description */
  Bob: 'BOB',
  /** TODO: Complete this description */
  Bov: 'BOV',
  /** TODO: Complete this description */
  Brl: 'BRL',
  /** TODO: Complete this description */
  Bsd: 'BSD',
  /** TODO: Complete this description */
  Btn: 'BTN',
  /** TODO: Complete this description */
  Bwp: 'BWP',
  /** TODO: Complete this description */
  Byn: 'BYN',
  /** TODO: Complete this description */
  Bzd: 'BZD',
  /** TODO: Complete this description */
  Cad: 'CAD',
  /** TODO: Complete this description */
  Cdf: 'CDF',
  /** TODO: Complete this description */
  Che: 'CHE',
  /** TODO: Complete this description */
  Chf: 'CHF',
  /** TODO: Complete this description */
  Chw: 'CHW',
  /** TODO: Complete this description */
  Clf: 'CLF',
  /** TODO: Complete this description */
  Clp: 'CLP',
  /** TODO: Complete this description */
  Cny: 'CNY',
  /** TODO: Complete this description */
  Cop: 'COP',
  /** TODO: Complete this description */
  Cou: 'COU',
  /** TODO: Complete this description */
  Crc: 'CRC',
  /** TODO: Complete this description */
  Cuc: 'CUC',
  /** TODO: Complete this description */
  Cup: 'CUP',
  /** TODO: Complete this description */
  Cve: 'CVE',
  /** TODO: Complete this description */
  Czk: 'CZK',
  /** TODO: Complete this description */
  Djf: 'DJF',
  /** TODO: Complete this description */
  Dkk: 'DKK',
  /** TODO: Complete this description */
  Dop: 'DOP',
  /** TODO: Complete this description */
  Dzd: 'DZD',
  /** TODO: Complete this description */
  Egp: 'EGP',
  /** TODO: Complete this description */
  Ern: 'ERN',
  /** TODO: Complete this description */
  Etb: 'ETB',
  /** TODO: Complete this description */
  Eur: 'EUR',
  /** TODO: Complete this description */
  Fjd: 'FJD',
  /** TODO: Complete this description */
  Fkp: 'FKP',
  /** TODO: Complete this description */
  Gbp: 'GBP',
  /** TODO: Complete this description */
  Gel: 'GEL',
  /** TODO: Complete this description */
  Ghs: 'GHS',
  /** TODO: Complete this description */
  Gip: 'GIP',
  /** TODO: Complete this description */
  Gmd: 'GMD',
  /** TODO: Complete this description */
  Gnf: 'GNF',
  /** TODO: Complete this description */
  Gtq: 'GTQ',
  /** TODO: Complete this description */
  Gyd: 'GYD',
  /** TODO: Complete this description */
  Hkd: 'HKD',
  /** TODO: Complete this description */
  Hnl: 'HNL',
  /** TODO: Complete this description */
  Hrk: 'HRK',
  /** TODO: Complete this description */
  Htg: 'HTG',
  /** TODO: Complete this description */
  Huf: 'HUF',
  /** TODO: Complete this description */
  Idr: 'IDR',
  /** TODO: Complete this description */
  Ils: 'ILS',
  /** TODO: Complete this description */
  Inr: 'INR',
  /** TODO: Complete this description */
  Iqd: 'IQD',
  /** TODO: Complete this description */
  Irr: 'IRR',
  /** TODO: Complete this description */
  Isk: 'ISK',
  /** TODO: Complete this description */
  Jmd: 'JMD',
  /** TODO: Complete this description */
  Jod: 'JOD',
  /** TODO: Complete this description */
  Jpy: 'JPY',
  /** TODO: Complete this description */
  Kes: 'KES',
  /** TODO: Complete this description */
  Kgs: 'KGS',
  /** TODO: Complete this description */
  Khr: 'KHR',
  /** TODO: Complete this description */
  Kmf: 'KMF',
  /** TODO: Complete this description */
  Kpw: 'KPW',
  /** TODO: Complete this description */
  Krw: 'KRW',
  /** TODO: Complete this description */
  Kwd: 'KWD',
  /** TODO: Complete this description */
  Kyd: 'KYD',
  /** TODO: Complete this description */
  Kzt: 'KZT',
  /** TODO: Complete this description */
  Lak: 'LAK',
  /** TODO: Complete this description */
  Lbp: 'LBP',
  /** TODO: Complete this description */
  Lkr: 'LKR',
  /** TODO: Complete this description */
  Lrd: 'LRD',
  /** TODO: Complete this description */
  Lsl: 'LSL',
  /** TODO: Complete this description */
  Lyd: 'LYD',
  /** TODO: Complete this description */
  Mad: 'MAD',
  /** TODO: Complete this description */
  Mdl: 'MDL',
  /** TODO: Complete this description */
  Mga: 'MGA',
  /** TODO: Complete this description */
  Mkd: 'MKD',
  /** TODO: Complete this description */
  Mmk: 'MMK',
  /** TODO: Complete this description */
  Mnt: 'MNT',
  /** TODO: Complete this description */
  Mop: 'MOP',
  /** TODO: Complete this description */
  Mru: 'MRU',
  /** TODO: Complete this description */
  Mur: 'MUR',
  /** TODO: Complete this description */
  Mvr: 'MVR',
  /** TODO: Complete this description */
  Mwk: 'MWK',
  /** TODO: Complete this description */
  Mxn: 'MXN',
  /** TODO: Complete this description */
  Mxv: 'MXV',
  /** TODO: Complete this description */
  Myr: 'MYR',
  /** TODO: Complete this description */
  Mzn: 'MZN',
  /** TODO: Complete this description */
  Nad: 'NAD',
  /** TODO: Complete this description */
  Ngn: 'NGN',
  /** TODO: Complete this description */
  Nio: 'NIO',
  /** TODO: Complete this description */
  Nok: 'NOK',
  /** TODO: Complete this description */
  Npr: 'NPR',
  /** TODO: Complete this description */
  Nzd: 'NZD',
  /** TODO: Complete this description */
  Omr: 'OMR',
  /** TODO: Complete this description */
  Pab: 'PAB',
  /** TODO: Complete this description */
  Pen: 'PEN',
  /** TODO: Complete this description */
  Pgk: 'PGK',
  /** TODO: Complete this description */
  Php: 'PHP',
  /** TODO: Complete this description */
  Pkr: 'PKR',
  /** TODO: Complete this description */
  Pln: 'PLN',
  /** TODO: Complete this description */
  Pyg: 'PYG',
  /** TODO: Complete this description */
  Qar: 'QAR',
  /** TODO: Complete this description */
  Ron: 'RON',
  /** TODO: Complete this description */
  Rsd: 'RSD',
  /** TODO: Complete this description */
  Rub: 'RUB',
  /** TODO: Complete this description */
  Rwf: 'RWF',
  /** TODO: Complete this description */
  Sar: 'SAR',
  /** TODO: Complete this description */
  Sbd: 'SBD',
  /** TODO: Complete this description */
  Scr: 'SCR',
  /** TODO: Complete this description */
  Sdg: 'SDG',
  /** TODO: Complete this description */
  Sek: 'SEK',
  /** TODO: Complete this description */
  Sgd: 'SGD',
  /** TODO: Complete this description */
  Shp: 'SHP',
  /** TODO: Complete this description */
  Sll: 'SLL',
  /** TODO: Complete this description */
  Sos: 'SOS',
  /** TODO: Complete this description */
  Srd: 'SRD',
  /** TODO: Complete this description */
  Ssp: 'SSP',
  /** TODO: Complete this description */
  Stn: 'STN',
  /** TODO: Complete this description */
  Svc: 'SVC',
  /** TODO: Complete this description */
  Syp: 'SYP',
  /** TODO: Complete this description */
  Szl: 'SZL',
  /** TODO: Complete this description */
  Thb: 'THB',
  /** TODO: Complete this description */
  Tjs: 'TJS',
  /** TODO: Complete this description */
  Tmt: 'TMT',
  /** TODO: Complete this description */
  Tnd: 'TND',
  /** TODO: Complete this description */
  Top: 'TOP',
  /** TODO: Complete this description */
  Try: 'TRY',
  /** TODO: Complete this description */
  Ttd: 'TTD',
  /** TODO: Complete this description */
  Twd: 'TWD',
  /** TODO: Complete this description */
  Tzs: 'TZS',
  /** TODO: Complete this description */
  Uah: 'UAH',
  /** TODO: Complete this description */
  Ugx: 'UGX',
  /** TODO: Complete this description */
  Usd: 'USD',
  /** TODO: Complete this description */
  Usn: 'USN',
  /** TODO: Complete this description */
  Uyi: 'UYI',
  /** TODO: Complete this description */
  Uyu: 'UYU',
  /** TODO: Complete this description */
  Uyw: 'UYW',
  /** TODO: Complete this description */
  Uzs: 'UZS',
  /** TODO: Complete this description */
  Ved: 'VED',
  /** TODO: Complete this description */
  Ves: 'VES',
  /** TODO: Complete this description */
  Vnd: 'VND',
  /** TODO: Complete this description */
  Vuv: 'VUV',
  /** TODO: Complete this description */
  Wst: 'WST',
  /** TODO: Complete this description */
  Xaf: 'XAF',
  /** TODO: Complete this description */
  Xag: 'XAG',
  /** TODO: Complete this description */
  Xau: 'XAU',
  /** TODO: Complete this description */
  Xba: 'XBA',
  /** TODO: Complete this description */
  Xbb: 'XBB',
  /** TODO: Complete this description */
  Xbc: 'XBC',
  /** TODO: Complete this description */
  Xbd: 'XBD',
  /** TODO: Complete this description */
  Xcd: 'XCD',
  /** TODO: Complete this description */
  Xdr: 'XDR',
  /** TODO: Complete this description */
  Xof: 'XOF',
  /** TODO: Complete this description */
  Xpd: 'XPD',
  /** TODO: Complete this description */
  Xpf: 'XPF',
  /** TODO: Complete this description */
  Xpt: 'XPT',
  /** TODO: Complete this description */
  Xsu: 'XSU',
  /** TODO: Complete this description */
  Xts: 'XTS',
  /** TODO: Complete this description */
  Xua: 'XUA',
  /** TODO: Complete this description */
  Xxx: 'XXX',
  /** TODO: Complete this description */
  Yer: 'YER',
  /** TODO: Complete this description */
  Zar: 'ZAR',
  /** TODO: Complete this description */
  Zmw: 'ZMW',
  /** TODO: Complete this description */
  Zwl: 'ZWL'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];
/** Input schema for triggerCurriculumDownload job */
export type CurriculumBuilder_TriggerCurriculumDownloadInput = {
  /** Include FullCatalog export or not */
  includeFullCatalog?: InputMaybe<Scalars['Boolean']>;
  /** Include SkillSet export or not */
  includeSkillSet?: InputMaybe<Scalars['Boolean']>;
  /** ProgramId to be exported */
  programId: Scalars['ID'];
  /** UserId of the requester */
  userId: Scalars['ID'];
};

/** CurriculumBuilder TriggerCurriculumDownloadResult */
export type CurriculumBuilder_TriggerCurriculumDownloadResult = {
  __typename?: 'CurriculumBuilder_TriggerCurriculumDownloadResult';
  /** Flag indicating if a job is triggered successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** Curriculum management results for course offerings and academic terms */
export type CurriculumManagementCourseOfferingsAndTerms_Result = {
  __typename?: 'CurriculumManagementCourseOfferingsAndTerms_Result';
  /** The paginated list of academic terms for the degree */
  academicTermsPaginated?: Maybe<CurriculumManagement_AcademicTermsPaginatedResult>;
  /** The course offerings for a provided term */
  courseOfferingsPaginated?: Maybe<CurriculumManagement_SegmentCoursesPaginatedResult>;
  /** Top level course offerings errors */
  courseOfferingsTopLevelErrors: Array<CurriculumManagement_CourseOfferingTopLevelError>;
  /** Academic term fatal validation errors */
  errors: Array<CurriculumManagement_AcademicTermsAndOfferingsErrors>;
  /** Top level event errors */
  eventTopLevelErrors: Array<CurriculumManagement_EventTopLevelError>;
  /** Degree id */
  id: Scalars['ID'];
  /** Top level term errors */
  termTopLevelErrors: Array<CurriculumManagement_TermTopLevelError>;
};


/** Curriculum management results for course offerings and academic terms */
export type CurriculumManagementCourseOfferingsAndTerms_ResultAcademicTermsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** Curriculum management results for course offerings and academic terms */
export type CurriculumManagementCourseOfferingsAndTerms_ResultCourseOfferingsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  termMappingId: Scalars['ID'];
};

/** Curriculum Management ingested data queries */
export type CurriculumManagementIngestedDataQueries = {
  __typename?: 'CurriculumManagementIngestedDataQueries';
  /** Query the ingested curriculums of a degree */
  queryAdminCourseOfferingsAndTermsByDegreeId: CurriculumManagementCourseOfferingsAndTerms_Result;
  /** Query the ingested curriculums of a degree */
  queryAdminCurriculumsByDegreeId: CurriculumManagement_Result;
  /** Query curriculum data validations */
  queryAdminIngestedDataValidationsByDegreeId: CurriculumManagementValidation_Result;
};


/** Curriculum Management ingested data queries */
export type CurriculumManagementIngestedDataQueriesQueryAdminCourseOfferingsAndTermsByDegreeIdArgs = {
  degreeId: Scalars['ID'];
};


/** Curriculum Management ingested data queries */
export type CurriculumManagementIngestedDataQueriesQueryAdminCurriculumsByDegreeIdArgs = {
  degreeId: Scalars['ID'];
};


/** Curriculum Management ingested data queries */
export type CurriculumManagementIngestedDataQueriesQueryAdminIngestedDataValidationsByDegreeIdArgs = {
  degreeId: Scalars['ID'];
};

/** Curriculum management data validation results */
export type CurriculumManagementValidation_Result = {
  __typename?: 'CurriculumManagementValidation_Result';
  /** Academic events have been uploaded successfully without validation errors */
  academicEventsValid: Scalars['Boolean'];
  /** Course offerings have been uploaded successfully without validation errors */
  courseOfferingsValid: Scalars['Boolean'];
  /**
   * Curriculum data has been uploaded successfully without validation errors (with at least 1
   * curriculum, category, segment, and course)
   */
  curriculumValid: Scalars['Boolean'];
  /** Student success form must be filled and accurate without validation errors */
  studentSuccessAttributesValid: Scalars['Boolean'];
  /** Term data has been uploaded / Term data validations have passed */
  termsValid: Scalars['Boolean'];
};

/** Curriculum Management file processing workflow queries */
export type CurriculumManagementWorkflowQueries = {
  __typename?: 'CurriculumManagementWorkflowQueries';
  /** Query the latest workflow by degree id and file processing type */
  queryWorkflowByDegreeIdAndProcessingType: CurriculumManagement_Workflow;
  /** Query the workflow by the invocation id (post-authorized, so no authorization tag here) */
  queryWorkflowByInvocationId: CurriculumManagement_Workflow;
};


/** Curriculum Management file processing workflow queries */
export type CurriculumManagementWorkflowQueriesQueryWorkflowByDegreeIdAndProcessingTypeArgs = {
  degreeId: Scalars['ID'];
  processingType: CurriculumManagement_FileProcessingType;
};


/** Curriculum Management file processing workflow queries */
export type CurriculumManagementWorkflowQueriesQueryWorkflowByInvocationIdArgs = {
  invocationId: Scalars['ID'];
};

/** The academic calendar events for a degree. These events could be relevant to any learner. */
export type CurriculumManagement_AcademicEvent = {
  __typename?: 'CurriculumManagement_AcademicEvent';
  /** The actionable link of the event (e.g. the link to the enrollment page), optional */
  actionLink?: Maybe<Scalars['URL']>;
  /** The association of the event, e.g. degree, term, etc */
  association?: Maybe<DegreeEvent_EventAssociation>;
  /** Custom call-to-action label for a nudge (connected to the actionLink) */
  ctaLabel?: Maybe<Scalars['String']>;
  /** The description of the event, optional */
  description?: Maybe<Scalars['String']>;
  /**
   * Optional display end date for event nudges, provided by the partner, this date will override
   * the default end date inferred from the event date
   */
  displayEndDate?: Maybe<Scalars['DateTime']>;
  /**
   * Optional display start date for event nudges, provided by the partner, this date will override
   * the default start date inferred from the event date
   */
  displayStartDate?: Maybe<Scalars['DateTime']>;
  /** Academic term level validation errors */
  errors: Array<CurriculumManagement_AcademicEventError>;
  /** The date when the event occurs, can be used to infer the default display window for event nudges */
  eventDate?: Maybe<Scalars['DateTime']>;
  /** The type of the event */
  eventType?: Maybe<DegreeEvent_EventType>;
  /** The id of the event */
  id: Scalars['ID'];
  /** The title of the event, optional */
  title?: Maybe<Scalars['String']>;
};

/** Academic event errors */
export type CurriculumManagement_AcademicEventError = CurriculumManagement_BlankField | CurriculumManagement_EventInvalidUrlFormatException | CurriculumManagement_InvalidField;

/** An academic term for a degree. */
export type CurriculumManagement_AcademicTerm = {
  __typename?: 'CurriculumManagement_AcademicTerm';
  /** End date of the academic term */
  endDate: Scalars['DateTime'];
  /** Explicit academic term level validation errors */
  errors: Array<CurriculumManagement_ExplicitAcademicTermError>;
  /** The events tied to the academic term, optional */
  events: Array<CurriculumManagement_AcademicEvent>;
  /** Unique ID of the academic term */
  id: Scalars['ID'];
  /** Whether or not students can enroll in the term */
  isTermAdmittable: Scalars['Boolean'];
  /** Partner representation of the term name, used for display purposes */
  partnerTermName: Scalars['String'];
  /** Start date of the academic term */
  startDate: Scalars['DateTime'];
};

/**
 * Estimated term-level errors (both entity-level and top-level). Applies to errors as a result of an
 * invalid term.
 */
export type CurriculumManagement_AcademicTermError = CurriculumManagement_UmbrellaTermTemplateNotExist;

/**
 * Academic terms top level errors. Applies to errors where the term itself cannot be generated, the
 * course term template cannot be generated, or if the event itself (attached to the term) cannot be
 * generated.
 */
export type CurriculumManagement_AcademicTermsAndOfferingsErrors = CurriculumManagement_DuplicateHeader | CurriculumManagement_EmptyFile | CurriculumManagement_InvalidCsvFile | CurriculumManagement_MissingFile | CurriculumManagement_MissingRequiredColumns | CurriculumManagement_UnknownError;

/** Paginated Academic Terms */
export type CurriculumManagement_AcademicTermsPaginatedResult = {
  __typename?: 'CurriculumManagement_AcademicTermsPaginatedResult';
  /** Ordered sequence of academic terms */
  elements: Array<CurriculumManagement_EstimatedAcademicTerm>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Blank field exception (General error that will apply to all levels) */
export type CurriculumManagement_BlankField = {
  __typename?: 'CurriculumManagement_BlankField';
  /** Names of fields where values are blank */
  blankFieldNames: Array<Scalars['String']>;
};

/**
 * A category can contain multiple segments. Used as a top level grouping object. Due to potential
 * ingestion failures (e.g. invalid fields), most fields are optional or could be empty
 */
export type CurriculumManagement_Category = {
  __typename?: 'CurriculumManagement_Category';
  /** The condition a learner must fulfill to complete the category */
  completionRule?: Maybe<CurriculumManagement_CompletionRule>;
  /** Category description */
  description?: Maybe<Scalars['String']>;
  /** Category-level error messages */
  errors: Array<CurriculumManagement_CategoryError>;
  /** Category id */
  id: Scalars['ID'];
  /**
   * Optional minimum passing GPA for all courses underneath this group. Overrides the minGpa field
   * set in curriculum
   */
  minGpa?: Maybe<Scalars['Float']>;
  /**
   * Optional minimum passing grade for all courses underneath this group. Overrides the
   * minPassingGradeForCourses field set in curriculum
   */
  minPassingGradeForCourses?: Maybe<Scalars['Int']>;
  /** List of segments under this category */
  segments: Array<CurriculumManagement_Segment>;
  /** Category title */
  title?: Maybe<Scalars['String']>;
};

/** Category completion rule type exception */
export type CurriculumManagement_CategoryCompletionRuleTypeInvalid = {
  __typename?: 'CurriculumManagement_CategoryCompletionRuleTypeInvalid';
  /** Invalid completion rule type */
  invalidCompletionRuleType: DegreePlan_CompletionRuleType;
};

/** Category-level errors */
export type CurriculumManagement_CategoryError = CurriculumManagement_BlankField | CurriculumManagement_CategoryCompletionRuleTypeInvalid | CurriculumManagement_InvalidCategoryCompletionSegments | CurriculumManagement_InvalidField;

/** Category not found exception */
export type CurriculumManagement_CategoryNotFound = {
  __typename?: 'CurriculumManagement_CategoryNotFound';
  /** Invalid category id (provided by partner) */
  invalidCategoryId: Scalars['ID'];
  /** Linked segment id (provided by partner) */
  linkedInstitutionSegmentId: Scalars['ID'];
};

/**
 * A condition for a learner to fulfill to achieve completion of a grouping of courses or segments. Due to potential
 * ingestion failures (e.g. invalid fields), all fields are optional or could be empty
 */
export type CurriculumManagement_CompletionRule = {
  __typename?: 'CurriculumManagement_CompletionRule';
  /** The minimum amount of credits/segments to complete */
  minUnits?: Maybe<Scalars['Int']>;
  /** Represents the rule the learner must complete to pass the grouping type */
  type?: Maybe<DegreePlan_CompletionRuleType>;
};

/**
 * Course properties. Due to potential ingestion failures (e.g. invalid fields), most
 * fields are optional or could be empty. The fields in this model match DegreePlan_Course excluding
 * the isPublicLiveCourse since this field is set internally and not via data ingestion
 */
export type CurriculumManagement_Course = {
  __typename?: 'CurriculumManagement_Course';
  /** Institution given degree course code, e.g. Math 101 */
  courseCode?: Maybe<Scalars['String']>;
  /** Institution given degree course name, e.g. Fundamentals of Calculus. This may be similar or identical to the Course_Course name. In the case where they are both available, the canonical Course_Course name is preferred. */
  courseName?: Maybe<Scalars['String']>;
  /** Courses can be taken on or off platform. If on-platform and the course has been created, this is the associated Coursera course with this Degree Plan Course. */
  courseraCourse?: Maybe<Course_Course>;
};

/** Course-level errors */
export type CurriculumManagement_CourseError = CurriculumManagement_BlankField | CurriculumManagement_InvalidField | CurriculumManagement_MismatchedSegmentCourseProperties | CurriculumManagement_PrereqCourseNotFound | CurriculumManagement_PrereqCoursesAndCodesMismatched;

/**
 * Course offerings top level errors
 * Note: Blank/Invalid field errors are not typically top level errors, but they need to be in this
 * case since without required fields, the course term template cannot generate course offerings
 */
export type CurriculumManagement_CourseOfferingTopLevelError = CurriculumManagement_BlankField | CurriculumManagement_EmptyOrInvalidCourseTermTemplateId | CurriculumManagement_InvalidCourseTermTemplateCourseError | CurriculumManagement_InvalidCourseTermTemplateRuleError | CurriculumManagement_InvalidCourseTermTemplateTermError | CurriculumManagement_InvalidField;

/** An ingested curriculum could either be a degree curriculum or a performance-based admission curriculum */
export type CurriculumManagement_Curriculum = CurriculumManagement_DegreeCurriculum | CurriculumManagement_PbaCurriculum;

/** Curriculum-level errors */
export type CurriculumManagement_CurriculumError = CurriculumManagement_BlankField | CurriculumManagement_InvalidCurriculumMinCredits | CurriculumManagement_InvalidField;

/** Curriculum not found exception */
export type CurriculumManagement_CurriculumNotFound = {
  __typename?: 'CurriculumManagement_CurriculumNotFound';
  /** Invalid curriculum id (provided by partner) */
  invalidCurriculumId: Scalars['ID'];
  /** Linked category id (provided by partner) */
  linkedInstitutionCategoryId: Scalars['ID'];
};

/**
 * The ingested data of a main curriculum of a single degree that defines graduation requirements. Due
 * to potential ingestion failures (e.g. invalid fields), most fields are optional or could be empty
 */
export type CurriculumManagement_DegreeCurriculum = {
  __typename?: 'CurriculumManagement_DegreeCurriculum';
  /** A list of categories underneath the curriculum */
  categories: Array<CurriculumManagement_Category>;
  /** Curriculum description */
  description?: Maybe<Scalars['String']>;
  /** Curriculum-level error messages */
  errors: Array<CurriculumManagement_CurriculumError>;
  /** The GPA scale of the curriculum */
  gpaScale?: Maybe<Scalars['Float']>;
  /** Curriculum id */
  id: Scalars['ID'];
  /** Minimum required credits to complete this curriculum */
  minCredits?: Maybe<Scalars['Int']>;
  /** Minimum passing GPA for all courses underneath this curriculum */
  minGpa?: Maybe<Scalars['Float']>;
  /** Minimum passing grade for all courses underneath this curriculum */
  minPassingGradeForCourses?: Maybe<Scalars['Int']>;
  /** Curriculum title */
  title?: Maybe<Scalars['String']>;
};

/** Duplicate header exception */
export type CurriculumManagement_DuplicateHeader = {
  __typename?: 'CurriculumManagement_DuplicateHeader';
  /** CSV files with duplicate headers */
  duplicateHeaderFileNames: Array<Scalars['String']>;
};

/** Empty file exception */
export type CurriculumManagement_EmptyFile = {
  __typename?: 'CurriculumManagement_EmptyFile';
  /** Empty CSV files */
  emptyFileNames: Array<Scalars['String']>;
};

/** Empty/blank/invalid category id exception */
export type CurriculumManagement_EmptyOrInvalidCategoryId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidCategoryId';
  /** Category id (if invalid not empty) */
  categoryId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid course term template id exception */
export type CurriculumManagement_EmptyOrInvalidCourseTermTemplateId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidCourseTermTemplateId';
  /** Course term template id (if invalid not empty) */
  courseTermTemplateId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid curriculum id exception */
export type CurriculumManagement_EmptyOrInvalidCurriculumId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidCurriculumId';
  /** Curriculum id (if invalid not empty) */
  curriculumId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid event id exception */
export type CurriculumManagement_EmptyOrInvalidEventId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidEventId';
  /** Event id (if invalid not empty) */
  eventId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid segment course id exception */
export type CurriculumManagement_EmptyOrInvalidSegmentCourseId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidSegmentCourseId';
  /** Segment course id (if invalid not empty) */
  segmentCourseId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid segment id exception */
export type CurriculumManagement_EmptyOrInvalidSegmentId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidSegmentId';
  /** Segment id (if invalid not empty) */
  segmentId?: Maybe<Scalars['ID']>;
};

/** Empty/blank/invalid term template id exception */
export type CurriculumManagement_EmptyOrInvalidTermTemplateId = {
  __typename?: 'CurriculumManagement_EmptyOrInvalidTermTemplateId';
  /** Term template id (if invalid not empty) */
  termTemplateId?: Maybe<Scalars['ID']>;
};

/** Estimated Academic Term in the degree */
export type CurriculumManagement_EstimatedAcademicTerm = {
  __typename?: 'CurriculumManagement_EstimatedAcademicTerm';
  /** Estimated academic term level validation errors */
  errors: Array<CurriculumManagement_AcademicTermError>;
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** Name of the estimated term */
  estimatedTermName?: Maybe<Scalars['String']>;
  /** Linked external term Id */
  linkedTerm?: Maybe<CurriculumManagement_AcademicTerm>;
};

/**
 * Top level exception for when the event is associated with an invalid term, as it wouldn't be
 * mappable under any explicit term entity
 */
export type CurriculumManagement_EventInvalidTermAssociation = {
  __typename?: 'CurriculumManagement_EventInvalidTermAssociation';
  /**
   * Invalid term template ID
   * @deprecated use invalidTermTemplateIds instead
   */
  invalidTermId: Scalars['ID'];
  /** Invalid term template IDs */
  invalidTermIds: Array<Scalars['ID']>;
};

/** Exception for when the event contains an invalid URL */
export type CurriculumManagement_EventInvalidUrlFormatException = {
  __typename?: 'CurriculumManagement_EventInvalidUrlFormatException';
  /** Invalid URL */
  invalidUrl: Scalars['String'];
};

/** Multiple term registration (starts or ends) events error */
export type CurriculumManagement_EventMultipleRegistrationsError = {
  __typename?: 'CurriculumManagement_EventMultipleRegistrationsError';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Invalid registration event dates error (i.e., start after end) */
export type CurriculumManagement_EventRegistrationInvalidDateError = {
  __typename?: 'CurriculumManagement_EventRegistrationInvalidDateError';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Missing event registration start or end error */
export type CurriculumManagement_EventRegistrationMissingError = {
  __typename?: 'CurriculumManagement_EventRegistrationMissingError';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Events top level errors */
export type CurriculumManagement_EventTopLevelError = CurriculumManagement_EmptyOrInvalidEventId | CurriculumManagement_EventInvalidTermAssociation;

/**
 * Explicit term-level errors (both entity-level and top-level). Applies to errors as a result of an
 * invalid term.
 */
export type CurriculumManagement_ExplicitAcademicTermError = CurriculumManagement_EventMultipleRegistrationsError | CurriculumManagement_EventRegistrationInvalidDateError | CurriculumManagement_EventRegistrationMissingError | CurriculumManagement_TermMissingGradingDateError;

/** Domain specific error interface for curriculum management file processing mutations */
export type CurriculumManagement_FileProcessingError = {
  /** Error message */
  message: Scalars['String'];
};

/** Types of file processing */
export const CurriculumManagement_FileProcessingType = {
  /** Curriculum data */
  Curriculum: 'CURRICULUM',
  /** Event data on the academic calendar */
  Event: 'EVENT',
  /** Term data */
  Term: 'TERM'
} as const;

export type CurriculumManagement_FileProcessingType = typeof CurriculumManagement_FileProcessingType[keyof typeof CurriculumManagement_FileProcessingType];
/** Invalid category completion segments exception */
export type CurriculumManagement_InvalidCategoryCompletionSegments = {
  __typename?: 'CurriculumManagement_InvalidCategoryCompletionSegments';
  /** Number of segments required by completion rule */
  numSegmentsInCompletionRule: Scalars['Int'];
  /** Total number of segments */
  totalCategorySegments: Scalars['Int'];
};

/** Exception for when the course term template contains an invalid course */
export type CurriculumManagement_InvalidCourseTermTemplateCourseError = {
  __typename?: 'CurriculumManagement_InvalidCourseTermTemplateCourseError';
  /**
   * The course term templates with the invalid course
   * @deprecated use invalidCourseTermTemplateIds instead
   */
  invalidCourseTermTemplateId: Scalars['ID'];
  /** The course term templates with the invalid course */
  invalidCourseTermTemplateIds: Array<Scalars['ID']>;
};

/** Exception for when the course term template contains an invalid course term template rule */
export type CurriculumManagement_InvalidCourseTermTemplateRuleError = {
  __typename?: 'CurriculumManagement_InvalidCourseTermTemplateRuleError';
  /**
   * The course term templates with the invalid rule
   * @deprecated use invalidCourseTermTemplateIds instead
   */
  invalidCourseTermTemplateId: Scalars['ID'];
  /** The course term templates with the invalid rule */
  invalidCourseTermTemplateIds: Array<Scalars['ID']>;
};

/** Exception for when the course term template contains an invalid term */
export type CurriculumManagement_InvalidCourseTermTemplateTermError = {
  __typename?: 'CurriculumManagement_InvalidCourseTermTemplateTermError';
  /**
   * The course term templates with the invalid term
   * @deprecated use invalidCourseTermTemplateIds instead
   */
  invalidCourseTermTemplateId: Scalars['ID'];
  /** The course term templates with the invalid term */
  invalidCourseTermTemplateIds: Array<Scalars['ID']>;
};

/** Invalid CSV file exception */
export type CurriculumManagement_InvalidCsvFile = {
  __typename?: 'CurriculumManagement_InvalidCsvFile';
  /** Invalid CSV files */
  invalidFileNames: Array<Scalars['String']>;
};

/** Invalid curriculum minimum credits exception */
export type CurriculumManagement_InvalidCurriculumMinCredits = {
  __typename?: 'CurriculumManagement_InvalidCurriculumMinCredits';
  /** Minimum number of credits */
  minCredits: Scalars['Int'];
  /** Total number of credits in the curriculum */
  totalCurriculumCredits: Scalars['Int'];
};

/** Invalid field value exception (General error that will apply to all levels) */
export type CurriculumManagement_InvalidField = {
  __typename?: 'CurriculumManagement_InvalidField';
  /** Names of fields where values are invalid (wrong type, etc.) */
  invalidFieldNames: Array<Scalars['String']>;
};

/** Invalid segment completion credits exception */
export type CurriculumManagement_InvalidSegmentCompletionCredits = {
  __typename?: 'CurriculumManagement_InvalidSegmentCompletionCredits';
  /** Number of credits required by completion rule */
  numCreditsInCompletionRule: Scalars['Int'];
  /** Total number of credits */
  totalSegmentCredits: Scalars['Int'];
};

/** Invocation related error, thrown when failed to start an invocation */
export type CurriculumManagement_InvocationError = CurriculumManagement_FileProcessingError & {
  __typename?: 'CurriculumManagement_InvocationError';
  /** Error type */
  errorType: CurriculumManagement_InvocationErrorType;
  /** Error message */
  message: Scalars['String'];
};

/** Types for invocation errors */
export const CurriculumManagement_InvocationErrorType = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** There is already an in-progress invocation for the same type */
  InProgressInvocationAlreadyExists: 'IN_PROGRESS_INVOCATION_ALREADY_EXISTS'
} as const;

export type CurriculumManagement_InvocationErrorType = typeof CurriculumManagement_InvocationErrorType[keyof typeof CurriculumManagement_InvocationErrorType];
/** Input for launching the DPM experience */
export type CurriculumManagement_LaunchDegreeProgressMapExperienceInput = {
  /** The degree slug */
  degreeSlug: Scalars['String'];
};

/** Mutation result for launching the DPM experience */
export type CurriculumManagement_LaunchDegreeProgressMapExperienceResult = CurriculumManagement_LaunchDegreeProgressMapExperienceResultFailure | CurriculumManagement_LaunchDegreeProgressMapExperienceResultSuccess;

/** Mutation result for launch failure */
export type CurriculumManagement_LaunchDegreeProgressMapExperienceResultFailure = {
  __typename?: 'CurriculumManagement_LaunchDegreeProgressMapExperienceResultFailure';
  /** Placeholder value */
  _?: Maybe<Scalars['Boolean']>;
};

/** Mutation result for successfully launching the DPM experience */
export type CurriculumManagement_LaunchDegreeProgressMapExperienceResultSuccess = {
  __typename?: 'CurriculumManagement_LaunchDegreeProgressMapExperienceResultSuccess';
  /** Placeholder value */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * Missing segment course properties exception, thrown when the degree courses mapping + properties
 * don't align (i.e., a course exists in the degree courses mapping file and not the degree courses
 * properties file so the course properties don't end up being set).
 */
export type CurriculumManagement_MismatchedSegmentCourseProperties = {
  __typename?: 'CurriculumManagement_MismatchedSegmentCourseProperties';
  /** Fields with default values (that may not have been set on ingestion) */
  defaultValueFieldNames: Array<Scalars['String']>;
};

/** Missing file exception */
export type CurriculumManagement_MissingFile = {
  __typename?: 'CurriculumManagement_MissingFile';
  /** Missing file names */
  missingFileNames: Array<Scalars['String']>;
};

/** Missing required columns exception */
export type CurriculumManagement_MissingRequiredColumns = {
  __typename?: 'CurriculumManagement_MissingRequiredColumns';
  /** CSV files missing required columns */
  missingRequiredColumnsFileNames: Array<Scalars['String']>;
};

/**
 * An optional secondary curriculum of a single degree that defines performance-based admission
 * requirements. Due to potential ingestion failures (e.g. invalid fields), most fields are optional
 * or could be empty
 */
export type CurriculumManagement_PbaCurriculum = {
  __typename?: 'CurriculumManagement_PBACurriculum';
  /** A list of categories underneath the curriculum */
  categories: Array<CurriculumManagement_Category>;
  /** Curriculum description */
  description?: Maybe<Scalars['String']>;
  /** Curriculum-level error messages */
  errors: Array<CurriculumManagement_CurriculumError>;
  /** The GPA scale of the curriculum */
  gpaScale?: Maybe<Scalars['Float']>;
  /** Curriculum id */
  id: Scalars['ID'];
  /** Minimum required credits to complete this curriculum */
  minCredits?: Maybe<Scalars['Int']>;
  /** Minimum passing GPA for all courses underneath this curriculum */
  minGpa?: Maybe<Scalars['Float']>;
  /** Minimum passing grade for all courses underneath this curriculum */
  minPassingGradeForCourses?: Maybe<Scalars['Int']>;
  /** Curriculum title */
  title?: Maybe<Scalars['String']>;
};

/** Prereq course not found exception */
export type CurriculumManagement_PrereqCourseNotFound = {
  __typename?: 'CurriculumManagement_PrereqCourseNotFound';
  /** Prereq institution course id (ingested partner data) */
  prereqInstitutionCourseId: Scalars['ID'];
};

/** Prereq courses and course codes have mismatched lengths */
export type CurriculumManagement_PrereqCoursesAndCodesMismatched = {
  __typename?: 'CurriculumManagement_PrereqCoursesAndCodesMismatched';
  /** Prereq institution course codes (ingested partner data) */
  prereqInstitutionCourseCodes: Array<Scalars['String']>;
  /** Prereq institution course ids (ingested partner data) */
  prereqInstitutionCourseIds: Array<Scalars['ID']>;
};

/**
 * A segment course's prerequisite requirements (identical to DegreePlan_Prerequisite except that the
 * prerequisite item will be the above optional course version instead of DegreePlan_Course)
 */
export type CurriculumManagement_Prerequisite = {
  __typename?: 'CurriculumManagement_Prerequisite';
  /** The completion type of the prerequisite */
  completionType: DegreePlan_PrerequisiteCompletionType;
  /** The actual items for the prerequisite */
  prerequisiteItems: Array<CurriculumManagement_PrerequisiteItem>;
};

/**
 * One prerequisite item could be another CurriculumManagement_Prerequisite to allow more advanced
 * requirements, or just a CurriculumManagement_Course, this allows a simple requirement like: Course A requires
 * Course B OR Course C; or a more complex requirement like: Course A requires Course B AND any of
 * (Course C OR Course D)
 */
export type CurriculumManagement_PrerequisiteItem = CurriculumManagement_Course | CurriculumManagement_Prerequisite;

/** Curriculum management result */
export type CurriculumManagement_Result = {
  __typename?: 'CurriculumManagement_Result';
  /** Curriculum data */
  curriculums: Array<CurriculumManagement_Curriculum>;
  /** Top-level errors */
  errors: Array<CurriculumManagement_TopLevelError>;
};

/**
 * A segment can contain multiple courses. Used as a secondary level grouping object. Due to potential
 * ingestion failures (e.g. invalid fields), most fields are optional or could be empty
 */
export type CurriculumManagement_Segment = {
  __typename?: 'CurriculumManagement_Segment';
  /** The condition a learner must fulfill to complete the segment */
  completionRule?: Maybe<CurriculumManagement_CompletionRule>;
  /** The segment courses under the segment */
  courses: Array<CurriculumManagement_SegmentCourse>;
  /** Segment description */
  description?: Maybe<Scalars['String']>;
  /** Segment-level error messages */
  errors: Array<CurriculumManagement_SegmentError>;
  /** Segment id */
  id: Scalars['ID'];
  /** Segment title */
  title?: Maybe<Scalars['String']>;
};

/** Segment completion rule type exception */
export type CurriculumManagement_SegmentCompletionRuleTypeInvalid = {
  __typename?: 'CurriculumManagement_SegmentCompletionRuleTypeInvalid';
  /** Invalid completion rule type */
  invalidCompletionRuleType: DegreePlan_CompletionRuleType;
};

/**
 * A course underneath a segment. Due to potential ingestion failures (e.g. invalid fields), most
 * fields are optional or could be empty
 */
export type CurriculumManagement_SegmentCourse = {
  __typename?: 'CurriculumManagement_SegmentCourse';
  /** The course with institution information */
  course?: Maybe<CurriculumManagement_Course>;
  /** Number of credits for this course under the segment */
  creditValue?: Maybe<Scalars['Int']>;
  /** Course-level error messages */
  errors: Array<CurriculumManagement_CourseError>;
  /** Segment course id */
  id: Scalars['ID'];
  /** The course prerequisite */
  prerequisite?: Maybe<CurriculumManagement_Prerequisite>;
  /**
   * An optional ordered list of the upcoming academic terms for this degree in which this course is
   * offered.
   */
  termAvailabilityPaginated?: Maybe<CurriculumManagement_AcademicTermsPaginatedResult>;
};


/**
 * A course underneath a segment. Due to potential ingestion failures (e.g. invalid fields), most
 * fields are optional or could be empty
 */
export type CurriculumManagement_SegmentCourseTermAvailabilityPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** Paginated Course Offerings */
export type CurriculumManagement_SegmentCoursesPaginatedResult = {
  __typename?: 'CurriculumManagement_SegmentCoursesPaginatedResult';
  /** Ordered sequence of academic terms */
  elements: Array<CurriculumManagement_SegmentCourse>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Segment-level errors */
export type CurriculumManagement_SegmentError = CurriculumManagement_BlankField | CurriculumManagement_InvalidField | CurriculumManagement_InvalidSegmentCompletionCredits | CurriculumManagement_SegmentCompletionRuleTypeInvalid;

/** Segment not found exception */
export type CurriculumManagement_SegmentNotFound = {
  __typename?: 'CurriculumManagement_SegmentNotFound';
  /** Invalid segment id (provided by partner) */
  invalidSegmentId: Scalars['ID'];
  /** Linked course id (provided by partner) */
  linkedSegmentCourseId: Scalars['ID'];
};

/** Failure type for starting file processing */
export type CurriculumManagement_StartFileProcessingFailure = {
  __typename?: 'CurriculumManagement_StartFileProcessingFailure';
  /** List of errors */
  errors: Array<CurriculumManagement_InvocationError>;
};

/** Input for starting file processing */
export type CurriculumManagement_StartFileProcessingInput = {
  /** The degree slug */
  degreeSlug: Scalars['String'];
  /** The partner slug */
  partnerSlug: Scalars['String'];
  /** The type of the data being processed */
  processingType: CurriculumManagement_FileProcessingType;
  /** The list of names of the uploaded files */
  uploadedFileNames: Array<Scalars['String']>;
};

/** Mutation result of starting file processing */
export type CurriculumManagement_StartFileProcessingResult = CurriculumManagement_StartFileProcessingFailure | CurriculumManagement_StartFileProcessingSuccess;

/** Success type for starting file processing */
export type CurriculumManagement_StartFileProcessingSuccess = {
  __typename?: 'CurriculumManagement_StartFileProcessingSuccess';
  /** The invocation id of the processing job */
  invocationId: Scalars['ID'];
};

/** Missing event grading submission deadline error */
export type CurriculumManagement_TermMissingGradingDateError = {
  __typename?: 'CurriculumManagement_TermMissingGradingDateError';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Exception when the term template ordering is the same as another term template */
export type CurriculumManagement_TermTemplateInvalidOrderError = {
  __typename?: 'CurriculumManagement_TermTemplateInvalidOrderError';
  /**
   * Invalid term template ID
   * @deprecated use invalidTermTemplateIds instead
   */
  invalidTermTemplateId: Scalars['ID'];
  /** Invalid term template IDs */
  invalidTermTemplateIds: Array<Scalars['ID']>;
};

/** Exception when the term template name contains a year, which is an invalid format */
export type CurriculumManagement_TermTemplateNameContainsYear = {
  __typename?: 'CurriculumManagement_TermTemplateNameContainsYear';
  /**
   * Invalid term template ID
   * @deprecated use invalidTermTemplateIds instead
   */
  invalidTermTemplateId: Scalars['ID'];
  /** Invalid term template IDs */
  invalidTermTemplateIds: Array<Scalars['ID']>;
};

/**
 * Terms top level errors
 * Note: Blank/Invalid field errors are not typically top level errors, but they need to be in this
 * case since without required fields, the term template cannot generate terms
 */
export type CurriculumManagement_TermTopLevelError = CurriculumManagement_BlankField | CurriculumManagement_EmptyOrInvalidTermTemplateId | CurriculumManagement_InvalidField | CurriculumManagement_TermTemplateInvalidOrderError | CurriculumManagement_TermTemplateNameContainsYear;

/**
 * Top-level errors
 *
 * Note: Because we defined all objects to require the ID field, if that ID field is empty on
 * ingestion, we need to surface this error at the top level since the object can't be created without
 * an ID field. If one or more rows in a file has an empty id, we'll throw the error below that matches
 * the file name (and EmptyOrInvalidSegmentCourseId will apply for all 3 degree courses files).
 */
export type CurriculumManagement_TopLevelError = CurriculumManagement_CategoryNotFound | CurriculumManagement_CurriculumNotFound | CurriculumManagement_DuplicateHeader | CurriculumManagement_EmptyFile | CurriculumManagement_EmptyOrInvalidCategoryId | CurriculumManagement_EmptyOrInvalidCurriculumId | CurriculumManagement_EmptyOrInvalidSegmentCourseId | CurriculumManagement_EmptyOrInvalidSegmentId | CurriculumManagement_InvalidCsvFile | CurriculumManagement_MissingFile | CurriculumManagement_MissingRequiredColumns | CurriculumManagement_SegmentNotFound | CurriculumManagement_UnknownError;

/** Exception when the umbrella term ID referenced by the term template does not exist */
export type CurriculumManagement_UmbrellaTermTemplateNotExist = {
  __typename?: 'CurriculumManagement_UmbrellaTermTemplateNotExist';
  /** Invalid term template ID */
  invalidTermTemplateId: Scalars['ID'];
};

/** Unknown error (i.e., service is down, API error, etc.) */
export type CurriculumManagement_UnknownError = {
  __typename?: 'CurriculumManagement_UnknownError';
  /**
   * Relevant error code (if there is one, most likely there won't be) - we are mostly defining the
   * field here because it is required for each type
   */
  errorCode?: Maybe<Scalars['Int']>;
};

/** File processing workflow */
export type CurriculumManagement_Workflow = {
  __typename?: 'CurriculumManagement_Workflow';
  /** The invocation id */
  invocationId: Scalars['ID'];
  /** The status of the workflow */
  status: CurriculumManagement_WorkflowStatus;
};

/** The workflow status types */
export const CurriculumManagement_WorkflowStatus = {
  /** The workflow failed */
  Failed: 'FAILED',
  /** The workflow is still in-progress */
  InProgress: 'IN_PROGRESS',
  /** The workflow ended successfully */
  Successful: 'SUCCESSFUL'
} as const;

export type CurriculumManagement_WorkflowStatus = typeof CurriculumManagement_WorkflowStatus[keyof typeof CurriculumManagement_WorkflowStatus];
export type CustomLabelsV1 = {
  __typename?: 'CustomLabelsV1';
  id: Scalars['String'];
  moduleNames?: Maybe<Array<Maybe<CustomLabelsV1_Org_Coursera_Content_WeekNumberToModuleName>>>;
  namings: Scalars['JSON'];
};

export type CustomLabelsV1ByCourseBranch = {
  __typename?: 'CustomLabelsV1ByCourseBranch';
  connection?: Maybe<CustomLabelsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type CustomLabelsV1ByUserAndCourse = {
  __typename?: 'CustomLabelsV1ByUserAndCourse';
  connection?: Maybe<CustomLabelsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CustomLabelsV1ByUserAndMultipleCourses = {
  __typename?: 'CustomLabelsV1ByUserAndMultipleCourses';
  connection?: Maybe<CustomLabelsV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CustomLabelsV1Connection = {
  __typename?: 'CustomLabelsV1Connection';
  elements: Array<Maybe<CustomLabelsV1>>;
  paging: ResponsePagination;
};

export type CustomLabelsV1Resource = {
  __typename?: 'CustomLabelsV1Resource';
  byCourseBranch?: Maybe<CustomLabelsV1Connection>;
  byUserAndCourse?: Maybe<CustomLabelsV1Connection>;
  byUserAndMultipleCourses?: Maybe<CustomLabelsV1Connection>;
};


export type CustomLabelsV1ResourceByCourseBranchArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type CustomLabelsV1ResourceByUserAndCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type CustomLabelsV1ResourceByUserAndMultipleCoursesArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CustomLabelsV1ResourceMutations = {
  __typename?: 'CustomLabelsV1ResourceMutations';
  byDegreeId?: Maybe<Scalars['JSON']>;
};


export type CustomLabelsV1ResourceMutationsByDegreeIdArgs = {
  degreeId: Scalars['String'];
};

export type CustomLabelsV1_Org_Coursera_Content_WeekNumberToModuleName = {
  __typename?: 'CustomLabelsV1_org_coursera_content_WeekNumberToModuleName';
  /** ID of a module in a course. It will never change and is unique within the course. */
  moduleId: Scalars['String'];
  moduleName: Scalars['String'];
  weekNumber: Scalars['Int'];
};

/** Daily goals queries */
export type DailyGoalsQueries = {
  __typename?: 'DailyGoalsQueries';
  /** Get a learners daily goal completion history */
  queryDailyGoalCompletionHistory: LearnerGoals_DailyGoalCompletionHistory;
  /** Get or create daily goals for the learner */
  queryDailyGoals: LearnerGoals_DailyGoals;
};


/** Daily goals queries */
export type DailyGoalsQueriesQueryDailyGoalCompletionHistoryArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


/** Daily goals queries */
export type DailyGoalsQueriesQueryDailyGoalsArgs = {
  activeCourseId?: InputMaybe<Scalars['ID']>;
};

/** Daily item completions queries */
export type DailyItemCompletionsQueries = {
  __typename?: 'DailyItemCompletionsQueries';
  /** Get daily item completions for the current week. */
  queryDailyItemCompletionsForCurrentWeek: DailyItemCompletions_DailyItemCompletionsForWeek;
};

/** Daily item completions for a learner in a week. */
export type DailyItemCompletions_DailyItemCompletionsForWeek = {
  __typename?: 'DailyItemCompletions_DailyItemCompletionsForWeek';
  /** The days in which the learner has learned and the number of items completed on each day. */
  itemCompletions: Array<DailyItemCompletions_DayItemCompletionCounts>;
};

/** Day in a week */
export const DailyItemCompletions_DayInAWeek = {
  /** Friday */
  Friday: 'FRIDAY',
  /** Monday */
  Monday: 'MONDAY',
  /** Saturday */
  Saturday: 'SATURDAY',
  /** Sunday */
  Sunday: 'SUNDAY',
  /** Thursday */
  Thursday: 'THURSDAY',
  /** Tuesday */
  Tuesday: 'TUESDAY',
  /** Wednesday */
  Wednesday: 'WEDNESDAY'
} as const;

export type DailyItemCompletions_DayInAWeek = typeof DailyItemCompletions_DayInAWeek[keyof typeof DailyItemCompletions_DayInAWeek];
/** Daily item completion counts by day. */
export type DailyItemCompletions_DayItemCompletionCounts = {
  __typename?: 'DailyItemCompletions_DayItemCompletionCounts';
  /** Day in a week. */
  day: DailyItemCompletions_DayInAWeek;
  /** Number of items the learner has completed. */
  numItemCompletions: Scalars['Int'];
};

/** Daily skill points queries */
export type DailySkillPointsQueries = {
  __typename?: 'DailySkillPointsQueries';
  /**
   * Get total skill points earned today for a specific course.
   * "Today" is determined by the learner's timezone from their user profile.
   * @deprecated Use queryDailySkillPointsForLearner with a courseId argument instead.
   */
  queryDailySkillPointsForCourse: DailySkillPoints_DailySkillPointsForCourse;
  /**
   * Get total skill points earned today by the current learner.
   * If courseId is provided, returns only points earned in that course.
   * Otherwise returns the learner-wide total across all skill-tagged courses.
   * "Today" is determined by the learner's timezone from their user profile.
   */
  queryDailySkillPointsForLearner: DailySkillPoints_DailySkillPointsForLearner;
  /**
   * Get skill points earned today per skill area for the current learner.
   * "Today" is determined by the learner's timezone from their user profile.
   */
  queryDailySkillPointsForLearnerBySkillArea: DailySkillPoints_DailySkillPointsBySkillAreaPaginatedResult;
};


/** Daily skill points queries */
export type DailySkillPointsQueriesQueryDailySkillPointsForCourseArgs = {
  courseId: Scalars['ID'];
};


/** Daily skill points queries */
export type DailySkillPointsQueriesQueryDailySkillPointsForLearnerArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


/** Daily skill points queries */
export type DailySkillPointsQueriesQueryDailySkillPointsForLearnerBySkillAreaArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/**
 * Skill points earned by the current learner today, broken down by skill area.
 * "Today" is the current calendar day in the learner's timezone.
 */
export type DailySkillPoints_DailySkillPointsBySkillAreaPaginatedResult = {
  __typename?: 'DailySkillPoints_DailySkillPointsBySkillAreaPaginatedResult';
  /** List of skill areas with skill points earned today. */
  elements: Array<DailySkillPoints_SkillAreaPointsEarned>;
  /** Pagination information. */
  pagination: Pagination;
};

/**
 * Skill points earned by a learner for a specific course today,
 * where "today" is the current calendar day in the learner's timezone.
 */
export type DailySkillPoints_DailySkillPointsForCourse = {
  __typename?: 'DailySkillPoints_DailySkillPointsForCourse';
  /** The course associated with these skill points. */
  course: Course_Course;
  /**
   * Total skill points (XP) earned today for this course,
   * where "today" is the current calendar day in the learner's timezone.
   * Returns 0 if no XP earned today.
   */
  totalSkillPointsEarned: Scalars['Int'];
};

/**
 * Skill points earned by the current learner today, optionally scoped
 * to a single course. "Today" is the current calendar day in the learner's
 * timezone.
 */
export type DailySkillPoints_DailySkillPointsForLearner = {
  __typename?: 'DailySkillPoints_DailySkillPointsForLearner';
  /**
   * The course associated with these skill points, or null if the result
   * is the learner-wide total across all skill-tagged courses.
   */
  course?: Maybe<Course_Course>;
  /**
   * Total skill points (XP) earned today. If a courseId was provided in
   * the query, scoped to that course; otherwise summed across all
   * skill-tagged courses. Returns 0 if no XP earned today.
   */
  totalSkillPointsEarned: Scalars['Int'];
};

/**
 * Skill points earned by the current learner today for a single skill area.
 * "Today" is the current calendar day in the learner's timezone.
 */
export type DailySkillPoints_SkillAreaPointsEarned = {
  __typename?: 'DailySkillPoints_SkillAreaPointsEarned';
  /**
   * The skill area progress entity, which includes the skill area name, id, and
   * child skill expressions.
   */
  skillAreaProgress: SkillSignals_SkillAreaXpProgress;
  /** Total skill points (XP) earned today in this skill area. */
  totalSkillPointsEarned: Scalars['Int'];
};

export type DecoratedEnterpriseContractsV1 = {
  __typename?: 'DecoratedEnterpriseContractsV1';
  amountRefunded?: Maybe<Scalars['String']>;
  amountRemaining: Scalars['String'];
  autoRenewInformation: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_AutoRenewInformation;
  billingSystemType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType;
  billingType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType;
  contractState: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState;
  contractTags?: Maybe<EnterpriseContractTagsV1Connection>;
  contractType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType;
  countryIsoCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  currencyCode?: Maybe<Scalars['String']>;
  durationInMonths?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['Float']>;
  endsAt?: Maybe<Scalars['Float']>;
  enterpriseContractId: Scalars['String'];
  hardPausedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isPaused: Scalars['Boolean'];
  isPriceFluctuationPossible?: Maybe<Scalars['Boolean']>;
  isReal: Scalars['Boolean'];
  isRefunded: Scalars['Boolean'];
  limitType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType;
  limits: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimits;
  name?: Maybe<Scalars['String']>;
  nextPaymentInformation?: Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextPaymentInformation>;
  planId: Scalars['Float'];
  previousPayments: Array<Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_PaidEnterpriseContractPayment>>;
  promotionId: Scalars['Int'];
  properties?: Maybe<DecoratedEnterpriseContractsV1_Properties>;
  purpose?: Maybe<Scalars['String']>;
  refundDeadline?: Maybe<Scalars['Float']>;
  remainingTermPayments: Array<Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_UnpaidEnterpriseContractPayment>>;
  salesforceCaseNumber?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['Float']>;
  terminationReason?: Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason>;
  terms: Array<Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTerm>>;
  thirdPartyOrganizationId: Scalars['String'];
  utilization?: Maybe<EnterpriseContractUtilizationsV1>;
  value: Scalars['String'];
};


export type DecoratedEnterpriseContractsV1ContractTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DecoratedEnterpriseContractsV1ByThirdPartyOrganization = {
  __typename?: 'DecoratedEnterpriseContractsV1ByThirdPartyOrganization';
  connection?: Maybe<DecoratedEnterpriseContractsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type DecoratedEnterpriseContractsV1Connection = {
  __typename?: 'DecoratedEnterpriseContractsV1Connection';
  elements: Array<Maybe<DecoratedEnterpriseContractsV1>>;
  paging: ResponsePagination;
};

export type DecoratedEnterpriseContractsV1Resource = {
  __typename?: 'DecoratedEnterpriseContractsV1Resource';
  byThirdPartyOrganization?: Maybe<DecoratedEnterpriseContractsV1Connection>;
  get?: Maybe<DecoratedEnterpriseContractsV1>;
  multiGet?: Maybe<DecoratedEnterpriseContractsV1Connection>;
};


export type DecoratedEnterpriseContractsV1ResourceByThirdPartyOrganizationArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DecoratedEnterpriseContractsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DecoratedEnterpriseContractsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DecoratedEnterpriseContractsV1ResourceMutations = {
  __typename?: 'DecoratedEnterpriseContractsV1ResourceMutations';
  getSelfServeTransactionAndPaymentHistory?: Maybe<Scalars['JSON']>;
};


export type DecoratedEnterpriseContractsV1ResourceMutationsGetSelfServeTransactionAndPaymentHistoryArgs = {
  contractId: Scalars['String'];
  termId?: InputMaybe<Scalars['String']>;
};

export type DecoratedEnterpriseContractsV1_InvoiceBilledContractPropertiesMember = {
  __typename?: 'DecoratedEnterpriseContractsV1_invoiceBilledContractPropertiesMember';
  invoiceBilledContractProperties: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_InvoiceBilledContractProperties;
};

export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType = {
  Installment: 'INSTALLMENT',
  Upgrade: 'UPGRADE'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Expired: 'EXPIRED',
  Paused: 'PAUSED',
  Terminated: 'TERMINATED'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = {
  ContractEndDate: 'CONTRACT_END_DATE',
  Downgraded: 'DOWNGRADED',
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  Migrated: 'MIGRATED',
  MissingPayment: 'MISSING_PAYMENT',
  Refunded: 'REFUNDED',
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason];
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = {
  SelfServe: 'SELF_SERVE',
  Standard: 'STANDARD'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType];
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterprisePaymentInformation = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_EnterprisePaymentInformation';
  creditCardLastFourDigits?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<Scalars['String']>;
  paymentEmail?: Maybe<Scalars['String']>;
  paymentProcessorId: Scalars['String'];
};

/** EnterpriseContract's can be paid for in a variety of different ways. The EnterpriseContractBillingSystemType is a finite list of the billing methods available for both direct sales and WES contracts. */
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = {
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  NonBillable: 'NON_BILLABLE',
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType];
/** Information about a contract's auto-renewal. */
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_AutoRenewInformation = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_AutoRenewInformation';
  currencyCode: Scalars['String'];
  enterprisePromotionId?: Maybe<Scalars['String']>;
  renewAmount: Scalars['String'];
  renewsAt?: Maybe<Scalars['Float']>;
  userLimit?: Maybe<Scalars['Int']>;
};

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextPaymentInformation = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_NextPaymentInformation';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
  dueAt: Scalars['Float'];
  isPaymentDue: Scalars['Boolean'];
  isPaymentOverdue: Scalars['Boolean'];
  scheduledPaymentType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType;
  willPaymentMethodExpireBeforePaymentDate: Scalars['Boolean'];
};

export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType = {
  InstallmentPayment: 'INSTALLMENT_PAYMENT',
  RenewalPayment: 'RENEWAL_PAYMENT'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_NextScheduledPaymentType];
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_PaidEnterpriseContractPayment = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_PaidEnterpriseContractPayment';
  amount: Scalars['String'];
  cartId: Scalars['Float'];
  currencyCode: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  paymentAt: Scalars['Float'];
  paymentInformation: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterprisePaymentInformation;
  paymentType: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Billing_EnterpriseContractPaymentType;
  seatsAdded?: Maybe<Scalars['Int']>;
  termId?: Maybe<Scalars['String']>;
  transactionId: Scalars['String'];
  unitPrice?: Maybe<Scalars['String']>;
};

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Decorated_UnpaidEnterpriseContractPayment = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_decorated_UnpaidEnterpriseContractPayment';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
  paymentDate: Scalars['Float'];
};

export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimits = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_limits_EnterpriseContractLimits';
  coursesPerUserLimit?: Maybe<Scalars['Int']>;
  enrollmentCapLimit?: Maybe<Scalars['Int']>;
  userLimit?: Maybe<Scalars['Int']>;
};

/** Names that identify price mappings for self-serve contracts, where a price mapping defines the per-user cost of a contract based on the contract's courses per user limit. */
export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = {
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName];
/** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_INVOICE */
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_InvoiceBilledContractProperties = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_properties_InvoiceBilledContractProperties';
  customerId: Scalars['String'];
  paymentProcessorId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

/** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_TRANSACTION_PAYMENT */
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_SelfServeEnterpriseContractProperties = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_contract_properties_SelfServeEnterpriseContractProperties';
  paymentWalletId: Scalars['Float'];
  priceMappingName?: Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName>;
};

/** Represents the source of truth for data related to each individual term of a contract. This model and its relations contain all information needed to accurately revshare enterprise contracts. EnterpriseContractPayments have a termId that references one instance of a term. The total of those payments represents the revenue that should be recognized over this contract's startsAt and endsAt. EnterpriseContractTransactions also contain a termId reference and their sum represents the contract limits for a term, which can differ between terms. Enrollments data can also be gotten from promotionId, but it's not currently implemented like this. */
export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTerm = {
  __typename?: 'DecoratedEnterpriseContractsV1_org_coursera_product_enterprise_term_EnterpriseContractTerm';
  endsAt?: Maybe<Scalars['Float']>;
  enterpriseContractId: Scalars['String'];
  fxRateId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  promotionId: Scalars['Int'];
  startsAt: Scalars['Float'];
  termTag?: Maybe<DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag>;
  unitPrice?: Maybe<Scalars['String']>;
  writtenAt: Scalars['Float'];
};

export const DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = {
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag[keyof typeof DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag];
export type DecoratedEnterpriseContractsV1_Properties = DecoratedEnterpriseContractsV1_InvoiceBilledContractPropertiesMember | DecoratedEnterpriseContractsV1_SelfServePropertiesMember;

export type DecoratedEnterpriseContractsV1_SelfServePropertiesMember = {
  __typename?: 'DecoratedEnterpriseContractsV1_selfServePropertiesMember';
  selfServeProperties: DecoratedEnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_SelfServeEnterpriseContractProperties;
};

/** Represents a degree */
export type Degree = {
  __typename?: 'Degree';
  /** Header banner image */
  headerImage?: Maybe<Scalars['String']>;
  /** Id of the degree */
  id: Scalars['ID'];
  /** Logo */
  logo?: Maybe<Scalars['String']>;
  /** The name of the degree */
  name?: Maybe<Scalars['String']>;
  /** The partner providing the degree */
  partnerEntities?: Maybe<Array<Maybe<Partner_Partner>>>;
  /**
   * The partner providing the degree
   * @deprecated use partnerEntities instead
   */
  partners?: Maybe<Array<Maybe<DegreeMarketing_Partner>>>;
  /** Product variant */
  productVariant?: Maybe<Scalars['String']>;
  /** Short name of the degree */
  shortName?: Maybe<Scalars['String']>;
  /** The slug of the degree */
  slug?: Maybe<Scalars['String']>;
  /** Tagline */
  tagline?: Maybe<Scalars['String']>;
};

/** Degree duration */
export type DegreeAttributes_Duration = {
  __typename?: 'DegreeAttributes_Duration';
  /** Total time for the degree */
  duration: Scalars['Int'];
  /** Unit of degree duration */
  totalTimeUnit: DegreeAttributes_TimeUnit;
};

/** Degree duration */
export type DegreeAttributes_DurationInput = {
  /** Total time for the degree */
  duration: Scalars['Int'];
  /** Unit of degree duration */
  totalTimeUnit: DegreeAttributes_TimeUnit;
};

/** Time unit for degree duration */
export const DegreeAttributes_TimeUnit = {
  /** Day */
  Day: 'DAY',
  /** Month */
  Month: 'MONTH',
  /** Week */
  Week: 'WEEK',
  /** Year */
  Year: 'YEAR'
} as const;

export type DegreeAttributes_TimeUnit = typeof DegreeAttributes_TimeUnit[keyof typeof DegreeAttributes_TimeUnit];
/** Tuition */
export type DegreeAttributes_Tuition = {
  __typename?: 'DegreeAttributes_Tuition';
  /** Amount */
  amount: Scalars['Float'];
  /** Currency */
  currency: Scalars['String'];
};

/** Tuition */
export type DegreeAttributes_TuitionInput = {
  /** Amount */
  amount: Scalars['Float'];
  /** Currency */
  currency: Scalars['String'];
};

/** Degree Attributes upsert request object */
export type DegreeAttributes_UpdateDegreeAttributesInput = {
  /** Degree ID */
  degreeId: Scalars['ID'];
  /** Whether the degree requires a bachelor's degree */
  degreeRequiresBachelorDegree?: InputMaybe<Scalars['Boolean']>;
  /** Total time for the degree */
  duration?: InputMaybe<DegreeAttributes_DurationInput>;
  /** Whether the degree has an application fee */
  hasApplicationFee?: InputMaybe<Scalars['Boolean']>;
  /** Whether the degree has a scholarship */
  hasScholarship?: InputMaybe<Scalars['Boolean']>;
  /** The tuition in the advertised currency for the degree */
  marketedTuition?: InputMaybe<DegreeAttributes_TuitionInput>;
  /** The number of courses in the degree */
  numCourses?: InputMaybe<Scalars['Int']>;
  /** The number of credits in the degree */
  numCredits?: InputMaybe<Scalars['Int']>;
  /** The number of modules in the degree */
  numModules?: InputMaybe<Scalars['Int']>;
  /** The number of cohorts for the degree */
  numberOfCohorts?: InputMaybe<Scalars['Int']>;
  /** The on campus tuition for the degree */
  onCampusTuition?: InputMaybe<Scalars['Float']>;
  /** Whether the online tuition is the same as the on campus tuition */
  onlineSameAsOnCampus?: InputMaybe<Scalars['Boolean']>;
  /** Whether the degree is pay as you go */
  payAsYouGo?: InputMaybe<Scalars['Boolean']>;
  /** The primary aligned job for the degree */
  primaryAlignedJob?: InputMaybe<Scalars['String']>;
  /** The QS ranking for the degree */
  qsRanking?: InputMaybe<Scalars['Int']>;
  /** The tuition in USD for the degree */
  tuitionInUsd?: InputMaybe<Scalars['Float']>;
  /** The webinar host for the degree */
  webinarHost?: InputMaybe<Scalars['String']>;
};

/** Degree Attributes upsert response object */
export type DegreeAttributes_UpdateDegreeAttributesResult = {
  __typename?: 'DegreeAttributes_UpdateDegreeAttributesResult';
  /** Degree ID */
  degreeId: Scalars['ID'];
  /** Whether the degree requires a bachelor's degree */
  degreeRequiresBachelorDegree?: Maybe<Scalars['Boolean']>;
  /** Total time for the degree */
  duration?: Maybe<DegreeAttributes_Duration>;
  /** Whether the degree has an application fee */
  hasApplicationFee?: Maybe<Scalars['Boolean']>;
  /** Whether the degree has a scholarship */
  hasScholarship?: Maybe<Scalars['Boolean']>;
  /** The tuition in the advertised currency for the degree */
  marketedTuition?: Maybe<DegreeAttributes_Tuition>;
  /** The number of courses in the degree */
  numCourses?: Maybe<Scalars['Int']>;
  /** The number of credits in the degree */
  numCredits?: Maybe<Scalars['Int']>;
  /** The number of modules in the degree */
  numModules?: Maybe<Scalars['Int']>;
  /** The number of cohorts for the degree */
  numberOfCohorts?: Maybe<Scalars['Int']>;
  /** The on campus tuition for the degree */
  onCampusTuition?: Maybe<Scalars['Float']>;
  /** Whether the online tuition is the same as the on campus tuition */
  onlineSameAsOnCampus?: Maybe<Scalars['Boolean']>;
  /** Whether the degree is pay as you go */
  payAsYouGo?: Maybe<Scalars['Boolean']>;
  /** The primary aligned job for the degree */
  primaryAlignedJob?: Maybe<Scalars['String']>;
  /** The QS ranking for the degree */
  qsRanking?: Maybe<Scalars['Int']>;
  /** The tuition in USD for the degree */
  tuitionInUsd?: Maybe<Scalars['Float']>;
  /** The webinar host for the degree */
  webinarHost?: Maybe<Scalars['String']>;
};

/** Authoring Queries */
export type DegreeAuthoringQueries = {
  __typename?: 'DegreeAuthoringQueries';
  /** Create a pre-signed URL for a file upload */
  generateFileUploadUrl: DegreeAuthoring_SignedUrlResult;
  /**
   * Query Degrees
   * A custom paginated query for Degrees in accordance with GraphQL pagination
   * Refer to service-definitions ADR 0005 for details on pagination implementation
   */
  getDegrees: DegreeAuthoring_DegreeDraftPaginatedResult;
};


/** Authoring Queries */
export type DegreeAuthoringQueriesGenerateFileUploadUrlArgs = {
  input: DegreeAuthoring_FileUploadSignUrlRequest;
};


/** Authoring Queries */
export type DegreeAuthoringQueriesGetDegreesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  query?: InputMaybe<DegreeAuthoring_DegreeQueryInput>;
};

/** Additional headers to be included with the pre-signed URL */
export type DegreeAuthoring_AdditionalHeader = {
  __typename?: 'DegreeAuthoring_AdditionalHeader';
  /** Name of the header */
  name: Scalars['String'];
  /** Value of the header */
  value: Scalars['String'];
};

/** Catalog availability status of the degree */
export const DegreeAuthoring_CatalogAvailabilityStatus = {
  /** Degree is archived */
  Archived: 'ARCHIVED',
  /** Degree is still in draft */
  Draft: 'DRAFT',
  /** Degree is live */
  Live: 'LIVE',
  /** Degree is in prelaunch */
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type DegreeAuthoring_CatalogAvailabilityStatus = typeof DegreeAuthoring_CatalogAvailabilityStatus[keyof typeof DegreeAuthoring_CatalogAvailabilityStatus];
/**
 * Degree, for authoring purposes
 * This object will be used for lazy authoring
 * including a first time auhthoring with no degree ID
 * then updating the degree with the ID
 */
export type DegreeAuthoring_DegreeDraft = {
  __typename?: 'DegreeAuthoring_DegreeDraft';
  /** Banner image of the degree */
  bannerImage?: Maybe<Scalars['URL']>;
  /** Catalog availability status of the degree */
  catalogAvailabilityStatus: DegreeAuthoring_CatalogAvailabilityStatus;
  /** Degree category Ids of the degree */
  degreeCategoryIds?: Maybe<Array<Scalars['ID']>>;
  /** Domain Ids of the degree */
  domainIds?: Maybe<Array<Domain_Domain>>;
  /** Expression of Interest type of the degree */
  eoiType?: Maybe<DegreeAuthoring_EoiType>;
  /** ID of the degree */
  id: Scalars['ID'];
  /** Language code of the degree */
  languageCode?: Maybe<Scalars['String']>;
  /** Launch date of the degree */
  launchDate?: Maybe<Scalars['DateTime']>;
  /** Mailspin template ID of the degree */
  mailspinTemplateId?: Maybe<Scalars['ID']>;
  /** Metadata of the degree */
  metadata?: Maybe<DegreeAuthoring_DegreeMetadata>;
  /** Name of the degree */
  name?: Maybe<Scalars['String']>;
  /** Product variant of the degree */
  productVariant?: Maybe<DegreeAuthoring_ProductVariant>;
  /** Short name of the degree */
  shortName?: Maybe<Scalars['String']>;
  /** Slug of the degree */
  slug?: Maybe<Scalars['String']>;
  /** Tagline of the degree */
  tagline?: Maybe<Scalars['String']>;
  /** Thumbnail image of the degree */
  thumbnailImage?: Maybe<Scalars['URL']>;
};

/** Result of querying Degrees */
export type DegreeAuthoring_DegreeDraftPaginatedResult = {
  __typename?: 'DegreeAuthoring_DegreeDraftPaginatedResult';
  /** List of Degrees */
  elements: Array<DegreeAuthoring_DegreeDraft>;
  /** Pagination information */
  pagination: Pagination;
};

/** Metadata of the degree */
export type DegreeAuthoring_DegreeMetadata = {
  __typename?: 'DegreeAuthoring_DegreeMetadata';
  /** Whether the degree has an application fee */
  hasApplicationFee?: Maybe<Scalars['Boolean']>;
  /** Whether the degree has a scholarship */
  hasScholarship?: Maybe<Scalars['Boolean']>;
  /** Number of cohorts in the degree */
  numCohorts?: Maybe<Scalars['Int']>;
  /** Number of courses in the degree */
  numCourses?: Maybe<Scalars['Int']>;
  /** Number of credits in the degree */
  numCredits?: Maybe<Scalars['Int']>;
  /** Number of modules in the degree */
  numModules?: Maybe<Scalars['Int']>;
  /** On campus tuition in USD of the degree */
  onCampusTuitionUsd?: Maybe<Scalars['Float']>;
  /** Whether online tuition is the same as on campus tuition */
  onlineSameAsCampus?: Maybe<Scalars['Boolean']>;
  /** Whether the degree is pay as you go */
  payAsYouGo?: Maybe<Scalars['Boolean']>;
  /** Primary aligned job of the degree */
  primaryAlignedJob?: Maybe<Scalars['String']>;
  /** QS ranking of the degree */
  qsRanking?: Maybe<Scalars['Int']>;
  /** Whether the degree requires a bachelor's degree */
  requiresBachelors?: Maybe<Scalars['Boolean']>;
  /** Tuition in USD of the degree */
  tuitionUsd?: Maybe<Scalars['Float']>;
  /** Webinar host of the degree */
  webinarHost?: Maybe<Scalars['String']>;
};

/** Query for Degrees */
export type DegreeAuthoring_DegreeQueryInput = {
  /** Query for Catalog availability statuses */
  catalogAvailabilityStatuses?: InputMaybe<Array<DegreeAuthoring_CatalogAvailabilityStatus>>;
  /** Query by Degree Category Ids */
  degreeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Query for domain Ids */
  domainIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Query by EOI types */
  eoiTypes?: InputMaybe<Array<DegreeAuthoring_EoiType>>;
  /** Query for Degree IDs, including draft degrees */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Query for language codes */
  languageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** Query by mailspin template ID */
  mailspinTemplateId?: InputMaybe<Scalars['ID']>;
  /** Query for partial name match */
  name?: InputMaybe<Scalars['String']>;
  /** Query for product variants */
  productVariants?: InputMaybe<Array<DegreeAuthoring_ProductVariant>>;
  /** Query for partial short name match */
  shortName?: InputMaybe<Scalars['String']>;
  /** Query for partial slug match */
  slug?: InputMaybe<Scalars['String']>;
  /** Query for partial tagline match */
  tagline?: InputMaybe<Scalars['String']>;
};

/** Expression of Interest types */
export const DegreeAuthoring_EoiType = {
  /** EOI Extra Questions */
  EoiExtraQuestions: 'EOI_EXTRA_QUESTIONS',
  /** One click email */
  EoiOneClickEmail: 'EOI_ONE_CLICK_EMAIL',
  /** Only phone */
  EoiOnlyPhone: 'EOI_ONLY_PHONE'
} as const;

export type DegreeAuthoring_EoiType = typeof DegreeAuthoring_EoiType[keyof typeof DegreeAuthoring_EoiType];
/** Input for generating a pre-signed URL for a file upload */
export type DegreeAuthoring_FileUploadSignUrlRequest = {
  /** MD5 checksum of the file to be uploaded */
  contentMd5?: InputMaybe<Scalars['String']>;
  /** MIME type of the file to be uploaded */
  contentType: Scalars['String'];
  /** Name of the file to be uploaded */
  fileName: Scalars['String'];
};

/** Prooduct variant of the degree */
export const DegreeAuthoring_ProductVariant = {
  /** Bachelors degree */
  BachelorsDegree: 'BachelorsDegree',
  /** Graduate certificate */
  GraduateCertificate: 'GraduateCertificate',
  /** MasterTrack */
  MasterTrack: 'MasterTrack',
  /** Masters degree */
  MastersDegree: 'MastersDegree',
  /** Postgraduate diploma */
  PostgraduateDiploma: 'PostgraduateDiploma',
  /** Professional certificate */
  ProfessionalCertificate: 'ProfessionalCertificate',
  /** University certificate */
  UniversityCertificate: 'UniversityCertificate'
} as const;

export type DegreeAuthoring_ProductVariant = typeof DegreeAuthoring_ProductVariant[keyof typeof DegreeAuthoring_ProductVariant];
/** Result of generating a pre-signed URL for a file upload */
export type DegreeAuthoring_SignedUrlResult = {
  __typename?: 'DegreeAuthoring_SignedUrlResult';
  /** Additional headers to be included with the URL */
  additionalHeaders: Array<DegreeAuthoring_AdditionalHeader>;
  /** Pre-signed URL for the file upload */
  url: Scalars['URL'];
};

export type DegreeCategoriesV1 = {
  __typename?: 'DegreeCategoriesV1';
  degreeListsV3?: Maybe<DegreeListsV3Connection>;
  id: Scalars['String'];
  isTest: Scalars['Boolean'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  tier: DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier;
};


export type DegreeCategoriesV1DegreeListsV3Args = {
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeCategoriesV1BySlug = {
  __typename?: 'DegreeCategoriesV1BySlug';
  connection?: Maybe<DegreeCategoriesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type DegreeCategoriesV1Connection = {
  __typename?: 'DegreeCategoriesV1Connection';
  elements: Array<Maybe<DegreeCategoriesV1>>;
  paging: ResponsePagination;
};

export type DegreeCategoriesV1Resource = {
  __typename?: 'DegreeCategoriesV1Resource';
  bySlug?: Maybe<DegreeCategoriesV1Connection>;
  get?: Maybe<DegreeCategoriesV1>;
  getAll?: Maybe<DegreeCategoriesV1Connection>;
  multiGet?: Maybe<DegreeCategoriesV1Connection>;
};


export type DegreeCategoriesV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type DegreeCategoriesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreeCategoriesV1ResourceGetAllArgs = {
  includeTest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  tiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type DegreeCategoriesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeCategoriesV1ResourceMutations = {
  __typename?: 'DegreeCategoriesV1ResourceMutations';
  create?: Maybe<DegreeCategoriesV1Connection>;
  delete?: Maybe<DegreeCategoriesV1Connection>;
  update?: Maybe<DegreeCategoriesV1Connection>;
};


export type DegreeCategoriesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type DegreeCategoriesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export const DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier = {
  Tier_1: 'TIER_1',
  Tier_2: 'TIER_2'
} as const;

export type DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier = typeof DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier[keyof typeof DegreeCategoriesV1_Org_Coursera_Degree_Category_DegreeCategoryTier];
/** Query definitions for fetching degree categories. */
export type DegreeCategoryFetchQueries = {
  __typename?: 'DegreeCategoryFetchQueries';
  /** Returns a list of degree categories that match the supplied filter. */
  getAll?: Maybe<Array<DegreeCategoryResponse>>;
  /** Returns a degree category having the supplied id. */
  getById?: Maybe<DegreeCategoryResponse>;
  /** Returns a degree category having the supplied slug. */
  getBySlug?: Maybe<DegreeCategoryResponse>;
  /** Returns a list of degree categories that match the supplied degree category ids. */
  multiGet?: Maybe<Array<DegreeCategoryResponse>>;
};


/** Query definitions for fetching degree categories. */
export type DegreeCategoryFetchQueriesGetAllArgs = {
  filter: DegreeCategoryGetAllQueryFilter;
};


/** Query definitions for fetching degree categories. */
export type DegreeCategoryFetchQueriesGetByIdArgs = {
  id: Scalars['String'];
};


/** Query definitions for fetching degree categories. */
export type DegreeCategoryFetchQueriesGetBySlugArgs = {
  slug: Scalars['String'];
};


/** Query definitions for fetching degree categories. */
export type DegreeCategoryFetchQueriesMultiGetArgs = {
  ids: Array<Scalars['String']>;
};

/** Search filter for querying degree categories. */
export type DegreeCategoryGetAllQueryFilter = {
  /** Optional parameter that determines whether degree counts should be included in degreeCategory response. */
  degreeCountSpecs?: InputMaybe<DegreeCountSpecs>;
  /** Optional parameter that determines whether premium products collections should be included in degreeCategory response. */
  learningProductSpecs?: InputMaybe<PremiumLearningProductSpecs>;
  /** Optional parameter for ordering degree categories. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Optional parameter specifying the Tier that degree category results should belong to. */
  tiers?: InputMaybe<Array<Scalars['String']>>;
};

/** Query definitions for updating degree categories. */
export type DegreeCategoryMutationQueries = {
  __typename?: 'DegreeCategoryMutationQueries';
  /** Creates a new degree category. */
  create: DegreeCategoryResponse;
  /** Deletes an existing degree category. */
  delete?: Maybe<Scalars['String']>;
  /** Updates an existing degree category. */
  update: DegreeCategoryResponse;
};


/** Query definitions for updating degree categories. */
export type DegreeCategoryMutationQueriesCreateArgs = {
  input: DegreeCategoryRequest;
};


/** Query definitions for updating degree categories. */
export type DegreeCategoryMutationQueriesDeleteArgs = {
  id: Scalars['String'];
};


/** Query definitions for updating degree categories. */
export type DegreeCategoryMutationQueriesUpdateArgs = {
  input: DegreeCategoryRequest;
};

/** Parameters for creating or updating a degree category. */
export type DegreeCategoryRequest = {
  /** Unique ID of the degree category. */
  id: Scalars['String'];
  /** Name of the degree category. */
  name: Scalars['String'];
  /** Unique slug of the degree category. */
  slug: Scalars['String'];
  /** Tag line of the degree category. */
  tagline: Scalars['String'];
  /** Tier that a degree category belongs to. */
  tier: Scalars['String'];
};

/** Response object that represents a Degree Category. */
export type DegreeCategoryResponse = {
  __typename?: 'DegreeCategoryResponse';
  /** Number of degrees that belong to a degree category. */
  degreeCount?: Maybe<Scalars['Int']>;
  /** Unique ID of the degree category. */
  id: Scalars['ID'];
  /** Name of the degree category. */
  name: Scalars['String'];
  /** Learning Products associated with a degree category. */
  premiumLearningProducts?: Maybe<PremiumLearningProductsResponse>;
  /** Unique slug of the degree category. */
  slug: Scalars['String'];
  /** Tag line of the degree category. */
  tagline: Scalars['String'];
  /** Tier that a degree category belongs to. */
  tier: Scalars['String'];
};

/** Namespaced queries through nesting to aid discoverability. */
export type DegreeConfigQueries = {
  __typename?: 'DegreeConfigQueries';
  /** To fetch the details, and all metadata for a program config */
  getConfigProgramDetailsForSlugAndProgramKey?: Maybe<DegreeConfigQueries_Result>;
  /** To download a config file, we will give a presigned s3 url to the user. */
  getUrlForConfigFileDownload?: Maybe<Scalars['URL']>;
};


/** Namespaced queries through nesting to aid discoverability. */
export type DegreeConfigQueriesGetConfigProgramDetailsForSlugAndProgramKeyArgs = {
  degreeSlug: Scalars['String'];
  programConfigKey?: InputMaybe<Scalars['String']>;
};


/** Namespaced queries through nesting to aid discoverability. */
export type DegreeConfigQueriesGetUrlForConfigFileDownloadArgs = {
  degreeSlug: Scalars['String'];
  programConfigKey?: InputMaybe<Scalars['String']>;
};

/** Defines how an error is created */
export type DegreeConfigQueries_Error = {
  __typename?: 'DegreeConfigQueries_Error';
  /** Any errorCode, if relevant */
  errorCode?: Maybe<Scalars['String']>;
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Defines a payload where all data is string */
export type DegreeConfigQueries_Payload = {
  __typename?: 'DegreeConfigQueries_Payload';
  /**
   * Data is represented as a string
   * @deprecated Will replace with the actual structure once API implementation is complete
   */
  dataForTesting: Scalars['String'];
};

/** Return the entire DegreeProgramConfigMetadata Payload */
export type DegreeConfigQueries_ProgramConfigMetadata_Payload = {
  __typename?: 'DegreeConfigQueries_ProgramConfigMetadata_Payload';
  /** application system */
  applicationSystem: Scalars['String'];
  /** Client Id for university partner */
  clientId?: Maybe<Scalars['ID']>;
  /** Client secret for university partner */
  clientSecret?: Maybe<Scalars['String']>;
  /** degree name */
  degreeName: Scalars['String'];
  /** degree slug for program */
  degreeSlug: Scalars['String'];
  /** If a program is found, then we can also generate the downloadable url and return it with the config metadata */
  downloadableTemplateUrl?: Maybe<Scalars['URL']>;
  /** lookback minutes date */
  lookbackMinutesDate?: Maybe<Scalars['DateTime']>;
  /** onboarded at date - created */
  onboardedAtDate: Scalars['DateTime'];
  /** onboarded by - will contain a coursera user id */
  onboardedBy: Scalars['ID'];
  /** onboarding status */
  onboardingStatus: Scalars['String'];
  /** Domain of the university partner's platform */
  partnerDomain: Scalars['String'];
  /** partner id */
  partnerId: Scalars['ID'];
  /** Password for university partner's platform */
  password: Scalars['String'];
  /** program config key */
  programConfigKey?: Maybe<Scalars['String']>;
  /** university name */
  universityName: Scalars['String'];
  /** Username for university partner's platform */
  username: Scalars['String'];
  /** version */
  version: Scalars['Int'];
  /** version id - combination of version & programconfigkey if present */
  versionId: Scalars['ID'];
};

/** The result of any api call that can help return a payload and a list of errors associated */
export type DegreeConfigQueries_Result = {
  __typename?: 'DegreeConfigQueries_Result';
  /** A list of readable errors which can be shown */
  errors?: Maybe<Array<DegreeConfigQueries_Error>>;
  /** Any data that needs to be returned as part of the result, if any */
  payload?: Maybe<DegreeConfigQueries_ProgramConfigMetadata_Payload>;
};

/** Input for creating student success attributes (same as above without version). */
export type DegreeConfig_CreateStudentSuccessAttributesInput = {
  /** The degree to update the attributes for. */
  degreeId: Scalars['ID'];
  /** Whether the degree supports disclaimers or not */
  disclaimersConfig: DegreeConfig_DisclaimerConfigInput;
  /** The enrollment URL provided by the partner where students can enroll for classes. */
  enrollmentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the degree supports FCND (for-credit non-degree) students or not. */
  fcndConfig: DegreeConfig_FcndConfigInput;
  /** Indicates whether the degree supports a performance pathway admissions process. */
  hasPbaAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports an open content performance pathway admissions process. */
  hasPbaWithOpenContentAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports a traditional admissions process. */
  hasTraditionalAdmissionProcess: Scalars['Boolean'];
  /**
   * The maximum number of terms (if there is one) that a student can be enrolled as a degree student
   * in the program.
   */
  maxTerms: Scalars['Int'];
};

/** Result for student success attributes create mutation */
export type DegreeConfig_CreateStudentSuccessAttributesResult = DegreeConfig_MutationFailure | DegreeConfig_StudentSuccessAttributes;

/** Configurations for disclaimer support. */
export type DegreeConfig_DisclaimerConfig = {
  __typename?: 'DegreeConfig_DisclaimerConfig';
  /** Optional call to action label. */
  disclaimerCallToAction?: Maybe<Scalars['String']>;
  /** Disclaimer message. */
  disclaimerMessage: Scalars['String'];
  /** Optional URL to redirect learners to partner portal. */
  disclaimerUrl?: Maybe<Scalars['URL']>;
  /** Whether disclaimer support is enabled or not. */
  enabled: Scalars['Boolean'];
};

/** Configurations for disclaimer support. */
export type DegreeConfig_DisclaimerConfigInput = {
  /** Optional call to action label. */
  disclaimerCallToAction?: InputMaybe<Scalars['String']>;
  /** Disclaimer message. */
  disclaimerMessage: Scalars['String'];
  /** Optional URL to redirect learners to partner portal. */
  disclaimerUrl?: InputMaybe<Scalars['URL']>;
  /** Whether disclaimer support is enabled or not. */
  enabled: Scalars['Boolean'];
};

/** Different degree config errors */
export const DegreeConfig_Error = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** Any other BE validation errors (data invalid) - this is so that any other validation errors on the BE are not thrown as internal errors */
  InvalidArgument: 'INVALID_ARGUMENT',
  /** The maxCreditsForFcnd field is null but FCND is enabled */
  MaxCreditsForFcndMissing: 'MAX_CREDITS_FOR_FCND_MISSING',
  /** The version does not match the stored version */
  VersionConflict: 'VERSION_CONFLICT'
} as const;

export type DegreeConfig_Error = typeof DegreeConfig_Error[keyof typeof DegreeConfig_Error];
/** Configurations for FCND support. */
export type DegreeConfig_FcndConfig = {
  __typename?: 'DegreeConfig_FcndConfig';
  /** Whether FCND support is enabled or not. */
  enabled: Scalars['Boolean'];
  /**
   * The maximum number of credits (if there is one) that learners can apply towards degree
   * completion as an FCND student (before being admitted to the degree)
   */
  maxNumberOfCredits?: Maybe<Scalars['Int']>;
};

/** Configurations for FCND support. */
export type DegreeConfig_FcndConfigInput = {
  /** Whether FCND support is enabled or not. */
  enabled: Scalars['Boolean'];
  /**
   * The maximum number of credits (if there is one) that learners can apply towards degree
   * completion as an FCND student (before being admitted to the degree)
   */
  maxNumberOfCredits?: InputMaybe<Scalars['Int']>;
};

/** The GPA Grade scale used to map grades to GPA points for the degree */
export type DegreeConfig_GradeScale = {
  __typename?: 'DegreeConfig_GradeScale';
  /** The scale entries for all continuous buckets that define the scale */
  buckets: Array<DegreeConfig_GradeScaleEntry>;
};

/** A single entry in the grade scale, that maps a grade range to a single grade point */
export type DegreeConfig_GradeScaleEntry = {
  __typename?: 'DegreeConfig_GradeScaleEntry';
  /**
   * The credit-point/grade-point for this grade range.
   * For example: 4.0 or 3.7 or 7.9
   */
  gradePoint: Scalars['Float'];
  /**
   * The ending percentage value for this grade range. This value is exclusive
   * The value is between 0-1. For example 0.9 means 90%.
   * This value must be greater than the gradeRangeStart.
   */
  gradeRangeEnd: Scalars['Float'];
  /**
   * The starting percentage value for this grade range. This value is inclusive.
   * The value is between 0-1. For example 0.9 means 90%.
   */
  gradeRangeStart: Scalars['Float'];
};

/** domain specific error interface for degree config mutations */
export type DegreeConfig_MutationError = {
  __typename?: 'DegreeConfig_MutationError';
  /** reason for the error */
  error: DegreeConfig_Error;
};

/** Error encountered while performing mutation */
export type DegreeConfig_MutationFailure = {
  __typename?: 'DegreeConfig_MutationFailure';
  /** errors encountered */
  errors?: Maybe<Array<DegreeConfig_MutationError>>;
};

/**
 * Properties regarding a degree hosted on DPM/CM that should not be considered student success
 * attributes
 */
export type DegreeConfig_Properties = {
  __typename?: 'DegreeConfig_Properties';
  /**
   * The time the degree is launched on the DPM experience for learners. It has no correlation
   * with the course launch flow.If null, the degree is not available for viewing on DPM experience.
   */
  launchedAt?: Maybe<Scalars['DateTime']>;
};

/** The student success attributes for a degree */
export type DegreeConfig_StudentSuccessAttributes = {
  __typename?: 'DegreeConfig_StudentSuccessAttributes';
  /** Whether the degree supports disclaimers or not */
  disclaimersConfig: DegreeConfig_DisclaimerConfig;
  /** The enrollment URL provided by the partner where student's can enroll for classes. */
  enrollmentUrl?: Maybe<Scalars['URL']>;
  /** Whether the degree supports FCND (for-credit non-degree) students or not. */
  fcndConfig: DegreeConfig_FcndConfig;
  /** Indicates whether the degree supports a performance pathway admissions process. */
  hasPbaAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports an open content performance pathway admissions process. */
  hasPbaWithOpenContentAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports a traditional (not performance pathway) admissions process. */
  hasTraditionalAdmissionProcess: Scalars['Boolean'];
  /**
   * The maximum number of terms (if there is one) that a student can be enrolled as a degree student
   * in the program.
   */
  maxTerms: Scalars['Int'];
  /** The version of the student success attributes. */
  version: Scalars['Int'];
};

/** Input for updating student success attributes. */
export type DegreeConfig_UpdateStudentSuccessAttributesInput = {
  /** The degree to update the attributes for. */
  degreeId: Scalars['ID'];
  /** Whether the degree supports disclaimers or not */
  disclaimersConfig: DegreeConfig_DisclaimerConfigInput;
  /** The enrollment URL provided by the partner where students can enroll for classes. */
  enrollmentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether the degree supports FCND (for-credit non-degree) students or not. */
  fcndConfig: DegreeConfig_FcndConfigInput;
  /** Indicates whether the degree supports a performance pathway admissions process. */
  hasPbaAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports an open content performance pathway admissions process. */
  hasPbaWithOpenContentAdmissionProcess: Scalars['Boolean'];
  /** Indicates whether the degree supports a traditional admissions process. */
  hasTraditionalAdmissionProcess: Scalars['Boolean'];
  /**
   * The maximum number of terms (if there is one) that a student can be enrolled as a degree student
   * in the program.
   */
  maxTerms: Scalars['Int'];
  /** The version of the student success attributes to trigger the update on. */
  version: Scalars['Int'];
};

/** Result for student success attributes update mutation */
export type DegreeConfig_UpdateStudentSuccessAttributesResult = DegreeConfig_MutationFailure | DegreeConfig_StudentSuccessAttributes;

/** Parameter for querying degree categories when degree count is required in the results. */
export type DegreeCountSpecs = {
  /** Availability status by which to retrieve degree counts. */
  catalogAvailabilityStatuses?: InputMaybe<Array<Scalars['String']>>;
};

/** Fetch data for degree description page (DDP) modules */
export type DegreeDescriptionPageModulesQueries = {
  __typename?: 'DegreeDescriptionPageModulesQueries';
  /**
   * Return a list of program admission deadlines.
   * Only include terms that admissions are still opening.
   * The terms will be sorted by admissionStartDate, from earliest to latest.
   */
  queryProgramAdmissionDeadlines: Array<DegreeDescriptionPageModules_ProgramAdmissionDeadlines>;
};


/** Fetch data for degree description page (DDP) modules */
export type DegreeDescriptionPageModulesQueriesQueryProgramAdmissionDeadlinesArgs = {
  degreeSlug?: InputMaybe<Scalars['String']>;
};

/** Program term info and deadlines */
export type DegreeDescriptionPageModules_ProgramAdmissionDeadlines = {
  __typename?: 'DegreeDescriptionPageModules_ProgramAdmissionDeadlines';
  /** admission start date */
  admissionStartDate: Scalars['Date'];
  /** admission term id */
  applicationAdmissionTermId: Scalars['ID'];
  /** admission term name */
  applicationAdmissionTermName: Scalars['String'];
  /** extended application deadline (can be null) */
  extendedSubtermDeadlineDate?: Maybe<Scalars['Date']>;
  /** priority application deadlines (can be empty) */
  priorityDeadlineDate?: Maybe<Scalars['Date']>;
  /** secondary priority application deadlines (can be empty) */
  secondaryPriorityDeadlineDate?: Maybe<Scalars['Date']>;
  /** upcoming regular application deadline (can be null) */
  subtermDeadlineDate?: Maybe<Scalars['Date']>;
};

/** List item */
export const DegreeEnrollmentCheckListItem = {
  /** APPLICATION_ACCEPTED */
  ApplicationAccepted: 'APPLICATION_ACCEPTED',
  /** ENROLL_IN_COURSES */
  EnrollInCourses: 'ENROLL_IN_COURSES',
  /** PAY_APPLICATION_FEE */
  PayApplicationFee: 'PAY_APPLICATION_FEE',
  /** SUBMIT_APPLICATION */
  SubmitApplication: 'SUBMIT_APPLICATION'
} as const;

export type DegreeEnrollmentCheckListItem = typeof DegreeEnrollmentCheckListItem[keyof typeof DegreeEnrollmentCheckListItem];
/** Mutations for enrollment checklist */
export type DegreeEnrollmentCheckListMutationQueries = {
  __typename?: 'DegreeEnrollmentCheckListMutationQueries';
  /** Delete checklist */
  deleteDegreeEnrollmentCheckList?: Maybe<Scalars['Boolean']>;
  /** Enable checklist */
  enableDegreeEnrollmentCheckList?: Maybe<Scalars['Boolean']>;
};


/** Mutations for enrollment checklist */
export type DegreeEnrollmentCheckListMutationQueriesDeleteDegreeEnrollmentCheckListArgs = {
  id: DegreeEnrollmentChecklistKey;
};


/** Mutations for enrollment checklist */
export type DegreeEnrollmentCheckListMutationQueriesEnableDegreeEnrollmentCheckListArgs = {
  key: DegreeEnrollmentChecklistKey;
  params?: InputMaybe<Array<Param>>;
};

/** Queries for enrollment checklist */
export type DegreeEnrollmentCheckListQueries = {
  __typename?: 'DegreeEnrollmentCheckListQueries';
  /** Get enrollment checklist for a single user and degree */
  getDegreeEnrollmentCheckList?: Maybe<DegreeEnrollmentChecklist>;
  /** Get enrollment checklists for a multiple users and degrees */
  multiGetDegreeEnrollmentCheckLists: Array<DegreeEnrollmentChecklist>;
};


/** Queries for enrollment checklist */
export type DegreeEnrollmentCheckListQueriesGetDegreeEnrollmentCheckListArgs = {
  key: DegreeEnrollmentChecklistKey;
};


/** Queries for enrollment checklist */
export type DegreeEnrollmentCheckListQueriesMultiGetDegreeEnrollmentCheckListsArgs = {
  keys: Array<DegreeEnrollmentChecklistKey>;
};

/** List of items */
export type DegreeEnrollmentChecklist = {
  __typename?: 'DegreeEnrollmentChecklist';
  /** Completed items */
  completedItems: Array<DegreeEnrollmentCheckListItem>;
  /** The id */
  id: Scalars['ID'];
};

/** Composite key for checklists */
export type DegreeEnrollmentChecklistKey = {
  /** Product slug */
  productSlug: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** User */
  userId: Scalars['String'];
};

export type DegreeEnrollmentChecklistsV1 = {
  __typename?: 'DegreeEnrollmentChecklistsV1';
  completedItems: Array<Maybe<DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem>>;
  id: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  productSlug: Scalars['String'];
  productType: DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type DegreeEnrollmentChecklistsV1Connection = {
  __typename?: 'DegreeEnrollmentChecklistsV1Connection';
  elements: Array<Maybe<DegreeEnrollmentChecklistsV1>>;
  paging: ResponsePagination;
};

export type DegreeEnrollmentChecklistsV1Resource = {
  __typename?: 'DegreeEnrollmentChecklistsV1Resource';
  get?: Maybe<DegreeEnrollmentChecklistsV1>;
  multiGet?: Maybe<DegreeEnrollmentChecklistsV1Connection>;
};


export type DegreeEnrollmentChecklistsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreeEnrollmentChecklistsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeEnrollmentChecklistsV1ResourceMutations = {
  __typename?: 'DegreeEnrollmentChecklistsV1ResourceMutations';
  delete?: Maybe<DegreeEnrollmentChecklistsV1Connection>;
  enableChecklist?: Maybe<Scalars['JSON']>;
};


export type DegreeEnrollmentChecklistsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type DegreeEnrollmentChecklistsV1ResourceMutationsEnableChecklistArgs = {
  id: Scalars['String'];
};

/** Includes all high-credentials and not just strict degrees, but for lack of a better term that's also widely accepted, still naming as degree here. Why are we using this type instead of [[DegreeProductVariant]] from the core [[Degree]] model? There are some types in [[DegreeProductVariant]] that don't concern us at all (we don't market every variant of degrees). We also don't want to couple the types we need for marketing purposes with the types that are created for learning experience purposes; for now, the systems for marketing specific data are largely isolated from learning experience systems. */
export const DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType = {
  Degree: 'DEGREE',
  Mastertrack: 'MASTERTRACK'
} as const;

export type DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType = typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType[keyof typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_DegreeProductType];
/** The things that a learner may have to do on their path to becoming a Mastertrack/Degree student. */
export const DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem = {
  ApplicationAccepted: 'APPLICATION_ACCEPTED',
  EnrollInCourses: 'ENROLL_IN_COURSES',
  PayApplicationFee: 'PAY_APPLICATION_FEE',
  SubmitApplication: 'SUBMIT_APPLICATION'
} as const;

export type DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem = typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem[keyof typeof DegreeEnrollmentChecklistsV1_Org_Coursera_Degreemarketing_Checklist_DegreeEnrollmentChecklistItem];
/** The academic calendar events for a degree. These events could be relevant to any learner. */
export type DegreeEvent_AcademicEvent = {
  __typename?: 'DegreeEvent_AcademicEvent';
  /** The actionable link of the event (e.g. the link to the enrollment page), optional */
  actionLink?: Maybe<Scalars['URL']>;
  /** The association of the event, e.g. degree, term, etc */
  association: DegreeEvent_EventAssociation;
  /** Custom call-to-action label for a nudge (connected to the actionLink) */
  ctaLabel?: Maybe<Scalars['String']>;
  /** The description of the event, optional */
  description?: Maybe<Scalars['String']>;
  /**
   * Optional display end date for event nudges, provided by the partner, this date will override
   * the default end date inferred from the event date
   */
  displayEndDate?: Maybe<Scalars['DateTime']>;
  /**
   * Optional display start date for event nudges, provided by the partner, this date will override
   * the default start date inferred from the event date
   */
  displayStartDate?: Maybe<Scalars['DateTime']>;
  /** The date when the event occurs, can be used to infer the default display window for event nudges */
  eventDate: Scalars['DateTime'];
  /** The type of the event */
  eventType: DegreeEvent_EventType;
  /** The id of the event */
  id: Scalars['ID'];
  /** The title of the event, optional */
  title?: Maybe<Scalars['String']>;
};

/** The event of passable items in a course */
export type DegreeEvent_AssignmentEvent = {
  __typename?: 'DegreeEvent_AssignmentEvent';
  /** Name of the assignment */
  assignmentName: Scalars['String'];
  /** Type of the assignment */
  assignmentType: Scalars['String'];
  /** URL to the assignment in the learner course experience. */
  assignmentUrl: Scalars['String'];
  /** The course that the assignment is in */
  course: Course_Course;
  /** URL to the course home of the learner experience */
  courseUrl: Scalars['String'];
  /** When the assignment is due */
  dueDate: Scalars['DateTime'];
  /** Percentile grade given for the assignment (if graded), optional */
  grade?: Maybe<Scalars['Float']>;
  /** When the assignment was graded (if graded) optional */
  gradedAtTime?: Maybe<Scalars['DateTime']>;
  /** Percentile grade given for the assignment, optional */
  gradingWeight?: Maybe<Scalars['Float']>;
  /** The item iD for the assignment item */
  id: Scalars['ID'];
  /** If the assignment is completed by the student */
  isComplete: Scalars['Boolean'];
  /** If the assignment should be dismissed from view */
  isDismissed: Scalars['Boolean'];
  /** Assignment progress state */
  progressState: DegreeEvent_AssignmentProgressState;
  /** Submission type configured for the assignment */
  submissionType: DegreeEvent_AssignmentSubmissionType;
};

/** Assignment progress state */
export const DegreeEvent_AssignmentProgressState = {
  /** If the assignment is graded and not passed */
  Failed: 'FAILED',
  /** If the assignment is not submitted by the student */
  NotSubmitted: 'NOT_SUBMITTED',
  /** If the assignment is not submitted and overdue */
  Overdue: 'OVERDUE',
  /** If the assignment is graded and passed */
  Passed: 'PASSED',
  /** If the assignment is not submitted by the student, but not graded */
  Submitted: 'SUBMITTED'
} as const;

export type DegreeEvent_AssignmentProgressState = typeof DegreeEvent_AssignmentProgressState[keyof typeof DegreeEvent_AssignmentProgressState];
/** Submission type configured for the assignment */
export const DegreeEvent_AssignmentSubmissionType = {
  /** The assignment is configured to be submitted by individual learners */
  Individual: 'INDIVIDUAL',
  /** The assignment has a submission type that doesn't belong to any of the common categories */
  Other: 'OTHER',
  /** The assignment is configured to be submitted by teams */
  Team: 'TEAM'
} as const;

export type DegreeEvent_AssignmentSubmissionType = typeof DegreeEvent_AssignmentSubmissionType[keyof typeof DegreeEvent_AssignmentSubmissionType];
/** The association type when the event is associated with a degree */
export type DegreeEvent_DegreeAssociation = {
  __typename?: 'DegreeEvent_DegreeAssociation';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** The union of all event types */
export type DegreeEvent_Event = DegreeEvent_AcademicEvent | DegreeEvent_AssignmentEvent | DegreeEvent_LiveEvent;

/** The association type for events */
export type DegreeEvent_EventAssociation = DegreeEvent_DegreeAssociation | DegreeEvent_TermAssociation;

/** The type of the academic event */
export const DegreeEvent_EventType = {
  /** The type for submitting grading */
  GradingSubmission: 'GRADING_SUBMISSION',
  /** A generic type for events that do not belong to all the above types */
  Other: 'OTHER',
  /** The type for the end of the registration */
  RegistrationEnd: 'REGISTRATION_END',
  /** The type for the start of the registration */
  RegistrationStart: 'REGISTRATION_START'
} as const;

export type DegreeEvent_EventType = typeof DegreeEvent_EventType[keyof typeof DegreeEvent_EventType];
/** The event of live events in a course */
export type DegreeEvent_LiveEvent = {
  __typename?: 'DegreeEvent_LiveEvent';
  /** The course that the live event is in */
  course: Course_Course;
  /** URL to the course home of the learner experience */
  courseUrl: Scalars['String'];
  /** When the event ends */
  endTime: Scalars['DateTime'];
  /** URL to join the event */
  eventUrl: Scalars['String'];
  /** The live event id */
  id: Scalars['ID'];
  /** If the event should be dismissed from view */
  isDismissed: Scalars['Boolean'];
  /** When the event starts */
  startTime: Scalars['DateTime'];
  /** Title of the event */
  title: Scalars['String'];
};

/** The association type when the event is associated with a term */
export type DegreeEvent_TermAssociation = {
  __typename?: 'DegreeEvent_TermAssociation';
  /** The term id */
  id: Scalars['ID'];
};

/** All DegreeHome queries */
export type DegreeHomeQueries = {
  __typename?: 'DegreeHomeQueries';
  /**
   * Query a learner's course states within a degree program by user ID and degree ID.
   * Returns the courses the learner has passed, is in progress on, and has not started.
   */
  degreeLearnerCourseStatesByUserIdAndDegreeId?: Maybe<DegreeHome_DegreeLearnerCourseStates>;
};


/** All DegreeHome queries */
export type DegreeHomeQueriesDegreeLearnerCourseStatesByUserIdAndDegreeIdArgs = {
  degreeId: Scalars['ID'];
};

/** Common interface for all course state types within a degree curriculum. */
export type DegreeHome_CourseState = {
  /** The course associated with this state */
  course: Course_Course;
};

/**
 * Represents a learner's course states within a degree program.
 * This entity tracks which courses the learner has passed, is currently taking, or has not started.
 */
export type DegreeHome_DegreeLearnerCourseStates = {
  __typename?: 'DegreeHome_DegreeLearnerCourseStates';
  /** The degree the learner is enrolled in */
  degree: Degree_Degree;
  /** Unique identifier for this learner course states record (composite of userId~degreeId) */
  id: Scalars['ID'];
  /** List of courses the learner is currently taking */
  inProgress: Array<DegreeHome_InProgressCourseState>;
  /** List of courses the learner has not started yet */
  notStarted: Array<DegreeHome_NotStartedCourseState>;
  /** List of courses the learner has passed/completed */
  passed: Array<DegreeHome_PassedCourseState>;
};

/**
 * Represents a course that is currently in progress.
 * Contains progress-specific information such as session details.
 */
export type DegreeHome_InProgressCourseState = DegreeHome_CourseState & {
  __typename?: 'DegreeHome_InProgressCourseState';
  /** The ID of the active session the learner is enrolled in */
  activeSessionId: Scalars['ID'];
  /** The course associated with this state */
  course: Course_Course;
  /** Whether there is an enrollable session available for this course */
  hasEnrollableSession: Scalars['Boolean'];
};

/** Represents a course that the learner has not started yet. */
export type DegreeHome_NotStartedCourseState = DegreeHome_CourseState & {
  __typename?: 'DegreeHome_NotStartedCourseState';
  /**
   * The ID of the upcoming session the learner is pre-enrolled in, if any.
   * Only present when the learner has a session that hasn't started yet.
   */
  activeSessionId?: Maybe<Scalars['ID']>;
  /** The course associated with this state */
  course: Course_Course;
  /**
   * Whether there is an enrollable session available for this course.
   * Always false when activeSessionId is present (upcoming session takes priority).
   */
  hasEnrollableSession: Scalars['Boolean'];
};

/** Represents a course that the learner has passed/completed. */
export type DegreeHome_PassedCourseState = DegreeHome_CourseState & {
  __typename?: 'DegreeHome_PassedCourseState';
  /** The course associated with this state */
  course: Course_Course;
};

export type DegreeLearnerCourseStatesV1 = {
  __typename?: 'DegreeLearnerCourseStatesV1';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
  id: Scalars['String'];
  inProgress: Array<Maybe<DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_DegreeCourseState>>;
  notStarted: Array<Maybe<DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_DegreeCourseState>>;
  passed: Array<Maybe<DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_DegreeCourseState>>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type DegreeLearnerCourseStatesV1Connection = {
  __typename?: 'DegreeLearnerCourseStatesV1Connection';
  elements: Array<Maybe<DegreeLearnerCourseStatesV1>>;
  paging: ResponsePagination;
};

export type DegreeLearnerCourseStatesV1Resource = {
  __typename?: 'DegreeLearnerCourseStatesV1Resource';
  get?: Maybe<DegreeLearnerCourseStatesV1>;
  multiGet?: Maybe<DegreeLearnerCourseStatesV1Connection>;
};


export type DegreeLearnerCourseStatesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreeLearnerCourseStatesV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeLearnerCourseStatesV1_CourseProgressState = DegreeLearnerCourseStatesV1_InProgressMember | DegreeLearnerCourseStatesV1_NotStartedMember | DegreeLearnerCourseStatesV1_PassedMember;

export type DegreeLearnerCourseStatesV1_InProgressMember = {
  __typename?: 'DegreeLearnerCourseStatesV1_inProgressMember';
  inProgress: DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CourseInProgressProgressState;
};

export type DegreeLearnerCourseStatesV1_NotStartedMember = {
  __typename?: 'DegreeLearnerCourseStatesV1_notStartedMember';
  notStarted: DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CourseNotStartedProgressState;
};

export type DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_DegreeCourseState = {
  __typename?: 'DegreeLearnerCourseStatesV1_org_coursera_degree_curriculum_DegreeCourseState';
  courseProgressState: DegreeLearnerCourseStatesV1_CourseProgressState;
  id: Scalars['String'];
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export type DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CourseInProgressProgressState = {
  __typename?: 'DegreeLearnerCourseStatesV1_org_coursera_degree_curriculum_progressState_CourseInProgressProgressState';
  activeSessionId?: Maybe<Scalars['String']>;
  hasEnrollableSession: Scalars['Boolean'];
};

export type DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CourseNotStartedProgressState = {
  __typename?: 'DegreeLearnerCourseStatesV1_org_coursera_degree_curriculum_progressState_CourseNotStartedProgressState';
  activeSessionId?: Maybe<Scalars['String']>;
  hasEnrollableSession: Scalars['Boolean'];
};

export type DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CoursePassedProgressState = {
  __typename?: 'DegreeLearnerCourseStatesV1_org_coursera_degree_curriculum_progressState_CoursePassedProgressState';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerCourseStatesV1_PassedMember = {
  __typename?: 'DegreeLearnerCourseStatesV1_passedMember';
  passed: DegreeLearnerCourseStatesV1_Org_Coursera_Degree_Curriculum_ProgressState_CoursePassedProgressState;
};

export type DegreeLearnerMembershipsV1 = {
  __typename?: 'DegreeLearnerMembershipsV1';
  createdAt: Scalars['Float'];
  degree?: Maybe<DegreesV1>;
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
  degreeIds?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  role: DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole;
  user?: Maybe<UsersV1>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
  userIds?: Maybe<Scalars['JSON']>;
};


export type DegreeLearnerMembershipsV1UserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DegreeLearnerMembershipsV1AllByDegree = {
  __typename?: 'DegreeLearnerMembershipsV1AllByDegree';
  connection?: Maybe<DegreeLearnerMembershipsV1Connection>;
  degreeId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type DegreeLearnerMembershipsV1ByDegree = {
  __typename?: 'DegreeLearnerMembershipsV1ByDegree';
  connection?: Maybe<DegreeLearnerMembershipsV1Connection>;
  degreeId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type DegreeLearnerMembershipsV1ByDegreeAndRole = {
  __typename?: 'DegreeLearnerMembershipsV1ByDegreeAndRole';
  connection?: Maybe<DegreeLearnerMembershipsV1Connection>;
  degreeId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  role: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type DegreeLearnerMembershipsV1ByUser = {
  __typename?: 'DegreeLearnerMembershipsV1ByUser';
  connection?: Maybe<DegreeLearnerMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type DegreeLearnerMembershipsV1Connection = {
  __typename?: 'DegreeLearnerMembershipsV1Connection';
  elements: Array<Maybe<DegreeLearnerMembershipsV1>>;
  paging: ResponsePagination;
};

export type DegreeLearnerMembershipsV1Resource = {
  __typename?: 'DegreeLearnerMembershipsV1Resource';
  allByDegree?: Maybe<DegreeLearnerMembershipsV1Connection>;
  byDegree?: Maybe<DegreeLearnerMembershipsV1Connection>;
  byDegreeAndRole?: Maybe<DegreeLearnerMembershipsV1Connection>;
  byUser?: Maybe<DegreeLearnerMembershipsV1Connection>;
  get?: Maybe<DegreeLearnerMembershipsV1>;
  multiGet?: Maybe<DegreeLearnerMembershipsV1Connection>;
};


export type DegreeLearnerMembershipsV1ResourceAllByDegreeArgs = {
  degreeId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreeLearnerMembershipsV1ResourceByDegreeArgs = {
  degreeId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreeLearnerMembershipsV1ResourceByDegreeAndRoleArgs = {
  degreeId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  role: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type DegreeLearnerMembershipsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type DegreeLearnerMembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreeLearnerMembershipsV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeLearnerMembershipsV1ResourceMutations = {
  __typename?: 'DegreeLearnerMembershipsV1ResourceMutations';
  create?: Maybe<DegreeLearnerMembershipsV1Connection>;
  delete?: Maybe<DegreeLearnerMembershipsV1Connection>;
  hardDelete?: Maybe<Scalars['JSON']>;
  removeAllByDegree?: Maybe<Scalars['JSON']>;
};


export type DegreeLearnerMembershipsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type DegreeLearnerMembershipsV1ResourceMutationsHardDeleteArgs = {
  id: Scalars['String'];
};


export type DegreeLearnerMembershipsV1ResourceMutationsRemoveAllByDegreeArgs = {
  degreeId: Scalars['String'];
};

/** Degree roles that are assignable to learners. */
export const DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole = {
  DeletedLearner: 'DELETED_LEARNER',
  Learner: 'LEARNER'
} as const;

export type DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole = typeof DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole[keyof typeof DegreeLearnerMembershipsV1_Org_Coursera_Degree_DegreeRole];
export type DegreeLearnerProgressesV1 = {
  __typename?: 'DegreeLearnerProgressesV1';
  courseIds?: Maybe<Scalars['JSON']>;
  courses?: Maybe<CoursesV1>;
  degreeIds?: Maybe<Scalars['JSON']>;
  degrees?: Maybe<DegreesV1>;
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  endTime: Scalars['Float'];
  id: Scalars['String'];
  learningSequenceElements: Array<Maybe<DegreeLearnerProgressesV1_CourseMember>>;
  membershipId: DegreeLearnerProgressesV1_Org_Coursera_Degree_Stored_DegreeMembershipId;
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  startTime: Scalars['Float'];
  timeCommitment: Scalars['Float'];
  userIds?: Maybe<Scalars['JSON']>;
  users?: Maybe<UsersV1>;
};


export type DegreeLearnerProgressesV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type DegreeLearnerProgressesV1UsersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type DegreeLearnerProgressesV1Connection = {
  __typename?: 'DegreeLearnerProgressesV1Connection';
  elements: Array<Maybe<DegreeLearnerProgressesV1>>;
  paging: ResponsePagination;
};

export type DegreeLearnerProgressesV1Resource = {
  __typename?: 'DegreeLearnerProgressesV1Resource';
  get?: Maybe<DegreeLearnerProgressesV1>;
  multiGet?: Maybe<DegreeLearnerProgressesV1Connection>;
};


export type DegreeLearnerProgressesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreeLearnerProgressesV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_ClosedPeerReviewItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_ClosedPeerReviewItemProgressMember';
  /** Data tracking a particular user's progress on a closed peer review item. */
  ClosedPeerReviewItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_ClosedPeerReviewItemProgress;
};

export type DegreeLearnerProgressesV1_GradedDiscussionPromptProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_GradedDiscussionPromptProgressMember';
  GradedDiscussionPromptProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_GradedDiscussionPromptProgress;
};

export type DegreeLearnerProgressesV1_GradedPeerReviewItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_GradedPeerReviewItemProgressMember';
  GradedPeerReviewItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_GradedPeerReviewItemProgress;
};

export type DegreeLearnerProgressesV1_LtiProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_LtiProgressMember';
  LtiProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_LtiProgress;
};

export type DegreeLearnerProgressesV1_PeerReviewItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_PeerReviewItemProgressMember';
  PeerReviewItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_PeerReviewItemProgress;
};

export type DegreeLearnerProgressesV1_PhasedPeerReviewItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_PhasedPeerReviewItemProgressMember';
  PhasedPeerReviewItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_PhasedPeerReviewItemProgress;
};

export type DegreeLearnerProgressesV1_ProgrammingItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_ProgrammingItemProgressMember';
  ProgrammingItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_LegacyProgrammingProgressContent;
};

export type DegreeLearnerProgressesV1_QuizItemProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_QuizItemProgressMember';
  QuizItemProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_QuizItemProgress;
};

export type DegreeLearnerProgressesV1_StaffGradedProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_StaffGradedProgressMember';
  StaffGradedProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_StaffGradedProgress;
};

export type DegreeLearnerProgressesV1_TeammateReviewProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_TeammateReviewProgressMember';
  TeammateReviewProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_TeammateReviewProgress;
};

export type DegreeLearnerProgressesV1_WiseFlowProgressMember = {
  __typename?: 'DegreeLearnerProgressesV1_WiseFlowProgressMember';
  WiseFlowProgress: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_WiseFlowProgress;
};

export type DegreeLearnerProgressesV1_AssessOpenSinglePageMember = {
  __typename?: 'DegreeLearnerProgressesV1_assessOpenSinglePageMember';
  assessOpenSinglePage: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type DegreeLearnerProgressesV1_ClosedPeerMember = {
  __typename?: 'DegreeLearnerProgressesV1_closedPeerMember';
  closedPeer: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type DegreeLearnerProgressesV1_CompoundLatePenaltyMember = {
  __typename?: 'DegreeLearnerProgressesV1_compoundLatePenaltyMember';
  compoundLatePenalty: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type DegreeLearnerProgressesV1_CompoundLatePenaltyRatioMember = {
  __typename?: 'DegreeLearnerProgressesV1_compoundLatePenaltyRatioMember';
  compoundLatePenaltyRatio: DegreeLearnerProgressesV1_Org_Coursera_Grading_CompoundLatePenaltyRatio;
};

/** Computed outcome of items. */
export type DegreeLearnerProgressesV1_ComputedOutcome = DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_NotGradedItemOutcomeMember | DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_OutcomeMember;

export type DegreeLearnerProgressesV1_Content = DegreeLearnerProgressesV1_ClosedPeerReviewItemProgressMember | DegreeLearnerProgressesV1_GradedDiscussionPromptProgressMember | DegreeLearnerProgressesV1_GradedPeerReviewItemProgressMember | DegreeLearnerProgressesV1_LtiProgressMember | DegreeLearnerProgressesV1_PeerReviewItemProgressMember | DegreeLearnerProgressesV1_PhasedPeerReviewItemProgressMember | DegreeLearnerProgressesV1_ProgrammingItemProgressMember | DegreeLearnerProgressesV1_QuizItemProgressMember | DegreeLearnerProgressesV1_StaffGradedProgressMember | DegreeLearnerProgressesV1_TeammateReviewProgressMember | DegreeLearnerProgressesV1_WiseFlowProgressMember;

export type DegreeLearnerProgressesV1_ContentSummary = DegreeLearnerProgressesV1_AssessOpenSinglePageMember | DegreeLearnerProgressesV1_ClosedPeerMember | DegreeLearnerProgressesV1_DiscussionPromptMember | DegreeLearnerProgressesV1_ExamMember | DegreeLearnerProgressesV1_GradedDiscussionPromptMember | DegreeLearnerProgressesV1_GradedLtiMember | DegreeLearnerProgressesV1_GradedPeerMember | DegreeLearnerProgressesV1_GradedProgrammingMember | DegreeLearnerProgressesV1_GradedWidgetMember | DegreeLearnerProgressesV1_LectureMember | DegreeLearnerProgressesV1_NotebookMember | DegreeLearnerProgressesV1_PeerMember | DegreeLearnerProgressesV1_PhasedPeerMember | DegreeLearnerProgressesV1_PlaceholderMember | DegreeLearnerProgressesV1_ProgrammingMember | DegreeLearnerProgressesV1_QuizMember | DegreeLearnerProgressesV1_SingleQuestionSubmitMember | DegreeLearnerProgressesV1_SlideshowMember | DegreeLearnerProgressesV1_StaffGradedMember | DegreeLearnerProgressesV1_SupplementMember | DegreeLearnerProgressesV1_TeammateReviewMember | DegreeLearnerProgressesV1_UngradedAssignmentMember | DegreeLearnerProgressesV1_UngradedLabMember | DegreeLearnerProgressesV1_UngradedLtiMember | DegreeLearnerProgressesV1_UngradedProgrammingMember | DegreeLearnerProgressesV1_UngradedWidgetMember | DegreeLearnerProgressesV1_WiseFlowMember | DegreeLearnerProgressesV1_WorkspaceLauncherMember;

export type DegreeLearnerProgressesV1_CourseMember = {
  __typename?: 'DegreeLearnerProgressesV1_courseMember';
  course: DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_Sequence_Course;
};

export type DegreeLearnerProgressesV1_DiscussionPromptMember = {
  __typename?: 'DegreeLearnerProgressesV1_discussionPromptMember';
  discussionPrompt: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type DegreeLearnerProgressesV1_ExamMember = {
  __typename?: 'DegreeLearnerProgressesV1_examMember';
  exam: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type DegreeLearnerProgressesV1_FixedGradingLatePenaltyMember = {
  __typename?: 'DegreeLearnerProgressesV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type DegreeLearnerProgressesV1_FixedLatePenaltyRatioMember = {
  __typename?: 'DegreeLearnerProgressesV1_fixedLatePenaltyRatioMember';
  fixedLatePenaltyRatio: DegreeLearnerProgressesV1_Org_Coursera_Grading_FixedLatePenaltyRatio;
};

export type DegreeLearnerProgressesV1_GradedDiscussionPromptMember = {
  __typename?: 'DegreeLearnerProgressesV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type DegreeLearnerProgressesV1_GradedLtiMember = {
  __typename?: 'DegreeLearnerProgressesV1_gradedLtiMember';
  gradedLti: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type DegreeLearnerProgressesV1_GradedPeerMember = {
  __typename?: 'DegreeLearnerProgressesV1_gradedPeerMember';
  gradedPeer: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type DegreeLearnerProgressesV1_GradedProgrammingMember = {
  __typename?: 'DegreeLearnerProgressesV1_gradedProgrammingMember';
  gradedProgramming: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type DegreeLearnerProgressesV1_GradedWidgetMember = {
  __typename?: 'DegreeLearnerProgressesV1_gradedWidgetMember';
  gradedWidget: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type DegreeLearnerProgressesV1_GradingLatePenalty = DegreeLearnerProgressesV1_CompoundLatePenaltyMember | DegreeLearnerProgressesV1_FixedGradingLatePenaltyMember | DegreeLearnerProgressesV1_IncrementalGradingLatePenaltyMember;

export type DegreeLearnerProgressesV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'DegreeLearnerProgressesV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type DegreeLearnerProgressesV1_IncrementalLatePenaltyRatioMember = {
  __typename?: 'DegreeLearnerProgressesV1_incrementalLatePenaltyRatioMember';
  incrementalLatePenaltyRatio: DegreeLearnerProgressesV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio;
};

export type DegreeLearnerProgressesV1_LatePenaltyRatio = DegreeLearnerProgressesV1_CompoundLatePenaltyRatioMember | DegreeLearnerProgressesV1_FixedLatePenaltyRatioMember | DegreeLearnerProgressesV1_IncrementalLatePenaltyRatioMember;

export type DegreeLearnerProgressesV1_LectureMember = {
  __typename?: 'DegreeLearnerProgressesV1_lectureMember';
  lecture: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

export type DegreeLearnerProgressesV1_NotebookMember = {
  __typename?: 'DegreeLearnerProgressesV1_notebookMember';
  notebook: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export const DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature = typeof DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature];
export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_ComputedItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_ComputedItemProgress';
  content?: Maybe<DegreeLearnerProgressesV1_Content>;
  progressState: DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState;
};

export const DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState = {
  Completed: 'Completed',
  Failed: 'Failed',
  InReview: 'InReview',
  NotStarted: 'NotStarted',
  Optional: 'Optional',
  Started: 'Started'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState = typeof DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_DegreeItemProgressState];
/** State of an item. */
export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_ItemState = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_ItemState';
  computedOutcome: DegreeLearnerProgressesV1_ComputedOutcome;
  computedProgress: DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_ComputedItemProgress;
  contentSummary: DegreeLearnerProgressesV1_ContentSummary;
  deadline: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Learnermaterial_Common_Deadline;
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  timeCommitment: Scalars['Float'];
  typeName: Scalars['String'];
};

/** Shell model representing outcome of not gradable items. */
export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_NotGradedItemOutcome = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_NotGradedItemOutcome';
  computedAt: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_NotGradedItemOutcomeMember = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_NotGradedItemOutcomeMember';
  org_coursera_degree_learner_NotGradedItemOutcome: DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_NotGradedItemOutcome;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_Outcome = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_Outcome';
  computedAt: Scalars['Float'];
  grade: Scalars['Float'];
  isPassed: Scalars['Boolean'];
  latePenaltyRatio?: Maybe<DegreeLearnerProgressesV1_LatePenaltyRatio>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_OutcomeMember = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_OutcomeMember';
  org_coursera_degree_learner_Outcome: DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_Outcome;
};

/** A course element within the learning sequence. */
export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_Sequence_Course = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_learner_sequence_Course';
  id: Scalars['String'];
  itemStates: Array<Maybe<DegreeLearnerProgressesV1_Org_Coursera_Degree_Learner_ItemState>>;
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

/** Identifier for a degree membership. */
export type DegreeLearnerProgressesV1_Org_Coursera_Degree_Stored_DegreeMembershipId = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_degree_stored_DegreeMembershipId';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Grading_CompoundLatePenaltyRatio = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_grading_CompoundLatePenaltyRatio';
  penaltyContext: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
  ratio: Scalars['Float'];
  submissionDeadline: Scalars['Float'];
  submissionTime: Scalars['Float'];
};

/** Grade evaluation containing the scoring of the item submission. */
export type DegreeLearnerProgressesV1_Org_Coursera_Grading_Evaluation = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_grading_Evaluation';
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  score: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Grading_FixedLatePenaltyRatio = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_grading_FixedLatePenaltyRatio';
  ratio: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_grading_IncrementalLatePenaltyRatio';
  duration: Scalars['Float'];
  ratio: Scalars['Float'];
};

/** Enum to indicate to the platform the status of the user towards the activity's completion. It is up to the tool to determine the appropriate value for this enum. See spec for more details: https://www.imsglobal.org/spec/lti-ags/v2p0/#activityprogress */
export const DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus = {
  Completed: 'Completed',
  InProgress: 'InProgress',
  Initialized: 'Initialized',
  Started: 'Started',
  Submitted: 'Submitted'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus = typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus];
/** Enum to indicate to the platform the status of the grading process, including allowing to inform when human intervention is needed. It is up to the tool to determine the appropriate value for this enum. See spec for more details: https://www.imsglobal.org/spec/lti-ags/v2p0/#gradingprogress */
export const DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress = {
  Failed: 'Failed',
  FullyGraded: 'FullyGraded',
  NotReady: 'NotReady',
  Pending: 'Pending',
  PendingManual: 'PendingManual'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress = typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress];
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export const DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<DegreeLearnerProgressesV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<DegreeLearnerProgressesV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Learnermaterial_Common_Deadline = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_learnermaterial_common_Deadline';
  dueAt?: Maybe<Scalars['Float']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
};

/** Data tracking a particular user's progress on a closed peer review item. */
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_ClosedPeerReviewItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_ClosedPeerReviewItemProgress';
  evaluation?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Grading_Evaluation>;
  requiredReviewCount?: Maybe<Scalars['Int']>;
  reviewCount: Scalars['Int'];
  submitted: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_GradedDiscussionPromptProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_GradedDiscussionPromptProgress';
  gradingStartsAt: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_GradedPeerReviewItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_GradedPeerReviewItemProgress';
  evaluation?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Grading_Evaluation>;
  requiredReviewCount?: Maybe<Scalars['Int']>;
  reviewCount: Scalars['Int'];
  submitted: Scalars['Boolean'];
};

/** Only exists for backwards-compatibility with the few internal users who have this progress type. @note This model is intentionally left empty. */
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_LegacyProgrammingProgressContent = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_LegacyProgrammingProgressContent';
  ArbitraryField: Scalars['String'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_LtiProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_LtiProgress';
  activityProgressStatus: DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemActivityProgressStatus;
  gradingProgressStatus: DegreeLearnerProgressesV1_Org_Coursera_Lti_Ags_ItemGradingProgress;
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_PeerReviewItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_PeerReviewItemProgress';
  requiredReviewCount?: Maybe<Scalars['Int']>;
  reviewCount: Scalars['Int'];
  submitted: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_PhasedPeerReviewItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_PhasedPeerReviewItemProgress';
  evaluation?: Maybe<DegreeLearnerProgressesV1_Org_Coursera_Grading_Evaluation>;
  requiredReviewCount: Scalars['Int'];
  reviewCount: Scalars['Int'];
  submitted: Scalars['Boolean'];
};

/** Quiz performance information for users who have submitted a quiz. Clients can use this to display "6 of 7 questions correct" to provide more information than just a `ProgressState`. @note Subclass of [[org.coursera.ondemand.progress.ItemProgressContent]]. */
export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_QuizItemProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_QuizItemProgress';
  maxScore: Scalars['Float'];
  score: Scalars['Float'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_StaffGradedProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_StaffGradedProgress';
  submitted: Scalars['Boolean'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_TeammateReviewProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_TeammateReviewProgress';
  authoredReviewCount: Scalars['Int'];
  requiredReviewCount: Scalars['Int'];
};

export type DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Progress_WiseFlowProgress = {
  __typename?: 'DegreeLearnerProgressesV1_org_coursera_ondemand_progress_WiseFlowProgress';
  submittedAt?: Maybe<Scalars['Float']>;
};

export type DegreeLearnerProgressesV1_PeerMember = {
  __typename?: 'DegreeLearnerProgressesV1_peerMember';
  peer: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type DegreeLearnerProgressesV1_PhasedPeerMember = {
  __typename?: 'DegreeLearnerProgressesV1_phasedPeerMember';
  phasedPeer: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type DegreeLearnerProgressesV1_PlaceholderMember = {
  __typename?: 'DegreeLearnerProgressesV1_placeholderMember';
  placeholder: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type DegreeLearnerProgressesV1_ProgrammingMember = {
  __typename?: 'DegreeLearnerProgressesV1_programmingMember';
  programming: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type DegreeLearnerProgressesV1_QuizMember = {
  __typename?: 'DegreeLearnerProgressesV1_quizMember';
  quiz: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type DegreeLearnerProgressesV1_SingleQuestionSubmitMember = {
  __typename?: 'DegreeLearnerProgressesV1_singleQuestionSubmitMember';
  singleQuestionSubmit: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type DegreeLearnerProgressesV1_SlideshowMember = {
  __typename?: 'DegreeLearnerProgressesV1_slideshowMember';
  slideshow: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type DegreeLearnerProgressesV1_StaffGradedMember = {
  __typename?: 'DegreeLearnerProgressesV1_staffGradedMember';
  staffGraded: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type DegreeLearnerProgressesV1_SupplementMember = {
  __typename?: 'DegreeLearnerProgressesV1_supplementMember';
  supplement: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type DegreeLearnerProgressesV1_TeammateReviewMember = {
  __typename?: 'DegreeLearnerProgressesV1_teammateReviewMember';
  teammateReview: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type DegreeLearnerProgressesV1_UngradedAssignmentMember = {
  __typename?: 'DegreeLearnerProgressesV1_ungradedAssignmentMember';
  ungradedAssignment: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type DegreeLearnerProgressesV1_UngradedLabMember = {
  __typename?: 'DegreeLearnerProgressesV1_ungradedLabMember';
  ungradedLab: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type DegreeLearnerProgressesV1_UngradedLtiMember = {
  __typename?: 'DegreeLearnerProgressesV1_ungradedLtiMember';
  ungradedLti: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type DegreeLearnerProgressesV1_UngradedProgrammingMember = {
  __typename?: 'DegreeLearnerProgressesV1_ungradedProgrammingMember';
  ungradedProgramming: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type DegreeLearnerProgressesV1_UngradedWidgetMember = {
  __typename?: 'DegreeLearnerProgressesV1_ungradedWidgetMember';
  ungradedWidget: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type DegreeLearnerProgressesV1_WiseFlowMember = {
  __typename?: 'DegreeLearnerProgressesV1_wiseFlowMember';
  wiseFlow: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type DegreeLearnerProgressesV1_WorkspaceLauncherMember = {
  __typename?: 'DegreeLearnerProgressesV1_workspaceLauncherMember';
  workspaceLauncher: DegreeLearnerProgressesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export type DegreeListsV3 = {
  __typename?: 'DegreeListsV3';
  degreePartners?: Maybe<PartnersV1Connection>;
  degreeProducts: Array<Maybe<DegreeListsV3_Org_Coursera_Catalogp_Browse_DegreeProduct>>;
  id: Scalars['String'];
  mastertrackPartners?: Maybe<PartnersV1Connection>;
};


export type DegreeListsV3DegreePartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreeListsV3MastertrackPartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeListsV3Connection = {
  __typename?: 'DegreeListsV3Connection';
  elements: Array<Maybe<DegreeListsV3>>;
  paging: ResponsePagination;
};

export type DegreeListsV3GetList = {
  __typename?: 'DegreeListsV3GetList';
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  connection?: Maybe<DegreeListsV3Connection>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  productTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productVariants?: Maybe<Array<Maybe<Scalars['String']>>>;
  start?: Maybe<Scalars['String']>;
};

export type DegreeListsV3Resource = {
  __typename?: 'DegreeListsV3Resource';
  getList?: Maybe<DegreeListsV3Connection>;
};


export type DegreeListsV3ResourceGetListArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  productTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreeListsV3_CatalogDegreeMember = {
  __typename?: 'DegreeListsV3_catalogDegreeMember';
  /** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. Note that a [[CatalogDegree]], different from a [[org.coursera.degree.stored.api.Degree]], is STRICTLY A DEGREE. For Mastertracks, see [[CatalogMastertrack]]. */
  catalogDegree: DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogDegree;
};

export type DegreeListsV3_CatalogMastertrackMember = {
  __typename?: 'DegreeListsV3_catalogMastertrackMember';
  /** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. */
  catalogMastertrack: DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogMastertrack;
};

export type DegreeListsV3_Org_Coursera_Catalogp_Browse_DegreeProduct = DegreeListsV3_CatalogDegreeMember | DegreeListsV3_CatalogMastertrackMember;

/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
/** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. Note that a [[CatalogDegree]], different from a [[org.coursera.degree.stored.api.Degree]], is STRICTLY A DEGREE. For Mastertracks, see [[CatalogMastertrack]]. */
export type DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogDegree = {
  __typename?: 'DegreeListsV3_org_coursera_catalogp_degree_CatalogDegree';
  bannerImage?: Maybe<Scalars['String']>;
  blockedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  catalogAvailabilityStatus: DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus;
  degreeCategoryIds: Array<Maybe<Scalars['String']>>;
  degreeUpcomingTermDates?: Maybe<DegreeListsV3_Org_Coursera_Degreemarketing_Dates_DegreeUpcomingTermDates>;
  domainIds: Array<Maybe<Scalars['String']>>;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  languageCode: Scalars['String'];
  launchDate?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  marketingName: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  productVariant: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  shortName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  upsellCourseIds: Array<Maybe<Scalars['String']>>;
  upsellS12nIds: Array<Maybe<Scalars['String']>>;
};

/** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. */
export type DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogMastertrack = {
  __typename?: 'DegreeListsV3_org_coursera_catalogp_degree_CatalogMastertrack';
  bannerImage?: Maybe<Scalars['String']>;
  catalogAvailabilityStatus: DegreeListsV3_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus;
  domainIds: Array<Maybe<Scalars['String']>>;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  languageCode: Scalars['String'];
  launchDate?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  productVariant: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  shortName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  upsellCourseIds: Array<Maybe<Scalars['String']>>;
};

/** Includes different types of dates of a degree program. */
export type DegreeListsV3_Org_Coursera_Degreemarketing_Dates_DegreeUpcomingTermDates = {
  __typename?: 'DegreeListsV3_org_coursera_degreemarketing_dates_DegreeUpcomingTermDates';
  nextAcademicTermStartDate?: Maybe<Scalars['Float']>;
  nextAdmissionDeadlineDate?: Maybe<Scalars['Float']>;
  nextAdmissionStartDate?: Maybe<Scalars['Float']>;
  nextAdmissionSubtermDeadlineDate?: Maybe<Scalars['Float']>;
};

/** Degree program deadlines */
export type DegreeMarketing_Deadline = {
  __typename?: 'DegreeMarketing_Deadline';
  /** Admission start date */
  admissionStartDate?: Maybe<Scalars['Date']>;
  /** Application admission term name */
  applicationAdmissionTermName: Scalars['String'];
  /** Extended subterm deadline date */
  extendedSubtermDeadlineDate?: Maybe<Scalars['Date']>;
  /** Priority deadline date */
  priorityDeadlineDate?: Maybe<Scalars['Date']>;
  /** Secondary priority deadline date */
  secondaryPriorityDeadlineDate?: Maybe<Scalars['Date']>;
  /** Subterm deadline date */
  subtermDeadlineDate?: Maybe<Scalars['Date']>;
};

/** Generic upsell */
export type DegreeMarketing_GenericUpsellResponse = {
  __typename?: 'DegreeMarketing_GenericUpsellResponse';
  /** Created UTC timestamp */
  createdUtc: Scalars['String'];
  /** Deleted UTC timestamp (only for deleted items) */
  deletedUtc?: Maybe<Scalars['String']>;
  /** The id of the upsell */
  id: Scalars['ID'];
  /** Additional parameters in JSON format */
  paramsJson?: Maybe<Scalars['String']>;
  /** The product that upsells */
  source: Product;
  /** The product to upsell to */
  target: Product;
  /** Upsell type */
  upsellType: Scalars['String'];
};

/**
 * Degree marketing types.
 * The first use case is to support value first landing pages.
 */
export const DegreeMarketing_MarketingType = {
  /** Pathway degrees. */
  Pathway: 'PATHWAY'
} as const;

export type DegreeMarketing_MarketingType = typeof DegreeMarketing_MarketingType[keyof typeof DegreeMarketing_MarketingType];
/** Partner that provides a degree */
export type DegreeMarketing_Partner = {
  __typename?: 'DegreeMarketing_Partner';
  /** Abbreviated name */
  abbrName?: Maybe<Scalars['String']>;
  /** The partner id */
  id: Scalars['ID'];
  /** Partner name */
  name: Scalars['String'];
  /** Square logo */
  squareLogo?: Maybe<Scalars['String']>;
};

/** Update input */
export type DegreeMarketing_UpdateCourseInput = {
  /** Id of the catalog degree course */
  id: Scalars['ID'];
  /** For Credit Non Degree flag */
  isForCreditNonDegree: Scalars['Boolean'];
};

/** Result of a catalog degree course mutation */
export type DegreeMarketing_UpdateCourseResult = {
  __typename?: 'DegreeMarketing_UpdateCourseResult';
  /** The catalog degree course */
  course?: Maybe<Course_Course>;
  /** The errors */
  errors?: Maybe<Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>>;
};

/** Filter accepted by the generic query */
export type DegreeMarketing_UpsellFilterRequest = {
  /** Return only upsells that were active at the given time */
  activeAtUtc?: InputMaybe<Scalars['String']>;
  /** Indicates weather to show deleted upsells too, it cancels the activeAtUtc flag */
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  /** The id of the product that upsells. If sourceId is present, source type must be present too */
  sourceId?: InputMaybe<Scalars['ID']>;
  /** The type of the product that upsells */
  sourceType?: InputMaybe<Scalars['String']>;
  /** The id of the product to upsell to. If targetId is present, source type must be present too */
  targetId?: InputMaybe<Scalars['ID']>;
  /** The type of the product to upsell to */
  targetType?: InputMaybe<Scalars['String']>;
  /** Upsell type */
  upsellType?: InputMaybe<Scalars['String']>;
};

/**
 * Average course star rating of a degree.
 * The numbers are calculated based on the courses that are part of the degree.
 */
export type DegreeMetadata_AverageCourseStarRating = {
  __typename?: 'DegreeMetadata_AverageCourseStarRating';
  /** Average star rating of all courses that are part of the degree. */
  averageStarRating: Scalars['Float'];
  /** Total review count of all courses that are part of the degree. */
  totalReviewCount: Scalars['Int'];
};

/** Fetch data for Pathways Upselling & Merchandising API (PUMA). */
export type DegreePathwaysMerchandisingQueries = {
  __typename?: 'DegreePathwaysMerchandisingQueries';
  /** Returns Degree Pathways Merchandising Modules for slot(s) */
  queryBySlots?: Maybe<DegreePathwaysMerchandising_ModulesPaginatedResult>;
};


/** Fetch data for Pathways Upselling & Merchandising API (PUMA). */
export type DegreePathwaysMerchandisingQueriesQueryBySlotsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  slots: Array<DegreePathwaysMerchandising_SlotInput>;
};

/**
 * This ID will be used by the FE to query Contentful (via CMS proxy) using an attribute-based query to
 * fetch the correct copy that will be used to populate this merchandising module component.
 */
export type DegreePathwaysMerchandising_ContentfulAttributeId = {
  __typename?: 'DegreePathwaysMerchandising_ContentfulAttributeId';
  /** The Contentful Attribute ID */
  contentfulAttributeId: Scalars['ID'];
};

/** Union of types for Degree Pathways Merchandising Copy information */
export type DegreePathwaysMerchandising_Copy = DegreePathwaysMerchandising_ContentfulAttributeId;

/** Slot Input for IN_COURSE_EXPERIENCE_COMPLETION_STATE Slot */
export type DegreePathwaysMerchandising_InCourseExperienceCompletionStateInput = {
  /** The ID of the course being taken. */
  courseId: Scalars['ID'];
  /** The ID of the specialization that the course being taken is part of. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** Slot Input for IN_COURSE_EXPERIENCE_UPSELL_NOTIFICATION Slot */
export type DegreePathwaysMerchandising_InCourseExperienceUpsellNotificationInput = {
  /** The ID of the course being taken. */
  courseId: Scalars['ID'];
  /** The ID of the specialization that the course being taken is part of. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** Slot Input for LIHP_MY_LEARNING_TAB Slot */
export type DegreePathwaysMerchandising_LoggedInHomePageMyLearningTabInput = {
  /** The IDs of the courses in the My Learning Tab */
  courseIds: Array<Scalars['ID']>;
  /** The IDs of the specializations in the My Learning Tab. */
  s12nIds: Array<Scalars['ID']>;
};

/** Slot Input for LIHP_PATHWAY_DEGREES_COLLECTION Slot */
export type DegreePathwaysMerchandising_LoggedInHomePagePathwayDegreesCollectionInput = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Slot Input for LIHP_STACKABLE_PATHWAY_CONTENT_COLLECTION Slot */
export type DegreePathwaysMerchandising_LoggedInHomePageStackablePathwayContentCollectionInput = {
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** A Degree Pathways Merchandising Module */
export type DegreePathwaysMerchandising_Module = {
  __typename?: 'DegreePathwaysMerchandising_Module';
  /** The copy, a.k.a. what to display for the module. */
  copy: DegreePathwaysMerchandising_Copy;
  /** The pathway degrees for this pathways merchandising module. */
  pathwayDegrees?: Maybe<DegreePathwaysMerchandising_PathwayDegreesPaginatedResult>;
  /** Any presentational tags to let the FE know about how to display or style the module. */
  presentationalTags: Array<DegreePathwaysMerchandising_PresentationalTags>;
  /** The slot for which the degree pathways merchandising module is for. */
  slot: DegreePathwaysMerchandising_Slot;
};


/** A Degree Pathways Merchandising Module */
export type DegreePathwaysMerchandising_ModulePathwayDegreesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Paginated result type for DegreePathwaysMerchandising_Module */
export type DegreePathwaysMerchandising_ModulesPaginatedResult = {
  __typename?: 'DegreePathwaysMerchandising_ModulesPaginatedResult';
  /** List of elements in the page */
  elements: Array<DegreePathwaysMerchandising_Module>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Pathway Content Types */
export type DegreePathwaysMerchandising_PathwayContent = Course_Course | Specialization_Specialization;

/** A Pathway Degree */
export type DegreePathwaysMerchandising_PathwayDegree = {
  __typename?: 'DegreePathwaysMerchandising_PathwayDegree';
  /** Federated Degree entity */
  degree: Degree_Degree;
  /** List of upsells that upsell to this degree */
  upsells?: Maybe<DegreePathwaysMerchandising_UpsellsPaginatedResult>;
};


/** A Pathway Degree */
export type DegreePathwaysMerchandising_PathwayDegreeUpsellsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Paginated result type for DegreePathwaysMerchandising_PathwayDegree */
export type DegreePathwaysMerchandising_PathwayDegreesPaginatedResult = {
  __typename?: 'DegreePathwaysMerchandising_PathwayDegreesPaginatedResult';
  /** List of elements in the page */
  elements: Array<DegreePathwaysMerchandising_PathwayDegree>;
  /** Pagination metadata */
  pagination: Pagination;
};

/**
 * Presentational Tags that let the FE know of any special styling that should
 * be done for the Degree Pathways merchandising module
 */
export const DegreePathwaysMerchandising_PresentationalTags = {
  /** Featured Visual Treatment */
  Featured: 'FEATURED',
  /** With Expression of Interest */
  WithEoi: 'WITH_EOI'
} as const;

export type DegreePathwaysMerchandising_PresentationalTags = typeof DegreePathwaysMerchandising_PresentationalTags[keyof typeof DegreePathwaysMerchandising_PresentationalTags];
/** Slots on Coursera of which we merchandise Degree Pathways */
export const DegreePathwaysMerchandising_Slot = {
  /** The completion state upsell on the LEX / in course experience */
  InCourseExperienceCompletionState: 'IN_COURSE_EXPERIENCE_COMPLETION_STATE',
  /** The upsell banner/notification on the LEX / in course experience */
  InCourseExperienceUpsellNotification: 'IN_COURSE_EXPERIENCE_UPSELL_NOTIFICATION',
  /**
   * The stackability module that is underneath course cards in the LIHP My Learning Tab
   * 'In Progress' and 'Completed'
   */
  LihpMyLearningTab: 'LIHP_MY_LEARNING_TAB',
  /** A collection of Pathway Degrees on the LIHP */
  LihpPathwayDegreesCollection: 'LIHP_PATHWAY_DEGREES_COLLECTION',
  /** A collection of stackable pathway content on the LIHP */
  LihpStackablePathwayContentCollection: 'LIHP_STACKABLE_PATHWAY_CONTENT_COLLECTION'
} as const;

export type DegreePathwaysMerchandising_Slot = typeof DegreePathwaysMerchandising_Slot[keyof typeof DegreePathwaysMerchandising_Slot];
/** Slot Inputs. One for each slot on Coursera of which we merchandise Degree Pathways using PUMA */
export type DegreePathwaysMerchandising_SlotInput = {
  /** Get Degree Pathways Merchandising Modules for the Learner Experience Complete State Module. */
  inCourseExperienceCompletionState?: InputMaybe<DegreePathwaysMerchandising_InCourseExperienceCompletionStateInput>;
  /** Get Degree Pathways Merchandising Modules for the Learner Experience Upsell Banner. */
  inCourseExperienceUpsellNotification?: InputMaybe<DegreePathwaysMerchandising_InCourseExperienceUpsellNotificationInput>;
  /** Get Degree Pathways Merchandising Modules for LIHP My Learning Tab */
  loggedInHomePageMyLearningTab?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePageMyLearningTabInput>;
  /** Get Degree Pathways Merchandising Modules for the LIHP Pathway Degrees Collection Slot. */
  loggedInHomePagePathwayDegreesCollection?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePagePathwayDegreesCollectionInput>;
  /** Get Degree Pathways Merchandising Modules for the LIHP Stackable Content Collection Slot. */
  loggedInHomePageStackablePathwayContentCollection?: InputMaybe<DegreePathwaysMerchandising_LoggedInHomePageStackablePathwayContentCollectionInput>;
};

/** An upsell for a Pathway Degree */
export type DegreePathwaysMerchandising_Upsell = {
  __typename?: 'DegreePathwaysMerchandising_Upsell';
  /**
   * Source of the upsell
   * @deprecated Use upsellContent instead.
   */
  pathwayContent: DegreePathwaysMerchandising_PathwayContent;
  /** Upsell content */
  upsellContent: DegreePathwaysMerchandising_UpsellContent;
  /**
   * Type of Upsell
   * @deprecated Use upsellContent instead.
   */
  upsellType: DegreePathwaysMerchandising_UpsellType;
};

/** Upsell Content Types */
export type DegreePathwaysMerchandising_UpsellContent = Pathways_TargetDegreeForCourse | Pathways_TargetDegreeForMasterTrack | Pathways_TargetDegreeForSpecialization;

/** Upsell relation types */
export const DegreePathwaysMerchandising_UpsellType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type DegreePathwaysMerchandising_UpsellType = typeof DegreePathwaysMerchandising_UpsellType[keyof typeof DegreePathwaysMerchandising_UpsellType];
/** Paginated list of upsells */
export type DegreePathwaysMerchandising_UpsellsPaginatedResult = {
  __typename?: 'DegreePathwaysMerchandising_UpsellsPaginatedResult';
  /** List of elements in the page */
  elements: Array<DegreePathwaysMerchandising_Upsell>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** An academic term for a degree. */
export type DegreePlan_AcademicTerm = {
  __typename?: 'DegreePlan_AcademicTerm';
  /** End date of the academic term */
  endDate: Scalars['DateTime'];
  /** The events tied to the academic term, optional */
  events?: Maybe<Array<DegreeEvent_AcademicEvent>>;
  /** Unique ID of the academic term */
  id: Scalars['ID'];
  /** Partner representation of the term name, used for display purposes */
  partnerTermName: Scalars['String'];
  /** Start date of the academic term */
  startDate: Scalars['DateTime'];
};

/** Paginated Academic Terms */
export type DegreePlan_AcademicTermsPaginatedResult = {
  __typename?: 'DegreePlan_AcademicTermsPaginatedResult';
  /** Ordered sequence of academic terms */
  elements: Array<DegreePlan_EstimatedAcademicTerm>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** A category can contain multiple segments. Used as a top level grouping object */
export type DegreePlan_Category = {
  __typename?: 'DegreePlan_Category';
  /** The condition a learner must fulfill to complete the course */
  completionRule: DegreePlan_CompletionRule;
  /** Optional description of this category */
  description?: Maybe<Scalars['String']>;
  /** Category id */
  id: Scalars['ID'];
  /**
   * Optional minimum passing GPA for all courses underneath this group. Overrides the minGpa field
   * set in curriculum
   */
  minGpa?: Maybe<Scalars['Float']>;
  /**
   * Optional minimum passing grade for all courses underneath this group. Overrides the
   * minPassingGradeForCourses field set in curriculum
   */
  minPassingGradeForCourses?: Maybe<Scalars['Int']>;
  /** List of segments under this category */
  segments: Array<DegreePlan_Segment>;
  /** Optional title */
  title?: Maybe<Scalars['String']>;
};

/** A condition for a learner to fulfill to achieve completion of a grouping of courses or segments */
export type DegreePlan_CompletionRule = {
  __typename?: 'DegreePlan_CompletionRule';
  /** The minimum amount of credits/segments to complete */
  minUnits: Scalars['Int'];
  /** Represents the rule the learner must complete to pass the grouping type */
  type: DegreePlan_CompletionRuleType;
};

/** The rule the learner must complete to pass the grouping type */
export const DegreePlan_CompletionRuleType = {
  /** The learner must complete x of y credits in this segment */
  Credit: 'CREDIT',
  /** The enum value for the invalid completion rule types */
  Invalid: 'INVALID',
  /** The learner must complete x of y segments in this category */
  Segment: 'SEGMENT'
} as const;

export type DegreePlan_CompletionRuleType = typeof DegreePlan_CompletionRuleType[keyof typeof DegreePlan_CompletionRuleType];
/** The course with institution information */
export type DegreePlan_Course = {
  __typename?: 'DegreePlan_Course';
  /**
   * The Coursera course
   * @deprecated need to make this field optional
   */
  course: Course_Course;
  /** Institution given degree course code, e.g. Math 101 */
  courseCode: Scalars['String'];
  /** Institution given degree course name, e.g. Fundamentals of Calculus. This may be similar or identical to the Course_Course name. In the case where they are both available, the canonical Course_Course name is preferred. */
  courseName: Scalars['String'];
  /** Courses can be taken on or off platform. If on-platform and the course has been created, this is the associated Coursera course with this Degree Plan Course. */
  courseraCourse?: Maybe<Course_Course>;
  /** Indicates if a course is public and live to determine if course has a "stackable" version */
  isPublicLiveCourse: Scalars['Boolean'];
};

/** A curriculum under a degree. */
export type DegreePlan_Curriculum = DegreePlan_DegreeCurriculum | DegreePlan_PbaCurriculum;

/** Contains the curriculum of the learner, as well as the learner's enrollment status */
export type DegreePlan_CurriculumResult = {
  __typename?: 'DegreePlan_CurriculumResult';
  /** Degree curriculum */
  curriculums: Array<DegreePlan_Curriculum>;
  /** An enum detailing the learner's admission status in the degree */
  learnerAdmissionStatus: DegreePlan_LearnerAdmissionStatus;
};

/**
 * The main curriculum of a single degree that defines graduation requirements. This is in contrast
 * to a performance-based admission curriculum that guarantees admission to the program.
 */
export type DegreePlan_DegreeCurriculum = {
  __typename?: 'DegreePlan_DegreeCurriculum';
  /** A list categories underneath this curriculum object. */
  categories: Array<DegreePlan_Category>;
  /** Optional description */
  description?: Maybe<Scalars['String']>;
  /** Enrollment URL for course enrollments on the partner's end */
  enrollmentUrl?: Maybe<Scalars['URL']>;
  /** Curriculum id */
  id: Scalars['ID'];
  /** Minimum required credits to complete this curriculum */
  minCredits: Scalars['Int'];
  /** Minimum passing GPA for all courses underneath this curriculum */
  minGpa: Scalars['Float'];
  /** Minimum passing grade for all courses underneath this curriculum */
  minPassingGradeForCourses: Scalars['Int'];
  /** Optional title */
  title?: Maybe<Scalars['String']>;
};

/** Estimated Academic Term in the degree */
export type DegreePlan_EstimatedAcademicTerm = DegreePlan_EstimatedTerm & {
  __typename?: 'DegreePlan_EstimatedAcademicTerm';
  /**
   * Courses offered in the term
   * @deprecated   courseOfferingsPaginated is deprecated in academicTermsPaginated. Use top-level
   * courseOfferingsPaginated instead.
   */
  courseOfferingsPaginated?: Maybe<DegreePlan_SegmentCoursesPaginatedResult>;
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** Name of the estimated term */
  estimatedTermName: Scalars['String'];
  /** the term exceeds the time the learner is allowed to graduate. */
  exceedsTimeAllowed: Scalars['Boolean'];
  /** Linked external term Id */
  linkedTerm?: Maybe<DegreePlan_AcademicTerm>;
};


/** Estimated Academic Term in the degree */
export type DegreePlan_EstimatedAcademicTermCourseOfferingsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** Interface for Estimated Term for a degree */
export type DegreePlan_EstimatedTerm = {
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** Name of the term */
  estimatedTermName: Scalars['String'];
  /** Linked external Term, optional */
  linkedTerm?: Maybe<DegreePlan_AcademicTerm>;
};

/** The learner's admission type */
export const DegreePlan_LearnerAdmissionStatus = {
  /** The learner is enrolled in the degree directly */
  Degree: 'DEGREE',
  /**
   * FCND stands for "for credit non degree". The learner is not enrolled in the degree, and not in a
   * PBA course, but is taking "for credit non degree" courses
   */
  FcndNone: 'FCND_NONE',
  /** The learner is not enrolled in the degree, but is in a performance-based admission course */
  FcndPba: 'FCND_PBA',
  /** The learner is not enrolled in the degree, not in a PBA course, and is not taking FCND courses */
  NotEnrolled: 'NOT_ENROLLED',
  /** The learner is enrolled in the degree via performance-based admission */
  Pba: 'PBA'
} as const;

export type DegreePlan_LearnerAdmissionStatus = typeof DegreePlan_LearnerAdmissionStatus[keyof typeof DegreePlan_LearnerAdmissionStatus];
/** Learner progress for a specific segment and course */
export type DegreePlan_LearnerProgress = {
  __typename?: 'DegreePlan_LearnerProgress';
  /** Optional field for learner grade. Empty if course not completed or in progress */
  grade?: Maybe<Scalars['Float']>;
  /** Learner state for the course */
  state: DegreePlan_LearnerProgressState;
  /** An optional field showing which term the learner finished or is taking the course in */
  takenInTerm?: Maybe<DegreePlan_AcademicTerm>;
};

/** The learner state for a given segment course */
export const DegreePlan_LearnerProgressState = {
  /** The course is completed with a passing grade by the learner */
  Completed: 'COMPLETED',
  /** The course is in progress by the learner */
  InProgress: 'IN_PROGRESS',
  /** The course has not been started by the learner. Default option */
  NotStarted: 'NOT_STARTED',
  /** The course has been planned by the learner */
  Planned: 'PLANNED'
} as const;

export type DegreePlan_LearnerProgressState = typeof DegreePlan_LearnerProgressState[keyof typeof DegreePlan_LearnerProgressState];
/** An optional secondary curriculum of a single degree that defines performance-based admission requirements */
export type DegreePlan_PbaCurriculum = {
  __typename?: 'DegreePlan_PBACurriculum';
  /** A list categories underneath this curriculum object. */
  categories: Array<DegreePlan_Category>;
  /** Optional description */
  description?: Maybe<Scalars['String']>;
  /** Enrollment URL for course enrollments on the partner's end */
  enrollmentUrl?: Maybe<Scalars['URL']>;
  /** Curriculum id */
  id: Scalars['ID'];
  /** Minimum number of credits needed to pass this curriculum */
  minCredits: Scalars['Int'];
  /** Minimum passing GPA for all courses underneath this curriculum */
  minGpa: Scalars['Float'];
  /** Minimum passing grade for all courses underneath this curriculum */
  minPassingGradeForCourses: Scalars['Int'];
  /** Optional title */
  title?: Maybe<Scalars['String']>;
};

/** A segment course that contains the learner progress information */
export type DegreePlan_PersonalizedSegmentCourse = {
  __typename?: 'DegreePlan_PersonalizedSegmentCourse';
  /** Learner progress for the segment course */
  learnerProgress: DegreePlan_LearnerProgress;
  /** The segment course */
  segmentCourse: DegreePlan_SegmentCourse;
};

/** A segment course's prerequisite requirements */
export type DegreePlan_Prerequisite = {
  __typename?: 'DegreePlan_Prerequisite';
  /** The completion type of the prerequisite */
  completionType: DegreePlan_PrerequisiteCompletionType;
  /** The actual items for the prerequisite */
  prerequisiteItems: Array<DegreePlan_PrerequisiteItem>;
};

/** The completion type of the prerequisite */
export const DegreePlan_PrerequisiteCompletionType = {
  /** All courses or descendant prerequisites must be satisfied */
  All: 'ALL',
  /** At least one course or descendant prerequisite must be satisfied */
  Any: 'ANY'
} as const;

export type DegreePlan_PrerequisiteCompletionType = typeof DegreePlan_PrerequisiteCompletionType[keyof typeof DegreePlan_PrerequisiteCompletionType];
/**
 * One prerequisite item could be another DegreePlan_Prerequisite to allow more advanced
 * requirements, or just a DegreePlan_Course, this allows a simple requirement like: Course A requires
 * Course B OR Course C; or a more complex requirement like: Course A requires Course B AND any of
 * (Course C OR Course D)
 */
export type DegreePlan_PrerequisiteItem = DegreePlan_Course | DegreePlan_Prerequisite;

/** A segment can contain multiple courses. Used as a secondary level grouping object */
export type DegreePlan_Segment = {
  __typename?: 'DegreePlan_Segment';
  /** The condition a learner must fulfill to complete the course */
  completionRule: DegreePlan_CompletionRule;
  /** The courses under the segment along with learner progress in each one */
  courses: Array<DegreePlan_PersonalizedSegmentCourse>;
  /** Optional description of this category */
  description?: Maybe<Scalars['String']>;
  /** Segment id */
  id: Scalars['ID'];
  /** Optional title */
  title?: Maybe<Scalars['String']>;
};

/** A course underneath a segment */
export type DegreePlan_SegmentCourse = {
  __typename?: 'DegreePlan_SegmentCourse';
  /**
   * courses with unconfirmed availability, termAvailabilityPaginated parameter for such courses
   * would contain all possible terms till next X years.
   */
  availabilityUnconfirmed: Scalars['Boolean'];
  /** The course with institution information */
  course: DegreePlan_Course;
  /** Number of credits for this course under the segment */
  creditValue: Scalars['Int'];
  /** Unique id of the segment course */
  id: Scalars['ID'];
  /** The optional course prerequisite */
  prerequisite?: Maybe<DegreePlan_Prerequisite>;
  /**
   * An optional ordered list of the upcoming academic terms for this degree in which this course is
   * offered.
   * @deprecated   termAvailability is
   * deprecated. Use termAvailability paginated instead.
   */
  termAvailability?: Maybe<Array<DegreePlan_AcademicTerm>>;
  /**
   * An optional ordered list of the upcoming academic terms for this degree in which this course is
   * offered.
   */
  termAvailabilityPaginated?: Maybe<DegreePlan_AcademicTermsPaginatedResult>;
};


/** A course underneath a segment */
export type DegreePlan_SegmentCourseTermAvailabilityPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** Paginated Course Offerings */
export type DegreePlan_SegmentCoursesPaginatedResult = {
  __typename?: 'DegreePlan_SegmentCoursesPaginatedResult';
  /** Ordered sequence of academic terms */
  elements: Array<DegreePlan_SegmentCourse>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** The term template */
export type DegreePlan_TermTemplate = {
  __typename?: 'DegreePlan_TermTemplate';
  /** Unique ID of the term template */
  id: Scalars['ID'];
  /** The numerical order of the term in any given year. The first term to start in a year would be 1, the second would be 2, etc. */
  index: Scalars['Int'];
  /** The term name */
  name: Scalars['String'];
};

/** All Degree queries */
export type DegreeQueries = {
  __typename?: 'DegreeQueries';
  /** Query all degrees */
  queryAll?: Maybe<Degree_DegreePaginatedResult>;
  /** Query all degrees associated with a course */
  queryByCourseId?: Maybe<Degree_DegreePaginatedResult>;
  /** Query a degree using a degree id */
  queryById?: Maybe<Degree_Degree>;
  /** Query multiple degrees using a list of degree ids */
  queryByIds: Array<Degree_Degree>;
  /** Query all degrees associated with a partner */
  queryByPartnerId?: Maybe<Degree_DegreePaginatedResult>;
  /** Query a degree using a degree slug */
  queryBySlug?: Maybe<Degree_Degree>;
  /** Query all degrees associated with a specializaton */
  queryBySpecializationId?: Maybe<Degree_DegreePaginatedResult>;
};


/** All Degree queries */
export type DegreeQueriesQueryAllArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  internalLaunchType?: Degree_InternalLaunchType;
  limit?: Scalars['Int'];
};


/** All Degree queries */
export type DegreeQueriesQueryByCourseIdArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** All Degree queries */
export type DegreeQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** All Degree queries */
export type DegreeQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** All Degree queries */
export type DegreeQueriesQueryByPartnerIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  partnerId: Scalars['ID'];
};


/** All Degree queries */
export type DegreeQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};


/** All Degree queries */
export type DegreeQueriesQueryBySpecializationIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  specializationId: Scalars['ID'];
};

/** Queries for the Degree Webinars resource in the Degree Marketing Application */
export type DegreeWebinarFetchQueries = {
  __typename?: 'DegreeWebinarFetchQueries';
  /** get webinars */
  getWebinars?: Maybe<DegreeWebinar_DegreeWebinarResponse>;
};


/** Queries for the Degree Webinars resource in the Degree Marketing Application */
export type DegreeWebinarFetchQueriesGetWebinarsArgs = {
  queryInput?: InputMaybe<DegreeWebinar_QueryDegreeWebinars>;
};

/**
 * A Degree Webinar has information related to a webinar, including
 * a past or future date. If the webinar is in the past, it should
 * include a recording link, if it is in the future, it should include
 * a registration link.
 */
export type DegreeWebinar_DegreeWebinar = {
  __typename?: 'DegreeWebinar_DegreeWebinar';
  /** Degree Webinar Title */
  catalogDegree?: Maybe<PremiumProductCollections_LearningProduct>;
  /** Degree Webinar Title */
  cta?: Maybe<Scalars['String']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** Recording link if webinar has already occurred */
  recordingLink?: Maybe<Scalars['String']>;
  /** Registration link if webinar has not yet occurred */
  registerLink?: Maybe<Scalars['String']>;
  /** Time of webinar expressed in seconds since epoch */
  timestamp?: Maybe<Timestamp>;
  /** Degree Webinar Title */
  title?: Maybe<Scalars['String']>;
};

/** Response for queries */
export type DegreeWebinar_DegreeWebinarResponse = {
  __typename?: 'DegreeWebinar_DegreeWebinarResponse';
  /** some made up ID because the linter made me add it */
  id: Scalars['ID'];
  /** Past webinars sorted in reverse chronological order */
  pastWebinars: Array<Maybe<DegreeWebinar_DegreeWebinar>>;
  /** Upcoming webinars sorted in chronological order */
  upcomingWebinars: Array<Maybe<DegreeWebinar_DegreeWebinar>>;
};

/** Input values for degree webinar query */
export type DegreeWebinar_QueryDegreeWebinars = {
  /** A list of degree category ids. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of degree variants */
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Webinar status is one of PAST or UPCOMING */
  webinarStatus?: InputMaybe<Scalars['String']>;
};

/** Representation of a color */
export type Degree_Color = Degree_LinearGradient2Colors | Degree_RgbaColor;

/** Paginated list of courses that are part of the degree */
export type Degree_CoursePaginatedResult = {
  __typename?: 'Degree_CoursePaginatedResult';
  /** List of elements in the page */
  elements: Array<Course_Course>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Federated degree entity stub */
export type Degree_Degree = {
  __typename?: 'Degree_Degree';
  /**
   * The list of academic terms for the degree
   * @deprecated academicTerms is deprecated. Use academicTermsPaginated instead.
   */
  academicTerms: Array<DegreePlan_AcademicTerm>;
  /** The paginated list of academic terms for the degree */
  academicTermsPaginated?: Maybe<DegreePlan_AcademicTermsPaginatedResult>;
  /** Average star rating of courses that are part of this degree */
  averageCourseStarRating?: Maybe<DegreeMetadata_AverageCourseStarRating>;
  /** List of countries the learning item is blocked in */
  blockedCountries: Array<Scalars['String']>;
  /** Catalog availability status */
  catalogAvailabilityStatus: Scalars['String'];
  /** Categories such as BUSINESS or DATA_ANALYTICS */
  categoryIds: Array<Scalars['String']>;
  /** The course offerings for a provided term */
  courseOfferingsPaginated?: Maybe<DegreePlan_SegmentCoursesPaginatedResult>;
  /** Paginated list of courses that are part of the degree */
  courses?: Maybe<Degree_CoursePaginatedResult>;
  /** The degree curriculum for a learner */
  curriculum?: Maybe<DegreePlan_CurriculumResult>;
  /** The degree properties  specific to the DPM/CM experience */
  degreePlanProperties?: Maybe<DegreeConfig_Properties>;
  /** Description of the degree program */
  description: CmlContent;
  /** Domains that the product falls in, such as business */
  domainIds: Array<Scalars['String']>;
  /** A collection of all known upcoming degree-level events */
  events: Array<DegreeEvent_Event>;
  /** The GPA Grade scale used to map grades to GPA points for the degree */
  gradeScale: DegreeConfig_GradeScale;
  /** Background color for header */
  headerBackgroundColor: Degree_Color;
  /** Additional banner for the degree */
  headerImageUrl?: Maybe<Scalars['URL']>;
  /** DegreeId */
  id: Scalars['ID'];
  /** Type of launch this degree was intended to launch as e.g. TEST or REAL */
  internalLaunchType: Degree_InternalLaunchType;
  /** Language code of the learning product. */
  languageCode: Scalars['String'];
  /** Launch date of the learning product. */
  launchDate?: Maybe<Scalars['String']>;
  /** Locale in the format en, en-US, etc */
  locale?: Maybe<Scalars['String']>;
  /** Logo for the degree */
  logoUrl?: Maybe<Scalars['URL']>;
  /** Pathway properties if this is a MasterTrack */
  masterTrackPathwayProperties?: Maybe<Pathways_MasterTrackProperties>;
  /** User-visible name of the degree */
  name: Scalars['String'];
  /** The partners for the learning product. */
  partnerEntities: Array<Partner_Partner>;
  /** List of partners */
  partners: Array<Partner_Partner>;
  /** Pathway properties */
  pathwayProperties?: Maybe<Pathways_DegreeProperties>;
  /**
   * Indicator of whether this is a degree, MT, degree backed Professional Certificate or
   * OnCampusProgram
   */
  productVariant: Degree_ProductVariant;
  /** Program Deadlines */
  programDeadlines: Array<DegreeMarketing_Deadline>;
  /**
   * Used to support marketing materials. An example of a shortName would be "iMBA" for Illinois's
   * Master of Business Administration. This is not a slug.
   */
  shortName?: Maybe<Scalars['String']>;
  /** Sorted list of skills that the degree is tagged with */
  skillTags: Array<SkillsTags_SkillTag>;
  /** Short name used in URLs */
  slug: Scalars['String'];
  /** List of specializations that are part of the degree */
  specializations: Array<Specialization_Specialization>;
  /** Paginated list of courses that stack into this degree */
  stackingCourses?: Maybe<Pathways_StackingCourseResult>;
  /** List of specializations that stack into this degree */
  stackingSpecializations?: Maybe<Pathways_StackingSpecializationResult>;
  /** The student success attributes for a degree */
  studentSuccessAttributes?: Maybe<DegreeConfig_StudentSuccessAttributes>;
  /** Support email address for learners to reach out for help */
  supportEmailAddress: Scalars['String'];
  /** Support link for learners to go to for help */
  supportLink?: Maybe<Scalars['String']>;
  /** Tagline of the learning product. */
  tagline: Scalars['String'];
  /** The list of the term templates for the degree */
  termTemplates: Array<DegreePlan_TermTemplate>;
  /** Thumbnail for marketing */
  thumbnailUrl?: Maybe<Scalars['URL']>;
  /** Upcoming term dates for the learning product. */
  upcomingTermDates?: Maybe<PremiumProductCollections_UpcomingTermDates>;
};


/** Federated degree entity stub */
export type Degree_DegreeAcademicTermsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** Federated degree entity stub */
export type Degree_DegreeCourseOfferingsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  termMappingId: Scalars['ID'];
};


/** Federated degree entity stub */
export type Degree_DegreeCoursesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Federated degree entity stub */
export type Degree_DegreeCurriculumArgs = {
  userId: Scalars['ID'];
};


/** Federated degree entity stub */
export type Degree_DegreeStackingCoursesArgs = {
  paginationRequest?: InputMaybe<PaginationRequest>;
};


/** Federated degree entity stub */
export type Degree_DegreeStackingSpecializationsArgs = {
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** Paginated result type for Degree_Degree */
export type Degree_DegreePaginatedResult = {
  __typename?: 'Degree_DegreePaginatedResult';
  /** List of elements in the page */
  elements: Array<Degree_Degree>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Type of launch this degree was intended to launch as e.g. TEST or REAL */
export const Degree_InternalLaunchType = {
  /** A real launch intended to be publicly accessible by everyone */
  Real: 'REAL',
  /** Test launch only accessible to Courserians */
  Test: 'TEST'
} as const;

export type Degree_InternalLaunchType = typeof Degree_InternalLaunchType[keyof typeof Degree_InternalLaunchType];
/** Represents gradient transition between two colors */
export type Degree_LinearGradient2Colors = {
  __typename?: 'Degree_LinearGradient2Colors';
  /** First color of the gradient */
  color1: Degree_RgbaColor;
  /** Second color of the gradient */
  color2: Degree_RgbaColor;
};

/** Product variants of the degree program */
export const Degree_ProductVariant = {
  /** Variant for a Bachelor's degree */
  BachelorsDegree: 'BACHELORS_DEGREE',
  /** Variant for a Graduate Certificate */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Variant for a Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** Variant for a MasterTrack certificate */
  MasterTrack: 'MASTER_TRACK',
  /** Variant for an On-Campus Program */
  OnCampusProgram: 'ON_CAMPUS_PROGRAM',
  /** Variant for Postgraduate Diploma */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Variant for Professional Certificate Degree */
  ProfessionalCertificateDegree: 'PROFESSIONAL_CERTIFICATE_DEGREE',
  /** Variant for University Certificate */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Unknown or unimplemented variant */
  Unknown: 'UNKNOWN'
} as const;

export type Degree_ProductVariant = typeof Degree_ProductVariant[keyof typeof Degree_ProductVariant];
/** Color as defined with red, green, blue hues and alpha */
export type Degree_RgbaColor = {
  __typename?: 'Degree_RGBAColor';
  /** Transparency level of the color, the range is [0.0, 1.0] */
  alpha: Scalars['Float'];
  /** Level of blue color, the range is [0, 255] */
  blue: Scalars['Int'];
  /** Level of green color, the range is [0, 255] */
  green: Scalars['Int'];
  /** Hex code of the color, in the #rrggbbaa format */
  hexCode: Scalars['String'];
  /** Level of red color, the range is [0, 255] */
  red: Scalars['Int'];
};

export type DegreesV1 = {
  __typename?: 'DegreesV1';
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  degreeCategoryIds: Array<Maybe<Scalars['String']>>;
  description: DegreesV1_CmlMember;
  headerBackgroundColor: DegreesV1_HeaderBackgroundColor;
  headerImage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalLaunchType: DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  partners?: Maybe<PartnersV1Connection>;
  productVariant: Scalars['String'];
  s12nIds: Array<Maybe<Scalars['String']>>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  shortName?: Maybe<Scalars['String']>;
  slackSettings?: Maybe<DegreesV1_Org_Coursera_Degree_Stored_SlackSettings>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  supportEmailAddress: Scalars['String'];
  supportLink?: Maybe<Scalars['String']>;
};


export type DegreesV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type DegreesV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreesV1ByCourseId = {
  __typename?: 'DegreesV1ByCourseId';
  connection?: Maybe<DegreesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type DegreesV1ByPartnerId = {
  __typename?: 'DegreesV1ByPartnerId';
  connection?: Maybe<DegreesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type DegreesV1ByS12nId = {
  __typename?: 'DegreesV1ByS12nId';
  connection?: Maybe<DegreesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type DegreesV1BySlug = {
  __typename?: 'DegreesV1BySlug';
  connection?: Maybe<DegreesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type DegreesV1Connection = {
  __typename?: 'DegreesV1Connection';
  elements: Array<Maybe<DegreesV1>>;
  paging: ResponsePagination;
};

export type DegreesV1Resource = {
  __typename?: 'DegreesV1Resource';
  byCourseId?: Maybe<DegreesV1Connection>;
  byPartnerId?: Maybe<DegreesV1Connection>;
  byS12nId?: Maybe<DegreesV1Connection>;
  bySlug?: Maybe<DegreesV1Connection>;
  get?: Maybe<DegreesV1>;
  getAll?: Maybe<DegreesV1Connection>;
  multiGet?: Maybe<DegreesV1Connection>;
};


export type DegreesV1ResourceByCourseIdArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1ResourceByPartnerIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1ResourceByS12nIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DegreesV1ResourceGetAllArgs = {
  internalLaunchType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DegreesV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DegreesV1_CmlMember = {
  __typename?: 'DegreesV1_cmlMember';
  cml: DegreesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Representation of a color. */
export type DegreesV1_HeaderBackgroundColor = DegreesV1_LinearGradient2Member | DegreesV1_RgbaColorMember;

export type DegreesV1_LinearGradient2Member = {
  __typename?: 'DegreesV1_linearGradient2Member';
  linearGradient2: DegreesV1_Org_Coursera_Common_Ui_LinearGradient2;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type DegreesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'DegreesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<DegreesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type DegreesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'DegreesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<DegreesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type DegreesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'DegreesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: DegreesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type DegreesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'DegreesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** Represents gradient transition between two colors. */
export type DegreesV1_Org_Coursera_Common_Ui_LinearGradient2 = {
  __typename?: 'DegreesV1_org_coursera_common_ui_LinearGradient2';
  color1: DegreesV1_Org_Coursera_Common_Ui_RgbaColor;
  color2: DegreesV1_Org_Coursera_Common_Ui_RgbaColor;
};

/** Color as defined with red, green, blue hues and alpha. @note: Opting to store as rgba instead of hex because hex is a lossy conversion and does not preserve alpha channel */
export type DegreesV1_Org_Coursera_Common_Ui_RgbaColor = {
  __typename?: 'DegreesV1_org_coursera_common_ui_RGBAColor';
  alpha: Scalars['Float'];
  blue: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
};

/** Type of launch this degree was intended to launch as e.g. TEST or REAL. */
export const DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType = typeof DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType[keyof typeof DegreesV1_Org_Coursera_Degree_Stored_InternalLaunchType];
export const DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType = {
  Free: 'FREE',
  Plus: 'PLUS',
  Standard: 'STANDARD'
} as const;

export type DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType = typeof DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType[keyof typeof DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType];
export type DegreesV1_Org_Coursera_Degree_Stored_SlackSettings = {
  __typename?: 'DegreesV1_org_coursera_degree_stored_SlackSettings';
  slackPlanType: DegreesV1_Org_Coursera_Degree_Stored_SlackPlanType;
  slackTeamDomain: Scalars['String'];
  slackTeamId: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type DegreesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'DegreesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<DegreesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type DegreesV1_RgbaColorMember = {
  __typename?: 'DegreesV1_rgbaColorMember';
  rgbaColor: DegreesV1_Org_Coursera_Common_Ui_RgbaColor;
};

/** Delete course offering request */
export type DeleteCourseOfferingRequest = {
  /** The course offering ID that is to be deleted. */
  courseOfferingId: Scalars['ID'];
};

/**  eslint-disable-next-line custom-rules/namespaced-types, @graphql-eslint/require-description */
export type DeleteCourseOfferingResponse = CourseOfferingErrorResponse | DeleteCourseOfferingSuccessResponse;

/** Delete course offering response */
export type DeleteCourseOfferingSuccessResponse = {
  __typename?: 'DeleteCourseOfferingSuccessResponse';
  /** Returns the deleted course offering ID. */
  courseOfferingId: Scalars['ID'];
};

/** All Descript POC Authoring queries */
export type DescriptQueries = {
  __typename?: 'DescriptQueries';
  /** Validates whether a given URL is a valid share URL from descript. */
  validateShareUrl: Descript_ValidateShareUrlResult;
};


/** All Descript POC Authoring queries */
export type DescriptQueriesValidateShareUrlArgs = {
  url: Scalars['URL'];
};

/** Mutation result when url creation fails */
export type Descript_CreateEditUrlFail = {
  __typename?: 'Descript_CreateEditUrlFail';
  /** description of why the export url failed to be generated */
  errorMessage: Scalars['String'];
};

/** inputs required to generate a descript url */
export type Descript_CreateEditUrlInput = {
  /** name that will be used to populate project in Descript */
  name: Scalars['String'];
  /**
   * an ID that Descript uses to uniquely identify the video, populated with atom id + video asset id for now (this has been intentionally left for the FE to handle to make it easier to swap if needed)
   * This is also used to handle export requests from Descript to Coursera.
   */
  sourceId: Scalars['ID'];
  /** URI to file that will be used by Descript */
  uri: Scalars['URL'];
};

/** Result of CreateEditUrl mutation */
export type Descript_CreateEditUrlResult = Descript_CreateEditUrlFail | Descript_CreateEditUrlSuccess;

/** Mutation result when url creation succeeds */
export type Descript_CreateEditUrlSuccess = {
  __typename?: 'Descript_CreateEditUrlSuccess';
  /** A signed url the user can use to navigate to descript and start their export to Descript */
  descriptUrl: Scalars['URL'];
  /** This ID is just the URL but satisfies apollo cache */
  id: Scalars['ID'];
};

/** Represents the result of the share url validation check. */
export type Descript_ValidateShareUrlResult = {
  __typename?: 'Descript_ValidateShareUrlResult';
  /** Indicates whether the url is a valid share url. */
  isValid: Scalars['Boolean'];
};

/** Queries for description pages */
export type DescriptionPageQueries = {
  __typename?: 'DescriptionPageQueries';
  /** This query returns the course page data to serve the front-end according to input. */
  queryCourseMarketingPage?: Maybe<DescriptionPage_CoursePage>;
  /** This query returns the course page data to serve the front-end according to input. */
  queryCoursePage?: Maybe<DescriptionPage_CoursePage>;
  /** This query returns the data needed to render the course reviews page. */
  queryCourseReviewsPage?: Maybe<DescriptionPage_CourseReviewsPage>;
  /** This query returns the enterprise course page data to serve the front-end according to input. */
  queryEnterpriseCoursePage?: Maybe<DescriptionPage_EnterpriseCoursePage>;
  /** This query returns the org-scoped enterprise course page data to serve the front-end according to input. */
  queryEnterpriseCoursePageByOrg?: Maybe<DescriptionPage_EnterpriseCoursePageByOrg>;
  /** This query returns the specialization page data to serve the front-end according to input. */
  queryEnterpriseSpecializationPage?: Maybe<DescriptionPage_EnterpriseSpecializationPage>;
  /** This query returns the org-scoped enterprise specialization page data to serve the front-end according to input. */
  queryEnterpriseSpecializationPageByOrg?: Maybe<DescriptionPage_EnterpriseSpecializationPageByOrg>;
  /** This query returns the specialization page data to serve the front-end according to input. */
  querySpecializationMarketingPage?: Maybe<DescriptionPage_SpecializationPage>;
  /** This query returns the specialization page data to serve the front-end according to input. */
  querySpecializationPage?: Maybe<DescriptionPage_SpecializationPage>;
  /** This query returns the verified skill paths page data to serve the front-end according to input. */
  queryVerifiedSkillPathsPage: Array<DescriptionPage_VerifiedSkillPathsPage>;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryCourseMarketingPageArgs = {
  input: DescriptionPage_QueryCourseMarketingPageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryCoursePageArgs = {
  input: DescriptionPage_QueryCoursePageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryCourseReviewsPageArgs = {
  input: DescriptionPage_QueryCourseReviewsPageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryEnterpriseCoursePageArgs = {
  input: DescriptionPage_QueryEnterpriseCoursePageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryEnterpriseCoursePageByOrgArgs = {
  input: DescriptionPage_QueryEnterpriseCoursePageByOrgInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryEnterpriseSpecializationPageArgs = {
  input: DescriptionPage_QueryEnterpriseSpecializationPageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryEnterpriseSpecializationPageByOrgArgs = {
  input: DescriptionPage_QueryEnterpriseSpecializationPageByOrgInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQuerySpecializationMarketingPageArgs = {
  input: DescriptionPage_QuerySpecializationMarketingPageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQuerySpecializationPageArgs = {
  input: DescriptionPage_QuerySpecializationPageInput;
};


/** Queries for description pages */
export type DescriptionPageQueriesQueryVerifiedSkillPathsPageArgs = {
  input: DescriptionPage_QueryVerifiedSkillPathsPageInput;
};

/** Career outcome data and resources. */
export type DescriptionPage_CareerOutcomes = {
  __typename?: 'DescriptionPage_CareerOutcomes';
  /** Additional value propositions */
  additionalValueProps?: Maybe<Array<Scalars['String']>>;
  /** The percentage of learners who report career improvement */
  careerGrowthInPercentage?: Maybe<Scalars['Int']>;
  /**
   * Career resources learners can get access to upon completion
   * @deprecated Support for career services has been sunsetted
   */
  careerResources?: Maybe<Array<DescriptionPage_CareerResource>>;
  /** Disclaimers for the data */
  disclaimers?: Maybe<Scalars['String']>;
  /** Disclaimers displayed to Enterprise learners */
  disclaimersForEnterpriseLearners?: Maybe<Scalars['String']>;
  /**
   * Hiring partners
   * @deprecated Support for career services has been sunsetted
   */
  hiringPartners?: Maybe<DescriptionPage_HiringPartners>;
  /** U.S. job openings */
  jobOpeningsInUs?: Maybe<Scalars['Int']>;
  /** Job title that earns the median entry-level salary */
  jobTitleForMedianEntryLevelSalary?: Maybe<Scalars['String']>;
  /** Median entry-level salary in USD */
  medianEntryLevelSalary?: Maybe<Scalars['Int']>;
  /** Job titles learners qualify for upon completion */
  qualifyingJobTitles?: Maybe<Array<Scalars['String']>>;
};

/** Career resources learners can get access to upon completion. */
export type DescriptionPage_CareerResource = {
  __typename?: 'DescriptionPage_CareerResource';
  /** The description of the career resource. This field is in markdown. */
  description?: Maybe<Scalars['String']>;
  /**
   * The name of the icon for the career resource.
   * All available icon names will be added to Contentful as options in a dropdown list.
   */
  iconName: Scalars['String'];
  /** The title of the career resource */
  title: Scalars['String'];
};

/** Certificate types */
export const DescriptionPage_CertificateType = {
  /** TODO: Complete this description */
  Specialization: 'SPECIALIZATION',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type DescriptionPage_CertificateType = typeof DescriptionPage_CertificateType[keyof typeof DescriptionPage_CertificateType];
/** CollectionEntity type for recommendations and related courses collections */
export type DescriptionPage_CollectionEntity = {
  __typename?: 'DescriptionPage_CollectionEntity';
  /** id */
  id: Scalars['ID'];
  /** image url */
  imageUrl?: Maybe<Scalars['URL']>;
  /** link */
  link: Scalars['String'];
  /** name */
  name: Scalars['String'];
  /** The IDs of partners. Internal use only */
  partnerIds: Array<Scalars['ID']>;
  /** The partners */
  partners: Array<DescriptionPage_Partner>;
  /** The product type */
  productType: DescriptionPage_LearningProductType;
  /** slug */
  slug: Scalars['String'];
};

/** The type for a course on a specialization page */
export type DescriptionPage_Course = {
  __typename?: 'DescriptionPage_Course';
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** The description of the course. */
  description?: Maybe<Scalars['String']>;
  /** Enterprise-only, if course has fixed session dates, this will contain when session starts and ends. */
  fixedSession?: Maybe<DescriptionPage_FixedSession>;
  /** The id of the course. */
  id: Scalars['ID'];
  /** The name of the course. */
  name: Scalars['String'];
  /** The partner IDs for the course - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor the course */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The source url of the course */
  photoUrl?: Maybe<Scalars['URL']>;
  /** The ratings of the course. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The skills learners will gain after taking the learning product. */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the course. */
  slug: Scalars['String'];
  /** Total amount of time in milliseconds to complete the course content. */
  totalContentDuration?: Maybe<Scalars['Duration']>;
};

/** Course page data */
export type DescriptionPage_CoursePage = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_CoursePage';
  /**
   * The specialization that matches specializationSlug in the input of the query.
   * If no match is found, this will be null.
   */
  activeSpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Average content satisfaction score of this course. */
  averageContentSatisfactionScore?: Maybe<Scalars['Float']>;
  /** The average rating of the instructors of the course. */
  averageInstructorRating?: Maybe<Scalars['Float']>;
  /** The types of certificates the learning product is associated with. */
  certificates?: Maybe<Array<DescriptionPage_CertificateType>>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Number of content satisfaction score we collected from learners of this course. */
  contentSatisfactionRatingsCount?: Maybe<Scalars['Int']>;
  /** The status of the course */
  courseStatus?: Maybe<DescriptionPage_CourseStatus>;
  /**
   * The type of the course.
   * Formerly named courseTypeMetadata. It is used to determine when to redirect to the PDP bundle.
   */
  courseType?: Maybe<DescriptionPage_CourseType>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** Languages that the course is dubbed into */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** Text field from product authoring detailing length of content. Used for project pages. */
  estimatedWorkload?: Maybe<Scalars['String']>;
  /** True if the course has a full 100% discount. */
  hasFullDiscount?: Maybe<Scalars['Boolean']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The total number of ratings of the instructors of the course. */
  instructorRatingCount?: Maybe<Scalars['Int']>;
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** Outcome statistics from learners who took this learning product */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** Course material */
  material?: Maybe<DescriptionPage_Material>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The source url of the picture of the learning product used by Recently Viewed in auto-complete. */
  photoUrl?: Maybe<Scalars['URL']>;
  /** The premium level of the learning product. */
  premiumExperienceVariant?: Maybe<DescriptionPage_PremiumExperienceVariant>;
  /** The language codes of the primary languages used in the learning product, such as en */
  primaryLanguages: Array<Scalars['String']>;
  /** The primary specialization the course is associated with. */
  primarySpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Only defined for courses of type PROJECT or RHYME_PROJECT, holds details for project content. */
  projectMetadata?: Maybe<DescriptionPage_ProjectMetadata>;
  /** Number of ratings by stars of this course. */
  ratingCountsByStar?: Maybe<DescriptionPage_RatingCountsByStar>;
  /** The ratings we received from learners of this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /**
   * The recommendations of this course
   * @deprecated use relatedRecommendations
   */
  recommendations?: Maybe<Array<DescriptionPage_CollectionEntity>>;
  /** The related curses of this course */
  relatedCourses?: Maybe<Array<DescriptionPage_CollectionEntity>>;
  /** The recommendations of this course */
  relatedRecommendations?: Maybe<Collection_Collection>;
  /** Highlighted reviews of this course. */
  reviewHighlights?: Maybe<Array<DescriptionPage_ReviewHighlight>>;
  /** The skill tags associated with this learning product. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /**
   * All the specializations the learning product associated with.
   * Formerly s12ns
   */
  specializations?: Maybe<Array<DescriptionPage_Specialization>>;
  /** The language codes of the languages used in subtitles of the learning product, such as en */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /**
   * Learner's reviews of this course.
   * This will replace topFourAndFiveStarReviews.
   */
  topReviews?: Maybe<Array<DescriptionPage_Review>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Aggregated data for the course reviews page. */
export type DescriptionPage_CourseReviewsPage = {
  __typename?: 'DescriptionPage_CourseReviewsPage';
  /** The description of the course. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the course. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The ID of the course. */
  id: Scalars['ID'];
  /** The course material, used here for total duration. */
  material?: Maybe<DescriptionPage_Material>;
  /** The name of the course. */
  name: Scalars['String'];
  /** The partners that sponsor the course. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The product card for the course. */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** The breakdown of rating counts by star value. */
  ratingCountsByStar?: Maybe<DescriptionPage_RatingCountsByStar>;
  /** The aggregate ratings for the course (average, rating count, comment count). */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** Repeated phrases highlighted across learner reviews, with their frequencies. */
  reviewHighlights?: Maybe<Array<DescriptionPage_ReviewHighlight>>;
  /** The skill tags associated with the course. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /** The slug of the course. */
  slug: Scalars['String'];
  /** Top learner reviews for the course. */
  topReviews?: Maybe<Array<DescriptionPage_Review>>;
};

/** Course status */
export const DescriptionPage_CourseStatus = {
  /** TODO: Complete this description */
  Draft: 'DRAFT',
  /** TODO: Complete this description */
  Inactive: 'INACTIVE',
  /** TODO: Complete this description */
  Launched: 'LAUNCHED',
  /** TODO: Complete this description */
  PreEnroll: 'PRE_ENROLL'
} as const;

export type DescriptionPage_CourseStatus = typeof DescriptionPage_CourseStatus[keyof typeof DescriptionPage_CourseStatus];
/** Course types */
export const DescriptionPage_CourseType = {
  /** TODO: Complete this description */
  Project: 'PROJECT',
  /** TODO: Complete this description */
  RhymeProject: 'RHYME_PROJECT',
  /** TODO: Complete this description */
  StandardCourse: 'STANDARD_COURSE'
} as const;

export type DescriptionPage_CourseType = typeof DescriptionPage_CourseType[keyof typeof DescriptionPage_CourseType];
/** Degree that a learning product is associated with. */
export type DescriptionPage_Degree = {
  __typename?: 'DescriptionPage_Degree';
  /**
   * Custom/curated duration of the degree. Marketing enters these strings manually and they do not conform to any set shape.
   * Example: "2 - 4 years", "24 months" etc.
   */
  duration?: Maybe<Scalars['String']>;
  /** Link to the expression of interest form for the product. This goes to the university's third party website. */
  eoiLink?: Maybe<Scalars['URL']>;
  /** The source url of the header image for the degree. */
  headerImage?: Maybe<Scalars['URL']>;
  /** The id of the degree. */
  id: Scalars['ID'];
  /** The name of the degree. */
  name: Scalars['String'];
  /** Indicator of whether this is a degree, MT, degree backed Professional Certificate or OnCampusProgram. */
  productVariant: DescriptionPage_ProductVariant;
  /** The slug of the degree. */
  slug: Scalars['String'];
  /**
   * The upsell partners for the degree.
   * This is only used by specialization pages.
   */
  upsellPartners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The upsell type of the degree. */
  upsellType?: Maybe<DescriptionPage_UpsellType>;
};

/** Learning product difficulty levels */
export const DescriptionPage_DifficultyLevel = {
  /** TODO: Complete this description */
  Advanced: 'ADVANCED',
  /** TODO: Complete this description */
  Beginner: 'BEGINNER',
  /** TODO: Complete this description */
  Intermediate: 'INTERMEDIATE'
} as const;

export type DescriptionPage_DifficultyLevel = typeof DescriptionPage_DifficultyLevel[keyof typeof DescriptionPage_DifficultyLevel];
/** Domain that a learning product is associated with. */
export type DescriptionPage_Domain = {
  __typename?: 'DescriptionPage_Domain';
  /** The id of the domain. */
  domainId: Scalars['ID'];
  /** The name of the domain. */
  domainName: Scalars['String'];
  /** The name of the subdomain. */
  subdomainId?: Maybe<Scalars['ID']>;
  /** The id of the subdomain. */
  subdomainName?: Maybe<Scalars['String']>;
};

/** Language that the product is dubbed into */
export type DescriptionPage_DubbedLanguage = {
  __typename?: 'DescriptionPage_DubbedLanguage';
  /**
   * Language code of the dubbed language
   * Example language code: zh-CN
   * List of language codes: https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  languageCode: Scalars['String'];
};

/** Enterprise course page data */
export type DescriptionPage_EnterpriseCoursePage = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_EnterpriseCoursePage';
  /**
   * The specialization that matches specializationSlug in the input of the query.
   * If no match is found, this will be null.
   */
  activeSpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Average content satisfaction score of this course. */
  averageContentSatisfactionScore?: Maybe<Scalars['Float']>;
  /** The average rating of the instructors of the course. */
  averageInstructorRating?: Maybe<Scalars['Float']>;
  /** The types of certificates the learning product is associated with. */
  certificates?: Maybe<Array<DescriptionPage_CertificateType>>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Number of content satisfaction score we collected from learners of this course. */
  contentSatisfactionRatingsCount?: Maybe<Scalars['Int']>;
  /** The status of the course */
  courseStatus?: Maybe<DescriptionPage_CourseStatus>;
  /**
   * The type of the course.
   * Formerly named courseTypeMetadata. It is used to determine when to redirect to the PDP bundle.
   */
  courseType?: Maybe<DescriptionPage_CourseType>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** Languages that the course is dubbed into */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** Text field from product authoring detailing length of content. Used for project pages. */
  estimatedWorkload?: Maybe<Scalars['String']>;
  /** If course has fixed session dates, this will contain when session starts and ends. */
  fixedSession?: Maybe<DescriptionPage_FixedSession>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The total number of ratings of the instructors of the course. */
  instructorRatingCount?: Maybe<Scalars['Int']>;
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** True if the course is exclusive to the program. */
  isExclusive?: Maybe<Scalars['Boolean']>;
  /** True if the course has been selected for credit by an admin. */
  isSelectedForCredit?: Maybe<Scalars['Boolean']>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** Outcome statistics from learners who took this learning product */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** Course material */
  material?: Maybe<DescriptionPage_Material>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the course - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The source url of the picture of the learning product used by Recently Viewed in auto-complete. */
  photoUrl?: Maybe<Scalars['URL']>;
  /** The premium level of the learning product. */
  premiumExperienceVariant?: Maybe<DescriptionPage_PremiumExperienceVariant>;
  /** The language codes of the primary languages used in the learning product, such as en */
  primaryLanguages: Array<Scalars['String']>;
  /** The primary specialization the course is associated with. */
  primarySpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Only defined for courses of type PROJECT or RHYME_PROJECT, holds details for project content. */
  projectMetadata?: Maybe<DescriptionPage_ProjectMetadata>;
  /** Number of ratings by stars of this course. */
  ratingCountsByStar?: Maybe<DescriptionPage_RatingCountsByStar>;
  /** The ratings we received from learners of this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /**
   * The recommendations of this course
   * @deprecated use relatedRecommendations
   */
  recommendations?: Maybe<Array<DescriptionPage_CollectionEntity>>;
  /** The related curses of this course */
  relatedCourses?: Maybe<Array<DescriptionPage_CollectionEntity>>;
  /** The recommendations of this course */
  relatedRecommendations?: Maybe<Collection_Collection>;
  /** Highlighted reviews of this course. */
  reviewHighlights?: Maybe<Array<DescriptionPage_ReviewHighlight>>;
  /** The skill tags associated with this learning product. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /**
   * All the specializations the learning product associated with.
   * Formerly s12ns
   */
  specializations?: Maybe<Array<DescriptionPage_Specialization>>;
  /** The language codes of the languages used in subtitles of the learning product, such as en */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /**
   * Learner's reviews of this course.
   * This will replace topFourAndFiveStarReviews.
   */
  topReviews?: Maybe<Array<DescriptionPage_Review>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Org-scoped enterprise course page data */
export type DescriptionPage_EnterpriseCoursePageByOrg = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_EnterpriseCoursePageByOrg';
  /**
   * The specialization that matches specializationSlug in the input of the query.
   * If no match is found, this will be null.
   */
  activeSpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Average content satisfaction score of this course with a maximum score of 100.0 */
  averageContentSatisfactionScore?: Maybe<Scalars['Float']>;
  /** The average rating of the instructors of the course with a maximum rating of 5.0 */
  averageInstructorRating?: Maybe<Scalars['Float']>;
  /** The types of certificates the learning product is associated with. */
  certificates?: Maybe<Array<DescriptionPage_CertificateType>>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Number of content satisfaction score we collected from learners of this course. */
  contentSatisfactionRatingsCount?: Maybe<Scalars['Int']>;
  /** The status of the course */
  courseStatus?: Maybe<DescriptionPage_CourseStatus>;
  /**
   * The type of the course.
   * Formerly named courseTypeMetadata. It is used to determine when to redirect to the PDP bundle.
   */
  courseType?: Maybe<DescriptionPage_CourseType>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** Languages that the course is dubbed into */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** Text field from product authoring detailing length of content. Used for project pages. */
  estimatedWorkload?: Maybe<Scalars['String']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The total number of ratings of the instructors of the course. */
  instructorRatingCount?: Maybe<Scalars['Int']>;
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** Outcome statistics from learners who took this learning product */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** Course material */
  material?: Maybe<DescriptionPage_Material>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the course - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The source url of the picture of the learning product used by Recently Viewed in auto-complete. */
  photoUrl?: Maybe<Scalars['URL']>;
  /** The premium level of the learning product. */
  premiumExperienceVariant?: Maybe<DescriptionPage_PremiumExperienceVariant>;
  /** The language codes of the primary languages used in the learning product, such as en */
  primaryLanguages: Array<Scalars['String']>;
  /** The primary specialization the course is associated with. */
  primarySpecialization?: Maybe<DescriptionPage_Specialization>;
  /** Program-specific data for this enterprise course page, such as exclusivity and credit selection. */
  programSpecificData: DescriptionPage_EnterpriseCourseProgramSpecificData;
  /** Only defined for courses of type PROJECT or RHYME_PROJECT, holds details for project content. */
  projectMetadata?: Maybe<DescriptionPage_ProjectMetadata>;
  /** Number of ratings by stars of this course. */
  ratingCountsByStar?: Maybe<DescriptionPage_RatingCountsByStar>;
  /** The ratings we received from learners of this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The related curses of this course */
  relatedCourses?: Maybe<Array<DescriptionPage_CollectionEntity>>;
  /** The recommendations of this course */
  relatedRecommendations?: Maybe<Collection_Collection>;
  /** Highlighted reviews of this course. */
  reviewHighlights?: Maybe<Array<DescriptionPage_ReviewHighlight>>;
  /** The skill tags associated with this learning product. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /**
   * All the specializations the learning product associated with.
   * Formerly s12ns
   */
  specializations?: Maybe<Array<DescriptionPage_Specialization>>;
  /** The language codes of the languages used in subtitles of the learning product, such as en */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /**
   * Learner's reviews of this course.
   * This will replace topFourAndFiveStarReviews.
   */
  topReviews?: Maybe<Array<DescriptionPage_Review>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Program-specific data for an enterprise course page. */
export type DescriptionPage_EnterpriseCourseProgramSpecificData = {
  __typename?: 'DescriptionPage_EnterpriseCourseProgramSpecificData';
  /** If course has fixed session dates, this will contain when session starts and ends. */
  fixedSession?: Maybe<DescriptionPage_FixedSession>;
  /** True if the course is exclusive to the program. */
  isExclusive?: Maybe<Scalars['Boolean']>;
  /** True if the course has been selected for credit by an admin. */
  isSelectedForCredit?: Maybe<Scalars['Boolean']>;
  /** The underlying program ID that is used on org-scoped XDPs and is needed for enrollment. */
  programId?: Maybe<Scalars['ID']>;
};

/** Enterprise specialization page data */
export type DescriptionPage_EnterpriseSpecializationPage = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_EnterpriseSpecializationPage';
  /** Career outcome data and resources. */
  careerOutcomes?: Maybe<DescriptionPage_CareerOutcomes>;
  /** The source url to the certificate logo for this specialization. */
  certificateLogo?: Maybe<Scalars['URL']>;
  /** The description of the specialization in CML format. */
  cmlDescription?: Maybe<CmlContent>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Indicator of whether this specialization enables co-branding. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** The source urls of company logos in this specialization. */
  companyLogos?: Maybe<Array<Scalars['URL']>>;
  /** The courses in this specialization. */
  courses?: Maybe<Array<DescriptionPage_Course>>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /**
   * Languages that the specialization is dubbed into.
   * A s12n is only dubbed into a language if every course in the specialization is dubbed into that language.
   */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** True if any courses within this specialization have fixed sessions. */
  hasFixedSessions?: Maybe<Scalars['Boolean']>;
  /** The headline of this specialization. */
  headline?: Maybe<Scalars['String']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** True if the specialization has been selected for credit by an admin. */
  isSelectedForCredit?: Maybe<Scalars['Boolean']>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** The estimated total number of hours per week to complete this specialization. */
  learningHoursPerWeek?: Maybe<Scalars['Int']>;
  /** Outcome statistics from learners who took this learning product. */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** Product tags applied to a learning product in retool */
  productTags?: Maybe<DescriptionPage_ProductTags>;
  /** The product type of the specialization. */
  productVariant: DescriptionPage_ProductVariant;
  /** Sub categories for professional certificates */
  professionalCertificateType?: Maybe<DescriptionPage_ProfessionalCertificateType>;
  /** Contains information on an applied learning project if the product has one. */
  projectsOverview?: Maybe<CmlContent>;
  /** The ratings we received from learners for this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The skill tags associated with this learning product. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** The skills learners will gain after taking the specialization. */
  specializationAndCourseSkills?: Maybe<Array<Scalars['String']>>;
  /** The subheader of this specialization. */
  subheader?: Maybe<Scalars['String']>;
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** The estimated total number of months to complete this specialization. */
  totalLearningMonths?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Org-scoped enterprise specialization page data */
export type DescriptionPage_EnterpriseSpecializationPageByOrg = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_EnterpriseSpecializationPageByOrg';
  /** Career outcome data and resources. */
  careerOutcomes?: Maybe<DescriptionPage_CareerOutcomes>;
  /** The source url to the certificate logo for this specialization. */
  certificateLogo?: Maybe<Scalars['URL']>;
  /** The description of the specialization in CML format. */
  cmlDescription?: Maybe<CmlContent>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Indicator of whether this specialization enables co-branding. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** The source urls of company logos in this specialization. */
  companyLogos?: Maybe<Array<Scalars['URL']>>;
  /** The courses in this specialization. */
  courses?: Maybe<Array<DescriptionPage_Course>>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /**
   * Languages that the specialization is dubbed into.
   * A s12n is only dubbed into a language if every course in the specialization is dubbed into that language.
   */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** The headline of this specialization. */
  headline?: Maybe<Scalars['String']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** The estimated total number of hours per week to complete this specialization. */
  learningHoursPerWeek?: Maybe<Scalars['Int']>;
  /** Outcome statistics from learners who took this learning product. */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** Product tags applied to a learning product in retool */
  productTags?: Maybe<DescriptionPage_ProductTags>;
  /** The product type of the specialization. */
  productVariant: DescriptionPage_ProductVariant;
  /** Sub categories for professional certificates */
  professionalCertificateType?: Maybe<DescriptionPage_ProfessionalCertificateType>;
  /** Program-specific data for this enterprise specialization page, such as fixed sessions and credit selection. */
  programSpecificData: DescriptionPage_EnterpriseSpecializationProgramSpecificData;
  /** Contains information on an applied learning project if the product has one. */
  projectsOverview?: Maybe<CmlContent>;
  /** The ratings we received from learners for this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The skill tags associated with this learning product. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** The skills learners will gain after taking the specialization. */
  specializationAndCourseSkills?: Maybe<Array<Scalars['String']>>;
  /** The subheader of this specialization. */
  subheader?: Maybe<Scalars['String']>;
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** The estimated total number of months to complete this specialization. */
  totalLearningMonths?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Program-specific data for an enterprise specialization page. */
export type DescriptionPage_EnterpriseSpecializationProgramSpecificData = {
  __typename?: 'DescriptionPage_EnterpriseSpecializationProgramSpecificData';
  /** True if any courses within this specialization have fixed sessions. */
  hasFixedSessions?: Maybe<Scalars['Boolean']>;
  /** True if the specialization has been selected for credit by an admin. */
  isSelectedForCredit?: Maybe<Scalars['Boolean']>;
  /** The underlying program ID that is used on org-scoped XDPs and is needed for enrollment. */
  programId?: Maybe<Scalars['ID']>;
};

/** FAQ of a learning product. */
export type DescriptionPage_Faq = {
  __typename?: 'DescriptionPage_Faq';
  /** The answer of a FAQ. */
  answer?: Maybe<CmlContent>;
  /** The id of a FAQ. */
  id: Scalars['ID'];
  /** The question of a FAQ. */
  question?: Maybe<CmlContent>;
};

/** Metadata for a course with fixed session dates. */
export type DescriptionPage_FixedSession = {
  __typename?: 'DescriptionPage_FixedSession';
  /** Timestamp of when the session ends. */
  endsAt: Scalars['DateTime'];
  /** The session ID. */
  id: Scalars['ID'];
  /** Timestamp of when the session starts. */
  startsAt: Scalars['DateTime'];
};

/** Hiring partner logo */
export type DescriptionPage_HiringPartnerLogo = {
  __typename?: 'DescriptionPage_HiringPartnerLogo';
  /** The alt text of the image of the hiring partner */
  imageAltText?: Maybe<Scalars['String']>;
  /** The source url of the image of the hiring partner */
  imageUrl: Scalars['URL'];
};

/** Hiring partners info. */
export type DescriptionPage_HiringPartners = {
  __typename?: 'DescriptionPage_HiringPartners';
  /** Hiring partner's logos */
  partnerLogos?: Maybe<Array<DescriptionPage_HiringPartnerLogo>>;
  /** The title of the hiring partners section. This field is in markdown. */
  title: Scalars['String'];
};

/** Image asset */
export type DescriptionPage_ImageAsset = {
  __typename?: 'DescriptionPage_ImageAsset';
  /** The description for the image */
  description?: Maybe<Scalars['String']>;
  /** The title of the image */
  title?: Maybe<Scalars['String']>;
  /** The source url of the image */
  url: Scalars['URL'];
};

/** Qualification types for the industry certification/exam specified in the industryCertificationName field */
export const DescriptionPage_IndustryCertificationQualificationType = {
  /** Product is not qualified, but learners can earn hours towards the industry certification/exam specified in the industryCertificationName field */
  HoursTowards: 'HOURS_TOWARDS',
  /** Product is qualified for the industry certification/exam specified in the industryCertificationName field */
  Qualified: 'QUALIFIED'
} as const;

export type DescriptionPage_IndustryCertificationQualificationType = typeof DescriptionPage_IndustryCertificationQualificationType[keyof typeof DescriptionPage_IndustryCertificationQualificationType];
/** The instructor information of a learning product. */
export type DescriptionPage_Instructor = {
  __typename?: 'DescriptionPage_Instructor';
  /** The total number of courses taught by this instructor. */
  coursesTaught?: Maybe<Scalars['Int']>;
  /** The department of the instructor. */
  department?: Maybe<Scalars['String']>;
  /** The full name of the instructor. */
  fullName: Scalars['String'];
  /** The id of the instructor. */
  id: Scalars['ID'];
  /** Indicator of whether this instructor is a top instructor. */
  isTopInstructor?: Maybe<Scalars['Boolean']>;
  /** The total number of learners who have taken courses taught by this instructor. */
  learnersReached?: Maybe<Scalars['Int']>;
  /** The source url to the profile image of the instructor. */
  photo?: Maybe<Scalars['URL']>;
  /** The short name of the instructor. */
  shortName?: Maybe<Scalars['String']>;
  /** The job title of the instructor. */
  title?: Maybe<Scalars['String']>;
  /** The url of the instructor's website */
  website?: Maybe<Scalars['URL']>;
};

/** Item counts */
export type DescriptionPage_ItemCounts = {
  __typename?: 'DescriptionPage_ItemCounts';
  /** The total number of assignments in this specialization. */
  totalAssignmentCount?: Maybe<Scalars['Int']>;
};

/** Learning incentive promotion */
export type DescriptionPage_LearnerIncentivePromotion = {
  __typename?: 'DescriptionPage_LearnerIncentivePromotion';
  /** The id of the promotion */
  id: Scalars['ID'];
  /** The source url of the image of the promotion */
  imageUrl?: Maybe<Scalars['URL']>;
  /** The promotion text */
  text: Scalars['String'];
  /** The id of the promotion */
  title: Scalars['String'];
};

/** Learners' career outcome statistics after they took this learning product. */
export type DescriptionPage_LearningOutcomes = {
  __typename?: 'DescriptionPage_LearningOutcomes';
  /** The number per 100 learners who started a new career after completing this learning product. */
  careerOutcomeNewCareer: Scalars['Int'];
  /** The number per 100 learners who got a pay increase after completing this learning product. */
  careerOutcomePayIncrease: Scalars['Int'];
  /** The number per 100 learners who got promoted after completing this learning product. */
  careerOutcomePromotion: Scalars['Int'];
  /** The number per 100 learners who got a tangible career benefit from this this learning product. */
  tangibleCareerOutcome: Scalars['Int'];
};

/** An interface that all description pages should implement */
export type DescriptionPage_LearningProductPage = {
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** The degrees this learning product is associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product is associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** Languages that the current program is dubbed into */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** Learners' career outcome statistics after they took this learning product. */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** The ratings we received from learners for this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The skills learners will gain after taking the learning product. */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
};

/** Learning product types including courses and s12ns */
export const DescriptionPage_LearningProductType = {
  /** Regular course */
  Course: 'COURSE',
  /** ProfessionalCertificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project */
  Project: 'PROJECT',
  /** Guided project */
  RhymeProject: 'RHYME_PROJECT',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type DescriptionPage_LearningProductType = typeof DescriptionPage_LearningProductType[keyof typeof DescriptionPage_LearningProductType];
/** Marketing Source */
export const DescriptionPage_MarketingSource = {
  /** Google */
  Google: 'GOOGLE',
  /** Paid Media, a.k.a Paid Ads */
  PaidMedia: 'PAID_MEDIA'
} as const;

export type DescriptionPage_MarketingSource = typeof DescriptionPage_MarketingSource[keyof typeof DescriptionPage_MarketingSource];
/** Course material */
export type DescriptionPage_Material = {
  __typename?: 'DescriptionPage_Material';
  /** The total duration for learners to complete the course. */
  totalDuration?: Maybe<Scalars['Duration']>;
  /** Learning material grouped by week */
  weeks: Array<DescriptionPage_WeeklyMaterial>;
};

/** Partner that sponsors  a learning product. */
export type DescriptionPage_Partner = {
  __typename?: 'DescriptionPage_Partner';
  /** The accent color for the partner. */
  accentColor?: Maybe<Scalars['String']>;
  /** The source url of the logo the partner uses on course page */
  classLogo?: Maybe<Scalars['URL']>;
  /** The description of the partner. */
  description?: Maybe<Scalars['String']>;
  /** The id of the partner. */
  id: Scalars['ID'];
  /** The IDs of instructors attached to partner. */
  instructorIds?: Maybe<Array<Scalars['ID']>>;
  /** The source url of the partner's logo. */
  logo?: Maybe<Scalars['URL']>;
  /** The name of the partner. */
  name: Scalars['String'];
  /** The marketing verbiage of the partner. */
  partnerMarketingBlurb?: Maybe<Scalars['String']>;
  /** The primary color for the partner. */
  primaryColor?: Maybe<Scalars['String']>;
  /**
   * The source url of the partner's primary logo.
   * The primaryLogo has the same value as the productBrandingLogo field with one exception,
   * which is when a course only has one partner and it has override logos, primaryLogo should be the first override logo.
   */
  primaryLogo?: Maybe<Scalars['URL']>;
  /** The source url of the partner's branding logo. */
  productBrandingLogo?: Maybe<Scalars['URL']>;
  /** The source url of the partner's rectangular logo. */
  rectangularLogo?: Maybe<Scalars['URL']>;
  /** The secondary color for the partner. */
  secondaryColor?: Maybe<Scalars['String']>;
  /** The short name of the partner. */
  shortName: Scalars['String'];
  /** The source url of the partner's square logo. */
  squareLogo?: Maybe<Scalars['URL']>;
  /** The url of the partner's website */
  website?: Maybe<Scalars['URL']>;
};

/** Premium Experience Variants */
export const DescriptionPage_PremiumExperienceVariant = {
  /** TODO: Complete this description */
  BaseVariant: 'BASE_VARIANT',
  /** TODO: Complete this description */
  PremiumCourse: 'PREMIUM_COURSE',
  /** TODO: Complete this description */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type DescriptionPage_PremiumExperienceVariant = typeof DescriptionPage_PremiumExperienceVariant[keyof typeof DescriptionPage_PremiumExperienceVariant];
/** Product tags applied to a learning product in retool */
export type DescriptionPage_ProductTags = {
  __typename?: 'DescriptionPage_ProductTags';
  /** The name of the industry certification/exam this product is qualified for */
  industryCertificationName?: Maybe<Scalars['String']>;
  /** Qualification for the industry certification/exam specified in the industryCertificationName field */
  industryCertificationQualification?: Maybe<DescriptionPage_IndustryCertificationQualificationType>;
  /** The url that links to the ACE Credit Recommendation page */
  linkToACECreditRecommendation?: Maybe<Scalars['URL']>;
  /** Sub categories for professional certificates */
  professionalCertificateType?: Maybe<DescriptionPage_ProfessionalCertificateType>;
};

/** Product variants */
export const DescriptionPage_ProductVariant = {
  /** TODO: Complete this description */
  BachelorsDegree: 'BACHELORS_DEGREE',
  /**
   * A specialization product that will be treated as a professional certificate, but will not add
   * "professional certificate" name to the title. Explanation:
   * https://coursera.slack.com/archives/C04PHNQAL/p1648067641940959?thread_ts=1648058204.861219&cid=C04PHNQAL
   */
  ExternalCertificate: 'EXTERNAL_CERTIFICATE',
  /** Professional certificate for Google */
  GoogleCertificate: 'GOOGLE_CERTIFICATE',
  /** TODO: Complete this description */
  MastersDegree: 'MASTERS_DEGREE',
  /** TODO: Complete this description */
  MasterTrack: 'MASTER_TRACK',
  /** TODO: Complete this description */
  OnCampusProgram: 'ON_CAMPUS_PROGRAM',
  /** TODO: Complete this description */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** TODO: Complete this description */
  StandardSpecialization: 'STANDARD_SPECIALIZATION'
} as const;

export type DescriptionPage_ProductVariant = typeof DescriptionPage_ProductVariant[keyof typeof DescriptionPage_ProductVariant];
/** Sub categories for professional certificates */
export const DescriptionPage_ProfessionalCertificateType = {
  /** Advanced (a.k.a non-gateway) certificate, e.g. google-it-automation */
  Advanced: 'ADVANCED',
  /** Gateway certificate, e.g. google-data-analytics */
  Gateway: 'GATEWAY'
} as const;

export type DescriptionPage_ProfessionalCertificateType = typeof DescriptionPage_ProfessionalCertificateType[keyof typeof DescriptionPage_ProfessionalCertificateType];
/** Metadata for a course of type PROJECT or RHYME_PROJECT. */
export type DescriptionPage_ProjectMetadata = {
  __typename?: 'DescriptionPage_ProjectMetadata';
  /** List of tasks describing project content. */
  cmlTasks?: Maybe<Array<CmlContent>>;
  /** The ID for the project. */
  id: Scalars['ID'];
  /** Screenshots of the project content. */
  screenshotUrls?: Maybe<Array<Scalars['String']>>;
};

/** Input to get course page data. */
export type DescriptionPage_QueryCourseMarketingPageInput = {
  /** The marketing source of the request */
  marketingSource: DescriptionPage_MarketingSource;
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
};

/** Input to get course page data. */
export type DescriptionPage_QueryCoursePageInput = {
  /** Filter out non Coursera Plus recommendations. */
  filterNonCourseraPlusRecommendations?: Scalars['Boolean'];
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course. */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get course reviews page data. */
export type DescriptionPage_QueryCourseReviewsPageInput = {
  /** The slug of the course whose reviews page should be fetched. */
  slug: Scalars['String'];
};

/** Input to get org-scoped enterprise course page data. */
export type DescriptionPage_QueryEnterpriseCoursePageByOrgInput = {
  /** The slug for the organization the course belongs to. */
  organizationSlug: Scalars['String'];
  /** optionally we can pass a program slug to provide context */
  programSlug?: InputMaybe<Scalars['String']>;
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get enterprise course page data. */
export type DescriptionPage_QueryEnterpriseCoursePageInput = {
  /** The slug for the program the course belongs to. */
  programSlug: Scalars['String'];
  /** The slug of the course to be fetched. */
  slug: Scalars['String'];
  /** The slug of the specialization that acts as the context of the course. */
  specializationSlug?: InputMaybe<Scalars['String']>;
};

/** Input to get org-scoped enterprise specialization page data. */
export type DescriptionPage_QueryEnterpriseSpecializationPageByOrgInput = {
  /** The slug for the organization the specialization belongs to. */
  organizationSlug: Scalars['String'];
  /** optionally we can pass a program slug to provide context */
  programSlug?: InputMaybe<Scalars['String']>;
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get enterprise specialization page data. */
export type DescriptionPage_QueryEnterpriseSpecializationPageInput = {
  /** The slug for the program the specialization belongs to. */
  programSlug: Scalars['String'];
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get specialization page data. */
export type DescriptionPage_QuerySpecializationMarketingPageInput = {
  /** The marketing source of the request */
  marketingSource: DescriptionPage_MarketingSource;
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input to get specialization page data. */
export type DescriptionPage_QuerySpecializationPageInput = {
  /** The slug of the specialization to be fetched. */
  slug: Scalars['String'];
};

/** Input for querying the Verified Skill Paths page */
export type DescriptionPage_QueryVerifiedSkillPathsPageInput = {
  /** List of course IDs to fetch Verified Skill Paths page data from */
  courseIds: Array<Scalars['ID']>;
};

/** Number of ratings by stars of a course. */
export type DescriptionPage_RatingCountsByStar = {
  __typename?: 'DescriptionPage_RatingCountsByStar';
  /** The number of ratings for five stars */
  fiveStarRatingCount?: Maybe<Scalars['Int']>;
  /** The number of ratings for four stars */
  fourStarRatingCount?: Maybe<Scalars['Int']>;
  /** The number of ratings for one star */
  oneStarRatingCount?: Maybe<Scalars['Int']>;
  /** The number of ratings for three stars */
  threeStarRatingCount?: Maybe<Scalars['Int']>;
  /** The number of ratings for two stars */
  twoStarRatingCount?: Maybe<Scalars['Int']>;
};

/** Ratings for a learning product. */
export type DescriptionPage_Ratings = {
  __typename?: 'DescriptionPage_Ratings';
  /** The average ratings for a learning product. */
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  /** The total number of comments for a learning product. */
  commentCount?: Maybe<Scalars['Int']>;
  /** The total number of ratings for a learning product. */
  ratingCount?: Maybe<Scalars['Int']>;
};

/** A review from learners of a course. */
export type DescriptionPage_Review = {
  __typename?: 'DescriptionPage_Review';
  /** The name of the learner who submitted the review */
  authorName: Scalars['String'];
  /** The review comment */
  comment: Scalars['String'];
  /** The id of the review */
  id: Scalars['ID'];
  /** The rating the learner gave. Formerly named averageFiveStarRating */
  rating: Scalars['Int'];
  /** The timpstamp of when the learner submitted the review */
  timestamp: Scalars['DateTime'];
};

/** Highlighted review text and its statistics. */
export type DescriptionPage_ReviewHighlight = {
  __typename?: 'DescriptionPage_ReviewHighlight';
  /** The text repeatedly appears in learner's reviews */
  highlightText: Scalars['String'];
  /** The number of reviews the highlightText appears in */
  reviewcount: Scalars['Int'];
};

/** Skill information with metadata. */
export type DescriptionPage_SkillTag = {
  __typename?: 'DescriptionPage_SkillTag';
  /** The id of the skill. */
  id: Scalars['ID'];
  /** Indicates if this skill is a software tool. */
  isToolSoftware: Scalars['Boolean'];
  /** The name of the skill. */
  name: Scalars['String'];
};

/** TODO: Complete this description */
export type DescriptionPage_Specialization = {
  __typename?: 'DescriptionPage_Specialization';
  /** Indicator of whether this specialization enables co-branding. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** The number of courses in this specialization. */
  courseCount: Scalars['Int'];
  /** The courses associated with this specialization. */
  courses?: Maybe<Array<DescriptionPage_Course>>;
  /** The description of this specialization. */
  description?: Maybe<Scalars['String']>;
  /** The domains this specialization is associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** The headline of this specialization. */
  headline?: Maybe<Scalars['String']>;
  /** The id of this specialization. */
  id: Scalars['ID'];
  /** The name of this specialization. */
  name: Scalars['String'];
  /** The partners that sponsor this specialization. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The product type of this specialization. */
  productVariant: DescriptionPage_ProductVariant;
  /** The slug of this specialization. */
  slug: Scalars['String'];
  /** The subheader of this specialization. */
  subheader?: Maybe<Scalars['String']>;
};

/** Specialization page data */
export type DescriptionPage_SpecializationPage = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_SpecializationPage';
  /** Logo for Specialization that is used in the product cards */
  cardImageUrl?: Maybe<Scalars['URL']>;
  /** Career outcome data and resources. */
  careerOutcomes?: Maybe<DescriptionPage_CareerOutcomes>;
  /** The source url to the certificate logo for this specialization. */
  certificateLogo?: Maybe<Scalars['URL']>;
  /** The description of the specialization in CML format. */
  cmlDescription?: Maybe<CmlContent>;
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** Indicator of whether this specialization enables co-branding. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** The source urls of company logos in this specialization. */
  companyLogos?: Maybe<Array<Scalars['URL']>>;
  /** The courses in this specialization. */
  courses?: Maybe<Array<DescriptionPage_Course>>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /**
   * Languages that the specialization is dubbed into.
   * A s12n is only dubbed into a language if every course in the specialization is dubbed into that language.
   */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** The headline of this specialization. */
  headline?: Maybe<Scalars['String']>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** Indicates whether the Specialization is mapped to a career role in the pathway taxonomy */
  isCareerRolePathway: Scalars['Boolean'];
  /** The total counts of items in this specialization. */
  itemCounts?: Maybe<DescriptionPage_ItemCounts>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** The estimated total number of hours per week to complete this specialization. */
  learningHoursPerWeek?: Maybe<Scalars['Int']>;
  /** Outcome statistics from learners who took this learning product. */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** Product tags applied to a learning product in retool */
  productTags?: Maybe<DescriptionPage_ProductTags>;
  /** The product type of the specialization. */
  productVariant: DescriptionPage_ProductVariant;
  /** Sub categories for professional certificates */
  professionalCertificateType?: Maybe<DescriptionPage_ProfessionalCertificateType>;
  /** Contains information on an applied learning project if the product has one. */
  projectsOverview?: Maybe<CmlContent>;
  /** The ratings we received from learners for this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** Skills information including metadata. */
  skillTags?: Maybe<Array<DescriptionPage_SkillTag>>;
  /**
   * The skills learners will gain after taking the learning product.
   * @deprecated Deprecated in favor of skillTags.name
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** The skills learners will gain after taking the specialization. */
  specializationAndCourseSkills?: Maybe<Array<Scalars['String']>>;
  /** The subheader of this specialization. */
  subheader?: Maybe<Scalars['String']>;
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** The estimated total number of months to complete this specialization. */
  totalLearningMonths?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Testimonial */
export type DescriptionPage_Testimonial = {
  __typename?: 'DescriptionPage_Testimonial';
  /** Name of the author */
  authorName?: Maybe<Scalars['String']>;
  /** Author's Organization */
  authorOrganization?: Maybe<Scalars['String']>;
  /** Author's title */
  authorTitle?: Maybe<Scalars['String']>;
  /** Image for this testimonial */
  image?: Maybe<DescriptionPage_ImageAsset>;
  /** Quote from the author */
  quote?: Maybe<Scalars['String']>;
  /** Link to the video testimonial */
  videoEmbedUrl?: Maybe<Scalars['URL']>;
  /** Cover image for the video testimonial */
  videoPlaceholderImage?: Maybe<DescriptionPage_ImageAsset>;
};

/** Language metadata for available translation */
export type DescriptionPage_TranslatedLanguage = {
  __typename?: 'DescriptionPage_TranslatedLanguage';
  /** Language code */
  code: Scalars['String'];
  /**
   * Whether the translation was generated by machine. If it was machine-translated,
   * we'll show additional labels to indicate that to user.
   */
  isMachineTranslated: Scalars['Boolean'];
};

/** Upsell types */
export const DescriptionPage_UpsellType = {
  /** TODO: Complete this description */
  OffersCredit: 'OFFERS_CREDIT',
  /** TODO: Complete this description */
  PartOf: 'PART_OF',
  /** TODO: Complete this description */
  RelatedTo: 'RELATED_TO'
} as const;

export type DescriptionPage_UpsellType = typeof DescriptionPage_UpsellType[keyof typeof DescriptionPage_UpsellType];
/** Verified Skill Paths page data */
export type DescriptionPage_VerifiedSkillPathsPage = DescriptionPage_LearningProductPage & {
  __typename?: 'DescriptionPage_VerifiedSkillPathsPage';
  /** FAQs of the learning product in CML format. */
  cmlFaqs?: Maybe<Array<DescriptionPage_Faq>>;
  /** The learning objectives of the learning product in CML format. */
  cmlLearningObjectives?: Maybe<Array<CmlContent>>;
  /** Knowledge/skills recommended to know before a learner takes a course. */
  cmlRecommendedBackground?: Maybe<CmlContent>;
  /** The degrees this learning product associated with. */
  degrees?: Maybe<Array<DescriptionPage_Degree>>;
  /** The description of the learning product. */
  description?: Maybe<Scalars['String']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DescriptionPage_DifficultyLevel>;
  /** The domains this learning product associated with. */
  domains?: Maybe<Array<DescriptionPage_Domain>>;
  /** Languages that the learning product is dubbed into */
  dubbedLanguages?: Maybe<Array<DescriptionPage_DubbedLanguage>>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The instructors of this learning product. */
  instructors?: Maybe<Array<DescriptionPage_Instructor>>;
  /** The timestamp when this product is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning incentive promotions of this learning product. */
  learnerIncentivePromotions?: Maybe<Array<DescriptionPage_LearnerIncentivePromotion>>;
  /** Outcome statistics from learners who took this learning product */
  learningOutcomes?: Maybe<DescriptionPage_LearningOutcomes>;
  /** Verified Skill Path material */
  material?: Maybe<VerifiedSkills_Material>;
  /** image source url used in SEO metatags */
  metaImgSrc?: Maybe<Scalars['URL']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The last month's page views of the learning product. */
  pageViewsInLastMonthCount?: Maybe<Scalars['Int']>;
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The partners that sponsor this learning product. */
  partners?: Maybe<Array<DescriptionPage_Partner>>;
  /** The language codes of the primary languages used in the learning product, such as en */
  primaryLanguages: Array<Scalars['String']>;
  /** The ratings we received from learners of this learning product. */
  ratings?: Maybe<DescriptionPage_Ratings>;
  /** The skills learners will gain after taking the learning product. */
  skills?: Maybe<Array<Scalars['String']>>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, such as en */
  subtitleLanguages?: Maybe<Array<Scalars['String']>>;
  /** Testimonials */
  testimonials?: Maybe<Array<DescriptionPage_Testimonial>>;
  /** The total number of enrollment of the learning product. */
  totalEnrollmentCount?: Maybe<Scalars['Int']>;
  /** Languages for available translations of the learning product, e.g. 'fr'. */
  translatedLanguages: Array<DescriptionPage_TranslatedLanguage>;
};

/** Learning material for each week */
export type DescriptionPage_WeeklyMaterial = {
  __typename?: 'DescriptionPage_WeeklyMaterial';
  /** All assessments in this week's material */
  assessments?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The description of the weekly learning material */
  description?: Maybe<Scalars['String']>;
  /** Deprecated. Use assessments instead. */
  exams?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The id of the weekly learning material */
  id: Scalars['ID'];
  /** All lectures in this week's material */
  lectures?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The name of the weekly learning material */
  name: Scalars['String'];
  /** Deprecated. Use assessments instead. */
  quizzes?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** All supplements in this week's material */
  supplements?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The total duration to finish all learning material of this week. */
  totalDuration?: Maybe<Scalars['Duration']>;
  /** The total duration to finish all lectures of this week. */
  totalLectureDuration?: Maybe<Scalars['Duration']>;
  /** Deprecated. Use assessments instead. */
  ungradedLabs?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
};

/** Learning material item */
export type DescriptionPage_WeeklyMaterialItem = {
  __typename?: 'DescriptionPage_WeeklyMaterialItem';
  /** If the current type is an assessment that contains items graded by AI */
  containsAiGrading?: Maybe<Scalars['Boolean']>;
  /** The duration to finish studying the learning material item */
  duration: Scalars['Duration'];
  /** The id of the learning material item */
  id: Scalars['ID'];
  /** If the current type is an assessment */
  isAssessment?: Maybe<Scalars['Boolean']>;
  /** If the current type is a graded assessment */
  isGraded?: Maybe<Scalars['Boolean']>;
  /** The name of the learning material item */
  name: Scalars['String'];
  /** Partners for learning material item if it is embedded from a different course */
  partners?: Maybe<Array<Partner_Partner>>;
  /** The slug of the learning material item */
  slug?: Maybe<Scalars['String']>;
  /** The type of the learning material item */
  typeName: DescriptionPage_WeeklyMaterialItemType;
};

/** Course material types */
export const DescriptionPage_WeeklyMaterialItemType = {
  /** Previously called LTI items */
  AppItem: 'APP_ITEM',
  /** Staff graded or ungraded assignment items */
  Assignment: 'ASSIGNMENT',
  /** Graded and ungraded discussion prompt items */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Deprecated. Use QUIZ instead. */
  Exam: 'EXAM',
  /** Lecture items */
  Lecture: 'LECTURE',
  /** Phased, closed, graded, or ungraded peer review items */
  PeerReview: 'PEER_REVIEW',
  /** Graded or ungraded widget items */
  Plugin: 'PLUGIN',
  /** Graded or ungraded programming items */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quizzes and exams (graded quizzes) */
  Quiz: 'QUIZ',
  /** Supplement items, mostly reading materials */
  Supplement: 'SUPPLEMENT',
  /** Teammate review items */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab items */
  UngradedLab: 'UNGRADED_LAB',
  /** WiseFlow items */
  WiseFlow: 'WISE_FLOW'
} as const;

export type DescriptionPage_WeeklyMaterialItemType = typeof DescriptionPage_WeeklyMaterialItemType[keyof typeof DescriptionPage_WeeklyMaterialItemType];
/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueries = {
  __typename?: 'DiscoveryCollectionsQueries';
  /**
   * This query returns ordered collections (aka modules) that are configured to be displayed in the specified context.
   * The list of collections will be the optimal list computed amongst all possible collections to display.
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  queryByDisplayContext?: Maybe<DiscoveryCollections_ProductCollectionsResult>;
  /**
   * This query simply duplicates `queryByDisplayContext` query to allow AB testing some changes made on the Edge level.
   * TODO(txiao) This query should be cleaned up once the experiment is done: https://coursera.atlassian.net/browse/PERSONAL-1606.
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  queryByDisplayContextDuplicate?: Maybe<DiscoveryCollections_ProductCollectionsResult>;
  /**
   * This query returns a set of collections that has data to serve the front-end according to input.
   * The collection set is defined by the Collection (Set) Management Tool.
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  queryCollections?: Maybe<Array<Maybe<DiscoveryCollections_ProductCollection>>>;
  /**
   * This query returns a single skill-based collection adjusted to the desired enterprise context.
   * The collections returned here are dynamically generated by upstream service and are not managed by
   * the Collection Management Tool.
   * @deprecated Use query queryEnterpriseCollectionsByProgram instead. skill ID's can be passed in using passThroughParameters.
   */
  queryEnterpriseCollectionBySkillId?: Maybe<DiscoveryCollections_ProductCollection>;
  /**
   * This query returns a set of collections adjusted to the desired enterprise organization context.
   * The collection set is defined by the Collection (Set) Management Tool.
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  queryEnterpriseCollectionsByOrganization?: Maybe<DiscoveryCollections_CursoredProductCollections>;
  /**
   * This query returns a set of collections adjusted to the desired enterprise program context.
   * The collection set is defined by the Collection (Set) Management Tool.
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  queryEnterpriseCollectionsByProgram?: Maybe<DiscoveryCollections_CursoredProductCollections>;
  /**
   * This query returns a set of collections adjusted to the desired TargetSkillProfile (TSP) context.
   * TSP is composed of a set of skills to define it. The collection set is defined by the Collection (Set) Management Tool.
   * @deprecated Use query queryEnterpriseCollectionsByProgram instead. skill ID's can be passed in using passThroughParameters.
   */
  queryEnterpriseCollectionsByTargetSkillProfile?: Maybe<DiscoveryCollections_CursoredProductCollections>;
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryByDisplayContextArgs = {
  input: DiscoveryCollections_QueryByDisplayContextInput;
  limit: Scalars['Int'];
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryByDisplayContextDuplicateArgs = {
  input: DiscoveryCollections_QueryByDisplayContextInput;
  limit: Scalars['Int'];
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryCollectionsArgs = {
  input?: InputMaybe<DiscoveryCollections_QueryCollectionsInput>;
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryEnterpriseCollectionBySkillIdArgs = {
  input: DiscoveryCollections_QueryEnterpriseCollectionBySkillIdInput;
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryEnterpriseCollectionsByOrganizationArgs = {
  input?: InputMaybe<DiscoveryCollections_QueryEnterpriseCollectionsByOrganizationInput>;
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryEnterpriseCollectionsByProgramArgs = {
  input?: InputMaybe<DiscoveryCollections_QueryEnterpriseCollectionsByProgramInput>;
};


/**
 * Queries relating to returning a complete data set of a list of collections.
 * Sets of collections are defined here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollectionsQueriesQueryEnterpriseCollectionsByTargetSkillProfileArgs = {
  input?: InputMaybe<DiscoveryCollections_QueryEnterpriseCollectionsByTspInput>;
};

/**
 * Fields representing a Clip (also known as a video) product.
 * This type name is formatted as DiscoveryCollections_UpperCase, instead of DiscoveryCollections_lowerCase like the other types that implement DiscoveryCollections_learningProduct due to a lint rule that was introduced after the initial development of the schema.
 */
export type DiscoveryCollections_Clip = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_Clip';
  /** The video duration of the Clip. */
  duration?: Maybe<Scalars['Duration']>;
  /** Clip ID. */
  id: Scalars['ID'];
  /** Marketing image for Clip. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Clip name. */
  name: Scalars['String'];
  /** The name of the parent course of the Clip. */
  parentCourseName?: Maybe<Scalars['String']>;
  /** The name of the parent lesson of the Clip. */
  parentLessonName?: Maybe<Scalars['String']>;
  /** List of partner IDs associated with Clip. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with Clip. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Clip slug. */
  slug: Scalars['String'];
  /** Note: Translation of the clip name is not supported currently. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL for Clip display page. */
  url: Scalars['String'];
  /** The number of views the Clip received. */
  views?: Maybe<Scalars['Int']>;
};

/** Learning product difficulty levels */
export const DiscoveryCollections_DifficultyLevel = {
  /** Advanced level */
  Advanced: 'ADVANCED',
  /** Beginner level */
  Beginner: 'BEGINNER',
  /** Intermediate level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type DiscoveryCollections_DifficultyLevel = typeof DiscoveryCollections_DifficultyLevel[keyof typeof DiscoveryCollections_DifficultyLevel];
/**
 * A parameter that is directly passed through to a collection.
 * See this for more information on how to use pass through parameters: https://coursera.atlassian.net/wiki/spaces/UD/pages/175374364/Collections#Pass-Through-Parameters
 */
export type DiscoveryCollections_PassThroughParameter = {
  /** The name of a parameter used in a collection. */
  name: Scalars['String'];
  /** The value that will be injected/replaced */
  value: Scalars['String'];
};

/**
 * A list of collections to be displayed on a webpage or within a specific part of a webpage.
 * This is unpaginated on purpose, because:
 * 1. Some collections are assigned randomized positions, so there's additional complexity in support preserving
 * the randomized order between requests for different pages.
 * 2. We don't expect more than ~10 collections to be returned.
 */
export type DiscoveryCollections_ProductCollectionsResult = {
  __typename?: 'DiscoveryCollections_ProductCollectionsResult';
  /** An ordered list of product collections. */
  elements: Array<DiscoveryCollections_ProductCollection>;
  /** The ID of this collection set. This will be in the format contextType~contextId. */
  id: Scalars['ID'];
};

/**
 * Compare this input to `DiscoveryCollections_queryCollectionsInput`:
 * * DiscoveryCollections_queryCollectionsInput: more like querying by ID, where contextType + contextId forms a composite
 * ID and the exact collection set keyed by the ID is returned.
 * * DiscoveryCollections_QueryByDisplayContextInput: the client provides where they want to display the collections and
 * the server will compute the optimal collection list to return.
 */
export type DiscoveryCollections_QueryByDisplayContextInput = {
  /**
   * Container on the page where the FE wants to display this collection list, e.g. "rc-CuratedCollections" or
   * "rc-BrowseCollections".
   * The default value is "page", which means that there is only one container on this page that displays collection sets,
   * and there is therefore no need to distinguish between different containers within the page.
   */
  container?: Scalars['String'];
  /** Page where the FE wants to display this collection list, e.g. "LIHP" (logged-in home page). */
  page: Scalars['String'];
};

/** Input to get a single skill-based collection within enterprise program context */
export type DiscoveryCollections_QueryEnterpriseCollectionBySkillIdInput = {
  /** The desired maximum number of entities per collection */
  maxNumberOfEntityIds?: InputMaybe<Scalars['Int']>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['ID'];
  /** SkillId specifies the id used to fetch skill-based recommendations */
  skillId: Scalars['ID'];
};

/** Fields representing a course product. */
export type DiscoveryCollections_Course = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_course';
  /** True if we should display product with first two partner logos. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DiscoveryCollections_DifficultyLevel>;
  /** The ids of the domains, e.g. 'business'. This doesn't hold subdomain id. */
  domainIds: Array<Scalars['ID']>;
  /**
   *  List of enterprise custom course sessions.
   * This field is applicable and will be populated only with enterprise apis.
   * Unfortunately, there is no easy way in GraphQL+DGS to isolate enterprise
   * context in this case while avoiding some code duplication and potentially
   * leaking enterprise context in the generic entitiesDataLoader.
   * If in the future we discover more use cases and want to avoid type bloating,
   * we can do more investigations of the alternatives or group all attributes together.
   * Likely, enterprise logic will be extracted into a different service before that.
   */
  enterpriseCustomSessions?: Maybe<Array<Maybe<DiscoveryCollections_LearningProductSession>>>;
  /** Course ID. */
  id: Scalars['ID'];
  /** Marekting image for course. */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if the course is free and/or should be promoted as such. */
  isCostFree?: Maybe<Scalars['Boolean']>;
  /** True if this product is part of the Coursera Plus catalog. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Course name. */
  name: Scalars['String'];
  /** List partner IDs associated with the course. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List partners associated with the course. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Course slug. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages: Array<Scalars['String']>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL to course display page. */
  url: Scalars['String'];
};

/** A list of collections at a particular page */
export type DiscoveryCollections_CursoredProductCollections = {
  __typename?: 'DiscoveryCollections_cursoredProductCollections';
  /** This is a nullable parameter indicating next index that can be used to request more collections */
  next?: Maybe<Scalars['Int']>;
  /** Collection of Coursera products */
  productCollections?: Maybe<Array<Maybe<DiscoveryCollections_ProductCollection>>>;
};

/** Fields representing a degree product. */
export type DiscoveryCollections_Degree = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_degree';
  /** Degree ID. */
  id: Scalars['ID'];
  /** Marketing image for degree. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Degree name. */
  name: Scalars['String'];
  /** List of partner IDs associated with degree. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with degree. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Degree slug. */
  slug: Scalars['String'];
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL for degree display page. */
  url: Scalars['String'];
};

/** Fields representing a guided project product. */
export type DiscoveryCollections_GuidedProject = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_guidedProject';
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DiscoveryCollections_DifficultyLevel>;
  /** The ids of the domains, e.g. 'business'. This doesn't hold subdomain id. */
  domainIds: Array<Scalars['ID']>;
  /** See description for this attribute in DiscoveryCollections_course */
  enterpriseCustomSessions?: Maybe<Array<Maybe<DiscoveryCollections_LearningProductSession>>>;
  /** Guided project ID. */
  id: Scalars['ID'];
  /** Marketing image for guided project. */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if the guided project is free and/or should be promoted as such. */
  isCostFree?: Maybe<Scalars['Boolean']>;
  /** True if this product is part of the Coursera Plus catalog. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Guided project name. */
  name: Scalars['String'];
  /** List of partner IDs associated with guided project. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with guided project. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Guided project slug. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages: Array<Scalars['String']>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL to guided project display page. */
  url: Scalars['String'];
};

/** Interface for common fields amongst all Coursera products. */
export type DiscoveryCollections_LearningProduct = {
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The URL of the image for the learning product. */
  imageUrl?: Maybe<Scalars['String']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The partner IDs for the learning product - used internally. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The partners for the learning product. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** The relative URL of the learning product. */
  url: Scalars['String'];
};

/** Session information for a product. */
export type DiscoveryCollections_LearningProductSession = {
  __typename?: 'DiscoveryCollections_learningProductSession';
  /** Session course id. */
  courseId: Scalars['String'];
  /** Learning product session end timestamp. */
  endsAt: Timestamp;
  /** The ID of session. */
  id: Scalars['ID'];
  /** Learning product session start timestamp. */
  startsAt: Timestamp;
};

/** Some collections have a dedicated page. This holds that info. */
export type DiscoveryCollections_LinkedCollectionPageMetadata = {
  __typename?: 'DiscoveryCollections_linkedCollectionPageMetadata';
  /** The URL for the collection page associated with the collection. */
  url?: Maybe<Scalars['String']>;
};

/** Fields representing a mastertrack product. */
export type DiscoveryCollections_MasterTrack = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_masterTrack';
  /** Mastertrack ID. */
  id: Scalars['ID'];
  /** Marketing image for mastertrack. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Mastertrack name. */
  name: Scalars['String'];
  /** List of partner IDs associated with mastertrack. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with mastertrack. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Mastertrack slug. */
  slug: Scalars['String'];
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL for mastertrack display page. */
  url: Scalars['String'];
};

/** Partner information on a product. */
export type DiscoveryCollections_Partner = {
  __typename?: 'DiscoveryCollections_partner';
  /** The ID of the partner. */
  id: Scalars['ID'];
  /** The logo for the partner. */
  logo?: Maybe<Scalars['String']>;
  /** The name of the partner. */
  name: Scalars['String'];
};

/** A collection containing a list of Coursera products. */
export type DiscoveryCollections_ProductCollection = {
  __typename?: 'DiscoveryCollections_productCollection';
  /** The entities associated with the collection. */
  entities?: Maybe<Array<Maybe<DiscoveryCollections_Clip | DiscoveryCollections_Course | DiscoveryCollections_Degree | DiscoveryCollections_GuidedProject | DiscoveryCollections_MasterTrack | DiscoveryCollections_ProfessionalCertificate | DiscoveryCollections_Project | DiscoveryCollections_Specialization>>>;
  /** The ID of the collection. */
  id: Scalars['ID'];
  /** The label/title of the collection. */
  label: Scalars['String'];
  /** The metadata associated with the collection. */
  linkedCollectionPageMetadata?: Maybe<DiscoveryCollections_LinkedCollectionPageMetadata>;
};

/** Fields representing a professional certificate product. */
export type DiscoveryCollections_ProfessionalCertificate = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_professionalCertificate';
  /** True if we should display product with first two partner logos. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of courses in the specialization. */
  courseCount: Scalars['Int'];
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DiscoveryCollections_DifficultyLevel>;
  /** The ids of the domains, e.g. 'business'. This doesn't hold subdomain id. */
  domainIds: Array<Scalars['ID']>;
  /** See some information about this attribute in DiscoveryCollections_specialization. */
  enterpriseCustomSessions?: Maybe<Array<Maybe<DiscoveryCollections_LearningProductSession>>>;
  /** Professional certificate ID. */
  id: Scalars['ID'];
  /** Marketing image for professional certificate. */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if this product is part of the Coursera Plus catalog. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Professional Certificates' latest child/base ID. */
  latestS12nId: Scalars['ID'];
  /** Professional certificate name. */
  name: Scalars['String'];
  /** List of partner IDs associated with professional certificate. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with professional certificate. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Professional certificate slug. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages: Array<Scalars['String']>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL for professional certificate display page. */
  url: Scalars['String'];
};

/** Fields representing a project product. */
export type DiscoveryCollections_Project = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_project';
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DiscoveryCollections_DifficultyLevel>;
  /** The ids of the domains, e.g. 'business'. This doesn't hold subdomain id. */
  domainIds: Array<Scalars['ID']>;
  /** See description for this attribute in DiscoveryCollections_course */
  enterpriseCustomSessions?: Maybe<Array<Maybe<DiscoveryCollections_LearningProductSession>>>;
  /** Project ID. */
  id: Scalars['ID'];
  /** Marketing image for project. */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if the Project is free and/or should be promoted as such. */
  isCostFree?: Maybe<Scalars['Boolean']>;
  /** True if this product is part of the Coursera Plus catalog. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Project name. */
  name: Scalars['String'];
  /** List of partner IDs associated with project. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associated with project. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Project slug. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages: Array<Scalars['String']>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL for project display page. */
  url: Scalars['String'];
};

/**
 * Standard input for discovery collection query.
 * contextType and contextId are defined in the collections tool here: coursera.org/collections-tool/browse.
 */
export type DiscoveryCollections_QueryCollectionsInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
};

/** Input to get collections within enterprise context. ProgramId and organizationId can't be both null at the same time */
export type DiscoveryCollections_QueryEnterpriseCollectionsByOrganizationInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Pagination cursor. */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** Contains organizationId, representing the context of collections being fetched */
  organizationId: Scalars['String'];
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
};

/** Input to get collections within enterprise context. ProgramId and organizationId can't be both null at the same time */
export type DiscoveryCollections_QueryEnterpriseCollectionsByProgramInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Pagination cursor. */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['String'];
};

/** Input to get collections within enterprise+targetSkillProfile (TSP) context */
export type DiscoveryCollections_QueryEnterpriseCollectionsByTspInput = {
  /** ContextId specifies a unique ID that describes the specific context in which the collections should be shown. Defined in the browse collections tool */
  contextId: Scalars['String'];
  /** ContextType describes the larger context in which the collections should be shown. Defined in the browse collections tool */
  contextType: Scalars['String'];
  /** Information to navigate response collections */
  cursor: DiscoveryCollections_RequestDataCursor;
  /** The desired maximum number of entities per collection */
  maxNumberOfEntityIds?: InputMaybe<Scalars['Int']>;
  /** A list of parameters to pass through to underlying collections. */
  passThroughParameters?: InputMaybe<Array<DiscoveryCollections_PassThroughParameter>>;
  /** Contains programId, representing the context of collections being fetched. One organization can have multiple different learning programs */
  programId: Scalars['String'];
  /** Contains tspId, representing the id for a targetSkillProfile we will be fetching products within collection for */
  targetSkillProfileId: Scalars['String'];
};

/** Information to navigate response collections */
export type DiscoveryCollections_RequestDataCursor = {
  /** Maximum number of returned collections */
  limit: Scalars['Int'];
  /** First 0-based collection index to return */
  start: Scalars['Int'];
};

/** Fields representing a specialization product. */
export type DiscoveryCollections_Specialization = DiscoveryCollections_LearningProduct & {
  __typename?: 'DiscoveryCollections_specialization';
  /** True if we should display product with first two partner logos. */
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of courses in the specialization. */
  courseCount: Scalars['Int'];
  /** The difficulty level of the learning product. */
  difficultyLevel?: Maybe<DiscoveryCollections_DifficultyLevel>;
  /** The ids of the domains, e.g. 'business'. This doesn't hold subdomain id. */
  domainIds: Array<Scalars['ID']>;
  /**
   * See some information about this attribute in DiscoveryCollections_course.
   * For specializations is be holding sessions of the underlying courses.
   */
  enterpriseCustomSessions?: Maybe<Array<Maybe<DiscoveryCollections_LearningProductSession>>>;
  /** Specialization ID. */
  id: Scalars['ID'];
  /** Marketing image for specialization. */
  imageUrl?: Maybe<Scalars['String']>;
  /** True if this product is part of the Coursera Plus catalog. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Specialization's latest child/base ID. */
  latestS12nId: Scalars['ID'];
  /** Specialization name. */
  name: Scalars['String'];
  /** List of partner IDs associated with specialization. */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of partners associatd with specialization. */
  partners?: Maybe<Array<Maybe<DiscoveryCollections_Partner>>>;
  /** The language codes of the primary languages used in the learning product, e.g. 'en' */
  primaryLanguages: Array<Scalars['String']>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Specialization slug. */
  slug: Scalars['String'];
  /** The language codes of the languages used in subtitles of the learning product, e.g. 'en' */
  subtitleLanguages: Array<Scalars['String']>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Relative URL to specialization display page. */
  url: Scalars['String'];
};

/** Queries that return Domains */
export type DomainQueries = {
  __typename?: 'DomainQueries';
  /** Return all domains */
  getAllDomains: Array<Domain_Domain>;
  /** Given an ID of a Domain, return the Domain. Returns null if there is no Domain with that ID. */
  queryById?: Maybe<Domain_Domain>;
  /** Given a list of IDs of Domains, return the Domains. Returns null if there is no Domain with that ID. */
  queryByIds: Array<Domain_Domain>;
  /**
   * Given a Domain slug, return the corresponding Domain
   * Returns null if there is no Domain with that slug
   */
  queryBySlug?: Maybe<Domain_Domain>;
};


/** Queries that return Domains */
export type DomainQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Queries that return Domains */
export type DomainQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Queries that return Domains */
export type DomainQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};

/** Placeholder for eventual Domain_Domain entity */
export type Domain_Domain = {
  __typename?: 'Domain_Domain';
  /** The background image URL of the Domain. */
  backgroundImageUrl?: Maybe<Scalars['URL']>;
  /** The description of the Domain. */
  description: Scalars['String'];
  /** The display color of the Domain in hex code. Example, "#FF0000" */
  displayColor?: Maybe<Scalars['String']>;
  /** The ID of the domain. */
  id: Scalars['ID'];
  /** The keywords of the Domain. */
  keywords: Array<Scalars['String']>;
  /** The name of the Domain. */
  name: Scalars['String'];
  /** The slug of the Domain. */
  slug: Scalars['String'];
  /** The subdomains of the Domain. */
  subdomains: Array<Domain_Subdomain>;
};

/** A Subdomain is a sub-category of a Domain. For example, "Marketing" is a Subdomain of the "Business" Domain. */
export type Domain_Subdomain = {
  __typename?: 'Domain_Subdomain';
  /** The background image URL of the Subdomain. */
  backgroundImageUrl?: Maybe<Scalars['URL']>;
  /** The description of the Subdomain. */
  description: Scalars['String'];
  /** The domain of the Subdomain. */
  domain: Domain_Domain;
  /** The ID of the subdomain. Also acts as a slug. */
  id: Scalars['ID'];
  /** The keywords of the Subdomain. */
  keywords: Array<Scalars['String']>;
  /** The name of the Subdomain. */
  name: Scalars['String'];
  /** The slug of the Subdomain. */
  slug: Scalars['String'];
};

export type DomainsV1 = {
  __typename?: 'DomainsV1';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  displayColor: Scalars['String'];
  id: Scalars['String'];
  keywords: Array<Maybe<Scalars['String']>>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  subdomainIds: Array<Maybe<Scalars['String']>>;
  subdomains?: Maybe<SubdomainsV1Connection>;
  topic?: Maybe<Scalars['String']>;
};


export type DomainsV1SubdomainsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type DomainsV1Connection = {
  __typename?: 'DomainsV1Connection';
  elements: Array<Maybe<DomainsV1>>;
  paging: ResponsePagination;
};

export type DomainsV1Resource = {
  __typename?: 'DomainsV1Resource';
  get?: Maybe<DomainsV1>;
  getAll?: Maybe<DomainsV1Connection>;
  multiGet?: Maybe<DomainsV1Connection>;
  slug?: Maybe<DomainsV1Connection>;
};


export type DomainsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type DomainsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DomainsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type DomainsV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type DomainsV1Slug = {
  __typename?: 'DomainsV1Slug';
  connection?: Maybe<DomainsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

/** All queries related to fetching the questions in a draft question bank */
export type DraftQuestionBankQuestionsQueries = {
  __typename?: 'DraftQuestionBankQuestionsQueries';
  /** Search question bank Questions */
  search: QuestionBank_QuestionBankQuestionWithValidationPaginatedResult;
  /** Search question bank Questions */
  searchV2: QuestionBank_QuestionBankQuestionWithValidationPaginatedResultV2;
};


/** All queries related to fetching the questions in a draft question bank */
export type DraftQuestionBankQuestionsQueriesSearchArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  difficultyLevels?: InputMaybe<Array<QuestionBank_QuestionDifficultyLevel>>;
  id: Scalars['ID'];
  includeUnassignedDifficultyLevel: Scalars['Boolean'];
  includeUnassignedQuestionCategoryId: Scalars['Boolean'];
  invalidQuestionsOnly: Scalars['Boolean'];
  keywordsQuery: Scalars['String'];
  limit?: Scalars['Int'];
  questionCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  questionGeneratorBatchId?: InputMaybe<Scalars['ID']>;
};


/** All queries related to fetching the questions in a draft question bank */
export type DraftQuestionBankQuestionsQueriesSearchV2Args = {
  cursor?: InputMaybe<Scalars['String']>;
  difficultyLevels?: InputMaybe<Array<QuestionBank_QuestionDifficultyLevel>>;
  includeUnassignedDifficultyLevel: Scalars['Boolean'];
  includeUnassignedQuestionCategoryId: Scalars['Boolean'];
  invalidQuestionsOnly: Scalars['Boolean'];
  keywordsQuery: Scalars['String'];
  limit?: Scalars['Int'];
  questionBankId: Scalars['ID'];
  questionCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  questionGeneratorBatchId?: InputMaybe<Scalars['ID']>;
};

/**
 * This dummy type is used as a response type in application-specific DummyDataFetcher to support nested queries.
 * The query executor does not allow for null or empty response types.
 */
export type DummyData = {
  __typename?: 'DummyData';
  /** TODO: Complete this description */
  value?: Maybe<Scalars['String']>;
};

export type DummyType = {
  __typename?: 'DummyType';
  test?: Maybe<Scalars['String']>;
};

/** All DynamicPrompt queries */
export type DynamicPromptQueries = {
  __typename?: 'DynamicPromptQueries';
  /** Returns dynamic prompts for a given context based on user progress */
  queryForDynamicPrompts: AiCoach_DynamicPromptsResult;
};


/** All DynamicPrompt queries */
export type DynamicPromptQueriesQueryForDynamicPromptsArgs = {
  contextType: AiCoach_ContextType;
  courseBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
};

/** Email Whitelist Queries */
export type EmailWhitelistQueries = {
  __typename?: 'EmailWhitelistQueries';
  /**
   * Checks if an email address is in the whitelist.
   * Returns true if the email is whitelisted, false otherwise.
   */
  isEmailInWhitelist: Scalars['Boolean'];
};


/** Email Whitelist Queries */
export type EmailWhitelistQueriesIsEmailInWhitelistArgs = {
  email: Scalars['String'];
};

/** Input parameters for adding email to whitelist. */
export type EmailWhitelist_AddToWhitelistInput = {
  /** The email address to add to the whitelist. */
  email: Scalars['String'];
};

/** Result of adding email to whitelist operation. */
export type EmailWhitelist_AddToWhitelistResult = {
  __typename?: 'EmailWhitelist_AddToWhitelistResult';
  /** Status message describing the result. */
  message: Scalars['String'];
  /** Whether the operation was successful. */
  success: Scalars['Boolean'];
};

/** Input parameters for removing email from whitelist. */
export type EmailWhitelist_RemoveFromWhitelistInput = {
  /** The email address to remove from the whitelist. */
  email: Scalars['String'];
};

/** Result of removing email from whitelist operation. */
export type EmailWhitelist_RemoveFromWhitelistResult = {
  __typename?: 'EmailWhitelist_RemoveFromWhitelistResult';
  /** Status message describing the result. */
  message: Scalars['String'];
  /** Whether the operation was successful. */
  success: Scalars['Boolean'];
};

/** Admin query operations for the LMS-iframe embedding allowlist (EmbeddedExp). */
export type EmbeddedExpQueries = {
  __typename?: 'EmbeddedExpQueries';
  /**
   * Get all embedding allowed domains for an organization. By default only active
   * domains are returned; set includeInactive to true to also return inactive ones.
   */
  getAllowedDomainsByOrg: EmbeddedExp_AllowedDomainsByOrgResult;
};


/** Admin query operations for the LMS-iframe embedding allowlist (EmbeddedExp). */
export type EmbeddedExpQueriesGetAllowedDomainsByOrgArgs = {
  includeInactive?: Scalars['Boolean'];
  orgId: Scalars['ID'];
};

/** Input type for adding an allowed embedding domain for an organization. */
export type EmbeddedExp_AddAllowedDomainInput = {
  /** The domain permitted to embed Coursera */
  domain: Scalars['URL'];
  /**
   * Whether the domain should be active. Non-nullable with a default so clients
   * cannot override the intended default (active) by passing null.
   */
  isActive?: Scalars['Boolean'];
  /** The organization ID to add the allowed domain for */
  orgId: Scalars['ID'];
};

/** Result of adding an allowed domain. */
export type EmbeddedExp_AddAllowedDomainResult = {
  __typename?: 'EmbeddedExp_AddAllowedDomainResult';
  /** The newly added allowed domain */
  domain: EmbeddedExp_AllowedDomain;
};

/** A domain that is allowed to embed Coursera in an LMS iframe for an organization. */
export type EmbeddedExp_AllowedDomain = {
  __typename?: 'EmbeddedExp_AllowedDomain';
  /** ISO-8601 timestamp when this allowed domain record was created */
  createdAt: Scalars['DateTime'];
  /** The user ID that created this allowed domain record */
  createdBy: Scalars['ID'];
  /** The domain permitted to embed Coursera (used to build the CSP frame-ancestors header) */
  domain: Scalars['URL'];
  /** DB primary key for the allowed domain record */
  id: Scalars['ID'];
  /** Whether the domain is currently active. Only active domains are enforced at the edge. */
  isActive: Scalars['Boolean'];
  /** The organization ID this allowed domain belongs to */
  orgId: Scalars['ID'];
  /** ISO-8601 timestamp when this allowed domain record was last updated */
  updatedAt: Scalars['DateTime'];
  /** The user ID that last updated this allowed domain record */
  updatedBy: Scalars['ID'];
};

/** Result containing all allowed domains for an organization. */
export type EmbeddedExp_AllowedDomainsByOrgResult = {
  __typename?: 'EmbeddedExp_AllowedDomainsByOrgResult';
  /** The allowed domains for the organization */
  domains: Array<EmbeddedExp_AllowedDomain>;
};

/** Input type for deleting (soft-deleting) an allowed embedding domain. */
export type EmbeddedExp_DeleteAllowedDomainInput = {
  /** The allowed domain record ID to delete */
  id: Scalars['ID'];
};

/** Result of deleting (soft-deleting) an allowed domain. */
export type EmbeddedExp_DeleteAllowedDomainResult = {
  __typename?: 'EmbeddedExp_DeleteAllowedDomainResult';
  /** The deleted allowed domain */
  domain: EmbeddedExp_AllowedDomain;
};

/**
 * Input type for updating an allowed embedding domain. Behaves as a patch: only
 * the fields that are explicitly provided are updated; a field that is omitted is
 * left unchanged (it is not nulled out). At least one of domain or isActive must
 * be provided.
 */
export type EmbeddedExp_UpdateAllowedDomainInput = {
  /** The new domain value. Optional; at least one of domain or isActive is required. */
  domain?: InputMaybe<Scalars['URL']>;
  /** The allowed domain record ID to update */
  id: Scalars['ID'];
  /** The new active state. Optional; at least one of domain or isActive is required. */
  isActive?: InputMaybe<Scalars['Boolean']>;
};

/** Result of updating an allowed domain. */
export type EmbeddedExp_UpdateAllowedDomainResult = {
  __typename?: 'EmbeddedExp_UpdateAllowedDomainResult';
  /** The updated allowed domain */
  domain: EmbeddedExp_AllowedDomain;
};

export type EnrollmentAvailableChoicesV1 = {
  __typename?: 'EnrollmentAvailableChoicesV1';
  courseId: Scalars['String'];
  enrollmentChoiceReasonCode?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode>;
  enrollmentChoices: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoice>>;
  id: Scalars['String'];
  productId: Scalars['String'];
  productType: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType;
  specializationId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type EnrollmentAvailableChoicesV1Connection = {
  __typename?: 'EnrollmentAvailableChoicesV1Connection';
  elements: Array<Maybe<EnrollmentAvailableChoicesV1>>;
  paging: ResponsePagination;
};

export type EnrollmentAvailableChoicesV1Resource = {
  __typename?: 'EnrollmentAvailableChoicesV1Resource';
  get?: Maybe<EnrollmentAvailableChoicesV1>;
  multiGet?: Maybe<EnrollmentAvailableChoicesV1Connection>;
};


export type EnrollmentAvailableChoicesV1ResourceGetArgs = {
  id: Scalars['String'];
  includeProgramInvitationCheck?: InputMaybe<Scalars['Boolean']>;
};


export type EnrollmentAvailableChoicesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeProgramInvitationCheck?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnrollmentAvailableChoicesV1_Enroll_Through_Coursera_PlusMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_ENROLL_THROUGH_COURSERA_PLUSMember';
  ENROLL_THROUGH_COURSERA_PLUS: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_EnrollThroughCourseraPlusEnrollmentChoiceData;
};

export type EnrollmentAvailableChoicesV1_Enroll_Through_S12N_PrepaidMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_ENROLL_THROUGH_S12N_PREPAIDMember';
  ENROLL_THROUGH_S12N_PREPAID: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_S12nPrepaidData;
};

export type EnrollmentAvailableChoicesV1_Enroll_Through_S12N_SubscriptionMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_ENROLL_THROUGH_S12N_SUBSCRIPTIONMember';
  ENROLL_THROUGH_S12N_SUBSCRIPTION: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_S12nSubscriptionData;
};

export type EnrollmentAvailableChoicesV1_Purchase_Coursera_Tier_LiteMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_PURCHASE_COURSERA_TIER_LITEMember';
  PURCHASE_COURSERA_TIER_LITE: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_PurchaseCourseraTierLiteEnrollmentChoiceData;
};

export type EnrollmentAvailableChoicesV1_PrepaidProductPropertiesMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_PrepaidProductPropertiesMember';
  PrepaidProductProperties: EnrollmentAvailableChoicesV1_Org_Coursera_Product_PrepaidProductProperties;
};

export type EnrollmentAvailableChoicesV1_Subscribe_To_CatalogMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_SUBSCRIBE_TO_CATALOGMember';
  SUBSCRIBE_TO_CATALOG: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_CatalogSubscriptionData;
};

export type EnrollmentAvailableChoicesV1_Subscribe_To_Coursera_PlusMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_SUBSCRIBE_TO_COURSERA_PLUSMember';
  SUBSCRIBE_TO_COURSERA_PLUS: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_SubscribeToCourseraPlusEnrollmentChoiceData;
};

export type EnrollmentAvailableChoicesV1_SubscriptionProductPropertiesMember = {
  __typename?: 'EnrollmentAvailableChoicesV1_SubscriptionProductPropertiesMember';
  SubscriptionProductProperties: EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductProperties;
};

export type EnrollmentAvailableChoicesV1_EnrollmentChoiceData = EnrollmentAvailableChoicesV1_Enroll_Through_Coursera_PlusMember | EnrollmentAvailableChoicesV1_Enroll_Through_S12N_PrepaidMember | EnrollmentAvailableChoicesV1_Enroll_Through_S12N_SubscriptionMember | EnrollmentAvailableChoicesV1_Purchase_Coursera_Tier_LiteMember | EnrollmentAvailableChoicesV1_Subscribe_To_CatalogMember | EnrollmentAvailableChoicesV1_Subscribe_To_Coursera_PlusMember;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_CatalogSubscriptionData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_CatalogSubscriptionData';
  availableSubscriptions: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_SubscriptionProduct>>;
};

/** Tracks all the information associated with an enrollment choice */
export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoice = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_EnrollmentChoice';
  enrollmentChoiceData?: Maybe<EnrollmentAvailableChoicesV1_EnrollmentChoiceData>;
  enrollmentChoiceType: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType;
};

/** Choice reason code to give meta informaton to the clients on the enrollment choices returned. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode = {
  BlockedOnIos: 'BLOCKED_ON_IOS',
  CapstoneAccessLocked: 'CAPSTONE_ACCESS_LOCKED',
  CatalogSubscribed: 'CATALOG_SUBSCRIBED',
  EarnedS12NCertificate: 'EARNED_S12N_CERTIFICATE',
  Enrolled: 'ENROLLED',
  EnrolledRestrictedAudit: 'ENROLLED_RESTRICTED_AUDIT',
  NoAvailableSession: 'NO_AVAILABLE_SESSION',
  PurchasedSingleCourse: 'PURCHASED_SINGLE_COURSE',
  ReachedMaxAllowance: 'REACHED_MAX_ALLOWANCE',
  RegionBlocked: 'REGION_BLOCKED',
  SpecializationBulkPaid: 'SPECIALIZATION_BULK_PAID',
  SpecializationEnrolledThroughCourseraPlus: 'SPECIALIZATION_ENROLLED_THROUGH_COURSERA_PLUS',
  SpecializationSubscribed: 'SPECIALIZATION_SUBSCRIBED',
  SpecializationUpgradeRequired: 'SPECIALIZATION_UPGRADE_REQUIRED'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceReasonCode];
/** List of enrollment choices that are available to clients to show on the different enroll modals. TODO(CatalogSubscriptions Deprecation): There were 3 CatalogSubscription EnrollmentChoiceTypes that used to exist in this enum but have been deleted:  - SUBSCRIBE_TO_CATALOG  - SUBSCRIBE_TO_CATALOG_TRIAL  - UPGRADE_TO_CATALOG_SUBSCRIPTION  Leaving this comment here for context until we can finish deprecating the related client code.  See https://docs.google.com/document/d/1CDH0zUCI7BSpZwEfXMTd-MgqzB66F_IBSABuNSawOWI/edit# for additional context. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType = {
  AuditCourse: 'AUDIT_COURSE',
  BulkpayFullSpecialization: 'BULKPAY_FULL_SPECIALIZATION',
  BulkpayRemainingSpecializationCourses: 'BULKPAY_REMAINING_SPECIALIZATION_COURSES',
  EnrollCourse: 'ENROLL_COURSE',
  EnrollCourseWithFullDiscount: 'ENROLL_COURSE_WITH_FULL_DISCOUNT',
  EnrollThroughCourseraPlus: 'ENROLL_THROUGH_COURSERA_PLUS',
  EnrollThroughGroup: 'ENROLL_THROUGH_GROUP',
  EnrollThroughProgram: 'ENROLL_THROUGH_PROGRAM',
  EnrollThroughProgramInvitation: 'ENROLL_THROUGH_PROGRAM_INVITATION',
  EnrollThroughS12NPrepaid: 'ENROLL_THROUGH_S12N_PREPAID',
  EnrollThroughS12NSubscription: 'ENROLL_THROUGH_S12N_SUBSCRIPTION',
  EnrollThroughS12NSubscriptionTrial: 'ENROLL_THROUGH_S12N_SUBSCRIPTION_TRIAL',
  PurchaseCourseraTierLite: 'PURCHASE_COURSERA_TIER_LITE',
  PurchaseSingleCourse: 'PURCHASE_SINGLE_COURSE',
  SubscribeToCourseraPlus: 'SUBSCRIBE_TO_COURSERA_PLUS'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_EnrollmentChoiceType];
/** The product type that enrollment choices api supports. Historically we used org.coursera.product.ProductType file. As that file being diverged to be used in payment related product such as subscription, facilatedLearning, it is time for enrollment choices api to has its own product type that it supports. for backward compatibility, we use camel case just as org.coursera.product.ProductType. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType = {
  Specialization: 'Specialization',
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_ProductType];
export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_S12nPrepaidData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_S12nPrepaidData';
  availablePrepaid: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_PrepaidProduct>>;
  s12Ids: Array<Maybe<Scalars['String']>>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_S12nSubscriptionData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_S12nSubscriptionData';
  availableSubscriptions: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_SubscriptionProduct>>;
  s12Ids: Array<Maybe<Scalars['String']>>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusCourseEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseraplus_CourseraPlusCourseEnrollmentChoiceData';
  courseId: Scalars['String'];
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseraplus_CourseraPlusEnrollmentChoiceData';
  courseEnrollmentChoiceData?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusCourseEnrollmentChoiceData>;
  courseraPlusPermutationToDisplay?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Product_ProductSku>;
  hasExhaustedFreeTrial?: Maybe<Scalars['Boolean']>;
  s12nEnrollmentChoiceData?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusS12nEnrollmentChoiceData>;
  s12nSubscriptionEnrollmentChoiceData?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusS12nEnrollmentChoiceData>;
  tier?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusS12nEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseraplus_CourseraPlusS12nEnrollmentChoiceData';
  prepaid: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_PrepaidProduct>>;
  s12nId: Scalars['String'];
  subscription?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_SubscriptionProduct>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_EnrollThroughCourseraPlusEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseraplus_EnrollThroughCourseraPlusEnrollmentChoiceData';
  enrollmentChoiceData: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusEnrollmentChoiceData;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_SubscribeToCourseraPlusEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseraplus_SubscribeToCourseraPlusEnrollmentChoiceData';
  enrollmentChoiceData: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_CourseraPlusEnrollmentChoiceData;
};

/** List of Coursera Subscription Tiers. */
export const EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier = {
  CourseraPlus: 'COURSERA_PLUS',
  Lite: 'LITE'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseraplus_Tier];
export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_CourseraTierLiteEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseratierlite_CourseraTierLiteEnrollmentChoiceData';
  hasExhaustedFreeTrial?: Maybe<Scalars['Boolean']>;
  isCourseraTierLiteEnrollmentEnabled?: Maybe<Scalars['Boolean']>;
  s12nEnrollmentChoiceData?: Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_CourseraTierLiteS12nEnrollmentChoiceData>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_CourseraTierLiteS12nEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseratierlite_CourseraTierLiteS12nEnrollmentChoiceData';
  s12nId: Scalars['String'];
  subscription: Array<Maybe<EnrollmentAvailableChoicesV1_Org_Coursera_S12n_SubscriptionProduct>>;
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_PurchaseCourseraTierLiteEnrollmentChoiceData = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_enrollment_courseratierlite_PurchaseCourseraTierLiteEnrollmentChoiceData';
  enrollmentChoiceData: EnrollmentAvailableChoicesV1_Org_Coursera_Enrollment_Courseratierlite_CourseraTierLiteEnrollmentChoiceData;
};

export const EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle = {
  Annual: 'ANNUAL',
  Biannual: 'BIANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle];
/** Product properties associated with one-time payment products. */
export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_PrepaidProductProperties = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_product_PrepaidProductProperties';
  ownershipDays: Scalars['Int'];
  refundDays: Scalars['Int'];
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_ProductSku = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_product_ProductSku';
  iapSku?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  productItemId: Scalars['String'];
  productType: Scalars['String'];
  properties?: Maybe<EnrollmentAvailableChoicesV1_Properties>;
  underlyingProductId: Scalars['String'];
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductProperties = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_product_SubscriptionProductProperties';
  billingCycle: EnrollmentAvailableChoicesV1_Org_Coursera_Product_BillingCycle;
  numberOfCycles?: Maybe<Scalars['Int']>;
  numberOfTrialDays: Scalars['Int'];
  refundDays?: Maybe<Scalars['Int']>;
  status: EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus;
};

export const EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus[keyof typeof EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus];
export type EnrollmentAvailableChoicesV1_Org_Coursera_S12n_PrepaidProduct = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_s12n_PrepaidProduct';
  productItemId: Scalars['String'];
  productProperties: EnrollmentAvailableChoicesV1_Org_Coursera_Product_PrepaidProductProperties;
  productType: Scalars['String'];
};

export type EnrollmentAvailableChoicesV1_Org_Coursera_S12n_SubscriptionProduct = {
  __typename?: 'EnrollmentAvailableChoicesV1_org_coursera_s12n_SubscriptionProduct';
  productItemId: Scalars['String'];
  productProperties: EnrollmentAvailableChoicesV1_Org_Coursera_Product_SubscriptionProductProperties;
  productType: Scalars['String'];
};

/** Properties associated to a product offering. Will be refactored out in separate tables as part of Next Gen Product Configuration project in Q2 2021. */
export type EnrollmentAvailableChoicesV1_Properties = EnrollmentAvailableChoicesV1_PrepaidProductPropertiesMember | EnrollmentAvailableChoicesV1_SubscriptionProductPropertiesMember;

/** Data containing the code and companion information on why the user cannot enroll. */
export type EnrollmentBlockingReason = {
  __typename?: 'EnrollmentBlockingReason';
  /** Reason code why the learner cannot enroll into the product */
  enrollmentChoiceReasonCode?: Maybe<EnrollmentChoiceReasonCode>;
  /** Metadata attached to when blocking enrollment */
  enrollmentChoiceReasonMetadata?: Maybe<EnrollmentChoiceReasonMetadata>;
};

/** TODO: Complete this description */
export type EnrollmentChoice = {
  __typename?: 'EnrollmentChoice';
  /**
   * Companion information for an enrollment choice.
   * FE uses it to render specific visuals and create a payment cart.
   */
  enrollmentChoiceInfo?: Maybe<EnrollmentChoice_EnrollmentChoiceInfo>;
  /** TODO: Complete this description */
  enrollmentChoiceType: EnrollmentChoice_EnrollmentChoiceType;
  /** Companion information for pre-enrollment enrollment choice. */
  preEnrollmentChoiceInfo?: Maybe<EnrollmentChoice_PreEnrollmentChoice>;
};

/** Enrollment Choice Response */
export type EnrollmentChoicePayload = {
  __typename?: 'EnrollmentChoicePayload';
  /** Course ID */
  courseId?: Maybe<Scalars['ID']>;
  /** Reason why the enrollment to the product is blocked. */
  enrollmentBlockingReason?: Maybe<EnrollmentBlockingReason>;
  /**
   * Reason for enrollment blocking
   * @deprecated Please use enrollmentBlockingReason
   */
  enrollmentChoiceReasonCode?: Maybe<EnrollmentChoiceReasonCode>;
  /**
   * Metadata attached to when blocking enrollment
   * @deprecated Please use enrollmentBlockingReason
   */
  enrollmentChoiceReasonMetadata?: Maybe<EnrollmentChoiceReasonMetadata>;
  /** All enrollment choices for the given product */
  enrollmentChoices: Array<EnrollmentChoice>;
  /**
   * Blocking enrollment choices for an s12n.
   *
   * This field is used for the mix-and-match case where a given course can be part of multiple s12ns,
   * and may have different enrollment status for all the s12ns.
   */
  s12nEnrollmentBlockingData?: Maybe<Array<Maybe<S12nEnrollmentBlockingData>>>;
  /** Specialization ID */
  specializationId?: Maybe<Scalars['ID']>;
};

/** All enrollmentChoice queries */
export type EnrollmentChoiceQueries = {
  __typename?: 'EnrollmentChoiceQueries';
  /** This query returns if a user can enroll into a course or s12n via different product choices. */
  enrollmentChoices: EnrollmentChoicePayload;
  /** Check if a logged in user is eligible to access coach on the specified course ID. */
  queryCoachAccessEligibility: EnrollmentChoice_CoachAccessEligibility;
};


/** All enrollmentChoice queries */
export type EnrollmentChoiceQueriesEnrollmentChoicesArgs = {
  includeProgramInvitationCheck?: InputMaybe<Scalars['Boolean']>;
  productItemId: Scalars['ID'];
  productType: Scalars['String'];
  userId: Scalars['Int'];
};


/** All enrollmentChoice queries */
export type EnrollmentChoiceQueriesQueryCoachAccessEligibilityArgs = {
  courseId: Scalars['ID'];
};

/** Reasons to block enrollment */
export const EnrollmentChoiceReasonCode = {
  /** Blocked on iOS (i.e. if price is too high for in-app purchases). */
  BlockedOnIos: 'BLOCKED_ON_IOS',
  /** User is not eligible to enroll in the underlying product. */
  CapstoneAccessLocked: 'CAPSTONE_ACCESS_LOCKED',
  /** User has a catalog subscription. */
  CatalogSubscribed: 'CATALOG_SUBSCRIBED',
  /**
   * Use has s12n certificate when they finish a superset of a s12n.
   * FE will see this EnrollmentChoiceReasonCode and create an S12nMembership.
   */
  EarnedS12NCertificate: 'EARNED_S12N_CERTIFICATE',
  /** User is already enrolled in the underlying product. */
  Enrolled: 'ENROLLED',
  /** User is not eligible to pre-enroll in an s12n which is currently pre-enrolling */
  NotEligibleToPreEnroll: 'NOT_ELIGIBLE_TO_PRE_ENROLL',
  /** Currently no session avaialbe for a course, meaning a leaner can not enroll. */
  NoAvailableSession: 'NO_AVAILABLE_SESSION',
  /** User is already pre-enrolled in the given specialization */
  PreEnrolled: 'PRE_ENROLLED',
  /** User has purchased this course. */
  PurchasedSingleCourse: 'PURCHASED_SINGLE_COURSE',
  /** Currently no session avaialbe for a course, meaning a leaner can not enroll. */
  ReachedMaxAllowance: 'REACHED_MAX_ALLOWANCE',
  /** Blocked by Sanction. */
  RegionBlocked: 'REGION_BLOCKED',
  /** User already bulk paid for the underlying specialization. */
  SpecializationBulkPaid: 'SPECIALIZATION_BULK_PAID',
  /**
   * User enrolled in the underlying specialization through Coursera Plus
   * Used for computing choices for courses in a specialization
   */
  SpecializationEnrolledThroughCourseraPlus: 'SPECIALIZATION_ENROLLED_THROUGH_COURSERA_PLUS',
  /** User already subscribed the underlying specialization. */
  SpecializationSubscribed: 'SPECIALIZATION_SUBSCRIBED',
  /** User cannot enroll into an old version of this s12n. */
  SpecializationUpgradeRequired: 'SPECIALIZATION_UPGRADE_REQUIRED'
} as const;

export type EnrollmentChoiceReasonCode = typeof EnrollmentChoiceReasonCode[keyof typeof EnrollmentChoiceReasonCode];
/** Metadata containing information required by the front-end for when blocking enrollment. */
export type EnrollmentChoiceReasonMetadata = {
  __typename?: 'EnrollmentChoiceReasonMetadata';
  /** Metadata containing information required by the front-end for when blocking enrollment. */
  enrollmentChoiceReasonMetadata?: Maybe<EnrollmentChoice_EnrollmentChoiceReasonMetadata>;
};

/** BillingCycles supported by existing subscriptions. */
export const EnrollmentChoice_BillingCycle = {
  /** Billed annually */
  Annual: 'ANNUAL',
  /** Billed Bi-anually */
  Biannual: 'BIANNUAL',
  /** Billed Monthly */
  Monthly: 'MONTHLY'
} as const;

export type EnrollmentChoice_BillingCycle = typeof EnrollmentChoice_BillingCycle[keyof typeof EnrollmentChoice_BillingCycle];
/** Response for coach access eligibility */
export type EnrollmentChoice_CoachAccessEligibility = {
  __typename?: 'EnrollmentChoice_CoachAccessEligibility';
  /** True if coach access is eligible on the course, false otherwise. */
  isEligible: Scalars['Boolean'];
};

/** Companion information for ENROLLMENT_CHOICE_TYPE_SUBSCRIBE_TO_COURSERA_PLUS and ENROLLMENT_CHOICE_TYPE_ENROLL_THROUGH_COURSERA_PLUS. */
export type EnrollmentChoice_CourseraPlusInfo = {
  __typename?: 'EnrollmentChoice_CourseraPlusInfo';
  /** optional. Only exists when a user queries enrollment choice for a course. */
  courseEnrollmentChoiceInfo?: Maybe<CourseraPlusCourseEnrollmentChoiceInfo>;
  /**
   * Product information of Coursera Plus with different permutations
   * (i.e. different billing cycles, free trial periods, etc)
   */
  courseraPlusPermutationToDisplay?: Maybe<EnrollmentChoice_ProductSku>;
  /** Metadata populated only when the learner is enrolling through a Coursera Tier product. */
  enrollThroughCourseraTierMetadata?: Maybe<EnrollmentChoice_EnrollThroughCourseraTierMetadata>;
  /**
   * Flag signaling if the user has activated a free trial for Coursera Plus. Starts as false.
   * Switches to true when they first obtain a free trial for Coursera Plus and remains true thereafter.
   * Null means EAC did not check free trial state for the given request.
   */
  hasExhaustedFreeTrial?: Maybe<Scalars['Boolean']>;
  /**
   * Eligible sku information represented using ownable product tuple (next-gen product fulfillment concepts).
   * This field will ideally replace the `courseraPlusPermutationToDisplay` from above.
   */
  ownableProductTuple?: Maybe<SharedOwnableProduct_OwnableProductTuple>;
  /** optional. Only exists when a user queries enrollment choice for a s12n. */
  s12nEnrollmentChoiceInfo?: Maybe<EnrollmentChoice_CourseraPlusS12nEnrollmentChoiceInfo>;
  /**
   * optional. Only exists for ENROLL_THROUGH_COURSERA_PLUS. The Coursera Subscription Tier.
   * @deprecated Please use enrollThroughCourseraTierMetadata instead
   */
  tier?: Maybe<EnrollmentChoice_Tier>;
};

/** Product properties related to the CourseraPlus sku enrollment option returned to the user. */
export type EnrollmentChoice_CourseraPlusProductProperties = EnrollmentChoice_PrepaidProductProperties | EnrollmentChoice_SubscriptionProductProperties;

/** S12n related info when a user queries enrollment choice for a s12n via coursera plus. */
export type EnrollmentChoice_CourseraPlusS12nEnrollmentChoiceInfo = {
  __typename?: 'EnrollmentChoice_CourseraPlusS12nEnrollmentChoiceInfo';
  /** Eligible sku information represented using ownable product tuple (next-gen product fulfillment concepts). */
  ownableProductTuples?: Maybe<Array<SharedOwnableProduct_OwnableProductTuple>>;
  /** Associated product information */
  productInfo: Array<EnrollmentChoice_ProductInfo>;
  /** Specialization ID */
  s12nId: Scalars['ID'];
};

/** Companion information for ENROLLMENT_CHOICE_TYPE_PURCHASE_COURSERA_TIER_LITE. */
export type EnrollmentChoice_CourseraTierLiteInfo = {
  __typename?: 'EnrollmentChoice_CourseraTierLiteInfo';
  /** Enrollment choice info specific to the Course. */
  courseEnrollmentChoiceInfo?: Maybe<EnrollmentChoice_CourseraTierLite_CourseEnrollmentChoiceInfo>;
  /**
   * Flag signaling if the user has activated a free trial for Coursera Lite. Starts as false.
   * Switches to true when they first obtain a free trial for Coursera Lite and remains true thereafter.
   * Null means EAC did not check free trial state for the given request.
   */
  hasExhaustedFreeTrial?: Maybe<Scalars['Boolean']>;
  /** Enrollment choice info specific to the S12N. */
  s12nEnrollmentChoiceInfo?: Maybe<EnrollmentChoice_CourseraTierLite_S12nEnrollmentChoiceInfo>;
};

/**
 * Course related info when a user queries enrollment choice for a standalone course via Coursera Tier
 * Lite.
 */
export type EnrollmentChoice_CourseraTierLite_CourseEnrollmentChoiceInfo = {
  __typename?: 'EnrollmentChoice_CourseraTierLite_CourseEnrollmentChoiceInfo';
  /** Course to be queried for enrollment choices */
  course: Course_Course;
};

/** S12N related info when a user queries enrollment choice for a S12N via Coursera Tier Lite. */
export type EnrollmentChoice_CourseraTierLite_S12nEnrollmentChoiceInfo = {
  __typename?: 'EnrollmentChoice_CourseraTierLite_S12nEnrollmentChoiceInfo';
  /** Eligible sku information represented using ownable product tuple (next-gen product fulfillment concepts). */
  ownableProductTuples?: Maybe<Array<SharedOwnableProduct_OwnableProductTuple>>;
  /** Associated product information */
  productInfo: Array<EnrollmentChoice_ProductInfo>;
  /** Specialization ID */
  s12nId: Scalars['ID'];
};

/** Metadata for enrolling through Coursera Tier (Plus or Lite). */
export type EnrollmentChoice_EnrollThroughCourseraTierMetadata = {
  __typename?: 'EnrollmentChoice_EnrollThroughCourseraTierMetadata';
  /**
   * Coursera Tier sku tuple currently owned by the learner
   * optional : because it is only populated for the coursera plus case
   */
  ownedTierProductTuple: SharedOwnableProduct_OwnableProductTuple;
  /** Enrollment choice tier */
  tier: EnrollmentChoice_Tier;
};

/**
 * Companion information for an enrollment choice.
 * FE uses it to render specific visuals and create a payment cart.
 */
export type EnrollmentChoice_EnrollmentChoiceInfo = EnrollmentChoice_CourseraPlusInfo | EnrollmentChoice_CourseraTierLiteInfo | EnrollmentChoice_S12nPrepaidInfo | EnrollmentChoice_S12nSubscriptionInfo;

/** Metadata containing information required by the front-end for when blocking enrollment. */
export type EnrollmentChoice_EnrollmentChoiceReasonMetadata = EnrollmentChoice_NotEligibleToPreEnrollMetadata | EnrollmentChoice_PreEnrolledMetadata;

/** List of enrollment choices that are available to clients to show on the different enroll modals. */
export const EnrollmentChoice_EnrollmentChoiceType = {
  /** Enrollment choice when the user is just going to audit the course */
  AuditCourse: 'AUDIT_COURSE',
  /** Enrollment choice when a user can purchase the full specialization */
  BulkpayFullSpecialization: 'BULKPAY_FULL_SPECIALIZATION',
  /** Enrollment choice when a user can purchase the remaining part of the specialization */
  BulkpayRemainingSpecializationCourses: 'BULKPAY_REMAINING_SPECIALIZATION_COURSES',
  /** Enrollment choice to be enrolled in the course for free */
  EnrollCourse: 'ENROLL_COURSE',
  /** Enrollment choice to be enrolled with a full (100%) discount */
  EnrollCourseWithFullDiscount: 'ENROLL_COURSE_WITH_FULL_DISCOUNT',
  /** The user is allowed to enroll in this content through CourseraPlus. */
  EnrollThroughCourseraPlus: 'ENROLL_THROUGH_COURSERA_PLUS',
  /** The user is part of a group that gives them access to the course/s12n */
  EnrollThroughGroup: 'ENROLL_THROUGH_GROUP',
  /** The user is part of a program that gives them access to the course/s12n */
  EnrollThroughProgram: 'ENROLL_THROUGH_PROGRAM',
  /** The user has a program invitation that gives them access to the course/s12n */
  EnrollThroughProgramInvitation: 'ENROLL_THROUGH_PROGRAM_INVITATION',
  /** The user is allowed to enroll to the s12n through prepaid payment options */
  EnrollThroughS12NPrepaid: 'ENROLL_THROUGH_S12N_PREPAID',
  /** The user is allowed to enroll to the s12n through subscription */
  EnrollThroughS12NSubscription: 'ENROLL_THROUGH_S12N_SUBSCRIPTION',
  /** The user is allowed to enroll to the s12n through subscription for a trial duration */
  EnrollThroughS12NSubscriptionTrial: 'ENROLL_THROUGH_S12N_SUBSCRIPTION_TRIAL',
  /** The user is eligible to pre-enroll into the course/s12n */
  PreEnrollmentEligible: 'PRE_ENROLLMENT_ELIGIBLE',
  /** The user is allowed to enroll in this content through Coursera Tier Lite */
  PurchaseCourseraTierLite: 'PURCHASE_COURSERA_TIER_LITE',
  /** Enrollment choice for a user to purchase just that one course */
  PurchaseSingleCourse: 'PURCHASE_SINGLE_COURSE',
  /** The user is able to subscribe to CourseraPlus. */
  SubscribeToCourseraPlus: 'SUBSCRIBE_TO_COURSERA_PLUS'
} as const;

export type EnrollmentChoice_EnrollmentChoiceType = typeof EnrollmentChoice_EnrollmentChoiceType[keyof typeof EnrollmentChoice_EnrollmentChoiceType];
/** Metadata related to when EnrollmentChoiceReasonCode = NOT_ELIGIBLE_TO_PRE_ENROLL */
export type EnrollmentChoice_NotEligibleToPreEnrollMetadata = {
  __typename?: 'EnrollmentChoice_NotEligibleToPreEnrollMetadata';
  /** The tentative launch timestamp of the s12n. */
  plannedLaunchTimestamp: Timestamp;
};

/** Metadata related to when EnrollmentChoiceReasonCode = PRE_ENROLLED */
export type EnrollmentChoice_PreEnrolledMetadata = {
  __typename?: 'EnrollmentChoice_PreEnrolledMetadata';
  /** The tentative launch timestamp of the s12n. */
  plannedLaunchTimestamp: Timestamp;
  /** Pre-enrollment id from the pre-enrollment-application system. */
  preEnrollmentId: Scalars['ID'];
};

/** Companion information for pre-enrollment enrollment choice. */
export type EnrollmentChoice_PreEnrollmentChoice = EnrollmentChoice_S12nPreEnrollmentInfo;

/** Prepaid product information required during cart creation. */
export type EnrollmentChoice_PrepaidProduct = {
  __typename?: 'EnrollmentChoice_PrepaidProduct';
  /** Product ID */
  productId: EnrollmentChoice_ProductId;
  /** Prepaid product properties */
  productProperties: EnrollmentChoice_PrepaidProductProperties;
};

/** Prepaid product properties required during cart creation. */
export type EnrollmentChoice_PrepaidProductProperties = {
  __typename?: 'EnrollmentChoice_PrepaidProductProperties';
  /** Ownership period for this prepaid product in days. */
  ownershipDays: Scalars['Int'];
  /** Number of days this prepaid product allows for refund. */
  refundDays: Scalars['Int'];
};

/** Product Id type encapsulating both the Type and ID together in one object. */
export type EnrollmentChoice_ProductId = {
  __typename?: 'EnrollmentChoice_ProductId';
  /** Product item ID identifying the corresponding product. */
  productItemId: Scalars['ID'];
  /**
   * Product types supported by the enrollment choice endpoints. It is a subset (VerifiedCertificate and Specialization) of product types
   * in the payment system.
   */
  productType: EnrollmentChoice_ProductType;
};

/** Union type containing either of subscription or prepaid product information. */
export type EnrollmentChoice_ProductInfo = EnrollmentChoice_PrepaidProduct | EnrollmentChoice_SubscriptionProduct;

/** Product information for Coursera Plus. */
export type EnrollmentChoice_ProductSku = {
  __typename?: 'EnrollmentChoice_ProductSku';
  /** Whether the product is active */
  isActive: Scalars['Boolean'];
  /** Top level Product ID */
  productId: EnrollmentChoice_ProductId;
  /** Product properties. */
  productProperties: EnrollmentChoice_CourseraPlusProductProperties;
  /** Underlying Product ID */
  underlyingProductId: EnrollmentChoice_ProductId;
};

/** Product types supported by payment system. */
export const EnrollmentChoice_ProductType = {
  /** Site wide subscription */
  CatalogSubscription: 'CatalogSubscription',
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'CourseraPlus',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'CourseraPlusSubscription',
  /** TODO: Complete this description */
  CredentialTrackCourse: 'CredentialTrackCourse',
  /**
   * A new version of CredentialTrackCourse that has different revenue recognition and ownership
   * granting logic from the original version. Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  CredentialTrackCourseV2: 'CredentialTrackCourseV2',
  /** TODO: Complete this description */
  CredentialTrackSubscription: 'CredentialTrackSubscription',
  /**
   * A new version of CredentialTrackSubscription that has different revenue recognition and
   * ownership granting logic from the original version. Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  CredentialTrackSubscriptionV2: 'CredentialTrackSubscriptionV2',
  /** TODO: Complete this description */
  EnterpriseContract: 'EnterpriseContract',
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type EnrollmentChoice_ProductType = typeof EnrollmentChoice_ProductType[keyof typeof EnrollmentChoice_ProductType];
/** The s12n pre-enrollment information used by the FE when displaying pre-enrollment details. */
export type EnrollmentChoice_S12nPreEnrollmentInfo = {
  __typename?: 'EnrollmentChoice_S12nPreEnrollmentInfo';
  /** The tentative launch timestamp of the s12n. */
  plannedLaunchTimestamp: Timestamp;
  /** Specialization ID */
  s12nId: Scalars['ID'];
};

/** The s12n information when the user is allowed to enroll via a prepaid payment option. */
export type EnrollmentChoice_S12nPrepaidInfo = {
  __typename?: 'EnrollmentChoice_S12nPrepaidInfo';
  /** Available pre-paid products. Must contain at least one prepaid configuration. */
  availablePrepaidProducts: Array<EnrollmentChoice_PrepaidProduct>;
  /** Eligible sku information represented using ownable product tuple (next-gen product fulfillment concepts). */
  ownableProductTuples?: Maybe<Array<SharedOwnableProduct_OwnableProductTuple>>;
  /** Specialization ID */
  s12nId: Scalars['ID'];
};

/**
 * The s12n information when the user is allowed to enroll in this content. The original model has
 * an array of s12n, but there should be max one s12n/subscription in s12nSubscriptionInfo
 */
export type EnrollmentChoice_S12nSubscriptionInfo = {
  __typename?: 'EnrollmentChoice_S12nSubscriptionInfo';
  /** Available subscription products */
  availableSubscriptionProducts: Array<EnrollmentChoice_SubscriptionProduct>;
  /**
   * Flag signaling if the user has activated a free trial for this S12n. Starts as false.
   * Switches to true when they first obtain a free trial for this S12n and remains true thereafter.
   * Null means EAC did not check free trial state for the given request.
   */
  hasExhaustedFreeTrial?: Maybe<Scalars['Boolean']>;
  /** Eligible sku information represented using ownable product tuple (next-gen product fulfillment concepts). */
  ownableProductTuples?: Maybe<Array<SharedOwnableProduct_OwnableProductTuple>>;
  /** Specialization ID */
  s12nId: Scalars['ID'];
};

/** Subscription product required during cart creation. */
export type EnrollmentChoice_SubscriptionProduct = {
  __typename?: 'EnrollmentChoice_SubscriptionProduct';
  /** Product ID */
  productId: EnrollmentChoice_ProductId;
  /** Subscription product properties */
  productProperties: EnrollmentChoice_SubscriptionProductProperties;
};

/**
 * Subscription product properties required during cart creation.
 * In courier there is a `status: SubscriptionProductPropertiesStatus = "ENABLED"` field was not added
 * here, since this field is no longer used and will be removed.
 */
export type EnrollmentChoice_SubscriptionProductProperties = {
  __typename?: 'EnrollmentChoice_SubscriptionProductProperties';
  /** Billing Cycle */
  billingCycle?: Maybe<EnrollmentChoice_BillingCycle>;
  /**
   * Number of billing cycles until subscription becomes Expired. NULL will default to the
   * subscription plan's default configured on the payment processor gateway.
   */
  numberOfCycles?: Maybe<Scalars['Int']>;
  /** Number of free trial days offered */
  numberOfTrialDays: Scalars['Int'];
};

/** List of Coursera Subscription Tiers. */
export const EnrollmentChoice_Tier = {
  /** Tier for Coursera Plus. */
  CourseraPlus: 'COURSERA_PLUS',
  /** Tier for Coursera Tier Lite. */
  Lite: 'LITE'
} as const;

export type EnrollmentChoice_Tier = typeof EnrollmentChoice_Tier[keyof typeof EnrollmentChoice_Tier];
/** Queries for enterprise collections */
export type EntCollectionQueries = {
  __typename?: 'EntCollectionQueries';
  /** Query for an enterprise collection based on the skill and program Id */
  queryCurriculumCollectionBySkill: EntCollection_Collection;
  /**
   * Fetch list of collections based on all the skills of target skill profile associated with the program.
   *
   * If skillId is provided, then it will fetch the collection only of the skill provided for
   * the provided target skill profile.
   */
  queryCurriculumCollectionBySkillAndTargetSkillProfile?: Maybe<Array<EntCollection_Collection>>;
  /**
   * Fetch list of collections for all the target skill profiles associated with the program.
   *
   * If targetSkillProfileId is provided, then it will fetch the collection only of provided
   * target skill profile.
   */
  queryCurriculumCollectionByTargetSkillProfile?: Maybe<Array<EntCollection_Collection>>;
};


/** Queries for enterprise collections */
export type EntCollectionQueriesQueryCurriculumCollectionBySkillArgs = {
  id: Scalars['ID'];
  skillId: Scalars['ID'];
};


/** Queries for enterprise collections */
export type EntCollectionQueriesQueryCurriculumCollectionBySkillAndTargetSkillProfileArgs = {
  id: Scalars['ID'];
  skillId?: InputMaybe<Scalars['ID']>;
  targetSkillProfileId: Scalars['ID'];
};


/** Queries for enterprise collections */
export type EntCollectionQueriesQueryCurriculumCollectionByTargetSkillProfileArgs = {
  id: Scalars['ID'];
  targetSkillProfileId?: InputMaybe<Scalars['ID']>;
};

/** Queries for enterprise collections with org slug */
export type EntCollectionWithOrgQueries = {
  __typename?: 'EntCollectionWithOrgQueries';
  /** Query for an enterprise collection based on the skill and org slug */
  queryCurriculumCollectionBySkill: EntCollection_Collection;
  /**
   * Fetch list of collections based on all the skills of target skill profile associated with the org slug.
   *
   * If skillId is provided, then it will fetch the collection only of the skill provided for
   * the provided target skill profile.
   */
  queryCurriculumCollectionBySkillAndTargetSkillProfile?: Maybe<EntCollection_CollectionPaginatedResult>;
  /**
   * Fetch list of collections for all the target skill profiles associated with the org slug.
   *
   * If targetSkillProfileId is provided, then it will fetch the collection only of provided
   * target skill profile.
   */
  queryCurriculumCollectionByTargetSkillProfile?: Maybe<EntCollection_CollectionPaginatedResult>;
};


/** Queries for enterprise collections with org slug */
export type EntCollectionWithOrgQueriesQueryCurriculumCollectionBySkillArgs = {
  orgSlug: Scalars['String'];
  skillId: Scalars['ID'];
};


/** Queries for enterprise collections with org slug */
export type EntCollectionWithOrgQueriesQueryCurriculumCollectionBySkillAndTargetSkillProfileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
  skillId?: InputMaybe<Scalars['ID']>;
  targetSkillProfileId: Scalars['ID'];
};


/** Queries for enterprise collections with org slug */
export type EntCollectionWithOrgQueriesQueryCurriculumCollectionByTargetSkillProfileArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
  targetSkillProfileId?: InputMaybe<Scalars['ID']>;
};

/**
 * Union type representing a collection of enterprise collections.
 * Currently, it only includes the Recommendation_Collection type.
 */
export type EntCollection_Collection = Recommendation_Collection;

/** Additional metadata regarding collection. */
export type EntCollection_CollectionContextMetadata = {
  __typename?: 'EntCollection_CollectionContextMetadata';
  /**
   * Curriculum collection id in the format of `${programId}~${trackId}`. This is the format used by naptime APIs:
   * https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/program/curriculum/CurriculumCollectionId.courier
   */
  curriculumCollectionId: Scalars['ID'];
  /** List of skills that are associated with the collection. */
  skills?: Maybe<Array<Skill_Skill>>;
  /** Organization specific target skill profile id. */
  targetSkillProfileId: Scalars['ID'];
};

/** Paginated response for EntCollection_Collection */
export type EntCollection_CollectionPaginatedResult = {
  __typename?: 'EntCollection_CollectionPaginatedResult';
  /** List of page components. */
  elements: Array<EntCollection_Collection>;
  /** Pagination information. */
  pagination: Pagination;
};

/** All EntCurriculum queries. */
export type EntCurriculumQueries = {
  __typename?: 'EntCurriculumQueries';
  /**
   * Returns the paginated, deduplicated list of curriculum domains across all programs in an
   * organization. Resolves the org slug to programs internally and aggregates domains from each
   * program's curriculum. If any program has a wildcard (full catalog) curriculum, returns all
   * domains; otherwise returns only domains explicitly configured in domains-type curricula.
   * Powers the DomainPills component on the public org home page.
   */
  getOrgCurriculumDomains: EntCurriculum_OrgCurriculumDomainsPaginatedResult;
  /**
   * Fetch org-scoped paginated curated collections for the view-all page.
   * Collections are ordered by program enrollment date (most recent first),
   * with admin order preserved within each program.
   */
  orgCuratedCollections: EntCurriculum_OrgCuratedCollections;
  /**
   * Check whether the authenticated user is enrolled in a specific product
   * within an organization. Returns enrollment state and the source program.
   */
  orgProductEnrollmentStatus?: Maybe<EntCurriculum_OrgProductEnrollmentStatusResult>;
};


/** All EntCurriculum queries. */
export type EntCurriculumQueriesGetOrgCurriculumDomainsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};


/** All EntCurriculum queries. */
export type EntCurriculumQueriesOrgCuratedCollectionsArgs = {
  orgSlug: Scalars['String'];
};


/** All EntCurriculum queries. */
export type EntCurriculumQueriesOrgProductEnrollmentStatusArgs = {
  orgSlug: Scalars['String'];
  productId: Scalars['ID'];
  productType: EntCurriculum_CurriculumItemType;
};

/** Common fields shared by all curriculum collection items. */
export type EntCurriculum_BaseCollectionItem = {
  /** Content ID (course ID, specialization ID, etc.). */
  contentId: Scalars['ID'];
  /** Type of content. */
  itemType: EntCurriculum_CurriculumItemType;
};

/** A single curriculum item within a collection. */
export type EntCurriculum_CollectionItem = EntCurriculum_BaseCollectionItem & {
  __typename?: 'EntCurriculum_CollectionItem';
  /** Content ID (course ID, specialization ID, etc.). */
  contentId: Scalars['ID'];
  /** Type of content. */
  itemType: EntCurriculum_CurriculumItemType;
};

/** Represents EntCurriculum_CollectionProgramSummary entity stub - Added for federation */
export type EntCurriculum_CollectionProgramSummary = {
  __typename?: 'EntCurriculum_CollectionProgramSummary';
  /** Number of curated collections in this program. */
  collectionCount?: Maybe<Scalars['Int']>;
  /** Enterprise Program. */
  program: EnterpriseProgram_EnterpriseProgram;
};

/** A content domain available in one or more program curricula within an organization. */
export type EntCurriculum_CurriculumDomain = {
  __typename?: 'EntCurriculum_CurriculumDomain';
  /** Domain entity from discovery-domains-application, resolvable via federation. */
  domain: Domain_Domain;
  /** Human-readable domain name (e.g. "Computer Science"). */
  domainName: Scalars['String'];
  /** Catalog-level product count for this domain. */
  productCount: Scalars['Int'];
  /** URL-friendly slug (e.g. "computer-science"). */
  slug: Scalars['String'];
  /** Child subdomains under this domain, resolvable via federation. */
  subdomains: Array<Domain_Subdomain>;
};

/** Type of curriculum item. */
export const EntCurriculum_CurriculumItemType = {
  /** A standard Coursera course. */
  Course: 'COURSE',
  /** A private/custom course. */
  PrivateCourse: 'PRIVATE_COURSE',
  /** A specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type EntCurriculum_CurriculumItemType = typeof EntCurriculum_CurriculumItemType[keyof typeof EntCurriculum_CurriculumItemType];
/** A curated collection within a program, flattened for paginated display. */
export type EntCurriculum_OrgCuratedCollection = {
  __typename?: 'EntCurriculum_OrgCuratedCollection';
  /** Unique collection ID (maps to a CurriculumTrack in the Scala service). */
  collectionId: Scalars['ID'];
  /** When the collection was created. Null for collections created before July 2024. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Collection description (CML rendered to plain text). */
  description?: Maybe<Scalars['String']>;
  /**
   * Fallback gradient identifier for the collection card background (e.g. "gradient-1").
   * Admin-configured, opaque to the backend. The frontend maps this to a CSS gradient.
   * Source: CurriculumTrack.gradient in infra-services.
   */
  gradient?: Maybe<Scalars['String']>;
  /** Collection card image URL. */
  image?: Maybe<Scalars['String']>;
  /** True if this collection also appears in a higher-priority program. */
  isDuplicate: Scalars['Boolean'];
  /** Items (courses, specializations, etc.) within this collection. */
  items: Array<EntCurriculum_CollectionItem>;
  /** Enterprise program */
  program?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /** Recommended items within this collection. */
  recommendedItems: Recommendation_Collection;
  /** Admin-defined sort order within its program. */
  sortOrder: Scalars['Int'];
  /** Collection title. */
  title: Scalars['String'];
};

/** Represents EntCurriculum_OrgCuratedCollections entity stub - Added for federation */
export type EntCurriculum_OrgCuratedCollections = {
  __typename?: 'EntCurriculum_OrgCuratedCollections';
  /** If true only for-credit (core) curriculum tracks are included in the collections */
  forCreditOnly?: Maybe<Scalars['Boolean']>;
  /** List of programs and their collection counts. */
  programs: Array<EntCurriculum_CollectionProgramSummary>;
  /** Paginated result of curated collection */
  result?: Maybe<EntCurriculum_OrgCuratedCollectionsPaginatedResult>;
};


/** Represents EntCurriculum_OrgCuratedCollections entity stub - Added for federation */
export type EntCurriculum_OrgCuratedCollectionsResultArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Paginated result for org-scoped curated collections. */
export type EntCurriculum_OrgCuratedCollectionsPaginatedResult = {
  __typename?: 'EntCurriculum_OrgCuratedCollectionsPaginatedResult';
  /** Curated collections for the current page. */
  elements: Array<EntCurriculum_OrgCuratedCollection>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Paginated result for org-scoped curriculum domains. */
export type EntCurriculum_OrgCurriculumDomainsPaginatedResult = {
  __typename?: 'EntCurriculum_OrgCurriculumDomainsPaginatedResult';
  /** Curriculum domains for the current page. */
  elements: Array<EntCurriculum_CurriculumDomain>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Derived enrollment state for a user/product within an organization. */
export const EntCurriculum_OrgProductEnrollmentState = {
  /**
   * The user was previously enrolled via a program in the organization but has since lost
   * program-level access (e.g. program membership ended). The user retains audit-only
   * access to the product.
   */
  Auditing: 'AUDITING',
  /** The user is actively enrolled in the product via a program in the organization. */
  Enrolled: 'ENROLLED',
  /** The user has been selected for (but not yet enrolled in) the product via a program. */
  Selected: 'SELECTED'
} as const;

export type EntCurriculum_OrgProductEnrollmentState = typeof EntCurriculum_OrgProductEnrollmentState[keyof typeof EntCurriculum_OrgProductEnrollmentState];
/** Result of checking whether a user is enrolled in a product within an organization. */
export type EntCurriculum_OrgProductEnrollmentStatusResult = {
  __typename?: 'EntCurriculum_OrgProductEnrollmentStatusResult';
  /**
   * Whether the user is enrolled or selected for this product in the organization.
   * Convenience field equivalent to `state == ENROLLED`.
   */
  isEnrolled: Scalars['Boolean'];
  /** The product item ID. */
  productId: Scalars['ID'];
  /** The type of product (COURSE, SPECIALIZATION, or PRIVATE_COURSE). */
  productType: EntCurriculum_CurriculumItemType;
  /** The program IDs through which the user has an enrollment record. Empty if no record exists. */
  programIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * Derived enrollment state for the product within the organization. Null if no
   * enrollment record exists for the user across any program in the org.
   */
  state?: Maybe<EntCurriculum_OrgProductEnrollmentState>;
};

/**
 * Input for EntCurriculum_UpdateProgramCurriculum. Mirrors the Naptime
 * update endpoint parameters; the curriculum body matches the Pegasus
 * typedDefinition shape of org.coursera.program.curriculum.Curriculum.
 */
export type EntCurriculum_UpdateProgramCurriculumInput = {
  /**
   * If true, allow the update to remove badge templates from existing
   * tracks. Default false — prevents accidental badge loss.
   */
  allowBadgeDeletion?: InputMaybe<Scalars['Boolean']>;
  /**
   * If true, allow the update to clear clip references from existing
   * course items. Default false.
   */
  allowClearingClips?: InputMaybe<Scalars['Boolean']>;
  /**
   * Curriculum payload in Pegasus typedDefinition format — exactly one of
   * { "tracksCurriculum": {...} } or { "wildcardCurriculum": {...} }.
   * Schema matches org.coursera.program.curriculum.Curriculum.courier
   * in infra-services.
   */
  curriculum: Scalars['JSON'];
  /** Curriculum ID being updated (StringKey form). */
  curriculumId: Scalars['ID'];
  /**
   * Program ID that owns this curriculum. Required for authorization
   * (per-program edit permission) and verified server-side against the
   * curriculum's actual owner.
   */
  programId: Scalars['ID'];
  /**
   * If true, items the requester is not authorized to use are silently
   * dropped during validation instead of failing the update. Default false.
   */
  skipUnauthorizedProducts?: InputMaybe<Scalars['Boolean']>;
  /**
   * Free-form tag for audit logs identifying what surface drove this
   * update.
   */
  updateSource?: InputMaybe<Scalars['String']>;
};

/** Result of EntCurriculum_UpdateProgramCurriculum. */
export type EntCurriculum_UpdateProgramCurriculumResult = {
  __typename?: 'EntCurriculum_UpdateProgramCurriculumResult';
  /**
   * The full curriculum after the update was applied, in the same
   * typedDefinition shape as the request payload.
   */
  curriculum: Scalars['JSON'];
  /** The curriculum ID that was updated. */
  curriculumId: Scalars['ID'];
};

/** External platform gateway configuration queries. */
export type EntExternalConnectorQueries = {
  __typename?: 'EntExternalConnectorQueries';
  /** Gets external platform gateway configurations by organization ID. */
  getConfigurationsByOrganizationId: EntExternalConnector_GetConfigurationsByOrganizationIdResult;
};


/** External platform gateway configuration queries. */
export type EntExternalConnectorQueriesGetConfigurationsByOrganizationIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: EntExternalConnector_GetConfigurationsByOrganizationIdInput;
  limit?: Scalars['Int'];
};

/**
 * Union of platform-specific additional configuration options. New platform implementations
 * should be unioned here.
 */
export type EntExternalConnector_AdditionalConfiguration = EntExternalConnector_CsodAdditionalConfiguration;

/**
 * Input union for platform-specific additional configuration options. Exactly one platform
 * implementation must be provided.
 */
export type EntExternalConnector_AdditionalConfigurationInput = {
  /** Cornerstone OnDemand additional configuration. */
  csodAdditionalConfiguration?: InputMaybe<EntExternalConnector_CsodAdditionalConfigurationInput>;
};

/** Authentication configuration for external platform gateway integrations. */
export type EntExternalConnector_AuthenticationConfiguration = {
  __typename?: 'EntExternalConnector_AuthenticationConfiguration';
  /** Authentication URL for the integration. */
  authUrl: Scalars['URL'];
  /** Client ID for authentication. */
  clientId: Scalars['ID'];
  /**
   * Client secret for authentication. Omitted on read when not returned to the client;
   * may be a masked placeholder when the credential is stored but not revealed.
   */
  clientSecret?: Maybe<Scalars['String']>;
};

/** Input for authentication configuration. */
export type EntExternalConnector_AuthenticationConfigurationInput = {
  /** Authentication URL for the integration. */
  authUrl: Scalars['URL'];
  /** Client ID for authentication. */
  clientId: Scalars['ID'];
  /**
   * Client secret for authentication. Required on create when authConfig is provided.
   * Omit on update to retain the stored secret.
   */
  clientSecret?: InputMaybe<Scalars['String']>;
};

/** Cornerstone OnDemand (CSOD) additional configuration options. */
export type EntExternalConnector_CsodAdditionalConfiguration = {
  __typename?: 'EntExternalConnector_CSODAdditionalConfiguration';
  /** Client ID for the business API. */
  businessClientId: Scalars['ID'];
  /**
   * Client secret for the business API. Omitted on read when not returned to the client;
   * may be a masked placeholder when the credential is stored but not revealed.
   */
  businessClientSecret?: Maybe<Scalars['String']>;
  /** Whether content should be included in mobile experiences. */
  includeInMobile: Scalars['Boolean'];
  /** Program IDs associated with this configuration. */
  programIds: Array<Scalars['ID']>;
  /** Whether to use modalities when syncing content. */
  useModalities: Scalars['Boolean'];
  /** Whether to use subject mapping when syncing content. */
  useSubjectMapping: Scalars['Boolean'];
};

/** Input for Cornerstone OnDemand additional configuration. */
export type EntExternalConnector_CsodAdditionalConfigurationInput = {
  /** Client ID for the business API. */
  businessClientId: Scalars['ID'];
  /**
   * Client secret for the business API. Required on create when additionalConfigs is provided.
   * Omit on update to retain the stored secret.
   */
  businessClientSecret?: InputMaybe<Scalars['String']>;
  /** Whether content should be included in mobile experiences. */
  includeInMobile?: Scalars['Boolean'];
  /** Program IDs associated with this configuration. */
  programIds: Array<Scalars['ID']>;
  /** Whether to use modalities when syncing content. */
  useModalities?: Scalars['Boolean'];
  /** Whether to use subject mapping when syncing content. */
  useSubjectMapping?: Scalars['Boolean'];
};

/** External platform gateway configuration for enterprise LMS integrations. */
export type EntExternalConnector_Configuration = {
  __typename?: 'EntExternalConnector_Configuration';
  /** Whether the integration is active. */
  active: Scalars['Boolean'];
  /** Additional platform-specific configuration options. */
  additionalConfigs?: Maybe<EntExternalConnector_AdditionalConfiguration>;
  /** Authentication configuration for the integration. */
  authConfig?: Maybe<EntExternalConnector_AuthenticationConfiguration>;
  /** Content configuration for the integration. */
  contentConfig?: Maybe<EntExternalConnector_ContentConfiguration>;
  /** Timestamp when the configuration was created. */
  createdAt: Scalars['DateTime'];
  /** ID of the user who created the configuration. */
  createdBy: Scalars['ID'];
  /** Unique identifier for the configuration. */
  integrationId: Scalars['ID'];
  /** Organization ID associated with this configuration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: EntExternalConnector_PlatformType;
  /** Timestamp when the configuration was last updated. */
  updatedAt: Scalars['DateTime'];
  /** ID of the user who last updated the configuration. */
  updatedBy: Scalars['ID'];
};

/** Validation failure returned when create or update input fails validation on save. */
export type EntExternalConnector_ConfigurationValidationFailure = {
  __typename?: 'EntExternalConnector_ConfigurationValidationFailure';
  /** Overall summary of the validation failure. */
  message: Scalars['String'];
  /** Per-field validation errors. */
  validationErrors: Array<EntExternalConnector_ValidationError>;
};

/** Content configuration for external platform gateway integrations. */
export type EntExternalConnector_ContentConfiguration = {
  __typename?: 'EntExternalConnector_ContentConfiguration';
  /** Content URL for the integration. */
  contentUrl?: Maybe<Scalars['URL']>;
  /** Whether video content is enabled. */
  enableVideo: Scalars['Boolean'];
};

/** Input for content configuration. */
export type EntExternalConnector_ContentConfigurationInput = {
  /** Content URL for the integration. */
  contentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether video content is enabled. */
  enableVideo?: Scalars['Boolean'];
};

/**
 * Input to create an external platform gateway configuration. authConfig, contentConfig,
 * and additionalConfigs are optional to support progressive setup; validation runs on save.
 */
export type EntExternalConnector_CreateConfigurationInput = {
  /** Whether the integration is active. */
  active?: Scalars['Boolean'];
  /** Additional platform-specific configuration options. */
  additionalConfigs?: InputMaybe<EntExternalConnector_AdditionalConfigurationInput>;
  /** Authentication configuration for the integration. */
  authConfig?: InputMaybe<EntExternalConnector_AuthenticationConfigurationInput>;
  /** Content configuration for the integration. */
  contentConfig?: InputMaybe<EntExternalConnector_ContentConfigurationInput>;
  /** Organization ID associated with this configuration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: EntExternalConnector_PlatformType;
};

/**
 * Result of creating an external platform gateway configuration. Returns either the created
 * configuration or validation errors when input fails validation on save.
 */
export type EntExternalConnector_CreateConfigurationResult = EntExternalConnector_ConfigurationValidationFailure | EntExternalConnector_CreateConfigurationSuccess;

/** Successful result of creating an external platform gateway configuration. */
export type EntExternalConnector_CreateConfigurationSuccess = {
  __typename?: 'EntExternalConnector_CreateConfigurationSuccess';
  /** The created external platform gateway configuration. */
  config: EntExternalConnector_Configuration;
};

/** Input to delete an external platform gateway configuration. */
export type EntExternalConnector_DeleteConfigurationInput = {
  /** Unique identifier for the configuration to delete. */
  integrationId: Scalars['ID'];
  /** Organization ID associated with the configuration to delete. */
  organizationId: Scalars['ID'];
  /** Platform type for the configuration to delete. */
  platform: EntExternalConnector_PlatformType;
};

/** Result of deleting an external platform gateway configuration. */
export type EntExternalConnector_DeleteConfigurationResult = {
  __typename?: 'EntExternalConnector_DeleteConfigurationResult';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** Input to get external platform gateway configurations by organization ID. */
export type EntExternalConnector_GetConfigurationsByOrganizationIdInput = {
  /** Optional filter to only return active configurations. */
  activeOnly?: Scalars['Boolean'];
  /** The organization ID to filter by. */
  organizationId: Scalars['ID'];
  /** Platform type to filter by. */
  platform: EntExternalConnector_PlatformType;
};

/** Result of getting external platform gateway configurations by organization ID. */
export type EntExternalConnector_GetConfigurationsByOrganizationIdResult = {
  __typename?: 'EntExternalConnector_GetConfigurationsByOrganizationIdResult';
  /** List of external platform gateway configurations. */
  elements: Array<EntExternalConnector_Configuration>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Platform types supported by the external platform gateway. */
export const EntExternalConnector_PlatformType = {
  /** Cornerstone OnDemand platform. */
  PlatformTypeCornerstone: 'PLATFORM_TYPE_CORNERSTONE',
  /** Invalid platform type. */
  PlatformTypeInvalid: 'PLATFORM_TYPE_INVALID'
} as const;

export type EntExternalConnector_PlatformType = typeof EntExternalConnector_PlatformType[keyof typeof EntExternalConnector_PlatformType];
/**
 * Input to update an existing external platform gateway configuration. authConfig and
 * contentConfig are required on every update (full replace of those sections).
 * additionalConfigs and active remain optional; omitted optional fields leave stored values unchanged.
 */
export type EntExternalConnector_UpdateConfigurationInput = {
  /** Whether the integration is active. Omit to retain the stored value. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Additional platform-specific configuration options. */
  additionalConfigs?: InputMaybe<EntExternalConnector_AdditionalConfigurationInput>;
  /** Authentication configuration for the integration. */
  authConfig: EntExternalConnector_AuthenticationConfigurationInput;
  /** Content configuration for the integration. */
  contentConfig: EntExternalConnector_ContentConfigurationInput;
  /** Unique identifier for the configuration to update. */
  integrationId: Scalars['ID'];
  /** Organization ID associated with this configuration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: EntExternalConnector_PlatformType;
};

/**
 * Result of updating an external platform gateway configuration. Returns either the updated
 * configuration or validation errors when input fails validation on save.
 */
export type EntExternalConnector_UpdateConfigurationResult = EntExternalConnector_ConfigurationValidationFailure | EntExternalConnector_UpdateConfigurationSuccess;

/** Successful result of updating an external platform gateway configuration. */
export type EntExternalConnector_UpdateConfigurationSuccess = {
  __typename?: 'EntExternalConnector_UpdateConfigurationSuccess';
  /** The updated external platform gateway configuration. */
  config: EntExternalConnector_Configuration;
};

/** Field-level validation error for external connector configuration. */
export type EntExternalConnector_ValidationError = {
  __typename?: 'EntExternalConnector_ValidationError';
  /** Classification of the validation error. */
  errorType: EntExternalConnector_ValidationErrorType;
  /** Input field path (e.g. authConfig.clientId, authentication). */
  field: Scalars['String'];
  /** Human-readable error for this field. */
  message: Scalars['String'];
};

/** Types of validation errors for external connector configuration. */
export const EntExternalConnector_ValidationErrorType = {
  /** Authentication failed. */
  ValidationErrorTypeAuthenticationFailed: 'VALIDATION_ERROR_TYPE_AUTHENTICATION_FAILED',
  /** Connection failed. */
  ValidationErrorTypeConnectionFailed: 'VALIDATION_ERROR_TYPE_CONNECTION_FAILED',
  /** Invalid validation error type. */
  ValidationErrorTypeInvalid: 'VALIDATION_ERROR_TYPE_INVALID',
  /** Invalid format. */
  ValidationErrorTypeInvalidFormat: 'VALIDATION_ERROR_TYPE_INVALID_FORMAT',
  /** Invalid URL. */
  ValidationErrorTypeInvalidUrl: 'VALIDATION_ERROR_TYPE_INVALID_URL',
  /** Required field is missing. */
  ValidationErrorTypeRequiredFieldMissing: 'VALIDATION_ERROR_TYPE_REQUIRED_FIELD_MISSING'
} as const;

export type EntExternalConnector_ValidationErrorType = typeof EntExternalConnector_ValidationErrorType[keyof typeof EntExternalConnector_ValidationErrorType];
/** Queries for EntSso */
export type EntSsoQueries = {
  __typename?: 'EntSsoQueries';
  /** Query if an organization forces SSO login by email domain */
  queryIfSsoForceLoginByEmailDomain?: Maybe<EntSso_Config>;
  /** Query if an organization forces SSO login by orgId */
  queryIfSsoForceLoginByOrgId?: Maybe<EntSso_Config>;
  /** Query if an organization forces SSO login by orgId V2 */
  queryIfSsoForceLoginByOrgIdV2?: Maybe<EntSso_Config>;
  /** Query if a user email is part of force SSO epic */
  queryIfUserEmailForceSso?: Maybe<Scalars['Boolean']>;
  /** Query if an organization forces SSO login by userId */
  queryIfUserNeedSsoLoginByUserId?: Maybe<EntSso_UserSettingConfig>;
  /** Query if an organization forces SSO login by userId V2 */
  queryIfUserNeedSsoLoginByUserIdV2?: Maybe<EntSso_UserSettingConfig>;
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfSsoForceLoginByEmailDomainArgs = {
  emailDomain: Scalars['String'];
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfSsoForceLoginByOrgIdArgs = {
  orgId: Scalars['ID'];
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfSsoForceLoginByOrgIdV2Args = {
  orgId: Scalars['ID'];
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfUserEmailForceSsoArgs = {
  emailId: Scalars['ID'];
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfUserNeedSsoLoginByUserIdArgs = {
  userId: Scalars['ID'];
};


/** Queries for EntSso */
export type EntSsoQueriesQueryIfUserNeedSsoLoginByUserIdV2Args = {
  userId: Scalars['ID'];
};

/** The result indicates if the email domain needs to be forced to SSO login */
export type EntSso_Config = {
  __typename?: 'EntSso_Config';
  /** a flag indicates if the email domain belongs to an organization that forces SSO login */
  isSsoLoginForced: Scalars['Boolean'];
};

/** The result indicate if a user needs to SSO login */
export type EntSso_UserSettingConfig = {
  __typename?: 'EntSso_UserSettingConfig';
  /** A flag indicate if the user need to SSO login */
  isSsoLoginForced: Scalars['Boolean'];
  /** The user's SSO email */
  userSsoEmail: Scalars['String'];
};

/** Input for adding or updating a payment method as backup for an enterprise contract. */
export type EntTransaction_AddOrUpdateNewPaymentMethodInput = {
  /** The enterprise contract ID to add or update the backup payment method for. */
  contractId: Scalars['ID'];
  /** The existing payment method ID to be removed from backup payment methods. */
  existingPaymentMethodId?: InputMaybe<Scalars['ID']>;
  /** The payment method request to add as a backup payment method. */
  updatePaymentMethodRequest: EntTransaction_AddPaymentMethodRequestInput;
};

/** Result of adding or updating a backup payment method. */
export type EntTransaction_AddOrUpdateNewPaymentMethodResult = {
  __typename?: 'EntTransaction_AddOrUpdateNewPaymentMethodResult';
  /** Success status of the operation. */
  success: Scalars['Boolean'];
};

/** Input for adding a payment method. */
export type EntTransaction_AddPaymentMethodRequestInput = {
  /** The billing country of the payment method, ISO 3166-1 alpha-2 code. */
  billingCountry?: InputMaybe<Scalars['String']>;
  /** The billing zip code of the payment method. */
  billingZipCode?: InputMaybe<Scalars['String']>;
  /** The nonce of the payment method. */
  nonce: Scalars['String'];
  /** The payment processor ID of the payment method. */
  paymentProcessorId: EntTransaction_PaymentProcessorType;
};

/**
 * Auto-renewal information for enterprise contracts.
 * Based on AutoRenewInformation message in proto.
 */
export type EntTransaction_AutoRenewInformation = {
  __typename?: 'EntTransaction_AutoRenewInformation';
  /** Total Amount for the renewal before any discounts. */
  basePriceTotal: Scalars['Float'];
  /** Currency code for the renewal. */
  currencyCode: Scalars['String'];
  /** Enterprise promotion ID for the renewal. */
  enterprisePromotionId?: Maybe<Scalars['ID']>;
  /** Amount for the renewal. */
  renewAmount: Scalars['Float'];
  /** Total amount for the renewal after all  discounts. */
  renewAmountTotal: Scalars['Float'];
  /** Timestamp when the contract will renew. */
  renewsAt?: Maybe<Scalars['DateTime']>;
  /** User limit for the renewal. */
  userLimit?: Maybe<Scalars['Int']>;
};

/** Input for automated invoice order properties. */
export type EntTransaction_AutomatedInvoiceOrderPropertiesInput = {
  /** Admin title. */
  adminTitle: Scalars['String'];
  /** Creator user ID. */
  creatorUserId: Scalars['ID'];
  /** Existing organization ID. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** Purchase order number. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Sales owner information. */
  salesOwner?: InputMaybe<EntTransaction_SalesOwnerInput>;
  /** Tax ID data. */
  taxIdData?: InputMaybe<EntTransaction_TaxIdDataInput>;
};

/** Enumeration for billing system types. */
export const EntTransaction_BillingSystemType = {
  /** Automated invoice handled by Enterprise Invoicing service. */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Automated transaction payment. */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Non-billable contract (usually for testing). */
  NonBillable: 'NON_BILLABLE',
  /** Off-platform invoice handled by internal finance team. */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EntTransaction_BillingSystemType = typeof EntTransaction_BillingSystemType[keyof typeof EntTransaction_BillingSystemType];
/** Enumeration for billing types. */
export const EntTransaction_BillingType = {
  /** Invoice-based billing. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time payment. */
  OneTime: 'ONE_TIME',
  /** Quarterly payments. */
  Quarterly: 'QUARTERLY'
} as const;

export type EntTransaction_BillingType = typeof EntTransaction_BillingType[keyof typeof EntTransaction_BillingType];
/** Input for creating an enterprise contract purchase order */
export type EntTransaction_CreateEnterpriseContractPurchaseOrderInput = {
  /** Information required to submit an automated invoice order. */
  automatedInvoiceOrderProperties?: InputMaybe<EntTransaction_AutomatedInvoiceOrderPropertiesInput>;
  /** Currency to bill in. */
  billingCurrency: Scalars['String'];
  /** Specify ONE_TIME for annual payments and QUARTERLY for quarterly-paid installments. */
  billingScheduleType: EntTransaction_BillingType;
  /** Specify AUTOMATED_TRANSACTION_PAYMENT or AUTOMATED_INVOICE. */
  billingSystemType: EntTransaction_BillingSystemType;
  /** Billing contact email address. */
  contactEmail: Scalars['String'];
  /** Billing contact name. */
  contactName?: InputMaybe<Scalars['String']>;
  /** Country ISO code for billing. */
  countryIsoCode: Scalars['String'];
  /** Information required to create a PaymentWallet with Coursera's payment service. Required if billingSystemType = AUTOMATED_TRANSACTION_PAYMENT. */
  createPaymentWalletRequest?: InputMaybe<EntTransaction_CreatePaymentWalletRequestInput>;
  /** If provided, will create new contract on existing organization. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** Number of licenses being ordered. */
  numberOfLicenses: Scalars['Int'];
  /** Any offers to create the contract order with. Supports free-trial and discretionaryDiscount~<id>. */
  offerCode?: InputMaybe<Scalars['String']>;
  /** Enterprise organization address. */
  organizationAddress?: InputMaybe<EntTransaction_ThirdPartyOrganizationAddressInput>;
  /** Enterprise organization size range. */
  organizationEmployeeRange?: InputMaybe<Scalars['String']>;
  /** Enterprise organization name. */
  organizationName: Scalars['String'];
  /** Enterprise organization type. */
  organizationType?: InputMaybe<Scalars['String']>;
  /** Coursera account user ID of the purchaser. */
  purchaserUserId: Scalars['ID'];
  /** Specify for testing purposes, else None. */
  testingOptions?: InputMaybe<EntTransaction_TestingOptionsInput>;
};

/** Result of creating an enterprise contract purchase order. */
export type EntTransaction_CreateEnterpriseContractPurchaseOrderResult = {
  __typename?: 'EntTransaction_CreateEnterpriseContractPurchaseOrderResult';
  /** The created purchase order. */
  order: EntTransaction_EnterpriseContractPurchaseOrder;
  /** Total amount for the contract. */
  totalAmount: Scalars['Float'];
};

/** Input for creating a non-billable free trial. */
export type EntTransaction_CreateNonBillableFreeTrialInput = {
  /** Company/Organization name. */
  companyName: Scalars['String'];
  /** ISO 3166-1 alpha-2 country code (e.g., "US", "IN"). */
  countryIsoCode: Scalars['String'];
  /** Organization size. */
  orgSize?: InputMaybe<EntTransaction_OrgSize>;
  /** Organization type. */
  organizationType?: InputMaybe<EntTransaction_OrgType>;
  /** Whether user is interested in research interviews. */
  researchOptIn?: Scalars['Boolean'];
  /** Full name of the user. */
  userName: Scalars['String'];
  /** Work email address. */
  workEmail: Scalars['String'];
};

/** Result of the free trial creation request. */
export type EntTransaction_CreateNonBillableFreeTrialResult = {
  __typename?: 'EntTransaction_CreateNonBillableFreeTrialResult';
  /**
   * Created enterprise contract. Returns a federated entity that can be
   * resolved to the full EnterpriseContract_EnterpriseContract.
   */
  contract: EnterpriseContract_EnterpriseContract;
  /**
   * Created third party organization. Returns a federated entity that can be
   * resolved to the full ThirdPartyOrganization_ThirdPartyOrganization.
   */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Input for creating a payment wallet request. */
export type EntTransaction_CreatePaymentWalletRequestInput = {
  /** Billing country ISO code. */
  billingCountry: Scalars['String'];
  /** Billing zip code (optional). */
  billingZipcode?: InputMaybe<Scalars['String']>;
  /** Cart ID (optional). */
  cartId?: InputMaybe<Scalars['ID']>;
  /** Payment method nonce/token from payment processor. */
  nonce: Scalars['String'];
  /** Payment processor ID (optional). */
  paymentProcessorId?: InputMaybe<Scalars['ID']>;
  /** Recaptcha token for verification (optional). */
  recaptchaToken?: InputMaybe<Scalars['String']>;
  /** User ID for the payment wallet. */
  userId: Scalars['ID'];
};

/** Credit card brand/types. */
export const EntTransaction_CreditCardType = {
  /** American Express. */
  Amex: 'AMEX',
  /** Cartes Bancaires (French). */
  CartesBancaires: 'CARTES_BANCAIRES',
  /** Diners Club. */
  Diners: 'DINERS',
  /** Discover. */
  Discover: 'DISCOVER',
  /** EFTPOS Australia. */
  EftposAu: 'EFTPOS_AU',
  /** Interac (Canadian debit). */
  Interac: 'INTERAC',
  /** JCB (Japan Credit Bureau). */
  Jcb: 'JCB',
  /** Link */
  Link: 'LINK',
  /** Mastercard. */
  Mastercard: 'MASTERCARD',
  /** UnionPay. */
  Unionpay: 'UNIONPAY',
  /** Other card brand. */
  Unknown: 'UNKNOWN',
  /** Visa. */
  Visa: 'VISA'
} as const;

export type EntTransaction_CreditCardType = typeof EntTransaction_CreditCardType[keyof typeof EntTransaction_CreditCardType];
/** Purchase metadata for the current term of an enterprise contract. */
export type EntTransaction_CurrentTermPurchaseMeta = {
  __typename?: 'EntTransaction_CurrentTermPurchaseMeta';
  /** Actual amount due today in local currency with promotion and tiered pricing discount if applicable. */
  actualAmountDueTodayInLocal?: Maybe<Scalars['Float']>;
  /** Actual total amount due in local currency with promotion and tiered pricing discount if applicable. */
  actualAmountDueTotalInLocal?: Maybe<Scalars['Float']>;
  /** Amount due today in local currency without seasonal promotion but can have tiered pricing discount if applicable. */
  amountDueTodayInLocalWithoutPromotionDiscount?: Maybe<Scalars['Float']>;
  /** Total amount due in local currency without seasonal promotion discount but can have tiered pricing discount if applicable. */
  amountDueTotalInLocalWithoutPromotionDiscount?: Maybe<Scalars['Float']>;
  /** Base amount due today in local currency (before any discounts). */
  baseAmountDueTodayInLocal?: Maybe<Scalars['Float']>;
  /** Base total amount in local currency (before any discounts). */
  baseAmountTotalInLocal?: Maybe<Scalars['Float']>;
  /** Base unit price in local currency. */
  baseUnitPriceInLocal?: Maybe<Scalars['Float']>;
  /** Cart ID associated with the transaction. */
  cartId: Scalars['ID'];
  /** Discounted unit price in local currency. */
  discountedUnitPriceInLocal?: Maybe<Scalars['Float']>;
  /** Enterprise coupon ID applied to this purchase. */
  enterpriseCouponId?: Maybe<Scalars['ID']>;
  /** Unit price discount percentage. */
  unitPriceDiscountPercentage?: Maybe<Scalars['Float']>;
  /** type of unit price discount */
  unitPriceDiscountType?: Maybe<EntTransaction_UnitPriceDiscountType>;
};

/** The active tier for the current contract term */
export type EntTransaction_CurrentTier = {
  __typename?: 'EntTransaction_CurrentTier';
  /** Discount percentage applied at the current tier. */
  unitPriceDiscountPercent: Scalars['Float'];
  /** Type of discount applied at the current tier. */
  unitPriceDiscountType: EntTransaction_UnitPriceDiscountType;
};

/**
 * Main decorated contract entity.
 * Based on DecoratedEnterpriseContract message in proto.
 */
export type EntTransaction_DecoratedEnterpriseContract = {
  __typename?: 'EntTransaction_DecoratedEnterpriseContract';
  /** Amount that was refunded, if any. */
  amountRefunded?: Maybe<Scalars['Float']>;
  /** Amount remaining on the contract. */
  amountRemaining: Scalars['Float'];
  /** Auto-renewal information for the contract. */
  autoRenewInformation: EntTransaction_AutoRenewInformation;
  /** Purchase metadata for the current term. */
  currentTermPurchaseMeta?: Maybe<EntTransaction_CurrentTermPurchaseMeta>;
  /** The core enterprise contract information. */
  enterpriseContract: EntTransaction_EnterpriseContract;
  /** Whether price fluctuation is possible for this contract. */
  isPriceFluctuationPossible?: Maybe<Scalars['Boolean']>;
  /** Whether the contract has been refunded. */
  isRefunded: Scalars['Boolean'];
  /** Next payment information, if applicable. */
  nextPaymentInformation?: Maybe<EntTransaction_NextPaymentInformation>;
  /** List of previous payments made on this contract. */
  previousPayments: Array<EntTransaction_PaidEnterpriseContractPayment>;
  /** Refund deadline timestamp. */
  refundDeadline?: Maybe<Scalars['DateTime']>;
  /** List of remaining payments due for the current term. */
  remainingTermPayments: Array<EntTransaction_UnpaidEnterpriseContractPayment>;
  /** Utilization information for the contract. */
  utilization?: Maybe<EntTransaction_EnterpriseContractUtilization>;
};

/** Paginated result for decorated enterprise contracts. */
export type EntTransaction_DecoratedEnterpriseContractPaginatedResult = {
  __typename?: 'EntTransaction_DecoratedEnterpriseContractPaginatedResult';
  /** List of decorated enterprise contracts in the current page. */
  elements: Array<EntTransaction_DecoratedEnterpriseContract>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueries = {
  __typename?: 'EntTransaction_DecoratedEnterpriseContractQueries';
  /**
   * Gets a decorated enterprise contract by ID.
   * Returns comprehensive contract information including payment history, renewal details, and financial status.
   */
  getDecoratedEnterpriseContractById: EntTransaction_DecoratedEnterpriseContract;
  /** Returns decorated enterprise contracts by third party organization ID. | Maximum page size: 100 */
  getDecoratedEnterpriseContractsByThirdPartyOrganization: EntTransaction_DecoratedEnterpriseContractPaginatedResult;
  /** Returns transaction history with pricing tier information for an enterprise contract. */
  getEnterpriseContractPricingTierSummary?: Maybe<EntTransaction_EnterpriseContractPricingTierSummary>;
  /**
   * Gets the last payment failure details for a particular enterprise contract.
   * Returns the most recent payment failure information including the failure ID, message, and timestamp.
   */
  getLastPaymentFailureReason?: Maybe<EntTransaction_LastPaymentFailure>;
  /**
   * Gets the last payment failure details for both payment wallet and backup payment wallet.
   * Returns the most recent failure information for the primary and backup payment wallets if failures exist.
   */
  getLastPaymentWalletsFailures?: Maybe<EntTransaction_PaymentWalletsFailureDetails>;
};


/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueriesGetDecoratedEnterpriseContractByIdArgs = {
  contractId: Scalars['ID'];
};


/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueriesGetDecoratedEnterpriseContractsByThirdPartyOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueriesGetEnterpriseContractPricingTierSummaryArgs = {
  enterpriseContractId: Scalars['ID'];
};


/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueriesGetLastPaymentFailureReasonArgs = {
  enterpriseContractId: Scalars['ID'];
};


/** Queries for Decorated Enterprise Contracts */
export type EntTransaction_DecoratedEnterpriseContractQueriesGetLastPaymentWalletsFailuresArgs = {
  daysToLookBack?: InputMaybe<Scalars['Int']>;
  enterpriseContractId: Scalars['ID'];
};

/** Input for deleting a backup payment method from an enterprise contract. */
export type EntTransaction_DeleteBackupPaymentMethodInput = {
  /** The enterprise contract ID to delete the backup payment method from. */
  contractId: Scalars['ID'];
  /** The payment method ID to delete from backup payment methods. */
  paymentMethodId: Scalars['ID'];
};

/** Result of deleting a backup payment method. */
export type EntTransaction_DeleteBackupPaymentMethodResult = {
  __typename?: 'EntTransaction_DeleteBackupPaymentMethodResult';
  /** Success status of the operation. */
  success: Scalars['Boolean'];
};

/**
 * Enterprise contract information.
 * Based on EnterpriseContract message in proto.
 */
export type EntTransaction_EnterpriseContract = {
  __typename?: 'EntTransaction_EnterpriseContract';
  /** Current state of the contract. */
  contractState: EntTransaction_EnterpriseContractState;
  /** Contract limits information. */
  limits: EntTransaction_EnterpriseContractLimits;
  /** Stored enterprise contract data. */
  storedEnterpriseContract: EntTransaction_StoredEnterpriseContract;
  /** List of contract terms. */
  terms: Array<EntTransaction_EnterpriseContractTerm>;
  /** Total contract value. */
  value: Scalars['Float'];
};

/** Enumeration for enterprise contract billing system types. */
export const EntTransaction_EnterpriseContractBillingSystemType = {
  /** Automated invoice. */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Automated transaction payment. */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Non-billable contract. */
  NonBillable: 'NON_BILLABLE',
  /** Off-platform invoice. */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EntTransaction_EnterpriseContractBillingSystemType = typeof EntTransaction_EnterpriseContractBillingSystemType[keyof typeof EntTransaction_EnterpriseContractBillingSystemType];
/** Enumeration for enterprise contract billing types. */
export const EntTransaction_EnterpriseContractBillingType = {
  /** Invoice-based billing. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time billing. */
  OneTime: 'ONE_TIME',
  /** Quarterly billing. */
  Quarterly: 'QUARTERLY'
} as const;

export type EntTransaction_EnterpriseContractBillingType = typeof EntTransaction_EnterpriseContractBillingType[keyof typeof EntTransaction_EnterpriseContractBillingType];
/** Enumeration for enterprise contract limit types. */
export const EntTransaction_EnterpriseContractLimitType = {
  /** Enrollment cap limit. */
  EnrollmentCap: 'ENROLLMENT_CAP',
  /** No limit specified. */
  NoLimit: 'NO_LIMIT',
  /** User license limit. */
  UserLicense: 'USER_LICENSE',
  /** User license with enrollment cap. */
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EntTransaction_EnterpriseContractLimitType = typeof EntTransaction_EnterpriseContractLimitType[keyof typeof EntTransaction_EnterpriseContractLimitType];
/**
 * Enterprise contract limits information.
 * Based on EnterpriseContractLimits message in proto.
 */
export type EntTransaction_EnterpriseContractLimits = {
  __typename?: 'EntTransaction_EnterpriseContractLimits';
  /** Courses per user limit. */
  coursesPerUserLimit: Scalars['Int'];
  /** Enrollment cap limit. */
  enrollmentCapLimit: Scalars['Int'];
  /** User limit for the contract. */
  userLimit: Scalars['Int'];
};

/** Enumeration for enterprise contract payment types. */
export const EntTransaction_EnterpriseContractPaymentType = {
  /** Installment payment. */
  Installment: 'INSTALLMENT',
  /** Upgrade payment. */
  Upgrade: 'UPGRADE'
} as const;

export type EntTransaction_EnterpriseContractPaymentType = typeof EntTransaction_EnterpriseContractPaymentType[keyof typeof EntTransaction_EnterpriseContractPaymentType];
/** Enumeration for enterprise contract price mapping names. */
export const EntTransaction_EnterpriseContractPriceMappingName = {
  /** One course value increase mappings. */
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  /** Original release mappings. */
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EntTransaction_EnterpriseContractPriceMappingName = typeof EntTransaction_EnterpriseContractPriceMappingName[keyof typeof EntTransaction_EnterpriseContractPriceMappingName];
/** Transaction history with tier pricing details for an enterprise contract. */
export type EntTransaction_EnterpriseContractPricingTierSummary = {
  __typename?: 'EntTransaction_EnterpriseContractPricingTierSummary';
  /** Base Unit price for this tier. */
  baseUnitPrice?: Maybe<Scalars['Float']>;
  /** The tier that the contract currently falls into based on seat count. */
  currentTier?: Maybe<EntTransaction_CurrentTier>;
  /**
   * Proximity to the next volume discount tier, present only when the contract is within
   * the threshold number of licenses from unlocking a better discount.
   */
  tierProximity?: Maybe<EntTransaction_TierProximity>;
  /** Total discount amount applied in local currency. */
  totalDiscountAmountInLocal?: Maybe<Scalars['Float']>;
  /** Transaction metadata list */
  transactionMetaItems: Array<EnterpriseContract_TransactionMeta>;
  /** All volume pricing tiers configured for the contract. */
  volumeTiers: Array<EnterpriseContract_VolumeTier>;
};

/**
 * Enterprise contract properties.
 * Based on EnterpriseContractProperties message in proto.
 */
export type EntTransaction_EnterpriseContractProperties = EntTransaction_InvoiceBilledContractProperties | EntTransaction_SelfServeEnterpriseContractProperties;

/**
 * Enterprise contract purchase order.
 * Based on EnterpriseContractPurchaseOrder class in Scala.
 */
export type EntTransaction_EnterpriseContractPurchaseOrder = {
  __typename?: 'EntTransaction_EnterpriseContractPurchaseOrder';
  /** Billing country. */
  billingCountry: Scalars['String'];
  /** Billing currency. */
  billingCurrency: Scalars['String'];
  /** Billing schedule type. */
  billingScheduleType: EntTransaction_BillingType;
  /** Billing system type. */
  billingSystemType: EntTransaction_BillingSystemType;
  /** Contact email address. */
  contactEmail: Scalars['String'];
  /** Contact name. */
  contactName?: Maybe<Scalars['String']>;
  /** Contract ID associated with the order, if any. */
  contractId?: Maybe<Scalars['ID']>;
  /** Step function execution ARN. */
  executionArn?: Maybe<Scalars['String']>;
  /** External purchase order number. */
  externalPurchaseOrderNumber: Scalars['String'];
  /** Unique identifier for the order. */
  id: Scalars['ID'];
  /** Line item details. */
  lineItem: EntTransaction_PurchaseOrderLineItem;
  /** Offer details. */
  offerDetails?: Maybe<EntTransaction_PurchaseOrderOffer>;
  /** Organization address. */
  organizationAddress?: Maybe<EntTransaction_ThirdPartyOrganizationAddress>;
  /** Organization employee range. */
  organizationEmployeeRange?: Maybe<Scalars['String']>;
  /** Organization name. */
  organizationName: Scalars['String'];
  /** Organization type. */
  organizationType?: Maybe<Scalars['String']>;
  /** Payment method information. */
  paymentMethodInformation?: Maybe<EntTransaction_PaymentMethodInformation>;
  /** User ID of the purchaser (internal). */
  purchaserUserId: Scalars['ID'];
  /** Current state of the order. */
  state: EntTransaction_PurchaseOrderState;
  /** Whether using sandbox payments. */
  useSandbox?: Maybe<Scalars['Boolean']>;
};

/** Paginated result for enterprise contract purchase orders. */
export type EntTransaction_EnterpriseContractPurchaseOrdersPaginatedResult = {
  __typename?: 'EntTransaction_EnterpriseContractPurchaseOrdersPaginatedResult';
  /** List of purchase orders for the current page. */
  elements: Array<EntTransaction_EnterpriseContractPurchaseOrder>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Enumeration for enterprise contract states. */
export const EntTransaction_EnterpriseContractState = {
  /** Contract is active. */
  Active: 'ACTIVE',
  /** Contract is created. */
  Created: 'CREATED',
  /** Contract is expired. */
  Expired: 'EXPIRED',
  /** Contract is paused. */
  Paused: 'PAUSED',
  /** Contract is terminated. */
  Terminated: 'TERMINATED'
} as const;

export type EntTransaction_EnterpriseContractState = typeof EntTransaction_EnterpriseContractState[keyof typeof EntTransaction_EnterpriseContractState];
/**
 * Enterprise contract term information.
 * Based on EnterpriseContractTerm message in proto.
 */
export type EntTransaction_EnterpriseContractTerm = {
  __typename?: 'EntTransaction_EnterpriseContractTerm';
  /** Term end timestamp. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Enterprise contract ID. */
  enterpriseContractId: Scalars['ID'];
  /** Enterprise contract term ID. */
  enterpriseContractTermId: Scalars['ID'];
  /** FX rate ID for currency conversion. */
  fxRateId?: Maybe<Scalars['ID']>;
  /** Promotion ID for the term. */
  promotionId: Scalars['ID'];
  /** Term start timestamp. */
  startsAt: Scalars['DateTime'];
  /** Term tag, if applicable. */
  termTag?: Maybe<EntTransaction_EnterpriseContractTermTag>;
  /** Unit price for the term. */
  unitPrice?: Maybe<Scalars['Float']>;
  /** Timestamp when the term was written. */
  writtenAt: Scalars['DateTime'];
};

/** Enumeration for enterprise contract term tags. */
export const EntTransaction_EnterpriseContractTermTag = {
  /** Free trial allowing access to Coursera for Teams. */
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EntTransaction_EnterpriseContractTermTag = typeof EntTransaction_EnterpriseContractTermTag[keyof typeof EntTransaction_EnterpriseContractTermTag];
/** Enumeration for enterprise contract terminated reasons. */
export const EntTransaction_EnterpriseContractTerminatedReason = {
  /** Contract ended due to end date. */
  ContractEndDate: 'CONTRACT_END_DATE',
  /** Contract was downgraded. */
  Downgraded: 'DOWNGRADED',
  /** Free trial conversion failed. */
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  /** Free trial expired. */
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  /** Initial invoice was voided. */
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  /** Initial payment failed. */
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  /** Contract was migrated. */
  Migrated: 'MIGRATED',
  /** Missing payment. */
  MissingPayment: 'MISSING_PAYMENT',
  /** Contract was refunded. */
  Refunded: 'REFUNDED',
  /** Renewal grace period exceeded. */
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EntTransaction_EnterpriseContractTerminatedReason = typeof EntTransaction_EnterpriseContractTerminatedReason[keyof typeof EntTransaction_EnterpriseContractTerminatedReason];
/** Enumeration for enterprise contract types. */
export const EntTransaction_EnterpriseContractType = {
  /** Self-serve enterprise contract. */
  SelfServe: 'SELF_SERVE',
  /** Standard enterprise contract. */
  Standard: 'STANDARD'
} as const;

export type EntTransaction_EnterpriseContractType = typeof EntTransaction_EnterpriseContractType[keyof typeof EntTransaction_EnterpriseContractType];
/** Utilization details for an enterprise contract, including total and remaining user allocations. */
export type EntTransaction_EnterpriseContractUtilization = {
  __typename?: 'EntTransaction_EnterpriseContractUtilization';
  /** Enterprise Contract id. */
  id: Scalars['ID'];
  /** Remaining number of users on the contract. */
  remaining: Scalars['Int'];
  /** Total number of users on the contract. */
  total: Scalars['Int'];
};

/**
 * Enterprise payment information.
 * Based on EnterprisePaymentInformation message in proto.
 */
export type EntTransaction_EnterprisePaymentInformation = {
  __typename?: 'EntTransaction_EnterprisePaymentInformation';
  /** Last four digits of the credit card. */
  creditCardLastFourDigits?: Maybe<Scalars['String']>;
  /** Credit card type, if applicable. */
  creditCardType?: Maybe<Scalars['String']>;
  /** Email associated with the payment. */
  paymentEmail?: Maybe<Scalars['String']>;
  /** Payment processor ID. */
  paymentProcessorId: Scalars['ID'];
};

/** Input for finalizing an order. */
export type EntTransaction_FinalizeOrderInput = {
  /** The contract ID to associate with the order. */
  contractId: Scalars['ID'];
  /** The order ID to finalize. */
  orderId: Scalars['ID'];
};

/** Result of finalizing an order. */
export type EntTransaction_FinalizeOrderResult = {
  __typename?: 'EntTransaction_FinalizeOrderResult';
  /**
   * GraphQL types must include at least one field, so a dummy field is defined here.
   * The operation returns no meaningful data on success.
   */
  _?: Maybe<Scalars['Boolean']>;
};

/** Reasons why a user might not be eligible for a free trial. */
export const EntTransaction_FreeTrialEligibilityFailureReason = {
  /** Email domain has reached the limit of free trials (3 per domain). */
  DomainTrialLimitExceeded: 'DOMAIN_TRIAL_LIMIT_EXCEEDED',
  /** User is already associated with an existing organization. */
  ExistingOrgAssociation: 'EXISTING_ORG_ASSOCIATION',
  /** Email address is not a valid business email. */
  InvalidBusinessEmail: 'INVALID_BUSINESS_EMAIL',
  /** User has already used a free trial previously. */
  PreviousFreeTrialUsed: 'PREVIOUS_FREE_TRIAL_USED',
  /** User's country is sanctioned and not allowed for free trials. */
  SanctionedCountry: 'SANCTIONED_COUNTRY',
  /** User already has a free trial request in progress. */
  TrialInProgress: 'TRIAL_IN_PROGRESS'
} as const;

export type EntTransaction_FreeTrialEligibilityFailureReason = typeof EntTransaction_FreeTrialEligibilityFailureReason[keyof typeof EntTransaction_FreeTrialEligibilityFailureReason];
/**
 * Result containing data for nudge decisions on admin dashboard.
 *
 * FE derives nudge state from endsAt:
 * - isExpired: endsAt < now
 * - isEndingSoon: endsAt > now AND (endsAt - now) <= threshold
 * - daysRemaining: (endsAt - now) in days
 *
 * Nudge Priority (FE decides based on this data):
 * 1. Trial Ended: Show if endsAt < now
 * 2. Trial Ending Soon: Show if endsAt is within threshold days
 * 3. Create Program: Show if hasProgramCreated = false
 * 4. Invite Learners: Show if hasProgramCreated = true AND hasInvitedLearners = false
 */
export type EntTransaction_FreeTrialNudgeDataResult = {
  __typename?: 'EntTransaction_FreeTrialNudgeDataResult';
  /**
   * Trial end date/time. Null if no free trial exists.
   * FE uses this to derive isExpired, isEndingSoon, and daysRemaining.
   */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Whether user has a free trial (active or expired). */
  hasFreeTrial: Scalars['Boolean'];
  /**
   * Whether at least one learner has been invited.
   * Used for "Invite Learners" nudge.
   */
  hasInvitedLearners: Scalars['Boolean'];
  /**
   * Whether at least one program has been created.
   * Used for "Create Program" nudge.
   */
  hasProgramCreated: Scalars['Boolean'];
};

/** Free trial offer details. */
export type EntTransaction_FreeTrialOffer = {
  __typename?: 'EntTransaction_FreeTrialOffer';
  /** Number of free trial days. */
  freeTrialDays: Scalars['Int'];
  /** Trial end date. */
  trialEndsAt: Scalars['String'];
};

/** Queries for free trial data to support admin dashboard nudges. */
export type EntTransaction_FreeTrialQueries = {
  __typename?: 'EntTransaction_FreeTrialQueries';
  /**
   * Get free trial nudge data for admin dashboard.
   * Returns data needed for FE to determine which nudge to display.
   * If thirdPartyOrganizationId is not provided, it is inferred from user context.
   */
  queryNudgeData: EntTransaction_FreeTrialNudgeDataResult;
  /**
   * Validates free trial eligibility without creating a trial.
   * Public API - no authentication required.
   * Checks eligibility based on email, country, and existing user status.
   */
  validateFreeTrialEligibility: EntTransaction_ValidateFreeTrialEligibilityResult;
};


/** Queries for free trial data to support admin dashboard nudges. */
export type EntTransaction_FreeTrialQueriesQueryNudgeDataArgs = {
  thirdPartyOrganizationId?: InputMaybe<Scalars['ID']>;
};


/** Queries for free trial data to support admin dashboard nudges. */
export type EntTransaction_FreeTrialQueriesValidateFreeTrialEligibilityArgs = {
  input: EntTransaction_ValidateFreeTrialEligibilityInput;
};

/**
 * Properties specific to invoice-billed contracts.
 * Based on InvoiceBilledContractProperties message in proto.
 */
export type EntTransaction_InvoiceBilledContractProperties = {
  __typename?: 'EntTransaction_InvoiceBilledContractProperties';
  /**
   * Indicates if the contract is eligible for auto-charging.
   * Becomes true after first successful card payment.
   */
  autoChargeEligible: Scalars['Boolean'];
  /** External customer ID on the payment processor. */
  customerId: Scalars['ID'];
  /**
   * Type of payment method stored (e.g., CARD, BANK_ACCOUNT).
   * Only CARD is supported for auto-charging.
   */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** Payment processor ID for invoice billing. */
  paymentProcessorId: Scalars['ID'];
  /**
   * The payment method ID from the payment processor.
   * Used for auto-charging invoice contracts.
   */
  paymentWalletId?: Maybe<Scalars['ID']>;
  /** User ID being invoiced. */
  userId: Scalars['ID'];
};

/**
 * Last payment failure information for an enterprise contract.
 * Based on GetLastPaymentFailureResponse message in proto.
 */
export type EntTransaction_LastPaymentFailure = {
  __typename?: 'EntTransaction_LastPaymentFailure';
  /** Timestamp when the payment failure occurred. */
  failedAt: Scalars['DateTime'];
  /** ID of the payment failure from the enterprise_contract_failed_payments table. */
  paymentFailureId: Scalars['ID'];
  /** User-friendly message describing the payment failure reason. */
  paymentFailureMessage: Scalars['String'];
};

/** Input for making a payment method the primary payment method for an enterprise contract. */
export type EntTransaction_MakeMethodPrimaryInput = {
  /** The enterprise contract ID to update the primary payment method for. */
  contractId: Scalars['ID'];
  /** The payment method ID to set as the primary payment method. */
  paymentMethodId: Scalars['ID'];
};

/** Result of making a payment method primary. */
export type EntTransaction_MakeMethodPrimaryResult = {
  __typename?: 'EntTransaction_MakeMethodPrimaryResult';
  /** Success status of the operation. */
  success: Scalars['Boolean'];
};

/**
 * Next payment information for enterprise contracts.
 * Based on NextPaymentInformation message in proto.
 */
export type EntTransaction_NextPaymentInformation = {
  __typename?: 'EntTransaction_NextPaymentInformation';
  /** Amount due for the next payment. */
  amount: Scalars['Float'];
  /** Base total contract value before any discounts, in local currency. */
  baseTotalContractValue: Scalars['Float'];
  /** Base total price due over installments */
  baseTotalPriceDueOverInstallments: Scalars['Float'];
  /** Currency code for the payment. */
  currencyCode: Scalars['String'];
  /** Due date for the next payment. */
  dueAt: Scalars['DateTime'];
  /** Whether the payment is currently due. */
  isPaymentDue: Scalars['Boolean'];
  /** Whether the payment is overdue. */
  isPaymentOverdue: Scalars['Boolean'];
  /** Number of installments remaining */
  numberOfInstallmentRemaining: Scalars['Int'];
  /** Type of the scheduled payment. */
  scheduledPaymentType: EntTransaction_NextScheduledPaymentType;
  /** Amount already paid until now */
  totalAmountAlreadyPaid?: Maybe<Scalars['Float']>;
  /** Total contract value after all discounts, in local currency. */
  totalContractValueAfterDiscounts: Scalars['Float'];
  /** Total promotional discount amount, in local currency. */
  totalPromotionalDiscountAmount?: Maybe<Scalars['Float']>;
  /** Total promotional discount as a percentage. */
  totalPromotionalDiscountAmountPercentage?: Maybe<Scalars['Float']>;
  /** Total unit price discount amount, in local currency. */
  totalUnitPriceDiscountAmount?: Maybe<Scalars['Float']>;
  /** Total unit price discount as a percentage. */
  totalUnitPriceDiscountPercentage?: Maybe<Scalars['Float']>;
  /** Type of unit price discount applied (e.g. VOLUME_DISCOUNT). */
  unitPriceDiscountType?: Maybe<EntTransaction_UnitPriceDiscountType>;
  /** Indicates whether all backup payment methods will expire before the payment date. */
  willAllBackupPaymentMethodsExpireBeforePaymentDate: Scalars['Boolean'];
  /** Whether the payment method will expire before the payment date. */
  willPaymentMethodExpireBeforePaymentDate: Scalars['Boolean'];
};

/** Enumeration for next scheduled payment types. */
export const EntTransaction_NextScheduledPaymentType = {
  /** Installment payment. */
  InstallmentPayment: 'INSTALLMENT_PAYMENT',
  /** Renewal payment. */
  RenewalPayment: 'RENEWAL_PAYMENT'
} as const;

export type EntTransaction_NextScheduledPaymentType = typeof EntTransaction_NextScheduledPaymentType[keyof typeof EntTransaction_NextScheduledPaymentType];
/** Enumeration for order states. */
export const EntTransaction_OrderState = {
  /** Order is aborted. */
  Aborted: 'ABORTED',
  /** Order is completed. */
  Completed: 'COMPLETED',
  /** Order is open. */
  Open: 'OPEN'
} as const;

export type EntTransaction_OrderState = typeof EntTransaction_OrderState[keyof typeof EntTransaction_OrderState];
/** Organization size options. */
export const EntTransaction_OrgSize = {
  /** 1 to 500 employees. */
  Size_1_500: 'SIZE_1_500',
  /** 501 to 1000 employees. */
  Size_501_1000: 'SIZE_501_1000',
  /** 1001 to 5000 employees. */
  Size_1001_5000: 'SIZE_1001_5000',
  /** 5001 to 15000 employees. */
  Size_5001_15000: 'SIZE_5001_15000',
  /** More than 15000 employees. */
  SizeMoreThan_15000: 'SIZE_MORE_THAN_15000'
} as const;

export type EntTransaction_OrgSize = typeof EntTransaction_OrgSize[keyof typeof EntTransaction_OrgSize];
/** Organization type options. */
export const EntTransaction_OrgType = {
  /** Business organization. */
  Business: 'BUSINESS',
  /** Campus/Educational institution. */
  Campus: 'CAMPUS',
  /** Government organization. */
  Government: 'GOVERNMENT'
} as const;

export type EntTransaction_OrgType = typeof EntTransaction_OrgType[keyof typeof EntTransaction_OrgType];
/**
 * Paid enterprise contract payment information.
 * Based on PaidEnterpriseContractPayment message in proto.
 */
export type EntTransaction_PaidEnterpriseContractPayment = {
  __typename?: 'EntTransaction_PaidEnterpriseContractPayment';
  /** Payment amount. */
  amount: Scalars['Float'];
  /** Cart ID associated with the payment. */
  cartId: Scalars['ID'];
  /** Currency code for the payment. */
  currencyCode: Scalars['String'];
  /** Invoice ID associated with the payment. */
  invoiceId?: Maybe<Scalars['ID']>;
  /** Timestamp when the payment was made. */
  paymentAt: Scalars['DateTime'];
  /** Payment method information. */
  paymentInformation: EntTransaction_EnterprisePaymentInformation;
  /** Type of payment (installment or upgrade). */
  paymentType: EntTransaction_EnterpriseContractPaymentType;
  /** Number of seats added (for upgrade payments only). */
  seatsAdded?: Maybe<Scalars['Int']>;
  /** Term ID associated with the payment. */
  termId?: Maybe<Scalars['ID']>;
  /** Transaction ID for the payment. */
  transactionId: Scalars['ID'];
  /** Unit price for the payment. */
  unitPrice?: Maybe<Scalars['Float']>;
};

/**
 * Payment failure details for a specific payment wallet.
 * Based on PaymentFailureDetails message in proto.
 */
export type EntTransaction_PaymentFailureDetails = {
  __typename?: 'EntTransaction_PaymentFailureDetails';
  /** Timestamp when the payment failure occurred. */
  failedAt: Scalars['DateTime'];
  /** ID of the payment failure from the enterprise_contract_failed_payments table. */
  paymentFailureId: Scalars['ID'];
  /** User-friendly message describing the payment failure reason. */
  paymentFailureMessage: Scalars['String'];
};

/** Payment method information for an enterprise contract. */
export type EntTransaction_PaymentMethod = {
  __typename?: 'EntTransaction_PaymentMethod';
  /** Billing country code. */
  billingCountry?: Maybe<Scalars['String']>;
  /** Billing ZIP/postal code. */
  billingZipcode?: Maybe<Scalars['String']>;
  /** Credit card expiration date. */
  creditCardExpiration?: Maybe<Scalars['DateTime']>;
  /** Last 4 digits of the credit card. */
  creditCardLastFourDigits?: Maybe<Scalars['String']>;
  /** Type of credit card (e.g., Visa, MasterCard, Amex). */
  creditCardType?: Maybe<EntTransaction_CreditCardType>;
  /** Email associated with the payment method. */
  email?: Maybe<Scalars['String']>;
  /** Unique identifier for the payment method (wallet ID). */
  id: Scalars['ID'];
  /** Whether this is the primary payment method for the contract. */
  isPrimary: Scalars['Boolean'];
  /** Payment processor type. */
  paymentProcessorType?: Maybe<EntTransaction_PaymentProcessorType>;
  /**
   * Priority of the payment method.
   * Higher priority means more preferred.
   */
  priority: Scalars['Int'];
};

/** Payment method information. */
export type EntTransaction_PaymentMethodInformation = {
  __typename?: 'EntTransaction_PaymentMethodInformation';
  /** Billing country ISO code. */
  billingCountry: Scalars['String'];
  /** Billing zip code (optional). */
  billingZipcode?: Maybe<Scalars['String']>;
  /** Cart ID (optional). */
  cartId?: Maybe<Scalars['ID']>;
  /** Payment method nonce/token from payment processor. */
  nonce: Scalars['String'];
  /** Payment processor ID (optional). */
  paymentProcessorId?: Maybe<Scalars['ID']>;
  /** Recaptcha token for verification (optional). */
  recaptchaToken?: Maybe<Scalars['String']>;
  /** User ID for the payment wallet. */
  userId: Scalars['ID'];
};

/** Payment methods queries entry point */
export type EntTransaction_PaymentMethodsQueries = {
  __typename?: 'EntTransaction_PaymentMethodsQueries';
  /** Fetches payment methods (primary and backup) for a list of enterprise contracts. */
  getPaymentMethodsForContracts: Array<EntTransaction_PaymentMethodsResponse>;
};


/** Payment methods queries entry point */
export type EntTransaction_PaymentMethodsQueriesGetPaymentMethodsForContractsArgs = {
  contractIds: Array<Scalars['ID']>;
};

/** Payment methods response - a map structure with contract ID as key and list of payment methods as value. */
export type EntTransaction_PaymentMethodsResponse = {
  __typename?: 'EntTransaction_PaymentMethodsResponse';
  /** The contract ID (key). */
  contractId: Scalars['ID'];
  /** List of payment methods for this contract (value). */
  paymentMethods: Array<EntTransaction_PaymentMethod>;
};

/** Payment processor types supported for enterprise transactions. */
export const EntTransaction_PaymentProcessorType = {
  /** Apple In-App Purchase Production. */
  AppleInapp: 'APPLE_INAPP',
  /** Apple In-App Purchase Sandbox. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree Production. */
  Braintree: 'BRAINTREE',
  /** Braintree Sandbox. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Internal payment processor for manual refunds. */
  CourseraManual: 'COURSERA_MANUAL',
  /** dLocal Production. */
  Dlocal: 'DLOCAL',
  /** dLocal Sandbox. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx Production. Deprecated. */
  Ebanx: 'EBANX',
  /** Ebanx Sandbox. Deprecated. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent Production. Deprecated. */
  Emergent: 'EMERGENT',
  /** Emergent Sandbox. Deprecated. */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid by Coursera. Deprecated. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play Billing Production. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Google Play Billing Sandbox. */
  GooglePlaySandbox: 'GOOGLE_PLAY_SANDBOX',
  /** Mock payment processor for testing. */
  Mock: 'MOCK',
  /** Paypal Production. */
  Paypal: 'PAYPAL',
  /** Paypal Sandbox. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay Production. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will Production. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will Sandbox. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay Sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe Enterprise Production (WES account). */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer Production (BV account). */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer Sandbox (BV account). */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer Production (US account). */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer Sandbox (US account). */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe Enterprise Sandbox (WES account). */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** Stripe Third Party Production (for subscriptions on third party processors). */
  StripeThirdParty: 'STRIPE_THIRD_PARTY',
  /** Stripe Third Party Sandbox (for subscriptions on third party processors). */
  StripeThirdPartySandbox: 'STRIPE_THIRD_PARTY_SANDBOX',
  /** ID used for checkouts with no charge. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type EntTransaction_PaymentProcessorType = typeof EntTransaction_PaymentProcessorType[keyof typeof EntTransaction_PaymentProcessorType];
/**
 * Payment failure details for both payment wallet and backup payment wallet.
 * Based on PaymentWalletsFailureDetails message in proto.
 */
export type EntTransaction_PaymentWalletsFailureDetails = {
  __typename?: 'EntTransaction_PaymentWalletsFailureDetails';
  /** Failure details for the backup payment wallet, if any failure exists. */
  backupPaymentWalletFailure?: Maybe<EntTransaction_PaymentFailureDetails>;
  /** Failure details for the primary payment wallet, if any failure exists. */
  paymentWalletFailure?: Maybe<EntTransaction_PaymentFailureDetails>;
};

/** Purchase order line item. */
export type EntTransaction_PurchaseOrderLineItem = {
  __typename?: 'EntTransaction_PurchaseOrderLineItem';
  /** Currency code. */
  currencyCode: Scalars['String'];
  /** Quantity of licenses. */
  quantity: Scalars['Int'];
  /** Unit price. */
  unitPrice: Scalars['Float'];
};

/** Purchase order offer. */
export type EntTransaction_PurchaseOrderOffer = {
  __typename?: 'EntTransaction_PurchaseOrderOffer';
  /** Offer details. */
  offerDetails: Scalars['String'];
  /** Offer type. */
  offerType: Scalars['String'];
};

/** Enumeration for purchase order states. */
export const EntTransaction_PurchaseOrderState = {
  /** Order is created. */
  Created: 'CREATED',
  /** Order is fulfilled. */
  Fulfilled: 'FULFILLED',
  /** Order is submitted. */
  Submitted: 'SUBMITTED'
} as const;

export type EntTransaction_PurchaseOrderState = typeof EntTransaction_PurchaseOrderState[keyof typeof EntTransaction_PurchaseOrderState];
/** Input for sales owner information. */
export type EntTransaction_SalesOwnerInput = {
  /** Sales owner name. */
  name: Scalars['String'];
  /** Sales owner user ID (internal). */
  userId: Scalars['ID'];
};

/**
 * Properties specific to self-serve enterprise contracts.
 * Based on SelfServeEnterpriseContractProperties message in proto.
 */
export type EntTransaction_SelfServeEnterpriseContractProperties = {
  __typename?: 'EntTransaction_SelfServeEnterpriseContractProperties';
  /** Backup payment wallet IDs to be used as fallback for recurring payments. */
  backupPaymentWalletIds?: Maybe<Array<Scalars['ID']>>;
  /** Payment wallet ID for the contract. */
  paymentWalletId: Scalars['ID'];
  /** Price mapping name for the contract. */
  priceMappingName?: Maybe<EntTransaction_EnterpriseContractPriceMappingName>;
};

/**
 * Stored enterprise contract information.
 * Based on StoredEnterpriseContract message in proto.
 */
export type EntTransaction_StoredEnterpriseContract = {
  __typename?: 'EntTransaction_StoredEnterpriseContract';
  /** Billing system type used for the contract. */
  billingSystemType: EntTransaction_EnterpriseContractBillingSystemType;
  /** Billing type for the contract. */
  billingType: EntTransaction_EnterpriseContractBillingType;
  /** Type of the contract. */
  contractType: EntTransaction_EnterpriseContractType;
  /** Country ISO code for the contract. */
  countryIsoCode?: Maybe<Scalars['String']>;
  /** Contract creation timestamp. */
  createdAt: Scalars['DateTime'];
  /** Currency code for the contract. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Duration of the contract in months. */
  durationInMonths?: Maybe<Scalars['Int']>;
  /** Actual contract end timestamp. */
  endedAt?: Maybe<Scalars['DateTime']>;
  /** Contract end timestamp. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Unique enterprise contract ID. */
  enterpriseContractId: Scalars['ID'];
  /** Timestamp when the contract was hard paused. */
  hardPausedAt?: Maybe<Scalars['DateTime']>;
  /** Whether the contract is currently paused. */
  isPaused: Scalars['Boolean'];
  /** Whether this is a real contract (not test). */
  isReal: Scalars['Boolean'];
  /** Type of limits applied to the contract. */
  limitType: EntTransaction_EnterpriseContractLimitType;
  /** Contract name. */
  name?: Maybe<Scalars['String']>;
  /** Plan ID associated with the contract. */
  planId: Scalars['ID'];
  /** Promotion ID applied to the contract. */
  promotionId: Scalars['ID'];
  /** Contract-specific properties. */
  properties?: Maybe<EntTransaction_EnterpriseContractProperties>;
  /** Purpose of the contract. */
  purpose?: Maybe<Scalars['String']>;
  /** Salesforce case number, if applicable. */
  salesforceCaseNumber?: Maybe<Scalars['String']>;
  /** Contract start timestamp. */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Reason for contract termination, if applicable. */
  terminationReason?: Maybe<EntTransaction_EnterpriseContractTerminatedReason>;
  /** Third party organization information. */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Input for tax ID data. */
export type EntTransaction_TaxIdDataInput = {
  /** Tax ID value. */
  taxId: Scalars['ID'];
  /** Tax ID type. */
  taxIdType: Scalars['String'];
};

/** Input for terminating a free trial. */
export type EntTransaction_TerminateFreeTrialInput = {
  /** The enterprise contract ID associated with the free trial to terminate. */
  enterpriseContractId: Scalars['ID'];
};

/** Result of the free trial termination request. */
export type EntTransaction_TerminateFreeTrialResult = {
  __typename?: 'EntTransaction_TerminateFreeTrialResult';
  /** Whether the termination was successful. */
  success: Scalars['Boolean'];
};

/** Input for testing options. */
export type EntTransaction_TestingOptionsInput = {
  /** Whether to create a fake organization. */
  createFakeOrg?: InputMaybe<Scalars['Boolean']>;
  /** Whether to use sandbox payments. */
  sandbox?: InputMaybe<Scalars['Boolean']>;
  /** Test lambda alias. */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix. */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
};

/** Third-party organization address. */
export type EntTransaction_ThirdPartyOrganizationAddress = {
  __typename?: 'EntTransaction_ThirdPartyOrganizationAddress';
  /** City. */
  city: Scalars['String'];
  /** Country ISO code. */
  countryIsoCode: Scalars['String'];
  /** Address line 1. */
  line1: Scalars['String'];
  /** Address line 2 (optional). */
  line2?: Maybe<Scalars['String']>;
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State or province. */
  state: Scalars['String'];
};

/** Input for third-party organization address. */
export type EntTransaction_ThirdPartyOrganizationAddressInput = {
  /** City. */
  city: Scalars['String'];
  /** Country ISO code. */
  countryIsoCode: Scalars['String'];
  /** Address line 1. */
  line1: Scalars['String'];
  /** Address line 2 (optional). */
  line2?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode: Scalars['String'];
  /** State or province. */
  state: Scalars['String'];
};

/** How close the contract is to unlocking the next volume-discount tier. */
export type EntTransaction_TierProximity = {
  __typename?: 'EntTransaction_TierProximity';
  /** Total current user license count. */
  currentUserLimit: Scalars['Int'];
  /** Discount percentage at the next tier. */
  nextTierDiscountPercent: Scalars['Float'];
  /** Remaining user licenses needed to unlock the next tier. */
  remainingUserLimitToUnlock: Scalars['Int'];
};

/** Enumeration for unit price discountType */
export const EntTransaction_UnitPriceDiscountType = {
  /** VOLUME_DISCOUNT */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EntTransaction_UnitPriceDiscountType = typeof EntTransaction_UnitPriceDiscountType[keyof typeof EntTransaction_UnitPriceDiscountType];
/**
 * Unpaid enterprise contract payment information.
 * Based on UnpaidEnterpriseContractPayment message in proto.
 */
export type EntTransaction_UnpaidEnterpriseContractPayment = {
  __typename?: 'EntTransaction_UnpaidEnterpriseContractPayment';
  /** Payment amount due. */
  amount: Scalars['Float'];
  /** Currency code for the payment. */
  currencyCode: Scalars['String'];
  /** Due date for the payment. */
  paymentDate: Scalars['DateTime'];
};

/** Input for updating contract and term ID. */
export type EntTransaction_UpdateContractAndTermIdInput = {
  /** The contract ID to associate. */
  contractId: Scalars['ID'];
  /** The order ID to update. */
  orderId: Scalars['ID'];
  /** The term ID to associate. */
  termId?: InputMaybe<Scalars['ID']>;
};

/** Result of updating contract and term ID. */
export type EntTransaction_UpdateContractAndTermIdResult = {
  __typename?: 'EntTransaction_UpdateContractAndTermIdResult';
  /**
   * GraphQL types must include at least one field, so a dummy field is defined here.
   * The operation returns no meaningful data on success.
   */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input for updating order state. */
export type EntTransaction_UpdateOrderStateInput = {
  /** The new state for the order. */
  newState: EntTransaction_OrderState;
  /** The order ID to update. */
  orderId: Scalars['ID'];
};

/** Result of updating order state. */
export type EntTransaction_UpdateOrderStateResult = {
  __typename?: 'EntTransaction_UpdateOrderStateResult';
  /**
   * GraphQL types must include at least one field, so a dummy field is defined here.
   * The operation returns no meaningful data on success.
   */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * Input for validating free trial eligibility.
 * Only requires minimal information needed for validation checks.
 */
export type EntTransaction_ValidateFreeTrialEligibilityInput = {
  /** ISO 3166-1 alpha-2 country code (e.g., "US", "IN"). */
  countryIsoCode: Scalars['String'];
  /** Email address to validate. */
  email: Scalars['String'];
};

/** Result of free trial eligibility validation. */
export type EntTransaction_ValidateFreeTrialEligibilityResult = {
  __typename?: 'EntTransaction_ValidateFreeTrialEligibilityResult';
  /** Whether the user is eligible for a free trial. */
  eligible: Scalars['Boolean'];
  /** Failure reason if not eligible. Null when eligible. */
  failureReason?: Maybe<EntTransaction_FreeTrialEligibilityFailureReason>;
};

/** EntUserEducator: This schema contains the queries and types for the ent-user-educator application. */
export type EntUserEducatorQueries = {
  __typename?: 'EntUserEducatorQueries';
  /** Queries for returning a list of private courses by course ids. */
  queryPrivateCoursesByCourseIds: Array<Course_Course>;
};


/** EntUserEducator: This schema contains the queries and types for the ent-user-educator application. */
export type EntUserEducatorQueriesQueryPrivateCoursesByCourseIdsArgs = {
  courseIds: Array<Scalars['ID']>;
};

/** Queries for enterprise admin account page contract lifetime metrics */
export type EnterpriseAdminAccountPageContractLifetimeMetricsQueries = {
  __typename?: 'EnterpriseAdminAccountPageContractLifetimeMetricsQueries';
  /** Returns the contract lifetime metrics for the given enterprise contract id */
  getContractLifetimeMetrics: EnterpriseAdminAccountPage_ContractLifetimeMetrics;
};


/** Queries for enterprise admin account page contract lifetime metrics */
export type EnterpriseAdminAccountPageContractLifetimeMetricsQueriesGetContractLifetimeMetricsArgs = {
  enterpriseContractId: Scalars['ID'];
};

/** Contract lifetime metrics */
export type EnterpriseAdminAccountPage_ContractLifetimeMetrics = {
  __typename?: 'EnterpriseAdminAccountPage_ContractLifetimeMetrics';
  /** Total items completed */
  itemsCompleted: Scalars['Int'];
  /** Total joined learners */
  joinedLearners: Scalars['Int'];
  /** Total learning hours */
  learningHours: Scalars['Int'];
  /** Total licenses */
  totalLicenses: Scalars['Int'];
};

/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueries = {
  __typename?: 'EnterpriseAdminHomePageMetricsQueries';
  /** Returns the contract utilization metrics for the given enterprise organization id, contract ids, and program ids */
  getContractUtilization: EnterpriseAdminHomePage_ContractUtilization;
  /** Returns the header details for the given enterprise organization id */
  getHeaderDetails: EnterpriseAdminHomePage_HeaderDetails;
  /** Returns the learner activity and progress metrics for the given enterprise organization id, time period, program ids, and contract ids */
  getLearnerActivityAndProgress: EnterpriseAdminHomePage_LearnerActivityAndProgressMetrics;
  /**
   * Returns the content that is most engaged with by learners for the given
   * enterprise organization id, time period, program ids, and contract ids
   */
  getMostEngagedContent: Array<EnterpriseAdminHomePage_Content>;
  /** Returns the recommended actions for the given enterprise organization id for the requestor admin */
  getRecommendedActions: Array<EnterpriseAdminHomePage_RecommendedAction>;
  /**
   * Returns the skill development metrics for the given enterprise organization id,
   * time period, program ids, and contract ids
   */
  getSkillDevelopmentMetrics: EnterpriseAdminHomePage_SkillDevelopmentMetrics;
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetContractUtilizationArgs = {
  contractIds: Array<Scalars['ID']>;
  enterpriseOrganizationId: Scalars['ID'];
  programIds: Array<Scalars['ID']>;
  timePeriod: EnterpriseAdminHomePage_TimePeriod;
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetHeaderDetailsArgs = {
  enterpriseOrganizationId: Scalars['ID'];
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetLearnerActivityAndProgressArgs = {
  contractIds: Array<Scalars['ID']>;
  enterpriseOrganizationId: Scalars['ID'];
  programIds: Array<Scalars['ID']>;
  timePeriod: EnterpriseAdminHomePage_TimePeriod;
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetMostEngagedContentArgs = {
  contractIds: Array<Scalars['ID']>;
  enterpriseOrganizationId: Scalars['ID'];
  programIds: Array<Scalars['ID']>;
  timePeriod: EnterpriseAdminHomePage_TimePeriod;
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetRecommendedActionsArgs = {
  enterpriseOrganizationId: Scalars['ID'];
  pageContext?: InputMaybe<EnterpriseAdminHomePage_PageContext>;
};


/** Enterprise admin homepage queries */
export type EnterpriseAdminHomePageMetricsQueriesGetSkillDevelopmentMetricsArgs = {
  contractIds: Array<Scalars['ID']>;
  enterpriseOrganizationId: Scalars['ID'];
  programIds: Array<Scalars['ID']>;
  skillId?: InputMaybe<Scalars['ID']>;
  timePeriod: EnterpriseAdminHomePage_TimePeriod;
};

/** Type of the action taken by the admin */
export const EnterpriseAdminHomePage_ActionTakenType = {
  /** Assign content to learners */
  AssignContent: 'ASSIGN_CONTENT',
  /** Encourage ongoing learning */
  EncourageOngoingLearning: 'ENCOURAGE_ONGOING_LEARNING',
  /** Invite learners to the program */
  InviteLearners: 'INVITE_LEARNERS',
  /** Message enrolled learners */
  MessageEnrolledLearners: 'MESSAGE_ENROLLED_LEARNERS',
  /** Message inactive learners */
  MessageInactiveLearners: 'MESSAGE_INACTIVE_LEARNERS',
  /** Promote popular course */
  PromotePopularCourse: 'PROMOTE_POPULAR_COURSE',
  /** Reinforce learning for career growth */
  ReinforceLearningForCareerGrowth: 'REINFORCE_LEARNING_FOR_CAREER_GROWTH',
  /** Reminder to complete course */
  ReminderToCompleteCourse: 'REMINDER_TO_COMPLETE_COURSE',
  /** Remind benefits of upskilling */
  RemindBenefitsOfUpskilling: 'REMIND_BENEFITS_OF_UPSKILLING',
  /** Remind to join the program */
  RemindToJoin: 'REMIND_TO_JOIN',
  /** Send accolades */
  SendAccolades: 'SEND_ACCOLADES'
} as const;

export type EnterpriseAdminHomePage_ActionTakenType = typeof EnterpriseAdminHomePage_ActionTakenType[keyof typeof EnterpriseAdminHomePage_ActionTakenType];
/** Content entity */
export type EnterpriseAdminHomePage_Content = {
  __typename?: 'EnterpriseAdminHomePage_Content';
  /** Content ID */
  id: Scalars['ID'];
};

/** Contract utilization metrics */
export type EnterpriseAdminHomePage_ContractUtilization = {
  __typename?: 'EnterpriseAdminHomePage_ContractUtilization';
  /** Total number of enrollments compared to similar organizations in the selected time period */
  enrollmentUtilizationComparisonWithSimilarOrgs: Scalars['Float'];
  /** Total number of enrollments compared to the previous time period */
  enrollmentUtilizationComparisonWithTimePeriod: Scalars['Float'];
  /** Total number of invitations sent to learners (irrespective of time period selected) */
  invitationsSent: Scalars['Int'];
  /** Number of learners who have not joined any programs (irrespective of time period selected) */
  learnersNotJoined: Scalars['Int'];
  /** License utilization compared to similar organizations in the selected time period */
  licenseUtilizationComparisonWithSimilarOrgs: Scalars['Float'];
  /** License utilization compared to the previous time period */
  licenseUtilizationComparisonWithTimePeriod: Scalars['Float'];
  /** Total number of enrollments available for purchase (irrespective of time period selected) */
  totalEnrollmentsAvailable: Scalars['Int'];
  /** Total number of enrollments occupied by learners (irrespective of time period selected) */
  totalEnrollmentsOccupied: Scalars['Int'];
  /** Total number of enrollments purchased (irrespective of time period selected) */
  totalEnrollmentsPurchased: Scalars['Int'];
  /** Total number of licenses available for purchase (irrespective of time period selected) */
  totalLicensesAvailable: Scalars['Int'];
  /** Total number of licenses occupied by learners (irrespective of time period selected) */
  totalLicensesOccupied: Scalars['Int'];
  /** Total number of licenses purchased (irrespective of time period selected) */
  totalLicensesPurchased: Scalars['Int'];
};

/** Header details for the enterprise admin homepage */
export type EnterpriseAdminHomePage_HeaderDetails = {
  __typename?: 'EnterpriseAdminHomePage_HeaderDetails';
  /** Last refresh at */
  lastRefreshAt?: Maybe<Scalars['DateTime']>;
};

/** Learner activity and progress metrics */
export type EnterpriseAdminHomePage_LearnerActivityAndProgressMetrics = {
  __typename?: 'EnterpriseAdminHomePage_LearnerActivityAndProgressMetrics';
  /** Percentage of active learners compared to similar organizations */
  activeLearnerPercentageComparisonWithSimilarOrgs: Scalars['Float'];
  /** Percentage of active learners compared to the previous time period */
  activeLearnerPercentageComparisonWithTimePeriod: Scalars['Float'];
  /** Number of active learners */
  activeLearners: Scalars['Int'];
  /** Assessments taken */
  assessmentsTaken: Scalars['Int'];
  /** Assessments taken compared to the previous time period */
  assessmentsTakenComparisonWithTimePeriod: Scalars['Float'];
  /** Average learning hours */
  averageLearningHours: Scalars['Float'];
  /** Average learning hours compared to similar organizations */
  averageLearningHoursComparisonWithSimilarOrgs: Scalars['Float'];
  /** Average learning hours compared to the previous time period */
  averageLearningHoursComparisonWithTimePeriod: Scalars['Float'];
  /** Items completed */
  itemsCompleted: Scalars['Int'];
  /** Items completed compared to the previous time period */
  itemsCompletedComparisonWithTimePeriod: Scalars['Float'];
  /** Total number of enrollments */
  totalEnrollments: Scalars['Int'];
  /** Total number of enrollments compared to the previous time period */
  totalEnrollmentsComparisonWithTimePeriod: Scalars['Float'];
  /** Number of total learners */
  totalLearners: Scalars['Int'];
};

/** Level metrics */
export type EnterpriseAdminHomePage_LevelMetrics = {
  __typename?: 'EnterpriseAdminHomePage_LevelMetrics';
  /** Learners assessed */
  currentLearnerCount: Scalars['Int'];
  /** Growth percentage in current time period */
  growthPercentage: Scalars['Float'];
  /** Percentage growth as compared to similar organizations */
  growthPercentageComparisonWithSimilarOrgs: Scalars['Float'];
  /** Level */
  level: Scalars['String'];
  /** Previous learner count */
  previousLearnerCount: Scalars['Int'];
};

/** Input type for marking a recommended action as completed */
export type EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedInput = {
  /** Type of action taken by the admin */
  actionTakenType: EnterpriseAdminHomePage_ActionTakenType;
  /** Enterprise organization ID */
  enterpriseOrganizationId: Scalars['ID'];
  /** Product ID related to the recommended action (if exists) */
  productId?: InputMaybe<Scalars['ID']>;
};

/** Result type for marking a recommended action as completed */
export type EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedResult = {
  __typename?: 'EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedResult';
  /** Message for the result */
  message?: Maybe<Scalars['String']>;
  /** Whether the action was marked as completed */
  success: Scalars['Boolean'];
};

/** Page context for which recommended actions are requested */
export const EnterpriseAdminHomePage_PageContext = {
  /** Messaging page */
  Messaging: 'MESSAGING'
} as const;

export type EnterpriseAdminHomePage_PageContext = typeof EnterpriseAdminHomePage_PageContext[keyof typeof EnterpriseAdminHomePage_PageContext];
/** Recommended action for the admin */
export type EnterpriseAdminHomePage_RecommendedAction = {
  __typename?: 'EnterpriseAdminHomePage_RecommendedAction';
  /** Status of the recommended action */
  actionStatus: EnterpriseAdminHomePage_RecommendedActionStatus;
  /** Type of the recommended action */
  actionType: EnterpriseAdminHomePage_RecommendedActionType;
  /** Course ID related to the recommended action (if exists) */
  courseId?: Maybe<Scalars['ID']>;
  /** Metric for the recommended action  (if exists) */
  metric?: Maybe<Scalars['Int']>;
  /** Skill ID related to the recommended action  (if exists) */
  skillId?: Maybe<Scalars['ID']>;
};

/** Status of the recommended action */
export const EnterpriseAdminHomePage_RecommendedActionStatus = {
  /** Completed status */
  Completed: 'COMPLETED',
  /** Pending status */
  Pending: 'PENDING'
} as const;

export type EnterpriseAdminHomePage_RecommendedActionStatus = typeof EnterpriseAdminHomePage_RecommendedActionStatus[keyof typeof EnterpriseAdminHomePage_RecommendedActionStatus];
/** Type of the recommended action */
export const EnterpriseAdminHomePage_RecommendedActionType = {
  /** Assign content high engagement */
  AssignContentHighEngagement: 'ASSIGN_CONTENT_HIGH_ENGAGEMENT',
  /** Assign content least growth skill */
  AssignContentLeastGrowthSkill: 'ASSIGN_CONTENT_LEAST_GROWTH_SKILL',
  /** Assign content low engagement */
  AssignContentLowEngagement: 'ASSIGN_CONTENT_LOW_ENGAGEMENT',
  /** Encourage ongoing learning */
  EncourageOngoingLearning: 'ENCOURAGE_ONGOING_LEARNING',
  /** Invite learners enrollment based */
  InviteLearnersEnrollmentBased: 'INVITE_LEARNERS_ENROLLMENT_BASED',
  /** Invite learners license based */
  InviteLearnersLicenseBased: 'INVITE_LEARNERS_LICENSE_BASED',
  /** Message enrolled learners */
  MessageEnrolledLearners: 'MESSAGE_ENROLLED_LEARNERS',
  /** Message inactive learners */
  MessageInactiveLearners: 'MESSAGE_INACTIVE_LEARNERS',
  /** Promote popular course */
  PromotePopularCourse: 'PROMOTE_POPULAR_COURSE',
  /** Reinforce learning for career growth */
  ReinforceLearningForCareerGrowth: 'REINFORCE_LEARNING_FOR_CAREER_GROWTH',
  /** Reminder to complete course */
  ReminderToCompleteCourse: 'REMINDER_TO_COMPLETE_COURSE',
  /** Remind benefits of upskilling */
  RemindBenefitsOfUpskilling: 'REMIND_BENEFITS_OF_UPSKILLING',
  /** Remind to join the program */
  RemindToJoin: 'REMIND_TO_JOIN',
  /** Send accolades */
  SendAccolades: 'SEND_ACCOLADES'
} as const;

export type EnterpriseAdminHomePage_RecommendedActionType = typeof EnterpriseAdminHomePage_RecommendedActionType[keyof typeof EnterpriseAdminHomePage_RecommendedActionType];
/** Input for requesting more licenses */
export type EnterpriseAdminHomePage_RequestMoreLicensesInput = {
  /** List of Contract IDs */
  contractIds: Array<Scalars['ID']>;
  /** Enterprise organization ID */
  enterpriseOrganizationId: Scalars['ID'];
};

/** Result for requesting more licenses */
export type EnterpriseAdminHomePage_RequestMoreLicensesResult = {
  __typename?: 'EnterpriseAdminHomePage_RequestMoreLicensesResult';
  /** Message for the result */
  message?: Maybe<Scalars['String']>;
  /** Whether the licenses were requested successfully */
  success: Scalars['Boolean'];
};

/** Skill development metrics */
export type EnterpriseAdminHomePage_SkillDevelopmentMetrics = {
  __typename?: 'EnterpriseAdminHomePage_SkillDevelopmentMetrics';
  /** Average skill growth */
  averageSkillGrowth: Scalars['Float'];
  /** Average skill growth as compared to similar organizations */
  averageSkillGrowthComparisonWithSimilarOrgs: Scalars['Float'];
  /** Average skill growth as compared to the previous time period */
  averageSkillGrowthComparisonWithTimePeriod: Scalars['Float'];
  /** Content driving skill growth */
  contentDrivingSkillGrowth: Array<EnterpriseAdminHomePage_Content>;
  /** Total number of learners assessed */
  learnersAssessed: Scalars['Int'];
  /** Percentage change of learners assessed as compared to the previous time period */
  learnersAssessedComparisonWithTimePeriod: Scalars['Float'];
  /** Skill trends */
  levelMetrics: Array<EnterpriseAdminHomePage_LevelMetrics>;
  /** Skill ID */
  skillId?: Maybe<Scalars['ID']>;
  /** List of top tracked skills. This will be the same irrespective of the skill id passed */
  topTrackedSkillIds: Array<Scalars['ID']>;
};

/** Time period for fetching enterprise admin homepage metrics */
export const EnterpriseAdminHomePage_TimePeriod = {
  /** Complete contract duration */
  AllTime: 'ALL_TIME',
  /** Last 90 days */
  NinetyDays: 'NINETY_DAYS',
  /** Last 30 days */
  ThirtyDays: 'THIRTY_DAYS'
} as const;

export type EnterpriseAdminHomePage_TimePeriod = typeof EnterpriseAdminHomePage_TimePeriod[keyof typeof EnterpriseAdminHomePage_TimePeriod];
/** Enterprise admin invitation queries */
export type EnterpriseAdminInvitationQueries = {
  __typename?: 'EnterpriseAdminInvitationQueries';
  /** This query returns a paginated enterprise admin invitations by organizationId and invitation state */
  queryByOrganizationIdAndState?: Maybe<EnterpriseAdmin_InvitationsPaginatedResult>;
};


/** Enterprise admin invitation queries */
export type EnterpriseAdminInvitationQueriesQueryByOrganizationIdAndStateArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  organizationId: Scalars['ID'];
  state: EnterpriseAdminInvitation_State;
};

/** Possible states for an EnterpriseAdmin invitation. */
export const EnterpriseAdminInvitation_State = {
  /** The invitation has been accepted. */
  Accepted: 'ACCEPTED',
  /** The invitation is active and can be accepted. */
  Active: 'ACTIVE',
  /** The invitation has been deleted. */
  Deleted: 'DELETED'
} as const;

export type EnterpriseAdminInvitation_State = typeof EnterpriseAdminInvitation_State[keyof typeof EnterpriseAdminInvitation_State];
/** Program admin homepage metrics queries */
export type EnterpriseAdminProgramMetricsQueries = {
  __typename?: 'EnterpriseAdminProgramMetricsQueries';
  /** Returns a list of summaries for the given program ids */
  getSummariesByProgramIds: Array<EnterpriseAdminProgramMetrics_Summary>;
};


/** Program admin homepage metrics queries */
export type EnterpriseAdminProgramMetricsQueriesGetSummariesByProgramIdsArgs = {
  programIds: Array<Scalars['ID']>;
};

/** Program admin homepage metrics summary */
export type EnterpriseAdminProgramMetrics_Summary = Node & {
  __typename?: 'EnterpriseAdminProgramMetrics_Summary';
  /** Number of active learners in the last 30 days */
  activeLearnersLast30Days?: Maybe<Scalars['Int']>;
  /** Program ID */
  id: Scalars['ID'];
  /** Number of enrollments still available to be utilized, if there is an enrollment limit, otherwise null */
  remainingEnrollmentLimit?: Maybe<Scalars['Int']>;
  /** Number of licenses still available to be utilized, if there is a license limit, otherwise null */
  remainingLicenseLimit?: Maybe<Scalars['Int']>;
  /** Total number of enrollments available to be utilized, if there is an enrollment limit, otherwise null */
  totalEnrollmentLimit?: Maybe<Scalars['Int']>;
  /** Number of invitations created in the system */
  totalInvitationCount: Scalars['Int'];
  /** Number of users that joined the programs */
  totalLearnersJoined: Scalars['Int'];
  /** Number of users that have not joined the programs */
  totalLearnersNotJoined: Scalars['Int'];
  /** Number of users that have joined the programs and have enrollments */
  totalLearnersWithEnrollments: Scalars['Int'];
  /** Number of users that have joined the programs and do not have enrollments */
  totalLearnersWithoutEnrollments: Scalars['Int'];
  /** Total number of licenses available to be utilized, if there is a license limit, otherwise null */
  totalLicenseLimit?: Maybe<Scalars['Int']>;
};

/** Failure response for EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailure */
export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailure = {
  __typename?: 'EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailure';
  /** Failure reason */
  reason: EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason;
};

/** Assignment failure reasons */
export const EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason = {
  /** User's email is not verified */
  EmailIsNotVerified: 'EMAIL_IS_NOT_VERIFIED',
  /** The email on the invitation is not associated with the current user */
  EmailNotAssociatedWithUser: 'EMAIL_NOT_ASSOCIATED_WITH_USER',
  /** Invitation not found or not active */
  NoActiveEnterpriseAdminInvitationFound: 'NO_ACTIVE_ENTERPRISE_ADMIN_INVITATION_FOUND'
} as const;

export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason = typeof EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason[keyof typeof EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailureReason];
/** Enterprise admin invitation accept all invitations for email and organization from invitation input */
export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationInput = {
  /** The invitation id to be accepted */
  invitationId: Scalars['ID'];
};

/** Success and failure handling for AcceptAllInvitationsForEmailAndOrganizationFromInvitation mutation */
export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationResult = EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationFailure | EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationSuccess;

/** Success accepting all invitations for email and organization from invitation */
export type EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationSuccess = {
  __typename?: 'EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Enterprise admin invitation input */
export type EnterpriseAdmin_CreateInvitationsOrRolesInput = {
  /** The emails of the invited users. */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs. Empty program IDs means adding the role at the org level. */
  programIds: Array<Scalars['ID']>;
  /** Template IDs of the roles to be created */
  roleTemplateId: Scalars['ID'];
  /** If we should send or skip the email notification */
  skipEmailNotification: Scalars['Boolean'];
};

/** Partial success response for EnterpriseAdmin_CreateInvitationsOrRoles */
export type EnterpriseAdmin_CreateInvitationsOrRolesPartialSuccess = {
  __typename?: 'EnterpriseAdmin_CreateInvitationsOrRolesPartialSuccess';
  /** Errors */
  errors: Array<Scalars['String']>;
  /** Invitations sent */
  invitesSent: Array<EnterpriseAdmin_GroupedInvitations>;
  /** Emails of roles created */
  rolesAdded?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Success and failure handling for CreateInvitationsOrRoles mutation */
export type EnterpriseAdmin_CreateInvitationsOrRolesResult = EnterpriseAdmin_CreateInvitationsOrRolesPartialSuccess | EnterpriseAdmin_CreateInvitationsOrRolesSuccess;

/** Success processing new invitations or roles */
export type EnterpriseAdmin_CreateInvitationsOrRolesSuccess = {
  __typename?: 'EnterpriseAdmin_CreateInvitationsOrRolesSuccess';
  /** Invitations created */
  invitesSent: Array<EnterpriseAdmin_GroupedInvitations>;
  /** Emails of roles created */
  rolesAdded?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Failure response for EnterprisePermission_DeleteAllAdminInvitations */
export type EnterpriseAdmin_DeleteAllAdminInvitationsFailure = EnterpriseAdmin_Error & Error & {
  __typename?: 'EnterpriseAdmin_DeleteAllAdminInvitationsFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise admin invitation delete all admin invitations input */
export type EnterpriseAdmin_DeleteAllAdminInvitationsInput = {
  /** User's email */
  email: Scalars['String'];
  /** The organization id */
  organizationId: Scalars['ID'];
};

/** Success and failure handling for DeleteAllAdminInvitations mutation */
export type EnterpriseAdmin_DeleteAllAdminInvitationsResult = EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteAllAdminInvitationsSuccess;

/** Success deleting admin invitations for EnterprisePermission_DeleteAllAdminInvitations */
export type EnterpriseAdmin_DeleteAllAdminInvitationsSuccess = {
  __typename?: 'EnterpriseAdmin_DeleteAllAdminInvitationsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Failure response for EnterpriseAdmin_DeleteInvitationsOrRolesFailure */
export type EnterpriseAdmin_DeleteInvitationsOrRolesFailure = EnterpriseAdmin_Error & Error & {
  __typename?: 'EnterpriseAdmin_DeleteInvitationsOrRolesFailure';
  /** Errors */
  message: Scalars['String'];
};

/** Enterprise admin invitation delete input */
export type EnterpriseAdmin_DeleteInvitationsOrRolesInput = {
  /** The invitation id to be deleted */
  invitationId: Scalars['ID'];
};

/** Success and failure handling for DeleteInvitationsOrRoles mutation */
export type EnterpriseAdmin_DeleteInvitationsOrRolesResult = EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseAdmin_DeleteInvitationsOrRolesSuccess;

/** Success deleting invitations or roles */
export type EnterpriseAdmin_DeleteInvitationsOrRolesSuccess = {
  __typename?: 'EnterpriseAdmin_DeleteInvitationsOrRolesSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Invitation error interface */
export type EnterpriseAdmin_Error = {
  /** Error message */
  message: Scalars['String'];
};

/** Invitations grouped by the recipient */
export type EnterpriseAdmin_GroupedInvitations = {
  __typename?: 'EnterpriseAdmin_GroupedInvitations';
  /** Email address of the recipient */
  email: Scalars['String'];
  /** Invitations associated with the email address */
  invitations: Array<EnterpriseAdmin_Invitation>;
};

/** Invalid admin create */
export type EnterpriseAdmin_InvalidAdminCreate = {
  __typename?: 'EnterpriseAdmin_InvalidAdminCreate';
  /** Invalid domains */
  domains: Array<EnterprisePermission_RoleDomain>;
  /** User email */
  email: Scalars['String'];
  /** Reason */
  reason: EnterpriseAdmin_InvalidAdminCreateReason;
};

/** Reason that an admin role or invitation cannot be created */
export const EnterpriseAdmin_InvalidAdminCreateReason = {
  /** There proposed role conflicts with another role or invitation */
  ConflictingRole: 'CONFLICTING_ROLE',
  /** The proposed role already exists */
  DuplicateRole: 'DUPLICATE_ROLE'
} as const;

export type EnterpriseAdmin_InvalidAdminCreateReason = typeof EnterpriseAdmin_InvalidAdminCreateReason[keyof typeof EnterpriseAdmin_InvalidAdminCreateReason];
/** An invitation to the EnterpriseAdmin portal. */
export type EnterpriseAdmin_Invitation = Node & {
  __typename?: 'EnterpriseAdmin_Invitation';
  /** The date and time the invitation was created. */
  createdAt: Scalars['DateTime'];
  /** The email of the invited user. */
  email: Scalars['String'];
  /** The ID of the invitation. */
  id: Scalars['ID'];
  /** A managed level scope the invited user has access to */
  managedLevelScope: EnterpriseAdmin_ManagedScopeLevel;
  /** The role the invited user is being granted. */
  role: EnterpriseAdmin_InvitationRole;
  /** Template ID of the role, absent for legacy program/org admins */
  roleTemplateId?: Maybe<Scalars['ID']>;
  /** The current state of the invitation. */
  state: EnterpriseAdminInvitation_State;
  /** The third party organization */
  thirdPartyOrganization: ThirdPartyOrganizationsV1;
  /** The date and time the invitation was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** Enterprise admin invitation role */
export const EnterpriseAdmin_InvitationRole = {
  /** The role is for a organization admin */
  OrganizationFull: 'ORGANIZATION_FULL',
  /** The role is for a program admin */
  ProgramFull: 'PROGRAM_FULL'
} as const;

export type EnterpriseAdmin_InvitationRole = typeof EnterpriseAdmin_InvitationRole[keyof typeof EnterpriseAdmin_InvitationRole];
/** Paginated result for EnterpriseAdmin_Invitation */
export type EnterpriseAdmin_InvitationsPaginatedResult = {
  __typename?: 'EnterpriseAdmin_InvitationsPaginatedResult';
  /** List of elements */
  elements: Array<EnterpriseAdmin_Invitation>;
  /** Pagination information */
  pagination: Pagination;
};

/** Enterprise admin managed scope level input */
export type EnterpriseAdmin_ManagedLevelScopeInput = {
  /** ID of the organization. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** ID of the program. */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Enterprise admin managed scope level (Program or Organization) */
export type EnterpriseAdmin_ManagedScopeLevel = EnterpriseAdmin_ManagedScopeLevelOrganization | EnterpriseAdmin_ManagedScopeLevelProgram;

/** Enterprise admin managed scope level organization */
export type EnterpriseAdmin_ManagedScopeLevelOrganization = {
  __typename?: 'EnterpriseAdmin_ManagedScopeLevelOrganization';
  /** The third party organization */
  naptimeOrganization: ThirdPartyOrganizationsV1;
};

/** Enterprise admin managed scope level program */
export type EnterpriseAdmin_ManagedScopeLevelProgram = {
  __typename?: 'EnterpriseAdmin_ManagedScopeLevelProgram';
  /** The program */
  program: EnterpriseProgram;
};

/** input to EnterpriseAdmin_ValidateInvitationsOrRoles */
export type EnterpriseAdmin_ValidateInvitationsOrRolesInput = {
  /** The emails of the invited users. */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Program IDs. Empty program IDs means adding the role at the org level. */
  programIds: Array<Scalars['ID']>;
  /** Template IDs of the roles to be created */
  roleTemplateId: Scalars['ID'];
};

/** Response for EnterpriseAdmin_ValidateInvitationsOrRoles */
export type EnterpriseAdmin_ValidateInvitationsOrRolesResult = {
  __typename?: 'EnterpriseAdmin_ValidateInvitationsOrRolesResult';
  /** Invalid admin creates */
  invalidAdminCreates: Array<EnterpriseAdmin_InvalidAdminCreate>;
};

export type EnterpriseAuthoringMappingsV1 = {
  __typename?: 'EnterpriseAuthoringMappingsV1';
  enterprisePrograms?: Maybe<EnterpriseProgramsV1Connection>;
  id: Scalars['String'];
  partner?: Maybe<PartnersV1>;
  partnerId: Scalars['Int'];
  thirdPartyOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  thirdPartyOrganizationId: Scalars['String'];
  updatedAt: Scalars['Float'];
};


export type EnterpriseAuthoringMappingsV1EnterpriseProgramsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseAuthoringMappingsV1ByPartnerId = {
  __typename?: 'EnterpriseAuthoringMappingsV1ByPartnerId';
  connection?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseAuthoringMappingsV1ByPartnerIds = {
  __typename?: 'EnterpriseAuthoringMappingsV1ByPartnerIds';
  connection?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseAuthoringMappingsV1ByThirdPartyOrganizationId = {
  __typename?: 'EnterpriseAuthoringMappingsV1ByThirdPartyOrganizationId';
  connection?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  orgId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseAuthoringMappingsV1Connection = {
  __typename?: 'EnterpriseAuthoringMappingsV1Connection';
  elements: Array<Maybe<EnterpriseAuthoringMappingsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseAuthoringMappingsV1Resource = {
  __typename?: 'EnterpriseAuthoringMappingsV1Resource';
  byPartnerId?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  byPartnerIds?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  byThirdPartyOrganizationId?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  get?: Maybe<EnterpriseAuthoringMappingsV1>;
  getAll?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
  multiGet?: Maybe<EnterpriseAuthoringMappingsV1Connection>;
};


export type EnterpriseAuthoringMappingsV1ResourceByPartnerIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseAuthoringMappingsV1ResourceByPartnerIdsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseAuthoringMappingsV1ResourceByThirdPartyOrganizationIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseAuthoringMappingsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseAuthoringMappingsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseAuthoringMappingsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseAuthoringMappingsV1ResourceMutations = {
  __typename?: 'EnterpriseAuthoringMappingsV1ResourceMutations';
  linkExistingPartner?: Maybe<Scalars['JSON']>;
  linkNewPartner?: Maybe<Scalars['JSON']>;
  unlinkPartner?: Maybe<Scalars['JSON']>;
};

/** TODO: Complete this description */
export type EnterpriseBadgeQueries = {
  __typename?: 'EnterpriseBadgeQueries';
  /** This query returns if an enterprise organization has more than 0 badges */
  doesOrgHaveBadges: Scalars['Boolean'];
  /** Returns badge data for orgSlug */
  findByOrgSlug?: Maybe<EnterpriseBadge_BadgeWithUserStatePaginatedResult>;
  /** Returns data for a single badge by org slug and badge template slug, used for XDP page. */
  findByOrgSlugAndBadgeTemplateSlug?: Maybe<EnterpriseBadge_BadgeWithUserState>;
  /** Returns data for a single badge by ID, used for XDP page. */
  findByProgramAndBadgeTemplateId?: Maybe<EnterpriseBadge_BadgeWithUserState>;
  /** Returns data for a single badge by slug, used for XDP page. */
  findByProgramAndBadgeTemplateSlug?: Maybe<EnterpriseBadge_BadgeWithUserState>;
  /** Returns badge data for a list of programs */
  findByProgramIds?: Maybe<EnterpriseBadge_BadgeWithUserStatePaginatedResult>;
  /** This query returns all enterprise badge collections for a program with user states. */
  findByUserAndProgram: EnterpriseBadge_PaginationBadgeCollectionWithUserState;
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesDoesOrgHaveBadgesArgs = {
  organizationId: Scalars['ID'];
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByOrgSlugArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByOrgSlugAndBadgeTemplateSlugArgs = {
  badgeTemplateSlug: Scalars['String'];
  orgSlug: Scalars['String'];
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByProgramAndBadgeTemplateIdArgs = {
  badgeTemplateId: Scalars['ID'];
  programId: Scalars['ID'];
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByProgramAndBadgeTemplateSlugArgs = {
  badgeTemplateSlug: Scalars['String'];
  programId: Scalars['ID'];
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByProgramIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programIds: Array<Scalars['ID']>;
};


/** TODO: Complete this description */
export type EnterpriseBadgeQueriesFindByUserAndProgramArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

/** Badge configuration object */
export type EnterpriseBadge_BadgeConfigurationInput = {
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Url for the badge image */
  imageUrl: Scalars['URL'];
};

/** Response for findByProgramAndBadgeTemplateId */
export type EnterpriseBadge_BadgeWithUserState = {
  __typename?: 'EnterpriseBadge_BadgeWithUserState';
  /** Badge template ID */
  enterpriseBadge: EnterpriseBadge_EnterpriseBadge;
  /** List of program IDs that this badge belongs to within the org context. */
  programIds: Array<Scalars['ID']>;
  /** Learning Path State for user */
  userState: EnterpriseBadge_UserState;
};

/** Paginated result wrapper for EnterpriseBadge_BadgeWithUserState */
export type EnterpriseBadge_BadgeWithUserStatePaginatedResult = {
  __typename?: 'EnterpriseBadge_BadgeWithUserStatePaginatedResult';
  /** A list of enterprise badges with user state */
  elements: Array<EnterpriseBadge_BadgeWithUserState>;
  /** Pagination information */
  pagination: Pagination;
};

/** Failure response for EnterpriseProgram_Create */
export type EnterpriseBadge_CreateFailure = {
  __typename?: 'EnterpriseBadge_CreateFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input for badge creation */
export type EnterpriseBadge_CreateInput = {
  /** Name of the badge */
  badgeName: Scalars['String'];
  /** Source of the badge, should default to Credly unless specified as Coursera */
  badgeSource?: Badge_Source;
  /** List of products that require completion to attain the badge */
  criteria: Array<EnterpriseBadge_CriteriaItemInput>;
  /** Description of the badge */
  description: Scalars['String'];
  /** Url for the badge logo image */
  imageUrl: Scalars['URL'];
  /** Set of learning objectives for the badge */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the Learning Path */
  learningPathName: Scalars['String'];
  /** Program ID */
  programId: Scalars['ID'];
  /** Add optional ReferenceCollectionConfiguration for LP so it can copy from LP library */
  referenceCollectionConfiguration?: InputMaybe<EnterpriseBadge_ReferenceCollectionConfiguration>;
  /** List of skills that required by Credly */
  skills: Array<Scalars['ID']>;
};

/** Success and failure handling for Enterprise Badge Create mutation */
export type EnterpriseBadge_CreateResult = EnterpriseBadge_CreateFailure | EnterpriseBadge_CreateSuccess;

/** Success response for EnterpriseBadge_Create */
export type EnterpriseBadge_CreateSuccess = {
  __typename?: 'EnterpriseBadge_CreateSuccess';
  /** Newly created Enterprise Badge */
  body: EnterpriseBadge_EnterpriseBadge;
  /** The collection tracking ID of newly created Learning Path in curriculum */
  curriculumTrackId?: Maybe<Scalars['ID']>;
};

/** Criteria options for badge creation */
export type EnterpriseBadge_CriteriaItemInput = {
  /** Only course as criteria are allowed currently */
  courseId?: InputMaybe<Scalars['ID']>;
};

/** Input for badge DeleteLearningPath */
export type EnterpriseBadge_DeleteLearningPathInput = {
  /** ID of the badge template to delete */
  badgeTemplateId: Scalars['ID'];
  /** Program ID that the the badge belongs to */
  programId: Scalars['ID'];
};

/** Response for EnterpriseBadge_DeleteLearningPath */
export type EnterpriseBadge_DeleteLearningPathResult = {
  __typename?: 'EnterpriseBadge_DeleteLearningPathResult';
  /** Flag indicating if the delete was completed successfully. */
  success: Scalars['Boolean'];
};

/** Input for duplicating Learning Path */
export type EnterpriseBadge_DuplicateLearningPathInput = {
  /** ID of the badge template to duplicate */
  badgeTemplateId: Scalars['ID'];
  /** Program Id contains the badge template to duplicate */
  originProgramId: Scalars['ID'];
  /** Program ID that new badge belongs to */
  programId: Scalars['ID'];
};

/** Success response for EnterpriseBadge_Create */
export type EnterpriseBadge_DuplicateLearningPathResult = {
  __typename?: 'EnterpriseBadge_DuplicateLearningPathResult';
  /** Newly created Enterprise Badge */
  badge: EnterpriseBadge_EnterpriseBadge;
};

/** Learning Path (Badge) entity */
export type EnterpriseBadge_EnterpriseBadge = {
  __typename?: 'EnterpriseBadge_EnterpriseBadge';
  /** List of products that require completion to attain the badge */
  badgeActivities: Array<EnterpriseBadge_Product>;
  /** Description of the badge */
  description: Scalars['String'];
  /** The id of the badge, Apollo Client relies on id for cache management */
  id: Scalars['ID'];
  /** Url for the badge logo image */
  imageUrl: Scalars['URL'];
  /** Set of learning objectives for the badge */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the badge */
  name: Scalars['String'];
  /** Preview URL */
  previewUrl?: Maybe<Scalars['URL']>;
  /**
   * List of skills derived from Badge contents and admin hand picks.
   * @deprecated please use skillsMetadata field instead
   */
  skills: Array<Scalars['ID']>;
  /** List of skills derived from Badge contents and admin hand picks. */
  skillsMetadata: Array<Maybe<Skill_Skill>>;
  /** Slug of the badge */
  slug: Scalars['String'];
};

/** Failure response for EnterpriseProgram_GenerateLearningObjectives */
export type EnterpriseBadge_GenerateLearningObjectivesFailure = {
  __typename?: 'EnterpriseBadge_GenerateLearningObjectivesFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input for EnterpriseBadge_GenerateLearningObjectives */
export type EnterpriseBadge_GenerateLearningObjectivesInput = {
  /** List of products that will exist in the learning path */
  criteria: Array<EnterpriseBadge_CriteriaItemInput>;
  /** Optional language to generate the learning objectives in, otherwise defaults to the language of the course name/descriptions */
  language?: InputMaybe<Scalars['String']>;
  /** Program ID that the the badge belongs to */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Success and failure handling for Enterprise Badge GenerateLearningObjectives mutation */
export type EnterpriseBadge_GenerateLearningObjectivesResult = EnterpriseBadge_GenerateLearningObjectivesFailure | EnterpriseBadge_GenerateLearningObjectivesSuccess;

/** Success response for EnterpriseBadge_GenerateLearningObjectives */
export type EnterpriseBadge_GenerateLearningObjectivesSuccess = {
  __typename?: 'EnterpriseBadge_GenerateLearningObjectivesSuccess';
  /** Generated Learning Objectives. */
  learningObjectives: Array<Scalars['String']>;
};

/** Product as earning criteria in Enterprise Badge */
export type EnterpriseBadge_Product = Course_Course;

/** Configuration for the reference collection. Null if the collection does not reference other collections. */
export type EnterpriseBadge_ReferenceCollectionConfiguration = {
  /** Whether the curriculum collection should be synced to match the reference collection */
  enableSync?: Scalars['Boolean'];
  /** reference collection id */
  referenceCollectionId: Scalars['ID'];
  /** reference collection type */
  referenceCollectionType: EnterpriseBadge_ReferenceCollectionType;
};

/** Enum for badge reference collection type */
export const EnterpriseBadge_ReferenceCollectionType = {
  /** An organization collection */
  Organization: 'ORGANIZATION',
  /** A preset collection */
  Preset: 'PRESET'
} as const;

export type EnterpriseBadge_ReferenceCollectionType = typeof EnterpriseBadge_ReferenceCollectionType[keyof typeof EnterpriseBadge_ReferenceCollectionType];
/** Input for badge UpdateBadgeConfigurations */
export type EnterpriseBadge_UpdateBadgeConfigurationsInput = {
  /** List of badge configurations to update */
  badgeConfigurations: Array<EnterpriseBadge_BadgeConfigurationInput>;
  /** Program ID that the the badges belong to, can not be changed */
  programId: Scalars['ID'];
};

/** Response for EnterpriseBadge_UpdateBadgeConfigurations */
export type EnterpriseBadge_UpdateBadgeConfigurationsResult = {
  __typename?: 'EnterpriseBadge_UpdateBadgeConfigurationsResult';
  /** Array of badge template ids that were not updated */
  failIds: Array<Scalars['ID']>;
  /** Array of badge template ids that were successfully updated */
  successIds: Array<Scalars['ID']>;
};

/** Failure response for EnterpriseProgram_UpdateLearningPathActivities */
export type EnterpriseBadge_UpdateLearningPathActivitiesFailure = {
  __typename?: 'EnterpriseBadge_UpdateLearningPathActivitiesFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input for badge UpdateLearningPathActivities */
export type EnterpriseBadge_UpdateLearningPathActivitiesInput = {
  /** List of products that require completion to attain the badge */
  activities: Array<EnterpriseBadge_CriteriaItemInput>;
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Program ID that the the badge belongs to, can not be changed */
  programId: Scalars['ID'];
};

/** Success and failure handling for Enterprise Badge UpdateLearningPathActivities mutation */
export type EnterpriseBadge_UpdateLearningPathActivitiesResult = EnterpriseBadge_UpdateLearningPathActivitiesFailure | EnterpriseBadge_UpdateLearningPathActivitiesSuccess;

/** Success response for EnterpriseBadge_UpdateLearningPathActivities */
export type EnterpriseBadge_UpdateLearningPathActivitiesSuccess = {
  __typename?: 'EnterpriseBadge_UpdateLearningPathActivitiesSuccess';
  /** Flag indicating if the update was completed successfully. */
  success: Scalars['Boolean'];
};

/** Failure response for EnterpriseProgram_UpdateLearningPathMetadata */
export type EnterpriseBadge_UpdateLearningPathMetadataFailure = {
  __typename?: 'EnterpriseBadge_UpdateLearningPathMetadataFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input for badge UpdateLearningPathMetadata */
export type EnterpriseBadge_UpdateLearningPathMetadataInput = {
  /** Name of the badge */
  badgeName: Scalars['String'];
  /** ID of the badge template to update */
  badgeTemplateId: Scalars['ID'];
  /** Description of the badge */
  description: Scalars['String'];
  /** Url for the badge logo image */
  imageUrl: Scalars['URL'];
  /** Set of learning objectives for the badge (min 2, max 4) */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the Learning Path */
  learningPathName: Scalars['String'];
  /** List of skills that required by Credly */
  skills: Array<Scalars['ID']>;
};

/** Success and failure handling for Enterprise Badge UpdateLearningPathMetadata mutation */
export type EnterpriseBadge_UpdateLearningPathMetadataResult = EnterpriseBadge_UpdateLearningPathMetadataFailure | EnterpriseBadge_UpdateLearningPathMetadataSuccess;

/** Success response for EnterpriseBadge_UpdateLearningPathMetadata */
export type EnterpriseBadge_UpdateLearningPathMetadataSuccess = {
  __typename?: 'EnterpriseBadge_UpdateLearningPathMetadataSuccess';
  /** Flag indicating if the update was completed successfully. */
  success: Scalars['Boolean'];
};

/**
 * Model that represents an enterprise badge collection with user state.
 * This is a combination of a badge template, badge user state, and products from an Enterprise
 * curriculum collection.
 */
export type EnterpriseBadge_BadgeCollectionWithUserState = {
  __typename?: 'EnterpriseBadge_badgeCollectionWithUserState';
  /** Id of the badge */
  badgeTemplateId: Scalars['String'];
  /** Id of the curriculum collection */
  collectionId: Scalars['String'];
  /** Description of the badge */
  description?: Maybe<Scalars['String']>;
  /** Url for the badge logo image */
  imageUrl: Scalars['String'];
  /** Set of learning objectives for the badge */
  learningObjectives: Array<Scalars['String']>;
  /** List of products that require completion to attain the badge */
  productIds: Array<EnterpriseBadge_ProductId>;
  /** List of skills derived from Badge contents and admin hand picks. */
  skillsMetadata: Array<Maybe<Skill_Skill>>;
  /** Slug of the badge */
  slug: Scalars['String'];
  /** Title of the badge */
  title: Scalars['String'];
  /** State that the user is in */
  userState: EnterpriseBadge_UserState;
};

/** TODO: Complete this description */
export type EnterpriseBadge_PaginationBadgeCollectionWithUserState = {
  __typename?: 'EnterpriseBadge_paginationBadgeCollectionWithUserState';
  /** TODO: Complete this description */
  badgeCollectionsWithUserState: Array<EnterpriseBadge_BadgeCollectionWithUserState>;
  /** This is a nullable parameter indicating next index that can be used to request more collections */
  next?: Maybe<Scalars['Int']>;
  /** Maximum number of returned records */
  total: Scalars['Int'];
};

/** Model that represents the type and id of a learning product */
export type EnterpriseBadge_ProductId = {
  __typename?: 'EnterpriseBadge_productId';
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  type: EnterpriseBadge_ProductType;
};

/** Enum that defines the type of products supported */
export const EnterpriseBadge_ProductType = {
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type EnterpriseBadge_ProductType = typeof EnterpriseBadge_ProductType[keyof typeof EnterpriseBadge_ProductType];
/** Enum that defines all possible user states for a badge */
export const EnterpriseBadge_UserState = {
  /** TODO: Complete this description */
  Enrolled: 'ENROLLED',
  /** TODO: Complete this description */
  Issued: 'ISSUED',
  /** TODO: Complete this description */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** TODO: Complete this description */
  Unenrolled: 'UNENROLLED'
} as const;

export type EnterpriseBadge_UserState = typeof EnterpriseBadge_UserState[keyof typeof EnterpriseBadge_UserState];
export type EnterpriseBrowseCollectionsV1 = {
  __typename?: 'EnterpriseBrowseCollectionsV1';
  courses?: Maybe<CoursesV1Connection>;
  debug?: Maybe<Scalars['String']>;
  degrees?: Maybe<DegreesV1Connection>;
  domain?: Maybe<DomainsV1>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId?: Maybe<Scalars['String']>;
  enterpriseProductConfigurations?: Maybe<EnterpriseProductConfigurationMetadataV1Connection>;
  entries: Array<Maybe<EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntry>>;
  eventingId?: Maybe<Scalars['String']>;
  facets: Scalars['JSON'];
  featuredListId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  label?: Maybe<Scalars['String']>;
  latestVersionS12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  linkedCollectionPageMetadata?: Maybe<EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget>;
  overrideRank?: Maybe<Scalars['Int']>;
  productConfigurationScopeIds: Array<Maybe<Scalars['String']>>;
  query?: Maybe<Scalars['String']>;
  relatedDegrees?: Maybe<DegreesV1Connection>;
  relatedQueries?: Maybe<Array<Maybe<Scalars['String']>>>;
  relatedS12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  relatedUpsellsDegrees?: Maybe<DegreesV1Connection>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  subdomain?: Maybe<SubdomainsV1>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
  suggestions: Array<Maybe<EnterpriseBrowseCollectionsV1_Org_Coursera_Catalog_Suggestion>>;
};


export type EnterpriseBrowseCollectionsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseBrowseCollectionsV1DegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1EnterpriseProductConfigurationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1LatestVersionS12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1RelatedDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1RelatedS12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1RelatedUpsellsDegreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseBrowseCollectionsV1AcademicDisciplines = {
  __typename?: 'EnterpriseBrowseCollectionsV1AcademicDisciplines';
  connection?: Maybe<EnterpriseBrowseCollectionsV1Connection>;
  contractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  recommendedOnly?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseBrowseCollectionsV1ByCollections = {
  __typename?: 'EnterpriseBrowseCollectionsV1ByCollections';
  connection?: Maybe<EnterpriseBrowseCollectionsV1Connection>;
  contextId: Scalars['String'];
  contextType: Scalars['String'];
  contractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  numEntriesPerCollection?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseBrowseCollectionsV1Connection = {
  __typename?: 'EnterpriseBrowseCollectionsV1Connection';
  elements: Array<Maybe<EnterpriseBrowseCollectionsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseBrowseCollectionsV1Resource = {
  __typename?: 'EnterpriseBrowseCollectionsV1Resource';
  academicDisciplines?: Maybe<EnterpriseBrowseCollectionsV1Connection>;
  byCollections?: Maybe<EnterpriseBrowseCollectionsV1Connection>;
};


export type EnterpriseBrowseCollectionsV1ResourceAcademicDisciplinesArgs = {
  contractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['String']>;
  recommendedOnly?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseBrowseCollectionsV1ResourceByCollectionsArgs = {
  contextId: Scalars['String'];
  contextType: Scalars['String'];
  contractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  numEntriesPerCollection?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseBrowseCollectionsV1_Org_Coursera_Catalog_Suggestion = {
  __typename?: 'EnterpriseBrowseCollectionsV1_org_coursera_catalog_Suggestion';
  frequency: Scalars['Float'];
  term: Scalars['String'];
};

export type EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntry = {
  __typename?: 'EnterpriseBrowseCollectionsV1_org_coursera_catalogp_browse_CatalogEntry';
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  additionalSolrFieldValues?: Maybe<Scalars['JSON']>;
  courseId?: Maybe<Scalars['String']>;
  degreeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isFreeCertificate?: Maybe<Scalars['Boolean']>;
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  latestVersionedS12nId?: Maybe<Scalars['String']>;
  onDemandSpecializationId?: Maybe<Scalars['String']>;
  relatedIds?: Maybe<EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds>;
  resourceName: Scalars['String'];
  score?: Maybe<Scalars['Float']>;
  specializationId?: Maybe<Scalars['String']>;
};

/** Record that contains ids relating to a specific CatalogEntry in some way. For example, if the CatalogEntry is a course, the `s12nId` field will be populated with the s12n that the course is a part of. "degreeId" will only be filled if a COURSE is a degree course "upsellsDegreeId" will be filled if a COURSE or S12N is a degree course, or is a stackable open degree enrollment item details: https://coursera.atlassian.net/wiki/spaces/GROW/pages/49512475/Degree+Upsells */
export type EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogEntryRelatedIds = {
  __typename?: 'EnterpriseBrowseCollectionsV1_org_coursera_catalogp_browse_CatalogEntryRelatedIds';
  /** Identifier for a degree. */
  degreeId?: Maybe<Scalars['String']>;
  s12nId?: Maybe<Scalars['String']>;
  /** Identifier for a degree. */
  upsellsDegreeId?: Maybe<Scalars['String']>;
};

export type EnterpriseBrowseCollectionsV1_Org_Coursera_Catalogp_Browse_CatalogResultTarget = {
  __typename?: 'EnterpriseBrowseCollectionsV1_org_coursera_catalogp_browse_CatalogResultTarget';
  /** Typeref for string that defines the isTranslatable property to true */
  label: Scalars['String'];
  url: Scalars['String'];
};

export type EnterpriseCollectionsAdminV1 = {
  __typename?: 'EnterpriseCollectionsAdminV1';
  collectionTypeProperties: EnterpriseCollectionsAdminV1_CollectionTypeProperties;
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  createdAt: Scalars['Float'];
  deletedAt?: Maybe<Scalars['Float']>;
  description?: Maybe<EnterpriseCollectionsAdminV1_CmlMember>;
  id: Scalars['String'];
  lastUpdatedAt: Scalars['Float'];
  /** id for a Coursera user */
  lastUpdatedBy: Scalars['Int'];
  orderedProducts: Array<Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_CollectionProduct>>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  thirdPartyOrganizationId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};


export type EnterpriseCollectionsAdminV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseCollectionsAdminV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseCollectionsAdminV1ByProgramIdAndSkillsetId = {
  __typename?: 'EnterpriseCollectionsAdminV1ByProgramIdAndSkillsetId';
  connection?: Maybe<EnterpriseCollectionsAdminV1Connection>;
  includeSkillsetStaticCollection?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  skillId?: Maybe<Scalars['String']>;
  skillsetId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  usePersonalizedRecs?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type EnterpriseCollectionsAdminV1Connection = {
  __typename?: 'EnterpriseCollectionsAdminV1Connection';
  elements: Array<Maybe<EnterpriseCollectionsAdminV1>>;
  paging: ResponsePagination;
};

export type EnterpriseCollectionsAdminV1Resource = {
  __typename?: 'EnterpriseCollectionsAdminV1Resource';
  byProgramIdAndSkillsetId?: Maybe<EnterpriseCollectionsAdminV1Connection>;
  get?: Maybe<EnterpriseCollectionsAdminV1>;
  multiGet?: Maybe<EnterpriseCollectionsAdminV1Connection>;
};


export type EnterpriseCollectionsAdminV1ResourceByProgramIdAndSkillsetIdArgs = {
  includeSkillsetStaticCollection?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  skillId?: InputMaybe<Scalars['String']>;
  skillsetId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  usePersonalizedRecs?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type EnterpriseCollectionsAdminV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseCollectionsAdminV1ResourceMultiGetArgs = {
  functionId?: InputMaybe<Scalars['String']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  occupationId?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  templateSkillProfileId?: InputMaybe<Scalars['String']>;
  usePersonalizedRecs?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type EnterpriseCollectionsAdminV1ResourceMutations = {
  __typename?: 'EnterpriseCollectionsAdminV1ResourceMutations';
  create?: Maybe<EnterpriseCollectionsAdminV1Connection>;
  delete?: Maybe<EnterpriseCollectionsAdminV1Connection>;
  patch?: Maybe<EnterpriseCollectionsAdminV1Connection>;
};


export type EnterpriseCollectionsAdminV1ResourceMutationsDeleteArgs = {
  deletedBy?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type EnterpriseCollectionsAdminV1ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};

export type EnterpriseCollectionsAdminV1_CmlMember = {
  __typename?: 'EnterpriseCollectionsAdminV1_cmlMember';
  cml: EnterpriseCollectionsAdminV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type EnterpriseCollectionsAdminV1_CollectionTypeProperties = EnterpriseCollectionsAdminV1_DynamicSkillsCollectionMember | EnterpriseCollectionsAdminV1_StaticSkillsCollectionMember | EnterpriseCollectionsAdminV1_StaticTargetSkillProfileCollectionMember;

export type EnterpriseCollectionsAdminV1_DynamicSkillsCollectionMember = {
  __typename?: 'EnterpriseCollectionsAdminV1_dynamicSkillsCollectionMember';
  dynamicSkillsCollection: EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_DynamicSkillsCollection;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type EnterpriseCollectionsAdminV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type EnterpriseCollectionsAdminV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type EnterpriseCollectionsAdminV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: EnterpriseCollectionsAdminV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type EnterpriseCollectionsAdminV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_CollectionProduct = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_enterprise_collection_CollectionProduct';
  productId: Scalars['String'];
};

/** This type of collection dynamically hydrates the content from Data Science APIs. This model can be expanded to contain relevant metadata. */
export type EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_DynamicSkillsCollection = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_enterprise_collection_DynamicSkillsCollection';
  /** Identifier for Skills at different levels in skill graph */
  skillId: Scalars['String'];
  targetProficiency: Scalars['Int'];
};

/** This type of collection has its products customized by an admin. */
export type EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_StaticSkillsCollection = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_enterprise_collection_StaticSkillsCollection';
  products: Array<Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_CollectionProduct>>;
  /** Identifier for Skills at different levels in skill graph */
  skillId: Scalars['String'];
  targetProficiency: Scalars['Int'];
};

export type EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_StaticTargetSkillProfileCollection = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_enterprise_collection_StaticTargetSkillProfileCollection';
  products: Array<Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_CollectionProduct>>;
  targetSkillProfileId: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type EnterpriseCollectionsAdminV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'EnterpriseCollectionsAdminV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<EnterpriseCollectionsAdminV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type EnterpriseCollectionsAdminV1_StaticSkillsCollectionMember = {
  __typename?: 'EnterpriseCollectionsAdminV1_staticSkillsCollectionMember';
  staticSkillsCollection: EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_StaticSkillsCollection;
};

export type EnterpriseCollectionsAdminV1_StaticTargetSkillProfileCollectionMember = {
  __typename?: 'EnterpriseCollectionsAdminV1_staticTargetSkillProfileCollectionMember';
  staticTargetSkillProfileCollection: EnterpriseCollectionsAdminV1_Org_Coursera_Enterprise_Collection_StaticTargetSkillProfileCollection;
};

/** Queries for enterprise content assignment */
export type EnterpriseContentAssignmentQueries = {
  __typename?: 'EnterpriseContentAssignmentQueries';
  /** Queries content assignment with summary info for admins. | Maximum page size: 200 */
  EnterpriseContentAssignment_GetAssignmentsByProgram: EnterpriseContentAssignment_PaginatedContentAssignments;
  /** Queries raw content assignments for individual learners. Used for showing assignments on program-home. | Maximum page size: 200 */
  getAssignmentsByUserAndPrograms: EnterpriseContentAssignment_LearnerContentAssignmentPaginatedResult;
};


/** Queries for enterprise content assignment */
export type EnterpriseContentAssignmentQueriesEnterpriseContentAssignment_GetAssignmentsByProgramArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  programId: Scalars['ID'];
};


/** Queries for enterprise content assignment */
export type EnterpriseContentAssignmentQueriesGetAssignmentsByUserAndProgramsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

/** Queries related to resolving admin insights around content assignments and user activity. */
export type EnterpriseContentAssignmentUserInsightQueries = {
  __typename?: 'EnterpriseContentAssignmentUserInsightQueries';
  /** Queries list of assigned users for a piece of content. Used by admins. | Maximum page size: 200 */
  getAssignedUsers: EnterpriseContentAssignment_AssignedUserPaginatedResult;
  /** Queries for a summary of how users are progressing through the assigned content. */
  getAssignmentUserFunnelInsights: EnterpriseContentAssignment_AssignmentUserFunnelInsights;
};


/** Queries related to resolving admin insights around content assignments and user activity. */
export type EnterpriseContentAssignmentUserInsightQueriesGetAssignedUsersArgs = {
  contentId: Scalars['ID'];
  contentType: EnterpriseContentAssignment_ContentType;
  cursor?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isEnrolled?: InputMaybe<Scalars['Boolean']>;
  isInvited?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
  searchByNameOrEmail?: InputMaybe<Scalars['String']>;
};


/** Queries related to resolving admin insights around content assignments and user activity. */
export type EnterpriseContentAssignmentUserInsightQueriesGetAssignmentUserFunnelInsightsArgs = {
  contentId: Scalars['ID'];
  contentType: EnterpriseContentAssignment_ContentType;
  programId: Scalars['ID'];
};

/** Assigned User model. */
export type EnterpriseContentAssignment_AssignedUser = {
  __typename?: 'EnterpriseContentAssignment_AssignedUser';
  /** Info about the admin that assigned the content. */
  assignedBy?: Maybe<EnterpriseContentAssignment_AssignerInfo>;
  /** When the content was assigned. */
  assignedTime: Scalars['DateTime'];
  /** Email address of assigned user */
  email: Scalars['String'];
  /** Full name of assigned user */
  fullName: Scalars['String'];
  /** Whether the learner completed the content. */
  isCompleted: Scalars['Boolean'];
  /** Whether the learner is enrolled into the content. */
  isEnrolled: Scalars['Boolean'];
  /** Whether the learner is invited to the program. */
  isInvited: Scalars['Boolean'];
  /** number of courses completed by the user. This field is only fetched if the user is enrolled and contentType is SPECIALIZATION. */
  numCoursesCompleted?: Maybe<Scalars['Int']>;
  /** number of courses total in the specialization. This field is only fetched if the user is enrolled and contentType is SPECIALIZATION. */
  numCoursesTotal?: Maybe<Scalars['Int']>;
  /**
   * Progress percentage of the user in the course. This data is only fetched if the user is enrolled.
   * It's possible for a user to have progress but not currently enrolled, which this won't handle.
   */
  progressPercentage?: Maybe<Scalars['Float']>;
  /** User ID of assigned user if the user is a program member (which they always will be to start). */
  userId?: Maybe<Scalars['ID']>;
};

/** Paginated result set of assigned users. */
export type EnterpriseContentAssignment_AssignedUserPaginatedResult = {
  __typename?: 'EnterpriseContentAssignment_AssignedUserPaginatedResult';
  /** List of returned assigned users */
  elements: Array<EnterpriseContentAssignment_AssignedUser>;
  /** Pagination information */
  pagination: Pagination;
};

/** Assigner info */
export type EnterpriseContentAssignment_AssignerInfo = {
  __typename?: 'EnterpriseContentAssignment_AssignerInfo';
  /** Full name of the assigner */
  name: Scalars['String'];
};

/** Assignment failure */
export type EnterpriseContentAssignment_AssignmentFailure = {
  __typename?: 'EnterpriseContentAssignment_AssignmentFailure';
  /** Email of the attempted assignee that failed. */
  email?: Maybe<Scalars['String']>;
  /** Failure reason for either the user ID or the email. If both are not present, it's a failure to assign to all users. */
  reason: EnterpriseContentAssignment_AssignmentFailureReason;
  /** User ID of the assignee */
  userId: Scalars['ID'];
};

/** Assignment failure reasons */
export const EnterpriseContentAssignment_AssignmentFailureReason = {
  /** Content is not enroll-able for user */
  ContentNotEnrollableForUser: 'CONTENT_NOT_ENROLLABLE_FOR_USER',
  /** Content is not available in the program */
  ContentNotInProgram: 'CONTENT_NOT_IN_PROGRAM',
  /** Content already assigned to the email address */
  EmailAlreadyAssigned: 'EMAIL_ALREADY_ASSIGNED',
  /** Email doesn't have program invitation and inviteNonMembers flag is false. */
  EmailDoesntHaveProgramInvitation: 'EMAIL_DOESNT_HAVE_PROGRAM_INVITATION',
  /**
   * NOTE: THIS ERROR WONT BE RETURNED ANYMORE. Since email could be not registered on coursera but still have program
   * invitation so we assign content to their email. Or, if invitation is not present and inviteNonMembers is false,
   * we return EMAIL_DOESNT_HAVE_PROGRAM_INVITATION error instead.
   */
  EmailNotRegistered: 'EMAIL_NOT_REGISTERED',
  /** User is already assigned to the content in the program */
  UserAlreadyAssigned: 'USER_ALREADY_ASSIGNED',
  /** User is not a member of the program */
  UserNotInProgram: 'USER_NOT_IN_PROGRAM'
} as const;

export type EnterpriseContentAssignment_AssignmentFailureReason = typeof EnterpriseContentAssignment_AssignmentFailureReason[keyof typeof EnterpriseContentAssignment_AssignmentFailureReason];
/** Funnel insights summary for assigned content. */
export type EnterpriseContentAssignment_AssignmentUserFunnelInsights = {
  __typename?: 'EnterpriseContentAssignment_AssignmentUserFunnelInsights';
  /** Number of content assignments to users and emails */
  assignedCount: Scalars['Int'];
  /** Number of users completed */
  completedCount: Scalars['Int'];
  /** Number of users enrolled */
  enrolledCount: Scalars['Int'];
};

/** Content */
export type EnterpriseContentAssignment_Content = Course_Course | EnterpriseBadge_EnterpriseBadge | Specialization_Specialization;

/** Content assignment summary for admins */
export type EnterpriseContentAssignment_ContentAssignment = {
  __typename?: 'EnterpriseContentAssignment_ContentAssignment';
  /** Assigner information, fetched by BE directly as FE lacks auth */
  assignedBy: Array<EnterpriseContentAssignment_AssignerInfo>;
  /** Content */
  content: EnterpriseContentAssignment_Content;
  /** Last assigned time */
  lastAssignedTime: Scalars['DateTime'];
  /** Total number of assignees */
  totalAssigned: Scalars['Int'];
};

/** Assignable content types */
export const EnterpriseContentAssignment_ContentType = {
  /** Course */
  Course: 'COURSE',
  /** Learning Path */
  LearningPath: 'LEARNING_PATH',
  /** Specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseContentAssignment_ContentType = typeof EnterpriseContentAssignment_ContentType[keyof typeof EnterpriseContentAssignment_ContentType];
/** Union input type representing different ways to select users. */
export type EnterpriseContentAssignment_CreateAssignmentUserSelectionInput = {
  /** CSV file location in S3, which contains a column of email addresses. */
  csvFile?: InputMaybe<EnterpriseContentAssignment_S3FileInput>;
  /** Filter ID referencing the saved filter that can be used to retrieve a list of users. */
  savedFilterId?: InputMaybe<Scalars['ID']>;
  /** Selected user IDs. For assigning content to program members. */
  userSelections?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for EnterpriseContentAssignment_CreateAssignmentsForPrograms */
export type EnterpriseContentAssignment_CreateAssignmentsForProgramsInput = {
  /** Display name of the assigner */
  assignedByDisplayName: Scalars['String'];
  /** Content ID for the assignment */
  contentId: Scalars['ID'];
  /** Content type for the assignment */
  contentType: EnterpriseContentAssignment_ContentType;
  /** Email message to be sent to assigned learners */
  emailMessage?: InputMaybe<Scalars['String']>;
  /** Program IDs to assign content across */
  programIds: Array<Scalars['ID']>;
};

/** Aggregated result of creating assignments across multiple programs. */
export type EnterpriseContentAssignment_CreateAssignmentsForProgramsResult = {
  __typename?: 'EnterpriseContentAssignment_CreateAssignmentsForProgramsResult';
  /** Per-program results for each program in the request */
  perProgramResults: Array<EnterpriseContentAssignment_PerProgramResult>;
  /** Total number of successfully assigned users across all programs */
  totalAssigned: Scalars['Int'];
  /** Total number of failed assignments across all programs */
  totalFailed: Scalars['Int'];
  /** Total number of successfully invited users across all programs */
  totalInvited: Scalars['Int'];
};

/** Input for EnterpriseContentAssignment_CreateAssignments */
export type EnterpriseContentAssignment_CreateAssignmentsInput = {
  /** Display name of the assigner */
  assignedByDisplayName: Scalars['String'];
  /** Content ID for the assignment */
  contentId: Scalars['ID'];
  /** Content type for the assignment */
  contentType: EnterpriseContentAssignment_ContentType;
  /** Email message to be sent to assigned learners */
  emailMessage?: InputMaybe<Scalars['String']>;
  /**
   * If true, invite non-members to program and assign content to their email, else throw error
   * EMAIL_DOESNT_HAVE_PROGRAM_INVITATION so can't assign content to non-invited learners.
   */
  inviteNonMembers?: Scalars['Boolean'];
  /** For assigning content to invited and non-invited learners and sending program invitations to non-invited learners. */
  invitees?: InputMaybe<Array<EnterpriseContentAssignment_ProgramInvitee>>;
  /** Boolean indicating whether the assignments will really be created, vs. just running through validations. */
  isPreview?: InputMaybe<Scalars['Boolean']>;
  /** Program ID for the assignment */
  programId: Scalars['ID'];
  /** roster_id to be used when inviting learners to a program with multiple contracts. */
  rosterId?: InputMaybe<Scalars['ID']>;
  /** Union input type representing different ways to select users. */
  userSelectionInput?: InputMaybe<EnterpriseContentAssignment_CreateAssignmentUserSelectionInput>;
  /**
   * Users to be assigned. Deprecated in favor of a new input type representing the different ways to select users.
   * @deprecated Use userSelectionInput instead
   */
  userSelections?: InputMaybe<Array<Scalars['ID']>>;
};

/** Response for EnterpriseContentAssignment_CreateAssignments */
export type EnterpriseContentAssignment_CreateAssignmentsResult = {
  __typename?: 'EnterpriseContentAssignment_CreateAssignmentsResult';
  /** Failed assignments */
  assignmentFailures: Array<EnterpriseContentAssignment_AssignmentFailure>;
  /**
   * If the async path was chosen and the job failed to trigger, this will be populated with the reason.
   * @deprecated Use the preProcessingFailure enum field instead
   */
  asyncFailureReason?: Maybe<Scalars['String']>;
  /** Pre-processing failure error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Emails for which program invitation failed */
  invitationFailures: Array<EnterpriseContentAssignment_ProgramInviteeFailure>;
  /**
   * Flag indicating whether the assignment is undergoing the async path instead of the synchronous path.
   * Note this will always be populated going forward, but nullable for backward-compatibility on the schema.
   * If value is null, that can be interpreted as false.
   */
  isAsync?: Maybe<Scalars['Boolean']>;
  /** When isPreview is true, this will indicate the total number of invitations that would be sent. */
  numberOfInvitationsToBeSent?: Maybe<Scalars['Int']>;
  /** Number of users previewed. */
  numberOfUsersPreviewed?: Maybe<Scalars['Int']>;
  /** Pre-processing failure, for example CSV issue or user selection issue. */
  preProcessingFailure?: Maybe<EnterpriseContentAssignment_PreProcessingFailure>;
  /** Pre-signed URL of the CSV file containing the message when the create assignment is async (i.e. isAsync is true). */
  preSignedUrl?: Maybe<Scalars['URL']>;
  /** Successfully assigned email addresses (for non-members) */
  successfullyAssignedEmails: Array<Scalars['String']>;
  /** Successfully assigned user IDs */
  successfullyAssignedUserIds: Array<Scalars['ID']>;
  /** Count of successfully invited users to the program */
  successfullyInvitedCount: Scalars['Int'];
};

/** Input for EnterpriseContentAssignment_DeleteAssignments */
export type EnterpriseContentAssignment_DeleteAssignmentsInput = {
  /** Content ID for the delete */
  contentId: Scalars['ID'];
  /** Content type for the delete */
  contentType: EnterpriseContentAssignment_ContentType;
  /** If true, delete all assignments for the content in program. This is cross-validated with `userSelections`. */
  deleteAll?: Scalars['Boolean'];
  /** Email-based Assignments to be deleted, */
  nonMemberEmails?: Array<Scalars['String']>;
  /** Program ID */
  programId: Scalars['ID'];
  /** Users to be deleted, empty array means all assigned users. This is cross-validated with `deleteAll`. */
  userSelections?: Array<Scalars['ID']>;
};

/** Response for EnterpriseContentAssignment_DeleteAssignments */
export type EnterpriseContentAssignment_DeleteAssignmentsResult = {
  __typename?: 'EnterpriseContentAssignment_DeleteAssignmentsResult';
  /** Number of deleted email-based assignments */
  numberOfEmailAssignmentsDeleted: Scalars['Int'];
  /** Number of deleted user assignments */
  numberOfUserAssignmentsDeleted: Scalars['Int'];
};

/** Input for EnterpriseContentAssignment_GenerateCsvUploadLocation */
export type EnterpriseContentAssignment_GenerateCsvUploadLocationInput = {
  /** Program ID related to the bulk assignment. */
  programId: Scalars['ID'];
};

/** Response for generate CSV upload location result. Returns S3 bucket and key, and a signed upload URL */
export type EnterpriseContentAssignment_GenerateCsvUploadLocationResult = {
  __typename?: 'EnterpriseContentAssignment_GenerateCsvUploadLocationResult';
  /** S3 bucket and key for the CSV file */
  csvUploadLocation: EnterpriseContentAssignment_S3File;
  /** Signed upload URL for the CSV file */
  signedUploadUrl: Scalars['URL'];
};

/** Content assignment object for a specific learner */
export type EnterpriseContentAssignment_LearnerContentAssignment = {
  __typename?: 'EnterpriseContentAssignment_LearnerContentAssignment';
  /** Assigner information, fetched by BE directly as FE lacks auth. */
  assignedBy: EnterpriseContentAssignment_AssignerInfo;
  /** Assigned time. */
  assignedTime: Scalars['DateTime'];
  /** Content */
  content: EnterpriseContentAssignment_Content;
};

/** Paginated learner content assignments */
export type EnterpriseContentAssignment_LearnerContentAssignmentPaginatedResult = {
  __typename?: 'EnterpriseContentAssignment_LearnerContentAssignmentPaginatedResult';
  /** List of returned content assignments */
  elements: Array<EnterpriseContentAssignment_LearnerContentAssignment>;
  /** Pagination information */
  pagination: Pagination;
};

/** Paginated content assignments */
export type EnterpriseContentAssignment_PaginatedContentAssignments = {
  __typename?: 'EnterpriseContentAssignment_PaginatedContentAssignments';
  /** List of returned content assignments */
  elements: Array<EnterpriseContentAssignment_ContentAssignment>;
  /** Pagination information */
  pagination: Pagination;
};

/** Result of creating assignments for a single program within a multi-program request. */
export type EnterpriseContentAssignment_PerProgramResult = {
  __typename?: 'EnterpriseContentAssignment_PerProgramResult';
  /** Failed assignments */
  assignmentFailures: Array<EnterpriseContentAssignment_AssignmentFailure>;
  /** Error message for this program's assignment attempt */
  errorMessage?: Maybe<Scalars['String']>;
  /** Emails for which program invitation failed */
  invitationFailures: Array<EnterpriseContentAssignment_ProgramInviteeFailure>;
  /** Flag indicating whether the assignment underwent the async path */
  isAsync: Scalars['Boolean'];
  /** Number of users previewed */
  numberOfUsersPreviewed?: Maybe<Scalars['Int']>;
  /** Pre-processing failure, for example CSV issue or user selection issue */
  preProcessingFailure?: Maybe<EnterpriseContentAssignment_PreProcessingFailure>;
  /** Pre-signed URL of the CSV file containing the message when the create assignment is async */
  preSignedUrl?: Maybe<Scalars['URL']>;
  /** Program ID this result corresponds to */
  programId: Scalars['ID'];
  /** Successfully assigned email addresses (for non-members) */
  successfullyAssignedEmails: Array<Scalars['String']>;
  /** Successfully assigned user IDs */
  successfullyAssignedUserIds: Array<Scalars['ID']>;
  /** Count of successfully invited users to the program */
  successfullyInvitedCount: Scalars['Int'];
};

/** Pre-processing failure reasons. */
export const EnterpriseContentAssignment_PreProcessingFailure = {
  /** Content not in program. This is validated before we process the users. */
  ContentNotInProgram: 'CONTENT_NOT_IN_PROGRAM',
  /** Unable to read CSV file (not in appropriate CSV format). */
  CsvIncorrectFormat: 'CSV_INCORRECT_FORMAT'
} as const;

export type EnterpriseContentAssignment_PreProcessingFailure = typeof EnterpriseContentAssignment_PreProcessingFailure[keyof typeof EnterpriseContentAssignment_PreProcessingFailure];
/** Program Invitee model */
export type EnterpriseContentAssignment_ProgramInvitee = {
  /** Invitee Email */
  email: Scalars['String'];
  /** Invitee External ID */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Invitee Name */
  name: Scalars['String'];
};

/** Program Invitation Failure */
export type EnterpriseContentAssignment_ProgramInviteeFailure = {
  __typename?: 'EnterpriseContentAssignment_ProgramInviteeFailure';
  /** Email of the attempted invitee that failed. */
  email: Scalars['String'];
  /** External ID of the attempted invitee that failed. */
  externalId?: Maybe<Scalars['ID']>;
  /** Error message for the invitee failure. */
  message?: Maybe<Scalars['String']>;
  /** Name of the attempted invitee that failed. */
  name: Scalars['String'];
  /** Failure reason for the invitee. */
  reason: EnterpriseContentAssignment_ProgramInviteeFailureReason;
};

/** Program Invitee Failure Reasons */
export const EnterpriseContentAssignment_ProgramInviteeFailureReason = {
  /** Invitation already exists for email */
  ExistingInvitationForEmail: 'EXISTING_INVITATION_FOR_EMAIL',
  /** Invitation already exists for external ID */
  ExistingInvitationForExternalId: 'EXISTING_INVITATION_FOR_EXTERNAL_ID',
  /** Membership already exists for email */
  ExistingMembershipForEmail: 'EXISTING_MEMBERSHIP_FOR_EMAIL',
  /** Membership already exists for external ID */
  ExistingMembershipForExternalId: 'EXISTING_MEMBERSHIP_FOR_EXTERNAL_ID',
  /** Invalid email */
  InvalidEmail: 'INVALID_EMAIL',
  /** Invalid external ID */
  InvalidExternalId: 'INVALID_EXTERNAL_ID',
  /** Invalid full name */
  InvalidFullName: 'INVALID_FULL_NAME',
  /** Roster Without an active Contract */
  RosterWithoutActiveContract: 'ROSTER_WITHOUT_ACTIVE_CONTRACT',
  /** Unhandled error */
  UnhandledError: 'UNHANDLED_ERROR'
} as const;

export type EnterpriseContentAssignment_ProgramInviteeFailureReason = typeof EnterpriseContentAssignment_ProgramInviteeFailureReason[keyof typeof EnterpriseContentAssignment_ProgramInviteeFailureReason];
/** S3 file location */
export type EnterpriseContentAssignment_S3File = {
  __typename?: 'EnterpriseContentAssignment_S3File';
  /** S3 Bucket */
  bucket: Scalars['String'];
  /** S3 Key */
  key: Scalars['String'];
};

/** S3 file location as an input */
export type EnterpriseContentAssignment_S3FileInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
};

/** Input for deleting a scheduled billing. */
export type EnterpriseContractBillingSchedule_DeleteBillingInput = {
  /** Identifier of the scheduled billing to delete. */
  billingId: Scalars['ID'];
};

/** Result of deleting a scheduled billing. */
export type EnterpriseContractBillingSchedule_DeleteBillingResult = {
  __typename?: 'EnterpriseContractBillingSchedule_DeleteBillingResult';
  /** Identifier of the scheduled billing that was requested for deletion. */
  billingId: Scalars['ID'];
  /**
   * Whether a scheduled billing was found and deleted. False when no billing existed for the
   * given identifier.
   */
  deleted: Scalars['Boolean'];
};

/** Input for scheduling a billing run for an enterprise contract installment. */
export type EnterpriseContractBillingSchedule_ScheduleBillingInput = {
  /** The enterprise contract to schedule billing for. */
  enterpriseContractId: Scalars['ID'];
  /** The installment number within the term to schedule billing for. */
  installmentNo: Scalars['Int'];
  /** Timestamp of the previous retry attempt. Null for the initial scheduling attempt. */
  lastRetryAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The retry attempt number of the previous billing schedule. Defaults to 0 for the
   * initial scheduling attempt.
   */
  lastRetryNo?: Scalars['Int'];
  /** The contract term number the installment belongs to. */
  termNo: Scalars['Int'];
};

/** Result of scheduling a billing run for an enterprise contract installment. */
export type EnterpriseContractBillingSchedule_ScheduleBillingResult = {
  __typename?: 'EnterpriseContractBillingSchedule_ScheduleBillingResult';
  /**
   * Identifier of the scheduled billing. Null when scheduling did not produce a billing
   * (for example, when scheduling was skipped or failed).
   */
  billingId?: Maybe<Scalars['ID']>;
  /** Timestamp at which the billing was scheduled. Null when no billing was scheduled. */
  scheduledAt?: Maybe<Scalars['DateTime']>;
  /** Error code describing why scheduling did not succeed, if applicable. */
  schedulingErrorCode?: Maybe<Scalars['String']>;
  /** Human readable error message describing why scheduling did not succeed, if applicable. */
  schedulingErrorMessage?: Maybe<Scalars['String']>;
};

/** Queries and Mutations for Enterprise Contract Deferred License Changes */
export type EnterpriseContractDeferredLicenseChangeQueries = {
  __typename?: 'EnterpriseContractDeferredLicenseChangeQueries';
  /** Creates a new deferred license change for an enterprise contract. */
  create: EnterpriseContractDeferredLicenseChange_CreateResult;
  /** Fetches the effective deferred license change for a given contract ID. */
  getEffectiveDeferredLicenseChange: EnterpriseContractDeferredLicenseChange_GetEffectiveResult;
};


/** Queries and Mutations for Enterprise Contract Deferred License Changes */
export type EnterpriseContractDeferredLicenseChangeQueriesCreateArgs = {
  input: EnterpriseContractDeferredLicenseChange_CreateInput;
};


/** Queries and Mutations for Enterprise Contract Deferred License Changes */
export type EnterpriseContractDeferredLicenseChangeQueriesGetEffectiveDeferredLicenseChangeArgs = {
  input: EnterpriseContractDeferredLicenseChange_GetEffectiveDeferredLicenseInput;
};

/** Input for creating a deferred license change. */
export type EnterpriseContractDeferredLicenseChange_CreateInput = {
  /** Number of licenses to change to. Null when this is a cancellation request. */
  changeNumLicensesTo?: InputMaybe<Scalars['Int']>;
  /** Enterprise Contract ID. */
  enterpriseContractId: Scalars['ID'];
  /** Type of the license change request. */
  requestType: EnterpriseContractDeferredLicenseChange_RequestType;
};

/** Represents the result of create mutation. */
export type EnterpriseContractDeferredLicenseChange_CreateResult = {
  __typename?: 'EnterpriseContractDeferredLicenseChange_CreateResult';
  /** The created deferred license change. */
  deferredLicenseChange: EnterpriseContractDeferredLicenseChange_Details;
};

/** Details of an enterprise contract deferred license change. */
export type EnterpriseContractDeferredLicenseChange_Details = {
  __typename?: 'EnterpriseContractDeferredLicenseChange_Details';
  /** Number of licenses to change to. Null when request type is cancellation. */
  changeNumLicensesTo?: Maybe<Scalars['Int']>;
  /** The contract value increase due to the deferred license change. */
  contractValueIncrease: Scalars['String'];
  /** Enterprise Contract ID associated with the change. */
  enterpriseContractId: EnterpriseContract_EnterpriseContract;
  /** Enterprise Contract Term ID associated with the change. */
  enterpriseContractTermId: Scalars['ID'];
  /** Deferred License Change ID. */
  id: Scalars['ID'];
  /** Type of the license change request. */
  requestType: EnterpriseContractDeferredLicenseChange_RequestType;
  /** Timestamp when the deferred license change was requested. */
  requestedAt: Scalars['DateTime'];
  /** User ID of the requester. */
  requestedByUserId: User_User;
};

/** Input for getEffectiveDeferredLicenseChange query. */
export type EnterpriseContractDeferredLicenseChange_GetEffectiveDeferredLicenseInput = {
  /** Enterprise Contract ID. */
  enterpriseContractId: Scalars['ID'];
};

/** Represents the result of getEffectiveDeferredLicenseChange query. */
export type EnterpriseContractDeferredLicenseChange_GetEffectiveResult = {
  __typename?: 'EnterpriseContractDeferredLicenseChange_GetEffectiveResult';
  /** List of effective deferred license changes. */
  deferredLicenseChanges: Array<EnterpriseContractDeferredLicenseChange_Details>;
};

/** Enumeration of possible license change request types. */
export const EnterpriseContractDeferredLicenseChange_RequestType = {
  /** Request license cancellation. */
  Cancellation: 'CANCELLATION',
  /** Request a new license change. */
  Request: 'REQUEST'
} as const;

export type EnterpriseContractDeferredLicenseChange_RequestType = typeof EnterpriseContractDeferredLicenseChange_RequestType[keyof typeof EnterpriseContractDeferredLicenseChange_RequestType];
/** Invoice creation billing address output */
export type EnterpriseContractInvoice_BillingAddress = {
  __typename?: 'EnterpriseContractInvoice_BillingAddress';
  /** City */
  city: Scalars['String'];
  /** Country */
  country: Scalars['String'];
  /** Address line 1 */
  line1: Scalars['String'];
  /** Address line 2 */
  line2?: Maybe<Scalars['String']>;
  /** Postal code */
  postalCode: Scalars['String'];
  /** State */
  state: Scalars['String'];
};

/** Invoice creation billing address input */
export type EnterpriseContractInvoice_BillingAddressInput = {
  /** City */
  city: Scalars['String'];
  /** Country */
  country: Scalars['String'];
  /** Address line 1 */
  line1: Scalars['String'];
  /** Address line 2 */
  line2?: InputMaybe<Scalars['String']>;
  /** Postal code */
  postalCode: Scalars['String'];
  /** State */
  state: Scalars['String'];
};

/** Billing system type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_BillingSystemType = {
  /** Contract payments handled by the Enterprise Invoicing service */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /** Contract billed by recurring automated transaction payment */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** Contract not integrated with any billing system (usually for test contracts) */
  NonBillable: 'NON_BILLABLE',
  /** Contract payments handled off-platform by internal finance team */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContractInvoice_BillingSystemType = typeof EnterpriseContractInvoice_BillingSystemType[keyof typeof EnterpriseContractInvoice_BillingSystemType];
/** Input for creating an invoice order */
export type EnterpriseContractInvoice_CreateInvoiceOrderInput = {
  /** Admin billing email */
  adminBillingEmail: Scalars['String'];
  /** Admin title */
  adminTitle: Scalars['String'];
  /** Billing country code */
  billingCountryCode: Scalars['String'];
  /** Custom total amount for testing */
  customTotalAmount?: InputMaybe<Scalars['String']>;
  /** Number of licenses */
  numberOfLicenses: Scalars['Int'];
  /** Organization billing address */
  organizationBillingAddress: EnterpriseContractInvoice_BillingAddressInput;
  /** Existing organization ID */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** Organization name */
  organizationName: Scalars['String'];
  /** Organization type */
  organizationType?: InputMaybe<EnterpriseContractInvoice_OrganizationType>;
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Sales owner */
  salesOwner?: InputMaybe<EnterpriseContractInvoice_SalesOwner>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Tax ID data */
  taxIdData?: InputMaybe<EnterpriseContractInvoice_TaxIdDataInput>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag */
  useSandbox: Scalars['Boolean'];
};

/** Result of creating an invoice order */
export type EnterpriseContractInvoice_CreateInvoiceOrderResult = {
  __typename?: 'EnterpriseContractInvoice_CreateInvoiceOrderResult';
  /** The created invoice order */
  invoiceOrder?: Maybe<EnterpriseContractInvoice_InitialOrder>;
  /** The execution ARN key for the invoice order */
  key: Scalars['String'];
};

/** Input for creating an invoice renewal order for an existing enterprise contract. */
export type EnterpriseContractInvoice_CreateInvoiceRenewalOrderInput = {
  /** Existing enterprise contract ID to renew */
  contractId: Scalars['ID'];
  /** Creator user ID. If omitted, it is resolved from the authenticated request context. */
  creatorId?: InputMaybe<Scalars['ID']>;
  /** Optional override for the renewal invoice due date (test/sandbox usage). */
  customDueAt?: InputMaybe<Scalars['DateTime']>;
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag. Defaults to false to match the other invoice order mutations. */
  useSandbox?: Scalars['Boolean'];
};

/** Result of creating an invoice renewal order */
export type EnterpriseContractInvoice_CreateInvoiceRenewalOrderResult = {
  __typename?: 'EnterpriseContractInvoice_CreateInvoiceRenewalOrderResult';
  /** The execution ARN key for the renewal invoice order state machine */
  key: Scalars['String'];
};

/** Input for creating an invoice upgrade (upsell) order */
export type EnterpriseContractInvoice_CreateInvoiceUpgradeOrderInput = {
  /** Existing enterprise contract ID to upgrade */
  contractId: Scalars['ID'];
  /** Admin billing emails to notify for the upsell invoice */
  emails: Array<Scalars['String']>;
  /** Optional enterprise promotion id. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /** Number of additional licenses to add */
  numberOfLicenses: Scalars['Int'];
  /** PO number */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: InputMaybe<Array<EnterpriseContractInvoice_KeyValuePairInput>>;
  /** Test lambda alias */
  testLambdaAlias?: InputMaybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: InputMaybe<Scalars['String']>;
  /** Use sandbox flag. Defaults to false to match the legacy Scala resource behavior. */
  useSandbox?: Scalars['Boolean'];
};

/** Result of creating an invoice upgrade (upsell) order */
export type EnterpriseContractInvoice_CreateInvoiceUpgradeOrderResult = {
  __typename?: 'EnterpriseContractInvoice_CreateInvoiceUpgradeOrderResult';
  /** The execution ARN key for the upsell invoice order state machine */
  key: Scalars['String'];
};

/** Enterprise contract invoice initial order */
export type EnterpriseContractInvoice_InitialOrder = {
  __typename?: 'EnterpriseContractInvoice_InitialOrder';
  /** Admin user ID */
  adminUserId: Scalars['ID'];
  /** Billing address */
  billingAddress: EnterpriseContractInvoice_BillingAddress;
  /** Billing system type */
  billingSystemType: EnterpriseContractInvoice_BillingSystemType;
  /** Country code */
  countryCode: Scalars['String'];
  /** Creator user ID */
  creatorUserId: Scalars['ID'];
  /** Currency code */
  currencyCode: Scalars['String'];
  /** Due date timestamp (in milliseconds since epoch) */
  dueAt?: Maybe<Scalars['DateTime']>;
  /** Invoice type */
  invoiceType: EnterpriseContractInvoice_InvoiceType;
  /** Number of seats */
  numSeats: Scalars['Int'];
  /** PO number */
  poNumber?: Maybe<Scalars['String']>;
  /** Raw total amount (before any adjustments) */
  rawTotalAmount: Scalars['String'];
  /** Sales owner */
  salesOwner?: Maybe<EnterpriseContractInvoice_SalesOwner>;
  /** Sandbox flag */
  sandbox: Scalars['Boolean'];
  /** Service forced clusters as key-value pairs */
  serviceForcedClusters?: Maybe<Array<EnterpriseContractInvoice_KeyValuePair>>;
  /** Tax ID data */
  taxIdData?: Maybe<EnterpriseContractInvoice_TaxIdData>;
  /** Test lambda alias */
  testLambdaAlias?: Maybe<Scalars['String']>;
  /** Test step function suffix */
  testStepFunctionSuffix?: Maybe<Scalars['String']>;
  /** Third party organization */
  thirdPartyOrganization: InvoiceOrder_ThirdPartyOrganization;
  /** Total amount */
  totalAmount: Scalars['String'];
  /** Unit price */
  unitPrice: Scalars['String'];
};

/** Invoice type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_InvoiceType = {
  /** Initial invoice for a new contract */
  Initial: 'INITIAL',
  /** Renewal invoice for extending an existing contract */
  Renewal: 'RENEWAL',
  /** Upgrade invoice for adding licenses to an existing contract */
  Upgrade: 'UPGRADE'
} as const;

export type EnterpriseContractInvoice_InvoiceType = typeof EnterpriseContractInvoice_InvoiceType[keyof typeof EnterpriseContractInvoice_InvoiceType];
/** Key-value pair output for representing map entries */
export type EnterpriseContractInvoice_KeyValuePair = {
  __typename?: 'EnterpriseContractInvoice_KeyValuePair';
  /** Key */
  key: Scalars['String'];
  /** Value */
  value: Scalars['String'];
};

/** Key-value pair input for representing map entries */
export type EnterpriseContractInvoice_KeyValuePairInput = {
  /** Key */
  key: Scalars['String'];
  /** Value */
  value: Scalars['String'];
};

/** Organization type enum for enterprise contract invoices */
export const EnterpriseContractInvoice_OrganizationType = {
  /** Business organization type */
  Business: 'BUSINESS',
  /** Campus organization type */
  Campus: 'CAMPUS',
  /** Government organization type */
  Government: 'GOVERNMENT'
} as const;

export type EnterpriseContractInvoice_OrganizationType = typeof EnterpriseContractInvoice_OrganizationType[keyof typeof EnterpriseContractInvoice_OrganizationType];
/** Enterprise sales owner enum */
export const EnterpriseContractInvoice_SalesOwner = {
  /** Coursera sales team */
  CourseraSales: 'COURSERA_SALES',
  /** Marketstar sales team */
  Marketstar: 'MARKETSTAR',
  /** Scaled success team */
  Scaledsuccess: 'SCALEDSUCCESS'
} as const;

export type EnterpriseContractInvoice_SalesOwner = typeof EnterpriseContractInvoice_SalesOwner[keyof typeof EnterpriseContractInvoice_SalesOwner];
/** Invoice creation tax ID data output */
export type EnterpriseContractInvoice_TaxIdData = {
  __typename?: 'EnterpriseContractInvoice_TaxIdData';
  /** Tax ID type */
  taxIdType: Scalars['String'];
  /** Tax ID value */
  taxIdValue: Scalars['String'];
};

/** Invoice creation tax ID data input */
export type EnterpriseContractInvoice_TaxIdDataInput = {
  /** Tax ID type */
  taxIdType: Scalars['String'];
  /** Tax ID value */
  taxIdValue: Scalars['String'];
};

export type EnterpriseContractPoliciesV1 = {
  __typename?: 'EnterpriseContractPoliciesV1';
  contractId: Scalars['String'];
  id: Scalars['String'];
  metadata: EnterpriseContractPoliciesV1_Metadata;
  policyType: EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType;
  updatedAt: Scalars['Float'];
  /** id for a Coursera user */
  updatedBy: Scalars['Int'];
};

export type EnterpriseContractPoliciesV1ByActivationDateRange = {
  __typename?: 'EnterpriseContractPoliciesV1ByActivationDateRange';
  connection?: Maybe<EnterpriseContractPoliciesV1Connection>;
  from: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};

/**
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/enterpriseContractPolicies.v1.graphql
 * Finder for Enterprise Contract Policies
 */
export type EnterpriseContractPoliciesV1ByContract = {
  __typename?: 'EnterpriseContractPoliciesV1ByContract';
  connection?: Maybe<EnterpriseContractPoliciesV1Connection>;
  enterpriseContractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractPoliciesV1ByContractPolicyId = {
  __typename?: 'EnterpriseContractPoliciesV1ByContractPolicyId';
  connection?: Maybe<EnterpriseContractPoliciesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

/**
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/enterpriseContractPolicies.v1.graphql
 * Finder for Enterprise Contract Policies by Fallback Contract
 */
export type EnterpriseContractPoliciesV1ByFallbackContract = {
  __typename?: 'EnterpriseContractPoliciesV1ByFallbackContract';
  connection?: Maybe<EnterpriseContractPoliciesV1Connection>;
  fallbackContractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

/**
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/enterpriseContractPolicies.v1.graphql
 * Finder for Enterprise Contract Policies by Renewal Contract
 */
export type EnterpriseContractPoliciesV1ByRenewalContract = {
  __typename?: 'EnterpriseContractPoliciesV1ByRenewalContract';
  connection?: Maybe<EnterpriseContractPoliciesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  renewalContractId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractPoliciesV1Connection = {
  __typename?: 'EnterpriseContractPoliciesV1Connection';
  elements: Array<Maybe<EnterpriseContractPoliciesV1>>;
  paging: ResponsePagination;
};

export type EnterpriseContractPoliciesV1Resource = {
  __typename?: 'EnterpriseContractPoliciesV1Resource';
  byActivationDateRange?: Maybe<EnterpriseContractPoliciesV1Connection>;
  byContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  byContractPolicyId?: Maybe<EnterpriseContractPoliciesV1Connection>;
  byFallbackContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  byRenewalContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  get?: Maybe<EnterpriseContractPoliciesV1>;
};


export type EnterpriseContractPoliciesV1ResourceByActivationDateRangeArgs = {
  from: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};


export type EnterpriseContractPoliciesV1ResourceByContractArgs = {
  enterpriseContractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractPoliciesV1ResourceByContractPolicyIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractPoliciesV1ResourceByFallbackContractArgs = {
  fallbackContractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractPoliciesV1ResourceByRenewalContractArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  renewalContractId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractPoliciesV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type EnterpriseContractPoliciesV1ResourceMutations = {
  __typename?: 'EnterpriseContractPoliciesV1ResourceMutations';
  create?: Maybe<EnterpriseContractPoliciesV1Connection>;
  delete?: Maybe<EnterpriseContractPoliciesV1Connection>;
  getAllActiveFallbackContractIds?: Maybe<Scalars['JSON']>;
  getFallbackActiveContractIds?: Maybe<Scalars['JSON']>;
};


export type EnterpriseContractPoliciesV1ResourceMutationsCreateArgs = {
  requestingUserId?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractPoliciesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractPoliciesV1ResourceMutationsGetAllActiveFallbackContractIdsArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractPoliciesV1ResourceMutationsGetFallbackActiveContractIdsArgs = {
  contractId: Scalars['String'];
};

export type EnterpriseContractPoliciesV1_ContractEndedPolicyMetadataMember = {
  __typename?: 'EnterpriseContractPoliciesV1_ContractEndedPolicyMetadataMember';
  ContractEndedPolicyMetadata: EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_ContractEndedPolicyMetadata;
};

export type EnterpriseContractPoliciesV1_ContractFullyUtilizedPolicyMetadataMember = {
  __typename?: 'EnterpriseContractPoliciesV1_ContractFullyUtilizedPolicyMetadataMember';
  ContractFullyUtilizedPolicyMetadata: EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_ContractFullyUtilizedPolicyMetadata;
};

export type EnterpriseContractPoliciesV1_Metadata = EnterpriseContractPoliciesV1_ContractEndedPolicyMetadataMember | EnterpriseContractPoliciesV1_ContractFullyUtilizedPolicyMetadataMember;

export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Migration_StoredContractMigrationId = {
  __typename?: 'EnterpriseContractPoliciesV1_org_coursera_enterprise_contract_migration_StoredContractMigrationId';
  id: Scalars['String'];
};

/** Policy metadata to handle when a contract ends */
export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_ContractEndedPolicyMetadata = {
  __typename?: 'EnterpriseContractPoliciesV1_org_coursera_enterprise_contract_policy_ContractEndedPolicyMetadata';
  downgradeContractConfiguration: EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Jobconfig_DowngradeEnterpriseContractJobConfig;
  renewalContractConfiguration?: Maybe<EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractRenewalContractConfig>;
};

/** Policy metadata to handle consumption situations when the contract is fully utilized or paused. */
export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_ContractFullyUtilizedPolicyMetadata = {
  __typename?: 'EnterpriseContractPoliciesV1_org_coursera_enterprise_contract_policy_ContractFullyUtilizedPolicyMetadata';
  fallbackContractId: Scalars['String'];
};

/** Specifies all the different types of policies that can be associated with an enterprise contract. Intended to be used in tandem with one of the EnterpriseContractPolicyMetadata types, where the policy metadata specifies auxiliary values used to enforce the policy */
export const EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType = {
  ContractEnded: 'CONTRACT_ENDED',
  ContractFullyUtilized: 'CONTRACT_FULLY_UTILIZED'
} as const;

export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType = typeof EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType[keyof typeof EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractPolicyType];
export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Policy_EnterpriseContractRenewalContractConfig = {
  __typename?: 'EnterpriseContractPoliciesV1_org_coursera_enterprise_contract_policy_EnterpriseContractRenewalContractConfig';
  activationDate?: Maybe<Scalars['Float']>;
  contractMigrationId?: Maybe<EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Contract_Migration_StoredContractMigrationId>;
  renewalContractId: Scalars['String'];
};

export type EnterpriseContractPoliciesV1_Org_Coursera_Enterprise_Jobconfig_DowngradeEnterpriseContractJobConfig = {
  __typename?: 'EnterpriseContractPoliciesV1_org_coursera_enterprise_jobconfig_DowngradeEnterpriseContractJobConfig';
  archiveProgramData: Scalars['Boolean'];
  dryRun: Scalars['Boolean'];
  enterpriseContractId: Scalars['String'];
  enterpriseContractIds: Array<Maybe<Scalars['String']>>;
  isHardPause: Scalars['Boolean'];
  sendMembershipDeletionNotification: Scalars['Boolean'];
};

/** Query definitions for Enterprise Contract Policy operations. */
export type EnterpriseContractPolicyQueries = {
  __typename?: 'EnterpriseContractPolicyQueries';
  /** Retrieves a contract policy by contract ID. */
  queryByContract: Array<EnterpriseContractPolicy_ContractPolicy>;
  /** Retrieves all contract policies associated with a fallback contract ID. */
  queryByFallbackContract: Array<EnterpriseContractPolicy_ContractPolicy>;
  /** Retrieves all contract policies associated with a renewal contract ID. */
  queryByRenewalContract: Array<EnterpriseContractPolicy_ContractPolicy>;
};


/** Query definitions for Enterprise Contract Policy operations. */
export type EnterpriseContractPolicyQueriesQueryByContractArgs = {
  contractId: Scalars['ID'];
};


/** Query definitions for Enterprise Contract Policy operations. */
export type EnterpriseContractPolicyQueriesQueryByFallbackContractArgs = {
  fallbackContractId: Scalars['ID'];
};


/** Query definitions for Enterprise Contract Policy operations. */
export type EnterpriseContractPolicyQueriesQueryByRenewalContractArgs = {
  renewalContractId: Scalars['ID'];
};

/** Metadata for a contract that has ended. */
export type EnterpriseContractPolicy_ContractEndedPolicyMetadata = {
  __typename?: 'EnterpriseContractPolicy_ContractEndedPolicyMetadata';
  /** The date when the contract becomes active, if applicable. */
  activationDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the contract migration, if applicable. */
  contractMigrationId?: Maybe<Scalars['ID']>;
  /** The ID of the renewal contract. */
  renewalContractId: Scalars['ID'];
};

/** Metadata for a contract that has been fully utilized. */
export type EnterpriseContractPolicy_ContractFullyUtilizedPolicyMetadata = {
  __typename?: 'EnterpriseContractPolicy_ContractFullyUtilizedPolicyMetadata';
  /** The ID of the fallback contract to use when the current contract is fully utilized. */
  fallbackContractId: Scalars['ID'];
};

/** Represents a contract policy for an enterprise contract. */
export type EnterpriseContractPolicy_ContractPolicy = {
  __typename?: 'EnterpriseContractPolicy_ContractPolicy';
  /** The ID of the contract this policy applies to. */
  contractId: Scalars['ID'];
  /** Additional metadata specific to the policy type. */
  metadata: EnterpriseContractPolicy_ContractPolicyMetadata;
  /** The type of contract policy. */
  policyType: EnterpriseContractPolicy_ContractPolicyType;
  /** Timestamp when the policy was last updated. */
  updatedAt: Scalars['DateTime'];
  /** ID of the user who last updated the policy. */
  updatedBy: Scalars['ID'];
};

/** Union type for contract policy metadata based on the policy type. */
export type EnterpriseContractPolicy_ContractPolicyMetadata = EnterpriseContractPolicy_ContractEndedPolicyMetadata | EnterpriseContractPolicy_ContractFullyUtilizedPolicyMetadata;

/** Represents the type of contract policy. */
export const EnterpriseContractPolicy_ContractPolicyType = {
  /** Policy for when a contract has ended. */
  ContractEnded: 'CONTRACT_ENDED',
  /** Policy for when a contract has been fully utilized. */
  ContractFullyUtilized: 'CONTRACT_FULLY_UTILIZED'
} as const;

export type EnterpriseContractPolicy_ContractPolicyType = typeof EnterpriseContractPolicy_ContractPolicyType[keyof typeof EnterpriseContractPolicy_ContractPolicyType];
/** Failure result for creating a contract ended policy. */
export type EnterpriseContractPolicy_CreateContractEndedPolicyFailure = {
  __typename?: 'EnterpriseContractPolicy_CreateContractEndedPolicyFailure';
  /** The error that occurred during policy creation. */
  error: EnterpriseContractPolicy_CreateContractPolicyError;
};

/** Input for creating a contract ended policy. */
export type EnterpriseContractPolicy_CreateContractEndedPolicyInput = {
  /** The date when the contract becomes active, if applicable. */
  activationDate?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the contract to create the policy for. */
  contractId: Scalars['ID'];
  /** The ID of the contract migration, if applicable. */
  contractMigrationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the renewal contract. */
  renewalContractId: Scalars['ID'];
};

/** Result of creating a contract ended policy. */
export type EnterpriseContractPolicy_CreateContractEndedPolicyResult = EnterpriseContractPolicy_CreateContractEndedPolicyFailure | EnterpriseContractPolicy_CreateContractEndedPolicySuccess;

/** Success result for creating a contract ended policy. */
export type EnterpriseContractPolicy_CreateContractEndedPolicySuccess = {
  __typename?: 'EnterpriseContractPolicy_CreateContractEndedPolicySuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Failure result for creating a contract fully utilized policy. */
export type EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyFailure = {
  __typename?: 'EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyFailure';
  /** The error that occurred during policy creation. */
  error: EnterpriseContractPolicy_CreateContractPolicyError;
};

/** Input for creating a contract fully utilized policy. */
export type EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyInput = {
  /** The ID of the contract to create the policy for. */
  contractId: Scalars['ID'];
  /** The ID of the fallback contract to use when the current contract is fully utilized. */
  fallbackContractId: Scalars['ID'];
};

/** Result of creating a contract fully utilized policy. */
export type EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyResult = EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyFailure | EnterpriseContractPolicy_CreateContractFullyUtilizedPolicySuccess;

/** Success result for creating a contract fully utilized policy. */
export type EnterpriseContractPolicy_CreateContractFullyUtilizedPolicySuccess = {
  __typename?: 'EnterpriseContractPolicy_CreateContractFullyUtilizedPolicySuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Error that occurred during contract policy creation. */
export type EnterpriseContractPolicy_CreateContractPolicyError = Error & {
  __typename?: 'EnterpriseContractPolicy_CreateContractPolicyError';
  /** The error message describing what went wrong. */
  message: Scalars['String'];
};

/** Input for deleting a contract policy. */
export type EnterpriseContractPolicy_DeleteContractPolicyInput = {
  /** The ID of the contract to delete the policy for. */
  contractId: Scalars['ID'];
  /** The type of contract policy to delete. */
  policyType: EnterpriseContractPolicy_ContractPolicyType;
};

/** Result of deleting a contract policy. */
export type EnterpriseContractPolicy_DeleteContractPolicyResult = {
  __typename?: 'EnterpriseContractPolicy_DeleteContractPolicyResult';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueries = {
  __typename?: 'EnterpriseContractPriceQueries';
  /**
   * Computes the invoice billed contract price based on provided parameters.
   * Returns a list of contract product prices for invoicing.
   * This is an internal-access API where client can provide countryIsoCode, instead of inferring it from IP address.
   * This is useful for cases where we do not know the original source country code. | Maximum page size: 100
   */
  computeInvoiceBilledContractPrice: EnterpriseContractPrice_PaginatedResult;
  /**
   * Determines the cost to update contract limits before actual update.
   * Calculates pricing for upgrading user limits, courses per user, or total courses.
   * Used to provide cost estimates for contract modifications.
   */
  determineUpdateCosts: EnterpriseContractPrice_DetermineUpdateCostsResult;
  /**
   * Fetches the enterprise self-serve contract product price based on provided parameters.
   * Returns pricing information for a contract based on the number of licenses, billing type, and other factors. | Maximum page size: 100
   */
  getEnterpriseSelfServeContractProductPrice: EnterpriseContractPrice_PaginatedResult;
  /**
   * Fetches the enterprise self-serve contract product price for a specific contract.
   * Returns contract product pricing information for a given contract ID. | Maximum page size: 100
   */
  getEnterpriseSelfServeContractProductPriceForContract: EnterpriseContractPrice_PaginatedResult;
  /**
   * Fetches the price by contract product price ID.
   * Returns the contract product price for the given product price ID.
   */
  getPrice: EnterpriseContractPrice_ProductPriceResult;
};


/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueriesComputeInvoiceBilledContractPriceArgs = {
  billingType: EnterpriseContractPrice_BillingType;
  countryIsoCode: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
  userLimit: Scalars['Int'];
};


/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueriesDetermineUpdateCostsArgs = {
  enterpriseContractId: Scalars['ID'];
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  limitValuesUpdate: EnterpriseContractPrice_LimitValuesUpdateInput;
};


/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueriesGetEnterpriseSelfServeContractProductPriceArgs = {
  countryIsoCode?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  fxRateId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  pricingModel?: InputMaybe<EnterpriseContractPrice_PricingModel>;
  stage?: InputMaybe<EnterprisePromotion_PromotionStage>;
  termInstallmentsTotal: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
  userLimit: Scalars['Int'];
};


/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueriesGetEnterpriseSelfServeContractProductPriceForContractArgs = {
  contractId: Scalars['ID'];
  countryIsoCode?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  fxRateId?: InputMaybe<Scalars['ID']>;
  limit?: Scalars['Int'];
  termInstallmentsTotal: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
  userLimit: Scalars['Int'];
};


/** Queries for Enterprise Contract Pricing */
export type EnterpriseContractPriceQueriesGetPriceArgs = {
  id: EnterpriseContractPrice_ProductPriceIdInput;
};

/**
 * Applied or rejected discount entry.
 * Used in both appliedDiscounts and rejectedDiscounts within discount info.
 */
export type EnterpriseContractPrice_AppliedOrRejectedDiscount = {
  __typename?: 'EnterpriseContractPrice_AppliedOrRejectedDiscount';
  /** Actual local discounted amount (negative value) for this discount. */
  actualLocalDiscountedAmountTotal: Scalars['Float'];
  /** Whether this discount is applied on the unit price. */
  discountOnUnitPrice: Scalars['Boolean'];
  /** Discount percentage for this discount. */
  discountPercentage: Scalars['Float'];
  /** Enterprise promotion ID when type is PROMOTION. */
  enterprisePromotionId?: Maybe<Scalars['ID']>;
  /** Enterprise promotion name when type is PROMOTION. */
  enterprisePromotionName?: Maybe<Scalars['String']>;
  /** Pricing rule ID when type is VOLUME_DISCOUNT. */
  pricingRuleId?: Maybe<Scalars['ID']>;
  /** Type of discount (e.g. PROMOTION, VOLUME_DISCOUNT). */
  type: EnterpriseContractPrice_DiscountType;
};

/** Base Price Info. No discounts on unit price & seasonal discounts applied. */
export type EnterpriseContractPrice_BasePriceInfo = {
  __typename?: 'EnterpriseContractPrice_BasePriceInfo';
  /** Total amount due today in local currency without any seasonal & unit price discount. */
  basePriceDueTodayInLocal: Scalars['Float'];
  /** Total amount in local currency without any seasonal & unit price discount. */
  basePriceTotalInLocal: Scalars['Float'];
  /** Base reference unit price in local currency without any seasonal & unit price discount. */
  baseReferenceUnitPriceInLocal: Scalars['Float'];
  /** Base unit price in local currency  without any seasonal & unit price discount. */
  baseUnitPriceInLocal: Scalars['Float'];
};

/**
 * Contract billing type enumeration.
 * Corresponds to EnterpriseContractBillingType in Scala.
 */
export const EnterpriseContractPrice_BillingType = {
  /** Invoice billing type. */
  Invoice: 'INVOICE',
  /** No billing type specified. */
  None: 'NONE',
  /** One-time billing type. */
  OneTime: 'ONE_TIME',
  /** Quarterly billing type. */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContractPrice_BillingType = typeof EnterpriseContractPrice_BillingType[keyof typeof EnterpriseContractPrice_BillingType];
/**
 * Enterprise contract limits update cost information.
 * Based on EnterpriseContractLimitsUpdateCost class in Scala.
 */
export type EnterpriseContractPrice_ContractLimitsUpdateCost = {
  __typename?: 'EnterpriseContractPrice_ContractLimitsUpdateCost';
  /** The amount due over installments for the contract update in local currency. */
  amountDueOverInstallments: Scalars['Float'];
  /** The amount due today for the contract update in local currency. */
  amountDueToday: Scalars['Float'];
  /** Undiscounted base price amounts (before volume/promo discounts). */
  basePriceInfo?: Maybe<EnterpriseContractPrice_UpdateCostBasePriceInfo>;
  /** The currency code for the pricing amounts. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Discount breakdown: effective percentage, applied/rejected discounts with amounts. */
  discountInfo?: Maybe<EnterpriseContractPrice_DiscountInfo>;
  /** The raw (before promotional discounts) amount due over installments in usd. */
  rawAmountDueOverInstallments?: Maybe<Scalars['Float']>;
  /** The raw (before promotional discounts) amount due today in usd. */
  rawAmountDueToday?: Maybe<Scalars['Float']>;
  /** Unit price (after tiered pricing discounts  applied). */
  unitPrice?: Maybe<Scalars['Float']>;
  /** Volume tier information: tiers and proximity to next tier. */
  volumeTierInfo?: Maybe<EnterpriseContractPrice_VolumeTierInfo>;
};

/** Input for creating a new pricing rule. */
export type EnterpriseContractPrice_CreatePricingDiscountRuleInput = {
  /** The discount percentage to apply (e.g. "5.00" for 5%). */
  discountPercentage: Scalars['String'];
  /** What the lower/upper limits refer to. */
  limitType: EnterpriseContractPrice_PricingRuleLimitType;
  /** Minimum seat count for this tier (inclusive). */
  lowerLimit: Scalars['Int'];
  /** The type of discount. */
  type: EnterpriseContractPrice_PricingDiscountType;
  /** Maximum seat count for this tier (inclusive). */
  upperLimit: Scalars['Int'];
};

/** Result of creating a pricing discount rule. */
export type EnterpriseContractPrice_CreatePricingDiscountRuleResult = {
  __typename?: 'EnterpriseContractPrice_CreatePricingDiscountRuleResult';
  /** The created pricing rule. */
  pricingRule: EnterpriseContractPrice_PricingDiscountRule;
};

/**
 * Result of determining contract update costs.
 * Based on EnterpriseContractLimitsUpdateCost class in Scala.
 */
export type EnterpriseContractPrice_DetermineUpdateCostsResult = {
  __typename?: 'EnterpriseContractPrice_DetermineUpdateCostsResult';
  /** The contract limits update cost information. */
  updateCost: EnterpriseContractPrice_ContractLimitsUpdateCost;
};

/**
 * Discount information for enterprise contract product price.
 * Includes unit price discount details, effective discount, and applied/rejected discounts.
 */
export type EnterpriseContractPrice_DiscountInfo = {
  __typename?: 'EnterpriseContractPrice_DiscountInfo';
  /** Discounts that were applied to the price. */
  appliedDiscounts: Array<EnterpriseContractPrice_AppliedOrRejectedDiscount>;
  /** Effective discount percentage applied overall. */
  effectiveDiscountPercentage: Scalars['Float'];
  /** Effective discount amount in local currency (negative value; the total discount applied). */
  effectiveLocalDiscountAmountDue: Scalars['Float'];
  /** Discounts that were not applied (e.g. did not qualify or were superseded). */
  rejectedDiscounts: Array<EnterpriseContractPrice_AppliedOrRejectedDiscount>;
};

/** Discount type enumeration for applied or rejected discounts. */
export const EnterpriseContractPrice_DiscountType = {
  /** Promotion-based discount (e.g. enterprise promotion). */
  Promotion: 'PROMOTION',
  /** Volume-based discount from pricing rules. */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EnterpriseContractPrice_DiscountType = typeof EnterpriseContractPrice_DiscountType[keyof typeof EnterpriseContractPrice_DiscountType];
/**
 * Input for updating enterprise contract limit values.
 * Based on EnterpriseContractLimitValuesUpdate class in Scala.
 */
export type EnterpriseContractPrice_LimitValuesUpdateInput = {
  /** Number of courses per user to add. */
  coursesPerUsersAdded?: Scalars['Int'];
  /** Total number of courses to add to the contract. */
  coursesTotalAdded?: Scalars['Int'];
  /** Number of users to add to the contract. */
  usersAdded: Scalars['Int'];
};

/** Paginated result for enterprise contract product prices. */
export type EnterpriseContractPrice_PaginatedResult = {
  __typename?: 'EnterpriseContractPrice_PaginatedResult';
  /** List of product price results. */
  elements: Array<EnterpriseContractPrice_ProductPriceResult>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Enterprise pricing discount rule. */
export type EnterpriseContractPrice_PricingDiscountRule = {
  __typename?: 'EnterpriseContractPrice_PricingDiscountRule';
  /** Whether this rule is currently active. */
  active: Scalars['Boolean'];
  /** Creation timestamp in epoch milliseconds. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The discount percentage applied. */
  discountPercentage: Scalars['String'];
  /** The unique ID of the pricing rule. */
  id: Scalars['ID'];
  /** What the lower/upper limits refer to. */
  limitType: EnterpriseContractPrice_PricingRuleLimitType;
  /** Minimum seat count for this tier (inclusive). */
  lowerLimit: Scalars['Int'];
  /** The discount type. */
  type: EnterpriseContractPrice_PricingDiscountType;
  /** Last update timestamp in epoch milliseconds. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Maximum seat count for this tier (inclusive). */
  upperLimit: Scalars['Int'];
};

/** Discount type for a pricing rule. */
export const EnterpriseContractPrice_PricingDiscountType = {
  /** Volume-based discount applied by seat count. */
  VolumeDiscount: 'VOLUME_DISCOUNT'
} as const;

export type EnterpriseContractPrice_PricingDiscountType = typeof EnterpriseContractPrice_PricingDiscountType[keyof typeof EnterpriseContractPrice_PricingDiscountType];
/**
 * Pricing model enumeration for enterprise contracts.
 * Determines whether differential pricing is applied based on billing frequency.
 */
export const EnterpriseContractPrice_PricingModel = {
  /** Differential pricing model with quarterly premium where quarterly billing has a 10% premium over annual billing. */
  DifferentialQuarterlyPremium: 'DIFFERENTIAL_QUARTERLY_PREMIUM',
  /** Standard pricing model where annual and quarterly billing have the same effective annual rate. */
  Standard: 'STANDARD'
} as const;

export type EnterpriseContractPrice_PricingModel = typeof EnterpriseContractPrice_PricingModel[keyof typeof EnterpriseContractPrice_PricingModel];
/** What the lower/upper limits of a pricing discount rule refer to. */
export const EnterpriseContractPrice_PricingRuleLimitType = {
  /** Limits are based on seat count. */
  Seats: 'SEATS'
} as const;

export type EnterpriseContractPrice_PricingRuleLimitType = typeof EnterpriseContractPrice_PricingRuleLimitType[keyof typeof EnterpriseContractPrice_PricingRuleLimitType];
/**
 * Enterprise self-serve contract product price information.
 * Based on EnterpriseSelfServeContractProductPrice class.
 */
export type EnterpriseContractPrice_ProductPrice = {
  __typename?: 'EnterpriseContractPrice_ProductPrice';
  /** Amount due today in local currency with discount on unit price and any seasonal discount applied (e.g. due today for quarterly). */
  actualLocalAmountDueToday: Scalars['Float'];
  /** Total amount in local currency with tiered pricing discount on unit price and  seasonal discount applied. */
  actualLocalAmountTotal: Scalars['Float'];
  /**
   * The total amount in the local currency that was discounted. This field is deprecated, use EnterpriseContractPrice_DiscountInfo instead.
   * @deprecated Prefer discountInfo.effectiveLocalDiscountAmountDue instead
   */
  actualLocalDiscountedAmount: Scalars['Float'];
  /**
   * Legacy amount due today field - will be removed in future. Use actualLocalAmountDueToday  instead.
   * @deprecated Use actualLocalAmountDueToday  instead
   */
  amountDueToday: Scalars['Float'];
  /**
   * Legacy total amount field - will be removed in future. Use actualLocalAmountTotal  instead.
   * @deprecated Use actualLocalAmountTotal instead
   */
  amountTotal: Scalars['Float'];
  /** Base price details. */
  baseUnitPriceInfo?: Maybe<EnterpriseContractPrice_BasePriceInfo>;
  /** The country in which the contract is to be purchased. */
  countryIsoCode: Scalars['String'];
  /** The local currency in which the prices are computed. */
  currencyCode: Scalars['String'];
  /** Discount breakdown including unit price discount, applied and rejected discounts. */
  discountInfo?: Maybe<EnterpriseContractPrice_DiscountInfo>;
  /**
   * The discount percentage applied. This field is deprecated, use EnterpriseContractPrice_DiscountInfo instead.
   * @deprecated Prefer discountInfo.effectiveDiscountPercentage instead
   */
  discountPercent: Scalars['Int'];
  /**
   * Defines the enterprise promotion being applied.
   * Optional field. When null, no promotion is applied to the price.
   */
  enterprisePromotionId?: Maybe<Scalars['ID']>;
  /**
   * Defines the exchange rate between USD and the local currency.
   * Optional field. When null, the default exchange rate will be used.
   */
  fxRateId?: Maybe<Scalars['ID']>;
  /**
   * Raw amount due today in USD
   * This amount can have tiered pricing discount applied but with no seasonal promotion discount applied.
   */
  rawAmountDueToday: Scalars['Float'];
  /**
   * Total amount in USD
   * This amount can have tiered pricing discount applied but with no seasonal promotion discount applied.
   */
  rawAmountTotal: Scalars['Float'];
  /**
   * Raw amount due today in local currency (e.g. due today for quarterly)
   * This amount can have tiered pricing discount applied but with no seasonal promotion discount applied.
   */
  rawLocalAmountDueToday: Scalars['Float'];
  /**
   * Total amount in local currency
   * This amount can have tiered pricing discount applied but with no seasonal promotion discount applied.
   */
  rawLocalAmountTotal: Scalars['Float'];
  /**
   * Reference unit price for comparison  (in local currency)(e.g.  quarterly unit price when viewing annual).
   * Can have discounts on unit price applied if eligible for tiered pricing based on number of licenses,
   * For quarterly billing with differential pricing, this shows the annual price. For annual billing with differential pricing, this shows the quarterly price. Null for standard pricing model.
   */
  referenceUnitPrice?: Maybe<Scalars['Float']>;
  /**
   * Unit price per license (In local currency).
   * Can have discounts on unit price applied if eligible for tiered pricing based on number of licenses,
   * Refer EnterpriseContractPrice_BasePriceInfo
   */
  unitPrice: Scalars['Float'];
  /** Volume tier information including tier proximity and tier definitions. */
  volumeTierInfo?: Maybe<EnterpriseContractPrice_VolumeTierInfo>;
};

/**
 * Enterprise self-serve contract product price ID.
 * Based on EnterpriseSelfServeContractProductPriceId class.
 */
export type EnterpriseContractPrice_ProductPriceId = {
  __typename?: 'EnterpriseContractPrice_ProductPriceId';
  /** Billing type for the contract. */
  billingType: EnterpriseContractPrice_BillingType;
  /** Number of user licenses for the contract. */
  userLimit: Scalars['Int'];
};

/**
 * Input for enterprise self-serve contract product price ID.
 * Based on EnterpriseSelfServeContractProductPriceId class.
 */
export type EnterpriseContractPrice_ProductPriceIdInput = {
  /** Billing type for the contract. */
  billingType: EnterpriseContractPrice_BillingType;
  /** Number of user licenses for the contract. */
  userLimit: Scalars['Int'];
};

/** Represents the result of getEnterpriseSelfServeContractProductPrice query and other price-related queries. */
export type EnterpriseContractPrice_ProductPriceResult = {
  __typename?: 'EnterpriseContractPrice_ProductPriceResult';
  /** The product price ID. */
  id: EnterpriseContractPrice_ProductPriceId;
  /** The product price details. */
  price: EnterpriseContractPrice_ProductPrice;
};

/** Why an estimate email was not sent. Only meaningful when `emailSent` is false. */
export const EnterpriseContractPrice_SendEstimateEmailErrorReason = {
  /** The downstream email service failed after validation and pricing succeeded. */
  EmailSendFailed: 'EMAIL_SEND_FAILED',
  /** The recipient address did not pass business email validation. */
  InvalidBusinessEmail: 'INVALID_BUSINESS_EMAIL',
  /** Validation requires the recipient to complete OTP before an estimate can be emailed. */
  OtpRequired: 'OTP_REQUIRED',
  /** The recipient reached the maximum number of estimate emails allowed in the configured time window. */
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type EnterpriseContractPrice_SendEstimateEmailErrorReason = typeof EnterpriseContractPrice_SendEstimateEmailErrorReason[keyof typeof EnterpriseContractPrice_SendEstimateEmailErrorReason];
/**
 * Input for sending a self-serve contract product price estimate via email.
 * Mirrors the parameters of `getEnterpriseSelfServeContractProductPrice` plus an
 * additional `email` field (and optional recipient personalization).
 */
export type EnterpriseContractPrice_SendEstimateEmailInput = {
  /**
   * Optional country ISO code for localized pricing. Falls back to the request's IP-derived
   * country when absent.
   */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Optional currency code for price conversion. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Recipient business email address. */
  email: Scalars['String'];
  /** Optional enterprise promotion ID to apply to the price. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /** Optional FX rate ID for specific currency conversion. */
  fxRateId?: InputMaybe<Scalars['ID']>;
  /**
   * Pricing model to apply for the contract. Defaults to STANDARD pricing where annual and
   * quarterly have the same effective annual rate.
   */
  pricingModel?: InputMaybe<EnterpriseContractPrice_PricingModel>;
  /** Promo Code to apply to the price. */
  promoCode?: InputMaybe<Scalars['String']>;
  /** Number of billing installments per term (1 for one-time, 4 for quarterly). */
  termInstallmentsTotal: Scalars['Int'];
  /** Optional user ID for user-specific pricing. */
  userId?: InputMaybe<Scalars['ID']>;
  /** Number of user licenses. */
  userLimit: Scalars['Int'];
};

/** Result of `EnterpriseContractPrice_SendEstimateEmail` mutation. */
export type EnterpriseContractPrice_SendEstimateEmailResult = {
  __typename?: 'EnterpriseContractPrice_SendEstimateEmailResult';
  /** Whether the estimate email was successfully sent. */
  emailSent: Scalars['Boolean'];
  /** When sending failed or was skipped, the reason. Null when `emailSent` is true. */
  errorReason?: Maybe<EnterpriseContractPrice_SendEstimateEmailErrorReason>;
};

/**
 * Tier proximity information.
 * Shows how close the current user count is to the next volume tier and the next tier's discount.
 */
export type EnterpriseContractPrice_TierProximity = {
  __typename?: 'EnterpriseContractPrice_TierProximity';
  /** Current user limit (license count) for the contract. */
  currentUserLimit: Scalars['Int'];
  /** Discount percentage at the next tier. */
  nextTierDiscountPercent: Scalars['Float'];
  /** Remaining user licenses needed to unlock the next tier. */
  remainingUserLimitToUnlock: Scalars['Int'];
};

/** Base (undiscounted) price amounts for contract limits update costs. */
export type EnterpriseContractPrice_UpdateCostBasePriceInfo = {
  __typename?: 'EnterpriseContractPrice_UpdateCostBasePriceInfo';
  /** Undiscounted amount due over installments (before volume/promo discounts). */
  amountDueOverInstallments: Scalars['Float'];
  /** Undiscounted amount due today (before volume/promo discounts). */
  amountDueToday: Scalars['Float'];
  /** Original undiscounted unit price. */
  unitPrice: Scalars['Float'];
};

/** Input for updating the active status of a pricing rule. */
export type EnterpriseContractPrice_UpdatePricingDiscountRuleStatusInput = {
  /** Whether the rule should be active. */
  active: Scalars['Boolean'];
  /** The pricing rule ID. */
  id: Scalars['ID'];
};

/** Result of updating a pricing discount rule status. */
export type EnterpriseContractPrice_UpdatePricingDiscountRuleStatusResult = {
  __typename?: 'EnterpriseContractPrice_UpdatePricingDiscountRuleStatusResult';
  /** The updated pricing rule. */
  pricingRule: EnterpriseContractPrice_PricingDiscountRule;
};

/** A single volume tier: user count range (inclusive) and unit price for that tier. */
export type EnterpriseContractPrice_VolumeTier = {
  __typename?: 'EnterpriseContractPrice_VolumeTier';
  /** Discount percentage for this tier (e.g. volume discount at this tier). */
  discountPercent?: Maybe<Scalars['Float']>;
  /** Lower bound (inclusive) of the user/license count range for this tier. */
  lowerLimit: Scalars['Int'];
  /** Unit price for this tier. */
  unitPrice: Scalars['Float'];
  /** Upper bound (inclusive) of the user/license count range for this tier. */
  upperLimit: Scalars['Int'];
};

/**
 * Volume tier information for enterprise contract product price.
 * Includes proximity to next tier and the list of tier definitions.
 */
export type EnterpriseContractPrice_VolumeTierInfo = {
  __typename?: 'EnterpriseContractPrice_VolumeTierInfo';
  /** Proximity to the next volume tier (current limit, next tier limit, remaining to unlock, next tier discount). */
  tierProximity?: Maybe<EnterpriseContractPrice_TierProximity>;
  /** List of volume tiers with upper/lower limits and unit price per tier. */
  tiers: Array<EnterpriseContractPrice_VolumeTier>;
};

/**
 * Auto-renewal authorization action enumeration.
 * Corresponds to AutoRenewAuthorizationAction in Scala.
 */
export const EnterpriseContractRenewal_AutoRenewAuthorizationAction = {
  /**
   * Disable auto-renewal for the contract.
   * Maps to opt-out for legacy cases.
   */
  Disable: 'DISABLE',
  /**
   * Enable auto-renewal for the contract.
   * Maps to opt-in for legacy cases.
   */
  Enable: 'ENABLE'
} as const;

export type EnterpriseContractRenewal_AutoRenewAuthorizationAction = typeof EnterpriseContractRenewal_AutoRenewAuthorizationAction[keyof typeof EnterpriseContractRenewal_AutoRenewAuthorizationAction];
/**
 * Input for changing the auto-renewal authorization for an enterprise contract.
 * Based on AutoRenewAuthorizationChange class.
 */
export type EnterpriseContractRenewal_ChangeAutoRenewAuthorizationInput = {
  /**
   * The action to take for auto-renewal authorization (ENABLE or DISABLE).
   * Maps to opt-in and opt-out respectively for legacy cases.
   */
  action: EnterpriseContractRenewal_AutoRenewAuthorizationAction;
  /** The ID of the enterprise contract to modify. */
  contractId: Scalars['ID'];
  /**
   * The ID of the user who is authorizing the change.
   * Primarily used in legacy opt-in/opt-out flows.
   */
  userId: Scalars['ID'];
};

/** Result type for the changeAutoRenewAuthorization mutation. */
export type EnterpriseContractRenewal_ChangeAutoRenewAuthorizationResult = {
  __typename?: 'EnterpriseContractRenewal_ChangeAutoRenewAuthorizationResult';
  /** Indicates whether the auto-renewal authorization change was successful. */
  success: Scalars['Boolean'];
};

/** The Input of the Enterprise Contract Tag to be added */
export type EnterpriseContractTag_AddTagInput = {
  /** The delist restricted products boolean value */
  delistRestrictedProducts: Scalars['Boolean'];
  /** The ID of the contract tag to add */
  id: EnterpriseContractTag_ContractTagId;
};

/** The Enterprise Contract Tag that was successfully added */
export type EnterpriseContractTag_AddTagResult = {
  __typename?: 'EnterpriseContractTag_AddTagResult';
  /** The Enterprise Contract Tag result that was added */
  result: EnterpriseContractTag_ContractTag;
};

/** Represents a contract tag within an enterprise contract. */
export type EnterpriseContractTag_ContractTag = {
  __typename?: 'EnterpriseContractTag_ContractTag';
  /** Unix timestamp representing when the tag was added. */
  addedAt: Scalars['DateTime'];
  /** ID of the user who added the tag. */
  addedBy: Scalars['ID'];
  /** The contract ID associated with the tag. */
  contractId: Scalars['ID'];
  /** The name of the contract tag. */
  contractTagName: Scalars['String'];
  /** List of domain-ids and subdomain-ids associated with the contract tag */
  domainsAndSubdomains?: Maybe<Array<EnterpriseContractTag_DomainAndSubdomains>>;
  /** The source of the contract tag. */
  source: EnterpriseContractTag_EnterpriseContractTagSource;
};

/** Represents the unique identifier of an EnterpriseContractTag. */
export type EnterpriseContractTag_ContractTagId = {
  /** The contract ID associated with the tag. */
  contractId: Scalars['ID'];
  /** The name of the contract tag. */
  contractTagName: Scalars['String'];
};

/** The Enterprise Contract Tag Input to be deleted */
export type EnterpriseContractTag_DeleteTagInput = {
  /** The ID of the contract tag to delete */
  id: EnterpriseContractTag_ContractTagId;
};

/** The Enterprise Contract Tag that was successfully added */
export type EnterpriseContractTag_DeleteTagResult = {
  __typename?: 'EnterpriseContractTag_DeleteTagResult';
  /** The Enterprise Contract Tag result that was deleted */
  result: EnterpriseContractTag_ContractTag;
};

/** Domain and Subdomain */
export type EnterpriseContractTag_DomainAndSubdomains = {
  __typename?: 'EnterpriseContractTag_DomainAndSubdomains';
  /** Domain ID */
  domain: Domain_Domain;
  /** Subdomain IDs */
  subdomains: Array<Domain_Subdomain>;
};

/** Represents the source of an EnterpriseContractTag. */
export const EnterpriseContractTag_EnterpriseContractTagSource = {
  /** Represents a contract tag added ad-hoc, not during any specific process. */
  Adhoc: 'ADHOC',
  /** Represents a contract tag added manually during the contract creation process. */
  ContractCreationManual: 'CONTRACT_CREATION_MANUAL',
  /** Represents a contract tag added via Salesforce during the contract creation process. */
  ContractCreationSfdc: 'CONTRACT_CREATION_SFDC',
  /** Represents a contract tag added during the contract renewal process. */
  ContractRenewal: 'CONTRACT_RENEWAL',
  /** Represents an invalid source value. */
  Invalid: 'INVALID'
} as const;

export type EnterpriseContractTag_EnterpriseContractTagSource = typeof EnterpriseContractTag_EnterpriseContractTagSource[keyof typeof EnterpriseContractTag_EnterpriseContractTagSource];
/** Paginated EnterpriseContractTags */
export type EnterpriseContractTag_EnterpriseContractTagsPaginatedResult = {
  __typename?: 'EnterpriseContractTag_EnterpriseContractTagsPaginatedResult';
  /** A list of enterprise contract tags. */
  elements: Array<EnterpriseContractTag_ContractTag>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueries = {
  __typename?: 'EnterpriseContractTagsQueries';
  /** Retrieves a list of EnterpriseContractTags associated with the provided contract IDs. */
  findByContractIds: EnterpriseContractTag_EnterpriseContractTagsPaginatedResult;
  /** Retrieves a list of EnterpriseContractTags associated with the provided organization ID. */
  findByOrganization: EnterpriseContractTag_EnterpriseContractTagsPaginatedResult;
  /** Retrieves the contract tag by the tagName */
  findByTag: EnterpriseContractTag_EnterpriseContractTagsPaginatedResult;
  /** Retrieves an EnterpriseContractTag by its ID. */
  getEnterpriseContractTag?: Maybe<EnterpriseContractTag_ContractTag>;
  /** Retrieves a list of EnterpriseContractTags, provided an array of IDs. */
  multiGetEnterpriseContractTags: Array<EnterpriseContractTag_ContractTag>;
  /** Retrieves a list of contract tags for each contract tag name */
  multiGetEnterpriseContractTagsByNames: Array<Maybe<EnterpriseContractTag_ContractTag>>;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesFindByContractIdsArgs = {
  contractIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesFindByOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  organizationId: Scalars['ID'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesFindByTagArgs = {
  contractTagName: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesGetEnterpriseContractTagArgs = {
  id: EnterpriseContractTag_ContractTagId;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesMultiGetEnterpriseContractTagsArgs = {
  ids: Array<EnterpriseContractTag_ContractTagId>;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractTagsQueriesMultiGetEnterpriseContractTagsByNamesArgs = {
  contractTagNames: Array<Scalars['String']>;
};

export type EnterpriseContractTagsV1 = {
  __typename?: 'EnterpriseContractTagsV1';
  addedAt: Scalars['Float'];
  /** id for a Coursera user */
  addedBy: Scalars['Int'];
  contract?: Maybe<EnterpriseContractsV1>;
  contractId: Scalars['String'];
  contractTag: Scalars['String'];
  id: Scalars['String'];
  source: EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource;
};

/**
 * enterpriseContractTags.v1?q=byContractIds
 *
 * See
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/enterpriseContractTags.v1.graphql
 * for the complete schema.
 */
export type EnterpriseContractTagsV1ByContractIds = {
  __typename?: 'EnterpriseContractTagsV1ByContractIds';
  connection?: Maybe<EnterpriseContractTagsV1Connection>;
  contractIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractTagsV1ByOrganization = {
  __typename?: 'EnterpriseContractTagsV1ByOrganization';
  connection?: Maybe<EnterpriseContractTagsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  orgId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractTagsV1ByTag = {
  __typename?: 'EnterpriseContractTagsV1ByTag';
  connection?: Maybe<EnterpriseContractTagsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  tag: Scalars['String'];
};

export type EnterpriseContractTagsV1Connection = {
  __typename?: 'EnterpriseContractTagsV1Connection';
  elements: Array<Maybe<EnterpriseContractTagsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseContractTagsV1Resource = {
  __typename?: 'EnterpriseContractTagsV1Resource';
  byContractIds?: Maybe<EnterpriseContractTagsV1Connection>;
  byOrganization?: Maybe<EnterpriseContractTagsV1Connection>;
  byTag?: Maybe<EnterpriseContractTagsV1Connection>;
  get?: Maybe<EnterpriseContractTagsV1>;
  multiGet?: Maybe<EnterpriseContractTagsV1Connection>;
};


export type EnterpriseContractTagsV1ResourceByContractIdsArgs = {
  contractIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractTagsV1ResourceByOrganizationArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractTagsV1ResourceByTagArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  tag: Scalars['String'];
};


export type EnterpriseContractTagsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractTagsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseContractTagsV1ResourceMutations = {
  __typename?: 'EnterpriseContractTagsV1ResourceMutations';
  addTag?: Maybe<Scalars['JSON']>;
  changeTag?: Maybe<Scalars['JSON']>;
  create?: Maybe<EnterpriseContractTagsV1Connection>;
  delete?: Maybe<EnterpriseContractTagsV1Connection>;
  validateContractTagCompatibility?: Maybe<Scalars['JSON']>;
};


export type EnterpriseContractTagsV1ResourceMutationsAddTagArgs = {
  delistRestrictedProducts?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type EnterpriseContractTagsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractTagsV1ResourceMutationsValidateContractTagCompatibilityArgs = {
  existingContractIds: Array<InputMaybe<Scalars['String']>>;
  newContractId: Scalars['String'];
};

export const EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource = {
  Adhoc: 'ADHOC',
  ContractCreationManual: 'CONTRACT_CREATION_MANUAL',
  ContractCreationSfdc: 'CONTRACT_CREATION_SFDC',
  ContractRenewal: 'CONTRACT_RENEWAL'
} as const;

export type EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource = typeof EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource[keyof typeof EnterpriseContractTagsV1_Org_Coursera_Enterprise_Contract_Tag_EnterpriseContractTagSource];
export type EnterpriseContractTransactionsV1 = {
  __typename?: 'EnterpriseContractTransactionsV1';
  enterpriseContractTransactions: Array<Maybe<EnterpriseContractTransactionsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTransaction>>;
  id: Scalars['String'];
};

export type EnterpriseContractTransactionsV1Connection = {
  __typename?: 'EnterpriseContractTransactionsV1Connection';
  elements: Array<Maybe<EnterpriseContractTransactionsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseContractTransactionsV1FindByContractIdAndMaybeTermId = {
  __typename?: 'EnterpriseContractTransactionsV1FindByContractIdAndMaybeTermId';
  connection?: Maybe<EnterpriseContractTransactionsV1Connection>;
  contractId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['String']>;
};

export type EnterpriseContractTransactionsV1Resource = {
  __typename?: 'EnterpriseContractTransactionsV1Resource';
  findByContractIdAndMaybeTermId?: Maybe<EnterpriseContractTransactionsV1Connection>;
  get?: Maybe<EnterpriseContractTransactionsV1>;
};


export type EnterpriseContractTransactionsV1ResourceFindByContractIdAndMaybeTermIdArgs = {
  contractId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  termId?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractTransactionsV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type EnterpriseContractTransactionsV1ResourceMutations = {
  __typename?: 'EnterpriseContractTransactionsV1ResourceMutations';
  createTransaction?: Maybe<Scalars['JSON']>;
  deleteByGrantedBy?: Maybe<Scalars['JSON']>;
  findByGrantedBy?: Maybe<Scalars['JSON']>;
  findTransactionsByGrantedBy?: Maybe<Scalars['JSON']>;
  getTotalContractValueByContractAndMaybeTerm?: Maybe<Scalars['JSON']>;
  updateDiscretionaryDiscountId?: Maybe<Scalars['JSON']>;
};


export type EnterpriseContractTransactionsV1ResourceMutationsDeleteByGrantedByArgs = {
  grantedBy: Scalars['String'];
};


export type EnterpriseContractTransactionsV1ResourceMutationsFindByGrantedByArgs = {
  grantedBy: Scalars['String'];
};


export type EnterpriseContractTransactionsV1ResourceMutationsGetTotalContractValueByContractAndMaybeTermArgs = {
  contractId: Scalars['String'];
  termIdOpt?: InputMaybe<Scalars['String']>;
};

export type EnterpriseContractTransactionsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTransaction = {
  __typename?: 'EnterpriseContractTransactionsV1_org_coursera_product_enterprise_contract_EnterpriseContractTransaction';
  contractValueIncrease: Scalars['String'];
  enterpriseContractId: Scalars['String'];
  enterpriseContractTermId?: Maybe<Scalars['String']>;
  enterpriseCouponId?: Maybe<Scalars['String']>;
  enterpriseDiscretionaryDiscountId?: Maybe<Scalars['String']>;
  fxRateId?: Maybe<Scalars['Int']>;
  grantedBy?: Maybe<Scalars['String']>;
  limitValuesUpdate: EnterpriseContractTransactionsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitValuesUpdate;
  rawValueIncrease?: Maybe<Scalars['String']>;
  timestamp: Scalars['Float'];
};

export type EnterpriseContractTransactionsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitValuesUpdate = {
  __typename?: 'EnterpriseContractTransactionsV1_org_coursera_product_enterprise_contract_limits_EnterpriseContractLimitValuesUpdate';
  coursesPerUsersAdded: Scalars['Int'];
  coursesTotalAdded: Scalars['Int'];
  usersAdded: Scalars['Int'];
};

/** Query definitions */
export type EnterpriseContractUtilizationsQueries = {
  __typename?: 'EnterpriseContractUtilizationsQueries';
  /**
   * This replicates the Get Request from the gRPC schema
   * Gets a utilization for a contract id
   */
  queryByContractId?: Maybe<EnterpriseContractUtilizations_UtilizationEntry>;
  /**
   * This replicates the MultiGet Request from the gRPC schema
   * Gets the utilization for multiple contract ids | Maximum page size: 100
   */
  queryByContractIds: EnterpriseContractUtilizations_UtilizationConnection;
};


/** Query definitions */
export type EnterpriseContractUtilizationsQueriesQueryByContractIdArgs = {
  contractId: Scalars['ID'];
};


/** Query definitions */
export type EnterpriseContractUtilizationsQueriesQueryByContractIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  contractIds: Array<Scalars['ID']>;
  first?: Scalars['Int'];
};

export type EnterpriseContractUtilizationsV1 = {
  __typename?: 'EnterpriseContractUtilizationsV1';
  contractLimitType: EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType;
  id: Scalars['String'];
  remaining?: Maybe<Scalars['Int']>;
  remainingEnrollment?: Maybe<Scalars['Int']>;
  remainingUserLicense?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  totalEnrollment?: Maybe<Scalars['Int']>;
  totalUserLicense?: Maybe<Scalars['Int']>;
};

export type EnterpriseContractUtilizationsV1Connection = {
  __typename?: 'EnterpriseContractUtilizationsV1Connection';
  elements: Array<Maybe<EnterpriseContractUtilizationsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseContractUtilizationsV1Resource = {
  __typename?: 'EnterpriseContractUtilizationsV1Resource';
  get?: Maybe<EnterpriseContractUtilizationsV1>;
  multiGet?: Maybe<EnterpriseContractUtilizationsV1Connection>;
};


export type EnterpriseContractUtilizationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractUtilizationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof EnterpriseContractUtilizationsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
/** Contract limit types */
export const EnterpriseContractUtilizations_ContractLimitType = {
  /** Limit set by enrollment cap */
  EnterpriseContractLimitTypeEnrollmentCap: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_ENROLLMENT_CAP',
  /** Limit type is invalid */
  EnterpriseContractLimitTypeInvalid: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_INVALID',
  /** No limit set */
  EnterpriseContractLimitTypeNoLimit: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_NO_LIMIT',
  /** Limit set by user licenses */
  EnterpriseContractLimitTypeUserLicense: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_USER_LICENSE',
  /** Limit set by user licenses and enrollment cap */
  EnterpriseContractLimitTypeUserLicenseWithEnrollmentCap: 'ENTERPRISE_CONTRACT_LIMIT_TYPE_USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractUtilizations_ContractLimitType = typeof EnterpriseContractUtilizations_ContractLimitType[keyof typeof EnterpriseContractUtilizations_ContractLimitType];
/** Paginated utilization */
export type EnterpriseContractUtilizations_UtilizationConnection = {
  __typename?: 'EnterpriseContractUtilizations_UtilizationConnection';
  /** Utilization edges in the graph */
  edges?: Maybe<Array<EnterpriseContractUtilizations_UtilizationEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** UtilizationEdge in graph */
export type EnterpriseContractUtilizations_UtilizationEdge = {
  __typename?: 'EnterpriseContractUtilizations_UtilizationEdge';
  /** Offset for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** Contract utilization */
  node: EnterpriseContractUtilizations_UtilizationEntry;
};

/** Enterprise Utilization - extended for federation */
export type EnterpriseContractUtilizations_UtilizationEntry = Node & {
  __typename?: 'EnterpriseContractUtilizations_UtilizationEntry';
  /** Contract limit type */
  contractLimitType: EnterpriseContractUtilizations_ContractLimitType;
  /** Enterprise Contract id. */
  id: Scalars['ID'];
  /** Remaining enrollment */
  remainingEnrollment?: Maybe<Scalars['Int']>;
  /** Remaining user licenses */
  remainingUserLicense?: Maybe<Scalars['Int']>;
  /** Total enrollment */
  totalEnrollment?: Maybe<Scalars['Int']>;
  /** Total user licenses */
  totalUserLicense?: Maybe<Scalars['Int']>;
};

/** Response for failed EnterpriseContract_ActivateContract mutation operation */
export type EnterpriseContract_ActivateContractFailure = {
  __typename?: 'EnterpriseContract_ActivateContractFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_ActivateContract mutation. */
export type EnterpriseContract_ActivateContractInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** Option to specify email notification preferences for the activation */
  emailRequest?: InputMaybe<EnterpriseContract_EmailRequestInput>;
  /** Notes with more details */
  notes?: InputMaybe<Scalars['String']>;
};

/** Response for EnterpriseContract_ActivateContract mutation operation */
export type EnterpriseContract_ActivateContractResult = EnterpriseContract_ActivateContractFailure | EnterpriseContract_ActivateContractSuccess;

/** Response for successful EnterpriseContract_ActivateContract mutation operation */
export type EnterpriseContract_ActivateContractSuccess = {
  __typename?: 'EnterpriseContract_ActivateContractSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Enterprise Contract Billing Type */
export const EnterpriseContract_BillingType = {
  /** Invoice */
  Invoice: 'INVOICE',
  /** None */
  None: 'NONE',
  /** One time */
  OneTime: 'ONE_TIME',
  /** Quarterly */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContract_BillingType = typeof EnterpriseContract_BillingType[keyof typeof EnterpriseContract_BillingType];
/** Enterprise contract account group */
export const EnterpriseContract_ContractAccountGroup = {
  /** Org Type C4B */
  C4B: 'C4B',
  /** Org Type C4C */
  C4C: 'C4C',
  /** Org Type C4G */
  C4G: 'C4G',
  /** Org Type GOOGLE */
  Google: 'GOOGLE',
  /** Org Type IP */
  Ip: 'IP',
  /** Org Type SOCIAL_IMPACT */
  SocialImpact: 'SOCIAL_IMPACT'
} as const;

export type EnterpriseContract_ContractAccountGroup = typeof EnterpriseContract_ContractAccountGroup[keyof typeof EnterpriseContract_ContractAccountGroup];
/**
 * EnterpriseContract's can be paid for in a variety of different ways.
 * The EnterpriseContractBillingSystemType is a finite list of the billing methods available
 * for both direct sales and WES contracts.
 */
export const EnterpriseContract_ContractBillingSystemType = {
  /**
   * This contract's payments are being handled by the Enterprise Invoicing service.
   * Transactions are initiated by interaction between the customer and payment processor,
   * notifying Coursera backend via asynchronous webhooks.
   */
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  /**
   * This contract is being billed by the recurring enterpriseselfservebilling Iguazu job.
   * Transactions are initiated by the payment service's cart system.
   * Usually used by WES contracts not handled by the Enterprise Invoicing service
   */
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  /** This contract is not integrated with any billing system. This is usually used by test (not-real) contracts. */
  NonBillable: 'NON_BILLABLE',
  /**
   * This contract's payments are being handled off-platform by Coursera's internal finance team,
   * The team manually sends the customer invoices and collects payment.
   * Usually used by direct sales contracts.
   */
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContract_ContractBillingSystemType = typeof EnterpriseContract_ContractBillingSystemType[keyof typeof EnterpriseContract_ContractBillingSystemType];
/**
 * Enterprise contract deal type.
 * Currently, all listed deal types are specific to C4G contracts.
 * Future expansion may include deal types for other contract types.
 */
export const EnterpriseContract_ContractDealType = {
  /** C4G deal for Government Employees */
  GovernmentEmployees: 'GOVERNMENT_EMPLOYEES',
  /** C4G deal for Ministries of Education */
  MinistriesOfEducation: 'MINISTRIES_OF_EDUCATION',
  /** C4G deal for Workforce Development */
  WorkforceDevelopment: 'WORKFORCE_DEVELOPMENT'
} as const;

export type EnterpriseContract_ContractDealType = typeof EnterpriseContract_ContractDealType[keyof typeof EnterpriseContract_ContractDealType];
/** Enterprise Contract Limit Type */
export const EnterpriseContract_ContractLimitType = {
  /** Number of enrollments the contract can have */
  EnrollmentCap: 'ENROLLMENT_CAP',
  /** No limit */
  NoLimit: 'NO_LIMIT',
  /** Number of members in the contract */
  UserLicense: 'USER_LICENSE',
  /** Number of members and enrollment the contract can have */
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContract_ContractLimitType = typeof EnterpriseContract_ContractLimitType[keyof typeof EnterpriseContract_ContractLimitType];
/** Enterprise Contract Limits */
export type EnterpriseContract_ContractLimits = {
  __typename?: 'EnterpriseContract_ContractLimits';
  /** Number of courses can be enrolled by each member */
  coursesPerUserLimit?: Maybe<Scalars['Int']>;
  /** Number of enrollments the contract can have */
  enrollmentCapLimit?: Maybe<Scalars['Int']>;
  /** Number of members can join the contract */
  userLimit?: Maybe<Scalars['Int']>;
};

/** Enterprise Contract Limits */
export type EnterpriseContract_ContractLimitsInput = {
  /** Number of courses that can be enrolled by each member */
  coursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /** Number of enrollments the contract can have */
  enrollmentCapLimit?: InputMaybe<Scalars['Int']>;
  /** Number of members that can be assigned to the contract */
  userLimit?: InputMaybe<Scalars['Int']>;
};

/** Enterprise Contract Properties */
export type EnterpriseContract_ContractProperties = {
  __typename?: 'EnterpriseContract_ContractProperties';
  /** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_INVOICE */
  invoiceBilledContractProperties?: Maybe<EnterpriseContract_InvoiceBilledContractProperties>;
  /** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_TRANSACTION_PAYMENT */
  selfServeProperties?: Maybe<EnterpriseContract_SelfServeEnterpriseContractProperties>;
};

/** Enterprise contract purpose */
export const EnterpriseContract_ContractPurpose = {
  /** Demo contract */
  Demo: 'DEMO',
  /** Trial contract intended for prospects */
  Trial: 'TRIAL'
} as const;

export type EnterpriseContract_ContractPurpose = typeof EnterpriseContract_ContractPurpose[keyof typeof EnterpriseContract_ContractPurpose];
/** Enterprise Contract State */
export const EnterpriseContract_ContractState = {
  /** ACTIVE: Active and consumable state for a contract. It moves into this stage after gets activated */
  Active: 'ACTIVE',
  /** CREATED: The state that the contract will be in when it just gets created. */
  Created: 'CREATED',
  /**
   * EXPIRED: The endsAt data has passed but contract has not been terminated yet. The contract
   * basically is treated as paused in this state
   */
  Expired: 'EXPIRED',
  /** PAUSED: The contract is paused and can't be consumed at this state. */
  Paused: 'PAUSED',
  /** TERMINATED: The contract is in this state after gets terminated and cannot be consumed or edited */
  Terminated: 'TERMINATED'
} as const;

export type EnterpriseContract_ContractState = typeof EnterpriseContract_ContractState[keyof typeof EnterpriseContract_ContractState];
/**
 * Represents the source of truth for data related to each individual term of a contract.
 * This model and its relations contain all information needed to accurately revshare enterprise
 * contracts. EnterpriseContractPayments have a termId that references one instance of a term.
 * The total of those payments represents the revenue that should be recognized over this
 * contract's startsAt and endsAt. EnterpriseContractTransactions also contain a termId reference
 * and their sum represents the contract limits for a term, which can differ between terms.
 * Enrollments data can also be gotten from promotionId, but it's not currently implemented like
 * this.
 */
export type EnterpriseContract_ContractTerm = Node & {
  __typename?: 'EnterpriseContract_ContractTerm';
  /**
   * The endsAt of the term. Differs from contract model's endsAt because terms represents the
   * source of truth for the interval that revenue should be recognized over regardless of early
   * terminations due to factors such as delinquent payments.
   *
   * For Self Serve contracts, endsAt should always be present and is currently 12 months after the
   * startsAt. We store both startsAt and endsAt to enable flexibility in case we want to start
   * offering contracts whose terms are not 1 year long.
   *
   * The only reason endsAt is optional is because term length is not well-defined/easily
   * accessible for Direct Sales contracts. For example, Direct Sales contracts can be multi-year
   * contracts. Direct Sales contracts can also be created before or after the physical contract is
   * signed, which affects the service period.
   *
   * endsAt data for Direct Sales contracts is on Salesforce/maybe ETL'ed to MEGA. Eventually this
   * data should be backfilled/made accessible to terms/contracts code so we can make endsAt
   * non-optional.
   */
  endTime?: Maybe<Scalars['DateTime']>;
  /**
   * The exchange rate used for pricing during this term.
   * This rate is the rate from the 5th business day of the previous month from when the term was created.
   */
  fxRateId?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['ID'];
  /** The promotionId used to create coupons that users use to enroll in courses in a program */
  promotionId: Scalars['Int'];
  /** Start time of the term */
  startTime?: Maybe<Scalars['DateTime']>;
  /** An optional EnterpriseContractTermTag associated with this term */
  termTag?: Maybe<EnterpriseContract_ContractTermTag>;
  /**
   * The unit price during this term. This will be the unit price in USD converted
   * to the local currency using the exchange rate on this term.
   */
  unitPrice?: Maybe<Scalars['Float']>;
  /** Differs from startsAt for cases such as backfilled data */
  writtenTime?: Maybe<Scalars['DateTime']>;
};

/** An enum for tagging terms with extra context */
export const EnterpriseContract_ContractTermTag = {
  /** Free trial allowing access to Coursera for Teams. */
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EnterpriseContract_ContractTermTag = typeof EnterpriseContract_ContractTermTag[keyof typeof EnterpriseContract_ContractTermTag];
/** Enterprise Contract Type */
export const EnterpriseContract_ContractType = {
  /** WES */
  SelfServe: 'SELF_SERVE',
  /** Standard */
  Standard: 'STANDARD'
} as const;

export type EnterpriseContract_ContractType = typeof EnterpriseContract_ContractType[keyof typeof EnterpriseContract_ContractType];
/** Response for failed EnterpriseContract_CreateContract mutation operation */
export type EnterpriseContract_CreateContractFailure = {
  __typename?: 'EnterpriseContract_CreateContractFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_CreateContract mutation. */
export type EnterpriseContract_CreateContractInput = {
  /** Account Group of the Salesforce case, one of C4B, C4C & C4G. */
  accountGroup?: InputMaybe<EnterpriseContract_ContractAccountGroup>;
  /** The billing type for the contract to be created */
  billingType: EnterpriseContract_BillingType;
  /**
   * Optional cart ID
   * - For STANDARD contract type, NOT required
   * - For SELF_SERVE contract type, optional only if planId is provided
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  cartId?: InputMaybe<Scalars['ID']>;
  /** The contract type for the contract to be created */
  contractLimitType: EnterpriseContract_ContractLimitType;
  /** The contract limits specifications */
  contractLimits: EnterpriseContract_ContractLimitsInput;
  /** A tag that should be associated with the contract. Currently limited to Direct Sales contracts */
  contractTag?: InputMaybe<Scalars['String']>;
  /** The contract type for the contract to be created */
  contractType: EnterpriseContract_ContractType;
  /** Country ISO code */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /**
   * The ID of user creating the contract
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  createdBy?: InputMaybe<Scalars['ID']>;
  /** The associated Currency Code */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * For a C4G accounts, there can be multiple types of deals. Null is allowed for C4B and C4C,
   * test and WES contracts.
   */
  dealType?: InputMaybe<EnterpriseContract_ContractDealType>;
  /** Duration of the contract in months */
  durationInMonths?: InputMaybe<Scalars['Float']>;
  /** Time when the contract ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Flag used to distinguish between real customer contracts and test contracts */
  isReal?: Scalars['Boolean'];
  /** A custom percentage recycling allowed in the contract. */
  licenseRecycleLimitPercent?: InputMaybe<Scalars['String']>;
  /**
   * Whether the customer has agreed to license recycle terms & conditions while signing the contract.
   * Null is allowed for the test and WES contracts
   */
  licenseRecycleTncEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Name of the contract */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optional payment wallet ID: Used for recurring payments
   * - Sent as String ID, since Long is not supported in GraphQL
   */
  paymentWalletId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional Plan ID
   * - For STANDARD contract type, always required
   * - For SELF_SERVE contract type, optional only if cartId is provided
   * - Sent as String ID format, since Long is not supported in GraphQL
   */
  planId?: InputMaybe<Scalars['ID']>;
  /** The purpose of the contract. NULL means "regular" contract that does not fall into any predefined categories. */
  purpose?: InputMaybe<EnterpriseContract_ContractPurpose>;
  /** Case number of the contract in salesforce */
  salesforceCaseNumber?: InputMaybe<Scalars['String']>;
  /** Scheduled activation timestamp for the contract. Must be in the future. */
  scheduledActivationAt?: InputMaybe<Scalars['DateTime']>;
  /** Time when the contract starts */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** Organization ID - must be non-blank */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Response for EnterpriseContract_CreateContract mutation operation */
export type EnterpriseContract_CreateContractResult = EnterpriseContract_CreateContractFailure | EnterpriseContract_CreateContractSuccess;

/** Response for successful EnterpriseContract_CreateContract mutation operation */
export type EnterpriseContract_CreateContractSuccess = {
  __typename?: 'EnterpriseContract_CreateContractSuccess';
  /** The updated Enterprise Contract */
  contract: EnterpriseContract_EnterpriseContract;
};

/** Input for deactivating an enterprise contract without refund. */
export type EnterpriseContract_DeactivateWithoutRefundInput = {
  /** The enterprise contract ID to deactivate. */
  enterpriseContractId: Scalars['ID'];
};

/**
 * Result of deactivating an enterprise contract without refund.
 * Based on RecordedContractRefund class in Scala.
 */
export type EnterpriseContract_DeactivateWithoutRefundResult = {
  __typename?: 'EnterpriseContract_DeactivateWithoutRefundResult';
  /** The recorded contract refund information. */
  recordedRefund: EnterpriseContract_RecordedContractRefund;
};

/** Input parameters for EnterpriseContract_DowngradeContract mutation. */
export type EnterpriseContract_DowngradeContractInput = {
  /** Id of the active contract to be downgraded */
  contractId: Scalars['ID'];
  /** Flag to determine whether membership deletion notifications should be sent */
  sendMembershipDeletionNotification?: InputMaybe<Scalars['Boolean']>;
};

/** Response for successful mutation operation */
export type EnterpriseContract_DowngradeContractResult = {
  __typename?: 'EnterpriseContract_DowngradeContractResult';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input parameters for EnterpriseContract_EmailOptionsInput mutation. */
export type EnterpriseContract_EmailRequestInput = {
  /** Flag to specify whether orgAdmins should also receive notifications about the activation */
  includeOrgAdmins: Scalars['Boolean'];
  /** List of emails to be notified about the activation */
  recipientEmailAddresses: Array<Scalars['String']>;
};

/** Enrollment Migration Configuration specifying how enrollments should be migrated */
export const EnterpriseContract_EnrollmentMigrationConfiguration = {
  /** Migrate only active program enrollments (determined by traffic light API) to the new contract */
  Active: 'ACTIVE',
  /** Migrate only enrollments starting after a date specified by enrollmentCutoffDate */
  AfterCutoffDate: 'AFTER_CUTOFF_DATE',
  /** Migrate all program enrollments to the new contract */
  All: 'ALL',
  /** Do not migrate any program enrollments to the new contract */
  None: 'NONE',
  /** Migrate enrollments that do not consume any credits (free consumption policy) */
  OnlyFreeEnrollments: 'ONLY_FREE_ENROLLMENTS',
  /** Only migrate enrollments defined in the range of ContractEnrollmentMigrationRange.min */
  Overage: 'OVERAGE',
  /** Migrate only enrollments specified in selectedUserCourseEnrollments */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_EnrollmentMigrationConfiguration = typeof EnterpriseContract_EnrollmentMigrationConfiguration[keyof typeof EnterpriseContract_EnrollmentMigrationConfiguration];
/** Represents the options for enrollment restoration configuration. */
export const EnterpriseContract_EnrollmentRestorationConfiguration = {
  /** Represents restore all program enrollments to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program enrollments. */
  None: 'NONE'
} as const;

export type EnterpriseContract_EnrollmentRestorationConfiguration = typeof EnterpriseContract_EnrollmentRestorationConfiguration[keyof typeof EnterpriseContract_EnrollmentRestorationConfiguration];
/** An Enterprise Contract - extended for federation */
export type EnterpriseContract_EnterpriseContract = Node & {
  __typename?: 'EnterpriseContract_EnterpriseContract';
  /** The billing system that is used to bill this contract */
  billingSystemType: EnterpriseContract_ContractBillingSystemType;
  /** The type of billing for this particular contract. */
  billingType: EnterpriseContract_BillingType;
  /** The state of the contract */
  contractState: EnterpriseContract_ContractState;
  /** The linked optional contract tag */
  contractTag?: Maybe<EnterpriseContractTag_ContractTag>;
  /** The type of contract. Either used for self-serve or standard enterprise offerings. */
  contractType: EnterpriseContract_ContractType;
  /** Country the contract is associated with. Used for geo-pricing. */
  countryIsoCode?: Maybe<Scalars['String']>;
  /** Contract created at timestamp */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Currency code the contract is associated with. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Duration in months of the contract */
  durationInMonths?: Maybe<Scalars['Float']>;
  /** The actual timestamp of terminating the contract. It will be empty for the non-terminated contracts */
  endedAt?: Maybe<Scalars['DateTime']>;
  /** Ends at timestamp */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Used to distinguish between pause and hard paused contract. */
  hardPausedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Whether the contract has a restricted course list applied. True if at least one active course
   * restriction exists for this contract, false otherwise.
   */
  hasRestrictedCourseList: Scalars['Boolean'];
  /** A unique ID for a Contract */
  id: Scalars['ID'];
  /** Whether the license recycle is restricted or not */
  isLicenseRecycleRestricted?: Maybe<Scalars['Boolean']>;
  /** Flag indicates if the contract is paused */
  isPaused: Scalars['Boolean'];
  /** Used to distinguish between real customer contracts and test contracts. */
  isReal: Scalars['Boolean'];
  /** The percentage by which license rotation is allowed */
  licenseRecycleLimitPercent?: Maybe<Scalars['String']>;
  /**
   * The limit type of the contract, which should be immutable after a contract starts. This
   * property is provided by clients creating the contract, and will validate the
   * [[EnterpriseContractLimits]] being set on the contract.
   */
  limitType: EnterpriseContract_ContractLimitType;
  /** Three types of contract limits */
  limits?: Maybe<EnterpriseContract_ContractLimits>;
  /** Name of the contract as shown on the UI */
  name?: Maybe<Scalars['String']>;
  /** The contract policies */
  naptimeEnterpriseContractPolicies?: Maybe<EnterpriseContractPoliciesV1ByContract>;
  /** The contract policies by fallback contract */
  naptimeEnterpriseContractPoliciesByFallbackContract?: Maybe<EnterpriseContractPoliciesV1ByFallbackContract>;
  /** The contract policies by renewal contract */
  naptimeEnterpriseContractPoliciesByRenewalContract?: Maybe<EnterpriseContractPoliciesV1ByRenewalContract>;
  /** The linked third party organization, resolved through Naptime via GraphQL Mesh */
  naptimeThirdPartyOrganization: ThirdPartyOrganizationsV1;
  /**
   * Public facing identifier for this enterprise contract.
   * This underlying value is equivalent to CartId.id
   */
  planId: Scalars['Int'];
  /** Used to manage creation and usage of coupons. */
  promotionId: Scalars['Int'];
  /** Additional properties that are specfic to the contract type. */
  properties?: Maybe<EnterpriseContract_ContractProperties>;
  /** The purpose of the contract */
  purpose?: Maybe<EnterpriseContract_ContractPurpose>;
  /** Salesforce Case Number */
  salesforceCaseNumber?: Maybe<Scalars['String']>;
  /** Scheduled activation timestamp for the contract. NULL if not scheduled or cancelled. */
  scheduledActivationAt?: Maybe<Scalars['DateTime']>;
  /** Starts at timestamp */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Contract Termination reason. It will be empty for the non-terminated contracts */
  terminationReason?: Maybe<EnterpriseContract_TerminatedReasonType>;
  /** Each individual term of a contract */
  terms?: Maybe<Array<EnterpriseContract_ContractTerm>>;
  /** The user rosters associated with this contract | Maximum page size: 1000 */
  userRosters?: Maybe<EnterpriseUserRosterConnection>;
  /** The linked contract utilizations */
  utilization: EnterpriseContractUtilizations_UtilizationEntry;
  /** Value */
  value?: Maybe<Scalars['Float']>;
};


/** An Enterprise Contract - extended for federation */
export type EnterpriseContract_EnterpriseContractUserRostersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Represents a paginated list of EnterpriseContracts */
export type EnterpriseContract_EnterpriseContractConnection = {
  __typename?: 'EnterpriseContract_EnterpriseContractConnection';
  /** The paginated list */
  edges: Array<EnterpriseContract_EnterpriseContractEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** Represents a EnterpriseProgram with its pagination cursor */
export type EnterpriseContract_EnterpriseContractEdge = {
  __typename?: 'EnterpriseContract_EnterpriseContractEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** The EnterpriseContract */
  node: EnterpriseContract_EnterpriseContract;
};

/** Pagination for EnterpriseContracts results. */
export type EnterpriseContract_EnterpriseContractPaginatedResult = {
  __typename?: 'EnterpriseContract_EnterpriseContractPaginatedResult';
  /** A list of enterprise contracts. */
  elements: Array<EnterpriseContract_EnterpriseContract>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/**
 * The housekeeping action to perform. Exactly one field must be set; supplying zero or more
 * than one is rejected.
 */
export type EnterpriseContract_HousekeepingAction = {
  /** Update the next scheduled payment date for a contract payment. */
  updateNextPaymentAt?: InputMaybe<EnterpriseContract_UpdateNextPaymentAtParams>;
  /** Update the end date of the contract's current term. */
  updateTermEndsAt?: InputMaybe<EnterpriseContract_UpdateTermEndsAtParams>;
};

/** Input for the `EnterpriseContract_Housekeeping` mutation. */
export type EnterpriseContract_HousekeepingInput = {
  /** The single housekeeping action to perform. Exactly one variant must be provided. */
  action: EnterpriseContract_HousekeepingAction;
  /** The enterprise contract ID the housekeeping action applies to. */
  contractId: Scalars['ID'];
};

/** Result of an `EnterpriseContract_Housekeeping` mutation. */
export type EnterpriseContract_HousekeepingResult = {
  __typename?: 'EnterpriseContract_HousekeepingResult';
  /** Indicates the housekeeping action completed successfully. */
  success: Scalars['Boolean'];
};

/** Invitation Migration Configuration specifying how invitations should be migrated */
export const EnterpriseContract_InvitationMigrationConfiguration = {
  /** Migrate all program invitations to the new contract */
  All: 'ALL',
  /** Do not migrate any program invitations to the new contract */
  None: 'NONE'
} as const;

export type EnterpriseContract_InvitationMigrationConfiguration = typeof EnterpriseContract_InvitationMigrationConfiguration[keyof typeof EnterpriseContract_InvitationMigrationConfiguration];
/** Represents the options for invitation restoration. */
export const EnterpriseContract_InvitationRestorationConfiguration = {
  /** Represents restore all program invitation to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program invitation the a new contract */
  None: 'NONE'
} as const;

export type EnterpriseContract_InvitationRestorationConfiguration = typeof EnterpriseContract_InvitationRestorationConfiguration[keyof typeof EnterpriseContract_InvitationRestorationConfiguration];
/** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_INVOICE */
export type EnterpriseContract_InvoiceBilledContractProperties = {
  __typename?: 'EnterpriseContract_InvoiceBilledContractProperties';
  /**
   * Indicates if the contract is eligible for auto-charging.
   * Becomes true after first successful card payment.
   */
  autoChargeEligible?: Maybe<Scalars['Boolean']>;
  /** The external id of the customer on the payment processor */
  customerId: Scalars['ID'];
  /**
   * Type of payment method stored (e.g., "CARD", "BANK_ACCOUNT").
   * Only "CARD" is supported for auto-charging.
   */
  paymentMethodType?: Maybe<Scalars['String']>;
  /** The payment processor that invoice bills this contract */
  paymentProcessorId: Scalars['ID'];
  /** The payment wallet id used for auto-charging */
  paymentWalletId?: Maybe<Scalars['ID']>;
  /** The coursera user id that is being invoiced */
  user: Scalars['ID'];
};

/** Membership Migration Configuration specifying how memberships should be migrated */
export const EnterpriseContract_MembershipMigrationConfiguration = {
  /** Migrate all members that have at least one active enrollment or completed enrollment */
  Active: 'ACTIVE',
  /** Migrate all program members to the new contract */
  All: 'ALL',
  /** Do not migrate any program members to the new contract */
  None: 'NONE',
  /** Only migrate users specified in selectedUserCourseEnrollments */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_MembershipMigrationConfiguration = typeof EnterpriseContract_MembershipMigrationConfiguration[keyof typeof EnterpriseContract_MembershipMigrationConfiguration];
/** Represents the options for membership restoration. */
export const EnterpriseContract_MembershipRestorationConfiguration = {
  /** Represents only restore active program memberships to the a new contract. */
  Active: 'ACTIVE',
  /** Represents restore all program memberships to the new contract. */
  All: 'ALL',
  /** Represents don't restore any program memberships the a new contract */
  None: 'NONE',
  /** Represents only restore users specified program memberships to the a new contract. */
  Selected: 'SELECTED'
} as const;

export type EnterpriseContract_MembershipRestorationConfiguration = typeof EnterpriseContract_MembershipRestorationConfiguration[keyof typeof EnterpriseContract_MembershipRestorationConfiguration];
/** Base error definition for EnterpriseContract mutations */
export type EnterpriseContract_MutationError = {
  /** Message that provides more details about the error */
  message: Scalars['String'];
};

/** Response for failed pause contract mutation operation */
export type EnterpriseContract_PauseContractFailure = {
  __typename?: 'EnterpriseContract_PauseContractFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_PauseContract mutation. */
export type EnterpriseContract_PauseContractInput = {
  /** Id of the contract to be paused */
  contractId: Scalars['ID'];
  /** Flag to determine whether the operation should be a hard-pause or not */
  hardPause?: Scalars['Boolean'];
  /** Notes about the pause */
  notes?: InputMaybe<Scalars['String']>;
};

/** Response for pause mutation operation */
export type EnterpriseContract_PauseContractResult = EnterpriseContract_PauseContractFailure | EnterpriseContract_PauseContractSuccess;

/** Response for successful pause mutation operation */
export type EnterpriseContract_PauseContractSuccess = {
  __typename?: 'EnterpriseContract_PauseContractSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Payment item details */
export type EnterpriseContract_PaymentItem = {
  __typename?: 'EnterpriseContract_PaymentItem';
  /** Amount paid for this item */
  amount: Scalars['Float'];
  /** Installment number (if this is an installment payment) */
  installmentNumber?: Maybe<Scalars['Int']>;
  /** Type of payment item */
  itemType: EnterpriseContract_PaymentItemType;
  /** Original amount before any adjustments */
  originalAmount: Scalars['Float'];
  /** Promotion information (if a promotion was applied) */
  promotionInfo?: Maybe<EnterpriseContract_PromotionInfo>;
  /** Number of proration days (if applicable) */
  prorationDays?: Maybe<Scalars['Int']>;
  /** Total number of installments (if this is an installment payment) */
  totalInstallments?: Maybe<Scalars['Int']>;
  /** User limit associated with this payment item (if applicable) */
  userLimit?: Maybe<Scalars['Int']>;
};

/** Payment item type */
export const EnterpriseContract_PaymentItemType = {
  /** Additional payment item */
  Additional: 'ADDITIONAL',
  /** Original payment item */
  Original: 'ORIGINAL'
} as const;

export type EnterpriseContract_PaymentItemType = typeof EnterpriseContract_PaymentItemType[keyof typeof EnterpriseContract_PaymentItemType];
/** Payment receipt information for enterprise contract */
export type EnterpriseContract_PaymentReceipt = {
  __typename?: 'EnterpriseContract_PaymentReceipt';
  /** Currency code (e.g., USD) */
  currencyCode: Scalars['String'];
  /** Invoice number (if available) */
  invoiceNumber?: Maybe<Scalars['String']>;
  /** Line items in the payment receipt */
  items: Array<EnterpriseContract_PaymentItem>;
  /** Total amount paid */
  totalAmount: Scalars['Float'];
  /** Transaction metadata list */
  transactionMetaItems: Array<EnterpriseContract_TransactionMeta>;
};

/**
 * Names that identify price mappings for self-serve contracts, where a price mapping defines the
 * per-user cost of a contract based on the contract's courses per user limit.
 */
export const EnterpriseContract_PriceMappingNameType = {
  /**
   * The name of the price mappings introduced in December 2017 to increase the one course per user
   * price from $100 to $110.
   */
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  /**
   * The name of the price mappings used for the launch of web enabled sales, which was late
   * extended to include unlimited courses per user.
   */
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EnterpriseContract_PriceMappingNameType = typeof EnterpriseContract_PriceMappingNameType[keyof typeof EnterpriseContract_PriceMappingNameType];
/** Program Migration Configuration specifying how a program should be migrated to the new contract */
export type EnterpriseContract_ProgramMigrationConfiguration = {
  /** Enrollment cutoff date (required if enrollmentMigrationConfiguration is AFTER_CUTOFF_DATE) */
  enrollmentCutoffDate?: InputMaybe<Scalars['DateTime']>;
  /** Configuration for migrating program enrollments */
  enrollmentMigrationConfiguration: EnterpriseContract_EnrollmentMigrationConfiguration;
  /** Configuration for migrating program invitations */
  invitationMigrationConfiguration: EnterpriseContract_InvitationMigrationConfiguration;
  /** Configuration for migrating program memberships */
  membershipMigrationConfiguration: EnterpriseContract_MembershipMigrationConfiguration;
  /** The ID of the program being migrated to a new contract */
  programId: Scalars['ID'];
  /** Selected user course enrollments (required if membershipMigrationConfiguration is SELECTED and enrollmentMigrationConfiguration is SELECTED) */
  selectedUserCourseEnrollments?: InputMaybe<Array<EnterpriseContract_UserCourseEnrollment>>;
  /** Flag to skip old roster cleanup */
  skipOldRosterCleanup?: Scalars['Boolean'];
};

/** Represents a program restoration configuration when restore contract. */
export type EnterpriseContract_ProgramRestorationConfigurations = {
  /** Enrollment Restoration Configuration. */
  enrollmentRestorationConfiguration: EnterpriseContract_EnrollmentRestorationConfiguration;
  /** Invitation Restoration Configuration. */
  invitationRestorationConfiguration: EnterpriseContract_InvitationRestorationConfiguration;
  /** Membership Restoration Configuration. */
  membershipRestorationConfiguration: EnterpriseContract_MembershipRestorationConfiguration;
  /** Program ID to restore. */
  programId: Scalars['ID'];
  /** Required if membershipMigrationConfiguration = SELECTED and enrollmentMigrationConfiguration = Selected. */
  selectedUserCourseEnrollments?: InputMaybe<Array<EnterpriseContract_UserCourseEnrollment>>;
};

/** Promotion information */
export type EnterpriseContract_PromotionInfo = {
  __typename?: 'EnterpriseContract_PromotionInfo';
  /** Discount amount */
  discountAmount?: Maybe<Scalars['Float']>;
  /** Discount percentage */
  discountPercent: Scalars['Int'];
  /** Enterprise promotion ID */
  enterprisePromotionId: Scalars['ID'];
  /** Promotion ID */
  promotionId: Scalars['ID'];
  /** Promotion name */
  promotionName: Scalars['String'];
};

/** Input parameters for EnterpriseContract_ProvisioningContract mutation. */
export type EnterpriseContract_ProvisionRenewalContractInput = {
  /** Account Group of the Salesforce case, one of C4B, C4C & C4G. */
  accountGroup?: InputMaybe<EnterpriseContract_ContractAccountGroup>;
  /** Flag to determine if the original contract should be archived */
  archiveContract?: Scalars['Boolean'];
  /** The billing type for the renewed contract */
  billingType: EnterpriseContract_BillingType;
  /** The contract limits for the renewed contract */
  contractLimits: EnterpriseContract_ContractLimitsInput;
  /**
   * For a C4G accounts, there can be multiple types of deals. Null is allowed for C4B and C4C,
   * test and WES contracts.
   */
  dealType?: InputMaybe<EnterpriseContract_ContractDealType>;
  /** The duration of the renewed contract in months (optional) */
  durationInMonths?: InputMaybe<Scalars['Int']>;
  /** Flag to determine if this is a real contract or a test contract */
  isReal?: Scalars['Boolean'];
  /** A custom percentage recycling allowed in the contract. */
  licenseRecycleLimitPercent?: InputMaybe<Scalars['String']>;
  /**
   * Whether the customer has agreed to license recycle terms & conditions while signing the contract.
   * Null is allowed for the test and WES contracts
   */
  licenseRecycleTncEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The limit type for the renewed contract */
  limitType: EnterpriseContract_ContractLimitType;
  /** The name of the renewed contract (optional) */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the original contract being renewed */
  originalContractId: Scalars['ID'];
  /** Program migration configurations (optional) */
  programMigrationConfigurations?: InputMaybe<Array<EnterpriseContract_ProgramMigrationConfiguration>>;
  /** The activation date for the renewed contract (optional) */
  renewalContractActivationDate?: InputMaybe<Scalars['DateTime']>;
  /** The Salesforce case number (optional) */
  salesforceCaseNumber?: InputMaybe<Scalars['String']>;
  /** Flag to determine if membership deletion notifications should be sent */
  sendMembershipDeletionNotification?: Scalars['Boolean'];
  /** The tag for the renewed contract (optional) */
  tag?: InputMaybe<Scalars['String']>;
  /** The ID of the third-party organization */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Response for EnterpriseContract_ProvisioningContract mutation operation */
export type EnterpriseContract_ProvisionRenewalContractResult = EnterpriseContract_ProvisioningContractFailure | EnterpriseContract_ProvisioningContractSuccess;

/** Response for failed EnterpriseContract_ProvisioningContract mutation operation */
export type EnterpriseContract_ProvisioningContractFailure = {
  __typename?: 'EnterpriseContract_ProvisioningContractFailure';
  /** Mutation Error */
  error: EnterpriseContract_ProvisioningError;
};

/** Response for successful EnterpriseContract_ProvisioningContract mutation operation */
export type EnterpriseContract_ProvisioningContractSuccess = {
  __typename?: 'EnterpriseContract_ProvisioningContractSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Enum representing possible errors during contract provisioning */
export const EnterpriseContract_ProvisioningError = {
  /** Renewal contract activation date cannot be in the past */
  ActivationDateInPast: 'ACTIVATION_DATE_IN_PAST',
  /** Renewal contract activation date cannot be after the original contract end date */
  ActivationDateTooFarInFuture: 'ACTIVATION_DATE_TOO_FAR_IN_FUTURE',
  /** Failed to create contract migration */
  ContractMigrationCreationFailed: 'CONTRACT_MIGRATION_CREATION_FAILED',
  /** Original contract not found */
  ContractNotFound: 'CONTRACT_NOT_FOUND',
  /** Internal error */
  InternalError: 'INTERNAL_ERROR',
  /** Renewal contract coursesPerUserLimit must be strictly greater than or equal to the original contract coursesPerUserLimit */
  InvalidCoursesPerUserLimit: 'INVALID_COURSES_PER_USER_LIMIT',
  /** Renewal contract enrollment cap limit must be strictly greater than or equal to the original enrollment cap limit */
  InvalidEnrollmentCapLimit: 'INVALID_ENROLLMENT_CAP_LIMIT',
  /** Renewal contract user limit must be strictly greater than or equal to the original contract user limit */
  InvalidUserLimit: 'INVALID_USER_LIMIT',
  /** Failed to provision the new contract */
  NewContractProvisioningFailed: 'NEW_CONTRACT_PROVISIONING_FAILED'
} as const;

export type EnterpriseContract_ProvisioningError = typeof EnterpriseContract_ProvisioningError[keyof typeof EnterpriseContract_ProvisioningError];
/**
 * Recorded contract refund information.
 * Based on RecordedContractRefund class in Scala.
 */
export type EnterpriseContract_RecordedContractRefund = {
  __typename?: 'EnterpriseContract_RecordedContractRefund';
  /** The cart ID associated with the refund. */
  cartId: Scalars['ID'];
  /** The enterprise contract ID that was refunded. */
  contractId: EnterpriseContract_EnterpriseContract;
  /** Whether this refund was previously recorded. */
  previouslyRecorded: Scalars['Boolean'];
};

/**
 * Input for processing an enterprise contract refund.
 * Based on EnterpriseContractRefundRequest class in Scala.
 */
export type EnterpriseContract_RefundContractInput = {
  /**
   * Field for skipping validation in the checkout flow which includes checks like
   * determining if a refund is within the 14 day window.
   * Validations should only be bypassed for exceptional cases.
   */
  bypassValidation?: Scalars['Boolean'];
  /** The enterprise contract ID to refund. */
  enterpriseContractId: Scalars['ID'];
};

/** Result of processing an enterprise contract refund. */
export type EnterpriseContract_RefundContractResult = {
  __typename?: 'EnterpriseContract_RefundContractResult';
  /**
   * Indicates the operation completed successfully.
   * GraphQL types must include at least one field, so a success indicator is defined here.
   */
  success: Scalars['Boolean'];
};

/** Self-serve Enterprise Contract Properties */
export type EnterpriseContract_SelfServeEnterpriseContractProperties = {
  __typename?: 'EnterpriseContract_SelfServeEnterpriseContractProperties';
  /** Backup payment wallet IDs */
  backupPaymentWalletIds?: Maybe<Array<Scalars['ID']>>;
  /** Saved payment information to be used for recurring payments */
  paymentWalletId?: Maybe<Scalars['Int']>;
  /**
   * The name of the price mappings used for this contract. If None, then the original price
   * mapping scheme (ORIGINAL_RELEASE_MAPPINGS) is assumed.
   */
  priceMappingName?: Maybe<EnterpriseContract_PriceMappingNameType>;
};

/** Represents the options for enterprise contract terminated reason type. */
export const EnterpriseContract_TerminatedReasonType = {
  /**
   * WES Contracts only.
   * Terminate the contract since it has reached its end date. Applies to legacy contracts that were
   * created with an endsAt and auto-renewable contracts that disable auto-renew and are therefore
   * updated to have an endsAt.
   */
  ContractEndDate: 'CONTRACT_END_DATE',
  /** Terminate the contract since it is manually downgraded. */
  Downgraded: 'DOWNGRADED',
  /** WES free trial contracts that have been terminated due to first payment failure at the end of the trial period. */
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  /** WES free trial contracts that have been terminated due to disabling auto-renew and reaching its end date. */
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  /** Used for terminating the contract as a side-effect if the initial invoice was voided. */
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  /** For WES contracts that fail first payment checkout. */
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  /**
   * Direct Sales Contracts only.
   * Terminate the contract since its state was migrated to a new contract.
   */
  Migrated: 'MIGRATED',
  /**
   * WES Contracts with QUARTERLY billing type only.
   * Terminate the contract after it is past the grace period for installment payment.
   */
  MissingPayment: 'MISSING_PAYMENT',
  /**
   * WES Contracts only.
   * Terminate the contract since it was refunded
   */
  Refunded: 'REFUNDED',
  /**
   * WES Contracts only.
   * Terminate the contract after it is past the grace period for renewal payment.
   */
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EnterpriseContract_TerminatedReasonType = typeof EnterpriseContract_TerminatedReasonType[keyof typeof EnterpriseContract_TerminatedReasonType];
/** Transaction metadata for an enterprise contract payment */
export type EnterpriseContract_TransactionMeta = {
  __typename?: 'EnterpriseContract_TransactionMeta';
  /** Base unit price in local currency */
  baseUnitPriceInLocal?: Maybe<Scalars['Float']>;
  /** Discounted unit price in local currency */
  discountedUnitPriceInLocal?: Maybe<Scalars['Float']>;
  /** Number of licenses in this transaction */
  numberOfLicenses?: Maybe<Scalars['Int']>;
};

/** Input paramaters for RestoreContractJob. */
export type EnterpriseContract_TriggerRestoreJobInput = {
  /**
   * If true, contract tag validation will not be performed during roster creation.
   * This serves the use case where IMs want to verify migration results before archiving
   * the old contract.
   */
  bypassContractTagValidation: Scalars['Boolean'];
  /** Dry Run Mode */
  isDryRun: Scalars['Boolean'];
  /** Id of the new active contract which we restore into. */
  newContractId: Scalars['ID'];
  /** Id of the old terminated contract which we restore from. */
  oldContractId: Scalars['ID'];
  /** Program Restoration Configurations */
  programRestorationConfigurations: Array<InputMaybe<EnterpriseContract_ProgramRestorationConfigurations>>;
};

/** EnterpriseContract TriggerRestoreJobResult */
export type EnterpriseContract_TriggerRestoreJobResult = {
  __typename?: 'EnterpriseContract_TriggerRestoreJobResult';
  /** Flag indicating if a job is triggered successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** Response for failed EnterpriseContract_UpdateContractBillingType Mutation operation */
export type EnterpriseContract_UpdateContractBillingTypeFailure = {
  __typename?: 'EnterpriseContract_UpdateContractBillingTypeFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_UpdateContractBillingType Mutation. */
export type EnterpriseContract_UpdateContractBillingTypeInput = {
  /** The billing type for this particular contract to be updated to */
  billingType: EnterpriseContract_BillingType;
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
};

/** Response for EnterpriseContract_UpdateContractBillingType Mutation operation */
export type EnterpriseContract_UpdateContractBillingTypeResult = EnterpriseContract_UpdateContractBillingTypeFailure | EnterpriseContract_UpdateContractBillingTypeSuccess;

/** Response for successful EnterpriseContract_UpdateContractBillingType Mutation operation */
export type EnterpriseContract_UpdateContractBillingTypeSuccess = {
  __typename?: 'EnterpriseContract_UpdateContractBillingTypeSuccess';
  /** The updated Enterprise Contract */
  contract: EnterpriseContract_EnterpriseContract;
};

/** Response for failed EnterpriseContract_UpdateContractEndsAt mutation operation */
export type EnterpriseContract_UpdateContractEndsAtFailure = {
  __typename?: 'EnterpriseContract_UpdateContractEndsAtFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_UpdateContractEndsAt mutation. */
export type EnterpriseContract_UpdateContractEndsAtInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract termination date/time */
  endsAt: Scalars['DateTime'];
};

/** Response for EnterpriseContract_UpdateContractEndsAt mutation operation */
export type EnterpriseContract_UpdateContractEndsAtResult = EnterpriseContract_UpdateContractEndsAtFailure | EnterpriseContract_UpdateContractEndsAtSuccess;

/** Response for successful EnterpriseContract_UpdateContractEndsAt mutation operation */
export type EnterpriseContract_UpdateContractEndsAtSuccess = {
  __typename?: 'EnterpriseContract_UpdateContractEndsAtSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Response for failed EnterpriseContract_UpdateContractLimits mutation operation */
export type EnterpriseContract_UpdateContractLimitsFailure = {
  __typename?: 'EnterpriseContract_UpdateContractLimitsFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_UpdateContractLimits mutation. */
export type EnterpriseContract_UpdateContractLimitsInput = {
  /**
   * A boolean flag where true implies the user's intent to change the contract limit type.
   * When false, the API will reject the request if the provided limitType does not match the
   * current contract's limit type
   */
  changeLimitType?: Scalars['Boolean'];
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract limit type for the contract to be updated to */
  contractLimitType: EnterpriseContract_ContractLimitType;
  /** Optional enterprise promotion id for upsell flows. */
  enterprisePromotionId?: InputMaybe<Scalars['ID']>;
  /**
   * Set to a positive value to set new courses per user limit. If omitted, limit will be unchanged.
   * - No value expected (omit field) for NO_LIMIT contract type
   * - To enable unlimited courses per user, Set to 0
   */
  newCoursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /**
   * The desired enrollment limit value to configure,
   * - no value expected (omit field) for NO_LIMIT, and USER_LICENSE contract types
   */
  newEnrollmentLimitValue?: InputMaybe<Scalars['Int']>;
  /**
   * The desired license limit value to configure,
   * - No value expected (omit field) for NO_LIMIT, and ENROLLMENT_CAP contract types
   */
  newUserLicenseLimitValue?: InputMaybe<Scalars['Int']>;
  /**
   * Used to update limits for WES contracts,
   * - No value expected (omit field) for direct sales contracts
   */
  updateCost?: InputMaybe<EnterpriseContract_UpdateCostInput>;
};

/** Response for EnterpriseContract_UpdateContractLimits mutation operation */
export type EnterpriseContract_UpdateContractLimitsResult = EnterpriseContract_UpdateContractLimitsFailure | EnterpriseContract_UpdateContractLimitsSuccess;

/** Response for successful EnterpriseContract_UpdateContractLimits mutation operation */
export type EnterpriseContract_UpdateContractLimitsSuccess = {
  __typename?: 'EnterpriseContract_UpdateContractLimitsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Response for failed EnterpriseContract_UpdateContractName mutation operation */
export type EnterpriseContract_UpdateContractNameFailure = {
  __typename?: 'EnterpriseContract_UpdateContractNameFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_UpdateContractName mutation. */
export type EnterpriseContract_UpdateContractNameInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The contract name for the contract to be updated to */
  name: Scalars['String'];
};

/** Response for EnterpriseContract_UpdateContractName mutation operation */
export type EnterpriseContract_UpdateContractNameResult = EnterpriseContract_UpdateContractNameFailure | EnterpriseContract_UpdateContractNameSuccess;

/** Response for successful EnterpriseContract_UpdateContractName mutation operation */
export type EnterpriseContract_UpdateContractNameSuccess = {
  __typename?: 'EnterpriseContract_UpdateContractNameSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Response for failed EnterpriseContract_UpdateContractPurpose mutation */
export type EnterpriseContract_UpdateContractPurposeFailure = {
  __typename?: 'EnterpriseContract_UpdateContractPurposeFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input for EnterpriseContract_UpdateContractPurpose */
export type EnterpriseContract_UpdateContractPurposeInput = {
  /** Id of the contract to be updated */
  contractId: Scalars['ID'];
  /** The updated contract purpose, can be set to NULL to remove the existing value. */
  purpose?: InputMaybe<EnterpriseContract_ContractPurpose>;
};

/** Response for EnterpriseContract_UpdateContractPurpose mutation */
export type EnterpriseContract_UpdateContractPurposeResult = EnterpriseContract_UpdateContractPurposeFailure | EnterpriseContract_UpdateContractPurposeSuccess;

/** Response for successful EnterpriseContract_UpdateContractPurpose mutation */
export type EnterpriseContract_UpdateContractPurposeSuccess = {
  __typename?: 'EnterpriseContract_UpdateContractPurposeSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input parameters for EnterpriseContract_UpdateContractLimits mutation. */
export type EnterpriseContract_UpdateCostInput = {
  /**
   * Amount that will be paid over the remaining installments, generally calculated as: (# users added) * (# of installments remaining) * (cost / installment for course limit)
   * - Decimal number represented as String e.g "126.75"
   */
  amountDueOverInstallment: Scalars['String'];
  /**
   * Amount due immediately at time of update, calculated based off time left in the current period and the annual cost for the course limit
   * - Decimal number represented as String e.g "126.75"
   */
  amountDueToday: Scalars['String'];
  /**
   * Amount due over installment
   * - Decimal number represented as String e.g "126.75"
   */
  rawAmountDueOverInstallment?: InputMaybe<Scalars['String']>;
  /**
   * Amount due today
   * - Decimal number represented as String e.g "126.75"
   */
  rawAmountDueToday?: InputMaybe<Scalars['String']>;
};

/** Parameters for the `updateNextPaymentAt` action. */
export type EnterpriseContract_UpdateNextPaymentAtParams = {
  /** The new next-payment date to set on the payment. */
  nextPaymentAt: Scalars['DateTime'];
  /** The ID of the enterprise contract payment whose next payment date is being updated. */
  paymentId: Scalars['ID'];
};

/** Response for failed EnterpriseContract_UpdateScheduledActivation mutation operation */
export type EnterpriseContract_UpdateScheduledActivationFailure = {
  __typename?: 'EnterpriseContract_UpdateScheduledActivationFailure';
  /** Mutation Errors */
  errors: Array<EnterpriseContract_ValidationError>;
};

/** Input parameters for EnterpriseContract_UpdateScheduledActivation mutation. */
export type EnterpriseContract_UpdateScheduledActivationInput = {
  /** Id of the contract to update scheduled activation */
  contractId: Scalars['ID'];
  /** Scheduled activation timestamp. Set to null to cancel scheduled activation. */
  scheduledActivationAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response for EnterpriseContract_UpdateScheduledActivation mutation operation */
export type EnterpriseContract_UpdateScheduledActivationResult = EnterpriseContract_UpdateScheduledActivationFailure | EnterpriseContract_UpdateScheduledActivationSuccess;

/** Response for successful EnterpriseContract_UpdateScheduledActivation mutation operation */
export type EnterpriseContract_UpdateScheduledActivationSuccess = {
  __typename?: 'EnterpriseContract_UpdateScheduledActivationSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Parameters for the `updateTermEndsAt` action. */
export type EnterpriseContract_UpdateTermEndsAtParams = {
  /**
   * Number of days to add to the term's current end date.
   * The resulting end date is computed server-side as currentTermEndsAt + numberOfDays.
   * Must be positive.
   */
  numberOfDays: Scalars['Int'];
  /** ID of the term to be updated. When omitted, the contract's latest term (by start date) is used. */
  termId?: InputMaybe<Scalars['ID']>;
};

/** Represents a user course pair to identify enrollment. */
export type EnterpriseContract_UserCourseEnrollment = {
  /** When migrating ALL or NONE enrollments, the courseSlug should be empty. */
  courseSlug?: InputMaybe<Scalars['String']>;
  /** The user email for enrollment selection */
  userEmail: Scalars['String'];
};

/** Error for failed contract validation during pause contract mutation operation */
export type EnterpriseContract_ValidationError = EnterpriseContract_MutationError & Error & {
  __typename?: 'EnterpriseContract_ValidationError';
  /** Message that provides more details about the error which caused a mutation failure */
  message: Scalars['String'];
};

/** Volume tier: user count range (inclusive) and unit price for that tier. */
export type EnterpriseContract_VolumeTier = {
  __typename?: 'EnterpriseContract_VolumeTier';
  /** Discount percentage for this tier (e.g. volume discount at this tier). */
  discountPercent: Scalars['Float'];
  /** Lower bound (inclusive) of the user/license count range for this tier. */
  lowerLimit: Scalars['Int'];
  /** Unit price for this tier. */
  unitPrice: Scalars['Float'];
  /** Upper bound (inclusive) of the user/license count range for this tier. */
  upperLimit: Scalars['Int'];
};

/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractsQueries = {
  __typename?: 'EnterpriseContractsQueries';
  /** Retrieves an EnterpriseContract by its ID. */
  queryContractById?: Maybe<EnterpriseContract_EnterpriseContract>;
  /** Retrieves an EnterpriseContract by its ID. */
  queryContractByIds: Array<EnterpriseContract_EnterpriseContract>;
  /** Retrieves an EnterpriseContract by Third Party ID. */
  queryContractsByOrgId: EnterpriseContract_EnterpriseContractPaginatedResult;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractsQueriesQueryContractByIdArgs = {
  id: Scalars['ID'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractsQueriesQueryContractByIdsArgs = {
  id: Array<Scalars['ID']>;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseContractsQueriesQueryContractsByOrgIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  limit?: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
};

/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1 = {
  __typename?: 'EnterpriseContractsV1';
  billingSystemType: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType;
  billingType: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType;
  contractState: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState;
  contractTags?: Maybe<EnterpriseContractTagsV1Connection>;
  contractType: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType;
  countryIsoCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  currencyCode?: Maybe<Scalars['String']>;
  durationInMonths?: Maybe<Scalars['Int']>;
  endedAt?: Maybe<Scalars['Float']>;
  endsAt?: Maybe<Scalars['Float']>;
  enterpriseContractId: Scalars['String'];
  hardPausedAt?: Maybe<Scalars['Float']>;
  /** A unique ID for a Contract */
  id: Scalars['String'];
  isPaused: Scalars['Boolean'];
  isReal: Scalars['Boolean'];
  limitType: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType;
  limits: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimits;
  name?: Maybe<Scalars['String']>;
  planId: Scalars['Float'];
  policiesByRenewalContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  policiesByUpsellContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  policiesForContract?: Maybe<EnterpriseContractPoliciesV1Connection>;
  promotionId: Scalars['Int'];
  properties?: Maybe<EnterpriseContractsV1_Properties>;
  purpose?: Maybe<Scalars['String']>;
  salesforceCaseNumber?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['Float']>;
  terminationReason?: Maybe<EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason>;
  terms: Array<Maybe<EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTerm>>;
  thirdPartyOrganizationId: Scalars['String'];
  userRosters?: Maybe<EnterpriseUserRostersV1Connection>;
  utilization?: Maybe<EnterpriseContractUtilizationsV1>;
  value: Scalars['String'];
};


/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1ContractTagsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1PoliciesByRenewalContractArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1PoliciesByUpsellContractArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1PoliciesForContractArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


/** A reference to naptime EnterpriseContract stub - used for federation */
export type EnterpriseContractsV1UserRostersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseContractsV1ByThirdPartyOrganization = {
  __typename?: 'EnterpriseContractsV1ByThirdPartyOrganization';
  connection?: Maybe<EnterpriseContractsV1Connection>;
  id: Scalars['String'];
  includeExpired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractsV1ByThirdPartyOrganizationAndContractType = {
  __typename?: 'EnterpriseContractsV1ByThirdPartyOrganizationAndContractType';
  connection?: Maybe<EnterpriseContractsV1Connection>;
  contractType: Scalars['String'];
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractsV1Connection = {
  __typename?: 'EnterpriseContractsV1Connection';
  elements: Array<Maybe<EnterpriseContractsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseContractsV1GetContractsByCurrentTermEndBetweenRange = {
  __typename?: 'EnterpriseContractsV1GetContractsByCurrentTermEndBetweenRange';
  billingSystemType?: Maybe<Scalars['String']>;
  connection?: Maybe<EnterpriseContractsV1Connection>;
  from: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  to: Scalars['String'];
};

export type EnterpriseContractsV1GetNonTerminatedFreeTrialContracts = {
  __typename?: 'EnterpriseContractsV1GetNonTerminatedFreeTrialContracts';
  connection?: Maybe<EnterpriseContractsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseContractsV1Resource = {
  __typename?: 'EnterpriseContractsV1Resource';
  byThirdPartyOrganization?: Maybe<EnterpriseContractsV1Connection>;
  byThirdPartyOrganizationAndContractType?: Maybe<EnterpriseContractsV1Connection>;
  get?: Maybe<EnterpriseContractsV1>;
  getContractsByCurrentTermEndBetweenRange?: Maybe<EnterpriseContractsV1Connection>;
  getNonTerminatedFreeTrialContracts?: Maybe<EnterpriseContractsV1Connection>;
  multiGet?: Maybe<EnterpriseContractsV1Connection>;
};


export type EnterpriseContractsV1ResourceByThirdPartyOrganizationArgs = {
  id: Scalars['String'];
  includeExpired?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceByThirdPartyOrganizationAndContractTypeArgs = {
  contractType: Scalars['String'];
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceGetContractsByCurrentTermEndBetweenRangeArgs = {
  billingSystemType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};


export type EnterpriseContractsV1ResourceGetNonTerminatedFreeTrialContractsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseContractsV1ResourceMutations = {
  __typename?: 'EnterpriseContractsV1ResourceMutations';
  activate?: Maybe<Scalars['JSON']>;
  create?: Maybe<EnterpriseContractsV1Connection>;
  debugTransitionState?: Maybe<Scalars['JSON']>;
  delete?: Maybe<EnterpriseContractsV1Connection>;
  directCreateWESContract?: Maybe<Scalars['JSON']>;
  downgrade?: Maybe<Scalars['JSON']>;
  initializeContractStartAndGet?: Maybe<Scalars['JSON']>;
  pause?: Maybe<Scalars['JSON']>;
  revokeContract?: Maybe<Scalars['JSON']>;
  revokeWESContract?: Maybe<Scalars['JSON']>;
  updateContractBillingType?: Maybe<Scalars['JSON']>;
  updateContractEndsAt?: Maybe<Scalars['JSON']>;
  updateContractLimitsV3?: Maybe<Scalars['JSON']>;
  updateContractName?: Maybe<Scalars['JSON']>;
  updateEndsAt?: Maybe<Scalars['JSON']>;
  updateIsReal?: Maybe<Scalars['JSON']>;
  updatePlanId?: Maybe<Scalars['JSON']>;
  updateStandardContractBillingType?: Maybe<Scalars['JSON']>;
  updateStartsAt?: Maybe<Scalars['JSON']>;
  updateWalletId?: Maybe<Scalars['JSON']>;
};


export type EnterpriseContractsV1ResourceMutationsDebugTransitionStateArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsDowngradeArgs = {
  id: Scalars['String'];
  sendMembershipDeletionNotification?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseContractsV1ResourceMutationsInitializeContractStartAndGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsRevokeContractArgs = {
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  revokeTime?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceMutationsRevokeWesContractArgs = {
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceMutationsUpdateContractBillingTypeArgs = {
  billingType: Scalars['String'];
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateContractEndsAtArgs = {
  endDate: Scalars['String'];
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateContractLimitsV3Args = {
  contractId: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateContractNameArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateEndsAtArgs = {
  contractId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
};


export type EnterpriseContractsV1ResourceMutationsUpdateIsRealArgs = {
  id: Scalars['String'];
  isReal: Scalars['Boolean'];
  notes?: InputMaybe<Scalars['String']>;
  skipValidation?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseContractsV1ResourceMutationsUpdatePlanIdArgs = {
  contractId: Scalars['String'];
  planId: Scalars['Float'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateStandardContractBillingTypeArgs = {
  billingType: Scalars['String'];
  id: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateStartsAtArgs = {
  contractId: Scalars['String'];
  startsAt: Scalars['String'];
};


export type EnterpriseContractsV1ResourceMutationsUpdateWalletIdArgs = {
  id: Scalars['String'];
  walletId: Scalars['String'];
};

export type EnterpriseContractsV1_InvoiceBilledContractPropertiesMember = {
  __typename?: 'EnterpriseContractsV1_invoiceBilledContractPropertiesMember';
  invoiceBilledContractProperties: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_InvoiceBilledContractProperties;
};

export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = {
  Active: 'ACTIVE',
  Created: 'CREATED',
  Expired: 'EXPIRED',
  Paused: 'PAUSED',
  Terminated: 'TERMINATED'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractState];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = {
  ContractEndDate: 'CONTRACT_END_DATE',
  Downgraded: 'DOWNGRADED',
  FreeTrialConversionFailure: 'FREE_TRIAL_CONVERSION_FAILURE',
  FreeTrialExpired: 'FREE_TRIAL_EXPIRED',
  InitialInvoiceVoided: 'INITIAL_INVOICE_VOIDED',
  InitialPaymentFailed: 'INITIAL_PAYMENT_FAILED',
  Migrated: 'MIGRATED',
  MissingPayment: 'MISSING_PAYMENT',
  Refunded: 'REFUNDED',
  RenewalGracePeriodExceeded: 'RENEWAL_GRACE_PERIOD_EXCEEDED'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractTerminatedReason];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = {
  SelfServe: 'SELF_SERVE',
  Standard: 'STANDARD'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractType];
/** EnterpriseContract's can be paid for in a variety of different ways. The EnterpriseContractBillingSystemType is a finite list of the billing methods available for both direct sales and WES contracts. */
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = {
  AutomatedInvoice: 'AUTOMATED_INVOICE',
  AutomatedTransactionPayment: 'AUTOMATED_TRANSACTION_PAYMENT',
  NonBillable: 'NON_BILLABLE',
  OffPlatformInvoice: 'OFF_PLATFORM_INVOICE'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Billing_EnterpriseContractBillingSystemType];
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = {
  EnrollmentCap: 'ENROLLMENT_CAP',
  NoLimit: 'NO_LIMIT',
  UserLicense: 'USER_LICENSE',
  UserLicenseWithEnrollmentCap: 'USER_LICENSE_WITH_ENROLLMENT_CAP'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimitType];
export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Limits_EnterpriseContractLimits = {
  __typename?: 'EnterpriseContractsV1_org_coursera_product_enterprise_contract_limits_EnterpriseContractLimits';
  coursesPerUserLimit?: Maybe<Scalars['Int']>;
  enrollmentCapLimit?: Maybe<Scalars['Int']>;
  userLimit?: Maybe<Scalars['Int']>;
};

/** Names that identify price mappings for self-serve contracts, where a price mapping defines the per-user cost of a contract based on the contract's courses per user limit. */
export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = {
  OneCourseValueIncreaseMappings: 'ONE_COURSE_VALUE_INCREASE_MAPPINGS',
  OriginalReleaseMappings: 'ORIGINAL_RELEASE_MAPPINGS'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName];
/** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_INVOICE */
export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_InvoiceBilledContractProperties = {
  __typename?: 'EnterpriseContractsV1_org_coursera_product_enterprise_contract_properties_InvoiceBilledContractProperties';
  customerId: Scalars['String'];
  paymentProcessorId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

/** Extra metadata specific to EnterpriseContractType.SELF_SERVE contracts being billed by EnterpriseContractBillingType.AUTOMATED_TRANSACTION_PAYMENT */
export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_SelfServeEnterpriseContractProperties = {
  __typename?: 'EnterpriseContractsV1_org_coursera_product_enterprise_contract_properties_SelfServeEnterpriseContractProperties';
  paymentWalletId: Scalars['Float'];
  priceMappingName?: Maybe<EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Pricing_EnterpriseContractPriceMappingName>;
};

/** Represents the source of truth for data related to each individual term of a contract. This model and its relations contain all information needed to accurately revshare enterprise contracts. EnterpriseContractPayments have a termId that references one instance of a term. The total of those payments represents the revenue that should be recognized over this contract's startsAt and endsAt. EnterpriseContractTransactions also contain a termId reference and their sum represents the contract limits for a term, which can differ between terms. Enrollments data can also be gotten from promotionId, but it's not currently implemented like this. */
export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTerm = {
  __typename?: 'EnterpriseContractsV1_org_coursera_product_enterprise_term_EnterpriseContractTerm';
  endsAt?: Maybe<Scalars['Float']>;
  enterpriseContractId: Scalars['String'];
  fxRateId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  promotionId: Scalars['Int'];
  startsAt: Scalars['Float'];
  termTag?: Maybe<EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag>;
  unitPrice?: Maybe<Scalars['String']>;
  writtenAt: Scalars['Float'];
};

export const EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = {
  C4TFreeTrial: 'C4T_FREE_TRIAL'
} as const;

export type EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag = typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag[keyof typeof EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Term_EnterpriseContractTermTag];
export type EnterpriseContractsV1_Properties = EnterpriseContractsV1_InvoiceBilledContractPropertiesMember | EnterpriseContractsV1_SelfServePropertiesMember;

export type EnterpriseContractsV1_SelfServePropertiesMember = {
  __typename?: 'EnterpriseContractsV1_selfServePropertiesMember';
  selfServeProperties: EnterpriseContractsV1_Org_Coursera_Product_Enterprise_Contract_Properties_SelfServeEnterpriseContractProperties;
};

/** Queries for Enterprise Coupons */
export type EnterpriseCouponQueries = {
  __typename?: 'EnterpriseCouponQueries';
  /** Fetches enterprise coupons by contract ID. */
  findByContract: EnterpriseCoupon_FindByContractResult;
};


/** Queries for Enterprise Coupons */
export type EnterpriseCouponQueriesFindByContractArgs = {
  contractId: Scalars['ID'];
};

/** Input parameters for EnterpriseCoupon_createForRenewal mutation. */
export type EnterpriseCoupon_CreateForRenewalInput = {
  /** The ID of the enterprise contract. */
  enterpriseContractId: Scalars['ID'];
  /** The ID of the enterprise promotion. */
  enterprisePromotionId: Scalars['ID'];
};

/** Response type for EnterpriseCoupon_createForRenewal mutation. */
export type EnterpriseCoupon_CreateForRenewalResult = {
  __typename?: 'EnterpriseCoupon_CreateForRenewalResult';
  /** The details of the enterprise coupon. */
  enterpriseCoupon: EnterpriseCoupon_Details;
  /** The ID of the created renewal. */
  id: Scalars['ID'];
};

/** Details of the enterprise coupon. */
export type EnterpriseCoupon_Details = {
  __typename?: 'EnterpriseCoupon_Details';
  /** The ID of the cart. */
  cartId?: Maybe<Scalars['Int']>;
  /** The ID of the coupon. */
  couponId: Scalars['ID'];
  /** The ID of the enterprise contract. */
  enterpriseContractId?: Maybe<Scalars['ID']>;
  /** The ID of the enterprise contract term. */
  enterpriseContractTermId?: Maybe<Scalars['ID']>;
  /** The ID of the enterprise promotion. */
  enterprisePromotionId: Scalars['ID'];
  /** The ID of the third-party organization. */
  thirdPartyOrganizationId?: Maybe<Scalars['ID']>;
};

/** Represents the result of findByContract query. */
export type EnterpriseCoupon_FindByContractResult = {
  __typename?: 'EnterpriseCoupon_FindByContractResult';
  /** List containing enterprise coupons. */
  coupons: Array<EnterpriseCoupon_FindByContractResultItem>;
};

/** Represents an individual result item for findByContract query. */
export type EnterpriseCoupon_FindByContractResultItem = {
  __typename?: 'EnterpriseCoupon_FindByContractResultItem';
  /** Enterprise coupon details. */
  enterpriseCoupon: EnterpriseCoupon_Details;
  /** Result ID. */
  id: Scalars['ID'];
};

/** Queries for generating email content via a language model. */
export type EnterpriseEmailContentGenerationQueries = {
  __typename?: 'EnterpriseEmailContentGenerationQueries';
  /** Produces structured email fields from the caller prompt. Resolver implementation invokes the configured LLM. */
  generateEmailContent: EnterpriseEmailContentGeneration_Result;
};


/** Queries for generating email content via a language model. */
export type EnterpriseEmailContentGenerationQueriesGenerateEmailContentArgs = {
  input: EnterpriseEmailContentGeneration_Input;
};

/** Structured LLM output for email UI. */
export type EnterpriseEmailContentGeneration_Content = {
  __typename?: 'EnterpriseEmailContentGeneration_Content';
  /** Suggested email body text. */
  body: Scalars['String'];
  /** Suggested call-to-action button url. */
  buttonUrl: Scalars['String'];
  /** Suggested call-to-action text. */
  callToAction: Scalars['String'];
  /** True when generated copy is specific to a program or course enrollment context. */
  isEnrollmentSpecific: Scalars['Boolean'];
  /** Preset or template identifier suggested by the model. */
  preset: Scalars['String'];
  /** Suggested email subject line. */
  subject: Scalars['String'];
  /** Audience the generated copy is aimed at (e.g. inactive learners, joined learners). */
  targetAudience: Scalars['String'];
};

/** One key/value pair in additionalContext. */
export type EnterpriseEmailContentGeneration_ContextEntry = {
  /** Map key */
  key: Scalars['String'];
  /** Map value */
  value: Scalars['String'];
};

/** Generation failed (e.g. model error, timeout). */
export type EnterpriseEmailContentGeneration_Failure = {
  __typename?: 'EnterpriseEmailContentGeneration_Failure';
  /** Human-readable error description. */
  error: Scalars['String'];
};

/** Input for email content generation. */
export type EnterpriseEmailContentGeneration_Input = {
  /** Optional arbitrary string context as map entries (GraphQL has no native map type). */
  additionalContext?: InputMaybe<Array<EnterpriseEmailContentGeneration_ContextEntry>>;
  /** Primary admin prompt for email generation. */
  prompt: Scalars['String'];
};

/** Outcome of generateEmailContent: structured copy on success, or an error message on failure. */
export type EnterpriseEmailContentGeneration_Result = EnterpriseEmailContentGeneration_Failure | EnterpriseEmailContentGeneration_Success;

/** Successful LLM email generation. */
export type EnterpriseEmailContentGeneration_Success = {
  __typename?: 'EnterpriseEmailContentGeneration_Success';
  /** Generated email fields for the UI. */
  content: EnterpriseEmailContentGeneration_Content;
};

/** Queries for enterprise enrollment */
export type EnterpriseEnrollmentQueries = {
  __typename?: 'EnterpriseEnrollmentQueries';
  /**
   * Returns the best program to enroll a user in for a given product, using a cascading priority
   * algorithm based on membership, product availability, academic integrity features, and contract
   * expiry dates.
   */
  getBestProgramToEnroll: EnterpriseEnrollment_GetBestProgramToEnrollResult;
  /**
   * Returns the aggregated, deduplicated list of auto-enrolled courses across all programs in an
   * organization. Resolves the org slug to programs internally and fetches JoinProgramEvent
   * enrollment settings for each program. Powers the AutoenrolledCoursesModal on Unified Home.
   */
  getOrgAutoEnrolledCourses: EnterpriseEnrollment_GetOrgAutoEnrolledCoursesResponse;
  /**
   * Returns the paginated list of saved (bookmarked) products for the logged-in user within
   * the specified organization. Replaces ProgramCurriculumProductsV1Resource selected.
   */
  orgSavedProducts: EnterpriseEnrollment_OrgSavedProductsResult;
};


/** Queries for enterprise enrollment */
export type EnterpriseEnrollmentQueriesGetBestProgramToEnrollArgs = {
  input: EnterpriseEnrollment_GetBestProgramToEnrollInput;
};


/** Queries for enterprise enrollment */
export type EnterpriseEnrollmentQueriesGetOrgAutoEnrolledCoursesArgs = {
  input: EnterpriseEnrollment_GetOrgAutoEnrolledCoursesInput;
};


/** Queries for enterprise enrollment */
export type EnterpriseEnrollmentQueriesOrgSavedProductsArgs = {
  input: EnterpriseEnrollment_OrgSavedProductsInput;
};

/** Queries related to enrollment reports */
export type EnterpriseEnrollmentReportQueries = {
  __typename?: 'EnterpriseEnrollmentReportQueries';
  /** Get course enrollments by user and org. Result is filtered based on current user's permissions. */
  getCourseEnrollmentsByUserAndOrg?: Maybe<EnterpriseReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult>;
};


/** Queries related to enrollment reports */
export type EnterpriseEnrollmentReportQueriesGetCourseEnrollmentsByUserAndOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  epicEnabled?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** A course that is configured for auto-enrollment when a learner joins a program. */
export type EnterpriseEnrollment_AutoEnrolledCourse = {
  __typename?: 'EnterpriseEnrollment_AutoEnrolledCourse';
  /** The course configured for auto-enrollment. Resolved via federation. */
  course: Course_Course;
  /** The ID of the program that has this auto-enrollment setting configured. */
  programId: Scalars['ID'];
  /** The ID of the ProgramEnrollmentSetting record. */
  settingId: Scalars['ID'];
};

/** Failure result of the getBestProgramToEnroll query. */
export type EnterpriseEnrollment_GetBestProgramToEnrollFailure = {
  __typename?: 'EnterpriseEnrollment_GetBestProgramToEnrollFailure';
  /** The error code indicating why program selection failed. */
  error: EnterpriseEnrollment_ProgramSelectionError;
  /** A human-readable message providing additional context about the failure. */
  message: Scalars['String'];
};

/** Input for the getBestProgramToEnroll query. */
export type EnterpriseEnrollment_GetBestProgramToEnrollInput = {
  /** The third-party organization ID that scopes the program selection to a specific organization. */
  organizationId: Scalars['ID'];
  /** The ID of the product (course or specialization) the user is trying to enroll in. */
  productId: Scalars['ID'];
  /** The type of product the user is trying to enroll in. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/**
 * Result of the getBestProgramToEnroll query. Returns either a successful program selection
 * or a failure with an error code and message.
 */
export type EnterpriseEnrollment_GetBestProgramToEnrollResult = EnterpriseEnrollment_GetBestProgramToEnrollFailure | EnterpriseEnrollment_GetBestProgramToEnrollSuccess;

/** Successful result of the getBestProgramToEnroll query. */
export type EnterpriseEnrollment_GetBestProgramToEnrollSuccess = {
  __typename?: 'EnterpriseEnrollment_GetBestProgramToEnrollSuccess';
  /** The ID of the program selected as the best match for enrollment. */
  selectedProgramId: Scalars['ID'];
  /** The reason why this program was selected. */
  selectionReason: EnterpriseEnrollment_ProgramSelectionReason;
};

/** Input for the getOrgAutoEnrolledCourses query. */
export type EnterpriseEnrollment_GetOrgAutoEnrolledCoursesInput = {
  /**
   * When true, only returns courses the logged-in user is actually enrolled in.
   * Defaults to false, which returns all configured auto-enrollment courses.
   */
  includeEnrolledCoursesOnly?: Scalars['Boolean'];
  /** The organization slug used to resolve all programs in the org. */
  orgSlug: Scalars['String'];
};

/**
 * Response containing the aggregated, deduplicated list of auto-enrolled courses across all
 * programs in the organization.
 */
export type EnterpriseEnrollment_GetOrgAutoEnrolledCoursesResponse = {
  __typename?: 'EnterpriseEnrollment_GetOrgAutoEnrolledCoursesResponse';
  /** The deduplicated list of auto-enrolled courses across all programs in the org. */
  courses: Array<EnterpriseEnrollment_AutoEnrolledCourse>;
};

/** Error codes for the orgSaveProduct mutation. */
export const EnterpriseEnrollment_OrgSaveProductError = {
  /** The product is already saved (duplicate). */
  AlreadySaved: 'ALREADY_SAVED',
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** No consumable contract found for the user in this organization. */
  NoConsumableContract: 'NO_CONSUMABLE_CONTRACT',
  /** No programs found for the given organization slug. */
  ProgramNotFound: 'PROGRAM_NOT_FOUND'
} as const;

export type EnterpriseEnrollment_OrgSaveProductError = typeof EnterpriseEnrollment_OrgSaveProductError[keyof typeof EnterpriseEnrollment_OrgSaveProductError];
/** Failure result for the orgSaveProduct mutation. */
export type EnterpriseEnrollment_OrgSaveProductFailure = {
  __typename?: 'EnterpriseEnrollment_OrgSaveProductFailure';
  /** The error code indicating why the save failed. */
  error: EnterpriseEnrollment_OrgSaveProductError;
  /** A human-readable message providing additional context about the failure. */
  message: Scalars['String'];
};

/** Input for saving (bookmarking) a product. */
export type EnterpriseEnrollment_OrgSaveProductInput = {
  /** Organization slug. Server resolves programId, contractId, termId, and orgId from this. */
  orgSlug: Scalars['String'];
  /** The ID of the product (course or specialization) to save. */
  productId: Scalars['ID'];
  /** The type of product to save. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/** Result of the orgSaveProduct mutation. */
export type EnterpriseEnrollment_OrgSaveProductResult = EnterpriseEnrollment_OrgSaveProductFailure | EnterpriseEnrollment_OrgSaveProductSuccess;

/** Successful save result. */
export type EnterpriseEnrollment_OrgSaveProductSuccess = {
  __typename?: 'EnterpriseEnrollment_OrgSaveProductSuccess';
  /** The saved product record. */
  savedProduct: EnterpriseEnrollment_OrgSavedProduct;
};

/** A product saved (bookmarked) by a learner within an organization. */
export type EnterpriseEnrollment_OrgSavedProduct = {
  __typename?: 'EnterpriseEnrollment_OrgSavedProduct';
  /** The unique identifier of the saved product record. */
  id: Scalars['ID'];
  /**
   * The unified product card for rendering this saved product. Resolved via federation using
   * productId and productType. Returns null if the product has been delisted from the platform.
   */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** The ID of the saved product (course or specialization). */
  productId: Scalars['ID'];
  /** The type of saved product. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
  /** The program under which this save was recorded (resolved server-side from orgSlug). */
  programId: Scalars['ID'];
  /** When the product was saved. */
  savedAt?: Maybe<Scalars['DateTime']>;
};

/** Error codes for the orgSavedProducts query. */
export const EnterpriseEnrollment_OrgSavedProductsError = {
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** No programs found for the given organization slug. */
  ProgramNotFound: 'PROGRAM_NOT_FOUND'
} as const;

export type EnterpriseEnrollment_OrgSavedProductsError = typeof EnterpriseEnrollment_OrgSavedProductsError[keyof typeof EnterpriseEnrollment_OrgSavedProductsError];
/** Failure result for the orgSavedProducts query. */
export type EnterpriseEnrollment_OrgSavedProductsFailure = {
  __typename?: 'EnterpriseEnrollment_OrgSavedProductsFailure';
  /** The error code indicating why the query failed. */
  error: EnterpriseEnrollment_OrgSavedProductsError;
  /** A human-readable message providing additional context about the failure. */
  message: Scalars['String'];
};

/** Input for fetching org-scoped saved products. */
export type EnterpriseEnrollment_OrgSavedProductsInput = {
  /** Cursor for pagination. Omit for the first page. */
  cursor?: InputMaybe<Scalars['String']>;
  /** Maximum number of results per page. Default 8. */
  limit?: Scalars['Int'];
  /** Organization slug to scope the saved products query. */
  orgSlug: Scalars['String'];
};

/** Successful result containing paginated saved products. */
export type EnterpriseEnrollment_OrgSavedProductsPaginatedResult = {
  __typename?: 'EnterpriseEnrollment_OrgSavedProductsPaginatedResult';
  /** The list of saved products for the current page. */
  elements: Array<EnterpriseEnrollment_OrgSavedProduct>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Result of the orgSavedProducts query. */
export type EnterpriseEnrollment_OrgSavedProductsResult = EnterpriseEnrollment_OrgSavedProductsFailure | EnterpriseEnrollment_OrgSavedProductsPaginatedResult;

/** Error codes for the orgUnsaveProduct mutation. */
export const EnterpriseEnrollment_OrgUnsaveProductError = {
  /** An unexpected internal error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The product is not currently saved. */
  NotSaved: 'NOT_SAVED'
} as const;

export type EnterpriseEnrollment_OrgUnsaveProductError = typeof EnterpriseEnrollment_OrgUnsaveProductError[keyof typeof EnterpriseEnrollment_OrgUnsaveProductError];
/** Failure result for the orgUnsaveProduct mutation. */
export type EnterpriseEnrollment_OrgUnsaveProductFailure = {
  __typename?: 'EnterpriseEnrollment_OrgUnsaveProductFailure';
  /** The error code indicating why the unsave failed. */
  error: EnterpriseEnrollment_OrgUnsaveProductError;
  /** A human-readable message providing additional context about the failure. */
  message: Scalars['String'];
};

/** Input for removing a saved (bookmarked) product. */
export type EnterpriseEnrollment_OrgUnsaveProductInput = {
  /** Organization slug. */
  orgSlug: Scalars['String'];
  /** The ID of the product (course or specialization) to unsave. */
  productId: Scalars['ID'];
  /** The type of product to unsave. */
  productType: EnterpriseEnrollment_ProgramSelectionProductType;
};

/** Result of the orgUnsaveProduct mutation. */
export type EnterpriseEnrollment_OrgUnsaveProductResult = EnterpriseEnrollment_OrgUnsaveProductFailure | EnterpriseEnrollment_OrgUnsaveProductSuccess;

/** Successful unsave result. */
export type EnterpriseEnrollment_OrgUnsaveProductSuccess = {
  __typename?: 'EnterpriseEnrollment_OrgUnsaveProductSuccess';
  /** Placeholder field required by GraphQL for empty success types. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Error codes for program selection failures. */
export const EnterpriseEnrollment_ProgramSelectionError = {
  /** An unexpected internal error occurred during program selection. */
  InternalError: 'INTERNAL_ERROR',
  /** The user has no program memberships. */
  NoProgramMemberships: 'NO_PROGRAM_MEMBERSHIPS',
  /** None of the user's programs offer the requested product. */
  NoProgramOffersProduct: 'NO_PROGRAM_OFFERS_PRODUCT',
  /** The caller is not authorized to perform this operation. */
  Unauthorized: 'UNAUTHORIZED'
} as const;

export type EnterpriseEnrollment_ProgramSelectionError = typeof EnterpriseEnrollment_ProgramSelectionError[keyof typeof EnterpriseEnrollment_ProgramSelectionError];
/** Product types supported by the program selection enrollment flow. */
export const EnterpriseEnrollment_ProgramSelectionProductType = {
  /** A single course product. */
  Course: 'COURSE',
  /** A specialization (s12n) product. */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseEnrollment_ProgramSelectionProductType = typeof EnterpriseEnrollment_ProgramSelectionProductType[keyof typeof EnterpriseEnrollment_ProgramSelectionProductType];
/** Reason why a particular program was selected as the best program to enroll in. */
export const EnterpriseEnrollment_ProgramSelectionReason = {
  /**
   * A program was selected based on academic integrity feature priority
   * (GradedItemLocking > Proctoring > LockingBrowser > PeerReviewAiGradingDisabled).
   */
  AcademicIntegrityPriority: 'ACADEMIC_INTEGRITY_PRIORITY',
  /** A program was selected based on course schedule priority (earliest session start date). */
  CourseSchedulePriority: 'COURSE_SCHEDULE_PRIORITY',
  /** A program was selected because it has the latest contract expiry date among candidates. */
  LatestContractExpiry: 'LATEST_CONTRACT_EXPIRY',
  /** The user is a member of exactly one program. */
  OnlyOneProgramMember: 'ONLY_ONE_PROGRAM_MEMBER',
  /** Exactly one of the user's programs offers the requested product. */
  OnlyOneProgramOffersProduct: 'ONLY_ONE_PROGRAM_OFFERS_PRODUCT'
} as const;

export type EnterpriseEnrollment_ProgramSelectionReason = typeof EnterpriseEnrollment_ProgramSelectionReason[keyof typeof EnterpriseEnrollment_ProgramSelectionReason];
/** TODO: Complete this description */
export type EnterpriseFilterOptionsQueries = {
  __typename?: 'EnterpriseFilterOptionsQueries';
  /** This query returns entries filled by label, id, entityType, next and total. It supports pagination. | Maximum page size: 100 */
  searchFilterOptions: EnterpriseFilterOptions_EnterpriseUserFilterLabelConnection;
  /** This query returns entries filled by label, id, entityType, next and total. It supports pagination. | Maximum page size: 100 */
  searchFilterOptionsProgramLevel: EnterpriseFilterOptions_EnterpriseUserFilterLabelConnection;
};


/** TODO: Complete this description */
export type EnterpriseFilterOptionsQueriesSearchFilterOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterType: EnterpriseFilterOptions_FilterType;
  first?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['ID'];
  searchWord?: InputMaybe<Scalars['String']>;
};


/** TODO: Complete this description */
export type EnterpriseFilterOptionsQueriesSearchFilterOptionsProgramLevelArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterType: EnterpriseFilterOptions_FilterType;
  first?: InputMaybe<Scalars['Int']>;
  programIds: Array<Scalars['ID']>;
  searchWord?: InputMaybe<Scalars['String']>;
};

/** enterpriseUserFilterLabel response entry */
export type EnterpriseFilterOptions_EnterpriseUserFilterLabel = {
  __typename?: 'EnterpriseFilterOptions_EnterpriseUserFilterLabel';
  /** Represents the type of the id (i.e. Contract). */
  entityType: EnterpriseFilterOptions_EntityType;
  /** Represents the id based on the FilterOptionEntityType type. */
  id: Scalars['ID'];
  /** Represents the slug/name based on the EnterpriseUserFilterEntity type. */
  label: Scalars['String'];
};

/** paginatedEnterpriseUserFilterLabel response entry */
export type EnterpriseFilterOptions_EnterpriseUserFilterLabelConnection = {
  __typename?: 'EnterpriseFilterOptions_EnterpriseUserFilterLabelConnection';
  /** TODO: Complete this description */
  edges?: Maybe<Array<Maybe<EnterpriseFilterOptions_EnterpriseUserFilterLabelEdge>>>;
  /** TODO: Complete this description */
  pageInfo: PageInfo;
  /** TODO: Complete this description */
  totalCount: Scalars['Int'];
};

/** TODO: Complete this description */
export type EnterpriseFilterOptions_EnterpriseUserFilterLabelEdge = {
  __typename?: 'EnterpriseFilterOptions_EnterpriseUserFilterLabelEdge';
  /** TODO: Complete this description */
  cursor?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  node?: Maybe<EnterpriseFilterOptions_EnterpriseUserFilterLabel>;
};

/** filterOptionEntityType model */
export const EnterpriseFilterOptions_EntityType = {
  /** Contract filter option entity type */
  FilterOptionEntityTypeContract: 'FILTER_OPTION_ENTITY_TYPE_CONTRACT',
  /** Verified certificate filter option entity type */
  FilterOptionEntityTypeCourse: 'FILTER_OPTION_ENTITY_TYPE_COURSE',
  /** Invalid filter option entity type */
  FilterOptionEntityTypeInvalid: 'FILTER_OPTION_ENTITY_TYPE_INVALID',
  /** Program filter option entity type */
  FilterOptionEntityTypeProgram: 'FILTER_OPTION_ENTITY_TYPE_PROGRAM',
  /** Specialization: specialization filter option entity type */
  FilterOptionEntityTypeSpecialization: 'FILTER_OPTION_ENTITY_TYPE_SPECIALIZATION'
} as const;

export type EnterpriseFilterOptions_EntityType = typeof EnterpriseFilterOptions_EntityType[keyof typeof EnterpriseFilterOptions_EntityType];
/** enterpriseFilterOptionType model */
export const EnterpriseFilterOptions_FilterType = {
  /** Query type based on the search API on available content. */
  EnterpriseFilterOptionTypeContent: 'ENTERPRISE_FILTER_OPTION_TYPE_CONTENT',
  /** Query type based on the keyword among contractIds. */
  EnterpriseFilterOptionTypeContract: 'ENTERPRISE_FILTER_OPTION_TYPE_CONTRACT',
  /** Invalid query type. */
  EnterpriseFilterOptionTypeInvalid: 'ENTERPRISE_FILTER_OPTION_TYPE_INVALID',
  /** Query type based on the keyword among programIds. */
  EnterpriseFilterOptionTypeProgram: 'ENTERPRISE_FILTER_OPTION_TYPE_PROGRAM'
} as const;

export type EnterpriseFilterOptions_FilterType = typeof EnterpriseFilterOptions_FilterType[keyof typeof EnterpriseFilterOptions_FilterType];
/** All queries related to enterprise gradebooks */
export type EnterpriseGradebooksQueries = {
  __typename?: 'EnterpriseGradebooksQueries';
  /** query gradebook last updated at timestamp */
  queryGradebooksUpdatedAtTime?: Maybe<EnterpriseGradebooks_UpdatedAtTime>;
};

/** Filter for which attempts to include in export */
export const EnterpriseGradebooks_AttemptFilter = {
  /** All attempt at the course */
  AllAttempts: 'ALL_ATTEMPTS',
  /** Only first attempt at the course */
  OnlyFirstAttempt: 'ONLY_FIRST_ATTEMPT',
  /** Only latest attempt at the course */
  OnlyLatestAttempt: 'ONLY_LATEST_ATTEMPT'
} as const;

export type EnterpriseGradebooks_AttemptFilter = typeof EnterpriseGradebooks_AttemptFilter[keyof typeof EnterpriseGradebooks_AttemptFilter];
/** Filter for completion status */
export const EnterpriseGradebooks_CompletionStatusFilter = {
  /** Include all courses */
  IncludeAll: 'INCLUDE_ALL',
  /** Include only completed courses */
  IncludeOnlyCompletedCourses: 'INCLUDE_ONLY_COMPLETED_COURSES',
  /** Include only incomplete courses */
  IncludeOnlyIncompleteCourses: 'INCLUDE_ONLY_INCOMPLETE_COURSES'
} as const;

export type EnterpriseGradebooks_CompletionStatusFilter = typeof EnterpriseGradebooks_CompletionStatusFilter[keyof typeof EnterpriseGradebooks_CompletionStatusFilter];
/** Curriculum Collection Id */
export type EnterpriseGradebooks_CurriculumCollectionId = {
  /** Program Id */
  programId: Scalars['ID'];
  /** Track Id */
  trackId: Scalars['ID'];
};

/** Input for start and end date */
export type EnterpriseGradebooks_DateRangeInput = {
  /** End Date range for export job */
  endDate: Scalars['String'];
  /** Start Date range for export job */
  startDate: Scalars['String'];
};

/** Scope for enterprise collection */
export type EnterpriseGradebooks_EnterpriseCollectionScope = {
  /** Curriculum Collection Id */
  collectionId: EnterpriseGradebooks_CurriculumCollectionId;
};

/** Input for Gradebook Export job */
export type EnterpriseGradebooks_EnterpriseItemAttemptsGradebooksInput = {
  /** Gradebook Attempt Filter */
  attemptFilter?: InputMaybe<EnterpriseGradebooks_AttemptFilter>;
  /** Course id to generate an export for a specific course */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Date range for gradebook report */
  dateRange?: InputMaybe<EnterpriseGradebooks_DateRangeInput>;
  /** Flag to include completed courses only */
  includeCompletedCoursesOnly?: InputMaybe<EnterpriseGradebooks_CompletionStatusFilter>;
  /** Flag to include deleted members */
  includeDeletedMembers?: InputMaybe<Scalars['Boolean']>;
  /** Flag to indicate if it is a plagiarism report */
  isPlagiarismReport?: InputMaybe<Scalars['Boolean']>;
  /** Flag to specify csv formatting */
  oneCsvPerProgram?: InputMaybe<Scalars['Boolean']>;
  /** Scope for export job */
  scope: EnterpriseGradebooks_Scope;
};

/** Export job request status */
export type EnterpriseGradebooks_EnterpriseItemAttemptsGradebooksResult = EnterpriseGradebooks_ExportJobFailure | EnterpriseGradebooks_ExportJobSuccess;

/** Scope for enterprise organization */
export type EnterpriseGradebooks_EnterpriseOrganizationScope = {
  /** Third PartyOrganization Id */
  organizationId: Scalars['ID'];
};

/** Scope for enterprise programs */
export type EnterpriseGradebooks_EnterpriseProgramsScope = {
  /** Array of ProgramId */
  programIds: Array<Scalars['ID']>;
};

/** The error returned when we fail to start the export job. */
export type EnterpriseGradebooks_ExportError = Error & {
  __typename?: 'EnterpriseGradebooks_ExportError';
  /** Error message */
  message: Scalars['String'];
};

/** This is returned if the mutation fails. */
export type EnterpriseGradebooks_ExportJobFailure = {
  __typename?: 'EnterpriseGradebooks_ExportJobFailure';
  /** List of errors */
  errors: Array<EnterpriseGradebooks_ExportError>;
};

/** This is returned if the mutation succeeds. */
export type EnterpriseGradebooks_ExportJobSuccess = {
  __typename?: 'EnterpriseGradebooks_ExportJobSuccess';
  /** Flag indicating if a job is triggered successfully. */
  success: Scalars['Boolean'];
};

/** Enterprise gradebook plagiarism report for learner */
export type EnterpriseGradebooks_LearnerPlagiarismReport = {
  __typename?: 'EnterpriseGradebooks_LearnerPlagiarismReport';
  /** Learner's appeal denied count */
  appealsDeniedCount: Scalars['Int'];
  /** Learner's appeal granted count */
  appealsGrantedCount: Scalars['Int'];
  /** Learner's appeal submitted count */
  appealsSubmittedCount: Scalars['Int'];
  /** List of course_ids that learner has plagiarism record */
  courseIds: Array<Scalars['ID']>;
  /** Email for this plagiarism report */
  email: Scalars['String'];
  /** FullName for this plagiarism report */
  fullName: Scalars['String'];
  /** Learner's last activity time */
  lastActivityAtTime: Scalars['DateTime'];
  /** Learner's plagiarism confirmed count */
  plagiarismsCount: Scalars['Int'];
  /** UserId for this plagiarism report */
  userId: Scalars['Int'];
};

/** Scopes for enterprise gradebook export job */
export type EnterpriseGradebooks_Scope = {
  /** Scope: Enterprise Collection */
  enterpriseCollectionGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseCollectionScope>;
  /**
   * Scope: Enterprise Organization
   * @deprecated org level export is no longer supported
   */
  enterpriseOrganizationGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseOrganizationScope>;
  /** Scope: Enterprise Program */
  enterpriseProgramsGradebookScope?: InputMaybe<EnterpriseGradebooks_EnterpriseProgramsScope>;
};

/** query gradebook last updated at timestamp */
export type EnterpriseGradebooks_UpdatedAtTime = {
  __typename?: 'EnterpriseGradebooks_UpdatedAtTime';
  /** Gradebook last updated at timestamp */
  gradebooksUpdatedAtTime: Scalars['DateTime'];
};

/** Failure response for EnterpriseGroup_Create */
export type EnterpriseGroup_CreateFailure = {
  __typename?: 'EnterpriseGroup_CreateFailure';
  /** Errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Enterprise Group Create Input */
export type EnterpriseGroup_CreateInput = {
  /**
   * The contract to associate with the new group. When provided, the group is
   * associated with exactly this contract (validated to belong to the org and be
   * active). When omitted, all active contracts for the org are associated
   * (backward-compatible default).
   */
  contractId?: InputMaybe<Scalars['ID']>;
  /** The group name */
  name: Scalars['String'];
  /** The organization the group will be created in */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Success and failure handling for Enterprise Group Create mutation */
export type EnterpriseGroup_CreateResult = EnterpriseGroup_CreateFailure | EnterpriseGroup_CreateSuccess;

/** Success creating group */
export type EnterpriseGroup_CreateSuccess = {
  __typename?: 'EnterpriseGroup_CreateSuccess';
  /** Newly created Enterprise Group (backed by EnterpriseProgram) */
  body: EnterpriseProgram_EnterpriseProgram;
};

/** Enterprise Group Delete Input */
export type EnterpriseGroup_DeleteInput = {
  /** IDs of groups to delete */
  groupIds: Array<Scalars['ID']>;
  /** How to handle learners in the deleted groups */
  learnerDeletionMode: EnterpriseGroup_LearnerDeletionMode;
  /** The organization the groups belong to (used for cross-org validation) */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Response for group deletion with per-group results */
export type EnterpriseGroup_DeleteResult = {
  __typename?: 'EnterpriseGroup_DeleteResult';
  /** Per-group failures with reason */
  failures: Array<EnterpriseGroup_GroupDeletionFailure>;
  /** IDs of groups that were successfully deleted */
  successfulGroupIds: Array<Scalars['ID']>;
};

/** Per-group failure detail */
export type EnterpriseGroup_GroupDeletionFailure = {
  __typename?: 'EnterpriseGroup_GroupDeletionFailure';
  /** ID of the group that failed to delete */
  groupId: Scalars['ID'];
  /** Reason for failure */
  message: Scalars['String'];
};

/** Learner deletion mode for group deletion */
export const EnterpriseGroup_LearnerDeletionMode = {
  /** Learners lose access to deleted groups but retain org and other group memberships */
  RemoveFromGroup: 'REMOVE_FROM_GROUP',
  /** Full org removal including All Learners with learner notification */
  RemoveFromOrg: 'REMOVE_FROM_ORG'
} as const;

export type EnterpriseGroup_LearnerDeletionMode = typeof EnterpriseGroup_LearnerDeletionMode[keyof typeof EnterpriseGroup_LearnerDeletionMode];
/** Billing schedule type enum. */
export const EnterpriseInvoice_BillingScheduleType = {
  /** Enum for enterprise invoice billing schedule type ONE_TIME for annual payments. */
  OneTime: 'ONE_TIME',
  /** Enum for enterprise invoice billing schedule type QUARTERLY for quarterly payments. */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseInvoice_BillingScheduleType = typeof EnterpriseInvoice_BillingScheduleType[keyof typeof EnterpriseInvoice_BillingScheduleType];
/** Input parameters for EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrl mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlInput = {
  /** The customer's billing address details. */
  customerAddress: EnterpriseInvoice_CustomerAddressInput;
  /** The customer's tax ID information. */
  customerTaxIdData?: InputMaybe<EnterpriseInvoice_CustomerTaxIdInput>;
  /** Optional purchase order number for the invoice. */
  poNumber?: InputMaybe<Scalars['String']>;
  /** Self Serve Invoice Payload */
  selfServeInvoiceDetails: EnterpriseInvoice_CreateSelfServeInvoiceInput;
};

/** Response type for EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrl mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlResult = {
  __typename?: 'EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlResult';
  /** The contract order ID. */
  contractOrderId: Scalars['ID'];
  /** The Stripe-hosted invoice URL where customers can view and pay the invoice. */
  invoiceHostedUrl: Scalars['URL'];
  /** The URL to download the invoice PDF. */
  invoicePdfUrl: Scalars['URL'];
};

/** Input parameters for EnterpriseInvoice_CreateSelfServeInvoice mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceInput = {
  /** The billing currency code. */
  billingCurrency: Scalars['String'];
  /** The billing schedule type. */
  billingScheduleType: EnterpriseInvoice_BillingScheduleType;
  /** The contact email for the invoice. */
  contactEmail: Scalars['String'];
  /** The country ISO code. */
  countryIsoCode: Scalars['String'];
  /** The existing organization ID. */
  existingOrganizationId?: InputMaybe<Scalars['ID']>;
  /** The number of licenses to purchase. */
  numberOfLicenses: Scalars['Int'];
  /** The offer code to apply. */
  offerCode?: InputMaybe<Scalars['String']>;
  /** The name of the organization. */
  organizationName?: InputMaybe<Scalars['String']>;
  /** The type of organization. */
  organizationType?: InputMaybe<EnterpriseInvoice_OrganizationType>;
  /** The user ID of the user who is purchasing the licenses. */
  purchaseUserId?: InputMaybe<Scalars['ID']>;
  /** Testing options for the invoice. */
  testingOptions?: InputMaybe<EnterpriseInvoice_TestingOptionsInput>;
};

/** Response type for EnterpriseInvoice_CreateSelfServeInvoice mutation. */
export type EnterpriseInvoice_CreateSelfServeInvoiceResult = {
  __typename?: 'EnterpriseInvoice_CreateSelfServeInvoiceResult';
  /** The client secret needed for Stripe Elements payment flow. */
  clientSecret: Scalars['String'];
  /** The contract order ID. */
  contractOrderId: Scalars['ID'];
};

/** Customer address information for invoicing. */
export type EnterpriseInvoice_CustomerAddressInput = {
  /** The customer's city. */
  city: Scalars['String'];
  /** The customer's country (ISO country code). */
  country: Scalars['String'];
  /** First line of the customer's address. */
  line1: Scalars['String'];
  /** Optional second line of the customer's address. */
  line2?: InputMaybe<Scalars['String']>;
  /** The customer's postal code. */
  postalCode: Scalars['String'];
  /** The customer's state or province. */
  state: Scalars['String'];
};

/** Customer tax ID information for invoicing. */
export type EnterpriseInvoice_CustomerTaxIdInput = {
  /** The customer's tax ID number. */
  taxId: Scalars['ID'];
  /** The type of tax ID. */
  taxIdType: Scalars['String'];
};

/** Organization type enum. */
export const EnterpriseInvoice_OrganizationType = {
  /** Enum for enterprise organization BUSINESS type. */
  Business: 'BUSINESS',
  /** Enum for enterprise organization GOVERNMENT type. */
  Government: 'GOVERNMENT',
  /** Enum for enterprise organization NON_PROFIT type. */
  NonProfit: 'NON_PROFIT',
  /** Enum for enterprise organization OTHER type. */
  Other: 'OTHER',
  /** Enum for enterprise organization UNIVERSITY type. */
  University: 'UNIVERSITY'
} as const;

export type EnterpriseInvoice_OrganizationType = typeof EnterpriseInvoice_OrganizationType[keyof typeof EnterpriseInvoice_OrganizationType];
/** Testing options for the invoice. */
export type EnterpriseInvoice_TestingOptionsInput = {
  /** Whether to create a fake organization. */
  createFakeOrg?: InputMaybe<Scalars['Boolean']>;
  /** Whether to use sandbox mode. */
  sandbox?: InputMaybe<Scalars['Boolean']>;
};

/** Input parameters for EnterpriseLead_CreateLead mutation. */
export type EnterpriseLead_CreateLeadInput = {
  /** The enterprise lead details. */
  enterpriseLead: EnterpriseLead_DetailsInput;
  /** Flag to skip storing the lead. */
  skipStore?: Scalars['Boolean'];
  /** Flag to skip Zapier integration. */
  skipZapier?: Scalars['Boolean'];
};

/** Response type for EnterpriseLead_Create mutation. */
export type EnterpriseLead_CreateLeadResult = {
  __typename?: 'EnterpriseLead_CreateLeadResult';
  /** The details of the created enterprise lead. */
  enterpriseLead: EnterpriseLead_Details;
  /** The ID of the created enterprise lead. */
  id: Scalars['ID'];
};

/** Output type for EnterpriseLead. */
export type EnterpriseLead_Details = {
  __typename?: 'EnterpriseLead_Details';
  /** Billing address for the enterprise lead. */
  billingAddress?: Maybe<EnterpriseLead_EnterpriseLeadBillingAddress>;
  /** Contact information for the enterprise lead. */
  contact: EnterpriseLead_EnterpriseLeadContact;
  /** created at time */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the created enterprise lead. */
  id: Scalars['ID'];
  /** Type of enterprise contract. */
  leadType: EnterpriseLead_EnterpriseLeadType;
  /** Organization details for the enterprise lead. */
  organization: EnterpriseLead_EnterpriseLeadOrganization;
  /** Additional properties for the enterprise lead. */
  properties?: Maybe<EnterpriseLead_EnterpriseLeadProperties>;
  /** Source of the enterprise lead. */
  source: EnterpriseLead_EnterpriseLeadSource;
  /** Transaction type of the enterprise lead. */
  transactionType: EnterpriseLead_EnterpriseLeadTransactionType;
};

/** Input type for EnterpriseLead. */
export type EnterpriseLead_DetailsInput = {
  /** Billing address for the enterprise lead. */
  billingAddress?: InputMaybe<EnterpriseLead_EnterpriseLeadBillingAddressInput>;
  /** Contact information for the enterprise lead. */
  contact: EnterpriseLead_EnterpriseLeadContactInput;
  /** created at time */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Type of enterprise contract. */
  leadType: EnterpriseLead_EnterpriseLeadType;
  /** Organization details for the enterprise lead. */
  organization: EnterpriseLead_EnterpriseLeadOrganizationInput;
  /** Additional properties for the enterprise lead. */
  properties?: InputMaybe<EnterpriseLead_EnterpriseLeadPropertiesInput>;
  /** Source of the enterprise lead. */
  source: EnterpriseLead_EnterpriseLeadSource;
  /** Transaction type of the enterprise lead. */
  transactionType: EnterpriseLead_EnterpriseLeadTransactionType;
};

/** Enum for enterprise contract billing types. */
export const EnterpriseLead_EnterpriseContractBillingType = {
  /** Enum for enterprise lead contract billing type INVOICE */
  Invoice: 'INVOICE',
  /** Enum for enterprise lead contract billing type NONE */
  None: 'NONE',
  /** Enum for enterprise lead contract billing type ONE_TIME */
  OneTime: 'ONE_TIME',
  /** Enum for enterprise lead contract billing type QUARTERLY */
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseLead_EnterpriseContractBillingType = typeof EnterpriseLead_EnterpriseContractBillingType[keyof typeof EnterpriseLead_EnterpriseContractBillingType];
/** type for EnterpriseContractLimits. */
export type EnterpriseLead_EnterpriseContractLimits = {
  __typename?: 'EnterpriseLead_EnterpriseContractLimits';
  /** Courses per user limit for the contract. */
  coursesPerUserLimit?: Maybe<Scalars['Int']>;
  /** Enrollment cap limit for the contract. */
  enrollmentCapLimit?: Maybe<Scalars['Int']>;
  /** User limit for the contract. */
  userLimit?: Maybe<Scalars['Int']>;
};

/** Input type for EnterpriseContractLimits. */
export type EnterpriseLead_EnterpriseContractLimitsInput = {
  /** Courses per user limit for the contract. */
  coursesPerUserLimit?: InputMaybe<Scalars['Int']>;
  /** Enrollment cap limit for the contract. */
  enrollmentCapLimit?: InputMaybe<Scalars['Int']>;
  /** User limit for the contract. */
  userLimit?: InputMaybe<Scalars['Int']>;
};

/** output type for EnterpriseLeadBillingAddress. */
export type EnterpriseLead_EnterpriseLeadBillingAddress = {
  __typename?: 'EnterpriseLead_EnterpriseLeadBillingAddress';
  /** Country of the billing address. */
  country?: Maybe<Scalars['String']>;
  /** Postal code of the billing address. */
  postalCode?: Maybe<Scalars['String']>;
  /** State of the billing address. */
  state?: Maybe<Scalars['String']>;
};

/** type for EnterpriseLeadBillingAddress. */
export type EnterpriseLead_EnterpriseLeadBillingAddressInput = {
  /** Country of the billing address. */
  country?: InputMaybe<Scalars['String']>;
  /** Postal code of the billing address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State of the billing address. */
  state?: InputMaybe<Scalars['String']>;
};

/** Output type for EnterpriseLeadContact. */
export type EnterpriseLead_EnterpriseLeadContact = {
  __typename?: 'EnterpriseLead_EnterpriseLeadContact';
  /** Department of the contact. */
  department?: Maybe<Scalars['String']>;
  /** Email address of the contact. */
  email?: Maybe<Scalars['String']>;
  /** Hashed email of the contact. */
  emailHash?: Maybe<Scalars['String']>;
  /** Full name of the contact. */
  fullName?: Maybe<Scalars['String']>;
  /** IP address of the contact. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Job title of the contact. */
  title?: Maybe<Scalars['String']>;
  /** User ID of the contact. */
  userId?: Maybe<Scalars['ID']>;
};

/** Input type for EnterpriseLeadContact. */
export type EnterpriseLead_EnterpriseLeadContactInput = {
  /** Department of the contact. */
  department?: InputMaybe<Scalars['String']>;
  /** Email address of the contact. */
  email?: InputMaybe<Scalars['String']>;
  /** Hashed email of the contact. */
  emailHash?: InputMaybe<Scalars['String']>;
  /** Full name of the contact. */
  fullName?: InputMaybe<Scalars['String']>;
  /** IP address of the contact. */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Job title of the contact. */
  title?: InputMaybe<Scalars['String']>;
  /** User ID of the contact. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** type for EnterpriseLeadContractPrice. */
export type EnterpriseLead_EnterpriseLeadContractPrice = {
  __typename?: 'EnterpriseLead_EnterpriseLeadContractPrice';
  /** Annual contract value. */
  annualContractValue?: Maybe<Scalars['String']>;
  /** Currency code for the contract price. */
  currencyCode: Scalars['String'];
  /** Total payment amount for the contract. */
  paymentTotal: Scalars['String'];
};

/** Input type for EnterpriseLeadContractPrice. */
export type EnterpriseLead_EnterpriseLeadContractPriceInput = {
  /** Annual contract value. */
  annualContractValue?: InputMaybe<Scalars['String']>;
  /** Currency code for the contract price. */
  currencyCode: Scalars['String'];
  /** Total payment amount for the contract. */
  paymentTotal: Scalars['String'];
};

/** output type for EnterpriseLeadOrganization. */
export type EnterpriseLead_EnterpriseLeadOrganization = {
  __typename?: 'EnterpriseLead_EnterpriseLeadOrganization';
  /** Name of the organization. */
  name: Scalars['String'];
  /** Size category of the organization. */
  sizeCategory?: Maybe<EnterpriseLead_EnterpriseLeadOrganizationSizeCategory>;
  /** Type of the organization. */
  type?: Maybe<EnterpriseLead_EnterpriseLeadOrganizationType>;
};

/** Input type for EnterpriseLeadOrganization. */
export type EnterpriseLead_EnterpriseLeadOrganizationInput = {
  /** Name of the organization. */
  name: Scalars['String'];
  /** Size category of the organization. */
  sizeCategory?: InputMaybe<EnterpriseLead_EnterpriseLeadOrganizationSizeCategory>;
  /** Type of the organization. */
  type?: InputMaybe<EnterpriseLead_EnterpriseLeadOrganizationType>;
};

/** Enum for enterprise lead organization size categories. */
export const EnterpriseLead_EnterpriseLeadOrganizationSizeCategory = {
  /** Enum for enterprise lead organization size type 1_500. */
  Size_1_500: 'SIZE_1_500',
  /** Enum for enterprise lead organization size type 501_1000. */
  Size_501_1000: 'SIZE_501_1000',
  /** Enum for enterprise lead organization size type 1001_5000 */
  Size_1001_5000: 'SIZE_1001_5000',
  /** Enum for enterprise lead organization size type 5001_15000 */
  Size_5001_15000: 'SIZE_5001_15000',
  /** Enum for enterprise lead organization size type 15000_PLUS */
  Size_15000Plus: 'SIZE_15000_PLUS'
} as const;

export type EnterpriseLead_EnterpriseLeadOrganizationSizeCategory = typeof EnterpriseLead_EnterpriseLeadOrganizationSizeCategory[keyof typeof EnterpriseLead_EnterpriseLeadOrganizationSizeCategory];
/** Enum for enterprise lead organization types. */
export const EnterpriseLead_EnterpriseLeadOrganizationType = {
  /** Enum for enterprise lead organization BUSINESS type. */
  Business: 'BUSINESS',
  /** Enum for enterprise lead organization GOVERNMENT type. */
  Government: 'GOVERNMENT',
  /** Enum for enterprise lead organization NON_PROFIT type. */
  NonProfit: 'NON_PROFIT',
  /** Enum for enterprise lead organization OTHER type. */
  Other: 'OTHER',
  /** Enum for enterprise lead organization UNIVERSITY type. */
  University: 'UNIVERSITY'
} as const;

export type EnterpriseLead_EnterpriseLeadOrganizationType = typeof EnterpriseLead_EnterpriseLeadOrganizationType[keyof typeof EnterpriseLead_EnterpriseLeadOrganizationType];
/** Output for EnterpriseLeadProperties. */
export type EnterpriseLead_EnterpriseLeadProperties = {
  __typename?: 'EnterpriseLead_EnterpriseLeadProperties';
  /** Self-serve properties for the enterprise lead. */
  selfServeProperties?: Maybe<EnterpriseLead_EnterpriseLeadSelfServeProperties>;
};

/** input for EnterpriseLeadProperties. */
export type EnterpriseLead_EnterpriseLeadPropertiesInput = {
  /** Self-serve properties for the enterprise lead. */
  selfServeProperties?: InputMaybe<EnterpriseLead_EnterpriseLeadSelfServePropertiesInput>;
};

/** type for EnterpriseLeadSelfServeProperties. */
export type EnterpriseLead_EnterpriseLeadSelfServeProperties = {
  __typename?: 'EnterpriseLead_EnterpriseLeadSelfServeProperties';
  /** Billing type for self-serve properties. */
  billingType?: Maybe<EnterpriseLead_EnterpriseContractBillingType>;
  /** Contract ID for self-serve properties. */
  contractId?: Maybe<Scalars['ID']>;
  /** Contract limits for self-serve properties. */
  contractLimits?: Maybe<EnterpriseLead_EnterpriseContractLimits>;
  /** Contract price for self-serve properties. */
  contractPrice?: Maybe<EnterpriseLead_EnterpriseLeadContractPrice>;
};

/** Input type for EnterpriseLeadSelfServeProperties. */
export type EnterpriseLead_EnterpriseLeadSelfServePropertiesInput = {
  /** Billing type for self-serve properties. */
  billingType?: InputMaybe<EnterpriseLead_EnterpriseContractBillingType>;
  /** Contract ID for self-serve properties. */
  contractId?: InputMaybe<Scalars['ID']>;
  /** Contract limits for self-serve properties. */
  contractLimits?: InputMaybe<EnterpriseLead_EnterpriseContractLimitsInput>;
  /** Contract price for self-serve properties. */
  contractPrice?: InputMaybe<EnterpriseLead_EnterpriseLeadContractPriceInput>;
};

/** Enum for enterprise lead sources. */
export const EnterpriseLead_EnterpriseLeadSource = {
  /** Enterprise lead source type ENTERPRISE_INTEREST_FORM */
  EnterpriseInterestForm: 'ENTERPRISE_INTEREST_FORM',
  /** Enterprise lead source type WEB_ENABLED_SALES */
  WebEnabledSales: 'WEB_ENABLED_SALES',
  /** Enterprise lead source type WEB_ENABLED_SALES_ACCOUNT_DETAILS */
  WebEnabledSalesAccountDetails: 'WEB_ENABLED_SALES_ACCOUNT_DETAILS',
  /** Enterprise lead source type WEB_ENABLED_SALES_BILLING_INFO */
  WebEnabledSalesBillingInfo: 'WEB_ENABLED_SALES_BILLING_INFO',
  /** Enterprise lead source type WEB_ENABLED_SALES_PLAN_DETAILS */
  WebEnabledSalesPlanDetails: 'WEB_ENABLED_SALES_PLAN_DETAILS'
} as const;

export type EnterpriseLead_EnterpriseLeadSource = typeof EnterpriseLead_EnterpriseLeadSource[keyof typeof EnterpriseLead_EnterpriseLeadSource];
/** Enum for enterprise lead transaction types. */
export const EnterpriseLead_EnterpriseLeadTransactionType = {
  /** Enterprise lead transaction type for an active free trial. */
  FreeTrialActive: 'FREE_TRIAL_ACTIVE',
  /** Enterprise lead transaction type for a free trial checkout that has started. */
  FreeTrialCheckoutStarted: 'FREE_TRIAL_CHECKOUT_STARTED',
  /** Enterprise lead transaction type for a free trial that converted to paid. */
  FreeTrialConvertedToPaid: 'FREE_TRIAL_CONVERTED_TO_PAID',
  /** Enterprise lead transaction type for a terminated free trial. */
  FreeTrialTerminated: 'FREE_TRIAL_TERMINATED',
  /** Enterprise lead transaction type for a paid transaction. */
  Paid: 'PAID',
  /** Enterprise lead transaction type for a standard checkout that has started. */
  StandardCheckoutStarted: 'STANDARD_CHECKOUT_STARTED'
} as const;

export type EnterpriseLead_EnterpriseLeadTransactionType = typeof EnterpriseLead_EnterpriseLeadTransactionType[keyof typeof EnterpriseLead_EnterpriseLeadTransactionType];
/** Enum for enterprise lead types. */
export const EnterpriseLead_EnterpriseLeadType = {
  /** Enterprise lead type for a self serve checkout */
  SelfServe: 'SELF_SERVE',
  /** Enterprise lead type for a standard checkout */
  Standard: 'STANDARD'
} as const;

export type EnterpriseLead_EnterpriseLeadType = typeof EnterpriseLead_EnterpriseLeadType[keyof typeof EnterpriseLead_EnterpriseLeadType];
/**
 * Queries for enterprise learner cohorts — fetching pages of a previously created cohort.
 * Cohort creation goes through the mutations EnterpriseLearnerCohort_Create and
 * EnterpriseLearnerCohort_CreateAndFetch.
 */
export type EnterpriseLearnerCohortQueries = {
  __typename?: 'EnterpriseLearnerCohortQueries';
  /**
   * Returns a page of learners for a previously created cohort.
   *
   * The cohort's RBAC scope (org + program isolation) is established at creation time and
   * enforced by ClickHouse row policy on every execution. The orgId argument is used only for
   * request-level authorization — it is not used to re-verify or re-scope the result set.
   */
  fetchEnterpriseLearnerCohorts?: Maybe<EnterpriseLearnerCohort_FetchResult>;
};


/**
 * Queries for enterprise learner cohorts — fetching pages of a previously created cohort.
 * Cohort creation goes through the mutations EnterpriseLearnerCohort_Create and
 * EnterpriseLearnerCohort_CreateAndFetch.
 */
export type EnterpriseLearnerCohortQueriesFetchEnterpriseLearnerCohortsArgs = {
  cohortId: Scalars['ID'];
  orgId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['Int']>;
  searchString?: InputMaybe<Scalars['String']>;
};

/**
 * Authentication context for a cohort request. Mirrors EnterpriseLearnerCohortAuthContext
 * in the gRPC API.
 */
export type EnterpriseLearnerCohort_AuthContextInput = {
  /** Enterprise organization ID the cohort is scoped to. */
  orgId: Scalars['ID'];
};

/**
 * Input for creating and immediately fetching an enterprise learner cohort.
 * Structurally identical to EnterpriseLearnerCohort_CreateInput; named separately to satisfy
 * the schema input-name convention (each mutation's input must match the mutation name).
 */
export type EnterpriseLearnerCohort_CreateAndFetchInput = {
  /** Authentication context identifying the enterprise organization. */
  authContext: EnterpriseLearnerCohort_AuthContextInput;
  /** Natural-language description of the cohort. */
  nlq: Scalars['String'];
  /** Optional program scope. When omitted, the caller's RBAC-allowed programs are applied. */
  sessionFilters?: InputMaybe<EnterpriseLearnerCohort_SessionFiltersInput>;
};

/**
 * Result of a combined create-and-fetch request (EnterpriseLearnerCohort_CreateAndFetch
 * mutation). Combines the cohort creation envelope with the first page of learners so the
 * caller avoids a second round-trip for the common case.
 */
export type EnterpriseLearnerCohort_CreateAndFetchResult = {
  __typename?: 'EnterpriseLearnerCohort_CreateAndFetchResult';
  /** Opaque cohort identifier for subsequent fetchEnterpriseLearnerCohorts calls. Null when status is ERROR. */
  cohortId?: Maybe<Scalars['ID']>;
  /** Total number of learners in the cohort. */
  cohortSize?: Maybe<Scalars['Int']>;
  /** Structured error when status is ERROR; null on success. */
  error?: Maybe<EnterpriseLearnerCohort_Error>;
  /** First page of learners. Empty when status is not SUCCESS. */
  learners: Array<EnterpriseLearnerCohort_Learner>;
  /**
   * Row offset for the next page. 0 means the result set is exhausted. Null when status is ERROR
   * (the field does not apply when creation failed).
   */
  nextPageToken?: Maybe<Scalars['Int']>;
  /**
   * The effective program scope the cohort was built against (RBAC-resolved). An empty
   * list means the cohort is org-wide.
   */
  resolvedProgramIds: Array<Scalars['ID']>;
  /**
   * The date-range filter resolved during filter resolution. Null when no time filter was
   * applied (e.g. point-in-time query, or no session/NLQ date range).
   */
  resolvedTimeRange?: Maybe<EnterpriseLearnerCohort_ResolvedTimeRange>;
  /** Outcome of the cohort creation request. */
  status: EnterpriseLearnerCohort_Status;
  /** Non-fatal warnings. */
  warnings: Array<Scalars['String']>;
};

/** Input for creating an enterprise learner cohort. */
export type EnterpriseLearnerCohort_CreateInput = {
  /** Authentication context identifying the enterprise organization. */
  authContext: EnterpriseLearnerCohort_AuthContextInput;
  /**
   * Natural-language description of the cohort, e.g. "inactive learners in the past 30
   * days" or "learners who completed a course in Q1".
   */
  nlq: Scalars['String'];
  /** Optional program scope. When omitted, the caller's RBAC-allowed programs are applied. */
  sessionFilters?: InputMaybe<EnterpriseLearnerCohort_SessionFiltersInput>;
};

/** Result of a cohort creation request (EnterpriseLearnerCohort_Create mutation). */
export type EnterpriseLearnerCohort_CreateResult = {
  __typename?: 'EnterpriseLearnerCohort_CreateResult';
  /** Opaque cohort identifier for subsequent fetchEnterpriseLearnerCohorts calls. Null when status is ERROR. */
  cohortId?: Maybe<Scalars['ID']>;
  /** Structured error when status is ERROR; null on success. */
  error?: Maybe<EnterpriseLearnerCohort_Error>;
  /**
   * The effective program scope the cohort was built against (RBAC-resolved). An empty
   * list means the cohort is org-wide.
   */
  resolvedProgramIds: Array<Scalars['ID']>;
  /**
   * The date-range filter resolved during filter resolution. Null when no time filter was
   * applied (e.g. point-in-time query, or no session/NLQ date range).
   */
  resolvedTimeRange?: Maybe<EnterpriseLearnerCohort_ResolvedTimeRange>;
  /** Outcome of the cohort creation request. */
  status: EnterpriseLearnerCohort_Status;
  /** Non-fatal warnings (e.g. scope was narrowed relative to the request). */
  warnings: Array<Scalars['String']>;
};

/** Structured error detail from a failed cohort operation. */
export type EnterpriseLearnerCohort_Error = {
  __typename?: 'EnterpriseLearnerCohort_Error';
  /**
   * Machine-readable error code (mirrors ControlPlaneErrorCodes in the Analytics Control
   * Plane).
   */
  code: Scalars['String'];
  /** Human-readable error description suitable for display or logging. */
  message: Scalars['String'];
};

/** Result of a paginated cohort fetch (fetchEnterpriseLearnerCohorts query). */
export type EnterpriseLearnerCohort_FetchResult = {
  __typename?: 'EnterpriseLearnerCohort_FetchResult';
  /**
   * Total number of learners in the cohort. When a searchString is active, this reflects
   * the count of matching learners, not the full cohort.
   */
  cohortSize: Scalars['Int'];
  /** Learners on this page, in deterministic order. */
  learners: Array<EnterpriseLearnerCohort_Learner>;
  /**
   * Row offset for the next page. 0 means the result set is exhausted — do not paginate
   * further. Pass this value as pageToken in the next fetchEnterpriseLearnerCohorts call.
   */
  nextPageToken: Scalars['Int'];
};

/**
 * A single learner in a cohort result. Core identity fields are typed; any additional
 * columns the NLQ projected are returned in attributes.
 */
export type EnterpriseLearnerCohort_Learner = {
  __typename?: 'EnterpriseLearnerCohort_Learner';
  /**
   * Extra columns projected by the NLQ beyond the core identity fields, keyed by column
   * name (raw string values).
   */
  attributes?: Maybe<Scalars['JSON']>;
  /** Learner's email address. PII. */
  email?: Maybe<Scalars['String']>;
  /** Caller-supplied external identifier for the learner (e.g. HRIS ID). PII. */
  externalId?: Maybe<Scalars['ID']>;
  /** Learner's display name. PII. */
  fullName?: Maybe<Scalars['String']>;
  /** ISO 8601 timestamp of the learner's last activity. */
  lastAccessTime?: Maybe<Scalars['DateTime']>;
  /**
   * Coursera internal user ID. PII — only surfaced to users with learner-data access.
   * May be null for rows where user_id was not projected by the query.
   */
  userId?: Maybe<Scalars['ID']>;
};

/**
 * Resolved date-range filter applied to a cohort query. Exactly one of startDate/endDate
 * or preset is non-null; the other fields are null. A null resolvedTimeRange on the parent
 * result means no time filter was applied (e.g. point-in-time query, or no session/NLQ
 * date range).
 */
export type EnterpriseLearnerCohort_ResolvedTimeRange = {
  __typename?: 'EnterpriseLearnerCohort_ResolvedTimeRange';
  /** Explicit window end in YYYY-MM-DD format. Non-null only when no named preset was used. */
  endDate?: Maybe<Scalars['String']>;
  /**
   * Named time-range preset (e.g. LAST_30_DAYS, THIS_MONTH). Non-null only when no explicit
   * date range was used.
   */
  preset?: Maybe<Scalars['String']>;
  /** Explicit window start in YYYY-MM-DD format. Non-null only when no named preset was used. */
  startDate?: Maybe<Scalars['String']>;
};

/**
 * Optional program scope for a cohort. When sessionFilters is omitted or programIds is
 * empty, the caller's RBAC-allowed programs are applied (org-wide for org admins). Mirrors
 * EnterpriseLearnerCohortSessionFilters in the gRPC API.
 */
export type EnterpriseLearnerCohort_SessionFiltersInput = {
  /** Restrict the cohort to these programs. Empty or omitted means org-wide scope. */
  programIds?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Status of a cohort creation request. Mirrors EnterpriseLearnerCohortStatus in the
 * Analytics Control Plane gRPC API.
 */
export const EnterpriseLearnerCohort_Status = {
  /**
   * The natural-language query was ambiguous; refine it and try again. No cohort was
   * persisted.
   */
  DisambiguationNeeded: 'DISAMBIGUATION_NEEDED',
  /** The request failed; see error for the structured cause. */
  Error: 'ERROR',
  /** The cohort was created successfully; learners are available via fetchEnterpriseLearnerCohorts. */
  Success: 'SUCCESS'
} as const;

export type EnterpriseLearnerCohort_Status = typeof EnterpriseLearnerCohort_Status[keyof typeof EnterpriseLearnerCohort_Status];
/** Queries related to enterprise gradebook plagiarism report */
export type EnterpriseLearnerPlagiarismReportQueries = {
  __typename?: 'EnterpriseLearnerPlagiarismReportQueries';
  /** This query returns learner's program level plagiarism report by searching userId and programId. */
  queryByUserAndProgram: EnterpriseGradebooks_LearnerPlagiarismReport;
};


/** Queries related to enterprise gradebook plagiarism report */
export type EnterpriseLearnerPlagiarismReportQueriesQueryByUserAndProgramArgs = {
  programId: Scalars['ID'];
  userId: Scalars['Int'];
};

/** Input for deleting all enterprise learner profiles in an organization. */
export type EnterpriseLearnerProfile_DeleteAllByOrganizationInput = {
  /** Organization ID */
  organizationId: Scalars['ID'];
};

/** Result for deleting all enterprise learner profiles in an organization. */
export type EnterpriseLearnerProfile_DeleteAllByOrganizationResult = {
  __typename?: 'EnterpriseLearnerProfile_DeleteAllByOrganizationResult';
  /** Number of profiles deleted */
  deletedCount: Scalars['Int'];
};

/** Input for deleting enterprise learner profiles by organization and emails. */
export type EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsInput = {
  /** List of emails */
  emails: Array<Scalars['String']>;
  /** Organization ID */
  organizationId: Scalars['ID'];
};

/** Result for deleting enterprise learner profiles by organization and emails. */
export type EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsResult = {
  __typename?: 'EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsResult';
  /** Number of profiles deleted */
  deletedCount: Scalars['Int'];
};

/** Shared enterprise learner profile standard fields model. */
export type EnterpriseLearnerProfile_StandardFields = {
  __typename?: 'EnterpriseLearnerProfile_StandardFields';
  /** Business Unit */
  businessUnit?: Maybe<Scalars['String']>;
  /** Business Unit 2 */
  businessUnit2?: Maybe<Scalars['String']>;
  /** Job Title */
  jobTitle?: Maybe<Scalars['String']>;
  /** job Type */
  jobType?: Maybe<Scalars['String']>;
  /** Location City */
  locationCity?: Maybe<Scalars['String']>;
  /** Location Country */
  locationCountry?: Maybe<Scalars['String']>;
  /** Location Region */
  locationRegion?: Maybe<Scalars['String']>;
  /** Manager Email */
  managerEmail?: Maybe<Scalars['String']>;
  /** Manager Name */
  managerName?: Maybe<Scalars['String']>;
};

export type EnterpriseLearnerSummariesV1 = {
  __typename?: 'EnterpriseLearnerSummariesV1';
  domains: Array<Maybe<EnterpriseLearnerSummariesV1_Org_Coursera_Program_Curriculum_ProgramCurriculumDomain>>;
  enterprisePrograms?: Maybe<EnterpriseProgramsV1Connection>;
  id: Scalars['String'];
  invitations?: Maybe<ProgramInvitationsV1Connection>;
  memberships: Array<Maybe<EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembership>>;
  programIds: Array<Maybe<Scalars['String']>>;
  programMembershipIds: Array<Maybe<Scalars['String']>>;
  thirdPartyOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  thirdPartyOrganizationId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};


export type EnterpriseLearnerSummariesV1EnterpriseProgramsArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseLearnerSummariesV1InvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseLearnerSummariesV1ByUserIdAndThirdPartyOrgSlug = {
  __typename?: 'EnterpriseLearnerSummariesV1ByUserIdAndThirdPartyOrgSlug';
  connection?: Maybe<EnterpriseLearnerSummariesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrgSlug: Scalars['String'];
  userId: Scalars['String'];
};

export type EnterpriseLearnerSummariesV1Connection = {
  __typename?: 'EnterpriseLearnerSummariesV1Connection';
  elements: Array<Maybe<EnterpriseLearnerSummariesV1>>;
  paging: ResponsePagination;
};

export type EnterpriseLearnerSummariesV1Resource = {
  __typename?: 'EnterpriseLearnerSummariesV1Resource';
  byUserIdAndThirdPartyOrgSlug?: Maybe<EnterpriseLearnerSummariesV1Connection>;
  get?: Maybe<EnterpriseLearnerSummariesV1>;
  multiGet?: Maybe<EnterpriseLearnerSummariesV1Connection>;
};


export type EnterpriseLearnerSummariesV1ResourceByUserIdAndThirdPartyOrgSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrgSlug: Scalars['String'];
  userId: Scalars['String'];
};


export type EnterpriseLearnerSummariesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseLearnerSummariesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseLearnerSummariesV1_GenericExternalUserDataMember = {
  __typename?: 'EnterpriseLearnerSummariesV1_genericExternalUserDataMember';
  genericExternalUserData: EnterpriseLearnerSummariesV1_Org_Coursera_Program_Invitation_GenericExternalUserData;
};

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Curriculum_ProgramCurriculumDomain = {
  __typename?: 'EnterpriseLearnerSummariesV1_org_coursera_program_curriculum_ProgramCurriculumDomain';
  courseCount: Scalars['Int'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  id: Scalars['String'];
  isSelected?: Maybe<Scalars['Boolean']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  subdomainIds: Array<Maybe<Scalars['String']>>;
};

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Invitation_GenericExternalUserData = {
  __typename?: 'EnterpriseLearnerSummariesV1_org_coursera_program_invitation_GenericExternalUserData';
  email: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
};

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembership = {
  __typename?: 'EnterpriseLearnerSummariesV1_org_coursera_program_membership_ProgramMembership';
  createdAt?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['Float']>;
  externalUserData: EnterpriseLearnerSummariesV1_GenericExternalUserDataMember;
  invitationId?: Maybe<Scalars['String']>;
  membershipState: EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState;
  role?: Maybe<EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole>;
  rosterIds: Array<Maybe<Scalars['String']>>;
};

export const EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState = {
  DeletedMember: 'DELETED_MEMBER',
  Invited: 'INVITED',
  InvitedEmailNotVerified: 'INVITED_EMAIL_NOT_VERIFIED',
  Member: 'MEMBER',
  NotMember: 'NOT_MEMBER',
  SoftDeletedMember: 'SOFT_DELETED_MEMBER',
  Whitelisted: 'WHITELISTED'
} as const;

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState = typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState[keyof typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramMembershipState];
export const EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole = {
  DerivedProgramAdmin: 'DERIVED_PROGRAM_ADMIN',
  Member: 'MEMBER',
  ProgramAdmin: 'PROGRAM_ADMIN'
} as const;

export type EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole = typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole[keyof typeof EnterpriseLearnerSummariesV1_Org_Coursera_Program_Membership_ProgramRole];
export type EnterpriseMemberCourseEnrollmentReportsV2 = {
  __typename?: 'EnterpriseMemberCourseEnrollmentReportsV2';
  id: Scalars['String'];
  programId: Scalars['String'];
  records: Array<Maybe<EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentRecordV2>>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type EnterpriseMemberCourseEnrollmentReportsV2Connection = {
  __typename?: 'EnterpriseMemberCourseEnrollmentReportsV2Connection';
  elements: Array<Maybe<EnterpriseMemberCourseEnrollmentReportsV2>>;
  paging: ResponsePagination;
};

export type EnterpriseMemberCourseEnrollmentReportsV2Resource = {
  __typename?: 'EnterpriseMemberCourseEnrollmentReportsV2Resource';
  get?: Maybe<EnterpriseMemberCourseEnrollmentReportsV2>;
  multiGet?: Maybe<EnterpriseMemberCourseEnrollmentReportsV2Connection>;
};


export type EnterpriseMemberCourseEnrollmentReportsV2ResourceGetArgs = {
  id: Scalars['String'];
  includeDowngraded?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseMemberCourseEnrollmentReportsV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeDowngraded?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentRecordV2 = {
  __typename?: 'EnterpriseMemberCourseEnrollmentReportsV2_org_coursera_enterprise_report_EnterpriseMemberCourseEnrollmentRecordV2';
  completedAt?: Maybe<Scalars['Float']>;
  courseId: Scalars['String'];
  courseName: Scalars['String'];
  enrolledAt: Scalars['Float'];
  isActive: Scalars['Boolean'];
  lastActivityAt?: Maybe<Scalars['Float']>;
  progressPercentage: Scalars['Float'];
  status: EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus;
};

export const EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Inactive: 'INACTIVE'
} as const;

export type EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus = typeof EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus[keyof typeof EnterpriseMemberCourseEnrollmentReportsV2_Org_Coursera_Enterprise_Report_EnterpriseMemberCourseEnrollmentStatus];
/** A type that represents the set of enterprise sent message query operations. */
export type EnterpriseMessagesQueries = {
  __typename?: 'EnterpriseMessagesQueries';
  /** Previews an automated message template rendered as HTML for the given organization. */
  previewAutomatedTemplates: EnterpriseMessages_AutomatedTemplatePreviewResult;
  /** Validates a manual learner-list CSV at the given S3 location and returns a sync or async import preview. */
  previewManualCsvImport: EnterpriseMessages_ManualCsvImportPreviewResult;
  /** Retrieve a list of enterprise sent messages by third party organization ID. */
  queryByThirdPartyOrgId: EnterpriseMessages_SentMessagesPaginatedResult;
};


/** A type that represents the set of enterprise sent message query operations. */
export type EnterpriseMessagesQueriesPreviewAutomatedTemplatesArgs = {
  organizationId: Scalars['ID'];
  templateId: Scalars['ID'];
};


/** A type that represents the set of enterprise sent message query operations. */
export type EnterpriseMessagesQueriesPreviewManualCsvImportArgs = {
  organizationId: Scalars['ID'];
  s3Bucket: Scalars['String'];
  s3Key: Scalars['String'];
};


/** A type that represents the set of enterprise sent message query operations. */
export type EnterpriseMessagesQueriesQueryByThirdPartyOrgIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Preview when validation or import continues asynchronously. */
export type EnterpriseMessages_AsyncManualCsvImportPreview = {
  __typename?: 'EnterpriseMessages_AsyncManualCsvImportPreview';
  /** True when the uploaded CSV has passed structural or initial validation for async processing. */
  csvValidated: Scalars['Boolean'];
};

/** Result of previewAutomatedTemplates. */
export type EnterpriseMessages_AutomatedTemplatePreviewResult = {
  __typename?: 'EnterpriseMessages_AutomatedTemplatePreviewResult';
  /** Click-through rate for the automated template: the number of learners who clicked a link out of total recipients, and the corresponding percentage. */
  ctr?: Maybe<EnterpriseMessages_EngagementRate>;
  /** Rendered HTML content for the automated template preview. */
  htmlContent: Scalars['String'];
  /** Total number of learners the automated message was sent to. May be null if the count is unavailable. */
  numberOfRecipients?: Maybe<Scalars['Int']>;
  /** Open rate for the automated template: the number of learners who opened the email out of total recipients, and the corresponding percentage. */
  openRate?: Maybe<EnterpriseMessages_EngagementRate>;
  /** Rendered subject line for the automated template preview. */
  subject: Scalars['String'];
};

/** Recurring cadence at which a scheduled campaign is sent. */
export const EnterpriseMessages_Cadence = {
  /** Sent every other week. */
  Biweekly: 'BIWEEKLY',
  /** Sent every month. */
  Monthly: 'MONTHLY',
  /** Sent every week. */
  Weekly: 'WEEKLY'
} as const;

export type EnterpriseMessages_Cadence = typeof EnterpriseMessages_Cadence[keyof typeof EnterpriseMessages_Cadence];
/** The ID of the call to action in an enterprise learner communication. */
export const EnterpriseMessages_CallToActionType = {
  /** Call to action is Continue Learning */
  ContinueLearning: 'CONTINUE_LEARNING',
  /** Call to action is Do Not Include */
  DoNotInclude: 'DO_NOT_INCLUDE',
  /** Call to action is Find a Course */
  FindACourse: 'FIND_A_COURSE',
  /** Call to action is Join Program */
  JoinProgram: 'JOIN_PROGRAM'
} as const;

export type EnterpriseMessages_CallToActionType = typeof EnterpriseMessages_CallToActionType[keyof typeof EnterpriseMessages_CallToActionType];
/** Engagement rate metrics containing a learner count and a percentage rate. */
export type EnterpriseMessages_EngagementRate = {
  __typename?: 'EnterpriseMessages_EngagementRate';
  /** Number of learners who performed the action (e.g. opened the email or clicked a link) out of the total number of recipients. */
  learnerCount: Scalars['Int'];
  /** Percentage of learners who performed the action, expressed as a decimal rounded to two decimal places (e.g. 79 or 65.75). */
  rate: Scalars['Float'];
};

/** The learner communication message */
export type EnterpriseMessages_EnterpriseLearnerCommunicationMessage = {
  __typename?: 'EnterpriseMessages_EnterpriseLearnerCommunicationMessage';
  /** The email author user object */
  author?: Maybe<User_User>;
  /** The call to action ID of the message */
  callToActionType?: Maybe<EnterpriseMessages_CallToActionType>;
  /** The CML content of the sent message. */
  cmlContent: Cml_Cml;
  /** Triggered message ID */
  id: Scalars['ID'];
  /** The preset for the enterprise sent message. */
  preset?: Maybe<EnterpriseSentMessages_Preset>;
  /** The reply-to email for the enterprise sent message. */
  replyTo?: Maybe<Scalars['String']>;
  /** The status of the sent triggered message. */
  status: EnterpriseMessages_SentTriggeredMessageStatus;
  /** The subject of the sent message. */
  subject: Scalars['String'];
  /**
   * The user filter parameters for the sent message. Can be either filterParams which is a
   * flattened version stored with the the SentTriggeredMessage, or an AdminUserFilter which is
   * stored in the Saved User Filter store.
   */
  userFilter: EnterpriseMessages_UserFilter;
};

/** Represents a product - which could be either a course or specialization. */
export type EnterpriseMessages_EnterpriseProduct = Course_Course | Specialization_Specialization;

/** A type that contains details about an enterprise sent message. */
export type EnterpriseMessages_EnterpriseSentMessage = {
  __typename?: 'EnterpriseMessages_EnterpriseSentMessage';
  /** The user data for the author of the message */
  authorUser?: Maybe<User_User>;
  /** The triggered message from the store */
  sentTriggeredMessage: EnterpriseMessages_SentTriggeredMessage;
};

/** The parameters used to filter users for an enterprise sent message. */
export type EnterpriseMessages_EnterpriseUserFilterParams = {
  __typename?: 'EnterpriseMessages_EnterpriseUserFilterParams';
  /** The list of contract IDs associated with the user fitler params */
  contracts: Array<EnterpriseContract_EnterpriseContract>;
  /** The user filter */
  filter?: Maybe<EnterpriseSavedFilter_AdminUserFilter>;
  /**
   * The list of product associated with the user fitler params. Can either be a course or a
   * specialization.
   */
  products: Array<EnterpriseMessages_EnterpriseProduct>;
  /** The list of program IDs associated with the user filter params */
  programs: Array<EnterpriseProgram>;
  /** The list of user ID identifiers to filter by. */
  users: Array<User_User>;
};

/** Input for EnterpriseMessages_GenerateUploadLocForManualList. */
export type EnterpriseMessages_GenerateUploadLocForManualListInput = {
  /** Enterprise organization ID for the upload context. */
  organizationId: Scalars['ID'];
};

/** Result of EnterpriseMessages_GenerateUploadLocForManualList. */
export type EnterpriseMessages_GenerateUploadLocForManualListResult = {
  __typename?: 'EnterpriseMessages_GenerateUploadLocForManualListResult';
  /** Target S3 bucket and key for the upload. */
  s3Location: EnterpriseMessages_S3Object;
  /** Presigned URL the client uses to PUT the CSV bytes to S3. */
  signedUploadUrl: Scalars['URL'];
};

/** Preview outcome: either a synchronous row-level summary or an async-import path. */
export type EnterpriseMessages_ManualCsvImportPreviewResult = EnterpriseMessages_AsyncManualCsvImportPreview | EnterpriseMessages_SyncManualCsvImportPreview;

/** A type that abstracts over AWS S3 objects. */
export type EnterpriseMessages_S3Object = {
  __typename?: 'EnterpriseMessages_S3Object';
  /** The bucket that contains the S3 object. */
  bucket: Scalars['String'];
  /** The key to locate the S3 object. */
  key: Scalars['String'];
};

/** Input for EnterpriseMessages_ScheduleScopedTrigger. */
export type EnterpriseMessages_ScheduleScopedTriggerInput = {
  /** The cadence at which the campaign should be sent. */
  cadence: EnterpriseMessages_Cadence;
  /** The scoped trigger identifier (encodes the campaign's scope and trigger). */
  triggerId: Scalars['ID'];
};

/** Result of EnterpriseMessages_ScheduleScopedTrigger. */
export type EnterpriseMessages_ScheduleScopedTriggerResult = {
  __typename?: 'EnterpriseMessages_ScheduleScopedTriggerResult';
  /** The scoped trigger identifier that was scheduled. */
  triggerId: Scalars['ID'];
};

/** Pagination for sentMessages query */
export type EnterpriseMessages_SentMessagesPaginatedResult = {
  __typename?: 'EnterpriseMessages_SentMessagesPaginatedResult';
  /** A list of user records */
  elements: Array<EnterpriseMessages_EnterpriseSentMessage>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** The triggered message that was sent */
export type EnterpriseMessages_SentTriggeredMessage = {
  __typename?: 'EnterpriseMessages_SentTriggeredMessage';
  /** The number of recipients of the sent message. */
  numberOfRecipients: Scalars['Int'];
  /** The recipients file for the sent message. */
  recipientsFile?: Maybe<EnterpriseMessages_S3Object>;
  /** The date and time when the message was sent. */
  sentAt: Scalars['DateTime'];
  /** The triggered message that was sent */
  triggeredMessage?: Maybe<EnterpriseMessages_TriggeredMessage>;
};

/** The set of possible statuses for a sent triggered message. */
export const EnterpriseMessages_SentTriggeredMessageStatus = {
  /** Indicates message is in progress */
  InProgress: 'IN_PROGRESS',
  /** Indicates message has been sent */
  MessageSent: 'MESSAGE_SENT'
} as const;

export type EnterpriseMessages_SentTriggeredMessageStatus = typeof EnterpriseMessages_SentTriggeredMessageStatus[keyof typeof EnterpriseMessages_SentTriggeredMessageStatus];
/** Simple message model */
export type EnterpriseMessages_SimpleMessage = {
  __typename?: 'EnterpriseMessages_SimpleMessage';
  /** The CML content of the message */
  content: Cml_Cml;
  /** Triggered message ID */
  id: Scalars['ID'];
  /** The status of the message. */
  status: EnterpriseMessages_SentTriggeredMessageStatus;
  /** The subject of the message */
  subject: Scalars['String'];
};

/** Row-level preview when the import can be validated synchronously. */
export type EnterpriseMessages_SyncManualCsvImportPreview = {
  __typename?: 'EnterpriseMessages_SyncManualCsvImportPreview';
  /** Email values that failed validation. */
  inviteesWithInvalidEmails: Array<Scalars['String']>;
  /** Name values that failed validation. */
  inviteesWithInvalidNames: Array<Scalars['String']>;
  /** Total learner rows seen in the CSV. */
  learnerCount: Scalars['Int'];
  /** Count of rows skipped (e.g. duplicates or non-org learners). */
  skippedLearnerCount: Scalars['Int'];
  /** Count of rows with valid learner data. */
  validLearnerCount: Scalars['Int'];
};

/** The triggered message */
export type EnterpriseMessages_TriggeredMessage = EnterpriseMessages_EnterpriseLearnerCommunicationMessage | EnterpriseMessages_SimpleMessage;

/** Input for EnterpriseMessages_UnscheduleScopedTrigger. */
export type EnterpriseMessages_UnscheduleScopedTriggerInput = {
  /** The scoped trigger identifier (encodes the campaign's scope and trigger). */
  triggerId: Scalars['ID'];
};

/** Result of EnterpriseMessages_UnscheduleScopedTrigger. */
export type EnterpriseMessages_UnscheduleScopedTriggerResult = {
  __typename?: 'EnterpriseMessages_UnscheduleScopedTriggerResult';
  /** The scoped trigger identifier that was unscheduled. */
  triggerId: Scalars['ID'];
};

/**
 * User filter can be either represented as a flat map of user filters
 * EnterpriseMessages_EnterpriseUserFilterParams or as a federated type
 * EnterpriseSavedFilter_AdminUserFilter which is fetched from the
 * Saved User Filter store
 */
export type EnterpriseMessages_UserFilter = EnterpriseMessages_EnterpriseUserFilterParams | EnterpriseSavedFilter_AdminUserFilter;

export type EnterprisePaymentWalletsV1 = {
  __typename?: 'EnterprisePaymentWalletsV1';
  billingCountry: Scalars['String'];
  billingState?: Maybe<Scalars['String']>;
  billingZipcode?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  creditCardExpiration?: Maybe<Scalars['Float']>;
  creditCardLastFourDigits?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Float']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isValid: Scalars['Boolean'];
  paymentProcessorId: Scalars['String'];
  paymentWalletId: Scalars['Float'];
  token: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type EnterprisePaymentWalletsV1Connection = {
  __typename?: 'EnterprisePaymentWalletsV1Connection';
  elements: Array<Maybe<EnterprisePaymentWalletsV1>>;
  paging: ResponsePagination;
};

export type EnterprisePaymentWalletsV1Resource = {
  __typename?: 'EnterprisePaymentWalletsV1Resource';
  get?: Maybe<EnterprisePaymentWalletsV1>;
  multiGet?: Maybe<EnterprisePaymentWalletsV1Connection>;
};


export type EnterprisePaymentWalletsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterprisePaymentWalletsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterprisePaymentWalletsV1ResourceMutations = {
  __typename?: 'EnterprisePaymentWalletsV1ResourceMutations';
  updateWalletAndBillContractIfDue?: Maybe<Scalars['JSON']>;
};

/** Queries related to enterprise permissions */
export type EnterprisePermissionQueries = {
  __typename?: 'EnterprisePermissionQueries';
  /**
   * This query returns all domain-level permissions for the user by searching with user ID and domain slug.
   * For example, when a program domain slug is passed in, only program-level permissions will be returned.
   * The results are not paginated because
   * (1) the number of permissions is bound by permissions in the domain
   * (2) there will never be outbound relationships from this type so fan-out isn't a concern
   * (3) the BE API isn't paginated so performance isn't affected
   * (4) FE will need all permissions to function
   */
  queryDomainLevelPermissions: Array<EnterprisePermission_CompressedPermissions>;
  /**
   * This query returns whether the user possesses program admin permissions
   * For example, if a program ID is not provided, the user's view program permission is returned
   * The results are not paginated because
   * (1) permissions are compressed and the clusters are by the number of permissions in the query
   * (2) there will never be outbound relationships from this type so fan-out isn't a concern
   * (3) the BE API isn't paginated so performance isn't affected
   * (4) FE will need all permissions to function
   */
  queryIsProgramAdmin: Scalars['Boolean'];
  /**
   * This query returns permissions matching the input for the user by searching under the domain.
   * For example, if an org domain is provided, then programs under the org are also checked.
   * The results are not paginated because
   * (1) permissions are compressed and the clusters are by the number of permissions in the query
   * (2) there will never be outbound relationships from this type so fan-out isn't a concern
   * (3) the BE API isn't paginated so performance isn't affected
   * (4) FE will need all permissions to function
   */
  querySelectPermissionsUnderDomain: Array<EnterprisePermission_CompressedPermissions>;
};


/** Queries related to enterprise permissions */
export type EnterprisePermissionQueriesQueryDomainLevelPermissionsArgs = {
  domainSlug: EnterprisePermission_DomainSlugInput;
  userId: Scalars['Int'];
};


/** Queries related to enterprise permissions */
export type EnterprisePermissionQueriesQueryIsProgramAdminArgs = {
  programId?: InputMaybe<Scalars['ID']>;
};


/** Queries related to enterprise permissions */
export type EnterprisePermissionQueriesQuerySelectPermissionsUnderDomainArgs = {
  domainSlug: EnterprisePermission_DomainSlugInput;
  permissions: Array<EnterprisePermission_FeatureTypePermissionInput>;
  userId: Scalars['Int'];
};

/** An admin with user metadata and role information */
export type EnterprisePermission_Admin = {
  __typename?: 'EnterprisePermission_Admin';
  /** Email address of admin */
  email: Scalars['String'];
  /** Full name of admin, not present for pending invitations */
  fullName?: Maybe<Scalars['String']>;
  /** Optional profile picture URL pulled from userProfiles.v1 */
  profilePicture?: Maybe<Scalars['URL']>;
  /** Role */
  roles: Array<EnterprisePermission_Role>;
  /** User id, not present for pending invitations */
  userId?: Maybe<Scalars['ID']>;
};

/** Compressed permissions */
export type EnterprisePermission_CompressedPermissions = {
  __typename?: 'EnterprisePermission_CompressedPermissions';
  /** Domain object IDs (program or organization) associated with the permissions */
  domainObjectIds: Array<Scalars['ID']>;
  /** Permission type */
  permissions: Array<EnterprisePermission_FeatureTypePermission>;
};

/** Input to delete the roles for a specific user for an org */
export type EnterprisePermission_DeleteAdminInput = {
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** Delete admin role response for either success of failure */
export type EnterprisePermission_DeleteAdminResult = EnterprisePermission_DeleteAdminResultFailure | EnterprisePermission_DeleteAdminResultSuccess;

/** Failure deleting the admin */
export type EnterprisePermission_DeleteAdminResultFailure = {
  __typename?: 'EnterprisePermission_DeleteAdminResultFailure';
  /** Errors */
  error: EnterprisePermission_UserRoles_Error;
};

/** Success deleting admin */
export type EnterprisePermission_DeleteAdminResultSuccess = {
  __typename?: 'EnterprisePermission_DeleteAdminResultSuccess';
  /** Flag indicating if the deletions was complete. */
  success: Scalars['Boolean'];
};

/** Parameter for the domain slug */
export type EnterprisePermission_DomainSlugInput = {
  /** Query organization-domain permissions for an organization */
  organizationSlug?: InputMaybe<Scalars['String']>;
  /** Query program-domain permissions for a program */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Feature type permissions */
export type EnterprisePermission_FeatureTypePermission = {
  __typename?: 'EnterprisePermission_FeatureTypePermission';
  /** Feature domain */
  domain: EnterprisePermission_PermissionDomain;
  /** Optional subdomain */
  subdomain?: Maybe<Scalars['String']>;
  /** Feature verb */
  verb: Scalars['String'];
};

/** Feature type permissions */
export type EnterprisePermission_FeatureTypePermissionInput = {
  /** Feature domain */
  domain: EnterprisePermission_PermissionDomain;
  /** Optional subdomain */
  subdomain?: InputMaybe<Scalars['String']>;
  /** Feature verb */
  verb: Scalars['String'];
};

/**
 * Similar to EnterprisePermission_Role, but excludes invitations.
 * Metadata like createdAt that requires an additional sql join is not included since our current use cases don't need it.
 */
export type EnterprisePermission_GrantedRole = {
  __typename?: 'EnterprisePermission_GrantedRole';
  /** Domain */
  domain: EnterprisePermission_RoleDomain;
  /** Role template id */
  templateId: Scalars['ID'];
  /** Universal role type, only present for universal roles */
  universalRole?: Maybe<EnterprisePermission_UniversalRole>;
};

/** Possible domains of a feature type permission */
export const EnterprisePermission_PermissionDomain = {
  /** Organization domain */
  PermissionDomainOrganization: 'PERMISSION_DOMAIN_ORGANIZATION',
  /** Program domain */
  PermissionDomainProgram: 'PERMISSION_DOMAIN_PROGRAM'
} as const;

export type EnterprisePermission_PermissionDomain = typeof EnterprisePermission_PermissionDomain[keyof typeof EnterprisePermission_PermissionDomain];
/** Invited and granted roles */
export type EnterprisePermission_Role = {
  __typename?: 'EnterprisePermission_Role';
  /** Creation timestamp of the invitation or role */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Domain */
  domain: EnterprisePermission_RoleDomain;
  /**
   * Domain type
   * @deprecated Use domain instead
   */
  domainType: EnterprisePermission_PermissionDomain;
  /** Invitation ID, only present for pending invitations */
  invitationId?: Maybe<Scalars['ID']>;
  /** Role template id */
  templateId: Scalars['ID'];
  /** Universal role type, only present for universal roles */
  universalRole?: Maybe<EnterprisePermission_UniversalRole>;
};

/** Role domain */
export type EnterprisePermission_RoleDomain = EnterprisePermission_RoleDomainOrganization | EnterprisePermission_RoleDomainProgram;

/** Role domain */
export type EnterprisePermission_RoleDomainInput = {
  /** The ID of the domain type that the role is being applied for */
  id: Scalars['ID'];
  /** The domain that the above ID relates to */
  roleDomainType: EnterprisePermission_PermissionDomain;
};

/** Organization role domain */
export type EnterprisePermission_RoleDomainOrganization = {
  __typename?: 'EnterprisePermission_RoleDomainOrganization';
  /** Naptime organization */
  naptimeOrganization: ThirdPartyOrganizationsV1;
};

/** Program role domain */
export type EnterprisePermission_RoleDomainProgram = {
  __typename?: 'EnterprisePermission_RoleDomainProgram';
  /** Program */
  program: EnterpriseProgram;
};

/** Role template */
export type EnterprisePermission_RoleTemplate = {
  __typename?: 'EnterprisePermission_RoleTemplate';
  /** Display name of the template */
  displayName: Scalars['String'];
  /** Hydration entity type */
  hydrationEntities: Array<Maybe<EnterprisePermission_PermissionDomain>>;
  /** Role template id */
  id: Scalars['ID'];
  /** Boolean that indicates if the template is universal */
  isUniversal: Scalars['Boolean'];
  /** Name of the template */
  name: Scalars['String'];
  /** Permission features for this role */
  permissionFeatures: Array<EnterprisePermission_FeatureTypePermission>;
};

/** Universal role enum, the graphql equivalent of coursera.proto.enterprisepermissions.shared.v1beta1.UniversalRole */
export const EnterprisePermission_UniversalRole = {
  /** Mentor */
  UniversalRoleMentor: 'UNIVERSAL_ROLE_MENTOR',
  /** Organization admin */
  UniversalRoleOrganizationAdmin: 'UNIVERSAL_ROLE_ORGANIZATION_ADMIN',
  /** Program admin */
  UniversalRoleProgramAdmin: 'UNIVERSAL_ROLE_PROGRAM_ADMIN',
  /** Recruiter */
  UniversalRoleRecruiter: 'UNIVERSAL_ROLE_RECRUITER',
  /** Restricted admin A.K.A Staff admin */
  UniversalRoleRestrictedAdmin: 'UNIVERSAL_ROLE_RESTRICTED_ADMIN'
} as const;

export type EnterprisePermission_UniversalRole = typeof EnterprisePermission_UniversalRole[keyof typeof EnterprisePermission_UniversalRole];
/** Input to update the roles associated with an user */
export type EnterprisePermission_UpdateUserRolesInput = {
  /** Domain */
  domains: Array<EnterprisePermission_RoleDomainInput>;
  /** Organization ID */
  organizationId: Scalars['ID'];
  /** Role template id */
  templateId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** User role update response for either success of failure */
export type EnterprisePermission_UpdateUserRolesResult = EnterprisePermission_UpdateUserRolesResultFailure | EnterprisePermission_UpdateUserRolesResultSuccess;

/** Failure updating user roles */
export type EnterprisePermission_UpdateUserRolesResultFailure = {
  __typename?: 'EnterprisePermission_UpdateUserRolesResultFailure';
  /** Errors */
  error: EnterprisePermission_UserRoles_Error;
};

/** Success updating user roles */
export type EnterprisePermission_UpdateUserRolesResultSuccess = {
  __typename?: 'EnterprisePermission_UpdateUserRolesResultSuccess';
  /** Flag indicating if the update was completed successfully. */
  success: Scalars['Boolean'];
};

/** Enterprise Permission User Role Error */
export type EnterprisePermission_UserRoles_Error = Error & {
  __typename?: 'EnterprisePermission_UserRoles_Error';
  /** Error message */
  message: Scalars['String'];
};

/** Queries related to enterprise gradebook plagiarism report */
export type EnterprisePlagiarismReportQueries = {
  __typename?: 'EnterprisePlagiarismReportQueries';
  /** This query returns learner's program level plagiarism report by searching userId and programId. */
  queryByUserAndProgram: EnterprisePlagiarismReport_LearnerPlagiarismReport;
  /** This query returns plagiarism report list by program. */
  queryPlagiarismReportListByProgram: EnterprisePlagiarismReport_PlagiarismReportListByProgramPaginatedResult;
  /** This query returns plagiarism report summaries by program. */
  queryPlagiarismReportSummaryByProgram: EnterprisePlagiarismReport_ProgramLevelPlagiarismReportSummary;
};


/** Queries related to enterprise gradebook plagiarism report */
export type EnterprisePlagiarismReportQueriesQueryByUserAndProgramArgs = {
  programId: Scalars['ID'];
  userId: Scalars['ID'];
};


/** Queries related to enterprise gradebook plagiarism report */
export type EnterprisePlagiarismReportQueriesQueryPlagiarismReportListByProgramArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  limit?: Scalars['Int'];
  nameOrEmail?: InputMaybe<Scalars['String']>;
  preset: EnterprisePlagiarismReport_PlagiarismReportUsersPreset;
  programId: Scalars['ID'];
  sortAscending?: Scalars['Boolean'];
  sortBy?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};


/** Queries related to enterprise gradebook plagiarism report */
export type EnterprisePlagiarismReportQueriesQueryPlagiarismReportSummaryByProgramArgs = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  programId: Scalars['ID'];
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Enterprise gradebook plagiarism report for learner */
export type EnterprisePlagiarismReport_LearnerPlagiarismReport = {
  __typename?: 'EnterprisePlagiarismReport_LearnerPlagiarismReport';
  /** Learner's appeal denied count */
  appealsDeniedCount: Scalars['Int'];
  /** Learner's appeal granted count */
  appealsGrantedCount: Scalars['Int'];
  /** Learner's appeal submitted count */
  appealsSubmittedCount: Scalars['Int'];
  /** List of courses that learner has plagiarism record */
  courses: Array<Course_Course>;
  /** Email for this plagiarism report */
  email: Scalars['String'];
  /** FullName for this plagiarism report */
  fullName: Scalars['String'];
  /** Learner's last activity time */
  lastActivityAtTime: Scalars['DateTime'];
  /** Learner's plagiarism confirmed count */
  plagiarismsCount: Scalars['Int'];
  /** User for this plagiarism report */
  user: User_User;
};

/** Paginated list of plagiarism reports */
export type EnterprisePlagiarismReport_PlagiarismReportListByProgramPaginatedResult = {
  __typename?: 'EnterprisePlagiarismReport_PlagiarismReportListByProgramPaginatedResult';
  /** List of plagiarism reports for current page */
  elements: Array<EnterprisePlagiarismReport_LearnerPlagiarismReport>;
  /** Pagination for elements */
  pagination: Pagination;
};

/** Search preset for plagiarism report list */
export const EnterprisePlagiarismReport_PlagiarismReportUsersPreset = {
  /** Appeal denied */
  AppealDenied: 'APPEAL_DENIED',
  /** Appeal granted */
  AppealGranted: 'APPEAL_GRANTED',
  /** Appeal submitted */
  AppealSubmitted: 'APPEAL_SUBMITTED',
  /** Plagiarized */
  Plagiarized: 'PLAGIARIZED'
} as const;

export type EnterprisePlagiarismReport_PlagiarismReportUsersPreset = typeof EnterprisePlagiarismReport_PlagiarismReportUsersPreset[keyof typeof EnterprisePlagiarismReport_PlagiarismReportUsersPreset];
/** Program-level plagiarism report summary */
export type EnterprisePlagiarismReport_ProgramLevelPlagiarismReportSummary = {
  __typename?: 'EnterprisePlagiarismReport_ProgramLevelPlagiarismReportSummary';
  /** Total number of appeals denied in program */
  appealsDeniedCount: Scalars['Int'];
  /** Total number of appeals granted in program */
  appealsGrantedCount: Scalars['Int'];
  /** Total number of appeals submitted in program */
  appealsSubmittedCount: Scalars['Int'];
  /** Total count of plagiarism detected in program */
  plagiarismCount: Scalars['Int'];
};

/** Domain-specific interface for errors. */
export type EnterprisePrivateCourses_AddToProgramError = {
  /** Error message. */
  message: Scalars['String'];
};

/** Failure response. */
export type EnterprisePrivateCourses_AddToProgramFailure = {
  __typename?: 'EnterprisePrivateCourses_AddToProgramFailure';
  /**
   * Errors that can be returned.
   * Typically there is just one error but returning a list to keep the interface flexible.
   */
  errors: Array<EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound>;
};

/** Input for AddToProgram mutation */
export type EnterprisePrivateCourses_AddToProgramInput = {
  /**
   * ID of the collection in the program if the user is adding the course to a specific collection.
   * Otherwise it will create a new default collection if none is specified.
   */
  collectionId?: InputMaybe<Scalars['ID']>;
  /** ID of the course being added. */
  courseId: Scalars['ID'];
  /** ID of the program that the course is intended to be added to. */
  programId: Scalars['ID'];
};

/** Mutation result, can either be a success or failure. */
export type EnterprisePrivateCourses_AddToProgramResult = EnterprisePrivateCourses_AddToProgramFailure | EnterprisePrivateCourses_AddToProgramSuccess;

/** Success response. */
export type EnterprisePrivateCourses_AddToProgramSuccess = {
  __typename?: 'EnterprisePrivateCourses_AddToProgramSuccess';
  /** Program that the course was added to. */
  enterpriseProgram: EnterpriseProgram;
};

/** Error returned when the requested collection is not found. */
export type EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram = EnterprisePrivateCourses_AddToProgramError & Error & {
  __typename?: 'EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram';
  /** Error message. */
  message: Scalars['String'];
};

/**
 * Error returned when the program content restrictions does not allow for the course to be added to the program,
 * likely due to the private course containing content from courses that are not permitted in that program's context.
 */
export type EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted = EnterprisePrivateCourses_AddToProgramError & Error & {
  __typename?: 'EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted';
  /** Error message. */
  message: Scalars['String'];
};

/** Error returned when the requested program is not found. */
export type EnterprisePrivateCourses_AddToProgram_ProgramNotFound = EnterprisePrivateCourses_AddToProgramError & Error & {
  __typename?: 'EnterprisePrivateCourses_AddToProgram_ProgramNotFound';
  /** Error message. */
  message: Scalars['String'];
};

export type EnterpriseProductConfigurationMetadataV1 = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1';
  associatedSession?: Maybe<OnDemandCourseSessionsV1>;
  id: Scalars['String'];
  metadataType: EnterpriseProductConfigurationMetadataV1_MetadataType;
  productId: EnterpriseProductConfigurationMetadataV1_Org_Coursera_Product_ProductId;
  scopeId: Scalars['String'];
};

export type EnterpriseProductConfigurationMetadataV1Connection = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1Connection';
  elements: Array<Maybe<EnterpriseProductConfigurationMetadataV1>>;
  paging: ResponsePagination;
};

export type EnterpriseProductConfigurationMetadataV1Resource = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1Resource';
  get?: Maybe<EnterpriseProductConfigurationMetadataV1>;
  multiGet?: Maybe<EnterpriseProductConfigurationMetadataV1Connection>;
};


export type EnterpriseProductConfigurationMetadataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseProductConfigurationMetadataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProductConfigurationMetadataV1_CourseMember = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1_courseMember';
  course: EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationMetadata;
};

export type EnterpriseProductConfigurationMetadataV1_MetadataType = EnterpriseProductConfigurationMetadataV1_CourseMember | EnterpriseProductConfigurationMetadataV1_SpecializationMember;

export type EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationMetadata = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1_org_coursera_enterprise_productconfigurations_EnterpriseCourseConfigurationMetadata';
  associatedSessionId?: Maybe<Scalars['String']>;
  configurationStatus?: Maybe<EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus>;
  courseId: Scalars['String'];
  hasMultipleOfferings: Scalars['Boolean'];
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  isAutoEnrollmentHidden: Scalars['Boolean'];
  isConfigurationAllowed: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  isRecommendedForCredit: Scalars['Boolean'];
  isSelectedForCredit: Scalars['Boolean'];
  isSelectedToRequireAllItemCompletion: Scalars['Boolean'];
};

export const EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus = {
  Failed: 'FAILED',
  Processing: 'PROCESSING'
} as const;

export type EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus = typeof EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus[keyof typeof EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus];
export type EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseSpecializationConfigurationMetadata = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1_org_coursera_enterprise_productconfigurations_EnterpriseSpecializationConfigurationMetadata';
  associatedSessionId?: Maybe<Scalars['String']>;
  configurationStatus?: Maybe<EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseCourseConfigurationStatus>;
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  isAutoEnrollmentHidden: Scalars['Boolean'];
  isConfigurationAllowed: Scalars['Boolean'];
  isRecommendedForCredit: Scalars['Boolean'];
  isSelectedForCredit: Scalars['Boolean'];
  isSelectedToRequireAllItemCompletion: Scalars['Boolean'];
  isSpecializationConfigured: Scalars['Boolean'];
  s12nId: Scalars['String'];
};

export type EnterpriseProductConfigurationMetadataV1_Org_Coursera_Product_ProductId = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1_org_coursera_product_ProductId';
  productItemId: Scalars['String'];
};

export type EnterpriseProductConfigurationMetadataV1_SpecializationMember = {
  __typename?: 'EnterpriseProductConfigurationMetadataV1_specializationMember';
  specialization: EnterpriseProductConfigurationMetadataV1_Org_Coursera_Enterprise_Productconfigurations_EnterpriseSpecializationConfigurationMetadata;
};

export type EnterpriseProductRecommendationsV1 = {
  __typename?: 'EnterpriseProductRecommendationsV1';
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  description?: Maybe<Scalars['String']>;
  entities: Array<Maybe<EnterpriseProductRecommendationsV1_Org_Coursera_Recs_SemiPersonalizedRecsModuleEntity>>;
  entityIdsAsString?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  recId: EnterpriseProductRecommendationsV1_Org_Coursera_Recs_Models_RecModuleIdAndAttibutes;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  sectionId?: Maybe<Scalars['String']>;
  specializationIds: Array<Maybe<Scalars['String']>>;
};


export type EnterpriseProductRecommendationsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProductRecommendationsV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProductRecommendationsV1Connection = {
  __typename?: 'EnterpriseProductRecommendationsV1Connection';
  elements: Array<Maybe<EnterpriseProductRecommendationsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseProductRecommendationsV1Resource = {
  __typename?: 'EnterpriseProductRecommendationsV1Resource';
  get?: Maybe<EnterpriseProductRecommendationsV1>;
  multiGet?: Maybe<EnterpriseProductRecommendationsV1Connection>;
};


export type EnterpriseProductRecommendationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseProductRecommendationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProductRecommendationsV1_Org_Coursera_Recs_SemiPersonalizedRecsModuleEntity = {
  __typename?: 'EnterpriseProductRecommendationsV1_org_coursera_recs_SemiPersonalizedRecsModuleEntity';
  attributeId?: Maybe<Scalars['String']>;
  attributeTypeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  entityRank: Scalars['Int'];
  sectionId: Scalars['String'];
};

export type EnterpriseProductRecommendationsV1_Org_Coursera_Recs_Models_RecModuleIdAndAttibutes = {
  __typename?: 'EnterpriseProductRecommendationsV1_org_coursera_recs_models_RecModuleIdAndAttibutes';
  attribute1: Scalars['String'];
  attribute2: Scalars['String'];
  recModuleId: Scalars['String'];
};

/** An Enterprise Program - extended for federation */
export type EnterpriseProgram = Node & {
  __typename?: 'EnterpriseProgram';
  /** The curriculum tied to the program. */
  curriculumId: Scalars['String'];
  /** The program description */
  description?: Maybe<Scalars['String']>;
  /** The time at which the program ended */
  endedAt?: Maybe<Scalars['DateTime']>;
  /** EnterpriseProgram id. */
  id: Scalars['ID'];
  /** The url for the landing page banner image */
  landingPageBanner?: Maybe<Scalars['String']>;
  /** The time at which the program is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** Academic Discipline IDs linked to the program */
  linkedAcademicDisciplineIds?: Maybe<Array<Scalars['ID']>>;
  /** Skillset IDs linked to the program */
  linkedTargetSkillProfileIds?: Maybe<Array<Scalars['ID']>>;
  /** The maximum number of courses an individual learner can enroll in */
  maxCoursesPerUser?: Maybe<Scalars['Int']>;
  /** The program slug */
  name: Scalars['String'];
  /** The third party organization this program belongs to, resolved through Naptime via GraphQL Mesh */
  naptimeThirdPartyOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  /** Primary color for the program */
  primaryColor?: Maybe<Scalars['String']>;
  /** Rectangular logo for the program */
  rectangularLogo?: Maybe<Scalars['URL']>;
  /** Skillset availability type for the program */
  skillsetAvailabilityType?: Maybe<EnterpriseProgram_SkillsetAvailabilityType>;
  /** The program slug */
  slug: Scalars['String'];
  /** Square logo for the program */
  squareLogo?: Maybe<Scalars['URL']>;
  /** The program tagline */
  tagline?: Maybe<Scalars['String']>;
  /**
   * The id for the third party organization this program belongs to.
   * @deprecated Use naptimeThirdPartyOrganization instead
   */
  thirdPartyOrganizationId: Scalars['ID'];
  /** The id for the tutorial video relation for the program */
  tutorialVideoAssetId?: Maybe<Scalars['String']>;
  /** The user rosters associated with this program | Maximum page size: 1000 */
  userRosters?: Maybe<EnterpriseUserRosterConnection>;
};


/** An Enterprise Program - extended for federation */
export type EnterpriseProgramUserRostersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type EnterpriseProgramCurriculumSummariesV2 = {
  __typename?: 'EnterpriseProgramCurriculumSummariesV2';
  courseSummaries: Scalars['JSON'];
  id: Scalars['String'];
};

export type EnterpriseProgramCurriculumSummariesV2Connection = {
  __typename?: 'EnterpriseProgramCurriculumSummariesV2Connection';
  elements: Array<Maybe<EnterpriseProgramCurriculumSummariesV2>>;
  paging: ResponsePagination;
};

export type EnterpriseProgramCurriculumSummariesV2Resource = {
  __typename?: 'EnterpriseProgramCurriculumSummariesV2Resource';
  get?: Maybe<EnterpriseProgramCurriculumSummariesV2>;
  multiGet?: Maybe<EnterpriseProgramCurriculumSummariesV2Connection>;
};


export type EnterpriseProgramCurriculumSummariesV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseProgramCurriculumSummariesV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProgramDraftsV1 = {
  __typename?: 'EnterpriseProgramDraftsV1';
  id: Scalars['String'];
  status: EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus;
};

export type EnterpriseProgramDraftsV1Connection = {
  __typename?: 'EnterpriseProgramDraftsV1Connection';
  elements: Array<Maybe<EnterpriseProgramDraftsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseProgramDraftsV1Resource = {
  __typename?: 'EnterpriseProgramDraftsV1Resource';
  get?: Maybe<EnterpriseProgramDraftsV1>;
  multiGet?: Maybe<EnterpriseProgramDraftsV1Connection>;
};


export type EnterpriseProgramDraftsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseProgramDraftsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus = {
  ContentAndMembers: 'CONTENT_AND_MEMBERS',
  ContentOnly: 'CONTENT_ONLY',
  MembersOnly: 'MEMBERS_ONLY',
  NoContentOrMembers: 'NO_CONTENT_OR_MEMBERS'
} as const;

export type EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus = typeof EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus[keyof typeof EnterpriseProgramDraftsV1_Org_Coursera_Program_Draft_ProgramDraftStatus];
/** Program membership states */
export const EnterpriseProgramMemberships_ProgramMembershipState = {
  /** TODO: Complete this description */
  ProgramMembershipStateAllowlisted: 'PROGRAM_MEMBERSHIP_STATE_ALLOWLISTED',
  /** TODO: Complete this description */
  ProgramMembershipStateDeletedMember: 'PROGRAM_MEMBERSHIP_STATE_DELETED_MEMBER',
  /** TODO: Complete this description */
  ProgramMembershipStateInvalid: 'PROGRAM_MEMBERSHIP_STATE_INVALID',
  /** TODO: Complete this description */
  ProgramMembershipStateInvited: 'PROGRAM_MEMBERSHIP_STATE_INVITED',
  /** TODO: Complete this description */
  ProgramMembershipStateMember: 'PROGRAM_MEMBERSHIP_STATE_MEMBER',
  /** TODO: Complete this description */
  ProgramMembershipStateSoftDeletedMember: 'PROGRAM_MEMBERSHIP_STATE_SOFT_DELETED_MEMBER'
} as const;

export type EnterpriseProgramMemberships_ProgramMembershipState = typeof EnterpriseProgramMemberships_ProgramMembershipState[keyof typeof EnterpriseProgramMemberships_ProgramMembershipState];
/** All EnterpriseProgram queries */
export type EnterpriseProgramQueries = {
  __typename?: 'EnterpriseProgramQueries';
  /** Get the system program associated with the given organization ID */
  getSystemProgram?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /**
   * Fetches the static skill profile collection for a given org and target skill profile.
   * Resolves the user's enrolled programs within the org, intersects with TSP-linked programs,
   * and merges collection items across those programs. Returns empty if no static collection
   * is configured on the TSP or if no intersecting programs exist.
   */
  orgSkillProfileCollection?: Maybe<EnterpriseProgram_OrgSkillProfileCollectionResult>;
  /** Query for a program by its curriculum ID */
  queryByCurriculumId?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /** Query for multiple programs by their ids */
  queryByIds: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /** Query programs that are associated with the given organization ID */
  queryByOrgId: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /** Query programs that are associated with the given organization ID and skillset ID */
  queryByOrgIdAndSkillsetId: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /** Query programs that are associated with the given organization slug */
  queryByOrganizationSlug: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /** Query programs that are associated with the given skillset ID */
  queryBySkillsetId: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /** Query for a program by its slug */
  queryBySlug?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /** Query program generation request by create request id */
  queryProgramGenerationRequestByCreateRequestId?: Maybe<EnterpriseProgram_GetProgramGenerationRequestResult>;
  /** Query program generation request by program id */
  queryProgramGenerationRequestByProgramId?: Maybe<EnterpriseProgram_GetProgramGenerationRequestResult>;
  /** Query program suggestions by program id */
  queryProgramSuggestions?: Maybe<EnterpriseProgram_ProgramSuggestionsResult>;
  /** Resolve program IDs associated with the given organization slug */
  resolveProgramsByOrganization: EnterpriseProgram_EnterpriseProgramPaginatedResult;
  /**
   * Validates whether the given programs share identical content access.
   * Returns isValid=true if all programs have the same permitted products
   * (same access type and same product set). Requires at least 2 program IDs.
   */
  validateContentAccess: EnterpriseProgram_ValidateContentAccessResult;
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesGetSystemProgramArgs = {
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesOrgSkillProfileCollectionArgs = {
  orgSlug: Scalars['String'];
  targetSkillProfileId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryByCurriculumIdArgs = {
  curriculumId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryByIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programIds: Array<Scalars['ID']>;
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryByOrgIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeArchived?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryByOrgIdAndSkillsetIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeArchived?: Scalars['Boolean'];
  includeProgramsWithAllSkillsets?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  skillsetId: Scalars['ID'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryByOrganizationSlugArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeArchived?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  organizationSlug: Scalars['String'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryBySkillsetIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeArchived?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  skillsetId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryProgramGenerationRequestByCreateRequestIdArgs = {
  programCreateRequestId: Scalars['ID'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryProgramGenerationRequestByProgramIdArgs = {
  programId: Scalars['ID'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesQueryProgramSuggestionsArgs = {
  programId: Scalars['ID'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesResolveProgramsByOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeArchived?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};


/** All EnterpriseProgram queries */
export type EnterpriseProgramQueriesValidateContentAccessArgs = {
  programIds: Array<Scalars['ID']>;
};

export type EnterpriseProgramSessionAssociationsV1 = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1';
  addedAt: Scalars['Float'];
  /** id for a Coursera user */
  addedBy: Scalars['Int'];
  associationType: EnterpriseProgramSessionAssociationsV1_AssociationType;
  baseS12nId?: Maybe<Scalars['String']>;
  courseId: Scalars['String'];
  deletedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  programId: Scalars['String'];
  session?: Maybe<OnDemandCourseSessionsV1>;
  sessionId: Scalars['String'];
};

export type EnterpriseProgramSessionAssociationsV1ByCourse = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByCourse';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  courseId: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByProgram = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByProgram';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByProgramAndCourse = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByProgramAndCourse';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  courseId: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByProgramAndCourses = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByProgramAndCourses';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByPrograms = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByPrograms';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByProgramsAndCourse = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByProgramsAndCourse';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  courseId: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ByProgramsAndSpecializations = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ByProgramsAndSpecializations';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programIds: Array<Maybe<Scalars['String']>>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1BySession = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1BySession';
  connection?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1Connection = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1Connection';
  elements: Array<Maybe<EnterpriseProgramSessionAssociationsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseProgramSessionAssociationsV1Resource = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1Resource';
  byCourse?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byProgram?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byProgramAndCourse?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byProgramAndCourses?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byPrograms?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byProgramsAndCourse?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  byProgramsAndSpecializations?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  bySession?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  get?: Maybe<EnterpriseProgramSessionAssociationsV1>;
  getAll?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByCourseArgs = {
  courseId: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramAndCourseArgs = {
  courseId: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramAndCoursesArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramsAndCourseArgs = {
  courseId: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceByProgramsAndSpecializationsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programIds: Array<InputMaybe<Scalars['String']>>;
  s12nIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceBySessionArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceGetArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceGetAllArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProgramSessionAssociationsV1ResourceMutations = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1ResourceMutations';
  create?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  delete?: Maybe<EnterpriseProgramSessionAssociationsV1Connection>;
  hardDelete?: Maybe<Scalars['JSON']>;
  upsert?: Maybe<Scalars['JSON']>;
};


export type EnterpriseProgramSessionAssociationsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseProgramSessionAssociationsV1ResourceMutationsHardDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseProgramSessionAssociationsV1ResourceMutationsUpsertArgs = {
  skipValidation?: InputMaybe<Scalars['Boolean']>;
};

/** Metadata regarding the type of private session enrollment. If in the future we need to support different types of session enrollment (e.g. groupless, multi-group), we can add additional union members here. */
export type EnterpriseProgramSessionAssociationsV1_AssociationType = EnterpriseProgramSessionAssociationsV1_ExternallyManagedMember | EnterpriseProgramSessionAssociationsV1_GroupEnrollmentMember;

export type EnterpriseProgramSessionAssociationsV1_ExternallyManagedMember = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1_externallyManagedMember';
  externallyManaged: EnterpriseProgramSessionAssociationsV1_Org_Coursera_Enterprise_Sessions_EnterpriseProgramSessionAssociationExternallyManaged;
};

export type EnterpriseProgramSessionAssociationsV1_GroupEnrollmentMember = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1_groupEnrollmentMember';
  groupEnrollment: EnterpriseProgramSessionAssociationsV1_Org_Coursera_Enterprise_Sessions_EnterpriseProgramSessionAssociationGroupEnrollment;
};

/** Represents a session created through the enterprise admin experience. */
export type EnterpriseProgramSessionAssociationsV1_Org_Coursera_Enterprise_Sessions_EnterpriseProgramSessionAssociationExternallyManaged = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1_org_coursera_enterprise_sessions_EnterpriseProgramSessionAssociationExternallyManaged';
  firstAssociatedAt: Scalars['Float'];
  name: Scalars['String'];
  referenceOpenSessionId?: Maybe<Scalars['String']>;
};

/** Represents an authored private session with a group. */
export type EnterpriseProgramSessionAssociationsV1_Org_Coursera_Enterprise_Sessions_EnterpriseProgramSessionAssociationGroupEnrollment = {
  __typename?: 'EnterpriseProgramSessionAssociationsV1_org_coursera_enterprise_sessions_EnterpriseProgramSessionAssociationGroupEnrollment';
  groupId: Scalars['String'];
};

export type EnterpriseProgramSummariesV2 = {
  __typename?: 'EnterpriseProgramSummariesV2';
  courseCount: Scalars['Int'];
  createdAt?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export type EnterpriseProgramSummariesV2ByThirdPartyOrganizationId = {
  __typename?: 'EnterpriseProgramSummariesV2ByThirdPartyOrganizationId';
  connection?: Maybe<EnterpriseProgramSummariesV2Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramSummariesV2Connection = {
  __typename?: 'EnterpriseProgramSummariesV2Connection';
  elements: Array<Maybe<EnterpriseProgramSummariesV2>>;
  paging: ResponsePagination;
};

export type EnterpriseProgramSummariesV2Resource = {
  __typename?: 'EnterpriseProgramSummariesV2Resource';
  byThirdPartyOrganizationId?: Maybe<EnterpriseProgramSummariesV2Connection>;
  get?: Maybe<EnterpriseProgramSummariesV2>;
  multiGet?: Maybe<EnterpriseProgramSummariesV2Connection>;
};


export type EnterpriseProgramSummariesV2ResourceByThirdPartyOrganizationIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramSummariesV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseProgramSummariesV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Failure response for EnterpriseAdmin_CreateInvitationsOrRoles */
export type EnterpriseProgram_ArchiveFailure = {
  __typename?: 'EnterpriseProgram_ArchiveFailure';
  /** Errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Enterprise Program Archive input */
export type EnterpriseProgram_ArchiveInput = {
  /** Flag to set whether to run programArchiveCleanup job */
  includeCleanup: Scalars['Boolean'];
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** Flag to set sendMembershipDeletionNotificationflag param in programArchiveCleanup job */
  sendMembershipDeletionNotification: Scalars['Boolean'];
};

/** Success and failure handling for Enterprise Program Archive mutation */
export type EnterpriseProgram_ArchiveResult = EnterpriseProgram_ArchiveFailure | EnterpriseProgram_ArchiveSuccess;

/** Success archiving program */
export type EnterpriseProgram_ArchiveSuccess = {
  __typename?: 'EnterpriseProgram_ArchiveSuccess';
  /** Flag indicating if data was received and will be processed. */
  success: Scalars['Boolean'];
};

/** Collection item in the suggestions, union of Course or s12n will be set, also clips */
export type EnterpriseProgram_CollectionItem = Clip_CourseItem | Course_Course | Specialization_Specialization;

/** Generated suggestions for the program */
export type EnterpriseProgram_CollectionSuggestions = {
  __typename?: 'EnterpriseProgram_CollectionSuggestions';
  /** List of items either containing course or s12n */
  collectionItems: Array<EnterpriseProgram_CollectionItem>;
  /** Description of the collection */
  description: Scalars['String'];
  /** Name of the collection */
  name: Scalars['String'];
};

/** Reason why content access validation failed. */
export const EnterpriseProgram_ContentAccessFailureReason = {
  /** Programs have different content access restrictions and cannot be used together. */
  CrossGroupMismatch: 'CROSS_GROUP_MISMATCH',
  /** No failure — all programs share the same content access. */
  None: 'NONE'
} as const;

export type EnterpriseProgram_ContentAccessFailureReason = typeof EnterpriseProgram_ContentAccessFailureReason[keyof typeof EnterpriseProgram_ContentAccessFailureReason];
/** Failure response for EnterpriseProgram_Create */
export type EnterpriseProgram_CreateFailure = {
  __typename?: 'EnterpriseProgram_CreateFailure';
  /** Errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Enterprise Program Create Input */
export type EnterpriseProgram_CreateInput = {
  /** The program contract ID */
  contractId?: InputMaybe<Scalars['ID']>;
  /** The program curriculum ID */
  curriculumId?: InputMaybe<Scalars['ID']>;
  /** The program default to empty tracks curriculum flag */
  defaultToEmptyTracksCurriculum?: Scalars['Boolean'];
  /** The program landing page banner */
  landingPageBanner?: InputMaybe<Scalars['String']>;
  /** The program logo */
  logo?: InputMaybe<Scalars['URL']>;
  /** The program maximum courses per user */
  maxCoursesPerUser?: InputMaybe<Scalars['Int']>;
  /** The program name */
  name: Scalars['String'];
  /** The program slug */
  slug?: InputMaybe<Scalars['String']>;
  /** The program tagline */
  tagline?: InputMaybe<Scalars['String']>;
  /** The organization the program will be linked to */
  thirdPartyOrganizationId: Scalars['ID'];
  /** The program tutorial video asset id */
  tutorialVideoAssetId?: InputMaybe<Scalars['ID']>;
};

/** Success and failure handling for Enterprise Program Archive mutation */
export type EnterpriseProgram_CreateResult = EnterpriseProgram_CreateFailure | EnterpriseProgram_CreateSuccess;

/** Success creating program */
export type EnterpriseProgram_CreateSuccess = {
  __typename?: 'EnterpriseProgram_CreateSuccess';
  /** Newly created Enterprise Program */
  body: EnterpriseProgram_EnterpriseProgram;
  /** Flag indicating if data was received and will be processed. */
  success: Scalars['Boolean'];
};

/** Curation item type for the curation */
export const EnterpriseProgram_CurationItemType = {
  /** Course */
  Course: 'COURSE',
  /** Guided Project */
  GuidedProject: 'GUIDED_PROJECT',
  /** Professional Certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project */
  Project: 'PROJECT',
  /** Specialization */
  Specialization: 'SPECIALIZATION',
  /** Video */
  Video: 'VIDEO'
} as const;

export type EnterpriseProgram_CurationItemType = typeof EnterpriseProgram_CurationItemType[keyof typeof EnterpriseProgram_CurationItemType];
/** Curation options for the program */
export const EnterpriseProgram_CurationOrganization = {
  /** Roles */
  Roles: 'ROLES',
  /** Skills */
  Skills: 'SKILLS'
} as const;

export type EnterpriseProgram_CurationOrganization = typeof EnterpriseProgram_CurationOrganization[keyof typeof EnterpriseProgram_CurationOrganization];
/** List of roles or skills selected by the admin for the program */
export type EnterpriseProgram_CurationSelection = {
  /** List of roles the admin selected to be relevant to the program */
  roles?: InputMaybe<Array<Scalars['String']>>;
  /** List of skills the admin selected to be relevant to the program */
  skills?: InputMaybe<Array<Scalars['String']>>;
};

/** Curation type for the program */
export const EnterpriseProgram_CurationType = {
  /** Collections */
  Collections: 'COLLECTIONS',
  /** Learning Paths */
  LearningPaths: 'LEARNING_PATHS'
} as const;

export type EnterpriseProgram_CurationType = typeof EnterpriseProgram_CurationType[keyof typeof EnterpriseProgram_CurationType];
/** Model representing a program's domain allow list, grouped by programId. */
export type EnterpriseProgram_DomainAllowListByProgram = {
  __typename?: 'EnterpriseProgram_DomainAllowListByProgram';
  /** Email domains that are part of the program's allow list. */
  emailDomains: Array<Scalars['String']>;
  /** Id of the program. */
  programId: Scalars['String'];
};

/** Model representing stored information for an entry in a program's domain allowlist. */
export type EnterpriseProgram_DomainAllowListEntry = {
  __typename?: 'EnterpriseProgram_DomainAllowListEntry';
  /** Email domain that is part of the allow list. */
  emailDomain: Scalars['String'];
  /** Id of the program, */
  programId: Scalars['String'];
  /**
   * Roster id associated with the allow list entry. This is used when a user join's a program
   * by being registered with an email whose domain is part of the program's allow list.
   */
  rosterId?: Maybe<Scalars['String']>;
};

/** Represents EnterpriseProgram entity stub - Added for federation */
export type EnterpriseProgram_EnterpriseProgram = {
  __typename?: 'EnterpriseProgram_EnterpriseProgram';
  /** The program description */
  description?: Maybe<Scalars['String']>;
  /** The time at which the program ended */
  endedAt?: Maybe<Scalars['DateTime']>;
  /** EnterpriseProgram id. */
  id: Scalars['ID'];
  /**
   * The url for the landing page banner image
   * Example: https://coursera-university-assets.s3.amazonaws.com/5e/61853ce44342cebf3c80c12a627785/Coursera.Logo3.jpg
   */
  landingPageBanner?: Maybe<Scalars['URL']>;
  /** The time at which the program is launched */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** Academic Discipline ID linked to the program */
  linkedAcademicDisciplineIds?: Maybe<Array<Scalars['ID']>>;
  /** The maximum number of courses an individual learner can enroll in */
  maxCoursesPerUser?: Maybe<Scalars['Int']>;
  /** The program slug */
  name: Scalars['String'];
  /** The curriculum tied to the program. */
  naptimeCurriculum: ProgramCurriculumsV1;
  /** Skillsets linked to the program */
  naptimeLinkedTargetSkillProfiles?: Maybe<Array<EnterpriseTargetSkillProfilesV1>>;
  /** The third party organization this program belongs to, resolved through Naptime via GraphQL Mesh */
  naptimeThirdPartyOrganization: ThirdPartyOrganizationsV1;
  /** Primary color for the program */
  primaryColor?: Maybe<Scalars['String']>;
  /** Rectangular logo for the program */
  rectangularLogo?: Maybe<Scalars['URL']>;
  /** Skillset availability type for the program */
  skillsetAvailabilityType?: Maybe<EnterpriseProgram_SkillsetAvailabilityType>;
  /** The program slug */
  slug: Scalars['String'];
  /** Square logo for the program */
  squareLogo?: Maybe<Scalars['URL']>;
  /** The program tagline */
  tagline?: Maybe<Scalars['String']>;
  /** The id for the tutorial video relation for the program */
  tutorialVideoAssetId?: Maybe<Scalars['ID']>;
  /** The url for the tutorial video relation for the program */
  tutorialVideoUrl?: Maybe<Scalars['URL']>;
};

/** Pagination for EnterprisePrograms results. */
export type EnterpriseProgram_EnterpriseProgramPaginatedResult = {
  __typename?: 'EnterpriseProgram_EnterpriseProgramPaginatedResult';
  /** A list of enterprise programs. */
  elements: Array<EnterpriseProgram_EnterpriseProgram>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Errors for the  EnterpriseProgram_GenerateProgramFileUploadLocation */
export const EnterpriseProgram_FileLocationErrors = {
  /** Invalid file type */
  InvalidFileType: 'INVALID_FILE_TYPE',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_FileLocationErrors = typeof EnterpriseProgram_FileLocationErrors[keyof typeof EnterpriseProgram_FileLocationErrors];
/** Enterprise Program Generate Outline Generate Request Input */
export type EnterpriseProgram_GenerateProgramContext = {
  /** The S3 object of the files uploaded by the user */
  files?: InputMaybe<Array<EnterpriseProgram_GenerateProgramS3FileInput>>;
  /** The optional prompt used to generate the outline */
  prompt?: InputMaybe<Scalars['String']>;
};

/** Failure response for EnterpriseProgram_GenerateProgramFileUploadLocation */
export type EnterpriseProgram_GenerateProgramFileUploadLocationFailure = {
  __typename?: 'EnterpriseProgram_GenerateProgramFileUploadLocationFailure';
  /** Error code */
  code: EnterpriseProgram_FileLocationErrors;
  /** Error message */
  message: Scalars['String'];
};

/** Input for EnterpriseProgram_GenerateProgramFileUploadLocation */
export type EnterpriseProgram_GenerateProgramFileUploadLocationInput = {
  /** File name */
  fileName: Scalars['String'];
  /** The existing ID of the program if just adding to a program */
  programId?: InputMaybe<Scalars['ID']>;
  /** Org ID related to program generation. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Success and failure handling for Enterprise Program file upload location */
export type EnterpriseProgram_GenerateProgramFileUploadLocationResult = EnterpriseProgram_GenerateProgramFileUploadLocationFailure | EnterpriseProgram_GenerateProgramFileUploadLocationSuccess;

/** Response for generate file upload location result. Returns S3 bucket and key, and a signed upload URL */
export type EnterpriseProgram_GenerateProgramFileUploadLocationSuccess = {
  __typename?: 'EnterpriseProgram_GenerateProgramFileUploadLocationSuccess';
  /** S3 bucket and key for the file */
  fileUploadLocation: EnterpriseProgram_S3File;
  /** Signed upload URL for the file */
  signedUploadUrl: Scalars['URL'];
};

/** Failure response for EnterpriseProgram_GenerateProgramOutline */
export type EnterpriseProgram_GenerateProgramOutlineFailure = {
  __typename?: 'EnterpriseProgram_GenerateProgramOutlineFailure';
  /** Error code */
  code: EnterpriseProgram_GenerationErrors;
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise Program Generate Outline Input */
export type EnterpriseProgram_GenerateProgramOutlineInput = {
  /** Information needed to generate the program outline given by the user, either a prompt or files */
  context?: InputMaybe<EnterpriseProgram_GenerateProgramContext>;
  /** The 2 letter code of the language of the program ex. "EN" or "ES" */
  language?: InputMaybe<Scalars['String']>;
  /** The existing ID of the program if just adding to a program */
  programId?: InputMaybe<Scalars['ID']>;
  /** The organization the program will be linked to, used for auth */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Success and failure handling for Enterprise Program Outline Generation  mutation */
export type EnterpriseProgram_GenerateProgramOutlineResult = EnterpriseProgram_GenerateProgramOutlineFailure | EnterpriseProgram_GenerateProgramOutlineSuccess;

/** Success response for EnterpriseProgram_GenerateProgramOutline */
export type EnterpriseProgram_GenerateProgramOutlineSuccess = {
  __typename?: 'EnterpriseProgram_GenerateProgramOutlineSuccess';
  /** Response from the LLM */
  body: EnterpriseProgram_GeneratedProgramOutline;
};

/** S3 file location as an input */
export type EnterpriseProgram_GenerateProgramS3FileInput = {
  /** S3 Bucket containing the file */
  bucket: Scalars['String'];
  /** S3 Key (path and file name) */
  key: Scalars['String'];
};

/** Enterprise Program Generate Suggestions Input */
export type EnterpriseProgram_GenerateProgramSuggestionsInput = {
  /** Updated information needed to generate the program outline given by the user, either a prompt or files */
  context?: InputMaybe<EnterpriseProgram_GenerateProgramContext>;
  /** The curation item types for the Collection or Learning Path */
  curationItemTypes?: InputMaybe<Array<EnterpriseProgram_CurationItemType>>;
  /** The curation options for the program Skills or Roles */
  curationOrganization: EnterpriseProgram_CurationOrganization;
  /** List of roles or skills selected by the admin for the program */
  curationSelections: EnterpriseProgram_CurationSelection;
  /** The curation type for the program Collections or Learning Paths */
  curationType: EnterpriseProgram_CurationType;
  /** Generated description of the program */
  description: Scalars['String'];
  /** The 2 letter code of the language of the program ex. "EN" or "ES" */
  language?: InputMaybe<Scalars['String']>;
  /** The desired length of the learning path in number of hours */
  learningPathLengthInHours?: InputMaybe<Scalars['Int']>;
  /** Generated name of the program */
  name: Scalars['String'];
  /** The program id to get the Generation Request */
  programId: Scalars['ID'];
};

/** Success and failure handling for Enterprise Program generate program suggestions */
export type EnterpriseProgram_GenerateProgramSuggestionsResult = EnterpriseProgram_GenerateSuggestionsFailure | EnterpriseProgram_GenerateSuggestionsSuccess;

/** Errors enum for  Generate Suggestions */
export const EnterpriseProgram_GenerateSuggestionsErrors = {
  /** Job trigger failed */
  JobFailedToTrigger: 'JOB_FAILED_TO_TRIGGER',
  /** Distributed lock is locked */
  RequestAlreadyInProgress: 'REQUEST_ALREADY_IN_PROGRESS',
  /** Request not found */
  RequestNotFound: 'REQUEST_NOT_FOUND',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_GenerateSuggestionsErrors = typeof EnterpriseProgram_GenerateSuggestionsErrors[keyof typeof EnterpriseProgram_GenerateSuggestionsErrors];
/** Failure response for Generate Suggestions */
export type EnterpriseProgram_GenerateSuggestionsFailure = {
  __typename?: 'EnterpriseProgram_GenerateSuggestionsFailure';
  /** Error code */
  code: EnterpriseProgram_GenerateSuggestionsErrors;
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise Program Generate Suggestions Result */
export type EnterpriseProgram_GenerateSuggestionsSuccess = {
  __typename?: 'EnterpriseProgram_GenerateSuggestionsSuccess';
  /** Bool indicating success */
  success: Scalars['Boolean'];
};

/** Enterprise Program Generate Outline Results form the LLM */
export type EnterpriseProgram_GeneratedProgramOutline = {
  __typename?: 'EnterpriseProgram_GeneratedProgramOutline';
  /** Generated description of the program */
  description: Scalars['String'];
  /** Generated name of the program */
  name: Scalars['String'];
  /** Id of the request to link to the initial request */
  programCreateRequestId: Scalars['ID'];
  /** Generated list of roles */
  roles: Array<Scalars['String']>;
  /** Generated list of skills */
  skills: Array<Scalars['String']>;
};

/** Generation Errors for the program generation */
export const EnterpriseProgram_GenerationErrors = {
  /** Generation failed */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_GenerationErrors = typeof EnterpriseProgram_GenerationErrors[keyof typeof EnterpriseProgram_GenerationErrors];
/** Generation Status for the program generation */
export const EnterpriseProgram_GenerationStatus = {
  /** Suggestions generated */
  Completed: 'COMPLETED',
  /** Generation failed */
  Failed: 'FAILED',
  /** Outline generated */
  GeneratedOutline: 'GENERATED_OUTLINE',
  /** Generating the outline */
  GeneratingOutline: 'GENERATING_OUTLINE',
  /** Generating suggestions */
  GeneratingSuggestions: 'GENERATING_SUGGESTIONS'
} as const;

export type EnterpriseProgram_GenerationStatus = typeof EnterpriseProgram_GenerationStatus[keyof typeof EnterpriseProgram_GenerationStatus];
/** Enterprise Program Get Program Generation Request Result */
export type EnterpriseProgram_GetProgramGenerationRequestResult = {
  __typename?: 'EnterpriseProgram_GetProgramGenerationRequestResult';
  /** The curation item types for the Collection or Learning Path */
  curationItemTypes?: Maybe<Array<EnterpriseProgram_CurationItemType>>;
  /** The curation options for the program Skills or Roles */
  curationOrganization?: Maybe<EnterpriseProgram_CurationOrganization>;
  /** The curation type for the program Collections or Learning Paths */
  curationType?: Maybe<EnterpriseProgram_CurationType>;
  /** The path in S3 to the files uploaded by the user */
  files?: Maybe<Array<Scalars['String']>>;
  /** The language of the program ex. "en-US" */
  language?: Maybe<Scalars['String']>;
  /** The program id to get the Generation Request */
  programId: Scalars['ID'];
  /** The optional prompt used to generate the outline */
  prompt?: Maybe<Scalars['String']>;
  /** Generated list of roles */
  roles: Array<Scalars['String']>;
  /** Generated list of skills */
  skills: Array<Scalars['String']>;
  /** The status of the generation */
  status: EnterpriseProgram_GenerationStatus;
};

/** Learning Path suggestions for the program */
export type EnterpriseProgram_LearningPathSuggestions = {
  __typename?: 'EnterpriseProgram_LearningPathSuggestions';
  /** Approximate total length of the collection in hours */
  approximateLengthInHours?: Maybe<Scalars['Int']>;
  /** Courses in the collection */
  courses: Array<Course_Course>;
  /** Description of the collection */
  description: Scalars['String'];
  /** Learning objectives for the collection */
  learningObjectives: Array<Scalars['String']>;
  /** Name of the collection */
  name: Scalars['String'];
  /** Skill ids for the collection */
  skills: Array<Skill_Skill>;
};

/** Errors for the  EnterpriseProgram_LinkProgramWithGenerationRequests */
export const EnterpriseProgram_LinkProgramWithGenerationErrors = {
  /** Request not found */
  RequestNotFound: 'REQUEST_NOT_FOUND',
  /** Catch all error */
  UnexpectedError: 'UNEXPECTED_ERROR'
} as const;

export type EnterpriseProgram_LinkProgramWithGenerationErrors = typeof EnterpriseProgram_LinkProgramWithGenerationErrors[keyof typeof EnterpriseProgram_LinkProgramWithGenerationErrors];
/** Failure response for EnterpriseProgram_LinkProgramWithGenerationRequests */
export type EnterpriseProgram_LinkProgramWithGenerationFailure = {
  __typename?: 'EnterpriseProgram_LinkProgramWithGenerationFailure';
  /** Error code */
  code: EnterpriseProgram_LinkProgramWithGenerationErrors;
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise Program Link Program with request Input */
export type EnterpriseProgram_LinkProgramWithGenerationRequestsInput = {
  /** Id of the request to link to the initial request */
  programCreateRequestId: Scalars['ID'];
  /** The program id to get the Generation Request */
  programId: Scalars['ID'];
};

/** Success and failure handling for EnterpriseProgram_LinkProgramWithGenerationRequests */
export type EnterpriseProgram_LinkProgramWithGenerationRequestsResult = EnterpriseProgram_LinkProgramWithGenerationFailure | EnterpriseProgram_LinkProgramWithGenerationSuccess;

/** Enterprise EnterpriseProgram_LinkProgramWithGenerationRequests Result */
export type EnterpriseProgram_LinkProgramWithGenerationSuccess = {
  __typename?: 'EnterpriseProgram_LinkProgramWithGenerationSuccess';
  /** Bool indicating success */
  success: Scalars['Boolean'];
};

/** Result of the orgSkillProfileCollection query. */
export type EnterpriseProgram_OrgSkillProfileCollectionResult = {
  __typename?: 'EnterpriseProgram_OrgSkillProfileCollectionResult';
  /** The ordered, merged collection items. */
  items: Array<EnterpriseProgram_SkillProfileCollectionItem>;
  /** The programs whose collections contributed to this result. */
  programs: Array<EnterpriseProgram_SkillProfileProgramGroup>;
  /** The target skill profile ID. */
  targetSkillProfileId: Scalars['ID'];
  /** The display name of the target skill profile. */
  targetSkillProfileName: Scalars['String'];
  /** Total number of items. */
  totalItemCount: Scalars['Int'];
};

/** The result of generating program suggestions */
export type EnterpriseProgram_ProgramSuggestionsResult = {
  __typename?: 'EnterpriseProgram_ProgramSuggestionsResult';
  /** Suggestions for the program, should either be a custom collection or curated collection */
  collections?: Maybe<Array<EnterpriseProgram_SuggestedCollection>>;
  /** Description of the program, needed if the admin changes the generated description */
  description: Scalars['String'];
  /** Learning Path suggestions for the program */
  learningPathSuggestions?: Maybe<Array<EnterpriseProgram_LearningPathSuggestions>>;
  /** Name of the program, needed if the admin changes the generated name */
  name: Scalars['String'];
};

/** S3 file location */
export type EnterpriseProgram_S3File = {
  __typename?: 'EnterpriseProgram_S3File';
  /** S3 Bucket */
  bucket: Scalars['String'];
  /** S3 Key */
  key: Scalars['String'];
};

/** Union of federated content types for a skill profile collection item. */
export type EnterpriseProgram_SkillProfileCollectionContent = Course_Course | Specialization_Specialization;

/**
 * A single item in the skill profile collection. content is a federation entity reference
 * (Course_Course or Specialization_Specialization) that the gateway resolves to full content.
 */
export type EnterpriseProgram_SkillProfileCollectionItem = {
  __typename?: 'EnterpriseProgram_SkillProfileCollectionItem';
  /** The federated content entity — either a Course_Course or Specialization_Specialization. */
  content: EnterpriseProgram_SkillProfileCollectionContent;
  /** The content ID (course or specialization ID). */
  contentId: Scalars['ID'];
  /** The item type discriminator. */
  itemType: EnterpriseProgram_SkillProfileItemType;
  /** Zero-based sort order within the merged collection. */
  sortOrder: Scalars['Int'];
  /**
   * Programs from which this item originates. An item appears in sourcePrograms for every
   * program whose collection contains it.
   */
  sourcePrograms: Array<EnterpriseProgram_SkillProfileProgramGroup>;
};

/** Type of content item in a skill profile collection. */
export const EnterpriseProgram_SkillProfileItemType = {
  /** A course content item. */
  Course: 'COURSE',
  /** A specialization content item. */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseProgram_SkillProfileItemType = typeof EnterpriseProgram_SkillProfileItemType[keyof typeof EnterpriseProgram_SkillProfileItemType];
/** A program that contributes content to the skill profile collection. */
export type EnterpriseProgram_SkillProfileProgramGroup = {
  __typename?: 'EnterpriseProgram_SkillProfileProgramGroup';
  /** The program ID. */
  programId: Scalars['ID'];
  /** The program display name. */
  programName: Scalars['String'];
  /** The program slug. */
  programSlug: Scalars['String'];
};

/** Enum for skillset availability type associated with the program */
export const EnterpriseProgram_SkillsetAvailabilityType = {
  /** Program has all skillsets linked */
  SkillSetAvailabilityTypeAllSkillsets: 'SKILL_SET_AVAILABILITY_TYPE_ALL_SKILLSETS',
  /** Invalid */
  SkillSetAvailabilityTypeInvalid: 'SKILL_SET_AVAILABILITY_TYPE_INVALID',
  /** Program has specific skillsets linked to them */
  SkillSetAvailabilityTypeLinkedSkillsetsOnly: 'SKILL_SET_AVAILABILITY_TYPE_LINKED_SKILLSETS_ONLY'
} as const;

export type EnterpriseProgram_SkillsetAvailabilityType = typeof EnterpriseProgram_SkillsetAvailabilityType[keyof typeof EnterpriseProgram_SkillsetAvailabilityType];
/** Enum for skillset update mode */
export const EnterpriseProgram_SkillsetUpdateMode = {
  /** Append mode */
  SkillsetsUpdateModeAppend: 'SKILLSETS_UPDATE_MODE_APPEND',
  /** Invalid */
  SkillsetsUpdateModeInvalid: 'SKILLSETS_UPDATE_MODE_INVALID',
  /** Remove mode */
  SkillsetsUpdateModeRemove: 'SKILLSETS_UPDATE_MODE_REMOVE',
  /** Reorder mode */
  SkillsetsUpdateModeReorder: 'SKILLSETS_UPDATE_MODE_REORDER'
} as const;

export type EnterpriseProgram_SkillsetUpdateMode = typeof EnterpriseProgram_SkillsetUpdateMode[keyof typeof EnterpriseProgram_SkillsetUpdateMode];
/** Collection suggestions for the program */
export type EnterpriseProgram_SuggestedCollection = Collection_Collection | EnterpriseProgram_CollectionSuggestions;

/** Failure response for EnterpriseProgram_Create */
export type EnterpriseProgram_UpdateFailure = {
  __typename?: 'EnterpriseProgram_UpdateFailure';
  /** Errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Enterprise Program Update input */
export type EnterpriseProgram_UpdateInput = {
  /** Contract Id associated with the program. */
  contractId?: InputMaybe<Scalars['ID']>;
  /** The curriculum tied to the program. */
  curriculumId: Scalars['ID'];
  /** The program description */
  description?: InputMaybe<Scalars['String']>;
  /** The time at which the program ended */
  endedAt?: InputMaybe<Scalars['DateTime']>;
  /** The url for the landing page banner image */
  landingPageBanner?: InputMaybe<Scalars['String']>;
  /** The time at which the program is launched */
  launchedAt?: InputMaybe<Scalars['DateTime']>;
  /** Academic Discipline ID linked to the program */
  linkedAcademicDisciplineIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Skillset IDs linked to the program */
  linkedTargetSkillProfileIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The logo for the program. */
  logo?: InputMaybe<Scalars['URL']>;
  /** The maximum number of courses an individual learner can enroll in */
  maxCoursesPerUser?: InputMaybe<Scalars['Int']>;
  /** The program slug */
  name: Scalars['String'];
  /** Primary color for the program */
  primaryColor?: InputMaybe<Scalars['String']>;
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** Rectangular logo for the program */
  rectangularLogo?: InputMaybe<Scalars['URL']>;
  /** Skillset availability type for the program */
  skillsetAvailabilityType?: InputMaybe<EnterpriseProgram_SkillsetAvailabilityType>;
  /** Flag to skip validations */
  skipValidations?: Scalars['Boolean'];
  /** The program slug */
  slug: Scalars['String'];
  /** Square logo for the program */
  squareLogo?: InputMaybe<Scalars['URL']>;
  /** The program tagline */
  tagline?: InputMaybe<Scalars['String']>;
  /** Third Party Organization Id. */
  thirdPartyOrganizationId?: InputMaybe<Scalars['ID']>;
  /** The id for the tutorial video relation for the program */
  tutorialVideoAssetId?: InputMaybe<Scalars['ID']>;
  /** The tutorial video URL for the program. */
  tutorialVideoUrl?: InputMaybe<Scalars['URL']>;
};

/** Success and failure handling for Enterprise Program UpdateSkillsets mutation */
export type EnterpriseProgram_UpdateResult = EnterpriseProgram_UpdateFailure | EnterpriseProgram_UpdateSuccess;

/** Failure response for EnterpriseProgram_Create */
export type EnterpriseProgram_UpdateSkillsetsFailure = {
  __typename?: 'EnterpriseProgram_UpdateSkillsetsFailure';
  /** Errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Enterprise Program UpdateSkillsets input */
export type EnterpriseProgram_UpdateSkillsetsInput = {
  /** EnterpriseProgram id. */
  programId: Scalars['ID'];
  /** List of skillset IDs */
  skillsetIds: Array<Scalars['ID']>;
  /** Skillset update mode */
  skillsetUpdateMode: EnterpriseProgram_SkillsetUpdateMode;
};

/** Success and failure handling for Enterprise Program UpdateSkillsets mutation */
export type EnterpriseProgram_UpdateSkillsetsResult = EnterpriseProgram_UpdateSkillsetsFailure | EnterpriseProgram_UpdateSkillsetsSuccess;

/** Success updating program skillsets */
export type EnterpriseProgram_UpdateSkillsetsSuccess = {
  __typename?: 'EnterpriseProgram_UpdateSkillsetsSuccess';
  /** Updated Enterprise Program */
  body: EnterpriseProgram_EnterpriseProgram;
  /** Flag indicating if data was received and will be processed. */
  success: Scalars['Boolean'];
};

/** Success updating program */
export type EnterpriseProgram_UpdateSuccess = {
  __typename?: 'EnterpriseProgram_UpdateSuccess';
  /** Updated Enterprise Program */
  body: EnterpriseProgram_EnterpriseProgram;
  /** Flag indicating if data was received and will be processed. */
  success: Scalars['Boolean'];
};

/** Result of validating content access compatibility across programs. */
export type EnterpriseProgram_ValidateContentAccessResult = {
  __typename?: 'EnterpriseProgram_ValidateContentAccessResult';
  /** Reason for failure. NONE when isValid is true. */
  failureReason: EnterpriseProgram_ContentAccessFailureReason;
  /** True if all programs have identical content access (same access type and same product set). */
  isValid: Scalars['Boolean'];
};

export type EnterpriseProgramsV1 = {
  __typename?: 'EnterpriseProgramsV1';
  contract?: Maybe<EnterpriseContractsV1>;
  contractId?: Maybe<Scalars['String']>;
  contractTags?: Maybe<Scalars['JSON']>;
  curriculum?: Maybe<ProgramCurriculumsV1>;
  curriculumCollections?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  curriculumDomains?: Maybe<ProgramCurriculumDomainsV1>;
  draft?: Maybe<EnterpriseProgramDraftsV1>;
  id: Scalars['String'];
  maxCoursesPerUser?: Maybe<Scalars['Int']>;
  metadata: EnterpriseProgramsV1_Org_Coursera_Program_ProgramMetadata;
  programMemberships?: Maybe<Scalars['JSON']>;
  thirdPartyOrg?: Maybe<ThirdPartyOrganizationsV1>;
  thirdPartyOrganizationId: Scalars['String'];
  tspSummaries?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  userRosters?: Maybe<EnterpriseUserRostersV1Connection>;
};


export type EnterpriseProgramsV1CurriculumArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  includeClips?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProgramsV1CurriculumCollectionsArgs = {
  debug?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  minEntriesInCollection?: InputMaybe<Scalars['Int']>;
  onlyIncludeProjects?: InputMaybe<Scalars['Boolean']>;
  skipEnterpriseCollections?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1CurriculumDomainsArgs = {
  includeUnselectedDomains?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProgramsV1TspSummariesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1UserRostersArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProgramsV1ByContractId = {
  __typename?: 'EnterpriseProgramsV1ByContractId';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  enterpriseContractId: Scalars['String'];
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramsV1ByCurriculumId = {
  __typename?: 'EnterpriseProgramsV1ByCurriculumId';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  curriculumId: Scalars['String'];
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramsV1ByOrganizationAndSkillsetId = {
  __typename?: 'EnterpriseProgramsV1ByOrganizationAndSkillsetId';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  includeProgramsWithAllSkillsets?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  unifiedSkillsetId: Scalars['String'];
};

export type EnterpriseProgramsV1ByOrganizationSlug = {
  __typename?: 'EnterpriseProgramsV1ByOrganizationSlug';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramsV1ByTargetSkillProfileId = {
  __typename?: 'EnterpriseProgramsV1ByTargetSkillProfileId';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  targetSkillProfileId: Scalars['String'];
};

export type EnterpriseProgramsV1ByThirdPartyOrganizationId = {
  __typename?: 'EnterpriseProgramsV1ByThirdPartyOrganizationId';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};

export type EnterpriseProgramsV1Connection = {
  __typename?: 'EnterpriseProgramsV1Connection';
  elements: Array<Maybe<EnterpriseProgramsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseProgramsV1Resource = {
  __typename?: 'EnterpriseProgramsV1Resource';
  byContractId?: Maybe<EnterpriseProgramsV1Connection>;
  byCurriculumId?: Maybe<EnterpriseProgramsV1Connection>;
  byOrganizationAndSkillsetId?: Maybe<EnterpriseProgramsV1Connection>;
  byOrganizationSlug?: Maybe<EnterpriseProgramsV1Connection>;
  byTargetSkillProfileId?: Maybe<EnterpriseProgramsV1Connection>;
  byThirdPartyOrganizationId?: Maybe<EnterpriseProgramsV1Connection>;
  get?: Maybe<EnterpriseProgramsV1>;
  getAll?: Maybe<EnterpriseProgramsV1Connection>;
  multiGet?: Maybe<EnterpriseProgramsV1Connection>;
  slug?: Maybe<EnterpriseProgramsV1Connection>;
};


export type EnterpriseProgramsV1ResourceByContractIdArgs = {
  enterpriseContractId: Scalars['String'];
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceByCurriculumIdArgs = {
  curriculumId: Scalars['String'];
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceByOrganizationAndSkillsetIdArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeProgramsWithAllSkillsets?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  unifiedSkillsetId: Scalars['String'];
};


export type EnterpriseProgramsV1ResourceByOrganizationSlugArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  organizationSlug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceByTargetSkillProfileIdArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  targetSkillProfileId: Scalars['String'];
};


export type EnterpriseProgramsV1ResourceByThirdPartyOrganizationIdArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type EnterpriseProgramsV1ResourceGetArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type EnterpriseProgramsV1ResourceGetAllArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceMultiGetArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceSlugArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProgramsV1ResourceMutations = {
  __typename?: 'EnterpriseProgramsV1ResourceMutations';
  archive?: Maybe<Scalars['JSON']>;
  create?: Maybe<EnterpriseProgramsV1Connection>;
  update?: Maybe<EnterpriseProgramsV1Connection>;
  updateAcademicDiscipline?: Maybe<Scalars['JSON']>;
  updateTargetSkillProfiles?: Maybe<Scalars['JSON']>;
};


export type EnterpriseProgramsV1ResourceMutationsArchiveArgs = {
  id: Scalars['String'];
  includeCleanup?: InputMaybe<Scalars['Boolean']>;
  sendMembershipDeletionNotification?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProgramsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
  skipValidation?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseProgramsV1ResourceMutationsUpdateAcademicDisciplineArgs = {
  academicDisciplineId: Scalars['String'];
  id: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type EnterpriseProgramsV1ResourceMutationsUpdateTargetSkillProfilesArgs = {
  id: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type EnterpriseProgramsV1Slug = {
  __typename?: 'EnterpriseProgramsV1Slug';
  connection?: Maybe<EnterpriseProgramsV1Connection>;
  eventualConsistency?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseProgramsV1_Org_Coursera_Program_ProgramMetadata = {
  __typename?: 'EnterpriseProgramsV1_org_coursera_program_ProgramMetadata';
  curriculumId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['Float']>;
  isLocked: Scalars['Boolean'];
  landingPageBanner?: Maybe<Scalars['String']>;
  launchedAt?: Maybe<Scalars['Float']>;
  linkedAcademicDisciplineIds: Array<Maybe<Scalars['String']>>;
  linkedTargetSkillProfileIds: Array<Maybe<Scalars['String']>>;
  logo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  rectangularLogo?: Maybe<Scalars['String']>;
  skillSetAvailabilityType: EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  squareLogo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  tagline?: Maybe<Scalars['String']>;
  tutorialVideoAssetId?: Maybe<Scalars['String']>;
  tutorialVideoUrl?: Maybe<Scalars['String']>;
};

/** Different configurations for SkillSets available to a learning program. Currently it is just ALL skillsets, no skillsets, or selected skillsets, but in the future, there may be configurations for all academies. */
export const EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType = {
  AllSkillsets: 'ALL_SKILLSETS',
  LinkedSkillsetsOnly: 'LINKED_SKILLSETS_ONLY'
} as const;

export type EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType = typeof EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType[keyof typeof EnterpriseProgramsV1_Org_Coursera_Program_SkillSetAvailabilityType];
/** Queries for Enterprise Promotions */
export type EnterprisePromotionQueries = {
  __typename?: 'EnterprisePromotionQueries';
  /**
   * Returns available enterprise promotions per contract per stage. Server-side filtered by
   * validity window, contract targeting, and trigger conditions (e.g. license utilization).
   * Empty promotions list when no candidate exists for a (contract, stage) pair.
   */
  availableContractPromotions: Array<EnterprisePromotion_AvailablePromotionsForContract>;
  /** Fetches an enterprise promotion by its enterprise promotion id. */
  getById?: Maybe<EnterprisePromotion_EnterprisePromotionDetails>;
  /** Fetches the enterprise promotion by promo code id. */
  getByPromoCodeId: EnterprisePromotion_GetByPromoCodeIdResult;
  /** Lists enterprise promotions filterable by stage, active status, contract ids, and promotion name. */
  list: EnterprisePromotion_PaginatedResult;
};


/** Queries for Enterprise Promotions */
export type EnterprisePromotionQueriesAvailableContractPromotionsArgs = {
  contractIds: Array<Scalars['ID']>;
  stages?: InputMaybe<Array<EnterprisePromotion_PromotionStage>>;
};


/** Queries for Enterprise Promotions */
export type EnterprisePromotionQueriesGetByIdArgs = {
  enterprisePromotionId: Scalars['ID'];
};


/** Queries for Enterprise Promotions */
export type EnterprisePromotionQueriesGetByPromoCodeIdArgs = {
  promoCodeId: Scalars['ID'];
};


/** Queries for Enterprise Promotions */
export type EnterprisePromotionQueriesListArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: EnterprisePromotion_ListInput;
  limit?: Scalars['Int'];
};

/**
 * Slim view of an available enterprise promotion, returned by availableContractPromotions.
 * Carries only the fields needed at apply / display time.
 */
export type EnterprisePromotion_AvailablePromotion = {
  __typename?: 'EnterprisePromotion_AvailablePromotion';
  /** Discount percentage (1-100). Sourced from the underlying B2C promotion. */
  discountPercent: Scalars['Int'];
  /** Promotion validity window end. Null means evergreen. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Enterprise promotion id. Use with EnterprisePromotionQueries.getById to fetch full details. */
  enterprisePromotionId: Scalars['ID'];
  /** Promotion validity window start. */
  startsAt: Scalars['DateTime'];
};

/** Available enterprise promotions for a single contract, grouped by stage. */
export type EnterprisePromotion_AvailablePromotionsForContract = {
  __typename?: 'EnterprisePromotion_AvailablePromotionsForContract';
  /**
   * Per-stage available promotions for this contract. One entry per requested stage,
   * with empty promotions when nothing matches after trigger evaluation.
   */
  byStage: Array<EnterprisePromotion_AvailablePromotionsForStage>;
  /** Enterprise contract id this entry is scoped to. */
  contractId: Scalars['ID'];
};

/** Available enterprise promotions for a single (contract, stage) pair. */
export type EnterprisePromotion_AvailablePromotionsForStage = {
  __typename?: 'EnterprisePromotion_AvailablePromotionsForStage';
  /**
   * Promotions that pass all server-side filters (validity, targeting, trigger conditions).
   * Slim payload tailored to apply-time decisions; callers needing the full record use
   * EnterprisePromotionQueries.getById with the returned enterprisePromotionId.
   */
  promotions: Array<EnterprisePromotion_AvailablePromotion>;
  /** Stage these promotions apply at. */
  stage: EnterprisePromotion_PromotionStage;
};

/** Input parameters for EnterprisePromotion_Create mutation. */
export type EnterprisePromotion_CreateInput = {
  /** Coupon hard expiry date. Must be greater than or equal to endsAt when both are set. */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** Discount percentage. Must be in the range 1-100. */
  discountPercent: Scalars['Int'];
  /** Promotion validity window end. Null means evergreen. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Whether the promotion auto-applies on all checkout / pricing pages without a promo code.
   * Only valid for CHECKOUT stage promotions.
   */
  isSiteWide?: Scalars['Boolean'];
  /** Maximum redemptions per contract. */
  limitPerContract?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per organization. */
  limitPerOrganization?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per individual user. */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Maximum total redemptions across all users. Null means unlimited. */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /** The description of the promotion. */
  promotionDescription: Scalars['String'];
  /** The user-facing name of the promotion. */
  promotionName: Scalars['String'];
  /**
   * Stage in the customer journey at which this promotion applies. The server derives
   * enterprisePromotionType from this: CHECKOUT maps to BEFORE_TERM; UPSELL,
   * RENEWAL_OPT_IN and RENEWAL_CANCEL_DEFLECTION map to DURING_TERM.
   */
  promotionStage?: EnterprisePromotion_PromotionStage;
  /** Promotion validity window start. */
  startsAt: Scalars['DateTime'];
  /** List of enterprise contract ids targeted by this promotion. Null or empty means open-to-all. */
  targetedContractIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Trigger conditions for activation. When provided, the promotion only applies when all
   * conditions are satisfied. Null means always active within the validity window.
   */
  triggerConditions?: InputMaybe<Array<EnterprisePromotion_TriggerConditionInput>>;
};

/**
 * Result of EnterprisePromotion_Create. Returns either a success containing the created
 * promotion, or a typed failure describing why the create was rejected.
 */
export type EnterprisePromotion_CreateResult = EnterprisePromotion_CreateSuccess | EnterprisePromotion_OverlapConflictFailure | EnterprisePromotion_ValidationFailure;

/** Successful result of EnterprisePromotion_Create. */
export type EnterprisePromotion_CreateSuccess = {
  __typename?: 'EnterprisePromotion_CreateSuccess';
  /** The newly created enterprise promotion. */
  enterprisePromotion: EnterprisePromotion_EnterprisePromotionDetails;
};

/** Input parameters for EnterprisePromotion_Delete mutation. */
export type EnterprisePromotion_DeleteInput = {
  /** Enterprise promotion id to delete. */
  enterprisePromotionId: Scalars['ID'];
};

/** Result of EnterprisePromotion_Delete. */
export type EnterprisePromotion_DeleteResult = {
  __typename?: 'EnterprisePromotion_DeleteResult';
  /** Id of the enterprise promotion that was deleted. */
  enterprisePromotionId: Scalars['ID'];
};

/** Enterprise Promotion. */
export type EnterprisePromotion_EnterprisePromotionDetails = {
  __typename?: 'EnterprisePromotion_EnterprisePromotionDetails';
  /** Promotion validity window end. Null means evergreen. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Enum for type of enterprise promotion. */
  enterprisePromotionType: EnterprisePromotion_PromotionType;
  /** Enterprise Promotion ID. */
  id: Scalars['ID'];
  /**
   * Whether the promotion auto-applies on all checkout / pricing pages without a promo code.
   * Only valid for CHECKOUT stage promotions; must be false for any other stage.
   */
  isSiteWide?: Maybe<Scalars['Boolean']>;
  /** Limit per Contract */
  limitPerContract?: Maybe<Scalars['Int']>;
  /** Limit per Organization */
  limitPerOrganization?: Maybe<Scalars['Int']>;
  /** Promotion details from payments Db. */
  promotion: EnterprisePromotion_Promotion;
  /** Display name of the enterprise promotion. Mirrored on the enterprise_promotions row. */
  promotionName?: Maybe<Scalars['String']>;
  /** Stage in the customer journey at which this promotion applies. */
  promotionStage?: Maybe<EnterprisePromotion_PromotionStage>;
  /** Promotion validity window start. */
  startsAt?: Maybe<Scalars['DateTime']>;
  /**
   * List of enterprise contract ids targeted by this promotion. Null or empty means
   * the promotion is open to all contracts (subject to other targeting rules).
   */
  targetedContractIds?: Maybe<Array<Scalars['ID']>>;
  /**
   * Trigger conditions for activation. When non-null, the promotion only applies when
   * all conditions are satisfied (e.g. license utilization exceeds the threshold).
   * Null means the promotion is always active within the validity window.
   */
  triggerConditions?: Maybe<Array<EnterprisePromotion_TriggerCondition>>;
};

/** Common error interface for all EnterprisePromotion mutation failures. */
export type EnterprisePromotion_Error = {
  /** Human-readable error message. */
  message: Scalars['String'];
};

/** Represents the result of getEnterprisePromotionByPromoCodeId query. */
export type EnterprisePromotion_GetByPromoCodeIdResult = {
  __typename?: 'EnterprisePromotion_GetByPromoCodeIdResult';
  /** Enterprise Promotion. */
  enterprisePromotion?: Maybe<EnterprisePromotion_EnterprisePromotionDetails>;
};

/** Filter and pagination input for EnterprisePromotionQueries.list. */
export type EnterprisePromotion_ListInput = {
  /** Filter promotions targeting any of these contract ids. */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by enterprise promotion ids. Null or empty means no id-level filter. */
  enterprisePromotionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by active status (currently within startsAt and endsAt window). */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Filter by underlying B2C promotion ids. Null or empty means no id-level filter. */
  promotionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by promotion name (partial match against the denormalized promotion name). */
  promotionName?: InputMaybe<Scalars['String']>;
  /** Filter by promotion stage. */
  stage?: InputMaybe<EnterprisePromotion_PromotionStage>;
};

/** Returned when an update refers to an enterprise promotion id that does not exist. */
export type EnterprisePromotion_NotFoundFailure = EnterprisePromotion_Error & {
  __typename?: 'EnterprisePromotion_NotFoundFailure';
  /** Enterprise promotion id that was not found. */
  enterprisePromotionId: Scalars['ID'];
  /** Human-readable error message. */
  message: Scalars['String'];
};

/**
 * Returned when create or update would conflict with another enterprise promotion of the
 * same stage whose validity window and contract targeting overlap with the new promotion.
 */
export type EnterprisePromotion_OverlapConflictFailure = EnterprisePromotion_Error & {
  __typename?: 'EnterprisePromotion_OverlapConflictFailure';
  /** Id of the existing enterprise promotion that overlaps with the requested change. */
  conflictingEnterprisePromotionId: Scalars['ID'];
  /** Stage of the existing conflicting enterprise promotion. */
  conflictingStage: EnterprisePromotion_PromotionStage;
  /** Human-readable error message. */
  message: Scalars['String'];
};

/** Paginated list of enterprise promotions. */
export type EnterprisePromotion_PaginatedResult = {
  __typename?: 'EnterprisePromotion_PaginatedResult';
  /** Enterprise promotions on this page. */
  elements: Array<EnterprisePromotion_EnterprisePromotionDetails>;
  /** Pagination data. */
  pagination: Pagination;
};

/** Promotion details from payments Db. */
export type EnterprisePromotion_Promotion = {
  __typename?: 'EnterprisePromotion_Promotion';
  /** Promotion Id from payments table */
  id: Scalars['ID'];
};

/**
 * Stage in the customer journey at which an enterprise promotion applies. Drives both
 * eligibility resolution at apply-time and overlap validation at create / update time.
 */
export const EnterprisePromotion_PromotionStage = {
  /** Applied at new-customer checkout / acquisition. */
  EnterprisePromotionStageCheckout: 'ENTERPRISE_PROMOTION_STAGE_CHECKOUT',
  /** Applied as a deflection offer when a customer initiates cancellation. */
  EnterprisePromotionStageRenewalCancelDeflection: 'ENTERPRISE_PROMOTION_STAGE_RENEWAL_CANCEL_DEFLECTION',
  /** Applied at renewal opt-in time for contracts approaching expiry. */
  EnterprisePromotionStageRenewalOptIn: 'ENTERPRISE_PROMOTION_STAGE_RENEWAL_OPT_IN',
  /** Applied when an existing customer adds more seats / upgrades. */
  EnterprisePromotionStageUpsell: 'ENTERPRISE_PROMOTION_STAGE_UPSELL'
} as const;

export type EnterprisePromotion_PromotionStage = typeof EnterprisePromotion_PromotionStage[keyof typeof EnterprisePromotion_PromotionStage];
/** Enumeration of possible possible promotion types. */
export const EnterprisePromotion_PromotionType = {
  /** Promotion that can be applied before term. */
  EnterprisePromotionTypeBeforeTerm: 'ENTERPRISE_PROMOTION_TYPE_BEFORE_TERM',
  /** Promotion that can be applied during term. */
  EnterprisePromotionTypeDuringTerm: 'ENTERPRISE_PROMOTION_TYPE_DURING_TERM'
} as const;

export type EnterprisePromotion_PromotionType = typeof EnterprisePromotion_PromotionType[keyof typeof EnterprisePromotion_PromotionType];
/** A single trigger condition that must be satisfied for a promotion to apply. */
export type EnterprisePromotion_TriggerCondition = {
  __typename?: 'EnterprisePromotion_TriggerCondition';
  /** The type of condition being evaluated. */
  conditionType: EnterprisePromotion_TriggerConditionType;
  /**
   * The threshold value for the condition. Semantics depend on conditionType:
   * for LICENSE_UTILIZATION this is the minimum utilization percentage (1-100).
   */
  thresholdValue: Scalars['Int'];
};

/** Input for a single trigger condition. */
export type EnterprisePromotion_TriggerConditionInput = {
  /** The type of condition being evaluated. */
  conditionType: EnterprisePromotion_TriggerConditionType;
  /** The threshold value. For LICENSE_UTILIZATION: minimum utilization percentage (1-100). */
  thresholdValue: Scalars['Int'];
};

/** Types of trigger conditions supported for enterprise promotions. */
export const EnterprisePromotion_TriggerConditionType = {
  /**
   * Promotion triggers when license utilization percentage meets or exceeds thresholdValue.
   * Evaluated per-contract at eligibility check time.
   */
  LicenseUtilization: 'LICENSE_UTILIZATION'
} as const;

export type EnterprisePromotion_TriggerConditionType = typeof EnterprisePromotion_TriggerConditionType[keyof typeof EnterprisePromotion_TriggerConditionType];
/**
 * Input parameters for EnterprisePromotion_Update mutation. Only fields that are non-null
 * are mutated; all other fields are left unchanged.
 */
export type EnterprisePromotion_UpdateInput = {
  /** Coupon hard expiry date. */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** Discount percentage. Must be in the range 1-100. */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** Promotion validity window end. Set to current time to deactivate the promotion. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Enterprise promotion id. */
  enterprisePromotionId: Scalars['ID'];
  /** Whether the promotion auto-applies on all checkout / pricing pages without a promo code. */
  isSiteWide?: InputMaybe<Scalars['Boolean']>;
  /** Maximum redemptions per contract. */
  limitPerContract?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per organization. */
  limitPerOrganization?: InputMaybe<Scalars['Int']>;
  /** Maximum redemptions per individual user. */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Maximum total redemptions across all users. */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /** The description of the promotion. */
  promotionDescription?: InputMaybe<Scalars['String']>;
  /** The user-facing name of the promotion. */
  promotionName?: InputMaybe<Scalars['String']>;
  /** Stage in the customer journey at which this promotion applies. */
  promotionStage?: InputMaybe<EnterprisePromotion_PromotionStage>;
  /** Promotion validity window start. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** List of enterprise contract ids targeted by this promotion. Null or empty means open-to-all. */
  targetedContractIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Trigger conditions for activation. Replaces existing conditions when non-null.
   * Pass an empty list to remove all conditions.
   */
  triggerConditions?: InputMaybe<Array<EnterprisePromotion_TriggerConditionInput>>;
};

/** Result of EnterprisePromotion_Update. */
export type EnterprisePromotion_UpdateResult = EnterprisePromotion_NotFoundFailure | EnterprisePromotion_OverlapConflictFailure | EnterprisePromotion_UpdateSuccess | EnterprisePromotion_ValidationFailure;

/** Successful result of EnterprisePromotion_Update. */
export type EnterprisePromotion_UpdateSuccess = {
  __typename?: 'EnterprisePromotion_UpdateSuccess';
  /** The updated enterprise promotion. */
  enterprisePromotion: EnterprisePromotion_EnterprisePromotionDetails;
};

/**
 * Returned when input fields fail validation rules (range checks, mutual-exclusion checks,
 * required-field checks, etc).
 */
export type EnterprisePromotion_ValidationFailure = EnterprisePromotion_Error & {
  __typename?: 'EnterprisePromotion_ValidationFailure';
  /** Optional name of the input field that failed validation. */
  field?: Maybe<Scalars['String']>;
  /** Human-readable error message. */
  message: Scalars['String'];
};

export type EnterprisePromotionsV1 = {
  __typename?: 'EnterprisePromotionsV1';
  enterprisePromotionType: EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType;
  id: Scalars['String'];
  limitPerContract?: Maybe<Scalars['Int']>;
  limitPerOrganization?: Maybe<Scalars['Int']>;
  promotion?: Maybe<PromotionsV3>;
  promotionId: Scalars['Int'];
};

export type EnterprisePromotionsV1Connection = {
  __typename?: 'EnterprisePromotionsV1Connection';
  elements: Array<Maybe<EnterprisePromotionsV1>>;
  paging: ResponsePagination;
};

export type EnterprisePromotionsV1FindByPromoCode = {
  __typename?: 'EnterprisePromotionsV1FindByPromoCode';
  connection?: Maybe<EnterprisePromotionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  promoCodeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterprisePromotionsV1Resource = {
  __typename?: 'EnterprisePromotionsV1Resource';
  findByPromoCode?: Maybe<EnterprisePromotionsV1Connection>;
  get?: Maybe<EnterprisePromotionsV1>;
  multiGet?: Maybe<EnterprisePromotionsV1Connection>;
};


export type EnterprisePromotionsV1ResourceFindByPromoCodeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  promoCodeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterprisePromotionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterprisePromotionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterprisePromotionsV1ResourceMutations = {
  __typename?: 'EnterprisePromotionsV1ResourceMutations';
  create?: Maybe<EnterprisePromotionsV1Connection>;
};

export const EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType = {
  BeforeTerm: 'BEFORE_TERM',
  DuringTerm: 'DURING_TERM'
} as const;

export type EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType = typeof EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType[keyof typeof EnterprisePromotionsV1_Org_Coursera_Product_Enterprise_Contract_Promotion_EnterprisePromotionType];
/** Queries related to fetching the different enterprise reports */
export type EnterpriseReportsQueries = {
  __typename?: 'EnterpriseReportsQueries';
  /** Fetches the scheduled reports by organization */
  findByOrganization?: Maybe<EnterpriseReports_ScheduledReportPaginatedResult>;
  /** Fetches metadata (last published time, data freshness) for all report types. */
  getReportMetadata: Array<EnterpriseReports_ReportMetadata>;
  /**
   * Preview the size of a report before exporting.
   * Returns estimated row count and file size only for the queried report.
   */
  previewReportSize?: Maybe<EnterpriseReports_PreviewReportSizeResult>;
  /**
   * Resolves a stable report download link ID to a presigned S3 URL. Used when the user clicks
   * the link from the report email. Returns null if the link is not found or expired.
   * Requires the user to be logged in.
   */
  resolveReportDownloadLink?: Maybe<Scalars['URL']>;
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseReportsQueriesFindByOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  showDeleted?: Scalars['Boolean'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseReportsQueriesPreviewReportSizeArgs = {
  input: EnterpriseReports_ExportReportInput;
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseReportsQueriesResolveReportDownloadLinkArgs = {
  reportDownloadId: Scalars['ID'];
};

/** Course enrollment */
export type EnterpriseReports_CourseEnrollment = {
  __typename?: 'EnterpriseReports_CourseEnrollment';
  /** Timestamp of the completion */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Course for the enrollment */
  course: Course_Course;
  /** Timestamp of the first enrollment */
  enrolledAt: Scalars['DateTime'];
  /** Last activity timestamp, null if there is no activity */
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  /** Program that the course was enrolled through */
  program: EnterpriseProgram_EnterpriseProgram;
  /** Progress percentage (0.0 to 100.0) */
  progressPercentage: Scalars['Float'];
};

/**
 * Input parameters related to the date range for report filtering
 * startDate and endDate are optional and only used when type is CUSTOM
 * startDate is populated for scheduled custom dates
 * both startDate and endDate are populated for export custom dates
 */
export type EnterpriseReports_DateRange = {
  /** End date to filter on, used for CUSTOM date type */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The type of date range to filter data on */
  type: EnterpriseReports_DateRangeType;
};

/** The type of date range filters available */
export const EnterpriseReports_DateRangeType = {
  /** ALL_TIME */
  AllTime: 'ALL_TIME',
  /** CUSTOM */
  Custom: 'CUSTOM',
  /** LAST_30_DAYS */
  Last_30Days: 'LAST_30_DAYS',
  /** LAST_60_DAYS */
  Last_60Days: 'LAST_60_DAYS',
  /** LAST_90_DAYS */
  Last_90Days: 'LAST_90_DAYS',
  /** SINCE_CONTRACT_STARTED */
  SinceContractStarted: 'SINCE_CONTRACT_STARTED',
  /** YEAR_TO_DATE */
  YearToDate: 'YEAR_TO_DATE'
} as const;

export type EnterpriseReports_DateRangeType = typeof EnterpriseReports_DateRangeType[keyof typeof EnterpriseReports_DateRangeType];
/** Failure response for EnterpriseReports_DeleteSchedule */
export type EnterpriseReports_DeleteScheduleFailure = {
  __typename?: 'EnterpriseReports_DeleteScheduleFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise delete schedule input */
export type EnterpriseReports_DeleteScheduleInput = {
  /** Report type of the scheduled report */
  reportType: EnterpriseReports_ReportType;
  /** Org id of the scheduled report */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Delete schedule result */
export type EnterpriseReports_DeleteScheduleResult = EnterpriseReports_DeleteScheduleFailure | EnterpriseReports_DeleteScheduleSuccess;

/** Success response for EnterpriseReports_DeleteSchedule */
export type EnterpriseReports_DeleteScheduleSuccess = {
  __typename?: 'EnterpriseReports_DeleteScheduleSuccess';
  /** Scheduled report id */
  id: Scalars['ID'];
};

/** Estimated file size for a specific export format */
export type EnterpriseReports_EstimatedFileSize = {
  __typename?: 'EnterpriseReports_EstimatedFileSize';
  /** Export format */
  format: EnterpriseReports_ExportFormat;
  /** Estimated file size in bytes */
  sizeBytes: Scalars['Int'];
};

/** Enterprise export curriculum report input */
export type EnterpriseReports_ExportCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export enrollment report input */
export type EnterpriseReports_ExportEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Export file format for downloadable reports */
export const EnterpriseReports_ExportFormat = {
  /** Comma-separated values format */
  Csv: 'CSV',
  /** Excel spreadsheet format */
  Xlsx: 'XLSX'
} as const;

export type EnterpriseReports_ExportFormat = typeof EnterpriseReports_ExportFormat[keyof typeof EnterpriseReports_ExportFormat];
/** Enterprise export learner engagement report input */
export type EnterpriseReports_ExportLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export learner performance report input */
export type EnterpriseReports_ExportLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise export learner skills report input */
export type EnterpriseReports_ExportLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise export membership report input */
export type EnterpriseReports_ExportMembershipReportInput = {
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Failure response for EnterpriseReports_ExportReport */
export type EnterpriseReports_ExportReportFailure = {
  __typename?: 'EnterpriseReports_ExportReportFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise export report input */
export type EnterpriseReports_ExportReportInput = {
  /** Curriculum report input */
  curriculum?: InputMaybe<EnterpriseReports_ExportCurriculumReportInput>;
  /** Enrollment report input */
  enrollment?: InputMaybe<EnterpriseReports_ExportEnrollmentReportInput>;
  /** Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseReports_ExportLearnerEngagementReportInput>;
  /** Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseReports_ExportLearnerPerformanceReportInput>;
  /** Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseReports_ExportLearnerSkillsReportInput>;
  /** Membership report input */
  membership?: InputMaybe<EnterpriseReports_ExportMembershipReportInput>;
  /** Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseReports_ExportVerifiedSkillPathProgressReportInput>;
};

/** Export report result */
export type EnterpriseReports_ExportReportResult = EnterpriseReports_ExportReportFailure | EnterpriseReports_ExportReportSuccess;

/** Success response for EnterpriseReports_ExportReport */
export type EnterpriseReports_ExportReportSuccess = {
  __typename?: 'EnterpriseReports_ExportReportSuccess';
  /** This is the s3 airflow metadata presigned url */
  presignedUrl?: Maybe<Scalars['URL']>;
  /**
   * This is the path for the zip file stored in S3.
   * coursera-course-exports/enterprise-reports/organization/<orgSlug>/ContentActivity-<orgSlug>-<timestamp>.zip
   */
  s3Path: Scalars['String'];
};

/** Enterprise export Verified Skill Path Progress report input */
export type EnterpriseReports_ExportVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Result for GetCourseEnrollmentsByUserAndOrg */
export type EnterpriseReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult = {
  __typename?: 'EnterpriseReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult';
  /** Paginated course enrollments */
  elements: Array<EnterpriseReports_CourseEnrollment>;
  /** Pagination */
  pagination: Pagination;
};

/** Failure response for previewReportSize */
export type EnterpriseReports_PreviewReportSizeFailure = {
  __typename?: 'EnterpriseReports_PreviewReportSizeFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Preview report size result */
export type EnterpriseReports_PreviewReportSizeResult = EnterpriseReports_PreviewReportSizeFailure | EnterpriseReports_PreviewReportSizeSuccess;

/** Success response for previewReportSize */
export type EnterpriseReports_PreviewReportSizeSuccess = {
  __typename?: 'EnterpriseReports_PreviewReportSizeSuccess';
  /** Estimated file sizes per export format */
  estimatedFileSizesByFormat: Array<EnterpriseReports_EstimatedFileSize>;
  /** Row counts for each report (CSV file or Excel sheet) */
  reportRowCounts: Array<EnterpriseReports_ReportRowCount>;
};

/**
 * Common report filters and configuration options
 * Reusable across multiple report types for consistency
 */
export type EnterpriseReports_ReportFilters = {
  /** List of contract IDs */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat?: EnterpriseReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** List of pathway IDs for VSP filtering */
  pathwayIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of skill IDs */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Metadata for a report type indicating when it was last published and the data freshness boundary. */
export type EnterpriseReports_ReportMetadata = {
  __typename?: 'EnterpriseReports_ReportMetadata';
  /** Timestamp of the latest activity included in the data */
  activityIncludedTill?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the report data was last published */
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  /** The report type identifier */
  reportType: EnterpriseReports_ReportType;
};

/** Names of individual report artifacts (CSV files or Excel sheets) */
export const EnterpriseReports_ReportName = {
  /** Activity by Business Unit pivot (Learner Engagement) */
  ActivityByBusinessUnit: 'ACTIVITY_BY_BUSINESS_UNIT',
  /** Activity by City pivot (Learner Engagement) */
  ActivityByCity: 'ACTIVITY_BY_CITY',
  /** Activity by Country pivot (Learner Engagement) */
  ActivityByCountry: 'ACTIVITY_BY_COUNTRY',
  /** Course Activity (Learner Engagement) */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Curated Curriculum (Curriculum) */
  CuratedCurriculum: 'CURATED_CURRICULUM',
  /** Full Catalog (Curriculum) */
  FullCatalog: 'FULL_CATALOG',
  /** Gradebook Report (Learner Performance) */
  GradebookReport: 'GRADEBOOK_REPORT',
  /** Learning Path Activity (Learner Engagement) */
  LearningPathActivity: 'LEARNING_PATH_ACTIVITY',
  /** Plagiarism Report (Learner Performance) */
  PlagiarismReport: 'PLAGIARISM_REPORT',
  /** Program Activity (Learner Engagement) */
  ProgramActivity: 'PROGRAM_ACTIVITY',
  /** Skills Verified (Verified Skills Path) */
  SkillsVerified: 'SKILLS_VERIFIED',
  /** Skill Benchmarking (Learner Skills) */
  SkillBenchmarking: 'SKILL_BENCHMARKING',
  /** Skill Leaderboard (Learner Skills) */
  SkillLeaderboard: 'SKILL_LEADERBOARD',
  /** Skill Proficiency (Learner Skills) */
  SkillProficiency: 'SKILL_PROFICIENCY',
  /** Specialization Activity (Learner Engagement) */
  SpecializationActivity: 'SPECIALIZATION_ACTIVITY',
  /** Verified Skills Path Activity (Verified Skills Path) */
  VerifiedSkillsPathActivity: 'VERIFIED_SKILLS_PATH_ACTIVITY',
  /** Video Clip Activity (Learner Engagement) */
  VideoClipActivity: 'VIDEO_CLIP_ACTIVITY'
} as const;

export type EnterpriseReports_ReportName = typeof EnterpriseReports_ReportName[keyof typeof EnterpriseReports_ReportName];
/** Row count information for a single report (CSV/sheet) */
export type EnterpriseReports_ReportRowCount = {
  __typename?: 'EnterpriseReports_ReportRowCount';
  /** Name of the report artifact */
  reportName: EnterpriseReports_ReportName;
  /** Estimated number of rows in this report */
  rowCount: Scalars['Int'];
};

/** The type of reports that can be scheduled */
export const EnterpriseReports_ReportType = {
  /** CURRICULUM */
  Curriculum: 'CURRICULUM',
  /** ENROLLMENT */
  Enrollment: 'ENROLLMENT',
  /** LEARNER_ENGAGEMENT */
  LearnerEngagement: 'LEARNER_ENGAGEMENT',
  /** LEARNER_PERFORMANCE */
  LearnerPerformance: 'LEARNER_PERFORMANCE',
  /** LEARNER_SKILLS */
  LearnerSkills: 'LEARNER_SKILLS',
  /** MEMBERSHIP */
  Membership: 'MEMBERSHIP',
  /** MONTHLY_DIGEST_EMAIL */
  MonthlyDigestEmail: 'MONTHLY_DIGEST_EMAIL',
  /** VERIFIED_SKILL_PATH_PROGRESS */
  VerifiedSkillPathProgress: 'VERIFIED_SKILL_PATH_PROGRESS'
} as const;

export type EnterpriseReports_ReportType = typeof EnterpriseReports_ReportType[keyof typeof EnterpriseReports_ReportType];
/** Failure response for EnterpriseReports_SaveSchedule */
export type EnterpriseReports_SaveScheduleFailure = {
  __typename?: 'EnterpriseReports_SaveScheduleFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise save schedule input */
export type EnterpriseReports_SaveScheduleInput = {
  /** Schedule Curriculum report input */
  curriculum?: InputMaybe<EnterpriseReports_ScheduleCurriculumReportInput>;
  /** Schedule Enrollment report input */
  enrollment?: InputMaybe<EnterpriseReports_ScheduleEnrollmentReportInput>;
  /** Schedule Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseReports_ScheduleLearnerEngagementReportInput>;
  /** Schedule Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseReports_ScheduleLearnerPerformanceReportInput>;
  /** Schedule Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseReports_ScheduleLearnerSkillsReportInput>;
  /** Schedule Membership report input */
  membership?: InputMaybe<EnterpriseReports_ScheduleMembershipReportInput>;
  /** Schedule Monthly Digest Email input */
  monthlyDigestEmail?: InputMaybe<EnterpriseReports_ScheduleMonthlyDigestEmailInput>;
  /** Schedule Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseReports_ScheduleVerifiedSkillPathProgressReportInput>;
};

/** Save schedule result */
export type EnterpriseReports_SaveScheduleResult = EnterpriseReports_SaveScheduleFailure | EnterpriseReports_SaveScheduleSuccess;

/** Success response for EnterpriseReports_SaveSchedule */
export type EnterpriseReports_SaveScheduleSuccess = {
  __typename?: 'EnterpriseReports_SaveScheduleSuccess';
  /** Scheduled report id */
  id: Scalars['ID'];
};

/** What day of the week the report is scheduled to send on, sends weekly */
export const EnterpriseReports_Schedule = {
  /** FRIDAY */
  Friday: 'FRIDAY',
  /** MONDAY */
  Monday: 'MONDAY',
  /** SATURDAY */
  Saturday: 'SATURDAY',
  /** SUNDAY */
  Sunday: 'SUNDAY',
  /** THURSDAY */
  Thursday: 'THURSDAY',
  /** TUESDAY */
  Tuesday: 'TUESDAY',
  /** WEDNESDAY */
  Wednesday: 'WEDNESDAY'
} as const;

export type EnterpriseReports_Schedule = typeof EnterpriseReports_Schedule[keyof typeof EnterpriseReports_Schedule];
/** Enterprise schedule curriculum report input */
export type EnterpriseReports_ScheduleCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseReports_ScheduleEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Should report include data about removed members */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner engagement report input */
export type EnterpriseReports_ScheduleLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner performance report input */
export type EnterpriseReports_ScheduleLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule learner skills report input */
export type EnterpriseReports_ScheduleLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseReports_ScheduleMembershipReportInput = {
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** Enterprise schedule monthly digest email input */
export type EnterpriseReports_ScheduleMonthlyDigestEmailInput = {
  /** Org and programId context for report (programIds should be empty for monthly digest) */
  scope: EnterpriseReports_Scope;
};

/** What days of the week the report is scheduled to send on, sends weekly */
export type EnterpriseReports_ScheduleObject = {
  __typename?: 'EnterpriseReports_ScheduleObject';
  /** FRIDAY */
  friday: Scalars['Boolean'];
  /** MONDAY */
  monday: Scalars['Boolean'];
  /** SATURDAY */
  saturday: Scalars['Boolean'];
  /** SUNDAY */
  sunday: Scalars['Boolean'];
  /** THURSDAY */
  thursday: Scalars['Boolean'];
  /** TUESDAY */
  tuesday: Scalars['Boolean'];
  /** WEDNESDAY */
  wednesday: Scalars['Boolean'];
};

/** Enterprise schedule Verified Skill Path Progress report input */
export type EnterpriseReports_ScheduleVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseReports_Scope;
};

/** A scheduled report */
export type EnterpriseReports_ScheduledReport = {
  __typename?: 'EnterpriseReports_ScheduledReport';
  /** List of contracts */
  contracts: Array<EnterpriseContract_EnterpriseContract>;
  /** End date to filter on, used for CUSTOM date type */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat: EnterpriseReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram: Scalars['Boolean'];
  /** Scheduled report id */
  id: Scalars['ID'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers: Scalars['Boolean'];
  /** Whether this schedule has been soft-deleted (cancelled) */
  isDeleted: Scalars['Boolean'];
  /** Timestamp when config was last modified */
  lastModifiedAt?: Maybe<Scalars['DateTime']>;
  /**
   * List of Verified Skill Pathway IDs selected as report filters. Empty when none
   * were selected at schedule time, allowing the edit flow to retain user selections.
   * Returned as a plain ID list (not a federated entity) because
   * VerifiedSkills_SkillPathwaySummary is not declared as an @key entity in the
   * verifiedskills subgraph; the frontend already resolves names via
   * getAllSkillPathwaysByProgramIds.
   */
  pathwayIds: Array<Scalars['ID']>;
  /** A list of program ids for the scope */
  programs: Array<EnterpriseProgram_EnterpriseProgram>;
  /** The type of scheduled report */
  reportType: EnterpriseReports_ReportType;
  /** When the report is scheduled to send */
  schedule: EnterpriseReports_ScheduleObject;
  /** Display name of the user who scheduled the report */
  schedulerName?: Maybe<Scalars['String']>;
  /** List of skills */
  skills: Array<Skill_Skill>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Org id this report is on */
  thirdPartyOrganizationId: Scalars['ID'];
  /** Organization timezone */
  timezone?: Maybe<Scalars['String']>;
  /** The type of date range to filter data on */
  type?: Maybe<EnterpriseReports_DateRangeType>;
};

/** Result for FindByOrganization */
export type EnterpriseReports_ScheduledReportPaginatedResult = {
  __typename?: 'EnterpriseReports_ScheduledReportPaginatedResult';
  /** Scheduled reports */
  elements: Array<EnterpriseReports_ScheduledReport>;
  /** Pagination */
  pagination: Pagination;
};

/** What context the report should be limited to */
export type EnterpriseReports_Scope = {
  /** Program ids to filter on */
  programIds: Array<Scalars['ID']>;
  /** Org id to filter on */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Queries related to enterprise role templates */
export type EnterpriseRoleTemplateQueries = {
  __typename?: 'EnterpriseRoleTemplateQueries';
  /**
   * This query returns an unpaginated list of user role templates for an organization. The expected
   * number of return objects is in the tens, so no pagination is required.
   */
  queryRoleTemplatesByOrganization: Array<EnterprisePermission_RoleTemplate>;
};


/** Queries related to enterprise role templates */
export type EnterpriseRoleTemplateQueriesQueryRoleTemplatesByOrganizationArgs = {
  includeUniversalTemplates?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};

/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseRostersQueries = {
  __typename?: 'EnterpriseRostersQueries';
  /** Retrieves Enterprise Rosters by ID. */
  queryRosterByIds: Array<EnterpriseUser_Roster>;
  /**
   * Retrieves Enterprise Rosters by Organization Id.
   * Authorization is done in Java.
   */
  queryRosterByOrganizationId: EnterpriseUser_RosterPaginatedResult;
  /** Retrieves Enterprise Rosters by Program IDs or Contract IDs or both. */
  queryRostersByProgramIdsOrContractIdsOrBothAndIncludeDeleted: EnterpriseUser_RosterPaginatedResult;
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseRostersQueriesQueryRosterByIdsArgs = {
  ids: Array<Scalars['ID']>;
  includeDeleted?: Scalars['Boolean'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseRostersQueriesQueryRosterByOrganizationIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeDeleted?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  organizationId: Scalars['ID'];
};


/** Defining the queries for Enterprise Contract Tag */
export type EnterpriseRostersQueriesQueryRostersByProgramIdsOrContractIdsOrBothAndIncludeDeletedArgs = {
  contractIds?: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  includeDeleted?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  programIds?: Array<Scalars['ID']>;
};

/** EnterpriseSavedFilter activity filter union */
export type EnterpriseSavedFilter_ActivityFilter = EnterpriseSavedFilter_ActivityFilter_AssignedContent | EnterpriseSavedFilter_ActivityFilter_Completed | EnterpriseSavedFilter_ActivityFilter_Enrolled | EnterpriseSavedFilter_ActivityFilter_EnrolledButInactive | EnterpriseSavedFilter_ActivityFilter_GeneralInactivity | EnterpriseSavedFilter_ActivityFilter_NoEnrollments;

/** EnterpriseSavedFilter activity filter for assigned content */
export type EnterpriseSavedFilter_ActivityFilter_AssignedContent = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_AssignedContent';
  /** Selected contents */
  contentSelection: Array<EnterpriseSavedFilter_EnterpriseProduct>;
  /** Flag signifying completion or non-completion */
  isCompleted?: Maybe<Scalars['Boolean']>;
  /** Flag signifying enrollment or non-enrollment */
  isEnrolled?: Maybe<Scalars['Boolean']>;
};

/** EnterpriseSavedFilter activity filter for completed */
export type EnterpriseSavedFilter_ActivityFilter_Completed = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_Completed';
  /** Date of completion */
  completionDate: EnterpriseSavedFilter_DateComparison;
  /** Date of enrollment */
  enrollmentDate?: Maybe<EnterpriseSavedFilter_DateComparison>;
  /** Selected products */
  productSelection: Array<EnterpriseSavedFilter_EnterpriseProduct>;
};

/** EnterpriseSavedFilter activity filter for enrolled */
export type EnterpriseSavedFilter_ActivityFilter_Enrolled = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_Enrolled';
  /** Date of enrollment */
  enrollmentDate?: Maybe<EnterpriseSavedFilter_DateComparison>;
  /** Selected products */
  productSelection: Array<EnterpriseSavedFilter_EnterpriseProduct>;
};

/** EnterpriseSavedFilter activity filter for enrolled but inactive */
export type EnterpriseSavedFilter_ActivityFilter_EnrolledButInactive = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_EnrolledButInactive';
  /** Date of enrollment */
  enrollmentDate?: Maybe<EnterpriseSavedFilter_DateComparison>;
  /** Date of last activity */
  lastActivityDate: EnterpriseSavedFilter_DateComparison;
  /** Selected products */
  productSelection: Array<EnterpriseSavedFilter_EnterpriseProduct>;
};

/** EnterpriseSavedFilter activity filter for general inactivity */
export type EnterpriseSavedFilter_ActivityFilter_GeneralInactivity = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_GeneralInactivity';
  /** Date of last activity */
  lastActivityDate: EnterpriseSavedFilter_DateComparison;
};

/** EnterpriseSavedFilter activity filter for no enrollments */
export type EnterpriseSavedFilter_ActivityFilter_NoEnrollments = {
  __typename?: 'EnterpriseSavedFilter_ActivityFilter_NoEnrollments';
  /** No operation field - used to emulate an object with no values since GraphQL doesn't allow empty objects */
  _?: Maybe<Scalars['Boolean']>;
};

/** EnterpriseSavedFilter additional attribute selection */
export type EnterpriseSavedFilter_AdditionalAttributeSelection = {
  __typename?: 'EnterpriseSavedFilter_AdditionalAttributeSelection';
  /** Attribute name. */
  attributeName: EnterpriseSavedFilter_AttributeName;
  /** Values in the list. */
  attributeValues: Array<Scalars['String']>;
};

/** A reference to the User stub - represents an admin user filter */
export type EnterpriseSavedFilter_AdminUserFilter = {
  __typename?: 'EnterpriseSavedFilter_AdminUserFilter';
  /** The enterprise contracts associated with this filter. */
  contracts: Array<EnterpriseContract_EnterpriseContract>;
  /** Timestamp of the filter creation. */
  createdAt: Scalars['DateTime'];
  /** User Filter. */
  filter: EnterpriseSavedFilter_UserFilter;
  /** Name of the filter, can be null. */
  filterName?: Maybe<Scalars['String']>;
  /** Type of the saved filter. */
  filterType: EnterpriseSavedFilter_FilterType;
  /** A unique ID for a Admin User Filter type */
  id: Scalars['ID'];
  /** The enterprise products associated with this filter. */
  products: Array<EnterpriseSavedFilter_EnterpriseProduct>;
  /** The enterprise programs associated with this filter. */
  programs: Array<EnterpriseProgram>;
  /** Purpose of the filter. */
  purpose: EnterpriseSavedFilter_FilterPurpose;
  /** Identifier of the third-party organization where the filter is used. */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
  /** Timestamp of the last filter update. */
  updatedAt: Scalars['DateTime'];
};

/** AttributeName: all attribute names */
export const EnterpriseSavedFilter_AttributeName = {
  /** Business unit */
  BusinessUnit: 'BUSINESS_UNIT',
  /** Contract id */
  Contract: 'CONTRACT',
  /** Job title */
  JobTitle: 'JOB_TITLE',
  /** Job type */
  JobType: 'JOB_TYPE',
  /** Location */
  Location: 'LOCATION',
  /** Manager */
  Manager: 'MANAGER'
} as const;

export type EnterpriseSavedFilter_AttributeName = typeof EnterpriseSavedFilter_AttributeName[keyof typeof EnterpriseSavedFilter_AttributeName];
/** SortableColumn: all sortable columns */
export const EnterpriseSavedFilter_ColumnName = {
  /** Business unit column */
  BusinessUnit: 'BUSINESS_UNIT',
  /** Deleted at column */
  DeletedAt: 'DELETED_AT',
  /** Invited at column */
  InvitedAt: 'INVITED_AT',
  /** Is soft deleted column */
  IsSoftDeleted: 'IS_SOFT_DELETED',
  /** Joined at column */
  JoinedAt: 'JOINED_AT',
  /** Latest activity at column */
  LatestActivityAt: 'LATEST_ACTIVITY_AT',
  /** Manager name column */
  ManagerName: 'MANAGER_NAME',
  /** Name column */
  Name: 'NAME',
  /** Number of completions column */
  NumCompletions: 'NUM_COMPLETIONS',
  /** Number of enrollments column */
  NumEnrollments: 'NUM_ENROLLMENTS'
} as const;

export type EnterpriseSavedFilter_ColumnName = typeof EnterpriseSavedFilter_ColumnName[keyof typeof EnterpriseSavedFilter_ColumnName];
/** Date comparison describes a range of before and/or after fields to compare in the filter. */
export type EnterpriseSavedFilter_DateComparison = EnterpriseSavedFilter_DateComparison_Absolute | EnterpriseSavedFilter_DateComparison_Relative;

/** Absolute date comparison where 'after' and 'before' fields holds absolute DateTime range values. */
export type EnterpriseSavedFilter_DateComparison_Absolute = {
  __typename?: 'EnterpriseSavedFilter_DateComparison_Absolute';
  /** Time after */
  after?: Maybe<Scalars['DateTime']>;
  /** Time before */
  before?: Maybe<Scalars['DateTime']>;
};

/**
 * Specifies a date range relative to today, using 'N' days in the past.
 * - 'nDaysAgoAfter': the start of the period (inclusive).
 * - 'nDaysAgoBefore': the end of the period (inclusive).
 * If only 'nDaysAgoAfter' is specified, the period extends up to today.
 */
export type EnterpriseSavedFilter_DateComparison_Relative = {
  __typename?: 'EnterpriseSavedFilter_DateComparison_Relative';
  /** The number of days from today which marks the start of the date range. */
  nDaysAgoAfter?: Maybe<Scalars['Int']>;
  /** The number of days from today which marks the end of the date range. */
  nDaysAgoBefore?: Maybe<Scalars['Int']>;
};

/** Represents an enterprise product - which could be either a course or specialization. */
export type EnterpriseSavedFilter_EnterpriseProduct = Course_Course | Specialization_Specialization;

/** Enum that represents the filter purpose. */
export const EnterpriseSavedFilter_FilterPurpose = {
  /** The filter is intended for assigning content. */
  AssignContent: 'ASSIGN_CONTENT',
  /** The filter is flagged for deletion. */
  Delete: 'DELETE',
  /** The filter is intended for downloads. */
  Download: 'DOWNLOAD',
  /** The filter is intended for sending messages. */
  Message: 'MESSAGE',
  /** The filter is intended for reuse. */
  Reuse: 'REUSE'
} as const;

export type EnterpriseSavedFilter_FilterPurpose = typeof EnterpriseSavedFilter_FilterPurpose[keyof typeof EnterpriseSavedFilter_FilterPurpose];
/** User selection for the filter result. */
export type EnterpriseSavedFilter_FilterResultUserSelection = {
  __typename?: 'EnterpriseSavedFilter_FilterResultUserSelection';
  /** User identifier selection. */
  userIdentifiers: Array<EnterpriseSavedFilter_UserIdentifier>;
};

/** Enum that represents the saved filter type. */
export const EnterpriseSavedFilter_FilterType = {
  /** The version 1 of the User filter type. */
  UserV1: 'USER_V1'
} as const;

export type EnterpriseSavedFilter_FilterType = typeof EnterpriseSavedFilter_FilterType[keyof typeof EnterpriseSavedFilter_FilterType];
/** EnterpriseSavedFilter primary filter union */
export type EnterpriseSavedFilter_Primary = EnterpriseSavedFilter_PrimaryFilter_Invited | EnterpriseSavedFilter_PrimaryFilter_Member | EnterpriseSavedFilter_PrimaryFilter_MultiType | EnterpriseSavedFilter_PrimaryFilter_RemovedMember;

/** User filter primary filter */
export type EnterpriseSavedFilter_PrimaryFilter = {
  /** Program selection */
  programSelection: Array<EnterpriseProgram>;
};

/** EnterpriseSavedFilter primary filter invited */
export type EnterpriseSavedFilter_PrimaryFilter_Invited = EnterpriseSavedFilter_PrimaryFilter & {
  __typename?: 'EnterpriseSavedFilter_PrimaryFilter_Invited';
  /** Selected programs - inherited */
  programSelection: Array<EnterpriseProgram>;
};

/** EnterpriseSavedFilter primary filter member */
export type EnterpriseSavedFilter_PrimaryFilter_Member = EnterpriseSavedFilter_PrimaryFilter & {
  __typename?: 'EnterpriseSavedFilter_PrimaryFilter_Member';
  /** Activity filter */
  activityFilter?: Maybe<EnterpriseSavedFilter_ActivityFilter>;
  /** Program join date */
  programJoinDate?: Maybe<EnterpriseSavedFilter_DateComparison>;
  /** Selected programs - inherited */
  programSelection: Array<EnterpriseProgram>;
};

/** EnterpriseSavedFilter primary filter member */
export type EnterpriseSavedFilter_PrimaryFilter_MultiType = EnterpriseSavedFilter_PrimaryFilter & {
  __typename?: 'EnterpriseSavedFilter_PrimaryFilter_MultiType';
  /** Activity filter */
  activityFilter?: Maybe<EnterpriseSavedFilter_ActivityFilter>;
  /** List of membership states to query */
  membershipStates: Array<EnterpriseSavedFilter_UserProgramMembershipStatus>;
  /** Program join date */
  programJoinDate?: Maybe<EnterpriseSavedFilter_DateComparison>;
  /** Selected programs - inherited */
  programSelection: Array<EnterpriseProgram>;
};

/** EnterpriseSavedFilter primary filter removed member */
export type EnterpriseSavedFilter_PrimaryFilter_RemovedMember = EnterpriseSavedFilter_PrimaryFilter & {
  __typename?: 'EnterpriseSavedFilter_PrimaryFilter_RemovedMember';
  /** Selected programs - inherited */
  programSelection: Array<EnterpriseProgram>;
};

/** SortDirection: sort direction */
export const EnterpriseSavedFilter_SortDirection = {
  /** Ascending sort direction */
  Ascending: 'ASCENDING',
  /** Descending sort direction */
  Descending: 'DESCENDING'
} as const;

export type EnterpriseSavedFilter_SortDirection = typeof EnterpriseSavedFilter_SortDirection[keyof typeof EnterpriseSavedFilter_SortDirection];
/** EnterpriseSavedFilter sortable column */
export type EnterpriseSavedFilter_SortableColumn = {
  __typename?: 'EnterpriseSavedFilter_SortableColumn';
  /** Column to sort by. */
  columnName: EnterpriseSavedFilter_ColumnName;
  /** Direction to sort by. */
  sortDirection: EnterpriseSavedFilter_SortDirection;
};

/** User filter type. */
export type EnterpriseSavedFilter_UserFilter = {
  __typename?: 'EnterpriseSavedFilter_UserFilter';
  /** Optional additional filters: list of additional filters. */
  additionalAttributeSelections?: Maybe<Array<EnterpriseSavedFilter_AdditionalAttributeSelection>>;
  /** Optional selected filter user identifier selections. */
  filterResultUserSelection?: Maybe<EnterpriseSavedFilter_FilterResultUserSelection>;
  /** Primary filter: membership state */
  primaryFilter: EnterpriseSavedFilter_PrimaryFilter_Invited | EnterpriseSavedFilter_PrimaryFilter_Member | EnterpriseSavedFilter_PrimaryFilter_MultiType | EnterpriseSavedFilter_PrimaryFilter_RemovedMember;
  /** Optional search name or emails: list of emails or names to search for. */
  searchNameOrEmails?: Maybe<Array<Scalars['String']>>;
  /** Optional sort by: list of sort requests. */
  sortBy?: Maybe<Array<EnterpriseSavedFilter_SortableColumn>>;
};

/**
 * User identifier union - either the user email or federated user object type is stored with the
 * filter in the user selection.
 */
export type EnterpriseSavedFilter_UserIdentifier = EnterpriseSavedFilter_UserIdentifier_Email | User_User;

/** User identifier email */
export type EnterpriseSavedFilter_UserIdentifier_Email = {
  __typename?: 'EnterpriseSavedFilter_UserIdentifier_Email';
  /** The email associated with the user. */
  email: Scalars['String'];
};

/** User Program Membership status */
export const EnterpriseSavedFilter_UserProgramMembershipStatus = {
  /** invited status */
  Invited: 'INVITED',
  /** joined status */
  Joined: 'JOINED',
  /** removed status */
  Removed: 'REMOVED'
} as const;

export type EnterpriseSavedFilter_UserProgramMembershipStatus = typeof EnterpriseSavedFilter_UserProgramMembershipStatus[keyof typeof EnterpriseSavedFilter_UserProgramMembershipStatus];
/** All queries for Enterprise SCIM */
export type EnterpriseScimQueries = {
  __typename?: 'EnterpriseScimQueries';
  /**
   * Check SCIM managed status for multiple users in bulk.
   * Returns the SCIM managed status for each user email provided.
   * A user is considered SCIM managed if:
   * 1. The organization is fully SCIM managed (isEnabled=true AND isMappingCreated=true)
   * 2. The user exists in the scim_user table for that organization
   */
  areUsersScimManaged: Array<EnterpriseScim_UserScimStatus>;
  /** Get all groups for an organization */
  getAllGroups: EnterpriseScim_GetAllGroupsResult;
  /** Get all programs for an organization */
  getAllPrograms: EnterpriseScim_GetAllProgramsResult;
  /** Get group program mappings for an organization */
  getMappings: EnterpriseScim_GetMappingsResult;
  /** Get SCIM configuration for an organization */
  getScimConfiguration: EnterpriseScim_GetScimConfigurationResult;
  /** Check if an organization is fully SCIM managed (both isEnabled and isMappingCreated are true) */
  isScimManaged: Scalars['Boolean'];
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesAreUsersScimManagedArgs = {
  input: EnterpriseScim_AreUsersScimManagedInput;
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesGetAllGroupsArgs = {
  orgId: Scalars['ID'];
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesGetAllProgramsArgs = {
  orgId: Scalars['ID'];
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesGetMappingsArgs = {
  orgId: Scalars['ID'];
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesGetScimConfigurationArgs = {
  orgId: Scalars['ID'];
};


/** All queries for Enterprise SCIM */
export type EnterpriseScimQueriesIsScimManagedArgs = {
  orgId: Scalars['ID'];
};

/** Input for checking users SCIM managed status */
export type EnterpriseScim_AreUsersScimManagedInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** List of user emails to check */
  userEmails: Array<Scalars['String']>;
};

/** Failure response when configuring SCIM */
export type EnterpriseScim_ConfigureScimFailure = {
  __typename?: 'EnterpriseScim_ConfigureScimFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for configuring SCIM */
export type EnterpriseScim_ConfigureScimInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
};

/** Result type for configuring SCIM */
export type EnterpriseScim_ConfigureScimResult = EnterpriseScim_ConfigureScimFailure | EnterpriseScim_ConfigureScimSuccess;

/** Success response when configuring SCIM */
export type EnterpriseScim_ConfigureScimSuccess = {
  __typename?: 'EnterpriseScim_ConfigureScimSuccess';
  /** The SCIM new configuration object */
  scimConfiguration: EnterpriseScim_NewScimConfiguration;
};

/** Error interface for SCIM operations */
export type EnterpriseScim_Error = {
  __typename?: 'EnterpriseScim_Error';
  /** Error code */
  errorCode: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
};

/** Failure response when generating a new SCIM token */
export type EnterpriseScim_GenerateTokenFailure = {
  __typename?: 'EnterpriseScim_GenerateTokenFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for generating a new SCIM token */
export type EnterpriseScim_GenerateTokenInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
};

/** Result type for generating a new SCIM token */
export type EnterpriseScim_GenerateTokenResult = EnterpriseScim_GenerateTokenFailure | EnterpriseScim_GenerateTokenSuccess;

/** Success response when generating a new SCIM token */
export type EnterpriseScim_GenerateTokenSuccess = {
  __typename?: 'EnterpriseScim_GenerateTokenSuccess';
  /** The newly generated token with its metadata */
  newToken: EnterpriseScim_NewToken;
};

/** Failure response when getting all groups */
export type EnterpriseScim_GetAllGroupsFailure = {
  __typename?: 'EnterpriseScim_GetAllGroupsFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Result type for getting all groups */
export type EnterpriseScim_GetAllGroupsResult = EnterpriseScim_GetAllGroupsFailure | EnterpriseScim_GetAllGroupsSuccess;

/** Success response when getting all groups */
export type EnterpriseScim_GetAllGroupsSuccess = {
  __typename?: 'EnterpriseScim_GetAllGroupsSuccess';
  /** List of groups */
  groups: Array<EnterpriseScim_Group>;
};

/** Failure response when getting all programs */
export type EnterpriseScim_GetAllProgramsFailure = {
  __typename?: 'EnterpriseScim_GetAllProgramsFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Result type for getting all programs */
export type EnterpriseScim_GetAllProgramsResult = EnterpriseScim_GetAllProgramsFailure | EnterpriseScim_GetAllProgramsSuccess;

/** Success response when getting all programs */
export type EnterpriseScim_GetAllProgramsSuccess = {
  __typename?: 'EnterpriseScim_GetAllProgramsSuccess';
  /** List of programs */
  programs: Array<EnterpriseProgram_EnterpriseProgram>;
};

/** Failure response when getting group program mappings */
export type EnterpriseScim_GetMappingsFailure = {
  __typename?: 'EnterpriseScim_GetMappingsFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Result type for getting group program mappings */
export type EnterpriseScim_GetMappingsResult = EnterpriseScim_GetMappingsFailure | EnterpriseScim_GetMappingsSuccess;

/** Success response when getting group program mappings */
export type EnterpriseScim_GetMappingsSuccess = {
  __typename?: 'EnterpriseScim_GetMappingsSuccess';
  /** List of group program mappings */
  mappings: Array<EnterpriseScim_GroupProgramMapping>;
};

/** Failure response when getting SCIM configuration */
export type EnterpriseScim_GetScimConfigurationFailure = {
  __typename?: 'EnterpriseScim_GetScimConfigurationFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Result type for getting SCIM configuration */
export type EnterpriseScim_GetScimConfigurationResult = EnterpriseScim_GetScimConfigurationFailure | EnterpriseScim_GetScimConfigurationSuccess;

/** Success response when getting SCIM configuration */
export type EnterpriseScim_GetScimConfigurationSuccess = {
  __typename?: 'EnterpriseScim_GetScimConfigurationSuccess';
  /** The SCIM configuration object */
  scimConfiguration: EnterpriseScim_ScimConfiguration;
};

/** Group type */
export type EnterpriseScim_Group = {
  __typename?: 'EnterpriseScim_Group';
  /** The group ID */
  groupId: Scalars['ID'];
  /** The group name */
  groupName: Scalars['String'];
};

/** Group Program Mapping type */
export type EnterpriseScim_GroupProgramMapping = {
  __typename?: 'EnterpriseScim_GroupProgramMapping';
  /** Error message when processingStatus is FAILED. Null otherwise. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The group ID */
  groupId: Scalars['ID'];
  /** The group name */
  groupName: Scalars['String'];
  /** Last activity timestamp for this group */
  lastActivity: Scalars['DateTime'];
  /**
   * Processing status of the mapping operation.
   * This field tracks the async processing state after a mapping update is requested.
   */
  processingStatus?: Maybe<EnterpriseScim_ProcessingStatus>;
  /** List of programs associated with this group */
  programs: Array<EnterpriseProgram_EnterpriseProgram>;
};

/** SCIM Configuration type */
export type EnterpriseScim_NewScimConfiguration = {
  __typename?: 'EnterpriseScim_NewScimConfiguration';
  /** The SCIM API base URL for this organization */
  baseUrl: Scalars['URL'];
  /** When the configuration was created */
  createdAt: Scalars['DateTime'];
  /** Whether SCIM is enabled for this organization */
  isEnabled: Scalars['Boolean'];
  /** The third party organization ID */
  thirdPartyOrganizationId: Scalars['ID'];
  /** List of SCIM tokens for this organization */
  tokens: Array<EnterpriseScim_NewToken>;
  /** When the configuration was last updated */
  updatedAt: Scalars['DateTime'];
};

/** New Token type (returned when generating a new token) */
export type EnterpriseScim_NewToken = {
  __typename?: 'EnterpriseScim_NewToken';
  /** When the token was created */
  createdAt: Scalars['DateTime'];
  /** Whether the token is active */
  isActive: Scalars['Boolean'];
  /** The masked token value (for display purposes) */
  maskedToken: Scalars['String'];
  /** The actual token value (only returned once when generated) */
  token: Scalars['String'];
  /** When the token expires */
  tokenExpiry: Scalars['DateTime'];
  /** The unique token ID */
  tokenId: Scalars['ID'];
};

/**
 * Processing status for group program mapping operations.
 * Tracks the async processing state after a mapping update is requested.
 */
export const EnterpriseScim_ProcessingStatus = {
  /** Mapping update completed successfully */
  Completed: 'COMPLETED',
  /** Mapping update failed after all retry attempts */
  Failed: 'FAILED',
  /** Mapping update has been requested but not yet started processing */
  Pending: 'PENDING',
  /** Mapping update is currently being processed */
  Processing: 'PROCESSING'
} as const;

export type EnterpriseScim_ProcessingStatus = typeof EnterpriseScim_ProcessingStatus[keyof typeof EnterpriseScim_ProcessingStatus];
/** Failure response when revoking a SCIM token */
export type EnterpriseScim_RevokeTokenFailure = {
  __typename?: 'EnterpriseScim_RevokeTokenFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for revoking a SCIM token */
export type EnterpriseScim_RevokeTokenInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** The token ID to revoke */
  tokenId: Scalars['ID'];
};

/** Result type for revoking a SCIM token */
export type EnterpriseScim_RevokeTokenResult = EnterpriseScim_RevokeTokenFailure | EnterpriseScim_RevokeTokenSuccess;

/** Success response when revoking a SCIM token */
export type EnterpriseScim_RevokeTokenSuccess = {
  __typename?: 'EnterpriseScim_RevokeTokenSuccess';
  /** The updated token object (with isActive set to false) */
  token: EnterpriseScim_ScimToken;
};

/** SCIM Configuration type */
export type EnterpriseScim_ScimConfiguration = {
  __typename?: 'EnterpriseScim_ScimConfiguration';
  /** The SCIM API base URL for this organization */
  baseUrl: Scalars['URL'];
  /** When the configuration was created */
  createdAt: Scalars['DateTime'];
  /** Whether SCIM is enabled for this organization */
  isEnabled: Scalars['Boolean'];
  /** Whether to send invite mail */
  shouldSendInviteMail: Scalars['Boolean'];
  /** The third party organization ID */
  thirdPartyOrganizationId: Scalars['ID'];
  /** List of SCIM tokens for this organization */
  tokens: Array<EnterpriseScim_ScimToken>;
  /** When the configuration was last updated */
  updatedAt: Scalars['DateTime'];
};

/** SCIM Token type */
export type EnterpriseScim_ScimToken = {
  __typename?: 'EnterpriseScim_ScimToken';
  /** When the token was created */
  createdAt: Scalars['DateTime'];
  /** Whether the token is active */
  isActive: Scalars['Boolean'];
  /** The masked token value (for display purposes) */
  maskedToken: Scalars['String'];
  /** When the token expires */
  tokenExpiry: Scalars['DateTime'];
  /** The unique token ID */
  tokenId: Scalars['ID'];
};

/** Failure response when updating group program mappings */
export type EnterpriseScim_UpdateGroupProgramMappingsFailure = {
  __typename?: 'EnterpriseScim_UpdateGroupProgramMappingsFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for updating group program mappings */
export type EnterpriseScim_UpdateGroupProgramMappingsInput = {
  /** The group ID */
  groupId: Scalars['ID'];
  /** The organization ID */
  orgId: Scalars['ID'];
  /** Program IDs to add to the group */
  programsAdded?: InputMaybe<Array<Scalars['ID']>>;
  /** Program IDs to remove from the group */
  programsRemoved?: InputMaybe<Array<Scalars['ID']>>;
};

/** Result type for updating group program mappings */
export type EnterpriseScim_UpdateGroupProgramMappingsResult = EnterpriseScim_UpdateGroupProgramMappingsFailure | EnterpriseScim_UpdateGroupProgramMappingsSuccess;

/** Success response when updating group program mappings */
export type EnterpriseScim_UpdateGroupProgramMappingsSuccess = {
  __typename?: 'EnterpriseScim_UpdateGroupProgramMappingsSuccess';
  /** The updated group program mapping */
  mapping: EnterpriseScim_GroupProgramMapping;
};

/** Failure response when updating SCIM status */
export type EnterpriseScim_UpdateScimStatusFailure = {
  __typename?: 'EnterpriseScim_UpdateScimStatusFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for updating SCIM status */
export type EnterpriseScim_UpdateScimStatusInput = {
  /** Whether to enable or disable SCIM */
  enable: Scalars['Boolean'];
  /** The organization ID */
  orgId: Scalars['ID'];
};

/** Result type for updating SCIM status (enable/disable) */
export type EnterpriseScim_UpdateScimStatusResult = EnterpriseScim_UpdateScimStatusFailure | EnterpriseScim_UpdateScimStatusSuccess;

/** Success response when updating SCIM status */
export type EnterpriseScim_UpdateScimStatusSuccess = {
  __typename?: 'EnterpriseScim_UpdateScimStatusSuccess';
  /** The updated SCIM configuration */
  scimConfiguration: EnterpriseScim_ScimConfiguration;
};

/** Failure response when updating should send invite mail flag */
export type EnterpriseScim_UpdateShouldSendInviteMailFailure = {
  __typename?: 'EnterpriseScim_UpdateShouldSendInviteMailFailure';
  /** List of errors that occurred */
  errors: Array<EnterpriseScim_Error>;
};

/** Input for updating should send invite mail flag */
export type EnterpriseScim_UpdateShouldSendInviteMailInput = {
  /** The organization ID */
  orgId: Scalars['ID'];
  /** Whether to send invite mail */
  shouldSendInviteMail: Scalars['Boolean'];
};

/** Result type for updating should send invite mail flag */
export type EnterpriseScim_UpdateShouldSendInviteMailResult = EnterpriseScim_UpdateShouldSendInviteMailFailure | EnterpriseScim_UpdateShouldSendInviteMailSuccess;

/** Success response when updating should send invite mail flag */
export type EnterpriseScim_UpdateShouldSendInviteMailSuccess = {
  __typename?: 'EnterpriseScim_UpdateShouldSendInviteMailSuccess';
  /** The updated SCIM configuration */
  scimConfiguration: EnterpriseScim_ScimConfiguration;
};

/** User SCIM managed status */
export type EnterpriseScim_UserScimStatus = {
  __typename?: 'EnterpriseScim_UserScimStatus';
  /** Whether the user is SCIM managed */
  isScimManaged: Scalars['Boolean'];
  /** The user email */
  userEmail: Scalars['String'];
};

export type EnterpriseSelfServeContractProductPricesV1 = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1';
  actualLocalAmountDueToday: Scalars['String'];
  actualLocalAmountTotal: Scalars['String'];
  actualLocalDiscountedAmount: Scalars['String'];
  amountDueToday: Scalars['String'];
  amountTotal: Scalars['String'];
  billingType: EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType;
  countryIsoCode: Scalars['String'];
  currencyCode: Scalars['String'];
  discountPercent: Scalars['Int'];
  enterprisePromotionId?: Maybe<Scalars['String']>;
  fxRateId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  rawAmountDueToday: Scalars['String'];
  rawAmountTotal: Scalars['String'];
  rawLocalAmountDueToday: Scalars['String'];
  rawLocalAmountTotal: Scalars['String'];
  unitPrice: Scalars['String'];
  userLimit: Scalars['Int'];
};

export type EnterpriseSelfServeContractProductPricesV1ComputeInvoiceBilledContractPrice = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1ComputeInvoiceBilledContractPrice';
  billingType: Scalars['String'];
  connection?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
  countryIsoCode: Scalars['String'];
  discretionaryDiscountId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};

export type EnterpriseSelfServeContractProductPricesV1Connection = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1Connection';
  elements: Array<Maybe<EnterpriseSelfServeContractProductPricesV1>>;
  paging: ResponsePagination;
};

export type EnterpriseSelfServeContractProductPricesV1GetEnterpriseSelfServeContractProductPrice = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1GetEnterpriseSelfServeContractProductPrice';
  connection?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
  countryIsoCodeOpt?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  discretionaryDiscountId?: Maybe<Scalars['String']>;
  enterprisePromotionId?: Maybe<Scalars['String']>;
  fxRateId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  termInstallmentsTotal: Scalars['Int'];
  userIdOpt?: Maybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};

export type EnterpriseSelfServeContractProductPricesV1GetEnterpriseSelfServeContractProductPriceForContract = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1GetEnterpriseSelfServeContractProductPriceForContract';
  connection?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
  contractId: Scalars['String'];
  countryIsoCodeOpt?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  enterprisePromotionId?: Maybe<Scalars['String']>;
  fxRateId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  termInstallmentsTotal: Scalars['Int'];
  userIdOpt?: Maybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};

export type EnterpriseSelfServeContractProductPricesV1Resource = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1Resource';
  computeInvoiceBilledContractPrice?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
  get?: Maybe<EnterpriseSelfServeContractProductPricesV1>;
  getEnterpriseSelfServeContractProductPrice?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
  getEnterpriseSelfServeContractProductPriceForContract?: Maybe<EnterpriseSelfServeContractProductPricesV1Connection>;
};


export type EnterpriseSelfServeContractProductPricesV1ResourceComputeInvoiceBilledContractPriceArgs = {
  billingType: Scalars['String'];
  countryIsoCode: Scalars['String'];
  discretionaryDiscountId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};


export type EnterpriseSelfServeContractProductPricesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseSelfServeContractProductPricesV1ResourceGetEnterpriseSelfServeContractProductPriceArgs = {
  countryIsoCodeOpt?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  discretionaryDiscountId?: InputMaybe<Scalars['String']>;
  enterprisePromotionId?: InputMaybe<Scalars['String']>;
  fxRateId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  termInstallmentsTotal: Scalars['Int'];
  userIdOpt?: InputMaybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};


export type EnterpriseSelfServeContractProductPricesV1ResourceGetEnterpriseSelfServeContractProductPriceForContractArgs = {
  contractId: Scalars['String'];
  countryIsoCodeOpt?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  enterprisePromotionId?: InputMaybe<Scalars['String']>;
  fxRateId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  termInstallmentsTotal: Scalars['Int'];
  userIdOpt?: InputMaybe<Scalars['String']>;
  userLimit: Scalars['Int'];
};

export type EnterpriseSelfServeContractProductPricesV1ResourceMutations = {
  __typename?: 'EnterpriseSelfServeContractProductPricesV1ResourceMutations';
  getEnterpriseSelfServeContractUnitPrice?: Maybe<Scalars['JSON']>;
  getEnterpriseSelfServeContractUnitPriceForContract?: Maybe<Scalars['JSON']>;
};

export const EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = {
  Invoice: 'INVOICE',
  None: 'NONE',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY'
} as const;

export type EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType = typeof EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType[keyof typeof EnterpriseSelfServeContractProductPricesV1_Org_Coursera_Product_Enterprise_Contract_EnterpriseContractBillingType];
/** Message preset */
export const EnterpriseSentMessages_Preset = {
  /** Preset to congratulate a user on an achievement */
  CongratulateAchievement: 'CONGRATULATE_ACHIEVEMENT',
  /** Custom preset */
  Custom: 'CUSTOM',
  /** Deleted preset */
  Deleted: 'DELETED',
  /** Preset to remind assigned learners */
  RemindAssignedLearners: 'REMIND_ASSIGNED_LEARNERS',
  /** Preset to remind a user to be active past 30 days */
  RemindBeActivePast_30Days: 'REMIND_BE_ACTIVE_PAST_30_DAYS',
  /** Preset to remind a user to be active past 90 days */
  RemindBeActivePast_90Days: 'REMIND_BE_ACTIVE_PAST_90_DAYS',
  /** Preset to remind a user to complete content */
  RemindComplete: 'REMIND_COMPLETE',
  /** Preset to remind a user to enroll */
  RemindEnroll: 'REMIND_ENROLL',
  /** Preset to remind a user to join */
  RemindJoin: 'REMIND_JOIN'
} as const;

export type EnterpriseSentMessages_Preset = typeof EnterpriseSentMessages_Preset[keyof typeof EnterpriseSentMessages_Preset];
/** Defining the queries */
export type EnterpriseSettingQueries = {
  __typename?: 'EnterpriseSettingQueries';
  /** Finder by org id, returns all the settings set for the org and optionally includ program level settings | Maximum page size: 100 */
  findByOrganization: EnterpriseSetting_SettingConnection;
  /** Finder by program id, returns all the settings set for the program and optionally includ org level settings | Maximum page size: 100 */
  findByProgram: EnterpriseSetting_SettingConnection;
  /**
   * This replicates the Get Request from the gRPC side
   * Finds a single setting based on the scope/value/key
   */
  findByScopeAndKey?: Maybe<EnterpriseSetting_Setting>;
};


/** Defining the queries */
export type EnterpriseSettingQueriesFindByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  includeProgramSettings?: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};


/** Defining the queries */
export type EnterpriseSettingQueriesFindByProgramArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  includeOrganizationSettings?: Scalars['Boolean'];
  programId: Scalars['ID'];
};


/** Defining the queries */
export type EnterpriseSettingQueriesFindByScopeAndKeyArgs = {
  enterpriseSettingKey: EnterpriseSetting_Key;
  managedLevelScopeType: EnterpriseSetting_ManagedLevelScopeType;
  managedLevelScopeValue: Scalars['String'];
};

/** ID of the setting to update */
export type EnterpriseSetting_Id = {
  /** Setting key to update */
  enterpriseSettingKey: EnterpriseSetting_Key;
  /** Scope to update */
  managedLevelScope: EnterpriseSetting_ManagedLevelScopeInput;
};

/**
 * The various setting keys available, this should be kept in sync with the proto defined list
 * coursera/proto/enterprisesetting/v1beta1/enterprise_setting.proto
 */
export const EnterpriseSetting_Key = {
  /** Permission for sharing anonymized ELP data (stored per org) with Coursera. */
  EnterpriseSettingKeyAllowElpDataShare: 'ENTERPRISE_SETTING_KEY_ALLOW_ELP_DATA_SHARE',
  /** Deprecated ENTERPRISE_SETTING_KEY_ANONYMOUS_PEER_REVIEW */
  EnterpriseSettingKeyAnonymousPeerReview: 'ENTERPRISE_SETTING_KEY_ANONYMOUS_PEER_REVIEW',
  /**
   * Indicate whether a C4CB survey has been submitted.
   * Product spec: https://docs.google.com/document/d/1n2AiqI-ammSKXLcHsW7PkhcJJNESv7otEacZoNaGnZ0/edit
   */
  EnterpriseSettingKeyC4CbSurveySubmitted: 'ENTERPRISE_SETTING_KEY_C4CB_SURVEY_SUBMITTED',
  /** Indicates whether role selections for a career academy program have been customized or not. */
  EnterpriseSettingKeyCareerAcademyRoleSelectionCustomized: 'ENTERPRISE_SETTING_KEY_CAREER_ACADEMY_ROLE_SELECTION_CUSTOMIZED',
  /** Indicates which variant of Career Academy is enabled for this program (if any). */
  EnterpriseSettingKeyCareerAcademyVariant: 'ENTERPRISE_SETTING_KEY_CAREER_ACADEMY_VARIANT',
  /** This setting allows custom messaging for filled programs instead of displaying the default. */
  EnterpriseSettingKeyCustomFilledProgramMessage: 'ENTERPRISE_SETTING_KEY_CUSTOM_FILLED_PROGRAM_MESSAGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_CUSTOM_INVITATION_LINK */
  EnterpriseSettingKeyCustomInvitationLink: 'ENTERPRISE_SETTING_KEY_CUSTOM_INVITATION_LINK',
  /**
   * By default if this setting is not set for a Career Academy program, the learner's default tab
   * will be the Career Academy page. This setting set to true will remove the career academy
   * page from the learners' default tab.
   */
  EnterpriseSettingKeyDisableCaLearnerDefaultTab: 'ENTERPRISE_SETTING_KEY_DISABLE_CA_LEARNER_DEFAULT_TAB',
  /** Deprecated ENTERPRISE_SETTING_KEY_DISABLE_PROGRAM_DELETION_EMAIL */
  EnterpriseSettingKeyDisableProgramDeletionEmail: 'ENTERPRISE_SETTING_KEY_DISABLE_PROGRAM_DELETION_EMAIL',
  /** Deprecated ENTERPRISE_SETTING_KEY_DISALLOW_PEER_REVIEW_URL_SHARING */
  EnterpriseSettingKeyDisallowPeerReviewUrlSharing: 'ENTERPRISE_SETTING_KEY_DISALLOW_PEER_REVIEW_URL_SHARING',
  /** Deprecated ENTERPRISE_SETTING_KEY_FIRST_UNENROLLMENT_TRIGGER_ENABLED */
  EnterpriseSettingKeyFirstUnenrollmentTriggerEnabled: 'ENTERPRISE_SETTING_KEY_FIRST_UNENROLLMENT_TRIGGER_ENABLED',
  /**
   * The GDPR Mode setting for 3PO scope.
   * See https://coursera.atlassian.net/wiki/spaces/PROD/pages/560300101/SSO+Login+and+Account+Creation+Usability+and+GDPR+Compliance+across+SSO+and+Non-SSO+Orgs#Acceptance-Criteria
   */
  EnterpriseSettingKeyGdprMode: 'ENTERPRISE_SETTING_KEY_GDPR_MODE',
  /** ENTERPRISE_SETTING_KEY_GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED */
  EnterpriseSettingKeyGradebookPlagiarismColumnsEnabled: 'ENTERPRISE_SETTING_KEY_GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED',
  /** Indicates whether or not to include billable contracts in the key insights for an organization */
  EnterpriseSettingKeyInsightsIncludeBillableContracts: 'ENTERPRISE_SETTING_KEY_INSIGHTS_INCLUDE_BILLABLE_CONTRACTS',
  /** Indicates whether or not to include non-billable contracts in the key insights for an organization */
  EnterpriseSettingKeyInsightsIncludeNonBillableContracts: 'ENTERPRISE_SETTING_KEY_INSIGHTS_INCLUDE_NON_BILLABLE_CONTRACTS',
  /** Indicates whether auto enrollment is enabled for LMS/LXP learners by admin */
  EnterpriseSettingKeyLmsLxpAutoEnrollmentEnabled: 'ENTERPRISE_SETTING_KEY_LMS_LXP_AUTO_ENROLLMENT_ENABLED',
  /** Used for checking email address updates. */
  EnterpriseSettingKeyOrgLevelVerifiedEmailDomains: 'ENTERPRISE_SETTING_KEY_ORG_LEVEL_VERIFIED_EMAIL_DOMAINS',
  /** Controls whether personalized content reordering is disabled for the organization */
  EnterpriseSettingKeyPersonalizedContentReorderingDisabled: 'ENTERPRISE_SETTING_KEY_PERSONALIZED_CONTENT_REORDERING_DISABLED',
  /** ENTERPRISE_SETTING_KEY_PLAGIARISM_DETECTION_ENABLED */
  EnterpriseSettingKeyPlagiarismDetectionEnabled: 'ENTERPRISE_SETTING_KEY_PLAGIARISM_DETECTION_ENABLED',
  /** ENTERPRISE_SETTING_KEY_PLAGIARISM_EMAIL_RECIPIENTS */
  EnterpriseSettingKeyPlagiarismEmailRecipients: 'ENTERPRISE_SETTING_KEY_PLAGIARISM_EMAIL_RECIPIENTS',
  /** ENTERPRISE_SETTING_KEY_PREFERRED_LANGUAGE_CODE */
  EnterpriseSettingKeyPreferredLanguageCode: 'ENTERPRISE_SETTING_KEY_PREFERRED_LANGUAGE_CODE',
  /** Indicates whether the employee (removed from program/s) anonymization feature is enabled for the enterprise. */
  EnterpriseSettingKeyRemovedMemberAnonymizationEnabled: 'ENTERPRISE_SETTING_KEY_REMOVED_MEMBER_ANONYMIZATION_ENABLED',
  /** Deprecated ENTERPRISE_SETTING_KEY_SECOND_UNENROLLMENT_TRIGGER_ENABLED */
  EnterpriseSettingKeySecondUnenrollmentTriggerEnabled: 'ENTERPRISE_SETTING_KEY_SECOND_UNENROLLMENT_TRIGGER_ENABLED',
  /** Boolean flag indicating whether SSO locked out state is enabled */
  EnterpriseSettingKeySsoLockedOutStateEnabled: 'ENTERPRISE_SETTING_KEY_SSO_LOCKED_OUT_STATE_ENABLED',
  /** ENTERPRISE_SETTING_KEY_SUPPRESS_ACCLAIM_BADGE */
  EnterpriseSettingKeySuppressAcclaimBadge: 'ENTERPRISE_SETTING_KEY_SUPPRESS_ACCLAIM_BADGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE */
  EnterpriseSettingKeyUnenrollmentProgressThresholdPercentage: 'ENTERPRISE_SETTING_KEY_UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE',
  /** Deprecated ENTERPRISE_SETTING_KEY_UNLIMITED_INVITATIONS */
  EnterpriseSettingKeyUnlimitedInvitations: 'ENTERPRISE_SETTING_KEY_UNLIMITED_INVITATIONS',
  /** Deprecated ENTERPRISE_SETTING_KEY_WHITELIST_EMAIL_DOMAINS */
  EnterpriseSettingKeyWhitelistEmailDomains: 'ENTERPRISE_SETTING_KEY_WHITELIST_EMAIL_DOMAINS'
} as const;

export type EnterpriseSetting_Key = typeof EnterpriseSetting_Key[keyof typeof EnterpriseSetting_Key];
/** Scope based on type and value */
export type EnterpriseSetting_ManagedLevelScope = {
  __typename?: 'EnterpriseSetting_ManagedLevelScope';
  /** Enum of org or program */
  scope: EnterpriseSetting_ManagedLevelScopeType;
  /** The ID of the entity set in the scope, program or org */
  value: Scalars['String'];
};

/** Scope based on type and value */
export type EnterpriseSetting_ManagedLevelScopeInput = {
  /** Enum of org or program */
  scope: EnterpriseSetting_ManagedLevelScopeType;
  /** The ID of the entity set in the scope, program or org */
  value: Scalars['String'];
};

/** The level of the setting, org or program */
export const EnterpriseSetting_ManagedLevelScopeType = {
  /** For program level settings */
  Program: 'PROGRAM',
  /** For org level settings */
  ThirdPartyOrganization: 'THIRD_PARTY_ORGANIZATION'
} as const;

export type EnterpriseSetting_ManagedLevelScopeType = typeof EnterpriseSetting_ManagedLevelScopeType[keyof typeof EnterpriseSetting_ManagedLevelScopeType];
/** The Enterprise setting model returned by the queries */
export type EnterpriseSetting_Setting = Node & {
  __typename?: 'EnterpriseSetting_Setting';
  /**
   * Key-Value pair of EnterpriseSetting_Key and its value.
   * This value can be of boolean, integer, string or list of strings type.
   * Json object examples:
   * {"SOME_ENTERPRISE_SETTING_KEY": true}, {"SOME_ENTERPRISE_SETTING_KEY": 10},
   * {"SOME_ENTERPRISE_SETTING_KEY=": "DEFAULT"}, {"SOME_ENTERPRISE_SETTING_KEY": ["foo.com"]}
   */
  data: Scalars['JSON'];
  /** ID */
  id: Scalars['ID'];
  /** Scope for the key */
  managedLevelScope: EnterpriseSetting_ManagedLevelScope;
};

/** Paginated Settings */
export type EnterpriseSetting_SettingConnection = {
  __typename?: 'EnterpriseSetting_SettingConnection';
  /** Setting edges in the graph */
  edges?: Maybe<Array<EnterpriseSetting_SettingEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of Settings */
  totalCount?: Maybe<Scalars['Int']>;
};

/** SkillsetEdge in graph. */
export type EnterpriseSetting_SettingEdge = {
  __typename?: 'EnterpriseSetting_SettingEdge';
  /** Offset for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** Setting */
  node: EnterpriseSetting_Setting;
};

/** Key value pair to mimic a map */
export type EnterpriseSetting_StringMapTypeValue = {
  /** key */
  key: Scalars['String'];
  /** value */
  value: Scalars['String'];
};

/** One of input based on the type to set */
export type EnterpriseSetting_Type = {
  /** bool setting */
  booleanEnterpriseSetting?: InputMaybe<Scalars['Boolean']>;
  /** int setting */
  integerEnterpriseSetting?: InputMaybe<Scalars['Int']>;
  /** Array of strings */
  stringArrayEnterpriseSetting?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** string setting */
  stringEnterpriseSetting?: InputMaybe<Scalars['String']>;
  /** Map<String, String> setting */
  stringMapEnterpriseSetting?: InputMaybe<Array<InputMaybe<EnterpriseSetting_StringMapTypeValue>>>;
};

/** TODO: Complete this description */
export type EnterpriseSetting_UpdateInput = {
  /** setting type to set */
  enterpriseSettingType: EnterpriseSetting_Type;
  /** org id */
  organizationId: Scalars['ID'];
  /** setting id */
  settingId: EnterpriseSetting_Id;
};

/** Enterprise setting data model result. */
export type EnterpriseSetting_UpdateResult = {
  __typename?: 'EnterpriseSetting_UpdateResult';
  /** setting data model result */
  result?: Maybe<EnterpriseSetting_Setting>;
};

export type EnterpriseSettingsV1 = {
  __typename?: 'EnterpriseSettingsV1';
  id: Scalars['String'];
  scope: Scalars['String'];
  setting: EnterpriseSettingsV1_Setting;
  settingKey: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey;
  thirdPartyOrganizationId?: Maybe<Scalars['String']>;
};

export type EnterpriseSettingsV1ByOrganization = {
  __typename?: 'EnterpriseSettingsV1ByOrganization';
  connection?: Maybe<EnterpriseSettingsV1Connection>;
  includeProgramSettings: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};

export type EnterpriseSettingsV1ByOrganizationKey = {
  __typename?: 'EnterpriseSettingsV1ByOrganizationKey';
  connection?: Maybe<EnterpriseSettingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  settingKey: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};

export type EnterpriseSettingsV1ByProgram = {
  __typename?: 'EnterpriseSettingsV1ByProgram';
  connection?: Maybe<EnterpriseSettingsV1Connection>;
  includeOrganizationSettings: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseSettingsV1BySettingKey = {
  __typename?: 'EnterpriseSettingsV1BySettingKey';
  connection?: Maybe<EnterpriseSettingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  settingKey: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseSettingsV1Connection = {
  __typename?: 'EnterpriseSettingsV1Connection';
  elements: Array<Maybe<EnterpriseSettingsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseSettingsV1Resource = {
  __typename?: 'EnterpriseSettingsV1Resource';
  byOrganization?: Maybe<EnterpriseSettingsV1Connection>;
  byOrganizationKey?: Maybe<EnterpriseSettingsV1Connection>;
  byProgram?: Maybe<EnterpriseSettingsV1Connection>;
  bySettingKey?: Maybe<EnterpriseSettingsV1Connection>;
  get?: Maybe<EnterpriseSettingsV1>;
};


export type EnterpriseSettingsV1ResourceByOrganizationArgs = {
  includeProgramSettings: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type EnterpriseSettingsV1ResourceByOrganizationKeyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  settingKey: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type EnterpriseSettingsV1ResourceByProgramArgs = {
  includeOrganizationSettings: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseSettingsV1ResourceBySettingKeyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  settingKey: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseSettingsV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type EnterpriseSettingsV1ResourceMutations = {
  __typename?: 'EnterpriseSettingsV1ResourceMutations';
  delete?: Maybe<EnterpriseSettingsV1Connection>;
  update?: Maybe<EnterpriseSettingsV1Connection>;
};


export type EnterpriseSettingsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseSettingsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type EnterpriseSettingsV1_BooleanContentMember = {
  __typename?: 'EnterpriseSettingsV1_booleanContentMember';
  booleanContent: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_BooleanEnterpriseSetting;
};

export type EnterpriseSettingsV1_IntegerContentMember = {
  __typename?: 'EnterpriseSettingsV1_integerContentMember';
  integerContent: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_IntegerEnterpriseSetting;
};

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_BooleanEnterpriseSetting = {
  __typename?: 'EnterpriseSettingsV1_org_coursera_enterprise_settings_BooleanEnterpriseSetting';
  value: Scalars['Boolean'];
};

export const EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey = {
  AllowElpDataShare: 'ALLOW_ELP_DATA_SHARE',
  AnonymousPeerReview: 'ANONYMOUS_PEER_REVIEW',
  C4CbSurveySubmitted: 'C4CB_SURVEY_SUBMITTED',
  CareerAcademyRoleSelectionCustomized: 'CAREER_ACADEMY_ROLE_SELECTION_CUSTOMIZED',
  CareerAcademyVariant: 'CAREER_ACADEMY_VARIANT',
  CustomFilledProgramMessage: 'CUSTOM_FILLED_PROGRAM_MESSAGE',
  CustomInvitationLink: 'CUSTOM_INVITATION_LINK',
  DisableCaLearnerDefaultTab: 'DISABLE_CA_LEARNER_DEFAULT_TAB',
  DisableProgramDeletionEmail: 'DISABLE_PROGRAM_DELETION_EMAIL',
  DisallowPeerReviewUrlSharing: 'DISALLOW_PEER_REVIEW_URL_SHARING',
  FirstUnenrollmentTriggerEnabled: 'FIRST_UNENROLLMENT_TRIGGER_ENABLED',
  GdprMode: 'GDPR_MODE',
  GradebookPlagiarismColumnsEnabled: 'GRADEBOOK_PLAGIARISM_COLUMNS_ENABLED',
  KeyInsightsIncludeBillableContracts: 'KEY_INSIGHTS_INCLUDE_BILLABLE_CONTRACTS',
  KeyInsightsIncludeNonBillableContracts: 'KEY_INSIGHTS_INCLUDE_NON_BILLABLE_CONTRACTS',
  OrgLevelVerifiedEmailDomains: 'ORG_LEVEL_VERIFIED_EMAIL_DOMAINS',
  PlagiarismDetectionEnabled: 'PLAGIARISM_DETECTION_ENABLED',
  PlagiarismEmailRecipients: 'PLAGIARISM_EMAIL_RECIPIENTS',
  PreferredLanguageCode: 'PREFERRED_LANGUAGE_CODE',
  RemovedMemberAnonymizationEnabled: 'REMOVED_MEMBER_ANONYMIZATION_ENABLED',
  SecondUnenrollmentTriggerEnabled: 'SECOND_UNENROLLMENT_TRIGGER_ENABLED',
  SuppressAcclaimBadge: 'SUPPRESS_ACCLAIM_BADGE',
  UnenrollmentProgressThresholdPercentage: 'UNENROLLMENT_PROGRESS_THRESHOLD_PERCENTAGE',
  UnlimitedInvitations: 'UNLIMITED_INVITATIONS',
  WhitelistEmailDomains: 'WHITELIST_EMAIL_DOMAINS'
} as const;

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey = typeof EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey[keyof typeof EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_EnterpriseSettingKey];
export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_IntegerEnterpriseSetting = {
  __typename?: 'EnterpriseSettingsV1_org_coursera_enterprise_settings_IntegerEnterpriseSetting';
  value: Scalars['Int'];
};

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringArrayEnterpriseSetting = {
  __typename?: 'EnterpriseSettingsV1_org_coursera_enterprise_settings_StringArrayEnterpriseSetting';
  value: Array<Maybe<Scalars['String']>>;
};

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringEnterpriseSetting = {
  __typename?: 'EnterpriseSettingsV1_org_coursera_enterprise_settings_StringEnterpriseSetting';
  value: Scalars['String'];
};

export type EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringMapEnterpriseSetting = {
  __typename?: 'EnterpriseSettingsV1_org_coursera_enterprise_settings_StringMapEnterpriseSetting';
  value: Scalars['JSON'];
};

export type EnterpriseSettingsV1_Setting = EnterpriseSettingsV1_BooleanContentMember | EnterpriseSettingsV1_IntegerContentMember | EnterpriseSettingsV1_StringArrayContentMember | EnterpriseSettingsV1_StringContentMember | EnterpriseSettingsV1_StringMapContentMember;

export type EnterpriseSettingsV1_StringArrayContentMember = {
  __typename?: 'EnterpriseSettingsV1_stringArrayContentMember';
  stringArrayContent: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringArrayEnterpriseSetting;
};

export type EnterpriseSettingsV1_StringContentMember = {
  __typename?: 'EnterpriseSettingsV1_stringContentMember';
  stringContent: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringEnterpriseSetting;
};

export type EnterpriseSettingsV1_StringMapContentMember = {
  __typename?: 'EnterpriseSettingsV1_stringMapContentMember';
  stringMapContent: EnterpriseSettingsV1_Org_Coursera_Enterprise_Settings_StringMapEnterpriseSetting;
};

/** Enterprise Skills Insights GraphQL Schema */
export type EnterpriseSkillsInsightsQueries = {
  __typename?: 'EnterpriseSkillsInsightsQueries';
  /** This query returns the metrics required for the Skills Insights section */
  querySkillsInsightsByOrg?: Maybe<EnterpriseSkillsInsights_SkillsInsights>;
  /** This query returns the metrics required for the Skills Insights section */
  querySkillsInsightsByProgram?: Maybe<EnterpriseSkillsInsights_SkillsInsights>;
  /**
   * Get the union of tracked skills across the given programs.
   *
   * Intended for powering a skills dropdown based on multiple selected programs.
   * Fetching is based only on programIds.
   */
  queryTrackedSkillsByPrograms: Array<EnterpriseSkillsInsights_RankedSkill>;
};


/** Enterprise Skills Insights GraphQL Schema */
export type EnterpriseSkillsInsightsQueriesQuerySkillsInsightsByOrgArgs = {
  enableTaxonomy2?: Scalars['Boolean'];
  metricsTimeFrame?: EnterpriseSkillsInsights_MetricTimeFrame;
  orgId: Scalars['ID'];
};


/** Enterprise Skills Insights GraphQL Schema */
export type EnterpriseSkillsInsightsQueriesQuerySkillsInsightsByProgramArgs = {
  enableTaxonomy2?: Scalars['Boolean'];
  metricsTimeFrame?: EnterpriseSkillsInsights_MetricTimeFrame;
  orgId?: InputMaybe<Scalars['ID']>;
  programId: Scalars['ID'];
};


/** Enterprise Skills Insights GraphQL Schema */
export type EnterpriseSkillsInsightsQueriesQueryTrackedSkillsByProgramsArgs = {
  metricsTimeFrame?: EnterpriseSkillsInsights_MetricTimeFrame;
  programIds: Array<Scalars['ID']>;
};

/** Last number of days to gather insight from */
export const EnterpriseSkillsInsights_MetricTimeFrame = {
  /** Metrics from the last 90 days */
  NinetyDays: 'NINETY_DAYS',
  /** Metrics from the last 60 days */
  SixtyDays: 'SIXTY_DAYS',
  /** Metrics from the last 30 days */
  ThirtyDays: 'THIRTY_DAYS'
} as const;

export type EnterpriseSkillsInsights_MetricTimeFrame = typeof EnterpriseSkillsInsights_MetricTimeFrame[keyof typeof EnterpriseSkillsInsights_MetricTimeFrame];
/** Insights for a ranked skill. */
export type EnterpriseSkillsInsights_RankedSkill = {
  __typename?: 'EnterpriseSkillsInsights_RankedSkill';
  /** Percentage change of learners learning within the selected timeframe. */
  changePercentage: Scalars['Float'];
  /** Number of learners developing the skill. */
  numOfLearners: Scalars['Int'];
  /** Percentage of all learners assessed for the skill. */
  percentageOfAllLearnersAssessed: Scalars['Float'];
  /** Trending rank of a skill. */
  rank: Scalars['Int'];
  /** Skill ID. */
  skillId: Scalars['ID'];
  /** Name of the skill. */
  skillName: Scalars['String'];
};

/** Skills insights metrics. */
export type EnterpriseSkillsInsights_SkillsInsights = {
  __typename?: 'EnterpriseSkillsInsights_SkillsInsights';
  /** List of skills insights that are tracked by an organization or program. */
  trackedSkillsInsights: Array<EnterpriseSkillsInsights_RankedSkill>;
  /** List of skills insights that are trending by an organization or program. */
  trendingSkillsInsights: Array<EnterpriseSkillsInsights_RankedSkill>;
};

/** Enterprise Skills Queries */
export type EnterpriseSkillsQueries = {
  __typename?: 'EnterpriseSkillsQueries';
  /** Returns skills associated to a org by orgSlug. */
  querySkillsByOrg: EnterpriseSkills_PaginatedResult;
  /** Returns skills associated to a program. */
  querySkillsByProgram: EnterpriseSkills_PaginatedResult;
};


/** Enterprise Skills Queries */
export type EnterpriseSkillsQueriesQuerySkillsByOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};


/** Enterprise Skills Queries */
export type EnterpriseSkillsQueriesQuerySkillsByProgramArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};

/** Paginated academies */
export type EnterpriseSkills_AcademiesConnection = {
  __typename?: 'EnterpriseSkills_AcademiesConnection';
  /** Academy edges in the graph */
  edges?: Maybe<Array<EnterpriseSkills_AcademyEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of academies */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Academy containing skillsets */
export type EnterpriseSkills_Academy = Node & {
  __typename?: 'EnterpriseSkills_Academy';
  /** Academy ID */
  id: Scalars['ID'];
  /** Academy name */
  name?: Maybe<Scalars['String']>;
};

/** Academy edge in graph. */
export type EnterpriseSkills_AcademyEdge = {
  __typename?: 'EnterpriseSkills_AcademyEdge';
  /** Offset for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** Academy */
  node: EnterpriseSkills_Academy;
};

/** A skill and its target proficiency level within a skill profile. */
export type EnterpriseSkills_EnrichedTargetSkillProficiency = {
  __typename?: 'EnterpriseSkills_EnrichedTargetSkillProficiency';
  /** The collection ID associated with this skill proficiency. */
  collectionId: Scalars['ID'];
  /** The unique identifier of the skill. */
  skill: Skill_Skill;
  /** The target proficiency level for this skill. */
  targetProficiency: Scalars['Int'];
};

/** Enterprise TargetSkillProfileSummaries Queries */
export type EnterpriseSkills_EnterpriseTargetSkillProfileSummaryQueries = {
  __typename?: 'EnterpriseSkills_EnterpriseTargetSkillProfileSummaryQueries';
  /** Returns multiple EnterpriseTargetSkillProfileSummaries by their IDs. */
  queryByIds: Array<EnterpriseSkills_EnterpriseTargetSkillProfileSummaryRecord>;
  /** Returns EnterpriseTargetSkillProfileSummaries associated to a org by orgSlug. */
  queryByOrgSlug: EnterpriseSkills_EnterpriseTargetSkillProfileSummary_PaginatedResult;
};


/** Enterprise TargetSkillProfileSummaries Queries */
export type EnterpriseSkills_EnterpriseTargetSkillProfileSummaryQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
  showNumberOfCourses: Scalars['Boolean'];
};


/** Enterprise TargetSkillProfileSummaries Queries */
export type EnterpriseSkills_EnterpriseTargetSkillProfileSummaryQueriesQueryByOrgSlugArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
  showNumberOfCourses: Scalars['Boolean'];
};

/** Summary of an enterprise target skill profile. */
export type EnterpriseSkills_EnterpriseTargetSkillProfileSummaryRecord = {
  __typename?: 'EnterpriseSkills_EnterpriseTargetSkillProfileSummaryRecord';
  /** List of academy IDs associated with this profile. */
  academyIds: Array<Scalars['ID']>;
  /** Timestamp when the profile was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Description of the skill profile in CML format. */
  description?: Maybe<Cml_Cml>;
  /** Optional function identifier. */
  functionId?: Maybe<Scalars['ID']>;
  /** The goal type of this skill profile. */
  goalType: EnterpriseSkills_GoalType;
  /** Unique identifier. */
  id: Scalars['ID'];
  /** Optional industry identifier. */
  industryId?: Maybe<Scalars['ID']>;
  /** Whether this profile has been customized. */
  isCustomized: Scalars['Boolean'];
  /** Number of courses associated with this profile. */
  numberOfCourses?: Maybe<Scalars['Int']>;
  /** Optional occupation identifier. */
  occupationId?: Maybe<Scalars['ID']>;
  /** URL-friendly slug. */
  slug: Scalars['String'];
  /** List of enriched target skill proficiencies. */
  targetSkillProficiencies: Array<EnterpriseSkills_EnrichedTargetSkillProficiency>;
  /** Optional reference to a template skill profile. */
  templateSkillProfileId?: Maybe<Scalars['ID']>;
  /** Third Party Organization. */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
  /** Title of the skill profile. */
  title: Scalars['String'];
};

/** Paginated result for EnterpriseTargetSkillProfileSummary queries. */
export type EnterpriseSkills_EnterpriseTargetSkillProfileSummary_PaginatedResult = {
  __typename?: 'EnterpriseSkills_EnterpriseTargetSkillProfileSummary_PaginatedResult';
  /** List of skill profile summary records. */
  elements: Array<EnterpriseSkills_EnterpriseTargetSkillProfileSummaryRecord>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Function */
export type EnterpriseSkills_Function = {
  __typename?: 'EnterpriseSkills_Function';
  /** Function ID */
  id: Scalars['ID'];
  /** Function display name */
  name?: Maybe<Scalars['String']>;
};

/** A way to categorize Skillsets based on the intended learner journey goal of the Skillset. */
export const EnterpriseSkills_GoalType = {
  /** Invalid goal type */
  Invalid: 'INVALID',
  /** To gain basic literacy in a skill */
  Literacy: 'LITERACY',
  /** Reskill from another career */
  Reskill: 'RESKILL',
  /** Upskill from some existing knowledge */
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseSkills_GoalType = typeof EnterpriseSkills_GoalType[keyof typeof EnterpriseSkills_GoalType];
/** Industry */
export type EnterpriseSkills_Industry = {
  __typename?: 'EnterpriseSkills_Industry';
  /** Industry ID */
  id: Scalars['ID'];
  /** Industry display name */
  name?: Maybe<Scalars['String']>;
};

/** Occupation */
export type EnterpriseSkills_Occupation = {
  __typename?: 'EnterpriseSkills_Occupation';
  /** Occupation ID */
  id: Scalars['ID'];
  /** Occupation display name */
  name?: Maybe<Scalars['String']>;
};

/** Paginated Skills. */
export type EnterpriseSkills_PaginatedResult = {
  __typename?: 'EnterpriseSkills_PaginatedResult';
  /** A list of skills. */
  elements: Array<Skill_Skill>;
  /** Pagination information. */
  pagination: Pagination;
};

/** The scope type of the skillset */
export const EnterpriseSkills_ScopeType = {
  /** Customized skillsets */
  EnterpriseOrganization: 'ENTERPRISE_ORGANIZATION',
  /** Template or global skillsets */
  Global: 'GLOBAL'
} as const;

export type EnterpriseSkills_ScopeType = typeof EnterpriseSkills_ScopeType[keyof typeof EnterpriseSkills_ScopeType];
/** Skill Proficiency Target for a Skillset */
export type EnterpriseSkills_SkillProficiencyTarget = Node & {
  __typename?: 'EnterpriseSkills_SkillProficiencyTarget';
  /** Skill ID */
  id: Scalars['ID'];
  /** Skill name */
  skillName: Scalars['String'];
  /** Proficiency score target for the skill */
  targetProficiencyScore: Scalars['Int'];
};

/** SkillProficiencyTarget edge in graph. */
export type EnterpriseSkills_SkillProficiencyTargetEdge = {
  __typename?: 'EnterpriseSkills_SkillProficiencyTargetEdge';
  /** Offset for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** SkillProficiencyTarget */
  node: EnterpriseSkills_SkillProficiencyTarget;
};

/** Paginated SkillProficiencyTargets */
export type EnterpriseSkills_SkillProficiencyTargetsConnection = {
  __typename?: 'EnterpriseSkills_SkillProficiencyTargetsConnection';
  /** SkillProficiencyTarget edges in the graph */
  edges?: Maybe<Array<EnterpriseSkills_SkillProficiencyTargetEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of SkillProficiencyTargets */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Skillset object */
export type EnterpriseSkills_Skillset = Node & {
  __typename?: 'EnterpriseSkills_Skillset';
  /** Academies that the Skillset is a part of. | Maximum page size: 100 */
  academies?: Maybe<EnterpriseSkills_AcademiesConnection>;
  /**
   * Timestamp of when the Skillset was created, either globally, or when the customer created their
   * own implementation.
   */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Description of Skillset in plain text */
  description: Scalars['String'];
  /**
   * Broad functional grouping of careers. Each career is assigned to at most one function_id
   * and corresponds to career_area in dev_ml.career_taxonomy_wide
   */
  function?: Maybe<EnterpriseSkills_Function>;
  /** A way to categorize Skillsets based on the intended learner journey goal of the Skillset. */
  goalType?: Maybe<EnterpriseSkills_GoalType>;
  /** ID */
  id: Scalars['ID'];
  /** Broader grouping based on the industry. */
  industry?: Maybe<EnterpriseSkills_Industry>;
  /** Name of Skillset */
  name: Scalars['String'];
  /** Represents a unique id identifying a particular career */
  occupation?: Maybe<EnterpriseSkills_Occupation>;
  /** The scope for each skillset. */
  scopeType: EnterpriseSkills_ScopeType;
  /** List of skills and corresponding skill score targets. | Maximum page size: 100 */
  skillProficiencyTargets?: Maybe<EnterpriseSkills_SkillProficiencyTargetsConnection>;
  /** URL-safe and readable ID, generated based on the name of the Skillset. */
  slug: Scalars['String'];
};


/** Skillset object */
export type EnterpriseSkills_SkillsetAcademiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
};


/** Skillset object */
export type EnterpriseSkills_SkillsetSkillProficiencyTargetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
};

/** SkillsetEdge in graph. */
export type EnterpriseSkills_SkillsetEdge = {
  __typename?: 'EnterpriseSkills_SkillsetEdge';
  /** Offset for pagination */
  cursor?: Maybe<Scalars['String']>;
  /** Skillset */
  node: EnterpriseSkills_Skillset;
};

/** Filterable parameters for Skillset data */
export type EnterpriseSkills_SkillsetFilterParameters = {
  /** Academy IDs to filter by */
  academyIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Functions to filter by */
  functionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Goal types to filter by */
  goalTypes?: InputMaybe<Array<EnterpriseSkills_GoalType>>;
  /** Roles to filter by */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Sortable parameters for Skillset data */
export type EnterpriseSkills_SkillsetOrderByInput = {
  /** Sort on createdAt field */
  createdAt?: InputMaybe<EnterpriseSkills_Sort>;
  /** Sort on name field */
  name?: InputMaybe<EnterpriseSkills_Sort>;
};

/** Paginated Skillsets */
export type EnterpriseSkills_SkillsetsConnection = {
  __typename?: 'EnterpriseSkills_SkillsetsConnection';
  /** Skillset edges in the graph */
  edges?: Maybe<Array<EnterpriseSkills_SkillsetEdge>>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Total number of Skillsets */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Sort direction */
export const EnterpriseSkills_Sort = {
  /** Sort ascending order */
  Asc: 'ASC',
  /** Sort descending order */
  Desc: 'DESC'
} as const;

export type EnterpriseSkills_Sort = typeof EnterpriseSkills_Sort[keyof typeof EnterpriseSkills_Sort];
/** The state of a user's relationship with a TargetSkillProfile goal. */
export const EnterpriseSkills_TargetSkillProfileUserGoalState = {
  /** TargetSkillProfile has been deleted from the user's organization. */
  Deleted: 'DELETED',
  /** TargetSkillProfile goal recommendation has been dismissed by the user. */
  Dismissed: 'DISMISSED',
  /** TargetSkillProfile has been saved as a goal for the user. */
  Saved: 'SAVED',
  /** TargetSkillProfile has been unsaved/removed as a goal for the user. */
  Unsaved: 'UNSAVED'
} as const;

export type EnterpriseSkills_TargetSkillProfileUserGoalState = typeof EnterpriseSkills_TargetSkillProfileUserGoalState[keyof typeof EnterpriseSkills_TargetSkillProfileUserGoalState];
/** Represents a user's state for a given target skill profile. */
export type EnterpriseSkills_TargetSkillProfileUserState = {
  __typename?: 'EnterpriseSkills_TargetSkillProfileUserState';
  /** Timestamp when this state was created. */
  createdAt: Scalars['DateTime'];
  /** The current goal state (SAVED, UNSAVED, DISMISSED, DELETED). */
  state: EnterpriseSkills_TargetSkillProfileUserGoalState;
  /** The third-party organization ID (UUID) associated with this state. */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
  /** Timestamp when this state was last updated. */
  updatedAt: Scalars['DateTime'];
};

/** A key-value entry mapping a TargetSkillProfileUserStateId to its corresponding state. */
export type EnterpriseSkills_TargetSkillProfileUserStateEntry = {
  __typename?: 'EnterpriseSkills_TargetSkillProfileUserStateEntry';
  /** The composite key identifying the user and target skill profile. */
  id: EnterpriseSkills_TargetSkillProfileUserStateId;
  /** The user's state for the target skill profile. */
  state: EnterpriseSkills_TargetSkillProfileUserState;
};

/** Composite key identifying a user's state for a specific target skill profile. */
export type EnterpriseSkills_TargetSkillProfileUserStateId = {
  __typename?: 'EnterpriseSkills_TargetSkillProfileUserStateId';
  /** The target skill profile ID (maps from org.coursera.skill.skillsets.UnifiedSkillsetId). */
  targetSkillProfileId: Scalars['ID'];
  /** The user's ID */
  userId: Scalars['ID'];
};

/** Paginated result for TargetSkillProfileUserState queries. */
export type EnterpriseSkills_TargetSkillProfileUserState_PaginatedResult = {
  __typename?: 'EnterpriseSkills_TargetSkillProfileUserState_PaginatedResult';
  /** List of target skill profile user state entries. */
  elements: Array<EnterpriseSkills_TargetSkillProfileUserStateEntry>;
  /** Pagination information. */
  pagination: Pagination;
};

/** TargetSkillProfileUserState Queries */
export type EnterpriseSkills_TargetSkillProfileUserStatesQueries = {
  __typename?: 'EnterpriseSkills_TargetSkillProfileUserStatesQueries';
  /** Returns target skill profile user states for a given org by orgSlug. */
  queryByOrgSlug: EnterpriseSkills_TargetSkillProfileUserState_PaginatedResult;
};


/** TargetSkillProfileUserState Queries */
export type EnterpriseSkills_TargetSkillProfileUserStatesQueriesQueryByOrgSlugArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};

/** Skillset Queries */
export type EnterpriseSkillsetQueries = {
  __typename?: 'EnterpriseSkillsetQueries';
  /** Gets the Skillset with the corresponding ID. */
  queryById?: Maybe<EnterpriseSkills_Skillset>;
  /** Queries skillsets with an organization-level context. | Maximum page size: 1000 */
  queryByOrganization: EnterpriseSkills_SkillsetsConnection;
  /** Queries skillsets with a program context based on the program configuration. | Maximum page size: 1000 */
  queryByProgram: EnterpriseSkills_SkillsetsConnection;
  /** Gets the Skillset with the corresponding slug. */
  queryBySlug?: Maybe<EnterpriseSkills_Skillset>;
};


/** Skillset Queries */
export type EnterpriseSkillsetQueriesQueryByIdArgs = {
  id: Scalars['String'];
};


/** Skillset Queries */
export type EnterpriseSkillsetQueriesQueryByOrganizationArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterParameters?: InputMaybe<EnterpriseSkills_SkillsetFilterParameters>;
  first?: Scalars['Int'];
  orderBy?: InputMaybe<EnterpriseSkills_SkillsetOrderByInput>;
  organizationId: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


/** Skillset Queries */
export type EnterpriseSkillsetQueriesQueryByProgramArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterParameters?: InputMaybe<EnterpriseSkills_SkillsetFilterParameters>;
  first?: Scalars['Int'];
  orderBy?: InputMaybe<EnterpriseSkills_SkillsetOrderByInput>;
  programId: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


/** Skillset Queries */
export type EnterpriseSkillsetQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};

export type EnterpriseSubjectMatterExpertsV1 = {
  __typename?: 'EnterpriseSubjectMatterExpertsV1';
  id: Scalars['String'];
  organizationId: Scalars['String'];
  partnerId: Scalars['Int'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type EnterpriseSubjectMatterExpertsV1ByOrganizationAndUser = {
  __typename?: 'EnterpriseSubjectMatterExpertsV1ByOrganizationAndUser';
  connection?: Maybe<EnterpriseSubjectMatterExpertsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type EnterpriseSubjectMatterExpertsV1ByUser = {
  __typename?: 'EnterpriseSubjectMatterExpertsV1ByUser';
  connection?: Maybe<EnterpriseSubjectMatterExpertsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type EnterpriseSubjectMatterExpertsV1Connection = {
  __typename?: 'EnterpriseSubjectMatterExpertsV1Connection';
  elements: Array<Maybe<EnterpriseSubjectMatterExpertsV1>>;
  paging: ResponsePagination;
};

export type EnterpriseSubjectMatterExpertsV1Resource = {
  __typename?: 'EnterpriseSubjectMatterExpertsV1Resource';
  byOrganizationAndUser?: Maybe<EnterpriseSubjectMatterExpertsV1Connection>;
  byUser?: Maybe<EnterpriseSubjectMatterExpertsV1Connection>;
  get?: Maybe<EnterpriseSubjectMatterExpertsV1>;
};


export type EnterpriseSubjectMatterExpertsV1ResourceByOrganizationAndUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type EnterpriseSubjectMatterExpertsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type EnterpriseSubjectMatterExpertsV1ResourceGetArgs = {
  id: Scalars['String'];
};

/** Queries related to enrollment reports */
export type EnterpriseSummaryEnrollmentReportQueries = {
  __typename?: 'EnterpriseSummaryEnrollmentReportQueries';
  /** Get course enrollments by user and org. Result is filtered based on current user's permissions. */
  getCourseEnrollmentsByUserAndOrg?: Maybe<EnterpriseSummaryReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult>;
};


/** Queries related to enrollment reports */
export type EnterpriseSummaryEnrollmentReportQueriesGetCourseEnrollmentsByUserAndOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  epicEnabled?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Queries related to fetching the different enterprise reports */
export type EnterpriseSummaryReportsQueries = {
  __typename?: 'EnterpriseSummaryReportsQueries';
  /** Fetches the scheduled reports by organization */
  findByOrganization?: Maybe<EnterpriseSummaryReports_ScheduledReportPaginatedResult>;
  /** Fetches metadata (last published time, data freshness) for all report types. */
  getReportMetadata: Array<EnterpriseSummaryReports_ReportMetadata>;
  /**
   * Preview the size of a report before exporting.
   * Returns estimated row count and file size only for the queried report.
   */
  previewReportSize?: Maybe<EnterpriseSummaryReports_PreviewReportSizeResult>;
  /**
   * Resolves a stable report download link ID to a presigned S3 URL. Used when the user clicks
   * the link from the report email. Returns null if the link is not found or expired.
   * Requires the user to be logged in.
   */
  resolveReportDownloadLink?: Maybe<Scalars['URL']>;
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseSummaryReportsQueriesFindByOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  showDeleted?: Scalars['Boolean'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseSummaryReportsQueriesPreviewReportSizeArgs = {
  input: EnterpriseSummaryReports_ExportReportInput;
};


/** Queries related to fetching the different enterprise reports */
export type EnterpriseSummaryReportsQueriesResolveReportDownloadLinkArgs = {
  reportDownloadId: Scalars['ID'];
};

/** Course enrollment */
export type EnterpriseSummaryReports_CourseEnrollment = {
  __typename?: 'EnterpriseSummaryReports_CourseEnrollment';
  /** Timestamp of the completion */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Course for the enrollment */
  course: Course_Course;
  /** Timestamp of the first enrollment */
  enrolledAt: Scalars['DateTime'];
  /** Last activity timestamp, null if there is no activity */
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  /** Program that the course was enrolled through */
  program: EnterpriseProgram_EnterpriseProgram;
  /** Progress percentage (0.0 to 100.0) */
  progressPercentage: Scalars['Float'];
};

/**
 * Input parameters related to the date range for report filtering
 * startDate and endDate are optional and only used when type is CUSTOM
 * startDate is populated for scheduled custom dates
 * both startDate and endDate are populated for export custom dates
 */
export type EnterpriseSummaryReports_DateRange = {
  /** End date to filter on, used for CUSTOM date type */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The type of date range to filter data on */
  type: EnterpriseSummaryReports_DateRangeType;
};

/** The type of date range filters available */
export const EnterpriseSummaryReports_DateRangeType = {
  /** ALL_TIME */
  AllTime: 'ALL_TIME',
  /** CUSTOM */
  Custom: 'CUSTOM',
  /** LAST_30_DAYS */
  Last_30Days: 'LAST_30_DAYS',
  /** LAST_60_DAYS */
  Last_60Days: 'LAST_60_DAYS',
  /** LAST_90_DAYS */
  Last_90Days: 'LAST_90_DAYS',
  /** SINCE_CONTRACT_STARTED */
  SinceContractStarted: 'SINCE_CONTRACT_STARTED',
  /** YEAR_TO_DATE */
  YearToDate: 'YEAR_TO_DATE'
} as const;

export type EnterpriseSummaryReports_DateRangeType = typeof EnterpriseSummaryReports_DateRangeType[keyof typeof EnterpriseSummaryReports_DateRangeType];
/** Failure response for EnterpriseSummaryReports_DeleteSchedule */
export type EnterpriseSummaryReports_DeleteScheduleFailure = {
  __typename?: 'EnterpriseSummaryReports_DeleteScheduleFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise delete schedule input */
export type EnterpriseSummaryReports_DeleteScheduleInput = {
  /** Report type of the scheduled report */
  reportType: EnterpriseSummaryReports_ReportType;
  /** Org id of the scheduled report */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Delete schedule result */
export type EnterpriseSummaryReports_DeleteScheduleResult = EnterpriseSummaryReports_DeleteScheduleFailure | EnterpriseSummaryReports_DeleteScheduleSuccess;

/** Success response for EnterpriseSummaryReports_DeleteSchedule */
export type EnterpriseSummaryReports_DeleteScheduleSuccess = {
  __typename?: 'EnterpriseSummaryReports_DeleteScheduleSuccess';
  /** Scheduled report id */
  id: Scalars['ID'];
};

/** Estimated file size for a specific export format */
export type EnterpriseSummaryReports_EstimatedFileSize = {
  __typename?: 'EnterpriseSummaryReports_EstimatedFileSize';
  /** Export format */
  format: EnterpriseSummaryReports_ExportFormat;
  /** Estimated file size in bytes */
  sizeBytes: Scalars['Int'];
};

/** Enterprise export curriculum report input */
export type EnterpriseSummaryReports_ExportCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export enrollment report input */
export type EnterpriseSummaryReports_ExportEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Export file format for downloadable reports */
export const EnterpriseSummaryReports_ExportFormat = {
  /** Comma-separated values format */
  Csv: 'CSV',
  /** Excel spreadsheet format */
  Xlsx: 'XLSX'
} as const;

export type EnterpriseSummaryReports_ExportFormat = typeof EnterpriseSummaryReports_ExportFormat[keyof typeof EnterpriseSummaryReports_ExportFormat];
/** Enterprise export learner engagement report input */
export type EnterpriseSummaryReports_ExportLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export learner performance report input */
export type EnterpriseSummaryReports_ExportLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise export learner skills report input */
export type EnterpriseSummaryReports_ExportLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise export membership report input */
export type EnterpriseSummaryReports_ExportMembershipReportInput = {
  /** Temporary field to indicate if Epic is enabled, will deprecate after dogfooding */
  epicEnabled?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Failure response for EnterpriseSummaryReports_ExportReport */
export type EnterpriseSummaryReports_ExportReportFailure = {
  __typename?: 'EnterpriseSummaryReports_ExportReportFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise export report input */
export type EnterpriseSummaryReports_ExportReportInput = {
  /** Curriculum report input */
  curriculum?: InputMaybe<EnterpriseSummaryReports_ExportCurriculumReportInput>;
  /** Enrollment report input */
  enrollment?: InputMaybe<EnterpriseSummaryReports_ExportEnrollmentReportInput>;
  /** Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseSummaryReports_ExportLearnerEngagementReportInput>;
  /** Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseSummaryReports_ExportLearnerPerformanceReportInput>;
  /** Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseSummaryReports_ExportLearnerSkillsReportInput>;
  /** Membership report input */
  membership?: InputMaybe<EnterpriseSummaryReports_ExportMembershipReportInput>;
  /** Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseSummaryReports_ExportVerifiedSkillPathProgressReportInput>;
};

/** Export report result */
export type EnterpriseSummaryReports_ExportReportResult = EnterpriseSummaryReports_ExportReportFailure | EnterpriseSummaryReports_ExportReportSuccess;

/** Success response for EnterpriseSummaryReports_ExportReport */
export type EnterpriseSummaryReports_ExportReportSuccess = {
  __typename?: 'EnterpriseSummaryReports_ExportReportSuccess';
  /** This is the s3 airflow metadata presigned url */
  presignedUrl?: Maybe<Scalars['URL']>;
  /**
   * This is the path for the zip file stored in S3.
   * coursera-course-exports/enterprise-reports/organization/<orgSlug>/ContentActivity-<orgSlug>-<timestamp>.zip
   */
  s3Path: Scalars['String'];
};

/** Enterprise export Verified Skill Path Progress report input */
export type EnterpriseSummaryReports_ExportVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Result for GetCourseEnrollmentsByUserAndOrg */
export type EnterpriseSummaryReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult = {
  __typename?: 'EnterpriseSummaryReports_GetCourseEnrollmentsByUserAndOrgPaginatedResult';
  /** Paginated course enrollments */
  elements: Array<EnterpriseSummaryReports_CourseEnrollment>;
  /** Pagination */
  pagination: Pagination;
};

/** Failure response for previewReportSize */
export type EnterpriseSummaryReports_PreviewReportSizeFailure = {
  __typename?: 'EnterpriseSummaryReports_PreviewReportSizeFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Preview report size result */
export type EnterpriseSummaryReports_PreviewReportSizeResult = EnterpriseSummaryReports_PreviewReportSizeFailure | EnterpriseSummaryReports_PreviewReportSizeSuccess;

/** Success response for previewReportSize */
export type EnterpriseSummaryReports_PreviewReportSizeSuccess = {
  __typename?: 'EnterpriseSummaryReports_PreviewReportSizeSuccess';
  /** Estimated file sizes per export format */
  estimatedFileSizesByFormat: Array<EnterpriseSummaryReports_EstimatedFileSize>;
  /** Row counts for each report (CSV file or Excel sheet) */
  reportRowCounts: Array<EnterpriseSummaryReports_ReportRowCount>;
};

/**
 * Common report filters and configuration options
 * Reusable across multiple report types for consistency
 */
export type EnterpriseSummaryReports_ReportFilters = {
  /** List of contract IDs */
  contractIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat?: EnterpriseSummaryReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram?: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** List of pathway IDs for VSP filtering */
  pathwayIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of skill IDs */
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Metadata for a report type indicating when it was last published and the data freshness boundary. */
export type EnterpriseSummaryReports_ReportMetadata = {
  __typename?: 'EnterpriseSummaryReports_ReportMetadata';
  /** Timestamp of the latest activity included in the data */
  activityIncludedTill?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the report data was last published */
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  /** The report type identifier */
  reportType: EnterpriseSummaryReports_ReportType;
};

/** Names of individual report artifacts (CSV files or Excel sheets) */
export const EnterpriseSummaryReports_ReportName = {
  /** Activity by Business Unit pivot (Learner Engagement) */
  ActivityByBusinessUnit: 'ACTIVITY_BY_BUSINESS_UNIT',
  /** Activity by City pivot (Learner Engagement) */
  ActivityByCity: 'ACTIVITY_BY_CITY',
  /** Activity by Country pivot (Learner Engagement) */
  ActivityByCountry: 'ACTIVITY_BY_COUNTRY',
  /** Course Activity (Learner Engagement) */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Curated Curriculum (Curriculum) */
  CuratedCurriculum: 'CURATED_CURRICULUM',
  /** Full Catalog (Curriculum) */
  FullCatalog: 'FULL_CATALOG',
  /** Gradebook Report (Learner Performance) */
  GradebookReport: 'GRADEBOOK_REPORT',
  /** Learning Path Activity (Learner Engagement) */
  LearningPathActivity: 'LEARNING_PATH_ACTIVITY',
  /** Plagiarism Report (Learner Performance) */
  PlagiarismReport: 'PLAGIARISM_REPORT',
  /** Program Activity (Learner Engagement) */
  ProgramActivity: 'PROGRAM_ACTIVITY',
  /** Skills Verified (Verified Skills Path) */
  SkillsVerified: 'SKILLS_VERIFIED',
  /** Skill Benchmarking (Learner Skills) */
  SkillBenchmarking: 'SKILL_BENCHMARKING',
  /** Skill Leaderboard (Learner Skills) */
  SkillLeaderboard: 'SKILL_LEADERBOARD',
  /** Skill Proficiency (Learner Skills) */
  SkillProficiency: 'SKILL_PROFICIENCY',
  /** Specialization Activity (Learner Engagement) */
  SpecializationActivity: 'SPECIALIZATION_ACTIVITY',
  /** Verified Skills Path Activity (Verified Skills Path) */
  VerifiedSkillsPathActivity: 'VERIFIED_SKILLS_PATH_ACTIVITY',
  /** Video Clip Activity (Learner Engagement) */
  VideoClipActivity: 'VIDEO_CLIP_ACTIVITY'
} as const;

export type EnterpriseSummaryReports_ReportName = typeof EnterpriseSummaryReports_ReportName[keyof typeof EnterpriseSummaryReports_ReportName];
/** Row count information for a single report (CSV/sheet) */
export type EnterpriseSummaryReports_ReportRowCount = {
  __typename?: 'EnterpriseSummaryReports_ReportRowCount';
  /** Name of the report artifact */
  reportName: EnterpriseSummaryReports_ReportName;
  /** Estimated number of rows in this report */
  rowCount: Scalars['Int'];
};

/** The type of reports that can be scheduled */
export const EnterpriseSummaryReports_ReportType = {
  /** CURRICULUM */
  Curriculum: 'CURRICULUM',
  /** ENROLLMENT */
  Enrollment: 'ENROLLMENT',
  /** LEARNER_ENGAGEMENT */
  LearnerEngagement: 'LEARNER_ENGAGEMENT',
  /** LEARNER_PERFORMANCE */
  LearnerPerformance: 'LEARNER_PERFORMANCE',
  /** LEARNER_SKILLS */
  LearnerSkills: 'LEARNER_SKILLS',
  /** MEMBERSHIP */
  Membership: 'MEMBERSHIP',
  /** MONTHLY_DIGEST_EMAIL */
  MonthlyDigestEmail: 'MONTHLY_DIGEST_EMAIL',
  /** VERIFIED_SKILL_PATH_PROGRESS */
  VerifiedSkillPathProgress: 'VERIFIED_SKILL_PATH_PROGRESS'
} as const;

export type EnterpriseSummaryReports_ReportType = typeof EnterpriseSummaryReports_ReportType[keyof typeof EnterpriseSummaryReports_ReportType];
/** Failure response for EnterpriseSummaryReports_SaveSchedule */
export type EnterpriseSummaryReports_SaveScheduleFailure = {
  __typename?: 'EnterpriseSummaryReports_SaveScheduleFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Enterprise save schedule input */
export type EnterpriseSummaryReports_SaveScheduleInput = {
  /** Schedule Curriculum report input */
  curriculum?: InputMaybe<EnterpriseSummaryReports_ScheduleCurriculumReportInput>;
  /** Schedule Enrollment report input */
  enrollment?: InputMaybe<EnterpriseSummaryReports_ScheduleEnrollmentReportInput>;
  /** Schedule Learner Engagement report input */
  learnerEngagement?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerEngagementReportInput>;
  /** Schedule Learner Performance report input */
  learnerPerformance?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerPerformanceReportInput>;
  /** Schedule Learner Skills report input */
  learnerSkills?: InputMaybe<EnterpriseSummaryReports_ScheduleLearnerSkillsReportInput>;
  /** Schedule Membership report input */
  membership?: InputMaybe<EnterpriseSummaryReports_ScheduleMembershipReportInput>;
  /** Schedule Monthly Digest Email input */
  monthlyDigestEmail?: InputMaybe<EnterpriseSummaryReports_ScheduleMonthlyDigestEmailInput>;
  /** Schedule Verified Skill Path Progress report input */
  verifiedSkillPathProgress?: InputMaybe<EnterpriseSummaryReports_ScheduleVerifiedSkillPathProgressReportInput>;
};

/** Save schedule result */
export type EnterpriseSummaryReports_SaveScheduleResult = EnterpriseSummaryReports_SaveScheduleFailure | EnterpriseSummaryReports_SaveScheduleSuccess;

/** Success response for EnterpriseSummaryReports_SaveSchedule */
export type EnterpriseSummaryReports_SaveScheduleSuccess = {
  __typename?: 'EnterpriseSummaryReports_SaveScheduleSuccess';
  /** Scheduled report id */
  id: Scalars['ID'];
};

/** What day of the week the report is scheduled to send on, sends weekly */
export const EnterpriseSummaryReports_Schedule = {
  /** FRIDAY */
  Friday: 'FRIDAY',
  /** MONDAY */
  Monday: 'MONDAY',
  /** SATURDAY */
  Saturday: 'SATURDAY',
  /** SUNDAY */
  Sunday: 'SUNDAY',
  /** THURSDAY */
  Thursday: 'THURSDAY',
  /** TUESDAY */
  Tuesday: 'TUESDAY',
  /** WEDNESDAY */
  Wednesday: 'WEDNESDAY'
} as const;

export type EnterpriseSummaryReports_Schedule = typeof EnterpriseSummaryReports_Schedule[keyof typeof EnterpriseSummaryReports_Schedule];
/** Enterprise schedule curriculum report input */
export type EnterpriseSummaryReports_ScheduleCurriculumReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseSummaryReports_ScheduleEnrollmentReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Should report include data about removed members */
  includeEnrolledWithoutActivity?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner engagement report input */
export type EnterpriseSummaryReports_ScheduleLearnerEngagementReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner performance report input */
export type EnterpriseSummaryReports_ScheduleLearnerPerformanceReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule learner skills report input */
export type EnterpriseSummaryReports_ScheduleLearnerSkillsReportInput = {
  /** Date range filtering */
  dateRange: EnterpriseSummaryReports_DateRange;
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
  /** List of skill IDs (required) */
  skillIds: Array<Scalars['ID']>;
};

/** Enterprise schedule enrollment report input */
export type EnterpriseSummaryReports_ScheduleMembershipReportInput = {
  /** Should report include data about invited learners */
  includeInvitedLearners?: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners?: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers?: Scalars['Boolean'];
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** Enterprise schedule monthly digest email input */
export type EnterpriseSummaryReports_ScheduleMonthlyDigestEmailInput = {
  /** Org and programId context for report (programIds should be empty for monthly digest) */
  scope: EnterpriseSummaryReports_Scope;
};

/** What days of the week the report is scheduled to send on, sends weekly */
export type EnterpriseSummaryReports_ScheduleObject = {
  __typename?: 'EnterpriseSummaryReports_ScheduleObject';
  /** FRIDAY */
  friday: Scalars['Boolean'];
  /** MONDAY */
  monday: Scalars['Boolean'];
  /** SATURDAY */
  saturday: Scalars['Boolean'];
  /** SUNDAY */
  sunday: Scalars['Boolean'];
  /** THURSDAY */
  thursday: Scalars['Boolean'];
  /** TUESDAY */
  tuesday: Scalars['Boolean'];
  /** WEDNESDAY */
  wednesday: Scalars['Boolean'];
};

/** Enterprise schedule Verified Skill Path Progress report input */
export type EnterpriseSummaryReports_ScheduleVerifiedSkillPathProgressReportInput = {
  /** Common report filters and configuration options */
  filters?: InputMaybe<EnterpriseSummaryReports_ReportFilters>;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_Schedule;
  /** Org and programId context for report */
  scope: EnterpriseSummaryReports_Scope;
};

/** A scheduled report */
export type EnterpriseSummaryReports_ScheduledReport = {
  __typename?: 'EnterpriseSummaryReports_ScheduledReport';
  /** List of contracts */
  contracts: Array<EnterpriseContract_EnterpriseContract>;
  /** End date to filter on, used for CUSTOM date type */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Export file format (CSV or XLSX). Defaults to CSV for backward compatibility. */
  exportFormat: EnterpriseSummaryReports_ExportFormat;
  /** Flag to export one CSV per program */
  exportOneCsvPerProgram: Scalars['Boolean'];
  /** Scheduled report id */
  id: Scalars['ID'];
  /** Should report include data about users enrolled but without activity */
  includeEnrolledWithoutActivity: Scalars['Boolean'];
  /** Should report include data about invited learners */
  includeInvitedLearners: Scalars['Boolean'];
  /** Should report include data about joined learners */
  includeJoinedLearners: Scalars['Boolean'];
  /** Should report include data about removed members */
  includeRemovedMembers: Scalars['Boolean'];
  /** Whether this schedule has been soft-deleted (cancelled) */
  isDeleted: Scalars['Boolean'];
  /** Timestamp when config was last modified */
  lastModifiedAt?: Maybe<Scalars['DateTime']>;
  /**
   * List of Verified Skill Pathway IDs selected as report filters. Empty when none
   * were selected at schedule time, allowing the edit flow to retain user selections.
   * Returned as a plain ID list (not a federated entity) because
   * VerifiedSkills_SkillPathwaySummary is not declared as an @key entity in the
   * verifiedskills subgraph; the frontend already resolves names via
   * getAllSkillPathwaysByProgramIds.
   */
  pathwayIds: Array<Scalars['ID']>;
  /** A list of program ids for the scope */
  programs: Array<EnterpriseProgram_EnterpriseProgram>;
  /** The type of scheduled report */
  reportType: EnterpriseSummaryReports_ReportType;
  /** When the report is scheduled to send */
  schedule: EnterpriseSummaryReports_ScheduleObject;
  /** Display name of the user who scheduled the report */
  schedulerName?: Maybe<Scalars['String']>;
  /** List of skills */
  skills: Array<Skill_Skill>;
  /** Start date to filter on, used for CUSTOM date type */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Org id this report is on */
  thirdPartyOrganizationId: Scalars['ID'];
  /** Organization timezone */
  timezone?: Maybe<Scalars['String']>;
  /** The type of date range to filter data on */
  type?: Maybe<EnterpriseSummaryReports_DateRangeType>;
};

/** Result for FindByOrganization */
export type EnterpriseSummaryReports_ScheduledReportPaginatedResult = {
  __typename?: 'EnterpriseSummaryReports_ScheduledReportPaginatedResult';
  /** Scheduled reports */
  elements: Array<EnterpriseSummaryReports_ScheduledReport>;
  /** Pagination */
  pagination: Pagination;
};

/** What context the report should be limited to */
export type EnterpriseSummaryReports_Scope = {
  /** Program ids to filter on */
  programIds: Array<Scalars['ID']>;
  /** Org id to filter on */
  thirdPartyOrganizationId: Scalars['ID'];
};

export type EnterpriseTargetSkillProfileSummariesV1 = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1';
  academyIds: Array<Maybe<Scalars['String']>>;
  collectionsAdmin?: Maybe<EnterpriseCollectionsAdminV1Connection>;
  createdAt: Scalars['Float'];
  description?: Maybe<EnterpriseTargetSkillProfileSummariesV1_CmlMember>;
  /** Identifier for availables role functions */
  functionId?: Maybe<Scalars['String']>;
  goalType?: Maybe<EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType>;
  id: Scalars['String'];
  /** Identifier for industry that we have role profiles for */
  industryId?: Maybe<Scalars['String']>;
  isCustomized: Scalars['Boolean'];
  learnerFacingTitle: Scalars['String'];
  numberOfCourses?: Maybe<Scalars['Int']>;
  /** Identifier for occupations that we have role profiles for */
  occupationId?: Maybe<Scalars['String']>;
  orgId: Scalars['String'];
  programs?: Maybe<EnterpriseProgramsV1Connection>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  targetSkillProficiencies: Array<Maybe<EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Enterprise_Skills_EnrichedTargetSkillProficiency>>;
  templateSkillProfileId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type EnterpriseTargetSkillProfileSummariesV1CollectionsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  templateSkillProfileId?: InputMaybe<Scalars['String']>;
  usePersonalizedRecs?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ProgramsArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1ByOrganization = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1ByOrganization';
  connection?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  showNumberOfCourses?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1ByOrganizationPaginated = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1ByOrganizationPaginated';
  connection?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  showNumberOfCourses?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1ByProgram = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1ByProgram';
  connection?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  showNumberOfCourses?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1BySlug = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1BySlug';
  connection?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  showNumberOfCourses?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1Connection = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1Connection';
  elements: Array<Maybe<EnterpriseTargetSkillProfileSummariesV1>>;
  paging: ResponsePagination;
};

export type EnterpriseTargetSkillProfileSummariesV1Resource = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1Resource';
  byOrganization?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  byOrganizationPaginated?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  byProgram?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  bySlug?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
  get?: Maybe<EnterpriseTargetSkillProfileSummariesV1>;
  multiGet?: Maybe<EnterpriseTargetSkillProfileSummariesV1Connection>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceByOrganizationArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceByOrganizationPaginatedArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceByProgramArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceGetArgs = {
  id: Scalars['String'];
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseTargetSkillProfileSummariesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfileSummariesV1_CmlMember = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_cmlMember';
  cml: EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Enterprise_Skills_EnrichedTargetSkillProficiency = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_enterprise_skills_EnrichedTargetSkillProficiency';
  collectionId: Scalars['String'];
  /** Identifier for Skills at different levels in skill graph */
  skillId: Scalars['String'];
  skillName: Scalars['String'];
  targetProficiency: Scalars['Int'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'EnterpriseTargetSkillProfileSummariesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

/** High-level goal for the skillset which will be used for grouping, filtering, reporting, and clarity */
export const EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType = {
  Literacy: 'LITERACY',
  Reskill: 'RESKILL',
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType = typeof EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType[keyof typeof EnterpriseTargetSkillProfileSummariesV1_Org_Coursera_Skill_GoalType];
/** SkillSet object, resolved through Naptime via Garphql Mesh */
export type EnterpriseTargetSkillProfilesV1 = {
  __typename?: 'EnterpriseTargetSkillProfilesV1';
  academyIds: Array<Maybe<Scalars['String']>>;
  createdAt: Scalars['Float'];
  description?: Maybe<EnterpriseTargetSkillProfilesV1_CmlMember>;
  /** Identifier for availables role functions */
  functionId?: Maybe<Scalars['String']>;
  goalType?: Maybe<EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType>;
  /** Skillset id */
  id: Scalars['String'];
  /** Identifier for industry that we have role profiles for */
  industryId?: Maybe<Scalars['String']>;
  isCustomized: Scalars['Boolean'];
  learnerFacingTitle: Scalars['String'];
  /** Identifier for occupations that we have role profiles for */
  occupationId?: Maybe<Scalars['String']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  staticCollectionId?: Maybe<Scalars['String']>;
  targetSkillProficiencies: Array<Maybe<EnterpriseTargetSkillProfilesV1_Org_Coursera_Enterprise_Skills_TargetSkillProficiency>>;
  templateSkillProfileId?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  title: Scalars['String'];
};

export type EnterpriseTargetSkillProfilesV1ByOrg = {
  __typename?: 'EnterpriseTargetSkillProfilesV1ByOrg';
  connection?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfilesV1ByOrgPaginated = {
  __typename?: 'EnterpriseTargetSkillProfilesV1ByOrgPaginated';
  connection?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfilesV1Connection = {
  __typename?: 'EnterpriseTargetSkillProfilesV1Connection';
  elements: Array<Maybe<EnterpriseTargetSkillProfilesV1>>;
  paging: ResponsePagination;
};

export type EnterpriseTargetSkillProfilesV1Resource = {
  __typename?: 'EnterpriseTargetSkillProfilesV1Resource';
  byOrg?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  byOrgPaginated?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  get?: Maybe<EnterpriseTargetSkillProfilesV1>;
  multiGet?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
};


export type EnterpriseTargetSkillProfilesV1ResourceByOrgArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfilesV1ResourceByOrgPaginatedArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseTargetSkillProfilesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type EnterpriseTargetSkillProfilesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseTargetSkillProfilesV1ResourceMutations = {
  __typename?: 'EnterpriseTargetSkillProfilesV1ResourceMutations';
  bulkDelete?: Maybe<Scalars['JSON']>;
  create?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  createFromTemplateWithCustomization?: Maybe<Scalars['JSON']>;
  delete?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  patch?: Maybe<EnterpriseTargetSkillProfilesV1Connection>;
  refreshAcademyIds?: Maybe<Scalars['JSON']>;
};


export type EnterpriseTargetSkillProfilesV1ResourceMutationsCreateArgs = {
  enableEpic?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseTargetSkillProfilesV1ResourceMutationsCreateFromTemplateWithCustomizationArgs = {
  enableEpic?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseTargetSkillProfilesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type EnterpriseTargetSkillProfilesV1ResourceMutationsPatchArgs = {
  enableEpic?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type EnterpriseTargetSkillProfilesV1ResourceMutationsRefreshAcademyIdsArgs = {
  id: Scalars['String'];
};

export type EnterpriseTargetSkillProfilesV1_CmlMember = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_cmlMember';
  cml: EnterpriseTargetSkillProfilesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** Targeted proficiency for a skill. */
export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Enterprise_Skills_TargetSkillProficiency = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_enterprise_skills_TargetSkillProficiency';
  collectionId: Scalars['String'];
  /** Identifier for Skills at different levels in skill graph */
  skillId: Scalars['String'];
  targetProficiency: Scalars['Int'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'EnterpriseTargetSkillProfilesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<EnterpriseTargetSkillProfilesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

/** High-level goal for the skillset which will be used for grouping, filtering, reporting, and clarity */
export const EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType = {
  Literacy: 'LITERACY',
  Reskill: 'RESKILL',
  Upskill: 'UPSKILL'
} as const;

export type EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType = typeof EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType[keyof typeof EnterpriseTargetSkillProfilesV1_Org_Coursera_Skill_GoalType];
/** EnterpriseUserAdminView: a view for enterprise admins to see user data */
export type EnterpriseUserAdminViewQueries = {
  __typename?: 'EnterpriseUserAdminViewQueries';
  /** This query counts the number of user records in an org based on the filter json file. */
  countByFilter: Scalars['Int'];
  /** This query returns a paginated list of user records. */
  queryByFilter: EnterpriseUserAdminView_QueryByFilterPaginatedResult;
};


/** EnterpriseUserAdminView: a view for enterprise admins to see user data */
export type EnterpriseUserAdminViewQueriesCountByFilterArgs = {
  filter: EnterpriseUserAdminView_UserFilterInput;
  orgId: Scalars['ID'];
};


/** EnterpriseUserAdminView: a view for enterprise admins to see user data */
export type EnterpriseUserAdminViewQueriesQueryByFilterArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter: EnterpriseUserAdminView_UserFilterInput;
  limit?: Scalars['Int'];
  orgId: Scalars['ID'];
};

/** ActivityFilterInput: all ActivityFilterInput variants */
export type EnterpriseUserAdminView_ActivityFilterInput = {
  /** assigned content */
  assignedContent?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_AssignedContentInput>;
  /** completed */
  completed?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_CompletedInput>;
  /** enrolled */
  enrolled?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_EnrolledInput>;
  /** enrolled but inactive */
  enrolledButInactive?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_EnrolledButInactiveInput>;
  /** general inactivity */
  generalInactivity?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_GeneralInactivityInput>;
  /** no enrollments */
  noEnrollments?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_NoEnrollmentsInput>;
  /** either not enrolled in the course or not completed the course */
  notEnrolledOrNotCompleted?: InputMaybe<EnterpriseUserAdminView_ActivityFilter_NotEnrolledOrNotCompletedInput>;
};

/** activity filter for assigned content */
export type EnterpriseUserAdminView_ActivityFilter_AssignedContentInput = {
  /** selected product ids */
  contentSelection: EnterpriseUserAdminView_ContentSelectionInput;
  /** flag signifying completion or non-enrollment */
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  /** flag signifying enrollment or non-enrollment */
  isEnrolled?: InputMaybe<Scalars['Boolean']>;
};

/** activity filter for completed */
export type EnterpriseUserAdminView_ActivityFilter_CompletedInput = {
  /** date of completion */
  completionDate: EnterpriseUserAdminView_DateComparisonInput;
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for enrolled but inactive */
export type EnterpriseUserAdminView_ActivityFilter_EnrolledButInactiveInput = {
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** date of last activity */
  lastActivityDate: EnterpriseUserAdminView_DateComparisonInput;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for enrolled */
export type EnterpriseUserAdminView_ActivityFilter_EnrolledInput = {
  /** date of enrollment */
  enrollmentDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** selected product ids */
  productIdSelection?: InputMaybe<EnterpriseUserAdminView_ProductIdSelectionInput>;
};

/** activity filter for general inactivity */
export type EnterpriseUserAdminView_ActivityFilter_GeneralInactivityInput = {
  /** date of last activity */
  lastActivityDate: EnterpriseUserAdminView_DateComparisonInput;
};

/** activity filter for no enrollments */
export type EnterpriseUserAdminView_ActivityFilter_NoEnrollmentsInput = {
  /** noop field - used to emulate an empty object since graphql-java does not support empty objects */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** activity filter for either not enrolled in the course or not completed the course */
export type EnterpriseUserAdminView_ActivityFilter_NotEnrolledOrNotCompletedInput = {
  /** selected product ids for the filter */
  productIdSelection: EnterpriseUserAdminView_ProductIdSelectionInput;
};

/** additional attribute selection */
export type EnterpriseUserAdminView_AdditionalAttributeSelectionInput = {
  /** attribute name */
  attributeName: EnterpriseUserAdminView_AttributeName;
  /** values in the list */
  values: Array<Scalars['ID']>;
};

/** AttributeName: all attribute names */
export const EnterpriseUserAdminView_AttributeName = {
  /** business unit */
  BusinessUnit: 'BUSINESS_UNIT',
  /** contract id */
  Contract: 'CONTRACT',
  /** job title */
  JobTitle: 'JOB_TITLE',
  /** job type */
  JobType: 'JOB_TYPE',
  /** location */
  Location: 'LOCATION',
  /** manager */
  Manager: 'MANAGER'
} as const;

export type EnterpriseUserAdminView_AttributeName = typeof EnterpriseUserAdminView_AttributeName[keyof typeof EnterpriseUserAdminView_AttributeName];
/** SortableColumn: all sortable columns */
export const EnterpriseUserAdminView_ColumnName = {
  /** business unit column */
  BusinessUnit: 'BUSINESS_UNIT',
  /** deleted at column */
  DeletedAt: 'DELETED_AT',
  /** invited at column */
  InvitedAt: 'INVITED_AT',
  /** is soft deleted column */
  IsSoftDeleted: 'IS_SOFT_DELETED',
  /** joined at column */
  JoinedAt: 'JOINED_AT',
  /** latest activity at column */
  LatestActivityAt: 'LATEST_ACTIVITY_AT',
  /** manager name column */
  ManagerName: 'MANAGER_NAME',
  /** name column */
  Name: 'NAME',
  /** number of enrollments column */
  NumCompletions: 'NUM_COMPLETIONS',
  /** number of enrollments column */
  NumEnrollments: 'NUM_ENROLLMENTS'
} as const;

export type EnterpriseUserAdminView_ColumnName = typeof EnterpriseUserAdminView_ColumnName[keyof typeof EnterpriseUserAdminView_ColumnName];
/** selected content */
export type EnterpriseUserAdminView_ContentInput = {
  /** content id */
  contentId: Scalars['ID'];
  /** content type */
  contentType: EnterpriseUserAdminView_ContentType;
};

/** selected content */
export type EnterpriseUserAdminView_ContentSelectionInput = {
  /** selected content */
  values: Array<EnterpriseUserAdminView_ContentInput>;
};

/** ContentType: all content types */
export const EnterpriseUserAdminView_ContentType = {
  /** course type */
  Course: 'COURSE',
  /** learning path type */
  LearningPath: 'LEARNING_PATH',
  /** specialization type */
  Specialization: 'SPECIALIZATION'
} as const;

export type EnterpriseUserAdminView_ContentType = typeof EnterpriseUserAdminView_ContentType[keyof typeof EnterpriseUserAdminView_ContentType];
/** Pagination for enterprise contracts results. */
export type EnterpriseUserAdminView_ContractsPaginatedResult = {
  __typename?: 'EnterpriseUserAdminView_ContractsPaginatedResult';
  /** A list of enterprise contracts - to be enriched by federation. */
  elements: Array<EnterpriseContract_EnterpriseContract>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** DateComparisonInput: all DateComparisonInput variants */
export type EnterpriseUserAdminView_DateComparisonInput = {
  /** absolute */
  absolute?: InputMaybe<EnterpriseUserAdminView_DateComparison_AbsoluteInput>;
  /** relative */
  relative?: InputMaybe<EnterpriseUserAdminView_DateComparison_RelativeInput>;
};

/** absolute date comparison type */
export type EnterpriseUserAdminView_DateComparison_AbsoluteInput = {
  /** time after */
  after?: InputMaybe<Scalars['DateTime']>;
  /** time before */
  before?: InputMaybe<Scalars['DateTime']>;
};

/** relative date comparison type */
export type EnterpriseUserAdminView_DateComparison_RelativeInput = {
  /** days after */
  nDaysAgoAfter?: InputMaybe<Scalars['Int']>;
  /** days before */
  nDaysAgoBefore?: InputMaybe<Scalars['Int']>;
};

/** Email: email */
export type EnterpriseUserAdminView_Email = {
  __typename?: 'EnterpriseUserAdminView_Email';
  /** email */
  email: Scalars['ID'];
};

/** Pagination for enterprise contracts results. */
export type EnterpriseUserAdminView_EnterpriseContractsPaginatedResult = {
  __typename?: 'EnterpriseUserAdminView_EnterpriseContractsPaginatedResult';
  /** A list of enterprise contracts - to be enriched by federation. */
  elements: Array<EnterpriseContractsV1>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Pagination for enterprise programs results. */
export type EnterpriseUserAdminView_EnterpriseProgramsPaginatedResult = {
  __typename?: 'EnterpriseUserAdminView_EnterpriseProgramsPaginatedResult';
  /** A list of enterprise programs - to be enriched by federation. */
  elements: Array<EnterpriseProgram>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** user identifiers selected in the filters */
export type EnterpriseUserAdminView_FilterResultUserSelectionInput = {
  /** optional user identifiers: list of userIds and/or emails */
  userIdentifiers: Array<EnterpriseUserAdminView_UserIdentifierInput>;
};

/** PrimaryFilterInput: all PrimaryFilterInput variants */
export type EnterpriseUserAdminView_PrimaryFilterInput = {
  /** invited */
  invited?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_InvitedInput>;
  /** member */
  member?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_MemberInput>;
  /** multi primaryFilterType */
  multiFilter?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_MultiFilterInput>;
  /** removed member */
  removedMember?: InputMaybe<EnterpriseUserAdminView_PrimaryFilter_RemovedMemberInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_InvitedInput = {
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_MemberInput = {
  /** activity filter */
  activityFilter?: InputMaybe<EnterpriseUserAdminView_ActivityFilterInput>;
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
  /** program join date */
  programJoinDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_MultiFilterInput = {
  /** activity filter */
  activityFilter?: InputMaybe<EnterpriseUserAdminView_ActivityFilterInput>;
  /** List of membership states to query */
  membershipStates: Array<EnterpriseUserAdminView_UserProgramMembershipStatus>;
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
  /** program join date */
  programJoinDate?: InputMaybe<EnterpriseUserAdminView_DateComparisonInput>;
  /** ScimState to query */
  scimManagedFilter?: InputMaybe<Scalars['Boolean']>;
};

/** primary filter */
export type EnterpriseUserAdminView_PrimaryFilter_RemovedMemberInput = {
  /** selected programIds */
  programIdSelection?: InputMaybe<EnterpriseUserAdminView_StringSelectionInput>;
};

/** represents a product - which could be either a course or specialization. */
export type EnterpriseUserAdminView_Product = Course_Course | Specialization_Specialization;

/** An Enterprise Product Id object */
export type EnterpriseUserAdminView_ProductIdInput = {
  /** product item id */
  productItemId: Scalars['ID'];
  /** product type */
  productType: EnterpriseUserAdminView_ProductType;
};

/** selected product ids */
export type EnterpriseUserAdminView_ProductIdSelectionInput = {
  /** selected product ids */
  values: Array<EnterpriseUserAdminView_ProductIdInput>;
};

/** product type */
export const EnterpriseUserAdminView_ProductType = {
  /** specialization type */
  Specialization: 'SPECIALIZATION',
  /** course type */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type EnterpriseUserAdminView_ProductType = typeof EnterpriseUserAdminView_ProductType[keyof typeof EnterpriseUserAdminView_ProductType];
/** Pagination for coursera products results. */
export type EnterpriseUserAdminView_ProductsPaginatedResult = {
  __typename?: 'EnterpriseUserAdminView_ProductsPaginatedResult';
  /** A list of products - to be enriched by federation. */
  elements: Array<Maybe<EnterpriseUserAdminView_Product>>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Pagination: pagination metadata */
export type EnterpriseUserAdminView_QueryByFilterPaginatedResult = {
  __typename?: 'EnterpriseUserAdminView_QueryByFilterPaginatedResult';
  /** A list of user records */
  elements: Array<EnterpriseUserAdminView_UserRecord>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** SortDirection: sort direction */
export const EnterpriseUserAdminView_SortDirection = {
  /** ascending sort direction */
  Ascending: 'ASCENDING',
  /** descending sort direction */
  Descending: 'DESCENDING'
} as const;

export type EnterpriseUserAdminView_SortDirection = typeof EnterpriseUserAdminView_SortDirection[keyof typeof EnterpriseUserAdminView_SortDirection];
/** SortRequest: a sort request */
export type EnterpriseUserAdminView_SortableColumnInput = {
  /** Column to sort by */
  columnName: EnterpriseUserAdminView_ColumnName;
  /** Direction to sort by */
  sortDirection?: EnterpriseUserAdminView_SortDirection;
};

/** primary filter */
export type EnterpriseUserAdminView_StringSelectionInput = {
  /** primary filter programId selections */
  values?: InputMaybe<Array<Scalars['String']>>;
};

/** UserFilterInput: all filter parameters input relating to UserFilterV1 */
export type EnterpriseUserAdminView_UserFilterInput = {
  /** optional additional filters: list of additional filters */
  additionalAttributeSelections?: InputMaybe<Array<EnterpriseUserAdminView_AdditionalAttributeSelectionInput>>;
  /** optional selected filter user identifier selections */
  filterResultUserSelection?: InputMaybe<EnterpriseUserAdminView_FilterResultUserSelectionInput>;
  /** primary filter: membership state */
  primaryFilter: EnterpriseUserAdminView_PrimaryFilterInput;
  /** optional search name or emails: list of emails or names to search for */
  searchNameOrEmails?: InputMaybe<Array<Scalars['String']>>;
  /** optional sort by: list of sort requests */
  sortBy?: InputMaybe<Array<EnterpriseUserAdminView_SortableColumnInput>>;
};

/** UserId: user id */
export type EnterpriseUserAdminView_UserId = {
  __typename?: 'EnterpriseUserAdminView_UserId';
  /** user id */
  userId: Scalars['ID'];
};

/** UserIdentifier: all user identifiers (output) */
export type EnterpriseUserAdminView_UserIdentifier = EnterpriseUserAdminView_Email | EnterpriseUserAdminView_UserId;

/** UserIdentifierInput: all user identifiers (input) */
export type EnterpriseUserAdminView_UserIdentifierInput = {
  /** email */
  email?: InputMaybe<Scalars['ID']>;
  /** user id */
  userId?: InputMaybe<Scalars['ID']>;
};

/** User Program Membership status */
export const EnterpriseUserAdminView_UserProgramMembershipStatus = {
  /** invited status */
  Invited: 'INVITED',
  /** joined status */
  Joined: 'JOINED',
  /** removed status */
  Removed: 'REMOVED'
} as const;

export type EnterpriseUserAdminView_UserProgramMembershipStatus = typeof EnterpriseUserAdminView_UserProgramMembershipStatus[keyof typeof EnterpriseUserAdminView_UserProgramMembershipStatus];
/** UserRecord: all user records */
export type EnterpriseUserAdminView_UserRecord = {
  __typename?: 'EnterpriseUserAdminView_UserRecord';
  /** optional business unit */
  businessUnit?: Maybe<Scalars['String']>;
  /** optional business unit2 */
  businessUnit2?: Maybe<Scalars['String']>;
  /** email */
  email: Scalars['ID'];
  /** contracts */
  enterpriseContracts?: Maybe<Array<EnterpriseContract_EnterpriseContract>>;
  /** contracts */
  enterpriseContractsPaginated: EnterpriseUserAdminView_ContractsPaginatedResult;
  /** programs */
  enterprisePrograms: EnterpriseUserAdminView_EnterpriseProgramsPaginatedResult;
  /** optional external id */
  externalId?: Maybe<Scalars['ID']>;
  /** full name */
  fullName: Scalars['String'];
  /** optional invited timestamp */
  invitedTimestamp?: Maybe<Scalars['DateTime']>;
  /** Boolean flag indicating if the user is a managed by SCIM */
  isScimManaged?: Maybe<Scalars['Boolean']>;
  /** is soft deleted */
  isSoftDeleted: Scalars['Boolean'];
  /** optional job title */
  jobTitle?: Maybe<Scalars['String']>;
  /** optional job type */
  jobType?: Maybe<Scalars['String']>;
  /** optional joined timestamp */
  joinedTimestamp?: Maybe<Scalars['DateTime']>;
  /** optional latest activity timestamp */
  latestActivityTimestamp?: Maybe<Scalars['DateTime']>;
  /** optional location city */
  locationCity?: Maybe<Scalars['String']>;
  /** optional location country */
  locationCountry?: Maybe<Scalars['String']>;
  /** optional location region */
  locationRegion?: Maybe<Scalars['String']>;
  /** optional manager email */
  managerEmail?: Maybe<Scalars['String']>;
  /** optional manager name */
  managerName?: Maybe<Scalars['String']>;
  /** optional membership deletion timestamp */
  membershipDeletionTimestamp?: Maybe<Scalars['DateTime']>;
  /** The membership status of the user in its programs */
  membershipStatus: EnterpriseUserAdminView_UserProgramMembershipStatus;
  /**
   * contracts
   * @deprecated Use enterpriseContractsPaginated instead
   */
  naptimeEnterpriseContracts: EnterpriseUserAdminView_EnterpriseContractsPaginatedResult;
  /** number of completions */
  numCompletions: Scalars['Int'];
  /** number of enrollments */
  numEnrollments: Scalars['Int'];
  /** products */
  products: EnterpriseUserAdminView_ProductsPaginatedResult;
  /** optional record updated timestamp */
  recordUpdatedTimestamp?: Maybe<Scalars['DateTime']>;
  /** optional user id */
  userId?: Maybe<Scalars['ID']>;
  /** user identifier */
  userIdentifier: EnterpriseUserAdminView_UserIdentifier;
};


/** UserRecord: all user records */
export type EnterpriseUserAdminView_UserRecordEnterpriseContractsPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** UserRecord: all user records */
export type EnterpriseUserAdminView_UserRecordEnterpriseProgramsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** UserRecord: all user records */
export type EnterpriseUserAdminView_UserRecordNaptimeEnterpriseContractsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** UserRecord: all user records */
export type EnterpriseUserAdminView_UserRecordProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Queries related to enterprise permissions */
export type EnterpriseUserRolesQueries = {
  __typename?: 'EnterpriseUserRolesQueries';
  /**
   * This query returns the full list of admins (roles and invitations) for the given organization.
   * Pagination is not supported due to grouping by user, and will only be possible when we move the backend
   * to ElasticSearch - see https://coursera.slack.com/archives/C01RA55AV9A/p1682528065632649?thread_ts=1682357480.799269&cid=C01RA55AV9A.
   */
  queryAllAdmins: Array<EnterprisePermission_Admin>;
  /**
   * This query returns the granted roles (i.e. not pending invitations) for a given user in a given organization.
   * Could be useful for tracking purposes (e.g. pendo) and should not be used for permission checks.
   */
  queryGrantedRolesByUserOrganization: Array<EnterprisePermission_GrantedRole>;
};


/** Queries related to enterprise permissions */
export type EnterpriseUserRolesQueriesQueryAllAdminsArgs = {
  organizationId: Scalars['ID'];
  programIds?: Array<Scalars['ID']>;
  templateIds?: Array<Scalars['ID']>;
};


/** Queries related to enterprise permissions */
export type EnterpriseUserRolesQueriesQueryGrantedRolesByUserOrganizationArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** An enterprise user roster record that links programs and contracts together */
export type EnterpriseUserRoster = Node & {
  __typename?: 'EnterpriseUserRoster';
  /** The enterprise contract fetched from the contract service */
  contract: EnterpriseContract_EnterpriseContract;
  /** The id of the linked contract */
  contractId: Scalars['ID'];
  /** The timestamp the roster was created at */
  createdAt: Scalars['DateTime'];
  /** The timestamp the roster was deleted at if it has been deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Roster id. */
  id: Scalars['ID'];
  /** If the roster has been deleted */
  isDeleted: Scalars['Boolean'];
  /** The linked contract tag, resolved through Naptime via GraphQL Mesh */
  naptimeContractTag?: Maybe<EnterpriseContractTagsV1ByContractIds>;
  /** The linked third party organization, resolved through Naptime via GraphQL Mesh */
  naptimeThirdPartyOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  /** The enterprise program fetched from the program service */
  program: EnterpriseProgram;
  /** The id of the linked program */
  programId: Scalars['ID'];
  /**
   * The id of the linked third party organization
   * @deprecated Use naptimeThirdPartyOrganization instead
   */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Represents a paginated collection of EnterpriseUserRosters */
export type EnterpriseUserRosterConnection = {
  __typename?: 'EnterpriseUserRosterConnection';
  /** The paginated collection */
  edges: Array<EnterpriseUserRosterEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** Represents an EnterpriseUserRoster with its pagination cursor */
export type EnterpriseUserRosterEdge = {
  __typename?: 'EnterpriseUserRosterEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** The roster */
  node: EnterpriseUserRoster;
};

export type EnterpriseUserRostersV1 = {
  __typename?: 'EnterpriseUserRostersV1';
  contract?: Maybe<EnterpriseContractsV1>;
  contractId: Scalars['String'];
  contractTag?: Maybe<EnterpriseContractTagsV1>;
  createdAt: Scalars['Float'];
  deletedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isDeleted: Scalars['Boolean'];
  program?: Maybe<EnterpriseProgramsV1>;
  programId: Scalars['String'];
  programInvitations?: Maybe<ProgramInvitationsV1Connection>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type EnterpriseUserRostersV1ProgramArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseUserRostersV1ProgramInvitationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByContract = {
  __typename?: 'EnterpriseUserRostersV1ByContract';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  id: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByContractAndProgram = {
  __typename?: 'EnterpriseUserRostersV1ByContractAndProgram';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  contractId: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByContracts = {
  __typename?: 'EnterpriseUserRostersV1ByContracts';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  contractIds: Array<Maybe<Scalars['String']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByOrganization = {
  __typename?: 'EnterpriseUserRostersV1ByOrganization';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  id: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByProgram = {
  __typename?: 'EnterpriseUserRostersV1ByProgram';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  id: Scalars['String'];
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1ByProgramIds = {
  __typename?: 'EnterpriseUserRostersV1ByProgramIds';
  connection?: Maybe<EnterpriseUserRostersV1Connection>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type EnterpriseUserRostersV1Connection = {
  __typename?: 'EnterpriseUserRostersV1Connection';
  elements: Array<Maybe<EnterpriseUserRostersV1>>;
  paging: ResponsePagination;
};

export type EnterpriseUserRostersV1Resource = {
  __typename?: 'EnterpriseUserRostersV1Resource';
  byContract?: Maybe<EnterpriseUserRostersV1Connection>;
  byContractAndProgram?: Maybe<EnterpriseUserRostersV1Connection>;
  byContracts?: Maybe<EnterpriseUserRostersV1Connection>;
  byOrganization?: Maybe<EnterpriseUserRostersV1Connection>;
  byProgram?: Maybe<EnterpriseUserRostersV1Connection>;
  byProgramIds?: Maybe<EnterpriseUserRostersV1Connection>;
  get?: Maybe<EnterpriseUserRostersV1>;
  multiGet?: Maybe<EnterpriseUserRostersV1Connection>;
};


export type EnterpriseUserRostersV1ResourceByContractArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceByContractAndProgramArgs = {
  contractId: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceByContractsArgs = {
  contractIds: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceByOrganizationArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceByProgramArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceByProgramIdsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type EnterpriseUserRostersV1ResourceGetArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type EnterpriseUserRostersV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** The roster entity is the link between enterprise programs and enterprise contracts. */
export type EnterpriseUser_Roster = {
  __typename?: 'EnterpriseUser_Roster';
  /** The linked enterprise contract */
  contract: EnterpriseContract_EnterpriseContract;
  /** The timestamp the roster was created at */
  createdAt: Scalars['DateTime'];
  /** The timestamp the roster was deleted at if it has been deleted */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Roster id. */
  id: Scalars['ID'];
  /** The invitations for the roster */
  invitations: ProgramInvitations_InvitationsPaginatedResult;
  /** If the roster has been deleted */
  isDeleted: Scalars['Boolean'];
  /** The linked enterprise program */
  program: EnterpriseProgram_EnterpriseProgram;
  /** The linked third party organization */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
};


/** The roster entity is the link between enterprise programs and enterprise contracts. */
export type EnterpriseUser_RosterInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** EnterpriseUser Roster with pagination */
export type EnterpriseUser_RosterPaginatedResult = {
  __typename?: 'EnterpriseUser_RosterPaginatedResult';
  /** EnterpriseUser Roster */
  elements: Array<EnterpriseUser_Roster>;
  /** Pagination */
  pagination: Pagination;
};

/** EnterpriseUsers: all queries related to EnterpriseUsers. */
export type EnterpriseUsersQueries = {
  __typename?: 'EnterpriseUsersQueries';
  /** This query returns the enterprise user data by searching with org Id and one of email or user Id. */
  queryByOrganizationAndUser?: Maybe<EnterpriseUsers_UserData>;
};


/** EnterpriseUsers: all queries related to EnterpriseUsers. */
export type EnterpriseUsersQueriesQueryByOrganizationAndUserArgs = {
  emailOrUserId: EnterpriseUsers_EmailOrUserId;
  orgId: Scalars['ID'];
};

/** Input argument for updating by email or user Id. */
export type EnterpriseUsers_EmailOrUserId = {
  /** Email: email associated with the user */
  email?: InputMaybe<Scalars['String']>;
  /** UserId: user's userId */
  userId?: InputMaybe<Scalars['Int']>;
};

/** Input data model for enterprise learner profile standard fields. */
export type EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput = {
  /** Business Unit */
  businessUnit?: InputMaybe<Scalars['String']>;
  /** Business Unit 2 */
  businessUnit2?: InputMaybe<Scalars['String']>;
  /** Job Title */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** job Type */
  jobType?: InputMaybe<Scalars['String']>;
  /** Location City */
  locationCity?: InputMaybe<Scalars['String']>;
  /** Location Country */
  locationCountry?: InputMaybe<Scalars['String']>;
  /** Location Region */
  locationRegion?: InputMaybe<Scalars['String']>;
  /** Manager Email */
  managerEmail?: InputMaybe<Scalars['String']>;
  /** Manager Name */
  managerName?: InputMaybe<Scalars['String']>;
};

/** Input argument for updating all fields of user data. */
export type EnterpriseUsers_FullUpdateUserDataInput = {
  /** Update by email or userId */
  emailOrUserId: EnterpriseUsers_EmailOrUserId;
  /** External Id to be updated */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Full name to be updated */
  fullName: Scalars['String'];
  /** Update by organization Id */
  orgId: Scalars['ID'];
  /** Standard fields to be updated */
  standardFields: EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput;
};

/** Enterprise users data model result. */
export type EnterpriseUsers_FullUpdateUserDataResult = {
  __typename?: 'EnterpriseUsers_FullUpdateUserDataResult';
  /** users data model result */
  result?: Maybe<EnterpriseUsers_UserData>;
};

/** Input for resending the verification email for a user within an organization. */
export type EnterpriseUsers_ResendVerificationEmailInput = {
  /** Email address to verify; must be owned by the authenticated user */
  email: Scalars['String'];
  /** Org slug identifying the organization the user is acting within */
  orgSlug: Scalars['String'];
};

/** Result of resending the org-scoped verification email */
export type EnterpriseUsers_ResendVerificationEmailResult = EnterpriseUsers_ResendVerificationEmailResultFailure | EnterpriseUsers_ResendVerificationEmailResultSuccess;

/** EnterpriseUsers_ResendVerificationEmail mutation error. */
export const EnterpriseUsers_ResendVerificationEmailResultError = {
  /** The email is not owned by the user or is already verified */
  NotEligibleForVerification: 'NOT_ELIGIBLE_FOR_VERIFICATION'
} as const;

export type EnterpriseUsers_ResendVerificationEmailResultError = typeof EnterpriseUsers_ResendVerificationEmailResultError[keyof typeof EnterpriseUsers_ResendVerificationEmailResultError];
/** Returned on EnterpriseUsers_ResendVerificationEmail mutation failure. */
export type EnterpriseUsers_ResendVerificationEmailResultFailure = {
  __typename?: 'EnterpriseUsers_ResendVerificationEmailResultFailure';
  /** Reason the resend could not be completed */
  error: EnterpriseUsers_ResendVerificationEmailResultError;
};

/** Returned on EnterpriseUsers_ResendVerificationEmail mutation success. */
export type EnterpriseUsers_ResendVerificationEmailResultSuccess = {
  __typename?: 'EnterpriseUsers_ResendVerificationEmailResultSuccess';
  /** Dummy field required by GraphQL (unions must have at least one field) */
  _?: Maybe<Scalars['Boolean']>;
};

/** Enterprise users data modal. */
export type EnterpriseUsers_UserData = {
  __typename?: 'EnterpriseUsers_UserData';
  /** User email */
  email: Scalars['String'];
  /** User external Id, it is possible to be null */
  externalId?: Maybe<Scalars['ID']>;
  /** User full name */
  fullName: Scalars['String'];
  /** User Enterprise Learner Profile Standard Fields, it is possible to be null */
  standardFields?: Maybe<EnterpriseLearnerProfile_StandardFields>;
};

/**
 * A contract visible to the caller under an org, returned by
 * NativeAnalytics.getContractsByOrg.
 */
export type Enterprise_Contract = {
  __typename?: 'Enterprise_Contract';
  /**
   * The billing type of the contract. Mirrors the existing
   * EnterpriseContract_BillingType enum from the legacy contract schema.
   * Sourced from enterprise_contract_billing_type on the contracts dim
   * table (zero NULLs across 189K contracts).
   */
  billingType: Enterprise_ContractBillingType;
  /**
   * WES contract state. Only populated for SELF_SERVE contracts
   * (billing_system_type AUTOMATED_TRANSACTION_PAYMENT or AUTOMATED_INVOICE).
   * Null for STANDARD contracts. Sourced from enterprise_wes_contract_state
   * on the contracts dim table.
   */
  contractState?: Maybe<Enterprise_ContractState>;
  /**
   * Whether this is a SELF_SERVE (WES) or STANDARD contract. Sourced from
   * enterprise_contract_type on the contracts dim table (zero NULLs across
   * all contracts).
   */
  contractType: Enterprise_ContractType;
  /**
   * Actual contract endedAt time. This may be different
   * from the enterprise_contract_end_ts that was set initially on contract creation.
   */
  endedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Contract end time from the Enterprise Platform, in UTC. This is the end time
   * based on start time and duration of a contract. This time might be different from the
   * actual end time of a contract, in the case for example when clients are given
   * a grace period after contract ends.
   */
  endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Enterprise contract ID (stable identifier passed back to other
   * native-analytics queries that accept contractIds).
   */
  id: Scalars['ID'];
  /**
   * Whether the contract is currently active. False for terminated contracts.
   * Sourced from is_enterprise_contract_active on the contracts dim table,
   * which covers both STANDARD and SELF_SERVE contract types (zero NULLs
   * across 189K contracts).
   */
  isActive: Scalars['Boolean'];
  /**
   * Whether this is a real customer contract (true) or a test contract
   * (false). Consistent with the existing isReal field on the legacy
   * EnterpriseContract_EnterpriseContract type. Sourced from the is_real
   * column on the contracts dim table (zero NULLs across 189K contracts).
   */
  isReal: Scalars['Boolean'];
  /**
   * Whether the contract grants unlimited course access. False means the
   * contract caps course access to a fixed number of enrollments per user.
   */
  isUnlimited: Scalars['Boolean'];
  /** Human-readable contract name for display in dropdowns. */
  name: Scalars['String'];
  /**
   * The contract's product type — license, user, enrollment, or
   * license_enrollment. Sourced from enterprise_contract_product_type on the
   * contracts dim table (zero NULLs across all contracts).
   */
  productType: Enterprise_ContractProductType;
  /**
   * Contract start time from the Enterprise Platform, in UTC. Sourced from
   * enterprise_contract_start_ts on the contracts dim table.
   */
  startsAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Billing type for an enterprise contract. Matches the values in the
 * enterprise_contract_billing_type column on the contracts dim table and
 * aligns with the existing EnterpriseContract_BillingType enum from the
 * legacy enterprise contract schema.
 */
export const Enterprise_ContractBillingType = {
  /** Billed via invoice (off-platform or automated). */
  Invoice: 'INVOICE',
  /**
   * Non-billable — typically test contracts or contracts not integrated
   * with any billing system.
   */
  None: 'NONE',
  /** One-time payment contract. */
  OneTime: 'ONE_TIME',
  /** Quarterly recurring billing. */
  Quarterly: 'QUARTERLY'
} as const;

export type Enterprise_ContractBillingType = typeof Enterprise_ContractBillingType[keyof typeof Enterprise_ContractBillingType];
/**
 * Product type for an enterprise contract, describing what the contract
 * grants access to. Sourced from enterprise_contract_product_type on the
 * contracts dim table.
 */
export const Enterprise_ContractProductType = {
  /** Enrollment-based access, capped by a purchased enrollment count. */
  Enrollment: 'ENROLLMENT',
  /** Seat-based license access. */
  License: 'LICENSE',
  /** Combined license and enrollment access. */
  LicenseEnrollment: 'LICENSE_ENROLLMENT',
  /** Per-user access not tied to a license or enrollment cap. */
  User: 'USER'
} as const;

export type Enterprise_ContractProductType = typeof Enterprise_ContractProductType[keyof typeof Enterprise_ContractProductType];
/**
 * WES contract lifecycle state. Only applicable to SELF_SERVE contracts.
 * Sourced from enterprise_wes_contract_state on the contracts dim table.
 */
export const Enterprise_ContractState = {
  /** Contract is currently active and in use. */
  Active: 'ACTIVE',
  /** Contract has been created but not yet activated. */
  Created: 'CREATED',
  /** Contract has passed its end date. */
  Expired: 'EXPIRED',
  /** Contract is temporarily paused. */
  Paused: 'PAUSED',
  /** Contract has been terminated before its natural end date. */
  Terminated: 'TERMINATED',
  /** Contract state could not be determined. */
  Unknown: 'UNKNOWN'
} as const;

export type Enterprise_ContractState = typeof Enterprise_ContractState[keyof typeof Enterprise_ContractState];
/**
 * Contract type for an enterprise contract, distinguishing self-serve
 * (WES-managed) contracts from standard (sales-managed) contracts. Sourced
 * from enterprise_contract_type on the contracts dim table.
 */
export const Enterprise_ContractType = {
  /** Self-serve contract managed through WES (Web Enrollment System). */
  SelfServe: 'SELF_SERVE',
  /** Standard contract managed through the sales/Salesforce process. */
  Standard: 'STANDARD'
} as const;

export type Enterprise_ContractType = typeof Enterprise_ContractType[keyof typeof Enterprise_ContractType];
/**
 * A program visible to the caller under an org, returned by
 * NativeAnalytics.getProgramsByOrg.
 */
export type Enterprise_Program = {
  __typename?: 'Enterprise_Program';
  /**
   * Contract this program belongs to. Null for legacy programs that
   * pre-date the contracts model or internal test programs. Sourced
   * from enterprise_contract_id on eal.enterprise_foundation_programs.
   */
  contractId?: Maybe<Scalars['ID']>;
  /**
   * When the program ended/expires, as an ISO 8601 timestamp
   * (e.g. "2025-10-15T00:00:00Z"). Null if the program has no end
   * date (still active). Converted server-side from the ended_at
   * epoch millis column on eal.enterprise_foundation_programs.
   */
  endedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Enterprise program ID (stable identifier passed back to other
   * native-analytics queries that accept programIds).
   */
  id: Scalars['ID'];
  /** Human-readable program name for display in dropdowns. */
  name: Scalars['String'];
  /**
   * The program's slug - Sourced from
   * enterprise_program_slug on eal.enterprise_foundation_programs.
   */
  slug: Scalars['String'];
};

/**
 * A roster — the linking entity modeling the many-to-many relationship
 * between an enterprise program and an enterprise contract — visible to the
 * caller under an org, returned by NativeAnalytics.getRostersByOrg.
 */
export type Enterprise_Roster = {
  __typename?: 'Enterprise_Roster';
  /** Contract this roster links to. */
  contractId: Scalars['ID'];
  /**
   * Enterprise roster ID (stable identifier for this program + contract
   * pairing).
   */
  id: Scalars['ID'];
  /** Program this roster links to. */
  programId: Scalars['ID'];
};

/**
 * A skill visible to the caller under an org, returned by
 * NativeAnalytics.getSkillsByOrg.
 */
export type Enterprise_Skill = {
  __typename?: 'Enterprise_Skill';
  /**
   * Skill ID (stable identifier passed back to other native-analytics
   * queries that accept skillIds).
   */
  id: Scalars['ID'];
  /** Human-readable skill name for display in dropdowns. */
  name: Scalars['String'];
};

/** TODO: Complete this description */
export type EntitlementQueries = {
  __typename?: 'EntitlementQueries';
  /** This query gets a single product ownership */
  queryProductOwnership?: Maybe<Entitlement_ProductOwnership>;
  /** This query allows getting multiple ownerships | Maximum page size: 1000 */
  queryProductOwnershipsById: Entitlement_ProductOwnershipConnection;
  /** This query allows getting ownerships for a user | Maximum page size: 1000 */
  queryStoredProductOwnershipsByUser: Entitlement_ProductOwnershipConnection;
};


/** TODO: Complete this description */
export type EntitlementQueriesQueryProductOwnershipArgs = {
  productOwnershipId: Scalars['String'];
};


/** TODO: Complete this description */
export type EntitlementQueriesQueryProductOwnershipsByIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  productOwnershipIds: Array<Scalars['String']>;
};


/** TODO: Complete this description */
export type EntitlementQueriesQueryStoredProductOwnershipsByUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

/** TODO: Complete this description */
export type Entitlement_CourseOwnership = {
  __typename?: 'Entitlement_CourseOwnership';
  /** TODO: Complete this description */
  courseId: Scalars['String'];
  /** Whether the learner owns the course */
  owns: Scalars['Boolean'];
};

/** TODO: Complete this description */
export type Entitlement_ProductOwnership = {
  __typename?: 'Entitlement_ProductOwnership';
  /**
   * Represents whether a learner used to own a product. It is mainly important for
   *   determining whether a learner has earned a certificate based off their ownership history
   *   (current or past), progress in the content, verification status, and whether they have an
   *   active profile.
   */
  expiredOwns: Scalars['Boolean'];
  /** Represents when your current ownership period for the given product ends, if applicable. */
  expiresAt?: Maybe<Timestamp>;
  /** Represents the start of the first non-revoked (non-refunded) ownership period for a learner, either current or past. */
  firstOwnedAt?: Maybe<Timestamp>;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  lastUpdatedTime?: Maybe<Timestamp>;
  /**
   * Represents whether a learner currently owns a product. Examples of its usage include checkout
   *   to determine product action eligibility, upsells in learner logged in dashboard, and paid
   *   access in the in-course experience.
   */
  owns: Scalars['Boolean'];
  /**
   * NOTE: I have high certainty that pending_confirmation does not have usages after grepping
   *   the BE and client codebases. Further investigation / removal are out of scope of this
   *   project. I've included the comment from the original model so that future engineers can make
   *   a determination about whether it may be useful given future needs.
   * ORIGINAL COMMENT: If a buy/refund transaction has been initiated, but not completed, the
   *   ownership is in an uncertain state. Sometimes, client logic might want to take this into
   *   consideration, to decide on the validity of an action (e.g. if a refund has been initiated,
   *   but not confirmed, we may want to continue providing the user with the verification UI, but
   *   not issue a physical certificate)
   */
  pendingConfirmation: Scalars['Boolean'];
  /** TODO: Complete this description */
  s12nCourseOwnerships?: Maybe<Array<Entitlement_CourseOwnership>>;
};

/** TODO: Complete this description */
export type Entitlement_ProductOwnershipConnection = {
  __typename?: 'Entitlement_ProductOwnershipConnection';
  /** TODO: Complete this description */
  edges?: Maybe<Array<Maybe<Entitlement_ProductOwnershipEdge>>>;
  /** TODO: Complete this description */
  pageInfo: PageInfo;
};

/** TODO: Complete this description */
export type Entitlement_ProductOwnershipEdge = {
  __typename?: 'Entitlement_ProductOwnershipEdge';
  /** TODO: Complete this description */
  cursor?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  node?: Maybe<Entitlement_ProductOwnership>;
};

/** TODO: Complete this description */
export const Entitlement_ProductType = {
  /** TODO: Complete this description */
  CatalogSubscription: 'CATALOG_SUBSCRIPTION',
  /** TODO: Complete this description */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** TODO: Complete this description */
  CredentialTrack: 'CREDENTIAL_TRACK',
  /** TODO: Complete this description */
  CredentialTrackCourse: 'CREDENTIAL_TRACK_COURSE',
  /** TODO: Complete this description */
  CredentialTrackCourseV2: 'CREDENTIAL_TRACK_COURSE_V2',
  /** TODO: Complete this description */
  CredentialTrackSubscription: 'CREDENTIAL_TRACK_SUBSCRIPTION',
  /** TODO: Complete this description */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** TODO: Complete this description */
  EnterpriseContract: 'ENTERPRISE_CONTRACT',
  /** TODO: Complete this description */
  FacilitatedLearning: 'FACILITATED_LEARNING',
  /** TODO: Complete this description */
  ProductTypeInvalid: 'PRODUCT_TYPE_INVALID',
  /** TODO: Complete this description */
  Specialization: 'SPECIALIZATION',
  /** TODO: Complete this description */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** TODO: Complete this description */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type Entitlement_ProductType = typeof Entitlement_ProductType[keyof typeof Entitlement_ProductType];
/** Real-time targeting options */
export type Eoi_RealTimeTargetingOptionsInput = {
  /** The URL parameters to match against */
  matchingUrlParameters?: InputMaybe<Array<Eoi_UrlParameterInput>>;
  /** Total time user spent on the page */
  totalTimeOnPageInMiliseconds?: InputMaybe<Scalars['Int']>;
};

/** An object that represents a URL key and value */
export type Eoi_UrlParameterInput = {
  /** The URL parameter key */
  key: Scalars['String'];
  /** The URL parameter value */
  value: Scalars['String'];
};

/** Queries for namespace parameters for Epic_Experiments. */
export type EpicExperimentNamespaceConfigurationQueries = {
  __typename?: 'EpicExperimentNamespaceConfigurationQueries';
  /** Returns all Epic Experiment Namespace Parameters. | Maximum page size: 10000 */
  queryAll: Epic_ExperimentNamespaceConfigurationConnection;
};


/** Queries for namespace parameters for Epic_Experiments. */
export type EpicExperimentNamespaceConfigurationQueriesQueryAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
};

/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueries = {
  __typename?: 'EpicExperimentQueries';
  /** Returns an Experiment that has the provided id. */
  queryExperiment: Epic_Experiment;
  /** Returns all experiments | Maximum page size: 100 */
  queryExperiments: Epic_ExperimentConnection;
  /** Returns all experiments | Maximum page size: 100 */
  queryExperimentsBackwards: Epic_ExperimentConnection;
  /** Returns the latest Experiment that has the provided (non-versioned) id. */
  queryLatestExperiment: Epic_Experiment;
  /** Return all Experiments with matching search text. | Maximum page size: 100 */
  searchExperiments: Epic_ExperimentConnection;
  /** Return all Experiments with matching search text. | Maximum page size: 100 */
  searchExperimentsBackwards: Epic_ExperimentConnection;
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesQueryExperimentArgs = {
  id: Scalars['ID'];
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesQueryExperimentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  creatorEmailContains?: InputMaybe<Scalars['String']>;
  displayNameContains?: InputMaybe<Scalars['String']>;
  experimentTypeIn?: InputMaybe<Array<Epic_ExperimentType>>;
  first?: Scalars['Int'];
  owningTeamsContains?: InputMaybe<Scalars['String']>;
  sortColumn?: Epic_ExperimentSortColumn;
  sortDirection?: Epic_SortDirection;
  statusIn?: InputMaybe<Array<Epic_ExperimentStatus>>;
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesQueryExperimentsBackwardsArgs = {
  before: Scalars['String'];
  creatorEmailContains?: InputMaybe<Scalars['String']>;
  displayNameContains?: InputMaybe<Scalars['String']>;
  experimentTypeIn?: InputMaybe<Array<Epic_ExperimentType>>;
  last?: Scalars['Int'];
  owningTeamsContains?: InputMaybe<Scalars['String']>;
  sortColumn?: Epic_ExperimentSortColumn;
  sortDirection?: Epic_SortDirection;
  statusIn?: InputMaybe<Array<Epic_ExperimentStatus>>;
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesQueryLatestExperimentArgs = {
  id: Scalars['ID'];
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesSearchExperimentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  query: Scalars['String'];
  sortColumn?: Epic_ExperimentSortColumn;
  sortDirection?: Epic_SortDirection;
};


/** Query definitions for querying Epic Experiments. */
export type EpicExperimentQueriesSearchExperimentsBackwardsArgs = {
  before: Scalars['String'];
  last?: Scalars['Int'];
  query: Scalars['String'];
  sortColumn?: Epic_ExperimentSortColumn;
  sortDirection?: Epic_SortDirection;
};

/** Query definitions for querying Epic Platform Metrics. */
export type EpicPlatformMetricQueries = {
  __typename?: 'EpicPlatformMetricQueries';
  /** Returns Platform Status Metrics for creators | Maximum page size: 100 */
  queryCreatorStatusMetrics: Epic_PlatformStatusMetricConnection;
  /** Returns Platform Status Metrics for namespaces | Maximum page size: 100 */
  queryNamespaceStatusMetrics: Epic_PlatformStatusMetricConnection;
  /** Returns Platform Status Metrics for teams | Maximum page size: 100 */
  queryTeamStatusMetrics: Epic_PlatformStatusMetricConnection;
};


/** Query definitions for querying Epic Platform Metrics. */
export type EpicPlatformMetricQueriesQueryCreatorStatusMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  sortBy?: Epic_PlatformStatusMetricSortBy;
  sortDirection?: Epic_SortDirection;
};


/** Query definitions for querying Epic Platform Metrics. */
export type EpicPlatformMetricQueriesQueryNamespaceStatusMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  sortBy?: Epic_PlatformStatusMetricSortBy;
  sortDirection?: Epic_SortDirection;
};


/** Query definitions for querying Epic Platform Metrics. */
export type EpicPlatformMetricQueriesQueryTeamStatusMetricsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  sortBy?: Epic_PlatformStatusMetricSortBy;
  sortDirection?: Epic_SortDirection;
};

/** Determines how an experiment is allocated. */
export const Epic_AllocationType = {
  /** Experiment uses the visitor's email. This allocation type is used for logged out email tests. */
  ByEmail: 'BY_EMAIL',
  /** Experiment uses the visitor's web browser session cookie for allocation. This allocation type is the only way to run an experiment on logged-out visitors, but it also is unable to guarantee a consistent experience for a given user. */
  BySessionCookie: 'BY_SESSION_COOKIE',
  /** Experiment uses the URL at impression time for allocation. This allocation type is used for SEO tests. */
  ByUrl: 'BY_URL',
  /** Experiment uses the visitor's user id for allocation. This allocation type guarantees a consistent experience for a given user, but cannot be used to reach logged-out visitors. */
  ByUser: 'BY_USER',
  /** The allocation type could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_AllocationType = typeof Epic_AllocationType[keyof typeof Epic_AllocationType];
/** A group of changes made to the experiment */
export type Epic_ChangeGroup = {
  __typename?: 'Epic_ChangeGroup';
  /** The time when the change occurred */
  changedAt: Scalars['DateTime'];
  /** The changes made to the experiment represented as a JSON object */
  changesAsJson?: Maybe<Scalars['JSON']>;
};

/** Represents how a client should be targeted. */
export type Epic_ClientTargeting = {
  __typename?: 'Epic_ClientTargeting';
  /** The tags that should be targeted */
  byTag?: Maybe<Epic_TagTarget>;
};

/** Represents how a client should be targeted. */
export type Epic_ClientTargetingInput = {
  /** The tags that should be targeted */
  byTag?: InputMaybe<Epic_TagTargetInput>;
};

/** Represents how a country should be targeted for an experiment. */
export type Epic_CountryTarget = {
  __typename?: 'Epic_CountryTarget';
  /** This can contain both ISO 3166-1 country codes and ISO 3166-2 subdivision codes. */
  countryCodes: Array<Scalars['String']>;
  /** Target type of the target */
  targetType: Epic_ListTargetType;
};

/** Represents how a country should be targeted for an experiment. */
export type Epic_CountryTargetInput = {
  /** This can contain both ISO 3166-1 country codes and ISO 3166-2 subdivision codes. */
  countryCodes: Array<Scalars['String']>;
  /** Target type of the target */
  targetType: Epic_ListTargetType;
};

/** Input used to create an experiment. */
export type Epic_CreateExperimentInput = {
  /**
   * The email of the experiments creator
   * @deprecated FE should not dictate the creator of the experiment.
   */
  creatorEmail?: InputMaybe<Scalars['String']>;
  /** The new values of the experiment. */
  experiment: Epic_ExperimentInput;
};

/** The result of creating an Epic_Experiment. */
export type Epic_CreateExperimentResult = Epic_Experiment;

/** An EPIC experiment */
export type Epic_Experiment = Node & {
  __typename?: 'Epic_Experiment';
  /** The allocation type of the Experiment */
  allocationType: Epic_AllocationType;
  /** Date when cleanup was ended - only exists if code has been cleaned (Bool isCodeCleaned set by author in FE). */
  cleanupEndedAt?: Maybe<Timestamp>;
  /**
   * The clientTargeting object is sent to the front end to support client side targeting
   * (i.e., when the information for targeting is not directly sent to EPIC, but the client
   * is able to access it). For example: course_id, partner_id
   */
  clientTargeting?: Maybe<Epic_ClientTargeting>;
  /** The experiments conclusion */
  conclusion?: Maybe<Scalars['String']>;
  /**
   * Allows conversion events to continue happening after the experiment
   * has ended and limits them to be close to the show event.
   * Units are specified in days.
   * @deprecated This is a legacy field that is no longer used.
   */
  conversionWindow?: Maybe<Scalars['Int']>;
  /** When the experiment was created. */
  createdAt: Timestamp;
  /** The email of the experiments creator */
  creatorEmail: Scalars['String'];
  /** Default metric shown on Results page after experiment is complete */
  defaultMetricGroup: Epic_MetricGroup;
  /** The description of the experiment */
  description: Scalars['String'];
  /** The display name of the Experiment */
  displayName: Scalars['String'];
  /** When the experiment ended */
  endedAt?: Maybe<Timestamp>;
  /** The date the experiment is estimated to end */
  estimatedEndDate?: Maybe<Timestamp>;
  /** The type of the Experiment */
  experimentType: Epic_ExperimentType;
  /**
   * The hash seed used to determine user allocation to the experiment.
   * This defaults to the experimentId but can be manually overridden. Cannot be required since the experiment ID is not known to the reads function.
   */
  hashSeed?: Maybe<Scalars['String']>;
  /** The changes made to the experiment */
  history: Array<Epic_ChangeGroup>;
  /** If specified, indicates that the experiment should exclude users associated with this holdout */
  holdoutName?: Maybe<Scalars['String']>;
  /** The id of the Experiment */
  id: Scalars['ID'];
  /**
   * Indicates the experiment is actually meant to act as a long term configuration
   * instead of an experiment.
   */
  isLongTermConfiguration?: Maybe<Scalars['Boolean']>;
  /** The override variants of the experiment */
  overrideVariants: Array<Epic_OverrideVariant>;
  /**
   * Array of teams that own the experiment.
   * The head of the Array is the primary owner of the experiment
   */
  owningTeams: Array<Scalars['String']>;
  /** The id of the primary metric */
  primaryMetricId?: Maybe<Scalars['String']>;
  /** The significance threshold of the primary metric */
  primaryMetricSignificanceThreshold?: Maybe<Scalars['Float']>;
  /**
   * The reason the experiment has ended
   * @deprecated This is a legacy field that is no longer used.
   */
  reasonEnded?: Maybe<Epic_ExperimentEndReason>;
  /**
   * The reserved url key
   * @deprecated This is a legacy field that is no longer used.
   */
  reservedUrlKey?: Maybe<Scalars['String']>;
  /** The percentage of targets who will participate in the rollout of the experiment. */
  rolloutFraction: Scalars['Float'];
  /** The serverTargeting object is used for server side targeting (e.g. ip address, GeoIP targeting) */
  serverTargeting?: Maybe<Epic_ServerTargeting>;
  /** When the experiment started */
  startedAt?: Maybe<Timestamp>;
  /** The status of the experiment */
  status: Epic_ExperimentStatus;
  /** Coursera emails subscribed to the Experiment */
  subscriberEmails: Array<Scalars['String']>;
  /** If true, generate V3 Impression events based on V2 epic.experiment.show events */
  trackImpressions: Scalars['Boolean'];
  /** When the experiment was updated */
  updatedAt: Timestamp;
  /**
   * The userTargeting object is used to target specifically on user data, including
   * user demography, behavior that are available in EDW as well as realtime user eventing data.
   */
  userTargeting?: Maybe<Scalars['String']>;
  /** The variants of the experiment */
  variants: Array<Epic_Variant>;
};

/** Connection containing Epic Experiments and page metadata. */
export type Epic_ExperimentConnection = {
  __typename?: 'Epic_ExperimentConnection';
  /** The Epic Experiments in this connection. */
  edges: Array<Epic_ExperimentEdge>;
  /** The page metadata for this connection. */
  pageInfo: PageInfo;
  /** The total number of edges in the query. */
  totalEdges?: Maybe<Scalars['Int']>;
};

/** Edge for Epic Experiment. */
export type Epic_ExperimentEdge = {
  __typename?: 'Epic_ExperimentEdge';
  /** The cursor for the Epic Experiment contained in this edge. This is the index of the experiment. */
  cursor: Scalars['String'];
  /** The Epic Experiment contained in this edge. */
  node: Epic_Experiment;
};

/**
 * Represents the reason an experiment has ended.
 * This enum is deprecated and should not be used.
 */
export const Epic_ExperimentEndReason = {
  /** The experiment end reason could not be determined */
  Invalid: 'INVALID',
  /** Experiment was manually ended */
  Manual: 'MANUAL',
  /** Experiment ended because no clear winning variant could be found */
  NoClearWinner: 'NO_CLEAR_WINNER',
  /** Experiment ended because a winning variant was found */
  WinnerFound: 'WINNER_FOUND'
} as const;

export type Epic_ExperimentEndReason = typeof Epic_ExperimentEndReason[keyof typeof Epic_ExperimentEndReason];
/** Model shared by Epic_UpdateExperimentInput and Epic_CreateExperimentInput */
export type Epic_ExperimentInput = {
  /** The allocation type of the Experiment */
  allocationType: Epic_AllocationType;
  /** Date when cleanup was ended - only exists if code has been cleaned (Bool isCodeCleaned set by author in FE). */
  cleanupEndedAt?: InputMaybe<TimestampInput>;
  /**
   * The clientTargeting object is sent to the front end to support client side targeting
   * (i.e., when the information for targeting is not directly sent to EPIC, but the client
   * is able to access it). For example: course_id, partner_id
   */
  clientTargeting?: InputMaybe<Epic_ClientTargetingInput>;
  /** The experiments conclusion */
  conclusion?: InputMaybe<Scalars['String']>;
  /** Id of the default metric shown on Results page after experiment is complete */
  defaultMetricGroup: Scalars['String'];
  /** The description of the experiment */
  description: Scalars['String'];
  /** The display name of the Experiment */
  displayName: Scalars['String'];
  /** When the experiment ended */
  endedAt?: InputMaybe<TimestampInput>;
  /** The date the experiment is estimated to end */
  estimatedEndDate?: InputMaybe<TimestampInput>;
  /** The type of the Experiment */
  experimentType: Epic_ExperimentType;
  /**
   * The hash seed used to determine user allocation to the experiment.
   * This defaults to the experimentId but can be manually overridden. Cannot be required since the experiment ID is not known to the reads function.
   */
  hashSeed?: InputMaybe<Scalars['String']>;
  /** If specified, indicates that the experiment should exclude users associated with this holdout */
  holdoutName?: InputMaybe<Scalars['String']>;
  /**
   * Indicates the experiment is actually meant to act as a long term configuration
   * instead of an experiment.
   */
  isLongTermConfiguration?: InputMaybe<Scalars['Boolean']>;
  /** The override variants of the experiment */
  overrideVariants: Array<Epic_OverrideVariantInput>;
  /**
   * Array of teams that own the experiment.
   * The head of the Array is the primary owner of the experiment
   */
  owningTeams: Array<Scalars['String']>;
  /** The id of the primary metric */
  primaryMetricId?: InputMaybe<Scalars['String']>;
  /** The significance threshold of the primary metric */
  primaryMetricSignificanceThreshold?: InputMaybe<Scalars['Float']>;
  /**
   * The reason the experiment has ended
   * @deprecated This is a legacy field that is no longer used.
   */
  reasonEnded?: InputMaybe<Epic_ExperimentEndReason>;
  /** The percentage of targets who will participate in the rollout of the experiment. */
  rolloutFraction: Scalars['Float'];
  /** The serverTargeting object is used for server side targeting (e.g. ip address, GeoIP targeting) */
  serverTargeting?: InputMaybe<Epic_ServerTargetingInput>;
  /** When the experiment started */
  startedAt?: InputMaybe<TimestampInput>;
  /** The status of the experiment */
  status: Epic_ExperimentStatus;
  /** Coursera emails subscribed to the Experiment */
  subscriberEmails: Array<Scalars['String']>;
  /** If true, generate V3 Impression events based on V2 epic.experiment.show events */
  trackImpressions: Scalars['Boolean'];
  /**
   * The userTargeting object is used to target specifically on user data, including
   * user demography, behavior that are available in EDW as well as realtime user eventing data.
   */
  userTargeting?: InputMaybe<Scalars['String']>;
  /** The variants of the experiment */
  variants: Array<Epic_VariantInput>;
};

/** Connection containing Epic Experiment Namespace Parameters and page metadata. */
export type Epic_ExperimentNamespaceConfigurationConnection = {
  __typename?: 'Epic_ExperimentNamespaceConfigurationConnection';
  /** The Epic Experiment Namespace Configuration in this connection. */
  edges: Array<Epic_ExperimentNamespaceConfigurationEdge>;
  /** The page metadata for this connection. */
  pageInfo: PageInfo;
};

/** Edge for Experiment Namespace Configuration */
export type Epic_ExperimentNamespaceConfigurationEdge = {
  __typename?: 'Epic_ExperimentNamespaceConfigurationEdge';
  /** The cursor for the Epic Experiment Namespace Parameters contained in this edge. This is the index of the Epic Experiment Namespace Parameters. */
  cursor: Scalars['String'];
  /** The Epic Experiment Namespace Parameters contained in this edge. */
  node: Epic_ExperimentNamespaceParameters;
};

/** Object containing a namespace used by Experiment Variants as well as the parameters used in the namespace. */
export type Epic_ExperimentNamespaceParameters = Node & {
  __typename?: 'Epic_ExperimentNamespaceParameters';
  /** The id of the Experiment Namespace Parameters. This is also the namespace. */
  id: Scalars['ID'];
  /** The namespace of an experiment variant. */
  namespace: Scalars['String'];
  /** The parameters used in the namespace. */
  parameters?: Maybe<Array<Scalars['String']>>;
};

/** The column to sort on. */
export const Epic_ExperimentSortColumn = {
  /** Sort the cleanupEndedAt field of Epic_Experiment. */
  CleanupEndedAt: 'CLEANUP_ENDED_AT',
  /** Sort the createdAt field of Epic_Experiment. */
  CreatedAt: 'CREATED_AT',
  /** Sort on the creator field of Epic_Experiment */
  Creator: 'CREATOR',
  /** Sort on the displayName field of Epic_Experiment */
  DisplayName: 'DISPLAY_NAME',
  /** Sort the createdAt field of Epic_Experiment. */
  EndedAt: 'ENDED_AT',
  /** Sort the estimatedEndDate field of Epic_Experiment. */
  EstimatedEndDate: 'ESTIMATED_END_DATE',
  /** Sort on the owningTeams field of Epic_Experiment */
  OwningTeams: 'OWNING_TEAMS',
  /** Sort on the rolloutFraction field of Epic_Experiment */
  RolloutFraction: 'ROLLOUT_FRACTION',
  /** Sort the startedAt field of Epic_Experiment. */
  StartedAt: 'STARTED_AT',
  /** Sort on the status field of Epic_Experiment */
  Status: 'STATUS',
  /** Sort on the type field of Epic_Experiment */
  Type: 'TYPE'
} as const;

export type Epic_ExperimentSortColumn = typeof Epic_ExperimentSortColumn[keyof typeof Epic_ExperimentSortColumn];
/** Represents the status of an experiment. */
export const Epic_ExperimentStatus = {
  /** An ended experiment. The description field can be changed. No parameters will be served. */
  Ended: 'ENDED',
  /** The status could not be determined */
  Invalid: 'INVALID',
  /** A new experiment. All fields are open for editing. */
  New: 'NEW',
  /**
   * This means that the experiment has effectively ended but epic still needs to provide the
   * override parameters for the winning variant.
   */
  OnlyWinnerRunning: 'ONLY_WINNER_RUNNING',
  /** A running experiment. The description and rollout fraction fields can be changed. THe value field can also be changed if this is a ROLLOUT. The experiment is serving traffic in production. Variants will be served according to the rollout fraction. */
  Running: 'RUNNING',
  /** A testing experiment. All fields are open for editing. The rollout fraction is set to 0 and the default variant is served. */
  Testing: 'TESTING'
} as const;

export type Epic_ExperimentStatus = typeof Epic_ExperimentStatus[keyof typeof Epic_ExperimentStatus];
/** How an experiment is distributed */
export const Epic_ExperimentType = {
  /** Experiment is designed to support regular AB tests. At least two variants must be defined. When the experiment is running, variants cannot be changed. */
  Ab: 'AB',
  /** The experiment type could not be determined */
  Invalid: 'INVALID',
  /** Experiment is designed to support new feature rollout or configuration changes without deployment. Exactly one variant must be defined. When the experiment is running, the value of the variant can be changed. */
  Rollout: 'ROLLOUT'
} as const;

export type Epic_ExperimentType = typeof Epic_ExperimentType[keyof typeof Epic_ExperimentType];
/** Represents how headers should be aggregated for targeting. */
export const Epic_HeaderAggregationType = {
  /** Indicates all headers must match to be considered a valid target */
  All: 'ALL',
  /** Indicates any header can match to be considered a valid target */
  Any: 'ANY',
  /** Header aggregation type could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_HeaderAggregationType = typeof Epic_HeaderAggregationType[keyof typeof Epic_HeaderAggregationType];
/** Represents a single rule for matching the value of the specified header. */
export type Epic_HeaderRule = {
  __typename?: 'Epic_HeaderRule';
  /** The header to examine. */
  header: Scalars['String'];
  /** Whether to match the value exactly or to simply check that the given value is contained in the header. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents a single rule for matching the value of the specified header. */
export type Epic_HeaderRuleInput = {
  /** The header to examine. */
  header: Scalars['String'];
  /** Whether to match the value exactly or to simply check that the given value is contained in the header. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents the targeting rules for the experiment based on headers. */
export type Epic_HeaderTarget = {
  __typename?: 'Epic_HeaderTarget';
  /** Whether to count any rule match or all rule matches as satisfying the targeting rules as a whole. */
  aggregationType: Epic_HeaderAggregationType;
  /** One or more rules to match. */
  headerRules: Array<Epic_HeaderRule>;
  /** Whether to treat satisfying the targeting rules as a whitelist (include in experiment) or a blacklist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Represents the targeting rules for the experiment based on headers. */
export type Epic_HeaderTargetInput = {
  /** Whether to count any rule match or all rule matches as satisfying the targeting rules as a whole. */
  aggregationType: Epic_HeaderAggregationType;
  /** One or more rules to match. */
  headerRules: Array<Epic_HeaderRuleInput>;
  /** Whether to treat satisfying the targeting rules as a whitelist (include in experiment) or a blacklist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Represents the valid target types. */
export const Epic_ListTargetType = {
  /** Indicates the target should be excluded */
  Blacklist: 'BLACKLIST',
  /** list target type could not be determined */
  Invalid: 'INVALID',
  /** Indicates the target should be included */
  Whitelist: 'WHITELIST'
} as const;

export type Epic_ListTargetType = typeof Epic_ListTargetType[keyof typeof Epic_ListTargetType];
/**
 * Represents an ordered list of metrics that should be rendered together as a dashboard. The
 * intended format is what is visible in the various tabs on the experiment results page:
 *  - An assortment of static info/warning notes at the top
 *  - A list of dimension drilldowns
 *  - Various metrics controlled by those drilldowns
 */
export type Epic_MetricGroup = {
  __typename?: 'Epic_MetricGroup';
  /** The id of the Metric Group */
  id: Scalars['ID'];
};

/** Used to indicate which id should be included/excluded from a variant. */
export type Epic_OverrideVariant = {
  __typename?: 'Epic_OverrideVariant';
  /** The id used for allocation, usually is a userId or a sessionId. */
  id: Scalars['String'];
  /** A comment about this override variant */
  note: Scalars['String'];
  /**
   * Variant name should match one of the variants of the experiment. A missing
   * variantName indicates that the id should be excluded (opted out) from the experiment
   * entirely.
   */
  variantName?: Maybe<Scalars['String']>;
};

/** Used to indicate which id should be included/excluded from a variant. */
export type Epic_OverrideVariantInput = {
  /** The id used for allocation, usually is a userId or a sessionId. */
  id: Scalars['String'];
  /** A comment about this override variant */
  note: Scalars['String'];
  /**
   * Variant name should match one of the variants of the experiment. A missing
   * variantName indicates that the id should be excluded (opted out) from the experiment
   * entirely.
   */
  variantName?: InputMaybe<Scalars['String']>;
};

/** A parameter defined by a user. */
export type Epic_ParameterInfo = {
  __typename?: 'Epic_ParameterInfo';
  /** The parameter namespace */
  namespace: Scalars['String'];
  /** The parameter */
  parameter: Scalars['String'];
  /** The value of the variant, This can be any JSON object. */
  value?: Maybe<Scalars['JSON']>;
};

/** A parameter defined by a user. */
export type Epic_ParameterInfoInput = {
  /** The parameter namespace */
  namespace: Scalars['String'];
  /** The parameter */
  parameter: Scalars['String'];
  /** The value of the variant, This can be any JSON object. */
  value?: InputMaybe<Scalars['JSON']>;
};

/** An EPIC Platform Status Metric */
export type Epic_PlatformStatusMetric = Node & {
  __typename?: 'Epic_PlatformStatusMetric';
  /** The number of experiments in the "NEW" status */
  countOfNewExperiments: Scalars['Int'];
  /** The number of experiments that are in the "RUNNING" status */
  countOfRunningExperiments: Scalars['Int'];
  /** The number of experiments that are in the "TESTING" status */
  countOfTestingExperiments: Scalars['Int'];
  /** The id of the metric being represented */
  id: Scalars['ID'];
};

/** Connection containing Epic Platform Status Metrics and page metadata. */
export type Epic_PlatformStatusMetricConnection = {
  __typename?: 'Epic_PlatformStatusMetricConnection';
  /** The Epic Platform Status Metrics in this connection. */
  edges: Array<Epic_PlatformStatusMetricEdge>;
  /** The page metadata for this connection. */
  pageInfo: PageInfo;
  /** The total number of edges in the query. */
  totalEdges?: Maybe<Scalars['Int']>;
};

/** Edge for Epic Platform StatusMetrics. */
export type Epic_PlatformStatusMetricEdge = {
  __typename?: 'Epic_PlatformStatusMetricEdge';
  /** The cursor for the Epic Experiment contained in this edge. This is the index of the experiment. */
  cursor: Scalars['String'];
  /** The Epic Platform Status Metric contained in this edge. */
  node: Epic_PlatformStatusMetric;
};

/** The attribute to sort on. */
export const Epic_PlatformStatusMetricSortBy = {
  /** Sort on the number of NEW experiments */
  CountOfNewExperiments: 'COUNT_OF_NEW_EXPERIMENTS',
  /** Sort on the number of RUNNING experiments */
  CountOfRunningExperiments: 'COUNT_OF_RUNNING_EXPERIMENTS',
  /** Sort on the number of TESTING experiments */
  CountOfTestingExperiments: 'COUNT_OF_TESTING_EXPERIMENTS',
  /** Sort on the total sum of NEW, TESTING, and RUNNING experiments. */
  CountOfUnEndedExperiments: 'COUNT_OF_UN_ENDED_EXPERIMENTS'
} as const;

export type Epic_PlatformStatusMetricSortBy = typeof Epic_PlatformStatusMetricSortBy[keyof typeof Epic_PlatformStatusMetricSortBy];
/** Represents how a predicate should be matched. */
export const Epic_PredicateType = {
  /** Indicates predicate should contain target. */
  Contains: 'CONTAINS',
  /** Inndicates predicate should end with target */
  EndsWith: 'ENDS_WITH',
  /** Indicates predicate should exactly match target */
  Exactly: 'EXACTLY',
  /** Predicate type could not be determined */
  Invalid: 'INVALID',
  /** Indicates predicate should start with target */
  StartsWith: 'STARTS_WITH'
} as const;

export type Epic_PredicateType = typeof Epic_PredicateType[keyof typeof Epic_PredicateType];
/** Represents how an experiment is targeted on the server. */
export type Epic_ServerTargeting = {
  __typename?: 'Epic_ServerTargeting';
  /**
   * Rules for countries that should be included/excluded when targeting. Countries codes take the form of:
   * - ISO 3166-1 alpha-2 code for targeting countries
   * - ISO 3166-2 code for targeting subdivisions of countries
   */
  byCountry?: Maybe<Epic_CountryTarget>;
  /** Rules for headers that should be included/excluded when targeting. */
  byHeader?: Maybe<Epic_HeaderTarget>;
  /** Rules for user agents that should be included/excluded when targeting. */
  byUserAgent?: Maybe<Epic_UserAgentTarget>;
  /** Flag to exclude Course admins from targeting. */
  excludeCourseAdminsOption?: Maybe<Scalars['Boolean']>;
  /** Flag to exclude degree learners from targeting. */
  excludeDegreeLearnersOption?: Maybe<Scalars['Boolean']>;
  /** Flag to exclude enterprise learners from targeting */
  excludeEnterpriseLearnersOption?: Maybe<Scalars['Boolean']>;
};

/** Represents how an experiment is targeted on the server. */
export type Epic_ServerTargetingInput = {
  /**
   * Rules for countries that should be included/excluded when targeting. This must be one of the following:
   * - ISO 3166-1 alpha-2 code for targeting countries
   * - ISO 3166-2 code for targeting subdivisions of countries
   */
  byCountry?: InputMaybe<Epic_CountryTargetInput>;
  /** Rules for headers that should be included/excluded when targeting. */
  byHeader?: InputMaybe<Epic_HeaderTargetInput>;
  /** Rules for user agents that should be included/excluded when targeting. */
  byUserAgent?: InputMaybe<Epic_UserAgentTargetInput>;
  /** Flag to exclude Course admins from targeting. */
  excludeCourseAdminsOption?: InputMaybe<Scalars['Boolean']>;
  /** Flag to exclude degree learners from targeting. */
  excludeDegreeLearnersOption?: InputMaybe<Scalars['Boolean']>;
  /** Flag to exclude enterprise learners from targeting */
  excludeEnterpriseLearnersOption?: InputMaybe<Scalars['Boolean']>;
};

/** The direction in which to sort the sort column of a query. */
export const Epic_SortDirection = {
  /** Sort the column in ascending order (oldest to newest). */
  Ascending: 'ASCENDING',
  /** Sort the column in descending order (newest to oldest). */
  Descending: 'DESCENDING'
} as const;

export type Epic_SortDirection = typeof Epic_SortDirection[keyof typeof Epic_SortDirection];
/** Represents a tag target. */
export type Epic_TagTarget = {
  __typename?: 'Epic_TagTarget';
  /** The name of the tag */
  tagName: Scalars['String'];
  /** A list of tag values to target */
  tagValues: Array<Scalars['String']>;
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Represents a tag target. */
export type Epic_TagTargetInput = {
  /** The name of the tag */
  tagName: Scalars['String'];
  /** A list of tag values to target */
  tagValues: Array<Scalars['String']>;
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
};

/** Input used to update an Experiment. */
export type Epic_UpdateExperimentInput = {
  /** The new values of the experiment. */
  experiment: Epic_ExperimentInput;
  /** The versioned id of the experiment to update. */
  id: Scalars['ID'];
};

/** The result of updating an of an Epic_Experiment. */
export type Epic_UpdateExperimentResult = Epic_Experiment;

/** Represents a single rule for matching the value of the UserAgent. */
export type Epic_UserAgentRule = {
  __typename?: 'Epic_UserAgentRule';
  /** Whether to match the value exactly or to simply check that the given value is contained in the value. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents a single rule for matching the value of the UserAgent. */
export type Epic_UserAgentRuleInput = {
  /** Whether to match the value exactly or to simply check that the given value is contained in the value. */
  predicate: Epic_PredicateType;
  /** The value to match. */
  value: Scalars['String'];
};

/** Represents the targeting rules for the experiment based on UserAgent. */
export type Epic_UserAgentTarget = {
  __typename?: 'Epic_UserAgentTarget';
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
  /** One or more rules to match. */
  userAgentRules: Array<Epic_UserAgentRule>;
};

/** Represents the targeting rules for the experiment based on UserAgent. */
export type Epic_UserAgentTargetInput = {
  /** Whether to treat satisfying the targeting rules as an allowlist (include in experiment) or a denylist (exclude from experiment). */
  targetType: Epic_ListTargetType;
  /** One or more rules to match. */
  userAgentRules: Array<Epic_UserAgentRuleInput>;
};

/** An experiment variant. */
export type Epic_Variant = {
  __typename?: 'Epic_Variant';
  /** The id of the variant */
  id: Scalars['ID'];
  /**
   * Flag indicating if the variant won the experiment.
   * @deprecated This is a legacy field which is no longer used.
   */
  isWinner?: Maybe<Scalars['Boolean']>;
  /** The name of the variant */
  name: Scalars['String'];
  /** The variants parameters */
  parameters: Array<Epic_ParameterInfo>;
  /** The status of the variant */
  status: Epic_VariantStatus;
  /** The weight of the variant. All variant weights must sum to 1. */
  weight: Scalars['Float'];
};

/** The experiment variant input. */
export type Epic_VariantInput = {
  /** The id of the variant. If id is null, it is assumed that this is a new variant. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the variant. */
  name: Scalars['String'];
  /** The variants parameters. */
  parameters: Array<Epic_ParameterInfoInput>;
  /** The status of the variant */
  status: Epic_VariantStatus;
  /** The weight of the variant. All variant weights must sum to 1. */
  weight: Scalars['Float'];
};

/** The status of a variant. */
export const Epic_VariantStatus = {
  /** The variant is active */
  Active: 'ACTIVE',
  /** The variant is not active */
  Inactive: 'INACTIVE',
  /** The variant status could not be determined */
  Invalid: 'INVALID'
} as const;

export type Epic_VariantStatus = typeof Epic_VariantStatus[keyof typeof Epic_VariantStatus];
/** Error interface to be used across subgraphs/services. */
export type Error = {
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

export const ErrorDetail = {
  /**
   * The deadline expired before the operation could complete.
   * For operations that change the state of the system, this error
   * may be returned even if the operation has completed successfully.
   * For example, a successful response from a server could have been
   * delayed long enough for the deadline to expire.
   * HTTP Mapping: 504 Gateway Timeout
   * Error Type: UNAVAILABLE
   */
  DeadlineExceeded: 'DEADLINE_EXCEEDED',
  /**
   * The server detected that the client is exhibiting a behavior that
   * might be generating excessive load.
   * HTTP Mapping: 429 Too Many Requests or 420 Enhance Your Calm
   * Error Type: UNAVAILABLE
   */
  EnhanceYourCalm: 'ENHANCE_YOUR_CALM',
  /**
   * The requested field is not found in the schema.
   * This differs from `NOT_FOUND` in that `NOT_FOUND` should be used when a
   * query is valid, but is unable to return a result (if, for example, a
   * specific video id doesn't exist). `FIELD_NOT_FOUND` is intended to be
   * returned by the server to signify that the requested field is not known to exist.
   * This may be returned in lieu of failing the entire query.
   * See also `PERMISSION_DENIED` for cases where the
   * requested field is invalid only for the given user or class of users.
   * HTTP Mapping: 404 Not Found
   * Error Type: BAD_REQUEST
   */
  FieldNotFound: 'FIELD_NOT_FOUND',
  /**
   * The client specified an invalid argument.
   *
   * Note that this differs from `FAILED_PRECONDITION`.
   * `INVALID_ARGUMENT` indicates arguments that are problematic
   * regardless of the state of the system (e.g., a malformed file name).
   *
   * HTTP Mapping: 400 Bad Request
   * Error Type: BAD_REQUEST
   */
  InvalidArgument: 'INVALID_ARGUMENT',
  /**
   * The provided cursor is not valid.
   *
   * The most common usage for this error is when a client is paginating
   * through a list that uses stateful cursors. In that case, the provided
   * cursor may be expired.
   *
   * HTTP Mapping: 404 Not Found
   * Error Type: NOT_FOUND
   */
  InvalidCursor: 'INVALID_CURSOR',
  /**
   * Unable to perform operation because a required resource is missing.
   *
   * Example: Client is attempting to refresh a list, but the specified
   * list is expired. This requires an action by the client to get a new list.
   *
   * If the user is simply trying GET a resource that is not found,
   * use the NOT_FOUND error type. FAILED_PRECONDITION.MISSING_RESOURCE
   * is to be used particularly when the user is performing an operation
   * that requires a particular resource to exist.
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   * Error Type: FAILED_PRECONDITION
   */
  MissingResource: 'MISSING_RESOURCE',
  /**
   * Service Error.
   *
   * There is a problem with an upstream service.
   *
   * This may be returned if a gateway receives an unknown error from a service
   * or if a service is unreachable.
   * If a request times out which waiting on a response from a service,
   * `DEADLINE_EXCEEDED` may be returned instead.
   * If a service returns a more specific error Type, the specific error Type may
   * be returned instead.
   * HTTP Mapping: 502 Bad Gateway
   * Error Type: UNAVAILABLE
   */
  ServiceError: 'SERVICE_ERROR',
  /**
   * Request failed due to network errors.
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  TcpFailure: 'TCP_FAILURE',
  /**
   * Request throttled based on server concurrency limits.
   * HTTP Mapping: 503 Unavailable
   * Error Type: UNAVAILABLE
   */
  ThrottledConcurrency: 'THROTTLED_CONCURRENCY',
  /**
   * Request throttled based on server CPU limits
   * HTTP Mapping: 503 Unavailable.
   * Error Type: UNAVAILABLE
   */
  ThrottledCpu: 'THROTTLED_CPU',
  /**
   * The operation is not implemented or is not currently supported/enabled.
   * HTTP Mapping: 501 Not Implemented
   * Error Type: BAD_REQUEST
   */
  Unimplemented: 'UNIMPLEMENTED',
  /**
   * Unknown error.
   *
   * This error should only be returned when no other error detail applies.
   * If a client sees an unknown errorDetail, it will be interpreted as UNKNOWN.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Unknown: 'UNKNOWN'
} as const;

export type ErrorDetail = typeof ErrorDetail[keyof typeof ErrorDetail];
/** Deprecated in favour of the `Error` interface */
export type ErrorDetails = {
  /**
   * Error code that can be used by our tooling for error metrics.
   * When developer defines a new custom error using the ErrorDetails interface,
   * they should use the name of the custom error as the errorCode.
   */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

export const ErrorType = {
  /**
   * Bad Request.
   *
   * There is a problem with the request.
   * Retrying the same request is not likely to succeed.
   * An example would be a query or argument that cannot be deserialized.
   *
   * HTTP Mapping: 400 Bad Request
   */
  BadRequest: 'BAD_REQUEST',
  /**
   * The operation was rejected because the system is not in a state
   * required for the operation's execution.  For example, the directory
   * to be deleted is non-empty, an rmdir operation is applied to
   * a non-directory, etc.
   *
   * Service implementers can use the following guidelines to decide
   * between `FAILED_PRECONDITION` and `UNAVAILABLE`:
   *
   * - Use `UNAVAILABLE` if the client can retry just the failing call.
   * - Use `FAILED_PRECONDITION` if the client should not retry until
   * the system state has been explicitly fixed.  E.g., if an "rmdir"
   *      fails because the directory is non-empty, `FAILED_PRECONDITION`
   * should be returned since the client should not retry unless
   * the files are deleted from the directory.
   * HTTP Mapping: 400 Bad Request or 500 Internal Server Error
   */
  FailedPrecondition: 'FAILED_PRECONDITION',
  /**
   * Internal error.
   *
   * An unexpected internal error was encountered. This means that some
   * invariants expected by the underlying system have been broken.
   * This error code is reserved for serious errors.
   *
   * HTTP Mapping: 500 Internal Server Error
   */
  Internal: 'INTERNAL',
  /**
   * The requested entity was not found.
   *
   * This could apply to a resource that has never existed (e.g. bad resource id),
   * or a resource that no longer exists (e.g. cache expired.)
   *
   * Note to server developers: if a request is denied for an entire class
   * of users, such as gradual feature rollout or undocumented allowlist,
   * `NOT_FOUND` may be used. If a request is denied for some users within
   * a class of users, such as user-based access control, `PERMISSION_DENIED`
   * must be used.
   * HTTP Mapping: 404 Not Found
   */
  NotFound: 'NOT_FOUND',
  /**
   * The caller does not have permission to execute the specified
   * operation.
   * `PERMISSION_DENIED` must not be used for rejections
   * caused by exhausting some resource or quota.
   * `PERMISSION_DENIED` must not be used if the caller
   * cannot be identified (use `UNAUTHENTICATED`
   * instead for those errors).
   *
   * This error Type does not imply the
   * request is valid or the requested entity exists or satisfies
   * other pre-conditions.
   *
   * HTTP Mapping: 403 Forbidden
   */
  PermissionDenied: 'PERMISSION_DENIED',
  /**
   * The request does not have valid authentication credentials.
   *
   * This is intended to be returned only for routes that require
   * authentication.
   *
   * HTTP Mapping: 401 Unauthorized
   */
  Unauthenticated: 'UNAUTHENTICATED',
  /**
   * Currently Unavailable.
   *
   * The service is currently unavailable.  This is most likely a
   * transient condition, which can be corrected by retrying with
   * a backoff.
   *
   * HTTP Mapping: 503 Unavailable
   */
  Unavailable: 'UNAVAILABLE',
  /**
   * Unknown error.
   * For example, this error may be returned when
   * an error code received from another address space belongs to
   * an error space that is not known in this address space.  Also
   * errors raised by APIs that do not return enough error information
   * may be converted to this error.
   *
   * If a client sees an unknown errorType, it will be interpreted as UNKNOWN.
   * Unknown errors MUST NOT trigger any special behavior. These MAY be treated
   * by an implementation as being equivalent to INTERNAL.
   *
   * When possible, a more specific error should be provided.
   *
   * HTTP Mapping: 520 Unknown Error
   */
  Unknown: 'UNKNOWN'
} as const;

export type ErrorType = typeof ErrorType[keyof typeof ErrorType];
/** TODO: Complete this description */
export const EvidenceType = {
  /** TODO: Complete this description */
  OutsourcingAgentRubricResponse: 'OUTSOURCING_AGENT_RUBRIC_RESPONSE',
  /** TODO: Complete this description */
  PreviousUserSubmission: 'PREVIOUS_USER_SUBMISSION',
  /** TODO: Complete this description */
  SubmissionFlaggedBySimilarityCheckSystem: 'SUBMISSION_FLAGGED_BY_SIMILARITY_CHECK_SYSTEM',
  /** TODO: Complete this description */
  SubmissionFlaggedByUser: 'SUBMISSION_FLAGGED_BY_USER',
  /** TODO: Complete this description */
  SubmissionRuledByStaff: 'SUBMISSION_RULED_BY_STAFF',
  /** TODO: Complete this description */
  SubmissionSimilarToOtherSubmission: 'SUBMISSION_SIMILAR_TO_OTHER_SUBMISSION',
  /** TODO: Complete this description */
  TestDetails: 'TEST_DETAILS',
  /** TODO: Complete this description */
  UserViewedOtherSubmission: 'USER_VIEWED_OTHER_SUBMISSION'
} as const;

export type EvidenceType = typeof EvidenceType[keyof typeof EvidenceType];
/** Assessment types */
export const ExamMonitor_AssessmentType = {
  /** Assignment item type */
  Assignment: 'ASSIGNMENT'
} as const;

export type ExamMonitor_AssessmentType = typeof ExamMonitor_AssessmentType[keyof typeof ExamMonitor_AssessmentType];
/** Queries related to Exam Recording. */
export type ExamRecordingQueries = {
  __typename?: 'ExamRecordingQueries';
  /** Query to get a recording by id. */
  queryRecording: ExamRecording_Recording;
};


/** Queries related to Exam Recording. */
export type ExamRecordingQueriesQueryRecordingArgs = {
  recordingId: Scalars['ID'];
};

/** Input to end a recording. */
export type ExamRecording_EndRecordingInput = {
  /** ID of the recording that should be ended. */
  recordingId: Scalars['ID'];
};

/** The result of the end recording mutation. */
export type ExamRecording_EndRecordingResult = {
  __typename?: 'ExamRecording_EndRecordingResult';
  /** Recording that was ended. */
  recording: ExamRecording_Recording;
};

/** Input to initialize a chunk and generate an upload URL. */
export type ExamRecording_InitializeChunkInput = {
  /** The chunk index starting from 0. */
  chunkIndex: Scalars['Int'];
  /** The recording for which the chunk is initialized. */
  recordingId: Scalars['ID'];
};

/** The result of the initialize chunk mutation. */
export type ExamRecording_InitializeChunkResult = {
  __typename?: 'ExamRecording_InitializeChunkResult';
  /** The URL to which the chunk should be uploaded. */
  uploadUrl: Scalars['URL'];
};

/** Input to initialize a segment and generate an upload URL. */
export type ExamRecording_InitializeSegmentInput = {
  /** The recording for which the segment is initialized. */
  recordingId: Scalars['ID'];
  /** The segment index starting from 0. */
  segmentIndex: Scalars['Int'];
};

/** The result of the initialize segment mutation. */
export type ExamRecording_InitializeSegmentResult = {
  __typename?: 'ExamRecording_InitializeSegmentResult';
  /** The URL to which the segment should be uploaded. */
  uploadUrl: Scalars['URL'];
};

/** A stub for the recording entity. */
export type ExamRecording_Recording = {
  __typename?: 'ExamRecording_Recording';
  /** Time when the recording was created (started). */
  createdAt: Scalars['DateTime'];
  /** ID of the recording. */
  id: Scalars['ID'];
  /** Status of the recording. */
  status: ExamRecording_Status;
  /** Presigned URL that can be used to watch the recording. */
  watchUrl?: Maybe<Scalars['URL']>;
};

/**
 * Input to reprocess recordings that previously failed processing.
 * INTERNAL USE ONLY: For manual intervention by engineers when processing failures need to be fixed.
 */
export type ExamRecording_ReprocessRecordingsInput = {
  /** The IDs of the recordings to reprocess. */
  recordingIds: Array<Scalars['ID']>;
};

/** The result of the reprocess recordings mutation. */
export type ExamRecording_ReprocessRecordingsResult = {
  __typename?: 'ExamRecording_ReprocessRecordingsResult';
  /** The IDs of the recordings that were submitted for reprocessing. */
  recordingIds: Array<Scalars['ID']>;
};

/** The result of the start recording mutation. There is no input type because userId is taken from the user's session. */
export type ExamRecording_StartRecordingResult = {
  __typename?: 'ExamRecording_StartRecordingResult';
  /** Recording that was started. */
  recording: ExamRecording_Recording;
};

/** The status of a recording. */
export const ExamRecording_Status = {
  /** The recording has been ended. */
  Ended: 'ENDED',
  /** The recording has failed processing. */
  ProcessingFailed: 'PROCESSING_FAILED',
  /** The recording has been processed successfully. */
  ProcessingSucceeded: 'PROCESSING_SUCCEEDED',
  /** The recording has been started. */
  Started: 'STARTED'
} as const;

export type ExamRecording_Status = typeof ExamRecording_Status[keyof typeof ExamRecording_Status];
/** Export Item Feedback GraphQL schema */
export type ExportItemFeedback_Job = {
  __typename?: 'ExportItemFeedback_Job';
  /** The course containing the item that the export feedback job corresponds to. */
  course?: Maybe<Course_Course>;
  /** The S3 url of the exported item feedback, present if job is completed. */
  exportUrl?: Maybe<Scalars['URL']>;
  /** ID for the export item feedback job. */
  id: Scalars['ID'];
  /** The id for the item that the feedback job corresponds to. */
  itemId?: Maybe<Scalars['ID']>;
  /** Status of the export item feedback job. */
  jobStatus: ExportItemFeedback_JobStatus;
};

/** Enum representing the different states for the export item feedback job. */
export const ExportItemFeedback_JobStatus = {
  /** Job has completed. */
  Completed: 'COMPLETED',
  /** Job is in the failed state. */
  Failed: 'FAILED',
  /** Job is in progress. */
  InProgress: 'IN_PROGRESS',
  /** Job has started. */
  Started: 'STARTED'
} as const;

export type ExportItemFeedback_JobStatus = typeof ExportItemFeedback_JobStatus[keyof typeof ExportItemFeedback_JobStatus];
/** Export item feedback queries. */
export type ExportItemFeedback_Queries = {
  __typename?: 'ExportItemFeedback_Queries';
  /** Get a specific ExportItemFeedback_Job. */
  getExportItemFeedbackJobByJobId?: Maybe<ExportItemFeedback_Job>;
};


/** Export item feedback queries. */
export type ExportItemFeedback_QueriesGetExportItemFeedbackJobByJobIdArgs = {
  jobId: Scalars['ID'];
};

/** Start export item feedback job error. */
export type ExportItemFeedback_StartExportItemFeedbackJobError = {
  __typename?: 'ExportItemFeedback_StartExportItemFeedbackJobError';
  /** Error message */
  message: Scalars['String'];
};

/** Start export item feedback job input. */
export type ExportItemFeedback_StartExportItemFeedbackJobInput = {
  /** Course branch id for where the item to export feedback for exists. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /**
   * Course id for where the item to export feedback for exists.
   * @deprecated Use courseBranchId instead
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Item id of item to export feedback for. */
  itemId?: InputMaybe<Scalars['ID']>;
};

/** Result for start export item feedback job. */
export type ExportItemFeedback_StartExportItemFeedbackJobResult = ExportItemFeedback_Job | ExportItemFeedback_StartExportItemFeedbackJobError;

/** EOI queries */
export type ExpressionOfInterestQueries = {
  __typename?: 'ExpressionOfInterestQueries';
  /**
   * Use this to prepare to show Chili Piper. Use case are
   * 1. start user tracking
   * 2. download and install Chili Piper, typically happens at the page root level.
   */
  shouldPrepareToShowChiliPiperForDegreeProgram: Scalars['Boolean'];
  /** Determine if Chili Piper should be visible for a specific program. Based on if user is in the epic and targeting rules are satisfied. */
  shouldShowChiliPiperForDegreeProgram: Scalars['Boolean'];
};


/** EOI queries */
export type ExpressionOfInterestQueriesShouldPrepareToShowChiliPiperForDegreeProgramArgs = {
  programSlug: Scalars['String'];
};


/** EOI queries */
export type ExpressionOfInterestQueriesShouldShowChiliPiperForDegreeProgramArgs = {
  programSlug: Scalars['String'];
  realtimeTargetingOptions: Eoi_RealTimeTargetingOptionsInput;
};

/** Queries for External App configuration */
export type ExternalAppQueries = {
  __typename?: 'ExternalAppQueries';
  /** This Query returns the External App deployment for a deployment Id */
  LtiPlatform_GetExternalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeploymentResult>;
  /**
   * This Query returns a list of External App Deployments available within a specific course ID
   * The result is able to be filtered down through app availability and deployment scope
   * If deployment scope is not set, this query will retrieve deployments for both the institution and the specific course
   */
  LtiPlatform_GetExternalAppDeploymentsForCourse: Array<LtiPlatform_ExternalAppDeploymentResult>;
  /**
   * This Query returns a list of External App Deployments for specific partner IDs
   * The result is able to be filtered down through session availability (private, all)
   */
  LtiPlatform_GetExternalAppDeploymentsForPartners: Array<LtiPlatform_ExternalAppDeploymentResult>;
  /** This Query returns the External App Registration V1.3 for a clientId */
  LtiPlatform_GetExternalAppRegistrationForClientId?: Maybe<LtiPlatform_ExternalAppRegistrationV13>;
  /** This Query returns the KeySet URL for the Platform */
  LtiPlatform_GetPlatformAccessConfig?: Maybe<LtiPlatform_PlatformAccessConfig>;
};


/** Queries for External App configuration */
export type ExternalAppQueriesLtiPlatform_GetExternalAppDeploymentArgs = {
  id: Scalars['ID'];
};


/** Queries for External App configuration */
export type ExternalAppQueriesLtiPlatform_GetExternalAppDeploymentsForCourseArgs = {
  appAvailability?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  courseId: Scalars['ID'];
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
};


/** Queries for External App configuration */
export type ExternalAppQueriesLtiPlatform_GetExternalAppDeploymentsForPartnersArgs = {
  appAvailability?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  partnerIds: Array<Scalars['ID']>;
};


/** Queries for External App configuration */
export type ExternalAppQueriesLtiPlatform_GetExternalAppRegistrationForClientIdArgs = {
  clientId: Scalars['ID'];
};

/** External integration platform configuration queries. */
export type ExternalIntegrationQueries = {
  __typename?: 'ExternalIntegrationQueries';
  /** This query gets all external integration platform configurations with optional filters and pagination. */
  getAllIntegrationConfigurations: ExternalIntegration_GetAllIntegrationConfigurationsResult;
  /** This query gets an existing external integration platform configuration by integration ID. */
  getIntegrationConfiguration?: Maybe<ExternalIntegration_GetIntegrationConfigurationResult>;
  /** This query gets external integration platform configurations by organization ID. */
  getIntegrationConfigurationsByOrganizationId: ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdResult;
  /** This query gets the sync status for an external integration by integration ID. */
  getIntegrationSyncStatus: ExternalIntegration_IntegrationSyncStatusResult;
};


/** External integration platform configuration queries. */
export type ExternalIntegrationQueriesGetAllIntegrationConfigurationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: ExternalIntegration_GetAllIntegrationConfigurationsInput;
  limit?: Scalars['Int'];
};


/** External integration platform configuration queries. */
export type ExternalIntegrationQueriesGetIntegrationConfigurationArgs = {
  input: ExternalIntegration_GetIntegrationConfigurationInput;
};


/** External integration platform configuration queries. */
export type ExternalIntegrationQueriesGetIntegrationConfigurationsByOrganizationIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdInput;
  limit?: Scalars['Int'];
};


/** External integration platform configuration queries. */
export type ExternalIntegrationQueriesGetIntegrationSyncStatusArgs = {
  integrationId: Scalars['ID'];
};

/** Authentication configuration for external integrations. */
export type ExternalIntegration_AuthenticationConfiguration = {
  __typename?: 'ExternalIntegration_AuthenticationConfiguration';
  /** Authentication URL for the integration. */
  authUrl: Scalars['URL'];
  /** Client ID for authentication. */
  clientId: Scalars['ID'];
  /** Client secret for authentication (may be masked for security). */
  clientSecret: Scalars['String'];
};

/** Input for authentication configuration. */
export type ExternalIntegration_AuthenticationConfigurationInput = {
  /** Authentication URL for the integration. */
  authUrl: Scalars['URL'];
  /** Client ID for authentication. */
  clientId: Scalars['ID'];
  /** Client secret for authentication. */
  clientSecret: Scalars['String'];
};

/** Content configuration for external integrations. */
export type ExternalIntegration_ContentConfiguration = {
  __typename?: 'ExternalIntegration_ContentConfiguration';
  /** Content URL for the integration. */
  contentUrl?: Maybe<Scalars['URL']>;
  /** Whether skill content is enabled. */
  enableSkill: Scalars['Boolean'];
  /** Whether video content is enabled. */
  enableVideo: Scalars['Boolean'];
};

/** Input for content configuration. */
export type ExternalIntegration_ContentConfigurationInput = {
  /** Content URL for the integration. */
  contentUrl?: InputMaybe<Scalars['URL']>;
  /** Whether skill content is enabled. */
  enableSkill?: InputMaybe<Scalars['Boolean']>;
  /** Whether video content is enabled. */
  enableVideo?: InputMaybe<Scalars['Boolean']>;
};

/** Error details for a content sync failure. */
export type ExternalIntegration_ContentSyncError = {
  __typename?: 'ExternalIntegration_ContentSyncError';
  /** Identifier of the content that failed. */
  contentId: Scalars['ID'];
  /** The type of content that failed (e.g., Course, Specialization). */
  contentType: Scalars['String'];
  /** Timestamp when the error occured. */
  errorAt?: Maybe<Scalars['DateTime']>;
  /** Error message describing the failure. */
  errorMessage: Scalars['String'];
};

/** Count of items for a specific content type. */
export type ExternalIntegration_ContentTypeCount = {
  __typename?: 'ExternalIntegration_ContentTypeCount';
  /** The type of content (e.g., Course, Specialization). */
  contentType: Scalars['String'];
  /** Number of items of this content type. */
  count: Scalars['Int'];
};

/** Input to create an external integration platform configuration. */
export type ExternalIntegration_CreateIntegrationConfigurationInput = {
  /** The external integration platform configuration to create. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Result of creating an external integration platform configuration. */
export type ExternalIntegration_CreateIntegrationConfigurationResult = {
  __typename?: 'ExternalIntegration_CreateIntegrationConfigurationResult';
  /** The created external integration platform configuration. */
  config: ExternalIntegration_IntegrationConfiguration;
};

/** Input to delete an external integration platform configuration. */
export type ExternalIntegration_DeleteIntegrationConfigurationInput = {
  /** The integration ID to delete. */
  integrationId: Scalars['ID'];
};

/** Result of deleting an external integration platform configuration. */
export type ExternalIntegration_DeleteIntegrationConfigurationResult = {
  __typename?: 'ExternalIntegration_DeleteIntegrationConfigurationResult';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** Input to get all external integration platform configurations. */
export type ExternalIntegration_GetAllIntegrationConfigurationsInput = {
  /** Optional filter to only return active configurations. */
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter by platform type. */
  platformType?: InputMaybe<ExternalIntegration_PlatformType>;
};

/** Result of getting all external integration platform configurations. */
export type ExternalIntegration_GetAllIntegrationConfigurationsResult = {
  __typename?: 'ExternalIntegration_GetAllIntegrationConfigurationsResult';
  /** List of external integration platform configurations. */
  elements: Array<ExternalIntegration_IntegrationConfiguration>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Input to get an external integration platform configuration by integration ID. */
export type ExternalIntegration_GetIntegrationConfigurationInput = {
  /** The integration ID to retrieve. */
  integrationId: Scalars['ID'];
};

/** Result of getting an external integration platform configuration. */
export type ExternalIntegration_GetIntegrationConfigurationResult = {
  __typename?: 'ExternalIntegration_GetIntegrationConfigurationResult';
  /** The external integration platform configuration. */
  config: ExternalIntegration_IntegrationConfiguration;
};

/** Input to get external integration platform configurations by organization ID. */
export type ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdInput = {
  /** Optional filter to only return active configurations. */
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  /** The organization ID to filter by. */
  organizationId: Scalars['ID'];
  /** Optional filter by platform type. */
  platformType?: InputMaybe<ExternalIntegration_PlatformType>;
};

/** Result of getting external integration platform configurations by organization ID. */
export type ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdResult = {
  __typename?: 'ExternalIntegration_GetIntegrationConfigurationsByOrganizationIdResult';
  /** List of external integration platform configurations. */
  elements: Array<ExternalIntegration_IntegrationConfiguration>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** External integration platform configuration. */
export type ExternalIntegration_IntegrationConfiguration = {
  __typename?: 'ExternalIntegration_IntegrationConfiguration';
  /** Whether the integration is active. */
  active: Scalars['Boolean'];
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: Maybe<ExternalIntegration_XapiActorIdentificationType>;
  /** Authentication configuration for the integration. */
  authConfig: ExternalIntegration_AuthenticationConfiguration;
  /** Content configuration for the integration. */
  contentConfig: ExternalIntegration_ContentConfiguration;
  /** Timestamp when the configuration was created. */
  createdAt: Scalars['DateTime'];
  /** ID of the user who created the configuration. */
  createdBy: Scalars['ID'];
  /** Unique identifier for the integration. */
  integrationId: Scalars['ID'];
  /** Whether the xapi integration is active. */
  isXapiEnabled: Scalars['Boolean'];
  /** Organization ID associated with this integration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: ExternalIntegration_PlatformType;
  /** Tracking configuration for the integration. */
  trackingConfig: ExternalIntegration_TrackingConfiguration;
  /** Timestamp when the configuration was last updated. */
  updatedAt: Scalars['DateTime'];
  /** ID of the user who last updated the configuration. */
  updatedBy: Scalars['ID'];
};

/** Input for external integration platform configuration. */
export type ExternalIntegration_IntegrationConfigurationInput = {
  /** Whether the integration is active. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<ExternalIntegration_XapiActorIdentificationType>;
  /** Authentication configuration for the integration. */
  authConfig: ExternalIntegration_AuthenticationConfigurationInput;
  /** Content configuration for the integration. */
  contentConfig?: InputMaybe<ExternalIntegration_ContentConfigurationInput>;
  /** Timestamp when the configuration was created. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who created the configuration. */
  createdBy?: InputMaybe<Scalars['ID']>;
  /** Unique identifier for the integration. */
  integrationId?: InputMaybe<Scalars['ID']>;
  /** Whether the xapi integration is active. */
  isXapiEnabled?: Scalars['Boolean'];
  /** Organization ID associated with this integration. */
  organizationId: Scalars['ID'];
  /** Platform type for the integration. */
  platform: ExternalIntegration_PlatformType;
  /** Tracking configuration for the integration. */
  trackingConfig?: InputMaybe<ExternalIntegration_TrackingConfigurationInput>;
  /** Timestamp when the configuration was last updated. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who last updated the configuration. */
  updatedBy?: InputMaybe<Scalars['ID']>;
};

/** Result of getting the sync status for an external integration. */
export type ExternalIntegration_IntegrationSyncStatusResult = {
  __typename?: 'ExternalIntegration_IntegrationSyncStatusResult';
  /** Timestamp when the sync completed. */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Detailed breakdown of the sync operation. */
  details?: Maybe<ExternalIntegration_SyncDetails>;
  /** Unique identifier for the integration. */
  integrationId: Scalars['ID'];
  /** Organization ID associated with this integration. */
  orgId: Scalars['ID'];
  /** Timestamp when the sync started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the sync operation. */
  status: ExternalIntegration_SyncStatus;
};

/** Platform types for external integrations. */
export const ExternalIntegration_PlatformType = {
  /** Degreed platform. */
  PlatformTypeDegreed: 'PLATFORM_TYPE_DEGREED',
  /** Edcast platform. */
  PlatformTypeEdcast: 'PLATFORM_TYPE_EDCAST',
  /** Invalid platform type. */
  PlatformTypeInvalid: 'PLATFORM_TYPE_INVALID',
  /** Standard platform. */
  PlatformTypeStandard: 'PLATFORM_TYPE_STANDARD',
  /** Walmart platform. */
  PlatformTypeWalmart: 'PLATFORM_TYPE_WALMART',
  /** Workday platform. */
  PlatformTypeWorkday: 'PLATFORM_TYPE_WORKDAY'
} as const;

export type ExternalIntegration_PlatformType = typeof ExternalIntegration_PlatformType[keyof typeof ExternalIntegration_PlatformType];
/** Status for a sync category (in progress or completed). */
export type ExternalIntegration_SyncCategoryStatus = {
  __typename?: 'ExternalIntegration_SyncCategoryStatus';
  /** Number of items in this category. */
  count: Scalars['Int'];
  /** Breakdown by content type. */
  details?: Maybe<Array<ExternalIntegration_ContentTypeCount>>;
};

/** Detailed breakdown of a sync operation. */
export type ExternalIntegration_SyncDetails = {
  __typename?: 'ExternalIntegration_SyncDetails';
  /** Status of items that failed to sync. */
  failed?: Maybe<ExternalIntegration_SyncFailureStatus>;
  /** Status of items currently being synced. */
  processing?: Maybe<ExternalIntegration_SyncCategoryStatus>;
  /** Status of items that completed syncing successfully. */
  succeeded?: Maybe<ExternalIntegration_SyncCategoryStatus>;
  /** Total count of items being synced. */
  total: Scalars['Int'];
};

/** Status for failed sync items with error details. */
export type ExternalIntegration_SyncFailureStatus = {
  __typename?: 'ExternalIntegration_SyncFailureStatus';
  /** Number of items that failed. */
  count: Scalars['Int'];
  /** Breakdown by content type. */
  details?: Maybe<Array<ExternalIntegration_ContentTypeCount>>;
  /** Recent errors encountered during sync. */
  recentErrors?: Maybe<Array<ExternalIntegration_ContentSyncError>>;
};

/** Status of a sync operation. */
export const ExternalIntegration_SyncStatus = {
  /** Sync failed. */
  Failure: 'FAILURE',
  /** Sync is currently in progress. */
  Processing: 'PROCESSING',
  /** Sync completed successfully. */
  Success: 'SUCCESS'
} as const;

export type ExternalIntegration_SyncStatus = typeof ExternalIntegration_SyncStatus[keyof typeof ExternalIntegration_SyncStatus];
/** Tracking configuration for external integrations. */
export type ExternalIntegration_TrackingConfiguration = {
  __typename?: 'ExternalIntegration_TrackingConfiguration';
  /** Whether to send item updates. */
  sendItemUpdates: Scalars['Boolean'];
  /** Whether to send non-graded items. */
  sendNonGradedItems: Scalars['Boolean'];
  /** Tracking URL for the integration. */
  trackingUrl?: Maybe<Scalars['URL']>;
};

/** Input for tracking configuration. */
export type ExternalIntegration_TrackingConfigurationInput = {
  /** Whether to send item updates. */
  sendItemUpdates?: InputMaybe<Scalars['Boolean']>;
  /** Whether to send non-graded items. */
  sendNonGradedItems?: InputMaybe<Scalars['Boolean']>;
  /** Tracking URL for the integration. */
  trackingUrl?: InputMaybe<Scalars['URL']>;
};

/** Input to update an external integration platform configuration. */
export type ExternalIntegration_UpdateIntegrationConfigurationInput = {
  /** The external integration platform configuration to update. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Result of updating an external integration platform configuration. */
export type ExternalIntegration_UpdateIntegrationConfigurationResult = {
  __typename?: 'ExternalIntegration_UpdateIntegrationConfigurationResult';
  /** The updated external integration platform configuration. */
  config: ExternalIntegration_IntegrationConfiguration;
};

/** Input to validate an external integration platform configuration. */
export type ExternalIntegration_ValidateIntegrationConfigurationInput = {
  /** The external integration platform configuration to validate. */
  config: ExternalIntegration_IntegrationConfigurationInput;
};

/** Result of validating an external integration platform configuration. */
export type ExternalIntegration_ValidateIntegrationConfigurationResult = {
  __typename?: 'ExternalIntegration_ValidateIntegrationConfigurationResult';
  /** Whether the configuration is valid. */
  isValid: Scalars['Boolean'];
  /** List of validation errors (if any). */
  validationErrors: Array<ExternalIntegration_ValidationError>;
};

/** Validation error for external integration platform configuration. */
export type ExternalIntegration_ValidationError = {
  __typename?: 'ExternalIntegration_ValidationError';
  /** The type of validation error. */
  errorType: ExternalIntegration_ValidationErrorType;
  /** The field that has the validation error. */
  field: Scalars['String'];
  /** The validation error message. */
  message: Scalars['String'];
};

/** Types of validation errors. */
export const ExternalIntegration_ValidationErrorType = {
  /** Authentication failed. */
  ValidationErrorTypeAuthenticationFailed: 'VALIDATION_ERROR_TYPE_AUTHENTICATION_FAILED',
  /** Connection failed. */
  ValidationErrorTypeConnectionFailed: 'VALIDATION_ERROR_TYPE_CONNECTION_FAILED',
  /** Invalid validation error type. */
  ValidationErrorTypeInvalid: 'VALIDATION_ERROR_TYPE_INVALID',
  /** Invalid format. */
  ValidationErrorTypeInvalidFormat: 'VALIDATION_ERROR_TYPE_INVALID_FORMAT',
  /** Invalid URL. */
  ValidationErrorTypeInvalidUrl: 'VALIDATION_ERROR_TYPE_INVALID_URL',
  /** Required field is missing. */
  ValidationErrorTypeRequiredFieldMissing: 'VALIDATION_ERROR_TYPE_REQUIRED_FIELD_MISSING'
} as const;

export type ExternalIntegration_ValidationErrorType = typeof ExternalIntegration_ValidationErrorType[keyof typeof ExternalIntegration_ValidationErrorType];
/** Enumeration type representing which method to use to identify xAPI actors */
export const ExternalIntegration_XapiActorIdentificationType = {
  /** Method of composing xAPI actor using an enterprise user's configured external id. */
  XapiActorIdentificationTypeAccount: 'XAPI_ACTOR_IDENTIFICATION_TYPE_ACCOUNT',
  /** Invalid value. */
  XapiActorIdentificationTypeInvalid: 'XAPI_ACTOR_IDENTIFICATION_TYPE_INVALID',
  /** Method of composing xAPI actor using email address in a mailto: format. */
  XapiActorIdentificationTypeMbox: 'XAPI_ACTOR_IDENTIFICATION_TYPE_MBOX'
} as const;

export type ExternalIntegration_XapiActorIdentificationType = typeof ExternalIntegration_XapiActorIdentificationType[keyof typeof ExternalIntegration_XapiActorIdentificationType];
export type ExternallyAccessibleNostosV1 = {
  __typename?: 'ExternallyAccessibleNostosV1';
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  content: Scalars['JSON'];
  id: Scalars['String'];
};

export type ExternallyAccessibleNostosV1Connection = {
  __typename?: 'ExternallyAccessibleNostosV1Connection';
  elements: Array<Maybe<ExternallyAccessibleNostosV1>>;
  paging: ResponsePagination;
};

export type ExternallyAccessibleNostosV1GetAllProperties = {
  __typename?: 'ExternallyAccessibleNostosV1GetAllProperties';
  connection?: Maybe<ExternallyAccessibleNostosV1Connection>;
  job_name: Scalars['String'];
  keys: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  overrideVersion?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type ExternallyAccessibleNostosV1Resource = {
  __typename?: 'ExternallyAccessibleNostosV1Resource';
  getAllProperties?: Maybe<ExternallyAccessibleNostosV1Connection>;
};


export type ExternallyAccessibleNostosV1ResourceGetAllPropertiesArgs = {
  job_name: Scalars['String'];
  keys: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  overrideVersion?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Queries specific to FAQs */
export type FaqQueries = {
  __typename?: 'FaqQueries';
  /** This query returns the default FAQs for a given product. */
  getDefaultFaqs: Array<DescriptionPage_Faq>;
};


/** Queries specific to FAQs */
export type FaqQueriesGetDefaultFaqsArgs = {
  input: Faq_DefaultFaqsInput;
};

/** Input for retrieving default FAQs. */
export type Faq_DefaultFaqsInput = {
  /** Product ID to get the default fAQs For */
  productId: Scalars['ID'];
  /** The type of product to retrieve FAQs for (COURSE or SPECIALIZATION). */
  productType: Faq_ProductType;
};

/** Type discriminator for default FAQs based on product type. */
export const Faq_ProductType = {
  /** FAQs for courses. */
  Course: 'COURSE',
  /** FAQs for specializations. */
  Specialization: 'SPECIALIZATION'
} as const;

export type Faq_ProductType = typeof Faq_ProductType[keyof typeof Faq_ProductType];
/** An instance of a Financial Aid Application */
export type FinancialAidApplication = {
  __typename?: 'FinancialAidApplication';
  /**
   * The estimated date when the application will be approved.
   * This value will be empty if the application is not in PENDING state.
   */
  approvalEstimatedAt?: Maybe<Scalars['DateTime']>;
  /** Career progression questionnaire */
  careerProgressionQuestionnaire?: Maybe<FinancialAidApplication_CareerProgressionQuestionnaire>;
  /** The CartId associated with this application */
  cartId: Cart;
  /** The country code of the applicant */
  countryIsoCode?: Maybe<Scalars['String']>;
  /** Date that the finAid application was submitted */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Education background */
  educationalBackground?: Maybe<FinancialAidApplication_EducationalBackground>;
  /** External financial assistance questionnaire */
  externalFinancialAssistanceQuestionnaire?: Maybe<FinancialAidApplication_ExternalFinancialAssistanceQuestionnaire>;
  /** Financial background */
  financialBackground?: Maybe<FinancialAidApplication_FinancialBackground>;
  /** The UUID of the application */
  id: Scalars['ID'];
  /** Product that the learner is applying for finAid to */
  productId?: Maybe<FinancialAidApplication_ProductId>;
  /** The current state of the application */
  state: FinancialAidApplication_State;
  /** The ID of the user who created the application */
  userId: User;
};

/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueries = {
  __typename?: 'FinancialAidApplicationQueries';
  /** Get a list of applications associated to the cart */
  queryByCart: Array<FinancialAidApplication>;
  /** Get an application by id */
  queryById?: Maybe<FinancialAidApplication>;
  /** Get a list of applications by UUIDs */
  queryByIds: Array<Maybe<FinancialAidApplication>>;
  /** Get a list of applications created by user id */
  queryByUser: FinancialAidApplication_FinancialAidApplicationPaginatedResult;
  /** Get a list of applications created by a user for a specific product */
  queryByUserAndProduct: FinancialAidApplication_FinancialAidApplicationPaginatedResult;
  /** Get a list of applications created by a user for a list of products */
  queryByUserAndProducts: FinancialAidApplication_FinancialAidApplicationPaginatedResult;
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByCartArgs = {
  cartId: Scalars['ID'];
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByUserArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  state?: InputMaybe<FinancialAidApplication_State>;
  userId: Scalars['ID'];
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByUserAndProductArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  productId: FinancialAidApplication_ProductIdInput;
  userId: Scalars['ID'];
};


/** All Financial Aid Application query definitions */
export type FinancialAidApplicationQueriesQueryByUserAndProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  productIds: Array<FinancialAidApplication_ProductIdInput>;
  userId: Scalars['ID'];
};

/** Approve application request payload */
export type FinancialAidApplication_ApproveInput = {
  /** Application UUID */
  id: Scalars['ID'];
};

/** Approve application response for either success of failure */
export type FinancialAidApplication_ApproveResult = FinancialAidApplication_Failure | FinancialAidApplication_VoidSuccess;

/** Contains career related questions from the FinancialAidApplication creation form */
export type FinancialAidApplication_CareerProgressionQuestionnaire = {
  __typename?: 'FinancialAidApplication_CareerProgressionQuestionnaire';
  /** How this course will contribute to the applicants career */
  howContributeToCareer?: Maybe<Scalars['String']>;
  /** How this course will contribute to the applicants community */
  howContributeToCommunity?: Maybe<Scalars['String']>;
  /** Why this applicant is applying */
  whyApplying?: Maybe<Scalars['String']>;
  /** Why this applicant wants to take this course */
  whyTakingCourse?: Maybe<Scalars['String']>;
};

/** Career related questions */
export type FinancialAidApplication_CareerProgressionQuestionnaireInput = {
  /** How this course will contribute to the applicants career */
  howContributeToCareer?: InputMaybe<Scalars['String']>;
  /** How this course will contribute to the applicants community */
  howContributeToCommunity?: InputMaybe<Scalars['String']>;
  /** Why this applicant is applying */
  whyApplying?: InputMaybe<Scalars['String']>;
  /** Why this applicant wants to take this course */
  whyTakingCourse?: InputMaybe<Scalars['String']>;
};

/** Create application request payload */
export type FinancialAidApplication_CreateInput = {
  /** Career progression questionnaire */
  careerProgressionQuestionnaire?: InputMaybe<FinancialAidApplication_CareerProgressionQuestionnaireInput>;
  /** The Cart Id associated with this application */
  cartId: Scalars['ID'];
  /** The country code of the applicant */
  countryIsoCode?: InputMaybe<Scalars['String']>;
  /** Education background */
  educationalBackground?: InputMaybe<FinancialAidApplication_EducationalBackgroundInput>;
  /** External financial assistance questionnaire */
  externalFinancialAssistanceQuestionnaire?: InputMaybe<FinancialAidApplication_ExternalFinancialAssistanceQuestionnaireInput>;
  /** Financial background */
  financialBackground?: InputMaybe<FinancialAidApplication_FinancialBackgroundInput>;
  /** The ID of the user associated with the application */
  userId: Scalars['ID'];
};

/** Create application response for either success of failure */
export type FinancialAidApplication_CreateResult = FinancialAidApplication_CreateSuccess | FinancialAidApplication_Failure;

/** Response after successful creation of application */
export type FinancialAidApplication_CreateSuccess = {
  __typename?: 'FinancialAidApplication_CreateSuccess';
  /** Application UUID */
  id?: Maybe<Scalars['ID']>;
};

/** Contains education related questions from the Financial Aid Application creation form */
export type FinancialAidApplication_EducationalBackground = {
  __typename?: 'FinancialAidApplication_EducationalBackground';
  /** The educational background of the applicant eg: HIGH_SCHOOL */
  educationalBackground?: Maybe<Scalars['String']>;
};

/** Education related questions */
export type FinancialAidApplication_EducationalBackgroundInput = {
  /** The educational background of the applicant eg: HIGH_SCHOOL */
  educationalBackground?: InputMaybe<Scalars['String']>;
};

/** Error details */
export type FinancialAidApplication_Error = ErrorDetails & {
  __typename?: 'FinancialAidApplication_Error';
  /** Inherited field from ErrorDetails interface */
  errorCode: Scalars['String'];
  /** Inherited field from ErrorDetails interface */
  message: Scalars['String'];
  /** Inherited field from ErrorDetails interface */
  path: Scalars['String'];
  /** Inherited field from ErrorDetails interface */
  suggestion?: Maybe<Scalars['String']>;
};

/** External financial information */
export type FinancialAidApplication_ExternalFinancialAssistanceQuestionnaire = {
  __typename?: 'FinancialAidApplication_ExternalFinancialAssistanceQuestionnaire';
  /** Why the applicant is not willing to take out a loan for this course */
  whyNotWillingToTakeOutLoan?: Maybe<Scalars['String']>;
  /** Is the applicant willing to take out a loan for this course? */
  willingToTakeOutLoan?: Maybe<Scalars['Boolean']>;
};

/** External financial information */
export type FinancialAidApplication_ExternalFinancialAssistanceQuestionnaireInput = {
  /** Why the applicant is not willing to take out a loan for this course */
  whyNotWillingToTakeOutLoan?: InputMaybe<Scalars['String']>;
  /** Is the applicant willing to take out a loan for this course? */
  willingToTakeOutLoan?: InputMaybe<Scalars['Boolean']>;
};

/** Failure response containing list of errors */
export type FinancialAidApplication_Failure = {
  __typename?: 'FinancialAidApplication_Failure';
  /** List of errors */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Pagination for FinancialAidApplication results. */
export type FinancialAidApplication_FinancialAidApplicationPaginatedResult = {
  __typename?: 'FinancialAidApplication_FinancialAidApplicationPaginatedResult';
  /** List of FinancialAidApplication results */
  elements: Array<FinancialAidApplication>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Financial Background information about the applicant */
export type FinancialAidApplication_FinancialBackground = {
  __typename?: 'FinancialAidApplication_FinancialBackground';
  /** How much the applicant can pay to take this course */
  affordToPay?: Maybe<Scalars['Float']>;
  /** The currency code for the applicant */
  affordToPayCurrencyCode?: Maybe<CurrencyCode>;
  /** The annual income of the applicant */
  annualIncome: Scalars['Float'];
  /** The type of currency referred to for annualIncome */
  annualIncomeCurrencyCode?: Maybe<CurrencyCode>;
  /** The current employment status of the applicant */
  employmentStatus?: Maybe<Scalars['String']>;
  /** How often does the applicant get paid */
  payPeriod?: Maybe<Scalars['String']>;
};

/** Financial Background */
export type FinancialAidApplication_FinancialBackgroundInput = {
  /** How much the applicant can pay to take this course */
  affordToPay: Scalars['Float'];
  /** The currency code for the applicant */
  affordToPayCurrencyCode: CurrencyCode;
  /** The annual income of the applicant */
  annualIncome: Scalars['Float'];
  /** The type of currency referred to for annualIncome */
  annualIncomeCurrencyCode: Scalars['String'];
  /** The current employment status of the applicant */
  employmentStatus?: InputMaybe<Scalars['String']>;
  /** How often does the applicant get paid */
  payPeriod?: InputMaybe<Scalars['String']>;
};

/** Product Id type encapsulating both the ProductType and ProductItemId together in one object. */
export type FinancialAidApplication_ProductId = {
  __typename?: 'FinancialAidApplication_ProductId';
  /** Product item ID identifying the corresponding product. */
  productItemId: Scalars['ID'];
  /** Product types supported by the Financial Aid endpoints. */
  productType: FinancialAidApplication_ProductType;
};

/** Product Id input for encapsulating both the ProductType and ProductItemId together in one object. */
export type FinancialAidApplication_ProductIdInput = {
  /** Product item ID identifying the corresponding product. */
  productItemId: Scalars['ID'];
  /** Product types supported by the Financial Aid endpoints. */
  productType: FinancialAidApplication_ProductType;
};

/** The supported product types for Financial Aid */
export const FinancialAidApplication_ProductType = {
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type FinancialAidApplication_ProductType = typeof FinancialAidApplication_ProductType[keyof typeof FinancialAidApplication_ProductType];
/** An enumerate the state of the application */
export const FinancialAidApplication_State = {
  /** The application is APPROVED */
  Approved: 'APPROVED',
  /** PAYMENT_PENDING to APPROVED_PAID. State change after successful payment of discounted price */
  ApprovedPaid: 'APPROVED_PAID',
  /**
   * PAYMENT_PENDING to PAYMENT_EXPIRED if payment is not made within N days.
   * ( N is the # of days since application was created )
   */
  PaymentExpired: 'PAYMENT_EXPIRED',
  /**
   * PENDING to PAYMENT_PENDING for <100% discounted applications.
   * Requires learner to make payment of the discounted price
   */
  PaymentPending: 'PAYMENT_PENDING',
  /** The application is PENDING */
  Pending: 'PENDING',
  /** The application is REJECTED */
  Rejected: 'REJECTED',
  /** The applicant has chosen to withdraw this application */
  Withdrawn: 'WITHDRAWN'
} as const;

export type FinancialAidApplication_State = typeof FinancialAidApplication_State[keyof typeof FinancialAidApplication_State];
/** Successful mutation that returns empty response payload */
export type FinancialAidApplication_VoidSuccess = {
  __typename?: 'FinancialAidApplication_VoidSuccess';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

export type FinancialAidApplicationsV2 = {
  __typename?: 'FinancialAidApplicationsV2';
  additionalQuestions?: Maybe<FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinAidAdditionalQuestions>;
  annualIncome: Scalars['String'];
  annualIncomeCurrencyCode?: Maybe<Scalars['String']>;
  applicationDate?: Maybe<Scalars['Float']>;
  approvalDate?: Maybe<Scalars['Float']>;
  cartId: Scalars['Float'];
  country?: Maybe<Scalars['String']>;
  denied: Scalars['Boolean'];
  howContributeToCommunity?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  productId?: Maybe<Scalars['String']>;
  state?: Maybe<FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
  whyApplying?: Maybe<Scalars['String']>;
  whyTakingCourse?: Maybe<Scalars['String']>;
};

export type FinancialAidApplicationsV2ByUser = {
  __typename?: 'FinancialAidApplicationsV2ByUser';
  connection?: Maybe<FinancialAidApplicationsV2Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type FinancialAidApplicationsV2Connection = {
  __typename?: 'FinancialAidApplicationsV2Connection';
  elements: Array<Maybe<FinancialAidApplicationsV2>>;
  paging: ResponsePagination;
};

export type FinancialAidApplicationsV2Resource = {
  __typename?: 'FinancialAidApplicationsV2Resource';
  byUser?: Maybe<FinancialAidApplicationsV2Connection>;
};


export type FinancialAidApplicationsV2ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type FinancialAidApplicationsV2ResourceMutations = {
  __typename?: 'FinancialAidApplicationsV2ResourceMutations';
  create?: Maybe<FinancialAidApplicationsV2Connection>;
};

export type FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinAidAdditionalQuestions = {
  __typename?: 'FinancialAidApplicationsV2_org_coursera_product_financialaid_FinAidAdditionalQuestions';
  affordToPay?: Maybe<Scalars['Float']>;
  affordToPayCurrencyCode?: Maybe<Scalars['String']>;
  educationalBackground?: Maybe<Scalars['String']>;
  employmentStatus?: Maybe<Scalars['String']>;
  howContributeToCareer?: Maybe<Scalars['String']>;
  payPeriod?: Maybe<Scalars['String']>;
  whyNotWillingToTakeLoan?: Maybe<Scalars['String']>;
  willingToBecomeCourseMentor?: Maybe<Scalars['Boolean']>;
  willingToHelpTranslate?: Maybe<Scalars['Boolean']>;
  willingToTakeOutLoan?: Maybe<Scalars['Boolean']>;
  willingToTest?: Maybe<Scalars['Boolean']>;
};

export const FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState = {
  Approved: 'APPROVED',
  ApprovedPaid: 'APPROVED_PAID',
  ApprovedPaymentSuccessful: 'APPROVED_PAYMENT_SUCCESSFUL',
  PaymentExpired: 'PAYMENT_EXPIRED',
  PaymentPending: 'PAYMENT_PENDING',
  Pending: 'PENDING',
  Rejected: 'REJECTED',
  Withdrawn: 'WITHDRAWN'
} as const;

export type FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState = typeof FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState[keyof typeof FinancialAidApplicationsV2_Org_Coursera_Product_Financialaid_FinancialAidApplicationState];
/** Flashcard Queries */
export type FlashcardQueries = {
  __typename?: 'FlashcardQueries';
  /** Queries flashcards by course slug with pagination */
  queryByCourseSlugForCurrentUser: Flashcards_FlashcardPaginatedResult;
  /** Query flashcards by course slug with advanced filtering and pagination */
  queryFlashcardsByCourseSlug: Flashcards_FlashcardPaginatedResult;
  /** Query modules with flashcards by course slug */
  queryModulesWithFlashcardsByCourseSlug: Array<Flashcards_Module>;
};


/** Flashcard Queries */
export type FlashcardQueriesQueryByCourseSlugForCurrentUserArgs = {
  courseSlug: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  moduleId?: InputMaybe<Scalars['ID']>;
  shuffleSeed?: InputMaybe<Scalars['Int']>;
};


/** Flashcard Queries */
export type FlashcardQueriesQueryFlashcardsByCourseSlugArgs = {
  courseSlug: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemIdFilterMode?: InputMaybe<Flashcards_ItemIdFilterMode>;
  limit?: Scalars['Int'];
  moduleId?: InputMaybe<Scalars['ID']>;
  shuffleSeed?: InputMaybe<Scalars['Int']>;
};


/** Flashcard Queries */
export type FlashcardQueriesQueryModulesWithFlashcardsByCourseSlugArgs = {
  courseSlug: Scalars['String'];
  itemId?: InputMaybe<Scalars['ID']>;
};

/** Paginated result for Flashcards_FlashcardWithMetadata */
export type Flashcards_FlashcardPaginatedResult = {
  __typename?: 'Flashcards_FlashcardPaginatedResult';
  /** List of flashcards in the page */
  elements: Array<Flashcards_FlashcardWithMetadata>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** FlashcardWithMetadata type based on the Java record */
export type Flashcards_FlashcardWithMetadata = {
  __typename?: 'Flashcards_FlashcardWithMetadata';
  /** The course flashcard is associated with */
  course: Course_Course;
  /** The flashcard definition */
  definition: Scalars['String'];
  /** ID of the flashcard */
  id: Scalars['ID'];
  /** Item entity */
  item: Flashcards_Item;
  /** Lesson entity */
  lesson: Flashcards_Lesson;
  /** Module entity */
  module: Flashcards_Module;
  /** The flashcard term */
  term: Scalars['String'];
};

/** The item the flashcard is associated with */
export type Flashcards_Item = {
  __typename?: 'Flashcards_Item';
  /** Item ID */
  id: Scalars['ID'];
  /** Item type */
  itemType: Flashcards_ItemType;
  /** Item name */
  name: Scalars['String'];
};

/** Flashcards_ItemIdFilterMode enumeration */
export const Flashcards_ItemIdFilterMode = {
  /** Return only flashcards for that item */
  Exact: 'EXACT',
  /** Return flashcards up to the item */
  UpTo: 'UP_TO'
} as const;

export type Flashcards_ItemIdFilterMode = typeof Flashcards_ItemIdFilterMode[keyof typeof Flashcards_ItemIdFilterMode];
/** Flashcards_ItemType enumeration */
export const Flashcards_ItemType = {
  /** Lecture item type */
  Lecture: 'LECTURE',
  /** Reading item type */
  Reading: 'READING'
} as const;

export type Flashcards_ItemType = typeof Flashcards_ItemType[keyof typeof Flashcards_ItemType];
/** The lesson the flashcard is associated with */
export type Flashcards_Lesson = {
  __typename?: 'Flashcards_Lesson';
  /** Lesson ID */
  id: Scalars['ID'];
  /** Lesson name */
  name: Scalars['String'];
};

/** The module the flashcard is associated with */
export type Flashcards_Module = {
  __typename?: 'Flashcards_Module';
  /** Module ID */
  id: Scalars['ID'];
  /**
   * Represents the sequential number of a module within a course, inferred from the module's order.
   * For example, the first module in the course has a moduleNumber of 1.
   */
  moduleNumber: Scalars['Int'];
  /** Module name */
  name: Scalars['String'];
};

/** Input for Flashcards_SetOptOut mutation. */
export type Flashcards_SetOptOutInput = {
  /** Id of the course for which to set the flashcards opt-out state. */
  courseId: Scalars['ID'];
  /** Whether the flashcards UI should be hidden (opted out) for the course. */
  optedOut: Scalars['Boolean'];
};

/** Result of the Flashcards_SetOptOut mutation. */
export type Flashcards_SetOptOutResult = Flashcards_SetOptOutSuccess | Flashcards_SetOptOut_InvalidArgumentsError;

/** Successful Result of the Flashcards_SetOptOut mutation. */
export type Flashcards_SetOptOutSuccess = {
  __typename?: 'Flashcards_SetOptOutSuccess';
  /** Course id for which the opt-out state was set. */
  courseId: Scalars['ID'];
  /** The opted-out state that was set for the course. */
  optedOut: Scalars['Boolean'];
};

/** Error indicating that invalid arguments were supplied to Flashcards_SetOptOut. */
export type Flashcards_SetOptOut_InvalidArgumentsError = {
  __typename?: 'Flashcards_SetOptOut_InvalidArgumentsError';
  /** Course for which invalid arguments were supplied. */
  courseId: Scalars['ID'];
  /** Error message. */
  message: Scalars['String'];
};

export type GdprSettingsV1 = {
  __typename?: 'GdprSettingsV1';
  allowAccountLinking: Scalars['Boolean'];
  gdprMode: GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode;
  id: Scalars['String'];
  recoveryAccountAfterFirstEnrollment: Scalars['Boolean'];
  recoveryAccountInSettings: Scalars['Boolean'];
  recoveryAccountOnHomePage: Scalars['Boolean'];
  recoveryPasswordAtCreation: Scalars['Boolean'];
};

export type GdprSettingsV1Connection = {
  __typename?: 'GdprSettingsV1Connection';
  elements: Array<Maybe<GdprSettingsV1>>;
  paging: ResponsePagination;
};

export type GdprSettingsV1Resource = {
  __typename?: 'GdprSettingsV1Resource';
  get?: Maybe<GdprSettingsV1>;
  multiGet?: Maybe<GdprSettingsV1Connection>;
};


export type GdprSettingsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type GdprSettingsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type GdprSettingsV1ResourceMutations = {
  __typename?: 'GdprSettingsV1ResourceMutations';
  update?: Maybe<GdprSettingsV1Connection>;
};


export type GdprSettingsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

/** ThirdPartyOrganization GDPR Modes define the expected account creation and existence of third party accounts where organizations have various restrictions on how and when they want users to be able to create recover accounts, etc. See https://coursera.atlassian.net/wiki/spaces/PROD/pages/560300101/SSO+Login+and+Account+Creation+Usability+and+GDPR+Compliance+across+SSO+and+Non-SSO+Orgs#Acceptance-Criteria */
export const GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode = {
  GdprModeDefault: 'GDPR_MODE_DEFAULT',
  GdprModeLight: 'GDPR_MODE_LIGHT',
  GdprModeRestrictive: 'GDPR_MODE_RESTRICTIVE',
  GdprModeStrict: 'GDPR_MODE_STRICT'
} as const;

export type GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode = typeof GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode[keyof typeof GdprSettingsV1_Org_Coursera_Enterprise_Gdpr_GdprMode];
/** Gibberish check status */
export const GibberishStatus = {
  /** Gibberish is skipped for a given prompt since it's not part of the allowlist */
  GibberishSkipped: 'GIBBERISH_SKIPPED',
  /** Gibberish is detected for a given prompt */
  IsGibberish: 'IS_GIBBERISH',
  /** Gibberish is not detected for a given prompt */
  NotGibberish: 'NOT_GIBBERISH'
} as const;

export type GibberishStatus = typeof GibberishStatus[keyof typeof GibberishStatus];
/** Queries related to the Graded Item Locking feature (formerly known as Require All Item Completion) */
export type GradedItemLockingQueries = {
  __typename?: 'GradedItemLockingQueries';
  /** Bulk query whether Graded Item Locking is enabled */
  getGradedItemLockingEnablements: GradedItemLocking_GetGradedItemLockingEnablementsResult;
  /** Query whether Graded Item Locking is enabled for the given course in the specified program and institution. */
  isGradedItemLockingEnabled: Scalars['Boolean'];
};


/** Queries related to the Graded Item Locking feature (formerly known as Require All Item Completion) */
export type GradedItemLockingQueriesGetGradedItemLockingEnablementsArgs = {
  enablementInputs: Array<GradedItemLocking_EnablementInput>;
};


/** Queries related to the Graded Item Locking feature (formerly known as Require All Item Completion) */
export type GradedItemLockingQueriesIsGradedItemLockingEnabledArgs = {
  courseId: Scalars['ID'];
  institutionId: Scalars['ID'];
  programId: Scalars['ID'];
};

/** A single enablement status */
export type GradedItemLocking_Enablement = {
  __typename?: 'GradedItemLocking_Enablement';
  /** Course ID */
  courseId: Scalars['ID'];
  /** Institution that the program is in for which this enablement is applied */
  institutionId: Scalars['ID'];
  /** Is enabled */
  isGradedItemLockingEnabled: Scalars['Boolean'];
  /** Program that the course is in for which this enablement is applied */
  programId: Scalars['ID'];
};

/** Parameters required to query a single Graded Item Locking enablement */
export type GradedItemLocking_EnablementInput = {
  /** Course whose enablement status to lookup */
  courseId: Scalars['ID'];
  /** Institution the program should be in for enablement lookup */
  institutionId: Scalars['ID'];
  /** Program the course should be in for enablement lookup */
  programId: Scalars['ID'];
};

/** Bulk enablement lookup result */
export type GradedItemLocking_GetGradedItemLockingEnablementsResult = {
  __typename?: 'GradedItemLocking_GetGradedItemLockingEnablementsResult';
  /** Indicates whether all enablements in result are enabled */
  allEnabled: Scalars['Boolean'];
  /** Indicates whether at least once in result is enabled */
  anyEnabled: Scalars['Boolean'];
  /** Enablement statuses */
  enablements: Array<GradedItemLocking_Enablement>;
};

/** The enablement to update and the enablement status */
export type GradedItemLocking_UpdateEnablementInput = {
  /** The course to update Graded Item Locking enablement status for */
  courseId: Scalars['ID'];
  /** The new enablement status to be set */
  enableGradedItemLocking: Scalars['Boolean'];
  /** The institution in which the course enablement should get updated */
  institutionId: Scalars['ID'];
  /** The program in which the course enablement should get updated */
  programId: Scalars['ID'];
};

/** Mutation result, returns nothing */
export type GradedItemLocking_UpdateEnablementResult = {
  __typename?: 'GradedItemLocking_UpdateEnablementResult';
  /** Dummy */
  _?: Maybe<Scalars['Boolean']>;
};

/** Set learner plugin grade error */
export type GradedPlugin_SetLearnerPluginGradeError = {
  __typename?: 'GradedPlugin_SetLearnerPluginGradeError';
  /** Error message */
  message: Scalars['String'];
};

/** Set learner plugin grade failure */
export type GradedPlugin_SetLearnerPluginGradeFailure = {
  __typename?: 'GradedPlugin_SetLearnerPluginGradeFailure';
  /** Set learner plugin grade errors */
  errors: Array<GradedPlugin_SetLearnerPluginGradeError>;
};

/** Set learner plugin grade input */
export type GradedPlugin_SetLearnerPluginGradeInput = {
  /** Course branch id */
  courseBranchId: Scalars['ID'];
  /** Course id */
  courseId: Scalars['ID'];
  /** It's a normalized grade (between 0 and 1) */
  grade: Scalars['Float'];
  /** Item id */
  itemId: Scalars['ID'];
  /** Passing fraction (between 0 and 1) */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** Widget session id */
  widgetSessionId: Scalars['ID'];
};

/** Set learner plugin grade result */
export type GradedPlugin_SetLearnerPluginGradeResult = GradedPlugin_SetLearnerPluginGradeFailure | GradedPlugin_SetLearnerPluginGradeSuccess;

/** Set learner plugin grade success */
export type GradedPlugin_SetLearnerPluginGradeSuccess = {
  __typename?: 'GradedPlugin_SetLearnerPluginGradeSuccess';
  /** Course id */
  courseId: Scalars['ID'];
  /** The final score of the learner for this item which is a normalized grade (between 0 and 1) */
  finalGrade: Scalars['Float'];
  /** Item id */
  itemId: Scalars['ID'];
  /** Widget session id */
  widgetSessionId: Scalars['ID'];
};

/** Queries for grader performance */
export type GraderPerformanceQueries = {
  __typename?: 'GraderPerformanceQueries';
  /**
   * Get grader performance dashboard saved settings for a session and the logged in user, will fetch
   * the userId from the logged in context, so will not need to pass userId in
   */
  queryDashboardSessionSettings?: Maybe<GraderPerformance_DashboardSessionSettings>;
  /** Get metrics for grader performance for a session (given groupId) */
  queryGroupMetrics?: Maybe<GraderPerformance_GroupMetrics>;
  /** Used to check if there are any ongoing refreshes on the grader performance metrics for a session */
  queryGroupMetricsRefreshStatus?: Maybe<GraderPerformance_GroupMetricsRefreshStatus>;
};


/** Queries for grader performance */
export type GraderPerformanceQueriesQueryDashboardSessionSettingsArgs = {
  groupId: Scalars['ID'];
};


/** Queries for grader performance */
export type GraderPerformanceQueriesQueryGroupMetricsArgs = {
  groupId: Scalars['ID'];
};


/** Queries for grader performance */
export type GraderPerformanceQueriesQueryGroupMetricsRefreshStatusArgs = {
  groupId: Scalars['ID'];
};

/** Values representing column names of the grader performance dashboard */
export const GraderPerformance_DashboardColumn = {
  /** assignmentsContributedCount column */
  AssignmentsContributedCount: 'ASSIGNMENTS_CONTRIBUTED_COUNT',
  /** averageCommentLengthPerRubric column */
  AverageCommentLengthPerRubric: 'AVERAGE_COMMENT_LENGTH_PER_RUBRIC',
  /** averageGradePerRubric column */
  AverageGradePerRubric: 'AVERAGE_GRADE_PER_RUBRIC',
  /** averageTimePerRubric column */
  AverageTimePerRubric: 'AVERAGE_TIME_PER_RUBRIC',
  /** overwrittenRubricsCount column */
  OverwrittenRubricsCount: 'OVERWRITTEN_RUBRICS_COUNT',
  /** rubricsContributedCount column */
  RubricsContributedCount: 'RUBRICS_CONTRIBUTED_COUNT'
} as const;

export type GraderPerformance_DashboardColumn = typeof GraderPerformance_DashboardColumn[keyof typeof GraderPerformance_DashboardColumn];
/** Grader performance dashboard saved settings for a user */
export type GraderPerformance_DashboardSessionSettings = {
  __typename?: 'GraderPerformance_DashboardSessionSettings';
  /** List of graders' userIds that are bookmarked */
  bookmarkedGraderIds: Array<Scalars['ID']>;
  /** Columns to hide on the grader dashboard */
  hiddenColumns: Array<GraderPerformance_DashboardColumn>;
};

/** Grader performance metrics for a user */
export type GraderPerformance_GraderMetrics = {
  __typename?: 'GraderPerformance_GraderMetrics';
  /** Number of assignments with grading activities for a user */
  assignmentsContributedCount?: Maybe<Scalars['Int']>;
  /** Average comment length (word count) per rubric for a user */
  averageCommentLengthPerRubric?: Maybe<Scalars['Float']>;
  /** Average rubric grade as a percent(0.02 = 2%) (total grade / total rubrics graded) for a user */
  averageGradePerRubric?: Maybe<Scalars['Float']>;
  /** Average grading time per rubric (total grading time / total rubrics graded) for a user */
  averageTimePerRubric?: Maybe<Scalars['Duration']>;
  /** Number of overwritten rubrics for a user */
  overwrittenRubricsCount?: Maybe<Scalars['Int']>;
  /** Number of rubrics with grading contributions for a user */
  rubricsContributedCount?: Maybe<Scalars['Int']>;
  /** User profile */
  userProfile: GraderPerformance_UserProfile;
};

/**
 * Contains the summary, and list of metrics, along with refresh time of the grader performance
 * group metrics within a session
 */
export type GraderPerformance_GroupMetrics = {
  __typename?: 'GraderPerformance_GroupMetrics';
  /** List of grader performance metrics per grader */
  graderMetrics: Array<GraderPerformance_GraderMetrics>;
  /** Time the grader performance data is refreshed */
  lastRefreshedAt: Scalars['DateTime'];
  /** Summary of the grader performance metrics in a session */
  summary?: Maybe<GraderPerformance_GroupSummary>;
};

/** Status of if there are any ongoing refreshes of grader performance group metrics */
export type GraderPerformance_GroupMetricsRefreshStatus = {
  __typename?: 'GraderPerformance_GroupMetricsRefreshStatus';
  /** True if there is an ongoing refresh */
  isRefreshInProgress: Scalars['Boolean'];
  /** Time of the last refresh of group grader performance metrics */
  lastRefreshedAt?: Maybe<Scalars['DateTime']>;
};

/** Session level summary of grading performance */
export type GraderPerformance_GroupSummary = {
  __typename?: 'GraderPerformance_GroupSummary';
  /** Number of assignments graded for a session */
  assignmentsGradedCount?: Maybe<Scalars['Int']>;
  /** Average grade of all learners in a session */
  averageLearnerGrade?: Maybe<Scalars['Float']>;
  /** Number of deadline extensions granted in a session */
  extensionsGrantedCount?: Maybe<Scalars['Int']>;
  /** TODO: Need to clarify with Robert U */
  gradingTurnaroundTime?: Maybe<Scalars['Duration']>;
  /** Percentage of learners with late submissions in a session (0.02 = 2%) */
  percentLateSubmissions?: Maybe<Scalars['Float']>;
  /** Total number of assignments in a session */
  totalAssignmentsCount?: Maybe<Scalars['Int']>;
};

/** Input for GraderPerformance_RefreshGroupMetrics mutation. */
export type GraderPerformance_RefreshGroupMetricsInput = {
  /** The groupId */
  groupId: Scalars['ID'];
};

/** Enum for explaining why the refresh of the group grader performance was not triggered */
export const GraderPerformance_RefreshGroupMetricsNotTriggeredReason = {
  /**
   * We don't trigger the refresh for group grader performance metrics if there is already an
   * ongoing refresh
   */
  ExistingRefershInProgress: 'EXISTING_REFERSH_IN_PROGRESS'
} as const;

export type GraderPerformance_RefreshGroupMetricsNotTriggeredReason = typeof GraderPerformance_RefreshGroupMetricsNotTriggeredReason[keyof typeof GraderPerformance_RefreshGroupMetricsNotTriggeredReason];
/** Result for GraderPerformance_RefreshGroupMetrics mutation. */
export type GraderPerformance_RefreshGroupMetricsResult = {
  __typename?: 'GraderPerformance_RefreshGroupMetricsResult';
  /** The groupId */
  groupId: Scalars['ID'];
  /** True if the refresh is triggered */
  isRefreshTriggered: Scalars['Boolean'];
  /** Time of the last refresh of group grader performance metrics */
  lastRefreshedAt?: Maybe<Scalars['DateTime']>;
  /** Enum for explaining why the refresh of the group grader performance was not triggered */
  refreshNotTriggeredReason?: Maybe<Scalars['String']>;
};

/**
 * Input for GraderPerformance_SaveDashboardSessionSettings mutation.
 * It is expected to provide all the fields of the settings every time you call the mutation
 */
export type GraderPerformance_SaveDashboardSessionSettingsInput = {
  /**
   * List of graders' userIds that are bookmarked, the caller is expected to provide all fields of
   * the settings even if they only want to change a single value
   */
  bookmarkedGraderIds: Array<Scalars['ID']>;
  /** The groupId */
  groupId: Scalars['ID'];
  /**
   * Columns to hide on the grader dashboard, the caller is expected to provide all fields of
   * the settings even if they only want to change a single value
   */
  hiddenColumns: Array<GraderPerformance_DashboardColumn>;
};

/** Result for GraderPerformance_SaveDashboardSessionSettings mutation. */
export type GraderPerformance_SaveDashboardSessionSettingsResult = {
  __typename?: 'GraderPerformance_SaveDashboardSessionSettingsResult';
  /** Saved dashboard settings */
  dashboardSettings: GraderPerformance_DashboardSessionSettings;
  /** The groupId */
  groupId: Scalars['ID'];
};

/** Profile for an individual user */
export type GraderPerformance_UserProfile = {
  __typename?: 'GraderPerformance_UserProfile';
  /** User display name */
  displayName?: Maybe<Scalars['String']>;
  /** User id */
  id: Scalars['ID'];
};

/** Grades disclaimer queries */
export type GradesDisclaimerQueries = {
  __typename?: 'GradesDisclaimerQueries';
  /** Query by user and course id */
  queryByUserAndCourse: GradesDisclaimer_QueryByUserAndCourseResponse;
};


/** Grades disclaimer queries */
export type GradesDisclaimerQueriesQueryByUserAndCourseArgs = {
  input: GradesDisclaimer_QueryByUserAndCourseInput;
};

/** Input parameters for GradesDisclaimerQueries */
export type GradesDisclaimer_QueryByUserAndCourseInput = {
  /** The ID of the course for which the grades disclaimer is being fetched. */
  courseId: Scalars['ID'];
};

/** Returns whether the user should see a grades disclaimer for a given course */
export type GradesDisclaimer_QueryByUserAndCourseResponse = {
  __typename?: 'GradesDisclaimer_QueryByUserAndCourseResponse';
  /** Indicates whether the user should see a grades disclaimer banner for the given course */
  shouldShowGradesDisclaimer: Scalars['Boolean'];
};

/** Grading comments GraphQL queries */
export type GradingCommentsQueries = {
  __typename?: 'GradingCommentsQueries';
  /** This query returns a single comment for a comment id */
  queryComment?: Maybe<GradingComments_Comment>;
  /** This query returns all comments based on filter | Maximum page size: 100 */
  queryCommentsByFilter: GradingComments_CommentConnection;
  /** This query returns grader's comments | Maximum page size: 100 */
  queryOwnComments: GradingComments_CommentConnection;
};


/** Grading comments GraphQL queries */
export type GradingCommentsQueriesQueryCommentArgs = {
  id: Scalars['ID'];
};


/** Grading comments GraphQL queries */
export type GradingCommentsQueriesQueryCommentsByFilterArgs = {
  after?: InputMaybe<Scalars['String']>;
  commentFilter: GradingComments_CommentFilter;
  first?: InputMaybe<Scalars['Int']>;
};


/** Grading comments GraphQL queries */
export type GradingCommentsQueriesQueryOwnCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  commentFilter?: InputMaybe<GradingComments_CommentFilter>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Grading comments GraphQL schema */
export type GradingComments_Comment = Node & {
  __typename?: 'GradingComments_Comment';
  /** The comment content. */
  commentContent: GradingComments_CommentContent;
  /** The comment id. */
  id: Scalars['ID'];
  /** The comment aggregated usage metrics */
  usageMetrics: GradingComments_UsageMetrics;
  /** The user id. */
  userId: Scalars['ID'];
};

/** Represents a paginated collection of comments */
export type GradingComments_CommentConnection = {
  __typename?: 'GradingComments_CommentConnection';
  /** The paginated collection */
  edges: Array<GradingComments_CommentEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/**
 * GradingComments_CommentContent is a union for easier future extension to support other content
 * type, currently only be CmlContent.
 */
export type GradingComments_CommentContent = CmlContent;

/** Represents a single comment with its pagination cursor */
export type GradingComments_CommentEdge = {
  __typename?: 'GradingComments_CommentEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** The comment */
  node: GradingComments_Comment;
};

/** Comment filter for the GraphQL queries */
export type GradingComments_CommentFilter = {
  /** [Required] filters results to assignment id */
  assignmentId: Scalars['ID'];
  /**
   * [Deprecated] [Optional] filter results based on provided search text
   * @deprecated use partialCommentContent instead
   */
  partialComment?: InputMaybe<Scalars['String']>;
  /** [Optional] filter results based on provided partial CmlContent */
  partialCommentContent?: InputMaybe<CmlContentInput>;
  /** [Required] filters results to review part id */
  reviewPartId: Scalars['ID'];
};

/** Comment usage GraphQL schema */
export type GradingComments_CommentUsage = {
  __typename?: 'GradingComments_CommentUsage';
  /** The assignment id. */
  assignmentId: Scalars['ID'];
  /** The comment id. */
  commentId: Scalars['ID'];
  /** The comment usage id */
  id: Scalars['ID'];
  /** The review part id. */
  reviewPartId: Scalars['ID'];
  /** Last time that grader reuses comment. */
  usageTime: Timestamp;
};

/** Input of the GradingComments_CreateComment mutation */
export type GradingComments_CreateCommentInput = {
  /** [required] comment's assignment id */
  assignmentId: Scalars['ID'];
  /** [required] comment's assignment version */
  assignmentVersion: Scalars['Int'];
  /** [required] see CmlContentInput */
  commentContentInput: CmlContentInput;
  /** [required] comment's review part id */
  reviewPartId: Scalars['ID'];
};

/** Result of the GradingComments_CreateComment mutation */
export type GradingComments_CreateCommentResult = {
  __typename?: 'GradingComments_CreateCommentResult';
  /** Created reusable comment */
  comment: GradingComments_Comment;
};

/** Input of GradingComments_CreateCommentUsage mutation */
export type GradingComments_CreateCommentUsageInput = {
  /** [required] assignment id */
  assignmentId: Scalars['ID'];
  /** [required] assignment version */
  assignmentVersion: Scalars['Int'];
  /** [required] comment id */
  commentId: Scalars['ID'];
  /** [required] review part id */
  reviewPartId: Scalars['ID'];
};

/** Result of the GradingComments_CreateCommentUsage mutation */
export type GradingComments_CreateCommentUsageResult = {
  __typename?: 'GradingComments_CreateCommentUsageResult';
  /** Created reusable comment usage */
  commentUsage: GradingComments_CommentUsage;
};

/** Input of the GradingComments_DeleteComment mutation */
export type GradingComments_DeleteCommentInput = {
  /** [required] comment id */
  commentId: Scalars['ID'];
};

/** Result of the GradingComments_DeleteComment mutation */
export type GradingComments_DeleteCommentResult = {
  __typename?: 'GradingComments_DeleteCommentResult';
  /** Id of deleted reusable comment */
  id: Scalars['ID'];
};

/** Failure of Deleting comment usages. */
export type GradingComments_DeleteCommentUsagesFailure = {
  __typename?: 'GradingComments_DeleteCommentUsagesFailure';
  /** Delete comment usages failure. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input of the GradingComments_DeleteCommentUsages mutation */
export type GradingComments_DeleteCommentUsagesInput = {
  /** [required] comment's assignment id */
  assignmentId: Scalars['ID'];
  /** [required] comment id */
  commentId: Scalars['ID'];
  /** [required] comment's review part id */
  reviewPartId: Scalars['ID'];
};

/** Result of the GradingComments_DeleteCommentUsages mutation */
export type GradingComments_DeleteCommentUsagesResult = GradingComments_DeleteCommentUsagesFailure | GradingComments_DeleteCommentUsagesSuccess;

/** Success of Deleting comment usages. */
export type GradingComments_DeleteCommentUsagesSuccess = {
  __typename?: 'GradingComments_DeleteCommentUsagesSuccess';
  /** field indicating if comment usages were deleted successfully. */
  success: Scalars['Boolean'];
};

/** Input of the GradingComments_UpdateComment mutation */
export type GradingComments_UpdateCommentInput = {
  /** [required] see CmlContentInput */
  commentContentInput: CmlContentInput;
  /** [required] comment id */
  commentId: Scalars['ID'];
};

/** Result of the GradingComments_UpdateComment mutation */
export type GradingComments_UpdateCommentResult = {
  __typename?: 'GradingComments_UpdateCommentResult';
  /** Updated reusable comment */
  comment: GradingComments_Comment;
};

/** Usage metrics of each comment */
export type GradingComments_UsageMetrics = {
  __typename?: 'GradingComments_UsageMetrics';
  /** The Comment Id */
  id: Scalars['ID'];
  /** Comment last used time */
  lastUsedAt: Timestamp;
  /** Comment usage count */
  usageCount: Scalars['Int'];
};

/** Overall grading status */
export const Grading_Status = {
  /** All grading activities are finished */
  Graded: 'GRADED',
  /** Human/AI Grading has started but it incomplete */
  Grading: 'GRADING',
  /** Grading has not started yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Grading_Status = typeof Grading_Status[keyof typeof Grading_Status];
/** TODO: Complete this description */
export type GroupGradingQueries = {
  __typename?: 'GroupGradingQueries';
  /**
   * This query returns info of the default submitter to be displayed when loading grader UI of
   * given group and item without selecting any submitter beforehand.
   */
  queryDefaultSubmitter?: Maybe<GroupGrading_DefaultSubmitter>;
  /** Returns a task containing all information required to render the grading UI and perform grading. */
  queryGradingTask?: Maybe<GroupGrading_GradingTaskV2>;
  /** This query returns all a single group for a group id. */
  queryGroup?: Maybe<GroupGrading_Group>;
  /**
   * This query returns specific submission. If no submissionId is provided, the latest submission
   * is returned.
   * @deprecated deleted API
   */
  querySubmission?: Maybe<GroupGrading_SgaSubmission>;
  /**
   * This query returns specific submission attempt. If no `submissionAttemptId` is provided, the
   * latest submission attempt is returned.
   */
  querySubmissionAttempt?: Maybe<GroupGrading_SgaSubmission>;
  /**
   * This query returns specific submission attempt. If no `submissionAttemptId` is provided, the
   * latest submission attempt is returned.
   */
  querySubmissionAttemptV2?: Maybe<GroupGrading_SgaSubmission>;
  /** Returns a list of submission attempts the learner made for the specific item. */
  querySubmissionHeaders: Array<GroupGrading_SgaSubmissionHeader>;
};


/** TODO: Complete this description */
export type GroupGradingQueriesQueryDefaultSubmitterArgs = {
  groupId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGradingQueriesQueryGradingTaskArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  scopedSubmitterId: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGradingQueriesQueryGroupArgs = {
  id: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGradingQueriesQuerySubmissionArgs = {
  groupId: Scalars['ID'];
  itemId: Scalars['ID'];
  submissionId?: InputMaybe<Scalars['ID']>;
  submitterId: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGradingQueriesQuerySubmissionAttemptArgs = {
  groupId: Scalars['ID'];
  itemId: Scalars['ID'];
  submissionAttemptId?: InputMaybe<Scalars['ID']>;
  submitterId: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGradingQueriesQuerySubmissionAttemptV2Args = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  scopedSubmitterId: Scalars['ID'];
  submissionAttemptId?: InputMaybe<Scalars['ID']>;
};


/** TODO: Complete this description */
export type GroupGradingQueriesQuerySubmissionHeadersArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  scopedSubmitterId: Scalars['ID'];
};

/** Input for GroupGrading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideInput = {
  /** Comment to be surfaced to learners for the grade override. */
  explanation?: InputMaybe<Scalars['String']>;
  /** Grade of the override. */
  grade: Scalars['Float'];
  /** Comment to be surfaced to partners for the grade override. */
  partnerExplanation?: InputMaybe<Scalars['String']>;
  /**
   * Parameters for locating the submitter's assignment to apply a grade override: {groupId, itemId,
   * submitterId} (can be single user or team)
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Result for GroupGrading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideResult = {
  __typename?: 'GroupGrading_ApplyGradeOverrideResult';
  /** Live grade data for the submitter's item grade. */
  liveOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Original grade data for submitter's item grade. */
  originalOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Overrides applied to the submitter's item grade. */
  overrideOutcome?: Maybe<GroupGrading_ItemOutcomeOverride>;
  /** Mirrors the submissionReference in the input. */
  submissionReference: GroupGrading_SubmissionReferenceOutput;
};

/** Input for Grading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideV2Input = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** Comment to be surfaced to learners for the grade override. */
  explanation?: InputMaybe<Scalars['String']>;
  /**
   * Grade of the override.
   * The value is in range 0-1 for grades 0%-100%. The grade may be higher if extra credit is applied.
   */
  grade: Scalars['Float'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** Comment to be surfaced to partners for the grade override. */
  partnerExplanation?: InputMaybe<Scalars['String']>;
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** Result for Grading_ApplyGradeOverride mutation. */
export type GroupGrading_ApplyGradeOverrideV2Result = {
  __typename?: 'GroupGrading_ApplyGradeOverrideV2Result';
  /** The course id. */
  courseId: Scalars['ID'];
  /**
   * Contains information for the item's latest grades for the submitter, grade overrides,
   * and grade visibility.
   * * Note: For team submissions, the gradebookEntry is the data we fetch from the first user on
   * the team *
   */
  gradebookEntry: GroupGrading_SubmitterGradebookEntry;
  /** The item id. */
  itemId: Scalars['ID'];
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** Assignment Review part */
export type GroupGrading_AssignmentReviewPart = GroupGrading_ReviewPart & {
  __typename?: 'GroupGrading_AssignmentReviewPart';
  /** [inherited] see parent GroupGrading_ReviewPart */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /** [inherited] see parent GroupGrading_ReviewPart */
  formElementNodeId: Scalars['ID'];
  /** [inherited] see parent GroupGrading_ReviewPart */
  position: Scalars['Int'];
};

/** Input for GroupGrading_BatchUpdateGradeVisibility mutation. */
export type GroupGrading_BatchUpdateGradeVisibilityInput = {
  /**
   * How to handle existing grade override and grade visibility drafts, will default to publishing
   * existing drafts like legacy behaviour in grading list view.
   */
  draftAction?: InputMaybe<GroupGrading_GradeVisibilityAndOverrideDraftAction>;
  /** groupId of top-level group for the private session. */
  groupId: Scalars['ID'];
  /** Whether to hide the grade or not. */
  isHidden: Scalars['Boolean'];
  /** itemId */
  itemId: Scalars['ID'];
  /** List of submitterId (can be user~[userId] or team~[teamId]). */
  submitterIds: Array<Scalars['ID']>;
};

/** Result for GroupGrading_BatchUpdateGradeVisibility mutation. */
export type GroupGrading_BatchUpdateGradeVisibilityResult = {
  __typename?: 'GroupGrading_BatchUpdateGradeVisibilityResult';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** [DEPRECATED] Input for GroupGrading_BatchUpdateReviewPartResponse mutation. */
export type GroupGrading_BatchUpdateReviewPartResponseInput = {
  /** List of choices updates for review part response. */
  choicesUpdates: Array<GroupGrading_ReviewPartResponseChoicesUpdate>;
  /** List of comment updates for review part response. */
  commentUpdates: Array<GroupGrading_ReviewPartResponseCommentUpdate>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** List of score updates for review part response. */
  scoreUpdates: Array<GroupGrading_ReviewPartResponseScoreUpdate>;
};

/**
 * [DEPRECATED] Result for GroupGrading_BatchUpdateReviewPartResponse mutation.
 *
 * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
 */
export type GroupGrading_BatchUpdateReviewPartResponseResult = {
  __typename?: 'GroupGrading_BatchUpdateReviewPartResponseResult';
  /**
   * Always true. GraphQL types can't be empty so we need to add some dummy field.
   * @deprecated deleted API
   */
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Used to bach update all of the rubric part responses at the same time. Note that this is organized
 * by rubric part response type instead of by rubric part form field. It also includes some additional
 * data that allows us to save an extra request to the "assignment" service in the BE.
 */
export type GroupGrading_BatchUpdateReviewPartResponsesInput = {
  /** Actions currently allowed by the BE in relation to current submission / grading state */
  allowedGradingActions: Array<GroupGrading_GradingStepActionType>;
  /** Collection of "inline feedback" review part responses */
  boxResponses: Array<GroupGrading_BoxReviewPartResponseInput>;
  /**
   * [Optional]. Conflict metadata previously fetched from sgaSubmission. The "correct" value may be
   * null
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Used to identify current grading task for submission */
  gradingTaskIdHash: Scalars['String'];
  /**
   * FE will compute if all rubric parts are complete.
   * If true, BE may combine step actions (i.e. update and submit) for performance boost.
   * If absent, it will be assumed to be false.
   */
  isRubricComplete?: InputMaybe<Scalars['Boolean']>;
  /** Collection of "multiLine" review part responses, question- and assignment-level */
  multiLineResponses: Array<GroupGrading_MultiLineInputReviewPartResponseInput>;
  /** Collection of "options" review part responses, question- and assignment-level */
  optionsResponses: Array<GroupGrading_OptionsReviewPartResponseInput>;
  /** Parameters for locating latest submission: {groupId, itemId, submitterId} */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Result for GroupGrading_BatchUpdateReviewPartResponse */
export type GroupGrading_BatchUpdateReviewPartResponsesResult = {
  __typename?: 'GroupGrading_BatchUpdateReviewPartResponsesResult';
  /** Contains submission and grading data */
  sgaSubmission: GroupGrading_SgaSubmission;
  /** Mirrors the submissionReference in the input. */
  submissionReference: GroupGrading_SubmissionReferenceOutput;
};

/** Input type for "inline feedback" rubric part responses */
export type GroupGrading_BoxReviewPartResponseInput = {
  /** indicates whether they are "done" with adding inline feedback or not. */
  annotationComplete: Scalars['Boolean'];
  /** to add comment */
  fileId: Scalars['String'];
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
};

/** TODO: Complete this description */
export type GroupGrading_CompoundLatePenaltyRatio = GroupGrading_LatePenaltyRatio & {
  __typename?: 'GroupGrading_CompoundLatePenaltyRatio';
  /** [inherited] see parent GroupGrading_LatePenaltyRatio. */
  ratio?: Maybe<Scalars['Float']>;
};

/** Representing the submitter to display in Quick Grader's initial loading */
export type GroupGrading_DefaultSubmitter = {
  __typename?: 'GroupGrading_DefaultSubmitter';
  /** will represent either a userId or teamId */
  submitterId: Scalars['ID'];
};

/** Input for GroupGrading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideInput = {
  /**
   * Parameters for locating the submitter's assignment to delete a grade override: {groupId, itemId,
   * submitterId}
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Result for GroupGrading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideResult = {
  __typename?: 'GroupGrading_DeleteGradeOverrideResult';
  /** Live grade data for the submitter's item grade. */
  liveOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Original grade data for submitter's item grade. */
  originalOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Overrides applied to the submitter's item grade. */
  overrideOutcome?: Maybe<GroupGrading_ItemOutcomeOverride>;
  /** Mirrors the submissionReference in the input. */
  submissionReference: GroupGrading_SubmissionReferenceOutput;
};

/** Input for Grading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideV2Input = {
  /** The course id. */
  courseId: Scalars['ID'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** Result for Grading_DeleteGradeOverride mutation. */
export type GroupGrading_DeleteGradeOverrideV2Result = {
  __typename?: 'GroupGrading_DeleteGradeOverrideV2Result';
  /** The course id. */
  courseId: Scalars['ID'];
  /**
   * Contains information for the item's latest grades for the submitter, grade overrides,
   * and grade visibility.
   * * Note: For team submissions, the gradebookEntry is the data we fetch from the first user on
   * the team *
   */
  gradebookEntry: GroupGrading_SubmitterGradebookEntry;
  /** The item id. */
  itemId: Scalars['ID'];
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
};

/** TODO: Complete this description */
export type GroupGrading_FixedLatePenaltyRatio = GroupGrading_LatePenaltyRatio & {
  __typename?: 'GroupGrading_FixedLatePenaltyRatio';
  /** [inherited] see parent GroupGrading_LatePenaltyRatio. */
  ratio?: Maybe<Scalars['Float']>;
};

/** Possible actions for grade override and grade visibility drafts. */
export const GroupGrading_GradeVisibilityAndOverrideDraftAction = {
  /** Discard any existing drafts for grade overrides and grade visibility. */
  DiscardExistingDrafts: 'DISCARD_EXISTING_DRAFTS',
  /**
   * Publish any existing drafts for grade overrides and grade visibility, like legacy behaviour in
   * grading list view's batch hide/unhide grades.
   */
  PublishExistingDrafts: 'PUBLISH_EXISTING_DRAFTS'
} as const;

export type GroupGrading_GradeVisibilityAndOverrideDraftAction = typeof GroupGrading_GradeVisibilityAndOverrideDraftAction[keyof typeof GroupGrading_GradeVisibilityAndOverrideDraftAction];
/** TODO: Complete this description */
export type GroupGrading_GradingAction = {
  __typename?: 'GroupGrading_GradingAction';
  /** time at which the grading action is performed */
  actionTime: Timestamp;
  /** full name of the user that performed the grading action */
  fullName?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type GroupGrading_GradingStatusCount = {
  __typename?: 'GroupGrading_GradingStatusCount';
  /** Count of submissions in this status */
  count: Scalars['Int'];
  /** Submission status enum */
  status: GroupGrading_SgaSubmissionStatus;
};

/** TODO: Complete this description */
export type GroupGrading_GradingStatusSummary = {
  __typename?: 'GroupGrading_GradingStatusSummary';
  /** Counts of submissions by statuses */
  statusCounts: Array<GroupGrading_GradingStatusCount>;
  /** Total count of submissions */
  total: Scalars['Int'];
};

/** This is data needed by the BE to successfully save the data */
export type GroupGrading_GradingStepActionMetadata = {
  __typename?: 'GroupGrading_GradingStepActionMetadata';
  /** List of actions that are currently allowed based on state of submission grading */
  allowedGradingActions?: Maybe<Array<GroupGrading_GradingStepActionType>>;
  /** Updated every time rubric responses are saved or submitted (i.e. grades are released) */
  conflictMetadata?: Maybe<Scalars['String']>;
  /** Opaque indicator of a particular grading task */
  gradingTaskIdHash?: Maybe<Scalars['String']>;
  /** Opaque id. Will likely be hash of [typeName]~groupId~itemId~submitterId */
  id: Scalars['ID'];
};

/** Subset of org.coursera.assignment.StepActionType used in grading flow */
export const GroupGrading_GradingStepActionType = {
  /** Allows someone to start grading (and send initial responses) */
  StartDraft: 'START_DRAFT',
  /** Allows someone to start and submit responses to gradebook */
  StartUpdateAndSubmitDraft: 'START_UPDATE_AND_SUBMIT_DRAFT',
  /** Allows someone to submit previously saved responses to gradebook */
  SubmitLatestDraft: 'SUBMIT_LATEST_DRAFT',
  /** Allows someone to save new responses and submit to gradebook */
  UpdateAndSubmitDraft: 'UPDATE_AND_SUBMIT_DRAFT',
  /** Allows someone to save new responses */
  UpdateDraft: 'UPDATE_DRAFT'
} as const;

export type GroupGrading_GradingStepActionType = typeof GroupGrading_GradingStepActionType[keyof typeof GroupGrading_GradingStepActionType];
/** TODO: Complete this description */
export type GroupGrading_GradingTask = {
  __typename?: 'GroupGrading_GradingTask';
  /**
   * Contains information for the item's latest grades for the submitter, grade overrides,
   * and grade visibility.
   * * Note: For team submissions, the gradebookEntry is the data we fetch from the first user on
   * the team *
   */
  gradebookEntry: GroupGrading_SubmitterGradebookEntry;
  /** The group id. */
  groupId: Scalars['ID'];
  /** Whether this submitter's submission has been graded. */
  isSubmissionGraded: Scalars['Boolean'];
  /** The item id. */
  itemId: Scalars['ID'];
  /**
   * Always points to what is or will be the latest submission. This should always be present
   * for SGA submissions, but empty for non-SGA submissions.
   */
  latestSubmission?: Maybe<GroupGrading_SgaSubmission>;
  /** Summary info of the latest submission. */
  latestSubmissionSummary?: Maybe<GroupGrading_SgaSubmissionSummary>;
  /**
   * Submission deadline for the current submitter on the current item. This is the final deadline
   * that takes potential individual overrides into account.
   */
  submissionDeadline: Timestamp;
  /** [deprecated] references to all submissions by submitter */
  submissionHeaders: Array<Maybe<GroupGrading_SgaSubmissionHeader>>;
  /** submitting user or team (if a team assignment) */
  submitter: GroupGrading_Submitter;
  /** will represent either a userId or teamId */
  submitterId: Scalars['ID'];
};


/** TODO: Complete this description */
export type GroupGrading_GradingTaskSubmissionHeadersArgs = {
  filter?: InputMaybe<GroupGrading_SgaSubmissionHeaderFilter>;
};

/** TODO: Complete this description */
export type GroupGrading_GradingTaskFilter = {
  /** task must be for one of these submitters */
  submitterIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Paginated list of grading tasks (submitters) associated with the item. */
export type GroupGrading_GradingTaskPaginatedResult = {
  __typename?: 'GroupGrading_GradingTaskPaginatedResult';
  /** Grading task (submitter) list. */
  elements: Array<GroupGrading_GradingTask>;
  /** Pagination. */
  pagination: Pagination;
};

/** The wrapper type contains all information required to render the grading UI and perform grading. */
export type GroupGrading_GradingTaskV2 = {
  __typename?: 'GroupGrading_GradingTaskV2';
  /** The course branch id. */
  courseBranchId: Scalars['ID'];
  /** The course id. */
  courseId: Scalars['ID'];
  /**
   * Contains information for the item's latest grades for the submitter, grade overrides,
   * and grade visibility.
   * * Note: For team submissions, the gradebookEntry is the data we fetch from the first user on
   * the team *
   */
  gradebookEntry: GroupGrading_SubmitterGradebookEntry;
  /** The unique grading task id. Likely to be composite/hash of courseId~courseBranchId~itemId. */
  id: Scalars['ID'];
  /** Whether this submitter's submission has been graded. */
  isSubmissionGraded: Scalars['Boolean'];
  /** The item. */
  item: GroupGrading_ItemV2;
  /** Summary info of the latest submission. */
  latestSubmission: GroupGrading_SgaSubmission;
  /** The scoped submitter id. Either `user~12345` or `team~PRIVATE_GROUP!!~groupId!~teamId". */
  scopedSubmitterId: Scalars['ID'];
  /**
   * Submission deadline for the current submitter on the current item. This is the final deadline
   * that takes potential individual overrides into account.
   */
  submissionDeadline: Scalars['DateTime'];
  /** submitting user or team (if a team assignment) */
  submitter: GroupGrading_Submitter;
};

/** TODO: Complete this description */
export type GroupGrading_Group = {
  __typename?: 'GroupGrading_Group';
  /** The course branch id. */
  branchId: Scalars['ID'];
  /** The primary private group associated with a particular course session. */
  groupId: Scalars['ID'];
  /** This query returns all the items associated with a given group. */
  items: Array<GroupGrading_Item>;
};


/** TODO: Complete this description */
export type GroupGrading_GroupItemsArgs = {
  itemFilter?: InputMaybe<GroupGrading_ItemFilter>;
};

/** TODO: Complete this description */
export type GroupGrading_IncrementalLatePenaltyRatio = GroupGrading_LatePenaltyRatio & {
  __typename?: 'GroupGrading_IncrementalLatePenaltyRatio';
  /** [inherited] see parent GroupGrading_LatePenaltyRatio. */
  ratio?: Maybe<Scalars['Float']>;
};

/** TODO: Complete this description */
export type GroupGrading_Item = {
  __typename?: 'GroupGrading_Item';
  /** Summary of grading status of submissions associated with the item */
  gradingStatusSummary: GroupGrading_GradingStatusSummary;
  /**
   * List of submitters associated with the item
   * @deprecated Use paginatedGradingTasks instead.
   */
  gradingTasks: Array<GroupGrading_GradingTask>;
  /** The group id. */
  groupId: Scalars['ID'];
  /** Whether the item has anonymous grading enabled. */
  hasAnonymousGrading: Scalars['Boolean'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** The name of the item. */
  name: Scalars['String'];
  /** Paginated list of grading tasks (submitters) associated with the item. */
  paginatedGradingTasks: GroupGrading_GradingTaskPaginatedResult;
  /** The type of the item. */
  type: GroupGrading_ItemType;
};


/** TODO: Complete this description */
export type GroupGrading_ItemGradingTasksArgs = {
  filter?: InputMaybe<GroupGrading_GradingTaskFilter>;
};


/** TODO: Complete this description */
export type GroupGrading_ItemPaginatedGradingTasksArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GroupGrading_GradingTaskFilter>;
  limit: Scalars['Int'];
};

/** TODO: Complete this description */
export type GroupGrading_ItemFilter = {
  /** If provided, filters results to item ids. */
  itemIds?: InputMaybe<Array<Scalars['ID']>>;
  /** If provided, filters results to itemTypes. */
  itemTypes?: InputMaybe<Array<GroupGrading_ItemType>>;
};

/** TODO: Complete this description */
export type GroupGrading_ItemOutcome = {
  __typename?: 'GroupGrading_ItemOutcome';
  /** Grade of the item. */
  grade: Scalars['Float'];
  /** Passing status of the item. */
  isPassed: Scalars['Boolean'];
  /** Late penalty applied to the assignment's grade */
  latePenaltyRatio?: Maybe<GroupGrading_CompoundLatePenaltyRatio | GroupGrading_FixedLatePenaltyRatio | GroupGrading_IncrementalLatePenaltyRatio>;
};

/** TODO: Complete this description */
export type GroupGrading_ItemOutcomeOverride = {
  __typename?: 'GroupGrading_ItemOutcomeOverride';
  /** Comment to be surfaced to learners for the grade override. */
  explanation?: Maybe<Scalars['String']>;
  /** Grade of the item. */
  grade: Scalars['Float'];
  /** Passing status of the item. */
  isPassed: Scalars['Boolean'];
  /** Instant at when this item's grade was overrided. */
  overriddenAt: Timestamp;
  /** UserId of the person who overrided the grade for this item. */
  overriderId: Scalars['ID'];
  /** Comment to be surfaced to partners for the grade override. */
  partnerExplanation?: Maybe<Scalars['String']>;
};

/**
 * Possible types of an item, corresponding to the type names in
 * org.coursera.ondemand.coursematerial.stored.StoredContent, but not comprehensive, only containing
 * types that are relevant in the context of group grading.
 */
export const GroupGrading_ItemType = {
  /** TODO: Complete this description */
  StaffGradedAssignment: 'STAFF_GRADED_ASSIGNMENT',
  /** TODO: Complete this description */
  Unknown: 'UNKNOWN'
} as const;

export type GroupGrading_ItemType = typeof GroupGrading_ItemType[keyof typeof GroupGrading_ItemType];
/** The course branch item details. */
export type GroupGrading_ItemV2 = {
  __typename?: 'GroupGrading_ItemV2';
  /** The course branch id. */
  courseBranchId: Scalars['ID'];
  /** The course id. */
  courseId: Scalars['ID'];
  /** Whether the item has anonymous grading enabled. */
  hasAnonymousGrading: Scalars['Boolean'];
  /** The unique item id. Likely to be a composite/hash of courseId~courseBranchId~itemId. */
  id: Scalars['ID'];
  /** The item id. */
  itemId: Scalars['ID'];
  /** The name of the item. */
  name: Scalars['String'];
};

/** TODO: Complete this description */
export type GroupGrading_LatePenaltyRatio = {
  /** Late penalty as a decimal <= 1. */
  ratio?: Maybe<Scalars['Float']>;
};

/** Input type for "multiLine" rubric part responses */
export type GroupGrading_MultiLineInputReviewPartResponseInput = {
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: InputMaybe<Scalars['ID']>;
  /** Text representing grader comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Type of grader for this review response */
  graderType?: AssignmentPresentations_GraderType;
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
  /**
   * Rich text representing grader comment.
   * This field is replacing plain text comment field.
   */
  richTextComment?: InputMaybe<CmlContentInput>;
  /** Score provided by grader. */
  score?: InputMaybe<Scalars['Float']>;
};

/** Input type for "options" rubric part responses */
export type GroupGrading_OptionsReviewPartResponseInput = {
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: InputMaybe<Scalars['ID']>;
  /** Represents selected choices. May be empty if none chosen. */
  choices: Array<Scalars['String']>;
  /** Type of grader for this review response */
  graderType?: AssignmentPresentations_GraderType;
  /** Example: “reviewResponseId~b57f9bad-a4c7-40c7-8e77-57cf6e7b9753” */
  responseId: Scalars['String'];
  /** [optional] rich text input */
  richTextInput?: InputMaybe<CmlContentInput>;
};

/** [DEPRECATED] Input for GroupGrading_PublishGradesToGradeBook mutation. */
export type GroupGrading_PublishGradesToGradeBookInput = {
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   *
   * responses and reviewConflictMetadata must be re-fetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/**
 * [DEPRECATED] Result for GroupGrading_PublishGradesToGradeBook mutation.
 *
 * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
 */
export type GroupGrading_PublishGradesToGradeBookResult = {
  __typename?: 'GroupGrading_PublishGradesToGradeBookResult';
  /**
   * Return latest sga submission to avoid a follow-up request.
   * @deprecated deleted API
   */
  sgaSubmission: GroupGrading_SgaSubmission;
  /**
   * Assuming the update is successful, then you should have the latest state so returning the
   * conflictMetadata here is acceptable. Errors will be communicated via GraphQl "errors".
   * @deprecated deleted API
   */
  success?: Maybe<Scalars['Boolean']>;
};

/** TODO: Complete this description */
export type GroupGrading_Question = {
  /** represents individual question and question responses (FormElementNode.courier) */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /**
   * identifier for form element in presentation (FormElementId.courier).
   * contains questionId for question form elements. we may want to surface questionId
   * separately.
   */
  formElementNodeId: Scalars['ID'];
  /** one-indexed value representing position in list */
  position: Scalars['Int'];
};

/** Auto graded question model. */
export type GroupGrading_QuestionAutoGraded = GroupGrading_Question & {
  __typename?: 'GroupGrading_QuestionAutoGraded';
  /** [inherited] see parent GroupGrading_Question */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /** [inherited] see parent GroupGrading_Question */
  formElementNodeId: Scalars['ID'];
  /** [inherited] see parent GroupGrading_Question */
  position: Scalars['Int'];
};

/** Manually graded question model */
export type GroupGrading_QuestionManuallyGraded = GroupGrading_Question & {
  __typename?: 'GroupGrading_QuestionManuallyGraded';
  /** [inherited] see parent GroupGrading_Question */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /** [inherited] see parent GroupGrading_Question */
  formElementNodeId: Scalars['ID'];
  /** question level grader instructions. */
  graderInstructions?: Maybe<AssignmentPresentations_ContentCmlContent>;
  /** [inherited] see parent GroupGrading_Question */
  position: Scalars['Int'];
  /** list of question level review parts. */
  questionReviewParts?: Maybe<Array<GroupGrading_QuestionReviewPart>>;
};

/** Question Review part */
export type GroupGrading_QuestionReviewPart = GroupGrading_ReviewPart & {
  __typename?: 'GroupGrading_QuestionReviewPart';
  /** [inherited] see parent GroupGrading_ReviewPart */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /** [inherited] see parent GroupGrading_ReviewPart */
  formElementNodeId: Scalars['ID'];
  /** [inherited] see parent GroupGrading_ReviewPart */
  position: Scalars['Int'];
};

/** Review part. */
export type GroupGrading_ReviewPart = {
  /** represents individual review part and review responses (FormElementNode.courier) */
  formElementNode?: Maybe<AssignmentPresentations_FormElementNode>;
  /**
   * identifier for form element in presentation (FormElementId.courier).
   * contains reviewPartId for review part form elements.
   */
  formElementNodeId: Scalars['ID'];
  /** one-indexed value representing position in list */
  position: Scalars['Int'];
};

/**
 * [DEPRECATED] Modeled after the result of
 * https://github.com/webedx-spark/web/blob/7549fae8c6553fe2c7a19848dfffee242d667cf7/static/bundles/author-assignment-grading/components/staff-graded-projects/components/submissionView/SGASubmissionRightSidebar.tsx#L102-L105
 */
export type GroupGrading_ReviewPartCompletionProgress = {
  __typename?: 'GroupGrading_ReviewPartCompletionProgress';
  /** If all review parts are completed. */
  areRubricsComplete: Scalars['Boolean'];
  /** Count of completed review parts */
  completedParts: Scalars['Int'];
  /** Count of total review parts */
  totalParts: Scalars['Int'];
};

/** [DEPRECATED] Choices update for review part response. */
export type GroupGrading_ReviewPartResponseChoicesUpdate = {
  /**
   * The list may be empty if no choices are selected. Or if multiple choices are
   * selected, they all need to be present in this list.
   */
  choices: Array<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Comment update for review part response. */
export type GroupGrading_ReviewPartResponseCommentUpdate = {
  /** [optional] plain text comment. sending no value will unset the comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** [DEPRECATED] Score update for review part response. */
export type GroupGrading_ReviewPartResponseScoreUpdate = {
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** [optional] integer or decimal values >= 0. sending no value will unset the score. */
  score?: InputMaybe<Scalars['Float']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** TODO: Complete this description */
export type GroupGrading_SgaSubmission = {
  __typename?: 'GroupGrading_SgaSubmission';
  /** list of assignment level review parts */
  assignmentReviewParts?: Maybe<Array<GroupGrading_AssignmentReviewPart>>;
  /** [Optional] Grader instructions. */
  graderInstructions?: Maybe<AssignmentPresentations_ContentCmlContent>;
  /**
   * [Optional] This is data needed by the BE to successfully save the response data. It's a bit of a
   * hack to include it in this model, but including it here allows the FE to return it to the BE via
   * the mutation request body which saves us from needing to make an expensive round-trip request on
   * the BE to fetch this data.
   */
  gradingStepActionMetadata?: Maybe<GroupGrading_GradingStepActionMetadata>;
  /** Opaque id. Will likely be hash of [typeName]~groupId~itemId~submitterId */
  id: Scalars['ID'];
  /**
   * contains time and user for the latest action made to the rubric parts, grade overrides, or
   * grade visibility
   */
  lastGradingAction?: Maybe<GroupGrading_GradingAction>;
  /** the max possible score for an assignment */
  maxScore?: Maybe<Scalars['Float']>;
  /** list of questions, not present if not submitted yet */
  questions?: Maybe<Array<GroupGrading_QuestionAutoGraded | GroupGrading_QuestionManuallyGraded>>;
  /**
   * the score for an assignment calculated by adding up the total number of points gotten for each
   * assignment part
   */
  rawScore?: Maybe<Scalars['Float']>;
  /**
   * [Optional] Must be included with each review part mutation. Will change after each request as
   * well. Ensures that a grader is making changes against the latest state.
   * [Deprecated]. Use conflict metadata in stepActionMetadata instead.
   */
  reviewConflictMetadata?: Maybe<Scalars['String']>;
  /** current submission status */
  status: GroupGrading_SgaSubmissionStatus;
  /**
   * [Optional] Submission attempt id - similar to `submissionAttempt~1Aa2Bb3Cc4Dd`. Present if SGA
   * was submitted, otherwise empty.
   */
  submissionAttemptId?: Maybe<Scalars['ID']>;
  /** submission time, empty if not submitted yet */
  submittedAt?: Maybe<Timestamp>;
};

/** TODO: Complete this description */
export type GroupGrading_SgaSubmissionHeader = {
  __typename?: 'GroupGrading_SgaSubmissionHeader';
  /** represents attempt count */
  attemptNumber: Scalars['Int'];
  /**
   * [DEPRECATED] execution id (full execution id including the `submissionAttempt~` prefix for SGA)
   * @deprecated replaced
   */
  executionId: Scalars['String'];
  /** opaque id (full execution id including the `submissionAttempt~` prefix for SGA) */
  id: Scalars['ID'];
  /** when learner start submission */
  startedAt?: Maybe<Timestamp>;
  /**
   * The submission attempt id - similar to `submissionAttempt~1Aa2Bb3Cc4Dd`.
   * TODO: Change to ID! when there's a better process for handling breaking changes.
   */
  submissionAttemptId: Scalars['String'];
  /** submission id (executionId without the `submissionAttempt~` prefix for SGA) */
  submissionId: Scalars['String'];
  /** represents submission count */
  submissionNumber: Scalars['Int'];
  /** when learner completed submitted */
  submittedAt?: Maybe<Timestamp>;
};

/** TODO: Complete this description */
export type GroupGrading_SgaSubmissionHeaderFilter = {
  /** submission must match one of the following ids */
  submissionIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** possible statuses of item submission, equivalent to org.coursera.ondemand.staffgraded.submission.SubmissionStatus */
export const GroupGrading_SgaSubmissionStatus = {
  /** TODO: Complete this description */
  AwaitingPeerReview: 'AWAITING_PEER_REVIEW',
  /** TODO: Complete this description */
  Deleted: 'DELETED',
  /** TODO: Complete this description */
  GradeReleased: 'GRADE_RELEASED',
  /** TODO: Complete this description */
  GradingFinished: 'GRADING_FINISHED',
  /** TODO: Complete this description */
  GradingStarted: 'GRADING_STARTED',
  /** TODO: Complete this description */
  NotStarted: 'NOT_STARTED',
  /** TODO: Complete this description */
  NotYetSubmitted: 'NOT_YET_SUBMITTED',
  /** TODO: Complete this description */
  ReadyForGrading: 'READY_FOR_GRADING'
} as const;

export type GroupGrading_SgaSubmissionStatus = typeof GroupGrading_SgaSubmissionStatus[keyof typeof GroupGrading_SgaSubmissionStatus];
/** Submission summary data in contrast to detailed data which includes questions, reviews etc. */
export type GroupGrading_SgaSubmissionSummary = {
  __typename?: 'GroupGrading_SgaSubmissionSummary';
  /** current submission status */
  status: GroupGrading_SgaSubmissionStatus;
  /** submission time, empty if not submitted yet */
  submittedAt?: Maybe<Timestamp>;
};

/**
 * These are a set of ids (groupId, itemId, and submitterId) that allow us to locate the latest
 * individual assignment submission for a learner. It would be ideal if we could use a single
 * submission id or attempt id, but the assignment system doesn't present that option (a consequence
 * of "off-platform" only submissions). The original API used (userId, courseId, itemId) for these
 * query parameters.  I decided to change to (groupId, itemId, and submitterId) as this is more
 * aligned with our group and submitter-oriented graphql query design.
 */
export type GroupGrading_SubmissionReference = {
  /** groupId of top-level group for the private session. */
  groupId: Scalars['ID'];
  /** itemId */
  itemId: Scalars['ID'];
  /** submitterId (either user~[userId] or team~[teamId]). */
  submitterId: Scalars['ID'];
};

/**
 * Mirrors the IDs in the input GroupGrading_SubmissionReference. This is used to return some of the
 * IDs originally passed in due to an issue with the Apollo mutation component where updating the
 * cache after the mutation loses reference of the original variables used to execute the mutation.
 */
export type GroupGrading_SubmissionReferenceOutput = {
  __typename?: 'GroupGrading_SubmissionReferenceOutput';
  /** groupId of top-level group for the private session. */
  groupId: Scalars['ID'];
  /** itemId */
  itemId: Scalars['ID'];
  /** submitterId (either user~[userId] or team~[teamId]). */
  submitterId: Scalars['ID'];
};

/** Input for GroupGrading_SubmitGradesToGradeBook mutation. */
export type GroupGrading_SubmitGradesToGradeBookInput = {
  /**
   * [Optional]. Conflict metadata previously fetched from sgaSubmission. The "correct" value may be
   * null
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Used to identify current grading task for submission */
  gradingTaskIdHash: Scalars['String'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Result for GroupGrading_SubmitGradesToGradeBook mutation. */
export type GroupGrading_SubmitGradesToGradeBookResult = {
  __typename?: 'GroupGrading_SubmitGradesToGradeBookResult';
  /**
   * Contains information for the item's latest grades for the submitter, grade overrides,
   * and grade visibility.
   * * Note: For team submissions, the gradebookEntry is the data we fetch from the first user on
   * the team *
   */
  gradebookEntry: GroupGrading_SubmitterGradebookEntry;
  /** Contains submission and grading data */
  sgaSubmission: GroupGrading_SgaSubmission;
  /** Mirrors the submissionReference in the input. */
  submissionReference: GroupGrading_SubmissionReferenceOutput;
};

/** abstract type of a user or team submitter */
export type GroupGrading_Submitter = GroupGrading_TeamSubmitter | GroupGrading_UserSubmitter;

/** TODO: Complete this description */
export type GroupGrading_SubmitterGradebookEntry = {
  __typename?: 'GroupGrading_SubmitterGradebookEntry';
  /** If the grade is hidden or not. */
  isHidden?: Maybe<Scalars['Boolean']>;
  /** Live grade data for the submitter's item grade. */
  liveOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Original grade data for submitter's item grade. */
  originalOutcome?: Maybe<GroupGrading_ItemOutcome>;
  /** Overrides applied to the submitter's item grade. */
  overrideOutcome?: Maybe<GroupGrading_ItemOutcomeOverride>;
};

/** TODO: Complete this description */
export type GroupGrading_TeamSubmitter = {
  __typename?: 'GroupGrading_TeamSubmitter';
  /** the group id */
  groupId: Scalars['ID'];
  /** name of team */
  name: Scalars['String'];
  /** the team id */
  teamId: Scalars['ID'];
  /** the team version */
  teamVersion: Scalars['Int'];
  /** users on team */
  userIds: Array<Scalars['ID']>;
  /** members of team */
  userProfiles: Array<GroupGrading_UserProfile>;
};

/** Input for GroupGrading_UpdateGradeVisibility mutation. */
export type GroupGrading_UpdateGradeVisibilityInput = {
  /** Whether to hide the grade or not. */
  isHidden: Scalars['Boolean'];
  /**
   * Parameters for locating the submitter's assignment to update grade visibility: {groupId, itemId,
   * submitterId} (can be single user or team)
   */
  submissionReference: GroupGrading_SubmissionReference;
};

/** Result for GroupGrading_UpdateGradeVisibility mutation. */
export type GroupGrading_UpdateGradeVisibilityResult = {
  __typename?: 'GroupGrading_UpdateGradeVisibilityResult';
  /** If the grade is hidden or not. */
  isHidden?: Maybe<Scalars['Boolean']>;
  /** Mirrors the submissionReference in the input. */
  submissionReference: GroupGrading_SubmissionReferenceOutput;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseChoices mutation. */
export type GroupGrading_UpdateReviewPartResponseChoicesInput = {
  /**
   * The list may be empty if no choices are selected. Or if multiple choices are
   * selected, they all need to be present in this list.
   */
  choices: Array<Scalars['String']>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/**
 * [DEPRECATED] Result for GroupGrading_UpdateReviewPartResponseChoices mutation.
 *
 * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
 */
export type GroupGrading_UpdateReviewPartResponseChoicesResult = {
  __typename?: 'GroupGrading_UpdateReviewPartResponseChoicesResult';
  /**
   * Assuming the update is successful, then you should have the latest state so returning the
   * conflictMetadata here is acceptable. Errors will be communicated via GraphQl "errors".
   * @deprecated deleted API
   */
  conflictMetadata?: Maybe<Scalars['String']>;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseComment mutation. */
export type GroupGrading_UpdateReviewPartResponseCommentInput = {
  /** [optional] plain text comment. sending no value will unset the comment. */
  comment?: InputMaybe<Scalars['String']>;
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST:ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/**
 * [DEPRECATED] Result for GroupGrading_UpdateReviewPartResponseComment mutation.
 *
 * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
 */
export type GroupGrading_UpdateReviewPartResponseCommentResult = {
  __typename?: 'GroupGrading_UpdateReviewPartResponseCommentResult';
  /**
   * Assuming the update is successful, then you should have the latest state so returning the
   * conflictMetadata here is acceptable. Errors will be communicated via GraphQl "errors".
   * @deprecated deleted API
   */
  conflictMetadata?: Maybe<Scalars['String']>;
};

/** [DEPRECATED] Input for GroupGrading_UpdateReviewPartResponseScore mutation. */
export type GroupGrading_UpdateReviewPartResponseScoreInput = {
  /**
   * You must include the data from GroupGrading_SgaSubmission#reviewConflictMetadata here in order
   * for the update to succeed. If the API returns a `BAD_REQUEST` with `ALREADY_EXISTS` it means
   * that the grading rubric that you are attempting to modify may be stale and the grading rubric
   * responses and reviewConflictMetadata must be refetched.
   */
  conflictMetadata?: InputMaybe<Scalars['String']>;
  /** Corresponds to a particular review part. */
  responseId: Scalars['ID'];
  /** [optional] integer or decimal values >= 0. sending no value will unset the score. */
  score?: InputMaybe<Scalars['Float']>;
  /** See description on GroupGrading_SubmissionReference. */
  submissionReference: GroupGrading_SubmissionReference;
};

/**
 * [DEPRECATED] Result for GroupGrading_UpdateReviewPartResponseScore mutation.
 *
 * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
 */
export type GroupGrading_UpdateReviewPartResponseScoreResult = {
  __typename?: 'GroupGrading_UpdateReviewPartResponseScoreResult';
  /**
   * Assuming the update is successful, then you should have the latest state so returning the
   * conflictMetadata here is acceptable. Errors will be communicated via GraphQl "errors".
   * @deprecated deleted API
   */
  conflictMetadata?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type GroupGrading_UserProfile = {
  __typename?: 'GroupGrading_UserProfile';
  /**
   * name to be displayed by the front-end
   * * may not be structured properly for non-latin languages *
   */
  displayName: Scalars['String'];
  /** email associated with group profile (e.g. university email), if available, or main user profile (e.g. personal email) */
  email?: Maybe<Scalars['String']>;
  /** id associated with group profile (e.g. university id), if available */
  externalId?: Maybe<Scalars['ID']>;
  /** first name (only available for some groups) */
  firstName?: Maybe<Scalars['String']>;
  /** name associated with group profile, if available, or main user profile */
  fullName: Scalars['String'];
  /** group context */
  groupId: Scalars['ID'];
  /** last name (only available for some groups) */
  lastName?: Maybe<Scalars['String']>;
  /** internal user id */
  userId: Scalars['ID'];
};

/** TODO: Complete this description */
export type GroupGrading_UserSubmitter = {
  __typename?: 'GroupGrading_UserSubmitter';
  /** the group id */
  groupId: Scalars['ID'];
  /** the user id */
  userId: Scalars['ID'];
  /** user profile */
  userProfile: GroupGrading_UserProfile;
};

export type GuidedCourseNextStepsV1 = {
  __typename?: 'GuidedCourseNextStepsV1';
  id: Scalars['String'];
  nextStep: GuidedCourseNextStepsV1_NextStep;
};

export type GuidedCourseNextStepsV1Connection = {
  __typename?: 'GuidedCourseNextStepsV1Connection';
  elements: Array<Maybe<GuidedCourseNextStepsV1>>;
  paging: ResponsePagination;
};

export type GuidedCourseNextStepsV1Resource = {
  __typename?: 'GuidedCourseNextStepsV1Resource';
  get?: Maybe<GuidedCourseNextStepsV1>;
  multiGet?: Maybe<GuidedCourseNextStepsV1Connection>;
};


export type GuidedCourseNextStepsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type GuidedCourseNextStepsV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  stepsToSkip?: InputMaybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_AssessOpenSinglePageMember = {
  __typename?: 'GuidedCourseNextStepsV1_assessOpenSinglePageMember';
  assessOpenSinglePage: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type GuidedCourseNextStepsV1_BlockingAssessmentLockInfoMember = {
  __typename?: 'GuidedCourseNextStepsV1_blockingAssessmentLockInfoMember';
  blockingAssessmentLockInfo: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo;
};

export type GuidedCourseNextStepsV1_ClosedPeerMember = {
  __typename?: 'GuidedCourseNextStepsV1_closedPeerMember';
  closedPeer: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type GuidedCourseNextStepsV1_CmlMember = {
  __typename?: 'GuidedCourseNextStepsV1_cmlMember';
  cml: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type GuidedCourseNextStepsV1_CoachMember = {
  __typename?: 'GuidedCourseNextStepsV1_coachMember';
  coach: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition;
};

export type GuidedCourseNextStepsV1_CompoundLatePenaltyMember = {
  __typename?: 'GuidedCourseNextStepsV1_compoundLatePenaltyMember';
  compoundLatePenalty: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type GuidedCourseNextStepsV1_CompoundLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseNextStepsV1_compoundLatePenaltyRatioMember';
  compoundLatePenaltyRatio: GuidedCourseNextStepsV1_Org_Coursera_Grading_CompoundLatePenaltyRatio;
};

export type GuidedCourseNextStepsV1_ContentSummary = GuidedCourseNextStepsV1_AssessOpenSinglePageMember | GuidedCourseNextStepsV1_ClosedPeerMember | GuidedCourseNextStepsV1_CoachMember | GuidedCourseNextStepsV1_DiscussionPromptMember | GuidedCourseNextStepsV1_ExamMember | GuidedCourseNextStepsV1_GradedDiscussionPromptMember | GuidedCourseNextStepsV1_GradedLtiMember | GuidedCourseNextStepsV1_GradedPeerMember | GuidedCourseNextStepsV1_GradedProgrammingMember | GuidedCourseNextStepsV1_GradedWidgetMember | GuidedCourseNextStepsV1_LectureMember | GuidedCourseNextStepsV1_NotebookMember | GuidedCourseNextStepsV1_PeerMember | GuidedCourseNextStepsV1_PhasedPeerMember | GuidedCourseNextStepsV1_PlaceholderMember | GuidedCourseNextStepsV1_ProgrammingMember | GuidedCourseNextStepsV1_QuizMember | GuidedCourseNextStepsV1_SingleQuestionSubmitMember | GuidedCourseNextStepsV1_SlideshowMember | GuidedCourseNextStepsV1_StaffGradedMember | GuidedCourseNextStepsV1_SupplementMember | GuidedCourseNextStepsV1_TeammateReviewMember | GuidedCourseNextStepsV1_UngradedAssignmentMember | GuidedCourseNextStepsV1_UngradedLabMember | GuidedCourseNextStepsV1_UngradedLtiMember | GuidedCourseNextStepsV1_UngradedProgrammingMember | GuidedCourseNextStepsV1_UngradedWidgetMember | GuidedCourseNextStepsV1_WiseFlowMember | GuidedCourseNextStepsV1_WorkspaceLauncherMember;

export type GuidedCourseNextStepsV1_CourseCompletedNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_courseCompletedNextStepMember';
  courseCompletedNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseCompletedNextStep;
};

export type GuidedCourseNextStepsV1_CourseMaterialNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_courseMaterialNextStepMember';
  courseMaterialNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStep;
};

export type GuidedCourseNextStepsV1_CourseScheduleAdjustmentNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_courseScheduleAdjustmentNextStepMember';
  courseScheduleAdjustmentNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseScheduleAdjustmentNextStep;
};

export type GuidedCourseNextStepsV1_DiscussionPromptMember = {
  __typename?: 'GuidedCourseNextStepsV1_discussionPromptMember';
  discussionPrompt: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type GuidedCourseNextStepsV1_ExamMember = {
  __typename?: 'GuidedCourseNextStepsV1_examMember';
  exam: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type GuidedCourseNextStepsV1_FixedGradingLatePenaltyMember = {
  __typename?: 'GuidedCourseNextStepsV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type GuidedCourseNextStepsV1_FixedLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseNextStepsV1_fixedLatePenaltyRatioMember';
  fixedLatePenaltyRatio: GuidedCourseNextStepsV1_Org_Coursera_Grading_FixedLatePenaltyRatio;
};

export type GuidedCourseNextStepsV1_GradedDiscussionPromptMember = {
  __typename?: 'GuidedCourseNextStepsV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type GuidedCourseNextStepsV1_GradedLtiMember = {
  __typename?: 'GuidedCourseNextStepsV1_gradedLtiMember';
  gradedLti: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type GuidedCourseNextStepsV1_GradedPeerMember = {
  __typename?: 'GuidedCourseNextStepsV1_gradedPeerMember';
  gradedPeer: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type GuidedCourseNextStepsV1_GradedProgrammingMember = {
  __typename?: 'GuidedCourseNextStepsV1_gradedProgrammingMember';
  gradedProgramming: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type GuidedCourseNextStepsV1_GradedWidgetMember = {
  __typename?: 'GuidedCourseNextStepsV1_gradedWidgetMember';
  gradedWidget: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type GuidedCourseNextStepsV1_GradingLatePenalty = GuidedCourseNextStepsV1_CompoundLatePenaltyMember | GuidedCourseNextStepsV1_FixedGradingLatePenaltyMember | GuidedCourseNextStepsV1_IncrementalGradingLatePenaltyMember;

export type GuidedCourseNextStepsV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'GuidedCourseNextStepsV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type GuidedCourseNextStepsV1_IncrementalLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseNextStepsV1_incrementalLatePenaltyRatioMember';
  incrementalLatePenaltyRatio: GuidedCourseNextStepsV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio;
};

export type GuidedCourseNextStepsV1_LatePenaltyRatio = GuidedCourseNextStepsV1_CompoundLatePenaltyRatioMember | GuidedCourseNextStepsV1_FixedLatePenaltyRatioMember | GuidedCourseNextStepsV1_IncrementalLatePenaltyRatioMember;

export type GuidedCourseNextStepsV1_LectureMember = {
  __typename?: 'GuidedCourseNextStepsV1_lectureMember';
  lecture: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

/** Union type used in ItemLockInfo to hold specific information on the different types of locks */
export type GuidedCourseNextStepsV1_LockInfo = GuidedCourseNextStepsV1_BlockingAssessmentLockInfoMember | GuidedCourseNextStepsV1_TimedReleaseContentLockInfoMember;

export type GuidedCourseNextStepsV1_MultipleDeadlinesNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_multipleDeadlinesNextStepMember';
  multipleDeadlinesNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_MultipleDeadlinesNextStep;
};

/** Recommended next step to take which can vary depending on the user's state within the course. */
export type GuidedCourseNextStepsV1_NextStep = GuidedCourseNextStepsV1_CourseCompletedNextStepMember | GuidedCourseNextStepsV1_CourseMaterialNextStepMember | GuidedCourseNextStepsV1_CourseScheduleAdjustmentNextStepMember | GuidedCourseNextStepsV1_MultipleDeadlinesNextStepMember | GuidedCourseNextStepsV1_NoActiveSessionNextStepMember | GuidedCourseNextStepsV1_NoAvailableNextStepFromErrorMember | GuidedCourseNextStepsV1_NoAvailableNextStepMember | GuidedCourseNextStepsV1_NoEnrollableSessionsNextStepMember | GuidedCourseNextStepsV1_NotEnoughPeerReviewsNextStepMember | GuidedCourseNextStepsV1_SessionEndedNextStepMember;

export type GuidedCourseNextStepsV1_NoActiveSessionNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_noActiveSessionNextStepMember';
  noActiveSessionNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoActiveSessionNextStep;
};

export type GuidedCourseNextStepsV1_NoAvailableNextStepFromErrorMember = {
  __typename?: 'GuidedCourseNextStepsV1_noAvailableNextStepFromErrorMember';
  noAvailableNextStepFromError: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStepFromError;
};

export type GuidedCourseNextStepsV1_NoAvailableNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_noAvailableNextStepMember';
  noAvailableNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStep;
};

export type GuidedCourseNextStepsV1_NoEnrollableSessionsNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_noEnrollableSessionsNextStepMember';
  noEnrollableSessionsNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoEnrollableSessionsNextStep;
};

export type GuidedCourseNextStepsV1_NotEnoughPeerReviewsNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_notEnoughPeerReviewsNextStepMember';
  notEnoughPeerReviewsNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NotEnoughPeerReviewsNextStep;
};

export type GuidedCourseNextStepsV1_NotebookMember = {
  __typename?: 'GuidedCourseNextStepsV1_notebookMember';
  notebook: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature = typeof GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature];
export const GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource = {
  Coursera: 'COURSERA',
  Credly: 'CREDLY',
  Invalid: 'INVALID'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource = typeof GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource];
export type GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeTemplate = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_badge_BadgeTemplate';
  activities: Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Badge_Course>>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  title: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Badge_Course = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_badge_Course';
  id: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Badge_IssuedBadge = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_badge_IssuedBadge';
  badgeTemplate: GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeTemplate;
  issuedAt: Scalars['Float'];
  issuedBadgeId: Scalars['String'];
  issuedBadgeSource: GuidedCourseNextStepsV1_Org_Coursera_Badge_BadgeSource;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type GuidedCourseNextStepsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: GuidedCourseNextStepsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type GuidedCourseNextStepsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Grading_CompoundLatePenaltyRatio = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_grading_CompoundLatePenaltyRatio';
  penaltyContext: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
  ratio: Scalars['Float'];
  submissionDeadline: Scalars['Float'];
  submissionTime: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Grading_FixedLatePenaltyRatio = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_grading_FixedLatePenaltyRatio';
  ratio: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_grading_IncrementalLatePenaltyRatio';
  duration: Scalars['Float'];
  ratio: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursegrades_ItemOutcome';
  grade: Scalars['Float'];
  isPassed: Scalars['Boolean'];
  latePenaltyRatio?: Maybe<GuidedCourseNextStepsV1_LatePenaltyRatio>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_BlockingAssessment';
  assessmentId: GuidedCourseNextStepsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember;
  courseBranchId: Scalars['String'];
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_BlockingAssessmentLockInfo';
  blockingAssessments: Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment>>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_CoachSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_ItemLockState';
  lockStatus: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus;
  reasonCode: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
/** Holds ItemLockState along with additional info depending on the type of lock. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_ItemLockSummary';
  isPreviewableByCourseStaff?: Maybe<Scalars['Boolean']>;
  lockInfo?: Maybe<GuidedCourseNextStepsV1_LockInfo>;
  lockState: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

/** Holds the time in which a TimedReleaseContent item will be unlocked and when it will be locked again */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_TimedReleaseContentLockInfo';
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  unlockedTimeEnd?: Maybe<Scalars['Float']>;
  unlockedTimeStart?: Maybe<Scalars['Float']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
/** Representation of an item and its related information in the GLEV2 API. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Item = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_Item';
  computedOutcome?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome>;
  computedProgressState: Scalars['String'];
  contentSummary: GuidedCourseNextStepsV1_ContentSummary;
  deadline?: Maybe<Scalars['Float']>;
  gradingLatePenalty?: Maybe<GuidedCourseNextStepsV1_GradingLatePenalty>;
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
  isLocked: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  itemDeadlineStatus: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus;
  itemGroup?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_ItemGroup>;
  itemLockSummary?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary>;
  name: Scalars['String'];
  resourcePath: Scalars['String'];
  timeCommitment: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_ItemGroup = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_ItemGroup';
  id: Scalars['String'];
  passableItemGroupChoiceIds: Array<Maybe<Scalars['String']>>;
  requiredPassedCount: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CertificateMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_CertificateMetadata';
  courseCertificatePreviewImageUrl: Scalars['String'];
  courseCertificateVerifyCode: Scalars['String'];
  specializationCertificateGrantedAt?: Maybe<Scalars['Float']>;
  specializationCertificatePreviewImageUrl?: Maybe<Scalars['String']>;
  specializationCertificateVerifyCode?: Maybe<Scalars['String']>;
};

/** Next step information for users who have completed the course. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseCompletedNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_CourseCompletedNextStep';
  canCompleteVerificationProfile: Scalars['Boolean'];
  canSubscribe: Scalars['Boolean'];
  canUnenroll: Scalars['Boolean'];
  canUpgrade: Scalars['Boolean'];
  canViewCertificate: Scalars['Boolean'];
  certificateMetadata?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CertificateMetadata>;
  course: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMetadata;
  enrolledCourseIds: Array<Maybe<Scalars['String']>>;
  gradeMetadata?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_GradeMetadata>;
  isEligibleButNoCertificate: Scalars['Boolean'];
  issuedBadges?: Maybe<Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Badge_IssuedBadge>>>;
  s12n?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_S12nMetadata>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_CourseMaterialNextStep';
  courseMaterialNextStepType: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType;
  currentWeekNumberByProgress: Scalars['Int'];
  item: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Item;
  sessionStartedAt: Scalars['Float'];
};

/** Reason for the resulting course material next step. */
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = {
  Default: 'DEFAULT',
  ExamFailedTryAgain: 'EXAM_FAILED_TRY_AGAIN',
  ExamFailedTryLater: 'EXAM_FAILED_TRY_LATER',
  ExamOntrack: 'EXAM_ONTRACK',
  ExamOverdue: 'EXAM_OVERDUE',
  ExamVerify: 'EXAM_VERIFY',
  GradedAssignmentFailedTryAgain: 'GRADED_ASSIGNMENT_FAILED_TRY_AGAIN',
  GradedAssignmentFailedTryLater: 'GRADED_ASSIGNMENT_FAILED_TRY_LATER',
  GradedAssignmentOntrack: 'GRADED_ASSIGNMENT_ONTRACK',
  GradedAssignmentOverdue: 'GRADED_ASSIGNMENT_OVERDUE',
  GradedAssignmentVerify: 'GRADED_ASSIGNMENT_VERIFY',
  GradedPeerFailed: 'GRADED_PEER_FAILED',
  GradedPeerOntrack: 'GRADED_PEER_ONTRACK',
  GradedPeerOverdue: 'GRADED_PEER_OVERDUE',
  GradedPeerReviewOntrack: 'GRADED_PEER_REVIEW_ONTRACK',
  GradedPeerReviewOverdue: 'GRADED_PEER_REVIEW_OVERDUE',
  GradedPeerUnsubmittedOntrack: 'GRADED_PEER_UNSUBMITTED_ONTRACK',
  GradedPeerUnsubmittedOverdue: 'GRADED_PEER_UNSUBMITTED_OVERDUE',
  GradedPeerVerify: 'GRADED_PEER_VERIFY',
  PracticeAssignmentOntrack: 'PRACTICE_ASSIGNMENT_ONTRACK',
  PracticeAssignmentOverdue: 'PRACTICE_ASSIGNMENT_OVERDUE',
  QuizOntrack: 'QUIZ_ONTRACK',
  QuizOverdue: 'QUIZ_OVERDUE',
  StudyMaterialOntrack: 'STUDY_MATERIAL_ONTRACK',
  StudyMaterialOverdue: 'STUDY_MATERIAL_OVERDUE',
  TmrFailed: 'TMR_FAILED',
  TmrUnsubmittedOntrack: 'TMR_UNSUBMITTED_ONTRACK',
  TmrUnsubmittedOverdue: 'TMR_UNSUBMITTED_OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType];
/** Course metadata necessary for next step API. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_CourseMetadata';
  /** Course type. Valid values include v1.session, v1.capstone, v2.ondemand, and v2.capstone */
  courseType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  partnerNames: Array<Maybe<Scalars['String']>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

/** Used instead of [[MultipleDeadlinesNextStep]], [[NotEnoughPeerReviewsNextStep]], and [[NoActiveSessionNextStep]] for learners in sessions v2 experiment. This essentially replaces all messages about session switching. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseScheduleAdjustmentNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_CourseScheduleAdjustmentNextStep';
  suggestion: GuidedCourseNextStepsV1_Suggestion;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_GradeMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_GradeMetadata';
  completedAt: Scalars['Float'];
  grade: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_MultipleDeadlinesNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_MultipleDeadlinesNextStep';
  courseId: Scalars['String'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NextStepCompletedS12nPartner = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NextStepCompletedS12nPartner';
  id: Scalars['Int'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoActiveSessionNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NoActiveSessionNextStep';
  courseId: Scalars['String'];
};

/** State representing lack of available next steps. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NoAvailableNextStep';
  reason: Scalars['String'];
};

/** No available step due to an incompatible or error state. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStepFromError = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NoAvailableNextStepFromError';
  reason: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoEnrollableSessionsNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NoEnrollableSessionsNextStep';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NotEnoughPeerReviewsNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_NotEnoughPeerReviewsNextStep';
  courseId: Scalars['String'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

/** S12n metadata necessary for next step API. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_S12nMetadata = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_S12nMetadata';
  capstoneCourseIds: Array<Maybe<Scalars['String']>>;
  courseIds: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  partners: Array<Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_NextStepCompletedS12nPartner>>;
  variant: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_SessionEndedNextStep = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_guided2_nextstep_SessionEndedNextStep';
  courseId: Scalars['String'];
  currentSessionEndedAt: Scalars['Float'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_BranchChange = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_BranchChange';
  changesDescription: GuidedCourseNextStepsV1_CmlMember;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_Extension';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason;
  sessionSwitch?: Maybe<GuidedCourseNextStepsV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_ExtensionMember';
  org_coursera_ondemand_schedule_suggestion_Extension: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_NoSuggestion';
  reason: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_NoSuggestionMember';
  org_coursera_ondemand_schedule_suggestion_NoSuggestion: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
/** Terminology: A "deadline" is a single point on a horizontal timeline. BeginningOfTime-----Deadline----EndofTime/Future "Moving forwards" is to move the deadline to the right                     Deadline-->>> Shift all deadlines forward by "days" Eg. Given Original Schedule: Let S = start Let E = end Let days = 4 1 2 3 4 5 6[S---------E] Becomes      [S--------E] If the shift in deadlines causes the user to be too far off from the relative schedule of other learners in the Cohort, they might not get enough time for Peer Review. Then we must recommend a new "Public Session/Cohort" Public Sessions act as "Cohorts/Groups" for learners in SessionsV2. Learners still receive their Peer Review Feedback from learners in the same Public Session, but have deadlines set to their own Personalized Schedule. */
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlines';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason;
  sessionSwitch?: Maybe<GuidedCourseNextStepsV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlinesMember';
  org_coursera_ondemand_schedule_suggestion_ShiftDeadlines: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines;
};

export const GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoalMember';
  org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SuggestedSwitch = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_session_SuggestedSwitch';
  branchChange?: Maybe<GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_BranchChange>;
  destinationSessionBranchId: Scalars['String'];
  destinationSessionId: Scalars['String'];
  sourceSessionBranchId: Scalars['String'];
  sourceSessionId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_session_SuggestedSwitchMember';
  org_coursera_ondemand_session_SuggestedSwitch: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SuggestedSwitch;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_session_SwitchNotNeeded';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_ondemand_session_SwitchNotNeededMember';
  org_coursera_ondemand_session_SwitchNotNeeded: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded;
};

export type GuidedCourseNextStepsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember = {
  __typename?: 'GuidedCourseNextStepsV1_org_coursera_staffgraded_StaffGradedAssignmentIdMember';
  org_coursera_staffgraded_StaffGradedAssignmentId: Scalars['String'];
};

export type GuidedCourseNextStepsV1_PeerMember = {
  __typename?: 'GuidedCourseNextStepsV1_peerMember';
  peer: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type GuidedCourseNextStepsV1_PhasedPeerMember = {
  __typename?: 'GuidedCourseNextStepsV1_phasedPeerMember';
  phasedPeer: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type GuidedCourseNextStepsV1_PlaceholderMember = {
  __typename?: 'GuidedCourseNextStepsV1_placeholderMember';
  placeholder: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type GuidedCourseNextStepsV1_ProgrammingMember = {
  __typename?: 'GuidedCourseNextStepsV1_programmingMember';
  programming: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type GuidedCourseNextStepsV1_QuizMember = {
  __typename?: 'GuidedCourseNextStepsV1_quizMember';
  quiz: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type GuidedCourseNextStepsV1_SessionEndedNextStepMember = {
  __typename?: 'GuidedCourseNextStepsV1_sessionEndedNextStepMember';
  sessionEndedNextStep: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Guided2_Nextstep_SessionEndedNextStep;
};

export type GuidedCourseNextStepsV1_SessionSwitch = GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember | GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember;

export type GuidedCourseNextStepsV1_SingleQuestionSubmitMember = {
  __typename?: 'GuidedCourseNextStepsV1_singleQuestionSubmitMember';
  singleQuestionSubmit: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type GuidedCourseNextStepsV1_SlideshowMember = {
  __typename?: 'GuidedCourseNextStepsV1_slideshowMember';
  slideshow: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type GuidedCourseNextStepsV1_StaffGradedMember = {
  __typename?: 'GuidedCourseNextStepsV1_staffGradedMember';
  staffGraded: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type GuidedCourseNextStepsV1_Suggestion = GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember | GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember | GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember | GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember;

export type GuidedCourseNextStepsV1_SupplementMember = {
  __typename?: 'GuidedCourseNextStepsV1_supplementMember';
  supplement: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type GuidedCourseNextStepsV1_TeammateReviewMember = {
  __typename?: 'GuidedCourseNextStepsV1_teammateReviewMember';
  teammateReview: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type GuidedCourseNextStepsV1_TimedReleaseContentLockInfoMember = {
  __typename?: 'GuidedCourseNextStepsV1_timedReleaseContentLockInfoMember';
  timedReleaseContentLockInfo: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo;
};

export type GuidedCourseNextStepsV1_UngradedAssignmentMember = {
  __typename?: 'GuidedCourseNextStepsV1_ungradedAssignmentMember';
  ungradedAssignment: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type GuidedCourseNextStepsV1_UngradedLabMember = {
  __typename?: 'GuidedCourseNextStepsV1_ungradedLabMember';
  ungradedLab: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type GuidedCourseNextStepsV1_UngradedLtiMember = {
  __typename?: 'GuidedCourseNextStepsV1_ungradedLtiMember';
  ungradedLti: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type GuidedCourseNextStepsV1_UngradedProgrammingMember = {
  __typename?: 'GuidedCourseNextStepsV1_ungradedProgrammingMember';
  ungradedProgramming: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type GuidedCourseNextStepsV1_UngradedWidgetMember = {
  __typename?: 'GuidedCourseNextStepsV1_ungradedWidgetMember';
  ungradedWidget: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type GuidedCourseNextStepsV1_WiseFlowMember = {
  __typename?: 'GuidedCourseNextStepsV1_wiseFlowMember';
  wiseFlow: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type GuidedCourseNextStepsV1_WorkspaceLauncherMember = {
  __typename?: 'GuidedCourseNextStepsV1_workspaceLauncherMember';
  workspaceLauncher: GuidedCourseNextStepsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1 = {
  __typename?: 'GuidedCourseSessionProgressesV1';
  course?: Maybe<CoursesV1>;
  courseId: Scalars['String'];
  courseProgressState: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  courseSlug: Scalars['String'];
  currentWeekByUserProgress: Scalars['Int'];
  endedAt: Scalars['Float'];
  hasSessionModuleDeadlines: Scalars['Boolean'];
  id: Scalars['String'];
  sessionEndedAt: Scalars['Float'];
  sessionId: Scalars['String'];
  sessionStartedAt: Scalars['Float'];
  startedAt: Scalars['Float'];
  weeks: Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_CourseWeekProgress>>;
};


export type GuidedCourseSessionProgressesV1CourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};

export type GuidedCourseSessionProgressesV1Connection = {
  __typename?: 'GuidedCourseSessionProgressesV1Connection';
  elements: Array<Maybe<GuidedCourseSessionProgressesV1>>;
  paging: ResponsePagination;
};

export type GuidedCourseSessionProgressesV1Resource = {
  __typename?: 'GuidedCourseSessionProgressesV1Resource';
  get?: Maybe<GuidedCourseSessionProgressesV1>;
  multiGet?: Maybe<GuidedCourseSessionProgressesV1Connection>;
};


export type GuidedCourseSessionProgressesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type GuidedCourseSessionProgressesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_AssessOpenSinglePageMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_assessOpenSinglePageMember';
  assessOpenSinglePage: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_BlockingAssessmentLockInfoMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_blockingAssessmentLockInfoMember';
  blockingAssessmentLockInfo: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo;
};

export type GuidedCourseSessionProgressesV1_ClosedPeerMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_closedPeerMember';
  closedPeer: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_CompoundLatePenaltyMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_compoundLatePenaltyMember';
  compoundLatePenalty: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type GuidedCourseSessionProgressesV1_CompoundLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_compoundLatePenaltyRatioMember';
  compoundLatePenaltyRatio: GuidedCourseSessionProgressesV1_Org_Coursera_Grading_CompoundLatePenaltyRatio;
};

export type GuidedCourseSessionProgressesV1_ContentSummary = GuidedCourseSessionProgressesV1_AssessOpenSinglePageMember | GuidedCourseSessionProgressesV1_ClosedPeerMember | GuidedCourseSessionProgressesV1_DiscussionPromptMember | GuidedCourseSessionProgressesV1_ExamMember | GuidedCourseSessionProgressesV1_GradedDiscussionPromptMember | GuidedCourseSessionProgressesV1_GradedLtiMember | GuidedCourseSessionProgressesV1_GradedPeerMember | GuidedCourseSessionProgressesV1_GradedProgrammingMember | GuidedCourseSessionProgressesV1_GradedWidgetMember | GuidedCourseSessionProgressesV1_LectureMember | GuidedCourseSessionProgressesV1_NotebookMember | GuidedCourseSessionProgressesV1_PeerMember | GuidedCourseSessionProgressesV1_PhasedPeerMember | GuidedCourseSessionProgressesV1_PlaceholderMember | GuidedCourseSessionProgressesV1_ProgrammingMember | GuidedCourseSessionProgressesV1_QuizMember | GuidedCourseSessionProgressesV1_SingleQuestionSubmitMember | GuidedCourseSessionProgressesV1_SlideshowMember | GuidedCourseSessionProgressesV1_StaffGradedMember | GuidedCourseSessionProgressesV1_SupplementMember | GuidedCourseSessionProgressesV1_TeammateReviewMember | GuidedCourseSessionProgressesV1_UngradedAssignmentMember | GuidedCourseSessionProgressesV1_UngradedLabMember | GuidedCourseSessionProgressesV1_UngradedLtiMember | GuidedCourseSessionProgressesV1_UngradedProgrammingMember | GuidedCourseSessionProgressesV1_UngradedWidgetMember | GuidedCourseSessionProgressesV1_WiseFlowMember | GuidedCourseSessionProgressesV1_WorkspaceLauncherMember;

export type GuidedCourseSessionProgressesV1_DiscussionPromptMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_discussionPromptMember';
  discussionPrompt: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_ExamMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_examMember';
  exam: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_FixedGradingLatePenaltyMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type GuidedCourseSessionProgressesV1_FixedLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_fixedLatePenaltyRatioMember';
  fixedLatePenaltyRatio: GuidedCourseSessionProgressesV1_Org_Coursera_Grading_FixedLatePenaltyRatio;
};

export type GuidedCourseSessionProgressesV1_GradedDiscussionPromptMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_GradedLtiMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_gradedLtiMember';
  gradedLti: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_GradedPeerMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_gradedPeerMember';
  gradedPeer: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_GradedProgrammingMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_gradedProgrammingMember';
  gradedProgramming: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_GradedWidgetMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_gradedWidgetMember';
  gradedWidget: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_GradingLatePenalty = GuidedCourseSessionProgressesV1_CompoundLatePenaltyMember | GuidedCourseSessionProgressesV1_FixedGradingLatePenaltyMember | GuidedCourseSessionProgressesV1_IncrementalGradingLatePenaltyMember;

export type GuidedCourseSessionProgressesV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type GuidedCourseSessionProgressesV1_IncrementalLatePenaltyRatioMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_incrementalLatePenaltyRatioMember';
  incrementalLatePenaltyRatio: GuidedCourseSessionProgressesV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio;
};

export type GuidedCourseSessionProgressesV1_LatePenaltyRatio = GuidedCourseSessionProgressesV1_CompoundLatePenaltyRatioMember | GuidedCourseSessionProgressesV1_FixedLatePenaltyRatioMember | GuidedCourseSessionProgressesV1_IncrementalLatePenaltyRatioMember;

export type GuidedCourseSessionProgressesV1_LectureMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_lectureMember';
  lecture: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

/** Union type used in ItemLockInfo to hold specific information on the different types of locks */
export type GuidedCourseSessionProgressesV1_LockInfo = GuidedCourseSessionProgressesV1_BlockingAssessmentLockInfoMember | GuidedCourseSessionProgressesV1_TimedReleaseContentLockInfoMember;

export type GuidedCourseSessionProgressesV1_NotebookMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_notebookMember';
  notebook: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export const GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature];
export type GuidedCourseSessionProgressesV1_Org_Coursera_Grading_CompoundLatePenaltyRatio = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_grading_CompoundLatePenaltyRatio';
  penaltyContext: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
  ratio: Scalars['Float'];
  submissionDeadline: Scalars['Float'];
  submissionTime: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Grading_FixedLatePenaltyRatio = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_grading_FixedLatePenaltyRatio';
  ratio: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_grading_IncrementalLatePenaltyRatio';
  duration: Scalars['Float'];
  ratio: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursegrades_ItemOutcome';
  grade: Scalars['Float'];
  isPassed: Scalars['Boolean'];
  latePenaltyRatio?: Maybe<GuidedCourseSessionProgressesV1_LatePenaltyRatio>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_BlockingAssessment';
  assessmentId: GuidedCourseSessionProgressesV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember;
  courseBranchId: Scalars['String'];
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_BlockingAssessmentLockInfo';
  blockingAssessments: Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment>>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_ItemLockState';
  lockStatus: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus;
  reasonCode: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode;
};

export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
/** Holds ItemLockState along with additional info depending on the type of lock. */
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_ItemLockSummary';
  isPreviewableByCourseStaff?: Maybe<Scalars['Boolean']>;
  lockInfo?: Maybe<GuidedCourseSessionProgressesV1_LockInfo>;
  lockState: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState;
};

export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

/** Holds the time in which a TimedReleaseContent item will be unlocked and when it will be locked again */
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_TimedReleaseContentLockInfo';
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  unlockedTimeEnd?: Maybe<Scalars['Float']>;
  unlockedTimeStart?: Maybe<Scalars['Float']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

/** Progress for a user within a particular week of the course. */
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_CourseWeekProgress = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_CourseWeekProgress';
  deadline?: Maybe<Scalars['Float']>;
  estimateTimeProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_GuidedWeekEstimateTimeProgress;
  isCurrentWeekBySchedule: Scalars['Boolean'];
  learnerMaterialWeekNumber: Scalars['String'];
  modules: Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Weekcard_GuidedModule>>;
  previousWeekStatus?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus>;
  weekStatus: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus;
};

export const GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
/** Representation of an item and its related information in the GLEV2 API. */
export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Item = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_Item';
  computedOutcome?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome>;
  computedProgressState: Scalars['String'];
  contentSummary: GuidedCourseSessionProgressesV1_ContentSummary;
  deadline?: Maybe<Scalars['Float']>;
  gradingLatePenalty?: Maybe<GuidedCourseSessionProgressesV1_GradingLatePenalty>;
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
  isLocked: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  itemDeadlineStatus: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus;
  itemGroup?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_ItemGroup>;
  itemLockSummary?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary>;
  name: Scalars['String'];
  resourcePath: Scalars['String'];
  timeCommitment: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_ItemGroup = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_ItemGroup';
  id: Scalars['String'];
  passableItemGroupChoiceIds: Array<Maybe<Scalars['String']>>;
  requiredPassedCount: Scalars['Int'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_timeprogress_EstimateTimeProgress';
  nextItem?: Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Item>;
  remainingCount: Scalars['Int'];
  remainingDuration: Scalars['Float'];
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Float'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_GuidedModuleEstimateTimeProgress = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_timeprogress_GuidedModuleEstimateTimeProgress';
  lecturesProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  nonGradedAssessmentsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  otherNonPassableItemsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  readingsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  totalItemsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_GuidedWeekEstimateTimeProgress = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_timeprogress_GuidedWeekEstimateTimeProgress';
  nonPassableItemsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  passableItemsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
  totalItemsProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_EstimateTimeProgress;
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Weekcard_GuidedModule = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_ondemand_guided2_weekcard_GuidedModule';
  /** ID of a module in a course. It will never change and is unique within the course. */
  id: Scalars['String'];
  items: Array<Maybe<GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Item>>;
  moduleTimeProgress: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Guided2_Timeprogress_GuidedModuleEstimateTimeProgress;
  name: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_org_coursera_staffgraded_StaffGradedAssignmentIdMember';
  org_coursera_staffgraded_StaffGradedAssignmentId: Scalars['String'];
};

export type GuidedCourseSessionProgressesV1_PeerMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_peerMember';
  peer: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_PhasedPeerMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_phasedPeerMember';
  phasedPeer: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_PlaceholderMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_placeholderMember';
  placeholder: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_ProgrammingMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_programmingMember';
  programming: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_QuizMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_quizMember';
  quiz: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_SingleQuestionSubmitMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_singleQuestionSubmitMember';
  singleQuestionSubmit: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_SlideshowMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_slideshowMember';
  slideshow: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_StaffGradedMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_staffGradedMember';
  staffGraded: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_SupplementMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_supplementMember';
  supplement: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_TeammateReviewMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_teammateReviewMember';
  teammateReview: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_TimedReleaseContentLockInfoMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_timedReleaseContentLockInfoMember';
  timedReleaseContentLockInfo: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo;
};

export type GuidedCourseSessionProgressesV1_UngradedAssignmentMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_ungradedAssignmentMember';
  ungradedAssignment: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_UngradedLabMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_ungradedLabMember';
  ungradedLab: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_UngradedLtiMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_ungradedLtiMember';
  ungradedLti: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_UngradedProgrammingMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_ungradedProgrammingMember';
  ungradedProgramming: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_UngradedWidgetMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_ungradedWidgetMember';
  ungradedWidget: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_WiseFlowMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_wiseFlowMember';
  wiseFlow: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type GuidedCourseSessionProgressesV1_WorkspaceLauncherMember = {
  __typename?: 'GuidedCourseSessionProgressesV1_workspaceLauncherMember';
  workspaceLauncher: GuidedCourseSessionProgressesV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export const HttpMethod = {
  Connect: 'CONNECT',
  Delete: 'DELETE',
  Get: 'GET',
  Head: 'HEAD',
  Options: 'OPTIONS',
  Patch: 'PATCH',
  Post: 'POST',
  Put: 'PUT',
  Trace: 'TRACE'
} as const;

export type HttpMethod = typeof HttpMethod[keyof typeof HttpMethod];
/** HonorlockEnablement Queries */
export type HonorlockEnablementQueries = {
  __typename?: 'HonorlockEnablementQueries';
  /** Retrieve honorlock enablement data */
  queryHonorlockEnablement: HonorlockEnablement_Data;
};


/** HonorlockEnablement Queries */
export type HonorlockEnablementQueriesQueryHonorlockEnablementArgs = {
  input: HonorlockEnablement_Input;
};

/** Honorlock enablement data */
export type HonorlockEnablement_Data = {
  __typename?: 'HonorlockEnablement_Data';
  /** Assignment type */
  assignmentType: Honorlock_AssignmentType;
  /** Honorlock exam id. Unique identifier for which assignment is honorlocl enabled */
  honorlockExamId: Scalars['ID'];
  /** Honorlock enablement status */
  status: HonorlockEnablement_Status;
};

/** An unique identifier to check honorlock enablement */
export type HonorlockEnablement_Input = {
  /** Assignment id */
  assignmentId: Scalars['ID'];
  /** Assignment type */
  assignmentType: Honorlock_AssignmentType;
  /** Session id */
  sessionId: Scalars['ID'];
};

/** The status of enablement */
export const HonorlockEnablement_Status = {
  /** Disable Honorlock */
  Disable: 'DISABLE',
  /** Enable Honorlock */
  Enable: 'ENABLE'
} as const;

export type HonorlockEnablement_Status = typeof HonorlockEnablement_Status[keyof typeof HonorlockEnablement_Status];
/** Queries to interact with third-party proctoring tool Honorlock */
export type HonorlockLearnerFlowQueries = {
  __typename?: 'HonorlockLearnerFlowQueries';
  /**
   * Query instructions to student for a specific Honorlock exam by session Id and assignment Id,
   * which are used to uniquely look up an Honorlock exam
   */
  queryExamInstructions?: Maybe<HonorlockLearnerFlow_ExamInstructions>;
  /** Query installation instructions for Honorlock browser extension to kickstart learner flow */
  queryHonorlockInstallInstructions: HonorlockLearnerFlow_InstallInstructions;
};


/** Queries to interact with third-party proctoring tool Honorlock */
export type HonorlockLearnerFlowQueriesQueryExamInstructionsArgs = {
  assignmentId: Scalars['ID'];
  sessionId: Scalars['ID'];
};


/** Queries to interact with third-party proctoring tool Honorlock */
export type HonorlockLearnerFlowQueriesQueryHonorlockInstallInstructionsArgs = {
  assignmentId: Scalars['ID'];
  sessionId: Scalars['ID'];
};

/** Instructions to student configured for a specific exam */
export type HonorlockLearnerFlow_ExamInstructions = {
  __typename?: 'HonorlockLearnerFlow_ExamInstructions';
  /** Launch screen to display exam instructions */
  launchScreenUrl: Scalars['URL'];
};

/** Install instructions for the Honorlock browser extension */
export type HonorlockLearnerFlow_InstallInstructions = {
  __typename?: 'HonorlockLearnerFlow_InstallInstructions';
  /** iframe for guiding user through install process */
  iframeUrl: Scalars['URL'];
};

/** Assignment type that enables honorlock */
export const Honorlock_AssignmentType = {
  /**
   * For now we only support honorlock enablement for staff graded assignment,
   * possibly extend this feature to other assignment types(ex. coding assignment)
   */
  StaffGraded: 'STAFF_GRADED'
} as const;

export type Honorlock_AssignmentType = typeof Honorlock_AssignmentType[keyof typeof Honorlock_AssignmentType];
/** iMocha Assessment GraphQL Schema queries */
export type IMochaAssessmentQueries = {
  __typename?: 'IMochaAssessmentQueries';
  /** This query generates test status for the most recent test attempt of a test taken by the current logged in user. */
  IMochaAssessment_GetTestStatus: IMochaAssessment_TestStatusResult;
};


/** iMocha Assessment GraphQL Schema queries */
export type IMochaAssessmentQueriesIMochaAssessment_GetTestStatusArgs = {
  testId: Scalars['ID'];
};

/** This is returned if the mutation for generating test link fails */
export type IMochaAssessment_GenerateTestLinkFailure = {
  __typename?: 'IMochaAssessment_GenerateTestLinkFailure';
  /** The expected errors that caused this mutation to fail */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input to generate the test link on iMocha */
export type IMochaAssessment_GenerateTestLinkInput = {
  /** Unique test identifier. Since GraphQL does not support Int64, use ID instead. */
  testId: Scalars['ID'];
};

/** Result for generating the test link for the current logged in user */
export type IMochaAssessment_GenerateTestLinkResult = IMochaAssessment_GenerateTestLinkFailure | IMochaAssessment_GenerateTestLinkSuccess;

/** This is returned if the mutation for generating test link succeeds */
export type IMochaAssessment_GenerateTestLinkSuccess = {
  __typename?: 'IMochaAssessment_GenerateTestLinkSuccess';
  /** Generated test link for the user. */
  testLink: Scalars['URL'];
};

/** Error type for when the test attempt was already taken but still request for test link */
export type IMochaAssessment_TestAttemptAlreadyTaken = ErrorDetails & {
  __typename?: 'IMochaAssessment_TestAttemptAlreadyTaken';
  /** errorCode is the name of the custom error */
  errorCode: Scalars['String'];
  /** Readable message provides the error details */
  message: Scalars['String'];
  /** Path of the error */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error */
  suggestion?: Maybe<Scalars['String']>;
};

/** Different the current completion status of an iMocha test attempt */
export const IMochaAssessment_TestCompletionStatus = {
  /** The test invitation is still pending as user hasn't started the test yet */
  InvitationPending: 'INVITATION_PENDING',
  /** The test is completed */
  TestCompleted: 'TEST_COMPLETED',
  /** The user is currently taking the test */
  TestInProgress: 'TEST_IN_PROGRESS',
  /** The test is abandoned after the user already started the test */
  TestLeft: 'TEST_LEFT'
} as const;

export type IMochaAssessment_TestCompletionStatus = typeof IMochaAssessment_TestCompletionStatus[keyof typeof IMochaAssessment_TestCompletionStatus];
/** Result for generating the test link for a user */
export type IMochaAssessment_TestStatusResult = {
  __typename?: 'IMochaAssessment_TestStatusResult';
  /** Grading Status of the test. */
  testGraded: Scalars['Boolean'];
  /** Test invitation or completion status. */
  testStatus: IMochaAssessment_TestCompletionStatus;
};

/**
 * This endpoint aims to combine calls made to PersonaIdVerificationsResource and JumioIdVerificationsResource from
 * Scala and return verification status to FE
 *
 * BE will fetch user id from auth request context
 */
export type IdVerificationVendorIntegrationQueries = {
  __typename?: 'IdVerificationVendorIntegrationQueries';
  /** Get latest user verification details */
  latestByMe?: Maybe<IdVerificationVendorIntegration_Details>;
};

/** idverificationvendorintegration details */
export type IdVerificationVendorIntegration_Details = {
  __typename?: 'IdVerificationVendorIntegration_Details';
  /** UUID */
  verificationId: Scalars['ID'];
  /** Verification statuses defined by Coursera */
  verificationStatus: CourseraVerificationStatus;
};

export type IdVerificationsV1 = {
  __typename?: 'IdVerificationsV1';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jumioIdVerificationAttemptHistory: IdVerificationsV1_Org_Coursera_Userverification_Idverification_JumioIdVerificationAttemptHistory;
  lastModified: Scalars['Float'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  verifiedBy: IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource;
};

export type IdVerificationsV1Connection = {
  __typename?: 'IdVerificationsV1Connection';
  elements: Array<Maybe<IdVerificationsV1>>;
  paging: ResponsePagination;
};

export type IdVerificationsV1Me = {
  __typename?: 'IdVerificationsV1Me';
  connection?: Maybe<IdVerificationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type IdVerificationsV1Resource = {
  __typename?: 'IdVerificationsV1Resource';
  get?: Maybe<IdVerificationsV1>;
  me?: Maybe<IdVerificationsV1Connection>;
  multiGet?: Maybe<IdVerificationsV1Connection>;
};


export type IdVerificationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type IdVerificationsV1ResourceMeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type IdVerificationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type IdVerificationsV1ResourceMutations = {
  __typename?: 'IdVerificationsV1ResourceMutations';
  attestName?: Maybe<Scalars['JSON']>;
  delete?: Maybe<IdVerificationsV1Connection>;
  grantVerificationAsAdmin?: Maybe<Scalars['JSON']>;
  resetIdVerificationAsAdmin?: Maybe<Scalars['JSON']>;
  update?: Maybe<IdVerificationsV1Connection>;
};


export type IdVerificationsV1ResourceMutationsAttestNameArgs = {
  id: Scalars['String'];
};


export type IdVerificationsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type IdVerificationsV1ResourceMutationsGrantVerificationAsAdminArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName: Scalars['String'];
  userId: Scalars['String'];
};


export type IdVerificationsV1ResourceMutationsResetIdVerificationAsAdminArgs = {
  id: Scalars['String'];
};


export type IdVerificationsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export const IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource = {
  Admin: 'ADMIN',
  Jumio: 'JUMIO',
  NameAttest: 'NAME_ATTEST',
  None: 'NONE',
  Persona: 'PERSONA',
  Sigtrack: 'SIGTRACK',
  SsoSignin: 'SSO_SIGNIN'
} as const;

export type IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource = typeof IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource[keyof typeof IdVerificationsV1_Org_Coursera_Userverification_Idverification_IdVerificationApprovalSource];
export type IdVerificationsV1_Org_Coursera_Userverification_Idverification_JumioIdVerificationAttemptHistory = {
  __typename?: 'IdVerificationsV1_org_coursera_userverification_idverification_JumioIdVerificationAttemptHistory';
  failedAttemptCount: Scalars['Int'];
};

/** Query for get completed in-lab instruction IDs */
export type InLabInstructionsQueries = {
  __typename?: 'InLabInstructionsQueries';
  /** Query for completed in-lab instructions in one course's item for one learner */
  getCompletedInstructionsForCurrentUser: InLabInstructions_CompletedInstructions;
};


/** Query for get completed in-lab instruction IDs */
export type InLabInstructionsQueriesGetCompletedInstructionsForCurrentUserArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};

/** Response of a completed in-lab instruction list query */
export type InLabInstructions_CompletedInstructions = {
  __typename?: 'InLabInstructions_CompletedInstructions';
  /** The list of completed instructions' ids after update */
  completedInstructionsForCurrentUser: Array<InLabInstructions_Instruction>;
  /** The course entity */
  course: Course_Course;
  /** The item ID */
  itemId: Scalars['ID'];
};

/** An in-lab instruction id */
export type InLabInstructions_Instruction = {
  __typename?: 'InLabInstructions_Instruction';
  /** The instruction ID */
  instructionId: Scalars['ID'];
};

/** Input to mark an in-lab instruction as complete */
export type InLabInstructions_MarkInstructionAsCompleteInput = {
  /** The course ID */
  courseId: Scalars['ID'];
  /** The instruction ID */
  instructionId: Scalars['ID'];
  /** The item ID */
  itemId: Scalars['ID'];
};

/** Response of marking an in-lab instruction as complete */
export type InLabInstructions_MarkInstructionAsCompleteResult = {
  __typename?: 'InLabInstructions_MarkInstructionAsCompleteResult';
  /** The list of completed instructions' ids */
  completedInstructions: Array<InLabInstructions_Instruction>;
  /** The course entity */
  course: Course_Course;
  /** The item ID */
  itemId: Scalars['ID'];
};

/** Inferred role of interest for the user. */
export type Inferred_CareerRolesOfInterest = {
  __typename?: 'Inferred_CareerRolesOfInterest';
  /** The confidence level of the inferred role */
  confidenceLevel: Confidence_Level;
  /** The inferred role for the user */
  role: Skill_CareerRole;
};

/** Root queries for InjectableActivities. */
export type InjectableActivitiesQueries = {
  __typename?: 'InjectableActivitiesQueries';
  /** Queries the current user's injectable activities for their current branch in the specified course. */
  queryMyInjectableActivitiesForCurrentBranch: InjectableActivities_InjectableActivityPaginatedResult;
};


/** Root queries for InjectableActivities. */
export type InjectableActivitiesQueriesQueryMyInjectableActivitiesForCurrentBranchArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/**
 * Represents the placement of an injectable activity adjacent to another item in course outline.
 * Implements InjectableItemPlacement.
 */
export type InjectableActivities_CourseOutlineItemPlacement = {
  __typename?: 'InjectableActivities_CourseOutlineItemPlacement';
  /** The unique identifier for the adjacent item (e.g. "bcdeg"). */
  adjacentItemId: Scalars['ID'];
  /** The display name of the injectable activity. */
  displayName: Scalars['String'];
  /** The locally unique identifier for this item. (e.g. "abcde") */
  itemId: Scalars['ID'];
  /** The unique identifier for the containing lesson. */
  lessonId: Scalars['ID'];
  /** The unique identifier for the containing module. */
  moduleId: Scalars['ID'];
  /** The position of this item ("abcde") relative to the adjacent item (e.g. "bcdeg"). */
  relativePosition: InjectableActivities_RelativePosition;
  /** The expected timeCommitment of the injectable activity. */
  timeCommitment: Scalars['Duration'];
};

/** An error that occurred while directly triggering the injection configuration. */
export type InjectableActivities_DirectlyTriggerInjectionConfigurationFailure = InjectableActivities_Error & {
  __typename?: 'InjectableActivities_DirectlyTriggerInjectionConfigurationFailure';
  /** The error message. */
  message: Scalars['String'];
};

/** Input schema for InjectableActivities_DirectlyTriggerInjectionConfiguration mutation */
export type InjectableActivities_DirectlyTriggerInjectionConfigurationInput = {
  /** An optional description for the trigger event. */
  description?: InputMaybe<Scalars['String']>;
  /** The unique identifier for the injection configuration to be triggered. */
  injectionConfigurationId: Scalars['ID'];
};

/** Result of directly triggering an injection configuration. */
export type InjectableActivities_DirectlyTriggerInjectionConfigurationResult = InjectableActivities_DirectlyTriggerInjectionConfigurationFailure | InjectableActivities_DirectlyTriggerInjectionConfigurationSuccess;

/** The trigger of the configuration was successful and a new execution was created. */
export type InjectableActivities_DirectlyTriggerInjectionConfigurationSuccess = {
  __typename?: 'InjectableActivities_DirectlyTriggerInjectionConfigurationSuccess';
  /** The unique identifier for the now running execution of the injection configuration. */
  injectionExecutionId: Scalars['ID'];
};

/** InjectableActivities domain error interface */
export type InjectableActivities_Error = {
  /** The error message. */
  message: Scalars['String'];
};

/** Represents an injectable activity that can be assigned to a course item. */
export type InjectableActivities_InjectableActivity = {
  __typename?: 'InjectableActivities_InjectableActivity';
  /** The course to which the injectable activity belongs. */
  course: Course_Course;
  /** The course branch to which the injectable activity belongs. */
  courseBranchId: Scalars['ID'];
  /** The unique identifier for the injectable activity. */
  id: Scalars['ID'];
  /** The placement of the injectable activity within the course experience. */
  placement: InjectableActivities_InjectableActivityPlacement;
  /** The progress of the injectable activity for the user. */
  progress: InjectableActivities_InjectableActivityProgress;
  /** The type of the injectable activity. */
  type: InjectableActivities_InjectableActivityType;
};

/** A paginated result containing injectable activities and pagination info. */
export type InjectableActivities_InjectableActivityPaginatedResult = {
  __typename?: 'InjectableActivities_InjectableActivityPaginatedResult';
  /** The list of injectable activities. */
  elements: Array<InjectableActivities_InjectableActivity>;
  /** Pagination information for the result set. */
  pagination: Pagination;
};

/** Represents the possible placements for an injectable activity. */
export type InjectableActivities_InjectableActivityPlacement = InjectableActivities_CourseOutlineItemPlacement;

/** Represents the progress of an injectable activity for a user. */
export type InjectableActivities_InjectableActivityProgress = {
  __typename?: 'InjectableActivities_InjectableActivityProgress';
  /** The unique identifier for the progress record. (e.g. userId~injectableActivityId) */
  id: Scalars['ID'];
  /** The unique identifier (UUID) for the injectable activity. */
  injectableActivityId: Scalars['ID'];
  /** The current progress state of the activity. */
  progressState: InjectableActivities_ProgressState;
};

/** Represents the type of an injectable activity. */
export type InjectableActivities_InjectableActivityType = {
  __typename?: 'InjectableActivities_InjectableActivityType';
  /** The unique identifier for the activity type. */
  id: Scalars['ID'];
  /** Unique snake case of the activity type. (e.g. flashcards, real-world-example) */
  typeName: Scalars['String'];
};

/** Represents the progress state of an injectable activity. */
export const InjectableActivities_ProgressState = {
  /** Represents that the injectable activity has been completed. */
  Completed: 'COMPLETED',
  /** Represents that the injectable activity has not been started. */
  NotStarted: 'NOT_STARTED',
  /** Represents that the injectable activity is in progress. */
  Started: 'STARTED'
} as const;

export type InjectableActivities_ProgressState = typeof InjectableActivities_ProgressState[keyof typeof InjectableActivities_ProgressState];
/** An error that occurred while provisioning the proactive AI experiment. */
export type InjectableActivities_ProvisionProactiveAiExperimentFailure = InjectableActivities_Error & {
  __typename?: 'InjectableActivities_ProvisionProactiveAiExperimentFailure';
  /** The error message. */
  message: Scalars['String'];
};

/** Input schema for InjectableActivities_ProvisionProactiveAiExperiment mutation */
export type InjectableActivities_ProvisionProactiveAiExperimentInput = {
  /** The unique identifier for the course branch to provision the proactive AI experiment for. */
  courseBranchId: Scalars['ID'];
};

/** Result of provisioning the proactive AI experiment. */
export type InjectableActivities_ProvisionProactiveAiExperimentResult = InjectableActivities_ProvisionProactiveAiExperimentFailure | InjectableActivities_ProvisionProactiveAiExperimentSuccess;

/** The provisioning of the proactive AI experiment was successful. */
export type InjectableActivities_ProvisionProactiveAiExperimentSuccess = {
  __typename?: 'InjectableActivities_ProvisionProactiveAiExperimentSuccess';
  /** Indicates that the experiment was successfully provisioned. */
  success: Scalars['Boolean'];
};

/** Possible positions for an adjacent item placement. */
export const InjectableActivities_RelativePosition = {
  /** Place the activity after the adjacent item. */
  After: 'AFTER',
  /** Place the activity before the adjacent item. */
  Before: 'BEFORE'
} as const;

export type InjectableActivities_RelativePosition = typeof InjectableActivities_RelativePosition[keyof typeof InjectableActivities_RelativePosition];
/** An error that occurred while updating the injectable activity progress. */
export type InjectableActivities_UpdateInjectableActivityProgressFailure = InjectableActivities_Error & {
  __typename?: 'InjectableActivities_UpdateInjectableActivityProgressFailure';
  /** The error message. */
  message: Scalars['String'];
};

/** Input schema for InjectableActivities_UpdateInjectableActivityProgress mutation */
export type InjectableActivities_UpdateInjectableActivityProgressInput = {
  /** The unique identifier for the injectable activity. */
  injectableActivityId: Scalars['ID'];
  /** The new progress state for the injectable activity. */
  progressState: InjectableActivities_ProgressState;
};

/** Result of updating injectable activity progress. */
export type InjectableActivities_UpdateInjectableActivityProgressResult = InjectableActivities_UpdateInjectableActivityProgressFailure | InjectableActivities_UpdateInjectableActivityProgressSuccess;

/** The update of injectable activity progress was successful. */
export type InjectableActivities_UpdateInjectableActivityProgressSuccess = {
  __typename?: 'InjectableActivities_UpdateInjectableActivityProgressSuccess';
  /** The updated injectable activity progress. */
  injectableActivityProgress: InjectableActivities_InjectableActivityProgress;
};

/** Queries for Institution Staff Invitations */
export type InstitutionStaffInvitationQueries = {
  __typename?: 'InstitutionStaffInvitationQueries';
  /** Returns Institution Staff Invitations for specified query params */
  queryStaffInvitations?: Maybe<InstitutionStaffInvitation_InvitationPagedResult>;
};


/** Queries for Institution Staff Invitations */
export type InstitutionStaffInvitationQueriesQueryStaffInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  invitationFilter: InstitutionStaffInvitation_InvitationQueryFilter;
  limit?: Scalars['Int'];
};

/** Accept Invitation failure response */
export type InstitutionStaffInvitation_AcceptInvitationFailureResult = {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitationFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<InstitutionStaffInvitation_AcceptInvitation_EmailMismatchError | InstitutionStaffInvitation_AcceptInvitation_ForbiddenError | InstitutionStaffInvitation_AcceptInvitation_InvalidStatusError | InstitutionStaffInvitation_AcceptInvitation_InvitationNotFoundError | InstitutionStaffInvitation_AcceptInvitation_UserNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_InternalError | InstitutionStaffInvitation_InviteStaffByEmails_PartnerNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_ValidationError | InstitutionStaffInvitation_RevokeInvitations_InternalError>;
};

/** Input for updating invitation role assignments */
export type InstitutionStaffInvitation_AcceptInvitationInput = {
  /**
   * invitation id associated with the invitation url that was used to land on coursera from an
   * invitation email
   */
  invitationId: Scalars['ID'];
  /** email address that the invitee registered with on coursera after landing via an invitation url. */
  inviteeRegisteredEmail: Scalars['ID'];
};

/** Accept Invitation result, can either be a success or failure */
export type InstitutionStaffInvitation_AcceptInvitationResult = InstitutionStaffInvitation_AcceptInvitationFailureResult | InstitutionStaffInvitation_AcceptInvitationSuccessResult;

/** Accept Invitation success response */
export type InstitutionStaffInvitation_AcceptInvitationSuccessResult = {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitationSuccessResult';
  /** Staff invitation id */
  invitationId: Scalars['ID'];
  /** Status of the invitation after acceptance has been processed */
  invitationStatus: InstitutionStaffInvitation_InvitationStatus;
};

/** Registered email does not match the invitation email */
export type InstitutionStaffInvitation_AcceptInvitation_EmailMismatchError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitation_EmailMismatchError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Logged-in user does not match the invitation's invitee */
export type InstitutionStaffInvitation_AcceptInvitation_ForbiddenError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitation_ForbiddenError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Invitation is not in INVITED status */
export type InstitutionStaffInvitation_AcceptInvitation_InvalidStatusError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitation_InvalidStatusError';
  /** The current status of the invitation */
  currentStatus: InstitutionStaffInvitation_InvitationStatus;
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Invitation ID not found */
export type InstitutionStaffInvitation_AcceptInvitation_InvitationNotFoundError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitation_InvitationNotFoundError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Invitee email not associated with any Coursera user */
export type InstitutionStaffInvitation_AcceptInvitation_UserNotFoundError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_AcceptInvitation_UserNotFoundError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/**
 * Domain-specific error interface for institution staff invitation mutations.
 * Clients can use this as a fallback for any new error types added in the future.
 */
export type InstitutionStaffInvitation_Error = {
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Invitation entity */
export type InstitutionStaffInvitation_Invitation = {
  __typename?: 'InstitutionStaffInvitation_Invitation';
  /** time when user accepted invitation */
  acceptedAt?: Maybe<Scalars['DateTime']>;
  /** time when invitation was cancelled */
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /** Id of user who cancelled/revoked the invitation */
  cancelledBy?: Maybe<Scalars['ID']>;
  /** time when invitation expired */
  expiredAt?: Maybe<Scalars['DateTime']>;
  /** Id of the invitation */
  invitationId: Scalars['ID'];
  /** Invitation status */
  invitationStatus: InstitutionStaffInvitation_InvitationStatus;
  /** time when user was invited */
  invitedAt?: Maybe<Scalars['DateTime']>;
  /** Id of user who initiated the invitation */
  invitedBy?: Maybe<Scalars['ID']>;
  /** Invitee's email */
  inviteeEmail: Scalars['String'];
  /** time when user joined via invitation */
  joinedAt?: Maybe<Scalars['DateTime']>;
  /** roles that invitee was assigned on invitation */
  roleTemplates: Array<InstitutionStaffInvitation_RoleTemplate>;
  /** Invitee's invitation membership scope */
  scope: InstitutionStaffInvitation_MembershipScope;
};

/** Describes what action was taken for each invitation in a batch invite request. */
export const InstitutionStaffInvitation_InvitationAction = {
  /** Invitee has existing Coursera account, directly added as staff */
  AddedAsStaff: 'ADDED_AS_STAFF',
  /** Invitation created for a new invitee, email sent */
  Created: 'CREATED',
  /** Previously CANCELLED invitation reactivated to INVITED, email sent */
  Reactivated: 'REACTIVATED',
  /** Invitee already has an INVITED invitation, no action taken */
  SkippedAlreadyInvited: 'SKIPPED_ALREADY_INVITED',
  /** Invitee already JOINED as staff, no action taken */
  SkippedAlreadyJoined: 'SKIPPED_ALREADY_JOINED',
  /** Existing INVITED invitation had roles updated, email resent */
  Updated: 'UPDATED'
} as const;

export type InstitutionStaffInvitation_InvitationAction = typeof InstitutionStaffInvitation_InvitationAction[keyof typeof InstitutionStaffInvitation_InvitationAction];
/** Invitation request input */
export type InstitutionStaffInvitation_InvitationInput = {
  /** email address of individual who is being invited */
  inviteeEmail: Scalars['String'];
  /** Ids of the roles that should be assigned to the invited individual */
  roleTemplateIds: Array<Scalars['ID']>;
  /** Staff Invitation scope */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Invitations where processing was refused due to invalid input */
export type InstitutionStaffInvitation_InvitationInputDeclined = {
  __typename?: 'InstitutionStaffInvitation_InvitationInputDeclined';
  /** email address of individual who was being invited */
  inviteeEmail: Scalars['String'];
  /** list of reasons of why the invitation input was rejected */
  reasons: Array<Scalars['String']>;
  /** Ids of the roles that were to be assigned to the invited individual */
  roleTemplateIds: Array<Scalars['ID']>;
  /** Staff Invitation scope */
  scope: InstitutionStaffInvitation_MembershipScope;
};

/**
 * Staff invitation result.
 * NOTE - Because we do not fail the entire request if some invitations internally failed,
 * Ensure to handle the following Scenarios;
 * - (userId = ${userId-value} && wasAddedAsStaff == false)
 *     - This means the invitation was NOT successfully processed for an inviteeEmail that
 * already exists on Coursera
 */
export type InstitutionStaffInvitation_InvitationOutput = {
  __typename?: 'InstitutionStaffInvitation_InvitationOutput';
  /** Describes what action was taken for this invitation */
  invitationAction: InstitutionStaffInvitation_InvitationAction;
  /**
   * Optional invitationId - Will have a value if the inviteeEmail owns an existing Coursera Account
   * When this has no value, then wasAddedAsStaff would be true
   * Otherwise when this has a value, then wasAddedAsStaff would be false
   */
  invitationId?: Maybe<Scalars['ID']>;
  /** Email that invitation was sent to */
  inviteeEmail: Scalars['String'];
  /**
   * Optional userId
   * Will return a value if the invitation was to an email having
   * an existing Coursera Account, other wise will not.
   */
  userId?: Maybe<Scalars['ID']>;
  /**
   * Flag that specifies whether the inviteeEmail was added as staff (i.e existing Coursera Account)
   * Or not (i.e new individual without an existing Coursera Account).
   * When this is true, then invitationId would have no value
   * Otherwise when this is false, then invitationId would have a value
   * @deprecated Use invitationAction instead
   */
  wasAddedAsStaff: Scalars['Boolean'];
};

/** Paginated invitation results. */
export type InstitutionStaffInvitation_InvitationPagedResult = {
  __typename?: 'InstitutionStaffInvitation_InvitationPagedResult';
  /** A list of invitation entities. */
  elements: Array<InstitutionStaffInvitation_Invitation>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Invitation request input */
export type InstitutionStaffInvitation_InvitationQueryFilter = {
  /** Optional filter results invitation status */
  invitationStatuses?: InputMaybe<Array<InstitutionStaffInvitation_InvitationStatus>>;
  /**
   * Staff-membership scope for an invitation
   * For now, only PARTNER scopeType is supported
   * If this API receives an unsupported scopeType it would return an appropriate message
   * detailing the unavailable support
   */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** invitation ids and reasons for Revocation failures */
export type InstitutionStaffInvitation_InvitationRevokeFailed = {
  __typename?: 'InstitutionStaffInvitation_InvitationRevokeFailed';
  /** List of reasons why the Revocation failed */
  failureReasons: Array<Scalars['String']>;
  /** Staff invitation id */
  invitationId: Scalars['ID'];
  /** invitation status after revoking. Successful revocation would have a status of CANCELLED */
  invitationStatus: InstitutionStaffInvitation_InvitationStatus;
};

/** Invitation status enum */
export const InstitutionStaffInvitation_InvitationStatus = {
  /** Status when a user's staff membership invitation has been revoked */
  Cancelled: 'CANCELLED',
  /** Initial status when a user is invited */
  Invited: 'INVITED',
  /** Status when a user has been added as a staff member of the institution */
  Joined: 'JOINED'
} as const;

export type InstitutionStaffInvitation_InvitationStatus = typeof InstitutionStaffInvitation_InvitationStatus[keyof typeof InstitutionStaffInvitation_InvitationStatus];
/** Invite Staff By Emails failure response */
export type InstitutionStaffInvitation_InviteStaffByEmailsFailureResult = {
  __typename?: 'InstitutionStaffInvitation_InviteStaffByEmailsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<InstitutionStaffInvitation_AcceptInvitation_EmailMismatchError | InstitutionStaffInvitation_AcceptInvitation_ForbiddenError | InstitutionStaffInvitation_AcceptInvitation_InvalidStatusError | InstitutionStaffInvitation_AcceptInvitation_InvitationNotFoundError | InstitutionStaffInvitation_AcceptInvitation_UserNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_InternalError | InstitutionStaffInvitation_InviteStaffByEmails_PartnerNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_ValidationError | InstitutionStaffInvitation_RevokeInvitations_InternalError>;
};

/** Staff Invitation input */
export type InstitutionStaffInvitation_InviteStaffByEmailsInput = {
  /** set of invitation inputs */
  invitations: Array<InstitutionStaffInvitation_InvitationInput>;
  /** Staff-membership scope for the invitations */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Invite Staff By Emails result, can either be a success or failure */
export type InstitutionStaffInvitation_InviteStaffByEmailsResult = InstitutionStaffInvitation_InviteStaffByEmailsFailureResult | InstitutionStaffInvitation_InviteStaffByEmailsSuccessResult;

/** Invite Staff By Emails success response */
export type InstitutionStaffInvitation_InviteStaffByEmailsSuccessResult = {
  __typename?: 'InstitutionStaffInvitation_InviteStaffByEmailsSuccessResult';
  /** List of invitation inputs that did not get processed due to invalid input values */
  invalidInvitationInputs: Array<InstitutionStaffInvitation_InvitationInputDeclined>;
  /** Staff invitation result */
  invitations?: Maybe<Array<InstitutionStaffInvitation_InvitationOutput>>;
};

/** Transient/internal error: email sending failure, staff membership creation failure */
export type InstitutionStaffInvitation_InviteStaffByEmails_InternalError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_InviteStaffByEmails_InternalError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Partner not found for the given scope */
export type InstitutionStaffInvitation_InviteStaffByEmails_PartnerNotFoundError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_InviteStaffByEmails_PartnerNotFoundError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Validation error: multiple scope IDs, invalid role templates, etc. */
export type InstitutionStaffInvitation_InviteStaffByEmails_ValidationError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_InviteStaffByEmails_ValidationError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Staff Invitation scope */
export type InstitutionStaffInvitation_MembershipScope = {
  __typename?: 'InstitutionStaffInvitation_MembershipScope';
  /** scopeId for the associated scopeType */
  scopeId: Scalars['ID'];
  /** Membership scope type for the invitation */
  scopeType: InstitutionStaffInvitation_ScopeType;
};

/** Staff Invitation scope input */
export type InstitutionStaffInvitation_MembershipScopeInput = {
  /** scopeId for the associated scopeType */
  scopeId: Scalars['ID'];
  /** Membership scope type for the invitation */
  scopeType: InstitutionStaffInvitation_ScopeType;
};

/** Revoke Invitation failure response */
export type InstitutionStaffInvitation_RevokeInvitationsFailureResult = {
  __typename?: 'InstitutionStaffInvitation_RevokeInvitationsFailureResult';
  /** List of errors resulting from an attempted mutation */
  errors: Array<InstitutionStaffInvitation_AcceptInvitation_EmailMismatchError | InstitutionStaffInvitation_AcceptInvitation_ForbiddenError | InstitutionStaffInvitation_AcceptInvitation_InvalidStatusError | InstitutionStaffInvitation_AcceptInvitation_InvitationNotFoundError | InstitutionStaffInvitation_AcceptInvitation_UserNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_InternalError | InstitutionStaffInvitation_InviteStaffByEmails_PartnerNotFoundError | InstitutionStaffInvitation_InviteStaffByEmails_ValidationError | InstitutionStaffInvitation_RevokeInvitations_InternalError>;
};

/** Input for revoking invitation */
export type InstitutionStaffInvitation_RevokeInvitationsInput = {
  /** invitation ids to be revoked */
  invitationIds: Array<Scalars['ID']>;
  /** Staff-membership scope for the invitations being revoked */
  scope: InstitutionStaffInvitation_MembershipScopeInput;
};

/** Revoke Invitation result, can either be a success or failure */
export type InstitutionStaffInvitation_RevokeInvitationsResult = InstitutionStaffInvitation_RevokeInvitationsFailureResult | InstitutionStaffInvitation_RevokeInvitationsSuccessResult;

/** Revoke Invitation success response */
export type InstitutionStaffInvitation_RevokeInvitationsSuccessResult = {
  __typename?: 'InstitutionStaffInvitation_RevokeInvitationsSuccessResult';
  /** List of invitation Ids that failed to get revoked */
  failedRevokeInvitations: Array<InstitutionStaffInvitation_InvitationRevokeFailed>;
  /** Staff invitation ids that were successfully revoked */
  successInvitationIds: Array<Scalars['ID']>;
};

/** Transient/internal error during revocation */
export type InstitutionStaffInvitation_RevokeInvitations_InternalError = InstitutionStaffInvitation_Error & {
  __typename?: 'InstitutionStaffInvitation_RevokeInvitations_InternalError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Role Template */
export type InstitutionStaffInvitation_RoleTemplate = {
  __typename?: 'InstitutionStaffInvitation_RoleTemplate';
  /** User friendly display name of the role template */
  displayName: Scalars['String'];
  /** Id for the role template */
  roleTemplateId: Scalars['ID'];
};

/**
 * Membership scope type for an invitation
 * Known admin staff-membership scope types are [PARTNER, COURSE, GROUP, DEGREE]
 * Only PARTNER admin scope is supported for now, but this enum is to provide flexibility to
 * support the other scopes when required. They can be added here when support is to be implemented.
 */
export const InstitutionStaffInvitation_ScopeType = {
  /** Type name for partner scope */
  Partner: 'PARTNER'
} as const;

export type InstitutionStaffInvitation_ScopeType = typeof InstitutionStaffInvitation_ScopeType[keyof typeof InstitutionStaffInvitation_ScopeType];
export type InstructorProfilesV1 = {
  __typename?: 'InstructorProfilesV1';
  bio: Scalars['String'];
  certificateTitle: Scalars['String'];
  department: Scalars['String'];
  email: Scalars['String'];
  ethnicities: Array<Maybe<Scalars['String']>>;
  fullName: Scalars['String'];
  id: Scalars['Int'];
  lastUpdatedByUser?: Maybe<Scalars['Float']>;
  photo: Scalars['String'];
  shortName: Scalars['String'];
  showOnPartnerPage: Scalars['Boolean'];
  signature: Scalars['String'];
  social: InstructorProfilesV1_Org_Coursera_Instructor_SocialInfo;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<InstructorProfilesV1_Org_Coursera_User_UserId>;
};

export type InstructorProfilesV1Connection = {
  __typename?: 'InstructorProfilesV1Connection';
  elements: Array<Maybe<InstructorProfilesV1>>;
  paging: ResponsePagination;
};

export type InstructorProfilesV1Resource = {
  __typename?: 'InstructorProfilesV1Resource';
  get?: Maybe<InstructorProfilesV1>;
  multiGet?: Maybe<InstructorProfilesV1Connection>;
  shortName?: Maybe<InstructorProfilesV1Connection>;
};


export type InstructorProfilesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type InstructorProfilesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type InstructorProfilesV1ResourceShortNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type InstructorProfilesV1ResourceMutations = {
  __typename?: 'InstructorProfilesV1ResourceMutations';
  createProfile?: Maybe<Scalars['JSON']>;
  delete?: Maybe<InstructorProfilesV1Connection>;
  findByEmail?: Maybe<Scalars['JSON']>;
  update?: Maybe<InstructorProfilesV1Connection>;
};


export type InstructorProfilesV1ResourceMutationsCreateProfileArgs = {
  id: Scalars['String'];
  partnerId: Scalars['String'];
};


export type InstructorProfilesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type InstructorProfilesV1ResourceMutationsFindByEmailArgs = {
  email: Scalars['String'];
};


export type InstructorProfilesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type InstructorProfilesV1ShortName = {
  __typename?: 'InstructorProfilesV1ShortName';
  connection?: Maybe<InstructorProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type InstructorProfilesV1_Org_Coursera_Instructor_SocialInfo = {
  __typename?: 'InstructorProfilesV1_org_coursera_instructor_SocialInfo';
  facebook: Scalars['String'];
  gplus: Scalars['String'];
  linkedin: Scalars['String'];
  twitter: Scalars['String'];
  websites: Array<Maybe<Scalars['String']>>;
  youtube: Scalars['String'];
};

export type InstructorProfilesV1_Org_Coursera_User_UserId = {
  __typename?: 'InstructorProfilesV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

/** Federated Instructor entity stub */
export type Instructor_Instructor = {
  __typename?: 'Instructor_Instructor';
  /** String representation of an instructor id, eg. "1909875" */
  id: Scalars['ID'];
};

export type InstructorsV1 = {
  __typename?: 'InstructorsV1';
  bio: Scalars['String'];
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  department?: Maybe<Scalars['String']>;
  displayOnPartnerPage: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  nameTitleDepartmentUniversity: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  partners?: Maybe<PartnersV1Connection>;
  photo?: Maybe<Scalars['String']>;
  prefixName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  suffixName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  websites?: Maybe<InstructorsV1_Org_Coursera_Catalogp_InstructorWebsites>;
};


export type InstructorsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type InstructorsV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type InstructorsV1Connection = {
  __typename?: 'InstructorsV1Connection';
  elements: Array<Maybe<InstructorsV1>>;
  paging: ResponsePagination;
};

export type InstructorsV1Resource = {
  __typename?: 'InstructorsV1Resource';
  get?: Maybe<InstructorsV1>;
  getAll?: Maybe<InstructorsV1Connection>;
  multiGet?: Maybe<InstructorsV1Connection>;
  shortName?: Maybe<InstructorsV1Connection>;
};


export type InstructorsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type InstructorsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type InstructorsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type InstructorsV1ResourceShortNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type InstructorsV1ShortName = {
  __typename?: 'InstructorsV1ShortName';
  connection?: Maybe<InstructorsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type InstructorsV1_Org_Coursera_Catalogp_InstructorWebsites = {
  __typename?: 'InstructorsV1_org_coursera_catalogp_InstructorWebsites';
  website?: Maybe<Scalars['String']>;
  websiteFacebook?: Maybe<Scalars['String']>;
  websiteGplus?: Maybe<Scalars['String']>;
  websiteLinkedin?: Maybe<Scalars['String']>;
  websiteTwitter?: Maybe<Scalars['String']>;
};

/** Academic integrity checks. */
export type IntegrityCheckQueries = {
  __typename?: 'IntegrityCheckQueries';
  /** Run the specified integrity checks. */
  queryIntegrityChecks?: Maybe<IntegrityCheck_CheckResult>;
};


/** Academic integrity checks. */
export type IntegrityCheckQueriesQueryIntegrityChecksArgs = {
  orderedChecks: Array<IntegrityCheck_StageDefinitionInput>;
  submission: IntegrityCheck_SubmissionInput;
};

/** The type of assessment for which the integrity check is being run. */
export const IntegrityCheck_AssessmentType = {
  /** The assessment is an assignment */
  Assignment: 'ASSIGNMENT',
  /** The assessment is a peer review */
  PeerReview: 'PEER_REVIEW'
} as const;

export type IntegrityCheck_AssessmentType = typeof IntegrityCheck_AssessmentType[keyof typeof IntegrityCheck_AssessmentType];
/** The assignment level check result */
export type IntegrityCheck_CheckResult = {
  __typename?: 'IntegrityCheck_CheckResult';
  /** The level of deterrence to apply to this submission */
  deterrence: IntegrityCheck_DeterrenceType;
  /** The individual prompt results */
  promptResults: Array<IntegrityCheck_PromptResult>;
};

/** The type of check to be applied */
export const IntegrityCheck_CheckType = {
  /** Detects gibberish and returns a boolean. */
  Gibberish: 'GIBBERISH',
  /** Uses simtext to compute a similarity score from 0 to 100. */
  Textsimilarity: 'TEXTSIMILARITY'
} as const;

export type IntegrityCheck_CheckType = typeof IntegrityCheck_CheckType[keyof typeof IntegrityCheck_CheckType];
/** The actual content for a given prompt. */
export type IntegrityCheck_ContentInput = {
  /** The URL of the submitted file */
  fileUrl?: InputMaybe<Scalars['String']>;
  /** The text content for prompts with type TEXT */
  textContent?: InputMaybe<Scalars['String']>;
  /**
   * Tagged union. Depending on the value, the server expects the corresponding
   * field to be present and non null.
   * typeTag == TEXT => textContent is present.
   * typeTag == FILE => fileUrl is present.
   */
  typeTag: IntegrityCheck_ContentInputType;
};

/**
 * The content type of a given submission prompt.
 * Currently, text and files are supported.
 * Possibly support urls in the future.
 */
export const IntegrityCheck_ContentInputType = {
  /** The FILE type is used for file uploads. */
  File: 'FILE',
  /** The TEXT type is used for raw text, cml, and html. */
  Text: 'TEXT'
} as const;

export type IntegrityCheck_ContentInputType = typeof IntegrityCheck_ContentInputType[keyof typeof IntegrityCheck_ContentInputType];
/** The types of deterrence that we can indicate. */
export const IntegrityCheck_DeterrenceType = {
  /** This prompt should be actively deterred from submission */
  IntegrityCheckActive: 'INTEGRITY_CHECK_ACTIVE',
  /** No deterrence is necessary for this prompt */
  IntegrityCheckNone: 'INTEGRITY_CHECK_NONE',
  /** This prompt should be passively deterred from submission */
  IntegrityCheckPassive: 'INTEGRITY_CHECK_PASSIVE'
} as const;

export type IntegrityCheck_DeterrenceType = typeof IntegrityCheck_DeterrenceType[keyof typeof IntegrityCheck_DeterrenceType];
/** The result for gibberish checking */
export type IntegrityCheck_GibberishResult = {
  __typename?: 'IntegrityCheck_GibberishResult';
  /** The summarized gibberish status of this check */
  gibberish_status: GibberishStatus;
  /** The gibberish score */
  score: Scalars['Int'];
};

/** The result of a check for an individual submission prompt */
export type IntegrityCheck_PromptResult = {
  __typename?: 'IntegrityCheck_PromptResult';
  /** The results from each pipeline stage (if available) */
  checkResults: Array<IntegrityCheck_Result>;
  /** The checks that require deterrence */
  deterredChecks: Array<Maybe<IntegrityCheck_CheckType>>;
  /** Prompt id */
  promptId: Scalars['ID'];
};

/** The result of a particular stage */
export type IntegrityCheck_Result = IntegrityCheck_GibberishResult | IntegrityCheck_TextSimilarityResult;

/** The configuration for a stage in the check pipeline */
export type IntegrityCheck_StageDefinitionInput = {
  /** The type of check to be executed at this stage */
  checkType: IntegrityCheck_CheckType;
  /**
   * This flag is used for indicating whether or not "failing" submission
   * prompts should be filtered out before executing the next stage.
   */
  withFiltering: Scalars['Boolean'];
};

/** The submission to be checked */
export type IntegrityCheck_SubmissionInput = {
  /** The type of assessment */
  assessmentType?: InputMaybe<IntegrityCheck_AssessmentType>;
  /** The assignment id */
  assignmentId: Scalars['ID'];
  /** The assignment version */
  assignmentVersion?: InputMaybe<Scalars['Int']>;
  /** The individual submission prompts to be checked */
  prompts: Array<IntegrityCheck_SubmissionPromptInput>;
  /** The submitter id */
  submitterId: Scalars['ID'];
  /**
   * Intended to be the submission version, but was used as an assignment version on the frontend.
   * @deprecated This has been used as an assignment version on the frontend, but was not used on the backend. Please use assignmentVersion instead.
   */
  version?: InputMaybe<Scalars['Int']>;
};

/** A single prompt from a submission */
export type IntegrityCheck_SubmissionPromptInput = {
  /**
   * The enablement configuration to be used for this prompt
   * @deprecated The configurationId field is deprecated and will be removed in the future. Use the prompt's enablement data instead.
   */
  configurationId?: InputMaybe<Scalars['ID']>;
  /** Content of the prompt which should be checked */
  content: IntegrityCheck_ContentInput;
  /** Prompt id */
  promptId: Scalars['ID'];
};

/** The result for text similarity checking */
export type IntegrityCheck_TextSimilarityResult = {
  __typename?: 'IntegrityCheck_TextSimilarityResult';
  /** The summarized plagiarism status of this check */
  plagiarism_status: PlagiarismStatus;
  /** The similarity score */
  score: Scalars['Int'];
};

/** Queries related to integrity settings */
export type IntegritySettingsQueriesV2 = {
  __typename?: 'IntegritySettingsQueriesV2';
  /** Get integrity settings for an assessment in a private or public course session */
  queryIntegritySettings: Array<Integrity_IntegritySettings>;
};


/** Queries related to integrity settings */
export type IntegritySettingsQueriesV2QueryIntegritySettingsArgs = {
  settingsIds: Array<Integrity_SettingsIdentifier>;
};

/** Settings for an assessment which is proctored using AutoProctor. */
export type Integrity_AutoProctorSettings = {
  __typename?: 'Integrity_AutoProctorSettings';
  /** The client ID to be used when creating an AutoProctor session. Only available if enabled is true. */
  clientId?: Maybe<Scalars['ID']>;
  /** Whether or not the assessment is being proctored by AutoProctor. */
  enabled: Scalars['Boolean'];
  /** The in-progress or next attemptId signed using AutoProctor's secret key, can be used to create a proctoring session. Only available if enabled is true. */
  hashedAttemptId?: Maybe<Scalars['ID']>;
};

/** Settings for Coursera Proctoring for an assessment. */
export type Integrity_CourseraProctoringSettings = {
  __typename?: 'Integrity_CourseraProctoringSettings';
  /** Configuration for proctoring. Only present if proctoring is enabled. */
  configuration?: Maybe<CourseraProctoring_Configuration>;
  /** Whether or not the assessment is being proctored. */
  enabled: Scalars['Boolean'];
};

/** Settings for assessments which are in sessions being proctored by the external service Honorlock. */
export type Integrity_HonorlockSettings = {
  __typename?: 'Integrity_HonorlockSettings';
  /** Whether or not the assessment is being proctored by Honorlock. */
  enabled: Scalars['Boolean'];
};

/** Academic integrity prevention settings. */
export type Integrity_IntegritySettings = {
  __typename?: 'Integrity_IntegritySettings';
  /** Identifier of the in-progress attempt, otherwise, next attempt. Can be null if assessment doesn't have attempts. */
  attemptId?: Maybe<Scalars['ID']>;
  /** Settings for an assessment which is proctored using AutoProctor. */
  autoProctorSettings: Integrity_AutoProctorSettings;
  /** The course in which integrity settings are fetched. */
  course: Course_Course;
  /** Settings for an assessment which is proctored using Coursera Proctoring. */
  courseraProctoringSettings: Integrity_CourseraProctoringSettings;
  /** Settings for assessments which are in sessions being proctored by the external service Honorlock. */
  honorlockSettings: Integrity_HonorlockSettings;
  /** Settings for assessments which require the use of a locking browser. */
  lockingBrowserSettings: Integrity_LockingBrowserSettings;
  /** The course session in which integrity settings are fetched. */
  session: Session_Session;
  /** Settings for Viva Exam feature. */
  vivaExamSettings: Integrity_VivaExamSettings;
};

/** Exclusion data for a given learner */
export type Integrity_LockingBrowserExclusion = {
  __typename?: 'Integrity_LockingBrowserExclusion';
  /** Time of exclusion creation */
  created: Scalars['DateTime'];
  /** The ID of the learner being excluded */
  learner: User_PublicUser;
};

/** Settings for assessments which require the use of a locking browser */
export type Integrity_LockingBrowserSettings = {
  __typename?: 'Integrity_LockingBrowserSettings';
  /** Whether or not the assessment requires the use of the locking browser */
  enabled: Scalars['Boolean'];
  /**
   * Is the locking browser enabled for the user making the request excluded? This does not make sense when
   * requesting bulk exclusions.
   */
  enabledForCurrentUser: Scalars['Boolean'];
  /** Which students have been excluded from the enablement, if enabled */
  exclusions: Array<Integrity_LockingBrowserExclusion>;
};

/** An identifier of integrity settings */
export type Integrity_SettingsIdentifier = {
  /** The id of the assessment */
  assessmentId: Scalars['ID'];
  /** The type of the assessment */
  assessmentType: ExamMonitor_AssessmentType;
  /** The version of the assessment */
  assessmentVersion: Scalars['Int'];
  /** The id of the course */
  courseId: Scalars['ID'];
  /** The id of the course session */
  sessionId: Scalars['ID'];
};

/** Settings for Viva Exam feature */
export type Integrity_VivaExamSettings = {
  __typename?: 'Integrity_VivaExamSettings';
  /** The status of the viva exam configuration */
  status: VivaExam_ConfigurationStatus;
};

/** IntlCompliance_PreEnrollmentIdInput */
export type IntlCompliance_PreEnrollmentIdInput = {
  /** The ID of the pre-enrollment for which the user is consenting to recurring charges. */
  id: Scalars['ID'];
};

/** Recurring charge consent request payload. */
export type IntlCompliance_RecurringChargeConsentInput = {
  /** IntlCompliance_PreEnrollmentIdInput */
  preEnrollmentId?: InputMaybe<IntlCompliance_PreEnrollmentIdInput>;
  /** IntlCompliance_SubscriptionCartIdInput */
  subscriptionCartId?: InputMaybe<IntlCompliance_SubscriptionCartIdInput>;
};

/** Successful mutation that returns empty response payload */
export type IntlCompliance_RecurringChargeConsentResult = {
  __typename?: 'IntlCompliance_RecurringChargeConsentResult';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** IntlCompliance_SubscriptionCartIdInput */
export type IntlCompliance_SubscriptionCartIdInput = {
  /** The ID of the subscription cart for which the user is consenting to recurring charges. */
  id: Scalars['ID'];
};

/** Third Party Organization - extended for federation */
export type InvoiceOrder_ThirdPartyOrganization = {
  __typename?: 'InvoiceOrder_ThirdPartyOrganization';
  /** A unique ID for a Third Party Organization */
  id: Scalars['ID'];
  /** Third party organization name */
  name: Scalars['String'];
  /** Organization type */
  organizationType?: Maybe<EnterpriseContractInvoice_OrganizationType>;
};

/** Namespace wrapper for Item authoring queries */
export type ItemAuthoringQueries = {
  __typename?: 'ItemAuthoringQueries';
  /**
   * Populate reusability properties for specified atoms.
   * Method extract all atoms from specified branch and populate requested reusable properties | Maximum page size: 1000
   */
  atomReusabilityProperties?: Maybe<ItemAuthoring_ItemReusabilityPropertiesConnection>;
  /** Fetch whether the current user has permissions to edit a given atom */
  queryAuthoringEditPermissionsByAtomId?: Maybe<ItemAuthoring_AuthoringEditPermissions>;
  /** Fetch an authoring item by its atom id, which can be both versioned or unversioned */
  queryAuthoringItemByAtomId?: Maybe<ItemPlatform_AuthoringItem>;
  /** Fetch all the parent contexts an atom is used in | Maximum page size: 100 */
  queryParentBranchByAtomId?: Maybe<ItemAuthoring_ItemParentBranchConnection>;
};


/** Namespace wrapper for Item authoring queries */
export type ItemAuthoringQueriesAtomReusabilityPropertiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  sourceBranchId: Scalars['ID'];
};


/** Namespace wrapper for Item authoring queries */
export type ItemAuthoringQueriesQueryAuthoringEditPermissionsByAtomIdArgs = {
  atomId: Scalars['ID'];
};


/** Namespace wrapper for Item authoring queries */
export type ItemAuthoringQueriesQueryAuthoringItemByAtomIdArgs = {
  atomId: Scalars['ID'];
  courseId?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
};


/** Namespace wrapper for Item authoring queries */
export type ItemAuthoringQueriesQueryParentBranchByAtomIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  atomId: Scalars['ID'];
  first?: Scalars['Int'];
};

/** Indicates whether a user has authoring edit permissions */
export type ItemAuthoring_AuthoringEditPermissions = {
  __typename?: 'ItemAuthoring_AuthoringEditPermissions';
  /** True if the user has the requested permissions */
  hasPermissions: Scalars['Boolean'];
};

/** Indicates the status of a branch and its association with sessions */
export const ItemAuthoring_BranchStatus = {
  /**
   * Branch is not associated with a currently running session or future sessions, but was
   * associated with a past session
   */
  Archived: 'ARCHIVED',
  /** Branch is in the process of being created and cannot be accessed or modified yet */
  Creating: 'CREATING',
  /**
   * Branch is either associated with a currently running session OR
   * has a past session along with a future scheduled session OR
   * has a past session and is the branch that would be associated with new future sessions
   */
  Live: 'LIVE',
  /** Branch isn't associated with any sessions */
  New: 'NEW',
  /** Branch has been submitted for approval but has not yet been approved for use in sessions */
  Pending: 'PENDING',
  /** Branch is about to go live in a future session for the first time */
  Upcoming: 'UPCOMING'
} as const;

export type ItemAuthoring_BranchStatus = typeof ItemAuthoring_BranchStatus[keyof typeof ItemAuthoring_BranchStatus];
/** Returned if ItemAuthoring_DiscardItemDraft ran into a client-actionable error */
export type ItemAuthoring_DiscardItemDraftFailure = {
  __typename?: 'ItemAuthoring_DiscardItemDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for the ItemAuthoring_DiscardItemDraft mutation */
export type ItemAuthoring_DiscardItemDraftInput = {
  /** Id of the atom whose draft is to be discarded */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
};

/** Result union for the ItemAuthoring_DiscardItemDraft mutation */
export type ItemAuthoring_DiscardItemDraftResult = ItemAuthoring_DiscardItemDraftFailure | ItemAuthoring_DiscardItemDraftSuccess;

/** Returned if ItemAuthoring_DiscardItemDraft completed successfully */
export type ItemAuthoring_DiscardItemDraftSuccess = {
  __typename?: 'ItemAuthoring_DiscardItemDraftSuccess';
  /** The updated item */
  item: ItemPlatform_AuthoringItem;
};

/** Represents a parent branch that contains a given item */
export type ItemAuthoring_ItemParentBranch = Node & {
  __typename?: 'ItemAuthoring_ItemParentBranch';
  /** Id of the branch's parent course */
  courseId: Scalars['ID'];
  /** Name of the branch's parent course */
  courseName: Scalars['String'];
  /** Slug of the branch's parent course */
  courseSlug: Scalars['String'];
  /** Id of the parent authoringCourseBranch */
  id: Scalars['ID'];
  /** boolean flag indicating if the atom reference in this branch is at the latest version of the atom */
  isAtomAtLatestVersion: Scalars['Boolean'];
  /** Denotes if the branch is private or public */
  isPrivate: Scalars['Boolean'];
  /** User created name of the branch */
  name: Scalars['String'];
  /** Current status of the branch */
  status: ItemAuthoring_BranchStatus;
};

/** Connection wrapper for ItemAuthoring_ItemParentBranch */
export type ItemAuthoring_ItemParentBranchConnection = {
  __typename?: 'ItemAuthoring_ItemParentBranchConnection';
  /** List of parent branches */
  edges: Array<ItemAuthoring_ItemParentBranchEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
};

/** Edge wrapper for ItemAuthoring_ItemParentBranch */
export type ItemAuthoring_ItemParentBranchEdge = {
  __typename?: 'ItemAuthoring_ItemParentBranchEdge';
  /** Pagination cursor */
  cursor: Scalars['String'];
  /** Contains the actual ItemAuthoring_ItemParentBranch */
  node: ItemAuthoring_ItemParentBranch;
};

/** Contains ItemAuthoring reusablity properties */
export type ItemAuthoring_ItemReusabilityProperties = Node & {
  __typename?: 'ItemAuthoring_ItemReusabilityProperties';
  /** Indicate if ItemAuthoring is copyable to public branch or not */
  copyableToPublicBranch: Scalars['Boolean'];
  /** ItemAuthoring atom Id */
  id: Scalars['ID'];
};

/** Connection wrapper for ItemAuthoring_ItemReusabilityProperties */
export type ItemAuthoring_ItemReusabilityPropertiesConnection = {
  __typename?: 'ItemAuthoring_ItemReusabilityPropertiesConnection';
  /** List of reusable properties */
  edges: Array<ItemAuthoring_ItemReusabilityPropertiesEdge>;
  /** Pagination metadata */
  pageInfo: PageInfo;
};

/** Edge wrapper for ItemAuthoring_ItemReusabilityProperties */
export type ItemAuthoring_ItemReusabilityPropertiesEdge = {
  __typename?: 'ItemAuthoring_ItemReusabilityPropertiesEdge';
  /** Pagination cursor */
  cursor: Scalars['String'];
  /** Contains the actual ItemAuthoring_ItemReusabilityProperties */
  node: ItemAuthoring_ItemReusabilityProperties;
};

/** All queries related to item personalization */
export type ItemPersonalizationQueries = {
  __typename?: 'ItemPersonalizationQueries';
  /**
   * Get all item personalizations for a learner for a given action(s).
   * This should be used with action SKIP to determine which items can be skipped and
   * determine time saved. This should be used with action
   * FOCUS to determine which items to recommend next and with action SKIP to determine which items
   * to not display (UX TBD).
   */
  getAllItemPersonalizationsByLearnerAndAction: ItemPersonalization_ItemPersonalizationPaginatedResult;
};


/** All queries related to item personalization */
export type ItemPersonalizationQueriesGetAllItemPersonalizationsByLearnerAndActionArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  personalizationAction?: InputMaybe<Array<ItemPersonalization_PersonalizationAction>>;
};

/** Input for creating an item personalization record */
export type ItemPersonalization_CreateItemPersonalizationInput = {
  /** The branch ID */
  branchId: Scalars['ID'];
  /** The course ID */
  courseId: Scalars['ID'];
  /** The item ID to personalize */
  itemId: Scalars['ID'];
  /** The personalization action to apply (e.g., SKIP or FOCUS) */
  personalizationAction: ItemPersonalization_PersonalizationAction;
  /** The source of the personalization (e.g., VERIFIED_SKILLS_DIAGNOSTIC) */
  personalizationSource: ItemPersonalization_PersonalizationSource;
};

/** Result of creating an item personalization */
export type ItemPersonalization_CreateItemPersonalizationResult = {
  __typename?: 'ItemPersonalization_CreateItemPersonalizationResult';
  /** The created item personalization record */
  itemPersonalization: ItemPersonalization_ItemPersonalization;
};

/** Item personalization containing the personalization action for a learner's item */
export type ItemPersonalization_ItemPersonalization = {
  __typename?: 'ItemPersonalization_ItemPersonalization';
  /** The branch ID */
  branchId: Scalars['ID'];
  /** The course */
  course: Course_Course;
  /** The item ID */
  itemId: Scalars['ID'];
  /** The learner ID */
  learnerId: Scalars['ID'];
  /** The personalization action */
  personalizationAction: ItemPersonalization_PersonalizationAction;
  /** The personalization action */
  personalizationSource: ItemPersonalization_PersonalizationSource;
};

/** Paginated result wrapper for ItemPersonalization_ItemPersonalization */
export type ItemPersonalization_ItemPersonalizationPaginatedResult = {
  __typename?: 'ItemPersonalization_ItemPersonalizationPaginatedResult';
  /** A list of item personalizations that match the provided filters */
  elements: Array<ItemPersonalization_ItemPersonalization>;
  /** Pagination information */
  pagination: Pagination;
};

/** The personalization action to be applied to an item for a learner */
export const ItemPersonalization_PersonalizationAction = {
  /** Focus on the item */
  Focus: 'FOCUS',
  /** Skip the item */
  Skip: 'SKIP'
} as const;

export type ItemPersonalization_PersonalizationAction = typeof ItemPersonalization_PersonalizationAction[keyof typeof ItemPersonalization_PersonalizationAction];
/** The personalization source */
export const ItemPersonalization_PersonalizationSource = {
  /** Verified Skills Assessment */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** Diagnostics Assessment */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC'
} as const;

export type ItemPersonalization_PersonalizationSource = typeof ItemPersonalization_PersonalizationSource[keyof typeof ItemPersonalization_PersonalizationSource];
/** Assignment content */
export type ItemPlatform_AssignmentContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_AssignmentContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/**
 * Denotes whether a created atom was manually created by a user, or generated with AI assistance. Needed for Guided Review
 * to identify AI-generated items.
 */
export const ItemPlatform_AtomGenerationSource = {
  /** Indicates that the atom was generated with AI assistance */
  Ai: 'AI',
  /** Indicates that the atom was manually created by a user */
  User: 'USER'
} as const;

export type ItemPlatform_AtomGenerationSource = typeof ItemPlatform_AtomGenerationSource[keyof typeof ItemPlatform_AtomGenerationSource];
/** Represents an item and its in-progress drafts */
export type ItemPlatform_AuthoringItem = {
  __typename?: 'ItemPlatform_AuthoringItem';
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /**
   * Conflict detection token, expected to be passed in with mutations to help determine if
   * conflicting edits have been made. Can be null if the user can't edit the current item, either
   * due to a lack of permissions or because the item is frozen at a previous version
   */
  conflictDetectionToken?: Maybe<Scalars['String']>;
  /**
   * Current draft version of an item. Can be null if no changes have been made compared to the last
   * published version. Expected to be of the same type as `publishedItemContent`.
   */
  draftItemContent?: Maybe<ItemPlatform_AssignmentContent | ItemPlatform_CoachItemContent | ItemPlatform_DiscussionPromptContent | ItemPlatform_LectureContent | ItemPlatform_PeerReviewContent | ItemPlatform_PlaceholderContent | ItemPlatform_ProgrammingAssignmentContent | ItemPlatform_QuizContent | ItemPlatform_ReadingContent | ItemPlatform_TeammateReviewContent | ItemPlatform_UngradedLabContent | ItemPlatform_WidgetContent | ItemPlatform_WiseflowContent | LtiPlatform_LtiContent>;
  /** Id of the underlying atom. */
  id: Scalars['ID'];
  /** Item type of the current item */
  itemType: ItemPlatform_ItemType;
  /** Currently published version of an item. Expected to be of the same type as `draftItemContent`. */
  publishedItemContent: ItemPlatform_AssignmentContent | ItemPlatform_CoachItemContent | ItemPlatform_DiscussionPromptContent | ItemPlatform_LectureContent | ItemPlatform_PeerReviewContent | ItemPlatform_PlaceholderContent | ItemPlatform_ProgrammingAssignmentContent | ItemPlatform_QuizContent | ItemPlatform_ReadingContent | ItemPlatform_TeammateReviewContent | ItemPlatform_UngradedLabContent | ItemPlatform_WidgetContent | ItemPlatform_WiseflowContent | LtiPlatform_LtiContent;
};

/** Authoring items with paginations */
export type ItemPlatform_AuthoringItemsPaginatedResult = {
  __typename?: 'ItemPlatform_AuthoringItemsPaginatedResult';
  /** Items elements */
  elements: Array<ItemPlatform_AuthoringItem>;
  /** Pagination */
  pagination: Pagination;
};

/** CoachItem content */
export type ItemPlatform_CoachItemContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_CoachItemContent';
  /** coach item content, in CoachActivity format */
  coachActivity?: Maybe<CoachItemAuthoring_CoachActivity>;
  /** Whether the coach item is graded */
  isGraded?: Maybe<Scalars['Boolean']>;
  /** User authored name of the item */
  name: Scalars['String'];
  /** Passing fraction threshold (0.0 to 1.0). Only applicable when isGraded is true. */
  passingFraction?: Maybe<Scalars['Float']>;
  /** Submission limit configuration. Only applicable when isGraded is true. */
  submissionLimitConfig?: Maybe<CoachItemAuthoring_SubmissionLimitConfig>;
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
  /** versioned Id of the underlying coach activity */
  versionedCoachActivityId?: Maybe<Scalars['ID']>;
};

/**
 * Error returned when the conflictDetectionToken passed in as a mutation input didn't match the
 * expected value, indicating that a conflicting change has occurred
 */
export type ItemPlatform_ConflictDetectionTokenMismatchError = ErrorDetails & {
  __typename?: 'ItemPlatform_ConflictDetectionTokenMismatchError';
  /**
   * Error code that can be used by our tooling for error metrics.
   *
   * When developer defines a new custom error using the ErrorDetails interface,
   * they should use the name of the custom error as the errorCode.
   */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Discussion prompt content */
export type ItemPlatform_DiscussionPromptContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_DiscussionPromptContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/**
 * Error returned when a client attempts to mutate an atom that has been frozen to a specific version.
 * Instructors must first unfreeze/fast-forward their atom to the latest version before changes can be
 * made.
 */
export type ItemPlatform_FrozenAtomMutationError = ErrorDetails & {
  __typename?: 'ItemPlatform_FrozenAtomMutationError';
  /**
   * Error code that can be used by our tooling for error metrics.
   *
   * When developer defines a new custom error using the ErrorDetails interface,
   * they should use the name of the custom error as the errorCode.
   */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** An interface that all different published/draft item content types should implement */
export type ItemPlatform_ItemContent = {
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Represents the passing fraction of an item within a branch. */
export type ItemPlatform_ItemPassingFraction = {
  __typename?: 'ItemPlatform_ItemPassingFraction';
  /** Branch item ID. */
  itemId: Scalars['ID'];
  /** Passing fraction for the item in the branch. Value is between 0 and 1 (inclusive). */
  passingFraction: Scalars['Float'];
};

/**
 * List of supported item types.
 * See https://coursera.atlassian.net/wiki/spaces/CP/pages/2743533707/Item+Types+a+complete+list for documentation about
 * each item type.
 */
export const ItemPlatform_ItemType = {
  /**
   * Assignment item. Previously known as staff-graded assignments or SGAs, the Unified Assignment project has expanded
   * their role to encompass use cases previously handled by QUIZ items. Can be either graded or ungraded.
   */
  Assignment: 'ASSIGNMENT',
  /** Coach Item. Either a Socratic Dialogue or a Role Play */
  Coach: 'COACH',
  /** Discussion prompt item. Can be either graded or ungraded. */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Lecture item used for lecture videos. */
  Lecture: 'LECTURE',
  /**
   * LTI (Learning Tools Interoperability) item. Referred to as "App Items" in UI. Can be either graded or ungraded.
   * This item type still isn't handled by the Item Platform, but it will be, so this schema is used.
   */
  Lti: 'LTI',
  /** Peer review item. Can be either ungraded (Standard/Practice) or graded (Phased). */
  PeerReview: 'PEER_REVIEW',
  /** Placeholder item representing deprecated item types while preserving learner grades/progress. */
  Placeholder: 'PLACEHOLDER',
  /**
   * Programming assignment. Can be either graded or ungraded, though we don't currently allow instructors to create
   * graded programming assignments directly. Instead, they must first create an ungraded programming assignment and
   * then convert it to graded from within the item detail view.
   */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /**
   * Quiz item. Can be either graded or ungraded.
   * Deprecated in favour of assignments, and can no longer be created as of Q1 2024
   */
  Quiz: 'QUIZ',
  /** Reading, also known as a 'supplement' in older code. */
  Reading: 'READING',
  /** Teammate review item. Graded. */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab item. */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget item. Referred to as "Plugins" in UI. At present, only new ungraded plugins can be created. */
  Widget: 'WIDGET',
  /** WISEflow item. Graded. Unlaunched as of Q1 2021. */
  Wiseflow: 'WISEFLOW'
} as const;

export type ItemPlatform_ItemType = typeof ItemPlatform_ItemType[keyof typeof ItemPlatform_ItemType];
/** Lecture content, on the FE we call these Video Items */
export type ItemPlatform_LectureContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_LectureContent';
  /** The on demand asset video, equivalent to org.coursera.ondemand.storedvideo.AssetVideo in Scala */
  assetVideo?: Maybe<AssetVideo_Video>;
  /** List of attached assets */
  attachedAssets?: Maybe<Array<LectureAuthoring_AttachedAsset>>;
  /** Lecture draft fields, only applicable for drafts */
  draftFields?: Maybe<LectureAuthoring_LectureDraftFields>;
  /** How long a lecture video is */
  duration?: Maybe<Scalars['Duration']>;
  /** ID of the in video assessment associated with this lecture content */
  inVideoAssessmentId?: Maybe<Scalars['ID']>;
  /** User authored name of the item */
  name: Scalars['String'];
  /** Status of subtitle transcription job, only available for published lectures */
  subtitleStatus?: Maybe<LectureAuthoring_SubtitleJobState>;
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
  /** The lecture video information */
  video?: Maybe<LectureAuthoring_LectureVideo>;
};

/** Peer review content */
export type ItemPlatform_PeerReviewContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_PeerReviewContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Placeholder content */
export type ItemPlatform_PlaceholderContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_PlaceholderContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Programming assignment content */
export type ItemPlatform_ProgrammingAssignmentContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_ProgrammingAssignmentContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Quiz content */
export type ItemPlatform_QuizContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_QuizContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Reading content */
export type ItemPlatform_ReadingContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_ReadingContent';
  /** Reading content, in CML format */
  content: CmlContent;
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Teammate review content */
export type ItemPlatform_TeammateReviewContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_TeammateReviewContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Ungraded lab content */
export type ItemPlatform_UngradedLabContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_UngradedLabContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Error returned when a validation failure has occurred for one or more fields */
export type ItemPlatform_ValidationError = ErrorDetails & {
  __typename?: 'ItemPlatform_ValidationError';
  /**
   * Error code that can be used by our tooling for error metrics.
   *
   * When developer defines a new custom error using the ErrorDetails interface,
   * they should use the name of the custom error as the errorCode.
   */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Widget content */
export type ItemPlatform_WidgetContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_WidgetContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** WISEflow content */
export type ItemPlatform_WiseflowContent = ItemPlatform_ItemContent & {
  __typename?: 'ItemPlatform_WiseflowContent';
  /** User authored name of the item */
  name: Scalars['String'];
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
};

/** Used to "fix" item progress state by resending it to the core progress tracking systems. */
export type ItemProgress_ItemStateRefreshByBranchInput = {
  /** Branch Id */
  branchId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** This doesn't include the result of the refresh operation, but it does provide some additional context. */
export type ItemProgress_ItemStateRefreshByBranchResult = {
  __typename?: 'ItemProgress_ItemStateRefreshByBranchResult';
  /** Branch ID */
  branchId: Scalars['ID'];
  /** Course */
  course: Course_Course;
  /** Item ID */
  itemId: Scalars['ID'];
  /** Item Interaction ID. Progress is actually tracked against these. Looked up using the branch and item. */
  itemInteractionId: Scalars['ID'];
  /** User */
  user: User_User;
};

/**
 * Used to "fix" item progress state by resending it to the core progress tracking systems. The correct branch id is
 * inferred from the user's enrollment in the course.
 */
export type ItemProgress_ItemStateRefreshByCourseInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** User ID */
  userId: Scalars['ID'];
};

/** This doesn't include the result of the refresh operation, but it does provide some additional context. */
export type ItemProgress_ItemStateRefreshByCourseResult = {
  __typename?: 'ItemProgress_ItemStateRefreshByCourseResult';
  /** Branch ID. Inferred from the user's enrollment in the course. */
  branchId: Scalars['ID'];
  /** Course */
  course: Course_Course;
  /** Item ID */
  itemId: Scalars['ID'];
  /** Item Interaction ID. Progress is actually tracked against these. Looked up using the branch and item. */
  itemInteractionId: Scalars['ID'];
  /** User */
  user: User_User;
};

/** Item publish comments GraphQL schema */
export type ItemPublishComments_Comment = {
  __typename?: 'ItemPublishComments_Comment';
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Comment string. */
  commentString: Scalars['String'];
  /** Comment id. */
  id: Scalars['ID'];
  /** Is this atom version a draft. */
  isDraft: Scalars['Boolean'];
  /** Atom version. For a draft the version is (latest version + 1). */
  version: Scalars['Int'];
};

/** Item publish comments GraphQL queries */
export type ItemPublishComments_CommentsQueries = {
  __typename?: 'ItemPublishComments_CommentsQueries';
  /**
   * This query returns the comment given the atom id and the optional version if there is any.
   * If the version is empty, the endpoint will try to fetch the comment for the draft if exists.
   */
  queryCommentByMaybeVersionedAtomId?: Maybe<ItemPublishComments_Comment>;
};


/** Item publish comments GraphQL queries */
export type ItemPublishComments_CommentsQueriesQueryCommentByMaybeVersionedAtomIdArgs = {
  atomId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};

/** Delete ItemPublishComment error */
export type ItemPublishComments_DeleteItemPublishCommentError = {
  /** Error message. */
  message: Scalars['String'];
};

/** Delete ItemPublishComment failure. */
export type ItemPublishComments_DeleteItemPublishCommentFailure = {
  __typename?: 'ItemPublishComments_DeleteItemPublishCommentFailure';
  /** A list of ItemPublishComments_DeleteItemPublishCommentErrors. */
  errors: Array<ItemPublishComments_DeleteItemPublishCommentImplError>;
};

/** Delete ItemPublishComment error implementation */
export type ItemPublishComments_DeleteItemPublishCommentImplError = ItemPublishComments_DeleteItemPublishCommentError & {
  __typename?: 'ItemPublishComments_DeleteItemPublishCommentImplError';
  /** Error message. */
  message: Scalars['String'];
};

/** Delete ItemPublishComment input. */
export type ItemPublishComments_DeleteItemPublishCommentInput = {
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Atom version. For a draft the version is empty (optional). */
  version?: InputMaybe<Scalars['Int']>;
};

/** Delete ItemPublishComment result. */
export type ItemPublishComments_DeleteItemPublishCommentResult = ItemPublishComments_DeleteItemPublishCommentFailure | ItemPublishComments_DeleteItemPublishCommentSuccess;

/** Delete ItemPublishComment success. */
export type ItemPublishComments_DeleteItemPublishCommentSuccess = {
  __typename?: 'ItemPublishComments_DeleteItemPublishCommentSuccess';
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Atom version. */
  version: Scalars['Int'];
};

/** Save ItemPublishComment error. */
export type ItemPublishComments_SaveItemPublishCommentError = {
  /** Error message. */
  message: Scalars['String'];
};

/** Save ItemPublishComment failure. */
export type ItemPublishComments_SaveItemPublishCommentFailure = {
  __typename?: 'ItemPublishComments_SaveItemPublishCommentFailure';
  /** A list of ItemPublishComments_SaveItemPublishCommentErrors. */
  errors: Array<ItemPublishComments_SaveItemPublishCommentImplError>;
};

/** Save ItemPublishComment error implementation. */
export type ItemPublishComments_SaveItemPublishCommentImplError = ItemPublishComments_SaveItemPublishCommentError & {
  __typename?: 'ItemPublishComments_SaveItemPublishCommentImplError';
  /** Error message. */
  message: Scalars['String'];
};

/** Save ItemPublishComment input. */
export type ItemPublishComments_SaveItemPublishCommentInput = {
  /** Unversioned AtomId. */
  atomId: Scalars['ID'];
  /** Comment string. */
  commentString: Scalars['String'];
  /** Is this atom version a draft. */
  isDraft: Scalars['Boolean'];
  /** Atom version. For a draft the version is empty (optional). */
  version?: InputMaybe<Scalars['Int']>;
};

/** Save ItemPublishComment result. */
export type ItemPublishComments_SaveItemPublishCommentResult = ItemPublishComments_Comment | ItemPublishComments_SaveItemPublishCommentFailure;

/** TODO: Complete this description */
export type ItemPublishHistoryQueries = {
  __typename?: 'ItemPublishHistoryQueries';
  /** This query returns a list of ItemPublishRecord for the input atomId and authoringCourseBranchId. */
  queryAuthoringItemWithBranch: Array<ItemPublishHistory_ItemPublishRecord>;
};


/** TODO: Complete this description */
export type ItemPublishHistoryQueriesQueryAuthoringItemWithBranchArgs = {
  atomId: Scalars['String'];
  authoringCourseBranchId: Scalars['String'];
};

/** Status of an atom version for a branch */
export const ItemPublishHistory_BranchAtomVersionStatus = {
  /** Atom contains a draft. */
  Draft: 'DRAFT',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /** Similar to the PUBLISHED status, but the version has been updated and replaced by a newer version. */
  PreviouslyPublished: 'PREVIOUSLY_PUBLISHED',
  /** Similar to the READY status, but the version has been updated and replaced by a newer version. */
  PreviouslyReady: 'PREVIOUSLY_READY',
  /**
   *  Atom version does not contain any drafts, and the branch has been launched, the content
   * is visible to learners.
   */
  Published: 'PUBLISHED',
  /**
   *  Atom version does not contain any drafts, but since the branch has not been launched, the content
   * is not visible to learners yet.
   */
  Ready: 'READY'
} as const;

export type ItemPublishHistory_BranchAtomVersionStatus = typeof ItemPublishHistory_BranchAtomVersionStatus[keyof typeof ItemPublishHistory_BranchAtomVersionStatus];
/** Item publish info for the linked branch. */
export type ItemPublishHistory_BranchItemPublishInfo = {
  __typename?: 'ItemPublishHistory_BranchItemPublishInfo';
  /** Branch atom version status. */
  branchAtomVersionStatus?: Maybe<ItemPublishHistory_BranchAtomVersionStatus>;
  /** Branch Id. */
  branchId?: Maybe<Scalars['String']>;
  /** Branch name. */
  branchName?: Maybe<Scalars['String']>;
  /** Branch status. */
  branchStatus?: Maybe<ItemPublishHistory_BranchStatus>;
  /** Course name. */
  courseName?: Maybe<Scalars['String']>;
  /** Course slug. */
  courseSlug?: Maybe<Scalars['String']>;
  /**
   *  Only for atom versions with PREVIOUSLY_PUBLISHED status, represents the publish time of
   * the next version when the current version has been replaced.
   */
  nextVersionPublishTime?: Maybe<Timestamp>;
  /** The time when the branch is launched (visible to learners). */
  publishTime?: Maybe<Timestamp>;
};

/** Status of a branch. */
export const ItemPublishHistory_BranchStatus = {
  /**
   *  Branch is currently not running in any ongoing session and is not
   * scheduled to run in a future session but ran in an already ended session
   */
  Archived: 'ARCHIVED',
  /** Branch is in the process of being created and cannot be accessed or modified yet. */
  Creating: 'CREATING',
  /** TODO: Complete this description */
  Invalid: 'INVALID',
  /**
   *  Branch is either currently running in a session OR
   * has a past session along with a future scheduled session OR
   * has a past session and would be the branch associated with any future sessions.
   */
  Live: 'LIVE',
  /** Branch isn’t associated with any sessions. */
  New: 'NEW',
  /** Branch has been submitted for approval but has not been approved for use in sessions. */
  Pending: 'PENDING',
  /** Branch is about to go live in a future session for the first time. */
  Upcoming: 'UPCOMING'
} as const;

export type ItemPublishHistory_BranchStatus = typeof ItemPublishHistory_BranchStatus[keyof typeof ItemPublishHistory_BranchStatus];
/** User's basic info for who has contributed to a version of atom. */
export type ItemPublishHistory_Contributor = {
  __typename?: 'ItemPublishHistory_Contributor';
  /** User Id. */
  userId?: Maybe<Scalars['String']>;
  /** User name. */
  userName?: Maybe<Scalars['String']>;
  /** user profile picture URL. */
  userProfileUrl?: Maybe<Scalars['String']>;
};

/**
 * GraphQl Schema for ItemPublishRecord, see ItemPublishRecordMessage in item_publish_record.proto
 * for documentation of each field.
 */
export type ItemPublishHistory_ItemPublishRecord = {
  __typename?: 'ItemPublishHistory_ItemPublishRecord';
  /** The version of the atom. */
  atomVersion?: Maybe<Scalars['Int']>;
  /**
   *  The displayed name for an atom version, starting from v.1
   * the displayed name for a draft is Draft.
   */
  atomVersionDisplayedName?: Maybe<Scalars['String']>;
  /** An optional comment that users could add to describe summary of changes. */
  comment?: Maybe<Scalars['String']>;
  /**
   *  All the users who have contributed to the item between the previous version (if exists)
   * and this version.
   */
  contributors: Array<ItemPublishHistory_Contributor>;
  /** Item publish info in all branches where the item exists. */
  linkedBranchesItemPublishInfo: Array<ItemPublishHistory_BranchItemPublishInfo>;
};

/** Queries for comparing item versions and returning their diffs. */
export type ItemVersionDiffsQueries = {
  __typename?: 'ItemVersionDiffsQueries';
  /**
   * This query returns the diffs, or changes that occur between two versions of an item,
   * given by its atom id. | Maximum page size: 100
   */
  findItemVersionDiffs?: Maybe<ItemVersionDiffs_DiffsConnection>;
};


/** Queries for comparing item versions and returning their diffs. */
export type ItemVersionDiffsQueriesFindItemVersionDiffsArgs = {
  after?: InputMaybe<Scalars['String']>;
  atomId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  originalVersion: Scalars['Int'];
  revisedVersion?: InputMaybe<Scalars['Int']>;
};

/** A diff between blocks of items that correspond to each other in original and revised lists. */
export type ItemVersionDiffs_BlockDiff = {
  __typename?: 'ItemVersionDiffs_BlockDiff';
  /** The unique id of the BlockDiff. */
  id: Scalars['ID'];
  /** The position of the block in the original list. */
  originalPosition: Scalars['Int'];
  /** The size of the block in the original list. */
  originalSize: Scalars['Int'];
  /** The position of the block in the revised list. */
  revisedPosition: Scalars['Int'];
  /** The size of the block in the revised list. */
  revisedSize: Scalars['Int'];
};

/** The diffs between two versions of an item. */
export type ItemVersionDiffs_DiffsConnection = {
  __typename?: 'ItemVersionDiffs_DiffsConnection';
  /** A list of edges to diffs. */
  edges: Array<ItemVersionDiffs_PathDiffEdge>;
  /** Contains information for paginating the collection. */
  pageInfo: PageInfo;
};

/** A single diff between two paths. */
export type ItemVersionDiffs_PathDiff = Node & {
  __typename?: 'ItemVersionDiffs_PathDiff';
  /** Position and sizes of blocks in a list that have changed (if any). */
  blockDiffs: Array<ItemVersionDiffs_BlockDiff>;
  /** The unique id of the PathDiff. */
  id: Scalars['ID'];
  /** The original path to the change. */
  originalPath: Scalars['String'];
  /** The revised path to the change. */
  revisedPath: Scalars['String'];
};

/** Represents a PathDiff with its pagination cursor */
export type ItemVersionDiffs_PathDiffEdge = {
  __typename?: 'ItemVersionDiffs_PathDiffEdge';
  /** The pagination cursor for this PathDiff */
  cursor: Scalars['String'];
  /** The PathDiff */
  node: ItemVersionDiffs_PathDiff;
};

/**
 * Queries for the new Job Recommendations page that matches
 * learners with jobs.
 */
export type JobMatchQueries = {
  __typename?: 'JobMatchQueries';
  /**
   * Returns a list of all of the locations where the learner has
   * at least a 60% match.
   * The list will always have "Remote" first if remote is an option,
   * after that it should be ordered alphabetically by state then city.
   */
  getAllLocationsForLearner: Array<Scalars['String']>;
  /**
   * Gets a list of up to 10 job matches for a learner.
   * The learner must be a part of our job match experiment to receive any matches.
   */
  getMatchesForLearner: Array<JobMatch_JobMatch>;
};


/**
 * Queries for the new Job Recommendations page that matches
 * learners with jobs.
 */
export type JobMatchQueriesGetAllLocationsForLearnerArgs = {
  userId: Scalars['ID'];
};


/**
 * Queries for the new Job Recommendations page that matches
 * learners with jobs.
 */
export type JobMatchQueriesGetMatchesForLearnerArgs = {
  isFullTime?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['ID'];
};

/** A single job */
export type JobMatch_Job = {
  __typename?: 'JobMatch_Job';
  /** A link that the learner can use to apply for the job. */
  applicationLink: Scalars['URL'];
  /** A URL where the company's logo is stored */
  companyLogoUrl: Scalars['URL'];
  /** The name of the company */
  companyName: Scalars['String'];
  /** The full description of the job, which may include some HTML styling. */
  description: Scalars['String'];
  /** Unique ID of the job. */
  id: Scalars['ID'];
  /** False if the position is full-time, true if the position is an internship. */
  isInternship: Scalars['Boolean'];
  /**
   * One or more locations where the position is located.
   * Typically this will be in the form "City, State", but may just be "Remote"
   */
  location: Array<Scalars['String']>;
  /**
   * A list of tags that we would like to be displayed on the UI.
   * The list may be empty if we have no tags for the job.
   */
  tags: Array<Scalars['String']>;
  /** Title of the job */
  title: Scalars['String'];
};

/** A single job match */
export type JobMatch_JobMatch = {
  __typename?: 'JobMatch_JobMatch';
  /** Details about the job */
  job: JobMatch_Job;
  /** The percentage match (out of 100) of the learner with the job */
  matchScore: Scalars['Int'];
};

export type JumioIdVerificationsV1 = {
  __typename?: 'JumioIdVerificationsV1';
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  callbackData?: Maybe<Scalars['JSON']>;
  callbackReceivedAt?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  id: Scalars['String'];
  jumioIdScanReference: Scalars['String'];
  merchantIdScanReference: Scalars['String'];
  originalVerificationStatus?: Maybe<JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
  verificationStatus: JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus;
};

export type JumioIdVerificationsV1ByUser = {
  __typename?: 'JumioIdVerificationsV1ByUser';
  connection?: Maybe<JumioIdVerificationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type JumioIdVerificationsV1Connection = {
  __typename?: 'JumioIdVerificationsV1Connection';
  elements: Array<Maybe<JumioIdVerificationsV1>>;
  paging: ResponsePagination;
};

export type JumioIdVerificationsV1LatestByMe = {
  __typename?: 'JumioIdVerificationsV1LatestByMe';
  connection?: Maybe<JumioIdVerificationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type JumioIdVerificationsV1Resource = {
  __typename?: 'JumioIdVerificationsV1Resource';
  byUser?: Maybe<JumioIdVerificationsV1Connection>;
  get?: Maybe<JumioIdVerificationsV1>;
  latestByMe?: Maybe<JumioIdVerificationsV1Connection>;
};


export type JumioIdVerificationsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type JumioIdVerificationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type JumioIdVerificationsV1ResourceLatestByMeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type JumioIdVerificationsV1ResourceMutations = {
  __typename?: 'JumioIdVerificationsV1ResourceMutations';
  delete?: Maybe<JumioIdVerificationsV1Connection>;
  resetJumioIdVerificationDataForUser?: Maybe<Scalars['JSON']>;
  retrieveFromJumioAndUpdate?: Maybe<Scalars['JSON']>;
  sendJumioVerificationFailureEmail?: Maybe<Scalars['JSON']>;
};


export type JumioIdVerificationsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type JumioIdVerificationsV1ResourceMutationsResetJumioIdVerificationDataForUserArgs = {
  userId: Scalars['String'];
};


export type JumioIdVerificationsV1ResourceMutationsRetrieveFromJumioAndUpdateArgs = {
  forceUpdateRegardlessOfStatus?: InputMaybe<Scalars['Boolean']>;
  jumioIdScanReference: Scalars['String'];
};


export type JumioIdVerificationsV1ResourceMutationsSendJumioVerificationFailureEmailArgs = {
  jumioIdScanReference: Scalars['String'];
  userId: Scalars['String'];
  verificationStatus: Scalars['String'];
};

/** Note: These are verification statuses that are useful from Coursera's perspective, and are defined by Coursera. They are NOT the original callback parameter verificationStatus states defined by Jumio. For original verificationStatus states defined by Jumio, see:   org.coursera.userverification.jumioidverification.callback.JumioCallbackVerificationStatus */
export const JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus = {
  Approved: 'APPROVED',
  DeniedAge: 'DENIED_AGE',
  DeniedByJumio: 'DENIED_BY_JUMIO',
  DeniedByPersona: 'DENIED_BY_PERSONA',
  DeniedExpiredId: 'DENIED_EXPIRED_ID',
  DeniedRestrictedCountry: 'DENIED_RESTRICTED_COUNTRY',
  ErrorNotJumioSupportedCountry: 'ERROR_NOT_JUMIO_SUPPORTED_COUNTRY',
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  NoIdUploaded: 'NO_ID_UPLOADED',
  Pending: 'PENDING'
} as const;

export type JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus = typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus[keyof typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_CourseraVerificationStatus];
/** This is the original verificationStatus parameter sent by Jumio in their callback. These statuses are defined by Jumio:   https://github.com/Jumio/implementation-guides/blob/master/netverify/callback.md#parameters */
export const JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus = {
  ApprovedVerified: 'APPROVED_VERIFIED',
  DeniedFraud: 'DENIED_FRAUD',
  DeniedNameMismatch: 'DENIED_NAME_MISMATCH',
  DeniedUnsupportedIdCountry: 'DENIED_UNSUPPORTED_ID_COUNTRY',
  DeniedUnsupportedIdType: 'DENIED_UNSUPPORTED_ID_TYPE',
  ErrorNotReadableId: 'ERROR_NOT_READABLE_ID',
  NoIdUploaded: 'NO_ID_UPLOADED'
} as const;

export type JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus = typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus[keyof typeof JumioIdVerificationsV1_Org_Coursera_Userverification_Jumioidverification_Callback_JumioCallbackVerificationStatus];
/** All queries for JWT Logins */
export type JwtLoginsQueries = {
  __typename?: 'JwtLoginsQueries';
  /** Returns JwtLogin for the supplied id. */
  getById: JwtLogins_GetResult;
  /**
   * Returns completed JWT logins for the given claim ID.
   * Only accessible by internal users and courserians.
   */
  getCompletedJwtLoginsByJwtClaimId: JwtLogins_GetCompletedByClaimIdResult;
};


/** All queries for JWT Logins */
export type JwtLoginsQueriesGetByIdArgs = {
  id: Scalars['ID'];
  validate?: InputMaybe<Scalars['Boolean']>;
};


/** All queries for JWT Logins */
export type JwtLoginsQueriesGetCompletedJwtLoginsByJwtClaimIdArgs = {
  claimId: Scalars['ID'];
};

/** Input for creating a JWT login */
export type JwtLogins_CreateJwtLoginInput = {
  /** The organization name to be slugified */
  organization: Scalars['String'];
  /** The web token to be parsed and validated */
  webToken: Scalars['String'];
};

/** Result type for create JWT login */
export type JwtLogins_CreateJwtLoginResult = JwtLogins_CreateSuccess | JwtLogins_Failure;

/** Success response when for create JWT login */
export type JwtLogins_CreateSuccess = {
  __typename?: 'JwtLogins_CreateSuccess';
  /** The JWT Login object */
  jwtLogin: JwtLogins_JwtLogin;
};

/** Error type for JWT login operations */
export type JwtLogins_Error = {
  __typename?: 'JwtLogins_Error';
  /** Error message */
  message: Scalars['String'];
};

/** Failure response for JWT login operations */
export type JwtLogins_Failure = {
  __typename?: 'JwtLogins_Failure';
  /** List of errors */
  errors: Array<JwtLogins_Error>;
};

/** Result type for getting completed JWT logins by claim ID */
export type JwtLogins_GetCompletedByClaimIdResult = JwtLogins_GetCompletedByClaimIdSuccess;

/** Success response when getting completed JWT logins by claim ID */
export type JwtLogins_GetCompletedByClaimIdSuccess = {
  __typename?: 'JwtLogins_GetCompletedByClaimIdSuccess';
  /** List of completed JWT logins */
  jwtLogins: Array<JwtLogins_JwtLogin>;
};

/** Result type for getting JWT login */
export type JwtLogins_GetResult = JwtLogins_GetSuccess;

/** Success response when for get JWT login */
export type JwtLogins_GetSuccess = {
  __typename?: 'JwtLogins_GetSuccess';
  /** The JWT Login object */
  jwtLogin: JwtLogins_JwtLogin;
};

/** JWT Login object containing parsed user data */
export type JwtLogins_JwtLogin = {
  __typename?: 'JwtLogins_JwtLogin';
  /** Optional claim ID from the JWT */
  claimId?: Maybe<Scalars['ID']>;
  /** Whether the JWT login is completed */
  completed: Scalars['Boolean'];
  /** When the JWT login was created */
  createdAt: Scalars['DateTime'];
  /** The user's email from the JWT */
  email: Scalars['String'];
  /** The method used for JWT login */
  method: JwtLogins_LoginMethod;
  /** The user's name from the JWT */
  name: Scalars['String'];
  /** The opaque ID from the JWT */
  opaqueId: Scalars['ID'];
  /** Raw claims from the JWT */
  rawClaims?: Maybe<Scalars['JSON']>;
  /** The third party organization ID */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Enum representing JWT login methods */
export const JwtLogins_LoginMethod = {
  /** Standard JWT login method */
  Jwt: 'JWT',
  /** JWT invite login method */
  JwtInvite: 'JWT_INVITE'
} as const;

export type JwtLogins_LoginMethod = typeof JwtLogins_LoginMethod[keyof typeof JwtLogins_LoginMethod];
/** Input for creating a JWT login with invitation token */
export type JwtLogins_LoginWithInvitationTokenInput = {
  /** The invitation token to be parsed and validated */
  invitationToken: Scalars['String'];
  /** The organization slug */
  organizationSlug: Scalars['String'];
};

/** Result type for login with inivitation token */
export type JwtLogins_LoginWithInvitationTokenResult = JwtLogins_CreateSuccess | JwtLogins_Failure;

/** Query for lab admin token */
export type LabAdminTokensQueries = {
  __typename?: 'LabAdminTokensQueries';
  /** Query for lab admin token */
  get?: Maybe<LabAdmin_Token>;
  /** Query for commit jwt token */
  getCommitJwt?: Maybe<LabAdmin_Token>;
};


/** Query for lab admin token */
export type LabAdminTokensQueriesGetArgs = {
  tokenType: Scalars['String'];
};


/** Query for lab admin token */
export type LabAdminTokensQueriesGetCommitJwtArgs = {
  workspaceId: Scalars['ID'];
};

/**
 * Response of a Lab token request
 * Includes the token itself and token type
 * This can be null in the case of an invalid request.
 */
export type LabAdmin_Token = {
  __typename?: 'LabAdmin_Token';
  /** Token value */
  token?: Maybe<Scalars['String']>;
  /** Token type */
  tokenType?: Maybe<Scalars['String']>;
};

/** LabAuthoringTemplate */
export type LabAuthoringTemplate_LabAuthoringTemplate = {
  __typename?: 'LabAuthoringTemplate_LabAuthoringTemplate';
  /** Description of the template */
  description?: Maybe<Scalars['String']>;
  /** Computed field. The course items that are using the published template. */
  entryPoints: Array<LabAuthoringTemplate_LabEntryPoint>;
  /** The unique identifier for the lab authoring template */
  id: Scalars['ID'];
  /** Image for the template, formatted as `workspace/<image name>:<tag>` */
  imageTag: Scalars['String'];
  /** Human readable name of the template, null if not set */
  name?: Maybe<Scalars['String']>;
  /** The published version of the template */
  publishedTemplate?: Maybe<LabTemplate_LabTemplate>;
  /** Computed field. Id of the workspace template that the authoring workspace template published into. null if not published. */
  publishedTemplateId?: Maybe<Scalars['ID']>;
  /** The shared workspace of the template, also known as instructor workspace. */
  sharedWorkspace: LabAuthoringTemplate_SharedWorkspace;
  /** The time the template was last updated. null if not set. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user who last updated the template. null if not set. */
  updatedBy?: Maybe<Scalars['ID']>;
  /** Computed view of the volume definition. */
  volumeMountPaths: Array<LabAuthoringTemplate_VolumeMountPath>;
};

/** The course items (labs) that are using the published template. */
export type LabAuthoringTemplate_LabEntryPoint = {
  __typename?: 'LabAuthoringTemplate_LabEntryPoint';
  /** The authoring course branch id for that lab item */
  authoringCourseBranchId: Scalars['ID'];
  /** The unique identifier for the course */
  course: Course_Course;
  /** Indicate the source course where the content has been linked from. null if it was not embedded. */
  embeddedContentSourceCourse?: Maybe<Course_Course>;
  /** The unique identifier for the lab item */
  itemId: Scalars['ID'];
};

/** The shared workspace of the template, also known as instructor workspace. */
export type LabAuthoringTemplate_SharedWorkspace = {
  __typename?: 'LabAuthoringTemplate_SharedWorkspace';
  /** Workspace id, aka lab id */
  id: Scalars['ID'];
};

/** Computed view of the volume definition. */
export type LabAuthoringTemplate_VolumeMountPath = {
  __typename?: 'LabAuthoringTemplate_VolumeMountPath';
  /** Indicate if the path is deletable */
  isDeletable: Scalars['Boolean'];
  /** Indicate if the path is read only */
  isReadOnly: Scalars['Boolean'];
  /** Indicate if the path is renamable */
  isRenamable: Scalars['Boolean'];
  /** The path in the container */
  path: Scalars['String'];
};

/** Query logs for a lab */
export type LabContainerLogsQueries = {
  __typename?: 'LabContainerLogsQueries';
  /** Query logs for a lab container */
  queryContainer?: Maybe<LabContainerLogs_QueryContainerPayload>;
};


/** Query logs for a lab */
export type LabContainerLogsQueriesQueryContainerArgs = {
  fileId?: InputMaybe<Scalars['ID']>;
  labId: Scalars['ID'];
  pageSize: Scalars['Int'];
  pageToken: Scalars['String'];
  requestedCourseId: Scalars['ID'];
  tailLog: Scalars['Boolean'];
};

/** Payload of a lab container logs query */
export type LabContainerLogs_QueryContainerPayload = {
  __typename?: 'LabContainerLogs_QueryContainerPayload';
  /** The lab container logs. */
  containerLogs?: Maybe<Scalars['String']>;
  /** Token for logs on the next page. */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Token for logs on the previous page. */
  previousPageToken?: Maybe<Scalars['String']>;
};

/** Query image authoring data for a lab */
export type LabImageAuthoringDataQueries = {
  __typename?: 'LabImageAuthoringDataQueries';
  /** Query image authoring data by atom id */
  byAtomId?: Maybe<LabImageAuthoringData_Payload>;
  /** Query image authoring data by course id */
  byCourseId: LabImageAuthoringData_PaginatedResult;
  /** Query image authoring data by image id and course id */
  byImageAndCourse?: Maybe<LabImageAuthoringData_Payload>;
  /** Batch query image authoring data by image id and course id values */
  byImageAndCourseBatch: Array<LabImageAuthoringData_Payload>;
};


/** Query image authoring data for a lab */
export type LabImageAuthoringDataQueriesByAtomIdArgs = {
  atomId: Scalars['ID'];
};


/** Query image authoring data for a lab */
export type LabImageAuthoringDataQueriesByCourseIdArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  programId?: InputMaybe<Scalars['ID']>;
};


/** Query image authoring data for a lab */
export type LabImageAuthoringDataQueriesByImageAndCourseArgs = {
  courseId: Scalars['ID'];
  imageId: Scalars['ID'];
};


/** Query image authoring data for a lab */
export type LabImageAuthoringDataQueriesByImageAndCourseBatchArgs = {
  courseId: Scalars['ID'];
  imageIds: Array<Scalars['ID']>;
};

/** ImageBuildSource: Base Image With Customizations */
export type LabImageAuthoringData_BaseImageWithCustomizations = {
  __typename?: 'LabImageAuthoringData_BaseImageWithCustomizations';
  /** Base image */
  baseImage: Scalars['String'];
  /** Build Metadata */
  buildMetadata: LabImageAuthoringData_BuildImageMetadata;
  /** Customizations */
  customizations: Scalars['JSON'];
};

/** ImageBuildSource: BaseImageWithCustomizationsMember */
export type LabImageAuthoringData_BaseImageWithCustomizationsMember = {
  __typename?: 'LabImageAuthoringData_BaseImageWithCustomizationsMember';
  /** Base image with customizations */
  baseImageWithCustomizations: LabImageAuthoringData_BaseImageWithCustomizations;
};

/** Build Image Metadata */
export type LabImageAuthoringData_BuildImageMetadata = {
  __typename?: 'LabImageAuthoringData_BuildImageMetadata';
  /** Grader Type if this is a graded image, null otherwise */
  grader?: Maybe<LabImageAuthoringData_LabGraderType>;
};

/** Environment variables */
export type LabImageAuthoringData_ContainerEnvVar = {
  __typename?: 'LabImageAuthoringData_ContainerEnvVar';
  /** Env variable name */
  key: Scalars['String'];
  /** Env variable value */
  value: Scalars['String'];
};

/** Container resource limits */
export type LabImageAuthoringData_ContainerResourceLimits = {
  __typename?: 'LabImageAuthoringData_ContainerResourceLimits';
  /**
   * Specify how much of the available CPU resources a container can use.
   * This is a numeric value, represented as a string field because graphQl doesn't natively have a double time.
   */
  cpus: Scalars['String'];
  /**
   * The maximum amount of memory (in bytes) that the container can use.
   * This is a numeric value, represented as a string field because graphQl doesn't natively have a long time.
   */
  memory: Scalars['String'];
};

/** Coursera Asset data */
export type LabImageAuthoringData_CourseraAsset = {
  __typename?: 'LabImageAuthoringData_CourseraAsset';
  /** Coursera Asset Id */
  assetId: Scalars['ID'];
};

/** Image Build Source: Coursera Asset Member */
export type LabImageAuthoringData_CourseraAssetMember = {
  __typename?: 'LabImageAuthoringData_CourseraAssetMember';
  /** Coursera Asset data */
  courseraAsset: LabImageAuthoringData_CourseraAsset;
};

/** Image Build Source: Docker Commit Member */
export type LabImageAuthoringData_DockerCommitMember = {
  __typename?: 'LabImageAuthoringData_DockerCommitMember';
  /** Docker commit data */
  dockerCommit: Scalars['JSON'];
};

/** Image Build Source: Github Member */
export type LabImageAuthoringData_GitHubMember = {
  __typename?: 'LabImageAuthoringData_GitHubMember';
  /** GitHub data */
  gitHub: Scalars['JSON'];
};

/** Configuration for health check with this image */
export type LabImageAuthoringData_HealthCheckConfig = {
  __typename?: 'LabImageAuthoringData_HealthCheckConfig';
  /** Path used for health check request */
  path: Scalars['String'];
};

/** Image Build Source: might be from different build systems */
export type LabImageAuthoringData_ImageBuildSource = LabImageAuthoringData_BaseImageWithCustomizationsMember | LabImageAuthoringData_CourseraAssetMember | LabImageAuthoringData_DockerCommitMember | LabImageAuthoringData_GitHubMember | LabImageAuthoringData_MigratedFromLegacyNotebookMember;

/** ImageBuildStatus */
export const LabImageAuthoringData_ImageBuildStatus = {
  /** Build failed */
  Failed: 'FAILED',
  /** Build fault */
  Fault: 'FAULT',
  /** Build in progress */
  InProgress: 'IN_PROGRESS',
  /** Build stopped */
  Stopped: 'STOPPED',
  /** Build succeeded */
  Succeeded: 'SUCCEEDED',
  /** Build timed out */
  TimedOut: 'TIMED_OUT'
} as const;

export type LabImageAuthoringData_ImageBuildStatus = typeof LabImageAuthoringData_ImageBuildStatus[keyof typeof LabImageAuthoringData_ImageBuildStatus];
/** Image Build Information */
export type LabImageAuthoringData_ImageBuildWithTag = {
  __typename?: 'LabImageAuthoringData_ImageBuildWithTag';
  /** True if the build task has completed (success or failure). */
  buildComplete: Scalars['Boolean'];
  /** Build status, null if not available */
  buildStatus?: Maybe<LabImageAuthoringData_ImageBuildStatus>;
  /**
   * Id for the codebuild instance used to build the image
   * null if the image has not built
   */
  codeBuildId?: Maybe<Scalars['ID']>;
  /** Build end time, null if the build has not ended */
  endAt?: Maybe<Scalars['DateTime']>;
  /** Image tag ("test", "latest", "1.0.0", etc.) */
  imageTag: Scalars['String'];
  /** Source to download image build files, eg: Dockerfile. */
  source: LabImageAuthoringData_ImageBuildSource;
  /** Build start time, null if the build has not started */
  startedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Details of the user maintaining the image
 * We could be using the User_User federated type here
 * but it would require the userId to always be present,
 * while it is currently defined (in Courier) as optional
 */
export type LabImageAuthoringData_ImageMaintainer = {
  __typename?: 'LabImageAuthoringData_ImageMaintainer';
  /** Email of the user */
  email: Scalars['String'];
  /** Name of the user */
  name: Scalars['String'];
  /** Id of the user, null if this was not recorded */
  userId?: Maybe<Scalars['ID']>;
};

/** Image manifest information */
export type LabImageAuthoringData_ImageManifest = {
  __typename?: 'LabImageAuthoringData_ImageManifest';
  /** The changes on the image, null if there are no changes documented */
  changes?: Maybe<Scalars['String']>;
  /** Description of the image, null if no description was set */
  description?: Maybe<Scalars['String']>;
  /** Environment variables */
  environmentVariables: Array<LabImageAuthoringData_ContainerEnvVar>;
  /** Configuration for health check with this image */
  healthCheck?: Maybe<LabImageAuthoringData_HealthCheckConfig>;
  /** Specification of the host to run the image (cpu, gpu, etc.) */
  hostSpec: Scalars['String'];
  /** The port used for this image */
  httpPort: Scalars['Int'];
  /** Indicates if file browser is enabled */
  isFileBrowserEnabled: Scalars['Boolean'];
  /** Label of the image */
  label: Scalars['String'];
  /** Container resource limits */
  limits: LabImageAuthoringData_ContainerResourceLimits;
  /** Details of the user maintaining the image */
  maintainer: LabImageAuthoringData_ImageMaintainer;
  /** Volume mount path list */
  volumeMountPaths: Array<Scalars['String']>;
};

/** ImagePublishStatus */
export const LabImageAuthoringData_ImagePublishStatus = {
  /** Published */
  Published: 'PUBLISHED',
  /** Unpublished */
  Unpublished: 'UNPUBLISHED',
  /** Has unpublished changes */
  UnpublishedChanges: 'UNPUBLISHED_CHANGES'
} as const;

export type LabImageAuthoringData_ImagePublishStatus = typeof LabImageAuthoringData_ImagePublishStatus[keyof typeof LabImageAuthoringData_ImagePublishStatus];
/** LabAuthoringTemplate */
export type LabImageAuthoringData_LabAuthoringTemplates = {
  __typename?: 'LabImageAuthoringData_LabAuthoringTemplates';
  /** Lab Authoring Template Elements */
  elements?: Maybe<Array<LabAuthoringTemplate_LabAuthoringTemplate>>;
};

/** Lab Grader Metadata */
export type LabImageAuthoringData_LabGraderMetadata = {
  __typename?: 'LabImageAuthoringData_LabGraderMetadata';
  /** executor record id from grid platform, null if this is not a Grid grader */
  executorId?: Maybe<Scalars['ID']>;
  /** Grader type */
  graderType: LabImageAuthoringData_LabGraderType;
};

/** Lab Grader Type */
export const LabImageAuthoringData_LabGraderType = {
  /** NBGrader */
  NbGrader: 'NB_GRADER',
  /** VSCode custom grader */
  VscodeCustomGrader: 'VSCODE_CUSTOM_GRADER',
  /** VSCode preconfigured java */
  VscodePreconfiguredJava: 'VSCODE_PRECONFIGURED_JAVA'
} as const;

export type LabImageAuthoringData_LabGraderType = typeof LabImageAuthoringData_LabGraderType[keyof typeof LabImageAuthoringData_LabGraderType];
/** Lab Image Authoring Data Publish Metadata */
export type LabImageAuthoringData_LabImageAuthoringDataPublishMetadata = {
  __typename?: 'LabImageAuthoringData_LabImageAuthoringDataPublishMetadata';
  /** Image publish status */
  publishStatus: LabImageAuthoringData_ImagePublishStatus;
  /** Published at, null if not published */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** Published by (user id), null if not published */
  publishedBy?: Maybe<Scalars['Int']>;
  /** Ready for publish validation */
  readyForPublish: LabImageAuthoringData_LabImageAuthoringDataPublishValidation;
};

/** LabImageAuthoringDataPublishValidation */
export type LabImageAuthoringData_LabImageAuthoringDataPublishValidation = {
  __typename?: 'LabImageAuthoringData_LabImageAuthoringDataPublishValidation';
  /** Is ready for publish */
  isReadyForPublish: Scalars['Boolean'];
  /** Reason for not being ready for publish, null if it is ready for publish */
  reason?: Maybe<Scalars['String']>;
};

/** Image Build Source: Migrated From Legacy Notebook Member */
export type LabImageAuthoringData_MigratedFromLegacyNotebookMember = {
  __typename?: 'LabImageAuthoringData_MigratedFromLegacyNotebookMember';
  /** Migrated from legacy notebook data */
  migratedFromLegacyNotebook: Scalars['JSON'];
};

/** Lab image authoring data with pagination */
export type LabImageAuthoringData_PaginatedResult = {
  __typename?: 'LabImageAuthoringData_PaginatedResult';
  /** Lab images */
  elements: Array<LabImageAuthoringData_Payload>;
  /** Pagination */
  pagination: Pagination;
};

/**
 * Payload of a lab image authoring data query
 * Modeling here a subset of the data which is currently required by the FE
 */
export type LabImageAuthoringData_Payload = {
  __typename?: 'LabImageAuthoringData_Payload';
  /** The authoring templates that are associated with this image. */
  authoringTemplates?: Maybe<LabImageAuthoringData_LabAuthoringTemplates>;
  /** Image builds */
  builds: Array<LabImageAuthoringData_ImageBuildWithTag>;
  /** Lab Grader Metadata, null if this is not a graded lab image */
  graderMetadata?: Maybe<LabImageAuthoringData_LabGraderMetadata>;
  /** The type of the application (e.g. jupyter, rstudio, etc.) */
  imageApplicationType: LabImageAuthoringData_WorkspaceImageApplicationType;
  /** The id of the image */
  imageId: Scalars['ID'];
  /** The name of the image */
  imageName: Scalars['String'];
  /** Is the image a default image */
  isDefaultImage: Scalars['Boolean'];
  /** Is the image editable */
  isEditable: Scalars['Boolean'];
  /** Is the image public */
  isPublic: Scalars['Boolean'];
  /** Image manifest information */
  manifest: LabImageAuthoringData_ImageManifest;
  /** Manifest change message, null if there isn't any message associated with the manifest change */
  manifestChangedMessage?: Maybe<Scalars['String']>;
  /** Publish metadata */
  publishMetadata: LabImageAuthoringData_LabImageAuthoringDataPublishMetadata;
  /** The version which was published */
  publishedVersion: Scalars['String'];
  /** Ready for publish validation */
  readyForPublish: LabImageAuthoringData_LabImageAuthoringDataPublishValidation;
  /** The scopes in which this image is used */
  scopes: Array<Scalars['String']>;
  /** The version which was tested */
  testVersion: Scalars['String'];
  /** Lab id used for testing */
  testWorkspaceId: Scalars['ID'];
  /** Last update time */
  updatedAt: Scalars['DateTime'];
  /** Last updated by */
  updatedBy: Scalars['ID'];
};

/** Indicates the type of the base image */
export const LabImageAuthoringData_WorkspaceImageApplicationType = {
  /** AWS Cloud */
  AwsCloud: 'AWS_CLOUD',
  /** Custom image */
  Custom: 'CUSTOM',
  /** Gen AI Sandbox */
  GenAiSandbox: 'GEN_AI_SANDBOX',
  /** Jupyter notebook */
  JupyterNotebook: 'JUPYTER_NOTEBOOK',
  /** Linux Desktop */
  Linux: 'LINUX',
  /** RStudio */
  Rstudio: 'RSTUDIO',
  /** Virtual web browser */
  VirtualBrowser: 'VIRTUAL_BROWSER',
  /** VSCode */
  Vscode: 'VSCODE'
} as const;

export type LabImageAuthoringData_WorkspaceImageApplicationType = typeof LabImageAuthoringData_WorkspaceImageApplicationType[keyof typeof LabImageAuthoringData_WorkspaceImageApplicationType];
/** Query logs for a lab image build */
export type LabImageBuildLogsQueries = {
  __typename?: 'LabImageBuildLogsQueries';
  /** Query logs for a lab image build */
  queryImageBuild?: Maybe<LabImageBuildLogs_QueryImageBuildPayload>;
};


/** Query logs for a lab image build */
export type LabImageBuildLogsQueriesQueryImageBuildArgs = {
  labImageBuildId: Scalars['String'];
  pageSize: Scalars['Int'];
  pageToken: Scalars['String'];
  requestedCourseId: Scalars['String'];
  tailLog: Scalars['Boolean'];
};

/** Payload of a lab image build */
export type LabImageBuildLogs_QueryImageBuildPayload = {
  __typename?: 'LabImageBuildLogs_QueryImageBuildPayload';
  /** The lab image build logs */
  imageBuildLogs?: Maybe<Scalars['String']>;
  /** Token for logs on the next page. */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Token for logs on the previous page. */
  previousPageToken?: Maybe<Scalars['String']>;
};

/** Query for lab log */
export type LabLogQueries = {
  __typename?: 'LabLogQueries';
  /** Query for lab log */
  get?: Maybe<LabLog_FileList>;
};


/** Query for lab log */
export type LabLogQueriesGetArgs = {
  limit?: Scalars['Int'];
  workspaceId: Scalars['ID'];
};

/** A single lab log file */
export type LabLog_File = {
  __typename?: 'LabLog_File';
  /** id of the file */
  fileId: Scalars['ID'];
  /** launch time of the file */
  launchTime: Scalars['DateTime'];
};

/**
 * Response for a lab log get request
 * A list of lab log files
 */
export type LabLog_FileList = {
  __typename?: 'LabLog_FileList';
  /** workspace id */
  id: Scalars['ID'];
  /** List of files */
  labLogFiles?: Maybe<Array<LabLog_File>>;
};

/** Queries for lab recording video access */
export type LabRecordingQueries = {
  __typename?: 'LabRecordingQueries';
  /** Fetch recording status and recording ID. */
  getStatus: LabRecording_GetStatusResult;
  /** Generate a presigned URL for video playback. Only valid when status is EXPORTED. */
  getVideoUrl: LabRecording_GetVideoUrlResult;
};


/** Queries for lab recording video access */
export type LabRecordingQueriesGetStatusArgs = {
  courseId: Scalars['ID'];
  externalSessionId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** Queries for lab recording video access */
export type LabRecordingQueriesGetVideoUrlArgs = {
  recordingId: Scalars['ID'];
};

/** Input to clean up a lab recording */
export type LabRecording_CleanupInput = {
  /** The course ID */
  courseId: Scalars['ID'];
  /** External session ID (e.g. attempt ID) */
  externalSessionId: Scalars['ID'];
  /** The item ID */
  itemId: Scalars['ID'];
};

/** Response for cleaning up a lab recording */
export type LabRecording_CleanupResult = {
  __typename?: 'LabRecording_CleanupResult';
  /** The current status (DELETING) */
  status: LabRecording_Status;
};

/** Input to continue lab recording */
export type LabRecording_ContinueInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Response for continuing a lab recording */
export type LabRecording_ContinueResult = {
  __typename?: 'LabRecording_ContinueResult';
  /** The recording ID */
  recordingId: Scalars['ID'];
  /** The current status */
  status: LabRecording_Status;
};

/** Input to export a lab recording to video */
export type LabRecording_ExportInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Response for exporting a lab recording */
export type LabRecording_ExportResult = {
  __typename?: 'LabRecording_ExportResult';
  /** The recording ID */
  recordingId: Scalars['ID'];
  /** The current status */
  status: LabRecording_Status;
};

/** Response for fetching lab recording status */
export type LabRecording_GetStatusResult = {
  __typename?: 'LabRecording_GetStatusResult';
  /** The recording ID */
  recordingId: Scalars['ID'];
  /** The current status */
  status: LabRecording_Status;
};

/** Response for getting the presigned video URL */
export type LabRecording_GetVideoUrlResult = {
  __typename?: 'LabRecording_GetVideoUrlResult';
  /** Presigned URL for video playback */
  presignedUrl: Scalars['URL'];
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Input to pause a lab recording */
export type LabRecording_PauseInput = {
  /** The recording ID */
  recordingId: Scalars['ID'];
};

/** Response for pausing a lab recording */
export type LabRecording_PauseResult = {
  __typename?: 'LabRecording_PauseResult';
  /** The recording ID */
  recordingId: Scalars['ID'];
  /** The current status */
  status: LabRecording_Status;
};

/** Input to start a lab recording */
export type LabRecording_StartInput = {
  /** External session ID (e.g. attempt ID) */
  externalSessionId: Scalars['ID'];
  /** The lab ID */
  labId: Scalars['ID'];
  /** Heartbeat interval in seconds. Defaults to 10. */
  recordingDurationSeconds?: Scalars['Int'];
};

/** Response for starting a lab recording */
export type LabRecording_StartResult = {
  __typename?: 'LabRecording_StartResult';
  /** The recording ID */
  recordingId: Scalars['ID'];
  /** The current status */
  status: LabRecording_Status;
};

/** The lifecycle status of a lab recording */
export const LabRecording_Status = {
  /** Capture is active */
  Active: 'ACTIVE',
  /** Recording has been deleted */
  Deleted: 'DELETED',
  /** Recording is scheduled for deletion */
  Deleting: 'DELETING',
  /** Video has been exported */
  Exported: 'EXPORTED',
  /** Video export is in progress */
  Exporting: 'EXPORTING',
  /** Lab type does not support recording */
  NotSupported: 'NOT_SUPPORTED',
  /** Recording is paused */
  Paused: 'PAUSED',
  /** Recording created, waiting for capture to begin */
  Pending: 'PENDING'
} as const;

export type LabRecording_Status = typeof LabRecording_Status[keyof typeof LabRecording_Status];
/** Environment variables */
export type LabTemplate_ContainerEnvVar = {
  __typename?: 'LabTemplate_ContainerEnvVar';
  /** Env variable name */
  key: Scalars['String'];
  /** Env variable value */
  value: Scalars['String'];
};

/** Container resource limits */
export type LabTemplate_ContainerResourceLimits = {
  __typename?: 'LabTemplate_ContainerResourceLimits';
  /**
   * Specify how much of the available CPU resources a container can use.
   * This is a numeric value, represented as a string field because graphQl doesn't natively have a double time.
   */
  cpus: Scalars['String'];
  /**
   * The maximum amount of memory (in bytes) that the container can use.
   * This is a numeric value, represented as a string field because graphQl doesn't natively have a long time.
   */
  memory: Scalars['String'];
};

/** Configuration for health check with this lab */
export type LabTemplate_HealthCheckConfig = {
  __typename?: 'LabTemplate_HealthCheckConfig';
  /** Path used for health check request */
  path: Scalars['String'];
};

/** LabTemplate entity */
export type LabTemplate_LabTemplate = {
  __typename?: 'LabTemplate_LabTemplate';
  /** Publish settings for child workspaces. If absent child workspaces can not be published */
  childPublishSettings?: Maybe<LabTemplate_PublishSettings>;
  /** Command associated with this lab template (optional) */
  command?: Maybe<Scalars['String']>;
  /** Description of the template */
  description?: Maybe<Scalars['String']>;
  /** Environment variables */
  environmentVars: Array<LabTemplate_ContainerEnvVar>;
  /** Configuration for health check with this image */
  healthCheck: LabTemplate_HealthCheckConfig;
  /** Specification of the host to run the lab (cpu, gpu, etc.) */
  hostSpecs: Array<Scalars['String']>;
  /** The port used for this image */
  httpPort: Scalars['Int'];
  /** The id of the lab template */
  id: Scalars['ID'];
  /** Image tag ("test", "latest", "1.0.0", etc.) */
  imageTag: Scalars['String'];
  /** List of launch context macros defined for this lab template */
  launchContextMacros: Array<LabTemplates_LaunchContextMacro>;
  /** Human readable name of the template. */
  name?: Maybe<Scalars['String']>;
  /** Details provided by author during instructor lab publish */
  publishMetadata?: Maybe<LabTemplates_PublishMetadata>;
  /** Container resource limits */
  resourceLimits?: Maybe<LabTemplate_ContainerResourceLimits>;
  /** List of scopes where the template is used */
  scopes: Array<Scalars['String']>;
  /**
   * List of shared workspaces created for the template.
   * Empty list suggests that there are no shared workspaces for the template hence user specific
   * workspaces should be created.
   */
  sharedWorkspaces: Array<LabTemplate_SharedWorkspace>;
  /** The time the template was last updated. null if not set. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user who last updated the template. null if not set. */
  updatedBy?: Maybe<Scalars['ID']>;
  /** Version of this lab template */
  version: Scalars['Int'];
  /** Mount points for volumes and their definition */
  volumes: Scalars['JSON'];
};

/** Publish settings for child workspaces */
export type LabTemplate_PublishSettings = {
  __typename?: 'LabTemplate_PublishSettings';
  /** The publish types allowed for child workspaces */
  publishTypes: Array<LabTemplate_PublishType>;
};

/** Publish type */
export const LabTemplate_PublishType = {
  /** PUBLISHER CHOICE */
  PublisherChoice: 'PUBLISHER_CHOICE',
  /** RO ONLY */
  RoOnly: 'RO_ONLY'
} as const;

export type LabTemplate_PublishType = typeof LabTemplate_PublishType[keyof typeof LabTemplate_PublishType];
/** The shared workspace of the template, also known as instructor workspace. */
export type LabTemplate_SharedWorkspace = {
  __typename?: 'LabTemplate_SharedWorkspace';
  /** Workspace id, aka lab id */
  id: Scalars['ID'];
};

/** List the LaunchContextMacro which can be resolved and set as environment variables when launching a lab */
export const LabTemplates_LaunchContextMacro = {
  /** AWS Cloud Lab Start URL */
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  /** Course Branch Id */
  CourseBranchId: 'COURSE_BRANCH_ID',
  /** A hashed value of user id */
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  /** Course Id */
  CourseId: 'COURSE_ID',
  /** Course Name */
  CourseName: 'COURSE_NAME',
  /** Course Session Duration */
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  /** Course Slug */
  CourseSlug: 'COURSE_SLUG',
  /** EVG1 Code */
  Evg1Code: 'EVG1_CODE',
  /** GCP Key */
  GcloudKey: 'GCLOUD_KEY',
  /** Gen AI Models */
  GenAiModels: 'GEN_AI_MODELS',
  /** Image Application Type */
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  /** Instructor Name */
  InstructorName: 'INSTRUCTOR_NAME',
  /** In lab browser start URL */
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  /** Item Deadline */
  ItemDeadline: 'ITEM_DEADLINE',
  /** All item deadlines */
  ItemDeadlines: 'ITEM_DEADLINES',
  /** Item Id */
  ItemId: 'ITEM_ID',
  /** OPENAI API Key */
  OpenaiApiKey: 'OPENAI_API_KEY',
  /** Partner Id */
  PartnerId: 'PARTNER_ID',
  /** Session Start Time */
  SessionStartTime: 'SESSION_START_TIME',
  /** Submission Token */
  SubmissionToken: 'SUBMISSION_TOKEN',
  /** University Student Id */
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type LabTemplates_LaunchContextMacro = typeof LabTemplates_LaunchContextMacro[keyof typeof LabTemplates_LaunchContextMacro];
/** Publish metadata for a lab template */
export type LabTemplates_PublishMetadata = {
  __typename?: 'LabTemplates_PublishMetadata';
  /** Should this update be forced on existing labs */
  isForced: Scalars['Boolean'];
  /** Does it require notifying the learners */
  isNotifying: Scalars['Boolean'];
  /** Summary of the published version */
  publishSummary?: Maybe<Scalars['String']>;
};

/** 2-letter ISO language codes. */
export const LanguageCode = {
  /** Afar */
  Aa: 'aa',
  /** Abkhazian */
  Ab: 'ab',
  /** Afrikaans */
  Af: 'af',
  /** Amharic */
  Am: 'am',
  /** Arabic */
  Ar: 'ar',
  /** Assamese */
  As: 'as',
  /** Aymara */
  Ay: 'ay',
  /** Azerbaijani */
  Az: 'az',
  /** Bashkir */
  Ba: 'ba',
  /** Byelorussian */
  Be: 'be',
  /** Bulgarian */
  Bg: 'bg',
  /** Bihari */
  Bh: 'bh',
  /** Bislama */
  Bi: 'bi',
  /** Bengali; Bangla */
  Bn: 'bn',
  /** Tibetan */
  Bo: 'bo',
  /** Breton */
  Br: 'br',
  /** Catalan */
  Ca: 'ca',
  /** Corsican */
  Co: 'co',
  /** Czech */
  Cs: 'cs',
  /** Welsh */
  Cy: 'cy',
  /** Danish */
  Da: 'da',
  /** German */
  De: 'de',
  /** Bhutani */
  Dz: 'dz',
  /** Greek */
  El: 'el',
  /** English */
  En: 'en',
  /** Esperanto */
  Eo: 'eo',
  /** Spanish */
  Es: 'es',
  /** Estonian */
  Et: 'et',
  /** Basque */
  Eu: 'eu',
  /** Persian */
  Fa: 'fa',
  /** Finnish */
  Fi: 'fi',
  /** Fiji */
  Fj: 'fj',
  /** Faeroese */
  Fo: 'fo',
  /** French */
  Fr: 'fr',
  /** Frisian */
  Fy: 'fy',
  /** Irish */
  Ga: 'ga',
  /** Scots, Gaelic */
  Gd: 'gd',
  /** Galician */
  Gl: 'gl',
  /**
   * Global language code is the default language that should fall back to for a given country (for default language code should be used for english in the US).
   * This enables falling back to the country default language if a combination of country / language that is not supported is provided.
   */
  Global: 'global',
  /** Guarani */
  Gn: 'gn',
  /** Gujarati */
  Gu: 'gu',
  /** Hausa */
  Ha: 'ha',
  /** Hebrew */
  He: 'he',
  /** Hindi */
  Hi: 'hi',
  /** Croatian */
  Hr: 'hr',
  /** Hungarian */
  Hu: 'hu',
  /** Armenian */
  Hy: 'hy',
  /** Interlingua */
  Ia: 'ia',
  /** Indonesian */
  Id: 'id',
  /** Interlingue */
  Ie: 'ie',
  /** Inupiak */
  Ik: 'ik',
  /** Indonesian */
  In: 'in',
  /** Icelandic */
  Is: 'is',
  /** Italian */
  It: 'it',
  /** Inuktitut */
  Iu: 'iu',
  /** Hebrew (obsolete) */
  Iw: 'iw',
  /** Japanese */
  Ja: 'ja',
  /** Yiddish (obsolete) */
  Ji: 'ji',
  /** Javanese */
  Jw: 'jw',
  /** Georgian */
  Ka: 'ka',
  /** Kazakh */
  Kk: 'kk',
  /** Greenlandic */
  Kl: 'kl',
  /** Cambodian */
  Km: 'km',
  /** Kannada */
  Kn: 'kn',
  /** Korean */
  Ko: 'ko',
  /** Kashmiri */
  Ks: 'ks',
  /** Kurdish */
  Ku: 'ku',
  /** Kirghiz */
  Ky: 'ky',
  /** Latin */
  La: 'la',
  /** Lingala */
  Ln: 'ln',
  /** Laothian */
  Lo: 'lo',
  /** Lithuanian */
  Lt: 'lt',
  /** Latvian, Lettish */
  Lv: 'lv',
  /** Malagasy */
  Mg: 'mg',
  /** Maori */
  Mi: 'mi',
  /** Macedonian */
  Mk: 'mk',
  /** Malayalam */
  Ml: 'ml',
  /** Mongolian */
  Mn: 'mn',
  /** Moldavian */
  Mo: 'mo',
  /** Marathi */
  Mr: 'mr',
  /** Malay */
  Ms: 'ms',
  /** Maltese */
  Mt: 'mt',
  /** Burmese */
  My: 'my',
  /** Nauru */
  Na: 'na',
  /** Nepali */
  Ne: 'ne',
  /** Dutch */
  Nl: 'nl',
  /** Norwegian */
  No: 'no',
  /** Occitan */
  Oc: 'oc',
  /** (Afan), Oromo */
  Om: 'om',
  /** Oriya */
  Or: 'or',
  /** Punjabi */
  Pa: 'pa',
  /** Polish */
  Pl: 'pl',
  /** Pashto, Pushto */
  Ps: 'ps',
  /** Portuguese */
  Pt: 'pt',
  /** Quechua */
  Qu: 'qu',
  /** Rhaeto-Romance */
  Rm: 'rm',
  /** Kirundi */
  Rn: 'rn',
  /** Romanian */
  Ro: 'ro',
  /** Russian */
  Ru: 'ru',
  /** Kinyarwanda */
  Rw: 'rw',
  /** Sanskrit */
  Sa: 'sa',
  /** Sindhi */
  Sd: 'sd',
  /** Sangro */
  Sg: 'sg',
  /** Serbo-Croatian */
  Sh: 'sh',
  /** Singhalese */
  Si: 'si',
  /** Slovak */
  Sk: 'sk',
  /** Slovenian */
  Sl: 'sl',
  /** Samoan */
  Sm: 'sm',
  /** Shona */
  Sn: 'sn',
  /** Somali */
  So: 'so',
  /** Albanian */
  Sq: 'sq',
  /** Serbian */
  Sr: 'sr',
  /** Siswati */
  Ss: 'ss',
  /** Sesotho */
  St: 'st',
  /** Sundanese */
  Su: 'su',
  /** Swedish */
  Sv: 'sv',
  /** Swahili */
  Sw: 'sw',
  /** Tamil */
  Ta: 'ta',
  /** Tegulu */
  Te: 'te',
  /** Tajik */
  Tg: 'tg',
  /** Thai */
  Th: 'th',
  /** Tigrinya */
  Ti: 'ti',
  /** Turkmen */
  Tk: 'tk',
  /** Tagalog */
  Tl: 'tl',
  /** Setswana */
  Tn: 'tn',
  /** Tonga */
  To: 'to',
  /** Turkish */
  Tr: 'tr',
  /** Tsonga */
  Ts: 'ts',
  /** Tatar */
  Tt: 'tt',
  /** Twi */
  Tw: 'tw',
  /** Uigur */
  Ug: 'ug',
  /** Ukrainian */
  Uk: 'uk',
  /** Urdu */
  Ur: 'ur',
  /** Uzbek */
  Uz: 'uz',
  /** Vietnamese */
  Vi: 'vi',
  /** Volapuk */
  Vo: 'vo',
  /** Wolof */
  Wo: 'wo',
  /** Xhosa */
  Xh: 'xh',
  /** Yiddish */
  Y: 'y',
  /** Yoruba */
  Yo: 'yo',
  /** Zuang */
  Za: 'za',
  /** Chinese */
  Zh: 'zh',
  /** Zulu */
  Zu: 'zu'
} as const;

export type LanguageCode = typeof LanguageCode[keyof typeof LanguageCode];
/** languagesForProduct GraphQL Schema, maps products like courses to their available languages. */
export type LanguagesForProductQueries = {
  __typename?: 'LanguagesForProductQueries';
  /** Languages by course */
  queryByCourse?: Maybe<LanguagesForProduct_QueryByCourseResult>;
};


/** languagesForProduct GraphQL Schema, maps products like courses to their available languages. */
export type LanguagesForProductQueriesQueryByCourseArgs = {
  input: LanguagesForProduct_QueryByCourseInput;
};

/** Primary and available languages for a product */
export type LanguagesForProduct_AvailableLanguages = {
  __typename?: 'LanguagesForProduct_AvailableLanguages';
  /** Whether crowd-sourced subtitle translation via GTC is enabled (default true) */
  isSubtitleTranslationEnabled: Scalars['Boolean'];
  /**
   * Languages being served for machine-enabled content translation. Does not include subtitle
   * translations.
   * @deprecated Use translatedLanguages instead
   */
  machineTranslationEnabledLanguageCodes: Array<Scalars['String']>;
  /** The primary languages spoken in course videos. User-modifiable. */
  primaryLanguageCodes: Array<Scalars['String']>;
  /** Available subtitle languages */
  subtitleLanguageCodes: Array<Scalars['String']>;
  /** Languages for available translations of the course. Does not include subtitle translations. */
  translatedLanguages: Array<LanguagesForProduct_TranslatedLanguage>;
};

/** LanguagesForProduct-specific error interface */
export type LanguagesForProduct_Error = {
  /** Error Message */
  message: Scalars['String'];
};

/** Error message if querying by course fails */
export type LanguagesForProduct_QueryByCourseError = Error & LanguagesForProduct_Error & {
  __typename?: 'LanguagesForProduct_QueryByCourseError';
  /** Inherited field from LanguagesForProduct_Error interface */
  message: Scalars['String'];
};

/** Query by course input: course Id */
export type LanguagesForProduct_QueryByCourseInput = {
  /** Course ID */
  courseId: Scalars['ID'];
};

/** Result for query by course */
export type LanguagesForProduct_QueryByCourseResult = LanguagesForProduct_QueryByCourseError | LanguagesForProduct_QueryByCourseSuccess;

/** Success result for queryByCourse */
export type LanguagesForProduct_QueryByCourseSuccess = {
  __typename?: 'LanguagesForProduct_QueryByCourseSuccess';
  /** Available languages for the course */
  availableLanguages: LanguagesForProduct_AvailableLanguages;
};

/** Language metadata for available translation */
export type LanguagesForProduct_TranslatedLanguage = {
  __typename?: 'LanguagesForProduct_TranslatedLanguage';
  /** Language code */
  languageCode: Scalars['String'];
  /** Translation type for the language */
  translationType: LanguagesForProduct_TranslationType;
};

/** Translation type for a language */
export const LanguagesForProduct_TranslationType = {
  /** Human translation */
  Human: 'HUMAN',
  /** Machine translation */
  Machine: 'MACHINE'
} as const;

export type LanguagesForProduct_TranslationType = typeof LanguagesForProduct_TranslationType[keyof typeof LanguagesForProduct_TranslationType];
/** Queries related to the launch of a lab */
export type LaunchLabQueries = {
  __typename?: 'LaunchLabQueries';
  /** Get the status of a lab as it is being prepared for launch */
  getLabPreparationStatus?: Maybe<LaunchLab_State>;
};


/** Queries related to the launch of a lab */
export type LaunchLabQueriesGetLabPreparationStatusArgs = {
  labId: Scalars['ID'];
};

/** The state of a lab container. */
export const LaunchLab_ContainerState = {
  /** The container is healthy and ready to use */
  ContainerHealthy: 'CONTAINER_HEALTHY',
  /** The container is being removed */
  ContainerRemoved: 'CONTAINER_REMOVED',
  /** The container is being started, not ready yet */
  ContainerStarted: 'CONTAINER_STARTED',
  /** The container is unhealthy */
  ContainerUnhealthy: 'CONTAINER_UNHEALTHY',
  /** The status is unknown */
  Unknown: 'UNKNOWN'
} as const;

export type LaunchLab_ContainerState = typeof LaunchLab_ContainerState[keyof typeof LaunchLab_ContainerState];
/** Prepare lab for launch input. */
export type LaunchLab_PrepareInput = {
  /** The id of the course. */
  courseId: Scalars['ID'];
  /** Should we force a refresh for this lab? */
  forceRefresh?: Scalars['Boolean'];
  /** The id of the item. */
  itemId: Scalars['ID'];
  /** The id of the learner. */
  learnerId: Scalars['ID'];
  /** Wait for the preparation to complete (Sync), or kick off preparation, and execute async? */
  wait?: Scalars['Boolean'];
};

/** Prepare lab for launch output. */
export type LaunchLab_PrepareResult = {
  __typename?: 'LaunchLab_PrepareResult';
  /** The state of the lab after preparation. */
  labState: LaunchLab_State;
};

/** The state of a lab as it is being prepared for launch */
export type LaunchLab_State = {
  __typename?: 'LaunchLab_State';
  /** The state of the lab's containers */
  containerState: LaunchLab_ContainerState;
  /** The id of the lab */
  labId: Scalars['ID'];
  /** The state of the lab's volumes */
  volumeState: LaunchLab_VolumeState;
};

/** The state of a lab volume. */
export const LaunchLab_VolumeState = {
  /** The status is unknown */
  Unknown: 'UNKNOWN',
  /** Writing failed.  Fix and try again. */
  VolumeArchiveFailed: 'VOLUME_ARCHIVE_FAILED',
  /** Archiving then deleting volumes. DO NOT TOUCH */
  VolumeArchiveInProgress: 'VOLUME_ARCHIVE_IN_PROGRESS',
  /** The volumes are archived and deleted. Must prepare before use. */
  VolumeArchiveSucceeded: 'VOLUME_ARCHIVE_SUCCEEDED',
  /** Volumes could not be completely built.  Fix and try again. */
  VolumePreparationFailed: 'VOLUME_PREPARATION_FAILED',
  /** Volumes are being built *\/ */
  VolumePreparationInProgress: 'VOLUME_PREPARATION_IN_PROGRESS',
  /** Volumes are built */
  VolumePreparationSucceeded: 'VOLUME_PREPARATION_SUCCEEDED'
} as const;

export type LaunchLab_VolumeState = typeof LaunchLab_VolumeState[keyof typeof LaunchLab_VolumeState];
/** validation error is returned when the provided input is invalid */
export type LeanerPlan_ValidationError = Error & LearnerPlan_MutationError & {
  __typename?: 'LeanerPlan_ValidationError';
  /** reason for the validation error */
  message: Scalars['String'];
};

/** All learnercalendar queries */
export type LearnerCalendarQueries = {
  __typename?: 'LearnerCalendarQueries';
  /** This query returns a learner calendar for a user. */
  queryLearnerCalendar: LearnerCalendars_LearnerCalendar;
  /** This query returns learner calendars for a list of users. */
  queryLearnerCalendars: Array<LearnerCalendars_LearnerCalendar>;
};


/** All learnercalendar queries */
export type LearnerCalendarQueriesQueryLearnerCalendarArgs = {
  userId: Scalars['ID'];
};


/** All learnercalendar queries */
export type LearnerCalendarQueriesQueryLearnerCalendarsArgs = {
  userIds: Array<Scalars['ID']>;
};

/** Input to create new calendar settings for a user. */
export type LearnerCalendars_CreateLearnerCalendarInput = {
  /** Workaround for Android. If enabled, then the calendar feed has content, else the feed will be blank. */
  shouldDisplayContent: Scalars['Boolean'];
  /** User ID */
  userId: Scalars['ID'];
};

/** LearnerCalendars_CreateLearnerCalendar mutation result. */
export type LearnerCalendars_CreateLearnerCalendarResult = {
  __typename?: 'LearnerCalendars_CreateLearnerCalendarResult';
  /** The resulting learner calendar. */
  learnerCalendar: LearnerCalendars_LearnerCalendar;
};

/** A Learner Calendar */
export type LearnerCalendars_LearnerCalendar = {
  __typename?: 'LearnerCalendars_LearnerCalendar';
  /** Workaround for Android. If enabled, then the calendar feed has content, else the feed will be blank. */
  shouldDisplayContent: Scalars['Boolean'];
  /** Url which returns a ics file of the learner's calendar. */
  url: Scalars['String'];
};

/** Input to Toggle the "shouldDisplayContent" setting for a user. */
export type LearnerCalendars_ToggleShouldDisplayContentInput = {
  /** Workaround for Android. If enabled, then the calendar feed has content, else the feed will be blank. */
  shouldDisplayContent: Scalars['Boolean'];
  /** User ID */
  userId: Scalars['ID'];
};

/** LearnerCalendars_ToggleShouldDisplayContent mutation result. */
export type LearnerCalendars_ToggleShouldDisplayContentResult = {
  __typename?: 'LearnerCalendars_ToggleShouldDisplayContentResult';
  /** The resulting learner calendar. */
  learnerCalendar: LearnerCalendars_LearnerCalendar;
};

export type LearnerCourseScheduleSuggestionsV1 = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1';
  courseId: Scalars['String'];
  id: Scalars['String'];
  suggestions: Array<Maybe<LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_LearnerCourseScheduleSuggestion>>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type LearnerCourseScheduleSuggestionsV1Connection = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1Connection';
  elements: Array<Maybe<LearnerCourseScheduleSuggestionsV1>>;
  paging: ResponsePagination;
};

export type LearnerCourseScheduleSuggestionsV1Resource = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1Resource';
  get?: Maybe<LearnerCourseScheduleSuggestionsV1>;
  multiGet?: Maybe<LearnerCourseScheduleSuggestionsV1Connection>;
};


export type LearnerCourseScheduleSuggestionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type LearnerCourseScheduleSuggestionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type LearnerCourseScheduleSuggestionsV1ResourceMutations = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1ResourceMutations';
  getRecommendedSuggestion?: Maybe<Scalars['JSON']>;
  getSuggestionsForShiftingDeadlines?: Maybe<Scalars['JSON']>;
  shouldResetForGoalChange?: Maybe<Scalars['JSON']>;
};


export type LearnerCourseScheduleSuggestionsV1ResourceMutationsGetRecommendedSuggestionArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};


export type LearnerCourseScheduleSuggestionsV1ResourceMutationsGetSuggestionsForShiftingDeadlinesArgs = {
  id: Scalars['String'];
};


export type LearnerCourseScheduleSuggestionsV1ResourceMutationsShouldResetForGoalChangeArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};

export type LearnerCourseScheduleSuggestionsV1_CmlMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_cmlMember';
  cml: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<LearnerCourseScheduleSuggestionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_BranchChange = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_BranchChange';
  changesDescription: LearnerCourseScheduleSuggestionsV1_CmlMember;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_Extension';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason;
  sessionSwitch?: Maybe<LearnerCourseScheduleSuggestionsV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_ExtensionMember';
  org_coursera_ondemand_schedule_suggestion_Extension: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_LearnerCourseScheduleSuggestion = LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember | LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember | LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember | LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_NoSuggestion';
  reason: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_NoSuggestionMember';
  org_coursera_ondemand_schedule_suggestion_NoSuggestion: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion;
};

export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
/** Terminology: A "deadline" is a single point on a horizontal timeline. BeginningOfTime-----Deadline----EndofTime/Future "Moving forwards" is to move the deadline to the right                     Deadline-->>> Shift all deadlines forward by "days" Eg. Given Original Schedule: Let S = start Let E = end Let days = 4 1 2 3 4 5 6[S---------E] Becomes      [S--------E] If the shift in deadlines causes the user to be too far off from the relative schedule of other learners in the Cohort, they might not get enough time for Peer Review. Then we must recommend a new "Public Session/Cohort" Public Sessions act as "Cohorts/Groups" for learners in SessionsV2. Learners still receive their Peer Review Feedback from learners in the same Public Session, but have deadlines set to their own Personalized Schedule. */
export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlines';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason;
  sessionSwitch?: Maybe<LearnerCourseScheduleSuggestionsV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlinesMember';
  org_coursera_ondemand_schedule_suggestion_ShiftDeadlines: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines;
};

export const LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal';
  ArbitraryField: Scalars['String'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoalMember';
  org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SuggestedSwitch = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_session_SuggestedSwitch';
  branchChange?: Maybe<LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Schedule_BranchChange>;
  destinationSessionBranchId: Scalars['String'];
  destinationSessionId: Scalars['String'];
  sourceSessionBranchId: Scalars['String'];
  sourceSessionId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_session_SuggestedSwitchMember';
  org_coursera_ondemand_session_SuggestedSwitch: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SuggestedSwitch;
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_session_SwitchNotNeeded';
  ArbitraryField: Scalars['String'];
};

export type LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember = {
  __typename?: 'LearnerCourseScheduleSuggestionsV1_org_coursera_ondemand_session_SwitchNotNeededMember';
  org_coursera_ondemand_session_SwitchNotNeeded: LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded;
};

export type LearnerCourseScheduleSuggestionsV1_SessionSwitch = LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember | LearnerCourseScheduleSuggestionsV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember;

export type LearnerCourseSchedulesV1 = {
  __typename?: 'LearnerCourseSchedulesV1';
  computationMetadata: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Metadata_LearnerCourseScheduleComputationMetadata;
  courseId: Scalars['String'];
  endsAt: Scalars['Float'];
  id: Scalars['String'];
  itemDeadlines: Scalars['JSON'];
  itemDeadlinesArray?: Maybe<Array<Maybe<LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_ItemDeadlineWithId>>>;
  moduleDeadlines: Scalars['JSON'];
  moduleDeadlinesArray?: Maybe<Array<Maybe<LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_ModuleDeadlineWithId>>>;
  mostRecentDeadlineChangeTime?: Maybe<Scalars['Float']>;
  scheduleActivityStatus: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus;
  scheduleTypeContent: LearnerCourseSchedulesV1_ScheduleTypeContent;
  startsAt: Scalars['Float'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type LearnerCourseSchedulesV1Connection = {
  __typename?: 'LearnerCourseSchedulesV1Connection';
  elements: Array<Maybe<LearnerCourseSchedulesV1>>;
  paging: ResponsePagination;
};

export type LearnerCourseSchedulesV1FindBySlug = {
  __typename?: 'LearnerCourseSchedulesV1FindBySlug';
  connection?: Maybe<LearnerCourseSchedulesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type LearnerCourseSchedulesV1Resource = {
  __typename?: 'LearnerCourseSchedulesV1Resource';
  findBySlug?: Maybe<LearnerCourseSchedulesV1Connection>;
  get?: Maybe<LearnerCourseSchedulesV1>;
  multiGet?: Maybe<LearnerCourseSchedulesV1Connection>;
};


export type LearnerCourseSchedulesV1ResourceFindBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type LearnerCourseSchedulesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type LearnerCourseSchedulesV1ResourceMutations = {
  __typename?: 'LearnerCourseSchedulesV1ResourceMutations';
  adjust?: Maybe<Scalars['JSON']>;
  create?: Maybe<LearnerCourseSchedulesV1Connection>;
  delete?: Maybe<LearnerCourseSchedulesV1Connection>;
  lag?: Maybe<Scalars['JSON']>;
  previewSchedule?: Maybe<Scalars['JSON']>;
  recomputeEndDate?: Maybe<Scalars['JSON']>;
  updateScheduleForUserLevelGoals?: Maybe<Scalars['JSON']>;
  updateScheduleWithLearnerGoal?: Maybe<Scalars['JSON']>;
  updateStoredPersonalizedSchedule?: Maybe<Scalars['JSON']>;
};


export type LearnerCourseSchedulesV1ResourceMutationsAdjustArgs = {
  id: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsLagArgs = {
  id: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsPreviewScheduleArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsRecomputeEndDateArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsUpdateScheduleForUserLevelGoalsArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsUpdateScheduleWithLearnerGoalArgs = {
  courseId: Scalars['String'];
  userId: Scalars['String'];
};


export type LearnerCourseSchedulesV1ResourceMutationsUpdateStoredPersonalizedScheduleArgs = {
  id: Scalars['String'];
};

export type LearnerCourseSchedulesV1_CredentialTrackSessionMember = {
  __typename?: 'LearnerCourseSchedulesV1_credentialTrackSessionMember';
  credentialTrackSession: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession;
};

export type LearnerCourseSchedulesV1_DegreeSessionMember = {
  __typename?: 'LearnerCourseSchedulesV1_degreeSessionMember';
  degreeSession: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession;
};

/** Temporary (probably, famous last words) projection of map[ItemId, ItemDeadline] for better GraphQL support. Check mobile client usages before removing. */
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_ItemDeadlineWithId = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_course_session_ItemDeadlineWithId';
  deadline: Scalars['Float'];
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
};

/** Temporary (probably, famous last words) projection of map[ModuleId, ModuleDeadline] for better GraphQL support. Check mobile client usages before removing. */
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_ModuleDeadlineWithId = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_course_session_ModuleDeadlineWithId';
  deadline: Scalars['Float'];
  /** ID of a module in a course. It will never change and is unique within the course. */
  id: Scalars['String'];
};

/** This session is associated with a credential track. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_course_session_typemetadata_CredentialTrackSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

/** This session is associated with a degree. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_course_session_typemetadata_DegreeSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Flexible = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_Flexible';
  enabledForCustomScheduleExperiment?: Maybe<Scalars['Boolean']>;
  scheduleOverride?: Maybe<LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride>;
};

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_FlexibleMember = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_FlexibleMember';
  org_coursera_ondemand_schedule_Flexible: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Flexible;
};

export const LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  Paused: 'PAUSED'
} as const;

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus = typeof LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus[keyof typeof LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleActivityStatus];
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_ScheduleOverride';
  timedItemLocks: Scalars['JSON'];
};

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Strict = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_Strict';
  scheduleOverride?: Maybe<LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride>;
};

export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_StrictMember = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_StrictMember';
  org_coursera_ondemand_schedule_Strict: LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Strict;
};

/** Holds information related to how the LearnerCourseSchedule was computed. This will be a subset of the Session, as a Session is the base information on which deadline overrides are applied. */
export type LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_Metadata_LearnerCourseScheduleComputationMetadata = {
  __typename?: 'LearnerCourseSchedulesV1_org_coursera_ondemand_schedule_metadata_LearnerCourseScheduleComputationMetadata';
  branchId: Scalars['String'];
  courseId: Scalars['String'];
  discussionSessionId?: Maybe<Scalars['String']>;
  enrollmentEndsAt?: Maybe<Scalars['Float']>;
  isPreview?: Maybe<Scalars['Boolean']>;
  isPrivate: Scalars['Boolean'];
  sessionId: Scalars['String'];
  sessionTypeMetadata?: Maybe<LearnerCourseSchedulesV1_SessionTypeMetadata>;
  versionedBranchId?: Maybe<Scalars['String']>;
};

export type LearnerCourseSchedulesV1_ScheduleTypeContent = LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_FlexibleMember | LearnerCourseSchedulesV1_Org_Coursera_Ondemand_Schedule_StrictMember;

export type LearnerCourseSchedulesV1_SessionTypeMetadata = LearnerCourseSchedulesV1_CredentialTrackSessionMember | LearnerCourseSchedulesV1_DegreeSessionMember;

/** Course timeline GraphQL queries */
export type LearnerCourseTimelineQueries = {
  __typename?: 'LearnerCourseTimelineQueries';
  /** Query course timeline */
  queryCourseTimeline: LearnerCourseTimeline_CourseTimeline;
};


/** Course timeline GraphQL queries */
export type LearnerCourseTimelineQueriesQueryCourseTimelineArgs = {
  courseId: Scalars['ID'];
};

/** Course timeline of a course. */
export type LearnerCourseTimeline_CourseTimeline = {
  __typename?: 'LearnerCourseTimeline_CourseTimeline';
  /** Estimated course end date */
  endDate: Scalars['DateTime'];
  /** Overall course status */
  overallCourseStatus: LearnerCourseTimeline_OverallCourseStatus;
  /** Course start date when the user enrolled in the course */
  startDate: Scalars['DateTime'];
  /** object containing the required fields used to construct the DeadlineOverdueMessage for a course */
  strictScheduleModuleStatuses?: Maybe<LearnerCourseTimeline_StrictScheduleModuleStatuses>;
  /** Upcoming items of the course. Size will be between 0 to 2. */
  upcomingItems: Array<LearnerCourseTimeline_UpcomingItem>;
};

/** Overall course status */
export type LearnerCourseTimeline_OverallCourseStatus = LearnerCourseTimeline_OverallCourseStatusAheadOfSchedule | LearnerCourseTimeline_OverallCourseStatusCompleted | LearnerCourseTimeline_OverallCourseStatusOnTrack | LearnerCourseTimeline_OverallCourseStatusOverdue | LearnerCourseTimeline_OverallCourseStatusResetDeadlines | LearnerCourseTimeline_OverallCourseStatusSwitchSessions;

/** Ahead of schedule overall course status */
export type LearnerCourseTimeline_OverallCourseStatusAheadOfSchedule = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusAheadOfSchedule';
  /** Number of days the learner is ahead of course schedule. Empty if a required item is skipped. */
  daysAheadOfSchedule?: Maybe<Scalars['Int']>;
};

/** Completed overall course status */
export type LearnerCourseTimeline_OverallCourseStatusCompleted = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusCompleted';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** On track overall course status */
export type LearnerCourseTimeline_OverallCourseStatusOnTrack = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusOnTrack';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Overdue overall course status */
export type LearnerCourseTimeline_OverallCourseStatusOverdue = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusOverdue';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Reset deadlines overall course status */
export type LearnerCourseTimeline_OverallCourseStatusResetDeadlines = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusResetDeadlines';
  /** Number of days to adjust deadlines. */
  daysToAdjust: Scalars['Int'];
  /** The new estimated course end date after resetting deadlines. */
  newEstimatedEndDate: Scalars['DateTime'];
};

/** Value that determines whether a user should be shown the JoinNextSessionMessage */
export type LearnerCourseTimeline_OverallCourseStatusSwitchSessions = {
  __typename?: 'LearnerCourseTimeline_OverallCourseStatusSwitchSessions';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * Object containing module specific statuses to determine whether a module is overdue for the
 * deadline overdue message
 */
export type LearnerCourseTimeline_OverdueModuleStatuses = {
  __typename?: 'LearnerCourseTimeline_OverdueModuleStatuses';
  /** Whether or not the user has peer reviews they have yet to submit */
  hasUnsubmittedPeerReviews: Scalars['Boolean'];
  /** Whether the user has overdue peer reviews they have yet to submit */
  isPeerReviewOverdue: Scalars['Boolean'];
  /** Module for which the subsequent fields correspond to */
  moduleNumber?: Maybe<Scalars['Int']>;
};

/** Object containing the fields required to determine whether to show a user the DeadlineOverdueMessage */
export type LearnerCourseTimeline_StrictScheduleModuleStatuses = {
  __typename?: 'LearnerCourseTimeline_StrictScheduleModuleStatuses';
  /**
   * Whether or not there are sessions other then the current one a user is enrolled in, that
   * are available in the course for the user to enroll in
   */
  hasEnrollableSession: Scalars['Boolean'];
  /** Whether or not the users currently enrolled session is private */
  isSessionPrivate: Scalars['Boolean'];
  /**
   * module specific status fields used to calculate whether or not to show the deadline overdue
   * message for a module
   */
  overdueModuleStatuses: Array<LearnerCourseTimeline_OverdueModuleStatuses>;
  /** End date time for the users currently enrolled session */
  sessionEndDateTime: Scalars['DateTime'];
};

/** Upcoming course item */
export type LearnerCourseTimeline_UpcomingItem = {
  __typename?: 'LearnerCourseTimeline_UpcomingItem';
  /** Item due date */
  itemDueDate: Scalars['DateTime'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Item name */
  itemName: Scalars['String'];
  /** Item resource path, e.g. /learn/trees-graphs-basics/supplement/APJv5/course-facilitation */
  itemResourcePath: Scalars['String'];
  /** Item status */
  itemStatus: LearnerCourseTimeline_UpcomingItemStatus;
};

/** Upcoming item status. */
export const LearnerCourseTimeline_UpcomingItemStatus = {
  /** On track item status. Item due date is before the current time. */
  OnTrack: 'ON_TRACK',
  /** Overdue item status. Item due date is after the current time. */
  Overdue: 'OVERDUE'
} as const;

export type LearnerCourseTimeline_UpcomingItemStatus = typeof LearnerCourseTimeline_UpcomingItemStatus[keyof typeof LearnerCourseTimeline_UpcomingItemStatus];
/** Learner goals queries */
export type LearnerGoalsQueries = {
  __typename?: 'LearnerGoalsQueries';
  /**
   * Query the active macro goal for a learner. Null if the learner is in the control group,
   * is ineligible, or has no macro goal.
   *
   * If `courseId` is supplied on first-touch auto-creation, the macro goal is bound to that course
   * (or its primary specialization). Subsequent calls return the existing goal regardless of
   * `courseId`. When absent, the server runs the activity-ranking resolver across the learner's
   * memberships. See ADR-007 in the agentic-initiative-macro-goals vault.
   */
  queryMacroGoal?: Maybe<LearnerGoals_MacroGoal>;
  /** Query available macro goal options (target date suggestions) for a given credential. */
  queryMacroGoalOptions: LearnerGoals_MacroGoalOptions;
  /** Query weekly goal for a learner. Null if the learner has not set a weekly goal. */
  queryWeeklyGoal?: Maybe<LearnerGoals_WeeklyGoal>;
};


/** Learner goals queries */
export type LearnerGoalsQueriesQueryMacroGoalArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


/** Learner goals queries */
export type LearnerGoalsQueriesQueryMacroGoalOptionsArgs = {
  input: LearnerGoals_QueryMacroGoalOptionsInput;
};

/**
 * For goals where a learner has to complete a specific number of items, this contains details
 * regarding their progress towards completing the target number of items.
 */
export type LearnerGoals_CompleteItemsProgressDetails = {
  __typename?: 'LearnerGoals_CompleteItemsProgressDetails';
  /** The number of completed items. */
  numberOfCompletedItems: Scalars['Int'];
  /** The target number of items to complete for the goal (including already completed items) */
  targetNumberOfItemsToComplete: Scalars['Int'];
};

/** Tracking data for a course macro goal. */
export type LearnerGoals_CourseTracking = {
  __typename?: 'LearnerGoals_CourseTracking';
  /** Number of items completed so far. */
  completedItems: Scalars['Int'];
  /** Total number of items in the course. */
  totalItems: Scalars['Int'];
};

/** A daily goal for a learner. */
export type LearnerGoals_DailyGoal = {
  __typename?: 'LearnerGoals_DailyGoal';
  /** Goal Id */
  goalId: Scalars['ID'];
  /** Type of the goal with possible additional progress details */
  goalTypeAndProgressDetails: LearnerGoals_DailyGoalDetails;
  /** Overall progress status of the daily goals. */
  progressStatus: LearnerGoals_DailyGoalProgressStatus;
};

/** Progress of daily goal type to add a career goal. */
export type LearnerGoals_DailyGoalAddCareerGoal = {
  __typename?: 'LearnerGoals_DailyGoalAddCareerGoal';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete all practice exercises in a module. */
export type LearnerGoals_DailyGoalCompleteAllPracticeInModule = {
  __typename?: 'LearnerGoals_DailyGoalCompleteAllPracticeInModule';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete assessments */
export type LearnerGoals_DailyGoalCompleteAssessments = {
  __typename?: 'LearnerGoals_DailyGoalCompleteAssessments';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete a course. */
export type LearnerGoals_DailyGoalCompleteCourse = {
  __typename?: 'LearnerGoals_DailyGoalCompleteCourse';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete a dialogue exercise. */
export type LearnerGoals_DailyGoalCompleteDialogue = {
  __typename?: 'LearnerGoals_DailyGoalCompleteDialogue';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete first course ever. */
export type LearnerGoals_DailyGoalCompleteFirstCourse = {
  __typename?: 'LearnerGoals_DailyGoalCompleteFirstCourse';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete first hands-on exercise. */
export type LearnerGoals_DailyGoalCompleteFirstHandsOnItem = {
  __typename?: 'LearnerGoals_DailyGoalCompleteFirstHandsOnItem';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete first lab assignment. */
export type LearnerGoals_DailyGoalCompleteFirstLab = {
  __typename?: 'LearnerGoals_DailyGoalCompleteFirstLab';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete a graded assessment. */
export type LearnerGoals_DailyGoalCompleteGradedAssessment = {
  __typename?: 'LearnerGoals_DailyGoalCompleteGradedAssessment';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete hands-on items */
export type LearnerGoals_DailyGoalCompleteHandsOnItems = {
  __typename?: 'LearnerGoals_DailyGoalCompleteHandsOnItems';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete a video with interactive questions. */
export type LearnerGoals_DailyGoalCompleteInVideoQuestion = {
  __typename?: 'LearnerGoals_DailyGoalCompleteInVideoQuestion';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete X items. */
export type LearnerGoals_DailyGoalCompleteItems = {
  __typename?: 'LearnerGoals_DailyGoalCompleteItems';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete X lectures. */
export type LearnerGoals_DailyGoalCompleteLectures = {
  __typename?: 'LearnerGoals_DailyGoalCompleteLectures';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete a module. */
export type LearnerGoals_DailyGoalCompleteModule = {
  __typename?: 'LearnerGoals_DailyGoalCompleteModule';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete a percentage checkpoint of the course. */
export type LearnerGoals_DailyGoalCompletePercentageCheckpoint = {
  __typename?: 'LearnerGoals_DailyGoalCompletePercentageCheckpoint';
  /** Target Percentage to be completed for the checkpoint. */
  targetPercentage: Scalars['Int'];
};

/**
 * Progress of daily goal type to complete practice items (ex. practice quiz, practice peer review,
 * etc)
 */
export type LearnerGoals_DailyGoalCompletePractice = {
  __typename?: 'LearnerGoals_DailyGoalCompletePractice';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete X readings. */
export type LearnerGoals_DailyGoalCompleteReadings = {
  __typename?: 'LearnerGoals_DailyGoalCompleteReadings';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_CompleteItemsProgressDetails;
};

/** Progress of daily goal type to complete a role-play exercise. */
export type LearnerGoals_DailyGoalCompleteRolePlay = {
  __typename?: 'LearnerGoals_DailyGoalCompleteRolePlay';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Represents a learner's daily goal completion history over a specified time period. */
export type LearnerGoals_DailyGoalCompletionHistory = {
  __typename?: 'LearnerGoals_DailyGoalCompletionHistory';
  /** A list of days where a learner made some progress against their daily goals */
  dailyGoalCompletionProgressHistory: Array<LearnerGoals_DailyGoalCompletionHistoryDayProgress>;
  /** The end date of the historical period (inclusive) */
  endDate: Scalars['Date'];
  /** The start date of the historical period (inclusive) */
  startDate: Scalars['Date'];
};

/** Represents one day where a learner made some progress against their daily goals */
export type LearnerGoals_DailyGoalCompletionHistoryDayProgress = {
  __typename?: 'LearnerGoals_DailyGoalCompletionHistoryDayProgress';
  /** Date where learner made progress */
  day: Scalars['Date'];
  /** Number of daily goals the learner was assigned on that date */
  numberOfGoalsAssigned: Scalars['Int'];
  /** Number of daily goals the learner completed on that date */
  numberOfGoalsCompleted: Scalars['Int'];
};

/**
 * Progress of daily goal type to complete an item to meet a weekly streak target for an existing
 * streak
 */
export type LearnerGoals_DailyGoalContinueWeeklyStreak = {
  __typename?: 'LearnerGoals_DailyGoalContinueWeeklyStreak';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Daily goal progress of different goal types. */
export type LearnerGoals_DailyGoalDetails = LearnerGoals_DailyGoalAddCareerGoal | LearnerGoals_DailyGoalCompleteAllPracticeInModule | LearnerGoals_DailyGoalCompleteAssessments | LearnerGoals_DailyGoalCompleteCourse | LearnerGoals_DailyGoalCompleteDialogue | LearnerGoals_DailyGoalCompleteFirstCourse | LearnerGoals_DailyGoalCompleteFirstHandsOnItem | LearnerGoals_DailyGoalCompleteFirstLab | LearnerGoals_DailyGoalCompleteGradedAssessment | LearnerGoals_DailyGoalCompleteHandsOnItems | LearnerGoals_DailyGoalCompleteInVideoQuestion | LearnerGoals_DailyGoalCompleteItems | LearnerGoals_DailyGoalCompleteLectures | LearnerGoals_DailyGoalCompleteModule | LearnerGoals_DailyGoalCompletePercentageCheckpoint | LearnerGoals_DailyGoalCompletePractice | LearnerGoals_DailyGoalCompleteReadings | LearnerGoals_DailyGoalCompleteRolePlay | LearnerGoals_DailyGoalContinueWeeklyStreak | LearnerGoals_DailyGoalEarnSkillPoints | LearnerGoals_DailyGoalMakeProgressOnWeeklyStreakTarget | LearnerGoals_DailyGoalPracticeWithCoach | LearnerGoals_DailyGoalReturnToCoursera | LearnerGoals_DailyGoalScore80PercentOnAssignment | LearnerGoals_DailyGoalSetUpLearningPlan | LearnerGoals_DailyGoalShareYourCertificate | LearnerGoals_DailyGoalStartCourse | LearnerGoals_DailyGoalStartNextCourse | LearnerGoals_DailyGoalStartWeeklyStreak | LearnerGoals_DailyGoalUnlockPersonalizedTracker;

/** Progress of daily goal type to earn skill XP. */
export type LearnerGoals_DailyGoalEarnSkillPoints = {
  __typename?: 'LearnerGoals_DailyGoalEarnSkillPoints';
  /** Additional details on the users progress against the goal */
  progressDetails: LearnerGoals_EarnSkillPointsProgressDetails;
};

/** Progress of daily goal type to complete an item to make progress toward a weekly streak target */
export type LearnerGoals_DailyGoalMakeProgressOnWeeklyStreakTarget = {
  __typename?: 'LearnerGoals_DailyGoalMakeProgressOnWeeklyStreakTarget';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to practice with Coach. */
export type LearnerGoals_DailyGoalPracticeWithCoach = {
  __typename?: 'LearnerGoals_DailyGoalPracticeWithCoach';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Overall goal progress status of a daily goal. */
export const LearnerGoals_DailyGoalProgressStatus = {
  /** A learner has completed the daily goal. */
  Completed: 'COMPLETED',
  /** A learner is making progress to complete the daily goal. */
  InProgress: 'IN_PROGRESS',
  /** A learner has not started making progress on the daily goal. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LearnerGoals_DailyGoalProgressStatus = typeof LearnerGoals_DailyGoalProgressStatus[keyof typeof LearnerGoals_DailyGoalProgressStatus];
/** Progress of daily goal type to return to Coursera. */
export type LearnerGoals_DailyGoalReturnToCoursera = {
  __typename?: 'LearnerGoals_DailyGoalReturnToCoursera';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to score 80 percent on an assignment */
export type LearnerGoals_DailyGoalScore80PercentOnAssignment = {
  __typename?: 'LearnerGoals_DailyGoalScore80PercentOnAssignment';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to set up a learning plan. */
export type LearnerGoals_DailyGoalSetUpLearningPlan = {
  __typename?: 'LearnerGoals_DailyGoalSetUpLearningPlan';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to share your certificate. */
export type LearnerGoals_DailyGoalShareYourCertificate = {
  __typename?: 'LearnerGoals_DailyGoalShareYourCertificate';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to start course. */
export type LearnerGoals_DailyGoalStartCourse = {
  __typename?: 'LearnerGoals_DailyGoalStartCourse';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to start next course. */
export type LearnerGoals_DailyGoalStartNextCourse = {
  __typename?: 'LearnerGoals_DailyGoalStartNextCourse';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to complete an item to meet a weekly streak target for a new streak */
export type LearnerGoals_DailyGoalStartWeeklyStreak = {
  __typename?: 'LearnerGoals_DailyGoalStartWeeklyStreak';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Progress of daily goal type to unlock personalized tracker */
export type LearnerGoals_DailyGoalUnlockPersonalizedTracker = {
  __typename?: 'LearnerGoals_DailyGoalUnlockPersonalizedTracker';
  /** GraphQL types must include at least one field, so an empty field is defined here */
  _?: Maybe<Scalars['Boolean']>;
};

/** Daily goals for a learner. */
export type LearnerGoals_DailyGoals = {
  __typename?: 'LearnerGoals_DailyGoals';
  /** List of daily goals. */
  dailyGoals: Array<LearnerGoals_DailyGoal>;
  /** Which day in their learning journey a user is on. Values will be between 1-4 */
  dayOfLearning: Scalars['Int'];
};

/** Goal status of a day. */
export type LearnerGoals_DayGoalStatus = {
  __typename?: 'LearnerGoals_DayGoalStatus';
  /** Day in a week. */
  day: LearnerGoals_DayInAWeek;
  /** If the learner made progress on the day. */
  hasMadeProgress: Scalars['Boolean'];
  /** If the day is a goal day to learn. */
  isGoalDay: Scalars['Boolean'];
};

/** Day in a week */
export const LearnerGoals_DayInAWeek = {
  /** Friday */
  Friday: 'FRIDAY',
  /** Monday */
  Monday: 'MONDAY',
  /** Saturday */
  Saturday: 'SATURDAY',
  /** Sunday */
  Sunday: 'SUNDAY',
  /** Thursday */
  Thursday: 'THURSDAY',
  /** Tuesday */
  Tuesday: 'TUESDAY',
  /** Wednesday */
  Wednesday: 'WEDNESDAY'
} as const;

export type LearnerGoals_DayInAWeek = typeof LearnerGoals_DayInAWeek[keyof typeof LearnerGoals_DayInAWeek];
/** Learn on day X of a week */
export type LearnerGoals_DayToLearnInAWeek = {
  /** Specify which day to learn in a week */
  day: LearnerGoals_DayInAWeek;
};

/**
 * For goals where a learner has to earn skill XP, this contains details regarding their progress
 * towards earning the target amount of skill XP.
 */
export type LearnerGoals_EarnSkillPointsProgressDetails = {
  __typename?: 'LearnerGoals_EarnSkillPointsProgressDetails';
  /** The amount of skill XP the learner has earned so far today. */
  earnedSkillPoints: Scalars['Int'];
  /** The target amount of skill XP to earn for the goal. */
  targetSkillPointsToEarn: Scalars['Int'];
};

/** Edit weekly goal to learn X days in a week. */
export type LearnerGoals_EditWeeklyGoalDaysOfLearningInput = {
  /** Edit the days to learn in a week. */
  daysToLearn: Array<LearnerGoals_DayToLearnInAWeek>;
};

/** Edit weekly goal input. */
export type LearnerGoals_EditWeeklyGoalInput = {
  /** Edit weekly goal to learn X days in a week. */
  daysOfLearning?: InputMaybe<LearnerGoals_EditWeeklyGoalDaysOfLearningInput>;
};

/** Edit weekly goal result. */
export type LearnerGoals_EditWeeklyGoalResult = LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_EditWeeklyGoalResultSuccess;

/** Edit weekly goal throws an error. */
export type LearnerGoals_EditWeeklyGoalResultError = Error & {
  __typename?: 'LearnerGoals_EditWeeklyGoalResultError';
  /** Edit weekly goal error message. */
  message: Scalars['String'];
};

/** Edit weekly goal successfully. */
export type LearnerGoals_EditWeeklyGoalResultSuccess = {
  __typename?: 'LearnerGoals_EditWeeklyGoalResultSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * A macro goal represents a learner's long-term completion goal for a target credential
 * (course or specialization), including a target date and pacing information.
 */
export type LearnerGoals_MacroGoal = {
  __typename?: 'LearnerGoals_MacroGoal';
  /** Number of days per week the learner plans to study. */
  daysPerWeek: Scalars['Int'];
  /** Number of items the learner aims to complete per learning day. Negotiated by the learner in the goal-setting dialog. */
  itemsPerDay: Scalars['Int'];
  /** Pacing information. Use state field for NOT_STARTED/UNAVAILABLE cases. */
  pacing: LearnerGoals_Pacing;
  /** Source of the macro goal (auto-generated or user-customized). */
  source: LearnerGoals_MacroGoalSource;
  /** Target date for completion. */
  targetCompletionDate: Scalars['Date'];
  /** The target credential of the macro goal. Title and other display fields are resolved via federation. */
  targetCredential: LearnerGoals_TargetCredential;
  /** Progress tracking data. Shape varies by target credential type — use __typename to distinguish. */
  tracking: LearnerGoals_Tracking;
};

/** Available macro goal options for a target credential, including suggested target dates. */
export type LearnerGoals_MacroGoalOptions = {
  __typename?: 'LearnerGoals_MacroGoalOptions';
  /** Number of items the learner has completed in the target credential. */
  completedItems: Scalars['Int'];
  /** Target date options, ordered from fastest to most relaxed. One option will have isRecommended=true. */
  options: Array<LearnerGoals_TargetDateOption>;
  /** The target credential these options are for. Title and other display fields are resolved via federation. */
  targetCredential: LearnerGoals_TargetCredential;
  /** Total number of items in the target credential. */
  totalItems: Scalars['Int'];
};

/** Source of the macro goal. */
export const LearnerGoals_MacroGoalSource = {
  /** The macro goal was auto-generated by the system. */
  AutoGenerated: 'AUTO_GENERATED',
  /** The macro goal was customized by the user. */
  UserCustomized: 'USER_CUSTOMIZED'
} as const;

export type LearnerGoals_MacroGoalSource = typeof LearnerGoals_MacroGoalSource[keyof typeof LearnerGoals_MacroGoalSource];
/** Overall goal progress status of a weekly goal. */
export const LearnerGoals_OverallGoalProgressStatus = {
  /** A learner has completed the weekly goal. */
  Completed: 'COMPLETED',
  /** A learner made more progress than the weekly goal. */
  Exceeding: 'EXCEEDING',
  /** A learner has not started making progress on the weekly goal. */
  NotStarted: 'NOT_STARTED',
  /** A learner is on track to complete the weekly goal. */
  OnTrack: 'ON_TRACK'
} as const;

export type LearnerGoals_OverallGoalProgressStatus = typeof LearnerGoals_OverallGoalProgressStatus[keyof typeof LearnerGoals_OverallGoalProgressStatus];
/** Pacing information for a macro goal, describing learner progress relative to the target date. */
export type LearnerGoals_Pacing = {
  __typename?: 'LearnerGoals_Pacing';
  /** Percentage of the target credential completed, as a value between 0 and 100. */
  completionPercentage: Scalars['Int'];
  /** Predicted completion date based on current progress. Null when no items have been completed yet. */
  predictedCompletionDate?: Maybe<Scalars['Date']>;
  /** Current pacing state. */
  state: LearnerGoals_PacingState;
};

/** Pacing state for a macro goal. */
export const LearnerGoals_PacingState = {
  /** Learner is ahead of schedule. */
  Ahead: 'AHEAD',
  /** Learner is behind schedule. */
  Behind: 'BEHIND',
  /** Learner is on track to meet the target date. */
  OnTrack: 'ON_TRACK'
} as const;

export type LearnerGoals_PacingState = typeof LearnerGoals_PacingState[keyof typeof LearnerGoals_PacingState];
/** Input for querying macro goal options for a target credential. */
export type LearnerGoals_QueryMacroGoalOptionsInput = {
  /** ID of the target credential. */
  targetCredentialId: Scalars['ID'];
  /** Type of target credential. */
  targetCredentialType: LearnerGoals_TargetCredentialType;
};

/** Input for setting or updating a macro goal. */
export type LearnerGoals_SetMacroGoalInput = {
  /** Number of days per week the learner plans to study. */
  daysPerWeek: Scalars['Int'];
  /** Number of items the learner aims to complete per learning day. Negotiated by the learner in the goal-setting dialog. */
  itemsPerDay: Scalars['Int'];
  /** Target date for completion. */
  targetCompletionDate: Scalars['Date'];
  /** ID of the target credential. */
  targetCredentialId: Scalars['ID'];
  /** Type of target credential. */
  targetCredentialType: LearnerGoals_TargetCredentialType;
};

/** Set macro goal result. */
export type LearnerGoals_SetMacroGoalResult = LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetMacroGoalResultSuccess;

/** Set macro goal throws an error. */
export type LearnerGoals_SetMacroGoalResultError = Error & {
  __typename?: 'LearnerGoals_SetMacroGoalResultError';
  /** Set macro goal error message. */
  message: Scalars['String'];
};

/** Set macro goal successfully. */
export type LearnerGoals_SetMacroGoalResultSuccess = {
  __typename?: 'LearnerGoals_SetMacroGoalResultSuccess';
  /** The created or updated macro goal. */
  macroGoal: LearnerGoals_MacroGoal;
};

/** Set weekly goal to learn X days in a week. */
export type LearnerGoals_SetWeeklyGoalDaysOfLearningInput = {
  /** Set the days to learn in a week. */
  daysToLearn: Array<LearnerGoals_DayToLearnInAWeek>;
};

/** Set weekly goal input. */
export type LearnerGoals_SetWeeklyGoalInput = {
  /** Set weekly goal to learn X days in a week. */
  daysOfLearning?: InputMaybe<LearnerGoals_SetWeeklyGoalDaysOfLearningInput>;
};

/** Set weekly goal result. */
export type LearnerGoals_SetWeeklyGoalResult = LearnerGoals_SetWeeklyGoalResultError | LearnerGoals_SetWeeklyGoalResultSuccess;

/** Set weekly goal throws an error. */
export type LearnerGoals_SetWeeklyGoalResultError = Error & {
  __typename?: 'LearnerGoals_SetWeeklyGoalResultError';
  /** Set weekly goal error message */
  message: Scalars['String'];
};

/** Set weekly goal successfully. */
export type LearnerGoals_SetWeeklyGoalResultSuccess = {
  __typename?: 'LearnerGoals_SetWeeklyGoalResultSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Tracking data for a specialization macro goal. */
export type LearnerGoals_SpecializationTracking = {
  __typename?: 'LearnerGoals_SpecializationTracking';
  /** IDs of courses the learner has completed (passingState == PASSED). */
  completedCourseIds: Array<Scalars['ID']>;
  /** Ordered list of course IDs in the specialization. Populated at goal creation from catalog data. */
  courseIds: Array<Scalars['ID']>;
  /** Items completed in the current course. */
  currentCourseCompletedItems: Scalars['Int'];
  /** ID of the course the learner is currently working on. */
  currentCourseId: Scalars['ID'];
  /** Total items in the current course. */
  currentCourseTotalItems: Scalars['Int'];
};

/**
 * The target credential of a macro goal — the course or specialization the learner is
 * working toward. Extensible to other entity types (e.g. a future JobTitle) without
 * breaking clients.
 */
export type LearnerGoals_TargetCredential = Course_Course | Specialization_Specialization;

/**
 * Type of target credential for a macro goal. Used on inputs where a caller identifies
 * a target credential by (type, id) pair.
 */
export const LearnerGoals_TargetCredentialType = {
  /** A single course. */
  Course: 'COURSE',
  /** A specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type LearnerGoals_TargetCredentialType = typeof LearnerGoals_TargetCredentialType[keyof typeof LearnerGoals_TargetCredentialType];
/** A target date option for setting a macro goal. */
export type LearnerGoals_TargetDateOption = {
  __typename?: 'LearnerGoals_TargetDateOption';
  /** The suggested target completion date. */
  date: Scalars['Date'];
  /** Whether this is the recommended option. */
  isRecommended: Scalars['Boolean'];
  /** Pace-tier label for this option. The frontend maps this to the display string. */
  paceLabel: LearnerGoals_TargetDatePaceLabel;
};

/**
 * Label for a target date option, representing its pace relative to the other options.
 * The frontend maps these to display strings (e.g. "Fast pace", "Recommended", "Relaxed")
 * and can localize as needed.
 */
export const LearnerGoals_TargetDatePaceLabel = {
  /** Middle option. Derived from the default completion time for the target credential. */
  Default: 'DEFAULT',
  /** Faster than DEFAULT. */
  Fast: 'FAST',
  /** Slower than DEFAULT. */
  Slow: 'SLOW',
  /** Fastest option. Derived from the veryFast tier of the target credential's completion time config. */
  VeryFast: 'VERY_FAST',
  /** Slowest option. Derived from the verySlow tier of the target credential's completion time config. */
  VerySlow: 'VERY_SLOW'
} as const;

export type LearnerGoals_TargetDatePaceLabel = typeof LearnerGoals_TargetDatePaceLabel[keyof typeof LearnerGoals_TargetDatePaceLabel];
/** Progress tracking data, polymorphic by target credential type. */
export type LearnerGoals_Tracking = LearnerGoals_CourseTracking | LearnerGoals_SpecializationTracking;

/** Weekly goal for a learner. */
export type LearnerGoals_WeeklyGoal = {
  __typename?: 'LearnerGoals_WeeklyGoal';
  /** Goal status of each day in the current week. */
  dayGoalStatus: Array<LearnerGoals_DayGoalStatus>;
  /** Overall weekly goal progress status. */
  overallGoalProgressStatus: LearnerGoals_OverallGoalProgressStatus;
  /** Weekly Goal type. */
  weeklyGoalType: LearnerGoals_WeeklyGoalType;
};

/** Weekly goal type for a learner. */
export type LearnerGoals_WeeklyGoalType = LearnerGoals_WeeklyGoalTypeDaysOfLearning;

/** Weekly goal type to learn X days in a week. */
export type LearnerGoals_WeeklyGoalTypeDaysOfLearning = {
  __typename?: 'LearnerGoals_WeeklyGoalTypeDaysOfLearning';
  /** Number of days in a week to learn that a learner has set the weekly goal for. Value will be between 1 to 7. */
  daysToLearn: Scalars['Int'];
};

/** All supported products for recording learner's interest towards */
export type LearnerInterest_Product = {
  /** The ID of the product */
  productId: Scalars['ID'];
  /** The enum type of the product */
  productType: LearnerInterest_ProductType;
};

/** The enum indicating the type of the product */
export const LearnerInterest_ProductType = {
  /** The product is a course */
  Course: 'COURSE',
  /** The product is a S12N */
  Specialization: 'SPECIALIZATION'
} as const;

export type LearnerInterest_ProductType = typeof LearnerInterest_ProductType[keyof typeof LearnerInterest_ProductType];
/** Error result for setting learner interest */
export type LearnerInterest_SetLearnerInterestError = Error & {
  __typename?: 'LearnerInterest_SetLearnerInterestError';
  /** Error code */
  code: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
};

/** Input of setting learner interest */
export type LearnerInterest_SetLearnerInterestInput = {
  /**
   * Input flag indicating learner interest state.
   * - true: record that learner is no longer interested in this product
   * - false: clears a previous 'no longer interested' state if present (no-op otherwise)
   */
  noLongerInterested: Scalars['Boolean'];
  /** a learning product, such as a course */
  product: LearnerInterest_Product;
};

/** Result of setting learner interest */
export type LearnerInterest_SetLearnerInterestResult = LearnerInterest_SetLearnerInterestError | LearnerInterest_SetLearnerInterestSuccess;

/** Success result for setting learner interest */
export type LearnerInterest_SetLearnerInterestSuccess = {
  __typename?: 'LearnerInterest_SetLearnerInterestSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** LearnerObject queries */
export type LearnerObjectQueries = {
  __typename?: 'LearnerObjectQueries';
  /**
   * Get the learner object for the authenticated user, scoped to the given course.
   * The authenticated user's ID is derived from the security context; the caller cannot
   * request another user's course data.
   */
  attributesByCourseId?: Maybe<LearnerObject_CourseScopedLearnerObject>;
  /** Get the learner object for the authenticated user. */
  attributesByUserId?: Maybe<LearnerObject_LearnerObject>;
  /** Get the learner object for a logged-out user by their user identifier (cookie ID or hashed cookie ID). */
  attributesByUserIdentifier?: Maybe<LearnerObject_LearnerObject>;
};


/** LearnerObject queries */
export type LearnerObjectQueriesAttributesByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/** LearnerObject queries */
export type LearnerObjectQueriesAttributesByUserIdentifierArgs = {
  userIdentifier: Scalars['String'];
};

/** User's birthday with month, day, and year. */
export type LearnerObject_Birthday = {
  __typename?: 'LearnerObject_Birthday';
  /** Birth day (1-31). */
  day?: Maybe<Scalars['Int']>;
  /** Birth month (1-12). */
  month?: Maybe<Scalars['Int']>;
  /** Birth year. */
  year?: Maybe<Scalars['Int']>;
};

/** Input type for birthday. */
export type LearnerObject_BirthdayInput = {
  /** Birth day (1-31). */
  day: Scalars['Int'];
  /** Birth month (1-12). */
  month: Scalars['Int'];
  /** Birth year. */
  year: Scalars['Int'];
};

/** Union type of the two career/occupation types used in learner object */
export type LearnerObject_Career = LearnerObject_OccupationId | LearnerObject_UserGeneratedOccupation;

/**
 * Record representing a learner object scoped to a specific course. Contains only
 * course-scoped attributes; user-level attributes are returned by attributesByUserId.
 */
export type LearnerObject_CourseScopedLearnerObject = {
  __typename?: 'LearnerObject_CourseScopedLearnerObject';
  /** Course id this learner object is scoped to. */
  courseId: Scalars['ID'];
  /** External identifier for the learner. */
  externalId?: Maybe<Scalars['ID']>;
  /**
   * ML inferred prediction of how likely this learner is to disengage in the
   * course this learner object is scoped to.
   */
  inferredLearnerAtRiskCoursePrediction?: Maybe<LearnerObject_InferredLearnerAtRiskCoursePrediction>;
  /** User id of the learner. */
  userId: Scalars['ID'];
};

/** A single saved Collection entry. */
export type LearnerObject_CourseraPlusCollection = {
  __typename?: 'LearnerObject_CourseraPlusCollection';
  /** The type of action that was taken on this Collection (see enum definition). */
  action: LearnerObject_CourseraPlusCollectionActionType;
  /** The additional input required for fetching the Collection; the same as `Recommendations.queryCollection`'s `additionalInput`. */
  additionalInput?: Maybe<Scalars['JSON']>;
  /** The Collection's recommender ID; the same as `Recommendations.queryCollection`'s `id`. */
  id: Scalars['ID'];
  /** Timestamp when the Collection was saved (ISO 8601 format). */
  savedAt: Scalars['DateTime'];
  /** The Coursera Plus subscription tied to the Collection-save. */
  subscriptionId: Scalars['ID'];
};

/** The type of action that a user took on a CourseraPlusCollection. */
export const LearnerObject_CourseraPlusCollectionActionType = {
  /** Coursera Plus Collection action type indicating a learner's Collection-save drove a Coursera Plus checkout. */
  CheckoutSave: 'CHECKOUT_SAVE',
  /** Coursera Plus Collection action type indicating an existing Plus subscriber saved a Collection. */
  Save: 'SAVE'
} as const;

export type LearnerObject_CourseraPlusCollectionActionType = typeof LearnerObject_CourseraPlusCollectionActionType[keyof typeof LearnerObject_CourseraPlusCollectionActionType];
/** Information about learner's current occupation. */
export type LearnerObject_CurrentOccupation = {
  __typename?: 'LearnerObject_CurrentOccupation';
  /** The occupation name or identifier. */
  occupation?: Maybe<Scalars['String']>;
  /** Whether the occupation was from a defined taxonomy or user-generated. */
  occupationInputType?: Maybe<LearnerObject_OccupationInputType>;
};

/** Input type for current occupation. */
export type LearnerObject_CurrentOccupationInput = {
  /** The occupation name or identifier. */
  occupation?: InputMaybe<Scalars['String']>;
  /** Whether the occupation was from a defined taxonomy or user-generated. */
  occupationInputType?: InputMaybe<LearnerObject_OccupationInputType>;
};

/** Result type for deleteLearningGoal mutation. */
export type LearnerObject_DeleteLearningGoalResult = LearnerObject_DeleteLearningGoalResultError | LearnerObject_DeleteLearningGoalResultSuccess;

/** Error result for deleteLearningGoal mutation. */
export type LearnerObject_DeleteLearningGoalResultError = Error & {
  __typename?: 'LearnerObject_DeleteLearningGoalResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for deleteLearningGoal mutation. */
export type LearnerObject_DeleteLearningGoalResultSuccess = {
  __typename?: 'LearnerObject_DeleteLearningGoalResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Standardized list of options for education levels. */
export const LearnerObject_EducationLevel = {
  /** Associate degree. */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree. */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Some college but no degree. */
  CollegeNoDegree: 'COLLEGE_NO_DEGREE',
  /** Doctorate degree (Ph.D.). */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High school diploma or equivalent. */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Less than high school diploma. */
  LessThanHighSchoolDiploma: 'LESS_THAN_HIGH_SCHOOL_DIPLOMA',
  /** Master's degree. */
  MastersDegree: 'MASTERS_DEGREE',
  /** Professional degree (e.g., JD, MD). */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type LearnerObject_EducationLevel = typeof LearnerObject_EducationLevel[keyof typeof LearnerObject_EducationLevel];
/** Information about learner's education background. */
export type LearnerObject_EducationProfile = {
  __typename?: 'LearnerObject_EducationProfile';
  /** Learner's education level. */
  educationLevel?: Maybe<LearnerObject_EducationLevel>;
};

/** Input type for education profile. */
export type LearnerObject_EducationProfileInput = {
  /** Learner's education level. */
  educationLevel?: InputMaybe<LearnerObject_EducationLevel>;
};

/** Metadata about how an attribute was inferred. */
export type LearnerObject_InferenceMetadata = {
  __typename?: 'LearnerObject_InferenceMetadata';
  /** Confidence score between 0.0 and 1.0. */
  confidenceScore: Scalars['Float'];
  /** Timestamp when the inference was made (ISO 8601 format). */
  inferredAt: Scalars['DateTime'];
  /** The method used to infer this attribute. */
  method: LearnerObject_InferenceMethod;
};

/** Enum for tracking the method used to infer an attribute. */
export const LearnerObject_InferenceMethod = {
  /** Inferred via Coach Memory system. */
  CoachMemory: 'COACH_MEMORY',
  /** Inferred via ML model. */
  MlInferred: 'ML_INFERRED'
} as const;

export type LearnerObject_InferenceMethod = typeof LearnerObject_InferenceMethod[keyof typeof LearnerObject_InferenceMethod];
/** Individual inferred career/occupation item with per-item inference metadata. */
export type LearnerObject_InferredCareerItem = {
  __typename?: 'LearnerObject_InferredCareerItem';
  /** Inference metadata for this specific career. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The occupation identifier. */
  occupationId: Scalars['ID'];
};

/** Inferred current occupation with inference metadata. */
export type LearnerObject_InferredCurrentOccupation = {
  __typename?: 'LearnerObject_InferredCurrentOccupation';
  /** Inference metadata (confidence, method, timestamp). */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The inferred current occupation value. */
  value: LearnerObject_CurrentOccupation;
};

/** Inferred degree interest with inference metadata. */
export type LearnerObject_InferredDegreeInterest = {
  __typename?: 'LearnerObject_InferredDegreeInterest';
  /** Inference metadata (confidence, method, timestamp). */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** Whether the learner is interested in a degree. */
  value: Scalars['Boolean'];
};

/** Individual inferred domain item with per-item inference metadata. */
export type LearnerObject_InferredDomainItem = {
  __typename?: 'LearnerObject_InferredDomainItem';
  /** The resolved domain entity. */
  domain: Domain_Domain;
  /** Inference metadata for this specific domain. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
};

/** Inferred education profile with inference metadata. */
export type LearnerObject_InferredEducationProfile = {
  __typename?: 'LearnerObject_InferredEducationProfile';
  /** Inference metadata (confidence, method, timestamp). */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The inferred education profile value. */
  value: LearnerObject_EducationProfile;
};

/** Inferred careers with per-item confidence scores. */
export type LearnerObject_InferredInterestedCareers = {
  __typename?: 'LearnerObject_InferredInterestedCareers';
  /** List of inferred careers/occupations with individual confidence metadata. */
  careers: Array<LearnerObject_InferredCareerItem>;
  /** List of user-generated occupations that could not be normalized to taxonomy values. */
  userGeneratedOccupations: Array<LearnerObject_UserGeneratedInferredCareerItem>;
};

/** Inferred interested domains with per-item confidence scores. */
export type LearnerObject_InferredInterestedDomains = {
  __typename?: 'LearnerObject_InferredInterestedDomains';
  /** List of inferred domains with individual confidence metadata. */
  domains: Array<LearnerObject_InferredDomainItem>;
};

/**
 * Represents the at-risk classification tiers based on the at-risk probability
 * that a learner likely is to disengage in a course. Most callers should use
 * this for personalization.
 */
export const LearnerObject_InferredLearnerAtRiskClassification = {
  /** Highest at-risk tier; learner is most likely to disengage. */
  Critical: 'CRITICAL',
  /** High at-risk tier. */
  High: 'HIGH',
  /** Low at-risk tier; learner is least likely to disengage. */
  Low: 'LOW',
  /** Medium at-risk tier. */
  Medium: 'MEDIUM'
} as const;

export type LearnerObject_InferredLearnerAtRiskClassification = typeof LearnerObject_InferredLearnerAtRiskClassification[keyof typeof LearnerObject_InferredLearnerAtRiskClassification];
/**
 * Representing the ML inferred likelihood that a learner is going to
 * disengage in a course. Inferences are only conducted for active learners.
 * Callers should check the inference date being from the last day before
 * using this for personalization.
 */
export type LearnerObject_InferredLearnerAtRiskCoursePrediction = {
  __typename?: 'LearnerObject_InferredLearnerAtRiskCoursePrediction';
  /**
   * The probability that a learner is likely to disengage, in the inclusive
   * range [0.0, 1.0].
   */
  atRiskProbability: Scalars['Float'];
  /**
   * Classification using the at-risk probability into tiers of becoming
   * at-risk (CRITICAL, HIGH, MEDIUM, LOW). Most callers should use this.
   */
  classification: LearnerObject_InferredLearnerAtRiskClassification;
  /** Course ID that this inference is for. */
  courseId: Scalars['ID'];
  /** Inference metadata (confidence, method, timestamp). */
  inferenceMetadata: LearnerObject_InferenceMetadata;
};

/** Inferred learning goal along with inference metadata. */
export type LearnerObject_InferredLearningGoal = {
  __typename?: 'LearnerObject_InferredLearningGoal';
  /** Inference metadata (confidence, method, timestamp). */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The inferred learning goal value. */
  value: LearnerObject_LearningGoal;
};

/** Individual inferred role item with per-item inference metadata. */
export type LearnerObject_InferredRoleItem = {
  __typename?: 'LearnerObject_InferredRoleItem';
  /** Inference metadata for this specific role. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The role identifier. */
  roleId: Scalars['ID'];
};

/** Inferred roles with per-item confidence scores. */
export type LearnerObject_InferredRoles = {
  __typename?: 'LearnerObject_InferredRoles';
  /** List of inferred roles with individual confidence scores. */
  roles: Array<LearnerObject_InferredRoleItem>;
};

/** Individual inferred skill item with per-item inference metadata. */
export type LearnerObject_InferredSkillItem = {
  __typename?: 'LearnerObject_InferredSkillItem';
  /** Inference metadata for this specific skill. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The resolved skill entity. */
  skill: Skill_Skill;
};

/** Inferred skills with per-item confidence scores. */
export type LearnerObject_InferredSkillsWantedV2 = {
  __typename?: 'LearnerObject_InferredSkillsWantedV2';
  /** List of inferred skills with individual confidence metadata. */
  skills: Array<LearnerObject_InferredSkillItem>;
  /** List of user-generated skills that could not be normalized to taxonomy values. */
  userGeneratedSkills: Array<LearnerObject_UserGeneratedInferredSkillItem>;
};

/** User's interested careers. */
export type LearnerObject_InterestedCareers = {
  __typename?: 'LearnerObject_InterestedCareers';
  /** List of user interested careers, either in form of occupation entities or user input strings. */
  careers: Array<LearnerObject_Career>;
};

/** Input type for interested careers. */
export type LearnerObject_InterestedCareersInput = {
  /** Occupations selected from predefined list. */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** User-generated occupations entered as free-form text. */
  userGeneratedOccupations?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * ML-derived learner guidance segment.
 *
 * mlScore is the raw model output stored in DynamoDB; label is the server-derived
 * value resolved by mapping mlScore into the threshold ranges declared in the
 * attribute's TACO derivationConfig (e.g. score < 0.55 -> "LOW",
 * score >= 0.55 -> "HIGH"). label is read-only.
 */
export type LearnerObject_LearnerGuidanceSegment = {
  __typename?: 'LearnerObject_LearnerGuidanceSegment';
  /** Server-derived label from the attribute's TACO derivationConfig. Read-only. */
  label: Scalars['String'];
  /** Raw ML score in the inclusive range [0.0, 1.0]. */
  mlScore: Scalars['Float'];
};

/** Record representing a learner object containing learner profile and preferences. */
export type LearnerObject_LearnerObject = {
  __typename?: 'LearnerObject_LearnerObject';
  /** User's birthday. */
  birthday?: Maybe<LearnerObject_Birthday>;
  /** User's current occupation. */
  currentOccupation?: Maybe<LearnerObject_CurrentOccupation>;
  /** User education profile. */
  educationProfile?: Maybe<LearnerObject_EducationProfile>;
  /** External identifier for the learner. */
  externalId?: Maybe<Scalars['ID']>;
  /** User's full name. */
  fullName?: Maybe<Scalars['String']>;
  /** Inferred current occupation with confidence metadata. */
  inferredCurrentOccupation?: Maybe<LearnerObject_InferredCurrentOccupation>;
  /** Inferred degree interest with confidence metadata. */
  inferredDegreeInterest?: Maybe<LearnerObject_InferredDegreeInterest>;
  /** Inferred education profile with confidence metadata. */
  inferredEducationProfile?: Maybe<LearnerObject_InferredEducationProfile>;
  /** Inferred careers with per-item confidence metadata. */
  inferredInterestedCareers?: Maybe<LearnerObject_InferredInterestedCareers>;
  /** Inferred domains with per-item confidence metadata. */
  inferredInterestedDomains?: Maybe<LearnerObject_InferredInterestedDomains>;
  /** Inferred learning goal with confidence metadata. */
  inferredLearningGoal?: Maybe<LearnerObject_InferredLearningGoal>;
  /** Inferred roles with per-item confidence scores. */
  inferredRoles?: Maybe<LearnerObject_InferredRoles>;
  /** Inferred skills with per-item confidence metadata. */
  inferredSkillsWantedV2?: Maybe<LearnerObject_InferredSkillsWantedV2>;
  /** User's interested careers. */
  interestedCareers?: Maybe<LearnerObject_InterestedCareers>;
  /** Timestamp when user last indicated they were unsure about their roles (ISO 8601 format). */
  lastIndicatedUnsureRolesAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp when user last indicated they were unsure about their skills (ISO 8601 format). */
  lastIndicatedUnsureSkillsAt?: Maybe<Scalars['DateTime']>;
  /**
   * ML-derived learner guidance segment. mlScore is the raw model output that is
   * stored; label is server-derived at read time from the attribute's TACO
   * derivationConfig thresholds.
   */
  learnerGuidanceSegment?: Maybe<LearnerObject_LearnerGuidanceSegment>;
  /** User learning goal. */
  learningGoal?: Maybe<LearnerObject_LearningGoal>;
  /** User's preferred locale (BCP 47 language tag). */
  locale?: Maybe<Scalars['String']>;
  /** User's location. */
  location?: Maybe<LearnerObject_Location>;
  /** Learner's most recently completed course */
  mostRecentCourseCompletion?: Maybe<LearnerObject_MostRecentCourseCompletion>;
  /** User's saved Collections. */
  savedCollections?: Maybe<LearnerObject_SavedCollections>;
  /** User's interested skills. */
  skillsWantedV2?: Maybe<LearnerObject_SkillsWantedV2>;
  /** User's timezone (IANA timezone identifier). */
  timezone?: Maybe<Scalars['String']>;
  /** User id of the learner. */
  userId: Scalars['ID'];
};

/** Standardized list of options for learning goals. */
export const LearnerObject_LearningGoal = {
  /** Goal is to change career. */
  ChangeCareer: 'CHANGE_CAREER',
  /** Goal is to improve existing skills. */
  ImproveSkills: 'IMPROVE_SKILLS',
  /** Goal is to land a new job. */
  LandNewJob: 'LAND_NEW_JOB',
  /** Goal is personal interest/hobby. */
  PersonalInterest: 'PERSONAL_INTEREST'
} as const;

export type LearnerObject_LearningGoal = typeof LearnerObject_LearningGoal[keyof typeof LearnerObject_LearningGoal];
/** User's location with geographical details. */
export type LearnerObject_Location = {
  __typename?: 'LearnerObject_Location';
  /** City name. */
  city?: Maybe<Scalars['String']>;
  /** Country name. */
  country?: Maybe<Scalars['String']>;
  /** Free-form location text entered by the user (e.g. "Coffee shop on Mission St"). */
  freeform?: Maybe<Scalars['String']>;
  /** Latitude in decimal degrees. */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude in decimal degrees. */
  longitude?: Maybe<Scalars['Float']>;
  /** State, province, or region. */
  state?: Maybe<Scalars['String']>;
};

/** Input type for location. */
export type LearnerObject_LocationInput = {
  /** City name. */
  city?: InputMaybe<Scalars['String']>;
  /** Country name. */
  country?: InputMaybe<Scalars['String']>;
  /** Free-form location text entered by the user (e.g. "Coffee shop on Mission St"). */
  freeform?: InputMaybe<Scalars['String']>;
  /** Latitude in decimal degrees. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude in decimal degrees. */
  longitude?: InputMaybe<Scalars['Float']>;
  /** State, province, or region. */
  state?: InputMaybe<Scalars['String']>;
};

/** Learners most recently completed course */
export type LearnerObject_MostRecentCourseCompletion = {
  __typename?: 'LearnerObject_MostRecentCourseCompletion';
  /** time at which the course was completed */
  completedAt: Scalars['DateTime'];
  /** most recent completed course */
  course: Course_Course;
};

/** Input type for most recent course completion. */
export type LearnerObject_MostRecentCourseCompletionInput = {
  /** Time at which the course was completed (ISO 8601 format). */
  completedAt: Scalars['DateTime'];
  /** ID of the most recently completed course. */
  courseId: Scalars['ID'];
};

/** An occupation which is mapped to occupation taxonomy */
export type LearnerObject_OccupationId = {
  __typename?: 'LearnerObject_OccupationId';
  /** The id of the occupation */
  id: Scalars['ID'];
};

/** List covering whether the user's occupation was from defined taxonomy or user generated. */
export const LearnerObject_OccupationInputType = {
  /** Occupation selected from predefined taxonomy. */
  Defined: 'DEFINED',
  /** Occupation entered as free-form text by user. */
  UserGenerated: 'USER_GENERATED'
} as const;

export type LearnerObject_OccupationInputType = typeof LearnerObject_OccupationInputType[keyof typeof LearnerObject_OccupationInputType];
/** User's saved Collections. */
export type LearnerObject_SavedCollections = {
  __typename?: 'LearnerObject_SavedCollections';
  /** List of saved Collection entries. */
  collections: Array<LearnerObject_CourseraPlusCollection>;
};

/** Union type of the two skill types used in learner object */
export type LearnerObject_Skill = LearnerObject_UserGeneratedSkill | Skill_Skill;

/** User's interested skills collected during onboarding. */
export type LearnerObject_SkillsWantedV2 = {
  __typename?: 'LearnerObject_SkillsWantedV2';
  /** List of user interested skills, either in form of skill entities or user input strings. */
  skills: Array<LearnerObject_Skill>;
};

/** Input type for skills wanted. */
export type LearnerObject_SkillsWantedV2Input = {
  /** User-generated skills entered as free-form text. */
  userGeneratedSkills?: InputMaybe<Array<Scalars['String']>>;
  /** Skills selected from predefined list of skill IDs. */
  userInterestSkillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Input for updating birthday. */
export type LearnerObject_UpdateBirthdayInput = {
  /** The new birthday value. */
  birthday: LearnerObject_BirthdayInput;
};

/** Result type for updateBirthday mutation. */
export type LearnerObject_UpdateBirthdayResult = LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateBirthdayResultSuccess;

/** Error result for updateBirthday mutation. */
export type LearnerObject_UpdateBirthdayResultError = Error & {
  __typename?: 'LearnerObject_UpdateBirthdayResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateBirthday mutation. */
export type LearnerObject_UpdateBirthdayResultSuccess = {
  __typename?: 'LearnerObject_UpdateBirthdayResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating current occupation. */
export type LearnerObject_UpdateCurrentOccupationInput = {
  /** The new current occupation value. */
  currentOccupation: LearnerObject_CurrentOccupationInput;
};

/** Result type for updateCurrentOccupation mutation. */
export type LearnerObject_UpdateCurrentOccupationResult = LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateCurrentOccupationResultSuccess;

/** Error result for updateCurrentOccupation mutation. */
export type LearnerObject_UpdateCurrentOccupationResultError = Error & {
  __typename?: 'LearnerObject_UpdateCurrentOccupationResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateCurrentOccupation mutation. */
export type LearnerObject_UpdateCurrentOccupationResultSuccess = {
  __typename?: 'LearnerObject_UpdateCurrentOccupationResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating education profile. */
export type LearnerObject_UpdateEducationProfileInput = {
  /** The new education profile value. */
  educationProfile: LearnerObject_EducationProfileInput;
};

/** Result type for updateEducationProfile mutation. */
export type LearnerObject_UpdateEducationProfileResult = LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateEducationProfileResultSuccess;

/** Error result for updateEducationProfile mutation. */
export type LearnerObject_UpdateEducationProfileResultError = Error & {
  __typename?: 'LearnerObject_UpdateEducationProfileResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateEducationProfile mutation. */
export type LearnerObject_UpdateEducationProfileResultSuccess = {
  __typename?: 'LearnerObject_UpdateEducationProfileResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating full name. */
export type LearnerObject_UpdateFullNameInput = {
  /** The new full name value. */
  fullName: Scalars['String'];
};

/** Result type for updateFullName mutation. */
export type LearnerObject_UpdateFullNameResult = LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateFullNameResultSuccess;

/** Error result for updateFullName mutation. */
export type LearnerObject_UpdateFullNameResultError = Error & {
  __typename?: 'LearnerObject_UpdateFullNameResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateFullName mutation. */
export type LearnerObject_UpdateFullNameResultSuccess = {
  __typename?: 'LearnerObject_UpdateFullNameResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating interested careers. */
export type LearnerObject_UpdateInterestedCareersInput = {
  /** The new interested careers value. */
  interestedCareers: LearnerObject_InterestedCareersInput;
};

/** Result type for updateInterestedCareers mutation. */
export type LearnerObject_UpdateInterestedCareersResult = LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateInterestedCareersResultSuccess;

/** Error result for updateInterestedCareers mutation. */
export type LearnerObject_UpdateInterestedCareersResultError = Error & {
  __typename?: 'LearnerObject_UpdateInterestedCareersResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateInterestedCareers mutation. */
export type LearnerObject_UpdateInterestedCareersResultSuccess = {
  __typename?: 'LearnerObject_UpdateInterestedCareersResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating last indicated unsure roles timestamp. */
export type LearnerObject_UpdateLastIndicatedUnsureRolesAtInput = {
  /** The timestamp when the user indicated they were unsure about their roles (ISO 8601 format). */
  lastIndicatedUnsureRolesAt: Scalars['DateTime'];
};

/** Result type for updateLastIndicatedUnsureRolesAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureRolesAtResult = LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultSuccess;

/** Error result for updateLastIndicatedUnsureRolesAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError = Error & {
  __typename?: 'LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateLastIndicatedUnsureRolesAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureRolesAtResultSuccess = {
  __typename?: 'LearnerObject_UpdateLastIndicatedUnsureRolesAtResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating last indicated unsure skills timestamp. */
export type LearnerObject_UpdateLastIndicatedUnsureSkillsAtInput = {
  /** The timestamp when the user indicated they were unsure about their skills (ISO 8601 format). */
  lastIndicatedUnsureSkillsAt: Scalars['DateTime'];
};

/** Result type for updateLastIndicatedUnsureSkillsAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureSkillsAtResult = LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultSuccess;

/** Error result for updateLastIndicatedUnsureSkillsAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError = Error & {
  __typename?: 'LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateLastIndicatedUnsureSkillsAt mutation. */
export type LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultSuccess = {
  __typename?: 'LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating learning goal. */
export type LearnerObject_UpdateLearningGoalInput = {
  /** The new learning goal value. */
  learningGoal: LearnerObject_LearningGoal;
};

/** Result type for updateLearningGoal mutation. */
export type LearnerObject_UpdateLearningGoalResult = LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLearningGoalResultSuccess;

/** Error result for updateLearningGoal mutation. */
export type LearnerObject_UpdateLearningGoalResultError = Error & {
  __typename?: 'LearnerObject_UpdateLearningGoalResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateLearningGoal mutation. */
export type LearnerObject_UpdateLearningGoalResultSuccess = {
  __typename?: 'LearnerObject_UpdateLearningGoalResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating locale. */
export type LearnerObject_UpdateLocaleInput = {
  /** The new locale value (BCP 47 language tag). */
  locale: Scalars['String'];
};

/** Result type for updateLocale mutation. */
export type LearnerObject_UpdateLocaleResult = LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocaleResultSuccess;

/** Error result for updateLocale mutation. */
export type LearnerObject_UpdateLocaleResultError = Error & {
  __typename?: 'LearnerObject_UpdateLocaleResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateLocale mutation. */
export type LearnerObject_UpdateLocaleResultSuccess = {
  __typename?: 'LearnerObject_UpdateLocaleResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating location. */
export type LearnerObject_UpdateLocationInput = {
  /** The new location value. */
  location: LearnerObject_LocationInput;
};

/** Result type for updateLocation mutation. */
export type LearnerObject_UpdateLocationResult = LearnerObject_UpdateLocationResultError | LearnerObject_UpdateLocationResultSuccess;

/** Error result for updateLocation mutation. */
export type LearnerObject_UpdateLocationResultError = Error & {
  __typename?: 'LearnerObject_UpdateLocationResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateLocation mutation. */
export type LearnerObject_UpdateLocationResultSuccess = {
  __typename?: 'LearnerObject_UpdateLocationResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating most recent course completion. */
export type LearnerObject_UpdateMostRecentCourseCompletionInput = {
  /** The most recent completed course details. */
  mostRecentCourseCompletion: LearnerObject_MostRecentCourseCompletionInput;
};

/** Result type for updateMostRecentCourseCompletion mutation. */
export type LearnerObject_UpdateMostRecentCourseCompletionResult = LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateMostRecentCourseCompletionResultSuccess;

/** Error result for updateMostRecentCourseCompletion mutation. */
export type LearnerObject_UpdateMostRecentCourseCompletionResultError = Error & {
  __typename?: 'LearnerObject_UpdateMostRecentCourseCompletionResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateMostRecentCourseCompletion mutation. */
export type LearnerObject_UpdateMostRecentCourseCompletionResultSuccess = {
  __typename?: 'LearnerObject_UpdateMostRecentCourseCompletionResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating skills wanted. */
export type LearnerObject_UpdateSkillsWantedV2Input = {
  /** The new skills wanted value. */
  skillsWantedV2: LearnerObject_SkillsWantedV2Input;
};

/** Result type for updateSkillsWantedV2 mutation. */
export type LearnerObject_UpdateSkillsWantedV2Result = LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateSkillsWantedV2ResultSuccess;

/** Error result for updateSkillsWantedV2 mutation. */
export type LearnerObject_UpdateSkillsWantedV2ResultError = Error & {
  __typename?: 'LearnerObject_UpdateSkillsWantedV2ResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateSkillsWantedV2 mutation. */
export type LearnerObject_UpdateSkillsWantedV2ResultSuccess = {
  __typename?: 'LearnerObject_UpdateSkillsWantedV2ResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** Input for updating timezone. */
export type LearnerObject_UpdateTimezoneInput = {
  /** The new timezone value (IANA timezone identifier). */
  timezone: Scalars['String'];
};

/** Result type for updateTimezone mutation. */
export type LearnerObject_UpdateTimezoneResult = LearnerObject_UpdateTimezoneResultError | LearnerObject_UpdateTimezoneResultSuccess;

/** Error result for updateTimezone mutation. */
export type LearnerObject_UpdateTimezoneResultError = Error & {
  __typename?: 'LearnerObject_UpdateTimezoneResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for updateTimezone mutation. */
export type LearnerObject_UpdateTimezoneResultSuccess = {
  __typename?: 'LearnerObject_UpdateTimezoneResultSuccess';
  /** The updated learner object data. */
  learnerObject: LearnerObject_LearnerObject;
};

/** User-generated inferred career/occupation item with inference metadata, stored when normalization fails. */
export type LearnerObject_UserGeneratedInferredCareerItem = {
  __typename?: 'LearnerObject_UserGeneratedInferredCareerItem';
  /** Inference metadata for this specific career. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The raw occupation name as extracted (not normalized to taxonomy). */
  name: Scalars['String'];
};

/** User-generated inferred skill item with inference metadata, stored when normalization fails. */
export type LearnerObject_UserGeneratedInferredSkillItem = {
  __typename?: 'LearnerObject_UserGeneratedInferredSkillItem';
  /** Inference metadata for this specific skill. */
  inferenceMetadata: LearnerObject_InferenceMetadata;
  /** The raw skill name as extracted (not normalized to taxonomy). */
  name: Scalars['String'];
};

/** An occupation which is not mapped to occupation taxonomy and is free text user input */
export type LearnerObject_UserGeneratedOccupation = {
  __typename?: 'LearnerObject_UserGeneratedOccupation';
  /** The user inputted name for the occupation */
  name: Scalars['String'];
};

/** A skill which is not mapped to skills v2 taxonomy and is free text user input */
export type LearnerObject_UserGeneratedSkill = {
  __typename?: 'LearnerObject_UserGeneratedSkill';
  /** The user inputted name for the skill */
  name: Scalars['String'];
};

/** Learner onboarding queries definition */
export type LearnerOnboardingQueries = {
  __typename?: 'LearnerOnboardingQueries';
  /** Get the consumer onboarding module config for a given input context, returns onboarding module config based on input, and user eligibility. */
  getOnboardingModuleConfig?: Maybe<LearnerOnboarding_OnboardingModuleConfigResponse>;
  /** A query to retrieve metadata about current consumer user's onboarding status. */
  me: LearnerOnboarding_Data;
  /** Get all skills mapped to role for the role provided. */
  queryOccupationSkillsMapping: LearnerOnboarding_QueryOccupationSkillsMappingPaginatedResult;
  /** Get all related skills for a list of skills provided. */
  queryRelatedSkills: Array<LearnerOnboarding_Skill>;
  /**
   * A query to retrieve onboarding responses for a learner using it's userId. User has to be logged in. Returns empty
   * onboarding if the learner has no onboarding response.
   */
  queryResponse: LearnerOnboarding_LearnerOnboarding;
  /**
   * A query to retrieve onboarding responses for a learner using it's userId. User has to be logged in. Returns empty
   * if the learner has no onboarding response.
   * @deprecated Having userId as input for logged in request is not recommended.
   */
  queryResponseByUserId: LearnerOnboarding_LearnerOnboarding;
  /**
   * A query to retrieve roles so it can be populated in the dropdown widget for the learners to select. If input flag is
   * false, result will only include roles from business, tech, and data domain.
   * @deprecated we no longer need filtered roles.
   */
  queryRoles: Array<LearnerOnboarding_Role>;
};


/** Learner onboarding queries definition */
export type LearnerOnboardingQueriesGetOnboardingModuleConfigArgs = {
  input: LearnerOnboarding_OnboardingModuleConfigInput;
};


/** Learner onboarding queries definition */
export type LearnerOnboardingQueriesQueryOccupationSkillsMappingArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  occupationId?: InputMaybe<Scalars['ID']>;
};


/** Learner onboarding queries definition */
export type LearnerOnboardingQueriesQueryRelatedSkillsArgs = {
  programId?: InputMaybe<Scalars['ID']>;
  skillIds: Array<Scalars['ID']>;
};


/** Learner onboarding queries definition */
export type LearnerOnboardingQueriesQueryResponseByUserIdArgs = {
  userId: Scalars['ID'];
};


/** Learner onboarding queries definition */
export type LearnerOnboardingQueriesQueryRolesArgs = {
  includeAll?: InputMaybe<Scalars['Boolean']>;
};

/** Add a new skill that the learner is interest in to the learner onboarding response */
export type LearnerOnboarding_AddSkillInput = {
  /** Id of the skill to save in the onboarding response of the learner. */
  skillId: Scalars['ID'];
  /** Name of the skill. */
  skillName: Scalars['String'];
  /** User ID of the learner. */
  userId: Scalars['ID'];
};

/** Result of the mutation of adding skill. */
export type LearnerOnboarding_AddSkillResult = {
  __typename?: 'LearnerOnboarding_AddSkillResult';
  /** Onboarding response of the learner. */
  learnerOnboarding: LearnerOnboarding_LearnerOnboarding;
};

/** Data about a learner's onboarding */
export type LearnerOnboarding_Data = {
  __typename?: 'LearnerOnboarding_Data';
  /** Whether learner has viewed an onboarding modal */
  hasSeenOnboarding: Scalars['Boolean'];
  /** The last time the learner viewed an onboarding modal */
  lastSeenOnboardingTime?: Maybe<Scalars['DateTime']>;
  /** The onboarding version that was last seen */
  onboardingVersion?: Maybe<Scalars['String']>;
};

/** Module type for standard onboarding flow with a sequence of questions. */
export type LearnerOnboarding_GenericModule = {
  __typename?: 'LearnerOnboarding_GenericModule';
  /** Ordered list of question types to present in the module. */
  questionPath?: Maybe<Array<LearnerOnboarding_ModularOnboardingQuestionType>>;
};

/** Goals of enterprise learner onboarding */
export const LearnerOnboarding_Goal = {
  /** Indicates learner wants to get new credentials or degree. */
  Credentials: 'CREDENTIALS',
  /** Indicates learner wants to explore. */
  Explore: 'EXPLORE',
  /** Indicates learner wants to grow in a role. */
  Grow: 'GROW',
  /** Indicates learner wants to land a job. */
  Land: 'LAND',
  /** Indicates learner wants to become a leader. */
  Leader: 'LEADER',
  /** Indicates learner wants to switch in to a new role. */
  Switch: 'SWITCH'
} as const;

export type LearnerOnboarding_Goal = typeof LearnerOnboarding_Goal[keyof typeof LearnerOnboarding_Goal];
/**
 * Module type for onboarding flow where a role has been inferred for the user.
 * e.g. we suggest what role they may be interested in based on what their recent search was
 */
export type LearnerOnboarding_InferredRoleModule = {
  __typename?: 'LearnerOnboarding_InferredRoleModule';
  /** This contains the inferred role */
  inferredRole?: Maybe<Skill_CareerRole>;
};

/** Onboarding response for a learner */
export type LearnerOnboarding_LearnerOnboarding = {
  __typename?: 'LearnerOnboarding_LearnerOnboarding';
  /** List of goal selected by learner. */
  goals?: Maybe<Array<LearnerOnboarding_Goal>>;
  /** User ID of the learner. */
  id: Scalars['ID'];
  /** Flag to indicate whether the learner has completed the onboarding */
  isCompleted: Scalars['Boolean'];
  /** Flag indicating if the learner has selected that they are unsure of role. */
  isUnsureOfRole: Scalars['Boolean'];
  /** Level selected by learner. */
  level?: Maybe<LearnerOnboarding_Level>;
  /** Occupation id of the role entered by leaner. */
  occupationId?: Maybe<Scalars['ID']>;
  /** List of skill ids that we retrieve from occupationId-to-skills mapping. */
  occupationSkills?: Maybe<Array<LearnerOnboarding_Skill>>;
  /**
   * Time to remind the learner to fill out the onboarding flow. This will be empty when either learner hasn't visited a
   * program home page or if the learner has completed the flow. Once flow is completed this field is ignored.
   */
  remindMeByTime?: Maybe<Scalars['DateTime']>;
  /** List of skills that learner have selected and is interested in. */
  skillsLearnerInterestedIn?: Maybe<Array<LearnerOnboarding_Skill>>;
  /** Time this response was created or updated. */
  updatedTime?: Maybe<Scalars['DateTime']>;
};

/** Level in enterprise learner onboarding */
export const LearnerOnboarding_Level = {
  /** Indicates learner has an advanced knowledge of the selected role. */
  Advanced: 'ADVANCED',
  /** Indicates learner has a beginner knowledge of the selected role. */
  Beginner: 'BEGINNER',
  /** Indicates learner has an expert knowledge of the selected role. */
  Expert: 'EXPERT',
  /** Indicates learner has an intermediate knowledge of the selected role. */
  Intermediate: 'INTERMEDIATE',
  /** Indicates learner has an mixed knowledge or is not sure of his level of the selected role. */
  Unsure: 'UNSURE'
} as const;

export type LearnerOnboarding_Level = typeof LearnerOnboarding_Level[keyof typeof LearnerOnboarding_Level];
/** Enum that defines all supported frontend entrypoints for modular onboarding. */
export const LearnerOnboarding_ModularOnboardingEntryPoint = {
  /** Entry point from the logged-in-home-page home tab. */
  LihpHome: 'LIHP_HOME',
  /** Entry point from the Role Description Page. */
  Rdp: 'RDP',
  /** Entry point from the search results page. */
  Search: 'SEARCH'
} as const;

export type LearnerOnboarding_ModularOnboardingEntryPoint = typeof LearnerOnboarding_ModularOnboardingEntryPoint[keyof typeof LearnerOnboarding_ModularOnboardingEntryPoint];
/** Enum that defines modular onboarding actions we want to store */
export const LearnerOnboarding_ModularOnboardingInteractionType = {
  /** Indicates user dismisses the onboarding module */
  Dismissal: 'DISMISSAL',
  /** Indicates user confirms inferred role */
  RoleConfirmation: 'ROLE_CONFIRMATION'
} as const;

export type LearnerOnboarding_ModularOnboardingInteractionType = typeof LearnerOnboarding_ModularOnboardingInteractionType[keyof typeof LearnerOnboarding_ModularOnboardingInteractionType];
/** Enum that defines all supported question types for modular onboarding. */
export const LearnerOnboarding_ModularOnboardingQuestionType = {
  /** Question about the user's learning goals and objectives. */
  LearningGoal: 'LEARNING_GOAL',
  /** Question about the user's desired roles. */
  Role: 'ROLE',
  /** Question about the user's desired skills. */
  Skill: 'SKILL'
} as const;

export type LearnerOnboarding_ModularOnboardingQuestionType = typeof LearnerOnboarding_ModularOnboardingQuestionType[keyof typeof LearnerOnboarding_ModularOnboardingQuestionType];
/** Union type representing different types of onboarding modules that can be displayed. */
export type LearnerOnboarding_OnboardingModule = LearnerOnboarding_GenericModule | LearnerOnboarding_InferredRoleModule;

/** Input needed to fetch modular onboarding config */
export type LearnerOnboarding_OnboardingModuleConfigInput = {
  /** The frontend entrypoint from which the onboarding module config is requested */
  entrypoint: LearnerOnboarding_ModularOnboardingEntryPoint;
  /** The career role id from the caller for cases where the client wants to provide an inferred role (e.g RDP) */
  inferredRoleId?: InputMaybe<Scalars['ID']>;
};

/** Response type for the onboarding module configuration query, containing display settings and module data. */
export type LearnerOnboarding_OnboardingModuleConfigResponse = {
  __typename?: 'LearnerOnboarding_OnboardingModuleConfigResponse';
  /** Should a module be displayed at all? */
  displayModule: Scalars['Boolean'];
  /** Specifies the module type and includes the data required to render it. */
  module?: Maybe<LearnerOnboarding_OnboardingModule>;
};

/** Paginated result type for LearnerOnboarding_queryOccupationSkillsMapping */
export type LearnerOnboarding_QueryOccupationSkillsMappingPaginatedResult = {
  __typename?: 'LearnerOnboarding_QueryOccupationSkillsMappingPaginatedResult';
  /** List of elements */
  elements: Array<LearnerOnboarding_Skill>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Removes a learner response from onboarding responses table identified by userId */
export type LearnerOnboarding_RemoveResponseInput = {
  /** User ID of the learner. */
  userId: Scalars['ID'];
};

/** Result of the mutation of removing learner response. */
export type LearnerOnboarding_RemoveResponseResult = {
  __typename?: 'LearnerOnboarding_RemoveResponseResult';
  /** True if deletion was successful, false otherwise. */
  success: Scalars['Boolean'];
};

/** Role present in a onboarding flow for a learner to select */
export type LearnerOnboarding_Role = {
  __typename?: 'LearnerOnboarding_Role';
  /** Id of the role. */
  id: Scalars['ID'];
  /** Name of the role. */
  name: Scalars['String'];
};

/** Set interaction result for the onboarding module */
export type LearnerOnboarding_SetModularOnboardingInteractionInput = {
  /** Modular onboarding actions, either dismiss onboarding or confirm inferred role */
  type: LearnerOnboarding_ModularOnboardingInteractionType;
};

/** Response for setting modular onboarding interaction */
export type LearnerOnboarding_SetModularOnboardingInteractionResult = {
  __typename?: 'LearnerOnboarding_SetModularOnboardingInteractionResult';
  /** True if interaction was updated, false if otherwise */
  success: Scalars['Boolean'];
};

/** Input for setting onboarding seen */
export type LearnerOnboarding_SetOnboardingSeenInput = {
  /** The onboarding version that was last seen */
  onboardingVersion: Scalars['String'];
};

/** Response for setting onboarding seen */
export type LearnerOnboarding_SetOnboardingSeenResult = {
  __typename?: 'LearnerOnboarding_SetOnboardingSeenResult';
  /** Placeholder field to maintain backward compatibility. */
  _?: Maybe<Scalars['Boolean']>;
  /** The onboarding version that was last seen */
  onboardingVersion?: Maybe<Scalars['String']>;
};

/** Skill representation in learner onboarding */
export type LearnerOnboarding_Skill = {
  __typename?: 'LearnerOnboarding_Skill';
  /** Id of the skill. */
  id: Scalars['ID'];
  /** Name of the skill. */
  name: Scalars['String'];
};

/** Set interested skill for a learner in onboarding responses table. */
export type LearnerOnboarding_UpdateInterestedSkillsInput = {
  /** Ids of the skill that learner is interested in. */
  ids: Array<Scalars['ID']>;
};

/** Result of the mutation of updating interested skills of a learner. */
export type LearnerOnboarding_UpdateInterestedSkillsResult = {
  __typename?: 'LearnerOnboarding_UpdateInterestedSkillsResult';
  /** Onboarding response of the learner. */
  learnerOnboarding: LearnerOnboarding_LearnerOnboarding;
};

/** Update the time to remind learner by in the learner onboarding response. */
export type LearnerOnboarding_UpdateRemindMeByTimeInput = {
  /**
   * Time to remind the learner to fill out the onboarding flow. This will be empty when either learner hasn't visited a
   * program home page or if the learner has completed the flow. Once flow is completed this field is ignored.
   */
  remindMeByTime: Scalars['DateTime'];
  /**
   * User ID of the learner.
   * @deprecated Having userId as input for logged in request is not recommended.
   */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Result of the mutation of updating remindMeByTime field. */
export type LearnerOnboarding_UpdateRemindMeByTimeResult = {
  __typename?: 'LearnerOnboarding_UpdateRemindMeByTimeResult';
  /** Onboarding response of the learner. */
  learnerOnboarding: LearnerOnboarding_LearnerOnboarding;
};

/** Update the role for a learner in onboarding responses table. */
export type LearnerOnboarding_UpdateRoleInput = {
  /** Occupation id of the role to be set. */
  occupationId: Scalars['ID'];
};

/** Result of the mutation of updating role. */
export type LearnerOnboarding_UpdateRoleResult = {
  __typename?: 'LearnerOnboarding_UpdateRoleResult';
  /** Onboarding response of the learner. */
  learnerOnboarding: LearnerOnboarding_LearnerOnboarding;
};

/** Queries for the learner created plan */
export type LearnerPlanQueries = {
  __typename?: 'LearnerPlanQueries';
  /** Query the plan for the learner */
  queryPlan?: Maybe<LearnerPlan_LearnerPlanResult>;
};


/** Queries for the learner created plan */
export type LearnerPlanQueriesQueryPlanArgs = {
  degreeId: Scalars['ID'];
};

/** Input for adding a term for plan */
export type LearnerPlan_AddTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** List of Segment CourseIds the learner planned for a term */
  plannedSegmentCourses?: InputMaybe<Array<Scalars['ID']>>;
  /** Specifies if the learner explicitly planned to skip the term */
  skipped: Scalars['Boolean'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** Result of learner Plan add term mutation */
export type LearnerPlan_AddTermResult = LearnerPlan_LearnerPlanResult | LearnerPlan_MutationFailure;

/** CourseAlreadyExistsError is returned when the course is already planned by the learner */
export type LearnerPlan_CourseAlreadyExistsError = Error & LearnerPlan_MutationError & {
  __typename?: 'LearnerPlan_CourseAlreadyExistsError';
  /** reason for the error */
  message: Scalars['String'];
};

/** Input for creating learner plan */
export type LearnerPlan_CreatePlanInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
};

/** Result for learner plan create plan mutation */
export type LearnerPlan_CreatePlanResult = LearnerPlan_LearnerPlanResult | LearnerPlan_MutationFailure;

/** Input for deleting learner plan */
export type LearnerPlan_DeletePlanInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
};

/** Result of delete learner Plan plan mutation */
export type LearnerPlan_DeletePlanResult = LearnerPlan_DeletePlanSuccess | LearnerPlan_MutationFailure;

/** Result of a successful delete plan operation */
export type LearnerPlan_DeletePlanSuccess = {
  __typename?: 'LearnerPlan_DeletePlanSuccess';
  /** A placeholder field, because graphQl doesn't allow empty type definitions */
  success?: Maybe<Scalars['Boolean']>;
};

/** Result of learner Plan remove term mutation */
export type LearnerPlan_LearnerPlanResult = {
  __typename?: 'LearnerPlan_LearnerPlanResult';
  /** Learner plan sorted based on term start date */
  learnerPlan?: Maybe<Array<LearnerPlan_TermPlan>>;
  /** version of the plan. */
  version: Scalars['Int'];
};

/** Detail input for moving courses from one term to another */
export type LearnerPlan_MoveCourseInput = {
  /** IDs of the courses to be moved */
  courseId: Scalars['ID'];
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** ID of the destination term to where the courses are to be moved */
  destinationTermId: Scalars['ID'];
  /** ID of the source term from where the courses are to be moved */
  sourceTermId: Scalars['ID'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** Result of learner Plan move courses mutation */
export type LearnerPlan_MoveCourseResult = LearnerPlan_LearnerPlanResult | LearnerPlan_MutationFailure;

/** domain specific error interface for learner plan mutations */
export type LearnerPlan_MutationError = {
  /** reason for the error */
  message: Scalars['String'];
};

/** Error encountered while performing mutation */
export type LearnerPlan_MutationFailure = {
  __typename?: 'LearnerPlan_MutationFailure';
  /** errors encountered */
  errors?: Maybe<Array<LeanerPlan_ValidationError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError>>;
};

/** The planned segment course for a learner. */
export type LearnerPlan_PlannedSegmentCourse = {
  __typename?: 'LearnerPlan_PlannedSegmentCourse';
  /**
   * courses with unknown availability
   * @deprecated we return availabilityUnconfirmed in personalizedSegmentCourse.segmentCourse object
   */
  availabilityUnconfirmed: Scalars['Boolean'];
  /** The course offerings have changed for the planned term */
  needsReplan: Scalars['Boolean'];
  /** PersonalizedSegmentCourse, part of the degree curriculum with a customized learner progress */
  personalizedSegmentCourse?: Maybe<DegreePlan_PersonalizedSegmentCourse>;
  /**
   * SegmentCourse, part of the degree curriculum
   * @deprecated segmentCourse is deprecated. Use personalizedSegmentCourse instead.
   */
  segmentCourse?: Maybe<DegreePlan_SegmentCourse>;
};

/** Input for removing term from the plan" */
export type LearnerPlan_RemoveTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** version of the plan to trigger remove on */
  version: Scalars['Int'];
};

/** Result of learner Plan remove term mutation */
export type LearnerPlan_RemoveTermResult = LearnerPlan_LearnerPlanResult | LearnerPlan_MutationFailure;

/** LearnerPlan for a given term */
export type LearnerPlan_TermPlan = DegreePlan_EstimatedTerm & {
  __typename?: 'LearnerPlan_TermPlan';
  /**
   * The term was autocorrected, courses were automatically added, or removed based on
   * learner's
   * enrollment, un-enrollment, or course failure.
   */
  autoCorrected: Scalars['Boolean'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** Name of the estimated term */
  estimatedTermName: Scalars['String'];
  /**
   * If the term exceeds the time Allowed to complete, usually for degree learners. Will be empty for
   * FCND
   * learners.
   */
  exceedsTimeAllowed: Scalars['Boolean'];
  /** Linked external Term, optional */
  linkedTerm?: Maybe<DegreePlan_AcademicTerm>;
  /** List of planned courses for the term */
  plannedSegmentCourses?: Maybe<Array<LearnerPlan_PlannedSegmentCourse>>;
  /** Learner Planned to skip the term */
  skipped: Scalars['Boolean'];
};

/** Input for updating a term for plan */
export type LearnerPlan_UpdateTermInput = {
  /** degreeId for the plan */
  degreeId: Scalars['ID'];
  /** Id of the estimated term */
  estimatedTermId: Scalars['ID'];
  /** List of Segment CourseIds the learner planned for a term */
  plannedSegmentCourses?: InputMaybe<Array<Scalars['ID']>>;
  /** Specifies if the learner explicitly planned to skip the term */
  skipped: Scalars['Boolean'];
  /** version of the plan to trigger update on. */
  version: Scalars['Int'];
};

/** Result of learner Plan update term mutation */
export type LearnerPlan_UpdateTermResult = LearnerPlan_LearnerPlanResult | LearnerPlan_MutationFailure;

/**
 * version conflict error is returned when the update/ remove is not triggered on the latest version of
 * the plan
 */
export type LearnerPlan_VersionConflictError = Error & LearnerPlan_MutationError & {
  __typename?: 'LearnerPlan_VersionConflictError';
  /** reason for the version conflict error */
  message: Scalars['String'];
};

/** LearnerProfile queries */
export type LearnerProfileQueries = {
  __typename?: 'LearnerProfileQueries';
  /** For the user to access their own profile. The user id will be taken out of the request context */
  me?: Maybe<LearnerProfile_Profile>;
  /**
   * For anyone to access another user's profile. They can query by the users external id.
   *
   * Some fields are hidden here depending on if the requesting user is a recruiter. See field level comments for more information.
   *
   * All fields except the name of the learner, external id and privacy toggles can be hidden if the privacy toggle
   * relevant to the requester is false. E.G.
   * - showToPublic = false and the requestor is not a recruiter. Only returns name, externalId and showToPublic
   * - includedInTalentPipeline = false and showToPublic = false and the requestor is a recruiter.
   * Only returns name, externalId, showToPublic, includedInTalentPipeline and recruitingOrganizationOfViewer
   */
  queryByExternalId?: Maybe<LearnerProfile_Profile>;
  /** For loading profile by the user customized slug */
  queryByProfileSlug?: Maybe<LearnerProfile_Profile>;
};


/** LearnerProfile queries */
export type LearnerProfileQueriesQueryByExternalIdArgs = {
  externalId: Scalars['ID'];
};


/** LearnerProfile queries */
export type LearnerProfileQueriesQueryByProfileSlugArgs = {
  profileSlug: Scalars['String'];
};

/** Fields for an artifact in the project */
export type LearnerProfile_Artifact = {
  __typename?: 'LearnerProfile_Artifact';
  /** The assignment link of the artifact item */
  assignmentLink?: Maybe<Scalars['URL']>;
  /** The assignment title of the artifact item */
  assignmentTitle?: Maybe<Scalars['String']>;
  /** The item id of the artifact */
  itemId?: Maybe<Scalars['ID']>;
  /** The link of the artifact item */
  link?: Maybe<Scalars['URL']>;
  /** The type of the artifact item entered by learner (eg. Github URL) */
  type?: Maybe<Scalars['String']>;
};

/** One of 'remove' (removes boolean) or 'boolean' to patch to new value */
export type LearnerProfile_BooleanOrRemoveInput = {
  /** Set if boolean field should be patched to new value */
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  /** Set if boolean field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Fields for challenge lab achievement, if applies */
export type LearnerProfile_ChallengeAchievement = {
  __typename?: 'LearnerProfile_ChallengeAchievement';
  /** The percentile of the learner in the challenge lab (i.e., "4.97" to indicate "top 5%") */
  percentile: Scalars['Float'];
  /**
   * The placement of the learner in the challenge lab (i.e., "1", "2" to indicate 1st, 2nd place respectively)
   * If no placement was recorded, this will be null
   */
  placement?: Maybe<Scalars['Int']>;
  /** The total number of participants in the challenge lab */
  totalNumberOfParticipants: Scalars['Int'];
};

/** The user's work eligibilities, keyed by country code. */
export type LearnerProfile_CountryWorkEligibilities = {
  __typename?: 'LearnerProfile_CountryWorkEligibilities';
  /** US work eligibility */
  US?: Maybe<LearnerProfile_UsWorkEligibility>;
};

/** Input for user's work eligibilities, keyed by country code. */
export type LearnerProfile_CountryWorkEligibilitiesInput = {
  /** US work eligibility */
  US?: InputMaybe<LearnerProfile_UsWorkEligibilityInput>;
};

/** One of 'remove' (removes countryWorkEligibilities) or countryWorkEligibilities to patch to new value */
export type LearnerProfile_CountryWorkEligibilitiesOrRemoveInput = {
  /** Set if countryWorkEligibilities should be patched to new value */
  countryWorkEligibilities?: InputMaybe<LearnerProfile_CountryWorkEligibilitiesInput>;
  /** Set if countryWorkEligibilities should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** A course the learner has completed */
export type LearnerProfile_Course = {
  __typename?: 'LearnerProfile_Course';
  /** The date the learner completed the course */
  completionDate: Scalars['DateTime'];
  /** The name of the course */
  name: Scalars['String'];
  /** The product id of the course */
  productId: Scalars['ID'];
  /** The skills gained from the course */
  skillNames: Array<Scalars['String']>;
  /** The verification code of course, used to generate links to the accomplishment page for the user */
  verifyCode: Scalars['String'];
};

/** A summary of the learner's activity on Coursera */
export type LearnerProfile_CourseraHistory = {
  __typename?: 'LearnerProfile_CourseraHistory';
  /** The list of courses the user has completed. Max returned is 9. */
  completedCourses: Array<LearnerProfile_Course>;
  /** The list of professional certs the user has completed on coursera. Max returned is 9. */
  completedProfessionalCertificates: Array<LearnerProfile_Specialization>;
  /** The list of specializations the user has completed. Max returned is 9. */
  completedSpecializations: Array<LearnerProfile_Specialization>;
  /** The date time the learner joined Coursera */
  joinDate?: Maybe<Scalars['DateTime']>;
  /** Learning stats of the learner */
  learningStats?: Maybe<LearnerProfile_LearningStats>;
};

/** One of 'remove' (removes desiredSkills) or 'desiredSkills' to patch to new value */
export type LearnerProfile_DesiredSkillsOrRemoveInput = {
  /** Set if 'desiredSkills' should be patched to new 'desiredSkills' value. A maximum of 50 skills is allowed. */
  desiredSkills?: InputMaybe<Array<LearnerProfile_SkillInput>>;
  /** Set if 'desiredSkills' should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** A set of configurations that help determine which UI components to show or hide. */
export type LearnerProfile_DisplaySettings = {
  __typename?: 'LearnerProfile_DisplaySettings';
  /** Whether or not we have active recruiters in this region */
  enableHiringSolutionsActivelyHiring: Scalars['Boolean'];
  /** Whether or not the learner is able to opt in to Coursera Hiring Solutions */
  enableHiringSolutionsOptInFlow: Scalars['Boolean'];
  /** Whether or not we should display preferred work locations */
  showPreferredWorkLocationFields: Scalars['Boolean'];
  /** Whether or not sensitive personal information can be displayed */
  showSensitivePersonalInfoFields: Scalars['Boolean'];
};

/** Domains we support */
export type LearnerProfile_Domain = Domain_Domain | LearnerProfile_OtherDomain;

/** Input for LearnerProfile_Domain. Accepts either a domain ID or an enum value for the other domain. */
export type LearnerProfile_DomainInput = {
  /** The id of the domain */
  id?: InputMaybe<Scalars['ID']>;
  /** The enum value of the other domain */
  otherDomain?: InputMaybe<LearnerProfile_OtherDomainEnum>;
};

/** Single entry in a learners education history */
export type LearnerProfile_EducationHistory = {
  __typename?: 'LearnerProfile_EducationHistory';
  /** The sub-area within the major e.g. computer science -> machine learning */
  areaOfConcentration?: Maybe<Scalars['String']>;
  /** Degree type for the course the user is studying */
  degreeType?: Maybe<LearnerProfile_EducationHistoryDegreeType>;
  /**
   * The user's grade at this institution.
   * This can be a GPA e.g., 3.0 or 3.0/4.0 or some free text e.g., "Summa Cum Laude"
   */
  grade?: Maybe<Scalars['String']>;
  /**
   * The grade point average the user achieved for this degree
   * Note: this will be deprecated as part of https://coursera.atlassian.net/browse/LPD-554
   */
  gradePointAverageX100?: Maybe<Scalars['Int']>;
  /** Graduation date of the learner. Can be in the future */
  graduationDate?: Maybe<LearnerProfile_YearMonthDate>;
  /** The name of the education institution the learner studied at */
  institutionName?: Maybe<Scalars['String']>;
  /** If the learner is currently studying at this institution */
  isCurrentlyAStudent?: Maybe<Scalars['Boolean']>;
  /** The field of study the learner is reading */
  major?: Maybe<LearnerProfile_EducationHistoryMajor>;
  /** The month & year the user started at the institution */
  startDate?: Maybe<LearnerProfile_YearMonthDate>;
};

/** Enum for degree type options for an education history item */
export const LearnerProfile_EducationHistoryDegreeType = {
  /** Associate's degree */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Doctorate degree */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High school diploma */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** No degree level qualification */
  NoDegree: 'NO_DEGREE',
  /** A professional school degree */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type LearnerProfile_EducationHistoryDegreeType = typeof LearnerProfile_EducationHistoryDegreeType[keyof typeof LearnerProfile_EducationHistoryDegreeType];
/** LearnerProfile Education History Input */
export type LearnerProfile_EducationHistoryInput = {
  /** Area of concentration for the education */
  areaOfConcentration?: InputMaybe<Scalars['String']>;
  /** Degree type for the course the user is studying */
  degreeType?: InputMaybe<LearnerProfile_EducationHistoryDegreeType>;
  /**
   * The user's grade at this institution.
   * This can be a GPA e.g., 3.0 or 3.0/4.0 or some free text e.g., "Summa Cum Laude"
   */
  grade?: InputMaybe<Scalars['String']>;
  /** Graduation date of the education */
  graduationDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
  /** Name of the institution */
  institutionName?: InputMaybe<Scalars['String']>;
  /** Set to true if learner is currently a student of the education history, false otherwise. */
  isCurrentlyAStudent?: InputMaybe<Scalars['Boolean']>;
  /** The field of study the learner is reading */
  major?: InputMaybe<LearnerProfile_EducationHistoryMajor>;
  /** Start date of the education */
  startDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** Enum for major of education */
export const LearnerProfile_EducationHistoryMajor = {
  /** Arts or humanities major */
  ArtsAndHumanities: 'ARTS_AND_HUMANITIES',
  /** Biology major */
  BiologicalSciences: 'BIOLOGICAL_SCIENCES',
  /** Business major */
  Business: 'BUSINESS',
  /** Computer Science major */
  ComputerScience: 'COMPUTER_SCIENCE',
  /** Education-related major */
  Education: 'EDUCATION',
  /** Engineering major of any type */
  Engineering: 'ENGINEERING',
  /** Any kind of doctor or health-related major */
  HealthProfessions: 'HEALTH_PROFESSIONS',
  /** Any kind of law or legal major */
  LegalProfessions: 'LEGAL_PROFESSIONS',
  /** Math and/or statistics major */
  MathematicsAndStatistics: 'MATHEMATICS_AND_STATISTICS',
  /** Not Applicable for some reason */
  Na: 'NA',
  /** Anything else that is not listed */
  Other: 'OTHER',
  /** Physics major */
  PhysicalSciences: 'PHYSICAL_SCIENCES',
  /** Any kind of social or behavioral sciences major */
  SocialSciences: 'SOCIAL_SCIENCES'
} as const;

export type LearnerProfile_EducationHistoryMajor = typeof LearnerProfile_EducationHistoryMajor[keyof typeof LearnerProfile_EducationHistoryMajor];
/** One of 'remove' (removes education history) or 'educationHistory' to patch to new value */
export type LearnerProfile_EducationHistoryOrRemoveInput = {
  /** Set if educationHistory should be patched to new educationHistory value */
  educationHistory?: InputMaybe<Array<LearnerProfile_EducationHistoryInput>>;
  /** Set if educationHistory should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** The users gender which is mapped to a static list of enums */
export type LearnerProfile_EnumGenderEntry = {
  __typename?: 'LearnerProfile_EnumGenderEntry';
  /** The selected gender enum */
  selectedEnum: LearnerProfile_GenderEnum;
};

/** One of 'remove' (removes ethnicities) or ethnicities to patch to new value */
export type LearnerProfile_EthnicitiesOrRemoveInput = {
  /** Set if ethnicities should be patched to new value */
  ethnicities?: InputMaybe<Array<LearnerProfile_Ethnicity>>;
  /** Set if ethnicities should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/**
 * Options for a Learner's Ethnicity/Ethnicities.
 * Used by the recruiting platform for DEI metrics.
 */
export const LearnerProfile_Ethnicity = {
  /** African American */
  AfricanAmerican: 'AFRICAN_AMERICAN',
  /** American Indian or Alaskan Native */
  AmericanIndian: 'AMERICAN_INDIAN',
  /** Asian */
  Asian: 'ASIAN',
  /** Hispanic or LatinX */
  Hispanic: 'HISPANIC',
  /** Native Hawaiian or Pacific Islander */
  NativeHawaiian: 'NATIVE_HAWAIIAN',
  /** Prefer not to answer */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** White */
  White: 'WHITE'
} as const;

export type LearnerProfile_Ethnicity = typeof LearnerProfile_Ethnicity[keyof typeof LearnerProfile_Ethnicity];
/** Mapping of external link types to links */
export type LearnerProfile_ExternalLinks = {
  __typename?: 'LearnerProfile_ExternalLinks';
  /** A non domain specific profile url */
  default?: Maybe<Scalars['URL']>;
  /** The learners facebook profile url */
  facebook?: Maybe<Scalars['URL']>;
  /** The learners github profile url */
  github?: Maybe<Scalars['URL']>;
  /** The learners linkedIn profile url */
  linkedin?: Maybe<Scalars['URL']>;
  /** The learners twitter profile url */
  twitter?: Maybe<Scalars['URL']>;
};

/** The LearnerProfile external links to patch */
export type LearnerProfile_ExternalLinksInput = {
  /**
   * Sets new default url if default url is not null.
   * If null, default url remains unchanged
   * If RemoveInput, removes default url
   */
  defaultLink?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new facebook url if facebook url is not null.
   * If null, facebook url remains unchanged
   * If RemoveInput, removes facebook url
   */
  facebook?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new github url if github url is not null.
   * If null, github url remains unchanged
   * If RemoveInput, removes github url
   */
  github?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new linkedin url if linkedin url is not null.
   * If null, linkedin url remains unchanged
   * If RemoveInput, removes linkedin url
   */
  linkedin?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
  /**
   * Sets new twitter url if twitter url is not null.
   * If null, twitter url remains unchanged
   * If RemoveInput, removes twitter url
   */
  twitter?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
};

/** One of 'remove' (removes float) or 'float' to patch to new value */
export type LearnerProfile_FloatOrRemoveInput = {
  /** Set if float field should be patched to new value */
  float?: InputMaybe<Scalars['Float']>;
  /** Set if float field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Enum for gender options available in the profile */
export const LearnerProfile_Gender = {
  /** Agender */
  Agender: 'AGENDER',
  /** Not listed */
  GenderNotListed: 'GENDER_NOT_LISTED',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Prefer not to say */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Transgender */
  Transgender: 'TRANSGENDER',
  /** Two sprit */
  TwoSpirit: 'TWO_SPIRIT',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type LearnerProfile_Gender = typeof LearnerProfile_Gender[keyof typeof LearnerProfile_Gender];
/** Enum for gender options available in the learner profile */
export const LearnerProfile_GenderEnum = {
  /** Agender */
  Agender: 'AGENDER',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Prefer not to say */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Transgender man */
  TransgenderMan: 'TRANSGENDER_MAN',
  /** Transgender woman */
  TransgenderWoman: 'TRANSGENDER_WOMAN',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type LearnerProfile_GenderEnum = typeof LearnerProfile_GenderEnum[keyof typeof LearnerProfile_GenderEnum];
/** A result from an IMocha skill assessment for an individual skill */
export type LearnerProfile_IndividualSkillAssessment = {
  __typename?: 'LearnerProfile_IndividualSkillAssessment';
  /** The proficiency of the user in the assessment */
  proficiency: LearnerProfile_SkillAssessmentProficiency;
  /** The percentage score the user got in the assessment */
  score: Scalars['Int'];
  /** The name of the skill assessed */
  skillName: Scalars['String'];
};

/** Union type of the two industry types */
export type LearnerProfile_Industry = LearnerProfile_IndustryId | LearnerProfile_UserGeneratedIndustry;

/** An industry which is mapped to ProfileOccupationChoices.V1 */
export type LearnerProfile_IndustryId = {
  __typename?: 'LearnerProfile_IndustryId';
  /** The id of the industry */
  id: Scalars['ID'];
};

/** Learner Profile Industry Input */
export type LearnerProfile_IndustryInput = {
  /** The id of the industry */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the industry */
  name?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes int) or 'int' to patch to new value */
export type LearnerProfile_IntOrRemoveInput = {
  /** Set if int field should be patched to new value */
  int?: InputMaybe<Scalars['Int']>;
  /** Set if int field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** One of 'remove' (removes desiredDomain) or 'desiredDomains' to patch to new value */
export type LearnerProfile_InterestedDomainsOrRemoveInput = {
  /** Set if 'desiredDomains' should be patched to new 'desiredDomains' value. A maximum of 11 domains are allowed. This matches the number of domains that exist today (7/23/2025). */
  desiredDomains?: InputMaybe<Array<LearnerProfile_DomainInput>>;
  /** Set if 'desiredDomains' should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Union type of the two learner profile gender types */
export type LearnerProfile_LearnerProfileGender = LearnerProfile_EnumGenderEntry | LearnerProfile_UserGenderEntry;

/** Learner Profile Gender Input */
export type LearnerProfile_LearnerProfileGenderInput = {
  /** The selected gender enum */
  selectedEnum?: InputMaybe<LearnerProfile_GenderEnum>;
  /** The custom self declared gender of the user */
  userGenderInput?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes learnerProfileGender) or 'learnerProfileGender' to patch to new value */
export type LearnerProfile_LearnerProfileGenderOrRemoveInput = {
  /** Set if learnerProfileGender should be patched to new value */
  learnerProfileGender?: InputMaybe<LearnerProfile_LearnerProfileGenderInput>;
  /** Set if learnerProfileGender should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Options for a User's Learning Goal */
export const LearnerProfile_LearningGoal = {
  /** Change career */
  ChangeCareer: 'CHANGE_CAREER',
  /** Improve skills */
  ImproveSkills: 'IMPROVE_SKILLS',
  /** Land a new job */
  LandNewJob: 'LAND_NEW_JOB',
  /** Personal interest */
  PersonalInterest: 'PERSONAL_INTEREST'
} as const;

export type LearnerProfile_LearningGoal = typeof LearnerProfile_LearningGoal[keyof typeof LearnerProfile_LearningGoal];
/** Captured information about users and learning programs */
export type LearnerProfile_LearningPrograms = {
  __typename?: 'LearnerProfile_LearningPrograms';
  /** Users captured learning goal */
  learningGoal?: Maybe<LearnerProfile_LearningGoal>;
};

/** Learning stats */
export type LearnerProfile_LearningStats = {
  __typename?: 'LearnerProfile_LearningStats';
  /** Number of completed courses. Set to 0 if the learner never completes any courses. */
  coursesCompleted: Scalars['Int'];
  /**
   * Number of completed professional certificates. Set to 0 if the learner never completes any
   * professional certificates.
   */
  professionalCertificatesCompleted: Scalars['Int'];
  /**
   * Number of completed programming assignments. Set to 0 if the learner never completes any
   * programming assignments.
   */
  programmingAssignmentsCompleted: Scalars['Int'];
  /** Number of completed specializations. Set to 0 if the learner never completes any specializations. */
  specializationsCompleted: Scalars['Int'];
  /** Total learning hours on Coursera. Set to 0 if the learner never starts learning. */
  totalLearningHours: Scalars['Int'];
};

/** Union type of the two occupation types */
export type LearnerProfile_Occupation = LearnerProfile_OccupationId | LearnerProfile_UserGeneratedOccupation;

/** An occupation which is mapped to ProfileOccupationChoices.V1 */
export type LearnerProfile_OccupationId = {
  __typename?: 'LearnerProfile_OccupationId';
  /** The id of the occupation */
  id: Scalars['ID'];
};

/** Learner Profile Occupation Input */
export type LearnerProfile_OccupationInput = {
  /** The id of the occupation. The id must be lower-kebab-case, and must be at most 100 characters long. */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the occupation. The name cannot be empty, cannot have special characters, and must be at most 100 characters long. */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * A mapping of occupation to experience level to track a users preferred occupation and preferred industry
 * indicating what roles they are looking for.
 */
export type LearnerProfile_OccupationPreference = {
  __typename?: 'LearnerProfile_OccupationPreference';
  /** The industry associated with the preference */
  industry?: Maybe<LearnerProfile_Industry>;
  /** The level of occupation the candidate is looking for */
  level?: Maybe<LearnerProfile_OccupationPreferenceLevel>;
  /** The occupation associated with the preference */
  occupation: LearnerProfile_Occupation;
};

/** Enum for the levels of experience the learner is looking for in their preferred role */
export const LearnerProfile_OccupationPreferenceLevel = {
  /** Senior manager level of occupation */
  Director: 'DIRECTOR',
  /** Executive level of occupation */
  ExecutiveManagement: 'EXECUTIVE_MANAGEMENT',
  /** Intern level of occupation */
  Intern: 'INTERN',
  /** Entry or Junior level of occupation */
  JuniorIndividualContributor: 'JUNIOR_INDIVIDUAL_CONTRIBUTOR',
  /** Lead level of occupation */
  ManagerialLeadershipRole: 'MANAGERIAL_LEADERSHIP_ROLE',
  /** Not applicable for the role they are looking for */
  NotApplicable: 'NOT_APPLICABLE',
  /** Senior Contributor level of occupation */
  SeniorIndividualContributor: 'SENIOR_INDIVIDUAL_CONTRIBUTOR'
} as const;

export type LearnerProfile_OccupationPreferenceLevel = typeof LearnerProfile_OccupationPreferenceLevel[keyof typeof LearnerProfile_OccupationPreferenceLevel];
/** Learner Profile Occupation Preferences Input */
export type LearnerProfile_OccupationPreferencesInput = {
  /** Preferred industry */
  industry?: InputMaybe<LearnerProfile_IndustryInput>;
  /** Preferred level of the occupation */
  level?: InputMaybe<LearnerProfile_OccupationPreferenceLevel>;
  /** Preferred occupation */
  occupation?: InputMaybe<LearnerProfile_OccupationInput>;
};

/** One of 'remove' (removes occupation preferences) or 'occupationPreferences' to patch to new value */
export type LearnerProfile_OccupationPreferencesOrRemoveInput = {
  /**
   * Set if occupationPreferences should be patched to new occupationPreferences value
   * A maximum of 8 occupation preferences is allowed.
   */
  occupationPreferences?: InputMaybe<Array<LearnerProfile_OccupationPreferencesInput>>;
  /** Set if occupationPreferences should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Object wrapper for other domain enum values */
export type LearnerProfile_OtherDomain = {
  __typename?: 'LearnerProfile_OtherDomain';
  /** The enum value for other domains */
  value: LearnerProfile_OtherDomainEnum;
};

/** Common domain categories available on Coursera */
export const LearnerProfile_OtherDomainEnum = {
  /** Other domain */
  Other: 'OTHER'
} as const;

export type LearnerProfile_OtherDomainEnum = typeof LearnerProfile_OtherDomainEnum[keyof typeof LearnerProfile_OtherDomainEnum];
/** Flattened partner object for learners s12ns */
export type LearnerProfile_Partner = {
  __typename?: 'LearnerProfile_Partner';
  /** The logo of the partner */
  logoUrl: Scalars['URL'];
  /** The name of the partner */
  name: Scalars['String'];
};

/** Input of the LearnerProfile_PatchAdditionalInfo mutation */
export type LearnerProfile_PatchAdditionalInfoInput = {
  /**
   * If about type is LearnerProfile_RemoveInput, sets about to null
   * If about field is null don’t change value of about
   * If about is not null set about to new value
   */
  about?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If externalLinks field is null, field is undefined and don’t change value of externalLinks
   * If externalLinks is not null, set externalLinks to new value
   */
  externalLinks?: InputMaybe<LearnerProfile_ExternalLinksInput>;
  /**
   * If resumeUrl type is LearnerProfile_RemoveInput, sets resumeUrl to null
   * If resumeUrl field is null, field is undefined and don’t change value of resumeUrl
   * If resumeUrl is not null, set resumeUrl to new value
   */
  resumeUrl?: InputMaybe<LearnerProfile_UrlOrRemoveInput>;
};

/** LearnerProfile Additional Info Dialog update response for either success or failure */
export type LearnerProfile_PatchAdditionalInfoResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Input of the LearnerProfile_PatchDomains mutation. */
export type LearnerProfile_PatchDomainsInput = {
  /**
   * If interestedDomains type is LearnerProfile_RemoveInput, sets interestedDomains to null
   * If interestedDomains field is null don't change value of interestedDomains
   * If interestedDomains is not null set interestedDomains to new value
   */
  interestedDomains?: InputMaybe<LearnerProfile_InterestedDomainsOrRemoveInput>;
};

/** LearnerProfile domains update response for either success or failure */
export type LearnerProfile_PatchDomainsResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Input of the LearnerProfile_PatchEducation mutation */
export type LearnerProfile_PatchEducationInput = {
  /**
   * If educationHistory type is LearnerProfile_RemoveInput, sets educationHistory to null
   * If educationHistory field is null don’t change value of educationHistory
   * If educationHistory is not null set educationHistory to new value
   */
  educationHistory?: InputMaybe<LearnerProfile_EducationHistoryOrRemoveInput>;
};

/** LearnerProfile Education Dialog update response for either success or failure */
export type LearnerProfile_PatchEducationResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** LearnerProfile Patch Mutation Error */
export type LearnerProfile_PatchError = Error & {
  __typename?: 'LearnerProfile_PatchError';
  /** Error message */
  message: Scalars['String'];
};

/** This is returned if the LearnerProfile_Patch mutation fails. */
export type LearnerProfile_PatchFailure = {
  __typename?: 'LearnerProfile_PatchFailure';
  /** Errors */
  errors: Array<LearnerProfile_PatchError>;
};

/** Input of the LearnerProfile_PatchPersonalInformation mutation */
export type LearnerProfile_PatchPersonalInformationInput = {
  /**
   * If countryWorkEligibilities type is LearnerProfile_RemoveInput, sets countryWorkEligibilities to null
   * If countryWorkEligibilities field is null don’t change value of countryWorkEligibilities
   * If countryWorkEligibilities is not null set countryWorkEligibilities to new value
   */
  countryWorkEligibilities?: InputMaybe<LearnerProfile_CountryWorkEligibilitiesOrRemoveInput>;
  /**
   * If ethnicities field is null don’t change value of ethnicities
   * If ethnicities is not null set ethnicities to new value
   */
  ethnicities?: InputMaybe<LearnerProfile_EthnicitiesOrRemoveInput>;
  /**
   * If fullName type is LearnerProfile_RemoveInput, sets fullName to null
   * If fullName field is null or string field is null, field is undefined and don’t change value of fullName
   * If fullName is string and string field has value, set fullName to new value
   */
  fullName?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If learnerProfileGender type is LearnerProfile_RemoveInput, sets learnerProfileGender to null
   * If learnerProfileGender field is null don’t change value of learnerProfileGender
   * If learnerProfileGender is not null set learnerProfileGender to new value
   */
  learnerProfileGender?: InputMaybe<LearnerProfile_LearnerProfileGenderOrRemoveInput>;
  /**
   * If location type is LearnerProfile_RemoveInput, sets location to null
   * If location field is null don’t change value of location
   * If location is not null set location to new value
   */
  location?: InputMaybe<LearnerProfile_UserLocationOrRemoveInput>;
  /**
   * If phone type is LearnerProfile_RemoveInput, sets phone to null
   * If phone field is null don’t change value of phone
   * If phone is not null set phone to new value
   */
  phone?: InputMaybe<LearnerProfile_PhoneOrRemoveInput>;
  /**
   * If profilePhoto type is LearnerProfile_RemoveInput, sets profilePhoto to null
   * If profilePhoto field is null don’t change value of profilePhoto
   * If profilePhoto is not null set profilePhoto to new value
   */
  profilePhoto?: InputMaybe<LearnerProfile_ProfilePhotoOrRemoveInput>;
  /**
   * If pronoun type is LearnerProfile_RemoveInput, sets pronoun to null
   * If pronoun field is null don’t change value of pronoun
   * If pronoun is not null set pronoun to new value
   */
  pronoun?: InputMaybe<LearnerProfile_StringOrRemoveInput>;
  /**
   * If veteranStatus type is LearnerProfile_RemoveInput, sets veteranStatus to null
   * If veteranStatus field is null don’t change value of veteranStatus
   * If veteranStatus is not null set veteranStatus to the new value
   */
  veteranStatus?: InputMaybe<LearnerProfile_VeteranStatusOrRemoveInput>;
};

/** LearnerProfile Personal Information Dialog update response for either success or failure */
export type LearnerProfile_PatchPersonalInformationResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Input of the LearnerProfile_PatchPrivacySettings mutation */
export type LearnerProfile_PatchPrivacySettingsInput = {
  /**
   * If includedInTalentPipeline type is LearnerProfile_RemoveInput, sets includedInTalentPipeline to null
   * If includedInTalentPipeline field is null don’t change value of includedInTalentPipeline
   * If includedInTalentPipeline is not null set includedInTalentPipeline to new value
   */
  includedInTalentPipeline?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If showToPublic type is LearnerProfile_RemoveInput, sets showToPublic to null
   * If showToPublic field is null don’t change value of showToPublic
   * If showToPublic is not null set showToPublic to new value
   */
  showToPublic?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** LearnerProfile Privacy Settings Dialog update response for either success or failure */
export type LearnerProfile_PatchPrivacySettingsResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Input of the LearnerProfile_PatchProfileSlug mutation */
export type LearnerProfile_PatchProfileSlugInput = {
  /** the user-provided custom slug for use in the profile url, ex: https://coursera.org/profile/my-slug */
  profileSlug: Scalars['String'];
};

/** LearnerProfile Slug update response for either success or failure */
export type LearnerProfile_PatchProfileSlugResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/**
 * Input of the LearnerProfile_PatchSkills mutation.
 *
 * Note: We are adding the 'ratedSkills' field to this input. Both 'existingField' and 'ratedSkills' will be available, and the client will specify which field to update.
 */
export type LearnerProfile_PatchSkillsInput = {
  /**
   * If desiredSkills type is LearnerProfile_RemoveInput, sets desiredSkills to null
   * If desiredSkills field is null don't change value of desiredSkills
   * If desiredSkills is not null set desiredSkills to new value
   */
  desiredSkills?: InputMaybe<LearnerProfile_DesiredSkillsOrRemoveInput>;
  /**
   * The learner may indicate that they're unsure of what skills they're
   * interested in developing
   */
  isUnsureOfSkills?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** LearnerProfile skills update response for either success or failure */
export type LearnerProfile_PatchSkillsResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** This is returned if the LearnerProfile_Patch mutation succeeds. */
export type LearnerProfile_PatchSuccess = {
  __typename?: 'LearnerProfile_PatchSuccess';
  /** Updated LearnerProfile */
  profile?: Maybe<LearnerProfile_Profile>;
};

/** Input of the LearnerProfile_PatchWorkExperience mutation */
export type LearnerProfile_PatchWorkExperienceInput = {
  /**
   * If workHistory type is LearnerProfile_RemoveInput, sets workHistory to null
   * If workHistory field is null don’t change value of workHistory
   * If workHistory is not null set workHistory to new value
   */
  workHistory?: InputMaybe<LearnerProfile_WorkHistoryOrRemoveInput>;
};

/** LearnerProfile Work Experience Dialog update response for either success or failure */
export type LearnerProfile_PatchWorkExperienceResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Input of the LearnerProfile_PatchWorkPreferences mutation */
export type LearnerProfile_PatchWorkPreferencesInput = {
  /**
   * The learner indicated that they’re unsure of which role they’re interested
   * in pursuing
   */
  isUnsureOfRoles?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If occupationPreferences type is LearnerProfile_RemoveInput, sets occupationPreferences to null
   * If occupationPreferences field is null don’t change value of occupationPreferences
   * If occupationPreferences is not null set occupationPreferences to new value
   * A maximum of 8 occupation preferences is allowed.
   */
  occupationPreferences?: InputMaybe<LearnerProfile_OccupationPreferencesOrRemoveInput>;
  /**
   * If openToRemoteWork type is LearnerProfile_RemoveInput, sets openToRemoteWork to null
   * If openToRemoteWork field is null, field is undefined and don’t change value of openToRemoteWork
   * If openToRemoteWork is boolean, set openToRemoteWork to new value
   */
  openToRemoteWork?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
  /**
   * If willingToRelocate type is LearnerProfile_RemoveInput, sets willingToRelocate to null
   * If willingToRelocate field is null, field is undefined and don’t change value of willingToRelocate
   * If willingToRelocate is boolean, set willingToRelocate to new value
   */
  willingToRelocate?: InputMaybe<LearnerProfile_BooleanOrRemoveInput>;
};

/** LearnerProfile Work Preferences Dialog update response for either success or failure */
export type LearnerProfile_PatchWorkPreferencesResult = LearnerProfile_PatchFailure | LearnerProfile_PatchSuccess;

/** Information about user's phone */
export type LearnerProfile_Phone = {
  __typename?: 'LearnerProfile_Phone';
  /** Country code of the phone number (e.g. US: 1, Brazil: 55, Botswana: 267) */
  countryCode?: Maybe<Scalars['String']>;
  /** The phone extension */
  extension?: Maybe<Scalars['String']>;
  /** The national phone number without the country code and extension */
  phoneNumber: Scalars['String'];
};

/** Learner Profile Phone input */
export type LearnerProfile_PhoneInput = {
  /** Sets country code of the phone number (e.g. US: 1, Brazil: 55, Botswana: 267) */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Sets the phone extension */
  extension?: InputMaybe<Scalars['String']>;
  /** Sets the national phone number without the country code and extension */
  phoneNumber: Scalars['String'];
};

/** One of 'remove' (removes phone) or 'phone' to patch to new value */
export type LearnerProfile_PhoneOrRemoveInput = {
  /** Set if phone should be patched to new value */
  phone?: InputMaybe<LearnerProfile_PhoneInput>;
  /** Set if phone should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/**
 * A project that the learner has completed in order to showcase their expertise to
 * potential employers.
 */
export type LearnerProfile_PortfolioProject = {
  __typename?: 'LearnerProfile_PortfolioProject';
  /**
   * The user-generated description of the steps the user took to complete the project
   * Will be null if the user has not yet completed this field.
   */
  approach?: Maybe<CmlContent>;
  /**
   * A list of the artifacts for the project published by learner.
   * If no artifacts published, this will be null.
   */
  artifacts?: Maybe<Array<LearnerProfile_Artifact>>;
  /** A text field indicating the business challenge the project aims to solve. */
  businessChallenge: Scalars['String'];
  /**
   * Challenge lab achievement, if applies to this project
   * If it does not apply, this will be null
   */
  challengeAchievement?: Maybe<LearnerProfile_ChallengeAchievement>;
  /**
   * The date when the project was completed.
   * Will be null if the project has not yet been completed.
   */
  completed?: Maybe<Scalars['DateTime']>;
  /** A text field indicating the amount of time that this project is expected to take. */
  estimatedWorkload: Scalars['String'];
  /**
   * The user-generated summary of their findings.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'approach' instead
   */
  findingsSummary?: Maybe<CmlContent>;
  /** The unique ID of the portfolio project for the learner. */
  id: Scalars['ID'];
  /**
   * The branding image of the project.
   * For now, this is the same as the Course branding image.
   */
  image: Scalars['URL'];
  /** Whether this project has been auto-published or (will be) manually added to the learner's profile. */
  isAutoPublished: Scalars['Boolean'];
  /**
   * The date when the project was last updated.
   * This will be null if the learner has not yet entered any of the manually entered fields.
   */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /**
   * A URL that links to a location where the learner's work may be viewed.
   * Will be null if the user has not yet provided a link.
   */
  linkToWork?: Maybe<Scalars['URL']>;
  /** A text field indicating the occupation id the project is related to. */
  occupationId: Scalars['ID'];
  /** An optional field containing partner info of the project (eg. partner name, partner logo). */
  partner?: Maybe<Partner_Partner>;
  /**
   * The user-generated summary of the problem and the methods they used to solve it.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'solution' instead
   */
  problemSummary?: Maybe<CmlContent>;
  /**
   * The user-generated summary of the project.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'summary' instead
   */
  projectSummary?: Maybe<CmlContent>;
  /** An enum field indicating the type of the project (eg. Capstone). */
  projectType: LearnerProfile_ProjectType;
  /** A list of skills associated with this portfolio project. */
  skills: Array<Scalars['String']>;
  /** The slug of the project. For now this is the course slug. */
  slug: Scalars['String'];
  /**
   * The user-generated explanation of how the solution achieved the project objectives
   * Will be null if the user has not yet completed this field.
   */
  solution?: Maybe<CmlContent>;
  /**
   * The user-generated summary of the project.
   * Will be null if the user has not yet completed this field.
   */
  summary?: Maybe<Scalars['String']>;
  /**
   * The title of the project.
   * For now, this is the same as the name of the Course
   */
  title: Scalars['String'];
  /** A list of tools used in the project. */
  tools: Array<Scalars['String']>;
};

/** The learner profile object */
export type LearnerProfile_Profile = {
  __typename?: 'LearnerProfile_Profile';
  /** The learners description of themselves */
  about?: Maybe<Scalars['String']>;
  /** This field contains the badges that a user has earned */
  badges?: Maybe<Badge_UserBadges>;
  /**
   * This field contains the occupationPreferences values normalized to roles taxonomy 2.0
   * If there is no match in taxonomy 2.0 the value will be null.
   */
  careerRoles?: Maybe<Array<Skill_CareerRole>>;
  /**
   * The list of portfolio projects that the learner has completed and published.
   * Null if errors were encountered while loading the projects.
   */
  completedPortfolioProjects?: Maybe<Array<LearnerProfile_PortfolioProject>>;
  /** The user's work eligibilities, keyed by country code */
  countryWorkEligibilities?: Maybe<LearnerProfile_CountryWorkEligibilities>;
  /** A history of the learners accomplishments on Coursera */
  courseraHistory?: Maybe<LearnerProfile_CourseraHistory>;
  /** List of user desired skills, either in form of ids or user input strings. This maps to the 'skillsWantedV2' field in the protobuf API definition. */
  desiredSkills: Array<LearnerProfile_Skill>;
  /** A set of properties that can hide or show various functionalities on the Learner Profile. */
  displaySettings: LearnerProfile_DisplaySettings;
  /**
   * The list of portfolio projects that the learner has enrolled in, but not yet published.
   * Null if errors were encountered while loading the projects.
   */
  draftPortfolioProjects?: Maybe<Array<LearnerProfile_PortfolioProject>>;
  /** A history of the learners educational studies */
  educationHistory: Array<LearnerProfile_EducationHistory>;
  /**
   * The user's ethnicity/ethnicities
   * Only returned if the requesting user is a recruiter or the profile's owner
   */
  ethnicities?: Maybe<Array<LearnerProfile_Ethnicity>>;
  /** The external id associated with the user */
  externalId: Scalars['ID'];
  /** Full url external links for the user's other profiles E.G. LinkedIn */
  externalLinks?: Maybe<LearnerProfile_ExternalLinks>;
  /** The user's full name */
  fullName?: Maybe<Scalars['String']>;
  /**
   * The gender of the user.
   * Only returned to the current user via me query otherwise will be null.
   * @deprecated Use learnerProfileGender instead for larger selection of enums and support of custom user input
   */
  gender?: Maybe<LearnerProfile_Gender>;
  /**
   * If the profile is included in the talent pipeline.
   *
   * This will be used to determine if the FE should hide some modules which are only available
   * if the user is in the talent pipeline.
   */
  includedInTalentPipeline?: Maybe<Scalars['Boolean']>;
  /**
   * A list of inferred career roles of interest for the user.
   * Only returned if the requesting user is a power user or the profile's owner
   */
  inferredCareerRolesOfInterest?: Maybe<Array<Inferred_CareerRolesOfInterest>>;
  /** The country code from the user's inferred location or country from the location field if it is set. */
  inferredUserLocationCountryCode?: Maybe<Scalars['String']>;
  /** List of user interested domains. */
  interestedDomains: Array<LearnerProfile_Domain>;
  /**
   * The most recent time (if ever) that a learner has indicated that they’re unsure of which
   * role/occupation they’re interested in pursuing. Any flow that wants to check if a learner
   * is currently unsure would check both not having roles/skills set and the timestamp existing
   */
  lastIndicatedUnsureRolesAt?: Maybe<Scalars['DateTime']>;
  /**
   * The most recent time (if ever) that a learner has indicated that they’re unsure of which skills
   * they’re interested in learning. Any flow that wants to check if a learner is currently unsure
   * would check both not having skills set and the timestamp existing
   */
  lastIndicatedUnsureSkillsAt?: Maybe<Scalars['DateTime']>;
  /**
   * The learner profile specific gender of the user.
   * This can be one of a larger list of enums or can also be a custom input.
   * Only returned to the current user via me query otherwise will be null.
   */
  learnerProfileGender?: Maybe<LearnerProfile_LearnerProfileGender>;
  /** Captured information about users and learning programs */
  learningPrograms?: Maybe<LearnerProfile_LearningPrograms>;
  /** The user's locale, e.g. en, en-US */
  locale?: Maybe<Scalars['Locale']>;
  /** The user's location information */
  location?: Maybe<LearnerProfile_UserLocation>;
  /** The preferences of what occupations the user is looking to get employed in */
  occupationPreferences: Array<LearnerProfile_OccupationPreference>;
  /**
   * The users results from iMocha skill assessments.
   * Only returned if the requesting user is a recruiter or the profile's owner
   */
  occupationSkillAssessments?: Maybe<Array<LearnerProfile_SkillAssessmentOccupationEntry>>;
  /** If the user is open to remote work */
  openToRemoteWork?: Maybe<Scalars['Boolean']>;
  /**
   * The user's phone information.
   * Only returned to the current user via me query otherwise will be null.
   */
  phone?: Maybe<LearnerProfile_Phone>;
  /**
   * A pre-signed URL to the users uploaded resume in S3 bucket coursera-profile-resumes. This is a pre-signed URL
   * which is valid for only 1 hour.
   */
  preSignedResumeUrl?: Maybe<Scalars['URL']>;
  /** The profile photo of the user if uploaded */
  profilePhoto?: Maybe<LearnerProfile_ProfilePhoto>;
  /** The pronouns of the user */
  pronoun?: Maybe<Scalars['String']>;
  /**
   * The organization the requesting recruiter belongs to.
   * Only returned via queryByExternalId if the requesting user is a recruiter otherwise will be null.
   *
   * This will be used to determine if the FE should hide UI which is only available to recruiters
   */
  recruitingOrganizationOfViewer?: Maybe<LearnerProfile_RecruiterOrganization>;
  /** The url of the user's resume */
  resumeUrl?: Maybe<Scalars['URL']>;
  /**
   * The visibility level of the whole profile to the public.
   *
   * This will be used to determine whether the user should be shown the profile if the requester is not a recruiter.
   */
  showToPublic?: Maybe<Scalars['Boolean']>;
  /** All ProfileSlug records associated with the user */
  slugs?: Maybe<Array<LearnerProfile_ProfileSlug>>;
  /** The user's timezone, e.g. America/Los Angeles */
  timezone?: Maybe<Scalars['String']>;
  /**
   * If the user is a member of underrepresented gender.
   * Only returned via the queryByExternalId query otherwise will be null.
   */
  underrepresentedDemographic?: Maybe<Scalars['Boolean']>;
  /**
   * The user's veteran status
   * Only returned if the requesting user is a recruiter or the profile's owner
   */
  veteranStatus?: Maybe<LearnerProfile_VeteranStatus>;
  /** If the user is open to relocating */
  willingToRelocate?: Maybe<Scalars['Boolean']>;
  /** A history of the learners work history */
  workHistory: Array<LearnerProfile_WorkHistory>;
};

/** The learner's profile photo */
export type LearnerProfile_ProfilePhoto = {
  __typename?: 'LearnerProfile_ProfilePhoto';
  /** 500px wide. The default url to use */
  default?: Maybe<Scalars['URL']>;
  /** The profile photo sized to 24px wide */
  size24?: Maybe<Scalars['URL']>;
  /** The profile photo sized to 60px wide */
  size60?: Maybe<Scalars['URL']>;
  /** The profile photo sized to 120px wide */
  size120?: Maybe<Scalars['URL']>;
};

/** Learner Profile Photo input */
export type LearnerProfile_ProfilePhotoInput = {
  /**
   * Sets new defaultSize if defaultSize is not null.
   * If null, defaultSize sets to null.
   */
  defaultSize?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size24 if size24 is not null.
   * If null, size24 sets to null
   */
  size24?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size60 if size60 is not null.
   * If null, size60 sets to null
   */
  size60?: InputMaybe<Scalars['URL']>;
  /**
   * Sets new size120 if size120 is not null.
   * If null, size120 sets to null
   */
  size120?: InputMaybe<Scalars['URL']>;
};

/** One of 'remove' (removes profilePhoto) or 'profilePhoto' to patch to new value */
export type LearnerProfile_ProfilePhotoOrRemoveInput = {
  /** Set if profilePhoto should be patched to new value */
  profilePhoto?: InputMaybe<LearnerProfile_ProfilePhotoInput>;
  /** Set if profilePhoto should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/** Custom user-specified slug for pretty URLs: https://coursera.org/profile/my-slug */
export type LearnerProfile_ProfileSlug = {
  __typename?: 'LearnerProfile_ProfileSlug';
  /** Timestamp when ProfileSlug was created */
  createdAt: Scalars['DateTime'];
  /** Slug value, matches /[^a-zA-Z0-9-]/g */
  slug: Scalars['String'];
};

/** Project type enum. */
export const LearnerProfile_ProjectType = {
  /** Capstone project type. */
  Capstone: 'CAPSTONE',
  /** Portfolio project type. */
  Demonstration: 'DEMONSTRATION'
} as const;

export type LearnerProfile_ProjectType = typeof LearnerProfile_ProjectType[keyof typeof LearnerProfile_ProjectType];
/** The organization of the requesting recruiter */
export type LearnerProfile_RecruiterOrganization = {
  __typename?: 'LearnerProfile_RecruiterOrganization';
  /** The id of the organization */
  id: Scalars['ID'];
};

/** Input used to remove LearnerProfile inputs */
export type LearnerProfile_RemoveInput = {
  /** Dummy field whose value is unused. GraphQL requires input to have at least one field. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Union type of the two skill types used in learner profile */
export type LearnerProfile_Skill = LearnerProfile_UserGeneratedSkill | Skill_Skill;

/** The mapping of an IMocha test and result to an occupation */
export type LearnerProfile_SkillAssessmentOccupationEntry = {
  __typename?: 'LearnerProfile_SkillAssessmentOccupationEntry';
  /** The occupation the test is for */
  occupation: LearnerProfile_OccupationId;
  /** The test to result entry for each test associated with the occupation */
  testResults: Array<LearnerProfile_SkillAssessmentTestResultEntry>;
};

/** Proficiency level of the user in a given skill assessment */
export const LearnerProfile_SkillAssessmentProficiency = {
  /** Beginner level of proficiency */
  Beginner: 'BEGINNER',
  /** Experienced level of proficiency */
  Experienced: 'EXPERIENCED',
  /** Intermediate level of proficiency */
  Intermediate: 'INTERMEDIATE',
  /** Proficient level of proficiency */
  Proficient: 'PROFICIENT'
} as const;

export type LearnerProfile_SkillAssessmentProficiency = typeof LearnerProfile_SkillAssessmentProficiency[keyof typeof LearnerProfile_SkillAssessmentProficiency];
/** The overall summary for an IMocha skill assessment including a reference to the individual skill results */
export type LearnerProfile_SkillAssessmentTestResult = {
  __typename?: 'LearnerProfile_SkillAssessmentTestResult';
  /** The assessment results for each skill */
  individualSkillAssessments: Array<LearnerProfile_IndividualSkillAssessment>;
  /** The text label for the proficiency of the user in the assessment */
  proficiency: LearnerProfile_SkillAssessmentProficiency;
  /** The overall percentage score the learner got for all the skill tests */
  score: Scalars['Int'];
};

/** A single IMocha assessment and result entry for an occupation */
export type LearnerProfile_SkillAssessmentTestResultEntry = {
  __typename?: 'LearnerProfile_SkillAssessmentTestResultEntry';
  /** The result if taken for the test */
  result?: Maybe<LearnerProfile_SkillAssessmentTestResult>;
  /** The id of the IMocha test */
  testId: Scalars['ID'];
  /** The amount of time (in minutes) that the assessment has been designed to take to complete. */
  typicalDurationMinutes: Scalars['Int'];
};

/** Input for LearnerProfile_Skill */
export type LearnerProfile_SkillInput = {
  /** The id of the skill */
  id?: InputMaybe<Scalars['ID']>;
  /** The user inputted name for the skill */
  name?: InputMaybe<Scalars['String']>;
};

/** A s12n the learner has completed */
export type LearnerProfile_Specialization = {
  __typename?: 'LearnerProfile_Specialization';
  /** The date the learner completed the specialization */
  completionDate: Scalars['DateTime'];
  /** The name of the specialization */
  name: Scalars['String'];
  /** The partner info for the certificate */
  partners: Array<LearnerProfile_Partner>;
  /** The product id of the specialization */
  productId: Scalars['ID'];
  /** The skills gained from the specialization */
  skillNames: Array<Scalars['String']>;
  /** The number of weeks the specialization typically takes to complete */
  totalContentWeeks?: Maybe<Scalars['Int']>;
  /** The verification code of theSpecialization, used to generate links to the accomplishment page for the user */
  verifyCode: Scalars['String'];
};

/** One of 'remove' (removes string) or 'string' to patch to new value */
export type LearnerProfile_StringOrRemoveInput = {
  /** Set if string field should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if string field should be patched to new value */
  string?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes url) or 'url' to patch to new value */
export type LearnerProfile_UrlOrRemoveInput = {
  /** Set if url should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if url should be patched to new URL value */
  url?: InputMaybe<Scalars['URL']>;
};

/** Fields for US work eligibility. */
export type LearnerProfile_UsWorkEligibility = {
  __typename?: 'LearnerProfile_UsWorkEligibility';
  /** True if the user is authorized to work in the US, false otherwise. */
  hasWorkAuthorization?: Maybe<Scalars['Boolean']>;
  /** True if the user requires visa sponsorship to work in the US, false otherwise. */
  requiresVisaSponsorship?: Maybe<Scalars['Boolean']>;
};

/** US work eligibility input */
export type LearnerProfile_UsWorkEligibilityInput = {
  /** True if the user is authorized to work in the US, false otherwise. */
  hasWorkAuthorization?: InputMaybe<Scalars['Boolean']>;
  /** True if the user requires visa sponsorship to work in the US, false otherwise. */
  requiresVisaSponsorship?: InputMaybe<Scalars['Boolean']>;
};

/** The users free text self declared gender entry */
export type LearnerProfile_UserGenderEntry = {
  __typename?: 'LearnerProfile_UserGenderEntry';
  /** The custom self declared gender of the user */
  userGenderInput: Scalars['String'];
};

/** An industry which is not mapped to ProfileOccupationChoices.V1 and is free text user input */
export type LearnerProfile_UserGeneratedIndustry = {
  __typename?: 'LearnerProfile_UserGeneratedIndustry';
  /** The user inputted name for the industry */
  name: Scalars['String'];
};

/** An occupation which is not mapped to ProfileOccupationChoices.V1 and is free text user input */
export type LearnerProfile_UserGeneratedOccupation = {
  __typename?: 'LearnerProfile_UserGeneratedOccupation';
  /** The user inputted name for the occupation */
  name: Scalars['String'];
};

/** An skill which is not mapped to skills v2 taxonomy and is free text user input */
export type LearnerProfile_UserGeneratedSkill = {
  __typename?: 'LearnerProfile_UserGeneratedSkill';
  /** The user inputted name for the skill */
  name: Scalars['String'];
};

/** The learners current location */
export type LearnerProfile_UserLocation = {
  __typename?: 'LearnerProfile_UserLocation';
  /** The name (in English) of the candidate's city. */
  cityName?: Maybe<Scalars['String']>;
  /** The two-letter ISO code of the candidate's country. Eg. US */
  countryCode?: Maybe<Scalars['String']>;
  /**
   * The name (in English) of the candidate's country. Eg. United States
   * This is mapped from countryCode
   */
  countryName?: Maybe<Scalars['String']>;
  /** The latitude of the candidate's location */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude of the candidate's location */
  longitude?: Maybe<Scalars['Float']>;
  /** The name (in English) of the candidate's state/province. */
  stateName?: Maybe<Scalars['String']>;
};

/** User Location Input */
export type LearnerProfile_UserLocationInput = {
  /**
   * Sets new cityName if cityName is not null.
   * If null, cityName sets to null
   */
  cityName?: InputMaybe<Scalars['String']>;
  /**
   * Sets new countryCode if countryCode is not null.
   * If null, countryCode sets to null
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * Sets new latitude if latitude is not null.
   * If null, latitude sets to null
   */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Sets new longitude if longitude is not null.
   * If null, longitude sets to null
   */
  longitude?: InputMaybe<Scalars['Float']>;
  /**
   * Sets new stateName if stateName is not null.
   * If null, stateName sets to null
   */
  stateName?: InputMaybe<Scalars['String']>;
};

/** One of 'remove' (removes location) or 'location' to patch to new value */
export type LearnerProfile_UserLocationOrRemoveInput = {
  /** Set if location should be patched to new value */
  location?: InputMaybe<LearnerProfile_UserLocationInput>;
  /** Set if location should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
};

/**
 * Options for a Learner's Veteran Status.
 * Used by the recruiting platform in the United States for DEI metrics.
 */
export const LearnerProfile_VeteranStatus = {
  /** Not a Protected Veteran */
  NotProtectedVeteran: 'NOT_PROTECTED_VETERAN',
  /** Prefer not to answer */
  PreferNotToSay: 'PREFER_NOT_TO_SAY',
  /** Protected Veteran (specifically in the US) */
  ProtectedVeteran: 'PROTECTED_VETERAN'
} as const;

export type LearnerProfile_VeteranStatus = typeof LearnerProfile_VeteranStatus[keyof typeof LearnerProfile_VeteranStatus];
/** One of 'remove' (removes veteranStatus) or veteranStatus to patch to new value */
export type LearnerProfile_VeteranStatusOrRemoveInput = {
  /** Set if veteranStatus should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if veteranStatus should be patched to new value */
  veteranStatus?: InputMaybe<LearnerProfile_VeteranStatus>;
};

/** A single entry in the learners work history */
export type LearnerProfile_WorkHistory = {
  __typename?: 'LearnerProfile_WorkHistory';
  /** A description of the duties held */
  description?: Maybe<Scalars['String']>;
  /** The name of the employer they were employed with */
  employerName?: Maybe<Scalars['String']>;
  /** The date they ended their employment */
  endDate?: Maybe<LearnerProfile_YearMonthDate>;
  /** If the learner is currently employed at this employer */
  isCurrentlyEmployed?: Maybe<Scalars['Boolean']>;
  /** The title of the job they held */
  jobTitle?: Maybe<LearnerProfile_Occupation>;
  /** The date they started their employment */
  startDate?: Maybe<LearnerProfile_YearMonthDate>;
};

/** LearnerProfile Work History Input */
export type LearnerProfile_WorkHistoryInput = {
  /** Description of the work history */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the employer */
  employerName?: InputMaybe<Scalars['String']>;
  /** End date of the work history */
  endDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
  /** Set to true if the learner is currently employed in the work history, false otherwise */
  isCurrentlyEmployed?: InputMaybe<Scalars['Boolean']>;
  /** Job title of the work history */
  jobTitle?: InputMaybe<LearnerProfile_OccupationInput>;
  /** Start date of the work history */
  startDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** One of 'remove' (removes work history) or 'workHistory' to patch to new value */
export type LearnerProfile_WorkHistoryOrRemoveInput = {
  /** Set if workHistory should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if workHistory should be patched to new workHistory value */
  workHistory?: InputMaybe<Array<LearnerProfile_WorkHistoryInput>>;
};

/** Simple date format for learner profile dates E.G. graduation date */
export type LearnerProfile_YearMonthDate = {
  __typename?: 'LearnerProfile_YearMonthDate';
  /** The month associated with the date */
  month: Scalars['Int'];
  /** The year associated with the date */
  year: Scalars['Int'];
};

/** YearMonthDate Input */
export type LearnerProfile_YearMonthDateInput = {
  /** The month associated with the date, if null, don't change. Change month if not null. */
  month?: InputMaybe<Scalars['Int']>;
  /** The year associated with the date, if null, don't change. Change year if not null. */
  year?: InputMaybe<Scalars['Int']>;
};

/** One of 'remove' (removes yearMonthDate) or 'yearMonthDate' to patch to new value */
export type LearnerProfile_YearMonthDateOrRemoveInput = {
  /** Set if yearMonthDate should be removed */
  remove?: InputMaybe<LearnerProfile_RemoveInput>;
  /** Set if yearMonthDate should be patched to new yearMonthDate value */
  yearMonthDate?: InputMaybe<LearnerProfile_YearMonthDateInput>;
};

/** Weekly streak for a learner. */
export type LearnerStreaks_Streak = {
  __typename?: 'LearnerStreaks_Streak';
  /** Indicates whether a learner has met their weekly learning target for the current week. */
  isCurrentWeeklyStreakTargetMet: Scalars['Boolean'];
  /** The number of weeks the learner has consistently learned. */
  streakCount: Scalars['Int'];
  /** The number of days a learner needs to learn in a week to meet their target. */
  streakTargetDays: Scalars['Int'];
};

/** LearningHours_Error error interface */
export type LearningHours_Error = {
  /** Error Message */
  message: Scalars['String'];
};

/** Platform this event was sent from. */
export const LearningHours_EventPlatform = {
  /** Mobile device such as android or iOS */
  Mobile: 'MOBILE',
  /** Web */
  Web: 'WEB'
} as const;

export type LearningHours_EventPlatform = typeof LearningHours_EventPlatform[keyof typeof LearningHours_EventPlatform];
/**
 * Data sent every "durationSeconds" from the FE that contains
 * data on what course the user was learning on and potential item details.
 * UserId is taken from request context.
 */
export type LearningHours_Heartbeat = {
  /**
   * ISO Date Formatted String with Millisecond precision.
   * In cases where local storage may be used (Eg. Mobile) to batch events, it could be possible for
   * clientTimestamp and serverTimestamp to differ by a large amount
   */
  clientDateTime: Scalars['DateTime'];
  /** Optional course branch ID the learner is viewing. */
  courseBranchId?: InputMaybe<Scalars['ID']>;
  /** courseId */
  courseId: Scalars['ID'];
  /**
   * Optional field if available.
   * Used to uniquely identify the device incase a learner has coursera open
   * on multiple browsers or is sharing accounts
   */
  deviceId?: InputMaybe<Scalars['ID']>;
  /** Length of the heart beat interval in milliseconds. Eg. 30000 for 30 secs */
  durationMilliSeconds: Scalars['Int'];
  /**
   * event os:
   * Eg. Mac OS X, Windows 10, Android, iOS, etc
   * There are too many past and potential future values to enumerate here so leaving this as a String
   */
  eventOs: Scalars['String'];
  /** event platform */
  eventPlatform: LearningHours_EventPlatform;
  /** Optional itemDetails */
  itemDetails?: InputMaybe<LearningHours_HeartbeatItemDetails>;
  /** User Action Type */
  userActionType: LearningHours_UserActionType;
};

/** Details about the item the learner may have been viewing when the heartbeat was sent */
export type LearningHours_HeartbeatItemDetails = {
  /** ItemId if user was on an item page when heartbeat was sent */
  itemId: Scalars['ID'];
  /** Optional details about the item the learner was on. */
  learnerActivityType?: InputMaybe<LearningHours_LearnerActivityType>;
};

/**
 * Types are defined on the FE:
 * https://github.com/webedx-spark/web/blob/main/static/bundles/course-v2/utils/LearningHoursSignalsUtil.ts#L5
 */
export const LearningHours_LearnerActivityType = {
  /** Learner was on a discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Learner was on a video page */
  Lecture: 'LECTURE',
  /** Learner was on a peer review */
  PeerReview: 'PEER_REVIEW',
  /** Learner was on a programming item */
  Programming: 'PROGRAMMING',
  /** Learner was on a quiz item */
  Quiz: 'QUIZ',
  /** Learner was on a reading item */
  Reading: 'READING',
  /** Learner was on a staff graded item */
  StaffGraded: 'STAFF_GRADED',
  /** Learner was on a teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Learner was on an ungraded lab item */
  UngradedLab: 'UNGRADED_LAB'
} as const;

export type LearningHours_LearnerActivityType = typeof LearningHours_LearnerActivityType[keyof typeof LearningHours_LearnerActivityType];
/** Error message if send event fails */
export type LearningHours_SendEventError = LearningHours_Error & {
  __typename?: 'LearningHours_SendEventError';
  /** Inherited field from LearningHours_Error interface */
  message: Scalars['String'];
};

/** LearningHours_SendEventInput */
export type LearningHours_SendEventInput = {
  /** LearningHours_Heartbeat */
  heartbeat: LearningHours_Heartbeat;
};

/** Result for LearningHours_SendEvent */
export type LearningHours_SendEventResult = LearningHours_SendEventError | LearningHours_SendEventSuccess;

/** LearningHours_SendEvent */
export type LearningHours_SendEventSuccess = {
  __typename?: 'LearningHours_SendEventSuccess';
  /** Id of event created */
  id: Scalars['ID'];
};

/** Action that triggered the event */
export const LearningHours_UserActionType = {
  /** Mouse click or keyboard press */
  KeyPress: 'KEY_PRESS',
  /** Mouse movement */
  MouseMovement: 'MOUSE_MOVEMENT',
  /** Page scroll */
  PageScroll: 'PAGE_SCROLL',
  /** Learner is on video page and video is playing */
  VideoIsPlaying: 'VIDEO_IS_PLAYING'
} as const;

export type LearningHours_UserActionType = typeof LearningHours_UserActionType[keyof typeof LearningHours_UserActionType];
/** Attached asset wrapper types, which can contain a file upload (asset based) asset, or other, which can contain CML, HTML, or URL based assets */
export type LectureAuthoring_AttachedAsset = {
  __typename?: 'LectureAuthoring_AttachedAsset';
  /** OpenCourseAsset that contains the asset contents */
  openCourseAsset: OpenCourseAsset;
};

/** Audio described video info for a specific language. */
export type LectureAuthoring_AudioDescriptionVideo = {
  __typename?: 'LectureAuthoring_AudioDescriptionVideo';
  /** Asset id of the audio described video. */
  assetId: Scalars['ID'];
  /** Language code (e.g., "en", "fr"). */
  languageCode: Scalars['String'];
  /** List of resolutions and their source URLs for the audio described video. */
  resolutions: Array<LectureAuthoring_ResolutionSource>;
};

/** Various formats for audio */
export const LectureAuthoring_AudioFormat = {
  /** Audio format mp3 */
  Mp3: 'MP3'
} as const;

export type LectureAuthoring_AudioFormat = typeof LectureAuthoring_AudioFormat[keyof typeof LectureAuthoring_AudioFormat];
/** Entity containing an audio source URL and info */
export type LectureAuthoring_AudioSource = {
  __typename?: 'LectureAuthoring_AudioSource';
  /** Audio format, ex: "audio/mp3" */
  audioFormat: LectureAuthoring_AudioFormat;
  /** Audio bitrate */
  bitrate: Scalars['Int'];
  /** Audio source URL */
  url: Scalars['URL'];
};

/** Returned if LectureAuthoring_AutoPublishLectureDraft ran into a client-actionable error */
export type LectureAuthoring_AutoPublishLectureDraftFailure = {
  __typename?: 'LectureAuthoring_AutoPublishLectureDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Input for the LectureAuthoring_AutoPublishLectureDraft mutation */
export type LectureAuthoring_AutoPublishLectureDraftInput = {
  /** Id of the atom to publish */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /**
   * Optional limit on which branches to publish to. If specified, only branches mapping to the
   * supplied branch ids will be published to and all other instances of the atom will be frozen.
   */
  publishBranchIdsIncluded?: InputMaybe<Array<Scalars['ID']>>;
};

/** Result union for the LectureAuthoring_AutoPublishLectureDraft mutation */
export type LectureAuthoring_AutoPublishLectureDraftResult = LectureAuthoring_AutoPublishLectureDraftFailure | LectureAuthoring_AutoPublishLectureDraftSuccess;

/** Returned if LectureAuthoring_AutoPublishLectureDraft completed successfully */
export type LectureAuthoring_AutoPublishLectureDraftSuccess = {
  __typename?: 'LectureAuthoring_AutoPublishLectureDraftSuccess';
  /**
   * If false the requested lecture was published immediately. When true an auto publish was
   * scheduled for the requested lecture.
   */
  autoPublishScheduled: Scalars['Boolean'];
  /** The updated lecture */
  item: ItemPlatform_AuthoringItem;
};

/** Returned if LectureAuthoring_DeleteLectureDraft ran into a client-actionable error */
export type LectureAuthoring_DeleteLectureDraftFailure = {
  __typename?: 'LectureAuthoring_DeleteLectureDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Input for the LectureAuthoring_UpdateLectureDraft mutation */
export type LectureAuthoring_DeleteLectureDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Whether to also delete subtitles */
  deleteSubtitleDrafts: Scalars['Boolean'];
};

/** Result union for the LectureAuthoring_DeleteLectureDraft mutation */
export type LectureAuthoring_DeleteLectureDraftResult = LectureAuthoring_DeleteLectureDraftFailure | LectureAuthoring_DeleteLectureDraftSuccess;

/** Returned if LectureAuthoring_DeleteLectureDraft completed successfully */
export type LectureAuthoring_DeleteLectureDraftSuccess = {
  __typename?: 'LectureAuthoring_DeleteLectureDraftSuccess';
  /** Atom Id of deleted lecture draft */
  atomId: Scalars['ID'];
};

/** Lecture draft content, represented as an input type */
export type LectureAuthoring_DraftContentInput = {
  /** List of VersionedOpenCourseAssetIds */
  attachedAssets?: InputMaybe<Array<Scalars['ID']>>;
  /** List of deleted subtitle language codes */
  deletedSubtitleLanguageCodes?: InputMaybe<Array<Scalars['String']>>;
  /** In-video assessment id for adding in video assessments to lectures */
  inVideoAssessmentId?: InputMaybe<Scalars['ID']>;
  /** Updated item name */
  name: Scalars['String'];
  /** Subtitle AssetIds of the staged subtitle drafts for this lecture */
  stagedSubtitleDrafts?: InputMaybe<Array<Scalars['ID']>>;
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
  /** List of subtitles that will replace the existing subtitles */
  updatedSubtitles?: InputMaybe<Array<LectureAuthoring_SubtitleInput>>;
  /** Updated video asset Id */
  videoAssetId?: InputMaybe<Scalars['ID']>;
};

/** Various fields that are only applicable to lecture drafts */
export type LectureAuthoring_LectureDraftFields = {
  __typename?: 'LectureAuthoring_LectureDraftFields';
  /** Whether at least one resolution is ready, only available for lecture drafts */
  isAtLeastOneResolutionReady: Scalars['Boolean'];
  /** List of subtitle draft information with validation, only available for lecture drafts */
  stagedSubtitleDrafts: Array<LectureAuthoring_SubtitleDraftIdWithValidation>;
  /** Percentage of transcoding work completed, in the range [0, 100], only available for lecture drafts */
  transcodingProgress: Scalars['Int'];
  /** Transcoding status of the lecture video, only available for lecture drafts */
  transcodingStatus: LectureAuthoring_TranscodingStatus;
};

/** Lecture video sources and info */
export type LectureAuthoring_LectureVideo = {
  __typename?: 'LectureAuthoring_LectureVideo';
  /** Audio described videos. Keyed by language code, contains the asset id and source URLs for each audio described video. */
  audioDescriptionVideos?: Maybe<Array<LectureAuthoring_AudioDescriptionVideo>>;
  /** Video source URLs */
  sources: LectureAuthoring_VideoSources;
  /** List of language codes to corresponding subtitle asset proxy URLs for srt subtitles */
  srtSubtitles: Array<LectureAuthoring_Subtitle>;
  /** List of language codes to corresponding subtitle asset proxy URLs for txt subtitles */
  txtSubtitles: Array<LectureAuthoring_Subtitle>;
  /** List of language codes to corresponding subtitle asset proxy URLs for vtt subtitles */
  vttSubtitles: Array<LectureAuthoring_Subtitle>;
};

/** Entity containing the video source URLS for a specific resolution */
export type LectureAuthoring_ResolutionSource = {
  __typename?: 'LectureAuthoring_ResolutionSource';
  /** The resolution of the video source, ex. 240p, 360p */
  resolution: LectureAuthoring_VideoResolution;
  /** The source URLs for the resolution */
  urls: LectureAuthoring_VideoSourceUrls;
};

/** Entity containing the subtitle url for a specific language */
export type LectureAuthoring_Subtitle = {
  __typename?: 'LectureAuthoring_Subtitle';
  /** AssetId of subtitle asset */
  assetId?: Maybe<Scalars['ID']>;
  /** The language code of the subtitle asset */
  languageCode: Scalars['String'];
  /** The subtitle asset proxy URL */
  url: Scalars['URL'];
};

/** Subtitle draft info with validation */
export type LectureAuthoring_SubtitleDraftIdWithValidation = {
  __typename?: 'LectureAuthoring_SubtitleDraftIdWithValidation';
  /** Asset ID for the subtitle draft */
  assetId: Scalars['ID'];
  /** Whether the subtitle draft is valid */
  isValidSubtitle: Scalars['Boolean'];
  /** Language code */
  languageCode: Scalars['String'];
  /** SRT URL */
  srtUrl?: Maybe<Scalars['URL']>;
  /** Vtt URL */
  vttUrl?: Maybe<Scalars['URL']>;
};

/** Subtitle update parameters */
export type LectureAuthoring_SubtitleInput = {
  /** AssetId to update to */
  assetId: Scalars['ID'];
  /** Language code of subtitle to update */
  languageCode: Scalars['String'];
};

/** Various states a subtitle transcription job can be in */
export const LectureAuthoring_SubtitleJobState = {
  /** Transcription job was aborted by the vendor */
  Aborted: 'ABORTED',
  /** Media context has been uploaded, so the transcription job is ready to be authorized */
  AuthorizeTranscription: 'AUTHORIZE_TRANSCRIPTION',
  /** Primary-language subtitle asset is present. Attempt to upload for translation here */
  CreateTranslation: 'CREATE_TRANSLATION',
  /** Something went horribly wrong (eg. vendor lost data) */
  Failed: 'FAILED',
  /** Initial state. Attempt to create a new transcription job here */
  NotStarted: 'NOT_STARTED',
  /** Transcription has been completed, so we attempt to download and create subtitle assets here */
  TranscriptionReady: 'TRANSCRIPTION_READY',
  /** Transcription job has been authorized. Poll transcription vendors for progress updates here */
  TranscriptionStarted: 'TRANSCRIPTION_STARTED',
  /** Subtitles uploaded to Smartling. Poll for completed translations here */
  Translating: 'TRANSLATING',
  /** Transcription job has been created, but needs media to be uploaded */
  UploadMedia: 'UPLOAD_MEDIA'
} as const;

export type LectureAuthoring_SubtitleJobState = typeof LectureAuthoring_SubtitleJobState[keyof typeof LectureAuthoring_SubtitleJobState];
/** States that a video transcoding job can be in */
export const LectureAuthoring_TranscodingStatus = {
  /** Transcoding has been completed */
  Completed: 'COMPLETED',
  /** Transcoding has failed */
  Failed: 'FAILED',
  /** Transcoding is still in progress */
  InProgress: 'IN_PROGRESS',
  /** Transcoding not started */
  NotStarted: 'NOT_STARTED'
} as const;

export type LectureAuthoring_TranscodingStatus = typeof LectureAuthoring_TranscodingStatus[keyof typeof LectureAuthoring_TranscodingStatus];
/** Returned if LectureAuthoring_UpdateLectureDraft ran into a client-actionable error */
export type LectureAuthoring_UpdateLectureDraftFailure = {
  __typename?: 'LectureAuthoring_UpdateLectureDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Input for the LectureAuthoring_UpdateLectureDraft mutation */
export type LectureAuthoring_UpdateLectureDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: LectureAuthoring_DraftContentInput;
};

/** Result union for the LectureAuthoring_UpdateLectureDraft mutation */
export type LectureAuthoring_UpdateLectureDraftResult = LectureAuthoring_UpdateLectureDraftFailure | LectureAuthoring_UpdateLectureDraftSuccess;

/** Returned if LectureAuthoring_UpdateLectureDraft completed successfully */
export type LectureAuthoring_UpdateLectureDraftSuccess = {
  __typename?: 'LectureAuthoring_UpdateLectureDraftSuccess';
  /** The updated lecture */
  item: ItemPlatform_AuthoringItem;
};

/** Various resolutions for videos */
export const LectureAuthoring_VideoResolution = {
  /** Lowest resolution we transcode, only used on mobile */
  Resolution_234P: 'RESOLUTION_234P',
  /** Lowest resolution used on web */
  Resolution_240P: 'RESOLUTION_240P',
  /** 270p only used for mobile */
  Resolution_270P: 'RESOLUTION_270P',
  /** 360p resolution */
  Resolution_360P: 'RESOLUTION_360P',
  /** 540p resolution */
  Resolution_540P: 'RESOLUTION_540P',
  /** 720p resolution */
  Resolution_720P: 'RESOLUTION_720P',
  /** 1080p resolution */
  Resolution_1080P: 'RESOLUTION_1080P'
} as const;

export type LectureAuthoring_VideoResolution = typeof LectureAuthoring_VideoResolution[keyof typeof LectureAuthoring_VideoResolution];
/** Entity containing the various types of video source URLs */
export type LectureAuthoring_VideoSourceUrls = {
  __typename?: 'LectureAuthoring_VideoSourceUrls';
  /** The mp4 source URL */
  mp4?: Maybe<Scalars['URL']>;
  /** The webm source URL */
  webm?: Maybe<Scalars['URL']>;
};

/** Entity containing the various video and audio source URLs for a lecture video */
export type LectureAuthoring_VideoSources = {
  __typename?: 'LectureAuthoring_VideoSources';
  /** List of audio sources */
  audioSources: Array<LectureAuthoring_AudioSource>;
  /** List of resolutions and their source URLs */
  resolutions: Array<LectureAuthoring_ResolutionSource>;
};

/** LevelSetAttempts Queries */
export type LevelSetAttemptsQueries = {
  __typename?: 'LevelSetAttemptsQueries';
  /** Get LevelSet attempts data by a Learner LevelSet ID. */
  getByLearnerLevelSetId?: Maybe<LevelSet_UserProgress>;
  /** Get LevelSet attempts data by Learner LevelSet IDs. */
  multiGetByLearnerLevelSetIds: Array<LevelSet_UserProgress>;
  /** Query LevelSet attempts data by User and Skill IDs. */
  queryByUserAndSkillIds: Array<LevelSet_UserProgress>;
};


/** LevelSetAttempts Queries */
export type LevelSetAttemptsQueriesGetByLearnerLevelSetIdArgs = {
  learnerLevelSetId: LevelSetAttempts_LearnerLevelSetId;
};


/** LevelSetAttempts Queries */
export type LevelSetAttemptsQueriesMultiGetByLearnerLevelSetIdsArgs = {
  learnerLevelSetIds: Array<LevelSetAttempts_LearnerLevelSetId>;
};


/** LevelSetAttempts Queries */
export type LevelSetAttemptsQueriesQueryByUserAndSkillIdsArgs = {
  skillIds: Array<Scalars['ID']>;
  userId: Scalars['Int'];
};

/** Learner LevelSet ID. */
export type LevelSetAttempts_LearnerLevelSetId = {
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
  /** Unique ID of the User. */
  userId: Scalars['Int'];
};

/** Input of the LevelSetAttempts_ResetAttempts mutation. */
export type LevelSetAttempts_ResetAttemptsInput = {
  /** Learner LevelSet ID. */
  learnerLevelSetId: LevelSetAttempts_LearnerLevelSetId;
};

/** Result of the LevelSetAttempts_ResetAttempts mutation. */
export type LevelSetAttempts_ResetAttemptsResult = {
  __typename?: 'LevelSetAttempts_ResetAttemptsResult';
  /** User ID. */
  userId: Scalars['ID'];
};

/** LevelSetContent Queries */
export type LevelSetContentQueries = {
  __typename?: 'LevelSetContentQueries';
  /** Get LevelSet content by a Versioned Skill ID. */
  getByVersionedSkillId?: Maybe<LevelSetContent_Response>;
  /** Get LevelSet content by Versioned Skill IDs. */
  multiGetByVersionedSkillIds: Array<LevelSetContent_Response>;
};


/** LevelSetContent Queries */
export type LevelSetContentQueriesGetByVersionedSkillIdArgs = {
  versionedSkillId: LevelSetContent_VersionedSkillId;
};


/** LevelSetContent Queries */
export type LevelSetContentQueriesMultiGetByVersionedSkillIdsArgs = {
  versionedSkillIds: Array<LevelSetContent_VersionedSkillId>;
};

/** Response object that represents LevelSet Content. */
export type LevelSetContent_Response = {
  __typename?: 'LevelSetContent_Response';
  /** The list of topics covered within the LevelSet. */
  description?: Maybe<Array<Scalars['String']>>;
  /** The type of benchmark that was used to determine the percentile. */
  duration: Scalars['Duration'];
  /** The number of questions in the LevelSet. */
  numberOfQuestions: Scalars['Int'];
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
  /** Name of the skill. */
  skillName: Scalars['String'];
};

/** Versioned Skill ID. */
export type LevelSetContent_VersionedSkillId = {
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
  /** The version of the skill. */
  version: Scalars['Int'];
};

/** LevelSets queries */
export type LevelSetQueries = {
  __typename?: 'LevelSetQueries';
  /** Query all LevelSet recommendations | Maximum page size: 1000 */
  queryLevelSetRecommendations: LevelSet_StateConnection;
};


/** LevelSets queries */
export type LevelSetQueriesQueryLevelSetRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  enterpriseProgramId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** The feedback of the levelset attempt. */
export type LevelSet_AttemptFeedback = {
  __typename?: 'LevelSet_AttemptFeedback';
  /** The total score earned by the user for the attempt. */
  earnedScore: Scalars['Float'];
  /** The sum of full score of questions in the attempt. */
  fullScore: Scalars['Float'];
};

/** Mastery level of a skill. */
export const LevelSet_MasteryLevel = {
  /** Mastery level 1. */
  MasteryLevel_1: 'MASTERY_LEVEL_1',
  /** Mastery level 2. */
  MasteryLevel_2: 'MASTERY_LEVEL_2',
  /** Mastery level 3. */
  MasteryLevel_3: 'MASTERY_LEVEL_3',
  /** Mastery level 4. */
  MasteryLevel_4: 'MASTERY_LEVEL_4'
} as const;

export type LevelSet_MasteryLevel = typeof LevelSet_MasteryLevel[keyof typeof LevelSet_MasteryLevel];
/** Result type for submitting responses to questions in a LevelSet. */
export type LevelSet_Question = {
  __typename?: 'LevelSet_Question';
  /**
   * The contribution information list of the question, e.g. name of the course and partner the
   * question is picked from; each course, partner pair is a separate metadata object
   */
  metadata: Array<LevelSet_QuestionMetadata>;
  /** The opaque Json string of the question definition */
  question: Scalars['JSON'];
  /** The ID of the question being answered. */
  questionId: Scalars['ID'];
  /**
   * The type of question being responded to.
   * This should match the response data provided.
   */
  questionType: LevelSet_QuestionType;
  /** The version of the question being answered. */
  questionVersion: Scalars['Int'];
};

/**
 * The contribution information of the question, e.g. name of the course and partner the question is
 * picked from
 */
export type LevelSet_QuestionMetadata = {
  __typename?: 'LevelSet_QuestionMetadata';
  /** The course name where the question comes from */
  courseName?: Maybe<Scalars['String']>;
  /** The name of the partner that owns the course containing the question */
  partnerNames?: Maybe<Scalars['String']>;
};

/** The response object for questions per questionType */
export type LevelSet_QuestionResponse = {
  /** The ID of the question being answered. */
  questionId: Scalars['ID'];
  /** The type of question being responded to. */
  questionType: LevelSet_QuestionType;
  /** The version of the question being answered. */
  questionVersion: Scalars['Int'];
  /** The response object for questions per questionType */
  response?: InputMaybe<Scalars['JSON']>;
};

/** The enum of question types. */
export const LevelSet_QuestionType = {
  /** A checkbox question. */
  Checkbox: 'CHECKBOX',
  /** A multiple choice question. */
  MultipleChoice: 'MULTIPLE_CHOICE'
} as const;

export type LevelSet_QuestionType = typeof LevelSet_QuestionType[keyof typeof LevelSet_QuestionType];
/** Skill details of the LevelSet */
export type LevelSet_Skill = {
  __typename?: 'LevelSet_Skill';
  /** Domains for the skill. */
  domains: Array<LevelSet_SkillDomain>;
  /** Skill id. */
  id: Scalars['ID'];
  /** User-friendly skill name. */
  skillName: Scalars['String'];
};

/** Skill domain of the LevelSet */
export type LevelSet_SkillDomain = {
  __typename?: 'LevelSet_SkillDomain';
  /** User-friendly domain name. */
  domainName: Scalars['String'];
  /** Domain id of a skill. */
  id: Scalars['ID'];
};

/** Skill mastery level object. */
export type LevelSet_SkillMasteryLevel = {
  __typename?: 'LevelSet_SkillMasteryLevel';
  /** The learner’s mastery level. */
  masteryLevel: LevelSet_MasteryLevel;
  /**
   * How far along the user is to mastering the given skill-mastery
   * (from 0 to 1).
   */
  masteryPercent: Scalars['Float'];
  /**
   * Likelihood that the learner will answer the next question pertaining to
   * the given skill-mastery correctly.
   */
  nextQuestionCorrectLikelihood: Scalars['Float'];
  /** The last time this skill mastery level was updated. */
  updatedAt: Scalars['DateTime'];
};

/** Input type for starting a new LevelSet attempt. */
export type LevelSet_StartAttemptInput = {
  /** The ID of the program in which the assessment is conducted. */
  programId?: InputMaybe<Scalars['ID']>;
  /** The ID of the skill being assessed. */
  skillId: Scalars['ID'];
};

/** Type definition for LevelSetAttemptsV2, representing user attempts at skill assessments within a specific program. */
export type LevelSet_StartAttemptResult = {
  __typename?: 'LevelSet_StartAttemptResult';
  /** The unique identifier for the attempt. */
  attemptId: Scalars['ID'];
  /** Questions to be answered in the attempt. */
  questions: Array<LevelSet_Question>;
};

/** Represents a LevelSet state */
export type LevelSet_State = Node & {
  __typename?: 'LevelSet_State';
  /** LevelSet id, the same as the skill id */
  id: Scalars['ID'];
  /** LevelSet progress of the requester */
  progress: LevelSet_UserProgress;
  /** Skill details of the LevelSet */
  skill: LevelSet_Skill;
};

/** Represents a paginated collection of LevelSet states */
export type LevelSet_StateConnection = {
  __typename?: 'LevelSet_StateConnection';
  /** The paginated collection */
  edges: Array<LevelSet_StateEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** Represents a LevelSet state with its pagination cursor */
export type LevelSet_StateEdge = {
  __typename?: 'LevelSet_StateEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** The LevelSet state */
  node: LevelSet_State;
};

/** Input type for ending an existing LevelSet attempt. */
export type LevelSet_SubmitAttemptInput = {
  /** The ID of the attempt being ended. */
  attemptId: Scalars['ID'];
  /** Json strings of serialized question responses. */
  questions: Array<LevelSet_QuestionResponse>;
  /** The ID of the skill being assessed. */
  skillId: Scalars['ID'];
};

/** Type definition for LevelSetAttemptsV2, representing user attempts at skill assessments within a specific program. */
export type LevelSet_SubmitAttemptResult = {
  __typename?: 'LevelSet_SubmitAttemptResult';
  /** The unique identifier for the attempt. */
  attemptId: Scalars['ID'];
  /** The feedback of the attempt. */
  feedback: LevelSet_AttemptFeedback;
  /** The mastery level results for the skill from skills evaluation */
  masteryLevelResults: LevelSet_SkillMasteryLevel;
  /** The skill id. */
  skillId: Scalars['ID'];
};

/** User progress of the LevelSet */
export type LevelSet_UserProgress = {
  __typename?: 'LevelSet_UserProgress';
  /** Number of the LevelSet attempts left. */
  attemptsLeft?: Maybe<Scalars['Int']>;
  /** LevelSet id. */
  id: Scalars['ID'];
  /** User progress status of the LevelSet. */
  status: LevelSet_UserProgressStatus;
  /** Number of the total LevelSet attempts. */
  totalAttempts?: Maybe<Scalars['Int']>;
};

/** User progress status of a LevelSet */
export const LevelSet_UserProgressStatus = {
  /** A user has completed a LevelSet. */
  Completed: 'COMPLETED',
  /** A user is working on a LevelSet and hasn't submitted it yet. */
  InProgress: 'IN_PROGRESS',
  /** A user hasn't started on a LevelSet. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LevelSet_UserProgressStatus = typeof LevelSet_UserProgressStatus[keyof typeof LevelSet_UserProgressStatus];
/** Root queries for event-related operations */
export type LexExperimentEventsQueries = {
  __typename?: 'LexExperimentEventsQueries';
  /**
   * Query for an event by it's event type (and optional course ID).
   * User id will be taken from the request context.
   */
  queryByEventType?: Maybe<LexExperimentEvents_Event>;
};


/** Root queries for event-related operations */
export type LexExperimentEventsQueriesQueryByEventTypeArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  eventType: LexExperimentEvents_EventType;
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** LexExperimentEvents_CreateEvent Mutation Error */
export type LexExperimentEvents_CreateError = Error & {
  __typename?: 'LexExperimentEvents_CreateError';
  /** Error message */
  message: Scalars['String'];
};

/** The input for the LexExperimentEvents_CreateEvent mutation */
export type LexExperimentEvents_CreateEventInput = {
  /** Course ID of the the event type. Empty if the event is course-agnostic. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The type of the event to create */
  eventType: LexExperimentEvents_EventType;
  /** Specialization ID of the event type. If provided, the event will be associated with a specialization instead of a course. */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** The result type of creating an event */
export type LexExperimentEvents_CreateEventResult = LexExperimentEvents_CreateFailure | LexExperimentEvents_CreateSuccess;

/** The response on failure to create an event */
export type LexExperimentEvents_CreateFailure = {
  __typename?: 'LexExperimentEvents_CreateFailure';
  /** Errors */
  errors: Array<LexExperimentEvents_CreateError>;
};

/** This is returned if the LexExperimentEvents_CreateEvent mutation succeeds. */
export type LexExperimentEvents_CreateSuccess = {
  __typename?: 'LexExperimentEvents_CreateSuccess';
  /** The created event */
  event: LexExperimentEvents_Event;
};

/** LexExperimentEvents_DeleteEvent Mutation Error */
export type LexExperimentEvents_DeleteError = Error & {
  __typename?: 'LexExperimentEvents_DeleteError';
  /** Error message */
  message: Scalars['String'];
};

/** The input for the LexExperimentEvents_DeleteEvent mutation */
export type LexExperimentEvents_DeleteEventInput = {
  /** Course ID of the the event type. Empty if the event is course-agnostic. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The type of the event to delete */
  eventType: LexExperimentEvents_EventType;
  /** The user id for whom the event will be deleted */
  userId: Scalars['ID'];
};

/** The result type of deleting an event */
export type LexExperimentEvents_DeleteEventResult = LexExperimentEvents_DeleteFailure | LexExperimentEvents_DeleteSuccess;

/** The response on failure to delete an event */
export type LexExperimentEvents_DeleteFailure = {
  __typename?: 'LexExperimentEvents_DeleteFailure';
  /** Errors */
  errors: Array<LexExperimentEvents_DeleteError>;
};

/** This is returned if the LexExperimentEvents_DeleteEvent mutation succeeds. */
export type LexExperimentEvents_DeleteSuccess = {
  __typename?: 'LexExperimentEvents_DeleteSuccess';
  /** A flag indicating whether the deletion was successful or not */
  success: Scalars['Boolean'];
};

/** The Event object */
export type LexExperimentEvents_Event = {
  __typename?: 'LexExperimentEvents_Event';
  /** The timestamp reflecting when the event was created */
  createdAt: Scalars['DateTime'];
  /** The type of the event, represented by an enum */
  eventType: LexExperimentEvents_EventType;
  /** The unique identifier of the event */
  id: Scalars['ID'];
};

/** Enum for event type options */
export const LexExperimentEvents_EventType = {
  /** The event for when the weekly streaks backfilled dialog on the logged-in homepage is seen. */
  BackfilledWeeklyStreakModalSeen: 'BACKFILLED_WEEKLY_STREAK_MODAL_SEEN',
  /** The event for when the learner sees the day one onboarding modal. */
  DayOneOnboardingModalSeen: 'DAY_ONE_ONBOARDING_MODAL_SEEN',
  /** The event for when the learner sees the macro goals education modal. */
  MacroGoalsEducationModalSeen: 'MACRO_GOALS_EDUCATION_MODAL_SEEN',
  /** The event for when the learner interacted with the personalized coach welcome experience. */
  PersonalizedCoachWelcomeInteracted: 'PERSONALIZED_COACH_WELCOME_INTERACTED',
  /** The event for when the learner returns to Coursera for the first time. */
  ReturnToCourseraSeen: 'RETURN_TO_COURSERA_SEEN',
  /** The event for when the learner shares their certificate, primarily used for goal generation purposes */
  ShareCertificateButtonClicked: 'SHARE_CERTIFICATE_BUTTON_CLICKED',
  /** The event for when the learner sees the skills intro modal for the first time after completing an item. */
  SkillPointsIntroSeen: 'SKILL_POINTS_INTRO_SEEN',
  /** The event for when the learner visits a course that is tagged with skill XP. */
  SkillXpTaggedCourseVisited: 'SKILL_XP_TAGGED_COURSE_VISITED',
  /** The event for when the learner starts their first course. */
  StartsCourseSeen: 'STARTS_COURSE_SEEN',
  /** The event for when the learner unlocks their daily goal trends. */
  TrackDailyGoalsTrendsSeen: 'TRACK_DAILY_GOALS_TRENDS_SEEN'
} as const;

export type LexExperimentEvents_EventType = typeof LexExperimentEvents_EventType[keyof typeof LexExperimentEvents_EventType];
/** Root queries for learner statistics and analytics operations */
export type LexExperimentLearnerStatsQueries = {
  __typename?: 'LexExperimentLearnerStatsQueries';
  /** Get comprehensive statistics for a learner */
  getLearnerStats: LexExperimentLearnerStats_Stats;
};

/** Daily activity statistics for a learner */
export type LexExperimentLearnerStats_DayStats = {
  __typename?: 'LexExperimentLearnerStats_DayStats';
  /** The date of activity */
  date: Scalars['DateTime'];
  /** Number of items completed on this day */
  numberOfItemsCompleted: Scalars['Int'];
};

/** Comprehensive learner statistics */
export type LexExperimentLearnerStats_Stats = {
  __typename?: 'LexExperimentLearnerStats_Stats';
  /**
   * 4 weeks of activity. Only days with activity will be returned, otherwise learner completed 0
   * items that day
   */
  activeDays?: Maybe<Array<LexExperimentLearnerStats_DayStats>>;
  /** Total days user was active on coursera for all time */
  allTimeActiveDays: Scalars['Int'];
  /** Current week stats */
  currentWeekStats: LexExperimentLearnerStats_WeekStats;
  /** Number of minutes spent learning in the last 4 weeks */
  minutesLearnedLastMonth: Scalars['Float'];
  /** Total number of items (videos, readings, quizzes) completed */
  totalItemsCompleted: Scalars['Int'];
  /** Total learning hours across all courses (24 hours out of date) */
  totalLearningMinutes: Scalars['Float'];
  /** How many weeks they've come to coursera in a row */
  weeklyStreak: Scalars['Int'];
};

/** Weekly statistics for a learner */
export type LexExperimentLearnerStats_WeekStats = {
  __typename?: 'LexExperimentLearnerStats_WeekStats';
  /**
   * Difference in items completed compared to last week (can be negative). Null if this is the
   * learners first week
   */
  differenceItemsCompletedLastWeek?: Maybe<Scalars['Int']>;
  /**
   * Difference in minutes learned compared to last week (can be negative). Null if this is the
   * learners first week
   */
  differenceMinutesLearnedLastWeek?: Maybe<Scalars['Int']>;
  /** Number of items completed this week */
  itemsCompleted: Scalars['Int'];
  /** Minutes spent learning this week */
  minutesLearned: Scalars['Int'];
};

export type LinkedAtomInfoV1 = {
  __typename?: 'LinkedAtomInfoV1';
  atomIdToLinkInfoMap: Scalars['JSON'];
  branchId: Scalars['String'];
  id: Scalars['String'];
};

export type LinkedAtomInfoV1Connection = {
  __typename?: 'LinkedAtomInfoV1Connection';
  elements: Array<Maybe<LinkedAtomInfoV1>>;
  paging: ResponsePagination;
};

export type LinkedAtomInfoV1FindLinkedAtomsByBranchId = {
  __typename?: 'LinkedAtomInfoV1FindLinkedAtomsByBranchId';
  branchId: Scalars['String'];
  connection?: Maybe<LinkedAtomInfoV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type LinkedAtomInfoV1Resource = {
  __typename?: 'LinkedAtomInfoV1Resource';
  findLinkedAtomsByBranchId?: Maybe<LinkedAtomInfoV1Connection>;
};


export type LinkedAtomInfoV1ResourceFindLinkedAtomsByBranchIdArgs = {
  branchId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Request input for creating experiment configuration. */
export type Localization_CreateExperimentConfigurationInput = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** Configuration fields and values that will be used by the localization-application self-serve A/B system to find the correct EPIC exp parameter to use. */
  experimentConfiguration: Localization_ExperimentConfiguration;
};

/** Result of creating experiment configuration. */
export type Localization_CreateExperimentConfigurationResult = {
  __typename?: 'Localization_CreateExperimentConfigurationResult';
  /** Epic experiment parameter name. */
  epicParamName: Scalars['String'];
};

/**
 * Request input for creating a Statsig experiment. The BE supplies the rest (Statsig team, ID
 * type, display name, auto-generated hypothesis with the localization-system marker).
 */
export type Localization_CreateStatsigExperimentInput = {
  /** This is the reference to the Contentful content type https://app.contentful.com/spaces/wp1lcwdav1p1/content_types/. */
  contentType: Scalars['String'];
  /** Configuration fields and values used to derive the Statsig layer name. Same fields as `Localization_CreateExperimentConfiguration`, but encoded as the layer name (lowercased, `_`-delimited per Statsig's `[a-z0-9_-]` rule). */
  experimentConfiguration: Localization_ExperimentConfiguration;
  /** Ordered list of variant names. Group sizes auto-balance to 100 / N. Each variant becomes a Statsig group whose `parameterValues.variant` equals the variant name. */
  variants: Array<Scalars['String']>;
};

/** Result of creating a Statsig experiment. */
export type Localization_CreateStatsigExperimentResult = {
  __typename?: 'Localization_CreateStatsigExperimentResult';
  /** Statsig experiment ID returned by the Console API. */
  experimentId: Scalars['ID'];
  /** Statsig layer ID created to host the experiment's variant parameter. */
  layerId: Scalars['ID'];
  /** The Statsig layer name derived from contentType + experimentConfiguration (lowercased, `_`-delimited per Statsig's `[a-z0-9_-]` rule); the Statsig read path resolves the variant against it at runtime. Differs from `Localization_CreateExperimentConfiguration`, which returns the legacy EPIC parameter name (`~`-delimited, case-preserving). */
  parameterName: Scalars['String'];
};

/** Experiment configuration variables. */
export type Localization_ExperimentConfiguration = {
  /** List of configuration entries. */
  variables: Array<Localization_ExperimentConfigurationInputEntry>;
};

/** Experiment configuration entry. */
export type Localization_ExperimentConfigurationInputEntry = {
  /** configuration field key. */
  key: Scalars['String'];
  /** configuration field value. */
  value: Scalars['String'];
};

/** Related Entity Types - Should only have federated types */
export type Localization_RelatedEntity = Collection_Collection | Course_Course | ProductCard_ProductCard | Specialization_Specialization;

/** List of Localization_RelatedEntity grouped by key */
export type Localization_RelatedEntityGroup = {
  __typename?: 'Localization_RelatedEntityGroup';
  /** list of related entity */
  entities: Array<Maybe<Localization_RelatedEntity>>;
  /** Group key identifier */
  key: Scalars['String'];
};

/** Read-side lifecycle status of a Statsig experiment, mirroring the Statsig Console API's status vocabulary. Distinct from `Localization_StatsigExperimentStatus`, which lists only the transitions `Localization_UpdateStatsigExperiment` accepts. */
export const Localization_StatsigExperimentLifecycleStatus = {
  /** Stopped without a decision. */
  Abandoned: 'ABANDONED',
  /** Live: traffic is being allocated to the experiment's variants. */
  Active: 'ACTIVE',
  /** Archived in the Statsig console. */
  Archived: 'ARCHIVED',
  /** Group assignment was stopped. */
  AssignmentStopped: 'ASSIGNMENT_STOPPED',
  /** Stopped with a decision recorded. */
  DecisionMade: 'DECISION_MADE',
  /** The experiment was stopped. */
  ExperimentStopped: 'EXPERIMENT_STOPPED',
  /** Created but not yet started; no traffic is being allocated. */
  Setup: 'SETUP',
  /** Fallback for status values Statsig adds that this schema does not know yet. Clients should render these neutrally rather than failing. */
  Unknown: 'UNKNOWN'
} as const;

export type Localization_StatsigExperimentLifecycleStatus = typeof Localization_StatsigExperimentLifecycleStatus[keyof typeof Localization_StatsigExperimentLifecycleStatus];
/** Lifecycle status of a Statsig experiment. */
export const Localization_StatsigExperimentStatus = {
  /** Stopped with a decision recorded. */
  DecisionMade: 'DECISION_MADE',
  /** Live: traffic is being allocated to the experiment's variants. */
  Running: 'RUNNING',
  /** Created but not yet started; no traffic is being allocated. */
  Setup: 'SETUP'
} as const;

export type Localization_StatsigExperimentStatus = typeof Localization_StatsigExperimentStatus[keyof typeof Localization_StatsigExperimentStatus];
/** Summary of one self-serve Statsig experiment, as reported by the Statsig Console API list endpoint. */
export type Localization_StatsigExperimentSummary = {
  __typename?: 'Localization_StatsigExperimentSummary';
  /** When the experiment was created in Statsig. */
  createdAt: Scalars['DateTime'];
  /** Statsig experiment ID — what `Localization_UpdateStatsigExperiment` takes. Statsig derives it from the experiment's name at creation, and the self-serve flow names experiments after their layer, so this equals the layer name derived from contentType + experimentConfiguration (lowercased, `_`-delimited per Statsig's `[a-z0-9_-]` rule). */
  id: Scalars['ID'];
  /** Lifecycle status as reported by Statsig. Wider than `Localization_StatsigExperimentStatus` (the transitions the update mutation accepts) because statuses can also be applied in the Statsig console, e.g. archiving. */
  status: Localization_StatsigExperimentLifecycleStatus;
  /** Variant names in group order (e.g. `["control", "treatment"]`). */
  variants: Array<Scalars['String']>;
};

/** Paginated self-serve Statsig experiment summaries. */
export type Localization_StatsigExperimentSummaryPaginatedResult = {
  __typename?: 'Localization_StatsigExperimentSummaryPaginatedResult';
  /** Experiments on this page, newest first. */
  elements: Array<Localization_StatsigExperimentSummary>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Request input for updating a Statsig experiment. */
export type Localization_UpdateStatsigExperimentInput = {
  /** Statsig experiment ID to update. */
  experimentId: Scalars['ID'];
  /** Optional status transition. Omit to leave unchanged. */
  status?: InputMaybe<Localization_StatsigExperimentStatus>;
  /** Optional replacement variant list. Omit to leave the existing groups unchanged. When provided, group sizes auto-balance to 100 / N. */
  variants?: InputMaybe<Array<Scalars['String']>>;
};

/** Result of updating a Statsig experiment. */
export type Localization_UpdateStatsigExperimentResult = {
  __typename?: 'Localization_UpdateStatsigExperimentResult';
  /** Statsig experiment ID that was updated. */
  experimentId: Scalars['ID'];
};

/** localized data response from Contentful localized query. */
export type LocalizedDataPayload = {
  __typename?: 'LocalizedDataPayload';
  /**
   * This is the stringified Contentful response.
   * @deprecated Use contentDataJson instead.
   */
  contentData: Scalars['String'];
  /** This is the Contentful response as JSON. */
  contentDataJson: Scalars['JSON'];
  /**
   * This is a unique id for that query and the variables, it is used by Apollo to cache the response.
   * It is generated by the backend since we want to cache the response based on the variables used to query contentful, these variables can be different than the ones sent by the client.
   */
  id: Scalars['String'];
  /** Entities related to the Localized Data that are fetchable via federation */
  relatedEntities: Array<Localization_RelatedEntityGroup>;
};

/** Localized data queries. */
export type LocalizedDataQueries = {
  __typename?: 'LocalizedDataQueries';
  /** This query returns the localized data. */
  getLocalizedData?: Maybe<LocalizedDataPayload>;
  /** This query returns the contentful data from the correct variant. */
  getVariantContent?: Maybe<LocalizedDataPayload>;
};


/** Localized data queries. */
export type LocalizedDataQueriesGetLocalizedDataArgs = {
  contentfulRequest: ContentfulRequestInput;
};


/** Localized data queries. */
export type LocalizedDataQueriesGetVariantContentArgs = {
  contentType: Scalars['String'];
  contentfulSpace?: InputMaybe<Scalars['String']>;
  epicNamespace?: Scalars['String'];
  experimentConfiguration: Localization_ExperimentConfiguration;
  isPreview: Scalars['Boolean'];
  query: Scalars['String'];
};

/** Type of identifier used to identify the learner */
export const LockingBrowser_ExclusionIdentifierType = {
  /** The learner's primary email */
  Email: 'EMAIL',
  /** The external id of a user */
  ExternalId: 'EXTERNAL_ID'
} as const;

export type LockingBrowser_ExclusionIdentifierType = typeof LockingBrowser_ExclusionIdentifierType[keyof typeof LockingBrowser_ExclusionIdentifierType];
/** Operation to apply to the exclusion */
export const LockingBrowser_ExclusionOperation = {
  /** Add the learner to the exclusion list */
  Add: 'ADD',
  /** Remove the learner from the exclusion list */
  Remove: 'REMOVE'
} as const;

export type LockingBrowser_ExclusionOperation = typeof LockingBrowser_ExclusionOperation[keyof typeof LockingBrowser_ExclusionOperation];
/** Exclusion update to apply to an assessment's locking browser requirement */
export type LockingBrowser_ExclusionUpdate = {
  /** The identifier of the learner for whom we're updating the exclusion */
  learnerIdentifier: Scalars['String'];
  /** The type of identifier used to identify the learner */
  learnerIdentifierType: LockingBrowser_ExclusionIdentifierType;
  /** The operation to apply to the exclusion */
  operation: LockingBrowser_ExclusionOperation;
};

/** Session data which will be used to determine if this is a private or public session */
export type LockingBrowser_SessionInput = {
  /** Is this a private or public session? */
  isPrivate: Scalars['Boolean'];
  /** The session for this assessment */
  sessionId: Scalars['ID'];
};

/** Exclusion updates to apply to an assessment's locking browser requirement */
export type LockingBrowser_UpdateExclusionsInput = {
  /** The assessment ID without the version */
  assessmentId: Scalars['ID'];
  /**
   * The course for this session and assessment
   * Optional for backwards compatibility, but required for public sessions
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The updates to be applied to the assessment's exclusions */
  exclusionUpdates: Array<LockingBrowser_ExclusionUpdate>;
  /**
   * The session for this assessment
   * Optional for backwards compatibility
   */
  session?: InputMaybe<LockingBrowser_SessionInput>;
  /**
   * The session for this assessment
   * @deprecated Use session instead
   */
  sessionId?: InputMaybe<Scalars['ID']>;
};

/**
 * Result of updating the exclusions, this will return all
 * exclusions, not just the updated ones.
 */
export type LockingBrowser_UpdateExclusionsResult = {
  __typename?: 'LockingBrowser_UpdateExclusionsResult';
  /** All exclusions for the assessment */
  exclusions: Array<Integrity_LockingBrowserExclusion>;
};

/** Settings to update for the given assessment/session */
export type LockingBrowser_UpdateSettingsInput = {
  /** The assessment ID without the version */
  assessmentId: Scalars['ID'];
  /**
   * The course for this session and assessment
   * Optional for backwards compatibility, but required for public sessions
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Whether or not the Locking browser should be enabled */
  enabled: Scalars['Boolean'];
  /**
   * The session for this assessment
   * Optional for backwards compatibility
   */
  session?: InputMaybe<LockingBrowser_SessionInput>;
  /**
   * The session for this assessment
   * @deprecated Use session instead
   */
  sessionId?: InputMaybe<Scalars['ID']>;
};

/** Result of updating the settings */
export type LockingBrowser_UpdateSettingsResult = {
  __typename?: 'LockingBrowser_UpdateSettingsResult';
  /** The updated locking browser settings */
  settings: Integrity_LockingBrowserSettings;
};

/** Fetch data for LoggedIn home page stackability */
export type LoggedInHomePageStackabilityQueries = {
  __typename?: 'LoggedInHomePageStackabilityQueries';
  /**
   * Returns a list of degrees, with the specializations that the learner is enrolled in, and that
   * the degree is upsold from
   */
  getDegreeUpsellsForEnrolledSpecializations: LoggedInHomePageStackability_DegreeUpsellsAndEnrolledSpecializations;
};


/** Fetch data for LoggedIn home page stackability */
export type LoggedInHomePageStackabilityQueriesGetDegreeUpsellsForEnrolledSpecializationsArgs = {
  relation: LoggedInHomePageStackability_UpsellRelationType;
};

/** API response that includes: 1. degrees with s12n upsells. 2. a list of enrolled s12ns */
export type LoggedInHomePageStackability_DegreeUpsellsAndEnrolledSpecializations = {
  __typename?: 'LoggedInHomePageStackability_DegreeUpsellsAndEnrolledSpecializations';
  /**
   * A degree with a list of specializations to be displayed on the upsell card. Degrees sorted by
   * recommendations, s12ns sorted by enrollment time.
   */
  degreeWithUpsells: Array<LoggedInHomePageStackability_DegreeWithUpsells>;
  /**
   * The enrolled s12ns, which is an aggregation of all the s12ns in degreeWithUpsells sorted by
   * enrollment time.
   */
  enrolledSpecializations: Array<Specialization_Specialization>;
};

/** A degree with a list of specializations to be displayed on the upsell card. */
export type LoggedInHomePageStackability_DegreeWithUpsells = {
  __typename?: 'LoggedInHomePageStackability_DegreeWithUpsells';
  /** The upsell target, with federated fields */
  degree: Degree_Degree;
  /** The list of specialization upsells that the user enrolled in, and that are upselling to the degree */
  specializationsUpsells: Array<Specialization_Specialization>;
};

/** Upsell relation types */
export const LoggedInHomePageStackability_UpsellRelationType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type LoggedInHomePageStackability_UpsellRelationType = typeof LoggedInHomePageStackability_UpsellRelationType[keyof typeof LoggedInHomePageStackability_UpsellRelationType];
export type LoggedInHomeS12nModalV1 = {
  __typename?: 'LoggedInHomeS12nModalV1';
  badgeType?: Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType>;
  courseCards: Array<Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeMiniCourseCard>>;
  coursesEnrolledCount: Scalars['Int'];
  dropdownOptions?: Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalDropdownOptions>;
  id: Scalars['String'];
  isS12nComplete: Scalars['Boolean'];
  name: Scalars['String'];
  partners: Array<Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_PartnerInfoForLoggedInHomeComponent>>;
  primaryButtonCtaType?: Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType>;
  s12nId: Scalars['String'];
  userId: Scalars['Int'];
};

export type LoggedInHomeS12nModalV1Connection = {
  __typename?: 'LoggedInHomeS12nModalV1Connection';
  elements: Array<Maybe<LoggedInHomeS12nModalV1>>;
  paging: ResponsePagination;
};

export type LoggedInHomeS12nModalV1Resource = {
  __typename?: 'LoggedInHomeS12nModalV1Resource';
  get?: Maybe<LoggedInHomeS12nModalV1>;
  multiGet?: Maybe<LoggedInHomeS12nModalV1Connection>;
};


export type LoggedInHomeS12nModalV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type LoggedInHomeS12nModalV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = {
  GoToCourse: 'GO_TO_COURSE',
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  NoButton: 'NO_BUTTON',
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  ResetDeadlines: 'RESET_DEADLINES',
  StartCourse: 'START_COURSE',
  SwitchSessions: 'SWITCH_SESSIONS',
  VerifyId: 'VERIFY_ID',
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType];
export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeDropdownOptions = {
  __typename?: 'LoggedInHomeS12nModalV1_org_coursera_catalogp_loggedinhome_LoggedInHomeDropdownOptions';
  shouldShowCourseraPlusUnenrollOption: Scalars['Boolean'];
  shouldShowRateCourseOption: Scalars['Boolean'];
  shouldShowResetDeadlineOption: Scalars['Boolean'];
  shouldShowSessionSwitchOption: Scalars['Boolean'];
  shouldShowUnenrollOption: Scalars['Boolean'];
};

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeMiniCourseCard = {
  __typename?: 'LoggedInHomeS12nModalV1_org_coursera_catalogp_loggedinhome_LoggedInHomeMiniCourseCard';
  dropdownOptions?: Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeDropdownOptions>;
  id: Scalars['String'];
  isCurrentlyEnrolled: Scalars['Boolean'];
  isLockedCapstone: Scalars['Boolean'];
  name: Scalars['String'];
  primaryButtonCtaType: LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType;
  secondaryCtaType?: Maybe<LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType = {
  Subscribed: 'SUBSCRIBED'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalBadgeType];
export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType = {
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalButtonCtaType];
export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalDropdownOptions = {
  __typename?: 'LoggedInHomeS12nModalV1_org_coursera_catalogp_loggedinhome_LoggedInHomeS12nModalDropdownOptions';
  shouldShowCancelSubscriptionOption: Scalars['Boolean'];
  shouldShowUnenrollFromS12nOption: Scalars['Boolean'];
};

export const LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType = {
  ResetDeadlines: 'RESET_DEADLINES',
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType = typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType[keyof typeof LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeS12nModalSecondaryCtaType];
/** Model for returning partner info to Course Cards and S12n Modals */
export type LoggedInHomeS12nModalV1_Org_Coursera_Catalogp_Loggedinhome_PartnerInfoForLoggedInHomeComponent = {
  __typename?: 'LoggedInHomeS12nModalV1_org_coursera_catalogp_loggedinhome_PartnerInfoForLoggedInHomeComponent';
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LoggedInHomeV1 = {
  __typename?: 'LoggedInHomeV1';
  courseCards: Array<Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCard>>;
  courseCardsResponsePagination: LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseCardsResponsePagination;
  id: Scalars['String'];
  loggedInHomeTab: LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab;
  notificationMessage?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage>;
  topBanner?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTopBanner>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type LoggedInHomeV1Connection = {
  __typename?: 'LoggedInHomeV1Connection';
  elements: Array<Maybe<LoggedInHomeV1>>;
  paging: ResponsePagination;
};

export type LoggedInHomeV1Resource = {
  __typename?: 'LoggedInHomeV1Resource';
  get?: Maybe<LoggedInHomeV1>;
  multiGet?: Maybe<LoggedInHomeV1Connection>;
};


export type LoggedInHomeV1ResourceGetArgs = {
  courseCardsLimit?: InputMaybe<Scalars['Int']>;
  courseCardsStart?: InputMaybe<Scalars['Int']>;
  debugCourseOrS12nIdsWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enableDebugLogging?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type LoggedInHomeV1ResourceMultiGetArgs = {
  courseCardsLimit?: InputMaybe<Scalars['Int']>;
  courseCardsStart?: InputMaybe<Scalars['Int']>;
  debugCourseOrS12nIdsWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enableDebugLogging?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type LoggedInHomeV1_AssessOpenSinglePageMember = {
  __typename?: 'LoggedInHomeV1_assessOpenSinglePageMember';
  assessOpenSinglePage: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type LoggedInHomeV1_ClosedPeerMember = {
  __typename?: 'LoggedInHomeV1_closedPeerMember';
  closedPeer: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type LoggedInHomeV1_CmlMember = {
  __typename?: 'LoggedInHomeV1_cmlMember';
  cml: LoggedInHomeV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type LoggedInHomeV1_CompoundLatePenaltyMember = {
  __typename?: 'LoggedInHomeV1_compoundLatePenaltyMember';
  compoundLatePenalty: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type LoggedInHomeV1_CompoundLatePenaltyRatioMember = {
  __typename?: 'LoggedInHomeV1_compoundLatePenaltyRatioMember';
  compoundLatePenaltyRatio: LoggedInHomeV1_Org_Coursera_Grading_CompoundLatePenaltyRatio;
};

export type LoggedInHomeV1_ContentSummary = LoggedInHomeV1_AssessOpenSinglePageMember | LoggedInHomeV1_ClosedPeerMember | LoggedInHomeV1_DiscussionPromptMember | LoggedInHomeV1_ExamMember | LoggedInHomeV1_GradedDiscussionPromptMember | LoggedInHomeV1_GradedLtiMember | LoggedInHomeV1_GradedPeerMember | LoggedInHomeV1_GradedProgrammingMember | LoggedInHomeV1_GradedWidgetMember | LoggedInHomeV1_LectureMember | LoggedInHomeV1_NotebookMember | LoggedInHomeV1_PeerMember | LoggedInHomeV1_PhasedPeerMember | LoggedInHomeV1_PlaceholderMember | LoggedInHomeV1_ProgrammingMember | LoggedInHomeV1_QuizMember | LoggedInHomeV1_SingleQuestionSubmitMember | LoggedInHomeV1_SlideshowMember | LoggedInHomeV1_StaffGradedMember | LoggedInHomeV1_SupplementMember | LoggedInHomeV1_TeammateReviewMember | LoggedInHomeV1_UngradedAssignmentMember | LoggedInHomeV1_UngradedLabMember | LoggedInHomeV1_UngradedLtiMember | LoggedInHomeV1_UngradedProgrammingMember | LoggedInHomeV1_UngradedWidgetMember | LoggedInHomeV1_WiseFlowMember | LoggedInHomeV1_WorkspaceLauncherMember;

export type LoggedInHomeV1_CourseCompletedNextStepMember = {
  __typename?: 'LoggedInHomeV1_courseCompletedNextStepMember';
  courseCompletedNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseCompletedNextStep;
};

export type LoggedInHomeV1_CourseMaterialNextStepMember = {
  __typename?: 'LoggedInHomeV1_courseMaterialNextStepMember';
  courseMaterialNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStep;
};

export type LoggedInHomeV1_CourseScheduleAdjustmentNextStepMember = {
  __typename?: 'LoggedInHomeV1_courseScheduleAdjustmentNextStepMember';
  courseScheduleAdjustmentNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseScheduleAdjustmentNextStep;
};

export type LoggedInHomeV1_DiscussionPromptMember = {
  __typename?: 'LoggedInHomeV1_discussionPromptMember';
  discussionPrompt: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type LoggedInHomeV1_ExamMember = {
  __typename?: 'LoggedInHomeV1_examMember';
  exam: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type LoggedInHomeV1_FixedGradingLatePenaltyMember = {
  __typename?: 'LoggedInHomeV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type LoggedInHomeV1_FixedLatePenaltyRatioMember = {
  __typename?: 'LoggedInHomeV1_fixedLatePenaltyRatioMember';
  fixedLatePenaltyRatio: LoggedInHomeV1_Org_Coursera_Grading_FixedLatePenaltyRatio;
};

export type LoggedInHomeV1_GradedDiscussionPromptMember = {
  __typename?: 'LoggedInHomeV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type LoggedInHomeV1_GradedLtiMember = {
  __typename?: 'LoggedInHomeV1_gradedLtiMember';
  gradedLti: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type LoggedInHomeV1_GradedPeerMember = {
  __typename?: 'LoggedInHomeV1_gradedPeerMember';
  gradedPeer: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type LoggedInHomeV1_GradedProgrammingMember = {
  __typename?: 'LoggedInHomeV1_gradedProgrammingMember';
  gradedProgramming: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type LoggedInHomeV1_GradedWidgetMember = {
  __typename?: 'LoggedInHomeV1_gradedWidgetMember';
  gradedWidget: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type LoggedInHomeV1_GradingLatePenalty = LoggedInHomeV1_CompoundLatePenaltyMember | LoggedInHomeV1_FixedGradingLatePenaltyMember | LoggedInHomeV1_IncrementalGradingLatePenaltyMember;

export type LoggedInHomeV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'LoggedInHomeV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type LoggedInHomeV1_IncrementalLatePenaltyRatioMember = {
  __typename?: 'LoggedInHomeV1_incrementalLatePenaltyRatioMember';
  incrementalLatePenaltyRatio: LoggedInHomeV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio;
};

export type LoggedInHomeV1_LatePenaltyRatio = LoggedInHomeV1_CompoundLatePenaltyRatioMember | LoggedInHomeV1_FixedLatePenaltyRatioMember | LoggedInHomeV1_IncrementalLatePenaltyRatioMember;

export type LoggedInHomeV1_LectureMember = {
  __typename?: 'LoggedInHomeV1_lectureMember';
  lecture: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

export type LoggedInHomeV1_MultipleDeadlinesNextStepMember = {
  __typename?: 'LoggedInHomeV1_multipleDeadlinesNextStepMember';
  multipleDeadlinesNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_MultipleDeadlinesNextStep;
};

/** Recommended next step to take which can vary depending on the user's state within the course. */
export type LoggedInHomeV1_NextStep = LoggedInHomeV1_CourseCompletedNextStepMember | LoggedInHomeV1_CourseMaterialNextStepMember | LoggedInHomeV1_CourseScheduleAdjustmentNextStepMember | LoggedInHomeV1_MultipleDeadlinesNextStepMember | LoggedInHomeV1_NoActiveSessionNextStepMember | LoggedInHomeV1_NoAvailableNextStepFromErrorMember | LoggedInHomeV1_NoAvailableNextStepMember | LoggedInHomeV1_NoEnrollableSessionsNextStepMember | LoggedInHomeV1_NotEnoughPeerReviewsNextStepMember | LoggedInHomeV1_SessionEndedNextStepMember;

export type LoggedInHomeV1_NoActiveSessionNextStepMember = {
  __typename?: 'LoggedInHomeV1_noActiveSessionNextStepMember';
  noActiveSessionNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoActiveSessionNextStep;
};

export type LoggedInHomeV1_NoAvailableNextStepFromErrorMember = {
  __typename?: 'LoggedInHomeV1_noAvailableNextStepFromErrorMember';
  noAvailableNextStepFromError: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStepFromError;
};

export type LoggedInHomeV1_NoAvailableNextStepMember = {
  __typename?: 'LoggedInHomeV1_noAvailableNextStepMember';
  noAvailableNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStep;
};

export type LoggedInHomeV1_NoEnrollableSessionsNextStepMember = {
  __typename?: 'LoggedInHomeV1_noEnrollableSessionsNextStepMember';
  noEnrollableSessionsNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoEnrollableSessionsNextStep;
};

export type LoggedInHomeV1_NotEnoughPeerReviewsNextStepMember = {
  __typename?: 'LoggedInHomeV1_notEnoughPeerReviewsNextStepMember';
  notEnoughPeerReviewsNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NotEnoughPeerReviewsNextStep;
};

export type LoggedInHomeV1_NotebookMember = {
  __typename?: 'LoggedInHomeV1_notebookMember';
  notebook: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export const LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature = typeof LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature];
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseAssociatedS12nInfo = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_CourseAssociatedS12nInfo';
  courseProgressListInS12n: Array<Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_S12nCourseProgress>>;
  coursesCompletedCount?: Maybe<Scalars['Int']>;
  coursesEnrolledCount?: Maybe<Scalars['Int']>;
  isS12nComplete: Scalars['Boolean'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  nextS12nCourseSlug?: Maybe<Scalars['String']>;
  productVariant: Scalars['String'];
  s12nId: Scalars['String'];
  s12nName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  s12nSlug: Scalars['String'];
  shouldSeeS12nModal: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseCardsResponsePagination = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_CourseCardsResponsePagination';
  next?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

/** Computed course progress for learner. */
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseProgress = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_CourseProgress';
  /** Percentage @param value An Int[0,100] representing a percentage */
  courseProgressPercentage: Scalars['Int'];
  courseProgressState: Scalars['String'];
};

/** States are mutually exclusive. IN_PROGRESS: last activity in course is > 14d ago COMPLETED: self explanatory. OVERDUE: meets resetDeadline criteria where one deadline on the course is overdue by 14 days or multiple deadlines are overdue. */
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState = {
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS',
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState];
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCard = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_LoggedInHomeCourseCard';
  associatedS12nInfo?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseAssociatedS12nInfo>;
  certificateVerifyCode?: Maybe<Scalars['String']>;
  courseId: Scalars['String'];
  courseMetadata: LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseMetadata;
  courseName: Scalars['String'];
  courseProgress: LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_CourseProgress;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  courseSlug: Scalars['String'];
  dropdownOptions?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeDropdownOptions>;
  nextStep?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_GuidedCourseNextStepResponse>;
  partners: Array<Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_PartnerInfoForLoggedInHomeComponent>>;
  userCourseState?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeUserCourseDerivedState>;
};

export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = {
  GoToCourse: 'GO_TO_COURSE',
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  NoButton: 'NO_BUTTON',
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  ResetDeadlines: 'RESET_DEADLINES',
  StartCourse: 'START_COURSE',
  SwitchSessions: 'SWITCH_SESSIONS',
  VerifyId: 'VERIFY_ID',
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType = {
  RateCourse: 'RATE_COURSE',
  ResetDeadlines: 'RESET_DEADLINES',
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType];
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_LoggedInHomeCourseMetadata';
  courseType: LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType;
  photoUrl?: Maybe<Scalars['String']>;
};

export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType = {
  Project: 'PROJECT',
  RhymeProject: 'RHYME_PROJECT',
  ShortFormContent: 'SHORT_FORM_CONTENT',
  StandardCourse: 'STANDARD_COURSE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseTypeMetadataCourseType];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState = {
  NoUpsell: 'NO_UPSELL',
  UpsellForCertificate: 'UPSELL_FOR_CERTIFICATE',
  UpsellFromAudit: 'UPSELL_FROM_AUDIT'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState];
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeDropdownOptions = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_LoggedInHomeDropdownOptions';
  shouldShowCourseraPlusUnenrollOption: Scalars['Boolean'];
  shouldShowRateCourseOption: Scalars['Boolean'];
  shouldShowResetDeadlineOption: Scalars['Boolean'];
  shouldShowSessionSwitchOption: Scalars['Boolean'];
  shouldShowUnenrollOption: Scalars['Boolean'];
};

export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage = {
  InactiveUserNotificationMessage: 'INACTIVE_USER_NOTIFICATION_MESSAGE',
  NewUserNotificationMessage: 'NEW_USER_NOTIFICATION_MESSAGE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeNotificationMessage];
export const LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab = {
  Completed: 'COMPLETED',
  Home: 'HOME',
  InProgress: 'IN_PROGRESS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab = typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab[keyof typeof LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTab];
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeTopBanner = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_LoggedInHomeTopBanner';
  text: LoggedInHomeV1_Text;
};

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeUserCourseDerivedState = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_LoggedInHomeUserCourseDerivedState';
  activityState?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseActivityDerivedState>;
  primaryButtonCtaType?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardButtonCtaType>;
  secondaryCtaType?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseCardSecondaryCtaType>;
  upsellState?: Maybe<LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_LoggedInHomeCourseUpsellDerivedState>;
};

/** Model for returning partner info to Course Cards and S12n Modals */
export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_PartnerInfoForLoggedInHomeComponent = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_PartnerInfoForLoggedInHomeComponent';
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Catalogp_Loggedinhome_S12nCourseProgress = {
  __typename?: 'LoggedInHomeV1_org_coursera_catalogp_loggedinhome_S12nCourseProgress';
  courseId: Scalars['String'];
  courseName: Scalars['String'];
  courseProgressState: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  courseSlug: Scalars['String'];
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type LoggedInHomeV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'LoggedInHomeV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<LoggedInHomeV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type LoggedInHomeV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<LoggedInHomeV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: LoggedInHomeV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type LoggedInHomeV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'LoggedInHomeV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Grading_CompoundLatePenaltyRatio = {
  __typename?: 'LoggedInHomeV1_org_coursera_grading_CompoundLatePenaltyRatio';
  penaltyContext: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
  ratio: Scalars['Float'];
  submissionDeadline: Scalars['Float'];
  submissionTime: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Grading_FixedLatePenaltyRatio = {
  __typename?: 'LoggedInHomeV1_org_coursera_grading_FixedLatePenaltyRatio';
  ratio: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Grading_IncrementalLatePenaltyRatio = {
  __typename?: 'LoggedInHomeV1_org_coursera_grading_IncrementalLatePenaltyRatio';
  duration: Scalars['Float'];
  ratio: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursegrades_ItemOutcome';
  grade: Scalars['Float'];
  isPassed: Scalars['Boolean'];
  latePenaltyRatio?: Maybe<LoggedInHomeV1_LatePenaltyRatio>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_ItemLockState';
  lockStatus: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus;
  reasonCode: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode;
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
/** Holds ItemLockState along with additional info depending on the type of lock. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_ItemLockSummary';
  isPreviewableByCourseStaff?: Maybe<Scalars['Boolean']>;
  lockInfo?: Maybe<LoggedInHomeV1_TimedReleaseContentLockInfoMember>;
  lockState: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState;
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

/** Holds the time in which a TimedReleaseContent item will be unlocked and when it will be locked again */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_TimedReleaseContentLockInfo';
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  unlockedTimeEnd?: Maybe<Scalars['Float']>;
  unlockedTimeStart?: Maybe<Scalars['Float']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<LoggedInHomeV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Ontrack: 'ONTRACK',
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus];
/** Representation of an item and its related information in the GLEV2 API. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Item = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_Item';
  computedOutcome?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursegrades_ItemOutcome>;
  computedProgressState: Scalars['String'];
  contentSummary: LoggedInHomeV1_ContentSummary;
  deadline?: Maybe<Scalars['Float']>;
  gradingLatePenalty?: Maybe<LoggedInHomeV1_GradingLatePenalty>;
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
  isLocked: Scalars['Boolean'];
  isOptional: Scalars['Boolean'];
  itemDeadlineStatus: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_DeadlineStatus;
  itemGroup?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_ItemGroup>;
  itemLockSummary?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary>;
  name: Scalars['String'];
  resourcePath: Scalars['String'];
  timeCommitment: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_ItemGroup = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_ItemGroup';
  id: Scalars['String'];
  passableItemGroupChoiceIds: Array<Maybe<Scalars['String']>>;
  requiredPassedCount: Scalars['Int'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CertificateMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_CertificateMetadata';
  courseCertificatePreviewImageUrl: Scalars['String'];
  courseCertificateVerifyCode: Scalars['String'];
  specializationCertificateGrantedAt?: Maybe<Scalars['Float']>;
  specializationCertificatePreviewImageUrl?: Maybe<Scalars['String']>;
  specializationCertificateVerifyCode?: Maybe<Scalars['String']>;
};

/** Next step information for users who have completed the course. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseCompletedNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_CourseCompletedNextStep';
  canCompleteVerificationProfile: Scalars['Boolean'];
  canSubscribe: Scalars['Boolean'];
  canUnenroll: Scalars['Boolean'];
  canUpgrade: Scalars['Boolean'];
  canViewCertificate: Scalars['Boolean'];
  certificateMetadata?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CertificateMetadata>;
  course: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMetadata;
  enrolledCourseIds: Array<Maybe<Scalars['String']>>;
  gradeMetadata?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_GradeMetadata>;
  isEligibleButNoCertificate: Scalars['Boolean'];
  s12n?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_S12nMetadata>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_CourseMaterialNextStep';
  courseMaterialNextStepType: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType;
  currentWeekNumberByProgress: Scalars['Int'];
  item: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Item;
  sessionStartedAt: Scalars['Float'];
};

/** Reason for the resulting course material next step. */
export const LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = {
  Default: 'DEFAULT',
  ExamFailedTryAgain: 'EXAM_FAILED_TRY_AGAIN',
  ExamFailedTryLater: 'EXAM_FAILED_TRY_LATER',
  ExamOntrack: 'EXAM_ONTRACK',
  ExamOverdue: 'EXAM_OVERDUE',
  ExamVerify: 'EXAM_VERIFY',
  GradedAssignmentFailedTryAgain: 'GRADED_ASSIGNMENT_FAILED_TRY_AGAIN',
  GradedAssignmentFailedTryLater: 'GRADED_ASSIGNMENT_FAILED_TRY_LATER',
  GradedAssignmentOntrack: 'GRADED_ASSIGNMENT_ONTRACK',
  GradedAssignmentOverdue: 'GRADED_ASSIGNMENT_OVERDUE',
  GradedAssignmentVerify: 'GRADED_ASSIGNMENT_VERIFY',
  GradedPeerFailed: 'GRADED_PEER_FAILED',
  GradedPeerOntrack: 'GRADED_PEER_ONTRACK',
  GradedPeerOverdue: 'GRADED_PEER_OVERDUE',
  GradedPeerReviewOntrack: 'GRADED_PEER_REVIEW_ONTRACK',
  GradedPeerReviewOverdue: 'GRADED_PEER_REVIEW_OVERDUE',
  GradedPeerUnsubmittedOntrack: 'GRADED_PEER_UNSUBMITTED_ONTRACK',
  GradedPeerUnsubmittedOverdue: 'GRADED_PEER_UNSUBMITTED_OVERDUE',
  GradedPeerVerify: 'GRADED_PEER_VERIFY',
  PracticeAssignmentOntrack: 'PRACTICE_ASSIGNMENT_ONTRACK',
  PracticeAssignmentOverdue: 'PRACTICE_ASSIGNMENT_OVERDUE',
  QuizOntrack: 'QUIZ_ONTRACK',
  QuizOverdue: 'QUIZ_OVERDUE',
  StudyMaterialOntrack: 'STUDY_MATERIAL_ONTRACK',
  StudyMaterialOverdue: 'STUDY_MATERIAL_OVERDUE',
  TmrFailed: 'TMR_FAILED',
  TmrUnsubmittedOntrack: 'TMR_UNSUBMITTED_ONTRACK',
  TmrUnsubmittedOverdue: 'TMR_UNSUBMITTED_OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMaterialNextStepType];
/** Course metadata necessary for next step API. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_CourseMetadata';
  /** Course type. Valid values include v1.session, v1.capstone, v2.ondemand, and v2.capstone */
  courseType: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  partnerNames: Array<Maybe<Scalars['String']>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

/** Used instead of [[MultipleDeadlinesNextStep]], [[NotEnoughPeerReviewsNextStep]], and [[NoActiveSessionNextStep]] for learners in sessions v2 experiment. This essentially replaces all messages about session switching. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_CourseScheduleAdjustmentNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_CourseScheduleAdjustmentNextStep';
  suggestion: LoggedInHomeV1_Suggestion;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_GradeMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_GradeMetadata';
  completedAt: Scalars['Float'];
  grade: Scalars['Float'];
};

/** Response from computing the recommended next step to take for the user within a course. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_GuidedCourseNextStepResponse = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_GuidedCourseNextStepResponse';
  nextStep: LoggedInHomeV1_NextStep;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_MultipleDeadlinesNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_MultipleDeadlinesNextStep';
  courseId: Scalars['String'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NextStepCompletedS12nPartner = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NextStepCompletedS12nPartner';
  id: Scalars['Int'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoActiveSessionNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NoActiveSessionNextStep';
  courseId: Scalars['String'];
};

/** State representing lack of available next steps. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NoAvailableNextStep';
  reason: Scalars['String'];
};

/** No available step due to an incompatible or error state. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoAvailableNextStepFromError = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NoAvailableNextStepFromError';
  reason: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NoEnrollableSessionsNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NoEnrollableSessionsNextStep';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NotEnoughPeerReviewsNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_NotEnoughPeerReviewsNextStep';
  courseId: Scalars['String'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

/** S12n metadata necessary for next step API. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_S12nMetadata = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_S12nMetadata';
  capstoneCourseIds: Array<Maybe<Scalars['String']>>;
  courseIds: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  name: Scalars['String'];
  partners: Array<Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_NextStepCompletedS12nPartner>>;
  variant: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_SessionEndedNextStep = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_guided2_nextstep_SessionEndedNextStep';
  courseId: Scalars['String'];
  currentSessionEndedAt: Scalars['Float'];
  isSessionPrivate?: Maybe<Scalars['Boolean']>;
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<LoggedInHomeV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_BranchChange = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_BranchChange';
  changesDescription: LoggedInHomeV1_CmlMember;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_Extension';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason;
  sessionSwitch?: Maybe<LoggedInHomeV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_ExtensionMember';
  org_coursera_ondemand_schedule_suggestion_Extension: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_Extension;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_NoSuggestion';
  reason: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_NoSuggestionMember';
  org_coursera_ondemand_schedule_suggestion_NoSuggestion: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestion;
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleExtensionReason];
export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = {
  AllDeadlinesOnTrack: 'ALL_DEADLINES_ON_TRACK',
  NoAvailableSessionToSwitch: 'NO_AVAILABLE_SESSION_TO_SWITCH',
  NoDeadlines: 'NO_DEADLINES',
  NoUnderlyingSession: 'NO_UNDERLYING_SESSION',
  OnStrictSchedule: 'ON_STRICT_SCHEDULE',
  SingleDeadlineOverdue: 'SINGLE_DEADLINE_OVERDUE'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ScheduleNoSuggestionReason];
/** Terminology: A "deadline" is a single point on a horizontal timeline. BeginningOfTime-----Deadline----EndofTime/Future "Moving forwards" is to move the deadline to the right                     Deadline-->>> Shift all deadlines forward by "days" Eg. Given Original Schedule: Let S = start Let E = end Let days = 4 1 2 3 4 5 6[S---------E] Becomes      [S--------E] If the shift in deadlines causes the user to be too far off from the relative schedule of other learners in the Cohort, they might not get enough time for Peer Review. Then we must recommend a new "Public Session/Cohort" Public Sessions act as "Cohorts/Groups" for learners in SessionsV2. Learners still receive their Peer Review Feedback from learners in the same Public Session, but have deadlines set to their own Personalized Schedule. */
export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlines';
  days: Scalars['Int'];
  endsAt: Scalars['Float'];
  /** Percentage @param value An Int[0,100] representing a percentage */
  progressPercentage?: Maybe<Scalars['Int']>;
  reason: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason;
  sessionSwitch?: Maybe<LoggedInHomeV1_SessionSwitch>;
  startsAt: Scalars['Float'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_ShiftDeadlinesMember';
  org_coursera_ondemand_schedule_suggestion_ShiftDeadlines: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlines;
};

export const LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = {
  LastDeadlineInThePast: 'LAST_DEADLINE_IN_THE_PAST',
  LearnerSupportToolsSuggestion: 'LEARNER_SUPPORT_TOOLS_SUGGESTION',
  MultipleDeadlinesOverdue: 'MULTIPLE_DEADLINES_OVERDUE',
  SingleDeadlineOverdueMoreThanTwoWeeks: 'SINGLE_DEADLINE_OVERDUE_MORE_THAN_TWO_WEEKS'
} as const;

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason = typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason[keyof typeof LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesReason];
export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoalMember';
  org_coursera_ondemand_schedule_suggestion_UpdateDeadlinesWithWeeklyGoal: LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoal;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Session_SuggestedSwitch = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_session_SuggestedSwitch';
  branchChange?: Maybe<LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_BranchChange>;
  destinationSessionBranchId: Scalars['String'];
  destinationSessionId: Scalars['String'];
  sourceSessionBranchId: Scalars['String'];
  sourceSessionId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_session_SuggestedSwitchMember';
  org_coursera_ondemand_session_SuggestedSwitch: LoggedInHomeV1_Org_Coursera_Ondemand_Session_SuggestedSwitch;
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_session_SwitchNotNeeded';
  ArbitraryField: Scalars['String'];
};

export type LoggedInHomeV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember = {
  __typename?: 'LoggedInHomeV1_org_coursera_ondemand_session_SwitchNotNeededMember';
  org_coursera_ondemand_session_SwitchNotNeeded: LoggedInHomeV1_Org_Coursera_Ondemand_Session_SwitchNotNeeded;
};

export type LoggedInHomeV1_PeerMember = {
  __typename?: 'LoggedInHomeV1_peerMember';
  peer: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type LoggedInHomeV1_PhasedPeerMember = {
  __typename?: 'LoggedInHomeV1_phasedPeerMember';
  phasedPeer: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type LoggedInHomeV1_PlaceholderMember = {
  __typename?: 'LoggedInHomeV1_placeholderMember';
  placeholder: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type LoggedInHomeV1_ProgrammingMember = {
  __typename?: 'LoggedInHomeV1_programmingMember';
  programming: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type LoggedInHomeV1_QuizMember = {
  __typename?: 'LoggedInHomeV1_quizMember';
  quiz: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type LoggedInHomeV1_SessionEndedNextStepMember = {
  __typename?: 'LoggedInHomeV1_sessionEndedNextStepMember';
  sessionEndedNextStep: LoggedInHomeV1_Org_Coursera_Ondemand_Guided2_Nextstep_SessionEndedNextStep;
};

export type LoggedInHomeV1_SessionSwitch = LoggedInHomeV1_Org_Coursera_Ondemand_Session_SuggestedSwitchMember | LoggedInHomeV1_Org_Coursera_Ondemand_Session_SwitchNotNeededMember;

export type LoggedInHomeV1_SingleQuestionSubmitMember = {
  __typename?: 'LoggedInHomeV1_singleQuestionSubmitMember';
  singleQuestionSubmit: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type LoggedInHomeV1_SlideshowMember = {
  __typename?: 'LoggedInHomeV1_slideshowMember';
  slideshow: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type LoggedInHomeV1_StaffGradedMember = {
  __typename?: 'LoggedInHomeV1_staffGradedMember';
  staffGraded: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type LoggedInHomeV1_Suggestion = LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ExtensionMember | LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_NoSuggestionMember | LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_ShiftDeadlinesMember | LoggedInHomeV1_Org_Coursera_Ondemand_Schedule_Suggestion_UpdateDeadlinesWithWeeklyGoalMember;

export type LoggedInHomeV1_SupplementMember = {
  __typename?: 'LoggedInHomeV1_supplementMember';
  supplement: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type LoggedInHomeV1_TeammateReviewMember = {
  __typename?: 'LoggedInHomeV1_teammateReviewMember';
  teammateReview: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type LoggedInHomeV1_Text = DummyType | LoggedInHomeV1_CmlMember;

export type LoggedInHomeV1_TimedReleaseContentLockInfoMember = {
  __typename?: 'LoggedInHomeV1_timedReleaseContentLockInfoMember';
  timedReleaseContentLockInfo: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo;
};

export type LoggedInHomeV1_UngradedAssignmentMember = {
  __typename?: 'LoggedInHomeV1_ungradedAssignmentMember';
  ungradedAssignment: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type LoggedInHomeV1_UngradedLabMember = {
  __typename?: 'LoggedInHomeV1_ungradedLabMember';
  ungradedLab: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type LoggedInHomeV1_UngradedLtiMember = {
  __typename?: 'LoggedInHomeV1_ungradedLtiMember';
  ungradedLti: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type LoggedInHomeV1_UngradedProgrammingMember = {
  __typename?: 'LoggedInHomeV1_ungradedProgrammingMember';
  ungradedProgramming: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type LoggedInHomeV1_UngradedWidgetMember = {
  __typename?: 'LoggedInHomeV1_ungradedWidgetMember';
  ungradedWidget: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type LoggedInHomeV1_WiseFlowMember = {
  __typename?: 'LoggedInHomeV1_wiseFlowMember';
  wiseFlow: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type LoggedInHomeV1_WorkspaceLauncherMember = {
  __typename?: 'LoggedInHomeV1_workspaceLauncherMember';
  workspaceLauncher: LoggedInHomeV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

/** An enum for Activity State */
export const LoggedInHome_ActivityState = {
  /** COMPLETED */
  Completed: 'COMPLETED',
  /** IN PROGRESS */
  InProgress: 'IN_PROGRESS',
  /** OVERDUE */
  Overdue: 'OVERDUE'
} as const;

export type LoggedInHome_ActivityState = typeof LoggedInHome_ActivityState[keyof typeof LoggedInHome_ActivityState];
/** Associated S12n informaion for a course the learner enrolled in */
export type LoggedInHome_AssociatedS12nInfo = {
  __typename?: 'LoggedInHome_AssociatedS12nInfo';
  /** the course progress for all the courses in this s12n */
  courseProgressListInS12n: Array<LoggedInHome_CourseProgress>;
  /** course completed count */
  coursesCompletedCount: Scalars['Int'];
  /** course enrolled count */
  coursesEnrolledCount: Scalars['Int'];
  /** is the s12n completed */
  isS12nComplete: Scalars['Boolean'];
  /** next course, null if all the courses in the s12n are completed */
  nextCourse?: Maybe<Course_Course>;
  /** the s12n associated with the course */
  s12n: Specialization_Specialization;
  /** should see s12n modal */
  shouldSeeS12nModal: Scalars['Boolean'];
};

/** An enum for all the possible types of the Course Card button CTA */
export const LoggedInHome_CourseCardButtonCta = {
  /** CTA for Go to Course */
  GoToCourse: 'GO_TO_COURSE',
  /** CTA for Go to Next Item */
  GoToNextItem: 'GO_TO_NEXT_ITEM',
  /** CTA for Go to Next s12n Course */
  GoToNextS12NCourse: 'GO_TO_NEXT_S12N_COURSE',
  /** No button CTA */
  NoButton: 'NO_BUTTON',
  /** CTA for Purchase Certificate */
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  /** CTA for Reset Deadline */
  ResetDeadlines: 'RESET_DEADLINES',
  /** CTA for Start Course */
  StartCourse: 'START_COURSE',
  /** CTA for Switch Sessions */
  SwitchSessions: 'SWITCH_SESSIONS',
  /** CTA for Verify ID */
  VerifyId: 'VERIFY_ID',
  /** CTA for View Certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHome_CourseCardButtonCta = typeof LoggedInHome_CourseCardButtonCta[keyof typeof LoggedInHome_CourseCardButtonCta];
/** An enum for all the possible types of the Course Card Secondary CTA */
export const LoggedInHome_CourseCardSecondaryCta = {
  /** no CTA */
  NoSecondaryCta: 'NO_SECONDARY_CTA',
  /** CTA for Rate the Course */
  RateCourse: 'RATE_COURSE',
  /** CTA for Reset Deadlines */
  ResetDeadlines: 'RESET_DEADLINES',
  /** CTA for Switch Sessions */
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHome_CourseCardSecondaryCta = typeof LoggedInHome_CourseCardSecondaryCta[keyof typeof LoggedInHome_CourseCardSecondaryCta];
/** An enum for if the course is eligible for upgrade from Freemium. */
export const LoggedInHome_CourseCardUpgradeCta = {
  /** No course upgrade CTA */
  NoCta: 'NO_CTA',
  /** CTA for upgrading the course */
  Upgrade: 'UPGRADE'
} as const;

export type LoggedInHome_CourseCardUpgradeCta = typeof LoggedInHome_CourseCardUpgradeCta[keyof typeof LoggedInHome_CourseCardUpgradeCta];
/** Course Next Step */
export type LoggedInHome_CourseNextStep = {
  __typename?: 'LoggedInHome_CourseNextStep';
  /** The course next step */
  courseNextStep: LoggedInHome_CourseNextStepEnum;
  /** The reason why that next step. This string is not localized */
  reason?: Maybe<Scalars['String']>;
};

/** An enum for course Next steps */
export const LoggedInHome_CourseNextStepEnum = {
  /** Course Completed next step */
  CourseCompletedNextStep: 'COURSE_COMPLETED_NEXT_STEP',
  /** Course Material next step */
  CourseMaterialNextStep: 'COURSE_MATERIAL_NEXT_STEP',
  /** course schedule adjustment */
  CourseScheduleAdjustmentNextStep: 'COURSE_SCHEDULE_ADJUSTMENT_NEXT_STEP',
  /** multiple deadlines */
  MultipleDeadlinesNextStep: 'MULTIPLE_DEADLINES_NEXT_STEP',
  /** Not enough peer review */
  NotEnoughPeerReviewsNextStep: 'NOT_ENOUGH_PEER_REVIEWS_NEXT_STEP',
  /** No active session */
  NoActiveSessionNextStep: 'NO_ACTIVE_SESSION_NEXT_STEP',
  /** no available next step */
  NoAvailableNextStep: 'NO_AVAILABLE_NEXT_STEP',
  /** no available next step from error */
  NoAvailableNextStepFromError: 'NO_AVAILABLE_NEXT_STEP_FROM_ERROR',
  /** no enrollable sessions */
  NoEnrollableSessionsNextStep: 'NO_ENROLLABLE_SESSIONS_NEXT_STEP',
  /** Session ended */
  SessionEndedNextStep: 'SESSION_ENDED_NEXT_STEP'
} as const;

export type LoggedInHome_CourseNextStepEnum = typeof LoggedInHome_CourseNextStepEnum[keyof typeof LoggedInHome_CourseNextStepEnum];
/** A type for the learner's progress information towards a course */
export type LoggedInHome_CourseProgress = {
  __typename?: 'LoggedInHome_CourseProgress';
  /** learners course certificate or validation if certificate not present */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** the course */
  course: Course_Course;
  /**
   * percentage completed, i.e. completed item count / total item count. If total is 0, percentage
   * completed is 100%
   */
  courseProgressPercentage: Scalars['Float'];
  /** course proress state */
  courseProgressState: LoggedInHome_CourseProgressStateEnum;
  /** estimated course completion date */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>;
  /** recap markdown string, null if the condition to show recap is not met. */
  recap?: Maybe<Scalars['String']>;
};

/** An enum for the learner's learning progress state towards a course (has learner membership with) */
export const LoggedInHome_CourseProgressStateEnum = {
  /** Completed */
  Completed: 'COMPLETED',
  /** Not Started */
  NotStarted: 'NOT_STARTED',
  /** Started */
  Started: 'STARTED'
} as const;

export type LoggedInHome_CourseProgressStateEnum = typeof LoggedInHome_CourseProgressStateEnum[keyof typeof LoggedInHome_CourseProgressStateEnum];
/** A type denotes what options are there in the drop down menu of a Course card */
export type LoggedInHome_DropdownOptions = {
  __typename?: 'LoggedInHome_DropdownOptions';
  /** show C+ unenroll */
  showCourseraPlusUnenrollOption: Scalars['Boolean'];
  /** show rate course */
  showRateCourseOption: Scalars['Boolean'];
  /** show reset deadline */
  showResetDeadlineOption: Scalars['Boolean'];
  /** show session switch */
  showSessionSwitchOption: Scalars['Boolean'];
  /** show unenroll */
  showUnenrollOption: Scalars['Boolean'];
};

/** An enum for interest CTA */
export const LoggedInHome_LearnerInterestCta = {
  /** no CTA */
  NoCta: 'NO_CTA',
  /** CTA for learner to click to show that they are no longer interested in a product */
  NoLongerInterested: 'NO_LONGER_INTERESTED'
} as const;

export type LoggedInHome_LearnerInterestCta = typeof LoggedInHome_LearnerInterestCta[keyof typeof LoggedInHome_LearnerInterestCta];
/**
 * Currently only support course cards (and use course cards for consolidated completed s12n), but
 * making it general as much to allow adding s12n cards in the future
 */
export type LoggedInHome_LearningProduct = Course_Course;

/**
 * A product card for Logged In Home Page enrolled products by the logged in learner, currently this
 * model is a COURSE card but naming it generally for future extension
 */
export type LoggedInHome_ProductCard = {
  __typename?: 'LoggedInHome_ProductCard';
  /** activity state */
  activityState?: Maybe<LoggedInHome_ActivityState>;
  /** associated s12n info */
  associatedS12nInfo?: Maybe<LoggedInHome_AssociatedS12nInfo>;
  /** course next step */
  courseNextStep?: Maybe<LoggedInHome_CourseNextStep>;
  /** course progress */
  courseProgress?: Maybe<LoggedInHome_CourseProgress>;
  /** course upgrade cta */
  courseUpgradeCta?: Maybe<LoggedInHome_CourseCardUpgradeCta>;
  /** dropdown options */
  dropdownOptions?: Maybe<LoggedInHome_DropdownOptions>;
  /** learner's interest CTA */
  learnerInterestCta?: Maybe<LoggedInHome_LearnerInterestCta>;
  /** the learning product */
  learningProduct: LoggedInHome_LearningProduct;
  /** primary button */
  primaryButton?: Maybe<LoggedInHome_CourseCardButtonCta>;
  /** secondary cta */
  secondaryCta?: Maybe<LoggedInHome_CourseCardSecondaryCta>;
  /** the upsell state */
  upsellState?: Maybe<LoggedInHome_UpsellState>;
};

/** Output for query queryEnrolledProductCards */
export type LoggedInHome_QueryEnrolledProductCardsPaginatedResult = {
  __typename?: 'LoggedInHome_QueryEnrolledProductCardsPaginatedResult';
  /** elements */
  elements: Array<LoggedInHome_ProductCard>;
  /**
   * A shared type of pagination, it is the cursor type of pagination with two fields: String
   * cursor and Int totalElements. The cursor is the starting cursor for the next page. Null if the
   * end of the collection has been reached.
   */
  pagination: Pagination;
};

/** A type representing an s12n modal */
export type LoggedInHome_S12nModal = {
  __typename?: 'LoggedInHome_S12nModal';
  /** Number of courses enrolled by the logged in user belonging to this s12n */
  coursesEnrolledCount: Scalars['Int'];
  /** the dropdown options */
  dropdownOptions: LoggedInHome_S12nModalDropdownOptions;
  /** completed or not */
  isS12nComplete: Scalars['Boolean'];
  /** the mini course cards */
  miniCourseCards: Array<LoggedInHome_S12nModalMiniCourseCard>;
  /** primary cta */
  primaryButtonCta: LoggedInHome_S12nModalButtonCta;
  /** the s12n */
  s12n: Specialization_Specialization;
};

/** An enum for s12n modal buttonCta */
export const LoggedInHome_S12nModalButtonCta = {
  /** no button */
  NoButton: 'NO_BUTTON',
  /** view certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type LoggedInHome_S12nModalButtonCta = typeof LoggedInHome_S12nModalButtonCta[keyof typeof LoggedInHome_S12nModalButtonCta];
/** s12n modal dropdown options */
export type LoggedInHome_S12nModalDropdownOptions = {
  __typename?: 'LoggedInHome_S12nModalDropdownOptions';
  /** show cancel subscription */
  showCancelSubscriptionOption: Scalars['Boolean'];
};

/** A type representing the mini course card shown inside an s12n modal */
export type LoggedInHome_S12nModalMiniCourseCard = {
  __typename?: 'LoggedInHome_S12nModalMiniCourseCard';
  /** course */
  course: Course_Course;
  /** drop down options */
  dropdownOptions?: Maybe<LoggedInHome_DropdownOptions>;
  /** is currently enrolled? */
  isCurrentlyEnrolled?: Maybe<Scalars['Boolean']>;
  /** is locked capstone? */
  isLockedCapstone?: Maybe<Scalars['Boolean']>;
  /** primary button cta type */
  primaryButtonCta?: Maybe<LoggedInHome_CourseCardButtonCta>;
  /** secondary CTA */
  secondaryCta?: Maybe<LoggedInHome_S12nModalMiniCourseCardSecondaryCta>;
};

/**
 * An enum for the secondary CTA in an mini course card in an s12n modal.
 * This is different from the secondary CTA type in a regular course card that has RATE_COURSE
 */
export const LoggedInHome_S12nModalMiniCourseCardSecondaryCta = {
  /** no CTA */
  NoSecondaryCta: 'NO_SECONDARY_CTA',
  /** RESET DEADLINES */
  ResetDeadlines: 'RESET_DEADLINES',
  /** SWITCH SESSIONS */
  SwitchSessions: 'SWITCH_SESSIONS'
} as const;

export type LoggedInHome_S12nModalMiniCourseCardSecondaryCta = typeof LoggedInHome_S12nModalMiniCourseCardSecondaryCta[keyof typeof LoggedInHome_S12nModalMiniCourseCardSecondaryCta];
/** An enum representing the tabs of the Logged In Home Page (LIHP) */
export const LoggedInHome_Tab = {
  /** The Completed tab of the Logged In Home Page (LIHP) */
  Completed: 'COMPLETED',
  /** The Home tab of the Logged In Home Page (LIHP) */
  Home: 'HOME',
  /** The In-Progress tab of the Logged In Home Page (LIHP) */
  InProgress: 'IN_PROGRESS'
} as const;

export type LoggedInHome_Tab = typeof LoggedInHome_Tab[keyof typeof LoggedInHome_Tab];
/** An enum for upsell state */
export const LoggedInHome_UpsellState = {
  /** no upsell */
  NoUpsell: 'NO_UPSELL',
  /** upsell for certificate */
  UpsellForCertificate: 'UPSELL_FOR_CERTIFICATE',
  /** upsell from audit */
  UpsellFromAudit: 'UPSELL_FROM_AUDIT'
} as const;

export type LoggedInHome_UpsellState = typeof LoggedInHome_UpsellState[keyof typeof LoggedInHome_UpsellState];
/** All Low Stakes Learning queries */
export type LowStakesLearningQueries = {
  __typename?: 'LowStakesLearningQueries';
  /** Mutation to execute a user submission and get the response */
  executeCodeBlockPractice?: Maybe<LowStakesLearning_CodingPracticeResult>;
  /** Get the variant of one code expression question using its assess question id */
  getCodingPracticeVariant?: Maybe<LowStakesLearning_CodingPracticeVariant>;
  /**
   * Query to fetch audio narration data for a reading item.
   * Returns S3 URL and audio duration.
   */
  readingAudio?: Maybe<LowStakesLearning_ReadingAudio>;
  /**
   * Query to fetch audio narration data for all reading items in a course branch.
   * Returns a list of items that have audio available, with their presigned S3 URLs.
   * Items without audio are omitted from the result.
   */
  readingAudioByCourseBranch: Array<LowStakesLearning_ReadingAudio>;
  /**
   * Check if user is eligible for the 5-minute flashcard refresher.
   * Returns true if user has completed at least 1 item with flashcards in the course.
   */
  refresherEligibility?: Maybe<LowStakesLearning_RefresherEligibility>;
  /**
   * Get a deck of flashcards for the 5-minute refresher review experience.
   * Returns flashcards from completed items with recency-based selection.
   */
  reviewFlashcardsDeck?: Maybe<LowStakesLearning_ReviewFlashcardsDeck>;
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesExecuteCodeBlockPracticeArgs = {
  code: Scalars['String'];
  evaluatorId: Scalars['ID'];
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesGetCodingPracticeVariantArgs = {
  questionId: Scalars['ID'];
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesReadingAudioArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesReadingAudioByCourseBranchArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesRefresherEligibilityArgs = {
  courseId: Scalars['ID'];
};


/** All Low Stakes Learning queries */
export type LowStakesLearningQueriesReviewFlashcardsDeckArgs = {
  courseId: Scalars['ID'];
};

/** Low Stakes Learning Tools Queries */
export type LowStakesLearningToolsQueries = {
  __typename?: 'LowStakesLearningToolsQueries';
  /**
   * Query flashcards by course slug with advanced filtering and pagination.
   * Mirrors the Flashcards.queryFlashcardsByCourseSlug endpoint contract.
   */
  queryFlashcardsByCourseSlug: LowStakesLearningTools_FlashcardPaginatedResult;
  /**
   * Query modules with flashcards by course slug.
   * Returns modules that have at least one flashcard, ordered by moduleNumber.
   */
  queryModulesWithFlashcardsByCourseSlug: Array<LowStakesLearningTools_Module>;
  /** Query AI Generated Practice by Course and Item ID */
  queryPracticesByItemId: LowStakesLearningTools_AiGeneratedPracticePaginatedResult;
};


/** Low Stakes Learning Tools Queries */
export type LowStakesLearningToolsQueriesQueryFlashcardsByCourseSlugArgs = {
  courseSlug: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['ID']>;
  itemIdFilterMode?: LowStakesLearningTools_ItemIdFilterMode;
  limit?: Scalars['Int'];
  moduleId?: InputMaybe<Scalars['ID']>;
  shuffleSeed?: InputMaybe<Scalars['Int']>;
};


/** Low Stakes Learning Tools Queries */
export type LowStakesLearningToolsQueriesQueryModulesWithFlashcardsByCourseSlugArgs = {
  courseSlug: Scalars['String'];
  itemId?: InputMaybe<Scalars['ID']>;
};


/** Low Stakes Learning Tools Queries */
export type LowStakesLearningToolsQueriesQueryPracticesByItemIdArgs = {
  courseBranchId?: InputMaybe<Scalars['ID']>;
  courseId?: InputMaybe<Scalars['ID']>;
  courseSlug?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
  shuffleSeed?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<LowStakesLearningTools_AiGeneratedPracticeType>>;
};

/** AI generated practice */
export type LowStakesLearningTools_AiGeneratedPractice = {
  __typename?: 'LowStakesLearningTools_AiGeneratedPractice';
  /** Content in Json format */
  content: Scalars['JSON'];
  /** AI generated practice ID */
  id: Scalars['ID'];
  /** AI generated practice type */
  type: LowStakesLearningTools_AiGeneratedPracticeType;
};

/** AI generated practice result */
export type LowStakesLearningTools_AiGeneratedPracticePaginatedResult = {
  __typename?: 'LowStakesLearningTools_AiGeneratedPracticePaginatedResult';
  /** AI generated practice */
  elements: Array<LowStakesLearningTools_AiGeneratedPractice>;
  /** Pagination */
  pagination: Pagination;
};

/** AI generated practice type */
export const LowStakesLearningTools_AiGeneratedPracticeType = {
  /** Codeblock Select correct Output Multiple Choice Question */
  CodeblockOutputMcq: 'CODEBLOCK_OUTPUT_MCQ',
  /** Code Expression Question */
  CodeExpressionQuestion: 'CODE_EXPRESSION_QUESTION',
  /** Experimental Find the Bug */
  ExperimentalFindTheBug: 'EXPERIMENTAL_FIND_THE_BUG',
  /** Fill in the Blank */
  FillInTheBlank: 'FILL_IN_THE_BLANK',
  /** Flashcard */
  Flashcard: 'FLASHCARD',
  /** Matching Game */
  MatchingGame: 'MATCHING_GAME',
  /** True/False Question */
  TrueFalseQuestion: 'TRUE_FALSE_QUESTION'
} as const;

export type LowStakesLearningTools_AiGeneratedPracticeType = typeof LowStakesLearningTools_AiGeneratedPracticeType[keyof typeof LowStakesLearningTools_AiGeneratedPracticeType];
/** Input for archiving an AI generated practice */
export type LowStakesLearningTools_ArchivePracticeInput = {
  /** The ID of the AI generated practice to archive */
  aiGeneratedPracticeId: Scalars['ID'];
};

/** Result of archiving an AI generated practice */
export type LowStakesLearningTools_ArchivePracticeResult = {
  __typename?: 'LowStakesLearningTools_ArchivePracticeResult';
  /** Whether the archive operation was successful */
  success: Scalars['Boolean'];
};

/** Paginated result for LowStakesLearningTools_FlashcardWithMetadata */
export type LowStakesLearningTools_FlashcardPaginatedResult = {
  __typename?: 'LowStakesLearningTools_FlashcardPaginatedResult';
  /** List of flashcards in the page */
  elements: Array<LowStakesLearningTools_FlashcardWithMetadata>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Flashcard with associated course, module, lesson, and item metadata */
export type LowStakesLearningTools_FlashcardWithMetadata = {
  __typename?: 'LowStakesLearningTools_FlashcardWithMetadata';
  /** The course this flashcard is associated with */
  course: Course_Course;
  /** The flashcard definition (back of card) */
  definition: Scalars['String'];
  /** ID of the flashcard */
  id: Scalars['ID'];
  /** The item this flashcard is associated with */
  item: LowStakesLearningTools_Item;
  /** The lesson this flashcard is associated with */
  lesson: LowStakesLearningTools_Lesson;
  /** The module this flashcard is associated with */
  module: LowStakesLearningTools_Module;
  /** The flashcard term (front of card) */
  term: Scalars['String'];
};

/** Item entity for flashcard metadata */
export type LowStakesLearningTools_Item = {
  __typename?: 'LowStakesLearningTools_Item';
  /** Item ID */
  id: Scalars['ID'];
  /** Item type (LECTURE or READING) */
  itemType: LowStakesLearningTools_ItemType;
  /** Item name */
  name: Scalars['String'];
};

/** Filter mode for itemId when querying flashcards */
export const LowStakesLearningTools_ItemIdFilterMode = {
  /** Return only flashcards for the exact specified item */
  Exact: 'EXACT',
  /** Return flashcards up to and including the specified item */
  UpTo: 'UP_TO'
} as const;

export type LowStakesLearningTools_ItemIdFilterMode = typeof LowStakesLearningTools_ItemIdFilterMode[keyof typeof LowStakesLearningTools_ItemIdFilterMode];
/** Item type enumeration for flashcard items */
export const LowStakesLearningTools_ItemType = {
  /** Lecture item type */
  Lecture: 'LECTURE',
  /** Reading item type */
  Reading: 'READING'
} as const;

export type LowStakesLearningTools_ItemType = typeof LowStakesLearningTools_ItemType[keyof typeof LowStakesLearningTools_ItemType];
/** Lesson entity for flashcard metadata */
export type LowStakesLearningTools_Lesson = {
  __typename?: 'LowStakesLearningTools_Lesson';
  /** Lesson ID */
  id: Scalars['ID'];
  /** Lesson name */
  name: Scalars['String'];
};

/** Module entity for flashcard metadata */
export type LowStakesLearningTools_Module = {
  __typename?: 'LowStakesLearningTools_Module';
  /** Module ID */
  id: Scalars['ID'];
  /**
   * Represents the sequential number of a module within a course, inferred from the module's order.
   * For example, the first module in the course has a moduleNumber of 1.
   */
  moduleNumber: Scalars['Int'];
  /** Module name */
  name: Scalars['String'];
};

/** Result of an execution */
export type LowStakesLearning_CodingPracticeResult = {
  __typename?: 'LowStakesLearning_CodingPracticeResult';
  /** Whether it passed validation or not */
  correctness: Scalars['Boolean'];
  /** Message back from the validation code */
  message: Scalars['String'];
};

/** The coding practice variant */
export type LowStakesLearning_CodingPracticeVariant = {
  __typename?: 'LowStakesLearning_CodingPracticeVariant';
  /** Language type used in the question */
  codeLanguage: Scalars['String'];
  /** Evaluator id to use for running code snippets */
  evaluatorId: Scalars['ID'];
  /** Question id */
  id: Scalars['ID'];
  /** Prompt of the question */
  prompt: Cml_Cml;
  /** REPL evaluator id to use for running code snippets */
  replEvaluatorId: Scalars['ID'];
  /** Starter code to initialize the question with */
  starterCode: Scalars['String'];
};

/** Input for completing flashcards. */
export type LowStakesLearning_CompleteFlashcardsInput = {
  /** Course ID the learner completed the flashcards for. */
  courseId: Scalars['ID'];
};

/** Result of completing flashcards. */
export type LowStakesLearning_CompleteFlashcardsResult = {
  __typename?: 'LowStakesLearning_CompleteFlashcardsResult';
  /** Whether the completion event was published. */
  success: Scalars['Boolean'];
};

/** Audio narration data for a reading item */
export type LowStakesLearning_ReadingAudio = {
  __typename?: 'LowStakesLearning_ReadingAudio';
  /** S3 URL of the audio file (mp3 format) */
  audioUrl: Scalars['URL'];
  /** Item ID of the reading item. Null when queried via the single-item readingAudio endpoint. */
  itemId?: Maybe<Scalars['ID']>;
};

/** Eligibility status for the 5-minute flashcard refresher */
export type LowStakesLearning_RefresherEligibility = {
  __typename?: 'LowStakesLearning_RefresherEligibility';
  /** True if user has completed at least 1 item with flashcards in the course */
  hasCompletedFlashcardItem: Scalars['Boolean'];
};

/** A flashcard for the 5-minute refresher review */
export type LowStakesLearning_ReviewFlashcard = {
  __typename?: 'LowStakesLearning_ReviewFlashcard';
  /** The answer (back of card) */
  answer: Scalars['String'];
  /** Unique identifier for the flashcard */
  id: Scalars['ID'];
  /** The question (front of card) */
  question: Scalars['String'];
};

/** A deck of flashcards for the 5-minute refresher review experience */
export type LowStakesLearning_ReviewFlashcardsDeck = {
  __typename?: 'LowStakesLearning_ReviewFlashcardsDeck';
  /** List of flashcards selected for review */
  flashcards: Array<LowStakesLearning_ReviewFlashcard>;
};

/** Queries for LTI Item Authoring */
export type LtiItemAuthoringQueries = {
  __typename?: 'LtiItemAuthoringQueries';
  /** Fetch an LTI authoring item by its atom id, which can be both versioned or unversioned */
  LtiPlatform_QueryAuthoringItemByAtomId?: Maybe<ItemPlatform_AuthoringItem>;
};


/** Queries for LTI Item Authoring */
export type LtiItemAuthoringQueriesLtiPlatform_QueryAuthoringItemByAtomIdArgs = {
  atomId: Scalars['ID'];
};

/** Deprecated. Use LtiPlatform_AtomicValidationError instead. */
export type LtiItemAuthoring_AtomicValidationError = {
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiItemAuthoring_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Deprecated. Use LtiPlatform_ValidationErrorStatus instead. */
export const LtiItemAuthoring_ValidationErrorStatus = {
  /** BAD_REFERENCE validation status. */
  BadReference: 'BAD_REFERENCE',
  /** DUPLICATE validation status. */
  Duplicate: 'DUPLICATE',
  /** EMPTY validation status. */
  Empty: 'EMPTY',
  /** ENUM validation status. */
  Enum: 'ENUM',
  /** FORMAT validation status. */
  Format: 'FORMAT',
  /** LOCKED validation status. */
  Locked: 'LOCKED',
  /** NON_EMPTY validation status. */
  NonEmpty: 'NON_EMPTY',
  /** OTHER validation status. */
  Other: 'OTHER',
  /** OVERLAP validation status. */
  Overlap: 'OVERLAP',
  /** TOO_LARGE validation status. */
  TooLarge: 'TOO_LARGE',
  /** TOO_LONG validation status. */
  TooLong: 'TOO_LONG',
  /** TOO_SHORT validation status. */
  TooShort: 'TOO_SHORT',
  /** TOO_SMALL validation status. */
  TooSmall: 'TOO_SMALL'
} as const;

export type LtiItemAuthoring_ValidationErrorStatus = typeof LtiItemAuthoring_ValidationErrorStatus[keyof typeof LtiItemAuthoring_ValidationErrorStatus];
/** App availability scope configured for the External App Deployment */
export const LtiPlatform_AppAvailabilityScope = {
  /**
   * Identifies if the External App Deployment will be available in All Sessions under the
   * partner/course scope. This includes Private sessions, Public sessions (and Org only sessions for Enterprise partners)
   */
  AllSessions: 'ALL_SESSIONS',
  /** Identifies if the External App Deployment should be made available specifically in Guided Projects */
  GuidedProjects: 'GUIDED_PROJECTS',
  /**
   * Identifies if the External App Deployment will be available in Private Sessions under the
   * partner/course scope
   */
  PrivateSessions: 'PRIVATE_SESSIONS'
} as const;

export type LtiPlatform_AppAvailabilityScope = typeof LtiPlatform_AppAvailabilityScope[keyof typeof LtiPlatform_AppAvailabilityScope];
/** Root interface for different validation criteria on item fields. */
export type LtiPlatform_AtomicValidationError = {
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Conflict Result type for External App Queries/Mutations */
export type LtiPlatform_ConflictResponse = {
  __typename?: 'LtiPlatform_ConflictResponse';
  /** Message accompanying the conflict error. */
  message: Scalars['String'];
};

/** Input Object for creating a new External App Registration V13 for a Curated App */
export type LtiPlatform_CreateCuratedAppExternalAppRegistrationV13Input = {
  /** OIDC Authorization Request URL configured for the External App */
  authRequestUrl: Scalars['String'];
  /** Curated App Key */
  curatedAppKey: LtiPlatform_CuratedAppKey;
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Redirect URLs configured for the External App */
  redirectUrls: Array<Scalars['String']>;
  /** Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** Result type for creating a new External App Registration V13 for a Curated App */
export type LtiPlatform_CreateCuratedAppExternalAppRegistrationV13Result = LtiPlatform_ExternalAppRegistrationV13 | LtiPlatform_FailureResponse;

/** Create External app Deployment for a Partner Input object for Curated apps */
export type LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerInput = {
  /** Input Object for creating a new LTI v1.1 and LTI v1.3 Deployment for Curated App */
  curatedExternalAppDeploymentInput?: InputMaybe<LtiPlatform_CuratedExternalAppDeploymentInput>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure External app Create Deployment Result Wrapper type for Curated Apps */
export type LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerResult = LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerResultSuccess | LtiPlatform_FailureResponse;

/** External app Create Deployment Result Wrapper type for Curated Apps */
export type LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerResultSuccess';
  /** External app Create Deployment Result for Curated Apps */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
};

/** Create External app Deployment Input for a course object for LTI 1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForCourseInput = {
  /** Course identifier */
  courseId: Scalars['ID'];
  /** Input Object for creating a new LTI v1.1 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV11Input;
};

/** Success/Failure External app Create Deployment Result Wrapper type for LTI v1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForCourseResult = LtiPlatform_CreateExternalAppDeploymentV11ForCourseResultSuccess | LtiPlatform_FailureResponse;

/** Success Result Wrapper type for Create LTI v1.1 External app deployment for a course */
export type LtiPlatform_CreateExternalAppDeploymentV11ForCourseResultSuccess = {
  __typename?: 'LtiPlatform_CreateExternalAppDeploymentV11ForCourseResultSuccess';
  /** External app Create Deployment Result */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
};

/** Create External app Deployment for a Partner Input object for LTI v1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForPartnerInput = {
  /** Input Object for creating a new LTI v1.1 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV11Input;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure External app Create Deployment Result Wrapper type for LTI v1.1 */
export type LtiPlatform_CreateExternalAppDeploymentV11ForPartnerResult = LtiPlatform_CreateExternalAppDeploymentV11ForPartnerResultSuccess | LtiPlatform_FailureResponse;

/** Success Result Wrapper type for Create LTI v1.1 External app deployment for a partner */
export type LtiPlatform_CreateExternalAppDeploymentV11ForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_CreateExternalAppDeploymentV11ForPartnerResultSuccess';
  /** External app Create Deployment Result */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
};

/** Create External app Deployment Input for a course object for LTI 1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for creating a new LTI v1.3 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV13Input;
};

/** Success/Failure External app Create Deployment Result Wrapper type for LTI v1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForCourseResult = LtiPlatform_CreateExternalAppDeploymentV13ForCourseResultSuccess | LtiPlatform_FailureResponse;

/** Success Result Wrapper type for Create LTI v1.3 External app deployment for a course */
export type LtiPlatform_CreateExternalAppDeploymentV13ForCourseResultSuccess = {
  __typename?: 'LtiPlatform_CreateExternalAppDeploymentV13ForCourseResultSuccess';
  /** External app Create Deployment Result */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
  /** Platform KeySet Configuration */
  platformAccessConfig?: Maybe<LtiPlatform_PlatformAccessConfig>;
};

/** Create External app Deployment Input for a Partner object for LTI 1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForPartnerInput = {
  /** Input Object for creating a new LTI v1.3 Deployment */
  externalAppDeploymentInput: LtiPlatform_ExternalAppDeploymentV13Input;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure External app Create Deployment Result Wrapper type for LTI v1.3 */
export type LtiPlatform_CreateExternalAppDeploymentV13ForPartnerResult = LtiPlatform_CreateExternalAppDeploymentV13ForPartnerResultSuccess | LtiPlatform_FailureResponse;

/** Success Result Wrapper type for Update LTI v1.3 External app Registration */
export type LtiPlatform_CreateExternalAppDeploymentV13ForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_CreateExternalAppDeploymentV13ForPartnerResultSuccess';
  /** External app Create Deployment Result for LTI v1.3 */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
  /** Platform KeySet Configuration */
  platformAccessConfig?: Maybe<LtiPlatform_PlatformAccessConfig>;
};

/** Curated App List */
export const LtiPlatform_CuratedAppKey = {
  /** Gradescope LTI tool */
  Gradescope: 'GRADESCOPE',
  /** Honorlock LTI tool */
  Honorlock: 'HONORLOCK',
  /** Turnitin LTI tool */
  Turnitin: 'TURNITIN'
} as const;

export type LtiPlatform_CuratedAppKey = typeof LtiPlatform_CuratedAppKey[keyof typeof LtiPlatform_CuratedAppKey];
/** Create External app Deployment Input object for Curated apps */
export type LtiPlatform_CuratedExternalAppDeploymentInput = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Curated External App identifier */
  curatedAppKey: LtiPlatform_CuratedAppKey;
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/**
 * Custom Parameter key-value pair for the LTI item; it's also used in External Apps here:
 * coursera/graphql/ltiplatform/schema/common.graphqls - it's defined here to avoid dragging in an LTI
 * specific dependency into the shared service definition.
 */
export type LtiPlatform_CustomParam = {
  __typename?: 'LtiPlatform_CustomParam';
  /** Custom Param Key */
  key: Scalars['String'];
  /** Custom Param Value */
  value?: Maybe<Scalars['String']>;
};

/** Custom type for Key-value pair */
export type LtiPlatform_CustomParamInput = {
  /** Custom Param Key */
  key: Scalars['String'];
  /** Custom Param Value */
  value?: InputMaybe<Scalars['String']>;
};

/** Lti draft content, represented as an input type */
export type LtiPlatform_DraftContentInput = {
  /** Custom parameter map for this LTI item. */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Learner-facing LTI item description in CML format. */
  description: CmlContentInput;
  /**
   * External app reference. Used for LTI V2 items.
   * This field MUST be populated for LTI v2 items, otherwise the lti will revert to lti v1. If there is no linked external app, the follow default value should be used.
   * https://github.com/webedx-spark/web/blob/387c64c9bac086b6131b4273b38d7efde4aed84f/static/bundles/item-authoring/lti/utils/convertLtiDraftContentToMutationInput.ts#L12
   */
  externalAppReference?: InputMaybe<LtiPlatform_LtiExternalAppReferenceInput>;
  /**
   * Deprecated. Use launchUrlString instead.
   * @deprecated Use launchUrlString instead.
   */
  launchUrl?: InputMaybe<Scalars['URL']>;
  /**
   * Endpoint for a non-external-app LTI tool to display, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this URL can be used as an override.
   *
   * Note: In case of LTI v1.1, this field is called "Launch URL", and in case of LTI v1.3 it's called
   * "Target Link URI".
   */
  launchUrlString?: InputMaybe<Scalars['String']>;
  /**
   * Privacy level for a non-external-app LTI tool, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this privacy level can be used as an override.
   */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
  /** User authored name of the LTI item. */
  name: Scalars['String'];
  /**
   * A passing threshold between 0 and 1; eg. 0.8 means 80% passing threshold.
   *
   * Note: Internal models have three values that interact: `ltiType` (`ungraded` or `graded`),
   * `hasGradeCallback` (boolean), and `passingFraction` which only exists if `hasGradeCallback` is
   * set to `true`. Additionally, a callback can be missing only if the `ltiType` is `ungraded`. In
   * this schema, these three fields are collapsed into just the `passingFraction` in external models
   * in the following way:
   * a) If `passingFraction` is missing or zero: LTI is ungraded and the callback isn't present
   * b) If `passingFraction` is >0: LTI is graded and the callback is present.
   */
  passingFraction?: InputMaybe<Scalars['Float']>;
  /** How long a given item is expected to take to complete. */
  timeCommitment: Scalars['Duration'];
  /**
   * Determines the LTI protocol version of LTI items not referencing an external app: v1.1 or v1.3.
   * If an external app is referenced, this field should be ignored.
   *
   * This field is introduced because we don't want to "forget" version configuration parameters of
   * the version which currently isn't configured for the item. E.g. if version v1.1 is selected and
   * the authoring user switches to version v1.3, we want to keep all v1.1 configuration parameters in
   * case the user made the edit by mistake and wants to revert it.
   */
  version: LtiPlatform_Version;
  /**
   * LTI protocol version v1.1 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_1?: InputMaybe<LtiPlatform_LtiVersionConfigV11Input>;
  /**
   * LTI protocol version v1.3 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_3?: InputMaybe<LtiPlatform_LtiVersionConfigV13Input>;
};

/** External App Deployment type */
export type LtiPlatform_ExternalAppDeployment = {
  __typename?: 'LtiPlatform_ExternalAppDeployment';
  /** Identifies whether a deployment will be available for private or public sessions" */
  appAvailabilityScope: LtiPlatform_AppAvailabilityScope;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** The course that owns the deployment, only applicable for course level deployments */
  course?: Maybe<Course_Course>;
  /** Custom Parameters for the deployment */
  customParams?: Maybe<Array<LtiPlatform_CustomParam>>;
  /** Deployment ID of the External App deployment */
  deploymentId?: Maybe<Scalars['ID']>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: Maybe<LtiPlatform_LtiDeploymentScope>;
  /** External App Registration configured for the deployment */
  externalAppRegistration: LtiPlatform_ExternalAppRegistrationV11 | LtiPlatform_ExternalAppRegistrationV13;
  /** Auto-generated ID of the External App deployment */
  id: Scalars['ID'];
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy: LtiPlatform_LearnerPrivacy;
  /** The partner who owns the deployment, only applicable for partner level deployments */
  partner?: Maybe<Partner_Partner>;
  /** Revision number for this deployment. This is used to determine whether deployment has been changed at the partner level or course level. */
  revision: Scalars['Int'];
  /** The timestamp at which this deployment was last updated. If this value is null, the revision predates addition of this field. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Name of individual that last updated this deployment.  If this value is null, the revision predates addition of this field. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Wrapper Result type for External App Deployment */
export type LtiPlatform_ExternalAppDeploymentResult = {
  __typename?: 'LtiPlatform_ExternalAppDeploymentResult';
  /** External App Deployment object type */
  externalAppDeployment: LtiPlatform_ExternalAppDeployment;
  /** Depicts if an External App Deployment is being used in a session. Configuration settings of an external App can not be updated if it is being used in any sessions */
  usedInLiveOrArchivedSessions: Scalars['Boolean'];
};

/** Create External app Deployment Input object for LTI v1.1 */
export type LtiPlatform_ExternalAppDeploymentV11Input = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** External App Registration configured for the deployment */
  externalAppRegistration: LtiPlatform_ExternalAppRegistrationV11Input;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/** Create External app Deployment Input object for LTI 1.3 */
export type LtiPlatform_ExternalAppDeploymentV13Input = {
  /** Identifies at what level would the external app be available as part of this config */
  appAvailabilityScope?: InputMaybe<LtiPlatform_AppAvailabilityScope>;
  /** App name configured for the External app deployment */
  appName: Scalars['String'];
  /** Custom Parameters for the deployment */
  customParams?: InputMaybe<Array<LtiPlatform_CustomParamInput>>;
  /** Identifies if the External App is deployed at COURSE OR PARTNER Level */
  deploymentScope?: InputMaybe<LtiPlatform_LtiDeploymentScope>;
  /** External App Registration configured for the deployment */
  externalAppRegistration: LtiPlatform_ExternalAppRegistrationV13Input;
  /** Learner Privacy configured for the External app deployment */
  learnerPrivacy?: InputMaybe<LtiPlatform_LearnerPrivacy>;
};

/** Union type for External App registration of either LTI v1.1 or v1.3 types */
export type LtiPlatform_ExternalAppRegistration = {
  /** Identifier for Curated External App */
  curatedAppKey?: Maybe<LtiPlatform_CuratedAppKey>;
  /** Auto-generated ID of the External App configured Curated or Custom */
  id: Scalars['ID'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Revision number for this registration. This is used to determine whether registration has been changed at the partner level or course level. */
  revision: Scalars['Int'];
  /** The timestamp at which this registration was last updated. If this value is null, the revision predates addition of this field. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Name of individual that last updated this registration.  If this value is null, the revision predates addition of this field. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** External app registration type for LTI V1.1 registration */
export type LtiPlatform_ExternalAppRegistrationV11 = LtiPlatform_ExternalAppRegistration & {
  __typename?: 'LtiPlatform_ExternalAppRegistrationV11';
  /** External App client secret from the external app configuration */
  clientSecret: Scalars['String'];
  /** External App consumer Key from the external app configuration */
  consumerKey: Scalars['String'];
  /** Identifier for Curated External App */
  curatedAppKey?: Maybe<LtiPlatform_CuratedAppKey>;
  /** Auto-generated ID of the External App configured Curated or Custom */
  id: Scalars['ID'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Revision number for this registration. This is used to determine whether registration has been changed at the partner level or course level. */
  revision: Scalars['Int'];
  /** The timestamp at which this registration was last updated. If this value is null, the revision predates addition of this field. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Name of individual that last updated this registration.  If this value is null, the revision predates addition of this field. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Create External app Registration Input object for LTI v1.1 */
export type LtiPlatform_ExternalAppRegistrationV11Input = {
  /** External App client secret from the external app configuration */
  clientSecret: Scalars['String'];
  /** External App consumer Key from the external app configuration */
  consumerKey: Scalars['String'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
};

/** External app registration type for LTI V1.3 registration */
export type LtiPlatform_ExternalAppRegistrationV13 = LtiPlatform_ExternalAppRegistration & {
  __typename?: 'LtiPlatform_ExternalAppRegistrationV13';
  /** OIDC Authorization Request URL configured for the External App */
  authRequestUrl: Scalars['String'];
  /** Platform ClientID identify tool's registration on the platform as part of the Security Contract */
  clientId?: Maybe<Scalars['ID']>;
  /** Identifier for Curated External App */
  curatedAppKey?: Maybe<LtiPlatform_CuratedAppKey>;
  /** Auto-generated ID of the External App configured Curated or Custom */
  id: Scalars['ID'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Redirect URLs configured for the External App */
  redirectUrls: Array<Scalars['String']>;
  /** Revision number for this registration. This is used to determine whether registration has been changed at the partner level or course level. */
  revision: Scalars['Int'];
  /** Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySet;
  /** The timestamp at which this registration was last updated. If this value is null, the revision predates addition of this field. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Name of individual that last updated this registration.  If this value is null, the revision predates addition of this field. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Create External app Registration Input object for LTI v1.3 */
export type LtiPlatform_ExternalAppRegistrationV13Input = {
  /** OIDC Authorization Request URL configured for the External App */
  authRequestUrl: Scalars['String'];
  /** Launch URL configured for the External App */
  launchUrl: Scalars['String'];
  /** Redirect URLs configured for the External App */
  redirectUrls: Array<Scalars['String']>;
  /** Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** Failure Result type for External App Queries/Mutations */
export type LtiPlatform_FailureResponse = {
  __typename?: 'LtiPlatform_FailureResponse';
  /**
   * Deprecated. Use validationErrors instead.
   * @deprecated Use validationErrors instead
   */
  errors?: Maybe<Array<LtiItemAuthoring_AtomicValidationError>>;
  /** List of Errors thrown by relevant Query/Mutation */
  validationErrors?: Maybe<Array<LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation>>;
};

/** Generic validation rule. */
export type LtiPlatform_GenericValidation = ErrorDetails & LtiPlatform_AtomicValidationError & {
  __typename?: 'LtiPlatform_GenericValidation';
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Whether the latest or the highest submitted grade should be kept for this LTI item. */
export const LtiPlatform_GradePreference = {
  /**
   * When the score is submitted, keep the highest score submitted thus far, even if more submissions
   * has been made since.
   */
  Highest: 'HIGHEST',
  /** When the score is submitted, keep the latest score submitted. */
  Latest: 'LATEST'
} as const;

export type LtiPlatform_GradePreference = typeof LtiPlatform_GradePreference[keyof typeof LtiPlatform_GradePreference];
/** Int range validation rule. */
export type LtiPlatform_IntRangeValidation = ErrorDetails & LtiPlatform_AtomicValidationError & {
  __typename?: 'LtiPlatform_IntRangeValidation';
  /** actual field of the validation; value that the field was assigned. */
  actual: Scalars['Int'];
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** includeMax field of the validation; indicates if the Max value is legal for this validation. */
  includeMax?: Maybe<Scalars['Boolean']>;
  /** includeMin field of the validation; indicates if the Min value is legal for this validation. */
  includeMin?: Maybe<Scalars['Boolean']>;
  /** max field of the validation. */
  max?: Maybe<Scalars['Int']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** min field of the validation. */
  min?: Maybe<Scalars['Int']>;
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Identifies whether JSON Web Key Sets is fetched from Jwks URL or an RSA_KEY */
export const LtiPlatform_JwksKeyType = {
  /** Identifies if the LTI v1.3 registration uses a KeySet URL for authentication */
  KeysetUrl: 'KEYSET_URL',
  /** Identifies if the LTI v1.3 registration uses an RSA key for authentication */
  RsaKey: 'RSA_KEY'
} as const;

export type LtiPlatform_JwksKeyType = typeof LtiPlatform_JwksKeyType[keyof typeof LtiPlatform_JwksKeyType];
/**
 * Learner Privacy configured for the LTI item; it's also used in External Apps here:
 * coursera/graphql/ltiplatform/schema/common.graphqls - it's defined here to avoid dragging in an LTI
 * specific dependency into the shared service definition.
 */
export const LtiPlatform_LearnerPrivacy = {
  /** Anonymous Learner Privacy scope; don't share any information when the launch is made */
  Nothing: 'NOTHING',
  /** Learner Privacy scope allowing for the opaque Learner Id to be shared */
  ShareLearnerId: 'SHARE_LEARNER_ID',
  /** Learner Privacy scope allowing for Learner Id and Learner Full name to be shared */
  ShareLearnerIdFullName: 'SHARE_LEARNER_ID_FULL_NAME',
  /**
   * Learner Privacy scope allowing for Learner Id, Learner Full name and Learner Email address to be
   * shared
   */
  ShareLearnerIdFullNameEmailAddress: 'SHARE_LEARNER_ID_FULL_NAME_EMAIL_ADDRESS'
} as const;

export type LtiPlatform_LearnerPrivacy = typeof LtiPlatform_LearnerPrivacy[keyof typeof LtiPlatform_LearnerPrivacy];
/** LTI content */
export type LtiPlatform_LtiContent = ItemPlatform_ItemContent & {
  __typename?: 'LtiPlatform_LtiContent';
  /** Custom parameter map for this LTI item. */
  customParams?: Maybe<Array<LtiPlatform_CustomParam>>;
  /** Learner-facing LTI item description in CML format. */
  description: CmlContent;
  /** External app deployment settings for this item. */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
  /**
   * This flag, indicates whether this item is graded or not.
   * For legacy items, this field is set by the saved item data and is required to maintain the gradedness state of the existing item as we transition them to the v2 UI.
   * For v2 lti items, this is a calculated value. For now, it is determined by the passing threshold but may be revised once we investigate how we want to consolidate the similar/overlapping grade-related fields for LTIs.
   */
  isGraded?: Maybe<Scalars['Boolean']>;
  /**
   * This flag, if present and `true`, indicates that this content belongs to a legacy LTI item. It's
   * illegal for an LTI item to contain a non-null value for the `externalAppDeployment` property
   * and also have this property set to `true`. If the external app hasn't been chosen yet however, the
   * `externalAppDeployment` will not be set, so `isLegacyItem` is needed to distinguish between
   * actual legacy LTI items and External App LTI items for which the external app hasn't been chosen
   * yet.
   */
  isLegacyItem?: Maybe<Scalars['Boolean']>;
  /**
   * Deprecated. Use launchUrlString instead.
   * @deprecated Use launchUrlString instead.
   */
  launchUrl?: Maybe<Scalars['URL']>;
  /**
   * Endpoint for a non-external-app LTI tool to display, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this URL can be used as an override.
   *
   * Note: In case of LTI v1.1, this field is called "Launch URL", and in case of LTI v1.3 it's called
   * "Target Link URI".
   */
  launchUrlString?: Maybe<Scalars['String']>;
  /**
   * Privacy level for a non-external-app LTI tool, or an override in case of an external app LTI item.
   * Even if this is an external app LTI item, this privacy level can be used as an override.
   */
  learnerPrivacy?: Maybe<LtiPlatform_LearnerPrivacy>;
  /** User authored name of the item */
  name: Scalars['String'];
  /**
   * A passing threshold between 0 and 1; eg. 0.8 means 80% passing threshold.
   *
   * Note: Internal models have three values that interact: `ltiType` (`ungraded` or `graded`),
   * `hasGradeCallback` (boolean), and `passingFraction` which only exists if `hasGradeCallback` is
   * set to `true`. Additionally, a callback can be missing only if the `ltiType` is `ungraded`. In
   * this schema, these three fields are collapsed into just the `passingFraction` in external models
   * in the following way:
   *   a) If `passingFraction` is missing or zero: LTI is ungraded and the callback isn't present
   *   b) If `passingFraction` is >0: LTI is graded and the callback is present.
   */
  passingFraction?: Maybe<Scalars['Float']>;
  /** How long a given item is expected to take to complete */
  timeCommitment: Scalars['Duration'];
  /**
   * Determines the LTI protocol version of LTI items not referencing an external app: v1.1 or v1.3.
   * If an external app is referenced, this field should be ignored.
   *
   * This field is introduced because we don't want to "forget" version configuration parameters of
   * the version which currently isn't configured for the item. E.g. if version v1.1 is selected and
   * the authoring user switches to version v1.3, we want to keep all v1.1 configuration parameters in
   * case the user made the edit by mistake and wants to revert it.
   */
  version?: Maybe<LtiPlatform_Version>;
  /**
   * LTI protocol version v1.1 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_1?: Maybe<LtiPlatform_LtiVersionConfigV11>;
  /**
   * LTI protocol version v1.3 for this item.
   * When external app reference is added, this field will only contain potential override values,
   * where applicable.
   */
  versionConfigV1_3?: Maybe<LtiPlatform_LtiVersionConfigV13>;
};

/** Integration level for the External App */
export const LtiPlatform_LtiDeploymentScope = {
  /** Identifies if External App is deployed at Course scope */
  Course: 'COURSE',
  /** Identifies if External App is deployed at Partner scope */
  Partner: 'PARTNER'
} as const;

export type LtiPlatform_LtiDeploymentScope = typeof LtiPlatform_LtiDeploymentScope[keyof typeof LtiPlatform_LtiDeploymentScope];
/** LTI external app deployment input. */
export type LtiPlatform_LtiExternalAppDeploymentInput = {
  /** Deployment id. */
  id: Scalars['ID'];
  /** Revision used to determine if a deployment has been changed. */
  revision: Scalars['Int'];
};

/**
 * LTI external app reference.
 * Fields specific to LTI items which use registered external apps.
 */
export type LtiPlatform_LtiExternalAppReferenceInput = {
  /** Deployment input. Used only for v1.3 items, since there is no separate deployment step for v1.1 items. */
  deployment?: InputMaybe<LtiPlatform_LtiExternalAppDeploymentInput>;
  /** Registration input. */
  registration: LtiPlatform_LtiExternalAppRegistrationInput;
};

/** LTI external app registration input. */
export type LtiPlatform_LtiExternalAppRegistrationInput = {
  /** Registration id. */
  id: Scalars['ID'];
  /** Registration revision used to determine if a registration has been changed. */
  revision: Scalars['Int'];
};

/**
 * LTI protocol version v1.1 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable. In order for the LTI Item to be published, this field must either be omitted, or both fields must be populated.
 */
export type LtiPlatform_LtiVersionConfigV11 = {
  __typename?: 'LtiPlatform_LtiVersionConfigV11';
  /** Client secret from the external app configuration */
  clientSecret?: Maybe<Scalars['String']>;
  /** Consumer Key from the external app configuration */
  consumerKey?: Maybe<Scalars['String']>;
};

/**
 * LTI protocol version v1.1 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable.
 */
export type LtiPlatform_LtiVersionConfigV11Input = {
  /** Client secret from the external app configuration */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Consumer Key from the external app configuration */
  consumerKey?: InputMaybe<Scalars['String']>;
};

/**
 * LTI protocol version v1.3 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable.
 */
export type LtiPlatform_LtiVersionConfigV13 = {
  __typename?: 'LtiPlatform_LtiVersionConfigV13';
  /**
   * Deprecated. Use authRequestUrlString instead.
   * This field must be omitted for V2 LTIs (ie do not provide this value with a null or undefined value).
   * @deprecated Use authRequestUrlString instead.
   */
  authRequestUrl?: Maybe<Scalars['URL']>;
  /**
   * OIDC Authorization Request URL configured for the LTI item.
   * This field must be omitted for V2 LTIs (ie do not provide this value with a null or undefined value).
   */
  authRequestUrlString?: Maybe<Scalars['String']>;
  /** Whether the latest or the highest submitted grade should be kept for this LTI item. */
  gradePreference?: Maybe<LtiPlatform_GradePreference>;
  /**
   * Redirect URLs configured for the LTI item.
   * Skipping pagination for MVP. This field must be omitted for V2 LTIs (ie do not provide this value with a null or undefined value).
   */
  redirectUrlStrings?: Maybe<Array<Scalars['String']>>;
  /**
   * Deprecated. Use redirectUrlStrings instead.
   * This field must be omitted for V2 LTIs (ie do not provide this value with a null or undefined value).
   * @deprecated Use redirectUrlStrings instead.
   */
  redirectUrls?: Maybe<Array<Scalars['URL']>>;
  /** Key in PEM-format that will be used to interact with the platform services and send messages back to the platform. */
  toolPublicKey?: Maybe<Scalars['String']>;
};

/**
 * LTI protocol version v1.3 for this item.
 * When external app reference is added, this field will only contain potential override values,
 * where applicable.
 */
export type LtiPlatform_LtiVersionConfigV13Input = {
  /**
   * Deprecated. Use authRequestUrlString instead.
   * @deprecated Use authRequestUrlString instead.
   */
  authRequestUrl?: InputMaybe<Scalars['URL']>;
  /** OIDC Authorization Request URL configured for the LTI item. */
  authRequestUrlString?: InputMaybe<Scalars['String']>;
  /** Whether the latest or the highest submitted grade should be kept for this LTI item. */
  gradePreference?: InputMaybe<LtiPlatform_GradePreference>;
  /** Redirect URLs configured for the LTI item. */
  redirectUrlStrings?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Deprecated. Use redirectUrlStrings instead.
   * @deprecated Use redirectUrlStrings instead.
   */
  redirectUrls?: InputMaybe<Array<Scalars['URL']>>;
  /**
   * Key in PEM-format that will be used to interact with the platform services and send messages back
   * to the platform.
   */
  toolPublicKey?: InputMaybe<Scalars['String']>;
};

/** Numeric range validation rule. */
export type LtiPlatform_NumericRangeValidation = ErrorDetails & LtiPlatform_AtomicValidationError & {
  __typename?: 'LtiPlatform_NumericRangeValidation';
  /** actual field of the validation; */
  actual: Scalars['Float'];
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** includeMax field of the validation; indicates if the Max value is legal for this validation. */
  includeMax?: Maybe<Scalars['Boolean']>;
  /** includeMin field of the validation; indicates if the Min value is legal for this validation. */
  includeMin?: Maybe<Scalars['Boolean']>;
  /** max field of the validation. */
  max?: Maybe<Scalars['Float']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** min field of the validation. */
  min?: Maybe<Scalars['Float']>;
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Platform KeySet Configuration */
export type LtiPlatform_PlatformAccessConfig = {
  __typename?: 'LtiPlatform_PlatformAccessConfig';
  /** Platform access token URL to be pasted on the external app configuration */
  accessTokenUrl?: Maybe<Scalars['String']>;
  /** Platform Issuer to be pasted on the external app configuration */
  issuer?: Maybe<Scalars['String']>;
  /** Platform OIDC login initiation URL to be pasted on the external app configuration */
  openIdConnectUrl?: Maybe<Scalars['String']>;
  /** Platform Keyset URL to be pasted on the external app configuration */
  platformKeySetUrl?: Maybe<Scalars['String']>;
};

/** Wrapper object for Update input for deployment availability scope */
export type LtiPlatform_SetExternalAppAppAvailabilityScope = {
  /** Update input for deployment availability scope */
  appAvailabilityScope: LtiPlatform_AppAvailabilityScope;
};

/** Wrapper object for Update input for External app Registration Auth request url */
export type LtiPlatform_SetExternalAppAuthRequestUrl = {
  /** Update input for External app Registration OIDC Auth request url */
  authRequestUrl: Scalars['String'];
};

/** Wrapper object for Update input for Client Secret */
export type LtiPlatform_SetExternalAppClientSecret = {
  /** Update input for Client Secret */
  clientSecret: Scalars['String'];
};

/** Wrapper object for Update input for Consumer Key */
export type LtiPlatform_SetExternalAppConsumerKey = {
  /** Update input for Consumer Key */
  consumerKey: Scalars['String'];
};

/** Wrapper object for Update input for deployment custom parameters */
export type LtiPlatform_SetExternalAppCustomParams = {
  /** Update input for deployment custom parameters */
  customParams: Array<InputMaybe<LtiPlatform_CustomParamInput>>;
};

/** Wrapper object for Update input for External app Registration launch url */
export type LtiPlatform_SetExternalAppLaunchUrl = {
  /** Update input for External app Registration launch url */
  launchUrl: Scalars['String'];
};

/** Wrapper object for Update input for Learner Privacy */
export type LtiPlatform_SetExternalAppLearnerPrivacy = {
  /** Update input for Learner Privacy */
  learnerPrivacy: LtiPlatform_LearnerPrivacy;
};

/** Wrapper object for Update input for app name */
export type LtiPlatform_SetExternalAppName = {
  /** Update input for app name */
  appName: Scalars['String'];
};

/** Wrapper object for Update input for External app Registration redirect url */
export type LtiPlatform_SetExternalAppRedirectUrls = {
  /** Update input for External app Registration redirect url */
  redirectUrl: Array<Scalars['String']>;
};

/** Wrapper object for Update input for External app Registration Id for External App deployment */
export type LtiPlatform_SetExternalAppRegistrationId = {
  /** Update input for External app Registration Id for External App deployment */
  registrationId: Scalars['ID'];
};

/** Wrapper object for Update input for External app Registration JWKS Key type */
export type LtiPlatform_SetExternalAppToolKeySet = {
  /** Update input Key set with Jwks/Public key type and value */
  toolKeySet: LtiPlatform_ToolKeySetInput;
};

/** Text length validation rule. */
export type LtiPlatform_TextLengthValidation = ErrorDetails & LtiPlatform_AtomicValidationError & {
  __typename?: 'LtiPlatform_TextLengthValidation';
  /** actualLength field of the validation; actual number of characters in the text field. */
  actualLength: Scalars['Int'];
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** maxLength field of the validation; indicates maximum length in characters. */
  maxLength?: Maybe<Scalars['Int']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** minLength field of the validation; indicates minimum length in characters. */
  minLength?: Maybe<Scalars['Int']>;
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** External App Key set with Jwks/Public key type and value */
export type LtiPlatform_ToolKeySet = {
  __typename?: 'LtiPlatform_ToolKeySet';
  /** Keyset key type configured for the External App */
  keyType: LtiPlatform_JwksKeyType;
  /** Key value configured for the External App */
  keyValue: Scalars['String'];
};

/** External App Key set with Jwks/Public key type and value */
export type LtiPlatform_ToolKeySetInput = {
  /** Keyset key type configured for the External App */
  keyType: LtiPlatform_JwksKeyType;
  /** Key value configured for the External App */
  keyValue: Scalars['String'];
};

/** Update External app Deployment for a Course Input object */
export type LtiPlatform_UpdateExternalAppDeploymentForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for update a new LTI Deployment for External App */
  externalAppDeploymentInput: LtiPlatform_UpdateExternalAppDeploymentInput;
};

/** Success/Failure Result Wrapper type for Update External app Deployment */
export type LtiPlatform_UpdateExternalAppDeploymentForCourseResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppDeploymentForCourseResultSuccess;

/** External app Update Deployment Result Wrapper type */
export type LtiPlatform_UpdateExternalAppDeploymentForCourseResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppDeploymentForCourseResultSuccess';
  /** External app Update Deployment Result */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
};

/** Update External app Deployment for a Partner Input object */
export type LtiPlatform_UpdateExternalAppDeploymentForPartnerInput = {
  /** Input Object for update a new LTI Deployment for External App (Curated or Custom) */
  externalAppDeploymentInput: LtiPlatform_UpdateExternalAppDeploymentInput;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure Result Wrapper type for Update External app Deployment */
export type LtiPlatform_UpdateExternalAppDeploymentForPartnerResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppDeploymentForPartnerResultSuccess;

/** External app Update Deployment Result Wrapper type */
export type LtiPlatform_UpdateExternalAppDeploymentForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppDeploymentForPartnerResultSuccess';
  /** External app Update Deployment Result */
  externalAppDeployment?: Maybe<LtiPlatform_ExternalAppDeployment>;
};

/** Update External app Deployment for a Partner Input object */
export type LtiPlatform_UpdateExternalAppDeploymentInput = {
  /** External app Deployment Input object identifier */
  id: Scalars['ID'];
  /** External app Deployment Input Availability scope */
  setAppAvailabilityScope?: InputMaybe<LtiPlatform_SetExternalAppAppAvailabilityScope>;
  /** External app Deployment Input App name */
  setAppName?: InputMaybe<LtiPlatform_SetExternalAppName>;
  /** External app Deployment Input Custom Parameters */
  setCustomParams?: InputMaybe<LtiPlatform_SetExternalAppCustomParams>;
  /** External app Deployment Input Learner Privacy */
  setLearnerPrivacy?: InputMaybe<LtiPlatform_SetExternalAppLearnerPrivacy>;
  /** External app Deployment Input Registration id for the referred registration object */
  setRegistrationId?: InputMaybe<LtiPlatform_SetExternalAppRegistrationId>;
};

/** Update External app Registration for a Partner Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForCourseInput = {
  /** Course identifier */
  courseId: Scalars['ID'];
  /** Input Object for updating a LTI v1.1 Registration for App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV11Input>;
};

/** Success/Failure Result Wrapper type for Update LTI v1.1 External app Registration */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForCourseResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppRegistrationV11ForCourseResultSuccess;

/** External app Update Registration Result Wrapper type for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForCourseResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppRegistrationV11ForCourseResultSuccess';
  /** External app Update Registration Result for LTI v1.1 */
  externalAppRegistration?: Maybe<LtiPlatform_ExternalAppRegistrationV11 | LtiPlatform_ExternalAppRegistrationV13>;
};

/** Update External app Registration for a Partner Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerInput = {
  /** Input Object for updating a LTI v1.1 Registration for Custom App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV11Input>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure Result Wrapper type for Update LTI v1.1 External app Registration */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerResultSuccess;

/** External app Update Registration Result Wrapper type for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerResultSuccess';
  /** External app Update Registration Result for LTI v1.1 */
  externalAppRegistration?: Maybe<LtiPlatform_ExternalAppRegistrationV11 | LtiPlatform_ExternalAppRegistrationV13>;
};

/** Update External app Registration Input object for LTI v1.1 */
export type LtiPlatform_UpdateExternalAppRegistrationV11Input = {
  /** External app Registration Input object identifier */
  id: Scalars['ID'];
  /** External app Registration Input client secret */
  setClientSecret?: InputMaybe<LtiPlatform_SetExternalAppClientSecret>;
  /** External app Registration Input consumer key */
  setConsumerKey?: InputMaybe<LtiPlatform_SetExternalAppConsumerKey>;
  /** External app Registration Input launch Url */
  setLaunchUrl?: InputMaybe<LtiPlatform_SetExternalAppLaunchUrl>;
};

/** Update External app Registration for a Course Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForCourseInput = {
  /** course identifier */
  courseId: Scalars['ID'];
  /** Input Object for updating a LTI v1.3 Registration for   App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV13Input>;
};

/** Success/Failure Result Wrapper type for Update LTI v1.3 External app Registration */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForCourseResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppRegistrationV13ForCourseResultSuccess;

/** External app Update Registration Result Wrapper type for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForCourseResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppRegistrationV13ForCourseResultSuccess';
  /** External app Update Registration Result for LTI v1.3 */
  externalAppRegistration?: Maybe<LtiPlatform_ExternalAppRegistrationV11 | LtiPlatform_ExternalAppRegistrationV13>;
};

/** Update External app Registration for a Partner Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerInput = {
  /** Input Object for updating a LTI v1.3 Registration for Curated App */
  externalAppRegistrationInput?: InputMaybe<LtiPlatform_UpdateExternalAppRegistrationV13Input>;
  /** Partner identifier */
  partnerId: Scalars['ID'];
};

/** Success/Failure Result Wrapper type for Update LTI v1.3 External app Registration */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerResult = LtiPlatform_FailureResponse | LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerResultSuccess;

/** External app Update Registration Result Wrapper type for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerResultSuccess = {
  __typename?: 'LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerResultSuccess';
  /** External app Update Registration Result for LTI v1.3 */
  externalAppRegistration?: Maybe<LtiPlatform_ExternalAppRegistrationV11 | LtiPlatform_ExternalAppRegistrationV13>;
};

/** Update External app Registration Input object for LTI v1.3 */
export type LtiPlatform_UpdateExternalAppRegistrationV13Input = {
  /** External app Registration Input object identifier */
  id: Scalars['ID'];
  /** External app Registration Input OIDC Auth request Url */
  setAuthRequestUrl?: InputMaybe<LtiPlatform_SetExternalAppAuthRequestUrl>;
  /** External app Registration Input launch Url */
  setLaunchUrl?: InputMaybe<LtiPlatform_SetExternalAppLaunchUrl>;
  /** External app Registration Input Redirect Urls */
  setRedirectUrls?: InputMaybe<LtiPlatform_SetExternalAppRedirectUrls>;
  /** External app Registration Input Key set with Jwks/Public key type and value */
  setToolKeySet?: InputMaybe<LtiPlatform_SetExternalAppToolKeySet>;
};

/** Input for the LtiPlatform_UpdateLtiDraft mutation. */
export type LtiPlatform_UpdateLtiDraftInput = {
  /** Id of the underlying LTI atom to update. */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made. */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: LtiPlatform_DraftContentInput;
};

/** Result union for the LtiPlatform_UpdateLtiDraft mutation. */
export type LtiPlatform_UpdateLtiDraftResult = LtiPlatform_ConflictResponse | LtiPlatform_FailureResponse | LtiPlatform_UpdateLtiDraftSuccess;

/**
 * Result for the LtiPlatform_UpdateLtiDraft mutation. If an error occurs, a native GraphQL error
 * reporting mechanism will kick in, so no error entity is needed here.
 */
export type LtiPlatform_UpdateLtiDraftSuccess = {
  __typename?: 'LtiPlatform_UpdateLtiDraftSuccess';
  /** The updated LTI item. */
  item: ItemPlatform_AuthoringItem;
  /** Validation results of the draft contained in the item field. */
  validationErrors?: Maybe<Array<LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation>>;
};

/** All possible validation statuses. */
export const LtiPlatform_ValidationErrorStatus = {
  /** BAD_REFERENCE validation status. */
  BadReference: 'BAD_REFERENCE',
  /** DUPLICATE validation status. */
  Duplicate: 'DUPLICATE',
  /** EMPTY validation status. */
  Empty: 'EMPTY',
  /** ENUM validation status. */
  Enum: 'ENUM',
  /** FORMAT validation status. */
  Format: 'FORMAT',
  /** LOCKED validation status. */
  Locked: 'LOCKED',
  /** NON_EMPTY validation status. */
  NonEmpty: 'NON_EMPTY',
  /** OTHER validation status. */
  Other: 'OTHER',
  /** OVERLAP validation status. */
  Overlap: 'OVERLAP',
  /** TOO_LARGE validation status. */
  TooLarge: 'TOO_LARGE',
  /** TOO_LONG validation status. */
  TooLong: 'TOO_LONG',
  /** TOO_SHORT validation status. */
  TooShort: 'TOO_SHORT',
  /** TOO_SMALL validation status. */
  TooSmall: 'TOO_SMALL'
} as const;

export type LtiPlatform_ValidationErrorStatus = typeof LtiPlatform_ValidationErrorStatus[keyof typeof LtiPlatform_ValidationErrorStatus];
/** Determines the LTI protocol version of LTI items not referencing an external app: v1.1 or v1.3. */
export const LtiPlatform_Version = {
  /** This LTI item uses the LTI protocol version 1.1 */
  V1_1: 'V1_1',
  /** This LTI item uses the LTI protocol version 1.3 */
  V1_3: 'V1_3'
} as const;

export type LtiPlatform_Version = typeof LtiPlatform_Version[keyof typeof LtiPlatform_Version];
/** Word count validation rule. */
export type LtiPlatform_WordCountValidation = ErrorDetails & LtiPlatform_AtomicValidationError & {
  __typename?: 'LtiPlatform_WordCountValidation';
  /** actualCount field of the validation; number of words that were assigned in the text. */
  actualCount: Scalars['Int'];
  /**
   * errorCode is a custom code when used with one of the
   * predefined shared/standard error.
   *
   * When developer defines a new custom error using ErrorDetails interface
   * then they could use the name of the custom error as code.
   */
  errorCode: Scalars['String'];
  /** Name of the field to which the validation pertains to, if any. */
  fieldName?: Maybe<Scalars['String']>;
  /** maxCount field of the validation. */
  maxCount?: Maybe<Scalars['Int']>;
  /** A validation message, describing with more detail how validation isn't satisfied. */
  message: Scalars['String'];
  /** minCount field of the validation. */
  minCount?: Maybe<Scalars['Int']>;
  /** Path of the error. */
  path: Scalars['String'];
  /**
   * Validation error status, indicating how the validation isn't satisfied. Valid statuses aren't
   * communicated to the client, only potential errors.
   */
  status: LtiPlatform_ValidationErrorStatus;
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueries = {
  __typename?: 'LtiToolQueries';
  /**
   * Returns the full set of programs for an organization for admin selection in
   * Program Access Control. Requires admin permission on the organization.
   */
  getAdminPrograms: LtiTool_AdminProgramList;
  /** Get all LMS platform configurations for a given organization */
  getAllPlatformConfigsByOrganization: Array<LtiTool_PlatformConfig>;
  /**
   * Get the deep-linked content summary for an LMS context.
   *
   * Sourced from DeepLinkLaunch.itemsSelected (covers every linked content type, including videos).
   * Each row is enriched with a dueDate from the corresponding grading preference when one exists.
   *
   * Reachable by both INSTRUCTOR and LEARNER sessions — the resolver projects role-aware fields
   * based on session.role. Authorization: the LtiLoginSessionAspect validates the LTI_LOGIN_SESSION
   * cookie and enforces session.contextId == contextId (CONTEXT_MISMATCH on disagreement — protects
   * cross-tab cookie overwrites). After validation the resolver reads organizationId, role, and the
   * source-shell contextId off the session; the GraphQL-level @authorization is core.public so the
   * request reaches the resolver where the cookie is validated.
   */
  getCourseShellSummary: LtiTool_CourseShellSummary;
  /** Get deep linking context for instructor */
  getDeepLinkingInstructorContext: LtiTool_DeepLinkingInstructorContext;
  /**
   * Instructor-facing learner progress for one deep-linked content item within an
   * LMS course shell. The shell (contextId) is bound-checked against the caller's
   * active LTI session — a caller cannot read a shell it did not launch from. The
   * content is identified by the (courseId, moduleId?, itemId?) triple; item type
   * is derived server-side (itemId → ITEM, moduleId → MODULE, else COURSE).
   *
   * Authorization: the GraphQL-level @authorization is core.public so the request
   * reaches the resolver, where @RequiresLtiInstructorRole validates the
   * LTI_LOGIN_SESSION cookie, enforces session.role == INSTRUCTOR, and binds
   * session.contextId == contextId (CONTEXT_MISMATCH on disagreement). contextId
   * is a top-level arg (not nested in an input) so the aspect resolves it on its
   * Phase-1 by-name path — matching the getCourseShellSummary precedent.
   */
  getLearnerProgress: LtiTool_LearnerProgressPage;
  /** Get list of supported LMS names for platform configuration dropdown */
  getLmsNames: Array<LtiTool_LmsName>;
  /**
   * Returns the role and context derived from the LtiLoginSession identified by
   * the LTI_LOGIN_SESSION cookie + the requested contextId. Used by the
   * Coursera-hosted hub page on load to decide whether to render the instructor
   * or learner view.
   *
   * The contextId argument disambiguates which shell the caller is asking about
   * when an instructor has launched parallel hub tabs across multiple LMS shells
   * in the same browser (the cookie is last-write-wins; URL contextId tells the
   * backend which session to resolve).
   *
   * Authorization is enforced by the LtiLoginSessionInterceptor (cookie-based);
   * the GraphQL-level @authorization is core.public so the request is allowed to
   * reach the resolver where the cookie can be validated. The resolver surfaces
   * SESSION_MISSING / SESSION_EXPIRED error codes when the cookie is missing or
   * the session is no longer valid.
   */
  getLtiHubContext: LtiTool_LtiHubContext;
  /**
   * Get organization configuration for LTI integrations
   * Returns default values if config doesn't exist: nrpsGradeSyncEnabled=true, lookBackPeriodDays=30
   */
  getOrgConfig: LtiTool_OrgConfig;
  /** Get all LMS platform configuration by its IDs */
  getPlatformConfigsByIds: Array<LtiTool_PlatformConfig>;
  /** Get Product materials (modules, lessons, and items) for a product within a program */
  getProductDetails: LtiTool_ProductDetails;
  /** Get all enterprise programs for a given organization */
  getPrograms: Array<LtiTool_Program>;
  /**
   * Get every active LMS registration for an organization, each with its own
   * program access control state. Powers the settings-page list view (one row
   * per LMS registration, e.g. two separate Moodle registrations under one org).
   *
   * Note: @authorization below only enforces core.loggedIn. Admin permission for
   * the requested organizationId is enforced by the resolver (lti-tool-application),
   * not by a schema-level authorizer — same pattern as existing queries like
   * getOrgConfig.
   */
  getRegistrationsWithProgramAccessControl: Array<LtiTool_RegistrationProgramAccessControl>;
  /**
   * Returns details for a Specialization or Professional Certificate.
   * Returns federation stubs for the s12n and its constituent courses —
   * all displayable fields resolve via the gateway.
   *
   * Authorization: the GraphQL-level @authorization is core.public so the request
   * reaches the resolver, where @RequiresDeepLinkingSession validates the
   * X-Coursera-Lti-Tool-Application-Deep-Link-Session-Token header — mirroring
   * searchProducts / getProductDetails / getDeepLinkingInstructorContext /
   * deepLinkingSubmit. The LTI deep-linking instructor flow does not carry a
   * CAUTH cookie, so core.loggedIn would reject every LMS-originated call before
   * the resolver runs.
   */
  getSpecializationDetails?: Maybe<LtiTool_SpecializationDetails>;
  /** Get metadata about the Coursera LTI tool */
  getToolMetadata: LtiTool_ToolMetadata;
  /** Search for courses using the Coursera Search API */
  searchProducts: LtiTool_ProductSearchHitPaginatedResult;
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetAdminProgramsArgs = {
  input: LtiTool_AdminProgramsInput;
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetAllPlatformConfigsByOrganizationArgs = {
  organizationId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetCourseShellSummaryArgs = {
  contextId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetLearnerProgressArgs = {
  contextId: Scalars['ID'];
  courseId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<LtiTool_LearnerProgressFilterInput>;
  itemId?: InputMaybe<Scalars['ID']>;
  moduleId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
  s12nId?: InputMaybe<Scalars['ID']>;
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetLtiHubContextArgs = {
  contextId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetOrgConfigArgs = {
  organizationId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetPlatformConfigsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetProductDetailsArgs = {
  courseId: Scalars['ID'];
  programId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetProgramsArgs = {
  organizationId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetRegistrationsWithProgramAccessControlArgs = {
  organizationId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesGetSpecializationDetailsArgs = {
  programId: Scalars['ID'];
  s12nId: Scalars['ID'];
};


/** LTI Tool query operations for platform configurations and metadata */
export type LtiToolQueriesSearchProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: LtiTool_SearchProductInput;
  limit?: Scalars['Int'];
};

/** Input type for adding a new LTI platform configuration. */
export type LtiTool_AddPlatformConfigInput = {
  /** Authorization endpoint URL */
  authEndpoint: Scalars['URL'];
  /** Client ID */
  clientId: Scalars['ID'];
  /** Deployment ID */
  deploymentId: Scalars['ID'];
  /** Environment (e.g., "production", "test") */
  environment: LtiTool_Environment;
  /** Issuer URL */
  issuer: Scalars['URL'];
  /** JWKS URL */
  jwksUrl: Scalars['URL'];
  /** LMS type selected from the dropdown */
  lmsName?: InputMaybe<LtiTool_LmsName>;
  /** Name of the platform */
  name: Scalars['String'];
  /** organization ID */
  organizationId: Scalars['ID'];
  /** Custom LMS name when lmsName is OTHERS */
  otherLmsName?: InputMaybe<Scalars['String']>;
  /** Token endpoint URL. Optional for LCMS-only registrations (e.g. Talentsoft LCMS). */
  tokenEndpoint?: InputMaybe<Scalars['URL']>;
};

/** Add Platform configuration result */
export type LtiTool_AddPlatformConfigResult = {
  __typename?: 'LtiTool_AddPlatformConfigResult';
  /** Added successfully or not */
  result: Scalars['Boolean'];
};

/** Input type for adding or updating LTI tool metadata. */
export type LtiTool_AddToolMetadataInput = {
  /** Deep linking URL of the tool */
  deepLinkingUrl: Scalars['URL'];
  /** The initiate login url of the tool */
  initiateLoginUrl: Scalars['URL'];
  /** The URL to the tool's JWKS endpoint */
  jwksUrl: Scalars['URL'];
  /** The launch url of the tool */
  launchUrl: Scalars['URL'];
  /** Redirect URL of the tool */
  redirectUrls: Array<Scalars['URL']>;
};

/** Add Tool metadata result */
export type LtiTool_AddToolMetadataResult = {
  __typename?: 'LtiTool_AddToolMetadataResult';
  /** Added successfully or not */
  result: Scalars['Boolean'];
};

/**
 * Wrapper for the admin Program Access Control selection dialog response.
 * Returned non-paginated; the dialog filters and sorts client-side.
 */
export type LtiTool_AdminProgramList = {
  __typename?: 'LtiTool_AdminProgramList';
  /** All programs available for selection. */
  programs: Array<LtiTool_Program>;
  /** Total number of programs returned. */
  totalCount: Scalars['Int'];
};

/**
 * Input for fetching the full org program catalog for the admin Program Access
 * Control selection dialog.
 */
export type LtiTool_AdminProgramsInput = {
  /** Third party organization ID */
  organizationId: Scalars['ID'];
};

/** Detail of a single platform config LMS name backfill operation */
export type LtiTool_BackfillLmsNameDetail = {
  __typename?: 'LtiTool_BackfillLmsNameDetail';
  /** Issuer URL of the platform */
  issuer: Scalars['URL'];
  /** New LMS name to be set */
  newLmsName: Scalars['String'];
  /** Platform configuration ID */
  platformConfigId: Scalars['ID'];
  /** Previous LMS name (null if not set) */
  previousLmsName?: Maybe<Scalars['String']>;
  /** Status of the backfill operation for this config */
  status: LtiTool_BackfillStatus;
};

/** Input type for backfilling LMS names in platform configurations. */
export type LtiTool_BackfillLmsNamesInput = {
  /** Default LMS name for issuers not in the mapping. Defaults to "OTHERS" if not provided. */
  defaultLmsName?: InputMaybe<Scalars['String']>;
  /** If true, only returns what would be updated without persisting changes */
  dryRun: Scalars['Boolean'];
  /** List of issuer URL to LMS name mappings */
  issuerToLmsNameMappings: Array<LtiTool_IssuerLmsNameMapping>;
};

/** Result of backfilling LMS names in platform configurations */
export type LtiTool_BackfillLmsNamesResult = {
  __typename?: 'LtiTool_BackfillLmsNamesResult';
  /** Details of each update for auditing */
  details: Array<LtiTool_BackfillLmsNameDetail>;
  /** Whether this was a dry-run */
  dryRun: Scalars['Boolean'];
  /** Number of configs that failed to update */
  failedCount: Scalars['Int'];
  /** Number of configs that were skipped (already had correct value or null issuer) */
  skippedCount: Scalars['Int'];
  /** Total number of platform configs processed */
  totalProcessed: Scalars['Int'];
  /** Number of configs that were updated (or would be in dry-run) */
  updatedCount: Scalars['Int'];
};

/** Status of a backfill operation */
export const LtiTool_BackfillStatus = {
  /** Failed to update */
  Failed: 'FAILED',
  /** Skipped because value already matches or issuer is null */
  Skipped: 'SKIPPED',
  /** Successfully updated (or would be updated in dry-run) */
  Updated: 'UPDATED'
} as const;

export type LtiTool_BackfillStatus = typeof LtiTool_BackfillStatus[keyof typeof LtiTool_BackfillStatus];
/**
 * Whether (and how) the picker should surface the "Coursera Activity Tracker" Banner CTA
 * for an LMS course shell. See LtiTool_DeepLinkingInstructorContext.courseActivityTrackerState.
 */
export const LtiTool_CourseActivityTrackerState = {
  /** Non-Tracker content exists and no Tracker is placed yet; offer creation. */
  Creatable: 'CREATABLE',
  /** No prior non-Tracker content placed in the shell; the Tracker CTA is hidden. */
  None: 'NONE',
  /** A Tracker already exists in the shell; offer re-creation. */
  Recreatable: 'RECREATABLE'
} as const;

export type LtiTool_CourseActivityTrackerState = typeof LtiTool_CourseActivityTrackerState[keyof typeof LtiTool_CourseActivityTrackerState];
/** A single linked content entry within a course shell summary. */
export type LtiTool_CourseShellItem = {
  __typename?: 'LtiTool_CourseShellItem';
  /** Certificate URL for LEARNER responses. Always null in Phase 2. */
  certificateUrl?: Maybe<Scalars['URL']>;
  /**
   * When the viewing learner completed this content — the learner-progress
   * snapshot's lastActivity at the point it reached COMPLETED. Populated for
   * LEARNER responses whose content status is COMPLETED; null otherwise (e.g.
   * NOT_STARTED / IN_PROGRESS) and always null for INSTRUCTOR.
   */
  completedOn?: Maybe<Scalars['DateTime']>;
  /** Display name of the linked content (from itemsSelected.title). */
  contentName: Scalars['String'];
  /** Derived content granularity: itemId present → ITEM; moduleId only → MODULE; neither → COURSE. */
  contentType: LtiTool_DeepLinkingContentItemLinkType;
  /**
   * Coursera course ID linked in this entry. Null for SPECIALIZATION /
   * PROFESSIONAL_CERTIFICATE entries, which represent a multi-course bundle as a
   * whole and have no single constituent course — those are identified by s12nId.
   */
  courseId?: Maybe<Scalars['ID']>;
  /** When the DeepLinkLaunch that produced this entry was created. */
  createdAt: Scalars['DateTime'];
  /**
   * Due date sourced from the matching grading preference. Null when no grading
   * preference exists for this entry (e.g. videos).
   */
  dueDate?: Maybe<Scalars['DateTime']>;
  /**
   * Number of enrolled learners. Populated for INSTRUCTOR responses; null for LEARNER.
   * Always null in Phase 2 — pending wiring to the enrollments source.
   */
  enrolledLearners?: Maybe<Scalars['Int']>;
  /** Whether this entry is gradable. */
  gradable?: Maybe<Scalars['Boolean']>;
  /** Item ID — present for ITEM-level links only. */
  itemId?: Maybe<Scalars['ID']>;
  /** Max score for the line item (relevant for gradable entries). */
  maxScore?: Maybe<Scalars['Float']>;
  /** Module ID — present for MODULE and (optionally) ITEM links. */
  moduleId?: Maybe<Scalars['ID']>;
  /** Enterprise program ID associated with the linked course. */
  programId?: Maybe<Scalars['ID']>;
  /**
   * Specialization / Professional Certificate base ID (stable, version-independent
   * UUID). Present only for SPECIALIZATION / PROFESSIONAL_CERTIFICATE entries,
   * where the bundle is surfaced as one row; null for all course/module/item
   * entries (which are identified by courseId).
   */
  s12nId?: Maybe<Scalars['ID']>;
  /** Deep linking session this entry originated from (DeepLinkLaunch.sessionId). */
  sessionId: Scalars['ID'];
};

/**
 * Course shell summary for an LMS context. Flattens every linked content entry
 * across all DeepLinkLaunch sessions for the context. The caller role is not
 * echoed here — read it from LtiTool_LtiHubContext.role, which is the canonical
 * session-derived source.
 */
export type LtiTool_CourseShellSummary = {
  __typename?: 'LtiTool_CourseShellSummary';
  /** LMS course shell identifier (from the LTI context.id claim) for this summary. */
  contextId: Scalars['ID'];
  /** Display name of the LMS course shell (from the LTI context.title claim). */
  contextTitle?: Maybe<Scalars['String']>;
  /** One entry per item in DeepLinkLaunch.itemsSelected across all launches for the context. */
  items: Array<LtiTool_CourseShellItem>;
};

/** Grading Preference for the content enum */
export const LtiTool_DeepLinkingContentGradingType = {
  /** Grade will be final for single/multi assignment projects */
  Final: 'FINAL',
  /** Grade will be assigned on individual item level */
  ItemLevel: 'ITEM_LEVEL'
} as const;

export type LtiTool_DeepLinkingContentGradingType = typeof LtiTool_DeepLinkingContentGradingType[keyof typeof LtiTool_DeepLinkingContentGradingType];
/** Content item to be linked in the LMS */
export type LtiTool_DeepLinkingContentItemInput = {
  /**
   * Coursera course ID. Required for content-bound link types (COURSE, MODULE, ITEM, VIDEO).
   * Null for COURSE_ACTIVITY (single-placement hub link with no course binding).
   * Enforced at the manager layer per link type.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Description of the content item */
  description?: InputMaybe<Scalars['String']>;
  /** Whether the content item is gradable */
  gradable: Scalars['Boolean'];
  /** Optional due date for grade sync (UTC). Grade sync stops after this date. */
  gradeSyncDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Grading Preference for the content */
  gradingPreference?: InputMaybe<LtiTool_DeepLinkingContentGradingType>;
  /** Optional specific item ID within the course */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Deep linking type */
  linkType: LtiTool_DeepLinkingContentItemLinkType;
  /** Maximum score for gradable items */
  maxScore?: InputMaybe<Scalars['Float']>;
  /** Module ID within the course for Module level linking */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Module index within the course for Module level linking */
  moduleIndex?: InputMaybe<Scalars['Int']>;
  /**
   * Coursera program ID. Required for content-bound link types (COURSE, MODULE, ITEM, VIDEO).
   * Null for COURSE_ACTIVITY (single-placement hub link with no program binding).
   * Enforced at the manager layer per link type.
   */
  programId?: InputMaybe<Scalars['ID']>;
  /** Coursera specialization/professional_certificate Id */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** Title of the content item */
  title: Scalars['String'];
};

/** Deep linking content item link types */
export const LtiTool_DeepLinkingContentItemLinkType = {
  /** Coursera Course level linking */
  Course: 'COURSE',
  /**
   * Single-placement Coursera Activity Tracker link for cert / progress / due-date hub.
   * Carries no programId or courseId in the deep-linking content item input.
   */
  CourseActivity: 'COURSE_ACTIVITY',
  /** Coursera guided project linking */
  GuidedProject: 'GUIDED_PROJECT',
  /** Coursera Item level linking */
  Item: 'ITEM',
  /** Coursera Module level linking */
  Module: 'MODULE',
  /** Coursera professional certificate level linking */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Coursera standalone project linking */
  Project: 'PROJECT',
  /** Coursera specialization level linking */
  Specialization: 'SPECIALIZATION',
  /** Coursera Video level linking */
  Video: 'VIDEO'
} as const;

export type LtiTool_DeepLinkingContentItemLinkType = typeof LtiTool_DeepLinkingContentItemLinkType[keyof typeof LtiTool_DeepLinkingContentItemLinkType];
/** Deep linking context for instructor to select and link content */
export type LtiTool_DeepLinkingInstructorContext = {
  __typename?: 'LtiTool_DeepLinkingInstructorContext';
  /**
   * contextId (LMS course id) for the deep linking request. Nullable because LCMS-style
   * authoring surfaces (e.g. Cegid Talentsoft LCMS) initiate LtiDeepLinkingRequest
   * without a course context — the LTI 1.3 context claim is optional and absent there.
   */
  contextId?: Maybe<Scalars['ID']>;
  /**
   * What the picker should do with the "Coursera Activity Tracker" Banner CTA for this
   * LMS course shell. Drives a three-way decision on the FE: hide it, offer creation, or
   * offer re-creation.
   *
   * Computed by querying prior deep-linking sessions for the same (deploymentId,
   * contextId). A placed Tracker takes precedence (one-per-shell):
   *   * RECREATABLE  — a Tracker placement already exists in the shell.
   *   * CREATABLE    — no Tracker yet, but at least one prior placement of non-Tracker
   *                    Coursera content exists (gate from product: do not surface the
   *                    Tracker before the instructor has placed something for it to track).
   *   * NONE         — neither of the above; hide the CTA.
   */
  courseActivityTrackerState: LtiTool_CourseActivityTrackerState;
  /** Settings for the deep linking request */
  deepLinkingSettings: LtiTool_DeepLinkingSettings;
  /** Deployment ID for the LTI platform */
  deploymentId: Scalars['ID'];
  /** Information about the instructor initiating the deep linking */
  instructorInfo: LtiTool_DeepLinkingInstructorInfo;
  /**
   * LMS platform the deep-linking session originates from (e.g. MOODLE, CANVAS,
   * BLACKBOARD, TALENTSOFT), as recorded on the platform registration.
   *
   * Nullable: legacy registrations may not have an LMS name recorded. Registrations whose
   * recorded name does not match a known LMS are reported as OTHERS.
   */
  lmsName?: Maybe<LtiTool_LmsName>;
  /** Organization ID for the instructor */
  organizationId: Scalars['ID'];
  /** Unique session identifier for the deep linking request */
  sessionId: Scalars['ID'];
};

/** Information about the instructor making the deep linking request */
export type LtiTool_DeepLinkingInstructorInfo = {
  __typename?: 'LtiTool_DeepLinkingInstructorInfo';
  /** Display name of the instructor */
  displayName?: Maybe<Scalars['String']>;
  /** LTI user ID of the instructor */
  ltiUserId: Scalars['ID'];
  /** LTI roles assigned to the instructor */
  roles: Array<Scalars['String']>;
};

/** Settings for the deep linking request from the LMS platform */
export type LtiTool_DeepLinkingSettings = {
  __typename?: 'LtiTool_DeepLinkingSettings';
  /** Whether multiple content items can be selected */
  acceptMultiple: Scalars['Boolean'];
  /** Types of content that can be accepted (e.g., "link", "ltiResourceLink") */
  acceptTypes: Array<Scalars['String']>;
  /** Optional data to be echoed back in the response */
  data?: Maybe<Scalars['String']>;
  /** URL to return the deep linking response to */
  deepLinkReturnUrl: Scalars['URL'];
};

/** Input for submitting deep linking content items */
export type LtiTool_DeepLinkingSubmitInput = {
  /** List of content items to be linked */
  items: Array<LtiTool_DeepLinkingContentItemInput>;
};

/** Result of deep linking submission with JWT and return URL */
export type LtiTool_DeepLinkingSubmitResult = {
  __typename?: 'LtiTool_DeepLinkingSubmitResult';
  /** JWT token containing the deep linking response message */
  jwt: Scalars['String'];
  /** URL to return to the LMS platform */
  returnUrl: Scalars['URL'];
};

/**
 * Input for soft-deleting a deep-linked course shell item.
 *
 * sessionId targets the DeepLinkLaunch row directly (hash-key lookup —
 * no contextId GSI scan). The matching entry inside itemsSelected is located
 * by (courseId, moduleId, itemId).
 */
export type LtiTool_DeleteCourseShellItemInput = {
  /**
   * LMS context ID (course shell identifier). Must match the contextId bound to the
   * LTI_LOGIN_SESSION cookie; mismatch fails with CONTEXT_MISMATCH.
   */
  contextId: Scalars['ID'];
  /**
   * Coursera course ID for the linked content. Provide for COURSE / MODULE / ITEM
   * entries. Mutually exclusive with s12nId — leave null when deleting a
   * SPECIALIZATION / PROFESSIONAL_CERTIFICATE bundle.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Optional item ID for item-level deep links. */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Optional module ID for module-level deep links. */
  moduleId?: InputMaybe<Scalars['ID']>;
  /**
   * Specialization / Professional Certificate base ID. Provide instead of courseId
   * to delete a bundle as a whole — the single itemsSelected entry is removed and
   * every constituent course's grading preference is soft-deleted.
   */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** DeepLinkLaunch sessionId (DynamoDB hash key). */
  sessionId: Scalars['ID'];
};

/** Result of soft-deleting a course shell item */
export type LtiTool_DeleteCourseShellItemResult = {
  __typename?: 'LtiTool_DeleteCourseShellItemResult';
  /** Deleted successfully or not */
  result: Scalars['Boolean'];
};

/** Input type for deleting an LTI platform configuration. */
export type LtiTool_DeletePlatformConfigInput = {
  /** The platform configuration ID to delete */
  id: Scalars['ID'];
  /** The third party organization ID */
  organizationId: Scalars['ID'];
};

/** Delete Platform configuration result */
export type LtiTool_DeletePlatformConfigResult = {
  __typename?: 'LtiTool_DeletePlatformConfigResult';
  /** Deleted successfully or not */
  result: Scalars['Boolean'];
};

/** Environment types for the platform configuration */
export const LtiTool_Environment = {
  /** For prod configurations */
  Production: 'PRODUCTION',
  /** For test configurations */
  Test: 'TEST'
} as const;

export type LtiTool_Environment = typeof LtiTool_Environment[keyof typeof LtiTool_Environment];
/** A single facet value and how many products in the result set have that value. */
export type LtiTool_FacetValueAndCount = {
  __typename?: 'LtiTool_FacetValueAndCount';
  /** Number of products in the result set that have this facet value. */
  count: Scalars['Int'];
  /** The facet value, e.g. "Google", "Beginner", "Data Science", "English", "1-3 months". */
  value: Scalars['String'];
};

/** input for dynamicRegistrationUrl */
export type LtiTool_GenerateDynamicRegistrationUrlInput = {
  /** name of LMS to register */
  lmsName: LtiTool_LmsName;
  /** LTI tool shown on the LMS */
  ltiIdentifier: Scalars['String'];
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /** Name of the platform */
  platformName: Scalars['String'];
};

/** gives signed JWT token with time bound url */
export type LtiTool_GenerateDynamicRegistrationUrlResult = {
  __typename?: 'LtiTool_GenerateDynamicRegistrationUrlResult';
  /** Expiration for the URL */
  expiresAt: Scalars['DateTime'];
  /** The url for dynamic registration */
  registrationUrl: Scalars['URL'];
  /** ttl in seconds */
  ttlSeconds: Scalars['Int'];
};

/** Org level grade sync settings */
export type LtiTool_GradeSyncSettings = {
  __typename?: 'LtiTool_GradeSyncSettings';
  /**
   * Whether grade sync is enabled for learners who access
   * Coursera without launching from the LMS (without LTI authentication).
   * When enabled and NRPS (roster sync) is set up, grades sync
   * for all learners in the class regardless of how they access Coursera.
   */
  gradeSyncWithoutLtiAuth: Scalars['Boolean'];
  /**
   * Number of days for the look-back period (0-120).
   * Enables syncing of grades earned within the past N days.
   * Set to 0 to disable syncing of past grades.
   * Maximum allowed value is 120.
   */
  lookbackPeriodDays: Scalars['Int'];
};

/** Input for grade sync settings */
export type LtiTool_GradeSyncSettingsInput = {
  /**
   * Whether grade sync is enabled for learners who access
   * Coursera without launching from the LMS (without LTI authentication).
   * When enabled and NRPS (roster sync) is set up, grades sync
   * for all learners in the class regardless of how they access Coursera.
   */
  gradeSyncWithoutLtiAuth?: InputMaybe<Scalars['Boolean']>;
  /**
   * Number of days for the look-back period (0-120).
   * Enables syncing of grades earned within the past N days.
   * Set to 0 to disable syncing of past grades.
   * Maximum allowed value is 120.
   */
  lookbackPeriodDays?: InputMaybe<Scalars['Int']>;
};

/**
 * Role classification for an LMS-native hub launch. Computed at LtiLoginSession
 * creation time by matching the LTI launch token's roles claim against the
 * instructor-role allowlist.
 */
export const LtiTool_HubRole = {
  /** Launching user has an instructor-equivalent role in the LMS course. */
  Instructor: 'INSTRUCTOR',
  /** Launching user is a learner in the LMS course (default when not instructor). */
  Learner: 'LEARNER'
} as const;

export type LtiTool_HubRole = typeof LtiTool_HubRole[keyof typeof LtiTool_HubRole];
/** Mapping of issuer URL to LMS name */
export type LtiTool_IssuerLmsNameMapping = {
  /** The issuer URL to match */
  issuer: Scalars['URL'];
  /** The LMS name to assign */
  lmsName: Scalars['String'];
};

/** An item within a lesson (video, quiz, assignment, etc.) */
export type LtiTool_Item = {
  __typename?: 'LtiTool_Item';
  /** Atom ID for the item product */
  atomId?: Maybe<Scalars['ID']>;
  /** Duration in seconds */
  durationSeconds?: Maybe<Scalars['Int']>;
  /** Unique identifier for the item */
  id: Scalars['ID'];
  /** Type of the item (VIDEO, QUIZ, PROGRAMMING_ASSIGNMENT, etc.) */
  itemType: Scalars['String'];
  /** Name of the item */
  name: Scalars['String'];
};

/** Individual item details within a group */
export type LtiTool_ItemDetail = {
  __typename?: 'LtiTool_ItemDetail';
  /** Duration of this item (formatted, e.g., "5 minutes") */
  duration?: Maybe<Scalars['String']>;
  /** Duration in seconds */
  durationSeconds?: Maybe<Scalars['Int']>;
  /** Unique identifier for the item */
  id: Scalars['ID'];
  /**
   * Whether this item is gradable and can contribute to the final course grade.
   * (Set to true for gradable items, null otherwise.)
   */
  isGradable?: Maybe<Scalars['Boolean']>;
  /** Name of the item */
  name: Scalars['String'];
};

/** Grouped items by type with count, duration, and individual item details */
export type LtiTool_ItemTypeGroup = {
  __typename?: 'LtiTool_ItemTypeGroup';
  /** Number of items of this type */
  count: Scalars['Int'];
  /** Display name for the item type (e.g., "videos", "readings", "assignments") */
  displayName: Scalars['String'];
  /** Type of items in this group (VIDEO, READING, QUIZ, ASSIGNMENT, etc.) */
  itemType: Scalars['String'];
  /** List of individual items in this group */
  items: Array<LtiTool_ItemDetail>;
  /** Total duration for all items of this type (formatted, e.g., "38 minutes") */
  totalDuration?: Maybe<Scalars['String']>;
  /** Total duration in seconds for all items of this type */
  totalDurationSeconds?: Maybe<Scalars['Int']>;
};

/**
 * Filter and search options for the learner progress table. No sort option —
 * results are returned in learner-name order (the read index's natural order);
 * v1 has no user-selectable sort.
 */
export type LtiTool_LearnerProgressFilterInput = {
  /**
   * Case-insensitive prefix match against learner name. Empty / null means no
   * search filter.
   */
  nameSearch?: InputMaybe<Scalars['String']>;
  /**
   * Restrict results to learners with one of these statuses. Empty / null means
   * all statuses.
   */
  statuses?: InputMaybe<Array<LtiTool_LearnerProgressStatus>>;
};

/**
 * Page-based result for getLearnerProgress. The UI renders numbered pages with a
 * total ("Page N of M"), so the result carries the page coordinates + totals
 * rather than an opaque cursor.
 *
 * Intentionally not named *PaginatedResult: that suffix is reserved for Coursera's
 * cursor-based pagination scheme (elements + pagination, limit/cursor args). This
 * surface is page-based by design (jump-to-page + "Page N of M"); see TDD §5.5.
 */
export type LtiTool_LearnerProgressPage = {
  __typename?: 'LtiTool_LearnerProgressPage';
  /** Learner rows for the requested page, in name order. */
  elements: Array<LtiTool_LearnerProgressRow>;
  /** 1-based page number echoed back. */
  page: Scalars['Int'];
  /** Rows per page echoed back. */
  pageSize: Scalars['Int'];
  /** Total learners matching the filter (drives the page count and 'Page N of M'). */
  totalElements: Scalars['Int'];
  /** Total pages = ceil(totalElements / pageSize). */
  totalPages: Scalars['Int'];
};

/** A single learner row in the instructor progress table. */
export type LtiTool_LearnerProgressRow = {
  __typename?: 'LtiTool_LearnerProgressRow';
  /**
   * Certificate access URL for this learner. Populated when status = COMPLETED and
   * a certificate has been issued: a course-completion certificate when the query
   * targets a course (keyed by courseId), or a specialization certificate when it
   * targets a SPECIALIZATION / PROFESSIONAL_CERTIFICATE bundle (keyed by s12nId,
   * which also covers Professional Certificates). Null in all other cases
   * (status != COMPLETED, no certificate issued, or org cert surfacing disabled).
   */
  certificateUrl?: Maybe<Scalars['URL']>;
  /** Learner email. May be null if neither NRPS nor the launch token expose one. */
  email?: Maybe<Scalars['String']>;
  /**
   * ISO-8601 timestamp of the learner's most recent activity related to this
   * content. Null when status = NOT_STARTED.
   */
  lastActivity?: Maybe<Scalars['DateTime']>;
  /**
   * LMS-side learner identifier (LTI 1.3 sub claim or NRPS user_id).
   * Unique per (issuer, deploymentId, contextId).
   */
  learnerLmsId: Scalars['ID'];
  /**
   * Display name. Sourced from the NRPS roster when available, otherwise from the
   * learner's LTI launch token name claim.
   */
  name: Scalars['String'];
  /** Computed progress status. */
  status: LtiTool_LearnerProgressStatus;
};

/**
 * 3-state monotonic learner-progress status. Status cannot regress
 * (NOT_STARTED → IN_PROGRESS → COMPLETED).
 */
export const LtiTool_LearnerProgressStatus = {
  /** Content completed. */
  Completed: 'COMPLETED',
  /** Activity recorded but the content is not yet completed. */
  InProgress: 'IN_PROGRESS',
  /** No activity recorded for this content yet. */
  NotStarted: 'NOT_STARTED'
} as const;

export type LtiTool_LearnerProgressStatus = typeof LtiTool_LearnerProgressStatus[keyof typeof LtiTool_LearnerProgressStatus];
/** A lesson within a module containing items */
export type LtiTool_Lesson = {
  __typename?: 'LtiTool_Lesson';
  /** Unique identifier for the lesson */
  id: Scalars['ID'];
  /** List of items in the lesson */
  items: Array<LtiTool_Item>;
  /** Name of the lesson */
  name: Scalars['String'];
};

/** Learning Management System (LMS) names for platform configuration */
export const LtiTool_LmsName = {
  /** Blackboard LMS */
  Blackboard: 'BLACKBOARD',
  /** Canvas LMS */
  Canvas: 'CANVAS',
  /** D2L Brightspace LMS */
  D2L: 'D2L',
  /** Google Classroom */
  GoogleClassroom: 'GOOGLE_CLASSROOM',
  /** Moodle LMS */
  Moodle: 'MOODLE',
  /** Other LMS platforms not listed */
  Others: 'OTHERS',
  /** Cegid Talentsoft (both LMS delivery and LCMS deep-link authoring registrations) */
  Talentsoft: 'TALENTSOFT'
} as const;

export type LtiTool_LmsName = typeof LtiTool_LmsName[keyof typeof LtiTool_LmsName];
/**
 * Role and LMS context the Coursera-hosted hub page reads on load to decide
 * whether to render the instructor or learner view. Sourced from the
 * LtiLoginSession identified by the LTI_LOGIN_SESSION cookie.
 */
export type LtiTool_LtiHubContext = {
  __typename?: 'LtiTool_LtiHubContext';
  /** LMS course shell identifier (from the LTI context.id claim). */
  contextId?: Maybe<Scalars['ID']>;
  /** Display name of the LMS platform (e.g. "Canvas", "Moodle") for FE labeling. */
  lmsName: Scalars['String'];
  /**
   * Third-party organization slug — emitted for FE eventing payloads alongside
   * organizationId so analytics can join on the human-readable identifier.
   */
  orgSlug: Scalars['String'];
  /** Third-party organization ID this session belongs to. */
  organizationId: Scalars['ID'];
  /** Role classification persisted on the session at launch time. */
  role: LtiTool_HubRole;
};

/** A module in a course containing lessons with aggregated content counts */
export type LtiTool_Module = {
  __typename?: 'LtiTool_Module';
  /** Number of assignments (programming, peer-reviewed, etc.) in this module */
  assignmentCount?: Maybe<Scalars['Int']>;
  /** Description of the module */
  description?: Maybe<Scalars['String']>;
  /** Duration of this module (formatted, e.g., "38 minutes") */
  duration?: Maybe<Scalars['String']>;
  /** Unique identifier for the module */
  id: Scalars['ID'];
  /** Items grouped by type with details (e.g., "7 videos • Total 38 minutes") */
  itemTypeGroups: Array<LtiTool_ItemTypeGroup>;
  /** List of lessons in the module */
  lessons: Array<LtiTool_Lesson>;
  /** Name of the module */
  name: Scalars['String'];
  /** Number of quizzes/exams in this module */
  quizCount?: Maybe<Scalars['Int']>;
  /** Number of readings/supplements in this module */
  readingCount?: Maybe<Scalars['Int']>;
  /** Total number of items in this module */
  totalItemCount?: Maybe<Scalars['Int']>;
  /** Number of videos/lectures in this module */
  videoCount?: Maybe<Scalars['Int']>;
};

/** Organization-level configuration for LTI integrations */
export type LtiTool_OrgConfig = {
  __typename?: 'LtiTool_OrgConfig';
  /** Org level grade sync settings */
  gradeSyncSettings?: Maybe<LtiTool_GradeSyncSettings>;
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /**
   * Program access control settings for LTI deep linking, applied uniformly across every
   * LMS registration under this org.
   * Defaults to { enabled: false, selectedProgramIds: [] } when no record exists.
   */
  programAccessControl: LtiTool_ProgramAccessControl;
};

/** Partners offering the product */
export type LtiTool_Partner = {
  __typename?: 'LtiTool_Partner';
  /** PartnerId */
  id: Scalars['ID'];
  /** Logo URL of the partner */
  logoUrl?: Maybe<Scalars['URL']>;
  /** Name of the partner */
  name: Scalars['String'];
};

/** Platform Configuration Model returned by queries */
export type LtiTool_PlatformConfig = {
  __typename?: 'LtiTool_PlatformConfig';
  /** Authorization endpoint URL */
  authEndpoint: Scalars['URL'];
  /** Client ID */
  clientId: Scalars['ID'];
  /** Deployment ID */
  deploymentId: Scalars['ID'];
  /** environment (e.g., "production", "sandbox") */
  environment: LtiTool_Environment;
  /** DB primary key for the platform configuration */
  id: Scalars['ID'];
  /**
   * Whether this is a newly created dynamic registration that the admin has not yet seen.
   * Set to true when created via dynamic registration, reset to false after admin views the config list.
   */
  isNewDynamicRegistration: Scalars['Boolean'];
  /** Issuer URL */
  issuer: Scalars['URL'];
  /** JWKS URL */
  jwksUrl: Scalars['URL'];
  /** LMS type (e.g., Moodle, Canvas, Blackboard) */
  lmsName?: Maybe<LtiTool_LmsName>;
  /** Name of the platform */
  name: Scalars['String'];
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /** Custom LMS name when lmsName is OTHERS */
  otherLmsName?: Maybe<Scalars['String']>;
  /** How this registration was created: STATIC or DYNAMIC */
  registrationSource: LtiTool_RegistrationSource;
  /**
   * Access token endpoint URL. Null for LCMS-only registrations (e.g. Talentsoft LCMS) that
   * do not participate in AGS grade passback.
   */
  tokenEndpoint?: Maybe<Scalars['URL']>;
};

/** Product details containing course metadata and materials (modules, lessons, and items) */
export type LtiTool_ProductDetails = {
  __typename?: 'LtiTool_ProductDetails';
  /** The course */
  course: Course_Course;
  /** List of modules in the course */
  modules: Array<LtiTool_Module>;
};

/** Difficulty levels for products */
export const LtiTool_ProductDifficultyLevel = {
  /** Advanced level */
  Advanced: 'ADVANCED',
  /** Beginner level */
  Beginner: 'BEGINNER',
  /** Intermediate level */
  Intermediate: 'INTERMEDIATE',
  /** Mixed level */
  Mixed: 'MIXED'
} as const;

export type LtiTool_ProductDifficultyLevel = typeof LtiTool_ProductDifficultyLevel[keyof typeof LtiTool_ProductDifficultyLevel];
/** product metadata containing ratings, enrollments, and difficulty level */
export type LtiTool_ProductMetaData = {
  __typename?: 'LtiTool_ProductMetaData';
  /** Average rating of the product (0-5) */
  avgRating?: Maybe<Scalars['Float']>;
  /** Difficulty level of the product */
  difficultyLevel: LtiTool_ProductDifficultyLevel;
  /** Number of enrollments */
  enrollments: Scalars['Int'];
  /** Number of reviews for the product */
  numRating: Scalars['Int'];
};

/** Product search result */
export type LtiTool_ProductSearchHit = {
  __typename?: 'LtiTool_ProductSearchHit';
  /**
   * Number of constituent courses. Populated for SPECIALIZATION and
   * PROFESSIONAL_CERTIFICATE hits. Null for COURSE / VIDEO / PROJECT
   * / GUIDED_PROJECT hits.
   */
  courseCount?: Maybe<Scalars['Int']>;
  /** product tagline/description */
  description?: Maybe<Scalars['String']>;
  /** Estimated duration of this product(formatted, e.g., "38 hours") */
  estimatedDuration?: Maybe<Scalars['String']>;
  /** Unique identifier for the product */
  id: Scalars['ID'];
  /** URL of the product image */
  imageUrl?: Maybe<Scalars['URL']>;
  /** meta data of the product */
  metadata: LtiTool_ProductMetaData;
  /** Name of the product */
  name: Scalars['String'];
  /** Partners offering this product */
  partners?: Maybe<Array<LtiTool_Partner>>;
  /** Skills taught in the product */
  skills?: Maybe<Array<Skill_Skill>>;
  /** Type of the item (COURSE, VIDEO , PROJECT etc.) */
  type: LtiTool_ProductType;
};

/** Response type for product search */
export type LtiTool_ProductSearchHitPaginatedResult = {
  __typename?: 'LtiTool_ProductSearchHitPaginatedResult';
  /** List of product search results */
  elements: Array<LtiTool_ProductSearchHit>;
  /**
   * Facet value counts for every requested filter category (partners, productDifficultyLevel,
   * topic, language, productDuration, productTypeDescription). Each facet lists its distinct
   * values and their occurrence counts across the full result set, used to render the filter
   * panel with per-value counts.
   */
  facets: Array<LtiTool_SearchFacet>;
  /** Pagination */
  pagination: Pagination;
  /**
   * Product type counts from search facets.
   * Maps product types to their occurrence counts in the full result set (across all pages).
   */
  productTypeCounts: Array<LtiTool_ProductTypeCount>;
};

/** Sort options for product search, mirroring the consumer search experience. */
export const LtiTool_ProductSortBy = {
  /**
   * Best match. Ranking uses keyword matching and is optimized for long-term value.
   * This is the default when no sort is provided.
   */
  BestMatch: 'BEST_MATCH',
  /** Newest launch date first (descending by launch date). */
  New: 'NEW'
} as const;

export type LtiTool_ProductSortBy = typeof LtiTool_ProductSortBy[keyof typeof LtiTool_ProductSortBy];
/** Types of products in a program */
export const LtiTool_ProductType = {
  /** Product is a course */
  Course: 'COURSE',
  /** Product is a guided project */
  GuidedProject: 'GUIDED_PROJECT',
  /** For other product types not listed */
  Other: 'OTHER',
  /** Product is a professional certificate */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Product is a project */
  Project: 'PROJECT',
  /** Product is a specialization */
  Specialization: 'SPECIALIZATION',
  /** Product is a video */
  Video: 'VIDEO'
} as const;

export type LtiTool_ProductType = typeof LtiTool_ProductType[keyof typeof LtiTool_ProductType];
/** Count of products for a specific product type */
export type LtiTool_ProductTypeCount = {
  __typename?: 'LtiTool_ProductTypeCount';
  /** Number of products of this type in the search results */
  count: Scalars['Int'];
  /** The product type */
  productType: LtiTool_ProductType;
};

/**
 * Enterprise Program information with enrollment and course metrics, scoped to
 * the organization context in which it is requested.
 */
export type LtiTool_Program = {
  __typename?: 'LtiTool_Program';
  /** Total number of courses in the program. */
  courseCount: Scalars['Int'];
  /**
   * Timestamp the program became available to the requesting organization
   * (earliest non-deleted roster row for this (organization, program) pair).
   * Null when no roster record is found, or when the caller is not querying in
   * an organization-scoped context.
   */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Number of learners enrolled in the program for the requesting organization. */
  enrolledCount: Scalars['Int'];
  /** Federated reference to the enterprise program (id, name, slug, logos, etc.). */
  program: EnterpriseProgram_EnterpriseProgram;
};

/**
 * Program access control configuration for an organization.
 * Controls which programs are visible in the LMS/LTI deep linking picker.
 */
export type LtiTool_ProgramAccessControl = {
  __typename?: 'LtiTool_ProgramAccessControl';
  /**
   * Whether program access control is enabled.
   * When false (default), all programs are visible.
   * When true, only programs in selectedProgramIds are visible.
   */
  enabled: Scalars['Boolean'];
  /**
   * IDs of programs that are visible in LTI when access control is enabled.
   * Empty list when disabled or no programs selected.
   */
  selectedProgramIds: Array<Scalars['ID']>;
};

/**
 * Input for updating program access control settings.
 * When enabling, selectedProgramIds must contain at least one active program.
 */
export type LtiTool_ProgramAccessControlInput = {
  /** Whether to enable program access control. */
  enabled: Scalars['Boolean'];
  /**
   * IDs of programs to make visible in LTI deep linking.
   * Required and must be non-empty when enabled is true.
   * Ignored when enabled is false (existing selection preserved in storage).
   */
  selectedProgramIds?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * A single LMS registration together with its own program access control state.
 * Program access control (V2) is scoped per LMS registration rather than per organization,
 * so orgs running multiple LMS registrations (e.g. separate departments) can configure each
 * registration's program visibility independently.
 */
export type LtiTool_RegistrationProgramAccessControl = {
  __typename?: 'LtiTool_RegistrationProgramAccessControl';
  /** Client ID of the LMS registration */
  clientId: Scalars['ID'];
  /** Display name of the LMS registration, shown in the admin settings list */
  displayName: Scalars['String'];
  /** DB primary key of the LMS registration (platform configuration) */
  id: Scalars['ID'];
  /**
   * Program access control settings for this specific LMS registration.
   * Defaults to { enabled: false, selectedProgramIds: [] } when no record exists.
   */
  programAccessControl: LtiTool_ProgramAccessControl;
};

/** How the platform registration was created */
export const LtiTool_RegistrationSource = {
  /** Automatic via LTI Dynamic Registration */
  Dynamic: 'DYNAMIC',
  /** Manual configuration by admin */
  Static: 'STATIC'
} as const;

export type LtiTool_RegistrationSource = typeof LtiTool_RegistrationSource[keyof typeof LtiTool_RegistrationSource];
/** A single search facet: a filter category and the counts for each of its values. */
export type LtiTool_SearchFacet = {
  __typename?: 'LtiTool_SearchFacet';
  /**
   * The facet (attribute) name, e.g. "partners", "productDifficultyLevel", "topic",
   * "language", "productDuration", "productTypeDescription".
   */
  name: Scalars['String'];
  /** Distinct values for this facet and their occurrence counts in the full result set. */
  valuesAndCounts: Array<LtiTool_FacetValueAndCount>;
};

/** Input type for searching product */
export type LtiTool_SearchProductInput = {
  /**
   * Optional list of difficulty levels to filter by. Valid values: Beginner, Intermediate,
   * Advanced, Mixed. Values are the facet values returned in the `productDifficultyLevel` facet.
   */
  difficultyLevels?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Optional list of durations to filter by. Valid values: "Under 60 minutes",
   * "Less than 2 hours", "1-4 weeks", "1-3 months", "3-6 months", "6-12 months", "1-4 years".
   * Values are the facet values returned in the `productDuration` facet.
   */
  durations?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Optional list of languages to filter by, e.g. ["English", "Spanish"].
   * Values are the facet values returned in the `language` facet of a previous search.
   */
  languages?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Optional list of partner (educator) names to filter by, e.g. ["Google", "IBM"].
   * Values are the facet values returned in the `partners` facet of a previous search.
   */
  partners?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Optional list of product type to apply. Valid values: COURSE, PROJECT, GUIDED_PROJECT,
   * SHORT_FORM_CONTENT_VIDEO, PROFESSIONAL_CERTIFICATE, SPECIALIZATION, VIDEO, OTHER.
   * If not provided, default productTypes (COURSE, SHORT_FORM_CONTENT_VIDEO, PROJECT, GUIDED_PROJECT) will be used.
   */
  productTypes?: InputMaybe<Array<Scalars['String']>>;
  /** Optional program IDs to search within */
  programIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Text query to search for */
  query?: InputMaybe<Scalars['String']>;
  /**
   * Sort order for the results. Defaults to BEST_MATCH when not provided.
   * Non-nullable with a default so clients cannot override the intended default by passing null.
   */
  sortBy?: LtiTool_ProductSortBy;
  /**
   * Optional list of topics to filter by, e.g. ["Data Science", "Business"].
   * Values are the facet values returned in the `topic` facet of a previous search.
   */
  topics?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Container for the s12n View page in the LTI deep-link flow.
 * Both fields are federation key stubs — name, description, productVariant,
 * partners (with squareLogo/logo/name), course materials, and learningObjectives
 * are all resolved by the gateway from the partner, course authoring, and
 * related subgraphs.
 */
export type LtiTool_SpecializationDetails = {
  __typename?: 'LtiTool_SpecializationDetails';
  /**
   * Constituent courses, in display order. Federation resolves name,
   * estimatedDuration, learningObjectives, etc. via the courseauthoring subgraph.
   */
  courses: Array<Course_Course>;
  /**
   * S12n metadata. Federation resolves name, description, productVariant,
   * partners, etc. via the partner subgraph.
   */
  specialization: Specialization_Specialization;
};

/** Metadata about the Coursera LTI tool */
export type LtiTool_ToolMetadata = {
  __typename?: 'LtiTool_ToolMetadata';
  /** Deep linking URL of the tool */
  deepLinkingUrl: Scalars['URL'];
  /** The initiate login url of the tool */
  initiateLoginUrl: Scalars['URL'];
  /** The URL to the tool's JWKS endpoint */
  jwksUrl: Scalars['URL'];
  /** The launch url of the tool */
  launchUrl: Scalars['URL'];
  /** Redirect URL of the tool */
  redirectUrls: Array<Scalars['URL']>;
  /** Latest version of the metadata */
  version: Scalars['String'];
};

/** Input for updating the grade-sync due date of a deep-linked course shell item. */
export type LtiTool_UpdateCourseShellDueDateInput = {
  /**
   * LMS context ID (course shell identifier). Must match the contextId bound to the
   * LTI_LOGIN_SESSION cookie; mismatch fails with CONTEXT_MISMATCH.
   */
  contextId: Scalars['ID'];
  /**
   * Coursera course ID for the linked content. Provide for COURSE / MODULE / ITEM
   * entries. Mutually exclusive with s12nId — leave null when targeting a
   * SPECIALIZATION / PROFESSIONAL_CERTIFICATE bundle.
   */
  courseId?: InputMaybe<Scalars['ID']>;
  /**
   * New grade-sync due date (UTC). Null clears the existing due date.
   * Past dates are rejected.
   */
  gradeSyncDueDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional item ID for item-level deep links */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Optional module ID for module-level deep links */
  moduleId?: InputMaybe<Scalars['ID']>;
  /**
   * Specialization / Professional Certificate base ID. Provide instead of courseId
   * to update the due date for a bundle as a whole — the change fans out to the
   * grade-sync due date of every constituent course in the shell.
   */
  s12nId?: InputMaybe<Scalars['ID']>;
};

/** Result of updating a course shell item's grade-sync due date */
export type LtiTool_UpdateCourseShellDueDateResult = {
  __typename?: 'LtiTool_UpdateCourseShellDueDateResult';
  /** Updated successfully or not */
  result: Scalars['Boolean'];
};

/** Input for updating organization configuration */
export type LtiTool_UpdateOrgConfigInput = {
  /** Updated grade sync settings for an org */
  gradeSyncSettings?: InputMaybe<LtiTool_GradeSyncSettingsInput>;
  /** Third party organization ID */
  organizationId: Scalars['ID'];
  /** Program access control settings. When provided, updates the program visibility controls. */
  programAccessControl?: InputMaybe<LtiTool_ProgramAccessControlInput>;
};

/** Result of updating organization configuration */
export type LtiTool_UpdateOrgConfigResult = {
  __typename?: 'LtiTool_UpdateOrgConfigResult';
  /** Whether the update was successful */
  result: Scalars['Boolean'];
};

/** Input for updating program access control settings for a single LMS registration */
export type LtiTool_UpdateRegistrationProgramAccessControlInput = {
  /**
   * The third party organization ID. Must match the registration's own organization —
   * the update is rejected otherwise.
   */
  organizationId: Scalars['ID'];
  /** Updated program access control settings for this registration */
  programAccessControl: LtiTool_ProgramAccessControlInput;
  /** The LMS registration (platform configuration) ID to update */
  registrationId: Scalars['ID'];
};

/** Result of updating program access control for a single LMS registration */
export type LtiTool_UpdateRegistrationProgramAccessControlResult = {
  __typename?: 'LtiTool_UpdateRegistrationProgramAccessControlResult';
  /** Whether the update was successful */
  result: Scalars['Boolean'];
};

/** Status of the grading of the submission */
export const Manual_Grading_Status = {
  /** Grading finished */
  Graded: 'GRADED',
  /** Grading started */
  Grading: 'GRADING',
  /** Grading is not required */
  NotRequired: 'NOT_REQUIRED',
  /** Grading didn't start yet */
  NotStarted: 'NOT_STARTED'
} as const;

export type Manual_Grading_Status = typeof Manual_Grading_Status[keyof typeof Manual_Grading_Status];
/** All MCP Apps queries. */
export type McpAppsQueries = {
  __typename?: 'McpAppsQueries';
  /** Get all MCP apps for an organization. Secrets are masked. */
  mcpApps: McpApps_McpAppsResponse;
};


/** All MCP Apps queries. */
export type McpAppsQueriesMcpAppsArgs = {
  thirdPartyOrgId: Scalars['ID'];
};

/** Failure response for create MCP app. */
export type McpApps_CreateMcpAppFailure = {
  __typename?: 'McpApps_CreateMcpAppFailure';
  /** Error message. */
  message?: Maybe<Scalars['String']>;
};

/** Input for creating an MCP app. */
export type McpApps_CreateMcpAppInput = {
  /** The name of Application. */
  appName?: InputMaybe<Scalars['String']>;
  /** The type of MCP application. */
  mcpAppType: McpApps_McpAppType;
  /**
   * Redirect URIs for OAuth2.
   * Accepts custom schemes (e.g., cursor://) and localhost URLs; validated in business logic.
   */
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Result union for creating an MCP app. */
export type McpApps_CreateMcpAppResult = McpApps_CreateMcpAppFailure | McpApps_CreateMcpAppSuccess;

/** Response after creating an MCP app (includes client secret shown once). */
export type McpApps_CreateMcpAppSuccess = {
  __typename?: 'McpApps_CreateMcpAppSuccess';
  /** The name of Application. */
  appName: Scalars['String'];
  /** The type of MCP integration. */
  appType: McpApps_McpAppType;
  /** The OAuth client ID. */
  clientId: Scalars['ID'];
  /** The client secret (shown only once). */
  clientSecret: Scalars['String'];
};

/** Failure response for delete MCP app. */
export type McpApps_DeleteMcpAppFailure = {
  __typename?: 'McpApps_DeleteMcpAppFailure';
  /** Error message. */
  message?: Maybe<Scalars['String']>;
};

/** Input for deleting an MCP app. */
export type McpApps_DeleteMcpAppInput = {
  /** The OAuth client ID to delete. */
  clientId: Scalars['ID'];
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Result union for deleting an MCP app. */
export type McpApps_DeleteMcpAppResult = McpApps_DeleteMcpAppFailure | McpApps_DeleteMcpAppSuccess;

/** Success response after deleting an MCP app. */
export type McpApps_DeleteMcpAppSuccess = {
  __typename?: 'McpApps_DeleteMcpAppSuccess';
  /** Whether the deletion was successful. */
  success: Scalars['Boolean'];
};

/** Failure response for edit MCP app. */
export type McpApps_EditMcpAppFailure = {
  __typename?: 'McpApps_EditMcpAppFailure';
  /** Error message. */
  message?: Maybe<Scalars['String']>;
};

/** Input for editing an MCP app. At least one of appName or redirectUris must be provided. */
export type McpApps_EditMcpAppInput = {
  /** The new application name. If omitted, the name is unchanged. */
  appName?: InputMaybe<Scalars['String']>;
  /** The OAuth client ID of the app to edit. */
  clientId: Scalars['ID'];
  /** Accepts custom schemes (e.g., cursor://) and localhost URLs; validated in business logic. */
  redirectUris?: InputMaybe<Array<Scalars['String']>>;
  /** The third-party organization ID. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Result union for editing an MCP app. */
export type McpApps_EditMcpAppResult = McpApps_EditMcpAppFailure | McpApps_EditMcpAppSuccess;

/** Success response after editing an MCP app. */
export type McpApps_EditMcpAppSuccess = {
  __typename?: 'McpApps_EditMcpAppSuccess';
  /** The updated application name. */
  appName: Scalars['String'];
  /** The OAuth client ID. */
  clientId: Scalars['ID'];
};

/** An MCP application with masked credentials. */
export type McpApps_McpApp = {
  __typename?: 'McpApps_McpApp';
  /** The name of Application. */
  appName: Scalars['String'];
  /** The type of MCP integration. */
  appType: McpApps_McpAppType;
  /** The client ID for OAuth. */
  clientId: Scalars['ID'];
  /** When the application was created. */
  createdAt: Scalars['DateTime'];
  /** The registered redirect URIs for OAuth. */
  redirectUris?: Maybe<Array<Scalars['String']>>;
};

/** Enum representing the type of MCP application. */
export const McpApps_McpAppType = {
  /** ChatGPT MCP integration. */
  Chatgpt: 'CHATGPT',
  /** Claude MCP integration. */
  Claude: 'CLAUDE',
  /** Copilot MCP integration. */
  Copilot: 'COPILOT',
  /** Other MCP integration type. */
  Other: 'OTHER'
} as const;

export type McpApps_McpAppType = typeof McpApps_McpAppType[keyof typeof McpApps_McpAppType];
/** Response for listing all MCP apps. */
export type McpApps_McpAppsResponse = {
  __typename?: 'McpApps_McpAppsResponse';
  /** List of MCP applications. */
  apps: Array<McpApps_McpApp>;
};

export type MembershipsV1 = {
  __typename?: 'MembershipsV1';
  activeAndUpcomingSessions?: Maybe<OnDemandLearnerSessionsV1Connection>;
  activeSessionMembership?: Maybe<OnDemandSessionMembershipsV1>;
  course?: Maybe<CoursesV1>;
  courseId: Scalars['String'];
  enrolledTimestamp?: Maybe<Scalars['Float']>;
  grade?: Maybe<MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseGrade>;
  id: Scalars['String'];
  lastAccessedTimestamp?: Maybe<Scalars['Float']>;
  onDemandSessionMemberships?: Maybe<Scalars['JSON']>;
  role: MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole;
  s12n?: Maybe<OnDemandSpecializationsV1>;
  signatureTrackProfile?: Maybe<Scalars['JSON']>;
  userId: Scalars['Int'];
  vcMembership?: Maybe<VcMembershipsV1>;
  vcMembershipId?: Maybe<Scalars['JSON']>;
};


export type MembershipsV1ActiveAndUpcomingSessionsArgs = {
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1CourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};

export type MembershipsV1ByCode = {
  __typename?: 'MembershipsV1ByCode';
  code: Scalars['String'];
  connection?: Maybe<MembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MembershipsV1ByCodeForUser = {
  __typename?: 'MembershipsV1ByCodeForUser';
  code: Scalars['String'];
  connection?: Maybe<MembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MembershipsV1ByExternalUserId = {
  __typename?: 'MembershipsV1ByExternalUserId';
  activityStatus?: Maybe<Scalars['String']>;
  connection?: Maybe<MembershipsV1Connection>;
  externalUserId: Scalars['String'];
  filter?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MembershipsV1ByUser = {
  __typename?: 'MembershipsV1ByUser';
  activityStatus?: Maybe<Scalars['String']>;
  connection?: Maybe<MembershipsV1Connection>;
  filter?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  showHidden?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type MembershipsV1Connection = {
  __typename?: 'MembershipsV1Connection';
  elements: Array<Maybe<MembershipsV1>>;
  paging: ResponsePagination;
};

export type MembershipsV1FindByUserAndCourse = {
  __typename?: 'MembershipsV1FindByUserAndCourse';
  connection?: Maybe<MembershipsV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type MembershipsV1Me = {
  __typename?: 'MembershipsV1Me';
  activityStatus?: Maybe<Scalars['String']>;
  connection?: Maybe<MembershipsV1Connection>;
  filter?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  showHidden?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type MembershipsV1MeByCourse = {
  __typename?: 'MembershipsV1MeByCourse';
  connection?: Maybe<MembershipsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  showHidden?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type MembershipsV1Resource = {
  __typename?: 'MembershipsV1Resource';
  byCode?: Maybe<MembershipsV1Connection>;
  byCodeForUser?: Maybe<MembershipsV1Connection>;
  byExternalUserId?: Maybe<MembershipsV1Connection>;
  byUser?: Maybe<MembershipsV1Connection>;
  findByUserAndCourse?: Maybe<MembershipsV1Connection>;
  get?: Maybe<MembershipsV1>;
  me?: Maybe<MembershipsV1Connection>;
  meByCourse?: Maybe<MembershipsV1Connection>;
  multiGet?: Maybe<MembershipsV1Connection>;
};


export type MembershipsV1ResourceByCodeArgs = {
  code: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1ResourceByCodeForUserArgs = {
  code: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1ResourceByExternalUserIdArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  externalUserId: Scalars['String'];
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1ResourceByUserArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type MembershipsV1ResourceFindByUserAndCourseArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type MembershipsV1ResourceMeArgs = {
  activityStatus?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1ResourceMeByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MembershipsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type MembershipsV1ResourceMutations = {
  __typename?: 'MembershipsV1ResourceMutations';
  byUserAndCourse?: Maybe<Scalars['JSON']>;
};


export type MembershipsV1ResourceMutationsByUserAndCourseArgs = {
  userId: Scalars['String'];
};

/** Model representing a learner's grade in a course */
export type MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseGrade = {
  __typename?: 'MembershipsV1_org_coursera_catalogp_memberships_CourseGrade';
  distinctionLevel: MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel;
  record: MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord;
  score: Scalars['Float'];
  timestamp?: Maybe<Scalars['Float']>;
};

/** User's status in a course based on score and verification */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = {
  NotPassable: 'NOT_PASSABLE',
  NotPassed: 'NOT_PASSED',
  Passed: 'PASSED',
  VerifiedPassed: 'VERIFIED_PASSED'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord];
/** Distinction achieved by a learner getting a grade for a course */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** A user's relationship to a course. This is strongly related to [[org.coursera.opencourse.model.CourseRole]] */
export const MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole = {
  Browser: 'BROWSER',
  CourseAssistant: 'COURSE_ASSISTANT',
  DataCoordinator: 'DATA_COORDINATOR',
  Instructor: 'INSTRUCTOR',
  Learner: 'LEARNER',
  Mentor: 'MENTOR',
  NotEnrolled: 'NOT_ENROLLED',
  PartnerAdmin: 'PARTNER_ADMIN',
  PreEnrolledLearner: 'PRE_ENROLLED_LEARNER',
  SuperUser: 'SUPER_USER',
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole = typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole[keyof typeof MembershipsV1_Org_Coursera_Catalogp_Memberships_EnrollmentRole];
/** MerchandisingUpsellModule GraphQL Schema */
export type MerchandisingUpsellModuleQueries = {
  __typename?: 'MerchandisingUpsellModuleQueries';
  /**
   * Get the merchandising upsell for a given input context,  returns priority based on affinity level.
   * Clients can use this to determine where to place the upsell on a page.
   */
  getMerchandisingUpsell?: Maybe<MerchandisingUpsell_Upsell>;
};


/** MerchandisingUpsellModule GraphQL Schema */
export type MerchandisingUpsellModuleQueriesGetMerchandisingUpsellArgs = {
  input: MerchandisingUpsellModule_GetUpsellInput;
};

/** GetMerchandisingUpsell Input */
export type MerchandisingUpsellModule_GetUpsellInput = {
  /** The location of the upsell */
  location: MerchandisingUpsellModule_Location;
};

/** Surfaces of the merchandising upsell */
export const MerchandisingUpsellModule_Location = {
  /** Upsell on the career academy page */
  CareerAcademy: 'CAREER_ACADEMY',
  /** Upsell on the logged-in home page */
  Lihp: 'LIHP',
  /** Upsell on the role description page */
  Rdp: 'RDP'
} as const;

export type MerchandisingUpsellModule_Location = typeof MerchandisingUpsellModule_Location[keyof typeof MerchandisingUpsellModule_Location];
/** MerchandisingUpsellModule priority level */
export const MerchandisingUpsellModule_Priority = {
  /** High priority */
  High: 'HIGH',
  /** Low priority */
  Low: 'LOW'
} as const;

export type MerchandisingUpsellModule_Priority = typeof MerchandisingUpsellModule_Priority[keyof typeof MerchandisingUpsellModule_Priority];
/** MerchandisingUpsellModule type */
export const MerchandisingUpsellModule_Type = {
  /** Upsell for Coursera Plus */
  CourseraPlus: 'COURSERA_PLUS'
} as const;

export type MerchandisingUpsellModule_Type = typeof MerchandisingUpsellModule_Type[keyof typeof MerchandisingUpsellModule_Type];
/** MerchandisingUpsell data */
export type MerchandisingUpsell_Upsell = {
  __typename?: 'MerchandisingUpsell_Upsell';
  /** The priority level of the upsell module */
  priority?: Maybe<MerchandisingUpsellModule_Priority>;
  /** The type of the upsell */
  upsellType: MerchandisingUpsellModule_Type;
};

/** Namespace type for mobile queries */
export type MobileQueries = {
  __typename?: 'MobileQueries';
  /** Returns flashcards for the given course and module for the logged in learner */
  getFlashcards: Mobile_GetFlashcardsResponse;
  /** Returns the experiment associated with the given list of namespaces and parameters, if available */
  getParametersByIds: Mobile_GetParametersResponse;
};


/** Namespace type for mobile queries */
export type MobileQueriesGetFlashcardsArgs = {
  input: Mobile_GetFlashcardsInput;
};


/** Namespace type for mobile queries */
export type MobileQueriesGetParametersByIdsArgs = {
  input: Mobile_GetParametersInput;
};

/** A Course Module */
export type Mobile_CourseModule = {
  __typename?: 'Mobile_CourseModule';
  /** Id of the module */
  moduleId: Scalars['ID'];
  /** Name of the module */
  moduleName: Scalars['String'];
};

/** Wrapper type for experiment parameter namespace and parameter name */
export type Mobile_Experiment_Id = {
  /** Experiment namespace */
  namespace: Scalars['String'];
  /** Parameter name */
  parameterName: Scalars['String'];
};

/** A flashcard */
export type Mobile_Flashcard = {
  __typename?: 'Mobile_Flashcard';
  /** Second side to show */
  back: Scalars['String'];
  /** First side to show */
  front: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
};

/** A deck of flashcards, so it's easier to extend the type if needed */
export type Mobile_FlashcardDeck = {
  __typename?: 'Mobile_FlashcardDeck';
  /** The flashcards */
  flashcards: Array<Mobile_Flashcard>;
  /** Whether the deck is generated considering where the learner is at */
  isBasedOnLearnerProgress: Scalars['Boolean'];
  /**
   * Module of the deck, if missing, that means the flashcards are for the entire
   * course
   */
  module?: Maybe<Mobile_CourseModule>;
};

/** Wrapper type for flashcards parameters */
export type Mobile_GetFlashcardsInput = {
  /** Course slug */
  courseSlug: Scalars['String'];
  /**
   * Optional module id. If module id is missing, cards will be fetched for the
   * active module, based on learner progress
   */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/** Wrapper type for flashcard response */
export type Mobile_GetFlashcardsResponse = {
  __typename?: 'Mobile_GetFlashcardsResponse';
  /** Course */
  course: Course_Course;
  /** Flashcards, optional, of module doesn't have flashcards, it's null */
  deck?: Maybe<Mobile_FlashcardDeck>;
  /** Modules that flashcards can be fetched for, to populate the dropdown */
  modules: Array<Mobile_CourseModule>;
};

/** Wrapper type for experiment parameters */
export type Mobile_GetParametersInput = {
  /** List of experiment namespace and parameter name pairs */
  ids: Array<Mobile_Experiment_Id>;
};

/** Wrapper type for experiment parameter response */
export type Mobile_GetParametersResponse = {
  __typename?: 'Mobile_GetParametersResponse';
  /** List of experiment parameters */
  parameters: Array<Mobile_Parameter>;
};

/** This file contains the GraphQL schema for the mobile experiments. */
export type Mobile_Parameter = {
  __typename?: 'Mobile_Parameter';
  /** Experiment namespace */
  namespace: Scalars['String'];
  /** Experiment parameter name */
  parameterName: Scalars['String'];
  /**
   * Experiment parameter value, if this is missing from the response, either the experiment doesn't exist, or
   * there was an error retrieving it
   */
  value?: Maybe<Scalars['JSON']>;
};

/** currency GraphQL Schema */
export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  /** TODO: Complete this description */
  currencyCode: CurrencyCode;
  /** using String to avoid potential Float precision issues */
  value: Scalars['String'];
};

/** TODO: Complete this description */
export type MonetaryAmountInput = {
  /** TODO: Complete this description */
  currencyCode: CurrencyCode;
  /** using String to avoid potential Float precision issues */
  value: Scalars['String'];
};

/** Root Mutation type */
export type Mutation = {
  __typename?: 'Mutation';
  /** TODO: Complete this description */
  AcademicDiscipline_setupAcademicDisciplineBasedProgram?: Maybe<AcademicDiscipline_SetupAcademicDisciplineBasedProgramPayload>;
  /** This mutation hard removes product IDs from a contract tag */
  AdHocProducts_HardRemoveContractTagProductId: AdHocProducts_HardRemoveContractTagProductIdResult;
  /** This mutation updates contract tag product associations by allowing or denying product IDs */
  AdHocProducts_UpdateContractTagProductId: AdHocProducts_UpdateContractTagProductIdResult;
  /** Add back an original course item to a learning block (idempotent — no-op if already present) */
  AdaptiveLearning_AddCourseItemToLearningBlock: AdaptiveLearning_AddCourseItemToLearningBlockResult;
  /**
   * Deletes a learner's adaptive learning plan and all derived state for a course
   * branch, returning them to a pre-onboarding state. Internal admin tool —
   * requires Power User permission. Hard-deletes the plan, its learning blocks,
   * the user-scoped AI-generated content (both ONE_PAGER and
   * AI_GENERATED_PRACTICE), and the Redis-backed learning preferences and
   * practice-attempt records for the (userId, courseBranchId).
   */
  AdaptiveLearning_DeleteLearningPlan: AdaptiveLearning_DeleteLearningPlanResult;
  /** Onboard a user for adaptive learning in a course */
  AdaptiveLearning_Onboard: AdaptiveLearning_OnboardResult;
  /** Report that a user has completed an item within a session plan */
  AdaptiveLearning_ReportItemProgress: AdaptiveLearning_ReportItemProgressResult;
  /**
   * Report the learner's attempt on a single AI-generated practice question.
   * Latest attempt overwrites any prior attempt for the same (userId, courseBranchId,
   * aiGeneratedPracticeId, practiceType).
   */
  AdaptiveLearning_ReportPracticeAttempt: AdaptiveLearning_ReportPracticeAttemptResult;
  /** Submit pre-assessment answers */
  AdaptiveLearning_SubmitPreAssessmentAnswers: AdaptiveLearning_SubmitPreAssessmentAnswersResult;
  /**
   * Submits pre-assessment answers at either skill or subSkill granularity in a
   * single unified list. Server-side semantics: SKILL items fan out to every
   * constituent sub-skill, SUBSKILL items override fan-out for that sub-skill.
   * Order of items does not matter; the server processes all SKILL items first.
   * Does NOT regenerate the learning plan (only AdaptiveLearning_Onboard does).
   */
  AdaptiveLearning_SubmitPreAssessmentAnswersV2: AdaptiveLearning_SubmitPreAssessmentAnswersV2Result;
  /** Delete impersonated program selections. User ID is inferred from request context. */
  AdminProgramImpersonations_Delete: AdminProgramImpersonations_DeleteResult;
  /** Set impersonated program selections. User ID is inferred from request context. */
  AdminProgramImpersonations_Set: AdminProgramImpersonations_SetResult;
  /**
   * Given a list of emails, add session assistant staffs to a session if user accounts already
   * exists in Coursera. If accounts not exist, send invites to Coursera.
   * Note: the invitation invites them to join Coursera and doesn't add them as session assistants.
   */
  AdminStaffMemberships_AddSessionAssistantsByEmails: AdminStaffMemberships_AddSessionAssistantsByEmailsResult;
  /** Given a list of user IDs and a session ID, deletes those users' Session Assistant roles. */
  AdminStaffMemberships_DeleteSessionAssistants: AdminStaffMemberships_DeleteSessionAssistantsResult;
  /** Submits feedback about an LLM response */
  AiAuthoring_SubmitWritingAssistantFeedback: AiAuthoring_SubmitWritingAssistantFeedbackResult;
  /**
   * Admin override of a single auto-flagged AI cheating event (looked up by the
   * user/course/branch/item tuple)
   */
  AiCheatingFlaggedEvent_OverrideFlaggedEvent?: Maybe<AiCheatingFlaggedEvent_OverrideFlaggedEventResult>;
  /** Create a new chat session */
  AiCoach_CreateChatSession: AiCoach_CreateChatSessionResult;
  /** Returns a LiveKit access token + websocket URL for realtime audio room join. */
  AiCoach_CreateLiveKitToken: AiCoach_CreateLiveKitTokenResult;
  /**
   * For Developer Testing
   * - Returns a LiveKit access token + websocket URL for realtime audio room join
   * for the given agent type name
   *
   * The expectation is that one would have a named agent running in
   * ECS or their local machine and have given it a unique name.
   *
   * This endpoint can then be used to create a token that will dispatch
   * an instance of that named agent to the room when the user connects
   */
  AiCoach_CreateLiveKitTokenDev: AiCoach_CreateLiveKitTokenDevResult;
  /** This mutation creates and returns the message from the user and the subsequent response returned by the AI coach. */
  AiCoach_CreateUserMessageAndReturnResponse: AiCoach_CreateUserMessageAndReturnResponseResult;
  /** Delete all chat sessions for the current learner */
  AiCoach_DeleteAllChatSessionsForCurrentUser: AiCoach_DeleteAllChatSessionsForCurrentUserResult;
  /** Delete all chat sessions for the current learner */
  AiCoach_DeleteAllChatSessionsForUser: AiCoach_DeleteAllChatSessionsForUserResult;
  /** Delete all memories for the current learner */
  AiCoach_DeleteAllMemoriesForCurrentUser: AiCoach_DeleteAllMemoriesForCurrentUserResult;
  /** Delete one or several chat sessions for the current learner */
  AiCoach_DeleteChatSessionsForCurrentUser: AiCoach_DeleteChatSessionsForCurrentUserResult;
  /** Delete one or several memories for the current learner */
  AiCoach_DeleteMemoriesForCurrentUser: AiCoach_DeleteMemoriesForCurrentUserResult;
  /**
   * Re-points a logged-out learner's chat history to the calling authenticated user at first-time
   * registration. The hashed logged-out owner is resolved from the learner's cookieId; all matching
   * chat_session and chat_message rows are re-owned by the caller's userId. Safe to retry: a repeat
   * call after a successful migration is a no-op that returns zero counts.
   * See AiCoach_LinkLoggedOutHistoryToCurrentUserInput.
   */
  AiCoach_LinkLoggedOutHistoryToCurrentUser: AiCoach_LinkLoggedOutHistoryToCurrentUserResult;
  /**
   * Use for PLATFORM: similar to AiCoach_CreateUserMessageAndReturnResponse. This mutation creates and returns the message
   * from the user and the subsequent response returned by the AI coach.
   */
  AiCoach_RespondToUserMessage: AiCoach_RespondToUserMessageResult;
  /**
   * Use for PLATFORM: similar to AiCoach_CreateUserMessageAndReturnResponse. This mutation creates and returns the message
   * from the user and the subsequent response returned by the AI coach.
   */
  AiCoach_RespondToUserMessageAsync: AiCoach_RespondToUserMessageAsyncResult;
  /** Create or update Coach settings for the current learner */
  AiCoach_SaveCoachUserSettings: AiCoach_SaveCoachUserSettingsResult;
  /** Update an existing chat session */
  AiCoach_UpdateChatSession: AiCoach_UpdateChatSessionResult;
  /** Marks a dynamic prompt with a completed status for a learner. Does nothing for a static prompt. */
  AiCoach_UpdateDynamicPromptStatusAsComplete: AiCoach_UpdateDynamicPromptStatusAsCompleteResult;
  /**
   * This mutation is used to like or dislike, add feedback comments or remove user feedback on a response they received
   * from the AI coach.
   */
  AiCoach_UpdateWithUserFeedback: AiCoach_UpdateWithUserFeedbackResult;
  /** This mutation creates/updates the index for the given asset(s). */
  AiEmbeddings_IndexDocumentAsset: AiEmbeddings_IndexDocumentAssetResult;
  /** Create a challenge. */
  AiGradedChallenge_CreateChallenge: AiGradedChallenge_CreateChallengeResult;
  /**
   * Delete a draft challenge by assessment coordinates. The challenge must have a
   * DRAFT status and must not have been published forward (no PUBLISHED challenge
   * at the next version).
   */
  AiGradedChallenge_DeleteDraftChallenge: AiGradedChallenge_DeleteDraftChallengeResult;
  /**
   * Delete a draft challenge by its challenge ID. Same validation as
   * DeleteDraftChallenge: the challenge must have DRAFT status and must not have
   * been published forward.
   */
  AiGradedChallenge_DeleteDraftChallengeById: AiGradedChallenge_DeleteDraftChallengeByIdResult;
  /**
   * Publish a draft challenge, promoting its content verbatim to a new PUBLISHED
   * challenge at the next assessment version. Accepts no rubric, instruction, or
   * course data — the draft's content is copied as-is and is not re-validated,
   * since it was already validated at create/update time.
   */
  AiGradedChallenge_PublishChallenge: AiGradedChallenge_PublishChallengeResult;
  /** Save user feedback for a challenge. */
  AiGradedChallenge_SaveUserFeedback: AiGradedChallenge_SaveUserFeedbackResult;
  /** Submit a challenge associated with the caller. */
  AiGradedChallenge_SubmitChallenge: AiGradedChallenge_SubmitChallengeResult;
  /** Update a challenge. */
  AiGradedChallenge_UpdateChallenge: AiGradedChallenge_UpdateChallengeResult;
  /** Mutation to trigger a job that will generate rubrics for an assignment (not scoped to a specific question). */
  AiGrading_CreateAssignmentLevelRubricGenerationJob: AiGrading_CreateAssignmentLevelRubricGenerationJobResult;
  /** Mutation to trigger a job that will generate rubrics for a specific assignment question. */
  AiGrading_CreateAssignmentRubricGenerationJob: AiGrading_CreateAssignmentRubricGenerationJobResult;
  /** Create AI assignments dispute for a given submission */
  AiGrading_CreateDispute: AiGrading_CreateDisputeResult;
  /** Preview AI grade for the given question and input */
  AiGrading_PreviewGradeForQuestion: AiGrading_PreviewGradeForQuestionResult;
  /**
   * Preview an AI grade for a question bank question, using rubric criteria and
   * a question prompt directly. Unlike AiGrading_PreviewGradeForQuestion, this
   * does not require assignment authoring context (branchId/itemId/questionId),
   * since question bank questions do not have an assignment authoring state.
   */
  AiGrading_PreviewGradeForQuestionBankQuestion: AiGrading_PreviewGradeForQuestionBankQuestionResult;
  /** Saves a user's feedback for one review part of an open ended question. */
  AiGrading_SaveUserFeedback: AiGrading_SaveUserFeedbackResult;
  /**
   * Materialize a previously generated item into a module. This is the
   * GraphQL counterpart to the FinalizeGeneratedItem gRPC RPC, used to commit
   * a job that was generated with a deferred materialization.
   *
   * Takes only the job id: the placement and configuration captured at
   * generate time are replayed to create and position the item. Poll
   * AiItemGeneration.queryStatusByJobId for completion before finalizing.
   */
  AiItemGeneration_FinalizeGeneratedItem: AiItemGeneration_FinalizeGeneratedItemResult;
  /**
   * Create a new AI-generated item in the given module and kick off
   * asynchronous content generation. Returns immediately once the
   * generation job is enqueued.
   *
   * Poll AiItemGeneration.queryStatusByJobId for completion.
   */
  AiItemGeneration_GenerateItem: AiItemGeneration_GenerateItemResult;
  /** Used to save feedback given by grader to AI Suggestion */
  AiSuggestions_SaveSuggestionFeedback: AiSuggestions_SaveSuggestionFeedbackResult;
  /** Marks a dynamic prompt with a completed status for a learner. Does nothing for a static prompt. */
  AiTutor_UpdateDynamicPromptStatusAsComplete: AiTutor_UpdateDynamicPromptStatusAsCompleteResult;
  /** Generate an assessment */
  AssessmentGeneration_GenerateAssessment: AssessmentGeneration_GenerateAssessmentResult;
  /** Cancel an assessment generation */
  AssessmentGeneration_StopAssessmentGeneration: AssessmentGeneration_StopAssessmentGenerationResult;
  /** Start an assignment generation request */
  AssessmentGenerator_StartGeneration?: Maybe<AssessmentGenerator_StartGenerationResult>;
  /** Add asset video. */
  AssetVideo_AddAssetVideo: AssetVideo_AddAssetVideoResult;
  /** This mutation updates an existing video to be used as an audio descriptive video asset */
  AssetVideo_ConvertExistingVideoToAudioDescriptionVideo: AssetVideo_ConvertExistingVideoToAudioDescriptionVideoResult;
  /** This mutation attempts the deletion of an audio descriptive video asset */
  AssetVideo_DeleteAudioDescriptionVideo: AssetVideo_DeleteAudioDescriptionVideoResult;
  /** Set or replace the trimming range of the given videoId for a branch. */
  AssetVideo_SetTrimmingRangeForBranch: AssetVideo_SetTrimmingRangeForBranchResult;
  /** Used to apply AI suggestions to an actual review of an assignment */
  AssignmentAiGrading_ApplyAiGrading: AssignmentAiGrading_ApplyAiGradingResult;
  /** Chats with Azure AI */
  AssignmentAi_Utilities_ChatV1?: Maybe<AssignmentAi_Utilities_ChatV1Result>;
  /** Submit student feedback on the Assignment Coach output */
  AssignmentCoach_SubmitFeedbackOnSuggestion: AssignmentCoach_SubmitFeedbackOnSuggestionResult;
  /** Assignment submission regrade configuration registration & invoking regrade */
  Assignment_AssignmentRegrade: Assignment_AssignmentRegradeResult;
  /** Create atom summative content. */
  AtomSummativeContent_CreateAtomSummativeContent: AtomSummativeContent_CreateAtomSummativeContentResult;
  /** Delete atom summative content. */
  AtomSummativeContent_DeleteAtomSummativeContent: AtomSummativeContent_DeleteAtomSummativeContentResult;
  /** Update atom summative content. */
  AtomSummativeContent_UpdateAtomSummativeContent: AtomSummativeContent_UpdateAtomSummativeContentResult;
  /** This mutation attempts the creation of an asset */
  AuthoringAssetCreationAttempts_Create: AuthoringAssetCreationAttempts_CreateResult;
  /** Create or update a Credly badge template mapping for a given product. */
  Badge_CreateOrUpdateCredlyBadgeTemplateMapping: Badge_CreateOrUpdateCredlyBadgeTemplateMappingResult;
  /** Delete the Credly badge template mapping for a given product ID. */
  Badge_DeleteCredlyBadgeTemplateMapping: Badge_DeleteCredlyBadgeTemplateMappingResult;
  /** This mutation creates an Open Badge Image. Primary use case: Downloading a Badge. */
  Badge_OpenBadgeImageGeneration?: Maybe<Badge_OpenBadgeImageGenerationResult>;
  /** This mutation creates Badge's preview image */
  Badge_PreviewGenerator?: Maybe<Badge_PreviewGeneratorResult>;
  /** This mutation deletes a beta testing schedule. */
  BetaTestingSchedule_Delete?: Maybe<BetaTestingSchedule_DeleteResult>;
  /** This mutation updates or adds a beta testing schedule. */
  BetaTestingSchedule_Update?: Maybe<BetaTestingSchedule_UpdateResult>;
  /**
   * Creates a new unpublished item with default contents for given item type and patches to
   * destination branch
   */
  BranchItem_CreateBranchItem?: Maybe<BranchItem_CreateBranchItemResult>;
  /**
   * Creates a copy of the item and patches it into the destination, which should be contained
   * within the same branch.
   */
  BranchItem_DuplicateBranchItem?: Maybe<BranchItem_DuplicateBranchItemResult>;
  /** Creates a copy of the item and patches it into the destination. */
  BranchItem_ForkBranchItem?: Maybe<BranchItem_ForkBranchItemResult>;
  /** Publishes the current draft of the item to the requested publish scope */
  BranchItem_PublishBranchItem?: Maybe<BranchItem_PublishBranchItemResult>;
  /** Patch an existing item into the destination branch, preserving existing item linking history. */
  BranchItem_ShareBranchItem?: Maybe<BranchItem_ShareBranchItemResult>;
  /**
   * Replace a versioned atom reference in a branch with an unversioned atom reference, allowing the
   * branch to receive updates to the atom made from other branches.
   */
  BranchItem_UnfreezeBranchItem?: Maybe<BranchItem_UnfreezeBranchItemResult>;
  /** Unlink the current item from other instances used in other branches */
  BranchItem_UnlinkBranchItem?: Maybe<BranchItem_UnlinkBranchItemResult>;
  /** Download Business Case Proposal Request */
  BusinessCaseProposal_RequestDownload: BusinessCaseProposal_RequestDownloadResult;
  /**
   * Sends the personalized business-case proposal PDF to the provided business email.
   *
   * This is a public, unauthenticated mutation. The resolver validates the recipient
   * business email, rate-limits per-recipient, and then runs the proposal render and
   * email send asynchronously. Returns `success: true` as soon as the synchronous
   * validations pass; downstream render/send failures are observed via service alerts.
   */
  BusinessCaseProposal_SendEmail: BusinessCaseProposal_SendEmailResult;
  /** Mutation to archive a specific campaign by id */
  CampaignManagement_ArchiveCampaign?: Maybe<CampaignManagement_ArchiveCampaignResult>;
  /** Mutation to create a new campaign with input data */
  CampaignManagement_CreateCampaign?: Maybe<CampaignManagement_CreateCampaignResult>;
  /**
   * Mutation to delete a specific campaign by id
   * @deprecated Use CampaignManagement_ArchiveCampaign instead
   */
  CampaignManagement_DeleteCampaign?: Maybe<CampaignManagement_DeleteCampaignResult>;
  /** Mutation to end a specific campaign by id. Only non-null fields will be updated */
  CampaignManagement_EndCampaign?: Maybe<CampaignManagement_EndCampaignResult>;
  /** Mutation to mark a specific campaign ready for launch by id. Only non-null fields will be updated */
  CampaignManagement_MarkCampaignReadyForLaunch?: Maybe<CampaignManagement_MarkCampaignReadyForLaunchResult>;
  /** Mutation to patch a specific campaign by id. Only non-null fields will be updated. */
  CampaignManagement_PatchCampaign?: Maybe<CampaignManagement_PatchCampaignResult>;
  /** Mutation to execute an event related to campaign display */
  Campaign_RecordEvent?: Maybe<Campaign_RecordEventResult>;
  /** This mutation adds a content to an existing role */
  CareerAcademy_AddContentsToRole: CareerAcademy_AddContentsToRoleResult;
  /** This mutation adds a new role */
  CareerAcademy_AddRole: CareerAcademy_AddRoleResult;
  /** This mutation deletes an existing role */
  CareerAcademy_DeleteRole: CareerAcademy_DeleteRoleResult;
  /** This mutation triggers curriculum refresh job asynchronously */
  CareerAcademy_RefreshCurriculums: CareerAcademy_RefreshCurriculumsResult;
  /** This mutation removes a content from a role. This mutation can only be triggered by a user with POWER_USER permission. */
  CareerAcademy_RemoveContentFromRole: CareerAcademy_RemoveContentFromRoleResult;
  /**
   * This mutation saves a subset of CA roles or all CA reference curriculum for a particular program
   * Program admins may select only roles they want to be included in programs
   * instead of importing all roles from CA reference curriculum
   */
  CareerAcademy_UpdateProgramCurriculum: CareerAcademy_UpdateProgramCurriculumResult;
  /** Deletes a course certificate print settings */
  Certificates_DeleteCourseCertificatePrintSettings?: Maybe<Certificates_DeleteCourseCertificatePrintSettingsResult>;
  /** Deletes a s12n certificate print settings */
  Certificates_DeleteS12nCertificatePrintSettings?: Maybe<Certificates_DeleteS12nCertificatePrintSettingsResult>;
  /** Updates the print settings for a course certificate */
  Certificates_UpdateCourseCertificatePrintSettings?: Maybe<Certificates_UpdateCourseCertificatePrintSettingsResult>;
  /** Updates the print settings for a specialization certificate */
  Certificates_UpdateS12nCertificatePrintSettings?: Maybe<Certificates_UpdateS12nCertificatePrintSettingsResult>;
  /** Request appeal for a cheating incident */
  CheatingIncident_RequestAppealForCheatingIncident?: Maybe<CheatingIncident_RequestAppealForCheatingIncidentResult>;
  /** Create a new cart for a given user and ownable product */
  CheckoutGateway_CreateCart: CheckoutGateway_CreateCartResult;
  /** Updates a coach item's draft */
  CoachItemAuthoring_UpdateCoachItemDraft?: Maybe<CoachItemAuthoring_UpdateCoachItemDraftResult>;
  /**
   * Starts a proctor grading attempt for a graded coach item role-play session.
   * Must be called before the learner begins the role-play conversation.
   */
  CoachItemGrading_StartGradingAttempt: CoachItemGrading_StartGradingAttemptResult;
  /** Submits a coach item chat session for grading. */
  CoachItemGrading_SubmitForGrading: CoachItemGrading_SubmitForGradingResult;
  /** Updates the progress state for a specific coach item for a user */
  CoachItemProgress_UpdateCoachItemProgress: CoachItemProgress_UpdateCoachItemProgressResult;
  /**
   * Resolves pre-generated content for a coach item roleplay session (scenario description
   * or JSON actor context). Checks the DynamoDB cache first and falls back to live LLM
   * generation on a cache miss. The response is always stored in the RDS chat history
   * so the roleplay simulation can retrieve it via the session ID.
   *
   * The input signature is intentionally identical to AiCoach_RespondToUserMessage so
   * that the frontend change is minimal and the fallback to live AI generation is
   * transparent.
   */
  CoachItem_ResolveContent: CoachItem_ResolveContentResult;
  /** This mutation adds a collection to the collection management RDS */
  Collection_AddCollection: Collection_AddCollectionResult;
  /** This mutation updates the attributes of an existing collection */
  Collection_UpdateCollectionAttributes: Collection_UpdateCollectionAttributesResult;
  /** This mutation updates the visibility of an existing collection */
  Collection_UpdateCollectionVisibilities: Collection_UpdateCollectionVisibilitiesResult;
  /** Complete a content experiment group, deactivating allocation in the downstream experiment pipeline */
  ContentExperiment_CompleteGroup: ContentExperiment_CompleteGroupResult;
  /** Create a new content experiment group */
  ContentExperiment_CreateContentExperimentGroup: ContentExperiment_CreateContentExperimentGroupResult;
  /** Create subjects for a content experiment group */
  ContentExperiment_CreateSubjectsForGroup: ContentExperiment_CreateSubjectsForGroupResult;
  /**
   * Remove subjects from a content experiment group, deleting each subject record and its associated
   * course experiment in the downstream pipeline
   */
  ContentExperiment_RemoveSubjectsFromGroup: ContentExperiment_RemoveSubjectsFromGroupResult;
  /** Start a content experiment group, activating allocation in the downstream experiment pipeline */
  ContentExperiment_StartGroup: ContentExperiment_StartGroupResult;
  /**
   * Stop a content experiment group, halting allocation by stopping each subject's course experiment
   * in the downstream pipeline
   */
  ContentExperiment_StopGroup: ContentExperiment_StopGroupResult;
  /**
   * Triggers machine translation for one or more Contentful entries.
   * Translates each entry from the source language to all specified target languages.
   *
   * Use allowOverwrite=false (default) to preserve existing human translations.
   * Use allowOverwrite=true to force retranslation of updated source content.
   *
   * Returns per-entry results so callers can see which entries succeeded or failed.
   */
  ContentfulTranslation_TranslateEntries: ContentfulTranslation_TranslateEntriesResult;
  /** This mutation crate new core taxonomy branch. */
  CoreSkillTaxonomyBranch_CreateNewBranch?: Maybe<CoreSkillTaxonomyBranch_CreateNewBranchResult>;
  /** This deactivate branch. */
  CoreSkillTaxonomyBranch_DeactivateBranch?: Maybe<CoreSkillTaxonomyBranch_DeactivateBranchResult>;
  /** This mutation freeze branch. */
  CoreSkillTaxonomyBranch_FreezeBranch?: Maybe<CoreSkillTaxonomyBranch_FreezeBranchResult>;
  /** This merge branch into main branch. */
  CoreSkillTaxonomyBranch_MergeBranch?: Maybe<CoreSkillTaxonomyBranch_MergeBranchResult>;
  /** This delete skill node by its skill ids */
  CoreSkillTaxonomyNode_DeleteNodesByBranchName: CoreSkillTaxonomyNode_DeleteNodesByBranchNameResult;
  /** This upserts skill node by branch name */
  CoreSkillTaxonomyNode_UpsertNodesByBranchName: CoreSkillTaxonomyNode_UpsertNodesByBranchNameResult;
  /**
   * This triggers the generation of the assessment outline items for modules quizzes or/and final exams. It returns the
   * updated workflow with the generated assessment outline items and status set to USER_ASSESSMENTS_OUTLINE_CHECKPOINT
   */
  CourseBuilderV2_GenerateAssessmentsOutlineItems?: Maybe<CourseBuilderV2_GenerateAssessmentsOutlineItemsResult>;
  /**
   * Rewinds the workflow to an earlier checkpoint, optionally retaining a list of curated items to
   * use in the next workflow iteration
   */
  CourseBuilderV2_RewindToCheckpoint?: Maybe<CourseBuilderV2_RewindToCheckpointResult>;
  /**
   * Power-user mutation to rewind a workflow to an earlier step and trigger another executor job.
   * Typically used to re-run a failed workflow step.
   */
  CourseBuilderV2_RewindToStep?: Maybe<CourseBuilderV2_RewindToStepResult>;
  /** Saves the Coach chat session id for the current user to the workflow. */
  CourseBuilderV2_SaveCoachChatSession?: Maybe<CourseBuilderV2_SaveCoachChatSessionResult>;
  /** Starts analyzing a workflow's course outline for content gaps. */
  CourseBuilderV2_StartAnalyzingContentForGaps?: Maybe<CourseBuilderV2_StartAnalyzingContentForGapsResult>;
  /** Triggers execution of remaining workflow steps */
  CourseBuilderV2_StartGeneratingCourseMaterials?: Maybe<CourseBuilderV2_StartGeneratingCourseMaterialsResult>;
  /** Triggers the execution of the authoring from scratch workflow, up to the USER_OUTLINE_CHECKPOINT */
  CourseBuilderV2_StartGeneratingCourseOutlineFromScratch?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineFromScratchResult>;
  /**
   * Triggers execution of workflow steps up to USER_CURATION_CHECKPOINT. If a CreateInput is passed in,
   * a new workflow will be created. Otherwise, it is assumed that we're rerunning the
   * GENERATING_COURSE_OUTLINE_FROM_SELECTED_COURSES step for an existing workflow.
   */
  CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCourses?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesResult>;
  /**
   * Triggers execution of workflow steps up to USER_OUTLINE_CHECKPOINT. If a CreateInput is passed in,
   * a new workflow will be created. Otherwise, it is assumed that we're rerunning the
   * CONVERTING_SYLLABUS_TO_COURSE_OUTLINE step for an existing workflow.
   */
  CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFile?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileResult>;
  /** Triggers execution of workflow steps up to USER_CURATION_CHECKPOINT */
  CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItems?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsResult>;
  /**
   * Triggers execution of workflow steps up to USER_OUTLINE_CHECKPOINT. If a CreateInput is passed in,
   * a new workflow will be created. Otherwise, it is assumed that we're rerunning the
   * GENERATING_COURSE_OUTLINE_WITH_MODULES_AND_LEARNING_OBJECTIVES step for an existing workflow.
   */
  CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectives?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesResult>;
  /** Triggers execution of workflow steps up to USER_SEARCH_TERMS_CHECKPOINT */
  CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTerms?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsResult>;
  /** Generate the course outline with skills */
  CourseBuilderV2_StartGeneratingCourseOutlineWithSkills?: Maybe<CourseBuilderV2_StartGeneratingCourseOutlineWithSkillsResult>;
  /** Triggers the execution of step 2 of authoring from scratch workflow, generating items, up to the USER_ITEM_REVIEW_CHECKPOINT */
  CourseBuilderV2_StartGeneratingItemOutlineFromScratch?: Maybe<CourseBuilderV2_StartGeneratingItemOutlineFromScratchResult>;
  /**
   * Starts generating placeholder items for a workflow based on the recommendations
   * stored on the workflow.
   */
  CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendations?: Maybe<CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsResult>;
  /** Allows users to edit the `courseOutline` field. */
  CourseBuilderV2_UpdateCourseOutline?: Maybe<CourseBuilderV2_UpdateCourseOutlineResult>;
  /**
   * Allows users to edit the courseOutlineWithCuratedItems field during the USER_CURATION_CHECKPOINT step.
   *
   * Deprecated in favour of CourseBuilderV2_UpdateCourseOutline.
   * @deprecated Use CourseBuilderV2_UpdateCourseOutline instead
   */
  CourseBuilderV2_UpdateCourseOutlineWithCuratedItems?: Maybe<CourseBuilderV2_UpdateCourseOutlineWithCuratedItemsResult>;
  /**
   * Allows users to edit the courseOutlineWithModulesAndLearningObjectives field during the USER_OUTLINE_CHECKPOINT step
   *
   * Deprecated in favour of CourseBuilderV2_UpdateCourseOutline.
   * @deprecated Use CourseBuilderV2_UpdateCourseOutline instead
   */
  CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectives?: Maybe<CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesResult>;
  /**
   * Allows users to edit the courseOutlineWithSearchTerms field during the USER_SEARCH_TERMS_CHECKPOINT step.
   *
   * Deprecated in favour of CourseBuilderV2_UpdateCourseOutline.
   * @deprecated Use CourseBuilderV2_UpdateCourseOutline instead
   */
  CourseBuilderV2_UpdateCourseOutlineWithSearchTerms?: Maybe<CourseBuilderV2_UpdateCourseOutlineWithSearchTermsResult>;
  /**
   * Allows users to edit the courseOutlineWithItems field during the USER_ITEM_REVIEW_CHECKPOINT step
   * @deprecated Use CourseBuilderV2_UpdateCourseOutline instead
   */
  CourseBuilderV2_UpdateItemOutlineFromScratch?: Maybe<CourseBuilderV2_UpdateItemOutlineFromScratchResult>;
  /** Create a course builder restriction. */
  CourseBuilder_CreateRestriction: CourseBuilder_CreateRestrictionResult;
  /** Delete a course builder restriction. */
  CourseBuilder_DeleteRestriction: CourseBuilder_DeleteRestrictionResult;
  /** Update a course builder restriction. */
  CourseBuilder_UpdateRestriction: CourseBuilder_UpdateRestrictionResult;
  /** Trigger a translate job to proactively translate course content. */
  CourseContentTranslation_TriggerProactiveCourseTranslation: CourseContentTranslation_TriggerProactiveCourseTranslationResult;
  /**
   * Set the default enterprise program for a specific course.
   * This is used as a part of the Course Builder authoring flow, when embedding items author's select
   * from a list of enterprise program's to embed from. This mutation sets the default program for
   * a given course.
   */
  CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgram?: Maybe<CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramResult>;
  /** Modifies course offerings */
  CourseOfferingMutations: CourseOfferingMutationQueries;
  /** Update course profile for an institution */
  CourseProfiles_UpdateCourseProfileForInstitution?: Maybe<CourseProfiles_UpdateCourseProfileForInstitutionResult>;
  /** Update course profile for a program */
  CourseProfiles_UpdateCourseProfileForProgram?: Maybe<CourseProfiles_UpdateCourseProfileForProgramResult>;
  /** Apply a grade override for a user's course progress. */
  CourseProgress_ApplyCourseProgressOverride: CourseProgress_ApplyCourseProgressOverrideResult;
  /** Remove a grade override for a user's course progress. */
  CourseProgress_RemoveCourseProgressOverride: CourseProgress_RemoveCourseProgressOverrideResult;
  /** Resyncs item progress from atom progress store and recomputes branch progress. */
  CourseProgress_ResyncCourseBranchProgress: CourseProgress_ResyncCourseBranchProgressResult;
  /** Toggle the grade visibility for a user's atom progress. */
  CourseProgress_ToggleAtomGradeHide: CourseProgress_ToggleAtomGradeHideResult;
  /**
   * Saves a Coursera Plus Collection for the logged-in user. User ID is taken from request context.
   * Sends the Collection Welcome Email and returns the saved Collection on success.
   */
  CourseraPlusCollections_Save: CourseraPlusCollections_SaveResult;
  /** Request to end a proctoring session. */
  CourseraProctoring_EndProctoring: CourseraProctoring_EndProctoringResult;
  /** Register a proctoring asset and get an upload URL. */
  CourseraProctoring_InitializeAsset: CourseraProctoring_InitializeAssetResult;
  /** Request to analyze the uploaded asset and receive result. */
  CourseraProctoring_ProcessAsset: CourseraProctoring_ProcessAssetResult;
  /**
   * Request to manually reanalyze recordings that previously failed analysis.
   * INTERNAL USE ONLY: This operation is intended for manual intervention by engineers when recording analysis fails.
   */
  CourseraProctoring_ReanalyzeRecordings: CourseraProctoring_ReanalyzeRecordingsResult;
  /** Set the enablement configuration for Coursera Proctoring on an assessment. */
  CourseraProctoring_SetEnablement: CourseraProctoring_SetEnablementResult;
  /** Request to start a proctoring session. */
  CourseraProctoring_StartProctoring: CourseraProctoring_StartProctoringResult;
  /** Submit feedback for a proctoring event. */
  CourseraProctoring_SubmitProctoringEventFeedback: CourseraProctoring_SubmitProctoringEventFeedbackResult;
  /** Modifies CourseraTierSubscription-related data. */
  CourseraTierSubscriptionsMutations?: Maybe<CourseraTierSubscriptionsMutationQueries>;
  /** Delete the Courserian from our persisted data storage. */
  CourserianRoles_DeleteRolesOfCourserian: CourserianRoles_DeleteRolesOfCourserianResult;
  /**
   * Update the Courserian to take the supplied roles. Can be used to add new Courserians
   * (with roles specified), or add or remove roles for an existing Courserian.
   */
  CourserianRoles_UpdateRolesOfCourserian: CourserianRoles_UpdateRolesOfCourserianResult;
  /** Set credential configuration for a collection or learning path */
  CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPath: CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathResult;
  /** Set credential configuration for a program and its entire content */
  CredentialConfiguration_SetCredentialConfigurationForProgram: CredentialConfiguration_SetCredentialConfigurationForProgramResult;
  /**
   * Update credential configurations for an institution
   * The updates are specified for programs and collections under this program
   */
  CredentialConfiguration_UpdateCredentialConfigurationsForInstitution?: Maybe<CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionResult>;
  /**
   * Update credential configurations for a program
   * The updates are specified for collections and products under this program
   */
  CredentialConfiguration_UpdateCredentialConfigurationsForProgram?: Maybe<CredentialConfiguration_UpdateCredentialConfigurationsForProgramResult>;
  /** Add Group Curations to matching Programs */
  CurationBuilder_AddGroupCurationsToPrograms: CurationBuilder_AddGroupCurationsToProgramsResult;
  /** Creates an enterprise program from a program outline */
  CurationBuilder_CreateProgramFromProgramOutline: CurationBuilder_CreateProgramFromProgramOutlineResult;
  /** Generates multiple curation outlines for a potential learning path or collection */
  CurationBuilder_GenerateBulkCurationOutlines: CurationBuilder_GenerateBulkCurationOutlinesResult;
  /** Generates a single curation outline for a potential learning path or collection */
  CurationBuilder_GenerateCurationOutline: CurationBuilder_GenerateCurationOutlineResult;
  /** Generates content suggestions for curation outlines */
  CurationBuilder_GenerateCurationOutlineContentSuggestions: CurationBuilder_GenerateCurationOutlineContentSuggestionsResult;
  /**
   * Generates an s3 file upload location using the provided orgId & fileName
   * BE will return an s3 FileUploadLocation
   * FE is expected to use the returned FileUploadLocation to upload the actual file to s3.
   */
  CurationBuilder_GenerateFileUploadLocation: CurationBuilder_GenerateFileUploadLocationResult;
  /** Generates program outline (including multiple curated content outlines) for a potential program being built */
  CurationBuilder_GenerateProgramOutline: CurationBuilder_GenerateProgramOutlineResult;
  /**
   * After FE has uploaded the files, it should call this API passing the
   * s3 file upload location details for backend to process the file.
   */
  CurationBuilder_GeneratePromptAttributesFromFile: CurationBuilder_GeneratePromptAttributesFromFileResult;
  /** Updates badge configurations for learning paths */
  CurationBuilder_UpdateBadgeConfigurations: CurationBuilder_UpdateBadgeConfigurationsResult;
  /** Update badge configurations for multiple programs at once. */
  CurationBuilder_UpdateBadgeConfigurationsForPrograms: CurationBuilder_UpdateBadgeConfigurationsForProgramsResult;
  /** Updates an existing curation outline */
  CurationBuilder_UpdateCurationOutline: CurationBuilder_UpdateCurationOutlineResult;
  /** Updates an existing curation outline */
  CurationBuilder_UpdateCurationOutlineWithGroups: CurationBuilder_UpdateCurationOutlineWithGroupsResult;
  /** Updates an enterprise program from a curation outline */
  CurationBuilder_UpdateProgramFromCurationOutline: CurationBuilder_UpdateProgramFromCurationOutlineResult;
  /** Updates an existing program outline with manual user changes */
  CurationBuilder_UpdateProgramOutline: CurationBuilder_UpdateProgramOutlineResult;
  /** Generates new curation recommendations for a collection based on the specified input parameters */
  CurationRecommendation_GenerateRecommendation: CurationRecommendation_GenerateRecommendationResult;
  /** Updates the status of a curation recommendation suggestion */
  CurationRecommendation_UpdateSuggestionStatus: CurationRecommendation_UpdateSuggestionStatusResult;
  /** Trigger Curriculum Download job */
  CurriculumBuilder_TriggerCurriculumDownload?: Maybe<CurriculumBuilder_TriggerCurriculumDownloadResult>;
  /** Opens up the DPM experience for learners on degree home */
  CurriculumManagement_LaunchDegreeProgressMapExperience: CurriculumManagement_LaunchDegreeProgressMapExperienceResult;
  /** Triggers a file processing job */
  CurriculumManagement_StartFileProcessing?: Maybe<CurriculumManagement_StartFileProcessingResult>;
  /** Update Degree Attributes */
  DegreeAttributes_UpdateDegreeAttributes: DegreeAttributes_UpdateDegreeAttributesResult;
  /** Modifies degree category(ies). */
  DegreeCategoryMutations: DegreeCategoryMutationQueries;
  /** Create student success attributes */
  DegreeConfig_CreateStudentSuccessAttributes?: Maybe<DegreeConfig_CreateStudentSuccessAttributesResult>;
  /** Set student success attributes */
  DegreeConfig_UpdateStudentSuccessAttributes?: Maybe<DegreeConfig_UpdateStudentSuccessAttributesResult>;
  /** Modifies degree enrollments checklist. */
  DegreeEnrollmentCheckListMutations?: Maybe<DegreeEnrollmentCheckListMutationQueries>;
  /** Update catalog degree course */
  DegreeMarketing_UpdateCourse: DegreeMarketing_UpdateCourseResult;
  /** This mutation generates an URL for the user to import their video into descript */
  Descript_CreateEditUrl: Descript_CreateEditUrlResult;
  /**
   * Adds an email address to the whitelist.
   * Returns success status and message.
   */
  EmailWhitelist_AddToWhitelist: EmailWhitelist_AddToWhitelistResult;
  /**
   * Removes an email address from the whitelist.
   * Returns success status and message.
   */
  EmailWhitelist_RemoveFromWhitelist: EmailWhitelist_RemoveFromWhitelistResult;
  /**
   * Add a new embedding allowed domain for an organization. Fails with a
   * duplicate-domain error if the domain already exists for the organization.
   */
  EmbeddedExp_AddAllowedDomain: EmbeddedExp_AddAllowedDomainResult;
  /**
   * Delete an embedding allowed domain. This is a soft-delete; the record is marked
   * inactive rather than removed.
   */
  EmbeddedExp_DeleteAllowedDomain: EmbeddedExp_DeleteAllowedDomainResult;
  /**
   * Update an existing embedding allowed domain. At least one of domain or isActive
   * must be provided in the input.
   */
  EmbeddedExp_UpdateAllowedDomain: EmbeddedExp_UpdateAllowedDomainResult;
  /**
   * Updates an existing program curriculum. Migrated from Naptime
   * PUT /api/v1/programCurriculums/{id} in infra-services
   * (ProgramCurriculumsResource.update).
   *
   * Authorization mirrors access.editCurriculum(id) in the Naptime
   * resource, minus access.internal (no GraphQL analog — internal
   * callers use gRPC ProgramCurriculumsAPI.Update directly).
   *
   * The resolver verifies that input.programId actually owns
   * input.curriculumId before applying the update.
   */
  EntCurriculum_UpdateProgramCurriculum: EntCurriculum_UpdateProgramCurriculumResult;
  /** Creates a new external platform gateway configuration. */
  EntExternalConnector_CreateConfiguration: EntExternalConnector_CreateConfigurationResult;
  /** Deletes an existing external platform gateway configuration. */
  EntExternalConnector_DeleteConfiguration: EntExternalConnector_DeleteConfigurationResult;
  /** Updates an existing external platform gateway configuration. */
  EntExternalConnector_UpdateConfiguration: EntExternalConnector_UpdateConfigurationResult;
  /** Adds or updates a payment method as a backup for an enterprise contract. */
  EntTransaction_AddOrUpdateNewPaymentMethod: EntTransaction_AddOrUpdateNewPaymentMethodResult;
  /**
   * Creates a new enterprise contract purchase order.
   * Allows users to submit orders for enterprise contracts with various billing options.
   */
  EntTransaction_CreateEnterpriseContractPurchaseOrder: EntTransaction_CreateEnterpriseContractPurchaseOrderResult;
  /** Creates a non-billable free trial for Coursera for Teams. */
  EntTransaction_CreateNonBillableFreeTrial: EntTransaction_CreateNonBillableFreeTrialResult;
  /** Deletes a backup payment method from an enterprise contract. */
  EntTransaction_DeleteBackupPaymentMethod: EntTransaction_DeleteBackupPaymentMethodResult;
  /**
   * Finalizes an enterprise contract purchase order by associating it with a contract ID.
   * This is typically called after the contract has been created and provisioned.
   */
  EntTransaction_FinalizeOrder: EntTransaction_FinalizeOrderResult;
  /**
   * Makes a payment method the primary payment method for an enterprise contract.
   * Optionally adds the old primary payment method to the backup payment methods list.
   */
  EntTransaction_MakeMethodPrimary: EntTransaction_MakeMethodPrimaryResult;
  /**
   * Terminates an active free trial and revokes the associated enterprise contract.
   * This action will:
   * 1. Update the free trial status to TERMINATED
   * 2. Revoke the associated enterprise contract
   * 3. Remove admin role from the organization
   */
  EntTransaction_TerminateFreeTrial: EntTransaction_TerminateFreeTrialResult;
  /**
   * Updates the contract and term ID associated with an enterprise contract order.
   * This is typically called after a contract is created to link it back to the order.
   */
  EntTransaction_UpdateContractAndTermId: EntTransaction_UpdateContractAndTermIdResult;
  /**
   * Updates the state of an enterprise contract order.
   * Allows internal users to change the order status (e.g., OPEN, COMPLETED, ABORTED).
   */
  EntTransaction_UpdateOrderState: EntTransaction_UpdateOrderStateResult;
  /** Mark a recommended action as completed */
  EnterpriseAdminHomePage_MarkRecommendedActionAsCompleted: EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedResult;
  /** Request more licenses for a contract */
  EnterpriseAdminHomePage_RequestMoreLicenses: EnterpriseAdminHomePage_RequestMoreLicensesResult;
  /** This mutation accept all invitations for email and organization from invitation */
  EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitation: EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationResult;
  /** This mutation creates an enterprise admin invitation or role */
  EnterpriseAdmin_CreateInvitationsOrRoles: EnterpriseAdmin_CreateInvitationsOrRolesResult;
  /** This mutation deletes all admin invitations for a given userId and organizationId */
  EnterpriseAdmin_DeleteAllAdminInvitations: EnterpriseAdmin_DeleteAllAdminInvitationsResult;
  /** This mutation deletes an enterprise admin invitation by id */
  EnterpriseAdmin_DeleteInvitationsOrRoles: EnterpriseAdmin_DeleteInvitationsOrRolesResult;
  /** This mutation validates enterprise admin creation */
  EnterpriseAdmin_ValidateInvitationsOrRoles: EnterpriseAdmin_ValidateInvitationsOrRolesResult;
  /** This mutation creates Enterprise Badge */
  EnterpriseBadge_Create?: Maybe<EnterpriseBadge_CreateResult>;
  /** This mutation deletes the Learning Path */
  EnterpriseBadge_DeleteLearningPath?: Maybe<EnterpriseBadge_DeleteLearningPathResult>;
  /** This mutation duplicate the Learning Path to a program */
  EnterpriseBadge_DuplicateLearningPath?: Maybe<EnterpriseBadge_DuplicateLearningPathResult>;
  /** This mutation use AI automated to create Enterprise Badge's learning objectives */
  EnterpriseBadge_GenerateLearningObjectives?: Maybe<EnterpriseBadge_GenerateLearningObjectivesResult>;
  /** This mutation updates a list of badge template id and badge image urls */
  EnterpriseBadge_UpdateBadgeConfigurations?: Maybe<EnterpriseBadge_UpdateBadgeConfigurationsResult>;
  /** This mutation updates the Enterprise Badge Activities */
  EnterpriseBadge_UpdateLearningPathActivities?: Maybe<EnterpriseBadge_UpdateLearningPathActivitiesResult>;
  /** This mutation updates the Enterprise Badge */
  EnterpriseBadge_UpdateLearningPathMetadata?: Maybe<EnterpriseBadge_UpdateLearningPathMetadataResult>;
  /** Create new content assignments */
  EnterpriseContentAssignment_CreateAssignments: EnterpriseContentAssignment_CreateAssignmentsResult;
  /** Create content assignments across multiple programs. */
  EnterpriseContentAssignment_CreateAssignmentsForPrograms: EnterpriseContentAssignment_CreateAssignmentsForProgramsResult;
  /** Delete existing assignments */
  EnterpriseContentAssignment_DeleteAssignments: EnterpriseContentAssignment_DeleteAssignmentsResult;
  /** Generate CSV upload location. */
  EnterpriseContentAssignment_GenerateCsvUploadLocation: EnterpriseContentAssignment_GenerateCsvUploadLocationResult;
  /**
   * Deletes a scheduled billing by its billing identifier. Intended for internal Courserian
   * engineering tooling and operational cleanup. Deletion is idempotent: deleting a billing
   * that does not exist succeeds with deleted = false.
   */
  EnterpriseContractBillingSchedule_DeleteBilling: EnterpriseContractBillingSchedule_DeleteBillingResult;
  /**
   * Schedules a billing run for a specific installment of an enterprise contract term.
   * Mirrors the EnterpriseContractBillingScheduleAPI.ScheduleBilling gRPC method and is
   * intended for internal Courserian engineering tooling and operational backfills.
   */
  EnterpriseContractBillingSchedule_ScheduleBilling: EnterpriseContractBillingSchedule_ScheduleBillingResult;
  /**
   * Creates a new enterprise contract invoice initial order.
   * This endpoint creates an invoice for a new enterprise contract.
   */
  EnterpriseContractInvoice_CreateInvoiceOrder: EnterpriseContractInvoice_CreateInvoiceOrderResult;
  /**
   * Creates a new enterprise contract invoice renewal order.
   * This endpoint creates a renewal invoice that extends an existing enterprise
   * contract for another term.
   */
  EnterpriseContractInvoice_CreateInvoiceRenewalOrder: EnterpriseContractInvoice_CreateInvoiceRenewalOrderResult;
  /**
   * Creates a new enterprise contract invoice upgrade (upsell) order.
   * This endpoint creates an upsell invoice that adds additional licenses to an existing
   * enterprise contract, optionally applying an enterprise promotion.
   */
  EnterpriseContractInvoice_CreateInvoiceUpgradeOrder: EnterpriseContractInvoice_CreateInvoiceUpgradeOrderResult;
  /** Creates a contract ended policy for an enterprise contract. */
  EnterpriseContractPolicy_CreateContractEndedPolicy: EnterpriseContractPolicy_CreateContractEndedPolicyResult;
  /** Creates a contract fully utilized policy for an enterprise contract. */
  EnterpriseContractPolicy_CreateContractFullyUtilizedPolicy: EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyResult;
  /** Deletes a contract policy for an enterprise contract. */
  EnterpriseContractPolicy_DeleteContractPolicy: EnterpriseContractPolicy_DeleteContractPolicyResult;
  /** Creates a new enterprise pricing discount rule (e.g. volume discount tier). */
  EnterpriseContractPrice_CreatePricingDiscountRule: EnterpriseContractPrice_CreatePricingDiscountRuleResult;
  /**
   * Sends an enterprise self-serve contract pricing estimate to the provided business email.
   * Validates the recipient is a business email, computes the pricing using the same parameters
   * as `getEnterpriseSelfServeContractProductPrice`, and emails the breakdown.
   *
   * This is a public, unauthenticated mutation. Per-recipient send caps within a rolling window
   * are enforced server-side (see `errorReason` when `emailSent` is false).
   */
  EnterpriseContractPrice_SendEstimateEmail: EnterpriseContractPrice_SendEstimateEmailResult;
  /** Updates the active status of an existing pricing rule. */
  EnterpriseContractPrice_UpdatePricingDiscountRuleStatus: EnterpriseContractPrice_UpdatePricingDiscountRuleStatusResult;
  /**
   * Changes the auto-renewal authorization for an enterprise contract.
   * This mutation allows enabling or disabling automatic renewal for a contract.
   */
  EnterpriseContractRenewal_ChangeAutoRenewAuthorization: EnterpriseContractRenewal_ChangeAutoRenewAuthorizationResult;
  /** add a new contract tag */
  EnterpriseContractTag_AddTag: EnterpriseContractTag_AddTagResult;
  /** delete an existing contract tag */
  EnterpriseContractTag_DeleteTag: EnterpriseContractTag_DeleteTagResult;
  /** Activate a contract */
  EnterpriseContract_ActivateContract: EnterpriseContract_ActivateContractResult;
  /** Create a contract */
  EnterpriseContract_CreateContract: EnterpriseContract_CreateContractResult;
  /**
   * Deactivates an enterprise contract without processing a refund.
   * Used for migrating contracts or exceptional cases where refunds are not applicable.
   * Requires power user access level.
   */
  EnterpriseContract_DeactivateWithoutRefund: EnterpriseContract_DeactivateWithoutRefundResult;
  /** Downgrades an EnterpriseContract by ID - with an option to send membership deletion notification. */
  EnterpriseContract_DowngradeContract: EnterpriseContract_DowngradeContractResult;
  /**
   * Internal housekeeping mutation for enterprise contracts.
   *
   * This is an engineering-only operation used to correct or adjust contract state
   * out-of-band (for example, fixing an incorrect term end date, or adjusting the next
   * scheduled payment date). A single action is performed per call, selected by which field
   * is set on the `action` input.
   *
   * Requires Courserian engineer access.
   */
  EnterpriseContract_Housekeeping: EnterpriseContract_HousekeepingResult;
  /** Pause an EnterpriseContract */
  EnterpriseContract_PauseContract: EnterpriseContract_PauseContractResult;
  /** Renew an EnterpriseContract */
  EnterpriseContract_ProvisionRenewalContract: EnterpriseContract_ProvisionRenewalContractResult;
  /**
   * Processes a refund for an enterprise contract.
   * Internal operation with validation options for exceptional cases.
   * Requires power user access level.
   */
  EnterpriseContract_RefundContract: EnterpriseContract_RefundContractResult;
  /** This mutation to restore the old contract to a new contract. */
  EnterpriseContract_TriggerRestoreJob: EnterpriseContract_TriggerRestoreJobResult;
  /** Update an EnterpriseContract billing type */
  EnterpriseContract_UpdateContractBillingType: EnterpriseContract_UpdateContractBillingTypeResult;
  /** Update EnterpriseContract endsAt date/time */
  EnterpriseContract_UpdateContractEndsAt: EnterpriseContract_UpdateContractEndsAtResult;
  /** Update Contract Limits */
  EnterpriseContract_UpdateContractLimits: EnterpriseContract_UpdateContractLimitsResult;
  /** Update an EnterpriseContract name */
  EnterpriseContract_UpdateContractName: EnterpriseContract_UpdateContractNameResult;
  /** Update contract purpose */
  EnterpriseContract_UpdateContractPurpose: EnterpriseContract_UpdateContractPurposeResult;
  /** Update scheduled activation for a contract. Set scheduledActivationAt to null to cancel. */
  EnterpriseContract_UpdateScheduledActivation: EnterpriseContract_UpdateScheduledActivationResult;
  /** This mutation creates a renewal for an enterprise coupon. */
  EnterpriseCoupon_CreateForRenewal: EnterpriseCoupon_CreateForRenewalResult;
  /**
   * Save (bookmark) a product for the logged-in user within the specified organization.
   * Server resolves programId, contractId, termId, and orgId internally from orgSlug.
   * Replaces ProgramEnrollmentsV2 selectCourse / selectS12n.
   */
  EnterpriseEnrollment_OrgSaveProduct: EnterpriseEnrollment_OrgSaveProductResult;
  /**
   * Remove a saved (bookmarked) product for the logged-in user within the specified organization.
   * Replaces ProgramEnrollmentsV2 unselectCourse / unselectS12n.
   */
  EnterpriseEnrollment_OrgUnsaveProduct: EnterpriseEnrollment_OrgUnsaveProductResult;
  /** This mutation creates a Gradebook export job. */
  EnterpriseGradebooks_EnterpriseItemAttemptsGradebooks: EnterpriseGradebooks_EnterpriseItemAttemptsGradebooksResult;
  /** this mutation creates an Enterprise Group (backed by EnterpriseProgram with managementType=MANUAL) */
  EnterpriseGroup_Create?: Maybe<EnterpriseGroup_CreateResult>;
  /** this mutation deletes Enterprise Groups (bulk-native, two deletion modes) */
  EnterpriseGroup_Delete?: Maybe<EnterpriseGroup_DeleteResult>;
  /**
   * This mutation creates a self-serve invoice that allows customers to pay via Stripe Elements.
   * It returns the client secret and publishable key needed for the frontend payment flow.
   */
  EnterpriseInvoice_CreateSelfServeInvoice: EnterpriseInvoice_CreateSelfServeInvoiceResult;
  /**
   * This mutation creates a self-serve invoice with customer billing details and returns a hosted invoice URL.
   * Use this mutation when you need to generate an invoice with complete billing information including
   * customer address and tax ID details, and get a Stripe-hosted URL for invoice viewing and payment.
   */
  EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrl: EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlResult;
  /** This mutation creates an enterprise lead. */
  EnterpriseLead_CreateLead: EnterpriseLead_CreateLeadResult;
  /**
   * Builds a learner cohort from a natural-language query and persists the generated SQL.
   * Returns a cohort ID that can be paged via EnterpriseLearnerCohort.fetchEnterpriseLearnerCohorts.
   */
  EnterpriseLearnerCohort_Create: EnterpriseLearnerCohort_CreateResult;
  /**
   * Builds a cohort and returns its first page of learners in one round trip. Equivalent to
   * EnterpriseLearnerCohort_Create followed immediately by EnterpriseLearnerCohort.fetchEnterpriseLearnerCohorts.
   */
  EnterpriseLearnerCohort_CreateAndFetch: EnterpriseLearnerCohort_CreateAndFetchResult;
  /** This mutation deletes all enterprise learner profiles in an organization. */
  EnterpriseLearnerProfile_DeleteAllByOrganization: EnterpriseLearnerProfile_DeleteAllByOrganizationResult;
  /** This mutation deletes enterprise learner profiles by organization and emails. */
  EnterpriseLearnerProfile_DeleteByOrganizationAndEmails: EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsResult;
  /** Returns an S3 object location and a presigned URL for uploading a manual learner-list CSV. */
  EnterpriseMessages_GenerateUploadLocForManualList: EnterpriseMessages_GenerateUploadLocForManualListResult;
  /**
   * Schedules an enterprise learner-communication campaign (scoped trigger) at the given cadence and
   * marks its sent messages as AUTO_SEND. Wraps the postal scopedTriggersMetadata schedule action and,
   * on a best-effort basis, syncs the campaign's sent-message rows.
   */
  EnterpriseMessages_ScheduleScopedTrigger: EnterpriseMessages_ScheduleScopedTriggerResult;
  /**
   * Unschedules an enterprise learner-communication campaign (scoped trigger) and marks its sent
   * messages as PAUSED. Wraps the postal scopedTriggersMetadata unschedule action and, on a best-effort
   * basis, syncs the campaign's sent-message rows.
   */
  EnterpriseMessages_UnscheduleScopedTrigger: EnterpriseMessages_UnscheduleScopedTriggerResult;
  /** This mutation deletes an admin's roles */
  EnterprisePermission_DeleteAdmin: EnterprisePermission_DeleteAdminResult;
  /** This mutation updates the roles an admin has */
  EnterprisePermission_UpdateUserRoles: EnterprisePermission_UpdateUserRolesResult;
  /**
   * Runs the private course computation,
   * and then adds the course to a particular program / collection
   */
  EnterprisePrivateCourses_AddToProgram: EnterprisePrivateCourses_AddToProgramResult;
  /** this mutation creates EnterpriseProgram */
  EnterpriseProgram_Archive?: Maybe<EnterpriseProgram_ArchiveResult>;
  /** this mutation creates EnterpriseProgram */
  EnterpriseProgram_Create?: Maybe<EnterpriseProgram_CreateResult>;
  /** Generate file upload location for generated programs. */
  EnterpriseProgram_GenerateProgramFileUploadLocation: EnterpriseProgram_GenerateProgramFileUploadLocationResult;
  /** This mutation creates Program Outline */
  EnterpriseProgram_GenerateProgramOutline?: Maybe<EnterpriseProgram_GenerateProgramOutlineResult>;
  /** this mutation generates the program suggestions */
  EnterpriseProgram_GenerateProgramSuggestions?: Maybe<EnterpriseProgram_GenerateProgramSuggestionsResult>;
  /** this mutation links the created program with generation requests */
  EnterpriseProgram_LinkProgramWithGenerationRequests?: Maybe<EnterpriseProgram_LinkProgramWithGenerationRequestsResult>;
  /** this mutation updates EnterpriseProgram */
  EnterpriseProgram_Update?: Maybe<EnterpriseProgram_UpdateResult>;
  /** this mutation updates EnterpriseProgram Skillsets */
  EnterpriseProgram_UpdateSkillsets?: Maybe<EnterpriseProgram_UpdateSkillsetsResult>;
  /**
   * Creates a new enterprise promotion.
   * Writes the generic promotion row through the downstream promotions service and the
   * enterprise overlay row locally; optionally attaches a promo code when one is supplied
   * and the promotion is not site-wide.
   */
  EnterprisePromotion_Create: EnterprisePromotion_CreateResult;
  /**
   * Hard-deletes an enterprise promotion along with its underlying B2C promotion and any
   * attached promo codes. Returns the deleted enterprise promotion id. To deactivate a
   * promotion that has already been applied, use EnterprisePromotion_Update with
   * endsAt = current time instead.
   */
  EnterprisePromotion_Delete: EnterprisePromotion_DeleteResult;
  /**
   * Updates an existing enterprise promotion. All fields are optional; only supplied
   * fields are mutated. Changes to startsAt, endsAt, promotionStage, isSiteWide or
   * targetedContractIds re-run the overlap validator.
   * To deactivate a promotion, set endsAt to the current time.
   */
  EnterprisePromotion_Update: EnterprisePromotion_UpdateResult;
  /** this mutation deletes a scheduled job */
  EnterpriseReports_DeleteSchedule?: Maybe<EnterpriseReports_DeleteScheduleResult>;
  /** this mutation starts an export job */
  EnterpriseReports_ExportReport?: Maybe<EnterpriseReports_ExportReportResult>;
  /** this mutation upserts a scheduled job */
  EnterpriseReports_SaveSchedule?: Maybe<EnterpriseReports_SaveScheduleResult>;
  /** Configure SCIM for an organization */
  EnterpriseScim_ConfigureScim: EnterpriseScim_ConfigureScimResult;
  /** Generate a new SCIM token for an organization */
  EnterpriseScim_GenerateToken: EnterpriseScim_GenerateTokenResult;
  /** Revoke a SCIM token */
  EnterpriseScim_RevokeToken: EnterpriseScim_RevokeTokenResult;
  /** Update group to program mappings */
  EnterpriseScim_UpdateGroupProgramMappings: EnterpriseScim_UpdateGroupProgramMappingsResult;
  /** Enable or disable SCIM for an organization */
  EnterpriseScim_UpdateScimStatus: EnterpriseScim_UpdateScimStatusResult;
  /** Update should send invite mail flag for SCIM configuration */
  EnterpriseScim_UpdateShouldSendInviteMail: EnterpriseScim_UpdateShouldSendInviteMailResult;
  /** Update the enterprise setting */
  EnterpriseSetting_Update: EnterpriseSetting_UpdateResult;
  /** this mutation deletes a scheduled job */
  EnterpriseSummaryReports_DeleteSchedule?: Maybe<EnterpriseSummaryReports_DeleteScheduleResult>;
  /** this mutation starts an export job */
  EnterpriseSummaryReports_ExportReport?: Maybe<EnterpriseSummaryReports_ExportReportResult>;
  /** this mutation upserts a scheduled job */
  EnterpriseSummaryReports_SaveSchedule?: Maybe<EnterpriseSummaryReports_SaveScheduleResult>;
  /** This mutation updates full user data. */
  EnterpriseUsers_FullUpdateUserData: EnterpriseUsers_FullUpdateUserDataResult;
  /**
   * Resends the verification email for a user within an organization.
   * UserId is resolved from the security context — not supplied by the caller.
   * The redirect URL is constructed server-side from the orgSlug.
   */
  EnterpriseUsers_ResendVerificationEmail: EnterpriseUsers_ResendVerificationEmailResult;
  /** Create a Epic_Experiment */
  Epic_CreateExperiment: Epic_CreateExperimentResult;
  /** Update a Epic_Experiment */
  Epic_UpdateExperiment: Epic_UpdateExperimentResult;
  /** End an existing recording. */
  ExamRecording_EndRecording: ExamRecording_EndRecordingResult;
  /** Request to initialize a recording chunk and generate an upload URL for it. */
  ExamRecording_InitializeChunk: ExamRecording_InitializeChunkResult;
  /** Request to initialize a recording segment (standalone video) and generate an upload URL for it. */
  ExamRecording_InitializeSegment: ExamRecording_InitializeSegmentResult;
  /**
   * Request to manually reprocess recordings that previously failed processing.
   * INTERNAL USE ONLY: This operation is intended for manual intervention by engineers.
   */
  ExamRecording_ReprocessRecordings: ExamRecording_ReprocessRecordingsResult;
  /** Start a new recording. Only needs userId which is taken from the user's session. */
  ExamRecording_StartRecording: ExamRecording_StartRecordingResult;
  /** Start an export item feedback job. */
  ExportItemFeedback_StartExportItemFeedbackJob: ExportItemFeedback_StartExportItemFeedbackJobResult;
  /** This mutation creates a new external integration platform configuration. */
  ExternalIntegration_CreateIntegrationConfiguration?: Maybe<ExternalIntegration_CreateIntegrationConfigurationResult>;
  /** This mutation deletes an existing external integration platform configuration. */
  ExternalIntegration_DeleteIntegrationConfiguration?: Maybe<ExternalIntegration_DeleteIntegrationConfigurationResult>;
  /** This mutation updates an existing external integration platform configuration. */
  ExternalIntegration_UpdateIntegrationConfiguration?: Maybe<ExternalIntegration_UpdateIntegrationConfigurationResult>;
  /** This mutation validates client credentials for an external integration platform configuration before create/update. */
  ExternalIntegration_ValidateIntegrationConfiguration?: Maybe<ExternalIntegration_ValidateIntegrationConfigurationResult>;
  /** Approve application */
  FinancialAidApplication_Approve: FinancialAidApplication_ApproveResult;
  /** Create application */
  FinancialAidApplication_Create: FinancialAidApplication_CreateResult;
  /** Sets whether the flashcards UI is hidden (opted out) for a course. UI-only; does not affect generation. */
  Flashcards_SetOptOut: Flashcards_SetOptOutResult;
  /** Updates the Graded Item Locking enablement setting for the given course in the program and institution. */
  GradedItemLocking_UpdateEnablement: GradedItemLocking_UpdateEnablementResult;
  /** This mutation update the learner's grade to the gradebook */
  GradedPlugin_SetLearnerPluginGrade: GradedPlugin_SetLearnerPluginGradeResult;
  /** Used to refresh the grader performance group metrics to generate new aggregate data for a session */
  GraderPerformance_RefreshGroupMetrics: GraderPerformance_RefreshGroupMetricsResult;
  /**
   * Used to change the saved settings for the grader performance dashboard for a user and
   * session
   */
  GraderPerformance_SaveDashboardSessionSettings: GraderPerformance_SaveDashboardSessionSettingsResult;
  /** This mutation creates one reusable comment. */
  GradingComments_CreateComment: GradingComments_CreateCommentResult;
  /** This mutation creates one reusable comment usage. */
  GradingComments_CreateCommentUsage: GradingComments_CreateCommentUsageResult;
  /** This mutation deletes one reusable comment. */
  GradingComments_DeleteComment: GradingComments_DeleteCommentResult;
  /** This mutation deletes reusable comment usages associated with target assignment and review part. */
  GradingComments_DeleteCommentUsages: GradingComments_DeleteCommentUsagesResult;
  /** This mutation updates one reusable comment. */
  GradingComments_UpdateComment: GradingComments_UpdateCommentResult;
  /**
   * Used to apply a grade override.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_ApplyGradeOverride: GroupGrading_ApplyGradeOverrideResult;
  /**
   * Used to apply a grade override.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_ApplyGradeOverrideV2: GroupGrading_ApplyGradeOverrideV2Result;
  /**
   * Used to change grade visibility for a number of submitters for an assignment.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_BatchUpdateGradeVisibility: GroupGrading_BatchUpdateGradeVisibilityResult;
  /**
   * [DEPRECATED] Used to batch patch multiple rubric part response fields changes at one time.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   * @deprecated deleted API
   */
  GroupGrading_BatchUpdateReviewPartResponse: GroupGrading_BatchUpdateReviewPartResponseResult;
  /**
   * Used to update all rubric part responses.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_BatchUpdateReviewPartResponses: GroupGrading_BatchUpdateReviewPartResponsesResult;
  /**
   * Used to delete a grade override.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_DeleteGradeOverride: GroupGrading_DeleteGradeOverrideResult;
  /**
   * Used to delete a grade override.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_DeleteGradeOverrideV2: GroupGrading_DeleteGradeOverrideV2Result;
  /**
   * [DEPRECATED] Use GroupGrading_SubmitGradesToGradeBook instead.
   * Used to publish grades to GradeBook.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   * @deprecated deleted API
   */
  GroupGrading_PublishGradesToGradeBook: GroupGrading_PublishGradesToGradeBookResult;
  /**
   * Used to submit grades to Gradebook.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_SubmitGradesToGradeBook: GroupGrading_SubmitGradesToGradeBookResult;
  /**
   * Used to change grade visibility for a submitter's assignment.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   */
  GroupGrading_UpdateGradeVisibility: GroupGrading_UpdateGradeVisibilityResult;
  /**
   * [DEPRECATED] Used to update one rubric part response set of choices.
   * Only single select for now, but using array of choices for future-proofing.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   * @deprecated deleted API
   */
  GroupGrading_UpdateReviewPartResponseChoices: GroupGrading_UpdateReviewPartResponseChoicesResult;
  /**
   * [DEPRECATED] Used to update one rubric part response comment.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   * @deprecated deleted API
   */
  GroupGrading_UpdateReviewPartResponseComment: GroupGrading_UpdateReviewPartResponseCommentResult;
  /**
   * [DEPRECATED] Used to update one rubric part response score.
   *
   * May return a BAD_REQUEST:ALREADY_EXISTS error if there is a conflict.
   * @deprecated deleted API
   */
  GroupGrading_UpdateReviewPartResponseScore: GroupGrading_UpdateReviewPartResponseScoreResult;
  /** This mutation generates a test link for the current logged in user and stores the user test initialization data */
  IMochaAssessment_GenerateTestLink: IMochaAssessment_GenerateTestLinkResult;
  /** Mark an in-lab instruction as complete */
  InLabInstructions_MarkInstructionAsComplete: InLabInstructions_MarkInstructionAsCompleteResult;
  /**
   * Directly triggers an injection configuration by injectionConfigurationId. Mostly used for testing purposes.
   *
   * If there is already a running execution for the given configuration, an error will be returned.
   */
  InjectableActivities_DirectlyTriggerInjectionConfiguration: InjectableActivities_DirectlyTriggerInjectionConfigurationResult;
  /** Generates configurations and triggers injection for the proactive AI experiment on the given course branch. */
  InjectableActivities_ProvisionProactiveAiExperiment: InjectableActivities_ProvisionProactiveAiExperimentResult;
  /** Updates the progress state of an injectable activity for the current user. */
  InjectableActivities_UpdateInjectableActivityProgress: InjectableActivities_UpdateInjectableActivityProgressResult;
  /**
   * Accepts an invitation - should be called right after a new invitee that lands on Coursera via
   * an email invitation link has been successfully signed-up/registered.
   */
  InstitutionStaffInvitation_AcceptInvitation: InstitutionStaffInvitation_AcceptInvitationResult;
  /**
   * Invites individuals by their emails to become staff members of an institution with assigned roles.
   * If invitee already has an existing Coursera Account, then they will automatically be made a staff
   * member having the assigned roles, and get an invitation email to accelerate their staff onboarding
   * If invitee doesn't have a Coursera Account, then they will only get an invitation email which
   * they can use to signup and join the institution as a staff member
   */
  InstitutionStaffInvitation_InviteStaffByEmails: InstitutionStaffInvitation_InviteStaffByEmailsResult;
  /** Cancels staff invitations */
  InstitutionStaffInvitation_RevokeInvitations: InstitutionStaffInvitation_RevokeInvitationsResult;
  /** Mutation to consent to recurring charges for a subscription. */
  IntlCompliance_RecurringChargeConsent: IntlCompliance_RecurringChargeConsentResult;
  /** Discards the current draft for a given item, if it exists */
  ItemAuthoring_DiscardItemDraft?: Maybe<ItemAuthoring_DiscardItemDraftResult>;
  /**
   * Create a new item personalization record for a learner.
   * This allows setting personalization actions (e.g., SKIP, FOCUS) for specific items
   * based on various personalization sources (e.g., verified skills assessment, diagnostics, etc).
   */
  ItemPersonalization_CreateItemPersonalization: ItemPersonalization_CreateItemPersonalizationResult;
  /** Refreshes the item state for a user, branch, and item tuple. */
  ItemProgress_ItemStateRefreshByBranch: ItemProgress_ItemStateRefreshByBranchResult;
  /** Refreshes the item state for a user, course, and item tuple. */
  ItemProgress_ItemStateRefreshByCourse: ItemProgress_ItemStateRefreshByCourseResult;
  /** This mutation deletes a item publish comment. */
  ItemPublishComments_DeleteItemPublishComment: ItemPublishComments_DeleteItemPublishCommentResult;
  /** This mutation saves one item publish comment. */
  ItemPublishComments_SaveItemPublishComment: ItemPublishComments_SaveItemPublishCommentResult;
  /** Mutation to create a JWT Login */
  JwtLogins_CreateJwtLogin: JwtLogins_CreateJwtLoginResult;
  /** Creates a new JWT login using an invitation token. */
  JwtLogins_LoginWithInvitationToken: JwtLogins_LoginWithInvitationTokenResult;
  /** Mark a recording for deletion. */
  LabRecording_Cleanup: LabRecording_CleanupResult;
  /** Extend an active recording. */
  LabRecording_Continue: LabRecording_ContinueResult;
  /** Trigger async video export. Returns immediately with status EXPORTING. */
  LabRecording_Export: LabRecording_ExportResult;
  /** Pause an active recording. */
  LabRecording_Pause: LabRecording_PauseResult;
  /** Start or resume a recording for a lab session. Idempotent: returns existing recording if one is PENDING or ACTIVE or PAUSED. */
  LabRecording_Start: LabRecording_StartResult;
  /**
   * Prepare lab for launch, if any preparation is required.
   * Will not launch the lab.
   * Use this when the lab files are required, but the learner will interact with them without launching the lab.
   */
  LaunchLab_Prepare?: Maybe<LaunchLab_PrepareResult>;
  /** Create new calendar settings for a user. */
  LearnerCalendars_CreateLearnerCalendar: LearnerCalendars_CreateLearnerCalendarResult;
  /** Toggle the "shouldDisplayContent" setting for a user. */
  LearnerCalendars_ToggleShouldDisplayContent: LearnerCalendars_ToggleShouldDisplayContentResult;
  /** Edit an existing weekly goal. Error will be returned if a weekly goal doesn't exist. */
  LearnerGoals_EditWeeklyGoal: LearnerGoals_EditWeeklyGoalResult;
  /** Set or update a macro goal for the authenticated learner. */
  LearnerGoals_SetMacroGoal: LearnerGoals_SetMacroGoalResult;
  /** Set a new weekly goal. Error will be returned if a weekly goal exists. */
  LearnerGoals_SetWeeklyGoal: LearnerGoals_SetWeeklyGoalResult;
  /**
   * Set learner's interest on a product. This type of interest can affects how the home pages
   * display products for the learner, to be distinguished from UserPreference_SetUserPreference
   * which covers a wide range of preferences that are not necessarily product specific.
   * User ID is inferred from request context.
   */
  LearnerInterest_SetLearnerInterest?: Maybe<LearnerInterest_SetLearnerInterestResult>;
  /** Delete the learning goal for a learner. */
  LearnerObject_DeleteLearningGoal: LearnerObject_DeleteLearningGoalResult;
  /** Update the birthday for a learner. */
  LearnerObject_UpdateBirthday: LearnerObject_UpdateBirthdayResult;
  /** Update the current occupation for a learner. */
  LearnerObject_UpdateCurrentOccupation: LearnerObject_UpdateCurrentOccupationResult;
  /** Update the education profile for a learner. */
  LearnerObject_UpdateEducationProfile: LearnerObject_UpdateEducationProfileResult;
  /** Update the full name for a learner. */
  LearnerObject_UpdateFullName: LearnerObject_UpdateFullNameResult;
  /** Update the interested careers for a learner. */
  LearnerObject_UpdateInterestedCareers: LearnerObject_UpdateInterestedCareersResult;
  /** Update the last indicated unsure roles timestamp for a learner. */
  LearnerObject_UpdateLastIndicatedUnsureRolesAt: LearnerObject_UpdateLastIndicatedUnsureRolesAtResult;
  /** Update the last indicated unsure skills timestamp for a learner. */
  LearnerObject_UpdateLastIndicatedUnsureSkillsAt: LearnerObject_UpdateLastIndicatedUnsureSkillsAtResult;
  /** Update the learning goal for a learner. */
  LearnerObject_UpdateLearningGoal: LearnerObject_UpdateLearningGoalResult;
  /** Update the locale for a learner. */
  LearnerObject_UpdateLocale: LearnerObject_UpdateLocaleResult;
  /** Update the location for a learner. */
  LearnerObject_UpdateLocation: LearnerObject_UpdateLocationResult;
  /** Update the most recent course completion for a learner. */
  LearnerObject_UpdateMostRecentCourseCompletion: LearnerObject_UpdateMostRecentCourseCompletionResult;
  /** Update the skills wanted for a learner. */
  LearnerObject_UpdateSkillsWantedV2: LearnerObject_UpdateSkillsWantedV2Result;
  /** Update the timezone for a learner. */
  LearnerObject_UpdateTimezone: LearnerObject_UpdateTimezoneResult;
  /**
   * This mutation adds a skill to the onboarding response of the learner.
   * @deprecated Use LearnerOnboarding_UpdateInterestedSkills instead.
   */
  LearnerOnboarding_AddSkill?: Maybe<LearnerOnboarding_AddSkillResult>;
  /** This mutation removes a learner response. This should only be used for dev purposes and will require PU permission */
  LearnerOnboarding_RemoveResponse?: Maybe<LearnerOnboarding_RemoveResponseResult>;
  /** Record user's interaction with modular onboarding e.g dismiss onboarding, or confirm inferred role */
  LearnerOnboarding_SetModularOnboardingInteraction?: Maybe<LearnerOnboarding_SetModularOnboardingInteractionResult>;
  /** Record that the logged-in user has seen onboarding */
  LearnerOnboarding_SetOnboardingSeen?: Maybe<LearnerOnboarding_SetOnboardingSeenResult>;
  /** This mutation sets interested skills and will overwrite previous selection of skill for the learner. */
  LearnerOnboarding_UpdateInterestedSkills?: Maybe<LearnerOnboarding_UpdateInterestedSkillsResult>;
  /** This mutation updates remindMeByTime field in the onboarding response of the learner. */
  LearnerOnboarding_UpdateRemindMeByTime?: Maybe<LearnerOnboarding_UpdateRemindMeByTimeResult>;
  /** This mutation sets a role for the learner response. */
  LearnerOnboarding_UpdateRole?: Maybe<LearnerOnboarding_UpdateRoleResult>;
  /** This mutation adds a term to the learner plan. */
  LearnerPlan_AddTerm?: Maybe<LearnerPlan_AddTermResult>;
  /** Create/ initiate a learner plan */
  LearnerPlan_CreatePlan?: Maybe<LearnerPlan_CreatePlanResult>;
  /** This mutation deletes a learner plan for a given learner. */
  LearnerPlan_DeletePlan?: Maybe<LearnerPlan_DeletePlanResult>;
  /** This mutation moves courses from one term to another in the learner plan. */
  LearnerPlan_MoveCourse?: Maybe<LearnerPlan_MoveCourseResult>;
  /** This mutation removes a term from the learner plan. */
  LearnerPlan_RemoveTerm?: Maybe<LearnerPlan_RemoveTermResult>;
  /** This mutation updates a term for the learner plan. */
  LearnerPlan_UpdateTerm?: Maybe<LearnerPlan_UpdateTermResult>;
  /** Patch used to mutate LearnerProfile from the Additional info Dialog */
  LearnerProfile_PatchAdditionalInfo: LearnerProfile_PatchAdditionalInfoResult;
  /** Patch used to mutate domains in LearnerProfile */
  LearnerProfile_PatchDomains: LearnerProfile_PatchDomainsResult;
  /** Patch used to mutate LearnerProfile from the Education Dialog */
  LearnerProfile_PatchEducation: LearnerProfile_PatchEducationResult;
  /** Patch used to mutate LearnerProfile from the Personal Information Dialog */
  LearnerProfile_PatchPersonalInformation: LearnerProfile_PatchPersonalInformationResult;
  /** Patch used to mutate LearnerProfile from the Work Experience Dialog */
  LearnerProfile_PatchPrivacySettings: LearnerProfile_PatchPrivacySettingsResult;
  /** Patch used to mutate the user-supplied custom profile slug */
  LearnerProfile_PatchProfileSlug: LearnerProfile_PatchProfileSlugResult;
  /** Patch used to mutate skills in LearnerProfile */
  LearnerProfile_PatchSkills: LearnerProfile_PatchSkillsResult;
  /** Patch used to mutate LearnerProfile from the Work Experience Dialog */
  LearnerProfile_PatchWorkExperience: LearnerProfile_PatchWorkExperienceResult;
  /** Patch used to mutate LearnerProfile from the Work Preferences Dialog */
  LearnerProfile_PatchWorkPreferences: LearnerProfile_PatchWorkPreferencesResult;
  /** LearningHours_SendEvent */
  LearningHours_SendEvent?: Maybe<LearningHours_SendEventResult>;
  /**
   * Autopublish a lecture draft. Attempts to publish the requested lecture, if transcoding is ready
   * then the lecture is published immediately, otherwise an autopublish is scheduled for when the
   * lecture is ready to be published.
   */
  LectureAuthoring_AutoPublishLectureDraft?: Maybe<LectureAuthoring_AutoPublishLectureDraftResult>;
  /** Deletes a lecture draft */
  LectureAuthoring_DeleteLectureDraft?: Maybe<LectureAuthoring_DeleteLectureDraftResult>;
  /** Updates a lecture item's draft */
  LectureAuthoring_UpdateLectureDraft?: Maybe<LectureAuthoring_UpdateLectureDraftResult>;
  /** This mutation resets a learner’s attempts for a LevelSet. */
  LevelSetAttempts_ResetAttempts: LevelSetAttempts_ResetAttemptsResult;
  /**
   * Starts a new attempt for a given user, skill, and program.
   * Returns the created attempt object with relevant data.
   */
  LevelSet_StartAttempt: LevelSet_StartAttemptResult;
  /**
   * Submits an existing attempt for a given user, marking the attempt as completed.
   * Returns the updated mastery level results for the skill.
   */
  LevelSet_SubmitAttempt: LevelSet_SubmitAttemptResult;
  /**
   * Create an event for the current user and event type
   * User id will be taken from the request context.
   */
  LexExperimentEvents_CreateEvent: LexExperimentEvents_CreateEventResult;
  /**
   * Delete an event for the current user and event type
   * User id will be taken from the request context.
   */
  LexExperimentEvents_DeleteEvent: LexExperimentEvents_DeleteEventResult;
  /** Mutation for creating experiment configuration. Return epic parameter name as output. */
  Localization_CreateExperimentConfiguration: Localization_CreateExperimentConfigurationResult;
  /** Mutation for creating a Statsig experiment with one auto-balanced group per variant. Wraps the Statsig Console API: creates a layer, attaches the variant parameter, then creates the experiment under the layer. */
  Localization_CreateStatsigExperiment: Localization_CreateStatsigExperimentResult;
  /** Mutation for updating a Statsig experiment. Used to transition status (start/stop) and replace variant groups. */
  Localization_UpdateStatsigExperiment: Localization_UpdateStatsigExperimentResult;
  /** Updates the locking browser exclusions for the given assessment/session */
  LockingBrowser_UpdateExclusions: LockingBrowser_UpdateExclusionsResult;
  /** Updates the locking browser settings for the given assessment/session */
  LockingBrowser_UpdateSettings: LockingBrowser_UpdateSettingsResult;
  /**
   * Archives an AI generated practice by ID, removing it from active serving.
   * Requires internal or power user permissions.
   */
  LowStakesLearningTools_ArchivePractice: LowStakesLearningTools_ArchivePracticeResult;
  /** Mark a learner's flashcard set as completed. Emits a flashcard completion event. */
  LowStakesLearning_CompleteFlashcards: LowStakesLearning_CompleteFlashcardsResult;
  /** Create a new External App Registration V13 for a Curated App */
  LtiPlatform_CreateCuratedAppExternalAppRegistrationV13?: Maybe<LtiPlatform_CreateCuratedAppExternalAppRegistrationV13Result>;
  /**
   * This Mutation will create a External App Deployment for a LTI V1.1 and LTI V1.3 curated
   * for an partner
   */
  LtiPlatform_CreateCuratedExternalAppDeploymentForPartner?: Maybe<LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerResult>;
  /**
   * This Mutation will create a External App Deployment for a LTI V1.1 app
   * for a specific course.
   */
  LtiPlatform_CreateExternalAppDeploymentV11ForCourse?: Maybe<LtiPlatform_CreateExternalAppDeploymentV11ForCourseResult>;
  /**
   * This Mutation will create a External App Deployment for a LTI V1.1 custom app
   * for a partner
   */
  LtiPlatform_CreateExternalAppDeploymentV11ForPartner?: Maybe<LtiPlatform_CreateExternalAppDeploymentV11ForPartnerResult>;
  /**
   * This Mutation will create a External App Deployment for a LTI V1.3 app
   * for a specific course
   */
  LtiPlatform_CreateExternalAppDeploymentV13ForCourse?: Maybe<LtiPlatform_CreateExternalAppDeploymentV13ForCourseResult>;
  /**
   * This Mutation will create a External App Deployment for a LTI V1.3 custom app
   * for the partner
   */
  LtiPlatform_CreateExternalAppDeploymentV13ForPartner?: Maybe<LtiPlatform_CreateExternalAppDeploymentV13ForPartnerResult>;
  /**
   * This Mutation will update a External App Deployment
   * for a course
   */
  LtiPlatform_UpdateExternalAppDeploymentForCourse?: Maybe<LtiPlatform_UpdateExternalAppDeploymentForCourseResult>;
  /**
   * This Mutation will update a External App Deployment
   * for a partner
   */
  LtiPlatform_UpdateExternalAppDeploymentForPartner?: Maybe<LtiPlatform_UpdateExternalAppDeploymentForPartnerResult>;
  /**
   * This Mutation will update a External App Registration for a LTI V1.1 app
   * for a course
   */
  LtiPlatform_UpdateExternalAppRegistrationV11ForCourse?: Maybe<LtiPlatform_UpdateExternalAppRegistrationV11ForCourseResult>;
  /**
   * This Mutation will update a External App Registration for a LTI V1.1 custom app
   * for an partner
   */
  LtiPlatform_UpdateExternalAppRegistrationV11ForPartner?: Maybe<LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerResult>;
  /**
   * This Mutation will update a External App Registration for a LTI V1.3 app
   * for a course
   */
  LtiPlatform_UpdateExternalAppRegistrationV13ForCourse?: Maybe<LtiPlatform_UpdateExternalAppRegistrationV13ForCourseResult>;
  /**
   * This Mutation will update a External App Registration for a LTI V1.3 custom app
   * for an partner
   */
  LtiPlatform_UpdateExternalAppRegistrationV13ForPartner?: Maybe<LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerResult>;
  /** Updates an LTI item's draft. */
  LtiPlatform_UpdateLtiDraft?: Maybe<LtiPlatform_UpdateLtiDraftResult>;
  /** Add new LMS platform configuration details */
  LtiTool_AddPlatformConfig: LtiTool_AddPlatformConfigResult;
  /** Add LTI tool metadata */
  LtiTool_AddToolMetadata: LtiTool_AddToolMetadataResult;
  /**
   * Backfill LMS names in platform configurations based on issuer URL mappings.
   * Internal-only mutation for data migration.
   */
  LtiTool_BackfillLmsNames: LtiTool_BackfillLmsNamesResult;
  /** Submit selected content items for deep linking */
  LtiTool_DeepLinkingSubmit: LtiTool_DeepLinkingSubmitResult;
  /**
   * Soft-delete a deep-linked content item from a course shell.
   *
   * Stamps deleted=true / deletedAt on the matching entry inside
   * DeepLinkLaunch.itemsSelected, and (if present) stamps deletedAt on the
   * corresponding LtiDeepLinkGradingPreference row. Idempotent — re-delete
   * returns result=true.
   *
   * Authorization is enforced by the LtiLoginSessionInterceptor (LTI_LOGIN_SESSION cookie)
   * + @RequiresLtiInstructorRole aspect.
   */
  LtiTool_DeleteCourseShellItem: LtiTool_DeleteCourseShellItemResult;
  /** Delete LTI platform configuration */
  LtiTool_DeletePlatformConfig: LtiTool_DeletePlatformConfigResult;
  /** generate a signed, time bound dynamic registration url for a given organisation */
  LtiTool_GenerateDynamicRegistrationUrl: LtiTool_GenerateDynamicRegistrationUrlResult;
  /**
   * Update the grade-sync due date for a deep-linked content item in a course shell.
   *
   * Targets the LtiDeepLinkGradingPreference row matching the supplied identifiers.
   * gradeSyncDueDate of null clears the due date (grades sync indefinitely).
   * Past dates are rejected. If no preference row exists yet (e.g. a copied LMS
   * course shell), a new row is created with FINAL as a placeholder grading type.
   *
   * Authorization is enforced by the LtiLoginSessionInterceptor (LTI_LOGIN_SESSION cookie)
   * + @RequiresLtiInstructorRole aspect; organizationId is derived from the session.
   */
  LtiTool_UpdateCourseShellDueDate: LtiTool_UpdateCourseShellDueDateResult;
  /** Update organization configuration for LTI integrations. */
  LtiTool_UpdateOrgConfig: LtiTool_UpdateOrgConfigResult;
  /**
   * Update program access control settings for a single LMS registration.
   * Replaces the org-level update path for registrations migrated to per-registration
   * program access control.
   *
   * Note: @authorization below only enforces core.loggedIn. The check that the
   * registration belongs to the supplied organizationId is enforced by the resolver
   * (lti-tool-application), not by a schema-level authorizer — same pattern as the
   * existing LtiTool_UpdateOrgConfig / LtiTool_DeletePlatformConfig mutations.
   */
  LtiTool_UpdateRegistrationProgramAccessControl: LtiTool_UpdateRegistrationProgramAccessControlResult;
  /**
   * Create a new MCP application for an organization.
   * Returns the app with client secret (shown once).
   */
  McpApps_CreateMcpApp: McpApps_CreateMcpAppResult;
  /** Delete/revoke an existing MCP application. */
  McpApps_DeleteMcpApp: McpApps_DeleteMcpAppResult;
  /**
   * Edit an existing MCP application's name and/or redirect URIs.
   * At least one of appName or redirectUris must be provided.
   */
  McpApps_EditMcpApp: McpApps_EditMcpAppResult;
  NaptimeMutations: NaptimeMutations;
  /**
   * Update user preferences via preference center token (token-based authentication).
   * Used in preference center accessed via email unsubscribe links.
   */
  NotificationPreference_UpdatePreferencesByToken: NotificationPreference_UpdatePreferencesByTokenResult;
  /**
   * Sends an OTP code to the specified email address.
   * Generates a new OTP or reuses existing valid OTP based on rate limiting rules.
   */
  OTP_SendOTP: Otp_SendOtpResult;
  /** Create open course asset. */
  OpenCourseAsset_CreateOpenCourseAsset: OpenCourseAsset_CreateOpenCourseAssetResult;
  /** Update open course asset. */
  OpenCourseAsset_UpdateOpenCourseAsset: OpenCourseAsset_UpdateOpenCourseAssetResult;
  /**
   * Create a new API key for an organization.
   * If this is the first key, automatically initializes a Coursera service account user,
   * Apigee developer and app. Returns clientSecret only once — it cannot be retrieved again.
   */
  OrgApiKey_Create: OrgApiKey_CreateResult;
  /**
   * Revoke an existing API key.
   * The key is soft-deleted (marked as REVOKED) and removed from Apigee.
   */
  OrgApiKey_Revoke: OrgApiKey_RevokeResult;
  /**
   * Adds an org collection to the catalogs of one or more programs, so it becomes
   * visible in those programs. Corresponds to gRPC OrgCollectionAPI.AddCollectionToPrograms.
   */
  OrgCollection_AddCollectionToPrograms: OrgCollection_AddCollectionToProgramsResult;
  /** Archives an org collection. Corresponds to gRPC OrgCollectionAPI.ArchiveCollection. */
  OrgCollection_ArchiveCollection: OrgCollection_ArchiveCollectionResult;
  /** Creates a new org collection. Corresponds to gRPC OrgCollectionAPI.CreateCollection. */
  OrgCollection_CreateCollection: OrgCollection_CreateCollectionResult;
  /**
   * Removes an org collection from the catalogs of one or more programs.
   * Corresponds to gRPC OrgCollectionAPI.RemoveCollectionFromPrograms.
   */
  OrgCollection_RemoveCollectionFromPrograms: OrgCollection_RemoveCollectionFromProgramsResult;
  /**
   * Creates a new domain for verification. The domain will be in UNVERIFIED status
   * and a TXT record token will be generated for DNS verification.
   */
  OrgVerifiedDomain_Create: OrgVerifiedDomain_CreateResult;
  /**
   * Deletes a domain from the organization. This will prevent users from that domain
   * from authenticating via SSO.
   */
  OrgVerifiedDomain_Delete: OrgVerifiedDomain_DeleteResult;
  /**
   * Verifies a domain by based on the verification method.
   * The domain must be in UNVERIFIED status.
   */
  OrgVerifiedDomain_Verify: OrgVerifiedDomain_VerifyResult;
  /**
   * Given a list of revshare data, create new revshare records for each one. Also expire the current
   * records, if they exist.
   */
  OwnableProduct_UpsertOwnableProductPartnerRevshareRecords: OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsResult;
  /** Approve/reject all course/branch changes */
  PartnerApproval_ApproveOrRejectAllChanges: PartnerApproval_ApproveOrRejectAllChangesResult;
  /** Approve/reject entity change */
  PartnerApproval_ApproveOrRejectChange: PartnerApproval_ApproveOrRejectChangeResult;
  /** kicks off process to start creating items (ie implementing ai generated recommendations) */
  PartnerApproval_StartImplementingAiGeneratedRecommendations: PartnerApproval_StartImplementingAiGeneratedRecommendationsResult;
  /** Submit changes for partner approval */
  PartnerApproval_SubmitForApproval: PartnerApproval_SubmitForApprovalResult;
  /** Used to save new payment method. */
  PaymentProcessor_CreatePaymentMethod: PaymentProcessor_CreatePaymentMethodResult;
  /** Deletes a payment method. */
  PaymentProcessor_DeletePaymentMethod: PaymentProcessor_DeletePaymentMethodResult;
  /** Calls out to a payment processor to setup for creating a payment method. */
  PaymentProcessor_PreCreatePaymentMethod: PaymentProcessor_PreCreatePaymentMethodResult;
  /** Updates a user's payment method. */
  PaymentProcessor_UpdatePaymentMethod: PaymentProcessor_UpdatePaymentMethodResult;
  /** Initialize (or retrieve existing) CheckoutIntent for the given cartId. */
  PaymentsCheckout_InitializeCheckoutIntent: PaymentsCheckout_InitializeCheckoutIntentResult;
  /** Initialize a CheckoutIntent with an existing payment method. */
  PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethod: PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodResult;
  /**
   * Submit data to the Payment Processor for this checkout intent. Applicable only for Payment
   * Processors/payment methods that require a S2S (server to server) step in the checkout flow.
   */
  PaymentsCheckout_SubmitCheckoutIntent: PaymentsCheckout_SubmitCheckoutIntentResult;
  /**
   * Provide the CheckoutIntent with newly gathered details such as billing info in order
   * to update the CheckoutIntent to reflect this new data such as the tax amount.
   */
  PaymentsCheckout_UpdateCheckoutIntent: PaymentsCheckout_UpdateCheckoutIntentResult;
  /** Nullify the appliedAt field of the latest recommendation of a branch, used in E2E tests */
  PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendation: PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationResult;
  /** Switches the grading type of a peer review to peer/human grading */
  PeerReviewAi_RequestGradingByPeer: PeerReviewAi_RequestGradingByPeerResult;
  /** Saves a user's feedback for one review part of an AI grading */
  PeerReviewAi_SaveUserFeedback: PeerReviewAi_SaveUserFeedbackResult;
  /** Convert a peer review to an AI Graded assignment */
  PeerReviewMigration_ConvertPeerReviewToAiAssignment: PeerReviewMigration_ConvertPeerReviewToAiAssignmentResult;
  /** Add a product to a milestone. Returns the updated plan. */
  PersonalizedPlans_AddProduct: PersonalizedPlans_AddProductResult;
  /** Remove a product from a milestone. Returns the updated plan. */
  PersonalizedPlans_RemoveProduct: PersonalizedPlans_RemoveProductResult;
  /** Reorder products within a milestone. The list must be a permutation of existing products. */
  PersonalizedPlans_ReorderProducts: PersonalizedPlans_ReorderProductsResult;
  /**
   * Retry generation for a FAILED plan using its retained generation input, without the learner
   * re-entering their goal, role, and skills. On success the plan transitions to CREATED in place
   * (same planId). Returns a structured error for non-retryable plans, unknown plans, exhausted
   * retries, or a repeated generation failure.
   */
  PersonalizedPlans_RetryGeneration: PersonalizedPlans_RetryGenerationResult;
  /** Removes a Phrase course configuration by batch name. */
  PhraseCourseConfig_RemoveByBatchName?: Maybe<PhraseCourseConfig_RemoveByBatchNameResult>;
  /**
   * Validates and writes a Phrase course configuration to S3.
   * Validates course ID, branch ID, project template ID, and batch name uniqueness.
   */
  PhraseCourseConfig_ValidateAndSave: PhraseCourseConfig_ValidateAndSaveResult;
  /** TODO: Complete this description */
  Proctor_createOverrideForAssignmentSubmitter: Proctor_OverrideSubmitterProctorConfigOutput;
  /**
   * Add a profile consents for the current user. User ID and language code are derived from the request context
   * and Accept-Language header.
   * Consent version and consent acceptance timestamp is derived in the backend service implementation.
   */
  ProfileConsents_AddProfileConsents: ProfileConsents_AddProfileConsentsResult;
  /** This mutation deletes one or more email domains from a program's domain allow list. */
  ProgramInvitationsDomainAllowList_MultiDelete: ProgramInvitationsDomainAllowList_MultiDeleteResult;
  /** This mutation updates or adds one or more email domains to a program's domain allow list. */
  ProgramInvitationsDomainAllowList_MultiUpdate: ProgramInvitationsDomainAllowList_MultiUpdateResult;
  /** This mutation allows a user to accept an invitation to a program. */
  ProgramInvitations_AcceptInvitation: ProgramInvitations_AcceptInvitationResult;
  /**
   * Creates program invitations or memberships for a list of invitees, depending on whether each user is already
   * a member of another program in the same organization (mirrors AddUsersToProgram in ProgramInvitationsAPI).
   */
  ProgramInvitations_AddUsersToProgram: ProgramInvitations_AddUsersToProgramResult;
  /** This mutation allows the creation of a single program invitation. */
  ProgramInvitations_CreateInvitation: ProgramInvitations_CreateInvitationResult;
  /** This mutation allows the deletion of invitations in bulk. Admins use a different API so this is limited to PU only. */
  ProgramInvitations_MultiDeleteInvitations: ProgramInvitations_MultiDeleteInvitationsResult;
  /**
   * Triggers the stale-invitation cleanup job (ProgramInvitationExpiryJob), which removes pending
   * invitations older than a threshold. Runs asynchronously (Airflow) and returns the job invocation
   * id. Power-user only, since it can trigger an org-wide (or all-orgs) bulk deletion.
   */
  ProgramInvitations_TriggerExpiryJob: ProgramInvitations_TriggerExpiryJobResult;
  /** This mutation joins the user into the program and also sends the program joining notification */
  ProgramMembership_Join: ProgramMembership_JoinResult;
  /**
   * This mutation accepts all pending program invitations for the user within an organization in a single call.
   * Intended for the unified Org Home experience. Creation source is handled at the application layer.
   */
  ProgramMembership_JoinAllPendingForOrg: ProgramMembership_JoinAllPendingForOrgResult;
  /** This mutation resends the verification email to the user. Requires same-user authorization in code. */
  ProgramMembership_ResendVerificationEmail: ProgramMembership_ResendVerificationEmailResult;
  /**
   * Programming_CreateAttemptOverride is used to create an attempt override - either to override
   * the current one, or to create a new attempt.
   */
  Programming_CreateAttemptOverride: Programming_CreateAttemptOverrideResult;
  /** This mutation creates a promotion */
  Promotions_CreatePromotion?: Maybe<Promotions_CreatePromotionResult>;
  /** This mutation creates a promotion user eligible rule */
  Promotions_CreatePromotionUserEligibleRule?: Maybe<Promotions_CreatePromotionUserEligibleRuleResult>;
  /** This mutation used to export CSV file containing the codes generated in this batch */
  Promotions_ExportCodeBatch?: Maybe<Promotions_ExportCodeBatchResult>;
  /** This mutation generates a unique code batch */
  Promotions_GenerateCodeBatch?: Maybe<Promotions_GenerateCodeBatchResult>;
  /** This mutation updates a promotion */
  Promotions_UpdatePromotion?: Maybe<Promotions_UpdatePromotionResult>;
  /** This mutation updates a promotion user eligible rule */
  Promotions_UpdatePromotionUserEligibleRule?: Maybe<Promotions_UpdatePromotionUserEligibleRuleResult>;
  /** Mutation QualificationSurveyExperiment deleteQualificationSurveyExperiment. */
  QualificationSurveyExperiment_DeleteQualificationSurveyExperiment: QualificationSurveyExperiment_DeleteQualificationSurveyExperimentResult;
  /** Mutation for QualificationSurveyExperiment updateQualificationSurveyExperiment. */
  QualificationSurveyExperiment_UpdateQualificationSurveyExperiment: QualificationSurveyExperiment_UpdateQualificationSurveyExperimentResult;
  /** Mutation QualificationSurveySectionResponse CreateOrUpdate. */
  QualificationSurveySectionResponse_CreateOrUpdate: QualificationSurveySectionResponse_CreateOrUpdateResult;
  /** Mutation QualificationSurveySectionResponse DeleteByResponseIds. */
  QualificationSurveySectionResponse_DeleteByResponseIds: QualificationSurveySectionResponse_DeleteByResponseIdsResult;
  /** EOI application QualificationSurvey mutations createQualificationSurvey */
  QualificationSurvey_CreateQualificationSurvey: QualificationSurvey_CreateQualificationSurveyResult;
  /** EOI application QualificationSurvey mutations updateQualificationSurvey */
  QualificationSurvey_UpdateQualificationSurvey: QualificationSurvey_UpdateQualificationSurveyResult;
  /** Create a new quality rule. */
  QualityCoach_CreateQualityRule: QualityCoach_CreateQualityRuleResult;
  /** Delete an existing quality rule. */
  QualityCoach_DeleteQualityRule: QualityCoach_DeleteQualityRuleResult;
  /** Initiate a new quality review for an entity. */
  QualityCoach_InitiateQualityReviewForEntity: QualityCoach_InitiateQualityReviewForEntityResult;
  /** Update an existing quality rule. */
  QualityCoach_UpdateQualityRule: QualityCoach_UpdateQualityRuleResult;
  /** Mutation to add new question categories to a question bank draft. Duplicate question categories will be rejected. */
  QuestionBank_AddQuestionCategories: QuestionBank_AddQuestionCategoriesResult;
  /** Mutation to add new question categories to a question bank draft. Duplicate question categories will be rejected. */
  QuestionBank_AddQuestionCategoriesV2: QuestionBank_AddQuestionCategoriesV2Result;
  /** Mutation to add questions to a question bank draft */
  QuestionBank_AddQuestions: QuestionBank_AddQuestionsResult;
  /** Mutation to add questions to a question bank draft */
  QuestionBank_AddQuestionsV2: QuestionBank_AddQuestionsV2Result;
  /** Mutation to create a cascading publish transaction for a question bank and its related content */
  QuestionBank_CascadingPublishTransactionCreate: QuestionBank_CascadingPublishTransactionCreateResult;
  /** Mutation to execute a cascading publish transaction for a question bank and its related content */
  QuestionBank_CascadingPublishTransactionExecute: QuestionBank_CascadingPublishTransactionExecuteResult;
  /** Mutation to propose a question block update for a cascading publish transaction */
  QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdate: QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateResult;
  /** Mutation to create question bank */
  QuestionBank_CreateDraft: QuestionBank_CreateDraftResult;
  /** Mutation to link a question bank to a scope */
  QuestionBank_Link: QuestionBank_LinkResult;
  /** Mutation to merge questions into a question bank draft. Questions with matching IDs are updated; unmatched questions are added as new. */
  QuestionBank_MergeQuestions: QuestionBank_MergeQuestionsResult;
  /** Mutation to merge questions into a question bank draft. Questions with matching IDs are updated; unmatched questions are added as new. */
  QuestionBank_MergeQuestionsV2: QuestionBank_MergeQuestionsV2Result;
  /** Mutation to remove all questions from a question bank draft */
  QuestionBank_RemoveAllQuestions: QuestionBank_RemoveAllQuestionsResult;
  /** Mutation to remove all questions from a question bank draft */
  QuestionBank_RemoveAllQuestionsV2: QuestionBank_RemoveAllQuestionsV2Result;
  /** Mutation to remove question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
  QuestionBank_RemoveQuestionCategories: QuestionBank_RemoveQuestionCategoriesResult;
  /** Mutation to remove question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
  QuestionBank_RemoveQuestionCategoriesV2: QuestionBank_RemoveQuestionCategoriesV2Result;
  /** Mutation to remove specific questions from a question bank draft. All provided question IDs must already exist in the draft. */
  QuestionBank_RemoveQuestions: QuestionBank_RemoveQuestionsResult;
  /** Mutation to remove specific questions from a question bank draft. All provided question IDs must already exist in the draft. */
  QuestionBank_RemoveQuestionsV2: QuestionBank_RemoveQuestionsV2Result;
  /** Mutation to revert a question bank */
  QuestionBank_RevertDraft: QuestionBank_RevertDraftResult;
  /** Mutation to unlink a question bank from a scope */
  QuestionBank_Unlink: QuestionBank_UnlinkResult;
  /** Mutation to update the name of a question bank */
  QuestionBank_UpdateBank: QuestionBank_UpdateBankResult;
  /** Mutation to update the name of a question bank */
  QuestionBank_UpdateBankV2: QuestionBank_UpdateBankV2Result;
  /** Mutation to update existing question categories in a question bank draft */
  QuestionBank_UpdateQuestionCategories: QuestionBank_UpdateQuestionCategoriesResult;
  /** Mutation to update existing question categories in a question bank draft */
  QuestionBank_UpdateQuestionCategoriesV2: QuestionBank_UpdateQuestionCategoriesV2Result;
  /** Mutation to update existing questions in a question bank draft. All provided question IDs must already exist in the draft. */
  QuestionBank_UpdateQuestions: QuestionBank_UpdateQuestionsResult;
  /** Mutation to update existing questions in a question bank draft. All provided question IDs must already exist in the draft. */
  QuestionBank_UpdateQuestionsV2: QuestionBank_UpdateQuestionsV2Result;
  /** Creates a new experiment */
  QuestionGenerator_CreateExperiment?: Maybe<QuestionGenerator_CreateExperimentResult>;
  /** Start a generation request */
  QuestionGenerator_StartGeneration?: Maybe<QuestionGenerator_StartGenerationResult>;
  /** Stop a generation request */
  QuestionGenerator_StopGeneration?: Maybe<QuestionGenerator_StopGenerationResult>;
  /** Updates an existing experiment */
  QuestionGenerator_UpdateExperiment?: Maybe<QuestionGenerator_UpdateExperimentResult>;
  /** Save a human graded question generation rating */
  QuestionRater_SaveHumanQuestionRating?: Maybe<QuestionRater_SaveHumanQuestionRatingResult>;
  /** Start a generation for a specific course's question banks */
  QuestionRater_StartQuestionRating: QuestionRater_StartQuestionRatingResult;
  /** Updates a reading item's draft */
  ReadingAuthoring_UpdateReadingDraft?: Maybe<ReadingAuthoring_UpdateReadingDraftResult>;
  /**
   * Add a recently viewed product for the current user. User ID and session ID are both inferred from
   * request context.
   */
  RecentlyViewedProducts_AddRecentlyViewedProduct: RecentlyViewedProducts_AddRecentlyViewedProductResult;
  /** Sends invite to apply emails to candidates by filters */
  RecruitingInvitation_InviteByFilters?: Maybe<RecruitingInvitation_InviteByFiltersResult>;
  /** Sends invite to apply emails to candidates by external IDs */
  RecruitingInvitation_InviteByIds?: Maybe<RecruitingInvitation_InviteByIdsResult>;
  /** Creates a new position to recruit candidates for */
  RecruitingPosition_Create?: Maybe<RecruitingPosition_CreateResult>;
  /**
   * Deletes an existing position. Should be used to delete only test positions
   * or mistakes. To delete a used positions with sent invitations, this mutation
   * will not work and return errors. For that purpose an expire position mutation should be used.
   */
  RecruitingPosition_Delete?: Maybe<RecruitingPosition_DeleteResult>;
  /** [Deprecated]This mutation creates one reusable comment. */
  ReusableComments_CreateReusableComment: ReusableComments_CreateReusableCommentResult;
  /** [Deprecated] This mutation creates one reusable comment usage. */
  ReusableComments_CreateReusableCommentUsage: ReusableComments_CreateReusableCommentUsageResult;
  /** [Deprecated] This mutation deletes one reusable comment. */
  ReusableComments_DeleteReusableComment: ReusableComments_DeleteReusableCommentResult;
  /** [Deprecated]This mutation updates one reusable comment. */
  ReusableComments_UpdateReusableComment: ReusableComments_UpdateReusableCommentResult;
  /** This mutation create role skill mapping branch. */
  RoleSkillMappingBranch_CreateNewBranch?: Maybe<RoleSkillMappingBranch_CreateNewBranchResult>;
  /** This deactivate branch. */
  RoleSkillMappingBranch_DeactivateBranch?: Maybe<RoleSkillMappingBranch_DeactivateBranchResult>;
  /** This mutation freeze branch. */
  RoleSkillMappingBranch_FreezeBranch?: Maybe<RoleSkillMappingBranch_FreezeBranchResult>;
  /** This merge branch into main branch. */
  RoleSkillMappingBranch_MergeBranch?: Maybe<RoleSkillMappingBranch_MergeBranchResult>;
  /** This mutation upserts and deletes role skill mapping by branch name */
  RoleSkillMappingNode_UpsertAndDeleteNodesByBranchName: RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameResult;
  /** Complete a SAML flow */
  SamlFlows_CompleteFlow: SamlFlows_CompleteFlowResult;
  /** Mark a SAML login as completed */
  SamlFlows_MarkLoginCompleted: SamlFlows_MarkLoginCompletedResult;
  /** Adds a new user. */
  SampleUser_AddUser: SampleUser_AddUserResult;
  /**
   * Requests re-translation for a scope (e.g. a course) and a set of target languages.
   * Sets the retranslation timestamp to the current time for each specified language;
   * existing config and untouched language entries are preserved.
   * Requires an existing translation config for the scope.
   */
  ScopedTranslationConfig_RequestRetranslation: ScopedTranslationConfig_RequestRetranslationResult;
  /**
   * Pre-warms the user embedding cache for autocomplete personalization.
   * Always returns immediately (fire-and-forget); cache population happens asynchronously.
   * Accessible to all callers — logged-in users are warmed by user ID, anonymous users with a
   * session cookie are warmed by cookie, and callers with no session context are silently ignored.
   */
  Search_WarmSession: Search_WarmSessionAck;
  /** Mutation to write/ delete eqp data */
  Seo_EqpDataBulkEditV1Mutation: Seo_EqpDataBulkEditV1MutationResult;
  /**
   * Mutation to group eqpData using hreflang tags. Adds hreflang alternates for the specified EQPs.
   *
   * Authored EQP pages can be associated together in groups with each page in a group having a unique locale code.
   * e.g. /en-US/courses?query=color and /en-CA/courses?query=colour
   * would be grouped together for having the similar content, customized for their respective locale. The
   * grouping is stored by the EqpData hreflangLinks field.
   *
   * This mutation can be used to create a group or to grow a group. If the group needs to be removed or shrunk,
   * use the ungrouping mutation first.
   *
   * All of the URLs provided in the input must have preexisting EqpData entries.
   * The EqpData entries must not already belong to another group.
   * Exactly one of the Seo_HreflangLinkInput must have "x-default" set as the hreflang.
   * Locales must not be repeated within the set.
   * en-US is the default locale.
   */
  Seo_EqpHreflangGroupingMutation: Seo_EqpHreflangGroupingMutationResult;
  /**
   * Mutation to ungroup eqpData hreflang tags. Removes hreflang alternates between the specified EQPs.
   *
   * Authored EQP pages can be associated together in groups with each page in a group having a unique locale code.
   * e.g. /en-US/courses?query=color and /en-CA/courses?query=colour
   * would be grouped together for having the similar content, customized for their respective locale. The
   * grouping is stored by the EqpData hreflangLinks field.
   *
   * This mutation can be used to remove a group (unlink the EQPs by emptying hreflangLinks).
   *
   * All of the URLs provided in the input must have preexisting EqpData entries.
   * The EqpData entries must belong to the same group.
   */
  Seo_EqpHreflangUngroupingMutation: Seo_EqpHreflangUngroupingMutationResult;
  /**
   * Full import mutation for page data that overwrites all page data configs
   * Adding new ones, updating existing ones and deleting any existing records not in the input
   */
  Seo_PageDataFullImportV1Mutation: Seo_PageDataFullImportV1MutationResult;
  /** Modify page data that supports overwriting, deleting and merging existing page data configs. */
  Seo_PageDataOverrideV1Mutation: Seo_PageDataOverrideV1MutationResult;
  /** Create or modify an existing robots.txt */
  Seo_RobotsTxtV1Mutation: Seo_RobotsTxtV1MutationResult;
  /**
   * This is used by teaching staff to patch the session specific schedule overrides for a learner.
   * Only updates overrides for the itemIds specified.
   * Will return all overrides set for this learner and session.
   */
  SessionScheduleOverrides_PatchSessionScheduleOverrides: SessionScheduleOverrides_PatchSessionScheduleOverridesResult;
  /**
   * Update session specific item overrides. Currently only supports assessment post visibility
   * updates.
   */
  Session_UpdateSessionSpecificItemOverrides?: Maybe<Session_UpdateSessionSpecificItemOverridesResult>;
  /**
   * This mutation will try to enroll enterprise user in a course. Enterprise program
   * for enrollment will be chosen automatically, using the provided list of candidate programs
   */
  ShortFormContent_enrollEnterpriseUserIntoCourse?: Maybe<ShortFormContent_EnrollEnterpriseUserIntoCourseResult>;
  /** This mutaton is used to track user video progress */
  ShortFormContent_trackVideoProgress?: Maybe<ShortFormContent_TrackVideoProgressResult>;
  /** Similarity Check Mutations */
  SimilarityCheck_Submit: SimilarityCheck_SubmitResult;
  /** This mutation generates skill attainment progress report for given program IDs. */
  SkillAttainment_GenerateProgressReport: SkillAttainment_GenerateProgressReportResult;
  /** This mutation associates skill-ids to a contract-tag */
  SkillRestrictedContractTag_AddContractTagSkillIds: SkillRestrictedContractTag_AddContractTagSkillIdsResult;
  /** This mutation dissociates domain-ids and subdomain-ids from a contract-tag */
  SkillRestrictedContractTag_RemoveContractTagDomainIds: SkillRestrictedContractTag_RemoveContractTagDomainIdsResult;
  /** This mutation dissociates skill-ids from a contract-tag */
  SkillRestrictedContractTag_RemoveContractTagSkillIds: SkillRestrictedContractTag_RemoveContractTagSkillIdsResult;
  /** This mutation updates the skill relevancy for a contract-tag + skill row */
  SkillRestrictedContractTag_UpdateSkillRelevancy: SkillRestrictedContractTag_UpdateSkillRelevancyResult;
  /** This mutation associates domain-ids and subdomain-ids to a contract-tag */
  SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIds: SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsResult;
  /** This mutation updates Skills Tags Labeling submitted by a user. */
  SkillsTagsLabeling_UpdateSkillsTagsLabeling: SkillsTagsLabeling_UpdateSkillsTagsLabelingResult;
  /** Updates list of tracked skills, or creates it if it does not exist yet. */
  SkillsTracking_UpdateSkillsTracking: SkillsTracking_UpdateSkillsTrackingResult;
  /** Create a new social cohort. */
  SocialCohort_CreateCohort: SocialCohort_CreateCohortResult;
  /** Delete a social cohort. */
  SocialCohort_DeleteCohort: SocialCohort_DeleteCohortResult;
  /** Register the authenticated user as a member of a social cohort. */
  SocialCohort_RegisterMembership: SocialCohort_RegisterMembershipResult;
  /** Admin endpoint to register a specific user (by userId) to a social cohort, as opposed to RegisterMembership which registers the authenticated user. */
  SocialCohort_RegisterUsersToCohort: SocialCohort_RegisterUsersToCohortResult;
  /** Remove a user's membership from a social cohort. */
  SocialCohort_RemoveMembership: SocialCohort_RemoveMembershipResult;
  /** Update an existing social cohort's metadata. */
  SocialCohort_UpdateCohort: SocialCohort_UpdateCohortResult;
  /**
   * Create specialization membership with a specific membership role. This creates a new membership
   * record and assigns the appropriate role and access privileges.
   */
  SpecializationMembership_CreateMembership: SpecializationMembership_CreateMembershipResult;
  /**
   * Create a specialization membership for a user in a specialization they already own. Similar to
   * creating membership but it also checks product ownership.
   */
  SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12n: SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nResult;
  /** Remove a user's membership in a specialization. This is equivalent to unenrolling the user and revoking associated access and privileges. */
  SpecializationMembership_DeleteMembership: SpecializationMembership_DeleteMembershipResult;
  /** Decline an upgrade offer for a newer version of a specialization. This action retains the user's access to the current version of the specialization. */
  SpecializationUpgrade_DeclineUpgrade: SpecializationUpgrade_DeclineUpgradeResult;
  /** Upgrade a user to a newer version of a specialization. This allows users to transition to the latest version of the specialization with updated content and features. */
  SpecializationUpgrade_Upgrade: SpecializationUpgrade_UpgradeResult;
  /** Create upsell */
  Stackability_CreateUpsell: Stackability_CreateUpsellResult;
  /** Delete proprerty */
  Stackability_DeleteProperty: Stackability_DeletePropertyResult;
  /** Delete Upsell */
  Stackability_DeleteUpsell: Stackability_DeleteUpsellResult;
  /** Set property */
  Stackability_SetProperty: Stackability_SetPropertyResult;
  /** Update upsell */
  Stackability_UpdateUpsell: Stackability_UpdateUpsellResult;
  /**
   * Enqueues a task to bundle up the file upload questions for a particular assignment and group.
   * A link to the compressed bundle is then emailed to the grader who requested it.
   */
  SubmissionDownload_EnqueueDownload: SubmissionDownload_EnqueueDownloadResult;
  /** Creates a box view session for viewing an inline feedback response */
  Submission_CreateBoxSessionForView: Submission_CreateBoxSessionForViewResult;
  /**
   * Creates a proctored session for an assignment with Honorlock.
   * This provides an SGA specific interface to perform this action.
   */
  Submission_CreateHonorlockSession: Submission_CreateHonorlockSessionResult;
  /** Delete the latest attempt from a user. This is used by some administrative and internal tools. */
  Submission_DeleteAllAttempts: Submission_DeleteAllAttemptsResult;
  /** Create a new pre-signed URL */
  Submission_FileUploadQuestionGenerateUploadUrl: Submission_FileUploadQuestionGenerateUploadUrlResult;
  /** If the attempt is still open, this will open the last submission to be reworked. */
  Submission_ReworkSubmission: Submission_ReworkSubmissionResult;
  /** Updates the current submission with new responses */
  Submission_SaveResponses: Submission_SaveResponsesResult;
  /** Starts a new attempt */
  Submission_StartAttempt: Submission_StartAttemptResult;
  /** Submits the latest draft */
  Submission_SubmitLatestDraft: Submission_SubmitLatestDraftResult;
  /** Cancels a Subscription. */
  Subscriptions_Cancel: Subscriptions_CancelResult;
  /** Converts a Subscription from free trial to active. */
  Subscriptions_ConvertFreeTrialToActive: Subscriptions_ConvertFreeTrialToActiveResult;
  /**
   * Restore a canceled subscription
   * This method restores a canceled subscription to 'active' state. A subscription in 'active' state gets renewed at the end of the billing cycle.
   */
  Subscriptions_RestoreCanceledSubscription: Subscriptions_RestoreCanceledSubscriptionResult;
  /** Create a transcription workflow */
  Subtitles_CreateTranscriptionWorkflow: Subtitles_CreateTranscriptionWorkflowResult;
  /** Retry a failed transcription workflow */
  Subtitles_RetryTranscriptionWorkflow: Subtitles_RetryTranscriptionWorkflowResult;
  /** Locks team activity. Usually, only invoked manually by a developer after unblocking partners. */
  Teamwork_LockTeamActivity: Teamwork_LockTeamActivityResult;
  /** Unlocks team activity. Usually, only invoked manually by a developer to unblock partners. */
  Teamwork_UnlockTeamActivity: Teamwork_UnlockTeamActivityResult;
  /** This mutation creates the thirdPartyOrganizationEmailDomain Entry */
  ThirdPartyOrganizationEmailDomain_Create: ThirdPartyOrganizationEmailDomain_CreateResult;
  /** This mutation deletes the thirdPartyOrganizationEmailDomain Entry */
  ThirdPartyOrganizationEmailDomain_Delete: ThirdPartyOrganizationEmailDomain_DeleteResult;
  /** This mutation creates multiple entries for thirdPartyOrganizationEmailDomain */
  ThirdPartyOrganizationEmailDomain_MultiCreate: ThirdPartyOrganizationEmailDomain_MultiCreateResult;
  /** Create Service Account */
  ThirdPartyOrganizationServiceAccount_ServiceAccountCreate: ThirdPartyOrganizationServiceAccount_ServiceAccountCreateResult;
  /** Delete Service Account */
  ThirdPartyOrganizationServiceAccount_ServiceAccountDelete: ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteResult;
  /** This mutation set the isReal field of a ThirdPartyOrganization */
  ThirdPartyOrganization_SetIsReal: ThirdPartyOrganization_SetIsRealResult;
  /** This mutation updates the entityId field of a ThirdPartyOrganization */
  ThirdPartyOrganization_UpdateEntityId: ThirdPartyOrganization_UpdateEntityIdResult;
  /** Mutation to update Metadata for ThirdPartyOrganization */
  ThirdPartyOrganization_UpdateMetadata: ThirdPartyOrganization_UpdateMetadataResult;
  /** This mutation updates the signing certificate fingerprint for a ThirdPartyOrganization */
  ThirdPartyOrganization_UpdateSigningCertificate: ThirdPartyOrganization_UpdateSigningCertificateResult;
  /** Report Feedback */
  TranslationFeedback_ReportFeedback?: Maybe<TranslationFeedback_ReportFeedbackResult>;
  /**
   * This mutation adds Turnitin tenant configuration enabling the specified program/organization
   * to use the Turnitin-based similarity score checker.
   */
  TurnitinTenant_createEntry?: Maybe<TurnitinTenant_CreateEntryPayload>;
  /** Create a new ULBA job to initiate the conversion process for importing course materials */
  Ulba_CreateUlbaJob: Ulba_CreateUlbaJobResult;
  /** Export course structure as an Excel course template */
  Ulba_ExportCourseStructure: Ulba_ExportCourseStructureResult;
  /** Dismiss a report from parsing or loading so it will be hidden from the user */
  Ulba_UpdateUlbaJobDismissReport: Ulba_UpdateUlbaJobDismissReportResult;
  /** Start loading process to create course materials from a parsed ULBA job */
  Ulba_UpdateUlbaJobStartLoading: Ulba_UpdateUlbaJobStartLoadingResult;
  /**
   * Initiate Smart Ingestion by transferring the ULBA job to Course Builder. This is a synchronous
   * mutation, meaning the request will not return until the Courser Builder workflow has been created.
   */
  Ulba_UpdateUlbaJobStartSmartIngestionSync: Ulba_UpdateUlbaJobStartSmartIngestionSyncResult;
  /** Modifies upsells. */
  UpsellMutations?: Maybe<UpsellMutationQueries>;
  /** Request email to be deleted for the user */
  UserEmails_DeleteUserEmail: UserEmails_DeleteUserEmailResult;
  /** Update the user's experience context selection. User ID is inferred from request context. */
  UserExperienceContext_UpdateUserExperienceContext: UserExperienceContext_UpdateUserExperienceContextResult;
  /** Hides a previously published portfolio project from display on the profile page */
  UserPortfolioProject_Hide?: Maybe<UserPortfolioProject_HideResult>;
  /** Publishes a completed portfolio project for display on the profile page */
  UserPortfolioProject_Publish?: Maybe<UserPortfolioProject_PublishResult>;
  /** Saves any new updates to a user's portfolio project */
  UserPortfolioProject_Save?: Maybe<UserPortfolioProject_SaveResult>;
  /** Set user preference for the current user. User ID is inferred from request context. */
  UserPreference_SetUserPreference?: Maybe<UserPreference_SetUserPreferenceResult>;
  /** Deletes an override to enable or disable ID verification for a course. Idempotent. */
  UserVerification_DeleteIdVerificationCourseOverride: UserVerification_DeleteIdVerificationCourseOverrideResult;
  /** Sets an override to enable or disable ID verification for a course. Will create new or update an existing override. */
  UserVerification_SetIdVerificationCourseOverride: UserVerification_SetIdVerificationCourseOverrideResult;
  /** Request user data release by user ID, user data is sent to the users email address */
  User_ExportUserDataRelease: User_ExportUserDataReleaseResult;
  /** This mutation creates or updates skill expression to assessment mappings. */
  VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappings?: Maybe<VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsResult>;
  /** Mutation to save user feedback for the viva exam result */
  VivaExam_SaveUserFeedback?: Maybe<VivaExam_SaveUserFeedbackResult>;
  /** Mutation to start a viva exam session based on the provided input */
  VivaExam_StartExam?: Maybe<VivaExam_StartExamResult>;
  /** Mutation to submit an answer to a viva exam question */
  VivaExam_SubmitQuestionAnswer?: Maybe<VivaExam_SubmitQuestionAnswerResult>;
  /** This mutation sets up integrations for sending data via xAPI to external parties (i.e, Workday Cloud Connect for Learning). */
  XapiIntegration_CreateXapiIntegration: XapiIntegration_CreateXapiIntegrationResult;
  /** This mutation deletes an existing xAPI integration. */
  XapiIntegration_DeleteXapiIntegration: XapiIntegration_DeleteXapiIntegrationResult;
  /** This mutation permanently removes an existing xAPI integration record (instead of marking it disabled). */
  XapiIntegration_RemoveXapiIntegration: XapiIntegration_RemoveXapiIntegrationResult;
  /** This mutation triggers the xAPI Tracking Enrollment Sync job for one or more organizations. */
  XapiIntegration_TriggerEnrollmentSyncJob: XapiIntegration_TriggerEnrollmentSyncJobResult;
  /** This mutation updates client credentials for an xAPI integration */
  XapiIntegration_UpdateXapiIntegration: XapiIntegration_UpdateXapiIntegrationResult;
  /** This mutation validates client credentials for an xAPI integration before create/update */
  XapiIntegration_ValidateXapiIntegration: XapiIntegration_ValidateXapiIntegrationResult;
  /**
   * Capture a PaymentWalletId for the given PreEnrollment if it is of PAYMENT_WALLET_CAPTURE PreEnrollmentType, throws otherwise.
   * Return the passed in PreEnrollmentId.
   */
  capturePaymentWalletId: Scalars['String'];
  /**
   * Enroll a user to a specialization with a specific membership role.
   * @deprecated Use SpecializationMembership_CreateMembership.
   */
  createMembership?: Maybe<OnDemandSpecializationMembershipPayload>;
  /**
   * Mark a product as available for PreEnrollment or update launchAt if already exists.
   *
   * If known, launchAt can be provided as a TimeStamp.
   * @deprecated Please use upsertPreEnrollmentProduct instead
   */
  createOrUpdatePreEnrollmentProduct?: Maybe<PreEnrollmentProduct>;
  /**
   * Decline upgrading to a newer version of specialization.
   * @deprecated Use SpecializationUpgrade_DeclineUpgrade.
   */
  declineUpgrade?: Maybe<Scalars['Boolean']>;
  /**
   * The delete mutation works the same way as unenrolling a user from a s12n membership.
   * @deprecated Use SpecializationMembership_DeleteMembership.
   */
  deleteMembership: OnDemandSpecializationMembership_DeletePayload;
  /**
   * Similar as creating membership but it also checks product ownership.
   * @deprecated Use SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12n.
   */
  enrollInOwnedS12n: OnDemandSpecializationMembershipPayload;
  /** PreEnroll a learner into a product with the given PreEnrollmentType. */
  preEnrollUser: UserProductPreEnrollment;
  /** Redeem a course credit */
  redeemCourseCredit: RedeemCourseCreditResult;
  /** Refund a course credit and generate a new credit */
  refundCourseCredit: RefundCourseCreditResult;
  /** Unenroll the given PreEnrollment. Return the passed in PreEnrollmentId. */
  removePreEnrollment: Scalars['String'];
  /**
   * Upgrade to a newer version of specialization.
   * @deprecated Use SpecializationUpgrade_Upgrade.
   */
  upgrade?: Maybe<OnDemandSpecializationUpgradePayload>;
  /**
   * Mark a product as available for PreEnrollment or update launchAt if already exists.
   *
   * If known, launchAt can be provided as a TimeStamp.
   */
  upsertPreEnrollmentProduct?: Maybe<PreEnrollmentProduct>;
};


/** Root Mutation type */
export type MutationAcademicDiscipline_SetupAcademicDisciplineBasedProgramArgs = {
  input?: InputMaybe<AcademicDiscipline_SetupAcademicDisciplineBasedProgramInput>;
};


/** Root Mutation type */
export type MutationAdHocProducts_HardRemoveContractTagProductIdArgs = {
  input: AdHocProducts_HardRemoveContractTagProductIdInput;
};


/** Root Mutation type */
export type MutationAdHocProducts_UpdateContractTagProductIdArgs = {
  input: AdHocProducts_UpdateContractTagProductIdInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_AddCourseItemToLearningBlockArgs = {
  input: AdaptiveLearning_AddCourseItemToLearningBlockInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_DeleteLearningPlanArgs = {
  input: AdaptiveLearning_DeleteLearningPlanInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_OnboardArgs = {
  input: AdaptiveLearning_OnboardInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_ReportItemProgressArgs = {
  input: AdaptiveLearning_ReportItemProgressInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_ReportPracticeAttemptArgs = {
  input: AdaptiveLearning_ReportPracticeAttemptInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_SubmitPreAssessmentAnswersArgs = {
  input: AdaptiveLearning_SubmitPreAssessmentAnswersInput;
};


/** Root Mutation type */
export type MutationAdaptiveLearning_SubmitPreAssessmentAnswersV2Args = {
  input: AdaptiveLearning_SubmitPreAssessmentAnswersV2Input;
};


/** Root Mutation type */
export type MutationAdminProgramImpersonations_DeleteArgs = {
  input: AdminProgramImpersonations_DeleteInput;
};


/** Root Mutation type */
export type MutationAdminProgramImpersonations_SetArgs = {
  input: AdminProgramImpersonations_SetInput;
};


/** Root Mutation type */
export type MutationAdminStaffMemberships_AddSessionAssistantsByEmailsArgs = {
  input: AdminStaffMemberships_AddSessionAssistantsByEmailsInput;
};


/** Root Mutation type */
export type MutationAdminStaffMemberships_DeleteSessionAssistantsArgs = {
  input: AdminStaffMemberships_DeleteSessionAssistantsInput;
};


/** Root Mutation type */
export type MutationAiAuthoring_SubmitWritingAssistantFeedbackArgs = {
  input: AiAuthoring_SubmitWritingAssistantFeedbackInput;
};


/** Root Mutation type */
export type MutationAiCheatingFlaggedEvent_OverrideFlaggedEventArgs = {
  input: AiCheatingFlaggedEvent_OverrideFlaggedEventInput;
};


/** Root Mutation type */
export type MutationAiCoach_CreateChatSessionArgs = {
  input: AiCoach_CreateChatSessionInput;
};


/** Root Mutation type */
export type MutationAiCoach_CreateLiveKitTokenArgs = {
  input: AiCoach_CreateLiveKitTokenInput;
};


/** Root Mutation type */
export type MutationAiCoach_CreateLiveKitTokenDevArgs = {
  input: AiCoach_CreateLiveKitTokenDevInput;
};


/** Root Mutation type */
export type MutationAiCoach_CreateUserMessageAndReturnResponseArgs = {
  input: AiCoach_CreateUserMessageAndReturnResponseInput;
};


/** Root Mutation type */
export type MutationAiCoach_DeleteChatSessionsForCurrentUserArgs = {
  input: AiCoach_DeleteChatSessionsForCurrentUserInput;
};


/** Root Mutation type */
export type MutationAiCoach_DeleteMemoriesForCurrentUserArgs = {
  input: AiCoach_DeleteMemoriesForCurrentUserInput;
};


/** Root Mutation type */
export type MutationAiCoach_LinkLoggedOutHistoryToCurrentUserArgs = {
  input: AiCoach_LinkLoggedOutHistoryToCurrentUserInput;
};


/** Root Mutation type */
export type MutationAiCoach_RespondToUserMessageArgs = {
  input: AiCoach_RespondToUserMessageInput;
};


/** Root Mutation type */
export type MutationAiCoach_RespondToUserMessageAsyncArgs = {
  input: AiCoach_RespondToUserMessageAsyncInput;
};


/** Root Mutation type */
export type MutationAiCoach_SaveCoachUserSettingsArgs = {
  input: AiCoach_SaveCoachUserSettingsInput;
};


/** Root Mutation type */
export type MutationAiCoach_UpdateChatSessionArgs = {
  input: AiCoach_UpdateChatSessionInput;
};


/** Root Mutation type */
export type MutationAiCoach_UpdateDynamicPromptStatusAsCompleteArgs = {
  input: AiCoach_UpdateDynamicPromptStatusAsCompleteInput;
};


/** Root Mutation type */
export type MutationAiCoach_UpdateWithUserFeedbackArgs = {
  input: AiCoach_UpdateWithUserFeedbackInput;
};


/** Root Mutation type */
export type MutationAiEmbeddings_IndexDocumentAssetArgs = {
  input: AiEmbeddings_IndexDocumentAssetInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_CreateChallengeArgs = {
  input: AiGradedChallenge_CreateChallengeInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_DeleteDraftChallengeArgs = {
  input: AiGradedChallenge_DeleteDraftChallengeInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_DeleteDraftChallengeByIdArgs = {
  input: AiGradedChallenge_DeleteDraftChallengeByIdInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_PublishChallengeArgs = {
  input: AiGradedChallenge_PublishChallengeInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_SaveUserFeedbackArgs = {
  input: AiGradedChallenge_SaveUserFeedbackInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_SubmitChallengeArgs = {
  input: AiGradedChallenge_SubmitChallengeInput;
};


/** Root Mutation type */
export type MutationAiGradedChallenge_UpdateChallengeArgs = {
  input: AiGradedChallenge_UpdateChallengeInput;
};


/** Root Mutation type */
export type MutationAiGrading_CreateAssignmentLevelRubricGenerationJobArgs = {
  input: AiGrading_CreateAssignmentLevelRubricGenerationJobInput;
};


/** Root Mutation type */
export type MutationAiGrading_CreateAssignmentRubricGenerationJobArgs = {
  input: AiGrading_CreateAssignmentRubricGenerationJobInput;
};


/** Root Mutation type */
export type MutationAiGrading_CreateDisputeArgs = {
  input: AiGrading_CreateDisputeInput;
};


/** Root Mutation type */
export type MutationAiGrading_PreviewGradeForQuestionArgs = {
  input: AiGrading_PreviewGradeForQuestionInput;
};


/** Root Mutation type */
export type MutationAiGrading_PreviewGradeForQuestionBankQuestionArgs = {
  input: AiGrading_PreviewGradeForQuestionBankQuestionInput;
};


/** Root Mutation type */
export type MutationAiGrading_SaveUserFeedbackArgs = {
  input: AiGrading_SaveUserFeedbackInput;
};


/** Root Mutation type */
export type MutationAiItemGeneration_FinalizeGeneratedItemArgs = {
  input: AiItemGeneration_FinalizeGeneratedItemInput;
};


/** Root Mutation type */
export type MutationAiItemGeneration_GenerateItemArgs = {
  input: AiItemGeneration_GenerateItemInput;
};


/** Root Mutation type */
export type MutationAiSuggestions_SaveSuggestionFeedbackArgs = {
  input: AiSuggestions_SaveSuggestionFeedbackInput;
};


/** Root Mutation type */
export type MutationAiTutor_UpdateDynamicPromptStatusAsCompleteArgs = {
  input: AiTutor_UpdateDynamicPromptStatusAsCompleteInput;
};


/** Root Mutation type */
export type MutationAssessmentGeneration_GenerateAssessmentArgs = {
  input: AssessmentGeneration_GenerateAssessmentInput;
};


/** Root Mutation type */
export type MutationAssessmentGeneration_StopAssessmentGenerationArgs = {
  input: AssessmentGeneration_StopAssessmentGenerationInput;
};


/** Root Mutation type */
export type MutationAssessmentGenerator_StartGenerationArgs = {
  input: AssessmentGenerator_StartGenerationInput;
};


/** Root Mutation type */
export type MutationAssetVideo_AddAssetVideoArgs = {
  input: AssetVideo_AddAssetVideoInput;
};


/** Root Mutation type */
export type MutationAssetVideo_ConvertExistingVideoToAudioDescriptionVideoArgs = {
  input: AssetVideo_ConvertExistingVideoToAudioDescriptionVideoInput;
};


/** Root Mutation type */
export type MutationAssetVideo_DeleteAudioDescriptionVideoArgs = {
  input: AssetVideo_DeleteAudioDescriptionVideoInput;
};


/** Root Mutation type */
export type MutationAssetVideo_SetTrimmingRangeForBranchArgs = {
  input: AssetVideo_SetTrimmingRangeForBranchInput;
};


/** Root Mutation type */
export type MutationAssignmentAiGrading_ApplyAiGradingArgs = {
  input: AssignmentAiGrading_ApplyAiGradingInput;
};


/** Root Mutation type */
export type MutationAssignmentAi_Utilities_ChatV1Args = {
  input: AssignmentAi_Utilities_ChatV1Input;
};


/** Root Mutation type */
export type MutationAssignmentCoach_SubmitFeedbackOnSuggestionArgs = {
  input: AssignmentCoach_SubmitFeedbackOnSuggestionInput;
};


/** Root Mutation type */
export type MutationAssignment_AssignmentRegradeArgs = {
  input: Assignment_AssignmentRegradeInput;
};


/** Root Mutation type */
export type MutationAtomSummativeContent_CreateAtomSummativeContentArgs = {
  input: AtomSummativeContent_CreateAtomSummativeContentInput;
};


/** Root Mutation type */
export type MutationAtomSummativeContent_DeleteAtomSummativeContentArgs = {
  input: AtomSummativeContent_DeleteAtomSummativeContentInput;
};


/** Root Mutation type */
export type MutationAtomSummativeContent_UpdateAtomSummativeContentArgs = {
  input: AtomSummativeContent_UpdateAtomSummativeContentInput;
};


/** Root Mutation type */
export type MutationAuthoringAssetCreationAttempts_CreateArgs = {
  input: AuthoringAssetCreationAttempts_CreateInput;
};


/** Root Mutation type */
export type MutationBadge_CreateOrUpdateCredlyBadgeTemplateMappingArgs = {
  input: Badge_CreateOrUpdateCredlyBadgeTemplateMappingInput;
};


/** Root Mutation type */
export type MutationBadge_DeleteCredlyBadgeTemplateMappingArgs = {
  input: Badge_DeleteCredlyBadgeTemplateMappingInput;
};


/** Root Mutation type */
export type MutationBadge_OpenBadgeImageGenerationArgs = {
  input: Badge_OpenBadgeImageGenerationInput;
};


/** Root Mutation type */
export type MutationBadge_PreviewGeneratorArgs = {
  input: Badge_PreviewGeneratorInput;
};


/** Root Mutation type */
export type MutationBetaTestingSchedule_DeleteArgs = {
  input: BetaTestingSchedule_DeleteInput;
};


/** Root Mutation type */
export type MutationBetaTestingSchedule_UpdateArgs = {
  input: BetaTestingSchedule_UpdateInput;
};


/** Root Mutation type */
export type MutationBranchItem_CreateBranchItemArgs = {
  input: BranchItem_CreateBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_DuplicateBranchItemArgs = {
  input: BranchItem_DuplicateBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_ForkBranchItemArgs = {
  input: BranchItem_ForkBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_PublishBranchItemArgs = {
  input: BranchItem_PublishBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_ShareBranchItemArgs = {
  input: BranchItem_ShareBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_UnfreezeBranchItemArgs = {
  input: BranchItem_UnfreezeBranchItemInput;
};


/** Root Mutation type */
export type MutationBranchItem_UnlinkBranchItemArgs = {
  input: BranchItem_UnlinkBranchItemInput;
};


/** Root Mutation type */
export type MutationBusinessCaseProposal_RequestDownloadArgs = {
  input: BusinessCaseProposal_RequestDownloadInput;
};


/** Root Mutation type */
export type MutationBusinessCaseProposal_SendEmailArgs = {
  input: BusinessCaseProposal_SendEmailInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_ArchiveCampaignArgs = {
  input: CampaignManagement_ArchiveCampaignInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_CreateCampaignArgs = {
  input: CampaignManagement_CreateCampaignInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_DeleteCampaignArgs = {
  input: CampaignManagement_DeleteCampaignInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_EndCampaignArgs = {
  input: CampaignManagement_EndCampaignInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_MarkCampaignReadyForLaunchArgs = {
  input: CampaignManagement_MarkCampaignReadyForLaunchInput;
};


/** Root Mutation type */
export type MutationCampaignManagement_PatchCampaignArgs = {
  input: CampaignManagement_PatchCampaignInput;
};


/** Root Mutation type */
export type MutationCampaign_RecordEventArgs = {
  input: Campaign_RecordEventInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_AddContentsToRoleArgs = {
  input: CareerAcademy_AddContentsToRoleInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_AddRoleArgs = {
  input: CareerAcademy_AddRoleInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_DeleteRoleArgs = {
  input: CareerAcademy_DeleteRoleInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_RefreshCurriculumsArgs = {
  input: CareerAcademy_RefreshCurriculumsInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_RemoveContentFromRoleArgs = {
  input: CareerAcademy_RemoveContentFromRoleInput;
};


/** Root Mutation type */
export type MutationCareerAcademy_UpdateProgramCurriculumArgs = {
  input: CareerAcademy_UpdateProgramCurriculumInput;
};


/** Root Mutation type */
export type MutationCertificates_DeleteCourseCertificatePrintSettingsArgs = {
  input: Certificates_DeleteCourseCertificatePrintSettingsInput;
};


/** Root Mutation type */
export type MutationCertificates_DeleteS12nCertificatePrintSettingsArgs = {
  input: Certificates_DeleteS12nCertificatePrintSettingsInput;
};


/** Root Mutation type */
export type MutationCertificates_UpdateCourseCertificatePrintSettingsArgs = {
  input: Certificates_UpdateCourseCertificatePrintSettingsInput;
};


/** Root Mutation type */
export type MutationCertificates_UpdateS12nCertificatePrintSettingsArgs = {
  input: Certificates_UpdateS12nCertificatePrintSettingsInput;
};


/** Root Mutation type */
export type MutationCheatingIncident_RequestAppealForCheatingIncidentArgs = {
  input: CheatingIncident_RequestAppealForCheatingIncidentInput;
};


/** Root Mutation type */
export type MutationCheckoutGateway_CreateCartArgs = {
  input: CheckoutGateway_CreateCartInput;
};


/** Root Mutation type */
export type MutationCoachItemAuthoring_UpdateCoachItemDraftArgs = {
  input: CoachItemAuthoring_UpdateCoachItemDraftInput;
};


/** Root Mutation type */
export type MutationCoachItemGrading_StartGradingAttemptArgs = {
  input: CoachItemGrading_StartGradingAttemptInput;
};


/** Root Mutation type */
export type MutationCoachItemGrading_SubmitForGradingArgs = {
  input: CoachItemGrading_SubmitForGradingInput;
};


/** Root Mutation type */
export type MutationCoachItemProgress_UpdateCoachItemProgressArgs = {
  input: CoachItemProgress_UpdateCoachItemProgressInput;
};


/** Root Mutation type */
export type MutationCoachItem_ResolveContentArgs = {
  input: CoachItem_ResolveContentInput;
};


/** Root Mutation type */
export type MutationCollection_AddCollectionArgs = {
  input: Collection_AddCollectionInput;
};


/** Root Mutation type */
export type MutationCollection_UpdateCollectionAttributesArgs = {
  input: Collection_UpdateCollectionAttributesInput;
};


/** Root Mutation type */
export type MutationCollection_UpdateCollectionVisibilitiesArgs = {
  input: Collection_UpdateCollectionVisibilitiesInput;
};


/** Root Mutation type */
export type MutationContentExperiment_CompleteGroupArgs = {
  input: ContentExperiment_CompleteGroupInput;
};


/** Root Mutation type */
export type MutationContentExperiment_CreateContentExperimentGroupArgs = {
  input: ContentExperiment_CreateContentExperimentGroupInput;
};


/** Root Mutation type */
export type MutationContentExperiment_CreateSubjectsForGroupArgs = {
  input: ContentExperiment_CreateSubjectsForGroupInput;
};


/** Root Mutation type */
export type MutationContentExperiment_RemoveSubjectsFromGroupArgs = {
  input: ContentExperiment_RemoveSubjectsFromGroupInput;
};


/** Root Mutation type */
export type MutationContentExperiment_StartGroupArgs = {
  input: ContentExperiment_StartGroupInput;
};


/** Root Mutation type */
export type MutationContentExperiment_StopGroupArgs = {
  input: ContentExperiment_StopGroupInput;
};


/** Root Mutation type */
export type MutationContentfulTranslation_TranslateEntriesArgs = {
  input: ContentfulTranslation_TranslateEntriesInput;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyBranch_CreateNewBranchArgs = {
  input: CoreSkillTaxonomyBranch_CreateNewBranchInput;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyBranch_DeactivateBranchArgs = {
  input: CoreSkillTaxonomyBranch_DeactivateBranchInput;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyBranch_FreezeBranchArgs = {
  input: CoreSkillTaxonomyBranch_FreezeBranchInput;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyBranch_MergeBranchArgs = {
  input: CoreSkillTaxonomyBranch_MergeBranchInput;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyNode_DeleteNodesByBranchNameArgs = {
  input?: InputMaybe<CoreSkillTaxonomyNode_DeleteNodesByBranchNameInput>;
};


/** Root Mutation type */
export type MutationCoreSkillTaxonomyNode_UpsertNodesByBranchNameArgs = {
  input?: InputMaybe<CoreSkillTaxonomyNode_UpsertNodesByBranchNameInput>;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_GenerateAssessmentsOutlineItemsArgs = {
  input: CourseBuilderV2_GenerateAssessmentsOutlineItemsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_RewindToCheckpointArgs = {
  input: CourseBuilderV2_RewindToCheckpointInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_RewindToStepArgs = {
  input: CourseBuilderV2_RewindToStepInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_SaveCoachChatSessionArgs = {
  input: CourseBuilderV2_SaveCoachChatSessionInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartAnalyzingContentForGapsArgs = {
  input: CourseBuilderV2_StartAnalyzingContentForGapsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseMaterialsArgs = {
  input: CourseBuilderV2_StartGeneratingCourseMaterialsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineFromScratchArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineFromScratchInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineFromSelectedCoursesInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineFromSyllabusFileInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineWithCuratedItemsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineWithModulesAndLearningObjectivesInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineWithSearchTermsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingCourseOutlineWithSkillsArgs = {
  input: CourseBuilderV2_StartGeneratingCourseOutlineWithSkillsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingItemOutlineFromScratchArgs = {
  input: CourseBuilderV2_StartGeneratingItemOutlineFromScratchInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsArgs = {
  input: CourseBuilderV2_StartGeneratingPlaceholderItemsFromRecommendationsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_UpdateCourseOutlineArgs = {
  input: CourseBuilderV2_UpdateCourseOutlineInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_UpdateCourseOutlineWithCuratedItemsArgs = {
  input: CourseBuilderV2_UpdateCourseOutlineWithCuratedItemsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesArgs = {
  input: CourseBuilderV2_UpdateCourseOutlineWithModulesAndLearningObjectivesInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_UpdateCourseOutlineWithSearchTermsArgs = {
  input: CourseBuilderV2_UpdateCourseOutlineWithSearchTermsInput;
};


/** Root Mutation type */
export type MutationCourseBuilderV2_UpdateItemOutlineFromScratchArgs = {
  input: CourseBuilderV2_UpdateItemOutlineFromScratchInput;
};


/** Root Mutation type */
export type MutationCourseBuilder_CreateRestrictionArgs = {
  input: CourseBuilder_CreateRestrictionInput;
};


/** Root Mutation type */
export type MutationCourseBuilder_DeleteRestrictionArgs = {
  input: CourseBuilder_DeleteRestrictionInput;
};


/** Root Mutation type */
export type MutationCourseBuilder_UpdateRestrictionArgs = {
  input: CourseBuilder_UpdateRestrictionInput;
};


/** Root Mutation type */
export type MutationCourseContentTranslation_TriggerProactiveCourseTranslationArgs = {
  input: CourseContentTranslation_TriggerProactiveCourseTranslationInput;
};


/** Root Mutation type */
export type MutationCourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramArgs = {
  input: CourseDefaultEnterpriseProgram_SetCourseDefaultEnterpriseProgramInput;
};


/** Root Mutation type */
export type MutationCourseProfiles_UpdateCourseProfileForInstitutionArgs = {
  input: CourseProfiles_UpdateCourseProfileForInstitutionInput;
};


/** Root Mutation type */
export type MutationCourseProfiles_UpdateCourseProfileForProgramArgs = {
  input: CourseProfiles_UpdateCourseProfileForProgramInput;
};


/** Root Mutation type */
export type MutationCourseProgress_ApplyCourseProgressOverrideArgs = {
  input: CourseProgress_ApplyCourseProgressOverrideInput;
};


/** Root Mutation type */
export type MutationCourseProgress_RemoveCourseProgressOverrideArgs = {
  input: CourseProgress_RemoveCourseProgressOverrideInput;
};


/** Root Mutation type */
export type MutationCourseProgress_ResyncCourseBranchProgressArgs = {
  input: CourseProgress_ResyncCourseBranchProgressInput;
};


/** Root Mutation type */
export type MutationCourseProgress_ToggleAtomGradeHideArgs = {
  input: CourseProgress_ToggleAtomGradeHideInput;
};


/** Root Mutation type */
export type MutationCourseraPlusCollections_SaveArgs = {
  input: CourseraPlusCollections_SaveInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_EndProctoringArgs = {
  input: CourseraProctoring_EndProctoringInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_InitializeAssetArgs = {
  input: CourseraProctoring_InitializeAssetInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_ProcessAssetArgs = {
  input: CourseraProctoring_ProcessAssetInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_ReanalyzeRecordingsArgs = {
  input: CourseraProctoring_ReanalyzeRecordingsInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_SetEnablementArgs = {
  input: CourseraProctoring_SetEnablementInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_StartProctoringArgs = {
  input: CourseraProctoring_StartProctoringInput;
};


/** Root Mutation type */
export type MutationCourseraProctoring_SubmitProctoringEventFeedbackArgs = {
  input: CourseraProctoring_SubmitProctoringEventFeedbackInput;
};


/** Root Mutation type */
export type MutationCourserianRoles_DeleteRolesOfCourserianArgs = {
  input: CourserianRoles_DeleteRolesOfCourserianInput;
};


/** Root Mutation type */
export type MutationCourserianRoles_UpdateRolesOfCourserianArgs = {
  input: CourserianRoles_UpdateRolesOfCourserianInput;
};


/** Root Mutation type */
export type MutationCredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathArgs = {
  input: CredentialConfiguration_SetCredentialConfigurationForCollectionOrLearningPathInput;
};


/** Root Mutation type */
export type MutationCredentialConfiguration_SetCredentialConfigurationForProgramArgs = {
  input: CredentialConfiguration_SetCredentialConfigurationForProgramInput;
};


/** Root Mutation type */
export type MutationCredentialConfiguration_UpdateCredentialConfigurationsForInstitutionArgs = {
  input: CredentialConfiguration_UpdateCredentialConfigurationsForInstitutionInput;
};


/** Root Mutation type */
export type MutationCredentialConfiguration_UpdateCredentialConfigurationsForProgramArgs = {
  input: CredentialConfiguration_UpdateCredentialConfigurationsForProgramInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_AddGroupCurationsToProgramsArgs = {
  input: CurationBuilder_AddGroupCurationsToProgramsInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_CreateProgramFromProgramOutlineArgs = {
  input: CurationBuilder_CreateProgramFromProgramOutlineInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GenerateBulkCurationOutlinesArgs = {
  input: CurationBuilder_GenerateBulkCurationOutlinesInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GenerateCurationOutlineArgs = {
  input: CurationBuilder_GenerateCurationOutlineInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GenerateCurationOutlineContentSuggestionsArgs = {
  input: CurationBuilder_GenerateCurationOutlineContentSuggestionsInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GenerateFileUploadLocationArgs = {
  input: CurationBuilder_GenerateFileUploadLocationInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GenerateProgramOutlineArgs = {
  input: CurationBuilder_GenerateProgramOutlineInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_GeneratePromptAttributesFromFileArgs = {
  input: CurationBuilder_GeneratePromptAttributesFromFileInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateBadgeConfigurationsArgs = {
  input: CurationBuilder_UpdateBadgeConfigurationsInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateBadgeConfigurationsForProgramsArgs = {
  input: CurationBuilder_UpdateBadgeConfigurationsForProgramsInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateCurationOutlineArgs = {
  input: CurationBuilder_UpdateCurationOutlineInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateCurationOutlineWithGroupsArgs = {
  input: CurationBuilder_UpdateCurationOutlineWithGroupsInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateProgramFromCurationOutlineArgs = {
  input: CurationBuilder_UpdateProgramFromCurationOutlineInput;
};


/** Root Mutation type */
export type MutationCurationBuilder_UpdateProgramOutlineArgs = {
  input: CurationBuilder_UpdateProgramOutlineInput;
};


/** Root Mutation type */
export type MutationCurationRecommendation_GenerateRecommendationArgs = {
  input: CurationRecommendation_GenerateRecommendationInput;
};


/** Root Mutation type */
export type MutationCurationRecommendation_UpdateSuggestionStatusArgs = {
  input: CurationRecommendation_UpdateSuggestionStatusInput;
};


/** Root Mutation type */
export type MutationCurriculumBuilder_TriggerCurriculumDownloadArgs = {
  input?: InputMaybe<CurriculumBuilder_TriggerCurriculumDownloadInput>;
};


/** Root Mutation type */
export type MutationCurriculumManagement_LaunchDegreeProgressMapExperienceArgs = {
  input: CurriculumManagement_LaunchDegreeProgressMapExperienceInput;
};


/** Root Mutation type */
export type MutationCurriculumManagement_StartFileProcessingArgs = {
  input: CurriculumManagement_StartFileProcessingInput;
};


/** Root Mutation type */
export type MutationDegreeAttributes_UpdateDegreeAttributesArgs = {
  input: DegreeAttributes_UpdateDegreeAttributesInput;
};


/** Root Mutation type */
export type MutationDegreeConfig_CreateStudentSuccessAttributesArgs = {
  input: DegreeConfig_CreateStudentSuccessAttributesInput;
};


/** Root Mutation type */
export type MutationDegreeConfig_UpdateStudentSuccessAttributesArgs = {
  input: DegreeConfig_UpdateStudentSuccessAttributesInput;
};


/** Root Mutation type */
export type MutationDegreeMarketing_UpdateCourseArgs = {
  input: DegreeMarketing_UpdateCourseInput;
};


/** Root Mutation type */
export type MutationDescript_CreateEditUrlArgs = {
  input: Descript_CreateEditUrlInput;
};


/** Root Mutation type */
export type MutationEmailWhitelist_AddToWhitelistArgs = {
  input: EmailWhitelist_AddToWhitelistInput;
};


/** Root Mutation type */
export type MutationEmailWhitelist_RemoveFromWhitelistArgs = {
  input: EmailWhitelist_RemoveFromWhitelistInput;
};


/** Root Mutation type */
export type MutationEmbeddedExp_AddAllowedDomainArgs = {
  input: EmbeddedExp_AddAllowedDomainInput;
};


/** Root Mutation type */
export type MutationEmbeddedExp_DeleteAllowedDomainArgs = {
  input: EmbeddedExp_DeleteAllowedDomainInput;
};


/** Root Mutation type */
export type MutationEmbeddedExp_UpdateAllowedDomainArgs = {
  input: EmbeddedExp_UpdateAllowedDomainInput;
};


/** Root Mutation type */
export type MutationEntCurriculum_UpdateProgramCurriculumArgs = {
  input: EntCurriculum_UpdateProgramCurriculumInput;
};


/** Root Mutation type */
export type MutationEntExternalConnector_CreateConfigurationArgs = {
  input: EntExternalConnector_CreateConfigurationInput;
};


/** Root Mutation type */
export type MutationEntExternalConnector_DeleteConfigurationArgs = {
  input: EntExternalConnector_DeleteConfigurationInput;
};


/** Root Mutation type */
export type MutationEntExternalConnector_UpdateConfigurationArgs = {
  input: EntExternalConnector_UpdateConfigurationInput;
};


/** Root Mutation type */
export type MutationEntTransaction_AddOrUpdateNewPaymentMethodArgs = {
  input: EntTransaction_AddOrUpdateNewPaymentMethodInput;
};


/** Root Mutation type */
export type MutationEntTransaction_CreateEnterpriseContractPurchaseOrderArgs = {
  input: EntTransaction_CreateEnterpriseContractPurchaseOrderInput;
};


/** Root Mutation type */
export type MutationEntTransaction_CreateNonBillableFreeTrialArgs = {
  input: EntTransaction_CreateNonBillableFreeTrialInput;
};


/** Root Mutation type */
export type MutationEntTransaction_DeleteBackupPaymentMethodArgs = {
  input: EntTransaction_DeleteBackupPaymentMethodInput;
};


/** Root Mutation type */
export type MutationEntTransaction_FinalizeOrderArgs = {
  input: EntTransaction_FinalizeOrderInput;
};


/** Root Mutation type */
export type MutationEntTransaction_MakeMethodPrimaryArgs = {
  input: EntTransaction_MakeMethodPrimaryInput;
};


/** Root Mutation type */
export type MutationEntTransaction_TerminateFreeTrialArgs = {
  input: EntTransaction_TerminateFreeTrialInput;
};


/** Root Mutation type */
export type MutationEntTransaction_UpdateContractAndTermIdArgs = {
  input: EntTransaction_UpdateContractAndTermIdInput;
};


/** Root Mutation type */
export type MutationEntTransaction_UpdateOrderStateArgs = {
  input: EntTransaction_UpdateOrderStateInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdminHomePage_MarkRecommendedActionAsCompletedArgs = {
  input: EnterpriseAdminHomePage_MarkRecommendedActionAsCompletedInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdminHomePage_RequestMoreLicensesArgs = {
  input: EnterpriseAdminHomePage_RequestMoreLicensesInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationArgs = {
  input?: InputMaybe<EnterpriseAdmin_AcceptAllInvitationsForEmailAndOrganizationFromInvitationInput>;
};


/** Root Mutation type */
export type MutationEnterpriseAdmin_CreateInvitationsOrRolesArgs = {
  input: EnterpriseAdmin_CreateInvitationsOrRolesInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdmin_DeleteAllAdminInvitationsArgs = {
  input: EnterpriseAdmin_DeleteAllAdminInvitationsInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdmin_DeleteInvitationsOrRolesArgs = {
  input: EnterpriseAdmin_DeleteInvitationsOrRolesInput;
};


/** Root Mutation type */
export type MutationEnterpriseAdmin_ValidateInvitationsOrRolesArgs = {
  input: EnterpriseAdmin_ValidateInvitationsOrRolesInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_CreateArgs = {
  input: EnterpriseBadge_CreateInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_DeleteLearningPathArgs = {
  input: EnterpriseBadge_DeleteLearningPathInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_DuplicateLearningPathArgs = {
  input: EnterpriseBadge_DuplicateLearningPathInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_GenerateLearningObjectivesArgs = {
  input: EnterpriseBadge_GenerateLearningObjectivesInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_UpdateBadgeConfigurationsArgs = {
  input: EnterpriseBadge_UpdateBadgeConfigurationsInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_UpdateLearningPathActivitiesArgs = {
  input: EnterpriseBadge_UpdateLearningPathActivitiesInput;
};


/** Root Mutation type */
export type MutationEnterpriseBadge_UpdateLearningPathMetadataArgs = {
  input: EnterpriseBadge_UpdateLearningPathMetadataInput;
};


/** Root Mutation type */
export type MutationEnterpriseContentAssignment_CreateAssignmentsArgs = {
  input: EnterpriseContentAssignment_CreateAssignmentsInput;
};


/** Root Mutation type */
export type MutationEnterpriseContentAssignment_CreateAssignmentsForProgramsArgs = {
  input: EnterpriseContentAssignment_CreateAssignmentsForProgramsInput;
};


/** Root Mutation type */
export type MutationEnterpriseContentAssignment_DeleteAssignmentsArgs = {
  input: EnterpriseContentAssignment_DeleteAssignmentsInput;
};


/** Root Mutation type */
export type MutationEnterpriseContentAssignment_GenerateCsvUploadLocationArgs = {
  input: EnterpriseContentAssignment_GenerateCsvUploadLocationInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractBillingSchedule_DeleteBillingArgs = {
  input: EnterpriseContractBillingSchedule_DeleteBillingInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractBillingSchedule_ScheduleBillingArgs = {
  input: EnterpriseContractBillingSchedule_ScheduleBillingInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractInvoice_CreateInvoiceOrderArgs = {
  input: EnterpriseContractInvoice_CreateInvoiceOrderInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractInvoice_CreateInvoiceRenewalOrderArgs = {
  input: EnterpriseContractInvoice_CreateInvoiceRenewalOrderInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractInvoice_CreateInvoiceUpgradeOrderArgs = {
  input: EnterpriseContractInvoice_CreateInvoiceUpgradeOrderInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPolicy_CreateContractEndedPolicyArgs = {
  input: EnterpriseContractPolicy_CreateContractEndedPolicyInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPolicy_CreateContractFullyUtilizedPolicyArgs = {
  input: EnterpriseContractPolicy_CreateContractFullyUtilizedPolicyInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPolicy_DeleteContractPolicyArgs = {
  input: EnterpriseContractPolicy_DeleteContractPolicyInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPrice_CreatePricingDiscountRuleArgs = {
  input: EnterpriseContractPrice_CreatePricingDiscountRuleInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPrice_SendEstimateEmailArgs = {
  input: EnterpriseContractPrice_SendEstimateEmailInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractPrice_UpdatePricingDiscountRuleStatusArgs = {
  input: EnterpriseContractPrice_UpdatePricingDiscountRuleStatusInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractRenewal_ChangeAutoRenewAuthorizationArgs = {
  input: EnterpriseContractRenewal_ChangeAutoRenewAuthorizationInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractTag_AddTagArgs = {
  input: EnterpriseContractTag_AddTagInput;
};


/** Root Mutation type */
export type MutationEnterpriseContractTag_DeleteTagArgs = {
  input: EnterpriseContractTag_DeleteTagInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_ActivateContractArgs = {
  input: EnterpriseContract_ActivateContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_CreateContractArgs = {
  input: EnterpriseContract_CreateContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_DeactivateWithoutRefundArgs = {
  input: EnterpriseContract_DeactivateWithoutRefundInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_DowngradeContractArgs = {
  input: EnterpriseContract_DowngradeContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_HousekeepingArgs = {
  input: EnterpriseContract_HousekeepingInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_PauseContractArgs = {
  input: EnterpriseContract_PauseContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_ProvisionRenewalContractArgs = {
  input: EnterpriseContract_ProvisionRenewalContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_RefundContractArgs = {
  input: EnterpriseContract_RefundContractInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_TriggerRestoreJobArgs = {
  input: EnterpriseContract_TriggerRestoreJobInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateContractBillingTypeArgs = {
  input: EnterpriseContract_UpdateContractBillingTypeInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateContractEndsAtArgs = {
  input: EnterpriseContract_UpdateContractEndsAtInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateContractLimitsArgs = {
  input: EnterpriseContract_UpdateContractLimitsInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateContractNameArgs = {
  input: EnterpriseContract_UpdateContractNameInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateContractPurposeArgs = {
  input: EnterpriseContract_UpdateContractPurposeInput;
};


/** Root Mutation type */
export type MutationEnterpriseContract_UpdateScheduledActivationArgs = {
  input: EnterpriseContract_UpdateScheduledActivationInput;
};


/** Root Mutation type */
export type MutationEnterpriseCoupon_CreateForRenewalArgs = {
  input: EnterpriseCoupon_CreateForRenewalInput;
};


/** Root Mutation type */
export type MutationEnterpriseEnrollment_OrgSaveProductArgs = {
  input: EnterpriseEnrollment_OrgSaveProductInput;
};


/** Root Mutation type */
export type MutationEnterpriseEnrollment_OrgUnsaveProductArgs = {
  input: EnterpriseEnrollment_OrgUnsaveProductInput;
};


/** Root Mutation type */
export type MutationEnterpriseGradebooks_EnterpriseItemAttemptsGradebooksArgs = {
  input: EnterpriseGradebooks_EnterpriseItemAttemptsGradebooksInput;
};


/** Root Mutation type */
export type MutationEnterpriseGroup_CreateArgs = {
  input: EnterpriseGroup_CreateInput;
};


/** Root Mutation type */
export type MutationEnterpriseGroup_DeleteArgs = {
  input: EnterpriseGroup_DeleteInput;
};


/** Root Mutation type */
export type MutationEnterpriseInvoice_CreateSelfServeInvoiceArgs = {
  input: EnterpriseInvoice_CreateSelfServeInvoiceInput;
};


/** Root Mutation type */
export type MutationEnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlArgs = {
  input: EnterpriseInvoice_CreateSelfServeInvoiceForHostedUrlInput;
};


/** Root Mutation type */
export type MutationEnterpriseLead_CreateLeadArgs = {
  input: EnterpriseLead_CreateLeadInput;
};


/** Root Mutation type */
export type MutationEnterpriseLearnerCohort_CreateArgs = {
  input: EnterpriseLearnerCohort_CreateInput;
};


/** Root Mutation type */
export type MutationEnterpriseLearnerCohort_CreateAndFetchArgs = {
  input: EnterpriseLearnerCohort_CreateAndFetchInput;
};


/** Root Mutation type */
export type MutationEnterpriseLearnerProfile_DeleteAllByOrganizationArgs = {
  input: EnterpriseLearnerProfile_DeleteAllByOrganizationInput;
};


/** Root Mutation type */
export type MutationEnterpriseLearnerProfile_DeleteByOrganizationAndEmailsArgs = {
  input: EnterpriseLearnerProfile_DeleteByOrganizationAndEmailsInput;
};


/** Root Mutation type */
export type MutationEnterpriseMessages_GenerateUploadLocForManualListArgs = {
  input: EnterpriseMessages_GenerateUploadLocForManualListInput;
};


/** Root Mutation type */
export type MutationEnterpriseMessages_ScheduleScopedTriggerArgs = {
  input: EnterpriseMessages_ScheduleScopedTriggerInput;
};


/** Root Mutation type */
export type MutationEnterpriseMessages_UnscheduleScopedTriggerArgs = {
  input: EnterpriseMessages_UnscheduleScopedTriggerInput;
};


/** Root Mutation type */
export type MutationEnterprisePermission_DeleteAdminArgs = {
  input: EnterprisePermission_DeleteAdminInput;
};


/** Root Mutation type */
export type MutationEnterprisePermission_UpdateUserRolesArgs = {
  input: EnterprisePermission_UpdateUserRolesInput;
};


/** Root Mutation type */
export type MutationEnterprisePrivateCourses_AddToProgramArgs = {
  input: EnterprisePrivateCourses_AddToProgramInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_ArchiveArgs = {
  input: EnterpriseProgram_ArchiveInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_CreateArgs = {
  input: EnterpriseProgram_CreateInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_GenerateProgramFileUploadLocationArgs = {
  input: EnterpriseProgram_GenerateProgramFileUploadLocationInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_GenerateProgramOutlineArgs = {
  input: EnterpriseProgram_GenerateProgramOutlineInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_GenerateProgramSuggestionsArgs = {
  input: EnterpriseProgram_GenerateProgramSuggestionsInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_LinkProgramWithGenerationRequestsArgs = {
  input: EnterpriseProgram_LinkProgramWithGenerationRequestsInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_UpdateArgs = {
  input: EnterpriseProgram_UpdateInput;
};


/** Root Mutation type */
export type MutationEnterpriseProgram_UpdateSkillsetsArgs = {
  input: EnterpriseProgram_UpdateSkillsetsInput;
};


/** Root Mutation type */
export type MutationEnterprisePromotion_CreateArgs = {
  input: EnterprisePromotion_CreateInput;
};


/** Root Mutation type */
export type MutationEnterprisePromotion_DeleteArgs = {
  input: EnterprisePromotion_DeleteInput;
};


/** Root Mutation type */
export type MutationEnterprisePromotion_UpdateArgs = {
  input: EnterprisePromotion_UpdateInput;
};


/** Root Mutation type */
export type MutationEnterpriseReports_DeleteScheduleArgs = {
  input: EnterpriseReports_DeleteScheduleInput;
};


/** Root Mutation type */
export type MutationEnterpriseReports_ExportReportArgs = {
  input: EnterpriseReports_ExportReportInput;
};


/** Root Mutation type */
export type MutationEnterpriseReports_SaveScheduleArgs = {
  input: EnterpriseReports_SaveScheduleInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_ConfigureScimArgs = {
  input: EnterpriseScim_ConfigureScimInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_GenerateTokenArgs = {
  input: EnterpriseScim_GenerateTokenInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_RevokeTokenArgs = {
  input: EnterpriseScim_RevokeTokenInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_UpdateGroupProgramMappingsArgs = {
  input: EnterpriseScim_UpdateGroupProgramMappingsInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_UpdateScimStatusArgs = {
  input: EnterpriseScim_UpdateScimStatusInput;
};


/** Root Mutation type */
export type MutationEnterpriseScim_UpdateShouldSendInviteMailArgs = {
  input: EnterpriseScim_UpdateShouldSendInviteMailInput;
};


/** Root Mutation type */
export type MutationEnterpriseSetting_UpdateArgs = {
  input: EnterpriseSetting_UpdateInput;
};


/** Root Mutation type */
export type MutationEnterpriseSummaryReports_DeleteScheduleArgs = {
  input: EnterpriseSummaryReports_DeleteScheduleInput;
};


/** Root Mutation type */
export type MutationEnterpriseSummaryReports_ExportReportArgs = {
  input: EnterpriseSummaryReports_ExportReportInput;
};


/** Root Mutation type */
export type MutationEnterpriseSummaryReports_SaveScheduleArgs = {
  input: EnterpriseSummaryReports_SaveScheduleInput;
};


/** Root Mutation type */
export type MutationEnterpriseUsers_FullUpdateUserDataArgs = {
  input: EnterpriseUsers_FullUpdateUserDataInput;
};


/** Root Mutation type */
export type MutationEnterpriseUsers_ResendVerificationEmailArgs = {
  input: EnterpriseUsers_ResendVerificationEmailInput;
};


/** Root Mutation type */
export type MutationEpic_CreateExperimentArgs = {
  input: Epic_CreateExperimentInput;
};


/** Root Mutation type */
export type MutationEpic_UpdateExperimentArgs = {
  input: Epic_UpdateExperimentInput;
};


/** Root Mutation type */
export type MutationExamRecording_EndRecordingArgs = {
  input: ExamRecording_EndRecordingInput;
};


/** Root Mutation type */
export type MutationExamRecording_InitializeChunkArgs = {
  input: ExamRecording_InitializeChunkInput;
};


/** Root Mutation type */
export type MutationExamRecording_InitializeSegmentArgs = {
  input: ExamRecording_InitializeSegmentInput;
};


/** Root Mutation type */
export type MutationExamRecording_ReprocessRecordingsArgs = {
  input: ExamRecording_ReprocessRecordingsInput;
};


/** Root Mutation type */
export type MutationExportItemFeedback_StartExportItemFeedbackJobArgs = {
  input: ExportItemFeedback_StartExportItemFeedbackJobInput;
};


/** Root Mutation type */
export type MutationExternalIntegration_CreateIntegrationConfigurationArgs = {
  input: ExternalIntegration_CreateIntegrationConfigurationInput;
};


/** Root Mutation type */
export type MutationExternalIntegration_DeleteIntegrationConfigurationArgs = {
  input: ExternalIntegration_DeleteIntegrationConfigurationInput;
};


/** Root Mutation type */
export type MutationExternalIntegration_UpdateIntegrationConfigurationArgs = {
  input: ExternalIntegration_UpdateIntegrationConfigurationInput;
};


/** Root Mutation type */
export type MutationExternalIntegration_ValidateIntegrationConfigurationArgs = {
  input: ExternalIntegration_ValidateIntegrationConfigurationInput;
};


/** Root Mutation type */
export type MutationFinancialAidApplication_ApproveArgs = {
  input: FinancialAidApplication_ApproveInput;
};


/** Root Mutation type */
export type MutationFinancialAidApplication_CreateArgs = {
  input: FinancialAidApplication_CreateInput;
};


/** Root Mutation type */
export type MutationFlashcards_SetOptOutArgs = {
  input: Flashcards_SetOptOutInput;
};


/** Root Mutation type */
export type MutationGradedItemLocking_UpdateEnablementArgs = {
  input: Array<GradedItemLocking_UpdateEnablementInput>;
};


/** Root Mutation type */
export type MutationGradedPlugin_SetLearnerPluginGradeArgs = {
  input: GradedPlugin_SetLearnerPluginGradeInput;
};


/** Root Mutation type */
export type MutationGraderPerformance_RefreshGroupMetricsArgs = {
  input: GraderPerformance_RefreshGroupMetricsInput;
};


/** Root Mutation type */
export type MutationGraderPerformance_SaveDashboardSessionSettingsArgs = {
  input: GraderPerformance_SaveDashboardSessionSettingsInput;
};


/** Root Mutation type */
export type MutationGradingComments_CreateCommentArgs = {
  input?: InputMaybe<GradingComments_CreateCommentInput>;
};


/** Root Mutation type */
export type MutationGradingComments_CreateCommentUsageArgs = {
  input?: InputMaybe<GradingComments_CreateCommentUsageInput>;
};


/** Root Mutation type */
export type MutationGradingComments_DeleteCommentArgs = {
  input?: InputMaybe<GradingComments_DeleteCommentInput>;
};


/** Root Mutation type */
export type MutationGradingComments_DeleteCommentUsagesArgs = {
  input: GradingComments_DeleteCommentUsagesInput;
};


/** Root Mutation type */
export type MutationGradingComments_UpdateCommentArgs = {
  input?: InputMaybe<GradingComments_UpdateCommentInput>;
};


/** Root Mutation type */
export type MutationGroupGrading_ApplyGradeOverrideArgs = {
  input: GroupGrading_ApplyGradeOverrideInput;
};


/** Root Mutation type */
export type MutationGroupGrading_ApplyGradeOverrideV2Args = {
  input: GroupGrading_ApplyGradeOverrideV2Input;
};


/** Root Mutation type */
export type MutationGroupGrading_BatchUpdateGradeVisibilityArgs = {
  input: GroupGrading_BatchUpdateGradeVisibilityInput;
};


/** Root Mutation type */
export type MutationGroupGrading_BatchUpdateReviewPartResponseArgs = {
  input: GroupGrading_BatchUpdateReviewPartResponseInput;
};


/** Root Mutation type */
export type MutationGroupGrading_BatchUpdateReviewPartResponsesArgs = {
  input: GroupGrading_BatchUpdateReviewPartResponsesInput;
};


/** Root Mutation type */
export type MutationGroupGrading_DeleteGradeOverrideArgs = {
  input: GroupGrading_DeleteGradeOverrideInput;
};


/** Root Mutation type */
export type MutationGroupGrading_DeleteGradeOverrideV2Args = {
  input: GroupGrading_DeleteGradeOverrideV2Input;
};


/** Root Mutation type */
export type MutationGroupGrading_PublishGradesToGradeBookArgs = {
  input: GroupGrading_PublishGradesToGradeBookInput;
};


/** Root Mutation type */
export type MutationGroupGrading_SubmitGradesToGradeBookArgs = {
  input: GroupGrading_SubmitGradesToGradeBookInput;
};


/** Root Mutation type */
export type MutationGroupGrading_UpdateGradeVisibilityArgs = {
  input: GroupGrading_UpdateGradeVisibilityInput;
};


/** Root Mutation type */
export type MutationGroupGrading_UpdateReviewPartResponseChoicesArgs = {
  input: GroupGrading_UpdateReviewPartResponseChoicesInput;
};


/** Root Mutation type */
export type MutationGroupGrading_UpdateReviewPartResponseCommentArgs = {
  input: GroupGrading_UpdateReviewPartResponseCommentInput;
};


/** Root Mutation type */
export type MutationGroupGrading_UpdateReviewPartResponseScoreArgs = {
  input: GroupGrading_UpdateReviewPartResponseScoreInput;
};


/** Root Mutation type */
export type MutationIMochaAssessment_GenerateTestLinkArgs = {
  input: IMochaAssessment_GenerateTestLinkInput;
};


/** Root Mutation type */
export type MutationInLabInstructions_MarkInstructionAsCompleteArgs = {
  input: InLabInstructions_MarkInstructionAsCompleteInput;
};


/** Root Mutation type */
export type MutationInjectableActivities_DirectlyTriggerInjectionConfigurationArgs = {
  input: InjectableActivities_DirectlyTriggerInjectionConfigurationInput;
};


/** Root Mutation type */
export type MutationInjectableActivities_ProvisionProactiveAiExperimentArgs = {
  input: InjectableActivities_ProvisionProactiveAiExperimentInput;
};


/** Root Mutation type */
export type MutationInjectableActivities_UpdateInjectableActivityProgressArgs = {
  input: InjectableActivities_UpdateInjectableActivityProgressInput;
};


/** Root Mutation type */
export type MutationInstitutionStaffInvitation_AcceptInvitationArgs = {
  input: InstitutionStaffInvitation_AcceptInvitationInput;
};


/** Root Mutation type */
export type MutationInstitutionStaffInvitation_InviteStaffByEmailsArgs = {
  input: InstitutionStaffInvitation_InviteStaffByEmailsInput;
};


/** Root Mutation type */
export type MutationInstitutionStaffInvitation_RevokeInvitationsArgs = {
  input: InstitutionStaffInvitation_RevokeInvitationsInput;
};


/** Root Mutation type */
export type MutationIntlCompliance_RecurringChargeConsentArgs = {
  input: IntlCompliance_RecurringChargeConsentInput;
};


/** Root Mutation type */
export type MutationItemAuthoring_DiscardItemDraftArgs = {
  input: ItemAuthoring_DiscardItemDraftInput;
};


/** Root Mutation type */
export type MutationItemPersonalization_CreateItemPersonalizationArgs = {
  input: ItemPersonalization_CreateItemPersonalizationInput;
};


/** Root Mutation type */
export type MutationItemProgress_ItemStateRefreshByBranchArgs = {
  input: ItemProgress_ItemStateRefreshByBranchInput;
};


/** Root Mutation type */
export type MutationItemProgress_ItemStateRefreshByCourseArgs = {
  input: ItemProgress_ItemStateRefreshByCourseInput;
};


/** Root Mutation type */
export type MutationItemPublishComments_DeleteItemPublishCommentArgs = {
  input: ItemPublishComments_DeleteItemPublishCommentInput;
};


/** Root Mutation type */
export type MutationItemPublishComments_SaveItemPublishCommentArgs = {
  input: ItemPublishComments_SaveItemPublishCommentInput;
};


/** Root Mutation type */
export type MutationJwtLogins_CreateJwtLoginArgs = {
  input: JwtLogins_CreateJwtLoginInput;
};


/** Root Mutation type */
export type MutationJwtLogins_LoginWithInvitationTokenArgs = {
  input: JwtLogins_LoginWithInvitationTokenInput;
};


/** Root Mutation type */
export type MutationLabRecording_CleanupArgs = {
  input: LabRecording_CleanupInput;
};


/** Root Mutation type */
export type MutationLabRecording_ContinueArgs = {
  input: LabRecording_ContinueInput;
};


/** Root Mutation type */
export type MutationLabRecording_ExportArgs = {
  input: LabRecording_ExportInput;
};


/** Root Mutation type */
export type MutationLabRecording_PauseArgs = {
  input: LabRecording_PauseInput;
};


/** Root Mutation type */
export type MutationLabRecording_StartArgs = {
  input: LabRecording_StartInput;
};


/** Root Mutation type */
export type MutationLaunchLab_PrepareArgs = {
  input: LaunchLab_PrepareInput;
};


/** Root Mutation type */
export type MutationLearnerCalendars_CreateLearnerCalendarArgs = {
  input: LearnerCalendars_CreateLearnerCalendarInput;
};


/** Root Mutation type */
export type MutationLearnerCalendars_ToggleShouldDisplayContentArgs = {
  input: LearnerCalendars_ToggleShouldDisplayContentInput;
};


/** Root Mutation type */
export type MutationLearnerGoals_EditWeeklyGoalArgs = {
  input: LearnerGoals_EditWeeklyGoalInput;
};


/** Root Mutation type */
export type MutationLearnerGoals_SetMacroGoalArgs = {
  input: LearnerGoals_SetMacroGoalInput;
};


/** Root Mutation type */
export type MutationLearnerGoals_SetWeeklyGoalArgs = {
  input: LearnerGoals_SetWeeklyGoalInput;
};


/** Root Mutation type */
export type MutationLearnerInterest_SetLearnerInterestArgs = {
  input: LearnerInterest_SetLearnerInterestInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateBirthdayArgs = {
  input: LearnerObject_UpdateBirthdayInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateCurrentOccupationArgs = {
  input: LearnerObject_UpdateCurrentOccupationInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateEducationProfileArgs = {
  input: LearnerObject_UpdateEducationProfileInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateFullNameArgs = {
  input: LearnerObject_UpdateFullNameInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateInterestedCareersArgs = {
  input: LearnerObject_UpdateInterestedCareersInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateLastIndicatedUnsureRolesAtArgs = {
  input: LearnerObject_UpdateLastIndicatedUnsureRolesAtInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateLastIndicatedUnsureSkillsAtArgs = {
  input: LearnerObject_UpdateLastIndicatedUnsureSkillsAtInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateLearningGoalArgs = {
  input: LearnerObject_UpdateLearningGoalInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateLocaleArgs = {
  input: LearnerObject_UpdateLocaleInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateLocationArgs = {
  input: LearnerObject_UpdateLocationInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateMostRecentCourseCompletionArgs = {
  input: LearnerObject_UpdateMostRecentCourseCompletionInput;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateSkillsWantedV2Args = {
  input: LearnerObject_UpdateSkillsWantedV2Input;
};


/** Root Mutation type */
export type MutationLearnerObject_UpdateTimezoneArgs = {
  input: LearnerObject_UpdateTimezoneInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_AddSkillArgs = {
  input: LearnerOnboarding_AddSkillInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_RemoveResponseArgs = {
  input: LearnerOnboarding_RemoveResponseInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_SetModularOnboardingInteractionArgs = {
  input: LearnerOnboarding_SetModularOnboardingInteractionInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_SetOnboardingSeenArgs = {
  input?: InputMaybe<LearnerOnboarding_SetOnboardingSeenInput>;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_UpdateInterestedSkillsArgs = {
  input: LearnerOnboarding_UpdateInterestedSkillsInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_UpdateRemindMeByTimeArgs = {
  input: LearnerOnboarding_UpdateRemindMeByTimeInput;
};


/** Root Mutation type */
export type MutationLearnerOnboarding_UpdateRoleArgs = {
  input: LearnerOnboarding_UpdateRoleInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_AddTermArgs = {
  input: LearnerPlan_AddTermInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_CreatePlanArgs = {
  input: LearnerPlan_CreatePlanInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_DeletePlanArgs = {
  input: LearnerPlan_DeletePlanInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_MoveCourseArgs = {
  input: LearnerPlan_MoveCourseInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_RemoveTermArgs = {
  input: LearnerPlan_RemoveTermInput;
};


/** Root Mutation type */
export type MutationLearnerPlan_UpdateTermArgs = {
  input: LearnerPlan_UpdateTermInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchAdditionalInfoArgs = {
  input: LearnerProfile_PatchAdditionalInfoInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchDomainsArgs = {
  input: LearnerProfile_PatchDomainsInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchEducationArgs = {
  input: LearnerProfile_PatchEducationInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchPersonalInformationArgs = {
  input?: InputMaybe<LearnerProfile_PatchPersonalInformationInput>;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchPrivacySettingsArgs = {
  input: LearnerProfile_PatchPrivacySettingsInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchProfileSlugArgs = {
  input: LearnerProfile_PatchProfileSlugInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchSkillsArgs = {
  input: LearnerProfile_PatchSkillsInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchWorkExperienceArgs = {
  input: LearnerProfile_PatchWorkExperienceInput;
};


/** Root Mutation type */
export type MutationLearnerProfile_PatchWorkPreferencesArgs = {
  input: LearnerProfile_PatchWorkPreferencesInput;
};


/** Root Mutation type */
export type MutationLearningHours_SendEventArgs = {
  input: LearningHours_SendEventInput;
};


/** Root Mutation type */
export type MutationLectureAuthoring_AutoPublishLectureDraftArgs = {
  input: LectureAuthoring_AutoPublishLectureDraftInput;
};


/** Root Mutation type */
export type MutationLectureAuthoring_DeleteLectureDraftArgs = {
  input: LectureAuthoring_DeleteLectureDraftInput;
};


/** Root Mutation type */
export type MutationLectureAuthoring_UpdateLectureDraftArgs = {
  input: LectureAuthoring_UpdateLectureDraftInput;
};


/** Root Mutation type */
export type MutationLevelSetAttempts_ResetAttemptsArgs = {
  input: LevelSetAttempts_ResetAttemptsInput;
};


/** Root Mutation type */
export type MutationLevelSet_StartAttemptArgs = {
  input: LevelSet_StartAttemptInput;
};


/** Root Mutation type */
export type MutationLevelSet_SubmitAttemptArgs = {
  input: LevelSet_SubmitAttemptInput;
};


/** Root Mutation type */
export type MutationLexExperimentEvents_CreateEventArgs = {
  input: LexExperimentEvents_CreateEventInput;
};


/** Root Mutation type */
export type MutationLexExperimentEvents_DeleteEventArgs = {
  input: LexExperimentEvents_DeleteEventInput;
};


/** Root Mutation type */
export type MutationLocalization_CreateExperimentConfigurationArgs = {
  input: Localization_CreateExperimentConfigurationInput;
};


/** Root Mutation type */
export type MutationLocalization_CreateStatsigExperimentArgs = {
  input: Localization_CreateStatsigExperimentInput;
};


/** Root Mutation type */
export type MutationLocalization_UpdateStatsigExperimentArgs = {
  input: Localization_UpdateStatsigExperimentInput;
};


/** Root Mutation type */
export type MutationLockingBrowser_UpdateExclusionsArgs = {
  input: LockingBrowser_UpdateExclusionsInput;
};


/** Root Mutation type */
export type MutationLockingBrowser_UpdateSettingsArgs = {
  input: LockingBrowser_UpdateSettingsInput;
};


/** Root Mutation type */
export type MutationLowStakesLearningTools_ArchivePracticeArgs = {
  input: LowStakesLearningTools_ArchivePracticeInput;
};


/** Root Mutation type */
export type MutationLowStakesLearning_CompleteFlashcardsArgs = {
  input: LowStakesLearning_CompleteFlashcardsInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateCuratedAppExternalAppRegistrationV13Args = {
  input: LtiPlatform_CreateCuratedAppExternalAppRegistrationV13Input;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateCuratedExternalAppDeploymentForPartnerArgs = {
  input: LtiPlatform_CreateCuratedExternalAppDeploymentForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateExternalAppDeploymentV11ForCourseArgs = {
  input: LtiPlatform_CreateExternalAppDeploymentV11ForCourseInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateExternalAppDeploymentV11ForPartnerArgs = {
  input: LtiPlatform_CreateExternalAppDeploymentV11ForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateExternalAppDeploymentV13ForCourseArgs = {
  input: LtiPlatform_CreateExternalAppDeploymentV13ForCourseInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_CreateExternalAppDeploymentV13ForPartnerArgs = {
  input: LtiPlatform_CreateExternalAppDeploymentV13ForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppDeploymentForCourseArgs = {
  input: LtiPlatform_UpdateExternalAppDeploymentForCourseInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppDeploymentForPartnerArgs = {
  input: LtiPlatform_UpdateExternalAppDeploymentForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppRegistrationV11ForCourseArgs = {
  input: LtiPlatform_UpdateExternalAppRegistrationV11ForCourseInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppRegistrationV11ForPartnerArgs = {
  input: LtiPlatform_UpdateExternalAppRegistrationV11ForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppRegistrationV13ForCourseArgs = {
  input: LtiPlatform_UpdateExternalAppRegistrationV13ForCourseInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateExternalAppRegistrationV13ForPartnerArgs = {
  input: LtiPlatform_UpdateExternalAppRegistrationV13ForPartnerInput;
};


/** Root Mutation type */
export type MutationLtiPlatform_UpdateLtiDraftArgs = {
  input: LtiPlatform_UpdateLtiDraftInput;
};


/** Root Mutation type */
export type MutationLtiTool_AddPlatformConfigArgs = {
  input: LtiTool_AddPlatformConfigInput;
};


/** Root Mutation type */
export type MutationLtiTool_AddToolMetadataArgs = {
  input: LtiTool_AddToolMetadataInput;
};


/** Root Mutation type */
export type MutationLtiTool_BackfillLmsNamesArgs = {
  input: LtiTool_BackfillLmsNamesInput;
};


/** Root Mutation type */
export type MutationLtiTool_DeepLinkingSubmitArgs = {
  input: LtiTool_DeepLinkingSubmitInput;
};


/** Root Mutation type */
export type MutationLtiTool_DeleteCourseShellItemArgs = {
  input: LtiTool_DeleteCourseShellItemInput;
};


/** Root Mutation type */
export type MutationLtiTool_DeletePlatformConfigArgs = {
  input: LtiTool_DeletePlatformConfigInput;
};


/** Root Mutation type */
export type MutationLtiTool_GenerateDynamicRegistrationUrlArgs = {
  input: LtiTool_GenerateDynamicRegistrationUrlInput;
};


/** Root Mutation type */
export type MutationLtiTool_UpdateCourseShellDueDateArgs = {
  input: LtiTool_UpdateCourseShellDueDateInput;
};


/** Root Mutation type */
export type MutationLtiTool_UpdateOrgConfigArgs = {
  input: LtiTool_UpdateOrgConfigInput;
};


/** Root Mutation type */
export type MutationLtiTool_UpdateRegistrationProgramAccessControlArgs = {
  input: LtiTool_UpdateRegistrationProgramAccessControlInput;
};


/** Root Mutation type */
export type MutationMcpApps_CreateMcpAppArgs = {
  input: McpApps_CreateMcpAppInput;
};


/** Root Mutation type */
export type MutationMcpApps_DeleteMcpAppArgs = {
  input: McpApps_DeleteMcpAppInput;
};


/** Root Mutation type */
export type MutationMcpApps_EditMcpAppArgs = {
  input: McpApps_EditMcpAppInput;
};


/** Root Mutation type */
export type MutationNotificationPreference_UpdatePreferencesByTokenArgs = {
  input: NotificationPreference_UpdatePreferencesByTokenInput;
};


/** Root Mutation type */
export type MutationOtp_SendOtpArgs = {
  input: Otp_SendOtpInput;
};


/** Root Mutation type */
export type MutationOpenCourseAsset_CreateOpenCourseAssetArgs = {
  input: OpenCourseAsset_CreateOpenCourseAssetInput;
};


/** Root Mutation type */
export type MutationOpenCourseAsset_UpdateOpenCourseAssetArgs = {
  input: OpenCourseAsset_UpdateOpenCourseAssetInput;
};


/** Root Mutation type */
export type MutationOrgApiKey_CreateArgs = {
  input: OrgApiKey_CreateInput;
};


/** Root Mutation type */
export type MutationOrgApiKey_RevokeArgs = {
  input: OrgApiKey_RevokeInput;
};


/** Root Mutation type */
export type MutationOrgCollection_AddCollectionToProgramsArgs = {
  input: OrgCollection_AddCollectionToProgramsInput;
};


/** Root Mutation type */
export type MutationOrgCollection_ArchiveCollectionArgs = {
  input: OrgCollection_ArchiveCollectionInput;
};


/** Root Mutation type */
export type MutationOrgCollection_CreateCollectionArgs = {
  input: OrgCollection_CreateCollectionInput;
};


/** Root Mutation type */
export type MutationOrgCollection_RemoveCollectionFromProgramsArgs = {
  input: OrgCollection_RemoveCollectionFromProgramsInput;
};


/** Root Mutation type */
export type MutationOrgVerifiedDomain_CreateArgs = {
  input: OrgVerifiedDomain_CreateInput;
};


/** Root Mutation type */
export type MutationOrgVerifiedDomain_DeleteArgs = {
  input: OrgVerifiedDomain_DeleteInput;
};


/** Root Mutation type */
export type MutationOrgVerifiedDomain_VerifyArgs = {
  input: OrgVerifiedDomain_VerifyInput;
};


/** Root Mutation type */
export type MutationOwnableProduct_UpsertOwnableProductPartnerRevshareRecordsArgs = {
  input: OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsInput;
};


/** Root Mutation type */
export type MutationPartnerApproval_ApproveOrRejectAllChangesArgs = {
  input: PartnerApproval_ApproveOrRejectAllChangesInput;
};


/** Root Mutation type */
export type MutationPartnerApproval_ApproveOrRejectChangeArgs = {
  input: PartnerApproval_ApproveOrRejectChangeInput;
};


/** Root Mutation type */
export type MutationPartnerApproval_StartImplementingAiGeneratedRecommendationsArgs = {
  input: PartnerApproval_StartImplementingAiGeneratedRecommendationsInput;
};


/** Root Mutation type */
export type MutationPartnerApproval_SubmitForApprovalArgs = {
  input: PartnerApproval_SubmitForApprovalInput;
};


/** Root Mutation type */
export type MutationPaymentProcessor_CreatePaymentMethodArgs = {
  input: PaymentProcessor_CreatePaymentMethodInput;
};


/** Root Mutation type */
export type MutationPaymentProcessor_DeletePaymentMethodArgs = {
  input: PaymentProcessor_DeletePaymentMethodInput;
};


/** Root Mutation type */
export type MutationPaymentProcessor_PreCreatePaymentMethodArgs = {
  input: PaymentProcessor_PreCreatePaymentMethodInput;
};


/** Root Mutation type */
export type MutationPaymentProcessor_UpdatePaymentMethodArgs = {
  input: PaymentProcessor_UpdatePaymentMethodInput;
};


/** Root Mutation type */
export type MutationPaymentsCheckout_InitializeCheckoutIntentArgs = {
  input: PaymentsCheckout_InitializeCheckoutIntentInput;
};


/** Root Mutation type */
export type MutationPaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodArgs = {
  input: PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodInput;
};


/** Root Mutation type */
export type MutationPaymentsCheckout_SubmitCheckoutIntentArgs = {
  input: PaymentsCheckout_SubmitCheckoutIntentInput;
};


/** Root Mutation type */
export type MutationPaymentsCheckout_UpdateCheckoutIntentArgs = {
  input: PaymentsCheckout_UpdateCheckoutIntentInput;
};


/** Root Mutation type */
export type MutationPedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationArgs = {
  input: PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationInput;
};


/** Root Mutation type */
export type MutationPeerReviewAi_RequestGradingByPeerArgs = {
  input: PeerReviewAi_RequestGradingByPeerInput;
};


/** Root Mutation type */
export type MutationPeerReviewAi_SaveUserFeedbackArgs = {
  input: PeerReviewAi_SaveUserFeedbackInput;
};


/** Root Mutation type */
export type MutationPeerReviewMigration_ConvertPeerReviewToAiAssignmentArgs = {
  input: PeerReviewMigration_ConvertPeerReviewToAiAssignmentInput;
};


/** Root Mutation type */
export type MutationPersonalizedPlans_AddProductArgs = {
  input: PersonalizedPlans_AddProductInput;
};


/** Root Mutation type */
export type MutationPersonalizedPlans_RemoveProductArgs = {
  input: PersonalizedPlans_RemoveProductInput;
};


/** Root Mutation type */
export type MutationPersonalizedPlans_ReorderProductsArgs = {
  input: PersonalizedPlans_ReorderProductsInput;
};


/** Root Mutation type */
export type MutationPersonalizedPlans_RetryGenerationArgs = {
  input: PersonalizedPlans_RetryGenerationInput;
};


/** Root Mutation type */
export type MutationPhraseCourseConfig_RemoveByBatchNameArgs = {
  input: PhraseCourseConfig_RemoveByBatchNameInput;
};


/** Root Mutation type */
export type MutationPhraseCourseConfig_ValidateAndSaveArgs = {
  input: PhraseCourseConfig_ValidateAndSaveInput;
};


/** Root Mutation type */
export type MutationProctor_CreateOverrideForAssignmentSubmitterArgs = {
  input: Proctor_OverrideSubmitterProctorConfigInput;
};


/** Root Mutation type */
export type MutationProfileConsents_AddProfileConsentsArgs = {
  input: ProfileConsents_AddProfileConsentsInput;
};


/** Root Mutation type */
export type MutationProgramInvitationsDomainAllowList_MultiDeleteArgs = {
  input?: InputMaybe<ProgramInvitationsDomainAllowList_MultiDeleteInput>;
};


/** Root Mutation type */
export type MutationProgramInvitationsDomainAllowList_MultiUpdateArgs = {
  input?: InputMaybe<ProgramInvitationsDomainAllowList_MultiUpdateInput>;
};


/** Root Mutation type */
export type MutationProgramInvitations_AcceptInvitationArgs = {
  input: ProgramInvitations_AcceptInvitationInput;
};


/** Root Mutation type */
export type MutationProgramInvitations_AddUsersToProgramArgs = {
  input: ProgramInvitations_AddUsersToProgramInput;
};


/** Root Mutation type */
export type MutationProgramInvitations_CreateInvitationArgs = {
  input: ProgramInvitations_CreateInvitationInput;
};


/** Root Mutation type */
export type MutationProgramInvitations_MultiDeleteInvitationsArgs = {
  input: ProgramInvitations_MultiDeleteInvitationsInput;
};


/** Root Mutation type */
export type MutationProgramInvitations_TriggerExpiryJobArgs = {
  input: ProgramInvitations_TriggerExpiryJobInput;
};


/** Root Mutation type */
export type MutationProgramMembership_JoinArgs = {
  input: ProgramMembership_JoinInput;
};


/** Root Mutation type */
export type MutationProgramMembership_JoinAllPendingForOrgArgs = {
  input: ProgramMembership_JoinAllPendingForOrgInput;
};


/** Root Mutation type */
export type MutationProgramMembership_ResendVerificationEmailArgs = {
  input: ProgramMembership_ResendVerificationEmailInput;
};


/** Root Mutation type */
export type MutationProgramming_CreateAttemptOverrideArgs = {
  input: Programming_CreateAttemptOverrideInput;
};


/** Root Mutation type */
export type MutationPromotions_CreatePromotionArgs = {
  input: Promotions_CreatePromotionInput;
};


/** Root Mutation type */
export type MutationPromotions_CreatePromotionUserEligibleRuleArgs = {
  input: Promotions_CreatePromotionUserEligibleRuleInput;
};


/** Root Mutation type */
export type MutationPromotions_ExportCodeBatchArgs = {
  input: Promotions_ExportCodeBatchInput;
};


/** Root Mutation type */
export type MutationPromotions_GenerateCodeBatchArgs = {
  input: Promotions_GenerateCodeBatchInput;
};


/** Root Mutation type */
export type MutationPromotions_UpdatePromotionArgs = {
  input: Promotions_UpdatePromotionInput;
};


/** Root Mutation type */
export type MutationPromotions_UpdatePromotionUserEligibleRuleArgs = {
  input: Promotions_UpdatePromotionUserEligibleRuleInput;
};


/** Root Mutation type */
export type MutationQualificationSurveyExperiment_DeleteQualificationSurveyExperimentArgs = {
  input: QualificationSurveyExperiment_DeleteQualificationSurveyExperimentInput;
};


/** Root Mutation type */
export type MutationQualificationSurveyExperiment_UpdateQualificationSurveyExperimentArgs = {
  input: QualificationSurveyExperiment_UpdateQualificationSurveyExperimentInput;
};


/** Root Mutation type */
export type MutationQualificationSurveySectionResponse_CreateOrUpdateArgs = {
  input: QualificationSurveySectionResponse_CreateOrUpdateInput;
};


/** Root Mutation type */
export type MutationQualificationSurveySectionResponse_DeleteByResponseIdsArgs = {
  input: QualificationSurveySectionResponse_DeleteByResponseIdsInput;
};


/** Root Mutation type */
export type MutationQualificationSurvey_CreateQualificationSurveyArgs = {
  input: QualificationSurvey_CreateQualificationSurveyInput;
};


/** Root Mutation type */
export type MutationQualificationSurvey_UpdateQualificationSurveyArgs = {
  input: QualificationSurvey_UpdateQualificationSurveyInput;
};


/** Root Mutation type */
export type MutationQualityCoach_CreateQualityRuleArgs = {
  input: QualityCoach_CreateQualityRuleInput;
};


/** Root Mutation type */
export type MutationQualityCoach_DeleteQualityRuleArgs = {
  input: QualityCoach_DeleteQualityRuleInput;
};


/** Root Mutation type */
export type MutationQualityCoach_InitiateQualityReviewForEntityArgs = {
  input: QualityCoach_InitiateQualityReviewForEntityInput;
};


/** Root Mutation type */
export type MutationQualityCoach_UpdateQualityRuleArgs = {
  input: QualityCoach_UpdateQualityRuleInput;
};


/** Root Mutation type */
export type MutationQuestionBank_AddQuestionCategoriesArgs = {
  input: QuestionBank_AddQuestionCategoriesInput;
};


/** Root Mutation type */
export type MutationQuestionBank_AddQuestionCategoriesV2Args = {
  input: QuestionBank_AddQuestionCategoriesV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_AddQuestionsArgs = {
  input: QuestionBank_AddQuestionsInput;
};


/** Root Mutation type */
export type MutationQuestionBank_AddQuestionsV2Args = {
  input: QuestionBank_AddQuestionsV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_CascadingPublishTransactionCreateArgs = {
  input: QuestionBank_CascadingPublishTransactionCreateInput;
};


/** Root Mutation type */
export type MutationQuestionBank_CascadingPublishTransactionExecuteArgs = {
  input: QuestionBank_CascadingPublishTransactionExecuteInput;
};


/** Root Mutation type */
export type MutationQuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateArgs = {
  input: QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateInput;
};


/** Root Mutation type */
export type MutationQuestionBank_CreateDraftArgs = {
  input: QuestionBank_CreateDraftInput;
};


/** Root Mutation type */
export type MutationQuestionBank_LinkArgs = {
  input: QuestionBank_LinkInput;
};


/** Root Mutation type */
export type MutationQuestionBank_MergeQuestionsArgs = {
  input: QuestionBank_MergeQuestionsInput;
};


/** Root Mutation type */
export type MutationQuestionBank_MergeQuestionsV2Args = {
  input: QuestionBank_MergeQuestionsV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveAllQuestionsArgs = {
  input: QuestionBank_RemoveAllQuestionsInput;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveAllQuestionsV2Args = {
  input: QuestionBank_RemoveAllQuestionsV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveQuestionCategoriesArgs = {
  input: QuestionBank_RemoveQuestionCategoriesInput;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveQuestionCategoriesV2Args = {
  input: QuestionBank_RemoveQuestionCategoriesV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveQuestionsArgs = {
  input: QuestionBank_RemoveQuestionsInput;
};


/** Root Mutation type */
export type MutationQuestionBank_RemoveQuestionsV2Args = {
  input: QuestionBank_RemoveQuestionsV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_RevertDraftArgs = {
  input: QuestionBank_RevertDraftInput;
};


/** Root Mutation type */
export type MutationQuestionBank_UnlinkArgs = {
  input: QuestionBank_UnlinkInput;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateBankArgs = {
  input: QuestionBank_UpdateBankInput;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateBankV2Args = {
  input: QuestionBank_UpdateBankV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateQuestionCategoriesArgs = {
  input: QuestionBank_UpdateQuestionCategoriesInput;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateQuestionCategoriesV2Args = {
  input: QuestionBank_UpdateQuestionCategoriesV2Input;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateQuestionsArgs = {
  input: QuestionBank_UpdateQuestionsInput;
};


/** Root Mutation type */
export type MutationQuestionBank_UpdateQuestionsV2Args = {
  input: QuestionBank_UpdateQuestionsV2Input;
};


/** Root Mutation type */
export type MutationQuestionGenerator_CreateExperimentArgs = {
  input: QuestionGenerator_CreateExperimentInput;
};


/** Root Mutation type */
export type MutationQuestionGenerator_StartGenerationArgs = {
  input: QuestionGenerator_StartGenerationInput;
};


/** Root Mutation type */
export type MutationQuestionGenerator_StopGenerationArgs = {
  input: QuestionGenerator_StopGenerationInput;
};


/** Root Mutation type */
export type MutationQuestionGenerator_UpdateExperimentArgs = {
  input: QuestionGenerator_UpdateExperimentInput;
};


/** Root Mutation type */
export type MutationQuestionRater_SaveHumanQuestionRatingArgs = {
  input: QuestionRater_SaveHumanQuestionRatingInput;
};


/** Root Mutation type */
export type MutationQuestionRater_StartQuestionRatingArgs = {
  input: QuestionRater_StartQuestionRatingInput;
};


/** Root Mutation type */
export type MutationReadingAuthoring_UpdateReadingDraftArgs = {
  input: ReadingAuthoring_UpdateReadingDraftInput;
};


/** Root Mutation type */
export type MutationRecentlyViewedProducts_AddRecentlyViewedProductArgs = {
  input: RecentlyViewedProducts_AddRecentlyViewedProductInput;
};


/** Root Mutation type */
export type MutationRecruitingInvitation_InviteByFiltersArgs = {
  input: RecruitingInvitation_InviteByFiltersInput;
};


/** Root Mutation type */
export type MutationRecruitingInvitation_InviteByIdsArgs = {
  input: RecruitingInvitation_InviteByIdsInput;
};


/** Root Mutation type */
export type MutationRecruitingPosition_CreateArgs = {
  input: RecruitingPosition_CreateInput;
};


/** Root Mutation type */
export type MutationRecruitingPosition_DeleteArgs = {
  input: RecruitingPosition_DeleteInput;
};


/** Root Mutation type */
export type MutationReusableComments_CreateReusableCommentArgs = {
  input?: InputMaybe<ReusableComments_CreateReusableCommentInput>;
};


/** Root Mutation type */
export type MutationReusableComments_CreateReusableCommentUsageArgs = {
  input?: InputMaybe<ReusableComments_CreateReusableCommentUsageInput>;
};


/** Root Mutation type */
export type MutationReusableComments_DeleteReusableCommentArgs = {
  input?: InputMaybe<ReusableComments_DeleteReusableCommentInput>;
};


/** Root Mutation type */
export type MutationReusableComments_UpdateReusableCommentArgs = {
  input?: InputMaybe<ReusableComments_UpdateReusableCommentInput>;
};


/** Root Mutation type */
export type MutationRoleSkillMappingBranch_CreateNewBranchArgs = {
  input: RoleSkillMappingBranch_CreateNewBranchInput;
};


/** Root Mutation type */
export type MutationRoleSkillMappingBranch_DeactivateBranchArgs = {
  input: RoleSkillMappingBranch_DeactivateBranchInput;
};


/** Root Mutation type */
export type MutationRoleSkillMappingBranch_FreezeBranchArgs = {
  input: RoleSkillMappingBranch_FreezeBranchInput;
};


/** Root Mutation type */
export type MutationRoleSkillMappingBranch_MergeBranchArgs = {
  input: RoleSkillMappingBranch_MergeBranchInput;
};


/** Root Mutation type */
export type MutationRoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameArgs = {
  input?: InputMaybe<RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameInput>;
};


/** Root Mutation type */
export type MutationSamlFlows_CompleteFlowArgs = {
  input: SamlFlows_CompleteFlowInput;
};


/** Root Mutation type */
export type MutationSamlFlows_MarkLoginCompletedArgs = {
  input: SamlFlows_MarkLoginCompletedInput;
};


/** Root Mutation type */
export type MutationSampleUser_AddUserArgs = {
  input: SampleUser_AddUserInput;
};


/** Root Mutation type */
export type MutationScopedTranslationConfig_RequestRetranslationArgs = {
  input: ScopedTranslationConfig_RequestRetranslationInput;
};


/** Root Mutation type */
export type MutationSeo_EqpDataBulkEditV1MutationArgs = {
  input: Seo_EqpDataBulkEditV1MutationInput;
};


/** Root Mutation type */
export type MutationSeo_EqpHreflangGroupingMutationArgs = {
  input: Seo_EqpHreflangGroupingMutationInput;
};


/** Root Mutation type */
export type MutationSeo_EqpHreflangUngroupingMutationArgs = {
  input: Seo_EqpHreflangUngroupingMutationInput;
};


/** Root Mutation type */
export type MutationSeo_PageDataFullImportV1MutationArgs = {
  input: Seo_PageDataFullImportV1MutationInput;
};


/** Root Mutation type */
export type MutationSeo_PageDataOverrideV1MutationArgs = {
  input: Seo_PageDataOverrideV1MutationInput;
};


/** Root Mutation type */
export type MutationSeo_RobotsTxtV1MutationArgs = {
  input: Seo_RobotsTxtV1MutationInput;
};


/** Root Mutation type */
export type MutationSessionScheduleOverrides_PatchSessionScheduleOverridesArgs = {
  input: SessionScheduleOverrides_PatchSessionScheduleOverridesInput;
};


/** Root Mutation type */
export type MutationSession_UpdateSessionSpecificItemOverridesArgs = {
  input: Session_UpdateSessionSpecificItemOverridesInput;
};


/** Root Mutation type */
export type MutationShortFormContent_EnrollEnterpriseUserIntoCourseArgs = {
  input?: InputMaybe<ShortFormContent_EnrollEnterpriseUserIntoCourseInput>;
};


/** Root Mutation type */
export type MutationShortFormContent_TrackVideoProgressArgs = {
  input?: InputMaybe<ShortFormContent_TrackVideoProgressInput>;
};


/** Root Mutation type */
export type MutationSimilarityCheck_SubmitArgs = {
  input: SimilarityCheck_SubmitInput;
};


/** Root Mutation type */
export type MutationSkillAttainment_GenerateProgressReportArgs = {
  input: SkillAttainment_GenerateProgressReportInput;
};


/** Root Mutation type */
export type MutationSkillRestrictedContractTag_AddContractTagSkillIdsArgs = {
  input: SkillRestrictedContractTag_AddContractTagSkillIdsInput;
};


/** Root Mutation type */
export type MutationSkillRestrictedContractTag_RemoveContractTagDomainIdsArgs = {
  input: SkillRestrictedContractTag_RemoveContractTagDomainIdsInput;
};


/** Root Mutation type */
export type MutationSkillRestrictedContractTag_RemoveContractTagSkillIdsArgs = {
  input: SkillRestrictedContractTag_RemoveContractTagSkillIdsInput;
};


/** Root Mutation type */
export type MutationSkillRestrictedContractTag_UpdateSkillRelevancyArgs = {
  input: SkillRestrictedContractTag_UpdateSkillRelevancyInput;
};


/** Root Mutation type */
export type MutationSkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsArgs = {
  input: SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsInput;
};


/** Root Mutation type */
export type MutationSkillsTagsLabeling_UpdateSkillsTagsLabelingArgs = {
  input?: InputMaybe<SkillsTagsLabeling_UpdateSkillsTagsLabelingInput>;
};


/** Root Mutation type */
export type MutationSkillsTracking_UpdateSkillsTrackingArgs = {
  input: SkillsTracking_UpdateSkillsTrackingInput;
};


/** Root Mutation type */
export type MutationSocialCohort_CreateCohortArgs = {
  input: SocialCohort_CreateCohortInput;
};


/** Root Mutation type */
export type MutationSocialCohort_DeleteCohortArgs = {
  input: SocialCohort_DeleteCohortInput;
};


/** Root Mutation type */
export type MutationSocialCohort_RegisterMembershipArgs = {
  input: SocialCohort_RegisterMembershipInput;
};


/** Root Mutation type */
export type MutationSocialCohort_RegisterUsersToCohortArgs = {
  input: SocialCohort_RegisterUsersToCohortInput;
};


/** Root Mutation type */
export type MutationSocialCohort_RemoveMembershipArgs = {
  input: SocialCohort_RemoveMembershipInput;
};


/** Root Mutation type */
export type MutationSocialCohort_UpdateCohortArgs = {
  input: SocialCohort_UpdateCohortInput;
};


/** Root Mutation type */
export type MutationSpecializationMembership_CreateMembershipArgs = {
  input: SpecializationMembership_CreateMembershipInput;
};


/** Root Mutation type */
export type MutationSpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nArgs = {
  input: SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nInput;
};


/** Root Mutation type */
export type MutationSpecializationMembership_DeleteMembershipArgs = {
  input: SpecializationMembership_DeleteMembershipInput;
};


/** Root Mutation type */
export type MutationSpecializationUpgrade_DeclineUpgradeArgs = {
  input: SpecializationUpgrade_DeclineUpgradeInput;
};


/** Root Mutation type */
export type MutationSpecializationUpgrade_UpgradeArgs = {
  input: SpecializationUpgrade_UpgradeInput;
};


/** Root Mutation type */
export type MutationStackability_CreateUpsellArgs = {
  input: Stackability_CreateUpsellInput;
};


/** Root Mutation type */
export type MutationStackability_DeletePropertyArgs = {
  input: Stackability_DeletePropertyInput;
};


/** Root Mutation type */
export type MutationStackability_DeleteUpsellArgs = {
  input: Stackability_DeleteUpsellInput;
};


/** Root Mutation type */
export type MutationStackability_SetPropertyArgs = {
  input: Stackability_SetPropertyInput;
};


/** Root Mutation type */
export type MutationStackability_UpdateUpsellArgs = {
  input: Stackability_UpdateUpsellInput;
};


/** Root Mutation type */
export type MutationSubmissionDownload_EnqueueDownloadArgs = {
  input: SubmissionDownload_EnqueueDownloadInput;
};


/** Root Mutation type */
export type MutationSubmission_CreateBoxSessionForViewArgs = {
  input: Submission_CreateBoxSessionForViewInput;
};


/** Root Mutation type */
export type MutationSubmission_CreateHonorlockSessionArgs = {
  input: Submission_CreateHonorlockSessionInput;
};


/** Root Mutation type */
export type MutationSubmission_DeleteAllAttemptsArgs = {
  input: Submission_DeleteAllAttemptsInput;
};


/** Root Mutation type */
export type MutationSubmission_FileUploadQuestionGenerateUploadUrlArgs = {
  input: Submission_FileUploadQuestionGenerateUploadUrlInput;
};


/** Root Mutation type */
export type MutationSubmission_ReworkSubmissionArgs = {
  input: Submission_ReworkSubmissionInput;
};


/** Root Mutation type */
export type MutationSubmission_SaveResponsesArgs = {
  input: Submission_SaveResponsesInput;
};


/** Root Mutation type */
export type MutationSubmission_StartAttemptArgs = {
  input: Submission_StartAttemptInput;
};


/** Root Mutation type */
export type MutationSubmission_SubmitLatestDraftArgs = {
  input: Submission_SubmitLatestDraftInput;
};


/** Root Mutation type */
export type MutationSubscriptions_CancelArgs = {
  input: Subscriptions_CancelInput;
};


/** Root Mutation type */
export type MutationSubscriptions_ConvertFreeTrialToActiveArgs = {
  input: Subscriptions_ConvertFreeTrialToActiveInput;
};


/** Root Mutation type */
export type MutationSubscriptions_RestoreCanceledSubscriptionArgs = {
  input: Subscriptions_RestoreCanceledSubscriptionInput;
};


/** Root Mutation type */
export type MutationSubtitles_CreateTranscriptionWorkflowArgs = {
  input: Subtitles_CreateTranscriptionWorkflowInput;
};


/** Root Mutation type */
export type MutationSubtitles_RetryTranscriptionWorkflowArgs = {
  input: Subtitles_RetryTranscriptionWorkflowInput;
};


/** Root Mutation type */
export type MutationTeamwork_LockTeamActivityArgs = {
  input: Teamwork_LockTeamActivityInput;
};


/** Root Mutation type */
export type MutationTeamwork_UnlockTeamActivityArgs = {
  input: Teamwork_UnlockTeamActivityInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganizationEmailDomain_CreateArgs = {
  input: ThirdPartyOrganizationEmailDomain_CreateInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganizationEmailDomain_DeleteArgs = {
  input: ThirdPartyOrganizationEmailDomain_DeleteInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganizationEmailDomain_MultiCreateArgs = {
  input: ThirdPartyOrganizationEmailDomain_MultiCreateInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganizationServiceAccount_ServiceAccountCreateArgs = {
  input: ThirdPartyOrganizationServiceAccount_ServiceAccountCreateInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganizationServiceAccount_ServiceAccountDeleteArgs = {
  input: ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganization_SetIsRealArgs = {
  input: ThirdPartyOrganization_SetIsRealInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganization_UpdateEntityIdArgs = {
  input: ThirdPartyOrganization_UpdateEntityIdInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganization_UpdateMetadataArgs = {
  input: ThirdPartyOrganization_UpdateMetadataInput;
};


/** Root Mutation type */
export type MutationThirdPartyOrganization_UpdateSigningCertificateArgs = {
  input: ThirdPartyOrganization_UpdateSigningCertificateInput;
};


/** Root Mutation type */
export type MutationTranslationFeedback_ReportFeedbackArgs = {
  input: TranslationFeedback_ReportFeedbackInput;
};


/** Root Mutation type */
export type MutationTurnitinTenant_CreateEntryArgs = {
  input?: InputMaybe<TurnitinTenant_CreateEntryInput>;
};


/** Root Mutation type */
export type MutationUlba_CreateUlbaJobArgs = {
  input: Ulba_CreateUlbaJobInput;
};


/** Root Mutation type */
export type MutationUlba_ExportCourseStructureArgs = {
  input: Ulba_ExportCourseStructureInput;
};


/** Root Mutation type */
export type MutationUlba_UpdateUlbaJobDismissReportArgs = {
  input: Ulba_UpdateUlbaJobDismissReportInput;
};


/** Root Mutation type */
export type MutationUlba_UpdateUlbaJobStartLoadingArgs = {
  input: Ulba_UpdateUlbaJobStartLoadingInput;
};


/** Root Mutation type */
export type MutationUlba_UpdateUlbaJobStartSmartIngestionSyncArgs = {
  input: Ulba_UpdateUlbaJobStartSmartIngestionSyncInput;
};


/** Root Mutation type */
export type MutationUserEmails_DeleteUserEmailArgs = {
  input: UserEmails_DeleteUserEmailInput;
};


/** Root Mutation type */
export type MutationUserExperienceContext_UpdateUserExperienceContextArgs = {
  input: UserExperienceContext_UpdateUserExperienceContextInput;
};


/** Root Mutation type */
export type MutationUserPortfolioProject_HideArgs = {
  input: UserPortfolioProject_HideInput;
};


/** Root Mutation type */
export type MutationUserPortfolioProject_PublishArgs = {
  input: UserPortfolioProject_PublishInput;
};


/** Root Mutation type */
export type MutationUserPortfolioProject_SaveArgs = {
  input: UserPortfolioProject_SaveInput;
};


/** Root Mutation type */
export type MutationUserPreference_SetUserPreferenceArgs = {
  input: UserPreference_SetUserPreferenceInput;
};


/** Root Mutation type */
export type MutationUserVerification_DeleteIdVerificationCourseOverrideArgs = {
  input: UserVerification_DeleteIdVerificationCourseOverrideInput;
};


/** Root Mutation type */
export type MutationUserVerification_SetIdVerificationCourseOverrideArgs = {
  input: UserVerification_SetIdVerificationCourseOverrideInput;
};


/** Root Mutation type */
export type MutationUser_ExportUserDataReleaseArgs = {
  input: User_ExportUserDataReleaseInput;
};


/** Root Mutation type */
export type MutationVerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsArgs = {
  input: VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsInput;
};


/** Root Mutation type */
export type MutationVivaExam_SaveUserFeedbackArgs = {
  input: VivaExam_SaveUserFeedbackInput;
};


/** Root Mutation type */
export type MutationVivaExam_StartExamArgs = {
  input: VivaExam_StartExamInput;
};


/** Root Mutation type */
export type MutationVivaExam_SubmitQuestionAnswerArgs = {
  input: VivaExam_SubmitQuestionAnswerInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_CreateXapiIntegrationArgs = {
  input: XapiIntegration_CreateXapiIntegrationInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_DeleteXapiIntegrationArgs = {
  input: XapiIntegration_DeleteXapiIntegrationInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_RemoveXapiIntegrationArgs = {
  input: XapiIntegration_RemoveXapiIntegrationInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_TriggerEnrollmentSyncJobArgs = {
  input: XapiIntegration_TriggerEnrollmentSyncJobInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_UpdateXapiIntegrationArgs = {
  input: XapiIntegration_UpdateXapiIntegrationInput;
};


/** Root Mutation type */
export type MutationXapiIntegration_ValidateXapiIntegrationArgs = {
  input: XapiIntegration_ValidateXapiIntegrationInput;
};


/** Root Mutation type */
export type MutationCapturePaymentWalletIdArgs = {
  paymentWalletId: Scalars['Int'];
  preEnrollmentId: Scalars['String'];
};


/** Root Mutation type */
export type MutationCreateMembershipArgs = {
  input?: InputMaybe<OnDemandSpecializationMembership_CreateInput>;
};


/** Root Mutation type */
export type MutationCreateOrUpdatePreEnrollmentProductArgs = {
  launchAt?: InputMaybe<TimestampInput>;
  productItemId: Scalars['String'];
  productType: PreEnrollment_ProductType;
};


/** Root Mutation type */
export type MutationDeclineUpgradeArgs = {
  newS12nId: Scalars['String'];
  oldS12nId: Scalars['String'];
  userId: Scalars['String'];
};


/** Root Mutation type */
export type MutationDeleteMembershipArgs = {
  input?: InputMaybe<OnDemandSpecializationMembership_DeleteInput>;
};


/** Root Mutation type */
export type MutationEnrollInOwnedS12nArgs = {
  input: OnDemandSpecializationMembership_EnrollInOwnedS12nInput;
};


/** Root Mutation type */
export type MutationPreEnrollUserArgs = {
  countryIsoCode: Scalars['String'];
  currencyCode: Scalars['String'];
  enrollCourseId?: InputMaybe<Scalars['String']>;
  preEnrollmentType: PreEnrollmentType;
  productItemId: Scalars['String'];
  productType: PreEnrollment_ProductType;
  userId: Scalars['Int'];
};


/** Root Mutation type */
export type MutationRedeemCourseCreditArgs = {
  input: RedeemCourseCreditInput;
};


/** Root Mutation type */
export type MutationRefundCourseCreditArgs = {
  input: RefundCourseCreditInput;
};


/** Root Mutation type */
export type MutationRemovePreEnrollmentArgs = {
  preEnrollmentId: Scalars['String'];
};


/** Root Mutation type */
export type MutationUpgradeArgs = {
  s12nId: Scalars['String'];
  userId: Scalars['String'];
};


/** Root Mutation type */
export type MutationUpsertPreEnrollmentProductArgs = {
  launchAt?: InputMaybe<Scalars['DateTime']>;
  state: PreEnrollment_PreEnrollmentProductState;
  underlyingProductItemId: Scalars['ID'];
  underlyingProductType: PreEnrollment_ProductType;
};

export type MyFeedbackV1 = {
  __typename?: 'MyFeedbackV1';
  booleanResponses: Scalars['JSON'];
  comments: Scalars['JSON'];
  context: Scalars['String'];
  debugInfo?: Maybe<MyFeedbackV1_Org_Coursera_Common_AnyData>;
  id: Scalars['String'];
  rating: MyFeedbackV1_Org_Coursera_Feedback_RatingTrait;
  stringSetResponses: Scalars['JSON'];
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  timestamp: Scalars['Float'];
  userId: Scalars['Int'];
};

export type MyFeedbackV1ByCourseAndFeedback = {
  __typename?: 'MyFeedbackV1ByCourseAndFeedback';
  connection?: Maybe<MyFeedbackV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  feedbackSystem: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MyFeedbackV1Connection = {
  __typename?: 'MyFeedbackV1Connection';
  elements: Array<Maybe<MyFeedbackV1>>;
  paging: ResponsePagination;
};

export type MyFeedbackV1Course = {
  __typename?: 'MyFeedbackV1Course';
  connection?: Maybe<MyFeedbackV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MyFeedbackV1Item = {
  __typename?: 'MyFeedbackV1Item';
  connection?: Maybe<MyFeedbackV1Connection>;
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type MyFeedbackV1Resource = {
  __typename?: 'MyFeedbackV1Resource';
  byCourseAndFeedback?: Maybe<MyFeedbackV1Connection>;
  course?: Maybe<MyFeedbackV1Connection>;
  item?: Maybe<MyFeedbackV1Connection>;
  subItem?: Maybe<MyFeedbackV1Connection>;
};


export type MyFeedbackV1ResourceByCourseAndFeedbackArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  feedbackSystem: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MyFeedbackV1ResourceCourseArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MyFeedbackV1ResourceItemArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type MyFeedbackV1ResourceSubItemArgs = {
  courseId: Scalars['String'];
  genericSubItemId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type MyFeedbackV1ResourceMutations = {
  __typename?: 'MyFeedbackV1ResourceMutations';
  submit?: Maybe<Scalars['JSON']>;
};


export type MyFeedbackV1ResourceMutationsSubmitArgs = {
  audioLanguage?: InputMaybe<Scalars['String']>;
  courseId: Scalars['String'];
  dubbedSubtitleLanguage?: InputMaybe<Scalars['String']>;
  feedbackSystem: Scalars['String'];
  genericSubItemId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['String']>;
  subtitleLanguage?: InputMaybe<Scalars['String']>;
};

export type MyFeedbackV1SubItem = {
  __typename?: 'MyFeedbackV1SubItem';
  connection?: Maybe<MyFeedbackV1Connection>;
  courseId: Scalars['String'];
  genericSubItemId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

/** Marker type for arbitrary JSON data. */
export type MyFeedbackV1_Org_Coursera_Common_AnyData = {
  __typename?: 'MyFeedbackV1_org_coursera_common_AnyData';
  ArbitraryField: Scalars['String'];
};

/** Unable to infer schema. See the org.coursera.feedback.Rating Scala type for data model structure. */
export type MyFeedbackV1_Org_Coursera_Feedback_RatingTrait = {
  __typename?: 'MyFeedbackV1_org_coursera_feedback_RatingTrait';
  active: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type NaptimeMutations = {
  __typename?: 'NaptimeMutations';
  AuthoringActivitiesV1Resource: AuthoringActivitiesV1ResourceMutations;
  AuthoringActivitySetsV1Resource: AuthoringActivitySetsV1ResourceMutations;
  AuthoringCopyBranchesV2Resource: AuthoringCopyBranchesV2ResourceMutations;
  AuthoringTeammateReviewsV1Resource: AuthoringTeammateReviewsV1ResourceMutations;
  AuthoringTeamsV1Resource: AuthoringTeamsV1ResourceMutations;
  AuthoringTeamworkScopesV1Resource: AuthoringTeamworkScopesV1ResourceMutations;
  AuthoringWorkspaceTemplatesV1Resource: AuthoringWorkspaceTemplatesV1ResourceMutations;
  BrowseCollectionsV1Resource: BrowseCollectionsV1ResourceMutations;
  CertificateV1Resource: CertificateV1ResourceMutations;
  ContractMigrationsV2Resource: ContractMigrationsV2ResourceMutations;
  CourseTypeMetadataV1Resource: CourseTypeMetadataV1ResourceMutations;
  CourseraPlusEnrollmentsV1Resource: CourseraPlusEnrollmentsV1ResourceMutations;
  CustomLabelsV1Resource: CustomLabelsV1ResourceMutations;
  DecoratedEnterpriseContractsV1Resource: DecoratedEnterpriseContractsV1ResourceMutations;
  DegreeCategoriesV1Resource: DegreeCategoriesV1ResourceMutations;
  DegreeEnrollmentChecklistsV1Resource: DegreeEnrollmentChecklistsV1ResourceMutations;
  DegreeLearnerMembershipsV1Resource: DegreeLearnerMembershipsV1ResourceMutations;
  EnterpriseAuthoringMappingsV1Resource: EnterpriseAuthoringMappingsV1ResourceMutations;
  EnterpriseCollectionsAdminV1Resource: EnterpriseCollectionsAdminV1ResourceMutations;
  EnterpriseContractPoliciesV1Resource: EnterpriseContractPoliciesV1ResourceMutations;
  EnterpriseContractTagsV1Resource: EnterpriseContractTagsV1ResourceMutations;
  EnterpriseContractTransactionsV1Resource: EnterpriseContractTransactionsV1ResourceMutations;
  EnterpriseContractsV1Resource: EnterpriseContractsV1ResourceMutations;
  EnterprisePaymentWalletsV1Resource: EnterprisePaymentWalletsV1ResourceMutations;
  EnterpriseProgramSessionAssociationsV1Resource: EnterpriseProgramSessionAssociationsV1ResourceMutations;
  EnterpriseProgramsV1Resource: EnterpriseProgramsV1ResourceMutations;
  EnterprisePromotionsV1Resource: EnterprisePromotionsV1ResourceMutations;
  EnterpriseSelfServeContractProductPricesV1Resource: EnterpriseSelfServeContractProductPricesV1ResourceMutations;
  EnterpriseSettingsV1Resource: EnterpriseSettingsV1ResourceMutations;
  EnterpriseTargetSkillProfilesV1Resource: EnterpriseTargetSkillProfilesV1ResourceMutations;
  FinancialAidApplicationsV2Resource: FinancialAidApplicationsV2ResourceMutations;
  GdprSettingsV1Resource: GdprSettingsV1ResourceMutations;
  IdVerificationsV1Resource: IdVerificationsV1ResourceMutations;
  InstructorProfilesV1Resource: InstructorProfilesV1ResourceMutations;
  JumioIdVerificationsV1Resource: JumioIdVerificationsV1ResourceMutations;
  LearnerCourseScheduleSuggestionsV1Resource: LearnerCourseScheduleSuggestionsV1ResourceMutations;
  LearnerCourseSchedulesV1Resource: LearnerCourseSchedulesV1ResourceMutations;
  MembershipsV1Resource: MembershipsV1ResourceMutations;
  MyFeedbackV1Resource: MyFeedbackV1ResourceMutations;
  OnDemandCourseForumQuestionsV1Resource: OnDemandCourseForumQuestionsV1ResourceMutations;
  OnDemandCourseSessionsV1Resource: OnDemandCourseSessionsV1ResourceMutations;
  OnDemandInstructorNotesV1Resource: OnDemandInstructorNotesV1ResourceMutations;
  OnDemandLearnerSummariesForStaffV1Resource: OnDemandLearnerSummariesForStaffV1ResourceMutations;
  OnDemandSessionMembershipsV1Resource: OnDemandSessionMembershipsV1ResourceMutations;
  OnDemandSessionsV1Resource: OnDemandSessionsV1ResourceMutations;
  OnDemandSpecializationMembershipsV1Resource: OnDemandSpecializationMembershipsV1ResourceMutations;
  OnDemandSubmittedTeammateReviewsResourceV1Resource: OnDemandSubmittedTeammateReviewsResourceV1ResourceMutations;
  OpenCourseMembershipsV1Resource: OpenCourseMembershipsV1ResourceMutations;
  PresetCollectionsV1Resource: PresetCollectionsV1ResourceMutations;
  ProductPricesV4Resource: ProductPricesV4ResourceMutations;
  ProductSkusV1Resource: ProductSkusV1ResourceMutations;
  ProgramCurriculumsV1Resource: ProgramCurriculumsV1ResourceMutations;
  ProgramEnrollmentSettingsV1Resource: ProgramEnrollmentSettingsV1ResourceMutations;
  ProgramInvitationsV1Resource: ProgramInvitationsV1ResourceMutations;
  ProgramMembershipsV2Resource: ProgramMembershipsV2ResourceMutations;
  ProgramSwitcherSelectionsV1Resource: ProgramSwitcherSelectionsV1ResourceMutations;
  PromoCodesV1Resource: PromoCodesV1ResourceMutations;
  PromotionUserEligibleRulesV1Resource: PromotionUserEligibleRulesV1ResourceMutations;
  PromotionsV3Resource: PromotionsV3ResourceMutations;
  PromotionsV4Resource: PromotionsV4ResourceMutations;
  PublicPromotionInfoLandingPageBannersV1Resource: PublicPromotionInfoLandingPageBannersV1ResourceMutations;
  PublicPromotionInfoProductCollectionsV1Resource: PublicPromotionInfoProductCollectionsV1ResourceMutations;
  PublicPromotionInfoProductItemsV1Resource: PublicPromotionInfoProductItemsV1ResourceMutations;
  PublicPromotionInfoProductPageBannersV1Resource: PublicPromotionInfoProductPageBannersV1ResourceMutations;
  SubscriptionsV1Resource: SubscriptionsV1ResourceMutations;
  TargetSkillProfileUserStatesV1Resource: TargetSkillProfileUserStatesV1ResourceMutations;
  TeammateReviewAssessmentsV2Resource: TeammateReviewAssessmentsV2ResourceMutations;
  TeammateReviewDraftsV1Resource: TeammateReviewDraftsV1ResourceMutations;
  TeammateReviewStaffReviewDraftsV1Resource: TeammateReviewStaffReviewDraftsV1ResourceMutations;
  TeamworkTeamsV1Resource: TeamworkTeamsV1ResourceMutations;
  ThirdPartyAccountsV1Resource: ThirdPartyAccountsV1ResourceMutations;
  ThirdPartyOrganizationEmailDomainsV1Resource: ThirdPartyOrganizationEmailDomainsV1ResourceMutations;
  ThirdPartyOrganizationsV1Resource: ThirdPartyOrganizationsV1ResourceMutations;
  VcMembershipsV1Resource: VcMembershipsV1ResourceMutations;
  WorkspaceImageAuthoringDataV1Resource: WorkspaceImageAuthoringDataV1ResourceMutations;
  WorkspaceTemplatesV1Resource: WorkspaceTemplatesV1ResourceMutations;
};

export type NaptimeQueries = {
  __typename?: 'NaptimeQueries';
  AdminPagePermissionsV1Resource: AdminPagePermissionsV1Resource;
  AdminUserPermissionsV1Resource: AdminUserPermissionsV1Resource;
  AuthoringActivitiesV1Resource: AuthoringActivitiesV1Resource;
  AuthoringActivitySetActivitiesV1Resource: AuthoringActivitySetActivitiesV1Resource;
  AuthoringActivitySetTeamsV1Resource: AuthoringActivitySetTeamsV1Resource;
  AuthoringActivitySetsV1Resource: AuthoringActivitySetsV1Resource;
  AuthoringCandidateItemActivitiesV1Resource: AuthoringCandidateItemActivitiesV1Resource;
  AuthoringCopyBranchesV2Resource: AuthoringCopyBranchesV2Resource;
  AuthoringScopeDiffsV1Resource: AuthoringScopeDiffsV1Resource;
  AuthoringScopeMetadataV1Resource: AuthoringScopeMetadataV1Resource;
  AuthoringTeamMetadataV1Resource: AuthoringTeamMetadataV1Resource;
  AuthoringTeamUsersV1Resource: AuthoringTeamUsersV1Resource;
  AuthoringTeammateReviewsV1Resource: AuthoringTeammateReviewsV1Resource;
  AuthoringTeamsV1Resource: AuthoringTeamsV1Resource;
  AuthoringTeamworkScopesV1Resource: AuthoringTeamworkScopesV1Resource;
  AuthoringUserCoursePermissionsV1Resource: AuthoringUserCoursePermissionsV1Resource;
  AuthoringWorkspaceTemplatesV1Resource: AuthoringWorkspaceTemplatesV1Resource;
  BrowseCollectionsV1Resource: BrowseCollectionsV1Resource;
  CatalogCollectionPagesV1Resource: CatalogCollectionPagesV1Resource;
  CatalogMastertracksV1Resource: CatalogMastertracksV1Resource;
  CertificateV1Resource: CertificateV1Resource;
  ContractMigrationsV2Resource: ContractMigrationsV2Resource;
  CourseAccomplishmentsV1Resource: CourseAccomplishmentsV1Resource;
  CourseDerivativesV1Resource: CourseDerivativesV1Resource;
  CourseDerivativesV2Resource: CourseDerivativesV2Resource;
  CourseMessagesV1Resource: CourseMessagesV1Resource;
  CourseTypeMetadataV1Resource: CourseTypeMetadataV1Resource;
  CourseraPlusEnrollmentsV1Resource: CourseraPlusEnrollmentsV1Resource;
  CoursesV1Resource: CoursesV1Resource;
  CustomLabelsV1Resource: CustomLabelsV1Resource;
  DecoratedEnterpriseContractsV1Resource: DecoratedEnterpriseContractsV1Resource;
  DegreeCategoriesV1Resource: DegreeCategoriesV1Resource;
  DegreeEnrollmentChecklistsV1Resource: DegreeEnrollmentChecklistsV1Resource;
  DegreeLearnerCourseStatesV1Resource: DegreeLearnerCourseStatesV1Resource;
  DegreeLearnerMembershipsV1Resource: DegreeLearnerMembershipsV1Resource;
  DegreeLearnerProgressesV1Resource: DegreeLearnerProgressesV1Resource;
  DegreeListsV3Resource: DegreeListsV3Resource;
  DegreesV1Resource: DegreesV1Resource;
  DomainsV1Resource: DomainsV1Resource;
  EnrollmentAvailableChoicesV1Resource: EnrollmentAvailableChoicesV1Resource;
  EnterpriseAuthoringMappingsV1Resource: EnterpriseAuthoringMappingsV1Resource;
  EnterpriseBrowseCollectionsV1Resource: EnterpriseBrowseCollectionsV1Resource;
  EnterpriseCollectionsAdminV1Resource: EnterpriseCollectionsAdminV1Resource;
  EnterpriseContractPoliciesV1Resource: EnterpriseContractPoliciesV1Resource;
  EnterpriseContractTagsV1Resource: EnterpriseContractTagsV1Resource;
  EnterpriseContractTransactionsV1Resource: EnterpriseContractTransactionsV1Resource;
  EnterpriseContractUtilizationsV1Resource: EnterpriseContractUtilizationsV1Resource;
  EnterpriseContractsV1Resource: EnterpriseContractsV1Resource;
  EnterpriseLearnerSummariesV1Resource: EnterpriseLearnerSummariesV1Resource;
  EnterpriseMemberCourseEnrollmentReportsV2Resource: EnterpriseMemberCourseEnrollmentReportsV2Resource;
  EnterprisePaymentWalletsV1Resource: EnterprisePaymentWalletsV1Resource;
  EnterpriseProductConfigurationMetadataV1Resource: EnterpriseProductConfigurationMetadataV1Resource;
  EnterpriseProductRecommendationsV1Resource: EnterpriseProductRecommendationsV1Resource;
  EnterpriseProgramCurriculumSummariesV2Resource: EnterpriseProgramCurriculumSummariesV2Resource;
  EnterpriseProgramDraftsV1Resource: EnterpriseProgramDraftsV1Resource;
  EnterpriseProgramSessionAssociationsV1Resource: EnterpriseProgramSessionAssociationsV1Resource;
  EnterpriseProgramSummariesV2Resource: EnterpriseProgramSummariesV2Resource;
  EnterpriseProgramsV1Resource: EnterpriseProgramsV1Resource;
  EnterprisePromotionsV1Resource: EnterprisePromotionsV1Resource;
  EnterpriseSelfServeContractProductPricesV1Resource: EnterpriseSelfServeContractProductPricesV1Resource;
  EnterpriseSettingsV1Resource: EnterpriseSettingsV1Resource;
  EnterpriseSubjectMatterExpertsV1Resource: EnterpriseSubjectMatterExpertsV1Resource;
  EnterpriseTargetSkillProfileSummariesV1Resource: EnterpriseTargetSkillProfileSummariesV1Resource;
  EnterpriseTargetSkillProfilesV1Resource: EnterpriseTargetSkillProfilesV1Resource;
  EnterpriseUserRostersV1Resource: EnterpriseUserRostersV1Resource;
  ExternallyAccessibleNostosV1Resource: ExternallyAccessibleNostosV1Resource;
  FinancialAidApplicationsV2Resource: FinancialAidApplicationsV2Resource;
  GdprSettingsV1Resource: GdprSettingsV1Resource;
  GuidedCourseNextStepsV1Resource: GuidedCourseNextStepsV1Resource;
  GuidedCourseSessionProgressesV1Resource: GuidedCourseSessionProgressesV1Resource;
  IdVerificationsV1Resource: IdVerificationsV1Resource;
  InstructorProfilesV1Resource: InstructorProfilesV1Resource;
  InstructorsV1Resource: InstructorsV1Resource;
  JumioIdVerificationsV1Resource: JumioIdVerificationsV1Resource;
  LearnerCourseScheduleSuggestionsV1Resource: LearnerCourseScheduleSuggestionsV1Resource;
  LearnerCourseSchedulesV1Resource: LearnerCourseSchedulesV1Resource;
  LinkedAtomInfoV1Resource: LinkedAtomInfoV1Resource;
  LoggedInHomeS12nModalV1Resource: LoggedInHomeS12nModalV1Resource;
  LoggedInHomeV1Resource: LoggedInHomeV1Resource;
  MembershipsV1Resource: MembershipsV1Resource;
  MyFeedbackV1Resource: MyFeedbackV1Resource;
  OnDemandCourseForumQuestionsV1Resource: OnDemandCourseForumQuestionsV1Resource;
  OnDemandCourseForumsV1Resource: OnDemandCourseForumsV1Resource;
  OnDemandCourseSessionsV1Resource: OnDemandCourseSessionsV1Resource;
  OnDemandCoursesProgressV1Resource: OnDemandCoursesProgressV1Resource;
  OnDemandCoursesV1Resource: OnDemandCoursesV1Resource;
  OnDemandInstructorNotesV1Resource: OnDemandInstructorNotesV1Resource;
  OnDemandLearnerMaterialItemsV1Resource: OnDemandLearnerMaterialItemsV1Resource;
  OnDemandLearnerMaterialLessonsV1Resource: OnDemandLearnerMaterialLessonsV1Resource;
  OnDemandLearnerMaterialModulesV1Resource: OnDemandLearnerMaterialModulesV1Resource;
  OnDemandLearnerMaterialWeeksV1Resource: OnDemandLearnerMaterialWeeksV1Resource;
  OnDemandLearnerMaterialsV1Resource: OnDemandLearnerMaterialsV1Resource;
  OnDemandLearnerSessionsV1Resource: OnDemandLearnerSessionsV1Resource;
  OnDemandLearnerSummariesForSelfV1Resource: OnDemandLearnerSummariesForSelfV1Resource;
  OnDemandLearnerSummariesForStaffV1Resource: OnDemandLearnerSummariesForStaffV1Resource;
  OnDemandMentorForumsV1Resource: OnDemandMentorForumsV1Resource;
  OnDemandReferencesV1Resource: OnDemandReferencesV1Resource;
  OnDemandSessionMembershipsV1Resource: OnDemandSessionMembershipsV1Resource;
  OnDemandSessionsV1Resource: OnDemandSessionsV1Resource;
  OnDemandSpecializationMembershipsV1Resource: OnDemandSpecializationMembershipsV1Resource;
  OnDemandSpecializationsV1Resource: OnDemandSpecializationsV1Resource;
  OnDemandSubmittedTeammateReviewsResourceV1Resource: OnDemandSubmittedTeammateReviewsResourceV1Resource;
  OpenCourseMembershipsV1Resource: OpenCourseMembershipsV1Resource;
  PartnerMembershipsV1Resource: PartnerMembershipsV1Resource;
  PartnersV1Resource: PartnersV1Resource;
  PresetCollectionsV1Resource: PresetCollectionsV1Resource;
  ProductActionEligibilitiesV1Resource: ProductActionEligibilitiesV1Resource;
  ProductItemDetailsV1Resource: ProductItemDetailsV1Resource;
  ProductOwnershipsV2Resource: ProductOwnershipsV2Resource;
  ProductPricesV4Resource: ProductPricesV4Resource;
  ProductReviewOverviewV1Resource: ProductReviewOverviewV1Resource;
  ProductReviewsV1Resource: ProductReviewsV1Resource;
  ProductSkusV1Resource: ProductSkusV1Resource;
  ProfessionalCertsV1Resource: ProfessionalCertsV1Resource;
  ProgramCurriculumCollectionsV1Resource: ProgramCurriculumCollectionsV1Resource;
  ProgramCurriculumDomainsV1Resource: ProgramCurriculumDomainsV1Resource;
  ProgramCurriculumProductsV1Resource: ProgramCurriculumProductsV1Resource;
  ProgramCurriculumsV1Resource: ProgramCurriculumsV1Resource;
  ProgramEnrollmentSettingsV1Resource: ProgramEnrollmentSettingsV1Resource;
  ProgramInvitationsV1Resource: ProgramInvitationsV1Resource;
  ProgramMembershipsV2Resource: ProgramMembershipsV2Resource;
  ProgramProductMetadataV1Resource: ProgramProductMetadataV1Resource;
  ProgramSwitcherSelectionsV1Resource: ProgramSwitcherSelectionsV1Resource;
  ProgramsV1Resource: ProgramsV1Resource;
  PromoCodesV1Resource: PromoCodesV1Resource;
  PromotionDetailsV1Resource: PromotionDetailsV1Resource;
  PromotionUserEligibleRulesV1Resource: PromotionUserEligibleRulesV1Resource;
  PromotionsV3Resource: PromotionsV3Resource;
  PromotionsV4Resource: PromotionsV4Resource;
  PublicPromotionInfoLandingPageBannersV1Resource: PublicPromotionInfoLandingPageBannersV1Resource;
  PublicPromotionInfoProductCollectionsV1Resource: PublicPromotionInfoProductCollectionsV1Resource;
  PublicPromotionInfoProductItemsV1Resource: PublicPromotionInfoProductItemsV1Resource;
  PublicPromotionInfoProductPageBannersV1Resource: PublicPromotionInfoProductPageBannersV1Resource;
  S12nDerivativesV1Resource: S12nDerivativesV1Resource;
  SessionsV2AuthoringEligibilityCheckV1Resource: SessionsV2AuthoringEligibilityCheckV1Resource;
  SessionsV2EnrollmentEligibilityCheckV1Resource: SessionsV2EnrollmentEligibilityCheckV1Resource;
  SpecializationsV1Resource: SpecializationsV1Resource;
  SubdomainsV1Resource: SubdomainsV1Resource;
  SubscriptionTrialsV1Resource: SubscriptionTrialsV1Resource;
  SubscriptionsV1Resource: SubscriptionsV1Resource;
  TargetSkillProfileUserStatesV1Resource: TargetSkillProfileUserStatesV1Resource;
  TaxEstimatesV2Resource: TaxEstimatesV2Resource;
  TeammateReviewAssessmentsV2Resource: TeammateReviewAssessmentsV2Resource;
  TeammateReviewDraftsV1Resource: TeammateReviewDraftsV1Resource;
  TeammateReviewStaffReviewDraftsV1Resource: TeammateReviewStaffReviewDraftsV1Resource;
  TeammateReviewSubmittedStaffReviewsV1Resource: TeammateReviewSubmittedStaffReviewsV1Resource;
  TeamworkActivitiesV1Resource: TeamworkActivitiesV1Resource;
  TeamworkActivitySetsV1Resource: TeamworkActivitySetsV1Resource;
  TeamworkLearnerTeamActivitiesV1Resource: TeamworkLearnerTeamActivitiesV1Resource;
  TeamworkLearnerTeamActivitySetsV1Resource: TeamworkLearnerTeamActivitySetsV1Resource;
  TeamworkLearnerTeamsV1Resource: TeamworkLearnerTeamsV1Resource;
  TeamworkTeamsV1Resource: TeamworkTeamsV1Resource;
  TeamworkUserProfilesV1Resource: TeamworkUserProfilesV1Resource;
  ThirdPartyAccountsV1Resource: ThirdPartyAccountsV1Resource;
  ThirdPartyOrganizationEmailDomainsV1Resource: ThirdPartyOrganizationEmailDomainsV1Resource;
  ThirdPartyOrganizationsV1Resource: ThirdPartyOrganizationsV1Resource;
  UserProductTransactionsV1Resource: UserProductTransactionsV1Resource;
  UserVerificationRequirementsV1Resource: UserVerificationRequirementsV1Resource;
  UsersV1Resource: UsersV1Resource;
  VcMembershipsV1Resource: VcMembershipsV1Resource;
  WorkspaceImageAuthoringDataV1Resource: WorkspaceImageAuthoringDataV1Resource;
  WorkspacePublishStatesV1Resource: WorkspacePublishStatesV1Resource;
  WorkspaceTemplatesV1Resource: WorkspaceTemplatesV1Resource;
  XdpV1Resource: XdpV1Resource;
};

/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueries = {
  __typename?: 'NativeAnalyticsQueries';
  /**
   * Fetch resolved data for a single component (chart / metric card /
   * table) on a dashboard, applying the supplied filters and (for
   * tables) pagination.
   *
   * `limit` and `cursor` are consulted only when the resolved component
   * is a table; charts and metric cards return their full bounded
   * payload regardless.
   *
   * Pagination follows DR-0005's offset-as-cursor variant: cursor is a
   * plain-text stringified Int offset (e.g. "100") so clients can
   * construct cursors for arbitrary page jumps (e.g. CDS Table's
   * numbered pager + rows-per-page selector).
   */
  getComponentData?: Maybe<NativeAnalytics_ComponentDataResult>;
  /**
   * Contracts visible to the caller under the given org, sourced from the
   * foundation OBT and scoped by the caller's ACCESSIBLE_PROGRAMS set.
   * Mirrors the data backing getFilterOptions's contractId entries, but
   * carries human-readable names and is callable without a dashboard slug
   * (e.g. for filter dropdowns rendered outside a specific dashboard).
   */
  getContractsByOrg: Array<Enterprise_Contract>;
  /**
   * Fetch a single dashboard spec by its slug. Returns null if the
   * dashboard does not exist.
   */
  getDashboard?: Maybe<NativeAnalytics_Dashboard>;
  /**
   * Fetch the available options for every dynamic filter on the
   * dashboard in one call, scoped to the caller's org. Returned as one
   * NativeAnalytics_FilterOption per filter, each carrying its own
   * filterId. The FE calls this once on page load and uses the result
   * to populate every dropdown in the filter bar; per-option relatedIds
   * drive client-side cascading without further server roundtrips.
   */
  getFilterOptions: Array<NativeAnalytics_FilterOption>;
  /**
   * Programs visible to the caller under the given org, sourced from the
   * foundation OBT and scoped by the caller's ACCESSIBLE_PROGRAMS set.
   * Mirrors the data backing getFilterOptions's programId entries, but
   * carries human-readable names and is callable without a dashboard slug.
   */
  getProgramsByOrg: Array<Enterprise_Program>;
  /**
   * Rosters visible to the caller under the given org — the program + contract
   * pairings sourced directly from the foundation rosters table (the
   * authoritative org->contract->program mapping also used to scope
   * getContractsByOrg and getProgramsByOrg). Callable without a dashboard slug.
   */
  getRostersByOrg: Array<Enterprise_Roster>;
  /**
   * Skills visible to the caller under the given org, sourced from the
   * foundation OBT and scoped by the caller's ACCESSIBLE_PROGRAMS set.
   * Mirrors the data backing getFilterOptions's skillId entries, but
   * carries human-readable names and is callable without a dashboard slug
   */
  getSkillsByOrg: Array<Enterprise_Skill>;
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetComponentDataArgs = {
  componentId: Scalars['ID'];
  contractIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  filterValues?: InputMaybe<Array<NativeAnalytics_FilterValueInput>>;
  limit?: Scalars['Int'];
  orgId: Scalars['ID'];
  programIds: Array<Scalars['ID']>;
  slug: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetContractsByOrgArgs = {
  orgId: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetDashboardArgs = {
  orgId: Scalars['ID'];
  slug: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetFilterOptionsArgs = {
  orgId: Scalars['ID'];
  slug: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetProgramsByOrgArgs = {
  orgId: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetRostersByOrgArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
};


/**
 * Queries for the native analytics dashboard system, consumed by the
 * enterprise admin UI to render dashboards (layout via getDashboard,
 * component data via getComponentData, filter dropdowns via
 * getFilterOptions). Dashboard specs live as code-as-config in the ESA
 * deployment.
 *
 * getDashboard, getComponentData, and getFilterOptions gate on a
 * per-dashboard accessLevel evaluated by a single DashboardAccessAuthorizer
 * impl in ESA (EAL-1359). The schema declares three distinct auth keys
 * (one per operation) only because the platform's per-key numInputs
 * invariant requires distinct keys per arity — they back the same
 * authorizer class. The dashboardless org-scoped queries
 * (getContractsByOrg, getProgramsByOrg, getRostersByOrg) reuse the existing
 * enterprise.canViewProgramInOrg key for real admin callers, with a
 * core.powerUser fallthrough (OR'd) so internal Coursera staff can
 * exercise the endpoints in preview without being added to each org's
 * admin map — mirrors the pattern on EnterpriseSummaryReports_*.
 * Contract-type access levels (enrollments_contract / licenses_contract)
 * are FE-route-guarded only; see EAL-1338 for rationale.
 */
export type NativeAnalyticsQueriesGetSkillsByOrgArgs = {
  orgId: Scalars['ID'];
};

/** A single named data series within a chart component. */
export type NativeAnalytics_ChartSeries = {
  __typename?: 'NativeAnalytics_ChartSeries';
  /**
   * Stable id used by the dashboard spec to reference the series
   * (e.g. for color overrides). Distinct from `name`, which is rendered.
   */
  id: Scalars['ID'];
  /** Display name for the series, surfaced in legends and tooltips. */
  name: Scalars['String'];
  /**
   * Pre-shaped data points for Highcharts. Shape is per-chartType and
   * defined by the dashboard spec.
   */
  points: Scalars['JSON'];
};

/**
 * Chart component data — one or more named series in the shape
 * Highcharts consumes. Series ordering matches the dashboard spec's
 * component config; concrete point shape (categorical, time-series,
 * etc.) is determined by the spec's chartType.
 */
export type NativeAnalytics_ChartSeriesData = {
  __typename?: 'NativeAnalytics_ChartSeriesData';
  /** One entry per series rendered on the chart. */
  series: Array<NativeAnalytics_ChartSeries>;
};

/**
 * Resolved data payload for a dashboard component. Members map 1:1 to
 * the component categories defined in the dashboard spec.
 */
export type NativeAnalytics_ComponentData = NativeAnalytics_ChartSeriesData | NativeAnalytics_MetricCardData | NativeAnalytics_TableData;

/**
 * Per-component result envelope returned by getComponentData. Carries
 * either the resolved `data` payload or a structured `error`, plus
 * component-level `metadata` (e.g. data freshness) that the FE renders
 * alongside the visualization regardless of success/failure.
 */
export type NativeAnalytics_ComponentDataResult = {
  __typename?: 'NativeAnalytics_ComponentDataResult';
  /**
   * Echo of the requested componentId, so multiplexed FE callers can
   * match responses back to requests without threading state through
   * promise chains.
   */
  componentId: Scalars['ID'];
  /** The resolved component payload. Null when `error` is set. */
  data?: Maybe<NativeAnalytics_ComponentData>;
  /**
   * Structured error describing why `data` could not be produced. Null
   * on success.
   */
  error?: Maybe<NativeAnalytics_ComponentError>;
  /**
   * Component-level metadata (data freshness, etc.). Always present —
   * rendered alongside both successful and failed components (e.g. the
   * "Data as of …" label is meaningful even when this single component
   * errored).
   */
  metadata: NativeAnalytics_ComponentMetadata;
};

/**
 * Structured per-component error returned when a single component
 * fails to resolve. Distinct from GraphQL-level errors (which fail the
 * whole field): this lets a dashboard render the surviving components
 * plus a per-tile error UX.
 */
export type NativeAnalytics_ComponentError = {
  __typename?: 'NativeAnalytics_ComponentError';
  /** Machine-readable error category for client routing. */
  code: NativeAnalytics_ErrorCode;
  /**
   * Human-readable message intended for end-user display in the
   * per-component error UX.
   */
  message: Scalars['String'];
};

/** Component-level metadata returned alongside every component result. */
export type NativeAnalytics_ComponentMetadata = {
  __typename?: 'NativeAnalytics_ComponentMetadata';
  /**
   * Timestamp the underlying data was last refreshed (sourced from the
   * Semantic Layer's report_metadata table). Null when freshness is
   * unknown for this component (e.g. a metric not backed by a refreshed
   * ClickHouse table). Surfaced by the FE as "Data as of {date}".
   */
  lastUpdated?: Maybe<Scalars['DateTime']>;
};

/**
 * A native analytics dashboard spec. Specs live in code (deployed with
 * the ESA binary); compilation runs at build/deploy time, so any spec
 * returned at runtime is by definition compiled-OK.
 */
export type NativeAnalytics_Dashboard = {
  __typename?: 'NativeAnalytics_Dashboard';
  /**
   * URL-safe identifier for the dashboard, matching the spec's slug in
   * the deployed config.
   */
  slug: Scalars['ID'];
  /**
   * Opaque dashboard spec body. Shape is validated at deploy time
   * against the DashboardSpec JSON schema; clients should treat this as
   * pass-through configuration.
   */
  spec: Scalars['JSON'];
};

/** Categories of per-component resolution errors surfaced to the FE. */
export const NativeAnalytics_ErrorCode = {
  /**
   * The data source for this component is temporarily unavailable
   * (e.g. ClickHouse upstream down, table not yet built).
   */
  DataUnavailable: 'DATA_UNAVAILABLE',
  /** Unspecified server-side failure; details available in logs. */
  InternalError: 'INTERNAL_ERROR',
  /**
   * The component references a Semantic Layer metric that does not
   * exist or has been removed.
   */
  InvalidMetric: 'INVALID_METRIC',
  /**
   * The caller is not allowed to view the data backing this component
   * (sub-component scope check; the dashboard-level @authorization
   * already passed).
   */
  PermissionDenied: 'PERMISSION_DENIED',
  /** The underlying analytics query exceeded its time budget. */
  QueryTimeout: 'QUERY_TIMEOUT'
} as const;

export type NativeAnalytics_ErrorCode = typeof NativeAnalytics_ErrorCode[keyof typeof NativeAnalytics_ErrorCode];
/**
 * Resolved options for a single dashboard filter, returned by
 * NativeAnalytics.getFilterOptions. Cascading filter narrowing is done
 * client-side from each option's `relatedIds`; the BE returns the full
 * unfiltered option set per filter.
 */
export type NativeAnalytics_FilterOption = {
  __typename?: 'NativeAnalytics_FilterOption';
  /** ID of the filter in the dashboard spec these options belong to. */
  filterId: Scalars['ID'];
  /**
   * Selectable values for the filter. Each option's `id` is what the FE
   * passes back in NativeAnalytics_FilterValueInput.value.
   */
  options: Array<NativeAnalytics_FilterOptionValue>;
};

/** A single selectable value for a dashboard filter. */
export type NativeAnalytics_FilterOptionValue = {
  __typename?: 'NativeAnalytics_FilterOptionValue';
  /**
   * Opaque value passed back to getComponentData via
   * NativeAnalytics_FilterValueInput.value when this option is selected.
   */
  id: Scalars['ID'];
  /** Human-readable label rendered in the filter dropdown. */
  label: Scalars['String'];
  /**
   * Related entity IDs this option implies for cascading filter
   * narrowing, keyed by the downstream filterId those ids belong to
   * (e.g. `{"program_name": ["data-science-foundations", "leadership-dev"]}`
   * on a contract option). The FE applies these client-side to narrow
   * the referenced dropdowns without a server roundtrip. Empty object
   * when the option has no implied dependents.
   *
   * JSON (not `[ID!]!`) because a single option can imply ids in more
   * than one downstream filter (e.g., a contract implying both program
   * ids and course ids); a flat list can't disambiguate which ids map
   * to which target.
   */
  relatedIds: Scalars['JSON'];
};

/**
 * A single filter selection for a dashboard component data request. The
 * shape of `value` varies per filter type, defined by the dashboard
 * spec's filter[].type field (e.g., multi_select → array of strings,
 * date_range → string or {start, end} object). Validated app-side
 * against the filter's declared type at request time.
 */
export type NativeAnalytics_FilterValueInput = {
  /** ID of the filter in the dashboard spec being filtered on. */
  filterId: Scalars['ID'];
  /**
   * Opaque value whose shape is dictated by the filter's declared type
   * in the dashboard spec.
   */
  value: Scalars['JSON'];
};

/**
 * Metric card (KPI) component data: a single headline value with an
 * optional contextual subtitle.
 */
export type NativeAnalytics_MetricCardData = {
  __typename?: 'NativeAnalytics_MetricCardData';
  /**
   * Numeric progress value rendered as a progress-bar fill (0..100,
   * representing percent of target). Null when the metric is not
   * rendered as a progress-style KPI. Used by Phase 1 dashboards that
   * visualize "X% of target" indicators.
   */
  progressValue?: Maybe<Scalars['Float']>;
  /**
   * Pre-formatted contextual line rendered under the headline value
   * (e.g. "14% of 10312", "+12.3% vs previous 30 days"). Genuinely a
   * sentence assembled from spec-driven baseline / comparison context,
   * so a single string beats parallel raw fields. Null when the metric
   * has no subtitle configured.
   */
  subtitle?: Maybe<Scalars['String']>;
  /**
   * Raw numeric headline value (e.g. 1490). Float (not a pre-formatted
   * string) because the FE owns locale-aware formatting via CDS
   * formatters and may sort or compute on the value; baking format on
   * the BE is the wrong layer.
   */
  value: Scalars['Float'];
};

/**
 * Metadata for a single column in a table component, describing how
 * the FE should render the header and look up cell values for that
 * column.
 */
export type NativeAnalytics_TableColumn = {
  __typename?: 'NativeAnalytics_TableColumn';
  /**
   * Column key used to look up the cell value inside
   * NativeAnalytics_TableRow.values (e.g. accessor "learner_email"
   * pairs with the row's `values["learner_email"]` cell).
   */
  accessor: Scalars['ID'];
  /** Human-readable header text rendered in the table's header row. */
  label: Scalars['String'];
};

/**
 * Tabular component data: paginated rows plus a Pagination envelope.
 *
 * Naming note: this follows the spirit of *PaginatedResult (rows +
 * pagination + plain-text cursor per DR-0005) without adopting the
 * strict suffix because the convention applies to top-level paginated
 * query returns, not arms of a polymorphic union.
 */
export type NativeAnalytics_TableData = {
  __typename?: 'NativeAnalytics_TableData';
  /**
   * Column metadata in the order the table should render. The list
   * matches the column order declared in the dashboard spec's component
   * config; the FE iterates this list to draw both the header row and
   * the data cells (looking up each cell via the column's accessor).
   */
  columns: Array<NativeAnalytics_TableColumn>;
  /**
   * Cursor (next plain-text Int offset, per DR-0005) plus optional
   * totalElements. Cursor is null when the end of the result set has
   * been reached.
   */
  pagination: Pagination;
  /**
   * One row per record in the result set. Cell values are keyed by
   * column accessor and rendered against `columns` in declared order.
   */
  rows: Array<NativeAnalytics_TableRow>;
};

/**
 * A single table row, expressed as an opaque map of column accessor to
 * cell value. Cell value shapes (numbers, formatted strings, booleans,
 * etc.) vary per spec and are not worth rebuilding in the GraphQL type
 * system; the FE pairs each value with its column via the accessor in
 * NativeAnalytics_TableData.columns.
 */
export type NativeAnalytics_TableRow = {
  __typename?: 'NativeAnalytics_TableRow';
  /**
   * Per-column cell values keyed by the column's accessor (matching
   * NativeAnalytics_TableColumn.accessor).
   */
  values: Scalars['JSON'];
};

/** NoLimitSummary indicates that there are no limits for the learner, meaning they can submit their assignment unlimited number of times. */
export type NoLimitSummary = {
  __typename?: 'NoLimitSummary';
  /** TODO: Complete this description */
  dummy?: Maybe<Scalars['String']>;
};

/** Interface that all pagination nodes should implement */
export type Node = {
  /** Node entity id */
  id: Scalars['ID'];
};

/**
 * Nostos external queries for public access to pre-aggregated data.
 * Only tables with external_access_enabled=true can be queried through this endpoint.
 */
export type NostosExternalQueries = {
  __typename?: 'NostosExternalQueries';
  /**
   * Get data by keys from a Lakebase synced table.
   * Only tables with external_access_enabled=true are accessible.
   */
  getData: Nostos_GetDataResult;
};


/**
 * Nostos external queries for public access to pre-aggregated data.
 * Only tables with external_access_enabled=true can be queried through this endpoint.
 */
export type NostosExternalQueriesGetDataArgs = {
  input: Nostos_GetDataInput;
};

/** Nostos queries for accessing pre-aggregated data from Lakebase synced tables. */
export type NostosQueries = {
  __typename?: 'NostosQueries';
  /**
   * Get data by keys from a Lakebase synced table.
   *
   * Example:
   *   Input: { tableId: "12345", keys: ["u1", "u2"], columns: ["courses"] }
   *   Output: { entries: [{ key: "u1", data: [{ column: "courses", value: "[...]" }] }] }
   *
   * Note: The gRPC API returns data as a map, while GraphQL returns a list of
   * column/value pairs due to GraphQL's lack of native map support.
   */
  getData: Nostos_GetDataResult;
};


/** Nostos queries for accessing pre-aggregated data from Lakebase synced tables. */
export type NostosQueriesGetDataArgs = {
  input: Nostos_GetDataInput;
};

/** A column name and its JSON string value. */
export type Nostos_ColumnData = {
  __typename?: 'Nostos_ColumnData';
  /** The column name. */
  column: Scalars['String'];
  /** The JSON string value. */
  value: Scalars['String'];
};

/** A single data entry for a key. */
export type Nostos_DataEntry = {
  __typename?: 'Nostos_DataEntry';
  /**
   * Column data as raw JSON strings (no server-side parsing).
   * Example: [{ column: "courses", value: "[{\"id\":\"ml-101\"}]" }]
   */
  data: Array<Nostos_ColumnData>;
  /** The primary key value. */
  key: Scalars['String'];
};

/** Input for getting data from a Nostos table. */
export type Nostos_GetDataInput = {
  /** Columns to return. If empty, returns all data columns. */
  columns?: InputMaybe<Array<Scalars['String']>>;
  /** Primary key values to look up. Maximum 1000 keys per request. */
  keys: Array<Scalars['String']>;
  /** Opaque table identifier from the table registry (e.g., "12345", "67890"). */
  tableId: Scalars['ID'];
};

/** Result containing the requested data. */
export type Nostos_GetDataResult = {
  __typename?: 'Nostos_GetDataResult';
  /** Data entries for found keys. Keys not found are omitted. */
  entries: Array<Nostos_DataEntry>;
};

/** Namespaced queries for notification preferences. */
export type NotificationPreferenceQueries = {
  __typename?: 'NotificationPreferenceQueries';
  /**
   * Fetch user preferences via preference center token (token-based authentication).
   * Used in preference center accessed via email unsubscribe links.
   */
  getPreferencesByToken: NotificationPreference_PreferencesByTokenResponse;
};


/** Namespaced queries for notification preferences. */
export type NotificationPreferenceQueriesGetPreferencesByTokenArgs = {
  token: Scalars['String'];
};

/** Channel-only preference type. */
export type NotificationPreference_ChannelPreferenceType = {
  __typename?: 'NotificationPreference_ChannelPreferenceType';
  /** Communication channel */
  channel: NotificationPreference_ChannelType;
};

/** Channel-only preference type. */
export type NotificationPreference_ChannelPreferenceTypeInput = {
  /** Communication channel */
  channel: NotificationPreference_ChannelType;
};

/** Communication channel types. */
export const NotificationPreference_ChannelType = {
  /** Email notifications */
  ChannelTypeEmail: 'CHANNEL_TYPE_EMAIL'
} as const;

export type NotificationPreference_ChannelType = typeof NotificationPreference_ChannelType[keyof typeof NotificationPreference_ChannelType];
/** Contact information for a notification recipient. */
export type NotificationPreference_Contact = {
  __typename?: 'NotificationPreference_Contact';
  /** Contact identifier (userId for COURSERA_USER) */
  id: Scalars['ID'];
  /** Contact name (not populated for token-based access) */
  name?: Maybe<Scalars['String']>;
  /** Source of the contact */
  source: NotificationPreference_ContactSource;
};

/** Contact source type. */
export const NotificationPreference_ContactSource = {
  /** Coursera user account */
  ContactSourceCourseraUser: 'CONTACT_SOURCE_COURSERA_USER'
} as const;

export type NotificationPreference_ContactSource = typeof NotificationPreference_ContactSource[keyof typeof NotificationPreference_ContactSource];
/** Global notification categories that don't need scope-level tuning. */
export const NotificationPreference_GlobalNotificationCategory = {
  /** Degree marketing notifications */
  GlobalNotificationCategoryDegreeMarketing: 'GLOBAL_NOTIFICATION_CATEGORY_DEGREE_MARKETING',
  /** Promotional notifications */
  GlobalNotificationCategoryPromotion: 'GLOBAL_NOTIFICATION_CATEGORY_PROMOTION',
  /** Recommendation notifications */
  GlobalNotificationCategoryRecommendation: 'GLOBAL_NOTIFICATION_CATEGORY_RECOMMENDATION',
  /** Reminder notifications */
  GlobalNotificationCategoryReminder: 'GLOBAL_NOTIFICATION_CATEGORY_REMINDER',
  /** Volunteer opportunity notifications */
  GlobalNotificationCategoryVolunteer: 'GLOBAL_NOTIFICATION_CATEGORY_VOLUNTEER'
} as const;

export type NotificationPreference_GlobalNotificationCategory = typeof NotificationPreference_GlobalNotificationCategory[keyof typeof NotificationPreference_GlobalNotificationCategory];
/** Global category preference type. */
export type NotificationPreference_GlobalPreferenceType = {
  __typename?: 'NotificationPreference_GlobalPreferenceType';
  /** Global notification category */
  category: NotificationPreference_GlobalNotificationCategory;
  /** Communication channel */
  channel: NotificationPreference_ChannelType;
};

/** Global category preference type. */
export type NotificationPreference_GlobalPreferenceTypeInput = {
  /** Global notification category */
  category: NotificationPreference_GlobalNotificationCategory;
  /** Communication channel */
  channel: NotificationPreference_ChannelType;
};

/** A notification preference record. */
export type NotificationPreference_Preference = {
  __typename?: 'NotificationPreference_Preference';
  /** Contact information */
  contact: NotificationPreference_Contact;
  /** Source of the preference (e.g., settings page, email unsubscribe) */
  infoSource?: Maybe<NotificationPreference_Source>;
  /** Whether the user is subscribed */
  isSubscribed: Scalars['Boolean'];
  /** Timestamp of last modification (RFC-3339 format) */
  lastModifiedAt: Scalars['DateTime'];
  /** The type of preference */
  preferenceType: NotificationPreference_PreferenceType;
};

/** Input for a single notification preference update. */
export type NotificationPreference_PreferenceInput = {
  /** Whether the user is subscribed to this preference */
  isSubscribed: Scalars['Boolean'];
  /** The type of preference being updated */
  preferenceType: NotificationPreference_PreferenceTypeInput;
};

/**
 * Notification preference type (channel or global).
 * Union type ensures exactly one variant is present.
 */
export type NotificationPreference_PreferenceType = NotificationPreference_ChannelPreferenceType | NotificationPreference_GlobalPreferenceType;

/**
 * Input for notification preference type (channel or global).
 * Exactly one field must be provided.
 */
export type NotificationPreference_PreferenceTypeInput = {
  /** Channel-only preference (e.g., EMAIL) */
  channelPreference?: InputMaybe<NotificationPreference_ChannelPreferenceTypeInput>;
  /** Global category preference (e.g., EMAIL_PROMOTION) */
  globalPreference?: InputMaybe<NotificationPreference_GlobalPreferenceTypeInput>;
};

/** Response containing user preferences fetched by token. */
export type NotificationPreference_PreferencesByTokenResponse = {
  __typename?: 'NotificationPreference_PreferencesByTokenResponse';
  /**
   * Channel-level preferences (e.g., EMAIL, MOBILE_PUSH).
   * Unpaginated - returns all channel preferences (bounded set of 1-2 items).
   */
  channelPreferences: Array<NotificationPreference_Preference>;
  /** Contact information for the user. Null if user has no preferences. */
  contact?: Maybe<NotificationPreference_Contact>;
  /**
   * Global category preferences (e.g., EMAIL_PROMOTION, EMAIL_REMINDER).
   * Unpaginated - returns all global preferences (bounded set of ~5 items).
   */
  globalPreferences: Array<NotificationPreference_Preference>;
};

/** Source of truth for a notification preference. */
export const NotificationPreference_Source = {
  /** Updated via Braze email unsubscribe link */
  NotificationPreferenceSourceBrazeEmail: 'NOTIFICATION_PREFERENCE_SOURCE_BRAZE_EMAIL',
  /** Updated via Braze settings */
  NotificationPreferenceSourceBrazeSettings: 'NOTIFICATION_PREFERENCE_SOURCE_BRAZE_SETTINGS',
  /** Updated via Braze webhook */
  NotificationPreferenceSourceBrazeWebhook: 'NOTIFICATION_PREFERENCE_SOURCE_BRAZE_WEBHOOK',
  /** Updated via Coursera email unsubscribe link */
  NotificationPreferenceSourceCourseraEmail: 'NOTIFICATION_PREFERENCE_SOURCE_COURSERA_EMAIL',
  /** Updated via Coursera settings page */
  NotificationPreferenceSourceCourseraSettingsPage: 'NOTIFICATION_PREFERENCE_SOURCE_COURSERA_SETTINGS_PAGE',
  /** Updated via Coursera settings prompts */
  NotificationPreferenceSourceCourseraSettingsPrompts: 'NOTIFICATION_PREFERENCE_SOURCE_COURSERA_SETTINGS_PROMPTS',
  /** Invalid/unspecified source */
  NotificationPreferenceSourceInvalid: 'NOTIFICATION_PREFERENCE_SOURCE_INVALID'
} as const;

export type NotificationPreference_Source = typeof NotificationPreference_Source[keyof typeof NotificationPreference_Source];
/** Input for updating preferences by token. */
export type NotificationPreference_UpdatePreferencesByTokenInput = {
  /** List of preferences to update */
  preferences: Array<NotificationPreference_PreferenceInput>;
  /** Unsubscribe token from notification email */
  token: Scalars['String'];
};

/** Response from updating preferences by token. */
export type NotificationPreference_UpdatePreferencesByTokenResult = {
  __typename?: 'NotificationPreference_UpdatePreferencesByTokenResult';
  /** Indicates whether the update was successful */
  success: Scalars['Boolean'];
};

/**
 * OTP (One-Time Password) verification system for enterprise email validation.
 * Provides secure verification for emails with uncertain deliverability status.
 */
export type OtpQueries = {
  __typename?: 'OTPQueries';
  /**
   * Validates an OTP code for a given email address.
   * Returns validation status and remaining attempts information.
   */
  validateOTP: Otp_ValidateOtpResult;
};


/**
 * OTP (One-Time Password) verification system for enterprise email validation.
 * Provides secure verification for emails with uncertain deliverability status.
 */
export type OtpQueriesValidateOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
  username: Scalars['String'];
};

/** Input parameters for OTP_SendOTP mutation. */
export type Otp_SendOtpInput = {
  /** The email address to send the OTP to. */
  email: Scalars['String'];
  /** The username associated with the email address. */
  username: Scalars['String'];
};

/** Response for OTP send operation. */
export type Otp_SendOtpResult = {
  __typename?: 'OTP_SendOTPResult';
  /** Timestamp when the current operation expires (OTP expiry or block expiry). */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Number of remaining OTP validation attempts allowed for the sent OTP. */
  remainingOtpAttempts?: Maybe<Scalars['Int']>;
  /** Number of remaining resend attempts allowed. */
  remainingResends?: Maybe<Scalars['Int']>;
  /** The status of the OTP send operation. */
  status: Otp_SendOtpStatus;
};

/** Status enum for OTP send operations. */
export const Otp_SendOtpStatus = {
  /**
   * Email is currently blocked due to OTP send attempts being exhausted.
   * User cannot send new OTP until the block expires.
   */
  Blocked: 'BLOCKED',
  /** Maximum resend attempts exceeded within the time window. */
  MaxResendExceeded: 'MAX_RESEND_EXCEEDED',
  /** OTP was successfully sent or reused from cache. */
  Success: 'SUCCESS'
} as const;

export type Otp_SendOtpStatus = typeof Otp_SendOtpStatus[keyof typeof Otp_SendOtpStatus];
/** Response for OTP validation operation. */
export type Otp_ValidateOtpResult = {
  __typename?: 'OTP_ValidateOTPResult';
  /** Timestamp when the current operation expires (rate limiting window expiry). */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Number of remaining validation attempts allowed. */
  remainingAttempts?: Maybe<Scalars['Int']>;
  /** The status of the OTP validation operation. */
  status: Otp_ValidateOtpStatus;
};

/** Status enum for OTP validation operations. */
export const Otp_ValidateOtpStatus = {
  /**
   * Email is currently blocked due to OTP validation attempts being exhausted.
   * User cannot attempt OTP validation until the block expires.
   */
  Blocked: 'BLOCKED',
  /** OTP has expired or doesn't exist in cache. */
  Expired: 'EXPIRED',
  /** Provided OTP code is incorrect. */
  InvalidOtp: 'INVALID_OTP',
  /** OTP validation was successful. */
  Success: 'SUCCESS'
} as const;

export type Otp_ValidateOtpStatus = typeof Otp_ValidateOtpStatus[keyof typeof Otp_ValidateOtpStatus];
/** Queries for occupations. */
export type OccupationsQueries = {
  __typename?: 'OccupationsQueries';
  /** Get a list of all occupations with optional pagination. */
  getAllOccupations: Occupations_PaginatedResult;
};


/** Queries for occupations. */
export type OccupationsQueriesGetAllOccupationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Paginated result for occupations. */
export type Occupations_PaginatedResult = {
  __typename?: 'Occupations_PaginatedResult';
  /** A list of fetched occupations. */
  elements: Array<Skills_Occupation>;
  /** Pagination information. */
  pagination: Pagination;
};

export type OnDemandCourseForumAnswersV1 = {
  __typename?: 'OnDemandCourseForumAnswersV1';
  id: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1 = {
  __typename?: 'OnDemandCourseForumQuestionsV1';
  answerBadge: OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_QuestionAnswerBadge;
  content: OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionContent;
  courseId: Scalars['String'];
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  creatorId: Scalars['Int'];
  followCount: Scalars['Float'];
  forumAnswerBadgeTagMap: Scalars['JSON'];
  forumId: Scalars['String'];
  id: Scalars['String'];
  isFlagged: Scalars['Boolean'];
  isFollowing: Scalars['Boolean'];
  isUpvoted: Scalars['Boolean'];
  lastAnsweredAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  lastAnsweredBy?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  posts?: Maybe<Scalars['JSON']>;
  profiles?: Maybe<Scalars['JSON']>;
  sessionId?: Maybe<Scalars['String']>;
  state: OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionState;
  topLevelAnswerCount: Scalars['Float'];
  totalAnswerCount: Scalars['Float'];
  upvoteCount: Scalars['Int'];
  userId: Scalars['Int'];
  viewCount: Scalars['Float'];
};

export type OnDemandCourseForumQuestionsV1ByCourseForumId = {
  __typename?: 'OnDemandCourseForumQuestionsV1ByCourseForumId';
  answered?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
  courseForumId: Scalars['String'];
  creatorId?: Maybe<Scalars['String']>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  sessionFilter?: Maybe<Scalars['String']>;
  shouldAggregate?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1Connection = {
  __typename?: 'OnDemandCourseForumQuestionsV1Connection';
  elements: Array<Maybe<OnDemandCourseForumQuestionsV1>>;
  paging: ResponsePagination;
};

export type OnDemandCourseForumQuestionsV1Resource = {
  __typename?: 'OnDemandCourseForumQuestionsV1Resource';
  byCourseForumId?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
  get?: Maybe<OnDemandCourseForumQuestionsV1>;
  multiGet?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
};


export type OnDemandCourseForumQuestionsV1ResourceByCourseForumIdArgs = {
  answered?: InputMaybe<Scalars['Boolean']>;
  courseForumId: Scalars['String'];
  creatorId?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sessionFilter?: InputMaybe<Scalars['String']>;
  shouldAggregate?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceGetArgs = {
  forumAnswerLimit?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandCourseForumQuestionsV1ResourceMultiGetArgs = {
  forumAnswerLimit?: InputMaybe<Scalars['Int']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCourseForumQuestionsV1ResourceMutations = {
  __typename?: 'OnDemandCourseForumQuestionsV1ResourceMutations';
  close?: Maybe<Scalars['JSON']>;
  create?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
  delete?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
  move?: Maybe<Scalars['JSON']>;
  pin?: Maybe<Scalars['JSON']>;
  undoClose?: Maybe<Scalars['JSON']>;
  undoDelete?: Maybe<Scalars['JSON']>;
  unpin?: Maybe<Scalars['JSON']>;
  update?: Maybe<OnDemandCourseForumQuestionsV1Connection>;
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsCloseArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsMoveArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsPinArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsUndoCloseArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsUndoDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsUnpinArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseForumQuestionsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1_CmlMember = {
  __typename?: 'OnDemandCourseForumQuestionsV1_cmlMember';
  cml: OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** the pegasus schema for org.coursera.ondemand.content.Content. See https://phabricator.dkandu.me/D22517 */
export type OnDemandCourseForumQuestionsV1_Details = OnDemandCourseForumQuestionsV1_CmlMember | OnDemandCourseForumQuestionsV1_HtmlMember;

export type OnDemandCourseForumQuestionsV1_HtmlMember = {
  __typename?: 'OnDemandCourseForumQuestionsV1_htmlMember';
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  html: Scalars['String'];
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionContent = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_forum_question_ForumQuestionContent';
  details: OnDemandCourseForumQuestionsV1_Details;
  question: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionCopyDetails = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_forum_question_ForumQuestionCopyDetails';
  originalQuestionCreatedAt: Scalars['Float'];
  originalQuestionId: Scalars['String'];
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionState = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_forum_question_ForumQuestionState';
  closed?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails>;
  copied?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_Question_ForumQuestionCopyDetails>;
  deleted?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails>;
  edited?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails>;
  moved?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails>;
  pinned?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails>;
};

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Forum_State_StateDetails = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_forum_state_StateDetails';
  reason?: Maybe<Scalars['String']>;
  timestamp: Scalars['Float'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export const OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType = {
  Highlighted: 'HIGHLIGHTED',
  InstructorCreated: 'INSTRUCTOR_CREATED',
  InstructorResponded: 'INSTRUCTOR_RESPONDED',
  MentorCreated: 'MENTOR_CREATED',
  MentorResponded: 'MENTOR_RESPONDED',
  StaffCreated: 'STAFF_CREATED',
  StaffResponded: 'STAFF_RESPONDED'
} as const;

export type OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType = typeof OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType[keyof typeof OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType];
export type OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_QuestionAnswerBadge = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_ondemand_discussion_QuestionAnswerBadge';
  answerBadge?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Discussion_AnswerBadgeType>;
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandCourseForumQuestionsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandCourseForumQuestionsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandCourseForumQuestionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type OnDemandCourseForumsV1 = {
  __typename?: 'OnDemandCourseForumsV1';
  childForums?: Maybe<OnDemandCourseForumsV1Connection>;
  courseId: Scalars['String'];
  description: OnDemandCourseForumsV1_CmlMember;
  forumType: OnDemandCourseForumsV1_ForumType;
  id: Scalars['String'];
  legacyForumId?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  parentForumId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type OnDemandCourseForumsV1ChildForumsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1Connection = {
  __typename?: 'OnDemandCourseForumsV1Connection';
  elements: Array<Maybe<OnDemandCourseForumsV1>>;
  paging: ResponsePagination;
};

export type OnDemandCourseForumsV1Course = {
  __typename?: 'OnDemandCourseForumsV1Course';
  connection?: Maybe<OnDemandCourseForumsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  overrideBranchId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1CourseForumType = {
  __typename?: 'OnDemandCourseForumsV1CourseForumType';
  connection?: Maybe<OnDemandCourseForumsV1Connection>;
  courseForumType: Scalars['String'];
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  overrideBranchId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1ParentForum = {
  __typename?: 'OnDemandCourseForumsV1ParentForum';
  connection?: Maybe<OnDemandCourseForumsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  overrideBranchId?: Maybe<Scalars['String']>;
  parentForumId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1Resource = {
  __typename?: 'OnDemandCourseForumsV1Resource';
  course?: Maybe<OnDemandCourseForumsV1Connection>;
  courseForumType?: Maybe<OnDemandCourseForumsV1Connection>;
  get?: Maybe<OnDemandCourseForumsV1>;
  multiGet?: Maybe<OnDemandCourseForumsV1Connection>;
  parentForum?: Maybe<OnDemandCourseForumsV1Connection>;
  rootChildrenForums?: Maybe<OnDemandCourseForumsV1Connection>;
};


export type OnDemandCourseForumsV1ResourceCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseForumsV1ResourceCourseForumTypeArgs = {
  courseForumType: Scalars['String'];
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseForumsV1ResourceGetArgs = {
  id: Scalars['String'];
  overrideBranchId?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseForumsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseForumsV1ResourceParentForumArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  parentForumId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseForumsV1ResourceRootChildrenForumsArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  overrideBranchId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1RootChildrenForums = {
  __typename?: 'OnDemandCourseForumsV1RootChildrenForums';
  connection?: Maybe<OnDemandCourseForumsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  overrideBranchId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseForumsV1_CmlMember = {
  __typename?: 'OnDemandCourseForumsV1_cmlMember';
  cml: OnDemandCourseForumsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type OnDemandCourseForumsV1_CustomForumTypeMember = {
  __typename?: 'OnDemandCourseForumsV1_customForumTypeMember';
  customForumType: OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_CustomCourseForumType;
};

export type OnDemandCourseForumsV1_ForumType = OnDemandCourseForumsV1_CustomForumTypeMember | OnDemandCourseForumsV1_ItemForumTypeMember | OnDemandCourseForumsV1_RootForumTypeMember | OnDemandCourseForumsV1_WeekForumTypeMember;

export type OnDemandCourseForumsV1_ItemForumTypeMember = {
  __typename?: 'OnDemandCourseForumsV1_itemForumTypeMember';
  itemForumType: OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_ItemForumType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandCourseForumsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandCourseForumsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandCourseForumsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandCourseForumsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandCourseForumsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandCourseForumsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandCourseForumsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_CustomCourseForumType = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_ondemand_discussion_forum_CustomCourseForumType';
  ArbitraryField: Scalars['String'];
};

export type OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_ItemForumType = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_ondemand_discussion_forum_ItemForumType';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_RootCourseForumType = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_ondemand_discussion_forum_RootCourseForumType';
  ArbitraryField: Scalars['String'];
};

export type OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_WeekForumType = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_ondemand_discussion_forum_WeekForumType';
  weekNumber: Scalars['Int'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandCourseForumsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandCourseForumsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandCourseForumsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type OnDemandCourseForumsV1_RootForumTypeMember = {
  __typename?: 'OnDemandCourseForumsV1_rootForumTypeMember';
  rootForumType: OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_RootCourseForumType;
};

export type OnDemandCourseForumsV1_WeekForumTypeMember = {
  __typename?: 'OnDemandCourseForumsV1_weekForumTypeMember';
  weekForumType: OnDemandCourseForumsV1_Org_Coursera_Ondemand_Discussion_Forum_WeekForumType;
};

export type OnDemandCourseSessionsV1 = {
  __typename?: 'OnDemandCourseSessionsV1';
  courseBranchId?: Maybe<Scalars['String']>;
  courseId: Scalars['String'];
  deletedAt?: Maybe<Scalars['Float']>;
  discussionSessionId?: Maybe<Scalars['String']>;
  endsAt: Scalars['Float'];
  enrollmentEndsAt: Scalars['Float'];
  id: Scalars['String'];
  isExternallyManaged: Scalars['Boolean'];
  isPreview: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  itemDeadlines: Scalars['JSON'];
  moduleDeadlines: Scalars['JSON'];
  scheduleOverride?: Maybe<OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride>;
  sessionTypeMetadata?: Maybe<OnDemandCourseSessionsV1_SessionTypeMetadata>;
  startsAt: Scalars['Float'];
  versionedBranchId?: Maybe<Scalars['String']>;
};

export type OnDemandCourseSessionsV1AllByCourseAndEndAtRange = {
  __typename?: 'OnDemandCourseSessionsV1AllByCourseAndEndAtRange';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  courseId: Scalars['String'];
  fromEndsAt: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  toEndsAt: Scalars['String'];
};

export type OnDemandCourseSessionsV1AllByCourseAndStartAtRange = {
  __typename?: 'OnDemandCourseSessionsV1AllByCourseAndStartAtRange';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  courseId: Scalars['String'];
  fromStartedAt: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  toStartedAt: Scalars['String'];
};

export type OnDemandCourseSessionsV1AllByEndAtRange = {
  __typename?: 'OnDemandCourseSessionsV1AllByEndAtRange';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  fromEndsAt: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  toEndsAt: Scalars['String'];
};

export type OnDemandCourseSessionsV1Branch = {
  __typename?: 'OnDemandCourseSessionsV1Branch';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  courseBranchId: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  onlyIncludeActiveSessions: Scalars['Boolean'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseSessionsV1Connection = {
  __typename?: 'OnDemandCourseSessionsV1Connection';
  elements: Array<Maybe<OnDemandCourseSessionsV1>>;
  paging: ResponsePagination;
};

export type OnDemandCourseSessionsV1Course = {
  __typename?: 'OnDemandCourseSessionsV1Course';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  courseId: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseSessionsV1EarliestOpenSessionByCourse = {
  __typename?: 'OnDemandCourseSessionsV1EarliestOpenSessionByCourse';
  connection?: Maybe<OnDemandCourseSessionsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCourseSessionsV1Resource = {
  __typename?: 'OnDemandCourseSessionsV1Resource';
  allByCourseAndEndAtRange?: Maybe<OnDemandCourseSessionsV1Connection>;
  allByCourseAndStartAtRange?: Maybe<OnDemandCourseSessionsV1Connection>;
  allByEndAtRange?: Maybe<OnDemandCourseSessionsV1Connection>;
  branch?: Maybe<OnDemandCourseSessionsV1Connection>;
  course?: Maybe<OnDemandCourseSessionsV1Connection>;
  earliestOpenSessionByCourse?: Maybe<OnDemandCourseSessionsV1Connection>;
  get?: Maybe<OnDemandCourseSessionsV1>;
  getAll?: Maybe<OnDemandCourseSessionsV1Connection>;
  multiGet?: Maybe<OnDemandCourseSessionsV1Connection>;
};


export type OnDemandCourseSessionsV1ResourceAllByCourseAndEndAtRangeArgs = {
  courseId: Scalars['String'];
  fromEndsAt: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  toEndsAt: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceAllByCourseAndStartAtRangeArgs = {
  courseId: Scalars['String'];
  fromStartedAt: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  toStartedAt: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceAllByEndAtRangeArgs = {
  fromEndsAt: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  toEndsAt: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceBranchArgs = {
  courseBranchId: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  onlyIncludeActiveSessions: Scalars['Boolean'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseSessionsV1ResourceCourseArgs = {
  courseId: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseSessionsV1ResourceEarliestOpenSessionByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseSessionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCourseSessionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCourseSessionsV1ResourceMutations = {
  __typename?: 'OnDemandCourseSessionsV1ResourceMutations';
  create?: Maybe<OnDemandCourseSessionsV1Connection>;
  delete?: Maybe<OnDemandCourseSessionsV1Connection>;
  hardDelete?: Maybe<Scalars['JSON']>;
  revertSoftDelete?: Maybe<Scalars['JSON']>;
  syncSessionDeadlinesWithCourseMaterial?: Maybe<Scalars['JSON']>;
  update?: Maybe<OnDemandCourseSessionsV1Connection>;
};


export type OnDemandCourseSessionsV1ResourceMutationsCreateArgs = {
  skipCourseSessionErrorsCheck?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandCourseSessionsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceMutationsHardDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceMutationsRevertSoftDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceMutationsSyncSessionDeadlinesWithCourseMaterialArgs = {
  versionedCourseBranchId: Scalars['String'];
};


export type OnDemandCourseSessionsV1ResourceMutationsUpdateArgs = {
  allowBranchChanges?: InputMaybe<Scalars['Boolean']>;
  allowChangingExternallyManagedFlag?: InputMaybe<Scalars['Boolean']>;
  allowTimeChanges?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type OnDemandCourseSessionsV1_CredentialTrackSessionMember = {
  __typename?: 'OnDemandCourseSessionsV1_credentialTrackSessionMember';
  credentialTrackSession: OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession;
};

export type OnDemandCourseSessionsV1_DegreeSessionMember = {
  __typename?: 'OnDemandCourseSessionsV1_degreeSessionMember';
  degreeSession: OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession;
};

/** This session is associated with a credential track. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession = {
  __typename?: 'OnDemandCourseSessionsV1_org_coursera_ondemand_course_session_typemetadata_CredentialTrackSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

/** This session is associated with a degree. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession = {
  __typename?: 'OnDemandCourseSessionsV1_org_coursera_ondemand_course_session_typemetadata_DegreeSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

export type OnDemandCourseSessionsV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride = {
  __typename?: 'OnDemandCourseSessionsV1_org_coursera_ondemand_schedule_ScheduleOverride';
  timedItemLocks: Scalars['JSON'];
};

export type OnDemandCourseSessionsV1_SessionTypeMetadata = OnDemandCourseSessionsV1_CredentialTrackSessionMember | OnDemandCourseSessionsV1_DegreeSessionMember;

/**
 * See
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/onDemandCoursesProgress.v1.graphql
 * for the complete schema.
 */
export type OnDemandCoursesProgressV1 = {
  __typename?: 'OnDemandCoursesProgressV1';
  courseId: Scalars['String'];
  gradedAssignmentGroupProgress: Scalars['JSON'];
  id: Scalars['String'];
  isCompleted: Scalars['Boolean'];
  items: Scalars['JSON'];
  lessons: Scalars['JSON'];
  modules: Scalars['JSON'];
  /** Identifier for an item. This will never change and is unique within the course. */
  nextItem?: Maybe<Scalars['String']>;
  overall: Scalars['String'];
  userId: Scalars['Int'];
};

export type OnDemandCoursesProgressV1Connection = {
  __typename?: 'OnDemandCoursesProgressV1Connection';
  elements: Array<Maybe<OnDemandCoursesProgressV1>>;
  paging: ResponsePagination;
};

export type OnDemandCoursesProgressV1Resource = {
  __typename?: 'OnDemandCoursesProgressV1Resource';
  get?: Maybe<OnDemandCoursesProgressV1>;
  multiGet?: Maybe<OnDemandCoursesProgressV1Connection>;
};


export type OnDemandCoursesProgressV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandCoursesProgressV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCoursesV1 = {
  __typename?: 'OnDemandCoursesV1';
  assetLibraryAccessibilitySettings?: Maybe<OnDemandCoursesV1_Org_Coursera_Authoring_Course_AuthoringCourseAssetLibraryAccessibilitySettings>;
  brandingImage?: Maybe<Scalars['String']>;
  categoryIds: Array<Maybe<Scalars['Int']>>;
  certificatePurchaseEnabledAt?: Maybe<Scalars['Float']>;
  courseDerivatives?: Maybe<CourseDerivativesV1>;
  courseStatus?: Maybe<OnDemandCoursesV1_Org_Coursera_Course_CourseStatus>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  domainIds?: Maybe<Scalars['JSON']>;
  domainTypes: Array<Maybe<OnDemandCoursesV1_Org_Coursera_Catalogp_Browse_DomainType>>;
  domains?: Maybe<DomainsV1Connection>;
  enrollableSiteUserRoles: Array<Maybe<Scalars['String']>>;
  /** Typeref for string that defines the isTranslatable property to true */
  estimatedWorkload?: Maybe<Scalars['String']>;
  faqs: Array<Maybe<OnDemandCoursesV1_Org_Coursera_Ondemand_Common_CourseQnA>>;
  /** Typeref for string that defines the isTranslatable property to true */
  hardwareRequirement?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  instructors?: Maybe<InstructorsV1Connection>;
  isReal: Scalars['Boolean'];
  isRestrictedMembership: Scalars['Boolean'];
  isSubtitleTranslationEnabled: Scalars['Boolean'];
  isVerificationEnabled: Scalars['Boolean'];
  launchedAt?: Maybe<Scalars['Float']>;
  learningObjectives: Array<Maybe<OnDemandCoursesV1_CmlMember>>;
  level?: Maybe<OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  onDemandLearnerMaterials?: Maybe<OnDemandLearnerMaterialsV1>;
  overridePartnerLogos: Scalars['JSON'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  partners?: Maybe<PartnersV1Connection>;
  plannedLaunchDate?: Maybe<Scalars['String']>;
  preEnrollmentEnabledAt?: Maybe<Scalars['Float']>;
  premiumExperienceVariant?: Maybe<OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant>;
  previewUserIds: Array<Maybe<Scalars['Int']>>;
  primaryLanguageCodes: Array<Maybe<Scalars['String']>>;
  primaryTranslationEquivalentCourse?: Maybe<Scalars['String']>;
  promoPhoto?: Maybe<Scalars['String']>;
  recommendedBackground?: Maybe<OnDemandCoursesV1_RecommendedBackground>;
  sessionsEnabledAt?: Maybe<Scalars['Float']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  subtitleLanguageCodes: Array<Maybe<Scalars['String']>>;
  /** Typeref for string that defines the isTranslatable property to true */
  targetAudience?: Maybe<Scalars['String']>;
  verificationEnabledAt?: Maybe<Scalars['Float']>;
};


export type OnDemandCoursesV1DomainsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCoursesV1InstructorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCoursesV1OnDemandLearnerMaterialsArgs = {
  anonymousAccess?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandCoursesV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCoursesV1Connection = {
  __typename?: 'OnDemandCoursesV1Connection';
  elements: Array<Maybe<OnDemandCoursesV1>>;
  paging: ResponsePagination;
};

export type OnDemandCoursesV1Resource = {
  __typename?: 'OnDemandCoursesV1Resource';
  get?: Maybe<OnDemandCoursesV1>;
  getAll?: Maybe<OnDemandCoursesV1Connection>;
  multiGet?: Maybe<OnDemandCoursesV1Connection>;
  slug?: Maybe<OnDemandCoursesV1Connection>;
};


export type OnDemandCoursesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandCoursesV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCoursesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandCoursesV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandCoursesV1Slug = {
  __typename?: 'OnDemandCoursesV1Slug';
  connection?: Maybe<OnDemandCoursesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandCoursesV1_CmlMember = {
  __typename?: 'OnDemandCoursesV1_cmlMember';
  cml: OnDemandCoursesV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type OnDemandCoursesV1_Org_Coursera_Authoring_Course_AuthoringCourseAssetLibraryAccessibilitySettings = {
  __typename?: 'OnDemandCoursesV1_org_coursera_authoring_course_AuthoringCourseAssetLibraryAccessibilitySettings';
  isImageDescriptionAutoGenerationOn: Scalars['Boolean'];
  minAutoGeneratedImageDescriptionConfidenceLevel: Scalars['Float'];
};

/** Defined domain/subdomain type for a course */
export type OnDemandCoursesV1_Org_Coursera_Catalogp_Browse_DomainType = {
  __typename?: 'OnDemandCoursesV1_org_coursera_catalogp_browse_DomainType';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandCoursesV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandCoursesV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandCoursesV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandCoursesV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandCoursesV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandCoursesV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandCoursesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandCoursesV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandCoursesV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandCoursesV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandCoursesV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export const OnDemandCoursesV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Course_CourseStatus = typeof OnDemandCoursesV1_Org_Coursera_Course_CourseStatus[keyof typeof OnDemandCoursesV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant = typeof OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof OnDemandCoursesV1_Org_Coursera_Course_PremiumExperienceVariant];
export type OnDemandCoursesV1_Org_Coursera_Ondemand_Common_CourseQnA = {
  __typename?: 'OnDemandCoursesV1_org_coursera_ondemand_common_CourseQnA';
  answer: OnDemandCoursesV1_CmlMember;
  /** Typeref for string that defines the isTranslatable property to true */
  question: Scalars['String'];
};

export const OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof OnDemandCoursesV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandCoursesV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandCoursesV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandCoursesV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type OnDemandCoursesV1_RecommendedBackground = DummyType | OnDemandCoursesV1_CmlMember;

export type OnDemandInstructorNotesV1 = {
  __typename?: 'OnDemandInstructorNotesV1';
  body: Scalars['String'];
  context: OnDemandInstructorNotesV1_Context;
  id: Scalars['String'];
  instructorIds: Array<Maybe<OnDemandInstructorNotesV1_Org_Coursera_Opencourse_Model_InstructorId>>;
  title: Scalars['String'];
};

export type OnDemandInstructorNotesV1AllNotesByCourse = {
  __typename?: 'OnDemandInstructorNotesV1AllNotesByCourse';
  connection?: Maybe<OnDemandInstructorNotesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandInstructorNotesV1ByCourse = {
  __typename?: 'OnDemandInstructorNotesV1ByCourse';
  connection?: Maybe<OnDemandInstructorNotesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandInstructorNotesV1ByModule = {
  __typename?: 'OnDemandInstructorNotesV1ByModule';
  connection?: Maybe<OnDemandInstructorNotesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  moduleId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandInstructorNotesV1Connection = {
  __typename?: 'OnDemandInstructorNotesV1Connection';
  elements: Array<Maybe<OnDemandInstructorNotesV1>>;
  paging: ResponsePagination;
};

export type OnDemandInstructorNotesV1Resource = {
  __typename?: 'OnDemandInstructorNotesV1Resource';
  allNotesByCourse?: Maybe<OnDemandInstructorNotesV1Connection>;
  byCourse?: Maybe<OnDemandInstructorNotesV1Connection>;
  byModule?: Maybe<OnDemandInstructorNotesV1Connection>;
  get?: Maybe<OnDemandInstructorNotesV1>;
};


export type OnDemandInstructorNotesV1ResourceAllNotesByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandInstructorNotesV1ResourceByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandInstructorNotesV1ResourceByModuleArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  moduleId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandInstructorNotesV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type OnDemandInstructorNotesV1ResourceMutations = {
  __typename?: 'OnDemandInstructorNotesV1ResourceMutations';
  create?: Maybe<OnDemandInstructorNotesV1Connection>;
  delete?: Maybe<OnDemandInstructorNotesV1Connection>;
  update?: Maybe<OnDemandInstructorNotesV1Connection>;
  updateOrCreate?: Maybe<Scalars['JSON']>;
};


export type OnDemandInstructorNotesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandInstructorNotesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};


export type OnDemandInstructorNotesV1ResourceMutationsUpdateOrCreateArgs = {
  id: Scalars['String'];
};

export type OnDemandInstructorNotesV1_Context = OnDemandInstructorNotesV1_CourseContextMember | OnDemandInstructorNotesV1_ModuleContextMember;

export type OnDemandInstructorNotesV1_CourseContextMember = {
  __typename?: 'OnDemandInstructorNotesV1_courseContextMember';
  courseContext: OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_CourseContext;
};

export type OnDemandInstructorNotesV1_ModuleContextMember = {
  __typename?: 'OnDemandInstructorNotesV1_moduleContextMember';
  moduleContext: OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_ModuleContext;
};

export type OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_CourseContext = {
  __typename?: 'OnDemandInstructorNotesV1_org_coursera_ondemand_instructornote_CourseContext';
  courseId: Scalars['String'];
  position: OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position;
};

export type OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_ModuleContext = {
  __typename?: 'OnDemandInstructorNotesV1_org_coursera_ondemand_instructornote_ModuleContext';
  courseId: Scalars['String'];
  moduleId: Scalars['String'];
  position: OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position;
};

export const OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position = {
  End: 'end',
  Start: 'start'
} as const;

export type OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position = typeof OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position[keyof typeof OnDemandInstructorNotesV1_Org_Coursera_Ondemand_Instructornote_Position];
export type OnDemandInstructorNotesV1_Org_Coursera_Opencourse_Model_InstructorId = {
  __typename?: 'OnDemandInstructorNotesV1_org_coursera_opencourse_model_InstructorId';
  maestroId: Scalars['Int'];
  userId: OnDemandInstructorNotesV1_Org_Coursera_User_UserId;
};

export type OnDemandInstructorNotesV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandInstructorNotesV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1 = {
  __typename?: 'OnDemandLearnerMaterialItemsV1';
  contentSummary: OnDemandLearnerMaterialItemsV1_ContentSummary;
  courseId: Scalars['String'];
  dueAt?: Maybe<Scalars['Float']>;
  guidedItemProgressState?: Maybe<OnDemandLearnerMaterialItemsV1_GuidedItemProgressState>;
  id: Scalars['String'];
  isAllWorkDone?: Maybe<Scalars['Boolean']>;
  isCustomContent: Scalars['Boolean'];
  isDeadlineWorkDone?: Maybe<Scalars['Boolean']>;
  isEvaluable: Scalars['Boolean'];
  isOverallPassed?: Maybe<Scalars['Boolean']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  isPassable: Scalars['Boolean'];
  isPassedOrCompleted?: Maybe<Scalars['Boolean']>;
  isPendingPassed?: Maybe<Scalars['Boolean']>;
  isVerificationPending?: Maybe<Scalars['Boolean']>;
  isVerifiedPassed?: Maybe<Scalars['Boolean']>;
  itemId: Scalars['String'];
  learnerMaterialId: Scalars['String'];
  learnerMaterialLessonElementId: Scalars['String'];
  learnerMaterialLessonId: Scalars['String'];
  learnerMaterialModuleId: Scalars['String'];
  learnerMaterialWeekNumber: Scalars['String'];
  /** Identifier for an element in a lesson. */
  lessonElementId: Scalars['String'];
  /** ID of a lesson in a course. This will never change and is unique within the course. */
  lessonId: Scalars['String'];
  lockState?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState>;
  lockSummary?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary>;
  /** Identifier for an item. This will never change and is unique within the course. */
  lockableByItem?: Maybe<Scalars['String']>;
  lockableByLearnerMaterialItem?: Maybe<Scalars['String']>;
  /** ID of a module in a course. It will never change and is unique within the course. */
  moduleId: Scalars['String'];
  name: Scalars['String'];
  overallGrade?: Maybe<Scalars['Float']>;
  pendingGrade?: Maybe<Scalars['Float']>;
  /** Marker type for arbitrary JSON data. WARN: Provided for compatibility with existing data models only. Please define schemas for all data. If enveloping is required, please ask infrastructure team about 'AnyRecord'. This will be deprecated once `AnyRecord` is available. */
  progressContent?: Maybe<Scalars['JSON']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  totalWorkDuration: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
  userId: OnDemandLearnerMaterialItemsV1_Org_Coursera_User_UserId;
  verifiedGrade?: Maybe<Scalars['Float']>;
  weekNumber: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1Connection = {
  __typename?: 'OnDemandLearnerMaterialItemsV1Connection';
  elements: Array<Maybe<OnDemandLearnerMaterialItemsV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerMaterialItemsV1EvaluableHonorItems = {
  __typename?: 'OnDemandLearnerMaterialItemsV1EvaluableHonorItems';
  connection?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  ids: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1Items = {
  __typename?: 'OnDemandLearnerMaterialItemsV1Items';
  connection?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  courseId: Scalars['String'];
  itemIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1PassableNonHonorItems = {
  __typename?: 'OnDemandLearnerMaterialItemsV1PassableNonHonorItems';
  connection?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  ids: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1Resource = {
  __typename?: 'OnDemandLearnerMaterialItemsV1Resource';
  evaluableHonorItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  get?: Maybe<OnDemandLearnerMaterialItemsV1>;
  items?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  multiGet?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  passableNonHonorItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
};


export type OnDemandLearnerMaterialItemsV1ResourceEvaluableHonorItemsArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialItemsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandLearnerMaterialItemsV1ResourceItemsArgs = {
  courseId: Scalars['String'];
  itemIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialItemsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialItemsV1ResourcePassableNonHonorItemsArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_AssessOpenSinglePageMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_assessOpenSinglePageMember';
  assessOpenSinglePage: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_BlockingAssessmentLockInfoMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_blockingAssessmentLockInfoMember';
  blockingAssessmentLockInfo: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo;
};

export type OnDemandLearnerMaterialItemsV1_ClosedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_closedPeerMember';
  closedPeer: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_CoachMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_coachMember';
  coach: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_CompoundLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_compoundLatePenaltyMember';
  compoundLatePenalty: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type OnDemandLearnerMaterialItemsV1_ContentSummary = OnDemandLearnerMaterialItemsV1_AssessOpenSinglePageMember | OnDemandLearnerMaterialItemsV1_ClosedPeerMember | OnDemandLearnerMaterialItemsV1_CoachMember | OnDemandLearnerMaterialItemsV1_DiscussionPromptMember | OnDemandLearnerMaterialItemsV1_ExamMember | OnDemandLearnerMaterialItemsV1_GradedCoachMember | OnDemandLearnerMaterialItemsV1_GradedDiscussionPromptMember | OnDemandLearnerMaterialItemsV1_GradedLabMember | OnDemandLearnerMaterialItemsV1_GradedLtiMember | OnDemandLearnerMaterialItemsV1_GradedPeerMember | OnDemandLearnerMaterialItemsV1_GradedProgrammingMember | OnDemandLearnerMaterialItemsV1_GradedWidgetMember | OnDemandLearnerMaterialItemsV1_LectureMember | OnDemandLearnerMaterialItemsV1_NotebookMember | OnDemandLearnerMaterialItemsV1_PeerMember | OnDemandLearnerMaterialItemsV1_PhasedPeerMember | OnDemandLearnerMaterialItemsV1_PlaceholderMember | OnDemandLearnerMaterialItemsV1_ProgrammingMember | OnDemandLearnerMaterialItemsV1_QuizMember | OnDemandLearnerMaterialItemsV1_SingleQuestionSubmitMember | OnDemandLearnerMaterialItemsV1_SlideshowMember | OnDemandLearnerMaterialItemsV1_StaffGradedMember | OnDemandLearnerMaterialItemsV1_SupplementMember | OnDemandLearnerMaterialItemsV1_TeammateReviewMember | OnDemandLearnerMaterialItemsV1_UngradedAssignmentMember | OnDemandLearnerMaterialItemsV1_UngradedLabMember | OnDemandLearnerMaterialItemsV1_UngradedLtiMember | OnDemandLearnerMaterialItemsV1_UngradedProgrammingMember | OnDemandLearnerMaterialItemsV1_UngradedWidgetMember | OnDemandLearnerMaterialItemsV1_WiseFlowMember | OnDemandLearnerMaterialItemsV1_WorkspaceLauncherMember;

export type OnDemandLearnerMaterialItemsV1_DiscussionPromptMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_discussionPromptMember';
  discussionPrompt: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_ExamMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_examMember';
  exam: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_FixedGradingLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type OnDemandLearnerMaterialItemsV1_GradedCoachMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedCoachMember';
  gradedCoach: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedCoachSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedDiscussionPromptMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedLabMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedLabMember';
  gradedLab: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedLabSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedLtiMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedLtiMember';
  gradedLti: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedPeerMember';
  gradedPeer: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedProgrammingMember';
  gradedProgramming: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradedWidgetMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_gradedWidgetMember';
  gradedWidget: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_GradingLatePenalty = OnDemandLearnerMaterialItemsV1_CompoundLatePenaltyMember | OnDemandLearnerMaterialItemsV1_FixedGradingLatePenaltyMember | OnDemandLearnerMaterialItemsV1_IncrementalGradingLatePenaltyMember;

export type OnDemandLearnerMaterialItemsV1_GuidedItemProgressState = OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_NonPassableItemProgressStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PassableItemProgressStateMember;

export type OnDemandLearnerMaterialItemsV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type OnDemandLearnerMaterialItemsV1_LectureMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_lectureMember';
  lecture: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

/** Union type used in ItemLockInfo to hold specific information on the different types of locks */
export type OnDemandLearnerMaterialItemsV1_LockInfo = OnDemandLearnerMaterialItemsV1_BlockingAssessmentLockInfoMember | OnDemandLearnerMaterialItemsV1_TimedReleaseContentLockInfoMember;

export type OnDemandLearnerMaterialItemsV1_NotebookMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_notebookMember';
  notebook: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_BlockingAssessment';
  assessmentId: OnDemandLearnerMaterialItemsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember;
  courseBranchId: Scalars['String'];
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_BlockingAssessmentLockInfo';
  blockingAssessments: Array<Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment>>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_CoachSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_CoachSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedCoachSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedCoachSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedLabSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedLabSummaryDefinition';
  passingFraction: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  iframeTitle?: Maybe<Scalars['String']>;
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_ItemLockState';
  lockStatus: Org_Coursera_Ondemand_Coursematerial_ItemLockStatus;
  reasonCode: Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode;
};

/** Holds ItemLockState along with additional info depending on the type of lock. */
export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_ItemLockSummary';
  isPreviewableByCourseStaff?: Maybe<Scalars['Boolean']>;
  lockInfo?: Maybe<OnDemandLearnerMaterialItemsV1_LockInfo>;
  lockState: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  assignmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialItemsV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

/** Holds the time in which a TimedReleaseContent item will be unlocked and when it will be locked again */
export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_TimedReleaseContentLockInfo';
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  unlockedTimeEnd?: Maybe<Scalars['Float']>;
  unlockedTimeStart?: Maybe<Scalars['Float']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  assignmentFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  iframeTitle?: Maybe<Scalars['String']>;
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_DiscussionPromptAssignmentStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_DiscussionPromptAssignmentStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_LtiStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_LtiStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_NonPassableItemProgressState = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_NonPassableItemProgressState';
  progressState: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_NonPassableItemProgressStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_NonPassableItemProgressStateMember';
  org_coursera_ondemand_guided_itemprogress_NonPassableItemProgressState: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_NonPassableItemProgressState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PassableItemProgressState = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_PassableItemProgressState';
  genericState: Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState;
  startedState?: Maybe<OnDemandLearnerMaterialItemsV1_StartedState>;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PassableItemProgressStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_PassableItemProgressStateMember';
  org_coursera_ondemand_guided_itemprogress_PassableItemProgressState: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PassableItemProgressState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_PeerStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_PeerStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_ProgrammingStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_ProgrammingStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_StaffGradedStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_StaffGradedStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedStateMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_ondemand_guided_itemprogress_TeammateReviewStartedStateMember';
  org_coursera_ondemand_guided_itemprogress_TeammateReviewStartedState: Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState;
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_staffgraded_StaffGradedAssignmentIdMember';
  org_coursera_staffgraded_StaffGradedAssignmentId: Scalars['String'];
};

export type OnDemandLearnerMaterialItemsV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialItemsV1_PeerMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_peerMember';
  peer: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_PhasedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_phasedPeerMember';
  phasedPeer: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_PlaceholderMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_placeholderMember';
  placeholder: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_ProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_programmingMember';
  programming: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_QuizMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_quizMember';
  quiz: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_SingleQuestionSubmitMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_singleQuestionSubmitMember';
  singleQuestionSubmit: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_SlideshowMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_slideshowMember';
  slideshow: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_StaffGradedMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_staffGradedMember';
  staffGraded: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_StartedState = OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedStateMember | OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedStateMember;

export type OnDemandLearnerMaterialItemsV1_SupplementMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_supplementMember';
  supplement: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_TeammateReviewMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_teammateReviewMember';
  teammateReview: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_TimedReleaseContentLockInfoMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_timedReleaseContentLockInfoMember';
  timedReleaseContentLockInfo: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo;
};

export type OnDemandLearnerMaterialItemsV1_UngradedAssignmentMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_ungradedAssignmentMember';
  ungradedAssignment: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_UngradedLabMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_ungradedLabMember';
  ungradedLab: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_UngradedLtiMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_ungradedLtiMember';
  ungradedLti: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_UngradedProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_ungradedProgrammingMember';
  ungradedProgramming: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_UngradedWidgetMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_ungradedWidgetMember';
  ungradedWidget: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_WiseFlowMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_wiseFlowMember';
  wiseFlow: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type OnDemandLearnerMaterialItemsV1_WorkspaceLauncherMember = {
  __typename?: 'OnDemandLearnerMaterialItemsV1_workspaceLauncherMember';
  workspaceLauncher: OnDemandLearnerMaterialItemsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export type OnDemandLearnerMaterialLessonsV1 = {
  __typename?: 'OnDemandLearnerMaterialLessonsV1';
  completedAllEvaluablesCount?: Maybe<Scalars['Int']>;
  completedAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  courseId: Scalars['String'];
  courses?: Maybe<Scalars['JSON']>;
  doneAllEvaluablesCount?: Maybe<Scalars['Int']>;
  doneAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneAllPassablesCount?: Maybe<Scalars['Int']>;
  doneAllPassablesPercentage?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneCorePassablesCount?: Maybe<Scalars['Int']>;
  doneCorePassablesPercentage?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  isEvaluable: Scalars['Boolean'];
  isPassable: Scalars['Boolean'];
  itemIds: Array<Maybe<Scalars['String']>>;
  items?: Maybe<Scalars['JSON']>;
  learnerMaterialId: Scalars['String'];
  learnerMaterialItemIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  learnerMaterialLessonElementIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialModuleId: Scalars['String'];
  learnerMaterialWeekNumber: Scalars['String'];
  lessonElementIds: Array<Maybe<Scalars['String']>>;
  lessonId: Scalars['String'];
  /** ID of a module in a course. It will never change and is unique within the course. */
  moduleId: Scalars['String'];
  modules?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  passableItemGroupChoices?: Maybe<Scalars['JSON']>;
  passableItemGroupIds: Array<Maybe<Scalars['String']>>;
  passableItemGroups?: Maybe<Scalars['JSON']>;
  passableLessonElements?: Maybe<Scalars['JSON']>;
  passedAllPassablesCount?: Maybe<Scalars['Int']>;
  passedAllPassablesPercentage?: Maybe<Scalars['Int']>;
  passedCorePassablesCount?: Maybe<Scalars['Int']>;
  passedCorePassablesPercentage?: Maybe<Scalars['Int']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  totalDuration?: Maybe<Scalars['Float']>;
  totalEvaluablesCount: Scalars['Int'];
  totalLectureDuration: Scalars['Float'];
  totalLecturesCount?: Maybe<Scalars['Int']>;
  totalPassablesCount: Scalars['Int'];
  totalPhasedPeerItemsCount: Scalars['Int'];
  totalQuizzesCount: Scalars['Int'];
  totalSupplementsCount?: Maybe<Scalars['Int']>;
  totalWorkDuration: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
  userId: OnDemandLearnerMaterialLessonsV1_Org_Coursera_User_UserId;
  weekNumber: Scalars['Int'];
  weeks?: Maybe<Scalars['JSON']>;
};


export type OnDemandLearnerMaterialLessonsV1LearnerMaterialItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialLessonsV1Connection = {
  __typename?: 'OnDemandLearnerMaterialLessonsV1Connection';
  elements: Array<Maybe<OnDemandLearnerMaterialLessonsV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerMaterialLessonsV1Lessons = {
  __typename?: 'OnDemandLearnerMaterialLessonsV1Lessons';
  connection?: Maybe<OnDemandLearnerMaterialLessonsV1Connection>;
  courseId: Scalars['String'];
  lessonIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialLessonsV1Resource = {
  __typename?: 'OnDemandLearnerMaterialLessonsV1Resource';
  get?: Maybe<OnDemandLearnerMaterialLessonsV1>;
  lessons?: Maybe<OnDemandLearnerMaterialLessonsV1Connection>;
  multiGet?: Maybe<OnDemandLearnerMaterialLessonsV1Connection>;
};


export type OnDemandLearnerMaterialLessonsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandLearnerMaterialLessonsV1ResourceLessonsArgs = {
  courseId: Scalars['String'];
  lessonIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialLessonsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialLessonsV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandLearnerMaterialLessonsV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialModulesV1 = {
  __typename?: 'OnDemandLearnerMaterialModulesV1';
  completedAllEvaluablesCount?: Maybe<Scalars['Int']>;
  completedAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  courseId: Scalars['String'];
  description: Scalars['String'];
  doneAllEvaluablesCount?: Maybe<Scalars['Int']>;
  doneAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneAllPassablesCount?: Maybe<Scalars['Int']>;
  doneAllPassablesPercentage?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneCorePassablesCount?: Maybe<Scalars['Int']>;
  doneCorePassablesPercentage?: Maybe<Scalars['Int']>;
  dueAt?: Maybe<Scalars['Float']>;
  guidedModuleTimeProgress?: Maybe<OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_GuidedModuleEstimateTimeProgress>;
  id: Scalars['String'];
  isAllWorkDone?: Maybe<Scalars['Boolean']>;
  isDeadlineWorkDone?: Maybe<Scalars['Boolean']>;
  isEvaluable: Scalars['Boolean'];
  isOverdue?: Maybe<Scalars['Boolean']>;
  isPassable: Scalars['Boolean'];
  isPassedOrCompleted?: Maybe<Scalars['Boolean']>;
  itemIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialId: Scalars['String'];
  learnerMaterialItemIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessonElementIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessonIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialWeekNumber: Scalars['String'];
  lessonElementIds: Array<Maybe<Scalars['String']>>;
  lessonIds: Array<Maybe<Scalars['String']>>;
  moduleId: Scalars['String'];
  name: Scalars['String'];
  passableItemGroupIds: Array<Maybe<Scalars['String']>>;
  passedAllPassablesCount?: Maybe<Scalars['Int']>;
  passedAllPassablesPercentage?: Maybe<Scalars['Int']>;
  passedCorePassablesCount?: Maybe<Scalars['Int']>;
  passedCorePassablesPercentage?: Maybe<Scalars['Int']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  totalDuration?: Maybe<Scalars['Float']>;
  totalEvaluablesCount: Scalars['Int'];
  totalLectureDuration: Scalars['Float'];
  totalLecturesCount?: Maybe<Scalars['Int']>;
  totalPassablesCount: Scalars['Int'];
  totalPhasedPeerItemsCount: Scalars['Int'];
  totalQuizzesCount: Scalars['Int'];
  totalSupplementsCount?: Maybe<Scalars['Int']>;
  totalWorkDuration: Scalars['Float'];
  userId: OnDemandLearnerMaterialModulesV1_Org_Coursera_User_UserId;
  weekNumber: Scalars['Int'];
};

export type OnDemandLearnerMaterialModulesV1Connection = {
  __typename?: 'OnDemandLearnerMaterialModulesV1Connection';
  elements: Array<Maybe<OnDemandLearnerMaterialModulesV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerMaterialModulesV1Modules = {
  __typename?: 'OnDemandLearnerMaterialModulesV1Modules';
  connection?: Maybe<OnDemandLearnerMaterialModulesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  moduleIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialModulesV1Resource = {
  __typename?: 'OnDemandLearnerMaterialModulesV1Resource';
  get?: Maybe<OnDemandLearnerMaterialModulesV1>;
  modules?: Maybe<OnDemandLearnerMaterialModulesV1Connection>;
  multiGet?: Maybe<OnDemandLearnerMaterialModulesV1Connection>;
};


export type OnDemandLearnerMaterialModulesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandLearnerMaterialModulesV1ResourceModulesArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  moduleIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialModulesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress = {
  __typename?: 'OnDemandLearnerMaterialModulesV1_org_coursera_ondemand_guided_timeprogress_EstimateTimeProgress';
  /** Identifier for an item. This will never change and is unique within the course. */
  nextItem?: Maybe<Scalars['String']>;
  remainingCount: Scalars['Int'];
  remainingDuration: Scalars['Float'];
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Float'];
};

export type OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_GuidedModuleEstimateTimeProgress = {
  __typename?: 'OnDemandLearnerMaterialModulesV1_org_coursera_ondemand_guided_timeprogress_GuidedModuleEstimateTimeProgress';
  lecturesProgress: OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  nonGradedAssessmentsProgress: OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  otherNonPassableItemsProgress: OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  readingsProgress: OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  totalItemsProgress: OnDemandLearnerMaterialModulesV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
};

export type OnDemandLearnerMaterialModulesV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandLearnerMaterialModulesV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialWeeksV1 = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1';
  completedAllEvaluablesCount?: Maybe<Scalars['Int']>;
  completedAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  courseId: Scalars['String'];
  courses?: Maybe<Scalars['JSON']>;
  doneAllEvaluablesCount?: Maybe<Scalars['Int']>;
  doneAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneAllPassablesCount?: Maybe<Scalars['Int']>;
  doneAllPassablesPercentage?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneCorePassablesCount?: Maybe<Scalars['Int']>;
  doneCorePassablesPercentage?: Maybe<Scalars['Int']>;
  dueAt?: Maybe<Scalars['Float']>;
  guidedTimeProgress?: Maybe<OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress>;
  guidedWeekTimeProgress?: Maybe<OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_GuidedWeekEstimateTimeProgress>;
  id: Scalars['String'];
  isAllWorkDone?: Maybe<Scalars['Boolean']>;
  isDeadlineWorkDone?: Maybe<Scalars['Boolean']>;
  isEvaluable: Scalars['Boolean'];
  isOverdue?: Maybe<Scalars['Boolean']>;
  isPassable: Scalars['Boolean'];
  isPassedOrCompleted?: Maybe<Scalars['Boolean']>;
  isProgressCurrent?: Maybe<Scalars['Boolean']>;
  isScheduleCurrent?: Maybe<Scalars['Boolean']>;
  itemIds: Array<Maybe<Scalars['String']>>;
  items?: Maybe<Scalars['JSON']>;
  learnerMaterialId: Scalars['String'];
  learnerMaterialItemIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  learnerMaterialLessonElementIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessonIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessons?: Maybe<OnDemandLearnerMaterialLessonsV1Connection>;
  learnerMaterialModuleIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialModules?: Maybe<OnDemandLearnerMaterialModulesV1Connection>;
  lessonElementIds: Array<Maybe<Scalars['String']>>;
  lessonIds: Array<Maybe<Scalars['String']>>;
  lessons?: Maybe<Scalars['JSON']>;
  moduleIds: Array<Maybe<Scalars['String']>>;
  modules?: Maybe<Scalars['JSON']>;
  passableItemGroupChoices?: Maybe<Scalars['JSON']>;
  passableItemGroupIds: Array<Maybe<Scalars['String']>>;
  passableItemGroups?: Maybe<Scalars['JSON']>;
  passableLessonElements?: Maybe<Scalars['JSON']>;
  passedAllPassablesCount?: Maybe<Scalars['Int']>;
  passedAllPassablesPercentage?: Maybe<Scalars['Int']>;
  passedCorePassablesCount?: Maybe<Scalars['Int']>;
  passedCorePassablesPercentage?: Maybe<Scalars['Int']>;
  totalDuration?: Maybe<Scalars['Float']>;
  totalEvaluablesCount: Scalars['Int'];
  totalLectureDuration: Scalars['Float'];
  totalLecturesCount?: Maybe<Scalars['Int']>;
  totalPassablesCount: Scalars['Int'];
  totalPhasedPeerItemsCount: Scalars['Int'];
  totalQuizzesCount: Scalars['Int'];
  totalSupplementsCount?: Maybe<Scalars['Int']>;
  totalWorkDuration: Scalars['Float'];
  userId: OnDemandLearnerMaterialWeeksV1_Org_Coursera_User_UserId;
  weekNumber: Scalars['Int'];
};


export type OnDemandLearnerMaterialWeeksV1LearnerMaterialItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialWeeksV1LearnerMaterialLessonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialWeeksV1LearnerMaterialModulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialWeeksV1Connection = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1Connection';
  elements: Array<Maybe<OnDemandLearnerMaterialWeeksV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerMaterialWeeksV1ProgressCurrent = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1ProgressCurrent';
  connection?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  courseId?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialWeeksV1Resource = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1Resource';
  get?: Maybe<OnDemandLearnerMaterialWeeksV1>;
  multiGet?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  progressCurrent?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  scheduleCurrent?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  weeks?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
};


export type OnDemandLearnerMaterialWeeksV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandLearnerMaterialWeeksV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialWeeksV1ResourceProgressCurrentArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialWeeksV1ResourceScheduleCurrentArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialWeeksV1ResourceWeeksArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  weekNumbers: Array<InputMaybe<Scalars['Int']>>;
};

export type OnDemandLearnerMaterialWeeksV1ScheduleCurrent = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1ScheduleCurrent';
  connection?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  courseId?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialWeeksV1Weeks = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1Weeks';
  connection?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  weekNumbers: Array<Maybe<Scalars['Int']>>;
};

export type OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1_org_coursera_ondemand_guided_timeprogress_EstimateTimeProgress';
  /** Identifier for an item. This will never change and is unique within the course. */
  nextItem?: Maybe<Scalars['String']>;
  remainingCount: Scalars['Int'];
  remainingDuration: Scalars['Float'];
  totalCount: Scalars['Int'];
  totalDuration: Scalars['Float'];
};

export type OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_GuidedWeekEstimateTimeProgress = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1_org_coursera_ondemand_guided_timeprogress_GuidedWeekEstimateTimeProgress';
  nonPassableItemsProgress: OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  passableItemsProgress: OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
  totalItemsProgress: OnDemandLearnerMaterialWeeksV1_Org_Coursera_Ondemand_Guided_Timeprogress_EstimateTimeProgress;
};

export type OnDemandLearnerMaterialWeeksV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandLearnerMaterialWeeksV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialsV1 = {
  __typename?: 'OnDemandLearnerMaterialsV1';
  completedAllEvaluablesCount?: Maybe<Scalars['Int']>;
  completedAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  completedCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  course?: Maybe<CoursesV1>;
  courseId: Scalars['String'];
  doneAllEvaluablesCount?: Maybe<Scalars['Int']>;
  doneAllEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneAllPassablesCount?: Maybe<Scalars['Int']>;
  doneAllPassablesPercentage?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesCount?: Maybe<Scalars['Int']>;
  doneCoreEvaluablesPercentage?: Maybe<Scalars['Int']>;
  doneCorePassablesCount?: Maybe<Scalars['Int']>;
  doneCorePassablesPercentage?: Maybe<Scalars['Int']>;
  evaluableHonorItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  gradedRequiredItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  guidedCourseNextSteps?: Maybe<GuidedCourseNextStepsV1>;
  id: Scalars['String'];
  isAllWorkDone?: Maybe<Scalars['Boolean']>;
  isDeadlineWorkDone?: Maybe<Scalars['Boolean']>;
  isEvaluable: Scalars['Boolean'];
  isOverallPassed?: Maybe<Scalars['Boolean']>;
  isPassable: Scalars['Boolean'];
  isPassedOrCompleted?: Maybe<Scalars['Boolean']>;
  isProgressCritical?: Maybe<Scalars['Boolean']>;
  isVerifiedPassed?: Maybe<Scalars['Boolean']>;
  itemIds: Array<Maybe<Scalars['String']>>;
  items?: Maybe<Scalars['JSON']>;
  learnerMaterialItemIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialItems?: Maybe<OnDemandLearnerMaterialItemsV1Connection>;
  learnerMaterialLessonElementIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessonIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialLessons?: Maybe<OnDemandLearnerMaterialLessonsV1Connection>;
  learnerMaterialModuleIds: Array<Maybe<Scalars['String']>>;
  learnerMaterialModules?: Maybe<OnDemandLearnerMaterialModulesV1Connection>;
  learnerMaterialWeekNumbers: Array<Maybe<Scalars['String']>>;
  lessonElementIds: Array<Maybe<Scalars['String']>>;
  lessonIds: Array<Maybe<Scalars['String']>>;
  lessons?: Maybe<Scalars['JSON']>;
  moduleIds: Array<Maybe<Scalars['String']>>;
  modules?: Maybe<Scalars['JSON']>;
  nextStep?: Maybe<OnDemandLearnerMaterialsV1_NextStep>;
  overallGrade?: Maybe<Scalars['Float']>;
  passableItemGroupChoices?: Maybe<Scalars['JSON']>;
  passableItemGroupIds: Array<Maybe<Scalars['String']>>;
  passableItemGroups?: Maybe<Scalars['JSON']>;
  passableLessonElements?: Maybe<Scalars['JSON']>;
  passedAllPassablesCount?: Maybe<Scalars['Int']>;
  passedAllPassablesPercentage?: Maybe<Scalars['Int']>;
  passedCorePassablesCount?: Maybe<Scalars['Int']>;
  passedCorePassablesPercentage?: Maybe<Scalars['Int']>;
  resources?: Maybe<OnDemandReferencesV1Connection>;
  summaryCoreProgressPercentage?: Maybe<Scalars['Int']>;
  totalDuration?: Maybe<Scalars['Float']>;
  totalEvaluablesCount: Scalars['Int'];
  totalLectureDuration: Scalars['Float'];
  totalLecturesCount?: Maybe<Scalars['Int']>;
  totalPassablesCount: Scalars['Int'];
  totalPhasedPeerItemsCount: Scalars['Int'];
  totalQuizzesCount: Scalars['Int'];
  totalSupplementsCount?: Maybe<Scalars['Int']>;
  userId: OnDemandLearnerMaterialsV1_Org_Coursera_User_UserId;
  verifiedGrade?: Maybe<Scalars['Float']>;
  weekNumbers: Array<Maybe<Scalars['Int']>>;
  weekProgress?: Maybe<OnDemandLearnerMaterialWeeksV1Connection>;
  weeks?: Maybe<Scalars['JSON']>;
};


export type OnDemandLearnerMaterialsV1CourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandLearnerMaterialsV1EvaluableHonorItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1GradedRequiredItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1GuidedCourseNextStepsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  stepsToSkip?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1LearnerMaterialItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1LearnerMaterialLessonsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1LearnerMaterialModulesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1ResourcesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1WeekProgressArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1Connection = {
  __typename?: 'OnDemandLearnerMaterialsV1Connection';
  elements: Array<Maybe<OnDemandLearnerMaterialsV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerMaterialsV1CourseSlugs = {
  __typename?: 'OnDemandLearnerMaterialsV1CourseSlugs';
  connection?: Maybe<OnDemandLearnerMaterialsV1Connection>;
  courseSlugs: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1Courses = {
  __typename?: 'OnDemandLearnerMaterialsV1Courses';
  anonymousAccess?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<OnDemandLearnerMaterialsV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1Resource = {
  __typename?: 'OnDemandLearnerMaterialsV1Resource';
  courseSlugs?: Maybe<OnDemandLearnerMaterialsV1Connection>;
  courses?: Maybe<OnDemandLearnerMaterialsV1Connection>;
  get?: Maybe<OnDemandLearnerMaterialsV1>;
  multiGet?: Maybe<OnDemandLearnerMaterialsV1Connection>;
};


export type OnDemandLearnerMaterialsV1ResourceCourseSlugsArgs = {
  courseSlugs: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1ResourceCoursesArgs = {
  anonymousAccess?: InputMaybe<Scalars['Boolean']>;
  courseIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerMaterialsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandLearnerMaterialsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_AssessOpenSinglePageMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_assessOpenSinglePageMember';
  assessOpenSinglePage: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_BlockingAssessmentLockInfoMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_blockingAssessmentLockInfoMember';
  blockingAssessmentLockInfo: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo;
};

export type OnDemandLearnerMaterialsV1_ClosedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_closedPeerMember';
  closedPeer: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_CompoundLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_compoundLatePenaltyMember';
  compoundLatePenalty: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty;
};

export type OnDemandLearnerMaterialsV1_ContentSummary = OnDemandLearnerMaterialsV1_AssessOpenSinglePageMember | OnDemandLearnerMaterialsV1_ClosedPeerMember | OnDemandLearnerMaterialsV1_DiscussionPromptMember | OnDemandLearnerMaterialsV1_ExamMember | OnDemandLearnerMaterialsV1_GradedDiscussionPromptMember | OnDemandLearnerMaterialsV1_GradedLtiMember | OnDemandLearnerMaterialsV1_GradedPeerMember | OnDemandLearnerMaterialsV1_GradedProgrammingMember | OnDemandLearnerMaterialsV1_GradedWidgetMember | OnDemandLearnerMaterialsV1_LectureMember | OnDemandLearnerMaterialsV1_NotebookMember | OnDemandLearnerMaterialsV1_PeerMember | OnDemandLearnerMaterialsV1_PhasedPeerMember | OnDemandLearnerMaterialsV1_PlaceholderMember | OnDemandLearnerMaterialsV1_ProgrammingMember | OnDemandLearnerMaterialsV1_QuizMember | OnDemandLearnerMaterialsV1_SingleQuestionSubmitMember | OnDemandLearnerMaterialsV1_SlideshowMember | OnDemandLearnerMaterialsV1_StaffGradedMember | OnDemandLearnerMaterialsV1_SupplementMember | OnDemandLearnerMaterialsV1_TeammateReviewMember | OnDemandLearnerMaterialsV1_UngradedAssignmentMember | OnDemandLearnerMaterialsV1_UngradedLabMember | OnDemandLearnerMaterialsV1_UngradedLtiMember | OnDemandLearnerMaterialsV1_UngradedProgrammingMember | OnDemandLearnerMaterialsV1_UngradedWidgetMember | OnDemandLearnerMaterialsV1_WiseFlowMember | OnDemandLearnerMaterialsV1_WorkspaceLauncherMember;

export type OnDemandLearnerMaterialsV1_DiscussionPromptMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_discussionPromptMember';
  discussionPrompt: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_ExamMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_examMember';
  exam: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_FixedGradingLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_fixedGradingLatePenaltyMember';
  fixedGradingLatePenalty: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty;
};

export type OnDemandLearnerMaterialsV1_GradedDiscussionPromptMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_gradedDiscussionPromptMember';
  gradedDiscussionPrompt: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_GradedLtiMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_gradedLtiMember';
  gradedLti: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_GradedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_gradedPeerMember';
  gradedPeer: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_GradedProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_gradedProgrammingMember';
  gradedProgramming: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_GradedWidgetMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_gradedWidgetMember';
  gradedWidget: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_GradingLatePenalty = OnDemandLearnerMaterialsV1_CompoundLatePenaltyMember | OnDemandLearnerMaterialsV1_FixedGradingLatePenaltyMember | OnDemandLearnerMaterialsV1_IncrementalGradingLatePenaltyMember;

export type OnDemandLearnerMaterialsV1_IncrementalGradingLatePenaltyMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_incrementalGradingLatePenaltyMember';
  incrementalGradingLatePenalty: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty;
};

export type OnDemandLearnerMaterialsV1_LectureMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_lectureMember';
  lecture: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition;
};

/** Union type used in ItemLockInfo to hold specific information on the different types of locks */
export type OnDemandLearnerMaterialsV1_LockInfo = OnDemandLearnerMaterialsV1_BlockingAssessmentLockInfoMember | OnDemandLearnerMaterialsV1_TimedReleaseContentLockInfoMember;

export type OnDemandLearnerMaterialsV1_NextStep = OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStepMember | OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseMaterialNextStepMember | OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionNextStepMember;

export type OnDemandLearnerMaterialsV1_NotebookMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_notebookMember';
  notebook: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition;
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature];
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_AssessOpenSinglePageSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_AssessOpenSinglePageSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_AttemptRateLimit';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_BlockingAssessment';
  assessmentId: OnDemandLearnerMaterialsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember;
  courseBranchId: Scalars['String'];
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessmentLockInfo = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_BlockingAssessmentLockInfo';
  blockingAssessments: Array<Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_BlockingAssessment>>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ClosedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_ClosedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

/** This model captures a set of late penalty policies that can be stacked on top of one another. */
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_CompoundLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_CompoundLatePenalty';
  incrementalPenalty?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement>;
  maxAllowedScore?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap>;
  minScorethreshold?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_CourseMaterialItem = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_CourseMaterialItem';
  contentSummary: OnDemandLearnerMaterialsV1_ContentSummary;
  isCustomContent: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  itemLockSummary?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary>;
  itemLockedReasonCode?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode>;
  /** ID of a lesson in a course. This will never change and is unique within the course. */
  lessonId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  lockableByItem?: Maybe<Scalars['String']>;
  lockedStatus?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus>;
  /** ID of a module in a course. It will never change and is unique within the course. */
  moduleId: Scalars['String'];
  name: Scalars['String'];
  originalName?: Maybe<Scalars['String']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  timeCommitment: Scalars['Float'];
  /** The id for a track within a course. Clients may make very strong assumptions about what types of tracks are in a course and how they should treat those tracks, so we express those assumptions in the structure of the ids. For example, clients may assume that courses have exactly one core track, so we define exactly one core track id. */
  trackId: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_FixedGradingLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_FixedGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_FormativeQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  lockingConfiguration?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedDiscussionPromptSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_GradedDiscussionPromptSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedLtiSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_GradedLtiSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_GradedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_GradedProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_GradedWidgetSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_GradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_ImmediateProgrammingSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_IncrementalGradingLatePenalty = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_IncrementalGradingLatePenalty';
  penalty: Scalars['Float'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_ItemLockState';
  lockStatus: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus;
  reasonCode: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode;
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
/** Holds ItemLockState along with additional info depending on the type of lock. */
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockSummary = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_ItemLockSummary';
  isPreviewableByCourseStaff?: Maybe<Scalars['Boolean']>;
  lockInfo?: Maybe<OnDemandLearnerMaterialsV1_LockInfo>;
  lockState: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockState;
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyIncrement = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_LatePenaltyIncrement';
  applyEvery: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxApplications?: Maybe<Scalars['Int']>;
  penalty: Scalars['Float'];
  penaltyMode: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyMinScoreThreshold = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_LatePenaltyMinScoreThreshold';
  minScoreForLatePenaltyApplication: Scalars['Float'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LatePenaltyScoreCap = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_LatePenaltyScoreCap';
  applyAfter: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod;
  maxFinalScore: Scalars['Float'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LectureSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_LectureSummaryDefinition';
  duration?: Maybe<Scalars['Float']>;
  hasInVideoAssessment: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_LegacyUngradedDiscussionPromptSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_NotebookSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_NotebookSummaryDefinition';
  isGradedByItem: Scalars['Boolean'];
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType];
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_PhasedPeerSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  isMentorGraded: Scalars['Boolean'];
  /** PeerProctorConfigurationId used in [[AtomPeerReviewAssignmentContent]] and references proctoring configuration stored in the new proctoring system once a peer review assignment is published. */
  proctorConfigurationId?: Maybe<Scalars['String']>;
  requiredReviewCount: Scalars['Int'];
  reviewDeadlineOffset: Scalars['Float'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_PlaceholderItemContentSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  learnerMessage?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_SingleQuestionSubmitQuizSummaryDefinition';
  containsWidgetQuestions: Scalars['Boolean'];
  questionCount?: Maybe<Scalars['Int']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_SlideshowSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_StaffGradedSummaryDefinition';
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_StandardPeerSummaryDefinition';
  isMentorGraded: Scalars['Boolean'];
  requiredReviewCount: Scalars['Int'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SummativeQuizSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_SummativeQuizSummaryDefinition';
  allowedSubmissionsInterval: Scalars['Float'];
  allowedSubmissionsPerInterval: Scalars['Int'];
  containsWidgetQuestions: Scalars['Boolean'];
  gradingLatePenalty?: Maybe<OnDemandLearnerMaterialsV1_GradingLatePenalty>;
  lockingConfiguration?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_AttemptRateLimit>;
  maxScore: Scalars['Float'];
  passingFraction: Scalars['Float'];
  passingScore: Scalars['Float'];
  questionCount: Scalars['Int'];
  requiredMobileCapabilities: Array<Maybe<Scalars['String']>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_SupplementSummaryDefinition';
  assetTypeName: Scalars['String'];
  containsWidget: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_TeammateReviewSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TimePeriod = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_TimePeriod';
  count: Scalars['Int'];
  periodType: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PeriodType;
};

/** Holds the time in which a TimedReleaseContent item will be unlocked and when it will be locked again */
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_TimedReleaseContentLockInfo';
  timedItemLockCustomMessage?: Maybe<Scalars['String']>;
  unlockedTimeEnd?: Maybe<Scalars['Float']>;
  unlockedTimeStart?: Maybe<Scalars['Float']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_UngradedAssignmentSummaryDefinition';
  isTeamSubmissionEnabled: Scalars['Boolean'];
  requiredMobileFeatures?: Maybe<Array<Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Assignment_AssignmentFeature>>>;
  standardProctorConfigurationId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_UngradedLabSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_UngradedLtiSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_UngradedProgrammingSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_UngradedWidgetSummaryDefinition';
  minHeightPx?: Maybe<Scalars['Int']>;
  minWidthPx?: Maybe<Scalars['Int']>;
  supportsTouch: Scalars['Boolean'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_WiseFlowContentSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_coursematerial_WorkspaceLauncherSummaryDefinition';
  ArbitraryField: Scalars['String'];
};

/** One of these next steps will be recommended when the learner has verified and passed a course. */
export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep = {
  BuyCourse: 'BuyCourse',
  CompleteVerificationProfile: 'CompleteVerificationProfile',
  EligibleButNoCertificate: 'EligibleButNoCertificate',
  NoVcCourseCompleted: 'NoVcCourseCompleted',
  ViewCertificate: 'ViewCertificate'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep];
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStepMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_guided_nextstep_CourseCompletedNextStepMember';
  org_coursera_ondemand_guided_nextstep_CourseCompletedNextStep: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseCompletedNextStep;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseMaterialNextStep = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_guided_nextstep_CourseMaterialNextStep';
  courseOnTrackStatus: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus;
  dueAt?: Maybe<Scalars['Float']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  passableItemDetails: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_CourseMaterialItem;
  /** Identifier for an item. This will never change and is unique within the course. */
  passableItemId: Scalars['String'];
  /** Identifier for an element in a lesson. */
  passableLessonElementId: Scalars['String'];
  preparatoryItemDetails?: Maybe<OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_CourseMaterialItem>;
  /** Identifier for an item. This will never change and is unique within the course. */
  preparatoryItemId?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseMaterialNextStepMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_guided_nextstep_CourseMaterialNextStepMember';
  org_coursera_ondemand_guided_nextstep_CourseMaterialNextStep: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_CourseMaterialNextStep;
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus = {
  MultipleDeadlinesOverdue: 'MultipleDeadlinesOverdue',
  OnTrack: 'OnTrack',
  SingleDeadlineOverdue: 'SingleDeadlineOverdue'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_LearnerCourseOnTrackStatus];
/** This next step is chosen when we want to recommend the learner to switch sessions. The associated information about which session to switch to extra will be obtained from the `LearnerSession` API, so we are not duplicating it here. */
export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionNextStep = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_guided_nextstep_SwitchSessionNextStep';
  activeSessionId: Scalars['String'];
  nextEnrollableSessionId?: Maybe<Scalars['String']>;
  reason: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason;
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionNextStepMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_ondemand_guided_nextstep_SwitchSessionNextStepMember';
  org_coursera_ondemand_guided_nextstep_SwitchSessionNextStep: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionNextStep;
};

export const OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason = {
  MultipleDeadlinesOverdue: 'MultipleDeadlinesOverdue',
  NotEnoughPeerReviews: 'NotEnoughPeerReviews',
  SessionEnded: 'SessionEnded'
} as const;

export type OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason = typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason[keyof typeof OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Guided_Nextstep_SwitchSessionReason];
export type OnDemandLearnerMaterialsV1_Org_Coursera_Staffgraded_StaffGradedAssignmentIdMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_staffgraded_StaffGradedAssignmentIdMember';
  org_coursera_staffgraded_StaffGradedAssignmentId: Scalars['String'];
};

export type OnDemandLearnerMaterialsV1_Org_Coursera_User_UserId = {
  __typename?: 'OnDemandLearnerMaterialsV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export type OnDemandLearnerMaterialsV1_PeerMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_peerMember';
  peer: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_StandardPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_PhasedPeerMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_phasedPeerMember';
  phasedPeer: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PhasedPeerSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_PlaceholderMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_placeholderMember';
  placeholder: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_PlaceholderItemContentSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_ProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_programmingMember';
  programming: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_ImmediateProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_QuizMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_quizMember';
  quiz: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_FormativeQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_SingleQuestionSubmitMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_singleQuestionSubmitMember';
  singleQuestionSubmit: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SingleQuestionSubmitQuizSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_SlideshowMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_slideshowMember';
  slideshow: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SlideshowSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_StaffGradedMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_staffGradedMember';
  staffGraded: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_StaffGradedSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_SupplementMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_supplementMember';
  supplement: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_SupplementSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_TeammateReviewMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_teammateReviewMember';
  teammateReview: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TeammateReviewSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_TimedReleaseContentLockInfoMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_timedReleaseContentLockInfoMember';
  timedReleaseContentLockInfo: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_TimedReleaseContentLockInfo;
};

export type OnDemandLearnerMaterialsV1_UngradedAssignmentMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_ungradedAssignmentMember';
  ungradedAssignment: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedAssignmentSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_UngradedLabMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_ungradedLabMember';
  ungradedLab: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLabSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_UngradedLtiMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_ungradedLtiMember';
  ungradedLti: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedLtiSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_UngradedProgrammingMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_ungradedProgrammingMember';
  ungradedProgramming: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedProgrammingSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_UngradedWidgetMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_ungradedWidgetMember';
  ungradedWidget: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_UngradedWidgetSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_WiseFlowMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_wiseFlowMember';
  wiseFlow: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_WiseFlowContentSummaryDefinition;
};

export type OnDemandLearnerMaterialsV1_WorkspaceLauncherMember = {
  __typename?: 'OnDemandLearnerMaterialsV1_workspaceLauncherMember';
  workspaceLauncher: OnDemandLearnerMaterialsV1_Org_Coursera_Ondemand_Coursematerial_WorkspaceLauncherSummaryDefinition;
};

export type OnDemandLearnerSessionsV1 = {
  __typename?: 'OnDemandLearnerSessionsV1';
  courseId: Scalars['String'];
  endsAt: Scalars['Float'];
  enrollmentEndsAt: Scalars['Float'];
  enrollmentStartsAt: Scalars['Float'];
  id: Scalars['String'];
  isActiveEnrollment: Scalars['Boolean'];
  isEnrollableNow: Scalars['Boolean'];
  isEnrolled: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  isRunningNow: Scalars['Boolean'];
  sessionSwitch: OnDemandLearnerSessionsV1_Org_Coursera_Ondemand_Session_Membership_LearnerSessionSwitch;
  startsAt: Scalars['Float'];
  userId: Scalars['Int'];
};

export type OnDemandLearnerSessionsV1ActiveAndUpcoming = {
  __typename?: 'OnDemandLearnerSessionsV1ActiveAndUpcoming';
  connection?: Maybe<OnDemandLearnerSessionsV1Connection>;
  courseId?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  learnerId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerSessionsV1Connection = {
  __typename?: 'OnDemandLearnerSessionsV1Connection';
  elements: Array<Maybe<OnDemandLearnerSessionsV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerSessionsV1Resource = {
  __typename?: 'OnDemandLearnerSessionsV1Resource';
  activeAndUpcoming?: Maybe<OnDemandLearnerSessionsV1Connection>;
  runningAndUpcoming?: Maybe<OnDemandLearnerSessionsV1Connection>;
};


export type OnDemandLearnerSessionsV1ResourceActiveAndUpcomingArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  learnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerSessionsV1ResourceRunningAndUpcomingArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  courseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  learnerId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerSessionsV1RunningAndUpcoming = {
  __typename?: 'OnDemandLearnerSessionsV1RunningAndUpcoming';
  connection?: Maybe<OnDemandLearnerSessionsV1Connection>;
  courseId?: Maybe<Scalars['String']>;
  courseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  learnerId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerSessionsV1_CmlMember = {
  __typename?: 'OnDemandLearnerSessionsV1_cmlMember';
  cml: OnDemandLearnerSessionsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandLearnerSessionsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandLearnerSessionsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandLearnerSessionsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandLearnerSessionsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandLearnerSessionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandLearnerSessionsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandLearnerSessionsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandLearnerSessionsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandLearnerSessionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

/** Naming note: This is not yet personalized to a particular learner but we include "learner" in the name so we can eventually include learner-specific fields like how will your progress change, how many new assignments will you need to attempt, etc. */
export type OnDemandLearnerSessionsV1_Org_Coursera_Ondemand_Session_Membership_LearnerSessionSwitch = {
  __typename?: 'OnDemandLearnerSessionsV1_org_coursera_ondemand_session_membership_LearnerSessionSwitch';
  canSwitch: Scalars['Boolean'];
  changesDescription?: Maybe<OnDemandLearnerSessionsV1_CmlMember>;
  isRecommendedSwitch: Scalars['Boolean'];
};

export type OnDemandLearnerSummariesForSelfV1 = {
  __typename?: 'OnDemandLearnerSummariesForSelfV1';
  assessments?: Maybe<TeammateReviewAssessmentsV2Connection>;
  hasProvidedEnoughReviews: Scalars['Boolean'];
  hasReceivedEnoughReviews: Scalars['Boolean'];
  id: Scalars['Int'];
  reviews?: Maybe<TeammateReviewDraftsV1Connection>;
  scopeId: Scalars['String'];
  staffReview?: Maybe<TeammateReviewSubmittedStaffReviewsV1>;
  staffReviewId?: Maybe<Scalars['String']>;
  team?: Maybe<TeamworkTeamsV1>;
  teamId: Scalars['String'];
  teammates: Array<Maybe<OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_External_TeammateRevieweeMetadata>>;
};


export type OnDemandLearnerSummariesForSelfV1AssessmentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerSummariesForSelfV1ReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerSummariesForSelfV1StaffReviewArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerSummariesForSelfV1Connection = {
  __typename?: 'OnDemandLearnerSummariesForSelfV1Connection';
  elements: Array<Maybe<OnDemandLearnerSummariesForSelfV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerSummariesForSelfV1Resource = {
  __typename?: 'OnDemandLearnerSummariesForSelfV1Resource';
  userCourseItem?: Maybe<OnDemandLearnerSummariesForSelfV1Connection>;
};


export type OnDemandLearnerSummariesForSelfV1ResourceUserCourseItemArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandLearnerSummariesForSelfV1UserCourseItem = {
  __typename?: 'OnDemandLearnerSummariesForSelfV1UserCourseItem';
  connection?: Maybe<OnDemandLearnerSummariesForSelfV1Connection>;
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export const OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus = {
  Ineligible: 'INELIGIBLE',
  NotStarted: 'NOT_STARTED',
  Started: 'STARTED',
  Submitted: 'SUBMITTED'
} as const;

export type OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus = typeof OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus[keyof typeof OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus];
/** Describes the state of one teammate vis-a-vis a reviewer. */
export type OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_External_TeammateRevieweeMetadata = {
  __typename?: 'OnDemandLearnerSummariesForSelfV1_org_coursera_teammatereview_external_TeammateRevieweeMetadata';
  assessmentId: Scalars['String'];
  reviewId?: Maybe<Scalars['String']>;
  /** id for a Coursera user */
  revieweeId: Scalars['Int'];
  status: OnDemandLearnerSummariesForSelfV1_Org_Coursera_Teammatereview_TeammateReviewStatus;
};

export type OnDemandLearnerSummariesForStaffV1 = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1';
  assessment?: Maybe<TeammateReviewAssessmentsV2>;
  assessmentId: Scalars['String'];
  id: Scalars['Int'];
  numberOfTeammateReviewsProvided: Scalars['Int'];
  numberOfTeammateReviewsReceived: Scalars['Int'];
  receivedReviewIds: Array<Maybe<Scalars['String']>>;
  receivedReviews?: Maybe<OnDemandSubmittedTeammateReviewsResourceV1Connection>;
  requiredNumberOfTeammateReviews: Scalars['Int'];
  staffReview?: Maybe<TeammateReviewStaffReviewDraftsV1>;
  staffReviewId?: Maybe<Scalars['String']>;
  staffReviewStatus: OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus;
  /** We used to have a lot of different models for conflict metadata accross the Authoring service. The FE doesn't need to know what fields are in conflict metadata because it is only useful for conflict detection. Therefore, to unify the behavior we encrypt all different types of conflict metadata into a string ((see [[WriteAccessTokenEncrypter]])), namely WriteAccessToken, and return it to the FE. If we don't want to grant write access to the FE, we would just not return the field. WriteAccessToken serves 2 purposes: write access control and conflict detection. */
  staffReviewWriteAccessToken: Scalars['String'];
  team?: Maybe<TeamworkTeamsV1>;
  teamId: Scalars['String'];
};


export type OnDemandLearnerSummariesForStaffV1ReceivedReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandLearnerSummariesForStaffV1Connection = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1Connection';
  elements: Array<Maybe<OnDemandLearnerSummariesForStaffV1>>;
  paging: ResponsePagination;
};

export type OnDemandLearnerSummariesForStaffV1CourseGroupItem = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1CourseGroupItem';
  connection?: Maybe<OnDemandLearnerSummariesForStaffV1Connection>;
  courseId: Scalars['String'];
  groupId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandLearnerSummariesForStaffV1Resource = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1Resource';
  courseGroupItem?: Maybe<OnDemandLearnerSummariesForStaffV1Connection>;
  userCourseItem?: Maybe<OnDemandLearnerSummariesForStaffV1Connection>;
};


export type OnDemandLearnerSummariesForStaffV1ResourceCourseGroupItemArgs = {
  courseId: Scalars['String'];
  groupId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandLearnerSummariesForStaffV1ResourceUserCourseItemArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandLearnerSummariesForStaffV1ResourceMutations = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1ResourceMutations';
  releaseGrades?: Maybe<Scalars['JSON']>;
};


export type OnDemandLearnerSummariesForStaffV1ResourceMutationsReleaseGradesArgs = {
  groupId: Scalars['String'];
  itemId: Scalars['String'];
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};

export type OnDemandLearnerSummariesForStaffV1UserCourseItem = {
  __typename?: 'OnDemandLearnerSummariesForStaffV1UserCourseItem';
  connection?: Maybe<OnDemandLearnerSummariesForStaffV1Connection>;
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export const OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus = {
  Completed: 'COMPLETED',
  NotStarted: 'NOT_STARTED',
  Released: 'RELEASED',
  Started: 'STARTED'
} as const;

export type OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus = typeof OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus[keyof typeof OnDemandLearnerSummariesForStaffV1_Org_Coursera_Teammatereview_StaffReviewStatus];
export type OnDemandMentorForumsV1 = {
  __typename?: 'OnDemandMentorForumsV1';
  courseId: Scalars['String'];
  description: OnDemandMentorForumsV1_CmlMember;
  forumType: OnDemandMentorForumsV1_MentorForumTypeMember;
  id: Scalars['String'];
  legacyForumId?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  parentForumId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type OnDemandMentorForumsV1Connection = {
  __typename?: 'OnDemandMentorForumsV1Connection';
  elements: Array<Maybe<OnDemandMentorForumsV1>>;
  paging: ResponsePagination;
};

export type OnDemandMentorForumsV1Course = {
  __typename?: 'OnDemandMentorForumsV1Course';
  connection?: Maybe<OnDemandMentorForumsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandMentorForumsV1MentorForumType = {
  __typename?: 'OnDemandMentorForumsV1MentorForumType';
  connection?: Maybe<OnDemandMentorForumsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  mentorForumType: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandMentorForumsV1ParentForum = {
  __typename?: 'OnDemandMentorForumsV1ParentForum';
  connection?: Maybe<OnDemandMentorForumsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  parentForumId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandMentorForumsV1Resource = {
  __typename?: 'OnDemandMentorForumsV1Resource';
  course?: Maybe<OnDemandMentorForumsV1Connection>;
  get?: Maybe<OnDemandMentorForumsV1>;
  mentorForumType?: Maybe<OnDemandMentorForumsV1Connection>;
  parentForum?: Maybe<OnDemandMentorForumsV1Connection>;
};


export type OnDemandMentorForumsV1ResourceCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandMentorForumsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandMentorForumsV1ResourceMentorForumTypeArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  mentorForumType: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandMentorForumsV1ResourceParentForumArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  parentForumId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandMentorForumsV1_CmlMember = {
  __typename?: 'OnDemandMentorForumsV1_cmlMember';
  cml: OnDemandMentorForumsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type OnDemandMentorForumsV1_MentorForumTypeMember = {
  __typename?: 'OnDemandMentorForumsV1_mentorForumTypeMember';
  mentorForumType: OnDemandMentorForumsV1_Org_Coursera_Ondemand_Discussion_Forum_Mentor_BasicMentorForumType;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandMentorForumsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandMentorForumsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandMentorForumsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandMentorForumsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandMentorForumsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandMentorForumsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandMentorForumsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type OnDemandMentorForumsV1_Org_Coursera_Ondemand_Discussion_Forum_Mentor_BasicMentorForumType = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_ondemand_discussion_forum_mentor_BasicMentorForumType';
  ArbitraryField: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandMentorForumsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandMentorForumsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandMentorForumsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type OnDemandReferencesV1 = {
  __typename?: 'OnDemandReferencesV1';
  content: OnDemandReferencesV1_Org_Coursera_Ondemand_Reference_AssetReferenceContentMember;
  id: Scalars['String'];
  name: Scalars['String'];
  /** URL-friendly short id that is unique within the course. */
  shortId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export type OnDemandReferencesV1Connection = {
  __typename?: 'OnDemandReferencesV1Connection';
  elements: Array<Maybe<OnDemandReferencesV1>>;
  paging: ResponsePagination;
};

export type OnDemandReferencesV1CourseListed = {
  __typename?: 'OnDemandReferencesV1CourseListed';
  connection?: Maybe<OnDemandReferencesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandReferencesV1Resource = {
  __typename?: 'OnDemandReferencesV1Resource';
  courseListed?: Maybe<OnDemandReferencesV1Connection>;
  shortId?: Maybe<OnDemandReferencesV1Connection>;
};


export type OnDemandReferencesV1ResourceCourseListedArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandReferencesV1ResourceShortIdArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  shortId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandReferencesV1ShortId = {
  __typename?: 'OnDemandReferencesV1ShortId';
  connection?: Maybe<OnDemandReferencesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  shortId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandReferencesV1_Org_Coursera_Ondemand_Reference_AssetReferenceContent = {
  __typename?: 'OnDemandReferencesV1_org_coursera_ondemand_reference_AssetReferenceContent';
  assetId: Scalars['String'];
};

export type OnDemandReferencesV1_Org_Coursera_Ondemand_Reference_AssetReferenceContentMember = {
  __typename?: 'OnDemandReferencesV1_org_coursera_ondemand_reference_AssetReferenceContentMember';
  org_coursera_ondemand_reference_AssetReferenceContent: OnDemandReferencesV1_Org_Coursera_Ondemand_Reference_AssetReferenceContent;
};

export type OnDemandSessionMembershipsV1 = {
  __typename?: 'OnDemandSessionMembershipsV1';
  courseId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  id: Scalars['String'];
  personalizedSchedule?: Maybe<OnDemandSessionMembershipsV1_Org_Coursera_Ondemand_Schedule_PersonalizedSchedule>;
  session?: Maybe<OnDemandSessionsV1>;
  sessions?: Maybe<Scalars['JSON']>;
  userId: Scalars['Int'];
};

export type OnDemandSessionMembershipsV1ActiveByUserAndCourse = {
  __typename?: 'OnDemandSessionMembershipsV1ActiveByUserAndCourse';
  connection?: Maybe<OnDemandSessionMembershipsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSessionMembershipsV1AllBySession = {
  __typename?: 'OnDemandSessionMembershipsV1AllBySession';
  connection?: Maybe<OnDemandSessionMembershipsV1Connection>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSessionMembershipsV1BySession = {
  __typename?: 'OnDemandSessionMembershipsV1BySession';
  connection?: Maybe<OnDemandSessionMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSessionMembershipsV1ByUser = {
  __typename?: 'OnDemandSessionMembershipsV1ByUser';
  connection?: Maybe<OnDemandSessionMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSessionMembershipsV1ByUserAndCourse = {
  __typename?: 'OnDemandSessionMembershipsV1ByUserAndCourse';
  connection?: Maybe<OnDemandSessionMembershipsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSessionMembershipsV1Connection = {
  __typename?: 'OnDemandSessionMembershipsV1Connection';
  elements: Array<Maybe<OnDemandSessionMembershipsV1>>;
  paging: ResponsePagination;
};

export type OnDemandSessionMembershipsV1Resource = {
  __typename?: 'OnDemandSessionMembershipsV1Resource';
  activeByUserAndCourse?: Maybe<OnDemandSessionMembershipsV1Connection>;
  allBySession?: Maybe<OnDemandSessionMembershipsV1Connection>;
  bySession?: Maybe<OnDemandSessionMembershipsV1Connection>;
  byUser?: Maybe<OnDemandSessionMembershipsV1Connection>;
  byUserAndCourse?: Maybe<OnDemandSessionMembershipsV1Connection>;
  get?: Maybe<OnDemandSessionMembershipsV1>;
  multiGet?: Maybe<OnDemandSessionMembershipsV1Connection>;
};


export type OnDemandSessionMembershipsV1ResourceActiveByUserAndCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandSessionMembershipsV1ResourceAllBySessionArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionMembershipsV1ResourceBySessionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sessionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionMembershipsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandSessionMembershipsV1ResourceByUserAndCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandSessionMembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionMembershipsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandSessionMembershipsV1ResourceMutations = {
  __typename?: 'OnDemandSessionMembershipsV1ResourceMutations';
  create?: Maybe<OnDemandSessionMembershipsV1Connection>;
  delete?: Maybe<OnDemandSessionMembershipsV1Connection>;
  switch?: Maybe<Scalars['JSON']>;
};


export type OnDemandSessionMembershipsV1ResourceMutationsCreateArgs = {
  skipNotification?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandSessionMembershipsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};

export type OnDemandSessionMembershipsV1_Org_Coursera_Ondemand_Schedule_PersonalizedSchedule = {
  __typename?: 'OnDemandSessionMembershipsV1_org_coursera_ondemand_schedule_PersonalizedSchedule';
  itemDeadlines: Scalars['JSON'];
  timedItemLocks: Scalars['JSON'];
};

export type OnDemandSessionsV1 = {
  __typename?: 'OnDemandSessionsV1';
  courseId: Scalars['String'];
  discussionSessionId?: Maybe<OnDemandSessionsV1_Org_Coursera_Ondemand_Session_OnDemandSessionId>;
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  endedAt: Scalars['Float'];
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  enrollmentEndedAt: Scalars['Float'];
  flexibleScheduleAllowed: Scalars['Boolean'];
  id: Scalars['String'];
  isCredentialTrackSession: Scalars['Boolean'];
  isDegreeSession: Scalars['Boolean'];
  isExternallyManaged: Scalars['Boolean'];
  isNonTyped: Scalars['Boolean'];
  isPreview: Scalars['Boolean'];
  isPrivate: Scalars['Boolean'];
  isPublicNonTyped: Scalars['Boolean'];
  itemDeadlines?: Maybe<Scalars['JSON']>;
  moduleDeadlines: Array<Maybe<OnDemandSessionsV1_Org_Coursera_Ondemand_Deadline_OnDemandModuleDeadline>>;
  scheduleOverride?: Maybe<OnDemandSessionsV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride>;
  sessionTypeMetadata?: Maybe<OnDemandSessionsV1_SessionTypeMetadata>;
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  startedAt: Scalars['Float'];
  versionedBranchId?: Maybe<OnDemandSessionsV1_Org_Coursera_Common_Versioned>;
};

export type OnDemandSessionsV1AllByCourse = {
  __typename?: 'OnDemandSessionsV1AllByCourse';
  connection?: Maybe<OnDemandSessionsV1Connection>;
  courseId: Scalars['String'];
  includeExternallyManaged?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSessionsV1ByCourse = {
  __typename?: 'OnDemandSessionsV1ByCourse';
  connection?: Maybe<OnDemandSessionsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSessionsV1Connection = {
  __typename?: 'OnDemandSessionsV1Connection';
  elements: Array<Maybe<OnDemandSessionsV1>>;
  paging: ResponsePagination;
};

export type OnDemandSessionsV1CurrentOpenByCourse = {
  __typename?: 'OnDemandSessionsV1CurrentOpenByCourse';
  connection?: Maybe<OnDemandSessionsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSessionsV1NextEnrollableSessionsByUserAndCourse = {
  __typename?: 'OnDemandSessionsV1NextEnrollableSessionsByUserAndCourse';
  connection?: Maybe<OnDemandSessionsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSessionsV1Resource = {
  __typename?: 'OnDemandSessionsV1Resource';
  allByCourse?: Maybe<OnDemandSessionsV1Connection>;
  byCourse?: Maybe<OnDemandSessionsV1Connection>;
  currentOpenByCourse?: Maybe<OnDemandSessionsV1Connection>;
  get?: Maybe<OnDemandSessionsV1>;
  getAll?: Maybe<OnDemandSessionsV1Connection>;
  multiGet?: Maybe<OnDemandSessionsV1Connection>;
  nextEnrollableSessionsByUserAndCourse?: Maybe<OnDemandSessionsV1Connection>;
};


export type OnDemandSessionsV1ResourceAllByCourseArgs = {
  courseId: Scalars['String'];
  includeExternallyManaged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionsV1ResourceByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionsV1ResourceCurrentOpenByCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSessionsV1ResourceNextEnrollableSessionsByUserAndCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSessionsV1ResourceMutations = {
  __typename?: 'OnDemandSessionsV1ResourceMutations';
  clearSessionMemberships?: Maybe<Scalars['JSON']>;
  create?: Maybe<OnDemandSessionsV1Connection>;
  delete?: Maybe<OnDemandSessionsV1Connection>;
  hardDelete?: Maybe<Scalars['JSON']>;
  overrideItemAvailabilityAndDeadline?: Maybe<Scalars['JSON']>;
  update?: Maybe<OnDemandSessionsV1Connection>;
};


export type OnDemandSessionsV1ResourceMutationsClearSessionMembershipsArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionsV1ResourceMutationsHardDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionsV1ResourceMutationsOverrideItemAvailabilityAndDeadlineArgs = {
  id: Scalars['String'];
};


export type OnDemandSessionsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type OnDemandSessionsV1_Org_Coursera_Common_Versioned = {
  __typename?: 'OnDemandSessionsV1_org_coursera_common_Versioned';
  obj: Scalars['String'];
  version: Scalars['Int'];
};

/** This session is associated with a credential track. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_course_session_typemetadata_CredentialTrackSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

export type OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSessionMember = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_course_session_typemetadata_CredentialTrackSessionMember';
  org_coursera_ondemand_course_session_typemetadata_CredentialTrackSession: OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSession;
};

/** This session is associated with a degree. Public listing and enrollment apis do not allow access to this session. Degrees-specific listing and enrollment apis do allow access to this session. Code in the sessions system must treat `degreeId` as opaque. It must not make any calls to the degrees system to get any information about the degree at `degreeId`. */
export type OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_course_session_typemetadata_DegreeSession';
  /** Identifier for a degree. */
  degreeId: Scalars['String'];
};

export type OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSessionMember = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_course_session_typemetadata_DegreeSessionMember';
  org_coursera_ondemand_course_session_typemetadata_DegreeSession: OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSession;
};

export type OnDemandSessionsV1_Org_Coursera_Ondemand_Deadline_OnDemandModuleDeadline = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_deadline_OnDemandModuleDeadline';
  /** Unable to infer schema. See the org.joda.time.Instant Scala type for data model structure. */
  deadline: Scalars['Float'];
  moduleId: Scalars['String'];
};

export type OnDemandSessionsV1_Org_Coursera_Ondemand_Schedule_ScheduleOverride = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_schedule_ScheduleOverride';
  timedItemLocks: Scalars['JSON'];
};

export type OnDemandSessionsV1_Org_Coursera_Ondemand_Session_OnDemandSessionId = {
  __typename?: 'OnDemandSessionsV1_org_coursera_ondemand_session_OnDemandSessionId';
  id: Scalars['String'];
};

export type OnDemandSessionsV1_SessionTypeMetadata = OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_CredentialTrackSessionMember | OnDemandSessionsV1_Org_Coursera_Ondemand_Course_Session_Typemetadata_DegreeSessionMember;

export type OnDemandSocialProfilesV1 = {
  __typename?: 'OnDemandSocialProfilesV1';
  id: Scalars['String'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationMembershipPayload = {
  __typename?: 'OnDemandSpecializationMembershipPayload';
  /** The timestamp when this subscription was created */
  createdAt: Timestamp;
  /** The timestamp when this subscription was last modified */
  lastModified?: Maybe<Timestamp>;
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization Id */
  s12nId: Scalars['ID'];
  /** The user's Id */
  userId: Scalars['Int'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationMembershipQueries = {
  __typename?: 'OnDemandSpecializationMembershipQueries';
  /** This query returns specialization membership associated with a certificate code. */
  membershipByCertificateCode: OnDemandSpecializationMembershipPayload;
  /** This query returns specialization membership for a user. */
  membershipsByUser: Array<OnDemandSpecializationMembershipPayload>;
  /** Get the specialization memberships for the logged-in user in specific specializations. */
  userMembershipsByS12nIds: Array<OnDemandSpecializationMembership_S12nMembership>;
};


/** TODO: Complete this description */
export type OnDemandSpecializationMembershipQueriesMembershipByCertificateCodeArgs = {
  code: Scalars['String'];
};


/** TODO: Complete this description */
export type OnDemandSpecializationMembershipQueriesMembershipsByUserArgs = {
  role?: InputMaybe<OnDemandSpecializationMembershipRole>;
  userId: Scalars['Int'];
};


/** TODO: Complete this description */
export type OnDemandSpecializationMembershipQueriesUserMembershipsByS12nIdsArgs = {
  s12nIds: Array<Scalars['ID']>;
};

/** TODO: Complete this description */
export const OnDemandSpecializationMembershipRole = {
  /** TODO: Complete this description */
  Instructor: 'INSTRUCTOR',
  /** TODO: Complete this description */
  Learner: 'LEARNER',
  /** TODO: Complete this description */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** TODO: Complete this description */
  NotEnrolled: 'NOT_ENROLLED',
  /** TODO: Complete this description */
  UniversityAdmin: 'UNIVERSITY_ADMIN'
} as const;

export type OnDemandSpecializationMembershipRole = typeof OnDemandSpecializationMembershipRole[keyof typeof OnDemandSpecializationMembershipRole];
/** Entity for S12nMembership. */
export type OnDemandSpecializationMembership_S12nMembership = {
  __typename?: 'OnDemandSpecializationMembership_S12nMembership';
  /** The timestamp when this membership was created */
  createdAt: Scalars['DateTime'];
  /** The S12nMembership ID */
  id: Scalars['ID'];
  /** The timestamp when this membership was last modified */
  lastModified?: Maybe<Scalars['DateTime']>;
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization in which the user is enrolled */
  s12n: Specialization_Specialization;
  /** The user who is enrolled in the Specialization */
  user: User_User;
};

/** Creates a membership for the logged-in user. */
export type OnDemandSpecializationMembership_CreateInput = {
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
  /** Boolean to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/** Deletes a membership for the logged-in user. */
export type OnDemandSpecializationMembership_DeleteInput = {
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationMembership_DeletePayload = {
  __typename?: 'OnDemandSpecializationMembership_deletePayload';
  /** ID of the deleted membership */
  id: Scalars['ID'];
};

/** Input required to create a S12n Membership */
export type OnDemandSpecializationMembership_EnrollInOwnedS12nInput = {
  /** The optional course ID */
  courseId?: InputMaybe<Scalars['ID']>;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

export type OnDemandSpecializationMembershipsV1 = {
  __typename?: 'OnDemandSpecializationMembershipsV1';
  createdAt: Scalars['Float'];
  id: Scalars['String'];
  lastModified: Scalars['Float'];
  progress?: Maybe<Scalars['JSON']>;
  role: Scalars['String'];
  s12n?: Maybe<OnDemandSpecializationsV1>;
  s12nId: Scalars['String'];
  signatureTrackProfile?: Maybe<Scalars['JSON']>;
  userId: Scalars['Int'];
};

export type OnDemandSpecializationMembershipsV1ByCode = {
  __typename?: 'OnDemandSpecializationMembershipsV1ByCode';
  code: Scalars['String'];
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationMembershipsV1Connection = {
  __typename?: 'OnDemandSpecializationMembershipsV1Connection';
  elements: Array<Maybe<OnDemandSpecializationMembershipsV1>>;
  paging: ResponsePagination;
};

export type OnDemandSpecializationMembershipsV1Me = {
  __typename?: 'OnDemandSpecializationMembershipsV1Me';
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nRole?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationMembershipsV1MeByS12nId = {
  __typename?: 'OnDemandSpecializationMembershipsV1MeByS12nId';
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationMembershipsV1Resource = {
  __typename?: 'OnDemandSpecializationMembershipsV1Resource';
  byCode?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  get?: Maybe<OnDemandSpecializationMembershipsV1>;
  me?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  meByS12nId?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  multiGet?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  user?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  userAndBaseS12nId?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  userAndS12nIds?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
};


export type OnDemandSpecializationMembershipsV1ResourceByCodeArgs = {
  code: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationMembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandSpecializationMembershipsV1ResourceMeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nRole?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationMembershipsV1ResourceMeByS12nIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationMembershipsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationMembershipsV1ResourceUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nRole?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandSpecializationMembershipsV1ResourceUserAndBaseS12nIdArgs = {
  baseS12nId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OnDemandSpecializationMembershipsV1ResourceUserAndS12nIdsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  roleOption?: InputMaybe<Scalars['String']>;
  s12nIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSpecializationMembershipsV1ResourceMutations = {
  __typename?: 'OnDemandSpecializationMembershipsV1ResourceMutations';
  create?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  delete?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  enrollInOwnedS12n?: Maybe<Scalars['JSON']>;
  multiEnroll?: Maybe<Scalars['JSON']>;
};


export type OnDemandSpecializationMembershipsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OnDemandSpecializationMembershipsV1ResourceMutationsMultiEnrollArgs = {
  userId: Scalars['String'];
};

export type OnDemandSpecializationMembershipsV1User = {
  __typename?: 'OnDemandSpecializationMembershipsV1User';
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nRole?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSpecializationMembershipsV1UserAndBaseS12nId = {
  __typename?: 'OnDemandSpecializationMembershipsV1UserAndBaseS12nId';
  baseS12nId: Scalars['String'];
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OnDemandSpecializationMembershipsV1UserAndS12nIds = {
  __typename?: 'OnDemandSpecializationMembershipsV1UserAndS12nIds';
  connection?: Maybe<OnDemandSpecializationMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  roleOption?: Maybe<Scalars['String']>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** Various fields indicating the progress status of a user in a specialization. */
export type OnDemandSpecializationProgressPayload = {
  __typename?: 'OnDemandSpecializationProgressPayload';
  /** Certificate metadata for the specialization. */
  certificateMetadata?: Maybe<CertificateMetadata>;
  /** Indicates if all preconditions for the capstone are met, such as completing all non-capstone courses. */
  isEligibleForCapstone: Scalars['Boolean'];
  /**
   * This field used to contain the last item-level progress timestamp but currently is set to null and not used.
   * @deprecated Not used. If needed again should be federated to s12n progress app
   */
  lastActiveAt?: Maybe<Timestamp>;
  /**
   * Despite the name, this is field contains the first/next non-completed course in the specialization, or last completed
   * course if all courses are completed. The behavior has been changed but we kept the name for backward compatibility.
   * If you are considering using this field, please reach out to the team for more information first as in the long run
   * we would likely want to federate this field to s12n-progress-application.
   * See more info here: https://docs.google.com/document/d/10S8Xj-rm5HUVhXVm4LvN3INFWIqhEfINNYfiblPjoIQ/edit?tab=t.0
   */
  lastActiveCourseId?: Maybe<Scalars['ID']>;
  /** S12n Id the user is enrolled in, can be any Id in the s12n family, not necessarily the base or latest. */
  s12nId: Scalars['String'];
  /** User Id */
  userId: Scalars['Int'];
};

/** S12n progress queries. */
export type OnDemandSpecializationProgressQueries = {
  __typename?: 'OnDemandSpecializationProgressQueries';
  /** This query returns specialization progress. */
  progress: OnDemandSpecializationProgressPayload;
};


/** S12n progress queries. */
export type OnDemandSpecializationProgressQueriesProgressArgs = {
  s12nId: Scalars['String'];
  userId: Scalars['Int'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeEligibilityPayload = {
  __typename?: 'OnDemandSpecializationUpgradeEligibilityPayload';
  /** TODO: Complete this description */
  courses: Array<UpgradeEligibilityCourse>;
  /** TODO: Complete this description */
  expiresAt: Timestamp;
  /** TODO: Complete this description */
  newS12nId: Scalars['String'];
  /** TODO: Complete this description */
  oldS12nId: Scalars['String'];
  /** TODO: Complete this description */
  userId: Scalars['String'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationUpgradePayload = {
  __typename?: 'OnDemandSpecializationUpgradePayload';
  /** TODO: Complete this description */
  createdAt: Timestamp;
  /** TODO: Complete this description */
  newS12nId: Scalars['String'];
  /** TODO: Complete this description */
  oldS12nId: Scalars['String'];
  /** TODO: Complete this description */
  userId: Scalars['String'];
};

/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeQueries = {
  __typename?: 'OnDemandSpecializationUpgradeQueries';
  /** This query returns the eligibility of upgrading user to a newer version of specialization. */
  getAllEligibleS12nUpgradesForUser: Array<OnDemandSpecializationUpgrade_S12nUpgradeEligibility>;
  /** This query returns the eligibility of upgrading a user and s12n to the newest version. */
  getUpgradeEligibility?: Maybe<OnDemandSpecializationUpgrade_S12nUpgradeEligibility>;
  /** This query checks if a logged in user's eligibility for upgrading to the target s12n. */
  s12nUpgradeEligibilityToS12nId: OnDemandSpecializationUpgrade_S12nUpgradeEligibility;
  /**
   * This query returns a list of eligibilities of upgrading user's current specialization memberships
   * to newer versions.
   * @deprecated Use `getAllEligibleS12nUpgradesForUser`.
   */
  upgradeEligibilitiesForUser: Array<OnDemandSpecializationUpgradeEligibilityPayload>;
  /**
   * This query returns the eligibility of upgrading user to a newer version of specialization.
   * @deprecated Use `getUpgradeEligibility`.
   */
  upgradeEligibility?: Maybe<OnDemandSpecializationUpgradeEligibilityPayload>;
};


/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeQueriesGetUpgradeEligibilityArgs = {
  s12nId: Scalars['ID'];
};


/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeQueriesS12nUpgradeEligibilityToS12nIdArgs = {
  s12nId: Scalars['ID'];
};


/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeQueriesUpgradeEligibilitiesForUserArgs = {
  userId: Scalars['Int'];
};


/** TODO: Complete this description */
export type OnDemandSpecializationUpgradeQueriesUpgradeEligibilityArgs = {
  s12nId: Scalars['String'];
  userId: Scalars['Int'];
};

/** The source of the upgrade eligibility. */
export const OnDemandSpecializationUpgrade_OwnershipSource = {
  /** When ownership is through Consumer segment, like CPLUS, CLite, S12nSubscription, BulkPay, etc. */
  Consumer: 'CONSUMER',
  /** When ownership is through an Enterprise program. */
  Enterprise: 'ENTERPRISE'
} as const;

export type OnDemandSpecializationUpgrade_OwnershipSource = typeof OnDemandSpecializationUpgrade_OwnershipSource[keyof typeof OnDemandSpecializationUpgrade_OwnershipSource];
/** S12n upgrade eligibility */
export type OnDemandSpecializationUpgrade_S12nUpgradeEligibility = {
  __typename?: 'OnDemandSpecializationUpgrade_S12nUpgradeEligibility';
  /** The current S12n that the user enrolled in. Only present when upgradeEligibility is true. */
  currentEnrolledS12nInFamily?: Maybe<Specialization_Specialization>;
  /** The timestamp that the eligibility expires at. Only present when upgradeEligibility is true. */
  eligibilityExpiresAt?: Maybe<Scalars['DateTime']>;
  /**
   * The source of the upgrade eligibility. For example, if the user is
   * enrolled in the s12n through enterprise, then ownershipSource will be enterprise.
   */
  ownershipSource?: Maybe<OnDemandSpecializationUpgrade_OwnershipSource>;
  /** The target s12n that the user tries to upgrade to. */
  s12n: Specialization_Specialization;
  /** A flag that shows if the user is able to upgrade to the target s12n. */
  upgradeEligibility: Scalars['Boolean'];
};

export type OnDemandSpecializationsV1 = {
  __typename?: 'OnDemandSpecializationsV1';
  capstone?: Maybe<OnDemandSpecializationsV1_Org_Coursera_S12n_Capstone>;
  cmlDescription: OnDemandSpecializationsV1_CmlDescription;
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  derivative?: Maybe<S12nDerivativesV1>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  domainTypes: Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_Catalogp_Browse_DomainType>>;
  id: Scalars['String'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  instructors?: Maybe<InstructorsV1Connection>;
  interchangeableCourseIds: Scalars['JSON'];
  internalType: OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType;
  launchedAt?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  membership?: Maybe<OnDemandSpecializationMembershipsV1>;
  memberships?: Maybe<Scalars['JSON']>;
  metadata: OnDemandSpecializationsV1_Org_Coursera_S12n_S12nMetadata;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  partnerLogoOverrides: Scalars['JSON'];
  partners?: Maybe<PartnersV1Connection>;
  plannedLaunchDate?: Maybe<Scalars['Float']>;
  preEnrollmentEnabledAt?: Maybe<Scalars['Float']>;
  premiumExperienceVariant?: Maybe<OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant>;
  premiumExperiences: Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperience>>;
  productSkus?: Maybe<ProductSkusV1Connection>;
  productVariant: Scalars['String'];
  projectsOverview?: Maybe<OnDemandSpecializationsV1_CmlMember>;
  s12nDerivatives?: Maybe<Scalars['JSON']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  subscription?: Maybe<SubscriptionsV1>;
  /** Typeref for string that defines the isTranslatable property to true */
  tagline?: Maybe<Scalars['String']>;
  versionDescription?: Maybe<OnDemandSpecializationsV1_VersionDescription>;
};


export type OnDemandSpecializationsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type OnDemandSpecializationsV1InstructorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1PartnersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ProductSkusArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1Connection = {
  __typename?: 'OnDemandSpecializationsV1Connection';
  elements: Array<Maybe<OnDemandSpecializationsV1>>;
  paging: ResponsePagination;
};

export type OnDemandSpecializationsV1Course = {
  __typename?: 'OnDemandSpecializationsV1Course';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1Courses = {
  __typename?: 'OnDemandSpecializationsV1Courses';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  courseIds: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1LatestInFamilies = {
  __typename?: 'OnDemandSpecializationsV1LatestInFamilies';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1LatestInFamiliesWithBaseIdKey = {
  __typename?: 'OnDemandSpecializationsV1LatestInFamiliesWithBaseIdKey';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1LatestInFamilyByCourses = {
  __typename?: 'OnDemandSpecializationsV1LatestInFamilyByCourses';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  courseIds: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1Primary = {
  __typename?: 'OnDemandSpecializationsV1Primary';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1Resource = {
  __typename?: 'OnDemandSpecializationsV1Resource';
  course?: Maybe<OnDemandSpecializationsV1Connection>;
  courses?: Maybe<OnDemandSpecializationsV1Connection>;
  get?: Maybe<OnDemandSpecializationsV1>;
  getAll?: Maybe<OnDemandSpecializationsV1Connection>;
  latestInFamilies?: Maybe<OnDemandSpecializationsV1Connection>;
  latestInFamiliesWithBaseIdKey?: Maybe<OnDemandSpecializationsV1Connection>;
  latestInFamilyByCourses?: Maybe<OnDemandSpecializationsV1Connection>;
  multiGet?: Maybe<OnDemandSpecializationsV1Connection>;
  primary?: Maybe<OnDemandSpecializationsV1Connection>;
  slug?: Maybe<OnDemandSpecializationsV1Connection>;
};


export type OnDemandSpecializationsV1ResourceCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceCoursesArgs = {
  courseIds: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandSpecializationsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sortedBy?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceLatestInFamiliesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceLatestInFamiliesWithBaseIdKeyArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  s12nIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceLatestInFamilyByCoursesArgs = {
  courseIds: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourcePrimaryArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type OnDemandSpecializationsV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1Slug = {
  __typename?: 'OnDemandSpecializationsV1Slug';
  connection?: Maybe<OnDemandSpecializationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type OnDemandSpecializationsV1_Answer = DummyType | OnDemandSpecializationsV1_CmlMember;

export type OnDemandSpecializationsV1_CmlDescription = DummyType | OnDemandSpecializationsV1_CmlMember;

export type OnDemandSpecializationsV1_CmlMember = {
  __typename?: 'OnDemandSpecializationsV1_cmlMember';
  cml: OnDemandSpecializationsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type OnDemandSpecializationsV1_CmlRecommendedBackground = DummyType | OnDemandSpecializationsV1_CmlMember;

export type OnDemandSpecializationsV1_Org_Coursera_Authoring_S12n_AuthoringS12nSponsor = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_authoring_s12n_AuthoringS12nSponsor';
  logo: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

/** Defined domain/subdomain type for a course */
export type OnDemandSpecializationsV1_Org_Coursera_Catalogp_Browse_DomainType = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_catalogp_browse_DomainType';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type OnDemandSpecializationsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type OnDemandSpecializationsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type OnDemandSpecializationsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: OnDemandSpecializationsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type OnDemandSpecializationsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperience = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_course_PremiumExperience';
  enabledAt: Scalars['Float'];
  variant: OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant;
};

/** Different product variants that are currently supported. */
export const OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant = typeof OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof OnDemandSpecializationsV1_Org_Coursera_Course_PremiumExperienceVariant];
export const OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type OnDemandSpecializationsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<OnDemandSpecializationsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type OnDemandSpecializationsV1_Org_Coursera_S12n_Capstone = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_s12n_Capstone';
  courseIds: Array<Maybe<Scalars['String']>>;
};

export type OnDemandSpecializationsV1_Org_Coursera_S12n_CmlQnA = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_s12n_CmlQnA';
  answer: OnDemandSpecializationsV1_Answer;
  question: OnDemandSpecializationsV1_Question;
};

export type OnDemandSpecializationsV1_Org_Coursera_S12n_QnA = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_s12n_QnA';
  /** Typeref for string that defines the isTranslatable property to true */
  answer: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  question: Scalars['String'];
};

export const OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType = typeof OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType[keyof typeof OnDemandSpecializationsV1_Org_Coursera_S12n_S12nInternalType];
/** This model contains s12n metadata */
export type OnDemandSpecializationsV1_Org_Coursera_S12n_S12nMetadata = {
  __typename?: 'OnDemandSpecializationsV1_org_coursera_s12n_S12nMetadata';
  additionalFaqs: Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_S12n_QnA>>;
  certificateDescription: Scalars['String'];
  certificateLogo?: Maybe<Scalars['String']>;
  cmlAdditionalFaqs: Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_S12n_CmlQnA>>;
  cmlLearningObjectives: Array<Maybe<OnDemandSpecializationsV1_CmlMember>>;
  cmlRecommendedBackground?: Maybe<OnDemandSpecializationsV1_CmlRecommendedBackground>;
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  companyLogos: Array<Maybe<Scalars['String']>>;
  featuredIndex?: Maybe<Scalars['Int']>;
  headerImage?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  headline?: Maybe<Scalars['String']>;
  hoursPerWeekOverride?: Maybe<Scalars['Int']>;
  /** Typeref for string that defines the isTranslatable property to true */
  incentives?: Maybe<Scalars['String']>;
  learningObjectives: Array<Maybe<Scalars['String']>>;
  level?: Maybe<OnDemandSpecializationsV1_Org_Coursera_Ondemand_Common_DifficultyLevel>;
  monthsToCompleteOverride?: Maybe<Scalars['Int']>;
  partnerImage?: Maybe<Scalars['String']>;
  partnerImages?: Maybe<Scalars['JSON']>;
  /** Typeref for string that defines the isTranslatable property to true */
  partnerMarketingBlurb?: Maybe<Scalars['String']>;
  partnerMarketingBlurbs?: Maybe<Scalars['JSON']>;
  recommendedBackground: Array<Maybe<Scalars['String']>>;
  sponsors?: Maybe<Array<Maybe<OnDemandSpecializationsV1_Org_Coursera_Authoring_S12n_AuthoringS12nSponsor>>>;
  /** Typeref for string that defines the isTranslatable property to true */
  subheader?: Maybe<Scalars['String']>;
  useDefaultFaqs: Scalars['Boolean'];
};

export type OnDemandSpecializationsV1_Question = DummyType | OnDemandSpecializationsV1_CmlMember;

export type OnDemandSpecializationsV1_VersionDescription = DummyType | OnDemandSpecializationsV1_CmlMember;

export type OnDemandSubmittedTeammateReviewsResourceV1 = {
  __typename?: 'OnDemandSubmittedTeammateReviewsResourceV1';
  courseId: Scalars['String'];
  id: Scalars['String'];
  itemId: Scalars['String'];
  review: Scalars['JSON'];
  reviewee?: Maybe<TeamworkUserProfilesV1>;
  /** id for a Coursera user */
  revieweeId: Scalars['Int'];
  reviewer?: Maybe<TeamworkUserProfilesV1>;
  /** id for a Coursera user */
  reviewerId: Scalars['Int'];
};

export type OnDemandSubmittedTeammateReviewsResourceV1Connection = {
  __typename?: 'OnDemandSubmittedTeammateReviewsResourceV1Connection';
  elements: Array<Maybe<OnDemandSubmittedTeammateReviewsResourceV1>>;
  paging: ResponsePagination;
};

export type OnDemandSubmittedTeammateReviewsResourceV1Resource = {
  __typename?: 'OnDemandSubmittedTeammateReviewsResourceV1Resource';
  get?: Maybe<OnDemandSubmittedTeammateReviewsResourceV1>;
  multiGet?: Maybe<OnDemandSubmittedTeammateReviewsResourceV1Connection>;
};


export type OnDemandSubmittedTeammateReviewsResourceV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OnDemandSubmittedTeammateReviewsResourceV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OnDemandSubmittedTeammateReviewsResourceV1ResourceMutations = {
  __typename?: 'OnDemandSubmittedTeammateReviewsResourceV1ResourceMutations';
  delete?: Maybe<OnDemandSubmittedTeammateReviewsResourceV1Connection>;
};


export type OnDemandSubmittedTeammateReviewsResourceV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};

/** Open course asset. */
export type OpenCourseAsset = Node & {
  __typename?: 'OpenCourseAsset';
  /** Open course asset content. */
  assetContent: OpenCourseAsset_AssetContent;
  /** Name of asset, modifiable by authors, only applicable for asset based assets */
  assetName?: Maybe<Scalars['String']>;
  /** Name of the attached file, including the file extension, only applicable for asset based assets */
  fileName?: Maybe<Scalars['String']>;
  /** Open course asset unique ID. */
  id: Scalars['ID'];
  /** URL of the attached file, could be a cloudfront URL or a Coursera asset URL, only applicable for asset based assets */
  url?: Maybe<Scalars['URL']>;
  /** Versioned open course asset id. */
  versionedOpenCourseAssetId: OpenCourseAsset_VersionedOpenCourseAssetId;
};

/** Open course asset queries. */
export type OpenCourseAssetQueries = {
  __typename?: 'OpenCourseAssetQueries';
  /** Get latest open course asset. */
  getLatestOpenCourseAsset?: Maybe<OpenCourseAsset>;
  /** Get open course asset. */
  getOpenCourseAsset?: Maybe<OpenCourseAsset>;
  /** Multi-get latest open course asset. | Maximum page size: 1000 */
  multiGetLatestOpenCourseAsset: OpenCourseAsset_OpenCourseAssetsConnection;
  /** Multi-get open course asset. | Maximum page size: 1000 */
  multiGetOpenCourseAsset: OpenCourseAsset_OpenCourseAssetsConnection;
};


/** Open course asset queries. */
export type OpenCourseAssetQueriesGetLatestOpenCourseAssetArgs = {
  getLatestOpenCourseAssetInput: OpenCourseAsset_GetLatestOpenCourseAssetInput;
};


/** Open course asset queries. */
export type OpenCourseAssetQueriesGetOpenCourseAssetArgs = {
  getOpenCourseAssetInput: OpenCourseAsset_GetOpenCourseAssetInput;
};


/** Open course asset queries. */
export type OpenCourseAssetQueriesMultiGetLatestOpenCourseAssetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  multiGetLatestOpenCourseAssetInput: OpenCourseAsset_MultiGetLatestOpenCourseAssetInput;
};


/** Open course asset queries. */
export type OpenCourseAssetQueriesMultiGetOpenCourseAssetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  multiGetOpenCourseAssetInput: OpenCourseAsset_MultiGetOpenCourseAssetInput;
};

/** AssetBasedAsset. */
export type OpenCourseAsset_AssetBasedAsset = {
  __typename?: 'OpenCourseAsset_AssetBasedAsset';
  /** AssetService assetId (different from open course asset id). */
  assetId: Scalars['String'];
  /** Name. */
  name?: Maybe<Scalars['String']>;
};

/** Asset based input. */
export type OpenCourseAsset_AssetBasedAssetInput = {
  /** AssetService assetId (different from open course asset id). */
  assetId: Scalars['ID'];
  /** Name. */
  name?: InputMaybe<Scalars['String']>;
};

/** Open course asset content. */
export type OpenCourseAsset_AssetContent = CmlContent | OpenCourseAsset_AssetBasedAsset | OpenCourseAsset_HtmlTextAsset | OpenCourseAsset_UrlAsset;

/** Create open course asset input. */
export type OpenCourseAsset_CreateOpenCourseAssetInput = {
  /** Open course asset input. */
  openCourseAssetInput: OpenCourseAsset_OpenCourseAssetInput;
};

/** Create open course asset result. */
export type OpenCourseAsset_CreateOpenCourseAssetResult = OpenCourseAsset_OpenCourseAssetFailure | OpenCourseAsset_OpenCourseAssetSuccess;

/** Get latest open course asset input */
export type OpenCourseAsset_GetLatestOpenCourseAssetInput = {
  /** Open course asset id. */
  openCourseAssetId: Scalars['ID'];
};

/** Get open course asset input */
export type OpenCourseAsset_GetOpenCourseAssetInput = {
  /** Versioned open course asset id. */
  versionedOpenCourseAssetId: OpenCourseAsset_VersionedOpenCourseAssetIdInput;
};

/** Html text asset. */
export type OpenCourseAsset_HtmlTextAsset = {
  __typename?: 'OpenCourseAsset_HtmlTextAsset';
  /** This is a HTML string. */
  content: Scalars['String'];
};

/** Html text asset input. */
export type OpenCourseAsset_HtmlTextAssetInput = {
  /** This is a HTML string. */
  content: Scalars['String'];
};

/** Multi-get latest open course asset input. */
export type OpenCourseAsset_MultiGetLatestOpenCourseAssetInput = {
  /** Open course asset Ids. */
  openCourseAssetIds: Array<Scalars['ID']>;
};

/** Multi-get open course asset input. */
export type OpenCourseAsset_MultiGetOpenCourseAssetInput = {
  /** Versioned open course asset Ids input. */
  versionedOpenCourseAssetIdsInput: OpenCourseAsset_VersionedOpenCourseAssetIdsInput;
};

/** Open course asset edge (for pagination) */
export type OpenCourseAsset_OpenCourseAssetEdge = {
  __typename?: 'OpenCourseAsset_OpenCourseAssetEdge';
  /** Cursor. */
  cursor: Scalars['String'];
  /** Node. */
  node: OpenCourseAsset;
};

/** Open course asset error. */
export type OpenCourseAsset_OpenCourseAssetError = {
  __typename?: 'OpenCourseAsset_OpenCourseAssetError';
  /** Error message. */
  message: Scalars['String'];
};

/** Open course asset failure. */
export type OpenCourseAsset_OpenCourseAssetFailure = {
  __typename?: 'OpenCourseAsset_OpenCourseAssetFailure';
  /** Errors. */
  errors: Array<OpenCourseAsset_OpenCourseAssetError>;
};

/** Open course asset input. */
export type OpenCourseAsset_OpenCourseAssetInput = {
  /** assetBasedAssetInput. */
  assetBasedAssetInput?: InputMaybe<OpenCourseAsset_AssetBasedAssetInput>;
  /** Cml content input. */
  cmlContentInput?: InputMaybe<CmlContentInput>;
  /** htmlTextAssetInput. */
  htmlTextAssetInput?: InputMaybe<OpenCourseAsset_HtmlTextAssetInput>;
  /** urlAssetInput. */
  urlAssetInput?: InputMaybe<OpenCourseAsset_UrlAssetInput>;
};

/** Open course asset success. */
export type OpenCourseAsset_OpenCourseAssetSuccess = {
  __typename?: 'OpenCourseAsset_OpenCourseAssetSuccess';
  /** Open course asset. */
  OpenCourseAsset: OpenCourseAsset;
};

/** Multi-get open course asset connection (for pagination) */
export type OpenCourseAsset_OpenCourseAssetsConnection = {
  __typename?: 'OpenCourseAsset_OpenCourseAssetsConnection';
  /** Edges. */
  edges: Array<OpenCourseAsset_OpenCourseAssetEdge>;
  /** PageInfo. */
  pageInfo: PageInfo;
  /** Total count. */
  totalCount: Scalars['Int'];
};

/** Update open course asset input. */
export type OpenCourseAsset_UpdateOpenCourseAssetInput = {
  /** The atomId which this open course asset belongs to. This is to enable authoization check. */
  atomId: Scalars['ID'];
  /** Open course asset input. */
  openCourseAssetInput: OpenCourseAsset_OpenCourseAssetInput;
  /** Unversioned open course asset id. */
  unversionedOpenCourseAssetId: Scalars['ID'];
};

/** Update open course asset result. */
export type OpenCourseAsset_UpdateOpenCourseAssetResult = OpenCourseAsset_OpenCourseAssetFailure | OpenCourseAsset_OpenCourseAssetSuccess;

/** Url Asset. */
export type OpenCourseAsset_UrlAsset = {
  __typename?: 'OpenCourseAsset_UrlAsset';
  /** Name. */
  name: Scalars['String'];
  /** Url. */
  url: Scalars['URL'];
};

/** Url asset input. */
export type OpenCourseAsset_UrlAssetInput = {
  /** Name. */
  name: Scalars['String'];
  /** Url. */
  url: Scalars['URL'];
};

/** Open Course asset versioned asset id. */
export type OpenCourseAsset_VersionedOpenCourseAssetId = {
  __typename?: 'OpenCourseAsset_VersionedOpenCourseAssetId';
  /** Open course asset id. */
  id: Scalars['ID'];
  /** Version. */
  version: Scalars['Int'];
};

/** VersionedOpenCourseAssetId input */
export type OpenCourseAsset_VersionedOpenCourseAssetIdInput = {
  /** Open course asset Id. */
  id: Scalars['ID'];
  /** Version. */
  version: Scalars['Int'];
};

/** Versioned open course asset Ids input */
export type OpenCourseAsset_VersionedOpenCourseAssetIdsInput = {
  /** Versioned open course asset Ids. */
  versionedOpenCourseAssetIds: Array<OpenCourseAsset_VersionedOpenCourseAssetIdInput>;
};

export type OpenCourseMembershipsV1 = {
  __typename?: 'OpenCourseMembershipsV1';
  course?: Maybe<OnDemandCoursesV1>;
  courseId: Scalars['String'];
  courseRole: Scalars['String'];
  id: Scalars['String'];
  timestamp: Scalars['Float'];
  userId: Scalars['Int'];
};

export type OpenCourseMembershipsV1Connection = {
  __typename?: 'OpenCourseMembershipsV1Connection';
  elements: Array<Maybe<OpenCourseMembershipsV1>>;
  paging: ResponsePagination;
};

export type OpenCourseMembershipsV1FindByCourse = {
  __typename?: 'OpenCourseMembershipsV1FindByCourse';
  connection?: Maybe<OpenCourseMembershipsV1Connection>;
  courseId: Scalars['String'];
  courseRole: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type OpenCourseMembershipsV1FindByUser = {
  __typename?: 'OpenCourseMembershipsV1FindByUser';
  connection?: Maybe<OpenCourseMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OpenCourseMembershipsV1FindByUserAndRole = {
  __typename?: 'OpenCourseMembershipsV1FindByUserAndRole';
  connection?: Maybe<OpenCourseMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  refreshCache?: Maybe<Scalars['Boolean']>;
  role: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OpenCourseMembershipsV1FindByUserAndSlug = {
  __typename?: 'OpenCourseMembershipsV1FindByUserAndSlug';
  connection?: Maybe<OpenCourseMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type OpenCourseMembershipsV1Resource = {
  __typename?: 'OpenCourseMembershipsV1Resource';
  findByCourse?: Maybe<OpenCourseMembershipsV1Connection>;
  findByUser?: Maybe<OpenCourseMembershipsV1Connection>;
  findByUserAndRole?: Maybe<OpenCourseMembershipsV1Connection>;
  findByUserAndSlug?: Maybe<OpenCourseMembershipsV1Connection>;
  get?: Maybe<OpenCourseMembershipsV1>;
  multiGet?: Maybe<OpenCourseMembershipsV1Connection>;
};


export type OpenCourseMembershipsV1ResourceFindByCourseArgs = {
  courseId: Scalars['String'];
  courseRole: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type OpenCourseMembershipsV1ResourceFindByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceFindByUserAndRoleArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  refreshCache?: InputMaybe<Scalars['Boolean']>;
  role: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceFindByUserAndSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type OpenCourseMembershipsV1ResourceMutations = {
  __typename?: 'OpenCourseMembershipsV1ResourceMutations';
  create?: Maybe<OpenCourseMembershipsV1Connection>;
  createByEmail?: Maybe<Scalars['JSON']>;
  createSkipMembershipChangeNotification?: Maybe<Scalars['JSON']>;
  createSkipSessionEnroll?: Maybe<Scalars['JSON']>;
  delete?: Maybe<OpenCourseMembershipsV1Connection>;
  deleteSkipProductApproval?: Maybe<Scalars['JSON']>;
  hardDelete?: Maybe<Scalars['JSON']>;
  internalPureUpdate?: Maybe<Scalars['JSON']>;
  update?: Maybe<OpenCourseMembershipsV1Connection>;
};


export type OpenCourseMembershipsV1ResourceMutationsCreateByEmailArgs = {
  courseId: Scalars['String'];
  courseRole: Scalars['String'];
  email: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMutationsDeleteSkipProductApprovalArgs = {
  id: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMutationsHardDeleteArgs = {
  id: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMutationsInternalPureUpdateArgs = {
  id: Scalars['String'];
};


export type OpenCourseMembershipsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
  skipMembershipChangeNotification?: InputMaybe<Scalars['Boolean']>;
};

/** All partner approval queries */
export type OptimizationBranchQueries = {
  __typename?: 'OptimizationBranchQueries';
  /** Get optimization branch with recommendations */
  queryOptimizationBranchChangesByBranchId?: Maybe<OptimizationBranch_OptimizationBranchChanges>;
};


/** All partner approval queries */
export type OptimizationBranchQueriesQueryOptimizationBranchChangesByBranchIdArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
};

/** Optimization status */
export const OptimizationBranch_ApprovalState = {
  /** Approved */
  Approved: 'APPROVED',
  /** Pending */
  Pending: 'PENDING',
  /** Rejected */
  Rejected: 'REJECTED'
} as const;

export type OptimizationBranch_ApprovalState = typeof OptimizationBranch_ApprovalState[keyof typeof OptimizationBranch_ApprovalState];
/** Course item */
export type OptimizationBranch_CourseItem = {
  __typename?: 'OptimizationBranch_CourseItem';
  /** Optimization status (null if item is not part of optimization) */
  approvalState?: Maybe<OptimizationBranch_ApprovalState>;
  /** Atom id */
  atomId: Scalars['ID'];
  /** Latest related change review id (null if item is not part of optimization) */
  changeReviewId?: Maybe<Scalars['ID']>;
  /** Item id */
  itemId: Scalars['ID'];
  /** Additional data for items */
  itemMetadata?: Maybe<OptimizationBranch_ItemMetadata>;
  /** Item type */
  itemType: OptimizationBranch_ItemType;
  /** Item name */
  name: Scalars['String'];
  /** Time commitment */
  timeCommitment?: Maybe<Scalars['Int']>;
};

/** Lesson */
export type OptimizationBranch_CourseOutlineLesson = {
  __typename?: 'OptimizationBranch_CourseOutlineLesson';
  /** Lesson id */
  id: Scalars['ID'];
  /** Items in lesson */
  items: Array<OptimizationBranch_CourseItem>;
  /** Lesson name */
  name: Scalars['String'];
};

/** Module */
export type OptimizationBranch_CourseOutlineModule = {
  __typename?: 'OptimizationBranch_CourseOutlineModule';
  /** Module description */
  description: Scalars['String'];
  /** Module id */
  id: Scalars['ID'];
  /** Learning objectives */
  learningObjectives: Array<OptimizationBranch_LearningObjective>;
  /** Lessons */
  lessons: Array<OptimizationBranch_CourseOutlineLesson>;
  /** Module name */
  name: Scalars['String'];
  /** Time commitment */
  timeCommitment: Scalars['Int'];
};

/** Graded assignment integrity feature */
export type OptimizationBranch_GradedAssignmentIntegrityFeature = OptimizationBranch_IntegrityFeatureAttemptLimit | OptimizationBranch_IntegrityFeatureTimeLimit;

/** Graded assignment attempt rate */
export type OptimizationBranch_IntegrityFeatureAttemptLimit = {
  __typename?: 'OptimizationBranch_IntegrityFeatureAttemptLimit';
  /** Number of attempts allowed */
  numberOfAttempts: Scalars['Int'];
  /** Time range in milliseconds for attempt limit to apply */
  timeRange: Scalars['Int'];
};

/** Graded assignment time limit */
export type OptimizationBranch_IntegrityFeatureTimeLimit = {
  __typename?: 'OptimizationBranch_IntegrityFeatureTimeLimit';
  /** Integrity feature: time limit */
  timeLimitPerAttempt: Scalars['Int'];
};

/** Additional info for item type */
export type OptimizationBranch_ItemMetadata = OptimizationBranch_ItemMetadataGradedAssessments | OptimizationBranch_ItemMetadataPracticeAssignments;

/** Graded assessment metadata */
export type OptimizationBranch_ItemMetadataGradedAssessments = {
  __typename?: 'OptimizationBranch_ItemMetadataGradedAssessments';
  /** Integrity features */
  integrityFeatures: Array<OptimizationBranch_GradedAssignmentIntegrityFeature>;
  /** Number of question banks */
  numberOfQuestionBanks: Scalars['Int'];
  /** Number of questions */
  numberOfQuestions: Scalars['Int'];
};

/** Practice assignment metadata */
export type OptimizationBranch_ItemMetadataPracticeAssignments = {
  __typename?: 'OptimizationBranch_ItemMetadataPracticeAssignments';
  /** Number of questions */
  numberOfQuestions: Scalars['Int'];
};

/**
 * Item type
 * Note: we only need to specify ungraded/graded for assignments, otherwise types are generic
 */
export const OptimizationBranch_ItemType = {
  /**
   * Dialogue [new, coach type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue from a role play (which are both marked as "coach" item type)
   */
  CoachItemDialogue: 'COACH_ITEM_DIALOGUE',
  /**
   * Role play [new, coach type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue from a role play (which are both marked as "coach" item type)
   */
  CoachItemRolePlay: 'COACH_ITEM_ROLE_PLAY',
  /**
   * Dialogue [old, plugin type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a dialogue (which is by default marked previously as an ungradedWidget)
   */
  Dialogue: 'DIALOGUE',
  /** Discussion Prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Graded assignment */
  GradedAssignment: 'GRADED_ASSIGNMENT',
  /** Lecture */
  Lecture: 'LECTURE',
  /** LTI or App Item */
  Lti: 'LTI',
  /** Peer Review Assignment */
  PeerReview: 'PEER_REVIEW',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming Assignment */
  ProgrammingAssignment: 'PROGRAMMING_ASSIGNMENT',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Reading */
  Reading: 'READING',
  /**
   * Role play [old, plugin type]
   * Note: this is a custom type (not in course materials) so that the FE does not have to manually
   * identify a role play (which is by default marked previously as an ungradedWidget)
   */
  RolePlay: 'ROLE_PLAY',
  /** Teammate Review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded assignment */
  UngradedAssignment: 'UNGRADED_ASSIGNMENT',
  /** UNGRADED_LAB */
  UngradedLab: 'UNGRADED_LAB',
  /** Widget (aka Plugin) */
  Widget: 'WIDGET'
} as const;

export type OptimizationBranch_ItemType = typeof OptimizationBranch_ItemType[keyof typeof OptimizationBranch_ItemType];
/** Learning objective */
export type OptimizationBranch_LearningObjective = {
  __typename?: 'OptimizationBranch_LearningObjective';
  /** Learning objective description */
  description: Scalars['String'];
  /** Learning objective id */
  id: Scalars['ID'];
  /** List of course items IDs linked to a learning objective */
  itemIds: Array<Scalars['ID']>;
  /**
   * List of course items linked to a learning objective
   * @deprecated Using itemIds instead as fully hydrated items are not necessary and expensive for learning objectives
   */
  items: Array<OptimizationBranch_CourseItem>;
};

/** Course outline containing modules and learning objectives and optimization status for items */
export type OptimizationBranch_OptimizationBranchChanges = {
  __typename?: 'OptimizationBranch_OptimizationBranchChanges';
  /** Authoring branch id */
  authoringBranchId: Scalars['ID'];
  /** Modules in course branch */
  modules: Array<OptimizationBranch_CourseOutlineModule>;
};

/** Namespace type for Business API Key queries. */
export type OrgApiKeyQueries = {
  __typename?: 'OrgApiKeyQueries';
  /** Get all active API keys for an organization. */
  getByOrg: Array<OrgApiKey_Key>;
};


/** Namespace type for Business API Key queries. */
export type OrgApiKeyQueriesGetByOrgArgs = {
  thirdPartyOrgId: Scalars['ID'];
};

/** Error codes for API key creation failures. */
export const OrgApiKey_CreateError = {
  /** The organization has reached the maximum number of active API keys. */
  KeyLimitExceeded: 'KEY_LIMIT_EXCEEDED'
} as const;

export type OrgApiKey_CreateError = typeof OrgApiKey_CreateError[keyof typeof OrgApiKey_CreateError];
/** Failure result of creating an API key. */
export type OrgApiKey_CreateFailure = {
  __typename?: 'OrgApiKey_CreateFailure';
  /** Error code indicating the reason for failure. */
  error: OrgApiKey_CreateError;
  /** Human-readable error message. */
  errorMessage: Scalars['String'];
};

/** Input for creating a new API key. */
export type OrgApiKey_CreateInput = {
  /** Human-readable label for the new API key. */
  name: Scalars['String'];
  /** The third party organization ID to create the key for. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Result of creating an API key — either success with credentials or a typed failure. */
export type OrgApiKey_CreateResult = OrgApiKey_CreateFailure | OrgApiKey_CreateSuccess;

/** Successful result of creating an API key. Contains the client secret which is shown only once. */
export type OrgApiKey_CreateSuccess = {
  __typename?: 'OrgApiKey_CreateSuccess';
  /** Apigee consumer key (OAuth client ID). */
  clientId: Scalars['ID'];
  /** Apigee consumer secret (OAuth client secret). Shown only once and cannot be retrieved again. */
  clientSecret: Scalars['String'];
  /** Timestamp when the API key was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier of the newly created API key. */
  id: Scalars['ID'];
  /** Human-readable label for the API key. */
  name: Scalars['String'];
};

/** An API key belonging to an organization, backed by an Apigee consumer credential. */
export type OrgApiKey_Key = {
  __typename?: 'OrgApiKey_Key';
  /** Apigee consumer key (OAuth client ID) associated with this API key. */
  clientId: Scalars['ID'];
  /** Timestamp when the API key was created. */
  createdAt: Scalars['DateTime'];
  /** Unique identifier of the API key. */
  id: Scalars['ID'];
  /** Human-readable label for the API key. */
  name: Scalars['String'];
};

/** Error codes for API key revocation failures. */
export const OrgApiKey_RevokeError = {
  /** The specified API key was not found or is already revoked. */
  KeyNotFound: 'KEY_NOT_FOUND'
} as const;

export type OrgApiKey_RevokeError = typeof OrgApiKey_RevokeError[keyof typeof OrgApiKey_RevokeError];
/** Failure result of revoking an API key. */
export type OrgApiKey_RevokeFailure = {
  __typename?: 'OrgApiKey_RevokeFailure';
  /** Error code indicating the reason for failure. */
  error: OrgApiKey_RevokeError;
  /** Human-readable error message. */
  errorMessage: Scalars['String'];
};

/** Input for revoking an existing API key. */
export type OrgApiKey_RevokeInput = {
  /** The ID of the API key to revoke. */
  keyId: Scalars['ID'];
  /** The third party organization ID that owns the key. */
  thirdPartyOrgId: Scalars['ID'];
};

/** Result of revoking an API key — either success or a typed failure. */
export type OrgApiKey_RevokeResult = OrgApiKey_RevokeFailure | OrgApiKey_RevokeSuccess;

/** Successful result of revoking an API key. */
export type OrgApiKey_RevokeSuccess = {
  __typename?: 'OrgApiKey_RevokeSuccess';
  /** Whether the revocation was successful. */
  success: Scalars['Boolean'];
};

/** Queries for org collections — organization-level content curation managed by enterprise admins. */
export type OrgCollectionQueries = {
  __typename?: 'OrgCollectionQueries';
  /**
   * Finds existing org collections that are duplicates of the provided identity.
   *
   * A duplicate is determined by matching both the organization ID and the unordered
   * set of collection items (compared via a hash of the sorted item IDs). Returns all
   * matching collections, or an empty list if no duplicates are found.
   */
  findDuplicateCollections: Array<OrgCollection_Collection>;
  /**
   * Retrieves an org collection by its unique ID.
   *
   * Returns null if no collection with the given ID exists or if the collection has been archived.
   */
  getCollection?: Maybe<OrgCollection_Collection>;
};


/** Queries for org collections — organization-level content curation managed by enterprise admins. */
export type OrgCollectionQueriesFindDuplicateCollectionsArgs = {
  input: OrgCollection_CollectionIdentityInput;
};


/** Queries for org collections — organization-level content curation managed by enterprise admins. */
export type OrgCollectionQueriesGetCollectionArgs = {
  id: Scalars['ID'];
};

/** Input for OrgCollection_AddCollectionToPrograms. */
export type OrgCollection_AddCollectionToProgramsInput = {
  /** The ID of the collection to add to the given programs. */
  id: Scalars['ID'];
  /** The IDs of the programs to add this collection to. */
  programIds: Array<Scalars['ID']>;
  /**
   * The third-party organization that owns the collection. Used for authorization;
   * the resolver verifies this matches the collection's actual owning organization.
   */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of OrgCollection_AddCollectionToPrograms. */
export type OrgCollection_AddCollectionToProgramsResult = {
  __typename?: 'OrgCollection_AddCollectionToProgramsResult';
  /** The ID of the collection that was updated. */
  id: Scalars['ID'];
};

/** Properties specific to admin-curated collections (custom collections shown on the FE). */
export type OrgCollection_AdminCuratedCollectionProperties = {
  __typename?: 'OrgCollection_AdminCuratedCollectionProperties';
  /** The IDs of programs this collection has been added to. */
  addedToProgramIds?: Maybe<Array<Scalars['ID']>>;
  /** Badge image URL for the collection, used when collectionType is LEARNING_PATH. */
  badgeImageUrl?: Maybe<Scalars['URL']>;
  /** The curriculum items that make up this collection. */
  collectionItems: Array<OrgCollection_CollectionItemId>;
  /** The type of this collection (e.g. standard collection or learning path). */
  collectionType: OrgCollection_CollectionType;
  /** The ID of the program that originally created this collection. */
  createdByProgramId: Scalars['ID'];
  /**
   * The source workflow or system that created this collection. Null if not recorded
   * (e.g. for collections created before this field existed).
   */
  creationSource?: Maybe<OrgCollection_CollectionCreateSource>;
  /** The gradient identifier associated with this collection's visual presentation. */
  gradient?: Maybe<Scalars['String']>;
  /** The ID of the subject associated with this collection. */
  subjectId?: Maybe<Scalars['ID']>;
  /** Total number of units required to complete the collection (used for learning paths). */
  totalUnitsRequired?: Maybe<Scalars['Int']>;
};

/** Input for properties specific to admin-curated collections (custom collections shown on the FE). */
export type OrgCollection_AdminCuratedCollectionPropertiesInput = {
  /** Badge image URL for the collection, used when collectionType is LEARNING_PATH. */
  badgeImageUrl?: InputMaybe<Scalars['URL']>;
  /** The curriculum items that make up this collection. */
  collectionItems: Array<OrgCollection_CollectionItemInput>;
  /** The type of this collection (e.g. standard collection or learning path). */
  collectionType: OrgCollection_CollectionType;
  /** The ID of the program that originally created this collection. */
  createdByProgramId: Scalars['ID'];
  /** The source workflow or system that created this collection. */
  creationSource: OrgCollection_CollectionCreateSource;
  /** The gradient identifier associated with this collection's visual presentation. */
  gradient?: InputMaybe<Scalars['String']>;
  /** The ID of the subject associated with this collection. */
  subjectId?: InputMaybe<Scalars['ID']>;
  /** Total number of units required to complete the collection (used for learning paths). */
  totalUnitsRequired?: InputMaybe<Scalars['Int']>;
};

/** Input for OrgCollection_ArchiveCollection. */
export type OrgCollection_ArchiveCollectionInput = {
  /** Optional reason for archiving the collection. */
  archivalReason?: InputMaybe<Scalars['String']>;
  /** The ID of the collection to archive. */
  id: Scalars['ID'];
  /**
   * The third-party organization that owns the collection. Used for authorization;
   * the resolver verifies this matches the collection's actual owning organization.
   */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of OrgCollection_ArchiveCollection. */
export type OrgCollection_ArchiveCollectionResult = {
  __typename?: 'OrgCollection_ArchiveCollectionResult';
  /** The collection after it was archived. */
  collection: OrgCollection_Collection;
};

/** A collection item referencing a video clip within a course. */
export type OrgCollection_ClipItem = {
  __typename?: 'OrgCollection_ClipItem';
  /** The course that contains the clip. */
  course: Course_Course;
  /** The ID of the specific item (clip) within the course. */
  itemId: Scalars['ID'];
};

/** Identifies a video clip item by its parent course and the specific item ID within that course. */
export type OrgCollection_ClipItemInput = {
  /** The ID of the course containing the clip. */
  courseId: Scalars['ID'];
  /** The ID of the specific item (clip) within the course. */
  itemId: Scalars['ID'];
};

/** Rich-text content encoded in Coursera Markup Language (CML). */
export type OrgCollection_CmlContent = {
  __typename?: 'OrgCollection_CmlContent';
  /** The DTD identifier specifying the CML schema version. */
  dtdId: Scalars['ID'];
  /** The CML-encoded content string. */
  value: Scalars['String'];
};

/** Input for rich-text content encoded in Coursera Markup Language (CML). */
export type OrgCollection_CmlContentInput = {
  /** The DTD identifier specifying the CML schema version. */
  dtdId: Scalars['ID'];
  /** The CML-encoded content string. */
  value: Scalars['String'];
};

/**
 * An organization-level collection of curated learning content, managed by enterprise admins.
 * Org collections store a specific set of curriculum items for a given organization and support
 * duplicate detection via an order-independent hash of their item set.
 */
export type OrgCollection_Collection = {
  __typename?: 'OrgCollection_Collection';
  /** The reason provided when archiving this collection, populated only when status is ARCHIVED. */
  archivalReason?: Maybe<Scalars['String']>;
  /**
   * Type-specific properties for this collection. Use inline fragments to access
   * fields for the concrete type (e.g. `... on OrgCollection_AdminCuratedCollectionProperties`).
   */
  collectionProperties?: Maybe<OrgCollection_CollectionProperties>;
  /** Timestamp (milliseconds since epoch) when this collection was created. */
  createdAt: Scalars['DateTime'];
  /** The ID of the user who created this collection, if available. Immutable after creation. */
  createdBy?: Maybe<Scalars['ID']>;
  /** The optional description of the collection in CML (Coursera Markup Language) format. */
  description?: Maybe<OrgCollection_CmlContent>;
  /** The globally unique identifier for this collection. */
  id: Scalars['ID'];
  /** Timestamp (milliseconds since epoch) when this collection was last updated. */
  lastUpdatedAt: Scalars['DateTime'];
  /** The ID of the user who last modified this collection, if available. */
  lastUpdatedBy?: Maybe<Scalars['ID']>;
  /** The current lifecycle status of this collection. */
  status: OrgCollection_Status;
  /** The third-party organization that owns this collection. */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
  /** The display title of the collection. */
  title?: Maybe<Scalars['String']>;
  /** Version number used to prevent concurrent updates (optimistic concurrency control). */
  version: Scalars['Int'];
};

/** The source workflow or system that originally created a collection. */
export const OrgCollection_CollectionCreateSource = {
  /** Collection created for an academic discipline. */
  AcademicDiscipline: 'ACADEMIC_DISCIPLINE',
  /** Collection created as part of Career Academy. */
  CareerAcademy: 'CAREER_ACADEMY',
  /** Collection created via the content curation workflow. */
  ContentCuration: 'CONTENT_CURATION',
  /** Collection created as a curated collection. */
  CuratedCollection: 'CURATED_COLLECTION',
  /** Collection created via an internal tool. */
  InternalTool: 'INTERNAL_TOOL',
  /** Collection created as part of a learning path. */
  LearningPath: 'LEARNING_PATH',
  /** Collection created via the WES content curation workflow. */
  WesContentCuration: 'WES_CONTENT_CURATION'
} as const;

export type OrgCollection_CollectionCreateSource = typeof OrgCollection_CollectionCreateSource[keyof typeof OrgCollection_CollectionCreateSource];
/**
 * Identifies a collection by its owning organization and unordered set of content items.
 * Used to determine whether a collection with an equivalent identity already exists before creating a new one.
 */
export type OrgCollection_CollectionIdentityInput = {
  /** The type of the collection (e.g. standard collection or learning path). */
  collectionType?: InputMaybe<OrgCollection_CollectionType>;
  /**
   * The content items that make up the collection. Item order is not significant —
   * duplicate detection compares items as an unordered set.
   */
  items: Array<OrgCollection_CollectionItemInput>;
  /** The ID of the third-party organization that owns (or would own) the collection. */
  thirdPartyOrganisationId: Scalars['ID'];
};

/**
 * A curriculum content item within an org collection.
 * Resolves to the appropriate federated entity based on the item type (course, specialization,
 * domain, subdomain), or to OrgCollection_ClipItem for video clip references.
 */
export type OrgCollection_CollectionItemId = Course_Course | Domain_Domain | Domain_Subdomain | OrgCollection_ClipItem | Specialization_Specialization;

/**
 * Represents a single curriculum content item within a collection.
 * Exactly one of the type-specific fields must be set, corresponding to the type of content being referenced.
 */
export type OrgCollection_CollectionItemInput = {
  /** Set to specify this item as a video clip within a course. */
  clipId?: InputMaybe<OrgCollection_ClipItemInput>;
  /** Set to specify this item as a course, using the course ID. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a domain, using the domain ID. */
  domainId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a Specialization (s12n), using the s12n ID. */
  s12nId?: InputMaybe<Scalars['ID']>;
  /** Set to specify this item as a subdomain, using the subdomain ID. */
  subdomainId?: InputMaybe<Scalars['ID']>;
};

/** Add new collection property types here as new variants are introduced. */
export type OrgCollection_CollectionProperties = OrgCollection_AdminCuratedCollectionProperties | OrgCollection_PresetCollectionProperties;

/** The type of an admin-curated collection. */
export const OrgCollection_CollectionType = {
  /** A standard curated collection of content. */
  Collection: 'COLLECTION',
  /** A structured learning path through a curated set of content. */
  LearningPath: 'LEARNING_PATH'
} as const;

export type OrgCollection_CollectionType = typeof OrgCollection_CollectionType[keyof typeof OrgCollection_CollectionType];
/** Input for OrgCollection_CreateCollection. */
export type OrgCollection_CreateCollectionInput = {
  /** Type-specific properties for the collection being created. Exactly one variant must be set. */
  collectionProperties: OrgCollection_CreateCollectionPropertiesInput;
  /** The optional description of the collection in CML (Coursera Markup Language) format. */
  description?: InputMaybe<OrgCollection_CmlContentInput>;
  /** The third-party organization that will own this collection. */
  thirdPartyOrganizationId: Scalars['ID'];
  /** The display title of the collection. */
  title?: InputMaybe<Scalars['String']>;
};

/** Type-specific properties for a new collection. Exactly one field must be set. */
export type OrgCollection_CreateCollectionPropertiesInput = {
  /** Properties for an admin-curated collection (custom collection shown on the FE). */
  adminCuratedCollectionProperties?: InputMaybe<OrgCollection_AdminCuratedCollectionPropertiesInput>;
  /** Properties for a collection sourced from a Coursera preset collection. */
  presetCollectionProperties?: InputMaybe<OrgCollection_PresetCollectionPropertiesInput>;
};

/** Result of OrgCollection_CreateCollection. */
export type OrgCollection_CreateCollectionResult = {
  __typename?: 'OrgCollection_CreateCollectionResult';
  /** The newly created collection. */
  collection: OrgCollection_Collection;
};

/** Properties for collections sourced from a Coursera preset collection and surfaced in an org's catalog. */
export type OrgCollection_PresetCollectionProperties = {
  __typename?: 'OrgCollection_PresetCollectionProperties';
  /** The IDs of programs this collection has been added to. */
  addedToProgramIds?: Maybe<Array<Scalars['ID']>>;
  /** Badge image URL for the collection, used when collectionType is LEARNING_PATH. */
  badgeImageUrl?: Maybe<Scalars['URL']>;
  /** The type of this collection (e.g. standard collection or learning path). */
  collectionType: OrgCollection_CollectionType;
  /** Identifier of the source preset collection this org collection was synced from. */
  presetCollectionId: Scalars['ID'];
};

/** Input for properties of collections sourced from a Coursera preset collection. */
export type OrgCollection_PresetCollectionPropertiesInput = {
  /** Badge image URL for the collection, used when collectionType is LEARNING_PATH. */
  badgeImageUrl?: InputMaybe<Scalars['URL']>;
  /** The type of this collection (e.g. standard collection or learning path). */
  collectionType: OrgCollection_CollectionType;
  /** Identifier of the source preset collection this org collection is synced from. */
  presetCollectionId: Scalars['ID'];
};

/** Input for OrgCollection_RemoveCollectionFromPrograms. */
export type OrgCollection_RemoveCollectionFromProgramsInput = {
  /** The ID of the collection to remove from the given programs. */
  id: Scalars['ID'];
  /** The IDs of the programs to remove this collection from. */
  programIds: Array<Scalars['ID']>;
  /**
   * The third-party organization that owns the collection. Used for authorization;
   * the resolver verifies this matches the collection's actual owning organization.
   */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of OrgCollection_RemoveCollectionFromPrograms. */
export type OrgCollection_RemoveCollectionFromProgramsResult = {
  __typename?: 'OrgCollection_RemoveCollectionFromProgramsResult';
  /** The ID of the collection that was updated. */
  id: Scalars['ID'];
};

/** The lifecycle status of an org collection. */
export const OrgCollection_Status = {
  /** The collection has been archived and is no longer in active use. */
  Archived: 'ARCHIVED',
  /** The collection is in draft and not yet published. */
  Draft: 'DRAFT',
  /** The collection is published and available for use. */
  Published: 'PUBLISHED'
} as const;

export type OrgCollection_Status = typeof OrgCollection_Status[keyof typeof OrgCollection_Status];
/** All OrgVerifiedDomain Queries for domain verification in SSO authentication. */
export type OrgVerifiedDomainQueries = {
  __typename?: 'OrgVerifiedDomainQueries';
  /** Returns OrgVerifiedDomain having the supplied thirdPartyOrganizationId and domain. */
  getById: OrgVerifiedDomain_GetByIdResult;
  /** Returns all OrgVerifiedDomains for the supplied thirdPartyOrganizationId. */
  getByThirdPartyOrganization: Array<OrgVerifiedDomain_Domain>;
};


/** All OrgVerifiedDomain Queries for domain verification in SSO authentication. */
export type OrgVerifiedDomainQueriesGetByIdArgs = {
  domain: Scalars['String'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All OrgVerifiedDomain Queries for domain verification in SSO authentication. */
export type OrgVerifiedDomainQueriesGetByThirdPartyOrganizationArgs = {
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Errors that can occur when creating an OrgVerifiedDomain. */
export const OrgVerifiedDomain_CreateError = {
  /** This domain already exists for the organization. */
  DomainAlreadyExists: 'DOMAIN_ALREADY_EXISTS',
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT'
} as const;

export type OrgVerifiedDomain_CreateError = typeof OrgVerifiedDomain_CreateError[keyof typeof OrgVerifiedDomain_CreateError];
/** Input for creating a new OrgVerifiedDomain. */
export type OrgVerifiedDomain_CreateInput = {
  /**
   * The email domain to add (e.g., "example.com").
   * Must be a valid FQDN.
   */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that will own this domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of creating an OrgVerifiedDomain. Can be either success or failure. */
export type OrgVerifiedDomain_CreateResult = OrgVerifiedDomain_CreateResultFailure | OrgVerifiedDomain_CreateResultSuccess;

/** Failure response when creating an OrgVerifiedDomain. */
export type OrgVerifiedDomain_CreateResultFailure = {
  __typename?: 'OrgVerifiedDomain_CreateResultFailure';
  /** Error that occurred during creation. */
  error: OrgVerifiedDomain_CreateError;
  /** Human-readable error message. */
  errorMessage: Scalars['String'];
};

/** Success response when creating an OrgVerifiedDomain. */
export type OrgVerifiedDomain_CreateResultSuccess = {
  __typename?: 'OrgVerifiedDomain_CreateResultSuccess';
  /** The created domain record with verification metadata. */
  orgVerifiedDomain: OrgVerifiedDomain_Domain;
};

/** Errors that can occur when deleting an OrgVerifiedDomain. */
export const OrgVerifiedDomain_DeleteError = {
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT',
  /** The domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_DeleteError = typeof OrgVerifiedDomain_DeleteError[keyof typeof OrgVerifiedDomain_DeleteError];
/** Input for deleting an OrgVerifiedDomain. */
export type OrgVerifiedDomain_DeleteInput = {
  /** The email domain to delete (e.g., "example.com"). */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that owns the domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of deleting an OrgVerifiedDomain. Can be either success or failure. */
export type OrgVerifiedDomain_DeleteResult = OrgVerifiedDomain_DeleteResultFailure | OrgVerifiedDomain_DeleteResultSuccess;

/** Failure response when deleting an OrgVerifiedDomain. */
export type OrgVerifiedDomain_DeleteResultFailure = {
  __typename?: 'OrgVerifiedDomain_DeleteResultFailure';
  /** Error that occurred during deletion. */
  error: OrgVerifiedDomain_DeleteError;
  /** Human-readable error message. */
  errorMessage: Scalars['String'];
};

/** Success response when deleting an OrgVerifiedDomain. */
export type OrgVerifiedDomain_DeleteResultSuccess = {
  __typename?: 'OrgVerifiedDomain_DeleteResultSuccess';
  /** Indicates the deletion was successful. */
  success: Scalars['Boolean'];
};

/**
 * Response object that represents an OrgVerifiedDomain.
 * This is used for domain verification in SSO authentication.
 * Only users from VERIFIED domains can authenticate via SSO.
 */
export type OrgVerifiedDomain_Domain = {
  __typename?: 'OrgVerifiedDomain_Domain';
  /** Timestamp when the domain was created. */
  createdAt: Scalars['DateTime'];
  /** The email domain (e.g., "example.com"). */
  domain: Scalars['String'];
  /** Composite ID in format: thirdPartyOrganizationId~domain (e.g., "org_abc123~example.com"). */
  id: Scalars['ID'];
  /** The ThirdPartyOrganization ID that owns this domain. */
  thirdPartyOrganizationId: Scalars['ID'];
  /**
   * Metadata for verification as JSON. Structure depends on verificationMethod.
   * For DNS_TXT: { "txtRecordToken": "..." }
   */
  verificationMetadata?: Maybe<Scalars['JSON']>;
  /** Method used to verify the domain. */
  verificationMethod: OrgVerifiedDomain_VerificationMethod;
  /** Current verification status of the domain. */
  verificationStatus: OrgVerifiedDomain_VerificationStatus;
};

/** Result of getting a single OrgVerifiedDomain. Can be either success or failure. */
export type OrgVerifiedDomain_GetByIdResult = OrgVerifiedDomain_Domain | OrgVerifiedDomain_GetResponseFailure;

/** Errors that can occur when fetching OrgVerifiedDomain. */
export const OrgVerifiedDomain_GetResponseError = {
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The requested domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_GetResponseError = typeof OrgVerifiedDomain_GetResponseError[keyof typeof OrgVerifiedDomain_GetResponseError];
/** Failure response when getting an OrgVerifiedDomain. */
export type OrgVerifiedDomain_GetResponseFailure = {
  __typename?: 'OrgVerifiedDomain_GetResponseFailure';
  /** Error that occurred while fetching the domain. */
  error: OrgVerifiedDomain_GetResponseError;
};

/** Method used to verify domain ownership. */
export const OrgVerifiedDomain_VerificationMethod = {
  /** Self-serve DNS TXT record verification. Admin adds a TXT record to their domain's DNS. */
  DnsTxt: 'DNS_TXT',
  /** Manual verification by platform admin (SA). Used for legacy or high-risk customers. */
  Manual: 'MANUAL'
} as const;

export type OrgVerifiedDomain_VerificationMethod = typeof OrgVerifiedDomain_VerificationMethod[keyof typeof OrgVerifiedDomain_VerificationMethod];
/** Verification status of an organization domain for SSO authentication. */
export const OrgVerifiedDomain_VerificationStatus = {
  /** Domain has been added but not yet verified. */
  Unverified: 'UNVERIFIED',
  /** Domain has been successfully verified. */
  Verified: 'VERIFIED'
} as const;

export type OrgVerifiedDomain_VerificationStatus = typeof OrgVerifiedDomain_VerificationStatus[keyof typeof OrgVerifiedDomain_VerificationStatus];
/** Errors that can occur when verifying an OrgVerifiedDomain. */
export const OrgVerifiedDomain_VerifyError = {
  /** DNS resolution failed. Please try again later. */
  DnsResolutionFailed: 'DNS_RESOLUTION_FAILED',
  /** An internal service error occurred. */
  InternalError: 'INTERNAL_ERROR',
  /** The domain format is invalid. Must be a valid FQDN. */
  InvalidDomainFormat: 'INVALID_DOMAIN_FORMAT',
  /** The domain was not found for the organization. */
  NotFound: 'NOT_FOUND'
} as const;

export type OrgVerifiedDomain_VerifyError = typeof OrgVerifiedDomain_VerifyError[keyof typeof OrgVerifiedDomain_VerifyError];
/** Input for verifying an OrgVerifiedDomain. */
export type OrgVerifiedDomain_VerifyInput = {
  /** The email domain to verify (e.g., "example.com"). */
  domain: Scalars['String'];
  /** The ThirdPartyOrganization ID that owns the domain. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of verifying an OrgVerifiedDomain. Can be either success or failure. */
export type OrgVerifiedDomain_VerifyResult = OrgVerifiedDomain_VerifyResultFailure | OrgVerifiedDomain_VerifyResultSuccess;

/** Failure response when verifying an OrgVerifiedDomain. */
export type OrgVerifiedDomain_VerifyResultFailure = {
  __typename?: 'OrgVerifiedDomain_VerifyResultFailure';
  /** Error that occurred during verification. */
  error: OrgVerifiedDomain_VerifyError;
  /** Human-readable error message. */
  errorMessage: Scalars['String'];
};

/** Success response when verifying an OrgVerifiedDomain. */
export type OrgVerifiedDomain_VerifyResultSuccess = {
  __typename?: 'OrgVerifiedDomain_VerifyResultSuccess';
  /** The verified domain record with updated status. */
  orgVerifiedDomain: OrgVerifiedDomain_Domain;
};

/** Learner is ahead of course schedule */
export type OverallCourseStatus_AheadOfSchedule = {
  __typename?: 'OverallCourseStatus_AheadOfSchedule';
  /** Number of days ahead of schedule */
  daysAheadOfSchedule: Scalars['Int'];
};

/** Learner completed course */
export type OverallCourseStatus_Completed = {
  __typename?: 'OverallCourseStatus_Completed';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Learner is on track */
export type OverallCourseStatus_OnTrack = {
  __typename?: 'OverallCourseStatus_OnTrack';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Learner has one or more overdue items */
export type OverallCourseStatus_Overdue = {
  __typename?: 'OverallCourseStatus_Overdue';
  /** Number of days behind schedule */
  daysBehindSchedule: Scalars['Int'];
  /** Total number of overdue items */
  totalOverdueItems: Scalars['Int'];
};

/** Push deadline when the overdue deadlines have been due for more than 2 weeks */
export type OverallCourseStatus_PushDeadlines = {
  __typename?: 'OverallCourseStatus_PushDeadlines';
  /** Number of days to adjust */
  daysToAdjust: Scalars['Int'];
  /** Newly computed completion date time */
  newCompletionDateTime: Scalars['DateTime'];
};

/** Overall course status */
export type OverallCourseStatus_Status = OverallCourseStatus_AheadOfSchedule | OverallCourseStatus_Completed | OverallCourseStatus_OnTrack | OverallCourseStatus_Overdue | OverallCourseStatus_PushDeadlines;

/** Query operations for retrieving promotional pricing on ownable products. */
export type OwnableProductPromotionPriceQueries = {
  __typename?: 'OwnableProductPromotionPriceQueries';
  /**
   * Retrieves the promotional price for a specific ownable product when a promotion code is applied.
   * Returns only the calculated price after applying the promotion.
   *
   * Args:
   * input: Contains the product identifier and promotion details
   *
   * Returns:
   * OwnableProductPrice object with promotional pricing details
   *
   * Throws:
   * GraphQL exception when any of the following is true:
   *   (1) No active product with the given product_id
   *   (2) No active promotion with the given promotion_id
   *
   * Note:
   *   Does not validate if the promotion is applicable for the given product configuration and/or userId.
   */
  queryOwnableProductPromotionPrice?: Maybe<OwnableProduct_OwnableProductPrice>;
};


/** Query operations for retrieving promotional pricing on ownable products. */
export type OwnableProductPromotionPriceQueriesQueryOwnableProductPromotionPriceArgs = {
  input: OwnableProduct_PromotionPrice_Input;
};

/** OwnableProductQueries */
export type OwnableProductQueries = {
  __typename?: 'OwnableProductQueries';
  /**
   * Fetches the baseline price configuration for the product used primarily by the authoring page.
   *
   * For all requests coming from s12n authoring page, the baseline price configuration is the price
   * configuration associated to the monthly subscription product sku.
   *
   * For all requests coming from course authoring page, the baseline price configuration is the price
   * configuration associated to the 180 day one-time product sku.
   */
  findBaselinePriceConfigurationForProduct?: Maybe<OwnableProduct_ProductConfigurationToPriceConfigurationMapping>;
  /** Get an Ownable Product Fulfillment Configuration by its ID */
  findById?: Maybe<OwnableProduct_OwnableProductTuple>;
  /** Get a set of Ownable Product Fulfillment Configurations from a set of IDs */
  findByIds: Array<Maybe<OwnableProduct_OwnableProductTuple>>;
  /**
   * Get a list of Ownable Product Fulfillment Configurations by its underlying Ownable Product ID.
   * This call is equivalent to the ProductSkusResource#findByUnderlying scala call
   */
  findByOwnableProductId: Array<Maybe<OwnableProduct_OwnableProductTuple>>;
  /**
   * Get a list of Ownable Product Fulfillment Configurations by its Underlying Ownable Product Item ID
   * This call is equivalent to the ProductSkusResource#findByUnderlyingProductItemId
   */
  findByOwnableProductItemId: Array<Maybe<OwnableProduct_OwnableProductTuple>>;
  /**
   * Get an Ownable Product Fulfillment Configuration using its legacy product ID
   * This call is equivalent to ProductSkusResource#get
   */
  findLatestByLegacyProductId?: Maybe<OwnableProduct_OwnableProductTuple>;
  /**
   * Get a list of Ownable Product Fulfillment Configurations using its legacy product ID
   * This call is equivalent to ProductSkusResource:multiGet
   */
  findLatestByLegacyProductIds: Array<Maybe<OwnableProduct_OwnableProductTuple>>;
  /** Fetches the list of active ownable product partner revshare records by ownable product ID */
  getActiveOwnableProductPartnerRevshareRecordsByOwnableProductId: Array<OwnableProduct_OwnableProductPartnerRevshare>;
  /**
   * Get all standardized price configurations used primarily by the authoring pages.
   * Currently only supports S12ns and VCs as those are the only two new authoring product types.
   */
  getAllStandardizedPriceConfigurationsForProductType: Array<OwnableProduct_PriceConfiguration>;
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindBaselinePriceConfigurationForProductArgs = {
  productItemId: Scalars['ID'];
  productType: OwnableProduct_PriceConfiguration_SupportedProductType;
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindByIdArgs = {
  id: Scalars['ID'];
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindByOwnableProductIdArgs = {
  productId: OwnableProduct_ProductId_Input;
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindByOwnableProductItemIdArgs = {
  underlyingProductItemId: Scalars['ID'];
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindLatestByLegacyProductIdArgs = {
  legacyProductId: OwnableProduct_ProductId_Input;
};


/** OwnableProductQueries */
export type OwnableProductQueriesFindLatestByLegacyProductIdsArgs = {
  legacyProductIds: Array<OwnableProduct_ProductId_Input>;
};


/** OwnableProductQueries */
export type OwnableProductQueriesGetActiveOwnableProductPartnerRevshareRecordsByOwnableProductIdArgs = {
  ownableProductId: Scalars['ID'];
};


/** OwnableProductQueries */
export type OwnableProductQueriesGetAllStandardizedPriceConfigurationsForProductTypeArgs = {
  productType: OwnableProduct_PriceConfiguration_SupportedProductType;
};

/** GraphQL representation of BillingCycle.courier */
export const OwnableProduct_BillingCycle = {
  /** Annual Billing Cycle */
  BillingCycleAnnual: 'BILLING_CYCLE_ANNUAL',
  /** Biannual Billing Cycle */
  BillingCycleBiannual: 'BILLING_CYCLE_BIANNUAL',
  /** Invalid Billing Cycle */
  BillingCycleInvalid: 'BILLING_CYCLE_INVALID',
  /** Monthly Billing Cycle */
  BillingCycleMonthly: 'BILLING_CYCLE_MONTHLY'
} as const;

export type OwnableProduct_BillingCycle = typeof OwnableProduct_BillingCycle[keyof typeof OwnableProduct_BillingCycle];
/** Errors from the ownable-products-application. */
export type OwnableProduct_Error = {
  /** Error message. */
  message: Scalars['String'];
};

/** A reference to the fulfillmentConfiguration type. */
export type OwnableProduct_FulfillmentConfiguration = {
  __typename?: 'OwnableProduct_FulfillmentConfiguration';
  /**
   * Timestamp representing when a given fulfillment configuration became an invalid way to gain access to a given
   * ownable product. None indicates this fulfillment configuration should be valid forever.
   */
  expiredAt?: Maybe<Scalars['DateTime']>;
  /** ID of the fulfillmentConfiguration used to uniquely identify an OwnableProductTuple entity. */
  id: Scalars['ID'];
  /**
   * TODO: The importance of this field is unclear. It seems like most code in `ProductStoreImpl` refers to `startDate`
   *  and `endDate` to determine whether a product is valid, expire products, etc.
   */
  isActive: Scalars['Boolean'];
  /**
   * This maps to `ProductMetadata#paidProductId`.
   *
   * Historically, this field has very low importance / usages. The only notable usage is as a foreign key in the
   * `ProductPartner` model.
   *
   * We need to maintain this field for backfill / migration purposes. Eventually we should migrate `ProductPartner` to
   * use another ID, likely `OwnableProductId`.
   *
   * If `ProductPartner` data differs depending on the fulfillment configuration as well, we may also want to include
   * `OwnableProductFulfillmentConfigurationId`. This is pretty unlikely.
   */
  legacyId?: Maybe<Scalars['Int']>;
  /**
   * This maps to `ProductMetadata#productId` NOT `ProductMetadata#underlyingProductId`.
   *
   * The main goal of the Next Gen Product Configuration System is getting rid of this field. `ProductType` values in
   * this ID can take the value of our badly modeled "wrapper" ProductTypes, e.g. `SpecializationSubscription`. Going forward,
   * we want `PaymentScheme` to house the context about how a learner is gaining access to a given `OwnableProduct`.
   *
   * See documentation on `OwnableProductFulfillmentConfiguration#id` for more context.
   */
  legacyProductId?: Maybe<OwnableProduct_ProductId>;
  /** The OwnableProduct that this fulfillment configuration is tied to. */
  ownableProduct: OwnableProduct_OwnableProduct;
  /** The PaymentScheme that this fulfillment configuration is tied to. */
  paymentScheme: OwnableProduct_PaymentScheme;
  /**
   * Timestamp representing when a given fulfillment configuration became a valid way to gain access to a given
   * ownable product.
   */
  startedAt: Scalars['DateTime'];
};

/** GraphQL representation of InstallmentPaymentScheme.courier */
export type OwnableProduct_InstallmentPaymentScheme = {
  __typename?: 'OwnableProduct_InstallmentPaymentScheme';
  /**
   * The cadence of installment charge. Currently we uses BillingCycle from subscriptions
   * because our installment products are built as "subscription products with limited
   * number of billing cycles". It's charged on a [BillingCycle] basis and uses the
   * subscription engine underneath.
   */
  chargeCadence: OwnableProduct_BillingCycle;
  /** The number of installments. (or the number of BillingCycle with the current implementation) */
  numberOfInstallments: Scalars['Int'];
  /** The number of free trial days. */
  numberOfTrialDays: Scalars['Int'];
  /**
   * The ownership period (in days) that users will have after purchasing the product.
   * This is the days in total of all installments. Per installment ownershipDays is
   * calculated using ownershipDays / numberOfInstallments and are granted to user after
   * each installment. Reporting also uses the per installment ownershipDays to calculate
   * revenue recognition period.
   */
  ownershipDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/** GraphQL representation of NotApplicablePaymentScheme.courier */
export type OwnableProduct_NotApplicablePaymentScheme = {
  __typename?: 'OwnableProduct_NotApplicablePaymentScheme';
  /** Stated reason for the payment scheme not being applicable */
  reason: Scalars['String'];
};

/** OneTimePaymentScheme representation */
export type OwnableProduct_OneTimePaymentScheme = {
  __typename?: 'OwnableProduct_OneTimePaymentScheme';
  /**
   * The ownership period (in days) that users will have after purchasing the product.
   * This is also used to calculate revenue recognition period in reporting.
   */
  ownershipDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/** Ownable product model */
export type OwnableProduct_OwnableProduct = {
  __typename?: 'OwnableProduct_OwnableProduct';
  /**
   * An opaque identifier for an ownable product that will generally be referenced by Consumer flows (checkout,
   * configuration, enrollment modal, etc.).
   *
   * In the short-term, I envision the main purpose of this field as a more convenient way of representing the
   * one-to-many relationship between `OwnableProduct` -> `OwnableProductFulfillmentConfiguration`.
   *
   * My hunch is that we will probably continue to prefer productType~productItemId as the unique identifier for an
   * `OwnableProduct` in application code, especially as we're working through the migration in the short-term.
   *
   * I'm not sure what usage of `OwnableProductId` will look like in the future, I'm mainly including it for now for
   * the sake of modeling best practices.
   *
   * POSSIBLE EXTENSIONS FOR THIS MODEL:
   *
   * The original design doc (https://docs.google.com/document/d/1kOdR8owvZQV_ZXt7xWhZQJR6GDsxKTDF_GJtLRU9TCc/edit)
   * includes a `properties` field on this model (referred to as `ProductCatalogEntity` in old documents). The intention
   * behind this field was to support additional metadata that is PRODUCT-specific. We have omitted it because there
   * isn't an existing use case. However, we think it is feasible that Coursera will eventually develop product
   * features/experiences for which this field/abstraction most sensibly supports, which is why we've decided to call
   * out/document this extension specifically.
   *
   * Example use case: We create domain-specific Coursera Plus products (Data Science Coursera Plus, Software Engineer
   * Coursera Plus). The `properties` field could contain metadata about what domain this Coursera Plus product is for,
   * which could be used presentationally, in post-purchase side-effects (e.g. send a Github repo invitation for Data
   * Science/Software Engineer Coursera Plus but not MBA Coursera Plus), etc.
   *
   * The ontology of this field would probably map closely to some subset of the ontology of the ProductType model (e.g.
   * CourseraPlusProductProperties, SpecializationProductProperties, etc.).
   *
   * NOTE: The proposed `properties` field in this model should not be confused with the legacy
   * `ProductMetadata#properties` field. The legacy field is a badly named field, which most closely resembles
   * `OwnableProductFulfillmentConfiguration#paymentScheme`, e.g. payment/fulfillment-specific metadata, which includes
   * no product-specific context.
   */
  id: Scalars['ID'];
  /**
   * This maps to `ProductMetadata#underlyingProductId#productItemId`.
   *
   *  For products that map to a specific piece of content, this should generally be a string value which holds meaning /
   *  corresponds to data in other teams / systems, e.g. S12nId, DegreeId, CourseId. For these types of products, we
   *  generally use the ID to make API calls to external systems. Examples:
   *   - To execute post-checkout side-effects such as course/s12n membership creation, degree auto-enrollment, etc.
   *   - To fetch the courses in an s12n for cart item building
   *
   *  For this case, the serialized representations of
   *  ProductItemId and the external ID model are equivalent, we merely deserialize it into a different model for type
   *  safety.
   *
   *  For products that don’t map to a specific piece of content (`CourseraPlus`, `EnterpriseContract`), this is
   *  generally a randomly generated ID with no external meaning.
   *
   *  TODO: As we start migrating our systems to refer to this modeling, I envision some redundancy between `ProductItemId`
   *  and `OwnableProductId`. For now, we dumbly / blindly maintain this field for backwards compatibility / safety. We
   *  want to be able to cleanly reconstruct the legacy model's structure until the entire Next Gen Product Configuration
   *  System project is finished and in the wild for a bit.
   *
   *  Random ideas for dealing with potential redundancy in the future:
   *   - Rename this to something like `externalContext` that is optional and only used when additional external context
   *   is needed (e.g. for post-checkout side-effects)
   */
  productItemId: Scalars['ID'];
  /**
   * This maps to `ProductMetadata#underlyingProductId#productType`.
   *
   * In the legacy modeling, this could be any of the ProductType values defined here: https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/scala/org/coursera/product/ProductType.scala.
   * In the next gen modeling, this field should only reference ProductTypes that are agnostic of payment/billing
   * schemes, e.g. `Specialization` is valid, `SpecializationSubscription` is not.
   *
   * This is the primary insight motivating the Next Gen Product Configuration project: ideally, a ProductType and
   * ProductItemId tuple should only identify "what a learner is getting access to" not both "what a learner is getting
   * access to" and "how they're getting access to it" (see original proposal for rationale).
   *
   * I'm deliberately ignoring the `ProductId` convenience model and preferring individual `ProductType` and
   * `ProductItemId` fields here. It's a bit smelly to me if this model just encompasses two IDs (`OwnableProductId` and
   * `ProductId`). I think this smell is a result of suboptimal naming / modeling. Maybe ProductItemId is a bit of a
   * misnomer? In some cases it is just an opaque ID, in other cases it has external meaning in other systems / DB tables (see
   * below for more context). Maybe we don't need `OwnableProductId` at all? I'm deferring these questions until we get
   * deeper in the migration.
   */
  productType: OwnableProduct_ProductType;
};

/** The revenue shared by a partner for a given ownable product. */
export type OwnableProduct_OwnableProductPartnerRevshare = {
  __typename?: 'OwnableProduct_OwnableProductPartnerRevshare';
  /** The UTC datetime at which this revshare split for this ownable product was expired. Absence indicates this revshare split is active. */
  expiredAt?: Maybe<Scalars['DateTime']>;
  /**
   * An identifier for ownable products, usually formatted like op_jSYyHOPlSBq2EOfAzUIY4Q.
   * This ID shares a 1:1 relationship with underlying_product_id. It also has a 1:many relationship
   * with opfc_ IDs. A helpful way to think about it is that op_ represents "what you're getting"
   * and opfc_ represents "how you're getting it".
   */
  ownableProductId: Scalars['ID'];
  /** The partner that corresponds to this revshare split */
  partner: Partner_Partner;
  /**
   * The numerator of the overall fraction of revenue that the partner earns.
   * For example, if a given partner has a revshare count of 3 out of a revshare total
   * of 5, then the partner would earn 3/5 (i.e. 60%) of the revenue for that ownable product.
   */
  revshareCount: Scalars['Int'];
  /** The denominator of the overall fraction of revenue that the partner earns. */
  revshareTotal: Scalars['Int'];
  /** The UTC datetime at which this revshare split for this ownable product started */
  startedAt: Scalars['DateTime'];
};

/** Represents the price of a product in a specific country */
export type OwnableProduct_OwnableProductPrice = {
  __typename?: 'OwnableProduct_OwnableProductPrice';
  /** Amount in the localized currency. */
  amount: MonetaryAmount;
  /** The configuration details for the price */
  configuration: OwnableProduct_OwnableProductPrice_Configuration;
  /** Origin country used to apply geo-pricing */
  priceCountryIsoCode: Scalars['String'];
  /** Amount in USD currency code. */
  usdAmount: MonetaryAmount;
};

/** Represents the price configuration details for the price */
export type OwnableProduct_OwnableProductPrice_Configuration = {
  __typename?: 'OwnableProduct_OwnableProductPrice_Configuration';
  /** price configuration id. */
  id: Scalars['ID'];
};

/** A reference to OwnableProductTuple federated entity containing product, fulfillment and price configuration information. */
export type OwnableProduct_OwnableProductTuple = {
  __typename?: 'OwnableProduct_OwnableProductTuple';
  /** fulfillmentConfiguration object that contains the ID used to uniquely identify an OwnableProductTuple entity. */
  fulfillmentConfiguration: OwnableProduct_FulfillmentConfiguration;
  /**
   * The content (Course or S12n) or experience (Coursera Plus) that the learner is actually gaining
   * access to by purchasing the given fulfillmentConfiguration.
   */
  ownableProduct: OwnableProduct_OwnableProduct;
  /** The price information associated with the ownable product tuple. */
  price: OwnableProduct_OwnableProductPrice;
};

/** A Partner and revshare split pair. */
export type OwnableProduct_PartnerRevshareSplitInput = {
  /** The ID of the partner that corresponds to this revshare split */
  partnerId: Scalars['ID'];
  /**
   * The numerator of the overall fraction of revenue that the partner earns.
   * For example, if a given partner has a revshare count of 3 out of a revshare total
   * of 5, then the partner would earn 3/5 (i.e. 60%) of the revenue for that ownable product.
   */
  revshareCount: Scalars['Int'];
  /** The denominator of the overall fraction of revenue that the partner earns. */
  revshareTotal: Scalars['Int'];
};

/** GraphQL representation of PaymentScheme.courier */
export type OwnableProduct_PaymentScheme = OwnableProduct_InstallmentPaymentScheme | OwnableProduct_NotApplicablePaymentScheme | OwnableProduct_OneTimePaymentScheme | OwnableProduct_SubscriptionPaymentScheme;

/**
 * Represents a wrapper object to encapsulate both a base price and regional overrides (aka geo-prices).
 * This allows pricing to be more configurable with an overarching price and regional overrides where necessary.
 */
export type OwnableProduct_PriceConfig = {
  __typename?: 'OwnableProduct_PriceConfig';
  /**
   * Price in USD.
   * This is not necessary the price in US (could be that there is a geo-override for US) and should be thought of as rest of the world price.
   */
  basePriceInUsd: MonetaryAmount;
  /** List of regional price overrides over the base price. This allows for setting different product prices across different countries. */
  regionalPriceOverrides: Array<OwnableProduct_RegionalPrice>;
};

/** Price configuration is a versioned representation of the price template and some metadata. */
export type OwnableProduct_PriceConfiguration = {
  __typename?: 'OwnableProduct_PriceConfiguration';
  /**
   * price template
   * Price template representing an ordered collection of prices.
   */
  globalPriceConfig: OwnableProduct_PriceConfig;
  /**
   * Indicates whether or not this price configuration belongs exclusively to a high value partner.
   * List of partners include (Google, Meta, IBM)
   */
  highValuePartner?: Maybe<OwnableProduct_PriceConfiguration_HighValuePartner>;
  /** price configuration id. */
  id: Scalars['ID'];
  /** price configuration name. */
  name: Scalars['String'];
  /**
   * price configuration version.
   * This is used to prevent users from updating a stale price configuration.
   * When updating the value, ensure to set it to current epoch time in seconds.
   */
  version: Scalars['Int'];
};

/**
 * GraphQL enum containing supported product partners for authoring purposes.
 * This information is critical for when associating to the new pricing engine.
 */
export const OwnableProduct_PriceConfiguration_HighValuePartner = {
  /** GOOGLE partner */
  Google: 'GOOGLE',
  /** IBM partner */
  Ibm: 'IBM',
  /** META partner */
  Meta: 'META'
} as const;

export type OwnableProduct_PriceConfiguration_HighValuePartner = typeof OwnableProduct_PriceConfiguration_HighValuePartner[keyof typeof OwnableProduct_PriceConfiguration_HighValuePartner];
/** GraphQL enum containing supported price configuration product types */
export const OwnableProduct_PriceConfiguration_SupportedProductType = {
  /** Specialization product type */
  Specialization: 'SPECIALIZATION',
  /** Course product type */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type OwnableProduct_PriceConfiguration_SupportedProductType = typeof OwnableProduct_PriceConfiguration_SupportedProductType[keyof typeof OwnableProduct_PriceConfiguration_SupportedProductType];
/** Represents the mapping between a product configuration to a price configuration. */
export type OwnableProduct_ProductConfigurationToPriceConfigurationMapping = {
  __typename?: 'OwnableProduct_ProductConfigurationToPriceConfigurationMapping';
  /** Price configuration is a versioned representation of the price template and some metadata. */
  priceConfiguration: OwnableProduct_PriceConfiguration;
  /** Product configuration is one of the many representations of how a product can be purchased. */
  productFulfillmentConfiguration: OwnableProduct_FulfillmentConfiguration;
  /** Timestamp representing when the above price configuration to product configuration association was created. */
  startedAt: Scalars['DateTime'];
};

/** GraphQL representation of coursera.proto.sharedentitlement.v1beta1.ProductId */
export type OwnableProduct_ProductId = {
  __typename?: 'OwnableProduct_ProductId';
  /** ID for the product */
  productItemId: Scalars['ID'];
  /** Product Type for the Product */
  productType: OwnableProduct_ProductType;
};

/** GraphQL representation of coursera.proto.sharedentitlement.v1beta1.ProductId */
export type OwnableProduct_ProductId_Input = {
  /** ID for the product */
  productItemId: Scalars['ID'];
  /** Product Type for the Product */
  productType: OwnableProduct_ProductType;
};

/** Product Types defined in ProductType.scala */
export const OwnableProduct_ProductType = {
  /** CourseraPlus */
  ProductTypeCourseraPlus: 'PRODUCT_TYPE_COURSERA_PLUS',
  /** CourseraPlusSubscription */
  ProductTypeCourseraPlusSubscription: 'PRODUCT_TYPE_COURSERA_PLUS_SUBSCRIPTION',
  /** CourseraTierLite */
  ProductTypeCourseraTierLite: 'PRODUCT_TYPE_COURSERA_TIER_LITE',
  /** CredentialTrack - Prepaid version of CredentialTrackSubscriptionV2 */
  ProductTypeCredentialTrack: 'PRODUCT_TYPE_CREDENTIAL_TRACK',
  /** CredentialTrackCourse */
  ProductTypeCredentialTrackCourse: 'PRODUCT_TYPE_CREDENTIAL_TRACK_COURSE',
  /** Legacy CredentialTrackCourseV2 */
  ProductTypeCredentialTrackCourseV2: 'PRODUCT_TYPE_CREDENTIAL_TRACK_COURSE_V2',
  /** Legacy CredentialTrackSubscription */
  ProductTypeCredentialTrackSubscription: 'PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION',
  /** CredentialTrackSubscriptionV2 */
  ProductTypeCredentialTrackSubscriptionV2: 'PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** ENTERPRISE_CONTRACT */
  ProductTypeEnterpriseContract: 'PRODUCT_TYPE_ENTERPRISE_CONTRACT',
  /** Invalid product type */
  ProductTypeInvalid: 'PRODUCT_TYPE_INVALID',
  /** Specialization */
  ProductTypeSpecialization: 'PRODUCT_TYPE_SPECIALIZATION',
  /** SpecializationPrepaid */
  ProductTypeSpecializationPrepaid: 'PRODUCT_TYPE_SPECIALIZATION_PREPAID',
  /** SpecializationSubscription */
  ProductTypeSpecializationSubscription: 'PRODUCT_TYPE_SPECIALIZATION_SUBSCRIPTION',
  /** VerifiedCertificate */
  ProductTypeVerifiedCertificate: 'PRODUCT_TYPE_VERIFIED_CERTIFICATE'
} as const;

export type OwnableProduct_ProductType = typeof OwnableProduct_ProductType[keyof typeof OwnableProduct_ProductType];
/** Input parameters for querying promotional pricing on ownable products. */
export type OwnableProduct_PromotionPrice_Input = {
  /**
   * Unique identifier for the ownable product configuration.
   * Required to determine base pricing and apply promotion.
   */
  productId: OwnableProduct_ProductId_Input;
  /**
   * Promotion details specifying which discount to apply.
   * Must contain either a promotion code string or promotion ID.
   */
  promotion: OwnableProduct_Promotion_Input;
};

/**
 * Union input type for specifying a promotion using either a code string or unique ID.
 * Exactly one field must be provided due to @oneOf directive.
 */
export type OwnableProduct_Promotion_Input = {
  /**
   * Human-readable promotion code (e.g., "SUMMER2024", "WELCOME10").
   * Case-sensitive string that customers typically enter manually.
   */
  promoCode?: InputMaybe<Scalars['String']>;
  /**
   * Internal unique identifier for the promotion.
   * More reliable than codes as it doesn't change and avoids case sensitivity issues.
   */
  promotionId?: InputMaybe<Scalars['ID']>;
};

/** Represents regional prices inside a price template. */
export type OwnableProduct_RegionalPrice = {
  __typename?: 'OwnableProduct_RegionalPrice';
  /** Country in which the regional price is applied. */
  countryIsoCode: Scalars['String'];
  /** Regional prices defined for the above country. At least one price should be defined for the USD currency code. */
  regionalPrices: Array<MonetaryAmount>;
};

/** GraphQL representation of SubscriptionPaymentScheme.courier */
export type OwnableProduct_SubscriptionPaymentScheme = {
  __typename?: 'OwnableProduct_SubscriptionPaymentScheme';
  /** GraphQL representation of BillingCycle.courier */
  billingCycle: OwnableProduct_BillingCycle;
  /** The number of free trial days. */
  numberOfTrialDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/** Errors from the OwnableProduct_UpsertOwnableProductPartnerRevshareRecords mutation. */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsError = OwnableProduct_Error & {
  __typename?: 'OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsError';
  /** Error message. */
  message: Scalars['String'];
};

/** Failed OwnableProduct_UpsertOwnableProductPartnerRevshareRecords response body */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsFailure = {
  __typename?: 'OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsFailure';
  /** Error details. */
  errors: Array<OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsError>;
};

/** OwnableProduct_UpsertOwnableProductPartnerRevshareRecords request body */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsInput = {
  /** The ownable product ID by which to upsert ownable product partner revshare records */
  ownableProductId: Scalars['ID'];
  /** The list of partner revshare splits to upsert */
  partnerRevshareSplits: Array<OwnableProduct_PartnerRevshareSplitInput>;
};

/** OwnableProduct_UpsertOwnableProductPartnerRevshareRecords response body */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsResult = OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsFailure | OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsSuccess;

/** Successful OwnableProduct_UpsertOwnableProductPartnerRevshareRecords response body */
export type OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsSuccess = {
  __typename?: 'OwnableProduct_UpsertOwnableProductPartnerRevshareRecordsSuccess';
  /** The now-active list of ownable product partner revshare records */
  ownableProductPartnerRevshareRecords: Array<OwnableProduct_OwnableProductPartnerRevshare>;
};

/** Queries for config enabled pages. */
export type PageConfigQueries = {
  __typename?: 'PageConfigQueries';
  /**
   * Same as "queryComponents", but returns information about the chosen config and any overrides applied.
   * For debugging purposes.
   */
  debugQueryComponents?: Maybe<PageConfig_DebugQueryResponse>;
  /**
   * Returns a list of PageConfig_Components for the browse all page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryBrowseAllComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the browse domain pages with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryBrowseDomainComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the browse skill pages with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryBrowseSkillComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components from a given page (PageConfig_PageName) and possibly program slug.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryComponents?: Maybe<Array<Maybe<PageConfig_BrowseDegreeCollectionComponent | PageConfig_BrowseDomainListComponent | PageConfig_BrowseLoggedOutProgressiveOnboardingComponent | PageConfig_BrowseRelatedSkillsComponent | PageConfig_BrowseValuePropositionComponent | PageConfig_CampaignsCannedCollectionComponent | PageConfig_CoachOnboardingBanner | PageConfig_CollectionComponent | PageConfig_CompactCollectionComponent | PageConfig_CompactPremiumCollectionComponent | PageConfig_CoreSkillsComponent | PageConfig_CoreSkillsForRoleComponent | PageConfig_CourseraPlusBanner | PageConfig_DomainPillsComponent | PageConfig_EmbeddedPromoTemplatePage | PageConfig_EnrolledProductsComponent | PageConfig_EnterpriseAssignedCourses | PageConfig_EnterpriseBadgeCollectionsComponent | PageConfig_EnterpriseBrowseCollectionComponent | PageConfig_EnterpriseCourseraContentHeading | PageConfig_EnterpriseCuratedCollectionAndBadgeComponent | PageConfig_EnterpriseCuratedCollectionComponent | PageConfig_EnterpriseForCreditCollectionComponent | PageConfig_EnterpriseLearningPaths | PageConfig_EnterpriseOrganizationContentHeading | PageConfig_EnterpriseSkillClipsCollectionComponent | PageConfig_ExperimentalComponent | PageConfig_ExploreRolesComponent | PageConfig_FaqComponent | PageConfig_GoogleProgramBanner | PageConfig_GoogleProgramFooter | PageConfig_GroupedComponentsWrapper | PageConfig_LevelSets | PageConfig_MediumIntentSearchValuePropositionComponent | PageConfig_MediumIntentSearchValuePropositionForPartnerComponent | PageConfig_ModularOnboarding | PageConfig_MostPopularFreeByRoleCollection | PageConfig_MostPopularFreeBySkillCollection | PageConfig_MostPopularFreeCollection | PageConfig_OnboardingAdvancersHomeComplexCollection | PageConfig_OnboardingResultsHeaderComponent | PageConfig_PathwayDegreesCollection | PageConfig_PathwayDegreesOffersCreditEnrolledCollection | PageConfig_PathwayDegreesPartOfEnrolledCollection | PageConfig_PathwayFreeTrialCollection | PageConfig_PathwayRecommendationsComponent | PageConfig_PremiumCollectionComponent | PageConfig_PromoUnitsComponent | PageConfig_ReferralBanner | PageConfig_RelatedRolesComponent | PageConfig_SearchFrameComponent | PageConfig_SearchQueriesComponent | PageConfig_SkillDescriptionAndScoreComponent | PageConfig_SkillSetCardsComponent | PageConfig_SkillsFocusComponent | PageConfig_SkillsRecsComplexCollection | PageConfig_SpotlightCollectionComponent | PageConfig_StackablePathwayContentCollection | PageConfig_StandardRolesCollection | PageConfig_TopCourseraPartnersComponent | PageConfig_TopPartnersComponent | PageConfig_TrackDegreeProgress | PageConfig_UpsellComponent>>>;
  /**
   * Returns a list of PageConfig_Components for the consumer logged-in home page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryConsumerHomeComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the consumer search page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryConsumerSearchComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the enterprise home page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryEnterpriseHomeComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the enterprise org browse all page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryEnterpriseOrgBrowseAllComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the enterprise org browse domain pages with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryEnterpriseOrgBrowseDomainComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the enterprise org home page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryEnterpriseOrgHomeComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the enterprise org skill pages with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryEnterpriseOrgSkillComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the mobile enterprise org explore page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryMobileEnterpriseOrgExploreComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components for the mobile enterprise org explore domain page with pagination options.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE.
   */
  queryMobileEnterpriseOrgExploreDomainComponentsPaginated: PageConfig_QueryComponentsPaginatedResult;
  /**
   * Returns a list of PageConfig_Components from a given page (PageConfig_PageName) and possibly program slug.
   * The app that implements this query determines the implementation of PageConfig_Component and order
   * in which they are returned. The FE is expected to render this list as is, in the order it's returned
   * from the BE. This query includes pagination options.
   */
  queryPaginatedComponents: PageConfig_QueryComponentsPaginatedResult;
};


/** Queries for config enabled pages. */
export type PageConfigQueriesDebugQueryComponentsArgs = {
  input: PageConfig_QueryComponentsInput;
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryBrowseAllComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryBrowseDomainComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryBrowseDomainComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryBrowseSkillComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryBrowseSkillComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryComponentsArgs = {
  input: PageConfig_QueryComponentsInput;
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryConsumerHomeComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryConsumerSearchComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryConsumerSearchComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryEnterpriseHomeComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryEnterpriseHomeComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryEnterpriseOrgBrowseAllComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryEnterpriseOrgBrowseAllComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryEnterpriseOrgBrowseDomainComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryEnterpriseOrgBrowseDomainComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryEnterpriseOrgHomeComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryEnterpriseOrgHomeComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryEnterpriseOrgSkillComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryEnterpriseOrgSkillComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryMobileEnterpriseOrgExploreComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryMobileEnterpriseOrgExploreComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryMobileEnterpriseOrgExploreDomainComponentsPaginatedArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryMobileEnterpriseOrgExploreDomainComponentsInput;
  limit?: Scalars['Int'];
};


/** Queries for config enabled pages. */
export type PageConfigQueriesQueryPaginatedComponentsArgs = {
  componentListMetadataHash?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  input: PageConfig_QueryComponentsInput;
  limit?: Scalars['Int'];
};

/**
 * Maps to a component on the frontend that shows a filterable collection of degrees.
 * Owner: Recs
 */
export type PageConfig_BrowseDegreeCollectionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_BrowseDegreeCollectionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a list of domains.
 * Owner: Recs
 */
export type PageConfig_BrowseDomainListComponent = PageConfig_Component & {
  __typename?: 'PageConfig_BrowseDomainListComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Title to display for the component. */
  title: Scalars['String'];
};

/**
 * Maps to a component on the frontend that shows progressive onboarding for logged out users.
 * Owner: Recs
 */
export type PageConfig_BrowseLoggedOutProgressiveOnboardingComponent = PageConfig_Component & {
  __typename?: 'PageConfig_BrowseLoggedOutProgressiveOnboardingComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a list of skills.
 * Owner: Recs
 */
export type PageConfig_BrowseRelatedSkillsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_BrowseRelatedSkillsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Title to display for the component. */
  title: Scalars['String'];
};

/**
 * Maps to a component on the frontend that displays the counts of certain properties (such as free courses and free trial content).
 * Owner: Recs
 */
export type PageConfig_BrowseValuePropositionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_BrowseValuePropositionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that promotional cards for campaigns, such as a free trial for Coursera Plus
 * Owner: Merchandising
 */
export type PageConfig_CampaignsCannedCollectionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_CampaignsCannedCollectionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays Coursera Coach branding and notifies the learner about the state of their oboarding.
 * Owner: Learner Object
 */
export type PageConfig_CoachOnboardingBanner = PageConfig_Component & {
  __typename?: 'PageConfig_CoachOnboardingBanner';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** An entity representing all collections. This gives us the flexibility to deprecate and replace entities if needed without breaking APIs. */
export type PageConfig_Collection = Collection_Collection | Collection_CuratedCollection | EntCurriculum_OrgCuratedCollections | Recommendation_Collection;

/**
 * A PageConfig_Component implementation that maps to a product collection component on the frontend.
 * This schema will be expanded when we create a collection GraphQL entity.
 * Owner: Recs
 */
export type PageConfig_CollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_CollectionComponent';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The override for the primary title for the collection. If null, original title is used. */
  collectionTitleOverride?: Maybe<Scalars['String']>;
  /** The ID of the PageConfig_Component object. This is also the collection contained within this objects ID. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the collection was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /** The hash of the recommender configuration uniquely identifying a specific version of the configuration used to rank the collection. */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** A configuration articulating how the component should be rendered. A reasonable default will be used if no configuration is provided. */
  renderConfiguration?: Maybe<PageConfig_CollectionModuleConfiguration>;
  /** Custom configs for the collection, optional. */
  secondaryCta?: Maybe<PageConfig_CollectionComponentCustomCta>;
};

/** The custom CTA for a collection component */
export type PageConfig_CollectionComponentCustomCta = {
  __typename?: 'PageConfig_CollectionComponentCustomCta';
  /** Title of the CTA */
  ctaTitle: Scalars['String'];
  /** Tracking name for the CTA */
  ctaTrackingName?: Maybe<Scalars['String']>;
  /** Link for the CTA */
  ctaUrl: Scalars['String'];
  /** Flag to show arrow button for CTA, if null the value is defaulted to false. */
  showCtaArrowButton?: Maybe<Scalars['Boolean']>;
};

/**
 * A configuration articulating how a Collection Module should be rendered.
 * Properties here represent the properties articulated in the CDS labs component:
 * https://tools.coursera.org/web-storybook/main/cds-labs/index.html?path=/story/merchandising-modules-modules--collections-module
 *
 * This is not meant to be exhaustive of all properties. Instead, we surface on properties that are likely to change and be used.
 * This configuration acts as:
 * 1. A contract between FE and BE as to how a collection module should be rendered.
 * 2. A contract between the Merchandising pod and other teams. Properties and enums exposed here should ideally be "production ready" and not experimental.
 */
export type PageConfig_CollectionModuleConfiguration = {
  __typename?: 'PageConfig_CollectionModuleConfiguration';
  /**
   * The background color of a Collection Module. This must match one of the colors offered by
   * https://tools.coursera.org/web-storybook/main/cds-labs/index.html?path=/story/merchandising-modules-modules--collections-module
   * A null color will be rendered as transparent.
   */
  backgroundColor?: Maybe<Scalars['String']>;
  /**
   * The layout of the module. This must match one of the layouts offered by
   * https://tools.coursera.org/web-storybook/main/cds-labs/index.html?path=/story/merchandising-modules-modules--collections-module
   */
  moduleLayout?: Maybe<Scalars['String']>;
  /**
   * Shows rounded corners around the collection module's background if true.
   * Else, the collection module's background takes the entire row.
   */
  showRoundedCorners: Scalars['Boolean'];
};

/** An interface for all PageConfig_Component implementations that represent a collection. */
export type PageConfig_CollectionResult = {
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
};

/**
 * A PageConfig_Component implementation that maps to a compact product collection component on the frontend.
 * This is a variant of PageConfig_CollectionComponent with the same structure.
 * Owner: Recs
 */
export type PageConfig_CompactCollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_CompactCollectionComponent';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The override for the primary title for the collection. If null, original title is used. */
  collectionTitleOverride?: Maybe<Scalars['String']>;
  /** The ID of the PageConfig_Component object. This is also the collection contained within this objects ID. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the collection was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /** The hash of the recommender configuration uniquely identifying a specific version of the configuration used to rank the collection. */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Custom configs for the collection, optional. */
  secondaryCta?: Maybe<PageConfig_CollectionComponentCustomCta>;
};

/**
 * Maps to a component that displays a compact premium product (degrees, mastertracks) collection.
 * Owner: Recs
 */
export type PageConfig_CompactPremiumCollectionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_CompactPremiumCollectionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A purposely minimal interface for all of our components we need in our page configs.
 * Each implementation of PageConfig_Component has a matching component on the FE.
 */
export type PageConfig_Component = {
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays core skills related to a domain or topic.
 * This component shows essential skills that learners should focus on within a specific domain.
 * Owner: Search
 */
export type PageConfig_CoreSkillsComponent = PageConfig_Component & PageConfig_QueryClassification & {
  __typename?: 'PageConfig_CoreSkillsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /**
   * The matched classification value from query processing (e.g., "machine learning", "data scientist").
   * This represents the standardized name that the user's search query was classified as.
   */
  matchedQueryClassification?: Maybe<Scalars['String']>;
  /**
   * The type of classification that was matched.
   * This indicates which category the matched classification belongs to.
   */
  queryClassificationType?: Maybe<PageConfig_QueryClassificationType>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows core skills for a specific role.
 * Owner: Search
 */
export type PageConfig_CoreSkillsForRoleComponent = PageConfig_Component & PageConfig_QueryClassification & {
  __typename?: 'PageConfig_CoreSkillsForRoleComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /**
   * The matched classification value from query processing (e.g., "machine learning", "data scientist").
   * This represents the standardized name that the user's search query was classified as.
   */
  matchedQueryClassification?: Maybe<Scalars['String']>;
  /**
   * The type of classification that was matched.
   * This indicates which category the matched classification belongs to.
   */
  queryClassificationType?: Maybe<PageConfig_QueryClassificationType>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a C+ banner, prompting users to sign up for Coursera Plus.
 * Owner: Monetization
 */
export type PageConfig_CourseraPlusBanner = PageConfig_Component & {
  __typename?: 'PageConfig_CourseraPlusBanner';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Response for DebugQueryComponents. Includes information related to the chosen config that drives which pageComponents
 * are returned as well as the overrides that can also influence display.
 */
export type PageConfig_DebugQueryResponse = {
  __typename?: 'PageConfig_DebugQueryResponse';
  /**
   * The conditions that passed, which lead to the config being chosen.
   * Check which config has these conditions applied to find the chosen config.
   */
  configConditionsPassed: Array<Scalars['String']>;
  /**
   * If true, there is an epic experiment running on the current page,
   * This does not indicate which variant you are in, only that this page is under an active epic experiment.
   * Go to tools.coursera.org/epic and search with the page name for this query to find the experiment.
   */
  isEpicTestRunning: Scalars['Boolean'];
  /** The class name of any overrides applied to this query. */
  overridesApplied: Array<Scalars['String']>;
  /** PageConfig_Components chosen for display. */
  pageComponents?: Maybe<Array<Maybe<PageConfig_BrowseDegreeCollectionComponent | PageConfig_BrowseDomainListComponent | PageConfig_BrowseLoggedOutProgressiveOnboardingComponent | PageConfig_BrowseRelatedSkillsComponent | PageConfig_BrowseValuePropositionComponent | PageConfig_CampaignsCannedCollectionComponent | PageConfig_CoachOnboardingBanner | PageConfig_CollectionComponent | PageConfig_CompactCollectionComponent | PageConfig_CompactPremiumCollectionComponent | PageConfig_CoreSkillsComponent | PageConfig_CoreSkillsForRoleComponent | PageConfig_CourseraPlusBanner | PageConfig_DomainPillsComponent | PageConfig_EmbeddedPromoTemplatePage | PageConfig_EnrolledProductsComponent | PageConfig_EnterpriseAssignedCourses | PageConfig_EnterpriseBadgeCollectionsComponent | PageConfig_EnterpriseBrowseCollectionComponent | PageConfig_EnterpriseCourseraContentHeading | PageConfig_EnterpriseCuratedCollectionAndBadgeComponent | PageConfig_EnterpriseCuratedCollectionComponent | PageConfig_EnterpriseForCreditCollectionComponent | PageConfig_EnterpriseLearningPaths | PageConfig_EnterpriseOrganizationContentHeading | PageConfig_EnterpriseSkillClipsCollectionComponent | PageConfig_ExperimentalComponent | PageConfig_ExploreRolesComponent | PageConfig_FaqComponent | PageConfig_GoogleProgramBanner | PageConfig_GoogleProgramFooter | PageConfig_GroupedComponentsWrapper | PageConfig_LevelSets | PageConfig_MediumIntentSearchValuePropositionComponent | PageConfig_MediumIntentSearchValuePropositionForPartnerComponent | PageConfig_ModularOnboarding | PageConfig_MostPopularFreeByRoleCollection | PageConfig_MostPopularFreeBySkillCollection | PageConfig_MostPopularFreeCollection | PageConfig_OnboardingAdvancersHomeComplexCollection | PageConfig_OnboardingResultsHeaderComponent | PageConfig_PathwayDegreesCollection | PageConfig_PathwayDegreesOffersCreditEnrolledCollection | PageConfig_PathwayDegreesPartOfEnrolledCollection | PageConfig_PathwayFreeTrialCollection | PageConfig_PathwayRecommendationsComponent | PageConfig_PremiumCollectionComponent | PageConfig_PromoUnitsComponent | PageConfig_ReferralBanner | PageConfig_RelatedRolesComponent | PageConfig_SearchFrameComponent | PageConfig_SearchQueriesComponent | PageConfig_SkillDescriptionAndScoreComponent | PageConfig_SkillSetCardsComponent | PageConfig_SkillsFocusComponent | PageConfig_SkillsRecsComplexCollection | PageConfig_SpotlightCollectionComponent | PageConfig_StackablePathwayContentCollection | PageConfig_StandardRolesCollection | PageConfig_TopCourseraPartnersComponent | PageConfig_TopPartnersComponent | PageConfig_TrackDegreeProgress | PageConfig_UpsellComponent>>>;
};

/**
 * A reference to the PageConfig_DomainPillsComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Home
 */
export type PageConfig_DomainPillsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_DomainPillsComponent';
  /** The domains to include in the component. */
  domains: Array<Domain_Domain>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows an Embedded Promo Template Page.
 * Owner: Merchandising
 */
export type PageConfig_EmbeddedPromoTemplatePage = PageConfig_Component & {
  __typename?: 'PageConfig_EmbeddedPromoTemplatePage';
  /** The ID of the Promo Template Page, in the format of `domain:page-slug` */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A PageConfig_Component implementation that maps to a component on the frontend that displays
 * the learners currently enrolled products. This schema will be expanded when we create an
 * enrolled product card GraphQL entity.
 * Owner: Home
 */
export type PageConfig_EnrolledProductsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_EnrolledProductsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays courses that have been assigned to an enterprise learner within a program.
 *
 * Owner: Home
 */
export type PageConfig_EnterpriseAssignedCourses = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseAssignedCourses';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays collections associated with enterprise badges.
 * Owner: Home
 */
export type PageConfig_EnterpriseBadgeCollectionsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseBadgeCollectionsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays standard browse collections for enterprise learners.
 * Owner: Home
 */
export type PageConfig_EnterpriseBrowseCollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseBrowseCollectionComponent';
  /**
   * The enterprise browse collection.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a heading for grouping Coursera content.
 * Owner: Home
 */
export type PageConfig_EnterpriseCourseraContentHeading = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseCourseraContentHeading';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays both enterprise curated collections and collections associated with badges.
 * Owner: Home
 */
export type PageConfig_EnterpriseCuratedCollectionAndBadgeComponent = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseCuratedCollectionAndBadgeComponent';
  /**
   * The curated collection entity.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_CuratedCollection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays a collection of products curated by program admins.
 * Owner: Recs
 */
export type PageConfig_EnterpriseCuratedCollectionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseCuratedCollectionComponent';
  /**
   * The curated collection entity.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_CuratedCollection;
  /** The curated collection entity for the component. */
  collectionEntity?: Maybe<EntCurriculum_OrgCuratedCollections>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays a collection of products that program admins have deemed give credit.
 * Owner: Recs
 */
export type PageConfig_EnterpriseForCreditCollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseForCreditCollectionComponent';
  /**
   * The enterprise for credit collection.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays the learning paths a user has been assigned.
 * Owner: Home
 */
export type PageConfig_EnterpriseLearningPaths = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseLearningPaths';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a heading for grouping organization content.
 * Owner: Home
 */
export type PageConfig_EnterpriseOrganizationContentHeading = PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseOrganizationContentHeading';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays a recommendation of clips associated with skills chosen from onboarding.
 * Owner: Recs
 */
export type PageConfig_EnterpriseSkillClipsCollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_EnterpriseSkillClipsCollectionComponent';
  /**
   * The enterprise skill clips collection.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * When we need to add a new component for an experiment, this can be used to prevent adding PageConfig_Component types that we may need to deprecate later.
 * Add this component to your schema and then give it a unique ID. The FE will match on the experimental component type and ID to render your component.
 */
export type PageConfig_ExperimentalComponent = PageConfig_Component & {
  __typename?: 'PageConfig_ExperimentalComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a filterable collection consist of roles based on level and category. The filter is optional to show.
 * Owner: Recs
 */
export type PageConfig_ExploreRolesComponent = PageConfig_Component & PageConfig_QueryClassification & {
  __typename?: 'PageConfig_ExploreRolesComponent';
  /** Indicate if the component should show filters or not */
  hideFilters?: Maybe<Scalars['Boolean']>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /**
   * The matched classification value from query processing (e.g., "machine learning", "data scientist").
   * This represents the standardized name that the user's search query was classified as.
   */
  matchedQueryClassification?: Maybe<Scalars['String']>;
  /**
   * The type of classification that was matched.
   * This indicates which category the matched classification belongs to.
   */
  queryClassificationType?: Maybe<PageConfig_QueryClassificationType>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows FAQs.
 * Owner: Recs
 */
export type PageConfig_FaqComponent = PageConfig_Component & {
  __typename?: 'PageConfig_FAQComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** A filter item, typically used for complex collections. */
export type PageConfig_Filter = {
  __typename?: 'PageConfig_Filter';
  /** The display name of the filter. */
  name: Scalars['String'];
  /** The value for the filter, typically an ID for the associated item. */
  value: Scalars['String'];
};

/**
 * Maps to a program-specific "Grow with Google" banner that must show for certain Google enterprise programs.
 * Owner: Home
 */
export type PageConfig_GoogleProgramBanner = PageConfig_Component & {
  __typename?: 'PageConfig_GoogleProgramBanner';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a program-specific "Grow with Google" footer that must show for certain Google enterprise programs.
 * Owner: Home
 */
export type PageConfig_GoogleProgramFooter = PageConfig_Component & {
  __typename?: 'PageConfig_GoogleProgramFooter';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A wrapper that groups a list of page config components together
 * Owner: Home
 */
export type PageConfig_GroupedComponentsWrapper = PageConfig_Component & {
  __typename?: 'PageConfig_GroupedComponentsWrapper';
  /** The body of the group of components */
  body?: Maybe<Scalars['String']>;
  /** The group of page config components */
  components: Array<Maybe<PageConfig_BrowseDegreeCollectionComponent | PageConfig_BrowseDomainListComponent | PageConfig_BrowseLoggedOutProgressiveOnboardingComponent | PageConfig_BrowseRelatedSkillsComponent | PageConfig_BrowseValuePropositionComponent | PageConfig_CampaignsCannedCollectionComponent | PageConfig_CoachOnboardingBanner | PageConfig_CollectionComponent | PageConfig_CompactCollectionComponent | PageConfig_CompactPremiumCollectionComponent | PageConfig_CoreSkillsComponent | PageConfig_CoreSkillsForRoleComponent | PageConfig_CourseraPlusBanner | PageConfig_DomainPillsComponent | PageConfig_EmbeddedPromoTemplatePage | PageConfig_EnrolledProductsComponent | PageConfig_EnterpriseAssignedCourses | PageConfig_EnterpriseBadgeCollectionsComponent | PageConfig_EnterpriseBrowseCollectionComponent | PageConfig_EnterpriseCourseraContentHeading | PageConfig_EnterpriseCuratedCollectionAndBadgeComponent | PageConfig_EnterpriseCuratedCollectionComponent | PageConfig_EnterpriseForCreditCollectionComponent | PageConfig_EnterpriseLearningPaths | PageConfig_EnterpriseOrganizationContentHeading | PageConfig_EnterpriseSkillClipsCollectionComponent | PageConfig_ExperimentalComponent | PageConfig_ExploreRolesComponent | PageConfig_FaqComponent | PageConfig_GoogleProgramBanner | PageConfig_GoogleProgramFooter | PageConfig_GroupedComponentsWrapper | PageConfig_LevelSets | PageConfig_MediumIntentSearchValuePropositionComponent | PageConfig_MediumIntentSearchValuePropositionForPartnerComponent | PageConfig_ModularOnboarding | PageConfig_MostPopularFreeByRoleCollection | PageConfig_MostPopularFreeBySkillCollection | PageConfig_MostPopularFreeCollection | PageConfig_OnboardingAdvancersHomeComplexCollection | PageConfig_OnboardingResultsHeaderComponent | PageConfig_PathwayDegreesCollection | PageConfig_PathwayDegreesOffersCreditEnrolledCollection | PageConfig_PathwayDegreesPartOfEnrolledCollection | PageConfig_PathwayFreeTrialCollection | PageConfig_PathwayRecommendationsComponent | PageConfig_PremiumCollectionComponent | PageConfig_PromoUnitsComponent | PageConfig_ReferralBanner | PageConfig_RelatedRolesComponent | PageConfig_SearchFrameComponent | PageConfig_SearchQueriesComponent | PageConfig_SkillDescriptionAndScoreComponent | PageConfig_SkillSetCardsComponent | PageConfig_SkillsFocusComponent | PageConfig_SkillsRecsComplexCollection | PageConfig_SpotlightCollectionComponent | PageConfig_StackablePathwayContentCollection | PageConfig_StandardRolesCollection | PageConfig_TopCourseraPartnersComponent | PageConfig_TopPartnersComponent | PageConfig_TrackDegreeProgress | PageConfig_UpsellComponent>>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /**
   * The orientation used to lay out nested components within the group. If not provided,
   * consumers should default to VERTICAL.
   */
  orientation?: Maybe<PageConfig_OrientationType>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** The title of the group of components */
  title?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays level sets associated with a program.
 * Owner: Home
 */
export type PageConfig_LevelSets = PageConfig_Component & {
  __typename?: 'PageConfig_LevelSets';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a value proposition for medium-intent search queries.
 * This component shows relevant content and encourages engagement for users with moderate search intent.
 * Owner: Search
 */
export type PageConfig_MediumIntentSearchValuePropositionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_MediumIntentSearchValuePropositionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a value proposition for medium-intent search queries specifically for partner content.
 * This component shows relevant partner-specific content and encourages engagement.
 * Owner: Search
 */
export type PageConfig_MediumIntentSearchValuePropositionForPartnerComponent = PageConfig_Component & {
  __typename?: 'PageConfig_MediumIntentSearchValuePropositionForPartnerComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays modular onboarding content.
 * Owner: Learner Object
 */
export type PageConfig_ModularOnboarding = PageConfig_Component & {
  __typename?: 'PageConfig_ModularOnboarding';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a filterable collection of free content recommendation based on roles.
 * Owner: Search
 */
export type PageConfig_MostPopularFreeByRoleCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_MostPopularFreeByRoleCollection';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /**
   * Contains a list of role filters, whose "value" is the JSON string of one or more filters of role,
   * which is used as input for the recommendation collections,
   * e.g. {\"roleFilter\": [[\"role:cyber-security-analyst\"]]}.
   * The first item ID is used to power the collection attached to this component.
   */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a filterable collection of free content recommendation based on skill.
 * Owner: Search
 */
export type PageConfig_MostPopularFreeBySkillCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_MostPopularFreeBySkillCollection';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /**
   * Contains a list of skill filters, whose "value" is the JSON string of one or more filters of skill,
   * which will be passed in directly as input for the recommendation collections,
   * e.g. {\"skillFilter\": [[\"skill:Apple Xcode\", \"skill:Mobile Development\"]]}.
   * The first item ID is used to power the collection attached to this component.
   */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a filterable collection of free content recommendation based on topics.
 * Owner: Recs
 */
export type PageConfig_MostPopularFreeCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_MostPopularFreeCollection';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /**
   * Contains a list of topic filters, whose "value" is the JSON string of one or more filters of topic,
   * which will be passed in directly as input for the recommendation collections, e.g. {\"topicFilter\": [[\"topic:Business\"]]}.
   * The first item ID is used to power the collection attached to this component.
   */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** Maps to a component that shows a filterable collection based on skills the user chose from onboarding. */
export type PageConfig_OnboardingAdvancersHomeComplexCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_OnboardingAdvancersHomeComplexCollection';
  /**
   * A collection of products.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** Contains a list of skill filters, whose "value" is the skill ID, which is used as input for the recommendation collections. The first item ID is used to power the collection attached to this component. */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays choices made in onboarding.
 * Owner: Learner Object
 */
export type PageConfig_OnboardingResultsHeaderComponent = PageConfig_Component & {
  __typename?: 'PageConfig_OnboardingResultsHeaderComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** Defines layout orientation for grouped components. */
export const PageConfig_OrientationType = {
  /** Components are arranged horizontally (side by side). */
  Horizontal: 'HORIZONTAL',
  /** Components are arranged vertically (stacked). */
  Vertical: 'VERTICAL'
} as const;

export type PageConfig_OrientationType = typeof PageConfig_OrientationType[keyof typeof PageConfig_OrientationType];
/** An enum holding the names of pages that use the "queryComponents" query. */
export const PageConfig_PageName = {
  /** Used on the base browse page */
  BrowseAll: 'BROWSE_ALL',
  /** Used on domain (topic) browse pages. */
  BrowseDomain: 'BROWSE_DOMAIN',
  /** (Deprecated) Used for EQP page for free queries. Retained for backward compatibility. */
  BrowseEqpFree: 'BROWSE_EQP_FREE',
  /** Used on skill browse pages. */
  BrowseSkill: 'BROWSE_SKILL',
  /** Used on the consumer logged-in home. */
  ConsumerLoggedInHome: 'CONSUMER_LOGGED_IN_HOME',
  /** Used for consumer search page. */
  ConsumerSearch: 'CONSUMER_SEARCH',
  /** Used for enterprise home. */
  EnterpriseHome: 'ENTERPRISE_HOME',
  /** Used on the enterprise org browse page */
  EnterpriseOrgBrowseAll: 'ENTERPRISE_ORG_BROWSE_ALL',
  /** Used on enterprise org domain (topic) browse pages. */
  EnterpriseOrgBrowseDomain: 'ENTERPRISE_ORG_BROWSE_DOMAIN',
  /** Used for enterprise org home. */
  EnterpriseOrgHome: 'ENTERPRISE_ORG_HOME',
  /** Used on enterprise org skill pages. */
  EnterpriseOrgSkill: 'ENTERPRISE_ORG_SKILL',
  /** Used for EQP page for free queries. */
  Eqp: 'EQP',
  /** Used on the mobile explore page. */
  MobileEnterpriseOrgExplore: 'MOBILE_ENTERPRISE_ORG_EXPLORE',
  /** Used on the mobile explore domain page. */
  MobileEnterpriseOrgExploreDomain: 'MOBILE_ENTERPRISE_ORG_EXPLORE_DOMAIN'
} as const;

export type PageConfig_PageName = typeof PageConfig_PageName[keyof typeof PageConfig_PageName];
/**
 * Maps to a component that shows a collection of pathway degrees.
 * Owner: Home
 */
export type PageConfig_PathwayDegreesCollection = PageConfig_Component & {
  __typename?: 'PageConfig_PathwayDegreesCollection';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a collection of pathway degrees and user enrolled OFFERS_CREDIT content.
 * Owner: Home
 */
export type PageConfig_PathwayDegreesOffersCreditEnrolledCollection = PageConfig_Component & {
  __typename?: 'PageConfig_PathwayDegreesOffersCreditEnrolledCollection';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a collection of pathway degrees and user enrolled PART_OF content.
 * Owner: Home
 */
export type PageConfig_PathwayDegreesPartOfEnrolledCollection = PageConfig_Component & {
  __typename?: 'PageConfig_PathwayDegreesPartOfEnrolledCollection';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows a filterable collection of free trial pathway recommendation based on difficulty level.
 * Owner: Recs
 */
export type PageConfig_PathwayFreeTrialCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_PathwayFreeTrialCollection';
  /**
   * The collection entity for the component.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /**
   * Contains a list of topic filters, whose "value" is the JSON string of one or more filters of difficulty level,
   * which will be passed in directly as input for the recommendation collections,
   * e.g. {\"difficultyLevelFilter\": [[\"product_difficulty_level:Beginner\"]]}.
   * The first item ID is used to power the collection attached to this component.
   */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays recommended pathways for a user's chosen roles.
 * Owner: Recs
 */
export type PageConfig_PathwayRecommendationsComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_PathwayRecommendationsComponent';
  /**
   * A collection of career roles.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that displays a premium product (degrees, mastertracks) collection.
 * Owner: Home
 */
export type PageConfig_PremiumCollectionComponent = PageConfig_Component & {
  __typename?: 'PageConfig_PremiumCollectionComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A reference to the PageConfig_PromoUnitsComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Merchandising
 */
export type PageConfig_PromoUnitsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_PromoUnitsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Placement of the promo units component */
  placement: BannerAdCampaign_Placement;
  /** The banner ads displayed in the promo unit. */
  promoUnits: Array<BannerAdCampaign_BannerAdCampaign>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};


/**
 * A reference to the PageConfig_PromoUnitsComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Merchandising
 */
export type PageConfig_PromoUnitsComponentPromoUnitsArgs = {
  limit?: Scalars['Int'];
};

/** Input for querying browse domain pages components. */
export type PageConfig_QueryBrowseDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
};

/** Input for querying browse skill pages components. */
export type PageConfig_QueryBrowseSkillComponentsInput = {
  /** Include skill id so we can retrieve information about the current skill. */
  skillId: Scalars['ID'];
};

/**
 * An interface for components that support query classification metadata.
 * This provides standardized fields for components that need to display
 * information about how the user's search query was classified.
 */
export type PageConfig_QueryClassification = {
  /**
   * The matched classification value from query processing (e.g., "machine learning", "data scientist").
   * This represents the standardized name that the user's search query was classified as.
   */
  matchedQueryClassification?: Maybe<Scalars['String']>;
  /**
   * The type of classification that was matched.
   * This indicates which category the matched classification belongs to.
   */
  queryClassificationType?: Maybe<PageConfig_QueryClassificationType>;
};

/** The types of query classifications that can be matched. */
export const PageConfig_QueryClassificationType = {
  /** A subject domain or field of study (e.g., "machine learning", "data science") */
  Domain: 'DOMAIN',
  /** An educational or industry partner (e.g., "Google", "Stanford University") */
  Partner: 'PARTNER',
  /** A job role or career position (e.g., "data scientist", "software engineer") */
  Role: 'ROLE',
  /** A specific skill or competency (e.g., "Python programming", "project management") */
  Skill: 'SKILL'
} as const;

export type PageConfig_QueryClassificationType = typeof PageConfig_QueryClassificationType[keyof typeof PageConfig_QueryClassificationType];
/** The queryComponents input. */
export type PageConfig_QueryComponentsInput = {
  /** Additional input required for querying any collection entities under components. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * The page from which the query emanates. The BE will use the PageConfig_PageName enum to
   * determine which components to return and in what order.
   */
  pageName: PageConfig_PageName;
  /**
   * Required info when queries are made from enterprise pages.
   * Include program slug so we can retrieve information about the current program.
   */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Response for QueryPaginatedComponents */
export type PageConfig_QueryComponentsPaginatedResult = {
  __typename?: 'PageConfig_QueryComponentsPaginatedResult';
  /**
   * Hashed value of the finalized list of components generated on initial request to paginated query.
   * This gets passed back in when fetching more data along with the Pagination.cursor.
   */
  componentListMetadataHash: Scalars['String'];
  /** List of page components. */
  elements?: Maybe<Array<Maybe<PageConfig_BrowseDegreeCollectionComponent | PageConfig_BrowseDomainListComponent | PageConfig_BrowseLoggedOutProgressiveOnboardingComponent | PageConfig_BrowseRelatedSkillsComponent | PageConfig_BrowseValuePropositionComponent | PageConfig_CampaignsCannedCollectionComponent | PageConfig_CoachOnboardingBanner | PageConfig_CollectionComponent | PageConfig_CompactCollectionComponent | PageConfig_CompactPremiumCollectionComponent | PageConfig_CoreSkillsComponent | PageConfig_CoreSkillsForRoleComponent | PageConfig_CourseraPlusBanner | PageConfig_DomainPillsComponent | PageConfig_EmbeddedPromoTemplatePage | PageConfig_EnrolledProductsComponent | PageConfig_EnterpriseAssignedCourses | PageConfig_EnterpriseBadgeCollectionsComponent | PageConfig_EnterpriseBrowseCollectionComponent | PageConfig_EnterpriseCourseraContentHeading | PageConfig_EnterpriseCuratedCollectionAndBadgeComponent | PageConfig_EnterpriseCuratedCollectionComponent | PageConfig_EnterpriseForCreditCollectionComponent | PageConfig_EnterpriseLearningPaths | PageConfig_EnterpriseOrganizationContentHeading | PageConfig_EnterpriseSkillClipsCollectionComponent | PageConfig_ExperimentalComponent | PageConfig_ExploreRolesComponent | PageConfig_FaqComponent | PageConfig_GoogleProgramBanner | PageConfig_GoogleProgramFooter | PageConfig_GroupedComponentsWrapper | PageConfig_LevelSets | PageConfig_MediumIntentSearchValuePropositionComponent | PageConfig_MediumIntentSearchValuePropositionForPartnerComponent | PageConfig_ModularOnboarding | PageConfig_MostPopularFreeByRoleCollection | PageConfig_MostPopularFreeBySkillCollection | PageConfig_MostPopularFreeCollection | PageConfig_OnboardingAdvancersHomeComplexCollection | PageConfig_OnboardingResultsHeaderComponent | PageConfig_PathwayDegreesCollection | PageConfig_PathwayDegreesOffersCreditEnrolledCollection | PageConfig_PathwayDegreesPartOfEnrolledCollection | PageConfig_PathwayFreeTrialCollection | PageConfig_PathwayRecommendationsComponent | PageConfig_PremiumCollectionComponent | PageConfig_PromoUnitsComponent | PageConfig_ReferralBanner | PageConfig_RelatedRolesComponent | PageConfig_SearchFrameComponent | PageConfig_SearchQueriesComponent | PageConfig_SkillDescriptionAndScoreComponent | PageConfig_SkillSetCardsComponent | PageConfig_SkillsFocusComponent | PageConfig_SkillsRecsComplexCollection | PageConfig_SpotlightCollectionComponent | PageConfig_StackablePathwayContentCollection | PageConfig_StandardRolesCollection | PageConfig_TopCourseraPartnersComponent | PageConfig_TopPartnersComponent | PageConfig_TrackDegreeProgress | PageConfig_UpsellComponent>>>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Input for querying consumer search page components. */
export type PageConfig_QueryConsumerSearchComponentsInput = {
  /** Query term from the search page. */
  queryTerm: Scalars['String'];
};

/** Input for querying enterprise home page components. */
export type PageConfig_QueryEnterpriseHomeComponentsInput = {
  /**
   * Required info when queries are made from enterprise pages.
   * Include program slug so we can retrieve information about the current program.
   */
  programSlug: Scalars['String'];
};

/** Input for querying enterprise org browse all page components. */
export type PageConfig_QueryEnterpriseOrgBrowseAllComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org browse domain pages components. */
export type PageConfig_QueryEnterpriseOrgBrowseDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org home page components. */
export type PageConfig_QueryEnterpriseOrgHomeComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying enterprise org skill pages components. */
export type PageConfig_QueryEnterpriseOrgSkillComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
  /** Include skill id so we can retrieve information about the current skill. */
  skillId: Scalars['ID'];
};

/** Input for querying mobile enterprise org explore page components. */
export type PageConfig_QueryMobileEnterpriseOrgExploreComponentsInput = {
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Input for querying mobile enterprise org explore domain page components. */
export type PageConfig_QueryMobileEnterpriseOrgExploreDomainComponentsInput = {
  /** Include domain slug so we can retrieve information about the current domain. */
  domainSlug: Scalars['String'];
  /** The org slug for the enterprise organization. */
  orgSlug: Scalars['String'];
};

/** Maps to a component on the frontend that displays a referral banner (prompting users to refer a friend for a Coursera Plus discount). */
export type PageConfig_ReferralBanner = PageConfig_Component & {
  __typename?: 'PageConfig_ReferralBanner';
  /** The type of referral banner to display. */
  bannerType: PageConfig_ReferralBannerType;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** The type of referral banner to display. */
export const PageConfig_ReferralBannerType = {
  /**
   * User is subscribed to Coursera Plus.
   * Referral will lead to discount for the referred only.
   */
  Altruistic: 'ALTRUISTIC',
  /**
   * User is not subscribed to Coursera Plus.
   * Referral will lead to discount for both the referrer and the referred.
   */
  NeverSubscribed: 'NEVER_SUBSCRIBED'
} as const;

export type PageConfig_ReferralBannerType = typeof PageConfig_ReferralBannerType[keyof typeof PageConfig_ReferralBannerType];
/**
 * Maps to a component on the frontend that displays a list of roles related to a specific skill.
 * This component shows career roles that are associated with or require the skill being browsed,
 * helping users understand career paths and opportunities related to the skill.
 * Owner: Recs
 */
export type PageConfig_RelatedRolesComponent = PageConfig_Component & {
  __typename?: 'PageConfig_RelatedRolesComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Title to display for the component. */
  title: Scalars['String'];
};

/**
 * Maps to a component that shows search results based on the user's query.
 * Owner: Search
 */
export type PageConfig_SearchFrameComponent = PageConfig_Component & {
  __typename?: 'PageConfig_SearchFrameComponent';
  /**
   * List of facet names to display and order by. These are the attribute names that can be used
   * for filtering search results (e.g., "skills", "topic", "productDifficultyLevel", "partners").
   * The frontend can use these names to request faceted search results and display filter options.
   */
  facets?: Maybe<Array<Scalars['String']>>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows user's search queries.
 * Owner: Search
 */
export type PageConfig_SearchQueriesComponent = PageConfig_Component & {
  __typename?: 'PageConfig_SearchQueriesComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays skill name, description, and score with progress tracker.
 * Owner: Recs
 */
export type PageConfig_SkillDescriptionAndScoreComponent = PageConfig_Component & {
  __typename?: 'PageConfig_SkillDescriptionAndScoreComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A reference to the PageConfig_SkillSetCardsComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Home
 */
export type PageConfig_SkillSetCardsComponent = PageConfig_Component & {
  __typename?: 'PageConfig_SkillSetCardsComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** The skill set objects to include in the component. */
  skillSets: Array<PageConfig_SkillSetCardsComponentSkillSet>;
};


/**
 * A reference to the PageConfig_SkillSetCardsComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Home
 */
export type PageConfig_SkillSetCardsComponentSkillSetsArgs = {
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};

/**
 * Represents the skill sets displayed in the skill set cards component.
 *
 * Note: this will ideally be replaced with a federated entity that can represent the canonical enterprise skill sets data.
 */
export type PageConfig_SkillSetCardsComponentSkillSet = {
  __typename?: 'PageConfig_SkillSetCardsComponentSkillSet';
  /** The goal type of the skill set, optional */
  goalType?: Maybe<SkillSetCardsComponentSkillSet_GoalType>;
  /** ID of the skill set */
  id: Scalars['ID'];
  /** The occupation ID of the skill set, optional */
  occupationId?: Maybe<Scalars['ID']>;
  /** The skills in the skill set */
  skills: Array<Skill_Skill>;
  /** Slug of the skill set */
  slug: Scalars['String'];
  /** Title of the skill set */
  title: Scalars['String'];
};

/**
 * A reference to the PageConfig_SkillsFocusComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Home
 */
export type PageConfig_SkillsFocusComponent = PageConfig_Component & {
  __typename?: 'PageConfig_SkillsFocusComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** The skills progress for the current component */
  skillProgress: Array<PageConfig_SkillsFocusComponentSkillProgress>;
};


/**
 * A reference to the PageConfig_SkillsFocusComponent stub.
 *
 * See /graphql/home/pagecomponents.graphql for the full schema.
 *
 * Owner: Home
 */
export type PageConfig_SkillsFocusComponentSkillProgressArgs = {
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};

/**
 * Represents the skills progress displayed in the skill focus component.
 *
 * Note: this will ideally be replaced with a federated entity that can represent the canonical skill progress data.
 */
export type PageConfig_SkillsFocusComponentSkillProgress = {
  __typename?: 'PageConfig_SkillsFocusComponentSkillProgress';
  /** Unique id for the skill progress */
  id: Scalars['ID'];
  /** If the skill is eligible for scoring */
  isEligibleForScoring: Scalars['Boolean'];
  /** LevelSet status metadata */
  levelsetStatus: SkillsFocusComponentSkillProgress_LevelSetProgressStatus;
  /** The user's score for the skill, ranging from 0 to 500. */
  score: Scalars['Int'];
  /** The time that the user got the skill score */
  scoreAtTime: Scalars['DateTime'];
  /** The skill in the component */
  skill: Skill_Skill;
};

/** Maps to a component that shows a filterable collection based on relevant skill recommendations. */
export type PageConfig_SkillsRecsComplexCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_SkillsRecsComplexCollection';
  /**
   * A collection of products.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** Contains a list of skill filters, whose "value" is the skill ID, which is used as input for the recommendation collections. The first item ID is used to power the collection attached to this component. */
  filters: Array<PageConfig_Filter>;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * A PageConfig_Component implementation that maps to a product collection component on the frontend.
 * This is a variant of PageConfig_CollectionComponent that is used to render collections in a different way.
 *
 * Only Specializations or collections of specializations should be returned by this component.
 * Owner: Recs
 */
export type PageConfig_SpotlightCollectionComponent = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_SpotlightCollectionComponent';
  /**
   * The collection entity for the component. This returns nothing.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /**
   * The collection entities for the component.
   * @deprecated Use collectionEntity instead
   */
  collectionEntities?: Maybe<Array<PageConfig_Collection>>;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The override for the primary title for the collection. If null, original title is used. */
  collectionTitleOverride?: Maybe<Scalars['String']>;
  /** The ID of the PageConfig_Component object. This is also the collection contained within this objects ID. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the collection was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /** The hash of the recommender configuration uniquely identifying a specific version of the configuration used to rank the collection. */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /** Custom configs for the collection, optional. */
  secondaryCta?: Maybe<PageConfig_CollectionComponentCustomCta>;
};

/**
 * Maps to a component that shows a collection of Stackable Pathway Content.
 * Owner: Home
 */
export type PageConfig_StackablePathwayContentCollection = PageConfig_Component & {
  __typename?: 'PageConfig_StackablePathwayContentCollection';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays a non-filterable career roles collection.
 * Owner: Recs
 */
export type PageConfig_StandardRolesCollection = PageConfig_CollectionResult & PageConfig_Component & {
  __typename?: 'PageConfig_StandardRolesCollection';
  /**
   * A collection of career roles.
   * @deprecated Use collectionEntity instead
   */
  collection: Collection_Collection;
  /** The collection entity for the component. */
  collectionEntity: PageConfig_Collection;
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component on the frontend that displays top Coursera university and industry partners.
 * This component showcases prestigious institutions and companies that offer content on Coursera.
 * Owner: Search
 */
export type PageConfig_TopCourseraPartnersComponent = PageConfig_Component & PageConfig_QueryClassification & {
  __typename?: 'PageConfig_TopCourseraPartnersComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /**
   * The matched classification value from query processing (e.g., "machine learning", "data scientist").
   * This represents the standardized name that the user's search query was classified as.
   */
  matchedQueryClassification?: Maybe<Scalars['String']>;
  /**
   * The type of classification that was matched.
   * This indicates which category the matched classification belongs to.
   */
  queryClassificationType?: Maybe<PageConfig_QueryClassificationType>;
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows top partners.
 * Owner: Recs
 */
export type PageConfig_TopPartnersComponent = PageConfig_Component & {
  __typename?: 'PageConfig_TopPartnersComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows progress within a degree.
 * Owner: Home
 */
export type PageConfig_TrackDegreeProgress = PageConfig_Component & {
  __typename?: 'PageConfig_TrackDegreeProgress';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/**
 * Maps to a component that shows upsell advertisements (such as Coursera Plus).
 * Owner: Recs
 */
export type PageConfig_UpsellComponent = PageConfig_Component & {
  __typename?: 'PageConfig_UpsellComponent';
  /** The ID of the PageConfig_Component object. */
  id: Scalars['ID'];
  /** Non-sensitive and non-personal contextual metadata about how the component was ranked. */
  rankingContext?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration
   * used to rank the component.
   */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
};

/** Queries for page header configurations using the composable page header framework. */
export type PageHeaderQueries = {
  __typename?: 'PageHeaderQueries';
  /** Returns page header specific data that can also relate to the current learner. User ID is gathered from request context. */
  queryMyPageHeader: PageHeader_MyPageHeader;
};


/** Queries for page header configurations using the composable page header framework. */
export type PageHeaderQueriesQueryMyPageHeaderArgs = {
  degreeProgramSlug?: InputMaybe<Scalars['String']>;
  enterpriseProgramSlug?: InputMaybe<Scalars['String']>;
  thirdPartyOrgSlug?: InputMaybe<Scalars['String']>;
};

/** enum holding the types of Coursera Plus Subscriptions */
export const PageHeader_CourseraPlusSubscriptionCycle = {
  /** Monthly subscription. */
  Monthly: 'MONTHLY',
  /** Yearly subscription */
  Yearly: 'YEARLY'
} as const;

export type PageHeader_CourseraPlusSubscriptionCycle = typeof PageHeader_CourseraPlusSubscriptionCycle[keyof typeof PageHeader_CourseraPlusSubscriptionCycle];
/**
 * Object representing data relevant to serving header configurations using the composable page header framework.
 * Contains data specific to the current learner used in the page header and/or is relevant to particular items in a page header.
 */
export type PageHeader_MyPageHeader = {
  __typename?: 'PageHeader_MyPageHeader';
  /** Enables an educator admin link in the account dropdown for users who are educator admins. */
  canViewEducatorAdminLink: Scalars['Boolean'];
  /**
   * Defined if the user has selected a degree program as their “active” program from ProgramSwitcherSelectionsResource.
   * If this is defined, we will treat the user as an active degree learner.
   */
  chosenDegree?: Maybe<Degree_Degree>;
  /**
   * Defined if the user has selected an enterprise program as their “active” program from ProgramSwitcherSelectionsResource.
   * If this is defined, we will treat the user as an active enterprise learner.
   */
  chosenEnterpriseProgram?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /** The subscription cycle of the learner's active Coursera Plus subscription. */
  courseraPlusSubscriptionCycle?: Maybe<PageHeader_CourseraPlusSubscriptionCycle>;
  /** The degree pertaining to the current page, defined if degreeProgramSlug is passed into query/present in URL. */
  currentPageDegree?: Maybe<Degree_Degree>;
  /** The program pertaining to the current page, defined if programSlug is passed into query/present in URL. */
  currentPageProgram?: Maybe<EnterpriseProgram_EnterpriseProgram>;
  /** A list of degree programs the user is enrolled in. Used in the program switcher. */
  enrolledDegreePrograms?: Maybe<Array<Degree_Degree>>;
  /** A list of enterprise programs the user is a member of. Used in the program switcher. */
  enrolledEnterprisePrograms?: Maybe<Array<EnterpriseProgram_EnterpriseProgram>>;
  /** Enables a link in the account dropdown for users who have been flagged as having a cheating incident. */
  hasCheatingIncidents: Scalars['Boolean'];
  /** True if the learner has an active Coursera Plus subscription. */
  isCourseraPlusLearner: Scalars['Boolean'];
  /**
   * A list of third party organizations the user manages, used in the account dropdown.
   * @deprecated Use naptimeManagedThirdPartyOrganization instead. This is not accessible to non power users.
   */
  managedThirdPartyOrganizations?: Maybe<Array<ThirdPartyOrganization_ThirdPartyOrganization>>;
  /**
   * Defined if the user has selected an enterprise organization as their “active” organization from UserExperienceContext.
   * If this is defined, we will treat the user as an active enterprise learner.
   */
  naptimeChosenOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  /** The third party organization pertaining to the current page, defined if thirdPartyOrgId is passed into query/present in URL. */
  naptimeCurrentPageOrganization?: Maybe<ThirdPartyOrganizationsV1>;
  /** A list of third party organizations the user manages, used in the account dropdown. */
  naptimeManagedThirdPartyOrganizations?: Maybe<Array<ThirdPartyOrganizationsV1>>;
  /** A list of enterprise organizations the user is a member of. Used in the user experience switcher. */
  naptimeOrganizationsWithProgramEnrollments?: Maybe<Array<ThirdPartyOrganizationsV1>>;
};

/**
 * Relay PageInfo
 *
 * Deprecated in favour of Coursera's custom pagination scheme. See
 * https://github.com/webedx-spark/service-definitions/blob/main/decision-records/0005-graphql-custom-pagination.md
 * for details.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** TODO: Complete this description */
  endCursor?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  hasNextPage: Scalars['Boolean'];
  /** TODO: Complete this description */
  hasPreviousPage: Scalars['Boolean'];
  /** TODO: Complete this description */
  startCursor?: Maybe<Scalars['String']>;
};

/**
 * Pagination metadata type for Coursera's custom GraphQL pagination scheme.
 *
 * See https://github.com/webedx-spark/service-definitions/blob/main/decision-records/0005-graphql-custom-pagination.md
 * for details.
 */
export type Pagination = {
  __typename?: 'Pagination';
  /** Starting cursor for the next page. Null if the end of the collection has been reached. */
  cursor?: Maybe<Scalars['String']>;
  /** Total number of elements, if available. */
  totalElements?: Maybe<Scalars['Int']>;
};

/** Pagination parameters for a pageable request. */
export type PaginationRequest = {
  /** Page number of elements to be retrieved. */
  page?: InputMaybe<Scalars['Int']>;
  /** Number of elements to return. */
  size?: InputMaybe<Scalars['Int']>;
};

/** Pagination details for a pageable response. */
export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  /** Page of elements returned. */
  page?: Maybe<Scalars['Int']>;
  /** Number of elements returned. */
  size?: Maybe<Scalars['Int']>;
  /** Total Number of existing elements. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** String-string map entry */
export type Param = {
  /** Key of entry */
  key: Scalars['String'];
  /** Value of entry */
  value: Scalars['String'];
};

/** All partner approval queries */
export type PartnerApprovalQueries = {
  __typename?: 'PartnerApprovalQueries';
  /** Get partner approval optimization details */
  queryPartnerApprovalOptimizationDetails?: Maybe<PartnerApproval_PartnerApprovalOptimizationDetails>;
  /**
   * intended for determining the status of pedagogy recommendations which have been applied.
   *
   * Returns the current list of recommendations, tied to specific entities within the course.
   *
   * replaces branchLevel status (calculated from these recommendations instead)
   * - show "suggestions available" type banner if created but not applied recommendations
   * - show "review suggestions" type banner if recommendations applied but still in draft item state
   */
  queryPccrRecommendationsByBranch: PartnerApproval_RecommendationResponse;
  /** Get recommendation id by item id */
  queryRecommendationIdByItem?: Maybe<PartnerApproval_Recommendation>;
  /** Query submittable items */
  querySubmittableItems?: Maybe<Array<PartnerApproval_SubmittableItem>>;
};


/** All partner approval queries */
export type PartnerApprovalQueriesQueryPartnerApprovalOptimizationDetailsArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
};


/** All partner approval queries */
export type PartnerApprovalQueriesQueryPccrRecommendationsByBranchArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
};


/** All partner approval queries */
export type PartnerApprovalQueriesQueryRecommendationIdByItemArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** All partner approval queries */
export type PartnerApprovalQueriesQuerySubmittableItemsArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
};

/** Input to reject an entity change */
export type PartnerApproval_ApproveOrRejectAllChangesInput = {
  /** Action to take for remaining pending recommendations */
  action: PartnerApproval_ReviewAction;
  /** Authoring branch id (if present, search for branch-level review) */
  authoringBranchId?: InputMaybe<Scalars['ID']>;
  /**
   * Course id (always needed to determine course edit permission, if branch id is not present,
   * fetch course-level review)
   */
  courseId: Scalars['ID'];
};

/** Result of rejecting an entity change */
export type PartnerApproval_ApproveOrRejectAllChangesResult = {
  __typename?: 'PartnerApproval_ApproveOrRejectAllChangesResult';
  /** Success */
  success: Scalars['Boolean'];
};

/** Input to approve a single change */
export type PartnerApproval_ApproveOrRejectChangeInput = {
  /** Action */
  action: PartnerApproval_ReviewAction;
  /** Change review id */
  changeReviewId: Scalars['ID'];
  /** Course id (to determine course edit permission) */
  courseId: Scalars['ID'];
  /**
   * Skip authoring action:
   * If flag is set to true, on recommendation approval, skip publishing the item, and on
   * recommendation rejection, skip deleting the item
   */
  skipAuthoringAction?: Scalars['Boolean'];
};

/** Result of approving an entity change */
export type PartnerApproval_ApproveOrRejectChangeResult = {
  __typename?: 'PartnerApproval_ApproveOrRejectChangeResult';
  /** Success */
  success: Scalars['Boolean'];
};

/** Valid types of content that a recommendation may be associated with */
export const PartnerApproval_EntityType = {
  /** recommendation is for an item. */
  ItemId: 'ITEM_ID'
} as const;

export type PartnerApproval_EntityType = typeof PartnerApproval_EntityType[keyof typeof PartnerApproval_EntityType];
/** Enum for item generation type */
export const PartnerApproval_ItemGenerationType = {
  /** AI generated */
  AiGenerated: 'AI_GENERATED',
  /** Human generated */
  HumanGenerated: 'HUMAN_GENERATED'
} as const;

export type PartnerApproval_ItemGenerationType = typeof PartnerApproval_ItemGenerationType[keyof typeof PartnerApproval_ItemGenerationType];
/** Partner approval optimization status */
export const PartnerApproval_OptimizationStatus = {
  /** The optimization is completed */
  Completed: 'COMPLETED',
  /** The optimization is still pending */
  Pending: 'PENDING'
} as const;

export type PartnerApproval_OptimizationStatus = typeof PartnerApproval_OptimizationStatus[keyof typeof PartnerApproval_OptimizationStatus];
/** Partner approval optimization details */
export type PartnerApproval_PartnerApprovalOptimizationDetails = {
  __typename?: 'PartnerApproval_PartnerApprovalOptimizationDetails';
  /** The optimization status of the branch */
  optimizationStatus: PartnerApproval_OptimizationStatus;
  /** The partner approval user history, null if optimization status is pending */
  userHistory?: Maybe<Array<PartnerApproval_PartnerApprovalUserHistory>>;
};

/** Partner approval user history */
export type PartnerApproval_PartnerApprovalUserHistory = {
  __typename?: 'PartnerApproval_PartnerApprovalUserHistory';
  /** User email (not included in public user model) */
  email: Scalars['String'];
  /** Reviewed at */
  reviewedAt: Scalars['DateTime'];
  /** User (full name, etc.) */
  user: User_PublicUser;
};

/** Partner approval recommendation */
export type PartnerApproval_Recommendation = {
  __typename?: 'PartnerApproval_Recommendation';
  /** Recommendation approval state */
  approvalState: PartnerApproval_RecommendationApprovalState;
  /** Entity id (item id, learning objective id, etc.) */
  entityId: Scalars['ID'];
  /** describes what kind of id is provided in entityId */
  entityType: PartnerApproval_EntityType;
  /** Recommendation item generation type */
  generationType: PartnerApproval_ItemGenerationType;
  /** Recommendation id */
  id: Scalars['ID'];
  /** String item type (typename from course materials) */
  itemType: Scalars['String'];
  /** Optimization item type (optional for backwards compatability) */
  optimizationItemType?: Maybe<OptimizationBranch_ItemType>;
  /** short phrase indicating the rationale for the recommendation. needs translation */
  recommendationRationale?: Maybe<PartnerApproval_RecommendationRationale>;
  /** one or two line summary of the recommendation. needs translation */
  recommendationSummary?: Maybe<Scalars['String']>;
  /** Review id */
  reviewId: Scalars['ID'];
  /** User review history */
  reviewedBy?: Maybe<PartnerApproval_PartnerApprovalUserHistory>;
};

/** Partner approval recommendation state. */
export const PartnerApproval_RecommendationApprovalState = {
  /** The recommendation has been approved. Draft changes are published and available to learners. */
  Approved: 'APPROVED',
  /** The recommendation is pending.  Changes have been applied to the course but they are still in draft. */
  Pending: 'PENDING',
  /** The recommendation has been rejected. Draft changes have essentially been deleted. */
  Rejected: 'REJECTED'
} as const;

export type PartnerApproval_RecommendationApprovalState = typeof PartnerApproval_RecommendationApprovalState[keyof typeof PartnerApproval_RecommendationApprovalState];
/**
 * Enum that shows the current status of the item generation step, mainly to satisfy the loading step
 * This intentionally omits a partial success status per discussion with eng team
 */
export const PartnerApproval_RecommendationGenerationStatus = {
  /** recommendation is being applied (ie item generation has started) */
  Creating: 'CREATING',
  /** recommendation failed to be applied (ie item was not successfully created) */
  Failed: 'FAILED',
  /** No recommendations are pending creation */
  None: 'NONE',
  /** recommendation is ready for review (ie item is created) */
  Success: 'SUCCESS'
} as const;

export type PartnerApproval_RecommendationGenerationStatus = typeof PartnerApproval_RecommendationGenerationStatus[keyof typeof PartnerApproval_RecommendationGenerationStatus];
/** The reason this recommendation was generated */
export const PartnerApproval_RecommendationRationale = {
  /** this recommendation was generated to better prepare learners for upcoming assessments */
  AssessmentPreparation: 'ASSESSMENT_PREPARATION',
  /** this recommendation was generated in order to break up too many passive items in a row */
  BridgeDialogue: 'BRIDGE_DIALOGUE',
  /** this recommendation was implemented in order to engage learners earlier */
  EarlyEngagement: 'EARLY_ENGAGEMENT'
} as const;

export type PartnerApproval_RecommendationRationale = typeof PartnerApproval_RecommendationRationale[keyof typeof PartnerApproval_RecommendationRationale];
/** response for querying for pccr recommendations. at this point, this is assumed to contain T&L driven reccos and AI-generated. */
export type PartnerApproval_RecommendationResponse = {
  __typename?: 'PartnerApproval_RecommendationResponse';
  /** the overall branch status for item generation / pccr recommendations. */
  pccrRecommendationGenerationStatus: PartnerApproval_RecommendationGenerationStatus;
  /**
   * list of recommendations - these are either recommendations that are currently being applied (ie generated)
   * or have been applied (ie corresponding item already created)
   */
  pccrRecommendations: Array<PartnerApproval_Recommendation>;
};

/** Action to take on review */
export const PartnerApproval_ReviewAction = {
  /** Approve */
  Approve: 'APPROVE',
  /** Reject */
  Reject: 'REJECT'
} as const;

export type PartnerApproval_ReviewAction = typeof PartnerApproval_ReviewAction[keyof typeof PartnerApproval_ReviewAction];
/**
 * Input to start implementing ai generated recommendations
 * I'm assuming this will apply ALL outstanding pedagogy recommendations for that course
 */
export type PartnerApproval_StartImplementingAiGeneratedRecommendationsInput = {
  /** branch id */
  authoringBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/** Result of starting to implement ai generated recommendations */
export type PartnerApproval_StartImplementingAiGeneratedRecommendationsResult = {
  __typename?: 'PartnerApproval_StartImplementingAiGeneratedRecommendationsResult';
  /** Success */
  success: Scalars['Boolean'];
};

/** Input to submit course/branch (top level entity) for partner approval */
export type PartnerApproval_SubmitForApprovalInput = {
  /** Authoring branch id (nullable for course review) */
  authoringBranchId?: InputMaybe<Scalars['ID']>;
  /** Course id */
  courseId: Scalars['ID'];
};

/** Result of submitting for partner approval */
export type PartnerApproval_SubmitForApprovalResult = {
  __typename?: 'PartnerApproval_SubmitForApprovalResult';
  /** Item ids submitted for partner approval */
  itemIds?: Maybe<Array<Scalars['ID']>>;
  /** Review id */
  reviewId: Scalars['ID'];
};

/** Partner approval item ready to submit */
export type PartnerApproval_SubmittableItem = {
  __typename?: 'PartnerApproval_SubmittableItem';
  /** Atom id */
  atomId: Scalars['ID'];
  /** Item id */
  itemId: Scalars['ID'];
};

/** Queries a list of partner <-> group memberships */
export type PartnerGroupMembershipsQueries = {
  __typename?: 'PartnerGroupMembershipsQueries';
  /** Queries a list of partner <-> group memberships by groupId */
  queryByGroupId?: Maybe<PartnerGroupMemberships_Result>;
};


/** Queries a list of partner <-> group memberships */
export type PartnerGroupMembershipsQueriesQueryByGroupIdArgs = {
  groupId: Scalars['ID'];
};

/** A membership object that contains a groupID, partnerID, and partnerGroupMembershipId */
export type PartnerGroupMemberships_Membership = {
  __typename?: 'PartnerGroupMemberships_Membership';
  /** The ID of the group */
  groupId: Scalars['ID'];
  /** returns a Partner entity */
  partner: Partner_Partner;
  /** Concatenated string ID for partnerID and groupID relationship */
  partnerGroupMembershipId: Scalars['ID'];
};

/** Returns a list of membership objects (each membership holds a groupID, partnerID, and partnerGroupMembershipId) */
export type PartnerGroupMemberships_Result = {
  __typename?: 'PartnerGroupMemberships_Result';
  /** A list of partnerGroupMemberships */
  memberships: Array<PartnerGroupMemberships_Membership>;
};

export type PartnerMembershipsV1 = {
  __typename?: 'PartnerMembershipsV1';
  createdAt: Scalars['Float'];
  id: Scalars['Int'];
  partnerId: PartnerMembershipsV1_Org_Coursera_Opencourse_Model_LegacyPartnerId;
  role: PartnerMembershipsV1_Role;
  userId: PartnerMembershipsV1_Org_Coursera_User_UserId;
};

export type PartnerMembershipsV1Connection = {
  __typename?: 'PartnerMembershipsV1Connection';
  elements: Array<Maybe<PartnerMembershipsV1>>;
  paging: ResponsePagination;
};

export type PartnerMembershipsV1FindAllByUser = {
  __typename?: 'PartnerMembershipsV1FindAllByUser';
  connection?: Maybe<PartnerMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type PartnerMembershipsV1FindByPartner = {
  __typename?: 'PartnerMembershipsV1FindByPartner';
  connection?: Maybe<PartnerMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  partnerRole: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PartnerMembershipsV1FindByUser = {
  __typename?: 'PartnerMembershipsV1FindByUser';
  connection?: Maybe<PartnerMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerRole: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type PartnerMembershipsV1GetMemberships = {
  __typename?: 'PartnerMembershipsV1GetMemberships';
  connection?: Maybe<PartnerMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type PartnerMembershipsV1Resource = {
  __typename?: 'PartnerMembershipsV1Resource';
  findAllByUser?: Maybe<PartnerMembershipsV1Connection>;
  findByPartner?: Maybe<PartnerMembershipsV1Connection>;
  findByUser?: Maybe<PartnerMembershipsV1Connection>;
  getMemberships?: Maybe<PartnerMembershipsV1Connection>;
};


export type PartnerMembershipsV1ResourceFindAllByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type PartnerMembershipsV1ResourceFindByPartnerArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  partnerRole: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PartnerMembershipsV1ResourceFindByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerRole: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type PartnerMembershipsV1ResourceGetMembershipsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type PartnerMembershipsV1_Org_Coursera_Opencourse_Model_LegacyPartnerId = {
  __typename?: 'PartnerMembershipsV1_org_coursera_opencourse_model_LegacyPartnerId';
  maestroId: Scalars['Int'];
};

export type PartnerMembershipsV1_Org_Coursera_User_UserId = {
  __typename?: 'PartnerMembershipsV1_org_coursera_user_UserId';
  id: Scalars['Int'];
};

export const PartnerMembershipsV1_Role = {
  CourseAssistant: 'COURSE_ASSISTANT',
  DataCoordinator: 'DATA_COORDINATOR',
  Instructor: 'INSTRUCTOR',
  PartnerAdmin: 'PARTNER_ADMIN',
  TeachingStaff: 'TEACHING_STAFF'
} as const;

export type PartnerMembershipsV1_Role = typeof PartnerMembershipsV1_Role[keyof typeof PartnerMembershipsV1_Role];
/** Namespace type for partner queries */
export type PartnerQueries = {
  __typename?: 'PartnerQueries';
  /** Returns all partners */
  queryAll?: Maybe<Partner_PartnerPaginatedResult>;
  /** Returns the partner associated with the given id, if available */
  queryById?: Maybe<Partner_Partner>;
  /** Returns the partners associated with the given ids */
  queryByIds?: Maybe<Array<Partner_Partner>>;
  /** Returns the partner associated with the given slug, if available */
  queryBySlug?: Maybe<Partner_Partner>;
  /** Returns the partners associated with the given slugs */
  queryBySlugs?: Maybe<Array<Partner_Partner>>;
};


/** Namespace type for partner queries */
export type PartnerQueriesQueryAllArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeHidden?: Scalars['Boolean'];
  limit?: Scalars['Int'];
};


/** Namespace type for partner queries */
export type PartnerQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Namespace type for partner queries */
export type PartnerQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Namespace type for partner queries */
export type PartnerQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};


/** Namespace type for partner queries */
export type PartnerQueriesQueryBySlugsArgs = {
  slugs: Array<Scalars['String']>;
};

/** Paginated result type for Instructor_Instructor */
export type Partner_InstructorPaginatedResult = {
  __typename?: 'Partner_InstructorPaginatedResult';
  /** List of elements in the page */
  elements: Array<Instructor_Instructor>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Wrapper type for website links associated with a partner */
export type Partner_Links = {
  __typename?: 'Partner_Links';
  /** Facebook username */
  facebookUsername?: Maybe<Scalars['String']>;
  /** Twitter username */
  twitterUsername?: Maybe<Scalars['String']>;
  /** Main website url */
  website?: Maybe<Scalars['URL']>;
  /** YouTube channel handle */
  youtubeHandle?: Maybe<Scalars['String']>;
};

/** Partner location information */
export type Partner_Location = {
  __typename?: 'Partner_Location';
  /** City name */
  city?: Maybe<Scalars['String']>;
  /** ISO-3166-1 alpha-2 country code, eg. "US" */
  country?: Maybe<Scalars['String']>;
  /** Latitude */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']>;
  /** Location name */
  name?: Maybe<Scalars['String']>;
  /** State name */
  state?: Maybe<Scalars['String']>;
};

/** A reference to the partner stub */
export type Partner_Partner = {
  __typename?: 'Partner_Partner';
  /**
   * Abbreviated name that is sometimes used on the FE to avoid truncating full partner names.
   * Corresponds to `abbrName` in /api/partners.v1.
   */
  abbreviatedName: Scalars['String'];
  /** Accent branding color in hex code format, eg. #ffffff */
  accentColor?: Maybe<Scalars['String']>;
  /**
   * Partner logo url. At the time of writing:
   * - Corresponds to "Wide logo for marketing purposes" on /admin/institutions/settings/university-assets.
   * - PNG file
   * - 200px x 48px
   */
  classLogo?: Maybe<Scalars['URL']>;
  /** Partner description */
  description?: Maybe<Scalars['String']>;
  /** Boolean flag, controls if a partner should be publicly visible */
  display: Scalars['Boolean'];
  /**
   * Optional home page url override if a partner wishes to bypass the default partner landing page
   * on Coursera and use their own site. Corresponds to `homeLink` in /api/partners.v1.
   */
  homePageOverride?: Maybe<Scalars['URL']>;
  /** String representation of a partner id, eg. "783" */
  id: Scalars['ID'];
  /** Paginated list of instructors associated with the partner */
  instructors?: Maybe<Partner_InstructorPaginatedResult>;
  /**
   * Banner image url. At time of writing:
   * - Corresponds to "Banner for institution landing page" on /admin/institutions/settings/university-assets.
   * - JPG file with no borders
   * - 2560px x 640px
   */
  landingPageBanner?: Maybe<Scalars['URL']>;
  /** Website links associated with a partner that will appear on their landing page */
  links?: Maybe<Partner_Links>;
  /** Information about a partner's geographic location */
  location?: Maybe<Partner_Location>;
  /**
   * Partner logo url. At the time of writing:
   * - Corresponds to "Partner front and course logo" on /admin/institutions/settings/university-assets.
   * - 160px x 60px
   */
  logo?: Maybe<Scalars['URL']>;
  /** Partner name */
  name: Scalars['String'];
  /** Partner type */
  partnerType: Partner_Type;
  /** Primary branding color in hex code format, eg. #0156b8 */
  primaryColor?: Maybe<Scalars['String']>;
  /**
   * Partner logo. At the time of writing:
   * - Corresponds to "Logo for course and specialization description pages" on /admin/institutions/settings/university-assets.
   * - SVG or transparent PNG file
   * - White rectangular logo with no padding
   * - Minimum 250px x 50px
   * - Legible at small scale
   */
  productBrandingLogo?: Maybe<Scalars['URL']>;
  /**
   * Partner logo. At the time of writing:
   * - Corresponds to "Wide log SVG" on /admin/institutions/settings/university-assets.
   * - Used on course certificates and Degree/MasterTrack Program Home pages
   * - SVG file, wide
   */
  rectangularLogo?: Maybe<Scalars['URL']>;
  /** Secondary branding color in hex code format, eg. #82a8e1 */
  secondaryColor?: Maybe<Scalars['String']>;
  /** Human-readable identifier. Corresponds to `shortName` in /api/partners.v1. */
  slug: Scalars['String'];
  /**
   * Partner logo. At the time of writing:
   * - Corresponds to "Square logo for partner landing page" on /admin/institutions/settings/university-assets.
   * - Used on partner landing page and specialization certificates
   * - PNG file with no borders
   * - 360px x 360px
   */
  squareLogo?: Maybe<Scalars['URL']>;
};


/** A reference to the partner stub */
export type Partner_PartnerInstructorsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Paginated result type for Partner_Partner */
export type Partner_PartnerPaginatedResult = {
  __typename?: 'Partner_PartnerPaginatedResult';
  /** List of elements in the page */
  elements: Array<Partner_Partner>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Partner type */
export const Partner_Type = {
  /** Industry partner */
  Industry: 'INDUSTRY',
  /**
   * Private authoring partner, typically enterprise partners that wish to author content but only
   * make it available to their own employees
   */
  PrivateAuthoring: 'PRIVATE_AUTHORING',
  /** University partner */
  University: 'UNIVERSITY'
} as const;

export type Partner_Type = typeof Partner_Type[keyof typeof Partner_Type];
export type PartnersV1 = {
  __typename?: 'PartnersV1';
  abbrName: Scalars['String'];
  accentColor?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  classLogo?: Maybe<Scalars['String']>;
  courseIds: Array<Maybe<Scalars['String']>>;
  courses?: Maybe<CoursesV1Connection>;
  description?: Maybe<Scalars['String']>;
  display: Scalars['Boolean'];
  homeLink?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  instructors?: Maybe<InstructorsV1Connection>;
  landingPageBanner?: Maybe<Scalars['String']>;
  links?: Maybe<PartnersV1_Org_Coursera_Catalog_PartnerLinks>;
  location?: Maybe<PartnersV1_Org_Coursera_Catalog_PartnerLocation>;
  logo?: Maybe<Scalars['String']>;
  mastertracks?: Maybe<CatalogMastertracksV1Connection>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  partnerMarketingBlurb?: Maybe<Scalars['String']>;
  partnerType: Scalars['Int'];
  primaryColor?: Maybe<Scalars['String']>;
  productBrandingLogo?: Maybe<Scalars['String']>;
  professionalCertificates?: Maybe<ProfessionalCertsV1Connection>;
  rectangularLogo?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  shortName: Scalars['String'];
  specializations?: Maybe<OnDemandSpecializationsV1Connection>;
  squareLogo?: Maybe<Scalars['String']>;
};


export type PartnersV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type PartnersV1InstructorsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1MastertracksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  liveOnly?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1ProfessionalCertificatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1SpecializationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PartnersV1Connection = {
  __typename?: 'PartnersV1Connection';
  elements: Array<Maybe<PartnersV1>>;
  paging: ResponsePagination;
};

export type PartnersV1Resource = {
  __typename?: 'PartnersV1Resource';
  get?: Maybe<PartnersV1>;
  getAll?: Maybe<PartnersV1Connection>;
  multiGet?: Maybe<PartnersV1Connection>;
  shortName?: Maybe<PartnersV1Connection>;
  shortNames?: Maybe<PartnersV1Connection>;
};


export type PartnersV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PartnersV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1ResourceShortNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PartnersV1ResourceShortNamesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  shortNames: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};

export type PartnersV1ShortName = {
  __typename?: 'PartnersV1ShortName';
  connection?: Maybe<PartnersV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  shortName: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PartnersV1ShortNames = {
  __typename?: 'PartnersV1ShortNames';
  connection?: Maybe<PartnersV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  shortNames: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type PartnersV1_Org_Coursera_Catalog_PartnerLinks = {
  __typename?: 'PartnersV1_org_coursera_catalog_PartnerLinks';
  facebook?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

export type PartnersV1_Org_Coursera_Catalog_PartnerLocation = {
  __typename?: 'PartnersV1_org_coursera_catalog_PartnerLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueries = {
  __typename?: 'PathwayCareerRoleQueries';
  /** Query multiple career roles using a list of role ids. The returned roles are sorted and filtered appropriately. */
  queryRecommendedRolesByIds?: Maybe<Recommendation_Collection>;
  /** A query to retrieve skill role data by role slug. */
  queryRoleBySlug?: Maybe<Skill_CareerRole>;
  /** Query multiple career roles using a domain id. */
  queryRolesByDomain?: Maybe<Recommendation_Collection>;
  /** Query multiple career roles using a list of role ids. */
  queryRolesByIds: Array<Skill_CareerRole>;
  /**
   * Fetch career roles by Pathway Level and Job Category.
   * * 1) If both level and category are provided, the roles that match both will be returned.
   * * 2) If only one parameter (either level or category) is given, matching roles for that parameter will be returned.
   * * 3) If neither parameter is set, all roles will be returned.
   */
  queryRolesByPathwayLevelAndCategory?: Maybe<Recommendation_Collection>;
  /** Fetch career roles by product slug and product type. */
  queryRolesByProduct?: Maybe<Recommendation_Collection>;
  /** Query multiple career roles using a skill id. The returned roles are sorted by the importance of the skill to each role. */
  queryRolesBySkill?: Maybe<SkillCareerRole_PaginatedResult>;
  /** Fetches career roles by performing a fuzzy search on role names. This API retrieves all roles present in Role Taxonomy 2.0. */
  searchRolesByName?: Maybe<SkillCareerRole_PaginatedResult>;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRecommendedRolesByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRoleBySlugArgs = {
  slug: Scalars['String'];
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRolesByDomainArgs = {
  domainId: Scalars['ID'];
  roleCompletionStatusFilter?: CareerRole_CompletionStatusFilter;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRolesByIdsArgs = {
  enableRoleTaxonomy2?: Scalars['Boolean'];
  ids: Array<Scalars['ID']>;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRolesByPathwayLevelAndCategoryArgs = {
  jobCategory?: InputMaybe<CareerRole_MerchandisingJobCategory>;
  pathwayLevel?: InputMaybe<CareerRole_PathwayLevel>;
  roleCompletionStatusFilter?: CareerRole_CompletionStatusFilter;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRolesByProductArgs = {
  productSlug: Scalars['String'];
  productType?: CareerRole_ProductType;
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesQueryRolesBySkillArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  roleCompletionStatusFilter?: CareerRole_CompletionStatusFilter;
  skillId: Scalars['ID'];
};


/** Pathway career roles data queries definition. */
export type PathwayCareerRoleQueriesSearchRolesByNameArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  searchTerm: Scalars['String'];
};

/** Data structure holding the credits that can be applied towards a degree */
export type Pathways_CourseCredits = {
  __typename?: 'Pathways_CourseCredits';
  /** Maximum amount of credit that can be applied towards the degree when finishing this course */
  maximumTransferableCredit?: Maybe<Scalars['Int']>;
};

/** Paginated result of degree pathways */
export type Pathways_CourseForTargetDegree_PaginatedResult = {
  __typename?: 'Pathways_CourseForTargetDegree_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForCourse>;
  /** Pagination information */
  pagination: Pagination;
};

/** Data structure holding the progress made by a learner in the course, primarely used for pathway use cases */
export type Pathways_CourseProgress = {
  __typename?: 'Pathways_CourseProgress';
  /** Next learning item in in progress course */
  nextLearningItem: Pathways_InProgressCourseNextLearningItem;
  /** Progress percentage */
  progress: Scalars['Int'];
};

/** Pathway related properties of a Course_Course */
export type Pathways_CourseProperties = {
  __typename?: 'Pathways_CourseProperties';
  /** List of degrees that the course stacks into */
  degreePathways?: Maybe<Pathways_TargetDegreeForCourse_PaginatedResult>;
  /** Id - same as the course id */
  id: Scalars['ID'];
  /** For Credit Non Degree flag */
  isForCreditNonDegree?: Maybe<Scalars['Boolean']>;
  /** Progress */
  progress?: Maybe<Pathways_CourseProgress>;
};


/** Pathway related properties of a Course_Course */
export type Pathways_CoursePropertiesDegreePathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Pathway related properties of a Degree */
export type Pathways_DegreeProperties = {
  __typename?: 'Pathways_DegreeProperties';
  /** List of courses that stack into this degree */
  coursePathways?: Maybe<Pathways_CourseForTargetDegree_PaginatedResult>;
  /** Id - same as the degree id */
  id: Scalars['ID'];
  /** List of MasterTracks(R) that stack into this degree */
  masterTrackPathways?: Maybe<Pathways_MasterTrackForTargetDegree_PaginatedResult>;
  /** Pathway url */
  pathwayUrl?: Maybe<Scalars['URL']>;
  /** Progress made by a logged in learner towards a degree */
  progress?: Maybe<Pathways_Progress>;
  /** List of specializations that stack into this degree */
  specializationPathways?: Maybe<Pathways_SpecializationForTargetDegree_PaginatedResult>;
};


/** Pathway related properties of a Degree */
export type Pathways_DegreePropertiesCoursePathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Pathway related properties of a Degree */
export type Pathways_DegreePropertiesMasterTrackPathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Pathway related properties of a Degree */
export type Pathways_DegreePropertiesSpecializationPathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Data structure holding the next learning item in an in progress course */
export type Pathways_InProgressCourseNextLearningItem = {
  __typename?: 'Pathways_InProgressCourseNextLearningItem';
  /** Expected completion time in minutes */
  expectedCompletionTime: Scalars['Int'];
  /** Learning item id */
  id: Scalars['ID'];
  /** Learning item title */
  title: Scalars['String'];
  /** Learning item type */
  type: Scalars['String'];
  /** Learning item url */
  url: Scalars['URL'];
  /** Active week */
  week: Scalars['Int'];
};

/** Data structure holding the credits that can be applied towards a degree */
export type Pathways_MasterTrackCredits = {
  __typename?: 'Pathways_MasterTrackCredits';
  /** Maximum amount of credit that can be applied towards the degree when finishing this MasterTrack */
  maximumTransferableCredit?: Maybe<Scalars['Int']>;
};

/** Paginated result of degree pathways */
export type Pathways_MasterTrackForTargetDegree_PaginatedResult = {
  __typename?: 'Pathways_MasterTrackForTargetDegree_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForMasterTrack>;
  /** Pagination information */
  pagination: Pagination;
};

/** Pathway related properties of a MasterTrack, that is represented as a Degree_Degree */
export type Pathways_MasterTrackProperties = {
  __typename?: 'Pathways_MasterTrackProperties';
  /** List of degrees that the MasterTrack stacks into */
  degreePathways?: Maybe<Pathways_TargetDegreeForMasterTrack_PaginatedResult>;
  /** Id - same as the MasterTrack id */
  id: Scalars['ID'];
};


/** Pathway related properties of a MasterTrack, that is represented as a Degree_Degree */
export type Pathways_MasterTrackPropertiesDegreePathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Data structure holding the progress of a learner towards a degree */
export type Pathways_Progress = {
  __typename?: 'Pathways_Progress';
  /** Specializations in progress stacking into this degree */
  specializationProgress: Array<Pathways_SpecializationProgress>;
};

/** Data structure holding the cost savings that can be achieved by finishing a specialization */
export type Pathways_SpecializationCostSavings = {
  __typename?: 'Pathways_SpecializationCostSavings';
  /** Amount of money saved by finishing this specialization */
  amount: Scalars['Float'];
  /** Currency */
  currency: Scalars['String'];
};

/** Data structure holding the credits that can be applied towards a degree */
export type Pathways_SpecializationCredits = {
  __typename?: 'Pathways_SpecializationCredits';
  /** Maximum amount of credit that can be applied towards the degree when finishing this specialization */
  maximumTransferableCredit?: Maybe<Scalars['Int']>;
};

/** Paginated result of degree pathways */
export type Pathways_SpecializationForTargetDegree_PaginatedResult = {
  __typename?: 'Pathways_SpecializationForTargetDegree_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForSpecialization>;
  /** Pagination information */
  pagination: Pagination;
};

/** Data structure holding the progress of a learner in a specialization */
export type Pathways_SpecializationProgress = {
  __typename?: 'Pathways_SpecializationProgress';
  /** Number of completed courses */
  coursesCompleted: Scalars['Int'];
  /** In progress course */
  inProgressCourse?: Maybe<Course_Course>;
  /** Specialization */
  specialization: Specialization_Specialization;
};

/** Pathway related properties of a Specialization_Specialization */
export type Pathways_SpecializationProperties = {
  __typename?: 'Pathways_SpecializationProperties';
  /** List of degrees that the specialization stacks into */
  degreePathways?: Maybe<Pathways_TargetDegreeForSpecialization_PaginatedResult>;
  /** Id - same as the specialization id */
  id: Scalars['ID'];
};


/** Pathway related properties of a Specialization_Specialization */
export type Pathways_SpecializationPropertiesDegreePathwaysArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Data structure holding the savings that can be achieved by finishing a specialization */
export type Pathways_SpecializationSavings = {
  __typename?: 'Pathways_SpecializationSavings';
  /** Cost savings */
  cost?: Maybe<Pathways_SpecializationCostSavings>;
  /** Time savings */
  time?: Maybe<Pathways_SpecializationTimeSavings>;
};

/** Data structure holding the time savings that can be achieved by finishing a specialization */
export type Pathways_SpecializationTimeSavings = {
  __typename?: 'Pathways_SpecializationTimeSavings';
  /** Amount of time saved by finishing this specialization */
  amount: Scalars['Float'];
  /** Time unit */
  unit: Pathways_TimeUnit;
};

/** Federated course entity stub */
export type Pathways_StackingCourse = {
  __typename?: 'Pathways_StackingCourse';
  /** The course */
  course: Course_Course;
  /** Stacking type */
  stackingType: Pathways_StackingType;
};

/** Paginated result for stacking courses */
export type Pathways_StackingCourseResult = {
  __typename?: 'Pathways_StackingCourseResult';
  /** List of stacking courses */
  items: Array<Pathways_StackingCourse>;
  /** Pagination parameters for stacking courses */
  paginationResponse?: Maybe<PaginationResponse>;
};

/** Federated specialization entity stub */
export type Pathways_StackingSpecialization = {
  __typename?: 'Pathways_StackingSpecialization';
  /** The specialization */
  specialization: Specialization_Specialization;
  /** Stacking type */
  stackingType: Pathways_StackingType;
};

/** Paginated result for stacking specializations */
export type Pathways_StackingSpecializationResult = {
  __typename?: 'Pathways_StackingSpecializationResult';
  /** List of stacking specializations */
  items: Array<Pathways_StackingSpecialization>;
  /** Pagination parameters for stacking specializations */
  paginationResponse?: Maybe<PaginationResponse>;
};

/** Upsell types */
export const Pathways_StackingType = {
  /** Courses and specializations offering credit towards degree */
  OffersCredit: 'OFFERS_CREDIT',
  /** Courses and specializations offering progress transfer towards a degree */
  PartOf: 'PART_OF',
  /** Courses and specializations related to a degree */
  RelatedTo: 'RELATED_TO'
} as const;

export type Pathways_StackingType = typeof Pathways_StackingType[keyof typeof Pathways_StackingType];
/** Federated target degree entity stub */
export type Pathways_TargetDegree = {
  __typename?: 'Pathways_TargetDegree';
  /** The degree */
  degree: Degree_Degree;
  /** Stacking type */
  stackingType: Pathways_StackingType;
};

/** Data structure holding the parameters of the pathway relationship between a course and degree */
export type Pathways_TargetDegreeForCourse = {
  __typename?: 'Pathways_TargetDegreeForCourse';
  /** Course */
  course: Course_Course;
  /** Credits */
  credits?: Maybe<Pathways_CourseCredits>;
  /** The degree */
  degree: Degree_Degree;
  /** Id to be used in delete and update operations */
  id: Scalars['ID'];
  /** Stacking type */
  stackingType: Stackability_UpsellType;
};

/** Paginated result of degree pathways */
export type Pathways_TargetDegreeForCourse_PaginatedResult = {
  __typename?: 'Pathways_TargetDegreeForCourse_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForCourse>;
  /** Pagination information */
  pagination: Pagination;
};

/** Data structure holding the parameters of the pathway relationship between a MasterTrack and degree */
export type Pathways_TargetDegreeForMasterTrack = {
  __typename?: 'Pathways_TargetDegreeForMasterTrack';
  /** Credits */
  credits?: Maybe<Pathways_MasterTrackCredits>;
  /** The degree */
  degree: Degree_Degree;
  /** Id to be used in delete and update operations */
  id: Scalars['ID'];
  /** MasterTrack */
  masterTrack: Degree_Degree;
  /** Stacking type */
  stackingType: Stackability_UpsellType;
};

/** Paginated result of degree pathways */
export type Pathways_TargetDegreeForMasterTrack_PaginatedResult = {
  __typename?: 'Pathways_TargetDegreeForMasterTrack_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForMasterTrack>;
  /** Pagination information */
  pagination: Pagination;
};

/** Data structure holding the parameters of the pathway relationship between a specialization and degree */
export type Pathways_TargetDegreeForSpecialization = {
  __typename?: 'Pathways_TargetDegreeForSpecialization';
  /** Credits */
  credits?: Maybe<Pathways_SpecializationCredits>;
  /** The degree */
  degree: Degree_Degree;
  /** Id to be used in delete and update operations */
  id: Scalars['ID'];
  /** Savings */
  savings?: Maybe<Pathways_SpecializationSavings>;
  /** Specialization */
  specialization: Specialization_Specialization;
  /** Stacking type */
  stackingType: Stackability_UpsellType;
};

/** Paginated result of degree pathways */
export type Pathways_TargetDegreeForSpecialization_PaginatedResult = {
  __typename?: 'Pathways_TargetDegreeForSpecialization_PaginatedResult';
  /** List of degree pathways */
  elements: Array<Pathways_TargetDegreeForSpecialization>;
  /** Pagination information */
  pagination: Pagination;
};

/** Paginated result type for target degrees */
export type Pathways_TargetDegreeResult = {
  __typename?: 'Pathways_TargetDegreeResult';
  /** List of degrees that the course    stacks into */
  items?: Maybe<Array<Pathways_TargetDegree>>;
  /** Pagination parameters for target degrees */
  paginationResponse?: Maybe<PaginationResponse>;
};

/** Time unit for degree duration */
export const Pathways_TimeUnit = {
  /** Day */
  Day: 'DAY',
  /** Month */
  Month: 'MONTH',
  /** Week */
  Week: 'WEEK',
  /** Year */
  Year: 'YEAR'
} as const;

export type Pathways_TimeUnit = typeof Pathways_TimeUnit[keyof typeof Pathways_TimeUnit];
/** Payment int tools application queries definitions */
export type PaymentIntToolsApplicationQueries = {
  __typename?: 'PaymentIntToolsApplicationQueries';
  /** Find a support cart by transaction descriptor */
  querySupportCartByTransactionDescriptor?: Maybe<PaymentIntTools_SupportCart>;
  /** Find support transactions by cart ID */
  querySupportTransactionsByCartId?: Maybe<Array<Maybe<PaymentIntTools_SupportTransaction>>>;
};


/** Payment int tools application queries definitions */
export type PaymentIntToolsApplicationQueriesQuerySupportCartByTransactionDescriptorArgs = {
  transactionDescriptor: Scalars['ID'];
};


/** Payment int tools application queries definitions */
export type PaymentIntToolsApplicationQueriesQuerySupportTransactionsByCartIdArgs = {
  cartId: Scalars['ID'];
};

/** SupportCart type definition */
export type PaymentIntTools_SupportCart = {
  __typename?: 'PaymentIntTools_SupportCart';
  /** The ID of the cart containing this transaction */
  cartId?: Maybe<Scalars['ID']>;
  /** The ID of the user who created this transaction */
  userId?: Maybe<Scalars['ID']>;
};

/** SupportCreditCard type definition */
export type PaymentIntTools_SupportCreditCard = {
  __typename?: 'PaymentIntTools_SupportCreditCard';
  /** Credit card type */
  cardType?: Maybe<Scalars['String']>;
  /** Expiration month of the credit card in "01" format */
  expirationMonth?: Maybe<Scalars['String']>;
  /** Expiration year of the credit card */
  expirationYear?: Maybe<Scalars['String']>;
  /** Last 4 digits of the credit card number */
  last4?: Maybe<Scalars['String']>;
};

/** SupportStatusEvent type definition */
export type PaymentIntTools_SupportStatusEvent = {
  __typename?: 'PaymentIntTools_SupportStatusEvent';
  /** Transaction amount */
  amount?: Maybe<Scalars['String']>;
  /** Transaction source */
  source?: Maybe<Scalars['String']>;
  /** Transaction status */
  status?: Maybe<Scalars['String']>;
  /** Transaction timestamp in long number format */
  timestamp?: Maybe<Scalars['String']>;
  /** User who created this transaction */
  user?: Maybe<Scalars['String']>;
};

/** SupportTransaction type definition */
export type PaymentIntTools_SupportTransaction = {
  __typename?: 'PaymentIntTools_SupportTransaction';
  /** External payment processor additional response */
  additionalProcessorResponse?: Maybe<Scalars['String']>;
  /** Address verification service error response code */
  avsErrorResponseCode?: Maybe<Scalars['String']>;
  /** Address verification postal code response code */
  avsPostalCodeResponseCode?: Maybe<Scalars['String']>;
  /** Address verification street address response code */
  avsStreetAddressResponseCode?: Maybe<Scalars['String']>;
  /** Credit card details */
  creditCard?: Maybe<PaymentIntTools_SupportCreditCard>;
  /** The CVV provided matches the information on file with the cardholder's bank */
  cvvResponseCode?: Maybe<Scalars['String']>;
  /** Transaction ID */
  id?: Maybe<Scalars['ID']>;
  /** External payment processor response code */
  processorResponseCode?: Maybe<Scalars['String']>;
  /** External payment processor response text */
  processorResponseText?: Maybe<Scalars['String']>;
  /** External payment processor settlement response code */
  processorSettlementResponseCode?: Maybe<Scalars['String']>;
  /** External payment processor settlement response text */
  processorSettlementResponseText?: Maybe<Scalars['String']>;
  /** Response body that holds additional transaction information */
  responseBody?: Maybe<Scalars['String']>;
  /** List of support status events */
  statusHistory?: Maybe<Array<Maybe<PaymentIntTools_SupportStatusEvent>>>;
};

/** Queries related to PaymentMethods. */
export type PaymentMethodQueries = {
  __typename?: 'PaymentMethodQueries';
  /** Fetches payment methods for the calling user and paymentProcessorIds. Allows return of deleted records via includeDeleted parameter. */
  findPaymentMethods: PaymentProcessor_PaymentMethodPaginatedResult;
};


/** Queries related to PaymentMethods. */
export type PaymentMethodQueriesFindPaymentMethodsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeDeleted?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  paymentProcessorIds?: InputMaybe<Array<Payments_PaymentProcessorId>>;
};

/** Input for CreatePaymentMethod request. */
export type PaymentProcessor_CreatePaymentMethodInput = {
  /** Optional billing info for processors that do not return billing address information (e.g. Braintree). */
  billingInfo?: InputMaybe<Payments_BillingInfoInput>;
  /** Optional nickname to give payment method. */
  nickname?: InputMaybe<Scalars['String']>;
  /** Id of payment processor. */
  paymentProcessorId: Payments_PaymentProcessorId;
  /** Id of payment method on payment processor. */
  paymentProcessorPaymentMethodId: Scalars['ID'];
};

/** Result for CreatePaymentMethod. */
export type PaymentProcessor_CreatePaymentMethodResult = {
  __typename?: 'PaymentProcessor_CreatePaymentMethodResult';
  /** The created payment method object. */
  paymentMethod: Payments_PaymentMethod;
};

/** Input object for DeletePaymentMethod request. */
export type PaymentProcessor_DeletePaymentMethodInput = {
  /** ID of payment method to delete. */
  id: Scalars['ID'];
};

/** Result object for DeletePaymentMethod request. */
export type PaymentProcessor_DeletePaymentMethodResult = {
  __typename?: 'PaymentProcessor_DeletePaymentMethodResult';
  /** Dummy field. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Result object when PreCreatePaymentMethod is called for Braintree. */
export type PaymentProcessor_GenerateBraintreeClientTokenResponse = {
  __typename?: 'PaymentProcessor_GenerateBraintreeClientTokenResponse';
  /** Client token used to initialize Braintree Drop-in UI. */
  clientToken: Scalars['String'];
};

/** Result object when PreCreatePaymentMethod is called for Stripe. */
export type PaymentProcessor_GenerateStripeSetupIntentResponse = {
  __typename?: 'PaymentProcessor_GenerateStripeSetupIntentResponse';
  /** Stripe client secret. */
  clientSecret: Scalars['String'];
  /** Setup intent id. */
  setupIntentId: Scalars['ID'];
  /** Stripe API key. */
  stripeApiKey: Scalars['String'];
};

/** Result object of find payment methods call. */
export type PaymentProcessor_PaymentMethodPaginatedResult = {
  __typename?: 'PaymentProcessor_PaymentMethodPaginatedResult';
  /** Returned payment methods. */
  elements: Array<Payments_PaymentMethod>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Input object for PreCreatePaymentMethod request. */
export type PaymentProcessor_PreCreatePaymentMethodInput = {
  /** Payment Processor ID. */
  paymentProcessorId: Payments_PaymentProcessorId;
};

/** Result object of PreCreatePaymentMethod request. */
export type PaymentProcessor_PreCreatePaymentMethodResult = PaymentProcessor_GenerateBraintreeClientTokenResponse | PaymentProcessor_GenerateStripeSetupIntentResponse;

/** Input object for UpdatePaymentMethod request. */
export type PaymentProcessor_UpdatePaymentMethodInput = {
  /** Billing info object containing country, state, postal code. */
  billingInfo?: InputMaybe<Payments_BillingInfoInput>;
  /** Payment method id. */
  id: Scalars['ID'];
  /** New payment processor payment method id. */
  paymentProcessorPaymentMethodId?: InputMaybe<Scalars['ID']>;
};

/** Result object for UpdatePaymentMethod. */
export type PaymentProcessor_UpdatePaymentMethodResult = {
  __typename?: 'PaymentProcessor_UpdatePaymentMethodResult';
  /** The updated payment method object. */
  paymentMethod: Payments_PaymentMethod;
};

/** Result object of fetch valid payment processors call. */
export type PaymentProcessor_ValidPaymentProcessorsResult = {
  __typename?: 'PaymentProcessor_ValidPaymentProcessorsResult';
  /** Returned payment processors */
  processors: Array<Payments_PaymentProcessorId>;
};

/** Queries related to PaymentProcessors. */
export type PaymentProcessorsQueries = {
  __typename?: 'PaymentProcessorsQueries';
  /** Fetches payment processor for the provided geography. */
  getValidPaymentProcessors: PaymentProcessor_ValidPaymentProcessorsResult;
};


/** Queries related to PaymentProcessors. */
export type PaymentProcessorsQueriesGetValidPaymentProcessorsArgs = {
  countryIsoCode: Scalars['String'];
  currencyCode: Scalars['String'];
  hasPromotion: Scalars['Boolean'];
  productType: Payments_ProductType;
};

/** Queries related to Payment taxes. */
export type PaymentTaxesQueries = {
  __typename?: 'PaymentTaxesQueries';
  /** Gives an estimate of the taxes a learner will have to pay for a product. */
  taxEstimate: PaymentTaxes_TaxEstimateResult;
};


/** Queries related to Payment taxes. */
export type PaymentTaxesQueriesTaxEstimateArgs = {
  countryIsoCode: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  productType: PaymentTaxes_ProductType;
  transactionAmount: MonetaryAmountInput;
};

/** Products that are subject to tax */
export const PaymentTaxes_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** The Coursera Lite product, which gives limited access to a subset of the Coursera catalog. */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /**
   * Used for not taxable, deprecated, or invalid product types.
   * Please note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID',
  /** The most modern version of one-time payment for s12ns. */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** A Subscription product that gives access to an s12n and its courses. */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** Standalone course purchase */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type PaymentTaxes_ProductType = typeof PaymentTaxes_ProductType[keyof typeof PaymentTaxes_ProductType];
/** Tax estimate result */
export type PaymentTaxes_TaxEstimateResult = {
  __typename?: 'PaymentTaxes_TaxEstimateResult';
  /** Tax amount */
  taxAmount: Scalars['String'];
  /** Tax Rate */
  taxBehavior: Payments_TaxBehavior;
  /** Tax Rate */
  taxRate: Scalars['String'];
  /** Total amount after tax */
  totalAmountWithTax: Scalars['String'];
};

export type PaymentWalletsV1 = {
  __typename?: 'PaymentWalletsV1';
  id: Scalars['Float'];
};

/** Billing information in which to update a CheckoutIntent with. */
export type PaymentsCheckout_BillingInfoInput = {
  /** Country ISO code of the billing info (ISO 3166-1 alpha-2). */
  countryIsoCode: Scalars['String'];
  /** Postal code (ZIP code in the US) of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State code of the billing info (preferably the subdivision of ISO 3166-2, but this is not always possible). */
  state?: InputMaybe<Scalars['String']>;
};

/** Braintree subscription submit params. */
export type PaymentsCheckout_BraintreeSubscriptionSubmitParams = {
  /** Braintree nonce. */
  braintreeNonce: Scalars['String'];
};

/** The charging scheme of a CheckoutIntent. */
export type PaymentsCheckout_ChargingScheme = PaymentsCheckout_OneTimeChargingScheme | PaymentsCheckout_RecurringChargingScheme;

/** The result of a Checkout Attempt. */
export type PaymentsCheckout_CheckoutAttemptResult = {
  __typename?: 'PaymentsCheckout_CheckoutAttemptResult';
  /** The details of the payment processor exception, if one occurred. */
  exceptionDetails?: Maybe<PaymentsCheckout_PaymentProcessorExceptionDetails>;
  /** The ID of payment processor transaction, if one was created. */
  paymentProcessorTransactionId?: Maybe<Scalars['ID']>;
  /** The status of the checkout attempt. */
  status: PaymentsCheckout_CheckoutAttemptStatus;
  /** The timestamp of the checkout attempt result. */
  timestamp: Scalars['DateTime'];
};

/** Status of a Checkout Attempt. */
export const PaymentsCheckout_CheckoutAttemptStatus = {
  /** The checkout attempt was successful. */
  Accepted: 'ACCEPTED',
  /** The checkout attempt has failed. */
  Rejected: 'REJECTED'
} as const;

export type PaymentsCheckout_CheckoutAttemptStatus = typeof PaymentsCheckout_CheckoutAttemptStatus[keyof typeof PaymentsCheckout_CheckoutAttemptStatus];
/**
 * A CheckoutIntent represents the intent of a learner to checkout a cart and maintains the states
 * and data required to progress towards a paid state.
 */
export type PaymentsCheckout_CheckoutIntent = {
  __typename?: 'PaymentsCheckout_CheckoutIntent';
  /**
   * The promotion that is currently applied to this CheckoutIntent. If `null` then no promotion
   * is currently applied.
   */
  applicablePromotion?: Maybe<PaymentsCheckout_Promotion>;
  /**
   * The amount that will be charged for this CheckoutIntent.
   *
   * This amount does _not_ include the taxAmount of any promotion amounts. This is the _base_
   * amount before applying any of those modifiers.
   */
  baseAmount: MonetaryAmount;
  /**
   * The billing information associated with this CheckoutIntent, including country, state, and
   * postal code. This information is used to calculate the appropriate tax amount for the checkout.
   * If `null`, billing information has not yet been provided for this CheckoutIntent.
   */
  billingInfo?: Maybe<Payments_PaymentTransactionBillingInfo>;
  /** The charging scheme intended for this CheckoutIntent. */
  chargingScheme: PaymentsCheckout_ChargingScheme;
  /** The final amount that should be charged after applied discounts and taxes. */
  finalAmount: MonetaryAmount;
  /** The ID of the CheckoutIntent. */
  id: Scalars['ID'];
  /** The latest checkout attempt result, if available. */
  latestCheckoutAttemptResult?: Maybe<PaymentsCheckout_CheckoutAttemptResult>;
  /** The details from the Payment Processor necessary to render a checkout form. */
  paymentProcessorCheckoutContext: Array<PaymentsCheckout_PaymentProcessorCheckoutContextEntry>;
  /** The Reference ID of the Checkout on the Payment Processor's end. */
  paymentProcessorCheckoutReferenceId?: Maybe<Scalars['ID']>;
  /** The ID of the Payment Processor being used for this CheckoutIntent. */
  paymentProcessorId: PaymentsCheckout_PaymentProcessorId;
  /**
   * The amount that will be charged by the CheckoutIntent after applying any discounts, if applicable but before any taxes.
   *
   * If no discounts are applied, this is the same as the baseAmount.
   */
  postDiscountAmount: MonetaryAmount;
  /** The required action from the client or learner in order to proceed, if state is REQUIRES_ACTION. */
  requiredAction?: Maybe<PaymentsCheckout_RequiredAction>;
  /** Whether this CheckoutIntent is using sandbox mode. */
  sandbox: Scalars['Boolean'];
  /** Whether to save the payment method associated with this CheckoutIntent. */
  savePaymentMethod: Scalars['Boolean'];
  /** The current state of a CheckoutIntent. */
  state: PaymentsCheckout_State;
  /**
   * The tax amount that will be charged for this CheckoutIntent. This value can change when
   * the payment billing info is updated on the CheckoutIntent, as the taxes then need to be
   * recalculated. If `null`, then taxes have not yet been calculated for this CheckoutIntent.
   *
   * The currency between this value and the originalAmount should match.
   */
  taxDetails?: Maybe<PaymentsCheckout_TaxDetails>;
  /** Today's charge amount that should be charged after applied discounts and taxes. */
  todayChargeAmount: MonetaryAmount;
};

/** Dlocal checkout params. */
export type PaymentsCheckout_DlocalCheckoutParams = {
  /** Callback URL. */
  callbackUrl: Scalars['URL'];
  /** Payer Document(CPF or CNPJ) required by some payment method for expatriation purposse. */
  payerDocument?: InputMaybe<Scalars['String']>;
  /** Payer email. */
  payerEmail: Scalars['String'];
  /** Payer name. */
  payerName: Scalars['String'];
  /** Payer Phone. */
  payerPhone?: InputMaybe<Scalars['String']>;
  /** Payment method. */
  paymentMethod: PaymentsCheckout_DlocalPaymentMethodType;
};

/** Dlocal payment method type. */
export const PaymentsCheckout_DlocalPaymentMethodType = {
  /** GCash payment method - OTP (Philippines). */
  GcashOtp: 'GCASH_OTP',
  /** GCash Recurring (Philippines). */
  GcashRecurring: 'GCASH_RECURRING',
  /** Mercado Pago payment method - OTP. */
  MercadoPagoOtp: 'MERCADO_PAGO_OTP',
  /** Mercado Pago payment method - Recurring. */
  MercadoPagoRecurring: 'MERCADO_PAGO_RECURRING',
  /** OVO payment method in Indonesia. */
  Ovo: 'OVO',
  /** PIX Automático payment method. */
  PixAutomatico: 'PIX_AUTOMATICO'
} as const;

export type PaymentsCheckout_DlocalPaymentMethodType = typeof PaymentsCheckout_DlocalPaymentMethodType[keyof typeof PaymentsCheckout_DlocalPaymentMethodType];
/** PaymentsCheckout Error. */
export type PaymentsCheckout_Error = Error & {
  __typename?: 'PaymentsCheckout_Error';
  /** Error message */
  message: Scalars['String'];
};

/** The details of a flat discount amount promotion. */
export type PaymentsCheckout_FlatDiscountPromotion = {
  __typename?: 'PaymentsCheckout_FlatDiscountPromotion';
  /**
   * The flat amount in which to discount the CheckoutIntent amount by.
   *
   * The currency between this value and the CheckoutIntent amount should match.
   */
  amount: MonetaryAmount;
};

/** The details of a free trial based promotion. */
export type PaymentsCheckout_FreeTrialPromotion = {
  __typename?: 'PaymentsCheckout_FreeTrialPromotion';
  /** The number of free trial days to give for a CheckoutIntent. */
  numberOfTrialDays: Scalars['Int'];
};

/** Input for initializing a CheckoutIntent with a body. */
export type PaymentsCheckout_InitializeBodyInput = {
  /** Billing information to initialize the CheckoutIntent with. */
  billingInfo?: InputMaybe<PaymentsCheckout_BillingInfoInput>;
  /** Payment processor params used to initialize this CheckoutIntent. */
  paymentProcessorInitializeParams?: InputMaybe<PaymentsCheckout_PaymentProcessorInitializeParamsInput>;
  /** Whether to save the payment method associated with this CheckoutIntent. */
  savePaymentMethod?: Scalars['Boolean'];
};

/** Failure result of a CheckoutIntent initialization. */
export type PaymentsCheckout_InitializeCheckoutIntentFailure = {
  __typename?: 'PaymentsCheckout_InitializeCheckoutIntentFailure';
  /** Error details of a CheckoutIntent initialization. */
  errors: Array<PaymentsCheckout_Error>;
};

/** Input for initializing a CheckoutIntent. */
export type PaymentsCheckout_InitializeCheckoutIntentInput = {
  /** Body for initializing a CheckoutIntent. */
  body?: InputMaybe<PaymentsCheckout_InitializeBodyInput>;
  /** Cart ID in which to initialize a CheckoutIntent for. */
  cartId: Scalars['ID'];
  /** What Payment Processor ID to use for this CheckoutIntent. */
  paymentProcessorId?: InputMaybe<PaymentsCheckout_PaymentProcessorId>;
  /** Privileged checkout options. */
  privilegedOptions?: InputMaybe<PaymentsCheckout_PrivilegedInitializeCheckoutOptions>;
  /** Whether to use sandbox for checkout. */
  sandbox?: Scalars['Boolean'];
};

/** The result of a CheckoutIntent initialization. */
export type PaymentsCheckout_InitializeCheckoutIntentResult = PaymentsCheckout_InitializeCheckoutIntentFailure | PaymentsCheckout_InitializeCheckoutIntentSuccess;

/** Successful result of a CheckoutIntent initialization. */
export type PaymentsCheckout_InitializeCheckoutIntentSuccess = {
  __typename?: 'PaymentsCheckout_InitializeCheckoutIntentSuccess';
  /** A newly initialized (or existing PENDING) CheckoutIntent. */
  checkoutIntent: PaymentsCheckout_CheckoutIntent;
};

/** Failure result of initialization with payment method. */
export type PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodFailure = {
  __typename?: 'PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodFailure';
  /** Error details of an initialization with payment method.. */
  errors: Array<PaymentsCheckout_Error>;
};

/** Input for initializing a CheckoutIntent with a payment method. */
export type PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodInput = {
  /** Flag to indicate whether to wait for user input to submit checkout. */
  autoSubmit?: Scalars['Boolean'];
  /** Cart ID in which to initialize a CheckoutIntent for. */
  cartId: Scalars['ID'];
  /** ID for payment method being used to initialize CheckoutIntent. */
  paymentMethodId: Scalars['ID'];
  /** Privileged checkout options. */
  privilegedOptions?: InputMaybe<PaymentsCheckout_PrivilegedInitializeCheckoutOptions>;
};

/** The result of a CheckoutIntent initialization with payment method. */
export type PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodResult = PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodFailure | PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodSuccess;

/** Successful result of an initialization with payment method. */
export type PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodSuccess = {
  __typename?: 'PaymentsCheckout_InitializeCheckoutIntentWithPaymentMethodSuccess';
  /** A newly initialized CheckoutIntent. */
  checkoutIntent: PaymentsCheckout_CheckoutIntent;
};

/** The charging scheme that represents a simple one time checkout. */
export type PaymentsCheckout_OneTimeChargingScheme = {
  __typename?: 'PaymentsCheckout_OneTimeChargingScheme';
  /** Dummy field. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Details from the Payment Processor required to render the checkout form for a learner. */
export type PaymentsCheckout_PaymentProcessorCheckoutContextEntry = {
  __typename?: 'PaymentsCheckout_PaymentProcessorCheckoutContextEntry';
  /** The key of a PaymentProcessorCheckoutContextEntry. */
  key: Scalars['String'];
  /** The value of a PaymentProcessorCheckoutContextEntry. */
  value: Scalars['String'];
};

/** Details of a Payment Processor exception. */
export type PaymentsCheckout_PaymentProcessorExceptionDetails = {
  __typename?: 'PaymentsCheckout_PaymentProcessorExceptionDetails';
  /** The error code from the payment processor, if available. */
  code?: Maybe<Scalars['String']>;
  /** The error message from the payment processor. */
  message: Scalars['String'];
};

/**
 * ID of the Payment Processor being used for a CheckoutIntent.
 *
 * TODO: Update to use Payments_PaymentProcessorId
 */
export const PaymentsCheckout_PaymentProcessorId = {
  /** Braintree Payment processor ID. */
  Braintree: 'BRAINTREE',
  /** DLOCAL Payment Processor ID. */
  Dlocal: 'DLOCAL',
  /** Razorpay Payment Processor ID. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge-at-will Payment Processor ID. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Stripe Bv consumer Payment processor ID. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe consumer Payment processor ID. */
  StripeConsumer: 'STRIPE_CONSUMER'
} as const;

export type PaymentsCheckout_PaymentProcessorId = typeof PaymentsCheckout_PaymentProcessorId[keyof typeof PaymentsCheckout_PaymentProcessorId];
/** Payment processor params used to initialize the checkout. */
export type PaymentsCheckout_PaymentProcessorInitializeParamsInput = {
  /** Input params for Razorpay charge-at-will flow. */
  razorpayChargeAtWillParams?: InputMaybe<PaymentsCheckout_RazorpayChargeAtWillInitializeParams>;
};

/** Payment processor params used to submit the checkout. */
export type PaymentsCheckout_PaymentProcessorSubmitParamsInput = {
  /** Braintree subscription checkout params. */
  braintreeSubscriptionSubmitParams?: InputMaybe<PaymentsCheckout_BraintreeSubscriptionSubmitParams>;
  /** Dlocal checkout params. */
  dlocalSubmitParams?: InputMaybe<PaymentsCheckout_DlocalCheckoutParams>;
  /** Razorpay subscription submit params. */
  razorpaySubscriptionSubmitParams?: InputMaybe<PaymentsCheckout_RazorpaySubscriptionSubmitParams>;
};

/** The details of a percentage off promotion. */
export type PaymentsCheckout_PercentageOffPromotion = {
  __typename?: 'PaymentsCheckout_PercentageOffPromotion';
  /** The percentage in which to discount the CheckoutIntent amount by. */
  percentageOff: Scalars['String'];
};

/** Privileged CheckoutIntent initialization options. Only allowed for Privileged users. */
export type PaymentsCheckout_PrivilegedInitializeCheckoutOptions = {
  /** Whether to bypass validations for a CheckoutIntent. */
  bypassValidations?: Scalars['Boolean'];
};

/** Promotion details in which to apply to a Checkout Intent. */
export type PaymentsCheckout_Promotion = PaymentsCheckout_FlatDiscountPromotion | PaymentsCheckout_FreeTrialPromotion | PaymentsCheckout_PercentageOffPromotion;

/** Razorpay Charge-at-will input params. */
export type PaymentsCheckout_RazorpayChargeAtWillInitializeParams = {
  /** Selected payment method used to initialize the Razorpay checkout. */
  paymentMethod: PaymentsCheckout_RazorpayChargeAtWillPaymentMethod;
};

/** Payment method used to make the authorisation Razorpay charge-at-will transaction. */
export const PaymentsCheckout_RazorpayChargeAtWillPaymentMethod = {
  /** Razorpay Cards. */
  Card: 'CARD',
  /** Razorpay UPI (Unified Payments Interface). */
  Upi: 'UPI'
} as const;

export type PaymentsCheckout_RazorpayChargeAtWillPaymentMethod = typeof PaymentsCheckout_RazorpayChargeAtWillPaymentMethod[keyof typeof PaymentsCheckout_RazorpayChargeAtWillPaymentMethod];
/** Razorpay subscription submit params. */
export type PaymentsCheckout_RazorpaySubscriptionSubmitParams = {
  /** Razorpay payment ID. */
  razorpayPaymentId: Scalars['ID'];
  /** Razorpay signature. */
  razorpaySignature: Scalars['String'];
  /** Razorpay subscription ID. */
  razorpaySubscriptionId: Scalars['ID'];
};

/** The charging scheme that represents a recurring checkout. */
export type PaymentsCheckout_RecurringChargingScheme = {
  __typename?: 'PaymentsCheckout_RecurringChargingScheme';
  /** The cadence in which to charge the CheckoutIntent. */
  chargingCadence: SharedOwnableProduct_BillingCycle;
  /** The number of billing cycles to charge the CheckoutIntent for. If not provided then it will be charged indefinitely. */
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
};

/** The next action required of the learner from a Payment Processor. */
export type PaymentsCheckout_RequiredAction = PaymentsCheckout_RequiredActionCollectPayment | PaymentsCheckout_RequiredActionPollForCheckoutResults | PaymentsCheckout_RequiredActionReviewAndSubmit | PaymentsCheckout_RequiredActionUrlRedirect;

/** Indicates that the client needs to collect payment from the learner (either via C2S or S2S). */
export type PaymentsCheckout_RequiredActionCollectPayment = {
  __typename?: 'PaymentsCheckout_RequiredActionCollectPayment';
  /** Dummy field. The payment processor details required to render a form are provided on the CheckoutIntent object. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Indicates that the client needs to poll the backend for the updated CheckoutIntent. */
export type PaymentsCheckout_RequiredActionPollForCheckoutResults = {
  __typename?: 'PaymentsCheckout_RequiredActionPollForCheckoutResults';
  /** Dummy field. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Indicates that the client should review and submit the checkout as a next step. */
export type PaymentsCheckout_RequiredActionReviewAndSubmit = {
  __typename?: 'PaymentsCheckout_RequiredActionReviewAndSubmit';
  /** Dummy field. The payment processor details required to render a form are provided on the CheckoutIntent object. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Indicates that the client needs to redirect the user to the given url to processed the final checkout. */
export type PaymentsCheckout_RequiredActionUrlRedirect = {
  __typename?: 'PaymentsCheckout_RequiredActionUrlRedirect';
  /** redirect url */
  url: Scalars['URL'];
};

/** The state of a CheckoutIntent. */
export const PaymentsCheckout_State = {
  /**
   * The CheckoutIntent is awaiting for a result to be returned back asynchronously from the
   * Payment Processor to our backend.
   */
  AwaitingResult: 'AWAITING_RESULT',
  /** The CheckoutIntent is no longer valid and cannot be used for payment. */
  Expired: 'EXPIRED',
  /** The CheckoutIntent is complete, in that a payment has successfully been made. */
  Paid: 'PAID',
  /**
   * The CheckoutIntent requires further action from the learner in order to progress.
   * The action required can be found in the `nextAction` field of the CheckoutIntent.
   */
  RequiresAction: 'REQUIRES_ACTION'
} as const;

export type PaymentsCheckout_State = typeof PaymentsCheckout_State[keyof typeof PaymentsCheckout_State];
/** Failure result of a CheckoutIntent submission request. */
export type PaymentsCheckout_SubmitCheckoutIntentFailure = {
  __typename?: 'PaymentsCheckout_SubmitCheckoutIntentFailure';
  /** Error details of a CheckoutIntent submission request. */
  errors: Array<PaymentsCheckout_Error>;
};

/** Input for submitting details for a S2S (server to server) checkout step. */
export type PaymentsCheckout_SubmitCheckoutIntentInput = {
  /** ID of the CheckoutIntent in which to submit. */
  checkoutIntentId: Scalars['ID'];
  /**
   * Payment Processor specific data necessary to submit a S2S checkout step in JSON format.
   * @deprecated Migrated to paymentProcessorSubmitParams
   */
  paymentDetails?: InputMaybe<Scalars['String']>;
  /** Payment Processor specific data necessary to submit a S2S checkout step. */
  paymentProcessorSubmitParams?: InputMaybe<PaymentsCheckout_PaymentProcessorSubmitParamsInput>;
};

/** The result of a CheckoutIntent submission request. */
export type PaymentsCheckout_SubmitCheckoutIntentResult = PaymentsCheckout_SubmitCheckoutIntentFailure | PaymentsCheckout_SubmitCheckoutIntentSuccess;

/** Successful result of a CheckoutIntent submission request. */
export type PaymentsCheckout_SubmitCheckoutIntentSuccess = {
  __typename?: 'PaymentsCheckout_SubmitCheckoutIntentSuccess';
  /** Updated CheckoutIntent from a submission request. */
  checkoutIntent: PaymentsCheckout_CheckoutIntent;
};

/** The details of the taxes applied. */
export type PaymentsCheckout_TaxDetails = {
  __typename?: 'PaymentsCheckout_TaxDetails';
  /**
   * The amount of tax that will be charged for this CheckoutIntent.
   *
   * The currency between this value and the originalAmount should match.
   */
  amount: MonetaryAmount;
  /** The tax treatment behavior for this CheckoutIntent. */
  behavior: Payments_TaxBehavior;
  /** The tax rate that will be charged for this CheckoutIntent in decimal form. For example, "0.1" for 10%. */
  rate: Scalars['String'];
};

/** Update body for a CheckoutIntent update request. */
export type PaymentsCheckout_UpdateBodyInput = {
  /** Billing information to update the CheckoutIntent with. */
  billingInfo?: InputMaybe<PaymentsCheckout_BillingInfoInput>;
  /** Whether to save the payment method associated with this CheckoutIntent. */
  savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
};

/** Failure result of a CheckoutIntent update request. */
export type PaymentsCheckout_UpdateCheckoutIntentFailure = {
  __typename?: 'PaymentsCheckout_UpdateCheckoutIntentFailure';
  /** Error details of a CheckoutIntent update request. */
  errors: Array<PaymentsCheckout_Error>;
};

/** Input for updating a CheckoutIntent. */
export type PaymentsCheckout_UpdateCheckoutIntentInput = {
  /** ID of the CheckoutIntent in which to update. */
  checkoutIntentId: Scalars['ID'];
  /** The details in which to update the CheckoutIntent with. */
  updateBody: PaymentsCheckout_UpdateBodyInput;
};

/** The result of a CheckoutIntent update request. */
export type PaymentsCheckout_UpdateCheckoutIntentResult = PaymentsCheckout_UpdateCheckoutIntentFailure | PaymentsCheckout_UpdateCheckoutIntentSuccess;

/** Successful result of a CheckoutIntent update request. */
export type PaymentsCheckout_UpdateCheckoutIntentSuccess = {
  __typename?: 'PaymentsCheckout_UpdateCheckoutIntentSuccess';
  /** The updated CheckoutIntent as a result of the update request. */
  checkoutIntent: PaymentsCheckout_CheckoutIntent;
};

/** Failure result of ValidateCheckoutIntent request. */
export type PaymentsCheckout_ValidateCheckoutIntentFailure = {
  __typename?: 'PaymentsCheckout_ValidateCheckoutIntentFailure';
  /** Error details of validate CheckoutIntent request. */
  errors: Array<PaymentsCheckout_Error>;
};

/** The result of a ValidateCheckoutIntent request. */
export type PaymentsCheckout_ValidateCheckoutIntentResult = PaymentsCheckout_ValidateCheckoutIntentFailure | PaymentsCheckout_ValidateCheckoutIntentSuccess;

/** Successful result of ValidateCheckoutIntent request. */
export type PaymentsCheckout_ValidateCheckoutIntentSuccess = {
  __typename?: 'PaymentsCheckout_ValidateCheckoutIntentSuccess';
  /** checkoutIntent is ready for pay without validation errors */
  _: Scalars['Boolean'];
};

/** List of all queries */
export type PaymentsReportingQueries = {
  __typename?: 'PaymentsReportingQueries';
  /**
   * Download specified DLocal settlement report files as a zip archive.
   * All DLocal files are in the same S3 folder, so only file names are needed.
   */
  downloadDlocalSettlementReports?: Maybe<PaymentsReporting_DownloadFilesResponse>;
  /**
   * Generate a new package containing only the selected files from a reconciliation package and
   * provide a pre-signed URL to download it.
   */
  downloadReconciliationPackage?: Maybe<PaymentsReporting_DownloadReconciliationPackageResponse>;
  /** Search for payment reporting packages by date, and optionally target environment */
  queryAvailablePackagesByNamePrefix?: Maybe<PaymentsReporting_AvailablePackagesResponse>;
  /**
   * List available DLocal settlement report files within the specified date range.
   * Returns a flat list of files with metadata (file name, S3 path, date, etc.).
   */
  queryDlocalSettlementReportsByDateRange?: Maybe<PaymentsReporting_DLocalFilesResponse>;
};


/** List of all queries */
export type PaymentsReportingQueriesDownloadDlocalSettlementReportsArgs = {
  filesToDownload: Array<Scalars['String']>;
};


/** List of all queries */
export type PaymentsReportingQueriesDownloadReconciliationPackageArgs = {
  filesToDownload: Array<Scalars['String']>;
  packageName: Scalars['String'];
  targetEnvironment?: PaymentsReporting_TargetEnvironment;
};


/** List of all queries */
export type PaymentsReportingQueriesQueryAvailablePackagesByNamePrefixArgs = {
  packageNamePrefix: Scalars['String'];
  targetEnvironment?: InputMaybe<PaymentsReporting_TargetEnvironment>;
};


/** List of all queries */
export type PaymentsReportingQueriesQueryDlocalSettlementReportsByDateRangeArgs = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

/** Response to query to retrieve all packages matching some search query */
export type PaymentsReporting_AvailablePackagesResponse = {
  __typename?: 'PaymentsReporting_AvailablePackagesResponse';
  /**
   * List of packages that match the search query.
   * May be an empty list, but will not be null, and will not have null values.
   */
  availablePackages: Array<PaymentsReporting_Package>;
};

/** Represents a single DLocal settlement report file with metadata */
export type PaymentsReporting_DLocalFile = {
  __typename?: 'PaymentsReporting_DLocalFile';
  /** Date extracted from the filename (YYYY-MM-DD format) */
  fileDate: Scalars['Date'];
  /** Name of the file (e.g., "664388_Settlement_report_coursera_20260428_865219.csv") */
  fileName: Scalars['String'];
  /** Timestamp when this file was last modified in S3 */
  lastModified: Scalars['DateTime'];
  /** Full S3 path to the file */
  s3Path: Scalars['String'];
};

/** Response containing a list of DLocal settlement report files */
export type PaymentsReporting_DLocalFilesResponse = {
  __typename?: 'PaymentsReporting_DLocalFilesResponse';
  /**
   * List of DLocal settlement report files matching the query criteria.
   * May be an empty list, but will not be null, and will not have null values.
   */
  files: Array<PaymentsReporting_DLocalFile>;
};

/** Response containing the download URL for requested files */
export type PaymentsReporting_DownloadFilesResponse = {
  __typename?: 'PaymentsReporting_DownloadFilesResponse';
  /** Pre-signed S3 URL to download the zip archive containing the requested files */
  downloadUrl: Scalars['URL'];
  /** The name of the generated zip file */
  zipFileName: Scalars['String'];
};

/**
 * Response to query to retrieve the download link for the files selected from the
 * reconciliation package query
 */
export type PaymentsReporting_DownloadReconciliationPackageResponse = {
  __typename?: 'PaymentsReporting_DownloadReconciliationPackageResponse';
  /** The name of the package generated containing the files selected from the reconciliation package. */
  downloadPackageName: Scalars['String'];
  /**
   * The pre-signed URL from S3 to download the package containing all files selected from
   * reconciliation package.
   */
  downloadPackageUrl: Scalars['URL'];
};

/** Represents one package of payment reporting files */
export type PaymentsReporting_Package = {
  __typename?: 'PaymentsReporting_Package';
  /**
   * List of files in the package.
   * May be an empty list, but will not be null, and will not have nulls.
   */
  filesInPackage: Array<PaymentsReporting_ReportFile>;
  /** The name of the package. */
  packageName: Scalars['String'];
  /** Indicates whether this package is from production or development run. */
  targetEnvironment: PaymentsReporting_TargetEnvironment;
};

/** Represents one file of the payment reporting package */
export type PaymentsReporting_ReportFile = {
  __typename?: 'PaymentsReporting_ReportFile';
  /** Name of the file, e.g. only `netsuite.created.csv`. */
  fileName: Scalars['String'];
  /** Full path of the file on S3. */
  fileS3FullPath: Scalars['String'];
  /** The package this file is in. */
  packageName: Scalars['String'];
  /** Indicates whether this file is from production or development run. */
  targetEnvironment: PaymentsReporting_TargetEnvironment;
  /** The timestamp when this file was last updated. */
  writtenAt: Scalars['DateTime'];
};

/**
 * paymentsreporting GraphQL Schema
 * Different targets where the payment reporting jobs can be run
 */
export const PaymentsReporting_TargetEnvironment = {
  /** To be used for test runs during development or debugging */
  Development: 'DEVELOPMENT',
  /** To be used for production runs to be delivered to finance */
  Production: 'PRODUCTION'
} as const;

export type PaymentsReporting_TargetEnvironment = typeof PaymentsReporting_TargetEnvironment[keyof typeof PaymentsReporting_TargetEnvironment];
/** Billing information in which to update a CheckoutIntent with. */
export type Payments_BillingInfoInput = {
  /** Country ISO code of the billing info (ISO 3166-1 alpha-3). */
  countryIsoCode: Scalars['String'];
  /** Postal code (ZIP code in the US) of the address. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State code of the billing info (preferably the subdivision of ISO 3166-2, but this is not always possible). */
  state?: InputMaybe<Scalars['String']>;
};

/** Card Brand */
export const Payments_CardBrand = {
  /** American Express - Premium charge and credit cards known for high-end rewards and services */
  AmericanExpress: 'AMERICAN_EXPRESS',
  /** Cartes Bancaires - The French national debit card system, widely used in France */
  CartesBancaires: 'CARTES_BANCAIRES',
  /** Diners Club - International charge card and credit card company, one of the oldest card brands */
  DinersClub: 'DINERS_CLUB',
  /** Discover - American digital payment service and credit card company with cashback rewards */
  Discover: 'DISCOVER',
  /** EFTPOS Australia - Electronic funds transfer at point of sale system primarily used in Australia */
  EftposAustralia: 'EFTPOS_AUSTRALIA',
  /** Interac - Canadian debit card system and payment network widely used across Canada */
  Interac: 'INTERAC',
  /** JCB (Japan Credit Bureau) - Japanese credit card company and payment brand, widely accepted in Asia */
  Jcb: 'JCB',
  /** Mastercard - Global payment technology company and one of the world's largest payment card brands */
  Mastercard: 'MASTERCARD',
  /** Other card brand - Used when the brand cannot be determined */
  Other: 'OTHER',
  /** UnionPay - Chinese financial services corporation and payment card brand, dominant in China */
  UnionPay: 'UNION_PAY',
  /** Visa - American multinational financial services corporation and the world's largest payment card brand */
  Visa: 'VISA'
} as const;

export type Payments_CardBrand = typeof Payments_CardBrand[keyof typeof Payments_CardBrand];
/** Card payment method details. */
export type Payments_CardPaymentMethodDetails = {
  __typename?: 'Payments_CardPaymentMethodDetails';
  /** The brand (or network) of the card. */
  brand: Scalars['String'];
  /** The brand type of the card. */
  brandType?: Maybe<Payments_CardBrand>;
  /** Expiry month of the card. For example, 8 for August. */
  expiryMonth?: Maybe<Scalars['Int']>;
  /** Expiry year of the card. For example, 2050. */
  expiryYear?: Maybe<Scalars['Int']>;
  /** Last 4 digits of the card. */
  last4: Scalars['String'];
  /** Wallet type. For example, GOOGLE_PAY. */
  walletType?: Maybe<Payments_WalletType>;
};

/**
 * An instance of a Cart, used for checkout, refunds, renewals, etc. on Coursera's platform. Some
 * fields defined in Cart.scala in infra-services are omitted here because they're not relevant
 * to the Java implementations yet
 */
export type Payments_Cart = {
  __typename?: 'Payments_Cart';
  /** Country in which the cart was checked out. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** The Timestamp of when the cart was created at. */
  createdAt: Scalars['DateTime'];
  /** Id of the currency used to check out the cart */
  currencyId: Scalars['ID'];
  /** The fxRate used to convert to USD (should be empty if currency is USD) */
  fxRateId?: Maybe<Scalars['ID']>;
  /** Unique cart identifier */
  id: Scalars['ID'];
  /** The Timestamp of when the cart was last updated at. */
  lastUpdatedAt: Scalars['DateTime'];
  /** Id of the user for whom the cart was created */
  userId: Scalars['ID'];
};

/**
 * Components of the cart that a user is interested in checking out. Note that the following fields
 * were omitted from this model:
 *  - productPriceIdV2: This field is not currently used by the FE.
 *  - productActionMetadata: This field is more of a BE concept that we use for internal requests
 *    like Enterprise, Coursera Plus, etc..., rather than requests exposed on the FE. Also, the FE can
 *    construct a productSkus.v1 request using productType + productItemId to display the ownership
 *    duration on the checkout page, which is further reason why this field is
 *    is not necessary.
 */
export type Payments_CartItem = {
  __typename?: 'Payments_CartItem';
  /** The amount of the cart item after discount, NOT including taxes if any. */
  amount: Scalars['String'];
  /** The parent cart's id */
  cartId: Scalars['ID'];
  /** The cart item that is being refunded by this cart item. If none, this is a purchase. */
  cartItemIdToRefund?: Maybe<Scalars['ID']>;
  /** Optional coupon id */
  couponId?: Maybe<Scalars['ID']>;
  /** Cart item id */
  id: Scalars['ID'];
  /** Mirrors the CartItemMetadata courier enum in infra-services. */
  metadata?: Maybe<Payments_CartItemMetadata>;
  /** The amount of the cart item before discount. */
  originalAmount: Scalars['String'];
  /** The cart item container (e.g. specialization) */
  parentCartItemId?: Maybe<Scalars['ID']>;
  /** The ID to the product pricing table, which has the amount to charge/refund. */
  priceId?: Maybe<Scalars['ID']>;
  /**
   * What action the user wants to take on the product, such as "buy".
   * Optional since the next generation product config system intends to deprecate this concept.
   */
  productAction?: Maybe<Payments_ProductAction>;
  /**
   * What the user wants to buy/refund.
   * Optional since the next generation product config system intends to deprecate this concept.
   */
  productId?: Maybe<Payments_ProductId>;
};

/**
 * Resembles the CartItemMetadata courier enum in infra-services. Note that the model for
 * VerifiedCertificateCartItemMetadata is empty. The reason for this is because the FE does not
 * currently use the VerifiedCertificateCartItemMetadata model for standalone course
 * createCart/checkout. Some of the primary usages of this model include: (1) Standalone course carts
 * created via IAP, (2) Standalone course carts created via programEnrollments.v2#changeProductState,
 * and (3) Standalone course carts created by E2E test accounts. Each of these flows are outside the
 * scope of the standard B2C checkout flows that checkout-gateway handles, so we've opted to leave
 * this model as empty.
 * Full context: https://coursera.slack.com/archives/C05PKUWL9TK/p1699030689730829?thread_ts=1698947405.339869&cid=C05PKUWL9TK
 * TODO: Before FE implementation starts, remove legacy concepts from this metadata model so that we
 * only return next gen data. For example, we currently have Payments_SpecializationCartItemMetadata
 * and Payments_SpecializationCartItemMetadata. This is an issue because this model mixes the “what you’re
 * getting” with the “how you’re getting it”. Specifically, it mixes the product and payment scheme
 * together. Ideally, we would only have Payments_SpecializationCartItemMetadata, which is a container for
 * both Specialization one time payment checkout and s12n subscription checkout post fulfillment
 * side effects.
 */
export type Payments_CartItemMetadata = Payments_CourseraPlusCartItemMetadata | Payments_CourseraPlusSubscriptionCartItemMetadata | Payments_CourseraTierLiteCartItemMetadata | Payments_CredentialTrackSubscriptionCartItemMetadata | Payments_SpecializationCartItemMetadata | Payments_SpecializationSubscriptionCartItemMetadata | Payments_VerifiedCertificateCartItemMetadata;

/** Cashapp payment method details. */
export type Payments_CashappPaymentMethodDetails = {
  __typename?: 'Payments_CashappPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Metadata for CourseraPlus prepaid */
export type Payments_CourseraPlusCartItemMetadata = {
  __typename?: 'Payments_CourseraPlusCartItemMetadata';
  /** We should only enroll them in at most one content while they checkout Coursera Plus prepaid */
  productEnrollmentInformation?: Maybe<Payments_ProductEnrollmentInformation>;
};

/**
 * Metadata for a CourseraPlusSubscription subscription. Note that this model still has "product type
 * (CourseraPlus+ payment scheme (Subscription)" verbiage. For context, one of the goals for Next Gen
 * Product config phase 4 is the deprecation of these legacy concepts, however, certain fields such
 * as "paymentType" are heavily tied to subscription-based payment schemes. As a result, we didn't
 * consolidate this model with CourseraPlusCartItemMetadata since we want to avoid the coupling of
 * subscription-based concepts with other payment schemes.
 */
export type Payments_CourseraPlusSubscriptionCartItemMetadata = {
  __typename?: 'Payments_CourseraPlusSubscriptionCartItemMetadata';
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: Maybe<Payments_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout Coursera Plus */
  productEnrollmentInformation?: Maybe<Payments_ProductEnrollmentInformation>;
  /** Upgrade variants for Coursera Plus subscriptions. */
  upgradeVariants?: Maybe<Payments_CourseraPlusSubscriptionUpgradeVariants>;
};

/** Upgrade variants for Coursera Plus subscriptions. */
export type Payments_CourseraPlusSubscriptionUpgradeVariants = {
  __typename?: 'Payments_CourseraPlusSubscriptionUpgradeVariants';
  /** Metadata for an email regarding this variant */
  emailParameters?: Maybe<Payments_UpgradeEmailParameters>;
  /** Overridden number of trial days */
  freeTrialInDaysOverride?: Maybe<Scalars['Int']>;
  /** Promo code id, a.k.a. promotion name */
  nextBillingPromotion?: Maybe<Scalars['String']>;
  /** Variant name */
  priceVariant?: Maybe<Payments_PriceVariant>;
};

/** Metadata for a CourseraTierLite subscription */
export type Payments_CourseraTierLiteCartItemMetadata = {
  __typename?: 'Payments_CourseraTierLiteCartItemMetadata';
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: Maybe<Payments_SubscriptionCartItemMetadataPaymentType>;
  /** We should only enroll them in at most one content while they checkout Coursera Lite */
  productEnrollmentInformation?: Maybe<Payments_ProductEnrollmentInformation>;
};

/**
 * Metadata for a CredentialTrackSubscription cart item. Note that we don’t need `paymentType` since
 * this is only for differentiating between initial checkout and renewals. The
 * checkout-gateway-application only handles initial checkouts for now.
 */
export type Payments_CredentialTrackSubscriptionCartItemMetadata = {
  __typename?: 'Payments_CredentialTrackSubscriptionCartItemMetadata';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** GCash payment method details (DLocal, Philippines). */
export type Payments_GCashPaymentMethodDetails = {
  __typename?: 'Payments_GCashPaymentMethodDetails';
  /** The payer's email address. */
  email?: Maybe<Scalars['String']>;
  /** The payer's full name. */
  name?: Maybe<Scalars['String']>;
  /** The payer's phone number. */
  phone?: Maybe<Scalars['String']>;
};

/** Indonesia local wallet payment method details. (Dana or BRI Direct Debit) */
export type Payments_IdLocalWalletPaymentMethodDetails = {
  __typename?: 'Payments_IdLocalWalletPaymentMethodDetails';
  /** The payer's email address. */
  email?: Maybe<Scalars['String']>;
  /** The payer's full name. */
  name?: Maybe<Scalars['String']>;
  /** The payer's phone number. */
  phone?: Maybe<Scalars['String']>;
};

/** Klarna payment method details. */
export type Payments_KlarnaPaymentMethodDetails = {
  __typename?: 'Payments_KlarnaPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Link payment method details. */
export type Payments_LinkPaymentMethodDetails = {
  __typename?: 'Payments_LinkPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Mercado Pago payment method details (DLocal). */
export type Payments_MercadoPagoPaymentMethodDetails = {
  __typename?: 'Payments_MercadoPagoPaymentMethodDetails';
  /** The payer's document (tax ID for Mexico). */
  document?: Maybe<Scalars['String']>;
  /** The payer's email address. */
  email?: Maybe<Scalars['String']>;
  /** The payer's full name. */
  name?: Maybe<Scalars['String']>;
};

/** OVO payment method details (DLocal). */
export type Payments_OvoPaymentMethodDetails = {
  __typename?: 'Payments_OVOPaymentMethodDetails';
  /** The payer's email address. */
  email?: Maybe<Scalars['String']>;
  /** The payer's full name. */
  name?: Maybe<Scalars['String']>;
  /** The payer's phone number. */
  phone?: Maybe<Scalars['String']>;
};

/** Other payment method details. */
export type Payments_OtherPaymentMethodDetails = {
  __typename?: 'Payments_OtherPaymentMethodDetails';
  /** Name of payment method. */
  methodName: Scalars['String'];
};

/** Object for a PaymentMethod. */
export type Payments_PaymentMethod = {
  __typename?: 'Payments_PaymentMethod';
  /** Billing info object containing country, state, postal code. */
  billingInfo: Payments_PaymentTransactionBillingInfo;
  /** Cart country code for Dlocal payment method handling. */
  cartCountryCode?: Maybe<Scalars['String']>;
  /** Timestamp for when this payment method was created. */
  createdAt: Scalars['DateTime'];
  /** Currency code for Dlocal payment method handling. */
  currency?: Maybe<Scalars['String']>;
  /** Timestamp for when this payment method was deleted. Is null if not deleted. */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Details about payment method. */
  details: Payments_PaymentMethodDetails;
  /** ID of payment method. */
  id: Scalars['ID'];
  /** If set, the maximum amount that can be charged to this payment method (no limits apply otherwise). */
  maxAmount?: Maybe<MonetaryAmount>;
  /** Payment method nickname. */
  nickname?: Maybe<Scalars['String']>;
  /** Customer id on the payment processor. */
  paymentProcessorCustomerId: Scalars['ID'];
  /** Payment processor ID. */
  paymentProcessorId: Payments_PaymentProcessorId;
  /** Payment method id on the payment processor. */
  paymentProcessorPaymentMethodId: Scalars['ID'];
  /** Type of payment method. */
  type: Payments_PaymentMethodType;
  /** Timestamp for when this payment method was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Coursera user. */
  user: User_User;
};

/** Union type of different payment method details. */
export type Payments_PaymentMethodDetails = Payments_CardPaymentMethodDetails | Payments_CashappPaymentMethodDetails | Payments_GCashPaymentMethodDetails | Payments_IdLocalWalletPaymentMethodDetails | Payments_KlarnaPaymentMethodDetails | Payments_LinkPaymentMethodDetails | Payments_MercadoPagoPaymentMethodDetails | Payments_OvoPaymentMethodDetails | Payments_OtherPaymentMethodDetails | Payments_PaypalPaymentMethodDetails | Payments_PixAutomaticPaymentMethodDetails | Payments_PixPaymentMethodDetails | Payments_UnknownPaymentMethodDetails | Payments_UpiPaymentMethodDetails;

/** Enum type for different payment methods. */
export const Payments_PaymentMethodType = {
  /** Card payment method type. */
  Card: 'CARD',
  /** Cashapp payment method type. */
  Cashapp: 'CASHAPP',
  /** GCash payment method type (DLocal, Philippines). */
  Gcash: 'GCASH',
  /** Indonesia local wallet payment method type. */
  IdLocalWallet: 'ID_LOCAL_WALLET',
  /** Klarna payment method type. */
  Klarna: 'KLARNA',
  /** Link payment method type. */
  Link: 'LINK',
  /** MercadoPago payment method type. */
  Mercadopago: 'MERCADOPAGO',
  /** Other payment method type. */
  Other: 'OTHER',
  /** OVO payment method type. */
  Ovo: 'OVO',
  /** PayPal payment method type. */
  Paypal: 'PAYPAL',
  /** Pix payment method type (Stripe). */
  Pix: 'PIX',
  /** PIX Automatic payment method type (DLocal). */
  PixAutomatic: 'PIX_AUTOMATIC',
  /** Unknown payment method type. */
  Unknown: 'UNKNOWN',
  /** UPI payment method type. */
  Upi: 'UPI'
} as const;

export type Payments_PaymentMethodType = typeof Payments_PaymentMethodType[keyof typeof Payments_PaymentMethodType];
/** Enum for payment processor id. */
export const Payments_PaymentProcessorId = {
  /** IAP Production. */
  AppleInapp: 'APPLE_INAPP',
  /** IAP Sandbox. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree Production. */
  Braintree: 'BRAINTREE',
  /** Braintree Sandbox. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** ID used for manual refunds */
  CourseraManual: 'COURSERA_MANUAL',
  /** dLocal Production. */
  Dlocal: 'DLOCAL',
  /** dLocal Sandbox. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx Production. Deprecated. */
  Ebanx: 'EBANX',
  /** Ebanx Sandbox. Deprecated. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent Production. Deprecated. */
  Emergent: 'EMERGENT',
  /** Emergent Sandbox. Deprecated. */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid by Coursera. Deprecated. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play Billing. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Paypal Production. */
  Paypal: 'PAYPAL',
  /** Paypal Sandbox. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay Production. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will Production. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will Sandbox. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay Sandbox. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe Enterprise Production. */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer Production. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer Sandbox. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer Production. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer Sandbox. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe Enterprise WES. Deprecated. */
  StripeEnterpriseWes: 'STRIPE_ENTERPRISE_WES',
  /** Stripe Enterprise WES Sandbox. Deprecated. */
  StripeEnterpriseWesSandbox: 'STRIPE_ENTERPRISE_WES_SANDBOX',
  /** Stripe Enterprise Sandbox. */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** ID used for checkouts with no charge. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type Payments_PaymentProcessorId = typeof Payments_PaymentProcessorId[keyof typeof Payments_PaymentProcessorId];
/** Billing info object containing country, state, postal code. */
export type Payments_PaymentTransactionBillingInfo = {
  __typename?: 'Payments_PaymentTransactionBillingInfo';
  /** Billing country. */
  countryIsoCode: Scalars['String'];
  /** Billing postal code. */
  postalCode?: Maybe<Scalars['String']>;
  /** Billing state. */
  state?: Maybe<Scalars['String']>;
};

/** PayPal payment method details. */
export type Payments_PaypalPaymentMethodDetails = {
  __typename?: 'Payments_PaypalPaymentMethodDetails';
  /** Email associated with the PayPal account. */
  email: Scalars['String'];
};

/** PIX Automatic payment method details (DLocal). */
export type Payments_PixAutomaticPaymentMethodDetails = {
  __typename?: 'Payments_PixAutomaticPaymentMethodDetails';
  /** The payer's document (CPF/CNPJ for Brazil). */
  document?: Maybe<Scalars['String']>;
  /** The payer's email address. */
  email?: Maybe<Scalars['String']>;
  /** The payer's full name. */
  name?: Maybe<Scalars['String']>;
};

/** Pix payment method details (Stripe). */
export type Payments_PixPaymentMethodDetails = {
  __typename?: 'Payments_PixPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Variant name */
export type Payments_PriceVariant = {
  __typename?: 'Payments_PriceVariant';
  /** Variant name */
  variantName: Scalars['String'];
};

/** Product action of a transaction */
export const Payments_ProductAction = {
  /**
   * Buy product action is the primary product action used by the FE.
   * Additional product actions are used to support our internal tool for Learner Services.
   * For the CourseraTierLite rollout, we are skipping internal tool support for the MVP.
   * We will rely on direct API calls if we need to do admin-level refunds.
   */
  Buy: 'BUY'
} as const;

export type Payments_ProductAction = typeof Payments_ProductAction[keyof typeof Payments_ProductAction];
/**
 * Used when users purchase CourseraTierSubscription through an CDP or SDP. After users purchase
 * CourserTierSubscription, we also need to enroll them into the corresponding course or s12n.
 */
export type Payments_ProductEnrollmentInformation = {
  __typename?: 'Payments_ProductEnrollmentInformation';
  /**
   * Users can enroll in courseraTierSubscription through any CDP in an s12n. In this case, the user
   * should get the membership for that course instead of just going through normal s12n
   * enrollment flow which will grant the membership of the first course in the s12n
   */
  courseToGrantMembership?: Maybe<Course_Course>;
  /** The product to enroll with purchasing CourseraTierSubscription */
  productIdToEnroll: Scalars['ID'];
};

/** Sku of a particular tier product */
export type Payments_ProductId = {
  __typename?: 'Payments_ProductId';
  /** Id of the particular product */
  productItemId: Scalars['ID'];
  /** Type of the particular product */
  productType: Payments_ProductType;
};

/**
 * Information for the product promotion.
 * Note that when a coupon ID is present in the cart item, it will also require product promotion
 * information to be present as well.
 */
export type Payments_ProductPromotionInfo = {
  __typename?: 'Payments_ProductPromotionInfo';
  /** Calculated discount amount based on either the discountPercent or the flat amount used */
  discountAmount: Scalars['String'];
  /** Discount Percentage applied, if a discount percent was used (vs a flat discount amount) */
  discountPercent?: Maybe<Scalars['Int']>;
  /** ID of the promotion */
  promotionId: Scalars['ID'];
  /** Name of the promotion */
  promotionName: Scalars['String'];
};

/**
 * Product types. Note that not all of our available product type may be listed here.
 * They may be added as required.
 */
export const Payments_ProductType = {
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'COURSERA_PLUS',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /**
   * Represents MasterTrack one-time payment. Specifically, this is a fairly low-value flow we built
   * as a hack for India EMI payments.
   */
  CredentialTrack: 'CREDENTIAL_TRACK',
  /**
   * CredentialTrackCourse is our abstraction for the individual courses contained in a MasterTrack.
   * When you create a cart for an installments-based MasterTrack checkout (CredentialTrackSubscription)
   * or India prepaid (CredentialTrack) we construct a cart item / fulfillment tree that contains CredentialTrackCourse
   * entities as the leaf nodes.
   */
  CredentialTrackCourse: 'CREDENTIAL_TRACK_COURSE',
  /** Master track subscription, for course work that could count towards a degree */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /** Use for Invalid or deprecated product types */
  Invalid: 'INVALID',
  /**
   * Upon successful s12n subscription cart creation, the child cart items in the learner's validated
   * cart are populated with each of the courses that belong to the s12n, as well as the actual s12n
   * itself. This product type was added in strictly for this use case. Lastly, financial aid cart creation
   * is slightly different, as it will not be handled by checkout-gateway application. This enum value
   * will be cleaned up during phase 5+ of next gen product config.
   */
  Specialization: 'SPECIALIZATION',
  /** The most modern version of one-time payment for s12ns */
  SpecializationPrepaid: 'SPECIALIZATION_PREPAID',
  /** A subscription product that gives access to a s12n and its courses */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION',
  /** Standalone course purchase */
  VerifiedCertificate: 'VERIFIED_CERTIFICATE'
} as const;

export type Payments_ProductType = typeof Payments_ProductType[keyof typeof Payments_ProductType];
/**
 * Metadata for a Specialization item. Note that this model differs from the
 * SpecializationCartItemMetadata model in infra services. For context, during Next Gen
 * Product Config phase 4, we discovered that checkout-gateway-application would not have to support
 * legacy s12n bulk pay, however, we kept Payments_SpecializationCartItemMetadata around so that we
 * could have a convenient way of passing the "courseToGrantMembership" back to the FE for the s12n
 * prepaid case. Please note that this model is not meant to be a 1:1 mirror of the infra services
 * model.
 * Link to infra-services model: https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/payment/SpecializationCartItemMetadata.courier
 */
export type Payments_SpecializationCartItemMetadata = {
  __typename?: 'Payments_SpecializationCartItemMetadata';
  /**
   * The courseToGrantMembership is primarily used in the Specialization prepaid context when the FE
   * wants to fetch the courseId and link the learner to the course home of the specific course they're
   * enrolling into.
   */
  courseToGrantMembership?: Maybe<Course_Course>;
};

/**
 * Metadata for an s12n subscription item. Note that this model still has "product type
 * (Specialization + payment scheme (Subscription)" verbiage. For context, one of the goals for
 * Next Gen Product config phase 4 is the deprecation of these legacy concepts, however, certain
 * fields such as "paymentType" are heavily tied to subscription-based payment schemes. As a result,
 * we didn't consolidate this model with SpecializationCartItemMetadata since we want to avoid the
 * coupling of subscription-based concepts with other payment schemes.
 */
export type Payments_SpecializationSubscriptionCartItemMetadata = {
  __typename?: 'Payments_SpecializationSubscriptionCartItemMetadata';
  /**
   * The courseToGrantMembership is primarily used in the SpecializationSubscription context when the FE
   * wants to fetch the courseId and link the learner to the course home of the specific course they're
   * enrolling into.
   */
  courseToGrantMembership?: Maybe<Course_Course>;
  /** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
  paymentType?: Maybe<Payments_SubscriptionCartItemMetadataPaymentType>;
  /**
   * For purchases like Apple IAP and Google Play billing, the payment processors determine
   * the price to sell, which this field records
   */
  priceOverride?: Maybe<Scalars['String']>;
  /** Flag determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail: Scalars['Boolean'];
};

/** Subscription payment type; Whether it is an initial checkout or a subsequent payment */
export const Payments_SubscriptionCartItemMetadataPaymentType = {
  /**
   * Used to trigger different side effects based off what type of payment a subscription checkout
   * Represents. Right now we only have the need to distinguish between INITIAL_CHECKOUT and
   * SUBSEQUENT_PAYMENT, but we may find a need for other actions like REFUND.
   */
  SubscriptionCartItemMetadataPaymentTypeInitialCheckout: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_INITIAL_CHECKOUT',
  /**
   * Any payment after the initial checkout payment. Deliberately chose not to call it
   * RECURRING_PAYMENT since that means both initial and subsequent payments in the context of our
   * store. Also didn't call it installment because generally we only use that to mean subsequent
   * payment for a terminal subscription.
   */
  SubscriptionCartItemMetadataPaymentTypeSubsequentPayment: 'SUBSCRIPTION_CART_ITEM_METADATA_PAYMENT_TYPE_SUBSEQUENT_PAYMENT'
} as const;

export type Payments_SubscriptionCartItemMetadataPaymentType = typeof Payments_SubscriptionCartItemMetadataPaymentType[keyof typeof Payments_SubscriptionCartItemMetadataPaymentType];
/** The behavior of the tax. */
export const Payments_TaxBehavior = {
  /** The tax is inclusive of the amount. */
  Exclusive: 'EXCLUSIVE',
  /** The tax is exclusive of the amount. */
  Inclusive: 'INCLUSIVE',
  /** No tax is charged. */
  NotCharged: 'NOT_CHARGED'
} as const;

export type Payments_TaxBehavior = typeof Payments_TaxBehavior[keyof typeof Payments_TaxBehavior];
/** Unknown payment method details. */
export type Payments_UnknownPaymentMethodDetails = {
  __typename?: 'Payments_UnknownPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Metadata for an email regarding this variant */
export type Payments_UpgradeEmailParameters = {
  __typename?: 'Payments_UpgradeEmailParameters';
  /** Additional discount promotion code */
  additionalDiscountPromoCode?: Maybe<Scalars['String']>;
  /** Course to display */
  courseToDisplay?: Maybe<Course_Course>;
  /** Upgraded productId */
  upgradedProductId: Payments_ProductId;
};

/** UPI payment method details. */
export type Payments_UpiPaymentMethodDetails = {
  __typename?: 'Payments_UpiPaymentMethodDetails';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * A wrapper around cart that takes price computations into account, including promotions
 * and localization of prices; a cart that has been validated and prepared for checkout by our system.
 * Formerly referred to as CartWithComputed.
 */
export type Payments_ValidatedCart = {
  __typename?: 'Payments_ValidatedCart';
  /** The underlying cart */
  cart: Payments_Cart;
  /** The country iso code for the country in which the cart was checked out. Alpha-2 format, eg "US". */
  countryIsoCode: Scalars['String'];
  /** The currency code in which the cart was checked out */
  currencyCode: Scalars['String'];
  /** Id of the Cart */
  id: Scalars['ID'];
  /** Includes the computed fields that belong to the cart. */
  validatedCartFields: Payments_ValidatedCartFields;
};

/** Includes computed fields that belong to a cart such as amount, and cart items with computed amounts. */
export type Payments_ValidatedCartFields = {
  __typename?: 'Payments_ValidatedCartFields';
  /** The underlying cart items */
  cartItems: Array<Maybe<Payments_ValidatedCartItem>>;
  /** Represents the total cart amount before discounts */
  originalTotalCartAmount: Scalars['String'];
  /** Represents the total amount of the cart including discounts */
  totalCartAmount: Scalars['String'];
};

/**
 * Wrapper around CartItem that takes price computations into account, including promotions
 * and localization of prices. Formerly referred to as CartItemWithComputed.
 */
export type Payments_ValidatedCartItem = {
  __typename?: 'Payments_ValidatedCartItem';
  /** CartItem that is being wrapped */
  cartItem: Payments_CartItem;
  /** CartItem ID */
  id: Scalars['ID'];
  /** Promotion information for this cartItem if applicable */
  promotionInfo?: Maybe<Payments_ProductPromotionInfo>;
};

/**
 * Metadata for a course / verified certificate item. Note that this model currently serves as a
 * placeholder since the FE does not use VerifiedCertificateCartItemMetadata for any relevant B2C
 * checkout flows.
 */
export type Payments_VerifiedCertificateCartItemMetadata = {
  __typename?: 'Payments_VerifiedCertificateCartItemMetadata';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Wallet Type */
export const Payments_WalletType = {
  /** APPLE_PAY */
  ApplePay: 'APPLE_PAY',
  /** GOOGLE_PAY */
  GooglePay: 'GOOGLE_PAY',
  /** LINK */
  Link: 'LINK'
} as const;

export type Payments_WalletType = typeof Payments_WalletType[keyof typeof Payments_WalletType];
/** All pedagogy recommendation queries */
export type PedagogyRecommendationQueries = {
  __typename?: 'PedagogyRecommendationQueries';
  /**
   * intended for determining whether there are recommendations for a branch
   * and their statuses. Pedagogy recommendations will be suggestions for things to change in a course, and
   * does not involve any actual changes to the course.
   *
   * - if PccrRecommendations exist and haven't been reviewed yet, show that banner
   * - otherwise, show pedagogyRecommendations banner based on data from here
   */
  queryLatestPedagogyRecommendationByBranch?: Maybe<PedagogyRecommendation_PedagogyRecommendation>;
};


/** All pedagogy recommendation queries */
export type PedagogyRecommendationQueriesQueryLatestPedagogyRecommendationByBranchArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
};

/** Input to nullify the appliedAt field of the latest pedagogy recommendation of a branch */
export type PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationInput = {
  /** Authoring branch id */
  authoringBranchId: Scalars['ID'];
};

/** Result of nullifying the appliedAt field */
export type PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationResult = {
  __typename?: 'PedagogyRecommendation_NullifyAppliedAtOfLatestRecommendationResult';
  /** Dummy field since type cannot be empty in GraphQL */
  _?: Maybe<Scalars['Boolean']>;
};

/** approval status is removed since applied recommendation are no longer expected to be returned here */
export type PedagogyRecommendation_PedagogyRecommendation = {
  __typename?: 'PedagogyRecommendation_PedagogyRecommendation';
  /**
   * when the recommendation was applied (i.e., converted to actual item draft PCCR recommendations),
   * null if not applied yet
   */
  appliedAt?: Maybe<Scalars['DateTime']>;
  /** Recommendation id */
  id: Scalars['ID'];
  /** when the recommendation was updated at. used to calculate show/hide for user-based dismiss behaviour. */
  lastUpdatedAt: Scalars['DateTime'];
  /** the type of recommendation associated with this entity, determines which banner to show */
  recommendationType: PedagogyRecommendation_RecommendedChangeType;
};

/** category of change recommended */
export const PedagogyRecommendation_RecommendedChangeType = {
  /** recommendation is for a dialog item generation to be added to the course */
  RecommendDialogItemGeneration: 'RECOMMEND_DIALOG_ITEM_GENERATION',
  /** recommendation is for a lab item generation to be added to the course */
  RecommendLabItemGeneration: 'RECOMMEND_LAB_ITEM_GENERATION',
  /** recommendation is for multiple item types generation to be added to the course */
  RecommendMultipleItemTypesGeneration: 'RECOMMEND_MULTIPLE_ITEM_TYPES_GENERATION'
} as const;

export type PedagogyRecommendation_RecommendedChangeType = typeof PedagogyRecommendation_RecommendedChangeType[keyof typeof PedagogyRecommendation_RecommendedChangeType];
/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueries = {
  __typename?: 'PeerReviewAiQueries';
  /** Gets whether the logged in user is for Peer Review AI grading for the given assignment */
  getAiGradingEligibility?: Maybe<PeerReviewAi_AiGradingEligibility>;
  /**
   * Gets all the assignments associated with a course for a logged in user that are eligible for Peer
   * Review AI grading
   */
  getAiGradingEligibilityByCourse: Array<PeerReviewAi_AiGradingAssignmentEligibility>;
  /** Gets the status of a Peer Review AI grading, for a given submission */
  getAiGradingStatus: PeerReviewAi_Status;
  /**
   * Gets all the assignments associated with a course for a logged in user that are eligible for Peer
   * Review AI grading with Text File Uploads
   */
  getFileUploadAiGradingEligibilityByCourse: Array<PeerReviewAi_AiGradingAssignmentEligibility>;
  /** Gets the configuration for fully AI graded peer reviews */
  getFullyAiGradedConfig: PeerReviewAi_FullyAiGradedConfig;
  /** Gets the configurations for fully AI graded peer reviews by course */
  getFullyAiGradedConfigsByCourse: Array<PeerReviewAi_FullyAiGradedConfigItem>;
  /** Gets the logged in user's feedback for the AI grading in a given submission for every review */
  getReviewUserFeedbacksBySubmission: Array<PeerReviewAi_ReviewUserFeedback>;
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetAiGradingEligibilityArgs = {
  assignmentId: Scalars['ID'];
  assignmentVersion: Scalars['Int'];
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetAiGradingEligibilityByCourseArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetAiGradingStatusArgs = {
  submissionId: Scalars['ID'];
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetFileUploadAiGradingEligibilityByCourseArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetFullyAiGradedConfigsByCourseArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return Peer Review AI grading information */
export type PeerReviewAiQueriesGetReviewUserFeedbacksBySubmissionArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  submissionId: Scalars['ID'];
};

/** Special features that an AI enabled peer assignment has to indicate special behavior */
export const PeerReviewAi_AiEnabledAssignmentFeature = {
  /** Indicates this assignment contains at least 1 file upload question */
  FileUpload: 'FILE_UPLOAD',
  /**
   * Indicates that this assignment will be rolled out to 100% of paid and enterprise learners,
   * instead of the default behavior
   */
  PaidEnterprise_100: 'PAID_ENTERPRISE_100',
  /**
   * Indicates this assignment will be rolled out to all learners except for those excluded on legal
   * reasons
   */
  RolloutAll: 'ROLLOUT_ALL'
} as const;

export type PeerReviewAi_AiEnabledAssignmentFeature = typeof PeerReviewAi_AiEnabledAssignmentFeature[keyof typeof PeerReviewAi_AiEnabledAssignmentFeature];
/** Contains whether assignment with assignmentId is eligible for AI grading */
export type PeerReviewAi_AiGradingAssignmentEligibility = {
  __typename?: 'PeerReviewAi_AiGradingAssignmentEligibility';
  /** Assignment ID of the assignment */
  assignmentId: Scalars['ID'];
  /** The Assignment Version */
  assignmentVersion: Scalars['Int'];
  /** Contains the list of features for an AI grading enabled assignment */
  features: Array<PeerReviewAi_AiEnabledAssignmentFeature>;
  /** Whether the assignment with assignmentId is eligible for AI grading */
  isEligible: Scalars['Boolean'];
  /** Item ID of the assignment */
  itemId: Scalars['ID'];
  /** The rollout type for the peer review AI enabled assignment */
  rolloutType: PeerReviewAi_RolloutType;
};

/** Contains whether the specified versioned assignment is eligible for AI grading */
export type PeerReviewAi_AiGradingEligibility = {
  __typename?: 'PeerReviewAi_AiGradingEligibility';
  /**
   * Contains the list of features for an AI grading enabled assignment
   * @deprecated features unused after GA
   */
  features: Array<PeerReviewAi_AiEnabledAssignmentFeature>;
  /** Whether the specific versioned assignment is eligible for AI grading */
  isEligible: Scalars['Boolean'];
  /**
   * The rollout type for the peer review AI enabled assignment
   * @deprecated rollout unused after GA
   */
  rolloutType: PeerReviewAi_RolloutType;
};

/** Contains the configuration for fully AI graded peer assignments */
export type PeerReviewAi_FullyAiGradedConfig = {
  __typename?: 'PeerReviewAi_FullyAiGradedConfig';
  /** List of un-versioned assignmentIds for fully AI graded peer assignments */
  assignmentIds: Array<Scalars['ID']>;
};

/** Contains the configuration for a fully AI graded peer assignment in a course */
export type PeerReviewAi_FullyAiGradedConfigItem = {
  __typename?: 'PeerReviewAi_FullyAiGradedConfigItem';
  /** Un-versioned assignmentId for a fully AI graded peer assignment */
  assignmentId: Scalars['ID'];
  /** Item ID of the assignment */
  itemId: Scalars['ID'];
};

/** Input for PeerReviewAi_RequestGradingByPeer mutation */
export type PeerReviewAi_RequestGradingByPeerInput = {
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** Reason for switching the grading type */
  reason?: InputMaybe<Scalars['String']>;
  /** The Submission ID, requires successful peer review submission */
  submissionId: Scalars['ID'];
};

/** Result for PeerReviewAi_RequestGradingByPeer mutation */
export type PeerReviewAi_RequestGradingByPeerResult = {
  __typename?: 'PeerReviewAi_RequestGradingByPeerResult';
  /** Just returning Submission ID, will error out if mutation not successful */
  submissionId: Scalars['ID'];
};

/** Contains the user feedbacks for the AI grading for a specific review part */
export type PeerReviewAi_ReviewPartUserFeedback = {
  __typename?: 'PeerReviewAi_ReviewPartUserFeedback';
  /** Enum representing user's feedback choice for evaluating AI grading */
  feedbackChoice?: Maybe<PeerReviewAi_UserFeedbackChoice>;
  /** Review Part ID of the AI review */
  reviewPartId: Scalars['ID'];
};

/** Contains the user feedbacks for the AI grading for a specific review */
export type PeerReviewAi_ReviewUserFeedback = {
  __typename?: 'PeerReviewAi_ReviewUserFeedback';
  /** Review ID of the peer grading */
  reviewId: Scalars['ID'];
  /** List of user feedbacks for the AI grading for each review part */
  reviewPartUserFeedbacks: Array<PeerReviewAi_ReviewPartUserFeedback>;
};

/** Determines the type of rollout for the peer review AI enabled assignment */
export const PeerReviewAi_RolloutType = {
  /** Indicates that this assignment will be rolled out to 100% of paid and enterprise learners */
  PaidEnterprise_100: 'PAID_ENTERPRISE_100',
  /**
   * Indicates this assignment will be rolled out to all learners except for those excluded on legal
   * reasons
   */
  RolloutAll: 'ROLLOUT_ALL'
} as const;

export type PeerReviewAi_RolloutType = typeof PeerReviewAi_RolloutType[keyof typeof PeerReviewAi_RolloutType];
/** Input for PeerReviewAi_SaveUserFeedback mutation */
export type PeerReviewAi_SaveUserFeedbackInput = {
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The logged in user's feedback choice for the specified AI grading review part of a specific review */
  feedbackChoice?: InputMaybe<PeerReviewAi_UserFeedbackChoice>;
  /** The Item ID */
  itemId: Scalars['ID'];
  /** The Review ID for a peer review */
  reviewId: Scalars['ID'];
  /** The Review Part ID of the AI review */
  reviewPartId: Scalars['ID'];
  /** The Submission ID, requires successful peer review submission */
  submissionId: Scalars['ID'];
};

/** Result for PeerReviewAi_SaveUserFeedback mutation */
export type PeerReviewAi_SaveUserFeedbackResult = {
  __typename?: 'PeerReviewAi_SaveUserFeedbackResult';
  /** Just returning Submission ID, will error out if mutation not successful */
  submissionId: Scalars['ID'];
};

/** Enum representing the current status of an AI grading submission */
export const PeerReviewAi_Status = {
  /** AI review failed */
  Failed: 'FAILED',
  /** Submission is not AI Reviewed */
  None: 'NONE',
  /** AI review is under process */
  Pending: 'PENDING',
  /** AI review was successfully completed */
  Success: 'SUCCESS'
} as const;

export type PeerReviewAi_Status = typeof PeerReviewAi_Status[keyof typeof PeerReviewAi_Status];
/** Enum representing user feedback of AI grading */
export const PeerReviewAi_UserFeedbackChoice = {
  /** AI review part is disliked by the user */
  Dislike: 'DISLIKE',
  /** AI review part is liked by the user */
  Like: 'LIKE'
} as const;

export type PeerReviewAi_UserFeedbackChoice = typeof PeerReviewAi_UserFeedbackChoice[keyof typeof PeerReviewAi_UserFeedbackChoice];
/** Peer Review Migration queries */
export type PeerReviewMigrationQueries = {
  __typename?: 'PeerReviewMigrationQueries';
  /** Returns eligibility for converting the provided peer assignments to AI-graded assignments */
  getMigrationEligibility: Array<PeerReviewMigration_Eligibility>;
};


/** Peer Review Migration queries */
export type PeerReviewMigrationQueriesGetMigrationEligibilityArgs = {
  peerAssignments: Array<PeerReviewMigration_EligibilityInput>;
};

/** Input for convertPeerReviewToAiAssignment mutation */
export type PeerReviewMigration_ConvertPeerReviewToAiAssignmentInput = {
  /** Atom ID */
  atomId?: InputMaybe<Scalars['ID']>;
  /** Authoring branch ID of the course */
  authoringBranchId: Scalars['ID'];
  /** The course that the peer review is in */
  courseId: Scalars['ID'];
  /** Peer review assignment ID */
  peerAssignmentId: Scalars['ID'];
  /** Version */
  version: Scalars['Int'];
};

/** Response from triggering peer review to assignment conversion */
export type PeerReviewMigration_ConvertPeerReviewToAiAssignmentResult = {
  __typename?: 'PeerReviewMigration_ConvertPeerReviewToAiAssignmentResult';
  /** Converted assignment Id */
  assignmentId?: Maybe<Scalars['ID']>;
  /** Response message */
  message?: Maybe<Scalars['String']>;
  /** Success flag */
  success: Scalars['Boolean'];
};

/** Eligibility result for converting a peer assignment to AI grading */
export type PeerReviewMigration_Eligibility = {
  __typename?: 'PeerReviewMigration_Eligibility';
  /** The Assignment ID */
  assignmentId: Scalars['ID'];
  /** The Assignment Version */
  assignmentVersion: Scalars['Int'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** If the peer assignment is eligible for migration to Assignment with AI-graded questions */
  isEligible: Scalars['Boolean'];
  /** The Item ID */
  itemId: Scalars['ID'];
  /** Optional warnings about the eligibility of the peer assignment for migration */
  warnings: Array<PeerReviewMigration_EligibilityMessage>;
};

/** Input representing a versioned peer review assignment within a course and branch */
export type PeerReviewMigration_EligibilityInput = {
  /** The Assignment ID */
  assignmentId: Scalars['ID'];
  /** The Assignment Version */
  assignmentVersion: Scalars['Int'];
  /** The Course ID */
  courseId: Scalars['ID'];
  /** The Item ID */
  itemId: Scalars['ID'];
};

/** Additional migration eligibility context. Warnings highlight potential issues but do not necessarily prevent eligibility. */
export const PeerReviewMigration_EligibilityMessage = {
  /** Assignment mentions or allows invalid or unsupported file types. */
  ContainsInvalidFileTypesMention: 'CONTAINS_INVALID_FILE_TYPES_MENTION',
  /** Assignment includes questions that require URLs. */
  ContainsUrlQuestions: 'CONTAINS_URL_QUESTIONS',
  /** Assignment is part of or linked to a degree authoring branch. */
  IsPartOrLinkedToDegreeBranch: 'IS_PART_OR_LINKED_TO_DEGREE_BRANCH'
} as const;

export type PeerReviewMigration_EligibilityMessage = typeof PeerReviewMigration_EligibilityMessage[keyof typeof PeerReviewMigration_EligibilityMessage];
/** Peer Review Queries */
export type PeerReviewQueries = {
  __typename?: 'PeerReviewQueries';
  /**
   * Query to get a list of submission summaries for a private group.
   * Returned users will be in alphabetical order, including users without submission.
   */
  getPrivateGroupLearnerSummaries?: Maybe<PeerReview_LearnerSummaryPaginatedResult>;
  /**
   * Query to get a list of submission summaries for a public session.
   * Returned users will be ordered by submission time. Only includes learners with submission.
   */
  getPublicBranchLearnerSummaries?: Maybe<PeerReview_LearnerSummaryPaginatedResult>;
};


/** Peer Review Queries */
export type PeerReviewQueriesGetPrivateGroupLearnerSummariesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  groupId: Scalars['ID'];
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
};


/** Peer Review Queries */
export type PeerReviewQueriesGetPublicBranchLearnerSummariesArgs = {
  branchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
};

/** Assignment configuration summary */
export type PeerReview_AssignmentConfigurationSummary = {
  __typename?: 'PeerReview_AssignmentConfigurationSummary';
  /** Number of reviews learner needs to give */
  reviewsGivenRequired: Scalars['Int'];
  /** Number or review learner's submission needs to receive */
  reviewsReceivedRequired: Scalars['Int'];
};

/** Learner progress summary */
export type PeerReview_LearnerProgressSummary = {
  __typename?: 'PeerReview_LearnerProgressSummary';
  /** Assignment completion status */
  completed: Scalars['Boolean'];
  /**
   * Specifies whether the submission is graded by HUMAN (other learners), or by AI
   * (can be null if submission doesn't exist)
   */
  gradingType?: Maybe<PeerReview_PeerGradingType>;
  /** Number of reviews learner gave */
  reviewsGiven: Scalars['Int'];
  /** Number of reviews the submission received */
  reviewsReceived: Scalars['Int'];
  /** Submission id (can be null if submission doesn't exist) */
  submissionId?: Maybe<Scalars['ID']>;
  /** Submission time (can be null if submission doesn't exist) */
  submissionTime?: Maybe<Scalars['DateTime']>;
  /** Submission title (can be null if submission doesn't exist) */
  submissionTitle?: Maybe<Scalars['String']>;
};

/** Contains information about the progress of a single learner through a peer review assignment. */
export type PeerReview_LearnerSummary = {
  __typename?: 'PeerReview_LearnerSummary';
  /** Assignment configuration summary */
  assignmentConfiguration: PeerReview_AssignmentConfigurationSummary;
  /** Assignment id */
  assignmentId: Scalars['ID'];
  /** Unique summary id */
  id: Scalars['ID'];
  /** Item id */
  itemId: Scalars['ID'];
  /** Learner progress summary */
  learnerProgress: PeerReview_LearnerProgressSummary;
  /** User profile */
  userProfile: PeerReview_UserProfile;
};

/** Pagination for PeerReview_LearnerSummary */
export type PeerReview_LearnerSummaryPaginatedResult = {
  __typename?: 'PeerReview_LearnerSummaryPaginatedResult';
  /** List of returned PeerReview_LearnerSummary */
  elements: Array<PeerReview_LearnerSummary>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Specifies which grading type will be used for peer submission. */
export const PeerReview_PeerGradingType = {
  /** New grading type when submission is graded by AI. */
  Ai: 'AI',
  /** Original grading type when submission is graded by other learners. */
  Human: 'HUMAN'
} as const;

export type PeerReview_PeerGradingType = typeof PeerReview_PeerGradingType[keyof typeof PeerReview_PeerGradingType];
/** User profile */
export type PeerReview_UserProfile = {
  __typename?: 'PeerReview_UserProfile';
  /** User display name */
  displayName: Scalars['String'];
  /** User id */
  id: Scalars['ID'];
};

/** Fetch user data for personalized ddp */
export type PersonalizedDdpQueries = {
  __typename?: 'PersonalizedDdpQueries';
  /**
   * Returns the data of user's attributes and behavior that can help personalizing the ddp of the
   * degree.
   */
  queryPersonalizedDdpData?: Maybe<PersonalizedDdp_UserData>;
};


/** Fetch user data for personalized ddp */
export type PersonalizedDdpQueriesQueryPersonalizedDdpDataArgs = {
  degreeSlug?: InputMaybe<Scalars['String']>;
};

/** The buttons that the user ever clicked in the past 12 months. Can add more button types later */
export type PersonalizedDdp_ButtonClicks = {
  __typename?: 'PersonalizedDdp_ButtonClicks';
  /** If the user ever clicked apply button on ddp or xdp for this degree */
  clickedApplyButton: Scalars['Boolean'];
  /** The last DateTime that the user clicked the apply button */
  lastClickedApplyButtonTs?: Maybe<Scalars['DateTime']>;
};

/** Paginated list of courses that the student has enrolled */
export type PersonalizedDdp_CoursePaginatedResult = {
  __typename?: 'PersonalizedDdp_CoursePaginatedResult';
  /** List of elements in the page */
  elements: Array<Course_Course>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** The ddp views to the current ddp that the user ever had in the last 12 months */
export type PersonalizedDdp_DdpViews = {
  __typename?: 'PersonalizedDdp_DdpViews';
  /** The count of the views to the about tab of the ddp */
  aboutTabViews?: Maybe<Scalars['Int']>;
  /** The count of the views to the academics tab of the ddp */
  academicsTabViews?: Maybe<Scalars['Int']>;
  /** The count of the views to the admission tab of the ddp */
  admissionTabViews?: Maybe<Scalars['Int']>;
  /** The count of the views to the career tab of the ddp */
  careerTabViews?: Maybe<Scalars['Int']>;
  /** The last DateTime that the user visited the ddp */
  lastPageViewTs?: Maybe<Scalars['DateTime']>;
  /** The count of page views to the ddp (home page) */
  pageViews?: Maybe<Scalars['Int']>;
  /** The count of the views to the student experience tab of the ddp */
  studentExperienceTabViews?: Maybe<Scalars['Int']>;
  /** The count of the total tab views of the ddp */
  totalTabViews?: Maybe<Scalars['Int']>;
  /** The count of the total views (page views + tab views) to the ddp */
  totalViews?: Maybe<Scalars['Int']>;
  /** The count of the views to the tuition tab of the ddp */
  tuitionTabViews?: Maybe<Scalars['Int']>;
};

/**
 * Degree with basic information. This type is temporary and should be replaced by Degree_Degree after
 * the java migration of it is done.
 */
export type PersonalizedDdp_Degree = {
  __typename?: 'PersonalizedDdp_Degree';
  /** The id of the degree */
  id: Scalars['ID'];
  /** User-visible name of the degree */
  name: Scalars['String'];
  /** Short name used in URLs */
  slug: Scalars['String'];
};

/** The degree application that the user started in the last 12 months for this degree. */
export type PersonalizedDdp_DegreeApplication = {
  __typename?: 'PersonalizedDdp_DegreeApplication';
  /** admission term */
  admissionTerm?: Maybe<Scalars['String']>;
  /** application acceptance decision */
  applicationAcceptanceDecision?: Maybe<PersonalizedDdp_DegreeApplicationAcceptanceDecision>;
  /** the date the application was created */
  applicationCreatedDate?: Maybe<Scalars['Date']>;
  /** application status */
  applicationStatus?: Maybe<PersonalizedDdp_DegreeApplicationStatus>;
  /** the date the application was submitted */
  applicationSubmittedDate?: Maybe<Scalars['Date']>;
  /** application type */
  applicationType?: Maybe<PersonalizedDdp_DegreeApplicationType>;
};

/** Degree application acceptance decision */
export const PersonalizedDdp_DegreeApplicationAcceptanceDecision = {
  /** The application with ACCEPTED decision */
  Accepted: 'ACCEPTED',
  /** The application with DECLINED decision */
  Declined: 'DECLINED',
  /** The application with DEFERRED decision */
  Deferred: 'DEFERRED',
  /** The application with WITHDRAWN decision */
  Withdrawn: 'WITHDRAWN'
} as const;

export type PersonalizedDdp_DegreeApplicationAcceptanceDecision = typeof PersonalizedDdp_DegreeApplicationAcceptanceDecision[keyof typeof PersonalizedDdp_DegreeApplicationAcceptanceDecision];
/**
 * Degree application status. (There are more in the database, for now we only record these types
 * and mark the others as OTHER)
 */
export const PersonalizedDdp_DegreeApplicationStatus = {
  /** The application was accepted */
  Accepted: 'ACCEPTED',
  /** The application that awaiting for payment */
  AwaitingPayment: 'AWAITING_PAYMENT',
  /** The application that user started but hasn't submitted */
  AwaitingSubmission: 'AWAITING_SUBMISSION',
  /** The application with other status */
  Other: 'OTHER',
  /** The application in pending */
  Pending: 'PENDING',
  /** The application with performance pathway admit */
  PerformancePathwayAdmit: 'PERFORMANCE_PATHWAY_ADMIT',
  /** The application was rejected */
  Rejected: 'REJECTED',
  /** The application in waiting list */
  Waitlisted: 'WAITLISTED',
  /** The application was withdrawn */
  Withdrawn: 'WITHDRAWN'
} as const;

export type PersonalizedDdp_DegreeApplicationStatus = typeof PersonalizedDdp_DegreeApplicationStatus[keyof typeof PersonalizedDdp_DegreeApplicationStatus];
/** Degree application types */
export const PersonalizedDdp_DegreeApplicationType = {
  /** degree seeking */
  DegreeSeeking: 'DEGREE_SEEKING',
  /** missing value */
  MissingValue: 'MISSING_VALUE',
  /** non degree seeking */
  NonDegreeSeeking: 'NON_DEGREE_SEEKING'
} as const;

export type PersonalizedDdp_DegreeApplicationType = typeof PersonalizedDdp_DegreeApplicationType[keyof typeof PersonalizedDdp_DegreeApplicationType];
/** The user's EOI responses to the degree */
export type PersonalizedDdp_EoiResponse = {
  __typename?: 'PersonalizedDdp_EoiResponse';
  /**
   * If true: The user submitted the EOI.
   * If false: The user started the EOI but didn't submit.
   */
  completed: Scalars['Boolean'];
  /** The last DateTime of the EOI response */
  lastEoiResponseTs?: Maybe<Scalars['DateTime']>;
  /** The source of the EOI response */
  source?: Maybe<PersonalizedDdp_EoiResponseSource>;
};

/**
 * The source types of EOI responses. (There are around 30 different types in the database, for now we
 * only record the coursera sources and mark the others as OTHER)
 */
export const PersonalizedDdp_EoiResponseSource = {
  /** EOI from coursera article */
  CourseraArticle: 'COURSERA_ARTICLE',
  /** EOI from coursera blog */
  CourseraBlog: 'COURSERA_BLOG',
  /** EOI from DDP */
  CourseraDdp: 'COURSERA_DDP',
  /** EOI from degree hub */
  CourseraDegreeHub: 'COURSERA_DEGREE_HUB',
  /** EOI from coursera zoom webinars */
  CourseraZoomWebinars: 'COURSERA_ZOOM_WEBINARS',
  /** EOI from other source */
  Other: 'OTHER'
} as const;

export type PersonalizedDdp_EoiResponseSource = typeof PersonalizedDdp_EoiResponseSource[keyof typeof PersonalizedDdp_EoiResponseSource];
/**
 * The stackable content of this degree (i.e. coursera contents that have upsells relation with this
 * degree) that the user has enrolled / completed in the last 12 months
 */
export type PersonalizedDdp_StackableContent = {
  __typename?: 'PersonalizedDdp_StackableContent';
  /** The upsells source contents that have "OFFERS_CREDIT" relation with this degree */
  offersCreditContents?: Maybe<PersonalizedDdp_UpsellSourceContents>;
  /** The upsells source contents that have "PART_OF" relation with this degree */
  partOfContents?: Maybe<PersonalizedDdp_UpsellSourceContents>;
  /** The upsells source contents that have "RELATED_TO" relation with this degree */
  relatedToContents?: Maybe<PersonalizedDdp_UpsellSourceContents>;
};

/** Upsell relation types */
export const PersonalizedDdp_UpsellRelationType = {
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type PersonalizedDdp_UpsellRelationType = typeof PersonalizedDdp_UpsellRelationType[keyof typeof PersonalizedDdp_UpsellRelationType];
/** Basic information of the the upsell source content (course / specialization / mastertrack) */
export type PersonalizedDdp_UpsellSourceContents = {
  __typename?: 'PersonalizedDdp_UpsellSourceContents';
  /** list of courses */
  courses?: Maybe<Array<Course_Course>>;
  /** list of MasterTracks */
  masterTracks?: Maybe<Array<PersonalizedDdp_Degree>>;
  /** The upsell relation type to the degree of current ddp if exists. */
  relationType: PersonalizedDdp_UpsellRelationType;
  /** list of specializations */
  s12ns?: Maybe<Array<Specialization_Specialization>>;
};

/** User's data that can help personalizing the ddp */
export type PersonalizedDdp_UserData = {
  __typename?: 'PersonalizedDdp_UserData';
  /** The buttons that the user ever clicked on the DDP of this degree in the last 12 months */
  buttonClicks?: Maybe<PersonalizedDdp_ButtonClicks>;
  /**
   * The stackable content of this degree (i.e. coursera content that has upsells relation with this
   * degree) that the user has completed in the last 12 months
   */
  completedStackableContent?: Maybe<PersonalizedDdp_StackableContent>;
  /** If the user ever viewed a ddp page in the last 12 months */
  ddpViewed: Scalars['Boolean'];
  /** The user's ddp views data on the DDP of this degree in the last 12 months */
  ddpViews?: Maybe<PersonalizedDdp_DdpViews>;
  /** The application for this degree that the user started in the last 12 months */
  degreeApplications?: Maybe<Array<PersonalizedDdp_DegreeApplication>>;
  /** The different degrees that the user ever viewed in the last 12 months */
  diffDdpViewed?: Maybe<Array<PersonalizedDdp_Degree>>;
  /** The list of courses that the user has enrolled in the last 12 months */
  enrolledCourses?: Maybe<PersonalizedDdp_CoursePaginatedResult>;
  /**
   * The stackable content of this degree (i.e. coursera content that has upsells relation with this
   * degree) that the user has enrolled in the last 12 months
   */
  enrolledStackableContent?: Maybe<PersonalizedDdp_StackableContent>;
  /** The user's EOI responses for this degree in the last 12 months */
  eoiResponses?: Maybe<Array<PersonalizedDdp_EoiResponse>>;
  /** The different degrees that the user ever EOId to in the last 12 months */
  eoiToDiffDegrees?: Maybe<Array<PersonalizedDdp_Degree>>;
  /** If the user ever viewed a xdp page in the last 12 months */
  xdpViewed: Scalars['Boolean'];
};


/** User's data that can help personalizing the ddp */
export type PersonalizedDdp_UserDataEnrolledCoursesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** PersonalizedPlans namespaced queries. */
export type PersonalizedPlansQueries = {
  __typename?: 'PersonalizedPlansQueries';
  /**
   * Get the most recent active learning plan for the authenticated user.
   * The user is identified from the request context.
   */
  learningPlan?: Maybe<PersonalizedPlans_LearningPlan>;
  /**
   * Get a specific learning plan by its ID for the authenticated user.
   * The user is identified from the request context.
   */
  learningPlanById?: Maybe<PersonalizedPlans_LearningPlan>;
  /**
   * Simulate plan generation for an arbitrary user.
   * This is intended for internal testing and debugging. Plans are not persisted.
   * As this query is for internal use only, the query does not need to be backwards compatible. Breaking changes for this API should be expected and allowed.
   */
  simulatePersonalizedPlan: PersonalizedPlans_GeneratedLearningPlan;
  /**
   * Simulate plan generation with a caller-supplied LearningPlanConfiguration override.
   * This is intended for internal testing and debugging. Plans are not persisted.
   * As this query is for internal use only, the query does not need to be backwards compatible. Breaking changes for this API should be expected and allowed.
   */
  simulatePersonalizedPlanWithOverride: PersonalizedPlans_GeneratedLearningPlan;
};


/** PersonalizedPlans namespaced queries. */
export type PersonalizedPlansQueriesLearningPlanByIdArgs = {
  planId: Scalars['ID'];
};


/** PersonalizedPlans namespaced queries. */
export type PersonalizedPlansQueriesSimulatePersonalizedPlanArgs = {
  input: PersonalizedPlans_LearningPlanInput;
  sessionId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};


/** PersonalizedPlans namespaced queries. */
export type PersonalizedPlansQueriesSimulatePersonalizedPlanWithOverrideArgs = {
  configurationOverride: Scalars['JSON'];
  input: PersonalizedPlans_LearningPlanInput;
  sessionId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

/** Input for adding a product to a milestone within a learning plan. */
export type PersonalizedPlans_AddProductInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /** The plan to modify. */
  planId: Scalars['ID'];
  /** The product to add. */
  product: PersonalizedPlans_ProductIdentifier;
};

/** Result of adding a product to a milestone. */
export type PersonalizedPlans_AddProductResult = {
  __typename?: 'PersonalizedPlans_AddProductResult';
  /** The updated learning plan after adding the product. */
  plan: PersonalizedPlans_LearningPlan;
};

/** The full result of plan generation, including the plan itself and per-step debug context. */
export type PersonalizedPlans_GeneratedLearningPlan = {
  __typename?: 'PersonalizedPlans_GeneratedLearningPlan';
  /**
   * Per-step debug data (LLM inputs/outputs, retrieval results). Courserian-gated; never
   * returned to learners.
   */
  debugContext?: Maybe<Scalars['JSON']>;
  /** The generated plan. */
  plan: PersonalizedPlans_LearningPlan;
};

/**
 * The generation input retained on a FAILED plan, so generation can be retried without the
 * learner re-entering their goal, role, and skills. Only populated for plans in the FAILED state.
 */
export type PersonalizedPlans_GenerationInput = {
  __typename?: 'PersonalizedPlans_GenerationInput';
  /** Free-form learner goal (e.g. "become a data scientist in 6 months"). */
  goal: Scalars['String'];
  /** Free-form role name the learner mentioned, if any. */
  roleName?: Maybe<Scalars['String']>;
  /** Free-form skill names the learner mentioned. May be empty. */
  skillNames: Array<Scalars['String']>;
};

/** A learner's stated time budget for completing the plan, normalized upstream. Used to decide whether the generated plan overruns the deadline (and needs a relaxation note); never displayed verbatim except via displayText. */
export type PersonalizedPlans_GoalTimeFrameInput = {
  /** The stated deadline normalized to whole weeks (e.g. "2 months" -> 8). Null when the learner stated a pace but no deadline. */
  deadlineWeeks?: InputMaybe<Scalars['Int']>;
  /** The learner's stated timeframe in their own words (e.g. "2 months"), echoed back in the relaxation note. Null when no deadline was stated. */
  displayText?: InputMaybe<Scalars['String']>;
  /** The learner's stated study pace in hours/week, if any. When null the service assumes its default pace. */
  hoursPerWeek?: InputMaybe<Scalars['Float']>;
};

/** A personalized learning plan containing milestones and course recommendations. */
export type PersonalizedPlans_LearningPlan = {
  __typename?: 'PersonalizedPlans_LearningPlan';
  /** Timestamp when the plan was created. */
  createdAt: Scalars['DateTime'];
  /**
   * The original generation input, retained only for plans in the FAILED state so generation
   * can be retried without the learner re-entering their goal, role, and skills. Null otherwise.
   */
  generationInput?: Maybe<PersonalizedPlans_GenerationInput>;
  /** Timestamp of the most recent retry attempt, or null if generation has never been retried. */
  lastRetryAttempt?: Maybe<Scalars['DateTime']>;
  /** Ordered list of milestones in the plan. */
  milestones: Array<PersonalizedPlans_PlanMilestone>;
  /** Unique identifier for the learning plan. */
  planId: Scalars['ID'];
  /**
   * Number of times generation has been retried for this plan. Zero for plans that have not
   * failed or been retried.
   */
  retryCount: Scalars['Int'];
  /** Current status of the learning plan. */
  status: PersonalizedPlans_LearningPlanStatus;
  /** High-level summary metadata for the plan. */
  summary: PersonalizedPlans_LearningPlanSummary;
  /** Title of the learning plan. */
  title: Scalars['String'];
  /** Timestamp when the plan was last updated. */
  updatedAt: Scalars['DateTime'];
  /** Version number for optimistic concurrency control. */
  version: Scalars['Int'];
};

/**
 * A constituent course of a specialization plan product, with per-child enrollment state,
 * federation reference to next-item details, and item-completion progress.
 */
export type PersonalizedPlans_LearningPlanChildCourse = {
  __typename?: 'PersonalizedPlans_LearningPlanChildCourse';
  /** The course (federated catalog entity). */
  course: Course_Course;
  /** The learner's enrollment state for this child course. */
  enrollmentState: PersonalizedPlans_PlanProductEnrollmentState;
  /**
   * Federation reference to the learner's next item for this child course. Null when the learner
   * is not actively engaged (not enrolled, or fully completed).
   */
  nextCourseItem?: Maybe<CourseNavigation_LearnerNextItemDetails>;
  /**
   * Federation reference to the learner's item-completion progress for this child course. Clients
   * select fields like `overall` and `isCompleted` and derive any display state themselves.
   */
  progress?: Maybe<OnDemandCoursesProgressV1>;
};

/**
 * Input to generate a learning plan. This is exclusively used for the simulating personalized plans and thus is for internal use only.
 * The input does not need to be backwards compatible. Breaking changes for this API should be expected and allowed.
 */
export type PersonalizedPlans_LearningPlanInput = {
  /** Free-form learner goal (e.g. "become a data scientist in 6 months"). */
  goal: Scalars['String'];
  /** Learner-stated time budget, extracted and normalized upstream (e.g. by the Coach LLM) rather than parsed from `goal` inside the service. Null when the learner stated no timeframe. */
  goalTimeFrame?: InputMaybe<PersonalizedPlans_GoalTimeFrameInput>;
  /** Free-form role name. The application does a best-effort to resolve this to a taxonomy role. Unmatched values are considered user-generated. */
  roleName?: InputMaybe<Scalars['String']>;
  /** Free-form skill names. The application does a best-effort to resolve these to taxonomy skills. Unmatched values are considered user-generated. */
  skillNames: Array<Scalars['String']>;
};

/**
 * A product entry within a learning plan, wrapping the catalog product (a `Course_Course` or
 * `Specialization_Specialization` federated entity) with the learner's enrollment state, item-
 * completion progress, and a federation reference to the learner's next item.
 */
export type PersonalizedPlans_LearningPlanProduct = {
  __typename?: 'PersonalizedPlans_LearningPlanProduct';
  /**
   * Per-child-course breakdown. Populated for specialization products; null for course products.
   * Each entry carries its own enrollment state, next-item federation reference, and progress.
   */
  childCourses?: Maybe<Array<PersonalizedPlans_LearningPlanChildCourse>>;
  /**
   * The learner's enrollment state for this product. For specializations, ENROLLED if the learner
   * is enrolled in any constituent course; PRE_ENROLLED if any child is pre-enrolled but none
   * enrolled; otherwise NOT_ENROLLED.
   */
  enrollmentState: PersonalizedPlans_PlanProductEnrollmentState;
  /**
   * Federation reference to the learner's next item for this product. Null for specialization
   * products (use `childCourses[*].nextCourseItem` for per-child next-item). Null on course
   * products when the learner is not actively engaged (not enrolled, or fully completed).
   */
  nextCourseItem?: Maybe<CourseNavigation_LearnerNextItemDetails>;
  /**
   * The catalog product. Either a `Course_Course` or `Specialization_Specialization`, both
   * federated entities.
   */
  product: PersonalizedPlans_PlanProduct;
  /**
   * Federation reference to this product's card data in the productcard subgraph, keyed by product
   * id + canonical type. Lets the My Plan page resolve product-card fields inline without a separate
   * fetch.
   */
  productCard: ProductCard_ProductCard;
  /**
   * Federation reference to the learner's item-completion progress. Null for specialization
   * products (use `childCourses[*].progress` for per-child progress). Clients select fields like
   * `overall` and `isCompleted` and derive any display state themselves.
   */
  progress?: Maybe<OnDemandCoursesProgressV1>;
};

/** Status of a learning plan. */
export const PersonalizedPlans_LearningPlanStatus = {
  /** Learner has completed all milestones in the plan. */
  Completed: 'COMPLETED',
  /** Plan has been created but not yet started. */
  Created: 'CREATED',
  /**
   * Plan generation failed. The original generation input is retained on the plan so the
   * learner can retry generation without re-entering their goal, role, and skills.
   */
  Failed: 'FAILED',
  /** Learner has started working on the plan. */
  Started: 'STARTED'
} as const;

export type PersonalizedPlans_LearningPlanStatus = typeof PersonalizedPlans_LearningPlanStatus[keyof typeof PersonalizedPlans_LearningPlanStatus];
/** High-level summary metadata for a learning plan. */
export type PersonalizedPlans_LearningPlanSummary = {
  __typename?: 'PersonalizedPlans_LearningPlanSummary';
  /**
   * Deduplicated union of all skills covered across the plan's milestones, sourced the same way as
   * PersonalizedPlans_PlanMilestone.skills (derived from the milestones' products). Distinct from
   * `skills`, which are the learner's target skills from their parsed goal: `skills` is intent,
   * `aggregateSkills` is coverage, and the two can diverge.
   */
  aggregateSkills: Array<PersonalizedPlans_Skill>;
  /**
   * Deduplicated union of all software tools used across the plan's milestones' products (taxonomy
   * `is_tool_software` flag); the plan-level rollup of PersonalizedPlans_PlanMilestone.tools. Tools
   * are taxonomy-only, so unlike `aggregateSkills` there is no user-generated variant.
   */
  aggregateTools: Array<Skill_Skill>;
  /** A brief description of the learning plan. */
  description?: Maybe<Scalars['String']>;
  /** The learner's stated career or learning goal. */
  goal?: Maybe<Scalars['String']>;
  /** The target career role for this plan. Either a taxonomy Skill_CareerRole (resolved via federation) or a user-generated role name. */
  role?: Maybe<PersonalizedPlans_Role>;
  /** Skills targeted by this plan, either taxonomy or user-generated. */
  skills: Array<PersonalizedPlans_Skill>;
  /** Human-readable total estimated duration for the plan, e.g. "4 weeks". */
  totalDuration: Scalars['String'];
};

/** A milestone within a learning plan, grouping related products by skill area. */
export type PersonalizedPlans_PlanMilestone = {
  __typename?: 'PersonalizedPlans_PlanMilestone';
  /** Description of what the learner will achieve in this milestone. */
  description: Scalars['String'];
  /** Human-readable estimated duration for the milestone, e.g. "1 week". */
  duration: Scalars['String'];
  /**
   * Cumulative week range this milestone spans within the plan, pre-formatted for display
   * (e.g. "Weeks 1-3"). The end week is shared with the next milestone's start week. Empty
   * string when the plan has no usable duration data. Render as-is.
   */
  durationRange: Scalars['String'];
  /** Display name for the milestone. */
  name: Scalars['String'];
  /** Courses and specializations included in this milestone. */
  products: Array<PersonalizedPlans_PlanProduct>;
  /**
   * Per-product wrappers for the milestone's products, each carrying the learner's enrollment
   * state, item-completion progress, and a federation reference to next-item details. Sibling of
   * `products` — consume this from surfaces that need learner context inline (e.g., the My Plan
   * tab) instead of issuing parallel queries.
   */
  productsWithProgress: Array<PersonalizedPlans_LearningPlanProduct>;
  /** Skills covered by this milestone. */
  skills: Array<PersonalizedPlans_Skill>;
  /**
   * Software tools used across this milestone's products (e.g. Excel, Python), sourced from the
   * taxonomy `is_tool_software` flag. Sibling of `skills`; powers the "Tools you'll use" section.
   */
  tools: Array<Skill_Skill>;
};

/** A product within a learning plan, either a Course or Specialization resolved via federation. */
export type PersonalizedPlans_PlanProduct = Course_Course | Specialization_Specialization;

/** Per-learner enrollment state for a plan product or constituent course. */
export const PersonalizedPlans_PlanProductEnrollmentState = {
  /** The learner is actively enrolled (LEARNER role or equivalent). */
  Enrolled: 'ENROLLED',
  /** The learner has no enrolled-or-pre-enrolled course membership for this product. */
  NotEnrolled: 'NOT_ENROLLED',
  /** The learner is pre-enrolled — the course has not yet launched for them. */
  PreEnrolled: 'PRE_ENROLLED'
} as const;

export type PersonalizedPlans_PlanProductEnrollmentState = typeof PersonalizedPlans_PlanProductEnrollmentState[keyof typeof PersonalizedPlans_PlanProductEnrollmentState];
/** Identifies a specific learning product by its type and ID. */
export type PersonalizedPlans_ProductIdentifier = {
  /** The canonical product ID (e.g. a course slug or specialization ID). */
  productId: Scalars['ID'];
  /** The type of learning product. */
  productType: PersonalizedPlans_ProductType;
};

/** The type of learning product within a plan. */
export const PersonalizedPlans_ProductType = {
  /** A Coursera course. */
  Course: 'COURSE',
  /** A Coursera specialization (series of courses). */
  Specialization: 'SPECIALIZATION'
} as const;

export type PersonalizedPlans_ProductType = typeof PersonalizedPlans_ProductType[keyof typeof PersonalizedPlans_ProductType];
/** Input for removing a product from a milestone within a learning plan. */
export type PersonalizedPlans_RemoveProductInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /** The plan to modify. */
  planId: Scalars['ID'];
  /** The product to remove. */
  product: PersonalizedPlans_ProductIdentifier;
};

/** Result of removing a product from a milestone. */
export type PersonalizedPlans_RemoveProductResult = {
  __typename?: 'PersonalizedPlans_RemoveProductResult';
  /** The updated learning plan after removing the product. */
  plan: PersonalizedPlans_LearningPlan;
};

/** Input for reordering products within a milestone. */
export type PersonalizedPlans_ReorderProductsInput = {
  /** Optimistic lock — must match the plan's current version. */
  currentVersion: Scalars['Int'];
  /** Zero-based index of the target milestone. */
  milestoneIndex: Scalars['Int'];
  /**
   * Ordered list of products representing the desired order.
   * Must be a permutation of existing products in the milestone (no adds or removes).
   */
  orderedProducts: Array<PersonalizedPlans_ProductIdentifier>;
  /** The plan to modify. */
  planId: Scalars['ID'];
};

/** Result of reordering products within a milestone. */
export type PersonalizedPlans_ReorderProductsResult = {
  __typename?: 'PersonalizedPlans_ReorderProductsResult';
  /** The updated learning plan after reordering. */
  plan: PersonalizedPlans_LearningPlan;
};

/** A structured error explaining why a retry-generation request did not yield a usable plan. */
export type PersonalizedPlans_RetryGenerationError = {
  __typename?: 'PersonalizedPlans_RetryGenerationError';
  /** Machine-readable reason the retry did not succeed. */
  code: PersonalizedPlans_RetryGenerationErrorCode;
  /** Human-readable description of the failure, suitable for logging or developer display. */
  message: Scalars['String'];
};

/** Why a retry-generation request could not produce a new plan. */
export const PersonalizedPlans_RetryGenerationErrorCode = {
  /** Generation was retried but failed again. The plan remains FAILED with an incremented retry count. */
  GenerationFailed: 'GENERATION_FAILED',
  /** The plan has already been retried the maximum number of times; the learner should start over. */
  MaxRetriesExceeded: 'MAX_RETRIES_EXCEEDED',
  /** The plan is not in a retryable state (only FAILED plans can be retried). */
  NotRetryable: 'NOT_RETRYABLE',
  /** No plan with the given ID exists for the requesting learner. */
  PlanNotFound: 'PLAN_NOT_FOUND'
} as const;

export type PersonalizedPlans_RetryGenerationErrorCode = typeof PersonalizedPlans_RetryGenerationErrorCode[keyof typeof PersonalizedPlans_RetryGenerationErrorCode];
/** Input for retrying generation of a FAILED plan. */
export type PersonalizedPlans_RetryGenerationInput = {
  /** The ID of the FAILED plan to retry. */
  planId: Scalars['ID'];
};

/**
 * Result of retrying generation for a FAILED plan. Exactly one of `plan` or `error` is populated,
 * except on a repeated GENERATION_FAILED where the still-FAILED plan is returned alongside `error`
 * so the caller can read the updated retry count.
 */
export type PersonalizedPlans_RetryGenerationResult = {
  __typename?: 'PersonalizedPlans_RetryGenerationResult';
  /** Populated when the retry did not produce a usable plan; null on success. */
  error?: Maybe<PersonalizedPlans_RetryGenerationError>;
  /**
   * The plan after the retry. On success this is the regenerated CREATED plan (same planId). On a
   * repeated generation failure this is the still-FAILED plan with an incremented retryCount. Null
   * when rejected before generation (PLAN_NOT_FOUND, NOT_RETRYABLE, MAX_RETRIES_EXCEEDED).
   */
  plan?: Maybe<PersonalizedPlans_LearningPlan>;
};

/** The target role for a learning plan, either a taxonomy career role or user-generated. */
export type PersonalizedPlans_Role = PersonalizedPlans_UserGeneratedRole | Skill_CareerRole;

/** A skill associated with a learning plan, either a taxonomy skill or user-generated. */
export type PersonalizedPlans_Skill = PersonalizedPlans_UserGeneratedSkill | Skill_Skill;

/** A role name provided by the user that does not map to a taxonomy career role. */
export type PersonalizedPlans_UserGeneratedRole = {
  __typename?: 'PersonalizedPlans_UserGeneratedRole';
  /** The user-provided role name, e.g., "AI Product Manager". */
  name: Scalars['String'];
};

/** A skill name provided by the user that does not map to a taxonomy skill. */
export type PersonalizedPlans_UserGeneratedSkill = {
  __typename?: 'PersonalizedPlans_UserGeneratedSkill';
  /** The user-provided skill name. */
  name: Scalars['String'];
};

/** All queries for Phrase Course Config */
export type PhraseCourseConfigQueries = {
  __typename?: 'PhraseCourseConfigQueries';
  /**
   * Reads all Phrase course configurations from S3.
   * Returns the full configuration JSON with versionId for optimistic locking on updates.
   */
  allConfigs: PhraseCourseConfig_Response;
};

/** A Phrase course configuration for MT+PE translation. */
export type PhraseCourseConfig_Config = {
  __typename?: 'PhraseCourseConfig_Config';
  /** Unique batch name for this configuration. */
  batchName: Scalars['String'];
  /** Branch ID for content versioning. */
  branchId: Scalars['ID'];
  /** The Coursera course associated with this configuration. */
  course: Course_Course;
  /** Phrase project template ID. */
  projectTemplateId: Scalars['ID'];
  /** Source language code (e.g., "en-US"). */
  sourceLang?: Maybe<Scalars['String']>;
  /** Target language codes (e.g., ["es-ES", "fr-FR"]). */
  targetLanguages: Array<Scalars['String']>;
};

/** Input for deleting a Phrase course configuration. */
export type PhraseCourseConfig_RemoveByBatchNameInput = {
  /** The batch name of the configuration to remove. */
  batchName: Scalars['String'];
};

/** Empty result for remove operation. */
export type PhraseCourseConfig_RemoveByBatchNameResult = {
  __typename?: 'PhraseCourseConfig_RemoveByBatchNameResult';
  /** Placeholder field. GraphQL requires at least one field in a type. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Response containing Phrase course configurations and versionId for optimistic locking. */
export type PhraseCourseConfig_Response = {
  __typename?: 'PhraseCourseConfig_Response';
  /** List of configured courses for MT+PE translation. */
  configs: Array<PhraseCourseConfig_Config>;
  /** Version identifier for optimistic locking on updates. */
  versionId?: Maybe<Scalars['ID']>;
};

/** Conflict due to concurrent modification (version mismatch). */
export type PhraseCourseConfig_ValidateAndSaveConflict = {
  __typename?: 'PhraseCourseConfig_ValidateAndSaveConflict';
  /** Current version ID in storage. */
  currentVersionId?: Maybe<Scalars['ID']>;
  /** Conflict message. */
  message: Scalars['String'];
};

/** Input for validating and writing a Phrase course configuration. */
export type PhraseCourseConfig_ValidateAndSaveInput = {
  /** Unique batch name for this configuration. */
  batchName: Scalars['String'];
  /** Branch ID for content versioning. */
  branchId: Scalars['ID'];
  /** Coursera course ID. */
  courseId: Scalars['ID'];
  /** True if updating existing config, false for new config. */
  isUpdate?: Scalars['Boolean'];
  /** Phrase project template ID. */
  projectTemplateId: Scalars['ID'];
  /** Source language code (e.g., "en-US"). */
  sourceLang?: InputMaybe<Scalars['String']>;
  /** Target language codes (e.g., ["es-ES", "fr-FR"]). */
  targetLanguages: Array<Scalars['String']>;
  /** Version ID from previous read for optimistic locking. Null for new configs. */
  versionId?: InputMaybe<Scalars['ID']>;
};

/** Result union: success, validation errors, or conflict. */
export type PhraseCourseConfig_ValidateAndSaveResult = PhraseCourseConfig_ValidateAndSaveConflict | PhraseCourseConfig_ValidateAndSaveSuccess | PhraseCourseConfig_ValidateAndSaveValidationErrors;

/** Successful write to S3. */
export type PhraseCourseConfig_ValidateAndSaveSuccess = {
  __typename?: 'PhraseCourseConfig_ValidateAndSaveSuccess';
  /** Success message. */
  message: Scalars['String'];
  /** New version ID after successful write. */
  newVersionId: Scalars['ID'];
};

/** Validation errors preventing save. */
export type PhraseCourseConfig_ValidateAndSaveValidationErrors = {
  __typename?: 'PhraseCourseConfig_ValidateAndSaveValidationErrors';
  /** List of field validation errors. */
  errors: Array<PhraseCourseConfig_ValidationError>;
};

/** Validation error for a specific field. */
export type PhraseCourseConfig_ValidationError = {
  __typename?: 'PhraseCourseConfig_ValidationError';
  /** Field name that failed validation. */
  field: Scalars['String'];
  /** Error description. */
  message: Scalars['String'];
};

/** This file is a placeholder to satisfy the graphql library dependency brought in by enterprise-team-library. */
export type Placeholder = {
  __typename?: 'Placeholder';
  value?: Maybe<Scalars['String']>;
};

/** Text similarity check status */
export const PlagiarismStatus = {
  /** Content has been completely plagiarized a given prompt */
  CompletePlagiarism: 'COMPLETE_PLAGIARISM',
  /** Plagiarism is not detected for a given prompt */
  NotPlagiarism: 'NOT_PLAGIARISM',
  /** Plagiarism is detected for a given prompt */
  PartialPlagiarism: 'PARTIAL_PLAGIARISM',
  /** Plagiarism is skipped for a given prompt since it's not part of the allowlist */
  PlagiarismSkipped: 'PLAGIARISM_SKIPPED'
} as const;

export type PlagiarismStatus = typeof PlagiarismStatus[keyof typeof PlagiarismStatus];
/** Enum of the "known" list of rpc interactions we support between the platform and the widget iframe contents.  This is used to identify actions that a widget is allowed to take. */
export const Plugins_WidgetRpcActionType = {
  /** Get scoped activity summary data for the user. */
  GetActivitySummaries: 'GET_ACTIVITY_SUMMARIES',
  /** Get authoriziation data for specific APIs that the widget needs to communicate with. */
  GetExternalApiAuthorizations: 'GET_EXTERNAL_API_AUTHORIZATIONS',
  /** Deprecated action type, unused in practice but serialized within * AuthoringWidgetApprovalPolicy.actions, so must be retained for backward compatibility. */
  GetGroupMemberships: 'GET_GROUP_MEMBERSHIPS',
  /** Load current session's configuration data */
  GetSessionConfiguration: 'GET_SESSION_CONFIGURATION',
  /** retrieve storedValues from our BE */
  GetStoredValues: 'GET_STORED_VALUES',
  /** Read specific, session-configured data keys from Nostos. See usage of * [[WidgetNostosReadRequest]] and [[WidgetNostosReadAuthorization]] for details. */
  ReadCustomQueryResults: 'READ_CUSTOM_QUERY_RESULTS',
  /** set the answer for a graded widget */
  SetAnswer: 'SET_ANSWER',
  /** Set the item as complete */
  SetComplete: 'SET_COMPLETE',
  /** Sets the item as complete with a specific grade */
  SetGradedComplete: 'SET_GRADED_COMPLETE',
  /** Set the height of the widget */
  SetHeight: 'SET_HEIGHT',
  /** Deprecated, use [[SET_COMPLETE]] instead. Retained here for backward compatibility of* prototype widgets. Please see note on SET_COMPLETE. */
  SetItemComplete: 'SET_ITEM_COMPLETE',
  /** save storedValues to our BE for persistence. */
  SetStoredValues: 'SET_STORED_VALUES',
  /** Deprecated feature, retained for backward compatibility with legacy data. */
  SubmitSurveyResponse: 'SUBMIT_SURVEY_RESPONSE'
} as const;

export type Plugins_WidgetRpcActionType = typeof Plugins_WidgetRpcActionType[keyof typeof Plugins_WidgetRpcActionType];
/** A plugin (ie widget) session. */
export type Plugins_WidgetSession = {
  __typename?: 'Plugins_WidgetSession';
  /** An arbitrary json object that is passed to the widget iframe. The information that is passed through will depend on the widget itself. */
  configuration?: Maybe<Plugins_WidgetSessionConfiguration>;
  /** The expiration of the widget session. */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** versioned id of the widget session itself */
  id: Scalars['ID'];
  /** The title supplied to the iframe that is presenting the widget contents. */
  iframeTitle?: Maybe<Scalars['String']>;
  /** The list of rpc interactions that a widget is allowed to perform. This list is not paginated because the enum list is unlikely to grow. */
  rpcActionTypes: Array<Plugins_WidgetRpcActionType>;
  /** Controls the restrictions applied to the content embedded in the <iframe>. The value of the attribute can either be empty to apply all restrictions, or space-separated tokens to lift particular restrictions. See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe for a list of valid values. */
  sandbox?: Maybe<Scalars['String']>;
  /** the source url for the iframe to display. This is usually a youtube link or external url for out-of-the-box widgets, or a cloudfront link for custom widgets. */
  src: Scalars['URL'];
  /** Field used to enable post authorization check on widget sessions. */
  userId: Scalars['ID'];
};

/** describes the widget sessions configuration that will accompany the widget session. */
export type Plugins_WidgetSessionConfiguration = {
  __typename?: 'Plugins_WidgetSessionConfiguration';
  /** Configuration is an arbitary json object supplied by the user. */
  data?: Maybe<Scalars['JSON']>;
};

/** Fields for an artifact in the project */
export type PortfolioProject_Artifact = {
  __typename?: 'PortfolioProject_Artifact';
  /** The assignment link of the artifact item */
  assignmentLink?: Maybe<Scalars['URL']>;
  /** The assignment title of the artifact item */
  assignmentTitle?: Maybe<Scalars['String']>;
  /** The item id of the artifact */
  itemId?: Maybe<Scalars['ID']>;
  /** The link of the artifact item */
  link?: Maybe<Scalars['URL']>;
  /** The type of the artifact item entered by learner (eg. Github URL) */
  type?: Maybe<Scalars['String']>;
};

/** Fields for an artifact in the project from input */
export type PortfolioProject_ArtifactInput = {
  /** The assignment link of the artifact item */
  assignmentLink?: InputMaybe<Scalars['URL']>;
  /** The assignment title of the artifact item */
  assignmentTitle?: InputMaybe<Scalars['String']>;
  /** The item id of the artifact */
  itemId?: InputMaybe<Scalars['ID']>;
  /** The link of the artifact item */
  link?: InputMaybe<Scalars['URL']>;
  /** The type of the artifact item entered by learner (eg. Github URL) */
  type?: InputMaybe<Scalars['String']>;
};

/** A single portfolio project or course. */
export type PortfolioProject_Project = {
  __typename?: 'PortfolioProject_Project';
  /** A text field indicating the business challenge the project aims to solve. */
  businessChallenge: Scalars['String'];
  /** A text field indicating the amount of time that this project is expected to take. */
  estimatedWorkload: Scalars['String'];
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  id: Scalars['ID'];
  /**
   * The branding image of the project.
   * For now, this is the same as the Course branding image.
   */
  image: Scalars['URL'];
  /**
   * A flag indicating whether the project is active.
   * Inactive projects will remain accessible to already enrolled learners but will not be available for new enrollments.
   */
  isActive: Scalars['Boolean'];
  /** A text field indicating the occupation id the project is related to. */
  occupationId: Scalars['ID'];
  /** An optional field containing partner info of the project (eg. partner name, partner logo). */
  partner?: Maybe<Partner_Partner>;
  /** An enum field indicating the type of the project (eg. Capstone). */
  projectType: PortfolioProject_ProjectType;
  /** A list of skills associated with this portfolio project. */
  skills: Array<Scalars['String']>;
  /** The slug of the project. For now this is the course slug. */
  slug: Scalars['String'];
  /**
   * The title of the project.
   * For now, this is the same as the name of the Course
   */
  title: Scalars['String'];
  /** A list of tools used in the project. */
  tools: Array<Scalars['String']>;
};

/** A paginated list of PortfolioProject_Project */
export type PortfolioProject_ProjectPaginatedResult = {
  __typename?: 'PortfolioProject_ProjectPaginatedResult';
  /** The list of projects in this page of results. */
  elements: Array<PortfolioProject_Project>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** Project type enum. */
export const PortfolioProject_ProjectType = {
  /** Capstone project type. */
  Capstone: 'CAPSTONE',
  /** Portfolio project type. */
  Demonstration: 'DEMONSTRATION'
} as const;

export type PortfolioProject_ProjectType = typeof PortfolioProject_ProjectType[keyof typeof PortfolioProject_ProjectType];
/** Fields for user achievement in the project, if it was graded */
export type PortfolioProject_UserAchievement = {
  __typename?: 'PortfolioProject_UserAchievement';
  /** The percentile of the learner in the project (i.e., "4.97" to indicate "top 5%") */
  percentile: Scalars['Float'];
  /**
   * The placement of the learner in the project (i.e., "1", "2" to indicate 1st, 2nd place respectively)
   * If no placement was recorded, this will be null
   */
  placement?: Maybe<Scalars['Int']>;
  /** The total number of participants in the project */
  totalNumberOfParticipants: Scalars['Int'];
};

/** Representation of a product that is available for PreEnrollment */
export type PreEnrollmentProduct = {
  __typename?: 'PreEnrollmentProduct';
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** Optional launch at time (if known). */
  launchAt?: Maybe<Timestamp>;
  /** Pre enrollment state of the given product */
  state: PreEnrollment_PreEnrollmentProductState;
  /** Underlying product item id */
  underlyingProductItemId: Scalars['ID'];
  /** Underlying product type. */
  underlyingProductType: PreEnrollment_ProductType;
};

/** TODO: Complete this description */
export const PreEnrollmentType = {
  /**
   * This PreEnrollmentType will (attempt) to auto enroll the learner using their C+ or Enterprise
   * membership at the time of product launch.
   */
  AutoEnroll: 'AUTO_ENROLL',
  /**
   * This PreEnrollmentType will require an additional capturePaymentWalletId step to be completed.
   * When the product is launched, the Learner will automatically be charged and enrolled.
   */
  PaymentWalletCapture: 'PAYMENT_WALLET_CAPTURE'
} as const;

export type PreEnrollmentType = typeof PreEnrollmentType[keyof typeof PreEnrollmentType];
/** Representation of different states of pre-enrollment/enrollment a product can be in. */
export const PreEnrollment_PreEnrollmentProductState = {
  /** All pre-enrolled learners are now enrolled into the product. */
  CompletedEnrollments: 'COMPLETED_ENROLLMENTS',
  /** Product is open for pre-enrollment and learners can actively pre-enroll. */
  OpenForPreEnrollment: 'OPEN_FOR_PRE_ENROLLMENT',
  /** Product is now launched and pre-enrolled learners are ready to be enrolled. */
  ReadyToEnroll: 'READY_TO_ENROLL'
} as const;

export type PreEnrollment_PreEnrollmentProductState = typeof PreEnrollment_PreEnrollmentProductState[keyof typeof PreEnrollment_PreEnrollmentProductState];
/** Product types */
export const PreEnrollment_ProductType = {
  /** Subscription product */
  Specialization: 'SPECIALIZATION',
  /** Specialization sold as a subscription */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION'
} as const;

export type PreEnrollment_ProductType = typeof PreEnrollment_ProductType[keyof typeof PreEnrollment_ProductType];
/** Parameter for querying degree categories when premium learning products are required in the results. */
export type PremiumLearningProductSpecs = {
  /** Availability status of the premium products to be retrieved. */
  catalogAvailabilityStatuses?: InputMaybe<Array<Scalars['String']>>;
  /** Pagination parameters for premium product collection. */
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** Response object that represents premium learning products. */
export type PremiumLearningProductsResponse = {
  __typename?: 'PremiumLearningProductsResponse';
  /** Premium Products Collection Learning Products. */
  learningProducts?: Maybe<Array<Maybe<PremiumProductCollections_LearningProduct>>>;
  /** Pagination parameters for premium products collection. */
  paginationResponse?: Maybe<PaginationResponse>;
  /** Value propositions */
  valuePropositions?: Maybe<Array<PremiumProductCollections_ValueProposition>>;
};

/** TODO: Complete this description */
export type PremiumProductCollectionsQueries = {
  __typename?: 'PremiumProductCollectionsQueries';
  /** Returns a degree/mastertrack by slug */
  getBySlug?: Maybe<PremiumProductCollections_LearningProduct>;
  /** Returns a list of degrees with stackable content */
  getStackableDegrees: Array<Degree_Degree>;
  /**
   * Returns a paginated list of degreees with stackable content
   * filtered by the given domain
   * ordered by DRE ranking
   */
  getStackableDegreesByDomain?: Maybe<PremiumProductCollections_PaginatedDegreesResponse>;
  /** Returns a list of courses that stack into degrees */
  getStackingCourses: Array<Course_Course>;
  /** Return a list of courses and certificates that stack into degrees */
  getStackingCoursesOrCertificates: Array<PremiumProductCollections_Course | PremiumProductCollections_MasterTrack | PremiumProductCollections_Specialization>;
  /** Returns a list of specializations that stack into degrees for Logged out home page */
  getStackingSpecializations: Array<Specialization_Specialization>;
  /** Returns the degrees/mastertracks for the given ids */
  multiGetDegrees?: Maybe<Array<Maybe<PremiumProductCollections_LearningProduct>>>;
  /**
   * Returns a list of degrees under the given degree marketing type
   * TODO:
   * The response is a list of degrees without pagination. Number of degrees is expected to be small (< 100).
   * Pagination is non-trivial for this query, because the order of the degrees can change from query to query based on
   * real-time ML ranking. Will come up with proper pagination latter when we foresee substantial growth of degrees.
   */
  queryByMarketingType: Array<Degree_Degree>;
  /** This query returns a collection of learning products that match the input filters. */
  queryCollection?: Maybe<Array<Maybe<PremiumProductCollections_LearningProduct>>>;
  /**
   * This query returns a collection of paginated learning products that match the input filters. It also returns degrees for
   * the different value props. Value prop response is only meaningful for the first page.
   */
  queryCollectionPaginated?: Maybe<PremiumLearningProductsResponse>;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesGetBySlugArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesGetStackableDegreesByDomainArgs = {
  domainSlug: Scalars['String'];
  paginationRequest?: InputMaybe<PaginationRequest>;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesMultiGetDegreesArgs = {
  ids: Array<Scalars['ID']>;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesQueryByMarketingTypeArgs = {
  marketingType: DegreeMarketing_MarketingType;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesQueryCollectionArgs = {
  input?: InputMaybe<PremiumProductCollections_QueryCollectionInput>;
};


/** TODO: Complete this description */
export type PremiumProductCollectionsQueriesQueryCollectionPaginatedArgs = {
  input?: InputMaybe<PremiumProductCollections_QueryCollectionInput>;
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** A list item that is either a certificate or a course */
export type PremiumProductCollections_CertificateOrCourse = {
  /** Meaningless id */
  id: Scalars['ID'];
};

/** Course */
export type PremiumProductCollections_Course = PremiumProductCollections_CertificateOrCourse & {
  __typename?: 'PremiumProductCollections_Course';
  /** The Course */
  course?: Maybe<Course_Course>;
  /** Meaningless id */
  id: Scalars['ID'];
};

/** Degree Attributes. Contains extra metadata about a premium product. */
export type PremiumProductCollections_DegreeAttributes = {
  __typename?: 'PremiumProductCollections_DegreeAttributes';
  /** Whether the degree requires a bachelor's degree */
  degreeRequiresBachelorDegree?: Maybe<Scalars['Boolean']>;
  /** Whether the degree has an application fee */
  hasApplicationFee?: Maybe<Scalars['Boolean']>;
  /** Whether the degree has a scholarship */
  hasScholarship?: Maybe<Scalars['Boolean']>;
  /** The number of courses in the degree */
  numCourses?: Maybe<Scalars['Int']>;
  /** The number of credits in the degree */
  numCredits?: Maybe<Scalars['Int']>;
  /** The number of modules in the degree */
  numModules?: Maybe<Scalars['Int']>;
  /** The number of cohorts for the degree */
  numberOfCohorts?: Maybe<Scalars['Int']>;
  /** The on campus tuition for the degree */
  onCampusTuition?: Maybe<Scalars['Float']>;
  /** Whether the online tuition is the same as the on campus tuition */
  onlineSameAsOnCampus?: Maybe<Scalars['Boolean']>;
  /** Whether the degree is pay as you go */
  payAsYouGo?: Maybe<Scalars['Boolean']>;
  /** The primary aligned job for the degree */
  primaryAlignedJob?: Maybe<Scalars['String']>;
  /** The QS ranking for the degree */
  qsRanking?: Maybe<Scalars['Int']>;
  /** The tuition in USD for the degree */
  tuitionInUsd?: Maybe<Scalars['Float']>;
  /** The webinar host for the degree */
  webinarHost?: Maybe<Scalars['String']>;
};

/** MasterTrack */
export type PremiumProductCollections_MasterTrack = PremiumProductCollections_CertificateOrCourse & {
  __typename?: 'PremiumProductCollections_MasterTrack';
  /** Meaningless id */
  id: Scalars['ID'];
  /** The MasterTrack */
  masterTrack?: Maybe<Degree_Degree>;
};

/** Paginated response for degrees */
export type PremiumProductCollections_PaginatedDegreesResponse = {
  __typename?: 'PremiumProductCollections_PaginatedDegreesResponse';
  /** List of degrees */
  elements: Array<Degree_Degree>;
  /** Pagination metadata */
  pagination?: Maybe<PaginationResponse>;
};

/** Specialization */
export type PremiumProductCollections_Specialization = PremiumProductCollections_CertificateOrCourse & {
  __typename?: 'PremiumProductCollections_Specialization';
  /** Meaningless id */
  id: Scalars['ID'];
  /** The specialization */
  specialization?: Maybe<Specialization_Specialization>;
};

/** Value Proposition is a list of degrees selected based on a specific criteria. */
export type PremiumProductCollections_ValueProposition = {
  __typename?: 'PremiumProductCollections_ValueProposition';
  /** Id of the value proposition */
  id: Scalars['ID'];
  /** List of learning products promoted for the value proposition */
  learningProducts: Array<PremiumProductCollections_LearningProduct>;
};

/** A premium learning product. Includes degrees, mastertracks, and certificates. */
export type PremiumProductCollections_LearningProduct = {
  __typename?: 'PremiumProductCollections_learningProduct';
  /** List of countries the learning item is blocked in */
  blockedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Catalog availability status */
  catalogAvailabilityStatus: Scalars['String'];
  /** Categories such as BUSINESS or DATA_ANALYTICS */
  categoryIds: Array<Maybe<Scalars['String']>>;
  /** Degree attributes. metadata. */
  degreeAttributes?: Maybe<PremiumProductCollections_DegreeAttributes>;
  /** Domains that the product falls in, such as business */
  domainIds: Array<Maybe<Scalars['String']>>;
  /** The ID of the learning product. */
  id: Scalars['ID'];
  /** The URL of the image for the learning product. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Language code of the learning product. */
  languageCode: Scalars['String'];
  /** Launch date of the learning product. */
  launchDate?: Maybe<Scalars['String']>;
  /** The name of the learning product. */
  name: Scalars['String'];
  /** The partners for the learning product. */
  partnerEntities: Array<Partner_Partner>;
  /**
   * The partner IDs for the learning product - used internally.
   * @deprecated use partnerEntities instead
   */
  partnerIds: Array<Maybe<Scalars['String']>>;
  /**
   * The partners for the learning product.
   * @deprecated use partnerEntities instead
   */
  partners: Array<Maybe<PremiumProductCollections_Partner>>;
  /** Indicator of whether this is a degree, MT, degree backed Professional Certificate, etc. */
  productVariant: Scalars['String'];
  /** Program Deadlines */
  programDeadlines: Array<DegreeMarketing_Deadline>;
  /** Short Name of the learning product. */
  shortName: Scalars['String'];
  /** The slug of the learning product. */
  slug: Scalars['String'];
  /** Tagline of the learning product. */
  tagline: Scalars['String'];
  /** The URL of the thumbnail image for the learning product. */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** Upcoming term dates for the learning product. */
  upcomingTermDates?: Maybe<PremiumProductCollections_UpcomingTermDates>;
};

/** TODO: Complete this description */
export type PremiumProductCollections_Partner = {
  __typename?: 'PremiumProductCollections_partner';
  /** The ID of the partner. */
  id: Scalars['ID'];
  /** Location information for the partner. */
  location?: Maybe<PremiumProductCollections_PartnerLocation>;
  /** The square logo for the partner. */
  logo?: Maybe<Scalars['String']>;
  /** The name of the partner. */
  name: Scalars['String'];
  /** The primary color of the partner that can be used for styling, e.g. in degree cards. */
  primaryColor?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type PremiumProductCollections_PartnerLocation = {
  __typename?: 'PremiumProductCollections_partnerLocation';
  /** city of the location */
  city?: Maybe<Scalars['String']>;
  /** country of the location */
  country?: Maybe<Scalars['String']>;
  /** latitude of the location */
  latitude?: Maybe<Scalars['Float']>;
  /** longitude of the location */
  longitude?: Maybe<Scalars['Float']>;
  /** Name of the Location */
  name?: Maybe<Scalars['String']>;
  /** state of the location */
  state?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type PremiumProductCollections_QueryCollectionInput = {
  /** Catalog availability status */
  catalogAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of degree category ids. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of browse domain ids. */
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of product variants. */
  productVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * For now, the upcomingTermDates only applies to degree program, but it might be applied to
 * MTC/professionalCert in the future.
 */
export type PremiumProductCollections_UpcomingTermDates = {
  __typename?: 'PremiumProductCollections_upcomingTermDates';
  /** The soonest admittable academic term of this program. */
  nextAcademicTermStartDate?: Maybe<Timestamp>;
  /** The final deadline of next admission term. */
  nextAdmissionDeadlineDate?: Maybe<Timestamp>;
  /**
   *  The soonest admission/application term of which the start date or
   * deadline date has not passed, which can be upcoming or ongoing.
   */
  nextAdmissionStartDate?: Maybe<Timestamp>;
  /** The soonest subterm deadline */
  nextAdmissionSubtermDeadlineDate?: Maybe<Timestamp>;
};

export type PresetCollectionsV1 = {
  __typename?: 'PresetCollectionsV1';
  _0all: Scalars['String'];
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  createdBy: Scalars['Int'];
  curriculumItems: Array<Maybe<PresetCollectionsV1_CurriculumItems>>;
  description?: Maybe<PresetCollectionsV1_CmlMember>;
  gradient?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isLearningPath?: Maybe<Scalars['Boolean']>;
  latestUpdatedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  latestUpdatedBy?: Maybe<Scalars['Int']>;
  occupationGroupIdCareerBandMapping?: Maybe<Scalars['String']>;
  pageConfig?: Maybe<PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionPageConfig>;
  primaryLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  secondaryDescription?: Maybe<PresetCollectionsV1_SecondaryDescription>;
  skillAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  usageCount: Scalars['Int'];
};

export type PresetCollectionsV1ByPageSlug = {
  __typename?: 'PresetCollectionsV1ByPageSlug';
  connection?: Maybe<PresetCollectionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PresetCollectionsV1Connection = {
  __typename?: 'PresetCollectionsV1Connection';
  elements: Array<Maybe<PresetCollectionsV1>>;
  paging: ResponsePagination;
};

export type PresetCollectionsV1Pages = {
  __typename?: 'PresetCollectionsV1Pages';
  connection?: Maybe<PresetCollectionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type PresetCollectionsV1Resource = {
  __typename?: 'PresetCollectionsV1Resource';
  byPageSlug?: Maybe<PresetCollectionsV1Connection>;
  get?: Maybe<PresetCollectionsV1>;
  getAll?: Maybe<PresetCollectionsV1Connection>;
  multiGet?: Maybe<PresetCollectionsV1Connection>;
  pages?: Maybe<PresetCollectionsV1Connection>;
};


export type PresetCollectionsV1ResourceByPageSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PresetCollectionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PresetCollectionsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PresetCollectionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PresetCollectionsV1ResourcePagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type PresetCollectionsV1ResourceMutations = {
  __typename?: 'PresetCollectionsV1ResourceMutations';
  create?: Maybe<PresetCollectionsV1Connection>;
  delete?: Maybe<PresetCollectionsV1Connection>;
  multiDelete?: Maybe<Scalars['JSON']>;
  update?: Maybe<PresetCollectionsV1Connection>;
};


export type PresetCollectionsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type PresetCollectionsV1ResourceMutationsMultiDeleteArgs = {
  ids: Scalars['String'];
};


export type PresetCollectionsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type PresetCollectionsV1_CmlMember = {
  __typename?: 'PresetCollectionsV1_cmlMember';
  cml: PresetCollectionsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type PresetCollectionsV1_CourseIdMember = {
  __typename?: 'PresetCollectionsV1_courseIdMember';
  courseId: PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionCourseItemId;
};

export type PresetCollectionsV1_CuratorDescription = DummyType | PresetCollectionsV1_CmlMember;

export type PresetCollectionsV1_CuratorHeader = DummyType | PresetCollectionsV1_CmlMember;

/** A near replica of CurriculumItemId trimmed for use in populating preset collections in collection pages. Slack thread https://coursera.slack.com/archives/CBG5M6GT0/p1588954744028800 */
export type PresetCollectionsV1_CurriculumItems = PresetCollectionsV1_CourseIdMember | PresetCollectionsV1_DegreeIdMember | PresetCollectionsV1_S12nIdMember;

export type PresetCollectionsV1_DegreeIdMember = {
  __typename?: 'PresetCollectionsV1_degreeIdMember';
  degreeId: PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionDegreeItemId;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type PresetCollectionsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'PresetCollectionsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<PresetCollectionsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type PresetCollectionsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'PresetCollectionsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<PresetCollectionsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type PresetCollectionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'PresetCollectionsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: PresetCollectionsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type PresetCollectionsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'PresetCollectionsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type PresetCollectionsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'PresetCollectionsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<PresetCollectionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionCourseItemId = {
  __typename?: 'PresetCollectionsV1_org_coursera_program_curriculum_preset_collection_CollectionCourseItemId';
  id: Scalars['String'];
};

export type PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionDegreeItemId = {
  __typename?: 'PresetCollectionsV1_org_coursera_program_curriculum_preset_collection_CollectionDegreeItemId';
  /** Identifier for a degree. */
  id: Scalars['String'];
};

export type PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionPageConfig = {
  __typename?: 'PresetCollectionsV1_org_coursera_program_curriculum_preset_collection_CollectionPageConfig';
  curatorDescription?: Maybe<PresetCollectionsV1_CuratorDescription>;
  curatorHeader?: Maybe<PresetCollectionsV1_CuratorHeader>;
  isVisibleToLearners: Scalars['Boolean'];
  relatedCollections: Array<Maybe<Scalars['String']>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export type PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionS12nItemId = {
  __typename?: 'PresetCollectionsV1_org_coursera_program_curriculum_preset_collection_CollectionS12nItemId';
  id: Scalars['String'];
};

export type PresetCollectionsV1_S12nIdMember = {
  __typename?: 'PresetCollectionsV1_s12nIdMember';
  s12nId: PresetCollectionsV1_Org_Coursera_Program_Curriculum_Preset_Collection_CollectionS12nItemId;
};

export type PresetCollectionsV1_SecondaryDescription = DummyType | PresetCollectionsV1_CmlMember;

/** TODO: Complete this description */
export type ProctorQueries = {
  __typename?: 'ProctorQueries';
  /** TODO: Complete this description */
  getLatestOverrideForAssignmentSubmitter: Proctor_OverrideSubmitterProctorConfigOutput;
};


/** TODO: Complete this description */
export type ProctorQueriesGetLatestOverrideForAssignmentSubmitterArgs = {
  assessmentId: Scalars['String'];
  submitterId: Scalars['String'];
};

/** TODO: Complete this description */
export type Proctor_OverrideSubmitterProctorConfigInput = {
  /** TODO: Complete this description */
  assessmentId: Scalars['String'];
  /** TODO: Complete this description */
  attemptDuration?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  maxAttempts?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  maxSubmissionsPerAttempt?: InputMaybe<Scalars['Int']>;
  /** TODO: Complete this description */
  submitterId: Scalars['String'];
};

/** TODO: Complete this description */
export type Proctor_OverrideSubmitterProctorConfigOutput = {
  __typename?: 'Proctor_overrideSubmitterProctorConfigOutput';
  /** TODO: Complete this description */
  attemptDuration?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  createdTimestamp: Timestamp;
  /** TODO: Complete this description */
  maxAttempts?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  maxSubmissionsPerAttempt?: Maybe<Scalars['Int']>;
};

/** Represents a course or specialization or degree or mastertrack */
export type Product = {
  __typename?: 'Product';
  /** Id of the course or specialization or degree or mastertrack */
  id: Scalars['ID'];
  /** The product name */
  name?: Maybe<Scalars['String']>;
  /** The product slug */
  slug?: Maybe<Scalars['String']>;
  /** Product type, COURSE or SPECIALIZATION or DEGREE or MASTERTRACK */
  type: Scalars['String'];
  /** Upsell product definition */
  upsellProduct?: Maybe<UpsellQueries_Course | UpsellQueries_Degree | UpsellQueries_Mastertrack | UpsellQueries_Specialization>;
};

export type ProductActionEligibilitiesV1 = {
  __typename?: 'ProductActionEligibilitiesV1';
  currentlyOwns: Scalars['Boolean'];
  id: Scalars['String'];
  ineligibilityReason?: Maybe<Scalars['String']>;
  isEligible: Scalars['Boolean'];
  productId: ProductActionEligibilitiesV1_Org_Coursera_Product_ProductId;
  refundIneligibilityReasonCode?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type ProductActionEligibilitiesV1Connection = {
  __typename?: 'ProductActionEligibilitiesV1Connection';
  elements: Array<Maybe<ProductActionEligibilitiesV1>>;
  paging: ResponsePagination;
};

export type ProductActionEligibilitiesV1Resource = {
  __typename?: 'ProductActionEligibilitiesV1Resource';
  get?: Maybe<ProductActionEligibilitiesV1>;
  multiGet?: Maybe<ProductActionEligibilitiesV1Connection>;
};


export type ProductActionEligibilitiesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductActionEligibilitiesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProductActionEligibilitiesV1_Org_Coursera_Product_ProductId = {
  __typename?: 'ProductActionEligibilitiesV1_org_coursera_product_ProductId';
  productItemId: Scalars['String'];
};

/** All ProductCard queries */
export type ProductCardQueries = {
  __typename?: 'ProductCardQueries';
  /** Fetch a product card by key */
  queryByKey?: Maybe<ProductCard_ProductCard>;
  /** Fetch multiple product cards using a list of product card keys */
  queryByKeys: Array<Maybe<ProductCard_ProductCard>>;
};


/** All ProductCard queries */
export type ProductCardQueriesQueryByKeyArgs = {
  key: ProductCard_Key;
};


/** All ProductCard queries */
export type ProductCardQueriesQueryByKeysArgs = {
  productCardKeys: Array<ProductCard_Key>;
};

/** Enum of canonical types for product card. */
export const ProductCard_CanonicalType = {
  /** Clip canonical type. */
  Clip: 'CLIP',
  /** Course canonical type. */
  Course: 'COURSE',
  /** Degree canonical type. */
  Degree: 'DEGREE',
  /** Learning Path canonical type. */
  LearningPath: 'LEARNING_PATH',
  /** Specialization canonical type. */
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductCard_CanonicalType = typeof ProductCard_CanonicalType[keyof typeof ProductCard_CanonicalType];
/**
 * ProductCard clip type.
 * WARNING: CLIPS ARE NOT SUPPORTED YET. ALL CLIP REQUESTS RETURN NOT FOUND.
 */
export type ProductCard_Clip = {
  __typename?: 'ProductCard_Clip';
  /** A reference to the canonical entity object. */
  canonical: Clip_CourseItem;
};

/** ProductCard course type. */
export type ProductCard_Course = {
  __typename?: 'ProductCard_Course';
  /** A reference to the canonical entity object. */
  canonical: Course_Course;
  /** If the course is free. */
  isFree: Scalars['Boolean'];
  /** If the course is part of Coursera Plus. */
  isPartOfCourseraPlus: Scalars['Boolean'];
  /** Indicted whether the content is part of a degree or can be offered as credit towards a degree. */
  isPathwayContent: Scalars['Boolean'];
  /** The weighted average rating for the course. */
  rating: Scalars['Float'];
  /** The number of reviews for the course. */
  reviewCount: Scalars['Int'];
};

/** ProductCard degree type. */
export type ProductCard_Degree = {
  __typename?: 'ProductCard_Degree';
  /** A reference to the canonical entity object. */
  canonical: Degree_Degree;
};

/** The unique identifier of a product card. We name it "key" instead of "id" to prevent confusion with the `id` field within this type. */
export type ProductCard_Key = {
  /** The canonical type of the product requested. */
  canonicalType: ProductCard_CanonicalType;
  /** The entity ID. Examples: "GdeNrll1EeSROyIACtiVvg", "base~7KkNm4CtRpifVWmOqPrNyA" */
  id: Scalars['ID'];
};

/** ProductCard learning path type. */
export type ProductCard_LearningPath = {
  __typename?: 'ProductCard_LearningPath';
  /** A reference to the canonical entity object. */
  canonical: ProductCard_LearningPathCanonical;
};

/** Union to represent all types of learning path */
export type ProductCard_LearningPathCanonical = EnterpriseBadge_EnterpriseBadge;

/**
 * Union of all Product Card entity types.
 * WARNING: CLIPS ARE NOT SUPPORTED YET. ALL CLIP REQUESTS RETURN NOT FOUND.
 */
export type ProductCard_Product = ProductCard_Clip | ProductCard_Course | ProductCard_Degree | ProductCard_LearningPath | ProductCard_Specialization;

/** Product card stub */
export type ProductCard_ProductCard = {
  __typename?: 'ProductCard_ProductCard';
  /**
   * An array of badges to be displayed on the product card. Each badge is represented as a string.
   * Badges are typically used to highlight attractive features of the product, such as 'New', 'Free', 'Most Popular', etc.
   * This will not be paginated because 5 is the most badges allowed that makes sense for FE.
   */
  badges?: Maybe<Array<Scalars['String']>>;
  /** The canonical type of the product requested. This is used to determine the canonical entity type to resolve for. */
  canonicalType: ProductCard_CanonicalType;
  /** The product's id */
  id: Scalars['ID'];
  /** Product type identification for marketing purpose. It will be used to determine the type of product card to be displayed in the UI or other logic in the FE. */
  marketingProductType: ProductCard_ProductType;
  /** Attributes specific to the product type (currently aligned with canonical types). */
  productTypeAttributes: ProductCard_Product;
};

/**
 * Product types.
 * Defines specific types of product that are displayed to the user.
 * They may also be used as subcategories of products.
 * They differ from canonical types as they do not have a one-to-one mapping with them.
 */
export const ProductCard_ProductType = {
  /** Course product type. */
  Course: 'COURSE',
  /** Degree product type. */
  Degree: 'DEGREE',
  /** Graduate Certificate product type. */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Guided Project product type. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Learning Path product type. */
  LearningPath: 'LEARNING_PATH',
  /** Lesson product type. */
  Lesson: 'LESSON',
  /** MasterTrack product type. */
  Mastertrack: 'MASTERTRACK',
  /** Postgraduate Diploma product type. */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Professional Certificate product type. */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type. */
  Project: 'PROJECT',
  /** Specialization product type. */
  Specialization: 'SPECIALIZATION',
  /** University Certificate product type. */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Video product type. */
  Video: 'VIDEO'
} as const;

export type ProductCard_ProductType = typeof ProductCard_ProductType[keyof typeof ProductCard_ProductType];
/** ProductCard specialization type. */
export type ProductCard_Specialization = {
  __typename?: 'ProductCard_Specialization';
  /** A reference to the canonical entity object. */
  canonical: Specialization_Specialization;
  /** An array of the product cards associated with the constituent courses that form the specialization. */
  courseCards: Array<ProductCard_ProductCard>;
  /** Whether the course has a top instructor. */
  hasTopInstructor: Scalars['Boolean'];
  /** If the specialization is part of Coursera Plus. */
  isPartOfCourseraPlus: Scalars['Boolean'];
  /** Indicted whether the content is part of a degree or can be offered as credit towards a degree. */
  isPathwayContent: Scalars['Boolean'];
  /** The weighted average rating for the specialization. */
  rating: Scalars['Float'];
  /** The number of reviews for the specialization. */
  reviewCount: Scalars['Int'];
  /** The total number of assignments. */
  totalAssignmentCount: Scalars['Int'];
};

export type ProductItemDetailsV1 = {
  __typename?: 'ProductItemDetailsV1';
  id: Scalars['String'];
  productItemId: Scalars['String'];
  productName: Scalars['String'];
  productUrl: Scalars['String'];
};

export type ProductItemDetailsV1Connection = {
  __typename?: 'ProductItemDetailsV1Connection';
  elements: Array<Maybe<ProductItemDetailsV1>>;
  paging: ResponsePagination;
};

export type ProductItemDetailsV1Resource = {
  __typename?: 'ProductItemDetailsV1Resource';
  get?: Maybe<ProductItemDetailsV1>;
  multiGet?: Maybe<ProductItemDetailsV1Connection>;
};


export type ProductItemDetailsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductItemDetailsV1ResourceMultiGetArgs = {
  ids: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProductOwnershipsV2 = {
  __typename?: 'ProductOwnershipsV2';
  expiredOwns: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['Float']>;
  firstOwnedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  lastUpdated?: Maybe<Scalars['Float']>;
  optedOutOfVerification: Scalars['Boolean'];
  owns: Scalars['Boolean'];
  pendingConfirmation: Scalars['Boolean'];
  productId: Scalars['String'];
  s12nCourseOwnerships: Array<Maybe<ProductOwnershipsV2_Org_Coursera_Product_Ownership_CourseOwnership>>;
  userId: Scalars['Int'];
};

export type ProductOwnershipsV2Connection = {
  __typename?: 'ProductOwnershipsV2Connection';
  elements: Array<Maybe<ProductOwnershipsV2>>;
  paging: ResponsePagination;
};

export type ProductOwnershipsV2GetStoredByUser = {
  __typename?: 'ProductOwnershipsV2GetStoredByUser';
  connection?: Maybe<ProductOwnershipsV2Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  ownsAndExpiredOwnsFilter?: Maybe<Scalars['Boolean']>;
  ownsFilter?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type ProductOwnershipsV2Resource = {
  __typename?: 'ProductOwnershipsV2Resource';
  get?: Maybe<ProductOwnershipsV2>;
  getStoredByUser?: Maybe<ProductOwnershipsV2Connection>;
  multiGet?: Maybe<ProductOwnershipsV2Connection>;
};


export type ProductOwnershipsV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductOwnershipsV2ResourceGetStoredByUserArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  ownsAndExpiredOwnsFilter?: InputMaybe<Scalars['Boolean']>;
  ownsFilter?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProductOwnershipsV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProductOwnershipsV2_Org_Coursera_Product_Ownership_CourseOwnership = {
  __typename?: 'ProductOwnershipsV2_org_coursera_product_ownership_CourseOwnership';
  courseId: Scalars['String'];
  owns: Scalars['Boolean'];
};

export type ProductPricesV4 = {
  __typename?: 'ProductPricesV4';
  amount: Scalars['String'];
  countryIsoCode: Scalars['String'];
  couponId?: Maybe<Scalars['Int']>;
  finalAmount: Scalars['String'];
  formattedFinalAmount: ProductPricesV4_Org_Coursera_Payment_Price_FormattedPriceWithCurrency;
  fxRateId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  liableForTax: Scalars['Boolean'];
  priceCountryIsoCode: Scalars['String'];
  productItemId: Scalars['String'];
  productPriceId: Scalars['Float'];
  productPriceIdV2?: Maybe<Scalars['String']>;
  promotionInfo?: Maybe<ProductPricesV4_Org_Coursera_Payment_Price_ProductPricePromotionInfo>;
  userSessionStatus: Scalars['String'];
};

export type ProductPricesV4ByProductIds = {
  __typename?: 'ProductPricesV4ByProductIds';
  connection?: Maybe<ProductPricesV4Connection>;
  limit?: Maybe<Scalars['Int']>;
  productIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type ProductPricesV4Connection = {
  __typename?: 'ProductPricesV4Connection';
  elements: Array<Maybe<ProductPricesV4>>;
  paging: ResponsePagination;
};

export type ProductPricesV4PreviewDiscountedPrices = {
  __typename?: 'ProductPricesV4PreviewDiscountedPrices';
  connection?: Maybe<ProductPricesV4Connection>;
  countryIsoCode?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  previewPromoCodeId: Scalars['String'];
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProductPricesV4Resource = {
  __typename?: 'ProductPricesV4Resource';
  byProductIds?: Maybe<ProductPricesV4Connection>;
  get?: Maybe<ProductPricesV4>;
  previewDiscountedPrices?: Maybe<ProductPricesV4Connection>;
};


export type ProductPricesV4ResourceByProductIdsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProductPricesV4ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductPricesV4ResourcePreviewDiscountedPricesArgs = {
  countryIsoCode?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  previewPromoCodeId: Scalars['String'];
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type ProductPricesV4ResourceMutations = {
  __typename?: 'ProductPricesV4ResourceMutations';
  computePriceWithCartItemMetadata?: Maybe<Scalars['JSON']>;
};


export type ProductPricesV4ResourceMutationsComputePriceWithCartItemMetadataArgs = {
  countryIsoCode: Scalars['String'];
  couponId?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  productId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type ProductPricesV4_Org_Coursera_Payment_Price_FormattedPriceWithCurrency = {
  __typename?: 'ProductPricesV4_org_coursera_payment_price_FormattedPriceWithCurrency';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
  currencyId: Scalars['Float'];
  currencySymbol: Scalars['String'];
  formattedString: Scalars['String'];
};

export type ProductPricesV4_Org_Coursera_Payment_Price_ProductPricePromotionInfo = {
  __typename?: 'ProductPricesV4_org_coursera_payment_price_ProductPricePromotionInfo';
  discountAmount: Scalars['String'];
  discountPercent?: Maybe<Scalars['Int']>;
  promotionId: Scalars['Int'];
  promotionName: Scalars['String'];
};

export type ProductReviewOverviewV1 = {
  __typename?: 'ProductReviewOverviewV1';
  averageFiveStarRating: Scalars['Float'];
  countsByStar: Scalars['JSON'];
  id: Scalars['String'];
  productId: Scalars['String'];
  productType: ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType;
  totalReviewCount: Scalars['Float'];
};

export type ProductReviewOverviewV1ByProduct = {
  __typename?: 'ProductReviewOverviewV1ByProduct';
  connection?: Maybe<ProductReviewOverviewV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productCompleted?: Maybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProductReviewOverviewV1Connection = {
  __typename?: 'ProductReviewOverviewV1Connection';
  elements: Array<Maybe<ProductReviewOverviewV1>>;
  paging: ResponsePagination;
};

export type ProductReviewOverviewV1Resource = {
  __typename?: 'ProductReviewOverviewV1Resource';
  byProduct?: Maybe<ProductReviewOverviewV1Connection>;
};


export type ProductReviewOverviewV1ResourceByProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productCompleted?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType = typeof ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof ProductReviewOverviewV1_Org_Coursera_Catalogp_Browse_ProductType];
export type ProductReviewsV1 = {
  __typename?: 'ProductReviewsV1';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isMarkedHelpful: Scalars['Boolean'];
  mostHelpfulVoteCount?: Maybe<Scalars['Int']>;
  productCompleted?: Maybe<Scalars['Boolean']>;
  productId: ProductReviewsV1_Org_Coursera_Xdp_XdpProductId;
  rating: Scalars['Int'];
  reviewText?: Maybe<ProductReviewsV1_CmlMember>;
  reviewedAt: Scalars['Float'];
  userId: Scalars['Int'];
};

export type ProductReviewsV1ByProduct = {
  __typename?: 'ProductReviewsV1ByProduct';
  connection?: Maybe<ProductReviewsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productCompleted?: Maybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  ratingValues?: Maybe<Array<Maybe<Scalars['Int']>>>;
  sortByHelpfulVotes?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type ProductReviewsV1Connection = {
  __typename?: 'ProductReviewsV1Connection';
  elements: Array<Maybe<ProductReviewsV1>>;
  paging: ResponsePagination;
};

export type ProductReviewsV1Resource = {
  __typename?: 'ProductReviewsV1Resource';
  byProduct?: Maybe<ProductReviewsV1Connection>;
  get?: Maybe<ProductReviewsV1>;
  multiGet?: Maybe<ProductReviewsV1Connection>;
};


export type ProductReviewsV1ResourceByProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productCompleted?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['String'];
  ratingValues?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortByHelpfulVotes?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProductReviewsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductReviewsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProductReviewsV1_CmlMember = {
  __typename?: 'ProductReviewsV1_cmlMember';
  cml: ProductReviewsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType = typeof ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType];
/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type ProductReviewsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'ProductReviewsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<ProductReviewsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type ProductReviewsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'ProductReviewsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<ProductReviewsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type ProductReviewsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'ProductReviewsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: ProductReviewsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type ProductReviewsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'ProductReviewsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type ProductReviewsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'ProductReviewsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<ProductReviewsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type ProductReviewsV1_Org_Coursera_Xdp_XdpProductId = {
  __typename?: 'ProductReviewsV1_org_coursera_xdp_XDPProductId';
  productId: Scalars['String'];
  productType: ProductReviewsV1_Org_Coursera_Catalogp_Browse_ProductType;
};

export type ProductSkusV1 = {
  __typename?: 'ProductSkusV1';
  iapSku?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  productItemId: Scalars['String'];
  productType: Scalars['String'];
  properties?: Maybe<ProductSkusV1_Properties>;
  underlyingProductId: Scalars['String'];
};

export type ProductSkusV1Connection = {
  __typename?: 'ProductSkusV1Connection';
  elements: Array<Maybe<ProductSkusV1>>;
  paging: ResponsePagination;
};

export type ProductSkusV1FindByIapSku = {
  __typename?: 'ProductSkusV1FindByIapSku';
  connection?: Maybe<ProductSkusV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  sku: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProductSkusV1FindByUnderlying = {
  __typename?: 'ProductSkusV1FindByUnderlying';
  connection?: Maybe<ProductSkusV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type ProductSkusV1FindByUnderlyingProductItemId = {
  __typename?: 'ProductSkusV1FindByUnderlyingProductItemId';
  connection?: Maybe<ProductSkusV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  underlyingProductItemId: Scalars['String'];
};

export type ProductSkusV1Resource = {
  __typename?: 'ProductSkusV1Resource';
  findByIapSku?: Maybe<ProductSkusV1Connection>;
  findByUnderlying?: Maybe<ProductSkusV1Connection>;
  findByUnderlyingProductItemId?: Maybe<ProductSkusV1Connection>;
  get?: Maybe<ProductSkusV1>;
  multiGet?: Maybe<ProductSkusV1Connection>;
};


export type ProductSkusV1ResourceFindByIapSkuArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProductSkusV1ResourceFindByUnderlyingArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProductSkusV1ResourceFindByUnderlyingProductItemIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  underlyingProductItemId: Scalars['String'];
};


export type ProductSkusV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProductSkusV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProductSkusV1ResourceMutations = {
  __typename?: 'ProductSkusV1ResourceMutations';
  createFromUnderlying?: Maybe<Scalars['JSON']>;
  expireProduct?: Maybe<Scalars['JSON']>;
};

export const ProductSkusV1_Org_Coursera_Product_BillingCycle = {
  Annual: 'ANNUAL',
  Biannual: 'BIANNUAL',
  Monthly: 'MONTHLY'
} as const;

export type ProductSkusV1_Org_Coursera_Product_BillingCycle = typeof ProductSkusV1_Org_Coursera_Product_BillingCycle[keyof typeof ProductSkusV1_Org_Coursera_Product_BillingCycle];
/** Product properties associated with one-time payment products. */
export type ProductSkusV1_Org_Coursera_Product_PrepaidProductProperties = {
  __typename?: 'ProductSkusV1_org_coursera_product_PrepaidProductProperties';
  ownershipDays: Scalars['Int'];
  refundDays: Scalars['Int'];
};

export type ProductSkusV1_Org_Coursera_Product_PrepaidProductPropertiesMember = {
  __typename?: 'ProductSkusV1_org_coursera_product_PrepaidProductPropertiesMember';
  org_coursera_product_PrepaidProductProperties: ProductSkusV1_Org_Coursera_Product_PrepaidProductProperties;
};

export type ProductSkusV1_Org_Coursera_Product_SubscriptionProductProperties = {
  __typename?: 'ProductSkusV1_org_coursera_product_SubscriptionProductProperties';
  billingCycle: ProductSkusV1_Org_Coursera_Product_BillingCycle;
  numberOfCycles?: Maybe<Scalars['Int']>;
  numberOfTrialDays: Scalars['Int'];
  refundDays?: Maybe<Scalars['Int']>;
  status: ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus;
};

export type ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesMember = {
  __typename?: 'ProductSkusV1_org_coursera_product_SubscriptionProductPropertiesMember';
  org_coursera_product_SubscriptionProductProperties: ProductSkusV1_Org_Coursera_Product_SubscriptionProductProperties;
};

export const ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED'
} as const;

export type ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus = typeof ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus[keyof typeof ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesStatus];
/** Properties associated to a product offering. Will be refactored out in separate tables as part of Next Gen Product Configuration project in Q2 2021. */
export type ProductSkusV1_Properties = ProductSkusV1_Org_Coursera_Product_PrepaidProductPropertiesMember | ProductSkusV1_Org_Coursera_Product_SubscriptionProductPropertiesMember;

export type ProfessionalCertsV1 = {
  __typename?: 'ProfessionalCertsV1';
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  partnerSquareLogo?: Maybe<Scalars['String']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type ProfessionalCertsV1ByPartnerId = {
  __typename?: 'ProfessionalCertsV1ByPartnerId';
  connection?: Maybe<ProfessionalCertsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProfessionalCertsV1Connection = {
  __typename?: 'ProfessionalCertsV1Connection';
  elements: Array<Maybe<ProfessionalCertsV1>>;
  paging: ResponsePagination;
};

export type ProfessionalCertsV1Resource = {
  __typename?: 'ProfessionalCertsV1Resource';
  byPartnerId?: Maybe<ProfessionalCertsV1Connection>;
  getAll?: Maybe<ProfessionalCertsV1Connection>;
};


export type ProfessionalCertsV1ResourceByPartnerIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProfessionalCertsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Queries for profile consents */
export type ProfileConsentsQueries = {
  __typename?: 'ProfileConsentsQueries';
  /** Returns the profile consents of the current user. User ID is derived from request context. */
  me?: Maybe<User_ProfileConsents>;
};

/** ProfileConsents_AddProfileConsents mutation Error. */
export type ProfileConsents_AddError = Error & {
  __typename?: 'ProfileConsents_AddError';
  /** Error message */
  message: Scalars['String'];
};

/** Returned on ProfileConsents_AddProfileConsents mutation failure. */
export type ProfileConsents_AddFailure = {
  __typename?: 'ProfileConsents_AddFailure';
  /** List of errors causing failure */
  errors: Array<ProfileConsents_AddError>;
};

/** Input to add profile consents */
export type ProfileConsents_AddProfileConsentsInput = {
  /** Boolean indicating the user consents to Coursera's Terms of Use and Privacy Policy. */
  consentToTermsOfUse: Scalars['Boolean'];
};

/** Result of adding profile consents */
export type ProfileConsents_AddProfileConsentsResult = ProfileConsents_AddFailure | ProfileConsents_AddSuccess;

/** Returned on ProfileConsents_AddProfileConsents mutation success. */
export type ProfileConsents_AddSuccess = {
  __typename?: 'ProfileConsents_AddSuccess';
  /** User's updated state of profile consents */
  consents?: Maybe<User_ProfileConsents>;
};

/** ProfileOccupationChoices queries */
export type ProfileOccupationChoicesQueries = {
  __typename?: 'ProfileOccupationChoicesQueries';
  /** Fetch the list of occupation choices by filtering tags. */
  queryOccupationChoices: ProfileOccupationChoices_OccupationChoiceFilterPaginatedResult;
};


/** ProfileOccupationChoices queries */
export type ProfileOccupationChoicesQueriesQueryOccupationChoicesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  occupationChoiceFilter?: InputMaybe<ProfileOccupationChoices_OccupationChoiceFilter>;
};

/** Enum for deman levels used to form an occupation tag */
export const ProfileOccupationChoices_DemandLevel = {
  /** High */
  High: 'HIGH',
  /** Low */
  Low: 'LOW',
  /** Not applicable */
  NotApplicable: 'NOT_APPLICABLE'
} as const;

export type ProfileOccupationChoices_DemandLevel = typeof ProfileOccupationChoices_DemandLevel[keyof typeof ProfileOccupationChoices_DemandLevel];
/** Enum for feature tags used to form an occupation tag */
export const ProfileOccupationChoices_FeatureTag = {
  /**
   * ACTIVELY_HIRING
   * Use this tag if there's an open rec for this role on our recruiting platform
   */
  ActivelyHiring: 'ACTIVELY_HIRING',
  /** BASELINE */
  Baseline: 'BASELINE',
  /**
   * BASELINE_V2
   * It is for profile autocompete with updated occupation taxonomy
   * that is exported by https://tools.coursera.org/mega/s3Export/YptlEMBxEeq0d_0D90PFFg~S3_EXPORT_JOB@1#jobEditor
   * This is supposed to replace the old occupation taxonomy tagged with `PLP_V1`
   * which were hardcoded and not being updated
   */
  BaselineV2: 'BASELINE_V2',
  /**
   * DEGREES_ONLY
   * Use this if user completed degrees onboarding (currently as part of the PLP onboarding UI)
   * with an existing degree, and did NOT fill out occupation/skills/domains preferences.
   */
  DegreesOnly: 'DEGREES_ONLY',
  /** PLP_V1 */
  PlpV1: 'PLP_V1'
} as const;

export type ProfileOccupationChoices_FeatureTag = typeof ProfileOccupationChoices_FeatureTag[keyof typeof ProfileOccupationChoices_FeatureTag];
/** An individual occupation aspiration that a learner may choose on the learner profile. */
export type ProfileOccupationChoices_OccupationChoice = {
  __typename?: 'ProfileOccupationChoices_OccupationChoice';
  /**
   * The country code(s) if any that are actively hiring this role.
   * Empty list if there are no active openings for this role.
   * These are the ISO 3166-1 2 letter abbreviation codes like: IN or US
   */
  hiringCountries: Array<RecruitingPosition_Country>;
  /** The ID of the occupation */
  id: Scalars['ID'];
  /** The name of this occupation. */
  occupationName: Scalars['String'];
  /** A list of tags for this occupation. */
  occupationTags: Array<ProfileOccupationChoices_OccupationTag>;
};

/** Input type of filtering criteria to generate corresponding occupation choices. */
export type ProfileOccupationChoices_OccupationChoiceFilter = {
  /**
   * A list of occupation tags to filter for. The profileOccupationChoice.v1 has getAll and byTag.
   * By passing null here, it would return the results for getAll.
   */
  occupationTags?: InputMaybe<Array<ProfileOccupationChoices_OccupationTagInput>>;
};

/** Pagination for Occupation choice results. */
export type ProfileOccupationChoices_OccupationChoiceFilterPaginatedResult = {
  __typename?: 'ProfileOccupationChoices_OccupationChoiceFilterPaginatedResult';
  /** A list of occupation choices from the query result. */
  elements: Array<ProfileOccupationChoices_OccupationChoice>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** The occupation tag type. */
export type ProfileOccupationChoices_OccupationTag = {
  __typename?: 'ProfileOccupationChoices_OccupationTag';
  /** The demand level part of the occupation tag */
  demandLevel: ProfileOccupationChoices_DemandLevel;
  /** The feature tag part of the occupation tag */
  featureTag: ProfileOccupationChoices_FeatureTag;
};

/** The occupation tag input. */
export type ProfileOccupationChoices_OccupationTagInput = {
  /** The demand level part of the occupation tag input */
  demandLevel: ProfileOccupationChoices_DemandLevel;
  /** The feature tag part of the occupation tag input */
  featureTag: ProfileOccupationChoices_FeatureTag;
};

export type ProgramBrowsingExperiencesV1 = {
  __typename?: 'ProgramBrowsingExperiencesV1';
  id: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1 = {
  __typename?: 'ProgramCurriculumCollectionsV1';
  associatedSessionIds: Array<Maybe<Scalars['String']>>;
  associatedSessions?: Maybe<OnDemandCourseSessionsV1Connection>;
  badgeTemplateId?: Maybe<Scalars['String']>;
  catalogCourses?: Maybe<Scalars['JSON']>;
  collectionContextMetadata?: Maybe<ProgramCurriculumCollectionsV1_CollectionContextMetadata>;
  collectionTrackingId?: Maybe<Scalars['String']>;
  courseIds: Array<Maybe<Scalars['String']>>;
  courseSessions?: Maybe<Scalars['JSON']>;
  courses?: Maybe<CoursesV1Connection>;
  description: ProgramCurriculumCollectionsV1_CmlMember;
  gradient?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  items: Array<Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_CurriculumCollectionItem>>;
  programId: Scalars['String'];
  programProductIds: Array<Maybe<Scalars['String']>>;
  programProductMetadata?: Maybe<ProgramProductMetadataV1Connection>;
  referenceCollectionConfiguration?: Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferenceCollectionConfiguration>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  s12ns?: Maybe<OnDemandSpecializationsV1Connection>;
  title: Scalars['String'];
  trackId: Scalars['String'];
};


export type ProgramCurriculumCollectionsV1AssociatedSessionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1CoursesArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ProgramProductMetadataArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1S12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramCurriculumCollectionsV1ByProgram = {
  __typename?: 'ProgramCurriculumCollectionsV1ByProgram';
  connection?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  debug?: Maybe<Scalars['Boolean']>;
  fetchUserProductStates: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  minEntriesInCollection?: Maybe<Scalars['Int']>;
  onlyIncludeProjects?: Maybe<Scalars['Boolean']>;
  programId: Scalars['String'];
  skipEnterpriseCollections?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumCollectionsV1Connection = {
  __typename?: 'ProgramCurriculumCollectionsV1Connection';
  elements: Array<Maybe<ProgramCurriculumCollectionsV1>>;
  paging: ResponsePagination;
};

export type ProgramCurriculumCollectionsV1CurriculumTracksByProgram = {
  __typename?: 'ProgramCurriculumCollectionsV1CurriculumTracksByProgram';
  connection?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  includeBadgeCollections?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumCollectionsV1ForCreditCurriculumTracksByProgram = {
  __typename?: 'ProgramCurriculumCollectionsV1ForCreditCurriculumTracksByProgram';
  connection?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumCollectionsV1Resource = {
  __typename?: 'ProgramCurriculumCollectionsV1Resource';
  byProgram?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  curriculumTracksByProgram?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  forCreditCurriculumTracksByProgram?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  get?: Maybe<ProgramCurriculumCollectionsV1>;
  multiGet?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  skillCollectionBySkillId?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  staticSkillProfileCollectionByTargetSkillProfileId?: Maybe<ProgramCurriculumCollectionsV1Connection>;
};


export type ProgramCurriculumCollectionsV1ResourceByProgramArgs = {
  debug?: InputMaybe<Scalars['Boolean']>;
  fetchUserProductStates: Scalars['Boolean'];
  limit?: InputMaybe<Scalars['Int']>;
  minEntriesInCollection?: InputMaybe<Scalars['Int']>;
  onlyIncludeProjects?: InputMaybe<Scalars['Boolean']>;
  programId: Scalars['String'];
  skipEnterpriseCollections?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ResourceCurriculumTracksByProgramArgs = {
  includeBadgeCollections?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ResourceForCreditCurriculumTracksByProgramArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ResourceGetArgs = {
  fetchUserProductStates?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type ProgramCurriculumCollectionsV1ResourceMultiGetArgs = {
  fetchUserProductStates?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ResourceSkillCollectionBySkillIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  numEntriesPerCollection: Scalars['Int'];
  programId: Scalars['String'];
  skillId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumCollectionsV1ResourceStaticSkillProfileCollectionByTargetSkillProfileIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  numEntriesPerCollection?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  targetSkillProfileId: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1SkillCollectionBySkillId = {
  __typename?: 'ProgramCurriculumCollectionsV1SkillCollectionBySkillId';
  connection?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  numEntriesPerCollection: Scalars['Int'];
  programId: Scalars['String'];
  skillId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumCollectionsV1StaticSkillProfileCollectionByTargetSkillProfileId = {
  __typename?: 'ProgramCurriculumCollectionsV1StaticSkillProfileCollectionByTargetSkillProfileId';
  connection?: Maybe<ProgramCurriculumCollectionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  numEntriesPerCollection?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  targetSkillProfileId: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_CmlMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_cmlMember';
  cml: ProgramCurriculumCollectionsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type ProgramCurriculumCollectionsV1_CollectionContextMetadata = ProgramCurriculumCollectionsV1_SingleSkillMember | ProgramCurriculumCollectionsV1_SkillProfileMember;

export type ProgramCurriculumCollectionsV1_OrgCollectionIdMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_orgCollectionIdMember';
  orgCollectionId: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferenceOrgCollectionId;
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Clip_ClipId = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_clip_ClipId';
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type ProgramCurriculumCollectionsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: ProgramCurriculumCollectionsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type ProgramCurriculumCollectionsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type ProgramCurriculumCollectionsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_CurriculumCollectionItem = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_CurriculumCollectionItem';
  clipId?: Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Clip_ClipId>;
  productId: Scalars['String'];
  productState?: Maybe<ProgramCurriculumCollectionsV1_ProductState>;
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferenceCollectionConfiguration = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_ReferenceCollectionConfiguration';
  enableSync: Scalars['Boolean'];
  referenceCollectionId: ProgramCurriculumCollectionsV1_ReferenceCollectionId;
};

/** Reference to an enterprise organization collection used as a reference collection for curriculum tracks. */
export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferenceOrgCollectionId = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_ReferenceOrgCollectionId';
  id: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferencePresetCollectionId = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_ReferencePresetCollectionId';
  id: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_SingleSkillCollectionContext = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_SingleSkillCollectionContext';
  /** Identifier for Skills at different levels in skill graph */
  skillId: Scalars['String'];
  storedCollectionId: Scalars['String'];
  targetSkillProfileId: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_SkillProfileCollectionContext = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_curriculum_SkillProfileCollectionContext';
  skillIds: Array<Maybe<Scalars['String']>>;
  targetSkillProfileId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  targetSkillProfileSlug: Scalars['String'];
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_enrollment_ProgramCourseWithState';
  actions: Array<Maybe<Org_Coursera_Program_Enrollment_ProgramUserProductAction>>;
  completedAt?: Maybe<Scalars['Float']>;
  courseId: Scalars['String'];
  enrolledAt?: Maybe<Scalars['Float']>;
  enrolledTargetSkillProfileId?: Maybe<Scalars['String']>;
  isWishlisted?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  reasonsForState: Array<Maybe<Org_Coursera_Program_Enrollment_ProgramUserProductStateReason>>;
  state: Org_Coursera_Program_Enrollment_ProgramUserProductState;
};

export type ProgramCurriculumCollectionsV1_Org_Coursera_Program_Enrollment_ProgramS12nWithState = {
  __typename?: 'ProgramCurriculumCollectionsV1_org_coursera_program_enrollment_ProgramS12nWithState';
  actions: Array<Maybe<Org_Coursera_Program_Enrollment_ProgramUserProductAction>>;
  baseS12nId: Scalars['String'];
  courseStates: Array<Maybe<ProgramCurriculumCollectionsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState>>;
  enrolledAt?: Maybe<Scalars['Float']>;
  enrolledTargetSkillProfileId?: Maybe<Scalars['String']>;
  isWishlisted?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  latestS12nId: Scalars['String'];
  reasonsForState: Array<Maybe<Org_Coursera_Program_Enrollment_ProgramUserProductStateReason>>;
  s12nId: Scalars['String'];
  state: Org_Coursera_Program_Enrollment_ProgramUserProductState;
};

export type ProgramCurriculumCollectionsV1_PresetCollectionIdMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_presetCollectionIdMember';
  presetCollectionId: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_ReferencePresetCollectionId;
};

export type ProgramCurriculumCollectionsV1_ProductState = ProgramCurriculumCollectionsV1_ProgramCourseWithStateMember | ProgramCurriculumCollectionsV1_ProgramS12nWithStateMember;

export type ProgramCurriculumCollectionsV1_ProgramCourseWithStateMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_programCourseWithStateMember';
  programCourseWithState: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState;
};

export type ProgramCurriculumCollectionsV1_ProgramS12nWithStateMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_programS12nWithStateMember';
  programS12nWithState: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Enrollment_ProgramS12nWithState;
};

export type ProgramCurriculumCollectionsV1_ReferenceCollectionId = ProgramCurriculumCollectionsV1_OrgCollectionIdMember | ProgramCurriculumCollectionsV1_PresetCollectionIdMember;

export type ProgramCurriculumCollectionsV1_SingleSkillMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_singleSkillMember';
  singleSkill: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_SingleSkillCollectionContext;
};

export type ProgramCurriculumCollectionsV1_SkillProfileMember = {
  __typename?: 'ProgramCurriculumCollectionsV1_skillProfileMember';
  skillProfile: ProgramCurriculumCollectionsV1_Org_Coursera_Program_Curriculum_SkillProfileCollectionContext;
};

export type ProgramCurriculumDomainsV1 = {
  __typename?: 'ProgramCurriculumDomainsV1';
  domains: Array<Maybe<ProgramCurriculumDomainsV1_Org_Coursera_Program_Curriculum_ProgramCurriculumDomain>>;
  id: Scalars['String'];
};

export type ProgramCurriculumDomainsV1Connection = {
  __typename?: 'ProgramCurriculumDomainsV1Connection';
  elements: Array<Maybe<ProgramCurriculumDomainsV1>>;
  paging: ResponsePagination;
};

export type ProgramCurriculumDomainsV1Resource = {
  __typename?: 'ProgramCurriculumDomainsV1Resource';
  get?: Maybe<ProgramCurriculumDomainsV1>;
  multiGet?: Maybe<ProgramCurriculumDomainsV1Connection>;
};


export type ProgramCurriculumDomainsV1ResourceGetArgs = {
  id: Scalars['String'];
  includeUnselectedDomains?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramCurriculumDomainsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeUnselectedDomains?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramCurriculumDomainsV1_Org_Coursera_Program_Curriculum_ProgramCurriculumDomain = {
  __typename?: 'ProgramCurriculumDomainsV1_org_coursera_program_curriculum_ProgramCurriculumDomain';
  courseCount: Scalars['Int'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  id: Scalars['String'];
  isSelected?: Maybe<Scalars['Boolean']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  subdomainIds: Array<Maybe<Scalars['String']>>;
};

export type ProgramCurriculumProductsV1 = {
  __typename?: 'ProgramCurriculumProductsV1';
  catalogCourses?: Maybe<Scalars['JSON']>;
  courseProgress?: Maybe<Scalars['JSON']>;
  courseSchedules?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  partnerIds?: Maybe<Scalars['JSON']>;
  productItemId: Scalars['String'];
  productState: ProgramCurriculumProductsV1_ProductState;
  productType: Scalars['String'];
  program?: Maybe<EnterpriseProgramsV1>;
  programId: Scalars['String'];
  programProductMetadata?: Maybe<ProgramProductMetadataV1>;
  programUserCredits?: Maybe<Scalars['JSON']>;
  programs?: Maybe<Scalars['JSON']>;
  s12nIds?: Maybe<Scalars['JSON']>;
  s12nProgress?: Maybe<Scalars['JSON']>;
  targetSkillProfileUserStates?: Maybe<Scalars['JSON']>;
  targetSkillProfiles?: Maybe<Scalars['JSON']>;
};


export type ProgramCurriculumProductsV1ProgramArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramCurriculumProductsV1Available = {
  __typename?: 'ProgramCurriculumProductsV1Available';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1Connection = {
  __typename?: 'ProgramCurriculumProductsV1Connection';
  elements: Array<Maybe<ProgramCurriculumProductsV1>>;
  paging: ResponsePagination;
};

export type ProgramCurriculumProductsV1Enrolled = {
  __typename?: 'ProgramCurriculumProductsV1Enrolled';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1EnrolledCourses = {
  __typename?: 'ProgramCurriculumProductsV1EnrolledCourses';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1EnrolledS12ns = {
  __typename?: 'ProgramCurriculumProductsV1EnrolledS12ns';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1EnrollmentByUserAndCourse = {
  __typename?: 'ProgramCurriculumProductsV1EnrollmentByUserAndCourse';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ProgramCurriculumProductsV1EnrollmentsStartingLater = {
  __typename?: 'ProgramCurriculumProductsV1EnrollmentsStartingLater';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1LatestEnrolledCourseActivities = {
  __typename?: 'ProgramCurriculumProductsV1LatestEnrolledCourseActivities';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser = {
  __typename?: 'ProgramCurriculumProductsV1LatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type ProgramCurriculumProductsV1Resource = {
  __typename?: 'ProgramCurriculumProductsV1Resource';
  available?: Maybe<ProgramCurriculumProductsV1Connection>;
  enrolled?: Maybe<ProgramCurriculumProductsV1Connection>;
  enrolledCourses?: Maybe<ProgramCurriculumProductsV1Connection>;
  enrolledS12ns?: Maybe<ProgramCurriculumProductsV1Connection>;
  enrollmentByUserAndCourse?: Maybe<ProgramCurriculumProductsV1Connection>;
  enrollmentsStartingLater?: Maybe<ProgramCurriculumProductsV1Connection>;
  get?: Maybe<ProgramCurriculumProductsV1>;
  latestEnrolledCourseActivities?: Maybe<ProgramCurriculumProductsV1Connection>;
  latestEnrolledCourseActivitiesByThirdPartyOrganizationAndUser?: Maybe<ProgramCurriculumProductsV1Connection>;
  multiGet?: Maybe<ProgramCurriculumProductsV1Connection>;
  selected?: Maybe<ProgramCurriculumProductsV1Connection>;
  selectedOrEnrolled?: Maybe<ProgramCurriculumProductsV1Connection>;
};


export type ProgramCurriculumProductsV1ResourceAvailableArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceEnrolledArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceEnrolledCoursesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceEnrolledS12nsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceEnrollmentByUserAndCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type ProgramCurriculumProductsV1ResourceEnrollmentsStartingLaterArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramCurriculumProductsV1ResourceLatestEnrolledCourseActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceLatestEnrolledCourseActivitiesByThirdPartyOrganizationAndUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  userId: Scalars['String'];
};


export type ProgramCurriculumProductsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceSelectedArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumProductsV1ResourceSelectedOrEnrolledArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1Selected = {
  __typename?: 'ProgramCurriculumProductsV1Selected';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1SelectedOrEnrolled = {
  __typename?: 'ProgramCurriculumProductsV1SelectedOrEnrolled';
  connection?: Maybe<ProgramCurriculumProductsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState = {
  __typename?: 'ProgramCurriculumProductsV1_org_coursera_program_enrollment_ProgramCourseWithState';
  actions: Array<Maybe<ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction>>;
  completedAt?: Maybe<Scalars['Float']>;
  courseId: Scalars['String'];
  enrolledAt?: Maybe<Scalars['Float']>;
  enrolledTargetSkillProfile?: Maybe<EnterpriseTargetSkillProfilesV1>;
  enrolledTargetSkillProfileId?: Maybe<Scalars['String']>;
  isWishlisted?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  reasonsForState: Array<Maybe<ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason>>;
  state: ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState;
};

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramS12nWithState = {
  __typename?: 'ProgramCurriculumProductsV1_org_coursera_program_enrollment_ProgramS12nWithState';
  actions: Array<Maybe<ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction>>;
  baseS12nId: Scalars['String'];
  courseStates: Array<Maybe<ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState>>;
  enrolledAt?: Maybe<Scalars['Float']>;
  enrolledTargetSkillProfile?: Maybe<EnterpriseTargetSkillProfilesV1>;
  enrolledTargetSkillProfileId?: Maybe<Scalars['String']>;
  isWishlisted?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  latestS12nId: Scalars['String'];
  reasonsForState: Array<Maybe<ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason>>;
  s12nId: Scalars['String'];
  state: ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState;
};

export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction = {
  Enroll: 'ENROLL',
  Manage: 'MANAGE',
  Preview: 'PREVIEW',
  Resume: 'RESUME',
  Select: 'SELECT',
  Unenroll: 'UNENROLL',
  Unselect: 'UNSELECT',
  Upgrade: 'UPGRADE',
  View: 'VIEW'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductAction];
export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState = {
  Available: 'AVAILABLE',
  Completed: 'COMPLETED',
  Enrolled: 'ENROLLED',
  Unavailable: 'UNAVAILABLE'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductState];
export const ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = {
  UnavailableCourseNotLaunchedNorPreEnrollable: 'UNAVAILABLE_COURSE_NOT_LAUNCHED_NOR_PRE_ENROLLABLE',
  UnavailableCourseNoOpenSessions: 'UNAVAILABLE_COURSE_NO_OPEN_SESSIONS',
  UnavailableNotInProgram: 'UNAVAILABLE_NOT_IN_PROGRAM',
  UnavailableNotPermitted: 'UNAVAILABLE_NOT_PERMITTED',
  UnavailableNoCreditsRemaining: 'UNAVAILABLE_NO_CREDITS_REMAINING'
} as const;

export type ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason[keyof typeof ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramUserProductStateReason];
export type ProgramCurriculumProductsV1_ProductState = ProgramCurriculumProductsV1_ProgramCourseWithStateMember | ProgramCurriculumProductsV1_ProgramS12nWithStateMember;

export type ProgramCurriculumProductsV1_ProgramCourseWithStateMember = {
  __typename?: 'ProgramCurriculumProductsV1_programCourseWithStateMember';
  programCourseWithState: ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramCourseWithState;
};

export type ProgramCurriculumProductsV1_ProgramS12nWithStateMember = {
  __typename?: 'ProgramCurriculumProductsV1_programS12nWithStateMember';
  programS12nWithState: ProgramCurriculumProductsV1_Org_Coursera_Program_Enrollment_ProgramS12nWithState;
};

/** Program curriculum object, resolved through Naptime via Graphql Mesh */
export type ProgramCurriculumsV1 = {
  __typename?: 'ProgramCurriculumsV1';
  /** Curriculum id */
  id?: Maybe<Scalars['String']>;
};

export type ProgramCurriculumsV1Connection = {
  __typename?: 'ProgramCurriculumsV1Connection';
  elements: Array<Maybe<ProgramCurriculumsV1>>;
  paging: ResponsePagination;
};

export type ProgramCurriculumsV1Resource = {
  __typename?: 'ProgramCurriculumsV1Resource';
  get?: Maybe<ProgramCurriculumsV1>;
  getAll?: Maybe<ProgramCurriculumsV1Connection>;
  multiGet?: Maybe<ProgramCurriculumsV1Connection>;
};


export type ProgramCurriculumsV1ResourceGetArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  includeClips?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramCurriculumsV1ResourceGetAllArgs = {
  includeClips?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumsV1ResourceMultiGetArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
  ids: Array<InputMaybe<Scalars['String']>>;
  includeClips?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramCurriculumsV1ResourceMutations = {
  __typename?: 'ProgramCurriculumsV1ResourceMutations';
  copy?: Maybe<Scalars['JSON']>;
  create?: Maybe<ProgramCurriculumsV1Connection>;
  createDefault?: Maybe<Scalars['JSON']>;
  delete?: Maybe<ProgramCurriculumsV1Connection>;
  removeRestrictedProducts?: Maybe<Scalars['JSON']>;
  update?: Maybe<ProgramCurriculumsV1Connection>;
  upsertCollections?: Maybe<Scalars['JSON']>;
};


export type ProgramCurriculumsV1ResourceMutationsCreateDefaultArgs = {
  defaultToEmptyTracksCurriculum?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramCurriculumsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type ProgramCurriculumsV1ResourceMutationsRemoveRestrictedProductsArgs = {
  curriculumId: Scalars['String'];
};


export type ProgramCurriculumsV1ResourceMutationsUpdateArgs = {
  allowBadgeDeletion?: InputMaybe<Scalars['Boolean']>;
  allowClearingClips?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  requesterId?: InputMaybe<Scalars['String']>;
  skipUnauthorizedProducts?: InputMaybe<Scalars['Boolean']>;
  updateSource?: InputMaybe<Scalars['String']>;
};


export type ProgramCurriculumsV1ResourceMutationsUpsertCollectionsArgs = {
  id: Scalars['String'];
  requesterId?: InputMaybe<Scalars['String']>;
  skipUnauthorizedProducts?: InputMaybe<Scalars['Boolean']>;
  updateSource?: InputMaybe<Scalars['String']>;
};

export type ProgramEnrollmentSettingsV1 = {
  __typename?: 'ProgramEnrollmentSettingsV1';
  enrollmentTarget: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_ProgramEnrollmentTarget;
  enrollmentTargetCourse?: Maybe<CoursesV1>;
  enrollmentTargetProgram?: Maybe<EnterpriseProgramsV1>;
  enrollmentTargetS12n?: Maybe<OnDemandSpecializationsV1>;
  id: Scalars['String'];
  metadata: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_ProgramEnrollmentSettingMetadata;
  triggerEvent: ProgramEnrollmentSettingsV1_TriggerEvent;
  triggerEventCompletedCourse?: Maybe<CoursesV1>;
  triggerEventEnrolledCourse?: Maybe<CoursesV1>;
  triggerEventJoinedProgram?: Maybe<EnterpriseProgramsV1>;
};


export type ProgramEnrollmentSettingsV1EnrollmentTargetCourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramEnrollmentSettingsV1EnrollmentTargetProgramArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramEnrollmentSettingsV1TriggerEventCompletedCourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramEnrollmentSettingsV1TriggerEventEnrolledCourseArgs = {
  includeHiddenS12ns?: InputMaybe<Scalars['Boolean']>;
  withCorrectBehavior?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramEnrollmentSettingsV1TriggerEventJoinedProgramArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramEnrollmentSettingsV1ByTargetProgram = {
  __typename?: 'ProgramEnrollmentSettingsV1ByTargetProgram';
  connection?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramEnrollmentSettingsV1Connection = {
  __typename?: 'ProgramEnrollmentSettingsV1Connection';
  elements: Array<Maybe<ProgramEnrollmentSettingsV1>>;
  paging: ResponsePagination;
};

export type ProgramEnrollmentSettingsV1JoinProgramCourses = {
  __typename?: 'ProgramEnrollmentSettingsV1JoinProgramCourses';
  connection?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  includeEnrolledCoursesOnly?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramEnrollmentSettingsV1Resource = {
  __typename?: 'ProgramEnrollmentSettingsV1Resource';
  byTargetProgram?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  get?: Maybe<ProgramEnrollmentSettingsV1>;
  getAll?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  joinProgramCourses?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  multiGet?: Maybe<ProgramEnrollmentSettingsV1Connection>;
};


export type ProgramEnrollmentSettingsV1ResourceByTargetProgramArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramEnrollmentSettingsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramEnrollmentSettingsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramEnrollmentSettingsV1ResourceJoinProgramCoursesArgs = {
  includeEnrolledCoursesOnly?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramEnrollmentSettingsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramEnrollmentSettingsV1ResourceMutations = {
  __typename?: 'ProgramEnrollmentSettingsV1ResourceMutations';
  create?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  delete?: Maybe<ProgramEnrollmentSettingsV1Connection>;
  deleteByTargetProduct?: Maybe<Scalars['JSON']>;
  replaceEnrollmentSetting?: Maybe<Scalars['JSON']>;
};


export type ProgramEnrollmentSettingsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type ProgramEnrollmentSettingsV1ResourceMutationsReplaceEnrollmentSettingArgs = {
  id: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_CompleteCourseMember = {
  __typename?: 'ProgramEnrollmentSettingsV1_completeCourseMember';
  completeCourse: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_CompleteCourseEvent;
};

export type ProgramEnrollmentSettingsV1_CourseEnrollmentMember = {
  __typename?: 'ProgramEnrollmentSettingsV1_courseEnrollmentMember';
  courseEnrollment: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_CourseEnrollmentTarget;
};

export type ProgramEnrollmentSettingsV1_EnrollCourseMember = {
  __typename?: 'ProgramEnrollmentSettingsV1_enrollCourseMember';
  enrollCourse: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_EnrollCourseEvent;
};

export type ProgramEnrollmentSettingsV1_JoinProgramMember = {
  __typename?: 'ProgramEnrollmentSettingsV1_joinProgramMember';
  joinProgram: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_JoinProgramEvent;
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_CompleteCourseEvent = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_CompleteCourseEvent';
  completedCourseId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_CourseEnrollmentTarget = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_CourseEnrollmentTarget';
  targetCourseId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_EnrollCourseEvent = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_EnrollCourseEvent';
  enrolledCourseId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_JoinProgramEvent = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_JoinProgramEvent';
  joinedProgramId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_ProgramEnrollmentSettingMetadata = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_ProgramEnrollmentSettingMetadata';
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  createdBy: Scalars['Int'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_ProgramEnrollmentTarget = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_ProgramEnrollmentTarget';
  targetProduct: ProgramEnrollmentSettingsV1_TargetProduct;
  targetProgramId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_S12nEnrollmentTarget = {
  __typename?: 'ProgramEnrollmentSettingsV1_org_coursera_program_enrollment_setting_S12nEnrollmentTarget';
  targetS12nId: Scalars['String'];
};

export type ProgramEnrollmentSettingsV1_S12nEnrollmentMember = {
  __typename?: 'ProgramEnrollmentSettingsV1_s12nEnrollmentMember';
  s12nEnrollment: ProgramEnrollmentSettingsV1_Org_Coursera_Program_Enrollment_Setting_S12nEnrollmentTarget;
};

export type ProgramEnrollmentSettingsV1_TargetProduct = ProgramEnrollmentSettingsV1_CourseEnrollmentMember | ProgramEnrollmentSettingsV1_S12nEnrollmentMember;

export type ProgramEnrollmentSettingsV1_TriggerEvent = ProgramEnrollmentSettingsV1_CompleteCourseMember | ProgramEnrollmentSettingsV1_EnrollCourseMember | ProgramEnrollmentSettingsV1_JoinProgramMember;

/** Queries for program home pages. */
export type ProgramHomePageQueries = {
  __typename?: 'ProgramHomePageQueries';
  /** Get a list of products that a given user has enrolled in a given program. */
  queryEnrolledProducts: ProgramHome_EnrolledProductsPaginatedResult;
  /** Get the next course in the learning path for the logged in learner. */
  queryLearningPathNextCourse: ProgramHome_LearningPathNextCourse;
};


/** Queries for program home pages. */
export type ProgramHomePageQueriesQueryEnrolledProductsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: ProgramHome_QueryEnrolledProductsInput;
  limit: Scalars['Int'];
};


/** Queries for program home pages. */
export type ProgramHomePageQueriesQueryLearningPathNextCourseArgs = {
  programId: Scalars['ID'];
};

/** An enrolled product a learner enrolled */
export type ProgramHome_EnrolledProduct = {
  __typename?: 'ProgramHome_EnrolledProduct';
  /** Denotes if the learner can unenroll this learning product */
  canUnenroll?: Maybe<Scalars['Boolean']>;
  /** Denotes if the learner can upgrade this learning product */
  canUpgrade?: Maybe<Scalars['Boolean']>;
  /**
   * The ProgramHome_EnrolledProduct for the courses belonging to an S12N.
   * Valid iff the productType is SPECIALIZATION. Otherwise empty list
   */
  childEnrolledProducts: Array<Maybe<ProgramHome_EnrolledProduct>>;
  /** The time when the learning product is completed by the learner */
  completedAtUTC?: Maybe<Scalars['DateTime']>;
  /** The time when the learning product is enrolled by the learner */
  enrolledAtUTC?: Maybe<Scalars['DateTime']>;
  /** The Skillset through which the learner enrolled in this learning product. */
  enrolledTargetSkillProfileId?: Maybe<Scalars['ID']>;
  /** Denotes if the learning product is wishlisted */
  isWishlisted?: Maybe<Scalars['Boolean']>;
  /** The time when the learning product state is last updated */
  lastUpdatedAtUTC?: Maybe<Scalars['DateTime']>;
  /** The learning product */
  learningProduct?: Maybe<ProgramHome_LearningProduct>;
  /** The enterprise program id */
  programId: Scalars['ID'];
  /** The state of the enrolled product for the learner */
  state: ProgramHome_EnrolledProductState;
};

/** An enum denotes the state for a learner and a given enrolled learning product. */
export const ProgramHome_EnrolledProductState = {
  /**
   * A non-enrolled state that is only used to describe the enrollment state of a child course
   * under an enrolled specialization: the course is available to enroll;
   */
  Available: 'AVAILABLE',
  /** The user has completed the learning product; */
  Completed: 'COMPLETED',
  /** The user has enrolled and started but not yet completed the learning product; */
  EnrolledInProgress: 'ENROLLED_IN_PROGRESS',
  /**
   * The learner has enrolled but the session has not yet started. This is only applicable when the
   * course instance is limited availability, i.e., fixed session experience. When in this state,
   * the learner can preview the course but can not access the full course materials.
   */
  EnrolledStartingLater: 'ENROLLED_STARTING_LATER',
  /**
   * A non-enrolled state that is only used to describe the enrollment state of a child course
   * under an enrolled specialization: the course is not available to enroll;
   */
  Unavailable: 'UNAVAILABLE'
} as const;

export type ProgramHome_EnrolledProductState = typeof ProgramHome_EnrolledProductState[keyof typeof ProgramHome_EnrolledProductState];
/** An enum denotes the input state for a learner and a given enrolled learning product. */
export const ProgramHome_EnrolledProductStateInput = {
  /** The user has completed the learning product; */
  Completed: 'COMPLETED',
  /** The user has enrolled and started but not yet completed the learning product; */
  EnrolledInProgress: 'ENROLLED_IN_PROGRESS',
  /**
   * The learner has enrolled but the session has not yet started. This is only applicable when the
   * course instance is limited availability, i.e., fixed session experience. When in this state,
   * the learner can preview the course but can not access the full course materials.
   */
  EnrolledStartingLater: 'ENROLLED_STARTING_LATER'
} as const;

export type ProgramHome_EnrolledProductStateInput = typeof ProgramHome_EnrolledProductStateInput[keyof typeof ProgramHome_EnrolledProductStateInput];
/** The queryEnrolledProducts result */
export type ProgramHome_EnrolledProductsPaginatedResult = {
  __typename?: 'ProgramHome_EnrolledProductsPaginatedResult';
  /** A list of products the learner has enrolled */
  elements: Array<ProgramHome_EnrolledProduct>;
  /** Pagination information */
  pagination: Pagination;
};

/** The response type for queryLearningPathNextCourse query */
export type ProgramHome_LearningPathNextCourse = {
  __typename?: 'ProgramHome_LearningPathNextCourse';
  /** The ID of the next course in the learning path */
  course: Course_Course;
  /** The timestamp when the next course was last updated */
  timestamp: Scalars['DateTime'];
};

/**
 * A Product in ProgramHome domain is either a course type product or a specialization type product.
 * Course: usually referred by VerifiedCertificate, such as regular
 * courses and projects;
 * Specialization: usually referred by Specialization, such as regular
 * specializations and professional certificates
 */
export type ProgramHome_LearningProduct = Course_Course | Specialization_Specialization;

/** The queryEnrolledProducts input. */
export type ProgramHome_QueryEnrolledProductsInput = {
  /** enterprise program Id */
  programId: Scalars['ID'];
  /** the state of the enrolled product */
  state: ProgramHome_EnrolledProductStateInput;
};

/** Namespace type for ProgramInvitationsDomainAllowList queries */
export type ProgramInvitationsDomainAllowListQueries = {
  __typename?: 'ProgramInvitationsDomainAllowListQueries';
  /**
   * This query returns entries filtered by programId, rosterIds and a searchText matching email
   * domains. If rosterIds is empty and searchText is not defined, this query will only filter by
   * programId.
   */
  queryDomainAllowList: Array<EnterpriseProgram_DomainAllowListEntry>;
  /**
   * This query returns the domain allow list for every program in the given organization, grouped
   * by programId. Authorization is done in Java.
   */
  queryDomainAllowListByOrganization: Array<EnterpriseProgram_DomainAllowListByProgram>;
};


/** Namespace type for ProgramInvitationsDomainAllowList queries */
export type ProgramInvitationsDomainAllowListQueriesQueryDomainAllowListArgs = {
  programId: Scalars['ID'];
  rosterIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
};


/** Namespace type for ProgramInvitationsDomainAllowList queries */
export type ProgramInvitationsDomainAllowListQueriesQueryDomainAllowListByOrganizationArgs = {
  organizationId: Scalars['ID'];
};

/** ProgramInvitationsDomainAllowList_MultiDelete Input */
export type ProgramInvitationsDomainAllowList_MultiDeleteInput = {
  /** List of email domains that will be deleted from the allow list. */
  emailDomains: Array<Scalars['String']>;
  /** Id of the program whose allow list will be updated. */
  programId: Scalars['ID'];
};

/** ProgramInvitationsDomainAllowList_MultiDelete Result */
export type ProgramInvitationsDomainAllowList_MultiDeleteResult = {
  __typename?: 'ProgramInvitationsDomainAllowList_MultiDeleteResult';
  /** Email domains that were deleted. */
  emailDomains: Array<Scalars['String']>;
};

/** ProgramInvitationsDomainAllowList_MultiUpdate Input */
export type ProgramInvitationsDomainAllowList_MultiUpdateInput = {
  /** List of email domains to be added or updated. */
  emailDomains: Array<Scalars['String']>;
  /** Determines whether updates for existing domains will skipped. */
  insertOnly: Scalars['Boolean'];
  /** Id of the program whose allow list will be updated. */
  programId: Scalars['ID'];
  /** RosterId to be associated with the email domains added or updated. */
  rosterId: Scalars['ID'];
};

/** ProgramInvitationsDomainAllowList_MultiUpdate Result */
export type ProgramInvitationsDomainAllowList_MultiUpdateResult = {
  __typename?: 'ProgramInvitationsDomainAllowList_MultiUpdateResult';
  /** Number of domains added. */
  domainsAddedCount?: Maybe<Scalars['Int']>;
  /**
   * Number of domains skipped. Domains are skipped when insertOnly is true and
   * the email domain is already in a program's allow list.
   */
  domainsSkippedCount?: Maybe<Scalars['Int']>;
  /** Number of existing domains updated (will always be zero if insertOnly is true). */
  domainsUpdatedCount?: Maybe<Scalars['Int']>;
};

/** All queries related to program invitations */
export type ProgramInvitationsQueries = {
  __typename?: 'ProgramInvitationsQueries';
  /**
   * This query provides direct access to the invitation JWT without having to go through email.
   * Only e2e traffic is allowed by the implementation.
   */
  getTestingJwt: Scalars['String'];
  /** This query returns the program invitations matching the organization ID and email addresses for the requester. */
  queryByOrganizationAndRequester: Array<ProgramInvitations_Invitation>;
  /** This query returns the program invitations matching the program ID and roster IDs. */
  queryByProgramAndRosters: ProgramInvitations_InvitationsPaginatedResult;
  /** Search program invitations with search text matching invitee name or email */
  searchProgramInvitations: ProgramInvitations_InvitationsPaginatedResult;
};


/** All queries related to program invitations */
export type ProgramInvitationsQueriesGetTestingJwtArgs = {
  invitationId: Scalars['ID'];
};


/** All queries related to program invitations */
export type ProgramInvitationsQueriesQueryByOrganizationAndRequesterArgs = {
  includeInactiveInvitations?: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};


/** All queries related to program invitations */
export type ProgramInvitationsQueriesQueryByProgramAndRostersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeInactiveInvitations?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
  rosterIds: Array<Scalars['ID']>;
};


/** All queries related to program invitations */
export type ProgramInvitationsQueriesSearchProgramInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeInactiveInvitations?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
  rosterIds?: Array<Scalars['ID']>;
  searchText: Scalars['String'];
};

export type ProgramInvitationsV1 = {
  __typename?: 'ProgramInvitationsV1';
  createdAt?: Maybe<Scalars['Float']>;
  declines: Scalars['Boolean'];
  expiresAt: Scalars['Float'];
  id: Scalars['String'];
  invitee: ProgramInvitationsV1_Org_Coursera_Program_Invitation_ProgramInvitee;
  programId: Scalars['String'];
  reminderSendTimes: Array<Maybe<Scalars['Float']>>;
  rosterId: Scalars['String'];
  sendAttemptTimes: Array<Maybe<Scalars['Float']>>;
  thirdPartyOrganizationId: Scalars['String'];
  userRoster?: Maybe<EnterpriseUserRostersV1>;
};


export type ProgramInvitationsV1UserRosterArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramInvitationsV1ByEmail = {
  __typename?: 'ProgramInvitationsV1ByEmail';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  email: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type ProgramInvitationsV1ByProgram = {
  __typename?: 'ProgramInvitationsV1ByProgram';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramInvitationsV1ByProgramAndEmail = {
  __typename?: 'ProgramInvitationsV1ByProgramAndEmail';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  email: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramInvitationsV1ByProgramAndExternalId = {
  __typename?: 'ProgramInvitationsV1ByProgramAndExternalId';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  externalId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramInvitationsV1ByRosters = {
  __typename?: 'ProgramInvitationsV1ByRosters';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  rosterIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type ProgramInvitationsV1ByThirdPartyOrganizationAndUser = {
  __typename?: 'ProgramInvitationsV1ByThirdPartyOrganizationAndUser';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type ProgramInvitationsV1ByUser = {
  __typename?: 'ProgramInvitationsV1ByUser';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ProgramInvitationsV1Connection = {
  __typename?: 'ProgramInvitationsV1Connection';
  elements: Array<Maybe<ProgramInvitationsV1>>;
  paging: ResponsePagination;
};

export type ProgramInvitationsV1Resource = {
  __typename?: 'ProgramInvitationsV1Resource';
  byEmail?: Maybe<ProgramInvitationsV1Connection>;
  byProgram?: Maybe<ProgramInvitationsV1Connection>;
  byProgramAndEmail?: Maybe<ProgramInvitationsV1Connection>;
  byProgramAndExternalId?: Maybe<ProgramInvitationsV1Connection>;
  byRosters?: Maybe<ProgramInvitationsV1Connection>;
  byThirdPartyOrganizationAndUser?: Maybe<ProgramInvitationsV1Connection>;
  byUser?: Maybe<ProgramInvitationsV1Connection>;
  get?: Maybe<ProgramInvitationsV1>;
  multiGet?: Maybe<ProgramInvitationsV1Connection>;
  search?: Maybe<ProgramInvitationsV1Connection>;
};


export type ProgramInvitationsV1ResourceByEmailArgs = {
  email: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceByProgramArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceByProgramAndEmailArgs = {
  email: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceByProgramAndExternalIdArgs = {
  externalId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceByRostersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  rosterIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceByThirdPartyOrganizationAndUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
  userId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramInvitationsV1ResourceSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  rosterIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};

export type ProgramInvitationsV1ResourceMutations = {
  __typename?: 'ProgramInvitationsV1ResourceMutations';
  accept?: Maybe<Scalars['JSON']>;
  acceptAs?: Maybe<Scalars['JSON']>;
  create?: Maybe<ProgramInvitationsV1Connection>;
  delete?: Maybe<ProgramInvitationsV1Connection>;
  deleteByInvitationIds?: Maybe<Scalars['JSON']>;
  generateBulkUploadLocation?: Maybe<Scalars['JSON']>;
  getInvitationIdsByOrg?: Maybe<Scalars['JSON']>;
  getInvitationIdsByPrograms?: Maybe<Scalars['JSON']>;
  getTestingJwt?: Maybe<Scalars['JSON']>;
  join?: Maybe<Scalars['JSON']>;
  multiDelete?: Maybe<Scalars['JSON']>;
  multiSend?: Maybe<Scalars['JSON']>;
  patch?: Maybe<ProgramInvitationsV1Connection>;
  previewImportV2?: Maybe<Scalars['JSON']>;
  processImportAsynchronously?: Maybe<Scalars['JSON']>;
  processImportSynchronously?: Maybe<Scalars['JSON']>;
  send?: Maybe<Scalars['JSON']>;
  sendAllPending?: Maybe<Scalars['JSON']>;
};


export type ProgramInvitationsV1ResourceMutationsAcceptArgs = {
  id: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsAcceptAsArgs = {
  id: Scalars['String'];
  userId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsGenerateBulkUploadLocationArgs = {
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsGetInvitationIdsByOrgArgs = {
  orgId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsGetInvitationIdsByProgramsArgs = {
  programIds: Array<InputMaybe<Scalars['String']>>;
};


export type ProgramInvitationsV1ResourceMutationsGetTestingJwtArgs = {
  id: Scalars['String'];
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsJoinArgs = {
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsMultiDeleteArgs = {
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsMultiSendArgs = {
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsPreviewImportV2Args = {
  programId: Scalars['String'];
  rosterId?: InputMaybe<Scalars['String']>;
  s3Bucket: Scalars['String'];
  s3Key: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsProcessImportAsynchronouslyArgs = {
  programId: Scalars['String'];
  rosterId?: InputMaybe<Scalars['String']>;
  s3Bucket: Scalars['String'];
  s3Key: Scalars['String'];
  sendInvitations: Scalars['Boolean'];
};


export type ProgramInvitationsV1ResourceMutationsProcessImportSynchronouslyArgs = {
  programId: Scalars['String'];
  rosterId?: InputMaybe<Scalars['String']>;
  s3Bucket: Scalars['String'];
  s3Key: Scalars['String'];
  sendInvitations: Scalars['Boolean'];
};


export type ProgramInvitationsV1ResourceMutationsSendArgs = {
  id: Scalars['String'];
  programId: Scalars['String'];
};


export type ProgramInvitationsV1ResourceMutationsSendAllPendingArgs = {
  programId: Scalars['String'];
};

export type ProgramInvitationsV1Search = {
  __typename?: 'ProgramInvitationsV1Search';
  connection?: Maybe<ProgramInvitationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  rosterIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  start?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type ProgramInvitationsV1_GenericExternalUserDataMember = {
  __typename?: 'ProgramInvitationsV1_genericExternalUserDataMember';
  genericExternalUserData: ProgramInvitationsV1_Org_Coursera_Program_Invitation_GenericExternalUserData;
};

export type ProgramInvitationsV1_Org_Coursera_Program_Invitation_GenericExternalUserData = {
  __typename?: 'ProgramInvitationsV1_org_coursera_program_invitation_GenericExternalUserData';
  email: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
};

export type ProgramInvitationsV1_Org_Coursera_Program_Invitation_ProgramInvitee = {
  __typename?: 'ProgramInvitationsV1_org_coursera_program_invitation_ProgramInvitee';
  email: Scalars['String'];
  externalUserData: ProgramInvitationsV1_GenericExternalUserDataMember;
  name: Scalars['String'];
};

/** Returned on ProgramInvitations_AcceptInvitation mutation failure */
export type ProgramInvitations_AcceptInvitationFailure = {
  __typename?: 'ProgramInvitations_AcceptInvitationFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input argument for accepting an invitation */
export type ProgramInvitations_AcceptInvitationInput = {
  /** Program invitation ID */
  invitationId: Scalars['ID'];
};

/** Result of accepting an invitation */
export type ProgramInvitations_AcceptInvitationResult = ProgramInvitations_AcceptInvitationFailure | ProgramInvitations_AcceptInvitationSuccess;

/** Returned on ProgramInvitations_AcceptInvitation mutation success */
export type ProgramInvitations_AcceptInvitationSuccess = {
  __typename?: 'ProgramInvitations_AcceptInvitationSuccess';
  /** Dummy boolean */
  _?: Maybe<Scalars['Boolean']>;
};

/** Failed per-invitee outcome (ProgramInviteeFailed in gRPC). */
export type ProgramInvitations_AddUsersToProgramFailedInvitee = {
  __typename?: 'ProgramInvitations_AddUsersToProgramFailedInvitee';
  /** Invitee email */
  email: Scalars['String'];
  /** Error classification */
  errorCode: ProgramInvitations_ProgramInviteeError;
  /** Optional invitee external ID */
  externalId?: Maybe<Scalars['ID']>;
  /** Human-readable error message */
  message: Scalars['String'];
  /** Invitee name */
  name: Scalars['String'];
  /** Standard fields associated with the invitee */
  standardFields?: Maybe<EnterpriseLearnerProfile_StandardFields>;
};

/** Returned on ProgramInvitations_AddUsersToProgram mutation failure */
export type ProgramInvitations_AddUsersToProgramFailure = {
  __typename?: 'ProgramInvitations_AddUsersToProgramFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input argument for AddUsersToProgram (AddUsersToProgramRequest in gRPC). Caller identity is taken from the session when not overridden server-side. */
export type ProgramInvitations_AddUsersToProgramInput = {
  /** Invitees to add */
  invitees: Array<ProgramInvitations_AddUsersToProgramInviteeInput>;
  /** Organization ID. Used to resolve the org's system (All Learners) program when programId is not provided. */
  orgId?: InputMaybe<Scalars['ID']>;
  /** Enterprise program ID. Used if provided, otherwise orgId is used to resolve org's system program. */
  programId?: InputMaybe<Scalars['ID']>;
  /** Source of the invitation for learner profile update semantics (ProgramInvitationType in gRPC). */
  programInvitationType?: InputMaybe<ProgramInvitations_ProgramInvitationType>;
  /** Optional enterprise roster ID */
  rosterId?: InputMaybe<Scalars['ID']>;
};

/** Input for a single invitee when adding users to a program (ProgramInvitee in gRPC). */
export type ProgramInvitations_AddUsersToProgramInviteeInput = {
  /** Invitee email */
  email: Scalars['String'];
  /** Optional invitee external ID */
  externalId?: InputMaybe<Scalars['ID']>;
  /** Invitee name */
  name: Scalars['String'];
  /** Optional enterprise learner profile standard fields */
  standardFields?: InputMaybe<EnterpriseUsers_EnterpriseLearnerProfileStandardFieldsInput>;
};

/** Result of AddUsersToProgram */
export type ProgramInvitations_AddUsersToProgramResult = ProgramInvitations_AddUsersToProgramFailure | ProgramInvitations_AddUsersToProgramSuccess;

/** Returned on ProgramInvitations_AddUsersToProgram mutation success (AddUsersToProgramResponse in gRPC). */
export type ProgramInvitations_AddUsersToProgramSuccess = {
  __typename?: 'ProgramInvitations_AddUsersToProgramSuccess';
  /** Invitees that failed validation or conflict checks */
  failed: Array<ProgramInvitations_AddUsersToProgramFailedInvitee>;
  /** Emails for which program membership was created directly instead of an invitation */
  membershipEmails: Array<Scalars['String']>;
  /** Enterprise program ID */
  programId: Scalars['ID'];
  /** Optional enterprise roster ID */
  rosterId?: Maybe<Scalars['ID']>;
  /** Invitees for which an invitation was created or updated successfully */
  successful: Array<ProgramInvitations_AddUsersToProgramSuccessfulInvitee>;
};

/** Successful per-invitee outcome (ProgramInviteeSuccessful in gRPC). */
export type ProgramInvitations_AddUsersToProgramSuccessfulInvitee = {
  __typename?: 'ProgramInvitations_AddUsersToProgramSuccessfulInvitee';
  /** Invitee email */
  email: Scalars['String'];
  /** Optional invitee external ID */
  externalId?: Maybe<Scalars['ID']>;
  /** True when this was the first invitation for this email in the program */
  firstInvitation: Scalars['Boolean'];
  /** Invitee name */
  name: Scalars['String'];
  /** Program invitation ID */
  programInvitationId: Scalars['ID'];
  /** Standard fields associated with the invitee */
  standardFields?: Maybe<EnterpriseLearnerProfile_StandardFields>;
};

/** Returned on ProgramInvitations_CreateInvitation mutation failure */
export type ProgramInvitations_CreateInvitationFailure = {
  __typename?: 'ProgramInvitations_CreateInvitationFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input argument for creating an invitation */
export type ProgramInvitations_CreateInvitationInput = {
  /** Invitee email */
  inviteeEmail: Scalars['String'];
  /** Optional invitee external ID */
  inviteeExternalId?: InputMaybe<Scalars['ID']>;
  /** Invitee name */
  inviteeName: Scalars['String'];
  /** Enterprise program ID */
  programId: Scalars['ID'];
  /** Optional enterprise roster ID */
  rosterId?: InputMaybe<Scalars['ID']>;
};

/** Result of creating an invitation */
export type ProgramInvitations_CreateInvitationResult = ProgramInvitations_CreateInvitationFailure | ProgramInvitations_CreateInvitationSuccess;

/** Returned on ProgramInvitations_CreateInvitation mutation success */
export type ProgramInvitations_CreateInvitationSuccess = {
  __typename?: 'ProgramInvitations_CreateInvitationSuccess';
  /** Invitation created */
  invitation: ProgramInvitations_Invitation;
};

/** Program invitation */
export type ProgramInvitations_Invitation = {
  __typename?: 'ProgramInvitations_Invitation';
  /** Invitation created at timestamp */
  createdAt: Scalars['DateTime'];
  /** Optional invitation deletion timestamp */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Invitation state */
  invitationState: ProgramInvitations_InvitationState;
  /** Program invitee */
  invitee: ProgramInvitations_Invitee;
  /** Third party organization */
  naptimeThirdPartyOrganization: ThirdPartyOrganizationsV1;
  /** Program Id */
  program: EnterpriseProgram_EnterpriseProgram;
  /** Invitation ID */
  programInvitationId: Scalars['ID'];
  /** Invitation email reminder send times */
  reminderSendTimes: Array<Scalars['DateTime']>;
  /** Roster Id */
  rosterId: Scalars['ID'];
  /** Invitation email send attempt times */
  sendAttemptTimes: Array<Scalars['DateTime']>;
  /** Invitation updated at timestamp */
  updatedAt: Scalars['DateTime'];
};

/** Enum for invitation state */
export const ProgramInvitations_InvitationState = {
  /** Invitation has been accepted */
  Accepted: 'ACCEPTED',
  /** Invitation is active */
  Active: 'ACTIVE',
  /** Invitation is deleted */
  Deleted: 'DELETED'
} as const;

export type ProgramInvitations_InvitationState = typeof ProgramInvitations_InvitationState[keyof typeof ProgramInvitations_InvitationState];
/** Paginated result for invitations */
export type ProgramInvitations_InvitationsPaginatedResult = {
  __typename?: 'ProgramInvitations_InvitationsPaginatedResult';
  /** List of program invitations */
  elements: Array<ProgramInvitations_Invitation>;
  /** Pagination information */
  pagination: Pagination;
};

/** Program invitee data */
export type ProgramInvitations_Invitee = {
  __typename?: 'ProgramInvitations_Invitee';
  /** Email */
  email: Scalars['String'];
  /** Optional external ID */
  externalId?: Maybe<Scalars['ID']>;
  /** Name */
  name: Scalars['String'];
};

/** Returned on ProgramInvitations_MultiDeleteInvitations mutation failure */
export type ProgramInvitations_MultiDeleteInvitationsFailure = {
  __typename?: 'ProgramInvitations_MultiDeleteInvitationsFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input argument for bulk deleting invitations */
export type ProgramInvitations_MultiDeleteInvitationsInput = {
  /** List of invitation IDs to delete */
  invitationIds: Array<Scalars['ID']>;
};

/** Result of bulk deleting invitations */
export type ProgramInvitations_MultiDeleteInvitationsResult = ProgramInvitations_MultiDeleteInvitationsFailure | ProgramInvitations_MultiDeleteInvitationsSuccess;

/** Returned on ProgramInvitations_MultiDeleteInvitations mutation success */
export type ProgramInvitations_MultiDeleteInvitationsSuccess = {
  __typename?: 'ProgramInvitations_MultiDeleteInvitationsSuccess';
  /** Dummy boolean */
  _?: Maybe<Scalars['Boolean']>;
};

/** Program invitation creation channel (non-INVALID values of ProgramInvitationType in gRPC). */
export const ProgramInvitations_ProgramInvitationType = {
  /** API flow */
  Api: 'API',
  /** CSV import flow */
  Csv: 'CSV',
  /** SAML-based flow */
  Saml: 'SAML'
} as const;

export type ProgramInvitations_ProgramInvitationType = typeof ProgramInvitations_ProgramInvitationType[keyof typeof ProgramInvitations_ProgramInvitationType];
/** Error codes for per-invitee failure cases in AddUsersToProgram (copy of ProgramInviteeError in gRPC). */
export const ProgramInvitations_ProgramInviteeError = {
  /** Program Invitation already exists for the invitee email */
  ProgramInviteeErrorExistingInvitationForEmail: 'PROGRAM_INVITEE_ERROR_EXISTING_INVITATION_FOR_EMAIL',
  /** Program Invitation already exists for the invitee external ID */
  ProgramInviteeErrorExistingInvitationForExternalId: 'PROGRAM_INVITEE_ERROR_EXISTING_INVITATION_FOR_EXTERNAL_ID',
  /** Program Membership already exists for the invitee email */
  ProgramInviteeErrorExistingMembershipForEmail: 'PROGRAM_INVITEE_ERROR_EXISTING_MEMBERSHIP_FOR_EMAIL',
  /** Program Membership already exists for the invitee external ID */
  ProgramInviteeErrorExistingMembershipForExternalId: 'PROGRAM_INVITEE_ERROR_EXISTING_MEMBERSHIP_FOR_EXTERNAL_ID',
  /** Invalid invitee */
  ProgramInviteeErrorInvalid: 'PROGRAM_INVITEE_ERROR_INVALID',
  /** Invalid invitee email */
  ProgramInviteeErrorInvalidEmail: 'PROGRAM_INVITEE_ERROR_INVALID_EMAIL',
  /** Invalid invitee external ID */
  ProgramInviteeErrorInvalidExternalId: 'PROGRAM_INVITEE_ERROR_INVALID_EXTERNAL_ID',
  /** Invalid invitee full name */
  ProgramInviteeErrorInvalidFullName: 'PROGRAM_INVITEE_ERROR_INVALID_FULL_NAME',
  /** User is managed by SCIM and cannot be invited to the program */
  ProgramInviteeErrorScimManaged: 'PROGRAM_INVITEE_ERROR_SCIM_MANAGED',
  /** Program Invitation unhandled error */
  ProgramInviteeErrorUnhandledError: 'PROGRAM_INVITEE_ERROR_UNHANDLED_ERROR'
} as const;

export type ProgramInvitations_ProgramInviteeError = typeof ProgramInvitations_ProgramInviteeError[keyof typeof ProgramInvitations_ProgramInviteeError];
/** Returned on ProgramInvitations_TriggerExpiryJob mutation failure */
export type ProgramInvitations_TriggerExpiryJobFailure = {
  __typename?: 'ProgramInvitations_TriggerExpiryJobFailure';
  /** Error message */
  message: Scalars['String'];
};

/** Input argument for triggering the ProgramInvitationExpiryJob */
export type ProgramInvitations_TriggerExpiryJobInput = {
  /** When true, previews who would be removed without deleting. */
  isDryRun?: Scalars['Boolean'];
  /** Organization ID to scope the cleanup to (required). */
  organizationId: Scalars['ID'];
  /** Remove pending ACTIVE invitations older than this many days. */
  thresholdDays: Scalars['Int'];
};

/** Result of triggering the ProgramInvitationExpiryJob */
export type ProgramInvitations_TriggerExpiryJobResult = ProgramInvitations_TriggerExpiryJobFailure | ProgramInvitations_TriggerExpiryJobSuccess;

/** Returned on ProgramInvitations_TriggerExpiryJob mutation success */
export type ProgramInvitations_TriggerExpiryJobSuccess = {
  __typename?: 'ProgramInvitations_TriggerExpiryJobSuccess';
  /** Airflow invocation id of the triggered job run */
  invocationId: Scalars['ID'];
};

/** Source of program membership creation */
export const ProgramMembership_CreationSource = {
  /** membership created from auto-acceptance */
  AutoAccepted: 'AUTO_ACCEPTED',
  /** membership created from learner-action */
  LearnerAction: 'LEARNER_ACTION'
} as const;

export type ProgramMembership_CreationSource = typeof ProgramMembership_CreationSource[keyof typeof ProgramMembership_CreationSource];
/** Input for accepting all pending program invitations within an organization. UserId will be picked from the context. */
export type ProgramMembership_JoinAllPendingForOrgInput = {
  /** Organization ID whose pending program invitations should be accepted */
  organizationId: Scalars['ID'];
};

/** Join result for a single program within a ProgramMembership_JoinAllPendingForOrg call */
export type ProgramMembership_JoinAllPendingForOrgProgramResult = {
  __typename?: 'ProgramMembership_JoinAllPendingForOrgProgramResult';
  /** The program ID this result corresponds to */
  programId: Scalars['ID'];
  /** The join outcome for this program, using the same success/failure union as ProgramMembership_Join */
  result: ProgramMembership_JoinResult;
};

/**
 * Result of accepting all pending program invitations within an organization.
 * Contains a per-program result for each invitation that was processed.
 */
export type ProgramMembership_JoinAllPendingForOrgResult = {
  __typename?: 'ProgramMembership_JoinAllPendingForOrgResult';
  /** Per-program join results for each pending invitation processed within the organization */
  results: Array<ProgramMembership_JoinAllPendingForOrgProgramResult>;
};

/** Input for Joining the user into the program, UserId will be picked from the context */
export type ProgramMembership_JoinInput = {
  /** Optional Course ID, this will be sent when Program is enrolled when Joining the Course. And it will be used in sending the Notification. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Optional creation_source, this will store the source of program membership creation */
  creationSource?: InputMaybe<ProgramMembership_CreationSource>;
  /** Program ID */
  programId: Scalars['ID'];
};

/** Result of joining the user into program */
export type ProgramMembership_JoinResult = ProgramMembership_JoinResultFailure | ProgramMembership_JoinResultSuccess;

/** ProgramMembership_Join mutation Error. */
export const ProgramMembership_JoinResultError = {
  /** User is already a member of program */
  AlreadyAMember: 'ALREADY_A_MEMBER',
  /** No active contract is found for the program */
  ContractNotActive: 'CONTRACT_NOT_ACTIVE',
  /** No contract is found for the program */
  ContractNotAvailable: 'CONTRACT_NOT_AVAILABLE',
  /** Error if no available seat is available for the user on the contract */
  CreateMembershipEnrollmentCapLimitError: 'CREATE_MEMBERSHIP_ENROLLMENT_CAP_LIMIT_ERROR',
  /** User limit exceed for the contract, counts unique number of users across all active rosters for the contract. */
  CreateMembershipUserLimitError: 'CREATE_MEMBERSHIP_USER_LIMIT_ERROR',
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** Program state is not a valid state to Join */
  InvalidStateToJoin: 'INVALID_STATE_TO_JOIN',
  /** Membership not found against the programId and userId */
  MembershipNotFound: 'MEMBERSHIP_NOT_FOUND'
} as const;

export type ProgramMembership_JoinResultError = typeof ProgramMembership_JoinResultError[keyof typeof ProgramMembership_JoinResultError];
/** Returned on ProgramMembership_Join mutation failure. */
export type ProgramMembership_JoinResultFailure = {
  __typename?: 'ProgramMembership_JoinResultFailure';
  /** reason for the error */
  error: ProgramMembership_JoinResultError;
};

/** Returned on ProgramMembership_Join mutation success. */
export type ProgramMembership_JoinResultSuccess = {
  __typename?: 'ProgramMembership_JoinResultSuccess';
  /** User's updated state of profile consents */
  success: Scalars['Boolean'];
};

/** Input for resending the verification email to the user */
export type ProgramMembership_ResendVerificationEmailInput = {
  /** Program membership ID */
  programMembershipId: ProgramMemberships_ProgramMembershipId;
  /** Optional redirectUrl to redirect the user after verification, should start with /program */
  redirectUrl?: InputMaybe<Scalars['String']>;
};

/** Result of resending the verification email to the user */
export type ProgramMembership_ResendVerificationEmailResult = ProgramMembership_ResendVerificationEmailResultFailure | ProgramMembership_ResendVerificationEmailResultSuccess;

/** ProgramMembership_ResendVerificationEmail mutation Error. */
export const ProgramMembership_ResendVerificationEmailResultError = {
  /** The invitation and/or email is not eligible for verification */
  NotEligibleForVerification: 'NOT_ELIGIBLE_FOR_VERIFICATION'
} as const;

export type ProgramMembership_ResendVerificationEmailResultError = typeof ProgramMembership_ResendVerificationEmailResultError[keyof typeof ProgramMembership_ResendVerificationEmailResultError];
/** Returned on ProgramMembership_ResendVerificationEmail mutation failure. */
export type ProgramMembership_ResendVerificationEmailResultFailure = {
  __typename?: 'ProgramMembership_ResendVerificationEmailResultFailure';
  /** reason for the error */
  error: ProgramMembership_ResendVerificationEmailResultError;
};

/** Returned on ProgramMembership_ResendVerificationEmail mutation success. */
export type ProgramMembership_ResendVerificationEmailResultSuccess = {
  __typename?: 'ProgramMembership_ResendVerificationEmailResultSuccess';
  /** Dummy field */
  _?: Maybe<Scalars['Boolean']>;
};

/** ProgramMemberships: all queries related to ProgramMemberships. */
export type ProgramMembershipsQueries = {
  __typename?: 'ProgramMembershipsQueries';
  /** This query returns the deleted program memberships by searching with User Id. | Maximum page size: 100 */
  queryDeletedProgramMembershipsByUserId: ProgramMemberships_ProgramMembershipConnection;
  /** This query returns the program memberships by searching with Program Membership Ids. | Maximum page size: 100 */
  queryProgramMemberships: ProgramMemberships_ProgramMembershipConnection;
  /** This query returns the program memberships by searching with User Id. | Maximum page size: 100 */
  queryProgramMembershipsByUserIdAndIncludeInvitations: ProgramMemberships_ProgramMembershipConnection;
};


/** ProgramMemberships: all queries related to ProgramMemberships. */
export type ProgramMembershipsQueriesQueryDeletedProgramMembershipsByUserIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  userId: Scalars['Int'];
};


/** ProgramMemberships: all queries related to ProgramMemberships. */
export type ProgramMembershipsQueriesQueryProgramMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  programMembershipIds: Array<ProgramMemberships_ProgramMembershipId>;
};


/** ProgramMemberships: all queries related to ProgramMemberships. */
export type ProgramMembershipsQueriesQueryProgramMembershipsByUserIdAndIncludeInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  includeInvitations: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type ProgramMembershipsV2 = {
  __typename?: 'ProgramMembershipsV2';
  createdAt?: Maybe<Scalars['Float']>;
  deletedAt?: Maybe<Scalars['Float']>;
  domains?: Maybe<ProgramCurriculumDomainsV1>;
  enterpriseProgram?: Maybe<EnterpriseProgramsV1>;
  enterprisePrograms?: Maybe<Scalars['JSON']>;
  externalUserData: ProgramMembershipsV2_GenericExternalUserDataMember;
  id: Scalars['String'];
  invitationId?: Maybe<Scalars['String']>;
  membershipState: ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState;
  program?: Maybe<ProgramsV1>;
  programId: Scalars['String'];
  programs?: Maybe<Scalars['JSON']>;
  role?: Maybe<ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole>;
  rosterIds: Array<Maybe<Scalars['String']>>;
  switcherSelection?: Maybe<ProgramSwitcherSelectionsV1>;
  switcherSelections?: Maybe<Scalars['JSON']>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
  users?: Maybe<Scalars['JSON']>;
};


export type ProgramMembershipsV2DomainsArgs = {
  includeUnselectedDomains?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramMembershipsV2EnterpriseProgramArgs = {
  eventualConsistency?: InputMaybe<Scalars['Boolean']>;
};

export type ProgramMembershipsV2ByUser = {
  __typename?: 'ProgramMembershipsV2ByUser';
  connection?: Maybe<ProgramMembershipsV2Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ProgramMembershipsV2Connection = {
  __typename?: 'ProgramMembershipsV2Connection';
  elements: Array<Maybe<ProgramMembershipsV2>>;
  paging: ResponsePagination;
};

export type ProgramMembershipsV2DeletedMembershipsByUser = {
  __typename?: 'ProgramMembershipsV2DeletedMembershipsByUser';
  connection?: Maybe<ProgramMembershipsV2Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type ProgramMembershipsV2Resource = {
  __typename?: 'ProgramMembershipsV2Resource';
  byUser?: Maybe<ProgramMembershipsV2Connection>;
  deletedMembershipsByUser?: Maybe<ProgramMembershipsV2Connection>;
  get?: Maybe<ProgramMembershipsV2>;
  multiGet?: Maybe<ProgramMembershipsV2Connection>;
};


export type ProgramMembershipsV2ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type ProgramMembershipsV2ResourceDeletedMembershipsByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type ProgramMembershipsV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramMembershipsV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramMembershipsV2ResourceMutations = {
  __typename?: 'ProgramMembershipsV2ResourceMutations';
  create?: Maybe<ProgramMembershipsV2Connection>;
  delete?: Maybe<ProgramMembershipsV2Connection>;
  multiDelete?: Maybe<Scalars['JSON']>;
  resendVerificationEmail?: Maybe<Scalars['JSON']>;
};


export type ProgramMembershipsV2ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
  isSoftDelete?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramMembershipsV2ResourceMutationsMultiDeleteArgs = {
  isSoftDelete?: InputMaybe<Scalars['Boolean']>;
  programId: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};


export type ProgramMembershipsV2ResourceMutationsResendVerificationEmailArgs = {
  id: Scalars['String'];
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ProgramMembershipsV2_GenericExternalUserDataMember = {
  __typename?: 'ProgramMembershipsV2_genericExternalUserDataMember';
  genericExternalUserData: ProgramMembershipsV2_Org_Coursera_Program_Invitation_GenericExternalUserData;
};

export type ProgramMembershipsV2_Org_Coursera_Program_Invitation_GenericExternalUserData = {
  __typename?: 'ProgramMembershipsV2_org_coursera_program_invitation_GenericExternalUserData';
  email: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
};

export const ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState = {
  DeletedMember: 'DELETED_MEMBER',
  Invited: 'INVITED',
  InvitedEmailNotVerified: 'INVITED_EMAIL_NOT_VERIFIED',
  Member: 'MEMBER',
  NotMember: 'NOT_MEMBER',
  SoftDeletedMember: 'SOFT_DELETED_MEMBER',
  Whitelisted: 'WHITELISTED'
} as const;

export type ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState = typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState[keyof typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramMembershipState];
export const ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole = {
  DerivedProgramAdmin: 'DERIVED_PROGRAM_ADMIN',
  Member: 'MEMBER',
  ProgramAdmin: 'PROGRAM_ADMIN'
} as const;

export type ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole = typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole[keyof typeof ProgramMembershipsV2_Org_Coursera_Program_Membership_ProgramRole];
/** Model representing generated program membership entry */
export type ProgramMemberships_ProgramMembership = {
  __typename?: 'ProgramMemberships_ProgramMembership';
  /** TODO: Complete this description */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** TODO: Complete this description */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** TODO: Complete this description */
  emailVerified?: Maybe<Scalars['Boolean']>;
  /** Program membership Id */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  invitationId?: Maybe<Scalars['String']>;
  /** Program the user is a member of. */
  program?: Maybe<EnterpriseProgram>;
  /** TODO: Complete this description */
  rosterIds?: Maybe<Array<Scalars['String']>>;
  /** TODO: Complete this description */
  state: EnterpriseProgramMemberships_ProgramMembershipState;
  /** TODO: Complete this description */
  userData: ProgramMemberships_UserData;
};

/** Program membership with pagination model. */
export type ProgramMemberships_ProgramMembershipConnection = {
  __typename?: 'ProgramMemberships_ProgramMembershipConnection';
  /** TODO: Complete this description */
  edges?: Maybe<Array<Maybe<ProgramMemberships_ProgramMembershipEdge>>>;
  /** TODO: Complete this description */
  pageInfo: PageInfo;
  /** TODO: Complete this description */
  totalCount: Scalars['Int'];
};

/** TODO: Complete this description */
export type ProgramMemberships_ProgramMembershipEdge = {
  __typename?: 'ProgramMemberships_ProgramMembershipEdge';
  /** TODO: Complete this description */
  cursor: Scalars['String'];
  /** TODO: Complete this description */
  node?: Maybe<ProgramMemberships_ProgramMembership>;
};

/** Program membership Id is constructed by UserId and ProgramId */
export type ProgramMemberships_ProgramMembershipId = {
  /** TODO: Complete this description */
  programId: Scalars['String'];
  /** TODO: Complete this description */
  userId: Scalars['Int'];
};

/** Shared user data modal for enterprise user. */
export type ProgramMemberships_UserData = {
  __typename?: 'ProgramMemberships_UserData';
  /** User email */
  email: Scalars['String'];
  /** User external Id, it is possible to be null */
  externalId?: Maybe<Scalars['String']>;
  /** User full name */
  fullName: Scalars['String'];
};

export type ProgramProductMetadataV1 = {
  __typename?: 'ProgramProductMetadataV1';
  id: Scalars['String'];
  metadataType: ProgramProductMetadataV1_MetadataType;
  productItemId: Scalars['String'];
  productType: Scalars['String'];
  programId: Scalars['String'];
};

export type ProgramProductMetadataV1Connection = {
  __typename?: 'ProgramProductMetadataV1Connection';
  elements: Array<Maybe<ProgramProductMetadataV1>>;
  paging: ResponsePagination;
};

export type ProgramProductMetadataV1Resource = {
  __typename?: 'ProgramProductMetadataV1Resource';
  get?: Maybe<ProgramProductMetadataV1>;
  multiGet?: Maybe<ProgramProductMetadataV1Connection>;
};


export type ProgramProductMetadataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramProductMetadataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramProductMetadataV1_CourseMember = {
  __typename?: 'ProgramProductMetadataV1_courseMember';
  course: ProgramProductMetadataV1_Org_Coursera_Enterprise_Curriculumbuilder_ProgramCourseMetadata;
};

export type ProgramProductMetadataV1_MetadataType = ProgramProductMetadataV1_CourseMember | ProgramProductMetadataV1_SpecializationMember;

export type ProgramProductMetadataV1_Org_Coursera_Enterprise_Curriculumbuilder_ProgramCourseMetadata = {
  __typename?: 'ProgramProductMetadataV1_org_coursera_enterprise_curriculumbuilder_ProgramCourseMetadata';
  courseId: Scalars['String'];
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  isExclusive: Scalars['Boolean'];
  isSelectedForCredit: Scalars['Boolean'];
};

export type ProgramProductMetadataV1_Org_Coursera_Enterprise_Curriculumbuilder_ProgramSpecializationMetadata = {
  __typename?: 'ProgramProductMetadataV1_org_coursera_enterprise_curriculumbuilder_ProgramSpecializationMetadata';
  associatedSessionId?: Maybe<Scalars['String']>;
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  isSelectedForCredit: Scalars['Boolean'];
  s12nId: Scalars['String'];
};

export type ProgramProductMetadataV1_SpecializationMember = {
  __typename?: 'ProgramProductMetadataV1_specializationMember';
  specialization: ProgramProductMetadataV1_Org_Coursera_Enterprise_Curriculumbuilder_ProgramSpecializationMetadata;
};

export type ProgramSwitcherSelectionsV1 = {
  __typename?: 'ProgramSwitcherSelectionsV1';
  degree?: Maybe<DegreesV1>;
  /** Identifier for a degree. */
  degreeId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  program?: Maybe<ProgramsV1>;
  programId?: Maybe<Scalars['String']>;
  selectionType: ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type ProgramSwitcherSelectionsV1Connection = {
  __typename?: 'ProgramSwitcherSelectionsV1Connection';
  elements: Array<Maybe<ProgramSwitcherSelectionsV1>>;
  paging: ResponsePagination;
};

export type ProgramSwitcherSelectionsV1Resource = {
  __typename?: 'ProgramSwitcherSelectionsV1Resource';
  get?: Maybe<ProgramSwitcherSelectionsV1>;
  multiGet?: Maybe<ProgramSwitcherSelectionsV1Connection>;
};


export type ProgramSwitcherSelectionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramSwitcherSelectionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramSwitcherSelectionsV1ResourceMutations = {
  __typename?: 'ProgramSwitcherSelectionsV1ResourceMutations';
  update?: Maybe<ProgramSwitcherSelectionsV1Connection>;
};


export type ProgramSwitcherSelectionsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export const ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType = {
  Coursera: 'COURSERA',
  Degree: 'DEGREE',
  NotSelected: 'NOT_SELECTED',
  Program: 'PROGRAM'
} as const;

export type ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType = typeof ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType[keyof typeof ProgramSwitcherSelectionsV1_Org_Coursera_Program_Switcher_ProgramSwitcherSelectionType];
/** All queries belonging to ProgramUserCredits */
export type ProgramUserCreditsQueries = {
  __typename?: 'ProgramUserCreditsQueries';
  /**
   * This query returns the remaining credits for a user within a program.
   * It does not support pagination, but adding required fields would create non-breaking changes.
   */
  queryByProgramEnrollmentId: ProgramUserCredits_ProgramUserCreditsEntry;
  /** This query returns the remaining credits for each user in a list of users within a program. | Maximum page size: 100 */
  queryByProgramEnrollmentIds: ProgramUserCredits_ProgramUserCreditsConnection;
};


/** All queries belonging to ProgramUserCredits */
export type ProgramUserCreditsQueriesQueryByProgramEnrollmentIdArgs = {
  programEnrollmentId: ProgramUserCredits_ProgramEnrollmentId;
};


/** All queries belonging to ProgramUserCredits */
export type ProgramUserCreditsQueriesQueryByProgramEnrollmentIdsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  programEnrollmentIds: Array<ProgramUserCredits_ProgramEnrollmentId>;
};

/** coursesRemainingReason model */
export const ProgramUserCredits_CoursesRemainingReason = {
  /** Limit on the number of courses per user specified in the contract */
  ProgramUserCreditsContractCoursesPerUserLimit: 'PROGRAM_USER_CREDITS_CONTRACT_COURSES_PER_USER_LIMIT',
  /** Limit on the number of enrollments */
  ProgramUserCreditsEnrollmentCapLimit: 'PROGRAM_USER_CREDITS_ENROLLMENT_CAP_LIMIT',
  /** Is invalid */
  ProgramUserCreditsInvalid: 'PROGRAM_USER_CREDITS_INVALID',
  /** Limit on the number of courses per user specified by a program */
  ProgramUserCreditsProgramCoursesPerUserLimit: 'PROGRAM_USER_CREDITS_PROGRAM_COURSES_PER_USER_LIMIT'
} as const;

export type ProgramUserCredits_CoursesRemainingReason = typeof ProgramUserCredits_CoursesRemainingReason[keyof typeof ProgramUserCredits_CoursesRemainingReason];
/** Input type to Get and MultiGet queries */
export type ProgramUserCredits_ProgramEnrollmentId = {
  /** Id of program */
  programId: Scalars['String'];
  /** Id of user enrolled in given program */
  userId: Scalars['Int'];
};

/** Pagination friendly structure. */
export type ProgramUserCredits_ProgramUserCreditsConnection = {
  __typename?: 'ProgramUserCredits_ProgramUserCreditsConnection';
  /** List of edges is essentially the list of requested data along with potential metadata */
  edges?: Maybe<Array<ProgramUserCredits_ProgramUserCreditsEdge>>;
  /** Metadata that can describe the list of edges */
  pageInfo: PageInfo;
};

/** Information specific to the edge can be used to describe the relationship between a node and caller */
export type ProgramUserCredits_ProgramUserCreditsEdge = {
  __typename?: 'ProgramUserCredits_ProgramUserCreditsEdge';
  /** Offset or ID, used for flexible pagination */
  cursor?: Maybe<Scalars['String']>;
  /** Data requester is interested in. */
  node?: Maybe<ProgramUserCredits_ProgramUserCreditsEntry>;
};

/** Model representing stored information for an entry’s remaining credits in a program. */
export type ProgramUserCredits_ProgramUserCreditsEntry = Node & {
  __typename?: 'ProgramUserCredits_ProgramUserCreditsEntry';
  /**
   * Unordered set of contracts that are available for the user to consume from. An empty set of
   * contracts indicates that the does not have any available contracts to consume from.
   *
   * If there are more than one contract, then some policy outside of this model is used to
   * determine which contract to consume from.
   */
  availableContracts: Array<Scalars['String']>;
  /** Remaining courses */
  coursesRemaining?: Maybe<Scalars['Int']>;
  /** Indicates which limit is responsible for the coursesRemaining value, if that field is present. */
  coursesRemainingReason?: Maybe<ProgramUserCredits_CoursesRemainingReason>;
  /** Id unique to each entry node */
  id: Scalars['ID'];
  /** Is limited */
  isLimited: Scalars['Boolean'];
  /** Total allocated courses */
  totalAllocatedCourses?: Maybe<Scalars['Int']>;
};

/** Programming Assignment queries. */
export type ProgrammingAssignmentQueries = {
  __typename?: 'ProgrammingAssignmentQueries';
  /** query to get programming Assignment. */
  queryProgrammingAssignment: Programming_Assignment;
};


/** Programming Assignment queries. */
export type ProgrammingAssignmentQueriesQueryProgrammingAssignmentArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};

/** Programming_Assignment. */
export type Programming_Assignment = {
  __typename?: 'Programming_Assignment';
  /** Assignment instructions. */
  assignmentInstructions: Cml_Cml;
  /** Specifies weather the assignment is graded or ungraded. */
  isGraded: Scalars['Boolean'];
  /** Maximum score possible. */
  maxScore: Scalars['Int'];
  /** Part schema for each part. */
  partSchemas: Array<Programming_PartSchema>;
  /** Fraction to pass the assignment. */
  passingFraction: Scalars['Float'];
  /** Simply ceiling of maxScore * passingFraction, but computed for client convenience. */
  passingScore: Scalars['Int'];
  /** Schema for submission. */
  submissionSchema: Programming_SubmissionSchema;
  /** Versioned programming assignment ID. */
  versionedProgrammingAssignmentId: Scalars['ID'];
};

/** Programming_CreateAttemptOverride mutation input */
export type Programming_CreateAttemptOverrideInput = {
  /** course id */
  courseId: Scalars['String'];
  /** item id */
  itemId: Scalars['String'];
  /** new max submission limit of the attempt */
  maxSubmissions?: InputMaybe<Scalars['Int']>;
  /** whether to start the attempt immediately */
  startAttemptNow?: InputMaybe<Scalars['Boolean']>;
  /** new time limit of the attempt, unit Second */
  timeLimitSeconds?: InputMaybe<Scalars['Int']>;
  /**
   * user Id, to be more accurate, it should be learner's id here
   * the override is initiated by instructor for one learner
   */
  userId: Scalars['String'];
};

/** Programming_CreateAttemptOverride mutation result */
export type Programming_CreateAttemptOverrideResult = {
  __typename?: 'Programming_CreateAttemptOverrideResult';
  /** return the latest attempt summary to give frontend an overview */
  attemptSummary?: Maybe<AttemptSummary>;
};

/** LabSubmissionSchema. */
export type Programming_LabSubmissionSchema = {
  __typename?: 'Programming_LabSubmissionSchema';
  /** Schema name for each part. */
  schemaNames: Array<Programming_SchemaName>;
};

/** Part schema. */
export type Programming_PartSchema = {
  __typename?: 'Programming_PartSchema';
  /** Max score for part. */
  maxScore: Scalars['Int'];
  /** Order in which part should be shown. */
  order: Scalars['Int'];
  /** Part ID. */
  partId: Scalars['ID'];
  /** Title of the part. */
  title: Scalars['String'];
};

/** Schema name. */
export type Programming_SchemaName = {
  __typename?: 'Programming_SchemaName';
  /** Part ID. */
  partId: Scalars['ID'];
  /** Schema name. */
  schemaName: Scalars['String'];
};

/** ScriptSubmissionSchema . */
export type Programming_ScriptSubmissionSchema = {
  __typename?: 'Programming_ScriptSubmissionSchema';
  /** programmingAssignmentSlug. */
  programmingAssignmentSlug: Scalars['String'];
};

/** Programming Assignment Submission Schema. */
export type Programming_SubmissionSchema = Programming_LabSubmissionSchema | Programming_ScriptSubmissionSchema | Programming_WebSubmissionSchema;

/** Suggested filename. */
export type Programming_SuggestedFileName = {
  __typename?: 'Programming_SuggestedFileName';
  /** Part ID. */
  partId: Scalars['ID'];
  /** Suggested filename. */
  suggestedFilename: Scalars['String'];
};

/** WebSubmissionSchema . */
export type Programming_WebSubmissionSchema = {
  __typename?: 'Programming_WebSubmissionSchema';
  /** Suggested file name for each part. */
  suggestedFilenames: Array<Programming_SuggestedFileName>;
};

export type ProgramsV1 = {
  __typename?: 'ProgramsV1';
  curriculum: ProgramsV1_Curriculum;
  id: Scalars['String'];
  program: ProgramsV1_Program;
};

export type ProgramsV1ByThirdPartyOrganizationId = {
  __typename?: 'ProgramsV1ByThirdPartyOrganizationId';
  connection?: Maybe<ProgramsV1Connection>;
  includeArchived?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};

export type ProgramsV1Connection = {
  __typename?: 'ProgramsV1Connection';
  elements: Array<Maybe<ProgramsV1>>;
  paging: ResponsePagination;
};

export type ProgramsV1Resource = {
  __typename?: 'ProgramsV1Resource';
  byThirdPartyOrganizationId?: Maybe<ProgramsV1Connection>;
  get?: Maybe<ProgramsV1>;
  multiGet?: Maybe<ProgramsV1Connection>;
  slug?: Maybe<ProgramsV1Connection>;
};


export type ProgramsV1ResourceByThirdPartyOrganizationIdArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type ProgramsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ProgramsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ProgramsV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type ProgramsV1Slug = {
  __typename?: 'ProgramsV1Slug';
  connection?: Maybe<ProgramsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ProgramsV1_ClipIdMember = {
  __typename?: 'ProgramsV1_clipIdMember';
  clipId: ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumClipCourseItemId;
};

export type ProgramsV1_CmlMember = {
  __typename?: 'ProgramsV1_cmlMember';
  cml: ProgramsV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type ProgramsV1_CourseIdMember = {
  __typename?: 'ProgramsV1_courseIdMember';
  courseId: ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumCourseItemId;
};

/** This model supports the following four types of program curriculum. 1. Courses and s12ns. The items list in TracksCurriculum only has courseIds and s12nIds. 2. Domains and sub-domains. The items list in TracksCurriculum only has domainIds and sub-domainIds. 3. Wildcard. WildcardCurriculum. 4. Combination of type 1 and 2. The item list in racksCurriculum has course Ids, s12n Ids, domain Ids, and sub-domainIds. */
export type ProgramsV1_Curriculum = ProgramsV1_TracksCurriculumMember | ProgramsV1_WildcardCurriculumMember;

export type ProgramsV1_CurriculumItems = ProgramsV1_ClipIdMember | ProgramsV1_CourseIdMember | ProgramsV1_DomainIdMember | ProgramsV1_S12nIdMember | ProgramsV1_SubdomainIdMember;

export type ProgramsV1_DegreeProgramMember = {
  __typename?: 'ProgramsV1_degreeProgramMember';
  degreeProgram: ProgramsV1_Org_Coursera_Program_DegreeProgram;
};

export type ProgramsV1_DomainIdMember = {
  __typename?: 'ProgramsV1_domainIdMember';
  domainId: ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumDomainItemId;
};

export type ProgramsV1_EnterpriseProgramMember = {
  __typename?: 'ProgramsV1_enterpriseProgramMember';
  enterpriseProgram: ProgramsV1_Org_Coursera_Program_EnterpriseProgram;
};

export type ProgramsV1_OrgCollectionIdMember = {
  __typename?: 'ProgramsV1_orgCollectionIdMember';
  orgCollectionId: ProgramsV1_Org_Coursera_Program_Curriculum_ReferenceOrgCollectionId;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type ProgramsV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'ProgramsV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<ProgramsV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type ProgramsV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'ProgramsV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<ProgramsV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type ProgramsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'ProgramsV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: ProgramsV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type ProgramsV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'ProgramsV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type ProgramsV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'ProgramsV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<ProgramsV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_DegreeProgram = {
  __typename?: 'ProgramsV1_org_coursera_program_DegreeProgram';
  metadata: ProgramsV1_Org_Coursera_Program_ProgramMetadata;
  partnerIds: Array<Maybe<Scalars['Int']>>;
};

export type ProgramsV1_Org_Coursera_Program_EnterpriseProgram = {
  __typename?: 'ProgramsV1_org_coursera_program_EnterpriseProgram';
  contractId?: Maybe<Scalars['String']>;
  maxCoursesPerUser?: Maybe<Scalars['Int']>;
  metadata: ProgramsV1_Org_Coursera_Program_ProgramMetadata;
  thirdPartyOrganizationId: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_ProgramMetadata = {
  __typename?: 'ProgramsV1_org_coursera_program_ProgramMetadata';
  curriculumId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  endedAt?: Maybe<Scalars['Float']>;
  isLocked: Scalars['Boolean'];
  landingPageBanner?: Maybe<Scalars['String']>;
  launchedAt?: Maybe<Scalars['Float']>;
  linkedAcademicDisciplineIds: Array<Maybe<Scalars['String']>>;
  linkedTargetSkillProfileIds: Array<Maybe<Scalars['String']>>;
  logo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  primaryColor?: Maybe<Scalars['String']>;
  rectangularLogo?: Maybe<Scalars['String']>;
  skillSetAvailabilityType: Org_Coursera_Program_SkillSetAvailabilityType;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  squareLogo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  tagline?: Maybe<Scalars['String']>;
  tutorialVideoAssetId?: Maybe<Scalars['String']>;
  tutorialVideoUrl?: Maybe<Scalars['String']>;
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumClipCourseItemId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumClipCourseItemId';
  courseId: Scalars['String'];
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumCourseItemId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumCourseItemId';
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumDomainItemId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumDomainItemId';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumS12nItemId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumS12nItemId';
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumSubdomainItemId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumSubdomainItemId';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumTrack = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_CurriculumTrack';
  badgeTemplateId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  createdBy?: Maybe<Scalars['Int']>;
  creationSource?: Maybe<Scalars['String']>;
  curriculumItems: Array<Maybe<ProgramsV1_CurriculumItems>>;
  description?: Maybe<ProgramsV1_CmlMember>;
  gradient?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  referenceCollectionConfiguration?: Maybe<ProgramsV1_Org_Coursera_Program_Curriculum_ReferenceCollectionConfiguration>;
  roleId?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalUnitsRequired?: Maybe<Scalars['Int']>;
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_ReferenceCollectionConfiguration = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_ReferenceCollectionConfiguration';
  enableSync: Scalars['Boolean'];
  referenceCollectionId: ProgramsV1_ReferenceCollectionId;
};

/** Reference to an enterprise organization collection used as a reference collection for curriculum tracks. */
export type ProgramsV1_Org_Coursera_Program_Curriculum_ReferenceOrgCollectionId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_ReferenceOrgCollectionId';
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_ReferencePresetCollectionId = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_ReferencePresetCollectionId';
  id: Scalars['String'];
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_TracksCurriculum = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_TracksCurriculum';
  allCourseIds: Array<Maybe<Scalars['String']>>;
  allS12nIds: Array<Maybe<Scalars['String']>>;
  coreTracks: Array<Maybe<ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumTrack>>;
  electiveTracks: Array<Maybe<ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumTrack>>;
};

export type ProgramsV1_Org_Coursera_Program_Curriculum_WildcardCurriculum = {
  __typename?: 'ProgramsV1_org_coursera_program_curriculum_WildcardCurriculum';
  electiveTracks: Array<Maybe<ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumTrack>>;
};

export type ProgramsV1_PresetCollectionIdMember = {
  __typename?: 'ProgramsV1_presetCollectionIdMember';
  presetCollectionId: ProgramsV1_Org_Coursera_Program_Curriculum_ReferencePresetCollectionId;
};

export type ProgramsV1_Program = ProgramsV1_DegreeProgramMember | ProgramsV1_EnterpriseProgramMember;

export type ProgramsV1_ReferenceCollectionId = ProgramsV1_OrgCollectionIdMember | ProgramsV1_PresetCollectionIdMember;

export type ProgramsV1_S12nIdMember = {
  __typename?: 'ProgramsV1_s12nIdMember';
  s12nId: ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumS12nItemId;
};

export type ProgramsV1_SubdomainIdMember = {
  __typename?: 'ProgramsV1_subdomainIdMember';
  subdomainId: ProgramsV1_Org_Coursera_Program_Curriculum_CurriculumSubdomainItemId;
};

export type ProgramsV1_TracksCurriculumMember = {
  __typename?: 'ProgramsV1_tracksCurriculumMember';
  tracksCurriculum: ProgramsV1_Org_Coursera_Program_Curriculum_TracksCurriculum;
};

export type ProgramsV1_WildcardCurriculumMember = {
  __typename?: 'ProgramsV1_wildcardCurriculumMember';
  wildcardCurriculum: ProgramsV1_Org_Coursera_Program_Curriculum_WildcardCurriculum;
};

export type PromoCodesV1 = {
  __typename?: 'PromoCodesV1';
  code: Scalars['String'];
  id: Scalars['String'];
  promotionId: Scalars['Float'];
};

export type PromoCodesV1ByPromotion = {
  __typename?: 'PromoCodesV1ByPromotion';
  connection?: Maybe<PromoCodesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  promotionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PromoCodesV1Connection = {
  __typename?: 'PromoCodesV1Connection';
  elements: Array<Maybe<PromoCodesV1>>;
  paging: ResponsePagination;
};

export type PromoCodesV1FindAvailableForEveryonePromoByProductId = {
  __typename?: 'PromoCodesV1FindAvailableForEveryonePromoByProductId';
  connection?: Maybe<PromoCodesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PromoCodesV1Resource = {
  __typename?: 'PromoCodesV1Resource';
  byPromotion?: Maybe<PromoCodesV1Connection>;
  findAvailableForEveryonePromoByProductId?: Maybe<PromoCodesV1Connection>;
  get?: Maybe<PromoCodesV1>;
};


export type PromoCodesV1ResourceByPromotionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  promotionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PromoCodesV1ResourceFindAvailableForEveryonePromoByProductIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PromoCodesV1ResourceGetArgs = {
  id: Scalars['String'];
};

export type PromoCodesV1ResourceMutations = {
  __typename?: 'PromoCodesV1ResourceMutations';
  create?: Maybe<PromoCodesV1Connection>;
  delete?: Maybe<PromoCodesV1Connection>;
};


export type PromoCodesV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};

/** Paginated promo codes */
export type PromoCodes_PaginatedResult = {
  __typename?: 'PromoCodes_PaginatedResult';
  /** List of promo codes */
  elements: Array<Promotions_PromoCode>;
  /** Pagination data */
  pagination: Pagination;
};

export type PromotionDetailsV1 = {
  __typename?: 'PromotionDetailsV1';
  discountAmount?: Maybe<Scalars['JSON']>;
  discountPercent?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isTest: Scalars['Boolean'];
  promotionDescription: Scalars['String'];
  promotionId: Scalars['Int'];
  promotionName: Scalars['String'];
  startsAt: Scalars['Float'];
};

export type PromotionDetailsV1ByCouponId = {
  __typename?: 'PromotionDetailsV1ByCouponId';
  connection?: Maybe<PromotionDetailsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PromotionDetailsV1ByPromoCodeId = {
  __typename?: 'PromotionDetailsV1ByPromoCodeId';
  connection?: Maybe<PromotionDetailsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PromotionDetailsV1Connection = {
  __typename?: 'PromotionDetailsV1Connection';
  elements: Array<Maybe<PromotionDetailsV1>>;
  paging: ResponsePagination;
};

export type PromotionDetailsV1Resource = {
  __typename?: 'PromotionDetailsV1Resource';
  byCouponId?: Maybe<PromotionDetailsV1Connection>;
  byPromoCodeId?: Maybe<PromotionDetailsV1Connection>;
};


export type PromotionDetailsV1ResourceByCouponIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionDetailsV1ResourceByPromoCodeIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Paginated promotion products */
export type PromotionProducts_PaginatedResult = {
  __typename?: 'PromotionProducts_PaginatedResult';
  /** List of promotions */
  elements: Array<Promotions_PromotionProductType>;
  /** Pagination */
  pagination: Pagination;
};

export type PromotionUserEligibleRulesV1 = {
  __typename?: 'PromotionUserEligibleRulesV1';
  availableForEveryone: Scalars['Boolean'];
  id: Scalars['Float'];
  neverPaid: Scalars['Boolean'];
  promotionId: Scalars['Int'];
};

export type PromotionUserEligibleRulesV1Connection = {
  __typename?: 'PromotionUserEligibleRulesV1Connection';
  elements: Array<Maybe<PromotionUserEligibleRulesV1>>;
  paging: ResponsePagination;
};

export type PromotionUserEligibleRulesV1Resource = {
  __typename?: 'PromotionUserEligibleRulesV1Resource';
  get?: Maybe<PromotionUserEligibleRulesV1>;
  multiGet?: Maybe<PromotionUserEligibleRulesV1Connection>;
};


export type PromotionUserEligibleRulesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PromotionUserEligibleRulesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PromotionUserEligibleRulesV1ResourceMutations = {
  __typename?: 'PromotionUserEligibleRulesV1ResourceMutations';
  create?: Maybe<PromotionUserEligibleRulesV1Connection>;
  update?: Maybe<PromotionUserEligibleRulesV1Connection>;
};


export type PromotionUserEligibleRulesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

/** Paginated promotion user eligible rules */
export type PromotionUserEligibleRules_PaginatedResult = {
  __typename?: 'PromotionUserEligibleRules_PaginatedResult';
  /** List of promotion user eligible rules */
  elements: Array<Promotions_PromotionUserEligibleRule>;
  /** Pagination */
  pagination: Pagination;
};

/** Promotions application queries definitions */
export type PromotionsApplicationQueries = {
  __typename?: 'PromotionsApplicationQueries';
  /** Find a promo code batch by ID */
  queryPromoCodeBatchById?: Maybe<Promotions_PromoCodeBatch>;
  /**
   * Find promo codes filtered by redemption limit.
   * Primary use case: Admin UI fetching shared codes only (exclude batch codes).
   * Pass redemptionLimit=null to get shared codes.
   */
  queryPromoCodesByPromotionIdAndRedemptionLimit: PromoCodes_PaginatedResult;
  /** Find a promotion by ID */
  queryPromotionById?: Maybe<Promotions_Promotion>;
  /** Find promotion products by promo code */
  queryPromotionProductsByPromoCode: PromotionProducts_PaginatedResult;
  /** Find promotion products by promotion ID */
  queryPromotionProductsByPromotionId: PromotionProducts_PaginatedResult;
  /** Find promotion user eligible rule by promotion ID */
  queryPromotionUserEligibleRuleByPromotionId?: Maybe<Promotions_PromotionUserEligibleRule>;
  /** Find promotion user eligible rules by promotion IDs */
  queryPromotionUserEligibleRulesByPromotionIds: PromotionUserEligibleRules_PaginatedResult;
  /** Find promotions by IDs */
  queryPromotionsByIds: Promotions_PaginatedResult;
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromoCodeBatchByIdArgs = {
  batchId: Scalars['ID'];
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromoCodesByPromotionIdAndRedemptionLimitArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  promotionId: Scalars['ID'];
  redemptionLimit?: InputMaybe<Scalars['Int']>;
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionByIdArgs = {
  promotionId: Scalars['ID'];
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionProductsByPromoCodeArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  promoCode: Scalars['ID'];
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionProductsByPromotionIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  promotionId: Scalars['ID'];
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionUserEligibleRuleByPromotionIdArgs = {
  promotionId: Scalars['ID'];
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionUserEligibleRulesByPromotionIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  promotionIds: Array<Scalars['ID']>;
};


/** Promotions application queries definitions */
export type PromotionsApplicationQueriesQueryPromotionsByIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  promotionIds: Array<Scalars['ID']>;
};

export type PromotionsV3 = {
  __typename?: 'PromotionsV3';
  couponExpiresInDaysAfterIssued?: Maybe<Scalars['Int']>;
  couponHardExpiryDate?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  creatorId?: Maybe<Scalars['Int']>;
  discountAmount?: Maybe<Scalars['JSON']>;
  discountPercent?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  isTest: Scalars['Boolean'];
  maxRedemptionsPerUser?: Maybe<Scalars['Int']>;
  maxRedemptionsTotal?: Maybe<Scalars['Int']>;
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
  paymentProcessorDiscountId?: Maybe<Scalars['String']>;
  promotionDescription: Scalars['String'];
  promotionId: Scalars['Float'];
  promotionName: Scalars['String'];
  promotionType: Scalars['String'];
  startsAt: Scalars['Float'];
};

export type PromotionsV3ByEnterprisePromotionId = {
  __typename?: 'PromotionsV3ByEnterprisePromotionId';
  connection?: Maybe<PromotionsV3Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PromotionsV3ByPaymentProcessorDiscountId = {
  __typename?: 'PromotionsV3ByPaymentProcessorDiscountId';
  connection?: Maybe<PromotionsV3Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PromotionsV3Connection = {
  __typename?: 'PromotionsV3Connection';
  elements: Array<Maybe<PromotionsV3>>;
  paging: ResponsePagination;
};

export type PromotionsV3FindByProduct = {
  __typename?: 'PromotionsV3FindByProduct';
  connection?: Maybe<PromotionsV3Connection>;
  isActive?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  productItemId?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  promotionTypes: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type PromotionsV3Resource = {
  __typename?: 'PromotionsV3Resource';
  byEnterprisePromotionId?: Maybe<PromotionsV3Connection>;
  byPaymentProcessorDiscountId?: Maybe<PromotionsV3Connection>;
  findByProduct?: Maybe<PromotionsV3Connection>;
  get?: Maybe<PromotionsV3>;
  getAll?: Maybe<PromotionsV3Connection>;
  multiGet?: Maybe<PromotionsV3Connection>;
  searchByPromotionName?: Maybe<PromotionsV3Connection>;
};


export type PromotionsV3ResourceByEnterprisePromotionIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionsV3ResourceByPaymentProcessorDiscountIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionsV3ResourceFindByProductArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  productItemId?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  promotionTypes: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionsV3ResourceGetArgs = {
  id: Scalars['String'];
};


export type PromotionsV3ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionsV3ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PromotionsV3ResourceSearchByPromotionNameArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  promotionName: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type PromotionsV3ResourceMutations = {
  __typename?: 'PromotionsV3ResourceMutations';
  addAllEligiblePromotionProducts?: Maybe<Scalars['JSON']>;
  addPromotionProduct?: Maybe<Scalars['JSON']>;
  create?: Maybe<PromotionsV3Connection>;
  deletePromotionAndProducts?: Maybe<Scalars['JSON']>;
  deletePromotionProduct?: Maybe<Scalars['JSON']>;
  update?: Maybe<PromotionsV3Connection>;
  updateEndDate?: Maybe<Scalars['JSON']>;
  updateNameAndDescription?: Maybe<Scalars['JSON']>;
  updateRedemptionLimits?: Maybe<Scalars['JSON']>;
};


export type PromotionsV3ResourceMutationsAddAllEligiblePromotionProductsArgs = {
  id: Scalars['String'];
};


export type PromotionsV3ResourceMutationsAddPromotionProductArgs = {
  id: Scalars['String'];
};


export type PromotionsV3ResourceMutationsDeletePromotionAndProductsArgs = {
  promotionId: Scalars['String'];
};


export type PromotionsV3ResourceMutationsDeletePromotionProductArgs = {
  id: Scalars['String'];
};


export type PromotionsV3ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};


export type PromotionsV3ResourceMutationsUpdateEndDateArgs = {
  newEndDate: Scalars['String'];
  promotionId: Scalars['String'];
};

export type PromotionsV3SearchByPromotionName = {
  __typename?: 'PromotionsV3SearchByPromotionName';
  connection?: Maybe<PromotionsV3Connection>;
  limit?: Maybe<Scalars['Int']>;
  promotionName: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PromotionsV4 = {
  __typename?: 'PromotionsV4';
  couponExpiresInDaysAfterIssued?: Maybe<Scalars['Int']>;
  couponHardExpiryDate?: Maybe<Scalars['Float']>;
  createdAt: Scalars['Float'];
  /** id for a Coursera user */
  creatorId?: Maybe<Scalars['Int']>;
  discountAmount?: Maybe<Scalars['JSON']>;
  discountPercent?: Maybe<Scalars['Int']>;
  endsAt?: Maybe<Scalars['Float']>;
  id: Scalars['Float'];
  isTest: Scalars['Boolean'];
  maxRedemptionsPerUser?: Maybe<Scalars['Int']>;
  maxRedemptionsTotal?: Maybe<Scalars['Int']>;
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
  paymentProcessorPromotionIds: Scalars['JSON'];
  promotionDescription: Scalars['String'];
  promotionId: Scalars['Float'];
  promotionName: Scalars['String'];
  promotionType: Scalars['String'];
  startsAt: Scalars['Float'];
};

export type PromotionsV4Connection = {
  __typename?: 'PromotionsV4Connection';
  elements: Array<Maybe<PromotionsV4>>;
  paging: ResponsePagination;
};

export type PromotionsV4Resource = {
  __typename?: 'PromotionsV4Resource';
  get?: Maybe<PromotionsV4>;
  multiGet?: Maybe<PromotionsV4Connection>;
};


export type PromotionsV4ResourceGetArgs = {
  id: Scalars['String'];
};


export type PromotionsV4ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PromotionsV4ResourceMutations = {
  __typename?: 'PromotionsV4ResourceMutations';
  create?: Maybe<PromotionsV4Connection>;
  update?: Maybe<PromotionsV4Connection>;
};


export type PromotionsV4ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

/** Promotion creation */
export type Promotions_CreatePromotionInput = {
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: InputMaybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** The discount amounts */
  discountAmounts?: InputMaybe<Array<MonetaryAmountInput>>;
  /** The discount percent */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** True if this promotion was created for testing */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: InputMaybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: InputMaybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput>>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** List of promotion products */
  promotionProducts?: InputMaybe<Array<Promotions_PromotionProduct>>;
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Created promotion definition */
export type Promotions_CreatePromotionResult = {
  __typename?: 'Promotions_CreatePromotionResult';
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: Maybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: Maybe<Scalars['DateTime']>;
  /** Creation date of the promotion */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the creator */
  creatorId?: Maybe<Scalars['Int']>;
  /** The discount amounts */
  discountAmounts?: Maybe<Array<MonetaryAmount>>;
  /** The discount percent */
  discountPercent?: Maybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the promotion used for FE caching */
  id: Scalars['ID'];
  /** True if this promotion was created for testing */
  isTest?: Maybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: Maybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: Maybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: Maybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMap>>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Promotion user eligible rule creation */
export type Promotions_CreatePromotionUserEligibleRuleInput = {
  /** Determines if the promotion is available for every one. */
  availableForEveryone?: InputMaybe<Scalars['Boolean']>;
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Created promotion definition */
export type Promotions_CreatePromotionUserEligibleRuleResult = {
  __typename?: 'Promotions_CreatePromotionUserEligibleRuleResult';
  /** Determines if the promotion is available for every one */
  availableForEveryone: Scalars['Boolean'];
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /**
   * The ID of the promotion
   * Used on FE as the cache key
   */
  promotionId: Scalars['ID'];
};

/** Promotions error interface */
export type Promotions_Error = {
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Export code batch CSV input */
export type Promotions_ExportCodeBatchInput = {
  /** The ID of the batch */
  batchId: Scalars['ID'];
};

/** Result of exporting code batch CSV */
export type Promotions_ExportCodeBatchResult = {
  __typename?: 'Promotions_ExportCodeBatchResult';
  /** Unique identifier for the batch */
  batchId: Scalars['ID'];
  /** Pre-signed S3 URL for CSV download */
  csvUrl: Scalars['URL'];
  /** URL expiry */
  expiresAt: Scalars['DateTime'];
};

/** Generate code batch input */
export type Promotions_GenerateCodeBatchInput = {
  /** Optional name for this batch (e.g., "Win back for C+ learners") */
  batchName?: InputMaybe<Scalars['String']>;
  /** Optional prefix for generated codes (e.g., "WINBACK") */
  codePrefix?: InputMaybe<Scalars['String']>;
  /** Number of codes to generate (Max 50,000) */
  codeQuantity: Scalars['Int'];
  /** Optional expiration date (Must be before or equal to promotion.ends_at) */
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Result of generating a code batch */
export type Promotions_GenerateCodeBatchResult = {
  __typename?: 'Promotions_GenerateCodeBatchResult';
  /** The generated batch */
  batch: Promotions_PromoCodeBatch;
};

/** Paginated promotions */
export type Promotions_PaginatedResult = {
  __typename?: 'Promotions_PaginatedResult';
  /** List of promotions */
  elements: Array<Promotions_Promotion>;
  /** Pagination */
  pagination: Pagination;
};

/** Payment Processor ID */
export const Promotions_PaymentProcessorId = {
  /** APPLE_INAPP */
  AppleInapp: 'APPLE_INAPP',
  /** APPLE_INAPP_SANDBOX */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** BRAINTREE */
  Braintree: 'BRAINTREE',
  /** BRAINTREE_SANDBOX */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** COURSERA_MANUAL */
  CourseraManual: 'COURSERA_MANUAL',
  /** EBANX */
  Ebanx: 'EBANX',
  /** EBANX_SANDBOX */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** EMERGENT */
  Emergent: 'EMERGENT',
  /** EMERGENT_SANDBOX */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** FINANCIAL_AID */
  FinancialAid: 'FINANCIAL_AID',
  /** GOOGLE_PLAY */
  GooglePlay: 'GOOGLE_PLAY',
  /** MOCK */
  Mock: 'MOCK',
  /** PAYPAL */
  Paypal: 'PAYPAL',
  /** PAYPAL_SANDBOX */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** RAZORPAY */
  Razorpay: 'RAZORPAY',
  /** RAZORPAY_SANDBOX */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** STRIPE */
  Stripe: 'STRIPE',
  /** STRIPE_BV_CONSUMER */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** STRIPE_BV_CONSUMER_SANDBOX */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** STRIPE_CONSUMER */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** STRIPE_CONSUMER_SANDBOX */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** STRIPE_SANDBOX */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** ZERO_DOLLAR */
  ZeroDollar: 'ZERO_DOLLAR'
} as const;

export type Promotions_PaymentProcessorId = typeof Promotions_PaymentProcessorId[keyof typeof Promotions_PaymentProcessorId];
/** Payment processor ID to payment processor promotion ID map */
export type Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMap = {
  __typename?: 'Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMap';
  /** Payment processor ID */
  paymentProcessorId: Promotions_PaymentProcessorId;
  /** Payment processor promotion ID */
  paymentProcessorPromotionId: Scalars['ID'];
};

/** Payment processor ID to payment processor promotion ID map */
export type Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput = {
  /** Payment processor ID */
  paymentProcessorId: Promotions_PaymentProcessorId;
  /** Payment processor promotion ID */
  paymentProcessorPromotionId: Scalars['ID'];
};

/** Product types supported by payment system. */
export const Promotions_ProductType = {
  /** CatalogSubscription */
  CatalogSubscription: 'CatalogSubscription',
  /** Currently represents a one time product that gives access to a collection of content. */
  CourseraPlus: 'CourseraPlus',
  /** A subscription product that gives access to a collection of content. */
  CourseraPlusSubscription: 'CourseraPlusSubscription',
  /** CourseraTierLite */
  CourseraTierLite: 'CourseraTierLite',
  /** CredentialTrack */
  CredentialTrack: 'CredentialTrack',
  /** CredentialTrackCourse */
  CredentialTrackCourse: 'CredentialTrackCourse',
  /**
   * A new version of CredentialTrackCourse that has different revenue recognition and ownership
   * granting logic from the original version.
   */
  CredentialTrackCourseV2: 'CredentialTrackCourseV2',
  /** CredentialTrackSubscription */
  CredentialTrackSubscription: 'CredentialTrackSubscription',
  /**
   * A new version of CredentialTrackSubscription that has different revenue recognition and
   * ownership granting logic from the original version.
   */
  CredentialTrackSubscriptionV2: 'CredentialTrackSubscriptionV2',
  /** EnterpriseContract */
  EnterpriseContract: 'EnterpriseContract',
  /** FacilitatedLearning */
  FacilitatedLearning: 'FacilitatedLearning',
  /** InterestDeposit */
  InterestDeposit: 'InterestDeposit',
  /** SparkCourseShell */
  SparkCourseShell: 'SparkCourseShell',
  /** SparkSpecialization */
  SparkSpecialization: 'SparkSpecialization',
  /** SparkVerifiedCertificate */
  SparkVerifiedCertificate: 'SparkVerifiedCertificate',
  /** Specialization */
  Specialization: 'Specialization',
  /** One time specialization */
  SpecializationPrepaid: 'SpecializationPrepaid',
  /** Specialization Subscription */
  SpecializationSubscription: 'SpecializationSubscription',
  /** Course */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type Promotions_ProductType = typeof Promotions_ProductType[keyof typeof Promotions_ProductType];
/** Promo code information */
export type Promotions_PromoCode = {
  __typename?: 'Promotions_PromoCode';
  /**
   * Foreign key to promo_code_batches table.
   * null = manually created code (not part of a batch)
   * non-null = batch-generated code
   */
  batchId?: Maybe<Scalars['ID']>;
  /** The promo code string */
  code: Scalars['ID'];
  /** When the code was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the promotion this code belongs to */
  promotionId: Scalars['ID'];
  /**
   * Maximum number of times this code can be redeemed.
   * null = shared code (unlimited uses within promotion limits)
   * 1 = single-use unique code
   * n > 1 = multi-use unique code
   */
  redemptionLimit?: Maybe<Scalars['Int']>;
};

/** Promo code batch information */
export type Promotions_PromoCodeBatch = {
  __typename?: 'Promotions_PromoCodeBatch';
  /** Unique identifier for the batch */
  batchId: Scalars['ID'];
  /** Name of this batch */
  batchName?: Maybe<Scalars['String']>;
  /** Prefix used for codes in this batch */
  codePrefix?: Maybe<Scalars['String']>;
  /** Number of codes in this batch */
  codeQuantity: Scalars['Int'];
  /** When this batch was created */
  createdAt: Scalars['DateTime'];
  /** User who created this batch */
  createdBy: User_User;
  /** Expiration date for this batch */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** When this batch was invalidated (if applicable) */
  invalidatedAt?: Maybe<Scalars['DateTime']>;
  /** User who invalidated this batch (if applicable) */
  invalidatedBy?: Maybe<User_User>;
  /** Reason for invalidation (if applicable) */
  invalidationReason?: Maybe<Scalars['String']>;
  /** The promotion this batch belongs to */
  promotion: Promotions_Promotion;
};

/** Promotion type definition */
export type Promotions_Promotion = {
  __typename?: 'Promotions_Promotion';
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: Maybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: Maybe<Scalars['DateTime']>;
  /** Creation date of the promotion */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the creator */
  creatorId?: Maybe<Scalars['Int']>;
  /** The discount amounts */
  discountAmounts?: Maybe<Array<MonetaryAmount>>;
  /** The discount percent */
  discountPercent?: Maybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the promotion used for FE caching */
  id: Scalars['ID'];
  /** True if this promotion was created for testing */
  isTest?: Maybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: Maybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: Maybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: Maybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: Maybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMap>>;
  /** List of promo code batches associated with this promotion */
  promoCodeBatches: Array<Promotions_PromoCodeBatch>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Promotion product */
export type Promotions_PromotionProduct = {
  /** Product Item ID */
  productItemId?: InputMaybe<Scalars['ID']>;
  /** Product type */
  productType?: InputMaybe<Promotions_ProductType>;
};

/** Promotion type definition */
export type Promotions_PromotionProductType = {
  __typename?: 'Promotions_PromotionProductType';
  /** The product item ID used for FE caching */
  id: Scalars['ID'];
  /** Product Item ID */
  productItemId?: Maybe<Scalars['ID']>;
  /** Product type */
  productType: Promotions_ProductType;
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Promotion types */
export const Promotions_PromotionType = {
  /** CANCELLATION_DEFLECTION */
  CancellationDeflection: 'CANCELLATION_DEFLECTION',
  /** CORPORATE_SPONSORSHIP_DISCOUNT */
  CorporateSponsorshipDiscount: 'CORPORATE_SPONSORSHIP_DISCOUNT',
  /** COURSERA_PLUS_VOUCHER */
  CourseraPlusVoucher: 'COURSERA_PLUS_VOUCHER',
  /** COURSE_MIGRATED */
  CourseMigrated: 'COURSE_MIGRATED',
  /** COURSE_WITH_FULL_DISCOUNT_VOUCHER */
  CourseWithFullDiscountVoucher: 'COURSE_WITH_FULL_DISCOUNT_VOUCHER',
  /** DEGREE_ENROLLMENT_VOUCHER */
  DegreeEnrollmentVoucher: 'DEGREE_ENROLLMENT_VOUCHER',
  /** ENTERPRISE_CONTRACT */
  EnterpriseContract: 'ENTERPRISE_CONTRACT',
  /** EXTERNAL_DISCOUNT */
  ExternalDiscount: 'EXTERNAL_DISCOUNT',
  /** FINANCIAL_AID_CEILING_DISCOUNT */
  FinancialAidCeilingDiscount: 'FINANCIAL_AID_CEILING_DISCOUNT',
  /** GROUPS_DISCOUNT */
  GroupsDiscount: 'GROUPS_DISCOUNT',
  /** INTERNAL_PROMOTIONAL_DISCOUNT */
  InternalPromotionalDiscount: 'INTERNAL_PROMOTIONAL_DISCOUNT',
  /** MANUAL_DISCOUNT */
  ManualDiscount: 'MANUAL_DISCOUNT',
  /** S12N_BULK_PAY_DISCOUNT */
  S12NBulkPayDiscount: 'S12N_BULK_PAY_DISCOUNT',
  /** SPARK_DISCOUNT_VOUCHER */
  SparkDiscountVoucher: 'SPARK_DISCOUNT_VOUCHER',
  /** SPARK_REFUND_VOUCHER */
  SparkRefundVoucher: 'SPARK_REFUND_VOUCHER',
  /** SPARK_S12N_BULK_PAY */
  SparkS12NBulkPay: 'SPARK_S12N_BULK_PAY',
  /** SUBSCRIPTION_CHECKOUT_DISCOUNT */
  SubscriptionCheckoutDiscount: 'SUBSCRIPTION_CHECKOUT_DISCOUNT'
} as const;

export type Promotions_PromotionType = typeof Promotions_PromotionType[keyof typeof Promotions_PromotionType];
/** Promotion user eligible rule type definition */
export type Promotions_PromotionUserEligibleRule = {
  __typename?: 'Promotions_PromotionUserEligibleRule';
  /** Determines if the promotion is available for every one */
  availableForEveryone: Scalars['Boolean'];
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /**
   * The ID of the promotion
   * Used on FE as the cache key
   */
  promotionId: Scalars['ID'];
};

/** Specific error for missing required fields */
export type Promotions_RequiredFieldsError = Promotions_Error & {
  __typename?: 'Promotions_RequiredFieldsError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Promotion Update */
export type Promotions_UpdatePromotionInput = {
  /** Number of days that the coupon should expire after issuance */
  couponExpiresInDaysAfterIssued?: InputMaybe<Scalars['Int']>;
  /** The date the coupon expires */
  couponHardExpiryDate?: InputMaybe<Scalars['DateTime']>;
  /** The discount amounts */
  discountAmounts?: InputMaybe<Array<MonetaryAmountInput>>;
  /** The discount percent */
  discountPercent?: InputMaybe<Scalars['Int']>;
  /** The date the promotion ends */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** True if this promotion was created for testing */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** Max redemptions per user */
  maxRedemptionsPerUser?: InputMaybe<Scalars['Int']>;
  /** Max total redemptions */
  maxRedemptionsTotal?: InputMaybe<Scalars['Int']>;
  /**
   * The number of billing cycles for which the promotion applies a discount. Defaults to 1 for
   * Subscriptions if not set, and not applicable (ignored) when used for One Time Payments
   */
  numberOfBillingCycles?: InputMaybe<Scalars['Int']>;
  /** Map of payment processor IDs */
  paymentProcessorPromotionIdMaps?: InputMaybe<Array<Promotions_PaymentProcessorIdToPaymentProcessorPromotionIdMapInput>>;
  /** The description of the promotion */
  promotionDescription: Scalars['String'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
  /** The name of the promotion */
  promotionName: Scalars['String'];
  /** The promotion type */
  promotionType: Promotions_PromotionType;
  /** The date the promotion starts */
  startsAt: Scalars['DateTime'];
};

/** Updated promotion definition either success of failure */
export type Promotions_UpdatePromotionResult = Promotions_UpdatePromotionResultFailure | Promotions_UpdatePromotionResultSuccess;

/** Mutation failure result containing an array of error details */
export type Promotions_UpdatePromotionResultFailure = {
  __typename?: 'Promotions_UpdatePromotionResultFailure';
  /** Error details */
  errors: Array<Promotions_RequiredFieldsError>;
};

/** Successful mutation for updated promotion definition */
export type Promotions_UpdatePromotionResultSuccess = {
  __typename?: 'Promotions_UpdatePromotionResultSuccess';
  /** Updated promotion */
  promotion?: Maybe<Promotions_Promotion>;
};

/** Promotion user eligible rule update */
export type Promotions_UpdatePromotionUserEligibleRuleInput = {
  /** Determines if the promotion is available for every one. */
  availableForEveryone?: Scalars['Boolean'];
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /** The ID of the promotion */
  promotionId: Scalars['ID'];
};

/** Updated promotion user eligible rule definition */
export type Promotions_UpdatePromotionUserEligibleRuleResult = {
  __typename?: 'Promotions_UpdatePromotionUserEligibleRuleResult';
  /** Determines if the promotion is available for every one */
  availableForEveryone: Scalars['Boolean'];
  /** Determines if the promotion is never paid */
  neverPaid: Scalars['Boolean'];
  /**
   * The ID of the promotion
   * Used on FE as the cache key
   */
  promotionId: Scalars['ID'];
};

export type PublicPromotionInfoLandingPageBannersV1 = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1';
  /** Typeref for string that defines the isTranslatable property to true */
  bannerDescription: Scalars['String'];
  bannerDescriptionStyle?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  bannerHeading: Scalars['String'];
  bannerHeadingStyle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  leftLogoImage?: Maybe<Scalars['String']>;
  primaryBannerBackground: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  promotionDescription?: Maybe<Scalars['String']>;
  promotionDescriptionStyle?: Maybe<Scalars['String']>;
  publicPromotionInfoId: Scalars['String'];
  rightLogoImage?: Maybe<Scalars['String']>;
  secondaryBannerBackground: Scalars['String'];
};

export type PublicPromotionInfoLandingPageBannersV1ByPromoCodeId = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1ByPromoCodeId';
  connection?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoLandingPageBannersV1ByPromotionId = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1ByPromotionId';
  connection?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoLandingPageBannersV1Connection = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1Connection';
  elements: Array<Maybe<PublicPromotionInfoLandingPageBannersV1>>;
  paging: ResponsePagination;
};

export type PublicPromotionInfoLandingPageBannersV1Resource = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1Resource';
  byPromoCodeId?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  byPromotionId?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  get?: Maybe<PublicPromotionInfoLandingPageBannersV1>;
  getAll?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  multiGet?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
};


export type PublicPromotionInfoLandingPageBannersV1ResourceByPromoCodeIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoLandingPageBannersV1ResourceByPromotionIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoLandingPageBannersV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PublicPromotionInfoLandingPageBannersV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoLandingPageBannersV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PublicPromotionInfoLandingPageBannersV1ResourceMutations = {
  __typename?: 'PublicPromotionInfoLandingPageBannersV1ResourceMutations';
  create?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
  updateLandingPageBanner?: Maybe<PublicPromotionInfoLandingPageBannersV1Connection>;
};


export type PublicPromotionInfoLandingPageBannersV1ResourceMutationsUpdateLandingPageBannerArgs = {
  id: Scalars['String'];
};

export type PublicPromotionInfoProductCollectionsV1 = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1';
  /** Typeref for string that defines the isTranslatable property to true */
  collectionTitle: Scalars['String'];
  id: Scalars['Float'];
  /** Typeref for string that defines the isTranslatable property to true */
  promoValueProp?: Maybe<Scalars['String']>;
  publicPromotionInfoId: Scalars['String'];
  publicPromotionInfoProductCollectionId: Scalars['Int'];
  rowIndex: Scalars['Int'];
};

export type PublicPromotionInfoProductCollectionsV1ByPromoCodeId = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1ByPromoCodeId';
  connection?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductCollectionsV1ByPromotionId = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1ByPromotionId';
  connection?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductCollectionsV1Connection = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1Connection';
  elements: Array<Maybe<PublicPromotionInfoProductCollectionsV1>>;
  paging: ResponsePagination;
};

export type PublicPromotionInfoProductCollectionsV1Resource = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1Resource';
  byPromoCodeId?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  byPromotionId?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  getAll?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
};


export type PublicPromotionInfoProductCollectionsV1ResourceByPromoCodeIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductCollectionsV1ResourceByPromotionIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductCollectionsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PublicPromotionInfoProductCollectionsV1ResourceMutations = {
  __typename?: 'PublicPromotionInfoProductCollectionsV1ResourceMutations';
  create?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  delete?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
  update?: Maybe<PublicPromotionInfoProductCollectionsV1Connection>;
};


export type PublicPromotionInfoProductCollectionsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type PublicPromotionInfoProductCollectionsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type PublicPromotionInfoProductItemsV1 = {
  __typename?: 'PublicPromotionInfoProductItemsV1';
  colIndex: Scalars['Int'];
  id: Scalars['Float'];
  productId: Scalars['String'];
  productType: Scalars['String'];
  publicPromotionInfoProductCollectionId: Scalars['Int'];
  publicPromotionInfoProductItemId: Scalars['Int'];
};

export type PublicPromotionInfoProductItemsV1ByCollectionId = {
  __typename?: 'PublicPromotionInfoProductItemsV1ByCollectionId';
  connection?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  publicPromotionInfoProductCollectionId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductItemsV1ByMultiCollectionIds = {
  __typename?: 'PublicPromotionInfoProductItemsV1ByMultiCollectionIds';
  connection?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  publicPromotionInfoProductCollectionIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductItemsV1Connection = {
  __typename?: 'PublicPromotionInfoProductItemsV1Connection';
  elements: Array<Maybe<PublicPromotionInfoProductItemsV1>>;
  paging: ResponsePagination;
};

export type PublicPromotionInfoProductItemsV1Resource = {
  __typename?: 'PublicPromotionInfoProductItemsV1Resource';
  byCollectionId?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  byMultiCollectionIds?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  get?: Maybe<PublicPromotionInfoProductItemsV1>;
  multiGet?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
};


export type PublicPromotionInfoProductItemsV1ResourceByCollectionIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicPromotionInfoProductCollectionId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductItemsV1ResourceByMultiCollectionIdsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  publicPromotionInfoProductCollectionIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductItemsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PublicPromotionInfoProductItemsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PublicPromotionInfoProductItemsV1ResourceMutations = {
  __typename?: 'PublicPromotionInfoProductItemsV1ResourceMutations';
  create?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  delete?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
  update?: Maybe<PublicPromotionInfoProductItemsV1Connection>;
};


export type PublicPromotionInfoProductItemsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type PublicPromotionInfoProductItemsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type PublicPromotionInfoProductPageBannersV1 = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1';
  bannerBackgroundStyle: Scalars['String'];
  id: Scalars['String'];
  leftBannerImage: Scalars['String'];
  leftBannerStyle?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  promoBannerDescription: Scalars['String'];
  promoBannerDescriptionStyle?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  promoBannerLegalDisclaimer?: Maybe<Scalars['String']>;
  promoBannerLegalDisclaimerStyle?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  promoBannerTitle: Scalars['String'];
  promoBannerTitleStyle?: Maybe<Scalars['String']>;
  publicPromotionInfoId: Scalars['String'];
  rightBannerImage: Scalars['String'];
  rightBannerStyle?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  seeDetail: Scalars['String'];
};

export type PublicPromotionInfoProductPageBannersV1ByPromoCodeId = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1ByPromoCodeId';
  connection?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductPageBannersV1ByPromotionId = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1ByPromotionId';
  connection?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type PublicPromotionInfoProductPageBannersV1Connection = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1Connection';
  elements: Array<Maybe<PublicPromotionInfoProductPageBannersV1>>;
  paging: ResponsePagination;
};

export type PublicPromotionInfoProductPageBannersV1Resource = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1Resource';
  byPromoCodeId?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  byPromotionId?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  get?: Maybe<PublicPromotionInfoProductPageBannersV1>;
  getAll?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  multiGet?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
};


export type PublicPromotionInfoProductPageBannersV1ResourceByPromoCodeIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductPageBannersV1ResourceByPromotionIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductPageBannersV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type PublicPromotionInfoProductPageBannersV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type PublicPromotionInfoProductPageBannersV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type PublicPromotionInfoProductPageBannersV1ResourceMutations = {
  __typename?: 'PublicPromotionInfoProductPageBannersV1ResourceMutations';
  create?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
  updateProductPageBanner?: Maybe<PublicPromotionInfoProductPageBannersV1Connection>;
};


export type PublicPromotionInfoProductPageBannersV1ResourceMutationsUpdateProductPageBannerArgs = {
  id: Scalars['String'];
};

/** All queries related to fetching the questions in a published question bank */
export type PublishedQuestionBankQuestionsQueries = {
  __typename?: 'PublishedQuestionBankQuestionsQueries';
  /** Get paginated questions from a published question bank */
  get: QuestionBank_PublishedQuestionBankQuestionPaginatedResult;
  /** Get paginated questions from a published question bank */
  getV2: QuestionBank_PublishedQuestionBankQuestionPaginatedResultV2;
};


/** All queries related to fetching the questions in a published question bank */
export type PublishedQuestionBankQuestionsQueriesGetArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  questionBankId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};


/** All queries related to fetching the questions in a published question bank */
export type PublishedQuestionBankQuestionsQueriesGetV2Args = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  questionBankId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};

/** All QualificationSurveyExperimentQueries. */
export type QualificationSurveyExperimentQueries = {
  __typename?: 'QualificationSurveyExperimentQueries';
  /** Request for GetQualificationSurveyExperiment. GetQualificationSurveyExperiment by productId. */
  getQualificationSurveyExperiment?: Maybe<QualificationSurveyExperiment_QualificationSurveyExperiment>;
};


/** All QualificationSurveyExperimentQueries. */
export type QualificationSurveyExperimentQueriesGetQualificationSurveyExperimentArgs = {
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input for UpdateQualificationSurveyExperiment */
export type QualificationSurveyExperiment_DeleteQualificationSurveyExperimentInput = {
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** QualificationSurveyExperiment response for deleting either success of failure */
export type QualificationSurveyExperiment_DeleteQualificationSurveyExperimentResult = QualificationSurveyExperiment_Failure | QualificationSurveyExperiment_VoidSuccess;

/** QualificationSurveyExperiment_Error instance */
export type QualificationSurveyExperiment_Error = Error & {
  __typename?: 'QualificationSurveyExperiment_Error';
  /** Error message. */
  message: Scalars['String'];
};

/** Failure response containing list of errors */
export type QualificationSurveyExperiment_Failure = {
  __typename?: 'QualificationSurveyExperiment_Failure';
  /** List of errors */
  errors: Array<QualificationSurveyExperiment_Error>;
};

/** Model for a Qualification Survey Experiment */
export type QualificationSurveyExperiment_QualificationSurveyExperiment = {
  __typename?: 'QualificationSurveyExperiment_QualificationSurveyExperiment';
  /** The default value used in the experiment. */
  default?: Maybe<Scalars['String']>;
  /** The namespace of an experiment variant. */
  epicNamespace?: Maybe<Scalars['String']>;
  /** The parameters used in the namespace. */
  epicParameter?: Maybe<Scalars['String']>;
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input Model for a Qualification Survey Experiment. */
export type QualificationSurveyExperiment_QualificationSurveyExperimentInput = {
  /** The default value used in the experiment. */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** The namespace of an experiment variant. */
  epicNamespace?: InputMaybe<Scalars['String']>;
  /** The parameters used in the namespace. */
  epicParameter?: InputMaybe<Scalars['String']>;
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** Input for UpdateQualificationSurveyExperiment */
export type QualificationSurveyExperiment_UpdateQualificationSurveyExperimentInput = {
  /** qualificationSurveyExperiment to be update. */
  qualificationSurveyExperiment: QualificationSurveyExperiment_QualificationSurveyExperimentInput;
  /** qualificationSurveyProductId of the experiment. */
  qualificationSurveyProductId: Scalars['ID'];
};

/** QualificationSurveyExperiment response for updating either success of failure */
export type QualificationSurveyExperiment_UpdateQualificationSurveyExperimentResult = QualificationSurveyExperiment_Failure | QualificationSurveyExperiment_VoidSuccess;

/** Successful mutation that returns empty response payload */
export type QualificationSurveyExperiment_VoidSuccess = {
  __typename?: 'QualificationSurveyExperiment_VoidSuccess';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Query definitions for fetching Qualification Survey. */
export type QualificationSurveyQueries = {
  __typename?: 'QualificationSurveyQueries';
  /** Retrieves a QualificationSurvey by the given id. */
  getQualificationSurvey: QualificationSurvey_GetQualificationSurveyResponse;
  /** Retrieves a QualificationSurvey by the given productId. */
  getQualificationSurveyByProductId?: Maybe<QualificationSurvey_QualificationSurveyByProductIdPaginatedResult>;
};


/** Query definitions for fetching Qualification Survey. */
export type QualificationSurveyQueriesGetQualificationSurveyArgs = {
  id: Scalars['ID'];
};


/** Query definitions for fetching Qualification Survey. */
export type QualificationSurveyQueriesGetQualificationSurveyByProductIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  productId: Scalars['ID'];
};

/** Query definitions for fetching Qualification Survey Section. */
export type QualificationSurveySectionResponseQueries = {
  __typename?: 'QualificationSurveySectionResponseQueries';
  /**
   * Preview the start section (the first section) of the survey. "Preview" here means that a
   * survey response will not be created when the start section is rendered.
   * Reason why we have this endpoint: traditionally, to view the contents of a survey, we would
   * need to create a survey response. When tests (e.g. e2e tests) run to display those surveys
   * repeatedly, thus generating a large number of survey responses over time, performance issues arise.
   */
  getPreviewStartSection?: Maybe<QualificationSurveySectionResponse_QualificationSurveySectionWrapper>;
  /** Retrieve the complete qualification survey. */
  retrieveCompletedQualificationSurvey?: Maybe<QualificationSurveySectionResponse_QualificationSurveyResponse>;
};


/** Query definitions for fetching Qualification Survey Section. */
export type QualificationSurveySectionResponseQueriesGetPreviewStartSectionArgs = {
  productId: Scalars['ID'];
};


/** Query definitions for fetching Qualification Survey Section. */
export type QualificationSurveySectionResponseQueriesRetrieveCompletedQualificationSurveyArgs = {
  input: QualificationSurveySectionResponse_RetrieveCompletedQualificationSurveyInput;
};

/** Model for checkbox question response. */
export type QualificationSurveySectionResponse_CheckboxResponse = {
  __typename?: 'QualificationSurveySectionResponse_CheckboxResponse';
  /** ids */
  ids: Array<Scalars['ID']>;
  /** otherText */
  otherText?: Maybe<Scalars['String']>;
};

/** Input model for checkbox question response. */
export type QualificationSurveySectionResponse_CheckboxResponseInput = {
  /** ids */
  ids: Array<Scalars['ID']>;
  /** otherText */
  otherText?: InputMaybe<Scalars['String']>;
};

/** Input for QualificationSurveySectionResponse_CreateOrUpdate */
export type QualificationSurveySectionResponse_CreateOrUpdateInput = {
  /** The product id */
  productId: Scalars['ID'];
  /** qualification_survey_response_id field is optional for new survey responses. It needs to be provided if you want to update an existing survey response. */
  qualificationSurveyResponseId?: InputMaybe<Scalars['ID']>;
  /** QualificationSurveySectionResponse to be update. */
  sectionResponse: QualificationSurveySectionResponse_SectionResponseInput;
};

/** QualificationSurveySectionResponse response for createOrUpdate survey response either success of failure */
export type QualificationSurveySectionResponse_CreateOrUpdateResult = QualificationSurveySectionResponse_CreateOrUpdateSuccess | QualificationSurveySectionResponse_Failure;

/** Successful mutation that returns the survey response created. */
export type QualificationSurveySectionResponse_CreateOrUpdateSuccess = {
  __typename?: 'QualificationSurveySectionResponse_CreateOrUpdateSuccess';
  /** qualification_survey_response_id of qualification survey response created/updated. */
  id: Scalars['ID'];
  /** Model for a qualificationSurveySectionWrapper. */
  qualificationSurveySectionWrapper: QualificationSurveySectionResponse_QualificationSurveySectionWrapper;
};

/** Input for QualificationSurveySectionResponse_DeleteByResponseIdsInput */
export type QualificationSurveySectionResponse_DeleteByResponseIdsInput = {
  /** surveyResponseIds */
  surveyResponseIds: Array<Scalars['ID']>;
};

/** QualificationSurveySectionResponse response for Delete survey response By ResponseIds either success of failure */
export type QualificationSurveySectionResponse_DeleteByResponseIdsResult = QualificationSurveySectionResponse_DeleteByResponseIdsSuccess | QualificationSurveySectionResponse_Failure;

/** Successful deletetion that returns the survey response ids which deletes. */
export type QualificationSurveySectionResponse_DeleteByResponseIdsSuccess = {
  __typename?: 'QualificationSurveySectionResponse_DeleteByResponseIdsSuccess';
  /** qualification_survey_response_ids of qualification survey response to been deleted. */
  surveyResponseIds: Array<Scalars['ID']>;
};

/** Model for dropdown question response. */
export type QualificationSurveySectionResponse_DropdownResponse = {
  __typename?: 'QualificationSurveySectionResponse_DropdownResponse';
  /** Response id */
  id: Scalars['ID'];
};

/** Input model for dropdown question response. */
export type QualificationSurveySectionResponse_DropdownResponseInput = {
  /** Response id */
  id: Scalars['ID'];
};

/** QualificationSurveySectionResponse_Error instance */
export type QualificationSurveySectionResponse_Error = Error & {
  __typename?: 'QualificationSurveySectionResponse_Error';
  /** Error message. */
  message: Scalars['String'];
};

/** Model for expression of interest context. */
export type QualificationSurveySectionResponse_ExpressionOfInterestContextInput = {
  /**
   * Identifies the campaign and/or other attributes of the click associated with the EOI
   * This field is optional.
   */
  clickId?: InputMaybe<Scalars['ID']>;
  /**
   * Identifies the country where the Expression Of Interest is being submitted.
   * This field is optional.
   */
  countryCode?: InputMaybe<Scalars['String']>;
  /**
   * word to identify the source location of the EOI.
   * e.g. 'LinkedIn' indicate EOIs collected from off-platform sources LinkedIn,
   * and 'DDP' or 'DLP' for on-platform EOIs.
   * This field is optional.
   */
  responseSource?: InputMaybe<Scalars['String']>;
  /** Full URL of the source DDP or DLP. */
  source: Scalars['URL'];
  /** utmParameters */
  utmParameters: QualificationSurveySectionResponse_UtmParameters;
};

/** Failure response containing list of errors */
export type QualificationSurveySectionResponse_Failure = {
  __typename?: 'QualificationSurveySectionResponse_Failure';
  /** List of errors */
  errors: Array<QualificationSurveySectionResponse_Error>;
};

/** Model for multiple choice question response. */
export type QualificationSurveySectionResponse_MultipleChoiceResponse = {
  __typename?: 'QualificationSurveySectionResponse_MultipleChoiceResponse';
  /** Multiple Choice Response ID */
  id: Scalars['ID'];
};

/** Input model for multiple choice question response. */
export type QualificationSurveySectionResponse_MultipleChoiceResponseInput = {
  /** Multiple Choice Response ID */
  id: Scalars['ID'];
};

/** Model for numeric question response. */
export type QualificationSurveySectionResponse_NumericResponse = {
  __typename?: 'QualificationSurveySectionResponse_NumericResponse';
  /** Numeric Response */
  response: Scalars['Float'];
};

/** Input model for numeric question response. */
export type QualificationSurveySectionResponse_NumericResponseInput = {
  /** Numeric Response */
  response: Scalars['Float'];
};

/** Model for QualificationSurveyResponse */
export type QualificationSurveySectionResponse_QualificationSurveyResponse = {
  __typename?: 'QualificationSurveySectionResponse_QualificationSurveyResponse';
  /** completionTimestamp */
  completionTimestamp: Scalars['DateTime'];
  /** ID */
  id: Scalars['ID'];
  /** isComplete */
  isComplete: Scalars['Boolean'];
  /** lastUpdatedTimestamp */
  lastUpdatedTimestamp: Scalars['DateTime'];
  /** metadataString (The metadata string stores a serialized version of SurveyResponseMetadata) */
  metadataString?: Maybe<Scalars['String']>;
  /** responses */
  responses: Array<QualificationSurveySectionResponse_SurveyQuestionResponseMap>;
  /** sectionIds */
  sectionIds: Array<Scalars['ID']>;
  /**
   * Used to allow FE to include any additional data not related to the survey response.
   * For example: tracking, debugging, one-off partner requests for forwarding certain
   * fields (i.e. google analytic client IDs) etc.
   */
  trackingFields: Array<QualificationSurveySectionResponse_TrackingFields>;
};

/** Model for survey section */
export type QualificationSurveySectionResponse_QualificationSurveySection = QualificationSurvey_QuestionSection | QualificationSurvey_TerminalSection;

/** Model for QualificationSurveySectionWrapper */
export type QualificationSurveySectionResponse_QualificationSurveySectionWrapper = {
  __typename?: 'QualificationSurveySectionResponse_QualificationSurveySectionWrapper';
  /** QualificationSurveySection */
  section: QualificationSurveySectionResponse_QualificationSurveySection;
  /** section_id */
  sectionId: Scalars['ID'];
};

/** Input for QualificationSurveySectionResponse_RetrieveCompletedQualificationSurveyInput */
export type QualificationSurveySectionResponse_RetrieveCompletedQualificationSurveyInput = {
  /** EOI context */
  eoiContext?: InputMaybe<QualificationSurveySectionResponse_ExpressionOfInterestContextInput>;
  /** The lookback period in months */
  lookBackPeriodInMonths?: Scalars['Int'];
  /** The product id */
  productId: Scalars['ID'];
};

/** Model for survey section response input. */
export type QualificationSurveySectionResponse_SectionResponseInput = {
  /** EOI context */
  eoiContext?: InputMaybe<QualificationSurveySectionResponse_ExpressionOfInterestContextInput>;
  /** question_response_map */
  responses: Array<QualificationSurveySectionResponse_SurveyQuestionResponseMapInput>;
  /** section_id for response */
  sectionId: Scalars['ID'];
  /**
   * Used to allow FE to include any additional data not related to the survey response.
   * For example: tracking, debugging, one-off partner requests for forwarding certain
   * fields (i.e. google analytic client IDs) etc.
   */
  trackingFields: Array<QualificationSurveySectionResponse_TrackingFieldsInput>;
};

/** Model for short answer question response. */
export type QualificationSurveySectionResponse_ShortAnswerResponse = {
  __typename?: 'QualificationSurveySectionResponse_ShortAnswerResponse';
  /** Text Response */
  text: Scalars['String'];
};

/** Input model for short answer question response. */
export type QualificationSurveySectionResponse_ShortAnswerResponseInput = {
  /** Text Response */
  text: Scalars['String'];
};

/** Model for a QualificationSurvey_SurveyQuestion. */
export type QualificationSurveySectionResponse_SurveyQuestion = {
  __typename?: 'QualificationSurveySectionResponse_SurveyQuestion';
  /** Question Contents for survey question. */
  content: QualificationSurvey_QuestionContent;
  /**
   * Whether the question should take up only half the line width (where applicable) on the client
   * display.
   * This field default to false
   */
  displayHalfLine: Scalars['Boolean'];
  /** Set this question is required or not. */
  isRequired: Scalars['Boolean'];
  /** QuestionId for survey question. */
  questionId: Scalars['ID'];
};

/** Model for survey question response. */
export type QualificationSurveySectionResponse_SurveyQuestionResponse = QualificationSurveySectionResponse_CheckboxResponse | QualificationSurveySectionResponse_DropdownResponse | QualificationSurveySectionResponse_MultipleChoiceResponse | QualificationSurveySectionResponse_NumericResponse | QualificationSurveySectionResponse_ShortAnswerResponse | QualificationSurveySectionResponse_TypeaheadResponse;

/** Model for QualificationSurveySectionResponse_SurveyQuestionResponseMap. */
export type QualificationSurveySectionResponse_SurveyQuestionResponseMap = {
  __typename?: 'QualificationSurveySectionResponse_SurveyQuestionResponseMap';
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map key. */
  surveyQuestionResponseKey: Scalars['String'];
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map value. */
  surveyQuestionResponseValue: QualificationSurveySectionResponse_SurveyQuestionResponse;
};

/** Model for QualificationSurveySectionResponse_SurveyQuestionResponseMapInput. */
export type QualificationSurveySectionResponse_SurveyQuestionResponseMapInput = {
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map key. */
  surveyQuestionResponseKey: Scalars['String'];
  /** QualificationSurveySectionResponse_SurveyQuestionResponse Map value. */
  surveyQuestionResponseValue: QualificationSurveySectionResponse_SurveyQuestionResponseUnion;
};

/** Input models for survey question response. */
export type QualificationSurveySectionResponse_SurveyQuestionResponseUnion = {
  /** checkboxResponse */
  checkboxResponse?: InputMaybe<QualificationSurveySectionResponse_CheckboxResponseInput>;
  /** dropdownResponse */
  dropdownResponse?: InputMaybe<QualificationSurveySectionResponse_DropdownResponseInput>;
  /** multipleChoiceResponse */
  multipleChoiceResponse?: InputMaybe<QualificationSurveySectionResponse_MultipleChoiceResponseInput>;
  /** numericResponse */
  numericResponse?: InputMaybe<QualificationSurveySectionResponse_NumericResponseInput>;
  /** shortAnswerResponse */
  shortAnswerResponse?: InputMaybe<QualificationSurveySectionResponse_ShortAnswerResponseInput>;
  /** typeaheadResponse */
  typeaheadResponse?: InputMaybe<QualificationSurveySectionResponse_TypeaheadResponseInput>;
};

/** Model for QualificationSurveySectionResponse_TrackingFieldsInput. */
export type QualificationSurveySectionResponse_TrackingFields = {
  __typename?: 'QualificationSurveySectionResponse_TrackingFields';
  /** QualificationSurveySectionResponse_TrackingFields Map key. */
  trackingFieldsKey: Scalars['String'];
  /** QualificationSurveySectionResponse_TrackingFields Map value. */
  trackingFieldsValue: Scalars['String'];
};

/** Input model for QualificationSurveySectionResponse_TrackingFieldsInput. */
export type QualificationSurveySectionResponse_TrackingFieldsInput = {
  /** QualificationSurveySectionResponse_TrackingFields Map key. */
  trackingFieldsKey: Scalars['String'];
  /** QualificationSurveySectionResponse_TrackingFields Map value. */
  trackingFieldsValue: Scalars['String'];
};

/** Model for typeahead question response. */
export type QualificationSurveySectionResponse_TypeaheadResponse = {
  __typename?: 'QualificationSurveySectionResponse_TypeaheadResponse';
  /** id */
  id: Scalars['ID'];
  /** otherText */
  otherText?: Maybe<Scalars['String']>;
};

/** Input model for typeahead question response. */
export type QualificationSurveySectionResponse_TypeaheadResponseInput = {
  /** id */
  id?: InputMaybe<Scalars['ID']>;
  /** otherText */
  otherText?: InputMaybe<Scalars['String']>;
};

/** Model for UTM parameters. */
export type QualificationSurveySectionResponse_UtmParameters = {
  /**
   * Identifies a specific product promotion or strategic campaign. e.g utm_campaign=spring_sale.
   * This field is optional.
   */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /**
   * Identifies what specifically was clicked to bring the user to the site,
   * such as a banner ad or a text link. e.g utm_content=logolink or utm_content=textlink.
   * This field is optional.
   */
  utmContent?: InputMaybe<Scalars['String']>;
  /**
   * Identifies what type of link was used, such as cost per click or email. e.g utm_medium=cpc.
   * This field is optional.
   */
  utmMedium?: InputMaybe<Scalars['String']>;
  /**
   * Identifies which site sent the traffic, and is a required parameter. e.g utm_source=google.
   * This field is optional.
   */
  utmSource?: InputMaybe<Scalars['String']>;
  /**
   * Identifies search terms. e.g utm_term=running+shoes.
   * This field is optional.
   */
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** Model for AllConditionsValidTransition. */
export type QualificationSurvey_AllConditionsValidTransition = {
  __typename?: 'QualificationSurvey_AllConditionsValidTransition';
  /** condition for AllConditionsValidTransition. */
  conditions?: Maybe<Array<QualificationSurvey_TransitionCondition>>;
  /** destination for AllConditionsValidTransition. */
  destination: Scalars['String'];
};

/** Model for AllConditionsValidTransition. */
export type QualificationSurvey_AllConditionsValidTransitionInput = {
  /** condition for AllConditionsValidTransition. */
  conditions: Array<QualificationSurvey_TransitionConditionInput>;
  /** destination for AllConditionsValidTransition. */
  destination: Scalars['String'];
};

/** Model for any TransitionConditions. */
export type QualificationSurvey_AnyConditionsValidTransition = {
  __typename?: 'QualificationSurvey_AnyConditionsValidTransition';
  /** condition for any TransitionConditions. */
  conditions?: Maybe<Array<QualificationSurvey_TransitionCondition>>;
  /** destination for any TransitionConditions. */
  destination: Scalars['String'];
};

/** Model for any TransitionConditions. */
export type QualificationSurvey_AnyConditionsValidTransitionInput = {
  /** condition for any TransitionConditions. */
  conditions: Array<QualificationSurvey_TransitionConditionInput>;
  /** destination for any TransitionConditions. */
  destination: Scalars['String'];
};

/** Model for QualificationSurvey_CheckboxContent. */
export type QualificationSurvey_CheckboxContent = {
  __typename?: 'QualificationSurvey_CheckboxContent';
  /** helpText for QualificationSurvey_CheckboxContent. */
  helpText?: Maybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_CheckboxContent. */
  includeOther: Scalars['Boolean'];
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_CheckboxContent. */
  options?: Maybe<Array<QualificationSurvey_ChoiceAnswerOption>>;
  /** placeholderForOther for QualificationSurvey_CheckboxContent. */
  placeholderForOther?: Maybe<Scalars['String']>;
  /** prompt for QualificationSurvey_CheckboxContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_CheckboxContent. */
export type QualificationSurvey_CheckboxContentInput = {
  /** helpText for QualificationSurvey_CheckboxContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_CheckboxContent. */
  includeOther?: InputMaybe<Scalars['Boolean']>;
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_CheckboxContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** placeholderForOther for QualificationSurvey_CheckboxContent. */
  placeholderForOther?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_CheckboxContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_ChoiceAnswerOption. */
export type QualificationSurvey_ChoiceAnswerOption = {
  __typename?: 'QualificationSurvey_ChoiceAnswerOption';
  /** id for QualificationSurvey_ChoiceAnswerOption. */
  id: Scalars['ID'];
  /** text for QualificationSurvey_ChoiceAnswerOption. */
  text: Scalars['String'];
};

/** Model for QualificationSurvey_ChoiceAnswerOption. */
export type QualificationSurvey_ChoiceAnswerOptionInput = {
  /** id for QualificationSurvey_ChoiceAnswerOption. */
  id: Scalars['ID'];
  /** text for QualificationSurvey_ChoiceAnswerOption. */
  text: Scalars['String'];
};

/** Model to represent a course recommendation in the terminal section. */
export type QualificationSurvey_CourseRecommendationInput = {
  /** course ID of QualificationSurveyCourseRecommendation */
  courseId: Scalars['ID'];
};

/** Model for new qualificationSurvey to create. */
export type QualificationSurvey_CreateQualificationSurveyInput = {
  /** QualificationSurvey configuration excluding the associated Survey. */
  qualificationSurveyCommon: QualificationSurvey_QualificationSurveyCommonInput;
  /**
   * SectionId to section title map. Will be used to populate the title in Survey.sections
   * Used only if survey is of standard type i.e. phone or 1-click
   */
  sectionIdToSectionTitle?: InputMaybe<Array<QualificationSurvey_SectionIdTitleMapInput>>;
  /** Used only if survey is of non-standard type. */
  survey?: InputMaybe<QualificationSurvey_SurveyInput>;
  /**
   *  A way to categorize surveys, mostly for analytics purposes.
   *  For standard EOI's, the surveyFamilyOverride will be used to lookup a matching
   * [[QualificationSurveyTemplate]] which will be used to create a Survey.
   * For non-standard EOI's, the surveyFamilyOverride will be used to set the surveyFamily in the created Survey.
   */
  surveyFamilyOverride: Scalars['String'];
  /** Used only if survey is of standard type i.e. phone or 1-click. */
  surveyName?: InputMaybe<Scalars['String']>;
};

/** QualificationSurvey response for creating either success of failure */
export type QualificationSurvey_CreateQualificationSurveyResult = QualificationSurvey_CreateSuccess | QualificationSurvey_Failure;

/** Successful mutation that returns the survey created. */
export type QualificationSurvey_CreateSuccess = {
  __typename?: 'QualificationSurvey_CreateSuccess';
  /** qualificationSurveyId of qualification survey created. */
  id: Scalars['ID'];
  /** Model for a Qualification Survey. */
  qualification_survey: QualificationSurvey_QualificationSurveyObject;
};

/** Model for a QualificationSurvey_DropdownContent. */
export type QualificationSurvey_DropdownContent = {
  __typename?: 'QualificationSurvey_DropdownContent';
  /** helpText for a QualificationSurvey_DropdownContent. */
  helpText?: Maybe<Scalars['String']>;
  /** QualificationSurvey_ChoiceAnswerOption for a QualificationSurvey_DropdownContent. */
  options?: Maybe<Array<QualificationSurvey_ChoiceAnswerOption>>;
  /** Text to display before the user has selected an option. */
  placeholder?: Maybe<Scalars['String']>;
  /** prompt for a QualificationSurvey_DropdownContent. */
  prompt: Scalars['String'];
};

/** Model for a QualificationSurvey_DropdownContent. */
export type QualificationSurvey_DropdownContentInput = {
  /** helpText for a QualificationSurvey_DropdownContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** QualificationSurvey_ChoiceAnswerOption for a QualificationSurvey_DropdownContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** Text to display before the user has selected an option. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for a QualificationSurvey_DropdownContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_DynamicChoiceAnswerOptions. */
export type QualificationSurvey_DynamicChoiceAnswerOptions = {
  __typename?: 'QualificationSurvey_DynamicChoiceAnswerOptions';
  /** Human-readable name/description to help understand where the dynamic choices come from (e.g. comes from an API). */
  name: Scalars['String'];
};

/** Model for DynamicQualificationSurvey_ChoiceAnswerOptions. */
export type QualificationSurvey_DynamicChoiceAnswerOptionsInput = {
  /** Human-readable name/description to help understand where the dynamic choices come from (e.g. comes from an API). */
  name: Scalars['String'];
};

/** Model for email address and recipient name. */
export type QualificationSurvey_EmailAddress = {
  __typename?: 'QualificationSurvey_EmailAddress';
  /** Full email address. */
  address: Scalars['String'];
  /** Recipient  name of email address. */
  name: Scalars['String'];
};

/** Model for email address and recipient name. */
export type QualificationSurvey_EmailAddressInput = {
  /** Full email address. */
  address: Scalars['String'];
  /** Recipient  name of email address. */
  name: Scalars['String'];
};

/** QualificationSurvey EmailValidation */
export type QualificationSurvey_EmailValidation = {
  __typename?: 'QualificationSurvey_EmailValidation';
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** QualificationSurvey EmailValidation */
export type QualificationSurvey_EmailValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** QualificationSurvey_Error instance */
export type QualificationSurvey_Error = Error & {
  __typename?: 'QualificationSurvey_Error';
  /** Error message. */
  message: Scalars['String'];
};

/** Failure response containing list of errors */
export type QualificationSurvey_Failure = {
  __typename?: 'QualificationSurvey_Failure';
  /** List of errors */
  errors: Array<QualificationSurvey_Error>;
};

/** Response Model for retrieving a Qualification Survey by productId. */
export type QualificationSurvey_GetQualificationSurveyByProductIdResponse = {
  __typename?: 'QualificationSurvey_GetQualificationSurveyByProductIdResponse';
  /** qualificationSurveyId of qualification survey to be fetched. */
  id: Scalars['ID'];
  /** Model for a Qualification Survey. */
  qualification_survey: QualificationSurvey_QualificationSurveyObject;
};

/** The response containing the id and the retrieved QualificationSurvey. */
export type QualificationSurvey_GetQualificationSurveyResponse = {
  __typename?: 'QualificationSurvey_GetQualificationSurveyResponse';
  /** qualification Survey metadata Id of qualification survey to be fetched. */
  id: Scalars['ID'];
  /** Model for a Qualification Survey. */
  qualificationSurvey: QualificationSurvey_QualificationSurveyObject;
};

/** Model for Leads Configuration. */
export type QualificationSurvey_LeadsConfiguration = QualificationSurvey_ZapierConfiguration;

/**
 * Model for Leads Configuration.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_LeadsConfigurationInput = {
  /** configuration for zapier. */
  zapierConfiguration?: InputMaybe<QualificationSurvey_ZapierConfigurationInput>;
};

/** Model for sending email after survey submission. */
export type QualificationSurvey_MailSpinEmailAction = {
  __typename?: 'QualificationSurvey_MailSpinEmailAction';
  /** Email address for who send confirmation email */
  from?: Maybe<QualificationSurvey_EmailAddress>;
  /** MailSpinTemplateId for survey submission */
  mailSpinTemplateId: Scalars['ID'];
  /** Email address for reply to the survey submission */
  replyTo?: Maybe<QualificationSurvey_EmailAddress>;
};

/** Model for sending email after survey submission. */
export type QualificationSurvey_MailSpinEmailActionInput = {
  /** Email address for who send confirmation email */
  from?: InputMaybe<QualificationSurvey_EmailAddressInput>;
  /** MailSpinTemplateId for survey submission */
  mailSpinTemplateId: Scalars['ID'];
  /** Email address for reply to the survey submission */
  replyTo?: InputMaybe<QualificationSurvey_EmailAddressInput>;
};

/** Model for QualificationSurvey_MultipleChoiceContent. */
export type QualificationSurvey_MultipleChoiceContent = {
  __typename?: 'QualificationSurvey_MultipleChoiceContent';
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_MultipleChoiceContent. */
  options?: Maybe<Array<QualificationSurvey_ChoiceAnswerOption>>;
  /** prompt for QualificationSurvey_MultipleChoiceContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_MultipleChoiceContent. */
export type QualificationSurvey_MultipleChoiceContentInput = {
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_MultipleChoiceContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** prompt for QualificationSurvey_MultipleChoiceContent. */
  prompt: Scalars['String'];
};

/** QualificationSurvey NameValidation */
export type QualificationSurvey_NameValidation = {
  __typename?: 'QualificationSurvey_NameValidation';
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** QualificationSurvey NameValidation */
export type QualificationSurvey_NameValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Model for QualificationSurvey_NumericAnswerOption. */
export type QualificationSurvey_NumericAnswerOption = {
  __typename?: 'QualificationSurvey_NumericAnswerOption';
  /** AnswerOptionId id for QualificationSurvey_NumericAnswerOption. */
  id: Scalars['ID'];
  /** lowerBound for QualificationSurvey_NumericAnswerOption. */
  lowerBound?: Maybe<Scalars['Float']>;
  /** lowerBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  lowerBoundInclusive: Scalars['Boolean'];
  /** upperBound for QualificationSurvey_NumericAnswerOption. */
  upperBound?: Maybe<Scalars['Float']>;
  /** upperBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Model for QualificationSurvey_NumericAnswerOption. */
export type QualificationSurvey_NumericAnswerOptionInput = {
  /** AnswerOptionId id for QualificationSurvey_NumericAnswerOption. */
  id: Scalars['ID'];
  /** lowerBound for QualificationSurvey_NumericAnswerOption. */
  lowerBound?: InputMaybe<Scalars['Float']>;
  /** lowerBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  lowerBoundInclusive?: Scalars['Boolean'];
  /** upperBound for QualificationSurvey_NumericAnswerOption. */
  upperBound?: InputMaybe<Scalars['Float']>;
  /** upperBoundInclusive for QualificationSurvey_NumericAnswerOption. */
  upperBoundInclusive?: Scalars['Boolean'];
};

/** Model for QualificationSurvey_NumericAnswerValidation. */
export type QualificationSurvey_NumericAnswerValidation = QualificationSurvey_NumericRangeValidation;

/** Model for QualificationSurvey_NumericAnswerValidation. */
export type QualificationSurvey_NumericAnswerValidationInput = {
  /** numericRangeValidation. */
  numericRangeValidation?: InputMaybe<QualificationSurvey_NumericRangeValidationInput>;
};

/** Model for QualificationSurvey_NumericContent. */
export type QualificationSurvey_NumericContent = {
  __typename?: 'QualificationSurvey_NumericContent';
  /** QualificationSurvey_NumericAnswerOption list for QualificationSurvey_NumericContent. */
  options?: Maybe<Array<Maybe<QualificationSurvey_NumericAnswerOption>>>;
  /** Text to display when the user has not entered any input. */
  placeholder?: Maybe<Scalars['String']>;
  /** prompt for QualificationSurvey_NumericContent. */
  prompt: Scalars['String'];
  /** QualificationSurvey_NumericAnswerValidation list for QualificationSurvey_NumericContent. */
  validations?: Maybe<Array<QualificationSurvey_NumericAnswerValidation>>;
};

/** Model for QualificationSurvey_NumericContent. */
export type QualificationSurvey_NumericContentInput = {
  /** QualificationSurvey_NumericAnswerOption list for QualificationSurvey_NumericContent. */
  options: Array<QualificationSurvey_NumericAnswerOptionInput>;
  /** Text to display when the user has not entered any input. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_NumericContent. */
  prompt: Scalars['String'];
  /** QualificationSurvey_NumericAnswerValidation list for QualificationSurvey_NumericContent. */
  validations?: InputMaybe<Array<QualificationSurvey_NumericAnswerValidationInput>>;
};

/** Model for NumericRangeValidation. */
export type QualificationSurvey_NumericRangeValidation = {
  __typename?: 'QualificationSurvey_NumericRangeValidation';
  /** lowerBound for NumericRangeValidation. */
  lowerBound?: Maybe<Scalars['Float']>;
  /** lowerBoundInclusive for NumericRangeValidation. */
  lowerBoundInclusive: Scalars['Boolean'];
  /** upperBound for NumericRangeValidation. */
  upperBound?: Maybe<Scalars['Float']>;
  /** upperBoundInclusive for NumericRangeValidation. */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Model for NumericRangeValidation. */
export type QualificationSurvey_NumericRangeValidationInput = {
  /** lowerBound for NumericRangeValidation. */
  lowerBound?: InputMaybe<Scalars['Float']>;
  /** lowerBoundInclusive for NumericRangeValidation. */
  lowerBoundInclusive?: Scalars['Boolean'];
  /** upperBound for NumericRangeValidation. */
  upperBound?: InputMaybe<Scalars['Float']>;
  /** upperBoundInclusive for NumericRangeValidation. */
  upperBoundInclusive?: Scalars['Boolean'];
};

/** QualificationSurvey PhoneValidation */
export type QualificationSurvey_PhoneValidation = {
  __typename?: 'QualificationSurvey_PhoneValidation';
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** QualificationSurvey PhoneValidation */
export type QualificationSurvey_PhoneValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Paginated list of QualificationSurveys of the same ProductId */
export type QualificationSurvey_QualificationSurveyByProductIdPaginatedResult = {
  __typename?: 'QualificationSurvey_QualificationSurveyByProductIdPaginatedResult';
  /** List of elements in the page */
  elements: Array<QualificationSurvey_GetQualificationSurveyByProductIdResponse>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** QualificationSurvey configuration excluding the associated Survey. */
export type QualificationSurvey_QualificationSurveyCommon = {
  __typename?: 'QualificationSurvey_QualificationSurveyCommon';
  /** archived of qualification survey. */
  archived: Scalars['Boolean'];
  /** consentMessage of qualification survey. */
  consentMessage?: Maybe<CmlContent>;
  /** leadsConfiguration of qualification survey. */
  leadsConfiguration?: Maybe<QualificationSurvey_LeadsConfiguration>;
  /** product Id of qualification survey. */
  productId: Scalars['ID'];
  /** TerminalActionListMapping of qualification survey. */
  terminalActions?: Maybe<Array<QualificationSurvey_TerminalActionListMapping>>;
  /** TerminalSectionMapping of qualification survey. */
  terminalSections?: Maybe<Array<QualificationSurvey_TerminalSectionMapping>>;
};

/** QualificationSurvey configuration excluding the associated Survey. */
export type QualificationSurvey_QualificationSurveyCommonInput = {
  /** archived of qualification survey. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** consentMessage of qualification survey. */
  consentMessage?: InputMaybe<CmlContentInput>;
  /** leadsConfiguration of qualification survey. */
  leadsConfiguration?: InputMaybe<QualificationSurvey_LeadsConfigurationInput>;
  /** product Id of qualification survey. */
  productId: Scalars['ID'];
  /** TerminalActionListMapping of qualification survey. */
  terminalActions: Array<QualificationSurvey_TerminalActionListMappingInput>;
  /** TerminalSectionMapping of qualification survey. */
  terminalSections: Array<QualificationSurvey_TerminalSectionMappingInput>;
};

/** Model for a Qualification Survey. */
export type QualificationSurvey_QualificationSurveyObject = {
  __typename?: 'QualificationSurvey_QualificationSurveyObject';
  /** QualificationSurvey configuration excluding the associated Survey. */
  qualificationSurveyCommon: QualificationSurvey_QualificationSurveyCommon;
  /** Associated Survey for qualificationSurvey. */
  survey: QualificationSurvey_Survey;
};

/** Model for a Qualification Survey Input. */
export type QualificationSurvey_QualificationSurveyObjectInput = {
  /** QualificationSurvey configuration excluding the associated Survey. */
  qualification_survey_common: QualificationSurvey_QualificationSurveyCommonInput;
  /** Associated Survey for qualificationSurvey. */
  survey: QualificationSurvey_SurveyInput;
};

/** Model for a QualificationSurvey_QuestionContent. */
export type QualificationSurvey_QuestionContent = QualificationSurvey_CheckboxContent | QualificationSurvey_DropdownContent | QualificationSurvey_MultipleChoiceContent | QualificationSurvey_NumericContent | QualificationSurvey_ShortAnswerContent | QualificationSurvey_TypeaheadContent;

/** Model for a QualificationSurvey_QuestionContent. */
export type QualificationSurvey_QuestionContentInput = {
  /** checkboxContent */
  checkboxContent?: InputMaybe<QualificationSurvey_CheckboxContentInput>;
  /** dropdownContent */
  dropdownContent?: InputMaybe<QualificationSurvey_DropdownContentInput>;
  /** multipleChoiceContent */
  multipleChoiceContent?: InputMaybe<QualificationSurvey_MultipleChoiceContentInput>;
  /** numericContent */
  numericContent?: InputMaybe<QualificationSurvey_NumericContentInput>;
  /** shortAnswerContent */
  shortAnswerContent?: InputMaybe<QualificationSurvey_ShortAnswerContentInput>;
  /** typeaheadContent */
  typeaheadContent?: InputMaybe<QualificationSurvey_TypeaheadContentInput>;
};

/** Model for a QuestionGroup. */
export type QualificationSurvey_QuestionGroup = QualificationSurvey_SelectKQuestionGroup | QualificationSurvey_SingleQuestionGroup;

/** Model for a QuestionGroup. */
export type QualificationSurvey_QuestionGroupInput = {
  /** selectKQuestionGroup */
  selectKQuestionGroup?: InputMaybe<QualificationSurvey_SelectKQuestionGroupInput>;
  /** singleQuestionGroup */
  singleQuestionGroup?: InputMaybe<QualificationSurvey_SingleQuestionGroupInput>;
};

/** Model for QualificationSurveyQuestionSection */
export type QualificationSurvey_QuestionSection = {
  __typename?: 'QualificationSurvey_QuestionSection';
  /** CmlContent body of QualificationSurvey_QuestionSection. */
  consentMessage?: Maybe<CmlContent>;
  /** Section descriptions. */
  description?: Maybe<Scalars['String']>;
  /** nextMessage */
  nextMessage?: Maybe<Scalars['String']>;
  /** Questions for QualificationSurveySectionResponse */
  questions?: Maybe<Array<QualificationSurveySectionResponse_SurveyQuestion>>;
  /** section title. */
  title: Scalars['String'];
};

/** Model for QuestionSectionDefinition. */
export type QualificationSurvey_QuestionSectionDefinition = {
  __typename?: 'QualificationSurvey_QuestionSectionDefinition';
  /** DefaultDestination for QuestionSectionDefinition. */
  defaultDestination: Scalars['String'];
  /** NextMessage for QuestionSectionDefinition. */
  nextMessage?: Maybe<Scalars['String']>;
  /** Question Groups for QuestionSectionDefinition. */
  questionGroups?: Maybe<Array<QualificationSurvey_QuestionGroup>>;
  /** transitions for QuestionSectionDefinition. */
  transitions?: Maybe<Array<QualificationSurvey_Transition>>;
};

/** Model for QuestionSectionDefinition. */
export type QualificationSurvey_QuestionSectionDefinitionInput = {
  /** DefaultDestination for QuestionSectionDefinition. */
  defaultDestination: Scalars['String'];
  /** NextMessage for QuestionSectionDefinition. */
  nextMessage?: InputMaybe<Scalars['String']>;
  /** Question Groups for QuestionSectionDefinition. */
  questionGroups: Array<QualificationSurvey_QuestionGroupInput>;
  /** transitions for QuestionSectionDefinition. */
  transitions: Array<QualificationSurvey_TransitionInput>;
};

/** Model for a RandomTransition. */
export type QualificationSurvey_RandomTransition = {
  __typename?: 'QualificationSurvey_RandomTransition';
  /** List of possible Destinations for RandomTransition. */
  possibleDestinations?: Maybe<Array<Scalars['String']>>;
};

/** Model for a RandomTransition. */
export type QualificationSurvey_RandomTransitionInput = {
  /** List of possible Destinations for RandomTransition. */
  possibleDestinations: Array<Scalars['String']>;
};

/** Model to represent a recommendation in the terminal section. */
export type QualificationSurvey_Recommendation = Course_Course | Specialization_Specialization;

/**
 * Model to represent a recommendation in the terminal section.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_RecommendationInput = {
  /** represent a s12n recommendation in the terminal section. */
  QualificationSurveyS12nRecommendation?: InputMaybe<QualificationSurvey_S12nRecommendationInput>;
  /** represent a course recommendation in the terminal section. */
  qualificationSurveyCourseRecommendation?: InputMaybe<QualificationSurvey_CourseRecommendationInput>;
};

/** Model to represent a s12n recommendation in the terminal section. */
export type QualificationSurvey_S12nRecommendationInput = {
  /** S12nId id of QualificationSurveyS12nRecommendation. */
  S12nId: Scalars['ID'];
};

/** type for SectionDefinition */
export type QualificationSurvey_SectionDefinition = QualificationSurvey_QuestionSectionDefinition | QualificationSurvey_TerminalDefinition;

/** type for SectionDefinition */
export type QualificationSurvey_SectionDefinitionInput = {
  /** questionSectionDefinition. */
  questionSectionDefinition?: InputMaybe<QualificationSurvey_QuestionSectionDefinitionInput>;
  /** terminal Definition. */
  terminalDefinition?: InputMaybe<QualificationSurvey_TerminalDefinitionInput>;
};

/** Model for QualificationSurvey_SectionIdTitleMapInput */
export type QualificationSurvey_SectionIdTitleMapInput = {
  /** SectionId of Survey section title */
  sectionId: Scalars['ID'];
  /** title used in Survey.sections if survey is of standard type i.e. phone or 1-click */
  value: Scalars['String'];
};

/** Model for selecting multiple QuestionGroups. */
export type QualificationSurvey_SelectKQuestionGroup = {
  __typename?: 'QualificationSurvey_SelectKQuestionGroup';
  /** numberOfQuestionsToShow for selecting multiple QuestionGroups. */
  numberOfQuestionsToShow: Scalars['Int'];
  /** QuestionId list for selecting multiple QuestionGroups. */
  questionIds?: Maybe<Array<Scalars['ID']>>;
};

/** Model for selecting multiple QuestionGroups. */
export type QualificationSurvey_SelectKQuestionGroupInput = {
  /** numberOfQuestionsToShow for selecting multiple QuestionGroups. */
  numberOfQuestionsToShow: Scalars['Int'];
  /** QuestionId list for selecting multiple QuestionGroups. */
  questionIds: Array<Scalars['ID']>;
};

/** Model for QualificationSurvey_ShortAnswerAnswerOption. */
export type QualificationSurvey_ShortAnswerAnswerOption = {
  __typename?: 'QualificationSurvey_ShortAnswerAnswerOption';
  /** Answer for QualificationSurvey_ShortAnswerAnswerOption. */
  answer: Scalars['String'];
  /** id for QualificationSurvey_ShortAnswerAnswerOption. */
  id: Scalars['ID'];
};

/** Model for QualificationSurvey_ShortAnswerAnswerOption. */
export type QualificationSurvey_ShortAnswerAnswerOptionInput = {
  /** Answer for QualificationSurvey_ShortAnswerAnswerOption. */
  answer: Scalars['String'];
  /** id for QualificationSurvey_ShortAnswerAnswerOption. */
  id: Scalars['ID'];
};

/** Model for ShotAnswerContent. */
export type QualificationSurvey_ShortAnswerContent = {
  __typename?: 'QualificationSurvey_ShortAnswerContent';
  /** Matching conditions for associating an option id with a response. */
  options?: Maybe<Array<Maybe<QualificationSurvey_ShortAnswerAnswerOption>>>;
  /** Text to display when the user has not entered any input. */
  placeholder?: Maybe<Scalars['String']>;
  /** prompt for ShotAnswerContent. */
  prompt: Scalars['String'];
  /** validations need to be done for QualificationSurvey_ShortAnswerContent. */
  validations?: Maybe<Array<QualificationSurvey_ShortAnswerValidation>>;
};

/** Model for ShotAnswerContent. */
export type QualificationSurvey_ShortAnswerContentInput = {
  /** Matching conditions for associating an option id with a response. */
  options: Array<QualificationSurvey_ShortAnswerAnswerOptionInput>;
  /** Text to display when the user has not entered any input. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for ShotAnswerContent. */
  prompt: Scalars['String'];
  /** validations need to be done for QualificationSurvey_ShortAnswerContent. */
  validations?: InputMaybe<Array<QualificationSurvey_ShortAnswerValidationInput>>;
};

/** Model for QualificationSurvey_ShortAnswerValidation. */
export type QualificationSurvey_ShortAnswerValidation = QualificationSurvey_EmailValidation | QualificationSurvey_NameValidation | QualificationSurvey_PhoneValidation | QualificationSurvey_TextLengthValidation | QualificationSurvey_UrlValidation;

/** Model for QualificationSurvey_ShortAnswerValidation. */
export type QualificationSurvey_ShortAnswerValidationInput = {
  /** emailValidation. */
  emailValidation?: InputMaybe<QualificationSurvey_EmailValidationInput>;
  /** nameValidation. */
  nameValidation?: InputMaybe<QualificationSurvey_NameValidationInput>;
  /** phoneValidation. */
  phoneValidation?: InputMaybe<QualificationSurvey_PhoneValidationInput>;
  /** textLengthValidation. */
  textLengthValidation?: InputMaybe<QualificationSurvey_TextLengthValidationInput>;
  /** urlValidation. */
  urlValidation?: InputMaybe<QualificationSurvey_UrlValidationInput>;
};

/** Model for a SingleQuestionGroup. */
export type QualificationSurvey_SingleQuestionGroup = {
  __typename?: 'QualificationSurvey_SingleQuestionGroup';
  /** QuestionId for a SingleQuestionGroup. */
  questionId: Scalars['ID'];
};

/** Model for a SingleQuestionGroup. */
export type QualificationSurvey_SingleQuestionGroupInput = {
  /** QuestionId for a SingleQuestionGroup. */
  questionId: Scalars['ID'];
};

/** Model for associate Survey for Qualification Survey. */
export type QualificationSurvey_Survey = {
  __typename?: 'QualificationSurvey_Survey';
  /** all for Survey. */
  all: Scalars['String'];
  /** allowSectionResponseEdits for Survey. */
  allowSectionResponseEdits: Scalars['Boolean'];
  /** createdAt for Survey. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** maxResponses for Survey. */
  maxResponses?: Maybe<Scalars['Int']>;
  /** name for Survey. */
  name?: Maybe<Scalars['String']>;
  /** questions for Survey. */
  questions?: Maybe<Array<QualificationSurvey_SurveyQuestion>>;
  /** restartFromSavedResponses for Survey. */
  restartFromSavedResponses: Scalars['Boolean'];
  /** Section Maps for Survey. */
  sections?: Maybe<Array<QualificationSurvey_SurveySectionMapping>>;
  /** Section id for Survey start. */
  startSection: Scalars['String'];
  /** surveyFamily for Survey. */
  surveyFamily?: Maybe<Scalars['String']>;
};

/** Model for associate Survey for Qualification Survey. */
export type QualificationSurvey_SurveyInput = {
  /** all for Survey. */
  all?: Scalars['String'];
  /** allowSectionResponseEdits for Survey. */
  allowSectionResponseEdits?: Scalars['Boolean'];
  /** createdAt for Survey. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** maxResponses for Survey. */
  maxResponses?: InputMaybe<Scalars['Int']>;
  /** name for Survey. */
  name?: InputMaybe<Scalars['String']>;
  /** questions for Survey. */
  questions: Array<QualificationSurvey_SurveyQuestionInput>;
  /** restartFromSavedResponses for Survey. */
  restartFromSavedResponses?: Scalars['Boolean'];
  /** Section Maps for Survey. */
  sections: Array<QualificationSurvey_SurveySectionMappingInput>;
  /** Section id for Survey start. */
  startSection: Scalars['String'];
  /** surveyFamily for Survey. */
  surveyFamily?: InputMaybe<Scalars['String']>;
};

/** Model for a QualificationSurvey_SurveyQuestion. */
export type QualificationSurvey_SurveyQuestion = {
  __typename?: 'QualificationSurvey_SurveyQuestion';
  /** Map for question configuration. */
  configurations?: Maybe<Array<QualificationSurvey_SurveyQuestionConfiguration>>;
  /** Question Contents for survey question. */
  content: QualificationSurvey_QuestionContent;
  /** QuestionId for survey question. */
  id: Scalars['ID'];
  /** Set this question is required or not. */
  isRequired: Scalars['Boolean'];
};

/** Model for QualificationSurvey_SurveyQuestion configurations. */
export type QualificationSurvey_SurveyQuestionConfiguration = {
  __typename?: 'QualificationSurvey_SurveyQuestionConfiguration';
  /** QualificationSurvey_SurveyQuestionConfiguration Map key. */
  surveyQuestionConfigurationKey?: Maybe<Scalars['String']>;
  /** QualificationSurvey_SurveyQuestionConfiguration Map value. */
  surveyQuestionConfigurationValue?: Maybe<Scalars['String']>;
};

/** Model for QualificationSurvey_SurveyQuestion configurations. */
export type QualificationSurvey_SurveyQuestionConfigurationInput = {
  /** QualificationSurvey_SurveyQuestionConfiguration Map key. */
  surveyQuestionConfigurationKey?: InputMaybe<Scalars['String']>;
  /** QualificationSurvey_SurveyQuestionConfiguration Map value. */
  surveyQuestionConfigurationValue?: InputMaybe<Scalars['String']>;
};

/** Model for a QualificationSurvey_SurveyQuestion. */
export type QualificationSurvey_SurveyQuestionInput = {
  /** Map for question configuration. */
  configurations?: InputMaybe<Array<QualificationSurvey_SurveyQuestionConfigurationInput>>;
  /** Question Contents for survey question. */
  content: QualificationSurvey_QuestionContentInput;
  /** QuestionId for survey question. */
  id: Scalars['ID'];
  /** Set this question is required or not. */
  isRequired: Scalars['Boolean'];
};

/** Model for survey section. */
export type QualificationSurvey_SurveySection = {
  __typename?: 'QualificationSurvey_SurveySection';
  /** section Definition. */
  definition: QualificationSurvey_SectionDefinition;
  /** Section descriptions. */
  description?: Maybe<Scalars['String']>;
  /** section title. */
  title: Scalars['String'];
};

/** Model for survey section. */
export type QualificationSurvey_SurveySectionInput = {
  /** section Definition. */
  definition: QualificationSurvey_SectionDefinitionInput;
  /** Section descriptions. */
  description?: InputMaybe<Scalars['String']>;
  /** section title. */
  title: Scalars['String'];
};

/** Model for survey Section Map. */
export type QualificationSurvey_SurveySectionMapping = {
  __typename?: 'QualificationSurvey_SurveySectionMapping';
  /** value for survey Section Map. */
  section: QualificationSurvey_SurveySection;
  /** Key for for survey Section Map. */
  sectionKey: Scalars['String'];
};

/** Model for survey Section Map. */
export type QualificationSurvey_SurveySectionMappingInput = {
  /** value for survey Section Map. */
  section: QualificationSurvey_SurveySectionInput;
  /** Key for for survey Section Map. */
  sectionKey: Scalars['String'];
};

/** Actions after survey submission. */
export type QualificationSurvey_TerminalAction = QualificationSurvey_MailSpinEmailAction;

/**
 * Actions after survey submission.
 * GraphQL does not support unions for inputs. We are using a direction @oneOf which enforces
 * only one of the fields in the input can be non-null.
 */
export type QualificationSurvey_TerminalActionInput = {
  /** mailSpinEmailAction for survey terminalAction. */
  mailSpinEmailAction?: InputMaybe<QualificationSurvey_MailSpinEmailActionInput>;
};

/** action lists after survey submission. */
export type QualificationSurvey_TerminalActionList = {
  __typename?: 'QualificationSurvey_TerminalActionList';
  /** List of actions for survey submission. */
  actions?: Maybe<Array<QualificationSurvey_TerminalAction>>;
};

/** action lists after survey submission. */
export type QualificationSurvey_TerminalActionListInput = {
  /** List of actions for survey submission. */
  actions: Array<QualificationSurvey_TerminalActionInput>;
};

/** TerminalActionListMapping after survey submission. */
export type QualificationSurvey_TerminalActionListMapping = {
  __typename?: 'QualificationSurvey_TerminalActionListMapping';
  /** value of TerminalActionListMapping after survey submission. */
  terminalActionList: QualificationSurvey_TerminalActionList;
  /** key of TerminalActionListMapping after survey submission. */
  terminalActionListKey: Scalars['String'];
};

/** TerminalActionListMapping after survey submission. */
export type QualificationSurvey_TerminalActionListMappingInput = {
  /** value of TerminalActionListMapping after survey submission. */
  terminalActionList: QualificationSurvey_TerminalActionListInput;
  /** key of TerminalActionListMapping after survey submission. */
  terminalActionListKey: Scalars['String'];
};

/** Model for QualificationSurvey_TerminalDefinition. */
export type QualificationSurvey_TerminalDefinition = {
  __typename?: 'QualificationSurvey_TerminalDefinition';
  /** Dummy field whose value is unused. GraphQL requires input to have at least one field. */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** Model for QualificationSurvey_TerminalDefinition. */
export type QualificationSurvey_TerminalDefinitionInput = {
  /** Dummy field whose value is unused. GraphQL requires input to have at least one field. */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Model to represent message at end of survey. */
export type QualificationSurvey_TerminalSection = {
  __typename?: 'QualificationSurvey_TerminalSection';
  /** applyLink of QualificationSurveyTerminalSection. */
  applyLink?: Maybe<Scalars['String']>;
  /** CmlContent body of QualificationSurvey_TerminalSection. */
  body: CmlContent;
  /** brochureLink of QualificationSurveyTerminalSection. */
  brochureLink?: Maybe<Scalars['String']>;
  /** inviteToGroup of QualificationSurveyTerminalSection. */
  inviteToGroup: Scalars['Boolean'];
  /** QualificationSurveyRecommendation of QualificationSurveyTerminalSection. */
  recommendations?: Maybe<Array<QualificationSurvey_Recommendation>>;
  /** title of QualificationSurvey_TerminalSection. */
  title: Scalars['String'];
};

/** Model to represent message at end of survey. */
export type QualificationSurvey_TerminalSectionInput = {
  /** applyLink of QualificationSurveyTerminalSection. */
  applyLink?: InputMaybe<Scalars['String']>;
  /** CmlContent body of QualificationSurvey_TerminalSection. */
  body: CmlContentInput;
  /** brochureLink of QualificationSurveyTerminalSection. */
  brochureLink?: InputMaybe<Scalars['String']>;
  /** inviteToGroup of QualificationSurveyTerminalSection. */
  inviteToGroup?: InputMaybe<Scalars['Boolean']>;
  /** QualificationSurveyRecommendation of QualificationSurveyTerminalSection. */
  recommendations?: InputMaybe<Array<QualificationSurvey_RecommendationInput>>;
  /** title of QualificationSurvey_TerminalSection. */
  title: Scalars['String'];
};

/** TerminalSectionMapping of qualification survey. */
export type QualificationSurvey_TerminalSectionMapping = {
  __typename?: 'QualificationSurvey_TerminalSectionMapping';
  /** terminalSection of TerminalSectionMapping */
  terminalSection: QualificationSurvey_TerminalSection;
  /** key of TerminalSectionMapping */
  terminalSectionKey: Scalars['String'];
};

/** TerminalSectionMapping of qualification survey. */
export type QualificationSurvey_TerminalSectionMappingInput = {
  /** terminalSection of TerminalSectionMapping */
  terminalSection: QualificationSurvey_TerminalSectionInput;
  /** key of TerminalSectionMapping */
  terminalSectionKey: Scalars['String'];
};

/** For text length validation. */
export type QualificationSurvey_TextLengthValidation = {
  __typename?: 'QualificationSurvey_TextLengthValidation';
  /** text length validation for lower-bound. */
  lowerBound?: Maybe<Scalars['Int']>;
  /** text length validation for upper bound. */
  upperBound?: Maybe<Scalars['Int']>;
};

/** For text length validation. */
export type QualificationSurvey_TextLengthValidationInput = {
  /** text length validation for lower-bound. */
  lowerBound?: InputMaybe<Scalars['Int']>;
  /** text length validation for upper bound. */
  upperBound?: InputMaybe<Scalars['Int']>;
};

/** Model for QualificationSurvey Transition */
export type QualificationSurvey_Transition = QualificationSurvey_AllConditionsValidTransition | QualificationSurvey_AnyConditionsValidTransition | QualificationSurvey_RandomTransition;

/** Model for a TransitionCondition. */
export type QualificationSurvey_TransitionCondition = {
  __typename?: 'QualificationSurvey_TransitionCondition';
  /** answerOptionId for a TransitionCondition. */
  answerOptionId: Scalars['ID'];
  /** questionId for a TransitionCondition. */
  questionId: Scalars['ID'];
};

/** Model for a TransitionCondition. */
export type QualificationSurvey_TransitionConditionInput = {
  /** answerOptionId for a TransitionCondition. */
  answerOptionId: Scalars['ID'];
  /** questionId for a TransitionCondition. */
  questionId: Scalars['ID'];
};

/** Model for QualificationSurvey Transition */
export type QualificationSurvey_TransitionInput = {
  /** allConditionsValidTransition */
  allConditionsValidTransition?: InputMaybe<QualificationSurvey_AllConditionsValidTransitionInput>;
  /** anyConditionsValidTransition */
  anyConditionsValidTransition?: InputMaybe<QualificationSurvey_AnyConditionsValidTransitionInput>;
  /** randomTransition */
  randomTransition?: InputMaybe<QualificationSurvey_RandomTransitionInput>;
};

/** Model for QualificationSurvey_TypeaheadContent. */
export type QualificationSurvey_TypeaheadContent = {
  __typename?: 'QualificationSurvey_TypeaheadContent';
  /**
   * If this question content is configured with dynamic options, then options can be fetched
   * from some other source before being displayed to the user, instead of from the `options` field.
   * This field is optional.
   */
  dynamicOptions?: Maybe<QualificationSurvey_DynamicChoiceAnswerOptions>;
  /** helpText for QualificationSurvey_TypeaheadContent. */
  helpText?: Maybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_TypeaheadContent. */
  includeOther?: Maybe<Scalars['Boolean']>;
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_TypeaheadContent. */
  options?: Maybe<Array<QualificationSurvey_ChoiceAnswerOption>>;
  /** Text to display before the user has selected an option. */
  placeholder?: Maybe<Scalars['String']>;
  /** prompt for QualificationSurvey_TypeaheadContent. */
  prompt: Scalars['String'];
};

/** Model for QualificationSurvey_TypeaheadContent. */
export type QualificationSurvey_TypeaheadContentInput = {
  /**
   * If this question content is configured with dynamic options, then options can be fetched
   * from some other source before being displayed to the user, instead of from the `options` field.
   * This field is optional.
   */
  dynamicOptions?: InputMaybe<QualificationSurvey_DynamicChoiceAnswerOptionsInput>;
  /** helpText for QualificationSurvey_TypeaheadContent. */
  helpText?: InputMaybe<Scalars['String']>;
  /** includeOther for QualificationSurvey_TypeaheadContent. */
  includeOther?: Scalars['Boolean'];
  /** QualificationSurvey_ChoiceAnswerOption list for QualificationSurvey_TypeaheadContent. */
  options?: InputMaybe<Array<QualificationSurvey_ChoiceAnswerOptionInput>>;
  /** Text to display before the user has selected an option. */
  placeholder?: InputMaybe<Scalars['String']>;
  /** prompt for QualificationSurvey_TypeaheadContent. */
  prompt: Scalars['String'];
};

/** new qualificationSurvey to update. */
export type QualificationSurvey_UpdateQualificationSurveyInput = {
  /** qualificationSurveyId of this updated survey. */
  qualificationSurveyId: Scalars['ID'];
  /** body of update qualification survey. */
  qualification_survey: QualificationSurvey_QualificationSurveyObjectInput;
};

/** QualificationSurvey response for updating either success of failure */
export type QualificationSurvey_UpdateQualificationSurveyResult = QualificationSurvey_Failure | QualificationSurvey_VoidSuccess;

/** QualificationSurvey UrlValidation */
export type QualificationSurvey_UrlValidation = {
  __typename?: 'QualificationSurvey_UrlValidation';
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: Maybe<Scalars['Boolean']>;
};

/** QualificationSurvey UrlValidation */
export type QualificationSurvey_UrlValidationInput = {
  /** Dummy field. GraphQL types must include at least one field */
  dummy?: InputMaybe<Scalars['Boolean']>;
};

/** Successful mutation that returns empty response payload */
export type QualificationSurvey_VoidSuccess = {
  __typename?: 'QualificationSurvey_VoidSuccess';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** Model for Zapier Configuration. */
export type QualificationSurvey_ZapierConfiguration = {
  __typename?: 'QualificationSurvey_ZapierConfiguration';
  /** webhookUrl for Zapier configuration */
  webhookUrl: Scalars['URL'];
};

/** Model for Zapier Configuration. */
export type QualificationSurvey_ZapierConfigurationInput = {
  /** webhookUrl for Zapier configuration */
  webhookUrl: Scalars['URL'];
};

/** Indicates that atom is a draft (no version) */
export type QualityCoach_AtomDraft = {
  __typename?: 'QualityCoach_AtomDraft';
  /** Dummy field. GraphQL types must include at least one field */
  _?: Maybe<Scalars['Boolean']>;
};

/** A reference to a specific version or draft of an atom. */
export type QualityCoach_AtomReference = QualityCoach_TypedReviewableEntityReference & {
  __typename?: 'QualityCoach_AtomReference';
  /** The atom ID. */
  atomId: Scalars['ID'];
  /** The atom type. */
  atomType: QualityCoach_AtomType;
  /**
   * Whether this entity is a draft or a published version. Drafts of atoms are not connected to a
   * version.
   */
  atomVersion: QualityCoach_AtomStatusOrVersion;
  /** The atom ID. */
  entityReferenceId: Scalars['ID'];
  /** The type of the entity. */
  entityType: QualityCoach_ReviewableEntityReferenceType;
};

/** An input reference to an atom. */
export type QualityCoach_AtomReferenceInput = {
  /** The atom ID. */
  atomId: Scalars['ID'];
  /** The atom type. */
  atomType: QualityCoach_AtomType;
  /**
   * Whether this entity is a draft or a published version. Drafts of atoms are not connected to a
   * version.
   */
  atomVersion: QualityCoach_AtomStatusOrVersionInput;
};

/** Placeholder to indicate that the atom is a draft */
export const QualityCoach_AtomStatus = {
  /** Get atom draft */
  Draft: 'DRAFT',
  /** Get latest published atom */
  LatestPublished: 'LATEST_PUBLISHED'
} as const;

export type QualityCoach_AtomStatus = typeof QualityCoach_AtomStatus[keyof typeof QualityCoach_AtomStatus];
/** Status of an atom, it should either have a version or be a draft (never both) */
export type QualityCoach_AtomStatusOrVersion = QualityCoach_AtomDraft | QualityCoach_AtomVersion;

/** Status of an atom, it should either have a version or be a draft (never both) */
export type QualityCoach_AtomStatusOrVersionInput = {
  /** Get the atom by status (draft or latest published) */
  status?: InputMaybe<QualityCoach_AtomStatus>;
  /** Indicates that the atom is published and provides the version of the published atom */
  version?: InputMaybe<Scalars['Int']>;
};

/** Types of atoms that can be reviewed for adherence to best practices by the quality coach system. */
export const QualityCoach_AtomType = {
  /** A reading item. */
  ReadingItem: 'READING_ITEM'
} as const;

export type QualityCoach_AtomType = typeof QualityCoach_AtomType[keyof typeof QualityCoach_AtomType];
/** Version of an atom, wrapped to support union type above */
export type QualityCoach_AtomVersion = {
  __typename?: 'QualityCoach_AtomVersion';
  /** Atom version */
  version: Scalars['Int'];
};

/** A reference to a course branch that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseBranchReference = QualityCoach_TypedReviewableEntityReference & {
  __typename?: 'QualityCoach_CourseBranchReference';
  /** The id of the branch. */
  authoringBranchId: Scalars['ID'];
  /** The course ID. */
  entityReferenceId: Scalars['ID'];
  /** The type of the entity. */
  entityType: QualityCoach_ReviewableEntityReferenceType;
};

/** A reference to a course branch that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseBranchReferenceInput = {
  /** The id of the branch. */
  authoringBranchId: Scalars['ID'];
};

/** A reference to a course that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseReference = QualityCoach_TypedReviewableEntityReference & {
  __typename?: 'QualityCoach_CourseReference';
  /** The course. */
  course: Course_Course;
  /** The course ID. */
  entityReferenceId: Scalars['ID'];
  /** The type of the entity. */
  entityType: QualityCoach_ReviewableEntityReferenceType;
};

/** A reference to a course that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_CourseReferenceInput = {
  /** The id of the course. */
  courseId: Scalars['ID'];
};

/** Input to create a new quality rule. */
export type QualityCoach_CreateQualityRuleInput = {
  /** LLM configuration instructs the LLM system on how to evaluate the rule. */
  llmConfiguration?: InputMaybe<QualityCoach_RuleLlmConfigurationInput>;
  /** Rerun configuration instructs the orchestration system on when to rerun the rule. */
  rerunConfiguration: Array<QualityCoach_RuleRerunConfigurationType>;
  /** Descriptions of the rule in a human- and LLM-readable format. */
  ruleDescription: QualityCoach_RuleDescriptionInput;
  /** Filters define the conditions under which the rule is applicable. */
  ruleFilters: Array<QualityCoach_RuleFilterInput>;
  /** The weight of the rule in the overall score. */
  weight: Scalars['Float'];
};

/** Result of creating a new quality rule. */
export type QualityCoach_CreateQualityRuleResult = {
  __typename?: 'QualityCoach_CreateQualityRuleResult';
  /** The rule that was created */
  qualityRule: QualityCoach_QualityRule;
};

/** Input to delete an existing quality rule. */
export type QualityCoach_DeleteQualityRuleInput = {
  /** The id of the rule. */
  id: Scalars['ID'];
};

/** Result of deleting an existing quality rule. */
export type QualityCoach_DeleteQualityRuleResult = {
  __typename?: 'QualityCoach_DeleteQualityRuleResult';
  /** Whether the rule was deleted successfully. */
  success: Scalars['Boolean'];
};

/** Errors occurred when initiating a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntityErrors = {
  __typename?: 'QualityCoach_InitiateQualityReviewForEntityErrors';
  /** Error message */
  message: Scalars['String'];
};

/** Failure for initiating a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntityFailure = {
  __typename?: 'QualityCoach_InitiateQualityReviewForEntityFailure';
  /** List of errors */
  errors: Array<QualityCoach_InitiateQualityReviewForEntityErrors>;
};

/** Input to initiate a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntityInput = {
  /** If true, the quality review will be created even if there is an existing and still valid quality review. */
  forceNewQualityReview?: InputMaybe<Scalars['Boolean']>;
  /** The reviewable entity to review. */
  reviewableEntity: QualityCoach_ReviewableEntityReferenceInput;
};

/** Result of initiating a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntityResult = QualityCoach_InitiateQualityReviewForEntityFailure | QualityCoach_InitiateQualityReviewForEntitySuccess;

/** Success of initiating a new quality review for an entity. */
export type QualityCoach_InitiateQualityReviewForEntitySuccess = {
  __typename?: 'QualityCoach_InitiateQualityReviewForEntitySuccess';
  /**
   * Populated if an existing and still valid quality review was found.
   * In that case, no new quality review was created.
   */
  existingQualityReview?: Maybe<QualityCoach_QualityReview>;
  /** The ID of the quality review that was initiated. */
  id: Scalars['ID'];
};

/** Instruct the LLM on how to output the results of the rule, whether single result or issue list. */
export const QualityCoach_IssueOutputStyleType = {
  /** The LLM should output a review result with a list of issues for the rule. */
  IssueList: 'ISSUE_LIST',
  /** The LLM should output a single review result with an empty issue list for the rule. */
  SingleResult: 'SINGLE_RESULT'
} as const;

export type QualityCoach_IssueOutputStyleType = typeof QualityCoach_IssueOutputStyleType[keyof typeof QualityCoach_IssueOutputStyleType];
/** Instruct the LLM on how to output the results of the rule. */
export const QualityCoach_LlmOutputStyleType = {
  /** The LLM should output a plain text recommendation to address the rule violation. */
  PlainText: 'PLAIN_TEXT'
} as const;

export type QualityCoach_LlmOutputStyleType = typeof QualityCoach_LlmOutputStyleType[keyof typeof QualityCoach_LlmOutputStyleType];
/** A result of running all relevant rules on an entity. */
export type QualityCoach_QualityReview = {
  __typename?: 'QualityCoach_QualityReview';
  /** A paginated list of all the quality reviews of this entity's child entities. */
  childQualityReviews?: Maybe<QualityCoach_QualityReviewPaginatedResult>;
  /** The time the quality review was initiated. */
  createdAt: Scalars['DateTime'];
  /** The id of the quality review. */
  id: Scalars['ID'];
  /** How the quality review was initiated. */
  qualityReviewInitiationType: QualityCoach_QualityReviewInitiationType;
  /** The status of the quality review. */
  qualityReviewStatus: QualityCoach_QualityReviewStatus;
  /** A paginated list of results of evaluating the entity against rules. */
  reviewResults?: Maybe<QualityCoach_QualityRuleResultPaginatedResult>;
  /** The entity being reviewed. */
  reviewableEntity: QualityCoach_ReviewableEntityReference;
  /**
   * The overall score of the entity for this quality review (nullable for when the review is still in
   * progress).
   */
  score?: Maybe<QualityCoach_Score>;
  /** The time the quality review was last updated. */
  updatedAt: Scalars['DateTime'];
};


/** A result of running all relevant rules on an entity. */
export type QualityCoach_QualityReviewChildQualityReviewsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** A result of running all relevant rules on an entity. */
export type QualityCoach_QualityReviewReviewResultsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** How the quality review was initiated. */
export const QualityCoach_QualityReviewInitiationType = {
  /** The quality review was initiated manually. */
  Manual: 'MANUAL',
  /** The quality review was initiated on entity change. */
  OnEntityChange: 'ON_ENTITY_CHANGE'
} as const;

export type QualityCoach_QualityReviewInitiationType = typeof QualityCoach_QualityReviewInitiationType[keyof typeof QualityCoach_QualityReviewInitiationType];
/** A paginated list of quality reviews. */
export type QualityCoach_QualityReviewPaginatedResult = {
  __typename?: 'QualityCoach_QualityReviewPaginatedResult';
  /** List of elements in the page */
  elements: Array<QualityCoach_QualityReview>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Status of the quality review. */
export const QualityCoach_QualityReviewStatus = {
  /** The quality review is complete. */
  Complete: 'COMPLETE',
  /** The quality review completed in error */
  Failed: 'FAILED',
  /** The quality review is in progress. */
  InProgress: 'IN_PROGRESS'
} as const;

export type QualityCoach_QualityReviewStatus = typeof QualityCoach_QualityReviewStatus[keyof typeof QualityCoach_QualityReviewStatus];
/** Rule that defines how to review an entity's adherence to best practices. */
export type QualityCoach_QualityRule = {
  __typename?: 'QualityCoach_QualityRule';
  /** Created at time. */
  createdAt: Scalars['DateTime'];
  /** The composite id (rule id + updated at) */
  id: Scalars['ID'];
  /** LLM configuration instructs the LLM system on how to evaluate the rule. */
  llmConfiguration?: Maybe<QualityCoach_RuleLlmConfiguration>;
  /** Rerun configuration instructs the orchestration system on when to rerun the rule. */
  rerunConfiguration: Array<QualityCoach_RuleRerunConfigurationType>;
  /** Descriptions of the rule in human-readable format, used for displaying related results on the UI. */
  ruleDescription: QualityCoach_RuleDescription;
  /** Filters define the conditions under which the rule is applicable. */
  ruleFilters: Array<QualityCoach_RuleFilter>;
  /** The id of the rule. */
  ruleId: Scalars['ID'];
  /** Updated at time. */
  updatedAt: Scalars['DateTime'];
  /** The weight of the rule in the overall score. */
  weight: Scalars['Float'];
};

/** Paginated result type for QualityRule */
export type QualityCoach_QualityRulePaginatedResult = {
  __typename?: 'QualityCoach_QualityRulePaginatedResult';
  /** List of elements in the page */
  elements: Array<QualityCoach_QualityRule>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** A result of running a specific rule on an entity. */
export type QualityCoach_QualityRuleResult = {
  __typename?: 'QualityCoach_QualityRuleResult';
  /** The time the rule was run. */
  createdAt: Scalars['DateTime'];
  /** The result ID. */
  id: Scalars['ID'];
  /** List of issues found during the review, empty for rules that do not support issues. */
  issues: Array<QualityCoach_RuleIssue>;
  /** Recommendation to increase the entity's score against this rule */
  recommendation: QualityCoach_RuleResultRecommendation;
  /** Display information for the rule that was run. */
  ruleDescription: QualityCoach_RuleDescription;
  /** The overall score of the entity for this rule. */
  score: QualityCoach_Score;
};

/** A paginated list of results of evaluating an entity against rules. */
export type QualityCoach_QualityRuleResultPaginatedResult = {
  __typename?: 'QualityCoach_QualityRuleResultPaginatedResult';
  /** List of elements in the page */
  elements: Array<QualityCoach_QualityRuleResult>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Input to query quality reviews for an entity. */
export type QualityCoach_QueryQualityReviewsByEntityInput = {
  /** How to filter reviews by completion status. */
  completionFilter?: Array<QualityCoach_QualityReviewStatus>;
  /** Entity to look up quality reviews for. */
  entity: QualityCoach_ReviewableEntityReferenceInput;
  /** How to filter results by severity level. */
  severityFilter?: Array<QualityCoach_ScoreSeverity>;
};

/** An entity that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_ReviewableEntityReference = {
  __typename?: 'QualityCoach_ReviewableEntityReference';
  /**
   * The id of the entity that can be reviewed.
   * @deprecated Use the entityReference field instead
   */
  entityId: Scalars['ID'];
  /** The typed entity reference. */
  entityReference?: Maybe<QualityCoach_AtomReference | QualityCoach_CourseBranchReference | QualityCoach_CourseReference>;
  /**
   * The type of the entity that can be reviewed.
   * @deprecated Use the type within entityReference field instead
   */
  entityType?: Maybe<QualityCoach_ReviewableEntityReferenceType>;
  /**
   * The version of the entity, for entities that support versioning.
   * @deprecated Use the entityReference field instead
   */
  entityVersion?: Maybe<Scalars['ID']>;
};

/** Input for an entity that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_ReviewableEntityReferenceInput = {
  /**
   * The id of the entity that can be reviewed.
   * @deprecated Use the entityReference field instead
   */
  entityId?: InputMaybe<Scalars['ID']>;
  /** The typed entity reference. */
  entityReference?: InputMaybe<QualityCoach_TypedReviewableEntityReferenceInput>;
  /**
   * The type of the entity that can be reviewed.
   * @deprecated Use the entityReference field instead
   */
  entityType?: InputMaybe<QualityCoach_ReviewableEntityReferenceType>;
  /**
   * The version of the entity, for entities that support versioning.
   * @deprecated Use the entityReference field instead
   */
  entityVersion?: InputMaybe<Scalars['ID']>;
};

/** Types of entities that are supported for reviewing for adherence to best practices by the quality coach system. */
export const QualityCoach_ReviewableEntityReferenceType = {
  /** An atom entity. */
  ReviewableEntityAtom: 'REVIEWABLE_ENTITY_ATOM',
  /** A course entity. */
  ReviewableEntityCourse: 'REVIEWABLE_ENTITY_COURSE',
  /** A course branch entity. */
  ReviewableEntityCourseBranch: 'REVIEWABLE_ENTITY_COURSE_BRANCH',
  /** A reading item entity. */
  ReviewableEntityReadingItem: 'REVIEWABLE_ENTITY_READING_ITEM'
} as const;

export type QualityCoach_ReviewableEntityReferenceType = typeof QualityCoach_ReviewableEntityReferenceType[keyof typeof QualityCoach_ReviewableEntityReferenceType];
/** Descriptions of the rule in a human- and LLM-readable format. */
export type QualityCoach_RuleDescription = {
  __typename?: 'QualityCoach_RuleDescription';
  /**
   * A human- and LLM-readable description of the rule. It should give the user enough information to understand
   * why a rule exists and how to address its issues.
   */
  ruleDescription: Scalars['String'];
  /** A short name for the rule suitable for display in a list. */
  ruleShortName: Scalars['String'];
};

/** Descriptions of the rule in a human- and LLM-readable format. */
export type QualityCoach_RuleDescriptionInput = {
  /**
   * A human- and LLM-readable description of the rule. It should give the user enough information to understand
   * why a rule exists and how to address its issues.
   */
  ruleDescription: Scalars['String'];
  /** A short name for the rule suitable for display in a list. */
  ruleShortName: Scalars['String'];
};

/** A rule filter defines the conditions under which the rule is applicable. */
export type QualityCoach_RuleFilter = {
  __typename?: 'QualityCoach_RuleFilter';
  /** The type of the filter defines which field on the entity to filter on. */
  filterType: QualityCoach_RuleFilterType;
  /** The acceptable entity values for the filter. Empty list implies all values are acceptable. */
  filterValue: Array<Scalars['ID']>;
};

/** A rule filter defines the conditions under which the rule is applicable. */
export type QualityCoach_RuleFilterInput = {
  /** The type of the filter defines which field on the entity to filter on. */
  filterType: QualityCoach_RuleFilterType;
  /** The acceptable entity values for the filter. Empty list implies all values are acceptable. */
  filterValue: Array<Scalars['ID']>;
};

/** The type of the rule filter defines which field on the entity to filter on. */
export const QualityCoach_RuleFilterType = {
  /** Filter on the reviewable entity type. */
  ReviewableEntityTypeFilter: 'REVIEWABLE_ENTITY_TYPE_FILTER'
} as const;

export type QualityCoach_RuleFilterType = typeof QualityCoach_RuleFilterType[keyof typeof QualityCoach_RuleFilterType];
/** An issue is a specific instance of a rule violation against an entity. */
export type QualityCoach_RuleIssue = {
  __typename?: 'QualityCoach_RuleIssue';
  /** The issue description. */
  description: Scalars['String'];
  /** The issue ID. */
  id: Scalars['ID'];
  /** The location of the issue in the entity. */
  location: QualityCoach_RuleIssueLocation;
  /** The recommendation to address the issue. */
  recommendation: QualityCoach_RuleResultRecommendation;
  /** The issue-level score */
  score: QualityCoach_Score;
};

/** Location of the issue in the entity. */
export type QualityCoach_RuleIssueLocation = QualityCoach_RuleIssueLocationCaretPosition | QualityCoach_RuleIssueLocationField;

/** The caret position in the field's contents where the issue was found. */
export type QualityCoach_RuleIssueLocationCaretPosition = {
  __typename?: 'QualityCoach_RuleIssueLocationCaretPosition';
  /** The optional ending caret position in the field's contents. */
  endCaretPosition?: Maybe<Scalars['Int']>;
  /** The field JSON path. */
  fieldJsonPath: Scalars['String'];
  /** The starting caret position in the field's contents. */
  startCaretPosition: Scalars['Int'];
};

/** The field JSON path in which the issue was found. */
export type QualityCoach_RuleIssueLocationField = {
  __typename?: 'QualityCoach_RuleIssueLocationField';
  /** The field JSON path. */
  fieldJsonPath: Scalars['String'];
};

/** LLM configuration instructs the LLM system on how to evaluate the rule. */
export type QualityCoach_RuleLlmConfigurationInput = {
  /** Whether the LLM should generate a single review result or a review result with a list of issues. */
  issueOutputStyle: QualityCoach_IssueOutputStyleType;
  /** The LLM instruction for the rule. */
  llmInstruction: Scalars['String'];
  /** How the LLM should output the results of the rule. */
  llmOutputStyle: QualityCoach_LlmOutputStyleType;
};

/** LLM configuration instructs the LLM system on how to evaluate the rule. */
export type QualityCoach_RuleLlmConfiguration = {
  __typename?: 'QualityCoach_RuleLlmConfiguration';
  /** Whether the LLM should generate a single review result or a review result with a list of issues. */
  issueOutputStyle: QualityCoach_IssueOutputStyleType;
  /** The LLM instruction for the rule. */
  llmInstruction: Scalars['String'];
  /** How the LLM should output the results of the rule. */
  llmOutputStyle: QualityCoach_LlmOutputStyleType;
};

/** Rerun configuration instructs the orchestration system on when to re-evaluate the rule. */
export const QualityCoach_RuleRerunConfigurationType = {
  /** Rule can be manually triggered. */
  RuleRerunConfigurationManual: 'RULE_RERUN_CONFIGURATION_MANUAL',
  /** Rerun the rule on entity update. */
  RuleRerunConfigurationOnEntityUpdate: 'RULE_RERUN_CONFIGURATION_ON_ENTITY_UPDATE'
} as const;

export type QualityCoach_RuleRerunConfigurationType = typeof QualityCoach_RuleRerunConfigurationType[keyof typeof QualityCoach_RuleRerunConfigurationType];
/** A recommendation to increase the entity's score against a rule. */
export type QualityCoach_RuleResultRecommendation = {
  __typename?: 'QualityCoach_RuleResultRecommendation';
  /** A plain text recommendation to increase the entity's score against the rule. */
  recommendation: Scalars['String'];
};

/** Score is a value 0-1 where 0 is total violation and 1 is total adherence to the rules. */
export type QualityCoach_Score = {
  __typename?: 'QualityCoach_Score';
  /** Severity of the score */
  severity: QualityCoach_ScoreSeverity;
  /** The score value, 0-1 where 0 is total violation and 1 is total adherence. */
  value: Scalars['Float'];
};

/** Severity of the score */
export const QualityCoach_ScoreSeverity = {
  /** The score is an error (potentially launch-blocking). */
  Error: 'ERROR',
  /** The score is a pass. */
  Pass: 'PASS',
  /** The score is a suggestion. */
  Suggestion: 'SUGGESTION',
  /** The score is a warning. */
  Warning: 'WARNING'
} as const;

export type QualityCoach_ScoreSeverity = typeof QualityCoach_ScoreSeverity[keyof typeof QualityCoach_ScoreSeverity];
/** A reference to an entity that can be reviewed for adherence to best practices by the quality coach system. */
export type QualityCoach_TypedReviewableEntityReference = {
  /** The type of the entity. */
  entityType: QualityCoach_ReviewableEntityReferenceType;
};

/** Input types for referencing reviewable entities. */
export type QualityCoach_TypedReviewableEntityReferenceInput = {
  /** A reference to an atom. */
  atom?: InputMaybe<QualityCoach_AtomReferenceInput>;
  /** A reference to a course. */
  course?: InputMaybe<QualityCoach_CourseReferenceInput>;
  /** A reference to a course branch. */
  courseBranch?: InputMaybe<QualityCoach_CourseBranchReferenceInput>;
};

/** Input to update an existing quality rule. */
export type QualityCoach_UpdateQualityRuleInput = {
  /** LLM configuration instructs the LLM system on how to evaluate the rule. */
  llmConfiguration?: InputMaybe<QualityCoach_RuleLlmConfigurationInput>;
  /** Rerun configuration instructs the orchestration system on when to rerun the rule. */
  rerunConfiguration: Array<QualityCoach_RuleRerunConfigurationType>;
  /** Descriptions of the rule in a human- and LLM-readable format. */
  ruleDescription: QualityCoach_RuleDescriptionInput;
  /** Filters define the conditions under which the rule is applicable. */
  ruleFilters: Array<QualityCoach_RuleFilterInput>;
  /** The id of the rule. */
  ruleId: Scalars['ID'];
  /** The weight of the rule in the overall score. */
  weight: Scalars['Float'];
};

/** Result of updating an existing quality rule. */
export type QualityCoach_UpdateQualityRuleResult = {
  __typename?: 'QualityCoach_UpdateQualityRuleResult';
  /** The rule that was updated */
  qualityRule: QualityCoach_QualityRule;
};

/** Quality review GraphQL schema for the results of reviewing adherence of content to best practices. */
export type QualityReviewQueries = {
  __typename?: 'QualityReviewQueries';
  /** Get quality reviews by ids. */
  queryByIds: Array<QualityCoach_QualityReview>;
  /** Get up to limit number of quality reviews for an entity, filtered by completion status and sorted newest to oldest. */
  queryQualityReviewsByEntity?: Maybe<QualityCoach_QualityReviewPaginatedResult>;
};


/** Quality review GraphQL schema for the results of reviewing adherence of content to best practices. */
export type QualityReviewQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Quality review GraphQL schema for the results of reviewing adherence of content to best practices. */
export type QualityReviewQueriesQueryQualityReviewsByEntityArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: QualityCoach_QueryQualityReviewsByEntityInput;
  limit?: Scalars['Int'];
};

/** Quality rule GraphQL schema for reviewing adherence of content to best practices. */
export type QualityRuleQueries = {
  __typename?: 'QualityRuleQueries';
  /** Get quality rules by ids. */
  queryByIds: Array<QualityCoach_QualityRule>;
  /** Get up to limit number of relevant quality rules for an entity. */
  queryRelevantQualityRulesByEntity?: Maybe<QualityCoach_QualityRulePaginatedResult>;
};


/** Quality rule GraphQL schema for reviewing adherence of content to best practices. */
export type QualityRuleQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Quality rule GraphQL schema for reviewing adherence of content to best practices. */
export type QualityRuleQueriesQueryRelevantQualityRulesByEntityArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  entity: QualityCoach_ReviewableEntityReferenceInput;
  limit?: Scalars['Int'];
};

/** Root Query type */
export type Query = {
  __typename?: 'Query';
  /** TODO: Complete this description */
  AcademicDiscipline?: Maybe<AcademicDisciplineQueries>;
  /** Adaptive Learning Queries */
  AdaptiveLearning?: Maybe<AdaptiveLearningQueries>;
  /** Queries for the courses list from the admin view */
  AdminCourses?: Maybe<AdminCoursesQueries>;
  /** Returns a list of partner memberships */
  AdminPartnerMemberships?: Maybe<AdminPartnerMembershipsQueries>;
  /** Admin program impersonation queries. */
  AdminProgramImpersonations?: Maybe<AdminProgramImpersonationsQueries>;
  /** Returns a list of staff memberships */
  AdminStaffMemberships?: Maybe<AdminStaffMembershipsQueries>;
  /** Returns user profile information */
  AdminUserProfiles?: Maybe<AdminUserProfileQueries>;
  /** Returns a list of admin user roles */
  AdminUserRoles?: Maybe<AdminUserRoleQueries>;
  /** Queries related to AI cheating flagged events */
  AiCheatingFlaggedEvent?: Maybe<AiCheatingFlaggedEventQueries>;
  /** All AI coach queries */
  AiCoach?: Maybe<AiCoachQueries>;
  /** AiGradedChallenge Queries */
  AiGradedChallenge?: Maybe<AiGradedChallengeQueries>;
  /** Ai Grading Queries */
  AiGrading?: Maybe<AiGradingQueries>;
  /** AI Item Generation Queries */
  AiItemGeneration?: Maybe<AiItemGenerationQueries>;
  /** Queries for AI Grading */
  AiSuggestions?: Maybe<AiSuggestionsQueries>;
  /** Queries related to explaining flagged anomalous attempts */
  AnomalyExplainer?: Maybe<AnomalyExplainerQueries>;
  /** Fetch data for app fee waiver */
  AppFeeWaiver?: Maybe<AppFeeWaiverQueries>;
  /** Get generation parameters of a specific assessment generation */
  AssessmentGeneration_GetAssessmentGenerationParameters: AssessmentGeneration_AssessmentGenerationParametersResult;
  /** Get the status of an ongoing assessment generation */
  AssessmentGeneration_GetAssessmentGenerationStatus: AssessmentGeneration_AssessmentGenerationStatusResult;
  /** Query the status of an assignment generation request */
  AssessmentGenerator_GenerationState?: Maybe<AssessmentGenerator_GenerationStateResult>;
  /** Query the status of an assignment generation request */
  AssessmentGenerator_GenerationStateByAssessmentId?: Maybe<AssessmentGenerator_GenerationStateResult>;
  /** Administrative tools for working with assignments. */
  AssignmentAdminTools?: Maybe<AssignmentAdminToolQueries>;
  /** Assignment Coach Queries */
  AssignmentCoach?: Maybe<AssignmentCoachQueries>;
  /** Assignment metadata for course builder. */
  AssignmentMetadata?: Maybe<AssignmentMetadataQueries>;
  /** TODO: Complete this description */
  AssignmentPresentations?: Maybe<AssignmentPresentationsQueries>;
  /** Assignment content preview. E.g. question prompts */
  AssignmentPreview?: Maybe<AssignmentPreviewQueries>;
  /** Atom summative content queries */
  AtomSummativeContent?: Maybe<AtomSummativeContentQueries>;
  /** TODO: Complete this description */
  AttemptSummary?: Maybe<AttemptSummaryQueries>;
  /** Queries related to AutoProctor functionality. */
  AutoProctor?: Maybe<AutoProctorQueries>;
  /** Autograder analytics queries */
  AutograderAnalytics?: Maybe<AutograderAnalyticsQueries>;
  /** Badge application query */
  Badge?: Maybe<BadgeQueries>;
  /** TODO: Complete this description */
  BannerAdCampaign?: Maybe<BannerAdCampaignQueries>;
  /** Queries for BetaTestingSchedule */
  BetaTestingSchedule?: Maybe<BetaTestingScheduleQueries>;
  /** Queries for BrazeIntegrationApplication */
  BrazeIntegrationQueries?: Maybe<BrazeIntegrationQueries>;
  /** BulkProgramInvitations: all queries related to bulk program invitation imports. */
  BulkProgramInvitations?: Maybe<BulkProgramInvitationsQueries>;
  /**
   * Entry point for business-case proposal queries — currently the download-status poll for the
   * async download flow initiated by `BusinessCaseProposal_RequestDownload`.
   */
  BusinessCaseProposalQueries?: Maybe<BusinessCaseProposalQueries>;
  /** The root field for accessing all Campaign-related queries. */
  Campaign?: Maybe<CampaignQueries>;
  /** Campaign Management Queries */
  CampaignManagement?: Maybe<CampaignManagementQueries>;
  /** All Career Academy queries */
  CareerAcademy?: Maybe<CareerAcademyQueries>;
  /** Fetches catalog degree courses */
  CatalogDegreeCourseQueries?: Maybe<CatalogDegreeCourseQueries>;
  /** Certificate queries */
  Certificate?: Maybe<CertificateQueries>;
  /** All Certificate Print Settings queries */
  CertificatePrintSettings?: Maybe<CertificatePrintSettingsQueries>;
  /** Queries related to cheating cases */
  CheatingCase?: Maybe<CheatingCaseQueries>;
  /** Queries related to cheating case tasks */
  CheatingCaseTask?: Maybe<CheatingCaseTaskQueries>;
  /** queries related to cheating incidents */
  CheatingIncident?: Maybe<CheatingIncidentQueries>;
  /** Queries related to a CheckoutIntent. */
  CheckoutIntent?: Maybe<CheckoutIntentQueries>;
  /** Cities Queries */
  CitySearch?: Maybe<CityQueries>;
  /** GraphQL queries for querying the clip metadata */
  Clip?: Maybe<ClipQueries>;
  /** Coach Item queries */
  CoachItem?: Maybe<CoachItemQueries>;
  /** Queries for fetching collections */
  Collection?: Maybe<CollectionQueries>;
  /**
   * CollectionAttributesQueries: all queries for fetching results
   * for grouped Collection Attributes
   */
  CollectionAttributes?: Maybe<CollectionAttributesQueries>;
  /**
   * CollectionWithAttributesQueries: all queries for fetching results
   * for Collections with Collection Attributes
   */
  CollectionWithAttributes?: Maybe<CollectionWithAttributesQueries>;
  /** All content experiment queries */
  ContentExperiment?: Maybe<ContentExperimentQueries>;
  /** All Core Skill Taxonomy Branch Queries */
  CoreSkillTaxonomyBranch?: Maybe<CoreSkillTaxonomyBranchQueries>;
  /** All Core Skill Taxonomy Node Queries */
  CoreSkillTaxonomyNode?: Maybe<CoreSkillTaxonomyNodeQueries>;
  /** Queries for Course */
  Course?: Maybe<CourseQueries>;
  /**
   * Course builder query namespacing
   * @deprecated Use CourseBuilderV2 instead
   */
  CourseBuilder?: Maybe<CourseBuilderQueries>;
  /** Course Builder v2 query namespacing */
  CourseBuilderV2?: Maybe<CourseBuilderV2Queries>;
  /** Course change queries for authoring change log */
  CourseChange?: Maybe<CourseChangeQueries>;
  /** Graphql queries for the recommended courses after course completion */
  CourseCompletionRecommendations?: Maybe<CourseCompletionRecommendationsQueries>;
  /** Course Content Deadlines Queries */
  CourseContentDeadlines?: Maybe<CourseContentDeadlinesQueries>;
  /** TODO: Complete this description */
  CourseItemChange?: Maybe<CourseItemChangeQueries>;
  /** Course material queries. */
  CourseItems?: Maybe<CourseItemsQueries>;
  /** Course Navigation Queries */
  CourseNavigation?: Maybe<CourseNavigationQueries>;
  /** All courseOffering queries */
  CourseOffering?: Maybe<CourseOfferingQueries>;
  /** Course Preview Queries */
  CoursePreview?: Maybe<CoursePreviewQueries>;
  /** Queries related to Course profiles */
  CourseProfiles?: Maybe<CourseProfilesQueries>;
  /** Namespace for queries for courseprogress */
  CourseProgress?: Maybe<CourseProgressQueries>;
  /** Fetches CourseraPlusCollections-related data. */
  CourseraPlusCollectionsQueries?: Maybe<CourseraPlusCollectionsQueries>;
  /** Queries related to Coursera Proctoring. */
  CourseraProctoring?: Maybe<CourseraProctoringQueries>;
  /** Fetches CourseraTierSubscriptions-related data. */
  CourseraTierSubscriptionsQueries?: Maybe<CourseraTierSubscriptionsFetchQueries>;
  /** Queries for Courserian roles. */
  CourserianRoles?: Maybe<CourserianRolesQueries>;
  /** Fetch data for course stackability */
  CoursesStackability?: Maybe<CoursesStackabilityQueries>;
  /** Queries related to credential configurations */
  CredentialConfiguration?: Maybe<CredentialConfigurationQueries>;
  /** CSV download query namespacing */
  CsvDownload?: Maybe<CsvDownloadQueries>;
  /** Queries for program curations (collections and/or learning-paths for program/curation builder) */
  CurationBuilder?: Maybe<CurationBuilderQueries>;
  /** Queries for curation recommendations */
  CurationRecommendation?: Maybe<CurationRecommendationQueries>;
  /** Curriculum Management ingested data query namespacing */
  CurriculumManagementIngestedData?: Maybe<CurriculumManagementIngestedDataQueries>;
  /** Curriculum Management file processing workflow query namespacing */
  CurriculumManagementWorkflow?: Maybe<CurriculumManagementWorkflowQueries>;
  /** Daily goals queries */
  DailyGoals?: Maybe<DailyGoalsQueries>;
  /** Get daily item completion count for learner. */
  DailyItemCompletions?: Maybe<DailyItemCompletionsQueries>;
  /** Get daily skill points earned by a learner. */
  DailySkillPoints?: Maybe<DailySkillPointsQueries>;
  /** Queries for Degree */
  Degree?: Maybe<DegreeQueries>;
  /** Authoring Queries */
  DegreeAuthoringQueries?: Maybe<DegreeAuthoringQueries>;
  /** Fetches degree category(ies). */
  DegreeCategoryQueries?: Maybe<DegreeCategoryFetchQueries>;
  /** Queries for DegreeConfigApplication */
  DegreeConfigQueries?: Maybe<DegreeConfigQueries>;
  /** Fetch data for degree description page (DDP) modules */
  DegreeDescriptionPageModules?: Maybe<DegreeDescriptionPageModulesQueries>;
  /** Degree Enrollment CheckList Queries */
  DegreeEnrollmentCheckListQueries?: Maybe<DegreeEnrollmentCheckListQueries>;
  /** Queries for DegreeHome service */
  DegreeHome?: Maybe<DegreeHomeQueries>;
  /** Fetch data for PUMA (Pathways Upselling & Merchandising API). */
  DegreePathwaysMerchandising?: Maybe<DegreePathwaysMerchandisingQueries>;
  /** Degree Webinar Queries */
  DegreeWebinarQueries?: Maybe<DegreeWebinarFetchQueries>;
  /** All Descript POC Authoring queries */
  Descript?: Maybe<DescriptQueries>;
  /** Queries for fetching data for different types of description pages */
  DescriptionPage?: Maybe<DescriptionPageQueries>;
  /**
   * Returns a list of collections used for discovery purposes.
   * These queries is considered legacy and should be avoided if possible. Instead, consider using:
   * - coursera/graphql/collections/schema/collections.graphqls
   * - coursera/graphql/descriptionpage/schema/descriptionpage.graphqls
   * This API is deprecated (see https://docs.google.com/document/d/15alW0J0WlB-I3E8adhsmCD4tq1cDRmcTDqP0EjBAd-w/edit?tab=t.0#heading=h.mx7o3soqpxcu)
   * There is no direct replacement for this API, but the below API's are recommended:
   * - PageConfigQueries
   * - RecommendationQueries
   * @deprecated Use PageConfigQueries or RecommendationQueries instead.
   */
  DiscoveryCollections?: Maybe<DiscoveryCollectionsQueries>;
  /** Queries that return Domains */
  Domain?: Maybe<DomainQueries>;
  /** All queries related to question bank questions */
  DraftQuestionBankQuestions?: Maybe<DraftQuestionBankQuestionsQueries>;
  /** Entry point for Email Whitelist queries. */
  EmailWhitelistQueries?: Maybe<EmailWhitelistQueries>;
  /** EmbeddedExp: Admin queries for the LMS-iframe embedding allowlist. */
  EmbeddedExp?: Maybe<EmbeddedExpQueries>;
  /** All enrollmentChoice queries */
  EnrollmentChoice?: Maybe<EnrollmentChoiceQueries>;
  /**
   * Queries for fetching collections to display on enterprise page
   * @deprecated Use EntCollectionWithOrg instead.
   */
  EntCollection?: Maybe<EntCollectionQueries>;
  /** Queries for fetching collections to display on an org scoped route */
  EntCollectionWithOrg?: Maybe<EntCollectionWithOrgQueries>;
  /** Queries for org-scoped curriculum collections. */
  EntCurriculum?: Maybe<EntCurriculumQueries>;
  /** External platform gateway configuration queries. */
  EntExternalConnector?: Maybe<EntExternalConnectorQueries>;
  /** ent sso queries */
  EntSso?: Maybe<EntSsoQueries>;
  /** Entry point for the DecoratedEnterpriseContractQueries */
  EntTransaction_DecoratedEnterpriseContractQueries?: Maybe<EntTransaction_DecoratedEnterpriseContractQueries>;
  /** Entry point for free trial queries. */
  EntTransaction_FreeTrialQueries?: Maybe<EntTransaction_FreeTrialQueries>;
  /**
   * Fetches an enterprise contract purchase order by ID.
   * Returns the purchase order details if found.
   */
  EntTransaction_GetEnterpriseContractPurchaseOrder: EntTransaction_EnterpriseContractPurchaseOrder;
  /**
   * Fetches enterprise contract purchase orders by contract ID.
   * Returns a paginated list of orders associated with the specified contract.
   */
  EntTransaction_GetEnterpriseContractPurchaseOrdersByContractId: EntTransaction_EnterpriseContractPurchaseOrdersPaginatedResult;
  /**
   * Fetches free trial offer details for enterprise contracts.
   * Returns information about available free trial offers.
   */
  EntTransaction_GetFreeTrialOfferDetails: EntTransaction_FreeTrialOffer;
  /** Entry point for the PaymentMethodsQueries */
  EntTransaction_PaymentMethodsQueries?: Maybe<EntTransaction_PaymentMethodsQueries>;
  /** EntUserEducatorQueries: all queries for the ent-user-educator service */
  EntUserEducator?: Maybe<EntUserEducatorQueries>;
  /** All the queries for enterprise account page contract lifetime metrics */
  EnterpriseAdminAccountPageContractLifetimeMetrics?: Maybe<EnterpriseAdminAccountPageContractLifetimeMetricsQueries>;
  /** All the queries for enterprise admin homepage metrics */
  EnterpriseAdminHomePageMetrics?: Maybe<EnterpriseAdminHomePageMetricsQueries>;
  /** This are the enterprise admin invitation queries */
  EnterpriseAdminInvitation?: Maybe<EnterpriseAdminInvitationQueries>;
  /** All the queries for enterprise program metrics */
  EnterpriseAdminProgramMetrics?: Maybe<EnterpriseAdminProgramMetricsQueries>;
  /** TODO: Complete this description */
  EnterpriseBadge?: Maybe<EnterpriseBadgeQueries>;
  /** All queries belonging to EnterpriseContentAssignment */
  EnterpriseContentAssignment?: Maybe<EnterpriseContentAssignmentQueries>;
  /** All queries belonging to EnterpriseContentAssignmentUserInsight */
  EnterpriseContentAssignmentUserInsight?: Maybe<EnterpriseContentAssignmentUserInsightQueries>;
  /** EnterpriseContract Queries */
  EnterpriseContract?: Maybe<EnterpriseContractsQueries>;
  /** Entry point for the EnterpriseContractDeferredLicenseChangeQueries */
  EnterpriseContractDeferredLicenseChangeQueries?: Maybe<EnterpriseContractDeferredLicenseChangeQueries>;
  /** EnterpriseContractPolicy Queries */
  EnterpriseContractPolicy?: Maybe<EnterpriseContractPolicyQueries>;
  /** Entry point for Enterprise Contract Price Queries */
  EnterpriseContractPriceQueries?: Maybe<EnterpriseContractPriceQueries>;
  /** All queries related to enterprise contracts tag */
  EnterpriseContractTags?: Maybe<EnterpriseContractTagsQueries>;
  /** All the queries for enterprise contract utilization */
  EnterpriseContractUtilizations?: Maybe<EnterpriseContractUtilizationsQueries>;
  /** Entry point for Enterprise Coupon Queries */
  EnterpriseCouponQueries?: Maybe<EnterpriseCouponQueries>;
  /** EnterpriseEmailContentGeneration: all queries related to email generation. */
  EnterpriseEmailContentGeneration?: Maybe<EnterpriseEmailContentGenerationQueries>;
  /** All queries belonging to EnterpriseEnrollment */
  EnterpriseEnrollment?: Maybe<EnterpriseEnrollmentQueries>;
  /** All queries related to enterprise enrollment reports */
  EnterpriseEnrollmentReports?: Maybe<EnterpriseEnrollmentReportQueries>;
  /** EnterpriseFilterOptions: all queries belonging to EnterpriseFilterOptions */
  EnterpriseFilterOptions?: Maybe<EnterpriseFilterOptionsQueries>;
  /** All queries related to enterprise gradebooks */
  EnterpriseGradebooks?: Maybe<EnterpriseGradebooksQueries>;
  /** All the queries for enterprise learner cohorts */
  EnterpriseLearnerCohort?: Maybe<EnterpriseLearnerCohortQueries>;
  /** All queries related to enterprise plagiarism report */
  EnterpriseLearnerPlagiarismReport?: Maybe<EnterpriseLearnerPlagiarismReportQueries>;
  /** All queries related to enterprise permissions */
  EnterprisePermission?: Maybe<EnterprisePermissionQueries>;
  /** Queries related to enterprise plagiarism report */
  EnterprisePlagiarismReport?: Maybe<EnterprisePlagiarismReportQueries>;
  /** Queries for EnterpriseProgram */
  EnterpriseProgram?: Maybe<EnterpriseProgramQueries>;
  /** Entry point for Enterprise Promotion Queries */
  EnterprisePromotionQueries?: Maybe<EnterprisePromotionQueries>;
  /** All queries related to enterprise reports */
  EnterpriseReports?: Maybe<EnterpriseReportsQueries>;
  /** All queries related to enterprise role templates */
  EnterpriseRoleTemplate?: Maybe<EnterpriseRoleTemplateQueries>;
  /** EnterpriseRosters: all queries related to Enterprise Rosters. */
  EnterpriseRosters?: Maybe<EnterpriseRostersQueries>;
  /** All queries for Enterprise SCIM */
  EnterpriseScimQueries?: Maybe<EnterpriseScimQueries>;
  /** EnterpriseSetting: All the queries for enterprise settings */
  EnterpriseSetting?: Maybe<EnterpriseSettingQueries>;
  /** Skills Queries */
  EnterpriseSkills?: Maybe<EnterpriseSkillsQueries>;
  /** SkillsInsights Queries */
  EnterpriseSkillsInsights?: Maybe<EnterpriseSkillsInsightsQueries>;
  /** Skillset Queries */
  EnterpriseSkillset?: Maybe<EnterpriseSkillsetQueries>;
  /** All queries related to enterprise enrollment reports */
  EnterpriseSummaryEnrollmentReports?: Maybe<EnterpriseSummaryEnrollmentReportQueries>;
  /** All queries related to enterprise reports */
  EnterpriseSummaryReports?: Maybe<EnterpriseSummaryReportsQueries>;
  /** EnterpriseTargetSkillProfileSummaries Queries */
  EnterpriseTargetSkillProfileSummary?: Maybe<EnterpriseSkills_EnterpriseTargetSkillProfileSummaryQueries>;
  /** EnterpriseUserAdminView: all queries belonging to EnterpriseUserAdminView */
  EnterpriseUserAdminView?: Maybe<EnterpriseUserAdminViewQueries>;
  /** All queries related to enterprise user roles */
  EnterpriseUserRoles?: Maybe<EnterpriseUserRolesQueries>;
  /** EnterpriseUsers: all queries related to EnterpriseUsers. */
  EnterpriseUsers?: Maybe<EnterpriseUsersQueries>;
  /** TODO: Complete this description */
  Entitlement?: Maybe<EntitlementQueries>;
  /** Queries related to Exam Recording. */
  ExamRecording?: Maybe<ExamRecordingQueries>;
  /** Query definitions for Epic Experiments. */
  Experiment?: Maybe<EpicExperimentQueries>;
  /** Query definitions for Epic Experiment Namespace Configuration. */
  ExperimentNamespaceConfiguration?: Maybe<EpicExperimentNamespaceConfigurationQueries>;
  /** Query definitions for EOIs. */
  ExpressionOfInterest?: Maybe<ExpressionOfInterestQueries>;
  /** Queries for External App configuration */
  ExternalApp?: Maybe<ExternalAppQueries>;
  /** External integration platform configuration queries. */
  ExternalIntegration?: Maybe<ExternalIntegrationQueries>;
  /** Queries for FAQs. */
  Faq?: Maybe<FaqQueries>;
  /** Financial aid queries */
  FinancialAidApplication?: Maybe<FinancialAidApplicationQueries>;
  /** Flashcard Queries */
  Flashcards?: Maybe<FlashcardQueries>;
  /** Queries related to the Graded Item Locking feature (formerly known as Require All Item Completion) */
  GradedItemLocking?: Maybe<GradedItemLockingQueries>;
  /** Queries for fetching grader performance metrics */
  GraderPerformance?: Maybe<GraderPerformanceQueries>;
  /** Graphql queries for grades disclaimer banner */
  GradesDisclaimer?: Maybe<GradesDisclaimerQueries>;
  /** see GradingCommentsQueries */
  GradingComments?: Maybe<GradingCommentsQueries>;
  /** TODO: Complete this description */
  GroupGrading?: Maybe<GroupGradingQueries>;
  /** HonorlockEnablement queries */
  HonorlockEnablement?: Maybe<HonorlockEnablementQueries>;
  /** Honorlock Learner Flow queries */
  HonorlockLearnerFlow?: Maybe<HonorlockLearnerFlowQueries>;
  /** Queries for iMocha Assessment */
  IMochaAssessment?: Maybe<IMochaAssessmentQueries>;
  /** idverificationvendorintegration */
  IdVerificationVendorIntegration?: Maybe<IdVerificationVendorIntegrationQueries>;
  /** Query for completed in-lab instructions in one course's item for one learner */
  InLabInstructionsQueries?: Maybe<InLabInstructionsQueries>;
  /** Namespace for queries for injectable activities */
  InjectableActivities?: Maybe<InjectableActivitiesQueries>;
  /** Queries for Institution Staff Invitations */
  InstitutionStaffInvitation?: Maybe<InstitutionStaffInvitationQueries>;
  /**
   * Queries related to checking submissions and prompts for academic
   * integrity issues
   */
  IntegrityCheck?: Maybe<IntegrityCheckQueries>;
  /** Queries related to integrity settings */
  IntegritySettingsV2?: Maybe<IntegritySettingsQueriesV2>;
  /** Item authoring queries */
  ItemAuthoring?: Maybe<ItemAuthoringQueries>;
  /** ItemPersonalization: all queries related to item personalization */
  ItemPersonalization?: Maybe<ItemPersonalizationQueries>;
  /** TODO: Complete this description */
  ItemPublishHistory?: Maybe<ItemPublishHistoryQueries>;
  /** Root type of queries for comparing versions of items and returning their 'diffs' or changes. */
  ItemVersionDiffs?: Maybe<ItemVersionDiffsQueries>;
  /** All queries related to JWTLogins. */
  JWTLogins?: Maybe<JwtLoginsQueries>;
  /** JobMatch Queries */
  JobMatch?: Maybe<JobMatchQueries>;
  /** Query for labs admin token */
  LabAdminTokensQueries?: Maybe<LabAdminTokensQueries>;
  /** Query logs for a lab */
  LabContainerLogs?: Maybe<LabContainerLogsQueries>;
  /** Query image authoring data for a lab */
  LabImageAuthoringDataQueries?: Maybe<LabImageAuthoringDataQueries>;
  /** Query logs for a lab image build */
  LabImageBuildLogs?: Maybe<LabImageBuildLogsQueries>;
  /** Query for lab logs browser */
  LabLogQueries?: Maybe<LabLogQueries>;
  /** Query for lab recording status and video access */
  LabRecordingQueries?: Maybe<LabRecordingQueries>;
  /** Returns available and primary languages */
  LanguagesForProduct?: Maybe<LanguagesForProductQueries>;
  /** Query launch status for a lab */
  LaunchLabQueries?: Maybe<LaunchLabQueries>;
  /** LearnerCalendar queries */
  LearnerCalendar?: Maybe<LearnerCalendarQueries>;
  /** GraphQL queries for course timeline */
  LearnerCourseTimeline?: Maybe<LearnerCourseTimelineQueries>;
  /** Learner goals queries */
  LearnerGoals?: Maybe<LearnerGoalsQueries>;
  /** LearnerObject namespaced queries */
  LearnerObject?: Maybe<LearnerObjectQueries>;
  /** All learner onboarding queries. */
  LearnerOnboarding?: Maybe<LearnerOnboardingQueries>;
  /** Learner's plan to complete their degree */
  LearnerPlan?: Maybe<LearnerPlanQueries>;
  /** LearnerProfile namespaced queries */
  LearnerProfile?: Maybe<LearnerProfileQueries>;
  /** Get or create streak count for the learner */
  LearnerStreaks?: Maybe<WeeklyStreaksQueries>;
  /** Root queries for core lex event-related operations */
  LexExperimentEvents?: Maybe<LexExperimentEventsQueries>;
  /** Root queries for learner statistics and analytics */
  LexExperimentLearnerStats?: Maybe<LexExperimentLearnerStatsQueries>;
  /** Returns true when a Statsig experiment already exists for the given configuration. Backs Retool's duplicate-detection warning when marketers create a new experiment. Checks against the Statsig layer name derived from `contentType` and `experimentConfiguration` (lowercased, `_`-delimited per Statsig's `[a-z0-9_-]` rule) — the same name used by `Localization_CreateStatsigExperiment`, not the legacy EPIC parameter name from `Localization_CreateExperimentConfiguration`. */
  Localization_StatsigExperimentExistsForConfiguration: Scalars['Boolean'];
  /** Lists Statsig experiments created by the localization self-serve flow, newest first. Backs the experiment table in the Retool self-serve UI — the Statsig replacement for the legacy EPIC `searchExperiments` marker search. Experiments are identified by the `localization-self-serve` Statsig tag attached at creation; experiments created before tagging shipped, or whose tag was removed in the Statsig console, are not returned. */
  Localization_StatsigExperiments: Localization_StatsigExperimentSummaryPaginatedResult;
  /** Localized data queries. */
  LocalizedData?: Maybe<LocalizedDataQueries>;
  /** Fetch data for LoggedIn home page stackability */
  LoggedInHomePageStackability?: Maybe<LoggedInHomePageStackabilityQueries>;
  /** Low Stakes Learning Tools Queries */
  LowStakesLearningTools?: Maybe<LowStakesLearningToolsQueries>;
  /** Queries for LTI Item Authoring */
  LtiItemAuthoring?: Maybe<LtiItemAuthoringQueries>;
  /** LtiTool: All the queries for Lti Tool Application */
  LtiTool?: Maybe<LtiToolQueries>;
  /** All queries for MCP Apps */
  McpApps?: Maybe<McpAppsQueries>;
  /** All Merchandising Upsell Module queries */
  MerchandisingUpsellModule?: Maybe<MerchandisingUpsellModuleQueries>;
  /** Mobile queries */
  Mobile?: Maybe<MobileQueries>;
  NaptimeQueries: NaptimeQueries;
  /** All the queries for native analytics */
  NativeAnalytics?: Maybe<NativeAnalyticsQueries>;
  /**
   * Nostos API - serves pre-aggregated data from Lakebase synced tables.
   *
   * Data is prepared in Spark jobs and synced to Lakebase (PostgreSQL) via
   * Databricks Synced Tables. This service provides fast key-value lookups.
   */
  Nostos?: Maybe<NostosQueries>;
  /** Nostos External API - public access to tables with external_access_enabled=true. */
  NostosExternal?: Maybe<NostosExternalQueries>;
  /** Queries for NotificationPreferenceApplication */
  NotificationPreference?: Maybe<NotificationPreferenceQueries>;
  /** Entry point for OTP verification queries. */
  OTPQueries?: Maybe<OtpQueries>;
  /** All Occupations related queries */
  Occupations?: Maybe<OccupationsQueries>;
  /**
   * TODO: Complete this description
   * @deprecated Use SpecializationMembership instead.
   */
  OnDemandSpecializationMembership?: Maybe<OnDemandSpecializationMembershipQueries>;
  /**
   * TODO: Complete this description
   * @deprecated Use SpecializationProgress instead.
   */
  OnDemandSpecializationProgress?: Maybe<OnDemandSpecializationProgressQueries>;
  /**
   * TODO: Complete this description
   * @deprecated Use SpecializationUpgrade instead.
   */
  OnDemandSpecializationUpgrade?: Maybe<OnDemandSpecializationUpgradeQueries>;
  /** Open course asset queries. */
  OpenCourseAssetQueries?: Maybe<OpenCourseAssetQueries>;
  /** All partner approval queries */
  OptimizationBranch?: Maybe<OptimizationBranchQueries>;
  /** All queries for Business API Keys. */
  OrgApiKeyQueries?: Maybe<OrgApiKeyQueries>;
  /** Queries for managing organization-level collections */
  OrgCollection?: Maybe<OrgCollectionQueries>;
  /** All queries related to OrgVerifiedDomains for SSO domain verification. */
  OrgVerifiedDomain?: Maybe<OrgVerifiedDomainQueries>;
  /** OwnableProductPromotionPriceQueries */
  OwnableProductPromotionPriceQueries?: Maybe<OwnableProductPromotionPriceQueries>;
  /** OwnableProductQueries */
  OwnableProductQueries?: Maybe<OwnableProductQueries>;
  /** Queries for fetching a list of components to display on our config enabled pages. */
  PageConfig?: Maybe<PageConfigQueries>;
  /** Queries for fetching data required for page header configurations using the composable page header framework. */
  PageHeader?: Maybe<PageHeaderQueries>;
  /** Partner queries */
  Partner?: Maybe<PartnerQueries>;
  /** All partner approval queries */
  PartnerApproval?: Maybe<PartnerApprovalQueries>;
  /** Holds the partner <-> group connections */
  PartnerGroupMemberships?: Maybe<PartnerGroupMembershipsQueries>;
  /** Pathway Career Roles queries. */
  PathwaySkillCareerRoles?: Maybe<PathwayCareerRoleQueries>;
  /** All queries related to payment int tools application */
  PaymentIntToolsApplication?: Maybe<PaymentIntToolsApplicationQueries>;
  /** Queries related to PaymentMethods. */
  PaymentMethods?: Maybe<PaymentMethodQueries>;
  /** Queries related to PaymentProcessors. */
  PaymentProcessors?: Maybe<PaymentProcessorsQueries>;
  /** The top level query containing all other queries */
  PaymentsReporting?: Maybe<PaymentsReportingQueries>;
  /** All pedagogy recommendation queries */
  PedagogyRecommendations?: Maybe<PedagogyRecommendationQueries>;
  /** Peer Review Queries */
  PeerReview?: Maybe<PeerReviewQueries>;
  /** Peer Review AI Queries */
  PeerReviewAi?: Maybe<PeerReviewAiQueries>;
  /** Peer Review Migration Queries */
  PeerReviewMigration?: Maybe<PeerReviewMigrationQueries>;
  /** Fetch data for personalized ddp */
  PersonalizedDdp?: Maybe<PersonalizedDdpQueries>;
  /** PersonalizedPlans namespaced queries. */
  PersonalizedPlans?: Maybe<PersonalizedPlansQueries>;
  /** Phrase Course Config Queries */
  PhraseCourseConfig?: Maybe<PhraseCourseConfigQueries>;
  /** Query definitions for EPIC Platform metrics. */
  PlatformMetric?: Maybe<EpicPlatformMetricQueries>;
  /** Queries premium product collections. */
  PremiumProductCollections?: Maybe<PremiumProductCollectionsQueries>;
  /** TODO: Complete this description */
  Proctor?: Maybe<ProctorQueries>;
  /** Queries for ProductCard */
  ProductCard?: Maybe<ProductCardQueries>;
  /** User profile consents queries */
  ProfileConsents?: Maybe<ProfileConsentsQueries>;
  /** ProfileOccupationChoices namespaced queries */
  ProfileOccupationChoices?: Maybe<ProfileOccupationChoicesQueries>;
  /** ProgramHome queries */
  ProgramHome?: Maybe<ProgramHomePageQueries>;
  /** ProgramInvitations: all queries related to ProgramInvitations. */
  ProgramInvitations?: Maybe<ProgramInvitationsQueries>;
  /** ProgramInvitationsDomainAllowList: all queries related to ProgramInvitationsDomainAllowList. */
  ProgramInvitationsDomainAllowList?: Maybe<ProgramInvitationsDomainAllowListQueries>;
  /** ProgramMemberships: all queries related to ProgramMemberships. */
  ProgramMemberships?: Maybe<ProgramMembershipsQueries>;
  /** All queries belonging to ProgramUserCredits */
  ProgramUserCredits?: Maybe<ProgramUserCreditsQueries>;
  /** Programming Assignment queries. */
  Programming_Assignment?: Maybe<ProgrammingAssignmentQueries>;
  /** All queries related to promotions application */
  PromotionsApplication?: Maybe<PromotionsApplicationQueries>;
  /** All queries related to published question bank questions */
  PublishedQuestionBankQuestions?: Maybe<PublishedQuestionBankQuestionsQueries>;
  /** Query for QualificationSurveyExperiment */
  QualificationSurveyExperiment?: Maybe<QualificationSurveyExperimentQueries>;
  /** Fetches QualificationSurvey. */
  QualificationSurveyQueries?: Maybe<QualificationSurveyQueries>;
  /** Query for QualificationSurveySectionResponse */
  QualificationSurveySectionResponseQueries?: Maybe<QualificationSurveySectionResponseQueries>;
  /** Quality review for different entities of a course */
  QualityReview?: Maybe<QualityReviewQueries>;
  /** Quality rules to check for adherence to best practices for different entities of a course */
  QualityRule?: Maybe<QualityRuleQueries>;
  /** All queries related to question bank cascading publish transactions */
  QuestionBankCascadingPublishTransactions?: Maybe<QuestionBankCascadingPublishTransactionsQueries>;
  /** All question bank draft summaries queries */
  QuestionBankDraftSummaries?: Maybe<QuestionBankDraftSummariesQueries>;
  /** All question bank published summaries queries */
  QuestionBankSummaries?: Maybe<QuestionBankSummariesQueries>;
  /** All Question Blocks queries */
  QuestionBlocks?: Maybe<QuestionBlocksQueries>;
  /** Question Generator Queries */
  QuestionGenerator?: Maybe<QuestionGeneratorQueries>;
  /** Query the status of a generation request */
  QuestionGenerator_GenerationState?: Maybe<QuestionGenerator_GenerationStateResult>;
  /** Query all the generation requests in a branch */
  QuestionGenerator_RequestsByBranch?: Maybe<QuestionGenerator_GenerationRequestsByBranchResult>;
  /** Query to get all the source content identifiers used to generate questions in a question bank */
  QuestionGenerator_SourceContentIdentifiers?: Maybe<QuestionGenerator_SourceContentIdentifiersInQuestionBank>;
  /** Queries for fetching recently viewed products */
  RecentlyViewedProduct?: Maybe<RecentlyViewedProductsQueries>;
  /** Queries that return recommendations. See each query definition for specifics. */
  Recommendations?: Maybe<RecommendationQueries>;
  /** Graphql queries for the recommended module completion dates */
  RecommendedModuleDeadlines?: Maybe<RecommendedModuleDeadlinesQueries>;
  /** RecruitingCandidate Queries */
  RecruitingCandidate?: Maybe<RecruitingCandidateQueries>;
  /** RecruitingInvitation Queries */
  RecruitingInvitation?: Maybe<RecruitingInvitationQueries>;
  /** RecruitingPosition Queries */
  RecruitingPosition?: Maybe<RecruitingPositionQueries>;
  /** [Deprecated] */
  ReusableComments?: Maybe<ReusableCommentsQueries>;
  /** Role Skill Mapping Branch Queries */
  RoleSkillMappingBranch?: Maybe<RoleSkillMappingBranchQueries>;
  /** Role Skill Mapping Node Queries */
  RoleSkillMappingNode?: Maybe<RoleSkillMappingNodeQueries>;
  /** All queries related to SAML flows. */
  SamlFlows?: Maybe<SamlFlowsQueries>;
  /** TODO: Complete this description */
  SampleUser?: Maybe<SampleUserQueries>;
  /** TODO: Complete this description */
  ScopedContentRule?: Maybe<ScopedContentRuleQueries>;
  /** Queries for scoped translation configuration, including retranslation state. */
  ScopedTranslationConfig?: Maybe<ScopedTranslationConfigQueries>;
  /** Search queries. */
  SearchResult?: Maybe<SearchResultQueries>;
  /** Queries for fetching seo data for given path */
  Seo?: Maybe<SeoQueries>;
  /**
   * Queries for Sessions. Currently only returns session specific item overrides - full
   * migration of rest of fields will occur in 2024.
   */
  Session?: Maybe<SessionQueries>;
  /** All Session Schedule Overrides queries */
  SessionScheduleOverrides?: Maybe<SessionScheduleOverridesQueries>;
  /** GraphQL queries for short form content BFF service */
  ShortFormContent?: Maybe<ShortFormContentQueries>;
  /** Similarity Check Queries */
  SimilarityChecks?: Maybe<SimilarityCheckQueries>;
  /** Read-only Skill Mastery data queries */
  SkillMastery?: Maybe<SkillMasteryQueries>;
  /** Skill Mastery Levels Queries. */
  SkillMasteryLevels?: Maybe<SkillMasteryLevelsQueries>;
  /** Queries for fetching skill restricted contract tag */
  SkillRestrictedContractTags?: Maybe<SkillRestrictedContractTagQueries>;
  /** SkillScores Queries. */
  SkillScores?: Maybe<SkillScoresQueries>;
  /** Queries that return data for Skill Signals XP progress */
  SkillSignals?: Maybe<SkillSignalsQueries>;
  /** All Skill queries */
  Skills?: Maybe<SkillsQueries>;
  /** All Skill Progress queries */
  SkillsProgress?: Maybe<SkillsProgressQueries>;
  /** All Skill Tag queries */
  SkillsTags?: Maybe<SkillsTagsQueries>;
  /** SkillsTagsLabeling Queries */
  SkillsTagsLabeling?: Maybe<SkillsTagsLabelingQueries>;
  /** SkillsTracking Queries */
  SkillsTracking?: Maybe<SkillsTrackingQueries>;
  /** SocialCohort namespaced queries. */
  SocialCohort?: Maybe<SocialCohortQueries>;
  /** Spark course queries */
  SparkCourse?: Maybe<SparkCourseQueries>;
  /** Queries that return Specializations (of all types, including Professional Certificates and the like) */
  Specialization?: Maybe<SpecializationQueries>;
  /** Queries for specialization memberships. */
  SpecializationMembership?: Maybe<SpecializationMembershipQueries>;
  /** Queries for specialization progress. */
  SpecializationProgress?: Maybe<SpecializationProgressQueries>;
  /** Queries for specialization upgrade. */
  SpecializationUpgrade?: Maybe<SpecializationUpgradeQueries>;
  /** Fetch data for customized stackability contents, features override other old stackability queries. */
  Stackability?: Maybe<StackabilityQueries>;
  /** Queries that return Subdomains */
  Subdomain?: Maybe<SubdomainQueries>;
  /** Assignment submission grading GraphQL Schemas. */
  SubmissionDownload?: Maybe<SubmissionDownloadQueries>;
  /** Queries for the current state of the learner's submission. */
  SubmissionState?: Maybe<SubmissionStateQueries>;
  /** Fetches Subscriptions related data. */
  SubscriptionsQueries?: Maybe<SubscriptionsQueries>;
  /** Subtitles query namespacing */
  Subtitles?: Maybe<SubtitlesQueries>;
  /** Queries for TACO configurations. */
  TacoConfig?: Maybe<TacoConfigQueries>;
  /** TargetSkillProfileUserState Queries */
  TargetSkillProfileUserState?: Maybe<EnterpriseSkills_TargetSkillProfileUserStatesQueries>;
  /** Query definitions for Targeting Rules. */
  TargetingRule?: Maybe<TargetingRuleQueries>;
  /** Test case analytics queries */
  TestCaseAnalytics?: Maybe<TestCaseAnalyticsQueries>;
  /** All Queries for ThirdPartyOrganization */
  ThirdPartyOrganization?: Maybe<ThirdPartyOrganizationQueries>;
  /** All queries for ThirdPartyOrganizationConfiguration */
  ThirdPartyOrganizationConfiguration?: Maybe<ThirdPartyOrganizationConfigurationQueries>;
  /** All queries related to ThirdPartyOrganizationEmailDomains. */
  ThirdPartyOrganizationEmailDomain?: Maybe<ThirdPartyOrganizationEmailDomainQueries>;
  /** All Queries for ThirdPartyOrganizationServiceAccount */
  ThirdPartyOrganizationServiceAccount?: Maybe<ThirdPartyOrganizationServiceAccountQueries>;
  /**
   * Translate Content using Third Party Translation Services such as AWS, Google, DeepL.
   *
   * The translations are not backed by a database but will have a Redis Cache infront of it.
   * Pagination is therefore not available and we expect these API's to be called
   * on-demand for content that can not be translated using BE Translation Proxy approach.
   *
   * Examples of this type of content:
   * - User Generated Content (Eg. Peer Reviews, Discussion Forum Posts)
   */
  TranslateContent?: Maybe<TranslateContentQueries>;
  /** TODO: Complete this description */
  TurnitinTenantEntry?: Maybe<TurnitinTenantEntryQueries>;
  /** ULBA API queries for content import/export operations */
  Ulba?: Maybe<UlbaQueries>;
  /** UnifiedHome queries */
  UnifiedHome?: Maybe<UnifiedHomeQueries>;
  /** Graphql queries for the upcoming items */
  UpcomingItems?: Maybe<UpcomingItemsQueries>;
  /** Fetches upsells. */
  UpsellQueries?: Maybe<UpsellQueries>;
  /** User queries */
  User?: Maybe<UserQueries>;
  /** User entity queries, by email */
  UserEmail?: Maybe<UserEmailQueries>;
  /** UserEmails queries */
  UserEmails?: Maybe<UserEmailsQueries>;
  /** User experience context queries. */
  UserExperienceContext?: Maybe<UserExperienceContextQueries>;
  /**
   * Queries to retrieve details and status information about one or more Portfolio Projects
   * that learners have completed or are in the process of completing.
   */
  UserPortfolioProject?: Maybe<UserPortfolioProjectQueries>;
  /** User preference queries */
  UserPreference?: Maybe<UserPreferenceQueries>;
  /** Queries that return data related to the Verified Skills taxonomy */
  VerifiedSkills?: Maybe<VerifiedSkillsQueries>;
  /** Queries that return information a user's attainment status for Skill Expressions */
  VerifiedSkillsAttainment?: Maybe<VerifiedSkillsAttainmentQueries>;
  /** Queries that return data related to the Verified Skills mappings */
  VerifiedSkillsMapping?: Maybe<VerifiedSkillsMappingQueries>;
  /** Queries related to Viva AI Exams */
  VivaExam?: Maybe<VivaExamQueries>;
  /** Entry point for the WES Checkout queries. */
  WesCheckoutActionQueries?: Maybe<WesCheckoutActionQueries>;
  /** Entry point for the WES Validator queries. */
  WesValidatorQueries?: Maybe<WesValidatorQueries>;
  /** See queries in widgetSessions queries file. */
  WidgetSessions?: Maybe<WidgetSessionQueries>;
  /** xAPI integration queries. */
  XapiIntegration?: Maybe<XapiIntegrationQueries>;
  /** DynamicPrompt queries for AI Tutor */
  aiTutorDynamicPrompts?: Maybe<AiTutorDynamicPromptQueries>;
  /** Asset video queries. */
  assetVideoQueries?: Maybe<AssetVideo_Queries>;
  /** Branch item–specific queries. */
  branchItem: BranchItemQueries;
  /** CoachAsyncTaskQueries */
  coachAsyncTask?: Maybe<CoachAsyncTaskQueries>;
  /** CoachChatSessionQueries */
  coachChatSession?: Maybe<CoachChatSessionQueries>;
  /** DynamicPrompt queries for AI Coach */
  coachDynamicPrompts?: Maybe<DynamicPromptQueries>;
  /** CoachMemoryQueries */
  coachMemory?: Maybe<CoachMemoryQueries>;
  /** CoachSpeechQueries */
  coachSpeech?: Maybe<CoachSpeechQueries>;
  /** CoachUserSettingQueries */
  coachUserSetting?: Maybe<CoachUserSettingQueries>;
  /** TODO: Complete this description */
  commentQueries?: Maybe<ItemPublishComments_CommentsQueries>;
  /** Query to fetch course credits for the current user with pagination support */
  courseCredits: CourseCredit_PaginatedResult;
  /** Get payment receipt information for an enterprise contract purchase by cart ID */
  enterpriseContractPaymentReceipt?: Maybe<EnterpriseContract_PaymentReceipt>;
  /** EnterpriseMessages: all queries belonging to EnterpriseMessages */
  enterpriseMessages?: Maybe<EnterpriseMessagesQueries>;
  /** Export item feedback queries. */
  exportItemFeedbackQueries?: Maybe<ExportItemFeedback_Queries>;
  /**
   * Find and return the PreEnrollment matching the given criteria or null if not found.
   * If `includeIncomplete`, then include PAYMENT_WALLET_CAPTURE PreEnrollments that are missing a PaymentWalletId.
   */
  findUserProductPreEnrollment?: Maybe<UserProductPreEnrollment>;
  /**
   * Returns all the PreEnrollment products, filtered by the underlyingProductItemId and/or product pre-enrollment state if supplied.
   * Otherwise returns all the products eligible for pre-enrollment.
   */
  getPreEnrollmentProducts: Array<PreEnrollmentProduct>;
  /** Return the PreEnrollment matching the given id. */
  getUserProductPreEnrollment: UserProductPreEnrollment;
  /** LevelSetAttempts Queries */
  levelSetAttempts?: Maybe<LevelSetAttemptsQueries>;
  /** LevelSetContent Queries */
  levelSetContent?: Maybe<LevelSetContentQueries>;
  /** LevelSets Queries */
  levelSets?: Maybe<LevelSetQueries>;
  /** Low Stakes Learning Queries */
  lowStakesLearning?: Maybe<LowStakesLearningQueries>;
  /** Queries related to a Payment Taxes. */
  paymentTaxes?: Maybe<PaymentTaxesQueries>;
  /** Trimming range queries. */
  trimmingRangeQueries?: Maybe<TrimmingRange_Queries>;
  /**
   * Return all the PreEnrollments, filtered by PreEnrollmentType if supplied.
   * If `includeIncomplete`, then include PAYMENT_WALLET_CAPTURE PreEnrollments that are missing a PaymentWalletId.
   */
  userProductPreEnrollments: Array<UserProductPreEnrollment>;
};


/** Root Query type */
export type QueryAssessmentGeneration_GetAssessmentGenerationParametersArgs = {
  assessmentGenerationId: Scalars['ID'];
};


/** Root Query type */
export type QueryAssessmentGeneration_GetAssessmentGenerationStatusArgs = {
  input: AssessmentGeneration_GetAssessmentGenerationStatusInput;
};


/** Root Query type */
export type QueryAssessmentGenerator_GenerationStateArgs = {
  courseId: Scalars['ID'];
  generationRequestId: Scalars['ID'];
};


/** Root Query type */
export type QueryAssessmentGenerator_GenerationStateByAssessmentIdArgs = {
  assessmentId: Scalars['ID'];
  courseId: Scalars['ID'];
};


/** Root Query type */
export type QueryEntTransaction_GetEnterpriseContractPurchaseOrderArgs = {
  id: Scalars['ID'];
};


/** Root Query type */
export type QueryEntTransaction_GetEnterpriseContractPurchaseOrdersByContractIdArgs = {
  contractId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** Root Query type */
export type QueryLocalization_StatsigExperimentExistsForConfigurationArgs = {
  contentType: Scalars['String'];
  experimentConfiguration: Localization_ExperimentConfiguration;
};


/** Root Query type */
export type QueryLocalization_StatsigExperimentsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Root Query type */
export type QueryQuestionGenerator_GenerationStateArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  generationRequestId: Scalars['ID'];
  questionTypes?: InputMaybe<Array<QuestionGenerator_QuestionType>>;
};


/** Root Query type */
export type QueryQuestionGenerator_RequestsByBranchArgs = {
  authoringBranchId: Scalars['ID'];
  courseId: Scalars['ID'];
  questionBankIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Root Query type */
export type QueryQuestionGenerator_SourceContentIdentifiersArgs = {
  questionBankId: Scalars['ID'];
};


/** Root Query type */
export type QueryCourseCreditsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeExpired?: Scalars['Boolean'];
  limit?: Scalars['Int'];
};


/** Root Query type */
export type QueryEnterpriseContractPaymentReceiptArgs = {
  cartId: Scalars['ID'];
};


/** Root Query type */
export type QueryFindUserProductPreEnrollmentArgs = {
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  productItemId: Scalars['String'];
  productType: PreEnrollment_ProductType;
  userId: Scalars['Int'];
};


/** Root Query type */
export type QueryGetPreEnrollmentProductsArgs = {
  state?: InputMaybe<PreEnrollment_PreEnrollmentProductState>;
  underlyingProductItemId?: InputMaybe<Scalars['ID']>;
  underlyingProductType?: InputMaybe<PreEnrollment_ProductType>;
};


/** Root Query type */
export type QueryGetUserProductPreEnrollmentArgs = {
  preEnrollmentId: Scalars['String'];
};


/** Root Query type */
export type QueryUserProductPreEnrollmentsArgs = {
  includeIncomplete?: InputMaybe<Scalars['Boolean']>;
  preEnrollmentType?: InputMaybe<PreEnrollmentType>;
};

/** All queries related to Question Bank Cascading Publish Transactions */
export type QuestionBankCascadingPublishTransactionsQueries = {
  __typename?: 'QuestionBankCascadingPublishTransactionsQueries';
  /** Retrieve the transaction with the given id */
  queryById?: Maybe<QuestionBank_CascadingPublishTransactionWithValidation>;
};


/** All queries related to Question Bank Cascading Publish Transactions */
export type QuestionBankCascadingPublishTransactionsQueriesQueryByIdArgs = {
  transactionId: Scalars['ID'];
};

/** All queries related to Question bank summaries */
export type QuestionBankDraftSummariesQueries = {
  __typename?: 'QuestionBankDraftSummariesQueries';
  /** Get all question banks summaries in the course */
  course?: Maybe<QuestionBank_QuestionBankSummaryPaginatedResult>;
  /** Get a summary of a question bank */
  get?: Maybe<QuestionBank_QuestionBankSummary>;
};


/** All queries related to Question bank summaries */
export type QuestionBankDraftSummariesQueriesCourseArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  includeEmbedded?: Scalars['Boolean'];
  limit?: Scalars['Int'];
};


/** All queries related to Question bank summaries */
export type QuestionBankDraftSummariesQueriesGetArgs = {
  questionBankId: Scalars['ID'];
  requestingCourseId?: InputMaybe<Scalars['ID']>;
};

/** All queries related to published question bank summaries */
export type QuestionBankSummariesQueries = {
  __typename?: 'QuestionBankSummariesQueries';
  /** Get for a specific version */
  getByVersion: QuestionBank_PublishedQuestionBankSummary;
  /** Get for latest version */
  getLatest: QuestionBank_PublishedQuestionBankSummary;
  /** Get latest question bank summary in course */
  latestInCourse: Array<QuestionBank_PublishedQuestionBankSummary>;
};


/** All queries related to published question bank summaries */
export type QuestionBankSummariesQueriesGetByVersionArgs = {
  questionBankId: Scalars['ID'];
  version: Scalars['Int'];
};


/** All queries related to published question bank summaries */
export type QuestionBankSummariesQueriesGetLatestArgs = {
  questionBankId: Scalars['ID'];
};


/** All queries related to published question bank summaries */
export type QuestionBankSummariesQueriesLatestInCourseArgs = {
  courseId: Scalars['ID'];
};

/** AI Graded text rubric */
export type QuestionBank_AiGradedTextRubric = {
  __typename?: 'QuestionBank_AIGradedTextRubric';
  /** ID */
  id: Scalars['ID'];
  /** How much this rubric is worth */
  points: Scalars['Float'];
  /** Instructions for this option for the grader */
  prompt: Scalars['String'];
};

/** AI Graded text rubric */
export type QuestionBank_AiGradedTextRubricInput = {
  /** ID */
  id: Scalars['ID'];
  /** How much this rubric is worth */
  points: Scalars['Float'];
  /** Instructions for this option for the grader */
  prompt: Scalars['String'];
};

/** Validation for an AI graded text rubric */
export type QuestionBank_AiGradedTextRubricValidation = {
  __typename?: 'QuestionBank_AIGradedTextRubricValidation';
  /** Validation for the points value */
  points: QuestionBank_AtomicValidation;
  /** Validation for the rubric prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Authorization status for accessing the question bank */
export type QuestionBank_AccessAuthorization = QuestionBank_Authorized | QuestionBank_Unauthorized;

/** Input for adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add categories to */
  questionBankId: Scalars['ID'];
  /** The question categories to add. Duplicate categories will be rejected. */
  questionCategories: Array<QuestionBank_QuestionCategoryInput>;
};

/** Result of adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesResult = {
  __typename?: 'QuestionBank_AddQuestionCategoriesResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add categories to */
  questionBankId: Scalars['ID'];
  /** The question categories to add. Duplicate categories will be rejected. */
  questionCategories: Array<QuestionBank_QuestionCategoryInput>;
};

/** Result of adding question categories to a question bank draft */
export type QuestionBank_AddQuestionCategoriesV2Result = {
  __typename?: 'QuestionBank_AddQuestionCategoriesV2Result';
  /** The categories that were added */
  addedCategories: Array<QuestionBank_AddedQuestionCategory>;
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
};

/** Input for adding questions to a question bank draft */
export type QuestionBank_AddQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add questions to */
  questionBankId: Scalars['ID'];
  /** The questions to add */
  questions: Array<QuestionBank_MachineEvaluableQuestionInput>;
};

/** Result of adding questions to a question bank draft */
export type QuestionBank_AddQuestionsResult = {
  __typename?: 'QuestionBank_AddQuestionsResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for adding questions to a question bank draft */
export type QuestionBank_AddQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to add questions to */
  questionBankId: Scalars['ID'];
  /** The questions to add */
  questions: Array<QuestionBank_MachineEvaluableQuestionInputV2>;
};

/** Result of adding questions to a question bank draft */
export type QuestionBank_AddQuestionsV2Result = {
  __typename?: 'QuestionBank_AddQuestionsV2Result';
  /** The questions that were added */
  addedQuestions: Array<QuestionBank_AddedQuestion>;
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
};

/** A question added to the question bank, returned by V2 add and merge mutations */
export type QuestionBank_AddedQuestion = {
  __typename?: 'QuestionBank_AddedQuestion';
  /** The added question along with its validation state */
  question: QuestionBank_QuestionBankQuestionWithValidationV2;
  /** The ID of the added question */
  questionId: Scalars['ID'];
};

/** A question category added to the question bank */
export type QuestionBank_AddedQuestionCategory = {
  __typename?: 'QuestionBank_AddedQuestionCategory';
  /** The ID of the added question category */
  categoryId: Scalars['ID'];
  /** The added question category */
  questionCategory: QuestionBank_QuestionCategory;
};

/** A change that added a new question category to the question bank */
export type QuestionBank_AddedQuestionCategoryChange = {
  __typename?: 'QuestionBank_AddedQuestionCategoryChange';
  /** The ID of the added question category */
  id: Scalars['ID'];
  /** The added question category */
  questionCategory: QuestionBank_QuestionCategory;
};

/** A change that added a new question to the question bank */
export type QuestionBank_AddedQuestionChange = {
  __typename?: 'QuestionBank_AddedQuestionChange';
  /** The ID of the added question */
  id: Scalars['ID'];
  /** The added question along with its validation state */
  question: QuestionBank_QuestionBankQuestionWithValidation;
};

/** Information about an AI author */
export type QuestionBank_AiAuthor = {
  __typename?: 'QuestionBank_AiAuthor';
  /** The batch ID for the generation */
  batchId: Scalars['ID'];
  /** The AI model used to generate content */
  model: Scalars['String'];
};

/** AI Graded options rubric */
export type QuestionBank_AiGradedOptionsRubric = {
  __typename?: 'QuestionBank_AiGradedOptionsRubric';
  /** ID */
  id: Scalars['ID'];
  /** Instructions for this option for the grader */
  options: Array<QuestionBank_AiGradedOptionsRubricOption>;
  /** A description of the rubric to be provided to the AI */
  prompt: Scalars['String'];
};

/** AI Graded options rubric */
export type QuestionBank_AiGradedOptionsRubricInput = {
  /** ID */
  id: Scalars['ID'];
  /** Instructions for this option for the grader */
  options: Array<QuestionBank_AiGradedOptionsRubricOptionInput>;
  /** A description of the rubric to be provided to the AI */
  prompt: Scalars['String'];
};

/** AI Graded options rubric option */
export type QuestionBank_AiGradedOptionsRubricOption = {
  __typename?: 'QuestionBank_AiGradedOptionsRubricOption';
  /** Instructions for this option for the grader */
  description: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** How much this option is worth */
  points: Scalars['Float'];
};

/** AI Graded options rubric option */
export type QuestionBank_AiGradedOptionsRubricOptionInput = {
  /** Instructions for this option for the grader */
  description: Scalars['String'];
  /** ID */
  id: Scalars['ID'];
  /** How much this option is worth */
  points: Scalars['Float'];
};

/** Validation for an AI graded options rubric option */
export type QuestionBank_AiGradedOptionsRubricOptionValidation = {
  __typename?: 'QuestionBank_AiGradedOptionsRubricOptionValidation';
  /** Validation for the option description */
  description: QuestionBank_AtomicValidation;
  /** Validation for the option points value */
  points: QuestionBank_AtomicValidation;
};

/** Validation for an AI graded options rubric */
export type QuestionBank_AiGradedOptionsRubricValidation = {
  __typename?: 'QuestionBank_AiGradedOptionsRubricValidation';
  /** Validations for each rubric option */
  options: Array<QuestionBank_AiGradedOptionsRubricOptionValidation>;
  /** Validation for the rubric prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** AI Graded rubrics */
export type QuestionBank_AiGradedRubric = QuestionBank_AiGradedTextRubric | QuestionBank_AiGradedOptionsRubric;

/** AI Graded Rubrics for open ended questions */
export type QuestionBank_AiGradedRubricInput = {
  /** AI Graded options rubric */
  optionsRubric?: InputMaybe<QuestionBank_AiGradedOptionsRubricInput>;
  /** AI Graded text rubric */
  textRubric?: InputMaybe<QuestionBank_AiGradedTextRubricInput>;
};

/** Union of all possible AI graded rubric validation types */
export type QuestionBank_AiGradedRubricValidation = QuestionBank_AiGradedTextRubricValidation | QuestionBank_AiGradedOptionsRubricValidation | QuestionBank_AiGradedRubricsPresenceValidation;

/**
 * Validation for the presence of AI graded rubrics on a question. Surfaced as an
 * element of the rubric validations list when a question has no rubrics.
 */
export type QuestionBank_AiGradedRubricsPresenceValidation = {
  __typename?: 'QuestionBank_AiGradedRubricsPresenceValidation';
  /** Validation for whether at least one rubric is present */
  presence: QuestionBank_AtomicValidation;
};

/** Indicates which types of files are allowed to be uploaded for the file upload question */
export const QuestionBank_AllowedFileUploadType = {
  /** All file types are allowed */
  All: 'ALL',
  /** Audio files of certain extensions are allowed */
  Audio: 'AUDIO',
  /** Coding files of certain extensions are allowed */
  Coding: 'CODING',
  /** Image files of certain extensions are allowed */
  Image: 'IMAGE',
  /** Text files of certain extensions are allowed */
  Text: 'TEXT',
  /** Video files of certain extensions are allowed */
  Video: 'VIDEO'
} as const;

export type QuestionBank_AllowedFileUploadType = typeof QuestionBank_AllowedFileUploadType[keyof typeof QuestionBank_AllowedFileUploadType];
/** Atomic validation */
export type QuestionBank_AtomicValidation = QuestionBank_GenericValidation | QuestionBank_IntRangeValidation | QuestionBank_NumericRangeValidation | QuestionBank_TextLengthValidation | QuestionBank_WordCountValidation;

/** Union representing either AI-generated or human-authored content */
export type QuestionBank_Author = QuestionBank_AiAuthor | QuestionBank_HumanAuthor;

/** Content container for course branch items */
export type QuestionBank_AuthoringCourseBranchItemContainer = {
  __typename?: 'QuestionBank_AuthoringCourseBranchItemContainer';
  /** Authoring branch id */
  authoringBranchId: Scalars['ID'];
  /** The item id in the branch */
  itemId: Scalars['ID'];
};

/** A single change applied to a question bank */
export type QuestionBank_AuthoringQuestionBankChange = QuestionBank_AddedQuestionCategoryChange | QuestionBank_AddedQuestionChange | QuestionBank_NameChange | QuestionBank_RemovedQuestionCategoryChange | QuestionBank_RemovedQuestionChange | QuestionBank_UpdatedQuestionCategoryChange | QuestionBank_UpdatedQuestionChange;

/** Authoring metadata of question bank */
export type QuestionBank_AuthoringQuestionBankMetadata = {
  __typename?: 'QuestionBank_AuthoringQuestionBankMetadata';
  /** Timestamp when the question bank was created */
  createdAt: Scalars['DateTime'];
  /** ID of the user who created the question bank */
  createdBy?: Maybe<Scalars['Int']>;
  /** Published versioned question bank ID */
  publishedId?: Maybe<QuestionBank_VersionedQuestionBankId>;
  /** Timestamp when the question bank was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** ID of the user who last updated the question bank */
  updatedBy?: Maybe<Scalars['Int']>;
};

/** Authoring metadata of question bank */
export type QuestionBank_AuthoringQuestionBankMetadataInput = {
  /** Timestamp when the question bank was created */
  createdAt: Scalars['DateTime'];
  /** ID of the user who created the question bank */
  createdBy?: InputMaybe<Scalars['Int']>;
  /** Published versioned question bank ID */
  publishedId?: InputMaybe<QuestionBank_VersionedQuestionBankIdInput>;
  /** Timestamp when the question bank was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** ID of the user who last updated the question bank */
  updatedBy?: InputMaybe<Scalars['Int']>;
};

/** The state of a question bank after a mutation, together with a description of each change applied */
export type QuestionBank_AuthoringQuestionBankResponse = {
  __typename?: 'QuestionBank_AuthoringQuestionBankResponse';
  /** The list of individual changes applied to the question bank by the mutation */
  changes: Array<QuestionBank_AuthoringQuestionBankChange>;
  /** The updated authoring metadata of the question bank */
  metadata?: Maybe<QuestionBank_AuthoringQuestionBankMetadata>;
};

/** Reasons for unauthorized access to the question bank */
export const QuestionBank_AuthorizationReasonEnum = {
  /** Question bank is used by at least one assignment. This reason is just for 'delete a QB' case */
  ActivelyInUse: 'ACTIVELY_IN_USE',
  /** Authorized access */
  Authorized: 'AUTHORIZED',
  /** Question bank is embedded */
  Embedded: 'EMBEDDED',
  /** Insufficient access rights */
  InsufficientAccess: 'INSUFFICIENT_ACCESS'
} as const;

export type QuestionBank_AuthorizationReasonEnum = typeof QuestionBank_AuthorizationReasonEnum[keyof typeof QuestionBank_AuthorizationReasonEnum];
/** Authorized access to the question bank */
export type QuestionBank_Authorized = {
  __typename?: 'QuestionBank_Authorized';
  /** Reason for authorization */
  reason: QuestionBank_AuthorizationReasonEnum;
};

/** Input for creating a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionCreateInput = {
  /** The authoring metadata for the question bank being published. */
  authoringMetadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to be published. */
  questionBankId: Scalars['ID'];
};

/** Result of a cascading publish transaction including validation details */
export type QuestionBank_CascadingPublishTransactionCreateResult = {
  __typename?: 'QuestionBank_CascadingPublishTransactionCreateResult';
  /** An optional error message if the transaction failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The ID of the question bank being published. */
  questionBankId: Scalars['ID'];
  /** The current status of the cascading publish transaction. */
  status: QuestionBank_CascadingPublishTransactionStatus;
  /** The ID of the created transaction */
  transactionId?: Maybe<Scalars['ID']>;
  /** The validation results for the question bank and its questions before publishing. */
  validation: QuestionBank_CascadingPublishValidation;
};

/** Input for executing a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionExecuteInput = {
  /** The ID of the cascading publish transaction to execute. */
  transactionId: Scalars['ID'];
};

/** Result of executing a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionExecuteResult = {
  __typename?: 'QuestionBank_CascadingPublishTransactionExecuteResult';
  /** An optional error message if the transaction failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The ID of the question bank being published. */
  questionBankId: Scalars['ID'];
  /** The current status of the cascading publish transaction. */
  status: QuestionBank_CascadingPublishTransactionStatus;
  /** The validation results for the question bank and its questions after execution. */
  validation: QuestionBank_CascadingPublishValidation;
};

/** Input for proposing a question block update within a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateInput = {
  /** The ID of the question block to update. */
  questionBlockId: Scalars['ID'];
  /** The proposed question configuration for the question block. */
  questionConfiguration: QuestionBlock_QuestionConfigurationInput;
  /** The proposed selection criteria for the question block. */
  selectionCriteria: QuestionBlock_SelectionCriteriaInput;
  /** The ID of the cascading publish transaction to update. */
  transactionId: Scalars['ID'];
};

/** Result of proposing a question block update for a cascading publish transaction */
export type QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateResult = {
  __typename?: 'QuestionBank_CascadingPublishTransactionProposeQuestionBlockUpdateResult';
  /** An optional error message if the transaction failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The ID of the question bank being published. */
  questionBankId: Scalars['ID'];
  /** The current status of the cascading publish transaction. */
  status: QuestionBank_CascadingPublishTransactionStatus;
  /** The validation results for the question bank and its questions after the proposed update. */
  validation: QuestionBank_CascadingPublishValidation;
};

/** Status of a cascading publish transaction */
export const QuestionBank_CascadingPublishTransactionStatus = {
  /** The transaction has completed publishing the question bank and its questions. */
  Completed: 'COMPLETED',
  /** The transaction has failed to publish the question bank and its questions. */
  Failed: 'FAILED',
  /** The transaction is currently publishing the question bank and its questions. */
  Running: 'RUNNING',
  /** The transaction is validating the question bank and its questions before publishing. */
  Validating: 'VALIDATING'
} as const;

export type QuestionBank_CascadingPublishTransactionStatus = typeof QuestionBank_CascadingPublishTransactionStatus[keyof typeof QuestionBank_CascadingPublishTransactionStatus];
/** Question Bank Cascading Publish Transaction with Validation */
export type QuestionBank_CascadingPublishTransactionWithValidation = {
  __typename?: 'QuestionBank_CascadingPublishTransactionWithValidation';
  /** An optional error message if the transaction failed. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The ID of the question bank being published. */
  questionBankId: Scalars['ID'];
  /** The current status of the cascading publish transaction. */
  status: QuestionBank_CascadingPublishTransactionStatus;
  /** The validation results for the question bank and its questions before publishing. */
  validation: QuestionBank_CascadingPublishValidation;
};

/** Validation results for a cascading publish of a question bank and its related content */
export type QuestionBank_CascadingPublishValidation = {
  __typename?: 'QuestionBank_CascadingPublishValidation';
  /** Whether the question bank and all related content are ready for publish */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation result for the question bank draft itself */
  questionBankDraftValidation: QuestionBank_QuestionBankDraftValidation;
  /** Validation results for each related content item linked to the question bank */
  relationsWithValidation: Array<QuestionBank_QuestionBankRelationWithValidation>;
};

/** Definition for checkbox question type */
export type QuestionBank_CheckboxQuestionDefinition = {
  __typename?: 'QuestionBank_CheckboxQuestionDefinition';
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOption>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox question definition */
export type QuestionBank_CheckboxQuestionDefinitionInput = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox question definition */
export type QuestionBank_CheckboxQuestionDefinitionInputV2 = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Definition for checkbox question type */
export type QuestionBank_CheckboxQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_CheckboxQuestionDefinitionV2';
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** IDs of the correct options */
  correctOptionIds: Array<Scalars['ID']>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Validation for checkbox question type */
export type QuestionBank_CheckboxQuestionValidation = {
  __typename?: 'QuestionBank_CheckboxQuestionValidation';
  /** Validations for the correct options */
  correctOptions: Array<QuestionBank_AtomicValidation>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for the question options */
  options: Array<QuestionBank_DisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for checkbox question type */
export type QuestionBank_CheckboxQuestionValidationV2 = {
  __typename?: 'QuestionBank_CheckboxQuestionValidationV2';
  /** Validations for the correct options */
  correctOptionIds: Array<QuestionBank_AtomicValidation>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for the question options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Definition for checkbox reflection question type */
export type QuestionBank_CheckboxReflectQuestionDefinition = {
  __typename?: 'QuestionBank_CheckboxReflectQuestionDefinition';
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOption>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflection question definition */
export type QuestionBank_CheckboxReflectQuestionDefinitionInput = {
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a checkbox reflection question definition */
export type QuestionBank_CheckboxReflectQuestionDefinitionInputV2 = {
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Definition for checkbox reflection question type */
export type QuestionBank_CheckboxReflectQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_CheckboxReflectQuestionDefinitionV2';
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Validation for checkbox reflection question type */
export type QuestionBank_CheckboxReflectQuestionValidation = {
  __typename?: 'QuestionBank_CheckboxReflectQuestionValidation';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for the question options */
  options: Array<QuestionBank_DisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for checkbox reflection question type */
export type QuestionBank_CheckboxReflectQuestionValidationV2 = {
  __typename?: 'QuestionBank_CheckboxReflectQuestionValidationV2';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for the question options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Definition for code expression question type */
export type QuestionBank_CodeExpressionQuestionDefinition = {
  __typename?: 'QuestionBank_CodeExpressionQuestionDefinition';
  /** Programming language for the code */
  codeLanguage: Scalars['String'];
  /** Identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Optional identifier for the REPL evaluator */
  replEvaluatorId?: Maybe<Scalars['ID']>;
  /** Initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Input for a code expression question definition */
export type QuestionBank_CodeExpressionQuestionDefinitionInput = {
  /** The programming language for the code */
  codeLanguage: Scalars['String'];
  /** The identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** The optional identifier for the REPL evaluator */
  replEvaluatorId?: InputMaybe<Scalars['ID']>;
  /** The initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Input for a code expression question definition */
export type QuestionBank_CodeExpressionQuestionDefinitionInputV2 = {
  /** The programming language for the code */
  codeLanguage: Scalars['String'];
  /** The identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** The optional identifier for the REPL evaluator */
  replEvaluatorId?: InputMaybe<Scalars['ID']>;
  /** The initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Definition for code expression question type */
export type QuestionBank_CodeExpressionQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_CodeExpressionQuestionDefinitionV2';
  /** Programming language for the code */
  codeLanguage: Scalars['String'];
  /** Identifier for the code evaluator */
  evaluatorId: Scalars['ID'];
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Optional identifier for the REPL evaluator */
  replEvaluatorId?: Maybe<Scalars['ID']>;
  /** Initial code provided to the learner */
  starterCode: Scalars['String'];
};

/** Validation for code expression question type */
export type QuestionBank_CodeExpressionQuestionValidation = {
  __typename?: 'QuestionBank_CodeExpressionQuestionValidation';
  /** Validation for the code evaluator ID */
  evaluatorId: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validation for the REPL evaluator ID */
  replEvaluatorId: QuestionBank_AtomicValidation;
};

/** Validation for code expression question type */
export type QuestionBank_CodeExpressionQuestionValidationV2 = {
  __typename?: 'QuestionBank_CodeExpressionQuestionValidationV2';
  /** Validation for the code evaluator ID */
  evaluatorId: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validation for the REPL evaluator ID */
  replEvaluatorId: QuestionBank_AtomicValidation;
};

/** Union type ContentContainer, content could be course branch items, etc */
export type QuestionBank_ContentContainer = QuestionBank_AuthoringCourseBranchItemContainer;

/** Input for creating question bank draft */
export type QuestionBank_CreateDraftInput = {
  /** Name of the question bank */
  name: Scalars['String'];
  /** Scope of the question bank */
  scope: QuestionBank_Scope;
  /** Source of the question bank */
  source: QuestionBank_QuestionBankSource;
};

/** Result of creating question bank draft */
export type QuestionBank_CreateDraftResult = {
  __typename?: 'QuestionBank_CreateDraftResult';
  /** Question bank id */
  id: Scalars['ID'];
  /** Metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
};

/** Overview of the questions' tagged difficulty levels */
export type QuestionBank_DifficultyLevelsOverview = {
  __typename?: 'QuestionBank_DifficultyLevelsOverview';
  /** All difficulty levels tagged for the questions in the question bank */
  assignedDifficultyLevels: Array<QuestionBlock_DifficultyLevel>;
  /** Whether or not there are questions that are not tagged with any difficulty level */
  hasUnassignedQuestions: Scalars['Boolean'];
};

/** Validation for a display option */
export type QuestionBank_DisplayOptionValidation = {
  __typename?: 'QuestionBank_DisplayOptionValidation';
  /** Validation for the display text */
  display?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the feedback */
  feedback?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the option ID */
  id?: Maybe<QuestionBank_AtomicValidation>;
};

/** Definition for file upload question type */
export type QuestionBank_FileUploadQuestionDefinition = {
  __typename?: 'QuestionBank_FileUploadQuestionDefinition';
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubric>;
};

/** Input for a file upload question definition */
export type QuestionBank_FileUploadQuestionDefinitionInput = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Input for a file upload question definition */
export type QuestionBank_FileUploadQuestionDefinitionInputV2 = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Definition for file upload question type */
export type QuestionBank_FileUploadQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_FileUploadQuestionDefinitionV2';
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubric>;
};

/** Validation for file upload question type */
export type QuestionBank_FileUploadQuestionValidation = {
  __typename?: 'QuestionBank_FileUploadQuestionValidation';
  /** Validation for allowedFiles */
  allowedFiles: Array<QuestionBank_AllowedFileUploadType>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for file upload question type */
export type QuestionBank_FileUploadQuestionValidationV2 = {
  __typename?: 'QuestionBank_FileUploadQuestionValidationV2';
  /** Validation for allowedFiles */
  allowedFiles: Array<QuestionBank_AtomicValidation>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validations for the AI graded rubrics */
  rubrics: Array<QuestionBank_AiGradedRubricValidation>;
};

/** Generic validation */
export type QuestionBank_GenericValidation = {
  __typename?: 'QuestionBank_GenericValidation';
  /** Error message if the field is invalid */
  message?: Maybe<Scalars['String']>;
  /** Validation status */
  status: QuestionBank_ValidationStatus;
};

/** Information about a human author */
export type QuestionBank_HumanAuthor = {
  __typename?: 'QuestionBank_HumanAuthor';
  /** User ID of the human author */
  userId: Scalars['ID'];
};

/** Integer range validation */
export type QuestionBank_IntRangeValidation = {
  __typename?: 'QuestionBank_IntRangeValidation';
  /** Actual value */
  actual: Scalars['Int'];
  /** Whether the maximum value is included */
  includeMax?: Maybe<Scalars['Boolean']>;
  /** Whether the minimum value is included */
  includeMin?: Maybe<Scalars['Boolean']>;
  /** Maximum value */
  max?: Maybe<Scalars['Int']>;
  /** Error message if the field is invalid */
  message?: Maybe<Scalars['String']>;
  /** Minimum value */
  min?: Maybe<Scalars['Int']>;
  /** Validation status */
  status: QuestionBank_ValidationStatus;
};

/** Input for linking question bank to a scope */
export type QuestionBank_LinkInput = {
  /** Question bank id to link */
  questionBankId: Scalars['ID'];
  /** Scope to link the question bank to */
  scope: QuestionBank_Scope;
};

/** Result of linking question bank */
export type QuestionBank_LinkResult = {
  __typename?: 'QuestionBank_LinkResult';
  /** Question bank id that was linked */
  questionBankId: Scalars['ID'];
};

/** A machine evaluable question with metadata */
export type QuestionBank_MachineEvaluableQuestion = {
  __typename?: 'QuestionBank_MachineEvaluableQuestion';
  /** Author who created the question */
  createdByAuthor?: Maybe<QuestionBank_Author>;
  /** Definition of the question containing type-specific details */
  definition: QuestionBank_QuestionDefinition;
  /** Difficulty level of the question (EASY, MEDIUM, HARD) */
  difficultyLevel?: Maybe<QuestionBank_QuestionDifficultyLevel>;
  /** Category of the question */
  questionCategory?: Maybe<Scalars['String']>;
  /** Author who last updated the question */
  updatedByAuthor?: Maybe<QuestionBank_Author>;
};

/** Input for a machine evaluable question (without an ID, used when creating new questions) */
export type QuestionBank_MachineEvaluableQuestionInput = {
  /** The question definition, specifying the question type and its content */
  definition: QuestionBank_QuestionDefinitionInput;
  /** Optional difficulty level of the question */
  difficultyLevel?: InputMaybe<QuestionBank_QuestionDifficultyLevel>;
  /** Optional mastery level of the question */
  masteryLevel?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** Optional ID of the question category assigned to this question */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
};

/** Input for a machine evaluable question (without an ID, used when creating new questions) */
export type QuestionBank_MachineEvaluableQuestionInputV2 = {
  /** The question definition, specifying the question type and its content */
  definition: QuestionBank_QuestionDefinitionInputV2;
  /** Optional difficulty level of the question */
  difficultyLevel?: InputMaybe<QuestionBank_QuestionDifficultyLevel>;
  /** Optional mastery level of the question */
  masteryLevel?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** Optional ID of the question category assigned to this question */
  questionCategoryId?: InputMaybe<Scalars['ID']>;
};

/** A machine evaluable question with metadata */
export type QuestionBank_MachineEvaluableQuestionV2 = {
  __typename?: 'QuestionBank_MachineEvaluableQuestionV2';
  /** Timestamp when the question was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Author who created the question */
  createdByAuthor?: Maybe<QuestionBank_Author>;
  /** Definition of the question containing type-specific details */
  definition: QuestionBank_QuestionDefinitionV2;
  /** Difficulty level of the question (EASY, MEDIUM, HARD) */
  difficultyLevel?: Maybe<QuestionBank_QuestionDifficultyLevel>;
  /** ID of the Question Category */
  questionCategory?: Maybe<Scalars['ID']>;
  /** Timestamp when the question was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Author who last updated the question */
  updatedByAuthor?: Maybe<QuestionBank_Author>;
};

/** Union of all possible question validation types based on question type */
export type QuestionBank_MachineEvaluableQuestionValidation = QuestionBank_CheckboxQuestionValidation | QuestionBank_CheckboxReflectQuestionValidation | QuestionBank_CodeExpressionQuestionValidation | QuestionBank_FileUploadQuestionValidation | QuestionBank_MathExpressionQuestionValidation | QuestionBank_MultipleChoiceQuestionValidation | QuestionBank_MultipleChoiceReflectQuestionValidation | QuestionBank_MultipleFillableBlanksQuestionValidation | QuestionBank_NumericQuestionValidation | QuestionBank_RegexQuestionValidationMessage | QuestionBank_RichTextQuestionValidation | QuestionBank_TextExactMatchQuestionValidation | QuestionBank_TextReflectQuestionValidation | QuestionBank_WidgetQuestionValidation;

/** Union of all possible question validation types based on question type */
export type QuestionBank_MachineEvaluableQuestionValidationV2 = QuestionBank_CheckboxQuestionValidationV2 | QuestionBank_CheckboxReflectQuestionValidationV2 | QuestionBank_CodeExpressionQuestionValidationV2 | QuestionBank_FileUploadQuestionValidationV2 | QuestionBank_MathExpressionQuestionValidationV2 | QuestionBank_MultipleChoiceQuestionValidationV2 | QuestionBank_MultipleChoiceReflectQuestionValidationV2 | QuestionBank_MultipleFillableBlanksQuestionValidationV2 | QuestionBank_NumericQuestionValidationV2 | QuestionBank_RegexQuestionValidationMessageV2 | QuestionBank_RichTextQuestionValidationV2 | QuestionBank_TextExactMatchQuestionValidationV2 | QuestionBank_TextReflectQuestionValidationV2 | QuestionBank_WidgetQuestionValidationV2;

/** Overview of mastery levels tagged for the questions in the question bank */
export type QuestionBank_MasteryLevelsOverview = {
  __typename?: 'QuestionBank_MasteryLevelsOverview';
  /** Question mastery levels used to select Questions */
  assignedMasteryLevels: Array<QuestionBlock_MasteryLevel>;
  /** Whether or not there are questions that not tagged with any mastery level */
  hasUnassignedQuestions: Scalars['Boolean'];
};

/** Input for a math expression answer with its expression string and feedback */
export type QuestionBank_MathExpressionAnswerInputV2 = {
  /** The mathematical expression string (e.g. LaTeX) */
  answer: Scalars['String'];
  /** The feedback to show for this answer */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** A math expression answer with its expression string and feedback */
export type QuestionBank_MathExpressionAnswerV2 = {
  __typename?: 'QuestionBank_MathExpressionAnswerV2';
  /** The mathematical expression string (e.g. LaTeX) */
  answer: Scalars['String'];
  /** Feedback to show for this answer */
  feedback: Cml_Cml;
  /** Unique identifier for this answer */
  id: Scalars['ID'];
};

/** Definition for math expression question type */
export type QuestionBank_MathExpressionQuestionDefinition = {
  __typename?: 'QuestionBank_MathExpressionQuestionDefinition';
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_TextContent;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContent;
  /** Incorrect possible answers for display */
  incorrectPossibleAnswers: Array<QuestionBank_TextContent>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
};

/** Input for a math expression question definition */
export type QuestionBank_MathExpressionQuestionDefinitionInput = {
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_TextContentInput;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContentInput;
  /** Incorrect possible answers to display as distractors */
  incorrectPossibleAnswers: Array<QuestionBank_TextContentInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a math expression question definition */
export type QuestionBank_MathExpressionQuestionDefinitionInputV2 = {
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_MathExpressionAnswerInputV2;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_CmlInput;
  /** Incorrect possible answers to display as distractors */
  incorrectPossibleAnswers: Array<QuestionBank_MathExpressionAnswerInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Definition for math expression question type */
export type QuestionBank_MathExpressionQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_MathExpressionQuestionDefinitionV2';
  /** The correct mathematical expression answer */
  correctAnswer: QuestionBank_MathExpressionAnswerV2;
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_Cml;
  /** Incorrect possible answers for display */
  incorrectPossibleAnswers: Array<QuestionBank_MathExpressionAnswerV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
};

/** Validation for math expression question type */
export type QuestionBank_MathExpressionQuestionValidation = {
  __typename?: 'QuestionBank_MathExpressionQuestionValidation';
  /** Validation for the correct answer */
  correctAnswer: QuestionBank_DisplayOptionValidation;
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Validations for incorrect possible answers */
  incorrectPossibleAnswers: Array<QuestionBank_DisplayOptionValidation>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for math expression question type */
export type QuestionBank_MathExpressionQuestionValidationV2 = {
  __typename?: 'QuestionBank_MathExpressionQuestionValidationV2';
  /** Validation for the correct answer */
  correctAnswer: QuestionBank_QuestionDisplayOptionValidation;
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Validations for incorrect possible answers */
  incorrectPossibleAnswers: Array<QuestionBank_QuestionDisplayOptionValidation>;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Input for merging questions into a question bank draft. Questions with matching IDs are updated; questions without a matching ID are added as new. */
export type QuestionBank_MergeQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to merge questions into */
  questionBankId: Scalars['ID'];
  /** The questions to merge */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdInput>;
};

/** Result of merging questions into a question bank draft */
export type QuestionBank_MergeQuestionsResult = {
  __typename?: 'QuestionBank_MergeQuestionsResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for merging questions into a question bank draft. Questions with matching IDs are updated; questions without a matching ID are added as new. */
export type QuestionBank_MergeQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to merge questions into */
  questionBankId: Scalars['ID'];
  /** The questions to merge */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdV2Input>;
};

/** Result of merging questions into a question bank draft */
export type QuestionBank_MergeQuestionsV2Result = {
  __typename?: 'QuestionBank_MergeQuestionsV2Result';
  /** The questions that were added */
  addedQuestions: Array<QuestionBank_AddedQuestion>;
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The questions that were updated */
  updatedQuestions: Array<QuestionBank_UpdatedQuestion>;
};

/** A fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlank = {
  __typename?: 'QuestionBank_MultipleChoiceFillableBlank';
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** Unique identifier for the blank */
  id: Scalars['ID'];
  /** Options available for this blank */
  options: Array<QuestionBank_QuestionOption>;
};

/** Input for a fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlankInput = {
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** The unique identifier for this blank */
  id: Scalars['ID'];
  /** The options available for this blank */
  options: Array<QuestionBank_QuestionOptionInput>;
};

/** Input for a fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlankInputV2 = {
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** The unique identifier for this blank */
  id: Scalars['ID'];
  /** The options available for this blank */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
};

/** A fillable blank in a multiple choice fillable blanks question */
export type QuestionBank_MultipleChoiceFillableBlankV2 = {
  __typename?: 'QuestionBank_MultipleChoiceFillableBlankV2';
  /** The correct option for this blank */
  correctOption: Scalars['String'];
  /** Unique identifier for the blank */
  id: Scalars['ID'];
  /** Options available for this blank */
  options: Array<QuestionBank_QuestionDisplayOptionV2>;
};

/** Validation for a multiple choice fillable blank */
export type QuestionBank_MultipleChoiceFillableBlankValidation = {
  __typename?: 'QuestionBank_MultipleChoiceFillableBlankValidation';
  /** Validation for the correct option */
  correctOption: QuestionBank_AtomicValidation;
  /** Validation for the blank's ID */
  id: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_DisplayOptionValidation>;
};

/** Validation for a multiple choice fillable blank */
export type QuestionBank_MultipleChoiceFillableBlankValidationV2 = {
  __typename?: 'QuestionBank_MultipleChoiceFillableBlankValidationV2';
  /** Validation for the correct option */
  correctOption: QuestionBank_AtomicValidation;
  /** Validation for the blank's ID */
  id: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
};

/** Definition for multiple choice question type */
export type QuestionBank_MultipleChoiceQuestionDefinition = {
  __typename?: 'QuestionBank_MultipleChoiceQuestionDefinition';
  /** ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContent;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOption>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice question definition */
export type QuestionBank_MultipleChoiceQuestionDefinitionInput = {
  /** The ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContentInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice question definition */
export type QuestionBank_MultipleChoiceQuestionDefinitionInputV2 = {
  /** The ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback: Cml_CmlInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Definition for multiple choice question type */
export type QuestionBank_MultipleChoiceQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_MultipleChoiceQuestionDefinitionV2';
  /** ID of the correct option */
  correctOptionId: Scalars['ID'];
  /** Feedback to show when no option is chosen */
  noChosenFeedback?: Maybe<Cml_Cml>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Validation for multiple choice question type */
export type QuestionBank_MultipleChoiceQuestionValidation = {
  __typename?: 'QuestionBank_MultipleChoiceQuestionValidation';
  /** Validation for the correct option */
  correctOption: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no option is chosen */
  noChosenFeedback: QuestionBank_AtomicValidation;
  /** Validations for the question options */
  options: Array<QuestionBank_DisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for multiple choice question type */
export type QuestionBank_MultipleChoiceQuestionValidationV2 = {
  __typename?: 'QuestionBank_MultipleChoiceQuestionValidationV2';
  /** Validation for the correct option */
  correctOptionId: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no option is chosen */
  noChosenFeedback: QuestionBank_AtomicValidation;
  /** Validations for the question options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Definition for multiple choice reflection question type */
export type QuestionBank_MultipleChoiceReflectQuestionDefinition = {
  __typename?: 'QuestionBank_MultipleChoiceReflectQuestionDefinition';
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContent;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOption>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflection question definition */
export type QuestionBank_MultipleChoiceReflectQuestionDefinitionInput = {
  /** Feedback to show when no option is chosen */
  noChosenFeedback: QuestionBank_TextContentInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple choice reflection question definition */
export type QuestionBank_MultipleChoiceReflectQuestionDefinitionInputV2 = {
  /** Feedback to show when no option is chosen */
  noChosenFeedback: Cml_CmlInput;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options when presenting the question */
  shuffleOptions: Scalars['Boolean'];
};

/** Definition for multiple choice reflection question type */
export type QuestionBank_MultipleChoiceReflectQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_MultipleChoiceReflectQuestionDefinitionV2';
  /** Feedback to show when no option is chosen */
  noChosenFeedback?: Maybe<Cml_Cml>;
  /** The options available for selection */
  options: Array<QuestionBank_QuestionDisplayOptionV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Whether to shuffle the options */
  shuffleOptions: Scalars['Boolean'];
};

/** Validation for multiple choice reflection question type */
export type QuestionBank_MultipleChoiceReflectQuestionValidation = {
  __typename?: 'QuestionBank_MultipleChoiceReflectQuestionValidation';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no option is chosen */
  noChosenFeedback: QuestionBank_AtomicValidation;
  /** Validations for the question options */
  options: Array<QuestionBank_DisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for multiple choice reflection question type */
export type QuestionBank_MultipleChoiceReflectQuestionValidationV2 = {
  __typename?: 'QuestionBank_MultipleChoiceReflectQuestionValidationV2';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no option is chosen */
  noChosenFeedback: QuestionBank_AtomicValidation;
  /** Validations for the question options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Definition for multiple fillable blanks question type */
export type QuestionBank_MultipleFillableBlanksQuestionDefinition = {
  __typename?: 'QuestionBank_MultipleFillableBlanksQuestionDefinition';
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlank>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: QuestionBank_TextContent;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple fillable blanks question definition */
export type QuestionBank_MultipleFillableBlanksQuestionDefinitionInput = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlankInput>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Input for a multiple fillable blanks question definition */
export type QuestionBank_MultipleFillableBlanksQuestionDefinitionInputV2 = {
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlankInputV2>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Definition for multiple fillable blanks question type */
export type QuestionBank_MultipleFillableBlanksQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_MultipleFillableBlanksQuestionDefinitionV2';
  /** Whether to give partial credit for partially correct answers */
  allowPartialScoring: Scalars['Boolean'];
  /** The fillable blanks in the question */
  multipleChoiceFillableBlanks: Array<QuestionBank_MultipleChoiceFillableBlankV2>;
  /** Feedback to show when no answer is provided */
  notAnswerFeedback: Cml_Cml;
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Whether to shuffle the options for each blank */
  shuffleOptions: Scalars['Boolean'];
};

/** Validation for multiple fillable blanks question type */
export type QuestionBank_MultipleFillableBlanksQuestionValidation = {
  __typename?: 'QuestionBank_MultipleFillableBlanksQuestionValidation';
  /** Validation for the number of blanks in the question */
  blankCount: QuestionBank_AtomicValidation;
  /** Validation to ensure each blank has a unique ID */
  blankIdUniqueness: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for each multiple choice fillable blank */
  multipleChoiceFillableBlankValidations: Array<QuestionBank_MultipleChoiceFillableBlankValidation>;
  /** Validation for feedback when no answer is provided */
  notAnswerFeedback: QuestionBank_AtomicValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for multiple fillable blanks question type */
export type QuestionBank_MultipleFillableBlanksQuestionValidationV2 = {
  __typename?: 'QuestionBank_MultipleFillableBlanksQuestionValidationV2';
  /** Validation for the number of blanks in the question */
  blankCount: QuestionBank_AtomicValidation;
  /** Validation to ensure each blank has a unique ID */
  blankIdUniqueness: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validations for each multiple choice fillable blank */
  multipleChoiceFillableBlankValidations: Array<QuestionBank_MultipleChoiceFillableBlankValidationV2>;
  /** Validation for feedback when no answer is provided */
  notAnswerFeedback: QuestionBank_AtomicValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** A change that updated the name of the question bank */
export type QuestionBank_NameChange = {
  __typename?: 'QuestionBank_NameChange';
  /** The new name of the question bank */
  name: Scalars['String'];
};

/** A possible numeric answer with feedback */
export type QuestionBank_NumericAnswer = {
  __typename?: 'QuestionBank_NumericAnswer';
  /** The numeric value or range that is considered correct */
  answer: QuestionBank_NumericAnswerValue;
  /** Feedback to show when this answer is matched */
  feedback: QuestionBank_TextContent;
  /** Unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a possible numeric answer with feedback */
export type QuestionBank_NumericAnswerInput = {
  /** The numeric value or range considered correct */
  answer: QuestionBank_NumericAnswerValueInput;
  /** The feedback to show when this answer is matched */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** Input for a possible numeric answer with feedback */
export type QuestionBank_NumericAnswerInputV2 = {
  /** The numeric value or range considered correct */
  answer: QuestionBank_NumericAnswerValueInputV2;
  /** The feedback to show when this answer is matched */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** A possible numeric answer with feedback */
export type QuestionBank_NumericAnswerV2 = {
  __typename?: 'QuestionBank_NumericAnswerV2';
  /** The numeric value or range that is considered correct */
  answer: QuestionBank_NumericAnswerValue;
  /** Feedback to show when this answer is matched */
  feedback: Cml_Cml;
  /** Unique identifier for this answer */
  id: Scalars['ID'];
};

/** Union of single value or range value for numeric answers */
export type QuestionBank_NumericAnswerValue = QuestionBank_RangeNumericAnswerValue | QuestionBank_SingleNumericAnswerValue;

/** Input for a numeric answer value. Exactly one field must be provided. */
export type QuestionBank_NumericAnswerValueInput = {
  /** A range of acceptable numeric values */
  rangeValue?: InputMaybe<QuestionBank_RangeNumericAnswerValueInput>;
  /** A single exact numeric value */
  singleValue?: InputMaybe<QuestionBank_SingleNumericAnswerValueInput>;
};

/** Input for a numeric answer value. Exactly one field must be provided. */
export type QuestionBank_NumericAnswerValueInputV2 = {
  /** A range of acceptable numeric values */
  rangeValue?: InputMaybe<QuestionBank_RangeNumericAnswerValueInputV2>;
  /** A single exact numeric value */
  singleValue?: InputMaybe<QuestionBank_SingleNumericAnswerValueInputV2>;
};

/** Validation for numeric answer options */
export type QuestionBank_NumericOptionsValidation = {
  __typename?: 'QuestionBank_NumericOptionsValidation';
  /** Validation for the correct answers */
  correctAnswers: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_DisplayOptionValidation>;
};

/** Validation for numeric answer options */
export type QuestionBank_NumericOptionsValidationV2 = {
  __typename?: 'QuestionBank_NumericOptionsValidationV2';
  /** Validation for the correct answers */
  correctAnswers: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
};

/** Definition for numeric question type */
export type QuestionBank_NumericQuestionDefinition = {
  __typename?: 'QuestionBank_NumericQuestionDefinition';
  /** Possible numeric answers with feedback */
  answer: Array<QuestionBank_NumericAnswer>;
  /** IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback for responses */
  defaultFeedback: QuestionBank_TextContent;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
};

/** Input for a numeric question definition */
export type QuestionBank_NumericQuestionDefinitionInput = {
  /** The possible numeric answers with their feedback */
  answer: Array<QuestionBank_NumericAnswerInput>;
  /** The IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a numeric question definition */
export type QuestionBank_NumericQuestionDefinitionInputV2 = {
  /** The possible numeric answers with their feedback */
  answer: Array<QuestionBank_NumericAnswerInputV2>;
  /** The IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Definition for numeric question type */
export type QuestionBank_NumericQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_NumericQuestionDefinitionV2';
  /** Possible numeric answers with feedback */
  answer: Array<QuestionBank_NumericAnswerV2>;
  /** IDs of the correct numeric answers */
  correctAnswerIds: Array<Scalars['ID']>;
  /** Default feedback for responses */
  defaultFeedback: Cml_Cml;
  /** The question prompt text */
  prompt: Cml_Cml;
};

/** Validation for numeric question type */
export type QuestionBank_NumericQuestionValidation = {
  __typename?: 'QuestionBank_NumericQuestionValidation';
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for possible numeric answers */
  possibleAnswer: QuestionBank_NumericOptionsValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for numeric question type */
export type QuestionBank_NumericQuestionValidationV2 = {
  __typename?: 'QuestionBank_NumericQuestionValidationV2';
  /** Validation for possible numeric answers */
  answer: QuestionBank_NumericOptionsValidationV2;
  /** Validation for default feedback */
  defaultFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Numeric range validation */
export type QuestionBank_NumericRangeValidation = {
  __typename?: 'QuestionBank_NumericRangeValidation';
  /** Actual value */
  actual: Scalars['Float'];
  /** Whether the maximum value is included */
  includeMax?: Maybe<Scalars['Boolean']>;
  /** Whether the minimum value is included */
  includeMin?: Maybe<Scalars['Boolean']>;
  /** Maximum value */
  max?: Maybe<Scalars['Float']>;
  /** Error message if the field is invalid */
  message?: Maybe<Scalars['String']>;
  /** Minimum value */
  min?: Maybe<Scalars['Float']>;
  /** Validation status */
  status: QuestionBank_ValidationStatus;
};

/** A question in a published question bank */
export type QuestionBank_PublishedQuestionBankQuestion = {
  __typename?: 'QuestionBank_PublishedQuestionBankQuestion';
  /** The machine evaluable question data */
  question: QuestionBank_MachineEvaluableQuestion;
  /** Question bank question id */
  questionBankQuestionId: Scalars['ID'];
};

/** Paginated result containing published question bank questions */
export type QuestionBank_PublishedQuestionBankQuestionPaginatedResult = {
  __typename?: 'QuestionBank_PublishedQuestionBankQuestionPaginatedResult';
  /** List of published question bank questions */
  elements: Array<QuestionBank_PublishedQuestionBankQuestion>;
  /** Pagination information */
  pagination: Pagination;
};

/** Paginated result containing published question bank questions with V2 question types */
export type QuestionBank_PublishedQuestionBankQuestionPaginatedResultV2 = {
  __typename?: 'QuestionBank_PublishedQuestionBankQuestionPaginatedResultV2';
  /** List of published question bank questions */
  elements: Array<QuestionBank_PublishedQuestionBankQuestionV2>;
  /** Pagination information */
  pagination: Pagination;
};

/** A question in a published question bank */
export type QuestionBank_PublishedQuestionBankQuestionV2 = {
  __typename?: 'QuestionBank_PublishedQuestionBankQuestionV2';
  /** The machine evaluable question data */
  question: QuestionBank_MachineEvaluableQuestionV2;
  /** Question bank question id */
  questionBankQuestionId: Scalars['ID'];
};

/** Question bank summary for the published model */
export type QuestionBank_PublishedQuestionBankSummary = {
  __typename?: 'QuestionBank_PublishedQuestionBankSummary';
  /**
   * Indicate if the questions in the question bank are up-to-date to the published version, if yes
   * then it's searchable
   */
  areQuestionsSearchable: Scalars['Boolean'];
  /** Content using this question bank; could be embedded content or native content */
  contentUsingThisQuestionBank: Array<QuestionBank_QuestionBankUsageInContent>;
  /** Overview of the questions' tagged difficulty levels */
  difficultyLevelsOverview: QuestionBank_DifficultyLevelsOverview;
  /** Question Bank ID */
  id: Scalars['ID'];
  /** Question Bank name */
  name: Scalars['String'];
  /** Number of questions existing in the Question Bank */
  numberOfQuestions: Scalars['Int'];
  /** Source of the question bank, e.g. generated by AI (COPILOT) or authored by a human (AUTHOR) */
  questionBankSource?: Maybe<QuestionBank_QuestionBankSource>;
  /** An overview of the question categories in the bank, including assigned and unassigned. */
  questionCategoriesOverview: QuestionBank_QuestionCategoriesOverview;
  /** Optional version of the question bank */
  version?: Maybe<Scalars['Int']>;
};

/**
 * Whether the question bank is viewable/editable/deletable/duplicable in the course by
 * requesting user
 */
export type QuestionBank_QuestionBankAccess = {
  __typename?: 'QuestionBank_QuestionBankAccess';
  /** Authorization for deleting the question bank */
  delete: QuestionBank_AccessAuthorization;
  /** Authorization for downloading questions from the question bank */
  downloadQuestions: QuestionBank_AccessAuthorization;
  /** Authorization for duplicating the question bank */
  duplicate: QuestionBank_AccessAuthorization;
  /** Authorization for editing the question bank */
  edit: QuestionBank_AccessAuthorization;
  /** Authorization for viewing the question bank */
  view: QuestionBank_AccessAuthorization;
};

/** Validation result for a question bank draft */
export type QuestionBank_QuestionBankDraftValidation = {
  __typename?: 'QuestionBank_QuestionBankDraftValidation';
  /** Whether all questions in the question bank draft are valid */
  allQuestionsAreValid: Scalars['Boolean'];
};

/** Embedded content (e.g. question blocks) using this question bank, e.g. through course builder */
export type QuestionBank_QuestionBankEmbedUsage = {
  __typename?: 'QuestionBank_QuestionBankEmbedUsage';
  /** Authoring atom ID of the content using this question bank */
  authoringAtomId: Scalars['ID'];
  /** The container of this content, e.g. a course branch item */
  contentContainer: QuestionBank_ContentContainer;
  /** Name of the content using this question bank */
  contentName: Scalars['String'];
  /** Whether the content is graded */
  isGraded: Scalars['Boolean'];
  /** Whether or not this content allows team submission */
  isTeamSubmissionEnabled: Scalars['Boolean'];
};

/** Native content (e.g. question blocks) using this question bank */
export type QuestionBank_QuestionBankNativeUsage = {
  __typename?: 'QuestionBank_QuestionBankNativeUsage';
  /** Authoring atom ID of the content using this question bank */
  authoringAtomId: Scalars['ID'];
  /** The container of this content, e.g. a course branch item */
  contentContainers: Array<QuestionBank_ContentContainer>;
  /** Name of the content using this question bank */
  contentName: Scalars['String'];
  /** Whether the content is graded */
  isGraded: Scalars['Boolean'];
  /** Whether or not this content allows team submission */
  isTeamSubmissionEnabled: Scalars['Boolean'];
  /** Question blocks in the content using this Question bank */
  questionBlocks: Array<QuestionBank_QuestionBlockDraftWithValidation>;
};

/** A question from a question bank */
export type QuestionBank_QuestionBankQuestion = {
  __typename?: 'QuestionBank_QuestionBankQuestion';
  /** The question ID */
  id: Scalars['ID'];
  /** The machine-evaluable question content */
  question: QuestionBank_MachineEvaluableQuestion;
};

/** Input for a question bank question with its ID (used when updating or merging existing questions) */
export type QuestionBank_QuestionBankQuestionWithIdInput = {
  /** The ID of the question to update */
  id: Scalars['ID'];
  /** The updated question definition */
  question: QuestionBank_MachineEvaluableQuestionInput;
};

/** Input for a question bank question with its ID (used when updating or merging existing questions with V2 question types) */
export type QuestionBank_QuestionBankQuestionWithIdV2Input = {
  /** The ID of the question to update */
  id: Scalars['ID'];
  /** The updated question definition */
  question: QuestionBank_MachineEvaluableQuestionInputV2;
};

/** A question in the question bank along with its validation status */
export type QuestionBank_QuestionBankQuestionWithValidation = {
  __typename?: 'QuestionBank_QuestionBankQuestionWithValidation';
  /** When the question was added to the question bank */
  addedAt: Scalars['DateTime'];
  /** The machine evaluable question data */
  question: QuestionBank_MachineEvaluableQuestion;
  /** Question bank question id */
  questionBankQuestionId: Scalars['ID'];
  /** When the question was last updated */
  updatedAt: Scalars['DateTime'];
  /** Validation results for the question */
  validation: QuestionBank_MachineEvaluableQuestionValidation;
};

/** Paginated result containing question bank questions with validation information */
export type QuestionBank_QuestionBankQuestionWithValidationPaginatedResult = {
  __typename?: 'QuestionBank_QuestionBankQuestionWithValidationPaginatedResult';
  /** List of question bank questions with validation information */
  elements: Array<QuestionBank_QuestionBankQuestionWithValidation>;
  /** Pagination information */
  pagination: Pagination;
};

/** Paginated result containing question bank questions with V2 question types and validation information */
export type QuestionBank_QuestionBankQuestionWithValidationPaginatedResultV2 = {
  __typename?: 'QuestionBank_QuestionBankQuestionWithValidationPaginatedResultV2';
  /** List of question bank questions with validation information */
  elements: Array<QuestionBank_QuestionBankQuestionWithValidationV2>;
  /** Pagination information */
  pagination: Pagination;
};

/** A question in the question bank along with its validation status */
export type QuestionBank_QuestionBankQuestionWithValidationV2 = {
  __typename?: 'QuestionBank_QuestionBankQuestionWithValidationV2';
  /** When the question was added to the question bank */
  addedAt: Scalars['DateTime'];
  /** The machine evaluable question data */
  question: QuestionBank_MachineEvaluableQuestionV2;
  /** Question bank question id */
  questionBankQuestionId: Scalars['ID'];
  /** When the question was last updated */
  updatedAt: Scalars['DateTime'];
  /** Validation results for the question */
  validation: QuestionBank_MachineEvaluableQuestionValidationV2;
};

/** A content item related to the question bank along with its validation results */
export type QuestionBank_QuestionBankRelationWithValidation = {
  __typename?: 'QuestionBank_QuestionBankRelationWithValidation';
  /** Containers within the related content that reference the question bank */
  contentContainers: Array<QuestionBank_ContentContainer>;
  /** ID of the related content item */
  contentId: Scalars['ID'];
  /** Name of the related content item */
  contentName: Scalars['String'];
  /** Whether the related content is graded */
  isGraded: Scalars['Boolean'];
  /** Whether team submission is enabled for the related content */
  isTeamSubmissionEnabled: Scalars['Boolean'];
  /** Question blocks from the related content with their authoring data */
  questionBlocks: Array<QuestionBank_QuestionBlockAuthoringDataWithId>;
};

/** Source of question bank */
export const QuestionBank_QuestionBankSource = {
  /** Question bank authored by a human (AUTHOR) */
  Author: 'AUTHOR',
  /** Question bank generated by AI (COPILOT) */
  Copilot: 'COPILOT'
} as const;

export type QuestionBank_QuestionBankSource = typeof QuestionBank_QuestionBankSource[keyof typeof QuestionBank_QuestionBankSource];
/** Question bank summary model */
export type QuestionBank_QuestionBankSummary = {
  __typename?: 'QuestionBank_QuestionBankSummary';
  /**
   * Whether the question bank is viewable/editable/deletable/duplicable in the course by
   * requesting user
   */
  accessInContext: QuestionBank_QuestionBankAccess;
  /**
   * Indicate if the questions in the question bank are up-to-date to the published version, if yes
   * then it's searchable
   */
  areQuestionsSearchable: Scalars['Boolean'];
  /** Content using this question bank; could be embedded content or native content */
  contentUsingThisQuestionBank: Array<QuestionBank_QuestionBankUsageInContent>;
  /** Overview of the questions' tagged difficulty levels */
  difficultyLevelsOverview: QuestionBank_DifficultyLevelsOverview;
  /** Optional embedSourceCourseId, is only present for embedded question bank summary */
  embedSourceCourse?: Maybe<Course_Course>;
  /** Question Bank ID */
  id: Scalars['ID'];
  /** Whether the question bank is published */
  isPublished: Scalars['Boolean'];
  /** Overview of mastery levels tagged for the questions in the question bank */
  masteryLevelsOverview: QuestionBank_MasteryLevelsOverview;
  /** Authoring metadata of question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** Question Bank name */
  name: Scalars['String'];
  /** Number of questions existing in the Question Bank */
  numberOfQuestions: Scalars['Int'];
  /** Source of the question bank, e.g. generated by AI (COPILOT) or authored by a human (AUTHOR) */
  questionBankSource?: Maybe<QuestionBank_QuestionBankSource>;
  /** Overview of the questions' tagged question categories */
  questionCategoriesOverview: QuestionBank_QuestionCategoriesOverview;
  /** QuestionBankAuthoringScope where the question bank is available, e.g. courses (CourseScope) */
  scopes: Array<Scalars['String']>;
  /** Optional version of the question bank */
  version?: Maybe<Scalars['Int']>;
};

/** Paginated result of question bank summaries */
export type QuestionBank_QuestionBankSummaryPaginatedResult = {
  __typename?: 'QuestionBank_QuestionBankSummaryPaginatedResult';
  /** List of elements in the page */
  elements: Array<QuestionBank_QuestionBankSummary>;
  /** Pagination metadata */
  pagination: Pagination;
};

/**
 * Content using this question bank; could be embedded content or native
 * content
 */
export type QuestionBank_QuestionBankUsageInContent = QuestionBank_QuestionBankEmbedUsage | QuestionBank_QuestionBankNativeUsage;

/** Authoring data for a question block including its draft, validation, and sample questions */
export type QuestionBank_QuestionBlockAuthoringData = {
  __typename?: 'QuestionBank_QuestionBlockAuthoringData';
  /** Number of questions available in the question bank matching the block's selection criteria */
  numberOfQuestionsAvailable?: Maybe<Scalars['Int']>;
  /** The question block draft content */
  questionBlockDraft: QuestionBlock_QuestionBlockDraft;
  /** Sample questions drawn from the question bank for preview */
  sampleQuestions: Array<QuestionBank_QuestionBankQuestion>;
  /** Validation results for the question block draft */
  validation: QuestionBank_QuestionBlockDraftValidation;
};

/** A question block's authoring data paired with its identifier */
export type QuestionBank_QuestionBlockAuthoringDataWithId = {
  __typename?: 'QuestionBank_QuestionBlockAuthoringDataWithId';
  /** The authoring data for this question block */
  authoringData: QuestionBank_QuestionBlockAuthoringData;
  /** The question block ID */
  id: Scalars['ID'];
};

/** Question block validation */
export type QuestionBank_QuestionBlockDraftValidation = {
  __typename?: 'QuestionBank_QuestionBlockDraftValidation';
  /** Whether the question block is ready for publish, i.e. passes all validations */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for question bank id */
  questionBankId: QuestionBank_AtomicValidation;
  /** Validation for question configuration */
  questionConfiguration: QuestionBank_QuestionConfigurationValidation;
  /** Validation for selection criteria */
  selectionCriteria: QuestionBank_SelectionCriteriaValidation;
};

/** Question Block Draft With Validation */
export type QuestionBank_QuestionBlockDraftWithValidation = {
  __typename?: 'QuestionBank_QuestionBlockDraftWithValidation';
  /** Whether the question block is published */
  isPublished: Scalars['Boolean'];
  /**
   * As long as a Question Block has valid selection criteria, we show users the total number of
   * available questions.
   */
  numberOfAvailableQuestions?: Maybe<Scalars['Int']>;
  /** Question bank id associated with the question block */
  questionBankId?: Maybe<Scalars['ID']>;
  /** Question block id */
  questionBlockId: Scalars['ID'];
  /** Question configuration */
  questionConfiguration: QuestionBlock_QuestionConfiguration;
  /** Question selection criteria */
  selectionCriteria: QuestionBlock_SelectionCriteria;
  /** Updated at timestamp */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Updated by user */
  updatedBy?: Maybe<Scalars['ID']>;
  /** Question block validation */
  validation: QuestionBank_QuestionBlockDraftValidation;
};

/** Overview of the questions' tagged question categories */
export type QuestionBank_QuestionCategoriesOverview = {
  __typename?: 'QuestionBank_QuestionCategoriesOverview';
  /** Summaries of the questions' tagged question categories in the Question bank */
  questionCategoriesSummaries: Array<QuestionBank_QuestionCategorySummary>;
  /** Number of questions that are not tagged with any question category */
  unassignedQuestionsCount: Scalars['Int'];
};

/** A question category with just its name */
export type QuestionBank_QuestionCategory = {
  __typename?: 'QuestionBank_QuestionCategory';
  /** The name of the question category */
  name: Scalars['String'];
};

/** Input for a question category (without an ID, used when creating new categories) */
export type QuestionBank_QuestionCategoryInput = {
  /** The name of the question category */
  name: Scalars['String'];
};

/** Summary of the questions' tagged question categories */
export type QuestionBank_QuestionCategorySummary = {
  __typename?: 'QuestionBank_QuestionCategorySummary';
  /** Question Category Id */
  questionCategoryId: Scalars['ID'];
  /** Question Category Name */
  questionCategoryName: Scalars['String'];
  /** Number of questions tagged with this question category */
  taggedQuestionsCount: Scalars['Int'];
};

/** Input for a question category with its ID (used when updating existing categories) */
export type QuestionBank_QuestionCategoryWithIdInput = {
  /** The ID of the question category to update */
  id: Scalars['ID'];
  /** The updated name of the question category */
  name: Scalars['String'];
};

/** Validation for question configuration */
export type QuestionBank_QuestionConfigurationValidation = {
  __typename?: 'QuestionBank_QuestionConfigurationValidation';
  /** Validation for points per question */
  points: QuestionBank_AtomicValidation;
};

/** Union of all possible question definition types based on question type */
export type QuestionBank_QuestionDefinition = QuestionBank_CheckboxQuestionDefinition | QuestionBank_CheckboxReflectQuestionDefinition | QuestionBank_CodeExpressionQuestionDefinition | QuestionBank_FileUploadQuestionDefinition | QuestionBank_MathExpressionQuestionDefinition | QuestionBank_MultipleChoiceQuestionDefinition | QuestionBank_MultipleChoiceReflectQuestionDefinition | QuestionBank_MultipleFillableBlanksQuestionDefinition | QuestionBank_NumericQuestionDefinition | QuestionBank_RegexQuestionDefinition | QuestionBank_RichTextQuestionDefinition | QuestionBank_TextExactMatchQuestionDefinition | QuestionBank_TextReflectQuestionDefinition | QuestionBank_WidgetQuestionDefinition;

/** Input for a question definition. Exactly one field must be provided. */
export type QuestionBank_QuestionDefinitionInput = {
  /** A checkbox question */
  checkbox?: InputMaybe<QuestionBank_CheckboxQuestionDefinitionInput>;
  /** A checkbox reflection question */
  checkboxReflect?: InputMaybe<QuestionBank_CheckboxReflectQuestionDefinitionInput>;
  /** A code expression question */
  codeExpression?: InputMaybe<QuestionBank_CodeExpressionQuestionDefinitionInput>;
  /** File Upload */
  fileUpload?: InputMaybe<QuestionBank_FileUploadQuestionDefinitionInput>;
  /** A math expression question */
  mathExpression?: InputMaybe<QuestionBank_MathExpressionQuestionDefinitionInput>;
  /** A multiple choice question */
  multipleChoice?: InputMaybe<QuestionBank_MultipleChoiceQuestionDefinitionInput>;
  /** A multiple choice reflection question */
  multipleChoiceReflect?: InputMaybe<QuestionBank_MultipleChoiceReflectQuestionDefinitionInput>;
  /** A multiple fillable blanks question */
  multipleFillableBlanks?: InputMaybe<QuestionBank_MultipleFillableBlanksQuestionDefinitionInput>;
  /** A numeric question */
  numeric?: InputMaybe<QuestionBank_NumericQuestionDefinitionInput>;
  /** A regex question */
  regex?: InputMaybe<QuestionBank_RegexQuestionDefinitionInput>;
  /** Rich Text Question */
  richText?: InputMaybe<QuestionBank_RichTextQuestionDefinitionInput>;
  /** A text exact match question */
  textExactMatch?: InputMaybe<QuestionBank_TextExactMatchQuestionDefinitionInput>;
  /** A text reflection question */
  textReflect?: InputMaybe<QuestionBank_TextReflectQuestionDefinitionInput>;
  /** A widget question */
  widget?: InputMaybe<QuestionBank_WidgetQuestionDefinitionInput>;
};

/** Input for a question definition. Exactly one field must be provided. */
export type QuestionBank_QuestionDefinitionInputV2 = {
  /** A checkbox question */
  checkbox?: InputMaybe<QuestionBank_CheckboxQuestionDefinitionInputV2>;
  /** A checkbox reflection question */
  checkboxReflect?: InputMaybe<QuestionBank_CheckboxReflectQuestionDefinitionInputV2>;
  /** A code expression question */
  codeExpression?: InputMaybe<QuestionBank_CodeExpressionQuestionDefinitionInputV2>;
  /** File Upload */
  fileUpload?: InputMaybe<QuestionBank_FileUploadQuestionDefinitionInputV2>;
  /** A math expression question */
  mathExpression?: InputMaybe<QuestionBank_MathExpressionQuestionDefinitionInputV2>;
  /** A multiple choice question */
  multipleChoice?: InputMaybe<QuestionBank_MultipleChoiceQuestionDefinitionInputV2>;
  /** A multiple choice reflection question */
  multipleChoiceReflect?: InputMaybe<QuestionBank_MultipleChoiceReflectQuestionDefinitionInputV2>;
  /** A multiple fillable blanks question */
  multipleFillableBlanks?: InputMaybe<QuestionBank_MultipleFillableBlanksQuestionDefinitionInputV2>;
  /** A numeric question */
  numeric?: InputMaybe<QuestionBank_NumericQuestionDefinitionInputV2>;
  /** A regex question */
  regex?: InputMaybe<QuestionBank_RegexQuestionDefinitionInputV2>;
  /** Rich Text Question */
  richText?: InputMaybe<QuestionBank_RichTextQuestionDefinitionInputV2>;
  /** A text exact match question */
  textExactMatch?: InputMaybe<QuestionBank_TextExactMatchQuestionDefinitionInputV2>;
  /** A text reflection question */
  textReflect?: InputMaybe<QuestionBank_TextReflectQuestionDefinitionInputV2>;
  /** A widget question */
  widget?: InputMaybe<QuestionBank_WidgetQuestionDefinitionInputV2>;
};

/** Union of all possible question definition types based on question type */
export type QuestionBank_QuestionDefinitionV2 = QuestionBank_CheckboxQuestionDefinitionV2 | QuestionBank_CheckboxReflectQuestionDefinitionV2 | QuestionBank_CodeExpressionQuestionDefinitionV2 | QuestionBank_FileUploadQuestionDefinitionV2 | QuestionBank_MathExpressionQuestionDefinitionV2 | QuestionBank_MultipleChoiceQuestionDefinitionV2 | QuestionBank_MultipleChoiceReflectQuestionDefinitionV2 | QuestionBank_MultipleFillableBlanksQuestionDefinitionV2 | QuestionBank_NumericQuestionDefinitionV2 | QuestionBank_RegexQuestionDefinitionV2 | QuestionBank_RichTextQuestionDefinitionV2 | QuestionBank_TextExactMatchQuestionDefinitionV2 | QuestionBank_TextReflectQuestionDefinitionV2 | QuestionBank_WidgetQuestionDefinitionV2;

/** Difficulty levels for questions */
export const QuestionBank_QuestionDifficultyLevel = {
  /** Easy difficulty level */
  Easy: 'EASY',
  /** Hard difficulty level */
  Hard: 'HARD',
  /** Medium difficulty level */
  Medium: 'MEDIUM'
} as const;

export type QuestionBank_QuestionDifficultyLevel = typeof QuestionBank_QuestionDifficultyLevel[keyof typeof QuestionBank_QuestionDifficultyLevel];
/** Input for a question option with display text and feedback */
export type QuestionBank_QuestionDisplayOptionInputV2 = {
  /** The display text for this option */
  display: Cml_CmlInput;
  /** The feedback to show when this option is selected */
  feedback: Cml_CmlInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
};

/** An option in a question with display text and feedback */
export type QuestionBank_QuestionDisplayOptionV2 = {
  __typename?: 'QuestionBank_QuestionDisplayOptionV2';
  /** Display text for this option */
  display: Cml_Cml;
  /** Feedback to show when this option is selected */
  feedback: Cml_Cml;
  /** Unique identifier for this option */
  id: Scalars['ID'];
};

/** Validation for a display option */
export type QuestionBank_QuestionDisplayOptionValidation = {
  __typename?: 'QuestionBank_QuestionDisplayOptionValidation';
  /** Validation for the display text */
  display?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the feedback */
  feedback?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the option ID */
  id?: Maybe<QuestionBank_AtomicValidation>;
};

/** An option in a question with display text and feedback */
export type QuestionBank_QuestionOption = {
  __typename?: 'QuestionBank_QuestionOption';
  /** Display text for this option */
  display: QuestionBank_TextContent;
  /** Feedback to show when this option is selected */
  feedback: QuestionBank_TextContent;
  /** Unique identifier for this option */
  id: Scalars['ID'];
};

/** Input for a question option with display text and feedback. Exactly one of stringContent or cml must be provided for each text field. */
export type QuestionBank_QuestionOptionInput = {
  /** The display text for this option */
  display: QuestionBank_TextContentInput;
  /** The feedback to show when this option is selected */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
};

/** A range of numeric values that are considered correct */
export type QuestionBank_RangeNumericAnswerValue = {
  __typename?: 'QuestionBank_RangeNumericAnswerValue';
  /** The lower bound of the acceptable range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound itself is included in the range */
  lowerBoundInclusive: Scalars['Boolean'];
  /** The upper bound of the acceptable range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound itself is included in the range */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Input for a range of acceptable numeric answer values */
export type QuestionBank_RangeNumericAnswerValueInput = {
  /** The lower bound of the acceptable range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound itself is included in the range */
  lowerBoundInclusive: Scalars['Boolean'];
  /** The upper bound of the acceptable range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound itself is included in the range */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Input for a range of acceptable numeric answer values */
export type QuestionBank_RangeNumericAnswerValueInputV2 = {
  /** The lower bound of the acceptable range */
  lowerBound: Scalars['Float'];
  /** Whether the lower bound itself is included in the range */
  lowerBoundInclusive: Scalars['Boolean'];
  /** The upper bound of the acceptable range */
  upperBound: Scalars['Float'];
  /** Whether the upper bound itself is included in the range */
  upperBoundInclusive: Scalars['Boolean'];
};

/** Flags that can be applied to regex patterns */
export const QuestionBank_RegexFlag = {
  /** Makes the pattern case-insensitive */
  CaseInsensitive: 'CASE_INSENSITIVE',
  /** Makes . match newlines as well */
  Dotall: 'DOTALL',
  /** Enables multi-line mode where ^ and $ match start/end of lines */
  Multiline: 'MULTILINE'
} as const;

export type QuestionBank_RegexFlag = typeof QuestionBank_RegexFlag[keyof typeof QuestionBank_RegexFlag];
/** A regex pattern option for regex questions */
export type QuestionBank_RegexOption = {
  __typename?: 'QuestionBank_RegexOption';
  /** Feedback to show when this option is matched */
  feedback: QuestionBank_TextContent;
  /** Unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered correct */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPattern;
};

/** Input for a regex option with a pattern and feedback */
export type QuestionBank_RegexOptionInput = {
  /** The feedback to show when this pattern is matched */
  feedback: QuestionBank_TextContentInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered a correct answer */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPatternInput;
};

/** Input for a regex option with a pattern and feedback */
export type QuestionBank_RegexOptionInputV2 = {
  /** The feedback to show when this pattern is matched */
  feedback: Cml_CmlInput;
  /** The unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered a correct answer */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPatternInputV2;
};

/** A regex pattern option for regex questions */
export type QuestionBank_RegexOptionV2 = {
  __typename?: 'QuestionBank_RegexOptionV2';
  /** Feedback to show when this option is matched */
  feedback: Cml_Cml;
  /** Unique identifier for this option */
  id: Scalars['ID'];
  /** Whether this option is considered correct */
  isCorrect: Scalars['Boolean'];
  /** The regex pattern to match against */
  pattern: QuestionBank_RegexPattern;
};

/** Validation for regex answer options */
export type QuestionBank_RegexOptionsValidation = {
  __typename?: 'QuestionBank_RegexOptionsValidation';
  /** Validation for the correct answer */
  correctAnswer: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_DisplayOptionValidation>;
};

/** Validation for regex answer options */
export type QuestionBank_RegexOptionsValidationV2 = {
  __typename?: 'QuestionBank_RegexOptionsValidationV2';
  /** Validation for the correct answer */
  correctAnswer: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_QuestionDisplayOptionValidation>;
};

/** A regex pattern with flags for matching text */
export type QuestionBank_RegexPattern = {
  __typename?: 'QuestionBank_RegexPattern';
  /** Flags that modify how the pattern is applied */
  flags: Array<QuestionBank_RegexFlag>;
  /** The regex pattern string */
  value: Scalars['String'];
};

/** Input for a regex pattern with optional flags */
export type QuestionBank_RegexPatternInput = {
  /** Flags that modify how the pattern is applied */
  flags: Array<QuestionBank_RegexFlag>;
  /** The regex pattern string */
  value: Scalars['String'];
};

/** Input for a regex pattern with optional flags */
export type QuestionBank_RegexPatternInputV2 = {
  /** Flags that modify how the pattern is applied */
  flags: Array<QuestionBank_RegexFlag>;
  /** The regex pattern string */
  value: Scalars['String'];
};

/** Definition for regex question type */
export type QuestionBank_RegexQuestionDefinition = {
  __typename?: 'QuestionBank_RegexQuestionDefinition';
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContent;
  /** Possible regex pattern answers with feedback */
  possibleAnswers: Array<QuestionBank_RegexOption>;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
};

/** Input for a regex question definition */
export type QuestionBank_RegexQuestionDefinitionInput = {
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: QuestionBank_TextContentInput;
  /** The possible regex pattern answers with their feedback */
  possibleAnswers: Array<QuestionBank_RegexOptionInput>;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a regex question definition */
export type QuestionBank_RegexQuestionDefinitionInputV2 = {
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_CmlInput;
  /** The possible regex pattern answers with their feedback */
  possibleAnswers: Array<QuestionBank_RegexOptionInputV2>;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Definition for regex question type */
export type QuestionBank_RegexQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_RegexQuestionDefinitionV2';
  /** Default feedback for incorrect answers */
  defaultIncorrectFeedback: Cml_Cml;
  /** Possible regex pattern answers with feedback */
  possibleAnswers: Array<QuestionBank_RegexOptionV2>;
  /** The question prompt text */
  prompt: Cml_Cml;
};

/** Validation for regex question type */
export type QuestionBank_RegexQuestionValidationMessage = {
  __typename?: 'QuestionBank_RegexQuestionValidationMessage';
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for possible regex pattern answers */
  possibleAnswers: QuestionBank_RegexOptionsValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for regex question type */
export type QuestionBank_RegexQuestionValidationMessageV2 = {
  __typename?: 'QuestionBank_RegexQuestionValidationMessageV2';
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for possible regex pattern answers */
  possibleAnswers: QuestionBank_RegexOptionsValidationV2;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Input for removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove all questions from */
  questionBankId: Scalars['ID'];
};

/** Result of removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsResult = {
  __typename?: 'QuestionBank_RemoveAllQuestionsResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove all questions from */
  questionBankId: Scalars['ID'];
};

/** Result of removing all questions from a question bank draft */
export type QuestionBank_RemoveAllQuestionsV2Result = {
  __typename?: 'QuestionBank_RemoveAllQuestionsV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions that were removed */
  removedQuestionIds: Array<Scalars['ID']>;
};

/** Input for removing question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
export type QuestionBank_RemoveQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove categories from */
  questionBankId: Scalars['ID'];
  /** The IDs of the question categories to remove */
  questionCategoryIds: Array<Scalars['ID']>;
};

/** Result of removing question categories from a question bank draft */
export type QuestionBank_RemoveQuestionCategoriesResult = {
  __typename?: 'QuestionBank_RemoveQuestionCategoriesResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for removing question categories from a question bank draft. Also unassigns the removed categories from all questions in the draft. */
export type QuestionBank_RemoveQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove categories from */
  questionBankId: Scalars['ID'];
  /** The IDs of the question categories to remove */
  questionCategoryIds: Array<Scalars['ID']>;
};

/** Result of removing question categories from a question bank draft */
export type QuestionBank_RemoveQuestionCategoriesV2Result = {
  __typename?: 'QuestionBank_RemoveQuestionCategoriesV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The IDs of the categories that were removed */
  removedCategoryIds: Array<Scalars['ID']>;
};

/** Input for removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove questions from */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions to remove. All provided IDs must already exist in the draft. */
  questionIds: Array<Scalars['ID']>;
};

/** Result of removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsResult = {
  __typename?: 'QuestionBank_RemoveQuestionsResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank to remove questions from */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions to remove. All provided IDs must already exist in the draft. */
  questionIds: Array<Scalars['ID']>;
};

/** Result of removing specific questions from a question bank draft */
export type QuestionBank_RemoveQuestionsV2Result = {
  __typename?: 'QuestionBank_RemoveQuestionsV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The IDs of the questions that were removed */
  removedQuestionIds: Array<Scalars['ID']>;
};

/** A change that removed a question category from the question bank */
export type QuestionBank_RemovedQuestionCategoryChange = {
  __typename?: 'QuestionBank_RemovedQuestionCategoryChange';
  /** The ID of the removed question category */
  id: Scalars['ID'];
};

/** A change that removed a question from the question bank */
export type QuestionBank_RemovedQuestionChange = {
  __typename?: 'QuestionBank_RemovedQuestionChange';
  /** The ID of the removed question */
  id: Scalars['ID'];
};

/** Input for reverting a question bank */
export type QuestionBank_RevertDraftInput = {
  /** Metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** Question bank id to revert */
  questionBankId: Scalars['ID'];
};

/** Result of reverting a question bank */
export type QuestionBank_RevertDraftResult = {
  __typename?: 'QuestionBank_RevertDraftResult';
  /** Question bank id that was reverted */
  questionBankId: Scalars['ID'];
};

/** Definition for rich text question type */
export type QuestionBank_RichTextQuestionDefinition = {
  __typename?: 'QuestionBank_RichTextQuestionDefinition';
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubric>;
};

/** Input for a rich text question definition */
export type QuestionBank_RichTextQuestionDefinitionInput = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Input for a rich text question definition */
export type QuestionBank_RichTextQuestionDefinitionInputV2 = {
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubricInput>;
};

/** Definition for rich text question type */
export type QuestionBank_RichTextQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_RichTextQuestionDefinitionV2';
  /** Instructions sent to the AI grader, not visible to learners */
  aiGraderInstructions: Scalars['String'];
  /** The question prompt text */
  prompt: Cml_Cml;
  /** AI Graded Rubrics for this question */
  rubrics: Array<QuestionBank_AiGradedRubric>;
};

/** Validation for rich text question type */
export type QuestionBank_RichTextQuestionValidation = {
  __typename?: 'QuestionBank_RichTextQuestionValidation';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for rich text question type */
export type QuestionBank_RichTextQuestionValidationV2 = {
  __typename?: 'QuestionBank_RichTextQuestionValidationV2';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validations for the AI graded rubrics */
  rubrics: Array<QuestionBank_AiGradedRubricValidation>;
};

/** Source of the question bank */
export type QuestionBank_Scope = {
  /** Source is a course */
  course?: InputMaybe<Scalars['ID']>;
};

/** Validation for selection criteria */
export type QuestionBank_SelectionCriteriaValidation = {
  __typename?: 'QuestionBank_SelectionCriteriaValidation';
  /** Validation for difficulty level filter */
  difficultyLevel: QuestionBank_AtomicValidation;
  /** Validation for mastery level filter */
  masteryLevel: QuestionBank_AtomicValidation;
  /** Validation for number of requested questions */
  numberOfRequestedQuestions?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for question category filter */
  questionCategory: QuestionBank_AtomicValidation;
};

/** A single numeric value answer */
export type QuestionBank_SingleNumericAnswerValue = {
  __typename?: 'QuestionBank_SingleNumericAnswerValue';
  /** The exact numeric value that is correct */
  value: Scalars['Float'];
};

/** Input for a single exact numeric answer value */
export type QuestionBank_SingleNumericAnswerValueInput = {
  /** The exact numeric value that is correct */
  value: Scalars['Float'];
};

/** Input for a single exact numeric answer value */
export type QuestionBank_SingleNumericAnswerValueInputV2 = {
  /** The exact numeric value that is correct */
  value: Scalars['Float'];
};

/** Plain text content */
export type QuestionBank_StringContent = {
  __typename?: 'QuestionBank_StringContent';
  /** The plain text value */
  value: Scalars['String'];
};

/** Union representing either plain text or rich text content */
export type QuestionBank_TextContent = Cml_Cml | QuestionBank_StringContent;

/** Input for text content. Exactly one field must be provided. */
export type QuestionBank_TextContentInput = {
  /** Rich text content in CML format */
  cml?: InputMaybe<Cml_CmlInput>;
  /** Plain text content */
  stringContent?: InputMaybe<Scalars['String']>;
};

/** Input for a text exact match answer option with plain text display and CML feedback */
export type QuestionBank_TextExactMatchAnswerInputV2 = {
  /** The plain text string to match against */
  answer: Scalars['String'];
  /** The feedback to show when this option is selected */
  feedback: Cml_CmlInput;
  /** The unique identifier for this answer */
  id: Scalars['ID'];
};

/** A text exact match answer option with plain text display and CML feedback */
export type QuestionBank_TextExactMatchAnswerV2 = {
  __typename?: 'QuestionBank_TextExactMatchAnswerV2';
  /** The plain text string to match against */
  answer: Scalars['String'];
  /** Feedback to show when this option is selected */
  feedback: Cml_Cml;
  /** Unique identifier for this answer */
  id: Scalars['ID'];
};

/** Validation for a answer option */
export type QuestionBank_TextExactMatchAnswerValidationV2 = {
  __typename?: 'QuestionBank_TextExactMatchAnswerValidationV2';
  /** Validation for the answer */
  answer?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the feedback */
  feedback?: Maybe<QuestionBank_AtomicValidation>;
  /** Validation for the option ID */
  id?: Maybe<QuestionBank_AtomicValidation>;
};

/** Validation for text exact match answer options */
export type QuestionBank_TextExactMatchOptionsValidation = {
  __typename?: 'QuestionBank_TextExactMatchOptionsValidation';
  /** Validation for the correct answers */
  correctAnswers: QuestionBank_AtomicValidation;
  /** Validations for the options */
  options: Array<QuestionBank_DisplayOptionValidation>;
};

/** Validation for text exact match answer options */
export type QuestionBank_TextExactMatchOptionsValidationV2 = {
  __typename?: 'QuestionBank_TextExactMatchOptionsValidationV2';
  /** Validations for the options */
  answers: Array<QuestionBank_TextExactMatchAnswerValidationV2>;
  /** Validation for the correct answers */
  correctAnswers: QuestionBank_AtomicValidation;
};

/** Definition for text exact match question type */
export type QuestionBank_TextExactMatchQuestionDefinition = {
  __typename?: 'QuestionBank_TextExactMatchQuestionDefinition';
  /** Possible text answers with feedback */
  answers: Array<QuestionBank_QuestionOption>;
  /** IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback for responses */
  defaultFeedback: QuestionBank_TextContent;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
};

/** Input for a text exact match question definition */
export type QuestionBank_TextExactMatchQuestionDefinitionInput = {
  /** The possible text answers with their feedback */
  answers: Array<QuestionBank_QuestionOptionInput>;
  /** The IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a text exact match question definition */
export type QuestionBank_TextExactMatchQuestionDefinitionInputV2 = {
  /** The possible text answers with their feedback */
  answers: Array<QuestionBank_TextExactMatchAnswerInputV2>;
  /** The IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback to display for responses */
  defaultFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Definition for text exact match question type */
export type QuestionBank_TextExactMatchQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_TextExactMatchQuestionDefinitionV2';
  /** Possible text answers with feedback */
  answers: Array<QuestionBank_TextExactMatchAnswerV2>;
  /** IDs of the correct answer options */
  correctOptionIds: Array<Scalars['ID']>;
  /** Default feedback for responses */
  defaultFeedback: Cml_Cml;
  /** The question prompt text */
  prompt: Cml_Cml;
};

/** Validation for text exact match question type */
export type QuestionBank_TextExactMatchQuestionValidation = {
  __typename?: 'QuestionBank_TextExactMatchQuestionValidation';
  /** Validation for default feedback on incorrect answers */
  defaultIncorrectFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for text match options */
  options: QuestionBank_TextExactMatchOptionsValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for text exact match question type */
export type QuestionBank_TextExactMatchQuestionValidationV2 = {
  __typename?: 'QuestionBank_TextExactMatchQuestionValidationV2';
  /** Validation for text match options */
  answers: QuestionBank_TextExactMatchOptionsValidationV2;
  /** Validation for default feedback */
  defaultFeedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Text length validation */
export type QuestionBank_TextLengthValidation = {
  __typename?: 'QuestionBank_TextLengthValidation';
  /** Actual length of the text */
  actualLength: Scalars['Int'];
  /** Maximum length of the text */
  maxLength?: Maybe<Scalars['Int']>;
  /** Error message if the field is invalid */
  message?: Maybe<Scalars['String']>;
  /** Minimum length of the text */
  minLength?: Maybe<Scalars['Int']>;
  /** Validation status */
  status: QuestionBank_ValidationStatus;
};

/** Definition for text reflection question type */
export type QuestionBank_TextReflectQuestionDefinition = {
  __typename?: 'QuestionBank_TextReflectQuestionDefinition';
  /** General feedback for the learner after answering */
  feedback: QuestionBank_TextContent;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: QuestionBank_TextContent;
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
};

/** Input for a text reflection question definition */
export type QuestionBank_TextReflectQuestionDefinitionInput = {
  /** General feedback for the learner after answering */
  feedback: QuestionBank_TextContentInput;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: QuestionBank_TextContentInput;
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
};

/** Input for a text reflection question definition */
export type QuestionBank_TextReflectQuestionDefinitionInputV2 = {
  /** General feedback for the learner after answering */
  feedback: Cml_CmlInput;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: Cml_CmlInput;
  /** The question prompt */
  prompt: Cml_CmlInput;
};

/** Definition for text reflection question type */
export type QuestionBank_TextReflectQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_TextReflectQuestionDefinitionV2';
  /** General feedback for the learner after answering */
  feedback: Cml_Cml;
  /** Feedback to show when no answer is provided */
  noAnswerFeedback: Cml_Cml;
  /** The question prompt text */
  prompt: Cml_Cml;
};

/** Validation for text reflection question type */
export type QuestionBank_TextReflectQuestionValidation = {
  __typename?: 'QuestionBank_TextReflectQuestionValidation';
  /** Validation for feedback on the response */
  feedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no answer is provided */
  noAnswerFeedback: QuestionBank_AtomicValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Validation for text reflection question type */
export type QuestionBank_TextReflectQuestionValidationV2 = {
  __typename?: 'QuestionBank_TextReflectQuestionValidationV2';
  /** Validation for feedback on the response */
  feedback: QuestionBank_AtomicValidation;
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for feedback when no answer is provided */
  noAnswerFeedback: QuestionBank_AtomicValidation;
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
};

/** Unauthorized access to the question bank */
export type QuestionBank_Unauthorized = {
  __typename?: 'QuestionBank_Unauthorized';
  /** Reason for unauthorized access */
  reason: QuestionBank_AuthorizationReasonEnum;
};

/** Input for unlinking question bank from a scope */
export type QuestionBank_UnlinkInput = {
  /** Question bank id to unlink */
  questionBankId: Scalars['ID'];
  /** Scope to unlink the question bank from */
  scope: QuestionBank_Scope;
};

/** Result of unlinking question bank */
export type QuestionBank_UnlinkResult = {
  __typename?: 'QuestionBank_UnlinkResult';
  /** Question bank id that was unlinked */
  questionBankId: Scalars['ID'];
};

/** Input for updating the name of a question bank */
export type QuestionBank_UpdateBankInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The new name of the question bank */
  name: Scalars['String'];
  /** The ID of the question bank to update */
  questionBankId: Scalars['ID'];
};

/** Result of updating a question bank's name */
export type QuestionBank_UpdateBankResult = {
  __typename?: 'QuestionBank_UpdateBankResult';
  /** The ID of the updated question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for updating the name of a question bank */
export type QuestionBank_UpdateBankV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The new name of the question bank */
  name: Scalars['String'];
  /** The ID of the question bank to update */
  questionBankId: Scalars['ID'];
};

/** Result of updating a question bank's name */
export type QuestionBank_UpdateBankV2Result = {
  __typename?: 'QuestionBank_UpdateBankV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The new name of the question bank */
  name: Scalars['String'];
  /** The ID of the updated question bank */
  questionBankId: Scalars['ID'];
};

/** Input for updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose categories are to be updated */
  questionBankId: Scalars['ID'];
  /** The question categories to update, identified by their IDs */
  questionCategories: Array<QuestionBank_QuestionCategoryWithIdInput>;
};

/** Result of updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesResult = {
  __typename?: 'QuestionBank_UpdateQuestionCategoriesResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose categories are to be updated */
  questionBankId: Scalars['ID'];
  /** The question categories to update, identified by their IDs */
  questionCategories: Array<QuestionBank_QuestionCategoryWithIdInput>;
};

/** Result of updating question categories in a question bank draft */
export type QuestionBank_UpdateQuestionCategoriesV2Result = {
  __typename?: 'QuestionBank_UpdateQuestionCategoriesV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The categories that were updated */
  updatedCategories: Array<QuestionBank_UpdatedQuestionCategory>;
};

/** Input for updating existing questions in a question bank draft */
export type QuestionBank_UpdateQuestionsInput = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose questions are to be updated */
  questionBankId: Scalars['ID'];
  /** The questions to update, identified by their IDs. All provided IDs must already exist in the draft. */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdInput>;
};

/** Result of updating questions in a question bank draft */
export type QuestionBank_UpdateQuestionsResult = {
  __typename?: 'QuestionBank_UpdateQuestionsResult';
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The updated question bank state and a description of the changes applied */
  response: QuestionBank_AuthoringQuestionBankResponse;
};

/** Input for updating existing questions in a question bank draft */
export type QuestionBank_UpdateQuestionsV2Input = {
  /** Authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadataInput;
  /** The ID of the question bank whose questions are to be updated */
  questionBankId: Scalars['ID'];
  /** The questions to update, identified by their IDs. All provided IDs must already exist in the draft. */
  questions: Array<QuestionBank_QuestionBankQuestionWithIdV2Input>;
};

/** Result of updating questions in a question bank draft */
export type QuestionBank_UpdateQuestionsV2Result = {
  __typename?: 'QuestionBank_UpdateQuestionsV2Result';
  /** The updated authoring metadata of the question bank */
  metadata: QuestionBank_AuthoringQuestionBankMetadata;
  /** The ID of the question bank */
  questionBankId: Scalars['ID'];
  /** The questions that were updated */
  updatedQuestions: Array<QuestionBank_UpdatedQuestion>;
};

/** A question updated in the question bank, returned by V2 update and merge mutations */
export type QuestionBank_UpdatedQuestion = {
  __typename?: 'QuestionBank_UpdatedQuestion';
  /** The updated question along with its validation state */
  question: QuestionBank_QuestionBankQuestionWithValidationV2;
  /** The ID of the updated question */
  questionId: Scalars['ID'];
};

/** A question category updated in the question bank */
export type QuestionBank_UpdatedQuestionCategory = {
  __typename?: 'QuestionBank_UpdatedQuestionCategory';
  /** The ID of the updated question category */
  categoryId: Scalars['ID'];
  /** The updated question category */
  questionCategory: QuestionBank_QuestionCategory;
};

/** A change that updated an existing question category in the question bank */
export type QuestionBank_UpdatedQuestionCategoryChange = {
  __typename?: 'QuestionBank_UpdatedQuestionCategoryChange';
  /** The ID of the updated question category */
  id: Scalars['ID'];
  /** The updated question category */
  questionCategory: QuestionBank_QuestionCategory;
};

/** A change that updated an existing question in the question bank */
export type QuestionBank_UpdatedQuestionChange = {
  __typename?: 'QuestionBank_UpdatedQuestionChange';
  /** The ID of the updated question */
  id: Scalars['ID'];
  /** The updated question along with its validation state */
  question: QuestionBank_QuestionBankQuestionWithValidation;
};

/** Validation status */
export const QuestionBank_ValidationStatus = {
  /** The field has a bad reference */
  BadReference: 'BAD_REFERENCE',
  /** The field has a DTD error */
  Dtd: 'DTD',
  /** The field is a duplicate */
  Duplicate: 'DUPLICATE',
  /** The field is empty */
  Empty: 'EMPTY',
  /** The field has an ENUM error */
  Enum: 'ENUM',
  /** The field has a format error */
  Format: 'FORMAT',
  /** The field is locked */
  Locked: 'LOCKED',
  /** The field is not empty */
  NonEmpty: 'NON_EMPTY',
  /** The field has another unclassified type of error */
  Other: 'OTHER',
  /** The field has an overlap error */
  Overlap: 'OVERLAP',
  /** The field is too large */
  TooLarge: 'TOO_LARGE',
  /** The field is too long */
  TooLong: 'TOO_LONG',
  /** The field is too short */
  TooShort: 'TOO_SHORT',
  /** The field is too small */
  TooSmall: 'TOO_SMALL',
  /** The field is valid */
  Valid: 'VALID'
} as const;

export type QuestionBank_ValidationStatus = typeof QuestionBank_ValidationStatus[keyof typeof QuestionBank_ValidationStatus];
/** Versioned Question Bank ID */
export type QuestionBank_VersionedQuestionBankId = {
  __typename?: 'QuestionBank_VersionedQuestionBankId';
  /** Question Bank ID */
  id: Scalars['ID'];
  /** Version of the question bank */
  version: Scalars['Int'];
};

/** Versioned Question Bank ID */
export type QuestionBank_VersionedQuestionBankIdInput = {
  /** Question Bank ID */
  id: Scalars['ID'];
  /** Version of the question bank */
  version: Scalars['Int'];
};

/** Definition for widget question type */
export type QuestionBank_WidgetQuestionDefinition = {
  __typename?: 'QuestionBank_WidgetQuestionDefinition';
  /** The question prompt text */
  prompt: QuestionBank_TextContent;
  /** Type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** Identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Input for a widget question definition */
export type QuestionBank_WidgetQuestionDefinitionInput = {
  /** The question prompt */
  prompt: QuestionBank_TextContentInput;
  /** The type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** The identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Input for a widget question definition */
export type QuestionBank_WidgetQuestionDefinitionInputV2 = {
  /** The question prompt */
  prompt: Cml_CmlInput;
  /** The type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** The identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Definition for widget question type */
export type QuestionBank_WidgetQuestionDefinitionV2 = {
  __typename?: 'QuestionBank_WidgetQuestionDefinitionV2';
  /** The question prompt text */
  prompt: Cml_Cml;
  /** Type of response expected from the widget */
  responseType: QuestionBank_WidgetResponseType;
  /** Identifier for the widget provider */
  widgetProviderId: Scalars['ID'];
};

/** Validation for widget question type */
export type QuestionBank_WidgetQuestionValidation = {
  __typename?: 'QuestionBank_WidgetQuestionValidation';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validation for the widget provider ID */
  widgetProviderId: QuestionBank_AtomicValidation;
};

/** Validation for widget question type */
export type QuestionBank_WidgetQuestionValidationV2 = {
  __typename?: 'QuestionBank_WidgetQuestionValidationV2';
  /** Whether the question is ready to be published */
  isReadyForPublish: Scalars['Boolean'];
  /** Validation for the question prompt */
  prompt: QuestionBank_AtomicValidation;
  /** Validation for the widget provider ID */
  widgetProviderId: QuestionBank_AtomicValidation;
};

/** Response types for widget questions */
export const QuestionBank_WidgetResponseType = {
  /** Only a continue action is expected */
  ContinueOnly: 'CONTINUE_ONLY',
  /** No response expected */
  Empty: 'EMPTY',
  /** A submission is expected */
  Submission: 'SUBMISSION'
} as const;

export type QuestionBank_WidgetResponseType = typeof QuestionBank_WidgetResponseType[keyof typeof QuestionBank_WidgetResponseType];
/** Word count validation */
export type QuestionBank_WordCountValidation = {
  __typename?: 'QuestionBank_WordCountValidation';
  /** Actual word count */
  actualCount: Scalars['Int'];
  /** Maximum word count */
  maxCount?: Maybe<Scalars['Int']>;
  /** Error message if the field is invalid */
  message?: Maybe<Scalars['String']>;
  /** Minimum word count */
  minCount?: Maybe<Scalars['Int']>;
  /** Validation status */
  status: QuestionBank_ValidationStatus;
};

/** Question difficulty levels used to select Questions */
export const QuestionBlock_DifficultyLevel = {
  /** Question difficulty - easy */
  Easy: 'EASY',
  /** Question difficulty - hard */
  Hard: 'HARD',
  /** Question difficulty - medium */
  Medium: 'MEDIUM'
} as const;

export type QuestionBlock_DifficultyLevel = typeof QuestionBlock_DifficultyLevel[keyof typeof QuestionBlock_DifficultyLevel];
/** Question mastery levels used to select Questions */
export const QuestionBlock_MasteryLevel = {
  /** Question mastery level 1 - Foundational understanding */
  Level_1: 'LEVEL_1',
  /** Question mastery level 2 - Practical application */
  Level_2: 'LEVEL_2',
  /** Question mastery level 3 - Reason analytically */
  Level_3: 'LEVEL_3',
  /** Question mastery level 4 - Synthesize and innovate */
  Level_4: 'LEVEL_4'
} as const;

export type QuestionBlock_MasteryLevel = typeof QuestionBlock_MasteryLevel[keyof typeof QuestionBlock_MasteryLevel];
/** Question Block entity */
export type QuestionBlock_QuestionBlock = {
  __typename?: 'QuestionBlock_QuestionBlock';
  /** Question Block ID, without version */
  id: Scalars['ID'];
  /** ID of the Question Bank the Question Block connects */
  questionBankId: Scalars['ID'];
  /** Version of the Question Bank the Question Block connects */
  questionBankVersion: Scalars['Int'];
  /** Configuration of the questions themselves */
  questionConfiguration?: Maybe<QuestionBlock_QuestionConfiguration>;
  /** Question selection criteria */
  selectionCriteria?: Maybe<QuestionBlock_SelectionCriteria>;
  /** Last time Question Block was updated */
  updatedAt: Scalars['DateTime'];
  /** ID of the last user who updated the Question Block */
  updatedBy?: Maybe<User_User>;
  /** Question Block version */
  version: Scalars['Int'];
};

/** Draft version of a Question Block before publishing */
export type QuestionBlock_QuestionBlockDraft = {
  __typename?: 'QuestionBlock_QuestionBlockDraft';
  /** Whether the Question Block Draft is published or not */
  isPublished: Scalars['Boolean'];
  /** ID of the Question Bank the Question Block Draft connects */
  questionBankId?: Maybe<Scalars['ID']>;
  /** Configuration of the questions themselves */
  questionConfiguration?: Maybe<QuestionBlock_QuestionConfiguration>;
  /** Question selection criteria */
  selectionCriteria?: Maybe<QuestionBlock_SelectionCriteria>;
  /** Last time Question Block Draft was updated */
  updatedAt: Scalars['DateTime'];
  /** ID of the last user who updated the Question Block Draft */
  updatedBy?: Maybe<User_PublicUser>;
};

/** Configuration of selected questions within Question Block */
export type QuestionBlock_QuestionConfiguration = {
  __typename?: 'QuestionBlock_QuestionConfiguration';
  /** How many points per question should be awarded */
  points: Scalars['Int'];
};

/** Input for configuration of selected questions within Question Block */
export type QuestionBlock_QuestionConfigurationInput = {
  /** How many points per question should be awarded */
  points: Scalars['Int'];
};

/** Selection criteria for questions from Question Bank */
export type QuestionBlock_SelectionCriteria = {
  __typename?: 'QuestionBlock_SelectionCriteria';
  /** What is the difficulty level of the selected questions */
  difficultyLevelFilter?: Maybe<QuestionBlock_DifficultyLevel>;
  /** What is the mastery level of the selected questions */
  masteryLevelFilter?: Maybe<QuestionBlock_MasteryLevel>;
  /** How many questions are to be selected from the Question Bank */
  numberOfRequestedQuestions: Scalars['Int'];
  /** What category ID, if any, should be used in question selection */
  questionCategoryFilter?: Maybe<Scalars['ID']>;
};

/** Input for selection criteria for questions from Question Bank */
export type QuestionBlock_SelectionCriteriaInput = {
  /** What is the difficulty level of the selected questions */
  difficultyLevelFilter?: InputMaybe<QuestionBlock_DifficultyLevel>;
  /** What is the mastery level of the selected questions */
  masteryLevelFilter?: InputMaybe<QuestionBlock_MasteryLevel>;
  /** How many questions are to be selected from the Question Bank */
  numberOfRequestedQuestions: Scalars['Int'];
  /** What category ID, if any, should be used in question selection */
  questionCategoryFilter?: InputMaybe<Scalars['ID']>;
};

/** All queries related to Question Blocks */
export type QuestionBlocksQueries = {
  __typename?: 'QuestionBlocksQueries';
  /** Retrieve the specific version of the Question Block */
  get?: Maybe<QuestionBlock_QuestionBlock>;
  /** Retrieve the latest version of the Question Block */
  latest?: Maybe<QuestionBlock_QuestionBlock>;
};


/** All queries related to Question Blocks */
export type QuestionBlocksQueriesGetArgs = {
  questionBlockId: Scalars['ID'];
  version: Scalars['Int'];
};


/** All queries related to Question Blocks */
export type QuestionBlocksQueriesLatestArgs = {
  questionBlockId: Scalars['ID'];
};

/** Question Generator Queries */
export type QuestionGeneratorQueries = {
  __typename?: 'QuestionGeneratorQueries';
  /** Query to get all Question Generation Experiment ids */
  allExperiments?: Maybe<QuestionGenerator_AllExperimentsPaginatedResult>;
  /** Query to get Question Generation Experiment */
  experimentById?: Maybe<QuestionGenerator_GenerationExperiment>;
};


/** Question Generator Queries */
export type QuestionGeneratorQueriesAllExperimentsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


/** Question Generator Queries */
export type QuestionGeneratorQueriesExperimentByIdArgs = {
  experimentId: Scalars['ID'];
};

/** Successful (paginated) result of getting all experiment IDs */
export type QuestionGenerator_AllExperimentsPaginatedResult = {
  __typename?: 'QuestionGenerator_AllExperimentsPaginatedResult';
  /** List of experiments */
  elements: Array<QuestionGenerator_GenerationExperiment>;
  /** Pagination information */
  pagination: Pagination;
};

/** Category ID (Either a lesson or a learning objective) */
export type QuestionGenerator_CategoryId = QuestionGenerator_LearningObjectiveId | QuestionGenerator_LessonId | QuestionGenerator_ModuleId;

/** Input for setting an experiment */
export type QuestionGenerator_CreateExperimentInput = {
  /** The name of the experiement */
  name: Scalars['String'];
  /** The new prompt template to use */
  promptTemplate: Scalars['String'];
};

/** Result of creating an experiment */
export type QuestionGenerator_CreateExperimentResult = QuestionGenerator_CreateExperiment_Failure | QuestionGenerator_CreateExperiment_Success;

/** Failure response containing list of errors */
export type QuestionGenerator_CreateExperiment_Failure = {
  __typename?: 'QuestionGenerator_CreateExperiment_Failure';
  /** List of errors */
  errors: Array<QuestionGenerator_Error>;
};

/** Successful result of setting an experiment */
export type QuestionGenerator_CreateExperiment_Success = {
  __typename?: 'QuestionGenerator_CreateExperiment_Success';
  /** The experiment */
  experiment: QuestionGenerator_GenerationExperiment;
};

/** QuestionGenerator_Error */
export type QuestionGenerator_Error = {
  __typename?: 'QuestionGenerator_Error';
  /** Error message. */
  message: Scalars['String'];
};

/** Enum representing the types of feedback level */
export const QuestionGenerator_FeedbackType = {
  /** All relevant feedback provided */
  Full: 'FULL',
  /** Correct answer is not disclosed */
  Graded: 'GRADED',
  /** No feedback provided */
  None: 'NONE'
} as const;

export type QuestionGenerator_FeedbackType = typeof QuestionGenerator_FeedbackType[keyof typeof QuestionGenerator_FeedbackType];
/** Successful result of setting an experiment */
export type QuestionGenerator_GenerationExperiment = {
  __typename?: 'QuestionGenerator_GenerationExperiment';
  /** The ID of the experiment */
  id: Scalars['ID'];
  /** The name of the experiement */
  name: Scalars['String'];
  /** The current prompt template */
  promptTemplate: Scalars['String'];
  /** When the experiment was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** State of the generation request */
export type QuestionGenerator_GenerationRequestsByBranchResult = {
  __typename?: 'QuestionGenerator_GenerationRequestsByBranchResult';
  /** All the generation requests in the course + branch */
  generationRequests?: Maybe<Array<QuestionGenerator_RequestStatus>>;
};

/** Questions generated for one category */
export type QuestionGenerator_GenerationStateCount = {
  __typename?: 'QuestionGenerator_GenerationStateCount';
  /** Category used to generated the questions */
  categoryId: QuestionGenerator_CategoryId;
  /** Questions created so far */
  numberOfQuestionsGenerated: Scalars['Int'];
  /** Questions requested */
  numberOfQuestionsRequested: Scalars['Int'];
};

/** State of the generation request */
export type QuestionGenerator_GenerationStateResult = {
  __typename?: 'QuestionGenerator_GenerationStateResult';
  /** Estimated amount of seconds to complete the generation */
  estimatedSecondsToCompletion: Scalars['Int'];
  /** Question bank with the questions generated */
  questionBankId: Scalars['ID'];
  /** Number of questions added to the question bank so far by category */
  questionsAdded: Array<QuestionGenerator_GenerationStateCount>;
  /** Number of questions generated so far by category */
  questionsGenerated: Array<QuestionGenerator_GenerationStateCount>;
  /**
   * Authoring branches used to generate the content
   * @deprecated Use sourceContentIdentifiers instead
   */
  sourceAuthoringBranchIds?: Maybe<Array<Scalars['ID']>>;
  /** Content identifiers for the branch used to generate the content */
  sourceContentIdentifiers?: Maybe<Array<QuestionGenerator_SourceContentIdentifiers>>;
  /** Status of the generation request */
  status: QuestionGenerator_GenerationStatus;
};

/** Status of the generation request */
export const QuestionGenerator_GenerationStatus = {
  /** The user cancelled the generation request */
  Cancelled: 'CANCELLED',
  /** The generation request finished successfully */
  Complete: 'COMPLETE',
  /** The generation request didn't finish successfully */
  Failed: 'FAILED',
  /** The workers started picking up jobs */
  Inprogress: 'INPROGRESS',
  /** The generation request was queued but the workers didn't pick up jobs yet */
  Started: 'STARTED'
} as const;

export type QuestionGenerator_GenerationStatus = typeof QuestionGenerator_GenerationStatus[keyof typeof QuestionGenerator_GenerationStatus];
/** LearningObjective generation request */
export type QuestionGenerator_LearningObjectiveGenerationRequest = {
  /** LearningObjective ID */
  learningObjectiveId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Learning objective id */
export type QuestionGenerator_LearningObjectiveId = {
  __typename?: 'QuestionGenerator_LearningObjectiveId';
  /** The ID */
  id: Scalars['ID'];
};

/** Lesson generation request */
export type QuestionGenerator_LessonGenerationRequest = {
  /** Lesson ID */
  lessonId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Lesson ID */
export type QuestionGenerator_LessonId = {
  __typename?: 'QuestionGenerator_LessonId';
  /** The ID */
  id: Scalars['ID'];
};

/** Module generation request */
export type QuestionGenerator_ModuleGenerationRequest = {
  /** Module ID */
  moduleId: Scalars['ID'];
  /** Number of questions to generate */
  numberOfQuestions: Scalars['Int'];
};

/** Module id */
export type QuestionGenerator_ModuleId = {
  __typename?: 'QuestionGenerator_ModuleId';
  /** The Id */
  id: Scalars['ID'];
};

/** Enum representing the types of questions the AI can generate */
export const QuestionGenerator_QuestionType = {
  /** AI Graded */
  AiGraded: 'AiGraded',
  /** Checkboxes question */
  Checkbox: 'Checkbox',
  /** Code expression question */
  CodeExpression: 'CodeExpression',
  /** Multi-choice questions, or checkboxes */
  MultipleChoiceQuestion: 'MultipleChoiceQuestion',
  /** Number match questions */
  Number: 'Number',
  /** Text match questions */
  TextExactMatch: 'TextExactMatch'
} as const;

export type QuestionGenerator_QuestionType = typeof QuestionGenerator_QuestionType[keyof typeof QuestionGenerator_QuestionType];
/** Status of a request in the branch */
export type QuestionGenerator_RequestStatus = {
  __typename?: 'QuestionGenerator_RequestStatus';
  /** Generation request id */
  generationRequestId: Scalars['ID'];
  /** Question bank with the questions generated */
  questionBankId: Scalars['ID'];
  /** Number of questions generated so far by category */
  questionsGenerated: Array<QuestionGenerator_GenerationStateCount>;
  /** Status of the generation request */
  status: QuestionGenerator_GenerationStatus;
};

/** Identifiers for the content used to generate the question bank */
export type QuestionGenerator_SourceContentIdentifiers = {
  __typename?: 'QuestionGenerator_SourceContentIdentifiers';
  /** Authoring branch id */
  authoringBranchId: Scalars['ID'];
  /**
   * Learner branch id
   * @deprecated please use authoring branch id instead
   */
  branchId: Scalars['ID'];
  /** branch's course */
  course: Course_Course;
};

/** Return type for the list of source contents for a question bank */
export type QuestionGenerator_SourceContentIdentifiersInQuestionBank = {
  __typename?: 'QuestionGenerator_SourceContentIdentifiersInQuestionBank';
  /** The source content list in a question bank */
  sourceContentIdentifiers: Array<QuestionGenerator_SourceContentIdentifiers>;
};

/** Request to start a generation from learning objectives to question banks */
export type QuestionGenerator_StartGenerationFromLearningObjectivesToQuestionBanks = {
  /** Learning Objectives to generate from and how many questions */
  learningObjectives: Array<QuestionGenerator_LearningObjectiveGenerationRequest>;
};

/** Request to start a generation from lessons to question banks */
export type QuestionGenerator_StartGenerationFromLessonsToQuestionBanks = {
  /** Lessons to generate from and how many questions */
  lessons: Array<QuestionGenerator_LessonGenerationRequest>;
};

/** Request to start a generation from modules to question banks */
export type QuestionGenerator_StartGenerationFromModulesToQuestionBanks = {
  /** Modules to generate from and how many questions */
  modules: Array<QuestionGenerator_ModuleGenerationRequest>;
};

/** Input to start a question generation request */
export type QuestionGenerator_StartGenerationInput = {
  /** Authoring branch id with the content to use for generation */
  authoringBranchId: Scalars['ID'];
  /** Course ID in which to save the new question bank */
  courseId: Scalars['ID'];
  /** The type of feedback the AI should generate. Feedback is displayed to learners alongside their answer. */
  feedbackType?: InputMaybe<QuestionGenerator_FeedbackType>;
  /** The id of an existing question bank to append generated questions to */
  questionBankId?: InputMaybe<Scalars['ID']>;
  /** The name of the question bank to be created */
  questionBankName?: InputMaybe<Scalars['String']>;
  /** Question types to generate */
  questionTypes?: InputMaybe<Array<QuestionGenerator_QuestionType>>;
  /**
   * Whether to retry on low quality questions.
   * It makes the generation slower
   */
  retryLowQualityQuestions?: Scalars['Boolean'];
  /** Source to use to generate */
  sources: QuestionGenerator_StartGenerationSources;
};

/** Result of a request to start a generation request */
export type QuestionGenerator_StartGenerationResult = {
  __typename?: 'QuestionGenerator_StartGenerationResult';
  /** Estimated amount of seconds to complete the generation */
  estimatedSecondsToCompletion: Scalars['Int'];
  /** Generation request ID to check the status */
  generationRequestId: Scalars['ID'];
  /**
   * Process ID to check the status
   * @deprecated Use generationRequestId instead
   */
  processId: Scalars['ID'];
  /** Question bank with the generated questions */
  questionBankId: Scalars['ID'];
};

/** Start generation sources from a course */
export type QuestionGenerator_StartGenerationSources = {
  /** Start a question generation to a question bank from learning objectives */
  fromLearningObjectivesToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromLearningObjectivesToQuestionBanks>;
  /** Start a question generation to a question bank from lessons */
  fromLessonsToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromLessonsToQuestionBanks>;
  /** Start a question generation to a question bank from modules */
  fromModulesToQuestionBank?: InputMaybe<QuestionGenerator_StartGenerationFromModulesToQuestionBanks>;
};

/** Input for the stop generation request */
export type QuestionGenerator_StopGenerationInput = {
  /** Course ID */
  courseId?: InputMaybe<Scalars['ID']>;
  /** ID of the generation request to stop */
  generationRequestId: Scalars['ID'];
};

/** Result of the stop generation request */
export type QuestionGenerator_StopGenerationResult = {
  __typename?: 'QuestionGenerator_StopGenerationResult';
  /** New status of the generation request */
  status: QuestionGenerator_GenerationStatus;
};

/** Input for setting an experiment */
export type QuestionGenerator_UpdateExperimentInput = {
  /** The ID of the experiment to change */
  experimentId: Scalars['ID'];
  /** The new prompt to use */
  promptTemplate: Scalars['String'];
};

/** Result of setting an experiment */
export type QuestionGenerator_UpdateExperimentResult = QuestionGenerator_UpdateExperiment_Failure | QuestionGenerator_UpdateExperiment_Success;

/** Failure response containing list of errors */
export type QuestionGenerator_UpdateExperiment_Failure = {
  __typename?: 'QuestionGenerator_UpdateExperiment_Failure';
  /** List of errors */
  errors: Array<QuestionGenerator_Error>;
};

/** Successful result of setting an experiment */
export type QuestionGenerator_UpdateExperiment_Success = {
  __typename?: 'QuestionGenerator_UpdateExperiment_Success';
  /** The experiment */
  experiment: QuestionGenerator_GenerationExperiment;
};

/** Rating strategy for the question rater */
export const QuestionRater_RatingStrategy = {
  /** Rate only unrated questions */
  ContinueRating: 'CONTINUE_RATING',
  /** Rate all questions */
  RateAll: 'RATE_ALL'
} as const;

export type QuestionRater_RatingStrategy = typeof QuestionRater_RatingStrategy[keyof typeof QuestionRater_RatingStrategy];
/** Input for the save question rating request */
export type QuestionRater_SaveHumanQuestionRatingInput = {
  /** Absence of clues score */
  absenceOfCluesScore: Scalars['Int'];
  /** Answer feedback clarity score */
  answerFeedbackClarityScore: Scalars['Int'];
  /** Answer precision score */
  answerPrecisionScore: Scalars['Int'];
  /** Avoid negative phrasing score */
  avoidNegativePhrasingScore: Scalars['Int'];
  /** Generation batch ID */
  batchId: Scalars['ID'];
  /** Difficulty level alignment score */
  difficultyLevelAlignmentScore: Scalars['Int'];
  /** Factual accuracy score */
  factualAccuracyScore: Scalars['Int'];
  /** Feedback answer score */
  feedbackAnswerScore: Scalars['Int'];
  /** Meaningfulness score */
  meaningfulnessScore: Scalars['Int'];
  /** Human rater notes */
  notes: Scalars['String'];
  /** Plausibility score */
  plausibilityScore: Scalars['Int'];
  /** Problem presentation score */
  problemPresentationScore: Scalars['Int'];
  /** Question bank ID */
  questionBankId: Scalars['ID'];
  /** Question clarity score */
  questionClarityScore: Scalars['Int'];
  /** Question grammar score */
  questionGrammarScore: Scalars['Int'];
  /** Question ID */
  questionId: Scalars['ID'];
};

/** Result of the save question rating request */
export type QuestionRater_SaveHumanQuestionRatingResult = {
  __typename?: 'QuestionRater_SaveHumanQuestionRatingResult';
  /** Saved rating ID, NULL if saving failed */
  ratingId?: Maybe<Scalars['ID']>;
  /** Status of the request */
  status: QuestionRater_SaveHumanQuestionRatingStatus;
};

/** Whether the rating was saved or not */
export const QuestionRater_SaveHumanQuestionRatingStatus = {
  /** Rating not saved */
  RatingNotSaved: 'RATING_NOT_SAVED',
  /** Rating saved */
  RatingSaved: 'RATING_SAVED'
} as const;

export type QuestionRater_SaveHumanQuestionRatingStatus = typeof QuestionRater_SaveHumanQuestionRatingStatus[keyof typeof QuestionRater_SaveHumanQuestionRatingStatus];
/** Input for the mutation to start a question rater */
export type QuestionRater_StartQuestionRatingInput = {
  /** Course id  to rate */
  courseId: Scalars['ID'];
  /** Rating Strategy */
  ratingStrategy: QuestionRater_RatingStrategy;
};

/** The information needed to identify the specific rating request */
export type QuestionRater_StartQuestionRatingResult = {
  __typename?: 'QuestionRater_StartQuestionRatingResult';
  /** Question banks to rate */
  questionBankIds: Array<Scalars['ID']>;
  /** Rating strategy */
  ratingStrategy: QuestionRater_RatingStrategy;
  /** Start time of the question rating */
  startedAt: Scalars['DateTime'];
};

/** RateLimitSummary indicates that there are rate limits. Learners are limited to submit certain number of submissions in a given period. */
export type RateLimitSummary = {
  __typename?: 'RateLimitSummary';
  /** Next possible submission time in milliseconds since epoch. This is stored in string format, since Long is not supported in GraphQL. */
  nextPossibleSubmissionTime: Scalars['String'];
  /** The remaining submissions that are available at this moment. If this is zero, learner cannot make submissions. */
  remainingSubmissionsNow: Scalars['Int'];
  /** Interval duration in which the learner can make limited submissions. Represented in milliseconds. */
  submissionsIntervalDuration: Scalars['Int'];
  /** Number of submissions the learner can make in a given period. */
  submissionsPerInterval: Scalars['Int'];
};

/** Reading draft content, represented as an input type */
export type ReadingAuthoring_DraftContentInput = {
  /** Updated reading content, in CML format */
  content: CmlContentInput;
  /** Updated item name */
  name: Scalars['String'];
  /** Updated time commitment */
  timeCommitment: Scalars['Duration'];
};

/** Returned if ReadingAuthoring_UpdateReadingDraft ran into a client-actionable error */
export type ReadingAuthoring_UpdateReadingDraftFailure = {
  __typename?: 'ReadingAuthoring_UpdateReadingDraftFailure';
  /** List of errors. Common Item Platform errors are defined in shared-itemplatform/schema/core/errors.graphqls. */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for the ReadingAuthoring_UpdateReadingDraft mutation */
export type ReadingAuthoring_UpdateReadingDraftInput = {
  /** Id of the underlying atom */
  atomId: Scalars['ID'];
  /** Conflict detection token used to determine if conflicting edits have been made */
  conflictDetectionToken: Scalars['String'];
  /** Updated draft content */
  draftContent: ReadingAuthoring_DraftContentInput;
};

/** Result union for the ReadingAuthoring_UpdateReadingDraft mutation */
export type ReadingAuthoring_UpdateReadingDraftResult = ReadingAuthoring_UpdateReadingDraftFailure | ReadingAuthoring_UpdateReadingDraftSuccess;

/** Returned if ReadingAuthoring_UpdateReadingDraft completed successfully */
export type ReadingAuthoring_UpdateReadingDraftSuccess = {
  __typename?: 'ReadingAuthoring_UpdateReadingDraftSuccess';
  /** The updated reading */
  item: ItemPlatform_AuthoringItem;
};

/** Recently viewed product object. Can be either course or specialization or degree. */
export type RecentlyViewedProduct_Product = Course_Course | Specialization_Specialization;

/** Paginated result type for recently viewed products */
export type RecentlyViewedProduct_RecentlyViewedProductsPaginatedResult = {
  __typename?: 'RecentlyViewedProduct_RecentlyViewedProductsPaginatedResult';
  /** List of recently view products in the page */
  elements: Array<RecentlyViewedProduct_Product>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Queries that return recently viewed products. */
export type RecentlyViewedProductsQueries = {
  __typename?: 'RecentlyViewedProductsQueries';
  /**
   * Fetch recently viewed products for the current user or session id. User ID and Session ID is inferred from
   * request context. Session ID is used as a fallback if user ID is not available.
   */
  me: RecentlyViewedProducts_RecentlyViewedProducts;
};

/** RecentlyViewedProducts_AddRecentlyViewedProduct mutation Error. */
export type RecentlyViewedProducts_AddRecentlyViewedProductError = Error & {
  __typename?: 'RecentlyViewedProducts_AddRecentlyViewedProductError';
  /** Error message */
  message: Scalars['String'];
};

/** Input to add a recently viewed product */
export type RecentlyViewedProducts_AddRecentlyViewedProductInput = {
  /** Product id of the recently viewed product */
  productId: Scalars['ID'];
  /** Product type of the recently viewed product */
  productType: RecentlyViewedProducts_ProductType;
};

/** Result of adding a recently viewed product. */
export type RecentlyViewedProducts_AddRecentlyViewedProductResult = RecentlyViewedProducts_AddRecentlyViewedProductError | RecentlyViewedProducts_AddRecentlyViewedProductSuccess;

/** This is returned if the RecentlyViewedProducts_AddRecentlyViewedProduct mutation succeeds. */
export type RecentlyViewedProducts_AddRecentlyViewedProductSuccess = {
  __typename?: 'RecentlyViewedProducts_AddRecentlyViewedProductSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Product type for a recently viewed product */
export const RecentlyViewedProducts_ProductType = {
  /** Product is a course */
  Course: 'COURSE',
  /** Product is a specialization */
  Specialization: 'SPECIALIZATION'
} as const;

export type RecentlyViewedProducts_ProductType = typeof RecentlyViewedProducts_ProductType[keyof typeof RecentlyViewedProducts_ProductType];
/** The recently viewed products schema */
export type RecentlyViewedProducts_RecentlyViewedProducts = {
  __typename?: 'RecentlyViewedProducts_RecentlyViewedProducts';
  /** The recently viewed products. */
  entities: RecentlyViewedProduct_RecentlyViewedProductsPaginatedResult;
};


/** The recently viewed products schema */
export type RecentlyViewedProducts_RecentlyViewedProductsEntitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Queries that return content recommendations. */
export type RecommendationQueries = {
  __typename?: 'RecommendationQueries';
  /**
   * Query for a recommendation collection by name and custom input required by that collection. Recommendations will be personalized for the provided user ID and session ID.
   * This should be used by COURSERIANS ONLY.
   *
   * The set of valid recommendation configuration names is defined by the file names (sans the .json extension) found
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1
   */
  queryByNameAndCustomInputAndContext: Recommendation_Collection;
  /**
   * Query for a recommendation collection by its configuration and custom input required by that collection. Recommendations will be personalized for the currently signed-in user and session.
   * This should be used by COURSERIANS ONLY.
   *
   * This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  queryByRecommendationConfigurationAndCustomInput: Recommendation_Collection;
  /**
   * Query for a recommendation collection by its configuration and custom input required by that collection. Recommendations will be personalized for the provided user ID and session ID.
   * This should be used by COURSERIANS ONLY.
   *
   * This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  queryByRecommendationConfigurationAndCustomInputAndContext: Recommendation_Collection;
  /**
   * Query for a recommendation collection by its id (recommender configuration name) and custom input required by that
   * collection. Recommendations will be personalized for the currently signed-in user and session.
   */
  queryCollection: Recommendation_Collection;
};


/** Queries that return content recommendations. */
export type RecommendationQueriesQueryByNameAndCustomInputAndContextArgs = {
  input: Recommendation_QueryByNameAndCustomInputAndContext;
};


/** Queries that return content recommendations. */
export type RecommendationQueriesQueryByRecommendationConfigurationAndCustomInputArgs = {
  input: Recommendation_QueryByRecommendationConfigurationAndCustomInput;
};


/** Queries that return content recommendations. */
export type RecommendationQueriesQueryByRecommendationConfigurationAndCustomInputAndContextArgs = {
  input: Recommendation_QueryByRecommendationConfigurationAndCustomInputAndContext;
};


/** Queries that return content recommendations. */
export type RecommendationQueriesQueryCollectionArgs = {
  additionalInput?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  orgSlug?: InputMaybe<Scalars['String']>;
};

/** The recommendation collection entity stub */
export type Recommendation_Collection = {
  __typename?: 'Recommendation_Collection';
  /** Additional input required for fetching the collection */
  additionalInput?: Maybe<Scalars['JSON']>;
  /**
   * Reference Collection attributes. This is NOT supported in the context of a Federated Entity.
   *
   * TODO: This should be hoisted out of Recommendation_Collection and served by a separate Collection_CollectionWithAttributes type.
   */
  collectionAttributes: CollectionAttributes_CollectionAttributes;
  /** Non-sensitive and non-personal contextual metadata about how the recommendations were generated. */
  context?: Maybe<Scalars['JSON']>;
  /** Additional information for debugging and explaining how the Recommendation_Collection was generated. */
  debug?: Maybe<Scalars['JSON']>;
  /** The collection's description. This is the canonical source of a collection's title. */
  description: Scalars['String'];
  /** Additional metadata regarding collection. */
  enterpriseCollectionMetadata?: Maybe<EntCollection_CollectionContextMetadata>;
  /** The collection's title */
  enterpriseCollectionTitle?: Maybe<Scalars['String']>;
  /** Curriculum track ID in the collection */
  enterpriseCollectionTrackingId?: Maybe<Scalars['ID']>;
  /** The paginated response of entities in the collection */
  entities?: Maybe<Recommendation_CollectionEntitiesPaginatedResult>;
  /** The collection's recommender id, */
  id: Scalars['ID'];
  /** Collection content's last updated at */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** List of program associated with the organization */
  programs?: Maybe<Array<EnterpriseProgram_EnterpriseProgram>>;
  /** The hash of the recommender configuration uniquely identifying a specific version of the configuration used to generate the recommendations. */
  recommenderConfigurationHash?: Maybe<Scalars['String']>;
  /**
   * The collection's title. This is meant to be used exclusively in the context of Learning Paths/Enterprise Curated Collections.
   * See https://docs.google.com/document/d/1x1wF1Ns9WdWGfcYK4NaKXrE0PCUj4X2evsag7mrEaOY/edit for more details.
   */
  title?: Maybe<Scalars['String']>;
  /** Collection visibility scope for Enterprise Curated Collection */
  visibility: Array<Collection_VisibilityScope>;
};


/** The recommendation collection entity stub */
export type Recommendation_CollectionEntitiesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};

/** Paginated result type for entities under a collection */
export type Recommendation_CollectionEntitiesPaginatedResult = {
  __typename?: 'Recommendation_CollectionEntitiesPaginatedResult';
  /**
   * List of recommendation entity elements in the collection
   *
   * This field may be null if the recommended product cannot be resolved, typically because the product has not yet been
   * launched.
   */
  elements: Array<Maybe<Recommendation_Entity>>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Entities in the collection. Entities could be product cards, skill career roles, or nested collections. */
export type Recommendation_Entity = ProductCard_ProductCard | Recommendation_Collection | Recommendation_RecommendableEntity | Skill_CareerRole;

/**
 * Input for querying recommendations from a specific recommender configuration (specified by name) while providing
 * all input required by that module and the request context (user ID and session ID).
 */
export type Recommendation_QueryByNameAndCustomInputAndContext = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * The recommender's name. Names must be in lower-kebab-case.
   *
   * The set of valid recommendation configuration names is defined by the file names (sans the .json extension) found
   * in this directory: https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1
   */
  name: Scalars['String'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
  /** The Session ID for which to retrieve recommendations. A null value indicates no session. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** The user ID for which to retrieve recommendations. A null value indicates a logged out user. */
  userId?: InputMaybe<Scalars['Int']>;
};

/**
 * Input for querying recommendations for a recommender configuration (provided) while providing
 * all input required by that module.
 */
export type Recommendation_QueryByRecommendationConfigurationAndCustomInput = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * A JSON object representing a recommender configuration. This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  configuration: Scalars['JSON'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
};

/**
 * Input for querying recommendations for a recommender configuration (provided) while providing
 * all input required by that module and the request context (user ID and session ID).
 */
export type Recommendation_QueryByRecommendationConfigurationAndCustomInputAndContext = {
  /** All input features required by the recommendation module. */
  additionalInput?: InputMaybe<Scalars['JSON']>;
  /**
   * A JSON object representing a recommender configuration. This recommender configuration must be a valid configuration:
   * https://github.com/webedx-spark/taco-store-source/tree/main/source/recs/recommender-configurations/v1/README.md
   */
  configuration: Scalars['JSON'];
  /** Organization slug */
  orgSlug?: InputMaybe<Scalars['String']>;
  /** The Session ID for which to retrieve recommendations. A null value indicates no session. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** The user ID for which to retrieve recommendations. A null value indicates a logged out user. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** An entity which is not currently supported by any other federated GraphQL entity. Ideally this entity should never be returned. It exists when an invalid entity was returned or a new entity type is introduced and no relevant federated entity exists. FE should filter out and ignore these entities. */
export type Recommendation_RecommendableEntity = {
  __typename?: 'Recommendation_RecommendableEntity';
  /** This is the ID as represented by the canonical services of these entities. For example, the id of a course would be `zu4gnAarEe21Qg76AlMoeQ`. */
  id: Scalars['ID'];
  /** The type of the corresponding ID */
  type: Scalars['String'];
};

/** Recommended module completion dates GraphQL queries */
export type RecommendedModuleDeadlinesQueries = {
  __typename?: 'RecommendedModuleDeadlinesQueries';
  /** Query by user and course ids */
  queryByUserAndCourse?: Maybe<Array<RecommendedModuleDeadlines_Response>>;
};


/** Recommended module completion dates GraphQL queries */
export type RecommendedModuleDeadlinesQueriesQueryByUserAndCourseArgs = {
  input: RecommendedModuleDeadlines_QueryByUserAndCourseInput;
};

/** Input parameters for Query byUserAndCourse */
export type RecommendedModuleDeadlines_QueryByUserAndCourseInput = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** User Id */
  userId: Scalars['ID'];
};

/** Recommended completion date with module ID, and upcoming items associated with it. */
export type RecommendedModuleDeadlines_Response = {
  __typename?: 'RecommendedModuleDeadlines_Response';
  /** Module ID */
  moduleId: Scalars['ID'];
  /** Recommended completion date */
  recommendedDeadline: Scalars['DateTime'];
};

/** Queries for RecruitingCandidates */
export type RecruitingCandidateQueries = {
  __typename?: 'RecruitingCandidateQueries';
  /** Gets the candidate based on their external ID */
  queryByExternalId: RecruitingCandidate_Item;
  /**
   * Get the list of candidates who are interested in the selected occupation Id,
   * and meet any other criteria that was optionally specified. | Maximum page size: 100
   */
  queryByPositionId: RecruitingCandidate_Connection;
  /**
   * Gets a list of all of the distinct skills that candidates who qualify for this position
   * have achieved.
   */
  querySkillsByPositionId: Array<RecruitingCandidate_Skill>;
};


/** Queries for RecruitingCandidates */
export type RecruitingCandidateQueriesQueryByExternalIdArgs = {
  externalId: Scalars['ID'];
};


/** Queries for RecruitingCandidates */
export type RecruitingCandidateQueriesQueryByPositionIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  optionalFilters?: InputMaybe<RecruitingCandidate_Filters>;
  positionId: Scalars['ID'];
  sortBy?: RecruitingCandidate_SortOption;
};


/** Queries for RecruitingCandidates */
export type RecruitingCandidateQueriesQuerySkillsByPositionIdArgs = {
  positionId: Scalars['ID'];
};

/** Represents a paginated list of RecruitingCandidates */
export type RecruitingCandidate_Connection = {
  __typename?: 'RecruitingCandidate_Connection';
  /** The paginated list */
  edges: Array<RecruitingCandidate_Edge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
  /** Total number of candidates that meet the search criteria */
  totalElements: Scalars['Int'];
};

/** A paginated list of courses that a candidate has completed. */
export type RecruitingCandidate_CoursePaginatedResult = {
  __typename?: 'RecruitingCandidate_CoursePaginatedResult';
  /** The list of courses the the learner has completed. */
  elements: Array<Course_Course>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** A degree that a candidate is in the process of completing or has already completed. */
export type RecruitingCandidate_Degree = {
  __typename?: 'RecruitingCandidate_Degree';
  /** The level of the degree, for example Bachelors, Masters, etc. */
  educationLevel: RecruitingCandidate_EducationLevel;
  /**
   * The subject that a candidate is studying or has studied.
   * The complete list of eligible majors that candidates may select can be found here:
   * https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/userprofile/v1beta1/education_profile.proto#L56-L69
   */
  educationMajor: Scalars['String'];
  /** The candidate's graduation month of the year. Ex: 1 for January. */
  graduationMonth?: Maybe<Scalars['Int']>;
  /** The candidate's graduation year. */
  graduationYear?: Maybe<Scalars['Int']>;
  /** Tha name of the University or institution that this degree was granted by */
  universityName: Scalars['String'];
};

/** Represents a RecruitingCandidate with its pagination cursor */
export type RecruitingCandidate_Edge = {
  __typename?: 'RecruitingCandidate_Edge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** A Coursera learner that is an eligible candidate for recruitment */
  node: RecruitingCandidate_Item;
};

/** The level of education that a candidate has already or is in the process of achieving. */
export const RecruitingCandidate_EducationLevel = {
  /** Associate's degree */
  AssociateDegree: 'ASSOCIATE_DEGREE',
  /** Bachelor's degree */
  BachelorDegree: 'BACHELOR_DEGREE',
  /** Completed some college but no degree attained */
  CollegeNoDegree: 'COLLEGE_NO_DEGREE',
  /** Doctorate degree */
  DoctorateDegree: 'DOCTORATE_DEGREE',
  /** High School Diploma or GED */
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  /** Less than a High School Diploma */
  LessThanHighSchoolDiploma: 'LESS_THAN_HIGH_SCHOOL_DIPLOMA',
  /** Master's degree */
  MastersDegree: 'MASTERS_DEGREE',
  /** Some kind of professional degree */
  ProfessionalDegree: 'PROFESSIONAL_DEGREE'
} as const;

export type RecruitingCandidate_EducationLevel = typeof RecruitingCandidate_EducationLevel[keyof typeof RecruitingCandidate_EducationLevel];
/** Ethnicity options for candidates in the talent pipeline */
export const RecruitingCandidate_Ethnicity = {
  /** African American */
  AfricanAmerican: 'AFRICAN_AMERICAN',
  /** American Indian or Alaskan Native */
  AmericanIndian: 'AMERICAN_INDIAN',
  /** Asian */
  Asian: 'ASIAN',
  /** Hispanic or LatinX */
  Hispanic: 'HISPANIC',
  /** Native Hawaiian or Pacific Islander */
  NativeHawaiian: 'NATIVE_HAWAIIAN',
  /** White */
  White: 'WHITE'
} as const;

export type RecruitingCandidate_Ethnicity = typeof RecruitingCandidate_Ethnicity[keyof typeof RecruitingCandidate_Ethnicity];
/** A set of filters that can be used to limit the list of candidates on the recruiting dashboard. */
export type RecruitingCandidate_Filters = {
  /**
   * The maximum assessment score (from 0 to 100) that a candidate should have
   * achieved to be displayed.
   * Leave null if you do not wish to set a upper-bound on assessment score
   */
  assessmentMaximum?: InputMaybe<Scalars['Int']>;
  /**
   * The minimum assessment score (from 0 to 100) that a candidate should have
   * achieved to be displayed.
   * Leave null if you do not wish to set a lower-bound on assessment score
   */
  assessmentMinimum?: InputMaybe<Scalars['Int']>;
  /**
   * Filter candidates by whether or not they require sponsorship to work in the US.
   * A value of true will return only candidates who do not require sponsorship.
   * A value of false will return only candidates who require sponsorship.
   * Leave null if you do not wish to filter by sponsorship requirements.
   */
  canWorkInUsWithoutSponsorship?: InputMaybe<Scalars['Boolean']>;
  /**
   * One or more degree levels to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by degree level.
   */
  educationLevels?: InputMaybe<Array<RecruitingCandidate_EducationLevel>>;
  /**
   * One or more majors of study to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by major.
   * The complete list of eligible majors that candidates may select can be found here:
   * https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/userprofile/v1beta1/education_profile.proto#L56-L69
   */
  educationMajors?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Any race/ethnicity selections that should be used to filter candidates by.
   * Candidates will be included if they have selected any one of the ethnicities provided.
   * Leave null if you do not wish to filter by ethnicity.
   */
  ethnicities?: InputMaybe<Array<RecruitingCandidate_Ethnicity>>;
  /**
   * Any gender identity selections that should be used to filter candidates by.
   * Candidates will be included if they have selected any one of the gender identities provided.
   * Leave null if you do not wish to filter by gender identity.
   */
  genders?: InputMaybe<Array<RecruitingCandidate_Gender>>;
  /**
   * The maximum year that displayed candidates should have completed their most recent degree.
   * Leave null if you do not wish to set an upper-bound on graduation year
   */
  graduationYearMaximum?: InputMaybe<Scalars['Int']>;
  /**
   * The minimum year that displayed candidates should have completed their most recent degree.
   * Leave null if you do not wish to set a lower-bound on graduation year
   */
  graduationYearMinimum?: InputMaybe<Scalars['Int']>;
  /**
   * Filter candidates by whether or not they have been invited.
   * A value of true will return only candidates who have already been invited.
   * A value of false will return only candidates who have not been invited.
   * Leave null if you do not wish to filter by invitation status.
   */
  hasBeenInvited?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter candidates by whether or not they are eligible to work in the US.
   * A value of true will return only candidates who are eligible.
   * A value of false will return only candidates who are not eligible.
   * Leave null if you do not wish to filter by US work eligibility.
   */
  hasUsWorkAuthorization?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter candidates by whether or not they are protected veterans.
   * A value of true will return only candidates who have self-identifies as protected veterans.
   * A value of false will return only candidates who have self-identified as non-protected veterans.
   * Leave null if you do not wish to filter by veteran status.
   */
  isProtectedVeteran?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter the candidates by their current location.
   * Leave null if you do not wish to filter the candidates by location
   */
  locations?: InputMaybe<Array<RecruitingCandidate_LocationFilter>>;
  /**
   * Filter candidates by whether or not they are members in specific programs.
   * Candidates will be included if they are member of any one of the program IDs provided.
   * Leave null if you do not wish to filter by programs.
   */
  memberPrograms?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Any skills that the candidates should have achieved to be included in the result set.
   * The input should be the name of the skill, not the ID.
   * Candidates will be included if they have any one of the skills provided.
   * Leave null if you do not wish to filter by skill.
   */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Any Specializations that the candidates should have completed to be included in the result set.
   * Candidates will be included if they have completed any one of the specializations provided.
   * Leave null if you do not wish to filter by specialization.
   */
  specializationIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Set to true if you would like to filter to only "diverse" hires.
   * False or null will not filter the candidate result set.
   */
  underrepresentedTalentOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * One or more university names (in English) to filter the candidates by.
   * Leave null if you do not wish to filter the candidates by attended university.
   */
  universities?: InputMaybe<Array<Scalars['String']>>;
  /**
   * Filters candidates by whether or not they are willing to relocate.
   * Leave null if you do not wish to filter candidates by their relocation preferences.
   */
  willingToRelocate?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filters candidates by whether or not they are willing to work remotely.
   * Leave null if you do not wish to filter candidates by their remote work preferences.
   */
  willingToWorkRemote?: InputMaybe<Scalars['Boolean']>;
};

/** Gender options for candidates in the talent pipeline */
export const RecruitingCandidate_Gender = {
  /** Agender */
  Agender: 'AGENDER',
  /** Man */
  Man: 'MAN',
  /** Non-binary */
  NonBinary: 'NON_BINARY',
  /** Transgender man */
  TransgenderMan: 'TRANSGENDER_MAN',
  /** Transgender woman */
  TransgenderWoman: 'TRANSGENDER_WOMAN',
  /** Woman */
  Woman: 'WOMAN'
} as const;

export type RecruitingCandidate_Gender = typeof RecruitingCandidate_Gender[keyof typeof RecruitingCandidate_Gender];
/** A single email invitation that was sent to the candidate */
export type RecruitingCandidate_Invitation = {
  __typename?: 'RecruitingCandidate_Invitation';
  /** The unique ID of this invitation attempt */
  id: Scalars['ID'];
  /** The timestamp that the email request was made by the recruiter */
  sentAt: Scalars['DateTime'];
};

/** A Coursera learner that is an eligible candidate for recruitment */
export type RecruitingCandidate_Item = Node & {
  __typename?: 'RecruitingCandidate_Item';
  /**
   * The candidate's score out of 100 that they achieved on an external assessment to qualify for
   * this role.
   */
  assessmentScore?: Maybe<Scalars['Int']>;
  /** A paginated list of courses (excluding projects) that the learner has completed. */
  completedCourses: RecruitingCandidate_CoursePaginatedResult;
  /** A paginated list of specializations that the learner has completed. */
  completedSpecializations: RecruitingCandidate_SpecializationPaginatedResult;
  /**
   * The total number of courses that the candidate has completed on the Coursera platform
   * @deprecated Replaced by completedCourses field
   */
  courseCompletionCount: Scalars['Int'];
  /** The candidate's email address. */
  email?: Maybe<Scalars['String']>;
  /** The total number of guided projects that the candidate has completed on the Coursera platform */
  guidedProjectCompletionCount: Scalars['Int'];
  /**
   * Unique ID of the candidate.
   * This is an external ID that is OK to be displayed on public APIs and is differend from the userId that
   * is typically used to identify learners throughout the platform.
   */
  id: Scalars['ID'];
  /** Boolean field indicating if the candidate is still a student. */
  isCurrentlyAStudent: Scalars['Boolean'];
  /** Whether or not the candidate is a diverse hire. */
  isUnderrepresented: Scalars['Boolean'];
  /** The location of the candidate's current residence */
  location: RecruitingCandidate_Location;
  /** The candidate's most recent degree that the candidate has earned or is actively pursuing. */
  mostRecentDegree?: Maybe<RecruitingCandidate_Degree>;
  /**
   * The current status of the most recent invitation the candidate has been sent for this role.
   * Null if the candidate has not been invited yet.
   */
  mostRecentInvitation?: Maybe<RecruitingCandidate_Invitation>;
  /** The first and last name of the candidate */
  name: Scalars['String'];
  /** A list of invitation emails sent to the candidate. Empty if no emails have been sent. */
  pastInvitations: Array<RecruitingCandidate_Invitation>;
  /** The total number of programming assignments that the candidate has completed on the Coursera platform */
  programmingAssignmentCompletionCount: Scalars['Int'];
  /**
   * A list of skills that this candidate has obtained on the Coursera platform,
   * organized from most skilled at to least skilled at. | Maximum page size: 10
   */
  skills: RecruitingCandidate_SkillPaginatedResult;
  /**
   * A list of specializations (professional certifications and S12n certifications) that the candidate
   * has completed on the Coursera platform.
   * Empty if the user has not completed any specializations.
   * @deprecated Replaced by completedSpecializations field
   */
  specializationNames: Array<Scalars['String']>;
};


/** A Coursera learner that is an eligible candidate for recruitment */
export type RecruitingCandidate_ItemCompletedCoursesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** A Coursera learner that is an eligible candidate for recruitment */
export type RecruitingCandidate_ItemCompletedSpecializationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** A Coursera learner that is an eligible candidate for recruitment */
export type RecruitingCandidate_ItemSkillsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/**
 * A location.
 * For instance the location of a candidate's current residence or the location of a potential job
 */
export type RecruitingCandidate_Location = {
  __typename?: 'RecruitingCandidate_Location';
  /** The name (in English) of the candidate's city. */
  cityName?: Maybe<Scalars['String']>;
  /** The name (in English) of the candidate's country. */
  countryName: Scalars['String'];
  /** The name (in English) of the candidate's state. */
  stateName?: Maybe<Scalars['String']>;
};

/** Filters the candidates by their current lat/long location */
export type RecruitingCandidate_LocationFilter = {
  /** The latitude of the location */
  latitude: Scalars['Float'];
  /** The longitude of the location */
  longitude: Scalars['Float'];
  /**
   * The number of kilometers from the specified lat/long point that
   * we will allow candidates to be in.
   * Defaults to 60km
   */
  radiusKilometers?: Scalars['Int'];
};

/** A single Coursera Skill that a recruiting candidate has obtained on our platform. */
export type RecruitingCandidate_Skill = {
  __typename?: 'RecruitingCandidate_Skill';
  /** The name (in English) of the skill */
  name: Scalars['String'];
};

/** A paginated list of skills that a candidate has achieved on the Coursera platform. */
export type RecruitingCandidate_SkillPaginatedResult = {
  __typename?: 'RecruitingCandidate_SkillPaginatedResult';
  /** The list of skills on the current page */
  elements: Array<RecruitingCandidate_Skill>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** Whether we should sort ascending or descending */
export const RecruitingCandidate_SortDirection = {
  /** Sort from low to high */
  Asc: 'ASC',
  /** Sort from high to low */
  Desc: 'DESC'
} as const;

export type RecruitingCandidate_SortDirection = typeof RecruitingCandidate_SortDirection[keyof typeof RecruitingCandidate_SortDirection];
/** The column or field that we want to sort by */
export const RecruitingCandidate_SortField = {
  /** Sorts candidates by the grade that they have achieved on the job-specific qualifying assessment */
  AssessmentScore: 'ASSESSMENT_SCORE',
  /**
   * Sorts candidates based on their usage of the coursera platform.
   * Namely this means sorting by number of specializations, then by number of programming assignments
   */
  CourseraCredentials: 'COURSERA_CREDENTIALS'
} as const;

export type RecruitingCandidate_SortField = typeof RecruitingCandidate_SortField[keyof typeof RecruitingCandidate_SortField];
/** The order in which the candidates should be returned within the candidates list. */
export type RecruitingCandidate_SortOption = {
  /** Whether we should sort ascending or descending */
  direction: RecruitingCandidate_SortDirection;
  /** The column or field that we want to sort by */
  field: RecruitingCandidate_SortField;
};

/** A paginated list of specializations that a candidate has completed. */
export type RecruitingCandidate_SpecializationPaginatedResult = {
  __typename?: 'RecruitingCandidate_SpecializationPaginatedResult';
  /**
   * The list of specializations the the learner has completed.
   * This is a combination of both s12 (professional certs) as well as other specializations.
   *
   * Specialization here is nullable because we have had an issue where certain users don't have access
   * to certain certs. Instead of failing the whole call, just return null in this case.
   */
  elements: Array<Maybe<Specialization_Specialization>>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** City object */
export type RecruitingCities_City = {
  __typename?: 'RecruitingCities_City';
  /** The code of the administrative division */
  adminCode?: Maybe<Scalars['String']>;
  /** The name of the administrative division where the city is located */
  adminName?: Maybe<Scalars['String']>;
  /** The ASCII representation of the administrative division name */
  adminNameAscii?: Maybe<Scalars['String']>;
  /** The type of the administrative division */
  adminType?: Maybe<Scalars['String']>;
  /** The capital city of the administrative division */
  capital?: Maybe<Scalars['String']>;
  /** The name of the city */
  city?: Maybe<Scalars['String']>;
  /** An alternative name for the city */
  cityAlt?: Maybe<Array<Scalars['String']>>;
  /** The ASCII representation of the city name */
  cityAscii?: Maybe<Scalars['String']>;
  /** The country where the city is located */
  country?: Maybe<Scalars['String']>;
  /** The population density of the city per square kilometer at the lat/lng */
  density?: Maybe<Scalars['Float']>;
  /** The unique identifier of the city */
  id: Scalars['ID'];
  /** The ISO 2-letter code of the country */
  iso2?: Maybe<Scalars['String']>;
  /** The ISO 3-letter code of the country */
  iso3?: Maybe<Scalars['String']>;
  /** The latitude coordinate of the city */
  lat?: Maybe<Scalars['Float']>;
  /** The longitude coordinate of the city */
  lng?: Maybe<Scalars['Float']>;
  /** The total population of the city */
  population?: Maybe<Scalars['Int']>;
  /** The population of the city proper is an estimate of the city's municipal population. It is count the municipal population that lies within the urban area so population_proper will always be smaller than or equal to population */
  populationProper?: Maybe<Scalars['Int']>;
  /** The ranking of the city. An integer from 1-5 that captures the importance of a city (1 is most important, 5 least important). */
  ranking?: Maybe<Scalars['Int']>;
  /** Indicates if there are other cities with the same name */
  sameName?: Maybe<Scalars['Boolean']>;
  /** The timezone of the city */
  timezone?: Maybe<Scalars['String']>;
};

/** Response object for city search */
export type RecruitingCities_CityPaginatedResult = {
  __typename?: 'RecruitingCities_CityPaginatedResult';
  /** List of cities */
  elements: Array<RecruitingCities_City>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** Queries for RecruitingInvitation */
export type RecruitingInvitationQueries = {
  __typename?: 'RecruitingInvitationQueries';
  /** Returns the body HTML and Subject for a given Email */
  preview: RecruitingInvitation_Preview;
};


/** Queries for RecruitingInvitation */
export type RecruitingInvitationQueriesPreviewArgs = {
  email: RecruitingInvitation_Email;
};

/** Input type for the email object */
export type RecruitingInvitation_Email = {
  /** The body (content) of the email. This will be CML generated by FE rich text editor. */
  body: CmlContentInput;
  /** The label of the call to action button in the email */
  ctaLabel: Scalars['String'];
  /** Display name on who is sending the email. */
  fromName: Scalars['String'];
  /** The ID of the position that the recruiter is sending an invite email */
  positionId: Scalars['ID'];
  /** The URL for the position page to go when call to action button is clicked */
  positionUrl: Scalars['URL'];
  /** The subject of the email */
  subject: Scalars['String'];
  /** The total number of candidates in the filter chosen when invitation is being sent */
  totalInFilter: Scalars['Int'];
};

/** The result returned if any errors are hit during sending invitations by filters */
export type RecruitingInvitation_InviteByFiltersFailure = {
  __typename?: 'RecruitingInvitation_InviteByFiltersFailure';
  /** List of errors */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input type for sending invitation emails by filters */
export type RecruitingInvitation_InviteByFiltersInput = {
  /** The email to be sent to candidates */
  email: RecruitingInvitation_Email;
  /**
   * A set of optional filtering parameters that can be used to reduce the number
   * of candidates returned
   */
  optionalFilters?: InputMaybe<RecruitingCandidate_Filters>;
};

/** Result from sending invitations by filters */
export type RecruitingInvitation_InviteByFiltersResult = RecruitingInvitation_InviteByFiltersFailure | RecruitingInvitation_InviteByFiltersSuccess;

/** The response when sending invitations by filters is successful */
export type RecruitingInvitation_InviteByFiltersSuccess = {
  __typename?: 'RecruitingInvitation_InviteByFiltersSuccess';
  /** The ID of master invitation record */
  invitationId: Scalars['ID'];
};

/** The result returned if any errors are hit during sending invitations by external IDs */
export type RecruitingInvitation_InviteByIdsFailure = {
  __typename?: 'RecruitingInvitation_InviteByIdsFailure';
  /** List of errors */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input type for sending invitation emails by external IDs */
export type RecruitingInvitation_InviteByIdsInput = {
  /** The email to be sent to candidates */
  email: RecruitingInvitation_Email;
  /** List of External IDs of the candidates that will receive the invitations */
  externalIds: Array<Scalars['ID']>;
};

/** Result from sending invitations by external IDs */
export type RecruitingInvitation_InviteByIdsResult = RecruitingInvitation_InviteByIdsFailure | RecruitingInvitation_InviteByIdsSuccess;

/** The response when sending invitations by external IDs is successful */
export type RecruitingInvitation_InviteByIdsSuccess = {
  __typename?: 'RecruitingInvitation_InviteByIdsSuccess';
  /** The ID of master invitation record */
  invitationId: Scalars['ID'];
};

/** Represents the HTML body and subject of an email */
export type RecruitingInvitation_Preview = {
  __typename?: 'RecruitingInvitation_Preview';
  /** The HTML body */
  body: Scalars['String'];
  /** Subject of email */
  subject: Scalars['String'];
};

/** Queries for RecruitingPositions */
export type RecruitingPositionQueries = {
  __typename?: 'RecruitingPositionQueries';
  /** Get the list of open positions at the organization provided. | Maximum page size: 100 */
  queryByOrganizationId: RecruitingPosition_Connection;
  /**
   * Load the open position by organization and slug.
   * This will return a single, unique result.
   */
  queryBySlug: RecruitingPosition_Item;
};


/** Queries for RecruitingPositions */
export type RecruitingPositionQueriesQueryByOrganizationIdArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
  organizationId: Scalars['ID'];
};


/** Queries for RecruitingPositions */
export type RecruitingPositionQueriesQueryBySlugArgs = {
  organizationId: Scalars['ID'];
  positionSlug: Scalars['String'];
};

/** Assessment information for a given position. */
export type RecruitingPosition_Assessment = {
  __typename?: 'RecruitingPosition_Assessment';
  /** Unique ID of the assessment. It is unique across all countries. */
  id: Scalars['ID'];
  /** Boolean field indicating if the assessment is optional. */
  isAssessmentOptional: Scalars['Boolean'];
};

/** Represents a paginated list of RecruitingPositions */
export type RecruitingPosition_Connection = {
  __typename?: 'RecruitingPosition_Connection';
  /** The paginated list */
  edges: Array<RecruitingPosition_Edge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** The country associated with this position */
export const RecruitingPosition_Country = {
  /** Andorra */
  Ad: 'AD',
  /** United Arab Emirates */
  Ae: 'AE',
  /** Afghanistan */
  Af: 'AF',
  /** Antigua and Barbuda */
  Ag: 'AG',
  /** Anguilla */
  Ai: 'AI',
  /** Albania */
  Al: 'AL',
  /** Armenia */
  Am: 'AM',
  /** Netherlands Antilles */
  An: 'AN',
  /** Angola */
  Ao: 'AO',
  /** Antarctica */
  Aq: 'AQ',
  /** Argentina */
  Ar: 'AR',
  /** American Samoa */
  As: 'AS',
  /** Austria */
  At: 'AT',
  /** Australia */
  Au: 'AU',
  /** Aruba */
  Aw: 'AW',
  /** Åland Islands */
  Ax: 'AX',
  /** Azerbaijan */
  Az: 'AZ',
  /** Bosnia and Herzegovina */
  Ba: 'BA',
  /** Barbados */
  Bb: 'BB',
  /** Bangladesh */
  Bd: 'BD',
  /** Belgium */
  Be: 'BE',
  /** Burkina Faso */
  Bf: 'BF',
  /** Bulgaria */
  Bg: 'BG',
  /** Bahrain */
  Bh: 'BH',
  /** Burundi */
  Bi: 'BI',
  /** Benin */
  Bj: 'BJ',
  /** Saint Barthélemy */
  Bl: 'BL',
  /** Bermuda */
  Bm: 'BM',
  /** Brunei Darussalam */
  Bn: 'BN',
  /** Bolivia */
  Bo: 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq: 'BQ',
  /** Brazil */
  Br: 'BR',
  /** Bahamas */
  Bs: 'BS',
  /** Bhutan */
  Bt: 'BT',
  /** Bouvet Island */
  Bv: 'BV',
  /** Botswana */
  Bw: 'BW',
  /** Belarus */
  By: 'BY',
  /** Belize */
  Bz: 'BZ',
  /** Canada */
  Ca: 'CA',
  /** Cocos (Keeling) Islands */
  Cc: 'CC',
  /** Congo, The Democratic Republic of the */
  Cd: 'CD',
  /** Central African Republic */
  Cf: 'CF',
  /** Congo */
  Cg: 'CG',
  /** Switzerland */
  Ch: 'CH',
  /** Cote D'Ivoire */
  Ci: 'CI',
  /** Cook Islands */
  Ck: 'CK',
  /** Chile */
  Cl: 'CL',
  /** Cameroon */
  Cm: 'CM',
  /** China */
  Cn: 'CN',
  /** Colombia */
  Co: 'CO',
  /** Costa Rica */
  Cr: 'CR',
  /** Cuba */
  Cu: 'CU',
  /** Cape Verde */
  Cv: 'CV',
  /** Curaçao */
  Cw: 'CW',
  /** Christmas Island */
  Cx: 'CX',
  /** Cyprus */
  Cy: 'CY',
  /** Czech Republic */
  Cz: 'CZ',
  /** Germany */
  De: 'DE',
  /** Djibouti */
  Dj: 'DJ',
  /** Denmark */
  Dk: 'DK',
  /** Dominica */
  Dm: 'DM',
  /** Dominican Republic */
  Do: 'DO',
  /** Algeria */
  Dz: 'DZ',
  /** Ecuador */
  Ec: 'EC',
  /** Estonia */
  Ee: 'EE',
  /** Egypt */
  Eg: 'EG',
  /** Western Sahara */
  Eh: 'EH',
  /** Eritrea */
  Er: 'ER',
  /** Spain */
  Es: 'ES',
  /** Ethiopia */
  Et: 'ET',
  /** Finland */
  Fi: 'FI',
  /** Fiji */
  Fj: 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk: 'FK',
  /** Micronesia, Federated States of */
  Fm: 'FM',
  /** Faroe Islands */
  Fo: 'FO',
  /** France */
  Fr: 'FR',
  /** Gabon */
  Ga: 'GA',
  /** United Kingdom */
  Gb: 'GB',
  /** Grenada */
  Gd: 'GD',
  /** Georgia */
  Ge: 'GE',
  /** French Guiana */
  Gf: 'GF',
  /** Guernsey */
  Gg: 'GG',
  /** Ghana */
  Gh: 'GH',
  /** Gibraltar */
  Gi: 'GI',
  /** Greenland */
  Gl: 'GL',
  /** Gambia */
  Gm: 'GM',
  /** Guinea */
  Gn: 'GN',
  /** Guadeloupe */
  Gp: 'GP',
  /** Equatorial Guinea */
  Gq: 'GQ',
  /** Greece */
  Gr: 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs: 'GS',
  /** Guatemala */
  Gt: 'GT',
  /** Guam */
  Gu: 'GU',
  /** Guinea-Bissau */
  Gw: 'GW',
  /** Guyana */
  Gy: 'GY',
  /** Hong Kong */
  Hk: 'HK',
  /** Heard Island and Mcdonald Islands */
  Hm: 'HM',
  /** Honduras */
  Hn: 'HN',
  /** Croatia */
  Hr: 'HR',
  /** Haiti */
  Ht: 'HT',
  /** Hungary */
  Hu: 'HU',
  /** Indonesia */
  Id: 'ID',
  /** Ireland */
  Ie: 'IE',
  /** Israel */
  Il: 'IL',
  /** Isle of Man */
  Im: 'IM',
  /** India */
  In: 'IN',
  /** British Indian Ocean Territory */
  Io: 'IO',
  /** Iraq */
  Iq: 'IQ',
  /** Iran, Islamic Republic of */
  Ir: 'IR',
  /** Iceland */
  Is: 'IS',
  /** Italy */
  It: 'IT',
  /** Jersey */
  Je: 'JE',
  /** Jamaica */
  Jm: 'JM',
  /** Jordan */
  Jo: 'JO',
  /** Japan */
  Jp: 'JP',
  /** Kenya */
  Ke: 'KE',
  /** Kyrgyzstan */
  Kg: 'KG',
  /** Cambodia */
  Kh: 'KH',
  /** Kiribati */
  Ki: 'KI',
  /** Comoros */
  Km: 'KM',
  /** Saint Kitts and Nevis */
  Kn: 'KN',
  /** Korea, Democratic People's Republic of */
  Kp: 'KP',
  /** Korea, Republic of */
  Kr: 'KR',
  /** Kuwait */
  Kw: 'KW',
  /** Cayman Islands */
  Ky: 'KY',
  /** Kazakhstan */
  Kz: 'KZ',
  /** Lao People's Democratic Republic */
  La: 'LA',
  /** Lebanon */
  Lb: 'LB',
  /** Saint Lucia */
  Lc: 'LC',
  /** Liechtenstein */
  Li: 'LI',
  /** Sri Lanka */
  Lk: 'LK',
  /** Liberia */
  Lr: 'LR',
  /** Lesotho */
  Ls: 'LS',
  /** Lithuania */
  Lt: 'LT',
  /** Luxembourg */
  Lu: 'LU',
  /** Latvia */
  Lv: 'LV',
  /** Libya */
  Ly: 'LY',
  /** Morocco */
  Ma: 'MA',
  /** Monaco */
  Mc: 'MC',
  /** Moldova, Republic of */
  Md: 'MD',
  /** Montenegro */
  Me: 'ME',
  /** Saint Martin */
  Mf: 'MF',
  /** Madagascar */
  Mg: 'MG',
  /** Marshall Islands */
  Mh: 'MH',
  /** Macedonia, The Former Yugoslav Republic of */
  Mk: 'MK',
  /** Mali */
  Ml: 'ML',
  /** Myanmar */
  Mm: 'MM',
  /** Mongolia */
  Mn: 'MN',
  /** Macao */
  Mo: 'MO',
  /** Northern Mariana Islands */
  Mp: 'MP',
  /** Martinique */
  Mq: 'MQ',
  /** Mauritania */
  Mr: 'MR',
  /** Montserrat */
  Ms: 'MS',
  /** Malta */
  Mt: 'MT',
  /** Mauritius */
  Mu: 'MU',
  /** Maldives */
  Mv: 'MV',
  /** Malawi */
  Mw: 'MW',
  /** Mexico */
  Mx: 'MX',
  /** Malaysia */
  My: 'MY',
  /** Mozambique */
  Mz: 'MZ',
  /** Namibia */
  Na: 'NA',
  /** New Caledonia */
  Nc: 'NC',
  /** Niger */
  Ne: 'NE',
  /** Norfolk Island */
  Nf: 'NF',
  /** Nigeria */
  Ng: 'NG',
  /** Nicaragua */
  Ni: 'NI',
  /** Netherlands */
  Nl: 'NL',
  /** Norway */
  No: 'NO',
  /** Nepal */
  Np: 'NP',
  /** Nauru */
  Nr: 'NR',
  /** Niue */
  Nu: 'NU',
  /** New Zealand */
  Nz: 'NZ',
  /** Oman */
  Om: 'OM',
  /** Panama */
  Pa: 'PA',
  /** Peru */
  Pe: 'PE',
  /** French Polynesia */
  Pf: 'PF',
  /** Papua New Guinea */
  Pg: 'PG',
  /** Philippines */
  Ph: 'PH',
  /** Pakistan */
  Pk: 'PK',
  /** Poland */
  Pl: 'PL',
  /** Saint Pierre and Miquelon */
  Pm: 'PM',
  /** Pitcairn */
  Pn: 'PN',
  /** Puerto Rico */
  Pr: 'PR',
  /** Palestinian Territory, Occupied */
  Ps: 'PS',
  /** Portugal */
  Pt: 'PT',
  /** Palau */
  Pw: 'PW',
  /** Paraguay */
  Py: 'PY',
  /** Qatar */
  Qa: 'QA',
  /** Akrotiri */
  Qz: 'QZ',
  /** Reunion */
  Re: 'RE',
  /** Romania */
  Ro: 'RO',
  /** Serbia */
  Rs: 'RS',
  /** Russian Federation */
  Ru: 'RU',
  /** Rwanda */
  Rw: 'RW',
  /** Saudi Arabia */
  Sa: 'SA',
  /** Solomon Islands */
  Sb: 'SB',
  /** Seychelles */
  Sc: 'SC',
  /** Sudan */
  Sd: 'SD',
  /** Sweden */
  Se: 'SE',
  /** Singapore */
  Sg: 'SG',
  /** Saint Helena */
  Sh: 'SH',
  /** Slovenia */
  Si: 'SI',
  /** Svalbard and Jan Mayen */
  Sj: 'SJ',
  /** Slovakia */
  Sk: 'SK',
  /** Sierra Leone */
  Sl: 'SL',
  /** San Marino */
  Sm: 'SM',
  /** Senegal */
  Sn: 'SN',
  /** Somalia */
  So: 'SO',
  /** Suriname */
  Sr: 'SR',
  /** South Sudan */
  Ss: 'SS',
  /** Sao Tome and Principe */
  St: 'ST',
  /** El Salvador */
  Sv: 'SV',
  /** Sint Maarten (Dutch part) */
  Sx: 'SX',
  /** Syrian Arab Republic */
  Sy: 'SY',
  /** Swaziland */
  Sz: 'SZ',
  /** Turks and Caicos Islands */
  Tc: 'TC',
  /** Chad */
  Td: 'TD',
  /** French Southern Territories */
  Tf: 'TF',
  /** Togo */
  Tg: 'TG',
  /** Thailand */
  Th: 'TH',
  /** Tajikistan */
  Tj: 'TJ',
  /** Tokelau */
  Tk: 'TK',
  /** Timor-Leste */
  Tl: 'TL',
  /** Turkmenistan */
  Tm: 'TM',
  /** Tunisia */
  Tn: 'TN',
  /** Tonga */
  To: 'TO',
  /** Turkey */
  Tr: 'TR',
  /** Trinidad and Tobago */
  Tt: 'TT',
  /** Tuvalu */
  Tv: 'TV',
  /** Taiwan */
  Tw: 'TW',
  /** Tanzania, United Republic of */
  Tz: 'TZ',
  /** Ukraine */
  Ua: 'UA',
  /** Uganda */
  Ug: 'UG',
  /** United States Minor Outlying Islands */
  Um: 'UM',
  /** United States */
  Us: 'US',
  /** Uruguay */
  Uy: 'UY',
  /** Uzbekistan */
  Uz: 'UZ',
  /** Holy See (Vatican City State) */
  Va: 'VA',
  /** Saint Vincent and the Grenadines */
  Vc: 'VC',
  /** Venezuela */
  Ve: 'VE',
  /** Virgin Islands, British */
  Vg: 'VG',
  /** Virgin Islands, U.S. */
  Vi: 'VI',
  /** Vietnam */
  Vn: 'VN',
  /** Vanuatu */
  Vu: 'VU',
  /** Wallis and Futuna */
  Wf: 'WF',
  /** Samoa */
  Ws: 'WS',
  /** Gaza Strip */
  Xg: 'XG',
  /** Kosovo */
  Xk: 'XK',
  /** Svalbard */
  Xr: 'XR',
  /** Spratly Islands */
  Xs: 'XS',
  /** West Bank */
  Xw: 'XW',
  /** Yemen */
  Ye: 'YE',
  /** Mayotte */
  Yt: 'YT',
  /** South Africa */
  Za: 'ZA',
  /** Zambia */
  Zm: 'ZM',
  /** Zimbabwe */
  Zw: 'ZW'
} as const;

export type RecruitingPosition_Country = typeof RecruitingPosition_Country[keyof typeof RecruitingPosition_Country];
/** The result returned if any errors are hit during position creation */
export type RecruitingPosition_CreateFailure = {
  __typename?: 'RecruitingPosition_CreateFailure';
  /** List of errors */
  errors: Array<AuthorizationError | CoreSkillTaxonomyBranch_GenericError | CoreSkillTaxonomyNode_GenericError | FinancialAidApplication_Error | IMochaAssessment_TestAttemptAlreadyTaken | ItemPlatform_ConflictDetectionTokenMismatchError | ItemPlatform_FrozenAtomMutationError | ItemPlatform_ValidationError | LtiPlatform_GenericValidation | LtiPlatform_IntRangeValidation | LtiPlatform_NumericRangeValidation | LtiPlatform_TextLengthValidation | LtiPlatform_WordCountValidation | RoleSkillMappingBranch_GenericError | RoleSkillMappingNode_GenericError | Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Creates a new recruiting position */
export type RecruitingPosition_CreateInput = {
  /** The country in which eligible candidates should reside */
  hiringCountry: RecruitingPosition_Country;
  /** The name of the position to be displayed in the recruiting dashboard */
  name: Scalars['String'];
  /**
   * The type of occupation or industry that this position is for.
   * Null if this position is not associated with one specific occupation type.
   */
  occupationId?: InputMaybe<Scalars['ID']>;
  /** The ID of the third party organization that this position is under */
  organizationId: Scalars['ID'];
  /** The slug of the position, which should be unique within a given organization */
  positionSlug: Scalars['String'];
};

/** Result from creating a new recruiting position */
export type RecruitingPosition_CreateResult = RecruitingPosition_CreateFailure | RecruitingPosition_CreateSuccess;

/** The response when creating a new recruiting position was successful */
export type RecruitingPosition_CreateSuccess = {
  __typename?: 'RecruitingPosition_CreateSuccess';
  /** The ID of the newly created position */
  id: Scalars['ID'];
};

/** RecruitingPosition Mutation Error */
export type RecruitingPosition_DeleteError = {
  /** Error message */
  message: Scalars['String'];
};

/** The result returned if any errors are hit during position deletion */
export type RecruitingPosition_DeleteFailure = {
  __typename?: 'RecruitingPosition_DeleteFailure';
  /** List of errors */
  errors: Array<RecruitingPosition_DeleteError>;
};

/** Deletes an existing recruiting position */
export type RecruitingPosition_DeleteInput = {
  /** The ID of the position to be deleted */
  id: Scalars['ID'];
};

/** Result from deleting an existing recruiting position */
export type RecruitingPosition_DeleteResult = RecruitingPosition_DeleteFailure | RecruitingPosition_DeleteSuccess;

/** The response when deleting an existent recruiting position was successful */
export type RecruitingPosition_DeleteSuccess = {
  __typename?: 'RecruitingPosition_DeleteSuccess';
  /** The ID of the deleted position */
  id: Scalars['ID'];
};

/** Represents a RecruitingPosition with its pagination cursor */
export type RecruitingPosition_Edge = {
  __typename?: 'RecruitingPosition_Edge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** A single open position at the organization */
  node: RecruitingPosition_Item;
};

/**
 * Position-specific settings that can be used to toggle on/off
 * certain filters.
 */
export type RecruitingPosition_FilterConfigurations = {
  __typename?: 'RecruitingPosition_FilterConfigurations';
  /** Whether or not the ethnicity filter should be enabled for the given position. */
  ethnicityFilterEnabled: Scalars['Boolean'];
  /** Whether or not the gender filter should be enabled for the given position. */
  genderFilterEnabled: Scalars['Boolean'];
  /** Whether or not the US work eligibility filters should be enabled for the given position. */
  uSWorkEligibilityFiltersEnabled: Scalars['Boolean'];
  /** Whether or not the veteran status filter should be enabled for the given position. */
  veteranStatusFilterEnabled: Scalars['Boolean'];
};

/** A single open position at the organization */
export type RecruitingPosition_Item = Node & {
  __typename?: 'RecruitingPosition_Item';
  /** Assessment information for the position. Null if position does not have an assessment */
  assessment?: Maybe<RecruitingPosition_Assessment>;
  /** The country where the position is valid. */
  country: RecruitingPosition_Country;
  /** A description (in English) of the position */
  description: Scalars['String'];
  /**
   * Position-specific settings that can be used to toggle on/off
   * certain filters.
   */
  filterConfigurations: RecruitingPosition_FilterConfigurations;
  /** Unique ID of the position. It is unique across all organizations. */
  id: Scalars['ID'];
  /** The name (in English) of the position */
  name: Scalars['String'];
  /**
   * A Unique ID of this position within the Organization.
   * This value should be human-readable and may be displayed to the user via URL
   */
  positionSlug: Scalars['String'];
  /** The total number of candidates who have already been invited to apply for this position */
  totalInvitedCandidates: Scalars['Int'];
  /** The total number of candidates who currently qualify for the position */
  totalQualifiedCandidates: Scalars['Int'];
};

/** Input type for redeeming a course credit */
export type RedeemCourseCreditInput = {
  /** ID of the cart to apply the credit to */
  cartId: Scalars['String'];
  /** ID of the credit to redeem */
  creditId: Scalars['String'];
};

/** Result of a course credit redemption operation */
export type RedeemCourseCreditResult = {
  __typename?: 'RedeemCourseCreditResult';
  /** The redeemed credit */
  credit?: Maybe<CourseCredit>;
  /** Error message if the operation failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean'];
};

/** Input type for refunding a course credit */
export type RefundCourseCreditInput = {
  /** ID of the credit to refund */
  creditId: Scalars['String'];
};

/** Result of a course credit refund operation */
export type RefundCourseCreditResult = {
  __typename?: 'RefundCourseCreditResult';
  /** Error message if the operation failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** The newly generated credit */
  newCredit?: Maybe<CourseCredit>;
  /** The refunded credit */
  refundedCredit?: Maybe<CourseCredit>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean'];
};

export type ResponsePagination = {
  __typename?: 'ResponsePagination';
  next?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

/** [Deprecated] Reusable comments GraphQL queries */
export type ReusableCommentsQueries = {
  __typename?: 'ReusableCommentsQueries';
  /** This query returns a single comment for a comment id */
  queryComment?: Maybe<ReusableComments_ReusableComment>;
  /** This query returns all comments based on filter */
  queryCommentsByFilter?: Maybe<Array<ReusableComments_ReusableComment>>;
  /** This query returns grader's comments */
  queryOwnComments?: Maybe<Array<ReusableComments_ReusableComment>>;
};


/** [Deprecated] Reusable comments GraphQL queries */
export type ReusableCommentsQueriesQueryCommentArgs = {
  id: Scalars['ID'];
};


/** [Deprecated] Reusable comments GraphQL queries */
export type ReusableCommentsQueriesQueryCommentsByFilterArgs = {
  commentFilter: ReusableComments_CommentFilter;
};


/** [Deprecated] Reusable comments GraphQL queries */
export type ReusableCommentsQueriesQueryOwnCommentsArgs = {
  commentFilter?: InputMaybe<ReusableComments_CommentFilter>;
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CommentFilter = {
  /** [Required] filters results to assignment id */
  assignmentId: Scalars['ID'];
  /** [Required] filters results to review part id */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CreateReusableCommentInput = {
  /** TODO: Complete this description */
  assignmentId: Scalars['ID'];
  /** TODO: Complete this description */
  assignmentVersion: Scalars['Int'];
  /** TODO: Complete this description */
  commentText: Scalars['String'];
  /** TODO: Complete this description */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] Result of the ReusableComments_CreateReusableComment mutation */
export type ReusableComments_CreateReusableCommentResult = {
  __typename?: 'ReusableComments_CreateReusableCommentResult';
  /** Created reusable comment */
  reusableComment: ReusableComments_ReusableComment;
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_CreateReusableCommentUsageInput = {
  /** TODO: Complete this description */
  assignmentId: Scalars['ID'];
  /** TODO: Complete this description */
  assignmentVersion: Scalars['Int'];
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
  /** TODO: Complete this description */
  reviewPartId: Scalars['ID'];
};

/** [Deprecated] Result of the ReusableComments_CreateReusableCommentUsage mutation */
export type ReusableComments_CreateReusableCommentUsageResult = {
  __typename?: 'ReusableComments_CreateReusableCommentUsageResult';
  /** Created reusable comment usage */
  reusableCommentUsage: ReusableComments_ReusableCommentUsage;
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_DeleteReusableCommentInput = {
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
};

/** [Deprecated] Result of the ReusableComments_DeleteReusableComment mutation */
export type ReusableComments_DeleteReusableCommentResult = {
  __typename?: 'ReusableComments_DeleteReusableCommentResult';
  /** Id of deleted reusable comment */
  commentId: Scalars['ID'];
};

/** [Deprecated] Reusable comments GraphQL schema */
export type ReusableComments_ReusableComment = {
  __typename?: 'ReusableComments_ReusableComment';
  /** The comment text. */
  commentText: Scalars['String'];
  /** The comment id. */
  id: Scalars['ID'];
  /** The comment aggregated usage metrics */
  usageMetrics: ReusableComments_UsageMetrics;
  /** The user id. */
  userId: Scalars['ID'];
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_ReusableCommentUsage = {
  __typename?: 'ReusableComments_ReusableCommentUsage';
  /** The assignment id. */
  assignmentId: Scalars['ID'];
  /** The comment id. */
  commentId: Scalars['ID'];
  /** The comment usage id */
  id: Scalars['ID'];
  /** The review part id. */
  reviewPartId: Scalars['ID'];
  /** Last time that grader reuses comment. */
  usageTime: Timestamp;
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_UpdateReusableCommentInput = {
  /** TODO: Complete this description */
  commentId: Scalars['ID'];
  /** TODO: Complete this description */
  commentText: Scalars['String'];
};

/** [Deprecated] Result of the ReusableComments_UpdateReusableComment mutation */
export type ReusableComments_UpdateReusableCommentResult = {
  __typename?: 'ReusableComments_UpdateReusableCommentResult';
  /** Updated reusable comment */
  reusableComment: ReusableComments_ReusableComment;
};

/** [Deprecated] TODO: Complete this description */
export type ReusableComments_UsageMetrics = {
  __typename?: 'ReusableComments_UsageMetrics';
  /** The Comment Id */
  id: Scalars['ID'];
  /** Comment last used time */
  lastUsedAt: Timestamp;
  /** Comment usage count */
  usageCount: Scalars['Int'];
};

/** Role Skills mapping branch queries definition */
export type RoleSkillMappingBranchQueries = {
  __typename?: 'RoleSkillMappingBranchQueries';
  /** a query for role skill mappings */
  queryRoleSkillMappingBranchByNameAndStatus: RoleSkillMappingBranch_PaginatedResult;
};


/** Role Skills mapping branch queries definition */
export type RoleSkillMappingBranchQueriesQueryRoleSkillMappingBranchByNameAndStatusArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  name: Scalars['String'];
  statuses: Array<RoleSkillMappingBranch_Status>;
};

/** Role Skills mapping branch content */
export type RoleSkillMappingBranch_BranchContent = {
  __typename?: 'RoleSkillMappingBranch_BranchContent';
  /** craeted timestamp */
  createdTime: Scalars['DateTime'];
  /**
   * Branch ID/Name
   * use id to instead of name to help the client side caching
   */
  id: Scalars['ID'];
  /** Last updated userId */
  lastUpdatedByUser: Scalars['ID'];
  /** Last updated timestamp */
  lastUpdatedTime: Scalars['DateTime'];
  /** Branch Status */
  status: RoleSkillMappingBranch_Status;
};

/** Input argument for create new branch. */
export type RoleSkillMappingBranch_CreateNewBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for create new branch. */
export type RoleSkillMappingBranch_CreateNewBranchResult = RoleSkillMappingBranch_CreateNewBranchSuccess | RoleSkillMappingBranch_GenericError;

/** Success result for create new branch. */
export type RoleSkillMappingBranch_CreateNewBranchSuccess = {
  __typename?: 'RoleSkillMappingBranch_CreateNewBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Input argument for deactivate branch. */
export type RoleSkillMappingBranch_DeactivateBranchInput = {
  /** Flag to force deactivate freeze branch */
  includeFreezeBranch?: Scalars['Boolean'];
  /** The branch name */
  name: Scalars['String'];
};

/** Result for deactivate branch. */
export type RoleSkillMappingBranch_DeactivateBranchResult = RoleSkillMappingBranch_DeactivateBranchSuccess | RoleSkillMappingBranch_GenericError;

/** Success result for deactivate branch. */
export type RoleSkillMappingBranch_DeactivateBranchSuccess = {
  __typename?: 'RoleSkillMappingBranch_DeactivateBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Input argument for freeze branch. */
export type RoleSkillMappingBranch_FreezeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for freeze branch. */
export type RoleSkillMappingBranch_FreezeBranchResult = RoleSkillMappingBranch_FreezeBranchSuccess | RoleSkillMappingBranch_GenericError;

/** Success result for freeze branch. */
export type RoleSkillMappingBranch_FreezeBranchSuccess = {
  __typename?: 'RoleSkillMappingBranch_FreezeBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Generic error for RoleSkillMappingBranch */
export type RoleSkillMappingBranch_GenericError = ErrorDetails & {
  __typename?: 'RoleSkillMappingBranch_GenericError';
  /**
   * errorCode is a custom code when used with one of the predfined shared/standard errors.
   * When a developer defines a new custom error using the ErrorDetails interface, they should use the name of the custom error as the code.
   */
  errorCode: Scalars['String'];
  /** A readable message providing the error details. */
  message: Scalars['String'];
  /** The path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Input argument for merge branch. */
export type RoleSkillMappingBranch_MergeBranchInput = {
  /** The branch name */
  name: Scalars['String'];
};

/** Result for merge branch. */
export type RoleSkillMappingBranch_MergeBranchResult = RoleSkillMappingBranch_GenericError | RoleSkillMappingBranch_MergeBranchSuccess;

/** Success result for merge branch. */
export type RoleSkillMappingBranch_MergeBranchSuccess = {
  __typename?: 'RoleSkillMappingBranch_MergeBranchSuccess';
  /** The result */
  result: Scalars['Boolean'];
};

/** Role Skills mapping paginated results. */
export type RoleSkillMappingBranch_PaginatedResult = {
  __typename?: 'RoleSkillMappingBranch_PaginatedResult';
  /** Branch Content. */
  elements: Array<RoleSkillMappingBranch_BranchContent>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Role Skills mapping branch status */
export const RoleSkillMappingBranch_Status = {
  /** branch active for editing */
  Active: 'ACTIVE',
  /** branch deactivated for all operation other than deletion */
  Deactivate: 'DEACTIVATE',
  /** branch freezed for labelling and A/B testing */
  Freeze: 'FREEZE',
  /** branch has been merged into main */
  Merged: 'MERGED'
} as const;

export type RoleSkillMappingBranch_Status = typeof RoleSkillMappingBranch_Status[keyof typeof RoleSkillMappingBranch_Status];
/** Role Skill mappings nodes queries definition */
export type RoleSkillMappingNodeQueries = {
  __typename?: 'RoleSkillMappingNodeQueries';
  /** Query all role skill mapping nodes based on branch name */
  queryRoleSkillMappingNodeByBranchName: RoleSkillMappingNode_PaginatedResult;
};


/** Role Skill mappings nodes queries definition */
export type RoleSkillMappingNodeQueriesQueryRoleSkillMappingNodeByBranchNameArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  name: Scalars['String'];
};

/** DDN type for role skill mapping */
export const RoleSkillMappingNode_Ddn = {
  /** DEFINING_SKILLS */
  DefiningSkills: 'DEFINING_SKILLS',
  /** Distinguishing skills */
  DistinguishingSkills: 'DISTINGUISHING_SKILLS',
  /** Necessary skills */
  NecessarySkills: 'NECESSARY_SKILLS'
} as const;

export type RoleSkillMappingNode_Ddn = typeof RoleSkillMappingNode_Ddn[keyof typeof RoleSkillMappingNode_Ddn];
/** Generic error for RoleSkillMappingNode */
export type RoleSkillMappingNode_GenericError = ErrorDetails & {
  __typename?: 'RoleSkillMappingNode_GenericError';
  /** Inherited field from ErrorDetails interface */
  errorCode: Scalars['String'];
  /** A readable message providing the error details. */
  message: Scalars['String'];
  /** Inherited field from ErrorDetails interface */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Role skill mapping node for upsert */
export type RoleSkillMappingNode_MappingInput = {
  /** role description */
  desc: Scalars['String'];
  /** role id */
  id: Scalars['ID'];
  /** role name */
  name: Scalars['String'];
  /** mapped skills */
  skills: Array<RoleSkillMappingNode_SkillInput>;
};

/** Role skill mapping node */
export type RoleSkillMappingNode_MappingNode = {
  __typename?: 'RoleSkillMappingNode_MappingNode';
  /** role description */
  desc: Scalars['String'];
  /** role id */
  id: Scalars['ID'];
  /** Last updated userId */
  lastUpdatedByUser: Scalars['ID'];
  /** Last updated timestamp */
  lastUpdatedTime: Scalars['DateTime'];
  /** role name */
  name: Scalars['String'];
  /** mapped skills */
  skills: Array<RoleSkillMappingNode_SkillNode>;
};

/** Role skill mapping pagination results */
export type RoleSkillMappingNode_PaginatedResult = {
  __typename?: 'RoleSkillMappingNode_PaginatedResult';
  /** Branch Content. */
  elements: Array<RoleSkillMappingNode_MappingNode>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Skill node for upsert */
export type RoleSkillMappingNode_SkillInput = {
  /** skill DDN type */
  ddn: RoleSkillMappingNode_Ddn;
  /** skill id */
  id: Scalars['ID'];
  /** manually set skill proficiency score. */
  proficiency?: InputMaybe<Scalars['Int']>;
};

/** Skill node */
export type RoleSkillMappingNode_SkillNode = {
  __typename?: 'RoleSkillMappingNode_SkillNode';
  /** skill DDN type */
  ddn: RoleSkillMappingNode_Ddn;
  /** skill id */
  id: Scalars['ID'];
  /** manually set skill proficiency score. */
  proficiency: Scalars['Int'];
};

/** Input argument for upsert & deletion nodes by branch. */
export type RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameInput = {
  /** branch name */
  branchName: Scalars['String'];
  /** role ids that to be deleted. */
  deletions: Array<Scalars['ID']>;
  /** role Skill mapping node to be upserted. */
  upserts: Array<RoleSkillMappingNode_MappingInput>;
};

/** Result for upsert nodes. */
export type RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameResult = RoleSkillMappingNode_GenericError | RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameSuccess;

/** Success for upsert nodes. */
export type RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameSuccess = {
  __typename?: 'RoleSkillMappingNode_UpsertAndDeleteNodesByBranchNameSuccess';
  /** upserted nodes. */
  nodes: Array<RoleSkillMappingNode_MappingNode>;
};

export type S12nDerivativesV1 = {
  __typename?: 'S12nDerivativesV1';
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  avgLearningHoursAdjusted?: Maybe<Scalars['Float']>;
  catalogPrice?: Maybe<S12nDerivativesV1_Org_Coursera_Catalog_CatalogPrice>;
  id: Scalars['String'];
  ratingCount?: Maybe<Scalars['Float']>;
};

export type S12nDerivativesV1Connection = {
  __typename?: 'S12nDerivativesV1Connection';
  elements: Array<Maybe<S12nDerivativesV1>>;
  paging: ResponsePagination;
};

export type S12nDerivativesV1Resource = {
  __typename?: 'S12nDerivativesV1Resource';
  get?: Maybe<S12nDerivativesV1>;
  multiGet?: Maybe<S12nDerivativesV1Connection>;
};


export type S12nDerivativesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type S12nDerivativesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type S12nDerivativesV1_Org_Coursera_Catalog_CatalogPrice = {
  __typename?: 'S12nDerivativesV1_org_coursera_catalog_CatalogPrice';
  amount: Scalars['Float'];
  countryISOCode: Scalars['String'];
  currencyCode: Scalars['String'];
  currencySymbol: Scalars['String'];
  liableForTax: Scalars['Boolean'];
  productItemId: Scalars['String'];
  productPriceId: Scalars['String'];
  productType: Scalars['String'];
};

export type S12nDerivativesV2 = {
  __typename?: 'S12nDerivativesV2';
  id: Scalars['String'];
};

/**
 * Encapsulating object containing the enrollment blocking reason for each s12n. This is only populated
 * for the course in multiple s12n case.
 */
export type S12nEnrollmentBlockingData = {
  __typename?: 'S12nEnrollmentBlockingData';
  /** Reason why the enrollment to the product is blocked. */
  enrollmentBlockingReason?: Maybe<EnrollmentBlockingReason>;
  /** Specialization ID */
  specializationId: Scalars['ID'];
};

/** All queries for SAML flows */
export type SamlFlowsQueries = {
  __typename?: 'SamlFlowsQueries';
  /** Get a SAML login by ID */
  getById: SamlFlows_GetResult;
  /** Get single logout URL for a user by email */
  getSingleLogoutUrl: SamlFlows_GetSingleLogoutUrlResult;
};


/** All queries for SAML flows */
export type SamlFlowsQueriesGetByIdArgs = {
  samlLoginId: Scalars['ID'];
};


/** All queries for SAML flows */
export type SamlFlowsQueriesGetSingleLogoutUrlArgs = {
  email: Scalars['String'];
};

/** Input for completing a SAML flow */
export type SamlFlows_CompleteFlowInput = {
  /** The ID of the SAML login to complete */
  samlLoginId: Scalars['ID'];
};

/** Result type for completing a SAML flow */
export type SamlFlows_CompleteFlowResult = SamlFlows_CompleteFlowSuccess | SamlFlows_Failure;

/** Success response for completing a SAML flow */
export type SamlFlows_CompleteFlowSuccess = {
  __typename?: 'SamlFlows_CompleteFlowSuccess';
  /** The URL to return to after completing the flow */
  returnToUrl?: Maybe<Scalars['URL']>;
};

/** Failure response for SAML flow operations */
export type SamlFlows_Failure = {
  __typename?: 'SamlFlows_Failure';
  /** Error message */
  message: Scalars['String'];
};

/** Result type for getting SAML login */
export type SamlFlows_GetResult = SamlFlows_Failure | SamlFlows_GetSuccess;

/** Result type for getting a single logout URL */
export type SamlFlows_GetSingleLogoutUrlResult = SamlFlows_Failure | SamlFlows_GetSingleLogoutUrlSuccess;

/** Success response for getting a single logout URL */
export type SamlFlows_GetSingleLogoutUrlSuccess = {
  __typename?: 'SamlFlows_GetSingleLogoutUrlSuccess';
  /** The single logout URL */
  url?: Maybe<Scalars['URL']>;
};

/** Success response for get SAML login */
export type SamlFlows_GetSuccess = {
  __typename?: 'SamlFlows_GetSuccess';
  /** The SAML Login object */
  samlLogin: SamlFlows_SamlLogin;
};

/** Type of SAML login flow */
export const SamlFlows_LoginType = {
  /** Identity provider initiated login */
  IdpInitiated: 'IDP_INITIATED',
  /** Service provider (Coursera) initiated login */
  SpInitiated: 'SP_INITIATED'
} as const;

export type SamlFlows_LoginType = typeof SamlFlows_LoginType[keyof typeof SamlFlows_LoginType];
/** Input for marking a SAML login as completed */
export type SamlFlows_MarkLoginCompletedInput = {
  /** The ID of the SAML login to mark as completed */
  samlLoginId: Scalars['ID'];
};

/** Result type for marking a SAML login as completed */
export type SamlFlows_MarkLoginCompletedResult = SamlFlows_Failure | SamlFlows_MarkLoginCompletedSuccess;

/** Success response for marking a SAML login as completed */
export type SamlFlows_MarkLoginCompletedSuccess = {
  __typename?: 'SamlFlows_MarkLoginCompletedSuccess';
  /** Whether the operation was successful */
  success: Scalars['Boolean'];
};

/** SAML Login flow representation containing authentication data */
export type SamlFlows_SamlLogin = {
  __typename?: 'SamlFlows_SamlLogin';
  /** SAML login attributes */
  attributes: Scalars['JSON'];
  /** Whether the SAML login has been completed */
  completed: Scalars['Boolean'];
  /** When the SAML login was created */
  createdAt: Scalars['DateTime'];
  /** The display name of the user */
  displayName?: Maybe<Scalars['String']>;
  /** The email address of the user */
  email?: Maybe<Scalars['String']>;
  /** The entity ID associated with this SAML login */
  entityId?: Maybe<Scalars['ID']>;
  /** The eduPersonPrincipalName attribute from the SAML assertion */
  eppn?: Maybe<Scalars['String']>;
  /** Additional data associated with the SAML login */
  extraData?: Maybe<Scalars['JSON']>;
  /** The unique identifier of the SAML login */
  id: Scalars['ID'];
  /** The IP address from which the login was initiated */
  ipAddress?: Maybe<Scalars['String']>;
  /** The type of login (SP initiated or IdP initiated) */
  loginType: SamlFlows_LoginType;
  /** The time before which the SAML assertion is not valid */
  notBefore?: Maybe<Scalars['DateTime']>;
  /** The time after which the SAML assertion is not valid */
  notOnOrAfter?: Maybe<Scalars['DateTime']>;
  /** Whether to provision the user during first login */
  provisionUser: Scalars['Boolean'];
  /** The ID of the SAML response */
  responseId?: Maybe<Scalars['ID']>;
  /** The time the user returned to Coursera after authenticating with the IdP */
  returnTime?: Maybe<Scalars['DateTime']>;
  /** The time the SAML login flow was started */
  startTime: Scalars['DateTime'];
  /** The locality (typically IP address) from which the subject was authenticated */
  subjectLocality?: Maybe<Scalars['String']>;
  /** The targeted ID of the user */
  targetedId?: Maybe<Scalars['ID']>;
  /** The ID of the third party organization */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Namespaced queries through nesting to aid discoverability. */
export type SampleUserQueries = {
  __typename?: 'SampleUserQueries';
  /** TODO: Complete this description */
  queryUser: SampleUser_User;
  /** Queries all users using a fuzzy email search | Maximum page size: 1000 */
  queryUsersByEmail: SampleUser_UserConnection;
  /** Queries all users using a fuzzy name search | Maximum page size: 100 */
  queryUsersByName: SampleUser_UserConnection;
};


/** Namespaced queries through nesting to aid discoverability. */
export type SampleUserQueriesQueryUserArgs = {
  userId?: InputMaybe<Scalars['Int']>;
};


/** Namespaced queries through nesting to aid discoverability. */
export type SampleUserQueriesQueryUsersByEmailArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  queryText: Scalars['String'];
};


/** Namespaced queries through nesting to aid discoverability. */
export type SampleUserQueriesQueryUsersByNameArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  queryText: Scalars['String'];
};

/** TODO: Complete this description */
export type SampleUser_AddUserInput = {
  /** The user's email address. */
  email: Scalars['String'];
  /** The user's name. */
  name: Scalars['String'];
};

/** TODO: Complete this description */
export type SampleUser_AddUserResult = {
  __typename?: 'SampleUser_AddUserResult';
  /** TODO: Complete this description */
  user: SampleUser_User;
};

/** A user in the system. */
export type SampleUser_User = Node & {
  __typename?: 'SampleUser_User';
  /** The user's email address. */
  email: Scalars['String'];
  /** A unique identifier for this user */
  id: Scalars['ID'];
  /** The user's name. */
  name: Scalars['String'];
};

/** Represents a paginated collection of users */
export type SampleUser_UserConnection = {
  __typename?: 'SampleUser_UserConnection';
  /** The paginated collection */
  edges: Array<SampleUser_UserEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** Represents a single user with its pagination cursor */
export type SampleUser_UserEdge = {
  __typename?: 'SampleUser_UserEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** The user */
  node: SampleUser_User;
};

/** TODO: Complete this description */
export type ScopedContentRule = {
  __typename?: 'ScopedContentRule';
  /** TODO: Complete this description */
  gatesLineage: Array<ScopedContentRule_ScopedProductGateId>;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  policy: ScopedContentRule_ScopeRestrictionPolicy;
};

/** TODO: Complete this description */
export type ScopedContentRuleQueries = {
  __typename?: 'ScopedContentRuleQueries';
  /** TODO: Complete this description */
  getRule?: Maybe<ScopedContentRule_GetPayload>;
  /** TODO: Complete this description */
  multiGetRules?: Maybe<ScopedContentRule_MultiGetPayload>;
};


/** TODO: Complete this description */
export type ScopedContentRuleQueriesGetRuleArgs = {
  input: ScopedContentRule_Input;
};


/** TODO: Complete this description */
export type ScopedContentRuleQueriesMultiGetRulesArgs = {
  inputs: Array<ScopedContentRule_Input>;
};

/** TODO: Complete this description */
export type ScopedContentRule_Input = {
  /** TODO: Complete this description */
  productItemId: Scalars['String'];
  /** TODO: Complete this description */
  productType: ScopedContentRule_ProductType;
  /** TODO: Complete this description */
  scope: ScopedContentRule_ProductExperienceScopeType;
};

/** TODO: Complete this description */
export const ScopedContentRule_ProductExperienceScopeType = {
  /** TODO: Complete this description */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** TODO: Complete this description */
  CourseWithFullDiscount: 'COURSE_WITH_FULL_DISCOUNT'
} as const;

export type ScopedContentRule_ProductExperienceScopeType = typeof ScopedContentRule_ProductExperienceScopeType[keyof typeof ScopedContentRule_ProductExperienceScopeType];
/** TODO: Complete this description */
export type ScopedContentRule_ProductSourceId = ScopedContentRule_SourcePartnerId | ScopedContentRule_SourceProductId;

/** TODO: Complete this description */
export const ScopedContentRule_ProductType = {
  /** TODO: Complete this description */
  Specialization: 'Specialization',
  /** TODO: Complete this description */
  VerifiedCertificate: 'VerifiedCertificate'
} as const;

export type ScopedContentRule_ProductType = typeof ScopedContentRule_ProductType[keyof typeof ScopedContentRule_ProductType];
/** TODO: Complete this description */
export const ScopedContentRule_ScopeRestrictionPolicy = {
  /** TODO: Complete this description */
  Allow: 'ALLOW',
  /** TODO: Complete this description */
  Block: 'BLOCK'
} as const;

export type ScopedContentRule_ScopeRestrictionPolicy = typeof ScopedContentRule_ScopeRestrictionPolicy[keyof typeof ScopedContentRule_ScopeRestrictionPolicy];
/** TODO: Complete this description */
export type ScopedContentRule_ScopedProductGateId = {
  __typename?: 'ScopedContentRule_ScopedProductGateId';
  /** TODO: Complete this description */
  productSourceId: ScopedContentRule_ProductSourceId;
  /** TODO: Complete this description */
  scope: ScopedContentRule_ProductExperienceScopeType;
};

/** TODO: Complete this description */
export type ScopedContentRule_SourcePartnerId = {
  __typename?: 'ScopedContentRule_SourcePartnerId';
  /** TODO: Complete this description */
  id: Scalars['ID'];
};

/** TODO: Complete this description */
export type ScopedContentRule_SourceProductId = {
  __typename?: 'ScopedContentRule_SourceProductId';
  /** TODO: Complete this description */
  id: Scalars['ID'];
};

/** TODO: Complete this description */
export type ScopedContentRule_GetPayload = {
  __typename?: 'ScopedContentRule_getPayload';
  /** TODO: Complete this description */
  rule: ScopedContentRule;
};

/** TODO: Complete this description */
export type ScopedContentRule_MultiGetPayload = {
  __typename?: 'ScopedContentRule_multiGetPayload';
  /** TODO: Complete this description */
  rules: Array<ScopedContentRule>;
};

/** Queries for scoped translation configuration. */
export type ScopedTranslationConfigQueries = {
  __typename?: 'ScopedTranslationConfigQueries';
  /**
   * Returns the retranslation configs for a given scope key, showing when
   * re-translation was last requested for each target language.
   */
  retranslationConfigsByScopeKey: ScopedTranslationConfig_RetranslationConfigsByScopeKeyResult;
};


/** Queries for scoped translation configuration. */
export type ScopedTranslationConfigQueriesRetranslationConfigsByScopeKeyArgs = {
  input: ScopedTranslationConfig_RetranslationConfigsByScopeKeyInput;
};

/** ScopedTranslationConfig-specific error interface. */
export type ScopedTranslationConfig_Error = {
  /** Human-readable error message. */
  message: Scalars['String'];
};

/** Returned when the re-translation request fails. */
export type ScopedTranslationConfig_RequestRetranslationFailure = Error & ScopedTranslationConfig_Error & {
  __typename?: 'ScopedTranslationConfig_RequestRetranslationFailure';
  /** Human-readable error message describing why the request failed. */
  message: Scalars['String'];
};

/** Input for requesting re-translation of a scope. */
export type ScopedTranslationConfig_RequestRetranslationInput = {
  /** The scope key identifying the translation scope, e.g. COURSE~courseId or SPECIALIZATION~s12nId. */
  scopeKey: Scalars['String'];
  /**
   * Coursera language codes to request re-translation for, e.g. ["fr", "es"].
   * Must not be empty.
   * See: https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  targetLanguageCodes: Array<Scalars['String']>;
};

/** Result union for the re-translation request mutation. */
export type ScopedTranslationConfig_RequestRetranslationResult = ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RequestRetranslationSuccess;

/** Returned when the re-translation request succeeds. */
export type ScopedTranslationConfig_RequestRetranslationSuccess = {
  __typename?: 'ScopedTranslationConfig_RequestRetranslationSuccess';
  /** Per-language retranslation state after the update. */
  retranslationConfigs: Array<ScopedTranslationConfig_RetranslationConfig>;
  /** The scope key that was updated. */
  scopeKey: Scalars['String'];
};

/** Per-language retranslation state, tracking when re-translation was last requested. */
export type ScopedTranslationConfig_RetranslationConfig = {
  __typename?: 'ScopedTranslationConfig_RetranslationConfig';
  /** When re-translation was last requested for this language. */
  retranslationRequestedAt: Scalars['DateTime'];
  /**
   * Coursera language code, e.g. "fr", "zh-CN".
   * See: https://github.com/webedx-spark/translation-common-library/blob/main/src/main/java/org/coursera/translation/models/CourseraLanguageCode.java
   */
  targetLanguageCode: Scalars['String'];
};

/** Returned when the retranslation configs query fails, e.g. if no config exists for the scope. */
export type ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure = Error & ScopedTranslationConfig_Error & {
  __typename?: 'ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure';
  /** Human-readable error message describing why the query failed. */
  message: Scalars['String'];
};

/** Input for querying retranslation configs by scope key. */
export type ScopedTranslationConfig_RetranslationConfigsByScopeKeyInput = {
  /** The scope key identifying the translation scope, e.g. COURSE~courseId. */
  scopeKey: Scalars['String'];
};

/** Result union for the retranslation configs query. */
export type ScopedTranslationConfig_RetranslationConfigsByScopeKeyResult = ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeySuccess;

/** Returned when the retranslation configs are found for the given scope. */
export type ScopedTranslationConfig_RetranslationConfigsByScopeKeySuccess = {
  __typename?: 'ScopedTranslationConfig_RetranslationConfigsByScopeKeySuccess';
  /** Per-language retranslation state. Empty list if no re-translations have been requested. */
  retranslationConfigs: Array<ScopedTranslationConfig_RetranslationConfig>;
  /** The scope key. */
  scopeKey: Scalars['String'];
};

/** Search queries. */
export type SearchResultQueries = {
  __typename?: 'SearchResultQueries';
  /** Generate dynamic filter skill groups for use in search result filtering. */
  createDynamicFilterSkillGroups: Array<Search_DynamicFilterSkillGroup>;
  /**
   * Infer a refined search request from the user's recent conversation messages.
   * Uses an LLM to interpret the conversation as adjustments to an existing
   * search request, returning an adjusted set of search parameters (query,
   * filters, sort) that better captures the user's intent.
   *
   * This is a read-only interpretation step — callers must re-issue `search` with
   * the inferred parameters to fetch the refined results.
   */
  inferSearchRequest: Search_InferSearchRequestResult;
  /** Generate a list of query prompt recommendations for use on home page and autocomplete */
  recommendQueryPrompts: Search_RecommendQueryPromptsPaginatedResult;
  /**
   * Search products and other discovery-related content at Coursera. This search operation supports
   * multiple search requests so we can search multiple sources at the same time. The maximum number
   * of search requests that can be passed in is 15. The result array is not paginated because
   * the maximum number of search requests that can be passed in is not sufficiently large enough to
   * require pagination.
   */
  search: Array<Search_Result>;
  /**
   * Generate an AI-powered summary of the search results along with follow-up search suggestions.
   * This is a separate API call so as to not block users from seeing search results for the POC,
   * and in the future can be deprecated in favor of search streaming API.
   */
  summarizeSearchResults: Search_AiGeneratedSummary;
};


/** Search queries. */
export type SearchResultQueriesCreateDynamicFilterSkillGroupsArgs = {
  productsAndSkills: Array<Search_ProductsAndSkills>;
  query: Scalars['String'];
};


/** Search queries. */
export type SearchResultQueriesInferSearchRequestArgs = {
  messageHistory: Array<Search_UserMessage>;
  originalFacets?: InputMaybe<Array<Search_FacetInput>>;
  originalSearchRequest: Search_Request;
};


/** Search queries. */
export type SearchResultQueriesRecommendQueryPromptsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  routeTypes?: InputMaybe<Array<Search_QueryPromptRouteType>>;
};


/** Search queries. */
export type SearchResultQueriesSearchArgs = {
  requests: Array<Search_Request>;
};


/** Search queries. */
export type SearchResultQueriesSummarizeSearchResultsArgs = {
  originalSearchRequest: Search_Request;
  topSearchResults: Array<Search_HitMetadataInputForSummary>;
};

/** AI-generated summary of the search results along with follow-up search suggestions. */
export type Search_AiGeneratedSummary = {
  __typename?: 'Search_AiGeneratedSummary';
  /** List of AI-generated follow-up search suggestions related to the original search query. */
  suggestions: Array<Scalars['String']>;
  /** The AI-generated summary of the search results. */
  summary: Scalars['String'];
};

/** Metadata about AI-powered search capabilities used in the search request. */
export type Search_AiSearchMetadata = {
  __typename?: 'Search_AiSearchMetadata';
  /**
   * Whether the search query is eligible for follow-up AI-generated summaries, which will be another API call
   * so as to not block users from seeing search results.
   */
  isEligibleForAiGeneratedSummary: Scalars['Boolean'];
};

/**
 * Attributes for Coursera articles search results.
 *
 * The following attributes in this type are facetable (see facets documentation in [search.graphqls]):
 * - careerField
 * - category
 * - localizedCountryCd
 * - localizedLanguageCd
 * - skills
 * - subcategory
 * - topics
 */
export type Search_ArticleHit = {
  __typename?: 'Search_ArticleHit';
  /** Name of the AE (Associate/Assigning Editor) of the article. */
  aeName?: Maybe<Scalars['String']>;
  /** Career field associated with the article. */
  careerField?: Maybe<Scalars['String']>;
  /** The category the article belongs to. */
  category?: Maybe<Scalars['String']>;
  /** Author of the article. */
  createdByName?: Maybe<Scalars['String']>;
  /** Date and time the article was first published. */
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the article. */
  id?: Maybe<Scalars['ID']>;
  /** Internal content epic associated with the article. */
  internalContentEpic?: Maybe<Scalars['String']>;
  /** Internal product line associated with the article. */
  internalProductLine?: Maybe<Scalars['String']>;
  /** Internal keyword targeted by the article. */
  internalTargetKw?: Maybe<Scalars['String']>;
  /** Brief introduction or summary of the article. */
  introduction?: Maybe<Scalars['String']>;
  /** Boolean indicating whether the article is localized. */
  islocalized?: Maybe<Scalars['Boolean']>;
  /** Date and time the article was last published. */
  lastPublishedAt?: Maybe<Scalars['DateTime']>;
  /** Localized country code associated with the article. */
  localizedCountryCd?: Maybe<Scalars['String']>;
  /** Localized language code associated with the article. */
  localizedLanguageCd?: Maybe<Scalars['String']>;
  /** Name of the article. */
  name?: Maybe<Scalars['String']>;
  /** Skills associated with the article. */
  skills?: Maybe<Scalars['String']>;
  /** Subcategory of the article. */
  subcategory?: Maybe<Scalars['String']>;
  /** Topics associated with the article. */
  topics?: Maybe<Scalars['String']>;
  /**
   * URL for the article, e.g. "/articles/what-is-the-ccsp". Since this is a relative URL, we cannot
   * use the `URL` scalar here.
   */
  url?: Maybe<Scalars['String']>;
};

/** Context for the search. */
export type Search_Context = {
  /** Search for public content catalog videos, i.e. non-private and non-enterprise catalog only content. */
  searchConsumerVideos?: InputMaybe<Search_SearchConsumerVideos>;
  /** Search for products available to add into an existing program or for program creation. */
  searchForCuration?: InputMaybe<Search_SearchForCuration>;
  /** Search for products that have enrollments in an enterprise org or enterprise programs. */
  searchInEnrolled?: InputMaybe<Search_SearchInEnrolled>;
  /** Search within products available in specific enterprise programs. */
  searchInPrograms?: InputMaybe<Search_SearchInPrograms>;
  /** Search the web-enabled sales (WES) catalog. */
  searchInWebEnabledSalesCatalog?: InputMaybe<Search_SearchInWebEnabledSalesCatalog>;
  /** Search context for product suggestions, used to suggest products in the autocomplete experience. */
  searchProductSuggestions?: InputMaybe<Search_SearchProductSuggestions>;
  /** Search context for suggested queries, used to route requests for suggested queries. */
  searchSuggestedQueries?: InputMaybe<Search_SearchSuggestedQueries>;
};

/**
 * Skill information for dynamic filter skill groups.
 *
 * This type separates the skill value used for filtering from the display value to handle
 * internationalization correctly. When skill names are translated for display purposes, the
 * frontend needs the original untranslated value to apply filters in search requests. This
 * follows the same pattern used in Search_FacetValueAndCount where 'value' is used for filtering
 * and 'valueDisplay' is used for presentation.
 *
 * For example, if a skill "Machine Learning" is translated to "Aprendizaje Automático" in Spanish,
 * the frontend should:
 * - Display "Aprendizaje Automático" to the user (using skillDisplay)
 * - Apply "Machine Learning" in the facetFilters when the user selects it (using skill)
 */
export type Search_DynamicFilterSkill = {
  __typename?: 'Search_DynamicFilterSkill';
  /**
   * Skill identifier/value to be used for filtering in search requests. This value should be
   * passed in the facetFilters parameter when applying skill-based filters. This is the
   * untranslated, canonical skill name.
   */
  skill: Scalars['String'];
  /**
   * Localized display name for the skill, suitable for presentation to users. This value may be
   * translated based on the user's locale and should be used for UI display purposes only, not
   * for filtering.
   */
  skillDisplay: Scalars['String'];
};

/** Dynamic filter skill group used for filtering search results. */
export type Search_DynamicFilterSkillGroup = {
  __typename?: 'Search_DynamicFilterSkillGroup';
  /** Name of the dynamic filter skill group. */
  name: Scalars['String'];
  /**
   * List of skills in the dynamic filter skill group. Each skill includes both a filterable value
   * and a display value to support translated skill names while maintaining filter functionality.
   */
  skills: Array<Search_DynamicFilterSkill>;
};

/** Types of entities available to search. */
export const Search_EntityType = {
  /** Search for articles. */
  Articles: 'ARTICLES',
  /** Search for products (courses, specializations, degrees, etc). */
  Products: 'PRODUCTS',
  /** Search for auto-complete suggestions. */
  Suggestions: 'SUGGESTIONS'
} as const;

export type Search_EntityType = typeof Search_EntityType[keyof typeof Search_EntityType];
/** An error that occurred while executing a `Search_Request`. */
export type Search_Error = {
  __typename?: 'Search_Error';
  /** Error code. */
  code: Scalars['String'];
  /** Error message. */
  message: Scalars['String'];
};

/**
 * Facets object for the search results. Facets display the count of distinct values for desired
 * search attributes.
 *
 * For example, if the `Search_Request` input for the `PRODUCTS` entity type was set as follows:
 * * query = "machine learning"
 * * facets = ["topic"]
 * * maxValuesPerFacet: 3
 *
 * The value of `SearchFacet` would look like:
 * {
 *   "name": "topic",
 *   "nameDisplay": "topic",
 *   "valuesAndCounts": [
 *     {
 *       "value": "Data Science",
 *       "valueDisplay": "Data Science",
 *       "count": 13378
 *     },
 *     {
 *       "value": "Computer Science",
 *       "valueDisplay": "Computer Science",
 *       "count": 2632
 *     },
 *     {
 *       "value": "Business",
 *       "valueDisplay": "Business",
 *       "count": 2025
 *     }
 *   ]
 * }
 */
export type Search_Facet = {
  __typename?: 'Search_Facet';
  /** Name of the attribute name that was faceted on. Use this to apply filter in the search request. */
  name: Scalars['String'];
  /** Display name of the facet attribute name. */
  nameDisplay: Scalars['String'];
  /** List of facet values and their counts. */
  valuesAndCounts: Array<Search_FacetValueAndCount>;
};

/**
 * Input mirror of the `Search_Facet` output type, used to pass the facets
 * returned by a prior `search` call into `inferSearchRequest`. Display-only
 * fields (`nameDisplay`, `valueDisplay`) are omitted because the LLM only
 * reasons about the canonical names and counts.
 */
export type Search_FacetInput = {
  /** Attribute name (e.g., "skills", "topic"). Same semantics as `Search_Facet.name`. */
  name: Scalars['String'];
  /**
   * List of facet values and their counts. Same semantics as
   * `Search_Facet.valuesAndCounts`.
   */
  valuesAndCounts: Array<Search_FacetValueAndCountInput>;
};

/** Object for storing value and counts for a facet. */
export type Search_FacetValueAndCount = {
  __typename?: 'Search_FacetValueAndCount';
  /** How many times the value occurred in the search results. */
  count: Scalars['Int'];
  /** Value of the facet. Use this to apply filter in the search request. */
  value: Scalars['String'];
  /** Display value of the facet. */
  valueDisplay: Scalars['String'];
};

/**
 * Input mirror of `Search_FacetValueAndCount`. Carries the canonical value
 * and its document count for use as LLM context.
 */
export type Search_FacetValueAndCountInput = {
  /** How many times the value occurred in the original search results. */
  count: Scalars['Int'];
  /**
   * The canonical facet value (e.g., "Machine Learning"). Same semantics as
   * `Search_FacetValueAndCount.value`.
   */
  value: Scalars['String'];
};

/**
 * Search hit union type. Each search hit type in the union maps from a corresponding
 * `Search_EntityType` from [search.graphqls].
 */
export type Search_Hit = Search_ArticleHit | Search_ProductHit | Search_SuggestionHit;

/** Explanation of how a search hit was ranked, for a search request with `explain` set to true. */
export type Search_HitExplanationMetadata = {
  __typename?: 'Search_HitExplanationMetadata';
  /** JSON blob of features used in heavy ranker. */
  heavyRankerFeatures?: Maybe<Scalars['JSON']>;
  /** Overall rank from heavy ranker. */
  heavyRankerRank?: Maybe<Scalars['Int']>;
  /** Lexical match rank among search results. */
  lexicalMatchRank?: Maybe<Scalars['Int']>;
  /** Lexical score. */
  lexicalScore?: Maybe<Scalars['Float']>;
  /** Overall rank from light ranker. */
  lightRankerRank?: Maybe<Scalars['Int']>;
  /** Overall rank after Business Rule Engine (BRE) placement rules were applied. */
  postBusinessRulePlacementRank?: Maybe<Scalars['Int']>;
  /** AI-generated natural language explanation of how this result matches the search query. */
  relevanceExplanation?: Maybe<Scalars['String']>;
  /** Semantic score rank among search results. */
  semanticMatchRank?: Maybe<Scalars['Int']>;
  /** Semantic score. */
  semanticScore?: Maybe<Scalars['Float']>;
};

/**
 * Metadata about the top search results which are used as LLM input for the AI-generated summary.
 * This is just for the POC of AI-generated summaries where FE makes another API call,
 * but in the future we can consider creating a streaming API that returns search results first,
 * and then the summary and suggestions as they get loaded.
 */
export type Search_HitMetadataInputForSummary = {
  /** Average rating of the product from 0-5. */
  avgProductRating?: InputMaybe<Scalars['Float']>;
  /** The fully-translated languages for the search hit. */
  fullyTranslatedLanguages?: InputMaybe<Array<Scalars['String']>>;
  /** The ID of the search hit. */
  id: Scalars['ID'];
  /** Whether the content is new. */
  isNewContent?: InputMaybe<Scalars['Boolean']>;
  /** The name of the search hit. */
  name?: InputMaybe<Scalars['String']>;
  /** The partners associated with the search hit. */
  partners?: InputMaybe<Array<Scalars['String']>>;
  /** The difficulty level of the search hit. */
  productDifficultyLevel?: InputMaybe<Search_ProductDifficultyLevel>;
  /** Duration of the product. */
  productDuration?: InputMaybe<Search_ProductDuration>;
  /** The type of the search hit. */
  productType?: InputMaybe<Search_ProductType>;
  /** The skills associated with the search hit. */
  skills?: InputMaybe<Array<Scalars['String']>>;
  /** The topics associated with the search hit. */
  topics?: InputMaybe<Array<Scalars['String']>>;
  /** URL of the product description page. */
  url?: InputMaybe<Scalars['URL']>;
};

/**
 * The result of `inferSearchRequest` — wraps the inferred `Search_RefinedRequest`
 * alongside a human-readable rationale that the frontend can surface to the user.
 */
export type Search_InferSearchRequestResult = {
  __typename?: 'Search_InferSearchRequestResult';
  /**
   * Short human-readable explanation of what the LLM changed and why. Surfaced
   * to the user (e.g., "Narrowed to beginner-level Python courses based on your
   * message about being new to programming."). Null if no rationale was produced.
   */
  rationale?: Maybe<Scalars['String']>;
  /**
   * The inferred search parameters. Map this back onto a `Search_Request` and
   * re-issue `search` to fetch refined results.
   */
  searchRequest: Search_RefinedRequest;
};

/** Difficulty levels for products. */
export const Search_ProductDifficultyLevel = {
  /** Advanced difficulty level. */
  Advanced: 'ADVANCED',
  /** Beginner difficulty level. */
  Beginner: 'BEGINNER',
  /** Intermediate difficulty level. */
  Intermediate: 'INTERMEDIATE',
  /** Mixed difficulty level. */
  Mixed: 'MIXED'
} as const;

export type Search_ProductDifficultyLevel = typeof Search_ProductDifficultyLevel[keyof typeof Search_ProductDifficultyLevel];
/** Product durations. */
export const Search_ProductDuration = {
  /** Less than 2 hours. */
  LessThanTwoHours: 'LESS_THAN_TWO_HOURS',
  /** 1-4 weeks. */
  OneToFourWeeks: 'ONE_TO_FOUR_WEEKS',
  /** 1-4 years. */
  OneToFourYears: 'ONE_TO_FOUR_YEARS',
  /** 1-3 months. */
  OneToThreeMonths: 'ONE_TO_THREE_MONTHS',
  /** 6-12 months. */
  SixToTwelveMonths: 'SIX_TO_TWELVE_MONTHS',
  /** 3-6 months. */
  ThreeToSixMonths: 'THREE_TO_SIX_MONTHS',
  /** Under 60 minutes. */
  UnderSixtyMinutes: 'UNDER_SIXTY_MINUTES'
} as const;

export type Search_ProductDuration = typeof Search_ProductDuration[keyof typeof Search_ProductDuration];
/**
 * Attributes for Coursera product search results.
 *
 * The following attributes in this type are facetable (see facets documentation in [search.graphqls]):
 * - handsOnLearningTypes
 * - isCreditEligible
 * - isPartOfCourseraPlus
 * - partners
 * - productDifficultyLevel
 * - productDuration
 * - skills
 * - toolSoftwareSkillNames
 *
 * The following attributes are facetable, but do not appear as a field in `Search_ProductHit`. They
 * will only appear in the `facets` field in the response's `Search_Result` along with their distinct
 * values and aggregated counts within the search hits.
 *
 * +--------------------------+-------------+-------------------------------------------------+
 * | Attribute Name           | Type        | Description                                     |
 * +--------------------------+-------------+-------------------------------------------------+
 * | `allLanguages`           | `[String!]` | All languages supported in the product (primary |
 * |                          |             | language + subtitle languages).                 |
 * +--------------------------+-------------+-------------------------------------------------+
 * | `productTypeDescription` | `[String!]` | Description for the product's type.             |
 * +--------------------------+-------------+-------------------------------------------------+
 * | `language`               | `String`    | Primary language of the product.                |
 * +--------------------------+-------------+-------------------------------------------------+
 * | `subtitleLanguage`       | `[String!]` | Available subtitle languages for the product.   |
 * +--------------------------+-------------+-------------------------------------------------+
 * | `topic`                  | `String`    | Topic that the product teaches.                 |
 * +--------------------------+-------------+-------------------------------------------------+
 */
export type Search_ProductHit = {
  __typename?: 'Search_ProductHit';
  /** Average rating of the product from 0-5. */
  avgProductRating?: Maybe<Scalars['Float']>;
  /** Indicate whether a s12n cobranding is enabled or not. */
  cobrandingEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of completions. Only set for lesson and video product types. */
  completions?: Maybe<Scalars['Int']>;
  /** Length of the short-form content. Only set for lesson and video product types. */
  duration?: Maybe<Scalars['Duration']>;
  /** Number of enrollments of the product. */
  enrollments?: Maybe<Scalars['Int']>;
  /** Explanation of how each search hit was ranked, if the `explain` request parameter was set to true. */
  explanationMetadata?: Maybe<Search_HitExplanationMetadata>;
  /**
   * Languages fully supported for the product. All of audio, subtitles, and course materials will be translated for
   * each returned language.
   */
  fullyTranslatedLanguages?: Maybe<Array<Scalars['String']>>;
  /**
   * Types of hands-on learning practice items contained in the product, from our machine
   * learning-powered content-tagging system. Controlled tokens, e.g. "coding_labs", "guided_project",
   * "dialogs_and_role_plays". This attribute is facetable.
   */
  handsOnLearningTypes?: Maybe<Array<Scalars['String']>>;
  /** Unique identifier for the product. */
  id?: Maybe<Scalars['ID']>;
  /** URL of the image to display on the search card for the product. */
  imageUrl?: Maybe<Scalars['URL']>;
  /** Indicates whether a course is free or not. */
  isCourseFree?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a course is eligible for degree credit. */
  isCreditEligible?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a product is launched in recent 2 years. */
  isNewContent?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a product is offered as part of Coursera Plus. */
  isPartOfCourseraPlus?: Maybe<Scalars['Boolean']>;
  /** Name of the product, e.g. "Python for Everybody". */
  name?: Maybe<Scalars['String']>;
  /** Number of ratings the product has received. */
  numProductRatings?: Maybe<Scalars['Int']>;
  /** Parent course name. Only set for lesson product types. */
  parentCourseName?: Maybe<Scalars['String']>;
  /** Parent lesson name. Only set for video product types. */
  parentLessonName?: Maybe<Scalars['String']>;
  /** URLs of the partner logo images displayed in the search cards. */
  partnerLogos?: Maybe<Array<Scalars['URL']>>;
  /** Names of the partners that offer this product. */
  partners?: Maybe<Array<Scalars['String']>>;
  /** A reference to product card attributes */
  productCard?: Maybe<ProductCard_ProductCard>;
  /** Difficulty of the product. */
  productDifficultyLevel?: Maybe<Search_ProductDifficultyLevel>;
  /** Duration of the product. */
  productDuration?: Maybe<Search_ProductDuration>;
  /** Type of the product. */
  productType?: Maybe<Search_ProductType>;
  /**
   * Skills from our machine learning-powered skill tagging system that automatically labels our
   * products with skills. These skills are present in our skill taxonomy.
   */
  skills?: Maybe<Array<Scalars['String']>>;
  /**
   * Whether this hit is a partner-funded sponsored placement, promoted to its position by a sponsored
   * business rule. When true, the frontend renders a "Sponsored" label. Set post-search by the
   * business rules engine; not sourced from the index.
   *
   * Only `true` or `null` is returned: the business rules engine sets `true` when a sponsored rule
   * promotes the hit, and otherwise leaves the field absent (`null`). `false` is never emitted, so
   * consumers should treat `null`/absent as "not a sponsored placement".
   */
  sponsored?: Maybe<Scalars['Boolean']>;
  /**
   * Only subtitles are available for each returned language. The product does not have audio and/or course materials
   * translated.
   */
  subtitlesOnlyLanguages?: Maybe<Array<Scalars['String']>>;
  /** Tagline of the product. */
  tagline?: Maybe<Scalars['String']>;
  /**
   * Names of tools and software the product teaches, from our machine learning-powered skill-tagging
   * system, e.g. "TensorFlow", "Figma". This attribute is facetable.
   */
  toolSoftwareSkillNames?: Maybe<Array<Scalars['String']>>;
  /** Translation of the name. We keep both the original name and the translation for flexible A/B testing. */
  translatedName?: Maybe<Scalars['String']>;
  /** Translation of the parentCourseName. We keep both the original parentCourseName and the translation for flexible A/B testing. */
  translatedParentCourseName?: Maybe<Scalars['String']>;
  /** Translation of the parentLessonName. We keep both the original parentLessonName and the translation for flexible A/B testing. */
  translatedParentLessonName?: Maybe<Scalars['String']>;
  /** Translations of the tagged skills. We keep both the original skills and the translations for flexible A/B testing. */
  translatedSkills?: Maybe<Array<Scalars['String']>>;
  /**
   * Relative URL that, when appended to coursera.org, leads to the page for the course; e.g.
   * "/specializations/python". Since this is a relative URL, we cannot use the `URL` scalar here.
   */
  url?: Maybe<Scalars['String']>;
  /** Number of videos in the lesson. Only set for lesson product types. */
  videosInLesson?: Maybe<Scalars['Int']>;
};

/** Product types. */
export const Search_ProductType = {
  /** Course product type. */
  Course: 'COURSE',
  /** Degree product type. */
  Degree: 'DEGREE',
  /** Graduate Certificate product type. */
  GraduateCertificate: 'GRADUATE_CERTIFICATE',
  /** Guided Project product type. */
  GuidedProject: 'GUIDED_PROJECT',
  /** Learning Path product type. */
  LearningPath: 'LEARNING_PATH',
  /** Lesson product type. */
  Lesson: 'LESSON',
  /** MasterTrack product type. */
  Mastertrack: 'MASTERTRACK',
  /** Postgraduate Diploma product type. */
  PostgraduateDiploma: 'POSTGRADUATE_DIPLOMA',
  /** Professional Certificate product type. */
  ProfessionalCertificate: 'PROFESSIONAL_CERTIFICATE',
  /** Project product type. */
  Project: 'PROJECT',
  /** Specialization product type. */
  Specialization: 'SPECIALIZATION',
  /** University Certificate product type. */
  UniversityCertificate: 'UNIVERSITY_CERTIFICATE',
  /** Video product type. */
  Video: 'VIDEO'
} as const;

export type Search_ProductType = typeof Search_ProductType[keyof typeof Search_ProductType];
/** Input products and skills */
export type Search_ProductsAndSkills = {
  /** Product name. */
  productName: Scalars['String'];
  /** List of skill names. */
  skills: Array<Scalars['String']>;
};

/** A query prompt suggestion */
export type Search_QueryPrompt = {
  __typename?: 'Search_QueryPrompt';
  /** Unique identifier */
  id: Scalars['ID'];
  /** User intent represented by prompt */
  intentType: Scalars['String'];
  /** Prompt text appropriate for large elements, e.g. desktop */
  promptTextLong: Scalars['String'];
  /** Prompt text appropriate for small elements, e.g. mobile */
  promptTextShort: Scalars['String'];
  /** Argument for executing prompt.  For SERP, the search query.  For CHAT_only, the seed prompt. */
  routeParameter: Scalars['String'];
  /** Route used for executing prompt */
  routeType: Search_QueryPromptRouteType;
};

/** Routes possible for executing prompt suggestions */
export const Search_QueryPromptRouteType = {
  /** Route to chat-only interface */
  ChatOnly: 'CHAT_ONLY',
  /** Route to search results page. */
  Serp: 'SERP'
} as const;

export type Search_QueryPromptRouteType = typeof Search_QueryPromptRouteType[keyof typeof Search_QueryPromptRouteType];
/** Response to recommendQueryPrompts query */
export type Search_RecommendQueryPromptsPaginatedResult = {
  __typename?: 'Search_RecommendQueryPromptsPaginatedResult';
  /** List of query prompt suggestions */
  elements: Array<Search_QueryPrompt>;
  /** Pagination information. NOTE: the cursor is the next PAGE NUMBER, not the element's identifier. */
  pagination: Pagination;
};

/**
 * The refined search parameters produced by `inferSearchRequest`. Contains only
 * the fields the LLM is allowed to adjust (`query`, `facetFilters`, `sortBy`).
 *
 * Callers merge these onto the `originalSearchRequest` they passed in — every
 * other field on `Search_Request` (`entityType`, `searchContext`, `limit`,
 * `cursor`, `facets`, `maxValuesPerFacet`, `disableRecommender`,
 * `enableAutoAppliedFilters`, `explain`, `requestOrigin`) is carried forward
 * unchanged. This is a separate output type rather than a reuse of
 * `Search_Request` because GraphQL does not allow input types to be returned.
 */
export type Search_RefinedRequest = {
  __typename?: 'Search_RefinedRequest';
  /**
   * Refined facet filters, in the same nested-array convention as
   * `Search_Request.facetFilters` (inner array = OR, outer = AND). Null means
   * no filter change was inferred; empty outer array means clear all filters.
   */
  facetFilters?: Maybe<Array<Array<Scalars['String']>>>;
  /**
   * The refined search query text. May be identical to the original if the LLM
   * determined no rewrite was needed.
   */
  query: Scalars['String'];
  /** Refined sort criteria, or null to fall back to the entity type's default. */
  sortBy?: Maybe<Search_SortBy>;
};

/** Search request type. */
export type Search_Request = {
  /**
   * Cursor to paginate through results - NOTE: the page number is used as the cursor, not the
   * element (hit) number or identifier.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * Set to True to disable all recommenders. Disabling recommenders will improve search time.
   * Note: This is a `disable` instead of an `enable` because the server can only guarantee less work, and not more (for
   * performance reasons).
   */
  disableRecommender?: Scalars['Boolean'];
  /**
   * Set to True to enable auto-applied search filters using query understanding. The auto-applied filters will be returned
   * in the `autoAppliedFilters` field in the `Search_Result`.
   */
  enableAutoAppliedFilters?: Scalars['Boolean'];
  /** Type of entity to search. */
  entityType: Search_EntityType;
  /**
   * Set to True to get detailed explanation of how each search hit was ranked.
   * This parameter will be guarded by checks to see that the user is an internal Courserian.
   */
  explain?: Scalars['Boolean'];
  /**
   * Filter search hits by facet value. The given strings should be a comma separated key/value pair,
   * where the key is the attribute name and the value is the desired attribute value.
   *
   * Strings within the same array are interpreted as a disjunction (OR), while nested arrays are
   * interpreted as a conjunction (AND).
   *
   * For example, if the client only wants to show search results
   * where:
   *
   * (`allLanguages` attribute contains the "French" value) AND (`skills` attribute contains the
   * "Statistics" value OR `topic` attribute value is "Business")
   *
   * this would be set to:
   *
   * [["allLanguages:French"],["skills:Statistics","topic:Business"]]
   */
  facetFilters?: InputMaybe<Array<Array<Scalars['String']>>>;
  /**
   * Retrieve facets for the given attribute names (the list of distinct values and their counts),
   * which will be returned in the `facets` response field.
   *
   * For example, if the client wants to retrieve facets for the "skills" and "topic" attributes for
   * searches for the `PRODUCTS` entity type, this would be set to ["skills", "topic"].
   *
   * If a given attribute name is not facetable or does not exist for the entity type being
   * searched, it is silently ignored.
   *
   * See [hit.graphqls] for the list of valid, facetable attributes for each entity type.
   */
  facets?: InputMaybe<Array<Scalars['String']>>;
  /** Specify the maximum number of [Search_Hit]s to be returned in [Search_Result]. */
  limit: Scalars['Int'];
  /**
   * Maximum number of distinct values to return for each facet. The maximum value is 1000 for
   * performance reasons; any value higher will be interpreted as 1000.
   */
  maxValuesPerFacet?: Scalars['Int'];
  /** Text to search. */
  query: Scalars['String'];
  /**
   * Request origin of the search request. The goal for this is to eventually be an exhaustive set of enums
   * where different pages would pass in where the request is coming from, in order to inform logging and
   * determining eligibility for experiments that are orchestrated on BE.
   */
  requestOrigin?: InputMaybe<Search_RequestOrigin>;
  /** Optional context of the search. */
  searchContext?: InputMaybe<Search_Context>;
  /**
   * Sorting criteria to use for the search result hits.
   *
   * If this field is not set, a default sorting option will be chosen depending on the entity type.
   * May return a BAD_REQUEST if the entity type does not supporting the sorting option.
   *
   * See https://github.com/webedx-spark/search-application/blob/main/src/main/java/org/coursera/search/managers/EpicConfigurationHelper.java
   * for the supported sorting options and the default sort option for each entity type.
   */
  sortBy?: InputMaybe<Search_SortBy>;
};

/** Metadata for the request origin, used for logging and determining eligibility for experiments that are setup on the BE. */
export type Search_RequestOrigin = {
  /** FE page where the search request originated from, e.g. EQP, SERP */
  pageType: Search_RequestOriginPageType;
  /** Whether the page is part of the consumer or enterprise experience. */
  segmentType: Search_RequestOriginSegmentType;
};

/** FE page where the search request originated from, e.g. EQP, SERP. */
export const Search_RequestOriginPageType = {
  /** Entity Query Page, primarily used for linking users to browse topics from SEO and other site links. */
  Eqp: 'EQP',
  /** Search Entity Results Page, i.e. the page that renders after a user submits to the search bar. */
  Serp: 'SERP',
  /** Dropdown underneath the search bar when a user focuses and starts typing. */
  Suggestions: 'SUGGESTIONS'
} as const;

export type Search_RequestOriginPageType = typeof Search_RequestOriginPageType[keyof typeof Search_RequestOriginPageType];
/**
 * Whether the origin of the request is from a consumer or enterprise page,
 * e.g. enterprise SERP is separate from consumer SERP.
 */
export const Search_RequestOriginSegmentType = {
  /** Used for distinguishing pages in the consumer segment, e.g. consumer SERP. */
  Consumer: 'CONSUMER',
  /** Used for distinguishing pages in the enterprise segment, e.g. enterprise SERP. */
  Enterprise: 'ENTERPRISE'
} as const;

export type Search_RequestOriginSegmentType = typeof Search_RequestOriginSegmentType[keyof typeof Search_RequestOriginSegmentType];
/** Search result object. */
export type Search_Result = {
  __typename?: 'Search_Result';
  /**
   * Whether AI-powered search capabilities were used, such as LLM query-based rewrite, semantic-only search,
   * and whether it's eligible for AI-generated summaries.
   */
  aiSearchMetadata?: Maybe<Search_AiSearchMetadata>;
  /**
   * Filters that were automatically applied using query understanding.
   *
   * This field follows the same convention as the facetFilters field from Search_Request, where strings within the same
   * array are interpreted as a disjunction (OR), while nested arrays are interpreted as a conjunction (AND).
   */
  autoAppliedFilters?: Maybe<Array<Array<Scalars['String']>>>;
  /** List of search results. */
  elements: Array<Search_Hit>;
  /** Error information for the specific search request. If no error occurred, this field will be null. */
  error?: Maybe<Search_Error>;
  /**
   * List of facets for the search results, if the `facets` request parameter was set. Facets are
   * not paginated because the number of facetable attributes are small. See [hit.graphqls] for the
   * list of valid facetable attributes for each entity type.
   */
  facets?: Maybe<Array<Search_Facet>>;
  /** Pagination information. NOTE: the cursor is the next PAGE NUMBER, not the element's identifier. */
  pagination: Pagination;
  /** Source metadata, primarily used for eventing/monitoring. */
  source: Search_ResultSource;
  /** Total number of pages for the search results. */
  totalPages: Scalars['Int'];
};

/** Source metadata for search results. Used for eventing/monitoring. */
export type Search_ResultSource = {
  __typename?: 'Search_ResultSource';
  /** Which underlying search engine was used to conduct the search, e.g. "algolia". */
  engine: Scalars['String'];
  /** Which index was queried, if applicable. */
  indexName?: Maybe<Scalars['String']>;
  /**
   * The result source for recommenders, if applicable.
   * @deprecated Recommenders are no longer used.
   */
  recommender?: Maybe<Search_ResultSourceRecommender>;
};

/**
 * Source metadata for search results which leverage recommendations. Used for eventing/monitoring.
 * See https://github.com/webedx-spark/eventing-schemas/blob/main/schemas/eventingv3/entities/products/recommender.json for details
 * on how this data is intended to be used.
 */
export type Search_ResultSourceRecommender = {
  __typename?: 'Search_ResultSourceRecommender';
  /**
   * Non-sensitive and non-personal contextual metadata about how the search results were ranked.
   * @deprecated Recommenders are no longer used.
   */
  context?: Maybe<Scalars['JSON']>;
  /**
   * The hash of the recommender configuration uniquely identifying a specific version of the configuration used to rank the search results.
   * @deprecated Recommenders are no longer used.
   */
  hash?: Maybe<Scalars['String']>;
};

/** Search for public content catalog videos, i.e. non-private and non-enterprise catalog only content. */
export type Search_SearchConsumerVideos = {
  /** Dummy field as this context supports no extra metadata. */
  _?: InputMaybe<Scalars['Boolean']>;
  /** Search for videos only belonging to these parent course slugs. */
  parentCourseSlugs?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Search for products available to add into an existing program or for program creation. If no program
 * is provided (e.g. for program creation), the contractId is used.
 */
export type Search_SearchForCuration = {
  /** Enterprise contract ID to search within. */
  contractId: Scalars['ID'];
  /** Enterprise program ID to search within. */
  programId?: InputMaybe<Scalars['ID']>;
};

/**
 * Search for products that have enrollments in an enterprise org or enterprise programs. If the
 * programsId list is empty, search within the entire organization.
 */
export type Search_SearchInEnrolled = {
  /**
   * Whether to include products that have downgraded enrollments. An enrollment may be downgraded
   * if, for example, an enterprise contract is archived. Existing enrollments within that
   * contract lose access to premium features in the products, such as labs and quizzes.
   */
  includeDowngraded?: Scalars['Boolean'];
  /** Organization ID to search within. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /** List of program IDs to search within. */
  programIds: Array<Scalars['ID']>;
};

/** Search within products available in specific enterprise programs. */
export type Search_SearchInPrograms = {
  /** List of enterprise program IDs. */
  programIds: Array<Scalars['ID']>;
};

/** Search the web-enabled sales (WES) catalog. */
export type Search_SearchInWebEnabledSalesCatalog = {
  /**
   * Dummy field since searching the WES catalog takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Search context for product suggestions, used to suggest products in the autocomplete experience. */
export type Search_SearchProductSuggestions = {
  /**
   * Dummy field since this context takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Search context for suggested queries, used to route requests for suggested queries. */
export type Search_SearchSuggestedQueries = {
  /**
   * Dummy field since this context takes no extra metadata. GraphQL types must include
   * at least one field.
   */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Available sorting criteria for the search result hits. */
export const Search_SortBy = {
  /**
   * Sort by best match. Ranking uses keyword matching and is also optimized for LTV (long-term value).
   * For more information on LTV, visit https://coursera.atlassian.net/wiki/spaces/UD/pages/179601459/Search#LTV-Optimized-Search.
   */
  BestMatch: 'BEST_MATCH',
  /**
   * Sort by newest launch date. Ranking by launch date descending. This is an A/B test on SERP. (More info:
   * https://coursera.atlassian.net/wiki/spaces/GROW/pages/3038740481/Sort+by+new+option+in+the+Consumer+and+Enterprise+Search+Experience)
   */
  New: 'NEW'
} as const;

export type Search_SortBy = typeof Search_SortBy[keyof typeof Search_SortBy];
/**
 * Attributes for Coursera auto-complete suggestions.
 *
 * No attributes are facetable.
 */
export type Search_SuggestionHit = {
  __typename?: 'Search_SuggestionHit';
  /** Unique identifier for the suggestion. */
  id?: Maybe<Scalars['ID']>;
  /** Name of the suggestion. */
  name?: Maybe<Scalars['String']>;
  /**
   * Score for the suggestion. This is used for ranking purposes; suggestions with a higher score
   * will be suggested first.
   */
  score?: Maybe<Scalars['Int']>;
};

/**
 * A single chunk of a streamed AI-generated search summary. Chunks are emitted incrementally as the
 * LLM generates the summary, and the final chunk is indicated by `isLastChunk = true`.
 */
export type Search_SummaryChunk = {
  __typename?: 'Search_SummaryChunk';
  /** Zero-based index of this chunk in the stream, for ordering and debugging. */
  chunkIndex: Scalars['Int'];
  /**
   * Error information if something went wrong during summary generation (e.g., LLM timeout).
   * If no error occurred, this field will be null.
   */
  error?: Maybe<Search_Error>;
  /** Whether this is the final chunk of the stream. */
  isLastChunk: Scalars['Boolean'];
  /**
   * List of product cards referenced in this chunk along with AI-generated
   * justifications for why each product is relevant.
   */
  productCards?: Maybe<Array<Search_SummaryProductCard>>;
  /**
   * A fragment of the AI-generated summary text. May be null for chunks that only carry
   * metadata or indicate the end of the stream.
   */
  summaryChunk?: Maybe<Scalars['String']>;
};

/**
 * A product card surfaced by the AI search overview, paired with a justification for why it is
 * relevant to the user's query.
 */
export type Search_SummaryProductCard = {
  __typename?: 'Search_SummaryProductCard';
  /** Average rating of the product from 0-5. */
  avgProductRating?: Maybe<Scalars['Float']>;
  /** The ID of the product. */
  id: Scalars['ID'];
  /** URL of the image to display on the search card for the product. */
  imageUrl?: Maybe<Scalars['URL']>;
  /**
   * AI-generated justification explaining why this product is relevant to the user's search
   * query.
   */
  justification?: Maybe<Scalars['String']>;
  /** Name of the product, e.g. "Python for Everybody". */
  name?: Maybe<Scalars['String']>;
  /** URLs of the partner logo images displayed in the search cards. */
  partnerLogos?: Maybe<Array<Scalars['URL']>>;
  /** Names of the partners that offer this product. */
  partners?: Maybe<Array<Scalars['String']>>;
  /** Type of the product. */
  productType?: Maybe<Search_ProductType>;
  /** The display size of this product card. */
  size: Search_SummaryProductCardSize;
  /** Relative URL of the product page on coursera.org. */
  url?: Maybe<Scalars['String']>;
};

/** The display size of an AI summary product card. */
export const Search_SummaryProductCardSize = {
  /** A condensed card size, used for the similar courses section of the summary. */
  Compact: 'COMPACT',
  /** The smallest card size, used for the primary result inline within the summary text. */
  Mini: 'MINI'
} as const;

export type Search_SummaryProductCardSize = typeof Search_SummaryProductCardSize[keyof typeof Search_SummaryProductCardSize];
/**
 * A single conversation message passed to `inferSearchRequest`. Intentionally
 * minimal — only the raw text is needed for LLM interpretation. If sender
 * distinction is needed later, add a senderType enum without breaking callers.
 */
export type Search_UserMessage = {
  /** The message text. Callers should send user messages only. */
  message: Scalars['String'];
};

/**
 * Acknowledgement returned by Search_WarmSession in all cases — success, no-op, and
 * silent failure alike. The mutation is fire-and-forget; callers should not inspect
 * this type for outcome information.
 */
export type Search_WarmSessionAck = Search_WarmSessionResult & {
  __typename?: 'Search_WarmSessionAck';
  /** Dummy field — required by GraphQL. This type carries no meaningful response payload. */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * Result of the Search_WarmSession mutation. This mutation is fire-and-forget
 * and has no meaningful response payload; this interface allows future subtypes
 * to add fields without a breaking schema change.
 */
export type Search_WarmSessionResult = {
  /** Dummy field — required by GraphQL. This mutation carries no meaningful response payload. */
  _?: Maybe<Scalars['Boolean']>;
};

/** All SEO queries */
export type SeoQueries = {
  __typename?: 'SeoQueries';
  /**
   * Query to get all matched configuration
   * This replaces getAllMatchedPageData
   */
  getAllPathMatchedConfiguration: Seo_AllMatchedPathConfiguration;
  /** This query returns all robots.txt */
  getAllSeoRobotsTxtV1Query: Array<Seo_RobotsTxtV1>;
  /** Full page data export query, returns all page data configurations */
  getPageDataFullExportV1?: Maybe<Seo_PageDataFullExportV1>;
  /** Query to get sitemap report */
  getSitemapReport: Seo_SitemapReport;
  /** Query to get all eqp data */
  seoGetAllEqpDataV1Query: Array<Seo_EqpData>;
  /**
   * This query returns seo path configuration for given path
   * It replaces seoPageDataV1Query
   */
  seoPathConfigurationQuery: Seo_PathConfiguration;
};


/** All SEO queries */
export type SeoQueriesGetAllPathMatchedConfigurationArgs = {
  path: Scalars['String'];
};


/** All SEO queries */
export type SeoQueriesGetSitemapReportArgs = {
  date: Scalars['Date'];
};


/** All SEO queries */
export type SeoQueriesSeoPathConfigurationQueryArgs = {
  path: Scalars['String'];
};

/** All matched path configuration for a given data */
export type Seo_AllMatchedPathConfiguration = {
  __typename?: 'Seo_AllMatchedPathConfiguration';
  /** Optional eqp data for path */
  eqpData?: Maybe<Seo_EqpData>;
  /** SEO data id */
  id: Scalars['ID'];
  /** Collection of matched page data */
  pageData: Array<Seo_PageDataConfigV1>;
};

/** SEO component link type */
export type Seo_ComponentLink = {
  __typename?: 'Seo_ComponentLink';
  /** Url for this link */
  href: Scalars['URL'];
  /** SEO component link id */
  id: Scalars['ID'];
  /** Label for this link */
  label: Scalars['String'];
};

/** SEO component link input */
export type Seo_ComponentLinkInput = {
  /** Url for this link */
  href: Scalars['URL'];
  /** Label for this link */
  label: Scalars['String'];
};

/** Header payload for domain skills suggestions */
export type Seo_DomainSkillsHeader = {
  __typename?: 'Seo_DomainSkillsHeader';
  /** ID for this custom header */
  id: Scalars['ID'];
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** Header payload for domain skills suggestions */
export type Seo_DomainSkillsHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** Content block displated in EQP pages */
export type Seo_EqpContentBlock = {
  __typename?: 'Seo_EqpContentBlock';
  /** Content text */
  content: Scalars['String'];
  /** SEO data id */
  id: Scalars['ID'];
  /** Label of content block */
  label: Scalars['String'];
};

/** Eqp content block input */
export type Seo_EqpContentBlockInput = {
  /** Content text */
  content: Scalars['String'];
  /** Label of content block */
  label: Scalars['String'];
};

/** Eqp configuration data */
export type Seo_EqpData = {
  __typename?: 'Seo_EqpData';
  /** Bottom content block */
  bottomContentBlock?: Maybe<Seo_EqpContentBlock>;
  /** Description Tag */
  descriptionTag?: Maybe<Scalars['String']>;
  /** FAQ slug */
  faqSlug?: Maybe<Scalars['String']>;
  /** List of filter */
  filters: Array<Seo_EqpFilter>;
  /** Header */
  headers?: Maybe<Seo_EqpHeaders>;
  /** Hreflang links that belong to the same group */
  hreflangLinks: Array<Seo_HreflangLink>;
  /** SEO data id */
  id: Scalars['ID'];
  /**
   * Locale as defined by ISO 639-1 and ISO 3166-1 alpha-2 for language and country respectively.
   * E.g. "en-CA".
   * Not all locales are supported by EQP.
   */
  locale?: Maybe<Scalars['String']>;
  /** Title Tag */
  titleTag: Scalars['String'];
  /** Top content block */
  topContentBlock?: Maybe<Seo_EqpContentBlock>;
  /** Url path */
  url: Scalars['String'];
};

/** Eqp bulk edit mutation */
export type Seo_EqpDataBulkEditV1MutationInput = {
  /** Collection of urls to delete */
  delete?: InputMaybe<Array<Scalars['String']>>;
  /** Write eqp data input */
  write?: InputMaybe<Array<Seo_EqpDataInput>>;
};

/** Eqp mutation result. Contains a list of individual config results. */
export type Seo_EqpDataBulkEditV1MutationResult = {
  __typename?: 'Seo_EqpDataBulkEditV1MutationResult';
  /** SEO data id */
  id: Scalars['ID'];
  /** EQP edit results array */
  results: Array<Seo_EqpDataEditResult>;
};

/** EQP Config result action */
export const Seo_EqpDataEditAction = {
  /**
   * EQP config was added
   * The eqp url was not present in the data store and a new record was written
   */
  Add: 'ADD',
  /**
   * EQP config was deleted
   * The url previously existed in the data store and was removed
   */
  Delete: 'DELETE',
  /**
   * Page data config was updated
   * The eqp url existed in the data store and the configuration fields for that path regex were overwritten
   */
  Update: 'UPDATE'
} as const;

export type Seo_EqpDataEditAction = typeof Seo_EqpDataEditAction[keyof typeof Seo_EqpDataEditAction];
/** Union of EQP Configuration failures and success results */
export type Seo_EqpDataEditResult = Seo_EqpDataEditSuccessResult | Seo_MutationFailureResult;

/** EQP Config success result containing the action of the mutation and the configuration that was acted on */
export type Seo_EqpDataEditSuccessResult = {
  __typename?: 'Seo_EqpDataEditSuccessResult';
  /** Action of mutation */
  action: Seo_EqpDataEditAction;
  /** Configuration that was acted on */
  eqpData: Seo_EqpData;
  /** SEO data id */
  id: Scalars['ID'];
};

/** Eqp data input */
export type Seo_EqpDataInput = {
  /** Bottom content block */
  bottomContentBlock?: InputMaybe<Seo_EqpContentBlockInput>;
  /** Description Tag */
  descriptionTag?: InputMaybe<Scalars['String']>;
  /** FAQ slug */
  faqSlug?: InputMaybe<Scalars['String']>;
  /** List of filter */
  filters: Array<Seo_EqpFilterInput>;
  /** Header */
  headers?: InputMaybe<Seo_EqpHeadersInput>;
  /**
   * Locale as defined by ISO 639-1 and ISO 3166-1 alpha-2 for language and country respectively.
   * E.g. "en-CA".
   * Not all locales are supported by EQP.
   */
  locale?: InputMaybe<Scalars['String']>;
  /** Title Tag */
  titleTag: Scalars['String'];
  /** Top content block */
  topContentBlock?: InputMaybe<Seo_EqpContentBlockInput>;
};

/** Eqp filter */
export type Seo_EqpFilter = {
  __typename?: 'Seo_EqpFilter';
  /** Filter field */
  field: Scalars['String'];
  /** SEO data id */
  id: Scalars['ID'];
  /** Value of filter */
  value: Scalars['String'];
};

/** EQP filter input */
export type Seo_EqpFilterInput = {
  /** Filter field */
  field: Scalars['String'];
  /** Value of filter */
  value: Scalars['String'];
};

/** EQP Grouping success result containing the affected EqpData */
export type Seo_EqpGroupingMutationSuccess = {
  __typename?: 'Seo_EqpGroupingMutationSuccess';
  /** Configuration that was acted on */
  eqpData: Array<Seo_EqpData>;
};

/** Customizable EQP headers */
export type Seo_EqpHeaders = {
  __typename?: 'Seo_EqpHeaders';
  /** Header payload for domain skills suggestions */
  domainSkillsHeader?: Maybe<Seo_DomainSkillsHeader>;
  /** EQP headers id */
  id: Scalars['ID'];
  /** Header payload for related search suggestions */
  relatedSearchHeader?: Maybe<Seo_RelatedSearchHeader>;
  /** Header payload for main search results */
  searchResultsHeader?: Maybe<Seo_SearchResultsHeader>;
};

/** Customizable EQP headers input */
export type Seo_EqpHeadersInput = {
  /** Header payload for domain skills suggestions */
  domainSkillsHeader?: InputMaybe<Seo_DomainSkillsHeaderInput>;
  /** Header payload for related search suggestions */
  relatedSearchHeader?: InputMaybe<Seo_RelatedSearchHeaderInput>;
  /** Header payload for main search results */
  searchResultsHeader?: InputMaybe<Seo_SearchResultsHeaderInput>;
};

/** Eqp grouping mutation input */
export type Seo_EqpHreflangGroupingMutationInput = {
  /** List of hreflang links to group */
  hreflangLinks: Array<Seo_HreflangLinkInput>;
};

/** Union of EQP Grouping failures and success results */
export type Seo_EqpHreflangGroupingMutationResult = Seo_EqpGroupingMutationSuccess | Seo_MutationFailureResult;

/** Eqp ungrouping mutation input */
export type Seo_EqpHreflangUngroupingMutationInput = {
  /** List of hreflang links to ungroup */
  hreflangLinks: Array<Seo_HreflangLinkInput>;
};

/** Union of EQP Ungrouping failures and success results */
export type Seo_EqpHreflangUngroupingMutationResult = Seo_EqpUngroupingMutationSuccess | Seo_MutationFailureResult;

/** EQP Ungrouping success result containing the affected EqpData */
export type Seo_EqpUngroupingMutationSuccess = {
  __typename?: 'Seo_EqpUngroupingMutationSuccess';
  /** Configuration that was acted on */
  eqpData: Array<Seo_EqpData>;
};

/** Footer payload */
export type Seo_Footer = {
  __typename?: 'Seo_Footer';
  /** Footer categories */
  categories: Array<Seo_FooterCategory>;
  /** SEO footer id */
  id: Scalars['ID'];
};

/** Footer categories */
export type Seo_FooterCategory = {
  __typename?: 'Seo_FooterCategory';
  /** Header of category */
  header: Scalars['String'];
  /** SEO footer category id */
  id: Scalars['ID'];
  /** Links in this category */
  links: Array<Seo_ComponentLink>;
};

/** Footer category input */
export type Seo_FooterCategoryInput = {
  /** Header of category */
  header: Scalars['String'];
  /** Links in this category */
  links: Array<Seo_ComponentLinkInput>;
};

/** Generic error for seo mutations */
export type Seo_GenericMutationError = Error & {
  __typename?: 'Seo_GenericMutationError';
  /** Readable message provides the error details. */
  message: Scalars['String'];
};

/** Header payload */
export type Seo_Header = {
  __typename?: 'Seo_Header';
  /** Customizable EQP (Entity Query Page) headers, for SEO search results */
  eqp?: Maybe<Seo_EqpHeaders>;
  /** SEO header id */
  id: Scalars['ID'];
};

/** Header input */
export type Seo_HeaderInput = {
  /** Customizable EQP headers input */
  eqp?: InputMaybe<Seo_EqpHeadersInput>;
};

/** SEO Hreflang Link type */
export type Seo_HreflangLink = {
  __typename?: 'Seo_HreflangLink';
  /** Hreflang link href attribute */
  href: Scalars['URL'];
  /** Hreflang Link hreflang attribute */
  hreflang: Scalars['String'];
  /** Hreflang Link id */
  id: Scalars['ID'];
};

/** SEO Hreflang Link input */
export type Seo_HreflangLinkInput = {
  /** Hreflang link href attribute */
  href: Scalars['URL'];
  /** Hreflang Link hreflang attribute */
  hreflang: Scalars['String'];
};

/**
 * Matched page data - This type has page data as well as priority and path regex.
 * This will be used by admin tool to check all page data that matches with a given
 * path.
 */
export type Seo_MatchedPageDataV1 = {
  __typename?: 'Seo_MatchedPageDataV1';
  /** SEO data id */
  id: Scalars['ID'];
  /** Page data */
  pageData: Seo_PageDataV1;
  /** SEO page data path regex */
  pathRegex: Scalars['String'];
  /**
   * SEO page data priority
   * Higher value has higher priority
   */
  priority: Scalars['Int'];
};

/** Max Image Preview setting for robots meta tag */
export const Seo_MaxImagePreview = {
  /** Large image preview */
  Large: 'LARGE',
  /** No image preview */
  None: 'NONE',
  /** Standard image preview */
  Standard: 'STANDARD'
} as const;

export type Seo_MaxImagePreview = typeof Seo_MaxImagePreview[keyof typeof Seo_MaxImagePreview];
/** Mega menu payload for specified category and links overrides */
export type Seo_MegaMenu = {
  __typename?: 'Seo_MegaMenu';
  /** Top level categories within the mega menu */
  categories: Array<Seo_MegaMenuCategory>;
  /** SEO mega menu id */
  id: Scalars['ID'];
};

/** Customized category within the mega menu */
export type Seo_MegaMenuCategory = {
  __typename?: 'Seo_MegaMenuCategory';
  /** Header label of the top-level category */
  header: Scalars['String'];
  /** Mega menu category id */
  id: Scalars['ID'];
  /** Subcategories within the mega menu category */
  subcategories: Array<Seo_MegaMenuSubcategory>;
};

/** Mega menu input for specifying a top-level category */
export type Seo_MegaMenuCategoryInput = {
  /** Header label of the top-level category */
  header: Scalars['String'];
  /** Subcategory info */
  subcategories: Array<Seo_MegaMenuSubcategoryInput>;
};

/** Mega menu input for specifying category and links overrides */
export type Seo_MegaMenuInput = {
  /** Top level categories within the mega menu */
  categories: Array<Seo_MegaMenuCategoryInput>;
};

/** Subcategory within a mega menu category */
export type Seo_MegaMenuSubcategory = {
  __typename?: 'Seo_MegaMenuSubcategory';
  /** Subcategory header */
  header: Scalars['String'];
  /** ID for this subcategory */
  id: Scalars['ID'];
  /** Links that populate the menu subcategory contents */
  links: Array<Seo_ComponentLink>;
};

/** Subcategory info */
export type Seo_MegaMenuSubcategoryInput = {
  /** Header label of the subcategory */
  header: Scalars['String'];
  /** Links that will populate the menu subcategory contents */
  links: Array<Seo_ComponentLinkInput>;
};

/** Meta Tags type */
export type Seo_MetaTags = {
  __typename?: 'Seo_MetaTags';
  /** Canonical URL */
  canonicalURL?: Maybe<Scalars['URL']>;
  /** Description Tag */
  descriptionTag?: Maybe<Scalars['String']>;
  /**
   * Disable Crawler AI Flag
   * The default behavior is false, indicating that crawlers are allowed to use the content for AI on a given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from using content for AI training.
   */
  disableCrawlerAI?: Maybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Follow Flag
   * The default behavior is false, indicating that crawlers are allowed to follow links on the given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from following links.
   */
  disableCrawlerFollow?: Maybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Indexing Flag
   * The default behavior is false, indicating that crawlers are allowed to add the given page to their index.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given
   * page and that generated metatags should not block crawling.
   */
  disableCrawlerIndexing?: Maybe<Scalars['Boolean']>;
  /** Hreflang Links */
  hreflangLinks?: Maybe<Array<Seo_HreflangLink>>;
  /** SEO Meta Tags id */
  id: Scalars['ID'];
  /**
   * Max Image Preview setting for robots meta tag
   * Controls the size of image preview shown in search results. A null value means no specific setting is applied.
   */
  maxImagePreview?: Maybe<Seo_MaxImagePreview>;
  /** Title Tag */
  titleTag?: Maybe<Scalars['String']>;
};

/** Meta Tags input */
export type Seo_MetaTagsInput = {
  /** Canonical URL */
  canonicalURL?: InputMaybe<Scalars['URL']>;
  /** Description Tag */
  descriptionTag?: InputMaybe<Scalars['String']>;
  /**
   * Disable Crawler AI Flag
   * The default behavior is false, indicating that crawlers are allowed to use the content for AI on a given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from using content for AI training.
   */
  disableCrawlerAI?: InputMaybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Follow Flag
   * The default behavior is false, indicating that crawlers are allowed to follow links on the given page.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given page
   * and that generated metatags should not block crawlers from following links.
   */
  disableCrawlerFollow?: InputMaybe<Scalars['Boolean']>;
  /**
   * Disable Crawler Indexing Flag
   * The default behavior is false, indicating that crawlers are allowed to add the given page to their index.
   * A null value indicates that there is no specific override set by internal SEO tooling for the given
   * page and that generated metatags should not block crawling.
   */
  disableCrawlerIndexing?: InputMaybe<Scalars['Boolean']>;
  /** Hreflang Links */
  hreflangLinks?: InputMaybe<Array<Seo_HreflangLinkInput>>;
  /**
   * Max Image Preview setting for robots meta tag
   * Controls the size of image preview shown in search results. A null value means no specific setting is applied.
   */
  maxImagePreview?: InputMaybe<Seo_MaxImagePreview>;
  /** Title Tag */
  titleTag?: InputMaybe<Scalars['String']>;
};

/** Mutation failure result containing an array of error details */
export type Seo_MutationFailureResult = {
  __typename?: 'Seo_MutationFailureResult';
  /** Error details */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** Page Data Config result action (add, update, delete) */
export const Seo_PageDataConfigResultActionV1 = {
  /**
   * Page data config was added
   * The pathRegex was not present in the data store and a new record was written
   */
  Add: 'ADD',
  /**
   * Page data config was deleted
   * The pathRegex previously existed in the data store and was removed
   */
  Delete: 'DELETE',
  /**
   * Page data config was updated
   * The pathRegex existed in the data store and the configuration fields for that path regex were overwritten
   */
  Update: 'UPDATE'
} as const;

export type Seo_PageDataConfigResultActionV1 = typeof Seo_PageDataConfigResultActionV1[keyof typeof Seo_PageDataConfigResultActionV1];
/** Union of Page Data Configuration failures and success results */
export type Seo_PageDataConfigResultV1 = Seo_MutationFailureResult | Seo_PageDataConfigSuccessResultV1;

/** Page Data Config success result containing the action of the mutation and the configuration that was acted on */
export type Seo_PageDataConfigSuccessResultV1 = {
  __typename?: 'Seo_PageDataConfigSuccessResultV1';
  /** Action of mutation */
  action: Seo_PageDataConfigResultActionV1;
  /** Configuration that was acted on */
  pageDataConfig: Seo_PageDataConfigV1;
};

/**
 * Seo page data config - This type is used for self service and includes the priority and the
 * path regex configured by SEO content management
 */
export type Seo_PageDataConfigV1 = {
  __typename?: 'Seo_PageDataConfigV1';
  /** Global footer links */
  globalFooter?: Maybe<Seo_Footer>;
  /** Header text and links */
  headers?: Maybe<Seo_Header>;
  /**
   * SEO page data config data ID
   * The ID will be based on the pathRegex as that defines a unique record
   * The planned structure is `pathData~<MD5 sum of pathRegex>`
   */
  id: Scalars['ID'];
  /** Mega menu categories and links */
  megaMenu?: Maybe<Seo_MegaMenu>;
  /** SEO Meta Tags */
  metaTags?: Maybe<Seo_MetaTags>;
  /**
   * SEO page data path regex
   * This field defines a unique record
   */
  pathRegex: Scalars['String'];
  /** SEO page data priority */
  priority: Scalars['Int'];
  /** Subfooter links */
  subfooter?: Maybe<Seo_Footer>;
};

/** Full export type contains an array of every Page Data Config in the pageData field */
export type Seo_PageDataFullExportV1 = {
  __typename?: 'Seo_PageDataFullExportV1';
  /** Full Export ID */
  id: Scalars['ID'];
  /** Array of all page data configurations */
  pageData: Array<Seo_PageDataConfigV1>;
};

/** Full import input takes an array of every Page Data Config input in the pageData field */
export type Seo_PageDataFullImportV1MutationInput = {
  /** Array of all page data config inputs */
  pageData: Array<Seo_PageDataInputV1>;
};

/** Page Data full import response. Contains a list of individual config results. */
export type Seo_PageDataFullImportV1MutationResult = {
  __typename?: 'Seo_PageDataFullImportV1MutationResult';
  /** Page Data full import response ID */
  id: Scalars['ID'];
  /** Page Data full import response results array */
  results: Array<Seo_PageDataConfigResultV1>;
};

/** Page Data Input */
export type Seo_PageDataInputV1 = {
  /** Global footer links */
  globalFooter?: InputMaybe<Array<Seo_FooterCategoryInput>>;
  /** Header text and links */
  headers?: InputMaybe<Seo_HeaderInput>;
  /** Mega menu categories and links */
  megaMenu?: InputMaybe<Seo_MegaMenuInput>;
  /** SEO Meta Tags */
  metaTags?: InputMaybe<Seo_MetaTagsInput>;
  /**
   * SEO page data path regex
   * This field defines a unique record
   */
  pathRegex: Scalars['String'];
  /**
   * SEO page data priority
   * Higher value has higher priority
   */
  priority: Scalars['Int'];
  /** Subfooter links */
  subfooter?: InputMaybe<Array<Seo_FooterCategoryInput>>;
};

/** Page data override input takes an array for overwrite, merge and delete */
export type Seo_PageDataOverrideV1MutationInput = {
  /** Path regexes to delete */
  delete?: InputMaybe<Array<Scalars['String']>>;
  /** Merge page data input */
  merge?: InputMaybe<Array<Seo_PageDataInputV1>>;
  /** Overwrite page data input */
  overwrite?: InputMaybe<Array<Seo_PageDataInputV1>>;
};

/** Page Data override mutation result. Contains a list of individual config results. */
export type Seo_PageDataOverrideV1MutationResult = {
  __typename?: 'Seo_PageDataOverrideV1MutationResult';
  /** Page Data override response ID */
  id: Scalars['ID'];
  /** Page Data override response results array */
  results: Array<Seo_PageDataConfigResultV1>;
};

/**
 * Seo page data - This type is used by the frontend to render dynamic SEO content
 * on the page. It does not include priority or path regex because those fields
 * are used for business logic within the seo-application backend service.
 */
export type Seo_PageDataV1 = {
  __typename?: 'Seo_PageDataV1';
  /** Global footer links */
  globalFooter?: Maybe<Seo_Footer>;
  /**
   * Header text and links
   * @deprecated Use Seo_EqpHeaders in Seo_EqpData because the headers are specifically relevant to EQP page type
   */
  headers?: Maybe<Seo_Header>;
  /** SEO data id */
  id: Scalars['ID'];
  /** Mega menu categories and links */
  megaMenu?: Maybe<Seo_MegaMenu>;
  /** SEO Meta Tags */
  metaTags?: Maybe<Seo_MetaTags>;
  /** Subfooter links */
  subfooter?: Maybe<Seo_Footer>;
};

/** Seo path configuration */
export type Seo_PathConfiguration = {
  __typename?: 'Seo_PathConfiguration';
  /** EQP data */
  eqpData?: Maybe<Seo_EqpData>;
  /** SEO data id */
  id: Scalars['ID'];
  /** Page data */
  pageData: Seo_PageDataV1;
};

/** Header payload for related search suggestions */
export type Seo_RelatedSearchHeader = {
  __typename?: 'Seo_RelatedSearchHeader';
  /** ID for this custom header */
  id: Scalars['ID'];
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
  /** Custom links that will guide learners to related searches */
  links: Array<Seo_ComponentLink>;
};

/** Header payload for related search suggestions */
export type Seo_RelatedSearchHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
  /** Custom links that will guide learners to related searches */
  links: Array<Seo_ComponentLinkInput>;
};

/** Seo Robots.txt */
export type Seo_RobotsTxtV1 = {
  __typename?: 'Seo_RobotsTxtV1';
  /** Robots.txt content */
  content: Scalars['String'];
  /** SEO Robots id */
  id: Scalars['ID'];
  /** Subdomain */
  subDomain: Scalars['String'];
};

/** Input for robots.txt mutation */
export type Seo_RobotsTxtV1MutationInput = {
  /** Robots.txt content */
  content: Scalars['String'];
  /** Subdomain */
  subDomain: Scalars['String'];
};

/** Result of seo robots.txt mutation */
export type Seo_RobotsTxtV1MutationResult = Seo_MutationFailureResult | Seo_RobotsTxtV1MutationSuccess;

/** Successful robots.txt mutation result */
export type Seo_RobotsTxtV1MutationSuccess = {
  __typename?: 'Seo_RobotsTxtV1MutationSuccess';
  /** Robots.txt content */
  content: Scalars['String'];
  /** SEO Robots id */
  id: Scalars['ID'];
  /** Subdomain */
  subDomain: Scalars['String'];
};

/** Header payload for main search results */
export type Seo_SearchResultsHeader = {
  __typename?: 'Seo_SearchResultsHeader';
  /** ID for this custom header */
  id: Scalars['ID'];
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** Header payload for main search results */
export type Seo_SearchResultsHeaderInput = {
  /** Custom label to use as the text for this header */
  label: Scalars['String'];
};

/** SEO sitemap report type */
export type Seo_SitemapReport = {
  __typename?: 'Seo_SitemapReport';
  /** SEO sitemap report id */
  id: Scalars['ID'];
  /** SEO sitemap report JSON content */
  report: Scalars['JSON'];
};

/** All Session queries */
export type SessionQueries = {
  __typename?: 'SessionQueries';
  /** Query a session by ID */
  queryById?: Maybe<Session_Session>;
};


/** All Session queries */
export type SessionQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};

/** Session Schedule Overrides queries */
export type SessionScheduleOverridesQueries = {
  __typename?: 'SessionScheduleOverridesQueries';
  /**
   * Query the schedule overrides for a learner by course session id.
   * This api is used by teaching staff to view the overrides set for a learner
   */
  sessionScheduleOverridesByUserAndSession?: Maybe<SessionScheduleOverrides_SessionScheduleOverrides>;
};


/** Session Schedule Overrides queries */
export type SessionScheduleOverridesQueriesSessionScheduleOverridesByUserAndSessionArgs = {
  sessionId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Item deadline override */
export type SessionScheduleOverrides_DeadlineOverride = {
  __typename?: 'SessionScheduleOverrides_DeadlineOverride';
  /** The new deadline this item should have for the learner. */
  deadline: Scalars['DateTime'];
  /** The itemId */
  itemId: Scalars['ID'];
};

/** Item deadline to override */
export type SessionScheduleOverrides_DeadlineOverrideInput = {
  /**
   * The new deadline this item should have for the learner.
   * This can be null in order to delete the deadline override for this item.
   */
  deadline?: InputMaybe<Scalars['DateTime']>;
  /** The itemId to override the deadline for. */
  itemId: Scalars['ID'];
};

/** Item availability window override */
export type SessionScheduleOverrides_ItemAvailabilityOverride = {
  __typename?: 'SessionScheduleOverrides_ItemAvailabilityOverride';
  /** The itemId */
  itemId: Scalars['ID'];
  /** The availability window for the item. */
  timedItemLock: SessionScheduleOverrides_TimedItemLock;
};

/** Item availability window to override */
export type SessionScheduleOverrides_ItemAvailbilityOverrideInput = {
  /** The itemId to override the availability window for */
  itemId: Scalars['ID'];
  /**
   * The availability window for the item.
   * This can be null in order to delete the availability override for this item.
   */
  timedItemLock?: InputMaybe<SessionScheduleOverrides_TimedItemLockInput>;
};

/** Domain specific error interface for patching session schedule overrides */
export type SessionScheduleOverrides_PatchErrors = {
  /** reason for the error */
  message: Scalars['String'];
};

/** Error encountered while performing patch */
export type SessionScheduleOverrides_PatchFailure = {
  __typename?: 'SessionScheduleOverrides_PatchFailure';
  /** errors encountered */
  errors: Array<SessionScheduleOverrides_PatchErrors>;
};

/** Field that indicates if an assessment itemId is accessible to read after the session ends. */
export type SessionScheduleOverrides_PatchSessionScheduleOverridesInput = {
  /**
   * Item deadlines to update
   * Optional, you do not have to set deadlineOverrides if not updating.
   */
  itemDeadlines?: InputMaybe<Array<SessionScheduleOverrides_DeadlineOverrideInput>>;
  /** The session ID */
  sessionId: Scalars['ID'];
  /**
   * Item availability windows to update.
   * Optional, you do not have to set timedItemLocks if not updating.
   */
  timedItemLocks?: InputMaybe<Array<SessionScheduleOverrides_ItemAvailbilityOverrideInput>>;
  /** The userId of the learner whose schedule should be overridden */
  userId: Scalars['ID'];
};

/** Result for patch session schedule overrides mutation */
export type SessionScheduleOverrides_PatchSessionScheduleOverridesResult = SessionScheduleOverrides_PatchFailure | SessionScheduleOverrides_PatchSuccess;

/** Result of a  patch session schedule overrides mutation */
export type SessionScheduleOverrides_PatchSuccess = {
  __typename?: 'SessionScheduleOverrides_PatchSuccess';
  /** The override object */
  overrides: SessionScheduleOverrides_SessionScheduleOverrides;
};

/** The overrides set for a learner and course session */
export type SessionScheduleOverrides_SessionScheduleOverrides = {
  __typename?: 'SessionScheduleOverrides_SessionScheduleOverrides';
  /** A list of item deadlines overrides */
  itemDeadlines: Array<SessionScheduleOverrides_DeadlineOverride>;
  /** SessionId */
  sessionId: Scalars['ID'];
  /** A list of item availability window overrides */
  timedItemLocks: Array<SessionScheduleOverrides_ItemAvailabilityOverride>;
  /** Learners userId */
  userId: Scalars['ID'];
};

/** Indicates when an item will be available (unlocked) for a user */
export type SessionScheduleOverrides_TimedItemLock = {
  __typename?: 'SessionScheduleOverrides_TimedItemLock';
  /** Duration of time from the start of the session to when the item will be relocked */
  relockTime: Scalars['Duration'];
  /** Duration of time from the start of the session to when the item will be unlocked */
  unlockTime: Scalars['Duration'];
};

/** Indicates when an item will be available (unlocked) for a user */
export type SessionScheduleOverrides_TimedItemLockInput = {
  /** Duration of time from the start of the session to when the item will be relocked */
  relockTime: Scalars['Duration'];
  /** Duration of time from the start of the session to when the item will be unlocked */
  unlockTime: Scalars['Duration'];
};

/** Monthly repeat frequency */
export type Session_Monthly = {
  __typename?: 'Session_Monthly';
  /** Repeats every n months */
  cadence: Scalars['Int'];
  /** Day of the month this event should repeat on. Must be <= 28 to allow all months */
  dayOfMonth: Scalars['Int'];
};

/** Domain specific error interface for session mutations */
export type Session_MutationError = {
  /** reason for the error */
  message: Scalars['String'];
};

/** Error encountered while performing mutation */
export type Session_MutationFailure = {
  __typename?: 'Session_MutationFailure';
  /** errors encountered */
  errors?: Maybe<Array<Session_UpdateSessionSpecificItemOverridesError>>;
};

/** Represents the frequency at which sessions in a course will run */
export type Session_RepeatFrequency = Session_Monthly | Session_Weekly;

/** Reference to the course session entity */
export type Session_Session = {
  __typename?: 'Session_Session';
  /** The associated course */
  course: Course_Course;
  /** Course Branch Id */
  courseBranchId: Scalars['ID'];
  /** Deletion time of the course session */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Discussion Session Id */
  discussionSessionId: Scalars['ID'];
  /** End time of the course session */
  endsAt: Scalars['DateTime'];
  /** Enrollment end time */
  enrollmentEndsAt: Scalars['DateTime'];
  /** ID of the session */
  id: Scalars['ID'];
  /** Is the course session externally managed */
  isExternallyManaged: Scalars['Boolean'];
  /** Is the course session preview */
  isPreview: Scalars['Boolean'];
  /** Is the course session private */
  isPrivate: Scalars['Boolean'];
  /** Item Deadlines */
  itemDeadlines: Array<CourseSession_ItemDeadline>;
  /** Module Deadlines */
  moduleDeadlines: Array<CourseSession_ModuleDeadline>;
  /** Schedule Override, returns null if no overrides are pressent */
  scheduleOverride?: Maybe<CourseSession_ScheduleOverride>;
  /**
   * Overrides that are specific to this session and are not applied to other sessions in which
   * this item appears in.
   */
  sessionSpecificItemOverridesPaginated?: Maybe<Session_SessionSpecificItemOverridePaginatedResult>;
  /** Session Type Metadata */
  sessionTypeMetadata: CourseSession_SessionTypeMetadata;
  /** Start time of the course session */
  startsAt: Scalars['DateTime'];
  /** Versioned Course Branch Id */
  versionedBranchId: Scalars['ID'];
};


/** Reference to the course session entity */
export type Session_SessionSessionSpecificItemOverridesPaginatedArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** Result of a session mutation */
export type Session_SessionMutationSuccess = {
  __typename?: 'Session_SessionMutationSuccess';
  /** The session object */
  session: Session_Session;
};

/** Specification for auto-generating recurring sessions */
export type Session_SessionSchedule = {
  __typename?: 'Session_SessionSchedule';
  /** Duration for which enrollment will remain open after session starts */
  postStartEnrollmentDuration: Scalars['Duration'];
  /**
   * How often and when does the session repeat. In other words, this determines the start date
   * of each recurring session
   */
  repeatFrequency: Session_RepeatFrequency;
  /**
   * The date & time on/after which the auto-created sessions should begin. If this date doesn't
   * follow the repetition frequency pattern, the first appropriate date after this date is
   * chosen for the first session
   */
  startsOn: Scalars['DateTime'];
};

/**
 * Overrides that are specific to a session and are not applied to other sessions in which
 * this item appears in.
 */
export type Session_SessionSpecificItemOverride = {
  __typename?: 'Session_SessionSpecificItemOverride';
  /** The session + atom ID of this override. */
  id: Scalars['ID'];
  /** The item ID of this override. */
  itemId: Scalars['ID'];
  /**
   * The optional timestamp of when post session read access to the item is closed. If empty, post
   * session read access is permanently on.
   */
  readAccessItemRelockTime?: Maybe<Scalars['DateTime']>;
};

/** Input for an delete item session mutation. */
export type Session_SessionSpecificItemOverrideDeleteInput = {
  /** The atom ID of the assessment to be deleted */
  assessmentAtomId: Scalars['ID'];
  /** The item ID of the assessment to be deleted */
  assessmentItemId: Scalars['ID'];
  /**
   * The optional dateTime of when post session read access to the item is closed. If empty, post
   * session read access is permanently on.
   */
  deleteReadAccessItemRelockTime?: InputMaybe<Scalars['Boolean']>;
};

/** Input for a session specific item override, can be update or delete */
export type Session_SessionSpecificItemOverrideInput = {
  /** Delete different assessments properties for specific session */
  delete?: InputMaybe<Session_SessionSpecificItemOverrideDeleteInput>;
  /** Update different assessments properties for specific session */
  update?: InputMaybe<Session_SessionSpecificItemOverrideUpdateInput>;
};

/** Paginated Session specific item overrides */
export type Session_SessionSpecificItemOverridePaginatedResult = {
  __typename?: 'Session_SessionSpecificItemOverridePaginatedResult';
  /** List of session specific item overrides */
  elements: Array<Session_SessionSpecificItemOverride>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Field that indicates if an assessment itemId is accessible to read after the session ends. */
export type Session_SessionSpecificItemOverrideUpdateInput = {
  /** The atom ID of the assessment */
  assessmentAtomId: Scalars['ID'];
  /** The item ID of the assessment */
  assessmentItemId: Scalars['ID'];
  /**
   * The optional dateTime of when post session read access to the item is closed. If empty, post
   * session read access is permanently on.
   */
  readAccessItemRelockTime?: InputMaybe<Scalars['DateTime']>;
};

/** Error thrown when update a session specific item overrides fails. */
export type Session_UpdateSessionSpecificItemOverridesError = Error & Session_MutationError & {
  __typename?: 'Session_UpdateSessionSpecificItemOverridesError';
  /** Error message */
  message: Scalars['String'];
};

/** Input for an update item override in session mutation. */
export type Session_UpdateSessionSpecificItemOverridesInput = {
  /** The session ID for the session to be updated */
  sessionId: Scalars['ID'];
  /**
   * List of itemId -> dateTime to indicate if an assessment item can be accessible to read after
   * the session ends.
   */
  sessionSpecificItemOverrides?: InputMaybe<Array<Session_SessionSpecificItemOverrideInput>>;
};

/** Result for update session mutation */
export type Session_UpdateSessionSpecificItemOverridesResult = Session_MutationFailure | Session_SessionMutationSuccess;

/** Weekly repeat frequency */
export type Session_Weekly = {
  __typename?: 'Session_Weekly';
  /** Repeats every n weeks */
  cadence: Scalars['Int'];
  /** Day of week that this event should repeat on ((Monday = 1, Tuesday = 2.. Sunday = 7) */
  dayOfWeek: Scalars['Int'];
};

export type SessionsV2AuthoringEligibilityCheckV1 = {
  __typename?: 'SessionsV2AuthoringEligibilityCheckV1';
  eligibleForSessionsV2: Scalars['Boolean'];
  exemptFromSessionsV2Reasons?: Maybe<Array<Maybe<SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason>>>;
  id: Scalars['String'];
};

export type SessionsV2AuthoringEligibilityCheckV1Connection = {
  __typename?: 'SessionsV2AuthoringEligibilityCheckV1Connection';
  elements: Array<Maybe<SessionsV2AuthoringEligibilityCheckV1>>;
  paging: ResponsePagination;
};

export type SessionsV2AuthoringEligibilityCheckV1Resource = {
  __typename?: 'SessionsV2AuthoringEligibilityCheckV1Resource';
  get?: Maybe<SessionsV2AuthoringEligibilityCheckV1>;
  multiGet?: Maybe<SessionsV2AuthoringEligibilityCheckV1Connection>;
};


export type SessionsV2AuthoringEligibilityCheckV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type SessionsV2AuthoringEligibilityCheckV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = {
  CopiedFromLimitedAvailabilityBranch: 'COPIED_FROM_LIMITED_AVAILABILITY_BRANCH',
  CourseHasDegreeSession: 'COURSE_HAS_DEGREE_SESSION',
  CourseIsExempt: 'COURSE_IS_EXEMPT',
  IrregularCadence: 'IRREGULAR_CADENCE',
  PartnerIsExempt: 'PARTNER_IS_EXEMPT'
} as const;

export type SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = typeof SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason[keyof typeof SessionsV2AuthoringEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason];
export type SessionsV2EnrollmentEligibilityCheckV1 = {
  __typename?: 'SessionsV2EnrollmentEligibilityCheckV1';
  eligibleForSessionsV2: Scalars['Boolean'];
  exemptFromSessionsV2Reasons?: Maybe<Array<Maybe<SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason>>>;
  id: Scalars['String'];
};

export type SessionsV2EnrollmentEligibilityCheckV1Connection = {
  __typename?: 'SessionsV2EnrollmentEligibilityCheckV1Connection';
  elements: Array<Maybe<SessionsV2EnrollmentEligibilityCheckV1>>;
  paging: ResponsePagination;
};

export type SessionsV2EnrollmentEligibilityCheckV1Resource = {
  __typename?: 'SessionsV2EnrollmentEligibilityCheckV1Resource';
  get?: Maybe<SessionsV2EnrollmentEligibilityCheckV1>;
  multiGet?: Maybe<SessionsV2EnrollmentEligibilityCheckV1Connection>;
};


export type SessionsV2EnrollmentEligibilityCheckV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type SessionsV2EnrollmentEligibilityCheckV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = {
  CopiedFromLimitedAvailabilityBranch: 'COPIED_FROM_LIMITED_AVAILABILITY_BRANCH',
  CourseHasDegreeSession: 'COURSE_HAS_DEGREE_SESSION',
  CourseIsExempt: 'COURSE_IS_EXEMPT',
  IrregularCadence: 'IRREGULAR_CADENCE',
  PartnerIsExempt: 'PARTNER_IS_EXEMPT'
} as const;

export type SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason = typeof SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason[keyof typeof SessionsV2EnrollmentEligibilityCheckV1_Org_Coursera_Ondemand_Schedule_Eligibility_ExemptFromSessionsV2Reason];
/** GraphQL representation of BillingCycle.courier */
export const SharedOwnableProduct_BillingCycle = {
  /** Annual Billing Cycle */
  BillingCycleAnnual: 'BILLING_CYCLE_ANNUAL',
  /** Biannual Billing Cycle */
  BillingCycleBiannual: 'BILLING_CYCLE_BIANNUAL',
  /** Invalid Billing Cycle */
  BillingCycleInvalid: 'BILLING_CYCLE_INVALID',
  /** Monthly Billing Cycle */
  BillingCycleMonthly: 'BILLING_CYCLE_MONTHLY'
} as const;

export type SharedOwnableProduct_BillingCycle = typeof SharedOwnableProduct_BillingCycle[keyof typeof SharedOwnableProduct_BillingCycle];
/** GraphQL representation of InstallmentPaymentScheme.courier */
export type SharedOwnableProduct_InstallmentPaymentScheme = {
  __typename?: 'SharedOwnableProduct_InstallmentPaymentScheme';
  /**
   * The cadence of installment charge. Currently we uses BillingCycle from subscriptions
   * because our installment products are built as "subscription products with limited
   * number of billing cycles". It's charged on a [BillingCycle] basis and uses the
   * subscription engine underneath.
   */
  chargeCadence: SharedOwnableProduct_BillingCycle;
  /** The number of installments. (or the number of BillingCycle with the current implementation) */
  numberOfInstallments: Scalars['Int'];
  /** The number of free trial days. */
  numberOfTrialDays: Scalars['Int'];
  /**
   * The ownership period (in days) that users will have after purchasing the product.
   * This is the days in total of all installments. Per installment ownershipDays is
   * calculated using ownershipDays / numberOfInstallments and are granted to user after
   * each installment. Reporting also uses the per installment ownershipDays to calculate
   * revenue recognition period.
   */
  ownershipDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/** GraphQL representation of NotApplicablePaymentScheme.courier */
export type SharedOwnableProduct_NotApplicablePaymentScheme = {
  __typename?: 'SharedOwnableProduct_NotApplicablePaymentScheme';
  /** Stated reason for the payment scheme not being applicable */
  reason: Scalars['String'];
};

/** OneTimePaymentScheme representation */
export type SharedOwnableProduct_OneTimePaymentScheme = {
  __typename?: 'SharedOwnableProduct_OneTimePaymentScheme';
  /**
   * The ownership period (in days) that users will have after purchasing the product.
   * This is also used to calculate revenue recognition period in reporting.
   */
  ownershipDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/**
 * An `OwnableProduct` is a product that has a concept of ownership or "elevated access".
 *
 * These products can represent either content (courses, s12ns) or experiences (Coursera for Teams, Coursera Plus).
 *
 * The `OwnableProduct` naming deliberately avoids verbiage like "Purchase", e.g. `PurchasableProduct`. This is because
 * purchasing / paying for something directly isn't the only way to get elevated access to a piece of content or
 * experience. Instances of this model are also critical to Coursera Plus, Enterprise, and Degree enrollment flows which
 * don't involve purchase / payment, hence the more general naming of `OwnableProduct`.
 *
 * This model was created as a part of the Next Gen Product Configuration System project, which aims to decompose and
 * invert the legacy ProductMetadata model (https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/product/ProductMetadata.courier)
 * into a more sane modeling for our current use cases. For more context, refer to the following Confluence homebase
 * and the associated tech docs/artifacts: https://coursera.atlassian.net/wiki/spaces/B2C/pages/2090336410/Next+Gen+Product+Configuration+System.
 * In most of these artifacts, we use the placeholder names of `ProductCatalogEntity` and `ProductCatalogEntityConfiguration`
 * to refer to the `OwnableProduct` and `OwnableProductFulfillmentConfiguration` models respectively.
 */
export type SharedOwnableProduct_OwnableProduct = {
  __typename?: 'SharedOwnableProduct_OwnableProduct';
  /**
   * An opaque identifier for an ownable product that will generally be referenced by Consumer flows (checkout,
   * configuration, enrollment modal, etc.).
   *
   * In the short-term, I envision the main purpose of this field as a more convenient way of representing the
   * one-to-many relationship between `OwnableProduct` -> `OwnableProductFulfillmentConfiguration`.
   *
   * My hunch is that we will probably continue to prefer productType~productItemId as the unique identifier for an
   * `OwnableProduct` in application code, especially as we're working through the migration in the short-term.
   *
   * I'm not sure what usage of `OwnableProductId` will look like in the future, I'm mainly including it for now for
   * the sake of modeling best practices.
   *
   * POSSIBLE EXTENSIONS FOR THIS MODEL:
   *
   * The original design doc (https://docs.google.com/document/d/1kOdR8owvZQV_ZXt7xWhZQJR6GDsxKTDF_GJtLRU9TCc/edit)
   * includes a `properties` field on this model (referred to as `ProductCatalogEntity` in old documents). The intention
   * behind this field was to support additional metadata that is PRODUCT-specific. We have omitted it because there
   * isn't an existing use case. However, we think it is feasible that Coursera will eventually develop product
   * features/experiences for which this field/abstraction most sensibly supports, which is why we've decided to call
   * out/document this extension specifically.
   *
   * Example use case: We create domain-specific Coursera Plus products (Data Science Coursera Plus, Software Engineer
   * Coursera Plus). The `properties` field could contain metadata about what domain this Coursera Plus product is for,
   * which could be used presentationally, in post-purchase side-effects (e.g. send a Github repo invitation for Data
   * Science/Software Engineer Coursera Plus but not MBA Coursera Plus), etc.
   *
   * The ontology of this field would probably map closely to some subset of the ontology of the ProductType model (e.g.
   * CourseraPlusProductProperties, SpecializationProductProperties, etc.).
   *
   * NOTE: The proposed `properties` field in this model should not be confused with the legacy
   * `ProductMetadata#properties` field. The legacy field is a badly named field, which most closely resembles
   * `OwnableProductFulfillmentConfiguration#paymentScheme`, e.g. payment/fulfillment-specific metadata, which includes
   * no product-specific context.
   */
  id: Scalars['ID'];
  /**
   * This maps to `ProductMetadata#underlyingProductId#productItemId`.
   *
   * For products that map to a specific piece of content, this should generally be a string value which holds meaning /
   * corresponds to data in other teams / systems, e.g. S12nId, DegreeId, CourseId. For these types of products, we
   * generally use the ID to make API calls to external systems. Examples:
   *  - To execute post-checkout side-effects such as course/s12n membership creation, degree auto-enrollment, etc.
   *  - To fetch the courses in an s12n for cart item building
   *
   * For this case, the serialized representations of
   * ProductItemId and the external ID model are equivalent, we merely deserialize it into a different model for type
   * safety.
   *
   * For products that don’t map to a specific piece of content (`CourseraPlus`, `EnterpriseContract`), this is
   * generally a randomly generated ID with no external meaning.
   *
   * TODO: As we start migrating our systems to refer to this modeling, I envision some redundancy between `ProductItemId`
   * and `OwnableProductId`. For now, we dumbly / blindly maintain this field for backwards compatibility / safety. We
   * want to be able to cleanly reconstruct the legacy model's structure until the entire Next Gen Product Configuration
   * System project is finished and in the wild for a bit.
   *
   * Random ideas for dealing with potential redundancy in the future:
   *  - Rename this to something like `externalContext` that is optional and only used when additional external context
   *  is needed (e.g. for post-checkout side-effects)
   */
  productItemId: Scalars['ID'];
  /**
   * This maps to `ProductMetadata#underlyingProductId#productType`.
   *
   * In the legacy modeling, this could be any of the ProductType values defined here: https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/scala/org/coursera/product/ProductType.scala.
   * In the next gen modeling, this field should only reference ProductTypes that are agnostic of payment/billing
   * schemes, e.g. `Specialization` is valid, `SpecializationSubscription` is not.
   *
   * This is the primary insight motivating the Next Gen Product Configuration project: ideally, a ProductType and
   * ProductItemId tuple should only identify "what a learner is getting access to" not both "what a learner is getting
   * access to" and "how they're getting access to it" (see original proposal for rationale).
   *
   * I'm deliberately ignoring the `ProductId` convenience model and preferring individual `ProductType` and
   * `ProductItemId` fields here. It's a bit smelly to me if this model just encompasses two IDs (`OwnableProductId` and
   * `ProductId`). I think this smell is a result of suboptimal naming / modeling. Maybe ProductItemId is a bit of a
   * misnomer? In some cases it is just an opaque ID, in other cases it has external meaning in other systems / DB tables (see
   * below for more context). Maybe we don't need `OwnableProductId` at all? I'm deferring these questions until we get
   * deeper in the migration.
   */
  productType: SharedOwnableProduct_OwnableProductType;
};

/**
 * OwnableProductTuple is a shared model representing all the details required to
 * fulfill both payment and product related fulfillment details for the learner.
 */
export type SharedOwnableProduct_OwnableProductTuple = {
  __typename?: 'SharedOwnableProduct_OwnableProductTuple';
  /**
   * An ownable product is defined as a product (s12n, course, cplus) that can be
   * owned by a learner at Coursera (either through purchase or non-purchase).
   */
  ownableProduct: SharedOwnableProduct_OwnableProduct;
  /**
   * Id that uniquely identifies the specific fulfillment configuration of the ownable product.
   * For more details please refer to `OwnableProductFulfillmentConfiguration::id`
   */
  ownableProductFulfillmentConfigurationId: Scalars['ID'];
  /** Payment scheme on how this configuration can be purchased and/or fulfilled. */
  paymentScheme: SharedOwnableProduct_PaymentScheme;
};

/**
 * This enum represents all the ownable product types at Coursera.
 * This is different from ProductType because product type has both underlying and top-level product types
 * whereas OwnableProductType are only the underlying product types.s
 * For more information refer to `OwnableProduct::productType`.
 */
export const SharedOwnableProduct_OwnableProductType = {
  /** Catalog subscription. */
  OwnableProductTypeCatalogSubscription: 'OWNABLE_PRODUCT_TYPE_CATALOG_SUBSCRIPTION',
  /**
   * [2022 Q2] payment-experience is working on the Coursera Plus Prepaid (one-time payment scheme) product.
   *
   * We've been rethinking the product configuration system as a part of the Next Gen Product Configuration System
   * project (https://coursera.atlassian.net/wiki/spaces/B2C/pages/2090336410/Next+Gen+Product+Configuration+System).
   * Due to this rethinking, we've decided to deviate from past patterns for concurrently selling products under
   * one-time and subscription payment schemes (e.g. s12ns use 3 Specialization* ProductTypes).
   *
   * Our current plan for supporting Coursera Plus in general is:
   *   - Coursera Plus Prepaid: use ProductType.CourseraPlus for (using legacy terminology) both the product_item_id
   *     and the underlying_product_item_id
   *   - Coursera Plus Subscription: use ProductType.CourseraPlusSubscription for (using legacy terminology) both the
   *     product_item_id and the underlying_product_item_id
   *
   * Eventually we hope to deprecate ProductType.CourseraPlusSubscription entirely in favor of
   * ProductType.CourseraPlus and the SubscriptionPaymentScheme (https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/product/PaymentScheme.courier)/
   * This worked is captured by Phase 4 of Next Gen Product Configuration System.
   */
  OwnableProductTypeCourseraPlus: 'OWNABLE_PRODUCT_TYPE_COURSERA_PLUS',
  /** Internal representation of a site-wide subscription at Coursera. */
  OwnableProductTypeCourseraPlusSubscription: 'OWNABLE_PRODUCT_TYPE_COURSERA_PLUS_SUBSCRIPTION',
  /**
   * [2022 Q3] Coursera Plus Pod is working on the "Subscription Tier" product, which is a new
   * type of subscription which will give learner's access based on which tier they are in.
   *
   * We are currently introducing "Lite Tier" which is a low cost subscription which will
   * provide the learner auditing access (As a corollary, auditing will be removed from free
   * learners). As part of the Next Gen Product System, while the product is officially called
   * "Subscription Tier", we will be omitted "subscription" from the name of the product to leave
   * the payment scheme out from the product.
   *
   * Technical Document:
   * https://docs.google.com/document/d/10545kiuM6KRpyvpG1Yw-Dmej-0EyAn34ZEgIw5FY2vg/edit?usp=sharing
   */
  OwnableProductTypeCourseraTierLite: 'OWNABLE_PRODUCT_TYPE_COURSERA_TIER_LITE',
  /**
   * Internal representation of the Master track product line at Coursera which is a collection of
   * courses sold as an elevated degree content.
   */
  OwnableProductTypeCredentialTrackSubscription: 'OWNABLE_PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION',
  /**
   * The updated internal representation of the Master track product line at Coursera.
   *
   * A new version of CredentialTrackSubscription/CredentialTrackCourse that has different
   * revenue recognition and ownership granting logic from the original version.
   *
   * Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   */
  OwnableProductTypeCredentialTrackSubscriptionV2: 'OWNABLE_PRODUCT_TYPE_CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /**
   * Represents an enterprise contract. This is not an ownable product type, but a purchasable
   * product type. This is used to represent the enterprise contract in the checkout flow.
   */
  OwnableProductTypeEnterpriseContract: 'OWNABLE_PRODUCT_TYPE_ENTERPRISE_CONTRACT',
  /** Facilitated learning. */
  OwnableProductTypeFacilitatedLearning: 'OWNABLE_PRODUCT_TYPE_FACILITATED_LEARNING',
  /** Interest deposit. */
  OwnableProductTypeInterestDeposit: 'OWNABLE_PRODUCT_TYPE_INTEREST_DEPOSIT',
  /** Invalid product type. This is used as a default value. */
  OwnableProductTypeInvalid: 'OWNABLE_PRODUCT_TYPE_INVALID',
  /** Spark course shell. */
  OwnableProductTypeSparkCourseShell: 'OWNABLE_PRODUCT_TYPE_SPARK_COURSE_SHELL',
  /** Spark specialization. */
  OwnableProductTypeSparkSpecialization: 'OWNABLE_PRODUCT_TYPE_SPARK_SPECIALIZATION',
  /** Spark verified certificate. */
  OwnableProductTypeSparkVerifiedCertificate: 'OWNABLE_PRODUCT_TYPE_SPARK_VERIFIED_CERTIFICATE',
  /**
   * Internal representation of the specialization product type. It represents a collection of
   * courses that are part of a specialization.
   */
  OwnableProductTypeSpecialization: 'OWNABLE_PRODUCT_TYPE_SPECIALIZATION',
  /**
   * Internal representation of the course product type. This represents all the courses at
   * Coursera including guided projects, course in specializations and course in degrees.
   */
  OwnableProductTypeVerifiedCertificate: 'OWNABLE_PRODUCT_TYPE_VERIFIED_CERTIFICATE'
} as const;

export type SharedOwnableProduct_OwnableProductType = typeof SharedOwnableProduct_OwnableProductType[keyof typeof SharedOwnableProduct_OwnableProductType];
/** GraphQL representation of PaymentScheme.courier */
export type SharedOwnableProduct_PaymentScheme = SharedOwnableProduct_InstallmentPaymentScheme | SharedOwnableProduct_NotApplicablePaymentScheme | SharedOwnableProduct_OneTimePaymentScheme | SharedOwnableProduct_SubscriptionPaymentScheme;

/** GraphQL representation of SubscriptionPaymentScheme.courier */
export type SharedOwnableProduct_SubscriptionPaymentScheme = {
  __typename?: 'SharedOwnableProduct_SubscriptionPaymentScheme';
  /** GraphQL representation of BillingCycle.courier */
  billingCycle: SharedOwnableProduct_BillingCycle;
  /** The number of free trial days. */
  numberOfTrialDays: Scalars['Int'];
  /** The number of days after purchase that users can refund the product. */
  refundDays: Scalars['Int'];
};

/** shortformcontent GraphQL Schema queries */
export type ShortFormContentQueries = {
  __typename?: 'ShortFormContentQueries';
  /**
   * This query provides Information required to power up SFC VLP. NOTE: BE is responsible for resolving
   * corresponding enterprise context
   */
  queryVideoData?: Maybe<ShortFormContent_VideoData>;
  /**
   * This query provides some important Information required to power up SFC VLP in the known enterprise organization context
   * @deprecated Specifying Enterprise context is no longer supported, use queryVideoDataForEnterpriseProgramContext instead
   */
  queryVideoDataForEnterpriseOrganizationContext?: Maybe<ShortFormContent_VideoData>;
  /**
   * This query provides Information required to power up SFC VLP in the known enterprise program context
   * @deprecated Specifying Enterprise context is no longer supported, use queryVideoDataForEnterpriseProgramContext instead
   */
  queryVideoDataForEnterpriseProgramContext?: Maybe<ShortFormContent_VideoData>;
};


/** shortformcontent GraphQL Schema queries */
export type ShortFormContentQueriesQueryVideoDataArgs = {
  input?: InputMaybe<ShortFormContent_QueryVideoDataInput>;
};


/** shortformcontent GraphQL Schema queries */
export type ShortFormContentQueriesQueryVideoDataForEnterpriseOrganizationContextArgs = {
  input?: InputMaybe<ShortFormContent_QueryVideoDataForEnterpriseOrganizationContextInput>;
};


/** shortformcontent GraphQL Schema queries */
export type ShortFormContentQueriesQueryVideoDataForEnterpriseProgramContextArgs = {
  input?: InputMaybe<ShortFormContent_QueryVideoDataForEnterpriseProgramContextInput>;
};

/** Course Lesson Details */
export type ShortFormContent_CourseLesson = {
  __typename?: 'ShortFormContent_CourseLesson';
  /** Lesson ID */
  lessonId: Scalars['ID'];
  /** Lesson Title */
  lessonTitle: Scalars['String'];
};

/** Details of all Course Lessons */
export type ShortFormContent_CourseLessons = {
  __typename?: 'ShortFormContent_CourseLessons';
  /** Course Lessons Details */
  lessons: Array<ShortFormContent_CourseLesson>;
};

/** Course Video Details */
export type ShortFormContent_CourseVideo = {
  __typename?: 'ShortFormContent_CourseVideo';
  /** Is Video Completed by learner */
  isCompleted: Scalars['Boolean'];
  /** Total Video Duration */
  videoDurationMs: Scalars['Int'];
  /** Video ID */
  videoId: Scalars['ID'];
  /** Video Progress Time Duration */
  videoProgressMs: Scalars['Int'];
  /** Video Thumbnail URL */
  videoThumbnailUrl: Scalars['URL'];
  /** Video Title */
  videoTitle: Scalars['String'];
};

/** Details of all Course Videos */
export type ShortFormContent_CourseVideos = {
  __typename?: 'ShortFormContent_CourseVideos';
  /** Course Videos Details */
  videos: Array<ShortFormContent_CourseVideo>;
};

/**
 * Container object for information required to enroll enterprise user in the course using an enterprise program.
 * User id will be picked up from logged-in context
 */
export type ShortFormContent_EnrollEnterpriseUserIntoCourseInput = {
  /** Course id enterprise user attempts to enroll into */
  courseId: Scalars['String'];
  /**
   * Video item id. This is needed so that mutation result can contain
   * video assets information that becomes available to user
   * on the successful enrollment
   */
  itemId: Scalars['String'];
  /** Enterprise programs to be used for course enrollment. */
  programId: Scalars['String'];
  /**
   * This flag is used to unsubscribe learner from all course notifications (including emails)
   * For SFC MVP launch it should be true by default. Later on, FE will be able to start supporting it via
   * checkbox, so this default value for this parameter can be removed
   */
  unsubscribeFromCourseNotifications?: InputMaybe<Scalars['Boolean']>;
};

/** User course enrollment result */
export type ShortFormContent_EnrollEnterpriseUserIntoCourseResult = {
  __typename?: 'ShortFormContent_enrollEnterpriseUserIntoCourseResult';
  /** Indicates if course enrollment was successful */
  success: Scalars['Boolean'];
  /** Subtitles, video links and preview images. This will be null in case course enrollment wasn't successful */
  videoAssets?: Maybe<ShortFormContent_VideoAssets>;
};

/** Container object for an enterprise program */
export type ShortFormContent_EnterpriseProgram = {
  __typename?: 'ShortFormContent_enterpriseProgram';
  /** Enterprise program Id */
  id: Scalars['ID'];
  /** Enterprise program slug */
  slug: Scalars['String'];
};

/**
 * Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context
 * NOTE: Specifying Enterprise context is no longer supported, this type shouldn't be used!
 */
export type ShortFormContent_QueryVideoDataForEnterpriseOrganizationContextInput = {
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /** Video item id */
  itemId: Scalars['String'];
  /**
   * Optional OrganizationId identifying the list of programs to be considered as enterprise SFC VLP
   * preview and enrollment context
   */
  organizationId?: InputMaybe<Scalars['String']>;
  /** Optional Organization slug to be considered as enterprise SFC VLP preview and enrollment context */
  organizationSlug?: InputMaybe<Scalars['String']>;
};

/**
 * Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context
 * NOTE: Specifying Enterprise context is no longer supported, this type shouldn't be used!
 */
export type ShortFormContent_QueryVideoDataForEnterpriseProgramContextInput = {
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /** Video item id */
  itemId: Scalars['String'];
  /** Optional Program id to be considered as enterprise SFC VLP preview and enrollment context */
  programId?: InputMaybe<Scalars['String']>;
  /** Optional Program slug to be considered as enterprise SFC VLP preview and enrollment context */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Container object for information required to fetch SFC VLP video data. User id will be picked up from logged-in context */
export type ShortFormContent_QueryVideoDataInput = {
  /** List of atom ids for the batch query */
  atomIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** The id of the course which contains video item */
  courseId: Scalars['String'];
  /**
   * Video item id
   * @deprecated Use itemIds instead
   */
  itemId?: InputMaybe<Scalars['String']>;
  /** List of item ids for batch query */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional Program slug to be considered as enterprise short-form-content (SFC) VLP preview and enrollment context.
   * The FE may specify a program slug to the SFC service, indicates which program video watch progress and enrollment occurs against.
   */
  programSlug?: InputMaybe<Scalars['String']>;
};

/** Pagination abstraction */
export type ShortFormContent_SubtitlesVttEdge = {
  __typename?: 'ShortFormContent_subtitlesVttEdge';
  /** Pagination abstraction */
  cursor: Scalars['String'];
  /** Pagination abstraction */
  node: ShortFormContent_VideoSubtitleVtt;
};

/** Pagination abstraction */
export type ShortFormContent_SubtitlesVttsConnection = {
  __typename?: 'ShortFormContent_subtitlesVttsConnection';
  /** Pagination abstraction */
  edges: Array<Maybe<ShortFormContent_SubtitlesVttEdge>>;
  /** Pagination abstraction */
  pageInfo: PageInfo;
};

/** Container object for information required to track user video progress */
export type ShortFormContent_TrackVideoProgressInput = {
  /** Course id that contains the video being tracked */
  courseId: Scalars['String'];
  /**
   * This represents current video progress ms. It is a timestamp correposnding to the location at which user
   * is currently in the video
   */
  currentVideoProgressMs: Scalars['Int'];
  /** Video item id corresponding to the video being tracked */
  itemId: Scalars['String'];
  /** Optional OrganizationId. The FE may specify an organizationId to the SFC service, indicates which organization video watch progress and enrollment occurs against. */
  organizationId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional programId. The FE may specify a programId to the SFC service, indicates which
   * program video watch progress and enrollment occurs against.
   */
  programId?: InputMaybe<Scalars['ID']>;
  /**
   * Optional Program slug to be considered as enterprise short-form-content (SFC) VLP preview and enrollment context.
   * The FE may specify a program slug to the SFC service, indicates which program video watch progress and enrollment occurs against.
   */
  programSlug?: InputMaybe<Scalars['String']>;
  /**
   * Total video duration. This is needed because sometimes video metadata in the BE contains incorrect information
   * and only web player would know it reliably when it loaded the video
   */
  totalVideoDurationMs: Scalars['Int'];
};

/** Track user video progress result. This type is empty */
export type ShortFormContent_TrackVideoProgressResult = {
  __typename?: 'ShortFormContent_trackVideoProgressResult';
  /**
   * This parameter is not used and created here only to comply with graphQL linter
   * In reality if tracking call fails, it will fail the request
   */
  ignoreMe?: Maybe<Scalars['String']>;
};

/** Container for video assents required by SFC VLP */
export type ShortFormContent_VideoAssets = {
  __typename?: 'ShortFormContent_videoAssets';
  /** Video id */
  id: Scalars['ID'];
  /** Video subtitles information. This will be null in case user can't watch the video | Maximum page size: 1000 */
  subtitlesVttsConnection?: Maybe<ShortFormContent_SubtitlesVttsConnection>;
  /** Video sources information | Maximum page size: 1000 */
  videoSourcesConnection: ShortFormContent_VideoSourcesConnection;
};


/** Container for video assents required by SFC VLP */
export type ShortFormContent_VideoAssetsSubtitlesVttsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Container for video assents required by SFC VLP */
export type ShortFormContent_VideoAssetsVideoSourcesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Container object for SFC VLP video data */
export type ShortFormContent_VideoData = {
  __typename?: 'ShortFormContent_videoData';
  /**
   * Contains enterprise program information used for providing enterprise access to the VLP.
   * User should be part of this program, program should be enabled for SFC and contain
   * corresponding course in its curroculum with requested SFC video
   * Field is used to produce program related components needed on SFC VLP
   * Can be null if user is not part of any program or need to join program
   */
  accessProvidedViaProgram?: Maybe<ShortFormContent_EnterpriseProgram>;
  /** Course Lessons Details */
  courseLessons?: Maybe<ShortFormContent_CourseLessons>;
  /** Course Videos Details */
  courseVideos?: Maybe<ShortFormContent_CourseVideos>;
  /** Id of the course item video (videoID) */
  id: Scalars['ID'];
  /**
   * The number of times this video item was likes
   * @deprecated Use data from shortFormContent_videoDetailsConnection instead
   */
  likes: Scalars['Int'];
  /**
   * Contract tags for program and organization context
   * @deprecated This was never implemented and doesn't seem to be required. This shouldn't even belong to videoData
   */
  organizationContractTags?: Maybe<Array<Scalars['String']>>;
  /**
   * Contains enterprise program information that can be used for enrollment. This field will be null
   * in case there are no available programs for enrollment for any reason e.g.
   * program enrollment cap was reached, user is not part of the program, course is currently not part of the program curriculum,
   * program doesn't exist, etc.
   */
  preferredAvailableForEnrollmentProgram?: Maybe<ShortFormContent_EnterpriseProgram>;
  /** Way to return batch video details | Maximum page size: 1000 */
  shortFormContent_videoDetailsConnection?: Maybe<ShortFormContent_VideoDetailsConnection>;
  /**
   * Contains enterprise program information which the user is suggested to join. This happens in
   * case the user is not currently part of any enterprise program that were provided in the request
   * and have the request content.
   * FE is supposed to use this program to redirect user to program home
   */
  suggestedToJoinProgram?: Maybe<ShortFormContent_EnterpriseProgram>;
  /**
   * Summary of the course item video. It is generated by a job using GPT that is run periodically so summary wil be null
   * until it's not generated
   */
  summary?: Maybe<Scalars['String']>;
  /** Title of the course item video (videoTitle) */
  title: Scalars['String'];
  /** Indicates if user is enrolled into the course which this video data is part of or not */
  userEnrolledIntoCourse: Scalars['Boolean'];
  /**
   * Subtitles, video links and preview images. This will not contain video urls in case the user can't view the video
   * Can be null if user is not a part of a program with the course, and need the
   * suggestedToJoinProgram field to redirect user to program home
   * @deprecated Use data from shortFormContent_videoDetailsConnection instead
   */
  videoAssets?: Maybe<ShortFormContent_VideoAssets>;
  /**
   * The number of times this video item was viewed
   * @deprecated Use data from shortFormContent_videoDetailsConnection instead
   */
  views: Scalars['Int'];
};


/** Container object for SFC VLP video data */
export type ShortFormContent_VideoDataShortFormContent_VideoDetailsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/**
 * Container object for video details. We want to eventually serve batch results to frontend and deprecate
 * current way
 */
export type ShortFormContent_VideoDetails = Node & {
  __typename?: 'ShortFormContent_videoDetails';
  /** Video atom id */
  atomId: Scalars['ID'];
  /** Id of the course item video (videoID) */
  id: Scalars['ID'];
  /** Video  item id */
  itemId: Scalars['String'];
  /** The number of times this video item was likes */
  likes: Scalars['Int'];
  /**
   * Subtitles, video links and preview images. This will not contain video urls in case the user can't view the video
   * Can be null if user is not a part of a program with the course, and need the
   * suggestedToJoinProgram field to redirect user to program home
   */
  videoAssets?: Maybe<ShortFormContent_VideoAssets>;
  /** The number of times this video item was viewed */
  views: Scalars['Int'];
};

/** Pagination abstraction */
export type ShortFormContent_VideoDetailsConnection = {
  __typename?: 'ShortFormContent_videoDetailsConnection';
  /** Pagination abstraction */
  edges: Array<Maybe<ShortFormContent_VideoDetailsEdge>>;
  /** Pagination abstraction */
  pageInfo: PageInfo;
};

/** batch video details */
export type ShortFormContent_VideoDetailsEdge = {
  __typename?: 'ShortFormContent_videoDetailsEdge';
  /** Pagination abstraction */
  cursor: Scalars['String'];
  /** Pagination abstraction */
  node: ShortFormContent_VideoDetails;
};

/** Information corresponding to a single video source of a certain resulution */
export type ShortFormContent_VideoSource = Node & {
  __typename?: 'ShortFormContent_videoSource';
  /** Video resolution label e.g. 540p */
  id: Scalars['ID'];
  /** Mp4 video url - this will be null in case user is not able to watch the video */
  mp4VideoUrl?: Maybe<Scalars['String']>;
  /** Preview image url */
  previewImageUrl: Scalars['String'];
  /** Webm video url - this will be null in case user is not able to watch the video */
  webMVideoUrl?: Maybe<Scalars['String']>;
};

/** Pagination abstraction */
export type ShortFormContent_VideoSourceEdge = {
  __typename?: 'ShortFormContent_videoSourceEdge';
  /** Pagination abstraction */
  cursor: Scalars['String'];
  /** Pagination abstraction */
  node: ShortFormContent_VideoSource;
};

/** Pagination abstraction */
export type ShortFormContent_VideoSourcesConnection = {
  __typename?: 'ShortFormContent_videoSourcesConnection';
  /** Pagination abstraction */
  edges: Array<Maybe<ShortFormContent_VideoSourceEdge>>;
  /** Pagination abstraction */
  pageInfo: PageInfo;
};

/** Information about video subtitles for a certain language */
export type ShortFormContent_VideoSubtitleVtt = Node & {
  __typename?: 'ShortFormContent_videoSubtitleVtt';
  /** Language code e.g. en */
  id: Scalars['ID'];
  /** Subtitles source path */
  sourcePath: Scalars['String'];
};

/** TODO: Complete this description */
export const SimilarityCheckContextType = {
  /** TODO: Complete this description */
  Degree: 'DEGREE',
  /** TODO: Complete this description */
  Enterprise: 'ENTERPRISE'
} as const;

export type SimilarityCheckContextType = typeof SimilarityCheckContextType[keyof typeof SimilarityCheckContextType];
/** Queries for retrieving the status of a similarity check. */
export type SimilarityCheckQueries = {
  __typename?: 'SimilarityCheckQueries';
  /** Query for similarity check status by providing a unique id. */
  queryByCheckId: SimilarityCheck_ReadResult;
  /** Query for similarity check status by providing metadata about the submission. */
  queryByMetadata: SimilarityCheck_ReadResult;
};


/** Queries for retrieving the status of a similarity check. */
export type SimilarityCheckQueriesQueryByCheckIdArgs = {
  similarityCheckId: Scalars['ID'];
};


/** Queries for retrieving the status of a similarity check. */
export type SimilarityCheckQueriesQueryByMetadataArgs = {
  metadata: SimilarityCheck_MetadataInput;
};

/**
 * The similarity check is complete, and we have a score. We may or may not have a
 * a report URL which can be used to view the report.
 */
export type SimilarityCheck_CompleteStatus = {
  __typename?: 'SimilarityCheck_CompleteStatus';
  /** The report URL for the submission, if available. */
  reportUrl?: Maybe<Scalars['URL']>;
  /** The overall plagiarism score for the submission */
  score: Scalars['Float'];
};

/**
 * The reason why the similarity check was failed. This contains both internal errors
 * that lead to us not even submitting the check to the external provider and vendor provided
 * errors when the check was submitted but failed for some reason.
 */
export const SimilarityCheck_ErrorCode = {
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because the content could not be extracted.
   */
  CannotExtractText: 'CANNOT_EXTRACT_TEXT',
  /** The submission was not submitted to the external provider for an unspecified reason. */
  DidNotSubmit: 'DID_NOT_SUBMIT',
  /** The submission was not submitted and a default record was created for the submission. */
  DidNotSubmitDefaultRecord: 'DID_NOT_SUBMIT_DEFAULT_RECORD',
  /** The submission was not submitted to the external provider because no content was found. */
  DidNotSubmitNoContent: 'DID_NOT_SUBMIT_NO_CONTENT',
  /** The submission was not submitted to the external provider because the file type is not supported. */
  DidNotSubmitUnsupportedFileType: 'DID_NOT_SUBMIT_UNSUPPORTED_FILE_TYPE',
  /** The submission was not submitted to the external provider because the upload failed. */
  DidNotSubmitUploadFailed: 'DID_NOT_SUBMIT_UPLOAD_FAILED',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because the file was locked.
   */
  FileLocked: 'FILE_LOCKED',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * for an unspecified reason. Likely indicates that an error code is not captured in this enum
   * and should be added.
   */
  Other: 'OTHER',
  /** The submission was submitted to the external provider, but the provider failed to process it. */
  ProcessingError: 'PROCESSING_ERROR',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there was not enough content.
   */
  TooLittleText: 'TOO_LITTLE_TEXT',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there were too many pages.
   */
  TooManyPages: 'TOO_MANY_PAGES',
  /**
   * The submission was submitted to the external provider, but the provider failed to process it
   * because there was too much content.
   */
  TooMuchText: 'TOO_MUCH_TEXT',
  /**
   * The submission was submited to the external provider, but the provider failed to process it due
   * to the file type.
   */
  UnsupportedFileType: 'UNSUPPORTED_FILE_TYPE'
} as const;

export type SimilarityCheck_ErrorCode = typeof SimilarityCheck_ErrorCode[keyof typeof SimilarityCheck_ErrorCode];
/**
 * The similarity check was either not submitted, or failed for some reason. The error
 * code will provide more information about the failure.
 */
export type SimilarityCheck_FailedStatus = {
  __typename?: 'SimilarityCheck_FailedStatus';
  /** The reason why the similarity check failed. */
  error: SimilarityCheck_ErrorCode;
};

/** The similarity check is still in progress, so we cannot provide a score yet. */
export type SimilarityCheck_InProgressStatus = {
  __typename?: 'SimilarityCheck_InProgressStatus';
  /** Dummy required since we can not have an empty type */
  _: Scalars['Boolean'];
};

/** An individual submitter. This is a user who authored and submitted the assignment. */
export type SimilarityCheck_IndividualSubmitter = {
  /** The submitter of the assignment */
  submitterId: Scalars['ID'];
};

/**
 * Data necessary to identify a submission which has been previously submitted when we
 * do not have the similarity check id.
 */
export type SimilarityCheck_MetadataInput = {
  /**
   * This endpoint will, in general, submit the most recent submission for checking.
   * When this flag is set, draft submissions will be considered when finding the
   * most recent submission.
   */
  considerDrafts: Scalars['Boolean'];
  /** The course for the item to be checked */
  courseId: Scalars['ID'];
  /** The id of the item to be checked */
  itemId: Scalars['ID'];
  /** The response id of the item to be checked for the given author/submitter */
  responseId: Scalars['ID'];
  /** The submitter of the item to be checked */
  submitter: SimilarityCheck_Submitter;
};

/**
 * The result of the similarity check, if available. If not available, or in progress,
 * an error result will be returned.
 */
export type SimilarityCheck_ReadResult = {
  __typename?: 'SimilarityCheck_ReadResult';
  /** The report status/data for the similarity check that was requested */
  result: SimilarityCheck_ReportStatus;
  /**
   * The generated id for the similarity check. This can be used to query the status of the
   * similarity check.
   */
  similarityCheckId: Scalars['ID'];
};

/** The various types of results we may provide */
export type SimilarityCheck_ReportStatus = SimilarityCheck_CompleteStatus | SimilarityCheck_FailedStatus | SimilarityCheck_InProgressStatus;

/** Data necessary to identify a submission which should be checked for similarity. */
export type SimilarityCheck_SubmitInput = {
  /**
   * This endpoint will, in general, submit the most recent submission for checking.
   * When this flag is set, draft submissions will be considered when finding the
   * most recent submission.
   */
  considerDrafts: Scalars['Boolean'];
  /** The course for the item to be checked */
  courseId: Scalars['ID'];
  /** The id of the item to be checked */
  itemId: Scalars['ID'];
  /** The response id of the item to be checked for the given author/submitter */
  responseId: Scalars['ID'];
  /**
   * As of 2021-11-26, this field is used to create cheating cases for peer review submissions with
   * similarity scores over the threshold. It is ignored for SGA submissions. If this field is not
   * set, we will not create a cheating case regardless of score.
   */
  submissionKey?: InputMaybe<Scalars['String']>;
  /** The submitter of the item to be checked */
  submitter: SimilarityCheck_Submitter;
};

/**
 * Basic data needed to identify a submission. Currently, it is just an id, since we want
 * to minimize the surface area of the API. We may want to extend with a status since we can
 * possibly determine some failures or reasons for not processing even though this is an
 * async call.
 */
export type SimilarityCheck_SubmitResult = {
  __typename?: 'SimilarityCheck_SubmitResult';
  /**
   * The generated id for the similarity check. This can be used to query the status of the
   * similarity check.
   */
  similarityCheckId: Scalars['ID'];
};

/** The submitter of the submission. This is either an individual or a team. */
export type SimilarityCheck_Submitter = {
  /** An individual author/submitter */
  individualSubmitter?: InputMaybe<SimilarityCheck_IndividualSubmitter>;
  /** A team submission and the submission author */
  teamSubmitter?: InputMaybe<SimilarityCheck_TeamSubmitter>;
};

/** A team submitter. This contains the author of the submission and the author's team. */
export type SimilarityCheck_TeamSubmitter = {
  /** The scoped team id that the author is a member of */
  scopedTeamId: Scalars['ID'];
  /** The submitter of the assignment */
  submitterId: Scalars['ID'];
};

/** Credit level for skill expression mastery */
export const SkillAttainmentProgress_AttainmentStatus = {
  /** Full credit - skill expression fully attained */
  FullAttainment: 'FULL_ATTAINMENT',
  /** No credit - skill expression not attained */
  NoAttainment: 'NO_ATTAINMENT'
} as const;

export type SkillAttainmentProgress_AttainmentStatus = typeof SkillAttainmentProgress_AttainmentStatus[keyof typeof SkillAttainmentProgress_AttainmentStatus];
/** Input type for the SkillAttainment_GenerateProgressReport mutation. */
export type SkillAttainment_GenerateProgressReportInput = {
  /** Career Band for the skill attainments to be returned in the report. */
  careerBand: VerifiedSkills_CareerBand;
  /** Occupation Group ID for the skill attainments to be returned in the report. */
  occupationGroupId: Scalars['ID'];
  /** List of program IDs whose enrolled users will be included in the generated progress report. */
  programIds: Array<Scalars['ID']>;
};

/** Result type for the SkillAttainment_GenerateProgressReport mutation. */
export type SkillAttainment_GenerateProgressReportResult = {
  __typename?: 'SkillAttainment_GenerateProgressReportResult';
  /** The run ID for the report generation job triggered. */
  jobRunId: Scalars['ID'];
};

/** Skill Area-level information about user's skill expression attainment */
export type SkillAttainment_SkillAreaAttainment = {
  __typename?: 'SkillAttainment_SkillAreaAttainment';
  /** Flags whether or not all Skill Expressions in the Skill Area have been attained */
  areAllExpressionsAttained: Scalars['Boolean'];
  /** Verified Skills Pathway Skill Area, composed of multiple Skill Expressions */
  skillArea: VerifiedSkills_SkillArea;
  /** List of Skill Expressions in the Skill Area */
  skillExpressionsAttainment?: Maybe<Array<SkillAttainment_SkillExpressionAttainment>>;
};

/** Skill Expression information and user skill expression attainment status */
export type SkillAttainment_SkillExpressionAttainment = {
  __typename?: 'SkillAttainment_SkillExpressionAttainment';
  /** Whether or not a user has attained the skill expression. Partial credit is out of scope for MVP */
  attainmentStatus: SkillAttainmentProgress_AttainmentStatus;
  /** Skill expression the attainment is for */
  skillExpression: VerifiedSkills_SkillExpression;
};

/** Paginated career roles. */
export type SkillCareerRole_PaginatedResult = {
  __typename?: 'SkillCareerRole_PaginatedResult';
  /** A list of career roles. */
  elements: Array<Skill_CareerRole>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Skill Mastery Levels Queries */
export type SkillMasteryLevelsQueries = {
  __typename?: 'SkillMasteryLevelsQueries';
  /** Returns skill mastery levels for a learner. User ID inferred from request context. */
  querySkillsMasteryLevels: SkillMasteryLevels_PaginatedResult;
};


/** Skill Mastery Levels Queries */
export type SkillMasteryLevelsQueriesQuerySkillsMasteryLevelsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
};

/**
 * Mastery level of a skill. More info on the differences between levels can be found here:
 * https://www.figma.com/board/1PGhhkVdMFqgm8NU1XGZFs/Degree-Data-For-Mastery-Verification?node-id=1-162&node-type=frame&t=krBlcqRPJeoGOlTW-0
 */
export const SkillMasteryLevels_MasteryLevel = {
  /** Mastery level 1. */
  MasteryLevel_1: 'MASTERY_LEVEL_1',
  /** Mastery level 2. */
  MasteryLevel_2: 'MASTERY_LEVEL_2',
  /** Mastery level 3. */
  MasteryLevel_3: 'MASTERY_LEVEL_3',
  /** Mastery level 4. */
  MasteryLevel_4: 'MASTERY_LEVEL_4'
} as const;

export type SkillMasteryLevels_MasteryLevel = typeof SkillMasteryLevels_MasteryLevel[keyof typeof SkillMasteryLevels_MasteryLevel];
/** Paginated Skill Mastery Levels. */
export type SkillMasteryLevels_PaginatedResult = {
  __typename?: 'SkillMasteryLevels_PaginatedResult';
  /** A list of Skill mastery levels. */
  elements: Array<SkillMasteryLevels_SkillMasteryLevel>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Skill mastery level object. */
export type SkillMasteryLevels_SkillMasteryLevel = {
  __typename?: 'SkillMasteryLevels_SkillMasteryLevel';
  /** The learner’s mastery level. */
  masteryLevel: SkillMasteryLevels_MasteryLevel;
  /**
   * How far along the user is to mastering the given skill-mastery
   * (from 0 to 1).
   */
  masteryPercent: Scalars['Float'];
  /**
   * Likelihood that the learner will answer the next question pertaining to
   * the given skill-mastery correctly (from 0 to 1).
   */
  nextQuestionCorrectLikelihood: Scalars['Float'];
  /** Skill. */
  skill: Skill_Skill;
  /** The last time this skill mastery level was updated. */
  updatedAt: Scalars['DateTime'];
};

/** Read-only Skill Mastery data queries. */
export type SkillMasteryQueries = {
  __typename?: 'SkillMasteryQueries';
  /**
   * Returns the course items of a course, each paired with the skill
   * expressions tagged on it.
   *
   * Source selection, branch resolution, and filter semantics match
   * `getSkillExpressionCourseItemMappingsByCourseId`. The same per-course
   * top-K cut is applied: only the top `skillExpressionLimit` skill
   * expressions appear anywhere in the response, and items whose
   * expressions all fall below the cut are omitted. Items are emitted in
   * itemId-ascending order. Returns an empty list when the course has no
   * coverage or all rows are filtered out.
   */
  getCourseItemSkillExpressionMappingsByCourseId: Array<SkillMastery_CourseItemSkillExpressions>;
  /**
   * Returns the skill expressions taught by a course, each paired with the
   * course items on which it is tagged.
   *
   * - Source: T&L-curated mappings for VSP courses; ML-derived tagging
   *   otherwise (server-selected).
   * - Branch: `courseBranchId` if provided; otherwise the requester's
   *   enrolled branch, falling back to the course's latest branch.
   * - `filters` are applied per (item, skill expression) tag row before
   *   ranking and only affect ML data; they are ignored on the VSP path.
   * - After filtering, skill expressions are ranked by distinct item count
   *   (descending; tie-broken by id ascending) and capped at
   *   `skillExpressionLimit`. Each result lists its surviving item ids in
   *   ascending order.
   * - Returns an empty list when the course has no coverage or all rows are
   *   filtered out.
   */
  getSkillExpressionCourseItemMappingsByCourseId: Array<SkillMastery_SkillExpressionCourseItems>;
};


/** Read-only Skill Mastery data queries. */
export type SkillMasteryQueriesGetCourseItemSkillExpressionMappingsByCourseIdArgs = {
  courseBranchId?: InputMaybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  filters?: InputMaybe<SkillMastery_TagFilters>;
  skillExpressionLimit?: Scalars['Int'];
};


/** Read-only Skill Mastery data queries. */
export type SkillMasteryQueriesGetSkillExpressionCourseItemMappingsByCourseIdArgs = {
  courseBranchId?: InputMaybe<Scalars['ID']>;
  courseId: Scalars['ID'];
  filters?: InputMaybe<SkillMastery_TagFilters>;
  skillExpressionLimit?: Scalars['Int'];
};

/**
 * The highest Bloom's-taxonomy cognitive level the item requires of the
 * learner with respect to the skill expression.
 */
export const SkillMastery_BloomLevel = {
  /**
   * Break information into parts, compare alternatives, identify
   * relationships, diagnose causes, or distinguish patterns.
   */
  Analyze: 'ANALYZE',
  /**
   * Execute a known method in a familiar context (routine problems or
   * procedural tasks).
   */
  Apply: 'APPLY',
  /**
   * Produce original work by combining ideas into a new solution, design,
   * artifact, or plan.
   */
  Create: 'CREATE',
  /**
   * Judge quality or correctness against criteria; justify decisions,
   * critiques, or recommendations.
   */
  Evaluate: 'EVALUATE',
  /**
   * Recall facts, terms, definitions, or simple statements with no
   * interpretation required.
   */
  Remember: 'REMEMBER',
  /**
   * Explain, summarize, paraphrase, interpret, or recognize conceptual
   * meaning.
   */
  Understand: 'UNDERSTAND'
} as const;

export type SkillMastery_BloomLevel = typeof SkillMastery_BloomLevel[keyof typeof SkillMastery_BloomLevel];
/** A course item and the skill expressions tagged on it in the queried course. */
export type SkillMastery_CourseItemSkillExpressions = {
  __typename?: 'SkillMastery_CourseItemSkillExpressions';
  /** Course item id. */
  itemId: Scalars['ID'];
  /**
   * Skill expressions tagged on this item (curated or ML-derived, per server
   * selection). Non-empty.
   */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
};

/** What the item asks the learner to do, on the ICAP spectrum. */
export const SkillMastery_InteractionMode = {
  /**
   * Producing something: typing answers, writing code, recording video,
   * drawing, designing, building artifacts, or uploading work.
   */
  Constructive: 'CONSTRUCTIVE',
  /**
   * Reading, watching, listening, or clicking "Next" (e.g., lectures,
   * videos, readings, recaps).
   */
  Passive: 'PASSIVE',
  /**
   * Constrained-response interactions: multiple choice, drag-and-drop,
   * matching, selecting from options.
   */
  Selective: 'SELECTIVE'
} as const;

export type SkillMastery_InteractionMode = typeof SkillMastery_InteractionMode[keyof typeof SkillMastery_InteractionMode];
/**
 * Pedagogical relationship between a course item and a skill expression. The
 * three values ingested in v1 are listed in priority order (ASSESS >
 * PRACTICE_APPLY > TEACH_DEVELOP).
 */
export const SkillMastery_SkillContentCategory = {
  /**
   * Summative: the item asks the learner to demonstrate the skill for
   * evaluation, without scaffolding, hints, or immediate feedback.
   */
  Assess: 'ASSESS',
  /**
   * Formative: the item asks the learner to apply the skill with scaffolding,
   * hints, guidance, or immediate feedback.
   */
  PracticeApply: 'PRACTICE_APPLY',
  /**
   * Instructional: the item explicitly teaches how to perform the skill or
   * explains the deeper why behind it (e.g., demonstrations, worked examples,
   * step-by-step directions).
   */
  TeachDevelop: 'TEACH_DEVELOP'
} as const;

export type SkillMastery_SkillContentCategory = typeof SkillMastery_SkillContentCategory[keyof typeof SkillMastery_SkillContentCategory];
/**
 * A skill expression and the course item ids on which it is tagged in the
 * queried course.
 */
export type SkillMastery_SkillExpressionCourseItems = {
  __typename?: 'SkillMastery_SkillExpressionCourseItems';
  /** Course item ids where this skill expression is tagged, ascending. Non-empty. */
  itemIds: Array<Scalars['ID']>;
  /** The skill expression (curated or ML-derived, per server selection). */
  skillExpression: VerifiedSkills_SkillExpression;
};

/**
 * Optional facet filters for Skill Mastery queries (ML data only). Within a
 * facet, values are OR-ed; across facets, conditions are AND-ed. Filters
 * match on individual (item, skill expression) tag rows, so multi-facet AND
 * preserves per-tag correlation. Ignored when curated VSP data is served.
 *
 * The server already enforces `effectivenessLevel >= 2` and a
 * `skillContentCategory` whitelist (ASSESS, PRACTICE_APPLY, TEACH_DEVELOP)
 * at ingestion.
 */
export type SkillMastery_TagFilters = {
  /** Restrict to these Bloom levels. Null/empty means any. */
  bloomLevels?: InputMaybe<Array<SkillMastery_BloomLevel>>;
  /** Restrict to these interaction modes. Null/empty means any. */
  interactionModes?: InputMaybe<Array<SkillMastery_InteractionMode>>;
  /**
   * Tightens the effectiveness floor above the server baseline of 2. Values
   * below the baseline are clamped up.
   */
  minimumEffectivenessLevel?: InputMaybe<Scalars['Int']>;
  /** Restrict to these skill-content categories. Null/empty means any. */
  skillContentCategories?: InputMaybe<Array<SkillMastery_SkillContentCategory>>;
};

/** Queries for Collection Attributes */
export type SkillRestrictedContractTagQueries = {
  __typename?: 'SkillRestrictedContractTagQueries';
  /** Retrieves all skill-restricted Contract Tag names */
  getAllContractTagNames: SkillRestrictedContractTag_ContractTagNamesResult;
  /** Retrieves contract tag and all skill-ids associated with it */
  getContractTagSkillIds: SkillRestrictedContractTag_ContractTagSkillIdsResult;
  /** Retrieves a list of contract tag names with all skill-ids associated with each Contract Tag name */
  multiGetContractTagsWithSkillIds: SkillRestrictedContractTag_ContractTagsWithSkillIdsResult;
};


/** Queries for Collection Attributes */
export type SkillRestrictedContractTagQueriesGetContractTagSkillIdsArgs = {
  contractTagName: Scalars['String'];
};


/** Queries for Collection Attributes */
export type SkillRestrictedContractTagQueriesMultiGetContractTagsWithSkillIdsArgs = {
  contractTagNames: Array<Scalars['String']>;
};

/** AddContractTagSkillIds Mutation Failure response. */
export type SkillRestrictedContractTag_AddContractTagSkillIdsFailure = {
  __typename?: 'SkillRestrictedContractTag_AddContractTagSkillIdsFailure';
  /** List of errors resulting from an attempted mutation. */
  errors: Array<SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError>;
};

/** input for associating skill-ids to/from a contract-tag. */
export type SkillRestrictedContractTag_AddContractTagSkillIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-ids to be associated/dissociated to/from a contract-tag */
  skillIds: Array<Scalars['ID']>;
};

/** AddContractTagSkillIds Mutation result, can either be a success or failure. */
export type SkillRestrictedContractTag_AddContractTagSkillIdsResult = SkillRestrictedContractTag_AddContractTagSkillIdsFailure | SkillRestrictedContractTag_AddContractTagSkillIdsSuccess;

/** AddContractTagSkillIds Mutation Success response. */
export type SkillRestrictedContractTag_AddContractTagSkillIdsSuccess = {
  __typename?: 'SkillRestrictedContractTag_AddContractTagSkillIdsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Contract tag names */
export type SkillRestrictedContractTag_ContractTagNamesResult = {
  __typename?: 'SkillRestrictedContractTag_ContractTagNamesResult';
  /** A list of contract tag names */
  contractTagNames: Array<Scalars['String']>;
};

/**
 * Error returned if an attempt is made to add skill-ids to a contract tag where a
 * previous association already existed.
 */
export type SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError = Error & SkillRestrictedContractTag_MutationError & {
  __typename?: 'SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError';
  /** Error message. */
  message: Scalars['String'];
};

/**
 * Error returned if an attempt is made to remove skill-ids from a contract tag where an association
 * does not previously exist.
 */
export type SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError = Error & SkillRestrictedContractTag_MutationError & {
  __typename?: 'SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError';
  /** Error message. */
  message: Scalars['String'];
};

/** Single contract tag with associated skill-ids */
export type SkillRestrictedContractTag_ContractTagSkillIdsResult = {
  __typename?: 'SkillRestrictedContractTag_ContractTagSkillIdsResult';
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** List of skill-ids associated with the contract tag */
  skills: Array<SkillRestrictedContractTag_SkillAndRelevancy>;
};

/** Result for list of contract tags with associated skill-ids */
export type SkillRestrictedContractTag_ContractTagsWithSkillIdsResult = {
  __typename?: 'SkillRestrictedContractTag_ContractTagsWithSkillIdsResult';
  /** List of contract tag names with all skill-ids associated with each Contract Tag name */
  contractTagsWithSkillIds: Array<SkillRestrictedContractTag_ContractTagSkillIdsResult>;
};

/** input for associating a domain-id and subdomain-id to a contract-tag */
export type SkillRestrictedContractTag_DomainIdAndSubdomainIdsInput = {
  /** Domain ID */
  domainId: Scalars['ID'];
  /** Subdomain ID */
  subdomainIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Base error interface. */
export type SkillRestrictedContractTag_MutationError = {
  /** Error message. */
  message: Scalars['String'];
};

/** RemoveContractTagDomainIdsAndSubdomainIds Mutation Failure response. */
export type SkillRestrictedContractTag_RemoveContractTagDomainIdsFailure = {
  __typename?: 'SkillRestrictedContractTag_RemoveContractTagDomainIdsFailure';
  /** Error message. */
  message: Scalars['String'];
};

/** input for dissociating domain-ids and subdomain-ids from a contract-tag */
export type SkillRestrictedContractTag_RemoveContractTagDomainIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** domain-ids to be dissociated from a contract-tag. All subdomain-ids associated with the domain-id will be dissociated as well. */
  domainIds: Array<Scalars['ID']>;
};

/** RemoveContractTagDomainIdsAndSubdomainIds Mutation result, can either be a success or failure. */
export type SkillRestrictedContractTag_RemoveContractTagDomainIdsResult = SkillRestrictedContractTag_RemoveContractTagDomainIdsFailure | SkillRestrictedContractTag_RemoveContractTagDomainIdsSuccess;

/** RemoveContractTagDomainIdsAndSubdomainIds Mutation Success response. */
export type SkillRestrictedContractTag_RemoveContractTagDomainIdsSuccess = {
  __typename?: 'SkillRestrictedContractTag_RemoveContractTagDomainIdsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** RemoveContractTagSkillIds Mutation Failure response. */
export type SkillRestrictedContractTag_RemoveContractTagSkillIdsFailure = {
  __typename?: 'SkillRestrictedContractTag_RemoveContractTagSkillIdsFailure';
  /** List of errors resulting from an attempted mutation. */
  errors: Array<SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError>;
};

/** input for dissociating skill-ids to/from a contract-tag */
export type SkillRestrictedContractTag_RemoveContractTagSkillIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-ids to be associated/dissociated to/from a contract-tag */
  skillIds: Array<Scalars['ID']>;
};

/** RemoveContractTagSkillIds Mutation result, can either be a success or failure. */
export type SkillRestrictedContractTag_RemoveContractTagSkillIdsResult = SkillRestrictedContractTag_RemoveContractTagSkillIdsFailure | SkillRestrictedContractTag_RemoveContractTagSkillIdsSuccess;

/** RemoveContractTagSkillIds Mutation Success response. */
export type SkillRestrictedContractTag_RemoveContractTagSkillIdsSuccess = {
  __typename?: 'SkillRestrictedContractTag_RemoveContractTagSkillIdsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Skill and Relevancy */
export type SkillRestrictedContractTag_SkillAndRelevancy = {
  __typename?: 'SkillRestrictedContractTag_SkillAndRelevancy';
  /** Skill ID */
  skillId: Scalars['ID'];
  /** Skill Relevancy - currently tagged_assessment_fraction value */
  skillRelevancy: Scalars['Float'];
};

/** UpdateSkillRelevancy Mutation Failure response. */
export type SkillRestrictedContractTag_UpdateSkillRelevancyFailure = {
  __typename?: 'SkillRestrictedContractTag_UpdateSkillRelevancyFailure';
  /** List of errors resulting from an attempted mutation. */
  errors: Array<SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError>;
};

/** input for updating skill relevancy */
export type SkillRestrictedContractTag_UpdateSkillRelevancyInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** skill-id associated with the contract-tag */
  skillId: Scalars['ID'];
  /** new skill relevancy value to update to */
  skillRelevancy: Scalars['Float'];
};

/** UpdateSkillRelevancy Mutation result, can either be a success or failure. */
export type SkillRestrictedContractTag_UpdateSkillRelevancyResult = SkillRestrictedContractTag_UpdateSkillRelevancyFailure | SkillRestrictedContractTag_UpdateSkillRelevancySuccess;

/** UpdateSkillRelevancy Mutation Success response. */
export type SkillRestrictedContractTag_UpdateSkillRelevancySuccess = {
  __typename?: 'SkillRestrictedContractTag_UpdateSkillRelevancySuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** UpsertContractTagDomainIdAndSubdomainIds Mutation Failure response. */
export type SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsFailure = {
  __typename?: 'SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsFailure';
  /** Error message. */
  message: Scalars['String'];
};

/** input for upserting domain-id and subdomain-ids to a contract-tag */
export type SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsInput = {
  /** A contract tag name */
  contractTagName: Scalars['String'];
  /** domain-id and subdomain-ids to be associated/dissociated to/from a contract-tag */
  domainIdAndSubdomainIds: SkillRestrictedContractTag_DomainIdAndSubdomainIdsInput;
};

/** UpsertContractTagDomainIdAndSubdomainIds Mutation result, can either be a success or failure. */
export type SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsResult = SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsFailure | SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsSuccess;

/** UpsertContractTagDomainIdAndSubdomainIds Mutation Success response. */
export type SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsSuccess = {
  __typename?: 'SkillRestrictedContractTag_UpsertContractTagDomainIdAndSubdomainIdsSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** SkillScores Queries. */
export type SkillScoresQueries = {
  __typename?: 'SkillScoresQueries';
  /** A query to retrieve all of a user’s skill scores for a given list of courses. */
  queryByCourseIds: SkillScores_SkillScoresPaginatedResult;
  /**
   * A query to retrieve skill scores percentiles.
   * This query will only return data for a skill score if it is in the top 30 percent for Coursera and/or an occupation.
   * By default this query will retrieve percentile data using Coursera's benchmark. | Maximum page size: 1000
   */
  querySkillScoresPercentiles: SkillScores_SkillScoresPercentilesConnection;
  /** A query to retrieve a UserSkillScore by course item ID (inferring the userId from the request context). */
  userSkillScoreByCourseItemId: Array<SkillScores_UserSkillScore>;
  /** A query to retrieve UserSkillScores by skill IDs, (inferring the userId from the request context). */
  userSkillScoresBySkillIds: Array<SkillScores_UserSkillScore>;
};


/** SkillScores Queries. */
export type SkillScoresQueriesQueryByCourseIdsArgs = {
  courseIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  enableTaxonomy2?: Scalars['Boolean'];
  limit: Scalars['Int'];
};


/** SkillScores Queries. */
export type SkillScoresQueriesQuerySkillScoresPercentilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  occupationId?: InputMaybe<Scalars['String']>;
  skillScores: Array<SkillScores_SkillScore>;
};


/** SkillScores Queries. */
export type SkillScoresQueriesUserSkillScoreByCourseItemIdArgs = {
  courseItemId: Scalars['ID'];
  enableTaxonomy2?: Scalars['Boolean'];
};


/** SkillScores Queries. */
export type SkillScoresQueriesUserSkillScoresBySkillIdsArgs = {
  enableTaxonomy2?: Scalars['Boolean'];
  skillIds: Array<Scalars['ID']>;
};

/** Skill score data. */
export type SkillScores_ContentSkillScore = {
  __typename?: 'SkillScores_ContentSkillScore';
  /** Content ID. */
  contentId: Scalars['ID'];
  /** Type of content. */
  contentType: SkillScores_ContentType;
  /** Skill ID. */
  id: Scalars['ID'];
  /** Raw (unscaled) score. */
  rawSkillScore: Scalars['Float'];
  /** Learner score for this skill, rescaled for readability and rounded from float. */
  scaledSkillScore: Scalars['Int'];
  /** The time that learner got this score. */
  scoredAtTime: Scalars['DateTime'];
  /** Skill level. */
  skillLevel: SkillScores_SkillLevel;
  /** Skill Name. */
  skillName: Scalars['String'];
};

/** An enum representing a content type. */
export const SkillScores_ContentType = {
  /** Course type. */
  Course: 'COURSE'
} as const;

export type SkillScores_ContentType = typeof SkillScores_ContentType[keyof typeof SkillScores_ContentType];
/** An enum representing a skill level. */
export const SkillScores_SkillLevel = {
  /** Skill score from 351-500. */
  Advanced: 'ADVANCED',
  /** Skill score from 51-150. */
  Beginner: 'BEGINNER',
  /** Skill score from 0-50. */
  Conversant: 'CONVERSANT',
  /** Skill score from 151-350. */
  Intermediate: 'INTERMEDIATE'
} as const;

export type SkillScores_SkillLevel = typeof SkillScores_SkillLevel[keyof typeof SkillScores_SkillLevel];
/** Skill Score argument parameter. */
export type SkillScores_SkillScore = {
  /** The score for the skill. */
  score: Scalars['Int'];
  /** Unique ID of the skill. */
  skillId: Scalars['ID'];
};

/** Skill Score Percentile data. */
export type SkillScores_SkillScorePercentile = Node & {
  __typename?: 'SkillScores_SkillScorePercentile';
  /** Skill ID. */
  id: Scalars['ID'];
  /** The percentile for the skill. */
  percentile: Scalars['Int'];
  /** The type of benchmark that was used to determine the percentile. */
  percentileType: SkillScores_SkillScorePercentileType;
};

/** SkillScorePercentile edge as one node within paginated results. */
export type SkillScores_SkillScorePercentileEdge = {
  __typename?: 'SkillScores_SkillScorePercentileEdge';
  /** The pagination cursor for this item. */
  cursor: Scalars['String'];
  /** Skill score percentile. */
  node: SkillScores_SkillScorePercentile;
};

/** Benchmark type for skill score percentile. */
export const SkillScores_SkillScorePercentileType = {
  /** Percentile data with respect to all users on Coursera. */
  CourseraBenchmark: 'COURSERA_BENCHMARK',
  /** Percentile data with respect to all users for an occupation. */
  OccupationBenchmark: 'OCCUPATION_BENCHMARK'
} as const;

export type SkillScores_SkillScorePercentileType = typeof SkillScores_SkillScorePercentileType[keyof typeof SkillScores_SkillScorePercentileType];
/** Pagination for SkillScores results. */
export type SkillScores_SkillScoresPaginatedResult = {
  __typename?: 'SkillScores_SkillScoresPaginatedResult';
  /** A list of skill scores for content. */
  elements: Array<SkillScores_ContentSkillScore>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Connection object representing the SkillScoresPercentiles results. */
export type SkillScores_SkillScoresPercentilesConnection = {
  __typename?: 'SkillScores_SkillScoresPercentilesConnection';
  /** A list of skill scores percentiles. */
  edges: Array<SkillScores_SkillScorePercentileEdge>;
  /** Contains information for paginating the collection. */
  pageInfo: PageInfo;
};

/**
 * Skill scores are a model-based way to simultaneously estimate how proficient a learner is at a skill,
 * and what degree of skill is required to successfully complete an assessment.
 * The ID for a UserSkillScore follows this format: userId~skillName
 */
export type SkillScores_UserSkillScore = {
  __typename?: 'SkillScores_UserSkillScore';
  /** The unique identifier for a UserSkillScore which follows this format: userId~skillName */
  id: Scalars['ID'];
  /** The last time that the assessment was attempted */
  lastAttemptAt: Scalars['DateTime'];
  /** The numerical score that the user got for the particular skill, rounded for readability */
  readableScore?: Maybe<Scalars['Int']>;
  /** The skill that is being scored */
  skill: Skill_Skill;
  /** The user who the score belongs to */
  user: User_User;
};

/** The goal type of a skill set */
export const SkillSetCardsComponentSkillSet_GoalType = {
  /** Signifies a LITERACY goalType */
  Literacy: 'LITERACY',
  /** Signifies a RESKILL goalType */
  Reskill: 'RESKILL',
  /** Signifies a UPSKILL goalType */
  Upskill: 'UPSKILL'
} as const;

export type SkillSetCardsComponentSkillSet_GoalType = typeof SkillSetCardsComponentSkillSet_GoalType[keyof typeof SkillSetCardsComponentSkillSet_GoalType];
/** TODO: Complete this description */
export type SkillSetSummary = {
  __typename?: 'SkillSetSummary';
  /** TODO: Complete this description */
  targetSkillProfileId?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  templateSkillProfileId: Scalars['String'];
  /** TODO: Complete this description */
  title: Scalars['String'];
};

/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueries = {
  __typename?: 'SkillSignalsQueries';
  /**
   * Fetches all Skill Area XP Progress for a learner. User Id is fetched from the
   * request context. Sorted by most recent progress. Eventually Consistent.
   */
  getAllSkillAreaXpProgress: SkillSignals_SkillAreaXpProgressPaginatedResult;
  /**
   * Fetches Skill Signal XP progress by item id. User Id is fetched from the request
   * context.
   */
  getCourseScopedSkillAreaXpProgressByItem: Array<SkillSignals_ItemSpecificCourseScopedSkillAreaXpProgress>;
  /**
   * Fetches global Skill Area XP progress for all skill areas covered by the given
   * course. XP totals reflect the learner's progress across ALL enrolled courses,
   * not just this one. Skill areas returned are still scoped to those tagged within
   * the course. User Id is fetched from the request context. Eventually Consistent.
   */
  getGlobalSkillAreaXpByCourse: SkillSignals_GlobalSkillAreaXpProgressPaginatedResult;
  /**
   * Fetches global Skill Signal XP progress by item id. Returns the XP delta earned
   * from the item alongside the learner's global Skill Area totals (across all
   * enrolled courses). Returns top skill areas by XP delta. User Id is fetched from
   * the request context.
   */
  getLearnerGlobalSkillAreaXpProgressByItem: Array<SkillSignals_ItemSpecificGlobalSkillAreaXpProgress>;
  /** Dynamically calculated XP based on a learner's previous progress and earned XP. User Id is fetched from request context. */
  getPotentialXpForItemByUser: Array<SkillSignals_LearnerSpecificSkillAreaPotentialXp>;
  /**
   * Fetches Skill Area XP progress scoped to the given course. User Id is fetched from
   * the request context. Eventually Consistent.
   */
  getSkillAreasXpByCourse: SkillSignals_CourseSpecificSkillAreaXpProgressPaginatedResult;
  /**
   * Gets Skill Signal delta progress for all items passed in, and total course-scope
   * skill area progress for tagged skill areas. User Id is fetched from the request
   * context. Delta means XP gained per item toward skill areas (incremental
   * contribution), not the learner's total for the course or skill area.
   */
  multigetCourseScopedItemSignalProgress: SkillSignals_CourseScopedItemSignalProgress;
  /**
   * Gets global Skill Signal delta progress for all items passed in, and global
   * skill area XP totals for tagged skill areas. Delta is XP gained per item toward
   * skill areas (incremental contribution). Skill Area totals reflect the learner's
   * progress across ALL enrolled courses. User Id is fetched from the request context.
   */
  multigetItemSignalProgressWithGlobalXp: SkillSignals_GlobalItemSignalProgress;
  /**
   * Fetches the 'tagging' data for items in a course. The XP fetched for the items is
   * static and doesn't change depending on the user.
   */
  multigetPotentialSkillAreaXpByItems: Array<SkillSignals_ItemSkillAreaPotentialXp>;
  /**
   * Fetches learners total XP earned in the passed in courses. This is NOT scoped to
   * Skill Areas and is instead a total sum of the XP that could be earned. User Id is fetched from the request context.
   * Eventually consistent.
   */
  multigetTotalCourseXpProgress: SkillSignals_CourseXpProgressPaginatedResult;
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetAllSkillAreaXpProgressArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetCourseScopedSkillAreaXpProgressByItemArgs = {
  courseBranchId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetGlobalSkillAreaXpByCourseArgs = {
  courseBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetLearnerGlobalSkillAreaXpProgressByItemArgs = {
  courseBranchId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetPotentialXpForItemByUserArgs = {
  courseBranchId: Scalars['ID'];
  itemId: Scalars['ID'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesGetSkillAreasXpByCourseArgs = {
  courseBranchId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesMultigetCourseScopedItemSignalProgressArgs = {
  courseBranchId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesMultigetItemSignalProgressWithGlobalXpArgs = {
  courseBranchId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesMultigetPotentialSkillAreaXpByItemsArgs = {
  courseBranchId: Scalars['ID'];
  itemIds: Array<Scalars['ID']>;
};


/**
 * Queries that return data for Skill Signals. Skill Signal XP marks a learner's progress.
 * When it is maxed out, it signals that a learner is ready to verify their skills. If a
 * learner attains skill verification they automatically get full XP points for the Skill
 * Expression.
 */
export type SkillSignalsQueriesMultigetTotalCourseXpProgressArgs = {
  courseBranchIds: Array<Scalars['ID']>;
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/**
 * Batch response containing per-item delta progress and deduplicated skill area progress.
 * Delta is XP gained per item toward skill areas (incremental contribution);
 * skillAreaProgress is aggregated course-scoped totals per skill area.
 */
export type SkillSignals_CourseScopedItemSignalProgress = {
  __typename?: 'SkillSignals_CourseScopedItemSignalProgress';
  /**
   * Per-item delta progress (incremental XP from each item toward skill areas, not
   * learner totals). Each item references skill area IDs.
   */
  itemProgress: Array<SkillSignals_ItemXpProgress>;
  /** Deduplicated skill area progress for all affected skill areas */
  skillAreaProgress: Array<SkillSignals_CourseSpecificSkillAreaXpProgress>;
};

/** Skill Area Signal Progress scoped to a specific course */
export type SkillSignals_CourseSpecificSkillAreaXpProgress = {
  __typename?: 'SkillSignals_CourseSpecificSkillAreaXpProgress';
  /** Course XP scoped to the Skill Area */
  courseLevelXpProgress: SkillSignals_SkillAreaContributingCourseXpProgress;
  /** Skill Area information with the Skill Area name and id */
  skillArea: VerifiedSkills_UnmamppedSkillArea;
};

/** Paginated results wrapper for SkillSignals_CourseSpecificSkillAreaXpProgress */
export type SkillSignals_CourseSpecificSkillAreaXpProgressPaginatedResult = {
  __typename?: 'SkillSignals_CourseSpecificSkillAreaXpProgressPaginatedResult';
  /** List of course-specific Skill Area XP progress entries */
  elements: Array<SkillSignals_CourseSpecificSkillAreaXpProgress>;
  /** Pagination information */
  pagination: Pagination;
};

/** XP progress scoped to a course */
export type SkillSignals_CourseXpProgress = {
  __typename?: 'SkillSignals_CourseXpProgress';
  /** Course information */
  course: Course_Course;
  /** XP a learner has earned in the given course */
  courseXpGained: Scalars['Int'];
  /** Total amount of XP that a learner could earn towards the course */
  totalPotentialXp: Scalars['Int'];
};

/** Paginated results wrapper for SkillSignals_CourseXpProgress */
export type SkillSignals_CourseXpProgressPaginatedResult = {
  __typename?: 'SkillSignals_CourseXpProgressPaginatedResult';
  /** List of course XP progress entries */
  elements: Array<SkillSignals_CourseXpProgress>;
  /** Pagination information */
  pagination: Pagination;
};

/**
 * Batch response for multigetItemSignalProgressWithGlobalXp.
 * itemProgress carries per-item XP deltas (incremental); skillAreaProgress carries
 * the learner's global totals for all affected skill areas.
 */
export type SkillSignals_GlobalItemSignalProgress = {
  __typename?: 'SkillSignals_GlobalItemSignalProgress';
  /**
   * Per-item delta progress. Each entry references skill area IDs and XP gained
   * from that item (incremental, not cumulative).
   */
  itemProgress: Array<SkillSignals_ItemXpProgress>;
  /**
   * Deduplicated global Skill Area progress for all skill areas touched by the
   * requested items.
   */
  skillAreaProgress: Array<SkillSignals_GlobalSkillAreaXpProgress>;
};

/**
 * Global Skill Area XP progress for a learner, independent of any single course.
 * totalPotentialXP and xpGained reflect the learner's aggregate across all enrolled
 * courses that contain skill areas mapping to this Skill Area's child SEs.
 */
export type SkillSignals_GlobalSkillAreaXpProgress = {
  __typename?: 'SkillSignals_GlobalSkillAreaXpProgress';
  /** Skill Area metadata (name, id, child Skill Expressions) */
  skillArea: VerifiedSkills_UnmamppedSkillArea;
  /** Total XP a learner can earn globally in this SA. 100XP * num child SEs. */
  totalPotentialXP: Scalars['Int'];
  /** Total XP the learner has earned globally across all content for this Skill Area. */
  xpGained: Scalars['Int'];
};

/** Paginated results wrapper for SkillSignals_GlobalSkillAreaXpProgress. */
export type SkillSignals_GlobalSkillAreaXpProgressPaginatedResult = {
  __typename?: 'SkillSignals_GlobalSkillAreaXpProgressPaginatedResult';
  /** List of global Skill Area XP progress entries */
  elements: Array<SkillSignals_GlobalSkillAreaXpProgress>;
  /** Pagination information */
  pagination: Pagination;
};

/** Potential XP an item could contribute to Skill Signal Progress. The XP is static. */
export type SkillSignals_ItemSkillAreaPotentialXp = {
  __typename?: 'SkillSignals_ItemSkillAreaPotentialXp';
  /** itemId */
  itemId: Scalars['ID'];
  /** Skill Area tag information for the item */
  skillAreaTags: Array<SkillSignals_SkillAreaPotentialXp>;
};

/** Skill Area Signal Progress scoped to a specific item */
export type SkillSignals_ItemSpecificCourseScopedSkillAreaXpProgress = {
  __typename?: 'SkillSignals_ItemSpecificCourseScopedSkillAreaXpProgress';
  /**
   * Course-scoped Skill Area specific information with the name, id, and total XP in
   * the SA within the course
   */
  courseScopedskillArea: SkillSignals_CourseSpecificSkillAreaXpProgress;
  /** Item id */
  itemId: Scalars['ID'];
  /**
   * Xp Gained in the given Skill Area from the specified item (the delta). Returns
   * null if the item has not yet been completed.
   */
  xpGainedFromItem?: Maybe<Scalars['Int']>;
};

/**
 * Global Skill Area XP progress scoped to a specific completed item.
 * xpGainedFromItem is the delta from this item; globalSkillArea carries the
 * learner's total XP across all courses for this Skill Area.
 */
export type SkillSignals_ItemSpecificGlobalSkillAreaXpProgress = {
  __typename?: 'SkillSignals_ItemSpecificGlobalSkillAreaXpProgress';
  /** Global Skill Area progress for the Skill Area this item contributes to. */
  globalSkillArea: SkillSignals_GlobalSkillAreaXpProgress;
  /** Item id */
  itemId: Scalars['ID'];
  /**
   * XP gained in the given Skill Area from this specific item (the delta).
   * Null if the item has not yet been completed.
   */
  xpGainedFromItem?: Maybe<Scalars['Int']>;
};

/**
 * XP progress delta for a single item: incremental Skill Signal XP from completing
 * this item toward tagged skill areas, not the learner's total for the course or area.
 */
export type SkillSignals_ItemXpProgress = {
  __typename?: 'SkillSignals_ItemXpProgress';
  /** Item Id */
  itemId: Scalars['ID'];
  /** IDs of skill areas this item contributes to */
  skillAreaIds: Array<Scalars['ID']>;
  /** XP gained from completing this item */
  xpGainedFromItem?: Maybe<Scalars['Int']>;
};

/** A Skill Area with learner-specific XP information. */
export type SkillSignals_LearnerSpecificSkillAreaPotentialXp = {
  __typename?: 'SkillSignals_LearnerSpecificSkillAreaPotentialXp';
  /**
   * Returns the actual Xp a learner earned from this item if already completed. Otherwise it
   * returns null.
   */
  earnedXp?: Maybe<Scalars['Int']>;
  /**
   * The amount of XP that could contribute to the Skill Area based on a learner's previous XP
   * progress. If a learner has already achieved their max XP in a Skill Expression, it will
   * fallback to O.
   */
  potentialXp: Scalars['Int'];
  /** Raw Skill Area core entity */
  skillArea: VerifiedSkills_UnmamppedSkillArea;
};

/** Skill Signal Progress by course */
export type SkillSignals_SkillAreaContributingCourseXpProgress = {
  __typename?: 'SkillSignals_SkillAreaContributingCourseXpProgress';
  /** Course information */
  course: Course_Course;
  /** XP a learner has earned in SA within the given course */
  courseXpGained: Scalars['Int'];
  /**
   * Total amount of XP that a learner could earn towards the Skill Area within the
   * course
   */
  totalPotentialXp: Scalars['Int'];
};

/** A Skill Area tag with the potential XP it could earn */
export type SkillSignals_SkillAreaPotentialXp = {
  __typename?: 'SkillSignals_SkillAreaPotentialXp';
  /** The amount of XP that could contribute to the Skill Area */
  potentialXp: Scalars['Int'];
  /** Raw Skill Area core entity */
  skillArea: VerifiedSkills_UnmamppedSkillArea;
};

/**
 * A skill area XP progress entity stub for federation, owned by the verifiedskills
 * subgraph.
 */
export type SkillSignals_SkillAreaXpProgress = {
  __typename?: 'SkillSignals_SkillAreaXpProgress';
  /** The skill area ID. */
  id: Scalars['ID'];
  /** Existing Core entity that includes Skill Area name, id and child Skill Expressions */
  skillArea: VerifiedSkills_UnmamppedSkillArea;
  /** Total XP a learner can earn in SA. 100XP * num of child skill expressions */
  totalPotentialXP: Scalars['Int'];
  /** Total XP a learner has earned in the Skill Area */
  xpGained: Scalars['Int'];
};

/** Paginated results wrapper for SkillSignals_SkillAreaXpProgress */
export type SkillSignals_SkillAreaXpProgressPaginatedResult = {
  __typename?: 'SkillSignals_SkillAreaXpProgressPaginatedResult';
  /** List of Skill Areas with progress */
  elements: Array<SkillSignals_SkillAreaXpProgress>;
  /** Pagination information */
  pagination: Pagination;
};

/** Connection object representing the SkillTagsByProductId results. */
export type SkillTags_ContentwithTags = {
  __typename?: 'SkillTags_ContentwithTags';
  /**
   * Difficulty level for the skill. This difficulty level is not guaranteed to exist for courses and specializations.
   * Course items will not have difficulty levels
   */
  difficultyLevel?: Maybe<SkillTags_DifficultyLevel>;
  /** A skill taggable product */
  skillTaggableContent: SkillsTags_SkillsTaggableContent;
  /** Sorted list of skill tags that the product is tagged with */
  skillTags: Array<SkillsTags_SkillTag>;
};

/** Level of difficulty for a piece of content (e.g. course or specialization). */
export const SkillTags_DifficultyLevel = {
  /** ADVANCED skill level */
  DifficultyLevelAdvanced: 'DIFFICULTY_LEVEL_ADVANCED',
  /** BEGINNER skill level */
  DifficultyLevelBeginner: 'DIFFICULTY_LEVEL_BEGINNER',
  /** INTERMEDIATE skill level */
  DifficultyLevelIntermediate: 'DIFFICULTY_LEVEL_INTERMEDIATE',
  /** INVALID skill level */
  DifficultyLevelInvalid: 'DIFFICULTY_LEVEL_INVALID'
} as const;

export type SkillTags_DifficultyLevel = typeof SkillTags_DifficultyLevel[keyof typeof SkillTags_DifficultyLevel];
/** Skills taggable s12n info */
export type SkillTags_SkillTaggableSpecialization = {
  __typename?: 'SkillTags_SkillTaggableSpecialization';
  /** S12n ID */
  s12nId: Scalars['ID'];
};

/** Skill_CareerRole stub */
export type Skill_CareerRole = {
  __typename?: 'Skill_CareerRole';
  /** Career outcomes module image. */
  careerOutcomesModuleImage?: Maybe<CareerRole_Image>;
  /** Career outcomes module image for mobile. */
  careerOutcomesModuleImageMobile?: Maybe<CareerRole_Image>;
  /** Long text description of the role. */
  description?: Maybe<Scalars['String']>;
  /** Domain of the role. */
  domain?: Maybe<Domain_Domain>;
  /** Hero image. */
  heroImage?: Maybe<CareerRole_Image>;
  /** Hero image for mobile. */
  heroImageMobile?: Maybe<CareerRole_Image>;
  /** The career role's id */
  id: Scalars['ID'];
  /** The primary color used in hexadecimal format for role images (e.g. #e339c4). */
  imagePrimaryColor?: Maybe<Scalars['String']>;
  /** Whether the role has completed merchandising data and pathways, can be ready for launching RDP. */
  isCompletedRole?: Maybe<Scalars['Boolean']>;
  /** The job posting data based on the role and country. */
  jobPostingData?: Maybe<CareerRole_JobPostingData>;
  /** The merchandising job category of the role. */
  merchandisingJobCategory?: Maybe<CareerRole_MerchandisingJobCategory>;
  /** The merchandising skill names to display. */
  merchandisingSkillNames: Array<Scalars['String']>;
  /** Name of the role. */
  name?: Maybe<Scalars['String']>;
  /** Onboarding role option image. */
  onboardingRoleOptionImage?: Maybe<CareerRole_Image>;
  /** The levels of the pathway specializations under this role. */
  pathwayLevels: Array<CareerRole_PathwayLevel>;
  /** The pathway specializations under this role. */
  pathways?: Maybe<Collection_Collection>;
  /** Role card image. */
  roleCardImage?: Maybe<CareerRole_Image>;
  /** Short text description of the role. */
  shortDescription?: Maybe<Scalars['String']>;
  /** Skills tagged against specialization. */
  skills: Array<Skill_Skill>;
  /** Unique slug for role. */
  slug: Scalars['String'];
};

/** Result of the querySkills query */
export type Skill_PaginatedResult = {
  __typename?: 'Skill_PaginatedResult';
  /** Skills that match the query */
  elements: Array<Skill_Skill>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Query skills request. */
export type Skill_QuerySkillsRequest = {
  /**
   * Filter query by child skill IDs.
   * The query results will include skills with child skill IDs that match any child_skill_ids provided.
   */
  childSkillIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by domain IDs.
   * The query results will include skills with domain IDs that match domain_ids provided.
   */
  domainIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by granularities.
   * The query results will include skills with granularity match any granularities provided.
   */
  granularities?: InputMaybe<Array<Scalars['Int']>>;
  /** If set to true, only skills eligible for scoring will be returned. Defaults to true if is not set. */
  includeOnlyEligibleForScoring?: Scalars['Boolean'];
  /**
   * Filter query by minimum number of recommendations.
   * The query results will include skills with number of recs that's equal to or larger than provided minimum number.
   * Defaults to 0 if not set.
   * 0 means no filtering because number of recs is no less than 0.
   */
  minimumNumberOfRecs?: Scalars['Int'];
  /**
   * Filter query by occupation IDs.
   * The query results will include skills with occupation IDs that match occupation_ids provided.
   */
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Filter query by parent skill IDs.
   * The query results will include skills with parent skill IDs that match any parent_skill_ids provided.
   */
  parentSkillIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter query by the skill names. */
  skillNames?: InputMaybe<Array<Scalars['String']>>;
  /** How to sort the results. If empty or null, sorting by skill ids as default. */
  skillSorts?: InputMaybe<Array<Skill_Sort>>;
};

/** Represents skill metadata and taxonomy. */
export type Skill_Skill = {
  __typename?: 'Skill_Skill';
  /** A list of domains that are associated with the given skill */
  domains: Array<Domain_Domain>;
  /** The unique identifier for a Skill */
  id: Scalars['ID'];
  /** User-friendly skill name. There are no assumptions on format, such as upper/lowercase. */
  skillName: Scalars['String'];
};

/** Acceptable ways to sort skills. */
export const Skill_Sort = {
  /** Sort by enrollment of tagged course in ascending order. */
  CourseEnrollmentAsc: 'COURSE_ENROLLMENT_ASC',
  /** Sort by enrollment of tagged course in descending order. */
  CourseEnrollmentDesc: 'COURSE_ENROLLMENT_DESC',
  /** Sort by number of tagged courses in ascending order. */
  CourseTagsAsc: 'COURSE_TAGS_ASC',
  /** Sort by number of tagged courses in descending order. */
  CourseTagsDesc: 'COURSE_TAGS_DESC',
  /** Sort by full text search score. */
  FullTextSearchScore: 'FULL_TEXT_SEARCH_SCORE',
  /** Sort by skill granularity in ascending order. */
  GranularityAsc: 'GRANULARITY_ASC',
  /** Sort by skill granularity in descending order. */
  GranularityDesc: 'GRANULARITY_DESC',
  /** Sort by skill name in ascending order. */
  LexicographicOrderAsc: 'LEXICOGRAPHIC_ORDER_ASC',
  /** Sort by skill name in descending order. */
  LexicographicOrderDesc: 'LEXICOGRAPHIC_ORDER_DESC'
} as const;

export type Skill_Sort = typeof Skill_Sort[keyof typeof Skill_Sort];
/** The skill progress' level set status */
export const SkillsFocusComponentSkillProgress_LevelSetProgressStatus = {
  /** Signifies a COMPLETED_ALL levelSet */
  CompletedAll: 'COMPLETED_ALL',
  /** Signifies a COMPLETED_ONCE levelSet */
  CompletedOnce: 'COMPLETED_ONCE',
  /** Signifies an IN_PROGRESS levelSet */
  InProgress: 'IN_PROGRESS',
  /** Signifies a NOT_STARTED levelSet */
  NotStarted: 'NOT_STARTED',
  /** Signifies a UNAVAILABLE levelSet */
  Unavailable: 'UNAVAILABLE'
} as const;

export type SkillsFocusComponentSkillProgress_LevelSetProgressStatus = typeof SkillsFocusComponentSkillProgress_LevelSetProgressStatus[keyof typeof SkillsFocusComponentSkillProgress_LevelSetProgressStatus];
/** Skills progress queries definition */
export type SkillsProgressQueries = {
  __typename?: 'SkillsProgressQueries';
  /**
   * A query to retrieve all the skills progress for learner | Maximum page size: 1000
   * @deprecated After the launch of Skills V2, the endpoint can no longer handle the drammatic increase of skills
   */
  queryAllSkillProgress: SkillsProgress_UserProgressConnection;
  /**
   * Returns latest skill scores, also known as skills progress for a
   * learner. Only returns skills that have a skill score greater than 0.
   * User ID inferred from request context. | Maximum page size: 500
   */
  queryLearnersLatestSkillProgress: SkillsProgress_PaginatedResultWithProgressFlag;
  /**
   * Returns latest skill scores, also known as skills progress for a
   * learner by orgSlug. Only returns skills that have a skill score greater than 0.
   * User ID inferred from request context. | Maximum page size: 500
   */
  queryLearnersLatestSkillProgressByOrg: SkillsProgress_PaginatedResultWithProgressFlag;
  /**
   * Returns skill progress for skills in the given org that match the
   * search query, with and without a skill score greater than 0.User ID
   * inferred from request context. | Maximum page size: 500
   */
  queryProgressForTrendingSkillsInOrg: SkillsProgress_PaginatedResult;
  /**
   * Returns skill progress for skills in the given program that match the
   * search query, with and without a skill score greater than 0.User ID
   * inferred from request context. | Maximum page size: 500
   */
  queryProgressForTrendingSkillsInProgram: SkillsProgress_PaginatedResult;
  /**
   * Returns skill progress for skills that are available in the learner's
   * program and match the given skill name search query. User ID inferred
   * from request context. | Maximum page size: 500
   */
  searchForLearnerSkillProgress: SkillsProgress_PaginatedResult;
  /**
   * Returns skill progress for skills that are available in the learner's
   * org and match the given skill name search query. User ID inferred
   * from request context. | Maximum page size: 500
   */
  searchForLearnerSkillProgressByOrg: SkillsProgress_PaginatedResult;
};


/** Skills progress queries definition */
export type SkillsProgressQueriesQueryAllSkillProgressArgs = {
  after?: InputMaybe<Scalars['String']>;
  enableSkillsTaxonomy2Override?: InputMaybe<Scalars['Boolean']>;
  enterpriseProgramId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** Skills progress queries definition */
export type SkillsProgressQueriesQueryLearnersLatestSkillProgressArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeOnlySkillsWithCompletedLevelsets?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
  skillLevelFilter?: InputMaybe<SkillsProgress_SkillLevel>;
  sortOption?: SkillsProgress_SortOption;
  timerangeInDays?: InputMaybe<Scalars['Int']>;
};


/** Skills progress queries definition */
export type SkillsProgressQueriesQueryLearnersLatestSkillProgressByOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeOnlySkillsWithCompletedLevelsets?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
  skillLevelFilter?: InputMaybe<SkillsProgress_SkillLevel>;
  sortOption?: SkillsProgress_SortOption;
  timerangeInDays?: InputMaybe<Scalars['Int']>;
};


/** Skills progress queries definition */
export type SkillsProgressQueriesQueryProgressForTrendingSkillsInOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
};


/** Skills progress queries definition */
export type SkillsProgressQueriesQueryProgressForTrendingSkillsInProgramArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};


/** Skills progress queries definition */
export type SkillsProgressQueriesSearchForLearnerSkillProgressArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeOnlySkillsWithCompletedLevelsets?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
  skillLevelFilter?: InputMaybe<SkillsProgress_SkillLevel>;
  skillNameSearchQuery?: InputMaybe<Scalars['String']>;
  sortOption?: SkillsProgress_SortOption;
  timerangeInDays?: InputMaybe<Scalars['Int']>;
};


/** Skills progress queries definition */
export type SkillsProgressQueriesSearchForLearnerSkillProgressByOrgArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  includeOnlySkillsWithCompletedLevelsets?: Scalars['Boolean'];
  limit?: Scalars['Int'];
  orgSlug: Scalars['String'];
  skillLevelFilter?: InputMaybe<SkillsProgress_SkillLevel>;
  skillNameSearchQuery?: InputMaybe<Scalars['String']>;
  sortOption?: SkillsProgress_SortOption;
  timerangeInDays?: InputMaybe<Scalars['Int']>;
};

/** Skills progress domain standing for id coupled with name */
export type SkillsProgress_Domain = {
  __typename?: 'SkillsProgress_Domain';
  /** Name of the domain that the skill is part of */
  domainName: Scalars['String'];
  /** Unique ID identifier for domain (domainId) */
  id: Scalars['ID'];
};

/** LevelSet progress status for a particular skill */
export const SkillsProgress_LevelSetProgressStatus = {
  /** Signifies a COMPLETED levelSet */
  Completed: 'COMPLETED',
  /** Signifies an IN_PROGRESS levelSet */
  InProgress: 'IN_PROGRESS',
  /** Signifies a NOT_STARTED levelSet */
  NotStarted: 'NOT_STARTED'
} as const;

export type SkillsProgress_LevelSetProgressStatus = typeof SkillsProgress_LevelSetProgressStatus[keyof typeof SkillsProgress_LevelSetProgressStatus];
/** LevelSet status metadata */
export type SkillsProgress_LevelSetStatus = {
  __typename?: 'SkillsProgress_LevelSetStatus';
  /** Number of attempts left for learner */
  attemptsLeft: Scalars['Int'];
  /** Id as a levelSet id (skillId~userId combination) */
  id: Scalars['ID'];
  /** LevelSet progress status of learner */
  progressStatus: SkillsProgress_LevelSetProgressStatus;
};

/** Paginated Skills Progress. */
export type SkillsProgress_PaginatedResult = {
  __typename?: 'SkillsProgress_PaginatedResult';
  /** A list of skills with user's progress. */
  elements: Array<SkillsProgress_SkillProgress>;
  /** Pagination information. */
  pagination: Pagination;
};

/** Paginated Skills Progress with a flag on whether or not the learner has at least one skill score greater than 0 in the current program */
export type SkillsProgress_PaginatedResultWithProgressFlag = {
  __typename?: 'SkillsProgress_PaginatedResultWithProgressFlag';
  /** A list of skills with user's progress. */
  elements: Array<SkillsProgress_SkillProgress>;
  /**
   * A flag for whether a not a learner has any progress in the given
   * program
   */
  hasProgressInProgram: Scalars['Boolean'];
  /** Pagination information. */
  pagination: Pagination;
};

/** Skill metadata */
export type SkillsProgress_Skill = {
  __typename?: 'SkillsProgress_Skill';
  /**
   * Domains that the skill belongs to. The domains should not have to be paginated
   * as the number of domains per skill is typically small (3 as the max number of
   * domains per skill https://tools.coursera.org/mega/query/oT4uQOKpEeyAfgM-ZJ2MBQ@1#table).
   */
  domains: Array<SkillsProgress_Domain>;
  /** Unique id (userId~skillId) */
  id: Scalars['ID'];
  /** Whether the skill is eligible for scoring or not */
  isEligibleForScoring: Scalars['Boolean'];
  /** Name of the skill */
  skillName: Scalars['String'];
};

/** Level for a specified skill */
export const SkillsProgress_SkillLevel = {
  /** ADVANCED skill level */
  Advanced: 'ADVANCED',
  /** BEGINNER skill level */
  Beginner: 'BEGINNER',
  /** CONVERSANT skill level */
  Conversant: 'CONVERSANT',
  /** INTERMEDIATE skill level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type SkillsProgress_SkillLevel = typeof SkillsProgress_SkillLevel[keyof typeof SkillsProgress_SkillLevel];
/** Wrapper for a learner's skill score aka skill progress */
export type SkillsProgress_SkillProgress = {
  __typename?: 'SkillsProgress_SkillProgress';
  /** Unique id for node as userId~skillId */
  id: Scalars['ID'];
  /** LevelSet status for learner. Nullable as not all skills have levelSets */
  levelSetStatus?: Maybe<SkillsProgress_LevelSetStatus>;
  /** Skill learner has made progress in */
  skill: Skill_Skill;
  /** Score (or progress) from 0-500 associated with the skill */
  skillScore: SkillsProgress_SkillScoreV2;
  /** User information */
  user: User_User;
};

/** SkillScore metadata */
export type SkillsProgress_SkillScore = {
  __typename?: 'SkillsProgress_SkillScore';
  /** Unique id (skillId~userId) */
  id: Scalars['ID'];
  /** Skill score */
  score: Scalars['Int'];
  /** The time that the user got the skill score */
  scoredAtTime: Timestamp;
  /** Advancement level for the skill */
  skillLevel: SkillsProgress_SkillLevel;
};

/** SkillScore metadata */
export type SkillsProgress_SkillScoreV2 = {
  __typename?: 'SkillsProgress_SkillScoreV2';
  /** Unique id (skillId~userId) */
  id: Scalars['ID'];
  /** Skill score that is in the range of 0-500 */
  score: Scalars['Int'];
};

/** Whether we should sort ascending or descending */
export const SkillsProgress_SortDirection = {
  /** Sort from low to high */
  Asc: 'ASC',
  /** Sort from high to low */
  Desc: 'DESC'
} as const;

export type SkillsProgress_SortDirection = typeof SkillsProgress_SortDirection[keyof typeof SkillsProgress_SortDirection];
/** The field that we want to sort by */
export const SkillsProgress_SortField = {
  /** Sorts skills based on relevancy from search query */
  Relevancy: 'RELEVANCY',
  /** Sorts skills by when the skill name */
  SkillName: 'SKILL_NAME',
  /** Sorts skills by learner's score */
  SkillScore: 'SKILL_SCORE',
  /** Sorts skills by when the skill score was last updated */
  UpdatedAt: 'UPDATED_AT'
} as const;

export type SkillsProgress_SortField = typeof SkillsProgress_SortField[keyof typeof SkillsProgress_SortField];
/** The order in which skill progress information should be returned. */
export type SkillsProgress_SortOption = {
  /** Whether we should sort ascending or descending */
  direction: SkillsProgress_SortDirection;
  /** The field that we want to sort by */
  field: SkillsProgress_SortField;
};

/** UserProgress data */
export type SkillsProgress_UserProgress = Node & {
  __typename?: 'SkillsProgress_UserProgress';
  /** Unique id for node as userId~skillId */
  id: Scalars['ID'];
  /** LevelSet status for learner. Nullable as not all skills have levelSets */
  levelSetStatus?: Maybe<SkillsProgress_LevelSetStatus>;
  /** Skill metadata for learner progress */
  skill: SkillsProgress_Skill;
  /** Learner skill score */
  skillScore?: Maybe<SkillsProgress_SkillScore>;
};

/** Connection object representing the userProgress results */
export type SkillsProgress_UserProgressConnection = {
  __typename?: 'SkillsProgress_UserProgressConnection';
  /** A list of skills progress for user */
  edges: Array<SkillsProgress_UserProgressEdge>;
  /** Contains information for paginating the collection */
  pageInfo: PageInfo;
};

/** UserProgress edge as one node within paginated results */
export type SkillsProgress_UserProgressEdge = {
  __typename?: 'SkillsProgress_UserProgressEdge';
  /** The pagination cursor for this item */
  cursor: Scalars['String'];
  /** Skills progress for user */
  node: SkillsProgress_UserProgress;
};

/** Skills queries definition */
export type SkillsQueries = {
  __typename?: 'SkillsQueries';
  /** A query to retrieve skills by their IDs */
  multiGetSkillsById: Array<Skill_Skill>;
  /** A query to retrieve skills based on various parameters */
  querySkills: Skill_PaginatedResult;
};


/** Skills queries definition */
export type SkillsQueriesMultiGetSkillsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


/** Skills queries definition */
export type SkillsQueriesQuerySkillsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  request: Skill_QuerySkillsRequest;
};

/** SkillsTagsLabeling Queries */
export type SkillsTagsLabelingQueries = {
  __typename?: 'SkillsTagsLabelingQueries';
  /** Get user submitted Skills Tags by content ID. User ID is retrieved from request context. */
  getByContentId?: Maybe<SkillsTagsLabeling_Response>;
  /** Query clips to tag by domain. */
  queryClipsByDomain?: Maybe<SkillsTagsLabeling_ClipsResponse>;
  /** Query skills suggestions. */
  querySkillsSuggestions?: Maybe<SkillsTagsLabeling_SuggestionsResponse>;
};


/** SkillsTagsLabeling Queries */
export type SkillsTagsLabelingQueriesGetByContentIdArgs = {
  input: SkillsTagsLabeling_ContentId;
};


/** SkillsTagsLabeling Queries */
export type SkillsTagsLabelingQueriesQueryClipsByDomainArgs = {
  domain: Scalars['String'];
};


/** SkillsTagsLabeling Queries */
export type SkillsTagsLabelingQueriesQuerySkillsSuggestionsArgs = {
  includeCoreSkillTaxonomy?: Scalars['Boolean'];
  includeNonCoreSkillTaxonomy?: Scalars['Boolean'];
  maxNumberOfSuggestions?: Scalars['Int'];
  partialSkillName: Scalars['String'];
};

/** Clips metadata. */
export type SkillsTagsLabeling_ClipsMetadata = {
  __typename?: 'SkillsTagsLabeling_ClipsMetadata';
  /** Course item ID associated with a clip. */
  courseItemId: Scalars['ID'];
  /** Slug for the course associated with a clip. */
  courseSlug: Scalars['String'];
};

/** Response object that represents Clips. */
export type SkillsTagsLabeling_ClipsResponse = {
  __typename?: 'SkillsTagsLabeling_ClipsResponse';
  /** List of clips to be tagged. */
  clips: Array<SkillsTagsLabeling_ClipsMetadata>;
};

/** Content ID. */
export type SkillsTagsLabeling_ContentId = {
  /** Course ID. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Course and item ID. */
  courseItemId?: InputMaybe<SkillsTagsLabeling_CourseItemId>;
};

/** Course and Item ID. */
export type SkillsTagsLabeling_CourseItemId = {
  /** Course ID. */
  courseId: Scalars['ID'];
  /** Item ID. */
  itemId: Scalars['ID'];
};

/** Relevancy. */
export const SkillsTagsLabeling_Relevancy = {
  /** Skill is not relevant. */
  No: 'NO',
  /** It is unclear if skill is relevant. */
  Unsure: 'UNSURE',
  /** Skill is relevant. */
  Yes: 'YES'
} as const;

export type SkillsTagsLabeling_Relevancy = typeof SkillsTagsLabeling_Relevancy[keyof typeof SkillsTagsLabeling_Relevancy];
/** Response object that represents SkillsTagsLabeling. */
export type SkillsTagsLabeling_Response = {
  __typename?: 'SkillsTagsLabeling_Response';
  /** Timestamp of initial creation of this SkillsTagsLabeling. */
  createdAt: Scalars['DateTime'];
  /** List of skills and their relevance to the content. */
  skillsRelevancies: Array<SkillsTagsLabeling_SkillRelevancy>;
  /** Timestamp of last update to this SkillsTagsLabeling. */
  updatedAt: Scalars['DateTime'];
};

/** Relevancy of a specific skill. */
export type SkillsTagsLabeling_SkillRelevancy = {
  __typename?: 'SkillsTagsLabeling_SkillRelevancy';
  /** Relevance of skill. */
  relevancy: SkillsTagsLabeling_Relevancy;
  /** Skill ID. */
  skillId: Scalars['ID'];
};

/** Relevancy of a specific skill. */
export type SkillsTagsLabeling_SkillRelevancyInput = {
  /** Relevance of skill. */
  relevancy: SkillsTagsLabeling_Relevancy;
  /** Skill ID. */
  skillId: Scalars['ID'];
};

/** Source for a skill. */
export const SkillsTagsLabeling_SkillSource = {
  /** Core skill. */
  Core: 'CORE',
  /** Lightcast skill. */
  Lightcast: 'LIGHTCAST'
} as const;

export type SkillsTagsLabeling_SkillSource = typeof SkillsTagsLabeling_SkillSource[keyof typeof SkillsTagsLabeling_SkillSource];
/** Suggested Skills metadata. */
export type SkillsTagsLabeling_SuggestedSkills = {
  __typename?: 'SkillsTagsLabeling_SuggestedSkills';
  /** Skill ID. */
  skillId: Scalars['ID'];
  /** Skill Name. */
  skillName: Scalars['String'];
  /** Source for the skill. */
  skillSource: SkillsTagsLabeling_SkillSource;
};

/** Response object that represents Skill Suggestions. */
export type SkillsTagsLabeling_SuggestionsResponse = {
  __typename?: 'SkillsTagsLabeling_SuggestionsResponse';
  /** List of suggested skills based on passed in partial skill name. */
  suggestedSkillNames: Array<SkillsTagsLabeling_SuggestedSkills>;
};

/** Input of the SkillsTagsLabeling_UpdateSkillsTagsLabeling mutation. */
export type SkillsTagsLabeling_UpdateSkillsTagsLabelingInput = {
  /** ID of content being tagged. */
  contentId: SkillsTagsLabeling_ContentId;
  /** List of skills and their relevance to the content. */
  skillsRelevancies: Array<SkillsTagsLabeling_SkillRelevancyInput>;
};

/** Result of the SkillsTagsLabeling_UpdateSkillsTagsLabeling mutation. */
export type SkillsTagsLabeling_UpdateSkillsTagsLabelingResult = {
  __typename?: 'SkillsTagsLabeling_UpdateSkillsTagsLabelingResult';
  /** Timestamp of last update to this SkillsTagsLabeling. */
  updatedAt: Scalars['DateTime'];
};

/** Skills tags queries definition */
export type SkillsTagsQueries = {
  __typename?: 'SkillsTagsQueries';
  /**
   * A query to retrieve products with skills tags
   * The productIds parameter should be formatted like this: productType(in all caps)~productID
   * Example: "COURSE~fxgoIcbTEeqZOA5eKDHL-w"
   */
  multiGetSkillTagsByProductIds: Array<Maybe<SkillTags_ContentwithTags>>;
  /**
   * A query to retrieve a product with skills tags
   * The productId parameter should be formatted like this: productType(in all caps)~productID
   * Example: "COURSE~fxgoIcbTEeqZOA5eKDHL-w"
   */
  querySkillTagsByProductId?: Maybe<SkillTags_ContentwithTags>;
};


/** Skills tags queries definition */
export type SkillsTagsQueriesMultiGetSkillTagsByProductIdsArgs = {
  productIds: Array<Scalars['ID']>;
  sortSkillTagsDirection?: SkillsTags_SortDirection;
};


/** Skills tags queries definition */
export type SkillsTagsQueriesQuerySkillTagsByProductIdArgs = {
  enableEpic?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortSkillTagsDirection?: SkillsTags_SortDirection;
};

/** Skill tag info */
export type SkillsTags_SkillTag = {
  __typename?: 'SkillsTags_SkillTag';
  /** Whether the skill is considered a software tool. */
  isToolSoftware: Scalars['Boolean'];
  /** Skill ID */
  skillId: Scalars['ID'];
  /** Name of skill (e.g "Media Strategy & Planning"). */
  skillName: Scalars['String'];
  /** Skill relevancy to the taggable content */
  taggedAssessmentFraction?: Maybe<Scalars['Float']>;
};

/** Skills taggable course info */
export type SkillsTags_SkillTaggableCourse = {
  __typename?: 'SkillsTags_SkillTaggableCourse';
  /** Course ID */
  courseId: Scalars['ID'];
};

/** Skills taggable course item info */
export type SkillsTags_SkillTaggableCourseItem = {
  __typename?: 'SkillsTags_SkillTaggableCourseItem';
  /** ID of the course the item is in */
  courseId: Scalars['ID'];
  /** ID for the course item */
  itemId: Scalars['ID'];
};

/** Skills taggable degree info */
export type SkillsTags_SkillTaggableDegree = {
  __typename?: 'SkillsTags_SkillTaggableDegree';
  /** Degree ID */
  degreeId: Scalars['ID'];
};

/** One of the possible skill taggable content items */
export type SkillsTags_SkillsTaggableContent = SkillTags_SkillTaggableSpecialization | SkillsTags_SkillTaggableCourse | SkillsTags_SkillTaggableCourseItem | SkillsTags_SkillTaggableDegree;

/** Sorting direction for the SkillTag based on the taggedAssessmentFraction */
export const SkillsTags_SortDirection = {
  /** ASCENDING sorting order */
  Ascending: 'ASCENDING',
  /** DESCENDING sorting order */
  Descending: 'DESCENDING'
} as const;

export type SkillsTags_SortDirection = typeof SkillsTags_SortDirection[keyof typeof SkillsTags_SortDirection];
/** SkillsTracking Queries */
export type SkillsTrackingQueries = {
  __typename?: 'SkillsTrackingQueries';
  /** Query the list of skills tracked by an organization. */
  queryByOrganization?: Maybe<SkillsTracking_TrackedSkillsPaginatedResult>;
  /** Query the list of skills tracked by a program. */
  queryByProgram?: Maybe<SkillsTracking_TrackedSkillsPaginatedResult>;
  /** Query recommended skills to track based on program data */
  queryRecommendedSkillsToTrackByProgram: Array<Skill_Skill>;
};


/** SkillsTracking Queries */
export type SkillsTrackingQueriesQueryByOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  orgId: Scalars['ID'];
};


/** SkillsTracking Queries */
export type SkillsTrackingQueriesQueryByProgramArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};


/** SkillsTracking Queries */
export type SkillsTrackingQueriesQueryRecommendedSkillsToTrackByProgramArgs = {
  programId: Scalars['ID'];
};

/** Input argument of an organization id or program id. */
export type SkillsTracking_OrgOrProgramId = {
  /** Organization id. */
  orgId?: InputMaybe<Scalars['ID']>;
  /** Program id. */
  programId?: InputMaybe<Scalars['ID']>;
};

/** Tracked skill. */
export type SkillsTracking_TrackedSkill = {
  __typename?: 'SkillsTracking_TrackedSkill';
  /** Timestamp of initial creation of this tracked skills list. */
  createdAt: Scalars['DateTime'];
  /** Tracked skill. */
  skill: Skill_Skill;
  /**
   * Tracked skill ID.
   * @deprecated Use skill instead
   */
  skillId: Scalars['ID'];
  /** Timestamp of last update to this tracked skills list. */
  updatedAt: Scalars['DateTime'];
};

/** Response object that represents tracked skills paginated list. */
export type SkillsTracking_TrackedSkillsPaginatedResult = {
  __typename?: 'SkillsTracking_TrackedSkillsPaginatedResult';
  /** Tracked skills. */
  elements: Array<SkillsTracking_TrackedSkill>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Input used to update list of tracked skills. */
export type SkillsTracking_UpdateSkillsTrackingInput = {
  /** ID of org or program that is tracking skills. */
  orgOrProgramId: SkillsTracking_OrgOrProgramId;
  /** List of skills tracked. */
  skillIds: Array<Scalars['ID']>;
};

/** Result of updating skills tracking list. */
export type SkillsTracking_UpdateSkillsTrackingResult = {
  __typename?: 'SkillsTracking_UpdateSkillsTrackingResult';
  /** Timestamp of initial creation of skills tracking list. */
  createdAt: Scalars['DateTime'];
  /** Timestamp of last update to skills tracking list. */
  updatedAt: Scalars['DateTime'];
};

/** Represents an occupation (job or career) */
export type Skills_Occupation = {
  __typename?: 'Skills_Occupation';
  /**
   * Globally unique ID for each occupation.
   * Ex: agriculture-managers
   */
  id: Scalars['ID'];
  /**
   * User-friendly name for occupation.
   * Ex: Agriculture Managers
   */
  name: Scalars['String'];
};

/** All SocialCohort query definitions. */
export type SocialCohortQueries = {
  __typename?: 'SocialCohortQueries';
  /** Get all child cohorts of a given parent cohort. */
  queryChildCohorts: SocialCohort_CohortsPaginatedResult;
  /** Get a cohort by its unique identifier. */
  queryCohortById?: Maybe<SocialCohort_Cohort>;
  /** Get all cohorts that the authenticated user belongs to, with full cohort details. */
  queryCohortsByUserId: SocialCohort_CohortsPaginatedResult;
};


/** All SocialCohort query definitions. */
export type SocialCohortQueriesQueryChildCohortsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
  parentCohortId: Scalars['ID'];
};


/** All SocialCohort query definitions. */
export type SocialCohortQueriesQueryCohortByIdArgs = {
  cohortId: Scalars['ID'];
};


/** All SocialCohort query definitions. */
export type SocialCohortQueriesQueryCohortsByUserIdArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};

/** A social cohort that groups learners together. */
export type SocialCohort_Cohort = {
  __typename?: 'SocialCohort_Cohort';
  /** Unique identifier for the cohort. */
  cohortId: Scalars['ID'];
  /**
   * Number of members in the cohort. This is null when membershipModel is
   * MEMBER_BY_DEFAULT, since membership is implicit and the count is unknown.
   */
  cohortSize?: Maybe<Scalars['Int']>;
  /** Timestamp when the cohort was created (ISO 8601 format). */
  createdAt: Scalars['DateTime'];
  /** Optional description of the cohort. */
  description?: Maybe<Scalars['String']>;
  /**
   * How memberships are modeled for this cohort. Defaults to EXPLICIT_JOIN when
   * not specified at creation time. This is immutable after creation.
   */
  membershipModel: SocialCohort_MembershipModel;
  /** Human-readable name of the cohort. */
  name: Scalars['String'];
  /** ID of the parent cohort, if this is a child cohort. */
  parentCohortId?: Maybe<Scalars['ID']>;
  /** Optional type classification for the cohort. */
  type?: Maybe<Scalars['String']>;
  /** Timestamp when the cohort was last updated (ISO 8601 format). */
  updatedAt: Scalars['DateTime'];
};

/** Paginated list of cohorts. */
export type SocialCohort_CohortsPaginatedResult = {
  __typename?: 'SocialCohort_CohortsPaginatedResult';
  /** List of cohorts in this page. */
  elements: Array<SocialCohort_Cohort>;
  /** Pagination metadata. */
  pagination: Pagination;
};

/** Input for creating a new social cohort. */
export type SocialCohort_CreateCohortInput = {
  /** Optional description of the cohort. */
  description?: InputMaybe<Scalars['String']>;
  /** Client-provided unique identifier for the cohort. */
  id: Scalars['String'];
  /**
   * How memberships should be modeled for this cohort. When omitted, defaults to
   * EXPLICIT_JOIN, meaning learners must explicitly join to become members. This
   * is immutable after creation and cannot be changed via UpdateCohort.
   */
  membershipModel?: SocialCohort_MembershipModel;
  /** Human-readable name of the cohort. */
  name: Scalars['String'];
  /** Optional parent cohort ID to create a child cohort. */
  parentCohortId?: InputMaybe<Scalars['ID']>;
  /** Optional type classification for the cohort. */
  type?: InputMaybe<Scalars['String']>;
};

/** Result type for the CreateCohort mutation. */
export type SocialCohort_CreateCohortResult = SocialCohort_CreateCohortResultError | SocialCohort_CreateCohortResultSuccess;

/** Error result for the CreateCohort mutation. */
export type SocialCohort_CreateCohortResultError = Error & {
  __typename?: 'SocialCohort_CreateCohortResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the CreateCohort mutation. */
export type SocialCohort_CreateCohortResultSuccess = {
  __typename?: 'SocialCohort_CreateCohortResultSuccess';
  /** The newly created cohort. */
  cohort: SocialCohort_Cohort;
};

/** Input for deleting a social cohort. */
export type SocialCohort_DeleteCohortInput = {
  /** ID of the cohort to delete. */
  cohortId: Scalars['ID'];
};

/** Result type for the DeleteCohort mutation. */
export type SocialCohort_DeleteCohortResult = SocialCohort_DeleteCohortResultError | SocialCohort_DeleteCohortResultSuccess;

/** Error result for the DeleteCohort mutation. */
export type SocialCohort_DeleteCohortResultError = Error & {
  __typename?: 'SocialCohort_DeleteCohortResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the DeleteCohort mutation. */
export type SocialCohort_DeleteCohortResultSuccess = {
  __typename?: 'SocialCohort_DeleteCohortResultSuccess';
  /** ID of the deleted cohort. */
  cohortId: Scalars['ID'];
};

/**
 * Determines how memberships are modeled for a cohort. This is set at creation
 * time and is immutable thereafter.
 */
export const SocialCohort_MembershipModel = {
  /**
   * Learners must explicitly join the cohort (e.g. by clicking a join CTA) to
   * become a member. They are not members by default. This is the default when
   * no membership model is specified at creation time.
   */
  ExplicitJoin: 'EXPLICIT_JOIN',
  /**
   * Learners are members of the cohort by default without having to explicitly
   * join, unless they opt out. Because membership is implicit, the size of the
   * cohort (how many users have membership) is unknown, so cohortSize is null.
   */
  MemberByDefault: 'MEMBER_BY_DEFAULT'
} as const;

export type SocialCohort_MembershipModel = typeof SocialCohort_MembershipModel[keyof typeof SocialCohort_MembershipModel];
/** Role of a user within a social cohort. */
export const SocialCohort_MembershipRole = {
  /** Cohort administrator with management permissions. */
  Admin: 'ADMIN',
  /** Regular cohort member. */
  Member: 'MEMBER',
  /** Cohort owner with full control. */
  Owner: 'OWNER'
} as const;

export type SocialCohort_MembershipRole = typeof SocialCohort_MembershipRole[keyof typeof SocialCohort_MembershipRole];
/** Input for registering the authenticated user to a cohort. */
export type SocialCohort_RegisterMembershipInput = {
  /** ID of the cohort to join. */
  cohortId: Scalars['ID'];
  /** Role to assign to the user. */
  role: SocialCohort_MembershipRole;
};

/** Result type for the RegisterMembership mutation. */
export type SocialCohort_RegisterMembershipResult = SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterMembershipResultSuccess;

/** Error result for the RegisterMembership mutation. */
export type SocialCohort_RegisterMembershipResultError = Error & {
  __typename?: 'SocialCohort_RegisterMembershipResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the RegisterMembership mutation. */
export type SocialCohort_RegisterMembershipResultSuccess = {
  __typename?: 'SocialCohort_RegisterMembershipResultSuccess';
  /** The cohort the user was registered to. */
  cohort: SocialCohort_Cohort;
};

/** Input for registering a specific user (by userId) to a cohort. This is an admin endpoint processed asynchronously via SQS. */
export type SocialCohort_RegisterUsersToCohortInput = {
  /** ID of the cohort. */
  cohortId: Scalars['ID'];
  /** Optional description for the registration. */
  description?: InputMaybe<Scalars['String']>;
  /** Role to assign to the user. */
  role: SocialCohort_MembershipRole;
  /** Optional type classification for the registration. */
  type?: InputMaybe<Scalars['String']>;
  /** IDs of the users to register. */
  userIds: Array<Scalars['ID']>;
};

/** Result type for the RegisterUserIdToCohort mutation. */
export type SocialCohort_RegisterUsersToCohortResult = SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RegisterUsersToCohortResultSuccess;

/** Error result for the RegisterUsersToCohort mutation. */
export type SocialCohort_RegisterUsersToCohortResultError = Error & {
  __typename?: 'SocialCohort_RegisterUsersToCohortResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the RegisterUsersToCohort mutation. The registration is accepted for async processing. */
export type SocialCohort_RegisterUsersToCohortResultSuccess = {
  __typename?: 'SocialCohort_RegisterUsersToCohortResultSuccess';
  /** Whether the registration was accepted for processing. */
  accepted: Scalars['Boolean'];
};

/** Input for removing a cohort membership. */
export type SocialCohort_RemoveMembershipInput = {
  /** ID of the cohort. */
  cohortId: Scalars['ID'];
};

/** Result type for the RemoveMembership mutation. */
export type SocialCohort_RemoveMembershipResult = SocialCohort_RemoveMembershipResultError | SocialCohort_RemoveMembershipResultSuccess;

/** Error result for the RemoveMembership mutation. */
export type SocialCohort_RemoveMembershipResultError = Error & {
  __typename?: 'SocialCohort_RemoveMembershipResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the RemoveMembership mutation. */
export type SocialCohort_RemoveMembershipResultSuccess = {
  __typename?: 'SocialCohort_RemoveMembershipResultSuccess';
  /** Whether the membership was successfully removed. */
  success: Scalars['Boolean'];
};

/** Input for updating a social cohort. */
export type SocialCohort_UpdateCohortInput = {
  /** ID of the cohort to update. */
  cohortId: Scalars['ID'];
  /** New description for the cohort. */
  description?: InputMaybe<Scalars['String']>;
  /** New name for the cohort. */
  name?: InputMaybe<Scalars['String']>;
  /** New parent cohort ID. Set to null to make it a root cohort. */
  parentCohortId?: InputMaybe<Scalars['ID']>;
  /** New type classification for the cohort. */
  type?: InputMaybe<Scalars['String']>;
};

/** Result type for the UpdateCohort mutation. */
export type SocialCohort_UpdateCohortResult = SocialCohort_UpdateCohortResultError | SocialCohort_UpdateCohortResultSuccess;

/** Error result for the UpdateCohort mutation. */
export type SocialCohort_UpdateCohortResultError = Error & {
  __typename?: 'SocialCohort_UpdateCohortResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result for the UpdateCohort mutation. */
export type SocialCohort_UpdateCohortResultSuccess = {
  __typename?: 'SocialCohort_UpdateCohortResultSuccess';
  /** The updated cohort. */
  cohort: SocialCohort_Cohort;
};

/** Queries for spark courses. */
export type SparkCourseQueries = {
  __typename?: 'SparkCourseQueries';
  /** Fetch a course using a course id */
  queryById?: Maybe<SparkCourse_Course>;
  /** Fetch multiple courses using a list of course ids */
  queryByIds: Array<SparkCourse_Course>;
  /** Fetch spark courses by sessionID */
  queryBySessionIds: Array<SparkCourse_Course>;
};


/** Queries for spark courses. */
export type SparkCourseQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Queries for spark courses. */
export type SparkCourseQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Queries for spark courses. */
export type SparkCourseQueriesQueryBySessionIdsArgs = {
  sessionIds: Array<Scalars['ID']>;
};

/** Spark Course entity w/ federation */
export type SparkCourse_Course = {
  __typename?: 'SparkCourse_Course';
  /** The type of the spark course. */
  courseType: SparkCourse_CourseType;
  /** The course description. */
  description: Scalars['String'];
  /** The id of the spark course. */
  id: Scalars['ID'];
  /** The instructor ids associated with the course. */
  instructors: Array<Instructor_Instructor>;
  /** The course name. */
  name: Scalars['String'];
  /** The partner ids associated with the course. */
  partners: Array<Partner_Partner>;
  /** The photo URL for the course. */
  photoUrl?: Maybe<Scalars['URL']>;
  /** The primary languages for the course. */
  primaryLanguages: Array<Scalars['String']>;
  /** The course slug. */
  slug: Scalars['String'];
};

/** Spark course types */
export const SparkCourse_CourseType = {
  /** Capstone course */
  V1Capstone: 'V1CAPSTONE',
  /** Normal course */
  V1Session: 'V1SESSION'
} as const;

export type SparkCourse_CourseType = typeof SparkCourse_CourseType[keyof typeof SparkCourse_CourseType];
/** Provides query operations for retrieving specialization membership information. */
export type SpecializationMembershipQueries = {
  __typename?: 'SpecializationMembershipQueries';
  /** This query returns specialization membership associated with a certificate code. */
  membershipByCertificateCode: SpecializationMembership_SpecializationMembership;
  /** This query returns specialization memberships for the current user. */
  memberships: SpecializationMembership_SpecializationMembershipPaginatedResult;
  /** Get the specialization memberships for the logged-in user in specific specializations. */
  userMembershipsByS12nIds: SpecializationMembership_SpecializationMembershipPaginatedResult;
};


/** Provides query operations for retrieving specialization membership information. */
export type SpecializationMembershipQueriesMembershipByCertificateCodeArgs = {
  code: Scalars['String'];
};


/** Provides query operations for retrieving specialization membership information. */
export type SpecializationMembershipQueriesMembershipsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  role?: InputMaybe<SpecializationMembership_Role>;
};


/** Provides query operations for retrieving specialization membership information. */
export type SpecializationMembershipQueriesUserMembershipsByS12nIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  s12nIds: Array<Scalars['ID']>;
};

/** Creates a membership for the logged-in user. */
export type SpecializationMembership_CreateMembershipInput = {
  /** The user's role on the Specialization */
  role: OnDemandSpecializationMembershipRole;
  /** The Specialization ID. */
  s12nId: Scalars['ID'];
  /** Optional boolean to determine whether or not to send welcome email to newly-enrolled user to this s12n */
  skipWelcomeEmail?: Scalars['Boolean'];
};

/** Create result */
export type SpecializationMembership_CreateMembershipResult = SpecializationMembership_SpecializationMembership;

/** Input required to create a S12n Membership */
export type SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nInput = {
  /** The course to enroll in */
  courseToEnrollIn?: InputMaybe<Scalars['ID']>;
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** Create membership for owned s12n result */
export type SpecializationMembership_CreateS12nAndCourseMembershipForOwnedS12nResult = SpecializationMembership_SpecializationMembership;

/** Deletes a membership for the logged-in user. */
export type SpecializationMembership_DeleteMembershipInput = {
  /** The Specialization ID */
  s12nId: Scalars['ID'];
};

/** S12n membership delete empty payload */
export type SpecializationMembership_DeleteMembershipResult = {
  __typename?: 'SpecializationMembership_DeleteMembershipResult';
  /** Dummy boolean for empty result type */
  _?: Maybe<Scalars['Boolean']>;
};

/** Represents the possible roles a user can have in relation to a specialization. */
export const SpecializationMembership_Role = {
  /** User is an instructor for the specialization. */
  Instructor: 'INSTRUCTOR',
  /** User is currently enrolled as a student in the specialization. */
  Learner: 'LEARNER',
  /** User has never been enrolled in the specialization. */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** User was previously enrolled but is no longer enrolled in the specialization. */
  NotEnrolled: 'NOT_ENROLLED',
  /** User has university administrator privileges for the specialization. */
  UniversityAdmin: 'UNIVERSITY_ADMIN'
} as const;

export type SpecializationMembership_Role = typeof SpecializationMembership_Role[keyof typeof SpecializationMembership_Role];
/** Entity for S12nMembership. */
export type SpecializationMembership_SpecializationMembership = {
  __typename?: 'SpecializationMembership_SpecializationMembership';
  /** The timestamp when this membership was created */
  createdAt: Scalars['DateTime'];
  /** The S12nMembership ID */
  id: Scalars['ID'];
  /** The timestamp when this membership was last modified */
  modifiedAt?: Maybe<Scalars['DateTime']>;
  /** The user's role on the Specialization */
  role: SpecializationMembership_Role;
  /** The Specialization in which the user is enrolled */
  s12n: Specialization_Specialization;
  /** The user who is enrolled in the Specialization */
  user: User_User;
};

/** S12n membership with pagination */
export type SpecializationMembership_SpecializationMembershipPaginatedResult = {
  __typename?: 'SpecializationMembership_SpecializationMembershipPaginatedResult';
  /** S12n memberships */
  elements: Array<SpecializationMembership_SpecializationMembership>;
  /** Pagination */
  pagination: Pagination;
};

/** S12n progress queries. */
export type SpecializationProgressQueries = {
  __typename?: 'SpecializationProgressQueries';
  /** This query returns specialization progress. */
  progress: SpecializationProgress_Payload;
};


/** S12n progress queries. */
export type SpecializationProgressQueriesProgressArgs = {
  s12nId: Scalars['ID'];
};

/** Main data for a certificate. */
export type SpecializationProgress_CertificateMetadata = {
  __typename?: 'SpecializationProgress_CertificateMetadata';
  /** Granted at timestamp. */
  grantedAt?: Maybe<Scalars['DateTime']>;
  /** Verify code of the certificate. */
  verifyCode?: Maybe<Scalars['String']>;
};

/** Various fields indicating the progress status of a user in a specialization. */
export type SpecializationProgress_Payload = {
  __typename?: 'SpecializationProgress_Payload';
  /** Certificate metadata for the specialization. */
  certificateMetadata?: Maybe<SpecializationProgress_CertificateMetadata>;
  /** Indicates if all preconditions for the capstone are met, such as completing all non-capstone courses. */
  isEligibleForCapstone: Scalars['Boolean'];
  /**
   * Represents the first incomplete course in the specialization, or the last completed course if all are finished.
   * Intended to replace `lastActiveCourseId` for clearer progress tracking.
   * May later integrate with `s12n-progress-application`.
   *
   * More details: https://docs.google.com/document/d/10S8Xj-rm5HUVhXVm4LvN3INFWIqhEfINNYfiblPjoIQ/edit?tab=t.0
   */
  progressRelevantCourse?: Maybe<Course_Course>;
  /** S12n Id the user is enrolled in, can be any Id in the s12n family, not necessarily the base or latest. */
  s12n: Specialization_Specialization;
};

/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueries = {
  __typename?: 'SpecializationQueries';
  /**
   * Given a course ID, return the latest (most recently launched) Specializations the currently logged-in user is
   * subscribed to that contains the given course.
   *
   * The main use case for this query is to find the Specialization through which a user enrolled in a course. Returns null
   * if the course ID is not valid, or the course does not belong to a Specialization.
   */
  getPrimarySpecializationForCourse?: Maybe<Specialization_Specialization>;
  /** Given an ID of a Specialization, return the Specialization. Returns null if there is no Specialization with that ID. */
  queryById?: Maybe<Specialization_Specialization>;
  /**
   * Given an array of IDs of Specializations, return an array of the corresponding Specializations. The array may contain
   * fewer results than the number of IDs passed in, if a Specialization with the corresponding ID does not exist.
   */
  queryByIds: Array<Specialization_Specialization>;
  /**
   * Given a Specialization (Professional Certificate, etc) slug, return the latest version of the corresponding
   * Specialization. Returns null if there is no Specialization with that slug.
   */
  queryBySlug?: Maybe<Specialization_Specialization>;
  /**
   * Given a list Specialization (Professional Certificate, etc) slugs, return the latest version of the corresponding
   * Specializations. Returns empty list if there is no Specialization with those slugs.
   */
  queryBySlugs: Array<Specialization_Specialization>;
  /**
   * Given an array of Specialization IDs, return the _latest version_ of each Specialization.  The array may contain
   * fewer results than the number of IDs passed in, if a Specialization with the corresponding ID does not exist.
   */
  queryLatestVersionByIds: Array<Specialization_Specialization>;
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesGetPrimarySpecializationForCourseArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesQueryBySlugsArgs = {
  slugs: Array<Scalars['String']>;
};


/** Queries that return Specializations (of all types, including Professional Certificates and the like) */
export type SpecializationQueriesQueryLatestVersionByIdsArgs = {
  ids: Array<Scalars['ID']>;
};

/** Queries for specialization upgrade. */
export type SpecializationUpgradeQueries = {
  __typename?: 'SpecializationUpgradeQueries';
  /** This query returns the eligibility of upgrading user to a newer version of specialization. */
  getAllEligibleS12nUpgradesForUser: Array<SpecializationUpgrade_S12nUpgradeEligibility>;
  /** This query returns the eligibility of upgrading a user and s12n to the newest version. */
  getUpgradeEligibility?: Maybe<SpecializationUpgrade_S12nUpgradeEligibility>;
  /** This query checks if a logged in user's eligibility for upgrading to the target s12n. */
  s12nUpgradeEligibilityToS12nId: SpecializationUpgrade_S12nUpgradeEligibility;
};


/** Queries for specialization upgrade. */
export type SpecializationUpgradeQueriesGetUpgradeEligibilityArgs = {
  s12nId: Scalars['ID'];
};


/** Queries for specialization upgrade. */
export type SpecializationUpgradeQueriesS12nUpgradeEligibilityToS12nIdArgs = {
  s12nId: Scalars['ID'];
};

/** Input for decline upgrade. */
export type SpecializationUpgrade_DeclineUpgradeInput = {
  /** The unique identifier of the new specialization being declined. */
  newS12nId: Scalars['ID'];
  /** The unique identifier of the old specialization the user wants to retain. */
  oldS12nId: Scalars['ID'];
};

/** Result for decline upgrade. */
export type SpecializationUpgrade_DeclineUpgradeResult = {
  __typename?: 'SpecializationUpgrade_DeclineUpgradeResult';
  /** Dummy boolean for empty result type */
  _?: Maybe<Scalars['Boolean']>;
};

/** The source of the upgrade eligibility. */
export const SpecializationUpgrade_OwnershipSource = {
  /** When ownership is through Consumer segment, like CPLUS, CLite, S12nSubscription, BulkPay, etc. */
  Consumer: 'CONSUMER',
  /** When ownership is through an Enterprise program. */
  Enterprise: 'ENTERPRISE'
} as const;

export type SpecializationUpgrade_OwnershipSource = typeof SpecializationUpgrade_OwnershipSource[keyof typeof SpecializationUpgrade_OwnershipSource];
/** Payload for s12n upgrade mutations. */
export type SpecializationUpgrade_Payload = {
  __typename?: 'SpecializationUpgrade_Payload';
  /** The timestamp for when the upgrade was created */
  createdAt: Scalars['DateTime'];
  /** New specialization to upgrade to */
  newS12n: Specialization_Specialization;
  /** Old specialization to upgrade from */
  oldS12n: Specialization_Specialization;
};

/** S12n upgrade eligibility */
export type SpecializationUpgrade_S12nUpgradeEligibility = {
  __typename?: 'SpecializationUpgrade_S12nUpgradeEligibility';
  /** The current S12n that the user enrolled in. Only present when upgradeEligibility is true. */
  currentEnrolledS12nInFamily?: Maybe<Specialization_Specialization>;
  /** The timestamp that the eligibility expires at. Only present when upgradeEligibility is true. */
  eligibilityExpiresAt?: Maybe<Scalars['DateTime']>;
  /**
   * The source of the upgrade eligibility. For example, if the user is
   * enrolled in the s12n through enterprise, then ownershipSource will be enterprise.
   */
  ownershipSource?: Maybe<SpecializationUpgrade_OwnershipSource>;
  /** The target s12n that the user tries to upgrade to. */
  s12n: Specialization_Specialization;
  /** A flag that shows if the user is able to upgrade to the target s12n. */
  upgradeEligibility: Scalars['Boolean'];
};

/** Input for s12n upgrade */
export type SpecializationUpgrade_UpgradeInput = {
  /** The unique identifier of the specialization to upgrade to. */
  s12nId: Scalars['ID'];
};

/** Result for s12n upgrade mutation. */
export type SpecializationUpgrade_UpgradeResult = SpecializationUpgrade_Payload;

/** Price information to display on the catalog and similar pages */
export type Specialization_CatalogPrice = {
  __typename?: 'Specialization_CatalogPrice';
  /** Amount */
  amount: Scalars['Float'];
  /** Country ISO code */
  countryIsoCode: Scalars['String'];
  /** Currency code */
  currencyCode: Scalars['String'];
  /** Currency symbol */
  currencySymbol: Scalars['String'];
  /** Product price ID */
  id: Scalars['ID'];
};

/** Specialization Difficulty Level. */
export const Specialization_DifficultyLevel = {
  /** Advanced Level */
  Advanced: 'ADVANCED',
  /** Beginner Level */
  Beginner: 'BEGINNER',
  /** Intermediate Level */
  Intermediate: 'INTERMEDIATE'
} as const;

export type Specialization_DifficultyLevel = typeof Specialization_DifficultyLevel[keyof typeof Specialization_DifficultyLevel];
/** A domain and optional subdomain, e.g. Data Science > Machine Learning */
export type Specialization_DomainPath = {
  __typename?: 'Specialization_DomainPath';
  /** The top-level domain */
  domain: Domain_Domain;
  /** A subdomain under the top-level domain (optional) */
  subdomain?: Maybe<Domain_Subdomain>;
};

/** Determines what course content is behind a paywall and what is free */
export const Specialization_PremiumExperienceVariant = {
  /** Base variant: everything is free */
  BaseVariant: 'BASE_VARIANT',
  /** Premium (closed) Course variant: all course materials are behind a paywall. This course cannot be audited. */
  PremiumCourse: 'PREMIUM_COURSE',
  /**
   * Premium Grading variant: gradable assessments are behind a paywall, everything else (e.g. video lectures) are free.
   * This course is able to be audited.
   */
  PremiumGrading: 'PREMIUM_GRADING'
} as const;

export type Specialization_PremiumExperienceVariant = typeof Specialization_PremiumExperienceVariant[keyof typeof Specialization_PremiumExperienceVariant];
/** Product Variant. */
export const Specialization_ProductVariant = {
  /** External Certificate */
  ExternalCertificateS12N: 'EXTERNAL_CERTIFICATE_S12N',
  /** Google Certificate */
  GoogleCertificateS12N: 'GOOGLE_CERTIFICATE_S12N',
  /** Normal Specialization */
  NormalS12N: 'NORMAL_S12N',
  /** Professional Certificate */
  ProfessionalCertificateS12N: 'PROFESSIONAL_CERTIFICATE_S12N'
} as const;

export type Specialization_ProductVariant = typeof Specialization_ProductVariant[keyof typeof Specialization_ProductVariant];
/** Specialization program product metadata */
export type Specialization_ProgramProductMetadadata = {
  __typename?: 'Specialization_ProgramProductMetadadata';
  /** The associated session for the specialization */
  associatedSession?: Maybe<Session_Session>;
  /** Is specialization auto enrollment enabled */
  isAutoEnrollmentEnabled: Scalars['Boolean'];
  /** If the specialization is selected for credit */
  isSelectedForCredit: Scalars['Boolean'];
  /** The program that the metadata are associated with */
  programId: Scalars['ID'];
};

/** User ratings for the specialization and "average learning hours" */
export type Specialization_Rating = {
  __typename?: 'Specialization_Rating';
  /** The average ratings for the specialization */
  averageFiveStarRating: Scalars['Float'];
  /** "Average learning hours" estimate */
  avgLearningHoursAdjusted: Scalars['Int'];
  /** The specialization ID */
  id: Scalars['ID'];
  /** The total number of ratings */
  ratingCount: Scalars['Int'];
};

/** Paginated result type for Session_Session in Specialization_Specialization entity */
export type Specialization_SessionPaginatedResult = {
  __typename?: 'Specialization_SessionPaginatedResult';
  /** List of elements in the page */
  elements: Array<Session_Session>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** A skill related to this specialization */
export type Specialization_SkillTagForXdp = {
  __typename?: 'Specialization_SkillTagForXdp';
  /** The specialization ID and the skill ID, in that order, encoded as a JSON array */
  id: Scalars['ID'];
  /** Rnk */
  rnk?: Maybe<Scalars['Int']>;
  /** Skill ID */
  skillId?: Maybe<Scalars['ID']>;
  /** Skill name */
  skillName?: Maybe<Scalars['String']>;
};

/** A reference to the Specialization stub - represents a product of type = Specialization */
export type Specialization_Specialization = {
  __typename?: 'Specialization_Specialization';
  /**
   * If this Specialization is a newer version of a Specialization with more than one version, this will be the _first_
   * version of the Specialization. If there is only one version, or this Specialization is the first version, this field
   * will be identical to its parent.
   */
  baseSpecialization: Specialization_Specialization;
  /** The capstone courses that belong to this Specialization. If there are no capstone courses, returns an empty array. */
  capstoneCourses: Array<Course_Course>;
  /** The URL for the image used on the Specialization card */
  cardImageUrl: Scalars['URL'];
  /** Price information to display on the catalog and similar pages */
  catalogPrice?: Maybe<Specialization_CatalogPrice>;
  /** True if we should display this Specialization with the first two partner logos */
  coBrandingEnabled: Scalars['Boolean'];
  /** The source URLs of company logos for industry sponsors to display for this Specialization */
  companyLogoUrls: Array<Scalars['URL']>;
  /** The number of courses in the Specialization, including the capstone courses, if any */
  courseCount: Scalars['Int'];
  /** The courses that belong to this Specialization (in the proper order). Includes the capstone courses (if any). */
  courses: Array<Course_Course>;
  /** The Specialization description, in CML (Coursera Markup Language), with HTML as well */
  descriptionAsCml: CmlContent;
  /** The Specialization description, in plain text (often contains newline characters) */
  descriptionAsPlainText: Scalars['String'];
  /** The difficulty level of the Specialization */
  difficultyLevel: Specialization_DifficultyLevel;
  /** The enterprise custom sessions associated to the specialization */
  enterpriseCustomSessions?: Maybe<Specialization_SessionPaginatedResult>;
  /** Frequently asked questions (FAQs) to display on the Specialization description page (in addition to the default ones) */
  faqs: Array<Specialization_SpecializationQnA>;
  /**
   * Suggested number of hours per week required to complete the Specialization. Can be null if it should be calculated
   * from the Specialization's individual courses.
   */
  hoursPerWeekOverride?: Maybe<Scalars['Int']>;
  /**
   * A unique ID across all types of Specialization (Specializations, Professional Certificates, Google Certificates,
   * External Certificates)
   */
  id: Scalars['ID'];
  /** True if the launch date is in the past */
  isPublic: Scalars['Boolean'];
  /**
   * True if the Specialization is a real Specialization (as opposed to test). If not real, the Specialization is visible
   * to power users only.
   */
  isReal: Scalars['Boolean'];
  /**
   * Despite the name, this is field contains the first/next non-completed course in the specialization, or last completed
   * course if all courses are completed. The behavior has been changed but we kept the name for backward compatibility.
   * If you are considering using this field, please reach out to the team for more information first as in the long run
   * we would likely want to federate this field to s12n-progress-application.
   * See more info here: https://docs.google.com/document/d/10S8Xj-rm5HUVhXVm4LvN3INFWIqhEfINNYfiblPjoIQ/edit?tab=t.0
   */
  lastActiveCourse: Course_Course;
  /**
   * This will be the _latest_ (most recently launched) version of this Specialization. If there is only one version, or
   * this Specialization is the latest version, this field will be identical to its parent.
   */
  latestSpecialization: Specialization_Specialization;
  /** The date (and time) when the Specialization was launched. Null if the Specialization has not yet been launched. */
  launchedAt?: Maybe<Scalars['DateTime']>;
  /** The learning objectives of this Specialization (max 3), in CML (Coursera Markup Language), with HTML as well */
  learningObjectivesAsCml: Array<CmlContent>;
  /**
   * Typical number of months required to complete the Specialization. Can be null if it should be calculated from the
   * Specialization's individual courses.
   */
  monthsToCompleteOverride?: Maybe<Scalars['Int']>;
  /** The program product metadata for the specialization and given programs. */
  multiProgramProductMetadata: Array<Specialization_ProgramProductMetadadata>;
  /** The Specialization name */
  name: Scalars['String'];
  /**
   * The partners (universities, companies, and other institutions) that created the content for this Specialization
   * (its component courses)
   */
  partners: Array<Partner_Partner>;
  /** Pathway parameters */
  pathwayProperties?: Maybe<Pathways_SpecializationProperties>;
  /** The date an un-launched Specialization is expected to launch */
  plannedLaunchDate?: Maybe<Scalars['DateTime']>;
  /** The date a Specialization is open for pre-enrollment */
  preEnrollmentEnabledAt?: Maybe<Scalars['DateTime']>;
  /** The variant that each course in the Specialization belongs to */
  premiumExperienceVariant?: Maybe<Specialization_PremiumExperienceVariant>;
  /** The primary domain/subdomain path that this Specialization belongs to */
  primaryDomainPath: Specialization_DomainPath;
  /**
   * The type of Specialization this is (Specialization, Professional Certificate, Google Certificate, External
   * Certificate)
   */
  productVariant: Specialization_ProductVariant;
  /** The program product metadata for the specialization and given program. */
  programProductMetadata?: Maybe<Specialization_ProgramProductMetadadata>;
  /** User ratings for the specialization and "average learning hours" */
  rating?: Maybe<Specialization_Rating>;
  /**
   * The recommended background (prerequisite) for a person taking this Specialization, e.g. "at least 2 years of business
   * experience"
   */
  recommendedBackgroundAsCml?: Maybe<CmlContent>;
  /** An optional secondary domain/subdomain path that this Specialization also belongs to */
  secondaryDomainPath?: Maybe<Specialization_DomainPath>;
  /** Sorted list of skills that the specialization is tagged with */
  skillTags: Array<SkillsTags_SkillTag>;
  /** Skills related to this specialization */
  skillTagsForXdp?: Maybe<Array<Specialization_SkillTagForXdp>>;
  /** The Specialization slug, a human-readable identifier, used in URLs (contains only alphanumerics and hyphens) */
  slug: Scalars['String'];
  /** Subheader entry for the specialization */
  subheader?: Maybe<Scalars['String']>;
  /** The Specialization tagline (sometimes called "headline"), if any */
  tagline?: Maybe<Scalars['String']>;
  /** List of degrees that the specialization stacks into */
  targetDegrees?: Maybe<Pathways_TargetDegreeResult>;
  /** Translated name of the specialization */
  translatedName?: Maybe<Scalars['String']>;
  /** The URL path (without protocol and domain name) for this Specialization, e.g. "/professional-certificates/google-ux-design" */
  urlPath: Scalars['String'];
  /**
   * If this is not the first version of this Specialization, this will contain a description of what's new in this
   * version, in CML (Coursera Markup Language), with HTML as well. If this is the first (or only) version, this will be
   * null.
   */
  versionDescriptionAsCml?: Maybe<CmlContent>;
};


/** A reference to the Specialization stub - represents a product of type = Specialization */
export type Specialization_SpecializationEnterpriseCustomSessionsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  programId: Scalars['ID'];
};


/** A reference to the Specialization stub - represents a product of type = Specialization */
export type Specialization_SpecializationMultiProgramProductMetadataArgs = {
  programIds: Array<Scalars['ID']>;
};


/** A reference to the Specialization stub - represents a product of type = Specialization */
export type Specialization_SpecializationProgramProductMetadataArgs = {
  programId: Scalars['ID'];
};


/** A reference to the Specialization stub - represents a product of type = Specialization */
export type Specialization_SpecializationTargetDegreesArgs = {
  paginationRequest?: InputMaybe<PaginationRequest>;
};

/** A question/answer pair, to be used in a list of Frequently Asked Questions (FAQs) */
export type Specialization_SpecializationQnA = {
  __typename?: 'Specialization_SpecializationQnA';
  /** The answer to the question, in CML (Coursera Markup Language), with HTML as well */
  answerAsCml: CmlContent;
  /** A frequently asked question, in CML (Coursera Markup Language), with HTML as well */
  questionAsCml: CmlContent;
};

export type SpecializationsV1 = {
  __typename?: 'SpecializationsV1';
  details: SpecializationsV1_Org_Coursera_Catalog_SparkSpecializationDetails;
  display: Scalars['Boolean'];
  id: Scalars['String'];
  interchangeableCourseIds: Array<Maybe<Scalars['String']>>;
  interchangeableMap: Scalars['JSON'];
  launchDate?: Maybe<Scalars['Float']>;
  logo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  primaryCourseIds: Array<Maybe<Scalars['String']>>;
  shortName: Scalars['String'];
};

export type SpecializationsV1Connection = {
  __typename?: 'SpecializationsV1Connection';
  elements: Array<Maybe<SpecializationsV1>>;
  paging: ResponsePagination;
};

export type SpecializationsV1Resource = {
  __typename?: 'SpecializationsV1Resource';
  get?: Maybe<SpecializationsV1>;
  getAll?: Maybe<SpecializationsV1Connection>;
  multiGet?: Maybe<SpecializationsV1Connection>;
};


export type SpecializationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type SpecializationsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type SpecializationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** Model for spark specialization details */
export type SpecializationsV1_Org_Coursera_Catalog_SparkSpecializationDetails = {
  __typename?: 'SpecializationsV1_org_coursera_catalog_SparkSpecializationDetails';
  auxInfo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  byline?: Maybe<Scalars['String']>;
  certificateLogo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  defaultFaqs?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  description?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  disclaimer?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  faqs?: Maybe<Scalars['String']>;
  featuredIndex?: Maybe<Scalars['Int']>;
  /** Typeref for string that defines the isTranslatable property to true */
  incentives?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  recommendedBackground?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  shortDescription?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  subHead?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  videoKeyframe?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  whatYoullLearn?: Maybe<Scalars['String']>;
};

/** Fetch data for Stackability contents. */
export type StackabilityQueries = {
  __typename?: 'StackabilityQueries';
  /**
   * Returns the first DegreeWithStackableContents ranked by DRE where StackableContents is the content that the degree is upsold from.
   * StackableContents returned is ordered by number of enrollments (high to low).
   * Returns null if the learner is enrolled in any pathway content (we don't suggest any stackable contents to users who are already enrolled in pathway content).
   */
  getSuggestedStackableContentsAndDegree?: Maybe<Stackability_DegreeWithStackableContents>;
  /** Return a list of pathway degrees with customized sorting and filtering rules */
  queryCustomizedPathwayDegrees?: Maybe<Stackability_DegreePaginatedResult>;
  /** Return stackable courses and specializations based on customized sorting and filtering rules. */
  queryCustomizedStackableContent?: Maybe<Stackability_StackableContents>;
  /** Return stackable courses and specializations of target degrees, on customized sorting and filtering rules. */
  queryCustomizedStackableContentByTargetDegrees: Array<Stackability_DegreeWithStackableContents>;
  /**
   * Returns a list of DegreeWithStackableContents, where the StackableContents is the stackably enrolled content that the learner is enrolled in, and that the degree is upsold from.
   * Returned degrees are ordered by DRE and corresponding StackableContents are ordered by the learner's enrollment time.
   */
  queryDegreesWithEnrolledStackableContents?: Maybe<Stackability_DegreeWithStackableContentsPaginatedResult>;
};


/** Fetch data for Stackability contents. */
export type StackabilityQueriesQueryCustomizedPathwayDegreesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filteringRule?: InputMaybe<Stackability_DegreeFilter>;
  limit?: Scalars['Int'];
  sortingRules?: InputMaybe<Array<InputMaybe<Stackability_DegreeSortingRule>>>;
};


/** Fetch data for Stackability contents. */
export type StackabilityQueriesQueryCustomizedStackableContentArgs = {
  filteringRules?: InputMaybe<Array<InputMaybe<Stackability_ContentFilteringRule>>>;
  sortingRules?: InputMaybe<Array<InputMaybe<Stackability_ContentSortingRule>>>;
};


/** Fetch data for Stackability contents. */
export type StackabilityQueriesQueryCustomizedStackableContentByTargetDegreesArgs = {
  degreeIds: Array<Scalars['ID']>;
  filteringRules?: InputMaybe<Array<InputMaybe<Stackability_DegreeWithContentsFilteringRule>>>;
  sortingRules?: InputMaybe<Array<InputMaybe<Stackability_ContentSortingRule>>>;
};


/** Fetch data for Stackability contents. */
export type StackabilityQueriesQueryDegreesWithEnrolledStackableContentsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Filter stackable contents by upsell type and product type. */
export type Stackability_ContentFilter = {
  /** Product type */
  productType: Stackability_ProductType;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** Filtering rules for stackable courses and specializations. */
export const Stackability_ContentFilteringRule = {
  /** Return the stackable contents that the user enrolled to. Only works for logged-in users. */
  UserEnrolled: 'USER_ENROLLED'
} as const;

export type Stackability_ContentFilteringRule = typeof Stackability_ContentFilteringRule[keyof typeof Stackability_ContentFilteringRule];
/** Sorting rules for stackable courses and specializations. */
export const Stackability_ContentSortingRule = {
  /** Sort stackable contents by the specific user's enrollment time. Only works for logged-in users. */
  ByEnrollmentTime: 'BY_ENROLLMENT_TIME',
  /** Sort stackable contents by number of enrollments. */
  ByNumOfEnrollments: 'BY_NUM_OF_ENROLLMENTS'
} as const;

export type Stackability_ContentSortingRule = typeof Stackability_ContentSortingRule[keyof typeof Stackability_ContentSortingRule];
/** Paginated list of courses */
export type Stackability_CoursesPaginatedResult = {
  __typename?: 'Stackability_CoursesPaginatedResult';
  /** List of elements in the page */
  elements: Array<Course_Course>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Parameter for creating an upsell */
export type Stackability_CreateUpsellInput = {
  /** Additional parameters in JSON format */
  paramsJson?: InputMaybe<Scalars['JSON']>;
  /** The id of the product that upsells */
  sourceId: Scalars['ID'];
  /** The type of the product that upsells */
  sourceType: Stackability_ProductType;
  /** The id of the product to upsell to */
  targetId: Scalars['ID'];
  /** The type of the product to upsell to */
  targetType: Stackability_ProductType;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** The result of upsell creation */
export type Stackability_CreateUpsellResult = {
  __typename?: 'Stackability_CreateUpsellResult';
  /** The id of the created upsell */
  id: Scalars['ID'];
};

/** Filter rules for target degrees */
export type Stackability_DegreeFilter = {
  /** If the user has enrolled to the target degree. Only works for logged-in users. */
  hasTargetDegreeMembership: Scalars['Boolean'];
  /** If the user has enrolled to any stackble contents of this degree. Only works for logged-in users. */
  stackableContentMembershipFilters?: InputMaybe<Array<Stackability_ContentFilter>>;
};

/** Paginated list of degrees */
export type Stackability_DegreePaginatedResult = {
  __typename?: 'Stackability_DegreePaginatedResult';
  /** List of elements in the page */
  elements: Array<Degree_Degree>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Sorting rules for pathway degrees. */
export const Stackability_DegreeSortingRule = {
  /** Sort degrees by DRE rankscores. Only works for logged-in users. */
  ByDre: 'BY_DRE'
} as const;

export type Stackability_DegreeSortingRule = typeof Stackability_DegreeSortingRule[keyof typeof Stackability_DegreeSortingRule];
/** Filtering rules for degrees with stackable courses and specializations. */
export const Stackability_DegreeWithContentsFilteringRule = {
  /** For stackable courses, only return standalone ones, i.e. not part of any other stackable content. */
  StandaloneCourses: 'STANDALONE_COURSES',
  /** Return the stackable contents that the user enrolled to. Only works for logged-in users. */
  UserEnrolled: 'USER_ENROLLED'
} as const;

export type Stackability_DegreeWithContentsFilteringRule = typeof Stackability_DegreeWithContentsFilteringRule[keyof typeof Stackability_DegreeWithContentsFilteringRule];
/** Target degree with its stackable contents listed by customized sorting and filtering rules */
export type Stackability_DegreeWithStackableContents = {
  __typename?: 'Stackability_DegreeWithStackableContents';
  /** Upsell target degree */
  degree: Degree_Degree;
  /** Stackable contents */
  stackableContents?: Maybe<Stackability_StackableContents>;
};

/** Paginated list of DegreeWithStackableContents */
export type Stackability_DegreeWithStackableContentsPaginatedResult = {
  __typename?: 'Stackability_DegreeWithStackableContentsPaginatedResult';
  /** List of elements in the page */
  elements: Array<Stackability_DegreeWithStackableContents>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Input for delete property */
export type Stackability_DeletePropertyInput = {
  /** Property name */
  name: Scalars['String'];
  /** The id of the product that has the property */
  productId: Scalars['ID'];
  /** The type of the product */
  productType: Stackability_ProductType;
};

/** Result of deleting an property */
export type Stackability_DeletePropertyResult = {
  __typename?: 'Stackability_DeletePropertyResult';
  /** Whether the delete was successful */
  success: Scalars['Boolean'];
};

/** Input for delete upsell */
export type Stackability_DeleteUpsellInput = {
  /** The id of the upsell to delete */
  id: Scalars['ID'];
};

/** Result of deleting an upsell */
export type Stackability_DeleteUpsellResult = {
  __typename?: 'Stackability_DeleteUpsellResult';
  /** Whether the delete was successful */
  success: Scalars['Boolean'];
};

/** Upsell product type */
export const Stackability_ProductType = {
  /** Any product type. */
  Any: 'ANY',
  /** Course. */
  Course: 'COURSE',
  /** Degree */
  Degree: 'DEGREE',
  /** MasterTrack. */
  Mastertrack: 'MASTERTRACK',
  /** Specialization. */
  Specialization: 'SPECIALIZATION'
} as const;

export type Stackability_ProductType = typeof Stackability_ProductType[keyof typeof Stackability_ProductType];
/** Input for setting a property */
export type Stackability_SetPropertyInput = {
  /** Property name */
  name: Scalars['String'];
  /** The id of the product that has the property */
  productId: Scalars['ID'];
  /** The type of the product */
  productType: Stackability_ProductType;
  /** Property value */
  value: Scalars['String'];
};

/** The result of setting the property */
export type Stackability_SetPropertyResult = {
  __typename?: 'Stackability_SetPropertyResult';
  /** Whether the update was successful */
  success: Scalars['Boolean'];
};

/** Paginated list of specializations */
export type Stackability_SpecializationsPaginatedResult = {
  __typename?: 'Stackability_SpecializationsPaginatedResult';
  /** List of elements in the page */
  elements: Array<Specialization_Specialization>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Stackable courses and specializations */
export type Stackability_StackableContents = {
  __typename?: 'Stackability_StackableContents';
  /** Stackable courses */
  courses?: Maybe<Stackability_UpsellCourses>;
  /** Stackable specializations */
  specializations?: Maybe<Stackability_UpsellSpecializations>;
};

/** Input for updating an upsell */
export type Stackability_UpdateUpsellInput = {
  /** Id of the record to update */
  id: Scalars['ID'];
  /**
   * Additional parameters in JSON format. For now, the following structure is supported for OFFERS_CREDIT upsells:
   * {
   *   credits: {
   *     maximumTransferableCredit: 5
   *   }
   * }
   */
  paramsJson?: InputMaybe<Scalars['JSON']>;
  /** Upsell type */
  upsellType: Stackability_UpsellType;
};

/** The result of updating the upsell */
export type Stackability_UpdateUpsellResult = {
  __typename?: 'Stackability_UpdateUpsellResult';
  /** Update process marks existing upsell as deleted, and creates a new upsell. The return value is the id of the created upsell */
  id: Scalars['ID'];
};

/** Stackable courses */
export type Stackability_UpsellCourses = {
  __typename?: 'Stackability_UpsellCourses';
  /** List of courses with upsell relation type PART_OF */
  partOfCourses?: Maybe<Stackability_CoursesPaginatedResult>;
  /** List of courses with upsell relation type RELATED_TO */
  relatedToCourses?: Maybe<Stackability_CoursesPaginatedResult>;
};


/** Stackable courses */
export type Stackability_UpsellCoursesPartOfCoursesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Stackable courses */
export type Stackability_UpsellCoursesRelatedToCoursesArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Stackable specializations */
export type Stackability_UpsellSpecializations = {
  __typename?: 'Stackability_UpsellSpecializations';
  /** List of specializations with upsell relation type OFFERS_CREDIT */
  offersCreditSpecializations?: Maybe<Stackability_SpecializationsPaginatedResult>;
  /** List of specializations with upsell relation type PART_OF */
  partOfSpecializations?: Maybe<Stackability_SpecializationsPaginatedResult>;
  /** List of specializations with upsell relation type RELATED_TO */
  relatedToSpecializations?: Maybe<Stackability_SpecializationsPaginatedResult>;
};


/** Stackable specializations */
export type Stackability_UpsellSpecializationsOffersCreditSpecializationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Stackable specializations */
export type Stackability_UpsellSpecializationsPartOfSpecializationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** Stackable specializations */
export type Stackability_UpsellSpecializationsRelatedToSpecializationsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};

/** Upsell relation types */
export const Stackability_UpsellType = {
  /** Any types of relations */
  Any: 'ANY',
  /** OFFERS_CREDIT relation */
  OffersCredit: 'OFFERS_CREDIT',
  /** PART_OF relation */
  PartOf: 'PART_OF',
  /** RELATED_TO relation */
  RelatedTo: 'RELATED_TO'
} as const;

export type Stackability_UpsellType = typeof Stackability_UpsellType[keyof typeof Stackability_UpsellType];
/** Queries that return Subdomains */
export type SubdomainQueries = {
  __typename?: 'SubdomainQueries';
  /** Return all Subdomains */
  getAllSubdomains: Array<Domain_Subdomain>;
  /** Given an ID of a Subdomain, return the Subdomain. Returns null if there is no Subdomain with that ID. */
  queryById?: Maybe<Domain_Subdomain>;
  /** Given a list of IDs of Subdomain, return the Subdomains. Returns null if there is no Subdomain with that ID. */
  queryByIds: Array<Domain_Subdomain>;
  /**
   * Given a Subdomain slug, return the corresponding Subdomain
   * Returns null if there is no Domain with that slug
   */
  queryBySlug?: Maybe<Domain_Subdomain>;
};


/** Queries that return Subdomains */
export type SubdomainQueriesQueryByIdArgs = {
  id: Scalars['ID'];
};


/** Queries that return Subdomains */
export type SubdomainQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Queries that return Subdomains */
export type SubdomainQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};

export type SubdomainsV1 = {
  __typename?: 'SubdomainsV1';
  backgroundImageUrl?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  domain?: Maybe<DomainsV1>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  id: Scalars['String'];
  keywords: Array<Maybe<Scalars['String']>>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
};

export type SubdomainsV1Connection = {
  __typename?: 'SubdomainsV1Connection';
  elements: Array<Maybe<SubdomainsV1>>;
  paging: ResponsePagination;
};

export type SubdomainsV1Resource = {
  __typename?: 'SubdomainsV1Resource';
  get?: Maybe<SubdomainsV1>;
  getAll?: Maybe<SubdomainsV1Connection>;
  multiGet?: Maybe<SubdomainsV1Connection>;
  slug?: Maybe<SubdomainsV1Connection>;
};


export type SubdomainsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type SubdomainsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type SubdomainsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type SubdomainsV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type SubdomainsV1Slug = {
  __typename?: 'SubdomainsV1Slug';
  connection?: Maybe<SubdomainsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

/** TODO: Complete this description */
export type Subject = {
  __typename?: 'Subject';
  /** TODO: Complete this description */
  courseCount?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  guidedProjectCount?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  name: Scalars['String'];
  /** TODO: Complete this description */
  productIds: Array<Scalars['String']>;
  /** TODO: Complete this description */
  specializationCount?: Maybe<Scalars['Int']>;
};

export type SubmissionDownloadQueries = {
  __typename?: 'SubmissionDownloadQueries';
  /**
   * Returns information about the submissions which can be downloaded for a particular assignment
   * and group.
   */
  eligibleSubmissions?: Maybe<SubmissionDownload_EligibleSubmissionsResult>;
};


export type SubmissionDownloadQueriesEligibleSubmissionsArgs = {
  groupId: Scalars['ID'];
  includeStaffSubmissions?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
};

export const SubmissionDownload_EligibleSubmissionsErrors = {
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type SubmissionDownload_EligibleSubmissionsErrors = typeof SubmissionDownload_EligibleSubmissionsErrors[keyof typeof SubmissionDownload_EligibleSubmissionsErrors];
export type SubmissionDownload_EligibleSubmissionsFailure = {
  __typename?: 'SubmissionDownload_EligibleSubmissionsFailure';
  error: Array<Maybe<SubmissionDownload_EligibleSubmissionsErrors>>;
};

export type SubmissionDownload_EligibleSubmissionsResult = SubmissionDownload_EligibleSubmissionsFailure | SubmissionDownload_EligibleSubmissionsSuccess;

export type SubmissionDownload_EligibleSubmissionsSuccess = {
  __typename?: 'SubmissionDownload_EligibleSubmissionsSuccess';
  /** Number of files uploaded by submitters to be downloaded */
  fileCount: Scalars['Int'];
  /** Number of Submissions */
  submissionCount: Scalars['Int'];
  /** Number of Submitters */
  submitterCount: Scalars['Int'];
};

export const SubmissionDownload_EnqueueDownloadError = {
  RateLimitExceeded: 'RATE_LIMIT_EXCEEDED'
} as const;

export type SubmissionDownload_EnqueueDownloadError = typeof SubmissionDownload_EnqueueDownloadError[keyof typeof SubmissionDownload_EnqueueDownloadError];
export type SubmissionDownload_EnqueueDownloadFailure = {
  __typename?: 'SubmissionDownload_EnqueueDownloadFailure';
  error: Array<Maybe<SubmissionDownload_EnqueueDownloadError>>;
};

export type SubmissionDownload_EnqueueDownloadInput = {
  groupId: Scalars['ID'];
  /** Whether or not to include staff submitters and submissions in the bundle. */
  includeStaffSubmissions?: InputMaybe<Scalars['Boolean']>;
  itemId: Scalars['ID'];
  /**
   * The URL of the page where the download is initiated from.
   * When an error is encountered, this is used to redirect graders back to where they can retry
   * this operation.
   */
  sourcePageUrl: Scalars['URL'];
};

export type SubmissionDownload_EnqueueDownloadResult = SubmissionDownload_EnqueueDownloadFailure | SubmissionDownload_EnqueueDownloadSuccess;

export type SubmissionDownload_EnqueueDownloadSuccess = {
  __typename?: 'SubmissionDownload_EnqueueDownloadSuccess';
  /** Dummy field since type cannot be empty in GraphQL */
  _: Scalars['Boolean'];
};

/** SubmissionLimitSummary indicates that learner has limited submissions. */
export type SubmissionLimitSummary = {
  __typename?: 'SubmissionLimitSummary';
  /** Total number of allowed submissions for their assignment. */
  allowedSubmissions: Scalars['Int'];
  /**
   * The current attempt status indicating whether they can make submissions or not. They can only make submissions
   * if the attempt is in progress.
   */
  attemptStatus: AttemptStatus;
  /** The remaining remaining submissions before their attempt gets closed/completed. */
  remainingSubmissions: Scalars['Int'];
};

export type SubmissionStateQueries = {
  __typename?: 'SubmissionStateQueries';
  /**
   * This query returns a list of all submissions for a submitter.
   * This is used for the Submission History feature.
   */
  allSubmissions?: Maybe<Submission_AllSubmissionsResult>;
  /** This query returns the feedback for a single question (response) in an assignment submission. */
  getResponseFeedback?: Maybe<Submission_GetResponseFeedbackResult>;
  /** This query returns relevant learner states for a particular assignment. We derive `userId` from request context. */
  queryState?: Maybe<Submission_QueryStateResult>;
};


export type SubmissionStateQueriesAllSubmissionsArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type SubmissionStateQueriesGetResponseFeedbackArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
  response: Submission_QuestionResponseInput;
};


export type SubmissionStateQueriesQueryStateArgs = {
  courseId: Scalars['ID'];
  itemId: Scalars['ID'];
};

/**
 * Currently, this only returns header information used by Submission History.
 * It could be updated in the future to allow expansion into the SubmissionState for each submission.
 */
export type Submission_AllSubmissionsResult = {
  __typename?: 'Submission_AllSubmissionsResult';
  headers: Array<Maybe<Submission_SubmissionHeader>>;
};

/** TODO: Complete this description */
export const Submission_AllowedAction = {
  /** TODO: Complete this description */
  ResumeDraft: 'RESUME_DRAFT',
  /** TODO: Complete this description */
  ReworkSubmission: 'REWORK_SUBMISSION',
  /** TODO: Complete this description */
  StartNewAttempt: 'START_NEW_ATTEMPT'
} as const;

export type Submission_AllowedAction = typeof Submission_AllowedAction[keyof typeof Submission_AllowedAction];
/** Indicates which types of files are allowed to be uploaded for the file upload question */
export const Submission_AllowedFileType = {
  /** All file types are allowed */
  All: 'ALL',
  /** Audio files of certain extensions are allowed */
  Audio: 'AUDIO',
  /** Coding files of certain extensions are allowed */
  Coding: 'CODING',
  /** Image files of certain extensions are allowed */
  Image: 'IMAGE',
  /** Text files of certain extensions are allowed */
  Text: 'TEXT',
  /** Video files of certain extensions are allowed */
  Video: 'VIDEO'
} as const;

export type Submission_AllowedFileType = typeof Submission_AllowedFileType[keyof typeof Submission_AllowedFileType];
/** The assignment being attempted. */
export type Submission_Assignment = {
  __typename?: 'Submission_Assignment';
  /** List of all features used by the assignment */
  assignmentFeatures?: Maybe<Array<Submission_AssignmentFeature>>;
  /** Determines whether the assignment is graded or ungraded. */
  assignmentGradingType: Submission_AssignmentGradingType;
  /** Assignment Type */
  assignmentType: Submission_AssignmentType;
  /** Determines which grade to use as a learner's final grade if multiple grading attempts have been made */
  gradeSelectionStrategy?: Maybe<Submission_GradeSelectionStrategy>;
  /** Latest assignment id including the version */
  id: Scalars['ID'];
  /**
   * Learner feedback visibility
   * Information on the values: https://www.coursera.support/s/article/360024748191-Add-Staff-Graded-Assignments-and-Adjust-Assignment-Settings#feedback_type
   */
  learnerFeedbackVisibility?: Maybe<Submission_LearnerFeedbackVisibility>;
  /** Percentage grade needed to pass an assignment */
  passingFraction?: Maybe<Scalars['Float']>;
  /** List of required features that a mobile app version must support in order to render the assignment. */
  requiredMobileFeatures?: Maybe<Array<Submission_RequiredMobileFeature>>;
  /** The assignment ID without the version */
  unversionedId: Scalars['ID'];
  /** The version of the assignment */
  version: Scalars['Int'];
};

/** Assignment features that may potentially be unsupported by certain mobile app versions. */
export const Submission_AssignmentFeature = {
  /** Populated when StaffGradedAssignment.submissionSchema has AI graded questions */
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts has AI graded rubrics */
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts is not empty */
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  /** Populated when ProctorConfig.attemptDuration is not empty */
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  /** Represent values from StaffGradedAssignmentConfiguration.showGradeOnGradeRelease. */
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  /**
   * Populated when StaffGradedAssignment
   * staffGradedAssignmentConfiguration.visibilityForSubmittingLearner.postsubmitPhase.ResponseVisibility
   * is set to RESPONSE_VISIBILITY_RESPONSE_HIDDEN
   */
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  /** Populated when StaffGradedAssignment.evaluationSchema.parts has human graded rubrics */
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  /** Populated when ProctorConfig.maxAttempts is greater than zero */
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  /** Populated when ProctorConfig.maxSubmissionsPerAttempt is greater than zero */
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  /** Populated when StaffGradedAssignment.submissionSchema has human graded questions */
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  /** Populated when LearnerSubmission.parts includes at least one MultipleFillableBlanksQuestion */
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  /** Populated when ProctorConfig.maxSubmissionsPerAttempt is greater than 1 or is empty(unlimited) */
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  /** Populated when the assignment is proctored by an external service like Honorlock. */
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  /** Shows grade to learner after grade release */
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  /** Take the highest grade when reattempting */
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  /** Represent values from StaffGradedAssignmentConfiguration.gradeSelectionStrategy. */
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  /** Represents a value from StaffGradedAssignment.submissionEnabled */
  Teamwork: 'TEAMWORK',
  /**
   * This is a subtype of assignment parts (submission part, feedback part, etc) that is not
   * supported in all platforms yet
   */
  TextBlocks: 'TEXT_BLOCKS',
  /** This assignment is a verified skills assessment */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** This assignment is a verified skills diagnostic */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC',
  /** Populated when LearnerSubmission.parts includes at least one WidgetQuestion */
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Submission_AssignmentFeature = typeof Submission_AssignmentFeature[keyof typeof Submission_AssignmentFeature];
/** Determines whether the assignment is graded or ungraded */
export const Submission_AssignmentGradingType = {
  /** Indicates this is a graded assignment, as such it is included in the grading formula */
  Graded: 'GRADED',
  /** Indicates this is an ungraded (practice) assignment, as such it is not included in the grading formula */
  Ungraded: 'UNGRADED'
} as const;

export type Submission_AssignmentGradingType = typeof Submission_AssignmentGradingType[keyof typeof Submission_AssignmentGradingType];
/** Outcome of the assignment across all attempts */
export type Submission_AssignmentOutcome = {
  __typename?: 'Submission_AssignmentOutcome';
  /** Grade represented in the percentage format */
  earnedGrade: Scalars['Float'];
  /** Represents if the earnedGrade has an override from original */
  gradeOverride?: Maybe<Submission_GradeOverride>;
  /** If the learner passed the assignment */
  isPassed: Scalars['Boolean'];
  /** Decimal between 0 and 1 to represent late deduction */
  latePenaltyRatio?: Maybe<Scalars['Float']>;
};

/** What type of assignment this is */
export const Submission_AssignmentType = {
  /** A standard assignment. */
  Standard: 'STANDARD',
  /** This assessment is used for assessing verified skill attainment. */
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  /** This assessment is used for diagnosing skills. */
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC'
} as const;

export type Submission_AssignmentType = typeof Submission_AssignmentType[keyof typeof Submission_AssignmentType];
/** Assignment attempt, which could contain multiple submissions */
export type Submission_Attempts = {
  __typename?: 'Submission_Attempts';
  /** Unlimited if empty */
  attemptsAllowed?: Maybe<Scalars['Int']>;
  /** Number of previous attempts made */
  attemptsMade: Scalars['Int'];
  /** Unlimited if empty */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  /**
   * Proctor configuration id associated with the latest assignment version. It is required for assignments created
   * since 2021, but we still have a few old assignments that doesn't include a proctor configuration id.
   */
  id?: Maybe<Scalars['ID']>;
  /** Current, ongoing attempt */
  inProgressAttempt?: Maybe<Submission_InProgressAttempt>;
  /** If non-empty, provides information on the most recent submission */
  lastSubmission?: Maybe<Submission_LastSubmission>;
  /** If non-empty, provides information on the next attempt's configuration */
  nextAttempt?: Maybe<Submission_NextAttempt>;
  /** If non-empty, provides information on how many attempts can be made in a given time interval */
  rateLimiterConfig?: Maybe<Submission_RateLimiterConfig>;
};

/** Auto-graded feedback */
export type Submission_AutoGradedFeedback = {
  __typename?: 'Submission_AutoGradedFeedback';
  /** Overall correctness */
  correctness: Submission_AutoGradedQuestionCorrectness;
  /** Text feedback */
  feedback?: Maybe<Submission_RichText>;
  /** Question outcome */
  outcome: Submission_QuestionOutcome;
};

/**
 * Correctness of a question response. Currently a partially correctly answered question is marked as incorrectly
 * answered. In the future, we can improve the user experience by adding a "Partially Correct" status.
 */
export const Submission_AutoGradedQuestionCorrectness = {
  /** The question is correctly answered. A full score should be awarded. */
  Correct: 'CORRECT',
  /** The question is not correctly answered. A partial score or no score should be awarded. */
  Incorrect: 'INCORRECT'
} as const;

export type Submission_AutoGradedQuestionCorrectness = typeof Submission_AutoGradedQuestionCorrectness[keyof typeof Submission_AutoGradedQuestionCorrectness];
/** A BoxViewAnnotation rubric includes an third-party (Box) view of an annotated file with inline grader comments. */
export type Submission_BoxViewDocumentAnnotationRubricFeedback = {
  __typename?: 'Submission_BoxViewDocumentAnnotationRubricFeedback';
  /** Id of the file */
  fileId: Scalars['ID'];
  /** Id of the rubric */
  id: Scalars['ID'];
  /** Prompt of the rubric */
  prompt: Submission_RichText;
  /**
   * Id required by `onDemandBoxViewAnnotationSessions.v1` in order to create a viewing session. We should
   * consider deprecating this and simplify to just using `fileId`.
   */
  reviewResponseId: Scalars['ID'];
};

/** Describes a checkbox question with multiple correct answers. */
export type Submission_CheckboxQuestion = {
  __typename?: 'Submission_CheckboxQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_MultipleChoiceSchema;
  /** Response to the question */
  response: Submission_CheckboxQuestionResponse;
};

/** Response to a checkbox question */
export type Submission_CheckboxQuestionResponse = {
  __typename?: 'Submission_CheckboxQuestionResponse';
  /** Id of the chosen options, could be an empty list if the submitter didn't select any */
  chosen: Array<Scalars['ID']>;
};

/** Response to a checkbox question */
export type Submission_CheckboxQuestionResponseInput = {
  /** Id of the chosen options, could be an empty list if the submitter didn't select any */
  chosen: Array<Scalars['ID']>;
};

/** Describes a checkbox question. Full score is awarded when any option is selected. */
export type Submission_CheckboxReflectQuestion = {
  __typename?: 'Submission_CheckboxReflectQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_MultipleChoiceSchema;
  /** Response to the question */
  response: Submission_CheckboxQuestionResponse;
};

/** Code in a string format */
export type Submission_Code = {
  __typename?: 'Submission_Code';
  /** Code string */
  code: Scalars['String'];
};

/** Describes a text exact match question. Question input requires code. */
export type Submission_CodeExpressionQuestion = {
  __typename?: 'Submission_CodeExpressionQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_CodeExpressionQuestionSchema;
  /** Response to the question */
  response: Submission_CodeExpressionQuestionResponse;
};

/** Response to a code expression question */
export type Submission_CodeExpressionQuestionResponse = {
  __typename?: 'Submission_CodeExpressionQuestionResponse';
  /** Submitter's code submission */
  answer: Submission_Code;
};

/** Response to a code expression question */
export type Submission_CodeExpressionQuestionResponseInput = {
  /** Submitter's code submission */
  answer: Submission_CodeInput;
};

/** Code Expression question schema */
export type Submission_CodeExpressionQuestionSchema = {
  __typename?: 'Submission_CodeExpressionQuestionSchema';
  /** Language type used in the question */
  codeLanguage: Scalars['String'];
  /** Prompt of the question */
  prompt: Submission_RichText;
  /** Evaluator id to use for running code snippets */
  replEvaluatorId: Scalars['ID'];
  /** Starter code to initialize the question with */
  starterCode?: Maybe<Submission_Code>;
};

/** Code in a string format */
export type Submission_CodeInput = {
  /** Code string */
  code: Scalars['String'];
};

/** A correct answer to a text exact match question or a math question */
export type Submission_CorrectAnswer = {
  __typename?: 'Submission_CorrectAnswer';
  /** Answer string */
  answer: Scalars['String'];
  /** Feedback related to the answer */
  feedback: Submission_RichText;
  /** Option id */
  id: Scalars['ID'];
};

/** Failure result type for the mutation Submission_CreateBoxSessionForViewing */
export type Submission_CreateBoxSessionForViewFailure = {
  __typename?: 'Submission_CreateBoxSessionForViewFailure';
  /** Errors list */
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Input for creating a box session for viewing inline feedback responses */
export type Submission_CreateBoxSessionForViewInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID */
  itemId: Scalars['ID'];
  /**
   * Review Response ID for the question feedback to be viewed
   * Ex: 'reviewResponseId~6f56744c-0788-4ade-867d-d09af89d7a67'
   */
  responseId: Scalars['ID'];
  /** Submission ID */
  submissionId: Scalars['ID'];
};

/** Result type for the mutation Submission_CreateBoxSessionForViewing */
export type Submission_CreateBoxSessionForViewResult = Submission_CreateBoxSessionForViewFailure | Submission_CreateBoxSessionForViewSuccess;

/** Success result type for the mutation Submission_CreateBoxSessionForViewing */
export type Submission_CreateBoxSessionForViewSuccess = {
  __typename?: 'Submission_CreateBoxSessionForViewSuccess';
  /** Box Widget Session */
  session: Box_WidgetSession;
};

/** Submission_CreateHonorlockSessionFailure */
export type Submission_CreateHonorlockSessionFailure = {
  __typename?: 'Submission_CreateHonorlockSessionFailure';
  /** Errors */
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Creates a proctored session for an assignment with Honorlock. */
export type Submission_CreateHonorlockSessionInput = {
  /** The CourseId of the assignment being submitted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being submitted */
  itemId: Scalars['ID'];
};

/** Submission_CreateHonorlockSessionResult */
export type Submission_CreateHonorlockSessionResult = Submission_CreateHonorlockSessionFailure | Submission_CreateHonorlockSessionSuccess;

/**
 * All of these fields are obtained from the Honorlock API and are being passed through
 * for the frontend chrome extension to use. We are treating these values opaquely.
 */
export type Submission_CreateHonorlockSessionSuccess = {
  __typename?: 'Submission_CreateHonorlockSessionSuccess';
  /** Attempt ID */
  attemptId: Scalars['ID'];
  /** Configurations */
  configurations: Scalars['String'];
  /** Using String instead of URL to avoid validating data which we are neither producing nor consuming. */
  honorlockCameraUrl: Scalars['String'];
  /** Honorlock Exam ID */
  honorlockExamId: Scalars['ID'];
  /** Honorlock Session ID */
  honorlockSessionId: Scalars['ID'];
  /** Submitter Email */
  submitterEmail: Scalars['String'];
  /** Submitter FullName */
  submitterFullName: Scalars['String'];
  /** Submitter ID */
  submitterId: Scalars['ID'];
};

/** Inputs for deleting the latest attempt of a learner */
export type Submission_DeleteAllAttemptsInput = {
  /** The CourseId */
  courseId: Scalars['ID'];
  /** The ItemId */
  itemId: Scalars['ID'];
  /** The UserId */
  userId: Scalars['Int'];
};

/** Result for deleting the latest attempt of a learner */
export type Submission_DeleteAllAttemptsResult = {
  __typename?: 'Submission_DeleteAllAttemptsResult';
  /** Dummy field since type cannot be empty in GraphQL */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * Internal ErrorDetails interface that is backwards compatible with
 * the version before [this change](https://github.com/webedx-spark/service-definitions/commit/1bfc63d004cf989002cd3469108d06df86645dc2).
 */
export type Submission_ErrorDetailsWithErrorCode = {
  /** Error code for backwards compatibility */
  errorCode: Scalars['String'];
  /** Error message */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion to address the error */
  suggestion?: Maybe<Scalars['String']>;
};

/**
 * Feedback to a submission after it's ready and made visible either automatically or manually.
 *
 * There are three levels of feedback settings:
 * "Limited Feedback": We will not return any feedback data at all.
 * "Partial Feedback": Some fields will be hidden.
 * "Full Feedback": All available fields should be returned.
 *
 * The exact feedback settings isn't exposed to learners. The client should request all fields and render the view based
 * off of returned data.
 */
export type Submission_Feedback = {
  __typename?: 'Submission_Feedback';
  /** List of all features used by the assignment */
  assignmentFeatures?: Maybe<Array<Submission_AssignmentFeature>>;
  /**
   * Assignment level rubrics aren't attached to any parts of the submission. They are supposed to be evaluating the
   * overall quality of the submission.
   */
  assignmentLevelRubrics?: Maybe<Array<Submission_RubricFeedback>>;
  /** Id of feedback */
  id: Scalars['ID'];
  /** Instructions for the assignment */
  instructions?: Maybe<Submission_Instructions>;
  /** Overall outcome of the submission that this feedback is for */
  outcome?: Maybe<Submission_OverallOutcome>;
  /** Parts of a feedback. It's symmetrical to `Submission_SubmissionPart` */
  parts: Array<Submission_FeedbackPart>;
  /** List of required features that a mobile app version must support in order to render the feedback. */
  requiredMobileFeatures?: Maybe<Array<Submission_RequiredMobileFeature>>;
  /** ID of the graded Submission */
  submissionId: Scalars['ID'];
};

/** Feedback consists of questions and text blocks (when added) */
export type Submission_FeedbackPart = Submission_GradedCheckboxQuestion | Submission_GradedCheckboxReflectQuestion | Submission_GradedCodeExpressionQuestion | Submission_GradedFileUploadQuestion | Submission_GradedMathQuestion | Submission_GradedMultipleChoiceQuestion | Submission_GradedMultipleChoiceReflectQuestion | Submission_GradedMultipleFillableBlanksQuestion | Submission_GradedNumericQuestion | Submission_GradedOffPlatformQuestion | Submission_GradedPlainTextQuestion | Submission_GradedRegexQuestion | Submission_GradedRichTextQuestion | Submission_GradedTextExactMatchQuestion | Submission_GradedTextReflectQuestion | Submission_GradedUrlQuestion | Submission_GradedWidgetQuestion | Submission_TextBlock;

/** Describes a file upload question */
export type Submission_FileUploadQuestion = {
  __typename?: 'Submission_FileUploadQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_FileUploadQuestionSchema;
  /** Response to the question */
  response: Submission_FileUploadQuestionResponse;
};

/** S3 file parameters for pre-signed URL */
export type Submission_FileUploadQuestionGenerateUploadUrlInput = {
  /** Optionally include the MD5 CheckSum of the file, which is used to ensure that file transfer occurred without a file corruption */
  contentMd5?: InputMaybe<Scalars['String']>;
  /** MIME string, eg. image/gif or text/plain */
  contentType: Scalars['String'];
  /** Upload file name */
  fileName: Scalars['String'];
};

/** Pre-signed URL to an S3 bucket file */
export type Submission_FileUploadQuestionGenerateUploadUrlResult = {
  __typename?: 'Submission_FileUploadQuestionGenerateUploadUrlResult';
  /** Additional headers' key-value pairs that must be included with the url - else the signature check will fail */
  additionalHeaders: Array<UploadUrlResult_Header>;
  /**
   * Generated UUID key of the URL
   * @deprecated Not needed by FE.
   */
  key: Scalars['ID'];
  /** Pre-signed URL for S3 file interactions */
  url: Scalars['String'];
};

/** Response to a file upload question */
export type Submission_FileUploadQuestionResponse = {
  __typename?: 'Submission_FileUploadQuestionResponse';
  /** Caption to describe the file */
  caption: Scalars['String'];
  /** Generated file URL after upload */
  fileUrl: Scalars['String'];
  /** Title to describe the file */
  title: Scalars['String'];
};

/** Response to a file upload question */
export type Submission_FileUploadQuestionResponseInput = {
  /** Caption to describe the file */
  caption: Scalars['String'];
  /** Generated file URL after upload */
  fileUrl: Scalars['String'];
  /** Title to describe the file */
  title: Scalars['String'];
};

/** File upload question schema */
export type Submission_FileUploadQuestionSchema = {
  __typename?: 'Submission_FileUploadQuestionSchema';
  /** Indicates which types of files are allowed to be uploaded for the file upload question */
  allowedFiles: Array<Submission_AllowedFileType>;
  /** Flags to indicate whether plagiarism check is enabled for this specific question */
  plagiarismCheckStatus: Submission_QuestionPlagiarismCheckEnabledStatus;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** As of 10/06/2022, only "MultipleChoiceFillableBlank" is implemented */
export type Submission_FillableBlank = Submission_MultipleChoiceFillableBlank;

/** As of 10/06/2022, only "MultipleChoiceFillableBlank" is implemented */
export type Submission_FillableBlankResponse = Submission_MultipleChoiceFillableBlankResponse;

/** A wrapper to support different response types. Future fillable blank types can be added using @oneOf. */
export type Submission_FillableBlankResponseInput = {
  /** A multiple choice fillable blank response */
  multipleChoiceFillableBlankResponse?: InputMaybe<Submission_MultipleChoiceFillableBlankResponseInput>;
};

/** Errors for the query getResponseFeedback */
export type Submission_GetResponseFeedbackFailure = {
  __typename?: 'Submission_GetResponseFeedbackFailure';
  /** Errors encountered when calling the getResponseFeedback query */
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Possible result types from the query getResponseFeedback */
export type Submission_GetResponseFeedbackResult = Submission_GetResponseFeedbackFailure | Submission_GetResponseFeedbackSuccess;

/** Feedback to a single submission response */
export type Submission_GetResponseFeedbackSuccess = {
  __typename?: 'Submission_GetResponseFeedbackSuccess';
  /** Feedback for a single question (response) */
  part: Submission_FeedbackPart;
};

/** Outcome of the assignment across all attempts */
export type Submission_GradeOverride = {
  __typename?: 'Submission_GradeOverride';
  /** Original grade */
  original: Scalars['Float'];
  /** Override grade which represents the earnedGrade */
  override: Scalars['Float'];
};

/** Determines which grade to use as a learner's final grade if multiple grading attempts have been made */
export const Submission_GradeSelectionStrategy = {
  /** Use the highest grade out of all of the learner's grading attempts */
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  /** Use the grade from the learner's most recent grading attempt */
  TakeLatestGrade: 'TAKE_LATEST_GRADE'
} as const;

export type Submission_GradeSelectionStrategy = typeof Submission_GradeSelectionStrategy[keyof typeof Submission_GradeSelectionStrategy];
/** A graded checkbox question */
export type Submission_GradedCheckboxQuestion = {
  __typename?: 'Submission_GradedCheckboxQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question schema */
  questionSchema: Submission_GradedCheckboxSchema;
  /** Response to the question */
  response?: Maybe<Submission_CheckboxQuestionResponse>;
};

/** A graded checkbox reflect question */
export type Submission_GradedCheckboxReflectQuestion = {
  __typename?: 'Submission_GradedCheckboxReflectQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question schema */
  questionSchema: Submission_GradedCheckboxSchema;
  /** Response to the question */
  response?: Maybe<Submission_CheckboxQuestionResponse>;
};

/** Graded checkbox schema */
export type Submission_GradedCheckboxSchema = {
  __typename?: 'Submission_GradedCheckboxSchema';
  /** Possible options of the question */
  options?: Maybe<Array<Submission_GradedOption>>;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** A graded code expression question */
export type Submission_GradedCodeExpressionQuestion = {
  __typename?: 'Submission_GradedCodeExpressionQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question Schema */
  questionSchema: Submission_CodeExpressionQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_CodeExpressionQuestionResponse>;
};

/** A graded file upload question */
export type Submission_GradedFileUploadQuestion = {
  __typename?: 'Submission_GradedFileUploadQuestion';
  /** Manually-graded question feedback */
  feedback: Submission_ManuallyGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_FileUploadQuestionSchema;
  /** Response to the question */
  response: Submission_FileUploadQuestionResponse;
};

/** Graded fillable blank */
export type Submission_GradedFillableBlank = Submission_GradedMultipleChoiceFillableBlank;

/** A graded math question */
export type Submission_GradedMathQuestion = {
  __typename?: 'Submission_GradedMathQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_GradedMathQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_MathQuestionResponse>;
};

/** A graded Math question schema with the correct answer */
export type Submission_GradedMathQuestionSchema = {
  __typename?: 'Submission_GradedMathQuestionSchema';
  /** Correct answers of the question */
  correctAnswer?: Maybe<Submission_CorrectAnswer>;
  /** Question prompt */
  prompt: Submission_RichText;
};

/** Multiple choice graded fillable blank */
export type Submission_GradedMultipleChoiceFillableBlank = {
  __typename?: 'Submission_GradedMultipleChoiceFillableBlank';
  /** Answer options */
  answerOptions?: Maybe<Array<Submission_MultipleChoiceOption>>;
  /** Feedback for the FillableBlank */
  feedback?: Maybe<Submission_RichText>;
  /** Fillable blank Id */
  id: Scalars['ID'];
  /** Indicate if the FillableBlank was correctly answered */
  isCorrect: Scalars['Boolean'];
};

/** A graded multiple choice question */
export type Submission_GradedMultipleChoiceQuestion = {
  __typename?: 'Submission_GradedMultipleChoiceQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question schema */
  questionSchema: Submission_GradedMultipleChoiceSchema;
  /** Response to the question */
  response?: Maybe<Submission_MultipleChoiceQuestionResponse>;
};

/** A graded multiple choice reflect question */
export type Submission_GradedMultipleChoiceReflectQuestion = {
  __typename?: 'Submission_GradedMultipleChoiceReflectQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question schema */
  questionSchema: Submission_GradedMultipleChoiceSchema;
  /** Response to the question */
  response?: Maybe<Submission_MultipleChoiceQuestionResponse>;
};

/** Graded multiple choice schema */
export type Submission_GradedMultipleChoiceSchema = {
  __typename?: 'Submission_GradedMultipleChoiceSchema';
  /** Possible options of the question */
  options?: Maybe<Array<Submission_MultipleChoiceOption>>;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** A graded multiple fillable blanks question */
export type Submission_GradedMultipleFillableBlanksQuestion = {
  __typename?: 'Submission_GradedMultipleFillableBlanksQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question schema */
  questionSchema: Submission_GradedMultipleFillableBlanksSchema;
  /** Response to the question */
  response?: Maybe<Submission_MultipleFillableBlanksQuestionResponse>;
};

/** Graded multiple fillable blanks schema */
export type Submission_GradedMultipleFillableBlanksSchema = {
  __typename?: 'Submission_GradedMultipleFillableBlanksSchema';
  /** Possible options of the question */
  fillableBlanks: Array<Submission_GradedFillableBlank>;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** A graded numeric question */
export type Submission_GradedNumericQuestion = {
  __typename?: 'Submission_GradedNumericQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_NumericQuestionResponse>;
};

/** Feedback to an offplatform question */
export type Submission_GradedOffPlatformQuestion = {
  __typename?: 'Submission_GradedOffPlatformQuestion';
  /** Manually-graded question feedback */
  feedback: Submission_ManuallyGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
};

/** A graded option */
export type Submission_GradedOption = {
  __typename?: 'Submission_GradedOption';
  /**
   * Whether the option is correctly answered. It's calculated by checking equality of whether the option was selected
   * and whether it's supposed to be selected. If the question is reflective, this value will be unset.
   */
  correctlyAnswered?: Maybe<Scalars['Boolean']>;
  /** Option display content */
  display: Submission_RichText;
  /** Feedback content for the option */
  feedback: Submission_RichText;
  /** Option Id */
  id: Scalars['ID'];
};

/** A graded plain text question */
export type Submission_GradedPlainTextQuestion = {
  __typename?: 'Submission_GradedPlainTextQuestion';
  /** Manually-graded question feedback */
  feedback: Submission_ManuallyGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_PlainTextQuestionResponse;
};

/** A graded regex question */
export type Submission_GradedRegexQuestion = {
  __typename?: 'Submission_GradedRegexQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_RegexQuestionResponse>;
};

/** A graded rich text question */
export type Submission_GradedRichTextQuestion = {
  __typename?: 'Submission_GradedRichTextQuestion';
  /** Manually-graded question feedback */
  feedback: Submission_ManuallyGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_RichTextQuestionSchema;
  /** Response to the question */
  response: Submission_RichTextQuestionResponse;
};

/** A graded text exact match question */
export type Submission_GradedTextExactMatchQuestion = {
  __typename?: 'Submission_GradedTextExactMatchQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_GradedTextExactMatchQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_TextExactMatchQuestionResponse>;
};

/** A graded TextExactMatch question schema with correct answers */
export type Submission_GradedTextExactMatchQuestionSchema = {
  __typename?: 'Submission_GradedTextExactMatchQuestionSchema';
  /** Correct answers of the question */
  correctAnswers?: Maybe<Array<Submission_CorrectAnswer>>;
  /** Question prompt */
  prompt: Submission_RichText;
};

/** A graded text reflect question */
export type Submission_GradedTextReflectQuestion = {
  __typename?: 'Submission_GradedTextReflectQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_TextReflectQuestionResponse>;
};

/** A graded URL submission question */
export type Submission_GradedUrlQuestion = {
  __typename?: 'Submission_GradedUrlQuestion';
  /** Manually-graded question feedback */
  feedback: Submission_ManuallyGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_UrlQuestionSchema;
  /** Response to the question */
  response: Submission_UrlQuestionResponse;
};

/** A graded widget question */
export type Submission_GradedWidgetQuestion = {
  __typename?: 'Submission_GradedWidgetQuestion';
  /** Auto-graded question feedback */
  feedback: Submission_AutoGradedFeedback;
  /** Id of the question */
  id: Scalars['ID'];
  /** Question Schema */
  questionSchema: Submission_WidgetQuestionSchema;
  /** Response to the question */
  response?: Maybe<Submission_WidgetQuestionResponse>;
};

/** How the rubric was graded. Whether it was by a human or AI. */
export const Submission_GraderTypes = {
  /** AI Graded */
  Ai: 'AI',
  /** Auto graded questions */
  Auto: 'AUTO',
  /** Human Graded */
  Human: 'HUMAN'
} as const;

export type Submission_GraderTypes = typeof Submission_GraderTypes[keyof typeof Submission_GraderTypes];
/** Contains html in a string format. */
export type Submission_HtmlContent = {
  __typename?: 'Submission_HtmlContent';
  /** Html in string */
  value: Scalars['String'];
};

/** Contains html in a string format. */
export type Submission_HtmlContentInput = {
  /** Html in string */
  value: Scalars['String'];
};

/** TODO: Complete this description */
export type Submission_InProgressAttempt = {
  __typename?: 'Submission_InProgressAttempt';
  /** Unlimited if empty */
  allowedDuration?: Maybe<Scalars['Duration']>;
  /**
   * Indicates if auto-submission is required for the attempt. As of now, this is true when 1. the attempt is timed 2.
   * there hasn't been submission made in the attempt.
   */
  autoSubmissionRequired: Scalars['Boolean'];
  /** In-progress draft data */
  draft?: Maybe<Submission_Submission>;
  /** Identifier of the attempt in progress */
  id: Scalars['ID'];
  /** Unlimited if empty */
  remainingDuration?: Maybe<Scalars['Duration']>;
  /** When the attempt was started by the submitter */
  startedTime: Scalars['DateTime'];
  /** Unlimited if empty */
  submissionsAllowed?: Maybe<Scalars['Int']>;
  /** Submissions that the submitter has made so far in the attempt */
  submissionsMade: Scalars['Int'];
  /** Unlimited if empty */
  submissionsRemaining?: Maybe<Scalars['Int']>;
};

/** Represents an individual submitter. This is returned when an assignment is configured to use "individual" submission. */
export type Submission_IndividualSubmitter = {
  __typename?: 'Submission_IndividualSubmitter';
  /** Id of the submitter */
  id: Scalars['ID'];
};

/** Instructions for taking the assignment */
export type Submission_Instructions = {
  __typename?: 'Submission_Instructions';
  /** An overview of the assignment. */
  overview?: Maybe<Submission_RichText>;
  /** Should cover how the assignment will be evaluated. */
  reviewCriteria?: Maybe<Submission_RichText>;
};

/** Returned when the attempt user is trying to submit is invalid */
export type Submission_InvalidAttemptIdError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_InvalidAttemptIdError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Returned when the honorlock session is not valid */
export type Submission_InvalidHonorlockSessionError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_InvalidHonorlockSessionError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** The most recent submission for a given attempt */
export type Submission_LastSubmission = {
  __typename?: 'Submission_LastSubmission';
  /** Submission id */
  id: Scalars['ID'];
  /** May be empty since some assignment settings can disallow showing the last submission's content */
  submission?: Maybe<Submission_Submission>;
  /** Time of the submission */
  submittedAt: Scalars['DateTime'];
};

/**
 * Learner feedback visibility
 * Information on the values: https://www.coursera.support/s/article/360024748191-Add-Staff-Graded-Assignments-and-Adjust-Assignment-Settings#feedback_type
 */
export const Submission_LearnerFeedbackVisibility = {
  /** Full visibility */
  Full: 'FULL',
  /** Limited visibility */
  Limited: 'LIMITED',
  /** Partial visibility */
  Partial: 'PARTIAL'
} as const;

export type Submission_LearnerFeedbackVisibility = typeof Submission_LearnerFeedbackVisibility[keyof typeof Submission_LearnerFeedbackVisibility];
/** Manually-graded feedback that consists of rubrics */
export type Submission_ManuallyGradedFeedback = {
  __typename?: 'Submission_ManuallyGradedFeedback';
  /** Type of grader for this feedback */
  graderType: Submission_GraderTypes;
  /** Question outcome */
  outcome?: Maybe<Submission_QuestionOutcome>;
  /** Filled-out rubrics to the question */
  rubrics?: Maybe<Array<Submission_RubricFeedback>>;
};

/** Describes a math question. Question input requires a math expression. */
export type Submission_MathQuestion = {
  __typename?: 'Submission_MathQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_MathQuestionResponse;
};

/** Response to a math question */
export type Submission_MathQuestionResponse = {
  __typename?: 'Submission_MathQuestionResponse';
  /** Math expression in a string */
  answer: Scalars['String'];
};

/** Response to a math question */
export type Submission_MathQuestionResponseInput = {
  /** Math expression in a string */
  answer: Scalars['String'];
};

/**
 * A multiline rubric contains an input field for written feedback. When its configured to be scored, `maxScore` will be
 * non-empty and a score will be provided by the grader as well.
 */
export type Submission_MultilineRubricFeedback = {
  __typename?: 'Submission_MultilineRubricFeedback';
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: Maybe<Scalars['ID']>;
  /** How the rubric was graded. Whether it was by a human or AI. */
  graderType: Submission_GraderTypes;
  /** Id of the rubric */
  id: Scalars['ID'];
  /**
   * Grader input, if available. Being replaced by the `richTextInput` field, so it is expected that
   * they will be mutually exclusive.
   */
  input?: Maybe<Scalars['String']>;
  /** Max possible score of the rubric. When extra-credit is enabled, the actual score may exceed the `maxScore`. */
  maxScore?: Maybe<Scalars['Float']>;
  /** Prompt of the rubric */
  prompt: Submission_RichText;
  /**
   * Grader input, if available. Replacing the plain-text `input` field, so it is expected that they
   * will be mutually exclusive.
   */
  richTextInput?: Maybe<CmlContent>;
  /** Awarded score, if available */
  score?: Maybe<Scalars['Float']>;
};

/** A fillable blank */
export type Submission_MultipleChoiceFillableBlank = {
  __typename?: 'Submission_MultipleChoiceFillableBlank';
  /** Answer options */
  answerOptions: Array<Submission_MultipleChoiceOption>;
  /** Fillable blank Id */
  id: Scalars['ID'];
};

/** Response to a single multiple-choice fillable blank */
export type Submission_MultipleChoiceFillableBlankResponse = {
  __typename?: 'Submission_MultipleChoiceFillableBlankResponse';
  /** Id of the fillable blank. */
  id: Scalars['ID'];
  /** Id of the chosen option. */
  optionId: Scalars['ID'];
};

/** Response to a single multiple choice fillable blank */
export type Submission_MultipleChoiceFillableBlankResponseInput = {
  /** Id of the fillable blank */
  id: Scalars['ID'];
  /** Id of the chosen option */
  optionId: Scalars['ID'];
};

/** Option of a multiple-choice-like question */
export type Submission_MultipleChoiceOption = {
  __typename?: 'Submission_MultipleChoiceOption';
  /** Display content for the option */
  display: Submission_RichText;
  /** Option id */
  id: Scalars['ID'];
};

/** Describes a multiple choice question with a single correct answer. */
export type Submission_MultipleChoiceQuestion = {
  __typename?: 'Submission_MultipleChoiceQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_MultipleChoiceSchema;
  /** Response to the question */
  response: Submission_MultipleChoiceQuestionResponse;
};

/** Response to a multiple choice question */
export type Submission_MultipleChoiceQuestionResponse = {
  __typename?: 'Submission_MultipleChoiceQuestionResponse';
  /** Id of the chosen option, could be empty if the submitter didn't select any */
  chosen?: Maybe<Scalars['ID']>;
};

/** Response to a multiple choice question */
export type Submission_MultipleChoiceQuestionResponseInput = {
  /** Id of the chosen option, could be empty if the submitter didn't select any */
  chosen?: InputMaybe<Scalars['ID']>;
};

/** Describes a multiple choice reflect question. Full score is awarded when any option is selected. */
export type Submission_MultipleChoiceReflectQuestion = {
  __typename?: 'Submission_MultipleChoiceReflectQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_MultipleChoiceSchema;
  /** Response to the question */
  response: Submission_MultipleChoiceQuestionResponse;
};

/** Multiple Choice question schema */
export type Submission_MultipleChoiceSchema = {
  __typename?: 'Submission_MultipleChoiceSchema';
  /** Possible options of the question */
  options: Array<Submission_MultipleChoiceOption>;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** Multiple Fillable Blank question schema */
export type Submission_MultipleFillableBlankQuestionSchema = {
  __typename?: 'Submission_MultipleFillableBlankQuestionSchema';
  /** Possible options of the question */
  fillableBlanks: Array<Submission_FillableBlank>;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** Describes a multiple fillable blanks question. */
export type Submission_MultipleFillableBlanksQuestion = {
  __typename?: 'Submission_MultipleFillableBlanksQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_MultipleFillableBlankQuestionSchema;
  /** Response to the question */
  response: Submission_MultipleFillableBlanksQuestionResponse;
};

/** Response to a multiple fillable blanks question */
export type Submission_MultipleFillableBlanksQuestionResponse = {
  __typename?: 'Submission_MultipleFillableBlanksQuestionResponse';
  /** List of fillable blank responses */
  responses: Array<Submission_FillableBlankResponse>;
};

/** Response to a multiple fillable blanks question */
export type Submission_MultipleFillableBlanksQuestionResponseInput = {
  /** List of fillable blank responses, where each has the Id of the blank and the response */
  responses: Array<Submission_FillableBlankResponseInput>;
};

/** TODO: Complete this description */
export type Submission_NextAttempt = {
  __typename?: 'Submission_NextAttempt';
  /** Unlimited if empty */
  allowedDuration?: Maybe<Scalars['Duration']>;
  /** The next AttemptId which will be used */
  nextAttemptId: Scalars['ID'];
  /** Unlimited if empty */
  submissionsAllowed?: Maybe<Scalars['Int']>;
};

/** All but `StartAttempt` requires an in-progress attempt. Otherwise the request will be rejected by this error. */
export type Submission_NoAttemptInProgressError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_NoAttemptInProgressError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Saving responses or submitting draft requires an open draft. Otherwise the request will be rejected by this error. */
export type Submission_NoOpenDraftError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_NoOpenDraftError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Describes a numeric question. Question input requires a number. */
export type Submission_NumericQuestion = {
  __typename?: 'Submission_NumericQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_NumericQuestionResponse;
};

/** Response to a numeric question */
export type Submission_NumericQuestionResponse = {
  __typename?: 'Submission_NumericQuestionResponse';
  /** Numeric answer string */
  answer: Scalars['String'];
};

/** Response to a numeric question */
export type Submission_NumericQuestionResponseInput = {
  /** Numeric answer string */
  answer: Scalars['String'];
};

/** Describes an off-platform question. An off-platform question doesn't need responses. */
export type Submission_OffPlatformQuestion = {
  __typename?: 'Submission_OffPlatformQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
};

/** A options rubric contains an list of scored options for grader to select from. */
export type Submission_OptionsRubricFeedback = {
  __typename?: 'Submission_OptionsRubricFeedback';
  /** SuggestionId of the AI review if graded by AI */
  aiSuggestionId?: Maybe<Scalars['ID']>;
  /** How the rubric was graded. Whether it was by a human or AI. */
  graderType: Submission_GraderTypes;
  /** Id of the rubric */
  id: Scalars['ID'];
  /** Possible options of the rubric */
  options?: Maybe<Array<Submission_RubricOption>>;
  /** Prompt of the rubric */
  prompt: Submission_RichText;
  /** Grader input, if available */
  richTextInput?: Maybe<CmlContent>;
};

/**
 * Overall outcome of an evaluated submission. It contains both the latest and highest awarded grades
 * regardless of the grade selection strategy.
 */
export type Submission_OverallOutcome = {
  __typename?: 'Submission_OverallOutcome';
  /** Total highest score awarded to the submission. It maybe higher than maxScore when extra credit is enabled for the assignment. */
  highestScore: Scalars['Float'];
  /** Total latest score awarded to the submission. It maybe higher than maxScore when extra credit is enabled for the assignment. */
  latestScore: Scalars['Float'];
  /** Total max score of the assignment. It adds up all the rubrics and auto-grading points. */
  maxScore: Scalars['Float'];
  /**
   * Total score awarded to the submission. It maybe higher than maxScore when extra credit is enabled for the assignment.
   * @deprecated replaced with latestScore and highestScore fields.
   */
  score: Scalars['Float'];
};

/** Describes a plain text question. This question type has been deprecated and should only exist in old assignments. */
export type Submission_PlainTextQuestion = {
  __typename?: 'Submission_PlainTextQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_PlainTextQuestionResponse;
};

/**
 * Response to a plain text question. This question type has been deprecated and should only
 * exist in old assignments
 */
export type Submission_PlainTextQuestionResponse = {
  __typename?: 'Submission_PlainTextQuestionResponse';
  /** Plain text string */
  plainText: Scalars['String'];
};

/**
 * Response to a plain text question. This question type has been deprecated and should only
 * exist in old assignments
 */
export type Submission_PlainTextQuestionResponseInput = {
  /** Plain text string */
  plainText: Scalars['String'];
};

/** A common question schema with only a prompt */
export type Submission_PromptOnlyQuestionSchema = {
  __typename?: 'Submission_PromptOnlyQuestionSchema';
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** Errors when querying for the submission state */
export type Submission_QueryStateFailure = {
  __typename?: 'Submission_QueryStateFailure';
  /** Errors encountered when determining the submission state. */
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Possible result types from querying SubmissionState */
export type Submission_QueryStateResult = Submission_QueryStateFailure | Submission_SubmissionState;

/**
 * Thrown when the user's IP address is not in the pre-defined white list
 * Epic link: https://tools.coursera.org/epic/experiment/suQWLHKgEe6YYwrfq_--AQ
 */
export type Submission_QueryState_IpNotAllowedError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_QueryState_IPNotAllowedError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Thrown when a team is not assignment but required by the assignment */
export type Submission_QueryState_TeamNotAssignedError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_QueryState_TeamNotAssignedError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Grade settings of a question */
export type Submission_QuestionGradeSettings = {
  __typename?: 'Submission_QuestionGradeSettings';
  /** Grader type */
  graderType: Submission_GraderTypes;
  /** Maximum possible score to acquire for a question. The question is ungraded if this is not defined. */
  maxScore?: Maybe<Scalars['Float']>;
};

/**
 * Overall outcome of the question. For manually graded questions with multiple rubrics, this aggregates scores from
 * all the rubrics.
 */
export type Submission_QuestionOutcome = {
  __typename?: 'Submission_QuestionOutcome';
  /** Max possible score of the question. If a question is configured to be extra-credit. Max score can be exceeded. */
  maxScore: Scalars['Float'];
  /** Acquired score from the question */
  score: Scalars['Float'];
};

/** Enabled status of plagiarism check feature */
export const Submission_QuestionPlagiarismCheckEnabledStatus = {
  /** Plagiarism check disabled. */
  Disabled: 'DISABLED',
  /** Plagiarism check enabled. */
  Enabled: 'ENABLED'
} as const;

export type Submission_QuestionPlagiarismCheckEnabledStatus = typeof Submission_QuestionPlagiarismCheckEnabledStatus[keyof typeof Submission_QuestionPlagiarismCheckEnabledStatus];
/**
 * The response to a single question.
 * Provide a single QuestionType and the corresponding data.
 * Unfortunately, neither Union nor Oneof are currently available to make this simpler to use.
 */
export type Submission_QuestionResponseInput = {
  /** The ID of the question being responded to */
  questionId: Scalars['ID'];
  /** response to the question */
  questionResponse: Submission_QuestionResponseInputUnion;
  /**
   * The type of question being responded to.
   * This should match the response data provided.
   */
  questionType: Submission_QuestionType;
};

/**
 * A union type that use our custom @oneOf annotation to enforce exactly one field is set:
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Conventions#@oneOf-Inputs-(Input-Unions)
 */
export type Submission_QuestionResponseInputUnion = {
  checkboxResponse?: InputMaybe<Submission_CheckboxQuestionResponseInput>;
  codeExpressionResponse?: InputMaybe<Submission_CodeExpressionQuestionResponseInput>;
  fileUploadResponse?: InputMaybe<Submission_FileUploadQuestionResponseInput>;
  mathResponse?: InputMaybe<Submission_MathQuestionResponseInput>;
  multipleChoiceResponse?: InputMaybe<Submission_MultipleChoiceQuestionResponseInput>;
  multipleFillableBlanksResponse?: InputMaybe<Submission_MultipleFillableBlanksQuestionResponseInput>;
  numericResponse?: InputMaybe<Submission_NumericQuestionResponseInput>;
  plainTextResponse?: InputMaybe<Submission_PlainTextQuestionResponseInput>;
  regexResponse?: InputMaybe<Submission_RegexQuestionResponseInput>;
  richTextResponse?: InputMaybe<Submission_RichTextQuestionResponseInput>;
  textExactMatchResponse?: InputMaybe<Submission_TextExactMatchQuestionResponseInput>;
  textReflectResponse?: InputMaybe<Submission_TextReflectQuestionResponseInput>;
  urlResponse?: InputMaybe<Submission_UrlQuestionResponseInput>;
  widgetResponse?: InputMaybe<Submission_WidgetQuestionResponseInput>;
};

/** A list of all question types. */
export const Submission_QuestionType = {
  Checkbox: 'CHECKBOX',
  CheckboxReflect: 'CHECKBOX_REFLECT',
  CodeExpression: 'CODE_EXPRESSION',
  FileUpload: 'FILE_UPLOAD',
  Math: 'MATH',
  MultipleChoice: 'MULTIPLE_CHOICE',
  MultipleChoiceReflect: 'MULTIPLE_CHOICE_REFLECT',
  MultipleFillableBlanks: 'MULTIPLE_FILLABLE_BLANKS',
  Numeric: 'NUMERIC',
  PlainText: 'PLAIN_TEXT',
  Regex: 'REGEX',
  RichText: 'RICH_TEXT',
  TextExactMatch: 'TEXT_EXACT_MATCH',
  TextReflect: 'TEXT_REFLECT',
  Url: 'URL',
  Widget: 'WIDGET'
} as const;

export type Submission_QuestionType = typeof Submission_QuestionType[keyof typeof Submission_QuestionType];
/** To limit the number of attempts for a given time interval */
export type Submission_RateLimiterConfig = {
  __typename?: 'Submission_RateLimiterConfig';
  /** If rate limiting is enabled, this is when the remaining attempts will increase again to maxPerInterval */
  attemptsRemainingIncreasesAt?: Maybe<Scalars['DateTime']>;
  /**
   * DEPRECATED
   * @deprecated Use attemptsRemainingIncreasesAt instead
   */
  cannotBeStartedBefore?: Maybe<Scalars['DateTime']>;
  /** Maximum limit for the interval duration */
  maxPerInterval: Scalars['Int'];
  /** The duration for the rate limit */
  timeIntervalDuration: Scalars['Duration'];
};

/** Describes a text exact match question. Question input requires a regex expression. */
export type Submission_RegexQuestion = {
  __typename?: 'Submission_RegexQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_RegexQuestionResponse;
};

/** Response to a regex question */
export type Submission_RegexQuestionResponse = {
  __typename?: 'Submission_RegexQuestionResponse';
  /** A regex string */
  answer: Scalars['String'];
};

/** Response to a regex question */
export type Submission_RegexQuestionResponseInput = {
  /** A regex string */
  answer: Scalars['String'];
};

/** Assignment features that may potentially be unsupported by certain mobile app versions. */
export const Submission_RequiredMobileFeature = {
  /** The assignment has AI graded questions */
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  /** The assignment has AI-graded rubrics */
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  /** The assignment includes a learner-facing assignment rubric */
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  /** Attempts are limited to a maximum duration */
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  /** Grades are hidden from learners after release */
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  /** Past submissions are not visible to learners */
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  /** The assignment has human-graded rubrics, at either the assignment-level or question-level */
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  /** Learners are limited to a maximum number of allowed attempts */
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  /** Learners are limited to a maximum number of allowed submissions per attempt */
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  /** The assignment includes manually-graded questions */
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  /** The assignment includes multiple fillable blanks questions */
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  /** The assignment has more than one submission allowed per attempt */
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  /** The assignment uses a proctoring service like Honorlock or AutoProctor */
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  /** The assignment can be assigned to a team */
  Teamwork: 'TEAMWORK',
  /** The assignment contains text blocks */
  TextBlocks: 'TEXT_BLOCKS',
  /** The assignment includes widget questions */
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Submission_RequiredMobileFeature = typeof Submission_RequiredMobileFeature[keyof typeof Submission_RequiredMobileFeature];
export type Submission_ReworkSubmissionFailure = {
  __typename?: 'Submission_ReworkSubmissionFailure';
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Submits the latest draft */
export type Submission_ReworkSubmissionInput = {
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
};

export type Submission_ReworkSubmissionResult = Submission_ReworkSubmissionFailure | Submission_ReworkSubmissionSuccess;

export type Submission_ReworkSubmissionSuccess = {
  __typename?: 'Submission_ReworkSubmissionSuccess';
  submissionState?: Maybe<Submission_SubmissionState>;
};

/** Returned when there is no submission in the attempt to rework. */
export type Submission_ReworkSubmission_NoSubmissionToReworkError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_ReworkSubmission_NoSubmissionToReworkError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Rich text in Submission models can be encoded in Cml or Html */
export type Submission_RichText = CmlContent | Submission_HtmlContent;

/**
 * Rich text in Submission models can be encoded in Cml or Html.
 * Use either the HTML or CML node, but not both.
 */
export type Submission_RichTextInput = {
  /** CML Content */
  cml?: InputMaybe<CmlContentInput>;
  /** HTML string. */
  html?: InputMaybe<Submission_HtmlContentInput>;
};

/** Describes a rich text question */
export type Submission_RichTextQuestion = {
  __typename?: 'Submission_RichTextQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_RichTextQuestionSchema;
  /** Response to the question */
  response: Submission_RichTextQuestionResponse;
};

/** Response to a rich text question */
export type Submission_RichTextQuestionResponse = {
  __typename?: 'Submission_RichTextQuestionResponse';
  /**
   * Rich text encoded in either Cml or html. We prefer using Cml for new responses but there
   * is no strict guarantee that returned value is of Cml type due to legacy data
   */
  richText: Submission_RichText;
};

/** Response to a rich text question */
export type Submission_RichTextQuestionResponseInput = {
  /**
   * Rich text encoded in either Cml or html. We prefer using Cml for new responses but there
   * is no strict guarantee that returned value is of Cml type due to legacy data
   */
  richText: Submission_RichTextInput;
};

/** A rich text question schema */
export type Submission_RichTextQuestionSchema = {
  __typename?: 'Submission_RichTextQuestionSchema';
  /** Flags to indicate whether plagiarism check is enabled for this specific question */
  plagiarismCheckStatus: Submission_QuestionPlagiarismCheckEnabledStatus;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** A rubric feedback is a read-only, completed rubric with grader input. A rubric may be scored or not scored. */
export type Submission_RubricFeedback = Submission_BoxViewDocumentAnnotationRubricFeedback | Submission_MultilineRubricFeedback | Submission_OptionsRubricFeedback;

/** One option of the options rubric */
export type Submission_RubricOption = {
  __typename?: 'Submission_RubricOption';
  /** Display content of the option */
  display: Submission_RichText;
  /** Id of the option */
  id: Scalars['ID'];
  /** Points that the option is worth */
  points: Scalars['Float'];
  /** Whether the option is selected by the grader */
  selected: Scalars['Boolean'];
};

export type Submission_SaveResponsesFailure = {
  __typename?: 'Submission_SaveResponsesFailure';
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Updates the current submission with new responses */
export type Submission_SaveResponsesInput = {
  /** AttemptId of the response to save */
  attemptId?: InputMaybe<Scalars['ID']>;
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
  /** The question responses */
  questionResponses: Array<InputMaybe<Submission_QuestionResponseInput>>;
};

export type Submission_SaveResponsesResult = Submission_SaveResponsesFailure | Submission_SaveResponsesSuccess;

export type Submission_SaveResponsesSuccess = {
  __typename?: 'Submission_SaveResponsesSuccess';
  submissionState?: Maybe<Submission_SubmissionState>;
};

/** Returned when responses didn't pass validation. */
export type Submission_SaveResponses_InvalidResponsesError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_SaveResponses_InvalidResponsesError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/** Includes information on the slack integration for the team */
export type Submission_SlackIntegrationMetadata = {
  __typename?: 'Submission_SlackIntegrationMetadata';
  /** Slack GroupId */
  slackGroupId: Scalars['ID'];
  /** Team domain. It can be empty */
  slackTeamDomain?: Maybe<Scalars['String']>;
  /** Slack TeamId */
  slackTeamId: Scalars['ID'];
};

/** An individual user's slack profile */
export type Submission_SlackProfile = {
  __typename?: 'Submission_SlackProfile';
  /** If the user's account is deleted or inactive. This field is carried over from scala implementation. */
  deletedOrInactive: Scalars['Boolean'];
  /** User's name on Slack */
  slackName: Scalars['String'];
  /** Slack TeamId */
  slackTeamId: Scalars['ID'];
  /** UserId on Slack */
  slackUserId: Scalars['ID'];
};

/**
 * All submission mutations are blocked as soon as staff grading has started. Mutation requests after staff grading has
 * started will be rejected by this error.
 */
export type Submission_StaffGradingStartedError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_StaffGradingStartedError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

export type Submission_StartAttemptFailure = {
  __typename?: 'Submission_StartAttemptFailure';
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Starts a new attempt */
export type Submission_StartAttemptInput = {
  /** The CourseId of the assignment being attempted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being attempted */
  itemId: Scalars['ID'];
};

export type Submission_StartAttemptResult = Submission_StartAttemptFailure | Submission_StartAttemptSuccess;

export type Submission_StartAttemptSuccess = {
  __typename?: 'Submission_StartAttemptSuccess';
  submissionState?: Maybe<Submission_SubmissionState>;
};

/** Returned when there is no attempt remaining */
export type Submission_StartAttempt_OutOfAttemptsError = ErrorDetails & Submission_ErrorDetailsWithErrorCode & {
  __typename?: 'Submission_StartAttempt_OutOfAttemptsError';
  /** errorCode */
  errorCode: Scalars['String'];
  /** Readable message provides the error details. */
  message: Scalars['String'];
  /** Path of the error. */
  path: Scalars['String'];
  /** Suggestion for the client to fix the error. */
  suggestion?: Maybe<Scalars['String']>;
};

/**
 * A submission contains interactive or read only components that constitutes the
 * main body of an assignment.
 */
export type Submission_Submission = {
  __typename?: 'Submission_Submission';
  /** List of all features used by the assignment */
  assignmentFeatures?: Maybe<Array<Submission_AssignmentFeature>>;
  /** Id of the submission */
  id: Scalars['ID'];
  /** Instructions for the assignment */
  instructions?: Maybe<Submission_Instructions>;
  /** Last time this submission was saved */
  lastSavedAt: Scalars['DateTime'];
  /**
   * It's possible that we add pagination to submission parts in the future. However
   * there's a risk of prematurely allowing partial-loading of a submission before
   * adding proper pagination support on the FE. This ensures that learners always
   * see all the questions in the assignment experience.
   */
  parts?: Maybe<Array<Submission_SubmissionPart>>;
  /** List of required features that a mobile app version must support in order to render the submission. */
  requiredMobileFeatures?: Maybe<Array<Submission_RequiredMobileFeature>>;
};

export type Submission_SubmissionHeader = {
  __typename?: 'Submission_SubmissionHeader';
  attemptNumber: Scalars['Int'];
  /** This is legacy, though is currently required because of the use of the Presentation endpoint. */
  executionId: Scalars['ID'];
  /** The SubmissionId */
  id: Scalars['ID'];
  startedAt?: Maybe<Scalars['DateTime']>;
  submissionNumber: Scalars['Int'];
  submittedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * A submission view may contain more than just questions. For instance, we will add
 * text blocks in the future.
 */
export type Submission_SubmissionPart = Submission_CheckboxQuestion | Submission_CheckboxReflectQuestion | Submission_CodeExpressionQuestion | Submission_FileUploadQuestion | Submission_MathQuestion | Submission_MultipleChoiceQuestion | Submission_MultipleChoiceReflectQuestion | Submission_MultipleFillableBlanksQuestion | Submission_NumericQuestion | Submission_OffPlatformQuestion | Submission_PlainTextQuestion | Submission_RegexQuestion | Submission_RichTextQuestion | Submission_TextBlock | Submission_TextExactMatchQuestion | Submission_TextReflectQuestion | Submission_UrlQuestion | Submission_WidgetQuestion;

/** The current state of the assignment submission. */
export type Submission_SubmissionState = {
  __typename?: 'Submission_SubmissionState';
  /** AI Grading of the last submitted submission */
  aiGradingStatus?: Maybe<Ai_Grading_Status>;
  /** Current allowed action. At most one action is allowed at a time */
  allowedAction?: Maybe<Submission_AllowedAction>;
  /** The assignment being attempted. */
  assignment: Submission_Assignment;
  /** Learner's made, in-progress and remaining attempts */
  attempts?: Maybe<Submission_Attempts>;
  /** The course in which submission is being made. */
  course: Course_Course;
  /** Available feedback for the assignment */
  feedback?: Maybe<Submission_Feedback>;
  /** Overall grading of the last submitted submission */
  gradingStatus?: Maybe<Grading_Status>;
  /** Settings related to academic integrity preventions. Can be null if the current user is not enrolled in the course. */
  integritySettings?: Maybe<Integrity_IntegritySettings>;
  /** Staff/Human Grading status */
  manualGradingStatus?: Maybe<Manual_Grading_Status>;
  /** Outcome of the assignment */
  outcome?: Maybe<Submission_AssignmentOutcome>;
  /** The timestamp when the submission state had its skills verified */
  skillsVerifiedAt?: Maybe<Scalars['DateTime']>;
  /** Submitter that has been assigned to the assignment */
  submitter: Submission_Submitter;
  /** Informative warnings that we want let the learner be aware of */
  warnings?: Maybe<Array<Submission_Warning>>;
};

export type Submission_SubmitLatestDraftFailure = {
  __typename?: 'Submission_SubmitLatestDraftFailure';
  errors: Array<Submission_InvalidAttemptIdError | Submission_InvalidHonorlockSessionError | Submission_NoAttemptInProgressError | Submission_NoOpenDraftError | Submission_QueryState_IpNotAllowedError | Submission_QueryState_TeamNotAssignedError | Submission_ReworkSubmission_NoSubmissionToReworkError | Submission_SaveResponses_InvalidResponsesError | Submission_StaffGradingStartedError | Submission_StartAttempt_OutOfAttemptsError>;
};

/** Submits the latest draft */
export type Submission_SubmitLatestDraftInput = {
  /** The CourseId of the assignment being submitted */
  courseId: Scalars['ID'];
  /** The ItemId of the assignment being submitted */
  itemId: Scalars['ID'];
  /** ID of the Submission to submit */
  submissionId: Scalars['ID'];
};

export type Submission_SubmitLatestDraftResult = Submission_SubmitLatestDraftFailure | Submission_SubmitLatestDraftSuccess;

export type Submission_SubmitLatestDraftSuccess = {
  __typename?: 'Submission_SubmitLatestDraftSuccess';
  submissionState?: Maybe<Submission_SubmissionState>;
};

/** A submitter can be a user submitter or team submitter depending on the nature of the assignment */
export type Submission_Submitter = Submission_IndividualSubmitter | Submission_TeamSubmitter;

/** Represents an team submitter. This is returned when an assignment is configured to use "team" submission. */
export type Submission_TeamSubmitter = {
  __typename?: 'Submission_TeamSubmitter';
  /** Id of the submitter */
  id: Scalars['ID'];
  /** Profile of each team member */
  memberProfiles: Array<Submission_UserProfile>;
  /** Team name */
  name: Scalars['String'];
  /** Slack integration metadata, if configured for the team */
  slackIntegrationMetadata?: Maybe<Submission_SlackIntegrationMetadata>;
  /** Description of the team activity configured for the team and the assignment */
  teamActivityDescription?: Maybe<Scalars['String']>;
};

/** TextBlocks, no responses are required. In the future we may support non-collapsible textBlocks */
export type Submission_TextBlock = {
  __typename?: 'Submission_TextBlock';
  /** Body to the textBlock */
  body: CmlContent;
  /** TextBlock id */
  id: Scalars['ID'];
  /** Title of the textBlock, only collapsible textblocks has a title */
  title?: Maybe<Scalars['String']>;
};

/** Describes a text exact match question. Question input requires plain text. */
export type Submission_TextExactMatchQuestion = {
  __typename?: 'Submission_TextExactMatchQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_TextExactMatchQuestionResponse;
};

/** Response to a text exact match question */
export type Submission_TextExactMatchQuestionResponse = {
  __typename?: 'Submission_TextExactMatchQuestionResponse';
  /** Answer is allowed to be optional per the original question definition */
  answer?: Maybe<Scalars['String']>;
};

/** Response to a text exact match question */
export type Submission_TextExactMatchQuestionResponseInput = {
  /** Answer is allowed to be optional per the original question definition */
  answer?: InputMaybe<Scalars['String']>;
};

/** Describes a text exact match question. Question input requires plain text. */
export type Submission_TextReflectQuestion = {
  __typename?: 'Submission_TextReflectQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_PromptOnlyQuestionSchema;
  /** Response to the question */
  response: Submission_TextReflectQuestionResponse;
};

/** Response to a text reflect question */
export type Submission_TextReflectQuestionResponse = {
  __typename?: 'Submission_TextReflectQuestionResponse';
  /** Answer is allowed to be optional per the original question definition */
  answer?: Maybe<Scalars['String']>;
};

/** Response to a text reflect question */
export type Submission_TextReflectQuestionResponseInput = {
  /** Answer is allowed to be optional per the original question definition */
  answer?: InputMaybe<Scalars['String']>;
};

/** Describes a URL question */
export type Submission_UrlQuestion = {
  __typename?: 'Submission_UrlQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_UrlQuestionSchema;
  /** Response to the question */
  response: Submission_UrlQuestionResponse;
};

/** Response to a URL submission question */
export type Submission_UrlQuestionResponse = {
  __typename?: 'Submission_UrlQuestionResponse';
  /** Caption to describe the resource that the URL links to */
  caption: Scalars['String'];
  /** Title to describe the resource that the URL links to */
  title: Scalars['String'];
  /** URL string inputted by submitter */
  url: Scalars['String'];
};

/** Response to a URL submission question */
export type Submission_UrlQuestionResponseInput = {
  /** Caption to describe the resource that the URL links to */
  caption: Scalars['String'];
  /** Title to describe the resource that the URL links to */
  title: Scalars['String'];
  /** URL string inputted by submitter */
  url: Scalars['String'];
};

/** A URL question schema */
export type Submission_UrlQuestionSchema = {
  __typename?: 'Submission_UrlQuestionSchema';
  /** Flags to indicate whether plagiarism check is enabled for this specific question */
  plagiarismCheckStatus: Submission_QuestionPlagiarismCheckEnabledStatus;
  /** Prompt of the question */
  prompt: Submission_RichText;
};

/** Profile for an individual user */
export type Submission_UserProfile = {
  __typename?: 'Submission_UserProfile';
  /** User's email. It can be empty. */
  email?: Maybe<Scalars['String']>;
  /** Full name of the user. It can be empty. */
  fullName?: Maybe<Scalars['String']>;
  /** User id */
  id: Scalars['ID'];
  /** Url to user's profile photo. It can be empty. */
  photoUrl?: Maybe<Scalars['String']>;
  /** User's slack profile. If configured */
  slackProfile?: Maybe<Submission_SlackProfile>;
};

/** Informative warnings that we want let the learner be aware of */
export const Submission_Warning = {
  /** AI Grading is in progress */
  AiGradingInProgress: 'AI_GRADING_IN_PROGRESS',
  /** Assignment is outdated */
  AssignmentVersionOutdated: 'ASSIGNMENT_VERSION_OUTDATED',
  /** Human grading is in progress */
  GradingInProgress: 'GRADING_IN_PROGRESS'
} as const;

export type Submission_Warning = typeof Submission_Warning[keyof typeof Submission_Warning];
/** Describes a widget question. The question content is rendered using a widget session. */
export type Submission_WidgetQuestion = {
  __typename?: 'Submission_WidgetQuestion';
  /** Question grade settings */
  gradeSettings: Submission_QuestionGradeSettings;
  /** Question id */
  id: Scalars['ID'];
  /** Schema of the question */
  questionSchema: Submission_WidgetQuestionSchema;
  /** Response to the question */
  response: Submission_WidgetQuestionResponse;
};

/** Response to a widget question */
export type Submission_WidgetQuestionResponse = {
  __typename?: 'Submission_WidgetQuestionResponse';
  /** Widget question's answer could be in arbitrary shape. */
  answer: Scalars['JSON'];
};

/** Response to a widget question */
export type Submission_WidgetQuestionResponseInput = {
  /** Widget question's answer could be in arbitrary shape. */
  answer: Scalars['JSON'];
};

/** Widget question schema */
export type Submission_WidgetQuestionSchema = {
  __typename?: 'Submission_WidgetQuestionSchema';
  /** Prompt of the question */
  prompt: Submission_RichText;
  /** Session id of a widget to render the question */
  widgetSessionId: Scalars['ID'];
};

/** Root-level Subscription type */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Generic subscription for streaming AI Writing Assistant responses. At the time of writing, this feature lacks
   * well-defined product requirements and is in an exploratory prototyping phase, so the schema is deliberately designed
   * to be flexible enough to handle different use cases without requiring schema changes. It is likely that this will
   * be replaced by dedicated subscriptions for specific use cases in the future.
   */
  AiAuthoring_WritingAssistant: AiAuthoring_WritingAssistantResponse;
  /** Subscription for Coach text chat functionality. */
  AiCoach_TextStreamingChat: AiCoach_TextStreamingChatResult;
  /**
   * Subscription for tracking role play task completion status during a Coach Item session.
   * Streams updates as individual tasks are evaluated and completed by the AI coach.
   */
  CoachItem_RolePlayTaskStatus: CoachItem_RolePlayTaskStatusResponse;
  /**
   * Stream an AI-generated summary of search results. This is the streaming replacement for the
   * `summarizeSearchResults` query, allowing clients to progressively render the summary as
   * chunks arrive from the LLM.
   */
  Search_SummarizeSearchResultsStream: Search_SummaryChunk;
  /**
   * GraphQL types must include at least one field, so an empty field is defined here.
   *
   * Our gateway doesn't currently support Federated subscriptions, so this field is not marked `@shareable` like the
   * equivalent `Query` and `Mutation` fields.
   */
  _?: Maybe<Scalars['Boolean']>;
};


/** Root-level Subscription type */
export type SubscriptionAiAuthoring_WritingAssistantArgs = {
  input: AiAuthoring_WritingAssistantInput;
};


/** Root-level Subscription type */
export type SubscriptionAiCoach_TextStreamingChatArgs = {
  input: AiCoach_TextStreamingChatInput;
};


/** Root-level Subscription type */
export type SubscriptionCoachItem_RolePlayTaskStatusArgs = {
  input: CoachItem_RolePlayTaskStatusInput;
};


/** Root-level Subscription type */
export type SubscriptionSearch_SummarizeSearchResultsStreamArgs = {
  originalSearchRequest: Search_Request;
  topSearchResults: Array<Search_HitMetadataInputForSummary>;
};

export type SubscriptionTrialsV1 = {
  __typename?: 'SubscriptionTrialsV1';
  createdAt: Scalars['Float'];
  endsAt: Scalars['Float'];
  id: Scalars['String'];
  productItemId: Scalars['String'];
  productType: Scalars['String'];
  subscriptionId: Scalars['String'];
  subscriptionTrialId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type SubscriptionTrialsV1Connection = {
  __typename?: 'SubscriptionTrialsV1Connection';
  elements: Array<Maybe<SubscriptionTrialsV1>>;
  paging: ResponsePagination;
};

export type SubscriptionTrialsV1FindByUser = {
  __typename?: 'SubscriptionTrialsV1FindByUser';
  connection?: Maybe<SubscriptionTrialsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SubscriptionTrialsV1FindByUserAndProductType = {
  __typename?: 'SubscriptionTrialsV1FindByUserAndProductType';
  connection?: Maybe<SubscriptionTrialsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productType: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SubscriptionTrialsV1FindByUserAndUnderlyingProduct = {
  __typename?: 'SubscriptionTrialsV1FindByUserAndUnderlyingProduct';
  connection?: Maybe<SubscriptionTrialsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userProductItemId: Scalars['String'];
};

export type SubscriptionTrialsV1Resource = {
  __typename?: 'SubscriptionTrialsV1Resource';
  findByUser?: Maybe<SubscriptionTrialsV1Connection>;
  findByUserAndProductType?: Maybe<SubscriptionTrialsV1Connection>;
  findByUserAndUnderlyingProduct?: Maybe<SubscriptionTrialsV1Connection>;
};


export type SubscriptionTrialsV1ResourceFindByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionTrialsV1ResourceFindByUserAndProductTypeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productType: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionTrialsV1ResourceFindByUserAndUnderlyingProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userProductItemId: Scalars['String'];
};

/** Query definitions for fetching Subscription related data. */
export type SubscriptionsQueries = {
  __typename?: 'SubscriptionsQueries';
  /**
   * Fetches details of all canceled Subscriptions that are eligible for restoration to 'active' state for the logged in user.
   * In an ideal world, we'd use a Subscriptions_Subscription query to gather this information, but such a query does not yet exist.
   */
  queryMySubscriptionRestorationEligibility: Array<Subscriptions_RestorationEligibilityInfo>;
};

export type SubscriptionsV1 = {
  __typename?: 'SubscriptionsV1';
  cartId: Scalars['Float'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  nextBillingAt?: Maybe<Scalars['Float']>;
  paymentInformation: SubscriptionsV1_PaymentInformation;
  paymentProcessorId: Scalars['String'];
  productItemId: Scalars['String'];
  productSku: Scalars['String'];
  productSkuDetails?: Maybe<ProductSkusV1>;
  productType: Scalars['String'];
  startsAt: Scalars['Float'];
  status: SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus;
  subscriptionId: Scalars['String'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type SubscriptionsV1Connection = {
  __typename?: 'SubscriptionsV1Connection';
  elements: Array<Maybe<SubscriptionsV1>>;
  paging: ResponsePagination;
};

export type SubscriptionsV1FindByPaymentProcessorSubscriptionId = {
  __typename?: 'SubscriptionsV1FindByPaymentProcessorSubscriptionId';
  connection?: Maybe<SubscriptionsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  paymentProcessorId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type SubscriptionsV1FindByUser = {
  __typename?: 'SubscriptionsV1FindByUser';
  connection?: Maybe<SubscriptionsV1Connection>;
  isActive?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  paymentProcessorId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SubscriptionsV1FindByUserAndProduct = {
  __typename?: 'SubscriptionsV1FindByUserAndProduct';
  connection?: Maybe<SubscriptionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SubscriptionsV1FindWithNonFreeRecurringPayment = {
  __typename?: 'SubscriptionsV1FindWithNonFreeRecurringPayment';
  connection?: Maybe<SubscriptionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type SubscriptionsV1Me = {
  __typename?: 'SubscriptionsV1Me';
  connection?: Maybe<SubscriptionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type SubscriptionsV1MeByProductId = {
  __typename?: 'SubscriptionsV1MeByProductId';
  connection?: Maybe<SubscriptionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type SubscriptionsV1Resource = {
  __typename?: 'SubscriptionsV1Resource';
  findByPaymentProcessorSubscriptionId?: Maybe<SubscriptionsV1Connection>;
  findByUser?: Maybe<SubscriptionsV1Connection>;
  findByUserAndProduct?: Maybe<SubscriptionsV1Connection>;
  findWithNonFreeRecurringPayment?: Maybe<SubscriptionsV1Connection>;
  get?: Maybe<SubscriptionsV1>;
  me?: Maybe<SubscriptionsV1Connection>;
  meByProductId?: Maybe<SubscriptionsV1Connection>;
};


export type SubscriptionsV1ResourceFindByPaymentProcessorSubscriptionIdArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  paymentProcessorId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type SubscriptionsV1ResourceFindByUserArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  paymentProcessorId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionsV1ResourceFindByUserAndProductArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionsV1ResourceFindWithNonFreeRecurringPaymentArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type SubscriptionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type SubscriptionsV1ResourceMeByProductIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type SubscriptionsV1ResourceMutations = {
  __typename?: 'SubscriptionsV1ResourceMutations';
  applyDiscountToSubscription?: Maybe<Scalars['JSON']>;
  cancel?: Maybe<Scalars['JSON']>;
  cancelWithoutNotification?: Maybe<Scalars['JSON']>;
  create?: Maybe<SubscriptionsV1Connection>;
  createCart?: Maybe<Scalars['JSON']>;
  invalidate?: Maybe<Scalars['JSON']>;
  markAsInstallmentsComplete?: Maybe<Scalars['JSON']>;
  recomputeAndUpdateTax?: Maybe<Scalars['JSON']>;
  refund?: Maybe<Scalars['JSON']>;
  renew?: Maybe<Scalars['JSON']>;
  renewStripe?: Maybe<Scalars['JSON']>;
  revoke?: Maybe<Scalars['JSON']>;
};


export type SubscriptionsV1ResourceMutationsApplyDiscountToSubscriptionArgs = {
  id: Scalars['String'];
  promoCodeId: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsCancelArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsCancelWithoutNotificationArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsInvalidateArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsMarkAsInstallmentsCompleteArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsRecomputeAndUpdateTaxArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsRefundArgs = {
  id: Scalars['String'];
  keepMembership?: InputMaybe<Scalars['Boolean']>;
};


export type SubscriptionsV1ResourceMutationsRenewArgs = {
  id: Scalars['String'];
};


export type SubscriptionsV1ResourceMutationsRevokeArgs = {
  expireNow?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_GooglePlaySubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_GooglePlaySubscriptionPaymentInformation';
  googlePlayPurchaseToken: Scalars['String'];
  googlePlaySku: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_GooglePlaySubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_GooglePlaySubscriptionPaymentInformationMember';
  org_coursera_payment_GooglePlaySubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_GooglePlaySubscriptionPaymentInformation;
};

export type SubscriptionsV1_Org_Coursera_Payment_IapSubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_IapSubscriptionPaymentInformation';
  receipt: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_IapSubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_IapSubscriptionPaymentInformationMember';
  org_coursera_payment_IapSubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_IapSubscriptionPaymentInformation;
};

export type SubscriptionsV1_Org_Coursera_Payment_MockSubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_MockSubscriptionPaymentInformation';
  subscriptionId: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_MockSubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_MockSubscriptionPaymentInformationMember';
  org_coursera_payment_MockSubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_MockSubscriptionPaymentInformation;
};

export type SubscriptionsV1_Org_Coursera_Payment_RazorpaySubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_RazorpaySubscriptionPaymentInformation';
  isSandbox: Scalars['Boolean'];
  razorpayPaymentId?: Maybe<Scalars['String']>;
  razorpaySignature?: Maybe<Scalars['String']>;
  razorpaySubscriptionId: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_RazorpaySubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_RazorpaySubscriptionPaymentInformationMember';
  org_coursera_payment_RazorpaySubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_RazorpaySubscriptionPaymentInformation;
};

export type SubscriptionsV1_Org_Coursera_Payment_StripeSubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_StripeSubscriptionPaymentInformation';
  isSandBoxTransaction: Scalars['Boolean'];
  isStripeBv: Scalars['Boolean'];
  subscriptionId: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_StripeSubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_StripeSubscriptionPaymentInformationMember';
  org_coursera_payment_StripeSubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_StripeSubscriptionPaymentInformation;
};

export type SubscriptionsV1_Org_Coursera_Payment_StripeThirdPartySubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_StripeThirdPartySubscriptionPaymentInformation';
  isSandbox: Scalars['Boolean'];
  subscriptionId: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_StripeThirdPartySubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_StripeThirdPartySubscriptionPaymentInformationMember';
  org_coursera_payment_StripeThirdPartySubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_StripeThirdPartySubscriptionPaymentInformation;
};

export const SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  Expired: 'EXPIRED',
  FreeTrial: 'FREE_TRIAL',
  Inactive: 'INACTIVE',
  PastDue: 'PAST_DUE'
} as const;

export type SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus = typeof SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus[keyof typeof SubscriptionsV1_Org_Coursera_Payment_SubscriptionStatus];
export type SubscriptionsV1_Org_Coursera_Payment_WalletSubscriptionPaymentInformation = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_WalletSubscriptionPaymentInformation';
  paymentWalletId: Scalars['Float'];
  paymentWalletThreeDsNonce?: Maybe<Scalars['String']>;
  transactionId: Scalars['String'];
};

export type SubscriptionsV1_Org_Coursera_Payment_WalletSubscriptionPaymentInformationMember = {
  __typename?: 'SubscriptionsV1_org_coursera_payment_WalletSubscriptionPaymentInformationMember';
  org_coursera_payment_WalletSubscriptionPaymentInformation: SubscriptionsV1_Org_Coursera_Payment_WalletSubscriptionPaymentInformation;
};

export type SubscriptionsV1_PaymentInformation = SubscriptionsV1_Org_Coursera_Payment_GooglePlaySubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_IapSubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_MockSubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_RazorpaySubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_StripeSubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_StripeThirdPartySubscriptionPaymentInformationMember | SubscriptionsV1_Org_Coursera_Payment_WalletSubscriptionPaymentInformationMember;

/** Subscriptions_Cancel failure result. */
export type Subscriptions_CancelFailure = {
  __typename?: 'Subscriptions_CancelFailure';
  /** Error details. */
  errors: Array<Subscriptions_GenericError>;
};

/** Subscriptions_Cancel input. */
export type Subscriptions_CancelInput = {
  /** ID of the Subscription to cancel. */
  subscriptionId: Scalars['ID'];
};

/** Subscriptions_Cancel result. */
export type Subscriptions_CancelResult = Subscriptions_CancelFailure | Subscriptions_CancelSuccess;

/** Subscriptions_Cancel success result. */
export type Subscriptions_CancelSuccess = {
  __typename?: 'Subscriptions_CancelSuccess';
  /** The updated Subscription. */
  subscription: Subscriptions_Subscription;
};

/** Subscriptions_ConvertFreeTrialToActive failure result. */
export type Subscriptions_ConvertFreeTrialToActiveFailure = {
  __typename?: 'Subscriptions_ConvertFreeTrialToActiveFailure';
  /** Error details. */
  errors: Array<Subscriptions_GenericError>;
};

/** Subscriptions_ConvertFreeTrialToActive input. */
export type Subscriptions_ConvertFreeTrialToActiveInput = {
  /** ID of the Subscription to convert from free trial to active. */
  subscriptionId: Scalars['ID'];
};

/** Subscriptions_ConvertFreeTrialToActive result. */
export type Subscriptions_ConvertFreeTrialToActiveResult = Subscriptions_ConvertFreeTrialToActiveFailure | Subscriptions_ConvertFreeTrialToActiveSuccess;

/** Subscriptions_ConvertFreeTrialToActive success result. */
export type Subscriptions_ConvertFreeTrialToActiveSuccess = {
  __typename?: 'Subscriptions_ConvertFreeTrialToActiveSuccess';
  /** The free trial state of the Subscription, according to the payment processor. */
  isFreeTrial: Scalars['Boolean'];
  /** The Subscription's updated status, according to the payment processor. */
  processorStatus: Scalars['String'];
  /** ID of the updated Subscription. */
  subscriptionId: Scalars['ID'];
};

/**
 * The reason that this model contains (productType, subscriptionStatus, trialEndsAt) is because
 * the [2024 Q1] Block Certs in Free Trial project requires an endpoint that returns
 * the following data: (1) Whether a course is currently enrolled via a Subscription free trial, in
 * order to show the paywall, (2) Whether that free trial is for a s12n Subscription or a C+ monthly
 * subscriptions, in order to display the correct copy, (3) Whether the free trial is active or
 * cancelled, since only active free trials see the painted door modal, (4) The free trial end
 * date, to display inside the painted door modal test, and (5) The underlying product item
 * ID so that the FE can show a modal that lets the learner resubscribe to C+ or the s12n
 * sub they were previously subscribed to for the INACTIVE Subscription case.
 */
export type Subscriptions_EnrolledViaSubscriptionTrialMetadata = {
  __typename?: 'Subscriptions_EnrolledViaSubscriptionTrialMetadata';
  /**
   * The ID of the Subscription's payment processor.
   * @deprecated use `subscription: Subscriptions_Subscription` now that we have it
   */
  paymentProcessorId: Scalars['ID'];
  /**
   * The product type of the learner's Subscription.
   * @deprecated use `subscription: Subscriptions_Subscription` now that we have it
   */
  productType: Subscriptions_ProductType;
  /** The Subscription that allowed the learner to enroll into the course via free trial. */
  subscription: Subscriptions_Subscription;
  /**
   * The internal ID of the Subscription.
   * @deprecated use `subscription: Subscriptions_Subscription` now that we have it
   */
  subscriptionId: Scalars['ID'];
  /**
   * The internal status of the Subscription.
   * @deprecated use `subscription: Subscriptions_Subscription` now that we have it
   */
  subscriptionStatus: Subscriptions_SubscriptionStatus;
  /** The Timestamp of when the Subscription's free trial ends. */
  trialEndsAt: Scalars['DateTime'];
  /**
   * The underlyingProductItemId field represents the "product_item" field in the subscriptions
   * table. For the specialization Subscription case, this represents the s12nId of the specialization
   * that the learner has access to through their Subscription. For the coursera plus Subscription
   * case, this represents the underlying productItemId of the CourseraPlusSubscription product type.
   * Note that there is a bit of a mismatch between "underlyingProductItemId" and "productType".
   * The "productType" in this context maps to the product_sku_type, which would be
   * "SpecializationSubscription". The mix and match usage of "productType" and
   * "underlyingProductItemId" is a bit of a code smell that should be addressed prior to the
   * rollout of the Block Certs experiment. Jira ticket:https://coursera.atlassian.net/browse/SUBSCRIP-2786
   * @deprecated use `subscription: Subscriptions_Subscription` now that we have it
   */
  underlyingProductItemId: Scalars['ID'];
};

/** Errors from the subscriptions-application. */
export type Subscriptions_Error = {
  /** Error message. */
  message: Scalars['String'];
};

/** Generic error for the subscriptions-application. */
export type Subscriptions_GenericError = Subscriptions_Error & {
  __typename?: 'Subscriptions_GenericError';
  /** Readable message providing the error details. */
  message: Scalars['String'];
};

/** List of supported payment processors. */
export const Subscriptions_PaymentProcessor = {
  /** Apple In-App payment processor ID. */
  AppleInapp: 'APPLE_INAPP',
  /** Apple In-App sandbox payment processor ID. */
  AppleInappSandbox: 'APPLE_INAPP_SANDBOX',
  /** Braintree payment processor ID. */
  Braintree: 'BRAINTREE',
  /** Braintree sandbox payment processor ID. */
  BraintreeSandbox: 'BRAINTREE_SANDBOX',
  /** Coursera Manual payment processor ID. */
  CourseraManual: 'COURSERA_MANUAL',
  /** DLocal payment processor ID. */
  Dlocal: 'DLOCAL',
  /** DLocal sandbox payment processor ID. */
  DlocalSandbox: 'DLOCAL_SANDBOX',
  /** Ebanx payment processor ID. */
  Ebanx: 'EBANX',
  /** Ebanx sandbox payment processor ID. */
  EbanxSandbox: 'EBANX_SANDBOX',
  /** Emergent payment processor processor */
  Emergent: 'EMERGENT',
  /** Emergent sandbox payment processor */
  EmergentSandbox: 'EMERGENT_SANDBOX',
  /** Financial Aid payment processor ID. */
  FinancialAid: 'FINANCIAL_AID',
  /** Google Play payment processor ID. */
  GooglePlay: 'GOOGLE_PLAY',
  /** Google Play sandbox payment processor ID. */
  GooglePlaySandbox: 'GOOGLE_PLAY_SANDBOX',
  /** Mock payment processor ID. */
  Mock: 'MOCK',
  /** PayPal payment processor ID. */
  Paypal: 'PAYPAL',
  /** PayPal sandbox payment processor ID. */
  PaypalSandbox: 'PAYPAL_SANDBOX',
  /** Razorpay payment processor ID. */
  Razorpay: 'RAZORPAY',
  /** Razorpay Charge At Will payment processor ID. */
  RazorpayChargeAtWill: 'RAZORPAY_CHARGE_AT_WILL',
  /** Razorpay Charge At Will sandbox payment processor ID. */
  RazorpayChargeAtWillSandbox: 'RAZORPAY_CHARGE_AT_WILL_SANDBOX',
  /** Razorpay sandbox payment processor ID. */
  RazorpaySandbox: 'RAZORPAY_SANDBOX',
  /** Stripe payment processor ID. */
  Stripe: 'STRIPE',
  /** Stripe BV Consumer payment processor ID. */
  StripeBvConsumer: 'STRIPE_BV_CONSUMER',
  /** Stripe BV Consumer sandbox payment processor ID. */
  StripeBvConsumerSandbox: 'STRIPE_BV_CONSUMER_SANDBOX',
  /** Stripe Consumer payment processor ID. */
  StripeConsumer: 'STRIPE_CONSUMER',
  /** Stripe Consumer sandbox payment processor ID. */
  StripeConsumerSandbox: 'STRIPE_CONSUMER_SANDBOX',
  /** Stripe sandbox payment processor ID. */
  StripeSandbox: 'STRIPE_SANDBOX',
  /** Stripe Third Party payment processor ID. */
  StripeThirdParty: 'STRIPE_THIRD_PARTY',
  /** Stripe Third Party sandbox payment processor ID. */
  StripeThirdPartySandbox: 'STRIPE_THIRD_PARTY_SANDBOX',
  /** Zero Dollar payment processor ID. */
  Zerodollar: 'ZERODOLLAR'
} as const;

export type Subscriptions_PaymentProcessor = typeof Subscriptions_PaymentProcessor[keyof typeof Subscriptions_PaymentProcessor];
/** ProductType and productItemId wrapper fo a particular product. */
export type Subscriptions_ProductId = {
  __typename?: 'Subscriptions_ProductId';
  /** ID of the particular product. */
  productItemId: Scalars['ID'];
  /** Type of the particular product. */
  productType: Subscriptions_ProductType;
};

/**
 * Represents all subscription supported product types.
 *
 * Should map 1:1 to https://github.com/webedx-spark/infra-services/blob/19fb06e23d7c0b14ba3dc4820d66e800b9f0384c/libs/models/src/main/scala/org/coursera/product/ProductType.scala#L88
 * except the product types which are deprecated.
 */
export const Subscriptions_ProductType = {
  /** The Coursera Plus product, which gives learners full access to a subset of the Coursera catalog. */
  CourseraPlusSubscription: 'COURSERA_PLUS_SUBSCRIPTION',
  /** The Coursera Lite product, which gives limited access to a subset of the Coursera catalog. */
  CourseraTierLite: 'COURSERA_TIER_LITE',
  /** Represents the Master track product type. */
  CredentialTrackSubscription: 'CREDENTIAL_TRACK_SUBSCRIPTION',
  /**
   * A new version of CredentialTrackSubscription/CredentialTrackCourse that has different
   * revenue recognition and ownership granting logic from the original version.
   * Business logic change details:
   * https://docs.google.com/document/d/17IqYem_k70t0gJKpvCk8JbEhTyCqOSfGfb49x3HS4Hc/edit?usp=sharing
   * *\/
   */
  CredentialTrackSubscriptionV2: 'CREDENTIAL_TRACK_SUBSCRIPTION_V2',
  /**
   * Used for unexpected, deprecated, or invalid product types. In this context, an
   * "unexpected" product type falls out of the domain of subscriptions-application. Please
   * note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID',
  /** A Specialization product, which gives access to its collection of courses. */
  Specialization: 'SPECIALIZATION',
  /** A Subscription product that gives access to an s12n and its courses. */
  SpecializationSubscription: 'SPECIALIZATION_SUBSCRIPTION'
} as const;

export type Subscriptions_ProductType = typeof Subscriptions_ProductType[keyof typeof Subscriptions_ProductType];
/** Restoration eligibility info for canceled Subscriptions that can be moved back to 'active'. */
export type Subscriptions_RestorationEligibilityInfo = {
  __typename?: 'Subscriptions_RestorationEligibilityInfo';
  /** The deadline for restoring the canceled Subscription. */
  restorationEligibilityEndsAt: Scalars['DateTime'];
  /** The canceled Subscription. */
  subscription: Subscriptions_Subscription;
};

/** Subscriptions_RestoreCanceledSubscriptionFailure */
export type Subscriptions_RestoreCanceledSubscriptionFailure = {
  __typename?: 'Subscriptions_RestoreCanceledSubscriptionFailure';
  /** Error details. */
  errors: Array<Subscriptions_GenericError>;
};

/** Subscriptions_RestoreCanceledSubscriptionInput */
export type Subscriptions_RestoreCanceledSubscriptionInput = {
  /** ID of the canceled subscription to restore. */
  subscriptionId: Scalars['ID'];
};

/** Result of the restored subscription. Can be either success or failure */
export type Subscriptions_RestoreCanceledSubscriptionResult = Subscriptions_RestoreCanceledSubscriptionFailure | Subscriptions_RestoreCanceledSubscriptionSuccess;

/** Subscriptions_RestoreCanceledSubscriptionSuccess */
export type Subscriptions_RestoreCanceledSubscriptionSuccess = {
  __typename?: 'Subscriptions_RestoreCanceledSubscriptionSuccess';
  /** Details of the restored subscription with pre-cancellation status (i.e can be ACTIVE or FT) */
  subscription: Subscriptions_Subscription;
};

/** Subscription status. */
export const Subscriptions_Status = {
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  Active: 'ACTIVE',
  /** Learner maintains product ownership until the end of billing cycle after which status is INACTIVE. */
  Cancelled: 'CANCELLED',
  /**
   * Subscription has reached the specified number of billing cycles and has lapsed out of the
   * paid-through period.
   */
  Expired: 'EXPIRED',
  /** Learner has product ownership and recurring payments occur at the beginning of each billing cycle. */
  FreeTrial: 'FREE_TRIAL',
  /** Learner does not have product ownership and there is no longer a recurring payment. */
  Inactive: 'INACTIVE',
  /** Learner maintains product ownership until the end of grace period after which status is INACTIVE. */
  PastDue: 'PAST_DUE'
} as const;

export type Subscriptions_Status = typeof Subscriptions_Status[keyof typeof Subscriptions_Status];
/** A reference to internal Subscriptions_Subscription federated entity */
export type Subscriptions_Subscription = {
  __typename?: 'Subscriptions_Subscription';
  /** The ID of the Subscription. */
  id: Scalars['ID'];
  /**
   * Whether or not this Subscription is active. status=INACTIVE should accompany isActive=false. All
   * other Subscription status options are considered isActive=true. Note, though, that we've observed
   * some status=CANCELLED with isActive=false, most likely due to race conditions.
   */
  isActive: Scalars['Boolean'];
  /** The approximate time that we expect the next recurring payment to occur, if applicable. */
  nextBillingAt?: Maybe<Scalars['DateTime']>;
  /** Uses the complete legacyProductId (productType and productItemId) to federate with the ownableProductTuple. */
  ownableProductTuple: OwnableProduct_OwnableProductTuple;
  /** The payment processor that is responsible for processing this Subscription. */
  paymentProcessor: Subscriptions_PaymentProcessor;
  /** The ID of the Subscription in the payment processor's domain. */
  paymentProcessorSubscriptionId: Scalars['ID'];
  /** The ID of the payment wallet used at checkout. Not applicable to all payment processors. */
  paymentWalletId?: Maybe<Scalars['ID']>;
  /** The product ID that this Subscription is for (i.e. what was purchased); the underlying product. */
  productId: Subscriptions_ProductId;
  /** The product SKU used to check out this Subscription (i.e. how it was purchased). */
  productSku: Subscriptions_ProductId;
  /** The start time of the Subscription. */
  startsAt: Scalars['DateTime'];
  /** The status of the Subscription. */
  status: Subscriptions_Status;
};

/**
 * The internal status of the Subscription. Not all of our possible Subscription statuses are
 * listed here. Additional statuses may be added as required.
 */
export const Subscriptions_SubscriptionStatus = {
  /**
   * The Subscription has been cancelled and no new payment will be made for this Subscription.
   * One the Subscription moves past its paid up until date, it will transition to INACTIVE.
   */
  Cancelled: 'CANCELLED',
  /**
   * The Subscription is currently in a free trial period and the first payment is expected on the
   * nextBillingAt, at which case it will transition to either ACTIVE or PAST_DUE depending on
   * whether the payment was successfully pulled or not.
   */
  FreeTrial: 'FREE_TRIAL',
  /** Learner does not have product ownership and there is no longer a recurring payment. */
  Inactive: 'INACTIVE',
  /**
   * Used for unexpected, deprecated, or invalid Subscription statuses. In this context, an
   * "unexpected" Subscription status falls out of the domain of subscriptions-application. Please
   * note that this is not intended to be equivalent to INVALID in protobuf.
   */
  Invalid: 'INVALID'
} as const;

export type Subscriptions_SubscriptionStatus = typeof Subscriptions_SubscriptionStatus[keyof typeof Subscriptions_SubscriptionStatus];
/** Subtitles query namespace type */
export type SubtitlesQueries = {
  __typename?: 'SubtitlesQueries';
  /** Get a transcription workflow by ID */
  getTranscriptionWorkflow?: Maybe<Subtitles_TranscriptionWorkflow>;
  /** Get a transcription workflow by video asset ID */
  getTranscriptionWorkflowByAssetId?: Maybe<Subtitles_TranscriptionWorkflow>;
};


/** Subtitles query namespace type */
export type SubtitlesQueriesGetTranscriptionWorkflowArgs = {
  id: Scalars['ID'];
};


/** Subtitles query namespace type */
export type SubtitlesQueriesGetTranscriptionWorkflowByAssetIdArgs = {
  videoAssetId: Scalars['ID'];
};

/** Create transcription workflow input */
export type Subtitles_CreateTranscriptionWorkflowInput = {
  /** The ID of the atom that links to the video asset */
  atomId: Scalars['ID'];
  /** The ID of the video asset for which the transcription is generated */
  videoAssetId: Scalars['ID'];
};

/** Create transcription workflow result */
export type Subtitles_CreateTranscriptionWorkflowResult = TranscriptionWorkflow_MutationFailure | TranscriptionWorkflow_MutationSuccess;

/** Retry transcription workflow input */
export type Subtitles_RetryTranscriptionWorkflowInput = {
  /** The ID of the atom that links to the video asset in the workflow. */
  atomId: Scalars['ID'];
  /** Workflow ID. */
  id: Scalars['ID'];
};

/** Retry transcription workflow result */
export type Subtitles_RetryTranscriptionWorkflowResult = TranscriptionWorkflow_MutationFailure | TranscriptionWorkflow_MutationSuccess;

/** Transcription workflow schema */
export type Subtitles_TranscriptionWorkflow = {
  __typename?: 'Subtitles_TranscriptionWorkflow';
  /** Time when the workflow was initially created */
  createdAt: Scalars['DateTime'];
  /** Error message that is set if the workflow fails for any reason */
  errorMessage?: Maybe<Scalars['String']>;
  /** Workflow ID */
  id: Scalars['ID'];
  /** The language code of the created subtitle asset */
  languageCode?: Maybe<Scalars['String']>;
  /** Time when the workflow was last updated */
  lastUpdatedAt: Scalars['DateTime'];
  /** The progress of the workflow in percentage (0 - 100) */
  progressPercentage?: Maybe<Scalars['Int']>;
  /** The ID of the created subtitle asset */
  resultSubtitleAssetId?: Maybe<Scalars['String']>;
  /** Current status of the workflow */
  status: Transcription_WorkflowStatus;
  /** Auto-incremented version number used to prevent write conflicts */
  version: Scalars['Int'];
  /** The ID of the video asset for which the transcription is generated */
  videoAssetId: Scalars['ID'];
};

/** Queries for TACO configurations. */
export type TacoConfigQueries = {
  __typename?: 'TacoConfigQueries';
  /**
   * This query returns all the paramater name/value pairs for a given TACO namespace.
   * It will return null if the namespace (configuration file) does not exist.
   * It only looks in the "public" folder.
   */
  queryByNamespace?: Maybe<TacoConfig_Configuration>;
  /**
   * This query returns all the paramater name/value pairs for a given TACO "private" namespace.
   * Use this query to fetch a "private" configuration (one not in the "public" folder).
   * Power User access is required to use this query.
   * The query will return null if the namespace does not exist.
   */
  queryByPrivateNamespace?: Maybe<TacoConfig_Configuration>;
};


/** Queries for TACO configurations. */
export type TacoConfigQueriesQueryByNamespaceArgs = {
  namespace: Scalars['String'];
};


/** Queries for TACO configurations. */
export type TacoConfigQueriesQueryByPrivateNamespaceArgs = {
  namespace: Scalars['String'];
};

/**
 * This represents the contents of a TACO configuration file. The namespace is the path
 * to the configuration file in the S3 bucket. The values are the parameter names and
 * values contained in the configuration file for this namespace.
 */
export type TacoConfig_Configuration = {
  __typename?: 'TacoConfig_Configuration';
  /**
   * The namespace of the configuration. Equivalent to the path to the configuration file
   * in the S3 bucket. For a public configuration, this will always start with "public/".
   */
  namespace: Scalars['String'];
  /** The parameter names and values contained in the configuration file for this namespace. */
  values: Array<TacoConfig_Value>;
};

/** This represents a single parameter name and value in a TACO configuration file. */
export type TacoConfig_Value = {
  __typename?: 'TacoConfig_Value';
  /** The paramater name. */
  parameter: Scalars['String'];
  /** The value for the parameter, as an arbitrary JSON value (or null). */
  value?: Maybe<Scalars['JSON']>;
};

export type TargetSkillProfileUserStatesV1 = {
  __typename?: 'TargetSkillProfileUserStatesV1';
  createdAt: Scalars['Float'];
  id: Scalars['String'];
  state: TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState;
  targetSkillProfile?: Maybe<EnterpriseTargetSkillProfilesV1>;
  targetSkillProfileId: Scalars['String'];
  targetSkillProfileSummary?: Maybe<EnterpriseTargetSkillProfileSummariesV1>;
  thirdPartyOrganizationId: Scalars['String'];
  updatedAt: Scalars['Float'];
  /** id for a Coursera user */
  userId: Scalars['Int'];
};


export type TargetSkillProfileUserStatesV1TargetSkillProfileSummaryArgs = {
  showNumberOfCourses?: InputMaybe<Scalars['Boolean']>;
};

export type TargetSkillProfileUserStatesV1ByUserAndProgram = {
  __typename?: 'TargetSkillProfileUserStatesV1ByUserAndProgram';
  connection?: Maybe<TargetSkillProfileUserStatesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TargetSkillProfileUserStatesV1Connection = {
  __typename?: 'TargetSkillProfileUserStatesV1Connection';
  elements: Array<Maybe<TargetSkillProfileUserStatesV1>>;
  paging: ResponsePagination;
};

export type TargetSkillProfileUserStatesV1Resource = {
  __typename?: 'TargetSkillProfileUserStatesV1Resource';
  byUserAndProgram?: Maybe<TargetSkillProfileUserStatesV1Connection>;
  get?: Maybe<TargetSkillProfileUserStatesV1>;
  multiGet?: Maybe<TargetSkillProfileUserStatesV1Connection>;
};


export type TargetSkillProfileUserStatesV1ResourceByUserAndProgramArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  programId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TargetSkillProfileUserStatesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TargetSkillProfileUserStatesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TargetSkillProfileUserStatesV1ResourceMutations = {
  __typename?: 'TargetSkillProfileUserStatesV1ResourceMutations';
  set?: Maybe<Scalars['JSON']>;
};

export const TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState = {
  Deleted: 'DELETED',
  Dismissed: 'DISMISSED',
  Saved: 'SAVED',
  Unsaved: 'UNSAVED'
} as const;

export type TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState = typeof TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState[keyof typeof TargetSkillProfileUserStatesV1_Org_Coursera_Enterprise_Skills_TargetSkillProfileUserGoalState];
/** Query definitions for querying Targeting Rules. */
export type TargetingRuleQueries = {
  __typename?: 'TargetingRuleQueries';
  /** Returns all non-archived Targeting Rules. | Maximum page size: 500 */
  queryAll: Targeting_TargetingRuleConnection;
};


/** Query definitions for querying Targeting Rules. */
export type TargetingRuleQueriesQueryAllArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: Scalars['Int'];
};

/**
 * A Targeting Rule.
 * TODO: Add nostos rules and any match rules
 */
export type Targeting_TargetingRule = Node & {
  __typename?: 'Targeting_TargetingRule';
  /** DateTime the Targeting Rule was created. */
  createdAt: Scalars['DateTime'];
  /** The email of the user who created the Targeting Rule */
  creator: Scalars['String'];
  /** A description of the Targeting Rule */
  description: Scalars['String'];
  /** The ID of the Targeting Rule */
  id: Scalars['ID'];
  /** Flag indicating if the Targeting Rule is archived. If true, the Targeting Rule is no longer in use. */
  isArchived: Scalars['Boolean'];
  /** The email of the user who last modified the Targeting Rule. */
  modifiedBy: Scalars['String'];
  /** The title of the Targeting Rule */
  title: Scalars['String'];
  /** DateTime the Targeting Rule was last modified. */
  updatedAt: Scalars['DateTime'];
};

/** Connection containing Targeting Rules and page metadata. */
export type Targeting_TargetingRuleConnection = {
  __typename?: 'Targeting_TargetingRuleConnection';
  /** The Targeting Rules in this connection. */
  edges: Array<Targeting_TargetingRuleEdge>;
  /** The page metadata for this connection. */
  pageInfo: PageInfo;
  /** The total number of edges in the query. */
  totalEdges?: Maybe<Scalars['Int']>;
};

/** Edge for Targeting Rule */
export type Targeting_TargetingRuleEdge = {
  __typename?: 'Targeting_TargetingRuleEdge';
  /** The cursor for the Targeting Rule contained in this edge. */
  cursor: Scalars['String'];
  /** The Targeting Rule contained in this edge. */
  node: Targeting_TargetingRule;
};

export type TaxEstimatesV2 = {
  __typename?: 'TaxEstimatesV2';
  countryCode: Scalars['String'];
  id: Scalars['String'];
  productId: TaxEstimatesV2_Org_Coursera_Product_ProductId;
  taxAmount: Scalars['String'];
  taxBehavior: TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior;
  taxRate: Scalars['String'];
  taxRateForExclusiveTax: Scalars['String'];
  totalAmountWithTax: Scalars['String'];
  transactionAmount: Scalars['String'];
  userId: Scalars['Int'];
};

export type TaxEstimatesV2Connection = {
  __typename?: 'TaxEstimatesV2Connection';
  elements: Array<Maybe<TaxEstimatesV2>>;
  paging: ResponsePagination;
};

export type TaxEstimatesV2Resource = {
  __typename?: 'TaxEstimatesV2Resource';
  get?: Maybe<TaxEstimatesV2>;
  multiGet?: Maybe<TaxEstimatesV2Connection>;
};


export type TaxEstimatesV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type TaxEstimatesV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior = {
  Exclusive: 'EXCLUSIVE',
  Inclusive: 'INCLUSIVE',
  NotCharged: 'NOT_CHARGED'
} as const;

export type TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior = typeof TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior[keyof typeof TaxEstimatesV2_Org_Coursera_Payment_Tax_TaxBehavior];
export type TaxEstimatesV2_Org_Coursera_Product_ProductId = {
  __typename?: 'TaxEstimatesV2_org_coursera_product_ProductId';
  productItemId: Scalars['String'];
};

export type TeammateReviewAssessmentsV2 = {
  __typename?: 'TeammateReviewAssessmentsV2';
  id: Scalars['String'];
  staffEvaluationInstructions: TeammateReviewAssessmentsV2_StaffEvaluationInstructions;
  staffEvaluationMaxScore: Scalars['String'];
  staffEvaluationQuestions: Array<Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_ReviewPartSchema>>;
  teammateReviewInstructions: TeammateReviewAssessmentsV2_CmlMember;
  teammateReviewQuestions: Array<Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_ReviewPartSchema>>;
  wrapped: TeammateReviewAssessmentsV2_Org_Coursera_Common_Versioned;
};

export type TeammateReviewAssessmentsV2Connection = {
  __typename?: 'TeammateReviewAssessmentsV2Connection';
  elements: Array<Maybe<TeammateReviewAssessmentsV2>>;
  paging: ResponsePagination;
};

export type TeammateReviewAssessmentsV2Latest = {
  __typename?: 'TeammateReviewAssessmentsV2Latest';
  connection?: Maybe<TeammateReviewAssessmentsV2Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type TeammateReviewAssessmentsV2Resource = {
  __typename?: 'TeammateReviewAssessmentsV2Resource';
  get?: Maybe<TeammateReviewAssessmentsV2>;
  latest?: Maybe<TeammateReviewAssessmentsV2Connection>;
  multiGet?: Maybe<TeammateReviewAssessmentsV2Connection>;
};


export type TeammateReviewAssessmentsV2ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeammateReviewAssessmentsV2ResourceLatestArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeammateReviewAssessmentsV2ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeammateReviewAssessmentsV2ResourceMutations = {
  __typename?: 'TeammateReviewAssessmentsV2ResourceMutations';
  create?: Maybe<TeammateReviewAssessmentsV2Connection>;
  update?: Maybe<TeammateReviewAssessmentsV2Connection>;
};


export type TeammateReviewAssessmentsV2ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_AiAuthorMember = {
  __typename?: 'TeammateReviewAssessmentsV2_aiAuthorMember';
  aiAuthor: TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_AiAuthor;
};

export type TeammateReviewAssessmentsV2_BoxViewDocumentAnnotationMember = {
  __typename?: 'TeammateReviewAssessmentsV2_boxViewDocumentAnnotationMember';
  boxViewDocumentAnnotation: TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_BoxViewDocumentAnnotationSchema;
};

export type TeammateReviewAssessmentsV2_CmlMember = {
  __typename?: 'TeammateReviewAssessmentsV2_cmlMember';
  cml: TeammateReviewAssessmentsV2_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type TeammateReviewAssessmentsV2_CreatedBy = TeammateReviewAssessmentsV2_AiAuthorMember | TeammateReviewAssessmentsV2_HumanAuthorMember;

export type TeammateReviewAssessmentsV2_Details = TeammateReviewAssessmentsV2_BoxViewDocumentAnnotationMember | TeammateReviewAssessmentsV2_MultiLineInputMember | TeammateReviewAssessmentsV2_OptionsMember | TeammateReviewAssessmentsV2_SingleLineInputMember | TeammateReviewAssessmentsV2_YesNoMember;

/** the pegasus schema for org.coursera.ondemand.content.Content. See https://phabricator.dkandu.me/D22517 */
export type TeammateReviewAssessmentsV2_Display = TeammateReviewAssessmentsV2_CmlMember | TeammateReviewAssessmentsV2_HtmlMember;

export type TeammateReviewAssessmentsV2_HtmlMember = {
  __typename?: 'TeammateReviewAssessmentsV2_htmlMember';
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  html: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_HumanAuthorMember = {
  __typename?: 'TeammateReviewAssessmentsV2_humanAuthorMember';
  humanAuthor: TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_HumanAuthor;
};

export type TeammateReviewAssessmentsV2_MultiLineInputMember = {
  __typename?: 'TeammateReviewAssessmentsV2_multiLineInputMember';
  multiLineInput: TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_MultiLineReviewSchema;
};

export type TeammateReviewAssessmentsV2_OptionsMember = {
  __typename?: 'TeammateReviewAssessmentsV2_optionsMember';
  options: TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_OptionsReviewSchema;
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_AiAuthor = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_authoring_assignment_AIAuthor';
  aiGenerationJobId: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_HumanAuthor = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_authoring_assignment_HumanAuthor';
  ArbitraryField: Scalars['String'];
};

export const TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = {
  Ai: 'AI',
  Auto: 'AUTO',
  Human: 'HUMAN'
} as const;

export type TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType = typeof TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType[keyof typeof TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType];
/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type TeammateReviewAssessmentsV2_Org_Coursera_Cml_AssetData = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Cml_SubtitleTrack>>;
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: TeammateReviewAssessmentsV2_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type TeammateReviewAssessmentsV2_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Common_Versioned = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_common_Versioned';
  obj: Scalars['String'];
  version: Scalars['Int'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type TeammateReviewAssessmentsV2_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_BoxViewDocumentAnnotationSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_BoxViewDocumentAnnotationSchema';
  ArbitraryField: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_MultiLineReviewSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_MultiLineReviewSchema';
  points?: Maybe<Scalars['Float']>;
};

/** `points` are the points awarded for this option. If `isScored` is true in the schema, then `points` must be present. Otherwise, `points` must not be present. Notice that these are named `points` instead of `score` to distinguish them from scores which are the points that a particular user earns from a particular review. */
export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_OptionsOption = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_OptionsOption';
  display: TeammateReviewAssessmentsV2_Display;
  id: Scalars['String'];
  points?: Maybe<Scalars['Float']>;
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_OptionsReviewSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_OptionsReviewSchema';
  isScored: Scalars['Boolean'];
  options: Array<Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_OptionsOption>>;
};

/** Note: This schema should remain in sync with org.coursera.assignment.assemblerfixes.ReviewPartSchema. */
export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_ReviewPartSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_ReviewPartSchema';
  createdBy?: Maybe<TeammateReviewAssessmentsV2_CreatedBy>;
  details: TeammateReviewAssessmentsV2_Details;
  graderType: TeammateReviewAssessmentsV2_Org_Coursera_Authoring_Assignment_Manualgraded_GraderType;
  id: Scalars['String'];
  prompt: TeammateReviewAssessmentsV2_Prompt;
  submissionPartId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<TeammateReviewAssessmentsV2_UpdatedBy>;
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_SingleLineReviewSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_SingleLineReviewSchema';
  ArbitraryField: Scalars['String'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_YesNoPoints = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_YesNoPoints';
  no: Scalars['Float'];
  yes: Scalars['Float'];
};

export type TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_YesNoReviewSchema = {
  __typename?: 'TeammateReviewAssessmentsV2_org_coursera_project_review_YesNoReviewSchema';
  points?: Maybe<TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_YesNoPoints>;
};

export type TeammateReviewAssessmentsV2_Prompt = TeammateReviewAssessmentsV2_CmlMember | TeammateReviewAssessmentsV2_HtmlMember;

export type TeammateReviewAssessmentsV2_SingleLineInputMember = {
  __typename?: 'TeammateReviewAssessmentsV2_singleLineInputMember';
  singleLineInput: TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_SingleLineReviewSchema;
};

export type TeammateReviewAssessmentsV2_StaffEvaluationInstructions = DummyType | TeammateReviewAssessmentsV2_CmlMember;

export type TeammateReviewAssessmentsV2_UpdatedBy = TeammateReviewAssessmentsV2_AiAuthorMember | TeammateReviewAssessmentsV2_HumanAuthorMember;

export type TeammateReviewAssessmentsV2_YesNoMember = {
  __typename?: 'TeammateReviewAssessmentsV2_yesNoMember';
  yesNo: TeammateReviewAssessmentsV2_Org_Coursera_Project_Review_YesNoReviewSchema;
};

export type TeammateReviewDraftsV1 = {
  __typename?: 'TeammateReviewDraftsV1';
  errors: Scalars['JSON'];
  id: Scalars['String'];
  isSubmitted: Scalars['Boolean'];
  review: Scalars['JSON'];
  /** id for a Coursera user */
  revieweeId: Scalars['Int'];
  /** id for a Coursera user */
  reviewerId: Scalars['Int'];
  updatedAt: Scalars['Float'];
};

export type TeammateReviewDraftsV1ByReviewee = {
  __typename?: 'TeammateReviewDraftsV1ByReviewee';
  assessmentId: Scalars['String'];
  connection?: Maybe<TeammateReviewDraftsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeammateReviewDraftsV1Connection = {
  __typename?: 'TeammateReviewDraftsV1Connection';
  elements: Array<Maybe<TeammateReviewDraftsV1>>;
  paging: ResponsePagination;
};

export type TeammateReviewDraftsV1Resource = {
  __typename?: 'TeammateReviewDraftsV1Resource';
  byReviewee?: Maybe<TeammateReviewDraftsV1Connection>;
  get?: Maybe<TeammateReviewDraftsV1>;
  multiGet?: Maybe<TeammateReviewDraftsV1Connection>;
};


export type TeammateReviewDraftsV1ResourceByRevieweeArgs = {
  assessmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeammateReviewDraftsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeammateReviewDraftsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeammateReviewDraftsV1ResourceMutations = {
  __typename?: 'TeammateReviewDraftsV1ResourceMutations';
  delete?: Maybe<TeammateReviewDraftsV1Connection>;
};


export type TeammateReviewDraftsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};

export type TeammateReviewStaffReviewDraftsV1 = {
  __typename?: 'TeammateReviewStaffReviewDraftsV1';
  assessment?: Maybe<TeammateReviewAssessmentsV2>;
  assessmentId: Scalars['String'];
  errors: Scalars['JSON'];
  id: Scalars['String'];
  isSubmitted: Scalars['Boolean'];
  review: Scalars['JSON'];
  /** id for a Coursera user */
  revieweeId: Scalars['Int'];
  /** id for a Coursera user */
  reviewerId: Scalars['Int'];
  score: Scalars['String'];
  staff?: Maybe<UsersV1>;
  /** id for a Coursera user */
  staffId?: Maybe<Scalars['Int']>;
  /** We used to have a lot of different models for conflict metadata accross the Authoring service. The FE doesn't need to know what fields are in conflict metadata because it is only useful for conflict detection. Therefore, to unify the behavior we encrypt all different types of conflict metadata into a string ((see [[WriteAccessTokenEncrypter]])), namely WriteAccessToken, and return it to the FE. If we don't want to grant write access to the FE, we would just not return the field. WriteAccessToken serves 2 purposes: write access control and conflict detection. */
  staffReviewWriteAccessToken: Scalars['String'];
  updatedAt: Scalars['Float'];
};


export type TeammateReviewStaffReviewDraftsV1StaffArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TeammateReviewStaffReviewDraftsV1ByReviewee = {
  __typename?: 'TeammateReviewStaffReviewDraftsV1ByReviewee';
  assessmentId: Scalars['String'];
  connection?: Maybe<TeammateReviewStaffReviewDraftsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeammateReviewStaffReviewDraftsV1Connection = {
  __typename?: 'TeammateReviewStaffReviewDraftsV1Connection';
  elements: Array<Maybe<TeammateReviewStaffReviewDraftsV1>>;
  paging: ResponsePagination;
};

export type TeammateReviewStaffReviewDraftsV1Resource = {
  __typename?: 'TeammateReviewStaffReviewDraftsV1Resource';
  byReviewee?: Maybe<TeammateReviewStaffReviewDraftsV1Connection>;
  get?: Maybe<TeammateReviewStaffReviewDraftsV1>;
  multiGet?: Maybe<TeammateReviewStaffReviewDraftsV1Connection>;
};


export type TeammateReviewStaffReviewDraftsV1ResourceByRevieweeArgs = {
  assessmentId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeammateReviewStaffReviewDraftsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeammateReviewStaffReviewDraftsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeammateReviewStaffReviewDraftsV1ResourceMutations = {
  __typename?: 'TeammateReviewStaffReviewDraftsV1ResourceMutations';
  allByRevieweeAndAssessment?: Maybe<Scalars['JSON']>;
  delete?: Maybe<TeammateReviewStaffReviewDraftsV1Connection>;
  revertSoftDelete?: Maybe<Scalars['JSON']>;
  softDelete?: Maybe<Scalars['JSON']>;
};


export type TeammateReviewStaffReviewDraftsV1ResourceMutationsAllByRevieweeAndAssessmentArgs = {
  assessmentId: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


export type TeammateReviewStaffReviewDraftsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type TeammateReviewStaffReviewDraftsV1ResourceMutationsRevertSoftDeleteArgs = {
  id: Scalars['String'];
};


export type TeammateReviewStaffReviewDraftsV1ResourceMutationsSoftDeleteArgs = {
  id: Scalars['String'];
};

export type TeammateReviewSubmittedStaffReviewsV1 = {
  __typename?: 'TeammateReviewSubmittedStaffReviewsV1';
  assessment?: Maybe<TeammateReviewAssessmentsV2>;
  assessmentId: Scalars['String'];
  id: Scalars['String'];
  review: Scalars['JSON'];
  /** id for a Coursera user */
  revieweeId: Scalars['Int'];
  /** id for a Coursera user */
  reviewerId: Scalars['Int'];
  score: Scalars['String'];
  /** id for a Coursera user */
  staffId?: Maybe<Scalars['Int']>;
  /** We used to have a lot of different models for conflict metadata accross the Authoring service. The FE doesn't need to know what fields are in conflict metadata because it is only useful for conflict detection. Therefore, to unify the behavior we encrypt all different types of conflict metadata into a string ((see [[WriteAccessTokenEncrypter]])), namely WriteAccessToken, and return it to the FE. If we don't want to grant write access to the FE, we would just not return the field. WriteAccessToken serves 2 purposes: write access control and conflict detection. */
  staffReviewWriteAccessToken: Scalars['String'];
};

export type TeammateReviewSubmittedStaffReviewsV1Connection = {
  __typename?: 'TeammateReviewSubmittedStaffReviewsV1Connection';
  elements: Array<Maybe<TeammateReviewSubmittedStaffReviewsV1>>;
  paging: ResponsePagination;
};

export type TeammateReviewSubmittedStaffReviewsV1Resource = {
  __typename?: 'TeammateReviewSubmittedStaffReviewsV1Resource';
  get?: Maybe<TeammateReviewSubmittedStaffReviewsV1>;
  multiGet?: Maybe<TeammateReviewSubmittedStaffReviewsV1Connection>;
};


export type TeammateReviewSubmittedStaffReviewsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeammateReviewSubmittedStaffReviewsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkActivitiesV1 = {
  __typename?: 'TeamworkActivitiesV1';
  createdAt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  details: TeamworkActivitiesV1_Details;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
};

export type TeamworkActivitiesV1Connection = {
  __typename?: 'TeamworkActivitiesV1Connection';
  elements: Array<Maybe<TeamworkActivitiesV1>>;
  paging: ResponsePagination;
};

export type TeamworkActivitiesV1Resource = {
  __typename?: 'TeamworkActivitiesV1Resource';
  get?: Maybe<TeamworkActivitiesV1>;
  multiGet?: Maybe<TeamworkActivitiesV1Connection>;
};


export type TeamworkActivitiesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkActivitiesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkActivitiesV1_Item_DiscussionMember = {
  __typename?: 'TeamworkActivitiesV1_ITEM_DISCUSSIONMember';
  ITEM_DISCUSSION: TeamworkActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails;
};

export type TeamworkActivitiesV1_Item_SubmissionMember = {
  __typename?: 'TeamworkActivitiesV1_ITEM_SUBMISSIONMember';
  ITEM_SUBMISSION: TeamworkActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails;
};

export type TeamworkActivitiesV1_Practice_Item_SubmissionMember = {
  __typename?: 'TeamworkActivitiesV1_PRACTICE_ITEM_SUBMISSIONMember';
  PRACTICE_ITEM_SUBMISSION: TeamworkActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails;
};

export type TeamworkActivitiesV1_Standalone_DiscussionMember = {
  __typename?: 'TeamworkActivitiesV1_STANDALONE_DISCUSSIONMember';
  STANDALONE_DISCUSSION: TeamworkActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails;
};

export type TeamworkActivitiesV1_Teammate_ReviewMember = {
  __typename?: 'TeamworkActivitiesV1_TEAMMATE_REVIEWMember';
  TEAMMATE_REVIEW: TeamworkActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails;
};

export type TeamworkActivitiesV1_Details = TeamworkActivitiesV1_Item_DiscussionMember | TeamworkActivitiesV1_Item_SubmissionMember | TeamworkActivitiesV1_Practice_Item_SubmissionMember | TeamworkActivitiesV1_Standalone_DiscussionMember | TeamworkActivitiesV1_Teammate_ReviewMember;

export type TeamworkActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionActivityDetails = {
  __typename?: 'TeamworkActivitiesV1_org_coursera_teamwork_ItemDiscussionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type TeamworkActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionActivityDetails = {
  __typename?: 'TeamworkActivitiesV1_org_coursera_teamwork_ItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type TeamworkActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionActivityDetails = {
  __typename?: 'TeamworkActivitiesV1_org_coursera_teamwork_PracticeItemSubmissionActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type TeamworkActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionActivityDetails = {
  __typename?: 'TeamworkActivitiesV1_org_coursera_teamwork_StandaloneDiscussionActivityDetails';
  ArbitraryField: Scalars['String'];
};

export type TeamworkActivitiesV1_Org_Coursera_Teamwork_TeammateReviewActivityDetails = {
  __typename?: 'TeamworkActivitiesV1_org_coursera_teamwork_TeammateReviewActivityDetails';
  /** Identifier for an item. This will never change and is unique within the course. */
  itemId: Scalars['String'];
};

export type TeamworkActivitySetsV1 = {
  __typename?: 'TeamworkActivitySetsV1';
  activities?: Maybe<TeamworkActivitiesV1Connection>;
  activityIds: Array<Maybe<Scalars['String']>>;
  createdAt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  teamIds: Array<Maybe<Scalars['String']>>;
  teams?: Maybe<TeamworkTeamsV1Connection>;
  updatedAt?: Maybe<Scalars['Float']>;
};


export type TeamworkActivitySetsV1ActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkActivitySetsV1TeamsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkActivitySetsV1Connection = {
  __typename?: 'TeamworkActivitySetsV1Connection';
  elements: Array<Maybe<TeamworkActivitySetsV1>>;
  paging: ResponsePagination;
};

export type TeamworkActivitySetsV1Resource = {
  __typename?: 'TeamworkActivitySetsV1Resource';
  get?: Maybe<TeamworkActivitySetsV1>;
  multiGet?: Maybe<TeamworkActivitySetsV1Connection>;
};


export type TeamworkActivitySetsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkActivitySetsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkLearnerTeamActivitiesV1 = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1';
  activity?: Maybe<TeamworkActivitiesV1>;
  activitySet?: Maybe<TeamworkActivitySetsV1>;
  courseId: Scalars['String'];
  details: TeamworkLearnerTeamActivitiesV1_Details;
  id: Scalars['String'];
  scopedActivityId: Scalars['String'];
  scopedActivitySetId: Scalars['String'];
  scopedTeamActivityId: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ScopedTeamActivityId;
  scopedVersionedTeamId: Scalars['String'];
  team?: Maybe<TeamworkTeamsV1>;
  userId: Scalars['Int'];
};

export type TeamworkLearnerTeamActivitiesV1ByUserCourseScopedTeamActivityIds = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1ByUserCourseScopedTeamActivityIds';
  connection?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopedTeamActivityIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitiesV1Connection = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1Connection';
  elements: Array<Maybe<TeamworkLearnerTeamActivitiesV1>>;
  paging: ResponsePagination;
};

export type TeamworkLearnerTeamActivitiesV1Resource = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1Resource';
  byUserCourseScopedTeamActivityIds?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  get?: Maybe<TeamworkLearnerTeamActivitiesV1>;
  multiGet?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  scopeUser?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  userCourseItem?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
};


export type TeamworkLearnerTeamActivitiesV1ResourceByUserCourseScopedTeamActivityIdsArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopedTeamActivityIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkLearnerTeamActivitiesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkLearnerTeamActivitiesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkLearnerTeamActivitiesV1ResourceScopeUserArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkLearnerTeamActivitiesV1ResourceUserCourseItemArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitiesV1ScopeUser = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1ScopeUser';
  connection?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitiesV1UserCourseItem = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1UserCourseItem';
  connection?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitiesV1_Item_DiscussionMember = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_ITEM_DISCUSSIONMember';
  ITEM_DISCUSSION: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionTeamActivityDetails;
};

export type TeamworkLearnerTeamActivitiesV1_Item_SubmissionMember = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_ITEM_SUBMISSIONMember';
  ITEM_SUBMISSION: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionTeamActivityDetails;
};

export type TeamworkLearnerTeamActivitiesV1_Practice_Item_SubmissionMember = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_PRACTICE_ITEM_SUBMISSIONMember';
  PRACTICE_ITEM_SUBMISSION: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionTeamActivityDetails;
};

export type TeamworkLearnerTeamActivitiesV1_Standalone_DiscussionMember = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_STANDALONE_DISCUSSIONMember';
  STANDALONE_DISCUSSION: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionTeamActivityDetails;
};

export type TeamworkLearnerTeamActivitiesV1_Teammate_ReviewMember = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_TEAMMATE_REVIEWMember';
  TEAMMATE_REVIEW: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_TeammateReviewTeamActivityDetails;
};

export type TeamworkLearnerTeamActivitiesV1_Details = TeamworkLearnerTeamActivitiesV1_Item_DiscussionMember | TeamworkLearnerTeamActivitiesV1_Item_SubmissionMember | TeamworkLearnerTeamActivitiesV1_Practice_Item_SubmissionMember | TeamworkLearnerTeamActivitiesV1_Standalone_DiscussionMember | TeamworkLearnerTeamActivitiesV1_Teammate_ReviewMember;

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ItemDiscussionTeamActivityDetails = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_ItemDiscussionTeamActivityDetails';
  slackGroupId?: Maybe<Scalars['String']>;
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ItemSubmissionTeamActivityDetails = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_ItemSubmissionTeamActivityDetails';
  teamVersionLocked: Scalars['Boolean'];
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_PracticeItemSubmissionTeamActivityDetails = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_PracticeItemSubmissionTeamActivityDetails';
  teamVersionLocked: Scalars['Boolean'];
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_ScopedTeamActivityId = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_ScopedTeamActivityId';
  teamActivityId: TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_TeamActivityId;
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_StandaloneDiscussionTeamActivityDetails = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_StandaloneDiscussionTeamActivityDetails';
  slackGroupId?: Maybe<Scalars['String']>;
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_TeamActivityId = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_TeamActivityId';
  ArbitraryField: Scalars['String'];
};

export type TeamworkLearnerTeamActivitiesV1_Org_Coursera_Teamwork_TeammateReviewTeamActivityDetails = {
  __typename?: 'TeamworkLearnerTeamActivitiesV1_org_coursera_teamwork_TeammateReviewTeamActivityDetails';
  teamVersionLocked: Scalars['Boolean'];
};

export type TeamworkLearnerTeamActivitySetsV1 = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1';
  activitySet?: Maybe<TeamworkActivitySetsV1>;
  courseId: Scalars['String'];
  currentTeam?: Maybe<TeamworkTeamsV1>;
  id: Scalars['String'];
  scopedActivitySetId: Scalars['String'];
  scopedTeamActivityIds: Array<Maybe<Scalars['String']>>;
  scopedTeamActivitySetId: TeamworkLearnerTeamActivitySetsV1_Org_Coursera_Teamwork_ScopedTeamActivitySetId;
  scopedTeamId: Scalars['String'];
  teamActivities?: Maybe<TeamworkLearnerTeamActivitiesV1Connection>;
  userId: Scalars['Int'];
};


export type TeamworkLearnerTeamActivitySetsV1TeamActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkLearnerTeamActivitySetsV1Connection = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1Connection';
  elements: Array<Maybe<TeamworkLearnerTeamActivitySetsV1>>;
  paging: ResponsePagination;
};

export type TeamworkLearnerTeamActivitySetsV1Resource = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1Resource';
  get?: Maybe<TeamworkLearnerTeamActivitySetsV1>;
  multiGet?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  userCourse?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  userCourseCompatibilityTeam?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  userCourseItem?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  userCourseTeam?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
};


export type TeamworkLearnerTeamActivitySetsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkLearnerTeamActivitySetsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkLearnerTeamActivitySetsV1ResourceUserCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkLearnerTeamActivitySetsV1ResourceUserCourseCompatibilityTeamArgs = {
  compatibilityVersionedTeamId: Scalars['String'];
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkLearnerTeamActivitySetsV1ResourceUserCourseItemArgs = {
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkLearnerTeamActivitySetsV1ResourceUserCourseTeamArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopedVersionedTeamId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitySetsV1UserCourse = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1UserCourse';
  connection?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitySetsV1UserCourseCompatibilityTeam = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1UserCourseCompatibilityTeam';
  compatibilityVersionedTeamId: Scalars['String'];
  connection?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitySetsV1UserCourseItem = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1UserCourseItem';
  connection?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  courseId: Scalars['String'];
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitySetsV1UserCourseTeam = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1UserCourseTeam';
  connection?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopedVersionedTeamId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamActivitySetsV1_Org_Coursera_Teamwork_ScopedTeamActivitySetId = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1_org_coursera_teamwork_ScopedTeamActivitySetId';
  teamActivitySetId: TeamworkLearnerTeamActivitySetsV1_Org_Coursera_Teamwork_TeamActivitySetId;
};

export type TeamworkLearnerTeamActivitySetsV1_Org_Coursera_Teamwork_TeamActivitySetId = {
  __typename?: 'TeamworkLearnerTeamActivitySetsV1_org_coursera_teamwork_TeamActivitySetId';
  ArbitraryField: Scalars['String'];
};

export type TeamworkLearnerTeamsV1 = {
  __typename?: 'TeamworkLearnerTeamsV1';
  activitySets?: Maybe<TeamworkLearnerTeamActivitySetsV1Connection>;
  courseId: Scalars['String'];
  createdAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  memberProfiles?: Maybe<TeamworkUserProfilesV1Connection>;
  members: Array<Maybe<Scalars['Int']>>;
  name: Scalars['String'];
  scopedVersionedTeamId: Scalars['String'];
  slackIntegrationMetadata?: Maybe<TeamworkLearnerTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata>;
  updatedAt?: Maybe<Scalars['Float']>;
  userId: Scalars['Int'];
};


export type TeamworkLearnerTeamsV1ActivitySetsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkLearnerTeamsV1MemberProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkLearnerTeamsV1Connection = {
  __typename?: 'TeamworkLearnerTeamsV1Connection';
  elements: Array<Maybe<TeamworkLearnerTeamsV1>>;
  paging: ResponsePagination;
};

export type TeamworkLearnerTeamsV1Resource = {
  __typename?: 'TeamworkLearnerTeamsV1Resource';
  get?: Maybe<TeamworkLearnerTeamsV1>;
  multiGet?: Maybe<TeamworkLearnerTeamsV1Connection>;
  userCourse?: Maybe<TeamworkLearnerTeamsV1Connection>;
};


export type TeamworkLearnerTeamsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkLearnerTeamsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkLearnerTeamsV1ResourceUserCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamsV1UserCourse = {
  __typename?: 'TeamworkLearnerTeamsV1UserCourse';
  connection?: Maybe<TeamworkLearnerTeamsV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkLearnerTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata = {
  __typename?: 'TeamworkLearnerTeamsV1_org_coursera_teamwork_SlackIntegrationMetadata';
  slackGroupId: Scalars['String'];
  slackTeamDomain?: Maybe<Scalars['String']>;
  slackTeamId: Scalars['String'];
};

export type TeamworkTeamsV1 = {
  __typename?: 'TeamworkTeamsV1';
  createdAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  memberProfiles?: Maybe<TeamworkUserProfilesV1Connection>;
  members: Array<Maybe<Scalars['Int']>>;
  name: Scalars['String'];
  slackIntegrationMetadata?: Maybe<TeamworkTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata>;
  updatedAt?: Maybe<Scalars['Float']>;
  versionedTeamId: Scalars['String'];
};


export type TeamworkTeamsV1MemberProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkTeamsV1AllAssignedByScope = {
  __typename?: 'TeamworkTeamsV1AllAssignedByScope';
  connection?: Maybe<TeamworkTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkTeamsV1ByScopeActivityType = {
  __typename?: 'TeamworkTeamsV1ByScopeActivityType';
  activityType: Scalars['String'];
  connection?: Maybe<TeamworkTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkTeamsV1ByScopeActivityTypeItem = {
  __typename?: 'TeamworkTeamsV1ByScopeActivityTypeItem';
  activityType: Scalars['String'];
  connection?: Maybe<TeamworkTeamsV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkTeamsV1ByScopeTeamActivityTypeItem = {
  __typename?: 'TeamworkTeamsV1ByScopeTeamActivityTypeItem';
  activityType: Scalars['String'];
  connection?: Maybe<TeamworkTeamsV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamworkTeamsV1ByScopeTeamItem = {
  __typename?: 'TeamworkTeamsV1ByScopeTeamItem';
  connection?: Maybe<TeamworkTeamsV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  teamId: Scalars['String'];
};

export type TeamworkTeamsV1ByScopeUserActivityType = {
  __typename?: 'TeamworkTeamsV1ByScopeUserActivityType';
  activityType: Scalars['String'];
  connection?: Maybe<TeamworkTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkTeamsV1ByScopeUserActivityTypeItem = {
  __typename?: 'TeamworkTeamsV1ByScopeUserActivityTypeItem';
  activityType: Scalars['String'];
  connection?: Maybe<TeamworkTeamsV1Connection>;
  itemId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkTeamsV1Connection = {
  __typename?: 'TeamworkTeamsV1Connection';
  elements: Array<Maybe<TeamworkTeamsV1>>;
  paging: ResponsePagination;
};

export type TeamworkTeamsV1Latest = {
  __typename?: 'TeamworkTeamsV1Latest';
  connection?: Maybe<TeamworkTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedTeamId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkTeamsV1MultiLatest = {
  __typename?: 'TeamworkTeamsV1MultiLatest';
  connection?: Maybe<TeamworkTeamsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedTeamIds: Array<Maybe<Scalars['String']>>;
  start?: Maybe<Scalars['String']>;
};

export type TeamworkTeamsV1Resource = {
  __typename?: 'TeamworkTeamsV1Resource';
  allAssignedByScope?: Maybe<TeamworkTeamsV1Connection>;
  byScopeActivityType?: Maybe<TeamworkTeamsV1Connection>;
  byScopeActivityTypeItem?: Maybe<TeamworkTeamsV1Connection>;
  byScopeTeamActivityTypeItem?: Maybe<TeamworkTeamsV1Connection>;
  byScopeTeamItem?: Maybe<TeamworkTeamsV1Connection>;
  byScopeUserActivityType?: Maybe<TeamworkTeamsV1Connection>;
  byScopeUserActivityTypeItem?: Maybe<TeamworkTeamsV1Connection>;
  get?: Maybe<TeamworkTeamsV1>;
  latest?: Maybe<TeamworkTeamsV1Connection>;
  multiGet?: Maybe<TeamworkTeamsV1Connection>;
  multiLatest?: Maybe<TeamworkTeamsV1Connection>;
};


export type TeamworkTeamsV1ResourceAllAssignedByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkTeamsV1ResourceByScopeActivityTypeArgs = {
  activityType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkTeamsV1ResourceByScopeActivityTypeItemArgs = {
  activityType: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkTeamsV1ResourceByScopeTeamActivityTypeItemArgs = {
  activityType: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};


export type TeamworkTeamsV1ResourceByScopeTeamItemArgs = {
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  teamId: Scalars['String'];
};


export type TeamworkTeamsV1ResourceByScopeUserActivityTypeArgs = {
  activityType: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkTeamsV1ResourceByScopeUserActivityTypeItemArgs = {
  activityType: Scalars['String'];
  itemId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type TeamworkTeamsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkTeamsV1ResourceLatestArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopedTeamId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkTeamsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkTeamsV1ResourceMultiLatestArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopedTeamIds: Array<InputMaybe<Scalars['String']>>;
  start?: InputMaybe<Scalars['String']>;
};

export type TeamworkTeamsV1ResourceMutations = {
  __typename?: 'TeamworkTeamsV1ResourceMutations';
  addSlackIntegrationMetadata?: Maybe<Scalars['JSON']>;
  update?: Maybe<TeamworkTeamsV1Connection>;
};


export type TeamworkTeamsV1ResourceMutationsAddSlackIntegrationMetadataArgs = {
  id: Scalars['String'];
};


export type TeamworkTeamsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type TeamworkTeamsV1_Org_Coursera_Teamwork_SlackIntegrationMetadata = {
  __typename?: 'TeamworkTeamsV1_org_coursera_teamwork_SlackIntegrationMetadata';
  slackGroupId: Scalars['String'];
  slackTeamDomain?: Maybe<Scalars['String']>;
  slackTeamId: Scalars['String'];
};

export type TeamworkUserProfilesV1 = {
  __typename?: 'TeamworkUserProfilesV1';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isStaff: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  slackProfile?: Maybe<TeamworkUserProfilesV1_Org_Coursera_Group_SlackProfile>;
  userId: Scalars['Int'];
};

export type TeamworkUserProfilesV1ByScope = {
  __typename?: 'TeamworkUserProfilesV1ByScope';
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkUserProfilesV1CompatibilityVersionedTeam = {
  __typename?: 'TeamworkUserProfilesV1CompatibilityVersionedTeam';
  compatibilityVersionedTeam: Scalars['String'];
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type TeamworkUserProfilesV1Connection = {
  __typename?: 'TeamworkUserProfilesV1Connection';
  elements: Array<Maybe<TeamworkUserProfilesV1>>;
  paging: ResponsePagination;
};

export type TeamworkUserProfilesV1Resource = {
  __typename?: 'TeamworkUserProfilesV1Resource';
  byScope?: Maybe<TeamworkUserProfilesV1Connection>;
  compatibilityVersionedTeam?: Maybe<TeamworkUserProfilesV1Connection>;
  get?: Maybe<TeamworkUserProfilesV1>;
  multiGet?: Maybe<TeamworkUserProfilesV1Connection>;
  scopeAndUsers?: Maybe<TeamworkUserProfilesV1Connection>;
  scopeAndUsersAdmin?: Maybe<TeamworkUserProfilesV1Connection>;
  scopedTeamVersion?: Maybe<TeamworkUserProfilesV1Connection>;
  userCourse?: Maybe<TeamworkUserProfilesV1Connection>;
};


export type TeamworkUserProfilesV1ResourceByScopeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkUserProfilesV1ResourceCompatibilityVersionedTeamArgs = {
  compatibilityVersionedTeam: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkUserProfilesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type TeamworkUserProfilesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkUserProfilesV1ResourceScopeAndUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userIds: Array<InputMaybe<Scalars['String']>>;
};


export type TeamworkUserProfilesV1ResourceScopeAndUsersAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
  userIds: Array<InputMaybe<Scalars['String']>>;
};


export type TeamworkUserProfilesV1ResourceScopedTeamVersionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  scopedVersionedTeamId: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type TeamworkUserProfilesV1ResourceUserCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkUserProfilesV1ScopeAndUsers = {
  __typename?: 'TeamworkUserProfilesV1ScopeAndUsers';
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userIds: Array<Maybe<Scalars['String']>>;
};

export type TeamworkUserProfilesV1ScopeAndUsersAdmin = {
  __typename?: 'TeamworkUserProfilesV1ScopeAndUsersAdmin';
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopeId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
  userIds: Array<Maybe<Scalars['String']>>;
};

export type TeamworkUserProfilesV1ScopedTeamVersion = {
  __typename?: 'TeamworkUserProfilesV1ScopedTeamVersion';
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  scopedVersionedTeamId: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type TeamworkUserProfilesV1UserCourse = {
  __typename?: 'TeamworkUserProfilesV1UserCourse';
  connection?: Maybe<TeamworkUserProfilesV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type TeamworkUserProfilesV1_Org_Coursera_Group_SlackProfile = {
  __typename?: 'TeamworkUserProfilesV1_org_coursera_group_SlackProfile';
  deletedOrInactive: Scalars['Boolean'];
  slackName: Scalars['String'];
  slackTeamId: Scalars['String'];
  slackUserId: Scalars['String'];
};

/** An enum representing types of activity */
export const Teamwork_ActivityType = {
  /** Activity type for item discussions */
  ItemDiscussion: 'ITEM_DISCUSSION',
  /** Activity type for item submissions */
  ItemSubmission: 'ITEM_SUBMISSION',
  /** Activity type for practice assignments' items */
  PracticeItemSubmission: 'PRACTICE_ITEM_SUBMISSION',
  /** Activity type standalone discussions */
  StandaloneDiscussion: 'STANDALONE_DISCUSSION',
  /** Activity type for team mate review items */
  TeammateReview: 'TEAMMATE_REVIEW'
} as const;

export type Teamwork_ActivityType = typeof Teamwork_ActivityType[keyof typeof Teamwork_ActivityType];
/** Request to lock team activity */
export type Teamwork_LockTeamActivityInput = {
  /** Type of activity */
  activityType: Teamwork_ActivityType;
  /** Item for which activity should be locked */
  itemId: Scalars['ID'];
  /** Scoped identifier of the team */
  scopedTeamId: Teamwork_ScopedTeamIdInput;
};

/** Response for locking team activity */
export type Teamwork_LockTeamActivityResult = {
  __typename?: 'Teamwork_LockTeamActivityResult';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Scoped identifier of a team */
export type Teamwork_ScopedTeamIdInput = {
  /** The scopeId */
  scopeId: Scalars['ID'];
  /** The teamId */
  teamId: Scalars['ID'];
};

/** Request to unlock team activity */
export type Teamwork_UnlockTeamActivityInput = {
  /** Type of activity */
  activityType: Teamwork_ActivityType;
  /** Item for which activity should be unlocked */
  itemId: Scalars['ID'];
  /** Scoped identifier of the team */
  scopedTeamId: Teamwork_ScopedTeamIdInput;
};

/** Response for unlocking team activity */
export type Teamwork_UnlockTeamActivityResult = {
  __typename?: 'Teamwork_UnlockTeamActivityResult';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Test case analytics queries */
export type TestCaseAnalyticsQueries = {
  __typename?: 'TestCaseAnalyticsQueries';
  /** Query to get test case analytics summary for a given assignment id. */
  queryTestCaseAnalyticsSummary: Autograder_TestCaseAnalyticsPaginatedResult;
  /** Query to get test case results on an per-learner level. */
  queryTestCaseLearnerResults: Autograder_TestCaseLearnerResultsPaginatedResult;
};


/** Test case analytics queries */
export type TestCaseAnalyticsQueriesQueryTestCaseAnalyticsSummaryArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
  versionedProgrammingAssignmentId: Scalars['ID'];
};


/** Test case analytics queries */
export type TestCaseAnalyticsQueriesQueryTestCaseLearnerResultsArgs = {
  branchId: Scalars['ID'];
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemId: Scalars['ID'];
  limit: Scalars['Int'];
  testCaseId: Scalars['ID'];
  versionedProgrammingAssignmentId: Scalars['ID'];
};

export type ThirdPartyAccountsV1 = {
  __typename?: 'ThirdPartyAccountsV1';
  id: Scalars['String'];
  identifier: Scalars['String'];
  loginId: Scalars['Int'];
  permissions: ThirdPartyAccountsV1_Org_Coursera_Authentication_Thirdpartyauth_ThirdPartyAccountPermissions;
};

export type ThirdPartyAccountsV1ByUser = {
  __typename?: 'ThirdPartyAccountsV1ByUser';
  connection?: Maybe<ThirdPartyAccountsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type ThirdPartyAccountsV1Connection = {
  __typename?: 'ThirdPartyAccountsV1Connection';
  elements: Array<Maybe<ThirdPartyAccountsV1>>;
  paging: ResponsePagination;
};

export type ThirdPartyAccountsV1Resource = {
  __typename?: 'ThirdPartyAccountsV1Resource';
  byUser?: Maybe<ThirdPartyAccountsV1Connection>;
  get?: Maybe<ThirdPartyAccountsV1>;
  getAll?: Maybe<ThirdPartyAccountsV1Connection>;
};


export type ThirdPartyAccountsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type ThirdPartyAccountsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ThirdPartyAccountsV1ResourceMutations = {
  __typename?: 'ThirdPartyAccountsV1ResourceMutations';
  createPasswordRecoveryToken?: Maybe<Scalars['JSON']>;
  delete?: Maybe<ThirdPartyAccountsV1Connection>;
  delink?: Maybe<Scalars['JSON']>;
  fetchOrgIdForSsoEnabledByEmail?: Maybe<Scalars['JSON']>;
  invalidateSessions?: Maybe<Scalars['JSON']>;
  updateEppn?: Maybe<Scalars['JSON']>;
  updateSharePermission?: Maybe<Scalars['JSON']>;
};


export type ThirdPartyAccountsV1ResourceMutationsCreatePasswordRecoveryTokenArgs = {
  userId: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceMutationsDelinkArgs = {
  userId: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceMutationsFetchOrgIdForSsoEnabledByEmailArgs = {
  email: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceMutationsInvalidateSessionsArgs = {
  userId: Scalars['String'];
};


export type ThirdPartyAccountsV1ResourceMutationsUpdateEppnArgs = {
  newEppn: Scalars['String'];
  oldEppn: Scalars['String'];
  thirdPartyOrganizationId: Scalars['String'];
};

export type ThirdPartyAccountsV1_Org_Coursera_Authentication_Thirdpartyauth_ThirdPartyAccountPermissions = {
  __typename?: 'ThirdPartyAccountsV1_org_coursera_authentication_thirdpartyauth_ThirdPartyAccountPermissions';
  postToNetwork?: Maybe<Scalars['Boolean']>;
  shareWithFriends?: Maybe<Scalars['Boolean']>;
};

/** All queries for Third Party Organization Configuration */
export type ThirdPartyOrganizationConfigurationQueries = {
  __typename?: 'ThirdPartyOrganizationConfigurationQueries';
  /**
   * Check if LMS/LXP auto enrollment is enabled for a given organization
   * Returns true if ENTERPRISE_SETTING_KEY_LMS_LXP_AUTO_ENROLLMENT_ENABLED is set to true for the organization
   */
  isLmsLxpAutoEnrollmentEnabled: Scalars['Boolean'];
  /**
   * Check if SSO locked out is enabled for a given organization
   * Returns true if SSO locked out is enabled for the organization
   */
  isSsoLockedOutEnabled: Scalars['Boolean'];
};


/** All queries for Third Party Organization Configuration */
export type ThirdPartyOrganizationConfigurationQueriesIsLmsLxpAutoEnrollmentEnabledArgs = {
  organizationId: Scalars['ID'];
};


/** All queries for Third Party Organization Configuration */
export type ThirdPartyOrganizationConfigurationQueriesIsSsoLockedOutEnabledArgs = {
  organizationId: Scalars['ID'];
};

/** All ThirdPartyOrganizationEmailDomain Queries */
export type ThirdPartyOrganizationEmailDomainQueries = {
  __typename?: 'ThirdPartyOrganizationEmailDomainQueries';
  /** Returns all ThirdPartyEmailDomains . */
  getAll: ThirdPartyOrganizationEmailDomain_PaginatedResult;
  /** Returns ThirdPartyEmailDomain having the supplied id. */
  getById: ThirdPartyOrganizationEmailDomain_GetByIdResult;
  /** Find By ThirdPartyOrganizationId Query */
  getByThirdPartyOrganization: ThirdPartyOrganizationEmailDomain_PaginatedResult;
  /** Returns ThirdPartyEmailDomain having the supplied ids. */
  multiGetByIds: ThirdPartyOrganizationEmailDomain_PaginatedResult;
};


/** All ThirdPartyOrganizationEmailDomain Queries */
export type ThirdPartyOrganizationEmailDomainQueriesGetAllArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
};


/** All ThirdPartyOrganizationEmailDomain Queries */
export type ThirdPartyOrganizationEmailDomainQueriesGetByIdArgs = {
  id: Scalars['ID'];
};


/** All ThirdPartyOrganizationEmailDomain Queries */
export type ThirdPartyOrganizationEmailDomainQueriesGetByThirdPartyOrganizationArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All ThirdPartyOrganizationEmailDomain Queries */
export type ThirdPartyOrganizationEmailDomainQueriesMultiGetByIdsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
  limit?: Scalars['Int'];
};

/** Input for creating ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_CreateInput = {
  /** ID of ThirdPartyOrganizationEmailDomainId. */
  id: Scalars['ID'];
  /** The thirdPartyOrganization Id. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of creating thirdPartyOrganizationEmailDoamin */
export type ThirdPartyOrganizationEmailDomain_CreateResult = ThirdPartyOrganizationEmailDomain_CreateResultFailure | ThirdPartyOrganizationEmailDomain_CreateResultSuccess;

/** ThirdPartyOrganizationEmailDomain_Get* query Error. */
export const ThirdPartyOrganizationEmailDomain_CreateResultError = {
  /** ThirdPartyEmailDomain not found */
  DuplicateEntry: 'DUPLICATE_ENTRY',
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR'
} as const;

export type ThirdPartyOrganizationEmailDomain_CreateResultError = typeof ThirdPartyOrganizationEmailDomain_CreateResultError[keyof typeof ThirdPartyOrganizationEmailDomain_CreateResultError];
/** ThirdPartyOrganizationEmailDomain_CreateResultFailure */
export type ThirdPartyOrganizationEmailDomain_CreateResultFailure = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_CreateResultFailure';
  /** reason for the error */
  error: ThirdPartyOrganizationEmailDomain_CreateResultError;
  /** error message */
  errorMessage: Scalars['String'];
};

/** Returned on ProgramMembership_Join mutation success. */
export type ThirdPartyOrganizationEmailDomain_CreateResultSuccess = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_CreateResultSuccess';
  /** ThirdPartyOrganizationEmailDomain is created */
  success: Scalars['Boolean'];
};

/** Input for Deleting ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_DeleteInput = {
  /** ID of ThirdPartyOrganizationEmailDomain */
  id: Scalars['ID'];
};

/** Result of joining the user into program */
export type ThirdPartyOrganizationEmailDomain_DeleteResult = ThirdPartyOrganizationEmailDomain_DeleteResultFailure | ThirdPartyOrganizationEmailDomain_DeleteResultSuccess;

/** ThirdPartyOrganizationEmailDomain_Get query Error. */
export const ThirdPartyOrganizationEmailDomain_DeleteResultError = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** ThirdPartyEmailDomain not found */
  NotFound: 'NOT_FOUND'
} as const;

export type ThirdPartyOrganizationEmailDomain_DeleteResultError = typeof ThirdPartyOrganizationEmailDomain_DeleteResultError[keyof typeof ThirdPartyOrganizationEmailDomain_DeleteResultError];
/** ThirdPartyOrganizationEmailDomain_DeleteResultFailure */
export type ThirdPartyOrganizationEmailDomain_DeleteResultFailure = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_DeleteResultFailure';
  /** reason for the error */
  error: ThirdPartyOrganizationEmailDomain_DeleteResultError;
  /** error message */
  errorMessage: Scalars['String'];
};

/** Returned on ProgramMembership_Join mutation success. */
export type ThirdPartyOrganizationEmailDomain_DeleteResultSuccess = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_DeleteResultSuccess';
  /** ThirdPartyOrganizationEmailDomain is created */
  success: Scalars['Boolean'];
};

/** Response object that represents ThirdPartyEmailDomain */
export type ThirdPartyOrganizationEmailDomain_EmailDomain = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_EmailDomain';
  /** ID of ThirdPartyOrganizationEmailDomainId. */
  id: Scalars['ID'];
  /** The thirdPartyOrganization Id. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of the restored subscription. Can be either success or failure */
export type ThirdPartyOrganizationEmailDomain_GetByIdResult = ThirdPartyOrganizationEmailDomain_EmailDomain | ThirdPartyOrganizationEmailDomain_GetResponseFailure;

/** ThirdPartyOrganizationEmailDomain_Get* query Error. */
export const ThirdPartyOrganizationEmailDomain_GetResponseError = {
  /** There is a service (or unknown) error */
  InternalError: 'INTERNAL_ERROR',
  /** ThirdPartyEmailDomain not found */
  NotFound: 'NOT_FOUND'
} as const;

export type ThirdPartyOrganizationEmailDomain_GetResponseError = typeof ThirdPartyOrganizationEmailDomain_GetResponseError[keyof typeof ThirdPartyOrganizationEmailDomain_GetResponseError];
/** ThirdPartyOrganizationEmailDomain_GetResponseFailure */
export type ThirdPartyOrganizationEmailDomain_GetResponseFailure = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_GetResponseFailure';
  /** reason for the error */
  error: ThirdPartyOrganizationEmailDomain_GetResponseError;
};

/** Input for creating Multiple ThirdPartyOrganizationEmailDomain mutation */
export type ThirdPartyOrganizationEmailDomain_MultiCreateInput = {
  /** IDs of ThirdPartyOrganizationEmailDomain */
  ids: Array<Scalars['ID']>;
  /** The thirdPartyOrganization Id. */
  thirdPartyOrganizationId: Scalars['ID'];
};

/** Result of creating multiple thirdPartyOrganizationEmailDoamin */
export type ThirdPartyOrganizationEmailDomain_MultiCreateResult = ThirdPartyOrganizationEmailDomain_CreateResultFailure | ThirdPartyOrganizationEmailDomain_CreateResultSuccess;

/** Paginated response for third party email domains */
export type ThirdPartyOrganizationEmailDomain_PaginatedResult = {
  __typename?: 'ThirdPartyOrganizationEmailDomain_PaginatedResult';
  /** List of ThirdPartyOrganizationEmailDomain_EmailDomain */
  elements: Array<ThirdPartyOrganizationEmailDomain_EmailDomain>;
  /** Pagination metadata */
  pagination: Pagination;
};

export type ThirdPartyOrganizationEmailDomainsV1 = {
  __typename?: 'ThirdPartyOrganizationEmailDomainsV1';
  _0all: Scalars['String'];
  domainId: Scalars['String'];
  id: Scalars['String'];
  thirdPartyOrganizationId: Scalars['String'];
};

export type ThirdPartyOrganizationEmailDomainsV1Connection = {
  __typename?: 'ThirdPartyOrganizationEmailDomainsV1Connection';
  elements: Array<Maybe<ThirdPartyOrganizationEmailDomainsV1>>;
  paging: ResponsePagination;
};

export type ThirdPartyOrganizationEmailDomainsV1GetByThirdPartyOrganization = {
  __typename?: 'ThirdPartyOrganizationEmailDomainsV1GetByThirdPartyOrganization';
  connection?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};

export type ThirdPartyOrganizationEmailDomainsV1Resource = {
  __typename?: 'ThirdPartyOrganizationEmailDomainsV1Resource';
  get?: Maybe<ThirdPartyOrganizationEmailDomainsV1>;
  getAll?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
  getByThirdPartyOrganization?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
  multiGet?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
};


export type ThirdPartyOrganizationEmailDomainsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationEmailDomainsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationEmailDomainsV1ResourceGetByThirdPartyOrganizationArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  thirdPartyOrganizationId: Scalars['String'];
};


export type ThirdPartyOrganizationEmailDomainsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ThirdPartyOrganizationEmailDomainsV1ResourceMutations = {
  __typename?: 'ThirdPartyOrganizationEmailDomainsV1ResourceMutations';
  create?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
  delete?: Maybe<ThirdPartyOrganizationEmailDomainsV1Connection>;
  multiCreate?: Maybe<Scalars['JSON']>;
};


export type ThirdPartyOrganizationEmailDomainsV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};

/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueries = {
  __typename?: 'ThirdPartyOrganizationQueries';
  /** Get a single ThirdPartyOrganization by its ID */
  getById: ThirdPartyOrganization_ThirdPartyOrganization;
  /** Query for fetching Metadata Download URL by Third Party Organization ID. */
  getMetadataDownloadUrlById: ThirdPartyOrganization_MetadataDownloadUrlResult;
  /** Query for fetching Metadata Expiry by Third Party Organization ID. */
  getMetadataExpiry?: Maybe<ThirdPartyOrganization_MetadataExpiryResponse>;
  /** Query for fetching Metadata Upload URL by Third Party Organization ID. */
  getMetadataUploadUrlById: ThirdPartyOrganization_MetadataUploadUrlResult;
  /**
   * Initiates a login flow for a third-party organization.
   * Returns a redirect URL for the Single Sign-On authentication process.
   */
  initiateLoginFlow: ThirdPartyOrganization_LoginFlowResult;
  /** Query type for fetching a Third Party Organization by its entity ID. */
  queryByEntityId: Array<ThirdPartyOrganization_ThirdPartyOrganization>;
  /** Query ThirdPartyOrganizations using Text Search */
  queryByFullTextSearch?: Maybe<ThirdPartyOrganization_FullTextSearchQueryResult>;
  /** Query Multiple ThirdPartyOrganization using a list of ThirdPartyOrganization ids */
  queryByIds: Array<ThirdPartyOrganization_ThirdPartyOrganization>;
  /** Query type for fetching a Third Party Organization by its slug. */
  queryBySlug: Array<ThirdPartyOrganization_ThirdPartyOrganization>;
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesGetByIdArgs = {
  id: Scalars['ID'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesGetMetadataDownloadUrlByIdArgs = {
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesGetMetadataExpiryArgs = {
  refreshDays: Scalars['Int'];
  thirdPartyOrganizationId: Scalars['ID'];
  warningDays: Scalars['Int'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesGetMetadataUploadUrlByIdArgs = {
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesInitiateLoginFlowArgs = {
  format?: Scalars['String'];
  isMobile?: Scalars['Boolean'];
  returnTo?: InputMaybe<Scalars['URL']>;
  thirdPartyOrganizationId: Scalars['ID'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesQueryByEntityIdArgs = {
  entityId: Scalars['ID'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesQueryByFullTextSearchArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  queryString: Scalars['String'];
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesQueryByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


/** All ThirdPartyOrganization queries */
export type ThirdPartyOrganizationQueriesQueryBySlugArgs = {
  slug: Scalars['String'];
};

/** All ThirdPartyOrganization Service Account Queries */
export type ThirdPartyOrganizationServiceAccountQueries = {
  __typename?: 'ThirdPartyOrganizationServiceAccountQueries';
  /** Find By Organization Query */
  findByOrganization?: Maybe<ThirdPartyOrganizationServiceAccount_ServiceAccountFinderResult>;
  /** Find By User Query */
  findByUser?: Maybe<ThirdPartyOrganizationServiceAccount_ServiceAccountFinderResult>;
};


/** All ThirdPartyOrganization Service Account Queries */
export type ThirdPartyOrganizationServiceAccountQueriesFindByOrganizationArgs = {
  input: ThirdPartyOrganizationServiceAccount_ServiceAccountFindByOrganizationInput;
};


/** All ThirdPartyOrganization Service Account Queries */
export type ThirdPartyOrganizationServiceAccountQueriesFindByUserArgs = {
  input: ThirdPartyOrganizationServiceAccount_ServiceAccountFindByUserInput;
};

/** Create ThirdPartyOrganizationServiceAccount error */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError = Error & {
  __typename?: 'ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError';
  /** Error message */
  message: Scalars['String'];
};

/** Failure response if Create ThirdPartyOrganizationServiceAccount request fails */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateFailure = {
  __typename?: 'ThirdPartyOrganizationServiceAccount_ServiceAccountCreateFailure';
  /** List of errors */
  errors: Array<ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError>;
};

/** Input Request for Creating ThirdPartyOrganizationServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateInput = {
  /** ClientId for Create ServiceAccount */
  clientId: Scalars['ID'];
  /** OrganizationId for Create ServiceAccount */
  thirdPartyOrganizationId: Scalars['ID'];
  /** UserId for Create ServiceAccount */
  userId: Scalars['ID'];
};

/** Result for ThirdPartyOrganizationServiceAccount Create API */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateResult = ThirdPartyOrganizationServiceAccount_ServiceAccountCreateFailure | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateSuccess;

/** Success response if Create ThirdPartyOrganizationServiceAccount request success */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountCreateSuccess = {
  __typename?: 'ThirdPartyOrganizationServiceAccount_ServiceAccountCreateSuccess';
  /** clientId of Created ServiceAccount */
  clientId: Scalars['ID'];
  /** ServiceAccountId of Created ServiceAccount */
  serviceAccountId: Scalars['ID'];
};

/** Input Request for Deleting ThirdPartyOrganizationServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteInput = {
  /** ServiceAccountId to be Deleted */
  serviceAccountId: Scalars['ID'];
};

/** Response for Delete ThirdPartyOrganizationServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteResult = {
  __typename?: 'ThirdPartyOrganizationServiceAccount_ServiceAccountDeleteResult';
  /** deleted flag */
  success: Scalars['Boolean'];
};

/** Input Request for FindByOrganization ThirdPartyOrganizationServiceAccount API */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountFindByOrganizationInput = {
  /** OrganizationId to find ServiceAccount */
  organizationId: Scalars['String'];
};

/** Input Request for FindByUser ThirdPartyOrganizationServiceAccount API */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountFindByUserInput = {
  /** UserId to find ServiceAccount */
  userId: Scalars['String'];
};

/** Response for FindByOrganization ServiceAccount */
export type ThirdPartyOrganizationServiceAccount_ServiceAccountFinderResult = {
  __typename?: 'ThirdPartyOrganizationServiceAccount_ServiceAccountFinderResult';
  /** ClientId of find ServiceAccount Result */
  clientId: Scalars['ID'];
  /** ServiceAccountId of find ServiceAccount Result */
  serviceAccountId: Scalars['ID'];
};

/** Paginated list of ThirdPartyOrganization returned from text search query */
export type ThirdPartyOrganization_FullTextSearchQueryResult = {
  __typename?: 'ThirdPartyOrganization_FullTextSearchQueryResult';
  /** List of elements in the page */
  elements: Array<ThirdPartyOrganization_ThirdPartyOrganization>;
  /** Pagination metadata */
  pagination: Pagination;
};

/** Display mode for tracking progress legalese on the Terms & Conditions screen. */
export const ThirdPartyOrganization_LegaleseDisplayMode = {
  /**
   * Display organization-specific custom legalese text.
   * Requires customText field to be provided.
   */
  Custom: 'CUSTOM',
  /** Hide the tracking progress legalese block entirely. */
  Hidden: 'HIDDEN'
} as const;

export type ThirdPartyOrganization_LegaleseDisplayMode = typeof ThirdPartyOrganization_LegaleseDisplayMode[keyof typeof ThirdPartyOrganization_LegaleseDisplayMode];
/** Result type for the login flow initiation. */
export type ThirdPartyOrganization_LoginFlowResult = {
  __typename?: 'ThirdPartyOrganization_LoginFlowResult';
  /** The redirect URL for the login flow. */
  redirectUrl: Scalars['URL'];
};

/** A type that represents a URL. */
export type ThirdPartyOrganization_MetadataDownloadUrlResult = {
  __typename?: 'ThirdPartyOrganization_MetadataDownloadUrlResult';
  /** The metadata download URL for the Third Party Organization. */
  url: Scalars['URL'];
};

/** A type that represents the response for MetadataExpiry by Third Party Organization. */
export type ThirdPartyOrganization_MetadataExpiryResponse = {
  __typename?: 'ThirdPartyOrganization_MetadataExpiryResponse';
  /** The message to explain the expiry status. */
  message: Scalars['String'];
  /** The enum status of the metadata expiry */
  status: ThirdPartyOrganization_SamlMetadataExpiry;
  /** Timestamp when expiry will occur, DateTime format. */
  validUntil?: Maybe<Scalars['DateTime']>;
};

/** A type that represents a URL. */
export type ThirdPartyOrganization_MetadataUploadUrlResult = {
  __typename?: 'ThirdPartyOrganization_MetadataUploadUrlResult';
  /** The metadata upload URL for the Third Party Organization. */
  url: Scalars['URL'];
};

/** Enum representing Organization Employee Range. */
export const ThirdPartyOrganization_OrganizationEmployeeRange = {
  /** Organization has 1-500 employees. */
  EmployeeRange_1_500: 'EMPLOYEE_RANGE_1_500',
  /** Organization has 501-1000 employees. */
  EmployeeRange_501_1000: 'EMPLOYEE_RANGE_501_1000',
  /** Organization has 1001-5000 employees. */
  EmployeeRange_1001_5000: 'EMPLOYEE_RANGE_1001_5000',
  /** Organization has 5001-15,000 employees. */
  EmployeeRange_5001_15000: 'EMPLOYEE_RANGE_5001_15000',
  /** Organization has more than 15,000 employees. */
  EmployeeRangeMoreThan_15000: 'EMPLOYEE_RANGE_MORE_THAN_15000'
} as const;

export type ThirdPartyOrganization_OrganizationEmployeeRange = typeof ThirdPartyOrganization_OrganizationEmployeeRange[keyof typeof ThirdPartyOrganization_OrganizationEmployeeRange];
/** Enum representing organization types. */
export const ThirdPartyOrganization_OrganizationType = {
  /** Business organization type. */
  Business: 'BUSINESS',
  /** Campus organization type. */
  Campus: 'CAMPUS',
  /** Government organization type. */
  Government: 'GOVERNMENT'
} as const;

export type ThirdPartyOrganization_OrganizationType = typeof ThirdPartyOrganization_OrganizationType[keyof typeof ThirdPartyOrganization_OrganizationType];
/** Enum representing the program visibility rule. */
export const ThirdPartyOrganization_ProgramVisibilityRule = {
  /** Visibility for accepted privacy notice. */
  AcceptedPrivacyNotice: 'ACCEPTED_PRIVACY_NOTICE',
  /** Visibility rule where everyone can see the program. */
  Everyone: 'EVERYONE'
} as const;

export type ThirdPartyOrganization_ProgramVisibilityRule = typeof ThirdPartyOrganization_ProgramVisibilityRule[keyof typeof ThirdPartyOrganization_ProgramVisibilityRule];
/** Enum representing validity of SAML Metadata. */
export const ThirdPartyOrganization_SamlMetadataExpiry = {
  /** SAML Metadata has been expired. */
  Expired: 'EXPIRED',
  /** SAML Metadata is about to expire. */
  ExpiryWarning: 'EXPIRY_WARNING',
  /** SAML Metadata is missing. */
  MissingMetadata: 'MISSING_METADATA',
  /** SAML Metadata needs to be refreshed. */
  NeedsRefresh: 'NEEDS_REFRESH',
  /** SAML Metadata is valid. */
  Valid: 'VALID'
} as const;

export type ThirdPartyOrganization_SamlMetadataExpiry = typeof ThirdPartyOrganization_SamlMetadataExpiry[keyof typeof ThirdPartyOrganization_SamlMetadataExpiry];
/** Enum representing SAML signing algorithm. */
export const ThirdPartyOrganization_SamlSigningAlgorithm = {
  /** SAML signing algorithm SHA1_RSA. */
  Sha1Rsa: 'SHA1_RSA',
  /** SAML signing algorithm SHA256_RSA. */
  Sha256Rsa: 'SHA256_RSA'
} as const;

export type ThirdPartyOrganization_SamlSigningAlgorithm = typeof ThirdPartyOrganization_SamlSigningAlgorithm[keyof typeof ThirdPartyOrganization_SamlSigningAlgorithm];
/** Input for setIsReal mutation */
export type ThirdPartyOrganization_SetIsRealInput = {
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The new value for the isReal field */
  isReal: Scalars['Boolean'];
};

/** Success and failure handling for setIsReal mutation */
export type ThirdPartyOrganization_SetIsRealResult = ThirdPartyOrganization_SetIsRealResult_Failure | ThirdPartyOrganization_SetIsRealResult_Success;

/** Failure response for ThirdPartyOrganization_SetIsRealResult */
export type ThirdPartyOrganization_SetIsRealResult_Failure = {
  __typename?: 'ThirdPartyOrganization_SetIsRealResult_Failure';
  /** Error message */
  message: Scalars['String'];
};

/** Success response for ThirdPartyOrganization_SetIsRealResult */
export type ThirdPartyOrganization_SetIsRealResult_Success = {
  __typename?: 'ThirdPartyOrganization_SetIsRealResult_Success';
  /** The updated ThirdPartyOrganization */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Enum representing SSO login methods. */
export const ThirdPartyOrganization_SsoLoginMethod = {
  /** SSO login method JWT. */
  Jwt: 'JWT',
  /** SSO login method JWT_INVITE. */
  JwtInvite: 'JWT_INVITE',
  /** SSO login method SAML. */
  Saml: 'SAML'
} as const;

export type ThirdPartyOrganization_SsoLoginMethod = typeof ThirdPartyOrganization_SsoLoginMethod[keyof typeof ThirdPartyOrganization_SsoLoginMethod];
/** Third-party organization entity stub. */
export type ThirdPartyOrganization_ThirdPartyOrganization = {
  __typename?: 'ThirdPartyOrganization_ThirdPartyOrganization';
  /** The address for the Third Party Organization. */
  address?: Maybe<ThirdPartyOrganization_ThirdPartyOrganizationAddress>;
  /** The domain for emails registered under this Third Party Organization. */
  emailDomain?: Maybe<Scalars['String']>;
  /** Entity ID, specific for SAML. */
  entityId?: Maybe<Scalars['String']>;
  /** Color selected for icons. */
  iconColor?: Maybe<Scalars['String']>;
  /** The third-party organization ID. */
  id: Scalars['ID'];
  /** Boolean flag indicating if the Third Party Organization is real. */
  isReal: Scalars['Boolean'];
  /** Landing page banner URL. */
  landingPageBanner?: Maybe<Scalars['URL']>;
  /** The timestamp of the last update. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** The login method being used by the Third-Party Organization. */
  loginMethod?: Maybe<ThirdPartyOrganization_SsoLoginMethod>;
  /** Organization's metadata. */
  metadata?: Maybe<ThirdPartyOrganization_ThirdPartyOrganizationMetadata>;
  /** The name of the organization. */
  name: Scalars['String'];
  /** The range of employees within the organization. */
  organizationEmployeeRange?: Maybe<ThirdPartyOrganization_OrganizationEmployeeRange>;
  /** The type of the organization. */
  organizationType?: Maybe<ThirdPartyOrganization_OrganizationType>;
  /** The color used for co-branding, as a primary color. */
  primaryColor?: Maybe<Scalars['String']>;
  /** Defines the rule for program visibility within the organization. */
  programVisibilityRule: ThirdPartyOrganization_ProgramVisibilityRule;
  /** Rectangular logo URL. */
  rectangularLogo?: Maybe<Scalars['URL']>;
  /** The organization's unique slug (URL-friendly). */
  slug: Scalars['String'];
  /** URL to the square logo. */
  squareLogo?: Maybe<Scalars['URL']>;
  /** Indicates if Single Sign-On (SSO) is supported for the degree. */
  supportsDegreeSSOLogin: Scalars['Boolean'];
  /** The organization's tax ID. */
  taxId?: Maybe<Scalars['String']>;
  /** Custom legalese configuration for the tracking progress screen. */
  trackingProgressLegaleseConfig?: Maybe<ThirdPartyOrganization_TrackingProgressLegaleseConfig>;
};

/** A type that represents a Third Party Organization Address. */
export type ThirdPartyOrganization_ThirdPartyOrganizationAddress = {
  __typename?: 'ThirdPartyOrganization_ThirdPartyOrganizationAddress';
  /** The city of the address. */
  city: Scalars['String'];
  /** The country of the address. */
  country: Scalars['String'];
  /** The first line of the address. */
  line1: Scalars['String'];
  /** The second line of the address. */
  line2?: Maybe<Scalars['String']>;
  /** The state of the address. */
  state: Scalars['String'];
  /** The zipcode of the address. */
  zipCode: Scalars['String'];
};

/** A type that represents Third Party Organization JWT Metadata. */
export type ThirdPartyOrganization_ThirdPartyOrganizationJwtMetadata = {
  __typename?: 'ThirdPartyOrganization_ThirdPartyOrganizationJwtMetadata';
  /** The email field in the JWT metadata. */
  emailField: Scalars['String'];
  /** The name field in the JWT metadata. */
  nameField: Scalars['String'];
  /** The opaque ID field in the JWT metadata. */
  opaqueIdField: Scalars['String'];
  /** The list of secret keys in the JWT metadata. */
  secretKeys: Array<Scalars['String']>;
};

/** Union type that represents Third Party Organization Metadata. */
export type ThirdPartyOrganization_ThirdPartyOrganizationMetadata = ThirdPartyOrganization_ThirdPartyOrganizationJwtMetadata | ThirdPartyOrganization_ThirdPartyOrganizationSamlMetadata;

/** A type that represents Third Party Organization SAML Metadata. */
export type ThirdPartyOrganization_ThirdPartyOrganizationSamlMetadata = {
  __typename?: 'ThirdPartyOrganization_ThirdPartyOrganizationSamlMetadata';
  /** Flag to indicate if IDP initiated login is allowed. */
  allowsIdpInitiatedLogin: Scalars['Boolean'];
  /** The email attribute in the SAML metadata. */
  emailAttribute: Scalars['String'];
  /** The external ID attribute in the SAML metadata. */
  externalIdAttribute?: Maybe<Scalars['String']>;
  /** The first name attribute in the SAML metadata. */
  firstNameAttribute?: Maybe<Scalars['String']>;
  /** The last name attribute in the SAML metadata. */
  lastNameAttribute?: Maybe<Scalars['String']>;
  /** The name attribute in the SAML metadata. */
  nameAttribute?: Maybe<Scalars['String']>;
  /** The opaque ID attribute in the SAML metadata. */
  opaqueIdAttribute: Scalars['String'];
  /** The URL to refresh SAML configuration. */
  refreshUrl?: Maybe<Scalars['URL']>;
  /** Flag to indicate if SAML request should be signed. */
  signSamlRequest: Scalars['Boolean'];
  /** The algorithm used for signing SAML request. */
  signingAlgorithm: ThirdPartyOrganization_SamlSigningAlgorithm;
  /** The fingerprint of the signing certificate. */
  signingCertificateFingerprint?: Maybe<Scalars['String']>;
};

/**
 * Configuration for organization-level customization of tracking progress legalese.
 * Allows organizations to display custom text, hide the legalese block, or use default Coursera text (when config is null).
 */
export type ThirdPartyOrganization_TrackingProgressLegaleseConfig = {
  __typename?: 'ThirdPartyOrganization_TrackingProgressLegaleseConfig';
  /**
   * Custom legalese text (max 2000 characters).
   * Required when mode=CUSTOM, must be null when mode=HIDDEN.
   */
  customText?: Maybe<Scalars['String']>;
  /** Optional JIRA ticket key for legal approval audit trail. */
  legalApprovalJiraTicketKey?: Maybe<Scalars['String']>;
  /**
   * Display mode for the legalese: CUSTOM (show customText) or HIDDEN (hide block entirely).
   * When config is absent/null, Coursera default legalese is shown.
   */
  mode: ThirdPartyOrganization_LegaleseDisplayMode;
};

/** Input for updating entityId mutation */
export type ThirdPartyOrganization_UpdateEntityIdInput = {
  /** An optional boolean field to allow duplicate entityId (works with poweruser permission in backend) */
  allowDuplicateEntityIds?: InputMaybe<Scalars['Boolean']>;
  /** The new value for the entityId field */
  entityId: Scalars['ID'];
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
};

/** Success and failure handling for UpdateEntityId mutation */
export type ThirdPartyOrganization_UpdateEntityIdResult = ThirdPartyOrganization_UpdateEntityIdResult_Failure | ThirdPartyOrganization_UpdateEntityIdResult_Success;

/** Failure response for ThirdPartyOrganization_UpdateEntityIdResult */
export type ThirdPartyOrganization_UpdateEntityIdResult_Failure = {
  __typename?: 'ThirdPartyOrganization_UpdateEntityIdResult_Failure';
  /** Error message */
  message: Scalars['String'];
};

/** Success response for ThirdPartyOrganization_UpdateEntityIdResult */
export type ThirdPartyOrganization_UpdateEntityIdResult_Success = {
  __typename?: 'ThirdPartyOrganization_UpdateEntityIdResult_Success';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input for updating ThirdPartyOrganization metadata mutation */
export type ThirdPartyOrganization_UpdateMetadataInput = {
  /** The allowsIdpInitiatedLogin of the ThirdPartyOrganization */
  allowsIdpInitiatedLogin?: InputMaybe<Scalars['Boolean']>;
  /** The emailAttribute of the ThirdPartyOrganization */
  emailAttribute: Scalars['String'];
  /** The externalIdAttribute of the ThirdPartyOrganization */
  externalIdAttribute?: InputMaybe<Scalars['String']>;
  /** The firstNameAttribute of the ThirdPartyOrganization */
  firstNameAttribute?: InputMaybe<Scalars['String']>;
  /** hasSamlMetadataFileUpdated for the organization */
  hasSamlMetadataFileUpdated?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The lastNameAttribute of the ThirdPartyOrganization */
  lastNameAttribute?: InputMaybe<Scalars['String']>;
  /** The nameAttribute of the ThirdPartyOrganization */
  nameAttribute?: InputMaybe<Scalars['String']>;
  /** The opaqueIdAttribute of the ThirdPartyOrganization */
  opaqueIdAttribute: Scalars['String'];
  /** The refreshUrl of the ThirdPartyOrganization */
  refreshUrl?: InputMaybe<Scalars['URL']>;
  /** The signSamlRequest flag of the ThirdPartyOrganization */
  signSamlRequest?: InputMaybe<Scalars['Boolean']>;
  /** The signingAlgorithm of the ThirdPartyOrganization */
  signingAlgorithm: ThirdPartyOrganization_SamlSigningAlgorithm;
  /** The signingCertificateFingerprint of the ThirdPartyOrganization */
  signingCertificateFingerprint?: InputMaybe<Scalars['String']>;
};

/** Success and failure handling for UpdateMetadata mutation */
export type ThirdPartyOrganization_UpdateMetadataResult = ThirdPartyOrganization_UpdateMetadataResult_Failure | ThirdPartyOrganization_UpdateMetadataResult_Success;

/** Failure response for ThirdPartyOrganization_UpdateMetadataResult */
export type ThirdPartyOrganization_UpdateMetadataResult_Failure = {
  __typename?: 'ThirdPartyOrganization_UpdateMetadataResult_Failure';
  /** Error message */
  message: Scalars['String'];
};

/** Success response for ThirdPartyOrganization_UpdateMetadataResult */
export type ThirdPartyOrganization_UpdateMetadataResult_Success = {
  __typename?: 'ThirdPartyOrganization_UpdateMetadataResult_Success';
  /** Updated ThirdPartyOrganization */
  thirdPartyOrganization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Input for updateSigningCertificate mutation */
export type ThirdPartyOrganization_UpdateSigningCertificateInput = {
  /** The ID of the ThirdPartyOrganization */
  id: Scalars['ID'];
  /** The new signing certificate fingerprint to set */
  signingCertificateFingerprint: Scalars['String'];
};

/** Success and failure handling for updateSigningCertificate mutation */
export type ThirdPartyOrganization_UpdateSigningCertificateResult = ThirdPartyOrganization_UpdateSigningCertificateResult_Failure | ThirdPartyOrganization_UpdateSigningCertificateResult_Success;

/** Failure response for ThirdPartyOrganization_UpdateSigningCertificateResult */
export type ThirdPartyOrganization_UpdateSigningCertificateResult_Failure = {
  __typename?: 'ThirdPartyOrganization_UpdateSigningCertificateResult_Failure';
  /** Error message */
  message: Scalars['String'];
};

/** Success response for ThirdPartyOrganization_UpdateSigningCertificateResult */
export type ThirdPartyOrganization_UpdateSigningCertificateResult_Success = {
  __typename?: 'ThirdPartyOrganization_UpdateSigningCertificateResult_Success';
  /** GraphQL types must include at least one field, so a dummy field is defined to represent void/no-response bodies. */
  _?: Maybe<Scalars['Boolean']>;
};

/**
 * thirdPartyOrganizations.v1
 *
 * See
 * https://github.com/webedx-spark/graphql-gateway-schema/blob/main/schemas/thirdPartyOrganizations.v1.graphql
 * for the complete schema.
 */
export type ThirdPartyOrganizationsV1 = {
  __typename?: 'ThirdPartyOrganizationsV1';
  _0all: Scalars['String'];
  address?: Maybe<ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_ThirdPartyOrganizationAddress>;
  emailDomain?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  iconColor?: Maybe<Scalars['String']>;
  /** ID of the third party organization. */
  id: Scalars['String'];
  isReal: Scalars['Boolean'];
  landingPageBanner?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  loginMethod?: Maybe<Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod>;
  metadata?: Maybe<ThirdPartyOrganizationsV1_Metadata>;
  name: Scalars['String'];
  organizationEmployeeRange?: Maybe<Scalars['String']>;
  organizationType?: Maybe<Org_Coursera_Authentication_Thirdpartyauth_OrganizationType>;
  partnerId?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  programVisibilityRule: Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule;
  rectangularLogo?: Maybe<Scalars['String']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  squareLogo?: Maybe<Scalars['String']>;
  supportsDegreeSSOLogin: Scalars['Boolean'];
  taxId?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1ByEntityId = {
  __typename?: 'ThirdPartyOrganizationsV1ByEntityId';
  connection?: Maybe<ThirdPartyOrganizationsV1Connection>;
  entityId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1ByFullTextSearch = {
  __typename?: 'ThirdPartyOrganizationsV1ByFullTextSearch';
  connection?: Maybe<ThirdPartyOrganizationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  queryString: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1ByLoginMethod = {
  __typename?: 'ThirdPartyOrganizationsV1ByLoginMethod';
  connection?: Maybe<ThirdPartyOrganizationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  loginMethod: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1BySlug = {
  __typename?: 'ThirdPartyOrganizationsV1BySlug';
  connection?: Maybe<ThirdPartyOrganizationsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1Connection = {
  __typename?: 'ThirdPartyOrganizationsV1Connection';
  elements: Array<Maybe<ThirdPartyOrganizationsV1>>;
  paging: ResponsePagination;
};

export type ThirdPartyOrganizationsV1Resource = {
  __typename?: 'ThirdPartyOrganizationsV1Resource';
  byEntityId?: Maybe<ThirdPartyOrganizationsV1Connection>;
  byFullTextSearch?: Maybe<ThirdPartyOrganizationsV1Connection>;
  byLoginMethod?: Maybe<ThirdPartyOrganizationsV1Connection>;
  bySlug?: Maybe<ThirdPartyOrganizationsV1Connection>;
  get?: Maybe<ThirdPartyOrganizationsV1>;
  getAll?: Maybe<ThirdPartyOrganizationsV1Connection>;
  multiGet?: Maybe<ThirdPartyOrganizationsV1Connection>;
};


export type ThirdPartyOrganizationsV1ResourceByEntityIdArgs = {
  entityId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceByFullTextSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  queryString: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceByLoginMethodArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  loginMethod: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceBySlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1ResourceMutations = {
  __typename?: 'ThirdPartyOrganizationsV1ResourceMutations';
  create?: Maybe<ThirdPartyOrganizationsV1Connection>;
  getMetadataDownloadUrl?: Maybe<Scalars['JSON']>;
  getMetadataExpiry?: Maybe<Scalars['JSON']>;
  getMetadataUploadUrl?: Maybe<Scalars['JSON']>;
  getSigningCertificates?: Maybe<Scalars['JSON']>;
  initiateLoginFlow?: Maybe<Scalars['JSON']>;
  patch?: Maybe<ThirdPartyOrganizationsV1Connection>;
  setIsReal?: Maybe<Scalars['JSON']>;
  setOrganizationEmployeeRange?: Maybe<Scalars['JSON']>;
  setOrganizationType?: Maybe<Scalars['JSON']>;
  update?: Maybe<ThirdPartyOrganizationsV1Connection>;
  updateEntityId?: Maybe<Scalars['JSON']>;
  updateMetadata?: Maybe<Scalars['JSON']>;
  updateSigningCertificate?: Maybe<Scalars['JSON']>;
};


export type ThirdPartyOrganizationsV1ResourceMutationsGetMetadataDownloadUrlArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsGetMetadataExpiryArgs = {
  id: Scalars['String'];
  refreshDays: Scalars['Int'];
  warningDays: Scalars['Int'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsGetMetadataUploadUrlArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsGetSigningCertificatesArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsInitiateLoginFlowArgs = {
  format?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isMobile?: InputMaybe<Scalars['Boolean']>;
  returnTo?: InputMaybe<Scalars['String']>;
};


export type ThirdPartyOrganizationsV1ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsSetIsRealArgs = {
  id: Scalars['String'];
  isReal: Scalars['Boolean'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsSetOrganizationEmployeeRangeArgs = {
  id: Scalars['String'];
  organizationEmployeeRange: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsSetOrganizationTypeArgs = {
  id: Scalars['String'];
  organizationType: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsUpdateEntityIdArgs = {
  entityId: Scalars['String'];
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsUpdateMetadataArgs = {
  id: Scalars['String'];
};


export type ThirdPartyOrganizationsV1ResourceMutationsUpdateSigningCertificateArgs = {
  id: Scalars['String'];
  signingCertificateFingerprint: Scalars['String'];
};

export type ThirdPartyOrganizationsV1_Metadata = ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Jwt_ThirdPartyOrganizationJwtMetadataMember | ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Saml_ThirdPartyOrganizationSamlMetadataMember;

export type ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_ThirdPartyOrganizationAddress = {
  __typename?: 'ThirdPartyOrganizationsV1_org_coursera_authentication_thirdpartyauth_ThirdPartyOrganizationAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Jwt_ThirdPartyOrganizationJwtMetadata = {
  __typename?: 'ThirdPartyOrganizationsV1_org_coursera_authentication_thirdpartyauth_jwt_ThirdPartyOrganizationJwtMetadata';
  emailField: Scalars['String'];
  nameField: Scalars['String'];
  opaqueIdField: Scalars['String'];
  secretKeys: Array<Maybe<Scalars['String']>>;
};

export type ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Jwt_ThirdPartyOrganizationJwtMetadataMember = {
  __typename?: 'ThirdPartyOrganizationsV1_org_coursera_authentication_thirdpartyauth_jwt_ThirdPartyOrganizationJwtMetadataMember';
  org_coursera_authentication_thirdpartyauth_jwt_ThirdPartyOrganizationJwtMetadata: ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Jwt_ThirdPartyOrganizationJwtMetadata;
};

export type ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Saml_ThirdPartyOrganizationSamlMetadata = {
  __typename?: 'ThirdPartyOrganizationsV1_org_coursera_authentication_thirdpartyauth_saml_ThirdPartyOrganizationSamlMetadata';
  allowsIdpInitiatedLogin: Scalars['Boolean'];
  emailAttribute: Scalars['String'];
  externalIdAttribute?: Maybe<Scalars['String']>;
  firstNameAttribute?: Maybe<Scalars['String']>;
  lastNameAttribute?: Maybe<Scalars['String']>;
  nameAttribute?: Maybe<Scalars['String']>;
  opaqueIdAttribute: Scalars['String'];
  refreshUrl?: Maybe<Scalars['String']>;
  signSamlRequest: Scalars['Boolean'];
  signingAlgorithm: Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm;
  signingCertificateFingerprint?: Maybe<Scalars['String']>;
};

export type ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Saml_ThirdPartyOrganizationSamlMetadataMember = {
  __typename?: 'ThirdPartyOrganizationsV1_org_coursera_authentication_thirdpartyauth_saml_ThirdPartyOrganizationSamlMetadataMember';
  org_coursera_authentication_thirdpartyauth_saml_ThirdPartyOrganizationSamlMetadata: ThirdPartyOrganizationsV1_Org_Coursera_Authentication_Thirdpartyauth_Saml_ThirdPartyOrganizationSamlMetadata;
};

/**
 * TimeAndSubmissionLimitSummary indicates that learner has limited submissions and limited time. If the learner
 * runs out of either submissions or time, they will not be able to make submissions.
 */
export type TimeAndSubmissionLimitSummary = {
  __typename?: 'TimeAndSubmissionLimitSummary';
  /** The total time in milliseconds given for their assignment. */
  allowedDuration: Scalars['Int'];
  /** Total number of allowed submissions for their assignment. */
  allowedSubmissions: Scalars['Int'];
  /**
   * The current attempt status indicating whether they can make submissions or not. They can only make submissions
   * if the attempt is in progress.
   */
  attemptStatus: AttemptStatus;
  /** The remaining time in milliseconds before their attempt gets closed/completed. */
  remainingDuration: Scalars['Int'];
  /** The remaining remaining submissions before their attempt gets closed/completed. */
  remainingSubmissions: Scalars['Int'];
};

/** TimeLImitSummary indicates that learner has limited time but unlimited submissions. */
export type TimeLimitSummary = {
  __typename?: 'TimeLimitSummary';
  /** The total time in milliseconds given for their assignment. */
  allowedDuration: Scalars['Int'];
  /**
   * The current attempt status indicating whether they can make submissions or not. They can only make submissions
   * if the attempt is in progress.
   */
  attemptStatus: AttemptStatus;
  /** The remaining time in milliseconds before their attempt gets closed/completed. */
  remainingDuration: Scalars['Int'];
};

/**
 * GraphQL version of google.protobuf.Timestamp
 * A type representing a point in time independent of any time zone or local calendar, encoded as a count of
 * seconds and fractions of seconds at nanoseccond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the Gregorian calendar backwards to year one.
 */
export type Timestamp = {
  __typename?: 'Timestamp';
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999 inclusive.
   */
  nanos: Scalars['Int'];
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   * Note - since GraphQL does not support 64-bit Integers/Longs, defined with String type here.
   */
  seconds: Scalars['String'];
};

/**
 * GraphQL version of google.protobuf.Timestamp used for Input
 * A type representing a point in time independent of any time zone or local calendar, encoded as a count of
 * seconds and fractions of seconds at nanoseccond resolution. The count is relative to an epoch at UTC midnight on
 * January 1, 1970, in the proleptic Gregorian calendar which extends the Gregorian calendar backwards to year one.
 */
export type TimestampInput = {
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999 inclusive.
   */
  nanos: Scalars['Int'];
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   * Note - since GraphQL does not support 64-bit Integers/Longs, defined with String type here.
   */
  seconds: Scalars['String'];
};

/** Mutation failure */
export type TranscriptionWorkflow_MutationFailure = {
  __typename?: 'TranscriptionWorkflow_MutationFailure';
  /** Readable message provides the error details. */
  errorMessage: Scalars['String'];
};

/** Mutation success */
export type TranscriptionWorkflow_MutationSuccess = {
  __typename?: 'TranscriptionWorkflow_MutationSuccess';
  /** Transcription workflow */
  workflow: Subtitles_TranscriptionWorkflow;
};

/** The current status of the workflow */
export const Transcription_WorkflowStatus = {
  /** The workflow completed successfully */
  Completed: 'COMPLETED',
  /** The workflow ran into an error while executing */
  Failed: 'FAILED',
  /** The workflow was created, but the associated Airflow jobs have not yet run */
  NotStarted: 'NOT_STARTED',
  /** The associated Airflow jobs is running to transcribe */
  Transcribing: 'TRANSCRIBING'
} as const;

export type Transcription_WorkflowStatus = typeof Transcription_WorkflowStatus[keyof typeof Transcription_WorkflowStatus];
/**
 * TranslateContentQueries
 *
 * IMPORTANT: Batch Translation API's will enforce a limit of 20 elements per batch
 */
export type TranslateContentQueries = {
  __typename?: 'TranslateContentQueries';
  /** Translate CML */
  batchTranslateCml: TranslateContent_BatchTranslateCmlResult;
  /** Translate HTML */
  batchTranslateHtml: TranslateContent_BatchTranslateHtmlResult;
  /** Translate Plain Text */
  batchTranslatePlainText: TranslateContent_BatchTranslatePlainTextResult;
};


/**
 * TranslateContentQueries
 *
 * IMPORTANT: Batch Translation API's will enforce a limit of 20 elements per batch
 */
export type TranslateContentQueriesBatchTranslateCmlArgs = {
  inputs: Array<CmlContentInput>;
  languageSettings: TranslateContent_TranslateLanguageSettings;
};


/**
 * TranslateContentQueries
 *
 * IMPORTANT: Batch Translation API's will enforce a limit of 20 elements per batch
 */
export type TranslateContentQueriesBatchTranslateHtmlArgs = {
  inputs: Array<Scalars['String']>;
  languageSettings: TranslateContent_TranslateLanguageSettings;
};


/**
 * TranslateContentQueries
 *
 * IMPORTANT: Batch Translation API's will enforce a limit of 20 elements per batch
 */
export type TranslateContentQueriesBatchTranslatePlainTextArgs = {
  inputs: Array<Scalars['String']>;
  languageSettings: TranslateContent_TranslateLanguageSettings;
};

/** TranslateContent_TranslateCMLBatchResult */
export type TranslateContent_BatchTranslateCmlResult = TranslateContent_BatchTranslateCmlSuccess | TranslateContent_RateLimitError | TranslateContent_TranslateInvalidArgumentError;

/** TranslateContent_BatchTranslateCMLSuccess */
export type TranslateContent_BatchTranslateCmlSuccess = {
  __typename?: 'TranslateContent_BatchTranslateCMLSuccess';
  /**
   * Source Language that the Translation Third Party detected or source language that was passed in.
   * Can be null if translation third party fails to detect language
   */
  detectedSourceLanguage?: Maybe<Scalars['String']>;
  /**
   * Apollo is using the id property for caching and when it's missing there may be some issues.
   *
   * It's also recommended here:
   * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Best+Practices+and+Conventions#Every-type-should-have-an-ID%2C-when-possible
   */
  id: Scalars['ID'];
  /**
   * Translated results array will always be the same length
   * as the input array. If a particular element fails to load,
   * we will return an Error object with fallback value
   */
  results: Array<TranslateContent_TranslateCmlResult>;
};

/** TranslateContent_TranslateHTMLBatchResult */
export type TranslateContent_BatchTranslateHtmlResult = TranslateContent_BatchTranslateHtmlSuccess | TranslateContent_RateLimitError | TranslateContent_TranslateInvalidArgumentError;

/** TranslateContent_BatchTranslateHTMLSuccess */
export type TranslateContent_BatchTranslateHtmlSuccess = {
  __typename?: 'TranslateContent_BatchTranslateHTMLSuccess';
  /**
   * Source Language that the Translation Third Party detected or source language that was passed in.
   * Can be null if translation third party fails to detect language
   */
  detectedSourceLanguage?: Maybe<Scalars['String']>;
  /**
   * Apollo is using the id property for caching and when it's missing there may be some issues.
   *
   * It's also recommended here:
   * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Best+Practices+and+Conventions#Every-type-should-have-an-ID%2C-when-possible
   */
  id: Scalars['ID'];
  /**
   * Translated results array will always be the same length
   * as the input array. If a particular element fails to load,
   * we will return an Error object with fallback value
   */
  results: Array<TranslateContent_TranslateHtmlResult>;
};

/** TranslateContent_BatchTranslatePlainTextResult */
export type TranslateContent_BatchTranslatePlainTextResult = TranslateContent_BatchTranslatePlainTextSuccess | TranslateContent_RateLimitError | TranslateContent_TranslateInvalidArgumentError;

/** TranslateContent_BatchTranslatePlainTextSuccess */
export type TranslateContent_BatchTranslatePlainTextSuccess = {
  __typename?: 'TranslateContent_BatchTranslatePlainTextSuccess';
  /**
   * Source Language that the Translation Third Party detected or source language that was passed in.
   * Can be null if translation third party fails to detect language
   */
  detectedSourceLanguage?: Maybe<Scalars['String']>;
  /**
   * Apollo is using the id property for caching and when it's missing there may be some issues.
   *
   * It's also recommended here:
   * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Best+Practices+and+Conventions#Every-type-should-have-an-ID%2C-when-possible
   */
  id: Scalars['ID'];
  /**
   * Translated results array will always be the same length
   * as the input array. If a particular element fails to load,
   * we will return an Error object with fallback value
   */
  results: Array<TranslateContent_TranslatePlainTextResult>;
};

/**
 * Shared standardized error interface, which allows clients to define fallback behaviour for new error types coming from the backend that clients may not be updated to handle yet
 * (e.g. older mobile app versions).
 *
 * https://coursera.atlassian.net/wiki/spaces/EN/pages/1741815811/GraphQL+Schema+Best+Practices+and+Conventions#Mutation-Results-(Actionable-Errors)
 */
export type TranslateContent_Error = {
  /** A readable message providing the error details. */
  message: Scalars['String'];
};

/**
 * TranslateContent_RateLimitError
 *
 * This can be returned for the following reasons
 * - User has made too many requests to the API per minute
 */
export type TranslateContent_RateLimitError = TranslateContent_Error & {
  __typename?: 'TranslateContent_RateLimitError';
  /** Error Message */
  message: Scalars['String'];
};

/**
 * TranslateContent_TranslateCMLFailedError
 *
 * This can be returned for the following reasons
 * - 3rd party translation engine is unavailable
 * - Input values are invalid and cannot be parsed
 * - Translated result from 3rd party translation engine is invalid
 *
 * Will return a default fallbackValue for the FE to display based
 */
export type TranslateContent_TranslateCmlFailedError = TranslateContent_Error & {
  __typename?: 'TranslateContent_TranslateCMLFailedError';
  /**
   * fallbackValue incase of translation failure.
   * Will be an empty CML <co-content> block
   */
  fallbackValue: Cml_Cml;
  /** Error Message */
  message: Scalars['String'];
};

/** TranslateCML Payload */
export type TranslateContent_TranslateCmlPayload = {
  __typename?: 'TranslateContent_TranslateCMLPayload';
  /** CML */
  cml: Cml_Cml;
};

/** TranslateContent_BatchTranslateCMLResult */
export type TranslateContent_TranslateCmlResult = TranslateContent_TranslateCmlFailedError | TranslateContent_TranslateCmlPayload;

/**
 * TranslateContent_TranslateFailedError
 *
 * This can be returned for the following reasons
 * - 3rd party translation engine is unavailable
 * - Input values are invalid and cannot be parsed
 * - Translated result from 3rd party translation engine is invalid
 */
export type TranslateContent_TranslateFailedError = TranslateContent_Error & {
  __typename?: 'TranslateContent_TranslateFailedError';
  /**
   * FallbackValue if translation fails.
   * Will be an empty string if original input was plain text, or empty <div> if input was HTML
   */
  fallbackValue: Scalars['String'];
  /** Error Message */
  message: Scalars['String'];
};

/** TranslateHTML Payload */
export type TranslateContent_TranslateHtmlPayload = {
  __typename?: 'TranslateContent_TranslateHTMLPayload';
  /** HTML */
  html: Scalars['String'];
};

/** TranslateContent_BatchTranslateCMLResult */
export type TranslateContent_TranslateHtmlResult = TranslateContent_TranslateFailedError | TranslateContent_TranslateHtmlPayload;

/**
 * TranslateContent_TranslateInvalidArgumentError
 *
 * This can be returned for the following reasons
 * - Number of elements requested for Translation in a single batch call is too large (max of 20)
 */
export type TranslateContent_TranslateInvalidArgumentError = TranslateContent_Error & {
  __typename?: 'TranslateContent_TranslateInvalidArgumentError';
  /** Error Message */
  message: Scalars['String'];
};

/** Translate Language Settings */
export type TranslateContent_TranslateLanguageSettings = {
  /**
   * Language of the source content. Eg. en-US, zh-CN, es-US.
   * If not provided, will attempt to auto detect
   */
  sourceLanguage?: InputMaybe<Scalars['String']>;
  /**
   * Language to translate to. Eg. en-US, zh-CN, es-US.
   * If not provided, will translate to the language in users profile.
   */
  targetLanguage?: InputMaybe<Scalars['String']>;
};

/** TranslatePlainText Payload */
export type TranslateContent_TranslatePlainTextPayload = {
  __typename?: 'TranslateContent_TranslatePlainTextPayload';
  /** Plain Text */
  plainText: Scalars['String'];
};

/** TranslateContent_BatchTranslatePlainTextResult */
export type TranslateContent_TranslatePlainTextResult = TranslateContent_TranslateFailedError | TranslateContent_TranslatePlainTextPayload;

/**
 * Details on why the Translation is poor such as
 * the portion of text that was wrong, and how to improve it.
 */
export type TranslationFeedback_Details = {
  /** The mistranslated text, or a description of where it is and possible improvement */
  feedback: Scalars['String'];
  /** An array of potential reasons that the user can select on why the translation is inaccurate */
  reasonsForFeedback: Array<TranslationFeedback_ReasonForFeedback>;
};

/** TranslationFeedback-specific error interface */
export type TranslationFeedback_Error = {
  /** Error Message */
  message: Scalars['String'];
};

/** TranslationFeedback_ReasonForFeedback */
export const TranslationFeedback_ReasonForFeedback = {
  /** Translation is not clear */
  HardToUnderstand: 'HARD_TO_UNDERSTAND',
  /** Translation contains offensive or harmful words that are not appropriate */
  HarmfulOffensive: 'HARMFUL_OFFENSIVE',
  /** Any other reason that isn't listed above */
  Other: 'OTHER',
  /** Text is only partially translated */
  PartialTranslation: 'PARTIAL_TRANSLATION'
} as const;

export type TranslationFeedback_ReasonForFeedback = typeof TranslationFeedback_ReasonForFeedback[keyof typeof TranslationFeedback_ReasonForFeedback];
/** Error message if reporting feedback fails */
export type TranslationFeedback_ReportFeedbackError = Error & TranslationFeedback_Error & {
  __typename?: 'TranslationFeedback_ReportFeedbackError';
  /** Inherited field from TranslationFeedback_Error interface */
  message: Scalars['String'];
};

/** Feedback Input */
export type TranslationFeedback_ReportFeedbackInput = {
  /** The details of the feedback */
  details: TranslationFeedback_Details;
  /** Language the user viewed the translation in. Eg. en-US, zh-CN, es-US */
  languageCode: Scalars['String'];
  /**
   * May also be called refererKey in other areas.
   * This should be the URL the user is on when
   * the feedback is submitted.
   */
  refererURL: Scalars['URL'];
  /** Additional info to locate where the feedback was submitted */
  trackingInfo: TranslationFeedback_TrackingInfo;
  /** UserId that submitted feedback, None if logged out user */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Result for reporting feedback */
export type TranslationFeedback_ReportFeedbackResult = TranslationFeedback_ReportFeedbackError | TranslationFeedback_ReportFeedbackSuccess;

/** TranslationFeedback_ReportFeedbackSuccess */
export type TranslationFeedback_ReportFeedbackSuccess = {
  __typename?: 'TranslationFeedback_ReportFeedbackSuccess';
  /** Id of feedback record that was created */
  id: Scalars['ID'];
};

/** TranslationFeedback_TrackingInfo */
export type TranslationFeedback_TrackingInfo = {
  /** TrackingInfo for Enterprise Pages */
  enterpriseTrackingInfo?: InputMaybe<TranslationFeedback_TrackingInfo_Enterprise>;
  /** TrackingInfo for InCourse */
  inCourseTrackingInfo?: InputMaybe<TranslationFeedback_TrackingInfo_InCourse>;
};

/** Should be used for any feedback gathered under Enterprise /program */
export type TranslationFeedback_TrackingInfo_Enterprise = {
  /** Enterprise Org Id */
  enterpriseOrgId: Scalars['ID'];
  /** Program Slug */
  programSlug?: InputMaybe<Scalars['String']>;
  /** Name of possible Skill Set */
  skillSet?: InputMaybe<Scalars['String']>;
  /**
   * A comma delimited string of the skills.
   * Eg. java,computer science,business
   */
  skills?: InputMaybe<Scalars['String']>;
};

/** Should be used for any feedback gathered under /learn */
export type TranslationFeedback_TrackingInfo_InCourse = {
  /** CourseId */
  courseId: Scalars['ID'];
  /** CourseSlug */
  courseSlug: Scalars['String'];
  /** ItemId */
  itemId?: InputMaybe<Scalars['ID']>;
  /** ModuleId */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/** Trimming Range queries */
export type TrimmingRange_Queries = {
  __typename?: 'TrimmingRange_Queries';
  /** Retrieves a single trimming range for a given branch id and assetVideoId, returns null if not present. */
  getTrimmingRangeByBranchAndVideoId?: Maybe<AssetVideo_TrimmingRangesForBranches>;
};


/** Trimming Range queries */
export type TrimmingRange_QueriesGetTrimmingRangeByBranchAndVideoIdArgs = {
  authoringCourseBranchId: Scalars['ID'];
  videoId: Scalars['ID'];
};

/** TODO: Complete this description */
export type TurnitinTenantEntryQueries = {
  __typename?: 'TurnitinTenantEntryQueries';
  /**
   * We use programType and slug to get id.
   * This query returns Turnitin entry details filtered by program type and slug.
   * If it's a DEGREE type, the slug should be a program slug.
   * If it's an ENTERPRISE type, the slug should be an organization slug.
   * Both programType and slug should be provided.
   */
  queryTurnitinTenantEntryDetailsByProgramTypeAndSlug: TurnitinTenant_EntryDetails;
  /**
   * This query returns turnitin entry details filtered by userId and courseId.
   * Both userId and courseId should be provided.
   */
  queryTurnitinTenantEntryDetailsByUserAndCourseId: TurnitinTenant_EntryDetails;
};


/** TODO: Complete this description */
export type TurnitinTenantEntryQueriesQueryTurnitinTenantEntryDetailsByProgramTypeAndSlugArgs = {
  programType: SimilarityCheckContextType;
  slug: Scalars['String'];
};


/** TODO: Complete this description */
export type TurnitinTenantEntryQueriesQueryTurnitinTenantEntryDetailsByUserAndCourseIdArgs = {
  courseId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** TODO: Complete this description */
export type TurnitinTenant_CreateEntryInput = {
  /** programType helps to distinguish between DEGREE and ENTERPRISE program */
  programType: SimilarityCheckContextType;
  /**
   * If it's a DEGREE type, the slug should be a program slug.
   * If it's an ENTERPRISE type, the slug should be an organization slug.
   */
  slug: Scalars['String'];
  /** turnitinAPIKey will be used in header when GET/POST. */
  turnitinAPIKey: Scalars['String'];
  /**
   * We need to store turnitinTenantUrl in the sim_check_api_metadata_main collection
   * to enable vericite to make requests to the right tenant.
   * The CoreAPI class uses this url to make HTTP requests to Turnitin.
   */
  turnitinTenantUrl: Scalars['String'];
};

/** TODO: Complete this description */
export type TurnitinTenant_CreateEntryPayload = {
  __typename?: 'TurnitinTenant_createEntryPayload';
  /** SimilarityCheckContextId. */
  contextId?: Maybe<Scalars['ID']>;
};

/** TODO: Complete this description */
export type TurnitinTenant_EntryDetails = {
  __typename?: 'TurnitinTenant_entryDetails';
  /** ApiStatus shows whether the webhook is configured or not. */
  apiStatus: ApiStatusType;
  /** The url of the turnitin API used. */
  baseUrl: Scalars['String'];
  /** The time the configuration was created. */
  createdAt: Scalars['String'];
  /** The userId of the user who input this configuration. */
  createdBy: Scalars['ID'];
  /** The family name for the API, currently this is always “coursera”. */
  family: Scalars['String'];
  /** The version of the API used, currently this is always “1.0.0”. */
  version: Scalars['String'];
};

/** All ULBA API queries */
export type UlbaQueries = {
  __typename?: 'UlbaQueries';
  /** Get all latest ULBA jobs for a branch at the branch and lesson level */
  getAllLatestUlbaJobs: Ulba_GetAllLatestUlbaJobsResult;
  /** Get the current progress for loading course materials */
  getUlbaJobLoadingProgress: Ulba_GetUlbaJobLoadingProgressResult;
  /** Get the status of a ULBA job using course information */
  getUlbaJobStatus: Ulba_GetUlbaJobStatusResult;
};


/** All ULBA API queries */
export type UlbaQueriesGetAllLatestUlbaJobsArgs = {
  input: Ulba_GetAllLatestUlbaJobsInput;
};


/** All ULBA API queries */
export type UlbaQueriesGetUlbaJobLoadingProgressArgs = {
  input: Ulba_GetUlbaJobLoadingProgressInput;
};


/** All ULBA API queries */
export type UlbaQueriesGetUlbaJobStatusArgs = {
  input: Ulba_GetUlbaJobStatusInput;
};

/**
 * An error in the client request
 * Used in: Ulba_QueryFailure, Ulba_MutationFailure
 */
export type Ulba_ClientValidationError = Ulba_Error & {
  __typename?: 'Ulba_ClientValidationError';
  /** Error message */
  message: Scalars['String'];
};

/**
 * Content structure type
 * Used in: Ulba_UlbaSummary, Ulba_ExportEntityCount
 */
export const Ulba_ContentType = {
  /** Course level content */
  Course: 'COURSE',
  /** Item level content */
  Item: 'ITEM',
  /** Learning objective */
  LearningObjective: 'LEARNING_OBJECTIVE',
  /** Learning objective reference */
  LearningObjectiveReference: 'LEARNING_OBJECTIVE_REFERENCE',
  /** Lesson level content */
  Lesson: 'LESSON',
  /** Module level content */
  Module: 'MODULE',
  /** Question bank */
  QuestionBank: 'QUESTION_BANK',
  /** Sub-item content */
  SubItem: 'SUB_ITEM'
} as const;

export type Ulba_ContentType = typeof Ulba_ContentType[keyof typeof Ulba_ContentType];
/**
 * An error that happened in Course Builder during Smart Ingestion initiation
 * Used in: Ulba_MutationFailure for Ulba_UpdateUlbaJobStartSmartIngestionSync mutation
 */
export type Ulba_CourseBuilderError = Ulba_Error & {
  __typename?: 'Ulba_CourseBuilderError';
  /** Error message */
  message: Scalars['String'];
};

/**
 * Input for creating a ULBA job
 * Used in: Ulba_CreateUlbaJob mutation
 */
export type Ulba_CreateUlbaJobInput = {
  /** Destination information */
  destination: Ulba_DestinationInput;
  /**
   * Ingestion strategy to determine parsing and loading flow.
   * If not specified, defaults to CLASSIC for backward compatibility.
   * - CLASSIC: Uses traditional parsing and loading via startLoading()
   * - SMART_INGESTION: Uses node-based parsing with immediate Course Builder handoff
   */
  ingestionStrategy?: Ulba_IngestionStrategy;
  /** Source information */
  source: Ulba_SourceInput;
};

/**
 * Result of creating a ULBA job
 * Used in: Ulba_CreateUlbaJob mutation
 */
export type Ulba_CreateUlbaJobResult = Ulba_CreateUlbaJobSuccess | Ulba_CreateUlbaJobWithCourseBuilderHandoffSuccess | Ulba_MutationFailure;

/**
 * Success result for creating a ULBA job
 * Used in: Ulba_CreateUlbaJob mutation
 */
export type Ulba_CreateUlbaJobSuccess = {
  __typename?: 'Ulba_CreateUlbaJobSuccess';
  /** Destination information */
  destination: Ulba_Destination;
  /** Created job ID */
  jobId: Scalars['ID'];
  /** Parse result */
  parseResult: Ulba_UlbaParseResult;
  /** Source information */
  source: Ulba_Source;
  /** Summary of processed content */
  ulbaSummary: Array<Ulba_UlbaSummary>;
};

/**
 * Success type for ULBA job with direct Course Builder handoff
 * Used in: Ulba_CreateUlbaJob mutation when SMART_INGESTION strategy is used
 */
export type Ulba_CreateUlbaJobWithCourseBuilderHandoffSuccess = {
  __typename?: 'Ulba_CreateUlbaJobWithCourseBuilderHandoffSuccess';
  /** ID of the ULBA job */
  jobId: Scalars['ID'];
  /** Course Builder workflow with ID (federated entity - gateway will resolve additional fields) */
  workflow: CourseBuilderV2_Workflow;
};

/**
 * Describes where/the use case where the course materials are being processed for.
 * Used in: Ulba_UlbaJob, Ulba_CreateUlbaJobSuccess, Ulba_GetUlbaJobStatusSuccess
 */
export type Ulba_Destination = {
  __typename?: 'Ulba_Destination';
  /** Course entity - enables fetching the Course object and its ID */
  course: Course_Course;
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Item ID (optional) */
  itemId?: Maybe<Scalars['ID']>;
  /** Lesson ID (optional) */
  lessonId?: Maybe<Scalars['ID']>;
  /** Module ID (optional) */
  moduleId?: Maybe<Scalars['ID']>;
  /** Type of destination */
  typeName: Ulba_UlbaDestinationType;
};

/**
 * Describes where/the use case where the course materials are being processed for.
 * Used in: Ulba_CreateUlbaJobInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_DestinationInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID (optional) */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson ID (optional) */
  lessonId?: InputMaybe<Scalars['ID']>;
  /** Module ID (optional) */
  moduleId?: InputMaybe<Scalars['ID']>;
  /** Type of destination */
  typeName: Ulba_UlbaDestinationType;
};

/**
 * Namespaced error interface
 * Used in: Ulba_QueryFailure, Ulba_MutationFailure
 */
export type Ulba_Error = {
  /** Error message */
  message: Scalars['String'];
};

/**
 * Input for exporting course structure
 * Used in: Ulba_ExportCourseStructure mutation
 */
export type Ulba_ExportCourseStructureInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/**
 * Result of exporting course structure
 * Used in: Ulba_ExportCourseStructure mutation
 */
export type Ulba_ExportCourseStructureResult = Ulba_ExportCourseStructureSuccess | Ulba_MutationFailure;

/**
 * Success result for exporting course structure
 * Used in: Ulba_ExportCourseStructure mutation
 */
export type Ulba_ExportCourseStructureSuccess = {
  __typename?: 'Ulba_ExportCourseStructureSuccess';
  /** Error message if export failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** Count of exported entities by type */
  exportEntityCount: Array<Ulba_ExportEntityCount>;
  /** Export download link */
  exportLink?: Maybe<Scalars['URL']>;
};

/**
 * Export entity count
 * Used in: Ulba_ExportCourseStructureSuccess for Ulba_ExportCourseStructure mutation
 */
export type Ulba_ExportEntityCount = {
  __typename?: 'Ulba_ExportEntityCount';
  /** Content type */
  contentType: Ulba_ContentType;
  /** Number of entities of this type */
  entityCount: Scalars['Int'];
};

/**
 * Input for getting all latest ULBA jobs
 * Used in: getAllLatestUlbaJobs query
 */
export type Ulba_GetAllLatestUlbaJobsInput = {
  /** Branch ID */
  branchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
};

/**
 * Result of getting all latest ULBA jobs
 * Used in: getAllLatestUlbaJobs query
 */
export type Ulba_GetAllLatestUlbaJobsResult = Ulba_GetAllLatestUlbaJobsSuccess | Ulba_QueryFailure;

/**
 * Success result for getting all latest ULBA jobs
 * Used in: getAllLatestUlbaJobs query
 */
export type Ulba_GetAllLatestUlbaJobsSuccess = {
  __typename?: 'Ulba_GetAllLatestUlbaJobsSuccess';
  /** Map of ULBA jobs by reference ID */
  ulbaJobs: Array<Ulba_UlbaJobEntry>;
};

/**
 * Input for getting ULBA job loading progress
 * Used in: getUlbaJobLoadingProgress query
 */
export type Ulba_GetUlbaJobLoadingProgressInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Result of getting ULBA job loading progress
 * Used in: getUlbaJobLoadingProgress query
 */
export type Ulba_GetUlbaJobLoadingProgressResult = Ulba_GetUlbaJobLoadingProgressSuccess | Ulba_QueryFailure;

/**
 * Success result for getting loading progress
 * Used in: getUlbaJobLoadingProgress query
 */
export type Ulba_GetUlbaJobLoadingProgressSuccess = {
  __typename?: 'Ulba_GetUlbaJobLoadingProgressSuccess';
  /** Number of items completed so far */
  curItemsCompleted: Scalars['Int'];
  /** Total number of items to process */
  totalItems: Scalars['Int'];
};

/**
 * Input for getting ULBA job status
 * Used in: getUlbaJobStatus query
 */
export type Ulba_GetUlbaJobStatusInput = {
  /** Course branch ID */
  courseBranchId: Scalars['ID'];
  /** Course ID */
  courseId: Scalars['ID'];
  /** Item ID (optional) */
  itemId?: InputMaybe<Scalars['ID']>;
  /** Lesson ID (optional) */
  lessonId?: InputMaybe<Scalars['ID']>;
  /** Module ID (optional) */
  moduleId?: InputMaybe<Scalars['ID']>;
};

/**
 * Result of getting ULBA job status
 * Used in: getUlbaJobStatus query
 */
export type Ulba_GetUlbaJobStatusResult = Ulba_GetUlbaJobStatusSuccess | Ulba_QueryFailure;

/**
 * Success result for getting ULBA job status
 * Used in: getUlbaJobStatus query
 */
export type Ulba_GetUlbaJobStatusSuccess = {
  __typename?: 'Ulba_GetUlbaJobStatusSuccess';
  /** Destination information */
  destination: Ulba_Destination;
  /** Job ID */
  jobId: Scalars['ID'];
  /** Load result */
  loadResult?: Maybe<Ulba_UlbaLoadResult>;
  /** Parse result */
  parseResult?: Maybe<Ulba_UlbaParseResult>;
  /** Source information */
  source: Ulba_Source;
  /** Summary of processed content */
  ulbaSummary: Array<Ulba_UlbaSummary>;
};

/**
 * Ingestion strategy for ULBA job processing
 * Used in: Ulba_CreateUlbaJobInput
 */
export const Ulba_IngestionStrategy = {
  /** Classic ingestion flow using traditional loading via startLoading() */
  Classic: 'CLASSIC',
  /** Smart Ingestion flow with node-based parsing and immediate Course Builder handoff */
  SmartIngestion: 'SMART_INGESTION'
} as const;

export type Ulba_IngestionStrategy = typeof Ulba_IngestionStrategy[keyof typeof Ulba_IngestionStrategy];
/**
 * Identifies the type of item (e.g., assignment, quiz, video, etc.)
 * Used in: Ulba_UlbaSummary
 */
export const Ulba_ItemType = {
  /** Discussion prompt item */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Graded discussion prompt item */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** LTI item */
  LtiItem: 'LTI_ITEM',
  /** Peer review item */
  PeerReview: 'PEER_REVIEW',
  /** Programming assignment item */
  Programming: 'PROGRAMMING',
  /** Quiz item */
  Quiz: 'QUIZ',
  /** Reading item */
  Reading: 'READING',
  /** Staff graded assignment item */
  StaffGradedAssignment: 'STAFF_GRADED_ASSIGNMENT',
  /** Teammate review item */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab item */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded plugin item */
  UngradedPlugin: 'UNGRADED_PLUGIN',
  /** Unresolved item type */
  Unresolved: 'UNRESOLVED',
  /** Unset item type */
  Unset: 'UNSET',
  /** Video item */
  Video: 'VIDEO'
} as const;

export type Ulba_ItemType = typeof Ulba_ItemType[keyof typeof Ulba_ItemType];
/**
 * Common failure type for ULBA mutations
 * Used in: Ulba_CreateUlbaJob, Ulba_UpdateUlbaJobStartLoading, Ulba_UpdateUlbaJobDismissReport,
 *          Ulba_ExportCourseStructure, Ulba_UpdateUlbaJobStartSmartIngestionSync mutations
 */
export type Ulba_MutationFailure = {
  __typename?: 'Ulba_MutationFailure';
  /** List of errors */
  errors: Array<Ulba_ClientValidationError | Ulba_CourseBuilderError>;
};

/**
 * Query failure type
 * Used in: getAllLatestUlbaJobs, getUlbaJobStatus, getUlbaJobLoadingProgress queries
 */
export type Ulba_QueryFailure = {
  __typename?: 'Ulba_QueryFailure';
  /** List of errors */
  errors: Array<Ulba_ClientValidationError | Ulba_CourseBuilderError>;
};

/**
 * S3 object location
 * Used in: Ulba_Source (output) and Ulba_SourceInput (input)
 */
export type Ulba_S3Object = {
  __typename?: 'Ulba_S3Object';
  /** S3 bucket name */
  bucket: Scalars['String'];
  /** S3 object key */
  key: Scalars['String'];
};

/**
 * S3 object input
 * Used in: Ulba_SourceInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_S3ObjectInput = {
  /** S3 bucket name */
  bucket: Scalars['String'];
  /** S3 object key */
  key: Scalars['String'];
};

/**
 * Success type for Smart Ingestion ULBA job mutation
 * Used in: Ulba_UpdateUlbaJobStartSmartIngestionSync mutation
 */
export type Ulba_SmartIngestionJobMutationSuccess = {
  __typename?: 'Ulba_SmartIngestionJobMutationSuccess';
  /**
   * Course Builder workflow ID for the workflow which is associated with this ULBA job
   * @deprecated Use workflow instead, which is a federated entity the gateway can resolve automatically.
   */
  courseBuilderWorkflowId: Scalars['ID'];
  /** ID of the ULBA job */
  jobId: Scalars['ID'];
  /** Course Builder workflow (federated entity - gateway will resolve additional fields) */
  workflow: CourseBuilderV2_Workflow;
};

/**
 * Describes where the ULBA file is coming from. The content to upload is defined in one of 3 ways:
 * 1. the S3 object location (sourceDefinition),
 * 2. the assembly info (transloaditFiles and transloaditData) or
 * 3. the text itself (textContent).
 *
 * Used in: Ulba_UlbaJob, Ulba_CreateUlbaJobSuccess, Ulba_GetUlbaJobStatusSuccess
 */
export type Ulba_Source = {
  __typename?: 'Ulba_Source';
  /** Source filename */
  filename: Scalars['String'];
  /** S3 object location (optional) */
  sourceDefinition?: Maybe<Ulba_S3Object>;
  /** Text content (optional) */
  textContent?: Maybe<Scalars['String']>;
  /** Transloadit data (optional) */
  transloaditData?: Maybe<Scalars['String']>;
  /** Transloadit file information (optional) */
  transloaditFiles?: Maybe<Array<Ulba_TransloaditFileInfo>>;
  /** Type of source */
  typeName: Ulba_UlbaSourceType;
};

/**
 * Describes where the ULBA file is coming from. The content to upload is defined in one of 3 ways:
 * 1. the S3 object location (sourceDefinition),
 * 2. the assembly info (transloaditFiles and transloaditData) or
 * 3. the text itself (textContent).
 *
 * Used in: Ulba_CreateUlbaJobInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_SourceInput = {
  /** Source filename */
  filename: Scalars['String'];
  /** S3 object location (optional) */
  sourceDefinition?: InputMaybe<Ulba_S3ObjectInput>;
  /** Text content (optional) */
  textContent?: InputMaybe<Scalars['String']>;
  /** Transloadit data (optional) */
  transloaditData?: InputMaybe<Scalars['String']>;
  /** Transloadit file information (optional) */
  transloaditFiles?: InputMaybe<Array<Ulba_TransloaditFileInfoInput>>;
  /** Type of source */
  typeName: Ulba_UlbaSourceType;
};

/**
 * Sub-type classification for items (types of child content within items)
 * Used in: Ulba_UlbaSummary
 */
export const Ulba_SubItemType = {
  /** AI-graded question */
  AiGradedQuestion: 'AI_GRADED_QUESTION',
  /** Auto graded question */
  AutoGradedQuestion: 'AUTO_GRADED_QUESTION',
  /** Manual graded question */
  ManualGradedQuestion: 'MANUAL_GRADED_QUESTION',
  /** Question block */
  QuestionBlock: 'QUESTION_BLOCK'
} as const;

export type Ulba_SubItemType = typeof Ulba_SubItemType[keyof typeof Ulba_SubItemType];
/**
 * Transloadit file information; see https://transloadit.com/docs/api/metadata/ for more details
 * Used in: Ulba_Source (output)
 */
export type Ulba_TransloaditFileInfo = {
  __typename?: 'Ulba_TransloaditFileInfo';
  /** The extension of the file. */
  fileExt: Scalars['String'];
  /** An abstract type describing the file, which can currently be "image", "video", "audio", or null. */
  fileType: Scalars['String'];
  /** The name of the file. Transloadit will change the extension used for this field if the file undergoes processing into a different format. */
  filename: Scalars['String'];
  /** The determined MIME type for this file. */
  mime: Scalars['String'];
  /** File size in bytes (Float is used to prevent an overflow with the 32-bit Int for files > 2GB) */
  size: Scalars['Float'];
  /** SSL file URL */
  sslUrl: Scalars['URL'];
  /** The URL at which this file can be accessed. This is either a URL in your S3 bucket, or a temporary URL on our servers. Since temporary URLs expire after a few hours, you should make sure to move your files elsewhere unless you are using a storage robot. */
  url: Scalars['URL'];
};

/**
 * Transloadit file information input; see https://transloadit.com/docs/api/metadata/ for more details
 * Used in: Ulba_SourceInput for Ulba_CreateUlbaJob mutation
 */
export type Ulba_TransloaditFileInfoInput = {
  /** The extension of the file. */
  fileExt: Scalars['String'];
  /** An abstract type describing the file, which can currently be "image", "video", "audio", or null. */
  fileType: Scalars['String'];
  /** The name of the file. Transloadit will change the extension used for this field if the file undergoes processing into a different format. */
  filename: Scalars['String'];
  /** The determined MIME type for this file. */
  mime: Scalars['String'];
  /** File size in bytes (Float is used to prevent an overflow with the 32-bit Int for files > 2GB) */
  size: Scalars['Float'];
  /** SSL file URL */
  sslUrl: Scalars['URL'];
  /** The URL at which this file can be accessed. This is either a URL in your S3 bucket, or a temporary URL on our servers. Since temporary URLs expire after a few hours, you should make sure to move your files elsewhere unless you are using a storage robot. */
  url: Scalars['URL'];
};

/**
 * Represents what kind of place a content structure representation is headed to.
 * Used in: Ulba_Destination, Ulba_DestinationInput
 */
export const Ulba_UlbaDestinationType = {
  /** Import into empty course, also a stand-in for the deprecated ULBA_DESTINATION_TYPE_COURSERA_CONTENT */
  Empty: 'EMPTY',
  /** Export operation */
  Export: 'EXPORT',
  /** Import into populated course */
  Populated: 'POPULATED'
} as const;

export type Ulba_UlbaDestinationType = typeof Ulba_UlbaDestinationType[keyof typeof Ulba_UlbaDestinationType];
/**
 * ULBA job information
 * Used in: Ulba_UlbaJobEntry for getAllLatestUlbaJobs query
 */
export type Ulba_UlbaJob = {
  __typename?: 'Ulba_UlbaJob';
  /** Destination information */
  destination: Ulba_Destination;
  /** Job ID */
  jobId: Scalars['ID'];
  /** Load result */
  loadResult?: Maybe<Ulba_UlbaLoadResult>;
  /** Parse result */
  parseResult?: Maybe<Ulba_UlbaParseResult>;
  /** Source information */
  source: Ulba_Source;
};

/**
 * Entry in the ULBA jobs map
 * Used in: Ulba_GetAllLatestUlbaJobsSuccess for getAllLatestUlbaJobs query
 */
export type Ulba_UlbaJobEntry = {
  __typename?: 'Ulba_UlbaJobEntry';
  /** ULBA job information */
  job: Ulba_UlbaJob;
  /** Reference key (branch/lesson ID) */
  key: Scalars['String'];
};

/**
 * Load result information
 * Used in: Ulba_UlbaJob, Ulba_GetUlbaJobStatusSuccess
 */
export type Ulba_UlbaLoadResult = {
  __typename?: 'Ulba_UlbaLoadResult';
  /** Load completion time */
  completedTime?: Maybe<Scalars['DateTime']>;
  /** Course Builder workflow ID */
  courseBuilderWorkflowId?: Maybe<Scalars['ID']>;
  /** Error report link */
  errorReportLink?: Maybe<Scalars['URL']>;
  /** Whether the report has been dismissed */
  reportDismissed: Scalars['Boolean'];
  /** Load start time */
  startedTime?: Maybe<Scalars['DateTime']>;
  /** Load status */
  status: Ulba_UlbaStatus;
};

/**
 * Parse result information
 * Used in: Ulba_UlbaJob, Ulba_CreateUlbaJobSuccess, Ulba_GetUlbaJobStatusSuccess
 */
export type Ulba_UlbaParseResult = {
  __typename?: 'Ulba_UlbaParseResult';
  /** Parse completion time */
  completedTime?: Maybe<Scalars['DateTime']>;
  /** Error report link */
  errorReportLink?: Maybe<Scalars['URL']>;
  /** Whether the report has been dismissed */
  reportDismissed: Scalars['Boolean'];
  /** Parse start time */
  startedTime?: Maybe<Scalars['DateTime']>;
  /** Parse status */
  status: Ulba_UlbaStatus;
};

/**
 * Type of report that can be dismissed
 * Used in: Ulba_UpdateUlbaJobDismissReportInput mutation
 */
export const Ulba_UlbaReportType = {
  /** Load report */
  Load: 'LOAD',
  /** Parse report */
  Parse: 'PARSE'
} as const;

export type Ulba_UlbaReportType = typeof Ulba_UlbaReportType[keyof typeof Ulba_UlbaReportType];
/**
 * Represents what kind of place a content structure representation is being loaded from.
 * Used in: Ulba_Source, Ulba_SourceInput
 */
export const Ulba_UlbaSourceType = {
  /** IMS Common Cartridge file */
  ImsccFile: 'IMSCC_FILE',
  /** Peer review DOCX template */
  PeerReviewDocxFile: 'PEER_REVIEW_DOCX_FILE',
  /** SCORM package file */
  ScormFile: 'SCORM_FILE',
  /** Staff graded assignment DOCX template */
  SgaDocxFile: 'SGA_DOCX_FILE',
  /** Staff graded assignment QTI file */
  SgaQtiFile: 'SGA_QTI_FILE',
  /** Staff graded assignment text input */
  SgaTextInput: 'SGA_TEXT_INPUT',
  /** Staff graded assignment YAML file */
  SgaYamlFile: 'SGA_YAML_FILE',
  /** Tar gzip compressed file, usually this means an edX course */
  TarGzipFile: 'TAR_GZIP_FILE',
  /** Excel spreadsheet file */
  XlsxFile: 'XLSX_FILE'
} as const;

export type Ulba_UlbaSourceType = typeof Ulba_UlbaSourceType[keyof typeof Ulba_UlbaSourceType];
/**
 * Represents the status of each import step, i.e. parse and load.
 * Used in: Ulba_UlbaParseResult, Ulba_UlbaLoadResult, Ulba_UlbaSummary
 */
export const Ulba_UlbaStatus = {
  /** Operation failed */
  Failure: 'FAILURE',
  /** Operation is currently in progress */
  InProgress: 'IN_PROGRESS',
  /** Operation completed with some failures */
  PartialSuccess: 'PARTIAL_SUCCESS',
  /** Operation is pending */
  Pending: 'PENDING',
  /** Operation completed successfully */
  Success: 'SUCCESS'
} as const;

export type Ulba_UlbaStatus = typeof Ulba_UlbaStatus[keyof typeof Ulba_UlbaStatus];
/**
 * Summary information for processed content.
 * Used in: Ulba_CreateUlbaJobSuccess, Ulba_GetUlbaJobStatusSuccess
 */
export type Ulba_UlbaSummary = {
  __typename?: 'Ulba_UlbaSummary';
  /** Coursera content ID that is assigned to an entity during item creation. */
  contentId?: Maybe<Scalars['ID']>;
  /** Content type */
  contentType: Ulba_ContentType;
  /** Item type (e.g., video, quiz, reading, etc.) */
  itemType?: Maybe<Ulba_ItemType>;
  /** Load status */
  loadStatus: Ulba_UlbaStatus;
  /** Parse status */
  parseStatus: Ulba_UlbaStatus;
  /**
   * ID generated during parsing to identify the entity in ULBA processes.
   * It doesn't have any meaning outside of ULBA context.
   */
  referenceId: Scalars['ID'];
  /** Sub-item type (child content type within items) */
  subItemType?: Maybe<Ulba_SubItemType>;
};

/**
 * Input for dismissing a ULBA job report
 * Used in: Ulba_UpdateUlbaJobDismissReport mutation
 */
export type Ulba_UpdateUlbaJobDismissReportInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
  /** Type of report to dismiss */
  reportType: Ulba_UlbaReportType;
};

/**
 * Result of dismissing a ULBA job report
 * Used in: Ulba_UpdateUlbaJobDismissReport mutation
 */
export type Ulba_UpdateUlbaJobDismissReportResult = Ulba_MutationFailure | Ulba_UpdateUlbaJobDismissReportSuccess;

/**
 * Success result for dismissing a report
 * Used in: Ulba_UpdateUlbaJobDismissReport mutation
 */
export type Ulba_UpdateUlbaJobDismissReportSuccess = {
  __typename?: 'Ulba_UpdateUlbaJobDismissReportSuccess';
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Input for starting ULBA job loading
 * Used in: Ulba_UpdateUlbaJobStartLoading mutation
 */
export type Ulba_UpdateUlbaJobStartLoadingInput = {
  /** Course ID */
  courseId: Scalars['ID'];
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Result of starting ULBA job loading
 * Used in: Ulba_UpdateUlbaJobStartLoading mutation
 */
export type Ulba_UpdateUlbaJobStartLoadingResult = Ulba_MutationFailure | Ulba_UpdateUlbaJobStartLoadingSuccess;

/**
 * Success result for starting ULBA job loading
 * Used in: Ulba_UpdateUlbaJobStartLoading mutation
 */
export type Ulba_UpdateUlbaJobStartLoadingSuccess = {
  __typename?: 'Ulba_UpdateUlbaJobStartLoadingSuccess';
  /** Job ID */
  jobId: Scalars['ID'];
};

/**
 * Input for Smart Ingestion initiation from the ULBA job
 * Used in: Ulba_UpdateUlbaJobStartSmartIngestionSync mutation
 */
export type Ulba_UpdateUlbaJobStartSmartIngestionSyncInput = {
  /** ID of the course into which content will be ingested */
  courseId: Scalars['ID'];
  /** ID of the ULBA job to transfer to Course Builder via Smart Ingestion */
  jobId: Scalars['ID'];
};

/**
 * Result of Smart Ingestion ULBA job mutation
 * Used in: Ulba_UpdateUlbaJobStartSmartIngestionSync mutation
 */
export type Ulba_UpdateUlbaJobStartSmartIngestionSyncResult = Ulba_MutationFailure | Ulba_SmartIngestionJobMutationSuccess;

/** Unified Home Queries */
export type UnifiedHomeQueries = {
  __typename?: 'UnifiedHomeQueries';
  /** Experimental query for fetching short video clips */
  queryClips: UnifiedHome_QueryClipsResult;
  /** Query for all enrolled products, including courses, s12ns, and learning pathways(LPs) / verified skill pathways(VSPs). Has an option to exclude LPs & VSPs. */
  queryEnrolledProductCardsByTab: UnifiedHome_QueryEnrolledProductCardsPaginatedResult;
};


/** Unified Home Queries */
export type UnifiedHomeQueriesQueryClipsArgs = {
  input: UnifiedHome_QueryClipsInput;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};


/** Unified Home Queries */
export type UnifiedHomeQueriesQueryEnrolledProductCardsByTabArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  isLearningPathIncluded: Scalars['Boolean'];
  limit: Scalars['Int'];
  tab: UnifiedHome_Tab;
};

/** Data model for a clip shown for the feeds tab in LIHP */
export type UnifiedHome_Clip = {
  __typename?: 'UnifiedHome_Clip';
  /** blurhash */
  blurhash?: Maybe<Scalars['String']>;
  /** description of the clip */
  description?: Maybe<Scalars['String']>;
  /** how long is the clip in seconds */
  durationSeconds?: Maybe<Scalars['Int']>;
  /**
   * partner name. If sourceCourse is present, please use the linked Federated Partner_Partner from
   * the sourceCourse which provides more fields about partner. Use this when no sourceCourse. For
   * certain clips, this can be some non-traditional partner.
   */
  partnerName?: Maybe<Scalars['String']>;
  /**
   * partner slug. If sourceCourse is present, please use the linked Federated Partner_Partner from
   * the sourceCourse which provides more fields about partner. Use this when no sourceCourse
   */
  partnerSlug?: Maybe<Scalars['String']>;
  /** the data of the source course where the clip come from, only applicable to Ollie clips */
  sourceCourse?: Maybe<Course_Course>;
  /** thumbnail url */
  thumbnailUrl?: Maybe<Scalars['URL']>;
  /** title of the clip */
  title: Scalars['String'];
  /** video hls url */
  videoHlsUrl?: Maybe<Scalars['URL']>;
  /** video url */
  videoUrl: Scalars['URL'];
};

/** including features that only applicable to Consumer enrolled courses */
export type UnifiedHome_ConsumerEnrolledCourseCard = UnifiedHome_EnrolledCourseCard & UnifiedHome_EnrolledProductCard & {
  __typename?: 'UnifiedHome_ConsumerEnrolledCourseCard';
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: associated s12n data needed if a learner is enrolled only in a single course in a larger s12n */
  associatedS12n?: Maybe<Specialization_Specialization>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: learners course certificate or validation if certificate not present */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard */
  course: Course_Course;
  /**
   * [INHERITED] From UnifiedHome_EnrolledCourseCard: percentage completed, i.e. completed item count / total item count. If total is 0, percentage
   * completed is 100%
   */
  courseProgressPercentage?: Maybe<Scalars['Float']>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: course progress state */
  courseProgressState?: Maybe<UnifiedHome_CourseProgressStateEnum>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: should show upgrade for freemium */
  courseUpgradeCta: UnifiedHome_CourseCardUpgradeCta;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: estimated course completion date */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>;
  /**
   * [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards
   * by. If the card represents a future course to enroll nested under coursesInS12n of an enrolled
   * specialization, it is undefined
   */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: federated entity for next up item */
  nextCourseItem?: Maybe<CourseNavigation_LearnerNextItemDetails>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: primary button */
  primaryButton: UnifiedHome_CoursePrimaryButtonCta;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: recap markdown string, null if the condition to show recap is not met. */
  recap?: Maybe<Scalars['String']>;
  /** coursera plus specific unenroll option */
  showCourseraPlusUnenrollOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: should show option to rate course or not */
  showRateCourseOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: Boolean to show if learner can unenroll from the course */
  showUnenrollOption: Scalars['Boolean'];
  /** show upsell option for the course */
  showUpsellOption: Scalars['Boolean'];
};

/** including features that only applicable to Consumer enrolled specializations */
export type UnifiedHome_ConsumerEnrolledSpecializationCard = UnifiedHome_EnrolledProductCard & UnifiedHome_EnrolledSpecializationCard & {
  __typename?: 'UnifiedHome_ConsumerEnrolledSpecializationCard';
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: learners s12n certificate and validation. Null if the s12n is in-progress */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: course completed count */
  coursesCompletedCount: Scalars['Int'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: course enrolled count */
  coursesEnrolledCount: Scalars['Int'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: the course progress for all the courses in this s12n */
  coursesInS12n: Array<UnifiedHome_ConsumerEnrolledCourseCard | UnifiedHome_EnterpriseEnrolledCourseCard>;
  /** [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards by */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: next course, null if all the courses in the s12n are completed */
  nextCourse?: Maybe<Course_Course>;
  /** coursera plus specific unenroll option */
  showCourseraPlusUnenrollOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: Boolean to show if learner can unenroll from the course */
  showUnenrollOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard */
  specialization: Specialization_Specialization;
};

/** The enum upgrade CTA for the freemium experience */
export const UnifiedHome_CourseCardUpgradeCta = {
  /** No course upgrade CTA */
  NoCta: 'NO_CTA',
  /** CTA for upgrading the course */
  Upgrade: 'UPGRADE'
} as const;

export type UnifiedHome_CourseCardUpgradeCta = typeof UnifiedHome_CourseCardUpgradeCta[keyof typeof UnifiedHome_CourseCardUpgradeCta];
/** Primary CTA type, determines button displayed in enrolled product card */
export const UnifiedHome_CoursePrimaryButtonCta = {
  /** go to course */
  GoToCourse: 'GO_TO_COURSE',
  /** no button displayed */
  NoButton: 'NO_BUTTON',
  /** CTA for Purchase Certificate for course completed after audit (not applicable to Enterprise) */
  PurchaseCertificate: 'PURCHASE_CERTIFICATE',
  /** start course */
  StartCourse: 'START_COURSE',
  /** jumio ID verification */
  VerifyId: 'VERIFY_ID',
  /** view certificate */
  ViewCertificate: 'VIEW_CERTIFICATE'
} as const;

export type UnifiedHome_CoursePrimaryButtonCta = typeof UnifiedHome_CoursePrimaryButtonCta[keyof typeof UnifiedHome_CoursePrimaryButtonCta];
/** An enum for the learner's learning progress state towards a course */
export const UnifiedHome_CourseProgressStateEnum = {
  /** Completed */
  Completed: 'COMPLETED',
  /** Not Started */
  NotStarted: 'NOT_STARTED',
  /** Started */
  Started: 'STARTED'
} as const;

export type UnifiedHome_CourseProgressStateEnum = typeof UnifiedHome_CourseProgressStateEnum[keyof typeof UnifiedHome_CourseProgressStateEnum];
/** A course session, used for identifying the learner's currently-enrolled session. using fields from Session_Session */
export type UnifiedHome_CourseSession = {
  __typename?: 'UnifiedHome_CourseSession';
  /** Specifies when this specific session ends, helpful for identifying a current or closed course session */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Specifies when the session's enrollment period ends at */
  enrollmentEndsAt?: Maybe<Scalars['DateTime']>;
  /** An ID for us to match with other course sessions */
  id: Scalars['ID'];
  /** Specifies when this specific session starts, helpful for identifying a current or pre-enrollment course session */
  startsAt?: Maybe<Scalars['DateTime']>;
};

/** Enrolled course card: this is split later by business context */
export type UnifiedHome_EnrolledCourseCard = {
  /** associated s12n data: needed if a learner is enrolled only in a single course in a larger s12n */
  associatedS12n?: Maybe<Specialization_Specialization>;
  /** learners course certificate or validation if certificate not present */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** should be Course only */
  course: Course_Course;
  /**
   * percentage completed, i.e. completed item count / total item count. If total is 0, percentage
   * completed is 100%
   */
  courseProgressPercentage?: Maybe<Scalars['Float']>;
  /** course progress state */
  courseProgressState?: Maybe<UnifiedHome_CourseProgressStateEnum>;
  /** estimated course completion date */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>;
  /**
   * [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards
   * by. If the card represents a future course to enroll nested under coursesInS12n of an enrolled
   * specialization, it is undefined
   */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** federated entity for next up item */
  nextCourseItem?: Maybe<CourseNavigation_LearnerNextItemDetails>;
  /** Primary button CTA */
  primaryButton: UnifiedHome_CoursePrimaryButtonCta;
  /** recap markdown string, null if the condition to show recap is not met. */
  recap?: Maybe<Scalars['String']>;
  /** Option to rate course */
  showRateCourseOption: Scalars['Boolean'];
  /** Boolean to show if learner can unenroll from the course */
  showUnenrollOption: Scalars['Boolean'];
};

/** Base interface for all cards */
export type UnifiedHome_EnrolledProductCard = {
  /**
   * Last activity time to order the Product Cards by. If the card represents a future course to
   * enroll nested under coursesInS12n of an enrolled specialization, it is undefined
   */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
};

/** Enrolled specialization card: this is split later by business context, but has specialization-specific features */
export type UnifiedHome_EnrolledSpecializationCard = {
  /** learners s12n certificate and validation. Null if the s12n is in-progress */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** course completed count */
  coursesCompletedCount: Scalars['Int'];
  /** course enrolled count */
  coursesEnrolledCount: Scalars['Int'];
  /** the course progress for all the courses in this s12n */
  coursesInS12n: Array<UnifiedHome_ConsumerEnrolledCourseCard | UnifiedHome_EnterpriseEnrolledCourseCard>;
  /** [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards by */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** next course, null if all the courses in the s12n are completed */
  nextCourse?: Maybe<Course_Course>;
  /** Boolean to show if learner can unenroll from the s12n */
  showUnenrollOption: Scalars['Boolean'];
  /** should be S12n only */
  specialization: Specialization_Specialization;
};

/** including features that are only applicable to Enterprise enrolled courses */
export type UnifiedHome_EnterpriseEnrolledCourseCard = UnifiedHome_EnrolledCourseCard & UnifiedHome_EnrolledProductCard & {
  __typename?: 'UnifiedHome_EnterpriseEnrolledCourseCard';
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: associated s12n data */
  associatedS12n?: Maybe<Specialization_Specialization>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: learners course certificate or validation if certificate not present */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard */
  course: Course_Course;
  /**
   * [INHERITED] From UnifiedHome_EnrolledCourseCard: percentage completed, i.e. completed item count / total item count. If total is 0, percentage
   * completed is 100%
   */
  courseProgressPercentage?: Maybe<Scalars['Float']>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: course progress state */
  courseProgressState?: Maybe<UnifiedHome_CourseProgressStateEnum>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: should show upgrade for freemium */
  courseUpgradeCta: UnifiedHome_CourseCardUpgradeCta;
  /** fetches the currently-enrolled session */
  currentEnrolledSession?: Maybe<UnifiedHome_CourseSession>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: estimated course completion date */
  estimatedCompletionDate?: Maybe<Scalars['DateTime']>;
  /**
   * [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards
   * by. If the card represents a future course to enroll nested under coursesInS12n of an enrolled
   * specialization, it is undefined
   */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: federated entity for next up item */
  nextCourseItem?: Maybe<CourseNavigation_LearnerNextItemDetails>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: primary button */
  primaryButton: UnifiedHome_CoursePrimaryButtonCta;
  /** related enterprise program */
  program: EnterpriseProgram_EnterpriseProgram;
  /** related product metadata specific to the program it is enrolled through. marked as optional since this is not critical data */
  programProductMetadata?: Maybe<UnifiedHome_ProgramProductMetadata>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: recap markdown string, null if the condition to show recap is not met. */
  recap?: Maybe<Scalars['String']>;
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: should show option to rate course or not */
  showRateCourseOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledCourseCard: Boolean to show if learner can unenroll from the course */
  showUnenrollOption: Scalars['Boolean'];
};

/** Enrolled Learning Pathway card type */
export type UnifiedHome_EnterpriseEnrolledLearningPathwayCard = UnifiedHome_EnrolledProductCard & {
  __typename?: 'UnifiedHome_EnterpriseEnrolledLearningPathwayCard';
  /** should be Learning Pathway only for this type */
  badge: EnterpriseBadge_EnterpriseBadge;
  /** [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards by */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** The program this learning pathway belongs to */
  program: EnterpriseProgram_EnterpriseProgram;
  /** User state */
  userState: UnifiedHome_LearningPathwayUserState;
};

/** including features that only applicable to Enterprise enrolled specializations */
export type UnifiedHome_EnterpriseEnrolledSpecializationCard = UnifiedHome_EnrolledProductCard & UnifiedHome_EnrolledSpecializationCard & {
  __typename?: 'UnifiedHome_EnterpriseEnrolledSpecializationCard';
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: learners s12n certificate and validation. Null if the s12n is in-progress */
  certificateOrValidation?: Maybe<Certificate_UserProductCertificateOrValidation>;
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: course completed count */
  coursesCompletedCount: Scalars['Int'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: course enrolled count */
  coursesEnrolledCount: Scalars['Int'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: the course progress for all the courses in this s12n */
  coursesInS12n: Array<UnifiedHome_ConsumerEnrolledCourseCard | UnifiedHome_EnterpriseEnrolledCourseCard>;
  /** [INHERITED] From UnifiedHome_EnrolledProductCard: Last activity time to order the Product Cards by */
  lastActivityTimeUTC?: Maybe<Scalars['DateTime']>;
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: next course, null if all the courses in the s12n are completed */
  nextCourse?: Maybe<Course_Course>;
  /** related enterprise program */
  program: EnterpriseProgram_EnterpriseProgram;
  /** related product metadata specific to the program it is enrolled through. marked as optional since this is not critical data */
  programProductMetadata?: Maybe<UnifiedHome_ProgramProductMetadata>;
  /** show upgrade button for when new s12n version is present */
  showS12nUpgradeOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard: Boolean to show if learner can unenroll from the course */
  showUnenrollOption: Scalars['Boolean'];
  /** [INHERITED] From UnifiedHome_EnrolledSpecializationCard */
  specialization: Specialization_Specialization;
};

/** User Progress state in a Learning Pathway or Verified Skill Pathway */
export const UnifiedHome_LearningPathwayUserState = {
  /** enrolled in LP */
  Enrolled: 'ENROLLED',
  /** badge issued (completed) */
  Issued: 'ISSUED',
  /** never enrolled */
  NeverEnrolled: 'NEVER_ENROLLED',
  /** unenrolled */
  Unenrolled: 'UNENROLLED'
} as const;

export type UnifiedHome_LearningPathwayUserState = typeof UnifiedHome_LearningPathwayUserState[keyof typeof UnifiedHome_LearningPathwayUserState];
/** ProgramProductMetadata info that powers tagging on enrolled products */
export type UnifiedHome_ProgramProductMetadata = {
  __typename?: 'UnifiedHome_ProgramProductMetadata';
  /** isExclusive */
  isExclusive: Scalars['Boolean'];
  /** isSelectedForCredit */
  isSelectedForCredit: Scalars['Boolean'];
};

/** Input for query queryClips */
export type UnifiedHome_QueryClipsInput = {
  /**
   * optionally provide the category of clips, if null, return a general list of clips (aka "All"
   * category)
   */
  category?: InputMaybe<Scalars['String']>;
};

/** Output for query queryClips */
export type UnifiedHome_QueryClipsResult = {
  __typename?: 'UnifiedHome_QueryClipsResult';
  /**
   * clips based on the input, clips are picked per category if provided. No duplicated clips within
   * a given category or a general "all" category (when no category is given)
   */
  elements: Array<UnifiedHome_Clip>;
  /** next offset (null if reached the end of the list) */
  nextOffset?: Maybe<Scalars['Int']>;
  /** total eligible clips */
  total: Scalars['Int'];
};

/** Output for query queryEnrolledProductCards */
export type UnifiedHome_QueryEnrolledProductCardsPaginatedResult = {
  __typename?: 'UnifiedHome_QueryEnrolledProductCardsPaginatedResult';
  /** elements ordered by the lastActivityTimeUTC. for an S12n card, lastActivityTimeUTC is defined by the max of the course lastActivityTimeUTC among all the courses in that s12n. */
  elements: Array<UnifiedHome_ConsumerEnrolledCourseCard | UnifiedHome_ConsumerEnrolledSpecializationCard | UnifiedHome_EnterpriseEnrolledCourseCard | UnifiedHome_EnterpriseEnrolledLearningPathwayCard | UnifiedHome_EnterpriseEnrolledSpecializationCard>;
  /** Pagination */
  pagination: Pagination;
};

/** An enum representing the tabs of the Unified Logged In Home Page */
export const UnifiedHome_Tab = {
  /** The Completed tab */
  Completed: 'COMPLETED',
  /** Continue Learning (originally called HOME tab in Consumer LIHP) */
  ContinueLearning: 'CONTINUE_LEARNING',
  /** The In-Progress tab */
  InProgress: 'IN_PROGRESS'
} as const;

export type UnifiedHome_Tab = typeof UnifiedHome_Tab[keyof typeof UnifiedHome_Tab];
/** Upcoming items GraphQL queries */
export type UpcomingItemsQueries = {
  __typename?: 'UpcomingItemsQueries';
  /** Query by user and course ids */
  queryByUserAndCourse?: Maybe<Array<UpcomingItems_Response>>;
};


/** Upcoming items GraphQL queries */
export type UpcomingItemsQueriesQueryByUserAndCourseArgs = {
  input: UpcomingItems_QueryByUserAndCourseInput;
};

/**
 * Item status that is to show up in the UpcomingItem model. It could be on track, overdue or
 * failed.
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 */
export const UpcomingItems_ItemStatus = {
  /** Failed */
  Failed: 'FAILED',
  /** Invalid Status */
  Invalid: 'INVALID',
  /** Item on track */
  OnTrack: 'ON_TRACK',
  /** Item overdue */
  Overdue: 'OVERDUE'
} as const;

export type UpcomingItems_ItemStatus = typeof UpcomingItems_ItemStatus[keyof typeof UpcomingItems_ItemStatus];
/**
 * Item type
 * Reference: https://github.com/webedx-spark/service-definitions/blob/main/coursera/proto/guidedlearningexperience/scheduleincentives/v1beta1/upcoming_item.proto
 * Deprecate some item types based on https://docs.google.com/document/d/1xj9ffO56LgpH-QXUzLFWjUi966r7M_rteIW0e_d97GQ/edit#heading=h.hgy0mtjf8o5u
 */
export const UpcomingItems_ItemType = {
  /** Assessment open single page */
  AssesOpenSinglePage: 'ASSES_OPEN_SINGLE_PAGE',
  /** Closed peer */
  ClosedPeer: 'CLOSED_PEER',
  /** Discussion prompt */
  DiscussionPrompt: 'DISCUSSION_PROMPT',
  /** Exam */
  Exam: 'EXAM',
  /** Graded discussion prompt */
  GradedDiscussionPrompt: 'GRADED_DISCUSSION_PROMPT',
  /** Graded LTI */
  GradedLti: 'GRADED_LTI',
  /** Graded peer */
  GradedPeer: 'GRADED_PEER',
  /** Graded programming */
  GradedProgramming: 'GRADED_PROGRAMMING',
  /** Graded widget */
  GradedWidget: 'GRADED_WIDGET',
  /** Invalid Type */
  Invalid: 'INVALID',
  /** Lecture */
  Lecture: 'LECTURE',
  /** Notebook */
  Notebook: 'NOTEBOOK',
  /** Peer */
  Peer: 'PEER',
  /** Phased peer */
  PhasedPeer: 'PHASED_PEER',
  /** Placeholder */
  Placeholder: 'PLACEHOLDER',
  /** Programming */
  Programming: 'PROGRAMMING',
  /** Quiz */
  Quiz: 'QUIZ',
  /** Single question submit */
  SingleQuestionSubmit: 'SINGLE_QUESTION_SUBMIT',
  /** Slideshow */
  Slideshow: 'SLIDESHOW',
  /** Staff graded */
  StaffGraded: 'STAFF_GRADED',
  /** Supplement */
  Supplement: 'SUPPLEMENT',
  /** Teammate review */
  TeammateReview: 'TEAMMATE_REVIEW',
  /** Ungraded lab */
  UngradedLab: 'UNGRADED_LAB',
  /** Ungraded LTI */
  UngradedLti: 'UNGRADED_LTI',
  /** Ungraded programming */
  UngradedProgramming: 'UNGRADED_PROGRAMMING',
  /** Ungraded widget */
  UngradedWidget: 'UNGRADED_WIDGET',
  /** Wise flow */
  WiseFlow: 'WISE_FLOW',
  /** Workspace launcher */
  WorkspaceLauncher: 'WORKSPACE_LAUNCHER'
} as const;

export type UpcomingItems_ItemType = typeof UpcomingItems_ItemType[keyof typeof UpcomingItems_ItemType];
/** Input parameters for Query byUserAndCourse */
export type UpcomingItems_QueryByUserAndCourseInput = {
  /** Course Id */
  courseId: Scalars['ID'];
  /** User Id */
  userId: Scalars['ID'];
};

/** Upcoming item schema */
export type UpcomingItems_Response = {
  __typename?: 'UpcomingItems_Response';
  /** Item due date */
  itemDueDateTime: Scalars['DateTime'];
  /** Item ID */
  itemId: Scalars['ID'];
  /** Item name */
  itemName: Scalars['String'];
  /** Url path to item, e.g. /learn/trees-graphs-basics/supplement/APJv5/course-facilitation */
  itemResourcePath: Scalars['String'];
  /** Item status */
  itemStatus: UpcomingItems_ItemStatus;
  /** Item Type */
  itemType: UpcomingItems_ItemType;
};

/** Update course offering request */
export type UpdateCourseOfferingRequest = {
  /** The course offering updates. */
  courseOffering: CourseOfferingInput;
  /** The course offering ID for the update. */
  courseOfferingId: Scalars['ID'];
};

/**  eslint-disable-next-line custom-rules/namespaced-types, @graphql-eslint/require-description */
export type UpdateCourseOfferingResponse = CourseOfferingErrorResponse | UpdateCourseOfferingSuccessResponse;

/** Update course offering response */
export type UpdateCourseOfferingSuccessResponse = {
  __typename?: 'UpdateCourseOfferingSuccessResponse';
  /** Returns the updated course offering record. */
  courseOffering: CourseOffering_Record;
};

/** TODO: Complete this description */
export type UpgradeEligibilityCourse = {
  __typename?: 'UpgradeEligibilityCourse';
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** TODO: Complete this description */
  name: Scalars['String'];
};

/** Additional headers' pairs */
export type UploadUrlResult_Header = {
  __typename?: 'UploadUrlResult_Header';
  /** Header name */
  name: Scalars['String'];
  /** Header's value */
  value: Scalars['String'];
};

/** Mutations for upsells */
export type UpsellMutationQueries = {
  __typename?: 'UpsellMutationQueries';
  /** Creates a new upsell, returns the id of the newly created upsell */
  createUpsell?: Maybe<Scalars['ID']>;
  /** Delete Upsell */
  deleteUpsell?: Maybe<Scalars['Boolean']>;
  /** Update upsell */
  updateUpsell?: Maybe<Scalars['String']>;
};


/** Mutations for upsells */
export type UpsellMutationQueriesCreateUpsellArgs = {
  createUpsellRequest?: InputMaybe<CreateUpsellRequest>;
};


/** Mutations for upsells */
export type UpsellMutationQueriesDeleteUpsellArgs = {
  id: Scalars['ID'];
};


/** Mutations for upsells */
export type UpsellMutationQueriesUpdateUpsellArgs = {
  id: Scalars['ID'];
  paramsJson?: InputMaybe<Scalars['String']>;
  upsellType: Scalars['String'];
};

/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueries = {
  __typename?: 'UpsellQueries';
  /** Returns the list of courses that upsells to the given degree */
  getCourseUpsellsForDegree?: Maybe<Array<UpsellResponse>>;
  /** Returns the list of specializations that upsells to the given degree */
  getSpecializationUpsellsForDegree?: Maybe<Array<UpsellResponse>>;
  /** Returns the list of specializations that upsells to the given degree slug */
  getSpecializationUpsellsForDegreeBySlug?: Maybe<Array<UpsellResponse>>;
  /** Returns the list of upsells matching the query */
  getUpsells?: Maybe<Array<DegreeMarketing_GenericUpsellResponse>>;
  /** Returns the list of upsells for the product by Id */
  getUpsellsById?: Maybe<Array<DegreeMarketing_GenericUpsellResponse>>;
  /** Returns the list of upsells for the product by slug */
  getUpsellsBySlug?: Maybe<Array<DegreeMarketing_GenericUpsellResponse>>;
  /** Returns the list of upsells associated with the course */
  getUpsellsForCourse?: Maybe<Array<UpsellResponse>>;
  /** Returns the list of upsells associated with the specialization */
  getUpsellsForSpecialization?: Maybe<Array<UpsellResponse>>;
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetCourseUpsellsForDegreeArgs = {
  degreeId: Scalars['ID'];
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetSpecializationUpsellsForDegreeArgs = {
  degreeId: Scalars['ID'];
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetSpecializationUpsellsForDegreeBySlugArgs = {
  degreeSlug: Scalars['String'];
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetUpsellsArgs = {
  query: DegreeMarketing_UpsellFilterRequest;
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetUpsellsByIdArgs = {
  direction: UpsellQueries_UpsellDirection;
  id: Scalars['ID'];
  type: UpsellQueries_ProductType;
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetUpsellsBySlugArgs = {
  direction: UpsellQueries_UpsellDirection;
  productSlug: Scalars['String'];
  type: UpsellQueries_ProductType;
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetUpsellsForCourseArgs = {
  courseId: Scalars['String'];
};


/**
 * Upsells are relations between two products. An upsell indicates that two items are related,
 * and people interested in one might be interested in the other. Upsell is a directional relation,
 * one item being the source of upsell, the other being the target.
 */
export type UpsellQueriesGetUpsellsForSpecializationArgs = {
  specializationId: Scalars['String'];
};

/** Represents a course */
export type UpsellQueries_Course = UpsellQueries_Product & {
  __typename?: 'UpsellQueries_Course';
  /** The course data */
  course?: Maybe<UpsellQueries_InnerCourse>;
  /** Id of the course */
  id: Scalars['ID'];
};

/** Degree Product */
export type UpsellQueries_Degree = UpsellQueries_Product & {
  __typename?: 'UpsellQueries_Degree';
  /** If the product is a degree, details of the degree */
  degree?: Maybe<Degree>;
  /** The id of the Degree */
  id: Scalars['ID'];
};

/** Upsell Direction. */
export const UpsellQueries_DifficultyLevel = {
  /** Advanced Level. */
  Advanced: 'ADVANCED',
  /** Beginner Level. */
  Beginner: 'BEGINNER',
  /** Intermediate Level. */
  Intermediate: 'INTERMEDIATE',
  /** Undefined Level. */
  Undefined: 'UNDEFINED'
} as const;

export type UpsellQueries_DifficultyLevel = typeof UpsellQueries_DifficultyLevel[keyof typeof UpsellQueries_DifficultyLevel];
/** Represents a course */
export type UpsellQueries_InnerCourse = {
  __typename?: 'UpsellQueries_InnerCourse';
  /** Header banner image */
  headerImage?: Maybe<Scalars['String']>;
  /** Id of the course */
  id: Scalars['ID'];
  /** Difficulty Level */
  level: UpsellQueries_DifficultyLevel;
  /** Logo */
  logo?: Maybe<Scalars['String']>;
  /** The name of the course */
  name?: Maybe<Scalars['String']>;
  /** The partner providing the course */
  partnerEntities?: Maybe<Array<Maybe<Partner_Partner>>>;
  /**
   * The partner providing the course
   * @deprecated use partnerEntities instead
   */
  partners?: Maybe<Array<Maybe<UpsellQueries_Partner>>>;
  /** Product variant */
  productVariant?: Maybe<Scalars['String']>;
  /** The slug of the course */
  slug?: Maybe<Scalars['String']>;
};

/** Represents a mastertrack */
export type UpsellQueries_InnerMastertrack = {
  __typename?: 'UpsellQueries_InnerMastertrack';
  /** Header banner image */
  headerImage?: Maybe<Scalars['String']>;
  /** Id of the mastertrack */
  id: Scalars['ID'];
  /** Logo */
  logo?: Maybe<Scalars['String']>;
  /** The name of the mastertrack */
  name?: Maybe<Scalars['String']>;
  /** The partner providing the course */
  partnerEntities?: Maybe<Array<Maybe<Partner_Partner>>>;
  /**
   * The partner providing the mastertrack
   * @deprecated use partnerEntities instead
   */
  partners?: Maybe<Array<Maybe<UpsellQueries_Partner>>>;
  /** Product variant */
  productVariant?: Maybe<Scalars['String']>;
  /** The slug of the mastertrack */
  slug?: Maybe<Scalars['String']>;
  /** Tagline */
  tagline?: Maybe<Scalars['String']>;
};

/** Represents a mastertrack */
export type UpsellQueries_Mastertrack = UpsellQueries_Product & {
  __typename?: 'UpsellQueries_Mastertrack';
  /** Id of the mastertrack */
  id: Scalars['ID'];
  /** The course data */
  mastertrack?: Maybe<UpsellQueries_InnerMastertrack>;
};

/** Upsell query Partner */
export type UpsellQueries_Partner = {
  __typename?: 'UpsellQueries_Partner';
  /** The partner id */
  id: Scalars['ID'];
  /** Partner name */
  name: Scalars['String'];
  /** Square logo */
  squareLogo?: Maybe<Scalars['String']>;
};

/** Upsell Product. */
export type UpsellQueries_Product = {
  /** The id of the upsell */
  id: Scalars['ID'];
};

/** Product Type. */
export const UpsellQueries_ProductType = {
  /** Course. */
  Course: 'COURSE',
  /** Degree. */
  Degree: 'DEGREE',
  /** Mastertrack. */
  Mastertrack: 'MASTERTRACK',
  /** Specialization. */
  Specialization: 'SPECIALIZATION'
} as const;

export type UpsellQueries_ProductType = typeof UpsellQueries_ProductType[keyof typeof UpsellQueries_ProductType];
/** Specialization Product */
export type UpsellQueries_Specialization = UpsellQueries_Product & {
  __typename?: 'UpsellQueries_Specialization';
  /** The id of the specialization */
  id: Scalars['ID'];
  /** The partner providing the specialization */
  partnerEntities?: Maybe<Array<Maybe<Partner_Partner>>>;
  /**
   * The partner providing the specialization
   * @deprecated Use partnerEntities instead
   */
  partners?: Maybe<Array<Maybe<UpsellQueries_Partner>>>;
  /** If the product is a specialization, details of the specialization */
  specializationDetails?: Maybe<Specialization_Specialization>;
};

/** Upsell Direction. */
export const UpsellQueries_UpsellDirection = {
  /** Source, Upsell From. */
  Source: 'SOURCE',
  /** Target, Upsell To. */
  Target: 'TARGET'
} as const;

export type UpsellQueries_UpsellDirection = typeof UpsellQueries_UpsellDirection[keyof typeof UpsellQueries_UpsellDirection];
/** Represents an upsell */
export type UpsellResponse = {
  __typename?: 'UpsellResponse';
  /** The id of the degree */
  degree: Degree;
  /** Id of the upsell */
  id: Scalars['ID'];
  /** The product the upsell belongs to */
  product: Product;
  /** Type of the upsell: PART_OF,  RELATED_TO, OFFERS_CREDIT */
  upsellType: Scalars['String'];
};

/** User */
export type User = {
  __typename?: 'User';
  /** User ID */
  id: Scalars['ID'];
};

/** User entity queries, by email */
export type UserEmailQueries = {
  __typename?: 'UserEmailQueries';
  /** Returns users with a given email address. Returns an empty list if there are no users with the email */
  getUsersByEmail: Array<User_User>;
};


/** User entity queries, by email */
export type UserEmailQueriesGetUsersByEmailArgs = {
  email: Scalars['String'];
};

/** All UserEmails queries */
export type UserEmailsQueries = {
  __typename?: 'UserEmailsQueries';
  /** Returns a user's recovery email, if one exists. Null if no recovery email is set. */
  queryRecoveryEmailByUserId?: Maybe<UserEmails_RecoveryEmail>;
};


/** All UserEmails queries */
export type UserEmailsQueriesQueryRecoveryEmailByUserIdArgs = {
  userId: Scalars['ID'];
};

/** Error Type for Deleting */
export type UserEmails_DeleteUserEmailError = {
  __typename?: 'UserEmails_DeleteUserEmailError';
  /** Error Message for Deleting */
  message: Scalars['String'];
};

/** Input for the DeleteSecondaryUnverifiedEmailsForUser mutation */
export type UserEmails_DeleteUserEmailInput = {
  /** Email */
  email: Scalars['String'];
};

/** Result for Mutation - success or error */
export type UserEmails_DeleteUserEmailResult = UserEmails_DeleteUserEmailError | UserEmails_DeleteUserEmailSuccess;

/** Result for Mutation - success or error */
export type UserEmails_DeleteUserEmailSuccess = {
  __typename?: 'UserEmails_DeleteUserEmailSuccess';
  /** Returns true if deleted succesfully, else false */
  _?: Maybe<Scalars['Boolean']>;
};

/** A recovery email for a user */
export type UserEmails_RecoveryEmail = {
  __typename?: 'UserEmails_RecoveryEmail';
  /** The recovery email address */
  emailAddress: Scalars['String'];
  /** The user ID */
  id: Scalars['ID'];
  /** Whether the recovery email has been verified */
  isVerified: Scalars['Boolean'];
};

/** Queries for user experience context. */
export type UserExperienceContextQueries = {
  __typename?: 'UserExperienceContextQueries';
  /** Get the user's experience context selection. User ID is inferred from request context. */
  getUserExperienceContext?: Maybe<UserExperienceContext_UserExperienceSelection>;
};

/** Consumer experience selection. */
export type UserExperienceContext_ConsumerSelection = {
  __typename?: 'UserExperienceContext_ConsumerSelection';
  /** Placeholder field. Consumer selection has no additional data. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Input for selecting the consumer experience. */
export type UserExperienceContext_ConsumerSelectionInput = {
  /** Placeholder field required by @oneOf directive. */
  _?: InputMaybe<Scalars['Boolean']>;
};

/** Degree experience selection. */
export type UserExperienceContext_DegreeSelection = {
  __typename?: 'UserExperienceContext_DegreeSelection';
  /** The degree program for the degree experience. Includes id, slug, and name. */
  degreeProgram: Degree_Degree;
};

/** Input for selecting the degree experience. */
export type UserExperienceContext_DegreeSelectionInput = {
  /** The ID of the degree program for the degree experience. */
  degreeProgramId: Scalars['ID'];
};

/** Enterprise experience selection. */
export type UserExperienceContext_EnterpriseSelection = {
  __typename?: 'UserExperienceContext_EnterpriseSelection';
  /** The organization for the enterprise experience. Includes id, slug, and name. */
  organization: ThirdPartyOrganization_ThirdPartyOrganization;
};

/** Input for selecting the enterprise experience. */
export type UserExperienceContext_EnterpriseSelectionInput = {
  /** The ID of the organization for the enterprise experience. */
  organizationId: Scalars['ID'];
};

/** Input for updating user experience context. */
export type UserExperienceContext_UpdateUserExperienceContextInput = {
  /** The new experience context selection. */
  selection: UserExperienceContext_UserExperienceSelectionInput;
};

/** Result of updating user experience context. */
export type UserExperienceContext_UpdateUserExperienceContextResult = UserExperienceContext_UpdateUserExperienceContextResultError | UserExperienceContext_UpdateUserExperienceContextResultSuccess;

/** Error result of updating user experience context. */
export type UserExperienceContext_UpdateUserExperienceContextResultError = Error & {
  __typename?: 'UserExperienceContext_UpdateUserExperienceContextResultError';
  /** Error message describing what went wrong. */
  message: Scalars['String'];
};

/** Successful result of updating user experience context. */
export type UserExperienceContext_UpdateUserExperienceContextResultSuccess = {
  __typename?: 'UserExperienceContext_UpdateUserExperienceContextResultSuccess';
  /** The updated experience context selection. */
  selection: UserExperienceContext_UserExperienceSelection;
};

/** The user's experience context selection. Exactly one type is returned. */
export type UserExperienceContext_UserExperienceSelection = UserExperienceContext_ConsumerSelection | UserExperienceContext_DegreeSelection | UserExperienceContext_EnterpriseSelection;

/** The user's experience context selection. Exactly one field must be provided. */
export type UserExperienceContext_UserExperienceSelectionInput = {
  /** Consumer experience selection. */
  consumer?: InputMaybe<UserExperienceContext_ConsumerSelectionInput>;
  /** Degree experience selection. */
  degree?: InputMaybe<UserExperienceContext_DegreeSelectionInput>;
  /** Enterprise experience selection. */
  enterprise?: InputMaybe<UserExperienceContext_EnterpriseSelectionInput>;
};

/**
 * Entity that represents user feedback for various uses cases such as LevelSet score feedback, Skill recs feedback, or
 * Like/Dislike feedback on product card.
 */
export type UserFeedback_Feedback = {
  __typename?: 'UserFeedback_Feedback';
  /** The timestamp at which the feedback was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** User feedback value */
  feedback?: Maybe<Scalars['String']>;
  /**
   * ID of the user feedback. This does not follow any strict format and can be catered to any product use case.
   *
   * Such as for skill recs feedback an example of an id is "skill~computer-programming/F-h1g0w7EeWeOApO_l5R1w" and
   * for like/dislike feedback on a product card example of an id is
   * "product_card_like_dislike/s12n~RXmxbqnWEeqiXA7IcNvdCw".
   */
  id: Scalars['ID'];
  /** Metadata is an arbitrary json object supplied by the user. This can be used for any service specific domain data. */
  metadata?: Maybe<Scalars['JSON']>;
  /** Prompt related to the feedback */
  prompt?: Maybe<Scalars['String']>;
};

/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueries = {
  __typename?: 'UserPortfolioProjectQueries';
  /**
   * Obtain a paginated list of all portfolio projects to show a learner.
   * Note that any portfolio projects the learned has enrolled in should be excluded.
   * Only active projects will be returned
   * If occupationIds are provided then only include the list of projects associated with those occupations.
   */
  browseProjectsForUser: PortfolioProject_ProjectPaginatedResult;
  /** Check if a course is a capstone project */
  isCapstoneProjectByCourseId: Scalars['Boolean'];
  /** Check if a course is a portfolio project */
  isPortfolioProjectByCourseId: Scalars['Boolean'];
  /**
   * Obtain a single portfolio project from a userId and courseId.
   * Will throw a not found error if the learner does not have this courseId in their project portfolio.
   */
  queryProjectByUserAndCourse: UserPortfolioProject_Project;
  /**
   * Obtain a paginated list of all portfolio projects that a learner has completed or is in the process of completing.
   * Items should begin to appear in this list as soon as the learner has enrolled in a Portfolio Project course.
   * Please note: it is possible that the learner has un-enrolled from one of these projects, but we will continue
   * to return it in the list.
   */
  queryProjectsByUser: UserPortfolioProject_ProjectPaginatedResult;
};


/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueriesBrowseProjectsForUserArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  occupationIds?: InputMaybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
};


/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueriesIsCapstoneProjectByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueriesIsPortfolioProjectByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueriesQueryProjectByUserAndCourseArgs = {
  courseId: Scalars['ID'];
  userId: Scalars['ID'];
};


/**
 * Queries to retrieve details and status information about one or more Portfolio Projects
 * that learners have completed or are in the process of completing.
 */
export type UserPortfolioProjectQueriesQueryProjectsByUserArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  userId: Scalars['ID'];
};

/** The fields required to hide a learner's portfolio project */
export type UserPortfolioProject_HideInput = {
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** Result from hiding a portfolio project */
export type UserPortfolioProject_HideResult = UserPortfolioProject_HideResultFailure | UserPortfolioProject_HideResultSuccess;

/** The result returned if any errors are hit during hiding */
export type UserPortfolioProject_HideResultFailure = {
  __typename?: 'UserPortfolioProject_HideResultFailure';
  /** List of errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** The response when hiding is successful */
export type UserPortfolioProject_HideResultSuccess = {
  __typename?: 'UserPortfolioProject_HideResultSuccess';
  /** The newly updated project */
  project: UserPortfolioProject_Project;
};

/** A single portfolio project that the learner has enrolled in. */
export type UserPortfolioProject_Project = {
  __typename?: 'UserPortfolioProject_Project';
  /**
   * The user-generated description of the steps the user took to complete the project
   * Will be null if the user has not yet completed this field.
   */
  approach?: Maybe<CmlContent>;
  /**
   * A list of the artifacts for the project published by learner.
   * If no artifacts published, this will be null.
   */
  artifacts?: Maybe<Array<PortfolioProject_Artifact>>;
  /**
   * User achievement in the project, if such were recorded
   * If no achievement was recorded, this will be null
   */
  challengeAchievement?: Maybe<PortfolioProject_UserAchievement>;
  /**
   * The date when the project was completed.
   * Will be null if the project has not yet been completed.
   */
  completed?: Maybe<Scalars['DateTime']>;
  /**
   * The user-generated summary of their findings.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'approach' instead
   */
  findingsSummary?: Maybe<CmlContent>;
  /**
   * The unique ID of the learner portfolio project.
   * Right now in the format {userId}!~course~{courseId}
   */
  id: Scalars['ID'];
  /** Whether this project has been auto-published or (will be) manually added to the learner's profile. */
  isAutoPublished: Scalars['Boolean'];
  /** Whether or not this project has been published to the learner's profile. */
  isPublished: Scalars['Boolean'];
  /**
   * The date when the project was last updated.
   * This will be null if the learner has not yet entered any of the manually entered fields.
   */
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /**
   * A URL that links to a location where the learner's work may be viewed.
   * Will be null if the user has not yet provided a link.
   */
  linkToWork?: Maybe<Scalars['URL']>;
  /**
   * The user-generated summary of the problem and the methods they used to solve it.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'solution' instead
   */
  problemSummary?: Maybe<CmlContent>;
  /** Details about the project */
  project: PortfolioProject_Project;
  /**
   * The user-generated summary of the project.
   * Will be null if the user has not yet completed this field.
   * @deprecated Use 'summary' instead
   */
  projectSummary?: Maybe<CmlContent>;
  /**
   * The user-generated explanation of how the solution achieved the project objectives
   * Will be null if the user has not yet completed this field.
   */
  solution?: Maybe<CmlContent>;
  /**
   * The user-generated summary of the project.
   * Will be null if the user has not yet completed this field.
   */
  summary?: Maybe<Scalars['String']>;
};

/** A paginated list of UserPortfolioProject_Projects */
export type UserPortfolioProject_ProjectPaginatedResult = {
  __typename?: 'UserPortfolioProject_ProjectPaginatedResult';
  /** The list of projects in this page of results. */
  elements: Array<UserPortfolioProject_Project>;
  /** Details on the pagination */
  pagination: Pagination;
};

/** The fields requires to publish a learner's portfolio project */
export type UserPortfolioProject_PublishInput = {
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** Result from publishing a portfolio project */
export type UserPortfolioProject_PublishResult = UserPortfolioProject_PublishResultFailure | UserPortfolioProject_PublishResultSuccess;

/** The result returned if any errors are hit during publishing */
export type UserPortfolioProject_PublishResultFailure = {
  __typename?: 'UserPortfolioProject_PublishResultFailure';
  /** List of errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** The response when publishing is successful */
export type UserPortfolioProject_PublishResultSuccess = {
  __typename?: 'UserPortfolioProject_PublishResultSuccess';
  /** The newly updated project */
  project: UserPortfolioProject_Project;
};

/** The fields requires to save user portfolio projects */
export type UserPortfolioProject_SaveInput = {
  /**
   * The user-generated description of the steps the user took to complete the project
   * The behavior if this is Null is that it will delete an existing value.
   */
  approach?: InputMaybe<CmlContentInput>;
  /**
   * A list of the artifacts for the project entered by learner.
   * The behavior if this is Null is that it will delete existing artifacts..
   */
  artifacts?: InputMaybe<Array<PortfolioProject_ArtifactInput>>;
  /**
   * The user-generated summary of their findings.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'approach' instead
   */
  findingsSummary?: InputMaybe<CmlContentInput>;
  /**
   * A URL that links to a location where the learner's work may be viewed.
   * The behavior if this is Null is that it will delete an existing value.
   */
  linkToWork?: InputMaybe<Scalars['URL']>;
  /**
   * The user-generated summary of the problem and the methods they used to solve it.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'solution' instead
   */
  problemSummary?: InputMaybe<CmlContentInput>;
  /**
   * The unique ID of the portfolio project.
   * Right now in the format course~{courseId}
   */
  projectId: Scalars['ID'];
  /**
   * The user-generated summary of the project.
   * The behavior if this is Null is that it will delete an existing value.
   * Field is deprecated. Use 'summary' instead
   */
  projectSummary?: InputMaybe<CmlContentInput>;
  /**
   * The user-generated explanation of how the solution achieved the project objectives
   * The behavior if this is Null is that it will delete an existing value.
   */
  solution?: InputMaybe<CmlContentInput>;
  /**
   * The user-generated summary of the project.
   * The behavior if this is Null is that it will delete an existing value.
   */
  summary?: InputMaybe<Scalars['String']>;
  /** The ID of the user */
  userId: Scalars['ID'];
};

/** Result from saving a portfolio project */
export type UserPortfolioProject_SaveResult = UserPortfolioProject_SaveResultFailure | UserPortfolioProject_SaveResultSuccess;

/** The result returned if any errors are hit during save */
export type UserPortfolioProject_SaveResultFailure = {
  __typename?: 'UserPortfolioProject_SaveResultFailure';
  /** List of errors */
  errors: Array<AdminProgramImpersonations_DeleteResultError | AdminProgramImpersonations_SetResultError | CheckoutGateway_GenericError | ContentExperiment_CreateSubjectResultError | ContentExperiment_RemoveSubjectResultError | CourseBuilderV2_ConflictError | CourseDefaultEnterpriseProgram_Error | CourserianRoles_Error | CurationBuilder_MutationError | CurationRecommendation_MutationError | EnterpriseAdmin_DeleteAllAdminInvitationsFailure | EnterpriseAdmin_DeleteInvitationsOrRolesFailure | EnterpriseContractPolicy_CreateContractPolicyError | EnterpriseContract_ValidationError | EnterpriseGradebooks_ExportError | EnterprisePermission_UserRoles_Error | EnterprisePrivateCourses_AddToProgram_CollectionNotFoundInProgram | EnterprisePrivateCourses_AddToProgram_ProgramContentNotPermitted | EnterprisePrivateCourses_AddToProgram_ProgramNotFound | LanguagesForProduct_QueryByCourseError | LeanerPlan_ValidationError | LearnerGoals_EditWeeklyGoalResultError | LearnerGoals_SetMacroGoalResultError | LearnerGoals_SetWeeklyGoalResultError | LearnerInterest_SetLearnerInterestError | LearnerObject_DeleteLearningGoalResultError | LearnerObject_UpdateBirthdayResultError | LearnerObject_UpdateCurrentOccupationResultError | LearnerObject_UpdateEducationProfileResultError | LearnerObject_UpdateFullNameResultError | LearnerObject_UpdateInterestedCareersResultError | LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError | LearnerObject_UpdateLastIndicatedUnsureSkillsAtResultError | LearnerObject_UpdateLearningGoalResultError | LearnerObject_UpdateLocaleResultError | LearnerObject_UpdateLocationResultError | LearnerObject_UpdateMostRecentCourseCompletionResultError | LearnerObject_UpdateSkillsWantedV2ResultError | LearnerObject_UpdateTimezoneResultError | LearnerPlan_CourseAlreadyExistsError | LearnerPlan_VersionConflictError | LearnerProfile_PatchError | LexExperimentEvents_CreateError | LexExperimentEvents_DeleteError | PaymentsCheckout_Error | ProfileConsents_AddError | QualificationSurveyExperiment_Error | QualificationSurveySectionResponse_Error | QualificationSurvey_Error | RecentlyViewedProducts_AddRecentlyViewedProductError | ScopedTranslationConfig_RequestRetranslationFailure | ScopedTranslationConfig_RetranslationConfigsByScopeKeyFailure | Seo_GenericMutationError | Session_UpdateSessionSpecificItemOverridesError | SkillRestrictedContractTag_ContractTagSkillIdAssociationExistsError | SkillRestrictedContractTag_ContractTagSkillIdAssociationNotExistsError | SocialCohort_CreateCohortResultError | SocialCohort_DeleteCohortResultError | SocialCohort_RegisterMembershipResultError | SocialCohort_RegisterUsersToCohortResultError | SocialCohort_RemoveMembershipResultError | SocialCohort_UpdateCohortResultError | ThirdPartyOrganizationServiceAccount_ServiceAccountCreateError | TranslationFeedback_ReportFeedbackError | UserExperienceContext_UpdateUserExperienceContextResultError | UserPreference_SetUserPreferenceError | User_ExportUserDataReleaseError>;
};

/** The response when saving is successful */
export type UserPortfolioProject_SaveResultSuccess = {
  __typename?: 'UserPortfolioProject_SaveResultSuccess';
  /** The newly updated project */
  project: UserPortfolioProject_Project;
};

/** User preference queries */
export type UserPreferenceQueries = {
  __typename?: 'UserPreferenceQueries';
  /**
   * Returns the user preference for the current user. User ID is inferred from request context.
   * Returns null if the requested preference doesn't exist.
   */
  me?: Maybe<UserPreference_Preference>;
};


/** User preference queries */
export type UserPreferenceQueriesMeArgs = {
  preferenceType?: InputMaybe<UserPreference_PreferenceType>;
};

/** Admin selected partner user preference */
export type UserPreference_AdminSelectedPartnerUserPreference = {
  __typename?: 'UserPreference_AdminSelectedPartnerUserPreference';
  /** The partner the admin selected */
  partner?: Maybe<Partner_Partner>;
};

/** Admin selected partner user preference input */
export type UserPreference_AdminSelectedPartnerUserPreferenceInput = {
  /** partner id that the admin has selected */
  partnerId: Scalars['Int'];
};

/** Track when the user has skipped the honors modal for a course. */
export type UserPreference_CourseHonorsModalDisabledAt = {
  __typename?: 'UserPreference_CourseHonorsModalDisabledAt';
  /** The course of the honors modal */
  course: Course_Course;
  /** The honors modal disabled time */
  disabledAt: Scalars['DateTime'];
};

/** Track when the user has skipped the honors modal for a course. */
export type UserPreference_CourseHonorsModalDisabledAtInput = {
  /** The course id of the honors model */
  courseId: Scalars['ID'];
  /** The time when the honors modal was disabled */
  disabledAt: Scalars['DateTime'];
};

/** Generic user preference */
export type UserPreference_GenericUserPreference = {
  __typename?: 'UserPreference_GenericUserPreference';
  /** List of user activities */
  userActivities?: Maybe<Array<UserPreference_UserActivity>>;
};

/** Generic user preference input */
export type UserPreference_GenericUserPreferenceInput = {
  /** List of user activities */
  userActivities?: InputMaybe<Array<UserPreference_UserActivityInput>>;
};

/** Honors user preference */
export type UserPreference_HonorsUserPreference = {
  __typename?: 'UserPreference_HonorsUserPreference';
  /** List of honors modal disabled time */
  honorsModalDisabledAt?: Maybe<Array<UserPreference_CourseHonorsModalDisabledAt>>;
};

/** Honors user preference input */
export type UserPreference_HonorsUserPreferenceInput = {
  /** List of the honors modals disabled time */
  honorsModalDisabledAt?: InputMaybe<Array<UserPreference_CourseHonorsModalDisabledAtInput>>;
};

/**
 * Answers to the Onboarding question "When do you want to start learning?" that users may self
 * select.
 */
export const UserPreference_LearningStartTimeRange = {
  /** Not sure when to start learning */
  NotSure: 'NOT_SURE',
  /** Start learning in one to two weeks */
  OneToTwoWeeks: 'ONE_TO_TWO_WEEKS',
  /** Start learning in six months */
  SixMonths: 'SIX_MONTHS',
  /** Start learning in three months */
  ThreeMonths: 'THREE_MONTHS',
  /** Start learning in three to four weeks */
  ThreeToFourWeeks: 'THREE_TO_FOUR_WEEKS',
  /** Start learning today */
  Today: 'TODAY'
} as const;

export type UserPreference_LearningStartTimeRange = typeof UserPreference_LearningStartTimeRange[keyof typeof UserPreference_LearningStartTimeRange];
/** Different possible paths the user can take in the Onboarding flow. */
export const UserPreference_OnboardingPath = {
  /** Not choosing a onboarding path */
  NotChosen: 'NOT_CHOSEN',
  /** Onboarding path for personal interest */
  PersonalInterest: 'PERSONAL_INTEREST',
  /** Onboarding path to reskill */
  Reskiller: 'RESKILLER',
  /** Onboarding path to upskill */
  Upskiller: 'UPSKILLER'
} as const;

export type UserPreference_OnboardingPath = typeof UserPreference_OnboardingPath[keyof typeof UserPreference_OnboardingPath];
/** Onboarding user preference */
export type UserPreference_OnboardingUserPreference = {
  __typename?: 'UserPreference_OnboardingUserPreference';
  /** If the user has viewed onboarding survey or not */
  hasViewedSurvey?: Maybe<Scalars['Boolean']>;
  /** Onboarding flow */
  onboardingFlow?: Maybe<UserPreference_OnboardingPath>;
  /** List of preferred domains */
  preferredDomains?: Maybe<Array<Domain_Domain>>;
  /** List of preferred domains with type */
  preferredDomainsWithType?: Maybe<Array<UserPreference_PreferredDomain>>;
  /** Time to start learning */
  timeToStartLearning?: Maybe<UserPreference_TimeToStartLearning>;
};

/** Onboarding user preference input */
export type UserPreference_OnboardingUserPreferenceInput = {
  /** If the user has viewed survey or not */
  hasViewedSurvey?: InputMaybe<Scalars['Boolean']>;
  /** Onboarding flow */
  onboardingFlow?: InputMaybe<UserPreference_OnboardingPath>;
  /** Preferred domains */
  preferredDomains?: InputMaybe<Array<Scalars['String']>>;
  /** Preferred domains with type */
  preferredDomainsWithType?: InputMaybe<Array<UserPreference_PreferredDomainInput>>;
  /** Time to start learning */
  timeToStartLearning?: InputMaybe<UserPreference_TimeToStartLearningInput>;
};

/** Payment user preference */
export type UserPreference_PaymentUserPreference = {
  __typename?: 'UserPreference_PaymentUserPreference';
  /** If the user wants to enable one click pay or not */
  enableOneClickPay?: Maybe<Scalars['Boolean']>;
  /** If the user wants to save credit card or not */
  saveCreditCard?: Maybe<Scalars['Boolean']>;
};

/** Payment user preference input */
export type UserPreference_PaymentUserPreferenceInput = {
  /** If the user enables one click pay or not */
  enableOneClickPay?: InputMaybe<Scalars['Boolean']>;
  /** If the user wants to save credit card or not */
  saveCreditCard?: InputMaybe<Scalars['Boolean']>;
};

/** User preference of different preference types */
export type UserPreference_Preference = UserPreference_AdminSelectedPartnerUserPreference | UserPreference_GenericUserPreference | UserPreference_HonorsUserPreference | UserPreference_OnboardingUserPreference | UserPreference_PaymentUserPreference | UserPreference_PromotionLandingPageUserPreference | UserPreference_S12nUpgradeUserPreference;

/** User preference types */
export const UserPreference_PreferenceType = {
  /** Admin selected partner preference */
  AdminSelectedPartner: 'ADMIN_SELECTED_PARTNER',
  /** Generic preference */
  Generic: 'GENERIC',
  /** Honors preference */
  Honors: 'HONORS',
  /** Onboarding preference */
  Onboarding: 'ONBOARDING',
  /** Payment preference */
  Payment: 'PAYMENT',
  /** Promotion landing page preference */
  PromotionLandingPage: 'PROMOTION_LANDING_PAGE',
  /** S12n upgrade preference */
  S12NUpgrade: 'S12N_UPGRADE'
} as const;

export type UserPreference_PreferenceType = typeof UserPreference_PreferenceType[keyof typeof UserPreference_PreferenceType];
/** Preferred domain for onboarding user preference */
export type UserPreference_PreferredDomain = {
  __typename?: 'UserPreference_PreferredDomain';
  /** The preferred domain */
  domain: Domain_Domain;
  /** Domain type of the preferred domain */
  preferredDomainType?: Maybe<UserPreference_PreferredDomainType>;
};

/** Preferred domain input */
export type UserPreference_PreferredDomainInput = {
  /** Domain id of the preferred domain */
  domainId: Scalars['ID'];
  /** Type of the preferred domain */
  preferredDomainType?: InputMaybe<UserPreference_PreferredDomainType>;
};

/** Used to specify if a user's preferred domain is for their Career or Personal interest. */
export const UserPreference_PreferredDomainType = {
  /** Career interest for the preferred domain */
  Career: 'CAREER',
  /** Personal interest for the preferred domain */
  Personal: 'PERSONAL'
} as const;

export type UserPreference_PreferredDomainType = typeof UserPreference_PreferredDomainType[keyof typeof UserPreference_PreferredDomainType];
/** Promotion landing page user preference */
export type UserPreference_PromotionLandingPageUserPreference = {
  __typename?: 'UserPreference_PromotionLandingPageUserPreference';
  /** List of promo codes */
  promoCodes?: Maybe<Array<Scalars['String']>>;
};

/** Promotion landing page user preference input */
export type UserPreference_PromotionLandingPageUserPreferenceInput = {
  /** List of promo codes */
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
};

/** Specialization upgrade user preference */
export type UserPreference_S12nUpgradeUserPreference = {
  __typename?: 'UserPreference_S12nUpgradeUserPreference';
  /** List of s12n upgrade preferences */
  upgradePreferences?: Maybe<Array<UserPreference_S12nUpgradeUserPreferenceEntry>>;
};

/** S12n upgrade preference for one s12n */
export type UserPreference_S12nUpgradeUserPreferenceEntry = {
  __typename?: 'UserPreference_S12nUpgradeUserPreferenceEntry';
  /** The dismissed time of the s12n upgrade preference */
  dismissedTime?: Maybe<Scalars['DateTime']>;
  /** The s12n of the s12n upgrade preference */
  s12n: Specialization_Specialization;
  /** The stayed time of the s12n upgrade preference */
  stayedTime?: Maybe<Scalars['DateTime']>;
  /** The upgrade time of the s12n upgrade preference */
  upgradeTime?: Maybe<Scalars['DateTime']>;
};

/** S12n upgrade preference input for a s12n */
export type UserPreference_S12nUpgradeUserPreferenceEntryInput = {
  /** s12n upgrade dismissed time */
  dismissedTime?: InputMaybe<Scalars['DateTime']>;
  /** ID of the s12n */
  s12nId: Scalars['ID'];
  /** s12n upgrade stayed time */
  stayedTime?: InputMaybe<Scalars['DateTime']>;
  /** s12n upgrade time */
  upgradeTime?: InputMaybe<Scalars['DateTime']>;
};

/** S12n upgrade user preference input */
export type UserPreference_S12nUpgradeUserPreferenceInput = {
  /** List of s12n upgrade preferences */
  upgradePreferences?: InputMaybe<Array<UserPreference_S12nUpgradeUserPreferenceEntryInput>>;
};

/** Set user preference mutation error */
export type UserPreference_SetUserPreferenceError = Error & {
  __typename?: 'UserPreference_SetUserPreferenceError';
  /** Error message */
  message: Scalars['String'];
};

/** Input to set user preference for different preference types */
export type UserPreference_SetUserPreferenceInput = {
  /** Admin selected parner user preference input */
  adminSelectedPartner?: InputMaybe<UserPreference_AdminSelectedPartnerUserPreferenceInput>;
  /** Generic user preference input */
  generic?: InputMaybe<UserPreference_GenericUserPreferenceInput>;
  /** Honors user preference input */
  honors?: InputMaybe<UserPreference_HonorsUserPreferenceInput>;
  /** Onboarding user preference input */
  onboarding?: InputMaybe<UserPreference_OnboardingUserPreferenceInput>;
  /** Payment user preference input */
  payment?: InputMaybe<UserPreference_PaymentUserPreferenceInput>;
  /** Promotion landing page user preference input */
  promotionLandingPage?: InputMaybe<UserPreference_PromotionLandingPageUserPreferenceInput>;
  /** S12n upgrade user preference input */
  s12nUpgrade?: InputMaybe<UserPreference_S12nUpgradeUserPreferenceInput>;
};

/** Set user preference result */
export type UserPreference_SetUserPreferenceResult = UserPreference_SetUserPreferenceError | UserPreference_SetUserPreferenceSuccess;

/** Set user preference mutation success */
export type UserPreference_SetUserPreferenceSuccess = {
  __typename?: 'UserPreference_SetUserPreferenceSuccess';
  /** GraphQL types must include at least one field, so a dummy field is defined here. */
  _?: Maybe<Scalars['Boolean']>;
};

/** Time to start learning */
export type UserPreference_TimeToStartLearning = {
  __typename?: 'UserPreference_TimeToStartLearning';
  /** Time that last seen learning start time */
  lastSeenTimestamp: Scalars['DateTime'];
  /** Learning start time */
  learningStartTime: UserPreference_LearningStartTimeRange;
};

/** Time to start learning input */
export type UserPreference_TimeToStartLearningInput = {
  /** Time that last seen learning start time */
  lastSeenTimestamp: Scalars['DateTime'];
  /** Learning start time */
  learningStartTime: UserPreference_LearningStartTimeRange;
};

/** User activity */
export type UserPreference_UserActivity = {
  __typename?: 'UserPreference_UserActivity';
  /** The activity ID */
  activityId: Scalars['ID'];
  /** The timestamp of the activity */
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** User activity input */
export type UserPreference_UserActivityInput = {
  /** User activity ID */
  activityId: Scalars['ID'];
  /** User activity timestamp */
  timestamp: Scalars['DateTime'];
};

/** Representation of a Learner's PreEnrollment in a Product. */
export type UserProductPreEnrollment = {
  __typename?: 'UserProductPreEnrollment';
  /** Future price of the product at launch */
  amount: MonetaryAmount;
  /** Optional courseId in which to enroll in along with s12n at product launch. */
  enrollCourseId?: Maybe<Scalars['String']>;
  /** TODO: Complete this description */
  id: Scalars['ID'];
  /** Optional field that is only applicable for PAYMENT_WALLET_CAPTURE PreEnrollmentType. */
  paymentWalletId?: Maybe<Scalars['Int']>;
  /** TODO: Complete this description */
  preEnrollmentType: PreEnrollmentType;
  /** TODO: Complete this description */
  priceId: Scalars['Int'];
  /** TODO: Complete this description */
  productItemId: Scalars['String'];
  /** TODO: Complete this description */
  productType: PreEnrollment_ProductType;
  /** TODO: Complete this description */
  userId: Scalars['Int'];
};

export type UserProductTransactionsV1 = {
  __typename?: 'UserProductTransactionsV1';
  earnCertificateBy?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  lastUpdated: Scalars['Float'];
  productId: Scalars['String'];
  productItemId: Scalars['String'];
  productName: Scalars['String'];
  productType: Scalars['String'];
  productUrl: Scalars['String'];
  refundEligibility?: Maybe<ProductActionEligibilitiesV1>;
  refundEligibilityV2?: Maybe<ProductActionEligibilitiesV1>;
  refundProductActionEligibilityId: Scalars['String'];
  transactions: Array<Maybe<UserProductTransactionsV1_Org_Coursera_Payment_History_UserProductTransaction>>;
  /** id for a Coursera user */
  userId: Scalars['Int'];
};

export type UserProductTransactionsV1ByUser = {
  __typename?: 'UserProductTransactionsV1ByUser';
  connection?: Maybe<UserProductTransactionsV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type UserProductTransactionsV1Connection = {
  __typename?: 'UserProductTransactionsV1Connection';
  elements: Array<Maybe<UserProductTransactionsV1>>;
  paging: ResponsePagination;
};

export type UserProductTransactionsV1Me = {
  __typename?: 'UserProductTransactionsV1Me';
  connection?: Maybe<UserProductTransactionsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type UserProductTransactionsV1Resource = {
  __typename?: 'UserProductTransactionsV1Resource';
  byUser?: Maybe<UserProductTransactionsV1Connection>;
  get?: Maybe<UserProductTransactionsV1>;
  me?: Maybe<UserProductTransactionsV1Connection>;
  multiGet?: Maybe<UserProductTransactionsV1Connection>;
};


export type UserProductTransactionsV1ResourceByUserArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type UserProductTransactionsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type UserProductTransactionsV1ResourceMeArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type UserProductTransactionsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

/** This is one record of a completed refund like transaction. A completed transaction is defined as a completed refund cart checkout. Refund like payment types includes = Set(REFUND, VOID, PARTIAL_REFUND, CHARGEBACK) */
export type UserProductTransactionsV1_Org_Coursera_Payment_History_UserProductRefundLikeTransaction = {
  __typename?: 'UserProductTransactionsV1_org_coursera_payment_history_UserProductRefundLikeTransaction';
  amount: Scalars['String'];
  cartId: Scalars['Float'];
  cartItemToRefundId: Scalars['Float'];
  currencyCode: Scalars['String'];
  paymentProcessor: Scalars['String'];
  taxAmount?: Maybe<Scalars['String']>;
  timestamp: Scalars['Float'];
  transactionActionType: Org_Coursera_Payment_Transaction_PaymentTransactionActionType;
};

/** This is one record of a completed transaction. A completed transaction is defined as a completed purchase or refund cart checkout */
export type UserProductTransactionsV1_Org_Coursera_Payment_History_UserProductTransaction = {
  __typename?: 'UserProductTransactionsV1_org_coursera_payment_history_UserProductTransaction';
  amount: Scalars['String'];
  cartId: Scalars['Float'];
  countryIsoCode?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  currencyId: Scalars['Float'];
  numberOfInstallments?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Float']>;
  originalAmount: Scalars['String'];
  parentCartItemId: Scalars['Float'];
  paymentProcessor: Scalars['String'];
  paymentTransactionActionType?: Maybe<Org_Coursera_Payment_Transaction_PaymentTransactionActionType>;
  receiptAvailable: Scalars['Boolean'];
  refundDeadline?: Maybe<Scalars['Float']>;
  refundLikeTransactionMetadata?: Maybe<UserProductTransactionsV1_Org_Coursera_Payment_History_UserProductRefundLikeTransaction>;
  taxAmount?: Maybe<Scalars['String']>;
  timestamp: Scalars['Float'];
};

/** User Entity GraphQL Schema */
export type UserQueries = {
  __typename?: 'UserQueries';
  /**
   * Returns the current user. ID is inferred from request context. Returns null if the requester is
   * logged out of Coursera.
   */
  me?: Maybe<User_User>;
  /** Given an ID of a user, return the user. Returns null if there is no user with the id. */
  privilegedQueryById?: Maybe<User_User>;
  /**
   * Given an external ID of a user, return the public representation of the user. Returns null if
   * there is no user with the id.
   */
  publicQueryByExternalId?: Maybe<User_PublicUser>;
};


/** User Entity GraphQL Schema */
export type UserQueriesPrivilegedQueryByIdArgs = {
  id: Scalars['ID'];
};


/** User Entity GraphQL Schema */
export type UserQueriesPublicQueryByExternalIdArgs = {
  externalId: Scalars['ID'];
};

export type UserVerificationRequirementsV1 = {
  __typename?: 'UserVerificationRequirementsV1';
  id: Scalars['Int'];
  ownedIdVerifiedCourses: Array<Maybe<Scalars['String']>>;
  userVerificationRequirementState: UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState;
};

export type UserVerificationRequirementsV1Connection = {
  __typename?: 'UserVerificationRequirementsV1Connection';
  elements: Array<Maybe<UserVerificationRequirementsV1>>;
  paging: ResponsePagination;
};

export type UserVerificationRequirementsV1Resource = {
  __typename?: 'UserVerificationRequirementsV1Resource';
  get?: Maybe<UserVerificationRequirementsV1>;
  multiGet?: Maybe<UserVerificationRequirementsV1Connection>;
};


export type UserVerificationRequirementsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type UserVerificationRequirementsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export const UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState = {
  NeedsToAttestName: 'NEEDS_TO_ATTEST_NAME',
  NeedsToVerifyId: 'NEEDS_TO_VERIFY_ID',
  RequirementMet: 'REQUIREMENT_MET'
} as const;

export type UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState = typeof UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState[keyof typeof UserVerificationRequirementsV1_Org_Coursera_Userverification_UserVerificationRequirementState];
/** ID verification requirements for a course. */
export type UserVerification_CourseIdVerification = {
  __typename?: 'UserVerification_CourseIdVerification';
  /** Optional note with the context around the ID verification status. */
  note?: Maybe<Scalars['String']>;
  /** If ID verification for the course was overridden, this field contains the timestamp when the override was created. */
  overrideCreatedAt?: Maybe<Scalars['DateTime']>;
  /** Status of ID verification for the course. */
  status: UserVerification_CourseIdVerificationStatus;
};

/** Status of ID verification for a course. */
export const UserVerification_CourseIdVerificationStatus = {
  /** ID verification is disabled for this course. */
  Disabled: 'DISABLED',
  /** ID verification is enabled for this course. */
  Enabled: 'ENABLED'
} as const;

export type UserVerification_CourseIdVerificationStatus = typeof UserVerification_CourseIdVerificationStatus[keyof typeof UserVerification_CourseIdVerificationStatus];
/** User verification requirements for a course. */
export type UserVerification_CourseUserVerification = {
  __typename?: 'UserVerification_CourseUserVerification';
  /** ID verification requirements for the course. */
  idVerification: UserVerification_CourseIdVerification;
};

/** Input for deleting an ID verification override for a course. */
export type UserVerification_DeleteIdVerificationCourseOverrideInput = {
  /** ID of the course that the override should be applied to. */
  courseId: Scalars['ID'];
};

/** Result of deleting an ID verification override for a course. */
export type UserVerification_DeleteIdVerificationCourseOverrideResult = {
  __typename?: 'UserVerification_DeleteIdVerificationCourseOverrideResult';
  /** The course for which the override was deleted. */
  course: Course_Course;
};

/** Specifies whether an override is for enabling or disabling ID verification. */
export const UserVerification_IdVerificationOverrideType = {
  /** ID verification should be disabled. */
  Disable: 'DISABLE',
  /** ID verification should be enabled. */
  Enable: 'ENABLE'
} as const;

export type UserVerification_IdVerificationOverrideType = typeof UserVerification_IdVerificationOverrideType[keyof typeof UserVerification_IdVerificationOverrideType];
/** Input for setting an ID verification override for a course. */
export type UserVerification_SetIdVerificationCourseOverrideInput = {
  /** ID of the course that the override should be applied to. */
  courseId: Scalars['ID'];
  /** Note to provide context about the override. */
  note: Scalars['String'];
  /** Specifies an ID verification override action that should be applied to the course. */
  overrideType: UserVerification_IdVerificationOverrideType;
};

/** Result of setting an ID verification override for a course. Returns the updated override along with metadata. */
export type UserVerification_SetIdVerificationCourseOverrideResult = {
  __typename?: 'UserVerification_SetIdVerificationCourseOverrideResult';
  /** The course that the override should be applied to. */
  course: Course_Course;
  /** Timestamp when the override was created. */
  createdAt: Scalars['DateTime'];
  /** Note to provide context about the override. */
  note: Scalars['String'];
  /** Specifies an ID verification override action that should be applied to the course. */
  overrideType: UserVerification_IdVerificationOverrideType;
  /** Timestamp when the override was last time updated. */
  updatedAt: Scalars['DateTime'];
};

/** Export user data release error */
export type User_ExportUserDataReleaseError = Error & {
  __typename?: 'User_ExportUserDataReleaseError';
  /** Error message */
  message: Scalars['String'];
};

/** Failure response if export user data release fails */
export type User_ExportUserDataReleaseFailure = {
  __typename?: 'User_ExportUserDataReleaseFailure';
  /** List of errors */
  errors: Array<User_ExportUserDataReleaseError>;
};

/** Input for the export user data release mutation */
export type User_ExportUserDataReleaseInput = {
  /** User ID for the data release request */
  userId: Scalars['Int'];
};

/** Result for export user data release */
export type User_ExportUserDataReleaseResult = User_ExportUserDataReleaseFailure | User_ExportUserDataReleaseSuccess;

/** Success response if export user data release succeeds */
export type User_ExportUserDataReleaseSuccess = {
  __typename?: 'User_ExportUserDataReleaseSuccess';
  /** GraphQL type requires at least one field */
  success?: Maybe<Scalars['Boolean']>;
};

/** User's state of profile consents */
export type User_ProfileConsents = {
  __typename?: 'User_ProfileConsents';
  /**
   * Boolean indicating the user is required to accept the current Courser Terms of Use and Privacy Policy.
   * True if there is not an existing record of the user accepting the current language version.
   * False if there is an existing record of the user accepting the current language version.
   * The current language version is derived in the backend implementation and managed alongside content
   * updates to the Coursera Terms of Use and Privacy Policy.
   */
  requiresTermsOfUseConsent: Scalars['Boolean'];
};

/**
 * The user entity for a user that's open to the public. It shouldn't include sensitive PII data
 * without the user's consent.
 */
export type User_PublicUser = {
  __typename?: 'User_PublicUser';
  /** External-facing user id. */
  externalId: Scalars['ID'];
  /** Learner profile of the user with fields filtered by user profile privacy setting. */
  profile: LearnerProfile_Profile;
};

/** Stub for Coursera user object. */
export type User_User = {
  __typename?: 'User_User';
  /** Date that the user joined Coursera */
  dateJoined?: Maybe<Scalars['DateTime']>;
  /** Whether the user is marked as deleted */
  deleted: Scalars['Boolean'];
  /** User's primary email address */
  email: Scalars['String'];
  /** External-facing user id. */
  externalId: Scalars['ID'];
  /** Coursera user id. */
  id: Scalars['ID'];
  /** Whether the user is coursera staff */
  isStaff: Scalars['Boolean'];
  /** Learner profile of the user. */
  profile: LearnerProfile_Profile;
};

export type UsersV1 = {
  __typename?: 'UsersV1';
  dateJoined?: Maybe<Scalars['Float']>;
  deleted: Scalars['Boolean'];
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isStaff: Scalars['Boolean'];
  isSuperuser: Scalars['Boolean'];
  locale?: Maybe<Scalars['String']>;
  organization: Scalars['Float'];
  timezone?: Maybe<Scalars['String']>;
};

export type UsersV1Connection = {
  __typename?: 'UsersV1Connection';
  elements: Array<Maybe<UsersV1>>;
  paging: ResponsePagination;
};

export type UsersV1Email = {
  __typename?: 'UsersV1Email';
  connection?: Maybe<UsersV1Connection>;
  email: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  organizationId?: Maybe<Scalars['Float']>;
  start?: Maybe<Scalars['String']>;
};

export type UsersV1Emails = {
  __typename?: 'UsersV1Emails';
  connection?: Maybe<UsersV1Connection>;
  emails: Array<Maybe<Scalars['String']>>;
  includeDeleted?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type UsersV1Resource = {
  __typename?: 'UsersV1Resource';
  email?: Maybe<UsersV1Connection>;
  emails?: Maybe<UsersV1Connection>;
  get?: Maybe<UsersV1>;
  multiGet?: Maybe<UsersV1Connection>;
};


export type UsersV1ResourceEmailArgs = {
  email: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['Float']>;
  start?: InputMaybe<Scalars['String']>;
};


export type UsersV1ResourceEmailsArgs = {
  emails: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type UsersV1ResourceGetArgs = {
  id: Scalars['String'];
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UsersV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type VcMembershipsV1 = {
  __typename?: 'VcMembershipsV1';
  certificateCode?: Maybe<Scalars['String']>;
  certificateCodeWithGrade?: Maybe<Scalars['String']>;
  courseId: Scalars['String'];
  grade?: Maybe<VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseGrade>;
  grantedAt?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  isSparkCourse: Scalars['Boolean'];
  userId: Scalars['Int'];
};

export type VcMembershipsV1ByUser = {
  __typename?: 'VcMembershipsV1ByUser';
  connection?: Maybe<VcMembershipsV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type VcMembershipsV1Connection = {
  __typename?: 'VcMembershipsV1Connection';
  elements: Array<Maybe<VcMembershipsV1>>;
  paging: ResponsePagination;
};

export type VcMembershipsV1FindByUserAndCourse = {
  __typename?: 'VcMembershipsV1FindByUserAndCourse';
  connection?: Maybe<VcMembershipsV1Connection>;
  courseIds: Array<Maybe<Scalars['String']>>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type VcMembershipsV1Resource = {
  __typename?: 'VcMembershipsV1Resource';
  byUser?: Maybe<VcMembershipsV1Connection>;
  findByUserAndCourse?: Maybe<VcMembershipsV1Connection>;
  get?: Maybe<VcMembershipsV1>;
  multiGet?: Maybe<VcMembershipsV1Connection>;
};


export type VcMembershipsV1ResourceByUserArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type VcMembershipsV1ResourceFindByUserAndCourseArgs = {
  courseIds: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type VcMembershipsV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type VcMembershipsV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type VcMembershipsV1ResourceMutations = {
  __typename?: 'VcMembershipsV1ResourceMutations';
  byUserAndCourse?: Maybe<Scalars['JSON']>;
};


export type VcMembershipsV1ResourceMutationsByUserAndCourseArgs = {
  userId: Scalars['String'];
};

/** Model representing a learner's grade in a course */
export type VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseGrade = {
  __typename?: 'VcMembershipsV1_org_coursera_catalogp_memberships_CourseGrade';
  distinctionLevel: VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel;
  record: VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord;
  score: Scalars['Float'];
  timestamp?: Maybe<Scalars['Float']>;
};

/** User's status in a course based on score and verification */
export const VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = {
  NotPassable: 'NOT_PASSABLE',
  NotPassed: 'NOT_PASSED',
  Passed: 'PASSED',
  VerifiedPassed: 'VERIFIED_PASSED'
} as const;

export type VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord = typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord[keyof typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_CourseRecord];
/** Distinction achieved by a learner getting a grade for a course */
export const VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = {
  Distinction: 'DISTINCTION',
  Honors: 'HONORS',
  Normal: 'NORMAL',
  NoAchievement: 'NO_ACHIEVEMENT'
} as const;

export type VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel = typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel[keyof typeof VcMembershipsV1_Org_Coursera_Catalogp_Memberships_DistinctionLevel];
/** Queries that return information a user's attainment status for Skill Expressions */
export type VerifiedSkillsAttainmentQueries = {
  __typename?: 'VerifiedSkillsAttainmentQueries';
  /**
   * Fetches attainment progress for each skill expression mapped to the given
   * assessment. userId is fetched from request context.
   */
  skillAttainmentByAssessment?: Maybe<Array<SkillAttainment_SkillExpressionAttainment>>;
  /**
   * Fetches attainment progress for all skill expressions within the skill areas that
   * are mapped to the occupation group and career band. A max of 8 skill areas are in
   * each occupation group and career band grouping.
   */
  skillAttainmentByOccupationGroupAndCareerBand: Array<SkillAttainment_SkillAreaAttainment>;
  /**
   * Uses the skill area id to find all attainment progress for each skill expression
   * in the skill area. userId is fetched from request context.
   */
  skillAttainmentBySkillArea: SkillAttainment_SkillAreaAttainment;
};


/** Queries that return information a user's attainment status for Skill Expressions */
export type VerifiedSkillsAttainmentQueriesSkillAttainmentByAssessmentArgs = {
  assessmentId: Scalars['ID'];
  assessmentType: Scalars['String'];
};


/** Queries that return information a user's attainment status for Skill Expressions */
export type VerifiedSkillsAttainmentQueriesSkillAttainmentByOccupationGroupAndCareerBandArgs = {
  careerBand?: InputMaybe<VerifiedSkills_CareerBand>;
  occupationGroupId: Scalars['ID'];
};


/** Queries that return information a user's attainment status for Skill Expressions */
export type VerifiedSkillsAttainmentQueriesSkillAttainmentBySkillAreaArgs = {
  id: Scalars['ID'];
};

/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueries = {
  __typename?: 'VerifiedSkillsMappingQueries';
  /** Get all possible active occupation groups */
  getAllOccupationGroups: VerifiedSkills_OccuptionGroupPaginatedResult;
  /** Get all possible career bands given the occupation group. There are a max of 4 results (the total number of possible career band levels) */
  getCareerBandsByOccupationGroup?: Maybe<Array<VerifiedSkills_CareerBand>>;
  /** Fetches all potential Skill Area <> Course mappings for the given Skill Area ID. Unlike the finalized Verified Skills Path Skill Area, there can be multiple choices before T&L selects a final 1:1 mapping. There's unlikely to be more than a handful of courses returned. */
  getRawSkillAreaCourseMappings: Array<VerifiedSkills_SkillAreaCandidateCourse>;
  /**
   * Multiple courses may be candidates for mapping to a skill area before T&L makes a final decision on which course to map. Before the mapping is finalized, they
   * may need the skill area information from the course to test out assessment and activity mappings. A candidate course has a 1:1 mapping with a Skill Area.
   * This API includes development and test data intended for internal tools.
   * For learner-facing UIs, use VerifiedSkillsQueries.getSkillAreaByCourseId instead.
   */
  getSkillAreaByCandidateCourse?: Maybe<VerifiedSkills_UnmamppedSkillArea>;
  /** Get all possible skill areas given the occupation group id and career band. There are a max of 10 skill areas per OG + CB pairing. */
  getSkillAreasByCareerBandAndOccupationGroup: Array<VerifiedSkills_UnmamppedSkillArea>;
  /** Fetches all skill expression to assessment part mappings for the given assessment. */
  getSkillExpressionAssessmentMappingsByAssessmentId: Array<VerifiedSkills_SkillExpressionAndAssessmentPart>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetAllOccupationGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  skillTrack?: InputMaybe<Scalars['String']>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetCareerBandsByOccupationGroupArgs = {
  occupationGroupId: Scalars['ID'];
  skillTrack?: InputMaybe<Scalars['String']>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetRawSkillAreaCourseMappingsArgs = {
  skillAreaId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetSkillAreaByCandidateCourseArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetSkillAreasByCareerBandAndOccupationGroupArgs = {
  careerBand: VerifiedSkills_CareerBand;
  occupationGroupId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsMappingQueriesGetSkillExpressionAssessmentMappingsByAssessmentIdArgs = {
  assessmentId: Scalars['ID'];
  assessmentType: Scalars['String'];
};

/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueries = {
  __typename?: 'VerifiedSkillsQueries';
  /** Batch API to fetch skill pathways for org. */
  getAllSkillPathwaysByOrgSlug: Array<VerifiedSkills_SkillPathwayByProgram>;
  /**
   * Fetches all Skill Pathways in the given program, regardless of user enrollment. User id for the VerifiedSkills_SkillAreaWithUserData is fetched from the request context.
   *
   * MVP has 2 pathways, with a total of 6 pathways planned for 2025. This a query for MVP, and will likely be replaced once the longterm home of
   * Skill Pathways is determined.
   */
  getAllSkillPathwaysByProgramId: Array<VerifiedSkills_SkillPathway>;
  /** Batch API to fetch skill pathways for multiple programs. */
  getAllSkillPathwaysByProgramIds: Array<VerifiedSkills_SkillPathwayByProgram>;
  /** Fetches the embedded partners for a skill path. This is a separate query to avoid blocking the rest of the VSP page. */
  getEmbeddedPartnersForSkillPath: Array<Partner_Partner>;
  /**
   * Fetches learning materials that have skill expression mappings for the given
   * course. skillExpressionIds and itemId are optional fields that can be
   * used to further filter the results.
   *
   * Learner materials are dependent on the learner's course branch id.
   *
   * userId is fetched from the request context
   */
  getLearningMaterialsForCurrentUserByCourse: VerifiedSkills_SkillExpressionLearningMaterialPaginatedResult;
  /** Fetches OG&CB for given courseId */
  getOccupationGroupAndCareerBandByCourseId: Array<VerifiedSkills_OccupationGroupAndCareerBand>;
  /**
   * Fetches skill area information given course id. Assumes that only one skill area is mapped to each course
   * This API only includes finalized production data intended for learner-facing UIs.
   * For internal tools and test courses, use VerifiedSkillsMappingQueries.getSkillAreaByCandidateCourse instead.
   */
  getSkillAreaByCourseId: VerifiedSkills_SkillArea;
  /** Fetches skill area information for given skill area id. */
  getSkillAreaById: VerifiedSkills_SkillArea;
  /**
   * Fetches all skill areas and metadata for the given occupation and career band in
   * the order they are to be displayed. Returns a max of 8 skill areas.
   */
  getSkillAreasByOccupationGroupAndCareerBand: Array<VerifiedSkills_SkillArea>;
  /**
   * Fetches all skill areas and metadata for a skill pathway using the template id in
   * the order they are to be displayed. Returns a max of 8 skill areas.
   */
  getSkillAreasBySkillPathway: Array<VerifiedSkills_SkillArea>;
  /**
   * Primary usecase is to fetch the skill attainment assessment id for each skill
   * area. Content is tied to the course branch, which is determined by the learner's
   * enrollment.
   */
  getSkillAreasForCurrentUser: Array<VerifiedSkills_SkillAreaWithUserData>;
  /**
   * Fetches a skill pathway by badge id. If the pathway is a Learning Pathway, and not a Skill Pathway it returns null.
   *
   * User id for the VerifiedSkills_SkillAreaWithUserData is fetched from the request context. However, if the user is not logged in it defaults to the most recent version of the skill pathway.
   */
  getSkillPathwayByBadgeIdForCurrentUser?: Maybe<VerifiedSkills_SkillPathway>;
  /**
   * Checks whether any of the given programs have at least one Verified Skill Path.
   * Uses a multiget to fetch reference collections from the badge service and then
   * validates them against the verified skill pathways store — centralising VSP
   * determination in the VSP domain.
   */
  hasVspForOrganization: Scalars['Boolean'];
  /** Searches for matching skill expressions by name */
  searchForSkillExpressionsByName: VerifiedSkills_SkillExpressionPaginatedResult;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetAllSkillPathwaysByOrgSlugArgs = {
  orgSlug: Scalars['String'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetAllSkillPathwaysByProgramIdArgs = {
  programId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetAllSkillPathwaysByProgramIdsArgs = {
  programIds: Array<Scalars['ID']>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetEmbeddedPartnersForSkillPathArgs = {
  pathwayId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetLearningMaterialsForCurrentUserByCourseArgs = {
  courseId: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  itemIds?: InputMaybe<Array<Scalars['ID']>>;
  limit?: Scalars['Int'];
  skillExpressionIds?: InputMaybe<Array<Scalars['ID']>>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetOccupationGroupAndCareerBandByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillAreaByCourseIdArgs = {
  courseId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillAreaByIdArgs = {
  id: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillAreasByOccupationGroupAndCareerBandArgs = {
  careerBand?: InputMaybe<VerifiedSkills_CareerBand>;
  occupationGroupId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillAreasBySkillPathwayArgs = {
  pathwayId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillAreasForCurrentUserArgs = {
  careerBand?: InputMaybe<VerifiedSkills_CareerBand>;
  occupationGroupId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesGetSkillPathwayByBadgeIdForCurrentUserArgs = {
  badgeTemplateId: Scalars['ID'];
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesHasVspForOrganizationArgs = {
  programIds: Array<Scalars['ID']>;
};


/** Queries that return data related to the Verified Skills taxonomy */
export type VerifiedSkillsQueriesSearchForSkillExpressionsByNameArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  limit?: Scalars['Int'];
  query: Scalars['String'];
};

/** Determines what career band grouping a verified skills pathway is */
export const VerifiedSkills_CareerBand = {
  /** Early career CareerBand */
  EarlyCareerProfessional: 'EARLY_CAREER_PROFESSIONAL',
  /** Executive Careerband */
  ExecutiveProfessional: 'EXECUTIVE_PROFESSIONAL',
  /** Managerial CareerBnad */
  ManagerialProfessional: 'MANAGERIAL_PROFESSIONAL',
  /** Skilled Professional CareerBand */
  SkilledProfessional: 'SKILLED_PROFESSIONAL'
} as const;

export type VerifiedSkills_CareerBand = typeof VerifiedSkills_CareerBand[keyof typeof VerifiedSkills_CareerBand];
/** Input type for the VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappings mutation. */
export type VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsInput = {
  /** The assessment id, e.g. an assignment id */
  assessmentId: Scalars['ID'];
  /** The new skill expression mappings to assessment part for the assessment. */
  assessmentPartToSkillExpressionMappings: Array<VerifiedSkills_SkillExpressionAndAssessmentPartInput>;
  /** The assessment type, e.g. "assignment", "lab" */
  assessmentType: Scalars['String'];
};

/** Result type for the VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappings mutation. */
export type VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsResult = {
  __typename?: 'VerifiedSkills_CreateOrUpdateSkillExpressionAssessmentMappingsResult';
  /** The assessment id, e.g. an assignment id */
  assessmentId: Scalars['ID'];
  /** The skill expression mappings to assessment part for the assessment. */
  assessmentPartToSkillExpressionMappings: Array<VerifiedSkills_SkillExpressionAndAssessmentPart>;
  /** The assessment type, e.g. "assignment", "lab" */
  assessmentType: Scalars['String'];
  /** The timestamp when the mappings for the assessment was last updated. */
  updatedAt: Scalars['DateTime'];
  /** The user who last updated the mappings for the assessment. */
  updatedBy: Scalars['ID'];
};

/** Material for Verified Skill Paths */
export type VerifiedSkills_Material = {
  __typename?: 'VerifiedSkills_Material';
  /** The total duration for learners to complete the Verified Skill Path. */
  totalDuration?: Maybe<Scalars['Duration']>;
  /** Learning material grouped by week */
  weeks: Array<VerifiedSkills_WeeklyMaterial>;
};

/** Occupation group of a skill pathway */
export type VerifiedSkills_OccupationGroup = {
  __typename?: 'VerifiedSkills_OccupationGroup';
  /** The occupation group ID */
  id: Scalars['ID'];
  /** The name of the occupation group */
  name: Scalars['String'];
};

/** Wrapper of Occupation group and Career band */
export type VerifiedSkills_OccupationGroupAndCareerBand = {
  __typename?: 'VerifiedSkills_OccupationGroupAndCareerBand';
  /** The career band */
  careerBand: VerifiedSkills_CareerBand;
  /** Occupation group */
  occupationGroup: VerifiedSkills_OccupationGroup;
};

/** Paginated result wrapper for VerifiedSkills_OccuptionGroup */
export type VerifiedSkills_OccuptionGroupPaginatedResult = {
  __typename?: 'VerifiedSkills_OccuptionGroupPaginatedResult';
  /** A list of skill expressions that match the provided query */
  elements: Array<VerifiedSkills_OccupationGroup>;
  /** Pagination information */
  pagination: Pagination;
};

/** A grouping of Skill Expressions with a Verified Skills Pathway */
export type VerifiedSkills_SkillArea = {
  __typename?: 'VerifiedSkills_SkillArea';
  /** The course that teaches content for the skill area. */
  course: Course_Course;
  /** The skill area ID */
  id: Scalars['ID'];
  /** The name of the skill area */
  name: Scalars['String'];
  /** List of expressions attached to the skill area. */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
};

/** A course that has been tentatively mapped to a Skill Area, but may not be surfaced to learners yet. */
export type VerifiedSkills_SkillAreaCandidateCourse = {
  __typename?: 'VerifiedSkills_SkillAreaCandidateCourse';
  /** Course information for potential Skill Area mapping */
  course: Course_Course;
  /**
   * List of Skill Expressions recommended by ML that are not covered in the
   * candidate course content. The list is empty if the recommended Skill
   * Expressions are completely covered.
   */
  missingRecommendedSkillExpressions: Array<VerifiedSkills_SkillExpression>;
};

/** Wrapper of VerifiedSkills_SkillArea with additional user specific information with the final assessment item of the course attached to the skill area */
export type VerifiedSkills_SkillAreaWithUserData = {
  __typename?: 'VerifiedSkills_SkillAreaWithUserData';
  /**
   * Previously: only the course slug and item id were required to create a url to the assessment.
   * The course slug is provided in skillArea's course field.
   * @deprecated no longer needed in updated UX
   */
  assessmentItemId?: Maybe<Scalars['ID']>;
  /** Core Skill area information */
  skillArea: VerifiedSkills_SkillArea;
};

/** Granular skill that composes a skill area */
export type VerifiedSkills_SkillExpression = {
  __typename?: 'VerifiedSkills_SkillExpression';
  /** The description of the skill expression */
  description?: Maybe<Scalars['String']>;
  /** The skill expression ID */
  id: Scalars['ID'];
  /** The name of the skill expression */
  name: Scalars['String'];
};

/** Skill expression to assessment part mapping */
export type VerifiedSkills_SkillExpressionAndAssessmentPart = {
  __typename?: 'VerifiedSkills_SkillExpressionAndAssessmentPart';
  /** The assessment part id, e.g. a question id or a rubric id. */
  assessmentPartId: Scalars['ID'];
  /** The assessment part type, e.g. "question", "rubric" */
  assessmentPartType: Scalars['String'];
  /** The skill expression. */
  skillExpression: VerifiedSkills_SkillExpression;
  /** The weight of this assessment part of the skill expression. The overall weight of all parts of a skill expression should sum to 1.0. */
  weight?: Maybe<Scalars['Float']>;
};

/** Skill expression to assessment part mapping Input */
export type VerifiedSkills_SkillExpressionAndAssessmentPartInput = {
  /** The assessment part id, e.g. a question id or a rubric id. */
  assessmentPartId: Scalars['ID'];
  /** The assessment part type, e.g. "question", "rubric" */
  assessmentPartType: Scalars['String'];
  /** The skill expression Id. */
  skillExpressionId: Scalars['ID'];
  /** The weight of this assessment part of the skill expression. The overall weight of all parts of a skill expression should sum to 1.0. */
  weight?: InputMaybe<Scalars['Float']>;
};

/** Course content that is used to teach a skill area */
export type VerifiedSkills_SkillExpressionLearningMaterial = {
  __typename?: 'VerifiedSkills_SkillExpressionLearningMaterial';
  /** Item id */
  itemId: Scalars['ID'];
  /** List of skill expressions attached to the item. */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
};

/** Paginated result wrapper for VerifiedSkills_SkillExpressionLearningMaterial */
export type VerifiedSkills_SkillExpressionLearningMaterialPaginatedResult = {
  __typename?: 'VerifiedSkills_SkillExpressionLearningMaterialPaginatedResult';
  /** A list of learning material within the given course id that matches the provided optional filters */
  elements: Array<VerifiedSkills_SkillExpressionLearningMaterial>;
  /** Pagination information */
  pagination: Pagination;
};

/** Paginated result wrapper for VerifiedSkills_SkillExpression */
export type VerifiedSkills_SkillExpressionPaginatedResult = {
  __typename?: 'VerifiedSkills_SkillExpressionPaginatedResult';
  /** A list of skill expressions that match the provided query */
  elements: Array<VerifiedSkills_SkillExpression>;
  /** Pagination information */
  pagination: Pagination;
};

/** A Skill Pathway, composed of a max of 8 Skill Areas. */
export type VerifiedSkills_SkillPathway = {
  __typename?: 'VerifiedSkills_SkillPathway';
  /** Learning pathway (LP) template id used to map Verified Skill Pathway */
  badgeTemplateId: Scalars['ID'];
  /** Career band level of the skill pathway */
  careerBand?: Maybe<VerifiedSkills_CareerBand>;
  /** The Skill Pathway id */
  id: Scalars['ID'];
  /** Name and id of the occupation the skill pathway is working towards */
  occupationGroup: VerifiedSkills_OccupationGroup;
  /** A max of 8 skill areas within the Skill Pathway. User data is used to determine what Skill Area course version to use */
  skillAreasWithUserData: Array<VerifiedSkills_SkillAreaWithUserData>;
};

/** Program ID with its associated skill pathway summary. */
export type VerifiedSkills_SkillPathwayByProgram = {
  __typename?: 'VerifiedSkills_SkillPathwayByProgram';
  /** Program ID */
  programId: Scalars['ID'];
  /** Lightweight skill pathway summary for this program (without skill area details) */
  skillPathway?: Maybe<VerifiedSkills_SkillPathwaySummary>;
};

/**
 * Lightweight summary of a Skill Pathway, without skill area details.
 * Used for batch queries where only pathway existence needs to be checked.
 */
export type VerifiedSkills_SkillPathwaySummary = {
  __typename?: 'VerifiedSkills_SkillPathwaySummary';
  /** Learning pathway (LP) template id used to map Verified Skill Pathway */
  badgeTemplateId: Scalars['ID'];
  /** Career band level of the skill pathway */
  careerBand?: Maybe<VerifiedSkills_CareerBand>;
  /** The Skill Pathway id */
  id: Scalars['ID'];
  /** The name of the skill pathway (skill path name) */
  name?: Maybe<Scalars['String']>;
  /** Name and id of the occupation the skill pathway is working towards */
  occupationGroup: VerifiedSkills_OccupationGroup;
};

/** A grouping of Skill Expressions with an unmapped Verified Skills Pathway */
export type VerifiedSkills_UnmamppedSkillArea = {
  __typename?: 'VerifiedSkills_UnmamppedSkillArea';
  /** The skill area ID */
  id: Scalars['ID'];
  /** The name of the skill area */
  name: Scalars['String'];
  /** List of expressions attached to the skill area. */
  skillExpressions: Array<VerifiedSkills_SkillExpression>;
};

/** Weekly learning material for Verified Skill Paths */
export type VerifiedSkills_WeeklyMaterial = {
  __typename?: 'VerifiedSkills_WeeklyMaterial';
  /** All assessments in this week's material */
  assessments?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The id of the weekly learning material */
  id: Scalars['ID'];
  /** All lectures in this week's material */
  lectures?: Maybe<Array<DescriptionPage_WeeklyMaterialItem>>;
  /** The name of the weekly learning material */
  name: Scalars['String'];
  /** Tools and Languages associated with the module */
  toolsAndLanguages: Array<Skill_Skill>;
  /** The total duration for learners to complete the material */
  totalDuration?: Maybe<Scalars['Duration']>;
};

/** Queries related to Viva Exam sessions */
export type VivaExamQueries = {
  __typename?: 'VivaExamQueries';
  /** Query the latest viva exam responses by given user linked to given assignment */
  queryLatestExamResponses?: Maybe<VivaExam_ExamResponses>;
  /** Query the latest viva exam result summary by given user linked to given assignment */
  queryLatestExamResultSummary?: Maybe<VivaExam_ExamResultSummary>;
};


/** Queries related to Viva Exam sessions */
export type VivaExamQueriesQueryLatestExamResponsesArgs = {
  assignmentId: Scalars['ID'];
  assignmentType: VivaExam_AssignmentType;
  userId: Scalars['Int'];
};


/** Queries related to Viva Exam sessions */
export type VivaExamQueriesQueryLatestExamResultSummaryArgs = {
  assignmentId: Scalars['ID'];
  assignmentType: VivaExam_AssignmentType;
  userId: Scalars['Int'];
};

/** supported assignment type for viva exam */
export const VivaExam_AssignmentType = {
  /** the assignment type current for staff graded assignments and new quizzes */
  Assignment: 'ASSIGNMENT',
  /** peer review assignments */
  PeerReview: 'PEER_REVIEW'
} as const;

export type VivaExam_AssignmentType = typeof VivaExam_AssignmentType[keyof typeof VivaExam_AssignmentType];
/** Enum representing viva exam configuration status */
export const VivaExam_ConfigurationStatus = {
  /** The viva exam is disabled */
  Disabled: 'DISABLED',
  /** The viva exam is enabled */
  Enabled: 'ENABLED',
  /** The viva exam is enabled with learner feedback turned on */
  EnabledWithFeedback: 'ENABLED_WITH_FEEDBACK'
} as const;

export type VivaExam_ConfigurationStatus = typeof VivaExam_ConfigurationStatus[keyof typeof VivaExam_ConfigurationStatus];
/** viva exam error interface */
export type VivaExam_Error = {
  /** error message */
  message: Scalars['String'];
};

/** Full responses of the viva exam */
export type VivaExam_ExamResponses = {
  __typename?: 'VivaExam_ExamResponses';
  /** Viva exam session */
  examSession: VivaExam_VivaExamSession;
};

/** Conclusion of viva exam assessed by GPT */
export type VivaExam_ExamResultConclusion = {
  __typename?: 'VivaExam_ExamResultConclusion';
  /** Comment generated by GPT for the consistency score */
  consistencyComment: Scalars['String'];
  /** questions asked by GPT to assess the learner's consistency score */
  consistencyQuestions: Array<VivaExam_VivaExamQuestion>;
  /** A score of 0-10 representing the evaluation by GPT for the learner’s consistency in their submission */
  consistencyScore: Scalars['Float'];
  /** Comment generated by GPT for the knowledge score */
  knowledgeComment: Scalars['String'];
  /** questions asked by GPT to assess the learner's knowledge score */
  knowledgeQuestions: Array<VivaExam_VivaExamQuestion>;
  /** A score of 0-10 representing the evaluation by GPT for the learner’s knowledge */
  knowledgeScore: Scalars['Float'];
  /** Comment generated by GPT for the overall score */
  overallComment: Scalars['String'];
  /** A score of 0-10 representing the evaluation by GPT for the learner’s overall integrity in their submission */
  overallScore: Scalars['Float'];
  /** Comment generated by GPT for the relevance score */
  relevanceComment: Scalars['String'];
  /** questions asked by GPT to assess the learner's relevance score */
  relevanceQuestions: Array<VivaExam_VivaExamQuestion>;
  /** A score of 0-10 representing the evaluation by GPT for the learner’s submission’s relevance to the assignment */
  relevanceScore: Scalars['Float'];
  /** Comment generated by GPT for the understanding score */
  understandingComment: Scalars['String'];
  /** questions asked by GPT to assess the learner's understanding score */
  understandingQuestions: Array<VivaExam_VivaExamQuestion>;
  /** A score of 0-10 representing the evaluation by GPT for the learner’s understanding of the assignment */
  understandingScore: Scalars['Float'];
};

/** Evaluation summary of the viva exam */
export type VivaExam_ExamResultSummary = {
  __typename?: 'VivaExam_ExamResultSummary';
  /** Conclusion of viva exam assessed by GPT */
  conclusion?: Maybe<VivaExam_ExamResultConclusion>;
  /** Enum representing user's feedback choice for the viva exam session */
  feedbackChoice?: Maybe<VivaExam_UserFeedbackChoice>;
  /** Flagging status of the exam */
  flagStatus: VivaExam_VivaExamFlagStatus;
  /** ID of the viva exam session */
  id: Scalars['ID'];
};

/** Error that can usually be resolved through retrying the request */
export type VivaExam_Retriable_Error = VivaExam_Error & {
  __typename?: 'VivaExam_Retriable_Error';
  /** error message */
  message: Scalars['String'];
};

/** input to save user feedback to a viva exam session */
export type VivaExam_SaveUserFeedbackInput = {
  /** viva exam session Id */
  examSessionId: Scalars['ID'];
  /** Enum representing user's feedback choice for the viva exam session */
  feedbackChoice: VivaExam_UserFeedbackChoice;
  /** optional feedback comment for the viva exam session */
  feedbackComment?: InputMaybe<Scalars['String']>;
};

/** VivaExam_SaveUserFeedback mutation response */
export type VivaExam_SaveUserFeedbackResult = {
  __typename?: 'VivaExam_SaveUserFeedbackResult';
  /** viva exam session data */
  examSession: VivaExam_VivaExamSession;
};

/** startExam failure response with errors */
export type VivaExam_StartExamFailure = {
  __typename?: 'VivaExam_StartExamFailure';
  /** viva exam session data */
  errors: Array<VivaExam_Retriable_Error | VivaExam_Unsupported_Error>;
};

/** input parameters used to start a viva exam session */
export type VivaExam_StartExamInput = {
  /** assignment id */
  assignmentId: Scalars['ID'];
  /** supported assignment type */
  assignmentType: VivaExam_AssignmentType;
  /** course id */
  courseId: Scalars['ID'];
};

/** startExam mutation response */
export type VivaExam_StartExamResult = VivaExam_StartExamFailure | VivaExam_StartExamSuccess;

/** startExam success response */
export type VivaExam_StartExamSuccess = {
  __typename?: 'VivaExam_StartExamSuccess';
  /** viva exam session data */
  examSession: VivaExam_VivaExamSession;
};

/** submitQuestionAnswers failure response with errors */
export type VivaExam_SubmitQuestionAnswerFailure = {
  __typename?: 'VivaExam_SubmitQuestionAnswerFailure';
  /** errors */
  errors: Array<VivaExam_Retriable_Error | VivaExam_Unsupported_Error>;
};

/** input to submit an answer to a viva exam question */
export type VivaExam_SubmitQuestionAnswerInput = {
  /** viva exam session Id */
  examSessionId: Scalars['ID'];
  /** learner response to be submitted to viva exam question */
  response: Scalars['String'];
};

/** submitQuestionAnswer mutation response */
export type VivaExam_SubmitQuestionAnswerResult = VivaExam_SubmitQuestionAnswerFailure | VivaExam_SubmitQuestionAnswerSuccess;

/** submitQuestionAnswers response if successful */
export type VivaExam_SubmitQuestionAnswerSuccess = {
  __typename?: 'VivaExam_SubmitQuestionAnswerSuccess';
  /** return the viva exam session (contains either the next question or done status) */
  examSession?: Maybe<VivaExam_VivaExamSession>;
};

/** An error to indicate that viva exam cannot be attempted due to unsupported content, for example, uploading an supported file type as part of the submission */
export type VivaExam_Unsupported_Error = VivaExam_Error & {
  __typename?: 'VivaExam_Unsupported_Error';
  /** error message */
  message: Scalars['String'];
};

/** Enum representing user feedback of a viva exam session */
export const VivaExam_UserFeedbackChoice = {
  /** The viva exam session is disliked by the user */
  Dislike: 'DISLIKE',
  /** The viva exam session is liked by the user */
  Like: 'LIKE'
} as const;

export type VivaExam_UserFeedbackChoice = typeof VivaExam_UserFeedbackChoice[keyof typeof VivaExam_UserFeedbackChoice];
/** Enum representing the flagging status of the exam */
export const VivaExam_VivaExamFlagStatus = {
  /** Viva exam session is incomplete */
  Incomplete: 'INCOMPLETE',
  /** Integrity issue was found via the viva exam */
  IntegrityIssueFound: 'INTEGRITY_ISSUE_FOUND',
  /** No integrity issue was found via the viva exam */
  NoIntegrityIssue: 'NO_INTEGRITY_ISSUE'
} as const;

export type VivaExam_VivaExamFlagStatus = typeof VivaExam_VivaExamFlagStatus[keyof typeof VivaExam_VivaExamFlagStatus];
/** viva exam question and response data */
export type VivaExam_VivaExamQuestion = {
  __typename?: 'VivaExam_VivaExamQuestion';
  /** question data */
  question: Scalars['String'];
  /** question rationale(why this question was asked by GPT) */
  rationale?: Maybe<Scalars['String']>;
  /** learner response data, only present when answered */
  response?: Maybe<Scalars['String']>;
};

/** viva exam session data */
export type VivaExam_VivaExamSession = {
  __typename?: 'VivaExam_VivaExamSession';
  /** integrity check flag status */
  flagStatus: VivaExam_VivaExamFlagStatus;
  /** id of the exam session */
  id: Scalars['ID'];
  /** status of the exam session indicating whether it is complete */
  isComplete: Scalars['Boolean'];
  /** optional field that is only returned after the exam session is complete and the model has generated some feedback for the learner */
  learnerFeedback?: Maybe<Scalars['String']>;
  /** questions in the viva exam */
  questions: Array<VivaExam_VivaExamQuestion>;
  /** total expected questions in the exam session */
  totalExpectedQuestions: Scalars['Int'];
};

/** Weekly streaks queries */
export type WeeklyStreaksQueries = {
  __typename?: 'WeeklyStreaksQueries';
  /** Get the streak count of a learner before experiment launch. */
  queryBackfilledWeeklyStreak: BackfilledLearnerStreaks_Streak;
  /** Get or create weekly streak count for learner. */
  queryWeeklyStreak: LearnerStreaks_Streak;
};

/** WES Checkout queries type that includes all queries related to the WES Checkout service. */
export type WesCheckoutActionQueries = {
  __typename?: 'WesCheckoutActionQueries';
  /**
   * Determines the required checkout action (login to an existing account or create an account and checkout)
   * for the given email address. Returns an action indicating whether the user should log in
   * to an existing account or create a new account and proceed to checkout .
   */
  getWesCheckoutActionByEmail: WesCheckout_Action;
};


/** WES Checkout queries type that includes all queries related to the WES Checkout service. */
export type WesCheckoutActionQueriesGetWesCheckoutActionByEmailArgs = {
  email: Scalars['String'];
};

/**
 * Enumeration of possible actions for the WesCheckout process. This indicates whether the user
 * should log in to an existing account or create a new account and proceed to checkout.
 */
export const WesCheckout_Action = {
  /** The action to create a new account and proceed to checkout. */
  CreateAccountAndCheckout: 'CREATE_ACCOUNT_AND_CHECKOUT',
  /** The action to log in to an existing account. */
  LogInToExistingAccount: 'LOG_IN_TO_EXISTING_ACCOUNT'
} as const;

export type WesCheckout_Action = typeof WesCheckout_Action[keyof typeof WesCheckout_Action];
/** WES Validator queries type that includes all queries related to the Validating WES service. */
export type WesValidatorQueries = {
  __typename?: 'WesValidatorQueries';
  /**
   * Validates whether a given email address is a valid business email.
   * Performs comprehensive validation including format checking and
   * business domain verification.
   */
  validateBusinessEmail: WesValidator_BusinessEmailValidationResult;
  /**
   * Validates whether a given email domain is a valid business domain.
   * Checks if the domain belongs to a legitimate business organization
   * and is not a personal email provider (e.g., gmail.com, yahoo.com).
   */
  validateBusinessEmailDomain: WesValidator_BusinessEmailValidationResult;
};


/** WES Validator queries type that includes all queries related to the Validating WES service. */
export type WesValidatorQueriesValidateBusinessEmailArgs = {
  email: Scalars['String'];
};


/** WES Validator queries type that includes all queries related to the Validating WES service. */
export type WesValidatorQueriesValidateBusinessEmailDomainArgs = {
  emailDomain: Scalars['String'];
};

/**
 * Represents the result of business email or email domain validation.
 * Contains the validation outcome for both individual email addresses
 * and email domains used in business contexts.
 */
export type WesValidator_BusinessEmailValidationResult = {
  __typename?: 'WesValidator_BusinessEmailValidationResult';
  /**
   * Indicates whether OTP verification is required for this email.
   * OTP is required for emails with uncertain deliverability status
   * (Catch All, Unknown, Do Not Mail) even if they pass business validation.
   * This field is optional and may be null for backward compatibility.
   */
  isOtpRequired?: Maybe<Scalars['Boolean']>;
  /**
   * Indicates whether the validated email or email domain meets
   * business validation criteria and is considered valid.
   */
  isValid: Scalars['Boolean'];
};

/** Plugins (ie Widgets) GraphQL Schema */
export type WidgetSessionQueries = {
  __typename?: 'WidgetSessionQueries';
  /** A query to retrieve a widget session for a sessionId. Returns null if the user in the request context doesnt have permissions to view the associated session id. */
  queryWidgetSessionBySessionId?: Maybe<Plugins_WidgetSession>;
};


/** Plugins (ie Widgets) GraphQL Schema */
export type WidgetSessionQueriesQueryWidgetSessionBySessionIdArgs = {
  sessionId: Scalars['ID'];
};

export type WorkspaceImageAuthoringDataV1 = {
  __typename?: 'WorkspaceImageAuthoringDataV1';
  authoringTemplates?: Maybe<AuthoringWorkspaceTemplatesV1Connection>;
  builds: Array<Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImageBuildWithTag>>;
  courseId: Scalars['String'];
  graderMetadata?: Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceGraderMetadata>;
  id: Scalars['String'];
  imageApplicationType: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType;
  imageId: Scalars['String'];
  imageVersions: Scalars['JSON'];
  isDefaultImage: Scalars['Boolean'];
  isEditable: Scalars['Boolean'];
  isNbGraderImage: Scalars['Boolean'];
  isNbgraderImage: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  manifest: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_Manifest_ImageManifest;
  manifestChangedMessage?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  publishMetadata: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageAuthoringDataPublishMetadata;
  publishedVersion: Scalars['String'];
  readyForPublish: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageAuthoringDataPublishValidation;
  scopes: Array<Maybe<Scalars['String']>>;
  testVersion: Scalars['String'];
  testWorkspaceId: Scalars['String'];
  updatedAt: Scalars['Float'];
  /** id for a Coursera user */
  updatedBy: Scalars['Int'];
};


export type WorkspaceImageAuthoringDataV1AuthoringTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type WorkspaceImageAuthoringDataV1Connection = {
  __typename?: 'WorkspaceImageAuthoringDataV1Connection';
  elements: Array<Maybe<WorkspaceImageAuthoringDataV1>>;
  paging: ResponsePagination;
};

export type WorkspaceImageAuthoringDataV1Course = {
  __typename?: 'WorkspaceImageAuthoringDataV1Course';
  connection?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
  courseId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type WorkspaceImageAuthoringDataV1Resource = {
  __typename?: 'WorkspaceImageAuthoringDataV1Resource';
  course?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
  get?: Maybe<WorkspaceImageAuthoringDataV1>;
  multiGet?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
};


export type WorkspaceImageAuthoringDataV1ResourceCourseArgs = {
  courseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type WorkspaceImageAuthoringDataV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type WorkspaceImageAuthoringDataV1ResourceMutations = {
  __typename?: 'WorkspaceImageAuthoringDataV1ResourceMutations';
  addDefaultImageToCourse?: Maybe<Scalars['JSON']>;
  build?: Maybe<Scalars['JSON']>;
  create?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
  defaultImages?: Maybe<Scalars['JSON']>;
  delete?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
  imageName?: Maybe<Scalars['JSON']>;
  patch?: Maybe<WorkspaceImageAuthoringDataV1Connection>;
  publish?: Maybe<Scalars['JSON']>;
  setTestWorkspaceVersion?: Maybe<Scalars['JSON']>;
  updateBuildsAndPublish?: Maybe<Scalars['JSON']>;
  versionHistory?: Maybe<Scalars['JSON']>;
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsAddDefaultImageToCourseArgs = {
  courseId: Scalars['String'];
  imageId: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsBuildArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsDefaultImagesArgs = {
  includeGpu?: InputMaybe<Scalars['Boolean']>;
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsDeleteArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsImageNameArgs = {
  courseId: Scalars['String'];
  imageName: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsPatchArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsPublishArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsSetTestWorkspaceVersionArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsUpdateBuildsAndPublishArgs = {
  id: Scalars['String'];
};


export type WorkspaceImageAuthoringDataV1ResourceMutationsVersionHistoryArgs = {
  id: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_BaseImageWithCustomizationsMember = {
  __typename?: 'WorkspaceImageAuthoringDataV1_baseImageWithCustomizationsMember';
  baseImageWithCustomizations: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_BaseImageWithCustomizations;
};

export type WorkspaceImageAuthoringDataV1_CourseraAssetMember = {
  __typename?: 'WorkspaceImageAuthoringDataV1_courseraAssetMember';
  courseraAsset: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_CourseraAsset;
};

export type WorkspaceImageAuthoringDataV1_DockerCommitMember = {
  __typename?: 'WorkspaceImageAuthoringDataV1_dockerCommitMember';
  dockerCommit: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_DockerCommit;
};

export type WorkspaceImageAuthoringDataV1_GithubMember = {
  __typename?: 'WorkspaceImageAuthoringDataV1_githubMember';
  github: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_Github;
};

export type WorkspaceImageAuthoringDataV1_MigratedFromLegacyNotebookMember = {
  __typename?: 'WorkspaceImageAuthoringDataV1_migratedFromLegacyNotebookMember';
  migratedFromLegacyNotebook: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_MigratedFromLegacyNotebook;
};

export const WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus = {
  Failed: 'FAILED',
  Fault: 'FAULT',
  InProgress: 'IN_PROGRESS',
  Stopped: 'STOPPED',
  Succeeded: 'SUCCEEDED',
  TimedOut: 'TIMED_OUT'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus];
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_HealthCheckConfig = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_HealthCheckConfig';
  path: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_CourseraAsset = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_CourseraAsset';
  assetId: Scalars['String'];
  versionNotes: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_DockerCommit = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_DockerCommit';
  ArbitraryField: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_Github = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_Github';
  ArbitraryField: Scalars['String'];
};

/** Indicates the type of the image shared between workspace and grid platform. */
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType = {
  NbGrader: 'NB_GRADER',
  VscodeCustomGrader: 'VSCODE_CUSTOM_GRADER',
  VscodePreconfiguredJava: 'VSCODE_PRECONFIGURED_JAVA'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType];
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImageBuildWithTag = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_ImageBuildWithTag';
  buildComplete: Scalars['Boolean'];
  buildStatus?: Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Aws_Codebuild_BuildStatus>;
  codeBuildId?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['Float']>;
  imageTag: Scalars['String'];
  source: WorkspaceImageAuthoringDataV1_Source;
  startedAt?: Maybe<Scalars['Float']>;
};

export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus = {
  Published: 'PUBLISHED',
  Unpublished: 'UNPUBLISHED',
  UnpublishedChanges: 'UNPUBLISHED_CHANGES'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus];
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_MigratedFromLegacyNotebook = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_MigratedFromLegacyNotebook';
  ArbitraryField: Scalars['String'];
};

/** Computed view of the volume definition. */
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_VolumeMountPath = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_VolumeMountPath';
  isDeletable: Scalars['Boolean'];
  isPathRenamable: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  path: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceGraderMetadata = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_WorkspaceGraderMetadata';
  executorId?: Maybe<Scalars['String']>;
  graderType: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType;
};

/** Indicates the type of the base image. */
export const WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType = {
  AwsCloud: 'AWS_CLOUD',
  Custom: 'CUSTOM',
  GenAiSandbox: 'GEN_AI_SANDBOX',
  JupyterNotebook: 'JUPYTER_NOTEBOOK',
  Linux: 'LINUX',
  Rstudio: 'RSTUDIO',
  VirtualBrowser: 'VIRTUAL_BROWSER',
  Vscode: 'VSCODE'
} as const;

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType = typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType[keyof typeof WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageApplicationType];
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageAuthoringDataPublishMetadata = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_WorkspaceImageAuthoringDataPublishMetadata';
  publishStatus: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_ImagePublishStatus;
  publishedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  publishedBy?: Maybe<Scalars['Int']>;
  readyForPublish: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageAuthoringDataPublishValidation;
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_WorkspaceImageAuthoringDataPublishValidation = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_authoring_WorkspaceImageAuthoringDataPublishValidation';
  isReadyForPublish: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

/** Envrionment variables of container */
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Container_ContainerEnvVar = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_container_ContainerEnvVar';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Details of these limits can be found at [[https://docs.docker.com/engine/admin/resource_constraints/#--kernel-memory-details]] */
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Container_ContainerResourceLimits = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_container_ContainerResourceLimits';
  cpus: Scalars['Float'];
  disk?: Maybe<Scalars['Float']>;
  memory: Scalars['Float'];
};

/** Represents a base docker image+tag and a list of python packages to be added to it.  'customization' for a given package set (i.e. pip packages), provide the option to install specified packages  'grader' adds extra configuration to allow a grader to be attached with the image */
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_BaseImageWithCustomizations = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_image_BaseImageWithCustomizations';
  baseImage: Scalars['String'];
  buildMetadata: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_BuildImageMetadata;
  customizations: Scalars['JSON'];
  versionNotes: Scalars['String'];
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_BuildImageMetadata = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_image_BuildImageMetadata';
  grader?: Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_GraderType>;
};

/** Computed view of the [[WorkspaceImageManifest]]. */
export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_Manifest_ImageManifest = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_image_manifest_ImageManifest';
  changes?: Maybe<Scalars['String']>;
  defaultVolumeMountPaths: Array<Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Authoring_VolumeMountPath>>;
  description?: Maybe<Scalars['String']>;
  environmentVarirables: Array<Maybe<WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Container_ContainerEnvVar>>;
  healthCheck: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_HealthCheckConfig;
  hostSpec: Scalars['String'];
  httpPort: Scalars['Int'];
  isFileBrowserEnabled: Scalars['Boolean'];
  label: Scalars['String'];
  limits: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Container_ContainerResourceLimits;
  maintainer: WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_Manifest_WorkspaceImageMaintainer;
  volumeMountPaths: Array<Maybe<Scalars['String']>>;
};

export type WorkspaceImageAuthoringDataV1_Org_Coursera_Workspace_Image_Manifest_WorkspaceImageMaintainer = {
  __typename?: 'WorkspaceImageAuthoringDataV1_org_coursera_workspace_image_manifest_WorkspaceImageMaintainer';
  email: Scalars['String'];
  name: Scalars['String'];
  /** id for a Coursera user */
  userId?: Maybe<Scalars['Int']>;
};

export type WorkspaceImageAuthoringDataV1_Source = WorkspaceImageAuthoringDataV1_BaseImageWithCustomizationsMember | WorkspaceImageAuthoringDataV1_CourseraAssetMember | WorkspaceImageAuthoringDataV1_DockerCommitMember | WorkspaceImageAuthoringDataV1_GithubMember | WorkspaceImageAuthoringDataV1_MigratedFromLegacyNotebookMember;

export type WorkspacePublishStatesV1 = {
  __typename?: 'WorkspacePublishStatesV1';
  id: Scalars['String'];
  publishStartedAt: Scalars['Float'];
  publishStatus: WorkspacePublishStatesV1_PublishStatus;
  statusUpdatedAt: Scalars['Float'];
};

export type WorkspacePublishStatesV1Connection = {
  __typename?: 'WorkspacePublishStatesV1Connection';
  elements: Array<Maybe<WorkspacePublishStatesV1>>;
  paging: ResponsePagination;
};

export type WorkspacePublishStatesV1Resource = {
  __typename?: 'WorkspacePublishStatesV1Resource';
  get?: Maybe<WorkspacePublishStatesV1>;
  multiGet?: Maybe<WorkspacePublishStatesV1Connection>;
};


export type WorkspacePublishStatesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type WorkspacePublishStatesV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_HealthCheckConfig = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_HealthCheckConfig';
  path: Scalars['String'];
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_SharedWorkspace = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_SharedWorkspace';
  workspaceId: Scalars['String'];
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_WorkspaceTemplate = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_WorkspaceTemplate';
  childPublishSettings?: Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishSettings>;
  command?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  environmentVars: Array<Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_ContainerEnvVar>>;
  healthCheck: WorkspacePublishStatesV1_Org_Coursera_Workspace_HealthCheckConfig;
  hostSpecs: Array<Maybe<Scalars['String']>>;
  httpPort: Scalars['Int'];
  imageTag: Scalars['String'];
  launchContextMacros: Array<Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro>>;
  logType: WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType;
  name?: Maybe<Scalars['String']>;
  publishMetadata?: Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_WorkspacePublishMetadata>;
  resourceLimits?: Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_ContainerResourceLimits>;
  scopes: Array<Maybe<Scalars['String']>>;
  sharedWorkspaces: Array<Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_SharedWorkspace>>;
  updatedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  updatedBy?: Maybe<Scalars['Int']>;
  volumes: Scalars['JSON'];
};

/** Envrionment variables of container */
export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_ContainerEnvVar = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_container_ContainerEnvVar';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Details of these limits can be found at [[https://docs.docker.com/engine/admin/resource_constraints/#--kernel-memory-details]] */
export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_ContainerResourceLimits = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_container_ContainerResourceLimits';
  cpus: Scalars['Float'];
  disk?: Maybe<Scalars['Float']>;
  memory: Scalars['Float'];
};

/** Container log type. If set to AWS then container logs are sent to AWS cloudwatch. STD_OUT should be used as a default. */
export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType = {
  Aws: 'AWS',
  StdOut: 'STD_OUT'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Container_LogType];
export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = {
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  CourseBranchId: 'COURSE_BRANCH_ID',
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  CourseId: 'COURSE_ID',
  CourseName: 'COURSE_NAME',
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  CourseSlug: 'COURSE_SLUG',
  Evg1Code: 'EVG1_CODE',
  GcloudKey: 'GCLOUD_KEY',
  GenAiModels: 'GEN_AI_MODELS',
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  InstructorName: 'INSTRUCTOR_NAME',
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  ItemDeadline: 'ITEM_DEADLINE',
  ItemDeadlines: 'ITEM_DEADLINES',
  ItemId: 'ITEM_ID',
  OpenaiApiKey: 'OPENAI_API_KEY',
  PartnerId: 'PARTNER_ID',
  SessionStartTime: 'SESSION_START_TIME',
  SubmissionToken: 'SUBMISSION_TOKEN',
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro];
export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishFailed = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_publish_PublishFailed';
  errorMessage: Scalars['String'];
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishInProgress = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_publish_PublishInProgress';
  ArbitraryField: Scalars['String'];
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishSettings = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_publish_PublishSettings';
  publishTypes: Array<Maybe<WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType>>;
};

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishSucceeded = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_publish_PublishSucceeded';
  publishedTemplate: WorkspacePublishStatesV1_Org_Coursera_Workspace_WorkspaceTemplate;
  publishedTemplateId: Scalars['String'];
};

export const WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType = {
  PublisherChoice: 'PUBLISHER_CHOICE',
  RoOnly: 'RO_ONLY'
} as const;

export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType = typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType[keyof typeof WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishType];
export type WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_WorkspacePublishMetadata = {
  __typename?: 'WorkspacePublishStatesV1_org_coursera_workspace_publish_WorkspacePublishMetadata';
  isForced: Scalars['Boolean'];
  isNotifying: Scalars['Boolean'];
  publishSummary?: Maybe<Scalars['String']>;
};

export type WorkspacePublishStatesV1_PublishFailedMember = {
  __typename?: 'WorkspacePublishStatesV1_publishFailedMember';
  publishFailed: WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishFailed;
};

export type WorkspacePublishStatesV1_PublishInProgressMember = {
  __typename?: 'WorkspacePublishStatesV1_publishInProgressMember';
  publishInProgress: WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishInProgress;
};

export type WorkspacePublishStatesV1_PublishStatus = WorkspacePublishStatesV1_PublishFailedMember | WorkspacePublishStatesV1_PublishInProgressMember | WorkspacePublishStatesV1_PublishSucceededMember;

export type WorkspacePublishStatesV1_PublishSucceededMember = {
  __typename?: 'WorkspacePublishStatesV1_publishSucceededMember';
  publishSucceeded: WorkspacePublishStatesV1_Org_Coursera_Workspace_Publish_PublishSucceeded;
};

export type WorkspaceTemplatesV1 = {
  __typename?: 'WorkspaceTemplatesV1';
  childPublishSettings?: Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishSettings>;
  command?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  environmentVars: Array<Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_ContainerEnvVar>>;
  healthCheck: WorkspaceTemplatesV1_Org_Coursera_Workspace_HealthCheckConfig;
  hostSpecs: Array<Maybe<Scalars['String']>>;
  httpPort: Scalars['Int'];
  id: Scalars['String'];
  imageTag: Scalars['String'];
  launchContextMacros: Array<Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro>>;
  logType: WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType;
  name?: Maybe<Scalars['String']>;
  obj: Scalars['String'];
  publishMetadata?: Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_WorkspacePublishMetadata>;
  resourceLimits?: Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_ContainerResourceLimits>;
  scopes: Array<Maybe<Scalars['String']>>;
  sharedWorkspaces: Array<Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_SharedWorkspace>>;
  updatedAt?: Maybe<Scalars['Float']>;
  /** id for a Coursera user */
  updatedBy?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
  volumes: Scalars['JSON'];
};

export type WorkspaceTemplatesV1Connection = {
  __typename?: 'WorkspaceTemplatesV1Connection';
  elements: Array<Maybe<WorkspaceTemplatesV1>>;
  paging: ResponsePagination;
};

export type WorkspaceTemplatesV1CourseAndImage = {
  __typename?: 'WorkspaceTemplatesV1CourseAndImage';
  connection?: Maybe<WorkspaceTemplatesV1Connection>;
  courseId: Scalars['String'];
  imageTag: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type WorkspaceTemplatesV1Latest = {
  __typename?: 'WorkspaceTemplatesV1Latest';
  connection?: Maybe<WorkspaceTemplatesV1Connection>;
  id: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
};

export type WorkspaceTemplatesV1Resource = {
  __typename?: 'WorkspaceTemplatesV1Resource';
  courseAndImage?: Maybe<WorkspaceTemplatesV1Connection>;
  get?: Maybe<WorkspaceTemplatesV1>;
  latest?: Maybe<WorkspaceTemplatesV1Connection>;
};


export type WorkspaceTemplatesV1ResourceCourseAndImageArgs = {
  courseId: Scalars['String'];
  imageTag: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type WorkspaceTemplatesV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type WorkspaceTemplatesV1ResourceLatestArgs = {
  id: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};

export type WorkspaceTemplatesV1ResourceMutations = {
  __typename?: 'WorkspaceTemplatesV1ResourceMutations';
  batchCopyFromLaunchers?: Maybe<Scalars['JSON']>;
  batchShare?: Maybe<Scalars['JSON']>;
  update?: Maybe<WorkspaceTemplatesV1Connection>;
};


export type WorkspaceTemplatesV1ResourceMutationsUpdateArgs = {
  id: Scalars['String'];
};

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_HealthCheckConfig = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_HealthCheckConfig';
  path: Scalars['String'];
};

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_SharedWorkspace = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_SharedWorkspace';
  workspaceId: Scalars['String'];
};

/** Envrionment variables of container */
export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_ContainerEnvVar = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_container_ContainerEnvVar';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Details of these limits can be found at [[https://docs.docker.com/engine/admin/resource_constraints/#--kernel-memory-details]] */
export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_ContainerResourceLimits = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_container_ContainerResourceLimits';
  cpus: Scalars['Float'];
  disk?: Maybe<Scalars['Float']>;
  memory: Scalars['Float'];
};

/** Container log type. If set to AWS then container logs are sent to AWS cloudwatch. STD_OUT should be used as a default. */
export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType = {
  Aws: 'AWS',
  StdOut: 'STD_OUT'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Container_LogType];
export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = {
  AwsCloudLabStartUrl: 'AWS_CLOUD_LAB_START_URL',
  CourseBranchId: 'COURSE_BRANCH_ID',
  CourseHashedUserId: 'COURSE_HASHED_USER_ID',
  CourseId: 'COURSE_ID',
  CourseName: 'COURSE_NAME',
  CourseSessionDuration: 'COURSE_SESSION_DURATION',
  CourseSlug: 'COURSE_SLUG',
  Evg1Code: 'EVG1_CODE',
  GcloudKey: 'GCLOUD_KEY',
  GenAiModels: 'GEN_AI_MODELS',
  ImageApplicationType: 'IMAGE_APPLICATION_TYPE',
  InstructorName: 'INSTRUCTOR_NAME',
  InLabBrowserStartUrl: 'IN_LAB_BROWSER_START_URL',
  ItemDeadline: 'ITEM_DEADLINE',
  ItemDeadlines: 'ITEM_DEADLINES',
  ItemId: 'ITEM_ID',
  OpenaiApiKey: 'OPENAI_API_KEY',
  PartnerId: 'PARTNER_ID',
  SessionStartTime: 'SESSION_START_TIME',
  SubmissionToken: 'SUBMISSION_TOKEN',
  UniversityStudentId: 'UNIVERSITY_STUDENT_ID'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Launch_WorkspaceLaunchContextMacro];
export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishSettings = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_publish_PublishSettings';
  publishTypes: Array<Maybe<WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType>>;
};

export const WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType = {
  PublisherChoice: 'PUBLISHER_CHOICE',
  RoOnly: 'RO_ONLY'
} as const;

export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType = typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType[keyof typeof WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_PublishType];
export type WorkspaceTemplatesV1_Org_Coursera_Workspace_Publish_WorkspacePublishMetadata = {
  __typename?: 'WorkspaceTemplatesV1_org_coursera_workspace_publish_WorkspacePublishMetadata';
  isForced: Scalars['Boolean'];
  isNotifying: Scalars['Boolean'];
  publishSummary?: Maybe<Scalars['String']>;
};

/** xAPI integration queries. */
export type XapiIntegrationQueries = {
  __typename?: 'XapiIntegrationQueries';
  /**
   * Returns a pre-signed URL to download all xAPI statement audit records matching the filter
   * as a CSV file. organizationId is required. userId and courseId narrow the result to a specific
   * learner or learner+course combination. Time window defaults to the last 30 days.
   * courseId without userId is not supported. The returned URL is short-lived and intended for
   * one-time client download.
   */
  getAuditCsvDownload?: Maybe<XapiIntegration_AuditCsvDownload>;
  /**
   * Returns paginated xAPI statement audit records for an organization.
   * organizationId is required. userId and courseId narrow the result to a specific learner
   * or learner+course combination. Time window defaults to the last 30 days.
   * courseId without userId is not supported.
   */
  getAuditRecordsFilter?: Maybe<XapiIntegration_ListXapiStatementAuditResponse>;
  /**
   * Returns aggregate xAPI delivery stats for an organization over a time window.
   * organizationId is required. userId and courseId narrow the result to a specific learner
   * or learner+course combination. Time window defaults to the last 30 days.
   * courseId without userId is not supported.
   */
  getAuditStats?: Maybe<XapiIntegration_AuditStats>;
  /** This query gets existing xAPI integration. */
  getXapiIntegration?: Maybe<XapiIntegration_GetXapiIntegrationConfigurationResponse>;
};


/** xAPI integration queries. */
export type XapiIntegrationQueriesGetAuditCsvDownloadArgs = {
  input: XapiIntegration_ListXapiStatementAuditInput;
};


/** xAPI integration queries. */
export type XapiIntegrationQueriesGetAuditRecordsFilterArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  input: XapiIntegration_ListXapiStatementAuditInput;
  limit?: InputMaybe<Scalars['Int']>;
};


/** xAPI integration queries. */
export type XapiIntegrationQueriesGetAuditStatsArgs = {
  input: XapiIntegration_AuditStatsInput;
};


/** xAPI integration queries. */
export type XapiIntegrationQueriesGetXapiIntegrationArgs = {
  input?: InputMaybe<XapiIntegration_GetXapiIntegration>;
};

/** The type of content the xAPI statement describes. */
export const XapiIntegration_AuditContentScope = {
  /** Course-level content. */
  Course: 'COURSE',
  /** Item-level content. */
  Item: 'ITEM',
  /** Content scope could not be determined. */
  Unknown: 'UNKNOWN',
  /** Video-level content. */
  Video: 'VIDEO'
} as const;

export type XapiIntegration_AuditContentScope = typeof XapiIntegration_AuditContentScope[keyof typeof XapiIntegration_AuditContentScope];
/** Content scope bucket with its record count. */
export type XapiIntegration_AuditContentScopeCount = {
  __typename?: 'XapiIntegration_AuditContentScopeCount';
  /** The content scope. */
  contentScope: XapiIntegration_AuditContentScope;
  /** Number of records with this content scope. */
  count: Scalars['Int'];
};

/** Pre-signed CSV download for xAPI statement audit records matching a filter. */
export type XapiIntegration_AuditCsvDownload = {
  __typename?: 'XapiIntegration_AuditCsvDownload';
  /**
   * Short-lived URL that returns the audit records as a CSV file. May be an https:// pre-signed
   * URL or a self-contained data: URI; clients should treat it as opaque and not parse it.
   */
  downloadUrl: Scalars['String'];
  /** ISO-8601 timestamp at which the downloadUrl stops being usable. */
  expiresAt: Scalars['DateTime'];
  /** Number of audit records included in the CSV file. */
  rowCount: Scalars['Int'];
};

/** The reason a non-DELIVERED outcome occurred. */
export const XapiIntegration_AuditFailureReason = {
  /** Authentication with the external platform failed. */
  AuthenticationFailed: 'AUTHENTICATION_FAILED',
  /** The request was rejected by the external platform (4xx). */
  BadRequest: 'BAD_REQUEST',
  /** Integration credentials were missing. */
  CredentialsMissing: 'CREDENTIALS_MISSING',
  /** Delivery to the external platform failed (non-4xx error). */
  DeliveryFailed: 'DELIVERY_FAILED',
  /** No failure — statement was delivered successfully. */
  None: 'NONE',
  /** The organization has been rate limited. */
  RateLimited: 'RATE_LIMITED',
  /** The external platform was unavailable. */
  ServiceDown: 'SERVICE_DOWN',
  /** An unexpected error occurred. */
  Unhandled: 'UNHANDLED'
} as const;

export type XapiIntegration_AuditFailureReason = typeof XapiIntegration_AuditFailureReason[keyof typeof XapiIntegration_AuditFailureReason];
/** Failure reason bucket with its record count. */
export type XapiIntegration_AuditFailureReasonCount = {
  __typename?: 'XapiIntegration_AuditFailureReasonCount';
  /** Number of records that failed for this reason. */
  count: Scalars['Int'];
  /** The reason the failure occurred. */
  failureReason: XapiIntegration_AuditFailureReason;
};

/** Outcome type bucket with its record count. */
export type XapiIntegration_AuditOutcomeCount = {
  __typename?: 'XapiIntegration_AuditOutcomeCount';
  /** Number of records with this outcome type. */
  count: Scalars['Int'];
  /** The delivery outcome type. */
  outcomeType: XapiIntegration_AuditOutcomeType;
};

/** Outcome of an xAPI statement delivery attempt. */
export const XapiIntegration_AuditOutcomeType = {
  /** Statement delivery was deferred for retry. */
  Deferred: 'DEFERRED',
  /** Statement was successfully delivered to the external platform. */
  Delivered: 'DELIVERED',
  /** Statement delivery failed permanently. */
  Failed: 'FAILED',
  /** Statement was skipped (e.g. rate limited). */
  Skipped: 'SKIPPED'
} as const;

export type XapiIntegration_AuditOutcomeType = typeof XapiIntegration_AuditOutcomeType[keyof typeof XapiIntegration_AuditOutcomeType];
/** The source that triggered the xAPI statement delivery. */
export const XapiIntegration_AuditSourceType = {
  /** Statement originated from a dead-letter queue redrive. */
  DlqRedrive: 'DLQ_REDRIVE',
  /** Statement originated from a historical sync job. */
  HistoricalSync: 'HISTORICAL_SYNC',
  /** Statement originated from the real-time event queue. */
  RealTime: 'REAL_TIME'
} as const;

export type XapiIntegration_AuditSourceType = typeof XapiIntegration_AuditSourceType[keyof typeof XapiIntegration_AuditSourceType];
/** Stats computed across all records matching the filter. */
export type XapiIntegration_AuditStats = {
  __typename?: 'XapiIntegration_AuditStats';
  /** Count per contentScope. */
  contentScopeBreakdown: Array<XapiIntegration_AuditContentScopeCount>;
  /** Count per failureReason for non-DELIVERED records. */
  failureReasonBreakdown: Array<XapiIntegration_AuditFailureReasonCount>;
  /** Count per outcomeType. Only non-zero buckets are included. */
  outcomeBreakdown: Array<XapiIntegration_AuditOutcomeCount>;
  /** Total number of records matching the filter. */
  totalCount: Scalars['Int'];
  /**
   * Number of distinct users (Coursera userId) processed across all records matching the filter.
   * Records without a userId are not counted.
   */
  uniqueUserCount: Scalars['Int'];
};

/**
 * Filters for getAuditStats. organizationId is required.
 * Providing userId alone queries the GSI by user; providing both userId and courseId
 * narrows the GSI range key to that user+course combination.
 * courseId without userId is not supported.
 */
export type XapiIntegration_AuditStatsInput = {
  /** Coursera course id. Only meaningful when userId is also supplied. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Inclusive start of the stats window (ISO-8601). Defaults to 30 days before toCreatedAt. */
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The organization id to query. Required. */
  organizationId: Scalars['ID'];
  /** Inclusive end of the stats window (ISO-8601). Defaults to the current time. */
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Coursera user id. When provided, the GSI_ByUser index is used. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Input to create an xAPI integration. */
export type XapiIntegration_CreateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** String to specify external learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to create a xAPI integration. */
  organizationId: Scalars['ID'];
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Result of creating an xAPI integration configuration record */
export type XapiIntegration_CreateXapiIntegrationResult = {
  __typename?: 'XapiIntegration_CreateXapiIntegrationResult';
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: Maybe<XapiIntegration_XapiActorIdentificationType>;
  /** External learning platform. */
  externalLearningPlatform?: Maybe<XapiIntegration_ExternalLearningPlatform>;
  /** Status of the integration. */
  integrationStatus: XapiIntegration_XapiIntegrationStatus;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Maybe<Scalars['Boolean']>;
  /** Last time the xAPI integration was updated. */
  lastUpdatedTime: Timestamp;
  /** Id of an organization for which xAPI integration exists. */
  organizationId: Scalars['ID'];
};

/** Input to delete a xAPI integration. */
export type XapiIntegration_DeleteXapiIntegrationInput = {
  /** Id of an organization for which to delete xAPI integration. */
  organizationId: Scalars['ID'];
};

/** Result of deleting an xAPI integration configuration record */
export type XapiIntegration_DeleteXapiIntegrationResult = {
  __typename?: 'XapiIntegration_DeleteXapiIntegrationResult';
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: Maybe<XapiIntegration_XapiActorIdentificationType>;
  /** External learning platform. */
  externalLearningPlatform?: Maybe<XapiIntegration_ExternalLearningPlatform>;
  /** Status of the integration. */
  integrationStatus: XapiIntegration_XapiIntegrationStatus;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Maybe<Scalars['Boolean']>;
  /** Last time the xAPI integration was updated. */
  lastUpdatedTime: Timestamp;
  /** Id of an organization for which xAPI integration exists. */
  organizationId: Scalars['ID'];
};

/** External learning platform using this integration. */
export const XapiIntegration_ExternalLearningPlatform = {
  /** Degreed. */
  ExternalLearningPlatformDegreed: 'EXTERNAL_LEARNING_PLATFORM_DEGREED',
  /** Docebo. */
  ExternalLearningPlatformDocebo: 'EXTERNAL_LEARNING_PLATFORM_DOCEBO',
  /** EdCast. */
  ExternalLearningPlatformEdcast: 'EXTERNAL_LEARNING_PLATFORM_EDCAST',
  /** Execute Apps. A middleware for other bespoke LMS/LXPs we integrate with. */
  ExternalLearningPlatformExecuteApps: 'EXTERNAL_LEARNING_PLATFORM_EXECUTE_APPS',
  /** Invalid external learning platform. */
  ExternalLearningPlatformInvalid: 'EXTERNAL_LEARNING_PLATFORM_INVALID',
  /** Percipio. */
  ExternalLearningPlatformPercipio: 'EXTERNAL_LEARNING_PLATFORM_PERCIPIO',
  /** Standard. */
  ExternalLearningPlatformStandard: 'EXTERNAL_LEARNING_PLATFORM_STANDARD',
  /** Walmart. */
  ExternalLearningPlatformWalmart: 'EXTERNAL_LEARNING_PLATFORM_WALMART',
  /** Workday Cloud Connect for Learning. */
  ExternalLearningPlatformWorkday: 'EXTERNAL_LEARNING_PLATFORM_WORKDAY'
} as const;

export type XapiIntegration_ExternalLearningPlatform = typeof XapiIntegration_ExternalLearningPlatform[keyof typeof XapiIntegration_ExternalLearningPlatform];
/**
 * Filters for getAuditRecordsFilter. organizationId is required.
 * Providing userId alone queries the GSI by user; providing both userId and courseId
 * narrows the GSI range key to that user+course combination.
 * courseId without userId is not supported.
 */
export type XapiIntegration_ListXapiStatementAuditInput = {
  /** Coursera course id. Only meaningful when userId is also supplied. */
  courseId?: InputMaybe<Scalars['ID']>;
  /** Inclusive start of the audit window (ISO-8601). Defaults to 30 days before toCreatedAt. */
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** The organization id to query. Required. */
  organizationId: Scalars['ID'];
  /** Inclusive end of the audit window (ISO-8601). Defaults to the current time. */
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Coursera user id. When provided, the GSI_ByUser index is used. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Paginated audit list result. */
export type XapiIntegration_ListXapiStatementAuditResponse = {
  __typename?: 'XapiIntegration_ListXapiStatementAuditResponse';
  /** Audit rows for this page. */
  items: Array<XapiIntegration_StatementAuditRow>;
  /** Next page cursor, or null if this is the last page. */
  nextCursor?: Maybe<Scalars['String']>;
};

/** Input to permanently remove a xAPI integration record. */
export type XapiIntegration_RemoveXapiIntegrationInput = {
  /** Id of an organization for which to permanently remove the xAPI integration record. */
  organizationId: Scalars['ID'];
  /** External learning platform for which to permanently remove the xAPI integration record. */
  platformType: XapiIntegration_ExternalLearningPlatform;
};

/** Result of permanently removing an xAPI integration configuration record */
export type XapiIntegration_RemoveXapiIntegrationResult = {
  __typename?: 'XapiIntegration_RemoveXapiIntegrationResult';
  /** True if the xAPI integration record was successfully removed, false otherwise. */
  success: Scalars['Boolean'];
};

/** One persisted xAPI statement delivery audit row. */
export type XapiIntegration_StatementAuditRow = {
  __typename?: 'XapiIntegration_StatementAuditRow';
  /**
   * The identifier transmitted as the xAPI actor — actor.mbox (with any "mailto:" prefix stripped)
   * for MBOX-type integrations, or actor.account.name for ACCOUNT-type integrations. Null for
   * historical rows written before this attribute was populated.
   */
  actorId?: Maybe<Scalars['ID']>;
  /** Unique identifier for this audit record. */
  auditId: Scalars['ID'];
  /** The type of content the statement describes. */
  contentScope?: Maybe<XapiIntegration_AuditContentScope>;
  /** Coursera course id, if available. */
  courseId?: Maybe<Scalars['ID']>;
  /** ISO-8601 timestamp when this record was created. */
  createdAt: Scalars['DateTime'];
  /** Error type classification, if available. */
  errorType?: Maybe<Scalars['String']>;
  /** The external learning platform this statement was sent to. */
  externalLearningPlatform?: Maybe<XapiIntegration_ExternalLearningPlatform>;
  /** The reason a non-DELIVERED outcome occurred. */
  failureReason: XapiIntegration_AuditFailureReason;
  /** HTTP status code returned by the external platform, if available. */
  httpStatusCode?: Maybe<Scalars['Int']>;
  /** Coursera item id, if available. */
  itemId?: Maybe<Scalars['ID']>;
  /** Human-readable error or status message, if available. */
  message?: Maybe<Scalars['String']>;
  /** The organization that owns this audit record. */
  organizationId: Scalars['ID'];
  /** The delivery outcome for this statement. */
  outcomeType: XapiIntegration_AuditOutcomeType;
  /** Coursera program id, if available. */
  programId?: Maybe<Scalars['ID']>;
  /** The source that triggered this delivery attempt. */
  sourceType: XapiIntegration_AuditSourceType;
  /** The xAPI statement id, if available. */
  statementId?: Maybe<Scalars['ID']>;
  /** Coursera user id of the learner, if available. */
  userId?: Maybe<Scalars['ID']>;
  /** The xAPI verb id used in the statement. */
  verbId?: Maybe<Scalars['ID']>;
};

/** Input for triggering the xAPI Tracking Enrollment Sync job for a single organization. */
export type XapiIntegration_TriggerEnrollmentSyncJobInput = {
  /** When true, include deleted users in the sync. Defaults to false. */
  includeDeletedUsers?: InputMaybe<Scalars['Boolean']>;
  /** When true, run the sync without making external mutations. */
  isDryRun: Scalars['Boolean'];
  /** Organization id to process. */
  organizationId: Scalars['ID'];
  /**
   * Override end of the event time range. Must be supplied together with overrideEventStartTime,
   * or both omitted to fall back to the job's default range.
   */
  overrideEventEndTime?: InputMaybe<Scalars['DateTime']>;
  /**
   * Override start of the event time range. Must be supplied together with overrideEventEndTime,
   * or both omitted to fall back to the job's default range.
   */
  overrideEventStartTime?: InputMaybe<Scalars['DateTime']>;
};

/** Result of triggering the xAPI Tracking Enrollment Sync job. */
export type XapiIntegration_TriggerEnrollmentSyncJobResult = {
  __typename?: 'XapiIntegration_TriggerEnrollmentSyncJobResult';
  /** True if the job was successfully submitted to the job runner. */
  success: Scalars['Boolean'];
};

/** Input to update an xAPI integration. */
export type XapiIntegration_UpdateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** External learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to update a xAPI integration. */
  organizationId: Scalars['ID'];
  /**
   * String to specify tenant (user/customer) alias/name.
   * @deprecated No need for tenant alias.
   */
  tenantAlias?: InputMaybe<Scalars['String']>;
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Result of updating an xAPI integration configuration record */
export type XapiIntegration_UpdateXapiIntegrationResult = {
  __typename?: 'XapiIntegration_UpdateXapiIntegrationResult';
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: Maybe<XapiIntegration_XapiActorIdentificationType>;
  /** External learning platform. */
  externalLearningPlatform?: Maybe<XapiIntegration_ExternalLearningPlatform>;
  /** Status of the integration. */
  integrationStatus: XapiIntegration_XapiIntegrationStatus;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Maybe<Scalars['Boolean']>;
  /** Last time the xAPI integration was updated. */
  lastUpdatedTime: Timestamp;
  /** Id of an organization for which xAPI integration exists. */
  organizationId: Scalars['ID'];
};

/** Input to validate an xAPI integration. */
export type XapiIntegration_ValidateXapiIntegrationInput = {
  /** Value to specify how the organization wants xAPI actors to be formatted. */
  agentActorIdentificationType?: InputMaybe<XapiIntegration_XapiActorIdentificationType>;
  /** String to specify a client id. */
  clientId: Scalars['String'];
  /** String to specify a private key (client secret) reserved for client. */
  clientSecret: Scalars['String'];
  /** Value to specify external learning platform. */
  externalLearningPlatform?: InputMaybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Scalars['Boolean'];
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Scalars['Boolean'];
  /** String to specify authorization url. */
  openAuthorizationUrl: Scalars['URL'];
  /** The id of an organization for which to validate a xAPI integration. */
  organizationId: Scalars['ID'];
  /** String to specify tenant (user/customer) url. */
  tenantUrl: Scalars['URL'];
};

/** Result of validating an xAPI integration configuration record */
export type XapiIntegration_ValidateXapiIntegrationResult = {
  __typename?: 'XapiIntegration_ValidateXapiIntegrationResult';
  /** Validation Message String for passing the reason for validation failure */
  validationMessage: Scalars['String'];
  /** Value to represent the validation request passed/failed */
  validationStatus: XapiIntegration_ValidationStatus;
};

/** Different status of validate xAPI Integration */
export const XapiIntegration_ValidationStatus = {
  /** Client Credentials are incorrect, validation failed */
  ValidationFailed: 'VALIDATION_FAILED',
  /** Client Credentials successfully validated */
  ValidationPassed: 'VALIDATION_PASSED'
} as const;

export type XapiIntegration_ValidationStatus = typeof XapiIntegration_ValidationStatus[keyof typeof XapiIntegration_ValidationStatus];
/** Enumeration type representing which method to use to identify xAPI actors */
export const XapiIntegration_XapiActorIdentificationType = {
  /** Method of composing xAPI actor using an enterprise user's configured external id. */
  XapiActorIdentificationTypeAccount: 'XAPI_ACTOR_IDENTIFICATION_TYPE_ACCOUNT',
  /** Invalid value. */
  XapiActorIdentificationTypeInvalid: 'XAPI_ACTOR_IDENTIFICATION_TYPE_INVALID',
  /** Method of composing xAPI actor using email address in a mailto: format. */
  XapiActorIdentificationTypeMbox: 'XAPI_ACTOR_IDENTIFICATION_TYPE_MBOX'
} as const;

export type XapiIntegration_XapiActorIdentificationType = typeof XapiIntegration_XapiActorIdentificationType[keyof typeof XapiIntegration_XapiActorIdentificationType];
/** Input to get a xAPI integration. */
export type XapiIntegration_GetXapiIntegration = {
  /** The id of an organization for which to get a xAPI integration. */
  organizationId: Scalars['ID'];
};

/** Response object for getting an xAPI integration. */
export type XapiIntegration_GetXapiIntegrationConfigurationResponse = {
  __typename?: 'XapiIntegration_getXapiIntegrationConfigurationResponse';
  /** Client credential data for which xAPI integration exists or is not disabled. */
  xapiIntegrationClientCredentials?: Maybe<XapiIntegration_XapiIntegrationClientCredentials>;
  /** Configuration data for which xAPI integration exists. */
  xapiIntegrationConfiguration: XapiIntegration_XapiIntegrationConfiguration;
};

/** Client credential data of a particular xAPI integration. */
export type XapiIntegration_XapiIntegrationClientCredentials = {
  __typename?: 'XapiIntegration_xapiIntegrationClientCredentials';
  /** Client id of an organization for which xAPI integration is enabled. */
  clientId: Scalars['String'];
  /** Client secret of an organization for which xAPI integration is enabled. */
  clientSecret: Scalars['String'];
  /** External learning platform. */
  externalLearningPlatform?: Maybe<XapiIntegration_ExternalLearningPlatform>;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Maybe<Scalars['Boolean']>;
  /** Open authorizationi url of an organization for which xAPI integration is enabled. */
  openAuthorizationUrl: Scalars['String'];
  /** Id of an organization for which xAPI integration is enabled. */
  organizationId: Scalars['String'];
  /** Tenant url of an organization for which xAPI integration is enabled. */
  tenantUrl: Scalars['String'];
};

/** Configuration data of a particular xAPI integration. */
export type XapiIntegration_XapiIntegrationConfiguration = {
  __typename?: 'XapiIntegration_xapiIntegrationConfiguration';
  /** Configuration for how to format xAPI (agent) actors. See more @ https://xapi.com/blog/deep-dive-actor-agent/. */
  agentActorIdentificationType?: Maybe<XapiIntegration_XapiActorIdentificationType>;
  /** Status of the integration. */
  integrationStatus: XapiIntegration_XapiIntegrationStatus;
  /** Boolean value to enable item-level updates in xAPI */
  isItemUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Boolean flag enabling non-graded items in xAPI Statement */
  isNonGradedItemEnabled?: Maybe<Scalars['Boolean']>;
  /** Last time the xAPI integration was updated. */
  lastUpdatedTime: Timestamp;
  /** Id of an organization for which xAPI integration exists. */
  organizationId: Scalars['String'];
};

/** Current status of xAPI integration. */
export const XapiIntegration_XapiIntegrationStatus = {
  /** Disabled integration status. */
  XapiIntegrationStatusDisabled: 'XAPI_INTEGRATION_STATUS_DISABLED',
  /** Enabled integration status. */
  XapiIntegrationStatusEnabled: 'XAPI_INTEGRATION_STATUS_ENABLED',
  /** Invalid integration status. */
  XapiIntegrationStatusInvalid: 'XAPI_INTEGRATION_STATUS_INVALID'
} as const;

export type XapiIntegration_XapiIntegrationStatus = typeof XapiIntegration_XapiIntegrationStatus[keyof typeof XapiIntegration_XapiIntegrationStatus];
export type XdpV1 = {
  __typename?: 'XdpV1';
  fetchProductOverview?: Maybe<ProductReviewOverviewV1Connection>;
  fetchProductReviews?: Maybe<ProductReviewsV1Connection>;
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  processedAt?: Maybe<Scalars['Float']>;
  productId: Scalars['String'];
  productType: XdpV1_Org_Coursera_Catalogp_Browse_ProductType;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  xdpMetadata: XdpV1_XdpMetadata;
};


export type XdpV1FetchProductOverviewArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productCompleted?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};


export type XdpV1FetchProductReviewsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productCompleted?: InputMaybe<Scalars['Boolean']>;
  ratingValues?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sortByHelpfulVotes?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
};

export type XdpV1Connection = {
  __typename?: 'XdpV1Connection';
  elements: Array<Maybe<XdpV1>>;
  paging: ResponsePagination;
};

export type XdpV1Resource = {
  __typename?: 'XdpV1Resource';
  get?: Maybe<XdpV1>;
  getAll?: Maybe<XdpV1Connection>;
  multiGet?: Maybe<XdpV1Connection>;
  slug?: Maybe<XdpV1Connection>;
};


export type XdpV1ResourceGetArgs = {
  id: Scalars['String'];
};


export type XdpV1ResourceGetAllArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productType?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type XdpV1ResourceMultiGetArgs = {
  ids: Array<InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['String']>;
};


export type XdpV1ResourceSlugArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  productType: Scalars['String'];
  slug: Scalars['String'];
  start?: InputMaybe<Scalars['String']>;
};

export type XdpV1Slug = {
  __typename?: 'XdpV1Slug';
  connection?: Maybe<XdpV1Connection>;
  limit?: Maybe<Scalars['Int']>;
  productType: Scalars['String'];
  slug: Scalars['String'];
  start?: Maybe<Scalars['String']>;
};

export type XdpV1_Answer = DummyType | XdpV1_CmlMember;

export type XdpV1_CdpMetadataMember = {
  __typename?: 'XdpV1_cdpMetadataMember';
  /** Derived from [[org.coursera.course.Course]] courier model */
  cdpMetadata: XdpV1_Org_Coursera_Xdp_Cdp_CdpMetadata;
};

export type XdpV1_CmlMember = {
  __typename?: 'XdpV1_cmlMember';
  cml: XdpV1_Org_Coursera_Ondemand_Models_CmlContentType;
};

export type XdpV1_CmlRecommendedBackground = DummyType | XdpV1_CmlMember;

/** Marker for identifying what "type" of course a specific course shell is supposed to represent. Used for tailoring the learner and partner experience for each course type and for streamlined data reporting. This is modeled as a union rather than an enumeration to allow us to add course-type specific fields to these models, avoiding the possibility of invalid enumeration + field combinations. Type names should be kept in sync with the [[CourseType]] enum. */
export type XdpV1_CourseTypeMetadata = XdpV1_ProjectMember | XdpV1_RhymeProjectMember | XdpV1_ShortFormContentMember | XdpV1_StandardCourseMember;

export type XdpV1_Description = DummyType | XdpV1_CmlMember;

/** Representation of a color. */
export type XdpV1_HeaderBackgroundColor = XdpV1_LinearGradient2Member | XdpV1_RgbaColorMember;

export type XdpV1_LinearGradient2Member = {
  __typename?: 'XdpV1_linearGradient2Member';
  linearGradient2: XdpV1_Org_Coursera_Common_Ui_LinearGradient2;
};

export type XdpV1_Org_Coursera_Authoring_S12n_AuthoringS12nSponsor = {
  __typename?: 'XdpV1_org_coursera_authoring_s12n_AuthoringS12nSponsor';
  logo: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Catalog_PartnerLinks = {
  __typename?: 'XdpV1_org_coursera_catalog_PartnerLinks';
  facebook?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Catalog_PartnerLocation = {
  __typename?: 'XdpV1_org_coursera_catalog_PartnerLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Catalogp_InstructorWebsites = {
  __typename?: 'XdpV1_org_coursera_catalogp_InstructorWebsites';
  website?: Maybe<Scalars['String']>;
  websiteFacebook?: Maybe<Scalars['String']>;
  websiteGplus?: Maybe<Scalars['String']>;
  websiteLinkedin?: Maybe<Scalars['String']>;
  websiteTwitter?: Maybe<Scalars['String']>;
};

/** The product type of the document in the solr index NOTE: There are 2 other `ProductType` Courier models, they may evolve independently from this. */
export const XdpV1_Org_Coursera_Catalogp_Browse_ProductType = {
  Course: 'COURSE',
  Degree: 'DEGREE',
  Specialization: 'SPECIALIZATION'
} as const;

export type XdpV1_Org_Coursera_Catalogp_Browse_ProductType = typeof XdpV1_Org_Coursera_Catalogp_Browse_ProductType[keyof typeof XdpV1_Org_Coursera_Catalogp_Browse_ProductType];
/** Status of whether a degree/mastertrack (which are intended to be marketed to the public) is publicly available. */
export const XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = {
  Archived: 'ARCHIVED',
  Live: 'LIVE',
  PreLaunch: 'PRE_LAUNCH'
} as const;

export type XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus = typeof XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus[keyof typeof XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus];
/** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. Note that a [[CatalogDegree]], different from a [[org.coursera.degree.stored.api.Degree]], is STRICTLY A DEGREE. For Mastertracks, see [[CatalogMastertrack]]. */
export type XdpV1_Org_Coursera_Catalogp_Degree_CatalogDegree = {
  __typename?: 'XdpV1_org_coursera_catalogp_degree_CatalogDegree';
  bannerImage?: Maybe<Scalars['String']>;
  blockedCountries?: Maybe<Array<Maybe<Scalars['String']>>>;
  catalogAvailabilityStatus: XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus;
  degreeCategoryIds: Array<Maybe<Scalars['String']>>;
  degreeUpcomingTermDates?: Maybe<XdpV1_Org_Coursera_Degreemarketing_Dates_DegreeUpcomingTermDates>;
  domainIds: Array<Maybe<Scalars['String']>>;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  languageCode: Scalars['String'];
  launchDate?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  marketingName: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  productVariant: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  shortName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  upsellCourseIds: Array<Maybe<Scalars['String']>>;
  upsellS12nIds: Array<Maybe<Scalars['String']>>;
};

/** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. */
export type XdpV1_Org_Coursera_Catalogp_Degree_CatalogMastertrack = {
  __typename?: 'XdpV1_org_coursera_catalogp_degree_CatalogMastertrack';
  bannerImage?: Maybe<Scalars['String']>;
  catalogAvailabilityStatus: XdpV1_Org_Coursera_Catalogp_Degree_CatalogAvailabilityStatus;
  domainIds: Array<Maybe<Scalars['String']>>;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  languageCode: Scalars['String'];
  launchDate?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  productVariant: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  shortName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
  upsellCourseIds: Array<Maybe<Scalars['String']>>;
};

/** Additional data for assets. Currently, used to attach subtitles to video assets. Format: <pre> "metadata": {   "assetData": [     {       "id": "videoAssetId1",       "subtitles": [         {           "languageCode": "es",           "url": "https://example.com/en.vtt",         },         {            "languageCode: "es",            "url": "https://example.com/es.vtt"         }       ],     }   } } </pre> */
export type XdpV1_Org_Coursera_Cml_AssetData = {
  __typename?: 'XdpV1_org_coursera_cml_AssetData';
  assetId: Scalars['String'];
  subtitles: Array<Maybe<XdpV1_Org_Coursera_Cml_SubtitleTrack>>;
};

export type XdpV1_Org_Coursera_Cml_RenderableHtmlMetadata = {
  __typename?: 'XdpV1_org_coursera_cml_RenderableHtmlMetadata';
  assetData?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Cml_AssetData>>>;
  hasAssetBlock: Scalars['Boolean'];
  hasCodeBlock: Scalars['Boolean'];
  hasMath: Scalars['Boolean'];
  isPlainText: Scalars['Boolean'];
};

export type XdpV1_Org_Coursera_Cml_RenderableHtmlWithMetadata = {
  __typename?: 'XdpV1_org_coursera_cml_RenderableHtmlWithMetadata';
  metadata: XdpV1_Org_Coursera_Cml_RenderableHtmlMetadata;
  renderableHtml: Scalars['String'];
};

/** Represent subtitle tracks. Format: <pre>   {     "languageCode: "es",     "url": "https://example.com/es.vtt"   } </pre> */
export type XdpV1_Org_Coursera_Cml_SubtitleTrack = {
  __typename?: 'XdpV1_org_coursera_cml_SubtitleTrack';
  languageCode: Scalars['String'];
  url: Scalars['String'];
};

/** Represents gradient transition between two colors. */
export type XdpV1_Org_Coursera_Common_Ui_LinearGradient2 = {
  __typename?: 'XdpV1_org_coursera_common_ui_LinearGradient2';
  color1: XdpV1_Org_Coursera_Common_Ui_RgbaColor;
  color2: XdpV1_Org_Coursera_Common_Ui_RgbaColor;
};

/** Color as defined with red, green, blue hues and alpha. @note: Opting to store as rgba instead of hex because hex is a lossy conversion and does not preserve alpha channel */
export type XdpV1_Org_Coursera_Common_Ui_RgbaColor = {
  __typename?: 'XdpV1_org_coursera_common_ui_RGBAColor';
  alpha: Scalars['Float'];
  blue: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
};

export const XdpV1_Org_Coursera_Course_CertificateType = {
  Ace: 'ACE',
  SoA: 'SoA',
  Specialization: 'Specialization',
  VerifiedCert: 'VerifiedCert'
} as const;

export type XdpV1_Org_Coursera_Course_CertificateType = typeof XdpV1_Org_Coursera_Course_CertificateType[keyof typeof XdpV1_Org_Coursera_Course_CertificateType];
export const XdpV1_Org_Coursera_Course_CourseMode = {
  Ondemand: 'ONDEMAND',
  Session: 'SESSION'
} as const;

export type XdpV1_Org_Coursera_Course_CourseMode = typeof XdpV1_Org_Coursera_Course_CourseMode[keyof typeof XdpV1_Org_Coursera_Course_CourseMode];
export const XdpV1_Org_Coursera_Course_CourseStatus = {
  Draft: 'draft',
  Inactive: 'inactive',
  Launched: 'launched',
  Preenroll: 'preenroll'
} as const;

export type XdpV1_Org_Coursera_Course_CourseStatus = typeof XdpV1_Org_Coursera_Course_CourseStatus[keyof typeof XdpV1_Org_Coursera_Course_CourseStatus];
/** Different product variants that are currently supported. */
export const XdpV1_Org_Coursera_Course_PremiumExperienceVariant = {
  BaseVariant: 'BaseVariant',
  PremiumCourse: 'PremiumCourse',
  PremiumGrading: 'PremiumGrading'
} as const;

export type XdpV1_Org_Coursera_Course_PremiumExperienceVariant = typeof XdpV1_Org_Coursera_Course_PremiumExperienceVariant[keyof typeof XdpV1_Org_Coursera_Course_PremiumExperienceVariant];
/** Type of launch this degree was intended to launch as e.g. TEST or REAL. */
export const XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType = typeof XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType];
export const XdpV1_Org_Coursera_Degree_Stored_SlackPlanType = {
  Free: 'FREE',
  Plus: 'PLUS',
  Standard: 'STANDARD'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_SlackPlanType = typeof XdpV1_Org_Coursera_Degree_Stored_SlackPlanType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_SlackPlanType];
export type XdpV1_Org_Coursera_Degree_Stored_SlackSettings = {
  __typename?: 'XdpV1_org_coursera_degree_stored_SlackSettings';
  slackPlanType: XdpV1_Org_Coursera_Degree_Stored_SlackPlanType;
  slackTeamDomain: Scalars['String'];
  slackTeamId: Scalars['String'];
};

export type XdpV1_Org_Coursera_Degree_Stored_Api_Degree = {
  __typename?: 'XdpV1_org_coursera_degree_stored_api_Degree';
  courseIds: Array<Maybe<Scalars['String']>>;
  degreeCategoryIds: Array<Maybe<Scalars['String']>>;
  description: XdpV1_Description;
  headerBackgroundColor: XdpV1_HeaderBackgroundColor;
  headerImage?: Maybe<Scalars['String']>;
  internalLaunchType: XdpV1_Org_Coursera_Degree_Stored_InternalLaunchType;
  /** Language code that Coursera uses (two or three letters ISO 639 language code with optional two capital letters for country code) */
  locale?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['Int']>>;
  productVariant: Scalars['String'];
  s12nIds: Array<Maybe<Scalars['String']>>;
  shortName?: Maybe<Scalars['String']>;
  slackSettings?: Maybe<XdpV1_Org_Coursera_Degree_Stored_SlackSettings>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  supportEmailAddress: Scalars['String'];
  supportLink?: Maybe<Scalars['String']>;
};

/** Type of upsell */
export const XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType = {
  OffersCredit: 'OFFERS_CREDIT',
  PartOf: 'PART_OF',
  RelatedTo: 'RELATED_TO',
  SuppressUpsell: 'SUPPRESS_UPSELL'
} as const;

export type XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType = typeof XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType[keyof typeof XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType];
/** Includes different types of dates of a degree program. */
export type XdpV1_Org_Coursera_Degreemarketing_Dates_DegreeUpcomingTermDates = {
  __typename?: 'XdpV1_org_coursera_degreemarketing_dates_DegreeUpcomingTermDates';
  nextAcademicTermStartDate?: Maybe<Scalars['Float']>;
  nextAdmissionDeadlineDate?: Maybe<Scalars['Float']>;
  nextAdmissionStartDate?: Maybe<Scalars['Float']>;
  nextAdmissionSubtermDeadlineDate?: Maybe<Scalars['Float']>;
};

export const XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel = {
  Advanced: 'ADVANCED',
  Beginner: 'BEGINNER',
  Intermediate: 'INTERMEDIATE',
  Mixed: 'MIXED'
} as const;

export type XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel = typeof XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel[keyof typeof XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel];
export type XdpV1_Org_Coursera_Ondemand_Course_Types_ProjectMetadata = {
  __typename?: 'XdpV1_org_coursera_ondemand_course_types_ProjectMetadata';
  screenshotUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  tasks?: Maybe<Array<Maybe<XdpV1_CmlMember>>>;
  typeNameIndex: Scalars['String'];
};

export type XdpV1_Org_Coursera_Ondemand_Course_Types_RhymeProjectMetadata = {
  __typename?: 'XdpV1_org_coursera_ondemand_course_types_RhymeProjectMetadata';
  screenshotUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  tasks?: Maybe<Array<Maybe<XdpV1_CmlMember>>>;
  typeNameIndex: Scalars['String'];
};

export type XdpV1_Org_Coursera_Ondemand_Course_Types_ShortFormContentMetadata = {
  __typename?: 'XdpV1_org_coursera_ondemand_course_types_ShortFormContentMetadata';
  typeNameIndex: Scalars['String'];
};

export type XdpV1_Org_Coursera_Ondemand_Course_Types_StandardCourseMetadata = {
  __typename?: 'XdpV1_org_coursera_ondemand_course_types_StandardCourseMetadata';
  typeNameIndex: Scalars['String'];
};

/** the pegasus schema for org.coursera.ondemand.content.CmlContent. See https://phabricator.dkandu.me/D22517 */
export type XdpV1_Org_Coursera_Ondemand_Models_CmlContentType = {
  __typename?: 'XdpV1_org_coursera_ondemand_models_CmlContentType';
  dtdId: Scalars['String'];
  renderableHtmlWithMetadata?: Maybe<XdpV1_Org_Coursera_Cml_RenderableHtmlWithMetadata>;
  /** Typeref for string that defines the isTranslatable property to true */
  value: Scalars['String'];
};

/** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentive = {
  __typename?: 'XdpV1_org_coursera_partnerincentives_PartnerIncentive';
  eligibleProductIds: Array<Maybe<Scalars['String']>>;
  fetchType: XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType;
  /** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
  id: Scalars['Float'];
  partnerId: Scalars['Int'];
  status: XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus;
  type: XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType;
};

/** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus = {
  Active: 'ACTIVE',
  NonActive: 'NON_ACTIVE',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveStatus];
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType = {
  ExternalPartnerVoucher: 'EXTERNAL_PARTNER_VOUCHER'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveType];
/** This s the scala equivalent of the GRPC protobuf model. Refer to https://github.com/webedx-spark/service-definitions/tree/main/coursera/proto/partnerincentives/v1beta1 */
export const XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType = {
  Adobe: 'ADOBE',
  Facebook: 'FACEBOOK',
  InternalPromotion: 'INTERNAL_PROMOTION',
  Stored: 'STORED'
} as const;

export type XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType = typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType[keyof typeof XdpV1_Org_Coursera_Partnerincentives_PartnerIncentiveVoucherFetchType];
export type XdpV1_Org_Coursera_S12n_Capstone = {
  __typename?: 'XdpV1_org_coursera_s12n_Capstone';
  courseIds: Array<Maybe<Scalars['String']>>;
};

export const XdpV1_Org_Coursera_S12n_S12nInternalType = {
  Real: 'REAL',
  Test: 'TEST'
} as const;

export type XdpV1_Org_Coursera_S12n_S12nInternalType = typeof XdpV1_Org_Coursera_S12n_S12nInternalType[keyof typeof XdpV1_Org_Coursera_S12n_S12nInternalType];
/** Captures learner facing skill tags. */
export type XdpV1_Org_Coursera_Skill_Api_Skill = {
  __typename?: 'XdpV1_org_coursera_skill_api_Skill';
  aliases: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
};

/** Derived from [[org.coursera.course.Course]] courier model */
export type XdpV1_Org_Coursera_Xdp_Cdp_CdpMetadata = {
  __typename?: 'XdpV1_org_coursera_xdp_cdp_CDPMetadata';
  averageContentSatisfactionScore?: Maybe<Scalars['Float']>;
  averageInstructorRating?: Maybe<Scalars['Float']>;
  avgLearningHoursAdjusted?: Maybe<Scalars['Float']>;
  avgLearningHoursPerWeek?: Maybe<Scalars['Float']>;
  badges?: Maybe<Array<Maybe<Scalars['String']>>>;
  categories: Array<Maybe<Scalars['String']>>;
  certificates: Array<Maybe<XdpV1_Org_Coursera_Course_CertificateType>>;
  cmlFaqs: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_Xdpfaq>>;
  cmlLearningObjectives: Array<Maybe<XdpV1_CmlMember>>;
  cmlRecommendedBackground?: Maybe<XdpV1_CmlRecommendedBackground>;
  contentSatisfactionRatingsCount?: Maybe<Scalars['Float']>;
  courseMode: XdpV1_Org_Coursera_Course_CourseMode;
  courseStatus?: Maybe<XdpV1_Org_Coursera_Course_CourseStatus>;
  /** Course type. Valid values include v1.session, v1.capstone, v2.ondemand, and v2.capstone */
  courseType: Scalars['String'];
  courseTypeMetadata?: Maybe<XdpV1_CourseTypeMetadata>;
  degrees: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpDegree>>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  display: Scalars['Boolean'];
  domains: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpDomain>>;
  htmlFAQs: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpHtmlFaq>>;
  htmlLearningObjectives: Array<Maybe<Scalars['String']>>;
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  htmlRecommendedBackground?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  instructorRatingCount?: Maybe<Scalars['Float']>;
  instructors: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_InstructorWithId>>;
  learnerStoriesCount?: Maybe<Scalars['Float']>;
  learningObjectives?: Maybe<Array<Maybe<Scalars['String']>>>;
  learningOutcomes?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpLearningOutcomes>;
  level?: Maybe<XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel>;
  /** Note: these models intentionally do not use translatable strings as the cost of translating all course materials may be prohibitive. */
  material?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpCourseMaterial>;
  mostRecentLearnerStory?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  organizationId: Scalars['Int'];
  pageViewsInLastMonthCount?: Maybe<Scalars['Float']>;
  partnerIds: Array<Maybe<Scalars['Int']>>;
  partnerIncentives?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Partnerincentives_PartnerIncentive>>>;
  partners: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_PartnerWithId>>;
  photoUrl?: Maybe<Scalars['String']>;
  premiumExperienceVariant?: Maybe<XdpV1_Org_Coursera_Course_PremiumExperienceVariant>;
  primaryLanguages: Array<Maybe<Scalars['String']>>;
  primaryS12n?: Maybe<XdpV1_Org_Coursera_Xdp_Cdp_Cdps12n>;
  primaryS12nId?: Maybe<Scalars['String']>;
  ratings?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpRatings>;
  recommendedBackground?: Maybe<Array<Maybe<Scalars['String']>>>;
  reviewHighlights?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewHighlights>>>;
  s12nIds: Array<Maybe<Scalars['String']>>;
  s12ns: Array<Maybe<XdpV1_Org_Coursera_Xdp_Cdp_Cdps12n>>;
  skills: Array<Maybe<Scalars['String']>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  subtitleLanguages: Array<Maybe<Scalars['String']>>;
  testimonials?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewTestimonial>>>;
  topFourAndFiveStarReviews?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReview>>>;
  topReviews?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReview>>>;
  totalContentHours?: Maybe<Scalars['Float']>;
  totalContentWeeks?: Maybe<Scalars['Float']>;
  totalEnrollmentCount?: Maybe<Scalars['Float']>;
  workload?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Cdp_CdpNestedCourse = {
  __typename?: 'XdpV1_org_coursera_xdp_cdp_CDPNestedCourse';
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
};

export type XdpV1_Org_Coursera_Xdp_Cdp_Cdps12n = {
  __typename?: 'XdpV1_org_coursera_xdp_cdp_CDPS12n';
  badges: Array<Maybe<Scalars['String']>>;
  coBrandingEnabled: Scalars['Boolean'];
  companyLogos: Array<Maybe<Scalars['String']>>;
  courseCount: Scalars['Int'];
  courses: Array<Maybe<XdpV1_Org_Coursera_Xdp_Cdp_CdpNestedCourse>>;
  /** Typeref for string that defines the isTranslatable property to true */
  description: Scalars['String'];
  domains?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpDomain>>>;
  /** Typeref for string that defines the isTranslatable property to true */
  headline?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCertificate: Scalars['Boolean'];
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  partners: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_PartnerWithId>>;
  productVariant: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug: Scalars['String'];
  sponsors?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Authoring_S12n_AuthoringS12nSponsor>>>;
  /** Typeref for string that defines the isTranslatable property to true */
  subheader?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  tagline: Scalars['String'];
};

export type XdpV1_Org_Coursera_Xdp_Common_InstructorWithId = {
  __typename?: 'XdpV1_org_coursera_xdp_common_InstructorWithId';
  bio: Scalars['String'];
  courseIds: Array<Maybe<Scalars['String']>>;
  coursesTaught?: Maybe<Scalars['Float']>;
  department?: Maybe<Scalars['String']>;
  displayOnPartnerPage: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isTopInstructor?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  learnersReached?: Maybe<Scalars['Float']>;
  middleName?: Maybe<Scalars['String']>;
  nameTitleDepartmentUniversity: Scalars['String'];
  partnerIds: Array<Maybe<Scalars['String']>>;
  photo?: Maybe<Scalars['String']>;
  prefixName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  signature?: Maybe<Scalars['String']>;
  suffixName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  websites?: Maybe<XdpV1_Org_Coursera_Catalogp_InstructorWebsites>;
};

export type XdpV1_Org_Coursera_Xdp_Common_PartnerWithId = {
  __typename?: 'XdpV1_org_coursera_xdp_common_PartnerWithId';
  abbrName: Scalars['String'];
  accentColor?: Maybe<Scalars['String']>;
  banner?: Maybe<Scalars['String']>;
  classLogo?: Maybe<Scalars['String']>;
  courseIds: Array<Maybe<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
  display: Scalars['Boolean'];
  homeLink?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instructorIds: Array<Maybe<Scalars['String']>>;
  landingPageBanner?: Maybe<Scalars['String']>;
  links?: Maybe<XdpV1_Org_Coursera_Catalog_PartnerLinks>;
  location?: Maybe<XdpV1_Org_Coursera_Catalog_PartnerLocation>;
  logo?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  partnerMarketingBlurb?: Maybe<Scalars['String']>;
  partnerType: Scalars['Int'];
  primaryColor?: Maybe<Scalars['String']>;
  productBrandingLogo?: Maybe<Scalars['String']>;
  rectangularLogo?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  shortName: Scalars['String'];
  squareLogo?: Maybe<Scalars['String']>;
};

/** Note: these models intentionally do not use translatable strings as the cost of translating all course materials may be prohibitive. */
export type XdpV1_Org_Coursera_Xdp_Common_XdpCourseMaterial = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPCourseMaterial';
  totalDuration?: Maybe<Scalars['Float']>;
  totalLectureDuration?: Maybe<Scalars['Float']>;
  totalQuizzes?: Maybe<Scalars['Int']>;
  totalReadings?: Maybe<Scalars['Int']>;
  totalVideos?: Maybe<Scalars['Int']>;
  weeks: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpCourseWeek>>;
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpCourseModule = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPCourseModule';
  description?: Maybe<Scalars['String']>;
  /** ID of a module in a course. It will never change and is unique within the course. */
  id: Scalars['String'];
  items: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpModuleItem>>;
  name: Scalars['String'];
  totalDuration?: Maybe<Scalars['Float']>;
  totalLectureDuration?: Maybe<Scalars['Float']>;
  totalQuizzes?: Maybe<Scalars['Int']>;
  totalReadings?: Maybe<Scalars['Int']>;
  totalVideos?: Maybe<Scalars['Int']>;
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpCourseWeek = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPCourseWeek';
  modules: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpCourseModule>>;
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpDegree = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPDegree';
  /** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. Note that a [[CatalogDegree]], different from a [[org.coursera.degree.stored.api.Degree]], is STRICTLY A DEGREE. For Mastertracks, see [[CatalogMastertrack]]. */
  catalogDegree?: Maybe<XdpV1_Org_Coursera_Catalogp_Degree_CatalogDegree>;
  /** A model to store degree information to be displayed across our public catalog - browse, search and various description pages. It presents some data that is stored in the core degree model [[org.coursera.degree.stored .StoredDegree]], in addition to marketing-specific data that is exclusively managed by the degreeMarketing service. */
  catalogMastertrack?: Maybe<XdpV1_Org_Coursera_Catalogp_Degree_CatalogMastertrack>;
  degree: XdpV1_Org_Coursera_Degree_Stored_Api_Degree;
  upsellPartners?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_PartnerWithId>>>;
  upsellType?: Maybe<XdpV1_Org_Coursera_Degree_Stored_Api_UpsellType>;
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpDomain = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPDomain';
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  domainId: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  domainName: Scalars['String'];
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  subdomainId?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  subdomainName?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Common_Xdpfaq = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPFAQ';
  answer: XdpV1_Answer;
  faqType?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpfaqType>;
  question: XdpV1_Question;
};

export const XdpV1_Org_Coursera_Xdp_Common_XdpfaqType = {
  ClosedCourseAccess: 'ClosedCourseAccess',
  ClosedCourseEnroll: 'ClosedCourseEnroll',
  ClosedCourseNoAudit: 'ClosedCourseNoAudit',
  ClosedCoursePreview: 'ClosedCoursePreview',
  ClosedCourseReceiveCertificate: 'ClosedCourseReceiveCertificate',
  CourseAccess: 'CourseAccess',
  CourseFinancialAid: 'CourseFinancialAid',
  CourseFullyOnline: 'CourseFullyOnline',
  CourseUniversityCreditPromo: 'CourseUniversityCreditPromo',
  CourseValueProp: 'CourseValueProp',
  GenericRefund: 'GenericRefund',
  PaygCertificateRefund: 'PAYGCertificateRefund',
  ProfessionalCertCourseValueProp: 'ProfessionalCertCourseValueProp',
  ProfessionalCertEnrollInSingleCourse: 'ProfessionalCertEnrollInSingleCourse',
  S12nCourseValueProp: 'S12nCourseValueProp',
  S12nEnrollInSingleCourse: 'S12nEnrollInSingleCourse',
  S12nFinancialAid: 'S12nFinancialAid',
  S12nSubscriptionCourseCost: 'S12nSubscriptionCourseCost',
  S12nUniversityCredit: 'S12nUniversityCredit',
  S12nUniversityCreditPromo: 'S12nUniversityCreditPromo',
  StandAloneCourseRefund: 'StandAloneCourseRefund',
  SubscriptionTrialRefund: 'SubscriptionTrialRefund'
} as const;

export type XdpV1_Org_Coursera_Xdp_Common_XdpfaqType = typeof XdpV1_Org_Coursera_Xdp_Common_XdpfaqType[keyof typeof XdpV1_Org_Coursera_Xdp_Common_XdpfaqType];
/** #growth-acquisition is testing the performance gain of converting CML to HTML on the backend. This model is part of that frontend experiment. TODO(dgrossman) Cleanup after experiment: GR-21764 */
export type XdpV1_Org_Coursera_Xdp_Common_XdpHtmlFaq = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPHtmlFAQ';
  /** Typeref for string that defines the isTranslatable property to true */
  answer: Scalars['String'];
  faqType?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpfaqType>;
  /** Typeref for string that defines the isTranslatable property to true */
  question: Scalars['String'];
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpLearningOutcomes = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPLearningOutcomes';
  careerOutcomeNewCareer: Scalars['Int'];
  careerOutcomePayIncrease: Scalars['Int'];
  careerOutcomePromotion: Scalars['Int'];
  careerOutcomeStartBusiness: Scalars['Int'];
  surveyResponses: Scalars['Int'];
  tangibleCareerOutcome: Scalars['Int'];
  topOccupation?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpModuleItem = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPModuleItem';
  duration: Scalars['Float'];
  evaluable?: Maybe<Scalars['Boolean']>;
  /** Identifier for an item. This will never change and is unique within the course. */
  id: Scalars['String'];
  name: Scalars['String'];
  passable?: Maybe<Scalars['Boolean']>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  typeName: Scalars['String'];
};

export type XdpV1_Org_Coursera_Xdp_Common_XdpRatings = {
  __typename?: 'XdpV1_org_coursera_xdp_common_XDPRatings';
  averageFiveStarRating?: Maybe<Scalars['Float']>;
  commentCount?: Maybe<Scalars['Float']>;
  ratingCount?: Maybe<Scalars['Float']>;
};

export type XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReview = {
  __typename?: 'XdpV1_org_coursera_xdp_nostos_NostosXDPReview';
  authorName?: Maybe<Scalars['String']>;
  averageFiveStarRating?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  reviewId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewHighlights = {
  __typename?: 'XdpV1_org_coursera_xdp_nostos_NostosXDPReviewHighlights';
  highlighttext?: Maybe<Scalars['String']>;
  reviewcount?: Maybe<Scalars['Int']>;
};

export type XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewTestimonial = {
  __typename?: 'XdpV1_org_coursera_xdp_nostos_NostosXDPReviewTestimonial';
  author?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  credential?: Maybe<Scalars['String']>;
  job?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Sdp_SdpCourse = {
  __typename?: 'XdpV1_org_coursera_xdp_sdp_SDPCourse';
  averageContentSatisfactionScore?: Maybe<Scalars['Float']>;
  averageInstructorRating?: Maybe<Scalars['Float']>;
  /** Typeref for string that defines the isTranslatable property to true */
  description?: Maybe<Scalars['String']>;
  htmlLearningObjectives: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  learningObjectives: Array<Maybe<XdpV1_CmlMember>>;
  /** Note: these models intentionally do not use translatable strings as the cost of translating all course materials may be prohibitive. */
  material?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpCourseMaterial>;
  /** Typeref for string that defines the isTranslatable property to true */
  name?: Maybe<Scalars['String']>;
  ratings?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpRatings>;
  skills: Array<Maybe<XdpV1_Org_Coursera_Skill_Api_Skill>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
};

export type XdpV1_Org_Coursera_Xdp_Sdp_SdpMetadata = {
  __typename?: 'XdpV1_org_coursera_xdp_sdp_SDPMetadata';
  avgLearningHoursPerWeek?: Maybe<Scalars['Float']>;
  avgLearningMonthsAdjusted?: Maybe<Scalars['Float']>;
  badges?: Maybe<Array<Maybe<Scalars['String']>>>;
  capstone?: Maybe<XdpV1_Org_Coursera_S12n_Capstone>;
  certificateDescription?: Maybe<Scalars['String']>;
  certificateLogo?: Maybe<Scalars['String']>;
  cmlDescription?: Maybe<XdpV1_CmlMember>;
  cmlFaqs: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_Xdpfaq>>;
  cmlLearningObjectives: Array<Maybe<XdpV1_CmlMember>>;
  cmlRecommendedBackground?: Maybe<XdpV1_CmlRecommendedBackground>;
  coBrandingEnabled?: Maybe<Scalars['Boolean']>;
  companyLogos: Array<Maybe<Scalars['String']>>;
  courseIds: Array<Maybe<Scalars['String']>>;
  courses: Array<Maybe<XdpV1_Org_Coursera_Xdp_Sdp_SdpCourse>>;
  degrees: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpDegree>>;
  /** Typeref for string that defines the isTranslatable property to true */
  description?: Maybe<Scalars['String']>;
  display: Scalars['Boolean'];
  domains: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpDomain>>;
  headerImage?: Maybe<Scalars['String']>;
  /** Typeref for string that defines the isTranslatable property to true */
  headline?: Maybe<Scalars['String']>;
  hoursPerWeekOverride?: Maybe<Scalars['Int']>;
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  htmlDescription?: Maybe<Scalars['String']>;
  htmlFAQs: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpHtmlFaq>>;
  htmlLearningObjectives: Array<Maybe<Scalars['String']>>;
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  htmlProjectsOverview?: Maybe<Scalars['String']>;
  /** the pegasus schema for org.coursera.ondemand.content.HtmlContent. See https://phabricator.dkandu.me/D22517 */
  htmlRecommendedBackground?: Maybe<Scalars['String']>;
  htmlS12nAndCourseLearningObjectives: Array<Maybe<Scalars['String']>>;
  id: Scalars['String'];
  /** Typeref for string that defines the isTranslatable property to true */
  incentives?: Maybe<Scalars['String']>;
  instructorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  instructors: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_InstructorWithId>>;
  internalType?: Maybe<XdpV1_Org_Coursera_S12n_S12nInternalType>;
  isCertificate: Scalars['Boolean'];
  launchedAt?: Maybe<Scalars['Float']>;
  learningObjectives?: Maybe<Array<Maybe<Scalars['String']>>>;
  learningOutcomes?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpLearningOutcomes>;
  level?: Maybe<XdpV1_Org_Coursera_Ondemand_Common_DifficultyLevel>;
  monthsToCompleteOverride?: Maybe<Scalars['Int']>;
  /** Typeref for string that defines the isTranslatable property to true */
  name?: Maybe<Scalars['String']>;
  pageViewsInLastMonthCount?: Maybe<Scalars['Float']>;
  partnerIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  partnerIncentives?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Partnerincentives_PartnerIncentive>>>;
  partners: Array<Maybe<XdpV1_Org_Coursera_Xdp_Common_PartnerWithId>>;
  plannedLaunchDate?: Maybe<Scalars['Float']>;
  preEnrollmentEnabledAt?: Maybe<Scalars['Float']>;
  primaryLanguages: Array<Maybe<Scalars['String']>>;
  productVariant: Scalars['String'];
  projectsOverview?: Maybe<XdpV1_ProjectsOverview>;
  ratings?: Maybe<XdpV1_Org_Coursera_Xdp_Common_XdpRatings>;
  recommendedBackground?: Maybe<Array<Maybe<Scalars['String']>>>;
  reviewHighlights?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewHighlights>>>;
  s12nAndCourseLearningObjectives: Array<Maybe<XdpV1_CmlMember>>;
  s12nAndCourseSkills: Array<Maybe<Scalars['String']>>;
  skills: Array<Maybe<Scalars['String']>>;
  /** It is a human-readable identifier such as "machine-learning", which is suitable for URL. Previously it has been mostly used for ondemand course. This is now being shared for other purposes. It has arbitrary restrictions on the slug. Changing its validation may cause ondemand course to have unexpected behavior */
  slug?: Maybe<Scalars['String']>;
  sponsors?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Authoring_S12n_AuthoringS12nSponsor>>>;
  /** Typeref for string that defines the isTranslatable property to true */
  subheader?: Maybe<Scalars['String']>;
  subtitleLanguages: Array<Maybe<Scalars['String']>>;
  testimonials?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReviewTestimonial>>>;
  topFourAndFiveStarReviews?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReview>>>;
  topReviews?: Maybe<Array<Maybe<XdpV1_Org_Coursera_Xdp_Nostos_NostosXdpReview>>>;
  totalContentHours?: Maybe<Scalars['Float']>;
  totalContentWeeks?: Maybe<Scalars['Float']>;
  totalEnrollmentCount?: Maybe<Scalars['Float']>;
  workload?: Maybe<Scalars['String']>;
};

export type XdpV1_ProjectMember = {
  __typename?: 'XdpV1_projectMember';
  project: XdpV1_Org_Coursera_Ondemand_Course_Types_ProjectMetadata;
};

export type XdpV1_ProjectsOverview = DummyType | XdpV1_CmlMember;

export type XdpV1_Question = DummyType | XdpV1_CmlMember;

export type XdpV1_RgbaColorMember = {
  __typename?: 'XdpV1_rgbaColorMember';
  rgbaColor: XdpV1_Org_Coursera_Common_Ui_RgbaColor;
};

export type XdpV1_RhymeProjectMember = {
  __typename?: 'XdpV1_rhymeProjectMember';
  rhymeProject: XdpV1_Org_Coursera_Ondemand_Course_Types_RhymeProjectMetadata;
};

export type XdpV1_SdpMetadataMember = {
  __typename?: 'XdpV1_sdpMetadataMember';
  sdpMetadata: XdpV1_Org_Coursera_Xdp_Sdp_SdpMetadata;
};

export type XdpV1_ShortFormContentMember = {
  __typename?: 'XdpV1_shortFormContentMember';
  shortFormContent: XdpV1_Org_Coursera_Ondemand_Course_Types_ShortFormContentMetadata;
};

export type XdpV1_StandardCourseMember = {
  __typename?: 'XdpV1_standardCourseMember';
  standardCourse: XdpV1_Org_Coursera_Ondemand_Course_Types_StandardCourseMetadata;
};

export type XdpV1_XdpMetadata = XdpV1_CdpMetadataMember | XdpV1_SdpMetadataMember;

export const Org_Coursera_Assignment_AssignmentFeature = {
  AiGradedQuestions: 'AI_GRADED_QUESTIONS',
  AiGradedRubrics: 'AI_GRADED_RUBRICS',
  AssignmentRubrics: 'ASSIGNMENT_RUBRICS',
  AttemptTimeLimits: 'ATTEMPT_TIME_LIMITS',
  HideGradeOnRelease: 'HIDE_GRADE_ON_RELEASE',
  HideLearnerResponseAfterSubmission: 'HIDE_LEARNER_RESPONSE_AFTER_SUBMISSION',
  HumanGradedRubrics: 'HUMAN_GRADED_RUBRICS',
  LimitedAttempts: 'LIMITED_ATTEMPTS',
  LimitedSubmissions: 'LIMITED_SUBMISSIONS',
  ManualGradedQuestions: 'MANUAL_GRADED_QUESTIONS',
  MultipleFillableBlanksQuestions: 'MULTIPLE_FILLABLE_BLANKS_QUESTIONS',
  MultipleSubmissions: 'MULTIPLE_SUBMISSIONS',
  ProctoringIntegration: 'PROCTORING_INTEGRATION',
  ShowGradeOnRelease: 'SHOW_GRADE_ON_RELEASE',
  TakeHighestGrade: 'TAKE_HIGHEST_GRADE',
  TakeLatestGrade: 'TAKE_LATEST_GRADE',
  Teamwork: 'TEAMWORK',
  TextBlocks: 'TEXT_BLOCKS',
  VerifiedSkillsAssessment: 'VERIFIED_SKILLS_ASSESSMENT',
  VerifiedSkillsDiagnostic: 'VERIFIED_SKILLS_DIAGNOSTIC',
  WidgetQuestions: 'WIDGET_QUESTIONS'
} as const;

export type Org_Coursera_Assignment_AssignmentFeature = typeof Org_Coursera_Assignment_AssignmentFeature[keyof typeof Org_Coursera_Assignment_AssignmentFeature];
export const Org_Coursera_Authentication_Thirdpartyauth_OrganizationType = {
  Business: 'BUSINESS',
  Campus: 'CAMPUS',
  Government: 'GOVERNMENT'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_OrganizationType = typeof Org_Coursera_Authentication_Thirdpartyauth_OrganizationType[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_OrganizationType];
export const Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule = {
  AcceptedPrivacyNotice: 'ACCEPTED_PRIVACY_NOTICE',
  Everyone: 'EVERYONE'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule = typeof Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_ProgramVisibilityRule];
export const Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod = {
  Jwt: 'JWT',
  JwtInvite: 'JWT_INVITE',
  Lti: 'LTI',
  Saml: 'SAML'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod = typeof Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_SsoLoginMethod];
/** SAML signing algorithm. Used for generating the SAML Request in SP-initiated logins. */
export const Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm = {
  Sha1Rsa: 'SHA1_RSA',
  Sha256Rsa: 'SHA256_RSA'
} as const;

export type Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm = typeof Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm[keyof typeof Org_Coursera_Authentication_Thirdpartyauth_Saml_SamlSigningAlgorithm];
export const Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = {
  LockedForSubmitting: 'LOCKED_FOR_SUBMITTING',
  LockedFully: 'LOCKED_FULLY',
  LockedPartiallyForSubmitting: 'LOCKED_PARTIALLY_FOR_SUBMITTING'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_ItemLockStatus = typeof Org_Coursera_Ondemand_Coursematerial_ItemLockStatus[keyof typeof Org_Coursera_Ondemand_Coursematerial_ItemLockStatus];
export const Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = {
  BlockingAssessmentInProgress: 'BLOCKING_ASSESSMENT_IN_PROGRESS',
  EnrollmentPreview: 'ENROLLMENT_PREVIEW',
  PaidItem: 'PAID_ITEM',
  PassableItemCompletion: 'PASSABLE_ITEM_COMPLETION',
  Premium: 'PREMIUM',
  PremiumItem: 'PREMIUM_ITEM',
  RequireAllItemInLesson: 'REQUIRE_ALL_ITEM_IN_LESSON',
  ResittingItemLockOverride: 'RESITTING_ITEM_LOCK_OVERRIDE',
  RestrictedAudit: 'RESTRICTED_AUDIT',
  SessionEnded: 'SESSION_ENDED',
  SessionEndedForFlexibleSchedule: 'SESSION_ENDED_FOR_FLEXIBLE_SCHEDULE',
  SessionPreview: 'SESSION_PREVIEW',
  TimedReleaseContent: 'TIMED_RELEASE_CONTENT',
  TimedSubmissionLockedContent: 'TIMED_SUBMISSION_LOCKED_CONTENT'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode = typeof Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode[keyof typeof Org_Coursera_Ondemand_Coursematerial_ItemLockedReasonCode];
export const Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = {
  ApplyPenaltyFractionOnAwardedScore: 'APPLY_PENALTY_FRACTION_ON_AWARDED_SCORE',
  DecreasePenaltyPointsOnAwardedScore: 'DECREASE_PENALTY_POINTS_ON_AWARDED_SCORE'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode = typeof Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode[keyof typeof Org_Coursera_Ondemand_Coursematerial_PenaltyIncrementMode];
export const Org_Coursera_Ondemand_Coursematerial_PeriodType = {
  Day: 'DAY',
  Hour: 'HOUR',
  Infinity: 'INFINITY',
  Minute: 'MINUTE',
  Month: 'MONTH',
  Week: 'WEEK',
  Zero: 'ZERO'
} as const;

export type Org_Coursera_Ondemand_Coursematerial_PeriodType = typeof Org_Coursera_Ondemand_Coursematerial_PeriodType[keyof typeof Org_Coursera_Ondemand_Coursematerial_PeriodType];
export const Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState = {
  GradingStarted: 'GradingStarted',
  InProgress: 'InProgress'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_DiscussionPromptAssignmentStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState = {
  Failed: 'Failed',
  NotStarted: 'NotStarted',
  Started: 'Started',
  UnverifiedPassed: 'UnverifiedPassed',
  VerifiedPassed: 'VerifiedPassed'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_GenericPassableItemProgressState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_LtiStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState = {
  NotSubmitted: 'NotSubmitted',
  SubmittedNotReviewedOthers: 'SubmittedNotReviewedOthers',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_PeerStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_ProgrammingStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState = {
  NotSubmitted: 'NotSubmitted',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_StaffGradedStartedState];
export const Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState = {
  ReviewingOthers: 'ReviewingOthers',
  WaitingForGrading: 'WaitingForGrading'
} as const;

export type Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState = typeof Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState[keyof typeof Org_Coursera_Ondemand_Guided_Itemprogress_TeammateReviewStartedState];
export const Org_Coursera_Payment_Transaction_PaymentTransactionActionType = {
  Chargeback: 'CHARGEBACK',
  PartialRefund: 'PARTIAL_REFUND',
  Payment: 'PAYMENT',
  Query: 'QUERY',
  Refund: 'REFUND',
  Void: 'VOID'
} as const;

export type Org_Coursera_Payment_Transaction_PaymentTransactionActionType = typeof Org_Coursera_Payment_Transaction_PaymentTransactionActionType[keyof typeof Org_Coursera_Payment_Transaction_PaymentTransactionActionType];
/** Different configurations for SkillSets available to a learning program. Currently it is just ALL skillsets, no skillsets, or selected skillsets, but in the future, there may be configurations for all academies. */
export const Org_Coursera_Program_SkillSetAvailabilityType = {
  AllSkillsets: 'ALL_SKILLSETS',
  LinkedSkillsetsOnly: 'LINKED_SKILLSETS_ONLY'
} as const;

export type Org_Coursera_Program_SkillSetAvailabilityType = typeof Org_Coursera_Program_SkillSetAvailabilityType[keyof typeof Org_Coursera_Program_SkillSetAvailabilityType];
export const Org_Coursera_Program_Enrollment_ProgramUserProductAction = {
  Enroll: 'ENROLL',
  Manage: 'MANAGE',
  Preview: 'PREVIEW',
  Resume: 'RESUME',
  Select: 'SELECT',
  Unenroll: 'UNENROLL',
  Unselect: 'UNSELECT',
  Upgrade: 'UPGRADE',
  View: 'VIEW'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductAction = typeof Org_Coursera_Program_Enrollment_ProgramUserProductAction[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductAction];
/** Represents the enrollment state of a user for a specific content item (course or specialization) within a program. AVAILABLE - The content is in the user's program curriculum but the user is not   currently enrolled. This is the default state and also the state after unenrollment. ENROLLED - The user is actively enrolled in the content. COMPLETED - The user has completed the content. A completed enrollment cannot be unenrolled. UNAVAILABLE - The content is not currently available to the user. Possible reasons include:   the course has no open sessions, the course is not yet launched or pre-enrollable,   the organization has no remaining credits/licenses, or the content is not part of   the user's program. */
export const Org_Coursera_Program_Enrollment_ProgramUserProductState = {
  Available: 'AVAILABLE',
  Completed: 'COMPLETED',
  Enrolled: 'ENROLLED',
  Unavailable: 'UNAVAILABLE'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductState = typeof Org_Coursera_Program_Enrollment_ProgramUserProductState[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductState];
export const Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = {
  UnavailableCourseNotLaunchedNorPreEnrollable: 'UNAVAILABLE_COURSE_NOT_LAUNCHED_NOR_PRE_ENROLLABLE',
  UnavailableCourseNoOpenSessions: 'UNAVAILABLE_COURSE_NO_OPEN_SESSIONS',
  UnavailableNotInProgram: 'UNAVAILABLE_NOT_IN_PROGRAM',
  UnavailableNotPermitted: 'UNAVAILABLE_NOT_PERMITTED',
  UnavailableNoCreditsRemaining: 'UNAVAILABLE_NO_CREDITS_REMAINING'
} as const;

export type Org_Coursera_Program_Enrollment_ProgramUserProductStateReason = typeof Org_Coursera_Program_Enrollment_ProgramUserProductStateReason[keyof typeof Org_Coursera_Program_Enrollment_ProgramUserProductStateReason];